import * as A from "react";
import p, { useState as wt, useEffect as Tt, isValidElement as ca, Children as vu, PureComponent as Sc, forwardRef as tn, useRef as Gt, useImperativeHandle as xG, useCallback as Ft, useMemo as ua, cloneElement as br, createElement as lt, useContext as Wi, createContext as Ws, Component as EG, useLayoutEffect as vh, Fragment as oC, createRef as Rfe, memo as Pfe, version as _I, useDebugValue as SG, useSyncExternalStore as Dfe } from "react";
import * as mw from "react-dom";
import gw, { flushSync as Nfe, createPortal as vw } from "react-dom";
import { jsx as T, jsxs as ee, Fragment as ft } from "react/jsx-runtime";
import { Link as Lfe, useLocation as $fe } from "react-router-dom";
import './index.css';const $x = 768;
function yw() {
  const [n, e] = wt(
    window.innerWidth < $x
  );
  return Tt(() => {
    const t = window.matchMedia(
      `(max-width: ${$x - 1}px)`
    ), r = () => {
      e(window.innerWidth < $x);
    };
    return t.addEventListener("change", r), () => t.removeEventListener("change", r);
  }, []), !!n;
}
function CG(n) {
  var e, t, r = "";
  if (typeof n == "string" || typeof n == "number") r += n;
  else if (typeof n == "object") if (Array.isArray(n)) {
    var i = n.length;
    for (e = 0; e < i; e++) n[e] && (t = CG(n[e])) && (r && (r += " "), r += t);
  } else for (t in n) n[t] && (r && (r += " "), r += t);
  return r;
}
function Ut() {
  for (var n, e, t = 0, r = "", i = arguments.length; t < i; t++) (n = arguments[t]) && (e = CG(n)) && (r && (r += " "), r += e);
  return r;
}
const DA = "-", Ffe = (n) => {
  const e = zfe(n), {
    conflictingClassGroups: t,
    conflictingClassGroupModifiers: r
  } = n;
  return {
    getClassGroupId: (o) => {
      const a = o.split(DA);
      return a[0] === "" && a.length !== 1 && a.shift(), TG(a, e) || Bfe(o);
    },
    getConflictingClassGroupIds: (o, a) => {
      const l = t[o] || [];
      return a && r[o] ? [...l, ...r[o]] : l;
    }
  };
}, TG = (n, e) => {
  if (n.length === 0)
    return e.classGroupId;
  const t = n[0], r = e.nextPart.get(t), i = r ? TG(n.slice(1), r) : void 0;
  if (i)
    return i;
  if (e.validators.length === 0)
    return;
  const s = n.join(DA);
  return e.validators.find(({
    validator: o
  }) => o(s))?.classGroupId;
}, OI = /^\[(.+)\]$/, Bfe = (n) => {
  if (OI.test(n)) {
    const e = OI.exec(n)[1], t = e?.substring(0, e.indexOf(":"));
    if (t)
      return "arbitrary.." + t;
  }
}, zfe = (n) => {
  const {
    theme: e,
    classGroups: t
  } = n, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  for (const i in t)
    aC(t[i], r, i, e);
  return r;
}, aC = (n, e, t, r) => {
  n.forEach((i) => {
    if (typeof i == "string") {
      const s = i === "" ? e : II(e, i);
      s.classGroupId = t;
      return;
    }
    if (typeof i == "function") {
      if (Hfe(i)) {
        aC(i(r), e, t, r);
        return;
      }
      e.validators.push({
        validator: i,
        classGroupId: t
      });
      return;
    }
    Object.entries(i).forEach(([s, o]) => {
      aC(o, II(e, s), t, r);
    });
  });
}, II = (n, e) => {
  let t = n;
  return e.split(DA).forEach((r) => {
    t.nextPart.has(r) || t.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), t = t.nextPart.get(r);
  }), t;
}, Hfe = (n) => n.isThemeGetter, Ufe = (n) => {
  if (n < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let e = 0, t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const i = (s, o) => {
    t.set(s, o), e++, e > n && (e = 0, r = t, t = /* @__PURE__ */ new Map());
  };
  return {
    get(s) {
      let o = t.get(s);
      if (o !== void 0)
        return o;
      if ((o = r.get(s)) !== void 0)
        return i(s, o), o;
    },
    set(s, o) {
      t.has(s) ? t.set(s, o) : i(s, o);
    }
  };
}, lC = "!", cC = ":", Vfe = cC.length, jfe = (n) => {
  const {
    prefix: e,
    experimentalParseClassName: t
  } = n;
  let r = (i) => {
    const s = [];
    let o = 0, a = 0, l = 0, c;
    for (let m = 0; m < i.length; m++) {
      let g = i[m];
      if (o === 0 && a === 0) {
        if (g === cC) {
          s.push(i.slice(l, m)), l = m + Vfe;
          continue;
        }
        if (g === "/") {
          c = m;
          continue;
        }
      }
      g === "[" ? o++ : g === "]" ? o-- : g === "(" ? a++ : g === ")" && a--;
    }
    const u = s.length === 0 ? i : i.substring(l), d = Wfe(u), f = d !== u, h = c && c > l ? c - l : void 0;
    return {
      modifiers: s,
      hasImportantModifier: f,
      baseClassName: d,
      maybePostfixModifierPosition: h
    };
  };
  if (e) {
    const i = e + cC, s = r;
    r = (o) => o.startsWith(i) ? s(o.substring(i.length)) : {
      isExternal: !0,
      modifiers: [],
      hasImportantModifier: !1,
      baseClassName: o,
      maybePostfixModifierPosition: void 0
    };
  }
  if (t) {
    const i = r;
    r = (s) => t({
      className: s,
      parseClassName: i
    });
  }
  return r;
}, Wfe = (n) => n.endsWith(lC) ? n.substring(0, n.length - 1) : n.startsWith(lC) ? n.substring(1) : n, Gfe = (n) => {
  const e = Object.fromEntries(n.orderSensitiveModifiers.map((r) => [r, !0]));
  return (r) => {
    if (r.length <= 1)
      return r;
    const i = [];
    let s = [];
    return r.forEach((o) => {
      o[0] === "[" || e[o] ? (i.push(...s.sort(), o), s = []) : s.push(o);
    }), i.push(...s.sort()), i;
  };
}, Kfe = (n) => ({
  cache: Ufe(n.cacheSize),
  parseClassName: jfe(n),
  sortModifiers: Gfe(n),
  ...Ffe(n)
}), qfe = /\s+/, Yfe = (n, e) => {
  const {
    parseClassName: t,
    getClassGroupId: r,
    getConflictingClassGroupIds: i,
    sortModifiers: s
  } = e, o = [], a = n.trim().split(qfe);
  let l = "";
  for (let c = a.length - 1; c >= 0; c -= 1) {
    const u = a[c], {
      isExternal: d,
      modifiers: f,
      hasImportantModifier: h,
      baseClassName: m,
      maybePostfixModifierPosition: g
    } = t(u);
    if (d) {
      l = u + (l.length > 0 ? " " + l : l);
      continue;
    }
    let v = !!g, y = r(v ? m.substring(0, g) : m);
    if (!y) {
      if (!v) {
        l = u + (l.length > 0 ? " " + l : l);
        continue;
      }
      if (y = r(m), !y) {
        l = u + (l.length > 0 ? " " + l : l);
        continue;
      }
      v = !1;
    }
    const b = s(f).join(":"), x = h ? b + lC : b, E = x + y;
    if (o.includes(E))
      continue;
    o.push(E);
    const w = i(y, v);
    for (let C = 0; C < w.length; ++C) {
      const S = w[C];
      o.push(x + S);
    }
    l = u + (l.length > 0 ? " " + l : l);
  }
  return l;
};
function Xfe() {
  let n = 0, e, t, r = "";
  for (; n < arguments.length; )
    (e = arguments[n++]) && (t = AG(e)) && (r && (r += " "), r += t);
  return r;
}
const AG = (n) => {
  if (typeof n == "string")
    return n;
  let e, t = "";
  for (let r = 0; r < n.length; r++)
    n[r] && (e = AG(n[r])) && (t && (t += " "), t += e);
  return t;
};
function Zfe(n, ...e) {
  let t, r, i, s = o;
  function o(l) {
    const c = e.reduce((u, d) => d(u), n());
    return t = Kfe(c), r = t.cache.get, i = t.cache.set, s = a, a(l);
  }
  function a(l) {
    const c = r(l);
    if (c)
      return c;
    const u = Yfe(l, t);
    return i(l, u), u;
  }
  return function() {
    return s(Xfe.apply(null, arguments));
  };
}
const pr = (n) => {
  const e = (t) => t[n] || [];
  return e.isThemeGetter = !0, e;
}, MG = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, kG = /^\((?:(\w[\w-]*):)?(.+)\)$/i, Qfe = /^\d+\/\d+$/, Jfe = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, ehe = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, the = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, nhe = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, rhe = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, pd = (n) => Qfe.test(n), It = (n) => !!n && !Number.isNaN(Number(n)), Al = (n) => !!n && Number.isInteger(Number(n)), Fx = (n) => n.endsWith("%") && It(n.slice(0, -1)), Oa = (n) => Jfe.test(n), ihe = () => !0, she = (n) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  ehe.test(n) && !the.test(n)
), _G = () => !1, ohe = (n) => nhe.test(n), ahe = (n) => rhe.test(n), lhe = (n) => !Ye(n) && !Xe(n), che = (n) => yh(n, RG, _G), Ye = (n) => MG.test(n), Hc = (n) => yh(n, PG, she), Bx = (n) => yh(n, phe, It), RI = (n) => yh(n, OG, _G), uhe = (n) => yh(n, IG, ahe), ng = (n) => yh(n, DG, ohe), Xe = (n) => kG.test(n), Yh = (n) => bh(n, PG), dhe = (n) => bh(n, mhe), PI = (n) => bh(n, OG), fhe = (n) => bh(n, RG), hhe = (n) => bh(n, IG), rg = (n) => bh(n, DG, !0), yh = (n, e, t) => {
  const r = MG.exec(n);
  return r ? r[1] ? e(r[1]) : t(r[2]) : !1;
}, bh = (n, e, t = !1) => {
  const r = kG.exec(n);
  return r ? r[1] ? e(r[1]) : t : !1;
}, OG = (n) => n === "position" || n === "percentage", IG = (n) => n === "image" || n === "url", RG = (n) => n === "length" || n === "size" || n === "bg-size", PG = (n) => n === "length", phe = (n) => n === "number", mhe = (n) => n === "family-name", DG = (n) => n === "shadow", ghe = () => {
  const n = pr("color"), e = pr("font"), t = pr("text"), r = pr("font-weight"), i = pr("tracking"), s = pr("leading"), o = pr("breakpoint"), a = pr("container"), l = pr("spacing"), c = pr("radius"), u = pr("shadow"), d = pr("inset-shadow"), f = pr("text-shadow"), h = pr("drop-shadow"), m = pr("blur"), g = pr("perspective"), v = pr("aspect"), y = pr("ease"), b = pr("animate"), x = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], E = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], w = () => [...E(), Xe, Ye], C = () => ["auto", "hidden", "clip", "visible", "scroll"], S = () => ["auto", "contain", "none"], M = () => [Xe, Ye, l], k = () => [pd, "full", "auto", ...M()], _ = () => [Al, "none", "subgrid", Xe, Ye], O = () => ["auto", {
    span: ["full", Al, Xe, Ye]
  }, Al, Xe, Ye], I = () => [Al, "auto", Xe, Ye], R = () => ["auto", "min", "max", "fr", Xe, Ye], P = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], D = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], L = () => ["auto", ...M()], B = () => [pd, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...M()], $ = () => [n, Xe, Ye], z = () => [...E(), PI, RI, {
    position: [Xe, Ye]
  }], H = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], U = () => ["auto", "cover", "contain", fhe, che, {
    size: [Xe, Ye]
  }], F = () => [Fx, Yh, Hc], V = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    c,
    Xe,
    Ye
  ], X = () => ["", It, Yh, Hc], Z = () => ["solid", "dashed", "dotted", "double"], ie = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], J = () => [It, Fx, PI, RI], se = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    m,
    Xe,
    Ye
  ], te = () => ["none", It, Xe, Ye], le = () => ["none", It, Xe, Ye], de = () => [It, Xe, Ye], j = () => [pd, "full", ...M()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [Oa],
      breakpoint: [Oa],
      color: [ihe],
      container: [Oa],
      "drop-shadow": [Oa],
      ease: ["in", "out", "in-out"],
      font: [lhe],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [Oa],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [Oa],
      shadow: [Oa],
      spacing: ["px", It],
      text: [Oa],
      "text-shadow": [Oa],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", pd, Ye, Xe, v]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [It, Ye, Xe, a]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": x()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": x()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: w()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: C()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": C()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": C()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: S()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": S()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": S()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: k()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": k()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": k()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: k()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: k()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: k()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: k()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: k()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: k()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [Al, "auto", Xe, Ye]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [pd, "full", "auto", a, ...M()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [It, pd, "auto", "initial", "none", Ye]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", It, Xe, Ye]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", It, Xe, Ye]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [Al, "first", "last", "none", Xe, Ye]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": _()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: O()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": I()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": I()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": _()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: O()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": I()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": I()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": R()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": R()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: M()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": M()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": M()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...P(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...D(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...D()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...P()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...D(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...D(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": P()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...D(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...D()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: M()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: M()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: M()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: M()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: M()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: M()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: M()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: M()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: M()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: L()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: L()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: L()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: L()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: L()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: L()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: L()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: L()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: L()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": M()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": M()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: B()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [a, "screen", ...B()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          a,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...B()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          a,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [o]
          },
          ...B()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...B()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...B()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...B()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", t, Yh, Hc]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [r, Xe, Bx]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", Fx, Ye]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [dhe, Ye, e]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [i, Xe, Ye]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [It, "none", Xe, Bx]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          s,
          ...M()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Xe, Ye]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", Xe, Ye]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: $()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: $()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...Z(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [It, "from-font", "auto", Xe, Hc]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: $()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [It, "auto", Xe, Ye]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: M()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Xe, Ye]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Xe, Ye]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: z()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: H()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: U()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, Al, Xe, Ye],
          radial: ["", Xe, Ye],
          conic: [Al, Xe, Ye]
        }, hhe, uhe]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: $()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: F()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: F()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: F()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: $()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: $()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: $()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: V()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": V()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": V()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": V()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": V()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": V()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": V()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": V()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": V()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": V()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": V()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": V()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": V()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": V()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": V()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: X()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": X()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": X()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": X()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": X()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": X()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": X()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": X()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": X()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": X()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": X()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...Z(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...Z(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: $()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": $()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": $()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": $()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": $()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": $()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": $()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": $()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": $()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: $()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...Z(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [It, Xe, Ye]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", It, Yh, Hc]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: $()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          u,
          rg,
          ng
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: $()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", d, rg, ng]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": $()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: X()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: $()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [It, Hc]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": $()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": X()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": $()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", f, rg, ng]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": $()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [It, Xe, Ye]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...ie(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": ie()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [It]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": J()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": J()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": $()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": $()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": J()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": J()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": $()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": $()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": J()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": J()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": $()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": $()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": J()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": J()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": $()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": $()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": J()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": J()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": $()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": $()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": J()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": J()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": $()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": $()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": J()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": J()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": $()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": $()
      }],
      "mask-image-radial": [{
        "mask-radial": [Xe, Ye]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": J()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": J()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": $()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": $()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": E()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [It]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": J()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": J()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": $()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": $()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: z()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: H()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: U()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", Xe, Ye]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          Xe,
          Ye
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: se()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [It, Xe, Ye]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [It, Xe, Ye]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          h,
          rg,
          ng
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": $()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", It, Xe, Ye]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [It, Xe, Ye]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", It, Xe, Ye]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [It, Xe, Ye]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", It, Xe, Ye]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          Xe,
          Ye
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": se()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [It, Xe, Ye]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [It, Xe, Ye]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", It, Xe, Ye]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [It, Xe, Ye]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", It, Xe, Ye]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [It, Xe, Ye]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [It, Xe, Ye]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", It, Xe, Ye]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": M()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": M()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": M()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", Xe, Ye]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [It, "initial", Xe, Ye]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", y, Xe, Ye]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [It, Xe, Ye]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", b, Xe, Ye]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [g, Xe, Ye]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": w()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: te()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": te()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": te()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": te()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: le()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": le()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": le()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": le()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: de()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": de()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": de()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [Xe, Ye, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: w()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: j()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": j()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": j()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": j()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: $()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: $()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Xe, Ye]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": M()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": M()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": M()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": M()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": M()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": M()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": M()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": M()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": M()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": M()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": M()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": M()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": M()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": M()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": M()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": M()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": M()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": M()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Xe, Ye]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...$()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [It, Yh, Hc, Bx]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...$()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, vhe = /* @__PURE__ */ Zfe(ghe);
function Q(...n) {
  return vhe(Ut(n));
}
var o1 = (n) => n.type === "checkbox", ru = (n) => n instanceof Date, Ii = (n) => n == null;
const NG = (n) => typeof n == "object";
var lr = (n) => !Ii(n) && !Array.isArray(n) && NG(n) && !ru(n), LG = (n) => lr(n) && n.target ? o1(n.target) ? n.target.checked : n.target.value : n, yhe = (n) => n.substring(0, n.search(/\.\d+(\.|$)/)) || n, $G = (n, e) => n.has(yhe(e)), bhe = (n) => {
  const e = n.constructor && n.constructor.prototype;
  return lr(e) && e.hasOwnProperty("isPrototypeOf");
}, NA = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function On(n) {
  let e;
  const t = Array.isArray(n), r = typeof FileList < "u" ? n instanceof FileList : !1;
  if (n instanceof Date)
    e = new Date(n);
  else if (!(NA && (n instanceof Blob || r)) && (t || lr(n)))
    if (e = t ? [] : Object.create(Object.getPrototypeOf(n)), !t && !bhe(n))
      e = n;
    else
      for (const i in n)
        n.hasOwnProperty(i) && (e[i] = On(n[i]));
  else
    return n;
  return e;
}
var bw = (n) => /^\w*$/.test(n), kn = (n) => n === void 0, ww = (n) => Array.isArray(n) ? n.filter(Boolean) : [], LA = (n) => ww(n.replace(/["|']|\]/g, "").split(/\.|\[/)), Re = (n, e, t) => {
  if (!e || !lr(n))
    return t;
  const r = (bw(e) ? [e] : LA(e)).reduce((i, s) => Ii(i) ? i : i[s], n);
  return kn(r) || r === n ? kn(n[e]) ? t : n[e] : r;
}, cs = (n) => typeof n == "boolean", dn = (n, e, t) => {
  let r = -1;
  const i = bw(e) ? [e] : LA(e), s = i.length, o = s - 1;
  for (; ++r < s; ) {
    const a = i[r];
    let l = t;
    if (r !== o) {
      const c = n[a];
      l = lr(c) || Array.isArray(c) ? c : isNaN(+i[r + 1]) ? {} : [];
    }
    if (a === "__proto__" || a === "constructor" || a === "prototype")
      return;
    n[a] = l, n = n[a];
  }
};
const m2 = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, Is = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, Ia = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, $A = p.createContext(null);
$A.displayName = "HookFormContext";
const Ju = () => p.useContext($A), whe = (n) => {
  const { children: e, ...t } = n;
  return p.createElement($A.Provider, { value: t }, e);
};
var FG = (n, e, t, r = !0) => {
  const i = {
    defaultValues: e._defaultValues
  };
  for (const s in n)
    Object.defineProperty(i, s, {
      get: () => {
        const o = s;
        return e._proxyFormState[o] !== Is.all && (e._proxyFormState[o] = !r || Is.all), t && (t[o] = !0), n[o];
      }
    });
  return i;
};
const xw = typeof window < "u" ? p.useLayoutEffect : p.useEffect;
function xhe(n) {
  const e = Ju(), { control: t = e.control, disabled: r, name: i, exact: s } = n || {}, [o, a] = p.useState(t._formState), l = p.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  });
  return xw(() => t._subscribe({
    name: i,
    formState: l.current,
    exact: s,
    callback: (c) => {
      !r && a({
        ...t._formState,
        ...c
      });
    }
  }), [i, r, s]), p.useEffect(() => {
    l.current.isValid && t._setValid(!0);
  }, [t]), p.useMemo(() => FG(o, t, l.current, !1), [o, t]);
}
var ds = (n) => typeof n == "string", BG = (n, e, t, r, i) => ds(n) ? (r && e.watch.add(n), Re(t, n, i)) : Array.isArray(n) ? n.map((s) => (r && e.watch.add(s), Re(t, s))) : (r && (e.watchAll = !0), t), uC = (n) => Ii(n) || !NG(n);
function Ga(n, e, t = /* @__PURE__ */ new WeakSet()) {
  if (uC(n) || uC(e))
    return n === e;
  if (ru(n) && ru(e))
    return n.getTime() === e.getTime();
  const r = Object.keys(n), i = Object.keys(e);
  if (r.length !== i.length)
    return !1;
  if (t.has(n) || t.has(e))
    return !0;
  t.add(n), t.add(e);
  for (const s of r) {
    const o = n[s];
    if (!i.includes(s))
      return !1;
    if (s !== "ref") {
      const a = e[s];
      if (ru(o) && ru(a) || lr(o) && lr(a) || Array.isArray(o) && Array.isArray(a) ? !Ga(o, a, t) : o !== a)
        return !1;
    }
  }
  return !0;
}
function Ehe(n) {
  const e = Ju(), { control: t = e.control, name: r, defaultValue: i, disabled: s, exact: o, compute: a } = n || {}, l = p.useRef(i), c = p.useRef(a), u = p.useRef(void 0);
  c.current = a;
  const d = p.useMemo(() => t._getWatch(r, l.current), [t, r]), [f, h] = p.useState(c.current ? c.current(d) : d);
  return xw(() => t._subscribe({
    name: r,
    formState: {
      values: !0
    },
    exact: o,
    callback: (m) => {
      if (!s) {
        const g = BG(r, t._names, m.values || t._formValues, !1, l.current);
        if (c.current) {
          const v = c.current(g);
          Ga(v, u.current) || (h(v), u.current = v);
        } else
          h(g);
      }
    }
  }), [t, s, r, o]), p.useEffect(() => t._removeUnmounted()), f;
}
function wh(n) {
  const e = Ju(), { name: t, disabled: r, control: i = e.control, shouldUnregister: s, defaultValue: o } = n, a = $G(i._names.array, t), l = p.useMemo(() => Re(i._formValues, t, Re(i._defaultValues, t, o)), [i, t, o]), c = Ehe({
    control: i,
    name: t,
    defaultValue: l,
    exact: !0
  }), u = xhe({
    control: i,
    name: t,
    exact: !0
  }), d = p.useRef(n), f = p.useRef(void 0), h = p.useRef(i.register(t, {
    ...n.rules,
    value: c,
    ...cs(n.disabled) ? { disabled: n.disabled } : {}
  }));
  d.current = n;
  const m = p.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!Re(u.errors, t)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!Re(u.dirtyFields, t)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!Re(u.touchedFields, t)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!Re(u.validatingFields, t)
    },
    error: {
      enumerable: !0,
      get: () => Re(u.errors, t)
    }
  }), [u, t]), g = p.useCallback((x) => h.current.onChange({
    target: {
      value: LG(x),
      name: t
    },
    type: m2.CHANGE
  }), [t]), v = p.useCallback(() => h.current.onBlur({
    target: {
      value: Re(i._formValues, t),
      name: t
    },
    type: m2.BLUR
  }), [t, i._formValues]), y = p.useCallback((x) => {
    const E = Re(i._fields, t);
    E && x && (E._f.ref = {
      focus: () => x.focus && x.focus(),
      select: () => x.select && x.select(),
      setCustomValidity: (w) => x.setCustomValidity(w),
      reportValidity: () => x.reportValidity()
    });
  }, [i._fields, t]), b = p.useMemo(() => ({
    name: t,
    value: c,
    ...cs(r) || u.disabled ? { disabled: u.disabled || r } : {},
    onChange: g,
    onBlur: v,
    ref: y
  }), [t, r, u.disabled, g, v, y, c]);
  return p.useEffect(() => {
    const x = i._options.shouldUnregister || s, E = f.current;
    E && E !== t && !a && i.unregister(E), i.register(t, {
      ...d.current.rules,
      ...cs(d.current.disabled) ? { disabled: d.current.disabled } : {}
    });
    const w = (C, S) => {
      const M = Re(i._fields, C);
      M && M._f && (M._f.mount = S);
    };
    if (w(t, !0), x) {
      const C = On(Re(i._options.defaultValues, t, d.current.defaultValue));
      dn(i._defaultValues, t, C), kn(Re(i._formValues, t)) && dn(i._formValues, t, C);
    }
    return !a && i.register(t), f.current = t, () => {
      (a ? x && !i._state.action : x) ? i.unregister(t) : w(t, !1);
    };
  }, [t, i, a, s]), p.useEffect(() => {
    i._setDisabledField({
      disabled: r,
      name: t
    });
  }, [r, t, i]), p.useMemo(() => ({
    field: b,
    formState: u,
    fieldState: m
  }), [b, u, m]);
}
const She = (n) => n.render(wh(n));
var Che = (n, e, t, r, i) => e ? {
  ...t[n],
  types: {
    ...t[n] && t[n].types ? t[n].types : {},
    [r]: i || !0
  }
} : {}, Li = (n) => Array.isArray(n) ? n : [n], DI = () => {
  let n = [];
  return {
    get observers() {
      return n;
    },
    next: (i) => {
      for (const s of n)
        s.next && s.next(i);
    },
    subscribe: (i) => (n.push(i), {
      unsubscribe: () => {
        n = n.filter((s) => s !== i);
      }
    }),
    unsubscribe: () => {
      n = [];
    }
  };
};
function zG(n, e) {
  const t = {};
  for (const r in n)
    if (n.hasOwnProperty(r)) {
      const i = n[r], s = e[r];
      if (i && lr(i) && s) {
        const o = zG(i, s);
        lr(o) && (t[r] = o);
      } else n[r] && (t[r] = s);
    }
  return t;
}
var ui = (n) => lr(n) && !Object.keys(n).length, FA = (n) => n.type === "file", oo = (n) => typeof n == "function", g2 = (n) => {
  if (!NA)
    return !1;
  const e = n ? n.ownerDocument : 0;
  return n instanceof (e && e.defaultView ? e.defaultView.HTMLElement : HTMLElement);
}, HG = (n) => n.type === "select-multiple", BA = (n) => n.type === "radio", The = (n) => BA(n) || o1(n), zx = (n) => g2(n) && n.isConnected;
function Ahe(n, e) {
  const t = e.slice(0, -1).length;
  let r = 0;
  for (; r < t; )
    n = kn(n) ? r++ : n[e[r++]];
  return n;
}
function Mhe(n) {
  for (const e in n)
    if (n.hasOwnProperty(e) && !kn(n[e]))
      return !1;
  return !0;
}
function Jn(n, e) {
  const t = Array.isArray(e) ? e : bw(e) ? [e] : LA(e), r = t.length === 1 ? n : Ahe(n, t), i = t.length - 1, s = t[i];
  return r && delete r[s], i !== 0 && (lr(r) && ui(r) || Array.isArray(r) && Mhe(r)) && Jn(n, t.slice(0, -1)), n;
}
var khe = (n) => {
  for (const e in n)
    if (oo(n[e]))
      return !0;
  return !1;
};
function UG(n) {
  return Array.isArray(n) || lr(n) && !khe(n);
}
function dC(n, e = {}) {
  for (const t in n)
    UG(n[t]) ? (e[t] = Array.isArray(n[t]) ? [] : {}, dC(n[t], e[t])) : kn(n[t]) || (e[t] = !0);
  return e;
}
function Pd(n, e, t) {
  t || (t = dC(e));
  for (const r in n)
    UG(n[r]) ? kn(e) || uC(t[r]) ? t[r] = dC(n[r], Array.isArray(n[r]) ? [] : {}) : Pd(n[r], Ii(e) ? {} : e[r], t[r]) : t[r] = !Ga(n[r], e[r]);
  return t;
}
const NI = {
  value: !1,
  isValid: !1
}, LI = { value: !0, isValid: !0 };
var VG = (n) => {
  if (Array.isArray(n)) {
    if (n.length > 1) {
      const e = n.filter((t) => t && t.checked && !t.disabled).map((t) => t.value);
      return { value: e, isValid: !!e.length };
    }
    return n[0].checked && !n[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      n[0].attributes && !kn(n[0].attributes.value) ? kn(n[0].value) || n[0].value === "" ? LI : { value: n[0].value, isValid: !0 } : LI
    ) : NI;
  }
  return NI;
}, jG = (n, { valueAsNumber: e, valueAsDate: t, setValueAs: r }) => kn(n) ? n : e ? n === "" ? NaN : n && +n : t && ds(n) ? new Date(n) : r ? r(n) : n;
const $I = {
  isValid: !1,
  value: null
};
var WG = (n) => Array.isArray(n) ? n.reduce((e, t) => t && t.checked && !t.disabled ? {
  isValid: !0,
  value: t.value
} : e, $I) : $I;
function FI(n) {
  const e = n.ref;
  return FA(e) ? e.files : BA(e) ? WG(n.refs).value : HG(e) ? [...e.selectedOptions].map(({ value: t }) => t) : o1(e) ? VG(n.refs).value : jG(kn(e.value) ? n.ref.value : e.value, n);
}
var _he = (n, e, t, r) => {
  const i = {};
  for (const s of n) {
    const o = Re(e, s);
    o && dn(i, s, o._f);
  }
  return {
    criteriaMode: t,
    names: [...n],
    fields: i,
    shouldUseNativeValidation: r
  };
}, v2 = (n) => n instanceof RegExp, Xh = (n) => kn(n) ? n : v2(n) ? n.source : lr(n) ? v2(n.value) ? n.value.source : n.value : n, Wd = (n) => ({
  isOnSubmit: !n || n === Is.onSubmit,
  isOnBlur: n === Is.onBlur,
  isOnChange: n === Is.onChange,
  isOnAll: n === Is.all,
  isOnTouch: n === Is.onTouched
});
const BI = "AsyncFunction";
var Ohe = (n) => !!n && !!n.validate && !!(oo(n.validate) && n.validate.constructor.name === BI || lr(n.validate) && Object.values(n.validate).find((e) => e.constructor.name === BI)), Ihe = (n) => n.mount && (n.required || n.min || n.max || n.maxLength || n.minLength || n.pattern || n.validate), fC = (n, e, t) => !t && (e.watchAll || e.watch.has(n) || [...e.watch].some((r) => n.startsWith(r) && /^\.\w+/.test(n.slice(r.length))));
const nf = (n, e, t, r) => {
  for (const i of t || Object.keys(n)) {
    const s = Re(n, i);
    if (s) {
      const { _f: o, ...a } = s;
      if (o) {
        if (o.refs && o.refs[0] && e(o.refs[0], i) && !r)
          return !0;
        if (o.ref && e(o.ref, o.name) && !r)
          return !0;
        if (nf(a, e))
          break;
      } else if (lr(a) && nf(a, e))
        break;
    }
  }
};
function zI(n, e, t) {
  const r = Re(n, t);
  if (r || bw(t))
    return {
      error: r,
      name: t
    };
  const i = t.split(".");
  for (; i.length; ) {
    const s = i.join("."), o = Re(e, s), a = Re(n, s);
    if (o && !Array.isArray(o) && t !== s)
      return { name: t };
    if (a && a.type)
      return {
        name: s,
        error: a
      };
    if (a && a.root && a.root.type)
      return {
        name: `${s}.root`,
        error: a.root
      };
    i.pop();
  }
  return {
    name: t
  };
}
var Rhe = (n, e, t, r) => {
  t(n);
  const { name: i, ...s } = n;
  return ui(s) || Object.keys(s).length >= Object.keys(e).length || Object.keys(s).find((o) => e[o] === (!r || Is.all));
}, Phe = (n, e, t) => !n || !e || n === e || Li(n).some((r) => r && (t ? r === e : r.startsWith(e) || e.startsWith(r))), Dhe = (n, e, t, r, i) => i.isOnAll ? !1 : !t && i.isOnTouch ? !(e || n) : (t ? r.isOnBlur : i.isOnBlur) ? !n : (t ? r.isOnChange : i.isOnChange) ? n : !0, Nhe = (n, e) => !ww(Re(n, e)).length && Jn(n, e), GG = (n, e, t) => {
  const r = Li(Re(n, t));
  return dn(r, "root", e[t]), dn(n, t, r), n;
};
function HI(n, e, t = "validate") {
  if (ds(n) || Array.isArray(n) && n.every(ds) || cs(n) && !n)
    return {
      type: t,
      message: ds(n) ? n : "",
      ref: e
    };
}
var md = (n) => lr(n) && !v2(n) ? n : {
  value: n,
  message: ""
}, hC = async (n, e, t, r, i, s) => {
  const { ref: o, refs: a, required: l, maxLength: c, minLength: u, min: d, max: f, pattern: h, validate: m, name: g, valueAsNumber: v, mount: y } = n._f, b = Re(t, g);
  if (!y || e.has(g))
    return {};
  const x = a ? a[0] : o, E = (I) => {
    i && x.reportValidity && (x.setCustomValidity(cs(I) ? "" : I || ""), x.reportValidity());
  }, w = {}, C = BA(o), S = o1(o), M = C || S, k = (v || FA(o)) && kn(o.value) && kn(b) || g2(o) && o.value === "" || b === "" || Array.isArray(b) && !b.length, _ = Che.bind(null, g, r, w), O = (I, R, P, D = Ia.maxLength, L = Ia.minLength) => {
    const B = I ? R : P;
    w[g] = {
      type: I ? D : L,
      message: B,
      ref: o,
      ..._(I ? D : L, B)
    };
  };
  if (s ? !Array.isArray(b) || !b.length : l && (!M && (k || Ii(b)) || cs(b) && !b || S && !VG(a).isValid || C && !WG(a).isValid)) {
    const { value: I, message: R } = ds(l) ? { value: !!l, message: l } : md(l);
    if (I && (w[g] = {
      type: Ia.required,
      message: R,
      ref: x,
      ..._(Ia.required, R)
    }, !r))
      return E(R), w;
  }
  if (!k && (!Ii(d) || !Ii(f))) {
    let I, R;
    const P = md(f), D = md(d);
    if (!Ii(b) && !isNaN(b)) {
      const L = o.valueAsNumber || b && +b;
      Ii(P.value) || (I = L > P.value), Ii(D.value) || (R = L < D.value);
    } else {
      const L = o.valueAsDate || new Date(b), B = (H) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + H), $ = o.type == "time", z = o.type == "week";
      ds(P.value) && b && (I = $ ? B(b) > B(P.value) : z ? b > P.value : L > new Date(P.value)), ds(D.value) && b && (R = $ ? B(b) < B(D.value) : z ? b < D.value : L < new Date(D.value));
    }
    if ((I || R) && (O(!!I, P.message, D.message, Ia.max, Ia.min), !r))
      return E(w[g].message), w;
  }
  if ((c || u) && !k && (ds(b) || s && Array.isArray(b))) {
    const I = md(c), R = md(u), P = !Ii(I.value) && b.length > +I.value, D = !Ii(R.value) && b.length < +R.value;
    if ((P || D) && (O(P, I.message, R.message), !r))
      return E(w[g].message), w;
  }
  if (h && !k && ds(b)) {
    const { value: I, message: R } = md(h);
    if (v2(I) && !b.match(I) && (w[g] = {
      type: Ia.pattern,
      message: R,
      ref: o,
      ..._(Ia.pattern, R)
    }, !r))
      return E(R), w;
  }
  if (m) {
    if (oo(m)) {
      const I = await m(b, t), R = HI(I, x);
      if (R && (w[g] = {
        ...R,
        ..._(Ia.validate, R.message)
      }, !r))
        return E(R.message), w;
    } else if (lr(m)) {
      let I = {};
      for (const R in m) {
        if (!ui(I) && !r)
          break;
        const P = HI(await m[R](b, t), x, R);
        P && (I = {
          ...P,
          ..._(R, P.message)
        }, E(P.message), r && (w[g] = I));
      }
      if (!ui(I) && (w[g] = {
        ref: x,
        ...I
      }, !r))
        return w;
    }
  }
  return E(!0), w;
};
const Lhe = {
  mode: Is.onSubmit,
  reValidateMode: Is.onChange,
  shouldFocusError: !0
};
function $he(n = {}) {
  let e = {
    ...Lhe,
    ...n
  }, t = {
    submitCount: 0,
    isDirty: !1,
    isReady: !1,
    isLoading: oo(e.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1
  }, r = {}, i = lr(e.defaultValues) || lr(e.values) ? On(e.defaultValues || e.values) || {} : {}, s = e.shouldUnregister ? {} : On(i), o = {
    action: !1,
    mount: !1,
    watch: !1
  }, a = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, l, c = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  };
  let d = {
    ...u
  };
  const f = {
    array: DI(),
    state: DI()
  }, h = e.criteriaMode === Is.all, m = (G) => (re) => {
    clearTimeout(c), c = setTimeout(G, re);
  }, g = async (G) => {
    if (!e.disabled && (u.isValid || d.isValid || G)) {
      const re = e.resolver ? ui((await S()).errors) : await k(r, !0);
      re !== t.isValid && f.state.next({
        isValid: re
      });
    }
  }, v = (G, re) => {
    !e.disabled && (u.isValidating || u.validatingFields || d.isValidating || d.validatingFields) && ((G || Array.from(a.mount)).forEach((oe) => {
      oe && (re ? dn(t.validatingFields, oe, re) : Jn(t.validatingFields, oe));
    }), f.state.next({
      validatingFields: t.validatingFields,
      isValidating: !ui(t.validatingFields)
    }));
  }, y = (G, re = [], oe, Se, ye = !0, be = !0) => {
    if (Se && oe && !e.disabled) {
      if (o.action = !0, be && Array.isArray(Re(r, G))) {
        const Oe = oe(Re(r, G), Se.argA, Se.argB);
        ye && dn(r, G, Oe);
      }
      if (be && Array.isArray(Re(t.errors, G))) {
        const Oe = oe(Re(t.errors, G), Se.argA, Se.argB);
        ye && dn(t.errors, G, Oe), Nhe(t.errors, G);
      }
      if ((u.touchedFields || d.touchedFields) && be && Array.isArray(Re(t.touchedFields, G))) {
        const Oe = oe(Re(t.touchedFields, G), Se.argA, Se.argB);
        ye && dn(t.touchedFields, G, Oe);
      }
      (u.dirtyFields || d.dirtyFields) && (t.dirtyFields = Pd(i, s)), f.state.next({
        name: G,
        isDirty: O(G, re),
        dirtyFields: t.dirtyFields,
        errors: t.errors,
        isValid: t.isValid
      });
    } else
      dn(s, G, re);
  }, b = (G, re) => {
    dn(t.errors, G, re), f.state.next({
      errors: t.errors
    });
  }, x = (G) => {
    t.errors = G, f.state.next({
      errors: t.errors,
      isValid: !1
    });
  }, E = (G, re, oe, Se) => {
    const ye = Re(r, G);
    if (ye) {
      const be = Re(s, G, kn(oe) ? Re(i, G) : oe);
      kn(be) || Se && Se.defaultChecked || re ? dn(s, G, re ? be : FI(ye._f)) : P(G, be), o.mount && g();
    }
  }, w = (G, re, oe, Se, ye) => {
    let be = !1, Oe = !1;
    const ut = {
      name: G
    };
    if (!e.disabled) {
      if (!oe || Se) {
        (u.isDirty || d.isDirty) && (Oe = t.isDirty, t.isDirty = ut.isDirty = O(), be = Oe !== ut.isDirty);
        const Et = Ga(Re(i, G), re);
        Oe = !!Re(t.dirtyFields, G), Et ? Jn(t.dirtyFields, G) : dn(t.dirtyFields, G, !0), ut.dirtyFields = t.dirtyFields, be = be || (u.dirtyFields || d.dirtyFields) && Oe !== !Et;
      }
      if (oe) {
        const Et = Re(t.touchedFields, G);
        Et || (dn(t.touchedFields, G, oe), ut.touchedFields = t.touchedFields, be = be || (u.touchedFields || d.touchedFields) && Et !== oe);
      }
      be && ye && f.state.next(ut);
    }
    return be ? ut : {};
  }, C = (G, re, oe, Se) => {
    const ye = Re(t.errors, G), be = (u.isValid || d.isValid) && cs(re) && t.isValid !== re;
    if (e.delayError && oe ? (l = m(() => b(G, oe)), l(e.delayError)) : (clearTimeout(c), l = null, oe ? dn(t.errors, G, oe) : Jn(t.errors, G)), (oe ? !Ga(ye, oe) : ye) || !ui(Se) || be) {
      const Oe = {
        ...Se,
        ...be && cs(re) ? { isValid: re } : {},
        errors: t.errors,
        name: G
      };
      t = {
        ...t,
        ...Oe
      }, f.state.next(Oe);
    }
  }, S = async (G) => {
    v(G, !0);
    const re = await e.resolver(s, e.context, _he(G || a.mount, r, e.criteriaMode, e.shouldUseNativeValidation));
    return v(G), re;
  }, M = async (G) => {
    const { errors: re } = await S(G);
    if (G)
      for (const oe of G) {
        const Se = Re(re, oe);
        Se ? dn(t.errors, oe, Se) : Jn(t.errors, oe);
      }
    else
      t.errors = re;
    return re;
  }, k = async (G, re, oe = {
    valid: !0
  }) => {
    for (const Se in G) {
      const ye = G[Se];
      if (ye) {
        const { _f: be, ...Oe } = ye;
        if (be) {
          const ut = a.array.has(be.name), Et = ye._f && Ohe(ye._f);
          Et && u.validatingFields && v([be.name], !0);
          const Yt = await hC(ye, a.disabled, s, h, e.shouldUseNativeValidation && !re, ut);
          if (Et && u.validatingFields && v([be.name]), Yt[be.name] && (oe.valid = !1, re))
            break;
          !re && (Re(Yt, be.name) ? ut ? GG(t.errors, Yt, be.name) : dn(t.errors, be.name, Yt[be.name]) : Jn(t.errors, be.name));
        }
        !ui(Oe) && await k(Oe, re, oe);
      }
    }
    return oe.valid;
  }, _ = () => {
    for (const G of a.unMount) {
      const re = Re(r, G);
      re && (re._f.refs ? re._f.refs.every((oe) => !zx(oe)) : !zx(re._f.ref)) && J(G);
    }
    a.unMount = /* @__PURE__ */ new Set();
  }, O = (G, re) => !e.disabled && (G && re && dn(s, G, re), !Ga(H(), i)), I = (G, re, oe) => BG(G, a, {
    ...o.mount ? s : kn(re) ? i : ds(G) ? { [G]: re } : re
  }, oe, re), R = (G) => ww(Re(o.mount ? s : i, G, e.shouldUnregister ? Re(i, G, []) : [])), P = (G, re, oe = {}) => {
    const Se = Re(r, G);
    let ye = re;
    if (Se) {
      const be = Se._f;
      be && (!be.disabled && dn(s, G, jG(re, be)), ye = g2(be.ref) && Ii(re) ? "" : re, HG(be.ref) ? [...be.ref.options].forEach((Oe) => Oe.selected = ye.includes(Oe.value)) : be.refs ? o1(be.ref) ? be.refs.forEach((Oe) => {
        (!Oe.defaultChecked || !Oe.disabled) && (Array.isArray(ye) ? Oe.checked = !!ye.find((ut) => ut === Oe.value) : Oe.checked = ye === Oe.value || !!ye);
      }) : be.refs.forEach((Oe) => Oe.checked = Oe.value === ye) : FA(be.ref) ? be.ref.value = "" : (be.ref.value = ye, be.ref.type || f.state.next({
        name: G,
        values: On(s)
      })));
    }
    (oe.shouldDirty || oe.shouldTouch) && w(G, ye, oe.shouldTouch, oe.shouldDirty, !0), oe.shouldValidate && z(G);
  }, D = (G, re, oe) => {
    for (const Se in re) {
      if (!re.hasOwnProperty(Se))
        return;
      const ye = re[Se], be = G + "." + Se, Oe = Re(r, be);
      (a.array.has(G) || lr(ye) || Oe && !Oe._f) && !ru(ye) ? D(be, ye, oe) : P(be, ye, oe);
    }
  }, L = (G, re, oe = {}) => {
    const Se = Re(r, G), ye = a.array.has(G), be = On(re);
    dn(s, G, be), ye ? (f.array.next({
      name: G,
      values: On(s)
    }), (u.isDirty || u.dirtyFields || d.isDirty || d.dirtyFields) && oe.shouldDirty && f.state.next({
      name: G,
      dirtyFields: Pd(i, s),
      isDirty: O(G, be)
    })) : Se && !Se._f && !Ii(be) ? D(G, be, oe) : P(G, be, oe), fC(G, a) && f.state.next({ ...t, name: G }), f.state.next({
      name: o.mount ? G : void 0,
      values: On(s)
    });
  }, B = async (G) => {
    o.mount = !0;
    const re = G.target;
    let oe = re.name, Se = !0;
    const ye = Re(r, oe), be = (Et) => {
      Se = Number.isNaN(Et) || ru(Et) && isNaN(Et.getTime()) || Ga(Et, Re(s, oe, Et));
    }, Oe = Wd(e.mode), ut = Wd(e.reValidateMode);
    if (ye) {
      let Et, Yt;
      const Wt = re.type ? FI(ye._f) : LG(G), me = G.type === m2.BLUR || G.type === m2.FOCUS_OUT, Pe = !Ihe(ye._f) && !e.resolver && !Re(t.errors, oe) && !ye._f.deps || Dhe(me, Re(t.touchedFields, oe), t.isSubmitted, ut, Oe), yt = fC(oe, a, me);
      dn(s, oe, Wt), me ? (!re || !re.readOnly) && (ye._f.onBlur && ye._f.onBlur(G), l && l(0)) : ye._f.onChange && ye._f.onChange(G);
      const kt = w(oe, Wt, me), rn = !ui(kt) || yt;
      if (!me && f.state.next({
        name: oe,
        type: G.type,
        values: On(s)
      }), Pe)
        return (u.isValid || d.isValid) && (e.mode === "onBlur" ? me && g() : me || g()), rn && f.state.next({ name: oe, ...yt ? {} : kt });
      if (!me && yt && f.state.next({ ...t }), e.resolver) {
        const { errors: vn } = await S([oe]);
        if (be(Wt), Se) {
          const Xi = zI(t.errors, r, oe), ot = zI(vn, r, Xi.name || oe);
          Et = ot.error, oe = ot.name, Yt = ui(vn);
        }
      } else
        v([oe], !0), Et = (await hC(ye, a.disabled, s, h, e.shouldUseNativeValidation))[oe], v([oe]), be(Wt), Se && (Et ? Yt = !1 : (u.isValid || d.isValid) && (Yt = await k(r, !0)));
      Se && (ye._f.deps && (!Array.isArray(ye._f.deps) || ye._f.deps.length > 0) && z(ye._f.deps), C(oe, Yt, Et, kt));
    }
  }, $ = (G, re) => {
    if (Re(t.errors, re) && G.focus)
      return G.focus(), 1;
  }, z = async (G, re = {}) => {
    let oe, Se;
    const ye = Li(G);
    if (e.resolver) {
      const be = await M(kn(G) ? G : ye);
      oe = ui(be), Se = G ? !ye.some((Oe) => Re(be, Oe)) : oe;
    } else G ? (Se = (await Promise.all(ye.map(async (be) => {
      const Oe = Re(r, be);
      return await k(Oe && Oe._f ? { [be]: Oe } : Oe);
    }))).every(Boolean), !(!Se && !t.isValid) && g()) : Se = oe = await k(r);
    return f.state.next({
      ...!ds(G) || (u.isValid || d.isValid) && oe !== t.isValid ? {} : { name: G },
      ...e.resolver || !G ? { isValid: oe } : {},
      errors: t.errors
    }), re.shouldFocus && !Se && nf(r, $, G ? ye : a.mount), Se;
  }, H = (G, re) => {
    let oe = {
      ...o.mount ? s : i
    };
    return re && (oe = zG(re.dirtyFields ? t.dirtyFields : t.touchedFields, oe)), kn(G) ? oe : ds(G) ? Re(oe, G) : G.map((Se) => Re(oe, Se));
  }, U = (G, re) => ({
    invalid: !!Re((re || t).errors, G),
    isDirty: !!Re((re || t).dirtyFields, G),
    error: Re((re || t).errors, G),
    isValidating: !!Re(t.validatingFields, G),
    isTouched: !!Re((re || t).touchedFields, G)
  }), F = (G) => {
    G && Li(G).forEach((re) => Jn(t.errors, re)), f.state.next({
      errors: G ? t.errors : {}
    });
  }, V = (G, re, oe) => {
    const Se = (Re(r, G, { _f: {} })._f || {}).ref, ye = Re(t.errors, G) || {}, { ref: be, message: Oe, type: ut, ...Et } = ye;
    dn(t.errors, G, {
      ...Et,
      ...re,
      ref: Se
    }), f.state.next({
      name: G,
      errors: t.errors,
      isValid: !1
    }), oe && oe.shouldFocus && Se && Se.focus && Se.focus();
  }, X = (G, re) => oo(G) ? f.state.subscribe({
    next: (oe) => "values" in oe && G(I(void 0, re), oe)
  }) : I(G, re, !0), Z = (G) => f.state.subscribe({
    next: (re) => {
      Phe(G.name, re.name, G.exact) && Rhe(re, G.formState || u, Ie, G.reRenderRoot) && G.callback({
        values: { ...s },
        ...t,
        ...re,
        defaultValues: i
      });
    }
  }).unsubscribe, ie = (G) => (o.mount = !0, d = {
    ...d,
    ...G.formState
  }, Z({
    ...G,
    formState: d
  })), J = (G, re = {}) => {
    for (const oe of G ? Li(G) : a.mount)
      a.mount.delete(oe), a.array.delete(oe), re.keepValue || (Jn(r, oe), Jn(s, oe)), !re.keepError && Jn(t.errors, oe), !re.keepDirty && Jn(t.dirtyFields, oe), !re.keepTouched && Jn(t.touchedFields, oe), !re.keepIsValidating && Jn(t.validatingFields, oe), !e.shouldUnregister && !re.keepDefaultValue && Jn(i, oe);
    f.state.next({
      values: On(s)
    }), f.state.next({
      ...t,
      ...re.keepDirty ? { isDirty: O() } : {}
    }), !re.keepIsValid && g();
  }, se = ({ disabled: G, name: re }) => {
    (cs(G) && o.mount || G || a.disabled.has(re)) && (G ? a.disabled.add(re) : a.disabled.delete(re));
  }, te = (G, re = {}) => {
    let oe = Re(r, G);
    const Se = cs(re.disabled) || cs(e.disabled);
    return dn(r, G, {
      ...oe || {},
      _f: {
        ...oe && oe._f ? oe._f : { ref: { name: G } },
        name: G,
        mount: !0,
        ...re
      }
    }), a.mount.add(G), oe ? se({
      disabled: cs(re.disabled) ? re.disabled : e.disabled,
      name: G
    }) : E(G, !0, re.value), {
      ...Se ? { disabled: re.disabled || e.disabled } : {},
      ...e.progressive ? {
        required: !!re.required,
        min: Xh(re.min),
        max: Xh(re.max),
        minLength: Xh(re.minLength),
        maxLength: Xh(re.maxLength),
        pattern: Xh(re.pattern)
      } : {},
      name: G,
      onChange: B,
      onBlur: B,
      ref: (ye) => {
        if (ye) {
          te(G, re), oe = Re(r, G);
          const be = kn(ye.value) && ye.querySelectorAll && ye.querySelectorAll("input,select,textarea")[0] || ye, Oe = The(be), ut = oe._f.refs || [];
          if (Oe ? ut.find((Et) => Et === be) : be === oe._f.ref)
            return;
          dn(r, G, {
            _f: {
              ...oe._f,
              ...Oe ? {
                refs: [
                  ...ut.filter(zx),
                  be,
                  ...Array.isArray(Re(i, G)) ? [{}] : []
                ],
                ref: { type: be.type, name: G }
              } : { ref: be }
            }
          }), E(G, !1, void 0, be);
        } else
          oe = Re(r, G, {}), oe._f && (oe._f.mount = !1), (e.shouldUnregister || re.shouldUnregister) && !($G(a.array, G) && o.action) && a.unMount.add(G);
      }
    };
  }, le = () => e.shouldFocusError && nf(r, $, a.mount), de = (G) => {
    cs(G) && (f.state.next({ disabled: G }), nf(r, (re, oe) => {
      const Se = Re(r, oe);
      Se && (re.disabled = Se._f.disabled || G, Array.isArray(Se._f.refs) && Se._f.refs.forEach((ye) => {
        ye.disabled = Se._f.disabled || G;
      }));
    }, 0, !1));
  }, j = (G, re) => async (oe) => {
    let Se;
    oe && (oe.preventDefault && oe.preventDefault(), oe.persist && oe.persist());
    let ye = On(s);
    if (f.state.next({
      isSubmitting: !0
    }), e.resolver) {
      const { errors: be, values: Oe } = await S();
      t.errors = be, ye = On(Oe);
    } else
      await k(r);
    if (a.disabled.size)
      for (const be of a.disabled)
        Jn(ye, be);
    if (Jn(t.errors, "root"), ui(t.errors)) {
      f.state.next({
        errors: {}
      });
      try {
        await G(ye, oe);
      } catch (be) {
        Se = be;
      }
    } else
      re && await re({ ...t.errors }, oe), le(), setTimeout(le);
    if (f.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: ui(t.errors) && !Se,
      submitCount: t.submitCount + 1,
      errors: t.errors
    }), Se)
      throw Se;
  }, xe = (G, re = {}) => {
    Re(r, G) && (kn(re.defaultValue) ? L(G, On(Re(i, G))) : (L(G, re.defaultValue), dn(i, G, On(re.defaultValue))), re.keepTouched || Jn(t.touchedFields, G), re.keepDirty || (Jn(t.dirtyFields, G), t.isDirty = re.defaultValue ? O(G, On(Re(i, G))) : O()), re.keepError || (Jn(t.errors, G), u.isValid && g()), f.state.next({ ...t }));
  }, ne = (G, re = {}) => {
    const oe = G ? On(G) : i, Se = On(oe), ye = ui(G), be = ye ? i : Se;
    if (re.keepDefaultValues || (i = oe), !re.keepValues) {
      if (re.keepDirtyValues) {
        const Oe = /* @__PURE__ */ new Set([
          ...a.mount,
          ...Object.keys(Pd(i, s))
        ]);
        for (const ut of Array.from(Oe))
          Re(t.dirtyFields, ut) ? dn(be, ut, Re(s, ut)) : L(ut, Re(be, ut));
      } else {
        if (NA && kn(G))
          for (const Oe of a.mount) {
            const ut = Re(r, Oe);
            if (ut && ut._f) {
              const Et = Array.isArray(ut._f.refs) ? ut._f.refs[0] : ut._f.ref;
              if (g2(Et)) {
                const Yt = Et.closest("form");
                if (Yt) {
                  Yt.reset();
                  break;
                }
              }
            }
          }
        if (re.keepFieldsRef)
          for (const Oe of a.mount)
            L(Oe, Re(be, Oe));
        else
          r = {};
      }
      s = e.shouldUnregister ? re.keepDefaultValues ? On(i) : {} : On(be), f.array.next({
        values: { ...be }
      }), f.state.next({
        values: { ...be }
      });
    }
    a = {
      mount: re.keepDirtyValues ? a.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, o.mount = !u.isValid || !!re.keepIsValid || !!re.keepDirtyValues, o.watch = !!e.shouldUnregister, f.state.next({
      submitCount: re.keepSubmitCount ? t.submitCount : 0,
      isDirty: ye ? !1 : re.keepDirty ? t.isDirty : !!(re.keepDefaultValues && !Ga(G, i)),
      isSubmitted: re.keepIsSubmitted ? t.isSubmitted : !1,
      dirtyFields: ye ? {} : re.keepDirtyValues ? re.keepDefaultValues && s ? Pd(i, s) : t.dirtyFields : re.keepDefaultValues && G ? Pd(i, G) : re.keepDirty ? t.dirtyFields : {},
      touchedFields: re.keepTouched ? t.touchedFields : {},
      errors: re.keepErrors ? t.errors : {},
      isSubmitSuccessful: re.keepIsSubmitSuccessful ? t.isSubmitSuccessful : !1,
      isSubmitting: !1,
      defaultValues: i
    });
  }, qe = (G, re) => ne(oo(G) ? G(s) : G, re), ve = (G, re = {}) => {
    const oe = Re(r, G), Se = oe && oe._f;
    if (Se) {
      const ye = Se.refs ? Se.refs[0] : Se.ref;
      ye.focus && (ye.focus(), re.shouldSelect && oo(ye.select) && ye.select());
    }
  }, Ie = (G) => {
    t = {
      ...t,
      ...G
    };
  }, xt = {
    control: {
      register: te,
      unregister: J,
      getFieldState: U,
      handleSubmit: j,
      setError: V,
      _subscribe: Z,
      _runSchema: S,
      _focusError: le,
      _getWatch: I,
      _getDirty: O,
      _setValid: g,
      _setFieldArray: y,
      _setDisabledField: se,
      _setErrors: x,
      _getFieldArray: R,
      _reset: ne,
      _resetDefaultValues: () => oo(e.defaultValues) && e.defaultValues().then((G) => {
        qe(G, e.resetOptions), f.state.next({
          isLoading: !1
        });
      }),
      _removeUnmounted: _,
      _disableForm: de,
      _subjects: f,
      _proxyFormState: u,
      get _fields() {
        return r;
      },
      get _formValues() {
        return s;
      },
      get _state() {
        return o;
      },
      set _state(G) {
        o = G;
      },
      get _defaultValues() {
        return i;
      },
      get _names() {
        return a;
      },
      set _names(G) {
        a = G;
      },
      get _formState() {
        return t;
      },
      get _options() {
        return e;
      },
      set _options(G) {
        e = {
          ...e,
          ...G
        };
      }
    },
    subscribe: ie,
    trigger: z,
    register: te,
    handleSubmit: j,
    watch: X,
    setValue: L,
    getValues: H,
    reset: qe,
    resetField: xe,
    clearErrors: F,
    unregister: J,
    setError: V,
    setFocus: ve,
    getFieldState: U
  };
  return {
    ...xt,
    formControl: xt
  };
}
var Ml = () => {
  if (typeof crypto < "u" && crypto.randomUUID)
    return crypto.randomUUID();
  const n = typeof performance > "u" ? Date.now() : performance.now() * 1e3;
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (e) => {
    const t = (Math.random() * 16 + n) % 16 | 0;
    return (e == "x" ? t : t & 3 | 8).toString(16);
  });
}, Hx = (n, e, t = {}) => t.shouldFocus || kn(t.shouldFocus) ? t.focusName || `${n}.${kn(t.focusIndex) ? e : t.focusIndex}.` : "", Ux = (n, e) => [
  ...n,
  ...Li(e)
], Vx = (n) => Array.isArray(n) ? n.map(() => {
}) : void 0;
function jx(n, e, t) {
  return [
    ...n.slice(0, e),
    ...Li(t),
    ...n.slice(e)
  ];
}
var Wx = (n, e, t) => Array.isArray(n) ? (kn(n[t]) && (n[t] = void 0), n.splice(t, 0, n.splice(e, 1)[0]), n) : [], Gx = (n, e) => [
  ...Li(e),
  ...Li(n)
];
function Fhe(n, e) {
  let t = 0;
  const r = [...n];
  for (const i of e)
    r.splice(i - t, 1), t++;
  return ww(r).length ? r : [];
}
var Kx = (n, e) => kn(e) ? [] : Fhe(n, Li(e).sort((t, r) => t - r)), qx = (n, e, t) => {
  [n[e], n[t]] = [n[t], n[e]];
}, UI = (n, e, t) => (n[e] = t, n);
function Hbt(n) {
  const e = Ju(), { control: t = e.control, name: r, keyName: i = "id", shouldUnregister: s, rules: o } = n, [a, l] = p.useState(t._getFieldArray(r)), c = p.useRef(t._getFieldArray(r).map(Ml)), u = p.useRef(!1);
  t._names.array.add(r), p.useMemo(() => o && a.length >= 0 && t.register(r, o), [t, r, a.length, o]), xw(() => t._subjects.array.subscribe({
    next: ({ values: E, name: w }) => {
      if (w === r || !w) {
        const C = Re(E, r);
        Array.isArray(C) && (l(C), c.current = C.map(Ml));
      }
    }
  }).unsubscribe, [t, r]);
  const d = p.useCallback((E) => {
    u.current = !0, t._setFieldArray(r, E);
  }, [t, r]), f = (E, w) => {
    const C = Li(On(E)), S = Ux(t._getFieldArray(r), C);
    t._names.focus = Hx(r, S.length - 1, w), c.current = Ux(c.current, C.map(Ml)), d(S), l(S), t._setFieldArray(r, S, Ux, {
      argA: Vx(E)
    });
  }, h = (E, w) => {
    const C = Li(On(E)), S = Gx(t._getFieldArray(r), C);
    t._names.focus = Hx(r, 0, w), c.current = Gx(c.current, C.map(Ml)), d(S), l(S), t._setFieldArray(r, S, Gx, {
      argA: Vx(E)
    });
  }, m = (E) => {
    const w = Kx(t._getFieldArray(r), E);
    c.current = Kx(c.current, E), d(w), l(w), !Array.isArray(Re(t._fields, r)) && dn(t._fields, r, void 0), t._setFieldArray(r, w, Kx, {
      argA: E
    });
  }, g = (E, w, C) => {
    const S = Li(On(w)), M = jx(t._getFieldArray(r), E, S);
    t._names.focus = Hx(r, E, C), c.current = jx(c.current, E, S.map(Ml)), d(M), l(M), t._setFieldArray(r, M, jx, {
      argA: E,
      argB: Vx(w)
    });
  }, v = (E, w) => {
    const C = t._getFieldArray(r);
    qx(C, E, w), qx(c.current, E, w), d(C), l(C), t._setFieldArray(r, C, qx, {
      argA: E,
      argB: w
    }, !1);
  }, y = (E, w) => {
    const C = t._getFieldArray(r);
    Wx(C, E, w), Wx(c.current, E, w), d(C), l(C), t._setFieldArray(r, C, Wx, {
      argA: E,
      argB: w
    }, !1);
  }, b = (E, w) => {
    const C = On(w), S = UI(t._getFieldArray(r), E, C);
    c.current = [...S].map((M, k) => !M || k === E ? Ml() : c.current[k]), d(S), l([...S]), t._setFieldArray(r, S, UI, {
      argA: E,
      argB: C
    }, !0, !1);
  }, x = (E) => {
    const w = Li(On(E));
    c.current = w.map(Ml), d([...w]), l([...w]), t._setFieldArray(r, [...w], (C) => C, {}, !0, !1);
  };
  return p.useEffect(() => {
    if (t._state.action = !1, fC(r, t._names) && t._subjects.state.next({
      ...t._formState
    }), u.current && (!Wd(t._options.mode).isOnSubmit || t._formState.isSubmitted) && !Wd(t._options.reValidateMode).isOnSubmit)
      if (t._options.resolver)
        t._runSchema([r]).then((E) => {
          const w = Re(E.errors, r), C = Re(t._formState.errors, r);
          (C ? !w && C.type || w && (C.type !== w.type || C.message !== w.message) : w && w.type) && (w ? dn(t._formState.errors, r, w) : Jn(t._formState.errors, r), t._subjects.state.next({
            errors: t._formState.errors
          }));
        });
      else {
        const E = Re(t._fields, r);
        E && E._f && !(Wd(t._options.reValidateMode).isOnSubmit && Wd(t._options.mode).isOnSubmit) && hC(E, t._names.disabled, t._formValues, t._options.criteriaMode === Is.all, t._options.shouldUseNativeValidation, !0).then((w) => !ui(w) && t._subjects.state.next({
          errors: GG(t._formState.errors, w, r)
        }));
      }
    t._subjects.state.next({
      name: r,
      values: On(t._formValues)
    }), t._names.focus && nf(t._fields, (E, w) => {
      if (t._names.focus && w.startsWith(t._names.focus) && E.focus)
        return E.focus(), 1;
    }), t._names.focus = "", t._setValid(), u.current = !1;
  }, [a, r, t]), p.useEffect(() => (!Re(t._formValues, r) && t._setFieldArray(r), () => {
    const E = (w, C) => {
      const S = Re(t._fields, w);
      S && S._f && (S._f.mount = C);
    };
    t._options.shouldUnregister || s ? t.unregister(r) : E(r, !1);
  }), [r, t, i, s]), {
    swap: p.useCallback(v, [d, r, t]),
    move: p.useCallback(y, [d, r, t]),
    prepend: p.useCallback(h, [d, r, t]),
    append: p.useCallback(f, [d, r, t]),
    remove: p.useCallback(m, [d, r, t]),
    insert: p.useCallback(g, [d, r, t]),
    update: p.useCallback(b, [d, r, t]),
    replace: p.useCallback(x, [d, r, t]),
    fields: p.useMemo(() => a.map((E, w) => ({
      ...E,
      [i]: c.current[w] || Ml()
    })), [a, i])
  };
}
function Ubt(n = {}) {
  const e = p.useRef(void 0), t = p.useRef(void 0), [r, i] = p.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: oo(n.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: n.errors || {},
    disabled: n.disabled || !1,
    isReady: !1,
    defaultValues: oo(n.defaultValues) ? void 0 : n.defaultValues
  });
  if (!e.current)
    if (n.formControl)
      e.current = {
        ...n.formControl,
        formState: r
      }, n.defaultValues && !oo(n.defaultValues) && n.formControl.reset(n.defaultValues, n.resetOptions);
    else {
      const { formControl: o, ...a } = $he(n);
      e.current = {
        ...a,
        formState: r
      };
    }
  const s = e.current.control;
  return s._options = n, xw(() => {
    const o = s._subscribe({
      formState: s._proxyFormState,
      callback: () => i({ ...s._formState }),
      reRenderRoot: !0
    });
    return i((a) => ({
      ...a,
      isReady: !0
    })), s._formState.isReady = !0, o;
  }, [s]), p.useEffect(() => s._disableForm(n.disabled), [s, n.disabled]), p.useEffect(() => {
    n.mode && (s._options.mode = n.mode), n.reValidateMode && (s._options.reValidateMode = n.reValidateMode);
  }, [s, n.mode, n.reValidateMode]), p.useEffect(() => {
    n.errors && (s._setErrors(n.errors), s._focusError());
  }, [s, n.errors]), p.useEffect(() => {
    n.shouldUnregister && s._subjects.state.next({
      values: s._getWatch()
    });
  }, [s, n.shouldUnregister]), p.useEffect(() => {
    if (s._proxyFormState.isDirty) {
      const o = s._getDirty();
      o !== r.isDirty && s._subjects.state.next({
        isDirty: o
      });
    }
  }, [s, r.isDirty]), p.useEffect(() => {
    n.values && !Ga(n.values, t.current) ? (s._reset(n.values, {
      keepFieldsRef: !0,
      ...s._options.resetOptions
    }), t.current = n.values, i((o) => ({ ...o }))) : s._resetDefaultValues();
  }, [s, n.values]), p.useEffect(() => {
    s._state.mount || (s._setValid(), s._state.mount = !0), s._state.watch && (s._state.watch = !1, s._subjects.state.next({ ...s._formState })), s._removeUnmounted();
  }), e.current.formState = FG(r, s), e.current;
}
var ig = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function nn(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var Yx, VI;
function Gi() {
  if (VI) return Yx;
  VI = 1;
  var n = Array.isArray;
  return Yx = n, Yx;
}
var Xx, jI;
function KG() {
  if (jI) return Xx;
  jI = 1;
  var n = typeof ig == "object" && ig && ig.Object === Object && ig;
  return Xx = n, Xx;
}
var Zx, WI;
function Sa() {
  if (WI) return Zx;
  WI = 1;
  var n = KG(), e = typeof self == "object" && self && self.Object === Object && self, t = n || e || Function("return this")();
  return Zx = t, Zx;
}
var Qx, GI;
function a1() {
  if (GI) return Qx;
  GI = 1;
  var n = Sa(), e = n.Symbol;
  return Qx = e, Qx;
}
var Jx, KI;
function Bhe() {
  if (KI) return Jx;
  KI = 1;
  var n = a1(), e = Object.prototype, t = e.hasOwnProperty, r = e.toString, i = n ? n.toStringTag : void 0;
  function s(o) {
    var a = t.call(o, i), l = o[i];
    try {
      o[i] = void 0;
      var c = !0;
    } catch {
    }
    var u = r.call(o);
    return c && (a ? o[i] = l : delete o[i]), u;
  }
  return Jx = s, Jx;
}
var e4, qI;
function zhe() {
  if (qI) return e4;
  qI = 1;
  var n = Object.prototype, e = n.toString;
  function t(r) {
    return e.call(r);
  }
  return e4 = t, e4;
}
var t4, YI;
function yl() {
  if (YI) return t4;
  YI = 1;
  var n = a1(), e = Bhe(), t = zhe(), r = "[object Null]", i = "[object Undefined]", s = n ? n.toStringTag : void 0;
  function o(a) {
    return a == null ? a === void 0 ? i : r : s && s in Object(a) ? e(a) : t(a);
  }
  return t4 = o, t4;
}
var n4, XI;
function bl() {
  if (XI) return n4;
  XI = 1;
  function n(e) {
    return e != null && typeof e == "object";
  }
  return n4 = n, n4;
}
var r4, ZI;
function xh() {
  if (ZI) return r4;
  ZI = 1;
  var n = yl(), e = bl(), t = "[object Symbol]";
  function r(i) {
    return typeof i == "symbol" || e(i) && n(i) == t;
  }
  return r4 = r, r4;
}
var i4, QI;
function zA() {
  if (QI) return i4;
  QI = 1;
  var n = Gi(), e = xh(), t = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, r = /^\w*$/;
  function i(s, o) {
    if (n(s))
      return !1;
    var a = typeof s;
    return a == "number" || a == "symbol" || a == "boolean" || s == null || e(s) ? !0 : r.test(s) || !t.test(s) || o != null && s in Object(o);
  }
  return i4 = i, i4;
}
var s4, JI;
function Cc() {
  if (JI) return s4;
  JI = 1;
  function n(e) {
    var t = typeof e;
    return e != null && (t == "object" || t == "function");
  }
  return s4 = n, s4;
}
var o4, eR;
function HA() {
  if (eR) return o4;
  eR = 1;
  var n = yl(), e = Cc(), t = "[object AsyncFunction]", r = "[object Function]", i = "[object GeneratorFunction]", s = "[object Proxy]";
  function o(a) {
    if (!e(a))
      return !1;
    var l = n(a);
    return l == r || l == i || l == t || l == s;
  }
  return o4 = o, o4;
}
var a4, tR;
function Hhe() {
  if (tR) return a4;
  tR = 1;
  var n = Sa(), e = n["__core-js_shared__"];
  return a4 = e, a4;
}
var l4, nR;
function Uhe() {
  if (nR) return l4;
  nR = 1;
  var n = Hhe(), e = (function() {
    var r = /[^.]+$/.exec(n && n.keys && n.keys.IE_PROTO || "");
    return r ? "Symbol(src)_1." + r : "";
  })();
  function t(r) {
    return !!e && e in r;
  }
  return l4 = t, l4;
}
var c4, rR;
function qG() {
  if (rR) return c4;
  rR = 1;
  var n = Function.prototype, e = n.toString;
  function t(r) {
    if (r != null) {
      try {
        return e.call(r);
      } catch {
      }
      try {
        return r + "";
      } catch {
      }
    }
    return "";
  }
  return c4 = t, c4;
}
var u4, iR;
function Vhe() {
  if (iR) return u4;
  iR = 1;
  var n = HA(), e = Uhe(), t = Cc(), r = qG(), i = /[\\^$.*+?()[\]{}|]/g, s = /^\[object .+?Constructor\]$/, o = Function.prototype, a = Object.prototype, l = o.toString, c = a.hasOwnProperty, u = RegExp(
    "^" + l.call(c).replace(i, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function d(f) {
    if (!t(f) || e(f))
      return !1;
    var h = n(f) ? u : s;
    return h.test(r(f));
  }
  return u4 = d, u4;
}
var d4, sR;
function jhe() {
  if (sR) return d4;
  sR = 1;
  function n(e, t) {
    return e?.[t];
  }
  return d4 = n, d4;
}
var f4, oR;
function ed() {
  if (oR) return f4;
  oR = 1;
  var n = Vhe(), e = jhe();
  function t(r, i) {
    var s = e(r, i);
    return n(s) ? s : void 0;
  }
  return f4 = t, f4;
}
var h4, aR;
function Ew() {
  if (aR) return h4;
  aR = 1;
  var n = ed(), e = n(Object, "create");
  return h4 = e, h4;
}
var p4, lR;
function Whe() {
  if (lR) return p4;
  lR = 1;
  var n = Ew();
  function e() {
    this.__data__ = n ? n(null) : {}, this.size = 0;
  }
  return p4 = e, p4;
}
var m4, cR;
function Ghe() {
  if (cR) return m4;
  cR = 1;
  function n(e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
  }
  return m4 = n, m4;
}
var g4, uR;
function Khe() {
  if (uR) return g4;
  uR = 1;
  var n = Ew(), e = "__lodash_hash_undefined__", t = Object.prototype, r = t.hasOwnProperty;
  function i(s) {
    var o = this.__data__;
    if (n) {
      var a = o[s];
      return a === e ? void 0 : a;
    }
    return r.call(o, s) ? o[s] : void 0;
  }
  return g4 = i, g4;
}
var v4, dR;
function qhe() {
  if (dR) return v4;
  dR = 1;
  var n = Ew(), e = Object.prototype, t = e.hasOwnProperty;
  function r(i) {
    var s = this.__data__;
    return n ? s[i] !== void 0 : t.call(s, i);
  }
  return v4 = r, v4;
}
var y4, fR;
function Yhe() {
  if (fR) return y4;
  fR = 1;
  var n = Ew(), e = "__lodash_hash_undefined__";
  function t(r, i) {
    var s = this.__data__;
    return this.size += this.has(r) ? 0 : 1, s[r] = n && i === void 0 ? e : i, this;
  }
  return y4 = t, y4;
}
var b4, hR;
function Xhe() {
  if (hR) return b4;
  hR = 1;
  var n = Whe(), e = Ghe(), t = Khe(), r = qhe(), i = Yhe();
  function s(o) {
    var a = -1, l = o == null ? 0 : o.length;
    for (this.clear(); ++a < l; ) {
      var c = o[a];
      this.set(c[0], c[1]);
    }
  }
  return s.prototype.clear = n, s.prototype.delete = e, s.prototype.get = t, s.prototype.has = r, s.prototype.set = i, b4 = s, b4;
}
var w4, pR;
function Zhe() {
  if (pR) return w4;
  pR = 1;
  function n() {
    this.__data__ = [], this.size = 0;
  }
  return w4 = n, w4;
}
var x4, mR;
function UA() {
  if (mR) return x4;
  mR = 1;
  function n(e, t) {
    return e === t || e !== e && t !== t;
  }
  return x4 = n, x4;
}
var E4, gR;
function Sw() {
  if (gR) return E4;
  gR = 1;
  var n = UA();
  function e(t, r) {
    for (var i = t.length; i--; )
      if (n(t[i][0], r))
        return i;
    return -1;
  }
  return E4 = e, E4;
}
var S4, vR;
function Qhe() {
  if (vR) return S4;
  vR = 1;
  var n = Sw(), e = Array.prototype, t = e.splice;
  function r(i) {
    var s = this.__data__, o = n(s, i);
    if (o < 0)
      return !1;
    var a = s.length - 1;
    return o == a ? s.pop() : t.call(s, o, 1), --this.size, !0;
  }
  return S4 = r, S4;
}
var C4, yR;
function Jhe() {
  if (yR) return C4;
  yR = 1;
  var n = Sw();
  function e(t) {
    var r = this.__data__, i = n(r, t);
    return i < 0 ? void 0 : r[i][1];
  }
  return C4 = e, C4;
}
var T4, bR;
function epe() {
  if (bR) return T4;
  bR = 1;
  var n = Sw();
  function e(t) {
    return n(this.__data__, t) > -1;
  }
  return T4 = e, T4;
}
var A4, wR;
function tpe() {
  if (wR) return A4;
  wR = 1;
  var n = Sw();
  function e(t, r) {
    var i = this.__data__, s = n(i, t);
    return s < 0 ? (++this.size, i.push([t, r])) : i[s][1] = r, this;
  }
  return A4 = e, A4;
}
var M4, xR;
function Cw() {
  if (xR) return M4;
  xR = 1;
  var n = Zhe(), e = Qhe(), t = Jhe(), r = epe(), i = tpe();
  function s(o) {
    var a = -1, l = o == null ? 0 : o.length;
    for (this.clear(); ++a < l; ) {
      var c = o[a];
      this.set(c[0], c[1]);
    }
  }
  return s.prototype.clear = n, s.prototype.delete = e, s.prototype.get = t, s.prototype.has = r, s.prototype.set = i, M4 = s, M4;
}
var k4, ER;
function VA() {
  if (ER) return k4;
  ER = 1;
  var n = ed(), e = Sa(), t = n(e, "Map");
  return k4 = t, k4;
}
var _4, SR;
function npe() {
  if (SR) return _4;
  SR = 1;
  var n = Xhe(), e = Cw(), t = VA();
  function r() {
    this.size = 0, this.__data__ = {
      hash: new n(),
      map: new (t || e)(),
      string: new n()
    };
  }
  return _4 = r, _4;
}
var O4, CR;
function rpe() {
  if (CR) return O4;
  CR = 1;
  function n(e) {
    var t = typeof e;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
  }
  return O4 = n, O4;
}
var I4, TR;
function Tw() {
  if (TR) return I4;
  TR = 1;
  var n = rpe();
  function e(t, r) {
    var i = t.__data__;
    return n(r) ? i[typeof r == "string" ? "string" : "hash"] : i.map;
  }
  return I4 = e, I4;
}
var R4, AR;
function ipe() {
  if (AR) return R4;
  AR = 1;
  var n = Tw();
  function e(t) {
    var r = n(this, t).delete(t);
    return this.size -= r ? 1 : 0, r;
  }
  return R4 = e, R4;
}
var P4, MR;
function spe() {
  if (MR) return P4;
  MR = 1;
  var n = Tw();
  function e(t) {
    return n(this, t).get(t);
  }
  return P4 = e, P4;
}
var D4, kR;
function ope() {
  if (kR) return D4;
  kR = 1;
  var n = Tw();
  function e(t) {
    return n(this, t).has(t);
  }
  return D4 = e, D4;
}
var N4, _R;
function ape() {
  if (_R) return N4;
  _R = 1;
  var n = Tw();
  function e(t, r) {
    var i = n(this, t), s = i.size;
    return i.set(t, r), this.size += i.size == s ? 0 : 1, this;
  }
  return N4 = e, N4;
}
var L4, OR;
function jA() {
  if (OR) return L4;
  OR = 1;
  var n = npe(), e = ipe(), t = spe(), r = ope(), i = ape();
  function s(o) {
    var a = -1, l = o == null ? 0 : o.length;
    for (this.clear(); ++a < l; ) {
      var c = o[a];
      this.set(c[0], c[1]);
    }
  }
  return s.prototype.clear = n, s.prototype.delete = e, s.prototype.get = t, s.prototype.has = r, s.prototype.set = i, L4 = s, L4;
}
var $4, IR;
function YG() {
  if (IR) return $4;
  IR = 1;
  var n = jA(), e = "Expected a function";
  function t(r, i) {
    if (typeof r != "function" || i != null && typeof i != "function")
      throw new TypeError(e);
    var s = function() {
      var o = arguments, a = i ? i.apply(this, o) : o[0], l = s.cache;
      if (l.has(a))
        return l.get(a);
      var c = r.apply(this, o);
      return s.cache = l.set(a, c) || l, c;
    };
    return s.cache = new (t.Cache || n)(), s;
  }
  return t.Cache = n, $4 = t, $4;
}
var F4, RR;
function lpe() {
  if (RR) return F4;
  RR = 1;
  var n = YG(), e = 500;
  function t(r) {
    var i = n(r, function(o) {
      return s.size === e && s.clear(), o;
    }), s = i.cache;
    return i;
  }
  return F4 = t, F4;
}
var B4, PR;
function cpe() {
  if (PR) return B4;
  PR = 1;
  var n = lpe(), e = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, t = /\\(\\)?/g, r = n(function(i) {
    var s = [];
    return i.charCodeAt(0) === 46 && s.push(""), i.replace(e, function(o, a, l, c) {
      s.push(l ? c.replace(t, "$1") : a || o);
    }), s;
  });
  return B4 = r, B4;
}
var z4, DR;
function WA() {
  if (DR) return z4;
  DR = 1;
  function n(e, t) {
    for (var r = -1, i = e == null ? 0 : e.length, s = Array(i); ++r < i; )
      s[r] = t(e[r], r, e);
    return s;
  }
  return z4 = n, z4;
}
var H4, NR;
function upe() {
  if (NR) return H4;
  NR = 1;
  var n = a1(), e = WA(), t = Gi(), r = xh(), i = n ? n.prototype : void 0, s = i ? i.toString : void 0;
  function o(a) {
    if (typeof a == "string")
      return a;
    if (t(a))
      return e(a, o) + "";
    if (r(a))
      return s ? s.call(a) : "";
    var l = a + "";
    return l == "0" && 1 / a == -1 / 0 ? "-0" : l;
  }
  return H4 = o, H4;
}
var U4, LR;
function XG() {
  if (LR) return U4;
  LR = 1;
  var n = upe();
  function e(t) {
    return t == null ? "" : n(t);
  }
  return U4 = e, U4;
}
var V4, $R;
function ZG() {
  if ($R) return V4;
  $R = 1;
  var n = Gi(), e = zA(), t = cpe(), r = XG();
  function i(s, o) {
    return n(s) ? s : e(s, o) ? [s] : t(r(s));
  }
  return V4 = i, V4;
}
var j4, FR;
function Aw() {
  if (FR) return j4;
  FR = 1;
  var n = xh();
  function e(t) {
    if (typeof t == "string" || n(t))
      return t;
    var r = t + "";
    return r == "0" && 1 / t == -1 / 0 ? "-0" : r;
  }
  return j4 = e, j4;
}
var W4, BR;
function GA() {
  if (BR) return W4;
  BR = 1;
  var n = ZG(), e = Aw();
  function t(r, i) {
    i = n(i, r);
    for (var s = 0, o = i.length; r != null && s < o; )
      r = r[e(i[s++])];
    return s && s == o ? r : void 0;
  }
  return W4 = t, W4;
}
var G4, zR;
function QG() {
  if (zR) return G4;
  zR = 1;
  var n = GA();
  function e(t, r, i) {
    var s = t == null ? void 0 : n(t, r);
    return s === void 0 ? i : s;
  }
  return G4 = e, G4;
}
var dpe = QG();
const Ls = /* @__PURE__ */ nn(dpe);
var K4, HR;
function fpe() {
  if (HR) return K4;
  HR = 1;
  function n(e) {
    return e == null;
  }
  return K4 = n, K4;
}
var hpe = fpe();
const Bt = /* @__PURE__ */ nn(hpe);
var q4, UR;
function ppe() {
  if (UR) return q4;
  UR = 1;
  var n = yl(), e = Gi(), t = bl(), r = "[object String]";
  function i(s) {
    return typeof s == "string" || !e(s) && t(s) && n(s) == r;
  }
  return q4 = i, q4;
}
var mpe = ppe();
const Iu = /* @__PURE__ */ nn(mpe);
var gpe = HA();
const Mt = /* @__PURE__ */ nn(gpe);
var vpe = Cc();
const Eh = /* @__PURE__ */ nn(vpe);
var sg = { exports: {} }, Zt = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var VR;
function ype() {
  if (VR) return Zt;
  VR = 1;
  var n = Symbol.for("react.element"), e = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), o = Symbol.for("react.context"), a = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m;
  m = Symbol.for("react.module.reference");
  function g(v) {
    if (typeof v == "object" && v !== null) {
      var y = v.$$typeof;
      switch (y) {
        case n:
          switch (v = v.type, v) {
            case t:
            case i:
            case r:
            case c:
            case u:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case a:
                case o:
                case l:
                case f:
                case d:
                case s:
                  return v;
                default:
                  return y;
              }
          }
        case e:
          return y;
      }
    }
  }
  return Zt.ContextConsumer = o, Zt.ContextProvider = s, Zt.Element = n, Zt.ForwardRef = l, Zt.Fragment = t, Zt.Lazy = f, Zt.Memo = d, Zt.Portal = e, Zt.Profiler = i, Zt.StrictMode = r, Zt.Suspense = c, Zt.SuspenseList = u, Zt.isAsyncMode = function() {
    return !1;
  }, Zt.isConcurrentMode = function() {
    return !1;
  }, Zt.isContextConsumer = function(v) {
    return g(v) === o;
  }, Zt.isContextProvider = function(v) {
    return g(v) === s;
  }, Zt.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === n;
  }, Zt.isForwardRef = function(v) {
    return g(v) === l;
  }, Zt.isFragment = function(v) {
    return g(v) === t;
  }, Zt.isLazy = function(v) {
    return g(v) === f;
  }, Zt.isMemo = function(v) {
    return g(v) === d;
  }, Zt.isPortal = function(v) {
    return g(v) === e;
  }, Zt.isProfiler = function(v) {
    return g(v) === i;
  }, Zt.isStrictMode = function(v) {
    return g(v) === r;
  }, Zt.isSuspense = function(v) {
    return g(v) === c;
  }, Zt.isSuspenseList = function(v) {
    return g(v) === u;
  }, Zt.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === t || v === i || v === r || v === c || v === u || v === h || typeof v == "object" && v !== null && (v.$$typeof === f || v.$$typeof === d || v.$$typeof === s || v.$$typeof === o || v.$$typeof === l || v.$$typeof === m || v.getModuleId !== void 0);
  }, Zt.typeOf = g, Zt;
}
var Qt = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var jR;
function bpe() {
  return jR || (jR = 1, process.env.NODE_ENV !== "production" && (function() {
    var n = Symbol.for("react.element"), e = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), s = Symbol.for("react.provider"), o = Symbol.for("react.context"), a = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), f = Symbol.for("react.lazy"), h = Symbol.for("react.offscreen"), m = !1, g = !1, v = !1, y = !1, b = !1, x;
    x = Symbol.for("react.module.reference");
    function E(ne) {
      return !!(typeof ne == "string" || typeof ne == "function" || ne === t || ne === i || b || ne === r || ne === c || ne === u || y || ne === h || m || g || v || typeof ne == "object" && ne !== null && (ne.$$typeof === f || ne.$$typeof === d || ne.$$typeof === s || ne.$$typeof === o || ne.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      ne.$$typeof === x || ne.getModuleId !== void 0));
    }
    function w(ne) {
      if (typeof ne == "object" && ne !== null) {
        var qe = ne.$$typeof;
        switch (qe) {
          case n:
            var ve = ne.type;
            switch (ve) {
              case t:
              case i:
              case r:
              case c:
              case u:
                return ve;
              default:
                var Ie = ve && ve.$$typeof;
                switch (Ie) {
                  case a:
                  case o:
                  case l:
                  case f:
                  case d:
                  case s:
                    return Ie;
                  default:
                    return qe;
                }
            }
          case e:
            return qe;
        }
      }
    }
    var C = o, S = s, M = n, k = l, _ = t, O = f, I = d, R = e, P = i, D = r, L = c, B = u, $ = !1, z = !1;
    function H(ne) {
      return $ || ($ = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function U(ne) {
      return z || (z = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function F(ne) {
      return w(ne) === o;
    }
    function V(ne) {
      return w(ne) === s;
    }
    function X(ne) {
      return typeof ne == "object" && ne !== null && ne.$$typeof === n;
    }
    function Z(ne) {
      return w(ne) === l;
    }
    function ie(ne) {
      return w(ne) === t;
    }
    function J(ne) {
      return w(ne) === f;
    }
    function se(ne) {
      return w(ne) === d;
    }
    function te(ne) {
      return w(ne) === e;
    }
    function le(ne) {
      return w(ne) === i;
    }
    function de(ne) {
      return w(ne) === r;
    }
    function j(ne) {
      return w(ne) === c;
    }
    function xe(ne) {
      return w(ne) === u;
    }
    Qt.ContextConsumer = C, Qt.ContextProvider = S, Qt.Element = M, Qt.ForwardRef = k, Qt.Fragment = _, Qt.Lazy = O, Qt.Memo = I, Qt.Portal = R, Qt.Profiler = P, Qt.StrictMode = D, Qt.Suspense = L, Qt.SuspenseList = B, Qt.isAsyncMode = H, Qt.isConcurrentMode = U, Qt.isContextConsumer = F, Qt.isContextProvider = V, Qt.isElement = X, Qt.isForwardRef = Z, Qt.isFragment = ie, Qt.isLazy = J, Qt.isMemo = se, Qt.isPortal = te, Qt.isProfiler = le, Qt.isStrictMode = de, Qt.isSuspense = j, Qt.isSuspenseList = xe, Qt.isValidElementType = E, Qt.typeOf = w;
  })()), Qt;
}
var WR;
function wpe() {
  return WR || (WR = 1, process.env.NODE_ENV === "production" ? sg.exports = ype() : sg.exports = bpe()), sg.exports;
}
var xpe = wpe(), Y4, GR;
function JG() {
  if (GR) return Y4;
  GR = 1;
  var n = yl(), e = bl(), t = "[object Number]";
  function r(i) {
    return typeof i == "number" || e(i) && n(i) == t;
  }
  return Y4 = r, Y4;
}
var X4, KR;
function Epe() {
  if (KR) return X4;
  KR = 1;
  var n = JG();
  function e(t) {
    return n(t) && t != +t;
  }
  return X4 = e, X4;
}
var Spe = Epe();
const Sh = /* @__PURE__ */ nn(Spe);
var Cpe = JG();
const Tpe = /* @__PURE__ */ nn(Cpe);
var co = function(e) {
  return e === 0 ? 0 : e > 0 ? 1 : -1;
}, iu = function(e) {
  return Iu(e) && e.indexOf("%") === e.length - 1;
}, ke = function(e) {
  return Tpe(e) && !Sh(e);
}, Ape = function(e) {
  return Bt(e);
}, Sr = function(e) {
  return ke(e) || Iu(e);
}, Mpe = 0, l1 = function(e) {
  var t = ++Mpe;
  return "".concat(e || "").concat(t);
}, Ru = function(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
  if (!ke(e) && !Iu(e))
    return r;
  var s;
  if (iu(e)) {
    var o = e.indexOf("%");
    s = t * parseFloat(e.slice(0, o)) / 100;
  } else
    s = +e;
  return Sh(s) && (s = r), i && s > t && (s = t), s;
}, Wl = function(e) {
  if (!e)
    return null;
  var t = Object.keys(e);
  return t && t.length ? e[t[0]] : null;
}, kpe = function(e) {
  if (!Array.isArray(e))
    return !1;
  for (var t = e.length, r = {}, i = 0; i < t; i++)
    if (!r[e[i]])
      r[e[i]] = !0;
    else
      return !0;
  return !1;
}, _s = function(e, t) {
  return ke(e) && ke(t) ? function(r) {
    return e + r * (t - e);
  } : function() {
    return t;
  };
};
function y2(n, e, t) {
  return !n || !n.length ? null : n.find(function(r) {
    return r && (typeof e == "function" ? e(r) : Ls(r, e)) === t;
  });
}
var _pe = function(e, t) {
  return ke(e) && ke(t) ? e - t : Iu(e) && Iu(t) ? e.localeCompare(t) : e instanceof Date && t instanceof Date ? e.getTime() - t.getTime() : String(e).localeCompare(String(t));
};
function rf(n, e) {
  for (var t in n)
    if ({}.hasOwnProperty.call(n, t) && (!{}.hasOwnProperty.call(e, t) || n[t] !== e[t]))
      return !1;
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r) && !{}.hasOwnProperty.call(n, r))
      return !1;
  return !0;
}
function pC(n) {
  "@babel/helpers - typeof";
  return pC = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, pC(n);
}
var Ope = ["viewBox", "children"], Ipe = [
  "aria-activedescendant",
  "aria-atomic",
  "aria-autocomplete",
  "aria-busy",
  "aria-checked",
  "aria-colcount",
  "aria-colindex",
  "aria-colspan",
  "aria-controls",
  "aria-current",
  "aria-describedby",
  "aria-details",
  "aria-disabled",
  "aria-errormessage",
  "aria-expanded",
  "aria-flowto",
  "aria-haspopup",
  "aria-hidden",
  "aria-invalid",
  "aria-keyshortcuts",
  "aria-label",
  "aria-labelledby",
  "aria-level",
  "aria-live",
  "aria-modal",
  "aria-multiline",
  "aria-multiselectable",
  "aria-orientation",
  "aria-owns",
  "aria-placeholder",
  "aria-posinset",
  "aria-pressed",
  "aria-readonly",
  "aria-relevant",
  "aria-required",
  "aria-roledescription",
  "aria-rowcount",
  "aria-rowindex",
  "aria-rowspan",
  "aria-selected",
  "aria-setsize",
  "aria-sort",
  "aria-valuemax",
  "aria-valuemin",
  "aria-valuenow",
  "aria-valuetext",
  "className",
  "color",
  "height",
  "id",
  "lang",
  "max",
  "media",
  "method",
  "min",
  "name",
  "style",
  /*
   * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
   * that can use it and it conflicts with the recharts prop 'type'
   * https://github.com/recharts/recharts/pull/3327
   * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
   */
  // 'type',
  "target",
  "width",
  "role",
  "tabIndex",
  "accentHeight",
  "accumulate",
  "additive",
  "alignmentBaseline",
  "allowReorder",
  "alphabetic",
  "amplitude",
  "arabicForm",
  "ascent",
  "attributeName",
  "attributeType",
  "autoReverse",
  "azimuth",
  "baseFrequency",
  "baselineShift",
  "baseProfile",
  "bbox",
  "begin",
  "bias",
  "by",
  "calcMode",
  "capHeight",
  "clip",
  "clipPath",
  "clipPathUnits",
  "clipRule",
  "colorInterpolation",
  "colorInterpolationFilters",
  "colorProfile",
  "colorRendering",
  "contentScriptType",
  "contentStyleType",
  "cursor",
  "cx",
  "cy",
  "d",
  "decelerate",
  "descent",
  "diffuseConstant",
  "direction",
  "display",
  "divisor",
  "dominantBaseline",
  "dur",
  "dx",
  "dy",
  "edgeMode",
  "elevation",
  "enableBackground",
  "end",
  "exponent",
  "externalResourcesRequired",
  "fill",
  "fillOpacity",
  "fillRule",
  "filter",
  "filterRes",
  "filterUnits",
  "floodColor",
  "floodOpacity",
  "focusable",
  "fontFamily",
  "fontSize",
  "fontSizeAdjust",
  "fontStretch",
  "fontStyle",
  "fontVariant",
  "fontWeight",
  "format",
  "from",
  "fx",
  "fy",
  "g1",
  "g2",
  "glyphName",
  "glyphOrientationHorizontal",
  "glyphOrientationVertical",
  "glyphRef",
  "gradientTransform",
  "gradientUnits",
  "hanging",
  "horizAdvX",
  "horizOriginX",
  "href",
  "ideographic",
  "imageRendering",
  "in2",
  "in",
  "intercept",
  "k1",
  "k2",
  "k3",
  "k4",
  "k",
  "kernelMatrix",
  "kernelUnitLength",
  "kerning",
  "keyPoints",
  "keySplines",
  "keyTimes",
  "lengthAdjust",
  "letterSpacing",
  "lightingColor",
  "limitingConeAngle",
  "local",
  "markerEnd",
  "markerHeight",
  "markerMid",
  "markerStart",
  "markerUnits",
  "markerWidth",
  "mask",
  "maskContentUnits",
  "maskUnits",
  "mathematical",
  "mode",
  "numOctaves",
  "offset",
  "opacity",
  "operator",
  "order",
  "orient",
  "orientation",
  "origin",
  "overflow",
  "overlinePosition",
  "overlineThickness",
  "paintOrder",
  "panose1",
  "pathLength",
  "patternContentUnits",
  "patternTransform",
  "patternUnits",
  "pointerEvents",
  "pointsAtX",
  "pointsAtY",
  "pointsAtZ",
  "preserveAlpha",
  "preserveAspectRatio",
  "primitiveUnits",
  "r",
  "radius",
  "refX",
  "refY",
  "renderingIntent",
  "repeatCount",
  "repeatDur",
  "requiredExtensions",
  "requiredFeatures",
  "restart",
  "result",
  "rotate",
  "rx",
  "ry",
  "seed",
  "shapeRendering",
  "slope",
  "spacing",
  "specularConstant",
  "specularExponent",
  "speed",
  "spreadMethod",
  "startOffset",
  "stdDeviation",
  "stemh",
  "stemv",
  "stitchTiles",
  "stopColor",
  "stopOpacity",
  "strikethroughPosition",
  "strikethroughThickness",
  "string",
  "stroke",
  "strokeDasharray",
  "strokeDashoffset",
  "strokeLinecap",
  "strokeLinejoin",
  "strokeMiterlimit",
  "strokeOpacity",
  "strokeWidth",
  "surfaceScale",
  "systemLanguage",
  "tableValues",
  "targetX",
  "targetY",
  "textAnchor",
  "textDecoration",
  "textLength",
  "textRendering",
  "to",
  "transform",
  "u1",
  "u2",
  "underlinePosition",
  "underlineThickness",
  "unicode",
  "unicodeBidi",
  "unicodeRange",
  "unitsPerEm",
  "vAlphabetic",
  "values",
  "vectorEffect",
  "version",
  "vertAdvY",
  "vertOriginX",
  "vertOriginY",
  "vHanging",
  "vIdeographic",
  "viewTarget",
  "visibility",
  "vMathematical",
  "widths",
  "wordSpacing",
  "writingMode",
  "x1",
  "x2",
  "x",
  "xChannelSelector",
  "xHeight",
  "xlinkActuate",
  "xlinkArcrole",
  "xlinkHref",
  "xlinkRole",
  "xlinkShow",
  "xlinkTitle",
  "xlinkType",
  "xmlBase",
  "xmlLang",
  "xmlns",
  "xmlnsXlink",
  "xmlSpace",
  "y1",
  "y2",
  "y",
  "yChannelSelector",
  "z",
  "zoomAndPan",
  "ref",
  "key",
  "angle"
], qR = ["points", "pathLength"], Z4 = {
  svg: Ope,
  polygon: qR,
  polyline: qR
}, KA = ["dangerouslySetInnerHTML", "onCopy", "onCopyCapture", "onCut", "onCutCapture", "onPaste", "onPasteCapture", "onCompositionEnd", "onCompositionEndCapture", "onCompositionStart", "onCompositionStartCapture", "onCompositionUpdate", "onCompositionUpdateCapture", "onFocus", "onFocusCapture", "onBlur", "onBlurCapture", "onChange", "onChangeCapture", "onBeforeInput", "onBeforeInputCapture", "onInput", "onInputCapture", "onReset", "onResetCapture", "onSubmit", "onSubmitCapture", "onInvalid", "onInvalidCapture", "onLoad", "onLoadCapture", "onError", "onErrorCapture", "onKeyDown", "onKeyDownCapture", "onKeyPress", "onKeyPressCapture", "onKeyUp", "onKeyUpCapture", "onAbort", "onAbortCapture", "onCanPlay", "onCanPlayCapture", "onCanPlayThrough", "onCanPlayThroughCapture", "onDurationChange", "onDurationChangeCapture", "onEmptied", "onEmptiedCapture", "onEncrypted", "onEncryptedCapture", "onEnded", "onEndedCapture", "onLoadedData", "onLoadedDataCapture", "onLoadedMetadata", "onLoadedMetadataCapture", "onLoadStart", "onLoadStartCapture", "onPause", "onPauseCapture", "onPlay", "onPlayCapture", "onPlaying", "onPlayingCapture", "onProgress", "onProgressCapture", "onRateChange", "onRateChangeCapture", "onSeeked", "onSeekedCapture", "onSeeking", "onSeekingCapture", "onStalled", "onStalledCapture", "onSuspend", "onSuspendCapture", "onTimeUpdate", "onTimeUpdateCapture", "onVolumeChange", "onVolumeChangeCapture", "onWaiting", "onWaitingCapture", "onAuxClick", "onAuxClickCapture", "onClick", "onClickCapture", "onContextMenu", "onContextMenuCapture", "onDoubleClick", "onDoubleClickCapture", "onDrag", "onDragCapture", "onDragEnd", "onDragEndCapture", "onDragEnter", "onDragEnterCapture", "onDragExit", "onDragExitCapture", "onDragLeave", "onDragLeaveCapture", "onDragOver", "onDragOverCapture", "onDragStart", "onDragStartCapture", "onDrop", "onDropCapture", "onMouseDown", "onMouseDownCapture", "onMouseEnter", "onMouseLeave", "onMouseMove", "onMouseMoveCapture", "onMouseOut", "onMouseOutCapture", "onMouseOver", "onMouseOverCapture", "onMouseUp", "onMouseUpCapture", "onSelect", "onSelectCapture", "onTouchCancel", "onTouchCancelCapture", "onTouchEnd", "onTouchEndCapture", "onTouchMove", "onTouchMoveCapture", "onTouchStart", "onTouchStartCapture", "onPointerDown", "onPointerDownCapture", "onPointerMove", "onPointerMoveCapture", "onPointerUp", "onPointerUpCapture", "onPointerCancel", "onPointerCancelCapture", "onPointerEnter", "onPointerEnterCapture", "onPointerLeave", "onPointerLeaveCapture", "onPointerOver", "onPointerOverCapture", "onPointerOut", "onPointerOutCapture", "onGotPointerCapture", "onGotPointerCaptureCapture", "onLostPointerCapture", "onLostPointerCaptureCapture", "onScroll", "onScrollCapture", "onWheel", "onWheelCapture", "onAnimationStart", "onAnimationStartCapture", "onAnimationEnd", "onAnimationEndCapture", "onAnimationIteration", "onAnimationIterationCapture", "onTransitionEnd", "onTransitionEndCapture"], b2 = function(e, t) {
  if (!e || typeof e == "function" || typeof e == "boolean")
    return null;
  var r = e;
  if (/* @__PURE__ */ ca(e) && (r = e.props), !Eh(r))
    return null;
  var i = {};
  return Object.keys(r).forEach(function(s) {
    KA.includes(s) && (i[s] = t || function(o) {
      return r[s](r, o);
    });
  }), i;
}, Rpe = function(e, t, r) {
  return function(i) {
    return e(t, r, i), null;
  };
}, w2 = function(e, t, r) {
  if (!Eh(e) || pC(e) !== "object")
    return null;
  var i = null;
  return Object.keys(e).forEach(function(s) {
    var o = e[s];
    KA.includes(s) && typeof o == "function" && (i || (i = {}), i[s] = Rpe(o, t, r));
  }), i;
}, Ppe = ["children"], Dpe = ["children"];
function YR(n, e) {
  if (n == null) return {};
  var t = Npe(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function Npe(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n)
    if (Object.prototype.hasOwnProperty.call(n, r)) {
      if (e.indexOf(r) >= 0) continue;
      t[r] = n[r];
    }
  return t;
}
function mC(n) {
  "@babel/helpers - typeof";
  return mC = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, mC(n);
}
var XR = {
  click: "onClick",
  mousedown: "onMouseDown",
  mouseup: "onMouseUp",
  mouseover: "onMouseOver",
  mousemove: "onMouseMove",
  mouseout: "onMouseOut",
  mouseenter: "onMouseEnter",
  mouseleave: "onMouseLeave",
  touchcancel: "onTouchCancel",
  touchend: "onTouchEnd",
  touchmove: "onTouchMove",
  touchstart: "onTouchStart",
  contextmenu: "onContextMenu",
  dblclick: "onDoubleClick"
}, nl = function(e) {
  return typeof e == "string" ? e : e ? e.displayName || e.name || "Component" : "";
}, ZR = null, Q4 = null, qA = function n(e) {
  if (e === ZR && Array.isArray(Q4))
    return Q4;
  var t = [];
  return vu.forEach(e, function(r) {
    Bt(r) || (xpe.isFragment(r) ? t = t.concat(n(r.props.children)) : t.push(r));
  }), Q4 = t, ZR = e, t;
};
function go(n, e) {
  var t = [], r = [];
  return Array.isArray(e) ? r = e.map(function(i) {
    return nl(i);
  }) : r = [nl(e)], qA(n).forEach(function(i) {
    var s = Ls(i, "type.displayName") || Ls(i, "type.name");
    r.indexOf(s) !== -1 && t.push(i);
  }), t;
}
function ss(n, e) {
  var t = go(n, e);
  return t && t[0];
}
var QR = function(e) {
  if (!e || !e.props)
    return !1;
  var t = e.props, r = t.width, i = t.height;
  return !(!ke(r) || r <= 0 || !ke(i) || i <= 0);
}, Lpe = ["a", "altGlyph", "altGlyphDef", "altGlyphItem", "animate", "animateColor", "animateMotion", "animateTransform", "circle", "clipPath", "color-profile", "cursor", "defs", "desc", "ellipse", "feBlend", "feColormatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence", "filter", "font", "font-face", "font-face-format", "font-face-name", "font-face-url", "foreignObject", "g", "glyph", "glyphRef", "hkern", "image", "line", "lineGradient", "marker", "mask", "metadata", "missing-glyph", "mpath", "path", "pattern", "polygon", "polyline", "radialGradient", "rect", "script", "set", "stop", "style", "svg", "switch", "symbol", "text", "textPath", "title", "tref", "tspan", "use", "view", "vkern"], $pe = function(e) {
  return e && e.type && Iu(e.type) && Lpe.indexOf(e.type) >= 0;
}, Fpe = function(e) {
  return e && mC(e) === "object" && "clipDot" in e;
}, Bpe = function(e, t, r, i) {
  var s, o = (s = Z4?.[i]) !== null && s !== void 0 ? s : [];
  return t.startsWith("data-") || !Mt(e) && (i && o.includes(t) || Ipe.includes(t)) || r && KA.includes(t);
}, $t = function(e, t, r) {
  if (!e || typeof e == "function" || typeof e == "boolean")
    return null;
  var i = e;
  if (/* @__PURE__ */ ca(e) && (i = e.props), !Eh(i))
    return null;
  var s = {};
  return Object.keys(i).forEach(function(o) {
    var a;
    Bpe((a = i) === null || a === void 0 ? void 0 : a[o], o, t, r) && (s[o] = i[o]);
  }), s;
}, gC = function n(e, t) {
  if (e === t)
    return !0;
  var r = vu.count(e);
  if (r !== vu.count(t))
    return !1;
  if (r === 0)
    return !0;
  if (r === 1)
    return JR(Array.isArray(e) ? e[0] : e, Array.isArray(t) ? t[0] : t);
  for (var i = 0; i < r; i++) {
    var s = e[i], o = t[i];
    if (Array.isArray(s) || Array.isArray(o)) {
      if (!n(s, o))
        return !1;
    } else if (!JR(s, o))
      return !1;
  }
  return !0;
}, JR = function(e, t) {
  if (Bt(e) && Bt(t))
    return !0;
  if (!Bt(e) && !Bt(t)) {
    var r = e.props || {}, i = r.children, s = YR(r, Ppe), o = t.props || {}, a = o.children, l = YR(o, Dpe);
    return i && a ? rf(s, l) && gC(i, a) : !i && !a ? rf(s, l) : !1;
  }
  return !1;
}, eP = function(e, t) {
  var r = [], i = {};
  return qA(e).forEach(function(s, o) {
    if ($pe(s))
      r.push(s);
    else if (s) {
      var a = nl(s.type), l = t[a] || {}, c = l.handler, u = l.once;
      if (c && (!u || !i[a])) {
        var d = c(s, a, o);
        r.push(d), i[a] = !0;
      }
    }
  }), r;
}, zpe = function(e) {
  var t = e && e.type;
  return t && XR[t] ? XR[t] : null;
}, Hpe = function(e, t) {
  return qA(t).indexOf(e);
}, Upe = ["children", "width", "height", "viewBox", "className", "style", "title", "desc"];
function vC() {
  return vC = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, vC.apply(this, arguments);
}
function Vpe(n, e) {
  if (n == null) return {};
  var t = jpe(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function jpe(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n)
    if (Object.prototype.hasOwnProperty.call(n, r)) {
      if (e.indexOf(r) >= 0) continue;
      t[r] = n[r];
    }
  return t;
}
function yC(n) {
  var e = n.children, t = n.width, r = n.height, i = n.viewBox, s = n.className, o = n.style, a = n.title, l = n.desc, c = Vpe(n, Upe), u = i || {
    width: t,
    height: r,
    x: 0,
    y: 0
  }, d = Ut("recharts-surface", s);
  return /* @__PURE__ */ p.createElement("svg", vC({}, $t(c, !0, "svg"), {
    className: d,
    width: t,
    height: r,
    style: o,
    viewBox: "".concat(u.x, " ").concat(u.y, " ").concat(u.width, " ").concat(u.height)
  }), /* @__PURE__ */ p.createElement("title", null, a), /* @__PURE__ */ p.createElement("desc", null, l), e);
}
var Wpe = ["children", "className"];
function bC() {
  return bC = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, bC.apply(this, arguments);
}
function Gpe(n, e) {
  if (n == null) return {};
  var t = Kpe(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function Kpe(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n)
    if (Object.prototype.hasOwnProperty.call(n, r)) {
      if (e.indexOf(r) >= 0) continue;
      t[r] = n[r];
    }
  return t;
}
var jn = /* @__PURE__ */ p.forwardRef(function(n, e) {
  var t = n.children, r = n.className, i = Gpe(n, Wpe), s = Ut("recharts-layer", r);
  return /* @__PURE__ */ p.createElement("g", bC({
    className: s
  }, $t(i, !0), {
    ref: e
  }), t);
}), qpe = process.env.NODE_ENV !== "production", rl = function(e, t) {
  for (var r = arguments.length, i = new Array(r > 2 ? r - 2 : 0), s = 2; s < r; s++)
    i[s - 2] = arguments[s];
  if (qpe && typeof console < "u" && console.warn && (t === void 0 && console.warn("LogUtils requires an error message argument"), !e))
    if (t === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var o = 0;
      console.warn(t.replace(/%s/g, function() {
        return i[o++];
      }));
    }
}, J4, tP;
function Ype() {
  if (tP) return J4;
  tP = 1;
  function n(e, t, r) {
    var i = -1, s = e.length;
    t < 0 && (t = -t > s ? 0 : s + t), r = r > s ? s : r, r < 0 && (r += s), s = t > r ? 0 : r - t >>> 0, t >>>= 0;
    for (var o = Array(s); ++i < s; )
      o[i] = e[i + t];
    return o;
  }
  return J4 = n, J4;
}
var eE, nP;
function Xpe() {
  if (nP) return eE;
  nP = 1;
  var n = Ype();
  function e(t, r, i) {
    var s = t.length;
    return i = i === void 0 ? s : i, !r && i >= s ? t : n(t, r, i);
  }
  return eE = e, eE;
}
var tE, rP;
function eK() {
  if (rP) return tE;
  rP = 1;
  var n = "\\ud800-\\udfff", e = "\\u0300-\\u036f", t = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", i = e + t + r, s = "\\ufe0e\\ufe0f", o = "\\u200d", a = RegExp("[" + o + n + i + s + "]");
  function l(c) {
    return a.test(c);
  }
  return tE = l, tE;
}
var nE, iP;
function Zpe() {
  if (iP) return nE;
  iP = 1;
  function n(e) {
    return e.split("");
  }
  return nE = n, nE;
}
var rE, sP;
function Qpe() {
  if (sP) return rE;
  sP = 1;
  var n = "\\ud800-\\udfff", e = "\\u0300-\\u036f", t = "\\ufe20-\\ufe2f", r = "\\u20d0-\\u20ff", i = e + t + r, s = "\\ufe0e\\ufe0f", o = "[" + n + "]", a = "[" + i + "]", l = "\\ud83c[\\udffb-\\udfff]", c = "(?:" + a + "|" + l + ")", u = "[^" + n + "]", d = "(?:\\ud83c[\\udde6-\\uddff]){2}", f = "[\\ud800-\\udbff][\\udc00-\\udfff]", h = "\\u200d", m = c + "?", g = "[" + s + "]?", v = "(?:" + h + "(?:" + [u, d, f].join("|") + ")" + g + m + ")*", y = g + m + v, b = "(?:" + [u + a + "?", a, d, f, o].join("|") + ")", x = RegExp(l + "(?=" + l + ")|" + b + y, "g");
  function E(w) {
    return w.match(x) || [];
  }
  return rE = E, rE;
}
var iE, oP;
function Jpe() {
  if (oP) return iE;
  oP = 1;
  var n = Zpe(), e = eK(), t = Qpe();
  function r(i) {
    return e(i) ? t(i) : n(i);
  }
  return iE = r, iE;
}
var sE, aP;
function eme() {
  if (aP) return sE;
  aP = 1;
  var n = Xpe(), e = eK(), t = Jpe(), r = XG();
  function i(s) {
    return function(o) {
      o = r(o);
      var a = e(o) ? t(o) : void 0, l = a ? a[0] : o.charAt(0), c = a ? n(a, 1).join("") : o.slice(1);
      return l[s]() + c;
    };
  }
  return sE = i, sE;
}
var oE, lP;
function tme() {
  if (lP) return oE;
  lP = 1;
  var n = eme(), e = n("toUpperCase");
  return oE = e, oE;
}
var nme = tme();
const Mw = /* @__PURE__ */ nn(nme);
function Mn(n) {
  return function() {
    return n;
  };
}
const tK = Math.cos, x2 = Math.sin, ko = Math.sqrt, E2 = Math.PI, kw = 2 * E2, wC = Math.PI, xC = 2 * wC, qc = 1e-6, rme = xC - qc;
function nK(n) {
  this._ += n[0];
  for (let e = 1, t = n.length; e < t; ++e)
    this._ += arguments[e] + n[e];
}
function ime(n) {
  let e = Math.floor(n);
  if (!(e >= 0)) throw new Error(`invalid digits: ${n}`);
  if (e > 15) return nK;
  const t = 10 ** e;
  return function(r) {
    this._ += r[0];
    for (let i = 1, s = r.length; i < s; ++i)
      this._ += Math.round(arguments[i] * t) / t + r[i];
  };
}
class sme {
  constructor(e) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null, this._ = "", this._append = e == null ? nK : ime(e);
  }
  moveTo(e, t) {
    this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +t}`;
  }
  closePath() {
    this._x1 !== null && (this._x1 = this._x0, this._y1 = this._y0, this._append`Z`);
  }
  lineTo(e, t) {
    this._append`L${this._x1 = +e},${this._y1 = +t}`;
  }
  quadraticCurveTo(e, t, r, i) {
    this._append`Q${+e},${+t},${this._x1 = +r},${this._y1 = +i}`;
  }
  bezierCurveTo(e, t, r, i, s, o) {
    this._append`C${+e},${+t},${+r},${+i},${this._x1 = +s},${this._y1 = +o}`;
  }
  arcTo(e, t, r, i, s) {
    if (e = +e, t = +t, r = +r, i = +i, s = +s, s < 0) throw new Error(`negative radius: ${s}`);
    let o = this._x1, a = this._y1, l = r - e, c = i - t, u = o - e, d = a - t, f = u * u + d * d;
    if (this._x1 === null)
      this._append`M${this._x1 = e},${this._y1 = t}`;
    else if (f > qc) if (!(Math.abs(d * l - c * u) > qc) || !s)
      this._append`L${this._x1 = e},${this._y1 = t}`;
    else {
      let h = r - o, m = i - a, g = l * l + c * c, v = h * h + m * m, y = Math.sqrt(g), b = Math.sqrt(f), x = s * Math.tan((wC - Math.acos((g + f - v) / (2 * y * b))) / 2), E = x / b, w = x / y;
      Math.abs(E - 1) > qc && this._append`L${e + E * u},${t + E * d}`, this._append`A${s},${s},0,0,${+(d * h > u * m)},${this._x1 = e + w * l},${this._y1 = t + w * c}`;
    }
  }
  arc(e, t, r, i, s, o) {
    if (e = +e, t = +t, r = +r, o = !!o, r < 0) throw new Error(`negative radius: ${r}`);
    let a = r * Math.cos(i), l = r * Math.sin(i), c = e + a, u = t + l, d = 1 ^ o, f = o ? i - s : s - i;
    this._x1 === null ? this._append`M${c},${u}` : (Math.abs(this._x1 - c) > qc || Math.abs(this._y1 - u) > qc) && this._append`L${c},${u}`, r && (f < 0 && (f = f % xC + xC), f > rme ? this._append`A${r},${r},0,1,${d},${e - a},${t - l}A${r},${r},0,1,${d},${this._x1 = c},${this._y1 = u}` : f > qc && this._append`A${r},${r},0,${+(f >= wC)},${d},${this._x1 = e + r * Math.cos(s)},${this._y1 = t + r * Math.sin(s)}`);
  }
  rect(e, t, r, i) {
    this._append`M${this._x0 = this._x1 = +e},${this._y0 = this._y1 = +t}h${r = +r}v${+i}h${-r}Z`;
  }
  toString() {
    return this._;
  }
}
function YA(n) {
  let e = 3;
  return n.digits = function(t) {
    if (!arguments.length) return e;
    if (t == null)
      e = null;
    else {
      const r = Math.floor(t);
      if (!(r >= 0)) throw new RangeError(`invalid digits: ${t}`);
      e = r;
    }
    return n;
  }, () => new sme(e);
}
function XA(n) {
  return typeof n == "object" && "length" in n ? n : Array.from(n);
}
function rK(n) {
  this._context = n;
}
rK.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, e) {
    switch (n = +n, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(n, e) : this._context.moveTo(n, e);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(n, e);
        break;
    }
  }
};
function _w(n) {
  return new rK(n);
}
function iK(n) {
  return n[0];
}
function sK(n) {
  return n[1];
}
function oK(n, e) {
  var t = Mn(!0), r = null, i = _w, s = null, o = YA(a);
  n = typeof n == "function" ? n : n === void 0 ? iK : Mn(n), e = typeof e == "function" ? e : e === void 0 ? sK : Mn(e);
  function a(l) {
    var c, u = (l = XA(l)).length, d, f = !1, h;
    for (r == null && (s = i(h = o())), c = 0; c <= u; ++c)
      !(c < u && t(d = l[c], c, l)) === f && ((f = !f) ? s.lineStart() : s.lineEnd()), f && s.point(+n(d, c, l), +e(d, c, l));
    if (h) return s = null, h + "" || null;
  }
  return a.x = function(l) {
    return arguments.length ? (n = typeof l == "function" ? l : Mn(+l), a) : n;
  }, a.y = function(l) {
    return arguments.length ? (e = typeof l == "function" ? l : Mn(+l), a) : e;
  }, a.defined = function(l) {
    return arguments.length ? (t = typeof l == "function" ? l : Mn(!!l), a) : t;
  }, a.curve = function(l) {
    return arguments.length ? (i = l, r != null && (s = i(r)), a) : i;
  }, a.context = function(l) {
    return arguments.length ? (l == null ? r = s = null : s = i(r = l), a) : r;
  }, a;
}
function og(n, e, t) {
  var r = null, i = Mn(!0), s = null, o = _w, a = null, l = YA(c);
  n = typeof n == "function" ? n : n === void 0 ? iK : Mn(+n), e = typeof e == "function" ? e : Mn(e === void 0 ? 0 : +e), t = typeof t == "function" ? t : t === void 0 ? sK : Mn(+t);
  function c(d) {
    var f, h, m, g = (d = XA(d)).length, v, y = !1, b, x = new Array(g), E = new Array(g);
    for (s == null && (a = o(b = l())), f = 0; f <= g; ++f) {
      if (!(f < g && i(v = d[f], f, d)) === y)
        if (y = !y)
          h = f, a.areaStart(), a.lineStart();
        else {
          for (a.lineEnd(), a.lineStart(), m = f - 1; m >= h; --m)
            a.point(x[m], E[m]);
          a.lineEnd(), a.areaEnd();
        }
      y && (x[f] = +n(v, f, d), E[f] = +e(v, f, d), a.point(r ? +r(v, f, d) : x[f], t ? +t(v, f, d) : E[f]));
    }
    if (b) return a = null, b + "" || null;
  }
  function u() {
    return oK().defined(i).curve(o).context(s);
  }
  return c.x = function(d) {
    return arguments.length ? (n = typeof d == "function" ? d : Mn(+d), r = null, c) : n;
  }, c.x0 = function(d) {
    return arguments.length ? (n = typeof d == "function" ? d : Mn(+d), c) : n;
  }, c.x1 = function(d) {
    return arguments.length ? (r = d == null ? null : typeof d == "function" ? d : Mn(+d), c) : r;
  }, c.y = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : Mn(+d), t = null, c) : e;
  }, c.y0 = function(d) {
    return arguments.length ? (e = typeof d == "function" ? d : Mn(+d), c) : e;
  }, c.y1 = function(d) {
    return arguments.length ? (t = d == null ? null : typeof d == "function" ? d : Mn(+d), c) : t;
  }, c.lineX0 = c.lineY0 = function() {
    return u().x(n).y(e);
  }, c.lineY1 = function() {
    return u().x(n).y(t);
  }, c.lineX1 = function() {
    return u().x(r).y(e);
  }, c.defined = function(d) {
    return arguments.length ? (i = typeof d == "function" ? d : Mn(!!d), c) : i;
  }, c.curve = function(d) {
    return arguments.length ? (o = d, s != null && (a = o(s)), c) : o;
  }, c.context = function(d) {
    return arguments.length ? (d == null ? s = a = null : a = o(s = d), c) : s;
  }, c;
}
class aK {
  constructor(e, t) {
    this._context = e, this._x = t;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._point = 0;
  }
  lineEnd() {
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  }
  point(e, t) {
    switch (e = +e, t = +t, this._point) {
      case 0: {
        this._point = 1, this._line ? this._context.lineTo(e, t) : this._context.moveTo(e, t);
        break;
      }
      case 1:
        this._point = 2;
      // falls through
      default: {
        this._x ? this._context.bezierCurveTo(this._x0 = (this._x0 + e) / 2, this._y0, this._x0, t, e, t) : this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + t) / 2, e, this._y0, e, t);
        break;
      }
    }
    this._x0 = e, this._y0 = t;
  }
}
function ome(n) {
  return new aK(n, !0);
}
function ame(n) {
  return new aK(n, !1);
}
const ZA = {
  draw(n, e) {
    const t = ko(e / E2);
    n.moveTo(t, 0), n.arc(0, 0, t, 0, kw);
  }
}, lme = {
  draw(n, e) {
    const t = ko(e / 5) / 2;
    n.moveTo(-3 * t, -t), n.lineTo(-t, -t), n.lineTo(-t, -3 * t), n.lineTo(t, -3 * t), n.lineTo(t, -t), n.lineTo(3 * t, -t), n.lineTo(3 * t, t), n.lineTo(t, t), n.lineTo(t, 3 * t), n.lineTo(-t, 3 * t), n.lineTo(-t, t), n.lineTo(-3 * t, t), n.closePath();
  }
}, lK = ko(1 / 3), cme = lK * 2, ume = {
  draw(n, e) {
    const t = ko(e / cme), r = t * lK;
    n.moveTo(0, -t), n.lineTo(r, 0), n.lineTo(0, t), n.lineTo(-r, 0), n.closePath();
  }
}, dme = {
  draw(n, e) {
    const t = ko(e), r = -t / 2;
    n.rect(r, r, t, t);
  }
}, fme = 0.8908130915292852, cK = x2(E2 / 10) / x2(7 * E2 / 10), hme = x2(kw / 10) * cK, pme = -tK(kw / 10) * cK, mme = {
  draw(n, e) {
    const t = ko(e * fme), r = hme * t, i = pme * t;
    n.moveTo(0, -t), n.lineTo(r, i);
    for (let s = 1; s < 5; ++s) {
      const o = kw * s / 5, a = tK(o), l = x2(o);
      n.lineTo(l * t, -a * t), n.lineTo(a * r - l * i, l * r + a * i);
    }
    n.closePath();
  }
}, aE = ko(3), gme = {
  draw(n, e) {
    const t = -ko(e / (aE * 3));
    n.moveTo(0, t * 2), n.lineTo(-aE * t, -t), n.lineTo(aE * t, -t), n.closePath();
  }
}, Es = -0.5, Ss = ko(3) / 2, EC = 1 / ko(12), vme = (EC / 2 + 1) * 3, yme = {
  draw(n, e) {
    const t = ko(e / vme), r = t / 2, i = t * EC, s = r, o = t * EC + t, a = -s, l = o;
    n.moveTo(r, i), n.lineTo(s, o), n.lineTo(a, l), n.lineTo(Es * r - Ss * i, Ss * r + Es * i), n.lineTo(Es * s - Ss * o, Ss * s + Es * o), n.lineTo(Es * a - Ss * l, Ss * a + Es * l), n.lineTo(Es * r + Ss * i, Es * i - Ss * r), n.lineTo(Es * s + Ss * o, Es * o - Ss * s), n.lineTo(Es * a + Ss * l, Es * l - Ss * a), n.closePath();
  }
};
function bme(n, e) {
  let t = null, r = YA(i);
  n = typeof n == "function" ? n : Mn(n || ZA), e = typeof e == "function" ? e : Mn(e === void 0 ? 64 : +e);
  function i() {
    let s;
    if (t || (t = s = r()), n.apply(this, arguments).draw(t, +e.apply(this, arguments)), s) return t = null, s + "" || null;
  }
  return i.type = function(s) {
    return arguments.length ? (n = typeof s == "function" ? s : Mn(s), i) : n;
  }, i.size = function(s) {
    return arguments.length ? (e = typeof s == "function" ? s : Mn(+s), i) : e;
  }, i.context = function(s) {
    return arguments.length ? (t = s ?? null, i) : t;
  }, i;
}
function S2() {
}
function C2(n, e, t) {
  n._context.bezierCurveTo(
    (2 * n._x0 + n._x1) / 3,
    (2 * n._y0 + n._y1) / 3,
    (n._x0 + 2 * n._x1) / 3,
    (n._y0 + 2 * n._y1) / 3,
    (n._x0 + 4 * n._x1 + e) / 6,
    (n._y0 + 4 * n._y1 + t) / 6
  );
}
function uK(n) {
  this._context = n;
}
uK.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 3:
        C2(this, this._x1, this._y1);
      // falls through
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, e) {
    switch (n = +n, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(n, e) : this._context.moveTo(n, e);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3, this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
      // falls through
      default:
        C2(this, n, e);
        break;
    }
    this._x0 = this._x1, this._x1 = n, this._y0 = this._y1, this._y1 = e;
  }
};
function wme(n) {
  return new uK(n);
}
function dK(n) {
  this._context = n;
}
dK.prototype = {
  areaStart: S2,
  areaEnd: S2,
  lineStart: function() {
    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 1: {
        this._context.moveTo(this._x2, this._y2), this._context.closePath();
        break;
      }
      case 2: {
        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3), this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3), this._context.closePath();
        break;
      }
      case 3: {
        this.point(this._x2, this._y2), this.point(this._x3, this._y3), this.point(this._x4, this._y4);
        break;
      }
    }
  },
  point: function(n, e) {
    switch (n = +n, e = +e, this._point) {
      case 0:
        this._point = 1, this._x2 = n, this._y2 = e;
        break;
      case 1:
        this._point = 2, this._x3 = n, this._y3 = e;
        break;
      case 2:
        this._point = 3, this._x4 = n, this._y4 = e, this._context.moveTo((this._x0 + 4 * this._x1 + n) / 6, (this._y0 + 4 * this._y1 + e) / 6);
        break;
      default:
        C2(this, n, e);
        break;
    }
    this._x0 = this._x1, this._x1 = n, this._y0 = this._y1, this._y1 = e;
  }
};
function xme(n) {
  return new dK(n);
}
function fK(n) {
  this._context = n;
}
fK.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = NaN, this._point = 0;
  },
  lineEnd: function() {
    (this._line || this._line !== 0 && this._point === 3) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, e) {
    switch (n = +n, e = +e, this._point) {
      case 0:
        this._point = 1;
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        var t = (this._x0 + 4 * this._x1 + n) / 6, r = (this._y0 + 4 * this._y1 + e) / 6;
        this._line ? this._context.lineTo(t, r) : this._context.moveTo(t, r);
        break;
      case 3:
        this._point = 4;
      // falls through
      default:
        C2(this, n, e);
        break;
    }
    this._x0 = this._x1, this._x1 = n, this._y0 = this._y1, this._y1 = e;
  }
};
function Eme(n) {
  return new fK(n);
}
function hK(n) {
  this._context = n;
}
hK.prototype = {
  areaStart: S2,
  areaEnd: S2,
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._point && this._context.closePath();
  },
  point: function(n, e) {
    n = +n, e = +e, this._point ? this._context.lineTo(n, e) : (this._point = 1, this._context.moveTo(n, e));
  }
};
function Sme(n) {
  return new hK(n);
}
function cP(n) {
  return n < 0 ? -1 : 1;
}
function uP(n, e, t) {
  var r = n._x1 - n._x0, i = e - n._x1, s = (n._y1 - n._y0) / (r || i < 0 && -0), o = (t - n._y1) / (i || r < 0 && -0), a = (s * i + o * r) / (r + i);
  return (cP(s) + cP(o)) * Math.min(Math.abs(s), Math.abs(o), 0.5 * Math.abs(a)) || 0;
}
function dP(n, e) {
  var t = n._x1 - n._x0;
  return t ? (3 * (n._y1 - n._y0) / t - e) / 2 : e;
}
function lE(n, e, t) {
  var r = n._x0, i = n._y0, s = n._x1, o = n._y1, a = (s - r) / 3;
  n._context.bezierCurveTo(r + a, i + a * e, s - a, o - a * t, s, o);
}
function T2(n) {
  this._context = n;
}
T2.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN, this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        lE(this, this._t0, dP(this, this._t0));
        break;
    }
    (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line = 1 - this._line;
  },
  point: function(n, e) {
    var t = NaN;
    if (n = +n, e = +e, !(n === this._x1 && e === this._y1)) {
      switch (this._point) {
        case 0:
          this._point = 1, this._line ? this._context.lineTo(n, e) : this._context.moveTo(n, e);
          break;
        case 1:
          this._point = 2;
          break;
        case 2:
          this._point = 3, lE(this, dP(this, t = uP(this, n, e)), t);
          break;
        default:
          lE(this, this._t0, t = uP(this, n, e));
          break;
      }
      this._x0 = this._x1, this._x1 = n, this._y0 = this._y1, this._y1 = e, this._t0 = t;
    }
  }
};
function pK(n) {
  this._context = new mK(n);
}
(pK.prototype = Object.create(T2.prototype)).point = function(n, e) {
  T2.prototype.point.call(this, e, n);
};
function mK(n) {
  this._context = n;
}
mK.prototype = {
  moveTo: function(n, e) {
    this._context.moveTo(e, n);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(n, e) {
    this._context.lineTo(e, n);
  },
  bezierCurveTo: function(n, e, t, r, i, s) {
    this._context.bezierCurveTo(e, n, r, t, s, i);
  }
};
function Cme(n) {
  return new T2(n);
}
function Tme(n) {
  return new pK(n);
}
function gK(n) {
  this._context = n;
}
gK.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [], this._y = [];
  },
  lineEnd: function() {
    var n = this._x, e = this._y, t = n.length;
    if (t)
      if (this._line ? this._context.lineTo(n[0], e[0]) : this._context.moveTo(n[0], e[0]), t === 2)
        this._context.lineTo(n[1], e[1]);
      else
        for (var r = fP(n), i = fP(e), s = 0, o = 1; o < t; ++s, ++o)
          this._context.bezierCurveTo(r[0][s], i[0][s], r[1][s], i[1][s], n[o], e[o]);
    (this._line || this._line !== 0 && t === 1) && this._context.closePath(), this._line = 1 - this._line, this._x = this._y = null;
  },
  point: function(n, e) {
    this._x.push(+n), this._y.push(+e);
  }
};
function fP(n) {
  var e, t = n.length - 1, r, i = new Array(t), s = new Array(t), o = new Array(t);
  for (i[0] = 0, s[0] = 2, o[0] = n[0] + 2 * n[1], e = 1; e < t - 1; ++e) i[e] = 1, s[e] = 4, o[e] = 4 * n[e] + 2 * n[e + 1];
  for (i[t - 1] = 2, s[t - 1] = 7, o[t - 1] = 8 * n[t - 1] + n[t], e = 1; e < t; ++e) r = i[e] / s[e - 1], s[e] -= r, o[e] -= r * o[e - 1];
  for (i[t - 1] = o[t - 1] / s[t - 1], e = t - 2; e >= 0; --e) i[e] = (o[e] - i[e + 1]) / s[e];
  for (s[t - 1] = (n[t] + i[t - 1]) / 2, e = 0; e < t - 1; ++e) s[e] = 2 * n[e + 1] - i[e + 1];
  return [i, s];
}
function Ame(n) {
  return new gK(n);
}
function Ow(n, e) {
  this._context = n, this._t = e;
}
Ow.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN, this._point = 0;
  },
  lineEnd: function() {
    0 < this._t && this._t < 1 && this._point === 2 && this._context.lineTo(this._x, this._y), (this._line || this._line !== 0 && this._point === 1) && this._context.closePath(), this._line >= 0 && (this._t = 1 - this._t, this._line = 1 - this._line);
  },
  point: function(n, e) {
    switch (n = +n, e = +e, this._point) {
      case 0:
        this._point = 1, this._line ? this._context.lineTo(n, e) : this._context.moveTo(n, e);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0)
          this._context.lineTo(this._x, e), this._context.lineTo(n, e);
        else {
          var t = this._x * (1 - this._t) + n * this._t;
          this._context.lineTo(t, this._y), this._context.lineTo(t, e);
        }
        break;
      }
    }
    this._x = n, this._y = e;
  }
};
function Mme(n) {
  return new Ow(n, 0.5);
}
function kme(n) {
  return new Ow(n, 0);
}
function _me(n) {
  return new Ow(n, 1);
}
function Sf(n, e) {
  if ((o = n.length) > 1)
    for (var t = 1, r, i, s = n[e[0]], o, a = s.length; t < o; ++t)
      for (i = s, s = n[e[t]], r = 0; r < a; ++r)
        s[r][1] += s[r][0] = isNaN(i[r][1]) ? i[r][0] : i[r][1];
}
function SC(n) {
  for (var e = n.length, t = new Array(e); --e >= 0; ) t[e] = e;
  return t;
}
function Ome(n, e) {
  return n[e];
}
function Ime(n) {
  const e = [];
  return e.key = n, e;
}
function Rme() {
  var n = Mn([]), e = SC, t = Sf, r = Ome;
  function i(s) {
    var o = Array.from(n.apply(this, arguments), Ime), a, l = o.length, c = -1, u;
    for (const d of s)
      for (a = 0, ++c; a < l; ++a)
        (o[a][c] = [0, +r(d, o[a].key, c, s)]).data = d;
    for (a = 0, u = XA(e(o)); a < l; ++a)
      o[u[a]].index = a;
    return t(o, u), o;
  }
  return i.keys = function(s) {
    return arguments.length ? (n = typeof s == "function" ? s : Mn(Array.from(s)), i) : n;
  }, i.value = function(s) {
    return arguments.length ? (r = typeof s == "function" ? s : Mn(+s), i) : r;
  }, i.order = function(s) {
    return arguments.length ? (e = s == null ? SC : typeof s == "function" ? s : Mn(Array.from(s)), i) : e;
  }, i.offset = function(s) {
    return arguments.length ? (t = s ?? Sf, i) : t;
  }, i;
}
function Pme(n, e) {
  if ((r = n.length) > 0) {
    for (var t, r, i = 0, s = n[0].length, o; i < s; ++i) {
      for (o = t = 0; t < r; ++t) o += n[t][i][1] || 0;
      if (o) for (t = 0; t < r; ++t) n[t][i][1] /= o;
    }
    Sf(n, e);
  }
}
function Dme(n, e) {
  if ((i = n.length) > 0) {
    for (var t = 0, r = n[e[0]], i, s = r.length; t < s; ++t) {
      for (var o = 0, a = 0; o < i; ++o) a += n[o][t][1] || 0;
      r[t][1] += r[t][0] = -a / 2;
    }
    Sf(n, e);
  }
}
function Nme(n, e) {
  if (!(!((o = n.length) > 0) || !((s = (i = n[e[0]]).length) > 0))) {
    for (var t = 0, r = 1, i, s, o; r < s; ++r) {
      for (var a = 0, l = 0, c = 0; a < o; ++a) {
        for (var u = n[e[a]], d = u[r][1] || 0, f = u[r - 1][1] || 0, h = (d - f) / 2, m = 0; m < a; ++m) {
          var g = n[e[m]], v = g[r][1] || 0, y = g[r - 1][1] || 0;
          h += v - y;
        }
        l += d, c += h * d;
      }
      i[r - 1][1] += i[r - 1][0] = t, l && (t -= c / l);
    }
    i[r - 1][1] += i[r - 1][0] = t, Sf(n, e);
  }
}
function vm(n) {
  "@babel/helpers - typeof";
  return vm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, vm(n);
}
var Lme = ["type", "size", "sizeType"];
function CC() {
  return CC = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, CC.apply(this, arguments);
}
function hP(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function pP(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? hP(Object(t), !0).forEach(function(r) {
      $me(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : hP(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function $me(n, e, t) {
  return e = Fme(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function Fme(n) {
  var e = Bme(n, "string");
  return vm(e) == "symbol" ? e : e + "";
}
function Bme(n, e) {
  if (vm(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (vm(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function zme(n, e) {
  if (n == null) return {};
  var t = Hme(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function Hme(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n)
    if (Object.prototype.hasOwnProperty.call(n, r)) {
      if (e.indexOf(r) >= 0) continue;
      t[r] = n[r];
    }
  return t;
}
var vK = {
  symbolCircle: ZA,
  symbolCross: lme,
  symbolDiamond: ume,
  symbolSquare: dme,
  symbolStar: mme,
  symbolTriangle: gme,
  symbolWye: yme
}, Ume = Math.PI / 180, Vme = function(e) {
  var t = "symbol".concat(Mw(e));
  return vK[t] || ZA;
}, jme = function(e, t, r) {
  if (t === "area")
    return e;
  switch (r) {
    case "cross":
      return 5 * e * e / 9;
    case "diamond":
      return 0.5 * e * e / Math.sqrt(3);
    case "square":
      return e * e;
    case "star": {
      var i = 18 * Ume;
      return 1.25 * e * e * (Math.tan(i) - Math.tan(i * 2) * Math.pow(Math.tan(i), 2));
    }
    case "triangle":
      return Math.sqrt(3) * e * e / 4;
    case "wye":
      return (21 - 10 * Math.sqrt(3)) * e * e / 8;
    default:
      return Math.PI * e * e / 4;
  }
}, Wme = function(e, t) {
  vK["symbol".concat(Mw(e))] = t;
}, QA = function(e) {
  var t = e.type, r = t === void 0 ? "circle" : t, i = e.size, s = i === void 0 ? 64 : i, o = e.sizeType, a = o === void 0 ? "area" : o, l = zme(e, Lme), c = pP(pP({}, l), {}, {
    type: r,
    size: s,
    sizeType: a
  }), u = function() {
    var v = Vme(r), y = bme().type(v).size(jme(s, a, r));
    return y();
  }, d = c.className, f = c.cx, h = c.cy, m = $t(c, !0);
  return f === +f && h === +h && s === +s ? /* @__PURE__ */ p.createElement("path", CC({}, m, {
    className: Ut("recharts-symbols", d),
    transform: "translate(".concat(f, ", ").concat(h, ")"),
    d: u()
  })) : null;
};
QA.registerSymbol = Wme;
function Cf(n) {
  "@babel/helpers - typeof";
  return Cf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Cf(n);
}
function TC() {
  return TC = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, TC.apply(this, arguments);
}
function mP(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Gme(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? mP(Object(t), !0).forEach(function(r) {
      ym(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : mP(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function Kme(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function qme(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, bK(r.key), r);
  }
}
function Yme(n, e, t) {
  return e && qme(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function Xme(n, e, t) {
  return e = A2(e), Zme(n, yK() ? Reflect.construct(e, t || [], A2(n).constructor) : e.apply(n, t));
}
function Zme(n, e) {
  if (e && (Cf(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Qme(n);
}
function Qme(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function yK() {
  try {
    var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (yK = function() {
    return !!n;
  })();
}
function A2(n) {
  return A2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, A2(n);
}
function Jme(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && AC(n, e);
}
function AC(n, e) {
  return AC = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, AC(n, e);
}
function ym(n, e, t) {
  return e = bK(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function bK(n) {
  var e = e0e(n, "string");
  return Cf(e) == "symbol" ? e : e + "";
}
function e0e(n, e) {
  if (Cf(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Cf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
var Cs = 32, JA = /* @__PURE__ */ (function(n) {
  function e() {
    return Kme(this, e), Xme(this, e, arguments);
  }
  return Jme(e, n), Yme(e, [{
    key: "renderIcon",
    value: (
      /**
       * Render the path of icon
       * @param {Object} data Data of each legend item
       * @return {String} Path element
       */
      function(r) {
        var i = this.props.inactiveColor, s = Cs / 2, o = Cs / 6, a = Cs / 3, l = r.inactive ? i : r.color;
        if (r.type === "plainline")
          return /* @__PURE__ */ p.createElement("line", {
            strokeWidth: 4,
            fill: "none",
            stroke: l,
            strokeDasharray: r.payload.strokeDasharray,
            x1: 0,
            y1: s,
            x2: Cs,
            y2: s,
            className: "recharts-legend-icon"
          });
        if (r.type === "line")
          return /* @__PURE__ */ p.createElement("path", {
            strokeWidth: 4,
            fill: "none",
            stroke: l,
            d: "M0,".concat(s, "h").concat(a, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(2 * a, ",").concat(s, `
            H`).concat(Cs, "M").concat(2 * a, ",").concat(s, `
            A`).concat(o, ",").concat(o, ",0,1,1,").concat(a, ",").concat(s),
            className: "recharts-legend-icon"
          });
        if (r.type === "rect")
          return /* @__PURE__ */ p.createElement("path", {
            stroke: "none",
            fill: l,
            d: "M0,".concat(Cs / 8, "h").concat(Cs, "v").concat(Cs * 3 / 4, "h").concat(-Cs, "z"),
            className: "recharts-legend-icon"
          });
        if (/* @__PURE__ */ p.isValidElement(r.legendIcon)) {
          var c = Gme({}, r);
          return delete c.legendIcon, /* @__PURE__ */ p.cloneElement(r.legendIcon, c);
        }
        return /* @__PURE__ */ p.createElement(QA, {
          fill: l,
          cx: s,
          cy: s,
          size: Cs,
          sizeType: "diameter",
          type: r.type
        });
      }
    )
    /**
     * Draw items of legend
     * @return {ReactElement} Items
     */
  }, {
    key: "renderItems",
    value: function() {
      var r = this, i = this.props, s = i.payload, o = i.iconSize, a = i.layout, l = i.formatter, c = i.inactiveColor, u = {
        x: 0,
        y: 0,
        width: Cs,
        height: Cs
      }, d = {
        display: a === "horizontal" ? "inline-block" : "block",
        marginRight: 10
      }, f = {
        display: "inline-block",
        verticalAlign: "middle",
        marginRight: 4
      };
      return s.map(function(h, m) {
        var g = h.formatter || l, v = Ut(ym(ym({
          "recharts-legend-item": !0
        }, "legend-item-".concat(m), !0), "inactive", h.inactive));
        if (h.type === "none")
          return null;
        var y = Mt(h.value) ? null : h.value;
        rl(
          !Mt(h.value),
          `The name property is also required when using a function for the dataKey of a chart's cartesian components. Ex: <Bar name="Name of my Data"/>`
          // eslint-disable-line max-len
        );
        var b = h.inactive ? c : h.color;
        return /* @__PURE__ */ p.createElement("li", TC({
          className: v,
          style: d,
          key: "legend-item-".concat(m)
        }, w2(r.props, h, m)), /* @__PURE__ */ p.createElement(yC, {
          width: o,
          height: o,
          viewBox: u,
          style: f
        }, r.renderIcon(h)), /* @__PURE__ */ p.createElement("span", {
          className: "recharts-legend-item-text",
          style: {
            color: b
          }
        }, g ? g(y, h, m) : y));
      });
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.payload, s = r.layout, o = r.align;
      if (!i || !i.length)
        return null;
      var a = {
        padding: 0,
        margin: 0,
        textAlign: s === "horizontal" ? o : "left"
      };
      return /* @__PURE__ */ p.createElement("ul", {
        className: "recharts-default-legend",
        style: a
      }, this.renderItems());
    }
  }]);
})(Sc);
ym(JA, "displayName", "Legend");
ym(JA, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "middle",
  inactiveColor: "#ccc"
});
var cE, gP;
function t0e() {
  if (gP) return cE;
  gP = 1;
  var n = Cw();
  function e() {
    this.__data__ = new n(), this.size = 0;
  }
  return cE = e, cE;
}
var uE, vP;
function n0e() {
  if (vP) return uE;
  vP = 1;
  function n(e) {
    var t = this.__data__, r = t.delete(e);
    return this.size = t.size, r;
  }
  return uE = n, uE;
}
var dE, yP;
function r0e() {
  if (yP) return dE;
  yP = 1;
  function n(e) {
    return this.__data__.get(e);
  }
  return dE = n, dE;
}
var fE, bP;
function i0e() {
  if (bP) return fE;
  bP = 1;
  function n(e) {
    return this.__data__.has(e);
  }
  return fE = n, fE;
}
var hE, wP;
function s0e() {
  if (wP) return hE;
  wP = 1;
  var n = Cw(), e = VA(), t = jA(), r = 200;
  function i(s, o) {
    var a = this.__data__;
    if (a instanceof n) {
      var l = a.__data__;
      if (!e || l.length < r - 1)
        return l.push([s, o]), this.size = ++a.size, this;
      a = this.__data__ = new t(l);
    }
    return a.set(s, o), this.size = a.size, this;
  }
  return hE = i, hE;
}
var pE, xP;
function wK() {
  if (xP) return pE;
  xP = 1;
  var n = Cw(), e = t0e(), t = n0e(), r = r0e(), i = i0e(), s = s0e();
  function o(a) {
    var l = this.__data__ = new n(a);
    this.size = l.size;
  }
  return o.prototype.clear = e, o.prototype.delete = t, o.prototype.get = r, o.prototype.has = i, o.prototype.set = s, pE = o, pE;
}
var mE, EP;
function o0e() {
  if (EP) return mE;
  EP = 1;
  var n = "__lodash_hash_undefined__";
  function e(t) {
    return this.__data__.set(t, n), this;
  }
  return mE = e, mE;
}
var gE, SP;
function a0e() {
  if (SP) return gE;
  SP = 1;
  function n(e) {
    return this.__data__.has(e);
  }
  return gE = n, gE;
}
var vE, CP;
function xK() {
  if (CP) return vE;
  CP = 1;
  var n = jA(), e = o0e(), t = a0e();
  function r(i) {
    var s = -1, o = i == null ? 0 : i.length;
    for (this.__data__ = new n(); ++s < o; )
      this.add(i[s]);
  }
  return r.prototype.add = r.prototype.push = e, r.prototype.has = t, vE = r, vE;
}
var yE, TP;
function EK() {
  if (TP) return yE;
  TP = 1;
  function n(e, t) {
    for (var r = -1, i = e == null ? 0 : e.length; ++r < i; )
      if (t(e[r], r, e))
        return !0;
    return !1;
  }
  return yE = n, yE;
}
var bE, AP;
function SK() {
  if (AP) return bE;
  AP = 1;
  function n(e, t) {
    return e.has(t);
  }
  return bE = n, bE;
}
var wE, MP;
function CK() {
  if (MP) return wE;
  MP = 1;
  var n = xK(), e = EK(), t = SK(), r = 1, i = 2;
  function s(o, a, l, c, u, d) {
    var f = l & r, h = o.length, m = a.length;
    if (h != m && !(f && m > h))
      return !1;
    var g = d.get(o), v = d.get(a);
    if (g && v)
      return g == a && v == o;
    var y = -1, b = !0, x = l & i ? new n() : void 0;
    for (d.set(o, a), d.set(a, o); ++y < h; ) {
      var E = o[y], w = a[y];
      if (c)
        var C = f ? c(w, E, y, a, o, d) : c(E, w, y, o, a, d);
      if (C !== void 0) {
        if (C)
          continue;
        b = !1;
        break;
      }
      if (x) {
        if (!e(a, function(S, M) {
          if (!t(x, M) && (E === S || u(E, S, l, c, d)))
            return x.push(M);
        })) {
          b = !1;
          break;
        }
      } else if (!(E === w || u(E, w, l, c, d))) {
        b = !1;
        break;
      }
    }
    return d.delete(o), d.delete(a), b;
  }
  return wE = s, wE;
}
var xE, kP;
function l0e() {
  if (kP) return xE;
  kP = 1;
  var n = Sa(), e = n.Uint8Array;
  return xE = e, xE;
}
var EE, _P;
function c0e() {
  if (_P) return EE;
  _P = 1;
  function n(e) {
    var t = -1, r = Array(e.size);
    return e.forEach(function(i, s) {
      r[++t] = [s, i];
    }), r;
  }
  return EE = n, EE;
}
var SE, OP;
function eM() {
  if (OP) return SE;
  OP = 1;
  function n(e) {
    var t = -1, r = Array(e.size);
    return e.forEach(function(i) {
      r[++t] = i;
    }), r;
  }
  return SE = n, SE;
}
var CE, IP;
function u0e() {
  if (IP) return CE;
  IP = 1;
  var n = a1(), e = l0e(), t = UA(), r = CK(), i = c0e(), s = eM(), o = 1, a = 2, l = "[object Boolean]", c = "[object Date]", u = "[object Error]", d = "[object Map]", f = "[object Number]", h = "[object RegExp]", m = "[object Set]", g = "[object String]", v = "[object Symbol]", y = "[object ArrayBuffer]", b = "[object DataView]", x = n ? n.prototype : void 0, E = x ? x.valueOf : void 0;
  function w(C, S, M, k, _, O, I) {
    switch (M) {
      case b:
        if (C.byteLength != S.byteLength || C.byteOffset != S.byteOffset)
          return !1;
        C = C.buffer, S = S.buffer;
      case y:
        return !(C.byteLength != S.byteLength || !O(new e(C), new e(S)));
      case l:
      case c:
      case f:
        return t(+C, +S);
      case u:
        return C.name == S.name && C.message == S.message;
      case h:
      case g:
        return C == S + "";
      case d:
        var R = i;
      case m:
        var P = k & o;
        if (R || (R = s), C.size != S.size && !P)
          return !1;
        var D = I.get(C);
        if (D)
          return D == S;
        k |= a, I.set(C, S);
        var L = r(R(C), R(S), k, _, O, I);
        return I.delete(C), L;
      case v:
        if (E)
          return E.call(C) == E.call(S);
    }
    return !1;
  }
  return CE = w, CE;
}
var TE, RP;
function TK() {
  if (RP) return TE;
  RP = 1;
  function n(e, t) {
    for (var r = -1, i = t.length, s = e.length; ++r < i; )
      e[s + r] = t[r];
    return e;
  }
  return TE = n, TE;
}
var AE, PP;
function d0e() {
  if (PP) return AE;
  PP = 1;
  var n = TK(), e = Gi();
  function t(r, i, s) {
    var o = i(r);
    return e(r) ? o : n(o, s(r));
  }
  return AE = t, AE;
}
var ME, DP;
function f0e() {
  if (DP) return ME;
  DP = 1;
  function n(e, t) {
    for (var r = -1, i = e == null ? 0 : e.length, s = 0, o = []; ++r < i; ) {
      var a = e[r];
      t(a, r, e) && (o[s++] = a);
    }
    return o;
  }
  return ME = n, ME;
}
var kE, NP;
function h0e() {
  if (NP) return kE;
  NP = 1;
  function n() {
    return [];
  }
  return kE = n, kE;
}
var _E, LP;
function p0e() {
  if (LP) return _E;
  LP = 1;
  var n = f0e(), e = h0e(), t = Object.prototype, r = t.propertyIsEnumerable, i = Object.getOwnPropertySymbols, s = i ? function(o) {
    return o == null ? [] : (o = Object(o), n(i(o), function(a) {
      return r.call(o, a);
    }));
  } : e;
  return _E = s, _E;
}
var OE, $P;
function m0e() {
  if ($P) return OE;
  $P = 1;
  function n(e, t) {
    for (var r = -1, i = Array(e); ++r < e; )
      i[r] = t(r);
    return i;
  }
  return OE = n, OE;
}
var IE, FP;
function g0e() {
  if (FP) return IE;
  FP = 1;
  var n = yl(), e = bl(), t = "[object Arguments]";
  function r(i) {
    return e(i) && n(i) == t;
  }
  return IE = r, IE;
}
var RE, BP;
function tM() {
  if (BP) return RE;
  BP = 1;
  var n = g0e(), e = bl(), t = Object.prototype, r = t.hasOwnProperty, i = t.propertyIsEnumerable, s = n(/* @__PURE__ */ (function() {
    return arguments;
  })()) ? n : function(o) {
    return e(o) && r.call(o, "callee") && !i.call(o, "callee");
  };
  return RE = s, RE;
}
var Sp = { exports: {} }, PE, zP;
function v0e() {
  if (zP) return PE;
  zP = 1;
  function n() {
    return !1;
  }
  return PE = n, PE;
}
Sp.exports;
var HP;
function AK() {
  return HP || (HP = 1, (function(n, e) {
    var t = Sa(), r = v0e(), i = e && !e.nodeType && e, s = i && !0 && n && !n.nodeType && n, o = s && s.exports === i, a = o ? t.Buffer : void 0, l = a ? a.isBuffer : void 0, c = l || r;
    n.exports = c;
  })(Sp, Sp.exports)), Sp.exports;
}
var DE, UP;
function nM() {
  if (UP) return DE;
  UP = 1;
  var n = 9007199254740991, e = /^(?:0|[1-9]\d*)$/;
  function t(r, i) {
    var s = typeof r;
    return i = i ?? n, !!i && (s == "number" || s != "symbol" && e.test(r)) && r > -1 && r % 1 == 0 && r < i;
  }
  return DE = t, DE;
}
var NE, VP;
function rM() {
  if (VP) return NE;
  VP = 1;
  var n = 9007199254740991;
  function e(t) {
    return typeof t == "number" && t > -1 && t % 1 == 0 && t <= n;
  }
  return NE = e, NE;
}
var LE, jP;
function y0e() {
  if (jP) return LE;
  jP = 1;
  var n = yl(), e = rM(), t = bl(), r = "[object Arguments]", i = "[object Array]", s = "[object Boolean]", o = "[object Date]", a = "[object Error]", l = "[object Function]", c = "[object Map]", u = "[object Number]", d = "[object Object]", f = "[object RegExp]", h = "[object Set]", m = "[object String]", g = "[object WeakMap]", v = "[object ArrayBuffer]", y = "[object DataView]", b = "[object Float32Array]", x = "[object Float64Array]", E = "[object Int8Array]", w = "[object Int16Array]", C = "[object Int32Array]", S = "[object Uint8Array]", M = "[object Uint8ClampedArray]", k = "[object Uint16Array]", _ = "[object Uint32Array]", O = {};
  O[b] = O[x] = O[E] = O[w] = O[C] = O[S] = O[M] = O[k] = O[_] = !0, O[r] = O[i] = O[v] = O[s] = O[y] = O[o] = O[a] = O[l] = O[c] = O[u] = O[d] = O[f] = O[h] = O[m] = O[g] = !1;
  function I(R) {
    return t(R) && e(R.length) && !!O[n(R)];
  }
  return LE = I, LE;
}
var $E, WP;
function MK() {
  if (WP) return $E;
  WP = 1;
  function n(e) {
    return function(t) {
      return e(t);
    };
  }
  return $E = n, $E;
}
var Cp = { exports: {} };
Cp.exports;
var GP;
function b0e() {
  return GP || (GP = 1, (function(n, e) {
    var t = KG(), r = e && !e.nodeType && e, i = r && !0 && n && !n.nodeType && n, s = i && i.exports === r, o = s && t.process, a = (function() {
      try {
        var l = i && i.require && i.require("util").types;
        return l || o && o.binding && o.binding("util");
      } catch {
      }
    })();
    n.exports = a;
  })(Cp, Cp.exports)), Cp.exports;
}
var FE, KP;
function kK() {
  if (KP) return FE;
  KP = 1;
  var n = y0e(), e = MK(), t = b0e(), r = t && t.isTypedArray, i = r ? e(r) : n;
  return FE = i, FE;
}
var BE, qP;
function w0e() {
  if (qP) return BE;
  qP = 1;
  var n = m0e(), e = tM(), t = Gi(), r = AK(), i = nM(), s = kK(), o = Object.prototype, a = o.hasOwnProperty;
  function l(c, u) {
    var d = t(c), f = !d && e(c), h = !d && !f && r(c), m = !d && !f && !h && s(c), g = d || f || h || m, v = g ? n(c.length, String) : [], y = v.length;
    for (var b in c)
      (u || a.call(c, b)) && !(g && // Safari 9 has enumerable `arguments.length` in strict mode.
      (b == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      h && (b == "offset" || b == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      m && (b == "buffer" || b == "byteLength" || b == "byteOffset") || // Skip index properties.
      i(b, y))) && v.push(b);
    return v;
  }
  return BE = l, BE;
}
var zE, YP;
function x0e() {
  if (YP) return zE;
  YP = 1;
  var n = Object.prototype;
  function e(t) {
    var r = t && t.constructor, i = typeof r == "function" && r.prototype || n;
    return t === i;
  }
  return zE = e, zE;
}
var HE, XP;
function _K() {
  if (XP) return HE;
  XP = 1;
  function n(e, t) {
    return function(r) {
      return e(t(r));
    };
  }
  return HE = n, HE;
}
var UE, ZP;
function E0e() {
  if (ZP) return UE;
  ZP = 1;
  var n = _K(), e = n(Object.keys, Object);
  return UE = e, UE;
}
var VE, QP;
function S0e() {
  if (QP) return VE;
  QP = 1;
  var n = x0e(), e = E0e(), t = Object.prototype, r = t.hasOwnProperty;
  function i(s) {
    if (!n(s))
      return e(s);
    var o = [];
    for (var a in Object(s))
      r.call(s, a) && a != "constructor" && o.push(a);
    return o;
  }
  return VE = i, VE;
}
var jE, JP;
function c1() {
  if (JP) return jE;
  JP = 1;
  var n = HA(), e = rM();
  function t(r) {
    return r != null && e(r.length) && !n(r);
  }
  return jE = t, jE;
}
var WE, eD;
function Iw() {
  if (eD) return WE;
  eD = 1;
  var n = w0e(), e = S0e(), t = c1();
  function r(i) {
    return t(i) ? n(i) : e(i);
  }
  return WE = r, WE;
}
var GE, tD;
function C0e() {
  if (tD) return GE;
  tD = 1;
  var n = d0e(), e = p0e(), t = Iw();
  function r(i) {
    return n(i, t, e);
  }
  return GE = r, GE;
}
var KE, nD;
function T0e() {
  if (nD) return KE;
  nD = 1;
  var n = C0e(), e = 1, t = Object.prototype, r = t.hasOwnProperty;
  function i(s, o, a, l, c, u) {
    var d = a & e, f = n(s), h = f.length, m = n(o), g = m.length;
    if (h != g && !d)
      return !1;
    for (var v = h; v--; ) {
      var y = f[v];
      if (!(d ? y in o : r.call(o, y)))
        return !1;
    }
    var b = u.get(s), x = u.get(o);
    if (b && x)
      return b == o && x == s;
    var E = !0;
    u.set(s, o), u.set(o, s);
    for (var w = d; ++v < h; ) {
      y = f[v];
      var C = s[y], S = o[y];
      if (l)
        var M = d ? l(S, C, y, o, s, u) : l(C, S, y, s, o, u);
      if (!(M === void 0 ? C === S || c(C, S, a, l, u) : M)) {
        E = !1;
        break;
      }
      w || (w = y == "constructor");
    }
    if (E && !w) {
      var k = s.constructor, _ = o.constructor;
      k != _ && "constructor" in s && "constructor" in o && !(typeof k == "function" && k instanceof k && typeof _ == "function" && _ instanceof _) && (E = !1);
    }
    return u.delete(s), u.delete(o), E;
  }
  return KE = i, KE;
}
var qE, rD;
function A0e() {
  if (rD) return qE;
  rD = 1;
  var n = ed(), e = Sa(), t = n(e, "DataView");
  return qE = t, qE;
}
var YE, iD;
function M0e() {
  if (iD) return YE;
  iD = 1;
  var n = ed(), e = Sa(), t = n(e, "Promise");
  return YE = t, YE;
}
var XE, sD;
function OK() {
  if (sD) return XE;
  sD = 1;
  var n = ed(), e = Sa(), t = n(e, "Set");
  return XE = t, XE;
}
var ZE, oD;
function k0e() {
  if (oD) return ZE;
  oD = 1;
  var n = ed(), e = Sa(), t = n(e, "WeakMap");
  return ZE = t, ZE;
}
var QE, aD;
function _0e() {
  if (aD) return QE;
  aD = 1;
  var n = A0e(), e = VA(), t = M0e(), r = OK(), i = k0e(), s = yl(), o = qG(), a = "[object Map]", l = "[object Object]", c = "[object Promise]", u = "[object Set]", d = "[object WeakMap]", f = "[object DataView]", h = o(n), m = o(e), g = o(t), v = o(r), y = o(i), b = s;
  return (n && b(new n(new ArrayBuffer(1))) != f || e && b(new e()) != a || t && b(t.resolve()) != c || r && b(new r()) != u || i && b(new i()) != d) && (b = function(x) {
    var E = s(x), w = E == l ? x.constructor : void 0, C = w ? o(w) : "";
    if (C)
      switch (C) {
        case h:
          return f;
        case m:
          return a;
        case g:
          return c;
        case v:
          return u;
        case y:
          return d;
      }
    return E;
  }), QE = b, QE;
}
var JE, lD;
function O0e() {
  if (lD) return JE;
  lD = 1;
  var n = wK(), e = CK(), t = u0e(), r = T0e(), i = _0e(), s = Gi(), o = AK(), a = kK(), l = 1, c = "[object Arguments]", u = "[object Array]", d = "[object Object]", f = Object.prototype, h = f.hasOwnProperty;
  function m(g, v, y, b, x, E) {
    var w = s(g), C = s(v), S = w ? u : i(g), M = C ? u : i(v);
    S = S == c ? d : S, M = M == c ? d : M;
    var k = S == d, _ = M == d, O = S == M;
    if (O && o(g)) {
      if (!o(v))
        return !1;
      w = !0, k = !1;
    }
    if (O && !k)
      return E || (E = new n()), w || a(g) ? e(g, v, y, b, x, E) : t(g, v, S, y, b, x, E);
    if (!(y & l)) {
      var I = k && h.call(g, "__wrapped__"), R = _ && h.call(v, "__wrapped__");
      if (I || R) {
        var P = I ? g.value() : g, D = R ? v.value() : v;
        return E || (E = new n()), x(P, D, y, b, E);
      }
    }
    return O ? (E || (E = new n()), r(g, v, y, b, x, E)) : !1;
  }
  return JE = m, JE;
}
var e5, cD;
function iM() {
  if (cD) return e5;
  cD = 1;
  var n = O0e(), e = bl();
  function t(r, i, s, o, a) {
    return r === i ? !0 : r == null || i == null || !e(r) && !e(i) ? r !== r && i !== i : n(r, i, s, o, t, a);
  }
  return e5 = t, e5;
}
var t5, uD;
function I0e() {
  if (uD) return t5;
  uD = 1;
  var n = wK(), e = iM(), t = 1, r = 2;
  function i(s, o, a, l) {
    var c = a.length, u = c, d = !l;
    if (s == null)
      return !u;
    for (s = Object(s); c--; ) {
      var f = a[c];
      if (d && f[2] ? f[1] !== s[f[0]] : !(f[0] in s))
        return !1;
    }
    for (; ++c < u; ) {
      f = a[c];
      var h = f[0], m = s[h], g = f[1];
      if (d && f[2]) {
        if (m === void 0 && !(h in s))
          return !1;
      } else {
        var v = new n();
        if (l)
          var y = l(m, g, h, s, o, v);
        if (!(y === void 0 ? e(g, m, t | r, l, v) : y))
          return !1;
      }
    }
    return !0;
  }
  return t5 = i, t5;
}
var n5, dD;
function IK() {
  if (dD) return n5;
  dD = 1;
  var n = Cc();
  function e(t) {
    return t === t && !n(t);
  }
  return n5 = e, n5;
}
var r5, fD;
function R0e() {
  if (fD) return r5;
  fD = 1;
  var n = IK(), e = Iw();
  function t(r) {
    for (var i = e(r), s = i.length; s--; ) {
      var o = i[s], a = r[o];
      i[s] = [o, a, n(a)];
    }
    return i;
  }
  return r5 = t, r5;
}
var i5, hD;
function RK() {
  if (hD) return i5;
  hD = 1;
  function n(e, t) {
    return function(r) {
      return r == null ? !1 : r[e] === t && (t !== void 0 || e in Object(r));
    };
  }
  return i5 = n, i5;
}
var s5, pD;
function P0e() {
  if (pD) return s5;
  pD = 1;
  var n = I0e(), e = R0e(), t = RK();
  function r(i) {
    var s = e(i);
    return s.length == 1 && s[0][2] ? t(s[0][0], s[0][1]) : function(o) {
      return o === i || n(o, i, s);
    };
  }
  return s5 = r, s5;
}
var o5, mD;
function D0e() {
  if (mD) return o5;
  mD = 1;
  function n(e, t) {
    return e != null && t in Object(e);
  }
  return o5 = n, o5;
}
var a5, gD;
function N0e() {
  if (gD) return a5;
  gD = 1;
  var n = ZG(), e = tM(), t = Gi(), r = nM(), i = rM(), s = Aw();
  function o(a, l, c) {
    l = n(l, a);
    for (var u = -1, d = l.length, f = !1; ++u < d; ) {
      var h = s(l[u]);
      if (!(f = a != null && c(a, h)))
        break;
      a = a[h];
    }
    return f || ++u != d ? f : (d = a == null ? 0 : a.length, !!d && i(d) && r(h, d) && (t(a) || e(a)));
  }
  return a5 = o, a5;
}
var l5, vD;
function L0e() {
  if (vD) return l5;
  vD = 1;
  var n = D0e(), e = N0e();
  function t(r, i) {
    return r != null && e(r, i, n);
  }
  return l5 = t, l5;
}
var c5, yD;
function $0e() {
  if (yD) return c5;
  yD = 1;
  var n = iM(), e = QG(), t = L0e(), r = zA(), i = IK(), s = RK(), o = Aw(), a = 1, l = 2;
  function c(u, d) {
    return r(u) && i(d) ? s(o(u), d) : function(f) {
      var h = e(f, u);
      return h === void 0 && h === d ? t(f, u) : n(d, h, a | l);
    };
  }
  return c5 = c, c5;
}
var u5, bD;
function Ch() {
  if (bD) return u5;
  bD = 1;
  function n(e) {
    return e;
  }
  return u5 = n, u5;
}
var d5, wD;
function F0e() {
  if (wD) return d5;
  wD = 1;
  function n(e) {
    return function(t) {
      return t?.[e];
    };
  }
  return d5 = n, d5;
}
var f5, xD;
function B0e() {
  if (xD) return f5;
  xD = 1;
  var n = GA();
  function e(t) {
    return function(r) {
      return n(r, t);
    };
  }
  return f5 = e, f5;
}
var h5, ED;
function z0e() {
  if (ED) return h5;
  ED = 1;
  var n = F0e(), e = B0e(), t = zA(), r = Aw();
  function i(s) {
    return t(s) ? n(r(s)) : e(s);
  }
  return h5 = i, h5;
}
var p5, SD;
function Tc() {
  if (SD) return p5;
  SD = 1;
  var n = P0e(), e = $0e(), t = Ch(), r = Gi(), i = z0e();
  function s(o) {
    return typeof o == "function" ? o : o == null ? t : typeof o == "object" ? r(o) ? e(o[0], o[1]) : n(o) : i(o);
  }
  return p5 = s, p5;
}
var m5, CD;
function PK() {
  if (CD) return m5;
  CD = 1;
  function n(e, t, r, i) {
    for (var s = e.length, o = r + (i ? 1 : -1); i ? o-- : ++o < s; )
      if (t(e[o], o, e))
        return o;
    return -1;
  }
  return m5 = n, m5;
}
var g5, TD;
function H0e() {
  if (TD) return g5;
  TD = 1;
  function n(e) {
    return e !== e;
  }
  return g5 = n, g5;
}
var v5, AD;
function U0e() {
  if (AD) return v5;
  AD = 1;
  function n(e, t, r) {
    for (var i = r - 1, s = e.length; ++i < s; )
      if (e[i] === t)
        return i;
    return -1;
  }
  return v5 = n, v5;
}
var y5, MD;
function V0e() {
  if (MD) return y5;
  MD = 1;
  var n = PK(), e = H0e(), t = U0e();
  function r(i, s, o) {
    return s === s ? t(i, s, o) : n(i, e, o);
  }
  return y5 = r, y5;
}
var b5, kD;
function j0e() {
  if (kD) return b5;
  kD = 1;
  var n = V0e();
  function e(t, r) {
    var i = t == null ? 0 : t.length;
    return !!i && n(t, r, 0) > -1;
  }
  return b5 = e, b5;
}
var w5, _D;
function W0e() {
  if (_D) return w5;
  _D = 1;
  function n(e, t, r) {
    for (var i = -1, s = e == null ? 0 : e.length; ++i < s; )
      if (r(t, e[i]))
        return !0;
    return !1;
  }
  return w5 = n, w5;
}
var x5, OD;
function G0e() {
  if (OD) return x5;
  OD = 1;
  function n() {
  }
  return x5 = n, x5;
}
var E5, ID;
function K0e() {
  if (ID) return E5;
  ID = 1;
  var n = OK(), e = G0e(), t = eM(), r = 1 / 0, i = n && 1 / t(new n([, -0]))[1] == r ? function(s) {
    return new n(s);
  } : e;
  return E5 = i, E5;
}
var S5, RD;
function q0e() {
  if (RD) return S5;
  RD = 1;
  var n = xK(), e = j0e(), t = W0e(), r = SK(), i = K0e(), s = eM(), o = 200;
  function a(l, c, u) {
    var d = -1, f = e, h = l.length, m = !0, g = [], v = g;
    if (u)
      m = !1, f = t;
    else if (h >= o) {
      var y = c ? null : i(l);
      if (y)
        return s(y);
      m = !1, f = r, v = new n();
    } else
      v = c ? [] : g;
    e:
      for (; ++d < h; ) {
        var b = l[d], x = c ? c(b) : b;
        if (b = u || b !== 0 ? b : 0, m && x === x) {
          for (var E = v.length; E--; )
            if (v[E] === x)
              continue e;
          c && v.push(x), g.push(b);
        } else f(v, x, u) || (v !== g && v.push(x), g.push(b));
      }
    return g;
  }
  return S5 = a, S5;
}
var C5, PD;
function Y0e() {
  if (PD) return C5;
  PD = 1;
  var n = Tc(), e = q0e();
  function t(r, i) {
    return r && r.length ? e(r, n(i, 2)) : [];
  }
  return C5 = t, C5;
}
var X0e = Y0e();
const DD = /* @__PURE__ */ nn(X0e);
function DK(n, e, t) {
  return e === !0 ? DD(n, t) : Mt(e) ? DD(n, e) : n;
}
function Tf(n) {
  "@babel/helpers - typeof";
  return Tf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Tf(n);
}
var Z0e = ["ref"];
function ND(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Ra(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? ND(Object(t), !0).forEach(function(r) {
      Rw(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : ND(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function Q0e(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function LD(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, LK(r.key), r);
  }
}
function J0e(n, e, t) {
  return e && LD(n.prototype, e), t && LD(n, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function e1e(n, e, t) {
  return e = M2(e), t1e(n, NK() ? Reflect.construct(e, t || [], M2(n).constructor) : e.apply(n, t));
}
function t1e(n, e) {
  if (e && (Tf(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return n1e(n);
}
function n1e(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function NK() {
  try {
    var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (NK = function() {
    return !!n;
  })();
}
function M2(n) {
  return M2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, M2(n);
}
function r1e(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && MC(n, e);
}
function MC(n, e) {
  return MC = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, MC(n, e);
}
function Rw(n, e, t) {
  return e = LK(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function LK(n) {
  var e = i1e(n, "string");
  return Tf(e) == "symbol" ? e : e + "";
}
function i1e(n, e) {
  if (Tf(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Tf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
function s1e(n, e) {
  if (n == null) return {};
  var t = o1e(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function o1e(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n)
    if (Object.prototype.hasOwnProperty.call(n, r)) {
      if (e.indexOf(r) >= 0) continue;
      t[r] = n[r];
    }
  return t;
}
function a1e(n) {
  return n.value;
}
function l1e(n, e) {
  if (/* @__PURE__ */ p.isValidElement(n))
    return /* @__PURE__ */ p.cloneElement(n, e);
  if (typeof n == "function")
    return /* @__PURE__ */ p.createElement(n, e);
  e.ref;
  var t = s1e(e, Z0e);
  return /* @__PURE__ */ p.createElement(JA, t);
}
var $D = 1, yu = /* @__PURE__ */ (function(n) {
  function e() {
    var t;
    Q0e(this, e);
    for (var r = arguments.length, i = new Array(r), s = 0; s < r; s++)
      i[s] = arguments[s];
    return t = e1e(this, e, [].concat(i)), Rw(t, "lastBoundingBox", {
      width: -1,
      height: -1
    }), t;
  }
  return r1e(e, n), J0e(e, [{
    key: "componentDidMount",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      this.updateBBox();
    }
  }, {
    key: "getBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var r = this.wrapperNode.getBoundingClientRect();
        return r.height = this.wrapperNode.offsetHeight, r.width = this.wrapperNode.offsetWidth, r;
      }
      return null;
    }
  }, {
    key: "updateBBox",
    value: function() {
      var r = this.props.onBBoxUpdate, i = this.getBBox();
      i ? (Math.abs(i.width - this.lastBoundingBox.width) > $D || Math.abs(i.height - this.lastBoundingBox.height) > $D) && (this.lastBoundingBox.width = i.width, this.lastBoundingBox.height = i.height, r && r(i)) : (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) && (this.lastBoundingBox.width = -1, this.lastBoundingBox.height = -1, r && r(null));
    }
  }, {
    key: "getBBoxSnapshot",
    value: function() {
      return this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0 ? Ra({}, this.lastBoundingBox) : {
        width: 0,
        height: 0
      };
    }
  }, {
    key: "getDefaultPosition",
    value: function(r) {
      var i = this.props, s = i.layout, o = i.align, a = i.verticalAlign, l = i.margin, c = i.chartWidth, u = i.chartHeight, d, f;
      if (!r || (r.left === void 0 || r.left === null) && (r.right === void 0 || r.right === null))
        if (o === "center" && s === "vertical") {
          var h = this.getBBoxSnapshot();
          d = {
            left: ((c || 0) - h.width) / 2
          };
        } else
          d = o === "right" ? {
            right: l && l.right || 0
          } : {
            left: l && l.left || 0
          };
      if (!r || (r.top === void 0 || r.top === null) && (r.bottom === void 0 || r.bottom === null))
        if (a === "middle") {
          var m = this.getBBoxSnapshot();
          f = {
            top: ((u || 0) - m.height) / 2
          };
        } else
          f = a === "bottom" ? {
            bottom: l && l.bottom || 0
          } : {
            top: l && l.top || 0
          };
      return Ra(Ra({}, d), f);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, s = i.content, o = i.width, a = i.height, l = i.wrapperStyle, c = i.payloadUniqBy, u = i.payload, d = Ra(Ra({
        position: "absolute",
        width: o || "auto",
        height: a || "auto"
      }, this.getDefaultPosition(l)), l);
      return /* @__PURE__ */ p.createElement("div", {
        className: "recharts-legend-wrapper",
        style: d,
        ref: function(h) {
          r.wrapperNode = h;
        }
      }, l1e(s, Ra(Ra({}, this.props), {}, {
        payload: DK(u, c, a1e)
      })));
    }
  }], [{
    key: "getWithHeight",
    value: function(r, i) {
      var s = Ra(Ra({}, this.defaultProps), r.props), o = s.layout;
      return o === "vertical" && ke(r.props.height) ? {
        height: r.props.height
      } : o === "horizontal" ? {
        width: r.props.width || i
      } : null;
    }
  }]);
})(Sc);
Rw(yu, "displayName", "Legend");
Rw(yu, "defaultProps", {
  iconSize: 14,
  layout: "horizontal",
  align: "center",
  verticalAlign: "bottom"
});
var T5, FD;
function c1e() {
  if (FD) return T5;
  FD = 1;
  var n = a1(), e = tM(), t = Gi(), r = n ? n.isConcatSpreadable : void 0;
  function i(s) {
    return t(s) || e(s) || !!(r && s && s[r]);
  }
  return T5 = i, T5;
}
var A5, BD;
function $K() {
  if (BD) return A5;
  BD = 1;
  var n = TK(), e = c1e();
  function t(r, i, s, o, a) {
    var l = -1, c = r.length;
    for (s || (s = e), a || (a = []); ++l < c; ) {
      var u = r[l];
      i > 0 && s(u) ? i > 1 ? t(u, i - 1, s, o, a) : n(a, u) : o || (a[a.length] = u);
    }
    return a;
  }
  return A5 = t, A5;
}
var M5, zD;
function u1e() {
  if (zD) return M5;
  zD = 1;
  function n(e) {
    return function(t, r, i) {
      for (var s = -1, o = Object(t), a = i(t), l = a.length; l--; ) {
        var c = a[e ? l : ++s];
        if (r(o[c], c, o) === !1)
          break;
      }
      return t;
    };
  }
  return M5 = n, M5;
}
var k5, HD;
function d1e() {
  if (HD) return k5;
  HD = 1;
  var n = u1e(), e = n();
  return k5 = e, k5;
}
var _5, UD;
function FK() {
  if (UD) return _5;
  UD = 1;
  var n = d1e(), e = Iw();
  function t(r, i) {
    return r && n(r, i, e);
  }
  return _5 = t, _5;
}
var O5, VD;
function f1e() {
  if (VD) return O5;
  VD = 1;
  var n = c1();
  function e(t, r) {
    return function(i, s) {
      if (i == null)
        return i;
      if (!n(i))
        return t(i, s);
      for (var o = i.length, a = r ? o : -1, l = Object(i); (r ? a-- : ++a < o) && s(l[a], a, l) !== !1; )
        ;
      return i;
    };
  }
  return O5 = e, O5;
}
var I5, jD;
function sM() {
  if (jD) return I5;
  jD = 1;
  var n = FK(), e = f1e(), t = e(n);
  return I5 = t, I5;
}
var R5, WD;
function BK() {
  if (WD) return R5;
  WD = 1;
  var n = sM(), e = c1();
  function t(r, i) {
    var s = -1, o = e(r) ? Array(r.length) : [];
    return n(r, function(a, l, c) {
      o[++s] = i(a, l, c);
    }), o;
  }
  return R5 = t, R5;
}
var P5, GD;
function h1e() {
  if (GD) return P5;
  GD = 1;
  function n(e, t) {
    var r = e.length;
    for (e.sort(t); r--; )
      e[r] = e[r].value;
    return e;
  }
  return P5 = n, P5;
}
var D5, KD;
function p1e() {
  if (KD) return D5;
  KD = 1;
  var n = xh();
  function e(t, r) {
    if (t !== r) {
      var i = t !== void 0, s = t === null, o = t === t, a = n(t), l = r !== void 0, c = r === null, u = r === r, d = n(r);
      if (!c && !d && !a && t > r || a && l && u && !c && !d || s && l && u || !i && u || !o)
        return 1;
      if (!s && !a && !d && t < r || d && i && o && !s && !a || c && i && o || !l && o || !u)
        return -1;
    }
    return 0;
  }
  return D5 = e, D5;
}
var N5, qD;
function m1e() {
  if (qD) return N5;
  qD = 1;
  var n = p1e();
  function e(t, r, i) {
    for (var s = -1, o = t.criteria, a = r.criteria, l = o.length, c = i.length; ++s < l; ) {
      var u = n(o[s], a[s]);
      if (u) {
        if (s >= c)
          return u;
        var d = i[s];
        return u * (d == "desc" ? -1 : 1);
      }
    }
    return t.index - r.index;
  }
  return N5 = e, N5;
}
var L5, YD;
function g1e() {
  if (YD) return L5;
  YD = 1;
  var n = WA(), e = GA(), t = Tc(), r = BK(), i = h1e(), s = MK(), o = m1e(), a = Ch(), l = Gi();
  function c(u, d, f) {
    d.length ? d = n(d, function(g) {
      return l(g) ? function(v) {
        return e(v, g.length === 1 ? g[0] : g);
      } : g;
    }) : d = [a];
    var h = -1;
    d = n(d, s(t));
    var m = r(u, function(g, v, y) {
      var b = n(d, function(x) {
        return x(g);
      });
      return { criteria: b, index: ++h, value: g };
    });
    return i(m, function(g, v) {
      return o(g, v, f);
    });
  }
  return L5 = c, L5;
}
var $5, XD;
function v1e() {
  if (XD) return $5;
  XD = 1;
  function n(e, t, r) {
    switch (r.length) {
      case 0:
        return e.call(t);
      case 1:
        return e.call(t, r[0]);
      case 2:
        return e.call(t, r[0], r[1]);
      case 3:
        return e.call(t, r[0], r[1], r[2]);
    }
    return e.apply(t, r);
  }
  return $5 = n, $5;
}
var F5, ZD;
function y1e() {
  if (ZD) return F5;
  ZD = 1;
  var n = v1e(), e = Math.max;
  function t(r, i, s) {
    return i = e(i === void 0 ? r.length - 1 : i, 0), function() {
      for (var o = arguments, a = -1, l = e(o.length - i, 0), c = Array(l); ++a < l; )
        c[a] = o[i + a];
      a = -1;
      for (var u = Array(i + 1); ++a < i; )
        u[a] = o[a];
      return u[i] = s(c), n(r, this, u);
    };
  }
  return F5 = t, F5;
}
var B5, QD;
function b1e() {
  if (QD) return B5;
  QD = 1;
  function n(e) {
    return function() {
      return e;
    };
  }
  return B5 = n, B5;
}
var z5, JD;
function zK() {
  if (JD) return z5;
  JD = 1;
  var n = ed(), e = (function() {
    try {
      var t = n(Object, "defineProperty");
      return t({}, "", {}), t;
    } catch {
    }
  })();
  return z5 = e, z5;
}
var H5, eN;
function w1e() {
  if (eN) return H5;
  eN = 1;
  var n = b1e(), e = zK(), t = Ch(), r = e ? function(i, s) {
    return e(i, "toString", {
      configurable: !0,
      enumerable: !1,
      value: n(s),
      writable: !0
    });
  } : t;
  return H5 = r, H5;
}
var U5, tN;
function x1e() {
  if (tN) return U5;
  tN = 1;
  var n = 800, e = 16, t = Date.now;
  function r(i) {
    var s = 0, o = 0;
    return function() {
      var a = t(), l = e - (a - o);
      if (o = a, l > 0) {
        if (++s >= n)
          return arguments[0];
      } else
        s = 0;
      return i.apply(void 0, arguments);
    };
  }
  return U5 = r, U5;
}
var V5, nN;
function E1e() {
  if (nN) return V5;
  nN = 1;
  var n = w1e(), e = x1e(), t = e(n);
  return V5 = t, V5;
}
var j5, rN;
function S1e() {
  if (rN) return j5;
  rN = 1;
  var n = Ch(), e = y1e(), t = E1e();
  function r(i, s) {
    return t(e(i, s, n), i + "");
  }
  return j5 = r, j5;
}
var W5, iN;
function Pw() {
  if (iN) return W5;
  iN = 1;
  var n = UA(), e = c1(), t = nM(), r = Cc();
  function i(s, o, a) {
    if (!r(a))
      return !1;
    var l = typeof o;
    return (l == "number" ? e(a) && t(o, a.length) : l == "string" && o in a) ? n(a[o], s) : !1;
  }
  return W5 = i, W5;
}
var G5, sN;
function C1e() {
  if (sN) return G5;
  sN = 1;
  var n = $K(), e = g1e(), t = S1e(), r = Pw(), i = t(function(s, o) {
    if (s == null)
      return [];
    var a = o.length;
    return a > 1 && r(s, o[0], o[1]) ? o = [] : a > 2 && r(o[0], o[1], o[2]) && (o = [o[0]]), e(s, n(o, 1), []);
  });
  return G5 = i, G5;
}
var T1e = C1e();
const oM = /* @__PURE__ */ nn(T1e);
function bm(n) {
  "@babel/helpers - typeof";
  return bm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, bm(n);
}
function kC() {
  return kC = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, kC.apply(this, arguments);
}
function A1e(n, e) {
  return O1e(n) || _1e(n, e) || k1e(n, e) || M1e();
}
function M1e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function k1e(n, e) {
  if (n) {
    if (typeof n == "string") return oN(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return oN(n, e);
  }
}
function oN(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function _1e(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r, i, s, o, a = [], l = !0, c = !1;
    try {
      if (s = (t = t.call(n)).next, e !== 0) for (; !(l = (r = s.call(t)).done) && (a.push(r.value), a.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && t.return != null && (o = t.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return a;
  }
}
function O1e(n) {
  if (Array.isArray(n)) return n;
}
function aN(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function K5(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? aN(Object(t), !0).forEach(function(r) {
      I1e(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : aN(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function I1e(n, e, t) {
  return e = R1e(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function R1e(n) {
  var e = P1e(n, "string");
  return bm(e) == "symbol" ? e : e + "";
}
function P1e(n, e) {
  if (bm(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (bm(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function D1e(n) {
  return Array.isArray(n) && Sr(n[0]) && Sr(n[1]) ? n.join(" ~ ") : n;
}
var N1e = function(e) {
  var t = e.separator, r = t === void 0 ? " : " : t, i = e.contentStyle, s = i === void 0 ? {} : i, o = e.itemStyle, a = o === void 0 ? {} : o, l = e.labelStyle, c = l === void 0 ? {} : l, u = e.payload, d = e.formatter, f = e.itemSorter, h = e.wrapperClassName, m = e.labelClassName, g = e.label, v = e.labelFormatter, y = e.accessibilityLayer, b = y === void 0 ? !1 : y, x = function() {
    if (u && u.length) {
      var I = {
        padding: 0,
        margin: 0
      }, R = (f ? oM(u, f) : u).map(function(P, D) {
        if (P.type === "none")
          return null;
        var L = K5({
          display: "block",
          paddingTop: 4,
          paddingBottom: 4,
          color: P.color || "#000"
        }, a), B = P.formatter || d || D1e, $ = P.value, z = P.name, H = $, U = z;
        if (B && H != null && U != null) {
          var F = B($, z, P, D, u);
          if (Array.isArray(F)) {
            var V = A1e(F, 2);
            H = V[0], U = V[1];
          } else
            H = F;
        }
        return (
          // eslint-disable-next-line react/no-array-index-key
          /* @__PURE__ */ p.createElement("li", {
            className: "recharts-tooltip-item",
            key: "tooltip-item-".concat(D),
            style: L
          }, Sr(U) ? /* @__PURE__ */ p.createElement("span", {
            className: "recharts-tooltip-item-name"
          }, U) : null, Sr(U) ? /* @__PURE__ */ p.createElement("span", {
            className: "recharts-tooltip-item-separator"
          }, r) : null, /* @__PURE__ */ p.createElement("span", {
            className: "recharts-tooltip-item-value"
          }, H), /* @__PURE__ */ p.createElement("span", {
            className: "recharts-tooltip-item-unit"
          }, P.unit || ""))
        );
      });
      return /* @__PURE__ */ p.createElement("ul", {
        className: "recharts-tooltip-item-list",
        style: I
      }, R);
    }
    return null;
  }, E = K5({
    margin: 0,
    padding: 10,
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    whiteSpace: "nowrap"
  }, s), w = K5({
    margin: 0
  }, c), C = !Bt(g), S = C ? g : "", M = Ut("recharts-default-tooltip", h), k = Ut("recharts-tooltip-label", m);
  C && v && u !== void 0 && u !== null && (S = v(g, u));
  var _ = b ? {
    role: "status",
    "aria-live": "assertive"
  } : {};
  return /* @__PURE__ */ p.createElement("div", kC({
    className: M,
    style: E
  }, _), /* @__PURE__ */ p.createElement("p", {
    className: k,
    style: w
  }, /* @__PURE__ */ p.isValidElement(S) ? S : "".concat(S)), x());
};
function wm(n) {
  "@babel/helpers - typeof";
  return wm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, wm(n);
}
function ag(n, e, t) {
  return e = L1e(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function L1e(n) {
  var e = $1e(n, "string");
  return wm(e) == "symbol" ? e : e + "";
}
function $1e(n, e) {
  if (wm(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (wm(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
var Zh = "recharts-tooltip-wrapper", F1e = {
  visibility: "hidden"
};
function B1e(n) {
  var e = n.coordinate, t = n.translateX, r = n.translateY;
  return Ut(Zh, ag(ag(ag(ag({}, "".concat(Zh, "-right"), ke(t) && e && ke(e.x) && t >= e.x), "".concat(Zh, "-left"), ke(t) && e && ke(e.x) && t < e.x), "".concat(Zh, "-bottom"), ke(r) && e && ke(e.y) && r >= e.y), "".concat(Zh, "-top"), ke(r) && e && ke(e.y) && r < e.y));
}
function lN(n) {
  var e = n.allowEscapeViewBox, t = n.coordinate, r = n.key, i = n.offsetTopLeft, s = n.position, o = n.reverseDirection, a = n.tooltipDimension, l = n.viewBox, c = n.viewBoxDimension;
  if (s && ke(s[r]))
    return s[r];
  var u = t[r] - a - i, d = t[r] + i;
  if (e[r])
    return o[r] ? u : d;
  if (o[r]) {
    var f = u, h = l[r];
    return f < h ? Math.max(d, l[r]) : Math.max(u, l[r]);
  }
  var m = d + a, g = l[r] + c;
  return m > g ? Math.max(u, l[r]) : Math.max(d, l[r]);
}
function z1e(n) {
  var e = n.translateX, t = n.translateY, r = n.useTranslate3d;
  return {
    transform: r ? "translate3d(".concat(e, "px, ").concat(t, "px, 0)") : "translate(".concat(e, "px, ").concat(t, "px)")
  };
}
function H1e(n) {
  var e = n.allowEscapeViewBox, t = n.coordinate, r = n.offsetTopLeft, i = n.position, s = n.reverseDirection, o = n.tooltipBox, a = n.useTranslate3d, l = n.viewBox, c, u, d;
  return o.height > 0 && o.width > 0 && t ? (u = lN({
    allowEscapeViewBox: e,
    coordinate: t,
    key: "x",
    offsetTopLeft: r,
    position: i,
    reverseDirection: s,
    tooltipDimension: o.width,
    viewBox: l,
    viewBoxDimension: l.width
  }), d = lN({
    allowEscapeViewBox: e,
    coordinate: t,
    key: "y",
    offsetTopLeft: r,
    position: i,
    reverseDirection: s,
    tooltipDimension: o.height,
    viewBox: l,
    viewBoxDimension: l.height
  }), c = z1e({
    translateX: u,
    translateY: d,
    useTranslate3d: a
  })) : c = F1e, {
    cssProperties: c,
    cssClasses: B1e({
      translateX: u,
      translateY: d,
      coordinate: t
    })
  };
}
function Af(n) {
  "@babel/helpers - typeof";
  return Af = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Af(n);
}
function cN(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function uN(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? cN(Object(t), !0).forEach(function(r) {
      OC(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : cN(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function U1e(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function V1e(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, UK(r.key), r);
  }
}
function j1e(n, e, t) {
  return e && V1e(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function W1e(n, e, t) {
  return e = k2(e), G1e(n, HK() ? Reflect.construct(e, t || [], k2(n).constructor) : e.apply(n, t));
}
function G1e(n, e) {
  if (e && (Af(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return K1e(n);
}
function K1e(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function HK() {
  try {
    var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (HK = function() {
    return !!n;
  })();
}
function k2(n) {
  return k2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, k2(n);
}
function q1e(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && _C(n, e);
}
function _C(n, e) {
  return _C = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, _C(n, e);
}
function OC(n, e, t) {
  return e = UK(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function UK(n) {
  var e = Y1e(n, "string");
  return Af(e) == "symbol" ? e : e + "";
}
function Y1e(n, e) {
  if (Af(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Af(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
var dN = 1, X1e = /* @__PURE__ */ (function(n) {
  function e() {
    var t;
    U1e(this, e);
    for (var r = arguments.length, i = new Array(r), s = 0; s < r; s++)
      i[s] = arguments[s];
    return t = W1e(this, e, [].concat(i)), OC(t, "state", {
      dismissed: !1,
      dismissedAtCoordinate: {
        x: 0,
        y: 0
      },
      lastBoundingBox: {
        width: -1,
        height: -1
      }
    }), OC(t, "handleKeyDown", function(o) {
      if (o.key === "Escape") {
        var a, l, c, u;
        t.setState({
          dismissed: !0,
          dismissedAtCoordinate: {
            x: (a = (l = t.props.coordinate) === null || l === void 0 ? void 0 : l.x) !== null && a !== void 0 ? a : 0,
            y: (c = (u = t.props.coordinate) === null || u === void 0 ? void 0 : u.y) !== null && c !== void 0 ? c : 0
          }
        });
      }
    }), t;
  }
  return q1e(e, n), j1e(e, [{
    key: "updateBBox",
    value: function() {
      if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
        var r = this.wrapperNode.getBoundingClientRect();
        (Math.abs(r.width - this.state.lastBoundingBox.width) > dN || Math.abs(r.height - this.state.lastBoundingBox.height) > dN) && this.setState({
          lastBoundingBox: {
            width: r.width,
            height: r.height
          }
        });
      } else (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) && this.setState({
        lastBoundingBox: {
          width: -1,
          height: -1
        }
      });
    }
  }, {
    key: "componentDidMount",
    value: function() {
      document.addEventListener("keydown", this.handleKeyDown), this.updateBBox();
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }
  }, {
    key: "componentDidUpdate",
    value: function() {
      var r, i;
      this.props.active && this.updateBBox(), this.state.dismissed && (((r = this.props.coordinate) === null || r === void 0 ? void 0 : r.x) !== this.state.dismissedAtCoordinate.x || ((i = this.props.coordinate) === null || i === void 0 ? void 0 : i.y) !== this.state.dismissedAtCoordinate.y) && (this.state.dismissed = !1);
    }
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, s = i.active, o = i.allowEscapeViewBox, a = i.animationDuration, l = i.animationEasing, c = i.children, u = i.coordinate, d = i.hasPayload, f = i.isAnimationActive, h = i.offset, m = i.position, g = i.reverseDirection, v = i.useTranslate3d, y = i.viewBox, b = i.wrapperStyle, x = H1e({
        allowEscapeViewBox: o,
        coordinate: u,
        offsetTopLeft: h,
        position: m,
        reverseDirection: g,
        tooltipBox: this.state.lastBoundingBox,
        useTranslate3d: v,
        viewBox: y
      }), E = x.cssClasses, w = x.cssProperties, C = uN(uN({
        transition: f && s ? "transform ".concat(a, "ms ").concat(l) : void 0
      }, w), {}, {
        pointerEvents: "none",
        visibility: !this.state.dismissed && s && d ? "visible" : "hidden",
        position: "absolute",
        top: 0,
        left: 0
      }, b);
      return (
        // This element allow listening to the `Escape` key.
        // See https://github.com/recharts/recharts/pull/2925
        /* @__PURE__ */ p.createElement("div", {
          tabIndex: -1,
          className: E,
          style: C,
          ref: function(M) {
            r.wrapperNode = M;
          }
        }, c)
      );
    }
  }]);
})(Sc), Z1e = function() {
  return !(typeof window < "u" && window.document && window.document.createElement && window.setTimeout);
}, Th = {
  isSsr: Z1e()
};
function Mf(n) {
  "@babel/helpers - typeof";
  return Mf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Mf(n);
}
function fN(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function hN(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? fN(Object(t), !0).forEach(function(r) {
      aM(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : fN(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function Q1e(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function J1e(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, jK(r.key), r);
  }
}
function ege(n, e, t) {
  return e && J1e(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function tge(n, e, t) {
  return e = _2(e), nge(n, VK() ? Reflect.construct(e, t || [], _2(n).constructor) : e.apply(n, t));
}
function nge(n, e) {
  if (e && (Mf(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return rge(n);
}
function rge(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function VK() {
  try {
    var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (VK = function() {
    return !!n;
  })();
}
function _2(n) {
  return _2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _2(n);
}
function ige(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && IC(n, e);
}
function IC(n, e) {
  return IC = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, IC(n, e);
}
function aM(n, e, t) {
  return e = jK(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function jK(n) {
  var e = sge(n, "string");
  return Mf(e) == "symbol" ? e : e + "";
}
function sge(n, e) {
  if (Mf(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Mf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
function oge(n) {
  return n.dataKey;
}
function age(n, e) {
  return /* @__PURE__ */ p.isValidElement(n) ? /* @__PURE__ */ p.cloneElement(n, e) : typeof n == "function" ? /* @__PURE__ */ p.createElement(n, e) : /* @__PURE__ */ p.createElement(N1e, e);
}
var Yo = /* @__PURE__ */ (function(n) {
  function e() {
    return Q1e(this, e), tge(this, e, arguments);
  }
  return ige(e, n), ege(e, [{
    key: "render",
    value: function() {
      var r = this, i = this.props, s = i.active, o = i.allowEscapeViewBox, a = i.animationDuration, l = i.animationEasing, c = i.content, u = i.coordinate, d = i.filterNull, f = i.isAnimationActive, h = i.offset, m = i.payload, g = i.payloadUniqBy, v = i.position, y = i.reverseDirection, b = i.useTranslate3d, x = i.viewBox, E = i.wrapperStyle, w = m ?? [];
      d && w.length && (w = DK(m.filter(function(S) {
        return S.value != null && (S.hide !== !0 || r.props.includeHidden);
      }), g, oge));
      var C = w.length > 0;
      return /* @__PURE__ */ p.createElement(X1e, {
        allowEscapeViewBox: o,
        animationDuration: a,
        animationEasing: l,
        isAnimationActive: f,
        active: s,
        coordinate: u,
        hasPayload: C,
        offset: h,
        position: v,
        reverseDirection: y,
        useTranslate3d: b,
        viewBox: x,
        wrapperStyle: E
      }, age(c, hN(hN({}, this.props), {}, {
        payload: w
      })));
    }
  }]);
})(Sc);
aM(Yo, "displayName", "Tooltip");
aM(Yo, "defaultProps", {
  accessibilityLayer: !1,
  allowEscapeViewBox: {
    x: !1,
    y: !1
  },
  animationDuration: 400,
  animationEasing: "ease",
  contentStyle: {},
  coordinate: {
    x: 0,
    y: 0
  },
  cursor: !0,
  cursorStyle: {},
  filterNull: !0,
  isAnimationActive: !Th.isSsr,
  itemStyle: {},
  labelStyle: {},
  offset: 10,
  reverseDirection: {
    x: !1,
    y: !1
  },
  separator: " : ",
  trigger: "hover",
  useTranslate3d: !1,
  viewBox: {
    x: 0,
    y: 0,
    height: 0,
    width: 0
  },
  wrapperStyle: {}
});
var q5, pN;
function lge() {
  if (pN) return q5;
  pN = 1;
  var n = Sa(), e = function() {
    return n.Date.now();
  };
  return q5 = e, q5;
}
var Y5, mN;
function cge() {
  if (mN) return Y5;
  mN = 1;
  var n = /\s/;
  function e(t) {
    for (var r = t.length; r-- && n.test(t.charAt(r)); )
      ;
    return r;
  }
  return Y5 = e, Y5;
}
var X5, gN;
function uge() {
  if (gN) return X5;
  gN = 1;
  var n = cge(), e = /^\s+/;
  function t(r) {
    return r && r.slice(0, n(r) + 1).replace(e, "");
  }
  return X5 = t, X5;
}
var Z5, vN;
function WK() {
  if (vN) return Z5;
  vN = 1;
  var n = uge(), e = Cc(), t = xh(), r = NaN, i = /^[-+]0x[0-9a-f]+$/i, s = /^0b[01]+$/i, o = /^0o[0-7]+$/i, a = parseInt;
  function l(c) {
    if (typeof c == "number")
      return c;
    if (t(c))
      return r;
    if (e(c)) {
      var u = typeof c.valueOf == "function" ? c.valueOf() : c;
      c = e(u) ? u + "" : u;
    }
    if (typeof c != "string")
      return c === 0 ? c : +c;
    c = n(c);
    var d = s.test(c);
    return d || o.test(c) ? a(c.slice(2), d ? 2 : 8) : i.test(c) ? r : +c;
  }
  return Z5 = l, Z5;
}
var Q5, yN;
function dge() {
  if (yN) return Q5;
  yN = 1;
  var n = Cc(), e = lge(), t = WK(), r = "Expected a function", i = Math.max, s = Math.min;
  function o(a, l, c) {
    var u, d, f, h, m, g, v = 0, y = !1, b = !1, x = !0;
    if (typeof a != "function")
      throw new TypeError(r);
    l = t(l) || 0, n(c) && (y = !!c.leading, b = "maxWait" in c, f = b ? i(t(c.maxWait) || 0, l) : f, x = "trailing" in c ? !!c.trailing : x);
    function E(R) {
      var P = u, D = d;
      return u = d = void 0, v = R, h = a.apply(D, P), h;
    }
    function w(R) {
      return v = R, m = setTimeout(M, l), y ? E(R) : h;
    }
    function C(R) {
      var P = R - g, D = R - v, L = l - P;
      return b ? s(L, f - D) : L;
    }
    function S(R) {
      var P = R - g, D = R - v;
      return g === void 0 || P >= l || P < 0 || b && D >= f;
    }
    function M() {
      var R = e();
      if (S(R))
        return k(R);
      m = setTimeout(M, C(R));
    }
    function k(R) {
      return m = void 0, x && u ? E(R) : (u = d = void 0, h);
    }
    function _() {
      m !== void 0 && clearTimeout(m), v = 0, u = g = d = m = void 0;
    }
    function O() {
      return m === void 0 ? h : k(e());
    }
    function I() {
      var R = e(), P = S(R);
      if (u = arguments, d = this, g = R, P) {
        if (m === void 0)
          return w(g);
        if (b)
          return clearTimeout(m), m = setTimeout(M, l), E(g);
      }
      return m === void 0 && (m = setTimeout(M, l)), h;
    }
    return I.cancel = _, I.flush = O, I;
  }
  return Q5 = o, Q5;
}
var J5, bN;
function fge() {
  if (bN) return J5;
  bN = 1;
  var n = dge(), e = Cc(), t = "Expected a function";
  function r(i, s, o) {
    var a = !0, l = !0;
    if (typeof i != "function")
      throw new TypeError(t);
    return e(o) && (a = "leading" in o ? !!o.leading : a, l = "trailing" in o ? !!o.trailing : l), n(i, s, {
      leading: a,
      maxWait: s,
      trailing: l
    });
  }
  return J5 = r, J5;
}
var hge = fge();
const GK = /* @__PURE__ */ nn(hge);
function xm(n) {
  "@babel/helpers - typeof";
  return xm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, xm(n);
}
function wN(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function lg(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? wN(Object(t), !0).forEach(function(r) {
      pge(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : wN(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function pge(n, e, t) {
  return e = mge(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function mge(n) {
  var e = gge(n, "string");
  return xm(e) == "symbol" ? e : e + "";
}
function gge(n, e) {
  if (xm(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (xm(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function vge(n, e) {
  return xge(n) || wge(n, e) || bge(n, e) || yge();
}
function yge() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function bge(n, e) {
  if (n) {
    if (typeof n == "string") return xN(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return xN(n, e);
  }
}
function xN(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function wge(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r, i, s, o, a = [], l = !0, c = !1;
    try {
      if (s = (t = t.call(n)).next, e !== 0) for (; !(l = (r = s.call(t)).done) && (a.push(r.value), a.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && t.return != null && (o = t.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return a;
  }
}
function xge(n) {
  if (Array.isArray(n)) return n;
}
var Ege = /* @__PURE__ */ tn(function(n, e) {
  var t = n.aspect, r = n.initialDimension, i = r === void 0 ? {
    width: -1,
    height: -1
  } : r, s = n.width, o = s === void 0 ? "100%" : s, a = n.height, l = a === void 0 ? "100%" : a, c = n.minWidth, u = c === void 0 ? 0 : c, d = n.minHeight, f = n.maxHeight, h = n.children, m = n.debounce, g = m === void 0 ? 0 : m, v = n.id, y = n.className, b = n.onResize, x = n.style, E = x === void 0 ? {} : x, w = Gt(null), C = Gt();
  C.current = b, xG(e, function() {
    return Object.defineProperty(w.current, "current", {
      get: function() {
        return console.warn("The usage of ref.current.current is deprecated and will no longer be supported."), w.current;
      },
      configurable: !0
    });
  });
  var S = wt({
    containerWidth: i.width,
    containerHeight: i.height
  }), M = vge(S, 2), k = M[0], _ = M[1], O = Ft(function(R, P) {
    _(function(D) {
      var L = Math.round(R), B = Math.round(P);
      return D.containerWidth === L && D.containerHeight === B ? D : {
        containerWidth: L,
        containerHeight: B
      };
    });
  }, []);
  Tt(function() {
    var R = function(z) {
      var H, U = z[0].contentRect, F = U.width, V = U.height;
      O(F, V), (H = C.current) === null || H === void 0 || H.call(C, F, V);
    };
    g > 0 && (R = GK(R, g, {
      trailing: !0,
      leading: !1
    }));
    var P = new ResizeObserver(R), D = w.current.getBoundingClientRect(), L = D.width, B = D.height;
    return O(L, B), P.observe(w.current), function() {
      P.disconnect();
    };
  }, [O, g]);
  var I = ua(function() {
    var R = k.containerWidth, P = k.containerHeight;
    if (R < 0 || P < 0)
      return null;
    rl(iu(o) || iu(l), `The width(%s) and height(%s) are both fixed numbers,
       maybe you don't need to use a ResponsiveContainer.`, o, l), rl(!t || t > 0, "The aspect(%s) must be greater than zero.", t);
    var D = iu(o) ? R : o, L = iu(l) ? P : l;
    t && t > 0 && (D ? L = D / t : L && (D = L * t), f && L > f && (L = f)), rl(D > 0 || L > 0, `The width(%s) and height(%s) of chart should be greater than 0,
       please check the style of container, or the props width(%s) and height(%s),
       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the
       height and width.`, D, L, o, l, u, d, t);
    var B = !Array.isArray(h) && nl(h.type).endsWith("Chart");
    return p.Children.map(h, function($) {
      return /* @__PURE__ */ p.isValidElement($) ? /* @__PURE__ */ br($, lg({
        width: D,
        height: L
      }, B ? {
        style: lg({
          height: "100%",
          width: "100%",
          maxHeight: L,
          maxWidth: D
        }, $.props.style)
      } : {})) : $;
    });
  }, [t, h, l, f, d, u, k, o]);
  return /* @__PURE__ */ p.createElement("div", {
    id: v ? "".concat(v) : void 0,
    className: Ut("recharts-responsive-container", y),
    style: lg(lg({}, E), {}, {
      width: o,
      height: l,
      minWidth: u,
      minHeight: d,
      maxHeight: f
    }),
    ref: w
  }, I);
}), KK = function(e) {
  return null;
};
KK.displayName = "Cell";
function Em(n) {
  "@babel/helpers - typeof";
  return Em = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Em(n);
}
function EN(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function RC(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? EN(Object(t), !0).forEach(function(r) {
      Sge(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : EN(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function Sge(n, e, t) {
  return e = Cge(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function Cge(n) {
  var e = Tge(n, "string");
  return Em(e) == "symbol" ? e : e + "";
}
function Tge(n, e) {
  if (Em(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Em(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
var gd = {
  widthCache: {},
  cacheCount: 0
}, Age = 2e3, Mge = {
  position: "absolute",
  top: "-20000px",
  left: 0,
  padding: 0,
  margin: 0,
  border: "none",
  whiteSpace: "pre"
}, SN = "recharts_measurement_span";
function kge(n) {
  var e = RC({}, n);
  return Object.keys(e).forEach(function(t) {
    e[t] || delete e[t];
  }), e;
}
var Up = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (e == null || Th.isSsr)
    return {
      width: 0,
      height: 0
    };
  var r = kge(t), i = JSON.stringify({
    text: e,
    copyStyle: r
  });
  if (gd.widthCache[i])
    return gd.widthCache[i];
  try {
    var s = document.getElementById(SN);
    s || (s = document.createElement("span"), s.setAttribute("id", SN), s.setAttribute("aria-hidden", "true"), document.body.appendChild(s));
    var o = RC(RC({}, Mge), r);
    Object.assign(s.style, o), s.textContent = "".concat(e);
    var a = s.getBoundingClientRect(), l = {
      width: a.width,
      height: a.height
    };
    return gd.widthCache[i] = l, ++gd.cacheCount > Age && (gd.cacheCount = 0, gd.widthCache = {}), l;
  } catch {
    return {
      width: 0,
      height: 0
    };
  }
}, _ge = function(e) {
  return {
    top: e.top + window.scrollY - document.documentElement.clientTop,
    left: e.left + window.scrollX - document.documentElement.clientLeft
  };
};
function Sm(n) {
  "@babel/helpers - typeof";
  return Sm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Sm(n);
}
function O2(n, e) {
  return Pge(n) || Rge(n, e) || Ige(n, e) || Oge();
}
function Oge() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ige(n, e) {
  if (n) {
    if (typeof n == "string") return CN(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return CN(n, e);
  }
}
function CN(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function Rge(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r, i, s, o, a = [], l = !0, c = !1;
    try {
      if (s = (t = t.call(n)).next, e === 0) {
        if (Object(t) !== t) return;
        l = !1;
      } else for (; !(l = (r = s.call(t)).done) && (a.push(r.value), a.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && t.return != null && (o = t.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return a;
  }
}
function Pge(n) {
  if (Array.isArray(n)) return n;
}
function Dge(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function TN(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, Lge(r.key), r);
  }
}
function Nge(n, e, t) {
  return e && TN(n.prototype, e), t && TN(n, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function Lge(n) {
  var e = $ge(n, "string");
  return Sm(e) == "symbol" ? e : e + "";
}
function $ge(n, e) {
  if (Sm(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Sm(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
var AN = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, MN = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/, Fge = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/, Bge = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/, qK = {
  cm: 96 / 2.54,
  mm: 96 / 25.4,
  pt: 96 / 72,
  pc: 96 / 6,
  in: 96,
  Q: 96 / (2.54 * 40),
  px: 1
}, zge = Object.keys(qK), Gd = "NaN";
function Hge(n, e) {
  return n * qK[e];
}
var cg = /* @__PURE__ */ (function() {
  function n(e, t) {
    Dge(this, n), this.num = e, this.unit = t, this.num = e, this.unit = t, Number.isNaN(e) && (this.unit = ""), t !== "" && !Fge.test(t) && (this.num = NaN, this.unit = ""), zge.includes(t) && (this.num = Hge(e, t), this.unit = "px");
  }
  return Nge(n, [{
    key: "add",
    value: function(t) {
      return this.unit !== t.unit ? new n(NaN, "") : new n(this.num + t.num, this.unit);
    }
  }, {
    key: "subtract",
    value: function(t) {
      return this.unit !== t.unit ? new n(NaN, "") : new n(this.num - t.num, this.unit);
    }
  }, {
    key: "multiply",
    value: function(t) {
      return this.unit !== "" && t.unit !== "" && this.unit !== t.unit ? new n(NaN, "") : new n(this.num * t.num, this.unit || t.unit);
    }
  }, {
    key: "divide",
    value: function(t) {
      return this.unit !== "" && t.unit !== "" && this.unit !== t.unit ? new n(NaN, "") : new n(this.num / t.num, this.unit || t.unit);
    }
  }, {
    key: "toString",
    value: function() {
      return "".concat(this.num).concat(this.unit);
    }
  }, {
    key: "isNaN",
    value: function() {
      return Number.isNaN(this.num);
    }
  }], [{
    key: "parse",
    value: function(t) {
      var r, i = (r = Bge.exec(t)) !== null && r !== void 0 ? r : [], s = O2(i, 3), o = s[1], a = s[2];
      return new n(parseFloat(o), a ?? "");
    }
  }]);
})();
function YK(n) {
  if (n.includes(Gd))
    return Gd;
  for (var e = n; e.includes("*") || e.includes("/"); ) {
    var t, r = (t = AN.exec(e)) !== null && t !== void 0 ? t : [], i = O2(r, 4), s = i[1], o = i[2], a = i[3], l = cg.parse(s ?? ""), c = cg.parse(a ?? ""), u = o === "*" ? l.multiply(c) : l.divide(c);
    if (u.isNaN())
      return Gd;
    e = e.replace(AN, u.toString());
  }
  for (; e.includes("+") || /.-\d+(?:\.\d+)?/.test(e); ) {
    var d, f = (d = MN.exec(e)) !== null && d !== void 0 ? d : [], h = O2(f, 4), m = h[1], g = h[2], v = h[3], y = cg.parse(m ?? ""), b = cg.parse(v ?? ""), x = g === "+" ? y.add(b) : y.subtract(b);
    if (x.isNaN())
      return Gd;
    e = e.replace(MN, x.toString());
  }
  return e;
}
var kN = /\(([^()]*)\)/;
function Uge(n) {
  for (var e = n; e.includes("("); ) {
    var t = kN.exec(e), r = O2(t, 2), i = r[1];
    e = e.replace(kN, YK(i));
  }
  return e;
}
function Vge(n) {
  var e = n.replace(/\s+/g, "");
  return e = Uge(e), e = YK(e), e;
}
function jge(n) {
  try {
    return Vge(n);
  } catch {
    return Gd;
  }
}
function eS(n) {
  var e = jge(n.slice(5, -1));
  return e === Gd ? "" : e;
}
var Wge = ["x", "y", "lineHeight", "capHeight", "scaleToFit", "textAnchor", "verticalAnchor", "fill"], Gge = ["dx", "dy", "angle", "className", "breakAll"];
function PC() {
  return PC = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, PC.apply(this, arguments);
}
function _N(n, e) {
  if (n == null) return {};
  var t = Kge(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function Kge(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n)
    if (Object.prototype.hasOwnProperty.call(n, r)) {
      if (e.indexOf(r) >= 0) continue;
      t[r] = n[r];
    }
  return t;
}
function ON(n, e) {
  return Zge(n) || Xge(n, e) || Yge(n, e) || qge();
}
function qge() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Yge(n, e) {
  if (n) {
    if (typeof n == "string") return IN(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return IN(n, e);
  }
}
function IN(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function Xge(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r, i, s, o, a = [], l = !0, c = !1;
    try {
      if (s = (t = t.call(n)).next, e === 0) {
        if (Object(t) !== t) return;
        l = !1;
      } else for (; !(l = (r = s.call(t)).done) && (a.push(r.value), a.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && t.return != null && (o = t.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return a;
  }
}
function Zge(n) {
  if (Array.isArray(n)) return n;
}
var XK = /[ \f\n\r\t\v\u2028\u2029]+/, ZK = function(e) {
  var t = e.children, r = e.breakAll, i = e.style;
  try {
    var s = [];
    Bt(t) || (r ? s = t.toString().split("") : s = t.toString().split(XK));
    var o = s.map(function(l) {
      return {
        word: l,
        width: Up(l, i).width
      };
    }), a = r ? 0 : Up(" ", i).width;
    return {
      wordsWithComputedWidth: o,
      spaceWidth: a
    };
  } catch {
    return null;
  }
}, Qge = function(e, t, r, i, s) {
  var o = e.maxLines, a = e.children, l = e.style, c = e.breakAll, u = ke(o), d = a, f = function() {
    var D = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return D.reduce(function(L, B) {
      var $ = B.word, z = B.width, H = L[L.length - 1];
      if (H && (i == null || s || H.width + z + r < Number(i)))
        H.words.push($), H.width += z + r;
      else {
        var U = {
          words: [$],
          width: z
        };
        L.push(U);
      }
      return L;
    }, []);
  }, h = f(t), m = function(D) {
    return D.reduce(function(L, B) {
      return L.width > B.width ? L : B;
    });
  };
  if (!u)
    return h;
  for (var g = "…", v = function(D) {
    var L = d.slice(0, D), B = ZK({
      breakAll: c,
      style: l,
      children: L + g
    }).wordsWithComputedWidth, $ = f(B), z = $.length > o || m($).width > Number(i);
    return [z, $];
  }, y = 0, b = d.length - 1, x = 0, E; y <= b && x <= d.length - 1; ) {
    var w = Math.floor((y + b) / 2), C = w - 1, S = v(C), M = ON(S, 2), k = M[0], _ = M[1], O = v(w), I = ON(O, 1), R = I[0];
    if (!k && !R && (y = w + 1), k && R && (b = w - 1), !k && R) {
      E = _;
      break;
    }
    x++;
  }
  return E || h;
}, RN = function(e) {
  var t = Bt(e) ? [] : e.toString().split(XK);
  return [{
    words: t
  }];
}, Jge = function(e) {
  var t = e.width, r = e.scaleToFit, i = e.children, s = e.style, o = e.breakAll, a = e.maxLines;
  if ((t || r) && !Th.isSsr) {
    var l, c, u = ZK({
      breakAll: o,
      children: i,
      style: s
    });
    if (u) {
      var d = u.wordsWithComputedWidth, f = u.spaceWidth;
      l = d, c = f;
    } else
      return RN(i);
    return Qge({
      breakAll: o,
      children: i,
      maxLines: a,
      style: s
    }, l, c, t, r);
  }
  return RN(i);
}, PN = "#808080", I2 = function(e) {
  var t = e.x, r = t === void 0 ? 0 : t, i = e.y, s = i === void 0 ? 0 : i, o = e.lineHeight, a = o === void 0 ? "1em" : o, l = e.capHeight, c = l === void 0 ? "0.71em" : l, u = e.scaleToFit, d = u === void 0 ? !1 : u, f = e.textAnchor, h = f === void 0 ? "start" : f, m = e.verticalAnchor, g = m === void 0 ? "end" : m, v = e.fill, y = v === void 0 ? PN : v, b = _N(e, Wge), x = ua(function() {
    return Jge({
      breakAll: b.breakAll,
      children: b.children,
      maxLines: b.maxLines,
      scaleToFit: d,
      style: b.style,
      width: b.width
    });
  }, [b.breakAll, b.children, b.maxLines, d, b.style, b.width]), E = b.dx, w = b.dy, C = b.angle, S = b.className, M = b.breakAll, k = _N(b, Gge);
  if (!Sr(r) || !Sr(s))
    return null;
  var _ = r + (ke(E) ? E : 0), O = s + (ke(w) ? w : 0), I;
  switch (g) {
    case "start":
      I = eS("calc(".concat(c, ")"));
      break;
    case "middle":
      I = eS("calc(".concat((x.length - 1) / 2, " * -").concat(a, " + (").concat(c, " / 2))"));
      break;
    default:
      I = eS("calc(".concat(x.length - 1, " * -").concat(a, ")"));
      break;
  }
  var R = [];
  if (d) {
    var P = x[0].width, D = b.width;
    R.push("scale(".concat((ke(D) ? D / P : 1) / P, ")"));
  }
  return C && R.push("rotate(".concat(C, ", ").concat(_, ", ").concat(O, ")")), R.length && (k.transform = R.join(" ")), /* @__PURE__ */ p.createElement("text", PC({}, $t(k, !0), {
    x: _,
    y: O,
    className: Ut("recharts-text", S),
    textAnchor: h,
    fill: y.includes("url") ? PN : y
  }), x.map(function(L, B) {
    var $ = L.words.join(M ? "" : " ");
    return (
      // duplicate words will cause duplicate keys
      // eslint-disable-next-line react/no-array-index-key
      /* @__PURE__ */ p.createElement("tspan", {
        x: _,
        dy: B === 0 ? I : a,
        key: "".concat($, "-").concat(B)
      }, $)
    );
  }));
};
function ic(n, e) {
  return n == null || e == null ? NaN : n < e ? -1 : n > e ? 1 : n >= e ? 0 : NaN;
}
function eve(n, e) {
  return n == null || e == null ? NaN : e < n ? -1 : e > n ? 1 : e >= n ? 0 : NaN;
}
function lM(n) {
  let e, t, r;
  n.length !== 2 ? (e = ic, t = (a, l) => ic(n(a), l), r = (a, l) => n(a) - l) : (e = n === ic || n === eve ? n : tve, t = n, r = n);
  function i(a, l, c = 0, u = a.length) {
    if (c < u) {
      if (e(l, l) !== 0) return u;
      do {
        const d = c + u >>> 1;
        t(a[d], l) < 0 ? c = d + 1 : u = d;
      } while (c < u);
    }
    return c;
  }
  function s(a, l, c = 0, u = a.length) {
    if (c < u) {
      if (e(l, l) !== 0) return u;
      do {
        const d = c + u >>> 1;
        t(a[d], l) <= 0 ? c = d + 1 : u = d;
      } while (c < u);
    }
    return c;
  }
  function o(a, l, c = 0, u = a.length) {
    const d = i(a, l, c, u - 1);
    return d > c && r(a[d - 1], l) > -r(a[d], l) ? d - 1 : d;
  }
  return { left: i, center: o, right: s };
}
function tve() {
  return 0;
}
function QK(n) {
  return n === null ? NaN : +n;
}
function* nve(n, e) {
  for (let t of n)
    t != null && (t = +t) >= t && (yield t);
}
const rve = lM(ic), u1 = rve.right;
lM(QK).center;
class DN extends Map {
  constructor(e, t = ove) {
    if (super(), Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: t } }), e != null) for (const [r, i] of e) this.set(r, i);
  }
  get(e) {
    return super.get(NN(this, e));
  }
  has(e) {
    return super.has(NN(this, e));
  }
  set(e, t) {
    return super.set(ive(this, e), t);
  }
  delete(e) {
    return super.delete(sve(this, e));
  }
}
function NN({ _intern: n, _key: e }, t) {
  const r = e(t);
  return n.has(r) ? n.get(r) : t;
}
function ive({ _intern: n, _key: e }, t) {
  const r = e(t);
  return n.has(r) ? n.get(r) : (n.set(r, t), t);
}
function sve({ _intern: n, _key: e }, t) {
  const r = e(t);
  return n.has(r) && (t = n.get(r), n.delete(r)), t;
}
function ove(n) {
  return n !== null && typeof n == "object" ? n.valueOf() : n;
}
function ave(n = ic) {
  if (n === ic) return JK;
  if (typeof n != "function") throw new TypeError("compare is not a function");
  return (e, t) => {
    const r = n(e, t);
    return r || r === 0 ? r : (n(t, t) === 0) - (n(e, e) === 0);
  };
}
function JK(n, e) {
  return (n == null || !(n >= n)) - (e == null || !(e >= e)) || (n < e ? -1 : n > e ? 1 : 0);
}
const lve = Math.sqrt(50), cve = Math.sqrt(10), uve = Math.sqrt(2);
function R2(n, e, t) {
  const r = (e - n) / Math.max(0, t), i = Math.floor(Math.log10(r)), s = r / Math.pow(10, i), o = s >= lve ? 10 : s >= cve ? 5 : s >= uve ? 2 : 1;
  let a, l, c;
  return i < 0 ? (c = Math.pow(10, -i) / o, a = Math.round(n * c), l = Math.round(e * c), a / c < n && ++a, l / c > e && --l, c = -c) : (c = Math.pow(10, i) * o, a = Math.round(n / c), l = Math.round(e / c), a * c < n && ++a, l * c > e && --l), l < a && 0.5 <= t && t < 2 ? R2(n, e, t * 2) : [a, l, c];
}
function DC(n, e, t) {
  if (e = +e, n = +n, t = +t, !(t > 0)) return [];
  if (n === e) return [n];
  const r = e < n, [i, s, o] = r ? R2(e, n, t) : R2(n, e, t);
  if (!(s >= i)) return [];
  const a = s - i + 1, l = new Array(a);
  if (r)
    if (o < 0) for (let c = 0; c < a; ++c) l[c] = (s - c) / -o;
    else for (let c = 0; c < a; ++c) l[c] = (s - c) * o;
  else if (o < 0) for (let c = 0; c < a; ++c) l[c] = (i + c) / -o;
  else for (let c = 0; c < a; ++c) l[c] = (i + c) * o;
  return l;
}
function NC(n, e, t) {
  return e = +e, n = +n, t = +t, R2(n, e, t)[2];
}
function LC(n, e, t) {
  e = +e, n = +n, t = +t;
  const r = e < n, i = r ? NC(e, n, t) : NC(n, e, t);
  return (r ? -1 : 1) * (i < 0 ? 1 / -i : i);
}
function LN(n, e) {
  let t;
  for (const r of n)
    r != null && (t < r || t === void 0 && r >= r) && (t = r);
  return t;
}
function $N(n, e) {
  let t;
  for (const r of n)
    r != null && (t > r || t === void 0 && r >= r) && (t = r);
  return t;
}
function eq(n, e, t = 0, r = 1 / 0, i) {
  if (e = Math.floor(e), t = Math.floor(Math.max(0, t)), r = Math.floor(Math.min(n.length - 1, r)), !(t <= e && e <= r)) return n;
  for (i = i === void 0 ? JK : ave(i); r > t; ) {
    if (r - t > 600) {
      const l = r - t + 1, c = e - t + 1, u = Math.log(l), d = 0.5 * Math.exp(2 * u / 3), f = 0.5 * Math.sqrt(u * d * (l - d) / l) * (c - l / 2 < 0 ? -1 : 1), h = Math.max(t, Math.floor(e - c * d / l + f)), m = Math.min(r, Math.floor(e + (l - c) * d / l + f));
      eq(n, e, h, m, i);
    }
    const s = n[e];
    let o = t, a = r;
    for (Qh(n, t, e), i(n[r], s) > 0 && Qh(n, t, r); o < a; ) {
      for (Qh(n, o, a), ++o, --a; i(n[o], s) < 0; ) ++o;
      for (; i(n[a], s) > 0; ) --a;
    }
    i(n[t], s) === 0 ? Qh(n, t, a) : (++a, Qh(n, a, r)), a <= e && (t = a + 1), e <= a && (r = a - 1);
  }
  return n;
}
function Qh(n, e, t) {
  const r = n[e];
  n[e] = n[t], n[t] = r;
}
function dve(n, e, t) {
  if (n = Float64Array.from(nve(n)), !(!(r = n.length) || isNaN(e = +e))) {
    if (e <= 0 || r < 2) return $N(n);
    if (e >= 1) return LN(n);
    var r, i = (r - 1) * e, s = Math.floor(i), o = LN(eq(n, s).subarray(0, s + 1)), a = $N(n.subarray(s + 1));
    return o + (a - o) * (i - s);
  }
}
function fve(n, e, t = QK) {
  if (!(!(r = n.length) || isNaN(e = +e))) {
    if (e <= 0 || r < 2) return +t(n[0], 0, n);
    if (e >= 1) return +t(n[r - 1], r - 1, n);
    var r, i = (r - 1) * e, s = Math.floor(i), o = +t(n[s], s, n), a = +t(n[s + 1], s + 1, n);
    return o + (a - o) * (i - s);
  }
}
function hve(n, e, t) {
  n = +n, e = +e, t = (i = arguments.length) < 2 ? (e = n, n = 0, 1) : i < 3 ? 1 : +t;
  for (var r = -1, i = Math.max(0, Math.ceil((e - n) / t)) | 0, s = new Array(i); ++r < i; )
    s[r] = n + r * t;
  return s;
}
function Gs(n, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(n);
      break;
    default:
      this.range(e).domain(n);
      break;
  }
  return this;
}
function wl(n, e) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      typeof n == "function" ? this.interpolator(n) : this.range(n);
      break;
    }
    default: {
      this.domain(n), typeof e == "function" ? this.interpolator(e) : this.range(e);
      break;
    }
  }
  return this;
}
const $C = Symbol("implicit");
function cM() {
  var n = new DN(), e = [], t = [], r = $C;
  function i(s) {
    let o = n.get(s);
    if (o === void 0) {
      if (r !== $C) return r;
      n.set(s, o = e.push(s) - 1);
    }
    return t[o % t.length];
  }
  return i.domain = function(s) {
    if (!arguments.length) return e.slice();
    e = [], n = new DN();
    for (const o of s)
      n.has(o) || n.set(o, e.push(o) - 1);
    return i;
  }, i.range = function(s) {
    return arguments.length ? (t = Array.from(s), i) : t.slice();
  }, i.unknown = function(s) {
    return arguments.length ? (r = s, i) : r;
  }, i.copy = function() {
    return cM(e, t).unknown(r);
  }, Gs.apply(i, arguments), i;
}
function Cm() {
  var n = cM().unknown(void 0), e = n.domain, t = n.range, r = 0, i = 1, s, o, a = !1, l = 0, c = 0, u = 0.5;
  delete n.unknown;
  function d() {
    var f = e().length, h = i < r, m = h ? i : r, g = h ? r : i;
    s = (g - m) / Math.max(1, f - l + c * 2), a && (s = Math.floor(s)), m += (g - m - s * (f - l)) * u, o = s * (1 - l), a && (m = Math.round(m), o = Math.round(o));
    var v = hve(f).map(function(y) {
      return m + s * y;
    });
    return t(h ? v.reverse() : v);
  }
  return n.domain = function(f) {
    return arguments.length ? (e(f), d()) : e();
  }, n.range = function(f) {
    return arguments.length ? ([r, i] = f, r = +r, i = +i, d()) : [r, i];
  }, n.rangeRound = function(f) {
    return [r, i] = f, r = +r, i = +i, a = !0, d();
  }, n.bandwidth = function() {
    return o;
  }, n.step = function() {
    return s;
  }, n.round = function(f) {
    return arguments.length ? (a = !!f, d()) : a;
  }, n.padding = function(f) {
    return arguments.length ? (l = Math.min(1, c = +f), d()) : l;
  }, n.paddingInner = function(f) {
    return arguments.length ? (l = Math.min(1, f), d()) : l;
  }, n.paddingOuter = function(f) {
    return arguments.length ? (c = +f, d()) : c;
  }, n.align = function(f) {
    return arguments.length ? (u = Math.max(0, Math.min(1, f)), d()) : u;
  }, n.copy = function() {
    return Cm(e(), [r, i]).round(a).paddingInner(l).paddingOuter(c).align(u);
  }, Gs.apply(d(), arguments);
}
function tq(n) {
  var e = n.copy;
  return n.padding = n.paddingOuter, delete n.paddingInner, delete n.paddingOuter, n.copy = function() {
    return tq(e());
  }, n;
}
function Vp() {
  return tq(Cm.apply(null, arguments).paddingInner(1));
}
function uM(n, e, t) {
  n.prototype = e.prototype = t, t.constructor = n;
}
function nq(n, e) {
  var t = Object.create(n.prototype);
  for (var r in e) t[r] = e[r];
  return t;
}
function d1() {
}
var Tm = 0.7, P2 = 1 / Tm, sf = "\\s*([+-]?\\d+)\\s*", Am = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", da = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", pve = /^#([0-9a-f]{3,8})$/, mve = new RegExp(`^rgb\\(${sf},${sf},${sf}\\)$`), gve = new RegExp(`^rgb\\(${da},${da},${da}\\)$`), vve = new RegExp(`^rgba\\(${sf},${sf},${sf},${Am}\\)$`), yve = new RegExp(`^rgba\\(${da},${da},${da},${Am}\\)$`), bve = new RegExp(`^hsl\\(${Am},${da},${da}\\)$`), wve = new RegExp(`^hsla\\(${Am},${da},${da},${Am}\\)$`), FN = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
uM(d1, Mm, {
  copy(n) {
    return Object.assign(new this.constructor(), this, n);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: BN,
  // Deprecated! Use color.formatHex.
  formatHex: BN,
  formatHex8: xve,
  formatHsl: Eve,
  formatRgb: zN,
  toString: zN
});
function BN() {
  return this.rgb().formatHex();
}
function xve() {
  return this.rgb().formatHex8();
}
function Eve() {
  return rq(this).formatHsl();
}
function zN() {
  return this.rgb().formatRgb();
}
function Mm(n) {
  var e, t;
  return n = (n + "").trim().toLowerCase(), (e = pve.exec(n)) ? (t = e[1].length, e = parseInt(e[1], 16), t === 6 ? HN(e) : t === 3 ? new $i(e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, (e & 15) << 4 | e & 15, 1) : t === 8 ? ug(e >> 24 & 255, e >> 16 & 255, e >> 8 & 255, (e & 255) / 255) : t === 4 ? ug(e >> 12 & 15 | e >> 8 & 240, e >> 8 & 15 | e >> 4 & 240, e >> 4 & 15 | e & 240, ((e & 15) << 4 | e & 15) / 255) : null) : (e = mve.exec(n)) ? new $i(e[1], e[2], e[3], 1) : (e = gve.exec(n)) ? new $i(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, 1) : (e = vve.exec(n)) ? ug(e[1], e[2], e[3], e[4]) : (e = yve.exec(n)) ? ug(e[1] * 255 / 100, e[2] * 255 / 100, e[3] * 255 / 100, e[4]) : (e = bve.exec(n)) ? jN(e[1], e[2] / 100, e[3] / 100, 1) : (e = wve.exec(n)) ? jN(e[1], e[2] / 100, e[3] / 100, e[4]) : FN.hasOwnProperty(n) ? HN(FN[n]) : n === "transparent" ? new $i(NaN, NaN, NaN, 0) : null;
}
function HN(n) {
  return new $i(n >> 16 & 255, n >> 8 & 255, n & 255, 1);
}
function ug(n, e, t, r) {
  return r <= 0 && (n = e = t = NaN), new $i(n, e, t, r);
}
function Sve(n) {
  return n instanceof d1 || (n = Mm(n)), n ? (n = n.rgb(), new $i(n.r, n.g, n.b, n.opacity)) : new $i();
}
function FC(n, e, t, r) {
  return arguments.length === 1 ? Sve(n) : new $i(n, e, t, r ?? 1);
}
function $i(n, e, t, r) {
  this.r = +n, this.g = +e, this.b = +t, this.opacity = +r;
}
uM($i, FC, nq(d1, {
  brighter(n) {
    return n = n == null ? P2 : Math.pow(P2, n), new $i(this.r * n, this.g * n, this.b * n, this.opacity);
  },
  darker(n) {
    return n = n == null ? Tm : Math.pow(Tm, n), new $i(this.r * n, this.g * n, this.b * n, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new $i(bu(this.r), bu(this.g), bu(this.b), D2(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: UN,
  // Deprecated! Use color.formatHex.
  formatHex: UN,
  formatHex8: Cve,
  formatRgb: VN,
  toString: VN
}));
function UN() {
  return `#${su(this.r)}${su(this.g)}${su(this.b)}`;
}
function Cve() {
  return `#${su(this.r)}${su(this.g)}${su(this.b)}${su((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function VN() {
  const n = D2(this.opacity);
  return `${n === 1 ? "rgb(" : "rgba("}${bu(this.r)}, ${bu(this.g)}, ${bu(this.b)}${n === 1 ? ")" : `, ${n})`}`;
}
function D2(n) {
  return isNaN(n) ? 1 : Math.max(0, Math.min(1, n));
}
function bu(n) {
  return Math.max(0, Math.min(255, Math.round(n) || 0));
}
function su(n) {
  return n = bu(n), (n < 16 ? "0" : "") + n.toString(16);
}
function jN(n, e, t, r) {
  return r <= 0 ? n = e = t = NaN : t <= 0 || t >= 1 ? n = e = NaN : e <= 0 && (n = NaN), new ao(n, e, t, r);
}
function rq(n) {
  if (n instanceof ao) return new ao(n.h, n.s, n.l, n.opacity);
  if (n instanceof d1 || (n = Mm(n)), !n) return new ao();
  if (n instanceof ao) return n;
  n = n.rgb();
  var e = n.r / 255, t = n.g / 255, r = n.b / 255, i = Math.min(e, t, r), s = Math.max(e, t, r), o = NaN, a = s - i, l = (s + i) / 2;
  return a ? (e === s ? o = (t - r) / a + (t < r) * 6 : t === s ? o = (r - e) / a + 2 : o = (e - t) / a + 4, a /= l < 0.5 ? s + i : 2 - s - i, o *= 60) : a = l > 0 && l < 1 ? 0 : o, new ao(o, a, l, n.opacity);
}
function Tve(n, e, t, r) {
  return arguments.length === 1 ? rq(n) : new ao(n, e, t, r ?? 1);
}
function ao(n, e, t, r) {
  this.h = +n, this.s = +e, this.l = +t, this.opacity = +r;
}
uM(ao, Tve, nq(d1, {
  brighter(n) {
    return n = n == null ? P2 : Math.pow(P2, n), new ao(this.h, this.s, this.l * n, this.opacity);
  },
  darker(n) {
    return n = n == null ? Tm : Math.pow(Tm, n), new ao(this.h, this.s, this.l * n, this.opacity);
  },
  rgb() {
    var n = this.h % 360 + (this.h < 0) * 360, e = isNaN(n) || isNaN(this.s) ? 0 : this.s, t = this.l, r = t + (t < 0.5 ? t : 1 - t) * e, i = 2 * t - r;
    return new $i(
      tS(n >= 240 ? n - 240 : n + 120, i, r),
      tS(n, i, r),
      tS(n < 120 ? n + 240 : n - 120, i, r),
      this.opacity
    );
  },
  clamp() {
    return new ao(WN(this.h), dg(this.s), dg(this.l), D2(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const n = D2(this.opacity);
    return `${n === 1 ? "hsl(" : "hsla("}${WN(this.h)}, ${dg(this.s) * 100}%, ${dg(this.l) * 100}%${n === 1 ? ")" : `, ${n})`}`;
  }
}));
function WN(n) {
  return n = (n || 0) % 360, n < 0 ? n + 360 : n;
}
function dg(n) {
  return Math.max(0, Math.min(1, n || 0));
}
function tS(n, e, t) {
  return (n < 60 ? e + (t - e) * n / 60 : n < 180 ? t : n < 240 ? e + (t - e) * (240 - n) / 60 : e) * 255;
}
const dM = (n) => () => n;
function Ave(n, e) {
  return function(t) {
    return n + t * e;
  };
}
function Mve(n, e, t) {
  return n = Math.pow(n, t), e = Math.pow(e, t) - n, t = 1 / t, function(r) {
    return Math.pow(n + r * e, t);
  };
}
function kve(n) {
  return (n = +n) == 1 ? iq : function(e, t) {
    return t - e ? Mve(e, t, n) : dM(isNaN(e) ? t : e);
  };
}
function iq(n, e) {
  var t = e - n;
  return t ? Ave(n, t) : dM(isNaN(n) ? e : n);
}
const GN = (function n(e) {
  var t = kve(e);
  function r(i, s) {
    var o = t((i = FC(i)).r, (s = FC(s)).r), a = t(i.g, s.g), l = t(i.b, s.b), c = iq(i.opacity, s.opacity);
    return function(u) {
      return i.r = o(u), i.g = a(u), i.b = l(u), i.opacity = c(u), i + "";
    };
  }
  return r.gamma = n, r;
})(1);
function _ve(n, e) {
  e || (e = []);
  var t = n ? Math.min(e.length, n.length) : 0, r = e.slice(), i;
  return function(s) {
    for (i = 0; i < t; ++i) r[i] = n[i] * (1 - s) + e[i] * s;
    return r;
  };
}
function Ove(n) {
  return ArrayBuffer.isView(n) && !(n instanceof DataView);
}
function Ive(n, e) {
  var t = e ? e.length : 0, r = n ? Math.min(t, n.length) : 0, i = new Array(r), s = new Array(t), o;
  for (o = 0; o < r; ++o) i[o] = Ah(n[o], e[o]);
  for (; o < t; ++o) s[o] = e[o];
  return function(a) {
    for (o = 0; o < r; ++o) s[o] = i[o](a);
    return s;
  };
}
function Rve(n, e) {
  var t = /* @__PURE__ */ new Date();
  return n = +n, e = +e, function(r) {
    return t.setTime(n * (1 - r) + e * r), t;
  };
}
function N2(n, e) {
  return n = +n, e = +e, function(t) {
    return n * (1 - t) + e * t;
  };
}
function Pve(n, e) {
  var t = {}, r = {}, i;
  (n === null || typeof n != "object") && (n = {}), (e === null || typeof e != "object") && (e = {});
  for (i in e)
    i in n ? t[i] = Ah(n[i], e[i]) : r[i] = e[i];
  return function(s) {
    for (i in t) r[i] = t[i](s);
    return r;
  };
}
var BC = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, nS = new RegExp(BC.source, "g");
function Dve(n) {
  return function() {
    return n;
  };
}
function Nve(n) {
  return function(e) {
    return n(e) + "";
  };
}
function Lve(n, e) {
  var t = BC.lastIndex = nS.lastIndex = 0, r, i, s, o = -1, a = [], l = [];
  for (n = n + "", e = e + ""; (r = BC.exec(n)) && (i = nS.exec(e)); )
    (s = i.index) > t && (s = e.slice(t, s), a[o] ? a[o] += s : a[++o] = s), (r = r[0]) === (i = i[0]) ? a[o] ? a[o] += i : a[++o] = i : (a[++o] = null, l.push({ i: o, x: N2(r, i) })), t = nS.lastIndex;
  return t < e.length && (s = e.slice(t), a[o] ? a[o] += s : a[++o] = s), a.length < 2 ? l[0] ? Nve(l[0].x) : Dve(e) : (e = l.length, function(c) {
    for (var u = 0, d; u < e; ++u) a[(d = l[u]).i] = d.x(c);
    return a.join("");
  });
}
function Ah(n, e) {
  var t = typeof e, r;
  return e == null || t === "boolean" ? dM(e) : (t === "number" ? N2 : t === "string" ? (r = Mm(e)) ? (e = r, GN) : Lve : e instanceof Mm ? GN : e instanceof Date ? Rve : Ove(e) ? _ve : Array.isArray(e) ? Ive : typeof e.valueOf != "function" && typeof e.toString != "function" || isNaN(e) ? Pve : N2)(n, e);
}
function fM(n, e) {
  return n = +n, e = +e, function(t) {
    return Math.round(n * (1 - t) + e * t);
  };
}
function $ve(n, e) {
  e === void 0 && (e = n, n = Ah);
  for (var t = 0, r = e.length - 1, i = e[0], s = new Array(r < 0 ? 0 : r); t < r; ) s[t] = n(i, i = e[++t]);
  return function(o) {
    var a = Math.max(0, Math.min(r - 1, Math.floor(o *= r)));
    return s[a](o - a);
  };
}
function Fve(n) {
  return function() {
    return n;
  };
}
function L2(n) {
  return +n;
}
var KN = [0, 1];
function pi(n) {
  return n;
}
function zC(n, e) {
  return (e -= n = +n) ? function(t) {
    return (t - n) / e;
  } : Fve(isNaN(e) ? NaN : 0.5);
}
function Bve(n, e) {
  var t;
  return n > e && (t = n, n = e, e = t), function(r) {
    return Math.max(n, Math.min(e, r));
  };
}
function zve(n, e, t) {
  var r = n[0], i = n[1], s = e[0], o = e[1];
  return i < r ? (r = zC(i, r), s = t(o, s)) : (r = zC(r, i), s = t(s, o)), function(a) {
    return s(r(a));
  };
}
function Hve(n, e, t) {
  var r = Math.min(n.length, e.length) - 1, i = new Array(r), s = new Array(r), o = -1;
  for (n[r] < n[0] && (n = n.slice().reverse(), e = e.slice().reverse()); ++o < r; )
    i[o] = zC(n[o], n[o + 1]), s[o] = t(e[o], e[o + 1]);
  return function(a) {
    var l = u1(n, a, 1, r) - 1;
    return s[l](i[l](a));
  };
}
function f1(n, e) {
  return e.domain(n.domain()).range(n.range()).interpolate(n.interpolate()).clamp(n.clamp()).unknown(n.unknown());
}
function Dw() {
  var n = KN, e = KN, t = Ah, r, i, s, o = pi, a, l, c;
  function u() {
    var f = Math.min(n.length, e.length);
    return o !== pi && (o = Bve(n[0], n[f - 1])), a = f > 2 ? Hve : zve, l = c = null, d;
  }
  function d(f) {
    return f == null || isNaN(f = +f) ? s : (l || (l = a(n.map(r), e, t)))(r(o(f)));
  }
  return d.invert = function(f) {
    return o(i((c || (c = a(e, n.map(r), N2)))(f)));
  }, d.domain = function(f) {
    return arguments.length ? (n = Array.from(f, L2), u()) : n.slice();
  }, d.range = function(f) {
    return arguments.length ? (e = Array.from(f), u()) : e.slice();
  }, d.rangeRound = function(f) {
    return e = Array.from(f), t = fM, u();
  }, d.clamp = function(f) {
    return arguments.length ? (o = f ? !0 : pi, u()) : o !== pi;
  }, d.interpolate = function(f) {
    return arguments.length ? (t = f, u()) : t;
  }, d.unknown = function(f) {
    return arguments.length ? (s = f, d) : s;
  }, function(f, h) {
    return r = f, i = h, u();
  };
}
function hM() {
  return Dw()(pi, pi);
}
function Uve(n) {
  return Math.abs(n = Math.round(n)) >= 1e21 ? n.toLocaleString("en").replace(/,/g, "") : n.toString(10);
}
function $2(n, e) {
  if ((t = (n = e ? n.toExponential(e - 1) : n.toExponential()).indexOf("e")) < 0) return null;
  var t, r = n.slice(0, t);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +n.slice(t + 1)
  ];
}
function kf(n) {
  return n = $2(Math.abs(n)), n ? n[1] : NaN;
}
function Vve(n, e) {
  return function(t, r) {
    for (var i = t.length, s = [], o = 0, a = n[0], l = 0; i > 0 && a > 0 && (l + a + 1 > r && (a = Math.max(1, r - l)), s.push(t.substring(i -= a, i + a)), !((l += a + 1) > r)); )
      a = n[o = (o + 1) % n.length];
    return s.reverse().join(e);
  };
}
function jve(n) {
  return function(e) {
    return e.replace(/[0-9]/g, function(t) {
      return n[+t];
    });
  };
}
var Wve = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function km(n) {
  if (!(e = Wve.exec(n))) throw new Error("invalid format: " + n);
  var e;
  return new pM({
    fill: e[1],
    align: e[2],
    sign: e[3],
    symbol: e[4],
    zero: e[5],
    width: e[6],
    comma: e[7],
    precision: e[8] && e[8].slice(1),
    trim: e[9],
    type: e[10]
  });
}
km.prototype = pM.prototype;
function pM(n) {
  this.fill = n.fill === void 0 ? " " : n.fill + "", this.align = n.align === void 0 ? ">" : n.align + "", this.sign = n.sign === void 0 ? "-" : n.sign + "", this.symbol = n.symbol === void 0 ? "" : n.symbol + "", this.zero = !!n.zero, this.width = n.width === void 0 ? void 0 : +n.width, this.comma = !!n.comma, this.precision = n.precision === void 0 ? void 0 : +n.precision, this.trim = !!n.trim, this.type = n.type === void 0 ? "" : n.type + "";
}
pM.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function Gve(n) {
  e: for (var e = n.length, t = 1, r = -1, i; t < e; ++t)
    switch (n[t]) {
      case ".":
        r = i = t;
        break;
      case "0":
        r === 0 && (r = t), i = t;
        break;
      default:
        if (!+n[t]) break e;
        r > 0 && (r = 0);
        break;
    }
  return r > 0 ? n.slice(0, r) + n.slice(i + 1) : n;
}
var sq;
function Kve(n, e) {
  var t = $2(n, e);
  if (!t) return n + "";
  var r = t[0], i = t[1], s = i - (sq = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, o = r.length;
  return s === o ? r : s > o ? r + new Array(s - o + 1).join("0") : s > 0 ? r.slice(0, s) + "." + r.slice(s) : "0." + new Array(1 - s).join("0") + $2(n, Math.max(0, e + s - 1))[0];
}
function qN(n, e) {
  var t = $2(n, e);
  if (!t) return n + "";
  var r = t[0], i = t[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const YN = {
  "%": (n, e) => (n * 100).toFixed(e),
  b: (n) => Math.round(n).toString(2),
  c: (n) => n + "",
  d: Uve,
  e: (n, e) => n.toExponential(e),
  f: (n, e) => n.toFixed(e),
  g: (n, e) => n.toPrecision(e),
  o: (n) => Math.round(n).toString(8),
  p: (n, e) => qN(n * 100, e),
  r: qN,
  s: Kve,
  X: (n) => Math.round(n).toString(16).toUpperCase(),
  x: (n) => Math.round(n).toString(16)
};
function XN(n) {
  return n;
}
var ZN = Array.prototype.map, QN = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function qve(n) {
  var e = n.grouping === void 0 || n.thousands === void 0 ? XN : Vve(ZN.call(n.grouping, Number), n.thousands + ""), t = n.currency === void 0 ? "" : n.currency[0] + "", r = n.currency === void 0 ? "" : n.currency[1] + "", i = n.decimal === void 0 ? "." : n.decimal + "", s = n.numerals === void 0 ? XN : jve(ZN.call(n.numerals, String)), o = n.percent === void 0 ? "%" : n.percent + "", a = n.minus === void 0 ? "−" : n.minus + "", l = n.nan === void 0 ? "NaN" : n.nan + "";
  function c(d) {
    d = km(d);
    var f = d.fill, h = d.align, m = d.sign, g = d.symbol, v = d.zero, y = d.width, b = d.comma, x = d.precision, E = d.trim, w = d.type;
    w === "n" ? (b = !0, w = "g") : YN[w] || (x === void 0 && (x = 12), E = !0, w = "g"), (v || f === "0" && h === "=") && (v = !0, f = "0", h = "=");
    var C = g === "$" ? t : g === "#" && /[boxX]/.test(w) ? "0" + w.toLowerCase() : "", S = g === "$" ? r : /[%p]/.test(w) ? o : "", M = YN[w], k = /[defgprs%]/.test(w);
    x = x === void 0 ? 6 : /[gprs]/.test(w) ? Math.max(1, Math.min(21, x)) : Math.max(0, Math.min(20, x));
    function _(O) {
      var I = C, R = S, P, D, L;
      if (w === "c")
        R = M(O) + R, O = "";
      else {
        O = +O;
        var B = O < 0 || 1 / O < 0;
        if (O = isNaN(O) ? l : M(Math.abs(O), x), E && (O = Gve(O)), B && +O == 0 && m !== "+" && (B = !1), I = (B ? m === "(" ? m : a : m === "-" || m === "(" ? "" : m) + I, R = (w === "s" ? QN[8 + sq / 3] : "") + R + (B && m === "(" ? ")" : ""), k) {
          for (P = -1, D = O.length; ++P < D; )
            if (L = O.charCodeAt(P), 48 > L || L > 57) {
              R = (L === 46 ? i + O.slice(P + 1) : O.slice(P)) + R, O = O.slice(0, P);
              break;
            }
        }
      }
      b && !v && (O = e(O, 1 / 0));
      var $ = I.length + O.length + R.length, z = $ < y ? new Array(y - $ + 1).join(f) : "";
      switch (b && v && (O = e(z + O, z.length ? y - R.length : 1 / 0), z = ""), h) {
        case "<":
          O = I + O + R + z;
          break;
        case "=":
          O = I + z + O + R;
          break;
        case "^":
          O = z.slice(0, $ = z.length >> 1) + I + O + R + z.slice($);
          break;
        default:
          O = z + I + O + R;
          break;
      }
      return s(O);
    }
    return _.toString = function() {
      return d + "";
    }, _;
  }
  function u(d, f) {
    var h = c((d = km(d), d.type = "f", d)), m = Math.max(-8, Math.min(8, Math.floor(kf(f) / 3))) * 3, g = Math.pow(10, -m), v = QN[8 + m / 3];
    return function(y) {
      return h(g * y) + v;
    };
  }
  return {
    format: c,
    formatPrefix: u
  };
}
var fg, mM, oq;
Yve({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function Yve(n) {
  return fg = qve(n), mM = fg.format, oq = fg.formatPrefix, fg;
}
function Xve(n) {
  return Math.max(0, -kf(Math.abs(n)));
}
function Zve(n, e) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(kf(e) / 3))) * 3 - kf(Math.abs(n)));
}
function Qve(n, e) {
  return n = Math.abs(n), e = Math.abs(e) - n, Math.max(0, kf(e) - kf(n)) + 1;
}
function aq(n, e, t, r) {
  var i = LC(n, e, t), s;
  switch (r = km(r ?? ",f"), r.type) {
    case "s": {
      var o = Math.max(Math.abs(n), Math.abs(e));
      return r.precision == null && !isNaN(s = Zve(i, o)) && (r.precision = s), oq(r, o);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(s = Qve(i, Math.max(Math.abs(n), Math.abs(e)))) && (r.precision = s - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(s = Xve(i)) && (r.precision = s - (r.type === "%") * 2);
      break;
    }
  }
  return mM(r);
}
function Ac(n) {
  var e = n.domain;
  return n.ticks = function(t) {
    var r = e();
    return DC(r[0], r[r.length - 1], t ?? 10);
  }, n.tickFormat = function(t, r) {
    var i = e();
    return aq(i[0], i[i.length - 1], t ?? 10, r);
  }, n.nice = function(t) {
    t == null && (t = 10);
    var r = e(), i = 0, s = r.length - 1, o = r[i], a = r[s], l, c, u = 10;
    for (a < o && (c = o, o = a, a = c, c = i, i = s, s = c); u-- > 0; ) {
      if (c = NC(o, a, t), c === l)
        return r[i] = o, r[s] = a, e(r);
      if (c > 0)
        o = Math.floor(o / c) * c, a = Math.ceil(a / c) * c;
      else if (c < 0)
        o = Math.ceil(o * c) / c, a = Math.floor(a * c) / c;
      else
        break;
      l = c;
    }
    return n;
  }, n;
}
function F2() {
  var n = hM();
  return n.copy = function() {
    return f1(n, F2());
  }, Gs.apply(n, arguments), Ac(n);
}
function lq(n) {
  var e;
  function t(r) {
    return r == null || isNaN(r = +r) ? e : r;
  }
  return t.invert = t, t.domain = t.range = function(r) {
    return arguments.length ? (n = Array.from(r, L2), t) : n.slice();
  }, t.unknown = function(r) {
    return arguments.length ? (e = r, t) : e;
  }, t.copy = function() {
    return lq(n).unknown(e);
  }, n = arguments.length ? Array.from(n, L2) : [0, 1], Ac(t);
}
function cq(n, e) {
  n = n.slice();
  var t = 0, r = n.length - 1, i = n[t], s = n[r], o;
  return s < i && (o = t, t = r, r = o, o = i, i = s, s = o), n[t] = e.floor(i), n[r] = e.ceil(s), n;
}
function JN(n) {
  return Math.log(n);
}
function eL(n) {
  return Math.exp(n);
}
function Jve(n) {
  return -Math.log(-n);
}
function e2e(n) {
  return -Math.exp(-n);
}
function t2e(n) {
  return isFinite(n) ? +("1e" + n) : n < 0 ? 0 : n;
}
function n2e(n) {
  return n === 10 ? t2e : n === Math.E ? Math.exp : (e) => Math.pow(n, e);
}
function r2e(n) {
  return n === Math.E ? Math.log : n === 10 && Math.log10 || n === 2 && Math.log2 || (n = Math.log(n), (e) => Math.log(e) / n);
}
function tL(n) {
  return (e, t) => -n(-e, t);
}
function gM(n) {
  const e = n(JN, eL), t = e.domain;
  let r = 10, i, s;
  function o() {
    return i = r2e(r), s = n2e(r), t()[0] < 0 ? (i = tL(i), s = tL(s), n(Jve, e2e)) : n(JN, eL), e;
  }
  return e.base = function(a) {
    return arguments.length ? (r = +a, o()) : r;
  }, e.domain = function(a) {
    return arguments.length ? (t(a), o()) : t();
  }, e.ticks = (a) => {
    const l = t();
    let c = l[0], u = l[l.length - 1];
    const d = u < c;
    d && ([c, u] = [u, c]);
    let f = i(c), h = i(u), m, g;
    const v = a == null ? 10 : +a;
    let y = [];
    if (!(r % 1) && h - f < v) {
      if (f = Math.floor(f), h = Math.ceil(h), c > 0) {
        for (; f <= h; ++f)
          for (m = 1; m < r; ++m)
            if (g = f < 0 ? m / s(-f) : m * s(f), !(g < c)) {
              if (g > u) break;
              y.push(g);
            }
      } else for (; f <= h; ++f)
        for (m = r - 1; m >= 1; --m)
          if (g = f > 0 ? m / s(-f) : m * s(f), !(g < c)) {
            if (g > u) break;
            y.push(g);
          }
      y.length * 2 < v && (y = DC(c, u, v));
    } else
      y = DC(f, h, Math.min(h - f, v)).map(s);
    return d ? y.reverse() : y;
  }, e.tickFormat = (a, l) => {
    if (a == null && (a = 10), l == null && (l = r === 10 ? "s" : ","), typeof l != "function" && (!(r % 1) && (l = km(l)).precision == null && (l.trim = !0), l = mM(l)), a === 1 / 0) return l;
    const c = Math.max(1, r * a / e.ticks().length);
    return (u) => {
      let d = u / s(Math.round(i(u)));
      return d * r < r - 0.5 && (d *= r), d <= c ? l(u) : "";
    };
  }, e.nice = () => t(cq(t(), {
    floor: (a) => s(Math.floor(i(a))),
    ceil: (a) => s(Math.ceil(i(a)))
  })), e;
}
function uq() {
  const n = gM(Dw()).domain([1, 10]);
  return n.copy = () => f1(n, uq()).base(n.base()), Gs.apply(n, arguments), n;
}
function nL(n) {
  return function(e) {
    return Math.sign(e) * Math.log1p(Math.abs(e / n));
  };
}
function rL(n) {
  return function(e) {
    return Math.sign(e) * Math.expm1(Math.abs(e)) * n;
  };
}
function vM(n) {
  var e = 1, t = n(nL(e), rL(e));
  return t.constant = function(r) {
    return arguments.length ? n(nL(e = +r), rL(e)) : e;
  }, Ac(t);
}
function dq() {
  var n = vM(Dw());
  return n.copy = function() {
    return f1(n, dq()).constant(n.constant());
  }, Gs.apply(n, arguments);
}
function iL(n) {
  return function(e) {
    return e < 0 ? -Math.pow(-e, n) : Math.pow(e, n);
  };
}
function i2e(n) {
  return n < 0 ? -Math.sqrt(-n) : Math.sqrt(n);
}
function s2e(n) {
  return n < 0 ? -n * n : n * n;
}
function yM(n) {
  var e = n(pi, pi), t = 1;
  function r() {
    return t === 1 ? n(pi, pi) : t === 0.5 ? n(i2e, s2e) : n(iL(t), iL(1 / t));
  }
  return e.exponent = function(i) {
    return arguments.length ? (t = +i, r()) : t;
  }, Ac(e);
}
function bM() {
  var n = yM(Dw());
  return n.copy = function() {
    return f1(n, bM()).exponent(n.exponent());
  }, Gs.apply(n, arguments), n;
}
function o2e() {
  return bM.apply(null, arguments).exponent(0.5);
}
function sL(n) {
  return Math.sign(n) * n * n;
}
function a2e(n) {
  return Math.sign(n) * Math.sqrt(Math.abs(n));
}
function fq() {
  var n = hM(), e = [0, 1], t = !1, r;
  function i(s) {
    var o = a2e(n(s));
    return isNaN(o) ? r : t ? Math.round(o) : o;
  }
  return i.invert = function(s) {
    return n.invert(sL(s));
  }, i.domain = function(s) {
    return arguments.length ? (n.domain(s), i) : n.domain();
  }, i.range = function(s) {
    return arguments.length ? (n.range((e = Array.from(s, L2)).map(sL)), i) : e.slice();
  }, i.rangeRound = function(s) {
    return i.range(s).round(!0);
  }, i.round = function(s) {
    return arguments.length ? (t = !!s, i) : t;
  }, i.clamp = function(s) {
    return arguments.length ? (n.clamp(s), i) : n.clamp();
  }, i.unknown = function(s) {
    return arguments.length ? (r = s, i) : r;
  }, i.copy = function() {
    return fq(n.domain(), e).round(t).clamp(n.clamp()).unknown(r);
  }, Gs.apply(i, arguments), Ac(i);
}
function hq() {
  var n = [], e = [], t = [], r;
  function i() {
    var o = 0, a = Math.max(1, e.length);
    for (t = new Array(a - 1); ++o < a; ) t[o - 1] = fve(n, o / a);
    return s;
  }
  function s(o) {
    return o == null || isNaN(o = +o) ? r : e[u1(t, o)];
  }
  return s.invertExtent = function(o) {
    var a = e.indexOf(o);
    return a < 0 ? [NaN, NaN] : [
      a > 0 ? t[a - 1] : n[0],
      a < t.length ? t[a] : n[n.length - 1]
    ];
  }, s.domain = function(o) {
    if (!arguments.length) return n.slice();
    n = [];
    for (let a of o) a != null && !isNaN(a = +a) && n.push(a);
    return n.sort(ic), i();
  }, s.range = function(o) {
    return arguments.length ? (e = Array.from(o), i()) : e.slice();
  }, s.unknown = function(o) {
    return arguments.length ? (r = o, s) : r;
  }, s.quantiles = function() {
    return t.slice();
  }, s.copy = function() {
    return hq().domain(n).range(e).unknown(r);
  }, Gs.apply(s, arguments);
}
function pq() {
  var n = 0, e = 1, t = 1, r = [0.5], i = [0, 1], s;
  function o(l) {
    return l != null && l <= l ? i[u1(r, l, 0, t)] : s;
  }
  function a() {
    var l = -1;
    for (r = new Array(t); ++l < t; ) r[l] = ((l + 1) * e - (l - t) * n) / (t + 1);
    return o;
  }
  return o.domain = function(l) {
    return arguments.length ? ([n, e] = l, n = +n, e = +e, a()) : [n, e];
  }, o.range = function(l) {
    return arguments.length ? (t = (i = Array.from(l)).length - 1, a()) : i.slice();
  }, o.invertExtent = function(l) {
    var c = i.indexOf(l);
    return c < 0 ? [NaN, NaN] : c < 1 ? [n, r[0]] : c >= t ? [r[t - 1], e] : [r[c - 1], r[c]];
  }, o.unknown = function(l) {
    return arguments.length && (s = l), o;
  }, o.thresholds = function() {
    return r.slice();
  }, o.copy = function() {
    return pq().domain([n, e]).range(i).unknown(s);
  }, Gs.apply(Ac(o), arguments);
}
function mq() {
  var n = [0.5], e = [0, 1], t, r = 1;
  function i(s) {
    return s != null && s <= s ? e[u1(n, s, 0, r)] : t;
  }
  return i.domain = function(s) {
    return arguments.length ? (n = Array.from(s), r = Math.min(n.length, e.length - 1), i) : n.slice();
  }, i.range = function(s) {
    return arguments.length ? (e = Array.from(s), r = Math.min(n.length, e.length - 1), i) : e.slice();
  }, i.invertExtent = function(s) {
    var o = e.indexOf(s);
    return [n[o - 1], n[o]];
  }, i.unknown = function(s) {
    return arguments.length ? (t = s, i) : t;
  }, i.copy = function() {
    return mq().domain(n).range(e).unknown(t);
  }, Gs.apply(i, arguments);
}
const rS = /* @__PURE__ */ new Date(), iS = /* @__PURE__ */ new Date();
function Tr(n, e, t, r) {
  function i(s) {
    return n(s = arguments.length === 0 ? /* @__PURE__ */ new Date() : /* @__PURE__ */ new Date(+s)), s;
  }
  return i.floor = (s) => (n(s = /* @__PURE__ */ new Date(+s)), s), i.ceil = (s) => (n(s = new Date(s - 1)), e(s, 1), n(s), s), i.round = (s) => {
    const o = i(s), a = i.ceil(s);
    return s - o < a - s ? o : a;
  }, i.offset = (s, o) => (e(s = /* @__PURE__ */ new Date(+s), o == null ? 1 : Math.floor(o)), s), i.range = (s, o, a) => {
    const l = [];
    if (s = i.ceil(s), a = a == null ? 1 : Math.floor(a), !(s < o) || !(a > 0)) return l;
    let c;
    do
      l.push(c = /* @__PURE__ */ new Date(+s)), e(s, a), n(s);
    while (c < s && s < o);
    return l;
  }, i.filter = (s) => Tr((o) => {
    if (o >= o) for (; n(o), !s(o); ) o.setTime(o - 1);
  }, (o, a) => {
    if (o >= o)
      if (a < 0) for (; ++a <= 0; )
        for (; e(o, -1), !s(o); )
          ;
      else for (; --a >= 0; )
        for (; e(o, 1), !s(o); )
          ;
  }), t && (i.count = (s, o) => (rS.setTime(+s), iS.setTime(+o), n(rS), n(iS), Math.floor(t(rS, iS))), i.every = (s) => (s = Math.floor(s), !isFinite(s) || !(s > 0) ? null : s > 1 ? i.filter(r ? (o) => r(o) % s === 0 : (o) => i.count(0, o) % s === 0) : i)), i;
}
const B2 = Tr(() => {
}, (n, e) => {
  n.setTime(+n + e);
}, (n, e) => e - n);
B2.every = (n) => (n = Math.floor(n), !isFinite(n) || !(n > 0) ? null : n > 1 ? Tr((e) => {
  e.setTime(Math.floor(e / n) * n);
}, (e, t) => {
  e.setTime(+e + t * n);
}, (e, t) => (t - e) / n) : B2);
B2.range;
const Ya = 1e3, Ps = Ya * 60, Xa = Ps * 60, cl = Xa * 24, wM = cl * 7, oL = cl * 30, sS = cl * 365, ou = Tr((n) => {
  n.setTime(n - n.getMilliseconds());
}, (n, e) => {
  n.setTime(+n + e * Ya);
}, (n, e) => (e - n) / Ya, (n) => n.getUTCSeconds());
ou.range;
const xM = Tr((n) => {
  n.setTime(n - n.getMilliseconds() - n.getSeconds() * Ya);
}, (n, e) => {
  n.setTime(+n + e * Ps);
}, (n, e) => (e - n) / Ps, (n) => n.getMinutes());
xM.range;
const EM = Tr((n) => {
  n.setUTCSeconds(0, 0);
}, (n, e) => {
  n.setTime(+n + e * Ps);
}, (n, e) => (e - n) / Ps, (n) => n.getUTCMinutes());
EM.range;
const SM = Tr((n) => {
  n.setTime(n - n.getMilliseconds() - n.getSeconds() * Ya - n.getMinutes() * Ps);
}, (n, e) => {
  n.setTime(+n + e * Xa);
}, (n, e) => (e - n) / Xa, (n) => n.getHours());
SM.range;
const CM = Tr((n) => {
  n.setUTCMinutes(0, 0, 0);
}, (n, e) => {
  n.setTime(+n + e * Xa);
}, (n, e) => (e - n) / Xa, (n) => n.getUTCHours());
CM.range;
const h1 = Tr(
  (n) => n.setHours(0, 0, 0, 0),
  (n, e) => n.setDate(n.getDate() + e),
  (n, e) => (e - n - (e.getTimezoneOffset() - n.getTimezoneOffset()) * Ps) / cl,
  (n) => n.getDate() - 1
);
h1.range;
const Nw = Tr((n) => {
  n.setUTCHours(0, 0, 0, 0);
}, (n, e) => {
  n.setUTCDate(n.getUTCDate() + e);
}, (n, e) => (e - n) / cl, (n) => n.getUTCDate() - 1);
Nw.range;
const gq = Tr((n) => {
  n.setUTCHours(0, 0, 0, 0);
}, (n, e) => {
  n.setUTCDate(n.getUTCDate() + e);
}, (n, e) => (e - n) / cl, (n) => Math.floor(n / cl));
gq.range;
function td(n) {
  return Tr((e) => {
    e.setDate(e.getDate() - (e.getDay() + 7 - n) % 7), e.setHours(0, 0, 0, 0);
  }, (e, t) => {
    e.setDate(e.getDate() + t * 7);
  }, (e, t) => (t - e - (t.getTimezoneOffset() - e.getTimezoneOffset()) * Ps) / wM);
}
const Lw = td(0), z2 = td(1), l2e = td(2), c2e = td(3), _f = td(4), u2e = td(5), d2e = td(6);
Lw.range;
z2.range;
l2e.range;
c2e.range;
_f.range;
u2e.range;
d2e.range;
function nd(n) {
  return Tr((e) => {
    e.setUTCDate(e.getUTCDate() - (e.getUTCDay() + 7 - n) % 7), e.setUTCHours(0, 0, 0, 0);
  }, (e, t) => {
    e.setUTCDate(e.getUTCDate() + t * 7);
  }, (e, t) => (t - e) / wM);
}
const $w = nd(0), H2 = nd(1), f2e = nd(2), h2e = nd(3), Of = nd(4), p2e = nd(5), m2e = nd(6);
$w.range;
H2.range;
f2e.range;
h2e.range;
Of.range;
p2e.range;
m2e.range;
const TM = Tr((n) => {
  n.setDate(1), n.setHours(0, 0, 0, 0);
}, (n, e) => {
  n.setMonth(n.getMonth() + e);
}, (n, e) => e.getMonth() - n.getMonth() + (e.getFullYear() - n.getFullYear()) * 12, (n) => n.getMonth());
TM.range;
const AM = Tr((n) => {
  n.setUTCDate(1), n.setUTCHours(0, 0, 0, 0);
}, (n, e) => {
  n.setUTCMonth(n.getUTCMonth() + e);
}, (n, e) => e.getUTCMonth() - n.getUTCMonth() + (e.getUTCFullYear() - n.getUTCFullYear()) * 12, (n) => n.getUTCMonth());
AM.range;
const ul = Tr((n) => {
  n.setMonth(0, 1), n.setHours(0, 0, 0, 0);
}, (n, e) => {
  n.setFullYear(n.getFullYear() + e);
}, (n, e) => e.getFullYear() - n.getFullYear(), (n) => n.getFullYear());
ul.every = (n) => !isFinite(n = Math.floor(n)) || !(n > 0) ? null : Tr((e) => {
  e.setFullYear(Math.floor(e.getFullYear() / n) * n), e.setMonth(0, 1), e.setHours(0, 0, 0, 0);
}, (e, t) => {
  e.setFullYear(e.getFullYear() + t * n);
});
ul.range;
const dl = Tr((n) => {
  n.setUTCMonth(0, 1), n.setUTCHours(0, 0, 0, 0);
}, (n, e) => {
  n.setUTCFullYear(n.getUTCFullYear() + e);
}, (n, e) => e.getUTCFullYear() - n.getUTCFullYear(), (n) => n.getUTCFullYear());
dl.every = (n) => !isFinite(n = Math.floor(n)) || !(n > 0) ? null : Tr((e) => {
  e.setUTCFullYear(Math.floor(e.getUTCFullYear() / n) * n), e.setUTCMonth(0, 1), e.setUTCHours(0, 0, 0, 0);
}, (e, t) => {
  e.setUTCFullYear(e.getUTCFullYear() + t * n);
});
dl.range;
function vq(n, e, t, r, i, s) {
  const o = [
    [ou, 1, Ya],
    [ou, 5, 5 * Ya],
    [ou, 15, 15 * Ya],
    [ou, 30, 30 * Ya],
    [s, 1, Ps],
    [s, 5, 5 * Ps],
    [s, 15, 15 * Ps],
    [s, 30, 30 * Ps],
    [i, 1, Xa],
    [i, 3, 3 * Xa],
    [i, 6, 6 * Xa],
    [i, 12, 12 * Xa],
    [r, 1, cl],
    [r, 2, 2 * cl],
    [t, 1, wM],
    [e, 1, oL],
    [e, 3, 3 * oL],
    [n, 1, sS]
  ];
  function a(c, u, d) {
    const f = u < c;
    f && ([c, u] = [u, c]);
    const h = d && typeof d.range == "function" ? d : l(c, u, d), m = h ? h.range(c, +u + 1) : [];
    return f ? m.reverse() : m;
  }
  function l(c, u, d) {
    const f = Math.abs(u - c) / d, h = lM(([, , v]) => v).right(o, f);
    if (h === o.length) return n.every(LC(c / sS, u / sS, d));
    if (h === 0) return B2.every(Math.max(LC(c, u, d), 1));
    const [m, g] = o[f / o[h - 1][2] < o[h][2] / f ? h - 1 : h];
    return m.every(g);
  }
  return [a, l];
}
const [g2e, v2e] = vq(dl, AM, $w, gq, CM, EM), [y2e, b2e] = vq(ul, TM, Lw, h1, SM, xM);
function oS(n) {
  if (0 <= n.y && n.y < 100) {
    var e = new Date(-1, n.m, n.d, n.H, n.M, n.S, n.L);
    return e.setFullYear(n.y), e;
  }
  return new Date(n.y, n.m, n.d, n.H, n.M, n.S, n.L);
}
function aS(n) {
  if (0 <= n.y && n.y < 100) {
    var e = new Date(Date.UTC(-1, n.m, n.d, n.H, n.M, n.S, n.L));
    return e.setUTCFullYear(n.y), e;
  }
  return new Date(Date.UTC(n.y, n.m, n.d, n.H, n.M, n.S, n.L));
}
function Jh(n, e, t) {
  return { y: n, m: e, d: t, H: 0, M: 0, S: 0, L: 0 };
}
function w2e(n) {
  var e = n.dateTime, t = n.date, r = n.time, i = n.periods, s = n.days, o = n.shortDays, a = n.months, l = n.shortMonths, c = ep(i), u = tp(i), d = ep(s), f = tp(s), h = ep(o), m = tp(o), g = ep(a), v = tp(a), y = ep(l), b = tp(l), x = {
    a: B,
    A: $,
    b: z,
    B: H,
    c: null,
    d: fL,
    e: fL,
    f: V2e,
    g: J2e,
    G: tye,
    H: z2e,
    I: H2e,
    j: U2e,
    L: yq,
    m: j2e,
    M: W2e,
    p: U,
    q: F,
    Q: mL,
    s: gL,
    S: G2e,
    u: K2e,
    U: q2e,
    V: Y2e,
    w: X2e,
    W: Z2e,
    x: null,
    X: null,
    y: Q2e,
    Y: eye,
    Z: nye,
    "%": pL
  }, E = {
    a: V,
    A: X,
    b: Z,
    B: ie,
    c: null,
    d: hL,
    e: hL,
    f: oye,
    g: gye,
    G: yye,
    H: rye,
    I: iye,
    j: sye,
    L: wq,
    m: aye,
    M: lye,
    p: J,
    q: se,
    Q: mL,
    s: gL,
    S: cye,
    u: uye,
    U: dye,
    V: fye,
    w: hye,
    W: pye,
    x: null,
    X: null,
    y: mye,
    Y: vye,
    Z: bye,
    "%": pL
  }, w = {
    a: _,
    A: O,
    b: I,
    B: R,
    c: P,
    d: uL,
    e: uL,
    f: L2e,
    g: cL,
    G: lL,
    H: dL,
    I: dL,
    j: R2e,
    L: N2e,
    m: I2e,
    M: P2e,
    p: k,
    q: O2e,
    Q: F2e,
    s: B2e,
    S: D2e,
    u: T2e,
    U: A2e,
    V: M2e,
    w: C2e,
    W: k2e,
    x: D,
    X: L,
    y: cL,
    Y: lL,
    Z: _2e,
    "%": $2e
  };
  x.x = C(t, x), x.X = C(r, x), x.c = C(e, x), E.x = C(t, E), E.X = C(r, E), E.c = C(e, E);
  function C(te, le) {
    return function(de) {
      var j = [], xe = -1, ne = 0, qe = te.length, ve, Ie, mt;
      for (de instanceof Date || (de = /* @__PURE__ */ new Date(+de)); ++xe < qe; )
        te.charCodeAt(xe) === 37 && (j.push(te.slice(ne, xe)), (Ie = aL[ve = te.charAt(++xe)]) != null ? ve = te.charAt(++xe) : Ie = ve === "e" ? " " : "0", (mt = le[ve]) && (ve = mt(de, Ie)), j.push(ve), ne = xe + 1);
      return j.push(te.slice(ne, xe)), j.join("");
    };
  }
  function S(te, le) {
    return function(de) {
      var j = Jh(1900, void 0, 1), xe = M(j, te, de += "", 0), ne, qe;
      if (xe != de.length) return null;
      if ("Q" in j) return new Date(j.Q);
      if ("s" in j) return new Date(j.s * 1e3 + ("L" in j ? j.L : 0));
      if (le && !("Z" in j) && (j.Z = 0), "p" in j && (j.H = j.H % 12 + j.p * 12), j.m === void 0 && (j.m = "q" in j ? j.q : 0), "V" in j) {
        if (j.V < 1 || j.V > 53) return null;
        "w" in j || (j.w = 1), "Z" in j ? (ne = aS(Jh(j.y, 0, 1)), qe = ne.getUTCDay(), ne = qe > 4 || qe === 0 ? H2.ceil(ne) : H2(ne), ne = Nw.offset(ne, (j.V - 1) * 7), j.y = ne.getUTCFullYear(), j.m = ne.getUTCMonth(), j.d = ne.getUTCDate() + (j.w + 6) % 7) : (ne = oS(Jh(j.y, 0, 1)), qe = ne.getDay(), ne = qe > 4 || qe === 0 ? z2.ceil(ne) : z2(ne), ne = h1.offset(ne, (j.V - 1) * 7), j.y = ne.getFullYear(), j.m = ne.getMonth(), j.d = ne.getDate() + (j.w + 6) % 7);
      } else ("W" in j || "U" in j) && ("w" in j || (j.w = "u" in j ? j.u % 7 : "W" in j ? 1 : 0), qe = "Z" in j ? aS(Jh(j.y, 0, 1)).getUTCDay() : oS(Jh(j.y, 0, 1)).getDay(), j.m = 0, j.d = "W" in j ? (j.w + 6) % 7 + j.W * 7 - (qe + 5) % 7 : j.w + j.U * 7 - (qe + 6) % 7);
      return "Z" in j ? (j.H += j.Z / 100 | 0, j.M += j.Z % 100, aS(j)) : oS(j);
    };
  }
  function M(te, le, de, j) {
    for (var xe = 0, ne = le.length, qe = de.length, ve, Ie; xe < ne; ) {
      if (j >= qe) return -1;
      if (ve = le.charCodeAt(xe++), ve === 37) {
        if (ve = le.charAt(xe++), Ie = w[ve in aL ? le.charAt(xe++) : ve], !Ie || (j = Ie(te, de, j)) < 0) return -1;
      } else if (ve != de.charCodeAt(j++))
        return -1;
    }
    return j;
  }
  function k(te, le, de) {
    var j = c.exec(le.slice(de));
    return j ? (te.p = u.get(j[0].toLowerCase()), de + j[0].length) : -1;
  }
  function _(te, le, de) {
    var j = h.exec(le.slice(de));
    return j ? (te.w = m.get(j[0].toLowerCase()), de + j[0].length) : -1;
  }
  function O(te, le, de) {
    var j = d.exec(le.slice(de));
    return j ? (te.w = f.get(j[0].toLowerCase()), de + j[0].length) : -1;
  }
  function I(te, le, de) {
    var j = y.exec(le.slice(de));
    return j ? (te.m = b.get(j[0].toLowerCase()), de + j[0].length) : -1;
  }
  function R(te, le, de) {
    var j = g.exec(le.slice(de));
    return j ? (te.m = v.get(j[0].toLowerCase()), de + j[0].length) : -1;
  }
  function P(te, le, de) {
    return M(te, e, le, de);
  }
  function D(te, le, de) {
    return M(te, t, le, de);
  }
  function L(te, le, de) {
    return M(te, r, le, de);
  }
  function B(te) {
    return o[te.getDay()];
  }
  function $(te) {
    return s[te.getDay()];
  }
  function z(te) {
    return l[te.getMonth()];
  }
  function H(te) {
    return a[te.getMonth()];
  }
  function U(te) {
    return i[+(te.getHours() >= 12)];
  }
  function F(te) {
    return 1 + ~~(te.getMonth() / 3);
  }
  function V(te) {
    return o[te.getUTCDay()];
  }
  function X(te) {
    return s[te.getUTCDay()];
  }
  function Z(te) {
    return l[te.getUTCMonth()];
  }
  function ie(te) {
    return a[te.getUTCMonth()];
  }
  function J(te) {
    return i[+(te.getUTCHours() >= 12)];
  }
  function se(te) {
    return 1 + ~~(te.getUTCMonth() / 3);
  }
  return {
    format: function(te) {
      var le = C(te += "", x);
      return le.toString = function() {
        return te;
      }, le;
    },
    parse: function(te) {
      var le = S(te += "", !1);
      return le.toString = function() {
        return te;
      }, le;
    },
    utcFormat: function(te) {
      var le = C(te += "", E);
      return le.toString = function() {
        return te;
      }, le;
    },
    utcParse: function(te) {
      var le = S(te += "", !0);
      return le.toString = function() {
        return te;
      }, le;
    }
  };
}
var aL = { "-": "", _: " ", 0: "0" }, Pr = /^\s*\d+/, x2e = /^%/, E2e = /[\\^$*+?|[\]().{}]/g;
function Kt(n, e, t) {
  var r = n < 0 ? "-" : "", i = (r ? -n : n) + "", s = i.length;
  return r + (s < t ? new Array(t - s + 1).join(e) + i : i);
}
function S2e(n) {
  return n.replace(E2e, "\\$&");
}
function ep(n) {
  return new RegExp("^(?:" + n.map(S2e).join("|") + ")", "i");
}
function tp(n) {
  return new Map(n.map((e, t) => [e.toLowerCase(), t]));
}
function C2e(n, e, t) {
  var r = Pr.exec(e.slice(t, t + 1));
  return r ? (n.w = +r[0], t + r[0].length) : -1;
}
function T2e(n, e, t) {
  var r = Pr.exec(e.slice(t, t + 1));
  return r ? (n.u = +r[0], t + r[0].length) : -1;
}
function A2e(n, e, t) {
  var r = Pr.exec(e.slice(t, t + 2));
  return r ? (n.U = +r[0], t + r[0].length) : -1;
}
function M2e(n, e, t) {
  var r = Pr.exec(e.slice(t, t + 2));
  return r ? (n.V = +r[0], t + r[0].length) : -1;
}
function k2e(n, e, t) {
  var r = Pr.exec(e.slice(t, t + 2));
  return r ? (n.W = +r[0], t + r[0].length) : -1;
}
function lL(n, e, t) {
  var r = Pr.exec(e.slice(t, t + 4));
  return r ? (n.y = +r[0], t + r[0].length) : -1;
}
function cL(n, e, t) {
  var r = Pr.exec(e.slice(t, t + 2));
  return r ? (n.y = +r[0] + (+r[0] > 68 ? 1900 : 2e3), t + r[0].length) : -1;
}
function _2e(n, e, t) {
  var r = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(e.slice(t, t + 6));
  return r ? (n.Z = r[1] ? 0 : -(r[2] + (r[3] || "00")), t + r[0].length) : -1;
}
function O2e(n, e, t) {
  var r = Pr.exec(e.slice(t, t + 1));
  return r ? (n.q = r[0] * 3 - 3, t + r[0].length) : -1;
}
function I2e(n, e, t) {
  var r = Pr.exec(e.slice(t, t + 2));
  return r ? (n.m = r[0] - 1, t + r[0].length) : -1;
}
function uL(n, e, t) {
  var r = Pr.exec(e.slice(t, t + 2));
  return r ? (n.d = +r[0], t + r[0].length) : -1;
}
function R2e(n, e, t) {
  var r = Pr.exec(e.slice(t, t + 3));
  return r ? (n.m = 0, n.d = +r[0], t + r[0].length) : -1;
}
function dL(n, e, t) {
  var r = Pr.exec(e.slice(t, t + 2));
  return r ? (n.H = +r[0], t + r[0].length) : -1;
}
function P2e(n, e, t) {
  var r = Pr.exec(e.slice(t, t + 2));
  return r ? (n.M = +r[0], t + r[0].length) : -1;
}
function D2e(n, e, t) {
  var r = Pr.exec(e.slice(t, t + 2));
  return r ? (n.S = +r[0], t + r[0].length) : -1;
}
function N2e(n, e, t) {
  var r = Pr.exec(e.slice(t, t + 3));
  return r ? (n.L = +r[0], t + r[0].length) : -1;
}
function L2e(n, e, t) {
  var r = Pr.exec(e.slice(t, t + 6));
  return r ? (n.L = Math.floor(r[0] / 1e3), t + r[0].length) : -1;
}
function $2e(n, e, t) {
  var r = x2e.exec(e.slice(t, t + 1));
  return r ? t + r[0].length : -1;
}
function F2e(n, e, t) {
  var r = Pr.exec(e.slice(t));
  return r ? (n.Q = +r[0], t + r[0].length) : -1;
}
function B2e(n, e, t) {
  var r = Pr.exec(e.slice(t));
  return r ? (n.s = +r[0], t + r[0].length) : -1;
}
function fL(n, e) {
  return Kt(n.getDate(), e, 2);
}
function z2e(n, e) {
  return Kt(n.getHours(), e, 2);
}
function H2e(n, e) {
  return Kt(n.getHours() % 12 || 12, e, 2);
}
function U2e(n, e) {
  return Kt(1 + h1.count(ul(n), n), e, 3);
}
function yq(n, e) {
  return Kt(n.getMilliseconds(), e, 3);
}
function V2e(n, e) {
  return yq(n, e) + "000";
}
function j2e(n, e) {
  return Kt(n.getMonth() + 1, e, 2);
}
function W2e(n, e) {
  return Kt(n.getMinutes(), e, 2);
}
function G2e(n, e) {
  return Kt(n.getSeconds(), e, 2);
}
function K2e(n) {
  var e = n.getDay();
  return e === 0 ? 7 : e;
}
function q2e(n, e) {
  return Kt(Lw.count(ul(n) - 1, n), e, 2);
}
function bq(n) {
  var e = n.getDay();
  return e >= 4 || e === 0 ? _f(n) : _f.ceil(n);
}
function Y2e(n, e) {
  return n = bq(n), Kt(_f.count(ul(n), n) + (ul(n).getDay() === 4), e, 2);
}
function X2e(n) {
  return n.getDay();
}
function Z2e(n, e) {
  return Kt(z2.count(ul(n) - 1, n), e, 2);
}
function Q2e(n, e) {
  return Kt(n.getFullYear() % 100, e, 2);
}
function J2e(n, e) {
  return n = bq(n), Kt(n.getFullYear() % 100, e, 2);
}
function eye(n, e) {
  return Kt(n.getFullYear() % 1e4, e, 4);
}
function tye(n, e) {
  var t = n.getDay();
  return n = t >= 4 || t === 0 ? _f(n) : _f.ceil(n), Kt(n.getFullYear() % 1e4, e, 4);
}
function nye(n) {
  var e = n.getTimezoneOffset();
  return (e > 0 ? "-" : (e *= -1, "+")) + Kt(e / 60 | 0, "0", 2) + Kt(e % 60, "0", 2);
}
function hL(n, e) {
  return Kt(n.getUTCDate(), e, 2);
}
function rye(n, e) {
  return Kt(n.getUTCHours(), e, 2);
}
function iye(n, e) {
  return Kt(n.getUTCHours() % 12 || 12, e, 2);
}
function sye(n, e) {
  return Kt(1 + Nw.count(dl(n), n), e, 3);
}
function wq(n, e) {
  return Kt(n.getUTCMilliseconds(), e, 3);
}
function oye(n, e) {
  return wq(n, e) + "000";
}
function aye(n, e) {
  return Kt(n.getUTCMonth() + 1, e, 2);
}
function lye(n, e) {
  return Kt(n.getUTCMinutes(), e, 2);
}
function cye(n, e) {
  return Kt(n.getUTCSeconds(), e, 2);
}
function uye(n) {
  var e = n.getUTCDay();
  return e === 0 ? 7 : e;
}
function dye(n, e) {
  return Kt($w.count(dl(n) - 1, n), e, 2);
}
function xq(n) {
  var e = n.getUTCDay();
  return e >= 4 || e === 0 ? Of(n) : Of.ceil(n);
}
function fye(n, e) {
  return n = xq(n), Kt(Of.count(dl(n), n) + (dl(n).getUTCDay() === 4), e, 2);
}
function hye(n) {
  return n.getUTCDay();
}
function pye(n, e) {
  return Kt(H2.count(dl(n) - 1, n), e, 2);
}
function mye(n, e) {
  return Kt(n.getUTCFullYear() % 100, e, 2);
}
function gye(n, e) {
  return n = xq(n), Kt(n.getUTCFullYear() % 100, e, 2);
}
function vye(n, e) {
  return Kt(n.getUTCFullYear() % 1e4, e, 4);
}
function yye(n, e) {
  var t = n.getUTCDay();
  return n = t >= 4 || t === 0 ? Of(n) : Of.ceil(n), Kt(n.getUTCFullYear() % 1e4, e, 4);
}
function bye() {
  return "+0000";
}
function pL() {
  return "%";
}
function mL(n) {
  return +n;
}
function gL(n) {
  return Math.floor(+n / 1e3);
}
var vd, Eq, Sq;
wye({
  dateTime: "%x, %X",
  date: "%-m/%-d/%Y",
  time: "%-I:%M:%S %p",
  periods: ["AM", "PM"],
  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
});
function wye(n) {
  return vd = w2e(n), Eq = vd.format, vd.parse, Sq = vd.utcFormat, vd.utcParse, vd;
}
function xye(n) {
  return new Date(n);
}
function Eye(n) {
  return n instanceof Date ? +n : +/* @__PURE__ */ new Date(+n);
}
function MM(n, e, t, r, i, s, o, a, l, c) {
  var u = hM(), d = u.invert, f = u.domain, h = c(".%L"), m = c(":%S"), g = c("%I:%M"), v = c("%I %p"), y = c("%a %d"), b = c("%b %d"), x = c("%B"), E = c("%Y");
  function w(C) {
    return (l(C) < C ? h : a(C) < C ? m : o(C) < C ? g : s(C) < C ? v : r(C) < C ? i(C) < C ? y : b : t(C) < C ? x : E)(C);
  }
  return u.invert = function(C) {
    return new Date(d(C));
  }, u.domain = function(C) {
    return arguments.length ? f(Array.from(C, Eye)) : f().map(xye);
  }, u.ticks = function(C) {
    var S = f();
    return n(S[0], S[S.length - 1], C ?? 10);
  }, u.tickFormat = function(C, S) {
    return S == null ? w : c(S);
  }, u.nice = function(C) {
    var S = f();
    return (!C || typeof C.range != "function") && (C = e(S[0], S[S.length - 1], C ?? 10)), C ? f(cq(S, C)) : u;
  }, u.copy = function() {
    return f1(u, MM(n, e, t, r, i, s, o, a, l, c));
  }, u;
}
function Sye() {
  return Gs.apply(MM(y2e, b2e, ul, TM, Lw, h1, SM, xM, ou, Eq).domain([new Date(2e3, 0, 1), new Date(2e3, 0, 2)]), arguments);
}
function Cye() {
  return Gs.apply(MM(g2e, v2e, dl, AM, $w, Nw, CM, EM, ou, Sq).domain([Date.UTC(2e3, 0, 1), Date.UTC(2e3, 0, 2)]), arguments);
}
function Fw() {
  var n = 0, e = 1, t, r, i, s, o = pi, a = !1, l;
  function c(d) {
    return d == null || isNaN(d = +d) ? l : o(i === 0 ? 0.5 : (d = (s(d) - t) * i, a ? Math.max(0, Math.min(1, d)) : d));
  }
  c.domain = function(d) {
    return arguments.length ? ([n, e] = d, t = s(n = +n), r = s(e = +e), i = t === r ? 0 : 1 / (r - t), c) : [n, e];
  }, c.clamp = function(d) {
    return arguments.length ? (a = !!d, c) : a;
  }, c.interpolator = function(d) {
    return arguments.length ? (o = d, c) : o;
  };
  function u(d) {
    return function(f) {
      var h, m;
      return arguments.length ? ([h, m] = f, o = d(h, m), c) : [o(0), o(1)];
    };
  }
  return c.range = u(Ah), c.rangeRound = u(fM), c.unknown = function(d) {
    return arguments.length ? (l = d, c) : l;
  }, function(d) {
    return s = d, t = d(n), r = d(e), i = t === r ? 0 : 1 / (r - t), c;
  };
}
function Mc(n, e) {
  return e.domain(n.domain()).interpolator(n.interpolator()).clamp(n.clamp()).unknown(n.unknown());
}
function Cq() {
  var n = Ac(Fw()(pi));
  return n.copy = function() {
    return Mc(n, Cq());
  }, wl.apply(n, arguments);
}
function Tq() {
  var n = gM(Fw()).domain([1, 10]);
  return n.copy = function() {
    return Mc(n, Tq()).base(n.base());
  }, wl.apply(n, arguments);
}
function Aq() {
  var n = vM(Fw());
  return n.copy = function() {
    return Mc(n, Aq()).constant(n.constant());
  }, wl.apply(n, arguments);
}
function kM() {
  var n = yM(Fw());
  return n.copy = function() {
    return Mc(n, kM()).exponent(n.exponent());
  }, wl.apply(n, arguments);
}
function Tye() {
  return kM.apply(null, arguments).exponent(0.5);
}
function Mq() {
  var n = [], e = pi;
  function t(r) {
    if (r != null && !isNaN(r = +r)) return e((u1(n, r, 1) - 1) / (n.length - 1));
  }
  return t.domain = function(r) {
    if (!arguments.length) return n.slice();
    n = [];
    for (let i of r) i != null && !isNaN(i = +i) && n.push(i);
    return n.sort(ic), t;
  }, t.interpolator = function(r) {
    return arguments.length ? (e = r, t) : e;
  }, t.range = function() {
    return n.map((r, i) => e(i / (n.length - 1)));
  }, t.quantiles = function(r) {
    return Array.from({ length: r + 1 }, (i, s) => dve(n, s / r));
  }, t.copy = function() {
    return Mq(e).domain(n);
  }, wl.apply(t, arguments);
}
function Bw() {
  var n = 0, e = 0.5, t = 1, r = 1, i, s, o, a, l, c = pi, u, d = !1, f;
  function h(g) {
    return isNaN(g = +g) ? f : (g = 0.5 + ((g = +u(g)) - s) * (r * g < r * s ? a : l), c(d ? Math.max(0, Math.min(1, g)) : g));
  }
  h.domain = function(g) {
    return arguments.length ? ([n, e, t] = g, i = u(n = +n), s = u(e = +e), o = u(t = +t), a = i === s ? 0 : 0.5 / (s - i), l = s === o ? 0 : 0.5 / (o - s), r = s < i ? -1 : 1, h) : [n, e, t];
  }, h.clamp = function(g) {
    return arguments.length ? (d = !!g, h) : d;
  }, h.interpolator = function(g) {
    return arguments.length ? (c = g, h) : c;
  };
  function m(g) {
    return function(v) {
      var y, b, x;
      return arguments.length ? ([y, b, x] = v, c = $ve(g, [y, b, x]), h) : [c(0), c(0.5), c(1)];
    };
  }
  return h.range = m(Ah), h.rangeRound = m(fM), h.unknown = function(g) {
    return arguments.length ? (f = g, h) : f;
  }, function(g) {
    return u = g, i = g(n), s = g(e), o = g(t), a = i === s ? 0 : 0.5 / (s - i), l = s === o ? 0 : 0.5 / (o - s), r = s < i ? -1 : 1, h;
  };
}
function kq() {
  var n = Ac(Bw()(pi));
  return n.copy = function() {
    return Mc(n, kq());
  }, wl.apply(n, arguments);
}
function _q() {
  var n = gM(Bw()).domain([0.1, 1, 10]);
  return n.copy = function() {
    return Mc(n, _q()).base(n.base());
  }, wl.apply(n, arguments);
}
function Oq() {
  var n = vM(Bw());
  return n.copy = function() {
    return Mc(n, Oq()).constant(n.constant());
  }, wl.apply(n, arguments);
}
function _M() {
  var n = yM(Bw());
  return n.copy = function() {
    return Mc(n, _M()).exponent(n.exponent());
  }, wl.apply(n, arguments);
}
function Aye() {
  return _M.apply(null, arguments).exponent(0.5);
}
const vL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  scaleBand: Cm,
  scaleDiverging: kq,
  scaleDivergingLog: _q,
  scaleDivergingPow: _M,
  scaleDivergingSqrt: Aye,
  scaleDivergingSymlog: Oq,
  scaleIdentity: lq,
  scaleImplicit: $C,
  scaleLinear: F2,
  scaleLog: uq,
  scaleOrdinal: cM,
  scalePoint: Vp,
  scalePow: bM,
  scaleQuantile: hq,
  scaleQuantize: pq,
  scaleRadial: fq,
  scaleSequential: Cq,
  scaleSequentialLog: Tq,
  scaleSequentialPow: kM,
  scaleSequentialQuantile: Mq,
  scaleSequentialSqrt: Tye,
  scaleSequentialSymlog: Aq,
  scaleSqrt: o2e,
  scaleSymlog: dq,
  scaleThreshold: mq,
  scaleTime: Sye,
  scaleUtc: Cye,
  tickFormat: aq
}, Symbol.toStringTag, { value: "Module" }));
var lS, yL;
function Iq() {
  if (yL) return lS;
  yL = 1;
  var n = xh();
  function e(t, r, i) {
    for (var s = -1, o = t.length; ++s < o; ) {
      var a = t[s], l = r(a);
      if (l != null && (c === void 0 ? l === l && !n(l) : i(l, c)))
        var c = l, u = a;
    }
    return u;
  }
  return lS = e, lS;
}
var cS, bL;
function Mye() {
  if (bL) return cS;
  bL = 1;
  function n(e, t) {
    return e > t;
  }
  return cS = n, cS;
}
var uS, wL;
function kye() {
  if (wL) return uS;
  wL = 1;
  var n = Iq(), e = Mye(), t = Ch();
  function r(i) {
    return i && i.length ? n(i, t, e) : void 0;
  }
  return uS = r, uS;
}
var _ye = kye();
const Yl = /* @__PURE__ */ nn(_ye);
var dS, xL;
function Oye() {
  if (xL) return dS;
  xL = 1;
  function n(e, t) {
    return e < t;
  }
  return dS = n, dS;
}
var fS, EL;
function Iye() {
  if (EL) return fS;
  EL = 1;
  var n = Iq(), e = Oye(), t = Ch();
  function r(i) {
    return i && i.length ? n(i, t, e) : void 0;
  }
  return fS = r, fS;
}
var Rye = Iye();
const zw = /* @__PURE__ */ nn(Rye);
var hS, SL;
function Pye() {
  if (SL) return hS;
  SL = 1;
  var n = WA(), e = Tc(), t = BK(), r = Gi();
  function i(s, o) {
    var a = r(s) ? n : t;
    return a(s, e(o, 3));
  }
  return hS = i, hS;
}
var pS, CL;
function Dye() {
  if (CL) return pS;
  CL = 1;
  var n = $K(), e = Pye();
  function t(r, i) {
    return n(e(r, i), 1);
  }
  return pS = t, pS;
}
var Nye = Dye();
const Lye = /* @__PURE__ */ nn(Nye);
var mS, TL;
function $ye() {
  if (TL) return mS;
  TL = 1;
  var n = iM();
  function e(t, r) {
    return n(t, r);
  }
  return mS = e, mS;
}
var Fye = $ye();
const _m = /* @__PURE__ */ nn(Fye);
var Mh = 1e9, Bye = {
  // These values must be integers within the stated ranges (inclusive).
  // Most of these values can be changed during run-time using `Decimal.config`.
  // The maximum number of significant digits of the result of a calculation or base conversion.
  // E.g. `Decimal.config({ precision: 20 });`
  precision: 20,
  // 1 to MAX_DIGITS
  // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
  // `toFixed`, `toPrecision` and `toSignificantDigits`.
  //
  // ROUND_UP         0 Away from zero.
  // ROUND_DOWN       1 Towards zero.
  // ROUND_CEIL       2 Towards +Infinity.
  // ROUND_FLOOR      3 Towards -Infinity.
  // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
  // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
  // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
  // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
  // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
  //
  // E.g.
  // `Decimal.rounding = 4;`
  // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
  rounding: 4,
  // 0 to 8
  // The exponent value at and beneath which `toString` returns exponential notation.
  // JavaScript numbers: -7
  toExpNeg: -7,
  // 0 to -MAX_E
  // The exponent value at and above which `toString` returns exponential notation.
  // JavaScript numbers: 21
  toExpPos: 21,
  // 0 to MAX_E
  // The natural logarithm of 10.
  // 115 digits
  LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
}, IM, Ln = !0, Us = "[DecimalError] ", wu = Us + "Invalid argument: ", OM = Us + "Exponent out of range: ", kh = Math.floor, Yc = Math.pow, zye = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, fs, Mr = 1e7, Pn = 7, Rq = 9007199254740991, U2 = kh(Rq / Pn), Ke = {};
Ke.absoluteValue = Ke.abs = function() {
  var n = new this.constructor(this);
  return n.s && (n.s = 1), n;
};
Ke.comparedTo = Ke.cmp = function(n) {
  var e, t, r, i, s = this;
  if (n = new s.constructor(n), s.s !== n.s) return s.s || -n.s;
  if (s.e !== n.e) return s.e > n.e ^ s.s < 0 ? 1 : -1;
  for (r = s.d.length, i = n.d.length, e = 0, t = r < i ? r : i; e < t; ++e)
    if (s.d[e] !== n.d[e]) return s.d[e] > n.d[e] ^ s.s < 0 ? 1 : -1;
  return r === i ? 0 : r > i ^ s.s < 0 ? 1 : -1;
};
Ke.decimalPlaces = Ke.dp = function() {
  var n = this, e = n.d.length - 1, t = (e - n.e) * Pn;
  if (e = n.d[e], e) for (; e % 10 == 0; e /= 10) t--;
  return t < 0 ? 0 : t;
};
Ke.dividedBy = Ke.div = function(n) {
  return il(this, new this.constructor(n));
};
Ke.dividedToIntegerBy = Ke.idiv = function(n) {
  var e = this, t = e.constructor;
  return En(il(e, new t(n), 0, 1), t.precision);
};
Ke.equals = Ke.eq = function(n) {
  return !this.cmp(n);
};
Ke.exponent = function() {
  return cr(this);
};
Ke.greaterThan = Ke.gt = function(n) {
  return this.cmp(n) > 0;
};
Ke.greaterThanOrEqualTo = Ke.gte = function(n) {
  return this.cmp(n) >= 0;
};
Ke.isInteger = Ke.isint = function() {
  return this.e > this.d.length - 2;
};
Ke.isNegative = Ke.isneg = function() {
  return this.s < 0;
};
Ke.isPositive = Ke.ispos = function() {
  return this.s > 0;
};
Ke.isZero = function() {
  return this.s === 0;
};
Ke.lessThan = Ke.lt = function(n) {
  return this.cmp(n) < 0;
};
Ke.lessThanOrEqualTo = Ke.lte = function(n) {
  return this.cmp(n) < 1;
};
Ke.logarithm = Ke.log = function(n) {
  var e, t = this, r = t.constructor, i = r.precision, s = i + 5;
  if (n === void 0)
    n = new r(10);
  else if (n = new r(n), n.s < 1 || n.eq(fs)) throw Error(Us + "NaN");
  if (t.s < 1) throw Error(Us + (t.s ? "NaN" : "-Infinity"));
  return t.eq(fs) ? new r(0) : (Ln = !1, e = il(Om(t, s), Om(n, s), s), Ln = !0, En(e, i));
};
Ke.minus = Ke.sub = function(n) {
  var e = this;
  return n = new e.constructor(n), e.s == n.s ? Nq(e, n) : Pq(e, (n.s = -n.s, n));
};
Ke.modulo = Ke.mod = function(n) {
  var e, t = this, r = t.constructor, i = r.precision;
  if (n = new r(n), !n.s) throw Error(Us + "NaN");
  return t.s ? (Ln = !1, e = il(t, n, 0, 1).times(n), Ln = !0, t.minus(e)) : En(new r(t), i);
};
Ke.naturalExponential = Ke.exp = function() {
  return Dq(this);
};
Ke.naturalLogarithm = Ke.ln = function() {
  return Om(this);
};
Ke.negated = Ke.neg = function() {
  var n = new this.constructor(this);
  return n.s = -n.s || 0, n;
};
Ke.plus = Ke.add = function(n) {
  var e = this;
  return n = new e.constructor(n), e.s == n.s ? Pq(e, n) : Nq(e, (n.s = -n.s, n));
};
Ke.precision = Ke.sd = function(n) {
  var e, t, r, i = this;
  if (n !== void 0 && n !== !!n && n !== 1 && n !== 0) throw Error(wu + n);
  if (e = cr(i) + 1, r = i.d.length - 1, t = r * Pn + 1, r = i.d[r], r) {
    for (; r % 10 == 0; r /= 10) t--;
    for (r = i.d[0]; r >= 10; r /= 10) t++;
  }
  return n && e > t ? e : t;
};
Ke.squareRoot = Ke.sqrt = function() {
  var n, e, t, r, i, s, o, a = this, l = a.constructor;
  if (a.s < 1) {
    if (!a.s) return new l(0);
    throw Error(Us + "NaN");
  }
  for (n = cr(a), Ln = !1, i = Math.sqrt(+a), i == 0 || i == 1 / 0 ? (e = ta(a.d), (e.length + n) % 2 == 0 && (e += "0"), i = Math.sqrt(e), n = kh((n + 1) / 2) - (n < 0 || n % 2), i == 1 / 0 ? e = "5e" + n : (e = i.toExponential(), e = e.slice(0, e.indexOf("e") + 1) + n), r = new l(e)) : r = new l(i.toString()), t = l.precision, i = o = t + 3; ; )
    if (s = r, r = s.plus(il(a, s, o + 2)).times(0.5), ta(s.d).slice(0, o) === (e = ta(r.d)).slice(0, o)) {
      if (e = e.slice(o - 3, o + 1), i == o && e == "4999") {
        if (En(s, t + 1, 0), s.times(s).eq(a)) {
          r = s;
          break;
        }
      } else if (e != "9999")
        break;
      o += 4;
    }
  return Ln = !0, En(r, t);
};
Ke.times = Ke.mul = function(n) {
  var e, t, r, i, s, o, a, l, c, u = this, d = u.constructor, f = u.d, h = (n = new d(n)).d;
  if (!u.s || !n.s) return new d(0);
  for (n.s *= u.s, t = u.e + n.e, l = f.length, c = h.length, l < c && (s = f, f = h, h = s, o = l, l = c, c = o), s = [], o = l + c, r = o; r--; ) s.push(0);
  for (r = c; --r >= 0; ) {
    for (e = 0, i = l + r; i > r; )
      a = s[i] + h[r] * f[i - r - 1] + e, s[i--] = a % Mr | 0, e = a / Mr | 0;
    s[i] = (s[i] + e) % Mr | 0;
  }
  for (; !s[--o]; ) s.pop();
  return e ? ++t : s.shift(), n.d = s, n.e = t, Ln ? En(n, d.precision) : n;
};
Ke.toDecimalPlaces = Ke.todp = function(n, e) {
  var t = this, r = t.constructor;
  return t = new r(t), n === void 0 ? t : (ga(n, 0, Mh), e === void 0 ? e = r.rounding : ga(e, 0, 8), En(t, n + cr(t) + 1, e));
};
Ke.toExponential = function(n, e) {
  var t, r = this, i = r.constructor;
  return n === void 0 ? t = Pu(r, !0) : (ga(n, 0, Mh), e === void 0 ? e = i.rounding : ga(e, 0, 8), r = En(new i(r), n + 1, e), t = Pu(r, !0, n + 1)), t;
};
Ke.toFixed = function(n, e) {
  var t, r, i = this, s = i.constructor;
  return n === void 0 ? Pu(i) : (ga(n, 0, Mh), e === void 0 ? e = s.rounding : ga(e, 0, 8), r = En(new s(i), n + cr(i) + 1, e), t = Pu(r.abs(), !1, n + cr(r) + 1), i.isneg() && !i.isZero() ? "-" + t : t);
};
Ke.toInteger = Ke.toint = function() {
  var n = this, e = n.constructor;
  return En(new e(n), cr(n) + 1, e.rounding);
};
Ke.toNumber = function() {
  return +this;
};
Ke.toPower = Ke.pow = function(n) {
  var e, t, r, i, s, o, a = this, l = a.constructor, c = 12, u = +(n = new l(n));
  if (!n.s) return new l(fs);
  if (a = new l(a), !a.s) {
    if (n.s < 1) throw Error(Us + "Infinity");
    return a;
  }
  if (a.eq(fs)) return a;
  if (r = l.precision, n.eq(fs)) return En(a, r);
  if (e = n.e, t = n.d.length - 1, o = e >= t, s = a.s, o) {
    if ((t = u < 0 ? -u : u) <= Rq) {
      for (i = new l(fs), e = Math.ceil(r / Pn + 4), Ln = !1; t % 2 && (i = i.times(a), ML(i.d, e)), t = kh(t / 2), t !== 0; )
        a = a.times(a), ML(a.d, e);
      return Ln = !0, n.s < 0 ? new l(fs).div(i) : En(i, r);
    }
  } else if (s < 0) throw Error(Us + "NaN");
  return s = s < 0 && n.d[Math.max(e, t)] & 1 ? -1 : 1, a.s = 1, Ln = !1, i = n.times(Om(a, r + c)), Ln = !0, i = Dq(i), i.s = s, i;
};
Ke.toPrecision = function(n, e) {
  var t, r, i = this, s = i.constructor;
  return n === void 0 ? (t = cr(i), r = Pu(i, t <= s.toExpNeg || t >= s.toExpPos)) : (ga(n, 1, Mh), e === void 0 ? e = s.rounding : ga(e, 0, 8), i = En(new s(i), n, e), t = cr(i), r = Pu(i, n <= t || t <= s.toExpNeg, n)), r;
};
Ke.toSignificantDigits = Ke.tosd = function(n, e) {
  var t = this, r = t.constructor;
  return n === void 0 ? (n = r.precision, e = r.rounding) : (ga(n, 1, Mh), e === void 0 ? e = r.rounding : ga(e, 0, 8)), En(new r(t), n, e);
};
Ke.toString = Ke.valueOf = Ke.val = Ke.toJSON = Ke[Symbol.for("nodejs.util.inspect.custom")] = function() {
  var n = this, e = cr(n), t = n.constructor;
  return Pu(n, e <= t.toExpNeg || e >= t.toExpPos);
};
function Pq(n, e) {
  var t, r, i, s, o, a, l, c, u = n.constructor, d = u.precision;
  if (!n.s || !e.s)
    return e.s || (e = new u(n)), Ln ? En(e, d) : e;
  if (l = n.d, c = e.d, o = n.e, i = e.e, l = l.slice(), s = o - i, s) {
    for (s < 0 ? (r = l, s = -s, a = c.length) : (r = c, i = o, a = l.length), o = Math.ceil(d / Pn), a = o > a ? o + 1 : a + 1, s > a && (s = a, r.length = 1), r.reverse(); s--; ) r.push(0);
    r.reverse();
  }
  for (a = l.length, s = c.length, a - s < 0 && (s = a, r = c, c = l, l = r), t = 0; s; )
    t = (l[--s] = l[s] + c[s] + t) / Mr | 0, l[s] %= Mr;
  for (t && (l.unshift(t), ++i), a = l.length; l[--a] == 0; ) l.pop();
  return e.d = l, e.e = i, Ln ? En(e, d) : e;
}
function ga(n, e, t) {
  if (n !== ~~n || n < e || n > t)
    throw Error(wu + n);
}
function ta(n) {
  var e, t, r, i = n.length - 1, s = "", o = n[0];
  if (i > 0) {
    for (s += o, e = 1; e < i; e++)
      r = n[e] + "", t = Pn - r.length, t && (s += $l(t)), s += r;
    o = n[e], r = o + "", t = Pn - r.length, t && (s += $l(t));
  } else if (o === 0)
    return "0";
  for (; o % 10 === 0; ) o /= 10;
  return s + o;
}
var il = /* @__PURE__ */ (function() {
  function n(r, i) {
    var s, o = 0, a = r.length;
    for (r = r.slice(); a--; )
      s = r[a] * i + o, r[a] = s % Mr | 0, o = s / Mr | 0;
    return o && r.unshift(o), r;
  }
  function e(r, i, s, o) {
    var a, l;
    if (s != o)
      l = s > o ? 1 : -1;
    else
      for (a = l = 0; a < s; a++)
        if (r[a] != i[a]) {
          l = r[a] > i[a] ? 1 : -1;
          break;
        }
    return l;
  }
  function t(r, i, s) {
    for (var o = 0; s--; )
      r[s] -= o, o = r[s] < i[s] ? 1 : 0, r[s] = o * Mr + r[s] - i[s];
    for (; !r[0] && r.length > 1; ) r.shift();
  }
  return function(r, i, s, o) {
    var a, l, c, u, d, f, h, m, g, v, y, b, x, E, w, C, S, M, k = r.constructor, _ = r.s == i.s ? 1 : -1, O = r.d, I = i.d;
    if (!r.s) return new k(r);
    if (!i.s) throw Error(Us + "Division by zero");
    for (l = r.e - i.e, S = I.length, w = O.length, h = new k(_), m = h.d = [], c = 0; I[c] == (O[c] || 0); ) ++c;
    if (I[c] > (O[c] || 0) && --l, s == null ? b = s = k.precision : o ? b = s + (cr(r) - cr(i)) + 1 : b = s, b < 0) return new k(0);
    if (b = b / Pn + 2 | 0, c = 0, S == 1)
      for (u = 0, I = I[0], b++; (c < w || u) && b--; c++)
        x = u * Mr + (O[c] || 0), m[c] = x / I | 0, u = x % I | 0;
    else {
      for (u = Mr / (I[0] + 1) | 0, u > 1 && (I = n(I, u), O = n(O, u), S = I.length, w = O.length), E = S, g = O.slice(0, S), v = g.length; v < S; ) g[v++] = 0;
      M = I.slice(), M.unshift(0), C = I[0], I[1] >= Mr / 2 && ++C;
      do
        u = 0, a = e(I, g, S, v), a < 0 ? (y = g[0], S != v && (y = y * Mr + (g[1] || 0)), u = y / C | 0, u > 1 ? (u >= Mr && (u = Mr - 1), d = n(I, u), f = d.length, v = g.length, a = e(d, g, f, v), a == 1 && (u--, t(d, S < f ? M : I, f))) : (u == 0 && (a = u = 1), d = I.slice()), f = d.length, f < v && d.unshift(0), t(g, d, v), a == -1 && (v = g.length, a = e(I, g, S, v), a < 1 && (u++, t(g, S < v ? M : I, v))), v = g.length) : a === 0 && (u++, g = [0]), m[c++] = u, a && g[0] ? g[v++] = O[E] || 0 : (g = [O[E]], v = 1);
      while ((E++ < w || g[0] !== void 0) && b--);
    }
    return m[0] || m.shift(), h.e = l, En(h, o ? s + cr(h) + 1 : s);
  };
})();
function Dq(n, e) {
  var t, r, i, s, o, a, l = 0, c = 0, u = n.constructor, d = u.precision;
  if (cr(n) > 16) throw Error(OM + cr(n));
  if (!n.s) return new u(fs);
  for (Ln = !1, a = d, o = new u(0.03125); n.abs().gte(0.1); )
    n = n.times(o), c += 5;
  for (r = Math.log(Yc(2, c)) / Math.LN10 * 2 + 5 | 0, a += r, t = i = s = new u(fs), u.precision = a; ; ) {
    if (i = En(i.times(n), a), t = t.times(++l), o = s.plus(il(i, t, a)), ta(o.d).slice(0, a) === ta(s.d).slice(0, a)) {
      for (; c--; ) s = En(s.times(s), a);
      return u.precision = d, e == null ? (Ln = !0, En(s, d)) : s;
    }
    s = o;
  }
}
function cr(n) {
  for (var e = n.e * Pn, t = n.d[0]; t >= 10; t /= 10) e++;
  return e;
}
function gS(n, e, t) {
  if (e > n.LN10.sd())
    throw Ln = !0, t && (n.precision = t), Error(Us + "LN10 precision limit exceeded");
  return En(new n(n.LN10), e);
}
function $l(n) {
  for (var e = ""; n--; ) e += "0";
  return e;
}
function Om(n, e) {
  var t, r, i, s, o, a, l, c, u, d = 1, f = 10, h = n, m = h.d, g = h.constructor, v = g.precision;
  if (h.s < 1) throw Error(Us + (h.s ? "NaN" : "-Infinity"));
  if (h.eq(fs)) return new g(0);
  if (e == null ? (Ln = !1, c = v) : c = e, h.eq(10))
    return e == null && (Ln = !0), gS(g, c);
  if (c += f, g.precision = c, t = ta(m), r = t.charAt(0), s = cr(h), Math.abs(s) < 15e14) {
    for (; r < 7 && r != 1 || r == 1 && t.charAt(1) > 3; )
      h = h.times(n), t = ta(h.d), r = t.charAt(0), d++;
    s = cr(h), r > 1 ? (h = new g("0." + t), s++) : h = new g(r + "." + t.slice(1));
  } else
    return l = gS(g, c + 2, v).times(s + ""), h = Om(new g(r + "." + t.slice(1)), c - f).plus(l), g.precision = v, e == null ? (Ln = !0, En(h, v)) : h;
  for (a = o = h = il(h.minus(fs), h.plus(fs), c), u = En(h.times(h), c), i = 3; ; ) {
    if (o = En(o.times(u), c), l = a.plus(il(o, new g(i), c)), ta(l.d).slice(0, c) === ta(a.d).slice(0, c))
      return a = a.times(2), s !== 0 && (a = a.plus(gS(g, c + 2, v).times(s + ""))), a = il(a, new g(d), c), g.precision = v, e == null ? (Ln = !0, En(a, v)) : a;
    a = l, i += 2;
  }
}
function AL(n, e) {
  var t, r, i;
  for ((t = e.indexOf(".")) > -1 && (e = e.replace(".", "")), (r = e.search(/e/i)) > 0 ? (t < 0 && (t = r), t += +e.slice(r + 1), e = e.substring(0, r)) : t < 0 && (t = e.length), r = 0; e.charCodeAt(r) === 48; ) ++r;
  for (i = e.length; e.charCodeAt(i - 1) === 48; ) --i;
  if (e = e.slice(r, i), e) {
    if (i -= r, t = t - r - 1, n.e = kh(t / Pn), n.d = [], r = (t + 1) % Pn, t < 0 && (r += Pn), r < i) {
      for (r && n.d.push(+e.slice(0, r)), i -= Pn; r < i; ) n.d.push(+e.slice(r, r += Pn));
      e = e.slice(r), r = Pn - e.length;
    } else
      r -= i;
    for (; r--; ) e += "0";
    if (n.d.push(+e), Ln && (n.e > U2 || n.e < -U2)) throw Error(OM + t);
  } else
    n.s = 0, n.e = 0, n.d = [0];
  return n;
}
function En(n, e, t) {
  var r, i, s, o, a, l, c, u, d = n.d;
  for (o = 1, s = d[0]; s >= 10; s /= 10) o++;
  if (r = e - o, r < 0)
    r += Pn, i = e, c = d[u = 0];
  else {
    if (u = Math.ceil((r + 1) / Pn), s = d.length, u >= s) return n;
    for (c = s = d[u], o = 1; s >= 10; s /= 10) o++;
    r %= Pn, i = r - Pn + o;
  }
  if (t !== void 0 && (s = Yc(10, o - i - 1), a = c / s % 10 | 0, l = e < 0 || d[u + 1] !== void 0 || c % s, l = t < 4 ? (a || l) && (t == 0 || t == (n.s < 0 ? 3 : 2)) : a > 5 || a == 5 && (t == 4 || l || t == 6 && // Check whether the digit to the left of the rounding digit is odd.
  (r > 0 ? i > 0 ? c / Yc(10, o - i) : 0 : d[u - 1]) % 10 & 1 || t == (n.s < 0 ? 8 : 7))), e < 1 || !d[0])
    return l ? (s = cr(n), d.length = 1, e = e - s - 1, d[0] = Yc(10, (Pn - e % Pn) % Pn), n.e = kh(-e / Pn) || 0) : (d.length = 1, d[0] = n.e = n.s = 0), n;
  if (r == 0 ? (d.length = u, s = 1, u--) : (d.length = u + 1, s = Yc(10, Pn - r), d[u] = i > 0 ? (c / Yc(10, o - i) % Yc(10, i) | 0) * s : 0), l)
    for (; ; )
      if (u == 0) {
        (d[0] += s) == Mr && (d[0] = 1, ++n.e);
        break;
      } else {
        if (d[u] += s, d[u] != Mr) break;
        d[u--] = 0, s = 1;
      }
  for (r = d.length; d[--r] === 0; ) d.pop();
  if (Ln && (n.e > U2 || n.e < -U2))
    throw Error(OM + cr(n));
  return n;
}
function Nq(n, e) {
  var t, r, i, s, o, a, l, c, u, d, f = n.constructor, h = f.precision;
  if (!n.s || !e.s)
    return e.s ? e.s = -e.s : e = new f(n), Ln ? En(e, h) : e;
  if (l = n.d, d = e.d, r = e.e, c = n.e, l = l.slice(), o = c - r, o) {
    for (u = o < 0, u ? (t = l, o = -o, a = d.length) : (t = d, r = c, a = l.length), i = Math.max(Math.ceil(h / Pn), a) + 2, o > i && (o = i, t.length = 1), t.reverse(), i = o; i--; ) t.push(0);
    t.reverse();
  } else {
    for (i = l.length, a = d.length, u = i < a, u && (a = i), i = 0; i < a; i++)
      if (l[i] != d[i]) {
        u = l[i] < d[i];
        break;
      }
    o = 0;
  }
  for (u && (t = l, l = d, d = t, e.s = -e.s), a = l.length, i = d.length - a; i > 0; --i) l[a++] = 0;
  for (i = d.length; i > o; ) {
    if (l[--i] < d[i]) {
      for (s = i; s && l[--s] === 0; ) l[s] = Mr - 1;
      --l[s], l[i] += Mr;
    }
    l[i] -= d[i];
  }
  for (; l[--a] === 0; ) l.pop();
  for (; l[0] === 0; l.shift()) --r;
  return l[0] ? (e.d = l, e.e = r, Ln ? En(e, h) : e) : new f(0);
}
function Pu(n, e, t) {
  var r, i = cr(n), s = ta(n.d), o = s.length;
  return e ? (t && (r = t - o) > 0 ? s = s.charAt(0) + "." + s.slice(1) + $l(r) : o > 1 && (s = s.charAt(0) + "." + s.slice(1)), s = s + (i < 0 ? "e" : "e+") + i) : i < 0 ? (s = "0." + $l(-i - 1) + s, t && (r = t - o) > 0 && (s += $l(r))) : i >= o ? (s += $l(i + 1 - o), t && (r = t - i - 1) > 0 && (s = s + "." + $l(r))) : ((r = i + 1) < o && (s = s.slice(0, r) + "." + s.slice(r)), t && (r = t - o) > 0 && (i + 1 === o && (s += "."), s += $l(r))), n.s < 0 ? "-" + s : s;
}
function ML(n, e) {
  if (n.length > e)
    return n.length = e, !0;
}
function Lq(n) {
  var e, t, r;
  function i(s) {
    var o = this;
    if (!(o instanceof i)) return new i(s);
    if (o.constructor = i, s instanceof i) {
      o.s = s.s, o.e = s.e, o.d = (s = s.d) ? s.slice() : s;
      return;
    }
    if (typeof s == "number") {
      if (s * 0 !== 0)
        throw Error(wu + s);
      if (s > 0)
        o.s = 1;
      else if (s < 0)
        s = -s, o.s = -1;
      else {
        o.s = 0, o.e = 0, o.d = [0];
        return;
      }
      if (s === ~~s && s < 1e7) {
        o.e = 0, o.d = [s];
        return;
      }
      return AL(o, s.toString());
    } else if (typeof s != "string")
      throw Error(wu + s);
    if (s.charCodeAt(0) === 45 ? (s = s.slice(1), o.s = -1) : o.s = 1, zye.test(s)) AL(o, s);
    else throw Error(wu + s);
  }
  if (i.prototype = Ke, i.ROUND_UP = 0, i.ROUND_DOWN = 1, i.ROUND_CEIL = 2, i.ROUND_FLOOR = 3, i.ROUND_HALF_UP = 4, i.ROUND_HALF_DOWN = 5, i.ROUND_HALF_EVEN = 6, i.ROUND_HALF_CEIL = 7, i.ROUND_HALF_FLOOR = 8, i.clone = Lq, i.config = i.set = Hye, n === void 0 && (n = {}), n)
    for (r = ["precision", "rounding", "toExpNeg", "toExpPos", "LN10"], e = 0; e < r.length; ) n.hasOwnProperty(t = r[e++]) || (n[t] = this[t]);
  return i.config(n), i;
}
function Hye(n) {
  if (!n || typeof n != "object")
    throw Error(Us + "Object expected");
  var e, t, r, i = [
    "precision",
    1,
    Mh,
    "rounding",
    0,
    8,
    "toExpNeg",
    -1 / 0,
    0,
    "toExpPos",
    0,
    1 / 0
  ];
  for (e = 0; e < i.length; e += 3)
    if ((r = n[t = i[e]]) !== void 0)
      if (kh(r) === r && r >= i[e + 1] && r <= i[e + 2]) this[t] = r;
      else throw Error(wu + t + ": " + r);
  if ((r = n[t = "LN10"]) !== void 0)
    if (r == Math.LN10) this[t] = new this(r);
    else throw Error(wu + t + ": " + r);
  return this;
}
var IM = Lq(Bye);
fs = new IM(1);
const hn = IM;
function Uye(n) {
  return Gye(n) || Wye(n) || jye(n) || Vye();
}
function Vye() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function jye(n, e) {
  if (n) {
    if (typeof n == "string") return HC(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return HC(n, e);
  }
}
function Wye(n) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(n)) return Array.from(n);
}
function Gye(n) {
  if (Array.isArray(n)) return HC(n);
}
function HC(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
var Kye = function(e) {
  return e;
}, $q = {}, Fq = function(e) {
  return e === $q;
}, kL = function(e) {
  return function t() {
    return arguments.length === 0 || arguments.length === 1 && Fq(arguments.length <= 0 ? void 0 : arguments[0]) ? t : e.apply(void 0, arguments);
  };
}, qye = function n(e, t) {
  return e === 1 ? t : kL(function() {
    for (var r = arguments.length, i = new Array(r), s = 0; s < r; s++)
      i[s] = arguments[s];
    var o = i.filter(function(a) {
      return a !== $q;
    }).length;
    return o >= e ? t.apply(void 0, i) : n(e - o, kL(function() {
      for (var a = arguments.length, l = new Array(a), c = 0; c < a; c++)
        l[c] = arguments[c];
      var u = i.map(function(d) {
        return Fq(d) ? l.shift() : d;
      });
      return t.apply(void 0, Uye(u).concat(l));
    }));
  });
}, Hw = function(e) {
  return qye(e.length, e);
}, UC = function(e, t) {
  for (var r = [], i = e; i < t; ++i)
    r[i - e] = i;
  return r;
}, Yye = Hw(function(n, e) {
  return Array.isArray(e) ? e.map(n) : Object.keys(e).map(function(t) {
    return e[t];
  }).map(n);
}), Xye = function() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  if (!t.length)
    return Kye;
  var i = t.reverse(), s = i[0], o = i.slice(1);
  return function() {
    return o.reduce(function(a, l) {
      return l(a);
    }, s.apply(void 0, arguments));
  };
}, VC = function(e) {
  return Array.isArray(e) ? e.reverse() : e.split("").reverse.join("");
}, Bq = function(e) {
  var t = null, r = null;
  return function() {
    for (var i = arguments.length, s = new Array(i), o = 0; o < i; o++)
      s[o] = arguments[o];
    return t && s.every(function(a, l) {
      return a === t[l];
    }) || (t = s, r = e.apply(void 0, s)), r;
  };
};
function Zye(n) {
  var e;
  return n === 0 ? e = 1 : e = Math.floor(new hn(n).abs().log(10).toNumber()) + 1, e;
}
function Qye(n, e, t) {
  for (var r = new hn(n), i = 0, s = []; r.lt(e) && i < 1e5; )
    s.push(r.toNumber()), r = r.add(t), i++;
  return s;
}
var Jye = Hw(function(n, e, t) {
  var r = +n, i = +e;
  return r + t * (i - r);
}), ebe = Hw(function(n, e, t) {
  var r = e - +n;
  return r = r || 1 / 0, (t - n) / r;
}), tbe = Hw(function(n, e, t) {
  var r = e - +n;
  return r = r || 1 / 0, Math.max(0, Math.min(1, (t - n) / r));
});
const Uw = {
  rangeStep: Qye,
  getDigitCount: Zye,
  interpolateNumber: Jye,
  uninterpolateNumber: ebe,
  uninterpolateTruncation: tbe
};
function jC(n) {
  return ibe(n) || rbe(n) || zq(n) || nbe();
}
function nbe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function rbe(n) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(n)) return Array.from(n);
}
function ibe(n) {
  if (Array.isArray(n)) return WC(n);
}
function Im(n, e) {
  return abe(n) || obe(n, e) || zq(n, e) || sbe();
}
function sbe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zq(n, e) {
  if (n) {
    if (typeof n == "string") return WC(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return WC(n, e);
  }
}
function WC(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
function obe(n, e) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(n)))) {
    var t = [], r = !0, i = !1, s = void 0;
    try {
      for (var o = n[Symbol.iterator](), a; !(r = (a = o.next()).done) && (t.push(a.value), !(e && t.length === e)); r = !0)
        ;
    } catch (l) {
      i = !0, s = l;
    } finally {
      try {
        !r && o.return != null && o.return();
      } finally {
        if (i) throw s;
      }
    }
    return t;
  }
}
function abe(n) {
  if (Array.isArray(n)) return n;
}
function Hq(n) {
  var e = Im(n, 2), t = e[0], r = e[1], i = t, s = r;
  return t > r && (i = r, s = t), [i, s];
}
function Uq(n, e, t) {
  if (n.lte(0))
    return new hn(0);
  var r = Uw.getDigitCount(n.toNumber()), i = new hn(10).pow(r), s = n.div(i), o = r !== 1 ? 0.05 : 0.1, a = new hn(Math.ceil(s.div(o).toNumber())).add(t).mul(o), l = a.mul(i);
  return e ? l : new hn(Math.ceil(l));
}
function lbe(n, e, t) {
  var r = 1, i = new hn(n);
  if (!i.isint() && t) {
    var s = Math.abs(n);
    s < 1 ? (r = new hn(10).pow(Uw.getDigitCount(n) - 1), i = new hn(Math.floor(i.div(r).toNumber())).mul(r)) : s > 1 && (i = new hn(Math.floor(n)));
  } else n === 0 ? i = new hn(Math.floor((e - 1) / 2)) : t || (i = new hn(Math.floor(n)));
  var o = Math.floor((e - 1) / 2), a = Xye(Yye(function(l) {
    return i.add(new hn(l - o).mul(r)).toNumber();
  }), UC);
  return a(0, e);
}
function Vq(n, e, t, r) {
  var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
  if (!Number.isFinite((e - n) / (t - 1)))
    return {
      step: new hn(0),
      tickMin: new hn(0),
      tickMax: new hn(0)
    };
  var s = Uq(new hn(e).sub(n).div(t - 1), r, i), o;
  n <= 0 && e >= 0 ? o = new hn(0) : (o = new hn(n).add(e).div(2), o = o.sub(new hn(o).mod(s)));
  var a = Math.ceil(o.sub(n).div(s).toNumber()), l = Math.ceil(new hn(e).sub(o).div(s).toNumber()), c = a + l + 1;
  return c > t ? Vq(n, e, t, r, i + 1) : (c < t && (l = e > 0 ? l + (t - c) : l, a = e > 0 ? a : a + (t - c)), {
    step: s,
    tickMin: o.sub(new hn(a).mul(s)),
    tickMax: o.add(new hn(l).mul(s))
  });
}
function cbe(n) {
  var e = Im(n, 2), t = e[0], r = e[1], i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 6, s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = Math.max(i, 2), a = Hq([t, r]), l = Im(a, 2), c = l[0], u = l[1];
  if (c === -1 / 0 || u === 1 / 0) {
    var d = u === 1 / 0 ? [c].concat(jC(UC(0, i - 1).map(function() {
      return 1 / 0;
    }))) : [].concat(jC(UC(0, i - 1).map(function() {
      return -1 / 0;
    })), [u]);
    return t > r ? VC(d) : d;
  }
  if (c === u)
    return lbe(c, i, s);
  var f = Vq(c, u, o, s), h = f.step, m = f.tickMin, g = f.tickMax, v = Uw.rangeStep(m, g.add(new hn(0.1).mul(h)), h);
  return t > r ? VC(v) : v;
}
function ube(n, e) {
  var t = Im(n, 2), r = t[0], i = t[1], s = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0, o = Hq([r, i]), a = Im(o, 2), l = a[0], c = a[1];
  if (l === -1 / 0 || c === 1 / 0)
    return [r, i];
  if (l === c)
    return [l];
  var u = Math.max(e, 2), d = Uq(new hn(c).sub(l).div(u - 1), s, 0), f = [].concat(jC(Uw.rangeStep(new hn(l), new hn(c).sub(new hn(0.99).mul(d)), d)), [c]);
  return r > i ? VC(f) : f;
}
var dbe = Bq(cbe), fbe = Bq(ube), hbe = process.env.NODE_ENV === "production", vS = "Invariant failed";
function Fi(n, e) {
  if (hbe)
    throw new Error(vS);
  var t = typeof e == "function" ? e() : e, r = t ? "".concat(vS, ": ").concat(t) : vS;
  throw new Error(r);
}
var pbe = ["offset", "layout", "width", "dataKey", "data", "dataPointFormatter", "xAxis", "yAxis"];
function If(n) {
  "@babel/helpers - typeof";
  return If = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, If(n);
}
function V2() {
  return V2 = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, V2.apply(this, arguments);
}
function mbe(n, e) {
  return bbe(n) || ybe(n, e) || vbe(n, e) || gbe();
}
function gbe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function vbe(n, e) {
  if (n) {
    if (typeof n == "string") return _L(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return _L(n, e);
  }
}
function _L(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function ybe(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r, i, s, o, a = [], l = !0, c = !1;
    try {
      if (s = (t = t.call(n)).next, e !== 0) for (; !(l = (r = s.call(t)).done) && (a.push(r.value), a.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && t.return != null && (o = t.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return a;
  }
}
function bbe(n) {
  if (Array.isArray(n)) return n;
}
function wbe(n, e) {
  if (n == null) return {};
  var t = xbe(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function xbe(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n)
    if (Object.prototype.hasOwnProperty.call(n, r)) {
      if (e.indexOf(r) >= 0) continue;
      t[r] = n[r];
    }
  return t;
}
function Ebe(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Sbe(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, Gq(r.key), r);
  }
}
function Cbe(n, e, t) {
  return e && Sbe(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function Tbe(n, e, t) {
  return e = j2(e), Abe(n, jq() ? Reflect.construct(e, t || [], j2(n).constructor) : e.apply(n, t));
}
function Abe(n, e) {
  if (e && (If(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Mbe(n);
}
function Mbe(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function jq() {
  try {
    var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (jq = function() {
    return !!n;
  })();
}
function j2(n) {
  return j2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, j2(n);
}
function kbe(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && GC(n, e);
}
function GC(n, e) {
  return GC = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, GC(n, e);
}
function Wq(n, e, t) {
  return e = Gq(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function Gq(n) {
  var e = _be(n, "string");
  return If(e) == "symbol" ? e : e + "";
}
function _be(n, e) {
  if (If(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (If(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
var Vw = /* @__PURE__ */ (function(n) {
  function e() {
    return Ebe(this, e), Tbe(this, e, arguments);
  }
  return kbe(e, n), Cbe(e, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.offset, s = r.layout, o = r.width, a = r.dataKey, l = r.data, c = r.dataPointFormatter, u = r.xAxis, d = r.yAxis, f = wbe(r, pbe), h = $t(f, !1);
      this.props.direction === "x" && u.type !== "number" && (process.env.NODE_ENV !== "production" ? Fi(!1, 'ErrorBar requires Axis type property to be "number".') : Fi());
      var m = l.map(function(g) {
        var v = c(g, a), y = v.x, b = v.y, x = v.value, E = v.errorVal;
        if (!E)
          return null;
        var w = [], C, S;
        if (Array.isArray(E)) {
          var M = mbe(E, 2);
          C = M[0], S = M[1];
        } else
          C = S = E;
        if (s === "vertical") {
          var k = u.scale, _ = b + i, O = _ + o, I = _ - o, R = k(x - C), P = k(x + S);
          w.push({
            x1: P,
            y1: O,
            x2: P,
            y2: I
          }), w.push({
            x1: R,
            y1: _,
            x2: P,
            y2: _
          }), w.push({
            x1: R,
            y1: O,
            x2: R,
            y2: I
          });
        } else if (s === "horizontal") {
          var D = d.scale, L = y + i, B = L - o, $ = L + o, z = D(x - C), H = D(x + S);
          w.push({
            x1: B,
            y1: H,
            x2: $,
            y2: H
          }), w.push({
            x1: L,
            y1: z,
            x2: L,
            y2: H
          }), w.push({
            x1: B,
            y1: z,
            x2: $,
            y2: z
          });
        }
        return /* @__PURE__ */ p.createElement(jn, V2({
          className: "recharts-errorBar",
          key: "bar-".concat(w.map(function(U) {
            return "".concat(U.x1, "-").concat(U.x2, "-").concat(U.y1, "-").concat(U.y2);
          }))
        }, h), w.map(function(U) {
          return /* @__PURE__ */ p.createElement("line", V2({}, U, {
            key: "line-".concat(U.x1, "-").concat(U.x2, "-").concat(U.y1, "-").concat(U.y2)
          }));
        }));
      });
      return /* @__PURE__ */ p.createElement(jn, {
        className: "recharts-errorBars"
      }, m);
    }
  }]);
})(p.Component);
Wq(Vw, "defaultProps", {
  stroke: "black",
  strokeWidth: 1.5,
  width: 5,
  offset: 0,
  layout: "horizontal"
});
Wq(Vw, "displayName", "ErrorBar");
function Rm(n) {
  "@babel/helpers - typeof";
  return Rm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Rm(n);
}
function OL(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Uc(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? OL(Object(t), !0).forEach(function(r) {
      Obe(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : OL(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function Obe(n, e, t) {
  return e = Ibe(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function Ibe(n) {
  var e = Rbe(n, "string");
  return Rm(e) == "symbol" ? e : e + "";
}
function Rbe(n, e) {
  if (Rm(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Rm(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
var Kq = function(e) {
  var t = e.children, r = e.formattedGraphicalItems, i = e.legendWidth, s = e.legendContent, o = ss(t, yu);
  if (!o)
    return null;
  var a = yu.defaultProps, l = a !== void 0 ? Uc(Uc({}, a), o.props) : {}, c;
  return o.props && o.props.payload ? c = o.props && o.props.payload : s === "children" ? c = (r || []).reduce(function(u, d) {
    var f = d.item, h = d.props, m = h.sectors || h.data || [];
    return u.concat(m.map(function(g) {
      return {
        type: o.props.iconType || f.props.legendType,
        value: g.name,
        color: g.fill,
        payload: g
      };
    }));
  }, []) : c = (r || []).map(function(u) {
    var d = u.item, f = d.type.defaultProps, h = f !== void 0 ? Uc(Uc({}, f), d.props) : {}, m = h.dataKey, g = h.name, v = h.legendType, y = h.hide;
    return {
      inactive: y,
      dataKey: m,
      type: l.iconType || v || "square",
      color: RM(d),
      value: g || m,
      // @ts-expect-error property strokeDasharray is required in Payload but optional in props
      payload: h
    };
  }), Uc(Uc(Uc({}, l), yu.getWithHeight(o, i)), {}, {
    payload: c,
    item: o
  });
};
function Pm(n) {
  "@babel/helpers - typeof";
  return Pm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Pm(n);
}
function IL(n) {
  return Lbe(n) || Nbe(n) || Dbe(n) || Pbe();
}
function Pbe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Dbe(n, e) {
  if (n) {
    if (typeof n == "string") return KC(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return KC(n, e);
  }
}
function Nbe(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function Lbe(n) {
  if (Array.isArray(n)) return KC(n);
}
function KC(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function RL(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function qn(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? RL(Object(t), !0).forEach(function(r) {
      of(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : RL(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function of(n, e, t) {
  return e = $be(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function $be(n) {
  var e = Fbe(n, "string");
  return Pm(e) == "symbol" ? e : e + "";
}
function Fbe(n, e) {
  if (Pm(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Pm(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function ys(n, e, t) {
  return Bt(n) || Bt(e) ? t : Sr(e) ? Ls(n, e, t) : Mt(e) ? e(n) : t;
}
function jp(n, e, t, r) {
  var i = Lye(n, function(a) {
    return ys(a, e);
  });
  if (t === "number") {
    var s = i.filter(function(a) {
      return ke(a) || parseFloat(a);
    });
    return s.length ? [zw(s), Yl(s)] : [1 / 0, -1 / 0];
  }
  var o = r ? i.filter(function(a) {
    return !Bt(a);
  }) : i;
  return o.map(function(a) {
    return Sr(a) || a instanceof Date ? a : "";
  });
}
var Bbe = function(e) {
  var t, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], i = arguments.length > 2 ? arguments[2] : void 0, s = arguments.length > 3 ? arguments[3] : void 0, o = -1, a = (t = r?.length) !== null && t !== void 0 ? t : 0;
  if (a <= 1)
    return 0;
  if (s && s.axisType === "angleAxis" && Math.abs(Math.abs(s.range[1] - s.range[0]) - 360) <= 1e-6)
    for (var l = s.range, c = 0; c < a; c++) {
      var u = c > 0 ? i[c - 1].coordinate : i[a - 1].coordinate, d = i[c].coordinate, f = c >= a - 1 ? i[0].coordinate : i[c + 1].coordinate, h = void 0;
      if (co(d - u) !== co(f - d)) {
        var m = [];
        if (co(f - d) === co(l[1] - l[0])) {
          h = f;
          var g = d + l[1] - l[0];
          m[0] = Math.min(g, (g + u) / 2), m[1] = Math.max(g, (g + u) / 2);
        } else {
          h = u;
          var v = f + l[1] - l[0];
          m[0] = Math.min(d, (v + d) / 2), m[1] = Math.max(d, (v + d) / 2);
        }
        var y = [Math.min(d, (h + d) / 2), Math.max(d, (h + d) / 2)];
        if (e > y[0] && e <= y[1] || e >= m[0] && e <= m[1]) {
          o = i[c].index;
          break;
        }
      } else {
        var b = Math.min(u, f), x = Math.max(u, f);
        if (e > (b + d) / 2 && e <= (x + d) / 2) {
          o = i[c].index;
          break;
        }
      }
    }
  else
    for (var E = 0; E < a; E++)
      if (E === 0 && e <= (r[E].coordinate + r[E + 1].coordinate) / 2 || E > 0 && E < a - 1 && e > (r[E].coordinate + r[E - 1].coordinate) / 2 && e <= (r[E].coordinate + r[E + 1].coordinate) / 2 || E === a - 1 && e > (r[E].coordinate + r[E - 1].coordinate) / 2) {
        o = r[E].index;
        break;
      }
  return o;
}, RM = function(e) {
  var t, r = e, i = r.type.displayName, s = (t = e.type) !== null && t !== void 0 && t.defaultProps ? qn(qn({}, e.type.defaultProps), e.props) : e.props, o = s.stroke, a = s.fill, l;
  switch (i) {
    case "Line":
      l = o;
      break;
    case "Area":
    case "Radar":
      l = o && o !== "none" ? o : a;
      break;
    default:
      l = a;
      break;
  }
  return l;
}, zbe = function(e) {
  var t = e.barSize, r = e.totalSize, i = e.stackGroups, s = i === void 0 ? {} : i;
  if (!s)
    return {};
  for (var o = {}, a = Object.keys(s), l = 0, c = a.length; l < c; l++)
    for (var u = s[a[l]].stackGroups, d = Object.keys(u), f = 0, h = d.length; f < h; f++) {
      var m = u[d[f]], g = m.items, v = m.cateAxisId, y = g.filter(function(S) {
        return nl(S.type).indexOf("Bar") >= 0;
      });
      if (y && y.length) {
        var b = y[0].type.defaultProps, x = b !== void 0 ? qn(qn({}, b), y[0].props) : y[0].props, E = x.barSize, w = x[v];
        o[w] || (o[w] = []);
        var C = Bt(E) ? t : E;
        o[w].push({
          item: y[0],
          stackList: y.slice(1),
          barSize: Bt(C) ? void 0 : Ru(C, r, 0)
        });
      }
    }
  return o;
}, Hbe = function(e) {
  var t = e.barGap, r = e.barCategoryGap, i = e.bandSize, s = e.sizeList, o = s === void 0 ? [] : s, a = e.maxBarSize, l = o.length;
  if (l < 1) return null;
  var c = Ru(t, i, 0, !0), u, d = [];
  if (o[0].barSize === +o[0].barSize) {
    var f = !1, h = i / l, m = o.reduce(function(E, w) {
      return E + w.barSize || 0;
    }, 0);
    m += (l - 1) * c, m >= i && (m -= (l - 1) * c, c = 0), m >= i && h > 0 && (f = !0, h *= 0.9, m = l * h);
    var g = (i - m) / 2 >> 0, v = {
      offset: g - c,
      size: 0
    };
    u = o.reduce(function(E, w) {
      var C = {
        item: w.item,
        position: {
          offset: v.offset + v.size + c,
          // @ts-expect-error the type check above does not check for type number explicitly
          size: f ? h : w.barSize
        }
      }, S = [].concat(IL(E), [C]);
      return v = S[S.length - 1].position, w.stackList && w.stackList.length && w.stackList.forEach(function(M) {
        S.push({
          item: M,
          position: v
        });
      }), S;
    }, d);
  } else {
    var y = Ru(r, i, 0, !0);
    i - 2 * y - (l - 1) * c <= 0 && (c = 0);
    var b = (i - 2 * y - (l - 1) * c) / l;
    b > 1 && (b >>= 0);
    var x = a === +a ? Math.min(b, a) : b;
    u = o.reduce(function(E, w, C) {
      var S = [].concat(IL(E), [{
        item: w.item,
        position: {
          offset: y + (b + c) * C + (b - x) / 2,
          size: x
        }
      }]);
      return w.stackList && w.stackList.length && w.stackList.forEach(function(M) {
        S.push({
          item: M,
          position: S[S.length - 1].position
        });
      }), S;
    }, d);
  }
  return u;
}, Ube = function(e, t, r, i) {
  var s = r.children, o = r.width, a = r.margin, l = o - (a.left || 0) - (a.right || 0), c = Kq({
    children: s,
    legendWidth: l
  });
  if (c) {
    var u = i || {}, d = u.width, f = u.height, h = c.align, m = c.verticalAlign, g = c.layout;
    if ((g === "vertical" || g === "horizontal" && m === "middle") && h !== "center" && ke(e[h]))
      return qn(qn({}, e), {}, of({}, h, e[h] + (d || 0)));
    if ((g === "horizontal" || g === "vertical" && h === "center") && m !== "middle" && ke(e[m]))
      return qn(qn({}, e), {}, of({}, m, e[m] + (f || 0)));
  }
  return e;
}, Vbe = function(e, t, r) {
  return Bt(t) ? !0 : e === "horizontal" ? t === "yAxis" : e === "vertical" || r === "x" ? t === "xAxis" : r === "y" ? t === "yAxis" : !0;
}, qq = function(e, t, r, i, s) {
  var o = t.props.children, a = go(o, Vw).filter(function(c) {
    return Vbe(i, s, c.props.direction);
  });
  if (a && a.length) {
    var l = a.map(function(c) {
      return c.props.dataKey;
    });
    return e.reduce(function(c, u) {
      var d = ys(u, r);
      if (Bt(d)) return c;
      var f = Array.isArray(d) ? [zw(d), Yl(d)] : [d, d], h = l.reduce(function(m, g) {
        var v = ys(u, g, 0), y = f[0] - Math.abs(Array.isArray(v) ? v[0] : v), b = f[1] + Math.abs(Array.isArray(v) ? v[1] : v);
        return [Math.min(y, m[0]), Math.max(b, m[1])];
      }, [1 / 0, -1 / 0]);
      return [Math.min(h[0], c[0]), Math.max(h[1], c[1])];
    }, [1 / 0, -1 / 0]);
  }
  return null;
}, jbe = function(e, t, r, i, s) {
  var o = t.map(function(a) {
    return qq(e, a, r, s, i);
  }).filter(function(a) {
    return !Bt(a);
  });
  return o && o.length ? o.reduce(function(a, l) {
    return [Math.min(a[0], l[0]), Math.max(a[1], l[1])];
  }, [1 / 0, -1 / 0]) : null;
}, Yq = function(e, t, r, i, s) {
  var o = t.map(function(l) {
    var c = l.props.dataKey;
    return r === "number" && c && qq(e, l, c, i) || jp(e, c, r, s);
  });
  if (r === "number")
    return o.reduce(
      // @ts-expect-error if (type === number) means that the domain is numerical type
      // - but this link is missing in the type definition
      function(l, c) {
        return [Math.min(l[0], c[0]), Math.max(l[1], c[1])];
      },
      [1 / 0, -1 / 0]
    );
  var a = {};
  return o.reduce(function(l, c) {
    for (var u = 0, d = c.length; u < d; u++)
      a[c[u]] || (a[c[u]] = !0, l.push(c[u]));
    return l;
  }, []);
}, Xq = function(e, t) {
  return e === "horizontal" && t === "xAxis" || e === "vertical" && t === "yAxis" || e === "centric" && t === "angleAxis" || e === "radial" && t === "radiusAxis";
}, Zq = function(e, t, r, i) {
  if (i)
    return e.map(function(l) {
      return l.coordinate;
    });
  var s, o, a = e.map(function(l) {
    return l.coordinate === t && (s = !0), l.coordinate === r && (o = !0), l.coordinate;
  });
  return s || a.push(t), o || a.push(r), a;
}, Za = function(e, t, r) {
  if (!e) return null;
  var i = e.scale, s = e.duplicateDomain, o = e.type, a = e.range, l = e.realScaleType === "scaleBand" ? i.bandwidth() / 2 : 2, c = (t || r) && o === "category" && i.bandwidth ? i.bandwidth() / l : 0;
  if (c = e.axisType === "angleAxis" && a?.length >= 2 ? co(a[0] - a[1]) * 2 * c : c, t && (e.ticks || e.niceTicks)) {
    var u = (e.ticks || e.niceTicks).map(function(d) {
      var f = s ? s.indexOf(d) : d;
      return {
        // If the scaleContent is not a number, the coordinate will be NaN.
        // That could be the case for example with a PointScale and a string as domain.
        coordinate: i(f) + c,
        value: d,
        offset: c
      };
    });
    return u.filter(function(d) {
      return !Sh(d.coordinate);
    });
  }
  return e.isCategorical && e.categoricalDomain ? e.categoricalDomain.map(function(d, f) {
    return {
      coordinate: i(d) + c,
      value: d,
      index: f,
      offset: c
    };
  }) : i.ticks && !r ? i.ticks(e.tickCount).map(function(d) {
    return {
      coordinate: i(d) + c,
      value: d,
      offset: c
    };
  }) : i.domain().map(function(d, f) {
    return {
      coordinate: i(d) + c,
      value: s ? s[d] : d,
      index: f,
      offset: c
    };
  });
}, yS = /* @__PURE__ */ new WeakMap(), hg = function(e, t) {
  if (typeof t != "function")
    return e;
  yS.has(e) || yS.set(e, /* @__PURE__ */ new WeakMap());
  var r = yS.get(e);
  if (r.has(t))
    return r.get(t);
  var i = function() {
    e.apply(void 0, arguments), t.apply(void 0, arguments);
  };
  return r.set(t, i), i;
}, Wbe = function(e, t, r) {
  var i = e.scale, s = e.type, o = e.layout, a = e.axisType;
  if (i === "auto")
    return o === "radial" && a === "radiusAxis" ? {
      scale: Cm(),
      realScaleType: "band"
    } : o === "radial" && a === "angleAxis" ? {
      scale: F2(),
      realScaleType: "linear"
    } : s === "category" && t && (t.indexOf("LineChart") >= 0 || t.indexOf("AreaChart") >= 0 || t.indexOf("ComposedChart") >= 0 && !r) ? {
      scale: Vp(),
      realScaleType: "point"
    } : s === "category" ? {
      scale: Cm(),
      realScaleType: "band"
    } : {
      scale: F2(),
      realScaleType: "linear"
    };
  if (Iu(i)) {
    var l = "scale".concat(Mw(i));
    return {
      scale: (vL[l] || Vp)(),
      realScaleType: vL[l] ? l : "point"
    };
  }
  return Mt(i) ? {
    scale: i
  } : {
    scale: Vp(),
    realScaleType: "point"
  };
}, PL = 1e-4, Gbe = function(e) {
  var t = e.domain();
  if (!(!t || t.length <= 2)) {
    var r = t.length, i = e.range(), s = Math.min(i[0], i[1]) - PL, o = Math.max(i[0], i[1]) + PL, a = e(t[0]), l = e(t[r - 1]);
    (a < s || a > o || l < s || l > o) && e.domain([t[0], t[r - 1]]);
  }
}, Kbe = function(e, t) {
  if (!e)
    return null;
  for (var r = 0, i = e.length; r < i; r++)
    if (e[r].item === t)
      return e[r].position;
  return null;
}, qbe = function(e, t) {
  if (!t || t.length !== 2 || !ke(t[0]) || !ke(t[1]))
    return e;
  var r = Math.min(t[0], t[1]), i = Math.max(t[0], t[1]), s = [e[0], e[1]];
  return (!ke(e[0]) || e[0] < r) && (s[0] = r), (!ke(e[1]) || e[1] > i) && (s[1] = i), s[0] > i && (s[0] = i), s[1] < r && (s[1] = r), s;
}, Ybe = function(e) {
  var t = e.length;
  if (!(t <= 0))
    for (var r = 0, i = e[0].length; r < i; ++r)
      for (var s = 0, o = 0, a = 0; a < t; ++a) {
        var l = Sh(e[a][r][1]) ? e[a][r][0] : e[a][r][1];
        l >= 0 ? (e[a][r][0] = s, e[a][r][1] = s + l, s = e[a][r][1]) : (e[a][r][0] = o, e[a][r][1] = o + l, o = e[a][r][1]);
      }
}, Xbe = function(e) {
  var t = e.length;
  if (!(t <= 0))
    for (var r = 0, i = e[0].length; r < i; ++r)
      for (var s = 0, o = 0; o < t; ++o) {
        var a = Sh(e[o][r][1]) ? e[o][r][0] : e[o][r][1];
        a >= 0 ? (e[o][r][0] = s, e[o][r][1] = s + a, s = e[o][r][1]) : (e[o][r][0] = 0, e[o][r][1] = 0);
      }
}, Zbe = {
  sign: Ybe,
  // @ts-expect-error definitelytyped types are incorrect
  expand: Pme,
  // @ts-expect-error definitelytyped types are incorrect
  none: Sf,
  // @ts-expect-error definitelytyped types are incorrect
  silhouette: Dme,
  // @ts-expect-error definitelytyped types are incorrect
  wiggle: Nme,
  positive: Xbe
}, Qbe = function(e, t, r) {
  var i = t.map(function(a) {
    return a.props.dataKey;
  }), s = Zbe[r], o = Rme().keys(i).value(function(a, l) {
    return +ys(a, l, 0);
  }).order(SC).offset(s);
  return o(e);
}, Jbe = function(e, t, r, i, s, o) {
  if (!e)
    return null;
  var a = o ? t.reverse() : t, l = {}, c = a.reduce(function(d, f) {
    var h, m = (h = f.type) !== null && h !== void 0 && h.defaultProps ? qn(qn({}, f.type.defaultProps), f.props) : f.props, g = m.stackId, v = m.hide;
    if (v)
      return d;
    var y = m[r], b = d[y] || {
      hasStack: !1,
      stackGroups: {}
    };
    if (Sr(g)) {
      var x = b.stackGroups[g] || {
        numericAxisId: r,
        cateAxisId: i,
        items: []
      };
      x.items.push(f), b.hasStack = !0, b.stackGroups[g] = x;
    } else
      b.stackGroups[l1("_stackId_")] = {
        numericAxisId: r,
        cateAxisId: i,
        items: [f]
      };
    return qn(qn({}, d), {}, of({}, y, b));
  }, l), u = {};
  return Object.keys(c).reduce(function(d, f) {
    var h = c[f];
    if (h.hasStack) {
      var m = {};
      h.stackGroups = Object.keys(h.stackGroups).reduce(function(g, v) {
        var y = h.stackGroups[v];
        return qn(qn({}, g), {}, of({}, v, {
          numericAxisId: r,
          cateAxisId: i,
          items: y.items,
          stackedData: Qbe(e, y.items, s)
        }));
      }, m);
    }
    return qn(qn({}, d), {}, of({}, f, h));
  }, u);
}, ewe = function(e, t) {
  var r = t.realScaleType, i = t.type, s = t.tickCount, o = t.originalDomain, a = t.allowDecimals, l = r || t.scale;
  if (l !== "auto" && l !== "linear")
    return null;
  if (s && i === "number" && o && (o[0] === "auto" || o[1] === "auto")) {
    var c = e.domain();
    if (!c.length)
      return null;
    var u = dbe(c, s, a);
    return e.domain([zw(u), Yl(u)]), {
      niceTicks: u
    };
  }
  if (s && i === "number") {
    var d = e.domain(), f = fbe(d, s, a);
    return {
      niceTicks: f
    };
  }
  return null;
};
function DL(n) {
  var e = n.axis, t = n.ticks, r = n.bandSize, i = n.entry, s = n.index, o = n.dataKey;
  if (e.type === "category") {
    if (!e.allowDuplicatedCategory && e.dataKey && !Bt(i[e.dataKey])) {
      var a = y2(t, "value", i[e.dataKey]);
      if (a)
        return a.coordinate + r / 2;
    }
    return t[s] ? t[s].coordinate + r / 2 : null;
  }
  var l = ys(i, Bt(o) ? e.dataKey : o);
  return Bt(l) ? null : e.scale(l);
}
var NL = function(e) {
  var t = e.axis, r = e.ticks, i = e.offset, s = e.bandSize, o = e.entry, a = e.index;
  if (t.type === "category")
    return r[a] ? r[a].coordinate + i : null;
  var l = ys(o, t.dataKey, t.domain[a]);
  return Bt(l) ? null : t.scale(l) - s / 2 + i;
}, twe = function(e) {
  var t = e.numericAxis, r = t.scale.domain();
  if (t.type === "number") {
    var i = Math.min(r[0], r[1]), s = Math.max(r[0], r[1]);
    return i <= 0 && s >= 0 ? 0 : s < 0 ? s : i;
  }
  return r[0];
}, nwe = function(e, t) {
  var r, i = (r = e.type) !== null && r !== void 0 && r.defaultProps ? qn(qn({}, e.type.defaultProps), e.props) : e.props, s = i.stackId;
  if (Sr(s)) {
    var o = t[s];
    if (o) {
      var a = o.items.indexOf(e);
      return a >= 0 ? o.stackedData[a] : null;
    }
  }
  return null;
}, rwe = function(e) {
  return e.reduce(function(t, r) {
    return [zw(r.concat([t[0]]).filter(ke)), Yl(r.concat([t[1]]).filter(ke))];
  }, [1 / 0, -1 / 0]);
}, Qq = function(e, t, r) {
  return Object.keys(e).reduce(function(i, s) {
    var o = e[s], a = o.stackedData, l = a.reduce(function(c, u) {
      var d = rwe(u.slice(t, r + 1));
      return [Math.min(c[0], d[0]), Math.max(c[1], d[1])];
    }, [1 / 0, -1 / 0]);
    return [Math.min(l[0], i[0]), Math.max(l[1], i[1])];
  }, [1 / 0, -1 / 0]).map(function(i) {
    return i === 1 / 0 || i === -1 / 0 ? 0 : i;
  });
}, LL = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, $L = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/, qC = function(e, t, r) {
  if (Mt(e))
    return e(t, r);
  if (!Array.isArray(e))
    return t;
  var i = [];
  if (ke(e[0]))
    i[0] = r ? e[0] : Math.min(e[0], t[0]);
  else if (LL.test(e[0])) {
    var s = +LL.exec(e[0])[1];
    i[0] = t[0] - s;
  } else Mt(e[0]) ? i[0] = e[0](t[0]) : i[0] = t[0];
  if (ke(e[1]))
    i[1] = r ? e[1] : Math.max(e[1], t[1]);
  else if ($L.test(e[1])) {
    var o = +$L.exec(e[1])[1];
    i[1] = t[1] + o;
  } else Mt(e[1]) ? i[1] = e[1](t[1]) : i[1] = t[1];
  return i;
}, W2 = function(e, t, r) {
  if (e && e.scale && e.scale.bandwidth) {
    var i = e.scale.bandwidth();
    if (!r || i > 0)
      return i;
  }
  if (e && t && t.length >= 2) {
    for (var s = oM(t, function(d) {
      return d.coordinate;
    }), o = 1 / 0, a = 1, l = s.length; a < l; a++) {
      var c = s[a], u = s[a - 1];
      o = Math.min((c.coordinate || 0) - (u.coordinate || 0), o);
    }
    return o === 1 / 0 ? 0 : o;
  }
  return r ? void 0 : 0;
}, FL = function(e, t, r) {
  return !e || !e.length || _m(e, Ls(r, "type.defaultProps.domain")) ? t : e;
}, Jq = function(e, t) {
  var r = e.type.defaultProps ? qn(qn({}, e.type.defaultProps), e.props) : e.props, i = r.dataKey, s = r.name, o = r.unit, a = r.formatter, l = r.tooltipType, c = r.chartType, u = r.hide;
  return qn(qn({}, $t(e, !1)), {}, {
    dataKey: i,
    unit: o,
    formatter: a,
    name: s || i,
    color: RM(e),
    value: ys(t, i),
    type: l,
    payload: t,
    chartType: c,
    hide: u
  });
};
function Dm(n) {
  "@babel/helpers - typeof";
  return Dm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Dm(n);
}
function BL(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function zL(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? BL(Object(t), !0).forEach(function(r) {
      iwe(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : BL(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function iwe(n, e, t) {
  return e = swe(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function swe(n) {
  var e = owe(n, "string");
  return Dm(e) == "symbol" ? e : e + "";
}
function owe(n, e) {
  if (Dm(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Dm(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
var G2 = Math.PI / 180, awe = function(e) {
  return e * 180 / Math.PI;
}, jr = function(e, t, r, i) {
  return {
    x: e + Math.cos(-G2 * i) * r,
    y: t + Math.sin(-G2 * i) * r
  };
}, lwe = function(e, t) {
  var r = e.x, i = e.y, s = t.x, o = t.y;
  return Math.sqrt(Math.pow(r - s, 2) + Math.pow(i - o, 2));
}, cwe = function(e, t) {
  var r = e.x, i = e.y, s = t.cx, o = t.cy, a = lwe({
    x: r,
    y: i
  }, {
    x: s,
    y: o
  });
  if (a <= 0)
    return {
      radius: a
    };
  var l = (r - s) / a, c = Math.acos(l);
  return i > o && (c = 2 * Math.PI - c), {
    radius: a,
    angle: awe(c),
    angleInRadian: c
  };
}, uwe = function(e) {
  var t = e.startAngle, r = e.endAngle, i = Math.floor(t / 360), s = Math.floor(r / 360), o = Math.min(i, s);
  return {
    startAngle: t - o * 360,
    endAngle: r - o * 360
  };
}, dwe = function(e, t) {
  var r = t.startAngle, i = t.endAngle, s = Math.floor(r / 360), o = Math.floor(i / 360), a = Math.min(s, o);
  return e + a * 360;
}, HL = function(e, t) {
  var r = e.x, i = e.y, s = cwe({
    x: r,
    y: i
  }, t), o = s.radius, a = s.angle, l = t.innerRadius, c = t.outerRadius;
  if (o < l || o > c)
    return !1;
  if (o === 0)
    return !0;
  var u = uwe(t), d = u.startAngle, f = u.endAngle, h = a, m;
  if (d <= f) {
    for (; h > f; )
      h -= 360;
    for (; h < d; )
      h += 360;
    m = h >= d && h <= f;
  } else {
    for (; h > d; )
      h -= 360;
    for (; h < f; )
      h += 360;
    m = h >= f && h <= d;
  }
  return m ? zL(zL({}, t), {}, {
    radius: o,
    angle: dwe(h, t)
  }) : null;
};
function Nm(n) {
  "@babel/helpers - typeof";
  return Nm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Nm(n);
}
var fwe = ["offset"];
function hwe(n) {
  return vwe(n) || gwe(n) || mwe(n) || pwe();
}
function pwe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function mwe(n, e) {
  if (n) {
    if (typeof n == "string") return YC(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return YC(n, e);
  }
}
function gwe(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function vwe(n) {
  if (Array.isArray(n)) return YC(n);
}
function YC(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function ywe(n, e) {
  if (n == null) return {};
  var t = bwe(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function bwe(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n)
    if (Object.prototype.hasOwnProperty.call(n, r)) {
      if (e.indexOf(r) >= 0) continue;
      t[r] = n[r];
    }
  return t;
}
function UL(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function gr(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? UL(Object(t), !0).forEach(function(r) {
      wwe(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : UL(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function wwe(n, e, t) {
  return e = xwe(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function xwe(n) {
  var e = Ewe(n, "string");
  return Nm(e) == "symbol" ? e : e + "";
}
function Ewe(n, e) {
  if (Nm(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Nm(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function Lm() {
  return Lm = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, Lm.apply(this, arguments);
}
var Swe = function(e) {
  var t = e.value, r = e.formatter, i = Bt(e.children) ? t : e.children;
  return Mt(r) ? r(i) : i;
}, Cwe = function(e, t) {
  var r = co(t - e), i = Math.min(Math.abs(t - e), 360);
  return r * i;
}, Twe = function(e, t, r) {
  var i = e.position, s = e.viewBox, o = e.offset, a = e.className, l = s, c = l.cx, u = l.cy, d = l.innerRadius, f = l.outerRadius, h = l.startAngle, m = l.endAngle, g = l.clockWise, v = (d + f) / 2, y = Cwe(h, m), b = y >= 0 ? 1 : -1, x, E;
  i === "insideStart" ? (x = h + b * o, E = g) : i === "insideEnd" ? (x = m - b * o, E = !g) : i === "end" && (x = m + b * o, E = g), E = y <= 0 ? E : !E;
  var w = jr(c, u, v, x), C = jr(c, u, v, x + (E ? 1 : -1) * 359), S = "M".concat(w.x, ",").concat(w.y, `
    A`).concat(v, ",").concat(v, ",0,1,").concat(E ? 0 : 1, `,
    `).concat(C.x, ",").concat(C.y), M = Bt(e.id) ? l1("recharts-radial-line-") : e.id;
  return /* @__PURE__ */ p.createElement("text", Lm({}, r, {
    dominantBaseline: "central",
    className: Ut("recharts-radial-bar-label", a)
  }), /* @__PURE__ */ p.createElement("defs", null, /* @__PURE__ */ p.createElement("path", {
    id: M,
    d: S
  })), /* @__PURE__ */ p.createElement("textPath", {
    xlinkHref: "#".concat(M)
  }, t));
}, Awe = function(e) {
  var t = e.viewBox, r = e.offset, i = e.position, s = t, o = s.cx, a = s.cy, l = s.innerRadius, c = s.outerRadius, u = s.startAngle, d = s.endAngle, f = (u + d) / 2;
  if (i === "outside") {
    var h = jr(o, a, c + r, f), m = h.x, g = h.y;
    return {
      x: m,
      y: g,
      textAnchor: m >= o ? "start" : "end",
      verticalAnchor: "middle"
    };
  }
  if (i === "center")
    return {
      x: o,
      y: a,
      textAnchor: "middle",
      verticalAnchor: "middle"
    };
  if (i === "centerTop")
    return {
      x: o,
      y: a,
      textAnchor: "middle",
      verticalAnchor: "start"
    };
  if (i === "centerBottom")
    return {
      x: o,
      y: a,
      textAnchor: "middle",
      verticalAnchor: "end"
    };
  var v = (l + c) / 2, y = jr(o, a, v, f), b = y.x, x = y.y;
  return {
    x: b,
    y: x,
    textAnchor: "middle",
    verticalAnchor: "middle"
  };
}, Mwe = function(e) {
  var t = e.viewBox, r = e.parentViewBox, i = e.offset, s = e.position, o = t, a = o.x, l = o.y, c = o.width, u = o.height, d = u >= 0 ? 1 : -1, f = d * i, h = d > 0 ? "end" : "start", m = d > 0 ? "start" : "end", g = c >= 0 ? 1 : -1, v = g * i, y = g > 0 ? "end" : "start", b = g > 0 ? "start" : "end";
  if (s === "top") {
    var x = {
      x: a + c / 2,
      y: l - d * i,
      textAnchor: "middle",
      verticalAnchor: h
    };
    return gr(gr({}, x), r ? {
      height: Math.max(l - r.y, 0),
      width: c
    } : {});
  }
  if (s === "bottom") {
    var E = {
      x: a + c / 2,
      y: l + u + f,
      textAnchor: "middle",
      verticalAnchor: m
    };
    return gr(gr({}, E), r ? {
      height: Math.max(r.y + r.height - (l + u), 0),
      width: c
    } : {});
  }
  if (s === "left") {
    var w = {
      x: a - v,
      y: l + u / 2,
      textAnchor: y,
      verticalAnchor: "middle"
    };
    return gr(gr({}, w), r ? {
      width: Math.max(w.x - r.x, 0),
      height: u
    } : {});
  }
  if (s === "right") {
    var C = {
      x: a + c + v,
      y: l + u / 2,
      textAnchor: b,
      verticalAnchor: "middle"
    };
    return gr(gr({}, C), r ? {
      width: Math.max(r.x + r.width - C.x, 0),
      height: u
    } : {});
  }
  var S = r ? {
    width: c,
    height: u
  } : {};
  return s === "insideLeft" ? gr({
    x: a + v,
    y: l + u / 2,
    textAnchor: b,
    verticalAnchor: "middle"
  }, S) : s === "insideRight" ? gr({
    x: a + c - v,
    y: l + u / 2,
    textAnchor: y,
    verticalAnchor: "middle"
  }, S) : s === "insideTop" ? gr({
    x: a + c / 2,
    y: l + f,
    textAnchor: "middle",
    verticalAnchor: m
  }, S) : s === "insideBottom" ? gr({
    x: a + c / 2,
    y: l + u - f,
    textAnchor: "middle",
    verticalAnchor: h
  }, S) : s === "insideTopLeft" ? gr({
    x: a + v,
    y: l + f,
    textAnchor: b,
    verticalAnchor: m
  }, S) : s === "insideTopRight" ? gr({
    x: a + c - v,
    y: l + f,
    textAnchor: y,
    verticalAnchor: m
  }, S) : s === "insideBottomLeft" ? gr({
    x: a + v,
    y: l + u - f,
    textAnchor: b,
    verticalAnchor: h
  }, S) : s === "insideBottomRight" ? gr({
    x: a + c - v,
    y: l + u - f,
    textAnchor: y,
    verticalAnchor: h
  }, S) : Eh(s) && (ke(s.x) || iu(s.x)) && (ke(s.y) || iu(s.y)) ? gr({
    x: a + Ru(s.x, c),
    y: l + Ru(s.y, u),
    textAnchor: "end",
    verticalAnchor: "end"
  }, S) : gr({
    x: a + c / 2,
    y: l + u / 2,
    textAnchor: "middle",
    verticalAnchor: "middle"
  }, S);
}, kwe = function(e) {
  return "cx" in e && ke(e.cx);
};
function ni(n) {
  var e = n.offset, t = e === void 0 ? 5 : e, r = ywe(n, fwe), i = gr({
    offset: t
  }, r), s = i.viewBox, o = i.position, a = i.value, l = i.children, c = i.content, u = i.className, d = u === void 0 ? "" : u, f = i.textBreakAll;
  if (!s || Bt(a) && Bt(l) && !/* @__PURE__ */ ca(c) && !Mt(c))
    return null;
  if (/* @__PURE__ */ ca(c))
    return /* @__PURE__ */ br(c, i);
  var h;
  if (Mt(c)) {
    if (h = /* @__PURE__ */ lt(c, i), /* @__PURE__ */ ca(h))
      return h;
  } else
    h = Swe(i);
  var m = kwe(s), g = $t(i, !0);
  if (m && (o === "insideStart" || o === "insideEnd" || o === "end"))
    return Twe(i, h, g);
  var v = m ? Awe(i) : Mwe(i);
  return /* @__PURE__ */ p.createElement(I2, Lm({
    className: Ut("recharts-label", d)
  }, g, v, {
    breakAll: f
  }), h);
}
ni.displayName = "Label";
var eY = function(e) {
  var t = e.cx, r = e.cy, i = e.angle, s = e.startAngle, o = e.endAngle, a = e.r, l = e.radius, c = e.innerRadius, u = e.outerRadius, d = e.x, f = e.y, h = e.top, m = e.left, g = e.width, v = e.height, y = e.clockWise, b = e.labelViewBox;
  if (b)
    return b;
  if (ke(g) && ke(v)) {
    if (ke(d) && ke(f))
      return {
        x: d,
        y: f,
        width: g,
        height: v
      };
    if (ke(h) && ke(m))
      return {
        x: h,
        y: m,
        width: g,
        height: v
      };
  }
  return ke(d) && ke(f) ? {
    x: d,
    y: f,
    width: 0,
    height: 0
  } : ke(t) && ke(r) ? {
    cx: t,
    cy: r,
    startAngle: s || i || 0,
    endAngle: o || i || 0,
    innerRadius: c || 0,
    outerRadius: u || l || a || 0,
    clockWise: y
  } : e.viewBox ? e.viewBox : {};
}, _we = function(e, t) {
  return e ? e === !0 ? /* @__PURE__ */ p.createElement(ni, {
    key: "label-implicit",
    viewBox: t
  }) : Sr(e) ? /* @__PURE__ */ p.createElement(ni, {
    key: "label-implicit",
    viewBox: t,
    value: e
  }) : /* @__PURE__ */ ca(e) ? e.type === ni ? /* @__PURE__ */ br(e, {
    key: "label-implicit",
    viewBox: t
  }) : /* @__PURE__ */ p.createElement(ni, {
    key: "label-implicit",
    content: e,
    viewBox: t
  }) : Mt(e) ? /* @__PURE__ */ p.createElement(ni, {
    key: "label-implicit",
    content: e,
    viewBox: t
  }) : Eh(e) ? /* @__PURE__ */ p.createElement(ni, Lm({
    viewBox: t
  }, e, {
    key: "label-implicit"
  })) : null : null;
}, Owe = function(e, t) {
  var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!e || !e.children && r && !e.label)
    return null;
  var i = e.children, s = eY(e), o = go(i, ni).map(function(l, c) {
    return /* @__PURE__ */ br(l, {
      viewBox: t || s,
      // eslint-disable-next-line react/no-array-index-key
      key: "label-".concat(c)
    });
  });
  if (!r)
    return o;
  var a = _we(e.label, t || s);
  return [a].concat(hwe(o));
};
ni.parseViewBox = eY;
ni.renderCallByParent = Owe;
var bS, VL;
function Iwe() {
  if (VL) return bS;
  VL = 1;
  function n(e) {
    var t = e == null ? 0 : e.length;
    return t ? e[t - 1] : void 0;
  }
  return bS = n, bS;
}
var Rwe = Iwe();
const Pwe = /* @__PURE__ */ nn(Rwe);
function $m(n) {
  "@babel/helpers - typeof";
  return $m = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, $m(n);
}
var Dwe = ["valueAccessor"], Nwe = ["data", "dataKey", "clockWise", "id", "textBreakAll"];
function Lwe(n) {
  return zwe(n) || Bwe(n) || Fwe(n) || $we();
}
function $we() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Fwe(n, e) {
  if (n) {
    if (typeof n == "string") return XC(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return XC(n, e);
  }
}
function Bwe(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function zwe(n) {
  if (Array.isArray(n)) return XC(n);
}
function XC(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function K2() {
  return K2 = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, K2.apply(this, arguments);
}
function jL(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function WL(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? jL(Object(t), !0).forEach(function(r) {
      Hwe(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : jL(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function Hwe(n, e, t) {
  return e = Uwe(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function Uwe(n) {
  var e = Vwe(n, "string");
  return $m(e) == "symbol" ? e : e + "";
}
function Vwe(n, e) {
  if ($m(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if ($m(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function GL(n, e) {
  if (n == null) return {};
  var t = jwe(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function jwe(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n)
    if (Object.prototype.hasOwnProperty.call(n, r)) {
      if (e.indexOf(r) >= 0) continue;
      t[r] = n[r];
    }
  return t;
}
var Wwe = function(e) {
  return Array.isArray(e.value) ? Pwe(e.value) : e.value;
};
function sc(n) {
  var e = n.valueAccessor, t = e === void 0 ? Wwe : e, r = GL(n, Dwe), i = r.data, s = r.dataKey, o = r.clockWise, a = r.id, l = r.textBreakAll, c = GL(r, Nwe);
  return !i || !i.length ? null : /* @__PURE__ */ p.createElement(jn, {
    className: "recharts-label-list"
  }, i.map(function(u, d) {
    var f = Bt(s) ? t(u, d) : ys(u && u.payload, s), h = Bt(a) ? {} : {
      id: "".concat(a, "-").concat(d)
    };
    return /* @__PURE__ */ p.createElement(ni, K2({}, $t(u, !0), c, h, {
      parentViewBox: u.parentViewBox,
      value: f,
      textBreakAll: l,
      viewBox: ni.parseViewBox(Bt(o) ? u : WL(WL({}, u), {}, {
        clockWise: o
      })),
      key: "label-".concat(d),
      index: d
    }));
  }));
}
sc.displayName = "LabelList";
function Gwe(n, e) {
  return n ? n === !0 ? /* @__PURE__ */ p.createElement(sc, {
    key: "labelList-implicit",
    data: e
  }) : /* @__PURE__ */ p.isValidElement(n) || Mt(n) ? /* @__PURE__ */ p.createElement(sc, {
    key: "labelList-implicit",
    data: e,
    content: n
  }) : Eh(n) ? /* @__PURE__ */ p.createElement(sc, K2({
    data: e
  }, n, {
    key: "labelList-implicit"
  })) : null : null;
}
function Kwe(n, e) {
  var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
  if (!n || !n.children && t && !n.label)
    return null;
  var r = n.children, i = go(r, sc).map(function(o, a) {
    return /* @__PURE__ */ br(o, {
      data: e,
      // eslint-disable-next-line react/no-array-index-key
      key: "labelList-".concat(a)
    });
  });
  if (!t)
    return i;
  var s = Gwe(n.label, e);
  return [s].concat(Lwe(i));
}
sc.renderCallByParent = Kwe;
function Fm(n) {
  "@babel/helpers - typeof";
  return Fm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Fm(n);
}
function ZC() {
  return ZC = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, ZC.apply(this, arguments);
}
function KL(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function qL(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? KL(Object(t), !0).forEach(function(r) {
      qwe(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : KL(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function qwe(n, e, t) {
  return e = Ywe(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function Ywe(n) {
  var e = Xwe(n, "string");
  return Fm(e) == "symbol" ? e : e + "";
}
function Xwe(n, e) {
  if (Fm(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Fm(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
var Zwe = function(e, t) {
  var r = co(t - e), i = Math.min(Math.abs(t - e), 359.999);
  return r * i;
}, pg = function(e) {
  var t = e.cx, r = e.cy, i = e.radius, s = e.angle, o = e.sign, a = e.isExternal, l = e.cornerRadius, c = e.cornerIsExternal, u = l * (a ? 1 : -1) + i, d = Math.asin(l / u) / G2, f = c ? s : s + o * d, h = jr(t, r, u, f), m = jr(t, r, i, f), g = c ? s - o * d : s, v = jr(t, r, u * Math.cos(d * G2), g);
  return {
    center: h,
    circleTangency: m,
    lineTangency: v,
    theta: d
  };
}, tY = function(e) {
  var t = e.cx, r = e.cy, i = e.innerRadius, s = e.outerRadius, o = e.startAngle, a = e.endAngle, l = Zwe(o, a), c = o + l, u = jr(t, r, s, o), d = jr(t, r, s, c), f = "M ".concat(u.x, ",").concat(u.y, `
    A `).concat(s, ",").concat(s, `,0,
    `).concat(+(Math.abs(l) > 180), ",").concat(+(o > c), `,
    `).concat(d.x, ",").concat(d.y, `
  `);
  if (i > 0) {
    var h = jr(t, r, i, o), m = jr(t, r, i, c);
    f += "L ".concat(m.x, ",").concat(m.y, `
            A `).concat(i, ",").concat(i, `,0,
            `).concat(+(Math.abs(l) > 180), ",").concat(+(o <= c), `,
            `).concat(h.x, ",").concat(h.y, " Z");
  } else
    f += "L ".concat(t, ",").concat(r, " Z");
  return f;
}, Qwe = function(e) {
  var t = e.cx, r = e.cy, i = e.innerRadius, s = e.outerRadius, o = e.cornerRadius, a = e.forceCornerRadius, l = e.cornerIsExternal, c = e.startAngle, u = e.endAngle, d = co(u - c), f = pg({
    cx: t,
    cy: r,
    radius: s,
    angle: c,
    sign: d,
    cornerRadius: o,
    cornerIsExternal: l
  }), h = f.circleTangency, m = f.lineTangency, g = f.theta, v = pg({
    cx: t,
    cy: r,
    radius: s,
    angle: u,
    sign: -d,
    cornerRadius: o,
    cornerIsExternal: l
  }), y = v.circleTangency, b = v.lineTangency, x = v.theta, E = l ? Math.abs(c - u) : Math.abs(c - u) - g - x;
  if (E < 0)
    return a ? "M ".concat(m.x, ",").concat(m.y, `
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(o * 2, `,0
        a`).concat(o, ",").concat(o, ",0,0,1,").concat(-o * 2, `,0
      `) : tY({
      cx: t,
      cy: r,
      innerRadius: i,
      outerRadius: s,
      startAngle: c,
      endAngle: u
    });
  var w = "M ".concat(m.x, ",").concat(m.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(d < 0), ",").concat(h.x, ",").concat(h.y, `
    A`).concat(s, ",").concat(s, ",0,").concat(+(E > 180), ",").concat(+(d < 0), ",").concat(y.x, ",").concat(y.y, `
    A`).concat(o, ",").concat(o, ",0,0,").concat(+(d < 0), ",").concat(b.x, ",").concat(b.y, `
  `);
  if (i > 0) {
    var C = pg({
      cx: t,
      cy: r,
      radius: i,
      angle: c,
      sign: d,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: l
    }), S = C.circleTangency, M = C.lineTangency, k = C.theta, _ = pg({
      cx: t,
      cy: r,
      radius: i,
      angle: u,
      sign: -d,
      isExternal: !0,
      cornerRadius: o,
      cornerIsExternal: l
    }), O = _.circleTangency, I = _.lineTangency, R = _.theta, P = l ? Math.abs(c - u) : Math.abs(c - u) - k - R;
    if (P < 0 && o === 0)
      return "".concat(w, "L").concat(t, ",").concat(r, "Z");
    w += "L".concat(I.x, ",").concat(I.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(d < 0), ",").concat(O.x, ",").concat(O.y, `
      A`).concat(i, ",").concat(i, ",0,").concat(+(P > 180), ",").concat(+(d > 0), ",").concat(S.x, ",").concat(S.y, `
      A`).concat(o, ",").concat(o, ",0,0,").concat(+(d < 0), ",").concat(M.x, ",").concat(M.y, "Z");
  } else
    w += "L".concat(t, ",").concat(r, "Z");
  return w;
}, Jwe = {
  cx: 0,
  cy: 0,
  innerRadius: 0,
  outerRadius: 0,
  startAngle: 0,
  endAngle: 0,
  cornerRadius: 0,
  forceCornerRadius: !1,
  cornerIsExternal: !1
}, nY = function(e) {
  var t = qL(qL({}, Jwe), e), r = t.cx, i = t.cy, s = t.innerRadius, o = t.outerRadius, a = t.cornerRadius, l = t.forceCornerRadius, c = t.cornerIsExternal, u = t.startAngle, d = t.endAngle, f = t.className;
  if (o < s || u === d)
    return null;
  var h = Ut("recharts-sector", f), m = o - s, g = Ru(a, m, 0, !0), v;
  return g > 0 && Math.abs(u - d) < 360 ? v = Qwe({
    cx: r,
    cy: i,
    innerRadius: s,
    outerRadius: o,
    cornerRadius: Math.min(g, m / 2),
    forceCornerRadius: l,
    cornerIsExternal: c,
    startAngle: u,
    endAngle: d
  }) : v = tY({
    cx: r,
    cy: i,
    innerRadius: s,
    outerRadius: o,
    startAngle: u,
    endAngle: d
  }), /* @__PURE__ */ p.createElement("path", ZC({}, $t(t, !0), {
    className: h,
    d: v,
    role: "img"
  }));
};
function Bm(n) {
  "@babel/helpers - typeof";
  return Bm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Bm(n);
}
function QC() {
  return QC = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, QC.apply(this, arguments);
}
function YL(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function XL(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? YL(Object(t), !0).forEach(function(r) {
      e3e(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : YL(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function e3e(n, e, t) {
  return e = t3e(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function t3e(n) {
  var e = n3e(n, "string");
  return Bm(e) == "symbol" ? e : e + "";
}
function n3e(n, e) {
  if (Bm(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Bm(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
var ZL = {
  curveBasisClosed: xme,
  curveBasisOpen: Eme,
  curveBasis: wme,
  curveBumpX: ome,
  curveBumpY: ame,
  curveLinearClosed: Sme,
  curveLinear: _w,
  curveMonotoneX: Cme,
  curveMonotoneY: Tme,
  curveNatural: Ame,
  curveStep: Mme,
  curveStepAfter: _me,
  curveStepBefore: kme
}, mg = function(e) {
  return e.x === +e.x && e.y === +e.y;
}, np = function(e) {
  return e.x;
}, rp = function(e) {
  return e.y;
}, r3e = function(e, t) {
  if (Mt(e))
    return e;
  var r = "curve".concat(Mw(e));
  return (r === "curveMonotone" || r === "curveBump") && t ? ZL["".concat(r).concat(t === "vertical" ? "Y" : "X")] : ZL[r] || _w;
}, i3e = function(e) {
  var t = e.type, r = t === void 0 ? "linear" : t, i = e.points, s = i === void 0 ? [] : i, o = e.baseLine, a = e.layout, l = e.connectNulls, c = l === void 0 ? !1 : l, u = r3e(r, a), d = c ? s.filter(function(g) {
    return mg(g);
  }) : s, f;
  if (Array.isArray(o)) {
    var h = c ? o.filter(function(g) {
      return mg(g);
    }) : o, m = d.map(function(g, v) {
      return XL(XL({}, g), {}, {
        base: h[v]
      });
    });
    return a === "vertical" ? f = og().y(rp).x1(np).x0(function(g) {
      return g.base.x;
    }) : f = og().x(np).y1(rp).y0(function(g) {
      return g.base.y;
    }), f.defined(mg).curve(u), f(m);
  }
  return a === "vertical" && ke(o) ? f = og().y(rp).x1(np).x0(o) : ke(o) ? f = og().x(np).y1(rp).y0(o) : f = oK().x(np).y(rp), f.defined(mg).curve(u), f(d);
}, Wp = function(e) {
  var t = e.className, r = e.points, i = e.path, s = e.pathRef;
  if ((!r || !r.length) && !i)
    return null;
  var o = r && r.length ? i3e(e) : i;
  return /* @__PURE__ */ A.createElement("path", QC({}, $t(e, !1), b2(e), {
    className: Ut("recharts-curve", t),
    d: o,
    ref: s
  }));
}, gg = { exports: {} }, vg = { exports: {} }, Jt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var QL;
function s3e() {
  if (QL) return Jt;
  QL = 1;
  var n = typeof Symbol == "function" && Symbol.for, e = n ? Symbol.for("react.element") : 60103, t = n ? Symbol.for("react.portal") : 60106, r = n ? Symbol.for("react.fragment") : 60107, i = n ? Symbol.for("react.strict_mode") : 60108, s = n ? Symbol.for("react.profiler") : 60114, o = n ? Symbol.for("react.provider") : 60109, a = n ? Symbol.for("react.context") : 60110, l = n ? Symbol.for("react.async_mode") : 60111, c = n ? Symbol.for("react.concurrent_mode") : 60111, u = n ? Symbol.for("react.forward_ref") : 60112, d = n ? Symbol.for("react.suspense") : 60113, f = n ? Symbol.for("react.suspense_list") : 60120, h = n ? Symbol.for("react.memo") : 60115, m = n ? Symbol.for("react.lazy") : 60116, g = n ? Symbol.for("react.block") : 60121, v = n ? Symbol.for("react.fundamental") : 60117, y = n ? Symbol.for("react.responder") : 60118, b = n ? Symbol.for("react.scope") : 60119;
  function x(w) {
    if (typeof w == "object" && w !== null) {
      var C = w.$$typeof;
      switch (C) {
        case e:
          switch (w = w.type, w) {
            case l:
            case c:
            case r:
            case s:
            case i:
            case d:
              return w;
            default:
              switch (w = w && w.$$typeof, w) {
                case a:
                case u:
                case m:
                case h:
                case o:
                  return w;
                default:
                  return C;
              }
          }
        case t:
          return C;
      }
    }
  }
  function E(w) {
    return x(w) === c;
  }
  return Jt.AsyncMode = l, Jt.ConcurrentMode = c, Jt.ContextConsumer = a, Jt.ContextProvider = o, Jt.Element = e, Jt.ForwardRef = u, Jt.Fragment = r, Jt.Lazy = m, Jt.Memo = h, Jt.Portal = t, Jt.Profiler = s, Jt.StrictMode = i, Jt.Suspense = d, Jt.isAsyncMode = function(w) {
    return E(w) || x(w) === l;
  }, Jt.isConcurrentMode = E, Jt.isContextConsumer = function(w) {
    return x(w) === a;
  }, Jt.isContextProvider = function(w) {
    return x(w) === o;
  }, Jt.isElement = function(w) {
    return typeof w == "object" && w !== null && w.$$typeof === e;
  }, Jt.isForwardRef = function(w) {
    return x(w) === u;
  }, Jt.isFragment = function(w) {
    return x(w) === r;
  }, Jt.isLazy = function(w) {
    return x(w) === m;
  }, Jt.isMemo = function(w) {
    return x(w) === h;
  }, Jt.isPortal = function(w) {
    return x(w) === t;
  }, Jt.isProfiler = function(w) {
    return x(w) === s;
  }, Jt.isStrictMode = function(w) {
    return x(w) === i;
  }, Jt.isSuspense = function(w) {
    return x(w) === d;
  }, Jt.isValidElementType = function(w) {
    return typeof w == "string" || typeof w == "function" || w === r || w === c || w === s || w === i || w === d || w === f || typeof w == "object" && w !== null && (w.$$typeof === m || w.$$typeof === h || w.$$typeof === o || w.$$typeof === a || w.$$typeof === u || w.$$typeof === v || w.$$typeof === y || w.$$typeof === b || w.$$typeof === g);
  }, Jt.typeOf = x, Jt;
}
var en = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var JL;
function o3e() {
  return JL || (JL = 1, process.env.NODE_ENV !== "production" && (function() {
    var n = typeof Symbol == "function" && Symbol.for, e = n ? Symbol.for("react.element") : 60103, t = n ? Symbol.for("react.portal") : 60106, r = n ? Symbol.for("react.fragment") : 60107, i = n ? Symbol.for("react.strict_mode") : 60108, s = n ? Symbol.for("react.profiler") : 60114, o = n ? Symbol.for("react.provider") : 60109, a = n ? Symbol.for("react.context") : 60110, l = n ? Symbol.for("react.async_mode") : 60111, c = n ? Symbol.for("react.concurrent_mode") : 60111, u = n ? Symbol.for("react.forward_ref") : 60112, d = n ? Symbol.for("react.suspense") : 60113, f = n ? Symbol.for("react.suspense_list") : 60120, h = n ? Symbol.for("react.memo") : 60115, m = n ? Symbol.for("react.lazy") : 60116, g = n ? Symbol.for("react.block") : 60121, v = n ? Symbol.for("react.fundamental") : 60117, y = n ? Symbol.for("react.responder") : 60118, b = n ? Symbol.for("react.scope") : 60119;
    function x(j) {
      return typeof j == "string" || typeof j == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      j === r || j === c || j === s || j === i || j === d || j === f || typeof j == "object" && j !== null && (j.$$typeof === m || j.$$typeof === h || j.$$typeof === o || j.$$typeof === a || j.$$typeof === u || j.$$typeof === v || j.$$typeof === y || j.$$typeof === b || j.$$typeof === g);
    }
    function E(j) {
      if (typeof j == "object" && j !== null) {
        var xe = j.$$typeof;
        switch (xe) {
          case e:
            var ne = j.type;
            switch (ne) {
              case l:
              case c:
              case r:
              case s:
              case i:
              case d:
                return ne;
              default:
                var qe = ne && ne.$$typeof;
                switch (qe) {
                  case a:
                  case u:
                  case m:
                  case h:
                  case o:
                    return qe;
                  default:
                    return xe;
                }
            }
          case t:
            return xe;
        }
      }
    }
    var w = l, C = c, S = a, M = o, k = e, _ = u, O = r, I = m, R = h, P = t, D = s, L = i, B = d, $ = !1;
    function z(j) {
      return $ || ($ = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), H(j) || E(j) === l;
    }
    function H(j) {
      return E(j) === c;
    }
    function U(j) {
      return E(j) === a;
    }
    function F(j) {
      return E(j) === o;
    }
    function V(j) {
      return typeof j == "object" && j !== null && j.$$typeof === e;
    }
    function X(j) {
      return E(j) === u;
    }
    function Z(j) {
      return E(j) === r;
    }
    function ie(j) {
      return E(j) === m;
    }
    function J(j) {
      return E(j) === h;
    }
    function se(j) {
      return E(j) === t;
    }
    function te(j) {
      return E(j) === s;
    }
    function le(j) {
      return E(j) === i;
    }
    function de(j) {
      return E(j) === d;
    }
    en.AsyncMode = w, en.ConcurrentMode = C, en.ContextConsumer = S, en.ContextProvider = M, en.Element = k, en.ForwardRef = _, en.Fragment = O, en.Lazy = I, en.Memo = R, en.Portal = P, en.Profiler = D, en.StrictMode = L, en.Suspense = B, en.isAsyncMode = z, en.isConcurrentMode = H, en.isContextConsumer = U, en.isContextProvider = F, en.isElement = V, en.isForwardRef = X, en.isFragment = Z, en.isLazy = ie, en.isMemo = J, en.isPortal = se, en.isProfiler = te, en.isStrictMode = le, en.isSuspense = de, en.isValidElementType = x, en.typeOf = E;
  })()), en;
}
var e$;
function rY() {
  return e$ || (e$ = 1, process.env.NODE_ENV === "production" ? vg.exports = s3e() : vg.exports = o3e()), vg.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var wS, t$;
function a3e() {
  if (t$) return wS;
  t$ = 1;
  var n = Object.getOwnPropertySymbols, e = Object.prototype.hasOwnProperty, t = Object.prototype.propertyIsEnumerable;
  function r(s) {
    if (s == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(s);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var s = new String("abc");
      if (s[5] = "de", Object.getOwnPropertyNames(s)[0] === "5")
        return !1;
      for (var o = {}, a = 0; a < 10; a++)
        o["_" + String.fromCharCode(a)] = a;
      var l = Object.getOwnPropertyNames(o).map(function(u) {
        return o[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return wS = i() ? Object.assign : function(s, o) {
    for (var a, l = r(s), c, u = 1; u < arguments.length; u++) {
      a = Object(arguments[u]);
      for (var d in a)
        e.call(a, d) && (l[d] = a[d]);
      if (n) {
        c = n(a);
        for (var f = 0; f < c.length; f++)
          t.call(a, c[f]) && (l[c[f]] = a[c[f]]);
      }
    }
    return l;
  }, wS;
}
var xS, n$;
function PM() {
  if (n$) return xS;
  n$ = 1;
  var n = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return xS = n, xS;
}
var ES, r$;
function iY() {
  return r$ || (r$ = 1, ES = Function.call.bind(Object.prototype.hasOwnProperty)), ES;
}
var SS, i$;
function l3e() {
  if (i$) return SS;
  i$ = 1;
  var n = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var e = /* @__PURE__ */ PM(), t = {}, r = /* @__PURE__ */ iY();
    n = function(s) {
      var o = "Warning: " + s;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function i(s, o, a, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in s)
        if (r(s, u)) {
          var d;
          try {
            if (typeof s[u] != "function") {
              var f = Error(
                (l || "React class") + ": " + a + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof s[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            d = s[u](o, u, l, a, null, e);
          } catch (m) {
            d = m;
          }
          if (d && !(d instanceof Error) && n(
            (l || "React class") + ": type specification of " + a + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in t)) {
            t[d.message] = !0;
            var h = c ? c() : "";
            n(
              "Failed " + a + " type: " + d.message + (h ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (t = {});
  }, SS = i, SS;
}
var CS, s$;
function c3e() {
  if (s$) return CS;
  s$ = 1;
  var n = rY(), e = a3e(), t = /* @__PURE__ */ PM(), r = /* @__PURE__ */ iY(), i = /* @__PURE__ */ l3e(), s = function() {
  };
  process.env.NODE_ENV !== "production" && (s = function(a) {
    var l = "Warning: " + a;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return CS = function(a, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(H) {
      var U = H && (c && H[c] || H[u]);
      if (typeof U == "function")
        return U;
    }
    var f = "<<anonymous>>", h = {
      array: y("array"),
      bigint: y("bigint"),
      bool: y("boolean"),
      func: y("function"),
      number: y("number"),
      object: y("object"),
      string: y("string"),
      symbol: y("symbol"),
      any: b(),
      arrayOf: x,
      element: E(),
      elementType: w(),
      instanceOf: C,
      node: _(),
      objectOf: M,
      oneOf: S,
      oneOfType: k,
      shape: I,
      exact: R
    };
    function m(H, U) {
      return H === U ? H !== 0 || 1 / H === 1 / U : H !== H && U !== U;
    }
    function g(H, U) {
      this.message = H, this.data = U && typeof U == "object" ? U : {}, this.stack = "";
    }
    g.prototype = Error.prototype;
    function v(H) {
      if (process.env.NODE_ENV !== "production")
        var U = {}, F = 0;
      function V(Z, ie, J, se, te, le, de) {
        if (se = se || f, le = le || J, de !== t) {
          if (l) {
            var j = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw j.name = "Invariant Violation", j;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var xe = se + ":" + J;
            !U[xe] && // Avoid spamming the console because they are often not actionable except for lib authors
            F < 3 && (s(
              "You are manually calling a React.PropTypes validation function for the `" + le + "` prop on `" + se + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), U[xe] = !0, F++);
          }
        }
        return ie[J] == null ? Z ? ie[J] === null ? new g("The " + te + " `" + le + "` is marked as required " + ("in `" + se + "`, but its value is `null`.")) : new g("The " + te + " `" + le + "` is marked as required in " + ("`" + se + "`, but its value is `undefined`.")) : null : H(ie, J, se, te, le);
      }
      var X = V.bind(null, !1);
      return X.isRequired = V.bind(null, !0), X;
    }
    function y(H) {
      function U(F, V, X, Z, ie, J) {
        var se = F[V], te = L(se);
        if (te !== H) {
          var le = B(se);
          return new g(
            "Invalid " + Z + " `" + ie + "` of type " + ("`" + le + "` supplied to `" + X + "`, expected ") + ("`" + H + "`."),
            { expectedType: H }
          );
        }
        return null;
      }
      return v(U);
    }
    function b() {
      return v(o);
    }
    function x(H) {
      function U(F, V, X, Z, ie) {
        if (typeof H != "function")
          return new g("Property `" + ie + "` of component `" + X + "` has invalid PropType notation inside arrayOf.");
        var J = F[V];
        if (!Array.isArray(J)) {
          var se = L(J);
          return new g("Invalid " + Z + " `" + ie + "` of type " + ("`" + se + "` supplied to `" + X + "`, expected an array."));
        }
        for (var te = 0; te < J.length; te++) {
          var le = H(J, te, X, Z, ie + "[" + te + "]", t);
          if (le instanceof Error)
            return le;
        }
        return null;
      }
      return v(U);
    }
    function E() {
      function H(U, F, V, X, Z) {
        var ie = U[F];
        if (!a(ie)) {
          var J = L(ie);
          return new g("Invalid " + X + " `" + Z + "` of type " + ("`" + J + "` supplied to `" + V + "`, expected a single ReactElement."));
        }
        return null;
      }
      return v(H);
    }
    function w() {
      function H(U, F, V, X, Z) {
        var ie = U[F];
        if (!n.isValidElementType(ie)) {
          var J = L(ie);
          return new g("Invalid " + X + " `" + Z + "` of type " + ("`" + J + "` supplied to `" + V + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return v(H);
    }
    function C(H) {
      function U(F, V, X, Z, ie) {
        if (!(F[V] instanceof H)) {
          var J = H.name || f, se = z(F[V]);
          return new g("Invalid " + Z + " `" + ie + "` of type " + ("`" + se + "` supplied to `" + X + "`, expected ") + ("instance of `" + J + "`."));
        }
        return null;
      }
      return v(U);
    }
    function S(H) {
      if (!Array.isArray(H))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? s(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : s("Invalid argument supplied to oneOf, expected an array.")), o;
      function U(F, V, X, Z, ie) {
        for (var J = F[V], se = 0; se < H.length; se++)
          if (m(J, H[se]))
            return null;
        var te = JSON.stringify(H, function(de, j) {
          var xe = B(j);
          return xe === "symbol" ? String(j) : j;
        });
        return new g("Invalid " + Z + " `" + ie + "` of value `" + String(J) + "` " + ("supplied to `" + X + "`, expected one of " + te + "."));
      }
      return v(U);
    }
    function M(H) {
      function U(F, V, X, Z, ie) {
        if (typeof H != "function")
          return new g("Property `" + ie + "` of component `" + X + "` has invalid PropType notation inside objectOf.");
        var J = F[V], se = L(J);
        if (se !== "object")
          return new g("Invalid " + Z + " `" + ie + "` of type " + ("`" + se + "` supplied to `" + X + "`, expected an object."));
        for (var te in J)
          if (r(J, te)) {
            var le = H(J, te, X, Z, ie + "." + te, t);
            if (le instanceof Error)
              return le;
          }
        return null;
      }
      return v(U);
    }
    function k(H) {
      if (!Array.isArray(H))
        return process.env.NODE_ENV !== "production" && s("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var U = 0; U < H.length; U++) {
        var F = H[U];
        if (typeof F != "function")
          return s(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + $(F) + " at index " + U + "."
          ), o;
      }
      function V(X, Z, ie, J, se) {
        for (var te = [], le = 0; le < H.length; le++) {
          var de = H[le], j = de(X, Z, ie, J, se, t);
          if (j == null)
            return null;
          j.data && r(j.data, "expectedType") && te.push(j.data.expectedType);
        }
        var xe = te.length > 0 ? ", expected one of type [" + te.join(", ") + "]" : "";
        return new g("Invalid " + J + " `" + se + "` supplied to " + ("`" + ie + "`" + xe + "."));
      }
      return v(V);
    }
    function _() {
      function H(U, F, V, X, Z) {
        return P(U[F]) ? null : new g("Invalid " + X + " `" + Z + "` supplied to " + ("`" + V + "`, expected a ReactNode."));
      }
      return v(H);
    }
    function O(H, U, F, V, X) {
      return new g(
        (H || "React class") + ": " + U + " type `" + F + "." + V + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + X + "`."
      );
    }
    function I(H) {
      function U(F, V, X, Z, ie) {
        var J = F[V], se = L(J);
        if (se !== "object")
          return new g("Invalid " + Z + " `" + ie + "` of type `" + se + "` " + ("supplied to `" + X + "`, expected `object`."));
        for (var te in H) {
          var le = H[te];
          if (typeof le != "function")
            return O(X, Z, ie, te, B(le));
          var de = le(J, te, X, Z, ie + "." + te, t);
          if (de)
            return de;
        }
        return null;
      }
      return v(U);
    }
    function R(H) {
      function U(F, V, X, Z, ie) {
        var J = F[V], se = L(J);
        if (se !== "object")
          return new g("Invalid " + Z + " `" + ie + "` of type `" + se + "` " + ("supplied to `" + X + "`, expected `object`."));
        var te = e({}, F[V], H);
        for (var le in te) {
          var de = H[le];
          if (r(H, le) && typeof de != "function")
            return O(X, Z, ie, le, B(de));
          if (!de)
            return new g(
              "Invalid " + Z + " `" + ie + "` key `" + le + "` supplied to `" + X + "`.\nBad object: " + JSON.stringify(F[V], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(H), null, "  ")
            );
          var j = de(J, le, X, Z, ie + "." + le, t);
          if (j)
            return j;
        }
        return null;
      }
      return v(U);
    }
    function P(H) {
      switch (typeof H) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !H;
        case "object":
          if (Array.isArray(H))
            return H.every(P);
          if (H === null || a(H))
            return !0;
          var U = d(H);
          if (U) {
            var F = U.call(H), V;
            if (U !== H.entries) {
              for (; !(V = F.next()).done; )
                if (!P(V.value))
                  return !1;
            } else
              for (; !(V = F.next()).done; ) {
                var X = V.value;
                if (X && !P(X[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function D(H, U) {
      return H === "symbol" ? !0 : U ? U["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && U instanceof Symbol : !1;
    }
    function L(H) {
      var U = typeof H;
      return Array.isArray(H) ? "array" : H instanceof RegExp ? "object" : D(U, H) ? "symbol" : U;
    }
    function B(H) {
      if (typeof H > "u" || H === null)
        return "" + H;
      var U = L(H);
      if (U === "object") {
        if (H instanceof Date)
          return "date";
        if (H instanceof RegExp)
          return "regexp";
      }
      return U;
    }
    function $(H) {
      var U = B(H);
      switch (U) {
        case "array":
        case "object":
          return "an " + U;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + U;
        default:
          return U;
      }
    }
    function z(H) {
      return !H.constructor || !H.constructor.name ? f : H.constructor.name;
    }
    return h.checkPropTypes = i, h.resetWarningCache = i.resetWarningCache, h.PropTypes = h, h;
  }, CS;
}
var TS, o$;
function u3e() {
  if (o$) return TS;
  o$ = 1;
  var n = /* @__PURE__ */ PM();
  function e() {
  }
  function t() {
  }
  return t.resetWarningCache = e, TS = function() {
    function r(o, a, l, c, u, d) {
      if (d !== n) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var s = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: t,
      resetWarningCache: e
    };
    return s.PropTypes = s, s;
  }, TS;
}
var a$;
function d3e() {
  if (a$) return gg.exports;
  if (a$ = 1, process.env.NODE_ENV !== "production") {
    var n = rY(), e = !0;
    gg.exports = /* @__PURE__ */ c3e()(n.isElement, e);
  } else
    gg.exports = /* @__PURE__ */ u3e()();
  return gg.exports;
}
var f3e = /* @__PURE__ */ d3e();
const pe = /* @__PURE__ */ nn(f3e);
var h3e = Object.getOwnPropertyNames, p3e = Object.getOwnPropertySymbols, m3e = Object.prototype.hasOwnProperty;
function l$(n, e) {
  return function(r, i, s) {
    return n(r, i, s) && e(r, i, s);
  };
}
function yg(n) {
  return function(t, r, i) {
    if (!t || !r || typeof t != "object" || typeof r != "object")
      return n(t, r, i);
    var s = i.cache, o = s.get(t), a = s.get(r);
    if (o && a)
      return o === r && a === t;
    s.set(t, r), s.set(r, t);
    var l = n(t, r, i);
    return s.delete(t), s.delete(r), l;
  };
}
function g3e(n) {
  return n?.[Symbol.toStringTag];
}
function c$(n) {
  return h3e(n).concat(p3e(n));
}
var v3e = Object.hasOwn || (function(n, e) {
  return m3e.call(n, e);
});
function rd(n, e) {
  return n === e || !n && !e && n !== n && e !== e;
}
var y3e = "__v", b3e = "__o", w3e = "_owner", u$ = Object.getOwnPropertyDescriptor, d$ = Object.keys;
function x3e(n, e, t) {
  var r = n.length;
  if (e.length !== r)
    return !1;
  for (; r-- > 0; )
    if (!t.equals(n[r], e[r], r, r, n, e, t))
      return !1;
  return !0;
}
function E3e(n, e) {
  return rd(n.getTime(), e.getTime());
}
function S3e(n, e) {
  return n.name === e.name && n.message === e.message && n.cause === e.cause && n.stack === e.stack;
}
function C3e(n, e) {
  return n === e;
}
function f$(n, e, t) {
  var r = n.size;
  if (r !== e.size)
    return !1;
  if (!r)
    return !0;
  for (var i = new Array(r), s = n.entries(), o, a, l = 0; (o = s.next()) && !o.done; ) {
    for (var c = e.entries(), u = !1, d = 0; (a = c.next()) && !a.done; ) {
      if (i[d]) {
        d++;
        continue;
      }
      var f = o.value, h = a.value;
      if (t.equals(f[0], h[0], l, d, n, e, t) && t.equals(f[1], h[1], f[0], h[0], n, e, t)) {
        u = i[d] = !0;
        break;
      }
      d++;
    }
    if (!u)
      return !1;
    l++;
  }
  return !0;
}
var T3e = rd;
function A3e(n, e, t) {
  var r = d$(n), i = r.length;
  if (d$(e).length !== i)
    return !1;
  for (; i-- > 0; )
    if (!sY(n, e, t, r[i]))
      return !1;
  return !0;
}
function ip(n, e, t) {
  var r = c$(n), i = r.length;
  if (c$(e).length !== i)
    return !1;
  for (var s, o, a; i-- > 0; )
    if (s = r[i], !sY(n, e, t, s) || (o = u$(n, s), a = u$(e, s), (o || a) && (!o || !a || o.configurable !== a.configurable || o.enumerable !== a.enumerable || o.writable !== a.writable)))
      return !1;
  return !0;
}
function M3e(n, e) {
  return rd(n.valueOf(), e.valueOf());
}
function k3e(n, e) {
  return n.source === e.source && n.flags === e.flags;
}
function h$(n, e, t) {
  var r = n.size;
  if (r !== e.size)
    return !1;
  if (!r)
    return !0;
  for (var i = new Array(r), s = n.values(), o, a; (o = s.next()) && !o.done; ) {
    for (var l = e.values(), c = !1, u = 0; (a = l.next()) && !a.done; ) {
      if (!i[u] && t.equals(o.value, a.value, o.value, a.value, n, e, t)) {
        c = i[u] = !0;
        break;
      }
      u++;
    }
    if (!c)
      return !1;
  }
  return !0;
}
function _3e(n, e) {
  var t = n.length;
  if (e.length !== t)
    return !1;
  for (; t-- > 0; )
    if (n[t] !== e[t])
      return !1;
  return !0;
}
function O3e(n, e) {
  return n.hostname === e.hostname && n.pathname === e.pathname && n.protocol === e.protocol && n.port === e.port && n.hash === e.hash && n.username === e.username && n.password === e.password;
}
function sY(n, e, t, r) {
  return (r === w3e || r === b3e || r === y3e) && (n.$$typeof || e.$$typeof) ? !0 : v3e(e, r) && t.equals(n[r], e[r], r, r, n, e, t);
}
var I3e = "[object Arguments]", R3e = "[object Boolean]", P3e = "[object Date]", D3e = "[object Error]", N3e = "[object Map]", L3e = "[object Number]", $3e = "[object Object]", F3e = "[object RegExp]", B3e = "[object Set]", z3e = "[object String]", H3e = "[object URL]", U3e = Array.isArray, p$ = typeof ArrayBuffer == "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null, m$ = Object.assign, V3e = Object.prototype.toString.call.bind(Object.prototype.toString);
function j3e(n) {
  var e = n.areArraysEqual, t = n.areDatesEqual, r = n.areErrorsEqual, i = n.areFunctionsEqual, s = n.areMapsEqual, o = n.areNumbersEqual, a = n.areObjectsEqual, l = n.arePrimitiveWrappersEqual, c = n.areRegExpsEqual, u = n.areSetsEqual, d = n.areTypedArraysEqual, f = n.areUrlsEqual, h = n.unknownTagComparators;
  return function(g, v, y) {
    if (g === v)
      return !0;
    if (g == null || v == null)
      return !1;
    var b = typeof g;
    if (b !== typeof v)
      return !1;
    if (b !== "object")
      return b === "number" ? o(g, v, y) : b === "function" ? i(g, v, y) : !1;
    var x = g.constructor;
    if (x !== v.constructor)
      return !1;
    if (x === Object)
      return a(g, v, y);
    if (U3e(g))
      return e(g, v, y);
    if (p$ != null && p$(g))
      return d(g, v, y);
    if (x === Date)
      return t(g, v, y);
    if (x === RegExp)
      return c(g, v, y);
    if (x === Map)
      return s(g, v, y);
    if (x === Set)
      return u(g, v, y);
    var E = V3e(g);
    if (E === P3e)
      return t(g, v, y);
    if (E === F3e)
      return c(g, v, y);
    if (E === N3e)
      return s(g, v, y);
    if (E === B3e)
      return u(g, v, y);
    if (E === $3e)
      return typeof g.then != "function" && typeof v.then != "function" && a(g, v, y);
    if (E === H3e)
      return f(g, v, y);
    if (E === D3e)
      return r(g, v, y);
    if (E === I3e)
      return a(g, v, y);
    if (E === R3e || E === L3e || E === z3e)
      return l(g, v, y);
    if (h) {
      var w = h[E];
      if (!w) {
        var C = g3e(g);
        C && (w = h[C]);
      }
      if (w)
        return w(g, v, y);
    }
    return !1;
  };
}
function W3e(n) {
  var e = n.circular, t = n.createCustomConfig, r = n.strict, i = {
    areArraysEqual: r ? ip : x3e,
    areDatesEqual: E3e,
    areErrorsEqual: S3e,
    areFunctionsEqual: C3e,
    areMapsEqual: r ? l$(f$, ip) : f$,
    areNumbersEqual: T3e,
    areObjectsEqual: r ? ip : A3e,
    arePrimitiveWrappersEqual: M3e,
    areRegExpsEqual: k3e,
    areSetsEqual: r ? l$(h$, ip) : h$,
    areTypedArraysEqual: r ? ip : _3e,
    areUrlsEqual: O3e,
    unknownTagComparators: void 0
  };
  if (t && (i = m$({}, i, t(i))), e) {
    var s = yg(i.areArraysEqual), o = yg(i.areMapsEqual), a = yg(i.areObjectsEqual), l = yg(i.areSetsEqual);
    i = m$({}, i, {
      areArraysEqual: s,
      areMapsEqual: o,
      areObjectsEqual: a,
      areSetsEqual: l
    });
  }
  return i;
}
function G3e(n) {
  return function(e, t, r, i, s, o, a) {
    return n(e, t, a);
  };
}
function K3e(n) {
  var e = n.circular, t = n.comparator, r = n.createState, i = n.equals, s = n.strict;
  if (r)
    return function(l, c) {
      var u = r(), d = u.cache, f = d === void 0 ? e ? /* @__PURE__ */ new WeakMap() : void 0 : d, h = u.meta;
      return t(l, c, {
        cache: f,
        equals: i,
        meta: h,
        strict: s
      });
    };
  if (e)
    return function(l, c) {
      return t(l, c, {
        cache: /* @__PURE__ */ new WeakMap(),
        equals: i,
        meta: void 0,
        strict: s
      });
    };
  var o = {
    cache: void 0,
    equals: i,
    meta: void 0,
    strict: s
  };
  return function(l, c) {
    return t(l, c, o);
  };
}
var q3e = kc();
kc({ strict: !0 });
kc({ circular: !0 });
kc({
  circular: !0,
  strict: !0
});
kc({
  createInternalComparator: function() {
    return rd;
  }
});
kc({
  strict: !0,
  createInternalComparator: function() {
    return rd;
  }
});
kc({
  circular: !0,
  createInternalComparator: function() {
    return rd;
  }
});
kc({
  circular: !0,
  createInternalComparator: function() {
    return rd;
  },
  strict: !0
});
function kc(n) {
  n === void 0 && (n = {});
  var e = n.circular, t = e === void 0 ? !1 : e, r = n.createInternalComparator, i = n.createState, s = n.strict, o = s === void 0 ? !1 : s, a = W3e(n), l = j3e(a), c = r ? r(l) : G3e(l);
  return K3e({ circular: t, comparator: l, createState: i, equals: c, strict: o });
}
function Y3e(n) {
  typeof requestAnimationFrame < "u" && requestAnimationFrame(n);
}
function g$(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, t = -1, r = function i(s) {
    t < 0 && (t = s), s - t > e ? (n(s), t = -1) : Y3e(i);
  };
  requestAnimationFrame(r);
}
function JC(n) {
  "@babel/helpers - typeof";
  return JC = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, JC(n);
}
function X3e(n) {
  return exe(n) || J3e(n) || Q3e(n) || Z3e();
}
function Z3e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Q3e(n, e) {
  if (n) {
    if (typeof n == "string") return v$(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return v$(n, e);
  }
}
function v$(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function J3e(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function exe(n) {
  if (Array.isArray(n)) return n;
}
function txe() {
  var n = {}, e = function() {
    return null;
  }, t = !1, r = function i(s) {
    if (!t) {
      if (Array.isArray(s)) {
        if (!s.length)
          return;
        var o = s, a = X3e(o), l = a[0], c = a.slice(1);
        if (typeof l == "number") {
          g$(i.bind(null, c), l);
          return;
        }
        i(l), g$(i.bind(null, c));
        return;
      }
      JC(s) === "object" && (n = s, e(n)), typeof s == "function" && s();
    }
  };
  return {
    stop: function() {
      t = !0;
    },
    start: function(s) {
      t = !1, r(s);
    },
    subscribe: function(s) {
      return e = s, function() {
        e = function() {
          return null;
        };
      };
    }
  };
}
function zm(n) {
  "@babel/helpers - typeof";
  return zm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, zm(n);
}
function y$(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function b$(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? y$(Object(t), !0).forEach(function(r) {
      oY(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : y$(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function oY(n, e, t) {
  return e = nxe(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function nxe(n) {
  var e = rxe(n, "string");
  return zm(e) === "symbol" ? e : String(e);
}
function rxe(n, e) {
  if (zm(n) !== "object" || n === null) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (zm(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
var ixe = function(e, t) {
  return [Object.keys(e), Object.keys(t)].reduce(function(r, i) {
    return r.filter(function(s) {
      return i.includes(s);
    });
  });
}, sxe = function(e) {
  return e;
}, oxe = function(e) {
  return e.replace(/([A-Z])/g, function(t) {
    return "-".concat(t.toLowerCase());
  });
}, Gp = function(e, t) {
  return Object.keys(t).reduce(function(r, i) {
    return b$(b$({}, r), {}, oY({}, i, e(i, t[i])));
  }, {});
}, w$ = function(e, t, r) {
  return e.map(function(i) {
    return "".concat(oxe(i), " ").concat(t, "ms ").concat(r);
  }).join(",");
}, axe = process.env.NODE_ENV !== "production", q2 = function(e, t, r, i, s, o, a, l) {
  if (axe && typeof console < "u" && console.warn && (t === void 0 && console.warn("LogUtils requires an error message argument"), !e))
    if (t === void 0)
      console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      var c = [r, i, s, o, a, l], u = 0;
      console.warn(t.replace(/%s/g, function() {
        return c[u++];
      }));
    }
};
function lxe(n, e) {
  return dxe(n) || uxe(n, e) || aY(n, e) || cxe();
}
function cxe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function uxe(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r, i, s, o, a = [], l = !0, c = !1;
    try {
      if (s = (t = t.call(n)).next, e !== 0) for (; !(l = (r = s.call(t)).done) && (a.push(r.value), a.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && t.return != null && (o = t.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return a;
  }
}
function dxe(n) {
  if (Array.isArray(n)) return n;
}
function fxe(n) {
  return mxe(n) || pxe(n) || aY(n) || hxe();
}
function hxe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function aY(n, e) {
  if (n) {
    if (typeof n == "string") return eT(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return eT(n, e);
  }
}
function pxe(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function mxe(n) {
  if (Array.isArray(n)) return eT(n);
}
function eT(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
var Y2 = 1e-4, lY = function(e, t) {
  return [0, 3 * e, 3 * t - 6 * e, 3 * e - 3 * t + 1];
}, cY = function(e, t) {
  return e.map(function(r, i) {
    return r * Math.pow(t, i);
  }).reduce(function(r, i) {
    return r + i;
  });
}, x$ = function(e, t) {
  return function(r) {
    var i = lY(e, t);
    return cY(i, r);
  };
}, gxe = function(e, t) {
  return function(r) {
    var i = lY(e, t), s = [].concat(fxe(i.map(function(o, a) {
      return o * a;
    }).slice(1)), [0]);
    return cY(s, r);
  };
}, E$ = function() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  var i = t[0], s = t[1], o = t[2], a = t[3];
  if (t.length === 1)
    switch (t[0]) {
      case "linear":
        i = 0, s = 0, o = 1, a = 1;
        break;
      case "ease":
        i = 0.25, s = 0.1, o = 0.25, a = 1;
        break;
      case "ease-in":
        i = 0.42, s = 0, o = 1, a = 1;
        break;
      case "ease-out":
        i = 0.42, s = 0, o = 0.58, a = 1;
        break;
      case "ease-in-out":
        i = 0, s = 0, o = 0.58, a = 1;
        break;
      default: {
        var l = t[0].split("(");
        if (l[0] === "cubic-bezier" && l[1].split(")")[0].split(",").length === 4) {
          var c = l[1].split(")")[0].split(",").map(function(v) {
            return parseFloat(v);
          }), u = lxe(c, 4);
          i = u[0], s = u[1], o = u[2], a = u[3];
        } else
          q2(!1, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", t);
      }
    }
  q2([i, o, s, a].every(function(v) {
    return typeof v == "number" && v >= 0 && v <= 1;
  }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", t);
  var d = x$(i, o), f = x$(s, a), h = gxe(i, o), m = function(y) {
    return y > 1 ? 1 : y < 0 ? 0 : y;
  }, g = function(y) {
    for (var b = y > 1 ? 1 : y, x = b, E = 0; E < 8; ++E) {
      var w = d(x) - b, C = h(x);
      if (Math.abs(w - b) < Y2 || C < Y2)
        return f(x);
      x = m(x - w / C);
    }
    return f(x);
  };
  return g.isStepper = !1, g;
}, vxe = function() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.stiff, r = t === void 0 ? 100 : t, i = e.damping, s = i === void 0 ? 8 : i, o = e.dt, a = o === void 0 ? 17 : o, l = function(u, d, f) {
    var h = -(u - d) * r, m = f * s, g = f + (h - m) * a / 1e3, v = f * a / 1e3 + u;
    return Math.abs(v - d) < Y2 && Math.abs(g) < Y2 ? [d, 0] : [v, g];
  };
  return l.isStepper = !0, l.dt = a, l;
}, yxe = function() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  var i = t[0];
  if (typeof i == "string")
    switch (i) {
      case "ease":
      case "ease-in-out":
      case "ease-out":
      case "ease-in":
      case "linear":
        return E$(i);
      case "spring":
        return vxe();
      default:
        if (i.split("(")[0] === "cubic-bezier")
          return E$(i);
        q2(!1, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", t);
    }
  return typeof i == "function" ? i : (q2(!1, "[configEasing]: first argument type should be function or string, instead received %s", t), null);
};
function Hm(n) {
  "@babel/helpers - typeof";
  return Hm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Hm(n);
}
function S$(n) {
  return xxe(n) || wxe(n) || uY(n) || bxe();
}
function bxe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function wxe(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function xxe(n) {
  if (Array.isArray(n)) return nT(n);
}
function C$(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Nr(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? C$(Object(t), !0).forEach(function(r) {
      tT(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : C$(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function tT(n, e, t) {
  return e = Exe(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function Exe(n) {
  var e = Sxe(n, "string");
  return Hm(e) === "symbol" ? e : String(e);
}
function Sxe(n, e) {
  if (Hm(n) !== "object" || n === null) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Hm(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function Cxe(n, e) {
  return Mxe(n) || Axe(n, e) || uY(n, e) || Txe();
}
function Txe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function uY(n, e) {
  if (n) {
    if (typeof n == "string") return nT(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return nT(n, e);
  }
}
function nT(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function Axe(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r, i, s, o, a = [], l = !0, c = !1;
    try {
      if (s = (t = t.call(n)).next, e !== 0) for (; !(l = (r = s.call(t)).done) && (a.push(r.value), a.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && t.return != null && (o = t.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return a;
  }
}
function Mxe(n) {
  if (Array.isArray(n)) return n;
}
var X2 = function(e, t, r) {
  return e + (t - e) * r;
}, rT = function(e) {
  var t = e.from, r = e.to;
  return t !== r;
}, kxe = function n(e, t, r) {
  var i = Gp(function(s, o) {
    if (rT(o)) {
      var a = e(o.from, o.to, o.velocity), l = Cxe(a, 2), c = l[0], u = l[1];
      return Nr(Nr({}, o), {}, {
        from: c,
        velocity: u
      });
    }
    return o;
  }, t);
  return r < 1 ? Gp(function(s, o) {
    return rT(o) ? Nr(Nr({}, o), {}, {
      velocity: X2(o.velocity, i[s].velocity, r),
      from: X2(o.from, i[s].from, r)
    }) : o;
  }, t) : n(e, i, r - 1);
};
const _xe = (function(n, e, t, r, i) {
  var s = ixe(n, e), o = s.reduce(function(v, y) {
    return Nr(Nr({}, v), {}, tT({}, y, [n[y], e[y]]));
  }, {}), a = s.reduce(function(v, y) {
    return Nr(Nr({}, v), {}, tT({}, y, {
      from: n[y],
      velocity: 0,
      to: e[y]
    }));
  }, {}), l = -1, c, u, d = function() {
    return null;
  }, f = function() {
    return Gp(function(y, b) {
      return b.from;
    }, a);
  }, h = function() {
    return !Object.values(a).filter(rT).length;
  }, m = function(y) {
    c || (c = y);
    var b = y - c, x = b / t.dt;
    a = kxe(t, a, x), i(Nr(Nr(Nr({}, n), e), f())), c = y, h() || (l = requestAnimationFrame(d));
  }, g = function(y) {
    u || (u = y);
    var b = (y - u) / r, x = Gp(function(w, C) {
      return X2.apply(void 0, S$(C).concat([t(b)]));
    }, o);
    if (i(Nr(Nr(Nr({}, n), e), x)), b < 1)
      l = requestAnimationFrame(d);
    else {
      var E = Gp(function(w, C) {
        return X2.apply(void 0, S$(C).concat([t(1)]));
      }, o);
      i(Nr(Nr(Nr({}, n), e), E));
    }
  };
  return d = t.isStepper ? m : g, function() {
    return requestAnimationFrame(d), function() {
      cancelAnimationFrame(l);
    };
  };
});
function Rf(n) {
  "@babel/helpers - typeof";
  return Rf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Rf(n);
}
var Oxe = ["children", "begin", "duration", "attributeName", "easing", "isActive", "steps", "from", "to", "canBegin", "onAnimationEnd", "shouldReAnimate", "onAnimationReStart"];
function Ixe(n, e) {
  if (n == null) return {};
  var t = Rxe(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function Rxe(n, e) {
  if (n == null) return {};
  var t = {}, r = Object.keys(n), i, s;
  for (s = 0; s < r.length; s++)
    i = r[s], !(e.indexOf(i) >= 0) && (t[i] = n[i]);
  return t;
}
function AS(n) {
  return Lxe(n) || Nxe(n) || Dxe(n) || Pxe();
}
function Pxe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Dxe(n, e) {
  if (n) {
    if (typeof n == "string") return iT(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return iT(n, e);
  }
}
function Nxe(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function Lxe(n) {
  if (Array.isArray(n)) return iT(n);
}
function iT(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function T$(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Qs(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? T$(Object(t), !0).forEach(function(r) {
      Tp(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : T$(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function Tp(n, e, t) {
  return e = dY(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function $xe(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Fxe(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, dY(r.key), r);
  }
}
function Bxe(n, e, t) {
  return e && Fxe(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function dY(n) {
  var e = zxe(n, "string");
  return Rf(e) === "symbol" ? e : String(e);
}
function zxe(n, e) {
  if (Rf(n) !== "object" || n === null) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Rf(r) !== "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function Hxe(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && sT(n, e);
}
function sT(n, e) {
  return sT = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, sT(n, e);
}
function Uxe(n) {
  var e = Vxe();
  return function() {
    var r = Z2(n), i;
    if (e) {
      var s = Z2(this).constructor;
      i = Reflect.construct(r, arguments, s);
    } else
      i = r.apply(this, arguments);
    return oT(this, i);
  };
}
function oT(n, e) {
  if (e && (Rf(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return aT(n);
}
function aT(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function Vxe() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham) return !1;
  if (typeof Proxy == "function") return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Z2(n) {
  return Z2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Z2(n);
}
var fl = /* @__PURE__ */ (function(n) {
  Hxe(t, n);
  var e = Uxe(t);
  function t(r, i) {
    var s;
    $xe(this, t), s = e.call(this, r, i);
    var o = s.props, a = o.isActive, l = o.attributeName, c = o.from, u = o.to, d = o.steps, f = o.children, h = o.duration;
    if (s.handleStyleChange = s.handleStyleChange.bind(aT(s)), s.changeStyle = s.changeStyle.bind(aT(s)), !a || h <= 0)
      return s.state = {
        style: {}
      }, typeof f == "function" && (s.state = {
        style: u
      }), oT(s);
    if (d && d.length)
      s.state = {
        style: d[0].style
      };
    else if (c) {
      if (typeof f == "function")
        return s.state = {
          style: c
        }, oT(s);
      s.state = {
        style: l ? Tp({}, l, c) : c
      };
    } else
      s.state = {
        style: {}
      };
    return s;
  }
  return Bxe(t, [{
    key: "componentDidMount",
    value: function() {
      var i = this.props, s = i.isActive, o = i.canBegin;
      this.mounted = !0, !(!s || !o) && this.runAnimation(this.props);
    }
  }, {
    key: "componentDidUpdate",
    value: function(i) {
      var s = this.props, o = s.isActive, a = s.canBegin, l = s.attributeName, c = s.shouldReAnimate, u = s.to, d = s.from, f = this.state.style;
      if (a) {
        if (!o) {
          var h = {
            style: l ? Tp({}, l, u) : u
          };
          this.state && f && (l && f[l] !== u || !l && f !== u) && this.setState(h);
          return;
        }
        if (!(q3e(i.to, u) && i.canBegin && i.isActive)) {
          var m = !i.canBegin || !i.isActive;
          this.manager && this.manager.stop(), this.stopJSAnimation && this.stopJSAnimation();
          var g = m || c ? d : i.to;
          if (this.state && f) {
            var v = {
              style: l ? Tp({}, l, g) : g
            };
            (l && f[l] !== g || !l && f !== g) && this.setState(v);
          }
          this.runAnimation(Qs(Qs({}, this.props), {}, {
            from: g,
            begin: 0
          }));
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.mounted = !1;
      var i = this.props.onAnimationEnd;
      this.unSubscribe && this.unSubscribe(), this.manager && (this.manager.stop(), this.manager = null), this.stopJSAnimation && this.stopJSAnimation(), i && i();
    }
  }, {
    key: "handleStyleChange",
    value: function(i) {
      this.changeStyle(i);
    }
  }, {
    key: "changeStyle",
    value: function(i) {
      this.mounted && this.setState({
        style: i
      });
    }
  }, {
    key: "runJSAnimation",
    value: function(i) {
      var s = this, o = i.from, a = i.to, l = i.duration, c = i.easing, u = i.begin, d = i.onAnimationEnd, f = i.onAnimationStart, h = _xe(o, a, yxe(c), l, this.changeStyle), m = function() {
        s.stopJSAnimation = h();
      };
      this.manager.start([f, u, m, l, d]);
    }
  }, {
    key: "runStepAnimation",
    value: function(i) {
      var s = this, o = i.steps, a = i.begin, l = i.onAnimationStart, c = o[0], u = c.style, d = c.duration, f = d === void 0 ? 0 : d, h = function(g, v, y) {
        if (y === 0)
          return g;
        var b = v.duration, x = v.easing, E = x === void 0 ? "ease" : x, w = v.style, C = v.properties, S = v.onAnimationEnd, M = y > 0 ? o[y - 1] : v, k = C || Object.keys(w);
        if (typeof E == "function" || E === "spring")
          return [].concat(AS(g), [s.runJSAnimation.bind(s, {
            from: M.style,
            to: w,
            duration: b,
            easing: E
          }), b]);
        var _ = w$(k, b, E), O = Qs(Qs(Qs({}, M.style), w), {}, {
          transition: _
        });
        return [].concat(AS(g), [O, b, S]).filter(sxe);
      };
      return this.manager.start([l].concat(AS(o.reduce(h, [u, Math.max(f, a)])), [i.onAnimationEnd]));
    }
  }, {
    key: "runAnimation",
    value: function(i) {
      this.manager || (this.manager = txe());
      var s = i.begin, o = i.duration, a = i.attributeName, l = i.to, c = i.easing, u = i.onAnimationStart, d = i.onAnimationEnd, f = i.steps, h = i.children, m = this.manager;
      if (this.unSubscribe = m.subscribe(this.handleStyleChange), typeof c == "function" || typeof h == "function" || c === "spring") {
        this.runJSAnimation(i);
        return;
      }
      if (f.length > 1) {
        this.runStepAnimation(i);
        return;
      }
      var g = a ? Tp({}, a, l) : l, v = w$(Object.keys(g), o, c);
      m.start([u, s, Qs(Qs({}, g), {}, {
        transition: v
      }), o, d]);
    }
  }, {
    key: "render",
    value: function() {
      var i = this.props, s = i.children;
      i.begin;
      var o = i.duration;
      i.attributeName, i.easing;
      var a = i.isActive;
      i.steps, i.from, i.to, i.canBegin, i.onAnimationEnd, i.shouldReAnimate, i.onAnimationReStart;
      var l = Ixe(i, Oxe), c = vu.count(s), u = this.state.style;
      if (typeof s == "function")
        return s(u);
      if (!a || c === 0 || o <= 0)
        return s;
      var d = function(h) {
        var m = h.props, g = m.style, v = g === void 0 ? {} : g, y = m.className, b = /* @__PURE__ */ br(h, Qs(Qs({}, l), {}, {
          style: Qs(Qs({}, v), u),
          className: y
        }));
        return b;
      };
      return c === 1 ? d(vu.only(s)) : /* @__PURE__ */ p.createElement("div", null, vu.map(s, function(f) {
        return d(f);
      }));
    }
  }]), t;
})(Sc);
fl.displayName = "Animate";
fl.defaultProps = {
  begin: 0,
  duration: 1e3,
  from: "",
  to: "",
  attributeName: "",
  easing: "ease",
  isActive: !0,
  canBegin: !0,
  steps: [],
  onAnimationEnd: function() {
  },
  onAnimationStart: function() {
  }
};
fl.propTypes = {
  from: pe.oneOfType([pe.object, pe.string]),
  to: pe.oneOfType([pe.object, pe.string]),
  attributeName: pe.string,
  // animation duration
  duration: pe.number,
  begin: pe.number,
  easing: pe.oneOfType([pe.string, pe.func]),
  steps: pe.arrayOf(pe.shape({
    duration: pe.number.isRequired,
    style: pe.object.isRequired,
    easing: pe.oneOfType([pe.oneOf(["ease", "ease-in", "ease-out", "ease-in-out", "linear"]), pe.func]),
    // transition css properties(dash case), optional
    properties: pe.arrayOf("string"),
    onAnimationEnd: pe.func
  })),
  children: pe.oneOfType([pe.node, pe.func]),
  isActive: pe.bool,
  canBegin: pe.bool,
  onAnimationEnd: pe.func,
  // decide if it should reanimate with initial from style when props change
  shouldReAnimate: pe.bool,
  onAnimationStart: pe.func,
  onAnimationReStart: pe.func
};
function Um() {
  return Um = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, Um.apply(null, arguments);
}
function jxe(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n) if ({}.hasOwnProperty.call(n, r)) {
    if (e.indexOf(r) !== -1) continue;
    t[r] = n[r];
  }
  return t;
}
function Vm(n) {
  "@babel/helpers - typeof";
  return Vm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Vm(n);
}
function Q2() {
  return Q2 = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, Q2.apply(this, arguments);
}
function Wxe(n, e) {
  return Yxe(n) || qxe(n, e) || Kxe(n, e) || Gxe();
}
function Gxe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Kxe(n, e) {
  if (n) {
    if (typeof n == "string") return A$(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return A$(n, e);
  }
}
function A$(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function qxe(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r, i, s, o, a = [], l = !0, c = !1;
    try {
      if (s = (t = t.call(n)).next, e !== 0) for (; !(l = (r = s.call(t)).done) && (a.push(r.value), a.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && t.return != null && (o = t.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return a;
  }
}
function Yxe(n) {
  if (Array.isArray(n)) return n;
}
function M$(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function k$(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? M$(Object(t), !0).forEach(function(r) {
      Xxe(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : M$(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function Xxe(n, e, t) {
  return e = Zxe(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function Zxe(n) {
  var e = Qxe(n, "string");
  return Vm(e) == "symbol" ? e : e + "";
}
function Qxe(n, e) {
  if (Vm(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Vm(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
var _$ = function(e, t, r, i, s) {
  var o = Math.min(Math.abs(r) / 2, Math.abs(i) / 2), a = i >= 0 ? 1 : -1, l = r >= 0 ? 1 : -1, c = i >= 0 && r >= 0 || i < 0 && r < 0 ? 1 : 0, u;
  if (o > 0 && s instanceof Array) {
    for (var d = [0, 0, 0, 0], f = 0, h = 4; f < h; f++)
      d[f] = s[f] > o ? o : s[f];
    u = "M".concat(e, ",").concat(t + a * d[0]), d[0] > 0 && (u += "A ".concat(d[0], ",").concat(d[0], ",0,0,").concat(c, ",").concat(e + l * d[0], ",").concat(t)), u += "L ".concat(e + r - l * d[1], ",").concat(t), d[1] > 0 && (u += "A ".concat(d[1], ",").concat(d[1], ",0,0,").concat(c, `,
        `).concat(e + r, ",").concat(t + a * d[1])), u += "L ".concat(e + r, ",").concat(t + i - a * d[2]), d[2] > 0 && (u += "A ".concat(d[2], ",").concat(d[2], ",0,0,").concat(c, `,
        `).concat(e + r - l * d[2], ",").concat(t + i)), u += "L ".concat(e + l * d[3], ",").concat(t + i), d[3] > 0 && (u += "A ".concat(d[3], ",").concat(d[3], ",0,0,").concat(c, `,
        `).concat(e, ",").concat(t + i - a * d[3])), u += "Z";
  } else if (o > 0 && s === +s && s > 0) {
    var m = Math.min(o, s);
    u = "M ".concat(e, ",").concat(t + a * m, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(c, ",").concat(e + l * m, ",").concat(t, `
            L `).concat(e + r - l * m, ",").concat(t, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(c, ",").concat(e + r, ",").concat(t + a * m, `
            L `).concat(e + r, ",").concat(t + i - a * m, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(c, ",").concat(e + r - l * m, ",").concat(t + i, `
            L `).concat(e + l * m, ",").concat(t + i, `
            A `).concat(m, ",").concat(m, ",0,0,").concat(c, ",").concat(e, ",").concat(t + i - a * m, " Z");
  } else
    u = "M ".concat(e, ",").concat(t, " h ").concat(r, " v ").concat(i, " h ").concat(-r, " Z");
  return u;
}, Jxe = function(e, t) {
  if (!e || !t)
    return !1;
  var r = e.x, i = e.y, s = t.x, o = t.y, a = t.width, l = t.height;
  if (Math.abs(a) > 0 && Math.abs(l) > 0) {
    var c = Math.min(s, s + a), u = Math.max(s, s + a), d = Math.min(o, o + l), f = Math.max(o, o + l);
    return r >= c && r <= u && i >= d && i <= f;
  }
  return !1;
}, e4e = {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  // The radius of border
  // The radius of four corners when radius is a number
  // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
  radius: 0,
  isAnimationActive: !1,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, DM = function(e) {
  var t = k$(k$({}, e4e), e), r = Gt(), i = wt(-1), s = Wxe(i, 2), o = s[0], a = s[1];
  Tt(function() {
    if (r.current && r.current.getTotalLength)
      try {
        var E = r.current.getTotalLength();
        E && a(E);
      } catch {
      }
  }, []);
  var l = t.x, c = t.y, u = t.width, d = t.height, f = t.radius, h = t.className, m = t.animationEasing, g = t.animationDuration, v = t.animationBegin, y = t.isAnimationActive, b = t.isUpdateAnimationActive;
  if (l !== +l || c !== +c || u !== +u || d !== +d || u === 0 || d === 0)
    return null;
  var x = Ut("recharts-rectangle", h);
  return b ? /* @__PURE__ */ p.createElement(fl, {
    canBegin: o > 0,
    from: {
      width: u,
      height: d,
      x: l,
      y: c
    },
    to: {
      width: u,
      height: d,
      x: l,
      y: c
    },
    duration: g,
    animationEasing: m,
    isActive: b
  }, function(E) {
    var w = E.width, C = E.height, S = E.x, M = E.y;
    return /* @__PURE__ */ p.createElement(fl, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: v,
      duration: g,
      isActive: y,
      easing: m
    }, /* @__PURE__ */ p.createElement("path", Q2({}, $t(t, !0), {
      className: x,
      d: _$(S, M, w, C, f),
      ref: r
    })));
  }) : /* @__PURE__ */ p.createElement("path", Q2({}, $t(t, !0), {
    className: x,
    d: _$(l, c, u, d, f)
  }));
};
function lT() {
  return lT = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, lT.apply(this, arguments);
}
var NM = function(e) {
  var t = e.cx, r = e.cy, i = e.r, s = e.className, o = Ut("recharts-dot", s);
  return t === +t && r === +r && i === +i ? /* @__PURE__ */ A.createElement("circle", lT({}, $t(e, !1), b2(e), {
    className: o,
    cx: t,
    cy: r,
    r: i
  })) : null;
};
function jm(n) {
  "@babel/helpers - typeof";
  return jm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, jm(n);
}
var t4e = ["x", "y", "top", "left", "width", "height", "className"];
function cT() {
  return cT = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, cT.apply(this, arguments);
}
function O$(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function n4e(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? O$(Object(t), !0).forEach(function(r) {
      r4e(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : O$(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function r4e(n, e, t) {
  return e = i4e(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function i4e(n) {
  var e = s4e(n, "string");
  return jm(e) == "symbol" ? e : e + "";
}
function s4e(n, e) {
  if (jm(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (jm(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function o4e(n, e) {
  if (n == null) return {};
  var t = a4e(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function a4e(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n)
    if (Object.prototype.hasOwnProperty.call(n, r)) {
      if (e.indexOf(r) >= 0) continue;
      t[r] = n[r];
    }
  return t;
}
var l4e = function(e, t, r, i, s, o) {
  return "M".concat(e, ",").concat(s, "v").concat(i, "M").concat(o, ",").concat(t, "h").concat(r);
}, c4e = function(e) {
  var t = e.x, r = t === void 0 ? 0 : t, i = e.y, s = i === void 0 ? 0 : i, o = e.top, a = o === void 0 ? 0 : o, l = e.left, c = l === void 0 ? 0 : l, u = e.width, d = u === void 0 ? 0 : u, f = e.height, h = f === void 0 ? 0 : f, m = e.className, g = o4e(e, t4e), v = n4e({
    x: r,
    y: s,
    top: a,
    left: c,
    width: d,
    height: h
  }, g);
  return !ke(r) || !ke(s) || !ke(d) || !ke(h) || !ke(a) || !ke(c) ? null : /* @__PURE__ */ p.createElement("path", cT({}, $t(v, !0), {
    className: Ut("recharts-cross", m),
    d: l4e(r, s, d, h, a, c)
  }));
}, MS, I$;
function u4e() {
  if (I$) return MS;
  I$ = 1;
  var n = _K(), e = n(Object.getPrototypeOf, Object);
  return MS = e, MS;
}
var kS, R$;
function d4e() {
  if (R$) return kS;
  R$ = 1;
  var n = yl(), e = u4e(), t = bl(), r = "[object Object]", i = Function.prototype, s = Object.prototype, o = i.toString, a = s.hasOwnProperty, l = o.call(Object);
  function c(u) {
    if (!t(u) || n(u) != r)
      return !1;
    var d = e(u);
    if (d === null)
      return !0;
    var f = a.call(d, "constructor") && d.constructor;
    return typeof f == "function" && f instanceof f && o.call(f) == l;
  }
  return kS = c, kS;
}
var f4e = d4e();
const h4e = /* @__PURE__ */ nn(f4e);
var _S, P$;
function p4e() {
  if (P$) return _S;
  P$ = 1;
  var n = yl(), e = bl(), t = "[object Boolean]";
  function r(i) {
    return i === !0 || i === !1 || e(i) && n(i) == t;
  }
  return _S = r, _S;
}
var m4e = p4e();
const g4e = /* @__PURE__ */ nn(m4e);
function Wm(n) {
  "@babel/helpers - typeof";
  return Wm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Wm(n);
}
function J2() {
  return J2 = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, J2.apply(this, arguments);
}
function v4e(n, e) {
  return x4e(n) || w4e(n, e) || b4e(n, e) || y4e();
}
function y4e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function b4e(n, e) {
  if (n) {
    if (typeof n == "string") return D$(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return D$(n, e);
  }
}
function D$(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function w4e(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r, i, s, o, a = [], l = !0, c = !1;
    try {
      if (s = (t = t.call(n)).next, e !== 0) for (; !(l = (r = s.call(t)).done) && (a.push(r.value), a.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && t.return != null && (o = t.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return a;
  }
}
function x4e(n) {
  if (Array.isArray(n)) return n;
}
function N$(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function L$(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? N$(Object(t), !0).forEach(function(r) {
      E4e(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : N$(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function E4e(n, e, t) {
  return e = S4e(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function S4e(n) {
  var e = C4e(n, "string");
  return Wm(e) == "symbol" ? e : e + "";
}
function C4e(n, e) {
  if (Wm(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Wm(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
var $$ = function(e, t, r, i, s) {
  var o = r - i, a;
  return a = "M ".concat(e, ",").concat(t), a += "L ".concat(e + r, ",").concat(t), a += "L ".concat(e + r - o / 2, ",").concat(t + s), a += "L ".concat(e + r - o / 2 - i, ",").concat(t + s), a += "L ".concat(e, ",").concat(t, " Z"), a;
}, T4e = {
  x: 0,
  y: 0,
  upperWidth: 0,
  lowerWidth: 0,
  height: 0,
  isUpdateAnimationActive: !1,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
}, A4e = function(e) {
  var t = L$(L$({}, T4e), e), r = Gt(), i = wt(-1), s = v4e(i, 2), o = s[0], a = s[1];
  Tt(function() {
    if (r.current && r.current.getTotalLength)
      try {
        var x = r.current.getTotalLength();
        x && a(x);
      } catch {
      }
  }, []);
  var l = t.x, c = t.y, u = t.upperWidth, d = t.lowerWidth, f = t.height, h = t.className, m = t.animationEasing, g = t.animationDuration, v = t.animationBegin, y = t.isUpdateAnimationActive;
  if (l !== +l || c !== +c || u !== +u || d !== +d || f !== +f || u === 0 && d === 0 || f === 0)
    return null;
  var b = Ut("recharts-trapezoid", h);
  return y ? /* @__PURE__ */ p.createElement(fl, {
    canBegin: o > 0,
    from: {
      upperWidth: 0,
      lowerWidth: 0,
      height: f,
      x: l,
      y: c
    },
    to: {
      upperWidth: u,
      lowerWidth: d,
      height: f,
      x: l,
      y: c
    },
    duration: g,
    animationEasing: m,
    isActive: y
  }, function(x) {
    var E = x.upperWidth, w = x.lowerWidth, C = x.height, S = x.x, M = x.y;
    return /* @__PURE__ */ p.createElement(fl, {
      canBegin: o > 0,
      from: "0px ".concat(o === -1 ? 1 : o, "px"),
      to: "".concat(o, "px 0px"),
      attributeName: "strokeDasharray",
      begin: v,
      duration: g,
      easing: m
    }, /* @__PURE__ */ p.createElement("path", J2({}, $t(t, !0), {
      className: b,
      d: $$(S, M, E, w, C),
      ref: r
    })));
  }) : /* @__PURE__ */ p.createElement("g", null, /* @__PURE__ */ p.createElement("path", J2({}, $t(t, !0), {
    className: b,
    d: $$(l, c, u, d, f)
  })));
}, M4e = ["option", "shapeType", "propTransformer", "activeClassName", "isActive"];
function Gm(n) {
  "@babel/helpers - typeof";
  return Gm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Gm(n);
}
function k4e(n, e) {
  if (n == null) return {};
  var t = _4e(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function _4e(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n)
    if (Object.prototype.hasOwnProperty.call(n, r)) {
      if (e.indexOf(r) >= 0) continue;
      t[r] = n[r];
    }
  return t;
}
function F$(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function ey(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? F$(Object(t), !0).forEach(function(r) {
      O4e(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : F$(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function O4e(n, e, t) {
  return e = I4e(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function I4e(n) {
  var e = R4e(n, "string");
  return Gm(e) == "symbol" ? e : e + "";
}
function R4e(n, e) {
  if (Gm(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Gm(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function P4e(n, e) {
  return ey(ey({}, e), n);
}
function D4e(n, e) {
  return n === "symbols";
}
function B$(n) {
  var e = n.shapeType, t = n.elementProps;
  switch (e) {
    case "rectangle":
      return /* @__PURE__ */ p.createElement(DM, t);
    case "trapezoid":
      return /* @__PURE__ */ p.createElement(A4e, t);
    case "sector":
      return /* @__PURE__ */ p.createElement(nY, t);
    case "symbols":
      if (D4e(e))
        return /* @__PURE__ */ p.createElement(QA, t);
      break;
    default:
      return null;
  }
}
function N4e(n) {
  return /* @__PURE__ */ ca(n) ? n.props : n;
}
function L4e(n) {
  var e = n.option, t = n.shapeType, r = n.propTransformer, i = r === void 0 ? P4e : r, s = n.activeClassName, o = s === void 0 ? "recharts-active-shape" : s, a = n.isActive, l = k4e(n, M4e), c;
  if (/* @__PURE__ */ ca(e))
    c = /* @__PURE__ */ br(e, ey(ey({}, l), N4e(e)));
  else if (Mt(e))
    c = e(l);
  else if (h4e(e) && !g4e(e)) {
    var u = i(e, l);
    c = /* @__PURE__ */ p.createElement(B$, {
      shapeType: t,
      elementProps: u
    });
  } else {
    var d = l;
    c = /* @__PURE__ */ p.createElement(B$, {
      shapeType: t,
      elementProps: d
    });
  }
  return a ? /* @__PURE__ */ p.createElement(jn, {
    className: o
  }, c) : c;
}
function jw(n, e) {
  return e != null && "trapezoids" in n.props;
}
function Ww(n, e) {
  return e != null && "sectors" in n.props;
}
function Km(n, e) {
  return e != null && "points" in n.props;
}
function $4e(n, e) {
  var t, r, i = n.x === (e == null || (t = e.labelViewBox) === null || t === void 0 ? void 0 : t.x) || n.x === e.x, s = n.y === (e == null || (r = e.labelViewBox) === null || r === void 0 ? void 0 : r.y) || n.y === e.y;
  return i && s;
}
function F4e(n, e) {
  var t = n.endAngle === e.endAngle, r = n.startAngle === e.startAngle;
  return t && r;
}
function B4e(n, e) {
  var t = n.x === e.x, r = n.y === e.y, i = n.z === e.z;
  return t && r && i;
}
function z4e(n, e) {
  var t;
  return jw(n, e) ? t = $4e : Ww(n, e) ? t = F4e : Km(n, e) && (t = B4e), t;
}
function H4e(n, e) {
  var t;
  return jw(n, e) ? t = "trapezoids" : Ww(n, e) ? t = "sectors" : Km(n, e) && (t = "points"), t;
}
function U4e(n, e) {
  if (jw(n, e)) {
    var t;
    return (t = e.tooltipPayload) === null || t === void 0 || (t = t[0]) === null || t === void 0 || (t = t.payload) === null || t === void 0 ? void 0 : t.payload;
  }
  if (Ww(n, e)) {
    var r;
    return (r = e.tooltipPayload) === null || r === void 0 || (r = r[0]) === null || r === void 0 || (r = r.payload) === null || r === void 0 ? void 0 : r.payload;
  }
  return Km(n, e) ? e.payload : {};
}
function V4e(n) {
  var e = n.activeTooltipItem, t = n.graphicalItem, r = n.itemData, i = H4e(t, e), s = U4e(t, e), o = r.filter(function(l, c) {
    var u = _m(s, l), d = t.props[i].filter(function(m) {
      var g = z4e(t, e);
      return g(m, e);
    }), f = t.props[i].indexOf(d[d.length - 1]), h = c === f;
    return u && h;
  }), a = r.indexOf(o[o.length - 1]);
  return a;
}
var OS, z$;
function j4e() {
  if (z$) return OS;
  z$ = 1;
  var n = Math.ceil, e = Math.max;
  function t(r, i, s, o) {
    for (var a = -1, l = e(n((i - r) / (s || 1)), 0), c = Array(l); l--; )
      c[o ? l : ++a] = r, r += s;
    return c;
  }
  return OS = t, OS;
}
var IS, H$;
function fY() {
  if (H$) return IS;
  H$ = 1;
  var n = WK(), e = 1 / 0, t = 17976931348623157e292;
  function r(i) {
    if (!i)
      return i === 0 ? i : 0;
    if (i = n(i), i === e || i === -e) {
      var s = i < 0 ? -1 : 1;
      return s * t;
    }
    return i === i ? i : 0;
  }
  return IS = r, IS;
}
var RS, U$;
function W4e() {
  if (U$) return RS;
  U$ = 1;
  var n = j4e(), e = Pw(), t = fY();
  function r(i) {
    return function(s, o, a) {
      return a && typeof a != "number" && e(s, o, a) && (o = a = void 0), s = t(s), o === void 0 ? (o = s, s = 0) : o = t(o), a = a === void 0 ? s < o ? 1 : -1 : t(a), n(s, o, a, i);
    };
  }
  return RS = r, RS;
}
var PS, V$;
function G4e() {
  if (V$) return PS;
  V$ = 1;
  var n = W4e(), e = n();
  return PS = e, PS;
}
var K4e = G4e();
const ty = /* @__PURE__ */ nn(K4e);
function qm(n) {
  "@babel/helpers - typeof";
  return qm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, qm(n);
}
function j$(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function W$(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? j$(Object(t), !0).forEach(function(r) {
      hY(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : j$(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function hY(n, e, t) {
  return e = q4e(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function q4e(n) {
  var e = Y4e(n, "string");
  return qm(e) == "symbol" ? e : e + "";
}
function Y4e(n, e) {
  if (qm(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (qm(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
var X4e = ["Webkit", "Moz", "O", "ms"], Z4e = function(e, t) {
  var r = e.replace(/(\w)/, function(s) {
    return s.toUpperCase();
  }), i = X4e.reduce(function(s, o) {
    return W$(W$({}, s), {}, hY({}, o + r, t));
  }, {});
  return i[e] = t, i;
};
function Pf(n) {
  "@babel/helpers - typeof";
  return Pf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Pf(n);
}
function ny() {
  return ny = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, ny.apply(this, arguments);
}
function G$(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function DS(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? G$(Object(t), !0).forEach(function(r) {
      ns(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : G$(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function Q4e(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function K$(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, mY(r.key), r);
  }
}
function J4e(n, e, t) {
  return e && K$(n.prototype, e), t && K$(n, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function eEe(n, e, t) {
  return e = ry(e), tEe(n, pY() ? Reflect.construct(e, t || [], ry(n).constructor) : e.apply(n, t));
}
function tEe(n, e) {
  if (e && (Pf(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return nEe(n);
}
function nEe(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function pY() {
  try {
    var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (pY = function() {
    return !!n;
  })();
}
function ry(n) {
  return ry = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, ry(n);
}
function rEe(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && uT(n, e);
}
function uT(n, e) {
  return uT = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, uT(n, e);
}
function ns(n, e, t) {
  return e = mY(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function mY(n) {
  var e = iEe(n, "string");
  return Pf(e) == "symbol" ? e : e + "";
}
function iEe(n, e) {
  if (Pf(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Pf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
var sEe = function(e) {
  var t = e.data, r = e.startIndex, i = e.endIndex, s = e.x, o = e.width, a = e.travellerWidth;
  if (!t || !t.length)
    return {};
  var l = t.length, c = Vp().domain(ty(0, l)).range([s, s + o - a]), u = c.domain().map(function(d) {
    return c(d);
  });
  return {
    isTextActive: !1,
    isSlideMoving: !1,
    isTravellerMoving: !1,
    isTravellerFocused: !1,
    startX: c(r),
    endX: c(i),
    scale: c,
    scaleValues: u
  };
}, q$ = function(e) {
  return e.changedTouches && !!e.changedTouches.length;
}, Df = /* @__PURE__ */ (function(n) {
  function e(t) {
    var r;
    return Q4e(this, e), r = eEe(this, e, [t]), ns(r, "handleDrag", function(i) {
      r.leaveTimer && (clearTimeout(r.leaveTimer), r.leaveTimer = null), r.state.isTravellerMoving ? r.handleTravellerMove(i) : r.state.isSlideMoving && r.handleSlideDrag(i);
    }), ns(r, "handleTouchMove", function(i) {
      i.changedTouches != null && i.changedTouches.length > 0 && r.handleDrag(i.changedTouches[0]);
    }), ns(r, "handleDragEnd", function() {
      r.setState({
        isTravellerMoving: !1,
        isSlideMoving: !1
      }, function() {
        var i = r.props, s = i.endIndex, o = i.onDragEnd, a = i.startIndex;
        o?.({
          endIndex: s,
          startIndex: a
        });
      }), r.detachDragEndListener();
    }), ns(r, "handleLeaveWrapper", function() {
      (r.state.isTravellerMoving || r.state.isSlideMoving) && (r.leaveTimer = window.setTimeout(r.handleDragEnd, r.props.leaveTimeOut));
    }), ns(r, "handleEnterSlideOrTraveller", function() {
      r.setState({
        isTextActive: !0
      });
    }), ns(r, "handleLeaveSlideOrTraveller", function() {
      r.setState({
        isTextActive: !1
      });
    }), ns(r, "handleSlideDragStart", function(i) {
      var s = q$(i) ? i.changedTouches[0] : i;
      r.setState({
        isTravellerMoving: !1,
        isSlideMoving: !0,
        slideMoveStartX: s.pageX
      }), r.attachDragEndListener();
    }), r.travellerDragStartHandlers = {
      startX: r.handleTravellerDragStart.bind(r, "startX"),
      endX: r.handleTravellerDragStart.bind(r, "endX")
    }, r.state = {}, r;
  }
  return rEe(e, n), J4e(e, [{
    key: "componentWillUnmount",
    value: function() {
      this.leaveTimer && (clearTimeout(this.leaveTimer), this.leaveTimer = null), this.detachDragEndListener();
    }
  }, {
    key: "getIndex",
    value: function(r) {
      var i = r.startX, s = r.endX, o = this.state.scaleValues, a = this.props, l = a.gap, c = a.data, u = c.length - 1, d = Math.min(i, s), f = Math.max(i, s), h = e.getIndexInRange(o, d), m = e.getIndexInRange(o, f);
      return {
        startIndex: h - h % l,
        endIndex: m === u ? u : m - m % l
      };
    }
  }, {
    key: "getTextOfTick",
    value: function(r) {
      var i = this.props, s = i.data, o = i.tickFormatter, a = i.dataKey, l = ys(s[r], a, r);
      return Mt(o) ? o(l, r) : l;
    }
  }, {
    key: "attachDragEndListener",
    value: function() {
      window.addEventListener("mouseup", this.handleDragEnd, !0), window.addEventListener("touchend", this.handleDragEnd, !0), window.addEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "detachDragEndListener",
    value: function() {
      window.removeEventListener("mouseup", this.handleDragEnd, !0), window.removeEventListener("touchend", this.handleDragEnd, !0), window.removeEventListener("mousemove", this.handleDrag, !0);
    }
  }, {
    key: "handleSlideDrag",
    value: function(r) {
      var i = this.state, s = i.slideMoveStartX, o = i.startX, a = i.endX, l = this.props, c = l.x, u = l.width, d = l.travellerWidth, f = l.startIndex, h = l.endIndex, m = l.onChange, g = r.pageX - s;
      g > 0 ? g = Math.min(g, c + u - d - a, c + u - d - o) : g < 0 && (g = Math.max(g, c - o, c - a));
      var v = this.getIndex({
        startX: o + g,
        endX: a + g
      });
      (v.startIndex !== f || v.endIndex !== h) && m && m(v), this.setState({
        startX: o + g,
        endX: a + g,
        slideMoveStartX: r.pageX
      });
    }
  }, {
    key: "handleTravellerDragStart",
    value: function(r, i) {
      var s = q$(i) ? i.changedTouches[0] : i;
      this.setState({
        isSlideMoving: !1,
        isTravellerMoving: !0,
        movingTravellerId: r,
        brushMoveStartX: s.pageX
      }), this.attachDragEndListener();
    }
  }, {
    key: "handleTravellerMove",
    value: function(r) {
      var i = this.state, s = i.brushMoveStartX, o = i.movingTravellerId, a = i.endX, l = i.startX, c = this.state[o], u = this.props, d = u.x, f = u.width, h = u.travellerWidth, m = u.onChange, g = u.gap, v = u.data, y = {
        startX: this.state.startX,
        endX: this.state.endX
      }, b = r.pageX - s;
      b > 0 ? b = Math.min(b, d + f - h - c) : b < 0 && (b = Math.max(b, d - c)), y[o] = c + b;
      var x = this.getIndex(y), E = x.startIndex, w = x.endIndex, C = function() {
        var M = v.length - 1;
        return o === "startX" && (a > l ? E % g === 0 : w % g === 0) || a < l && w === M || o === "endX" && (a > l ? w % g === 0 : E % g === 0) || a > l && w === M;
      };
      this.setState(ns(ns({}, o, c + b), "brushMoveStartX", r.pageX), function() {
        m && C() && m(x);
      });
    }
  }, {
    key: "handleTravellerMoveKeyboard",
    value: function(r, i) {
      var s = this, o = this.state, a = o.scaleValues, l = o.startX, c = o.endX, u = this.state[i], d = a.indexOf(u);
      if (d !== -1) {
        var f = d + r;
        if (!(f === -1 || f >= a.length)) {
          var h = a[f];
          i === "startX" && h >= c || i === "endX" && h <= l || this.setState(ns({}, i, h), function() {
            s.props.onChange(s.getIndex({
              startX: s.state.startX,
              endX: s.state.endX
            }));
          });
        }
      }
    }
  }, {
    key: "renderBackground",
    value: function() {
      var r = this.props, i = r.x, s = r.y, o = r.width, a = r.height, l = r.fill, c = r.stroke;
      return /* @__PURE__ */ p.createElement("rect", {
        stroke: c,
        fill: l,
        x: i,
        y: s,
        width: o,
        height: a
      });
    }
  }, {
    key: "renderPanorama",
    value: function() {
      var r = this.props, i = r.x, s = r.y, o = r.width, a = r.height, l = r.data, c = r.children, u = r.padding, d = vu.only(c);
      return d ? /* @__PURE__ */ p.cloneElement(d, {
        x: i,
        y: s,
        width: o,
        height: a,
        margin: u,
        compact: !0,
        data: l
      }) : null;
    }
  }, {
    key: "renderTravellerLayer",
    value: function(r, i) {
      var s, o, a = this, l = this.props, c = l.y, u = l.travellerWidth, d = l.height, f = l.traveller, h = l.ariaLabel, m = l.data, g = l.startIndex, v = l.endIndex, y = Math.max(r, this.props.x), b = DS(DS({}, $t(this.props, !1)), {}, {
        x: y,
        y: c,
        width: u,
        height: d
      }), x = h || "Min value: ".concat((s = m[g]) === null || s === void 0 ? void 0 : s.name, ", Max value: ").concat((o = m[v]) === null || o === void 0 ? void 0 : o.name);
      return /* @__PURE__ */ p.createElement(jn, {
        tabIndex: 0,
        role: "slider",
        "aria-label": x,
        "aria-valuenow": r,
        className: "recharts-brush-traveller",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.travellerDragStartHandlers[i],
        onTouchStart: this.travellerDragStartHandlers[i],
        onKeyDown: function(w) {
          ["ArrowLeft", "ArrowRight"].includes(w.key) && (w.preventDefault(), w.stopPropagation(), a.handleTravellerMoveKeyboard(w.key === "ArrowRight" ? 1 : -1, i));
        },
        onFocus: function() {
          a.setState({
            isTravellerFocused: !0
          });
        },
        onBlur: function() {
          a.setState({
            isTravellerFocused: !1
          });
        },
        style: {
          cursor: "col-resize"
        }
      }, e.renderTraveller(f, b));
    }
  }, {
    key: "renderSlide",
    value: function(r, i) {
      var s = this.props, o = s.y, a = s.height, l = s.stroke, c = s.travellerWidth, u = Math.min(r, i) + c, d = Math.max(Math.abs(i - r) - c, 0);
      return /* @__PURE__ */ p.createElement("rect", {
        className: "recharts-brush-slide",
        onMouseEnter: this.handleEnterSlideOrTraveller,
        onMouseLeave: this.handleLeaveSlideOrTraveller,
        onMouseDown: this.handleSlideDragStart,
        onTouchStart: this.handleSlideDragStart,
        style: {
          cursor: "move"
        },
        stroke: "none",
        fill: l,
        fillOpacity: 0.2,
        x: u,
        y: o,
        width: d,
        height: a
      });
    }
  }, {
    key: "renderText",
    value: function() {
      var r = this.props, i = r.startIndex, s = r.endIndex, o = r.y, a = r.height, l = r.travellerWidth, c = r.stroke, u = this.state, d = u.startX, f = u.endX, h = 5, m = {
        pointerEvents: "none",
        fill: c
      };
      return /* @__PURE__ */ p.createElement(jn, {
        className: "recharts-brush-texts"
      }, /* @__PURE__ */ p.createElement(I2, ny({
        textAnchor: "end",
        verticalAnchor: "middle",
        x: Math.min(d, f) - h,
        y: o + a / 2
      }, m), this.getTextOfTick(i)), /* @__PURE__ */ p.createElement(I2, ny({
        textAnchor: "start",
        verticalAnchor: "middle",
        x: Math.max(d, f) + l + h,
        y: o + a / 2
      }, m), this.getTextOfTick(s)));
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.data, s = r.className, o = r.children, a = r.x, l = r.y, c = r.width, u = r.height, d = r.alwaysShowText, f = this.state, h = f.startX, m = f.endX, g = f.isTextActive, v = f.isSlideMoving, y = f.isTravellerMoving, b = f.isTravellerFocused;
      if (!i || !i.length || !ke(a) || !ke(l) || !ke(c) || !ke(u) || c <= 0 || u <= 0)
        return null;
      var x = Ut("recharts-brush", s), E = p.Children.count(o) === 1, w = Z4e("userSelect", "none");
      return /* @__PURE__ */ p.createElement(jn, {
        className: x,
        onMouseLeave: this.handleLeaveWrapper,
        onTouchMove: this.handleTouchMove,
        style: w
      }, this.renderBackground(), E && this.renderPanorama(), this.renderSlide(h, m), this.renderTravellerLayer(h, "startX"), this.renderTravellerLayer(m, "endX"), (g || v || y || b || d) && this.renderText());
    }
  }], [{
    key: "renderDefaultTraveller",
    value: function(r) {
      var i = r.x, s = r.y, o = r.width, a = r.height, l = r.stroke, c = Math.floor(s + a / 2) - 1;
      return /* @__PURE__ */ p.createElement(p.Fragment, null, /* @__PURE__ */ p.createElement("rect", {
        x: i,
        y: s,
        width: o,
        height: a,
        fill: l,
        stroke: "none"
      }), /* @__PURE__ */ p.createElement("line", {
        x1: i + 1,
        y1: c,
        x2: i + o - 1,
        y2: c,
        fill: "none",
        stroke: "#fff"
      }), /* @__PURE__ */ p.createElement("line", {
        x1: i + 1,
        y1: c + 2,
        x2: i + o - 1,
        y2: c + 2,
        fill: "none",
        stroke: "#fff"
      }));
    }
  }, {
    key: "renderTraveller",
    value: function(r, i) {
      var s;
      return /* @__PURE__ */ p.isValidElement(r) ? s = /* @__PURE__ */ p.cloneElement(r, i) : Mt(r) ? s = r(i) : s = e.renderDefaultTraveller(i), s;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      var s = r.data, o = r.width, a = r.x, l = r.travellerWidth, c = r.updateId, u = r.startIndex, d = r.endIndex;
      if (s !== i.prevData || c !== i.prevUpdateId)
        return DS({
          prevData: s,
          prevTravellerWidth: l,
          prevUpdateId: c,
          prevX: a,
          prevWidth: o
        }, s && s.length ? sEe({
          data: s,
          width: o,
          x: a,
          travellerWidth: l,
          startIndex: u,
          endIndex: d
        }) : {
          scale: null,
          scaleValues: null
        });
      if (i.scale && (o !== i.prevWidth || a !== i.prevX || l !== i.prevTravellerWidth)) {
        i.scale.range([a, a + o - l]);
        var f = i.scale.domain().map(function(h) {
          return i.scale(h);
        });
        return {
          prevData: s,
          prevTravellerWidth: l,
          prevUpdateId: c,
          prevX: a,
          prevWidth: o,
          startX: i.scale(r.startIndex),
          endX: i.scale(r.endIndex),
          scaleValues: f
        };
      }
      return null;
    }
  }, {
    key: "getIndexInRange",
    value: function(r, i) {
      for (var s = r.length, o = 0, a = s - 1; a - o > 1; ) {
        var l = Math.floor((o + a) / 2);
        r[l] > i ? a = l : o = l;
      }
      return i >= r[a] ? a : o;
    }
  }]);
})(Sc);
ns(Df, "displayName", "Brush");
ns(Df, "defaultProps", {
  height: 40,
  travellerWidth: 5,
  gap: 1,
  fill: "#fff",
  stroke: "#666",
  padding: {
    top: 1,
    right: 1,
    bottom: 1,
    left: 1
  },
  leaveTimeOut: 1e3,
  alwaysShowText: !1
});
var NS, Y$;
function oEe() {
  if (Y$) return NS;
  Y$ = 1;
  var n = sM();
  function e(t, r) {
    var i;
    return n(t, function(s, o, a) {
      return i = r(s, o, a), !i;
    }), !!i;
  }
  return NS = e, NS;
}
var LS, X$;
function aEe() {
  if (X$) return LS;
  X$ = 1;
  var n = EK(), e = Tc(), t = oEe(), r = Gi(), i = Pw();
  function s(o, a, l) {
    var c = r(o) ? n : t;
    return l && i(o, a, l) && (a = void 0), c(o, e(a, 3));
  }
  return LS = s, LS;
}
var lEe = aEe();
const cEe = /* @__PURE__ */ nn(lEe);
var fa = function(e, t) {
  var r = e.alwaysShow, i = e.ifOverflow;
  return r && (i = "extendDomain"), i === t;
}, $S, Z$;
function uEe() {
  if (Z$) return $S;
  Z$ = 1;
  var n = zK();
  function e(t, r, i) {
    r == "__proto__" && n ? n(t, r, {
      configurable: !0,
      enumerable: !0,
      value: i,
      writable: !0
    }) : t[r] = i;
  }
  return $S = e, $S;
}
var FS, Q$;
function dEe() {
  if (Q$) return FS;
  Q$ = 1;
  var n = uEe(), e = FK(), t = Tc();
  function r(i, s) {
    var o = {};
    return s = t(s, 3), e(i, function(a, l, c) {
      n(o, l, s(a, l, c));
    }), o;
  }
  return FS = r, FS;
}
var fEe = dEe();
const hEe = /* @__PURE__ */ nn(fEe);
var BS, J$;
function pEe() {
  if (J$) return BS;
  J$ = 1;
  function n(e, t) {
    for (var r = -1, i = e == null ? 0 : e.length; ++r < i; )
      if (!t(e[r], r, e))
        return !1;
    return !0;
  }
  return BS = n, BS;
}
var zS, eF;
function mEe() {
  if (eF) return zS;
  eF = 1;
  var n = sM();
  function e(t, r) {
    var i = !0;
    return n(t, function(s, o, a) {
      return i = !!r(s, o, a), i;
    }), i;
  }
  return zS = e, zS;
}
var HS, tF;
function gEe() {
  if (tF) return HS;
  tF = 1;
  var n = pEe(), e = mEe(), t = Tc(), r = Gi(), i = Pw();
  function s(o, a, l) {
    var c = r(o) ? n : e;
    return l && i(o, a, l) && (a = void 0), c(o, t(a, 3));
  }
  return HS = s, HS;
}
var vEe = gEe();
const gY = /* @__PURE__ */ nn(vEe);
var yEe = ["x", "y"];
function Nf(n) {
  "@babel/helpers - typeof";
  return Nf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Nf(n);
}
function dT() {
  return dT = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, dT.apply(this, arguments);
}
function nF(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function sp(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? nF(Object(t), !0).forEach(function(r) {
      bEe(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : nF(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function bEe(n, e, t) {
  return e = wEe(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function wEe(n) {
  var e = xEe(n, "string");
  return Nf(e) == "symbol" ? e : e + "";
}
function xEe(n, e) {
  if (Nf(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Nf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function EEe(n, e) {
  if (n == null) return {};
  var t = SEe(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function SEe(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n)
    if (Object.prototype.hasOwnProperty.call(n, r)) {
      if (e.indexOf(r) >= 0) continue;
      t[r] = n[r];
    }
  return t;
}
function CEe(n, e) {
  var t = n.x, r = n.y, i = EEe(n, yEe), s = "".concat(t), o = parseInt(s, 10), a = "".concat(r), l = parseInt(a, 10), c = "".concat(e.height || i.height), u = parseInt(c, 10), d = "".concat(e.width || i.width), f = parseInt(d, 10);
  return sp(sp(sp(sp(sp({}, e), i), o ? {
    x: o
  } : {}), l ? {
    y: l
  } : {}), {}, {
    height: u,
    width: f,
    name: e.name,
    radius: e.radius
  });
}
function rF(n) {
  return /* @__PURE__ */ p.createElement(L4e, dT({
    shapeType: "rectangle",
    propTransformer: CEe,
    activeClassName: "recharts-active-bar"
  }, n));
}
var TEe = function(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  return function(r, i) {
    if (typeof e == "number") return e;
    var s = ke(r) || Ape(r);
    return s ? e(r, i) : (s || (process.env.NODE_ENV !== "production" ? Fi(!1, "minPointSize callback function received a value with type of ".concat(Nf(r), ". Currently only numbers or null/undefined are supported.")) : Fi()), t);
  };
}, AEe = ["value", "background"], vY;
function Lf(n) {
  "@babel/helpers - typeof";
  return Lf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Lf(n);
}
function MEe(n, e) {
  if (n == null) return {};
  var t = kEe(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function kEe(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n)
    if (Object.prototype.hasOwnProperty.call(n, r)) {
      if (e.indexOf(r) >= 0) continue;
      t[r] = n[r];
    }
  return t;
}
function iy() {
  return iy = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, iy.apply(this, arguments);
}
function iF(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function rr(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? iF(Object(t), !0).forEach(function(r) {
      Xl(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : iF(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function _Ee(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function sF(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, bY(r.key), r);
  }
}
function OEe(n, e, t) {
  return e && sF(n.prototype, e), t && sF(n, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function IEe(n, e, t) {
  return e = sy(e), REe(n, yY() ? Reflect.construct(e, t || [], sy(n).constructor) : e.apply(n, t));
}
function REe(n, e) {
  if (e && (Lf(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return PEe(n);
}
function PEe(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function yY() {
  try {
    var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (yY = function() {
    return !!n;
  })();
}
function sy(n) {
  return sy = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, sy(n);
}
function DEe(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && fT(n, e);
}
function fT(n, e) {
  return fT = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, fT(n, e);
}
function Xl(n, e, t) {
  return e = bY(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function bY(n) {
  var e = NEe(n, "string");
  return Lf(e) == "symbol" ? e : e + "";
}
function NEe(n, e) {
  if (Lf(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Lf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
var p1 = /* @__PURE__ */ (function(n) {
  function e() {
    var t;
    _Ee(this, e);
    for (var r = arguments.length, i = new Array(r), s = 0; s < r; s++)
      i[s] = arguments[s];
    return t = IEe(this, e, [].concat(i)), Xl(t, "state", {
      isAnimationFinished: !1
    }), Xl(t, "id", l1("recharts-bar-")), Xl(t, "handleAnimationEnd", function() {
      var o = t.props.onAnimationEnd;
      t.setState({
        isAnimationFinished: !0
      }), o && o();
    }), Xl(t, "handleAnimationStart", function() {
      var o = t.props.onAnimationStart;
      t.setState({
        isAnimationFinished: !1
      }), o && o();
    }), t;
  }
  return DEe(e, n), OEe(e, [{
    key: "renderRectanglesStatically",
    value: function(r) {
      var i = this, s = this.props, o = s.shape, a = s.dataKey, l = s.activeIndex, c = s.activeBar, u = $t(this.props, !1);
      return r && r.map(function(d, f) {
        var h = f === l, m = h ? c : o, g = rr(rr(rr({}, u), d), {}, {
          isActive: h,
          option: m,
          index: f,
          dataKey: a,
          onAnimationStart: i.handleAnimationStart,
          onAnimationEnd: i.handleAnimationEnd
        });
        return /* @__PURE__ */ p.createElement(jn, iy({
          className: "recharts-bar-rectangle"
        }, w2(i.props, d, f), {
          // https://github.com/recharts/recharts/issues/5415
          // eslint-disable-next-line react/no-array-index-key
          key: "rectangle-".concat(d?.x, "-").concat(d?.y, "-").concat(d?.value, "-").concat(f)
        }), /* @__PURE__ */ p.createElement(rF, g));
      });
    }
  }, {
    key: "renderRectanglesWithAnimation",
    value: function() {
      var r = this, i = this.props, s = i.data, o = i.layout, a = i.isAnimationActive, l = i.animationBegin, c = i.animationDuration, u = i.animationEasing, d = i.animationId, f = this.state.prevData;
      return /* @__PURE__ */ p.createElement(fl, {
        begin: l,
        duration: c,
        isActive: a,
        easing: u,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "bar-".concat(d),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(h) {
        var m = h.t, g = s.map(function(v, y) {
          var b = f && f[y];
          if (b) {
            var x = _s(b.x, v.x), E = _s(b.y, v.y), w = _s(b.width, v.width), C = _s(b.height, v.height);
            return rr(rr({}, v), {}, {
              x: x(m),
              y: E(m),
              width: w(m),
              height: C(m)
            });
          }
          if (o === "horizontal") {
            var S = _s(0, v.height), M = S(m);
            return rr(rr({}, v), {}, {
              y: v.y + v.height - M,
              height: M
            });
          }
          var k = _s(0, v.width), _ = k(m);
          return rr(rr({}, v), {}, {
            width: _
          });
        });
        return /* @__PURE__ */ p.createElement(jn, null, r.renderRectanglesStatically(g));
      });
    }
  }, {
    key: "renderRectangles",
    value: function() {
      var r = this.props, i = r.data, s = r.isAnimationActive, o = this.state.prevData;
      return s && i && i.length && (!o || !_m(o, i)) ? this.renderRectanglesWithAnimation() : this.renderRectanglesStatically(i);
    }
  }, {
    key: "renderBackground",
    value: function() {
      var r = this, i = this.props, s = i.data, o = i.dataKey, a = i.activeIndex, l = $t(this.props.background, !1);
      return s.map(function(c, u) {
        c.value;
        var d = c.background, f = MEe(c, AEe);
        if (!d)
          return null;
        var h = rr(rr(rr(rr(rr({}, f), {}, {
          fill: "#eee"
        }, d), l), w2(r.props, c, u)), {}, {
          onAnimationStart: r.handleAnimationStart,
          onAnimationEnd: r.handleAnimationEnd,
          dataKey: o,
          index: u,
          className: "recharts-bar-background-rectangle"
        });
        return /* @__PURE__ */ p.createElement(rF, iy({
          key: "background-bar-".concat(u),
          option: r.props.background,
          isActive: u === a
        }, h));
      });
    }
  }, {
    key: "renderErrorBar",
    value: function(r, i) {
      if (this.props.isAnimationActive && !this.state.isAnimationFinished)
        return null;
      var s = this.props, o = s.data, a = s.xAxis, l = s.yAxis, c = s.layout, u = s.children, d = go(u, Vw);
      if (!d)
        return null;
      var f = c === "vertical" ? o[0].height / 2 : o[0].width / 2, h = function(v, y) {
        var b = Array.isArray(v.value) ? v.value[1] : v.value;
        return {
          x: v.x,
          y: v.y,
          value: b,
          errorVal: ys(v, y)
        };
      }, m = {
        clipPath: r ? "url(#clipPath-".concat(i, ")") : null
      };
      return /* @__PURE__ */ p.createElement(jn, m, d.map(function(g) {
        return /* @__PURE__ */ p.cloneElement(g, {
          key: "error-bar-".concat(i, "-").concat(g.props.dataKey),
          data: o,
          xAxis: a,
          yAxis: l,
          layout: c,
          offset: f,
          dataPointFormatter: h
        });
      }));
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.hide, s = r.data, o = r.className, a = r.xAxis, l = r.yAxis, c = r.left, u = r.top, d = r.width, f = r.height, h = r.isAnimationActive, m = r.background, g = r.id;
      if (i || !s || !s.length)
        return null;
      var v = this.state.isAnimationFinished, y = Ut("recharts-bar", o), b = a && a.allowDataOverflow, x = l && l.allowDataOverflow, E = b || x, w = Bt(g) ? this.id : g;
      return /* @__PURE__ */ p.createElement(jn, {
        className: y
      }, b || x ? /* @__PURE__ */ p.createElement("defs", null, /* @__PURE__ */ p.createElement("clipPath", {
        id: "clipPath-".concat(w)
      }, /* @__PURE__ */ p.createElement("rect", {
        x: b ? c : c - d / 2,
        y: x ? u : u - f / 2,
        width: b ? d : d * 2,
        height: x ? f : f * 2
      }))) : null, /* @__PURE__ */ p.createElement(jn, {
        className: "recharts-bar-rectangles",
        clipPath: E ? "url(#clipPath-".concat(w, ")") : null
      }, m ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(E, w), (!h || v) && sc.renderCallByParent(this.props, s));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      return r.animationId !== i.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curData: r.data,
        prevData: i.curData
      } : r.data !== i.curData ? {
        curData: r.data
      } : null;
    }
  }]);
})(Sc);
vY = p1;
Xl(p1, "displayName", "Bar");
Xl(p1, "defaultProps", {
  xAxisId: 0,
  yAxisId: 0,
  legendType: "rect",
  minPointSize: 0,
  hide: !1,
  data: [],
  layout: "vertical",
  activeBar: !1,
  isAnimationActive: !Th.isSsr,
  animationBegin: 0,
  animationDuration: 400,
  animationEasing: "ease"
});
Xl(p1, "getComposedData", function(n) {
  var e = n.props, t = n.item, r = n.barPosition, i = n.bandSize, s = n.xAxis, o = n.yAxis, a = n.xAxisTicks, l = n.yAxisTicks, c = n.stackedData, u = n.dataStartIndex, d = n.displayedData, f = n.offset, h = Kbe(r, t);
  if (!h)
    return null;
  var m = e.layout, g = t.type.defaultProps, v = g !== void 0 ? rr(rr({}, g), t.props) : t.props, y = v.dataKey, b = v.children, x = v.minPointSize, E = m === "horizontal" ? o : s, w = c ? E.scale.domain() : null, C = twe({
    numericAxis: E
  }), S = go(b, KK), M = d.map(function(k, _) {
    var O, I, R, P, D, L;
    c ? O = qbe(c[u + _], w) : (O = ys(k, y), Array.isArray(O) || (O = [C, O]));
    var B = TEe(x, vY.defaultProps.minPointSize)(O[1], _);
    if (m === "horizontal") {
      var $, z = [o.scale(O[0]), o.scale(O[1])], H = z[0], U = z[1];
      I = NL({
        axis: s,
        ticks: a,
        bandSize: i,
        offset: h.offset,
        entry: k,
        index: _
      }), R = ($ = U ?? H) !== null && $ !== void 0 ? $ : void 0, P = h.size;
      var F = H - U;
      if (D = Number.isNaN(F) ? 0 : F, L = {
        x: I,
        y: o.y,
        width: P,
        height: o.height
      }, Math.abs(B) > 0 && Math.abs(D) < Math.abs(B)) {
        var V = co(D || B) * (Math.abs(B) - Math.abs(D));
        R -= V, D += V;
      }
    } else {
      var X = [s.scale(O[0]), s.scale(O[1])], Z = X[0], ie = X[1];
      if (I = Z, R = NL({
        axis: o,
        ticks: l,
        bandSize: i,
        offset: h.offset,
        entry: k,
        index: _
      }), P = ie - Z, D = h.size, L = {
        x: s.x,
        y: R,
        width: s.width,
        height: D
      }, Math.abs(B) > 0 && Math.abs(P) < Math.abs(B)) {
        var J = co(P || B) * (Math.abs(B) - Math.abs(P));
        P += J;
      }
    }
    return rr(rr(rr({}, k), {}, {
      x: I,
      y: R,
      width: P,
      height: D,
      value: c ? O : O[1],
      payload: k,
      background: L
    }, S && S[_] && S[_].props), {}, {
      tooltipPayload: [Jq(t, k)],
      tooltipPosition: {
        x: I + P / 2,
        y: R + D / 2
      }
    });
  });
  return rr({
    data: M,
    layout: m
  }, f);
});
function Ym(n) {
  "@babel/helpers - typeof";
  return Ym = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ym(n);
}
function LEe(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function oF(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, wY(r.key), r);
  }
}
function $Ee(n, e, t) {
  return e && oF(n.prototype, e), t && oF(n, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function aF(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function io(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? aF(Object(t), !0).forEach(function(r) {
      Gw(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : aF(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function Gw(n, e, t) {
  return e = wY(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function wY(n) {
  var e = FEe(n, "string");
  return Ym(e) == "symbol" ? e : e + "";
}
function FEe(n, e) {
  if (Ym(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Ym(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
var BEe = function(e, t, r, i, s) {
  var o = e.width, a = e.height, l = e.layout, c = e.children, u = Object.keys(t), d = {
    left: r.left,
    leftMirror: r.left,
    right: o - r.right,
    rightMirror: o - r.right,
    top: r.top,
    topMirror: r.top,
    bottom: a - r.bottom,
    bottomMirror: a - r.bottom
  }, f = !!ss(c, p1);
  return u.reduce(function(h, m) {
    var g = t[m], v = g.orientation, y = g.domain, b = g.padding, x = b === void 0 ? {} : b, E = g.mirror, w = g.reversed, C = "".concat(v).concat(E ? "Mirror" : ""), S, M, k, _, O;
    if (g.type === "number" && (g.padding === "gap" || g.padding === "no-gap")) {
      var I = y[1] - y[0], R = 1 / 0, P = g.categoricalDomain.sort(_pe);
      if (P.forEach(function(X, Z) {
        Z > 0 && (R = Math.min((X || 0) - (P[Z - 1] || 0), R));
      }), Number.isFinite(R)) {
        var D = R / I, L = g.layout === "vertical" ? r.height : r.width;
        if (g.padding === "gap" && (S = D * L / 2), g.padding === "no-gap") {
          var B = Ru(e.barCategoryGap, D * L), $ = D * L / 2;
          S = $ - B - ($ - B) / L * B;
        }
      }
    }
    i === "xAxis" ? M = [r.left + (x.left || 0) + (S || 0), r.left + r.width - (x.right || 0) - (S || 0)] : i === "yAxis" ? M = l === "horizontal" ? [r.top + r.height - (x.bottom || 0), r.top + (x.top || 0)] : [r.top + (x.top || 0) + (S || 0), r.top + r.height - (x.bottom || 0) - (S || 0)] : M = g.range, w && (M = [M[1], M[0]]);
    var z = Wbe(g, s, f), H = z.scale, U = z.realScaleType;
    H.domain(y).range(M), Gbe(H);
    var F = ewe(H, io(io({}, g), {}, {
      realScaleType: U
    }));
    i === "xAxis" ? (O = v === "top" && !E || v === "bottom" && E, k = r.left, _ = d[C] - O * g.height) : i === "yAxis" && (O = v === "left" && !E || v === "right" && E, k = d[C] - O * g.width, _ = r.top);
    var V = io(io(io({}, g), F), {}, {
      realScaleType: U,
      x: k,
      y: _,
      scale: H,
      width: i === "xAxis" ? r.width : g.width,
      height: i === "yAxis" ? r.height : g.height
    });
    return V.bandSize = W2(V, F), !g.hide && i === "xAxis" ? d[C] += (O ? -1 : 1) * V.height : g.hide || (d[C] += (O ? -1 : 1) * V.width), io(io({}, h), {}, Gw({}, m, V));
  }, {});
}, xY = function(e, t) {
  var r = e.x, i = e.y, s = t.x, o = t.y;
  return {
    x: Math.min(r, s),
    y: Math.min(i, o),
    width: Math.abs(s - r),
    height: Math.abs(o - i)
  };
}, zEe = function(e) {
  var t = e.x1, r = e.y1, i = e.x2, s = e.y2;
  return xY({
    x: t,
    y: r
  }, {
    x: i,
    y: s
  });
}, EY = /* @__PURE__ */ (function() {
  function n(e) {
    LEe(this, n), this.scale = e;
  }
  return $Ee(n, [{
    key: "domain",
    get: function() {
      return this.scale.domain;
    }
  }, {
    key: "range",
    get: function() {
      return this.scale.range;
    }
  }, {
    key: "rangeMin",
    get: function() {
      return this.range()[0];
    }
  }, {
    key: "rangeMax",
    get: function() {
      return this.range()[1];
    }
  }, {
    key: "bandwidth",
    get: function() {
      return this.scale.bandwidth;
    }
  }, {
    key: "apply",
    value: function(t) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = r.bandAware, s = r.position;
      if (t !== void 0) {
        if (s)
          switch (s) {
            case "start":
              return this.scale(t);
            case "middle": {
              var o = this.bandwidth ? this.bandwidth() / 2 : 0;
              return this.scale(t) + o;
            }
            case "end": {
              var a = this.bandwidth ? this.bandwidth() : 0;
              return this.scale(t) + a;
            }
            default:
              return this.scale(t);
          }
        if (i) {
          var l = this.bandwidth ? this.bandwidth() / 2 : 0;
          return this.scale(t) + l;
        }
        return this.scale(t);
      }
    }
  }, {
    key: "isInRange",
    value: function(t) {
      var r = this.range(), i = r[0], s = r[r.length - 1];
      return i <= s ? t >= i && t <= s : t >= s && t <= i;
    }
  }], [{
    key: "create",
    value: function(t) {
      return new n(t);
    }
  }]);
})();
Gw(EY, "EPS", 1e-4);
var LM = function(e) {
  var t = Object.keys(e).reduce(function(r, i) {
    return io(io({}, r), {}, Gw({}, i, EY.create(e[i])));
  }, {});
  return io(io({}, t), {}, {
    apply: function(i) {
      var s = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o = s.bandAware, a = s.position;
      return hEe(i, function(l, c) {
        return t[c].apply(l, {
          bandAware: o,
          position: a
        });
      });
    },
    isInRange: function(i) {
      return gY(i, function(s, o) {
        return t[o].isInRange(s);
      });
    }
  });
};
function HEe(n) {
  return (n % 180 + 180) % 180;
}
var UEe = function(e) {
  var t = e.width, r = e.height, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, s = HEe(i), o = s * Math.PI / 180, a = Math.atan(r / t), l = o > a && o < Math.PI - a ? r / Math.sin(o) : t / Math.cos(o);
  return Math.abs(l);
}, US, lF;
function VEe() {
  if (lF) return US;
  lF = 1;
  var n = Tc(), e = c1(), t = Iw();
  function r(i) {
    return function(s, o, a) {
      var l = Object(s);
      if (!e(s)) {
        var c = n(o, 3);
        s = t(s), o = function(d) {
          return c(l[d], d, l);
        };
      }
      var u = i(s, o, a);
      return u > -1 ? l[c ? s[u] : u] : void 0;
    };
  }
  return US = r, US;
}
var VS, cF;
function jEe() {
  if (cF) return VS;
  cF = 1;
  var n = fY();
  function e(t) {
    var r = n(t), i = r % 1;
    return r === r ? i ? r - i : r : 0;
  }
  return VS = e, VS;
}
var jS, uF;
function WEe() {
  if (uF) return jS;
  uF = 1;
  var n = PK(), e = Tc(), t = jEe(), r = Math.max;
  function i(s, o, a) {
    var l = s == null ? 0 : s.length;
    if (!l)
      return -1;
    var c = a == null ? 0 : t(a);
    return c < 0 && (c = r(l + c, 0)), n(s, e(o, 3), c);
  }
  return jS = i, jS;
}
var WS, dF;
function GEe() {
  if (dF) return WS;
  dF = 1;
  var n = VEe(), e = WEe(), t = n(e);
  return WS = t, WS;
}
var KEe = GEe();
const qEe = /* @__PURE__ */ nn(KEe);
var YEe = YG();
const XEe = /* @__PURE__ */ nn(YEe);
var ZEe = XEe(function(n) {
  return {
    x: n.left,
    y: n.top,
    width: n.width,
    height: n.height
  };
}, function(n) {
  return ["l", n.left, "t", n.top, "w", n.width, "h", n.height].join("");
});
function oy(n) {
  "@babel/helpers - typeof";
  return oy = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, oy(n);
}
var $M = /* @__PURE__ */ Ws(void 0), FM = /* @__PURE__ */ Ws(void 0), SY = /* @__PURE__ */ Ws(void 0), CY = /* @__PURE__ */ Ws({}), TY = /* @__PURE__ */ Ws(void 0), AY = /* @__PURE__ */ Ws(0), MY = /* @__PURE__ */ Ws(0), fF = function(e) {
  var t = e.state, r = t.xAxisMap, i = t.yAxisMap, s = t.offset, o = e.clipPathId, a = e.children, l = e.width, c = e.height, u = ZEe(s);
  return /* @__PURE__ */ p.createElement($M.Provider, {
    value: r
  }, /* @__PURE__ */ p.createElement(FM.Provider, {
    value: i
  }, /* @__PURE__ */ p.createElement(CY.Provider, {
    value: s
  }, /* @__PURE__ */ p.createElement(SY.Provider, {
    value: u
  }, /* @__PURE__ */ p.createElement(TY.Provider, {
    value: o
  }, /* @__PURE__ */ p.createElement(AY.Provider, {
    value: c
  }, /* @__PURE__ */ p.createElement(MY.Provider, {
    value: l
  }, a)))))));
}, QEe = function() {
  return Wi(TY);
};
function kY(n) {
  var e = Object.keys(n);
  return e.length === 0 ? "There are no available ids." : "Available ids are: ".concat(e, ".");
}
var _Y = function(e) {
  var t = Wi($M);
  t == null && (process.env.NODE_ENV !== "production" ? Fi(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : Fi());
  var r = t[e];
  return r == null && (process.env.NODE_ENV !== "production" ? Fi(!1, 'Could not find xAxis by id "'.concat(e, '" [').concat(oy(e), "]. ").concat(kY(t))) : Fi()), r;
}, JEe = function() {
  var e = Wi($M);
  return Wl(e);
}, e5e = function() {
  var e = Wi(FM), t = qEe(e, function(r) {
    return gY(r.domain, Number.isFinite);
  });
  return t || Wl(e);
}, OY = function(e) {
  var t = Wi(FM);
  t == null && (process.env.NODE_ENV !== "production" ? Fi(!1, "Could not find Recharts context; are you sure this is rendered inside a Recharts wrapper component?") : Fi());
  var r = t[e];
  return r == null && (process.env.NODE_ENV !== "production" ? Fi(!1, 'Could not find yAxis by id "'.concat(e, '" [').concat(oy(e), "]. ").concat(kY(t))) : Fi()), r;
}, t5e = function() {
  var e = Wi(SY);
  return e;
}, n5e = function() {
  return Wi(CY);
}, BM = function() {
  return Wi(MY);
}, zM = function() {
  return Wi(AY);
};
function $f(n) {
  "@babel/helpers - typeof";
  return $f = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, $f(n);
}
function r5e(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function i5e(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, RY(r.key), r);
  }
}
function s5e(n, e, t) {
  return e && i5e(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function o5e(n, e, t) {
  return e = ay(e), a5e(n, IY() ? Reflect.construct(e, t || [], ay(n).constructor) : e.apply(n, t));
}
function a5e(n, e) {
  if (e && ($f(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return l5e(n);
}
function l5e(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function IY() {
  try {
    var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (IY = function() {
    return !!n;
  })();
}
function ay(n) {
  return ay = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, ay(n);
}
function c5e(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && hT(n, e);
}
function hT(n, e) {
  return hT = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, hT(n, e);
}
function hF(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function pF(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? hF(Object(t), !0).forEach(function(r) {
      HM(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : hF(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function HM(n, e, t) {
  return e = RY(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function RY(n) {
  var e = u5e(n, "string");
  return $f(e) == "symbol" ? e : e + "";
}
function u5e(n, e) {
  if ($f(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if ($f(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
function d5e(n, e) {
  return m5e(n) || p5e(n, e) || h5e(n, e) || f5e();
}
function f5e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function h5e(n, e) {
  if (n) {
    if (typeof n == "string") return mF(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return mF(n, e);
  }
}
function mF(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function p5e(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r, i, s, o, a = [], l = !0, c = !1;
    try {
      if (s = (t = t.call(n)).next, e !== 0) for (; !(l = (r = s.call(t)).done) && (a.push(r.value), a.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && t.return != null && (o = t.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return a;
  }
}
function m5e(n) {
  if (Array.isArray(n)) return n;
}
function pT() {
  return pT = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, pT.apply(this, arguments);
}
var g5e = function(e, t) {
  var r;
  return /* @__PURE__ */ p.isValidElement(e) ? r = /* @__PURE__ */ p.cloneElement(e, t) : Mt(e) ? r = e(t) : r = /* @__PURE__ */ p.createElement("line", pT({}, t, {
    className: "recharts-reference-line-line"
  })), r;
}, v5e = function(e, t, r, i, s, o, a, l, c) {
  var u = s.x, d = s.y, f = s.width, h = s.height;
  if (r) {
    var m = c.y, g = e.y.apply(m, {
      position: o
    });
    if (fa(c, "discard") && !e.y.isInRange(g))
      return null;
    var v = [{
      x: u + f,
      y: g
    }, {
      x: u,
      y: g
    }];
    return l === "left" ? v.reverse() : v;
  }
  if (t) {
    var y = c.x, b = e.x.apply(y, {
      position: o
    });
    if (fa(c, "discard") && !e.x.isInRange(b))
      return null;
    var x = [{
      x: b,
      y: d + h
    }, {
      x: b,
      y: d
    }];
    return a === "top" ? x.reverse() : x;
  }
  if (i) {
    var E = c.segment, w = E.map(function(C) {
      return e.apply(C, {
        position: o
      });
    });
    return fa(c, "discard") && cEe(w, function(C) {
      return !e.isInRange(C);
    }) ? null : w;
  }
  return null;
};
function y5e(n) {
  var e = n.x, t = n.y, r = n.segment, i = n.xAxisId, s = n.yAxisId, o = n.shape, a = n.className, l = n.alwaysShow, c = QEe(), u = _Y(i), d = OY(s), f = t5e();
  if (!c || !f)
    return null;
  rl(l === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
  var h = LM({
    x: u.scale,
    y: d.scale
  }), m = Sr(e), g = Sr(t), v = r && r.length === 2, y = v5e(h, m, g, v, f, n.position, u.orientation, d.orientation, n);
  if (!y)
    return null;
  var b = d5e(y, 2), x = b[0], E = x.x, w = x.y, C = b[1], S = C.x, M = C.y, k = fa(n, "hidden") ? "url(#".concat(c, ")") : void 0, _ = pF(pF({
    clipPath: k
  }, $t(n, !0)), {}, {
    x1: E,
    y1: w,
    x2: S,
    y2: M
  });
  return /* @__PURE__ */ p.createElement(jn, {
    className: Ut("recharts-reference-line", a)
  }, g5e(o, _), ni.renderCallByParent(n, zEe({
    x1: E,
    y1: w,
    x2: S,
    y2: M
  })));
}
var UM = /* @__PURE__ */ (function(n) {
  function e() {
    return r5e(this, e), o5e(this, e, arguments);
  }
  return c5e(e, n), s5e(e, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ p.createElement(y5e, this.props);
    }
  }]);
})(p.Component);
HM(UM, "displayName", "ReferenceLine");
HM(UM, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  fill: "none",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1,
  position: "middle"
});
function mT() {
  return mT = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, mT.apply(this, arguments);
}
function Ff(n) {
  "@babel/helpers - typeof";
  return Ff = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Ff(n);
}
function gF(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function vF(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? gF(Object(t), !0).forEach(function(r) {
      Kw(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : gF(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function b5e(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function w5e(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, DY(r.key), r);
  }
}
function x5e(n, e, t) {
  return e && w5e(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function E5e(n, e, t) {
  return e = ly(e), S5e(n, PY() ? Reflect.construct(e, t || [], ly(n).constructor) : e.apply(n, t));
}
function S5e(n, e) {
  if (e && (Ff(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return C5e(n);
}
function C5e(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function PY() {
  try {
    var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (PY = function() {
    return !!n;
  })();
}
function ly(n) {
  return ly = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, ly(n);
}
function T5e(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && gT(n, e);
}
function gT(n, e) {
  return gT = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, gT(n, e);
}
function Kw(n, e, t) {
  return e = DY(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function DY(n) {
  var e = A5e(n, "string");
  return Ff(e) == "symbol" ? e : e + "";
}
function A5e(n, e) {
  if (Ff(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Ff(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
var M5e = function(e) {
  var t = e.x, r = e.y, i = e.xAxis, s = e.yAxis, o = LM({
    x: i.scale,
    y: s.scale
  }), a = o.apply({
    x: t,
    y: r
  }, {
    bandAware: !0
  });
  return fa(e, "discard") && !o.isInRange(a) ? null : a;
}, qw = /* @__PURE__ */ (function(n) {
  function e() {
    return b5e(this, e), E5e(this, e, arguments);
  }
  return T5e(e, n), x5e(e, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.x, s = r.y, o = r.r, a = r.alwaysShow, l = r.clipPathId, c = Sr(i), u = Sr(s);
      if (rl(a === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.'), !c || !u)
        return null;
      var d = M5e(this.props);
      if (!d)
        return null;
      var f = d.x, h = d.y, m = this.props, g = m.shape, v = m.className, y = fa(this.props, "hidden") ? "url(#".concat(l, ")") : void 0, b = vF(vF({
        clipPath: y
      }, $t(this.props, !0)), {}, {
        cx: f,
        cy: h
      });
      return /* @__PURE__ */ p.createElement(jn, {
        className: Ut("recharts-reference-dot", v)
      }, e.renderDot(g, b), ni.renderCallByParent(this.props, {
        x: f - o,
        y: h - o,
        width: 2 * o,
        height: 2 * o
      }));
    }
  }]);
})(p.Component);
Kw(qw, "displayName", "ReferenceDot");
Kw(qw, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#fff",
  stroke: "#ccc",
  fillOpacity: 1,
  strokeWidth: 1
});
Kw(qw, "renderDot", function(n, e) {
  var t;
  return /* @__PURE__ */ p.isValidElement(n) ? t = /* @__PURE__ */ p.cloneElement(n, e) : Mt(n) ? t = n(e) : t = /* @__PURE__ */ p.createElement(NM, mT({}, e, {
    cx: e.cx,
    cy: e.cy,
    className: "recharts-reference-dot-dot"
  })), t;
});
function vT() {
  return vT = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, vT.apply(this, arguments);
}
function Bf(n) {
  "@babel/helpers - typeof";
  return Bf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Bf(n);
}
function yF(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function bF(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? yF(Object(t), !0).forEach(function(r) {
      Yw(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : yF(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function k5e(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function _5e(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, LY(r.key), r);
  }
}
function O5e(n, e, t) {
  return e && _5e(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function I5e(n, e, t) {
  return e = cy(e), R5e(n, NY() ? Reflect.construct(e, t || [], cy(n).constructor) : e.apply(n, t));
}
function R5e(n, e) {
  if (e && (Bf(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return P5e(n);
}
function P5e(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function NY() {
  try {
    var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (NY = function() {
    return !!n;
  })();
}
function cy(n) {
  return cy = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, cy(n);
}
function D5e(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && yT(n, e);
}
function yT(n, e) {
  return yT = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, yT(n, e);
}
function Yw(n, e, t) {
  return e = LY(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function LY(n) {
  var e = N5e(n, "string");
  return Bf(e) == "symbol" ? e : e + "";
}
function N5e(n, e) {
  if (Bf(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Bf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
var L5e = function(e, t, r, i, s) {
  var o = s.x1, a = s.x2, l = s.y1, c = s.y2, u = s.xAxis, d = s.yAxis;
  if (!u || !d) return null;
  var f = LM({
    x: u.scale,
    y: d.scale
  }), h = {
    x: e ? f.x.apply(o, {
      position: "start"
    }) : f.x.rangeMin,
    y: r ? f.y.apply(l, {
      position: "start"
    }) : f.y.rangeMin
  }, m = {
    x: t ? f.x.apply(a, {
      position: "end"
    }) : f.x.rangeMax,
    y: i ? f.y.apply(c, {
      position: "end"
    }) : f.y.rangeMax
  };
  return fa(s, "discard") && (!f.isInRange(h) || !f.isInRange(m)) ? null : xY(h, m);
}, Xw = /* @__PURE__ */ (function(n) {
  function e() {
    return k5e(this, e), I5e(this, e, arguments);
  }
  return D5e(e, n), O5e(e, [{
    key: "render",
    value: function() {
      var r = this.props, i = r.x1, s = r.x2, o = r.y1, a = r.y2, l = r.className, c = r.alwaysShow, u = r.clipPathId;
      rl(c === void 0, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
      var d = Sr(i), f = Sr(s), h = Sr(o), m = Sr(a), g = this.props.shape;
      if (!d && !f && !h && !m && !g)
        return null;
      var v = L5e(d, f, h, m, this.props);
      if (!v && !g)
        return null;
      var y = fa(this.props, "hidden") ? "url(#".concat(u, ")") : void 0;
      return /* @__PURE__ */ p.createElement(jn, {
        className: Ut("recharts-reference-area", l)
      }, e.renderRect(g, bF(bF({
        clipPath: y
      }, $t(this.props, !0)), v)), ni.renderCallByParent(this.props, v));
    }
  }]);
})(p.Component);
Yw(Xw, "displayName", "ReferenceArea");
Yw(Xw, "defaultProps", {
  isFront: !1,
  ifOverflow: "discard",
  xAxisId: 0,
  yAxisId: 0,
  r: 10,
  fill: "#ccc",
  fillOpacity: 0.5,
  stroke: "none",
  strokeWidth: 1
});
Yw(Xw, "renderRect", function(n, e) {
  var t;
  return /* @__PURE__ */ p.isValidElement(n) ? t = /* @__PURE__ */ p.cloneElement(n, e) : Mt(n) ? t = n(e) : t = /* @__PURE__ */ p.createElement(DM, vT({}, e, {
    className: "recharts-reference-area-rect"
  })), t;
});
function $Y(n, e, t) {
  if (e < 1)
    return [];
  if (e === 1 && t === void 0)
    return n;
  for (var r = [], i = 0; i < n.length; i += e)
    r.push(n[i]);
  return r;
}
function $5e(n, e, t) {
  var r = {
    width: n.width + e.width,
    height: n.height + e.height
  };
  return UEe(r, t);
}
function F5e(n, e, t) {
  var r = t === "width", i = n.x, s = n.y, o = n.width, a = n.height;
  return e === 1 ? {
    start: r ? i : s,
    end: r ? i + o : s + a
  } : {
    start: r ? i + o : s + a,
    end: r ? i : s
  };
}
function uy(n, e, t, r, i) {
  if (n * e < n * r || n * e > n * i)
    return !1;
  var s = t();
  return n * (e - n * s / 2 - r) >= 0 && n * (e + n * s / 2 - i) <= 0;
}
function B5e(n, e) {
  return $Y(n, e + 1);
}
function z5e(n, e, t, r, i) {
  for (var s = (r || []).slice(), o = e.start, a = e.end, l = 0, c = 1, u = o, d = function() {
    var m = r?.[l];
    if (m === void 0)
      return {
        v: $Y(r, c)
      };
    var g = l, v, y = function() {
      return v === void 0 && (v = t(m, g)), v;
    }, b = m.coordinate, x = l === 0 || uy(n, b, y, u, a);
    x || (l = 0, u = o, c += 1), x && (u = b + n * (y() / 2 + i), l += c);
  }, f; c <= s.length; )
    if (f = d(), f) return f.v;
  return [];
}
function Xm(n) {
  "@babel/helpers - typeof";
  return Xm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Xm(n);
}
function wF(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Qr(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? wF(Object(t), !0).forEach(function(r) {
      H5e(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : wF(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function H5e(n, e, t) {
  return e = U5e(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function U5e(n) {
  var e = V5e(n, "string");
  return Xm(e) == "symbol" ? e : e + "";
}
function V5e(n, e) {
  if (Xm(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Xm(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function j5e(n, e, t, r, i) {
  for (var s = (r || []).slice(), o = s.length, a = e.start, l = e.end, c = function(f) {
    var h = s[f], m, g = function() {
      return m === void 0 && (m = t(h, f)), m;
    };
    if (f === o - 1) {
      var v = n * (h.coordinate + n * g() / 2 - l);
      s[f] = h = Qr(Qr({}, h), {}, {
        tickCoord: v > 0 ? h.coordinate - v * n : h.coordinate
      });
    } else
      s[f] = h = Qr(Qr({}, h), {}, {
        tickCoord: h.coordinate
      });
    var y = uy(n, h.tickCoord, g, a, l);
    y && (l = h.tickCoord - n * (g() / 2 + i), s[f] = Qr(Qr({}, h), {}, {
      isShow: !0
    }));
  }, u = o - 1; u >= 0; u--)
    c(u);
  return s;
}
function W5e(n, e, t, r, i, s) {
  var o = (r || []).slice(), a = o.length, l = e.start, c = e.end;
  if (s) {
    var u = r[a - 1], d = t(u, a - 1), f = n * (u.coordinate + n * d / 2 - c);
    o[a - 1] = u = Qr(Qr({}, u), {}, {
      tickCoord: f > 0 ? u.coordinate - f * n : u.coordinate
    });
    var h = uy(n, u.tickCoord, function() {
      return d;
    }, l, c);
    h && (c = u.tickCoord - n * (d / 2 + i), o[a - 1] = Qr(Qr({}, u), {}, {
      isShow: !0
    }));
  }
  for (var m = s ? a - 1 : a, g = function(b) {
    var x = o[b], E, w = function() {
      return E === void 0 && (E = t(x, b)), E;
    };
    if (b === 0) {
      var C = n * (x.coordinate - n * w() / 2 - l);
      o[b] = x = Qr(Qr({}, x), {}, {
        tickCoord: C < 0 ? x.coordinate - C * n : x.coordinate
      });
    } else
      o[b] = x = Qr(Qr({}, x), {}, {
        tickCoord: x.coordinate
      });
    var S = uy(n, x.tickCoord, w, l, c);
    S && (l = x.tickCoord + n * (w() / 2 + i), o[b] = Qr(Qr({}, x), {}, {
      isShow: !0
    }));
  }, v = 0; v < m; v++)
    g(v);
  return o;
}
function VM(n, e, t) {
  var r = n.tick, i = n.ticks, s = n.viewBox, o = n.minTickGap, a = n.orientation, l = n.interval, c = n.tickFormatter, u = n.unit, d = n.angle;
  if (!i || !i.length || !r)
    return [];
  if (ke(l) || Th.isSsr)
    return B5e(i, typeof l == "number" && ke(l) ? l : 0);
  var f = [], h = a === "top" || a === "bottom" ? "width" : "height", m = u && h === "width" ? Up(u, {
    fontSize: e,
    letterSpacing: t
  }) : {
    width: 0,
    height: 0
  }, g = function(x, E) {
    var w = Mt(c) ? c(x.value, E) : x.value;
    return h === "width" ? $5e(Up(w, {
      fontSize: e,
      letterSpacing: t
    }), m, d) : Up(w, {
      fontSize: e,
      letterSpacing: t
    })[h];
  }, v = i.length >= 2 ? co(i[1].coordinate - i[0].coordinate) : 1, y = F5e(s, v, h);
  return l === "equidistantPreserveStart" ? z5e(v, y, g, i, o) : (l === "preserveStart" || l === "preserveStartEnd" ? f = W5e(v, y, g, i, o, l === "preserveStartEnd") : f = j5e(v, y, g, i, o), f.filter(function(b) {
    return b.isShow;
  }));
}
var G5e = ["viewBox"], K5e = ["viewBox"], q5e = ["ticks"];
function zf(n) {
  "@babel/helpers - typeof";
  return zf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, zf(n);
}
function Kd() {
  return Kd = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, Kd.apply(this, arguments);
}
function xF(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function mr(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? xF(Object(t), !0).forEach(function(r) {
      jM(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : xF(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function GS(n, e) {
  if (n == null) return {};
  var t = Y5e(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function Y5e(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n)
    if (Object.prototype.hasOwnProperty.call(n, r)) {
      if (e.indexOf(r) >= 0) continue;
      t[r] = n[r];
    }
  return t;
}
function X5e(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function EF(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, BY(r.key), r);
  }
}
function Z5e(n, e, t) {
  return e && EF(n.prototype, e), t && EF(n, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function Q5e(n, e, t) {
  return e = dy(e), J5e(n, FY() ? Reflect.construct(e, t || [], dy(n).constructor) : e.apply(n, t));
}
function J5e(n, e) {
  if (e && (zf(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return eSe(n);
}
function eSe(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function FY() {
  try {
    var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (FY = function() {
    return !!n;
  })();
}
function dy(n) {
  return dy = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, dy(n);
}
function tSe(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && bT(n, e);
}
function bT(n, e) {
  return bT = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, bT(n, e);
}
function jM(n, e, t) {
  return e = BY(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function BY(n) {
  var e = nSe(n, "string");
  return zf(e) == "symbol" ? e : e + "";
}
function nSe(n, e) {
  if (zf(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (zf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
var _h = /* @__PURE__ */ (function(n) {
  function e(t) {
    var r;
    return X5e(this, e), r = Q5e(this, e, [t]), r.state = {
      fontSize: "",
      letterSpacing: ""
    }, r;
  }
  return tSe(e, n), Z5e(e, [{
    key: "shouldComponentUpdate",
    value: function(r, i) {
      var s = r.viewBox, o = GS(r, G5e), a = this.props, l = a.viewBox, c = GS(a, K5e);
      return !rf(s, l) || !rf(o, c) || !rf(i, this.state);
    }
  }, {
    key: "componentDidMount",
    value: function() {
      var r = this.layerReference;
      if (r) {
        var i = r.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
        i && this.setState({
          fontSize: window.getComputedStyle(i).fontSize,
          letterSpacing: window.getComputedStyle(i).letterSpacing
        });
      }
    }
    /**
     * Calculate the coordinates of endpoints in ticks
     * @param  {Object} data The data of a simple tick
     * @return {Object} (x1, y1): The coordinate of endpoint close to tick text
     *  (x2, y2): The coordinate of endpoint close to axis
     */
  }, {
    key: "getTickLineCoord",
    value: function(r) {
      var i = this.props, s = i.x, o = i.y, a = i.width, l = i.height, c = i.orientation, u = i.tickSize, d = i.mirror, f = i.tickMargin, h, m, g, v, y, b, x = d ? -1 : 1, E = r.tickSize || u, w = ke(r.tickCoord) ? r.tickCoord : r.coordinate;
      switch (c) {
        case "top":
          h = m = r.coordinate, v = o + +!d * l, g = v - x * E, b = g - x * f, y = w;
          break;
        case "left":
          g = v = r.coordinate, m = s + +!d * a, h = m - x * E, y = h - x * f, b = w;
          break;
        case "right":
          g = v = r.coordinate, m = s + +d * a, h = m + x * E, y = h + x * f, b = w;
          break;
        default:
          h = m = r.coordinate, v = o + +d * l, g = v + x * E, b = g + x * f, y = w;
          break;
      }
      return {
        line: {
          x1: h,
          y1: g,
          x2: m,
          y2: v
        },
        tick: {
          x: y,
          y: b
        }
      };
    }
  }, {
    key: "getTickTextAnchor",
    value: function() {
      var r = this.props, i = r.orientation, s = r.mirror, o;
      switch (i) {
        case "left":
          o = s ? "start" : "end";
          break;
        case "right":
          o = s ? "end" : "start";
          break;
        default:
          o = "middle";
          break;
      }
      return o;
    }
  }, {
    key: "getTickVerticalAnchor",
    value: function() {
      var r = this.props, i = r.orientation, s = r.mirror, o = "end";
      switch (i) {
        case "left":
        case "right":
          o = "middle";
          break;
        case "top":
          o = s ? "start" : "end";
          break;
        default:
          o = s ? "end" : "start";
          break;
      }
      return o;
    }
  }, {
    key: "renderAxisLine",
    value: function() {
      var r = this.props, i = r.x, s = r.y, o = r.width, a = r.height, l = r.orientation, c = r.mirror, u = r.axisLine, d = mr(mr(mr({}, $t(this.props, !1)), $t(u, !1)), {}, {
        fill: "none"
      });
      if (l === "top" || l === "bottom") {
        var f = +(l === "top" && !c || l === "bottom" && c);
        d = mr(mr({}, d), {}, {
          x1: i,
          y1: s + f * a,
          x2: i + o,
          y2: s + f * a
        });
      } else {
        var h = +(l === "left" && !c || l === "right" && c);
        d = mr(mr({}, d), {}, {
          x1: i + h * o,
          y1: s,
          x2: i + h * o,
          y2: s + a
        });
      }
      return /* @__PURE__ */ p.createElement("line", Kd({}, d, {
        className: Ut("recharts-cartesian-axis-line", Ls(u, "className"))
      }));
    }
  }, {
    key: "renderTicks",
    value: (
      /**
       * render the ticks
       * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
       * @param {string} fontSize Fontsize to consider for tick spacing
       * @param {string} letterSpacing Letterspacing to consider for tick spacing
       * @return {ReactComponent} renderedTicks
       */
      function(r, i, s) {
        var o = this, a = this.props, l = a.tickLine, c = a.stroke, u = a.tick, d = a.tickFormatter, f = a.unit, h = VM(mr(mr({}, this.props), {}, {
          ticks: r
        }), i, s), m = this.getTickTextAnchor(), g = this.getTickVerticalAnchor(), v = $t(this.props, !1), y = $t(u, !1), b = mr(mr({}, v), {}, {
          fill: "none"
        }, $t(l, !1)), x = h.map(function(E, w) {
          var C = o.getTickLineCoord(E), S = C.line, M = C.tick, k = mr(mr(mr(mr({
            textAnchor: m,
            verticalAnchor: g
          }, v), {}, {
            stroke: "none",
            fill: c
          }, y), M), {}, {
            index: w,
            payload: E,
            visibleTicksCount: h.length,
            tickFormatter: d
          });
          return /* @__PURE__ */ p.createElement(jn, Kd({
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(E.value, "-").concat(E.coordinate, "-").concat(E.tickCoord)
          }, w2(o.props, E, w)), l && /* @__PURE__ */ p.createElement("line", Kd({}, b, S, {
            className: Ut("recharts-cartesian-axis-tick-line", Ls(l, "className"))
          })), u && e.renderTickItem(u, k, "".concat(Mt(d) ? d(E.value, w) : E.value).concat(f || "")));
        });
        return /* @__PURE__ */ p.createElement("g", {
          className: "recharts-cartesian-axis-ticks"
        }, x);
      }
    )
  }, {
    key: "render",
    value: function() {
      var r = this, i = this.props, s = i.axisLine, o = i.width, a = i.height, l = i.ticksGenerator, c = i.className, u = i.hide;
      if (u)
        return null;
      var d = this.props, f = d.ticks, h = GS(d, q5e), m = f;
      return Mt(l) && (m = f && f.length > 0 ? l(this.props) : l(h)), o <= 0 || a <= 0 || !m || !m.length ? null : /* @__PURE__ */ p.createElement(jn, {
        className: Ut("recharts-cartesian-axis", c),
        ref: function(v) {
          r.layerReference = v;
        }
      }, s && this.renderAxisLine(), this.renderTicks(m, this.state.fontSize, this.state.letterSpacing), ni.renderCallByParent(this.props));
    }
  }], [{
    key: "renderTickItem",
    value: function(r, i, s) {
      var o, a = Ut(i.className, "recharts-cartesian-axis-tick-value");
      return /* @__PURE__ */ p.isValidElement(r) ? o = /* @__PURE__ */ p.cloneElement(r, mr(mr({}, i), {}, {
        className: a
      })) : Mt(r) ? o = r(mr(mr({}, i), {}, {
        className: a
      })) : o = /* @__PURE__ */ p.createElement(I2, Kd({}, i, {
        className: "recharts-cartesian-axis-tick-value"
      }), s), o;
    }
  }]);
})(EG);
jM(_h, "displayName", "CartesianAxis");
jM(_h, "defaultProps", {
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  viewBox: {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  },
  // The orientation of axis
  orientation: "bottom",
  // The ticks
  ticks: [],
  stroke: "#666",
  tickLine: !0,
  axisLine: !0,
  tick: !0,
  mirror: !1,
  minTickGap: 5,
  // The width or height of tick
  tickSize: 6,
  tickMargin: 2,
  interval: "preserveEnd"
});
var rSe = ["x1", "y1", "x2", "y2", "key"], iSe = ["offset"];
function Du(n) {
  "@babel/helpers - typeof";
  return Du = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Du(n);
}
function SF(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function ri(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? SF(Object(t), !0).forEach(function(r) {
      sSe(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : SF(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function sSe(n, e, t) {
  return e = oSe(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function oSe(n) {
  var e = aSe(n, "string");
  return Du(e) == "symbol" ? e : e + "";
}
function aSe(n, e) {
  if (Du(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Du(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function au() {
  return au = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, au.apply(this, arguments);
}
function CF(n, e) {
  if (n == null) return {};
  var t = lSe(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function lSe(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n)
    if (Object.prototype.hasOwnProperty.call(n, r)) {
      if (e.indexOf(r) >= 0) continue;
      t[r] = n[r];
    }
  return t;
}
var cSe = function(e) {
  var t = e.fill;
  if (!t || t === "none")
    return null;
  var r = e.fillOpacity, i = e.x, s = e.y, o = e.width, a = e.height, l = e.ry;
  return /* @__PURE__ */ p.createElement("rect", {
    x: i,
    y: s,
    ry: l,
    width: o,
    height: a,
    stroke: "none",
    fill: t,
    fillOpacity: r,
    className: "recharts-cartesian-grid-bg"
  });
};
function zY(n, e) {
  var t;
  if (/* @__PURE__ */ p.isValidElement(n))
    t = /* @__PURE__ */ p.cloneElement(n, e);
  else if (Mt(n))
    t = n(e);
  else {
    var r = e.x1, i = e.y1, s = e.x2, o = e.y2, a = e.key, l = CF(e, rSe), c = $t(l, !1);
    c.offset;
    var u = CF(c, iSe);
    t = /* @__PURE__ */ p.createElement("line", au({}, u, {
      x1: r,
      y1: i,
      x2: s,
      y2: o,
      fill: "none",
      key: a
    }));
  }
  return t;
}
function uSe(n) {
  var e = n.x, t = n.width, r = n.horizontal, i = r === void 0 ? !0 : r, s = n.horizontalPoints;
  if (!i || !s || !s.length)
    return null;
  var o = s.map(function(a, l) {
    var c = ri(ri({}, n), {}, {
      x1: e,
      y1: a,
      x2: e + t,
      y2: a,
      key: "line-".concat(l),
      index: l
    });
    return zY(i, c);
  });
  return /* @__PURE__ */ p.createElement("g", {
    className: "recharts-cartesian-grid-horizontal"
  }, o);
}
function dSe(n) {
  var e = n.y, t = n.height, r = n.vertical, i = r === void 0 ? !0 : r, s = n.verticalPoints;
  if (!i || !s || !s.length)
    return null;
  var o = s.map(function(a, l) {
    var c = ri(ri({}, n), {}, {
      x1: a,
      y1: e,
      x2: a,
      y2: e + t,
      key: "line-".concat(l),
      index: l
    });
    return zY(i, c);
  });
  return /* @__PURE__ */ p.createElement("g", {
    className: "recharts-cartesian-grid-vertical"
  }, o);
}
function fSe(n) {
  var e = n.horizontalFill, t = n.fillOpacity, r = n.x, i = n.y, s = n.width, o = n.height, a = n.horizontalPoints, l = n.horizontal, c = l === void 0 ? !0 : l;
  if (!c || !e || !e.length)
    return null;
  var u = a.map(function(f) {
    return Math.round(f + i - i);
  }).sort(function(f, h) {
    return f - h;
  });
  i !== u[0] && u.unshift(0);
  var d = u.map(function(f, h) {
    var m = !u[h + 1], g = m ? i + o - f : u[h + 1] - f;
    if (g <= 0)
      return null;
    var v = h % e.length;
    return /* @__PURE__ */ p.createElement("rect", {
      key: "react-".concat(h),
      y: f,
      x: r,
      height: g,
      width: s,
      stroke: "none",
      fill: e[v],
      fillOpacity: t,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ p.createElement("g", {
    className: "recharts-cartesian-gridstripes-horizontal"
  }, d);
}
function hSe(n) {
  var e = n.vertical, t = e === void 0 ? !0 : e, r = n.verticalFill, i = n.fillOpacity, s = n.x, o = n.y, a = n.width, l = n.height, c = n.verticalPoints;
  if (!t || !r || !r.length)
    return null;
  var u = c.map(function(f) {
    return Math.round(f + s - s);
  }).sort(function(f, h) {
    return f - h;
  });
  s !== u[0] && u.unshift(0);
  var d = u.map(function(f, h) {
    var m = !u[h + 1], g = m ? s + a - f : u[h + 1] - f;
    if (g <= 0)
      return null;
    var v = h % r.length;
    return /* @__PURE__ */ p.createElement("rect", {
      key: "react-".concat(h),
      x: f,
      y: o,
      width: g,
      height: l,
      stroke: "none",
      fill: r[v],
      fillOpacity: i,
      className: "recharts-cartesian-grid-bg"
    });
  });
  return /* @__PURE__ */ p.createElement("g", {
    className: "recharts-cartesian-gridstripes-vertical"
  }, d);
}
var pSe = function(e, t) {
  var r = e.xAxis, i = e.width, s = e.height, o = e.offset;
  return Zq(VM(ri(ri(ri({}, _h.defaultProps), r), {}, {
    ticks: Za(r, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: i,
      height: s
    }
  })), o.left, o.left + o.width, t);
}, mSe = function(e, t) {
  var r = e.yAxis, i = e.width, s = e.height, o = e.offset;
  return Zq(VM(ri(ri(ri({}, _h.defaultProps), r), {}, {
    ticks: Za(r, !0),
    viewBox: {
      x: 0,
      y: 0,
      width: i,
      height: s
    }
  })), o.top, o.top + o.height, t);
}, yd = {
  horizontal: !0,
  vertical: !0,
  stroke: "#ccc",
  fill: "none",
  // The fill of colors of grid lines
  verticalFill: [],
  horizontalFill: []
};
function gSe(n) {
  var e, t, r, i, s, o, a = BM(), l = zM(), c = n5e(), u = ri(ri({}, n), {}, {
    stroke: (e = n.stroke) !== null && e !== void 0 ? e : yd.stroke,
    fill: (t = n.fill) !== null && t !== void 0 ? t : yd.fill,
    horizontal: (r = n.horizontal) !== null && r !== void 0 ? r : yd.horizontal,
    horizontalFill: (i = n.horizontalFill) !== null && i !== void 0 ? i : yd.horizontalFill,
    vertical: (s = n.vertical) !== null && s !== void 0 ? s : yd.vertical,
    verticalFill: (o = n.verticalFill) !== null && o !== void 0 ? o : yd.verticalFill,
    x: ke(n.x) ? n.x : c.left,
    y: ke(n.y) ? n.y : c.top,
    width: ke(n.width) ? n.width : c.width,
    height: ke(n.height) ? n.height : c.height
  }), d = u.x, f = u.y, h = u.width, m = u.height, g = u.syncWithTicks, v = u.horizontalValues, y = u.verticalValues, b = JEe(), x = e5e();
  if (!ke(h) || h <= 0 || !ke(m) || m <= 0 || !ke(d) || d !== +d || !ke(f) || f !== +f)
    return null;
  var E = u.verticalCoordinatesGenerator || pSe, w = u.horizontalCoordinatesGenerator || mSe, C = u.horizontalPoints, S = u.verticalPoints;
  if ((!C || !C.length) && Mt(w)) {
    var M = v && v.length, k = w({
      yAxis: x ? ri(ri({}, x), {}, {
        ticks: M ? v : x.ticks
      }) : void 0,
      width: a,
      height: l,
      offset: c
    }, M ? !0 : g);
    rl(Array.isArray(k), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(Du(k), "]")), Array.isArray(k) && (C = k);
  }
  if ((!S || !S.length) && Mt(E)) {
    var _ = y && y.length, O = E({
      xAxis: b ? ri(ri({}, b), {}, {
        ticks: _ ? y : b.ticks
      }) : void 0,
      width: a,
      height: l,
      offset: c
    }, _ ? !0 : g);
    rl(Array.isArray(O), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(Du(O), "]")), Array.isArray(O) && (S = O);
  }
  return /* @__PURE__ */ p.createElement("g", {
    className: "recharts-cartesian-grid"
  }, /* @__PURE__ */ p.createElement(cSe, {
    fill: u.fill,
    fillOpacity: u.fillOpacity,
    x: u.x,
    y: u.y,
    width: u.width,
    height: u.height,
    ry: u.ry
  }), /* @__PURE__ */ p.createElement(uSe, au({}, u, {
    offset: c,
    horizontalPoints: C,
    xAxis: b,
    yAxis: x
  })), /* @__PURE__ */ p.createElement(dSe, au({}, u, {
    offset: c,
    verticalPoints: S,
    xAxis: b,
    yAxis: x
  })), /* @__PURE__ */ p.createElement(fSe, au({}, u, {
    horizontalPoints: C
  })), /* @__PURE__ */ p.createElement(hSe, au({}, u, {
    verticalPoints: S
  })));
}
gSe.displayName = "CartesianGrid";
var vSe = ["layout", "type", "stroke", "connectNulls", "isRange", "ref"], ySe = ["key"], HY;
function Hf(n) {
  "@babel/helpers - typeof";
  return Hf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Hf(n);
}
function UY(n, e) {
  if (n == null) return {};
  var t = bSe(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function bSe(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n)
    if (Object.prototype.hasOwnProperty.call(n, r)) {
      if (e.indexOf(r) >= 0) continue;
      t[r] = n[r];
    }
  return t;
}
function lu() {
  return lu = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, lu.apply(this, arguments);
}
function TF(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Dl(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? TF(Object(t), !0).forEach(function(r) {
      na(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : TF(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function wSe(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function AF(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, jY(r.key), r);
  }
}
function xSe(n, e, t) {
  return e && AF(n.prototype, e), t && AF(n, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function ESe(n, e, t) {
  return e = fy(e), SSe(n, VY() ? Reflect.construct(e, t || [], fy(n).constructor) : e.apply(n, t));
}
function SSe(n, e) {
  if (e && (Hf(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return CSe(n);
}
function CSe(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function VY() {
  try {
    var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (VY = function() {
    return !!n;
  })();
}
function fy(n) {
  return fy = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, fy(n);
}
function TSe(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && wT(n, e);
}
function wT(n, e) {
  return wT = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, wT(n, e);
}
function na(n, e, t) {
  return e = jY(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function jY(n) {
  var e = ASe(n, "string");
  return Hf(e) == "symbol" ? e : e + "";
}
function ASe(n, e) {
  if (Hf(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Hf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
var id = /* @__PURE__ */ (function(n) {
  function e() {
    var t;
    wSe(this, e);
    for (var r = arguments.length, i = new Array(r), s = 0; s < r; s++)
      i[s] = arguments[s];
    return t = ESe(this, e, [].concat(i)), na(t, "state", {
      isAnimationFinished: !0
    }), na(t, "id", l1("recharts-area-")), na(t, "handleAnimationEnd", function() {
      var o = t.props.onAnimationEnd;
      t.setState({
        isAnimationFinished: !0
      }), Mt(o) && o();
    }), na(t, "handleAnimationStart", function() {
      var o = t.props.onAnimationStart;
      t.setState({
        isAnimationFinished: !1
      }), Mt(o) && o();
    }), t;
  }
  return TSe(e, n), xSe(e, [{
    key: "renderDots",
    value: function(r, i, s) {
      var o = this.props.isAnimationActive, a = this.state.isAnimationFinished;
      if (o && !a)
        return null;
      var l = this.props, c = l.dot, u = l.points, d = l.dataKey, f = $t(this.props, !1), h = $t(c, !0), m = u.map(function(v, y) {
        var b = Dl(Dl(Dl({
          key: "dot-".concat(y),
          r: 3
        }, f), h), {}, {
          index: y,
          cx: v.x,
          cy: v.y,
          dataKey: d,
          value: v.value,
          payload: v.payload,
          points: u
        });
        return e.renderDotItem(c, b);
      }), g = {
        clipPath: r ? "url(#clipPath-".concat(i ? "" : "dots-").concat(s, ")") : null
      };
      return /* @__PURE__ */ p.createElement(jn, lu({
        className: "recharts-area-dots"
      }, g), m);
    }
  }, {
    key: "renderHorizontalRect",
    value: function(r) {
      var i = this.props, s = i.baseLine, o = i.points, a = i.strokeWidth, l = o[0].x, c = o[o.length - 1].x, u = r * Math.abs(l - c), d = Yl(o.map(function(f) {
        return f.y || 0;
      }));
      return ke(s) && typeof s == "number" ? d = Math.max(s, d) : s && Array.isArray(s) && s.length && (d = Math.max(Yl(s.map(function(f) {
        return f.y || 0;
      })), d)), ke(d) ? /* @__PURE__ */ p.createElement("rect", {
        x: l < c ? l : l - u,
        y: 0,
        width: u,
        height: Math.floor(d + (a ? parseInt("".concat(a), 10) : 1))
      }) : null;
    }
  }, {
    key: "renderVerticalRect",
    value: function(r) {
      var i = this.props, s = i.baseLine, o = i.points, a = i.strokeWidth, l = o[0].y, c = o[o.length - 1].y, u = r * Math.abs(l - c), d = Yl(o.map(function(f) {
        return f.x || 0;
      }));
      return ke(s) && typeof s == "number" ? d = Math.max(s, d) : s && Array.isArray(s) && s.length && (d = Math.max(Yl(s.map(function(f) {
        return f.x || 0;
      })), d)), ke(d) ? /* @__PURE__ */ p.createElement("rect", {
        x: 0,
        y: l < c ? l : l - u,
        width: d + (a ? parseInt("".concat(a), 10) : 1),
        height: Math.floor(u)
      }) : null;
    }
  }, {
    key: "renderClipRect",
    value: function(r) {
      var i = this.props.layout;
      return i === "vertical" ? this.renderVerticalRect(r) : this.renderHorizontalRect(r);
    }
  }, {
    key: "renderAreaStatically",
    value: function(r, i, s, o) {
      var a = this.props, l = a.layout, c = a.type, u = a.stroke, d = a.connectNulls, f = a.isRange;
      a.ref;
      var h = UY(a, vSe);
      return /* @__PURE__ */ p.createElement(jn, {
        clipPath: s ? "url(#clipPath-".concat(o, ")") : null
      }, /* @__PURE__ */ p.createElement(Wp, lu({}, $t(h, !0), {
        points: r,
        connectNulls: d,
        type: c,
        baseLine: i,
        layout: l,
        stroke: "none",
        className: "recharts-area-area"
      })), u !== "none" && /* @__PURE__ */ p.createElement(Wp, lu({}, $t(this.props, !1), {
        className: "recharts-area-curve",
        layout: l,
        type: c,
        connectNulls: d,
        fill: "none",
        points: r
      })), u !== "none" && f && /* @__PURE__ */ p.createElement(Wp, lu({}, $t(this.props, !1), {
        className: "recharts-area-curve",
        layout: l,
        type: c,
        connectNulls: d,
        fill: "none",
        points: i
      })));
    }
  }, {
    key: "renderAreaWithAnimation",
    value: function(r, i) {
      var s = this, o = this.props, a = o.points, l = o.baseLine, c = o.isAnimationActive, u = o.animationBegin, d = o.animationDuration, f = o.animationEasing, h = o.animationId, m = this.state, g = m.prevPoints, v = m.prevBaseLine;
      return /* @__PURE__ */ p.createElement(fl, {
        begin: u,
        duration: d,
        isActive: c,
        easing: f,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "area-".concat(h),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(y) {
        var b = y.t;
        if (g) {
          var x = g.length / a.length, E = a.map(function(M, k) {
            var _ = Math.floor(k * x);
            if (g[_]) {
              var O = g[_], I = _s(O.x, M.x), R = _s(O.y, M.y);
              return Dl(Dl({}, M), {}, {
                x: I(b),
                y: R(b)
              });
            }
            return M;
          }), w;
          if (ke(l) && typeof l == "number") {
            var C = _s(v, l);
            w = C(b);
          } else if (Bt(l) || Sh(l)) {
            var S = _s(v, 0);
            w = S(b);
          } else
            w = l.map(function(M, k) {
              var _ = Math.floor(k * x);
              if (v[_]) {
                var O = v[_], I = _s(O.x, M.x), R = _s(O.y, M.y);
                return Dl(Dl({}, M), {}, {
                  x: I(b),
                  y: R(b)
                });
              }
              return M;
            });
          return s.renderAreaStatically(E, w, r, i);
        }
        return /* @__PURE__ */ p.createElement(jn, null, /* @__PURE__ */ p.createElement("defs", null, /* @__PURE__ */ p.createElement("clipPath", {
          id: "animationClipPath-".concat(i)
        }, s.renderClipRect(b))), /* @__PURE__ */ p.createElement(jn, {
          clipPath: "url(#animationClipPath-".concat(i, ")")
        }, s.renderAreaStatically(a, l, r, i)));
      });
    }
  }, {
    key: "renderArea",
    value: function(r, i) {
      var s = this.props, o = s.points, a = s.baseLine, l = s.isAnimationActive, c = this.state, u = c.prevPoints, d = c.prevBaseLine, f = c.totalLength;
      return l && o && o.length && (!u && f > 0 || !_m(u, o) || !_m(d, a)) ? this.renderAreaWithAnimation(r, i) : this.renderAreaStatically(o, a, r, i);
    }
  }, {
    key: "render",
    value: function() {
      var r, i = this.props, s = i.hide, o = i.dot, a = i.points, l = i.className, c = i.top, u = i.left, d = i.xAxis, f = i.yAxis, h = i.width, m = i.height, g = i.isAnimationActive, v = i.id;
      if (s || !a || !a.length)
        return null;
      var y = this.state.isAnimationFinished, b = a.length === 1, x = Ut("recharts-area", l), E = d && d.allowDataOverflow, w = f && f.allowDataOverflow, C = E || w, S = Bt(v) ? this.id : v, M = (r = $t(o, !1)) !== null && r !== void 0 ? r : {
        r: 3,
        strokeWidth: 2
      }, k = M.r, _ = k === void 0 ? 3 : k, O = M.strokeWidth, I = O === void 0 ? 2 : O, R = Fpe(o) ? o : {}, P = R.clipDot, D = P === void 0 ? !0 : P, L = _ * 2 + I;
      return /* @__PURE__ */ p.createElement(jn, {
        className: x
      }, E || w ? /* @__PURE__ */ p.createElement("defs", null, /* @__PURE__ */ p.createElement("clipPath", {
        id: "clipPath-".concat(S)
      }, /* @__PURE__ */ p.createElement("rect", {
        x: E ? u : u - h / 2,
        y: w ? c : c - m / 2,
        width: E ? h : h * 2,
        height: w ? m : m * 2
      })), !D && /* @__PURE__ */ p.createElement("clipPath", {
        id: "clipPath-dots-".concat(S)
      }, /* @__PURE__ */ p.createElement("rect", {
        x: u - L / 2,
        y: c - L / 2,
        width: h + L,
        height: m + L
      }))) : null, b ? null : this.renderArea(C, S), (o || b) && this.renderDots(C, D, S), (!g || y) && sc.renderCallByParent(this.props, a));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(r, i) {
      return r.animationId !== i.prevAnimationId ? {
        prevAnimationId: r.animationId,
        curPoints: r.points,
        curBaseLine: r.baseLine,
        prevPoints: i.curPoints,
        prevBaseLine: i.curBaseLine
      } : r.points !== i.curPoints || r.baseLine !== i.curBaseLine ? {
        curPoints: r.points,
        curBaseLine: r.baseLine
      } : null;
    }
  }]);
})(Sc);
HY = id;
na(id, "displayName", "Area");
na(id, "defaultProps", {
  stroke: "#3182bd",
  fill: "#3182bd",
  fillOpacity: 0.6,
  xAxisId: 0,
  yAxisId: 0,
  legendType: "line",
  connectNulls: !1,
  // points of area
  points: [],
  dot: !1,
  activeDot: !0,
  hide: !1,
  isAnimationActive: !Th.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
na(id, "getBaseValue", function(n, e, t, r) {
  var i = n.layout, s = n.baseValue, o = e.props.baseValue, a = o ?? s;
  if (ke(a) && typeof a == "number")
    return a;
  var l = i === "horizontal" ? r : t, c = l.scale.domain();
  if (l.type === "number") {
    var u = Math.max(c[0], c[1]), d = Math.min(c[0], c[1]);
    return a === "dataMin" ? d : a === "dataMax" || u < 0 ? u : Math.max(Math.min(c[0], c[1]), 0);
  }
  return a === "dataMin" ? c[0] : a === "dataMax" ? c[1] : c[0];
});
na(id, "getComposedData", function(n) {
  var e = n.props, t = n.item, r = n.xAxis, i = n.yAxis, s = n.xAxisTicks, o = n.yAxisTicks, a = n.bandSize, l = n.dataKey, c = n.stackedData, u = n.dataStartIndex, d = n.displayedData, f = n.offset, h = e.layout, m = c && c.length, g = HY.getBaseValue(e, t, r, i), v = h === "horizontal", y = !1, b = d.map(function(E, w) {
    var C;
    m ? C = c[u + w] : (C = ys(E, l), Array.isArray(C) ? y = !0 : C = [g, C]);
    var S = C[1] == null || m && ys(E, l) == null;
    return v ? {
      x: DL({
        axis: r,
        ticks: s,
        bandSize: a,
        entry: E,
        index: w
      }),
      y: S ? null : i.scale(C[1]),
      value: C,
      payload: E
    } : {
      x: S ? null : r.scale(C[1]),
      y: DL({
        axis: i,
        ticks: o,
        bandSize: a,
        entry: E,
        index: w
      }),
      value: C,
      payload: E
    };
  }), x;
  return m || y ? x = b.map(function(E) {
    var w = Array.isArray(E.value) ? E.value[0] : null;
    return v ? {
      x: E.x,
      y: w != null && E.y != null ? i.scale(w) : null
    } : {
      x: w != null ? r.scale(w) : null,
      y: E.y
    };
  }) : x = v ? i.scale(g) : r.scale(g), Dl({
    points: b,
    baseLine: x,
    layout: h,
    isRange: y
  }, f);
});
na(id, "renderDotItem", function(n, e) {
  var t;
  if (/* @__PURE__ */ p.isValidElement(n))
    t = /* @__PURE__ */ p.cloneElement(n, e);
  else if (Mt(n))
    t = n(e);
  else {
    var r = Ut("recharts-area-dot", typeof n != "boolean" ? n.className : ""), i = e.key, s = UY(e, ySe);
    t = /* @__PURE__ */ p.createElement(NM, lu({}, s, {
      key: i,
      className: r
    }));
  }
  return t;
});
function Uf(n) {
  "@babel/helpers - typeof";
  return Uf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Uf(n);
}
function MSe(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function kSe(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, KY(r.key), r);
  }
}
function _Se(n, e, t) {
  return e && kSe(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function OSe(n, e, t) {
  return e = hy(e), ISe(n, WY() ? Reflect.construct(e, t || [], hy(n).constructor) : e.apply(n, t));
}
function ISe(n, e) {
  if (e && (Uf(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return RSe(n);
}
function RSe(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function WY() {
  try {
    var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (WY = function() {
    return !!n;
  })();
}
function hy(n) {
  return hy = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, hy(n);
}
function PSe(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && xT(n, e);
}
function xT(n, e) {
  return xT = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, xT(n, e);
}
function GY(n, e, t) {
  return e = KY(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function KY(n) {
  var e = DSe(n, "string");
  return Uf(e) == "symbol" ? e : e + "";
}
function DSe(n, e) {
  if (Uf(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Uf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
function ET() {
  return ET = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, ET.apply(this, arguments);
}
function NSe(n) {
  var e = n.xAxisId, t = BM(), r = zM(), i = _Y(e);
  return i == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ A.createElement(_h, ET({}, i, {
      className: Ut("recharts-".concat(i.axisType, " ").concat(i.axisType), i.className),
      viewBox: {
        x: 0,
        y: 0,
        width: t,
        height: r
      },
      ticksGenerator: function(o) {
        return Za(o, !0);
      }
    }))
  );
}
var WM = /* @__PURE__ */ (function(n) {
  function e() {
    return MSe(this, e), OSe(this, e, arguments);
  }
  return PSe(e, n), _Se(e, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ A.createElement(NSe, this.props);
    }
  }]);
})(A.Component);
GY(WM, "displayName", "XAxis");
GY(WM, "defaultProps", {
  allowDecimals: !0,
  hide: !1,
  orientation: "bottom",
  width: 0,
  height: 30,
  mirror: !1,
  xAxisId: 0,
  tickCount: 5,
  type: "category",
  padding: {
    left: 0,
    right: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1,
  allowDuplicatedCategory: !0
});
function Vf(n) {
  "@babel/helpers - typeof";
  return Vf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Vf(n);
}
function LSe(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function $Se(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, XY(r.key), r);
  }
}
function FSe(n, e, t) {
  return e && $Se(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function BSe(n, e, t) {
  return e = py(e), zSe(n, qY() ? Reflect.construct(e, t || [], py(n).constructor) : e.apply(n, t));
}
function zSe(n, e) {
  if (e && (Vf(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return HSe(n);
}
function HSe(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function qY() {
  try {
    var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (qY = function() {
    return !!n;
  })();
}
function py(n) {
  return py = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, py(n);
}
function USe(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && ST(n, e);
}
function ST(n, e) {
  return ST = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, ST(n, e);
}
function YY(n, e, t) {
  return e = XY(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function XY(n) {
  var e = VSe(n, "string");
  return Vf(e) == "symbol" ? e : e + "";
}
function VSe(n, e) {
  if (Vf(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Vf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
function CT() {
  return CT = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, CT.apply(this, arguments);
}
var jSe = function(e) {
  var t = e.yAxisId, r = BM(), i = zM(), s = OY(t);
  return s == null ? null : (
    // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    /* @__PURE__ */ A.createElement(_h, CT({}, s, {
      className: Ut("recharts-".concat(s.axisType, " ").concat(s.axisType), s.className),
      viewBox: {
        x: 0,
        y: 0,
        width: r,
        height: i
      },
      ticksGenerator: function(a) {
        return Za(a, !0);
      }
    }))
  );
}, GM = /* @__PURE__ */ (function(n) {
  function e() {
    return LSe(this, e), BSe(this, e, arguments);
  }
  return USe(e, n), FSe(e, [{
    key: "render",
    value: function() {
      return /* @__PURE__ */ A.createElement(jSe, this.props);
    }
  }]);
})(A.Component);
YY(GM, "displayName", "YAxis");
YY(GM, "defaultProps", {
  allowDuplicatedCategory: !0,
  allowDecimals: !0,
  hide: !1,
  orientation: "left",
  width: 60,
  height: 0,
  mirror: !1,
  yAxisId: 0,
  tickCount: 5,
  type: "number",
  padding: {
    top: 0,
    bottom: 0
  },
  allowDataOverflow: !1,
  scale: "auto",
  reversed: !1
});
function MF(n) {
  return qSe(n) || KSe(n) || GSe(n) || WSe();
}
function WSe() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function GSe(n, e) {
  if (n) {
    if (typeof n == "string") return TT(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return TT(n, e);
  }
}
function KSe(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function qSe(n) {
  if (Array.isArray(n)) return TT(n);
}
function TT(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
var AT = function(e, t, r, i, s) {
  var o = go(e, UM), a = go(e, qw), l = [].concat(MF(o), MF(a)), c = go(e, Xw), u = "".concat(i, "Id"), d = i[0], f = t;
  if (l.length && (f = l.reduce(function(g, v) {
    if (v.props[u] === r && fa(v.props, "extendDomain") && ke(v.props[d])) {
      var y = v.props[d];
      return [Math.min(g[0], y), Math.max(g[1], y)];
    }
    return g;
  }, f)), c.length) {
    var h = "".concat(d, "1"), m = "".concat(d, "2");
    f = c.reduce(function(g, v) {
      if (v.props[u] === r && fa(v.props, "extendDomain") && ke(v.props[h]) && ke(v.props[m])) {
        var y = v.props[h], b = v.props[m];
        return [Math.min(g[0], y, b), Math.max(g[1], y, b)];
      }
      return g;
    }, f);
  }
  return s && s.length && (f = s.reduce(function(g, v) {
    return ke(v) ? [Math.min(g[0], v), Math.max(g[1], v)] : g;
  }, f)), f;
}, KS = { exports: {} }, kF;
function YSe() {
  return kF || (kF = 1, (function(n) {
    var e = Object.prototype.hasOwnProperty, t = "~";
    function r() {
    }
    Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (t = !1));
    function i(l, c, u) {
      this.fn = l, this.context = c, this.once = u || !1;
    }
    function s(l, c, u, d, f) {
      if (typeof u != "function")
        throw new TypeError("The listener must be a function");
      var h = new i(u, d || l, f), m = t ? t + c : c;
      return l._events[m] ? l._events[m].fn ? l._events[m] = [l._events[m], h] : l._events[m].push(h) : (l._events[m] = h, l._eventsCount++), l;
    }
    function o(l, c) {
      --l._eventsCount === 0 ? l._events = new r() : delete l._events[c];
    }
    function a() {
      this._events = new r(), this._eventsCount = 0;
    }
    a.prototype.eventNames = function() {
      var c = [], u, d;
      if (this._eventsCount === 0) return c;
      for (d in u = this._events)
        e.call(u, d) && c.push(t ? d.slice(1) : d);
      return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(u)) : c;
    }, a.prototype.listeners = function(c) {
      var u = t ? t + c : c, d = this._events[u];
      if (!d) return [];
      if (d.fn) return [d.fn];
      for (var f = 0, h = d.length, m = new Array(h); f < h; f++)
        m[f] = d[f].fn;
      return m;
    }, a.prototype.listenerCount = function(c) {
      var u = t ? t + c : c, d = this._events[u];
      return d ? d.fn ? 1 : d.length : 0;
    }, a.prototype.emit = function(c, u, d, f, h, m) {
      var g = t ? t + c : c;
      if (!this._events[g]) return !1;
      var v = this._events[g], y = arguments.length, b, x;
      if (v.fn) {
        switch (v.once && this.removeListener(c, v.fn, void 0, !0), y) {
          case 1:
            return v.fn.call(v.context), !0;
          case 2:
            return v.fn.call(v.context, u), !0;
          case 3:
            return v.fn.call(v.context, u, d), !0;
          case 4:
            return v.fn.call(v.context, u, d, f), !0;
          case 5:
            return v.fn.call(v.context, u, d, f, h), !0;
          case 6:
            return v.fn.call(v.context, u, d, f, h, m), !0;
        }
        for (x = 1, b = new Array(y - 1); x < y; x++)
          b[x - 1] = arguments[x];
        v.fn.apply(v.context, b);
      } else {
        var E = v.length, w;
        for (x = 0; x < E; x++)
          switch (v[x].once && this.removeListener(c, v[x].fn, void 0, !0), y) {
            case 1:
              v[x].fn.call(v[x].context);
              break;
            case 2:
              v[x].fn.call(v[x].context, u);
              break;
            case 3:
              v[x].fn.call(v[x].context, u, d);
              break;
            case 4:
              v[x].fn.call(v[x].context, u, d, f);
              break;
            default:
              if (!b) for (w = 1, b = new Array(y - 1); w < y; w++)
                b[w - 1] = arguments[w];
              v[x].fn.apply(v[x].context, b);
          }
      }
      return !0;
    }, a.prototype.on = function(c, u, d) {
      return s(this, c, u, d, !1);
    }, a.prototype.once = function(c, u, d) {
      return s(this, c, u, d, !0);
    }, a.prototype.removeListener = function(c, u, d, f) {
      var h = t ? t + c : c;
      if (!this._events[h]) return this;
      if (!u)
        return o(this, h), this;
      var m = this._events[h];
      if (m.fn)
        m.fn === u && (!f || m.once) && (!d || m.context === d) && o(this, h);
      else {
        for (var g = 0, v = [], y = m.length; g < y; g++)
          (m[g].fn !== u || f && !m[g].once || d && m[g].context !== d) && v.push(m[g]);
        v.length ? this._events[h] = v.length === 1 ? v[0] : v : o(this, h);
      }
      return this;
    }, a.prototype.removeAllListeners = function(c) {
      var u;
      return c ? (u = t ? t + c : c, this._events[u] && o(this, u)) : (this._events = new r(), this._eventsCount = 0), this;
    }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = t, a.EventEmitter = a, n.exports = a;
  })(KS)), KS.exports;
}
var XSe = YSe();
const ZSe = /* @__PURE__ */ nn(XSe);
var qS = new ZSe(), YS = "recharts.syncMouseEvents";
function Zm(n) {
  "@babel/helpers - typeof";
  return Zm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Zm(n);
}
function QSe(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function JSe(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, ZY(r.key), r);
  }
}
function e6e(n, e, t) {
  return e && JSe(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function XS(n, e, t) {
  return e = ZY(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function ZY(n) {
  var e = t6e(n, "string");
  return Zm(e) == "symbol" ? e : e + "";
}
function t6e(n, e) {
  if (Zm(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Zm(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
var n6e = /* @__PURE__ */ (function() {
  function n() {
    QSe(this, n), XS(this, "activeIndex", 0), XS(this, "coordinateList", []), XS(this, "layout", "horizontal");
  }
  return e6e(n, [{
    key: "setDetails",
    value: function(t) {
      var r, i = t.coordinateList, s = i === void 0 ? null : i, o = t.container, a = o === void 0 ? null : o, l = t.layout, c = l === void 0 ? null : l, u = t.offset, d = u === void 0 ? null : u, f = t.mouseHandlerCallback, h = f === void 0 ? null : f;
      this.coordinateList = (r = s ?? this.coordinateList) !== null && r !== void 0 ? r : [], this.container = a ?? this.container, this.layout = c ?? this.layout, this.offset = d ?? this.offset, this.mouseHandlerCallback = h ?? this.mouseHandlerCallback, this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
    }
  }, {
    key: "focus",
    value: function() {
      this.spoofMouse();
    }
  }, {
    key: "keyboardEvent",
    value: function(t) {
      if (this.coordinateList.length !== 0)
        switch (t.key) {
          case "ArrowRight": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1), this.spoofMouse();
            break;
          }
          case "ArrowLeft": {
            if (this.layout !== "horizontal")
              return;
            this.activeIndex = Math.max(this.activeIndex - 1, 0), this.spoofMouse();
            break;
          }
        }
    }
  }, {
    key: "setIndex",
    value: function(t) {
      this.activeIndex = t;
    }
  }, {
    key: "spoofMouse",
    value: function() {
      var t, r;
      if (this.layout === "horizontal" && this.coordinateList.length !== 0) {
        var i = this.container.getBoundingClientRect(), s = i.x, o = i.y, a = i.height, l = this.coordinateList[this.activeIndex].coordinate, c = ((t = window) === null || t === void 0 ? void 0 : t.scrollX) || 0, u = ((r = window) === null || r === void 0 ? void 0 : r.scrollY) || 0, d = s + l + c, f = o + this.offset.top + a / 2 + u;
        this.mouseHandlerCallback({
          pageX: d,
          pageY: f
        });
      }
    }
  }]);
})();
function r6e(n, e, t) {
  if (t === "number" && e === !0 && Array.isArray(n)) {
    var r = n?.[0], i = n?.[1];
    if (r && i && ke(r) && ke(i))
      return !0;
  }
  return !1;
}
function i6e(n, e, t, r) {
  var i = r / 2;
  return {
    stroke: "none",
    fill: "#ccc",
    x: n === "horizontal" ? e.x - i : t.left + 0.5,
    y: n === "horizontal" ? t.top + 0.5 : e.y - i,
    width: n === "horizontal" ? r : t.width - 1,
    height: n === "horizontal" ? t.height - 1 : r
  };
}
function QY(n) {
  var e = n.cx, t = n.cy, r = n.radius, i = n.startAngle, s = n.endAngle, o = jr(e, t, r, i), a = jr(e, t, r, s);
  return {
    points: [o, a],
    cx: e,
    cy: t,
    radius: r,
    startAngle: i,
    endAngle: s
  };
}
function s6e(n, e, t) {
  var r, i, s, o;
  if (n === "horizontal")
    r = e.x, s = r, i = t.top, o = t.top + t.height;
  else if (n === "vertical")
    i = e.y, o = i, r = t.left, s = t.left + t.width;
  else if (e.cx != null && e.cy != null)
    if (n === "centric") {
      var a = e.cx, l = e.cy, c = e.innerRadius, u = e.outerRadius, d = e.angle, f = jr(a, l, c, d), h = jr(a, l, u, d);
      r = f.x, i = f.y, s = h.x, o = h.y;
    } else
      return QY(e);
  return [{
    x: r,
    y: i
  }, {
    x: s,
    y: o
  }];
}
function Qm(n) {
  "@babel/helpers - typeof";
  return Qm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Qm(n);
}
function _F(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function bg(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? _F(Object(t), !0).forEach(function(r) {
      o6e(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : _F(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function o6e(n, e, t) {
  return e = a6e(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function a6e(n) {
  var e = l6e(n, "string");
  return Qm(e) == "symbol" ? e : e + "";
}
function l6e(n, e) {
  if (Qm(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Qm(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function c6e(n) {
  var e, t, r = n.element, i = n.tooltipEventType, s = n.isActive, o = n.activeCoordinate, a = n.activePayload, l = n.offset, c = n.activeTooltipIndex, u = n.tooltipAxisBandSize, d = n.layout, f = n.chartName, h = (e = r.props.cursor) !== null && e !== void 0 ? e : (t = r.type.defaultProps) === null || t === void 0 ? void 0 : t.cursor;
  if (!r || !h || !s || !o || f !== "ScatterChart" && i !== "axis")
    return null;
  var m, g = Wp;
  if (f === "ScatterChart")
    m = o, g = c4e;
  else if (f === "BarChart")
    m = i6e(d, o, l, u), g = DM;
  else if (d === "radial") {
    var v = QY(o), y = v.cx, b = v.cy, x = v.radius, E = v.startAngle, w = v.endAngle;
    m = {
      cx: y,
      cy: b,
      startAngle: E,
      endAngle: w,
      innerRadius: x,
      outerRadius: x
    }, g = nY;
  } else
    m = {
      points: s6e(d, o, l)
    }, g = Wp;
  var C = bg(bg(bg(bg({
    stroke: "#ccc",
    pointerEvents: "none"
  }, l), m), $t(h, !1)), {}, {
    payload: a,
    payloadIndex: c,
    className: Ut("recharts-tooltip-cursor", h.className)
  });
  return /* @__PURE__ */ ca(h) ? /* @__PURE__ */ br(h, C) : /* @__PURE__ */ lt(g, C);
}
var u6e = ["item"], d6e = ["children", "className", "width", "height", "style", "compact", "title", "desc"];
function jf(n) {
  "@babel/helpers - typeof";
  return jf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, jf(n);
}
function qd() {
  return qd = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, qd.apply(this, arguments);
}
function OF(n, e) {
  return p6e(n) || h6e(n, e) || eX(n, e) || f6e();
}
function f6e() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function h6e(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r, i, s, o, a = [], l = !0, c = !1;
    try {
      if (s = (t = t.call(n)).next, e !== 0) for (; !(l = (r = s.call(t)).done) && (a.push(r.value), a.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && t.return != null && (o = t.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return a;
  }
}
function p6e(n) {
  if (Array.isArray(n)) return n;
}
function IF(n, e) {
  if (n == null) return {};
  var t = m6e(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function m6e(n, e) {
  if (n == null) return {};
  var t = {};
  for (var r in n)
    if (Object.prototype.hasOwnProperty.call(n, r)) {
      if (e.indexOf(r) >= 0) continue;
      t[r] = n[r];
    }
  return t;
}
function g6e(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function v6e(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, tX(r.key), r);
  }
}
function y6e(n, e, t) {
  return e && v6e(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function b6e(n, e, t) {
  return e = my(e), w6e(n, JY() ? Reflect.construct(e, t || [], my(n).constructor) : e.apply(n, t));
}
function w6e(n, e) {
  if (e && (jf(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return x6e(n);
}
function x6e(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function JY() {
  try {
    var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (JY = function() {
    return !!n;
  })();
}
function my(n) {
  return my = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, my(n);
}
function E6e(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && MT(n, e);
}
function MT(n, e) {
  return MT = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, MT(n, e);
}
function Wf(n) {
  return T6e(n) || C6e(n) || eX(n) || S6e();
}
function S6e() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function eX(n, e) {
  if (n) {
    if (typeof n == "string") return kT(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return kT(n, e);
  }
}
function C6e(n) {
  if (typeof Symbol < "u" && n[Symbol.iterator] != null || n["@@iterator"] != null) return Array.from(n);
}
function T6e(n) {
  if (Array.isArray(n)) return kT(n);
}
function kT(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function RF(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function fe(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? RF(Object(t), !0).forEach(function(r) {
      dt(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : RF(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function dt(n, e, t) {
  return e = tX(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function tX(n) {
  var e = A6e(n, "string");
  return jf(e) == "symbol" ? e : e + "";
}
function A6e(n, e) {
  if (jf(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (jf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
var M6e = {
  xAxis: ["bottom", "top"],
  yAxis: ["left", "right"]
}, k6e = {
  width: "100%",
  height: "100%"
}, nX = {
  x: 0,
  y: 0
};
function wg(n) {
  return n;
}
var _6e = function(e, t) {
  return t === "horizontal" ? e.x : t === "vertical" ? e.y : t === "centric" ? e.angle : e.radius;
}, O6e = function(e, t, r, i) {
  var s = t.find(function(u) {
    return u && u.index === r;
  });
  if (s) {
    if (e === "horizontal")
      return {
        x: s.coordinate,
        y: i.y
      };
    if (e === "vertical")
      return {
        x: i.x,
        y: s.coordinate
      };
    if (e === "centric") {
      var o = s.coordinate, a = i.radius;
      return fe(fe(fe({}, i), jr(i.cx, i.cy, a, o)), {}, {
        angle: o,
        radius: a
      });
    }
    var l = s.coordinate, c = i.angle;
    return fe(fe(fe({}, i), jr(i.cx, i.cy, l, c)), {}, {
      angle: c,
      radius: l
    });
  }
  return nX;
}, Zw = function(e, t) {
  var r = t.graphicalItems, i = t.dataStartIndex, s = t.dataEndIndex, o = (r ?? []).reduce(function(a, l) {
    var c = l.props.data;
    return c && c.length ? [].concat(Wf(a), Wf(c)) : a;
  }, []);
  return o.length > 0 ? o : e && e.length && ke(i) && ke(s) ? e.slice(i, s + 1) : [];
};
function rX(n) {
  return n === "number" ? [0, "auto"] : void 0;
}
var _T = function(e, t, r, i) {
  var s = e.graphicalItems, o = e.tooltipAxis, a = Zw(t, e);
  return r < 0 || !s || !s.length || r >= a.length ? null : s.reduce(function(l, c) {
    var u, d = (u = c.props.data) !== null && u !== void 0 ? u : t;
    d && e.dataStartIndex + e.dataEndIndex !== 0 && // https://github.com/recharts/recharts/issues/4717
    // The data is sliced only when the active index is within the start/end index range.
    e.dataEndIndex - e.dataStartIndex >= r && (d = d.slice(e.dataStartIndex, e.dataEndIndex + 1));
    var f;
    if (o.dataKey && !o.allowDuplicatedCategory) {
      var h = d === void 0 ? a : d;
      f = y2(h, o.dataKey, i);
    } else
      f = d && d[r] || a[r];
    return f ? [].concat(Wf(l), [Jq(c, f)]) : l;
  }, []);
}, PF = function(e, t, r, i) {
  var s = i || {
    x: e.chartX,
    y: e.chartY
  }, o = _6e(s, r), a = e.orderedTooltipTicks, l = e.tooltipAxis, c = e.tooltipTicks, u = Bbe(o, a, c, l);
  if (u >= 0 && c) {
    var d = c[u] && c[u].value, f = _T(e, t, u, d), h = O6e(r, a, u, s);
    return {
      activeTooltipIndex: u,
      activeLabel: d,
      activePayload: f,
      activeCoordinate: h
    };
  }
  return null;
}, I6e = function(e, t) {
  var r = t.axes, i = t.graphicalItems, s = t.axisType, o = t.axisIdKey, a = t.stackGroups, l = t.dataStartIndex, c = t.dataEndIndex, u = e.layout, d = e.children, f = e.stackOffset, h = Xq(u, s);
  return r.reduce(function(m, g) {
    var v, y = g.type.defaultProps !== void 0 ? fe(fe({}, g.type.defaultProps), g.props) : g.props, b = y.type, x = y.dataKey, E = y.allowDataOverflow, w = y.allowDuplicatedCategory, C = y.scale, S = y.ticks, M = y.includeHidden, k = y[o];
    if (m[k])
      return m;
    var _ = Zw(e.data, {
      graphicalItems: i.filter(function(F) {
        var V, X = o in F.props ? F.props[o] : (V = F.type.defaultProps) === null || V === void 0 ? void 0 : V[o];
        return X === k;
      }),
      dataStartIndex: l,
      dataEndIndex: c
    }), O = _.length, I, R, P;
    r6e(y.domain, E, b) && (I = qC(y.domain, null, E), h && (b === "number" || C !== "auto") && (P = jp(_, x, "category")));
    var D = rX(b);
    if (!I || I.length === 0) {
      var L, B = (L = y.domain) !== null && L !== void 0 ? L : D;
      if (x) {
        if (I = jp(_, x, b), b === "category" && h) {
          var $ = kpe(I);
          w && $ ? (R = I, I = ty(0, O)) : w || (I = FL(B, I, g).reduce(function(F, V) {
            return F.indexOf(V) >= 0 ? F : [].concat(Wf(F), [V]);
          }, []));
        } else if (b === "category")
          w ? I = I.filter(function(F) {
            return F !== "" && !Bt(F);
          }) : I = FL(B, I, g).reduce(function(F, V) {
            return F.indexOf(V) >= 0 || V === "" || Bt(V) ? F : [].concat(Wf(F), [V]);
          }, []);
        else if (b === "number") {
          var z = jbe(_, i.filter(function(F) {
            var V, X, Z = o in F.props ? F.props[o] : (V = F.type.defaultProps) === null || V === void 0 ? void 0 : V[o], ie = "hide" in F.props ? F.props.hide : (X = F.type.defaultProps) === null || X === void 0 ? void 0 : X.hide;
            return Z === k && (M || !ie);
          }), x, s, u);
          z && (I = z);
        }
        h && (b === "number" || C !== "auto") && (P = jp(_, x, "category"));
      } else h ? I = ty(0, O) : a && a[k] && a[k].hasStack && b === "number" ? I = f === "expand" ? [0, 1] : Qq(a[k].stackGroups, l, c) : I = Yq(_, i.filter(function(F) {
        var V = o in F.props ? F.props[o] : F.type.defaultProps[o], X = "hide" in F.props ? F.props.hide : F.type.defaultProps.hide;
        return V === k && (M || !X);
      }), b, u, !0);
      if (b === "number")
        I = AT(d, I, k, s, S), B && (I = qC(B, I, E));
      else if (b === "category" && B) {
        var H = B, U = I.every(function(F) {
          return H.indexOf(F) >= 0;
        });
        U && (I = H);
      }
    }
    return fe(fe({}, m), {}, dt({}, k, fe(fe({}, y), {}, {
      axisType: s,
      domain: I,
      categoricalDomain: P,
      duplicateDomain: R,
      originalDomain: (v = y.domain) !== null && v !== void 0 ? v : D,
      isCategorical: h,
      layout: u
    })));
  }, {});
}, R6e = function(e, t) {
  var r = t.graphicalItems, i = t.Axis, s = t.axisType, o = t.axisIdKey, a = t.stackGroups, l = t.dataStartIndex, c = t.dataEndIndex, u = e.layout, d = e.children, f = Zw(e.data, {
    graphicalItems: r,
    dataStartIndex: l,
    dataEndIndex: c
  }), h = f.length, m = Xq(u, s), g = -1;
  return r.reduce(function(v, y) {
    var b = y.type.defaultProps !== void 0 ? fe(fe({}, y.type.defaultProps), y.props) : y.props, x = b[o], E = rX("number");
    if (!v[x]) {
      g++;
      var w;
      return m ? w = ty(0, h) : a && a[x] && a[x].hasStack ? (w = Qq(a[x].stackGroups, l, c), w = AT(d, w, x, s)) : (w = qC(E, Yq(f, r.filter(function(C) {
        var S, M, k = o in C.props ? C.props[o] : (S = C.type.defaultProps) === null || S === void 0 ? void 0 : S[o], _ = "hide" in C.props ? C.props.hide : (M = C.type.defaultProps) === null || M === void 0 ? void 0 : M.hide;
        return k === x && !_;
      }), "number", u), i.defaultProps.allowDataOverflow), w = AT(d, w, x, s)), fe(fe({}, v), {}, dt({}, x, fe(fe({
        axisType: s
      }, i.defaultProps), {}, {
        hide: !0,
        orientation: Ls(M6e, "".concat(s, ".").concat(g % 2), null),
        domain: w,
        originalDomain: E,
        isCategorical: m,
        layout: u
        // specify scale when no Axis
        // scale: isCategorical ? 'band' : 'linear',
      })));
    }
    return v;
  }, {});
}, P6e = function(e, t) {
  var r = t.axisType, i = r === void 0 ? "xAxis" : r, s = t.AxisComp, o = t.graphicalItems, a = t.stackGroups, l = t.dataStartIndex, c = t.dataEndIndex, u = e.children, d = "".concat(i, "Id"), f = go(u, s), h = {};
  return f && f.length ? h = I6e(e, {
    axes: f,
    graphicalItems: o,
    axisType: i,
    axisIdKey: d,
    stackGroups: a,
    dataStartIndex: l,
    dataEndIndex: c
  }) : o && o.length && (h = R6e(e, {
    Axis: s,
    graphicalItems: o,
    axisType: i,
    axisIdKey: d,
    stackGroups: a,
    dataStartIndex: l,
    dataEndIndex: c
  })), h;
}, D6e = function(e) {
  var t = Wl(e), r = Za(t, !1, !0);
  return {
    tooltipTicks: r,
    orderedTooltipTicks: oM(r, function(i) {
      return i.coordinate;
    }),
    tooltipAxis: t,
    tooltipAxisBandSize: W2(t, r)
  };
}, DF = function(e) {
  var t = e.children, r = e.defaultShowTooltip, i = ss(t, Df), s = 0, o = 0;
  return e.data && e.data.length !== 0 && (o = e.data.length - 1), i && i.props && (i.props.startIndex >= 0 && (s = i.props.startIndex), i.props.endIndex >= 0 && (o = i.props.endIndex)), {
    chartX: 0,
    chartY: 0,
    dataStartIndex: s,
    dataEndIndex: o,
    activeTooltipIndex: -1,
    isTooltipActive: !!r
  };
}, N6e = function(e) {
  return !e || !e.length ? !1 : e.some(function(t) {
    var r = nl(t && t.type);
    return r && r.indexOf("Bar") >= 0;
  });
}, NF = function(e) {
  return e === "horizontal" ? {
    numericAxisName: "yAxis",
    cateAxisName: "xAxis"
  } : e === "vertical" ? {
    numericAxisName: "xAxis",
    cateAxisName: "yAxis"
  } : e === "centric" ? {
    numericAxisName: "radiusAxis",
    cateAxisName: "angleAxis"
  } : {
    numericAxisName: "angleAxis",
    cateAxisName: "radiusAxis"
  };
}, L6e = function(e, t) {
  var r = e.props, i = e.graphicalItems, s = e.xAxisMap, o = s === void 0 ? {} : s, a = e.yAxisMap, l = a === void 0 ? {} : a, c = r.width, u = r.height, d = r.children, f = r.margin || {}, h = ss(d, Df), m = ss(d, yu), g = Object.keys(l).reduce(function(w, C) {
    var S = l[C], M = S.orientation;
    return !S.mirror && !S.hide ? fe(fe({}, w), {}, dt({}, M, w[M] + S.width)) : w;
  }, {
    left: f.left || 0,
    right: f.right || 0
  }), v = Object.keys(o).reduce(function(w, C) {
    var S = o[C], M = S.orientation;
    return !S.mirror && !S.hide ? fe(fe({}, w), {}, dt({}, M, Ls(w, "".concat(M)) + S.height)) : w;
  }, {
    top: f.top || 0,
    bottom: f.bottom || 0
  }), y = fe(fe({}, v), g), b = y.bottom;
  h && (y.bottom += h.props.height || Df.defaultProps.height), m && t && (y = Ube(y, i, r, t));
  var x = c - y.left - y.right, E = u - y.top - y.bottom;
  return fe(fe({
    brushBottom: b
  }, y), {}, {
    // never return negative values for height and width
    width: Math.max(x, 0),
    height: Math.max(E, 0)
  });
}, $6e = function(e, t) {
  if (t === "xAxis")
    return e[t].width;
  if (t === "yAxis")
    return e[t].height;
}, F6e = function(e) {
  var t = e.chartName, r = e.GraphicalChild, i = e.defaultTooltipEventType, s = i === void 0 ? "axis" : i, o = e.validateTooltipEventTypes, a = o === void 0 ? ["axis"] : o, l = e.axisComponents, c = e.legendContent, u = e.formatAxisMap, d = e.defaultProps, f = function(y, b) {
    var x = b.graphicalItems, E = b.stackGroups, w = b.offset, C = b.updateId, S = b.dataStartIndex, M = b.dataEndIndex, k = y.barSize, _ = y.layout, O = y.barGap, I = y.barCategoryGap, R = y.maxBarSize, P = NF(_), D = P.numericAxisName, L = P.cateAxisName, B = N6e(x), $ = [];
    return x.forEach(function(z, H) {
      var U = Zw(y.data, {
        graphicalItems: [z],
        dataStartIndex: S,
        dataEndIndex: M
      }), F = z.type.defaultProps !== void 0 ? fe(fe({}, z.type.defaultProps), z.props) : z.props, V = F.dataKey, X = F.maxBarSize, Z = F["".concat(D, "Id")], ie = F["".concat(L, "Id")], J = {}, se = l.reduce(function(re, oe) {
        var Se, ye, be = b["".concat(oe.axisType, "Map")], Oe = F["".concat(oe.axisType, "Id")];
        be && be[Oe] || oe.axisType === "zAxis" || (process.env.NODE_ENV !== "production" ? Fi(!1, "Specifying a(n) ".concat(oe.axisType, "Id requires a corresponding ").concat(
          oe.axisType,
          "Id on the targeted graphical component "
        ).concat((Se = z == null || (ye = z.type) === null || ye === void 0 ? void 0 : ye.displayName) !== null && Se !== void 0 ? Se : "")) : Fi());
        var ut = be[Oe];
        return fe(fe({}, re), {}, dt(dt({}, oe.axisType, ut), "".concat(oe.axisType, "Ticks"), Za(ut)));
      }, J), te = se[L], le = se["".concat(L, "Ticks")], de = E && E[Z] && E[Z].hasStack && nwe(z, E[Z].stackGroups), j = nl(z.type).indexOf("Bar") >= 0, xe = W2(te, le), ne = [], qe = B && zbe({
        barSize: k,
        stackGroups: E,
        totalSize: $6e(se, L)
      });
      if (j) {
        var ve, Ie, mt = Bt(X) ? R : X, xt = (ve = (Ie = W2(te, le, !0)) !== null && Ie !== void 0 ? Ie : mt) !== null && ve !== void 0 ? ve : 0;
        ne = Hbe({
          barGap: O,
          barCategoryGap: I,
          bandSize: xt !== xe ? xt : xe,
          sizeList: qe[ie],
          maxBarSize: mt
        }), xt !== xe && (ne = ne.map(function(re) {
          return fe(fe({}, re), {}, {
            position: fe(fe({}, re.position), {}, {
              offset: re.position.offset - xt / 2
            })
          });
        }));
      }
      var G = z && z.type && z.type.getComposedData;
      G && $.push({
        props: fe(fe({}, G(fe(fe({}, se), {}, {
          displayedData: U,
          props: y,
          dataKey: V,
          item: z,
          bandSize: xe,
          barPosition: ne,
          offset: w,
          stackedData: de,
          layout: _,
          dataStartIndex: S,
          dataEndIndex: M
        }))), {}, dt(dt(dt({
          key: z.key || "item-".concat(H)
        }, D, se[D]), L, se[L]), "animationId", C)),
        childIndex: Hpe(z, y.children),
        item: z
      });
    }), $;
  }, h = function(y, b) {
    var x = y.props, E = y.dataStartIndex, w = y.dataEndIndex, C = y.updateId;
    if (!QR({
      props: x
    }))
      return null;
    var S = x.children, M = x.layout, k = x.stackOffset, _ = x.data, O = x.reverseStackOrder, I = NF(M), R = I.numericAxisName, P = I.cateAxisName, D = go(S, r), L = Jbe(_, D, "".concat(R, "Id"), "".concat(P, "Id"), k, O), B = l.reduce(function(F, V) {
      var X = "".concat(V.axisType, "Map");
      return fe(fe({}, F), {}, dt({}, X, P6e(x, fe(fe({}, V), {}, {
        graphicalItems: D,
        stackGroups: V.axisType === R && L,
        dataStartIndex: E,
        dataEndIndex: w
      }))));
    }, {}), $ = L6e(fe(fe({}, B), {}, {
      props: x,
      graphicalItems: D
    }), b?.legendBBox);
    Object.keys(B).forEach(function(F) {
      B[F] = u(x, B[F], $, F.replace("Map", ""), t);
    });
    var z = B["".concat(P, "Map")], H = D6e(z), U = f(x, fe(fe({}, B), {}, {
      dataStartIndex: E,
      dataEndIndex: w,
      updateId: C,
      graphicalItems: D,
      stackGroups: L,
      offset: $
    }));
    return fe(fe({
      formattedGraphicalItems: U,
      graphicalItems: D,
      offset: $,
      stackGroups: L
    }, H), B);
  }, m = /* @__PURE__ */ (function(v) {
    function y(b) {
      var x, E, w;
      return g6e(this, y), w = b6e(this, y, [b]), dt(w, "eventEmitterSymbol", Symbol("rechartsEventEmitter")), dt(w, "accessibilityManager", new n6e()), dt(w, "handleLegendBBoxUpdate", function(C) {
        if (C) {
          var S = w.state, M = S.dataStartIndex, k = S.dataEndIndex, _ = S.updateId;
          w.setState(fe({
            legendBBox: C
          }, h({
            props: w.props,
            dataStartIndex: M,
            dataEndIndex: k,
            updateId: _
          }, fe(fe({}, w.state), {}, {
            legendBBox: C
          }))));
        }
      }), dt(w, "handleReceiveSyncEvent", function(C, S, M) {
        if (w.props.syncId === C) {
          if (M === w.eventEmitterSymbol && typeof w.props.syncMethod != "function")
            return;
          w.applySyncEvent(S);
        }
      }), dt(w, "handleBrushChange", function(C) {
        var S = C.startIndex, M = C.endIndex;
        if (S !== w.state.dataStartIndex || M !== w.state.dataEndIndex) {
          var k = w.state.updateId;
          w.setState(function() {
            return fe({
              dataStartIndex: S,
              dataEndIndex: M
            }, h({
              props: w.props,
              dataStartIndex: S,
              dataEndIndex: M,
              updateId: k
            }, w.state));
          }), w.triggerSyncEvent({
            dataStartIndex: S,
            dataEndIndex: M
          });
        }
      }), dt(w, "handleMouseEnter", function(C) {
        var S = w.getMouseInfo(C);
        if (S) {
          var M = fe(fe({}, S), {}, {
            isTooltipActive: !0
          });
          w.setState(M), w.triggerSyncEvent(M);
          var k = w.props.onMouseEnter;
          Mt(k) && k(M, C);
        }
      }), dt(w, "triggeredAfterMouseMove", function(C) {
        var S = w.getMouseInfo(C), M = S ? fe(fe({}, S), {}, {
          isTooltipActive: !0
        }) : {
          isTooltipActive: !1
        };
        w.setState(M), w.triggerSyncEvent(M);
        var k = w.props.onMouseMove;
        Mt(k) && k(M, C);
      }), dt(w, "handleItemMouseEnter", function(C) {
        w.setState(function() {
          return {
            isTooltipActive: !0,
            activeItem: C,
            activePayload: C.tooltipPayload,
            activeCoordinate: C.tooltipPosition || {
              x: C.cx,
              y: C.cy
            }
          };
        });
      }), dt(w, "handleItemMouseLeave", function() {
        w.setState(function() {
          return {
            isTooltipActive: !1
          };
        });
      }), dt(w, "handleMouseMove", function(C) {
        C.persist(), w.throttleTriggeredAfterMouseMove(C);
      }), dt(w, "handleMouseLeave", function(C) {
        w.throttleTriggeredAfterMouseMove.cancel();
        var S = {
          isTooltipActive: !1
        };
        w.setState(S), w.triggerSyncEvent(S);
        var M = w.props.onMouseLeave;
        Mt(M) && M(S, C);
      }), dt(w, "handleOuterEvent", function(C) {
        var S = zpe(C), M = Ls(w.props, "".concat(S));
        if (S && Mt(M)) {
          var k, _;
          /.*touch.*/i.test(S) ? _ = w.getMouseInfo(C.changedTouches[0]) : _ = w.getMouseInfo(C), M((k = _) !== null && k !== void 0 ? k : {}, C);
        }
      }), dt(w, "handleClick", function(C) {
        var S = w.getMouseInfo(C);
        if (S) {
          var M = fe(fe({}, S), {}, {
            isTooltipActive: !0
          });
          w.setState(M), w.triggerSyncEvent(M);
          var k = w.props.onClick;
          Mt(k) && k(M, C);
        }
      }), dt(w, "handleMouseDown", function(C) {
        var S = w.props.onMouseDown;
        if (Mt(S)) {
          var M = w.getMouseInfo(C);
          S(M, C);
        }
      }), dt(w, "handleMouseUp", function(C) {
        var S = w.props.onMouseUp;
        if (Mt(S)) {
          var M = w.getMouseInfo(C);
          S(M, C);
        }
      }), dt(w, "handleTouchMove", function(C) {
        C.changedTouches != null && C.changedTouches.length > 0 && w.throttleTriggeredAfterMouseMove(C.changedTouches[0]);
      }), dt(w, "handleTouchStart", function(C) {
        C.changedTouches != null && C.changedTouches.length > 0 && w.handleMouseDown(C.changedTouches[0]);
      }), dt(w, "handleTouchEnd", function(C) {
        C.changedTouches != null && C.changedTouches.length > 0 && w.handleMouseUp(C.changedTouches[0]);
      }), dt(w, "handleDoubleClick", function(C) {
        var S = w.props.onDoubleClick;
        if (Mt(S)) {
          var M = w.getMouseInfo(C);
          S(M, C);
        }
      }), dt(w, "handleContextMenu", function(C) {
        var S = w.props.onContextMenu;
        if (Mt(S)) {
          var M = w.getMouseInfo(C);
          S(M, C);
        }
      }), dt(w, "triggerSyncEvent", function(C) {
        w.props.syncId !== void 0 && qS.emit(YS, w.props.syncId, C, w.eventEmitterSymbol);
      }), dt(w, "applySyncEvent", function(C) {
        var S = w.props, M = S.layout, k = S.syncMethod, _ = w.state.updateId, O = C.dataStartIndex, I = C.dataEndIndex;
        if (C.dataStartIndex !== void 0 || C.dataEndIndex !== void 0)
          w.setState(fe({
            dataStartIndex: O,
            dataEndIndex: I
          }, h({
            props: w.props,
            dataStartIndex: O,
            dataEndIndex: I,
            updateId: _
          }, w.state)));
        else if (C.activeTooltipIndex !== void 0) {
          var R = C.chartX, P = C.chartY, D = C.activeTooltipIndex, L = w.state, B = L.offset, $ = L.tooltipTicks;
          if (!B)
            return;
          if (typeof k == "function")
            D = k($, C);
          else if (k === "value") {
            D = -1;
            for (var z = 0; z < $.length; z++)
              if ($[z].value === C.activeLabel) {
                D = z;
                break;
              }
          }
          var H = fe(fe({}, B), {}, {
            x: B.left,
            y: B.top
          }), U = Math.min(R, H.x + H.width), F = Math.min(P, H.y + H.height), V = $[D] && $[D].value, X = _T(w.state, w.props.data, D), Z = $[D] ? {
            x: M === "horizontal" ? $[D].coordinate : U,
            y: M === "horizontal" ? F : $[D].coordinate
          } : nX;
          w.setState(fe(fe({}, C), {}, {
            activeLabel: V,
            activeCoordinate: Z,
            activePayload: X,
            activeTooltipIndex: D
          }));
        } else
          w.setState(C);
      }), dt(w, "renderCursor", function(C) {
        var S, M = w.state, k = M.isTooltipActive, _ = M.activeCoordinate, O = M.activePayload, I = M.offset, R = M.activeTooltipIndex, P = M.tooltipAxisBandSize, D = w.getTooltipEventType(), L = (S = C.props.active) !== null && S !== void 0 ? S : k, B = w.props.layout, $ = C.key || "_recharts-cursor";
        return /* @__PURE__ */ p.createElement(c6e, {
          key: $,
          activeCoordinate: _,
          activePayload: O,
          activeTooltipIndex: R,
          chartName: t,
          element: C,
          isActive: L,
          layout: B,
          offset: I,
          tooltipAxisBandSize: P,
          tooltipEventType: D
        });
      }), dt(w, "renderPolarAxis", function(C, S, M) {
        var k = Ls(C, "type.axisType"), _ = Ls(w.state, "".concat(k, "Map")), O = C.type.defaultProps, I = O !== void 0 ? fe(fe({}, O), C.props) : C.props, R = _ && _[I["".concat(k, "Id")]];
        return /* @__PURE__ */ br(C, fe(fe({}, R), {}, {
          className: Ut(k, R.className),
          key: C.key || "".concat(S, "-").concat(M),
          ticks: Za(R, !0)
        }));
      }), dt(w, "renderPolarGrid", function(C) {
        var S = C.props, M = S.radialLines, k = S.polarAngles, _ = S.polarRadius, O = w.state, I = O.radiusAxisMap, R = O.angleAxisMap, P = Wl(I), D = Wl(R), L = D.cx, B = D.cy, $ = D.innerRadius, z = D.outerRadius;
        return /* @__PURE__ */ br(C, {
          polarAngles: Array.isArray(k) ? k : Za(D, !0).map(function(H) {
            return H.coordinate;
          }),
          polarRadius: Array.isArray(_) ? _ : Za(P, !0).map(function(H) {
            return H.coordinate;
          }),
          cx: L,
          cy: B,
          innerRadius: $,
          outerRadius: z,
          key: C.key || "polar-grid",
          radialLines: M
        });
      }), dt(w, "renderLegend", function() {
        var C = w.state.formattedGraphicalItems, S = w.props, M = S.children, k = S.width, _ = S.height, O = w.props.margin || {}, I = k - (O.left || 0) - (O.right || 0), R = Kq({
          children: M,
          formattedGraphicalItems: C,
          legendWidth: I,
          legendContent: c
        });
        if (!R)
          return null;
        var P = R.item, D = IF(R, u6e);
        return /* @__PURE__ */ br(P, fe(fe({}, D), {}, {
          chartWidth: k,
          chartHeight: _,
          margin: O,
          onBBoxUpdate: w.handleLegendBBoxUpdate
        }));
      }), dt(w, "renderTooltip", function() {
        var C, S = w.props, M = S.children, k = S.accessibilityLayer, _ = ss(M, Yo);
        if (!_)
          return null;
        var O = w.state, I = O.isTooltipActive, R = O.activeCoordinate, P = O.activePayload, D = O.activeLabel, L = O.offset, B = (C = _.props.active) !== null && C !== void 0 ? C : I;
        return /* @__PURE__ */ br(_, {
          viewBox: fe(fe({}, L), {}, {
            x: L.left,
            y: L.top
          }),
          active: B,
          label: D,
          payload: B ? P : [],
          coordinate: R,
          accessibilityLayer: k
        });
      }), dt(w, "renderBrush", function(C) {
        var S = w.props, M = S.margin, k = S.data, _ = w.state, O = _.offset, I = _.dataStartIndex, R = _.dataEndIndex, P = _.updateId;
        return /* @__PURE__ */ br(C, {
          key: C.key || "_recharts-brush",
          onChange: hg(w.handleBrushChange, C.props.onChange),
          data: k,
          x: ke(C.props.x) ? C.props.x : O.left,
          y: ke(C.props.y) ? C.props.y : O.top + O.height + O.brushBottom - (M.bottom || 0),
          width: ke(C.props.width) ? C.props.width : O.width,
          startIndex: I,
          endIndex: R,
          updateId: "brush-".concat(P)
        });
      }), dt(w, "renderReferenceElement", function(C, S, M) {
        if (!C)
          return null;
        var k = w, _ = k.clipPathId, O = w.state, I = O.xAxisMap, R = O.yAxisMap, P = O.offset, D = C.type.defaultProps || {}, L = C.props, B = L.xAxisId, $ = B === void 0 ? D.xAxisId : B, z = L.yAxisId, H = z === void 0 ? D.yAxisId : z;
        return /* @__PURE__ */ br(C, {
          key: C.key || "".concat(S, "-").concat(M),
          xAxis: I[$],
          yAxis: R[H],
          viewBox: {
            x: P.left,
            y: P.top,
            width: P.width,
            height: P.height
          },
          clipPathId: _
        });
      }), dt(w, "renderActivePoints", function(C) {
        var S = C.item, M = C.activePoint, k = C.basePoint, _ = C.childIndex, O = C.isRange, I = [], R = S.props.key, P = S.item.type.defaultProps !== void 0 ? fe(fe({}, S.item.type.defaultProps), S.item.props) : S.item.props, D = P.activeDot, L = P.dataKey, B = fe(fe({
          index: _,
          dataKey: L,
          cx: M.x,
          cy: M.y,
          r: 4,
          fill: RM(S.item),
          strokeWidth: 2,
          stroke: "#fff",
          payload: M.payload,
          value: M.value
        }, $t(D, !1)), b2(D));
        return I.push(y.renderActiveDot(D, B, "".concat(R, "-activePoint-").concat(_))), k ? I.push(y.renderActiveDot(D, fe(fe({}, B), {}, {
          cx: k.x,
          cy: k.y
        }), "".concat(R, "-basePoint-").concat(_))) : O && I.push(null), I;
      }), dt(w, "renderGraphicChild", function(C, S, M) {
        var k = w.filterFormatItem(C, S, M);
        if (!k)
          return null;
        var _ = w.getTooltipEventType(), O = w.state, I = O.isTooltipActive, R = O.tooltipAxis, P = O.activeTooltipIndex, D = O.activeLabel, L = w.props.children, B = ss(L, Yo), $ = k.props, z = $.points, H = $.isRange, U = $.baseLine, F = k.item.type.defaultProps !== void 0 ? fe(fe({}, k.item.type.defaultProps), k.item.props) : k.item.props, V = F.activeDot, X = F.hide, Z = F.activeBar, ie = F.activeShape, J = !!(!X && I && B && (V || Z || ie)), se = {};
        _ !== "axis" && B && B.props.trigger === "click" ? se = {
          onClick: hg(w.handleItemMouseEnter, C.props.onClick)
        } : _ !== "axis" && (se = {
          onMouseLeave: hg(w.handleItemMouseLeave, C.props.onMouseLeave),
          onMouseEnter: hg(w.handleItemMouseEnter, C.props.onMouseEnter)
        });
        var te = /* @__PURE__ */ br(C, fe(fe({}, k.props), se));
        function le(oe) {
          return typeof R.dataKey == "function" ? R.dataKey(oe.payload) : null;
        }
        if (J)
          if (P >= 0) {
            var de, j;
            if (R.dataKey && !R.allowDuplicatedCategory) {
              var xe = typeof R.dataKey == "function" ? le : "payload.".concat(R.dataKey.toString());
              de = y2(z, xe, D), j = H && U && y2(U, xe, D);
            } else
              de = z?.[P], j = H && U && U[P];
            if (ie || Z) {
              var ne = C.props.activeIndex !== void 0 ? C.props.activeIndex : P;
              return [/* @__PURE__ */ br(C, fe(fe(fe({}, k.props), se), {}, {
                activeIndex: ne
              })), null, null];
            }
            if (!Bt(de))
              return [te].concat(Wf(w.renderActivePoints({
                item: k,
                activePoint: de,
                basePoint: j,
                childIndex: P,
                isRange: H
              })));
          } else {
            var qe, ve = (qe = w.getItemByXY(w.state.activeCoordinate)) !== null && qe !== void 0 ? qe : {
              graphicalItem: te
            }, Ie = ve.graphicalItem, mt = Ie.item, xt = mt === void 0 ? C : mt, G = Ie.childIndex, re = fe(fe(fe({}, k.props), se), {}, {
              activeIndex: G
            });
            return [/* @__PURE__ */ br(xt, re), null, null];
          }
        return H ? [te, null, null] : [te, null];
      }), dt(w, "renderCustomized", function(C, S, M) {
        return /* @__PURE__ */ br(C, fe(fe({
          key: "recharts-customized-".concat(M)
        }, w.props), w.state));
      }), dt(w, "renderMap", {
        CartesianGrid: {
          handler: wg,
          once: !0
        },
        ReferenceArea: {
          handler: w.renderReferenceElement
        },
        ReferenceLine: {
          handler: wg
        },
        ReferenceDot: {
          handler: w.renderReferenceElement
        },
        XAxis: {
          handler: wg
        },
        YAxis: {
          handler: wg
        },
        Brush: {
          handler: w.renderBrush,
          once: !0
        },
        Bar: {
          handler: w.renderGraphicChild
        },
        Line: {
          handler: w.renderGraphicChild
        },
        Area: {
          handler: w.renderGraphicChild
        },
        Radar: {
          handler: w.renderGraphicChild
        },
        RadialBar: {
          handler: w.renderGraphicChild
        },
        Scatter: {
          handler: w.renderGraphicChild
        },
        Pie: {
          handler: w.renderGraphicChild
        },
        Funnel: {
          handler: w.renderGraphicChild
        },
        Tooltip: {
          handler: w.renderCursor,
          once: !0
        },
        PolarGrid: {
          handler: w.renderPolarGrid,
          once: !0
        },
        PolarAngleAxis: {
          handler: w.renderPolarAxis
        },
        PolarRadiusAxis: {
          handler: w.renderPolarAxis
        },
        Customized: {
          handler: w.renderCustomized
        }
      }), w.clipPathId = "".concat((x = b.id) !== null && x !== void 0 ? x : l1("recharts"), "-clip"), w.throttleTriggeredAfterMouseMove = GK(w.triggeredAfterMouseMove, (E = b.throttleDelay) !== null && E !== void 0 ? E : 1e3 / 60), w.state = {}, w;
    }
    return E6e(y, v), y6e(y, [{
      key: "componentDidMount",
      value: function() {
        var x, E;
        this.addListener(), this.accessibilityManager.setDetails({
          container: this.container,
          offset: {
            left: (x = this.props.margin.left) !== null && x !== void 0 ? x : 0,
            top: (E = this.props.margin.top) !== null && E !== void 0 ? E : 0
          },
          coordinateList: this.state.tooltipTicks,
          mouseHandlerCallback: this.triggeredAfterMouseMove,
          layout: this.props.layout
        }), this.displayDefaultTooltip();
      }
    }, {
      key: "displayDefaultTooltip",
      value: function() {
        var x = this.props, E = x.children, w = x.data, C = x.height, S = x.layout, M = ss(E, Yo);
        if (M) {
          var k = M.props.defaultIndex;
          if (!(typeof k != "number" || k < 0 || k > this.state.tooltipTicks.length - 1)) {
            var _ = this.state.tooltipTicks[k] && this.state.tooltipTicks[k].value, O = _T(this.state, w, k, _), I = this.state.tooltipTicks[k].coordinate, R = (this.state.offset.top + C) / 2, P = S === "horizontal", D = P ? {
              x: I,
              y: R
            } : {
              y: I,
              x: R
            }, L = this.state.formattedGraphicalItems.find(function($) {
              var z = $.item;
              return z.type.name === "Scatter";
            });
            L && (D = fe(fe({}, D), L.props.points[k].tooltipPosition), O = L.props.points[k].tooltipPayload);
            var B = {
              activeTooltipIndex: k,
              isTooltipActive: !0,
              activeLabel: _,
              activePayload: O,
              activeCoordinate: D
            };
            this.setState(B), this.renderCursor(M), this.accessibilityManager.setIndex(k);
          }
        }
      }
    }, {
      key: "getSnapshotBeforeUpdate",
      value: function(x, E) {
        if (!this.props.accessibilityLayer)
          return null;
        if (this.state.tooltipTicks !== E.tooltipTicks && this.accessibilityManager.setDetails({
          coordinateList: this.state.tooltipTicks
        }), this.props.layout !== x.layout && this.accessibilityManager.setDetails({
          layout: this.props.layout
        }), this.props.margin !== x.margin) {
          var w, C;
          this.accessibilityManager.setDetails({
            offset: {
              left: (w = this.props.margin.left) !== null && w !== void 0 ? w : 0,
              top: (C = this.props.margin.top) !== null && C !== void 0 ? C : 0
            }
          });
        }
        return null;
      }
    }, {
      key: "componentDidUpdate",
      value: function(x) {
        gC([ss(x.children, Yo)], [ss(this.props.children, Yo)]) || this.displayDefaultTooltip();
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        this.removeListener(), this.throttleTriggeredAfterMouseMove.cancel();
      }
    }, {
      key: "getTooltipEventType",
      value: function() {
        var x = ss(this.props.children, Yo);
        if (x && typeof x.props.shared == "boolean") {
          var E = x.props.shared ? "axis" : "item";
          return a.indexOf(E) >= 0 ? E : s;
        }
        return s;
      }
      /**
       * Get the information of mouse in chart, return null when the mouse is not in the chart
       * @param  {MousePointer} event    The event object
       * @return {Object}          Mouse data
       */
    }, {
      key: "getMouseInfo",
      value: function(x) {
        if (!this.container)
          return null;
        var E = this.container, w = E.getBoundingClientRect(), C = _ge(w), S = {
          chartX: Math.round(x.pageX - C.left),
          chartY: Math.round(x.pageY - C.top)
        }, M = w.width / E.offsetWidth || 1, k = this.inRange(S.chartX, S.chartY, M);
        if (!k)
          return null;
        var _ = this.state, O = _.xAxisMap, I = _.yAxisMap, R = this.getTooltipEventType(), P = PF(this.state, this.props.data, this.props.layout, k);
        if (R !== "axis" && O && I) {
          var D = Wl(O).scale, L = Wl(I).scale, B = D && D.invert ? D.invert(S.chartX) : null, $ = L && L.invert ? L.invert(S.chartY) : null;
          return fe(fe({}, S), {}, {
            xValue: B,
            yValue: $
          }, P);
        }
        return P ? fe(fe({}, S), P) : null;
      }
    }, {
      key: "inRange",
      value: function(x, E) {
        var w = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1, C = this.props.layout, S = x / w, M = E / w;
        if (C === "horizontal" || C === "vertical") {
          var k = this.state.offset, _ = S >= k.left && S <= k.left + k.width && M >= k.top && M <= k.top + k.height;
          return _ ? {
            x: S,
            y: M
          } : null;
        }
        var O = this.state, I = O.angleAxisMap, R = O.radiusAxisMap;
        if (I && R) {
          var P = Wl(I);
          return HL({
            x: S,
            y: M
          }, P);
        }
        return null;
      }
    }, {
      key: "parseEventsOfWrapper",
      value: function() {
        var x = this.props.children, E = this.getTooltipEventType(), w = ss(x, Yo), C = {};
        w && E === "axis" && (w.props.trigger === "click" ? C = {
          onClick: this.handleClick
        } : C = {
          onMouseEnter: this.handleMouseEnter,
          onDoubleClick: this.handleDoubleClick,
          onMouseMove: this.handleMouseMove,
          onMouseLeave: this.handleMouseLeave,
          onTouchMove: this.handleTouchMove,
          onTouchStart: this.handleTouchStart,
          onTouchEnd: this.handleTouchEnd,
          onContextMenu: this.handleContextMenu
        });
        var S = b2(this.props, this.handleOuterEvent);
        return fe(fe({}, S), C);
      }
    }, {
      key: "addListener",
      value: function() {
        qS.on(YS, this.handleReceiveSyncEvent);
      }
    }, {
      key: "removeListener",
      value: function() {
        qS.removeListener(YS, this.handleReceiveSyncEvent);
      }
    }, {
      key: "filterFormatItem",
      value: function(x, E, w) {
        for (var C = this.state.formattedGraphicalItems, S = 0, M = C.length; S < M; S++) {
          var k = C[S];
          if (k.item === x || k.props.key === x.key || E === nl(k.item.type) && w === k.childIndex)
            return k;
        }
        return null;
      }
    }, {
      key: "renderClipPath",
      value: function() {
        var x = this.clipPathId, E = this.state.offset, w = E.left, C = E.top, S = E.height, M = E.width;
        return /* @__PURE__ */ p.createElement("defs", null, /* @__PURE__ */ p.createElement("clipPath", {
          id: x
        }, /* @__PURE__ */ p.createElement("rect", {
          x: w,
          y: C,
          height: S,
          width: M
        })));
      }
    }, {
      key: "getXScales",
      value: function() {
        var x = this.state.xAxisMap;
        return x ? Object.entries(x).reduce(function(E, w) {
          var C = OF(w, 2), S = C[0], M = C[1];
          return fe(fe({}, E), {}, dt({}, S, M.scale));
        }, {}) : null;
      }
    }, {
      key: "getYScales",
      value: function() {
        var x = this.state.yAxisMap;
        return x ? Object.entries(x).reduce(function(E, w) {
          var C = OF(w, 2), S = C[0], M = C[1];
          return fe(fe({}, E), {}, dt({}, S, M.scale));
        }, {}) : null;
      }
    }, {
      key: "getXScaleByAxisId",
      value: function(x) {
        var E;
        return (E = this.state.xAxisMap) === null || E === void 0 || (E = E[x]) === null || E === void 0 ? void 0 : E.scale;
      }
    }, {
      key: "getYScaleByAxisId",
      value: function(x) {
        var E;
        return (E = this.state.yAxisMap) === null || E === void 0 || (E = E[x]) === null || E === void 0 ? void 0 : E.scale;
      }
    }, {
      key: "getItemByXY",
      value: function(x) {
        var E = this.state, w = E.formattedGraphicalItems, C = E.activeItem;
        if (w && w.length)
          for (var S = 0, M = w.length; S < M; S++) {
            var k = w[S], _ = k.props, O = k.item, I = O.type.defaultProps !== void 0 ? fe(fe({}, O.type.defaultProps), O.props) : O.props, R = nl(O.type);
            if (R === "Bar") {
              var P = (_.data || []).find(function($) {
                return Jxe(x, $);
              });
              if (P)
                return {
                  graphicalItem: k,
                  payload: P
                };
            } else if (R === "RadialBar") {
              var D = (_.data || []).find(function($) {
                return HL(x, $);
              });
              if (D)
                return {
                  graphicalItem: k,
                  payload: D
                };
            } else if (jw(k, C) || Ww(k, C) || Km(k, C)) {
              var L = V4e({
                graphicalItem: k,
                activeTooltipItem: C,
                itemData: I.data
              }), B = I.activeIndex === void 0 ? L : I.activeIndex;
              return {
                graphicalItem: fe(fe({}, k), {}, {
                  childIndex: B
                }),
                payload: Km(k, C) ? I.data[L] : k.props.data[L]
              };
            }
          }
        return null;
      }
    }, {
      key: "render",
      value: function() {
        var x = this;
        if (!QR(this))
          return null;
        var E = this.props, w = E.children, C = E.className, S = E.width, M = E.height, k = E.style, _ = E.compact, O = E.title, I = E.desc, R = IF(E, d6e), P = $t(R, !1);
        if (_)
          return /* @__PURE__ */ p.createElement(fF, {
            state: this.state,
            width: this.props.width,
            height: this.props.height,
            clipPathId: this.clipPathId
          }, /* @__PURE__ */ p.createElement(yC, qd({}, P, {
            width: S,
            height: M,
            title: O,
            desc: I
          }), this.renderClipPath(), eP(w, this.renderMap)));
        if (this.props.accessibilityLayer) {
          var D, L;
          P.tabIndex = (D = this.props.tabIndex) !== null && D !== void 0 ? D : 0, P.role = (L = this.props.role) !== null && L !== void 0 ? L : "application", P.onKeyDown = function($) {
            x.accessibilityManager.keyboardEvent($);
          }, P.onFocus = function() {
            x.accessibilityManager.focus();
          };
        }
        var B = this.parseEventsOfWrapper();
        return /* @__PURE__ */ p.createElement(fF, {
          state: this.state,
          width: this.props.width,
          height: this.props.height,
          clipPathId: this.clipPathId
        }, /* @__PURE__ */ p.createElement("div", qd({
          className: Ut("recharts-wrapper", C),
          style: fe({
            position: "relative",
            cursor: "default",
            width: S,
            height: M
          }, k)
        }, B, {
          ref: function(z) {
            x.container = z;
          }
        }), /* @__PURE__ */ p.createElement(yC, qd({}, P, {
          width: S,
          height: M,
          title: O,
          desc: I,
          style: k6e
        }), this.renderClipPath(), eP(w, this.renderMap)), this.renderLegend(), this.renderTooltip()));
      }
    }]);
  })(EG);
  dt(m, "displayName", t), dt(m, "defaultProps", fe({
    layout: "horizontal",
    stackOffset: "none",
    barCategoryGap: "10%",
    barGap: 4,
    margin: {
      top: 5,
      right: 5,
      bottom: 5,
      left: 5
    },
    reverseStackOrder: !1,
    syncMethod: "index"
  }, d)), dt(m, "getDerivedStateFromProps", function(v, y) {
    var b = v.dataKey, x = v.data, E = v.children, w = v.width, C = v.height, S = v.layout, M = v.stackOffset, k = v.margin, _ = y.dataStartIndex, O = y.dataEndIndex;
    if (y.updateId === void 0) {
      var I = DF(v);
      return fe(fe(fe({}, I), {}, {
        updateId: 0
      }, h(fe(fe({
        props: v
      }, I), {}, {
        updateId: 0
      }), y)), {}, {
        prevDataKey: b,
        prevData: x,
        prevWidth: w,
        prevHeight: C,
        prevLayout: S,
        prevStackOffset: M,
        prevMargin: k,
        prevChildren: E
      });
    }
    if (b !== y.prevDataKey || x !== y.prevData || w !== y.prevWidth || C !== y.prevHeight || S !== y.prevLayout || M !== y.prevStackOffset || !rf(k, y.prevMargin)) {
      var R = DF(v), P = {
        // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
        // any flickering
        chartX: y.chartX,
        chartY: y.chartY,
        // The tooltip should stay active when it was active in the previous render. If this is not
        // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
        isTooltipActive: y.isTooltipActive
      }, D = fe(fe({}, PF(y, x, S)), {}, {
        updateId: y.updateId + 1
      }), L = fe(fe(fe({}, R), P), D);
      return fe(fe(fe({}, L), h(fe({
        props: v
      }, L), y)), {}, {
        prevDataKey: b,
        prevData: x,
        prevWidth: w,
        prevHeight: C,
        prevLayout: S,
        prevStackOffset: M,
        prevMargin: k,
        prevChildren: E
      });
    }
    if (!gC(E, y.prevChildren)) {
      var B, $, z, H, U = ss(E, Df), F = U && (B = ($ = U.props) === null || $ === void 0 ? void 0 : $.startIndex) !== null && B !== void 0 ? B : _, V = U && (z = (H = U.props) === null || H === void 0 ? void 0 : H.endIndex) !== null && z !== void 0 ? z : O, X = F !== _ || V !== O, Z = !Bt(x), ie = Z && !X ? y.updateId : y.updateId + 1;
      return fe(fe({
        updateId: ie
      }, h(fe(fe({
        props: v
      }, y), {}, {
        updateId: ie,
        dataStartIndex: F,
        dataEndIndex: V
      }), y)), {}, {
        prevChildren: E,
        dataStartIndex: F,
        dataEndIndex: V
      });
    }
    return null;
  }), dt(m, "renderActiveDot", function(v, y, b) {
    var x;
    return /* @__PURE__ */ ca(v) ? x = /* @__PURE__ */ br(v, y) : Mt(v) ? x = v(y) : x = /* @__PURE__ */ p.createElement(NM, y), /* @__PURE__ */ p.createElement(jn, {
      className: "recharts-active-dot",
      key: b
    }, x);
  });
  var g = /* @__PURE__ */ tn(function(y, b) {
    return /* @__PURE__ */ p.createElement(m, qd({}, y, {
      ref: b
    }));
  });
  return g.displayName = m.displayName, g;
}, Vbt = F6e({
  chartName: "AreaChart",
  GraphicalChild: id,
  axisComponents: [{
    axisType: "xAxis",
    AxisComp: WM
  }, {
    axisType: "yAxis",
    AxisComp: GM
  }],
  formatAxisMap: BEe
});
function B6e(n) {
  if (typeof document > "u") return;
  let e = document.head || document.getElementsByTagName("head")[0], t = document.createElement("style");
  t.type = "text/css", e.appendChild(t), t.styleSheet ? t.styleSheet.cssText = n : t.appendChild(document.createTextNode(n));
}
const z6e = (n) => {
  switch (n) {
    case "success":
      return V6e;
    case "info":
      return W6e;
    case "warning":
      return j6e;
    case "error":
      return G6e;
    default:
      return null;
  }
}, H6e = Array(12).fill(0), U6e = ({ visible: n, className: e }) => /* @__PURE__ */ p.createElement("div", {
  className: [
    "sonner-loading-wrapper",
    e
  ].filter(Boolean).join(" "),
  "data-visible": n
}, /* @__PURE__ */ p.createElement("div", {
  className: "sonner-spinner"
}, H6e.map((t, r) => /* @__PURE__ */ p.createElement("div", {
  className: "sonner-loading-bar",
  key: `spinner-bar-${r}`
})))), V6e = /* @__PURE__ */ p.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ p.createElement("path", {
  fillRule: "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
  clipRule: "evenodd"
})), j6e = /* @__PURE__ */ p.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ p.createElement("path", {
  fillRule: "evenodd",
  d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
  clipRule: "evenodd"
})), W6e = /* @__PURE__ */ p.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ p.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
  clipRule: "evenodd"
})), G6e = /* @__PURE__ */ p.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ p.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
  clipRule: "evenodd"
})), K6e = /* @__PURE__ */ p.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /* @__PURE__ */ p.createElement("line", {
  x1: "18",
  y1: "6",
  x2: "6",
  y2: "18"
}), /* @__PURE__ */ p.createElement("line", {
  x1: "6",
  y1: "6",
  x2: "18",
  y2: "18"
})), q6e = () => {
  const [n, e] = p.useState(document.hidden);
  return p.useEffect(() => {
    const t = () => {
      e(document.hidden);
    };
    return document.addEventListener("visibilitychange", t), () => window.removeEventListener("visibilitychange", t);
  }, []), n;
};
let OT = 1;
class Y6e {
  constructor() {
    this.subscribe = (e) => (this.subscribers.push(e), () => {
      const t = this.subscribers.indexOf(e);
      this.subscribers.splice(t, 1);
    }), this.publish = (e) => {
      this.subscribers.forEach((t) => t(e));
    }, this.addToast = (e) => {
      this.publish(e), this.toasts = [
        ...this.toasts,
        e
      ];
    }, this.create = (e) => {
      var t;
      const { message: r, ...i } = e, s = typeof e?.id == "number" || ((t = e.id) == null ? void 0 : t.length) > 0 ? e.id : OT++, o = this.toasts.find((l) => l.id === s), a = e.dismissible === void 0 ? !0 : e.dismissible;
      return this.dismissedToasts.has(s) && this.dismissedToasts.delete(s), o ? this.toasts = this.toasts.map((l) => l.id === s ? (this.publish({
        ...l,
        ...e,
        id: s,
        title: r
      }), {
        ...l,
        ...e,
        id: s,
        dismissible: a,
        title: r
      }) : l) : this.addToast({
        title: r,
        ...i,
        dismissible: a,
        id: s
      }), s;
    }, this.dismiss = (e) => (e ? (this.dismissedToasts.add(e), requestAnimationFrame(() => this.subscribers.forEach((t) => t({
      id: e,
      dismiss: !0
    })))) : this.toasts.forEach((t) => {
      this.subscribers.forEach((r) => r({
        id: t.id,
        dismiss: !0
      }));
    }), e), this.message = (e, t) => this.create({
      ...t,
      message: e
    }), this.error = (e, t) => this.create({
      ...t,
      message: e,
      type: "error"
    }), this.success = (e, t) => this.create({
      ...t,
      type: "success",
      message: e
    }), this.info = (e, t) => this.create({
      ...t,
      type: "info",
      message: e
    }), this.warning = (e, t) => this.create({
      ...t,
      type: "warning",
      message: e
    }), this.loading = (e, t) => this.create({
      ...t,
      type: "loading",
      message: e
    }), this.promise = (e, t) => {
      if (!t)
        return;
      let r;
      t.loading !== void 0 && (r = this.create({
        ...t,
        promise: e,
        type: "loading",
        message: t.loading,
        description: typeof t.description != "function" ? t.description : void 0
      }));
      const i = Promise.resolve(e instanceof Function ? e() : e);
      let s = r !== void 0, o;
      const a = i.then(async (c) => {
        if (o = [
          "resolve",
          c
        ], p.isValidElement(c))
          s = !1, this.create({
            id: r,
            type: "default",
            message: c
          });
        else if (Z6e(c) && !c.ok) {
          s = !1;
          const d = typeof t.error == "function" ? await t.error(`HTTP error! status: ${c.status}`) : t.error, f = typeof t.description == "function" ? await t.description(`HTTP error! status: ${c.status}`) : t.description, m = typeof d == "object" && !p.isValidElement(d) ? d : {
            message: d
          };
          this.create({
            id: r,
            type: "error",
            description: f,
            ...m
          });
        } else if (c instanceof Error) {
          s = !1;
          const d = typeof t.error == "function" ? await t.error(c) : t.error, f = typeof t.description == "function" ? await t.description(c) : t.description, m = typeof d == "object" && !p.isValidElement(d) ? d : {
            message: d
          };
          this.create({
            id: r,
            type: "error",
            description: f,
            ...m
          });
        } else if (t.success !== void 0) {
          s = !1;
          const d = typeof t.success == "function" ? await t.success(c) : t.success, f = typeof t.description == "function" ? await t.description(c) : t.description, m = typeof d == "object" && !p.isValidElement(d) ? d : {
            message: d
          };
          this.create({
            id: r,
            type: "success",
            description: f,
            ...m
          });
        }
      }).catch(async (c) => {
        if (o = [
          "reject",
          c
        ], t.error !== void 0) {
          s = !1;
          const u = typeof t.error == "function" ? await t.error(c) : t.error, d = typeof t.description == "function" ? await t.description(c) : t.description, h = typeof u == "object" && !p.isValidElement(u) ? u : {
            message: u
          };
          this.create({
            id: r,
            type: "error",
            description: d,
            ...h
          });
        }
      }).finally(() => {
        s && (this.dismiss(r), r = void 0), t.finally == null || t.finally.call(t);
      }), l = () => new Promise((c, u) => a.then(() => o[0] === "reject" ? u(o[1]) : c(o[1])).catch(u));
      return typeof r != "string" && typeof r != "number" ? {
        unwrap: l
      } : Object.assign(r, {
        unwrap: l
      });
    }, this.custom = (e, t) => {
      const r = t?.id || OT++;
      return this.create({
        jsx: e(r),
        id: r,
        ...t
      }), r;
    }, this.getActiveToasts = () => this.toasts.filter((e) => !this.dismissedToasts.has(e.id)), this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
}
const Oi = new Y6e(), X6e = (n, e) => {
  const t = e?.id || OT++;
  return Oi.addToast({
    title: n,
    ...e,
    id: t
  }), t;
}, Z6e = (n) => n && typeof n == "object" && "ok" in n && typeof n.ok == "boolean" && "status" in n && typeof n.status == "number", Q6e = X6e, J6e = () => Oi.toasts, e8e = () => Oi.getActiveToasts(), Ap = Object.assign(Q6e, {
  success: Oi.success,
  info: Oi.info,
  warning: Oi.warning,
  error: Oi.error,
  custom: Oi.custom,
  message: Oi.message,
  promise: Oi.promise,
  dismiss: Oi.dismiss,
  loading: Oi.loading
}, {
  getHistory: J6e,
  getToasts: e8e
});
B6e("[data-sonner-toaster][dir=ltr],html[dir=ltr]{--toast-icon-margin-start:-3px;--toast-icon-margin-end:4px;--toast-svg-margin-start:-1px;--toast-svg-margin-end:0px;--toast-button-margin-start:auto;--toast-button-margin-end:0;--toast-close-button-start:0;--toast-close-button-end:unset;--toast-close-button-transform:translate(-35%, -35%)}[data-sonner-toaster][dir=rtl],html[dir=rtl]{--toast-icon-margin-start:4px;--toast-icon-margin-end:-3px;--toast-svg-margin-start:0px;--toast-svg-margin-end:-1px;--toast-button-margin-start:0;--toast-button-margin-end:auto;--toast-close-button-start:unset;--toast-close-button-end:0;--toast-close-button-transform:translate(35%, -35%)}[data-sonner-toaster]{position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1:hsl(0, 0%, 99%);--gray2:hsl(0, 0%, 97.3%);--gray3:hsl(0, 0%, 95.1%);--gray4:hsl(0, 0%, 93%);--gray5:hsl(0, 0%, 90.9%);--gray6:hsl(0, 0%, 88.7%);--gray7:hsl(0, 0%, 85.8%);--gray8:hsl(0, 0%, 78%);--gray9:hsl(0, 0%, 56.1%);--gray10:hsl(0, 0%, 52.3%);--gray11:hsl(0, 0%, 43.5%);--gray12:hsl(0, 0%, 9%);--border-radius:8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:0;z-index:999999999;transition:transform .4s ease}@media (hover:none) and (pointer:coarse){[data-sonner-toaster][data-lifted=true]{transform:none}}[data-sonner-toaster][data-x-position=right]{right:var(--offset-right)}[data-sonner-toaster][data-x-position=left]{left:var(--offset-left)}[data-sonner-toaster][data-x-position=center]{left:50%;transform:translateX(-50%)}[data-sonner-toaster][data-y-position=top]{top:var(--offset-top)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--offset-bottom)}[data-sonner-toast]{--y:translateY(100%);--lift-amount:calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:0;overflow-wrap:anywhere}[data-sonner-toast][data-styled=true]{padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px rgba(0,0,0,.1);width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}[data-sonner-toast]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-y-position=top]{top:0;--y:translateY(-100%);--lift:1;--lift-amount:calc(1 * var(--gap))}[data-sonner-toast][data-y-position=bottom]{bottom:0;--y:translateY(100%);--lift:-1;--lift-amount:calc(var(--lift) * var(--gap))}[data-sonner-toast][data-styled=true] [data-description]{font-weight:400;line-height:1.4;color:#3f3f3f}[data-rich-colors=true][data-sonner-toast][data-styled=true] [data-description]{color:inherit}[data-sonner-toaster][data-sonner-theme=dark] [data-description]{color:#e8e8e8}[data-sonner-toast][data-styled=true] [data-title]{font-weight:500;line-height:1.5;color:inherit}[data-sonner-toast][data-styled=true] [data-icon]{display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}[data-sonner-toast][data-promise=true] [data-icon]>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}[data-sonner-toast][data-styled=true] [data-icon]>*{flex-shrink:0}[data-sonner-toast][data-styled=true] [data-icon] svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}[data-sonner-toast][data-styled=true] [data-content]{display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;font-weight:500;cursor:pointer;outline:0;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}[data-sonner-toast][data-styled=true] [data-button]:focus-visible{box-shadow:0 0 0 2px rgba(0,0,0,.4)}[data-sonner-toast][data-styled=true] [data-button]:first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}[data-sonner-toast][data-styled=true] [data-cancel]{color:var(--normal-text);background:rgba(0,0,0,.08)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-styled=true] [data-cancel]{background:rgba(255,255,255,.3)}[data-sonner-toast][data-styled=true] [data-close-button]{position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);background:var(--normal-bg);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast][data-styled=true] [data-close-button]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-styled=true] [data-disabled=true]{cursor:not-allowed}[data-sonner-toast][data-styled=true]:hover [data-close-button]:hover{background:var(--gray2);border-color:var(--gray5)}[data-sonner-toast][data-swiping=true]::before{content:'';position:absolute;left:-100%;right:-100%;height:100%;z-index:-1}[data-sonner-toast][data-y-position=top][data-swiping=true]::before{bottom:50%;transform:scaleY(3) translateY(50%)}[data-sonner-toast][data-y-position=bottom][data-swiping=true]::before{top:50%;transform:scaleY(3) translateY(-50%)}[data-sonner-toast][data-swiping=false][data-removed=true]::before{content:'';position:absolute;inset:0;transform:scaleY(2)}[data-sonner-toast][data-expanded=true]::after{content:'';position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}[data-sonner-toast][data-mounted=true]{--y:translateY(0);opacity:1}[data-sonner-toast][data-expanded=false][data-front=false]{--scale:var(--toasts-before) * 0.05 + 1;--y:translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}[data-sonner-toast]>*{transition:opacity .4s}[data-sonner-toast][data-x-position=right]{right:0}[data-sonner-toast][data-x-position=left]{left:0}[data-sonner-toast][data-expanded=false][data-front=false][data-styled=true]>*{opacity:0}[data-sonner-toast][data-visible=false]{opacity:0;pointer-events:none}[data-sonner-toast][data-mounted=true][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}[data-sonner-toast][data-removed=true][data-front=true][data-swipe-out=false]{--y:translateY(calc(var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=false]{--y:translateY(40%);opacity:0;transition:transform .5s,opacity .2s}[data-sonner-toast][data-removed=true][data-front=false]::before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y,0)) translateX(var(--swipe-amount-x,0));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width:600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-sonner-theme=light]{--normal-bg:#fff;--normal-border:var(--gray4);--normal-text:var(--gray12);--success-bg:hsl(143, 85%, 96%);--success-border:hsl(145, 92%, 87%);--success-text:hsl(140, 100%, 27%);--info-bg:hsl(208, 100%, 97%);--info-border:hsl(221, 91%, 93%);--info-text:hsl(210, 92%, 45%);--warning-bg:hsl(49, 100%, 97%);--warning-border:hsl(49, 91%, 84%);--warning-text:hsl(31, 92%, 45%);--error-bg:hsl(359, 100%, 97%);--error-border:hsl(359, 100%, 94%);--error-text:hsl(360, 100%, 45%)}[data-sonner-toaster][data-sonner-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg:#000;--normal-border:hsl(0, 0%, 20%);--normal-text:var(--gray1)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg:#fff;--normal-border:var(--gray3);--normal-text:var(--gray12)}[data-sonner-toaster][data-sonner-theme=dark]{--normal-bg:#000;--normal-bg-hover:hsl(0, 0%, 12%);--normal-border:hsl(0, 0%, 20%);--normal-border-hover:hsl(0, 0%, 25%);--normal-text:var(--gray1);--success-bg:hsl(150, 100%, 6%);--success-border:hsl(147, 100%, 12%);--success-text:hsl(150, 86%, 65%);--info-bg:hsl(215, 100%, 6%);--info-border:hsl(223, 43%, 17%);--info-text:hsl(216, 87%, 65%);--warning-bg:hsl(64, 100%, 6%);--warning-border:hsl(60, 100%, 9%);--warning-text:hsl(46, 87%, 65%);--error-bg:hsl(358, 76%, 10%);--error-border:hsl(357, 89%, 16%);--error-text:hsl(358, 100%, 81%)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size:16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:first-child{animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}100%{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}100%{opacity:.15}}@media (prefers-reduced-motion){.sonner-loading-bar,[data-sonner-toast],[data-sonner-toast]>*{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}");
function xg(n) {
  return n.label !== void 0;
}
const t8e = 3, n8e = "24px", r8e = "16px", LF = 4e3, i8e = 356, s8e = 14, o8e = 45, a8e = 200;
function $o(...n) {
  return n.filter(Boolean).join(" ");
}
function l8e(n) {
  const [e, t] = n.split("-"), r = [];
  return e && r.push(e), t && r.push(t), r;
}
const c8e = (n) => {
  var e, t, r, i, s, o, a, l, c;
  const { invert: u, toast: d, unstyled: f, interacting: h, setHeights: m, visibleToasts: g, heights: v, index: y, toasts: b, expanded: x, removeToast: E, defaultRichColors: w, closeButton: C, style: S, cancelButtonStyle: M, actionButtonStyle: k, className: _ = "", descriptionClassName: O = "", duration: I, position: R, gap: P, expandByDefault: D, classNames: L, icons: B, closeButtonAriaLabel: $ = "Close toast" } = n, [z, H] = p.useState(null), [U, F] = p.useState(null), [V, X] = p.useState(!1), [Z, ie] = p.useState(!1), [J, se] = p.useState(!1), [te, le] = p.useState(!1), [de, j] = p.useState(!1), [xe, ne] = p.useState(0), [qe, ve] = p.useState(0), Ie = p.useRef(d.duration || I || LF), mt = p.useRef(null), xt = p.useRef(null), G = y === 0, re = y + 1 <= g, oe = d.type, Se = d.dismissible !== !1, ye = d.className || "", be = d.descriptionClassName || "", Oe = p.useMemo(() => v.findIndex((W) => W.toastId === d.id) || 0, [
    v,
    d.id
  ]), ut = p.useMemo(() => {
    var W;
    return (W = d.closeButton) != null ? W : C;
  }, [
    d.closeButton,
    C
  ]), Et = p.useMemo(() => d.duration || I || LF, [
    d.duration,
    I
  ]), Yt = p.useRef(0), Wt = p.useRef(0), me = p.useRef(0), Pe = p.useRef(null), [yt, kt] = R.split("-"), rn = p.useMemo(() => v.reduce((W, ue, we) => we >= Oe ? W : W + ue.height, 0), [
    v,
    Oe
  ]), vn = q6e(), Xi = d.invert || u, ot = oe === "loading";
  Wt.current = p.useMemo(() => Oe * P + rn, [
    Oe,
    rn
  ]), p.useEffect(() => {
    Ie.current = Et;
  }, [
    Et
  ]), p.useEffect(() => {
    X(!0);
  }, []), p.useEffect(() => {
    const W = xt.current;
    if (W) {
      const ue = W.getBoundingClientRect().height;
      return ve(ue), m((we) => [
        {
          toastId: d.id,
          height: ue,
          position: d.position
        },
        ...we
      ]), () => m((we) => we.filter((Le) => Le.toastId !== d.id));
    }
  }, [
    m,
    d.id
  ]), p.useLayoutEffect(() => {
    if (!V) return;
    const W = xt.current, ue = W.style.height;
    W.style.height = "auto";
    const we = W.getBoundingClientRect().height;
    W.style.height = ue, ve(we), m((Le) => Le.find((gt) => gt.toastId === d.id) ? Le.map((gt) => gt.toastId === d.id ? {
      ...gt,
      height: we
    } : gt) : [
      {
        toastId: d.id,
        height: we,
        position: d.position
      },
      ...Le
    ]);
  }, [
    V,
    d.title,
    d.description,
    m,
    d.id,
    d.jsx,
    d.action,
    d.cancel
  ]);
  const Ae = p.useCallback(() => {
    ie(!0), ne(Wt.current), m((W) => W.filter((ue) => ue.toastId !== d.id)), setTimeout(() => {
      E(d);
    }, a8e);
  }, [
    d,
    E,
    m,
    Wt
  ]);
  p.useEffect(() => {
    if (d.promise && oe === "loading" || d.duration === 1 / 0 || d.type === "loading") return;
    let W;
    return x || h || vn ? (() => {
      if (me.current < Yt.current) {
        const Le = (/* @__PURE__ */ new Date()).getTime() - Yt.current;
        Ie.current = Ie.current - Le;
      }
      me.current = (/* @__PURE__ */ new Date()).getTime();
    })() : (() => {
      Ie.current !== 1 / 0 && (Yt.current = (/* @__PURE__ */ new Date()).getTime(), W = setTimeout(() => {
        d.onAutoClose == null || d.onAutoClose.call(d, d), Ae();
      }, Ie.current));
    })(), () => clearTimeout(W);
  }, [
    x,
    h,
    d,
    oe,
    vn,
    Ae
  ]), p.useEffect(() => {
    d.delete && (Ae(), d.onDismiss == null || d.onDismiss.call(d, d));
  }, [
    Ae,
    d.delete
  ]);
  function De() {
    var W;
    if (B?.loading) {
      var ue;
      return /* @__PURE__ */ p.createElement("div", {
        className: $o(L?.loader, d == null || (ue = d.classNames) == null ? void 0 : ue.loader, "sonner-loader"),
        "data-visible": oe === "loading"
      }, B.loading);
    }
    return /* @__PURE__ */ p.createElement(U6e, {
      className: $o(L?.loader, d == null || (W = d.classNames) == null ? void 0 : W.loader),
      visible: oe === "loading"
    });
  }
  const et = d.icon || B?.[oe] || z6e(oe);
  var it, Ge;
  return /* @__PURE__ */ p.createElement("li", {
    tabIndex: 0,
    ref: xt,
    className: $o(_, ye, L?.toast, d == null || (e = d.classNames) == null ? void 0 : e.toast, L?.default, L?.[oe], d == null || (t = d.classNames) == null ? void 0 : t[oe]),
    "data-sonner-toast": "",
    "data-rich-colors": (it = d.richColors) != null ? it : w,
    "data-styled": !(d.jsx || d.unstyled || f),
    "data-mounted": V,
    "data-promise": !!d.promise,
    "data-swiped": de,
    "data-removed": Z,
    "data-visible": re,
    "data-y-position": yt,
    "data-x-position": kt,
    "data-index": y,
    "data-front": G,
    "data-swiping": J,
    "data-dismissible": Se,
    "data-type": oe,
    "data-invert": Xi,
    "data-swipe-out": te,
    "data-swipe-direction": U,
    "data-expanded": !!(x || D && V),
    "data-testid": d.testId,
    style: {
      "--index": y,
      "--toasts-before": y,
      "--z-index": b.length - y,
      "--offset": `${Z ? xe : Wt.current}px`,
      "--initial-height": D ? "auto" : `${qe}px`,
      ...S,
      ...d.style
    },
    onDragEnd: () => {
      se(!1), H(null), Pe.current = null;
    },
    onPointerDown: (W) => {
      W.button !== 2 && (ot || !Se || (mt.current = /* @__PURE__ */ new Date(), ne(Wt.current), W.target.setPointerCapture(W.pointerId), W.target.tagName !== "BUTTON" && (se(!0), Pe.current = {
        x: W.clientX,
        y: W.clientY
      })));
    },
    onPointerUp: () => {
      var W, ue, we;
      if (te || !Se) return;
      Pe.current = null;
      const Le = Number(((W = xt.current) == null ? void 0 : W.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), Pt = Number(((ue = xt.current) == null ? void 0 : ue.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), gt = (/* @__PURE__ */ new Date()).getTime() - ((we = mt.current) == null ? void 0 : we.getTime()), _e = z === "x" ? Le : Pt, $e = Math.abs(_e) / gt;
      if (Math.abs(_e) >= o8e || $e > 0.11) {
        ne(Wt.current), d.onDismiss == null || d.onDismiss.call(d, d), F(z === "x" ? Le > 0 ? "right" : "left" : Pt > 0 ? "down" : "up"), Ae(), le(!0);
        return;
      } else {
        var Qe, Xt;
        (Qe = xt.current) == null || Qe.style.setProperty("--swipe-amount-x", "0px"), (Xt = xt.current) == null || Xt.style.setProperty("--swipe-amount-y", "0px");
      }
      j(!1), se(!1), H(null);
    },
    onPointerMove: (W) => {
      var ue, we, Le;
      if (!Pe.current || !Se || ((ue = window.getSelection()) == null ? void 0 : ue.toString().length) > 0) return;
      const gt = W.clientY - Pe.current.y, _e = W.clientX - Pe.current.x;
      var $e;
      const Qe = ($e = n.swipeDirections) != null ? $e : l8e(R);
      !z && (Math.abs(_e) > 1 || Math.abs(gt) > 1) && H(Math.abs(_e) > Math.abs(gt) ? "x" : "y");
      let Xt = {
        x: 0,
        y: 0
      };
      const Bn = (Zi) => 1 / (1.5 + Math.abs(Zi) / 20);
      if (z === "y") {
        if (Qe.includes("top") || Qe.includes("bottom"))
          if (Qe.includes("top") && gt < 0 || Qe.includes("bottom") && gt > 0)
            Xt.y = gt;
          else {
            const Zi = gt * Bn(gt);
            Xt.y = Math.abs(Zi) < Math.abs(gt) ? Zi : gt;
          }
      } else if (z === "x" && (Qe.includes("left") || Qe.includes("right")))
        if (Qe.includes("left") && _e < 0 || Qe.includes("right") && _e > 0)
          Xt.x = _e;
        else {
          const Zi = _e * Bn(_e);
          Xt.x = Math.abs(Zi) < Math.abs(_e) ? Zi : _e;
        }
      (Math.abs(Xt.x) > 0 || Math.abs(Xt.y) > 0) && j(!0), (we = xt.current) == null || we.style.setProperty("--swipe-amount-x", `${Xt.x}px`), (Le = xt.current) == null || Le.style.setProperty("--swipe-amount-y", `${Xt.y}px`);
    }
  }, ut && !d.jsx && oe !== "loading" ? /* @__PURE__ */ p.createElement("button", {
    "aria-label": $,
    "data-disabled": ot,
    "data-close-button": !0,
    onClick: ot || !Se ? () => {
    } : () => {
      Ae(), d.onDismiss == null || d.onDismiss.call(d, d);
    },
    className: $o(L?.closeButton, d == null || (r = d.classNames) == null ? void 0 : r.closeButton)
  }, (Ge = B?.close) != null ? Ge : K6e) : null, (oe || d.icon || d.promise) && d.icon !== null && (B?.[oe] !== null || d.icon) ? /* @__PURE__ */ p.createElement("div", {
    "data-icon": "",
    className: $o(L?.icon, d == null || (i = d.classNames) == null ? void 0 : i.icon)
  }, d.promise || d.type === "loading" && !d.icon ? d.icon || De() : null, d.type !== "loading" ? et : null) : null, /* @__PURE__ */ p.createElement("div", {
    "data-content": "",
    className: $o(L?.content, d == null || (s = d.classNames) == null ? void 0 : s.content)
  }, /* @__PURE__ */ p.createElement("div", {
    "data-title": "",
    className: $o(L?.title, d == null || (o = d.classNames) == null ? void 0 : o.title)
  }, d.jsx ? d.jsx : typeof d.title == "function" ? d.title() : d.title), d.description ? /* @__PURE__ */ p.createElement("div", {
    "data-description": "",
    className: $o(O, be, L?.description, d == null || (a = d.classNames) == null ? void 0 : a.description)
  }, typeof d.description == "function" ? d.description() : d.description) : null), /* @__PURE__ */ p.isValidElement(d.cancel) ? d.cancel : d.cancel && xg(d.cancel) ? /* @__PURE__ */ p.createElement("button", {
    "data-button": !0,
    "data-cancel": !0,
    style: d.cancelButtonStyle || M,
    onClick: (W) => {
      xg(d.cancel) && Se && (d.cancel.onClick == null || d.cancel.onClick.call(d.cancel, W), Ae());
    },
    className: $o(L?.cancelButton, d == null || (l = d.classNames) == null ? void 0 : l.cancelButton)
  }, d.cancel.label) : null, /* @__PURE__ */ p.isValidElement(d.action) ? d.action : d.action && xg(d.action) ? /* @__PURE__ */ p.createElement("button", {
    "data-button": !0,
    "data-action": !0,
    style: d.actionButtonStyle || k,
    onClick: (W) => {
      xg(d.action) && (d.action.onClick == null || d.action.onClick.call(d.action, W), !W.defaultPrevented && Ae());
    },
    className: $o(L?.actionButton, d == null || (c = d.classNames) == null ? void 0 : c.actionButton)
  }, d.action.label) : null);
};
function $F() {
  if (typeof window > "u" || typeof document > "u") return "ltr";
  const n = document.documentElement.getAttribute("dir");
  return n === "auto" || !n ? window.getComputedStyle(document.documentElement).direction : n;
}
function u8e(n, e) {
  const t = {};
  return [
    n,
    e
  ].forEach((r, i) => {
    const s = i === 1, o = s ? "--mobile-offset" : "--offset", a = s ? r8e : n8e;
    function l(c) {
      [
        "top",
        "right",
        "bottom",
        "left"
      ].forEach((u) => {
        t[`${o}-${u}`] = typeof c == "number" ? `${c}px` : c;
      });
    }
    typeof r == "number" || typeof r == "string" ? l(r) : typeof r == "object" ? [
      "top",
      "right",
      "bottom",
      "left"
    ].forEach((c) => {
      r[c] === void 0 ? t[`${o}-${c}`] = a : t[`${o}-${c}`] = typeof r[c] == "number" ? `${r[c]}px` : r[c];
    }) : l(a);
  }), t;
}
const d8e = /* @__PURE__ */ p.forwardRef(function(e, t) {
  const { id: r, invert: i, position: s = "bottom-right", hotkey: o = [
    "altKey",
    "KeyT"
  ], expand: a, closeButton: l, className: c, offset: u, mobileOffset: d, theme: f = "light", richColors: h, duration: m, style: g, visibleToasts: v = t8e, toastOptions: y, dir: b = $F(), gap: x = s8e, icons: E, containerAriaLabel: w = "Notifications" } = e, [C, S] = p.useState([]), M = p.useMemo(() => r ? C.filter((V) => V.toasterId === r) : C.filter((V) => !V.toasterId), [
    C,
    r
  ]), k = p.useMemo(() => Array.from(new Set([
    s
  ].concat(M.filter((V) => V.position).map((V) => V.position)))), [
    M,
    s
  ]), [_, O] = p.useState([]), [I, R] = p.useState(!1), [P, D] = p.useState(!1), [L, B] = p.useState(f !== "system" ? f : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), $ = p.useRef(null), z = o.join("+").replace(/Key/g, "").replace(/Digit/g, ""), H = p.useRef(null), U = p.useRef(!1), F = p.useCallback((V) => {
    S((X) => {
      var Z;
      return (Z = X.find((ie) => ie.id === V.id)) != null && Z.delete || Oi.dismiss(V.id), X.filter(({ id: ie }) => ie !== V.id);
    });
  }, []);
  return p.useEffect(() => Oi.subscribe((V) => {
    if (V.dismiss) {
      requestAnimationFrame(() => {
        S((X) => X.map((Z) => Z.id === V.id ? {
          ...Z,
          delete: !0
        } : Z));
      });
      return;
    }
    setTimeout(() => {
      gw.flushSync(() => {
        S((X) => {
          const Z = X.findIndex((ie) => ie.id === V.id);
          return Z !== -1 ? [
            ...X.slice(0, Z),
            {
              ...X[Z],
              ...V
            },
            ...X.slice(Z + 1)
          ] : [
            V,
            ...X
          ];
        });
      });
    });
  }), [
    C
  ]), p.useEffect(() => {
    if (f !== "system") {
      B(f);
      return;
    }
    if (f === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? B("dark") : B("light")), typeof window > "u") return;
    const V = window.matchMedia("(prefers-color-scheme: dark)");
    try {
      V.addEventListener("change", ({ matches: X }) => {
        B(X ? "dark" : "light");
      });
    } catch {
      V.addListener(({ matches: Z }) => {
        try {
          B(Z ? "dark" : "light");
        } catch (ie) {
          console.error(ie);
        }
      });
    }
  }, [
    f
  ]), p.useEffect(() => {
    C.length <= 1 && R(!1);
  }, [
    C
  ]), p.useEffect(() => {
    const V = (X) => {
      var Z;
      if (o.every((se) => X[se] || X.code === se)) {
        var J;
        R(!0), (J = $.current) == null || J.focus();
      }
      X.code === "Escape" && (document.activeElement === $.current || (Z = $.current) != null && Z.contains(document.activeElement)) && R(!1);
    };
    return document.addEventListener("keydown", V), () => document.removeEventListener("keydown", V);
  }, [
    o
  ]), p.useEffect(() => {
    if ($.current)
      return () => {
        H.current && (H.current.focus({
          preventScroll: !0
        }), H.current = null, U.current = !1);
      };
  }, [
    $.current
  ]), // Remove item from normal navigation flow, only available via hotkey
  /* @__PURE__ */ p.createElement("section", {
    ref: t,
    "aria-label": `${w} ${z}`,
    tabIndex: -1,
    "aria-live": "polite",
    "aria-relevant": "additions text",
    "aria-atomic": "false",
    suppressHydrationWarning: !0
  }, k.map((V, X) => {
    var Z;
    const [ie, J] = V.split("-");
    return M.length ? /* @__PURE__ */ p.createElement("ol", {
      key: V,
      dir: b === "auto" ? $F() : b,
      tabIndex: -1,
      ref: $,
      className: c,
      "data-sonner-toaster": !0,
      "data-sonner-theme": L,
      "data-y-position": ie,
      "data-x-position": J,
      style: {
        "--front-toast-height": `${((Z = _[0]) == null ? void 0 : Z.height) || 0}px`,
        "--width": `${i8e}px`,
        "--gap": `${x}px`,
        ...g,
        ...u8e(u, d)
      },
      onBlur: (se) => {
        U.current && !se.currentTarget.contains(se.relatedTarget) && (U.current = !1, H.current && (H.current.focus({
          preventScroll: !0
        }), H.current = null));
      },
      onFocus: (se) => {
        se.target instanceof HTMLElement && se.target.dataset.dismissible === "false" || U.current || (U.current = !0, H.current = se.relatedTarget);
      },
      onMouseEnter: () => R(!0),
      onMouseMove: () => R(!0),
      onMouseLeave: () => {
        P || R(!1);
      },
      onDragEnd: () => R(!1),
      onPointerDown: (se) => {
        se.target instanceof HTMLElement && se.target.dataset.dismissible === "false" || D(!0);
      },
      onPointerUp: () => D(!1)
    }, M.filter((se) => !se.position && X === 0 || se.position === V).map((se, te) => {
      var le, de;
      return /* @__PURE__ */ p.createElement(c8e, {
        key: se.id,
        icons: E,
        index: te,
        toast: se,
        defaultRichColors: h,
        duration: (le = y?.duration) != null ? le : m,
        className: y?.className,
        descriptionClassName: y?.descriptionClassName,
        invert: i,
        visibleToasts: v,
        closeButton: (de = y?.closeButton) != null ? de : l,
        interacting: P,
        position: V,
        style: y?.style,
        unstyled: y?.unstyled,
        classNames: y?.classNames,
        cancelButtonStyle: y?.cancelButtonStyle,
        actionButtonStyle: y?.actionButtonStyle,
        closeButtonAriaLabel: y?.closeButtonAriaLabel,
        removeToast: F,
        toasts: M.filter((j) => j.position == se.position),
        heights: _.filter((j) => j.position == se.position),
        setHeights: O,
        expandByDefault: a,
        gap: x,
        expanded: I,
        swipeDirections: e.swipeDirections
      });
    })) : null;
  }));
});
var f8e = ["title"], h8e = ["title"], p8e = ["title"], m8e = ["title"], g8e = ["title"], v8e = ["title"], y8e = ["title"], b8e = ["title"], w8e = ["title"], x8e = ["title"], E8e = ["title"], S8e = ["title"], C8e = ["title"], T8e = ["title"], A8e = ["title"], M8e = ["title"], k8e = ["title"], _8e = ["title"], O8e = ["title"], I8e = ["title"], R8e = ["title"], P8e = ["title"], D8e = ["title"], N8e = ["title"], L8e = ["title"], $8e = ["title"], F8e = ["title"], B8e = ["title"], z8e = ["title"], H8e = ["title"], U8e = ["title"], V8e = ["title"], j8e = ["title"], W8e = ["title"], G8e = ["title"], K8e = ["title"], q8e = ["title"], Y8e = ["title"], X8e = ["title"], Z8e = ["title"], Q8e = ["title"], J8e = ["title"], eCe = ["title"], tCe = ["title"], nCe = ["title"], rCe = ["title"], iCe = ["title"], sCe = ["title"], oCe = ["title"], aCe = ["title"], lCe = ["title"], cCe = ["title"], uCe = ["title"], dCe = ["title"], fCe = ["title"], hCe = ["title"], pCe = ["title"], mCe = ["title"], gCe = ["title"], vCe = ["title"], yCe = ["title"], bCe = ["title"], wCe = ["title"], xCe = ["title"], ECe = ["title"], SCe = ["title"], CCe = ["title"], TCe = ["title"], ACe = ["title"], MCe = ["title"], kCe = ["title"], _Ce = ["title"], OCe = ["title"], ICe = ["title"], RCe = ["title"], PCe = ["title"], DCe = ["title"], NCe = ["title"], LCe = ["title"], $Ce = ["title"], FCe = ["title"], BCe = ["title"], zCe = ["title"], HCe = ["title"], UCe = ["title"], VCe = ["title"], jCe = ["title"], WCe = ["title"], GCe = ["title"], KCe = ["title"], qCe = ["title"], YCe = ["title"], XCe = ["title"], ZCe = ["title"], QCe = ["title"], JCe = ["title"], eTe = ["title"], tTe = ["title"], nTe = ["title"], rTe = ["title"], iTe = ["title"], sTe = ["title"], oTe = ["title"], aTe = ["title"], lTe = ["title"], cTe = ["title"], uTe = ["title"], dTe = ["title"], fTe = ["title"], hTe = ["title"], pTe = ["title"], mTe = ["title"], gTe = ["title"], vTe = ["title"], yTe = ["title"], bTe = ["title"], wTe = ["title"], xTe = ["title"], ETe = ["title"], STe = ["title"], CTe = ["title"], TTe = ["title"], ATe = ["title"], MTe = ["title"], kTe = ["title"], _Te = ["title"], OTe = ["title"], ITe = ["title"], RTe = ["title"], PTe = ["title"], DTe = ["title"], NTe = ["title"], LTe = ["title"], $Te = ["title"], FTe = ["title"], BTe = ["title"], zTe = ["title"], HTe = ["title"], UTe = ["title"], VTe = ["title"], jTe = ["title"], WTe = ["title"], GTe = ["title"], KTe = ["title"], qTe = ["title"], YTe = ["title"], XTe = ["title"], ZTe = ["title"], QTe = ["title"], JTe = ["title"], e7e = ["title"], t7e = ["title"], n7e = ["title"], r7e = ["title"], i7e = ["title"], s7e = ["title"], o7e = ["title"], a7e = ["title"], l7e = ["title"], c7e = ["title"], u7e = ["title"], d7e = ["title"], f7e = ["title"], h7e = ["title"], p7e = ["title"], m7e = ["title"], g7e = ["title"], v7e = ["title"], y7e = ["title"], b7e = ["title"], w7e = ["title"], x7e = ["title"], E7e = ["title"], S7e = ["title"], C7e = ["title"], T7e = ["title"], A7e = ["title"], M7e = ["title"], k7e = ["title"], _7e = ["title"], O7e = ["title"], I7e = ["title"], R7e = ["title"], P7e = ["title"], D7e = ["title"], N7e = ["title"], L7e = ["title"], $7e = ["title"], F7e = ["title"], B7e = ["title"], z7e = ["title"], H7e = ["title"], U7e = ["title"], V7e = ["title"], j7e = ["title"], W7e = ["title"], G7e = ["title"], K7e = ["title"], q7e = ["title"], Y7e = ["title"], X7e = ["title"], Z7e = ["title"], Q7e = ["title"], J7e = ["title"], e9e = ["title"], t9e = ["title"], n9e = ["title"], r9e = ["title"], i9e = ["title"], s9e = ["title"], o9e = ["title"], a9e = ["title"], l9e = ["title"], c9e = ["title"], u9e = ["title"], d9e = ["title"], f9e = ["title"], h9e = ["title"], p9e = ["title"], m9e = ["title"], g9e = ["title"], v9e = ["title"], y9e = ["title"], b9e = ["title"], w9e = ["title"], x9e = ["title"], E9e = ["title"], S9e = ["title"], C9e = ["title"], T9e = ["title"], A9e = ["title"], M9e = ["title"], k9e = ["title"], _9e = ["title"], O9e = ["title"], I9e = ["title"], R9e = ["title"], P9e = ["title"], D9e = ["title"], N9e = ["title"], L9e = ["title"], $9e = ["title"], F9e = ["title"], B9e = ["title"], z9e = ["title"], H9e = ["title"], U9e = ["title"], V9e = ["title"], j9e = ["title"], W9e = ["title"], G9e = ["title"], K9e = ["title"], q9e = ["title"], Y9e = ["title"];
function K() {
  return K = Object.assign || function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, K.apply(this, arguments);
}
function q(n, e) {
  if (n == null) return {};
  var t = X9e(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function X9e(n, e) {
  if (n == null) return {};
  var t = {}, r = Object.keys(n), i, s;
  for (s = 0; s < r.length; s++)
    i = r[s], !(e.indexOf(i) >= 0) && (t[i] = n[i]);
  return t;
}
var Z9e = function(e) {
  var t = e.title, r = q(e, f8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M440.1 181.1c-.1 39.2-6.4 81.4-57.4 101.5-51.1-20.1-57.3-62.3-57.4-101.5h114.8z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#29DBFF",
    d: "M439.6 197.7c-2.8 34.9-12.4 67.4-57 85-44.4-17.6-54.5-51.2-56.9-84.9"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M437.8 214.1c-3.2 24.3-16.7 53.5-55.1 68.6-38.4-15.1-50.5-42.5-55.1-68.4"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#29DBFF",
    d: "M434.2 230.3c-5.7 17.7-19.3 39.4-51.3 52.8-32-12.6-45.2-33.8-51.4-53"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M426.7 246.9c-6.5 11.3-17.7 25.4-44 35.9-27.5-11.5-37.4-25.3-44-36.1"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#29DBFF",
    d: "M412.4 265.1c-8.1 7.2-12 11.2-29.6 17.9-20.1-7.9-22.6-11.6-29.2-17.5"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#5CC85C",
    d: "M383.3 231.6c-.2-.2-27.9 35.7-27.9 35.7-1.8-1.3-10-9.5-13.3-15l41.3-50.1 40.2 49.7c-3.9 6.5-11.4 13.6-13.2 15M382.6 85.3l-26.5 45h53z"
  }), /* @__PURE__ */ p.createElement("ellipse", {
    transform: "rotate(-82.3 291.431 225.686)",
    fill: "#F7A226",
    cx: 291.4,
    cy: 225.7,
    rx: 48.7,
    ry: 15.7
  }), /* @__PURE__ */ p.createElement("ellipse", {
    transform: "rotate(-68.099 303.087 164.67)",
    fill: "#DDC7AB",
    cx: 303.1,
    cy: 164.7,
    rx: 11.7,
    ry: 7.2
  }), /* @__PURE__ */ p.createElement("ellipse", {
    transform: "rotate(-81.738 291.697 271.697)",
    fill: "#DDC7AB",
    cx: 291.7,
    cy: 271.7,
    rx: 11.4,
    ry: 3.3
  }), /* @__PURE__ */ p.createElement("ellipse", {
    transform: "matrix(.9986 -.05353 .05353 .9986 -13.992 16.424)",
    fill: "#DDC7AB",
    cx: 299.6,
    cy: 269.4,
    rx: 3.3,
    ry: 11
  }), /* @__PURE__ */ p.createElement("ellipse", {
    transform: "rotate(-21.518 314.54 201.06)",
    fill: "#DDC7AB",
    cx: 314.5,
    cy: 201.1,
    rx: 4.1,
    ry: 13.7
  }), /* @__PURE__ */ p.createElement("ellipse", {
    transform: "rotate(-21.518 317.511 178.077)",
    fill: "#DDC7AB",
    cx: 317.5,
    cy: 178.1,
    rx: 13.7,
    ry: 4.1
  }), /* @__PURE__ */ p.createElement("ellipse", {
    transform: "rotate(-7.7 473.781 225.857)",
    fill: "#F7A226",
    cx: 473.6,
    cy: 225.9,
    rx: 15.7,
    ry: 48.7
  }), /* @__PURE__ */ p.createElement("ellipse", {
    transform: "rotate(-21.901 462.057 164.866)",
    fill: "#DDC7AB",
    cx: 462,
    cy: 164.9,
    rx: 7.2,
    ry: 11.7
  }), /* @__PURE__ */ p.createElement("ellipse", {
    transform: "rotate(-8.27 473.27 271.908)",
    fill: "#DDC7AB",
    cx: 473.4,
    cy: 271.9,
    rx: 3.3,
    ry: 11.4
  }), /* @__PURE__ */ p.createElement("ellipse", {
    transform: "matrix(.05353 -.9986 .9986 .05353 171.34 719.998)",
    fill: "#DDC7AB",
    cx: 465.5,
    cy: 269.6,
    rx: 11,
    ry: 3.3
  }), /* @__PURE__ */ p.createElement("ellipse", {
    transform: "rotate(-68.482 450.552 201.247)",
    fill: "#DDC7AB",
    cx: 450.6,
    cy: 201.2,
    rx: 13.7,
    ry: 4.1
  }), /* @__PURE__ */ p.createElement("ellipse", {
    transform: "rotate(-68.482 447.58 178.265)",
    fill: "#DDC7AB",
    cx: 447.6,
    cy: 178.3,
    rx: 4.1,
    ry: 13.7
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#B0C6CC",
    d: "M373.3 130.3 356.1 155l17.8 26.1H396l4.7-25.4-5.4-25.4z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
  }));
}, Q9e = function(e) {
  var t = e.title, r = q(e, h8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342zM198.9 113.6H256v64.8h-57.1z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M267.6 113.6v64.7m16.6-64.7v64.7m16.6-64.7v64.7",
    stroke: "#D80027",
    strokeWidth: 7
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M247.4 178.4v64.7m-13.3-64.7v64.7m-13.3-64.6v53.9m-13.7-53.9v47.1",
    stroke: "#D80027",
    strokeWidth: 5
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "m199.9 146 27.6-32.4 28.5 32.3-28.1 32.4z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#BC8B00",
    d: "M182.2 95.9v92.2c0 34.3 27.3 54.2 48.6 64.5-.8 1.4 25.1 8.3 25.1 8.3s25.9-6.9 25.1-8.3c21.4-10.3 48.6-30.1 48.6-64.5V95.9H182.2zm129.9 92.2c0 16.9-10 29.4-32.8 43.9-8.6 5.5-17.5 9-23.3 11-5.8-2-14.7-5.5-23.3-11-22.8-14.5-32.8-28-32.8-43.9v-74.5h112.2v74.5z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M264.4 188.9h29.5v8.6h-29.5zm0 17.6h29.5v8.6h-29.5z"
  }));
}, J9e = function(e) {
  var t = e.title, r = q(e, p8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#009e49",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h171v342H0z"
  }));
}, eAe = function(e) {
  var t = e.title, r = q(e, m8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#DB3E00",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#479900",
    d: "M331 0h182v342H331z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h181.8v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M256 126.7c-19.4 0-35.2 15.8-35.2 35.2v52.8h70.4v-52.8c0-19.5-15.8-35.2-35.2-35.2z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M256 84.3c-47.7 0-86.4 38.7-86.4 86.4S208.3 257 256 257s86.4-38.7 86.4-86.4-38.7-86.3-86.4-86.3zm0 157.7c-39.4 0-71.4-32-71.4-71.4 0-39.4 32-71.4 71.4-71.4 39.4 0 71.4 32 71.4 71.4 0 39.5-32 71.4-71.4 71.4z"
  }));
}, tAe = function(e) {
  var t = e.title, r = q(e, g8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0072c6",
    d: "M88.8 136.5c-2.2 12.9-3.4 26.2-3.4 39.8 0 13.6 1.2 27 3.4 39.8L256 228.3l167.2-12.1c2.2-12.9 3.4-26.2 3.4-39.8s-1.2-27-3.4-39.8"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M423.2 219H88.8c15.8 69.8 84.7 122.3 167.2 122.3S407.4 288.8 423.2 219z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M365.9 136.5H146.1l44.9-21.1-23.9-43.5 48.8 9.4L222 32l34 36.2L290 32l6.1 49.3 48.8-9.4-23.9 43.5z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#ce1126"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M256.5 342 0 0v342z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M513 342V0L256 342z"
  })));
}, nAe = function(e) {
  var t = e.title, r = q(e, v8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#00318b",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M454.8 265.38c7.94-10.93 13.24-24.27 13.24-40.42V104.89a59.754 59.754 0 0 1-36.02 12.01c-19.64 0-37.07-9.43-48.03-24.01-10.95 14.58-28.39 24.01-48.03 24.01-13.52 0-25.99-4.47-36.02-12v120.06c0 16.16 5.3 29.5 13.24 40.42H454.8z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#8DCCFF",
    d: "M310.23 260.98C332.65 296.96 384 309 384 309s51.35-12.04 73.77-48.02H310.23z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D87B00",
    d: "M396.66 172.21c.32 1.42 8.72 10.17 17.56 20.15 1.39 1.57-8.74 12.63-6.91 12.59 4.75-.12 19.27-17.26 19.34 6.65.05 15.94-30 27.51-30 27.51h17.47l.65 14.96s4.97-13.34 7.59-16.57c8.1-9.97 20.18-30.07 34.59-27.1 14.41 2.97-13.66-13.92-13.66-13.92s-5.2-15.19-16.63-16.97c-10.06-1.57-14.29-2.51-26.64-7.3-1.68-.65-3.88-2.32-3.36 0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D87B00",
    d: "M359.69 198.69c1.07-.99 4.46-12.63 8.69-25.28.67-1.99 15.31 1.27 14.35-.3-2.47-4.06-24.58-8.08-3.9-20.08 13.79-8 38.82 12.27 38.82 12.27l-8.72-15.14 12.64-8.03s-14.05 2.35-18.14 1.69c-12.68-2.04-36.13-2.48-40.75-16.45-4.62-13.97-5.25 18.79-5.25 18.79s-10.56 12.08-6.4 22.88c3.66 9.5 4.96 13.64 6.97 26.73.29 1.79-.06 4.53 1.69 2.92z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D87B00",
    d: "M395.67 219.87c-1.39-.43-13.16 2.49-26.22 5.18-2.06.42-6.59-13.88-7.47-12.26-2.27 4.17 5.36 25.31-15.41 13.45-13.84-7.91-8.89-39.73-8.89-39.73l-8.71 15.14-13.29-6.9s9.09 10.96 10.57 14.84c4.6 11.99 16 32.49 6.24 43.49-9.76 11.01 18.88-4.9 18.88-4.9s15.76 3.07 23-5.96c6.38-7.94 9.3-11.14 19.61-19.45 1.43-1.12 3.97-2.19 1.69-2.9z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M256.5 0h-23.1L160 48.9V0H96v48.9L22.6 0H0v22.7l46.1 30.7H0v64h46.1L0 148.1V171h22.6L96 121.8V171h64v-49.2l73.4 49.2h23.1v-22.9l-46.6-30.7h46.6v-64h-46.6l46.6-30.7z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.4H0v32h112V171h32v-69.6h112.5v-32H144z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 171v-11.3l62.5-42.3h22.6L7.3 171zM7.3.1l77.8 53.2H62.5L0 11.1V.1zm249.2 0v11l-63 42.3h-22.6L248.7.1zM248.7 171l-77.8-53.6h22.6l63 42.3V171z"
  }));
}, rAe = function(e) {
  var t = e.title, r = q(e, y8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 60"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#ED2024",
    d: "M0 0h90v60H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#212121",
    d: "M32.5 12.2v16l7.1 2.5-5 4.9 2.4 3 5.3-5.5 1.2 2.3-3 4.9 3.6 5.6-1.8 2.6 2.8 3.6 2.7-3.7-1.5-2.6 3-5.8-2.7-4.6 1.2-2.3 5.2 5.5 2.5-2.9-5.2-5.1 7.2-2.6V12.2l-5.2 1.9-.1 3.8-3.3.3v-2.6l1.7-2.3 5.6-2.2-2.3-.4 1.4-1.2.9.4-.8-1.4L54 9l-1-1.1L47.5 9l1.4 1.1-3.8 4.9-3.8-4.8 1.3-1.1-5-1.2L36.2 9l-1.5-.4-.8 1.4.9-.6 1.6 1.1-2.3.5 5.5 2 1.6 2.3v2.9l-3.3-.3v-3.6z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M26.2 25h6.4v2.5h-6.4zm0-4.1h6.4v2.7h-6.4zm0-4.2h6.4v2.6h-6.4zm0-4h6.4v2.5h-6.4zM57.4 25h6.4v2.5h-6.4zm0-4.1h6.4v2.7h-6.4zm0-4.2h6.4v2.6h-6.4zm0-4h6.4v2.5h-6.4zM53.4 36.1h6.4V38h-6.4zm-23.2 0h6.4V38h-6.4z",
    fill: "#212121"
  }));
}, iAe = function(e) {
  var t = e.title, r = q(e, b8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FF9811",
    d: "M0 228h513v114H0z"
  }));
}, sAe = function(e) {
  var t = e.title, r = q(e, w8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    d: "M0 171h513v171H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v171H0z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFDA44"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "m332.7 135.6 17.5-8.6-7.4-19-18.7 6.2zm-45.6-56 5.5-18.8-19.1-7.2-8 18zm29.4 23.2 12.2-15.3-14.9-13.9-14.2 13.6zm19.4 68.9 19.5-.8v-21.3l-22.9.2zm-12.6 38.1 18.8 5.5 7.3-19-18-8zm-29 32.4 14.9 12.7 14.4-14.4-13.1-14.7zm-47-147.7 9.8 19.9 21.9 3.3-15.9 15.5 3.6 21.9-19.6-10.4-19.7 10.2 3.8-21.9-15.8-15.5 22-3.1z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m250.8 61.3-2.7 18.3c43.1 3.2 77 39.2 77 83.1 0 46-37.3 82.9-83.4 83.4-29.2.3-51.3-14.8-67-33.7l-13.9 12.3c15 19 40.8 39.9 80.9 39.9 56.3 0 101.9-45.6 101.9-101.9.1-53.2-40.7-96.9-92.8-101.4z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#000",
    d: "m291.9 223.4-11.8 14s51.9 38.9 53.6 40.4c1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-2-1.5-51.8-42-51.8-42z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M206.1 157.2c-7.7 10.3-7.5 23.1 2.8 30.9 0 0 135.2 101.5 136.9 103 1.7 1.5 5.2 2 9.1-2.7 3.7-4.5 2.8-8.1.9-9.7-1.9-1.5-149.7-121.5-149.7-121.5zm47.7 99.1 7.3 18.2 19.5-6-4.8-19.1zm-40.4-3.7-2 19.5 20.1 3.6 4.5-19.1zm-35.7-21.2L167.4 248l16.4 12.1 12.5-15.2z"
  })));
}, oAe = function(e) {
  var t = e.title, r = q(e, x8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 744 496"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#3A7DCE",
    d: "M0 0h744v496H0V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#fff",
    d: "m120 125 90 63 54-14 23-81 61-36 92 14 105 55 6 90 34 12v92l-65 115-78 24-72-17 18-30-8-32-10 9-162-25-49-85 20-46-49-62z"
  }));
}, aAe = function(e) {
  var t = e.title, r = q(e, E8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h512v114H0zm0 228h512v114H0z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FFDA44",
    stroke: "#d6ab00",
    strokeWidth: 5,
    cx: 256.5,
    cy: 171,
    r: 40
  }));
}, lAe = function(e) {
  var t = e.title, r = q(e, S8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#10338c",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M513 33 95.3 171 513 310.76V342L0 171 513 0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M513 287.18v24.58L81.72 171 513 30v24.16"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#A2001D",
    d: "m476.98 140.21-21.89 10.68-3.18-15.32 31.19-29.77s-9.42-40.65-13.75-44.98l-112.32 55.82-6.84 36.76-31.9 28.59-.4 34.2 34.29-22.76 67.23-2.66-1.51 38.11h22.23l11.9-44.64 31.55-24.61-6.6-19.42z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#EFC100",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "m317.89 238.41-22.24-11.11 22.24-11.11h144.46v22.22z"
  }));
}, cAe = function(e) {
  var t = e.title, r = q(e, C8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0zm0 228h513v114H0z"
  }));
}, uAe = function(e) {
  var t = e.title, r = q(e, T8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#10338c",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M222.2 170.7c.3-.3.5-.6.8-.9-.2.3-.5.6-.8.9zM188 212.6l11 22.9 24.7-5.7-11 22.8 19.9 15.8-24.8 5.6.1 25.4-19.9-15.9-19.8 15.9.1-25.4-24.8-5.6 19.9-15.8-11.1-22.8 24.8 5.7zm197.9 28.5 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6v12.2l-9.4-7.6-9.5 7.6.1-12.2-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zm-48.6-116 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.9-2.7 9.5-7.5-5.3-10.9L332 136zm48.6-66.2 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.8-2.7 9.5-7.5-5.3-10.9 11.8 2.7zm42.5 49.7 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6V150l-9.4-7.6-9.5 7.6v-12.2l-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zM398 166.5l4.1 12.7h13.3l-10.8 7.8 4.2 12.7-10.8-7.9-10.8 7.9 4.1-12.7-10.7-7.8h13.3z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M254.8 0v30.6l-45.1 25.1h45.1V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9H99v-48.6l-87.4 48.6H-1.2v-30.6L44 115H-1.2V55.7h59.1L-1.2 22.8V0h26.7L99 40.8V0h55.6v48.6L242.1 0z"
  })), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M142.8 0h-32v69.3h-112v32h112v69.4h32v-69.4h112v-32h-112z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "m154.6 115 100.2 55.7v-15.8L183 115z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "m154.6 115 100.2 55.7v-15.8L183 115z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m154.6 115 100.2 55.7v-15.8L183 115zm-83.9 0-71.9 39.9v15.8L99 115z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M99 55.7-1.2 0v15.7l71.9 40z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M99 55.7-1.2 0v15.7l71.9 40z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M99 55.7-1.2 0v15.7l71.9 40zm84 0 71.8-40V0L154.6 55.7z",
    fill: "#D80027"
  }));
}, dAe = function(e) {
  var t = e.title, r = q(e, A8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 363 242"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h363v242H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M57 96.9 14.7 78.2 57 59.6l18.6-42.2 18.6 42.2 42.3 18.6-42.3 18.7-18.6 42.2z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#f30028",
    d: "m75.6 40.6 11.5 26.1 26.1 11.5-26.1 11.5-11.5 26.1-11.5-26.1L38 78.2l26.1-11.5z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 152.2h363v15.7H0zm0 31.4h363v15.7H0z",
    fill: "#FFDA44"
  }));
}, fAe = function(e) {
  var t = e.title, r = q(e, M8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M513 210.9H202.2V342h-79.8V210.9H0v-79.8h122.4V0h79.8v131.1H513v61.2z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M513 149.7v42.6H183.7V342H141V192.3H0v-42.6h141V0h42.7v149.7z"
  }));
}, hAe = function(e) {
  var t = e.title, r = q(e, k8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#ef3340",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#00b5e2",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#509e2f",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M265.6 212.6c-23 0-41.6-18.6-41.6-41.6s18.6-41.6 41.6-41.6c7.2 0 13.9 1.8 19.8 5-9.2-9-21.9-14.6-35.8-14.6-28.3 0-51.2 22.9-51.2 51.2s22.9 51.2 51.2 51.2c13.9 0 26.6-5.6 35.8-14.6-5.9 3.2-12.6 5-19.8 5z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m297.6 142.2 5.5 15.5 14.9-7.1-7.1 14.9 15.5 5.5-15.5 5.5 7.1 14.9-14.9-7.1-5.5 15.5-5.5-15.5-14.9 7.1 7.1-14.9-15.5-5.5 15.5-5.5-7.1-14.9 14.9 7.1z"
  })));
}, pAe = function(e) {
  var t = e.title, r = q(e, _8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#10338C",
    d: "M0 0h513.1v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#F6C500",
    d: "M99.9 0h342v342"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M19.9 21.1 40.3 6.2 60.9 21 54 0H26.7z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M92.3 25.5 84.4 1.3l-7.8 24.2H51.3l20.5 14.8-7.8 24 20.4-14.8L105 64.3l-7.9-24 20.5-14.9z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m136.3 69.2-7.8-24-7.8 24H95.5l20.4 14.9-7.8 24 20.4-14.8 20.6 14.8-7.8-24 20.4-14.9z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m179.4 112.3-7.8-24.1-7.8 24.1h-25.3l20.5 14.9-7.8 24 20.4-14.8 20.6 14.8-7.9-24 20.5-15z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m222.5 155.3-7.8-24-7.8 24h-25.4l20.6 15-7.8 24 20.4-14.9 20.4 14.9-7.8-24 20.6-15z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m265.6 198.4-7.8-24-7.8 24h-25.4l20.6 14.9-7.8 24.1 20.4-14.9 20.4 14.9-7.8-24.2 20.5-14.8z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m308.7 241.5-7.9-24-7.8 24h-25.3l20.5 14.8-7.9 24.2 20.6-14.9 20.4 14.8-7.8-24.1 20.5-14.8z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m351.7 284.6-7.8-24.2-7.8 24.2h-25.3l20.4 14.8-7.8 24.1 20.5-14.9 20.5 14.9-7.8-24.1 20.4-14.8z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m387 303.5-7.9 24.1-25.3.1 19.8 14.3h26.6l19.9-14.4h-25.3z"
  })));
}, mAe = function(e) {
  var t = e.title, r = q(e, O8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#ffc726",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h171v342H0zm342 0h171v342H342z",
    fill: "#00267f"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m325.74 101.02-31.97 12.4c-.68 1.35-5.79 7.54-8.18 53.06h-17.05v-60.42L256 78.68l-12.54 27v60.8H226.4c-2.39-45.53-7.8-52.48-8.47-53.84l-31.68-11.63c.15.31 15.4 31.34 15.4 78.01v12.54h41.81v71.07h25.08v-71.07h41.81v-12.54c0-24.13 4.17-44.02 7.68-56.46 3.82-13.57 7.7-21.49 7.74-21.57l-.03.03z"
  }));
}, gAe = function(e) {
  var t = e.title, r = q(e, I8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#2d6e41",
    d: "M0 85.331h513v342H0z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#F40B32",
    cx: 218.902,
    cy: 256.5,
    r: 115
  }));
}, vAe = function(e) {
  var t = e.title, r = q(e, R8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#fdda25",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#ef3340",
    d: "M342 0h171v342H342z"
  }));
}, yAe = function(e) {
  var t = e.title, r = q(e, P8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#3d944f",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#ef2b2d",
    d: "M0 0h513v171H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "m256 102.6 16.9 52h54.7l-44.2 32.2 16.8 52-44.2-32.1-44.2 32.1 16.8-52-44.2-32.2h54.7z"
  }));
}, bAe = function(e) {
  var t = e.title, r = q(e, D8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#00966e",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#d62612",
    d: "M0 228h513v114H0z"
  }));
}, wAe = function(e) {
  var t = e.title, r = q(e, N8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "m222.8 34.3-85.2 34.2 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.1 85.2 34.1-85.2 34.8H0V0h137.6z"
  }));
}, xAe = function(e) {
  var t = e.title, r = q(e, L8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M215.9 170.7 0 314.6V26.8zM513 26.8v287.8L297.1 170.7z",
    fill: "#47a644"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M513 26.8 296.1 170.7 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M513 26.8 297.1 170.7 513 314.6V342h-40L256 197.4 39 342H0v-27.4l215.9-143.9L0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FFF",
    cx: 251.6,
    cy: 170.7,
    r: 100.2
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m251.4 103.6 7.4 12.9h14.8l-7.4 12.8 7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8H244zm38.8 66.7 7.4 12.9h14.8L305 196l7.4 12.8h-14.8l-7.4 12.9-7.4-12.9h-14.9l7.4-12.8-7.4-12.8h14.9zm-77.2 0 7.4 12.9h14.9l-7.4 12.8 7.4 12.8h-14.9l-7.4 12.9-7.4-12.9h-14.8l7.4-12.8-7.4-12.8h14.8z",
    fill: "#D80027",
    stroke: "#47a644",
    strokeWidth: 3
  }));
}, EAe = function(e) {
  var t = e.title, r = q(e, $8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#008751",
    d: "M0 85.333h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#fcd116",
    d: "M196.666 85.333H513v171H196.666z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#e8112d",
    d: "M196.666 256H513v171H196.666z"
  }));
}, SAe = function(e) {
  var t = e.title, r = q(e, F8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#E6BC00",
    d: "M157.31 199.76s-9.04 43.93-19.31 40.39c-10.62-3.54-17.53-18.76-17.53-18.76l-14.52 21.24s38.18 8.48 41.01 5.47c1.22-1.14 8.21-15.1 10.34-26.05v-22.29zm-56.13 60.57s-2.48 20.18-1.06 22.66c1.24 2.3 39.48 11.33 39.48 11.33s-24.96 16.46-29.74 20.54L91.8 284.94l-.71-24.61h10.09zm11.33-165.69s39.65 41.6 40.36 45.5c.71 3.72-4.25 3.19-4.25 3.19s-44.79-37.53-49.92-41.07c-5.31-3.55 13.81-7.62 13.81-7.62z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#ADADAD",
    d: "M99.41 104.73s16.99-.71 16.64-11.51c-.35-10.62-11.15-14.87-19.12-12.39-7.97 2.3-23.01 13.45-13.63 35.05 9.38 21.42 23.37 29.39 26.2 47.8 0 0-5.46 9.86-19.12.35-16.9-11.77-6.2-38.24-10.44-44.96-4.25-7.08-40.95-38.92-40.95-38.92s-30.24 39.37-18 74.92c16.95 49.21 51.74 31.98 64.61 36.76 0 0-42.13 61.96-49.57 67.09 0 0 24.08 8.32 47.8-18.76 0 0 5.84 9.74 7.08 20.18h10.27c4.78-26.2 51.51-64.26 49.92-82.32-1.77-21.25-49.21-49.39-51.69-73.29z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#E6BC00",
    d: "M359.17 201.27s8.96 42.43 19.23 38.89c10.62-3.54 17.53-18.76 17.53-18.76l14.52 21.24s-37 8.48-39.83 5.47c-1.21-1.14-9.32-13.79-11.52-24.66l.07-22.18zm56.05 59.06s2.48 20.18 1.06 22.66c-1.24 2.3-39.48 11.33-39.48 11.33s24.96 16.46 29.74 20.54l18.06-29.92.71-24.61h-10.09zM403.89 94.64s-39.65 41.6-40.36 45.5c-.71 3.72 4.25 3.19 4.25 3.19s44.79-37.53 49.92-41.07c5.14-3.55-13.81-7.62-13.81-7.62z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#125ECC",
    d: "M157.31 87.06H359.1v145.46c0 16.06-9.69 21.39-21.91 31.85l-45.92 39.41c-18.25 15.62-47.91 15.57-66.07 0l-46.01-39.43c-12.08-10.35-21.88-15.71-21.88-31.82V87.06z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFE600",
    d: "M200.55 147.71c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65-3c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65 3c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zM214.96 274.43c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41c.01 7.96-6.45 14.41-14.41 14.41zm43.24 14.42c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41c0 7.95-6.45 14.41-14.41 14.41zm43.24-14.42c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D60537",
    d: "M157.31 175.36H359.1v57.65H157.31v-57.65z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#EACE00",
    d: "M142.9 43.82s57.65-14.41 115.31-14.41 115.31 14.41 115.31 14.41l-14.41 57.65s-50.45-14.41-100.89-14.41-100.89 14.41-100.89 14.41L142.9 43.82z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#7A6920",
    d: "M258.2 72.65c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm57.65 5c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41zm-115.3 0c-7.96 0-14.41-6.45-14.41-14.41s6.45-14.41 14.41-14.41 14.41 6.45 14.41 14.41-6.45 14.41-14.41 14.41z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#ADADAD",
    d: "M365.08 178.02c-1.59 18.06 45.14 56.12 49.92 82.32h10.27c1.24-10.44 7.08-20.18 7.08-20.18 23.72 27.09 47.8 18.76 47.8 18.76-7.44-5.13-49.57-67.09-49.57-67.09 12.88-4.78 47.67 12.45 64.61-36.76 12.24-35.55-18-74.92-18-74.92s-36.7 31.84-40.95 38.92c-4.25 6.73 6.46 33.2-10.44 44.96-13.66 9.51-19.12-.35-19.12-.35 2.83-18.41 16.82-26.38 26.2-47.8 9.38-21.6-5.66-32.75-13.63-35.05-7.97-2.48-18.76 1.77-19.12 12.39-.35 10.8 16.64 11.51 16.64 11.51-2.48 23.9-49.92 52.04-51.69 73.29z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FFF",
    cx: 258.2,
    cy: 204.19,
    r: 16.93
  }));
}, CAe = function(e) {
  var t = e.title, r = q(e, B8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#c8102e",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#012169",
    d: "M0 .1h256.5v171H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M256 0h-22.6L160 48.9V0H96v48.9L22.6 0H0v22.7l46.1 30.7H0v64h46.1L0 148.1v22.6h22.6L96 121.8v48.9h64v-48.9l73.4 48.9H256v-22.6l-46.1-30.7H256v-64h-46.1L256 22.7z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#c8102e",
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#c8102e",
    d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
  }), /* @__PURE__ */ p.createElement("g", {
    transform: "translate(13 5)"
  }, /* @__PURE__ */ p.createElement("path", {
    fill: "#fff",
    d: "M303.9 94.94v99.69c0 59.81 79.75 99.69 79.75 99.69s79.75-39.88 79.75-99.69V94.94H303.9z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#2F8F22",
    d: "M436.37 254.44H330.93c23.13 25.08 52.72 39.88 52.72 39.88s29.59-14.8 52.72-39.88z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#65B5D2",
    cx: 383.65,
    cy: 214.56,
    r: 39.88
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#c8102e",
    cx: 343.77,
    cy: 194.63,
    r: 19.94
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#c8102e",
    cx: 423.52,
    cy: 194.63,
    r: 19.94
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#c8102e",
    cx: 383.65,
    cy: 154.75,
    r: 19.94
  })));
}, TAe = function(e) {
  var t = e.title, r = q(e, z8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m0 193.74 513 127.19V214.26L0 97.08z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M513 234.26v-86.67L0 20.41v86.67"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#D80027",
    stroke: "#231F20",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M306.4 134.01a50.28 50.28 0 0 1 6.07 24.02c0 21.55-13.51 39.94-32.52 47.19v-59.51c5.7-1.19 10-6.37 10-12.59 6.9 0 12.5-5.75 12.5-12.85h-.42c6.9 0 12.91-5.75 12.91-12.85h-34.99V76.58l-14.99-27.71-15 27.71v30.84h-34.99c0 7.1 6.01 12.85 12.91 12.85h-.42c0 7.1 5.6 12.85 12.5 12.85 0 6.22 4.29 11.4 9.99 12.59v61.37c-22.09-5.39-38.48-25.3-38.48-49.05 0-8.7 2.2-16.88 6.07-24.02-10.96 11.21-17.72 26.53-17.72 43.44 0 34.32 27.82 62.15 62.15 62.15s62.15-27.83 62.15-62.15c0-16.91-6.77-32.24-17.72-43.44z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M198.46 226.81s20.69 27.71 66.5 27.71 66.5-27.71 66.5-27.71l13.47 28.37s-21.03 27.71-79.97 27.71-79.97-27.71-79.97-27.71l13.47-28.37zm-69.22-93.63h20.88l24.93 27.26v73.45h-26.28v-68.37zm270.76 0h-20.88l-24.93 27.26v73.45h26.27v-68.37z"
  })));
}, AAe = function(e) {
  var t = e.title, r = q(e, H8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#d52b1e",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#f9e300",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#007934",
    d: "M0 228h513v114H0z"
  }));
}, MAe = function(e) {
  var t = e.title, r = q(e, U8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#012a87",
    d: "M0 342h513V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#f9d90f",
    d: "M250.4 0H0v166.9z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#dc171d",
    d: "m140.4 118.3 12.2 21.2h24.5l-12.3 21.1 12.3 21.2h-24.5L140.4 203l-12.2-21.2h-24.5l12.3-21.2-12.3-21.1h24.5z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "none",
    stroke: "#000",
    strokeWidth: 9,
    strokeMiterlimit: 10,
    cx: 140.4,
    cy: 160.6,
    r: 57.7
  }));
}, kAe = function(e) {
  var t = e.title, r = q(e, V8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#009b3a",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#fedf00",
    d: "m256.5 19.3 204.9 151.4L256.5 322 50.6 170.7z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FFF",
    cx: 256.5,
    cy: 171,
    r: 80.4
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#002776",
    d: "M215.9 165.7c-13.9 0-27.4 2.1-40.1 6 .6 43.9 36.3 79.3 80.3 79.3 27.2 0 51.3-13.6 65.8-34.3-24.9-31-63.2-51-106-51zm119 20.3c.9-5 1.5-10.1 1.5-15.4 0-44.4-36-80.4-80.4-80.4-33.1 0-61.5 20.1-73.9 48.6 10.9-2.2 22.1-3.4 33.6-3.4 46.8.1 89 19.5 119.2 50.6z"
  }));
}, _Ae = function(e) {
  var t = e.title, r = q(e, j8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#ffc72c",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h513v114H0zm0 228h513v114H0z",
    fill: "#00778b"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M256 171 0 342V0z"
  }));
}, OAe = function(e) {
  var t = e.title, r = q(e, W8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FF7415",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M513 0H0v342"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 42,
    strokeMiterlimit: 10,
    d: "M128.7 255.5s35 54 67.3 32.4c56.9-37.9-68.9-108.6-2.9-152.6 58.3-38.8 76.6 103.5 137.6 62.8 59-39.3-64.7-111.4-9.2-148.4 33.4-22.2 67.1 32.6 67.1 32.6"
  }));
}, IAe = function(e) {
  var t = e.title, r = q(e, G8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 33.333 1100 733.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#ef2b2d",
    d: "M0 0h1100v800H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#fff",
    d: "M300 0h200v800H300z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#fff",
    d: "M0 300h1100v200H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#002868",
    d: "M350 0h100v800H350z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#002868",
    d: "M0 350h1100v100H0z"
  }));
}, RAe = function(e) {
  var t = e.title, r = q(e, K8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 238h513v104H0zM0 0h513v104H0z",
    fill: "#6da9d2"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 125.5h513v89.656H0z"
  }));
}, PAe = function(e) {
  var t = e.title, r = q(e, q8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#007C30",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#CE1720",
    d: "M0 230h513V0H0"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M100 230V0H0v342h513-413z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M28 159.6 8.6 128.2 28 97.4l19.3 30.8zm44.6 0-19.3-31.4 19.3-30.8L92 128.2zM28 241.2 8.6 209.8 28 179l19.3 30.8zm44.6 0-19.3-31.4L72.6 179 92 209.8z",
    fill: "#CE1720"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m28 73.8-16.1-26L28 22.2l16 25.6zm44.6 0-16-26 16-25.6 16.1 25.6zM28 318l-16.1-26.1L28 266.3l16 25.6zm44.6 0-16-26.1 16-25.6 16.1 25.6z",
    fill: "none",
    stroke: "#CE1720",
    strokeWidth: 7
  }));
}, DAe = function(e) {
  var t = e.title, r = q(e, Y8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#003e87",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FFF",
    cx: 260.9,
    cy: 170.9,
    r: 118.9
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "none",
    stroke: "#6DA544",
    strokeWidth: 18,
    strokeMiterlimit: 10,
    cx: 261.9,
    cy: 173.1,
    r: 94.5
  }), /* @__PURE__ */ p.createElement("g", {
    stroke: "#000"
  }, /* @__PURE__ */ p.createElement("path", {
    fill: "#003e87",
    d: "m261.9 151.5-50.6 23.4v20c0 11.8 6.1 22.8 16.2 28.9L262 239l34.5-15.2c10-6.2 16.2-17.1 16.2-28.9v-20l-50.8-23.4z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M211.3 128.1h101.3v46.7H211.3z"
  })), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h513v35H0zm0 306h513v35H0z",
    fill: "#ce1127"
  }));
}, NAe = function(e) {
  var t = e.title, r = q(e, X8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h142v342H0zm371 0h142v342H371zm-64.5 206 50.4-25.2-25.2-12.6V143l-50.4 25.2 25.2-50.4h-25.2L256.1 80l-25.2 37.8h-25.2l25.2 50.4-50.4-25.2v25.2l-25.2 12.6 50.4 25.2-12.6 25.2h50.4V269h25.2v-37.8h50.4z",
    fill: "red"
  }));
}, LAe = function(e) {
  var t = e.title, r = q(e, Z8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "green",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m422.7 252.4 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.2V301l-11.1-8.9-11.1 8.9v-14.2l-13.8-3.2 11.1-8.8-6.2-12.8 13.9 3.2zm-46.6-136.3 6.2 12.9 13.8-3.2-6.2 12.8 11.2 8.8-13.9 3.1v14.3l-11.1-8.9-11.1 8.9.1-14.3-13.9-3.1 11.1-8.8-6.2-12.8L370 129zm37-77.8 6.2 12.8 13.8-3.2-6.2 12.8 11.2 8.9-13.9 3.1v14.2L413.1 78 402 86.9l.1-14.2-13.9-3.1 11.1-8.9-6.2-12.8 13.9 3.2zm51.8 58.4 6.2 12.8 13.9-3.2-6.3 12.8 11.2 8.9-13.9 3.1.1 14.2-11.2-8.9-11.1 8.9.1-14.2L440 128l11.2-8.9-6.3-12.8 13.9 3.2zm-28 68.1 4.9 14.8h15.6l-12.6 9.2 4.8 14.9-12.7-9.2-12.6 9.2 4.8-14.9-12.6-9.2h15.6zM306.8 254.7c-49.2 0-89.1-39.9-89.1-89.1s39.9-89.1 89.1-89.1c15.3 0 29.8 3.9 42.4 10.7C329.4 67.9 302.3 56 272.5 56c-60.5 0-109.6 49.1-109.6 109.6S212 275.3 272.5 275.3c29.8 0 56.9-11.9 76.6-31.3-12.6 6.8-27 10.7-42.3 10.7zM140.4 59.5C129.7 41 109.7 28.6 86.8 28.6S44 41 33.3 59.5h107.1zm.2.4-53.8 53.8-53.7-53.8C28 68.9 25 79.3 25 90.5c0 34.2 27.7 61.9 61.9 61.9s61.9-27.7 61.9-61.9c-.1-11.2-3.1-21.6-8.2-30.6z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#A2001D",
    d: "M71.4 98.2v52.2c4.9 1.3 10.1 1.9 15.5 1.9s10.5-.7 15.5-1.9V98.2h-31z"
  }));
}, $Ae = function(e) {
  var t = e.title, r = q(e, Q8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M513 66.9V0H411.7L0 274.4V342h100.3z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M513 0v40.1L60.2 342H0v-40.8L451.8 0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "m93.6 31.2 16.3 50.4H163l-42.9 31.2 16.4 50.5-42.9-31.2-43 31.2L67 112.8 24.1 81.6h53.1z"
  }));
}, FAe = function(e) {
  var t = e.title, r = q(e, J8e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#d21034",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 171h211.5v85.3H0zm300.5 0H512v85.3H300.5z",
    fill: "#3a9927"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#003082",
    d: "M0 0v85.3h211.5V0h89v85.3H513V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M300.5 85.3H512v85.3H300.5zM0 85.3h211.5v85.3H0z",
    fill: "#FFF"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M300.5 342h-89v-86H0v86h513v-86H300.5zM105.7 8.6l8.6 26.2h27.5L119.5 51l8.6 26.2L105.7 61 83.4 77.2 91.9 51 69.6 34.8h27.6z",
    fill: "#ffce00"
  }));
}, BAe = function(e) {
  var t = e.title, r = q(e, eCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#da1a35",
    d: "M0 85.331h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#009543",
    d: "M443.726 85.331 102.4 426.657H0V85.331z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#fbde4a",
    d: "M500.124 85.331 158.798 426.657H11.876L353.202 85.331z"
  }));
}, zAe = function(e) {
  var t = e.title, r = q(e, tCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "red",
    d: "M0 85.337h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M356.174 222.609h-66.783v-66.783h-66.782v66.783h-66.783v66.782h66.783v66.783h66.782v-66.783h66.783z"
  }));
}, HAe = function(e) {
  var t = e.title, r = q(e, nCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#009e60",
    d: "M342 0h171v342H342z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#f77f00",
    d: "M0 0h171v342H0z"
  }));
}, UAe = function(e) {
  var t = e.title, r = q(e, rCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#01237a",
    d: "M0 85.332h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m384 156.705 5.283 16.254h17.089l-13.826 10.045 5.281 16.254L384 189.211l-13.825 10.047 5.28-16.254-13.825-10.045h17.089zm-70.209 29.081 15.228 7.758 12.084-12.083-2.673 16.879 15.227 7.759-16.879 2.673-2.674 16.88-7.76-15.227-16.878 2.673 12.086-12.084zm-29.081 70.209 16.254-5.281.001-17.089 10.044 13.825 16.254-5.282-10.046 13.827 10.046 13.826-16.254-5.28-10.044 13.825v-17.09zm29.081 70.209 7.759-15.229-12.084-12.084 16.881 2.674 7.757-15.227 2.674 16.879 16.879 2.672-15.227 7.759 2.673 16.882-12.084-12.087zM384 355.284l-5.281-16.253h-17.091l13.827-10.045-5.28-16.254L384 322.776l13.827-10.044-5.281 16.254 13.826 10.045h-17.089zm70.209-29.08-15.229-7.758-12.083 12.084 2.673-16.882-15.227-7.756 16.879-2.675 2.675-16.879 7.756 15.227 16.881-2.674-12.086 12.085zm29.081-70.209-16.254 5.281v17.09l-10.045-13.826-16.254 5.281 10.046-13.826-10.046-13.827 16.254 5.282 10.045-13.825v17.089zm-29.081-70.207-7.757 15.226 12.082 12.084-16.881-2.673-7.756 15.227-2.675-16.88-16.879-2.675 15.227-7.757-2.673-16.878 12.084 12.082zM0 186.665v16h46.069L0 233.377v7.539l57.377-38.252H80L0 255.998h112v-69.334H0zm96 69.331H22.628L96 207.083v48.913zm80-117.331 80-53.334H144v69.334h112v-16h-46.069L256 107.951v-7.539l-57.377 38.251H176v.002zm-16-53.332h73.372L160 134.246V85.333zm-16 170.665h112l-80-53.334h22.623L256 240.917v-7.539l-46.069-30.713H256v-16H144v69.333zm16-48.915 73.372 48.913H160v-48.913zM112 85.331H0l80 53.334H57.377L0 100.413v7.539l46.069 30.712H0v16h112V85.331zm-16 48.915L22.628 85.333H96v48.913z",
    fill: "#FFF"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M144 85.331h-32v69.334H0v32h112v69.333h32v-69.333h112v-32H144z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M80 138.665 0 85.331v15.082l57.377 38.252zm96 0h22.623L256 100.413V85.331zm-118.623 64L0 240.917v15.081l80-53.333zm118.623 0 80 53.333v-15.081l-57.377-38.252z"
  })));
}, VAe = function(e) {
  var t = e.title, r = q(e, iCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M196 0h317v171H196z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0037A1",
    d: "M0 0h196v171H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M98 24.5 113.1 71H162l-39.6 28.7 15.2 46.5L98 117.5l-39.6 28.7 15.2-46.5L34 71h48.9z"
  }));
}, jAe = function(e) {
  var t = e.title, r = q(e, sCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#ce1126",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#007a5e",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M342 0h171v342H342zm-86 102.2 17.2 53H329L283.9 188l17.2 53-45.1-32.7-45.1 32.7 17.2-53-45.1-32.8h55.8z",
    fill: "#fcd116"
  }));
}, WAe = function(e) {
  var t = e.title, r = q(e, oCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m226.8 239.2-9.7-15.6-17.9 4.4 11.9-14.1-9.7-15.6 17.1 6.9 11.8-14.1-1.3 18.4 17.1 6.9-17.9 4.4zM290.6 82l-10.1 15.4 11.6 14.3-17.7-4.8-10.1 15.5-1-18.4-17.7-4.8 17.2-6.6-1-18.4 11.6 14.3zm-54.4-56.6-2 18.3 16.8 7.6-18 3.8-2 18.3-9.2-16-17.9 3.8 12.3-13.7-9.2-15.9 16.8 7.5zm56.6 136.4-14.9 10.9 5.8 17.5-14.9-10.8-14.9 11 5.6-17.6-14.9-10.7 18.4-.1 5.6-17.6 5.8 17.5zM115 46.3l17.3 53.5h56.2l-45.4 32.9 17.3 53.5-45.4-33-45.5 33 17.4-53.5-45.5-32.9h56.3z",
    fill: "#FFDA44"
  }));
}, GAe = function(e) {
  var t = e.title, r = q(e, aCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 256.5h513V342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 171h513v85.5H0z"
  }));
}, KAe = function(e) {
  var t = e.title, r = q(e, lCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 285h513v57H0zM0 0h513v57H0z"
  }));
}, qAe = function(e) {
  var t = e.title, r = q(e, cCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FF9811",
    d: "M0-40.8v422.9-211.4z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h513v68.3H0zm0 136.5h513v68.3H0zm0 136.6h513v68.3H0z",
    fill: "#0052B4"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M256 170.7 0 342V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "m86.5 111.4 12.7 39.2h41.3l-33.4 24.2 12.8 39.3-33.4-24.2-33.4 24.2 12.8-39.3-33.4-24.2h41.2z"
  }));
}, YAe = function(e) {
  var t = e.title, r = q(e, uCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#003893",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#cf2027",
    d: "M0 182.2h513v41.4H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 140.8h513v41.4H0zm0 82.8h513V265H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m150.4 70 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13.1-17.9 13.1 6.8-21.1-17.9-13.1h22.2zm0 209.7 6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13h22.2zm-97.6-70.9 6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-17.9-13H46zM90.1 91l6.9 21.1h22.2l-18 13 6.9 21.2-18-13.1-17.9 13.1 6.8-21.2-18-13h22.3zm-66.3 71H46l6.8-21.1 6.9 21.1h22.2l-18 13.1 6.9 21.1-18-13-17.9 13 6.8-21.1zm48.4 148.9 6.8-21.1-18-13h22.3l6.8-21.2 6.9 21.2h22.2l-18 13 6.9 21.1-18-13zM248 208.8l-6.9 21.1h-22.2l18 13-6.9 21.2 18-13.1 18 13.1-6.9-21.2 18-13h-22.2zM210.7 91l-6.8 21.1h-22.2l17.9 13-6.8 21.2 17.9-13.1 18 13.1-6.9-21.2 18-13h-22.2zm66.4 71h-22.2l-6.9-21.1-6.9 21.1h-22.2l18 13.1-6.9 21.1 18-13 18 13-6.9-21.1zm-48.4 148.9-6.9-21.1 18-13h-22.2l-6.9-21.2-6.8 21.2h-22.2l17.9 13-6.8 21.1 17.9-13z",
    fill: "#f7d116",
    stroke: "#000"
  }));
}, XAe = function(e) {
  var t = e.title, r = q(e, dCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#002b7f",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#f9e814",
    d: "M0 233.5h513v51H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m168.7 86.5 12.9 39.8h41.8l-33.8 24.5 12.9 39.7-33.8-24.5-33.8 24.5 12.9-39.7-33.8-24.5h41.8zm-83.3-54 7.8 23.9h25L97.9 71.1l7.8 23.8-20.3-14.7-20.3 14.7 7.8-23.8-20.3-14.7h25.1z",
    fill: "#FFF"
  }));
}, ZAe = function(e) {
  var t = e.title, r = q(e, fCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0021ad",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#1c8a42",
    d: "M0 0h513v342"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m77.6 272 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9V317l-10.3-8.3-10.2 8.3v-13.2l-12.8-2.9 10.3-8.1-5.8-11.9 12.9 3zm-37.1-98.9 5.7 11.9 12.8-3-5.7 11.8 10.3 8.2-12.9 2.9.1 13.2-10.3-8.3-10.3 8.3.1-13.2-12.9-2.9 10.4-8.2L22 182l12.8 3zm37.1-80.9 5.7 11.8 12.8-2.9-5.7 11.8 10.3 8.2-12.8 2.9v13.1l-10.3-8.2-10.2 8.2V124l-12.8-2.9 10.3-8.2-5.8-11.8L72 104zm46.1 62.9 5.7 11.9 12.8-3-5.7 11.9 10.3 8.1-12.8 2.9v13.2l-10.3-8.2-10.2 8.2v-13.2l-12.8-2.9 10.3-8.1-5.7-11.9 12.8 3zm-32.9 54 4.4 13.7h14.5L98 231.3l4.5 13.7-11.7-8.4-11.7 8.4 4.5-13.7-11.7-8.5h14.4z",
    fill: "#FFF"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#ffc639",
    cx: 267.1,
    cy: 170.7,
    r: 74.5
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#1c8a42",
    d: "M267.1 220.3h24.8s10.8-19 0-37.2l24.8-24.8-12.4-24.8h-12.4s-6.2 18.6-31 18.6-31-18.6-31-18.6h-12.4l12.4 24.8-12.4 24.8 12.4 12.4s12.4-24.8 37.2-12.4c0 0 10.5 15.5 0 37.2z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#ffc639",
    d: "M464.4 92.2c.6-2.9-.2-17.6-.2-20.7 0-21.3-13.9-39.4-33.2-45.7 5.9 12 9.2 25.4 9.2 39.7 0 4.8-.4 9.5-1.1 14.1-2.9-4.7-6.6-8.9-11.2-12.6-17.1-13.6-40.6-14-57.9-2.5 13.4 2.9 26.3 8.9 37.7 18 9 7.1 16.2 16.8 21.7 26.1 0 0-17.8 10.9-31 15.1s-42.3 7.9-42.3 7.9c72 12 132-36 132-36-6.5-13.4-15.8-4-23.7-3.4z"
  }));
}, QAe = function(e) {
  var t = e.title, r = q(e, hCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#DB7D00",
    d: "M141.7 154.7s.2 67.1 74.7 65.3l4.5 13.9h8.9s-7.4-41.1 60.1-41.5c0 0 0-27.6 27.6-27.6H359s-66-51.8 58.9-118l1.8-13.1s-129.9 71-198.9 57.2c0 0 10.7 42.5-10.8 42.5-10.8 0-9.7-8.1-32.3-8.1-18.7 0-17.3 19.7-26.3 19.5-8.9-.2-18.8-12.3-19.6-10.2-.7 2.1 9.9 20.1 9.9 20.1z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#006651"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M237.2 308.1c6.9-5 13-6.6 22.4-8.3s19.4-4.4 24.6-5.8-17.7 6.6-23.5 8.3c-5.8 1.6-23.5 5.8-23.5 5.8zm37.9-14.7c-1.9-11.9 2.8-24.3 13.5-29.3 2.5 8.6-5.2 23.2-13.5 29.3zm18.2-6.2c-5.8-9.8 4-22.6 11.1-28.8 3.3 6-2.5 23.7-11.1 28.8zm16.9-7.6c-6.2-8.4 1.1-23.2 8.8-29 3.1 8.2.1 23.2-8.8 29zm16.9-10.6c-5.6-8-1.7-20.4 6.3-28.4 5.8 6.6.9 21-6.3 28.4zm13.5-10.7c-4.7-7.5 1.1-25.4 8.6-30.4 3.3 6.6.8 25.4-8.6 30.4zm10.8-2.8c-1.4-10.8 17.4-22.7 25.2-22.4-.9 8.9-8.9 18.6-25.2 22.4zm-10.5 12.2c8.8-9.1 26-9.1 32.1-7.2-1.7 5.3-21.9 16.9-32.1 7.2z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M328.7 276.8c12.4-3.3 20.5-6.1 27.9 1.7-5.2 6.6-25.4 4.7-27.9-1.7zm-17.7 8c11.9-6.4 26.3 3 28.5 8.6-13.3 5.5-28.7-7.2-28.5-8.6zm-16.3 9.2c10.8-4.1 23.2 1.4 28.2 7.5-5.8 2.7-21 5.7-28.2-7.5zm-14.9 4.7c12.4-1.4 24.4 8 27 13.4-15.9 1.5-22-3.2-27-13.4zm-4 9.4c-6.9-5-13-6.6-22.4-8.3-9.4-1.7-19.4-4.4-24.6-5.8-5.3-1.4 17.7 6.6 23.5 8.3 5.8 1.6 23.5 5.8 23.5 5.8zm-37.9-14.7c1.9-11.9-2.8-24.3-13.5-29.3-2.5 8.6 5.2 23.2 13.5 29.3zm-18.2-6.2c5.8-9.8-4-22.6-11.1-28.8-3.3 6 2.5 23.7 11.1 28.8zm-16.9-7.6c6.2-8.4-1.1-23.2-8.8-29-3.1 8.2-.1 23.2 8.8 29zM185.9 269c5.6-8 1.7-20.4-6.3-28.4-5.8 6.6-.9 21 6.3 28.4zm-13.5-10.7c4.7-7.5-1.1-25.4-8.6-30.4-3.3 6.6-.8 25.4 8.6 30.4zm-10.8-2.8c1.4-10.8-17.4-22.7-25.2-22.4.9 8.9 8.9 18.6 25.2 22.4zm10.5 12.2c-8.8-9.1-26-9.1-32.1-7.2 1.7 5.3 21.9 16.9 32.1 7.2z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M184.3 276.8c-12.4-3.3-20.5-6.1-27.9 1.7 5.2 6.6 25.4 4.7 27.9-1.7zm17.7 8c-11.9-6.4-26.3 3-28.5 8.6 13.3 5.5 28.7-7.2 28.5-8.6zm16.3 9.2c-10.8-4.1-23.2 1.4-28.2 7.5 5.8 2.7 21 5.7 28.2-7.5zm14.9 4.7c-12.4-1.4-24.4 8-27 13.4 15.9 1.5 22-3.2 27-13.4z"
  })));
}, JAe = function(e) {
  var t = e.title, r = q(e, pCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#11457e",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#d7141a",
    d: "M513 171v171H0l256.5-171z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M513 0v171H256.5L0 0z"
  }));
}, eMe = function(e) {
  var t = e.title, r = q(e, mCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 228h513v114H0z"
  }));
}, tMe = function(e) {
  var t = e.title, r = q(e, gCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#12ad2b",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6ab2e7",
    d: "M513 0v166.7L0 170.8V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M256 170.7 0 342V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#d7141a",
    d: "m89.8 92.5 17 52.4H162l-44.6 32.5 17 52.4-44.6-32.4-44.6 32.4 17-52.4-44.6-32.5h55.2z"
  }));
}, nMe = function(e) {
  var t = e.title, r = q(e, vCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#c60c30",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M190 0h-60v140H0v60h130v142h60V200h323v-60H190z"
  }));
}, rMe = function(e) {
  var t = e.title, r = q(e, yCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#496E2D",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 110.7v120h513v-120z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 110.7h513v40H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 190.7h513v40H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M196 0h120v342H196z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M196 0h40v342h-40z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M274.7 0h40v342h-40z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#D80027",
    cx: 256,
    cy: 170.7,
    r: 123.1
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m256 58.6 4.6 14.2h15l-12.1 8.9 4.6 14.2-12.1-8.8-12.1 8.8 4.6-14.2-12.1-8.9h15zM190.1 80l12.2 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15l-4.6 14.2-4.7-14.2h-15l12.1-8.8zm-40.7 56h15l4.6-14.2 4.7 14.2h15l-12.2 8.8 4.7 14.3-12.2-8.8-12.1 8.8 4.6-14.3zm0 69.3 12.1-8.8-4.6-14.3L169 191l12.2-8.8-4.7 14.3 12.2 8.8h-15l-4.7 14.3-4.6-14.3zm40.7 56.1 4.6-14.3-12.1-8.8h15l4.7-14.3 4.6 14.3h15l-12.1 8.8 4.6 14.3-12.1-8.9zm65.9 21.4-4.6-14.3h-15l12.1-8.8-4.6-14.3 12.1 8.8 12.1-8.8-4.6 14.3 12.1 8.8h-15zm65.9-21.4-12.2-8.9-12.1 8.9 4.6-14.3-12.1-8.8h15l4.6-14.3 4.7 14.3h15l-12.1 8.8zm40.7-56.1h-15l-4.6 14.3-4.7-14.3h-15l12.2-8.8-4.7-14.3L343 191l12.1-8.8-4.6 14.3zm0-69.3-12.1 8.8 4.6 14.3-12.1-8.8-12.2 8.8 4.7-14.3-12.2-8.8h15l4.7-14.2 4.6 14.2zm-40.7-56-4.6 14.3 12.1 8.8h-15l-4.7 14.2-4.6-14.2h-15l12.1-8.8-4.6-14.3 12.1 8.8zM279.3 168.7c-11-21.1-14.5-25.1-14.5-25.1s.4-9.7.4-15.6c0-8.8-7.4-15.8-16.5-15.8-8.6 0-15.7 2.9-16.5 11-4.2.9-8.6 4.1-8.6 10.7 0 4.8 1 7.3 5.2 9.3 2.1-4.6 4.3-4.8 9.3-6.4.8.6 1.7 3 2.6 3.4l.3 1s-13.3 6.6-13.3 30.9c0 29.5 22 45.4 22 45.4l-1.8.3-1.9 7.1h22v-7.2l11 17.5c.3-.3 10.2-47.6.3-66.5z",
    fill: "#496E2D"
  }));
}, iMe = function(e) {
  var t = e.title, r = q(e, bCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 216h211v126H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h211v126H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M302 0h211v126H302z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M302 216h211v126H302z"
  }), /* @__PURE__ */ p.createElement("g", {
    stroke: "#FFF",
    strokeWidth: 5,
    strokeMiterlimit: 10
  }, /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M256 130h-49.9v49.4s19.5 6 49.9 6V130z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M206.1 179.4v6c0 27.5 22.3 49.9 49.9 49.9v-49.9c-30.4 0-49.9-6-49.9-6z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M256 235.3c27.5 0 49.9-22.3 49.9-49.9v-6s-19.5 6-49.9 6v49.9z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M256 130v55.4c30.4 0 49.9-6 49.9-6V130H256z"
  })));
}, sMe = function(e) {
  var t = e.title, r = q(e, wCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#41662E",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M256.5 0H513v342H256.5z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "m341.5 105.3-29.4 40.4-47.5-15.4 29.4 40.4-29.4 40.4 47.5-15.4 29.4 40.4v-50l47.5-15.5-47.5-15.4z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M309.9 276.7c-58.5 0-106-47.5-106-106s47.5-106 106-106c18.3 0 35.4 4.6 50.4 12.7-23.5-23-55.7-37.2-91.2-37.2-72 0-130.4 58.4-130.4 130.4S197.1 301 269.1 301c35.5 0 67.7-14.2 91.2-37.2-14.9 8.2-32.1 12.9-50.4 12.9z"
  })));
}, oMe = function(e) {
  var t = e.title, r = q(e, xCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 170.7h513V256H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 256h513v85.3H0z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FFDA44",
    cx: 256,
    cy: 171,
    r: 60
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#4C1F00",
    d: "M369.2 79.9s-27.2-13.8-33.9-16c-6.7-2.2-49.1-13.2-49.1-7 0 10.3-13.5 12-15.5 12s-2-5.3-14.8-5.3-13.7 4.8-15.8 4.8c-2.2 0-14.5-1-14.5-11.5 0-5.2-42.9 4-49.1 7-6.1 3.1-33.9 16-33.9 16s45.8 2.7 53.9 6.2 43.8 16.5 43.8 16.5l-2.8 13.3h37.8l-3.8-13.3s35.1-12.7 43.8-16.5 53.9-6.2 53.9-6.2z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#57BA17",
    d: "M217.7 171.7c0 21.1 17.2 38.3 38.3 38.3 21.1 0 38.3-17.2 38.3-38.3v-11.5h-76.5v11.5z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M256 110.5c-21.1 0-38.3 17.2-38.3 38.3v11.5h76.5v-11.5c.1-21.1-17.1-38.3-38.2-38.3z"
  }));
}, aMe = function(e) {
  var t = e.title, r = q(e, ECe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#111",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#368FD8",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 228h513v114H0z"
  }));
}, lMe = function(e) {
  var t = e.title, r = q(e, SCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#C09300",
    d: "M220.3 204.4s0-58.4 4.5-64.7c3.1-4.3 16.8 5.2 22.7 4.5 0 0 4.2-7.5 4.5-12 .3-4.6-1.1-7.6-4.9-6.2 0 0-1.2-2.1.5-3.3 1.6-1.2 5.6.1 5.6.1s-.5-1 1.6-.9c2.9.2 7.2 1.4 7.4 5.6.2 3.1.3 7.7.4 8.7.7 6.8 2.7 8.7 2.7 8.7s18.4-9.2 22-5.2c3.3 3.8 4.5 64.7 4.5 64.7l-18.1-16.8 12.1 29.5s-14.4 2.4-28.9 2.4c-14.5 0-31.1-4.2-31.1-4.2l13.8-28.2-19.3 17.3z"
  }));
}, cMe = function(e) {
  var t = e.title, r = q(e, CCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#428823",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M256 171 0 342V0zm53.1 0c0-22.9 13.1-42.1 34.6-46.8-3.3-.7-6.7-1.1-10.3-1.1-26.4 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9c3.5 0 7-.4 10.3-1.1-21.5-5.1-34.6-24.2-34.6-46.8z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m365 129.2 10.3 31.7h33.3l-27 19.6 10.3 31.7-26.9-19.6-27 19.6 10.3-31.7-27-19.6h33.4z"
  })));
}, uMe = function(e) {
  var t = e.title, r = q(e, TCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#56AF35",
    d: "M0 0h513v171H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "m0 342 513-171L0 0v342z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#ffc945"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M134.7 231.5c33.6 0 60.8-27.2 60.8-60.8s-27.2-60.8-60.8-60.8-60.8 27.2-60.8 60.8 27.2 60.8 60.8 60.8zm0 24.3c-47 0-85.2-38.1-85.2-85.2s38.1-85.2 85.2-85.2 85.2 38.1 85.2 85.2-38.2 85.2-85.2 85.2z"
  }), /* @__PURE__ */ p.createElement("circle", {
    cx: 119.5,
    cy: 148.3,
    r: 17.5
  }), /* @__PURE__ */ p.createElement("circle", {
    cx: 148.9,
    cy: 158.5,
    r: 17.5
  }), /* @__PURE__ */ p.createElement("circle", {
    cx: 134.7,
    cy: 135.2,
    r: 17.5
  }), /* @__PURE__ */ p.createElement("circle", {
    cx: 119.5,
    cy: 172.7,
    r: 17.5
  }), /* @__PURE__ */ p.createElement("circle", {
    cx: 149.9,
    cy: 182.8,
    r: 17.5
  }), /* @__PURE__ */ p.createElement("circle", {
    cx: 122.5,
    cy: 198,
    r: 17.5
  }), /* @__PURE__ */ p.createElement("circle", {
    cx: 145.9,
    cy: 205.2,
    r: 17.5
  })));
}, dMe = function(e) {
  var t = e.title, r = q(e, ACe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h22.5v15H0V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D03433",
    d: "M0 0h22.5v4H0V0zm0 11h22.5v4H0v-4z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FBCA46",
    d: "M0 4h22.5v7H0V4z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M7.8 7h1v.5h-1V7z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#A41517",
    d: "M7.2 8.5c0 .3.3.5.6.5s.6-.2.6-.5L8.5 7H7.1l.1 1.5zM6.6 7c0-.3.2-.5.4-.5h1.5c.3 0 .5.2.5.4V7l-.1 1.5c-.1.6-.5 1-1.1 1-.6 0-1-.4-1.1-1L6.6 7z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#A41517",
    d: "M6.8 7.5h2V8h-.5l-.5 1-.5-1h-.5v-.5zM5.3 6h1v3.5h-1V6zm4 0h1v3.5h-1V6zm-2.5-.5c0-.3.2-.5.5-.5h1c.3 0 .5.2.5.5v.2c0 .2-.1.3-.3.3H7c-.1 0-.2-.1-.2-.2v-.3z"
  }));
}, fMe = function(e) {
  var t = e.title, r = q(e, MCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#20AA46",
    d: "M0 0h22.5v5H0V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#E92F3B",
    d: "M0 10h22.5v5H0v-5z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FADF50",
    d: "M0 5h22.5v5H0V5z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#205CCA",
    cx: 11.3,
    cy: 7.5,
    r: 5.2
  }), /* @__PURE__ */ p.createElement("g", {
    stroke: "#FFDB3D",
    fill: "none"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "m11.3 8.8-2.1 1.5.8-2.4-2-1.5h2.5l.8-2.3.8 2.3h2.6l-2.1 1.5.8 2.4-2.1-1.5zm-1-2.4h1.9M9.9 7.8l1.3 1m.8-2.6.7 1.8M10 7.9l.6-1.8M11 9l1.6-1.1",
    strokeWidth: 0.5
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m8.7 3.9 1.1 1.6m4-1.7-1 1.6m-1.5 4.7V12M8.9 8.3 7.1 9m8.4 0-1.8-.7",
    strokeWidth: 0.25
  })));
}, iX = function(e) {
  var t = e.title, r = q(e, kCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 810 540"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#039",
    d: "M0 0h810v540H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FC0",
    d: "m404.951 59.865 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-90 24 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-66 66 6.735 20.718h21.894l-17.633 12.812 6.638 20.74-17.634-12.812-17.634 12.812 6.736-20.729-17.633-12.812h21.796zm-24 89.999 6.735 20.719h21.894l-17.633 12.813 6.638 20.74-17.634-12.813-17.634 12.813 6.736-20.731-17.633-12.811h21.796zm24 90.001 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm66 66 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm180-312 6.735 20.718h21.894l-17.633 12.812 6.637 20.74-17.633-12.812-17.635 12.812 6.737-20.729-17.633-12.812h21.795zm66 66 6.735 20.718h21.894l-17.633 12.812 6.637 20.74-17.633-12.812-17.635 12.812 6.737-20.729-17.633-12.812h21.795zm24 90 6.735 20.718h21.894l-17.633 12.813 6.638 20.74-17.634-12.813-17.634 12.813 6.736-20.731-17.633-12.811h21.796zm-24 90 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm-156 90 6.735 20.719h21.894l-17.633 12.811 6.638 20.74-17.634-12.811-17.634 12.811 6.736-20.729-17.633-12.812h21.796zm90-24.001 6.735 20.719h21.894l-17.633 12.812 6.639 20.74-17.635-12.812-17.633 12.812 6.735-20.73-17.633-12.811h21.797z"
  }));
}, hMe = function(e) {
  var t = e.title, r = q(e, _Ce);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#2E52B2",
    d: "M513 129.3V212H203.7v130H121V212H0v-82.7h121V0h82.7v129.3z"
  }));
}, pMe = function(e) {
  var t = e.title, r = q(e, OCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#62B5E5",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#F3F3F3",
    d: "M307.1 127.1v92c0 61.6 80.5 80.5 80.5 80.5s80.4-19 80.4-80.6v-92l-80.5-23-80.4 23.1z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M468 132.8V98.3H307.1v34.5h69v69h-69v23h69V296c6.9 2.5 11.5 3.5 11.5 3.5s4.6-1.1 11.5-3.5v-71.2h69v-23h-69v-69H468z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h256.5v170.6H0V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m155.9 115 100.6 55.6v-15.8L184.6 115h-28.7zm-55.7-59.3L0 0v15.8l71.8 39.9h28.4z"
  })), /* @__PURE__ */ p.createElement("path", {
    d: "m196.9 115 59.6 32.9V115h-59.6zm-41 0 100.6 55.6v-15.8L184.6 115h-28.7zm73.4 55.6-73.5-40.9v40.9h73.5zM45.2 115 0 140.1V115h45.2zm55 7.1v48.6H12.8l87.4-48.6zM59.1 55.7 0 22.8v32.8s59.1 0 59.1.1zm41.1 0L0 0v15.8l71.8 39.9h28.4zM26.7 0l73.5 40.8V0H26.7zm184.2 55.7 45.6-25.1v25.1h-45.6zm-55-7.2V0h87.4l-87.4 48.5z",
    fill: "#0052B4"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M144.3-.2h-32.1v69.5H0v32.1h112.2v69.5h32.1v-69.5h112.2V69.3H144.3V-.2z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m155.9 115 100.6 55.6v-15.8L184.6 115h-28.7zm-84.1 0L0 154.9v15.8L100.2 115H71.8zm28.4-59.3L0 0v15.8l71.8 39.9h28.4zm83.9 0 72.4-39.9V0L155.9 55.7h28.2z"
  })));
}, mMe = function(e) {
  var t = e.title, r = q(e, ICe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#1F8BDE",
    d: "M312.2 194.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M312.2 194.2v-90c0-8.5 6.5-15.3 15-15.3h120.5c8.3 0 15 6.8 15 15.3v90c0 75.2-75.2 105.3-75.2 105.3s-75.3-30.1-75.3-105.3zm79.6 86.3c7.9-4.5 15.9-10 23.2-16.7 20.5-18.5 32.6-41.4 32.6-69.7v-90c0-.3-120.4-.3-120.4-.3v90.3c0 28.3 12.1 51.2 32.6 69.7 8.3 7.5 17.6 13.9 27.6 19 1.4-.6 2.8-1.4 4.4-2.3z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#187536",
    d: "M347.1 193.4c-2.6-7.9 1.7-14.3 10.1-14.3h60.5c8.2 0 12.8 6.3 10.1 14.3l-5.5 16.5c-2.6 7.9-8.9 9.2-15.8 4 0 0 2.6-4.8-19.1-4.8-21.7 0-19.1 4.8-19.1 4.8-6.1 5.7-13.1 4-15.8-4 .1.1-5.4-16.5-5.4-16.5z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M357.4 179.1c8.1 1.6 17.8-15 30.1-15 13.1 0 21.8 17.1 30.1 15 7.4-1.8 15-22.2 15-30.1 0-16.6-20.2-30.1-45.1-30.1-24.9 0-45.1 13.5-45.1 30.1-.1 8.5 6.6 28.5 15 30.1zm-1.4 91.6c6.2.4 12.5-1.8 17.2-6.5l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c4.7 4.7 11 6.9 17.1 6.5 5.3-.3 32.5-33.5 25.7-32.6-4.6.6-9.1 2.8-12.7 6.3l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-3.5-3.5-7.8-5.6-12.3-6.3-6.7-1.1 20.1 32.2 25.3 32.5zM322.1 210c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0l9 9c8.8 8.7 22.9 8.7 31.7 0l9-9c2.9-2.9 7.5-2.9 10.4 0 0 0 5.5-14.8 2.5-15.9-7.9-2.9-17.2-1.2-23.5 5.2l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-8.7-8.8-22.9-8.8-31.7-.1l-.1.1-9 9c-2.9 2.9-7.5 2.9-10.4 0l-9-9c-6.2-6.2-15.1-8-22.8-5.5-3.1 1.1 1.9 16.1 1.9 16.1z"
  }));
}, gMe = function(e) {
  var t = e.title, r = q(e, RCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m256 37.9 10.1 31.2H299l-26.6 19.3 10.2 31.2-26.6-19.3-26.6 19.3 10.2-31.2L213 69.1h32.9zM123.2 170.7l31.2-10.2v-32.8l19.3 26.6 31.2-10.2-19.3 26.6 19.3 26.5-31.2-10.1-19.3 26.5v-32.8zM256 303.5l-10.1-31.2H213l26.6-19.3-10.2-31.3L256 241l26.6-19.3-10.2 31.3 26.6 19.3h-32.9zm132.8-132.8-31.2 10.1v32.8l-19.3-26.5-31.2 10.1 19.3-26.5-19.3-26.6 31.2 10.2 19.3-26.6v32.8z",
    fill: "#FFF"
  }));
}, vMe = function(e) {
  var t = e.title, r = q(e, PCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0F61A5",
    d: "M513 214.5H206.2V342h-87.8V214.5H0v-87.7h118.4V0h87.8v126.8H513V192z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#E50E3D",
    d: "M513 149.3V192H183.7v150H141V192H0v-42.7h141V0h42.7v149.3z"
  }));
}, yMe = function(e) {
  var t = e.title, r = q(e, DCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#00318A",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }));
}, bMe = function(e) {
  var t = e.title, r = q(e, NCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 228h513v114H0z"
  }));
}, wMe = function(e) {
  var t = e.title, r = q(e, LCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h513v341.3H0V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M311.7 230 513 341.3v-31.5L369.3 230h-57.6zM200.3 111.3 0 0v31.5l143.7 79.8h56.6z"
  })), /* @__PURE__ */ p.createElement("path", {
    d: "M393.8 230 513 295.7V230H393.8zm-82.1 0L513 341.3v-31.5L369.3 230h-57.6zm146.9 111.3-147-81.7v81.7h147zM90.3 230 0 280.2V230h90.3zm110 14.2v97.2H25.5l174.8-97.2zm-82.1-132.9L0 45.6v65.7h118.2zm82.1 0L0 0v31.5l143.7 79.8h56.6zM53.4 0l147 81.7V0h-147zm368.3 111.3L513 61.1v50.2h-91.3zm-110-14.2V0h174.9L311.7 97.1z",
    fill: "#0052B4"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M288 0h-64v138.7H0v64h224v138.7h64V202.7h224v-64H288V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M311.7 230 513 341.3v-31.5L369.3 230h-57.6zm-168 0L0 309.9v31.5L200.3 230h-56.6zm56.6-118.7L0 0v31.5l143.7 79.8h56.6zm168 0L513 31.5V0L311.7 111.3h56.6z"
  })));
}, xMe = function(e) {
  var t = e.title, r = q(e, $Ce);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#c60a0a",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#3E8446",
    d: "m256.5 170.7-212 126.1V44.5z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m256.5 170.7 211 126.1h-423zm211-126.2-211 126.2-212-126.2z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#3E8446",
    d: "M467.5 44.5v252.3l-211-126.1z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m256.5 10.4 2.8 10.2H270l-8.6 6.3 3.3 10.2-8.2-6.3-9.2 6.3 3.3-10.2-8.6-6.3h10.7zm-86.4 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm171.8 0 3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm-85.4 293.8 2.8 10.2H270l-8.6 6.3 3.3 10.2-8.2-6.3-9.2 6.3 3.3-10.2-8.6-6.3h10.7zm-86.4 0 3.3 10.2h10.7l-8.6 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7zm171.8 0 3.3 10.2H356l-8.7 6.3 3.3 10.2-8.7-6.3-8.7 6.3 3.3-10.2-8.6-6.3h10.7z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#c60a0a",
    cx: 244.5,
    cy: 170.7,
    r: 76.2
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "m244.5 110.1 13.6 41.8h44l-35.6 25.8 13.6 41.8-35.6-25.8-35.5 25.8 13.6-41.8-35.6-25.8h44zm-136.8 57.7c4.4 6.9 2.3 16.1-4.6 20.5s-16.1 2.3-20.5-4.6c-7.9-12.5-3.3-33-3.3-33s20.4 4.6 28.4 17.1z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#A2001D",
    cx: 99.1,
    cy: 182.1,
    r: 7.4
  }));
}, EMe = function(e) {
  var t = e.title, r = q(e, FCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#fff",
    d: "M0 0h22.5v15H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#eb000e",
    d: "M9.8 6H0v3h9.8v6h3V9h9.8V6h-9.8V0h-3v6z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#eb000e",
    d: "m17.3 2.7-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm-12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm0 9-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2zm12.7 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2z"
  }));
}, SMe = function(e) {
  var t = e.title, r = q(e, BCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 60"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FDEB01",
    d: "m0 0 90 60H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#58A846",
    d: "M90 0v60L0 0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#ED3D24",
    d: "m50.7 33.3 9.3-6.7H48.5L45 15.7l-3.5 10.9H30l9.3 6.7-3.6 11 9.3-6.7 9.3 6.7z"
  }));
}, CMe = function(e) {
  var t = e.title, r = q(e, zCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M308 0H204v118.7H0v104h204V342h104V222.7h205v-104H308z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "m368.6 188 26 17.3V136l-26 17.3h-95.3V58.1l17.3-26h-69.2l17.3 26v95.2h-95.3l-26-17.3v69.3l26-17.3h95.3v95.2l-17.3 26h69.2l-17.3-26V188z"
  }));
}, TMe = function(e) {
  var t = e.title, r = q(e, HCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#496E2D",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m255.9 113.8 14.1 43.4 40.4 3.2-37 26.9 19.5 40.3-37-26.9-37 26.9 14.1-43.5-36.9-26.9h45.7z"
  }));
}, AMe = function(e) {
  var t = e.title, r = q(e, UCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 230h513v112H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M363.1 131.8V99.1H374V77.3h-21.9v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7h-21.8V55.5h10.9V33.7h-21.8v10.9h-10.9V33.7H254v10.9h-10.9V33.7h-21.8v21.8h10.9v76.3h-21.8V99.1h10.9V77.3h-21.8v10.9h-21.8V77.3h-21.8v21.8h10.9v32.7H145V219h239.9v-87.2z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "m264.9 235.5-24.2 18.2 19.1 14.3v31.3h-23.2v9h23v7.9h-23v9.3H270V268l19.1-14.3-24.2-18.2zm0 25.3-10.1-7.1 10.1-7.1 10.1 7.1-10.1 7.1z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M239.6 209.7v-27.9s.1-22.3 25-22.3c24.8 0 25.7 22 25.7 22v28.2h-50.7zm-69.1 0v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M169.1 209.7v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zm151.8 0v-24.3s.1-18.7 19.6-18.7 20.2 18.4 20.2 18.4v24.5h-39.8zm8.4-77.7v-15.7s.1-12.1 11.3-12.1c11.3 0 11.7 11.9 11.7 11.9V132h-23zm-78.8 0v-23.7s.1-18.3 14.3-18.3c14.2 0 14.7 18 14.7 18v24h-29zm-73 0v-15.7s.1-12.1 11.3-12.1 11.7 11.9 11.7 11.9V132h-23z"
  }));
}, MMe = function(e) {
  var t = e.title, r = q(e, VCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M513 0v171H0V0z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FFF",
    cx: 185.8,
    cy: 171.2,
    r: 117.8
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M68 171c0-65.1 52.8-117.8 117.8-117.8 65.1 0 117.8 52.8 117.8 117.8"
  }));
}, kMe = function(e) {
  var t = e.title, r = q(e, jCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#cf0d19",
    d: "M0 0h513v100H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 121h513v100H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#1a7e25",
    d: "M0 242h513v100H0z"
  }));
}, _Me = function(e) {
  var t = e.title, r = q(e, WCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M342 0h171v342H342z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h171v342H0z"
  }));
}, OMe = function(e) {
  var t = e.title, r = q(e, GCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#00318A",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }));
}, IMe = function(e) {
  var t = e.title, r = q(e, KCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v113.8H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 227.6h513V342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0070C8",
    d: "M126 171 0 342V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    d: "M233.8 139.4v40.4c0 35.6 35.6 35.6 35.6 35.6s35.6 0 35.6-35.6v-40.4h-71.2z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#786145",
    d: "M264.5 179.8h9.8l4 25.8h-17.8z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M287.2 162c0-9.8-8-14.8-17.8-14.8s-17.8 5-17.8 14.8c-4.9 0-8.9 4-8.9 8.9s4 8.9 8.9 8.9h35.6c4.9 0 8.9-4 8.9-8.9s-4-8.9-8.9-8.9z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m230.7 120 1.9 3.3h3.8l-1.9 3.3 1.9 3.2h-3.8l-1.9 3.3-1.9-3.3H225l1.9-3.2-1.9-3.3h3.8zm15.3 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zm15.3 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2h-3.7l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8zm15.8 0 1.9 3.3h3.8l-1.9 3.3 1.9 3.2H279l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zm16 0 1.9 3.3h3.8l-1.9 3.3 1.9 3.2H295l-1.9 3.3-1.9-3.3h-3.7l1.8-3.2-1.8-3.3h3.7zm15 0 1.9 3.3h3.7l-1.9 3.3 1.9 3.2H310l-1.9 3.3-1.9-3.3h-3.8l1.9-3.2-1.9-3.3h3.8z",
    fill: "#FFDA00",
    stroke: "#000",
    strokeMiterlimit: 10
  }));
}, RMe = function(e) {
  var t = e.title, r = q(e, qCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#0d5eaf"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h190v190H0z"
  })), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M0 76h190v38H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M76 0h38v190H76z"
  })));
}, PMe = function(e) {
  var t = e.title, r = q(e, YCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 170.7v-11l62.5-42.3h22.6L7.3 170.7zM7.3.1l77.8 53.2H62.5L0 11.1V.1zM256 .1v11l-62.5 42.3h-22.6L248.7.1zm-7.3 170.6-77.8-53.3h22.6l62.5 42.3v11z"
  }), /* @__PURE__ */ p.createElement("ellipse", {
    fill: "#FFF",
    cx: 443.4,
    cy: 233.6,
    rx: 29,
    ry: 43.5
  }), /* @__PURE__ */ p.createElement("ellipse", {
    fill: "#FFCE00",
    cx: 406.9,
    cy: 317.7,
    rx: 22,
    ry: 9.3
  }), /* @__PURE__ */ p.createElement("ellipse", {
    fill: "#FFCE00",
    cx: 364,
    cy: 317.7,
    rx: 22,
    ry: 9.3
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#39B200",
    d: "m342 190.1 43.4 86.9 43.5-86.9z"
  }), /* @__PURE__ */ p.createElement("ellipse", {
    fill: "#9B9B9B",
    cx: 327.5,
    cy: 233.6,
    rx: 29,
    ry: 43.5
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#757575",
    d: "m371 175.6-14.5 14.5h57.9l-14.5-14.5 14.5-43.5s-13-29-29-29-29 29-29 29l14.6 43.5z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#C6B56F",
    cx: 385.4,
    cy: 67,
    r: 29
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#A54A00",
    cx: 386,
    cy: 88.7,
    r: 29
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FFF",
    cx: 443.4,
    cy: 117.7,
    r: 29
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#0049FF",
    cx: 342.2,
    cy: 146.7,
    r: 29
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#0041F9",
    cx: 429.8,
    cy: 146.7,
    r: 29
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#F7D71E",
    cx: 386,
    cy: 233.6,
    r: 29
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#CEC851",
    cx: 457.9,
    cy: 190.1,
    r: 29
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FFF",
    cx: 385.4,
    cy: 289.5,
    r: 29
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#7C0B29",
    d: "m371 135.7 14.5-3.5 14.5 3.5c0 7.5-14.5 11-14.5 11s-14.5-3.5-14.5-11z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FFF",
    cx: 327.5,
    cy: 117.4,
    r: 29
  }));
}, DMe = function(e) {
  var t = e.title, r = q(e, XCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h171v342H0zm342 0h171v342H342z",
    fill: "#338AF3"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#DCC26D",
    cx: 256,
    cy: 155.8,
    r: 25.5
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#628A40",
    d: "M194.2 155.9c0 22.1 11.8 42.5 30.8 53.5 5.9 3.4 13.5 1.4 16.9-4.5 3.4-5.9 1.4-13.5-4.5-16.9-11.5-6.6-18.5-18.9-18.5-32.1 0-6.8-5.5-12.4-12.4-12.4s-12.3 5.5-12.3 12.4zm95.1 52.1c17.8-11.4 28.6-31 28.5-52.1 0-6.8-5.5-12.4-12.4-12.4-6.8 0-12.4 5.5-12.4 12.4 0 12.7-6.5 24.5-17.1 31.3-5.8 3.6-7.7 11.2-4.1 17 3.6 5.8 11.2 7.7 17 4.1.2-.1.3-.2.5-.3z"
  }));
}, NMe = function(e) {
  var t = e.title, r = q(e, ZCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M11.1 11.1h489.7v319.1H11.1z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#7DBEF1",
    d: "M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#1C8AE6",
    d: "M179.8 180.7h152.6l-29.3 64.9h-95.2z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF042",
    d: "M192.3 205.9s40.5 38.2 51 38.2c12.4 0 12.6-18.4 25.5-25.5 20.2-11.1 51-12.7 51-12.7L297 248.7l-41 36.6-46.8-39.7-16.9-39.7z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#259C7B",
    d: "m256 157.5-22.5 15.6 7.9-26.2-21.8-16.5 27.4-.5 9-25.9 9 25.9 27.4.5-21.8 16.6 7.9 26.2-22.5-15.7z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#8E5715",
    d: "M249.7 144.6c-.9 9.2-1.5 18.4-1.7 27.6-.3 11.9.3 20.7 2 26 2.2 6.6 7.2 12.9 14.2 18.9 5.3 4.6 10.6 8.1 14.2 10.1 3.1 1.7 7 .6 8.7-2.4 1.7-3.1.6-7-2.4-8.7-4.3-2.5-8.4-5.4-12.2-8.7-5.4-4.6-9.1-9.2-10.4-13.3-1.1-3.4-1.6-11.3-1.4-21.7.2-8.9.8-17.8 1.7-26.6.4-3.5-2.2-6.6-5.7-7-3.6-.3-6.7 2.3-7 5.8z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "m217.8 170.7 25.5 38.2h-25.5v-38.2z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "none",
    stroke: "#D80027",
    strokeWidth: 12,
    strokeMiterlimit: 10,
    d: "M256 285.3s76.4-51.3 76.4-114.6S256 56 256 56s-76.4 51.3-76.4 114.6S256 285.3 256 285.3z"
  }));
}, LMe = function(e) {
  var t = e.title, r = q(e, QCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h512v171H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h182v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m98.3 109.8 15.1 46.5h48.9L122.8 185l15.1 46.5-39.6-28.7-39.5 28.7L73.9 185l-39.6-28.7h48.9z"
  }));
}, $Me = function(e) {
  var t = e.title, r = q(e, JCe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#009E49",
    d: "M0 0h900v600H0V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "m0 0 947 300L0 600V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFD00D",
    d: "M0 26.1 870 300 0 573.9V26.1z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#2D2D2D",
    d: "m0 0 450 300L0 600V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D3132F",
    d: "m0 35 397.5 265L0 565V35z"
  }));
}, FMe = function(e) {
  var t = e.title, r = q(e, eTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    viewBox: "0 0.5 21 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h21v15H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#ee1c25",
    d: "M0 0h21v15H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M12 7.19c-.798-.5-1 .409-1 0 0-.828.895-1.5 2-1.5s2 .672 2 1.5c-.949 0-1.044.5-1.5.5-.56 0-.702 0-1.5-.5zM13.25 7a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5zm-1.81 1.962c.228-.913-.698-.824-.31-.95.788-.257 1.703.387 2.045 1.438.341 1.05-.021 2.11-.809 2.366-.293-.903-.798-.838-.939-1.272-.173-.533-.217-.668.012-1.582zm.566 1.13a.25.25 0 1 0 .476-.154.25.25 0 0 0-.476.154zM9.58 8.977c.94-.065.57-.919.81-.588.486.67.157 1.74-.737 2.389-.894.65-2.013.632-2.5-.038.768-.558.55-1.018.92-1.286.453-.33.568-.413 1.507-.477zm-.899.888a.25.25 0 1 0 .294.405.25.25 0 0 0-.294-.405zm.312-2.652c.351.874 1.049.258.809.588-.487.67-1.606.687-2.5.038-.894-.65-1.223-1.719-.736-2.39.767.559 1.138.21 1.507.478.453.33.568.413.92 1.286zm-1.124-.58a.25.25 0 1 0-.293.404.25.25 0 0 0 .293-.404zm2.619-.524c-.722.605.08 1.078-.309.951-.788-.256-1.15-1.315-.809-2.365.342-1.05 1.257-1.695 2.045-1.439-.293.903.153 1.147.012 1.581-.173.533-.217.668-.939 1.272zm.205-1.247a.25.25 0 1 0-.475-.155.25.25 0 0 0 .475.155z",
    fill: "#FFF"
  })));
}, BMe = function(e) {
  var t = e.title, r = q(e, tTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M223.4 170.7c.3-.3.5-.6.8-.9-.3.3-.5.6-.8.9zm-34.2 41.9 11 22.9 24.7-5.7-11.1 22.8 19.9 15.8L209 274v25.4l-19.8-15.9-19.8 15.9.1-25.4-24.8-5.6 19.9-15.8-11.1-22.8 24.8 5.7zm197.9 28.5 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6v12.2l-9.4-7.6-9.5 7.6.1-12.2-11.9-2.6 9.5-7.5-5.3-10.9 11.9 2.7zm-48.6-116 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6v-12.1l-11.8-2.7 9.5-7.5-5.3-10.9 11.8 2.7zm48.6-66.2 5.2 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.7v12.1l-9.4-7.6-9.5 7.6.1-12.1-11.9-2.7 9.5-7.5-5.3-10.9 11.9 2.7zm42.4 49.7 5.3 10.9 11.8-2.7-5.3 10.9 9.5 7.5-11.8 2.6V150l-9.5-7.6-9.4 7.6v-12.2l-11.8-2.6 9.5-7.5-5.3-10.9 11.8 2.7zm-30.3 57.9 4.1 12.7h13.3l-10.8 7.8 4.1 12.6-10.7-7.8-10.8 7.8 4.1-12.6-10.7-7.8h13.3z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
  })), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z",
    fill: "#D80027"
  }));
}, zMe = function(e) {
  var t = e.title, r = q(e, nTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h513v114H0zm0 228h513v114H0zm203.5-110.1 6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zm105 0 6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zM256 147.6l6.7 16.6 17.6 1-14 10.9 4.7 17.7-15-9.9-15 9.9 4.7-17.7-14-10.9 17.6-1zm-52.5 29.7 6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1zm105 0 6.7 16.6 17.6 1-14 10.9 4.7 17.6-15-9.9-15 9.9 4.7-17.6-14-10.9 17.6-1z",
    fill: "#338AF3"
  }));
}, HMe = function(e) {
  var t = e.title, r = q(e, rTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M309.3 113.2v-44l17.5-14.4 17.7 14.4v44zm-105.6 0v-44l-17.3-14.4-17.9 14.4v44zm35.2 0v-44l17.6-14.4 17.6 14.4v44z",
    fill: "#338AF3"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M309.3 113.2h-35.2v-44l17.5-14.4 17.7 14.4zm-70.4 0h-35.2v-44l17.5-14.4 17.7 14.4z",
    fill: "#0052B4"
  }), /* @__PURE__ */ p.createElement("path", {
    stroke: "#D80027",
    fill: "#FFF",
    d: "M168.5 113.2v101.9c0 24.3 14.4 46.2 35.4 59.4 21.3 13.4 42.1 14.7 52.6 14.7s31.4-1.7 52.6-14.8c21-13 35.4-35.1 35.4-59.3V113.2h-176z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M168.5 113.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-105.6 35.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-105.6 35.2h35.2v35.2h-35.2zm35.2 35.2h35.2V254h-35.2zm35.2-35.2h35.2v35.2h-35.2zm70.4 0h35.2v35.2h-35.2zm-35.2 35.2h35.2V254h-35.2zm35.2 55.5c8.6-5.4 16.2-12.3 22-20.3h-22v20.3zM181.7 254c5.8 8 13.3 14.9 22 20.4V254h-22zm57.2 0v33.7c7.2 1.2 13.3 1.5 17.6 1.5 4.3 0 10.4-.3 17.6-1.6V254h-35.2z",
    fill: "#D80027"
  }));
}, UMe = function(e) {
  var t = e.title, r = q(e, iTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#A2001D",
    d: "M0 0h513v172H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 172h513v172H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "m381.4 251.5-110.7-13.8-110.8 13.8V85.4h221.5z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#0052B4",
    cx: 270.7,
    cy: 182.3,
    r: 55.4
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#A2001D",
    cx: 270.7,
    cy: 182.3,
    r: 27.7
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M229.1 113.1h83.1l-41.5 41.5z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M256.8 140.8h27.7v83h-27.7z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M314.9 215.5h-88.5l-66.5 36h221.5z"
  }));
}, VMe = function(e) {
  var t = e.title, r = q(e, sTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M0 228h513v114H0z"
  }));
}, jMe = function(e) {
  var t = e.title, r = q(e, oTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 200"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#fc0",
    d: "M0 0h300v200H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0768a9",
    d: "M0 0h200v200H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#fff",
    d: "M0 0h100v200H0z"
  }));
}, WMe = function(e) {
  var t = e.title, r = q(e, aTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#E00",
    d: "M0 0h513v171H0z"
  }));
}, GMe = function(e) {
  var t = e.title, r = q(e, lTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FF9811",
    d: "M342 0h171v342H342z"
  }));
}, KMe = function(e) {
  var t = e.title, r = q(e, cTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M340.6 122.4h-56.1l-28-48.6-28 48.6h-56.1l28 48.6-28 48.6h56.1l28 48.6 28-48.6h56.1l-28-48.6 28-48.6zM293.2 171 276 204.2h-38.9L219.8 171l17.2-33.2h38.9l17.3 33.2zm-36.7-71.8 11.9 23.3h-23.9l12-23.3zm-58.3 38.6h23.9l-10.8 21-13.1-21zm0 66.4 13-22.1 11.9 22.1h-24.9zm58.3 37.5-11.9-22.1h23.9l-12 22.1zm59.4-37.5h-25l11.9-22.1 13.1 22.1zm-26.1-66.4h26.1l-13 22.1-13.1-22.1zM0 21.3h512V64H0zm0 256h512V320H0z",
    fill: "#2E52B2"
  }));
}, qMe = function(e) {
  var t = e.title, r = q(e, uTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#E52D42",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M393.3 68.2h-45.8l-33.8 80.2-34.4-22.9s-24.7-59.1-34.4-68.2c-9.7-9.7-18.7-.6-48.9 7.8-29.6 8.4-30.8 18.7-42.2 18.7-4.8 0-19.9-17.5-27.7-22.3-12.1-7.8-16.9-4.2-13.9 7.2 1.2 4.8 10.9 10.9 16.9 19.9 7.8 11.5 12.7 25.9 12.7 25.9s10.9-10.3 16.9-12.1c9-2.4 19.3 1.8 31.4 0 15.1-2.4 31.4-10.9 31.4-10.9l4.2 43.4s-54.3 50.7-49.5 70.6 56.1 44.6 68.2 62.7c12.1 17.5-7.2 24.1-7.2 32.6s-1.8 19.9 7.2 16.3c9-3.6 10.3-18.1 18.7-31.4 6-9 10.3-13.9 11.5-17.5 1.8-9-23.5-32-37.4-48.9-6.6-7.8-19.9-18.7-19.9-18.7l39.2-29.6s67.6 27.7 82.6 18.7c15.1-9 19.3-98.3 19.3-98.3l47-11.5-12.1-11.7z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#F8DD4E",
    d: "M279.3 262.4c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.8-182.8c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm0 91.1c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6 0 11.5 4.8 11.5 11.5-.6 6.7-5.5 11.5-11.5 11.5zm-136.9 45.8c-6 0-11.5-4.8-11.5-11.5 0-6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5s-5.5 11.5-11.5 11.5zm45.2-136.9c-6 0-11.5-4.8-11.5-11.5s4.8-11.5 11.5-11.5c6 0 11.5 4.8 11.5 11.5s-4.8 11.5-11.5 11.5zm22.9 91.1c-6 0-11.5-10.3-11.5-22.9s4.8-22.9 11.5-22.9c6 0 11.5 10.3 11.5 22.9s-4.8 22.9-11.5 22.9zm-114-45.2c-6 0-11.5-4.8-11.5-11.5 0-6.6 4.8-11.5 11.5-11.5 6.6 0 11.5 4.8 11.5 11.5 0 6.6-4.8 11.5-11.5 11.5z"
  }));
}, YMe = function(e) {
  var t = e.title, r = q(e, dTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#F93",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#fff",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#138808",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ p.createElement("circle", {
    cx: 256.5,
    cy: 171,
    r: 34.2,
    stroke: "navy",
    strokeWidth: 4,
    fill: "none"
  }), /* @__PURE__ */ p.createElement("circle", {
    cx: 256.5,
    cy: 171,
    r: 3.42,
    fill: "navy"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m265.3 138.159-17.6 65.682m17.6-65.682-17.6 65.682m25.8-62.286-34 58.89m41.042-53.487-48.084 48.084M285.945 154l-58.89 34m62.286-25.8-65.682 17.6M290.5 171h-68m66.841 8.8-65.682-17.6m62.286 25.8-58.89-34m53.487 41.042-48.084-48.084m41.042 53.487-34-58.89m25.8 62.286-17.6-65.682M256.5 205v-68m-8.8 66.841 17.6-65.682m-25.8 62.286 34-58.89m-41.042 53.487 48.084-48.084M227.055 188l58.89-34m-62.286 25.8 65.682-17.6M222.5 171h68m-66.841-8.8 65.682 17.6M227.055 154l58.89 34m-53.487-41.042 48.084 48.084M239.5 141.555l34 58.89m-25.8-62.286 17.6 65.682",
    stroke: "navy",
    strokeWidth: 2
  }));
}, XMe = function(e) {
  var t = e.title, r = q(e, fTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0-.3h513V342H0V-.3z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M462.9 198.1c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zM0 31.7l19 10c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-10 20-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-10 21-10s13 6 20 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 21 10c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-10 20-10s14 6 20 10c11 6 22 12 32.1 12s20-6 31.1-12l19-10v-22c-10 1-20 6-30.1 12-7 4-16 9-20 9s-14-5-21-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-11-30.1-12v22zm462.9 55.2c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 3.9-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 1 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-8 19-9v-23zm-50.1 133.3c-4 0-14-5-21-9-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 9-20 9s-14-5-20-9c-11-6-22-12-32.1-12-9 0-20 6-31.1 12-7 4-16 9-20 9s-13-5-20-9c-11-6-22-12-31.1-12-10 0-21 6-32.1 12-6 4-16 9-20 9s-13-5-20-9c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 9-21 9s-13-5-20-9c-10-6-20-12-30.1-12v22l19 9c11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12l19-9v-22c-10 0-20 6-30.1 12-7 4-16 9-20 9zm50.1 34c-10 1-20 6-30.1 12-7 4-16 10-20 10s-14-6-21-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-14-6-20-10c-11-6-22-12-32.1-12s-20 6-31.1 12c-7 4-16 10-20 10s-13-6-20-10c-11-6-22-12-31.1-12s-21 6-32.1 12c-6 4-16 10-20 10s-13-6-20-10c-11-6-21-12-31.1-12s-20 6-31.1 12c-7 4-17 10-21 10s-13-6-20-10c-10-6-20-11-30.1-12v23c4 0 13 5 19 9 11 6 21 12 31.1 12s21-6 32.1-12c6-4 16-9 20-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 17-9 21-9s13 5 20 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 21 9c11 6 21 12 31.1 12s20-6 31.1-12c7-4 16-9 20-9s14 5 20 9c11 6 22 12 32.1 12s20-6 31.1-12c6-4 15-9 19-9v-23z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0-.3h256v171H0V-.3z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M389.8 119.9H408v78.8h-18.3l.1-78.8zm0 117.8H408v75.1h-18.3l.1-75.1z",
    fill: "#A2001D"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M144-.3h-32v70H0v32h112v69h32v-69h112v-32H144v-70z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0-.3v15l57 39h23L0-.3zm256 0v15l-57 39h-23l80-54z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0-.3v15l57 39h23L0-.3zm256 0v15l-57 39h-23l80-54zM0 170.7v-15l57-38h23l-80 53zm256 0v-15l-57-38h-23l80 53z"
  })), /* @__PURE__ */ p.createElement("g", {
    fill: "#2E52B2"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M0 22.7v31h46l-46-31zm96-23v49L23-.3h73zm160 23v31h-46l46-31zm-96-23v49l73-49h-73z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 22.7v31h46l-46-31zm96-23v49L23-.3h73zm160 23v31h-46l46-31zm-96-23v49l73-49h-73zM0 147.7v-30h46l-46 30zm96 23v-49l-73 49h73zm160-23v-30h-46l46 30zm-96 23v-49l73 49h-73z"
  })), /* @__PURE__ */ p.createElement("path", {
    fill: "#5DA51E",
    stroke: "#45602C",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M462.8 91.5h-29.1l25.7-25.7c4.5-4.4 4.5-11.4 0-15.8l-3.4-3.4c-4.4-4.4-11.4-4.4-15.8 0l-25.9 25.9V37.4c0-6.2-5.1-11.3-11.3-11.3h-4.7c-6.2 0-11.3 5.1-11.3 11.3v31.7l-23.5-23.8c-4.7-4.7-12.2-4.7-16.9 0l-3.6 3.6c-4.7 4.7-4.7 12.4 0 17.2l25 25.4h-30.6c-6 0-10.9 4.9-10.9 10.9v4.6c0 6 4.9 10.9 10.9 10.9H369l-20.7 20.7c-4.4 4.4-4.4 11.4 0 15.8l3.4 3.4c4.4 4.4 11.4 4.4 15.8 0l19.6-19.6V167c0 6.1 5.1 11.1 11.3 11.3h4.7c6.2 0 11.3-5.1 11.3-11.3v-28.3l22.2 22.6c4.7 4.7 12.4 4.7 17.1 0l3.6-3.6c4.7-4.7 4.7-12.4 0-17.2L435.2 118h27.6c5.9 0 10.7-4.9 10.9-10.9v-4.6c0-6.1-4.9-11-10.9-11z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#E2DD24",
    stroke: "#525625",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    d: "M439.2 249.1h-79.8s-.9-13.4-6-21.8c-6.2-10.4-13.9-28.1-1.4-36.7 15.9-10.9 33.7.8 48.2.8 11.8.1 26.9-14 45-.8 12.2 8.9 3.9 28.2-1.3 36.7-7 11.5-4.7 21.8-4.7 21.8z"
  }));
}, ZMe = function(e) {
  var t = e.title, r = q(e, hTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#CE1126",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M219.2 160.7h-29.3c1.5-5.7 6.6-9.9 12.8-9.9v-19.9c-18.3 0-33.1 14.9-33.1 33.1v16.5h49.6c1.8 0 3.3 1.5 3.3 3.3v6.6h-66.2v19.9h86.1v-26.5c0-12.7-10.4-23.1-23.2-23.1zm49.6 29.8v-59.6H249v79.5h33.1v-19.9zm66.2 0v-59.6h-19.8v59.6h-6.6v-19.8h-19.9v39.7h59.6v-19.9z",
    fill: "#547C31"
  }));
}, QMe = function(e) {
  var t = e.title, r = q(e, pTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 227.9h513v114H0zm278.8-93.1c.1 2 8.7 26.2 4.4 39.4-6.6 20.3-15.8 21.8-19.8 24.5V134l-6.9-4.2-6.9 4.2v64.7c-4-2.7-12.4-2.4-19.8-24.5-4.3-12.7 5.7-37.3 5.8-39.2 0 0-9.5 8.1-15.8 24-5.9 14.8 1.9 49.6 29.5 54.8 2.3.4 4.7 5.6 7.2 5.6 2.1 0 4.1-5.2 6-5.5 28.4-4.6 35-41.7 29.9-55.6-5.4-14.6-13.6-23.5-13.6-23.5z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M44.6 98.9h22.3v24.4H44.6zM0 98.9h22.3v24.4H0zm89.2 0h22.3v24.4H89.2zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4H223zm44.7 0H290v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0h22.3v24.4h-22.3zm44.6 0H513v24.4h-22.3zm-446.1 118h22.3v25.5H44.6zm-44.6 0h22.3v25.5H0zm89.2 0h22.3v25.5H89.2zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5H223zm44.7 0H290v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0h22.3v25.5h-22.3zm44.6 0H513v25.5h-22.3z",
    fill: "#FFF",
    opacity: 0.5
  }));
}, JMe = function(e) {
  var t = e.title, r = q(e, mTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M513 210.6H202.2v130.7h-79.8V210.6H0v-79.8h122.4V0h79.8v130.8H513v18.5l-1 42.7z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M513 149.3V192H183.7v149.3H141V192H0v-42.7h141V0h42.7v149.3z"
  }));
}, eke = function(e) {
  var t = e.title, r = q(e, gTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#F4F5F0",
    d: "M342 0H0v341.3h512V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#008C45",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#CD212A",
    d: "M342 0h171v342H342z"
  }));
}, tke = function(e) {
  var t = e.title, r = q(e, vTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M301.8 171 513 30.2V0h-45.3L256.5 140.8 45.3 0H0v30.2L211.2 171 0 311.8V342h45.3l211.2-140.8L467.7 342H513v-30.2z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "m233.7 44.6 22.3 5.6 22.3-5.6 4-20.9-14.9 6.5L256 14.8l-11.4 15.4-14.9-6.5z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M233.7 44.6s-4 12.9-4 29.9c0 27.9 26.3 41.3 26.3 41.3s26.3-15.5 26.3-41.3c0-15.4-4-29.9-4-29.9s-8.1-5-22.3-5-22.3 5-22.3 5z"
  }));
}, nke = function(e) {
  var t = e.title, r = q(e, yTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M215.9 171 0 314.6V26.8zM513 26.8v287.8L296.1 171z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M513 26.8 296.1 171 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4L215.9 171 0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M513 26.8 296.1 171 513 314.6V342h-41.1L256 197.4 40.1 342H0v-27.4L215.9 171 0 26.8V0h40.1L256 143.9 471.9 0H513z"
  }));
}, rke = function(e) {
  var t = e.title, r = q(e, bTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M256.5 170.7 0 341.3V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "m77.9 139.5 7.9 16.4 17.8-4.1-8 16.5 14.3 11.3-17.8 4 .1 18.3-14.3-11.5-14.2 11.5v-18.3l-17.8-4 14.3-11.3-7.9-16.5 17.7 4.1z"
  }));
}, ike = function(e) {
  var t = e.title, r = q(e, wTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#D80027",
    cx: 256.5,
    cy: 171,
    r: 96
  }));
}, ske = function(e) {
  var t = e.title, r = q(e, xTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h512v90.579H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#496E2D",
    d: "M0 251h513v91H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#A2001D",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "m323.3 54.5-25.6-11.8L256 137l-41.7-94.3-25.6 11.8 51.8 116.2-51.8 116.2 25.6 11.8 41.7-94.4 41.7 94.4 25.6-11.8-51.8-116.2z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M273.4 65.6c-9.9-10.8-17.4-17-17.4-17s-7.5 6.2-17.4 17v210.1c9.9 10.8 17.4 17 17.4 17s7.5-6.2 17.4-17V65.6z"
  })), /* @__PURE__ */ p.createElement("path", {
    d: "M209 105.9v129.5c10.5 18.5 23.3 33.7 32.9 43.8V62.1c-9.6 10.1-22.4 25.3-32.9 43.8zm94 0c-10.5-18.5-23.3-33.7-32.9-43.8v217.2c9.6-10.1 22.4-25.3 32.9-43.8V105.9z",
    fill: "#A2001D"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M303 105.9v129.5c10.6-18.8 18.8-41 18.8-64.8s-8.2-45.9-18.8-64.7zm-94 0v129.5c-10.6-18.8-18.8-41-18.8-64.8s8.2-45.9 18.8-64.7z"
  }));
}, oke = function(e) {
  var t = e.title, r = q(e, ETe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("circle", {
    cx: 256,
    cy: 170.7,
    r: 170.7
  })), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M382.4 170.7 330.8 195l27.5 50-56.1-10.7-7.1 56.6-39.1-41.7-39.1 41.7-7.1-56.6-56.1 10.7 27.5-50-51.6-24.3 51.6-24.3-27.5-50.1 56.1 10.8 7.1-56.7L256 92.1l39.1-41.7 7.1 56.7 56.1-10.8-27.5 50.1z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#D80027",
    cx: 257.4,
    cy: 170.7,
    r: 71.6
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M214.2 170.7c-2.1 0-4.1.1-6.2.3.1 12 4.4 22.9 11.6 31.5 3.8-10.3 9.5-19.6 16.7-27.7-6.9-2.7-14.3-4.1-22.1-4.1zm26.6 46.5c5.2 1.9 10.8 2.9 16.6 2.9 5.8 0 11.4-1 16.6-2.9-2.8-11.1-8.7-21-16.6-28.8-7.9 7.8-13.8 17.7-16.6 28.8zm59.4-71.2c-8.5-14.8-24.5-24.7-42.8-24.7-18.3 0-34.2 9.9-42.8 24.7 15.6.1 30.2 4.3 42.8 11.6 12.6-7.3 27.2-11.6 42.8-11.6zm-21.7 28.8c7.2 8 12.9 17.4 16.7 27.7 7.2-8.5 11.5-19.5 11.6-31.5-2-.2-4.1-.3-6.2-.3-7.7 0-15.2 1.4-22.1 4.1z",
    fill: "#FFDA44"
  }));
}, ake = function(e) {
  var t = e.title, r = q(e, STe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h513v114H0zm0 228h513v114H0z",
    fill: "#0052B4"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M303.5 196.6v-17.8h-11.9v-23.7l-11.9-11.9-11.8 11.9v-23.8L256 119.5l-11.9 11.8v23.8l-11.8-11.9-11.9 11.9v23.7h-11.9v17.8h-11.9v17.8h118.8v-17.8z"
  }));
}, lke = function(e) {
  var t = e.title, r = q(e, CTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 450 300"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#CE1126",
    d: "M0 0h450v300H0V0z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#FCD116"
  }, /* @__PURE__ */ p.createElement("circle", {
    cx: 227.6,
    cy: 161.2,
    r: 56.2
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m254.1 73.4-23.7 26 28.6 6.5zm-51.5.2-4.8 33.1 28.5-8zm94.3 26.7-34.7 8.5 20.1 23.7zm-138.3-1.8 15.5 32.7 20.2-22.7zm159 45.3-34.4-9.9 5.6 29.5zm-182-2.6 31.9 19.8 5.2-27.7z"
  })), /* @__PURE__ */ p.createElement("path", {
    fill: "#003F87",
    d: "M0 175h450v125H0V175z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 267c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21zm0-43c15 0 30 13 45 13s30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13 30 13 45 13 30-13 45-13v-21c-15 0-30 13-45 13s-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13-30 13-45 13-30-13-45-13v21z"
  }), /* @__PURE__ */ p.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#FCD116",
    d: "m183.2 48.3-1.1-5.3 22.4-3.7s-30.1-7.1-40-10.7c-14.3-5.1-16.3-12.1-16.3-12.1s44.7 11 64.8 11c4.3 0 12.8 10.7 12.8 10.7s14.8-14.9 21.9-15.4c32.1-2.3 66.6-6.4 66.6-6.4s-10 6.7-16 8.5c-16.2 4.9-50.6 11.7-50.6 11.7l-4.8 7.5H277l-14.4 4.3 7.4 6.9s-7.8-4.1-18.1-2.1c-7.1 1.3-15.4 6-22.9 8-18.7 4.8-29.9-12.8-29.9-12.8l-15.9-.1z"
  }));
}, cke = function(e) {
  var t = e.title, r = q(e, TTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v85.5H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.5h513V171H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 171h513v85.5H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M256.5 171 0 342V0z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M68.6 170.7c0-24.9 17.5-45.6 40.8-50.7-3.6-.8-7.3-1.2-11.1-1.2-28.7 0-51.9 23.3-51.9 51.9s23.3 51.9 51.9 51.9c3.8 0 7.5-.4 11.1-1.2-23.3-5.1-40.8-25.9-40.8-50.7z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m108.9 126.1 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.2-7.3 5.2 2.8-8.5-7.2-5.3h8.9zm0 22.3 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.3-7.3 5.3 2.8-8.5-7.2-5.3h8.9z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m108.9 170.7 2.7 8.5h9l-7.3 5.2 2.8 8.5-7.2-5.2-7.3 5.2 2.8-8.5-7.2-5.2h8.9zm0 22.2 2.7 8.5h9l-7.3 5.3 2.8 8.5-7.2-5.3-7.3 5.3 2.8-8.5-7.2-5.3h8.9z"
  })));
}, uke = function(e) {
  var t = e.title, r = q(e, ATe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M512 0H0v342"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M307.7 0 0 194.5V342h206.9L513 148.5V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M513 0H385.2L0 249.4V341l126.2 1L513 91.6z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m141.1 187 31.2 24 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.3-22.2zM310.6 70.8l31.2 23.9 32.3-22.2-13.1 37 31.1 23.9-39.2-1.1-13.2 37-11.1-37.6-39.2-1.1 32.4-22.2z",
    fill: "#FFF"
  }));
}, dke = function(e) {
  var t = e.title, r = q(e, MTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#91DC5A",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h513v57.188H0zm0 284.1h513v57.177H0z",
    fill: "#0052B4"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 79.9h513v181.582H0z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FFF",
    cx: 190.33,
    cy: 171,
    r: 65.668
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "m190.3 105 14.8 45.3h47.7l-38.6 28.1 14.8 45.5-38.7-28.2-38.6 28.1 14.8-45.4-38.6-28.1h47.7z"
  }));
}, fke = function(e) {
  var t = e.title, r = q(e, kTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h900v600H0z"
  }), /* @__PURE__ */ p.createElement("g", {
    transform: "rotate(-56.31)"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M-75 228.3H75m-150 37.5H75m-150 37.5H75m-150 475H75m-150 37.5H75m-150 37.5H75",
    stroke: "#000",
    strokeWidth: 25
  }), /* @__PURE__ */ p.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 12.5,
    d: "M0 753.3v125"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#ca163a",
    cy: 540.8,
    r: 150
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0e4896",
    d: "M0 390.8c-41.4 0-75 33.6-75 75s33.6 75 75 75 75 33.6 75 75-33.6 75-75 75c-82.8 0-150-67.2-150-150s67.2-150 150-150z"
  })), /* @__PURE__ */ p.createElement("path", {
    d: "m231.56 535.73-83.205-124.808M262.76 514.928l-83.205-124.807m114.407 104.006-83.205-124.808m478.43-138.675-83.205-124.807M720.39 209.843 637.184 85.036m114.407 104.006L668.386 64.234",
    stroke: "#000",
    strokeWidth: 25
  }), /* @__PURE__ */ p.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 12.5,
    d: "m205.6 462.897 31.202-20.8m389.981-259.989 36.444-24.296m31.202-20.801 31.202-20.801"
  }));
}, hke = function(e) {
  var t = e.title, r = q(e, _Te);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M167 227.6 0 341.3V0l167 113.8z"
  }));
}, pke = function(e) {
  var t = e.title, r = q(e, OTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#6DA544",
    cx: 384,
    cy: 96.5,
    r: 29.7
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M332.1 89H436v44.5H332.1z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#496E2D",
    d: "M435.9 170.7z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M332.1 200.3V230h15.6c9.4 9.2 22.2 14.8 36.3 14.8 14.1 0 27-5.7 36.3-14.8h15.6v-29.7H332.1z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M332.1 126.1v44.5c0 39.8 51.9 51.9 51.9 51.9s51.9-12.2 51.9-51.9v-44.5H332.1z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M384 149.9c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9v20.8c13 0 13 11.9 26 11.9s13-11.9 26-11.9 13 11.9 26 11.9 13-11.9 26-11.9v-20.8c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9zm0-41.6c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9v20.8c13 0 13 11.9 26 11.9s13-11.9 26-11.9 13 11.9 26 11.9 13-11.9 26-11.9v-20.8c-13 0-13 11.9-26 11.9s-13-11.9-26-11.9z",
    fill: "#F3F3F3"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M256 0v22.6l-46.1 30.7H256v64h-46.1L256 148v22.7h-22.6l-73.4-49v49H96v-49l-73.4 49H0V148l46.1-30.7H0v-64h46.1L0 22.6V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0v15.1l57.4 38.2H80zm256 0v15.1l-57.4 38.2H176z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0v15.1l57.4 38.2H80zm256 0v15.1l-57.4 38.2H176zM0 170.7v-15.1l57.4-38.3H80zm256 0v-15.1l-57.4-38.3H176z"
  })));
}, mke = function(e) {
  var t = e.title, r = q(e, ITe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#36B6CC",
    d: "M0 0h513v342H0V0z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FFD400",
    cx: 256.5,
    cy: 170.9,
    r: 68.4
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFD400",
    d: "m256.5 251.5-27.9 41.7-7.1-49.7-43.2 25.5 15.2-47.8-50 4.2 34.4-36.5-46.9-18 46.8-18-34.4-36.5 50 4.2-15.2-47.8 43.2 25.4 7.1-49.7 27.9 41.7 27.9-41.7 7.1 49.7 43.2-25.4-15.2 47.8 50-4.2-34.3 36.6 46.8 17.9-46.8 18 34.4 36.5-50-4.2 15.2 47.8-43.2-25.4-7.1 49.7c0-.1-27.9-41.8-27.9-41.8zm0-.8c44.1 0 79.9-35.8 79.9-79.9S300.6 91 256.5 91s-79.9 35.8-79.9 79.9 35.8 79.8 79.9 79.8zM22.8 28.3c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V28.3zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6V74zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0 45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H28.5c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm22.8-22.8c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7V245c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.7c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V188zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6v-11.4zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V96.8zm0-45.6c0-3.2 2.4-5.7 5.7-5.7h11.3c3.2 0 5.7 2.4 5.7 5.7v11.3c.1 3.1-2.4 5.7-5.6 5.7H51.3c-3.1 0-5.7-2.5-5.7-5.6V51.2z"
  }));
}, gke = function(e) {
  var t = e.title, r = q(e, RTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 .1h513v90.7H0zm0 251.2h513V342H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FFF",
    cx: 256.5,
    cy: 171,
    r: 65.9
  }));
}, vke = function(e) {
  var t = e.title, r = q(e, PTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 .2h513v90.7H0zm.5 251.1H513V342H.5z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M290.3 193.5 256 130.7l-34.3 62.8h25.7v17.2h17.2v-17.2z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#14AF5A",
    d: "M241.3 213.1c4.4-4.4 4.4-11.6-.1-16l4.7 4.7c-5.2-4.7-12.2-6.6-19.1-5.3l-23.5 5.9c-6.1 1.5-6.8-.4-1.8-4.2l27.1-20.3c5.1-3.8 4.2-6.9-2.3-6.9h-11c-6.4 0-7-2.3-1.5-5.1l25.3-12.7c5.6-2.8 5.1-5.1-1.5-5.1h-11c-6.4 0-7.4-3.1-2.3-6.9l27.1-20.3c5.6-3.8 12.9-3.8 18.5 0l27.1 20.3c5.1 3.8 4.2 6.9-2.3 6.9h-11c-6.4 0-7 2.3-1.5 5.1l25.3 12.7c5.6 2.8 5.1 5.1-1.5 5.1h-11c-6.4 0-7.4 3.1-2.3 6.9l27.1 20.3c5.1 3.8 4.4 5.7-1.8 4.2l-23.5-5.9c-6.8-1.3-13.9.6-19.1 5.3l4.7-4.7c-4.4 4.4-4.5 11.5-.1 16l6.8 6.8c4.4 4.4 3.1 8-3.3 8h-45.8c-6.2 0-7.7-3.6-3.3-8 .1.1 6.9-6.8 6.9-6.8z"
  }));
}, yke = function(e) {
  var t = e.title, r = q(e, DTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#55B2FF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#F3F3F3",
    d: "M148.5 298.1h216l-108-254.2z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#333",
    d: "m186 272.7 70.5-160.3L327 272.7z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M148.5 298.1h216l-108-101.7z"
  }));
}, bke = function(e) {
  var t = e.title, r = q(e, NTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v171H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M149.3 98.1c0-14-11.3-25.3-25.3-25.3-6.5 0-12.4 2.4-16.9 6.4V64.4h8.4V47.5h-8.4v-8.4H90.3v8.4h-8.4v16.9h8.4v14.9c-4.5-4-10.4-6.4-16.9-6.4-14 0-25.3 11.3-25.3 25.3 0 7.5 3.3 14.2 8.4 18.8v14.9h84.3V117c5.3-4.7 8.5-11.5 8.5-18.9z"
  }));
}, wke = function(e) {
  var t = e.title, r = q(e, LTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#A2001D",
    d: "M222.6 22.3h267.1v296.8H222.6z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M22.3 22.3h200.3v296.8H22.3z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M200.3 0h22.3v342h-22.3z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M22.3 22.3h89v296.8h-89z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FF9811",
    d: "M111.3 22.3h89v296.8h-89z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M368.2 156.8c-1.4-2 0-37.9 0-37.9.9-7.4.1-8.4 1-11.4.9-2.9 5.4-11.6 5.4-11.6s-6-2.3-10.3-.6c-4.3 1.7-24.7-7.5-31.2 3.4-4.4 7-23.6 16.2-24.6 14-1-2.2-5.9-5-6.9-2.9s-.7 13.9 0 16c.8 2.6 9.8 2 12.3 3.1 3.7 1.8 12.2 8.2 11.9 10.7-.3 2.5-22.5-6-24.2-4.5-1.4 1.2-1.9 13.2-.4 15 1.8 2.1 23.4 5.6 25 7.5 1.6 1.9-13.1 7.4-12.3 25 .7 14.7 8 17.4 8 17.4s-2.4 3.6-7.8 3.1c-6.2-.6-27.4-17.7-27.4-17.7s-3.5-109 3.6-121.4c4.9-8.5-22.7 10.1-22.7 50.8V151c0 6.6-1.4 22.4 2.6 34 0 0-.4 46.9 1.5 49.6s12.7 2.2 14.8 0 0-30 0-30c7.7.2 18.3 17.5 32.5 16.4 20.6-1.6 28.7-9.9 34.3-5 8.1 7.1 5.5 23.2.4 31.5-2.2 3.5-14.3 4.7-15.7 7.6-1.4 2.9.5 5.4.5 5.4h29.7s1.4-20.5 2.7-26.1c1.3-5.7-.6-10.7 5.9-10.4 23.5 1.1 39.8-15.3 45.5-8 3.2 4.1 5.6 29.9 3.3 33.3-2.2 3.4-13.8 2.8-15.2 6.7-1.4 4 .8 4.4.8 4.4h29.7s-.4-21.2 2.5-27.7 4.9-10.4 9.3-17.2c4.4-6.8 11.3-15.7 11.3-36.2 0-14.2-8.1-22.8-8.1-22.8H417c-14.1.2-47.4 2.3-48.8.3zm-136-124.5c10.7-10.6 20.2-2.7 22.2 2.1 1.9 4.8 2.1 8.2 2.8 13.6.9 6.9 4.9 14 4.9 14s-7.1-3.8-14.7-4.2c-4.7-.3-9-.6-13.6-2.5-5.7-2.3-11.7-12.9-1.6-23zm248.4-.1c10.7 10.6 2.8 20.2-2 22.2s-8.2 2.1-13.6 2.8c-6.9.9-14 5-14 5s3.7-7.1 4.2-14.7c.3-4.7.6-9.1 2.4-13.6 2.2-5.7 12.8-11.8 23-1.7zm.1 276.9c-10.7 10.6-20.2 2.6-22.2-2.2-1.9-4.8-2.1-8.2-2.7-13.6-.8-6.9-4.9-14.1-4.9-14.1s7 3.8 14.7 4.3c4.7.3 9 .6 13.6 2.5 5.7 2.4 11.7 13.1 1.5 23.1zm-248.2-.1c-10.6-10.7-2.7-20.2 2.1-22.2 4.8-1.9 8.2-2.1 13.6-2.8 6.9-.9 14-4.9 14-4.9s-3.8 7.1-4.2 14.7c-.3 4.7-.6 9-2.5 13.6-2.3 5.7-12.9 11.8-23 1.6z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "none",
    stroke: "#FFDA44",
    strokeWidth: 6,
    strokeMiterlimit: 10,
    d: "M446.9 162.4s7.5-2.6 8.4-16.1c.6-8.6-19.8-16-39-11.5-19.7 4.6-34-3.1-34-14.6 0-22.9 29.7-16.2 38.9-11.3 9.1 4.9 29.7 23.5 35.1 9.4"
  }));
}, xke = function(e) {
  var t = e.title, r = q(e, $Te);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h513v31.1H0zm0 62.2h513v31.1H0zm0 62.3h513v31.1H0zm0 62.3h513v31.1H0zm0 62.5h513v31.1H0zm0 61.6h513V342H0z",
    fill: "#bf0a30"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#002868",
    d: "M0 0h155.6v155.6H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "m77.8 30.2 10.7 32.9h34.6l-28 20.4 10.7 32.9-28-20.3-28 20.3 10.7-32.9-28-20.4h34.6z"
  }));
}, Eke = function(e) {
  var t = e.title, r = q(e, FTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M0 227.6h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m245.2 171 7.7-23.1c2-5.9 5.1-6 7.1 0l7.7 23.1 19.4 29.1c1.7 2.6 1.3 6.3-1.2 8 0 0-6.9 8-29.5 8s-29.5-8-29.5-8c-2.4-2-2.9-5.4-1.2-8l19.5-29.1z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M256.5 171c-12.5 0-22.6-10.1-22.6-22.6 0-12.5 10.1-22.6 22.6-22.6s22.6 10.1 22.6 22.6c0 12.5-10.2 22.6-22.6 22.6zm0 0c6.2 0 11.3-16.3 11.3-22.6 0-6.2-5.1-11.3-11.3-11.3-6.2 0-11.3 5.1-11.3 11.3 0 6.3 5 22.6 11.3 22.6z"
  }));
}, Ske = function(e) {
  var t = e.title, r = q(e, BTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 228h513v114H0z"
  }));
}, Cke = function(e) {
  var t = e.title, r = q(e, zTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M0 228h513v114H0z"
  }));
}, Tke = function(e) {
  var t = e.title, r = q(e, HTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    className: "prefix__st1",
    d: "M0 0h513v127.6H0zm0 214.4h513V342H0z",
    fill: "#A2001D"
  }));
}, Ake = function(e) {
  var t = e.title, r = q(e, UTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#496E2D",
    d: "M0 228h513v114H0z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "m281.4 150.7 9 12.3 14.5-4.7-9 12.4 9 12.3-14.5-4.7-9 12.3v-15.2l-14.5-4.7 14.5-4.7z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M257 201.5c-17 0-30.9-13.8-30.9-30.9s13.8-30.9 30.9-30.9c5.3 0 10.3 1.3 14.7 3.7-6.9-6.7-16.2-10.8-26.6-10.8-21 0-38 17-38 38s17 38 38 38c10.3 0 19.7-4.1 26.6-10.8-4.4 2.4-9.4 3.7-14.7 3.7z"
  })));
}, Mke = function(e) {
  var t = e.title, r = q(e, VTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 .3V342h513V.3z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#20661B",
    d: "M359.8 148.9h-73.3l-22.7-69.7-22.7 69.7h-73.3l59.3 43.1-22.7 69.7 59.3-43.1 59.3 43.1-22.5-69.7 59.3-43.1zm-116.1 37.7 7.7-23.6h24.8l7.7 23.6-20.1 14.6-20.1-14.6zm27.9-37.7H256l7.8-24 7.8 24zm24.3 29-4.8-14.9h25.3l-20.5 14.9zM236.6 163l-4.8 14.9-20.5-14.9h25.3zm-5.3 61.8 7.8-24 12.6 9.2-20.4 14.8zm44.5-14.9 12.6-9.2 7.8 24-20.4-14.8z"
  }));
}, kke = function(e) {
  var t = e.title, r = q(e, jTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h512v341.333H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#c70000",
    d: "M0 85.333h512V256H0z"
  }));
}, _ke = function(e) {
  var t = e.title, r = q(e, WTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#AF7F59",
    d: "M206.2 129.1h33.2L256 79.3l16.6 49.8h33.2v99.6L256 262l-49.8-33.2v-99.7zm33.2 33.3v49.8h33.2v-49.8h-33.2z"
  }));
}, Oke = function(e) {
  var t = e.title, r = q(e, GTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#E6BE53",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#E01D24",
    d: "M20 20h473v302H20z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#E6BE53",
    d: "M248.5 112.9c4.4 4.4 11.6 4.4 16 0l-4.7 4.7 22.7-22.7c4.9-4.5 12.1-5.6 18.2-2.8l2.1 1c5.7 2.9 6.7 8.7 2.3 13.1l4.7-4.7-22.8 22.8c-4.5 4.9-5.6 12.1-2.8 18.2l1 2.1c2.9 5.7 5.1 15.4 5.1 21.6v-11.3c0 6.2 4.4 9.1 10.2 6.2l2.1-1c5.7-2.9 6.7-8.7 2.3-13.1l4.7 4.7c-4.4-4.4-4.4-11.6 0-16l-4.7 4.7c5.2-5.5 9.6-11.6 13.1-18.2l1-2.1c2.9-5.7 6.3-15.1 7.9-21.2l5.8-23.3c1.5-6 5.9-6.8 9.6-1.8l20.2 26.9c3.8 5.1 6.9 14 6.9 20.6v22.4c0 6.3-2.2 15.8-5.1 21.7l-1 2.1c-3.5 6.6-7.9 12.7-13.1 18.2l-6.8 6.8c-5.4 5.2-11.5 9.6-18.2 13.1l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.2 0-6.9 2.2-1.1 5.1l2.1 1c5.7 2.9 13.8 8.7 18.2 13.1l-4.7-4.7c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L339 226c4.6 4.9 5.7 12.1 2.9 18.2l-1 2.1c-2.9 5.7-10.4 10.2-16.4 10.2-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.5-3.6-11.8-8.9-15.4-15.4l-1-2.1c-2.9-5.7-8.7-6.7-13.1-2.3l4.7-4.7c-4.4 4.7-5.2 11.8-1.8 17.3l10.3 15.4c3.4 5.1 2 12.1-3.1 15.5L266 284.4c-5.7 3.4-12.8 3.4-18.6 0L232 274.1c-5.1-3.4-6.5-10.3-3.1-15.5l10.3-15.4c3.4-5.5 2.6-12.6-1.8-17.3l4.7 4.7c-4.4-4.4-10.2-3.6-13.1 2.3l-1 2.1c-2.9 5.7-9.5 12.4-15.4 15.4l-2.1 1c-5.7 2.9-15.5 5.1-21.6 5.1-6.9-.3-13.1-4.2-16.4-10.2l-1-2.1c-2.8-6.1-1.6-13.3 2.9-18.2l-4.7 4.7c4.4-4.4 11.6-4.4 16 0L181 226c4.4 4.4 11.6 4.4 16 0l-4.7 4.7c5.5-5.2 11.6-9.6 18.2-13.1l2.1-1c5.7-2.9 5-5.1-1.1-5.1-7.5-.3-14.8-2-21.6-5.1l-2.1-1c-6.6-3.5-12.7-7.9-18.2-13.1l-6.8-6.8c-5.2-5.4-9.6-11.5-13.1-18.2l-1-2.1c-3.1-6.8-4.9-14.2-5.1-21.7V121c0-6.3 3.1-15.6 6.9-20.6l20.2-26.9c3.8-5.1 8.1-4.3 9.6 1.8l5.8 23.3c2 7.3 4.6 14.4 7.9 21.2l1 2.1c2.9 5.7 8.7 13.8 13.1 18.2l-4.7-4.7c4.4 4.4 4.4 11.6 0 16l4.7-4.7c-4.4 4.4-3.6 10.2 2.3 13.1l2.1 1c5.7 2.9 10.2 0 10.2-6.2v11.3c0-6.2 2.2-15.7 5.1-21.6l1-2.1c2.8-6.1 1.7-13.2-2.8-18.2l-22.7-22.7 4.7 4.7c-4.4-4.4-3.6-10.2 2.3-13.1l2.1-1c6.1-2.8 13.2-1.7 18.2 2.8l22.7 22.7-4.8-4.5zm-18-40.7c-4.4-4.4-3.2-9.5 2.8-11.5l12.4-4.2c6-2 15.5-2 21.5 0l12.4 4.2c6 2 7.2 7.1 2.8 11.5l-6.8 6.8c-5.3 4.7-12.1 7.5-19.2 7.9-6.2 0-14.8-3.5-19.2-7.9.1 0-6.7-6.8-6.7-6.8z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#215F90",
    d: "M233.9 200.2c0 6.2 1.7 6.4 4.2.5 0 0 7.1-23.2 18.4-23.2 11.3 0 18.6 23.6 18.6 23.6 2.2 5.7 4 5.3 4-1.1v-11.2c0-18.7-10.1-33.9-22.6-33.9-12.5 0-22.6 15.2-22.6 33.9v11.4z"
  }));
}, Ike = function(e) {
  var t = e.title, r = q(e, KTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108 72"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h108v72H0z",
    fill: "#003787"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h108L60 48v24H48V48z",
    fill: "#fff"
  }), /* @__PURE__ */ p.createElement("circle", {
    cx: 54,
    cy: 30,
    r: 8,
    fill: "#f9d90f"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M44 30h20L54 48z",
    fill: "#fff"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M54 48 38 33h32z",
    fill: "#cf142b"
  }));
}, Rke = function(e) {
  var t = e.title, r = q(e, qTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M512 426.666V85.329H0v341.337h512z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M512 85.331H0v170.666h512V85.331z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h181.793v341.337H0z"
  }));
}, Pke = function(e) {
  var t = e.title, r = q(e, YTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#1E509C",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M513 176.1V81.3L0 342l513-165.9z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#F18D36",
    d: "M513 0v81.3L0 342 513 0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "m126.7 99.3-7.8-54.1-7.7 54.1-20.8-23.7 10.7 31.6-31.5-10.7 23.6 20.8-54.1 7.7 54.1 7.7-23.6 20.8 31.5-10.7-10.7 31.6 20.8-23.7 7.7 54.1 7.8-54.1 20.7 23.7-10.6-31.6 31.5 10.7-23.6-20.8 54-7.7-54-7.7 23.6-20.8-31.5 10.7 10.6-31.6z"
  }));
}, Dke = function(e) {
  var t = e.title, r = q(e, XTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M383.875 426.662 256 252.286l26.827 174.376zM133.565 85.33 256 252.286 230.314 85.33zm95.606 341.332L256 252.286 128.124 426.662zM0 85.33V212.9l256 39.386L28.333 85.33zm0 341.332h18.212L256 252.286 0 291.67zm256-174.376L512 212.9V85.33h-28.331zM281.686 85.33 256 252.286 378.434 85.33zM512 426.662V291.671l-256-39.385 237.787 174.376z"
  }), /* @__PURE__ */ p.createElement("circle", {
    cx: 256,
    cy: 252.29,
    r: 59.359
  })), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FFDA44",
    cx: 256,
    cy: 252.29,
    r: 44.522
  }));
}, Nke = function(e) {
  var t = e.title, r = q(e, ZTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.331h170.663v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
}, Lke = function(e) {
  var t = e.title, r = q(e, QTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M384 227.261h-97.783L256 134.265l-30.217 92.997H128l79.108 57.475-30.217 92.998L256 320.925l79.108 56.81-30.217-92.998L384 227.261z"
  }));
}, $ke = function(e) {
  var t = e.title, r = q(e, JTe);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#095FAD",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M342 0h171v342H342zM0 0h171v342H0z",
    fill: "#BE1229"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFDA44"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M108.3 166.3h14.8v74.2h-14.8zm-59.4 0h14.8v74.2H48.9z"
  }), /* @__PURE__ */ p.createElement("circle", {
    cx: 86,
    cy: 203.4,
    r: 14.8
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M71.2 225.7h29.7v14.8H71.2zm0-59.4h29.7v14.8H71.2z"
  }), /* @__PURE__ */ p.createElement("circle", {
    cx: 86,
    cy: 144,
    r: 14.8
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M76.3 123.9h19.5L86 108.3z"
  })));
}, Fke = function(e) {
  var t = e.title, r = q(e, e7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#00745a",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M285.682 248.878c-4.19 0-8.166.836-11.861 2.164 2.023-4.509 3.379-9.527 3.379-14.885 0-21.201-21.201-37.101-21.201-37.101s-21.201 15.901-21.201 37.101c0 5.357 1.356 10.375 3.379 14.885-3.693-1.328-7.671-2.164-11.861-2.164-21.201 0-37.101 21.201-37.101 21.201s15.901 21.201 37.101 21.201c12.429 0 23.031-7.286 29.682-13.315 6.65 6.03 17.251 13.315 29.682 13.315 21.201 0 37.101-21.201 37.101-21.201s-15.899-21.201-37.099-21.201z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m256 152.111 4.38 13.476h14.171l-11.464 8.332 4.376 13.476-11.463-8.33-11.463 8.33 4.376-13.476-11.464-8.332h14.171zm-53.888 23.572 8.425 7.585 9.818-5.667-4.61 10.355 8.423 7.588-11.274-1.185-4.611 10.355-2.358-11.088-11.275-1.185 9.818-5.669zm-39.45 39.449 11.09 2.358 5.668-9.818 1.186 11.274 11.089 2.358-10.357 4.61 1.186 11.274-7.587-8.423-10.357 4.61 5.669-9.818zm147.227-39.449-8.425 7.585-9.818-5.667 4.611 10.355-8.425 7.588 11.275-1.185 4.61 10.355 2.359-11.088 11.275-1.185-9.818-5.669zm39.449 39.449-11.089 2.358-5.669-9.818-1.186 11.274-11.088 2.358 10.357 4.61-1.185 11.274 7.586-8.423 10.357 4.61-5.669-9.818z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M256 350.642c16.84 0 32.363-5.619 44.816-15.073h-89.63c12.451 9.454 27.974 15.073 44.814 15.073zm-68.023-44.522a74.138 74.138 0 0 0 8.85 15.073h118.345a74.13 74.13 0 0 0 8.85-15.073H187.977z",
    fill: "#FFF"
  }));
}, Bke = function(e) {
  var t = e.title, r = q(e, t7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0071BC",
    d: "M0 0h750v500H0V0z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFF",
    stroke: "#000",
    strokeWidth: 1.9
  }, /* @__PURE__ */ p.createElement("circle", {
    cx: 375,
    cy: 245,
    r: 225,
    fill: "#fff"
  }), /* @__PURE__ */ p.createElement("circle", {
    cx: 375,
    cy: 245,
    r: 165,
    fill: "#0071BC"
  })), /* @__PURE__ */ p.createElement("g", {
    stroke: "#000"
  }, /* @__PURE__ */ p.createElement("path", {
    fill: "#8C8A8C",
    strokeWidth: 1.9,
    d: "M444.7 450c.7 11-7.8 20-18.8 20H323.6c-11 0-19.5-9-19-20l16.7-325c.6-11 10-20 21-20h61.4c11 0 20.5 9 21.2 20l19.8 325z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    strokeWidth: 2,
    strokeLinejoin: "round",
    d: "m373 114 30 93h97l-78 56 29 92-78-56-78 57 30-93-79-57h97l30-92z"
  })));
}, zke = function(e) {
  var t = e.title, r = q(e, n7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    viewBox: "0 0 900 600",
    xmlns: "http://www.w3.org/2000/svg"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#231f1e",
    d: "M0 0h900v600H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#00a650",
    d: "M0 0h900v300H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#ef1923",
    d: "m0 0 450 300L0 600z"
  }));
}, Hke = function(e) {
  var t = e.title, r = q(e, r7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 100 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#006233",
    d: "M0 100h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#cd2a3e",
    d: "M0 100h513v46H0zm0 296h513v46H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#ffc400",
    d: "M256 298.851c-45.956 0-84.348-32.298-93.767-75.429A96.288 96.288 0 0 0 160 243.994c0 53.02 42.979 96 96 96s96-42.98 96-96c0-7.066-.785-13.942-2.233-20.572-9.419 43.131-47.811 75.429-93.767 75.429z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#ffc400",
    d: "m255.999 171.994 8.935 27.502h28.918l-23.394 16.996 8.936 27.503-23.395-16.998-23.394 16.998 8.937-27.503-23.394-16.996h28.915z"
  }));
}, Uke = function(e) {
  var t = e.title, r = q(e, i7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#1B4991",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#00A2B8",
    stroke: "#FFF",
    strokeWidth: 3,
    d: "M318.2 106.7v106.5c0 51.9 67.8 67.8 67.8 67.8s67.8-15.9 67.8-67.8V106.7H318.2z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#A35023",
    d: "M319.7 212.7c0 50.8 66.3 66.3 66.3 66.3s66.3-15.6 66.3-66.3H319.7z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M415.1 155.1h-19.4v-19.4h-19.4v19.4H357v19.4h19.3v58.1h19.4v-58.1h19.4z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M256 0v30.6l-45.2 25.1H256V115h-59.1l59.1 32.8v22.9h-26.7l-73.5-40.9v40.9h-55.6v-48.6l-87.5 48.6H0v-30.6L45.2 115H0V55.7h59.1L0 22.8V0h26.7l73.5 40.8V0h55.6v48.6L243.3 0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M144 0h-32v69.3H0v32h112v69.4h32v-69.4h112v-32H144z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M155.8 115 256 170.7v-15.8L184.2 115z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M155.8 115 256 170.7v-15.8L184.2 115zm-84 0L0 154.9v15.8L100.2 115z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M100.2 55.6 0 0v15.7l71.8 39.9zm84 0L256 15.7V0L155.8 55.6z"
  }));
}, Vke = function(e) {
  var t = e.title, r = q(e, s7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#C31B28",
    d: "M256 0h256.5v342H256z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#ACABB1",
    stroke: "#C31B28",
    strokeWidth: 2,
    d: "M101.2 68.2V33H66v35.2H30.8v35.2H66v35.2h35.2v-35.2h35.2V68.2z"
  }));
}, jke = function(e) {
  var t = e.title, r = q(e, o7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#f7ce00",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#e32737",
    d: "M0 85.331h512v85.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#191f6a",
    d: "M0 170.657h512v85.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#00a04e",
    d: "M0 341.331h512v85.337H0z"
  }));
}, Wke = function(e) {
  var t = e.title, r = q(e, a7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#d01920",
    d: "M0 85.331h512v341.333H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#017c3b",
    d: "M144.696 174.375h222.609v163.25H144.696z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M283.484 304.226c-26.637 0-48.232-21.594-48.232-48.232s21.594-48.232 48.232-48.232c8.306 0 16.12 2.1 22.943 5.797-10.703-10.467-25.341-16.927-41.494-16.927-32.784 0-59.362 26.577-59.362 59.362s26.578 59.362 59.362 59.362c16.154 0 30.791-6.461 41.494-16.927-6.822 3.698-14.636 5.797-22.943 5.797z"
  }));
}, Gke = function(e) {
  var t = e.title, r = q(e, l7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#272727",
    d: "M0 0h512v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#e40112",
    d: "M0 114h512v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#07893f",
    d: "M0 228h512v114H0z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#e40112",
    cx: 256,
    cy: 125,
    r: 95
  }));
}, Kke = function(e) {
  var t = e.title, r = q(e, c7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#dc2339",
    d: "M342 0H0v341.3h513V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#11865d",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M171 0h171v342H171z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#8C9157",
    d: "M195.8 171.2c0 21.6 11.5 41.7 30.3 52.5 5.8 3.4 13.2 1.4 16.6-4.4 3.4-5.8 1.4-13.2-4.4-16.6-11.3-6.5-18.2-18.5-18.2-31.5 0-6.7-5.4-12.1-12.1-12.1-6.7 0-12.2 5.4-12.2 12.1zm93.4 51.1c17.5-11.1 28-30.4 28-51.1 0-6.7-5.4-12.1-12.1-12.1s-12.1 5.4-12.1 12.1c0 12.4-6.3 24-16.8 30.7-5.7 3.5-7.5 10.9-4.1 16.7s10.9 7.5 16.7 4.1c0-.2.2-.3.4-.4z"
  }), /* @__PURE__ */ p.createElement("ellipse", {
    fill: "#C59262",
    cx: 256.5,
    cy: 159.1,
    rx: 24.3,
    ry: 36.4
  }));
}, qke = function(e) {
  var t = e.title, r = q(e, u7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h513v24.4H0zm0 48.9h513v24.4H0zm0 48.8h513v24.4H0zm0 48.9h513V171H0zm0 48.8h513v24.4H0zm0 48.9h513v24.4H0zm0 48.8h513v24.4H0z",
    fill: "#c00"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#006",
    d: "M0 0h256.5v195.4H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M153.3 42.1C122.6 30.7 88.5 46.3 77.1 77s4.2 64.8 34.9 76.2c13.3 5 28 5 41.4 0-30.7 24.5-75.4 19.6-100-11.1s-19.6-75.4 11.1-100c26-20.7 62.9-20.7 88.8 0zm26.7 75-20.6 23.3 5.4-30.6-31-1.6 27.3-14.9L143 68l28.6 12 8.4-29.9 8.4 29.9L217 68l-18 25.4 27.3 14.9-31 1.6 5.4 30.6-20.7-23.4z",
    fill: "#fc0"
  }));
}, Yke = function(e) {
  var t = e.title, r = q(e, d7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#f4d900",
    d: "M0 323.333h513v104H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#006d66",
    d: "M0 85.333h513v104H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 204.333h513v104H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#cb0f31",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#f4d900",
    d: "m83.477 195.132 15.107 46.498h48.894l-39.554 28.739 15.107 46.499-39.554-28.738-39.555 28.738 15.11-46.499-39.554-28.739H68.37z"
  }));
}, Xke = function(e) {
  var t = e.title, r = q(e, f7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 426.663V85.337h512"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#A2001D",
    d: "M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "m187.737 189.212-22.741 10.696 12.11 22.024-24.693-4.724-3.129 24.945-17.199-18.347-17.2 18.347-3.129-24.945-24.693 4.723 12.109-22.023-22.739-10.696 22.74-10.697-12.11-22.022 24.693 4.722 3.13-24.944 17.199 18.347 17.2-18.347 3.128 24.944 24.693-4.722-12.108 22.024z"
  }));
}, Zke = function(e) {
  var t = e.title, r = q(e, h7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 426.7"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#009543",
    d: "M0 293h640v133.7H0V293z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#ED4135",
    d: "M0 132h640v161.3H0V132z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0035AD",
    d: "M0 0h640v133.3H0V0z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FAE600",
    stroke: "#000",
    strokeWidth: 5.3,
    cx: 240,
    cy: 213.3,
    r: 157.3
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m307.9 354.5-31.8 12-36.1 4.2-37.8-2.4-35.9-15.5s28.6-29.3 40.7-33.5c8.6-3 22.4-3.7 22.4-3.7V122l-.3-66H246l-.5 67.5v191.7s15.3 1.2 22.1 4.1c11.3 4.9 40.3 35.2 40.3 35.2z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m212.727 102.375 42.955-21.418 5.577 11.187-42.955 21.417z"
  }), /* @__PURE__ */ p.createElement("ellipse", {
    cx: 237.8,
    cy: 280.5,
    rx: 16.8,
    ry: 26.5
  }), /* @__PURE__ */ p.createElement("circle", {
    cx: 237.4,
    cy: 143.4,
    r: 20.9
  }), /* @__PURE__ */ p.createElement("ellipse", {
    cx: 238.4,
    cy: 211.1,
    rx: 19.9,
    ry: 12.1
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M213.8 177h47v10h-47zm0 57h47v10h-47z"
  }));
}, Qke = function(e) {
  var t = e.title, r = q(e, p7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#e05206",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0db02b",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#e05206",
    cx: 256,
    cy: 256,
    r: 32
  }));
}, Jke = function(e) {
  var t = e.title, r = q(e, m7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.5 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.5h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.5h171v342H0zm342 0h171v342H342zm-38 226.495-48-152.001-48 152.001h36v39.999h24v-39.999z",
    fill: "#007b23"
  }));
}, e_e = function(e) {
  var t = e.title, r = q(e, g7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.5 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.5h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.5h171v342H0zm342 0h171v342H342z",
    fill: "#007b23"
  }));
}, t_e = function(e) {
  var t = e.title, r = q(e, v7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#338AF3"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M256 214.447c-22.949 0-41.553 18.603-41.553 41.553S233.05 297.553 256 297.553c22.949 0 41.553-18.603 41.553-41.553S278.949 214.447 256 214.447zm0 65.298c-13.114 0-23.745-10.631-23.745-23.745s10.631-23.745 23.745-23.745 23.745 10.631 23.745 23.745-10.631 23.745-23.745 23.745z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M276.563 261.936 256 256l-20.563 5.936-6.855 11.873h54.836z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "m256 226.32-13.709 23.744L256 256l13.709-5.936z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M235.437 261.936h41.126l-6.854-11.872h-27.418z"
  }));
}, n_e = function(e) {
  var t = e.title, r = q(e, y7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 114h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#cd1f2a",
    d: "M0 0h513v114H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#1d4185",
    d: "M0 228h513v114H0z"
  }));
}, r_e = function(e) {
  var t = e.title, r = q(e, b7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M512 295.883H202.195v130.783h-79.76V295.883H0v-79.772h122.435V85.329h79.76v130.782H512v61.218z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#2E52B2",
    d: "M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"
  }));
}, i_e = function(e) {
  var t = e.title, r = q(e, w7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 426.663V85.337l280.419 174.75H87.61l183.576 166.576z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M244.769 249.888 10.199 103.71v312.754h234.57L61.193 249.888z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "m98.003 324.433-14.589-6.863 7.77-14.13-15.844 3.03-2.008-16.005-11.035 11.772-11.036-11.772-2.008 16.005-15.843-3.031 7.77 14.131-14.591 6.863 14.591 6.862-7.77 14.13 15.844-3.029 2.007 16.004 11.036-11.772L73.332 358.4l2.008-16.004 15.843 3.03-7.769-14.13zm-9.735-132.771-10.612-4.991 5.651-10.278-11.523 2.205-1.461-11.641-8.026 8.561-8.026-8.561-1.46 11.641-11.525-2.205 5.652 10.278-10.613 4.991 25.972 5.194z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M93.462 191.662c0 17.212-13.953 31.165-31.165 31.165s-31.165-13.953-31.165-31.165"
  })));
}, s_e = function(e) {
  var t = e.title, r = q(e, x7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 239.994h512v32H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "m174.802 341.329-19.124 8.996 10.184 18.521-20.767-3.973-2.631 20.978L128 370.422l-14.465 15.429-2.63-20.978-20.767 3.973 10.183-18.521-19.123-8.996 19.124-8.995-10.184-18.52 20.766 3.971 2.632-20.978L128 312.236l14.465-15.429 2.63 20.978 20.767-3.971-10.183 18.521z"
  }));
}, o_e = function(e) {
  var t = e.title, r = q(e, E7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h256v170.663H0z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.329v15.083l57.377 38.251H80z"
  })), /* @__PURE__ */ p.createElement("path", {
    d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M256 85.329v15.083l-57.377 38.251H176z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 85.329v15.083l57.377 38.251H80z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M256 85.329v15.083l-57.377 38.251H176z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 255.997v-15.082l57.377-38.252H80z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 233.376v-30.713h46.069zm96 22.618v-48.912l-73.372 48.912z",
    fill: "#2E52B2"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M256 255.997v-15.082l-57.377-38.252H176z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#2E52B2"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M256 233.376v-30.713h-46.069zm-96 22.618v-48.912l73.372 48.912z"
  }), /* @__PURE__ */ p.createElement("circle", {
    cx: 128,
    cy: 170.66,
    r: 22.627
  })), /* @__PURE__ */ p.createElement("path", {
    d: "m128 154.663 3.97 12.222h12.854l-10.398 7.556 3.971 12.222L128 179.109l-10.398 7.554 3.972-12.222-10.398-7.556h12.853zm0 65.14 2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zm0-117.334 2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zm69.931 58.667 2.365 7.277h7.653l-6.192 4.499 2.365 7.279-6.191-4.498-6.191 4.498 2.365-7.279-6.191-4.499h7.652zm-139.862 0 2.364 7.277h7.653l-6.191 4.499 2.364 7.279-6.19-4.498-6.191 4.498 2.365-7.279-6.192-4.499h7.653z",
    fill: "#FFDA44"
  }));
}, a_e = function(e) {
  var t = e.title, r = q(e, S7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m425.301 233.745 3.388 10.428h10.963l-8.87 6.444 3.388 10.427-8.869-6.444-8.871 6.444 3.388-10.427-8.87-6.444h10.963zm-39.194 75.072 5.083 15.642h16.445l-13.305 9.667 5.082 15.64-13.305-9.667-13.305 9.667 5.083-15.64-13.305-9.667h16.445zm1.481-122.846 4.236 13.036h13.704l-11.088 8.054 4.235 13.034-11.087-8.056-11.088 8.056 4.235-13.034-11.087-8.054h13.704zm-37.712 47.32 5.082 15.641h16.446l-13.306 9.666 5.084 15.641-13.306-9.666-13.305 9.666 5.082-15.641-13.305-9.666h16.445z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M256.003 85.329v30.564l-45.178 25.088h45.178v59.359H196.89l59.113 32.846v22.806h-26.69l-73.484-40.826v40.826h-55.652v-48.573l-87.429 48.573H.003v-30.553l45.168-25.099H.003v-59.359h59.103L.003 108.147V85.329h26.68l73.494 40.838V85.329h55.652v48.573l87.43-48.573z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.334H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M155.826 200.344 256 255.998v-15.739l-71.847-39.915zm-83.98 0L0 240.259v15.739l100.174-55.654z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.983 0 85.33v15.738l71.847 39.915z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.983 0 85.33v15.738l71.847 39.915z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M100.174 140.983 0 85.33v15.738l71.847 39.915zm83.98 0L256 101.068V85.33l-100.174 55.653z",
    fill: "#D80027"
  }));
}, l_e = function(e) {
  var t = e.title, r = q(e, C7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M138 0h377v114H138z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#4A7C3A",
    d: "M138 230h377v114H138z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 10,
    strokeMiterlimit: 2
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M40.3 35.2s37.1 48 50.8 54.5c13.7 6.5 17.1 5.7 17.1 5.7"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M100 35.2S62.9 80.6 53.3 87.6c-9.6 7-18.7 7.8-18.7 7.8m17.1-30.1h37.9M70.7 35.2v30.1"
  })));
}, c_e = function(e) {
  var t = e.title, r = q(e, T7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M256 256v170.663H0V256h256z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M512 85.337V256H256V85.337h256z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "m128 123.034 11.824 36.389h38.263l-30.955 22.491 11.823 36.389L128 195.813l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "m384 293.697 11.824 36.389h38.263l-30.955 22.491 11.823 36.389L384 366.476l-30.955 22.49 11.823-36.389-30.955-22.491h38.263z"
  }));
}, u_e = function(e) {
  var t = e.title, r = q(e, A7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.331h170.663v341.337H0zm341.337 0H512v341.337H341.337z",
    fill: "#D80027"
  }));
}, d_e = function(e) {
  var t = e.title, r = q(e, M7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M293.991 256c0 20.982-17.01 33.243-37.992 33.243S218.008 276.982 218.008 256s17.01-37.992 37.992-37.992 37.991 17.01 37.991 37.992z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M293.991 256c0 20.982-17.01 37.992-37.992 37.992s-37.992-17.01-37.992-37.992"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M232.259 246.506h9.498v19h-9.498zm37.988 0h9.498v19h-9.498zm-19-14.247h9.498v33.243h-9.498z",
    fill: "#D80027"
  }));
}, f_e = function(e) {
  var t = e.title, r = q(e, k7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#A2001D",
    d: "M0 85.33h512v341.332"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m204.631 326.488 2.762 8.504h8.941l-7.233 5.255 2.763 8.502-7.233-5.254-7.233 5.254 2.762-8.502-7.233-5.255h8.94zm-22.834-81.622 4.605 14.172h14.901l-12.056 8.757 4.605 14.172-12.055-8.759-12.055 8.759 4.606-14.172-12.056-8.757h14.901zm0 103.883 4.604 14.173h14.902l-12.057 8.757 4.606 14.173-12.055-8.759-12.055 8.759 4.604-14.173-12.054-8.757h14.899zm43.566-66.782 4.606 14.172h14.901l-12.056 8.758 4.605 14.172-12.056-8.759-12.054 8.759 4.606-14.172-12.056-8.758h14.901zm-87.133 0 4.606 14.172h14.899l-12.054 8.758 4.603 14.172-12.054-8.759-12.055 8.759 4.605-14.172-12.055-8.758h14.9z",
    fill: "#FFF"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M376.526 204.163c-7.628-7.628-17.538-12.133-28.189-12.908l31.88-24.795c-12.698-12.698-29.714-18.431-46.319-17.218a44.31 44.31 0 0 0-11.396-19.511l-12.593 25.186a18.47 18.47 0 0 0-3.148-4.197c-7.245-7.245-18.991-7.244-26.234 0s-7.245 18.99 0 26.234a18.536 18.536 0 0 0 4.197 3.148l-25.186 12.593a44.303 44.303 0 0 0 19.519 11.399c-1.217 16.606 4.511 33.619 17.209 46.317L324.12 214.6a11.053 11.053 0 0 1 7.807-3.202c2.973 0 5.768 1.158 7.87 3.26a11.055 11.055 0 0 1 3.26 7.87c0 2.974-1.158 5.768-3.26 7.87l10.494 10.494c4.905-4.905 7.607-11.428 7.607-18.364 0-5.675-1.81-11.071-5.153-15.534a29.492 29.492 0 0 1 13.288 7.662c11.573 11.572 11.573 30.403 0 41.975l10.494 10.494c8.409-8.409 13.039-19.59 13.039-31.481-.001-11.892-4.632-23.072-13.04-31.481z"
  }));
}, h_e = function(e) {
  var t = e.title, r = q(e, _7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M512 85.337V256H256L0 85.337z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M512 256v170.663H0L256 256z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m161.908 256-27.288-12.835 14.532-26.428-29.632 5.668-3.755-29.933-20.64 22.015-20.639-22.015-3.755 29.933-29.631-5.669 14.531 26.428L28.343 256l27.288 12.835L41.1 295.263l29.633-5.668 3.753 29.933 20.639-22.015 20.64 22.015 3.755-29.933 29.631 5.669-14.532-26.427zM21.789 117.607l9.081 12.696 14.879-4.714-9.268 12.56 9.081 12.694-14.809-4.932-9.268 12.559.117-15.608-14.809-4.934 14.88-4.712zm0 235.923 9.081 12.696 14.879-4.714-9.268 12.56 9.081 12.695-14.809-4.933-9.268 12.558.117-15.607-14.809-4.934 14.88-4.712zm188.606-117.961-9.081 12.695-14.879-4.713 9.268 12.559-9.081 12.696 14.809-4.933 9.268 12.558-.117-15.607 14.809-4.934-14.88-4.713z",
    fill: "#FFDA44"
  }));
}, p_e = function(e) {
  var t = e.title, r = q(e, O7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "m393.508 170.516 17.512 18.875 23.363-10.821-12.541 22.487 17.513 18.876-25.263-4.978-12.539 22.488-3.073-25.564-25.263-4.978 23.363-10.82z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.343h512v341.326H0z"
  })), /* @__PURE__ */ p.createElement("path", {
    fill: "#01411c",
    d: "M128 85.331h384v341.337H128z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M361.909 298.793c-31.037 22.426-74.378 15.446-96.804-15.592-22.427-31.038-15.446-74.379 15.593-96.804 9.677-6.992 20.55-11.125 31.613-12.563-21.283-3.183-43.777 1.613-62.598 15.211-38.2 27.602-46.792 80.944-19.191 119.145 27.601 38.199 80.944 46.792 119.145 19.189 18.82-13.598 30.436-33.448 34.096-54.655-4.839 10.05-12.176 19.076-21.854 26.069zm-1.329-125.904 17.484 18.842 23.322-10.802-12.519 22.447 17.483 18.844-25.219-4.968-12.519 22.45-3.067-25.521-25.22-4.969 23.323-10.802z",
    fill: "#FFF"
  }));
}, m_e = function(e) {
  var t = e.title, r = q(e, I7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.337h512V256H0z"
  })), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 256h512v170.663H0z"
  }));
}, g_e = function(e) {
  var t = e.title, r = q(e, R7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#00318A",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }));
}, v_e = function(e) {
  var t = e.title, r = q(e, P7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#ACABB1",
    d: "M400.696 219.822 384 225.387l-16.696-5.565-5.565-13.913 5.565-13.913h33.392l-5.566 13.913z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M345.043 219.822v61.217c0 29.821 38.957 38.957 38.957 38.957s38.957-9.137 38.957-38.957v-61.217h-77.914z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M348.555 295.541C358.131 313.927 384 319.996 384 319.996s25.869-6.069 35.445-24.455L384 236.518l-35.445 59.023z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M422.957 280.421 384 219.822l-38.957 60.599v.618c0 5.518 1.337 10.328 3.512 14.503L384 240.405l35.445 55.137c2.175-4.175 3.512-8.983 3.512-14.503v-.618z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.825V85.333h55.652v48.572l87.43-48.572z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
    fill: "#D80027"
  }));
}, y_e = function(e) {
  var t = e.title, r = q(e, D7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.337h512V153.6H0zm0 136.526h512v68.263H0zM0 358.4h512v68.263H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "m83.477 195.132 15.107 46.498h48.894l-39.554 28.739 15.107 46.499-39.554-28.738-39.555 28.738 15.11-46.499-39.554-28.739H68.37z"
  }));
}, b_e = function(e) {
  var t = e.title, r = q(e, N7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#268024",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#e4312b",
    d: "M256 256.006 0 426.668V85.331z"
  }));
}, w_e = function(e) {
  var t = e.title, r = q(e, L7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M196.641 85.337v341.326H0V85.337z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FFDA44",
    cx: 196.641,
    cy: 256,
    r: 64
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M160.638 224v40.001c0 19.882 16.118 36 36 36s36-16.118 36-36V224h-72z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M196.638 276c-6.617 0-12-5.383-12-12v-16h24.001v16c-.001 6.616-5.385 12-12.001 12z"
  }));
}, x_e = function(e) {
  var t = e.title, r = q(e, $7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FFDA44",
    cx: 218.902,
    cy: 255.994,
    r: 74.207
  }));
}, E_e = function(e) {
  var t = e.title, r = q(e, F7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "m289.579 216.738-12.592 12.592c5.37 5.372 8.693 12.792 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.112-5.316-24.985-13.91-33.579z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "m256 232.51 4.421 13.605h14.304l-11.573 8.408 4.421 13.604L256 259.719l-11.573 8.408 4.421-13.604-11.573-8.408h14.304z"
  }));
}, S_e = function(e) {
  var t = e.title, r = q(e, B7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#751A46",
    d: "M0 0h512v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0v342h150.3l37.7-19.6-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19 37.7-18.9-37.7-19 37.7-19-37.7-18.9 37.7-19-37.7-18.9 37.7-19-37.7-19L188 57l-37.7-19L188 19.1 150.3 0z"
  }));
}, C_e = function(e) {
  var t = e.title, r = q(e, z7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#00318A",
    d: "M0 0h171v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M342 0h171v342H342z"
  }));
}, T_e = function(e) {
  var t = e.title, r = q(e, H7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h170.663v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
}, A_e = function(e) {
  var t = e.title, r = q(e, U7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v113.775H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 312.882h512v113.775H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M129.468 181.793v85.136c0 48.429 63.267 63.267 63.267 63.267S256 315.356 256 266.929v-85.136H129.468z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M155.634 196.634h74.201v-29.681l-14.841 7.42-22.261-22.26-22.259 22.26-14.84-7.42zm85.526 82.148-48.231-48.231-48.231 48.231 15.741 15.74 32.49-32.49 32.49 32.49z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M241.16 233.734h-22.504a14.74 14.74 0 0 0 2.001-7.418c0-8.196-6.645-14.84-14.84-14.84-5.663 0-10.581 3.172-13.083 7.836-2.502-4.663-7.421-7.836-13.083-7.836-8.195 0-14.84 6.644-14.84 14.84 0 2.706.736 5.235 2.001 7.418h-22.114c0 8.196 7.139 14.84 15.334 14.84h-.494c0 8.196 6.644 14.84 14.84 14.84 0 7.257 5.211 13.286 12.094 14.576l-11.694 26.401a48.075 48.075 0 0 0 18.149 3.544 48.079 48.079 0 0 0 18.149-3.544l-11.694-26.401c6.883-1.29 12.094-7.319 12.094-14.576 8.196 0 14.84-6.644 14.84-14.84h-.494c8.199 0 15.338-6.644 15.338-14.84z"
  }));
}, M_e = function(e) {
  var t = e.title, r = q(e, V7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.33v341.332h512V85.33z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.333h512v113.775H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 312.884h512v113.775H0z"
  }));
}, k_e = function(e) {
  var t = e.title, r = q(e, j7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 255.994h512v81.619H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#496E2D",
    d: "M0 337.614h512v89.043H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "m278.261 185.209 20.844 9.804-11.099 20.186 22.632-4.33 2.868 22.865 15.765-16.816 15.766 16.816 2.867-22.865 22.633 4.33-11.099-20.186 20.843-9.804-20.844-9.805 11.1-20.185-22.633 4.329-2.868-22.864-15.765 16.816-15.766-16.816-2.867 22.864-22.634-4.329 11.1 20.187z"
  }));
}, __e = function(e) {
  var t = e.title, r = q(e, W7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#055e1c",
    d: "M0 85.333h512v341.333H0z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M183.548 289.386c0 12.295 9.731 22.261 21.736 22.261h65.208c0 10.244 8.11 18.551 18.114 18.551h21.736c10.004 0 18.114-8.306 18.114-18.551v-22.261H183.548zm146.716-107.595v51.942c0 8.183-6.5 14.84-14.491 14.84v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.942h-21.735zm-155.773 51.943c0 8.183-6.5 14.84-14.491 14.84v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.942H174.49v51.942z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M297.661 181.788h21.736v51.942h-21.736zm-32.604 29.685c0 2.046-1.625 3.71-3.623 3.71-1.998 0-3.623-1.664-3.623-3.71v-29.682h-21.736v29.682c0 2.046-1.625 3.71-3.623 3.71s-3.623-1.664-3.623-3.71v-29.682h-21.736v29.682c0 14.32 11.376 25.971 25.358 25.971 5.385 0 10.38-1.733 14.491-4.677 4.11 2.944 9.106 4.677 14.491 4.677 1.084 0 2.15-.078 3.2-.215-1.54 6.499-7.255 11.345-14.068 11.345v22.261c19.976 0 36.226-16.643 36.226-37.101v-51.943h-21.736l.002 29.682z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M207.093 248.57h32.601v22.261h-32.601z"
  })));
}, O_e = function(e) {
  var t = e.title, r = q(e, G7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 426.663V85.329h512"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 396.494v30.169h45.255L512 115.499v-30.17h-45.255z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m85.688 108.787 5.12 15.756h16.566l-13.403 9.737 5.12 15.757-13.403-9.738-13.405 9.738 5.12-15.757L64 124.543h16.567zm84.624 0 5.121 15.756H192l-13.403 9.737 5.12 15.757-13.405-9.738-13.403 9.738 5.12-15.757-13.403-9.737h16.566zm-84.624 82.502 5.12 15.756h16.566l-13.403 9.738 5.12 15.757-13.403-9.739-13.405 9.739 5.12-15.757L64 207.045h16.567zm84.624 0 5.121 15.756H192l-13.403 9.738 5.12 15.757-13.405-9.739-13.403 9.739 5.12-15.757-13.403-9.738h16.566zM128 150.037l5.12 15.756h16.568l-13.405 9.738 5.12 15.758L128 181.55l-13.403 9.739 5.12-15.758-13.405-9.738h16.568z",
    fill: "#FFF"
  }));
}, I_e = function(e) {
  var t = e.title, r = q(e, K7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M235.454 85.337 0 426.663 427.345 85.337z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M512 329.393 0 426.663h512z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M512 85.337h-84.655L0 426.663l512-204.512z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337v341.326L235.454 85.337z"
  }));
}, R_e = function(e) {
  var t = e.title, r = q(e, q7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#496E2D",
    d: "M0 426.668V85.331l256 170.675z"
  }));
}, P_e = function(e) {
  var t = e.title, r = q(e, Y7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M192 85.33h-64v138.666H0v64h128v138.666h64V287.996h320v-64H192z"
  }));
}, D_e = function(e) {
  var t = e.title, r = q(e, X7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512V256H0z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M83.478 170.666c0-24.865 17.476-45.637 40.812-50.734a52.059 52.059 0 0 0-11.13-1.208c-28.688 0-51.942 23.254-51.942 51.941s23.255 51.942 51.942 51.942c3.822 0 7.543-.425 11.13-1.208-23.336-5.095-40.812-25.867-40.812-50.733zm66.783-48.231 3.684 11.337h11.921l-9.645 7.007 3.684 11.337-9.644-7.006-9.645 7.006 3.685-11.337-9.645-7.007h11.921z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m121.344 144.696 3.683 11.337h11.921l-9.645 7.007 3.684 11.337-9.643-7.006-9.645 7.006 3.685-11.337-9.645-7.007h11.921zm57.834 0 3.684 11.337h11.921l-9.645 7.007 3.684 11.337-9.644-7.006-9.644 7.006 3.685-11.337-9.645-7.007h11.921zm-11.131 33.391 3.684 11.337h11.921l-9.644 7.007 3.684 11.337-9.645-7.006-9.643 7.006 3.684-11.337-9.644-7.007h11.92zm-35.573 0 3.683 11.337h11.921l-9.644 7.007 3.684 11.337-9.644-7.006-9.644 7.006 3.684-11.337-9.644-7.007h11.92z"
  })));
}, N_e = function(e) {
  var t = e.title, r = q(e, Z7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h512v341.3H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z"
  })), /* @__PURE__ */ p.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 170.7v-15.1l57.4-38.2H80zm256 0v-15.1l-57.4-38.2H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#29DBFF",
    d: "M449 139.7c-.1 44.4-7.2 92.1-65 114.9-57.8-22.8-64.9-70.5-65-114.9h130z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#ffda44",
    d: "M449 139.7c0-16.7-.9-32.9-.5-47.1C426.9 83 398.4 81 383.9 81s-42.9 2-64.6 11.6c.4 14.2-.5 30.4-.5 47.1H449z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#BF521B",
    d: "m369.5 204.5.3 10.3-12.8.2 4.9 13.2h-17.3c-18-20.2-23.4-42.4-24.9-68.1l9.1-9.7 8.3 14.3 10.8-12.8 7 7.8.8 15.7 13.8 29.1z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#474747",
    d: "m436.6 192.5-8.6 18.3h-47l-29.2-19.5 25.7 10.5h25.1l3.7-6.5 7.2.2 2-3z"
  }));
}, L_e = function(e) {
  var t = e.title, r = q(e, Q7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 199.112h512v113.775H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l-.145-44.188 89.043-.266.146 44.454z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l-.145-44.188 89.043-.266.146 44.454z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M233.606 196.639v14.837c0 34.081-44.522 44.522-44.522 44.522s-44.522-10.44-44.522-44.522v-14.837l14.848 14.837 29.674-22.261 29.685 22.261 14.837-14.837z"
  }));
}, $_e = function(e) {
  var t = e.title, r = q(e, J7e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M512 295.883H202.195v130.783h-79.76V295.883H0v-79.772h122.435V85.329h79.76v130.782H512v61.218z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#2E52B2",
    d: "M512 234.666v42.663H183.652v149.337h-42.674V277.329H0v-42.663h140.978V85.329h42.674v149.337z"
  }));
}, F_e = function(e) {
  var t = e.title, r = q(e, e9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 196.641h512v118.717H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 315.359h512v111.304H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M129.468 181.799v85.136c0 48.429 63.267 63.267 63.267 63.267S256 315.362 256 266.935v-85.136H129.468z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M146.126 184.294v81.941c0 5.472 1.215 10.64 3.623 15.485h85.97c2.408-4.844 3.623-10.012 3.623-15.485v-81.941h-93.216z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M221.301 241.427h-21.425v-14.283h14.284v-14.283h-14.284v-14.284h-14.283v14.284h-14.282v14.283h14.282v14.283h-21.426v14.284h21.426v14.283h14.283v-14.283h21.425z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M169.232 301.658c9.204 5.783 18.66 9.143 23.502 10.636 4.842-1.494 14.298-4.852 23.502-10.636 9.282-5.833 15.79-12.506 19.484-19.939a24.878 24.878 0 0 0-14.418-4.583c-1.956 0-3.856.232-5.682.657-3.871-8.796-12.658-14.94-22.884-14.94-10.227 0-19.013 6.144-22.884 14.94a25.048 25.048 0 0 0-5.682-.657 24.88 24.88 0 0 0-14.418 4.583c3.691 7.433 10.198 14.106 19.48 19.939z"
  }));
}, B_e = function(e) {
  var t = e.title, r = q(e, t9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M0 312.888h512v113.775H0z"
  }));
}, z_e = function(e) {
  var t = e.title, r = q(e, n9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.34h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M512 85.334v166.69L0 256.175V85.334z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M323.744 203.099 256 270.843l-67.744-67.744a81.156 81.156 0 0 0-13.879 45.483v22.261c0 35.744 23.097 66.193 55.148 77.213-4.277 8.385-3.556 18.848 2.712 26.671l24.258-19.439 24.258 19.439c6.342-7.915 7.011-18.534 2.564-26.968 31.614-11.261 54.308-41.485 54.308-76.916v-22.261a81.174 81.174 0 0 0-13.881-45.483z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M256 330.206c-32.732 0-59.362-26.63-59.362-59.362v-22.261c0-32.733 26.63-59.363 59.362-59.363s59.362 26.63 59.362 59.362v22.261c0 32.733-26.63 59.363-59.362 59.363z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M293.101 270.843v-22.261c0-20.458-16.643-37.101-37.101-37.101s-37.101 16.643-37.101 37.101v22.261L256 278.264l37.101-7.421z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M218.899 270.843c0 20.458 16.643 37.101 37.101 37.101s37.101-16.643 37.101-37.101h-74.202z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M300.522 189.22c0-12.295-9.966-22.261-22.261-22.261a22.173 22.173 0 0 0-14.84 5.672v-13.093h7.421v-14.84h-7.421v-7.421h-14.84v7.421h-7.421v14.84h7.421v13.093a22.177 22.177 0 0 0-14.841-5.672c-12.295 0-22.261 9.966-22.261 22.261 0 6.591 2.867 12.512 7.421 16.589v13.093h74.203v-13.093c4.552-4.077 7.419-9.997 7.419-16.589z"
  }));
}, H_e = function(e) {
  var t = e.title, r = q(e, r9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M330.207 85.331H512v341.337H330.207z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.331h181.793v341.337H0zm255.999 111.301 14.733 45.347h47.685l-38.576 28.029 14.734 45.348-38.576-28.026-38.577 28.026 14.737-45.348-38.576-28.029h47.681z",
    fill: "#496E2D"
  }));
}, U_e = function(e) {
  var t = e.title, r = q(e, i9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "m256 157.273 22.663 69.748H352l-59.332 43.106 22.664 69.749L256 296.769l-59.332 43.107 22.664-69.749L160 227.021h73.337z"
  }));
}, V_e = function(e) {
  var t = e.title, r = q(e, s9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#A2001D",
    d: "M0 196.636h512v118.728H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 352.462h512v74.207H0zM0 85.331h512v74.207H0z",
    fill: "#6DA544"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "m256.742 218.003 9.43 29.021h30.518L272 264.963l9.431 29.023-24.689-17.937-24.689 17.937 9.431-29.023-24.69-17.939h30.518z"
  }));
}, j_e = function(e) {
  var t = e.title, r = q(e, o9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#496E2D",
    d: "M0 322.783h512v103.88H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.337h512v104.515H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#A2001D",
    d: "M0 210.877h512v89.656H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "m73.178 209.188 20.831 29.067 34.084-10.83-21.207 28.795 20.83 29.069-33.939-11.271-21.208 28.794.234-35.762-33.94-11.273 34.083-10.83z"
  }));
}, W_e = function(e) {
  var t = e.title, r = q(e, a9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#6DA544"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m302.049 226.318 7.368 22.674h23.842l-19.288 14.016 7.366 22.674-19.288-14.015-19.287 14.015 7.366-22.674-19.288-14.016h23.842zm74.203 0 7.367 22.674h23.842l-19.288 14.016 7.367 22.674-19.288-14.015-19.288 14.015 7.367-22.674-19.288-14.016h23.842z"
  }));
}, G_e = function(e) {
  var t = e.title, r = q(e, l9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.337h512v113.775H0zm0 227.551h512v113.775H0z",
    fill: "#0052B4"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M228.582 261.936 256 214.447l27.418 47.489z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M291.616 277.616 256 295.425l-35.616-17.809v-23.744h71.232z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "m289.579 216.485-12.592 12.592c5.37 5.372 8.693 12.791 8.693 20.988 0 16.392-13.289 29.68-29.68 29.68-16.392 0-29.68-13.289-29.68-29.68 0-8.195 3.322-15.616 8.693-20.988l-12.592-12.592c-8.594 8.594-13.91 20.466-13.91 33.579 0 26.228 21.261 47.489 47.489 47.489s47.489-21.261 47.489-47.489c0-13.114-5.316-24.987-13.91-33.579z"
  }));
}, K_e = function(e) {
  var t = e.title, r = q(e, c9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M512 85.331v166.69L0 256.173V85.331z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M256 256.006 0 426.668V85.331z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFDA44"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M59.621 256a59.546 59.546 0 0 0-.193 4.57c0 32.821 26.607 59.429 59.429 59.429s59.429-26.607 59.429-59.429c0-1.539-.078-3.061-.193-4.57H59.621z"
  }), /* @__PURE__ */ p.createElement("circle", {
    cx: 118.862,
    cy: 210.287,
    r: 18.286
  })), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M77.715 205.714v59.429c0 31.494 41.144 41.143 41.144 41.143s41.144-9.649 41.144-41.143v-59.429H77.715z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M118.877 287.148c-7.632-2.746-22.876-9.767-22.876-22.006v-41.144h45.715v41.144c-.001 12.28-15.244 19.283-22.839 22.006z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#F3F3F3",
    d: "M128.001 246.856v-9.142l-9.144-4.571-9.142 4.571v9.142l-4.571 4.573v18.285h27.428v-18.285z"
  }));
}, q_e = function(e) {
  var t = e.title, r = q(e, u9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h900v600H0z",
    fill: "#0f0f0f"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h900v400H0z",
    fill: "#fff"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h900v200H0z",
    fill: "#047a3f"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m176.26 375 48.738-150 48.738 150-127.6-92.705h157.72M626.256 375l48.738-150 48.738 150-127.6-92.705h157.72M401.252 375l48.738-150 48.738 150-127.6-92.705h157.72",
    fill: "#ce1126"
  }));
}, Y_e = function(e) {
  var t = e.title, r = q(e, d9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#2B5DEA",
    d: "M0 0h900v600H0V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDF29",
    d: "M0 100h900v400H0V100z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D70000",
    d: "M0 150h900v300H0V150z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M450 171.4v257.2c114.3 0 171.4-85.7 214.3-128.6-42.9-42.9-100-128.6-214.3-128.6z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M450 171.4c-100 0-171.4 85.7-214.3 128.6C278.6 342.9 350 428.6 450 428.6V171.4z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M346.3 254.3h21v91.3h-21zm51.9 0h21v91.3h-21z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M477.8 254.3h21v91.3h-21zm51.9 0h21v91.3h-21z"
  }));
}, X_e = function(e) {
  var t = e.title, r = q(e, f9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h512v341.3H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M256 0v117.4h-46.1l46.1 30.7v22.6h-22.6L160 121.8v48.9H96v-48.9l-73.4 48.9H0v-22.6l46.1-30.7H0v-64h46.1L0 22.7V0h22.6L96 48.9V0h64v48.9L233.4 0z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M144 0h-32v69.4H0v32h112v69.3h32v-69.3h112v-32H144z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z"
  })), /* @__PURE__ */ p.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0v15.1l57.4 38.3H80zm256 0v15.1l-57.4 38.3H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#2E52B2",
    d: "M256 22.7v30.7h-46.1z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 170.7v-15.1l57.4-38.2H80zm256 0v-15.1l-57.4-38.2H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#29DBFF",
    d: "M448.9 169.5c0 9.6-.3 29.6-1.4 39.2-4.1 34.9-23.5 68.8-62.1 85.9-45.3-17.9-60.8-51-64.9-85.9-1.1-9.6-1.5-19.4-1.5-29l.3-47.1h129.2l.4 36.9z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M447.5 208.7c-.2 1.6-.4 3.3-.6 4.9-4.8 33.1-22.9 65.4-61.5 81-43.2-17-59.4-47.9-64.2-81-.2-1.6-.4-3.2-.6-4.9"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#29DBFF",
    d: "m385.4 251.7-22.9-43h45.8z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "m385.4 165.8-22.9 42.9h45.8z"
  }), /* @__PURE__ */ p.createElement("ellipse", {
    fill: "#FFBE57",
    cx: 474.8,
    cy: 236.8,
    rx: 16.8,
    ry: 43.3
  }), /* @__PURE__ */ p.createElement("ellipse", {
    fill: "#FFBE57",
    cx: 295.3,
    cy: 236.8,
    rx: 16.8,
    ry: 43.3
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "m385.4 31.5-33.4 44h68.5zM315.5 280s33.8 29.5 69.9 29.5 67.1-29.5 67.1-29.5l8.5 14.6S439.2 326 385.4 326 307 294.6 307 294.6l8.5-14.6z"
  }), /* @__PURE__ */ p.createElement("ellipse", {
    fill: "#A5A5A5",
    cx: 386.3,
    cy: 104.3,
    rx: 34.3,
    ry: 23.3
  }));
}, Z_e = function(e) {
  var t = e.title, r = q(e, h9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M332.058 191.996v78.221c0 38.103 51.942 49.779 51.942 49.779s51.942-11.675 51.942-49.779v-78.221H332.058z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FF9811",
    d: "M376.579 220.44c0 7.855-6.644 28.445-14.84 28.445s-14.84-20.589-14.84-28.445c0-7.856 14.84-14.222 14.84-14.222s14.84 6.367 14.84 14.222z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#A2001D",
    d: "M415.961 235.93c2.394-5.6 4.257-13.785 4.257-17.86 0-6.546-8.904-11.852-8.904-11.852s-8.904 5.306-8.904 11.852c0 4.075 1.862 12.26 4.257 17.86l-5.141 11.123a26.898 26.898 0 0 0 9.788 1.831c3.463 0 6.766-.654 9.788-1.831l-5.141-11.123z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M372.87 270.217s-7.421 14.222-7.421 28.445h37.101c0-14.222-7.421-28.445-7.421-28.445l-11.13-7.111-11.129 7.111z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M395.13 270.217v-3.555c0-5.891-4.983-10.666-11.13-10.666-6.147 0-11.13 4.776-11.13 10.666v3.555h22.26z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M256 85.333v30.553l-45.167 25.099H256v59.359h-59.103L256 233.179v22.817h-26.68l-73.494-40.826v40.826h-55.652v-48.573l-87.43 48.573H0v-30.554l45.167-25.098H0v-59.359h59.103L0 108.139V85.333h26.68l73.494 40.825V85.333h55.652v48.572l87.43-48.572z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M144 85.33h-32v69.332H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M155.826 200.344 256 255.996v-15.737l-71.847-39.915zm-83.98 0L0 240.259v15.737l100.174-55.652z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M100.174 140.982 0 85.33v15.737l71.847 39.915zm83.98 0L256 101.067V85.33l-100.174 55.652z",
    fill: "#D80027"
  }));
}, Q_e = function(e) {
  var t = e.title, r = q(e, p9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h170.663v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M341.337 85.331H512v341.337H341.337z"
  }));
}, J_e = function(e) {
  var t = e.title, r = q(e, m9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h21v15H0V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0A388A",
    d: "M0 0h22.5v15H0V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h11.3v7.5H0V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M7.1 0h3.6v7H7.1V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0A388A",
    d: "M0 0h3.6v7H0V0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M3.6 0h3.6v7H3.6V0zm10.9 6h5L19 7h-1.5v.5h1l-.5 1h-.5V10h-1V7H15l-.5-1zm4 2.5 1 1.5h-2l1-1.5zm-3 0 1 1.5h-2l1-1.5zm1.5 3L16 10h2l-1 1.5zM20 8c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-6 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm1 4c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm4 0c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5zm-2 1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5z"
  }));
}, eOe = function(e) {
  var t = e.title, r = q(e, g9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.337h512V153.6H0zM0 358.4h512v68.263H0zm0-136.537h512v68.263H0z",
    fill: "#496E2D"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h204.054v204.054H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "m102.026 133.938 13.26 40.812h42.916l-34.718 25.226 13.26 40.814-34.718-25.224-34.719 25.224 13.263-40.814-34.718-25.226h42.913z"
  }));
}, tOe = function(e) {
  var t = e.title, r = q(e, v9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.334h512V426.66H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 194.056h512v123.882H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.334h512v54.522H0zm0 286.809h512v54.522H0z",
    fill: "#D80027"
  }));
}, nOe = function(e) {
  var t = e.title, r = q(e, y9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M0 312.888h512v113.775H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M226.318 300.522h59.364v-25.23l-11.873 5.937L256 263.421l-17.809 17.808-11.873-5.937zm-33.963-29.682 2.763 8.504h8.94l-7.233 5.255 2.763 8.502-7.233-5.255-7.234 5.255 2.763-8.502-7.233-5.255h8.94zm8.566-29.68 2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zm24.488-22.261 2.763 8.502h8.94l-7.233 5.255 2.763 8.504-7.233-5.256-7.234 5.256 2.763-8.504-7.233-5.255h8.94zm94.236 51.941-2.763 8.504h-8.94l7.233 5.255-2.763 8.502 7.233-5.255 7.234 5.255-2.763-8.502 7.233-5.255h-8.94zm-8.566-29.68-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zm-24.488-22.261-2.763 8.502h-8.94l7.233 5.255-2.763 8.504 7.233-5.256 7.234 5.256-2.763-8.504 7.233-5.255h-8.94zM256 207.767l2.763 8.503h8.941l-7.234 5.256 2.763 8.502-7.233-5.254-7.233 5.254 2.763-8.502-7.234-5.256h8.941z",
    fill: "#FFDA44"
  }));
}, rOe = function(e) {
  var t = e.title, r = q(e, b9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m210.715 174.377 3.684 11.338h11.919l-9.643 7.006 3.684 11.337-9.644-7.007-9.644 7.007 3.684-11.337-9.645-7.006h11.921zm-93.899 107.594 4.605 14.172h14.9l-12.055 8.757 4.606 14.173-12.056-8.76-12.055 8.76 4.604-14.173-12.054-8.757h14.899zm27.88-162.292 4.604 14.172h14.901l-12.056 8.758 4.606 14.171-12.055-8.759-12.056 8.759 4.606-14.171-12.055-8.758h14.9zm-75.157 55.652 4.604 14.172h14.9l-12.055 8.758 4.606 14.171-12.055-8.758-12.056 8.758 4.606-14.171-12.055-8.758h14.9z",
    fill: "#FFF"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M483.386 354.503H117.801s109.234-88.562 310.593-220.938c.001 0-88.443 128.935 54.992 220.938zm-365.585 11.586c-11.177 0-11.195 17.37 0 17.37h365.585c11.177 0 11.195-17.37 0-17.37H117.801z",
    fill: "#FFDA44"
  }));
}, iOe = function(e) {
  var t = e.title, r = q(e, w9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M256 256 0 90.691v44.242L155.826 256 0 377.067v44.242z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 90.691v330.618L189.217 256z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "m44.184 213.36 24.912 23.577 30.121-16.41-14.723 30.98 24.911 23.575-34.012-4.43L60.67 301.63l-6.296-33.716-34.012-4.43 30.119-16.408z"
  }));
}, sOe = function(e) {
  var t = e.title, r = q(e, x9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFF"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M357.208 183.679c8.397-23.404-1.036-48.858-21.281-61.536a52.131 52.131 0 0 1 10.884 2.621c27.002 9.688 41.038 39.428 31.35 66.431s-39.428 41.038-66.431 31.35a52.182 52.182 0 0 1-10.069-4.895c23.686 3.084 47.15-10.566 55.547-33.971zm-46.571-67.95-7.297 9.427-11.22-4.026 6.712 9.852-7.296 9.427 11.443-3.338 6.712 9.852.361-11.914 11.444-3.339-11.221-4.025z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m330.338 146.448-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.443-3.339 6.712 9.853.36-11.915 11.445-3.34-11.221-4.024zM275.9 126.916l-7.296 9.427-11.219-4.024 6.711 9.851-7.296 9.426 11.443-3.338 6.712 9.852.361-11.915 11.444-3.337-11.221-4.027zm-.799 35.189-7.296 9.427-11.221-4.026 6.712 9.852-7.296 9.427 11.444-3.338 6.711 9.852.362-11.915 11.443-3.338-11.22-4.026zm33.484 12.013-7.296 9.427-11.22-4.026 6.712 9.853-7.297 9.426 11.444-3.338 6.712 9.852.36-11.915 11.443-3.338-11.219-4.025z"
  })), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M83.478 85.337h89.043v341.326H83.478z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "m117.458 175.191-14.908-11.105v-15.705l14.908-11.105h21.084l14.908 11.105v15.705l-14.908 11.105z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M128 137.276h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.105v-8.012H128z",
    fill: "#FF9811"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "m117.458 374.725-14.908-11.106v-15.704l14.908-11.105h21.084l14.908 11.105v15.704l-14.908 11.106z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M128 336.81h-10.542l-14.908 11.105v7.678H128zm0 37.915h10.542l14.908-11.106v-8.011H128z",
    fill: "#FF9811"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m117.458 274.957-14.908-11.105v-15.703l14.908-11.106h21.084l14.908 11.106v15.703l-14.908 11.105zm36.513 24.434h-6.493v-6.493h-11.411l-8.068-8.068-8.067 8.068h-11.41v6.493h-6.493v12.986h6.493v6.492h11.41l8.068 8.069 8.068-8.069h11.41v-6.492h6.493zm0-99.768h-6.493v-6.492h-11.411l-8.068-8.069-8.067 8.069h-11.41v6.492h-6.493v12.986h6.493v6.492h11.41l8.068 8.07 8.068-8.07h11.41v-6.492h6.493z",
    fill: "#496E2D"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M120.576 248.576h14.84v14.84h-14.84z"
  }), /* @__PURE__ */ p.createElement("circle", {
    cx: 128,
    cy: 206.113,
    r: 7.421
  }), /* @__PURE__ */ p.createElement("circle", {
    cx: 128,
    cy: 305.887,
    r: 7.421
  })));
}, oOe = function(e) {
  var t = e.title, r = q(e, E9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FFF",
    cx: 256,
    cy: 255.994,
    r: 96
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "m267.826 219.291 16.47 22.695 26.673-8.649-16.496 22.676 16.468 22.695-26.664-8.681-16.495 22.676.017-28.04-26.664-8.682 26.674-8.648z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M277.818 312.724c-31.33 0-56.727-25.397-56.727-56.727s25.397-56.727 56.727-56.727c9.769 0 18.96 2.47 26.985 6.819-12.589-12.31-29.804-19.909-48.803-19.909-38.558 0-69.818 31.259-69.818 69.818s31.26 69.818 69.818 69.818c18.999 0 36.215-7.599 48.803-19.909-8.026 4.347-17.216 6.817-26.985 6.817z"
  })));
}, aOe = function(e) {
  var t = e.title, r = q(e, S9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.331h256v170.663H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M141.357 157.303V130.59h-26.714v26.713H87.93v26.713h26.713v26.713h26.714v-26.713h26.713v-26.713z"
  }));
}, lOe = function(e) {
  var t = e.title, r = q(e, C9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#E30A17",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M259.7 118.6c-13.1-9.5-29-14.6-45.3-14.5-40.8 0-73.8 30.8-73.8 68.9s33.1 68.9 73.8 68.9c17.1 0 32.9-5.4 45.3-14.5-30 38.6-85.7 45.6-124.3 15.5s-45.6-85.7-15.5-124.3 85.7-45.6 124.3-15.5c5.8 4.5 11 9.8 15.5 15.5zm39.9 65.8-18.1 21.9 1.2-28.4-26.4-10.4 27.3-7.6 1.8-28.3 15.6 23.7 27.5-7.1-17.5 22 15.3 23.9-26.7-9.7z"
  }));
}, cOe = function(e) {
  var t = e.title, r = q(e, T9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "m6.066 85.337 207.961 212.636 131.584 128.69h160.323L297.973 214.027 166.389 85.337z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M43.364 85.337 384.69 426.663h83.946L127.31 85.337z"
  }));
}, uOe = function(e) {
  var t = e.title, r = q(e, A9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 900 600"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h900v600H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#00B2EE",
    d: "M0 300h450V0h450v600H0V300z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "m345.3 480.9 29.4 90.6-77.1-56H393l-77.1 56 29.4-90.6zM706.4 340l29.4 90.6-77.1-56H754l-77.1 56 29.5-90.6zm106.4-78.5 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zm0-224.1 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M449.9 0v206.3h-81l81 54V300h-39.7l-129-85.9V300H168.7v-85.9L39.7 300H0v-39.7l81-54H0V93.8h81L0 39.9V0h39.7l129 85.9V0h112.5v85.9L410.2 0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M253.1 0h-56.3v122H0v56.2h196.8V300h56.3V178.2h196.8V122H253.1z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#2E52B2",
    d: "M449.9 39.9v53.9h-81z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 300v-19.3l109.9-74.4h39.7L12.8 300zM12.8.1l136.8 93.7h-39.7L0 19.4V.1zm437.1.1v19.3L340 93.8h-39.7L437.1.2zM437.1 300l-136.8-93.7H340l109.9 74.4V300z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "m719.9 131.6 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zM584 187.7l29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zm30 242.9 29.4 90.6-77.1-56h95.3l-77.1 56 29.5-90.6zM488 332l29.4 90.6-77.1-56h95.3l-77.1 56L488 332zm0 132 29.4 90.6-77.1-56h95.3l-77.1 56L488 464z"
  }));
}, dOe = function(e) {
  var t = e.title, r = q(e, M9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.337h256V256H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M186.435 170.669 162.558 181.9l12.714 23.125-25.927-4.961-3.286 26.192L128 206.993l-18.06 19.263-3.285-26.192-25.927 4.96 12.714-23.125-23.877-11.23 23.877-11.231-12.714-23.125 25.927 4.96 3.286-26.192L128 134.344l18.06-19.263 3.285 26.192 25.928-4.96-12.715 23.125z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#0052B4",
    cx: 128,
    cy: 170.674,
    r: 29.006
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M128 190.06c-10.692 0-19.391-8.7-19.391-19.391 0-10.692 8.7-19.391 19.391-19.391 10.692 0 19.391 8.7 19.391 19.391 0 10.691-8.699 19.391-19.391 19.391z"
  }));
}, fOe = function(e) {
  var t = e.title, r = q(e, k9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M0 426.663V85.337h512"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M512 152.222V85.337H411.67L0 359.778v66.885h100.33z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M512 85.337v40.125L60.193 426.663H0v-40.125L451.807 85.337z"
  }));
}, hOe = function(e) {
  var t = e.title, r = q(e, _9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512V256H0z"
  }));
}, pOe = function(e) {
  var t = e.title, r = q(e, O9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#232323",
    d: "M0 0h512v341.3H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 56.9h512v56.9H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D32300",
    d: "M0 113.8h512v56.9H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 227.6h512v56.9H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D32300",
    d: "M0 284.4h512v56.9H0z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FFF",
    cx: 256,
    cy: 170.7,
    r: 80.7
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M234.5 127.5c.9-1.4-19.6-2-19.6-2 1.7-2.5 18.4-10.5 18.4-10.5s-.9-6 2.7-9.8l-4.5-9.8s7-3.4 18.4-3.4 19.9 7 21 13.1l-6.4 3.4c-.1 4.7 1.7 11.6-4.3 17.3-5.9 5.7-8.3 6.9-8.5 18.8 0 3.9 2.3 8.2 8.8 11.7 17.4 9.3 38.6 28.2 44.6 33.9 6.1 5.7 5.1 19.2 2.6 25.2s-12.1 14.3-14.3 13.6c-2.2-.6 1.2-9.2-3.5-11.6 0 0-8.9-7.6-16.8.6s-.2 25.2 3.9 28c4.1 2.8 1.7 5-1.9 5H247c-3.8 0-5.4-2.3-1.9-5 7.6-3.8 12.4-15.3 7.4-20.3-4.9-4.9-18.3 1.5-21.5 6.3-2.8 2.8-8.8 3.6-12.9-1.4s-4.1-10.4-1.1-12.5c7-4.8 0 0 .1-.1 0 0 11.9-8.6 29.9-9 3.9 0 4.8-2.2 2.2-4.8 0 0-30.9-27.4-28.1-44.2 3-18.3 20-26.3 13.4-32.5-1.3-1.8 0 0 0 0z"
  }));
}, mOe = function(e) {
  var t = e.title, r = q(e, I9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#2E52B2",
    d: "M0 0h256.5v184.1H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z",
    fill: "#FFF"
  }));
}, gOe = function(e) {
  var t = e.title, r = q(e, R9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 0h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513v26.3H0zm0 52.7h513v26.3H0zm0 52.6h513v26.3H0zm0 52.6h513V342H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#2E52B2",
    d: "M0 0h256.5v184.1H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m47.8 138.9-4-12.8-4.4 12.8H26.2l10.7 7.7-4 12.8 10.9-7.9 10.6 7.9-4.1-12.8 10.9-7.7zm56.3 0-4.1-12.8-4.2 12.8H82.6l10.7 7.7-4 12.8 10.7-7.9 10.8 7.9-4-12.8 10.7-7.7zm56.5 0-4.3-12.8-4 12.8h-13.5l11 7.7-4.2 12.8 10.7-7.9 11 7.9-4.2-12.8 10.7-7.7zm56.2 0-4-12.8-4.2 12.8h-13.3l10.8 7.7-4 12.8 10.7-7.9 10.8 7.9-4.3-12.8 11-7.7zM100 75.3l-4.2 12.8H82.6L93.3 96l-4 12.6 10.7-7.8 10.8 7.8-4-12.6 10.7-7.9h-13.4zm-56.2 0-4.4 12.8H26.2L36.9 96l-4 12.6 10.9-7.8 10.6 7.8L50.3 96l10.9-7.9H47.8zm112.5 0-4 12.8h-13.5l11 7.9-4.2 12.6 10.7-7.8 11 7.8-4.2-12.6 10.7-7.9h-13.2zm56.5 0-4.2 12.8h-13.3l10.8 7.9-4 12.6 10.7-7.8 10.8 7.8-4.3-12.6 11-7.9h-13.5zm-169-50.6-4.4 12.6H26.2l10.7 7.9-4 12.7L43.8 50l10.6 7.9-4.1-12.7 10.9-7.9H47.8zm56.2 0-4.2 12.6H82.6l10.7 7.9-4 12.7L100 50l10.8 7.9-4-12.7 10.7-7.9h-13.4zm56.3 0-4 12.6h-13.5l11 7.9-4.2 12.7 10.7-7.9 11 7.9-4.2-12.7 10.7-7.9h-13.2zm56.5 0-4.2 12.6h-13.3l10.8 7.9-4 12.7 10.7-7.9 10.8 7.9-4.3-12.7 11-7.9h-13.5z",
    fill: "#FFF"
  }));
}, vOe = function(e) {
  var t = e.title, r = q(e, P9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 513 342"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h513v342H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 38h513v38H0zm0 76h513v38H0zm0 76h513v38H0zm0 76h513v38H0z",
    fill: "#0038a8"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h256.5v190H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FED443",
    d: "m128.3 138.7-15.1 22.6-3.8-26.9L86 148.2l8.2-25.9-27.2 2.2 18.6-19.8L60.3 95l25.4-9.7L67 65.5l27.1 2.3-8.2-25.9 23.4 13.8 3.9-26.9 15.1 22.6 15.1-22.6 3.8 26.9 23.4-13.8-8.2 25.9 27.1-2.2-18.6 19.8 25.4 9.7-25.4 9.7 18.6 19.8-27.1-2.2 8.2 25.9-23.4-13.8-3.9 26.9-15-22.7zm0-.5c23.9.9 44-17.6 44.9-41.5.9-23.9-17.6-44-41.5-44.9h-3.4c-23.9.8-42.6 20.8-41.8 44.6.6 22.8 19 41.1 41.8 41.8zm0-10.6c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.3 34-34 34z"
  }));
}, yOe = function(e) {
  var t = e.title, r = q(e, D9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M0 322.783h512v103.88H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512v104.515H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 210.877h512v89.656H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.337h512v104.515H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M188.688 137.589c0-15.984 11.234-29.339 26.236-32.614a33.531 33.531 0 0 0-7.155-.777c-18.442 0-33.391 14.949-33.391 33.391s14.949 33.391 33.391 33.391c2.458 0 4.85-.273 7.155-.777-15.002-3.275-26.236-16.63-26.236-32.614zm45.97 15.177 2.261 6.957h7.315l-5.918 4.301 2.261 6.956-5.919-4.3-5.918 4.3 2.261-6.956-5.918-4.301h7.315zm23.348 0 2.26 6.957h7.315l-5.918 4.301 2.261 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.917-4.301h7.314zm23.347 0 2.26 6.957h7.315l-5.917 4.301 2.26 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.918-4.301h7.315zm23.347 0 2.262 6.957h7.315l-5.919 4.301 2.261 6.956-5.919-4.3-5.918 4.3 2.262-6.956-5.919-4.301h7.314zm23.348 0 2.26 6.957h7.315l-5.918 4.301 2.261 6.956-5.918-4.3-5.918 4.3 2.26-6.956-5.917-4.301h7.314zm-70.042-24.284 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.917-4.3h7.314zm23.347 0 2.26 6.956h7.315l-5.917 4.3 2.26 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.918-4.3h7.315zm23.347 0 2.262 6.956h7.315l-5.919 4.3 2.261 6.957-5.919-4.299-5.918 4.299 2.262-6.957-5.919-4.3h7.314zm23.348 0 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.299-5.918 4.299 2.26-6.957-5.917-4.3h7.314zm-46.695-24.284 2.26 6.956h7.315l-5.917 4.3 2.26 6.957-5.918-4.3-5.918 4.3 2.26-6.957-5.918-4.3h7.315zm23.347 0 2.262 6.956h7.315l-5.919 4.3 2.261 6.957-5.919-4.3-5.918 4.3 2.262-6.957-5.919-4.3h7.314zm23.348 0 2.26 6.956h7.315l-5.918 4.3 2.261 6.957-5.918-4.3-5.918 4.3 2.26-6.957-5.917-4.3h7.314z",
    fill: "#FFF"
  }));
}, bOe = function(e) {
  var t = e.title, r = q(e, N9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M256 85.331h256v341.337H256z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#ACABB1",
    d: "m321.353 233.837 32.073 42.43c-5.053 7.651-5.026 17.961.817 25.692 7.414 9.807 21.374 11.748 31.182 4.335 9.807-7.414 11.748-21.374 4.334-31.182-5.843-7.731-15.756-10.568-24.495-7.795l-49.988-66.129-11.838 8.949-17.759 13.424 17.899 23.677 17.775-13.401zm46.175 48.78a7.421 7.421 0 1 1 8.95 11.84 7.421 7.421 0 0 1-8.95-11.84z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "m376.367 247.24 17.899-23.677-17.759-13.424-11.838-8.949-49.988 66.129c-8.74-2.775-18.651.063-24.495 7.795-7.414 9.808-5.473 23.768 4.334 31.182 9.808 7.414 23.768 5.473 31.182-4.335 5.845-7.731 5.871-18.041.817-25.692l32.073-42.43 17.775 13.401zm-62.504 45.771a7.42 7.42 0 1 1-11.84-8.95 7.42 7.42 0 0 1 11.84 8.95z"
  }));
}, wOe = function(e) {
  var t = e.title, r = q(e, L9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#338AF3",
    d: "M0 85.331h170.663v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M341.337 85.331H512v341.337H341.337zM214.261 283.82l-33.393-50.086 33.392-50.087 33.392 50.087zm83.478 0-33.391-50.086 33.391-50.087 33.393 50.087zM256 350.603l-33.391-50.087L256 250.429l33.391 50.087z",
    fill: "#6DA544"
  }));
}, xOe = function(e) {
  var t = e.title, r = q(e, $9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 22.5 15"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFCE00",
    d: "M0 0h22.5v5H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#203899",
    d: "M0 5h22.5v5H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D82B2B",
    d: "M0 10h22.5v5H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "m12.13 5.38.14.46.45.14-.39.27.01.48-.38-.29-.45.15.15-.44-.28-.38h.47zm-1.77 0 .27.39h.47l-.28.38.15.45-.45-.16-.38.28.01-.47-.39-.28.45-.13zm3.44.56-.01.48.39.27-.46.14-.14.45-.27-.38h-.48l.29-.38-.15-.45.45.16zm-5.11.02.4.27.44-.18-.13.46.3.36-.47.02-.26.4-.16-.44-.46-.12.37-.3zm6.55 1.17-.2.44.25.4-.47-.05-.31.36-.1-.46-.43-.18.41-.24.03-.47.35.31zm.19 1.12.21.43.47.07-.34.33.08.46-.42-.22-.42.22.08-.46-.34-.33.47-.07zM7 8.2l.21.43.47.06-.34.33.08.47L7 9.27l-.42.22.08-.47-.34-.33.47-.06zm.31-1.15.45.14.38-.29v.48l.39.26-.45.15-.13.46-.28-.38-.47.01.27-.38z"
  }));
}, EOe = function(e) {
  var t = e.title, r = q(e, F9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.334h512v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M256 85.334V202.66h-46.069L256 233.38v22.617h-22.628L160 207.078v48.919H96v-48.919l-73.372 48.919H0V233.38l46.069-30.72H0v-64h46.069L0 107.951V85.334h22.628L96 134.241V85.334h64v48.907l73.372-48.907z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#D80027"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.329v15.083l57.377 38.251H80zm256 0v15.083l-57.377 38.251H176z"
  })), /* @__PURE__ */ p.createElement("path", {
    fill: "#2E52B2",
    d: "M256 107.951v30.712h-46.069z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.329v15.083l57.377 38.251H80zm256 0v15.083l-57.377 38.251H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#2E52B2",
    d: "M256 107.951v30.712h-46.069z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 255.997v-15.082l57.377-38.252H80zm256 0v-15.082l-57.377-38.252H176z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "m384 259.706-46.129 46.129c8.645 16.675 26.051 28.074 46.129 28.074s37.484-11.4 46.129-28.074L384 259.706z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M332.058 178.084v81.624c.001 39.759 51.942 51.941 51.942 51.941s51.941-12.182 51.942-51.942v-81.623H332.058z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M372.87 215.181h22.261v59.359H372.87z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#A2001D",
    cx: 384,
    cy: 215.181,
    r: 11.13
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M346.902 192.92h14.84v14.84h-14.84zm0 33.392h14.84v14.84h-14.84zm0 33.391h14.84v14.84h-14.84zm59.359-66.783h14.84v14.84h-14.84zm0 33.392h14.84v14.84h-14.84zm0 33.391h14.84v14.84h-14.84z",
    fill: "#FFDA44"
  }));
}, SOe = function(e) {
  var t = e.title, r = q(e, B9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.3"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h512v341.3H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#1583C4",
    d: "m397.7 166.3-51 97.7c-1.1 2-.3 4.5 1.8 5.6 2 1.1 4.5.3 5.6-1.8l51-97.7c1-2.1.1-4.6-2-5.5-2-.9-4.3-.2-5.4 1.7z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#1583C4",
    d: "m404.9 188-57.8 75.4c-1.3 1.9-.8 4.5 1.1 5.8 1.7 1.2 4.1.9 5.5-.7l57.8-75.4c1.4-1.8 1.1-4.4-.8-5.8-1.8-1.5-4.4-1.1-5.8.7z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#1583C4",
    d: "m379 181.3-32.5 83.1c-.8 2.1.2 4.6 2.4 5.4 2.1.8 4.6-.2 5.4-2.4l32.5-83.1c.7-2.2-.4-4.5-2.6-5.3-2.1-.6-4.3.4-5.2 2.3z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#409347",
    d: "M122.1 171.9c.4 1.7 1.2 4.7 2.2 8.5 1.7 6.4 3.6 12.8 5.6 18.7 2.3 6.9 14.7 31.4 20.2 39.1 6.9 9.7 14.1 19.3 21.5 28.6 1.6 1.9 4.5 2.1 6.4.5 1.8-1.6 2.1-4.3.7-6.2-7.3-9.2-14.4-18.6-21.2-28.2-4.2-5.8-17.2-31.1-19-36.7-2.9-8.7-5.4-17.6-7.6-26.5-.5-2.4-2.9-4-5.3-3.5s-4 2.9-3.5 5.3c-.1.2 0 .3 0 .4z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFD836",
    stroke: "#231F20",
    strokeMiterlimit: 10
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M297.1 114.9S279.5 42.8 261 42.8c-6.9 0-11.9-.6-15.4 6.4-.9 1.7-20.7-1.6-19.1 20.8.5 6.9 1.1-9.8 14.9-3.4 6.3 3-16.4 48.2-16.4 48.2h72.1z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m466.1 48.4-90.9 22c-75.3 18.3-42.1 44.4-42.1 44.4l-72.1 12-72.1-12s33.2-26.1-42.1-44.4l-90.9-22C43.1 45.3 38.1 51.8 45.3 63c0 0 106.6 104 126.8 112 20.2 8.1 40.8 0 40.8 0s-14.9 8.7-24 24c-9.2 15.3-4.6 34.7-38.9 40.2-5.5 6.6-5 14 2.9 19.9 7.9 5.8 72.1-48.1 72.1-48.1s-24 24.4-24 36.1c0 5.1 44.1 53.8 60.1 53.8s60.1-48.7 60.1-53.8c0-11.7-24-36.1-24-36.1s64.2 53.9 72.1 48.1 11.4-19.3 2.8-19.9c-28-1.8-29.7-24.9-38.9-40.2-9.2-15.3-24-24-24-24s20.6 8.1 40.8 0S476.7 63 476.7 63c7.2-11.2 2.3-17.7-10.6-14.6z"
  })), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    stroke: "#231F20",
    strokeMiterlimit: 10,
    d: "M201.3 111.8v80.3c0 45.7 59.7 59.7 59.7 59.7s59.7-14 59.7-59.7v-80.3H201.3z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M225.2 137.7V235c8.2 6 17 10.2 23.9 12.9V137.7h-23.9zm71.6 0V235c-8.2 6-17 10.2-23.9 12.9V137.7h23.9z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M201.3 111.8h119.4v37.9H201.3z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#1583C4",
    d: "m60.1 210.5-21.9-58.1H15.7l31.8 80.8h25.2l31.5-80.8H81.7zm391.4-58.6h18.9v81.7h-18.9z"
  }));
}, COe = function(e) {
  var t = e.title, r = q(e, z9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M196.641 85.337H0v341.326h512V85.337z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "m256 157.279 22.663 69.747H352l-59.332 43.106 22.664 69.749L256 296.774l-59.332 43.107 22.664-69.749L160 227.026h73.337z"
  }));
}, TOe = function(e) {
  var t = e.title, r = q(e, H9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#6DA544",
    d: "M512 256v170.663H0L215.185 256z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M512 85.337V256H215.185L0 85.337z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M221.001 239.304 26.868 85.337H8.956l208.168 165.098H512v-11.131zM8.956 426.663h17.912l194.133-153.967H512v-11.131H217.124zM0 92.44v14.206L188.317 256 0 405.354v14.205L206.229 256z"
  }), /* @__PURE__ */ p.createElement("g", {
    fill: "#FFDA44"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M8.956 85.337H0v7.103L206.229 256 0 419.559v7.104h8.956l208.168-165.098H512v-11.13H217.124z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M63.718 292.382v-14.295c14.265 0 25.87-11.606 25.87-25.869 0-10.092-8.211-18.303-18.304-18.303-6.875 0-12.469 5.593-12.469 12.469 0 4.397 3.577 7.974 7.974 7.974a4.514 4.514 0 0 0 4.508-4.508h14.295c0 10.368-8.435 18.804-18.802 18.804-12.279-.002-22.269-9.993-22.269-22.271 0-14.758 12.006-26.764 26.764-26.764 17.975 0 32.599 14.623 32.599 32.599 0 22.145-18.018 40.164-40.166 40.164z"
  })));
}, AOe = function(e) {
  var t = e.title, r = q(e, U9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 150 100"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80B30",
    d: "M0 0h150v100H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#00318A",
    d: "M0 0h20v44.33H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M20 0h20v44.33H20z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "none",
    stroke: "#FFF",
    strokeWidth: 3,
    d: "M0 44.33h62.75V0"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M108.08 43.29 87.96 23.17h40.25l-20.13 20.12zm-6.7 6.71L81.25 29.88v40.25L101.38 50zm6.7 6.71L87.96 76.83h40.25l-20.13-20.12zm6.71-6.71 20.13-20.13v40.25L114.79 50z"
  }));
}, MOe = function(e) {
  var t = e.title, r = q(e, V9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 85.331h256v170.663H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m165.483 181.79 2.764 8.504h8.939l-7.232 5.254 2.763 8.503-7.234-5.255-7.233 5.255 2.763-8.503-7.233-5.254h8.94zm-44.904-66.783 4.606 14.173h14.9l-12.055 8.757 4.605 14.171-12.056-8.758-12.054 8.758 4.605-14.171-12.056-8.757h14.901zm44.522 14.841 4.606 14.172h14.9l-12.055 8.757 4.604 14.173-12.055-8.76-12.054 8.76 4.604-14.173-12.055-8.757h14.9zm-35.192 59.363 4.606 14.172h14.9l-12.055 8.758 4.604 14.171-12.055-8.759-12.054 8.759 4.604-14.171-12.055-8.758h14.9zm-39.01-37.103 4.605 14.173h14.9l-12.055 8.757 4.604 14.173-12.054-8.76-12.055 8.76 4.604-14.173-12.055-8.757h14.9z",
    fill: "#FFF"
  }));
}, kOe = function(e) {
  var t = e.title, r = q(e, j9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 341.33"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#0052B4",
    d: "M0 0h512v341.34H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "m220.72 42.63 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.36-15.9 8.36 3.03-17.7-12.86-12.54 17.78-2.58zm70.56-.06 7.95 16.1 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59zm62.08 11.36 7.95 16.11 17.77 2.58-12.86 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.87-12.54 17.78-2.58zm63.01 18.3 7.95 16.11 17.77 2.59-12.86 12.53 3.04 17.71-15.9-8.36-15.9 8.36 3.03-17.71-12.86-12.53 17.78-2.59zm-257.73-18.3 7.95 16.11 17.78 2.58-12.87 12.54 3.04 17.7-15.9-8.35-15.9 8.35 3.04-17.7-12.86-12.54 17.77-2.58zm-63.01 18.3 7.95 16.11 17.78 2.59-12.86 12.53 3.03 17.71-15.9-8.36-15.9 8.36 3.04-17.71-12.86-12.53 17.77-2.59z",
    fill: "#FFF"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "m217.53 259.33-27.22-13.61-27.22-54.43h27.22l27.22-27.22 13.61-27.22 27.22-13.61 13.61 13.61 27.22 13.61v13.61l13.61 13.61 40.83 27.22L340 245.73l-40.83 40.83-13.61-27.22-40.83 27.22v27.22l-13.61-13.61-13.59-40.84z"
  }));
}, _Oe = function(e) {
  var t = e.title, r = q(e, W9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M0 85.337h512v113.775H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 312.888h512v113.775H0z"
  }));
}, OOe = function(e) {
  var t = e.title, r = q(e, G9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 60"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 0h90v60H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    stroke: "#7f7f7f",
    strokeWidth: 0.25,
    fill: "#ABABAB",
    d: "M75.6 39.6c-1.1.7 0 1.8-.6 1.9-.6.1-1.5-1.4-.2-2.5 1.6-1.5 5.8 0 5.9 4.3 0 2.2-.9 6.8-7.2 6.8-7.6 0-11.4-5.7-11.4-11.4 0-4.8 3.7-13.5 6.5-14.6 3.1-1.2 6.7-3.5 6.8-5 0-.5-1.4-.1-3.3.9-3.1 1.7-6.6 2.5-6.6 1.4s2.9-3.1 4-4.6c1.2-1.6.9-5.5 3-5.5 7.6 0 9.9 7.7 7 11.7-1.9 2.6 4.3 1 4.3 1s0 5.3-3.2 7.3c-3 1.8-4.8 3.9-4.8 3.9s.2-4.6-.5-3.9c-.6.7-11.1 4.5-10.3 12 .3 3 4.5 5.4 8.5 5.2s5.7-2.4 5.8-4.9c.1-3.9-3-4.4-3.7-4zm-64.9 4c.1 2.5 1.8 4.7 5.8 4.9s8.2-2.2 8.5-5.2c.8-7.5-9.7-11.3-10.3-12-.7-.7-.5 3.9-.5 3.9s-1.8-2.1-4.8-3.9c-3.2-2-3.2-7.3-3.2-7.3s6.2 1.6 4.3-1c-2.9-4-.6-11.7 7-11.7 2.1 0 1.8 3.9 3 5.5 1.1 1.5 4 3.5 4 4.6s-3.5.3-6.6-1.4c-1.9-1-3.3-1.4-3.3-.9.1 1.5 3.7 3.8 6.8 5 2.8 1.1 6.5 9.8 6.5 14.6 0 5.7-3.8 11.4-11.4 11.4-6.3 0-7.2-4.6-7.2-6.8.1-4.3 4.3-5.8 5.9-4.3 1.2 1.1.4 2.7-.2 2.5-.6-.1.6-1.2-.6-1.9-.6-.4-3.7.1-3.7 4z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#DE393A",
    d: "M31 28.8v14c0 1.9 2.1 1.6 2.1 1.6h9.3c1.2 0 2.6 2.3 2.6 2.3s1.4-2.3 2.5-2.3h9.6s2 .2 2-1.8V28.7H31z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#3951A3",
    d: "M31 13.1h28v15.7H31z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M50.1 16.5c-.4 2.4-2.5 4.2-5.1 4.2-2.5 0-4.6-1.8-5.1-4.2-.5.9-.8 1.9-.8 3 0 3.3 2.6 5.9 5.9 5.9 3.3 0 5.9-2.6 5.9-5.9 0-1.1-.3-2.1-.8-3z"
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FEE05F",
    cx: 39.1,
    cy: 36.5,
    r: 3
  }), /* @__PURE__ */ p.createElement("circle", {
    fill: "#FEE05F",
    cx: 50.9,
    cy: 36.5,
    r: 3
  }));
}, IOe = function(e) {
  var t = e.title, r = q(e, K9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M0 85.337h512v341.326H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M114.024 256.001 0 141.926v228.17z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#ffb915",
    d: "M161.192 256 0 94.7v47.226l114.024 114.075L0 370.096v47.138z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#007847",
    d: "M509.833 289.391c.058-.44.804-.878 2.167-1.318v-65.464H222.602L85.33 85.337H0V94.7L161.192 256 0 417.234v9.429h85.33l137.272-137.272h287.231z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#000c8a",
    d: "M503.181 322.783H236.433l-103.881 103.88H512v-103.88z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#e1392d",
    d: "M503.181 189.217H512V85.337H132.552l103.881 103.88z"
  }));
}, ROe = function(e) {
  var t = e.title, r = q(e, q9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    fill: "#496E2D",
    d: "M0 85.331h512v341.337H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FF9811",
    d: "M490.668 195.476h-48c0-8.836-7.164-16-16-16s-16 7.164-16 16h-48c0 8.836 7.697 16 16.533 16h-.533c0 8.836 7.162 16 16 16 0 8.836 7.162 16 16 16h32c8.836 0 16-7.164 16-16 8.836 0 16-7.164 16-16h-.533c8.837 0 16.533-7.164 16.533-16z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "M341.337 255.994h56.888v170.663h-56.888z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FF9811",
    d: "M455.112 255.994H512v170.663h-56.888z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M398.225 255.994h56.888v170.663h-56.888z"
  }));
}, POe = function(e) {
  var t = e.title, r = q(e, Y9e);
  return /* @__PURE__ */ p.createElement("svg", K({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 85.333 512 341.333"
  }, r), t && /* @__PURE__ */ p.createElement("title", null, t), /* @__PURE__ */ p.createElement("path", {
    d: "M0 85.333h512V426.67H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 134.196h512v48.868H0zm0 195.472h512v48.868H0z",
    fill: "#FFDA44"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#057f44",
    d: "M0 85.333h512v48.868H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M0 183.069h512v48.868H0zm0 97.737h512v48.868H0z",
    fill: "#D80027"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#057f44",
    d: "M0 378.542h512v48.128H0z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFF",
    d: "M276.992 255.996 106.329 426.659H0V85.333h106.329z"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M256 255.996 85.334 426.662h20.987l170.667-170.666L106.321 85.33H85.334z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#D80027",
    d: "m102.465 202.57 13.259 40.812h42.917l-34.718 25.226 13.26 40.814-34.718-25.224-34.72 25.224 13.262-40.814-34.718-25.226h42.915z"
  }), /* @__PURE__ */ p.createElement("path", {
    fill: "#FFDA44",
    d: "m138.94 259.335-34.559-12.243s-2.553-23.955-2.708-24.766c-1.173-6.18-6.603-10.851-13.123-10.851-7.376 0-13.357 5.98-13.357 13.357 0 1.223.178 2.402.486 3.528l-9.689 9.755h17.229c0 17.882-13.344 17.882-13.344 35.691l7.402 17.809h44.522l7.422-17.809h-.004a17.782 17.782 0 0 0 1.381-5.231c6.397-2.589 8.342-9.24 8.342-9.24z"
  }));
};
const sX = {
  AC: Z9e,
  AD: Q9e,
  AE: J9e,
  AF: eAe,
  AG: tAe,
  AI: nAe,
  AL: rAe,
  AM: iAe,
  AO: sAe,
  AQ: oAe,
  AR: aAe,
  AS: lAe,
  AT: cAe,
  AU: uAe,
  AW: dAe,
  AX: fAe,
  AZ: hAe,
  BA: pAe,
  BB: mAe,
  BD: gAe,
  BE: vAe,
  BF: yAe,
  BG: bAe,
  BH: wAe,
  BI: xAe,
  BJ: EAe,
  BL: SAe,
  BM: CAe,
  BN: TAe,
  BO: AAe,
  BQ: MAe,
  BR: kAe,
  BS: _Ae,
  BT: OAe,
  BV: IAe,
  BW: RAe,
  BY: PAe,
  BZ: DAe,
  CA: NAe,
  CC: LAe,
  CD: $Ae,
  CF: FAe,
  CG: BAe,
  CH: zAe,
  CI: HAe,
  CK: UAe,
  CL: VAe,
  CM: jAe,
  CN: WAe,
  CO: GAe,
  CR: KAe,
  CU: qAe,
  CV: YAe,
  CW: XAe,
  CX: ZAe,
  CY: QAe,
  CZ: JAe,
  DE: eMe,
  DJ: tMe,
  DK: nMe,
  DM: rMe,
  DO: iMe,
  DZ: sMe,
  EC: oMe,
  EE: aMe,
  EG: lMe,
  EH: cMe,
  ER: uMe,
  ES: dMe,
  ET: fMe,
  EU: iX,
  FI: hMe,
  FJ: pMe,
  FK: mMe,
  FM: gMe,
  FO: vMe,
  FR: yMe,
  GA: bMe,
  GB: wMe,
  GD: xMe,
  GE: EMe,
  GF: SMe,
  GG: CMe,
  GH: TMe,
  GI: AMe,
  GL: MMe,
  GM: kMe,
  GN: _Me,
  GP: OMe,
  GQ: IMe,
  GR: RMe,
  GS: PMe,
  GT: DMe,
  GU: NMe,
  GW: LMe,
  GY: $Me,
  HK: FMe,
  HM: BMe,
  HN: zMe,
  HR: HMe,
  HT: UMe,
  HU: VMe,
  IC: jMe,
  ID: WMe,
  IE: GMe,
  IL: KMe,
  IM: qMe,
  IN: YMe,
  IO: XMe,
  IQ: ZMe,
  IR: QMe,
  IS: JMe,
  IT: eke,
  JE: tke,
  JM: nke,
  JO: rke,
  JP: ike,
  KE: ske,
  KG: oke,
  KH: ake,
  KI: lke,
  KM: cke,
  KN: uke,
  KP: dke,
  KR: fke,
  KW: hke,
  KY: pke,
  KZ: mke,
  LA: gke,
  LB: vke,
  LC: yke,
  LI: bke,
  LK: wke,
  LR: xke,
  LS: Eke,
  LT: Ske,
  LU: Cke,
  LV: Tke,
  LY: Ake,
  MA: Mke,
  MC: kke,
  MD: _ke,
  ME: Oke,
  MF: Ike,
  MG: Rke,
  MH: Pke,
  MK: Dke,
  ML: Nke,
  MM: Lke,
  MN: $ke,
  MO: Fke,
  MP: Bke,
  MQ: zke,
  MR: Hke,
  MS: Uke,
  MT: Vke,
  MU: jke,
  MV: Wke,
  MW: Gke,
  MX: Kke,
  MY: qke,
  MZ: Yke,
  NA: Xke,
  NC: Zke,
  NE: Qke,
  NF: Jke,
  NG: e_e,
  NI: t_e,
  NL: n_e,
  NO: r_e,
  NP: i_e,
  NR: s_e,
  NU: o_e,
  NZ: a_e,
  OM: l_e,
  PA: c_e,
  PE: u_e,
  PF: d_e,
  PG: f_e,
  PH: h_e,
  PK: p_e,
  PL: m_e,
  PM: g_e,
  PN: v_e,
  PR: y_e,
  PS: b_e,
  PT: w_e,
  PW: x_e,
  PY: E_e,
  QA: S_e,
  RE: C_e,
  RO: T_e,
  RS: A_e,
  RU: M_e,
  RW: k_e,
  SA: __e,
  SB: O_e,
  SC: I_e,
  SD: R_e,
  SE: P_e,
  SG: D_e,
  SH: N_e,
  SI: L_e,
  SJ: $_e,
  SK: F_e,
  SL: B_e,
  SM: z_e,
  SN: H_e,
  SO: U_e,
  SR: V_e,
  SS: j_e,
  ST: W_e,
  SV: G_e,
  SX: K_e,
  SY: q_e,
  SZ: Y_e,
  TA: X_e,
  TC: Z_e,
  TD: Q_e,
  TF: J_e,
  TG: eOe,
  TH: tOe,
  TJ: nOe,
  TK: rOe,
  TL: iOe,
  TM: sOe,
  TN: oOe,
  TO: aOe,
  TR: lOe,
  TT: cOe,
  TV: uOe,
  TW: dOe,
  TZ: fOe,
  UA: hOe,
  UG: pOe,
  UM: mOe,
  US: gOe,
  UY: vOe,
  UZ: yOe,
  VA: bOe,
  VC: wOe,
  VE: xOe,
  VG: EOe,
  VI: SOe,
  VN: COe,
  VU: TOe,
  WF: AOe,
  WS: MOe,
  XK: kOe,
  YE: _Oe,
  YT: OOe,
  ZA: IOe,
  ZM: ROe,
  ZW: POe
}, jbt = () => /* @__PURE__ */ T(qM, { country: "AU", countryName: "Australia" }), Wbt = () => /* @__PURE__ */ T(qM, { country: "US", countryName: "United States" }), Gbt = () => /* @__PURE__ */ T(qM, { country: "CA", countryName: "Canada" }), Kbt = () => /* @__PURE__ */ T("div", { className: "tw:inline-block tw:w-8 tw:h-4 tw:overflow-hidden tw:rounded-sm tw:[&_svg]:size-full tw:ps-1 tw:pe-1", children: /* @__PURE__ */ T(iX, {}) }), KM = ({ country: n, countryName: e }) => {
  const t = sX[n];
  return /* @__PURE__ */ T("span", { className: "tw:flex tw:h-4 tw:w-6 tw:overflow-hidden tw:rounded-sm tw:bg-foreground/20 tw:[&_svg]:size-full", children: t && /* @__PURE__ */ T(t, { title: e }) });
}, qM = ({
  country: n,
  countryName: e
}) => {
  const t = sX[n];
  return /* @__PURE__ */ T("div", { className: "tw:inline-block tw:w-8 tw:h-4 tw:overflow-hidden tw:rounded-sm tw:[&_svg]:size-full tw:ps-1 tw:pe-1", children: t && /* @__PURE__ */ T(t, { title: e }) });
};
function FF(n, e) {
  if (typeof n == "function")
    return n(e);
  n != null && (n.current = e);
}
function bi(...n) {
  return (e) => {
    let t = !1;
    const r = n.map((i) => {
      const s = FF(i, e);
      return !t && typeof s == "function" && (t = !0), s;
    });
    if (t)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const s = r[i];
          typeof s == "function" ? s() : FF(n[i], null);
        }
      };
  };
}
function ht(...n) {
  return A.useCallback(bi(...n), n);
}
var DOe = Symbol.for("react.lazy"), gy = A[" use ".trim().toString()];
function NOe(n) {
  return typeof n == "object" && n !== null && "then" in n;
}
function oX(n) {
  return n != null && typeof n == "object" && "$$typeof" in n && n.$$typeof === DOe && "_payload" in n && NOe(n._payload);
}
// @__NO_SIDE_EFFECTS__
function aX(n) {
  const e = /* @__PURE__ */ LOe(n), t = A.forwardRef((r, i) => {
    let { children: s, ...o } = r;
    oX(s) && typeof gy == "function" && (s = gy(s._payload));
    const a = A.Children.toArray(s), l = a.find(FOe);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? A.Children.count(c) > 1 ? A.Children.only(null) : A.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ T(e, { ...o, ref: i, children: A.isValidElement(c) ? A.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ T(e, { ...o, ref: i, children: s });
  });
  return t.displayName = `${n}.Slot`, t;
}
var sd = /* @__PURE__ */ aX("Slot");
// @__NO_SIDE_EFFECTS__
function LOe(n) {
  const e = A.forwardRef((t, r) => {
    let { children: i, ...s } = t;
    if (oX(i) && typeof gy == "function" && (i = gy(i._payload)), A.isValidElement(i)) {
      const o = zOe(i), a = BOe(s, i.props);
      return i.type !== A.Fragment && (a.ref = r ? bi(r, o) : o), A.cloneElement(i, a);
    }
    return A.Children.count(i) > 1 ? A.Children.only(null) : null;
  });
  return e.displayName = `${n}.SlotClone`, e;
}
var $Oe = Symbol("radix.slottable");
function FOe(n) {
  return A.isValidElement(n) && typeof n.type == "function" && "__radixId" in n.type && n.type.__radixId === $Oe;
}
function BOe(n, e) {
  const t = { ...e };
  for (const r in e) {
    const i = n[r], s = e[r];
    /^on[A-Z]/.test(r) ? i && s ? t[r] = (...a) => {
      const l = s(...a);
      return i(...a), l;
    } : i && (t[r] = i) : r === "style" ? t[r] = { ...i, ...s } : r === "className" && (t[r] = [i, s].filter(Boolean).join(" "));
  }
  return { ...n, ...t };
}
function zOe(n) {
  let e = Object.getOwnPropertyDescriptor(n.props, "ref")?.get, t = e && "isReactWarning" in e && e.isReactWarning;
  return t ? n.ref : (e = Object.getOwnPropertyDescriptor(n, "ref")?.get, t = e && "isReactWarning" in e && e.isReactWarning, t ? n.props.ref : n.props.ref || n.ref);
}
const BF = (n) => typeof n == "boolean" ? `${n}` : n === 0 ? "0" : n, zF = Ut, _c = (n, e) => (t) => {
  var r;
  if (e?.variants == null) return zF(n, t?.class, t?.className);
  const { variants: i, defaultVariants: s } = e, o = Object.keys(i).map((c) => {
    const u = t?.[c], d = s?.[c];
    if (u === null) return null;
    const f = BF(u) || BF(d);
    return i[c][f];
  }), a = t && Object.entries(t).reduce((c, u) => {
    let [d, f] = u;
    return f === void 0 || (c[d] = f), c;
  }, {}), l = e == null || (r = e.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((c, u) => {
    let { class: d, className: f, ...h } = u;
    return Object.entries(h).every((m) => {
      let [g, v] = m;
      return Array.isArray(v) ? v.includes({
        ...s,
        ...a
      }[g]) : {
        ...s,
        ...a
      }[g] === v;
    }) ? [
      ...c,
      d,
      f
    ] : c;
  }, []);
  return zF(n, o, l, t?.class, t?.className);
}, IT = _c(
  "tw:inline-flex tw:items-center tw:justify-center tw:gap-2 tw:whitespace-nowrap tw:rounded-md tw:text-sm tw:font-medium tw:ring-offset-background tw:transition-colors tw:focus-visible:outline-hidden tw:focus-visible:ring-2 tw:focus-visible:ring-ring tw:focus-visible:ring-offset-2 tw:disabled:pointer-events-none tw:disabled:opacity-50 tw:[&_svg]:pointer-events-none tw:[&_svg]:size-4 tw:[&_svg]:shrink-0 tw:cursor-pointer",
  {
    variants: {
      variant: {
        default: "tw:bg-primary tw:text-primary-foreground tw:hover:bg-primary/90",
        destructive: "tw:bg-destructive tw:text-destructive-foreground tw:hover:bg-destructive/90",
        outline: "tw:border tw:border-input tw:bg-background tw:hover:bg-accent tw:hover:text-accent-foreground",
        secondary: "tw:bg-secondary tw:text-secondary-foreground tw:hover:bg-secondary/80",
        ghost: "tw:hover:bg-accent tw:hover:text-accent-foreground",
        link: "tw:text-primary tw:underline-offset-4 tw:hover:underline"
      },
      size: {
        // TM - Added margin by default
        // TM - Which I since removed - tw:m-1
        default: "tw:h-10 tw:px-4 tw:py-2",
        sm: "tw:h-9 tw:rounded-md tw:px-3",
        lg: "tw:h-11 tw:rounded-md tw:px-8",
        icon: "tw:h-10 tw:w-10",
        // TM - Added none type
        none: "tw:m-0"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Nt = A.forwardRef(
  ({ className: n, variant: e, size: t, asChild: r = !1, ...i }, s) => /* @__PURE__ */ T(
    r ? sd : "button",
    {
      className: Q(IT({ variant: e, size: t, className: n })),
      ref: s,
      ...i
    }
  )
);
Nt.displayName = "Button";
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HOe = (n) => n.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), UOe = (n) => n.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (e, t, r) => r ? r.toUpperCase() : t.toLowerCase()
), HF = (n) => {
  const e = UOe(n);
  return e.charAt(0).toUpperCase() + e.slice(1);
}, lX = (...n) => n.filter((e, t, r) => !!e && e.trim() !== "" && r.indexOf(e) === t).join(" ").trim(), VOe = (n) => {
  for (const e in n)
    if (e.startsWith("aria-") || e === "role" || e === "title")
      return !0;
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var jOe = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WOe = tn(
  ({
    color: n = "currentColor",
    size: e = 24,
    strokeWidth: t = 2,
    absoluteStrokeWidth: r,
    className: i = "",
    children: s,
    iconNode: o,
    ...a
  }, l) => lt(
    "svg",
    {
      ref: l,
      ...jOe,
      width: e,
      height: e,
      stroke: n,
      strokeWidth: r ? Number(t) * 24 / Number(e) : t,
      className: lX("lucide", i),
      ...!s && !VOe(a) && { "aria-hidden": "true" },
      ...a
    },
    [
      ...o.map(([c, u]) => lt(c, u)),
      ...Array.isArray(s) ? s : [s]
    ]
  )
);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ze = (n, e) => {
  const t = tn(
    ({ className: r, ...i }, s) => lt(WOe, {
      ref: s,
      iconNode: e,
      className: lX(
        `lucide-${HOe(HF(n))}`,
        `lucide-${n}`,
        r
      ),
      ...i
    })
  );
  return t.displayName = HF(n), t;
};
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GOe = [
  ["path", { d: "m12 19-7-7 7-7", key: "1l729n" }],
  ["path", { d: "M19 12H5", key: "x3x0zl" }]
], KOe = Ze("arrow-left", GOe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qOe = [
  ["path", { d: "M5 12h14", key: "1ays0h" }],
  ["path", { d: "m12 5 7 7-7 7", key: "xquz4c" }]
], YOe = Ze("arrow-right", qOe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XOe = [
  ["path", { d: "m21 16-4 4-4-4", key: "f6ql7i" }],
  ["path", { d: "M17 20V4", key: "1ejh1v" }],
  ["path", { d: "m3 8 4-4 4 4", key: "11wl7u" }],
  ["path", { d: "M7 4v16", key: "1glfcx" }]
], qbt = Ze("arrow-up-down", XOe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZOe = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  ["path", { d: "M15 8h6", key: "8ybuxh" }],
  ["path", { d: "M18 5v6", key: "g5ayrv" }],
  [
    "path",
    {
      d: "M20.002 14.464a9 9 0 0 0 .738.863A1 1 0 0 1 20 17H4a1 1 0 0 1-.74-1.673C4.59 13.956 6 12.499 6 8a6 6 0 0 1 8.75-5.332",
      key: "1abcvy"
    }
  ]
], Ybt = Ze("bell-plus", ZOe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QOe = [
  ["path", { d: "M10.268 21a2 2 0 0 0 3.464 0", key: "vwvbt9" }],
  [
    "path",
    {
      d: "M3.262 15.326A1 1 0 0 0 4 17h16a1 1 0 0 0 .74-1.673C19.41 13.956 18 12.499 18 8A6 6 0 0 0 6 8c0 4.499-1.411 5.956-2.738 7.326",
      key: "11g9vi"
    }
  ]
], Xbt = Ze("bell", QOe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JOe = [
  [
    "path",
    {
      d: "M2.97 12.92A2 2 0 0 0 2 14.63v3.24a2 2 0 0 0 .97 1.71l3 1.8a2 2 0 0 0 2.06 0L12 19v-5.5l-5-3-4.03 2.42Z",
      key: "lc1i9w"
    }
  ],
  ["path", { d: "m7 16.5-4.74-2.85", key: "1o9zyk" }],
  ["path", { d: "m7 16.5 5-3", key: "va8pkn" }],
  ["path", { d: "M7 16.5v5.17", key: "jnp8gn" }],
  [
    "path",
    {
      d: "M12 13.5V19l3.97 2.38a2 2 0 0 0 2.06 0l3-1.8a2 2 0 0 0 .97-1.71v-3.24a2 2 0 0 0-.97-1.71L17 10.5l-5 3Z",
      key: "8zsnat"
    }
  ],
  ["path", { d: "m17 16.5-5-3", key: "8arw3v" }],
  ["path", { d: "m17 16.5 4.74-2.85", key: "8rfmw" }],
  ["path", { d: "M17 16.5v5.17", key: "k6z78m" }],
  [
    "path",
    {
      d: "M7.97 4.42A2 2 0 0 0 7 6.13v4.37l5 3 5-3V6.13a2 2 0 0 0-.97-1.71l-3-1.8a2 2 0 0 0-2.06 0l-3 1.8Z",
      key: "1xygjf"
    }
  ],
  ["path", { d: "M12 8 7.26 5.15", key: "1vbdud" }],
  ["path", { d: "m12 8 4.74-2.85", key: "3rx089" }],
  ["path", { d: "M12 13.5V8", key: "1io7kd" }]
], Zbt = Ze("boxes", JOe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eIe = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
], tIe = Ze("calendar", eIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nIe = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], oc = Ze("check", nIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rIe = [["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]], od = Ze("chevron-down", rIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const iIe = [["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]], cX = Ze("chevron-left", iIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sIe = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], m1 = Ze("chevron-right", sIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oIe = [["path", { d: "m18 15-6-6-6 6", key: "153udz" }]], aIe = Ze("chevron-up", oIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lIe = [
  ["path", { d: "m11 17-5-5 5-5", key: "13zhaf" }],
  ["path", { d: "m18 17-5-5 5-5", key: "h8a8et" }]
], cIe = Ze("chevrons-left", lIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uIe = [
  ["path", { d: "m6 17 5-5-5-5", key: "xnjwq" }],
  ["path", { d: "m13 17 5-5-5-5", key: "17xmmf" }]
], dIe = Ze("chevrons-right", uIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const fIe = [
  ["path", { d: "m7 15 5 5 5-5", key: "1hf1tw" }],
  ["path", { d: "m7 9 5-5 5 5", key: "sgt6xg" }]
], hIe = Ze("chevrons-up-down", fIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pIe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
], mIe = Ze("circle-alert", pIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gIe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M8 12h8", key: "1wcyev" }],
  ["path", { d: "M12 8v8", key: "napkw2" }]
], vIe = Ze("circle-plus", gIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const yIe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3", key: "1u773s" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], Qbt = Ze("circle-question-mark", yIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bIe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
], UF = Ze("circle-x", bIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const wIe = [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]], uX = Ze("circle", wIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xIe = [
  ["rect", { width: "8", height: "4", x: "8", y: "2", rx: "1", ry: "1", key: "tgr4d6" }],
  [
    "path",
    {
      d: "M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2",
      key: "116196"
    }
  ]
], EIe = Ze("clipboard", xIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const SIe = [
  ["path", { d: "M11 10.27 7 3.34", key: "16pf9h" }],
  ["path", { d: "m11 13.73-4 6.93", key: "794ttg" }],
  ["path", { d: "M12 22v-2", key: "1osdcq" }],
  ["path", { d: "M12 2v2", key: "tus03m" }],
  ["path", { d: "M14 12h8", key: "4f43i9" }],
  ["path", { d: "m17 20.66-1-1.73", key: "eq3orb" }],
  ["path", { d: "m17 3.34-1 1.73", key: "2wel8s" }],
  ["path", { d: "M2 12h2", key: "1t8f8n" }],
  ["path", { d: "m20.66 17-1.73-1", key: "sg0v6f" }],
  ["path", { d: "m20.66 7-1.73 1", key: "1ow05n" }],
  ["path", { d: "m3.34 17 1.73-1", key: "nuk764" }],
  ["path", { d: "m3.34 7 1.73 1", key: "1ulond" }],
  ["circle", { cx: "12", cy: "12", r: "2", key: "1c9p78" }],
  ["circle", { cx: "12", cy: "12", r: "8", key: "46899m" }]
], Jbt = Ze("cog", SIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const CIe = [
  ["path", { d: "M12 2a10 10 0 1 0 10 10 4 4 0 0 1-5-5 4 4 0 0 1-5-5", key: "laymnq" }],
  ["path", { d: "M8.5 8.5v.01", key: "ue8clq" }],
  ["path", { d: "M16 15.5v.01", key: "14dtrp" }],
  ["path", { d: "M12 12v.01", key: "u5ubse" }],
  ["path", { d: "M11 17v.01", key: "1hyl5a" }],
  ["path", { d: "M7 14v.01", key: "uct60s" }]
], ewt = Ze("cookie", CIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TIe = [
  [
    "path",
    {
      d: "M10 5a2 2 0 0 0-1.344.519l-6.328 5.74a1 1 0 0 0 0 1.481l6.328 5.741A2 2 0 0 0 10 19h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2z",
      key: "1yo7s0"
    }
  ],
  ["path", { d: "m12 9 6 6", key: "anjzzh" }],
  ["path", { d: "m18 9-6 6", key: "1fp51s" }]
], AIe = Ze("delete", TIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const MIe = [
  [
    "path",
    { d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z", key: "1jg4f8" }
  ]
], twt = Ze("facebook", MIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kIe = [
  [
    "path",
    {
      d: "M10 20a1 1 0 0 0 .553.895l2 1A1 1 0 0 0 14 21v-7a2 2 0 0 1 .517-1.341L21.74 4.67A1 1 0 0 0 21 3H3a1 1 0 0 0-.742 1.67l7.225 7.989A2 2 0 0 1 10 14z",
      key: "sc7q7i"
    }
  ]
], nwt = Ze("funnel", kIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const _Ie = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20", key: "13o1zl" }],
  ["path", { d: "M2 12h20", key: "9i4pu4" }]
], rwt = Ze("globe", _Ie);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OIe = [
  [
    "path",
    {
      d: "M3 11h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-5Zm0 0a9 9 0 1 1 18 0m0 0v5a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3Z",
      key: "12oyoe"
    }
  ],
  ["path", { d: "M21 16v2a4 4 0 0 1-4 4h-5", key: "1x7m43" }]
], iwt = Ze("headset", OIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IIe = [
  [
    "path",
    {
      d: "M19.414 14.414C21 12.828 22 11.5 22 9.5a5.5 5.5 0 0 0-9.591-3.676.6.6 0 0 1-.818.001A5.5 5.5 0 0 0 2 9.5c0 2.3 1.5 4 3 5.5l5.535 5.362a2 2 0 0 0 2.879.052 2.12 2.12 0 0 0-.004-3 2.124 2.124 0 1 0 3-3 2.124 2.124 0 0 0 3.004 0 2 2 0 0 0 0-2.828l-1.881-1.882a2.41 2.41 0 0 0-3.409 0l-1.71 1.71a2 2 0 0 1-2.828 0 2 2 0 0 1 0-2.828l2.823-2.762",
      key: "17lmqv"
    }
  ]
], swt = Ze("heart-handshake", IIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RIe = [
  ["path", { d: "M15 21v-8a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v8", key: "5wwlr5" }],
  [
    "path",
    {
      d: "M3 10a2 2 0 0 1 .709-1.528l7-6a2 2 0 0 1 2.582 0l7 6A2 2 0 0 1 21 10v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
      key: "r6nss1"
    }
  ]
], owt = Ze("house", RIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const PIe = [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "M12 16v-4", key: "1dtifu" }],
  ["path", { d: "M12 8h.01", key: "e9boi3" }]
], awt = Ze("info", PIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DIe = [
  [
    "path",
    {
      d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
      key: "zw3jo"
    }
  ],
  [
    "path",
    {
      d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
      key: "1wduqc"
    }
  ],
  [
    "path",
    {
      d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
      key: "kqbvx6"
    }
  ]
], lwt = Ze("layers", DIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const NIe = [
  [
    "path",
    {
      d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
      key: "1gvzjb"
    }
  ],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
], cwt = Ze("lightbulb", NIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LIe = [
  ["rect", { width: "18", height: "11", x: "3", y: "11", rx: "2", ry: "2", key: "1w4ew1" }],
  ["path", { d: "M7 11V7a5 5 0 0 1 10 0v4", key: "fwvmzm" }]
], $Ie = Ze("lock", LIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FIe = [
  [
    "path",
    {
      d: "M21.2 8.4c.5.38.8.97.8 1.6v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10a2 2 0 0 1 .8-1.6l8-6a2 2 0 0 1 2.4 0l8 6Z",
      key: "1jhwl8"
    }
  ],
  ["path", { d: "m22 10-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 10", key: "1qfld7" }]
], uwt = Ze("mail-open", FIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const BIe = [
  ["path", { d: "m22 7-8.991 5.727a2 2 0 0 1-2.009 0L2 7", key: "132q7q" }],
  ["rect", { x: "2", y: "4", width: "20", height: "16", rx: "2", key: "izxlao" }]
], dwt = Ze("mail", BIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zIe = [
  [
    "path",
    {
      d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
      key: "1r0f0z"
    }
  ],
  ["circle", { cx: "12", cy: "10", r: "3", key: "ilqhr7" }]
], fwt = Ze("map-pin", zIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const HIe = [
  ["path", { d: "M15 3h6v6", key: "1q9fwt" }],
  ["path", { d: "m21 3-7 7", key: "1l2asr" }],
  ["path", { d: "m3 21 7-7", key: "tjx5ai" }],
  ["path", { d: "M9 21H3v-6", key: "wtvkvv" }]
], UIe = Ze("maximize-2", HIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const VIe = [
  ["path", { d: "M4 5h16", key: "1tepv9" }],
  ["path", { d: "M4 12h16", key: "1lakjw" }],
  ["path", { d: "M4 19h16", key: "1djgab" }]
], jIe = Ze("menu", VIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WIe = [
  ["path", { d: "M18 8V6a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h8", key: "10dyio" }],
  ["path", { d: "M10 19v-3.96 3.15", key: "1irgej" }],
  ["path", { d: "M7 19h5", key: "qswx4l" }],
  ["rect", { width: "6", height: "10", x: "16", y: "12", rx: "2", key: "1egngj" }]
], hwt = Ze("monitor-smartphone", WIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const GIe = [
  [
    "path",
    {
      d: "M20.985 12.486a9 9 0 1 1-9.473-9.472c.405-.022.617.46.402.803a6 6 0 0 0 8.268 8.268c.344-.215.825-.004.803.401",
      key: "kfwtm"
    }
  ]
], KIe = Ze("moon", GIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const qIe = [
  [
    "path",
    {
      d: "M3 20h4.5a.5.5 0 0 0 .5-.5v-.282a.52.52 0 0 0-.247-.437 8 8 0 1 1 8.494-.001.52.52 0 0 0-.247.438v.282a.5.5 0 0 0 .5.5H21",
      key: "1x94xo"
    }
  ]
], pwt = Ze("omega", qIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const YIe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }],
  ["path", { d: "m16 15-3-3 3-3", key: "14y99z" }]
], mwt = Ze("panel-left-close", YIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const XIe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M9 3v18", key: "fh3hqa" }]
], gwt = Ze("panel-left", XIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const ZIe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }],
  ["path", { d: "m8 9 3 3-3 3", key: "12hl5m" }]
], vwt = Ze("panel-right-close", ZIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const QIe = [
  ["rect", { width: "18", height: "18", x: "3", y: "3", rx: "2", key: "afitv7" }],
  ["path", { d: "M15 3v18", key: "14nvp0" }]
], ywt = Ze("panel-right", QIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const JIe = [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ]
], bwt = Ze("pen", JIe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const eRe = [
  [
    "path",
    {
      d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z",
      key: "1a8usu"
    }
  ],
  ["path", { d: "m15 5 4 4", key: "1mk7zo" }]
], wwt = Ze("pencil", eRe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const tRe = [
  ["circle", { cx: "6", cy: "19", r: "3", key: "1kj8tv" }],
  ["path", { d: "M9 19h8.5c.4 0 .9-.1 1.3-.2", key: "1effex" }],
  ["path", { d: "M5.2 5.2A3.5 3.53 0 0 0 6.5 12H12", key: "k9y2ds" }],
  ["path", { d: "m2 2 20 20", key: "1ooewy" }],
  ["path", { d: "M21 15.3a3.5 3.5 0 0 0-3.3-3.3", key: "11nlu2" }],
  ["path", { d: "M15 5h-4.3", key: "6537je" }],
  ["circle", { cx: "18", cy: "5", r: "3", key: "gq8acd" }]
], xwt = Ze("route-off", tRe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const nRe = [
  ["path", { d: "m16 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "7g6ntu" }],
  ["path", { d: "m2 16 3-8 3 8c-.87.65-1.92 1-3 1s-2.13-.35-3-1Z", key: "ijws7r" }],
  ["path", { d: "M7 21h10", key: "1b0cd5" }],
  ["path", { d: "M12 3v18", key: "108xh3" }],
  ["path", { d: "M3 7h2c2 0 5-1 7-2 2 1 5 2 7 2h2", key: "3gwbw2" }]
], Ewt = Ze("scale", nRe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const rRe = [
  ["path", { d: "m21 21-4.34-4.34", key: "14j7rj" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], iRe = Ze("search", rRe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const sRe = [
  [
    "path",
    {
      d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
      key: "oel41y"
    }
  ],
  ["path", { d: "M6.376 18.91a6 6 0 0 1 11.249.003", key: "hnjrf2" }],
  ["circle", { cx: "12", cy: "11", r: "4", key: "1gt34v" }]
], Swt = Ze("shield-user", sRe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const oRe = [
  ["path", { d: "M7 18v-6a5 5 0 1 1 10 0v6", key: "pcx96s" }],
  [
    "path",
    { d: "M5 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2z", key: "1b4s83" }
  ],
  ["path", { d: "M21 12h1", key: "jtio3y" }],
  ["path", { d: "M18.5 4.5 18 5", key: "g5sp9y" }],
  ["path", { d: "M2 12h1", key: "1uaihz" }],
  ["path", { d: "M12 2v1", key: "11qlp1" }],
  ["path", { d: "m4.929 4.929.707.707", key: "1i51kw" }],
  ["path", { d: "M12 12v6", key: "3ahymv" }]
], Cwt = Ze("siren", oRe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const aRe = [
  ["path", { d: "M15.236 22a3 3 0 0 0-2.2-5", key: "21bitc" }],
  ["path", { d: "M16 20a3 3 0 0 1 3-3h1a2 2 0 0 0 2-2v-2a4 4 0 0 0-4-4V4", key: "oh0fg0" }],
  ["path", { d: "M18 13h.01", key: "9veqaj" }],
  [
    "path",
    {
      d: "M18 6a4 4 0 0 0-4 4 7 7 0 0 0-7 7c0-5 4-5 4-10.5a4.5 4.5 0 1 0-9 0 2.5 2.5 0 0 0 5 0C7 10 3 11 3 17c0 2.8 2.2 5 5 5h10",
      key: "980v8a"
    }
  ]
], Twt = Ze("squirrel", aRe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const lRe = [
  ["path", { d: "M12 19h8", key: "baeox8" }],
  ["path", { d: "m4 17 6-6-6-6", key: "1yngyt" }]
], Awt = Ze("terminal", lRe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const cRe = [
  ["line", { x1: "10", x2: "14", y1: "2", y2: "2", key: "14vaq8" }],
  ["line", { x1: "12", x2: "15", y1: "14", y2: "11", key: "17fdiu" }],
  ["circle", { cx: "12", cy: "14", r: "8", key: "1e1u0o" }]
], Mwt = Ze("timer", cRe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const uRe = [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
], kwt = Ze("triangle-alert", uRe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const dRe = [
  ["path", { d: "M9 14 4 9l5-5", key: "102s5s" }],
  ["path", { d: "M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5a5.5 5.5 0 0 1-5.5 5.5H11", key: "f3b9sd" }]
], fRe = Ze("undo-2", dRe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hRe = [
  ["path", { d: "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2", key: "1yyitq" }],
  ["path", { d: "M16 3.128a4 4 0 0 1 0 7.744", key: "16gr8j" }],
  ["path", { d: "M22 21v-2a4 4 0 0 0-3-3.87", key: "kshegd" }],
  ["circle", { cx: "9", cy: "7", r: "4", key: "nufk8" }]
], _wt = Ze("users", hRe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pRe = [
  [
    "path",
    {
      d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
      key: "ul74o6"
    }
  ],
  ["path", { d: "m14 7 3 3", key: "1r5n42" }],
  ["path", { d: "M5 6v4", key: "ilb8ba" }],
  ["path", { d: "M19 14v4", key: "blhpug" }],
  ["path", { d: "M10 2v2", key: "7u0qdc" }],
  ["path", { d: "M7 8H3", key: "zfb6yr" }],
  ["path", { d: "M21 16h-4", key: "1cnmox" }],
  ["path", { d: "M11 3H9", key: "1obp7u" }]
], mRe = Ze("wand-sparkles", pRe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gRe = [
  ["path", { d: "M12 20h.01", key: "zekei9" }],
  ["path", { d: "M2 8.82a15 15 0 0 1 20 0", key: "dnpr2z" }],
  ["path", { d: "M5 12.859a10 10 0 0 1 14 0", key: "1x1e6c" }],
  ["path", { d: "M8.5 16.429a5 5 0 0 1 7 0", key: "1bycff" }]
], Owt = Ze("wifi", gRe);
/**
 * @license lucide-react v0.548.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vRe = [
  ["path", { d: "M18 6 6 18", key: "1bl5f8" }],
  ["path", { d: "m6 6 12 12", key: "d8bk6v" }]
], YM = Ze("x", vRe), g1 = (n) => /* @__PURE__ */ T(
  Nt,
  {
    variant: "ghost",
    size: "none",
    className: "tw:ms-1",
    onClick: (e) => {
      dX(n.value), e.preventDefault();
    },
    children: /* @__PURE__ */ T(EIe, {})
  }
), dX = (n) => {
  navigator.clipboard.writeText(n), Ap.success("Copied to clipboard");
}, fX = { version: 4, country_calling_codes: { 1: ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], 7: ["RU", "KZ"], 20: ["EG"], 27: ["ZA"], 30: ["GR"], 31: ["NL"], 32: ["BE"], 33: ["FR"], 34: ["ES"], 36: ["HU"], 39: ["IT", "VA"], 40: ["RO"], 41: ["CH"], 43: ["AT"], 44: ["GB", "GG", "IM", "JE"], 45: ["DK"], 46: ["SE"], 47: ["NO", "SJ"], 48: ["PL"], 49: ["DE"], 51: ["PE"], 52: ["MX"], 53: ["CU"], 54: ["AR"], 55: ["BR"], 56: ["CL"], 57: ["CO"], 58: ["VE"], 60: ["MY"], 61: ["AU", "CC", "CX"], 62: ["ID"], 63: ["PH"], 64: ["NZ"], 65: ["SG"], 66: ["TH"], 81: ["JP"], 82: ["KR"], 84: ["VN"], 86: ["CN"], 90: ["TR"], 91: ["IN"], 92: ["PK"], 93: ["AF"], 94: ["LK"], 95: ["MM"], 98: ["IR"], 211: ["SS"], 212: ["MA", "EH"], 213: ["DZ"], 216: ["TN"], 218: ["LY"], 220: ["GM"], 221: ["SN"], 222: ["MR"], 223: ["ML"], 224: ["GN"], 225: ["CI"], 226: ["BF"], 227: ["NE"], 228: ["TG"], 229: ["BJ"], 230: ["MU"], 231: ["LR"], 232: ["SL"], 233: ["GH"], 234: ["NG"], 235: ["TD"], 236: ["CF"], 237: ["CM"], 238: ["CV"], 239: ["ST"], 240: ["GQ"], 241: ["GA"], 242: ["CG"], 243: ["CD"], 244: ["AO"], 245: ["GW"], 246: ["IO"], 247: ["AC"], 248: ["SC"], 249: ["SD"], 250: ["RW"], 251: ["ET"], 252: ["SO"], 253: ["DJ"], 254: ["KE"], 255: ["TZ"], 256: ["UG"], 257: ["BI"], 258: ["MZ"], 260: ["ZM"], 261: ["MG"], 262: ["RE", "YT"], 263: ["ZW"], 264: ["NA"], 265: ["MW"], 266: ["LS"], 267: ["BW"], 268: ["SZ"], 269: ["KM"], 290: ["SH", "TA"], 291: ["ER"], 297: ["AW"], 298: ["FO"], 299: ["GL"], 350: ["GI"], 351: ["PT"], 352: ["LU"], 353: ["IE"], 354: ["IS"], 355: ["AL"], 356: ["MT"], 357: ["CY"], 358: ["FI", "AX"], 359: ["BG"], 370: ["LT"], 371: ["LV"], 372: ["EE"], 373: ["MD"], 374: ["AM"], 375: ["BY"], 376: ["AD"], 377: ["MC"], 378: ["SM"], 380: ["UA"], 381: ["RS"], 382: ["ME"], 383: ["XK"], 385: ["HR"], 386: ["SI"], 387: ["BA"], 389: ["MK"], 420: ["CZ"], 421: ["SK"], 423: ["LI"], 500: ["FK"], 501: ["BZ"], 502: ["GT"], 503: ["SV"], 504: ["HN"], 505: ["NI"], 506: ["CR"], 507: ["PA"], 508: ["PM"], 509: ["HT"], 590: ["GP", "BL", "MF"], 591: ["BO"], 592: ["GY"], 593: ["EC"], 594: ["GF"], 595: ["PY"], 596: ["MQ"], 597: ["SR"], 598: ["UY"], 599: ["CW", "BQ"], 670: ["TL"], 672: ["NF"], 673: ["BN"], 674: ["NR"], 675: ["PG"], 676: ["TO"], 677: ["SB"], 678: ["VU"], 679: ["FJ"], 680: ["PW"], 681: ["WF"], 682: ["CK"], 683: ["NU"], 685: ["WS"], 686: ["KI"], 687: ["NC"], 688: ["TV"], 689: ["PF"], 690: ["TK"], 691: ["FM"], 692: ["MH"], 850: ["KP"], 852: ["HK"], 853: ["MO"], 855: ["KH"], 856: ["LA"], 880: ["BD"], 886: ["TW"], 960: ["MV"], 961: ["LB"], 962: ["JO"], 963: ["SY"], 964: ["IQ"], 965: ["KW"], 966: ["SA"], 967: ["YE"], 968: ["OM"], 970: ["PS"], 971: ["AE"], 972: ["IL"], 973: ["BH"], 974: ["QA"], 975: ["BT"], 976: ["MN"], 977: ["NP"], 992: ["TJ"], 993: ["TM"], 994: ["AZ"], 995: ["GE"], 996: ["KG"], 998: ["UZ"] }, countries: { AC: ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], AD: ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], AE: ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], AF: ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], AG: ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], AI: ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], AL: ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], AM: ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], AO: ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], AR: ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], AS: ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], AT: ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:48|5[0-3579]|[6-9])|7(?:20|32|8)|[89]", "(?:31|4)6|51|6(?:485|5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], AU: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:2(?:(?:[0-26-9]\\d|3[0-8]|5[0135-9])\\d|4(?:[02-9]\\d|10))|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90))|7(?:[013-57-9]\\d|2[0-8])\\d)\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|[34]\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-36-9])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], AW: ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], AX: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], AZ: ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], BA: ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], BB: ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], BD: ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], BE: ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], BF: ["226", "00", "(?:[025-7]\\d|44)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[024-7]"]]]], BG: ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], BH: ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], BI: ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], BJ: ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], BL: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], BM: ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], BN: ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], BO: ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], BQ: ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], BR: ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "[1-467]\\d{9,10}|55[0-46-9]\\d{8}|[34]\\d{7}|55\\d{7,8}|(?:5[0-46-9]|[89]\\d)\\d{7,9}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37|86)", "300|4(?:0(?:0|20)|370|864)"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], BS: ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], BT: ["975", "00", "[178]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-6]|7[246]|8[2-4]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|[78]"]]]], BW: ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], BY: ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], BZ: ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], CA: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|5[07]|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], CC: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-36-9])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CD: ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], CF: ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], CG: ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], CH: ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], CI: ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], CK: ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], CL: ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["60|809"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9(?:10|[2-9])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-8]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], CM: ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], CN: ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], CO: ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|9[14]"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], CR: ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], CU: ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], CV: ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], CW: ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], CX: ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-36-9])\\d{5}|4(?:[0-36]\\d|4[047-9]|[58][0-24-9]|7[02-8]|9[0-47-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], CY: ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], CZ: ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], DE: ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|3[13])"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], DJ: ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], DK: ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], DM: ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], DO: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], DZ: ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], EC: ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], EE: ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], EG: ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], EH: ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], ER: ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], ES: ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], ET: ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], FI: ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], FJ: ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], FK: ["500", "00", "[2-7]\\d{4}", [5]], FM: ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], FO: ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], FR: ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], GA: ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], GB: ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, "0|180020", 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-5])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|5[01]))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], GD: ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], GE: ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], GF: ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], GG: ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0|180020", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], GH: ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], GI: ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], GL: ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], GM: ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], GN: ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], GP: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], GQ: ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], GR: ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], GT: ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], GU: ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], GW: ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], GY: ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], HK: ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], HN: ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], HR: ["385", "00", "[2-69]\\d{8}|80\\d{5,7}|[1-79]\\d{7}|6\\d{6}", [7, 8, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], HT: ["509", "00", "[2-589]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], HU: ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], ID: ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], IE: ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], IL: ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], IM: ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0|180020", "1624$1", 0, "74576|(?:16|7[56])24"], IN: ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], IO: ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], IQ: ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], IR: ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], IS: ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], IT: ["39", "00", "0\\d{5,11}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[03]"]]], 0, 0, 0, 0, 0, 0, [["0(?:669[0-79]\\d{1,6}|831\\d{2,8})|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[2356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], JE: ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0|180020", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], JM: ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], JO: ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|427|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[47]"], "0$1"]], "0"], JP: ["81", "010", "00[1-9]\\d{6,14}|[25-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["3|4(?:2[09]|7[01])|6[1-9]", "3|4(?:2(?:0|9[02-69])|7(?:0[019]|1))|6[1-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[25-9]"], "0$1"]], "0", 0, "(000[2569]\\d{4,6})$|(?:(?:003768)0?)|0", "$1"], KE: ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], KG: ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], KH: ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], KI: ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], KM: ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], KN: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], KP: ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], KR: ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], KW: ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], KY: ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], KZ: ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33622|7", 0, "8~10"], LA: ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["3"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], LB: ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-6]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], LC: ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], LI: ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], LK: ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], LR: ["231", "00", "(?:[2457]\\d|33|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], LS: ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], LT: ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], LU: ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], LV: ["371", "00", "(?:[268]\\d|78|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2679]|8[01]"]]]], LY: ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], MA: ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-8]|5[0-5]|8[0-7]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], MC: ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], MD: ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], ME: ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], MF: ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-6])\\d{4}"]]], MG: ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], MH: ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], MK: ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], ML: ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], MM: ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], MN: ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], MO: ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], MP: ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], MQ: ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], MR: ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], MS: ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], MT: ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], MU: ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], MV: ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MW: ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], MX: ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], MY: ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], MZ: ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], NA: ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], NC: ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], NE: ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], NF: ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], NG: ["234", "009", "(?:20|9\\d)\\d{8}|[78]\\d{9,13}", [10, 11, 12, 13, 14], [["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], NI: ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], NL: ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], NO: ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], NP: ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], NR: ["674", "00", "(?:222|444|(?:55|8\\d)\\d|666|777|999)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[24-9]"]]]], NU: ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], NZ: ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], OM: ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], PA: ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], PE: ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], PF: ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], PG: ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], PH: ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], PK: ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], PL: ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], PM: ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], PR: ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], PS: ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], PT: ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], PW: ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], PY: ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], QA: ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[136]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], RE: ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[0-3]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-6]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], RO: ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], RS: ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], RU: ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, 0, [["336(?:[013-9]\\d|2[013-9])\\d{5}|(?:3(?:0[12]|4[1-35-79]|5[1-3]|65|8[1-58]|9[0145])|4(?:01|1[1356]|2[13467]|7[1-5]|8[1-7]|9[1-689])|8(?:1[1-8]|2[01]|3[13-6]|4[0-8]|5[15-7]|6[0-35-79]|7[1-37-9]))\\d{7}", [10]], ["9\\d{9}", [10]], ["8(?:0[04]|108\\d{3})\\d{7}"], ["80[39]\\d{7}", [10]], ["808\\d{7}", [10]]], "8~10"], RW: ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], SA: ["966", "00", "(?:[15]\\d|800|92)\\d{7}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], SB: ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], SC: ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], SD: ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], SE: ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], SG: ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], SH: ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], SI: ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], SJ: ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], SK: ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], SL: ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], SM: ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], SN: ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], SO: ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|7[67]|9[2-9]"]]], "0"], SR: ["597", "00", "(?:[2-5]|[6-8]\\d|90)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-9]"]]]], SS: ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], ST: ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], SV: ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], SX: ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], SY: ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], SZ: ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], TA: ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], TC: ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], TD: ["235", "00|16", "(?:22|30|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[236-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], TG: ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], TH: ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], TJ: ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], TK: ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], TL: ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], TM: ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], TN: ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], TO: ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], TR: ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], TT: ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], TV: ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], TW: ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], TZ: ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], UA: ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], UG: ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], US: ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["3052(?:0[0-8]|[1-9]\\d)\\d{4}|(?:2742|305[3-9])\\d{6}|(?:472|983)[2-47-9]\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[013-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-57-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-269])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[0-247]|4[0378]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[0168]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-3589]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], UY: ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|2\\d{3,4}|(?:[49]\\d|80)\\d{5}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{4,5})", "$1", ["21"]], ["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], UZ: ["998", "00", "(?:20|33|[5-9]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], VA: ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], VC: ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], VE: ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], VG: ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], VI: ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], VN: ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], VU: ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], WF: ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], WS: ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], XK: ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], YE: ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], YT: ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], ZA: ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], ZM: ["260", "00", "800\\d{6}|(?:21|[579]\\d|63)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[579]"], "0$1"]], "0"], ZW: ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, nonGeographic: { 800: ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], 808: ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], 870: ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], 878: ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], 881: ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], 882: ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], 883: ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], 888: ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], 979: ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
var ZS = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
var VF;
function yRe() {
  return VF || (VF = 1, (function(n) {
    (function() {
      var e = {}.hasOwnProperty;
      function t() {
        for (var s = "", o = 0; o < arguments.length; o++) {
          var a = arguments[o];
          a && (s = i(s, r(a)));
        }
        return s;
      }
      function r(s) {
        if (typeof s == "string" || typeof s == "number")
          return s;
        if (typeof s != "object")
          return "";
        if (Array.isArray(s))
          return t.apply(null, s);
        if (s.toString !== Object.prototype.toString && !s.toString.toString().includes("[native code]"))
          return s.toString();
        var o = "";
        for (var a in s)
          e.call(s, a) && s[a] && (o = i(o, a));
        return o;
      }
      function i(s, o) {
        return o ? s ? s + " " + o : s + o : s;
      }
      n.exports ? (t.default = t, n.exports = t) : window.classNames = t;
    })();
  })(ZS)), ZS.exports;
}
var bRe = yRe();
const vy = /* @__PURE__ */ nn(bRe);
function wRe(n, e, t) {
  switch (t) {
    case "Backspace":
      e > 0 && (n = n.slice(0, e - 1) + n.slice(e), e--);
      break;
    case "Delete":
      n = n.slice(0, e) + n.slice(e + 1);
      break;
  }
  return {
    value: n,
    caret: e
  };
}
function xRe(n, e, t) {
  for (var r = {}, i = "", s = 0, o = 0; o < n.length; ) {
    var a = t(n[o], i, r);
    a !== void 0 && (i += a, e !== void 0 && (e === o ? s = i.length - 1 : e > o && (s = i.length))), o++;
  }
  e === void 0 && (s = i.length);
  var l = {
    value: i,
    caret: s
  };
  return l;
}
function ERe(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t) return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = SRe(n)) || e) {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function SRe(n, e) {
  if (n) {
    if (typeof n == "string") return jF(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return jF(n, e);
  }
}
function jF(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
function RT(n, e) {
  for (var t = 0, r = ERe(e.split("")), i; !(i = r()).done; ) {
    var s = i.value;
    s === n && t++;
  }
  return t;
}
function CRe(n, e) {
  for (var t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "x", r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : " ", i = n.length, s = RT("(", n), o = RT(")", n), a = s - o; a > 0 && i < e.length; )
    n += e[i].replace(t, r), e[i] === ")" && a--, i++;
  return n;
}
function TRe(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t) return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = ARe(n)) || e) {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ARe(n, e) {
  if (n) {
    if (typeof n == "string") return WF(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return WF(n, e);
  }
}
function WF(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++)
    r[t] = n[t];
  return r;
}
function MRe(n) {
  var e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x", t = arguments.length > 2 ? arguments[2] : void 0;
  if (!n)
    return function(i) {
      return {
        text: i
      };
    };
  var r = RT(e, n);
  return function(i) {
    if (!i)
      return {
        text: "",
        template: n
      };
    for (var s = 0, o = "", a = TRe(n.split("")), l; !(l = a()).done; ) {
      var c = l.value;
      if (c !== e) {
        o += c;
        continue;
      }
      if (o += i[s], s++, s === i.length && i.length < r)
        break;
    }
    return t && (o = CRe(o, n)), {
      text: o,
      template: n
    };
  };
}
function kRe(n, e, t) {
  typeof t == "string" && (t = MRe(t));
  var r = t(n) || {}, i = r.text, s = r.template;
  if (i === void 0 && (i = n), s)
    if (e === void 0)
      e = i.length;
    else {
      for (var o = 0, a = !1, l = -1; o < i.length && o < s.length; ) {
        if (i[o] !== s[o]) {
          if (e === 0) {
            a = !0, e = o;
            break;
          }
          l = o, e--;
        }
        o++;
      }
      a || (e = l + 1);
    }
  return {
    text: i,
    caret: e
  };
}
function _Re(n) {
  return n.hasAttribute("readonly");
}
function ORe(n) {
  if (n.selectionStart !== n.selectionEnd)
    return {
      start: n.selectionStart,
      end: n.selectionEnd
    };
}
var GF = {
  Backspace: 8,
  Delete: 46
};
function IRe(n) {
  switch (n.keyCode) {
    case GF.Backspace:
      return "Backspace";
    case GF.Delete:
      return "Delete";
  }
}
function RRe(n) {
  return n.selectionStart;
}
function hX(n, e) {
  e !== void 0 && (PRe() ? setTimeout(function() {
    return n.setSelectionRange(e, e);
  }, 0) : n.setSelectionRange(e, e));
}
function PRe() {
  if (typeof navigator < "u")
    return DRe.test(navigator.userAgent);
}
var DRe = /Android/i;
function NRe(n, e, t, r, i) {
  PT(e, t, r, void 0, i);
}
function LRe(n, e, t, r, i) {
  if (!_Re(e)) {
    var s = IRe(n);
    switch (s) {
      case "Delete":
      case "Backspace":
        n.preventDefault();
        var o = ORe(e);
        return o ? ($Re(e, o), PT(e, t, r, void 0, i)) : PT(e, t, r, s, i);
    }
  }
}
function $Re(n, e) {
  var t = n.value;
  t = t.slice(0, e.start) + t.slice(e.end), n.value = t, hX(n, e.start);
}
function PT(n, e, t, r, i) {
  var s = xRe(n.value, RRe(n), e), o = s.value, a = s.caret;
  if (r) {
    var l = wRe(o, a, r);
    o = l.value, a = l.caret;
  }
  var c = kRe(o, a, t), u = c.text;
  a = c.caret, n.value = u, hX(n, a), i && i(o);
}
var FRe = ["ref", "parse", "format", "value", "defaultValue", "controlled", "onChange", "onKeyDown"];
function KF(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function bd(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? KF(Object(t), !0).forEach(function(r) {
      BRe(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : KF(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function BRe(n, e, t) {
  return e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function zRe(n, e) {
  if (n == null) return {};
  var t = HRe(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function HRe(n, e) {
  if (n == null) return {};
  var t = {}, r = Object.keys(n), i, s;
  for (s = 0; s < r.length; s++)
    i = r[s], !(e.indexOf(i) >= 0) && (t[i] = n[i]);
  return t;
}
function URe(n) {
  var e = n.ref, t = n.parse, r = n.format, i = n.value, s = n.defaultValue, o = n.controlled, a = o === void 0 ? !0 : o, l = n.onChange, c = n.onKeyDown, u = zRe(n, FRe), d = Gt(), f = Ft(function(v) {
    d.current = v, e && (typeof e == "function" ? e(v) : e.current = v);
  }, [e]), h = Ft(function(v) {
    return NRe(v, d.current, t, r, l);
  }, [d, t, r, l]), m = Ft(function(v) {
    if (c && c(v), !v.defaultPrevented)
      return LRe(v, d.current, t, r, l);
  }, [d, t, r, l, c]), g = bd(bd({}, u), {}, {
    ref: f,
    onChange: h,
    onKeyDown: m
  });
  return a ? bd(bd({}, g), {}, {
    value: r(qF(i) ? "" : i).text
  }) : bd(bd({}, g), {}, {
    defaultValue: r(qF(s) ? "" : s).text
  });
}
function qF(n) {
  return n == null;
}
var VRe = ["inputComponent", "parse", "format", "value", "defaultValue", "onChange", "controlled", "onKeyDown", "type"];
function YF(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function jRe(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? YF(Object(t), !0).forEach(function(r) {
      WRe(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : YF(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function WRe(n, e, t) {
  return e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function GRe(n, e) {
  if (n == null) return {};
  var t = KRe(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function KRe(n, e) {
  if (n == null) return {};
  var t = {}, r = Object.keys(n), i, s;
  for (s = 0; s < r.length; s++)
    i = r[s], !(e.indexOf(i) >= 0) && (t[i] = n[i]);
  return t;
}
function yy(n, e) {
  var t = n.inputComponent, r = t === void 0 ? "input" : t, i = n.parse, s = n.format, o = n.value, a = n.defaultValue, l = n.onChange, c = n.controlled, u = n.onKeyDown, d = n.type, f = d === void 0 ? "text" : d, h = GRe(n, VRe), m = URe(jRe({
    ref: e,
    parse: i,
    format: s,
    value: o,
    defaultValue: a,
    onChange: l,
    controlled: c,
    onKeyDown: u,
    type: f
  }, h));
  return /* @__PURE__ */ p.createElement(r, m);
}
yy = /* @__PURE__ */ p.forwardRef(yy);
yy.propTypes = {
  // Parses a single characher of `<input/>` text.
  parse: pe.func.isRequired,
  // Formats `value` into `<input/>` text.
  format: pe.func.isRequired,
  // Renders `<input/>` by default.
  inputComponent: pe.elementType,
  // `<input/>` `type` attribute.
  type: pe.string,
  // Is parsed from <input/> text.
  value: pe.string,
  // An initial value for an "uncontrolled" <input/>.
  defaultValue: pe.string,
  // This handler is called each time `<input/>` text is changed.
  onChange: pe.func,
  // Whether this input should be "controlled" or "uncontrolled".
  // The default value is `true` meaning "uncontrolled".
  controlled: pe.bool,
  // Passthrough
  onKeyDown: pe.func,
  onCut: pe.func,
  onPaste: pe.func
};
function XF(n, e) {
  n = n.split("-"), e = e.split("-");
  for (var t = n[0].split("."), r = e[0].split("."), i = 0; i < 3; i++) {
    var s = Number(t[i]), o = Number(r[i]);
    if (s > o) return 1;
    if (o > s) return -1;
    if (!isNaN(s) && isNaN(o)) return 1;
    if (isNaN(s) && !isNaN(o)) return -1;
  }
  return n[1] && e[1] ? n[1] > e[1] ? 1 : n[1] < e[1] ? -1 : 0 : !n[1] && e[1] ? 1 : n[1] && !e[1] ? -1 : 0;
}
var qRe = {}.constructor;
function xu(n) {
  return n != null && n.constructor === qRe;
}
function Gf(n) {
  "@babel/helpers - typeof";
  return Gf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Gf(n);
}
function Qw(n, e) {
  if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function YRe(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, XRe(r.key), r);
  }
}
function Jw(n, e, t) {
  return e && YRe(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function XRe(n) {
  var e = ZRe(n, "string");
  return Gf(e) == "symbol" ? e : e + "";
}
function ZRe(n, e) {
  if (Gf(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Gf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
var QRe = "1.2.0", JRe = "1.7.35", ZF = " ext. ", ePe = /^\d+$/, ur = /* @__PURE__ */ (function() {
  function n(e) {
    Qw(this, n), pX(e), this.metadata = e, gX.call(this, e);
  }
  return Jw(n, [{
    key: "getCountries",
    value: function() {
      return Object.keys(this.metadata.countries).filter(function(t) {
        return t !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function(t) {
      return this.metadata.countries[t];
    }
  }, {
    key: "nonGeographic",
    value: function() {
      if (!(this.v1 || this.v2 || this.v3))
        return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function(t) {
      return this.getCountryMetadata(t) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function(t) {
      if (this.getCountryCodesForCallingCode(t))
        return !0;
      if (this.nonGeographic()) {
        if (this.nonGeographic()[t])
          return !0;
      } else {
        var r = this.countryCallingCodes()[t];
        if (r && r.length === 1 && r[0] === "001")
          return !0;
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function(t) {
      return this.nonGeographic() ? !!this.nonGeographic()[t] : !this.getCountryCodesForCallingCode(t);
    }
    // Deprecated.
  }, {
    key: "country",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "selectNumberingPlan",
    value: function(t, r) {
      if (t && ePe.test(t) && (r = t, t = null), t && t !== "001") {
        if (!this.hasCountry(t))
          throw new Error("Unknown country: ".concat(t));
        this.numberingPlan = new QF(this.getCountryMetadata(t), this);
      } else if (r) {
        if (!this.hasCallingCode(r))
          throw new Error("Unknown calling code: ".concat(r));
        this.numberingPlan = new QF(this.getNumberingPlanMetadata(r), this);
      } else
        this.numberingPlan = void 0;
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function(t) {
      var r = this.countryCallingCodes()[t];
      if (r)
        return r.length === 1 && r[0].length === 3 ? void 0 : r;
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function(t) {
      var r = this.getCountryCodesForCallingCode(t);
      if (r)
        return r[0];
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function(t) {
      var r = this.getCountryCodeForCallingCode(t);
      if (r)
        return this.getCountryMetadata(r);
      if (this.nonGeographic()) {
        var i = this.nonGeographic()[t];
        if (i)
          return i;
      } else {
        var s = this.countryCallingCodes()[t];
        if (s && s.length === 1 && s[0] === "001")
          return this.metadata.countries["001"];
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function(t) {
      return this.numberingPlan.type(t);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function() {
      return this.v1 ? this.metadata.country_phone_code_to_countries : this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function(t) {
      return this.selectNumberingPlan(t);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function() {
      return this.numberingPlan !== void 0;
    }
  }]);
})(), QF = /* @__PURE__ */ (function() {
  function n(e, t) {
    Qw(this, n), this.globalMetadataObject = t, this.metadata = e, gX.call(this, t.metadata);
  }
  return Jw(n, [{
    key: "callingCode",
    value: function() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function() {
      if (!(this.v1 || this.v2))
        return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function() {
      return this.v1 || this.v2 ? this.metadata[1] : this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.v1)
        return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function(t) {
      return t[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function() {
      var t = this, r = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return r.map(function(i) {
        return new tPe(i, t);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function(t) {
      return t[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function() {
      return this.types() && this.types().length === 0 ? !1 : !!this.types();
    }
  }, {
    key: "type",
    value: function(t) {
      if (this.hasTypes() && JF(this.types(), t))
        return new rPe(JF(this.types(), t), this);
    }
  }, {
    key: "ext",
    value: function() {
      return this.v1 || this.v2 ? ZF : this.metadata[13] || ZF;
    }
  }]);
})(), tPe = /* @__PURE__ */ (function() {
  function n(e, t) {
    Qw(this, n), this._format = e, this.metadata = t;
  }
  return Jw(n, [{
    key: "pattern",
    value: function() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function() {
      return !!(this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !nPe.test(this.nationalPrefixFormattingRule()));
    }
  }, {
    key: "internationalFormat",
    value: function() {
      return this._format[5] || this.format();
    }
  }]);
})(), nPe = /^\(?\$1\)?$/, rPe = /* @__PURE__ */ (function() {
  function n(e, t) {
    Qw(this, n), this.type = e, this.metadata = t;
  }
  return Jw(n, [{
    key: "pattern",
    value: function() {
      return this.metadata.v1 ? this.type : this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function() {
      if (!this.metadata.v1)
        return this.type[1] || this.metadata.possibleLengths();
    }
  }]);
})();
function JF(n, e) {
  switch (e) {
    case "FIXED_LINE":
      return n[0];
    case "MOBILE":
      return n[1];
    case "TOLL_FREE":
      return n[2];
    case "PREMIUM_RATE":
      return n[3];
    case "PERSONAL_NUMBER":
      return n[4];
    case "VOICEMAIL":
      return n[5];
    case "UAN":
      return n[6];
    case "PAGER":
      return n[7];
    case "VOIP":
      return n[8];
    case "SHARED_COST":
      return n[9];
  }
}
function pX(n) {
  if (!n)
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  if (!xu(n) || !xu(n.countries))
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(xu(n) ? "an object of shape: { " + Object.keys(n).join(", ") + " }" : "a " + iPe(n) + ": " + n, "."));
}
var iPe = function(e) {
  return Gf(e);
};
function xl(n, e) {
  if (e = new ur(e), e.hasCountry(n))
    return e.selectNumberingPlan(n).countryCallingCode();
  throw new Error("Unknown country: ".concat(n));
}
function mX(n, e) {
  return e.countries.hasOwnProperty(n);
}
function gX(n) {
  var e = n.version;
  typeof e == "number" ? (this.v1 = e === 1, this.v2 = e === 2, this.v3 = e === 3, this.v4 = e === 4) : e ? XF(e, QRe) === -1 ? this.v2 = !0 : XF(e, JRe) === -1 ? this.v3 = !0 : this.v4 = !0 : this.v1 = !0;
}
function e3(n, e, t) {
  return sPe(n, e, void 0, t);
}
function sPe(n, e, t, r) {
  e && (r = new ur(r.metadata), r.selectNumberingPlan(e));
  var i = r.type(t), s = i && i.possibleLengths() || r.possibleLengths();
  if (!s)
    return "IS_POSSIBLE";
  var o = n.length, a = s[0];
  return a === o ? "IS_POSSIBLE" : a > o ? "TOO_SHORT" : s[s.length - 1] < o ? "TOO_LONG" : s.indexOf(o, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function oPe(n, e, t) {
  if (e === void 0 && (e = {}), t = new ur(t), e.v2) {
    if (!n.countryCallingCode)
      throw new Error("Invalid phone number object passed");
    t.selectNumberingPlan(n.countryCallingCode);
  } else {
    if (!n.phone)
      return !1;
    if (n.country) {
      if (!t.hasCountry(n.country))
        throw new Error("Unknown country: ".concat(n.country));
      t.selectNumberingPlan(n.country);
    } else {
      if (!n.countryCallingCode)
        throw new Error("Invalid phone number object passed");
      t.selectNumberingPlan(n.countryCallingCode);
    }
  }
  if (t.possibleLengths())
    return vX(n.phone || n.nationalNumber, n.country, t);
  if (n.countryCallingCode && t.isNonGeographicCallingCode(n.countryCallingCode))
    return !0;
  throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
}
function vX(n, e, t) {
  switch (e3(n, e, t)) {
    case "IS_POSSIBLE":
      return !0;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return !1;
  }
}
function hl(n, e) {
  return n = n || "", new RegExp("^(?:" + e + ")$").test(n);
}
function aPe(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t) return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = lPe(n)) || e) {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function lPe(n, e) {
  if (n) {
    if (typeof n == "string") return eB(n, e);
    var t = {}.toString.call(n).slice(8, -1);
    return t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set" ? Array.from(n) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? eB(n, e) : void 0;
  }
}
function eB(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = Array(e); t < e; t++) r[t] = n[t];
  return r;
}
var cPe = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function XM(n, e, t) {
  if (e = e || {}, !(!n.country && !n.countryCallingCode)) {
    t = new ur(t), t.selectNumberingPlan(n.country, n.countryCallingCode);
    var r = e.v2 ? n.nationalNumber : n.phone;
    if (hl(r, t.nationalNumberPattern())) {
      if (QS(r, "FIXED_LINE", t))
        return t.type("MOBILE") && t.type("MOBILE").pattern() === "" || !t.type("MOBILE") || QS(r, "MOBILE", t) ? "FIXED_LINE_OR_MOBILE" : "FIXED_LINE";
      for (var i = aPe(cPe), s; !(s = i()).done; ) {
        var o = s.value;
        if (QS(r, o, t))
          return o;
      }
    }
  }
}
function QS(n, e, t) {
  return e = t.type(e), !e || !e.pattern() || e.possibleLengths() && e.possibleLengths().indexOf(n.length) < 0 ? !1 : hl(n, e.pattern());
}
function uPe(n, e, t) {
  if (e = e || {}, t = new ur(t), t.selectNumberingPlan(n.country, n.countryCallingCode), t.hasTypes())
    return XM(n, e, t.metadata) !== void 0;
  var r = e.v2 ? n.nationalNumber : n.phone;
  return hl(r, t.nationalNumberPattern());
}
function dPe(n, e, t) {
  var r = new ur(t), i = r.getCountryCodesForCallingCode(n);
  return i ? i.filter(function(s) {
    return fPe(e, s, t);
  }) : [];
}
function fPe(n, e, t) {
  var r = new ur(t);
  return r.selectNumberingPlan(e), r.numberingPlan.possibleLengths().indexOf(n.length) >= 0;
}
var ZM = 2, hPe = 17, pPe = 3, wi = "0-9０-９٠-٩۰-۹", mPe = "-‐-―−ー－", gPe = "／/", vPe = "．.", yPe = "  ­​⁠　", bPe = "()（）［］\\[\\]", wPe = "~⁓∼～", vo = "".concat(mPe).concat(gPe).concat(vPe).concat(yPe).concat(bPe).concat(wPe), t3 = "+＋", xPe = new RegExp("([" + wi + "])");
function yX(n, e, t, r) {
  if (e) {
    var i = new ur(r);
    i.selectNumberingPlan(e, t);
    var s = new RegExp(i.IDDPrefix());
    if (n.search(s) === 0) {
      n = n.slice(n.match(s)[0].length);
      var o = n.match(xPe);
      if (!(o && o[1] != null && o[1].length > 0 && o[1] === "0"))
        return n;
    }
  }
}
function DT(n, e) {
  if (n && e.numberingPlan.nationalPrefixForParsing()) {
    var t = new RegExp("^(?:" + e.numberingPlan.nationalPrefixForParsing() + ")"), r = t.exec(n);
    if (r) {
      var i, s, o = r.length - 1, a = o > 0 && r[o];
      if (e.nationalPrefixTransformRule() && a)
        i = n.replace(t, e.nationalPrefixTransformRule()), o > 1 && (s = r[1]);
      else {
        var l = r[0];
        i = n.slice(l.length), a && (s = r[1]);
      }
      var c;
      if (a) {
        var u = n.indexOf(r[1]), d = n.slice(0, u);
        d === e.numberingPlan.nationalPrefix() && (c = e.numberingPlan.nationalPrefix());
      } else
        c = r[0];
      return {
        nationalNumber: i,
        nationalPrefix: c,
        carrierCode: s
      };
    }
  }
  return {
    nationalNumber: n
  };
}
function EPe(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t) return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = SPe(n)) || e) {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function SPe(n, e) {
  if (n) {
    if (typeof n == "string") return tB(n, e);
    var t = {}.toString.call(n).slice(8, -1);
    return t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set" ? Array.from(n) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? tB(n, e) : void 0;
  }
}
function tB(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function bX(n, e) {
  var t = e.countries, r = e.metadata;
  r = new ur(r);
  for (var i = EPe(t), s; !(s = i()).done; ) {
    var o = s.value;
    if (r.selectNumberingPlan(o), r.leadingDigits()) {
      if (n && n.search(r.leadingDigits()) === 0)
        return o;
    } else if (XM({
      phone: n,
      country: o
    }, void 0, r.metadata))
      return o;
  }
}
function QM(n, e) {
  var t = e.nationalNumber, r = e.metadata, i = r.getCountryCodesForCallingCode(n);
  if (i)
    return i.length === 1 ? i[0] : bX(t, {
      countries: i,
      metadata: r.metadata
    });
}
function NT(n, e, t) {
  var r = DT(n, t), i = r.carrierCode, s = r.nationalNumber;
  if (s !== n) {
    if (!CPe(n, s, t))
      return {
        nationalNumber: n
      };
    if (t.numberingPlan.possibleLengths() && (e || (e = QM(t.numberingPlan.callingCode(), {
      nationalNumber: s,
      metadata: t
    })), !TPe(s, e, t)))
      return {
        nationalNumber: n
      };
  }
  return {
    nationalNumber: s,
    carrierCode: i
  };
}
function CPe(n, e, t) {
  return !(hl(n, t.nationalNumberPattern()) && !hl(e, t.nationalNumberPattern()));
}
function TPe(n, e, t) {
  switch (e3(n, e, t)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return !1;
    default:
      return !0;
  }
}
function wX(n, e, t, r, i) {
  var s = e || t ? xl(e || t, i) : r;
  if (n.indexOf(s) === 0) {
    i = new ur(i), i.selectNumberingPlan(e || t, s);
    var o = n.slice(s.length), a = NT(o, e, i), l = a.nationalNumber, c = NT(n, e, i), u = c.nationalNumber;
    if (!hl(u, i.nationalNumberPattern()) && hl(l, i.nationalNumberPattern()) || e3(u, e, i) === "TOO_LONG")
      return {
        countryCallingCode: s,
        number: o
      };
  }
  return {
    number: n
  };
}
function JM(n, e, t, r, i) {
  if (!n)
    return {};
  var s;
  if (n[0] !== "+") {
    var o = yX(n, e || t, r, i);
    if (o && o !== n)
      s = !0, n = "+" + o;
    else {
      if (e || t || r) {
        var a = wX(n, e, t, r, i), l = a.countryCallingCode, c = a.number;
        if (l)
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode: l,
            number: c
          };
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: n
      };
    }
  }
  if (n[1] === "0")
    return {};
  i = new ur(i);
  for (var u = 2; u - 1 <= pPe && u <= n.length; ) {
    var d = n.slice(1, u);
    if (i.hasCallingCode(d))
      return i.selectNumberingPlan(d), {
        countryCallingCodeSource: s ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: d,
        number: n.slice(u)
      };
    u++;
  }
  return {};
}
function xX(n) {
  return n.replace(new RegExp("[".concat(vo, "]+"), "g"), " ").trim();
}
var EX = /(\$\d)/;
function SX(n, e, t) {
  var r = t.useInternationalFormat, i = t.withNationalPrefix;
  t.carrierCode, t.metadata;
  var s = n.replace(new RegExp(e.pattern()), r ? e.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    i && e.nationalPrefixFormattingRule() ? e.format().replace(EX, e.nationalPrefixFormattingRule()) : e.format()
  ));
  return r ? xX(s) : s;
}
var APe = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function MPe(n, e, t) {
  var r = new ur(t);
  if (r.selectNumberingPlan(n, e), r.defaultIDDPrefix())
    return r.defaultIDDPrefix();
  if (APe.test(r.IDDPrefix()))
    return r.IDDPrefix();
}
var kPe = ";ext=", wd = function(e) {
  return "([".concat(wi, "]{1,").concat(e, "})");
};
function CX(n) {
  var e = "20", t = "15", r = "9", i = "6", s = "[  \\t,]*", o = "[:\\.．]?[  \\t,-]*", a = "#?", l = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)", c = "(?:[xｘ#＃~～]|int|ｉｎｔ)", u = "[- ]+", d = "[  \\t]*", f = "(?:,{2}|;)", h = kPe + wd(e), m = s + l + o + wd(e) + a, g = s + c + o + wd(r) + a, v = u + wd(i) + "#", y = d + f + o + wd(t) + a, b = d + "(?:,)+" + o + wd(r) + a;
  return h + "|" + m + "|" + g + "|" + v + "|" + y + "|" + b;
}
var _Pe = "[" + wi + "]{" + ZM + "}", OPe = "[" + t3 + "]{0,1}(?:[" + vo + "]*[" + wi + "]){3,}[" + vo + wi + "]*", IPe = new RegExp("^[" + t3 + "]{0,1}(?:[" + vo + "]*[" + wi + "]){1,2}$", "i"), RPe = OPe + // Phone number extensions
"(?:" + CX() + ")?", PPe = new RegExp(
  // Either a short two-digit-only phone number
  "^" + _Pe + "$|^" + RPe + "$",
  "i"
);
function DPe(n) {
  return n.length >= ZM && PPe.test(n);
}
function NPe(n) {
  return IPe.test(n);
}
function LPe(n) {
  var e = n.number, t = n.ext;
  if (!e)
    return "";
  if (e[0] !== "+")
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  return "tel:".concat(e).concat(t ? ";ext=" + t : "");
}
var nB = {
  formatExtension: function(e, t, r) {
    return "".concat(e).concat(r.ext()).concat(t);
  }
};
function $Pe(n, e, t, r) {
  if (t ? t = zPe({}, nB, t) : t = nB, r = new ur(r), n.country && n.country !== "001") {
    if (!r.hasCountry(n.country))
      throw new Error("Unknown country: ".concat(n.country));
    r.selectNumberingPlan(n.country);
  } else if (n.countryCallingCode)
    r.selectNumberingPlan(n.countryCallingCode);
  else return n.phone || "";
  var i = r.countryCallingCode(), s = t.v2 ? n.nationalNumber : n.phone, o;
  switch (e) {
    case "NATIONAL":
      return s ? (o = by(s, n.carrierCode, "NATIONAL", r, t), JS(o, n.ext, r, t.formatExtension)) : "";
    case "INTERNATIONAL":
      return s ? (o = by(s, null, "INTERNATIONAL", r, t), o = "+".concat(i, " ").concat(o), JS(o, n.ext, r, t.formatExtension)) : "+".concat(i);
    case "E.164":
      return "+".concat(i).concat(s);
    case "RFC3966":
      return LPe({
        number: "+".concat(i).concat(s),
        ext: n.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!t.fromCountry)
        return;
      var a = BPe(s, n.carrierCode, i, t.fromCountry, r);
      return JS(a, n.ext, r, t.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(e, '"'));
  }
}
function by(n, e, t, r, i) {
  var s = FPe(r.formats(), n);
  return s ? SX(n, s, {
    useInternationalFormat: t === "INTERNATIONAL",
    withNationalPrefix: !(s.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && i && i.nationalPrefix === !1),
    carrierCode: e,
    metadata: r
  }) : n;
}
function FPe(n, e) {
  return HPe(n, function(t) {
    if (t.leadingDigitsPatterns().length > 0) {
      var r = t.leadingDigitsPatterns()[t.leadingDigitsPatterns().length - 1];
      if (e.search(r) !== 0)
        return !1;
    }
    return hl(e, t.pattern());
  });
}
function JS(n, e, t, r) {
  return e ? r(n, e, t) : n;
}
function BPe(n, e, t, r, i) {
  var s = xl(r, i.metadata);
  if (s === t) {
    var o = by(n, e, "NATIONAL", i);
    return t === "1" ? t + " " + o : o;
  }
  var a = MPe(r, void 0, i.metadata);
  if (a)
    return "".concat(a, " ").concat(t, " ").concat(by(n, null, "INTERNATIONAL", i));
}
function zPe() {
  for (var n = 1, e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  for (; n < t.length; ) {
    if (t[n])
      for (var i in t[n])
        t[0][i] = t[n][i];
    n++;
  }
  return t[0];
}
function HPe(n, e) {
  for (var t = 0; t < n.length; ) {
    if (e(n[t]))
      return n[t];
    t++;
  }
}
function Jm(n) {
  "@babel/helpers - typeof";
  return Jm = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Jm(n);
}
function rB(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function iB(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? rB(Object(t), !0).forEach(function(r) {
      UPe(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : rB(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function UPe(n, e, t) {
  return (e = TX(e)) in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function VPe(n, e) {
  if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function jPe(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, TX(r.key), r);
  }
}
function WPe(n, e, t) {
  return e && jPe(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function TX(n) {
  var e = GPe(n, "string");
  return Jm(e) == "symbol" ? e : e + "";
}
function GPe(n, e) {
  if (Jm(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Jm(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
var AX = /* @__PURE__ */ (function() {
  function n(e, t, r) {
    if (VPe(this, n), !e)
      throw new TypeError("First argument is required");
    if (typeof e != "string")
      throw new TypeError("First argument must be a string");
    if (e[0] === "+" && !t)
      throw new TypeError("`metadata` argument not passed");
    if (xu(t) && xu(t.countries)) {
      r = t;
      var i = e;
      if (!YPe.test(i))
        throw new Error('Invalid `number` argument passed: must consist of a "+" followed by digits');
      var s = JM(i, void 0, void 0, void 0, r), o = s.countryCallingCode, a = s.number;
      if (t = a, e = o, !t)
        throw new Error("Invalid `number` argument passed: too short");
    }
    if (!t)
      throw new TypeError("`nationalNumber` argument is required");
    if (typeof t != "string")
      throw new TypeError("`nationalNumber` argument must be a string");
    pX(r);
    var l = qPe(e, r), c = l.country, u = l.countryCallingCode;
    this.country = c, this.countryCallingCode = u, this.nationalNumber = t, this.number = "+" + this.countryCallingCode + this.nationalNumber, this.getMetadata = function() {
      return r;
    };
  }
  return WPe(n, [{
    key: "setExt",
    value: function(t) {
      this.ext = t;
    }
  }, {
    key: "getPossibleCountries",
    value: function() {
      return this.country ? [this.country] : dPe(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function() {
      return oPe(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function() {
      return uPe(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function() {
      var t = new ur(this.getMetadata());
      return t.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function(t) {
      return this.number === t.number && this.ext === t.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function() {
      return XM(this, {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function(t, r) {
      return $Pe(this, t, r ? iB(iB({}, r), {}, {
        v2: !0
      }) : {
        v2: !0
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function(t) {
      return this.format("NATIONAL", t);
    }
  }, {
    key: "formatInternational",
    value: function(t) {
      return this.format("INTERNATIONAL", t);
    }
  }, {
    key: "getURI",
    value: function(t) {
      return this.format("RFC3966", t);
    }
  }]);
})(), KPe = function(e) {
  return /^[A-Z]{2}$/.test(e);
};
function qPe(n, e) {
  var t, r, i = new ur(e);
  return KPe(n) ? (t = n, i.selectNumberingPlan(t), r = i.countryCallingCode()) : r = n, {
    country: t,
    countryCallingCode: r
  };
}
var YPe = /^\+\d+$/;
function LT(n) {
  "@babel/helpers - typeof";
  return LT = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, LT(n);
}
function XPe(n, e, t) {
  return Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function ZPe(n, e) {
  if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function QPe(n, e, t) {
  return e = t0(e), JPe(n, ek() ? Reflect.construct(e, t || [], t0(n).constructor) : e.apply(n, t));
}
function JPe(n, e) {
  if (e && (LT(e) == "object" || typeof e == "function")) return e;
  if (e !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return eDe(n);
}
function eDe(n) {
  if (n === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function tDe(n, e) {
  if (typeof e != "function" && e !== null) throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && e0(n, e);
}
function $T(n) {
  var e = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return $T = function(r) {
    if (r === null || !rDe(r)) return r;
    if (typeof r != "function") throw new TypeError("Super expression must either be null or a function");
    if (e !== void 0) {
      if (e.has(r)) return e.get(r);
      e.set(r, i);
    }
    function i() {
      return nDe(r, arguments, t0(this).constructor);
    }
    return i.prototype = Object.create(r.prototype, { constructor: { value: i, enumerable: !1, writable: !0, configurable: !0 } }), e0(i, r);
  }, $T(n);
}
function nDe(n, e, t) {
  if (ek()) return Reflect.construct.apply(null, arguments);
  var r = [null];
  r.push.apply(r, e);
  var i = new (n.bind.apply(n, r))();
  return t && e0(i, t.prototype), i;
}
function ek() {
  try {
    var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (ek = function() {
    return !!n;
  })();
}
function rDe(n) {
  try {
    return Function.toString.call(n).indexOf("[native code]") !== -1;
  } catch {
    return typeof n == "function";
  }
}
function e0(n, e) {
  return e0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, r) {
    return t.__proto__ = r, t;
  }, e0(n, e);
}
function t0(n) {
  return t0 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
    return e.__proto__ || Object.getPrototypeOf(e);
  }, t0(n);
}
var Va = /* @__PURE__ */ (function(n) {
  function e(t) {
    var r;
    return ZPe(this, e), r = QPe(this, e, [t]), Object.setPrototypeOf(r, e.prototype), r.name = r.constructor.name, r;
  }
  return tDe(e, n), XPe(e);
})(/* @__PURE__ */ $T(Error)), sB = new RegExp("(?:" + CX() + ")$", "i");
function iDe(n) {
  var e = n.search(sB);
  if (e < 0)
    return {};
  for (var t = n.slice(0, e), r = n.match(sB), i = 1; i < r.length; ) {
    if (r[i])
      return {
        number: t,
        ext: r[i]
      };
    i++;
  }
}
function sDe(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t) return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = oDe(n)) || e) {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function oDe(n, e) {
  if (n) {
    if (typeof n == "string") return oB(n, e);
    var t = {}.toString.call(n).slice(8, -1);
    return t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set" ? Array.from(n) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? oB(n, e) : void 0;
  }
}
function oB(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = Array(e); t < e; t++) r[t] = n[t];
  return r;
}
var aDe = {
  0: "0",
  1: "1",
  2: "2",
  3: "3",
  4: "4",
  5: "5",
  6: "6",
  7: "7",
  8: "8",
  9: "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function MX(n) {
  return aDe[n];
}
function wy(n) {
  for (var e = "", t = sDe(n.split("")), r; !(r = t()).done; ) {
    var i = r.value, s = MX(i);
    s && (e += s);
  }
  return e;
}
function lDe(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t) return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = cDe(n)) || e) {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function cDe(n, e) {
  if (n) {
    if (typeof n == "string") return aB(n, e);
    var t = {}.toString.call(n).slice(8, -1);
    return t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set" ? Array.from(n) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? aB(n, e) : void 0;
  }
}
function aB(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function FT(n) {
  for (var e = "", t = lDe(n.split("")), r; !(r = t()).done; ) {
    var i = r.value;
    e += kX(i, e) || "";
  }
  return e;
}
function kX(n, e, t) {
  if (n === "+") {
    if (e) {
      typeof t == "function" && t("end");
      return;
    }
    return "+";
  }
  return MX(n);
}
var _X = "+", uDe = "[\\-\\.\\(\\)]?", lB = "([" + wi + "]|" + uDe + ")", dDe = "^\\" + _X + lB + "*[" + wi + "]" + lB + "*$", fDe = new RegExp(dDe, "g"), BT = wi, hDe = "[" + BT + "]+((\\-)*[" + BT + "])*", pDe = "a-zA-Z", mDe = "[" + pDe + "]+((\\-)*[" + BT + "])*", gDe = "^(" + hDe + "\\.)*" + mDe + "\\.?$", vDe = new RegExp(gDe, "g"), cB = "tel:", zT = ";phone-context=", yDe = ";isub=";
function bDe(n) {
  var e = n.indexOf(zT);
  if (e < 0)
    return null;
  var t = e + zT.length;
  if (t >= n.length)
    return "";
  var r = n.indexOf(";", t);
  return r >= 0 ? n.substring(t, r) : n.substring(t);
}
function wDe(n) {
  return n === null ? !0 : n.length === 0 ? !1 : fDe.test(n) || vDe.test(n);
}
function xDe(n, e) {
  var t = e.extractFormattedPhoneNumber, r = bDe(n);
  if (!wDe(r))
    throw new Va("NOT_A_NUMBER");
  var i;
  if (r === null)
    i = t(n) || "";
  else {
    i = "", r.charAt(0) === _X && (i += r);
    var s = n.indexOf(cB), o;
    s >= 0 ? o = s + cB.length : o = 0;
    var a = n.indexOf(zT);
    i += n.substring(o, a);
  }
  var l = i.indexOf(yDe);
  if (l > 0 && (i = i.substring(0, l)), i !== "")
    return i;
}
var EDe = 250, SDe = new RegExp("[" + t3 + wi + "]"), CDe = new RegExp("[^" + wi + "#]+$");
function TDe(n, e, t) {
  if (e = e || {}, t = new ur(t), e.defaultCountry && !t.hasCountry(e.defaultCountry))
    throw e.v2 ? new Va("INVALID_COUNTRY") : new Error("Unknown country: ".concat(e.defaultCountry));
  var r = MDe(n, e.v2, e.extract), i = r.number, s = r.ext, o = r.error;
  if (!i) {
    if (e.v2)
      throw o === "TOO_SHORT" ? new Va("TOO_SHORT") : new Va("NOT_A_NUMBER");
    return {};
  }
  var a = _De(i, e.defaultCountry, e.defaultCallingCode, t), l = a.country, c = a.nationalNumber, u = a.countryCallingCode, d = a.countryCallingCodeSource, f = a.carrierCode;
  if (!t.hasSelectedNumberingPlan()) {
    if (e.v2)
      throw new Va("INVALID_COUNTRY");
    return {};
  }
  if (!c || c.length < ZM) {
    if (e.v2)
      throw new Va("TOO_SHORT");
    return {};
  }
  if (c.length > hPe) {
    if (e.v2)
      throw new Va("TOO_LONG");
    return {};
  }
  if (e.v2) {
    var h = new AX(u, c, t.metadata);
    return l && (h.country = l), f && (h.carrierCode = f), s && (h.ext = s), h.__countryCallingCodeSource = d, h;
  }
  var m = (e.extended ? t.hasSelectedNumberingPlan() : l) ? hl(c, t.nationalNumberPattern()) : !1;
  return e.extended ? {
    country: l,
    countryCallingCode: u,
    carrierCode: f,
    valid: m,
    possible: m ? !0 : !!(e.extended === !0 && t.possibleLengths() && vX(c, l, t)),
    phone: c,
    ext: s
  } : m ? kDe(l, c, s) : {};
}
function ADe(n, e, t) {
  if (n) {
    if (n.length > EDe) {
      if (t)
        throw new Va("TOO_LONG");
      return;
    }
    if (e === !1)
      return n;
    var r = n.search(SDe);
    if (!(r < 0))
      return n.slice(r).replace(CDe, "");
  }
}
function MDe(n, e, t) {
  var r = xDe(n, {
    extractFormattedPhoneNumber: function(o) {
      return ADe(o, t, e);
    }
  });
  if (!r)
    return {};
  if (!DPe(r))
    return NPe(r) ? {
      error: "TOO_SHORT"
    } : {};
  var i = iDe(r);
  return i.ext ? i : {
    number: r
  };
}
function kDe(n, e, t) {
  var r = {
    country: n,
    phone: e
  };
  return t && (r.ext = t), r;
}
function _De(n, e, t, r) {
  var i = JM(FT(n), void 0, e, t, r.metadata), s = i.countryCallingCodeSource, o = i.countryCallingCode, a = i.number, l;
  if (o)
    r.selectNumberingPlan(o);
  else if (a && (e || t))
    r.selectNumberingPlan(e, t), e && (l = e), o = t || xl(e, r.metadata);
  else return {};
  if (!a)
    return {
      countryCallingCodeSource: s,
      countryCallingCode: o
    };
  var c = NT(FT(a), l, r), u = c.nationalNumber, d = c.carrierCode, f = QM(o, {
    nationalNumber: u,
    metadata: r
  });
  return f && (l = f, f === "001" || r.selectNumberingPlan(l)), {
    country: l,
    countryCallingCode: o,
    countryCallingCodeSource: s,
    nationalNumber: u,
    carrierCode: d
  };
}
function n0(n) {
  "@babel/helpers - typeof";
  return n0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, n0(n);
}
function uB(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function dB(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? uB(Object(t), !0).forEach(function(r) {
      ODe(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : uB(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function ODe(n, e, t) {
  return (e = IDe(e)) in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function IDe(n) {
  var e = RDe(n, "string");
  return n0(e) == "symbol" ? e : e + "";
}
function RDe(n, e) {
  if (n0(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (n0(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function PDe(n, e, t) {
  return TDe(n, dB(dB({}, e), {}, {
    v2: !0
  }), t);
}
function r0(n) {
  "@babel/helpers - typeof";
  return r0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, r0(n);
}
function fB(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function DDe(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? fB(Object(t), !0).forEach(function(r) {
      NDe(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : fB(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function NDe(n, e, t) {
  return (e = LDe(e)) in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function LDe(n) {
  var e = $De(n, "string");
  return r0(e) == "symbol" ? e : e + "";
}
function $De(n, e) {
  if (r0(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (r0(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function FDe(n, e) {
  return UDe(n) || HDe(n, e) || zDe(n, e) || BDe();
}
function BDe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function zDe(n, e) {
  if (n) {
    if (typeof n == "string") return hB(n, e);
    var t = {}.toString.call(n).slice(8, -1);
    return t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set" ? Array.from(n) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? hB(n, e) : void 0;
  }
}
function hB(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function HDe(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r, i, s, o, a = [], l = !0, c = !1;
    try {
      if (s = (t = t.call(n)).next, e !== 0) for (; !(l = (r = s.call(t)).done) && (a.push(r.value), a.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && t.return != null && (o = t.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return a;
  }
}
function UDe(n) {
  if (Array.isArray(n)) return n;
}
function VDe(n) {
  var e = Array.prototype.slice.call(n), t = FDe(e, 4), r = t[0], i = t[1], s = t[2], o = t[3], a, l, c;
  if (typeof r == "string")
    a = r;
  else throw new TypeError("A text for parsing must be a string.");
  if (!i || typeof i == "string")
    o ? (l = s, c = o) : (l = void 0, c = s), i && (l = DDe({
      defaultCountry: i
    }, l));
  else if (xu(i))
    s ? (l = i, c = s) : c = i;
  else throw new Error("Invalid second argument: ".concat(i));
  return {
    text: a,
    options: l,
    metadata: c
  };
}
function i0(n) {
  "@babel/helpers - typeof";
  return i0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, i0(n);
}
function pB(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function mB(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? pB(Object(t), !0).forEach(function(r) {
      jDe(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : pB(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function jDe(n, e, t) {
  return (e = WDe(e)) in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function WDe(n) {
  var e = GDe(n, "string");
  return i0(e) == "symbol" ? e : e + "";
}
function GDe(n, e) {
  if (i0(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (i0(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function KDe(n, e, t) {
  e && e.defaultCountry && !mX(e.defaultCountry, t) && (e = mB(mB({}, e), {}, {
    defaultCountry: void 0
  }));
  try {
    return PDe(n, e, t);
  } catch (r) {
    if (!(r instanceof Va)) throw r;
  }
}
function qDe() {
  var n = VDe(arguments), e = n.text, t = n.options, r = n.metadata;
  return KDe(e, t, r);
}
function s0(n) {
  "@babel/helpers - typeof";
  return s0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, s0(n);
}
function YDe(n, e) {
  if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function XDe(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, QDe(r.key), r);
  }
}
function ZDe(n, e, t) {
  return e && XDe(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function QDe(n) {
  var e = JDe(n, "string");
  return s0(e) == "symbol" ? e : e + "";
}
function JDe(n, e) {
  if (s0(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (s0(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
var eNe = /* @__PURE__ */ (function() {
  function n(e) {
    var t = e.onCountryChange, r = e.onCallingCodeChange;
    YDe(this, n), this.onCountryChange = t, this.onCallingCodeChange = r;
  }
  return ZDe(n, [{
    key: "reset",
    value: function(t) {
      var r = t.country, i = t.callingCode;
      this.international = !1, this.missingPlus = !1, this.IDDPrefix = void 0, this.callingCode = void 0, this.digits = "", this.resetNationalSignificantNumber(), this.initCountryAndCallingCode(r, i);
    }
  }, {
    key: "resetNationalSignificantNumber",
    value: function() {
      this.nationalSignificantNumber = this.getNationalDigits(), this.nationalSignificantNumberIsModified = !1, this.nationalPrefix = void 0, this.carrierCode = void 0, this.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix = void 0;
    }
  }, {
    key: "update",
    value: function(t) {
      for (var r = 0, i = Object.keys(t); r < i.length; r++) {
        var s = i[r];
        this[s] = t[s];
      }
    }
  }, {
    key: "initCountryAndCallingCode",
    value: function(t, r) {
      this.setCountry(t), this.setCallingCode(r);
    }
  }, {
    key: "setCountry",
    value: function(t) {
      this.country = t, this.onCountryChange(t);
    }
  }, {
    key: "setCallingCode",
    value: function(t) {
      this.callingCode = t, this.onCallingCodeChange(t, this.country);
    }
  }, {
    key: "startInternationalNumber",
    value: function(t, r) {
      this.international = !0, this.initCountryAndCallingCode(t, r);
    }
  }, {
    key: "appendDigits",
    value: function(t) {
      this.digits += t;
    }
  }, {
    key: "appendNationalSignificantNumberDigits",
    value: function(t) {
      this.nationalSignificantNumber += t;
    }
    /**
     * Returns the part of `this.digits` that corresponds to the national number.
     * Basically, all digits that have been input by the user, except for the
     * international prefix and the country calling code part
     * (if the number is an international one).
     * @return {string}
     */
  }, {
    key: "getNationalDigits",
    value: function() {
      return this.international ? this.digits.slice((this.IDDPrefix ? this.IDDPrefix.length : 0) + (this.callingCode ? this.callingCode.length : 0)) : this.digits;
    }
  }, {
    key: "getDigitsWithoutInternationalPrefix",
    value: function() {
      return this.international && this.IDDPrefix ? this.digits.slice(this.IDDPrefix.length) : this.digits;
    }
  }]);
})();
function tNe(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t) return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = nNe(n)) || e) {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function nNe(n, e) {
  if (n) {
    if (typeof n == "string") return gB(n, e);
    var t = {}.toString.call(n).slice(8, -1);
    return t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set" ? Array.from(n) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? gB(n, e) : void 0;
  }
}
function gB(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = Array(e); t < e; t++) r[t] = n[t];
  return r;
}
var to = "x", e6 = new RegExp(to);
function Fv(n, e) {
  if (e < 1)
    return "";
  for (var t = ""; e > 1; )
    e & 1 && (t += n), e >>= 1, n += n;
  return t + n;
}
function vB(n, e) {
  return n[e] === ")" && e++, rNe(n.slice(0, e));
}
function rNe(n) {
  for (var e = [], t = 0; t < n.length; )
    n[t] === "(" ? e.push(t) : n[t] === ")" && e.pop(), t++;
  var r = 0, i = "";
  e.push(n.length);
  for (var s = 0, o = e; s < o.length; s++) {
    var a = o[s];
    i += n.slice(r, a), r = a + 1;
  }
  return i;
}
function iNe(n, e, t) {
  for (var r = tNe(t.split("")), i; !(i = r()).done; ) {
    var s = i.value;
    if (n.slice(e + 1).search(e6) < 0)
      return;
    e = n.search(e6), n = n.replace(e6, s);
  }
  return [n, e];
}
function sNe(n, e, t) {
  var r = t.metadata, i = t.shouldTryNationalPrefixFormattingRule, s = t.getSeparatorAfterNationalPrefix, o = new RegExp("^(?:".concat(e.pattern(), ")$"));
  if (o.test(n.nationalSignificantNumber))
    return aNe(n, e, {
      metadata: r,
      shouldTryNationalPrefixFormattingRule: i,
      getSeparatorAfterNationalPrefix: s
    });
}
function oNe(n, e, t) {
  return e3(n, e, t) === "IS_POSSIBLE";
}
function aNe(n, e, t) {
  var r = t.metadata, i = t.shouldTryNationalPrefixFormattingRule, s = t.getSeparatorAfterNationalPrefix;
  if (n.nationalSignificantNumber, n.international, n.nationalPrefix, n.carrierCode, i(e)) {
    var o = yB(n, e, {
      useNationalPrefixFormattingRule: !0,
      getSeparatorAfterNationalPrefix: s,
      metadata: r
    });
    if (o)
      return o;
  }
  return yB(n, e, {
    useNationalPrefixFormattingRule: !1,
    getSeparatorAfterNationalPrefix: s,
    metadata: r
  });
}
function yB(n, e, t) {
  var r = t.metadata, i = t.useNationalPrefixFormattingRule, s = t.getSeparatorAfterNationalPrefix, o = SX(n.nationalSignificantNumber, e, {
    carrierCode: n.carrierCode,
    useInternationalFormat: n.international,
    withNationalPrefix: i,
    metadata: r
  });
  if (i || (n.nationalPrefix ? o = n.nationalPrefix + s(e) + o : n.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix && (o = n.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix + " " + o)), lNe(o, n))
    return o;
}
function lNe(n, e) {
  return wy(n) === e.getNationalDigits();
}
function o0(n) {
  "@babel/helpers - typeof";
  return o0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, o0(n);
}
function cNe(n, e) {
  if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function uNe(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, fNe(r.key), r);
  }
}
function dNe(n, e, t) {
  return e && uNe(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function fNe(n) {
  var e = hNe(n, "string");
  return o0(e) == "symbol" ? e : e + "";
}
function hNe(n, e) {
  if (o0(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (o0(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
var pNe = /* @__PURE__ */ (function() {
  function n() {
    cNe(this, n);
  }
  return dNe(n, [{
    key: "parse",
    value: function(t) {
      if (this.context = [{
        or: !0,
        instructions: []
      }], this.parsePattern(t), this.context.length !== 1)
        throw new Error("Non-finalized contexts left when pattern parse ended");
      var r = this.context[0], i = r.branches, s = r.instructions;
      if (i)
        return {
          op: "|",
          args: i.concat([t6(s)])
        };
      if (s.length === 0)
        throw new Error("Pattern is required");
      return s.length === 1 ? s[0] : s;
    }
  }, {
    key: "startContext",
    value: function(t) {
      this.context.push(t);
    }
  }, {
    key: "endContext",
    value: function() {
      this.context.pop();
    }
  }, {
    key: "getContext",
    value: function() {
      return this.context[this.context.length - 1];
    }
  }, {
    key: "parsePattern",
    value: function(t) {
      if (!t)
        throw new Error("Pattern is required");
      var r = t.match(vNe);
      if (!r) {
        if (gNe.test(t))
          throw new Error("Illegal characters found in a pattern: ".concat(t));
        this.getContext().instructions = this.getContext().instructions.concat(t.split(""));
        return;
      }
      var i = r[1], s = t.slice(0, r.index), o = t.slice(r.index + i.length);
      switch (i) {
        case "(?:":
          s && this.parsePattern(s), this.startContext({
            or: !0,
            instructions: [],
            branches: []
          });
          break;
        case ")":
          if (!this.getContext().or)
            throw new Error('")" operator must be preceded by "(?:" operator');
          if (s && this.parsePattern(s), this.getContext().instructions.length === 0)
            throw new Error('No instructions found after "|" operator in an "or" group');
          var a = this.getContext(), l = a.branches;
          l.push(t6(this.getContext().instructions)), this.endContext(), this.getContext().instructions.push({
            op: "|",
            args: l
          });
          break;
        case "|":
          if (!this.getContext().or)
            throw new Error('"|" operator can only be used inside "or" groups');
          if (s && this.parsePattern(s), !this.getContext().branches)
            if (this.context.length === 1)
              this.getContext().branches = [];
            else
              throw new Error('"branches" not found in an "or" group context');
          this.getContext().branches.push(t6(this.getContext().instructions)), this.getContext().instructions = [];
          break;
        case "[":
          s && this.parsePattern(s), this.startContext({
            oneOfSet: !0
          });
          break;
        case "]":
          if (!this.getContext().oneOfSet)
            throw new Error('"]" operator must be preceded by "[" operator');
          this.endContext(), this.getContext().instructions.push({
            op: "[]",
            args: mNe(s)
          });
          break;
        /* istanbul ignore next */
        default:
          throw new Error("Unknown operator: ".concat(i));
      }
      o && this.parsePattern(o);
    }
  }]);
})();
function mNe(n) {
  for (var e = [], t = 0; t < n.length; ) {
    if (n[t] === "-") {
      if (t === 0 || t === n.length - 1)
        throw new Error("Couldn't parse a one-of set pattern: ".concat(n));
      for (var r = n[t - 1].charCodeAt(0) + 1, i = n[t + 1].charCodeAt(0) - 1, s = r; s <= i; )
        e.push(String.fromCharCode(s)), s++;
    } else
      e.push(n[t]);
    t++;
  }
  return e;
}
var gNe = /[\(\)\[\]\?\:\|]/, vNe = new RegExp(
  // any of:
  "(\\||\\(\\?\\:|\\)|\\[|\\])"
);
function t6(n) {
  return n.length === 1 ? n[0] : n;
}
function bB(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t) return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = yNe(n)) || e) {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function yNe(n, e) {
  if (n) {
    if (typeof n == "string") return wB(n, e);
    var t = {}.toString.call(n).slice(8, -1);
    return t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set" ? Array.from(n) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? wB(n, e) : void 0;
  }
}
function wB(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function a0(n) {
  "@babel/helpers - typeof";
  return a0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, a0(n);
}
function bNe(n, e) {
  if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function wNe(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, ENe(r.key), r);
  }
}
function xNe(n, e, t) {
  return e && wNe(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function ENe(n) {
  var e = SNe(n, "string");
  return a0(e) == "symbol" ? e : e + "";
}
function SNe(n, e) {
  if (a0(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (a0(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
var CNe = /* @__PURE__ */ (function() {
  function n(e) {
    bNe(this, n), this.matchTree = new pNe().parse(e);
  }
  return xNe(n, [{
    key: "match",
    value: function(t) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, i = r.allowOverflow;
      if (!t)
        throw new Error("String is required");
      var s = HT(t.split(""), this.matchTree, !0);
      if (s && s.match && delete s.matchedChars, !(s && s.overflow && !i))
        return s;
    }
  }]);
})();
function HT(n, e, t) {
  if (typeof e == "string") {
    var r = n.join("");
    return e.indexOf(r) === 0 ? n.length === e.length ? {
      match: !0,
      matchedChars: n
    } : {
      partialMatch: !0
      // matchedChars: characters
    } : r.indexOf(e) === 0 ? t && n.length > e.length ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: n.slice(0, e.length)
    } : void 0;
  }
  if (Array.isArray(e)) {
    for (var i = n.slice(), s = 0; s < e.length; ) {
      var o = e[s], a = HT(i, o, t && s === e.length - 1);
      if (a) {
        if (a.overflow)
          return a;
        if (a.match) {
          if (i = i.slice(a.matchedChars.length), i.length === 0)
            return s === e.length - 1 ? {
              match: !0,
              matchedChars: n
            } : {
              partialMatch: !0
              // matchedChars: characters
            };
        } else {
          if (a.partialMatch)
            return {
              partialMatch: !0
              // matchedChars: characters
            };
          throw new Error(`Unsupported match result:
`.concat(JSON.stringify(a, null, 2)));
        }
      } else return;
      s++;
    }
    return t ? {
      overflow: !0
    } : {
      match: !0,
      matchedChars: n.slice(0, n.length - i.length)
    };
  }
  switch (e.op) {
    case "|":
      for (var l, c = bB(e.args), u; !(u = c()).done; ) {
        var d = u.value, f = HT(n, d, t);
        if (f) {
          if (f.overflow)
            return f;
          if (f.match)
            return {
              match: !0,
              matchedChars: f.matchedChars
            };
          if (f.partialMatch)
            l = !0;
          else
            throw new Error(`Unsupported match result:
`.concat(JSON.stringify(f, null, 2)));
        }
      }
      return l ? {
        partialMatch: !0
        // matchedChars: ...
      } : void 0;
    case "[]":
      for (var h = bB(e.args), m; !(m = h()).done; ) {
        var g = m.value;
        if (n[0] === g)
          return n.length === 1 ? {
            match: !0,
            matchedChars: n
          } : t ? {
            overflow: !0
          } : {
            match: !0,
            matchedChars: [g]
          };
      }
      return;
    /* istanbul ignore next */
    default:
      throw new Error("Unsupported instruction tree: ".concat(e));
  }
}
function l0(n) {
  "@babel/helpers - typeof";
  return l0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, l0(n);
}
function xB(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t) return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = TNe(n)) || e) {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function TNe(n, e) {
  if (n) {
    if (typeof n == "string") return EB(n, e);
    var t = {}.toString.call(n).slice(8, -1);
    return t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set" ? Array.from(n) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? EB(n, e) : void 0;
  }
}
function EB(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function ANe(n, e) {
  if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function MNe(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, _Ne(r.key), r);
  }
}
function kNe(n, e, t) {
  return e && MNe(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function _Ne(n) {
  var e = ONe(n, "string");
  return l0(e) == "symbol" ? e : e + "";
}
function ONe(n, e) {
  if (l0(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (l0(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
var UT = "9", INe = 15, RNe = Fv(UT, INe), PNe = /[- ]/, DNe = function() {
  return /\[([^\[\]])*\]/g;
}, NNe = function() {
  return /\d(?=[^,}][^,}])/g;
}, LNe = new RegExp("[" + vo + "]*\\$1[" + vo + "]*(\\$\\d[" + vo + "]*)*$"), SB = 3, $Ne = /* @__PURE__ */ (function() {
  function n(e) {
    e.state;
    var t = e.metadata;
    ANe(this, n), this.metadata = t, this.resetFormat();
  }
  return kNe(n, [{
    key: "resetFormat",
    value: function() {
      this.chosenFormat = void 0, this.template = void 0, this.nationalNumberTemplate = void 0, this.populatedNationalNumberTemplate = void 0, this.populatedNationalNumberTemplatePosition = -1;
    }
  }, {
    key: "reset",
    value: function(t, r) {
      this.resetFormat(), t ? (this.isNANP = t.callingCode() === "1", this.matchingFormats = t.formats(), r.nationalSignificantNumber && this.narrowDownMatchingFormats(r)) : (this.isNANP = void 0, this.matchingFormats = []);
    }
    /**
     * Formats an updated phone number.
     * @param  {string} nextDigits — Additional phone number digits.
     * @param  {object} state — `AsYouType` state.
     * @return {[string]} Returns undefined if the updated phone number can't be formatted using any of the available formats.
     */
  }, {
    key: "format",
    value: function(t, r) {
      var i = this;
      if (oNe(r.nationalSignificantNumber, r.country, this.metadata))
        for (var s = xB(this.matchingFormats), o; !(o = s()).done; ) {
          var a = o.value, l = sNe(r, a, {
            metadata: this.metadata,
            shouldTryNationalPrefixFormattingRule: function(u) {
              return i.shouldTryNationalPrefixFormattingRule(u, {
                international: r.international,
                nationalPrefix: r.nationalPrefix
              });
            },
            getSeparatorAfterNationalPrefix: function(u) {
              return i.getSeparatorAfterNationalPrefix(u);
            }
          });
          if (l)
            return this.resetFormat(), this.chosenFormat = a, this.setNationalNumberTemplate(l.replace(/\d/g, to), r), this.populatedNationalNumberTemplate = l, this.populatedNationalNumberTemplatePosition = this.template.lastIndexOf(to), l;
        }
      return this.formatNationalNumberWithNextDigits(t, r);
    }
    // Formats the next phone number digits.
  }, {
    key: "formatNationalNumberWithNextDigits",
    value: function(t, r) {
      var i = this.chosenFormat, s = this.chooseFormat(r);
      if (s)
        return s === i ? this.formatNextNationalNumberDigits(t) : this.formatNextNationalNumberDigits(r.getNationalDigits());
    }
  }, {
    key: "narrowDownMatchingFormats",
    value: function(t) {
      var r = this, i = t.nationalSignificantNumber, s = t.nationalPrefix, o = t.international, a = i, l = a.length - SB;
      l < 0 && (l = 0), this.matchingFormats = this.matchingFormats.filter(function(c) {
        return r.formatSuits(c, o, s) && r.formatMatches(c, a, l);
      }), this.chosenFormat && this.matchingFormats.indexOf(this.chosenFormat) === -1 && this.resetFormat();
    }
  }, {
    key: "formatSuits",
    value: function(t, r, i) {
      return !(i && !t.usesNationalPrefix() && // !format.domesticCarrierCodeFormattingRule() &&
      !t.nationalPrefixIsOptionalWhenFormattingInNationalFormat() || !r && !i && t.nationalPrefixIsMandatoryWhenFormattingInNationalFormat());
    }
  }, {
    key: "formatMatches",
    value: function(t, r, i) {
      var s = t.leadingDigitsPatterns().length;
      if (s === 0)
        return !0;
      i = Math.min(i, s - 1);
      var o = t.leadingDigitsPatterns()[i];
      if (r.length < SB)
        try {
          return new CNe(o).match(r, {
            allowOverflow: !0
          }) !== void 0;
        } catch (a) {
          return console.error(a), !0;
        }
      return new RegExp("^(".concat(o, ")")).test(r);
    }
  }, {
    key: "getFormatFormat",
    value: function(t, r) {
      return r ? t.internationalFormat() : t.format();
    }
  }, {
    key: "chooseFormat",
    value: function(t) {
      for (var r = this, i = function() {
        var c = a.value;
        return r.chosenFormat === c ? 0 : LNe.test(r.getFormatFormat(c, t.international)) ? r.createTemplateForFormat(c, t) ? (r.chosenFormat = c, 0) : (r.matchingFormats = r.matchingFormats.filter(function(u) {
          return u !== c;
        }), 1) : 1;
      }, s, o = xB(this.matchingFormats.slice()), a; !(a = o()).done && (s = i(), s !== 0); )
        ;
      return this.chosenFormat || this.resetFormat(), this.chosenFormat;
    }
  }, {
    key: "createTemplateForFormat",
    value: function(t, r) {
      if (!(t.pattern().indexOf("|") >= 0)) {
        var i = this.getTemplateForFormat(t, r);
        if (i)
          return this.setNationalNumberTemplate(i, r), !0;
      }
    }
  }, {
    key: "getSeparatorAfterNationalPrefix",
    value: function(t) {
      return this.isNANP || t && t.nationalPrefixFormattingRule() && PNe.test(t.nationalPrefixFormattingRule()) ? " " : "";
    }
  }, {
    key: "getInternationalPrefixBeforeCountryCallingCode",
    value: function(t, r) {
      var i = t.IDDPrefix, s = t.missingPlus;
      return i ? r && r.spacing === !1 ? i : i + " " : s ? "" : "+";
    }
  }, {
    key: "getTemplate",
    value: function(t) {
      if (this.template) {
        for (var r = -1, i = 0, s = t.international ? this.getInternationalPrefixBeforeCountryCallingCode(t, {
          spacing: !1
        }) : ""; i < s.length + t.getDigitsWithoutInternationalPrefix().length; )
          r = this.template.indexOf(to, r + 1), i++;
        return vB(this.template, r + 1);
      }
    }
  }, {
    key: "setNationalNumberTemplate",
    value: function(t, r) {
      this.nationalNumberTemplate = t, this.populatedNationalNumberTemplate = t, this.populatedNationalNumberTemplatePosition = -1, r.international ? this.template = this.getInternationalPrefixBeforeCountryCallingCode(r).replace(/[\d\+]/g, to) + Fv(to, r.callingCode.length) + " " + t : this.template = t;
    }
    /**
     * Generates formatting template for a national phone number,
     * optionally containing a national prefix, for a format.
     * @param  {Format} format
     * @param  {string} nationalPrefix
     * @return {string}
     */
  }, {
    key: "getTemplateForFormat",
    value: function(t, r) {
      var i = r.nationalSignificantNumber, s = r.international, o = r.nationalPrefix, a = r.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix, l = t.pattern();
      l = l.replace(DNe(), "\\d").replace(NNe(), "\\d");
      var c = RNe.match(l)[0];
      if (!(i.length > c.length)) {
        var u = new RegExp("^" + l + "$"), d = i.replace(/\d/g, UT);
        u.test(d) && (c = d);
        var f = this.getFormatFormat(t, s), h;
        if (this.shouldTryNationalPrefixFormattingRule(t, {
          international: s,
          nationalPrefix: o
        })) {
          var m = f.replace(EX, t.nationalPrefixFormattingRule());
          if (wy(t.nationalPrefixFormattingRule()) === (o || "") + wy("$1") && (f = m, h = !0, o))
            for (var g = o.length; g > 0; )
              f = f.replace(/\d/, to), g--;
        }
        var v = c.replace(new RegExp(l), f).replace(new RegExp(UT, "g"), to);
        return h || (a ? v = Fv(to, a.length) + " " + v : o && (v = Fv(to, o.length) + this.getSeparatorAfterNationalPrefix(t) + v)), s && (v = xX(v)), v;
      }
    }
  }, {
    key: "formatNextNationalNumberDigits",
    value: function(t) {
      var r = iNe(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition, t);
      if (!r) {
        this.resetFormat();
        return;
      }
      return this.populatedNationalNumberTemplate = r[0], this.populatedNationalNumberTemplatePosition = r[1], vB(this.populatedNationalNumberTemplate, this.populatedNationalNumberTemplatePosition + 1);
    }
  }, {
    key: "shouldTryNationalPrefixFormattingRule",
    value: function(t, r) {
      var i = r.international, s = r.nationalPrefix;
      if (t.nationalPrefixFormattingRule()) {
        var o = t.usesNationalPrefix();
        if (o && s || !o && !i)
          return !0;
      }
    }
  }]);
})();
function c0(n) {
  "@babel/helpers - typeof";
  return c0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, c0(n);
}
function OX(n, e) {
  return HNe(n) || zNe(n, e) || BNe(n, e) || FNe();
}
function FNe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function BNe(n, e) {
  if (n) {
    if (typeof n == "string") return CB(n, e);
    var t = {}.toString.call(n).slice(8, -1);
    return t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set" ? Array.from(n) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? CB(n, e) : void 0;
  }
}
function CB(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function zNe(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r, i, s, o, a = [], l = !0, c = !1;
    try {
      if (s = (t = t.call(n)).next, e !== 0) for (; !(l = (r = s.call(t)).done) && (a.push(r.value), a.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && t.return != null && (o = t.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return a;
  }
}
function HNe(n) {
  if (Array.isArray(n)) return n;
}
function UNe(n, e) {
  if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function VNe(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, WNe(r.key), r);
  }
}
function jNe(n, e, t) {
  return e && VNe(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function WNe(n) {
  var e = GNe(n, "string");
  return c0(e) == "symbol" ? e : e + "";
}
function GNe(n, e) {
  if (c0(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (c0(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
var KNe = "[" + vo + wi + "]+", qNe = new RegExp("^" + KNe + "$", "i"), YNe = "(?:[" + t3 + "][" + vo + wi + "]*|[" + vo + wi + "]+)", XNe = new RegExp("[^" + vo + wi + "]+.*$"), ZNe = /[^\d\[\]]/, QNe = /* @__PURE__ */ (function() {
  function n(e) {
    var t = e.defaultCountry, r = e.defaultCallingCode, i = e.metadata, s = e.onNationalSignificantNumberChange;
    UNe(this, n), this.defaultCountry = t, this.defaultCallingCode = r, this.metadata = i, this.onNationalSignificantNumberChange = s;
  }
  return jNe(n, [{
    key: "input",
    value: function(t, r) {
      var i = tLe(t), s = OX(i, 2), o = s[0], a = s[1], l = wy(o), c;
      return a && (r.digits || (r.startInternationalNumber(void 0, void 0), l || (c = !0))), l && this.inputDigits(l, r), {
        digits: l,
        justLeadingPlus: c
      };
    }
    /**
     * Inputs "next" phone number digits.
     * @param  {string} digits
     * @return {string} [formattedNumber] Formatted national phone number (if it can be formatted at this stage). Returning `undefined` means "don't format the national phone number at this stage".
     */
  }, {
    key: "inputDigits",
    value: function(t, r) {
      var i = r.digits, s = i.length < 3 && i.length + t.length >= 3;
      if (r.appendDigits(t), s && this.extractIddPrefix(r), this.isWaitingForCountryCallingCode(r)) {
        if (!this.extractCountryCallingCode(r))
          return;
      } else
        r.appendNationalSignificantNumberDigits(t);
      r.international || this.hasExtractedNationalSignificantNumber || this.extractNationalSignificantNumber(r.getNationalDigits(), function(o) {
        return r.update(o);
      });
    }
  }, {
    key: "isWaitingForCountryCallingCode",
    value: function(t) {
      var r = t.international, i = t.callingCode;
      return r && !i;
    }
    // Extracts a country calling code from a number
    // being entered in internatonal format.
  }, {
    key: "extractCountryCallingCode",
    value: function(t) {
      var r = JM("+" + t.getDigitsWithoutInternationalPrefix(), t.country, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), i = r.countryCallingCode, s = r.number;
      if (i)
        return t.setCallingCode(i), t.update({
          nationalSignificantNumber: s
        }), !0;
    }
  }, {
    key: "reset",
    value: function(t) {
      if (t) {
        this.hasSelectedNumberingPlan = !0;
        var r = t._nationalPrefixForParsing();
        this.couldPossiblyExtractAnotherNationalSignificantNumber = r && ZNe.test(r);
      } else
        this.hasSelectedNumberingPlan = void 0, this.couldPossiblyExtractAnotherNationalSignificantNumber = void 0;
    }
    /**
     * Extracts a national (significant) number from user input.
     * Google's library is different in that it only applies `national_prefix_for_parsing`
     * and doesn't apply `national_prefix_transform_rule` after that.
     * https://github.com/google/libphonenumber/blob/a3d70b0487875475e6ad659af404943211d26456/java/libphonenumber/src/com/google/i18n/phonenumbers/AsYouTypeFormatter.java#L539
     * @return {boolean} [extracted]
     */
  }, {
    key: "extractNationalSignificantNumber",
    value: function(t, r) {
      if (this.hasSelectedNumberingPlan) {
        var i = DT(t, this.metadata), s = i.nationalPrefix, o = i.nationalNumber, a = i.carrierCode;
        if (o !== t)
          return this.onExtractedNationalNumber(s, a, o, t, r), !0;
      }
    }
    /**
     * In Google's code this function is called "attempt to extract longer NDD".
     * "Some national prefixes are a substring of others", they say.
     * @return {boolean} [result] — Returns `true` if extracting a national prefix produced different results from what they were.
     */
  }, {
    key: "extractAnotherNationalSignificantNumber",
    value: function(t, r, i) {
      if (!this.hasExtractedNationalSignificantNumber)
        return this.extractNationalSignificantNumber(t, i);
      if (this.couldPossiblyExtractAnotherNationalSignificantNumber) {
        var s = DT(t, this.metadata), o = s.nationalPrefix, a = s.nationalNumber, l = s.carrierCode;
        if (a !== r)
          return this.onExtractedNationalNumber(o, l, a, t, i), !0;
      }
    }
  }, {
    key: "onExtractedNationalNumber",
    value: function(t, r, i, s, o) {
      var a = !1, l, c = s.lastIndexOf(i);
      if (c < 0 || c !== s.length - i.length)
        a = !0;
      else {
        var u = s.slice(0, c);
        u && u !== t && (l = u);
      }
      o({
        nationalPrefix: t,
        carrierCode: r,
        nationalSignificantNumber: i,
        nationalSignificantNumberIsModified: a,
        prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix: l
      }), this.hasExtractedNationalSignificantNumber = !0, this.onNationalSignificantNumberChange();
    }
  }, {
    key: "reExtractNationalSignificantNumber",
    value: function(t) {
      if (this.extractAnotherNationalSignificantNumber(t.getNationalDigits(), t.nationalSignificantNumber, function(r) {
        return t.update(r);
      }))
        return !0;
      if (this.extractIddPrefix(t))
        return this.extractCallingCodeAndNationalSignificantNumber(t), !0;
      if (this.fixMissingPlus(t))
        return this.extractCallingCodeAndNationalSignificantNumber(t), !0;
    }
  }, {
    key: "extractIddPrefix",
    value: function(t) {
      var r = t.international, i = t.IDDPrefix, s = t.digits;
      if (t.nationalSignificantNumber, !(r || i)) {
        var o = yX(s, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata);
        if (o !== void 0 && o !== s)
          return t.update({
            IDDPrefix: s.slice(0, s.length - o.length)
          }), this.startInternationalNumber(t, {
            country: void 0,
            callingCode: void 0
          }), !0;
      }
    }
  }, {
    key: "fixMissingPlus",
    value: function(t) {
      if (!t.international) {
        var r = wX(t.digits, t.country, this.defaultCountry, this.defaultCallingCode, this.metadata.metadata), i = r.countryCallingCode;
        if (i)
          return t.update({
            missingPlus: !0
          }), this.startInternationalNumber(t, {
            country: t.country,
            callingCode: i
          }), !0;
      }
    }
  }, {
    key: "startInternationalNumber",
    value: function(t, r) {
      var i = r.country, s = r.callingCode;
      t.startInternationalNumber(i, s), t.nationalSignificantNumber && (t.resetNationalSignificantNumber(), this.onNationalSignificantNumberChange(), this.hasExtractedNationalSignificantNumber = void 0);
    }
  }, {
    key: "extractCallingCodeAndNationalSignificantNumber",
    value: function(t) {
      this.extractCountryCallingCode(t) && this.extractNationalSignificantNumber(t.getNationalDigits(), function(r) {
        return t.update(r);
      });
    }
  }]);
})();
function JNe(n) {
  var e = n.search(YNe);
  if (!(e < 0)) {
    n = n.slice(e);
    var t;
    return n[0] === "+" && (t = !0, n = n.slice(1)), n = n.replace(XNe, ""), t && (n = "+" + n), n;
  }
}
function eLe(n) {
  var e = JNe(n) || "";
  return e[0] === "+" ? [e.slice(1), !0] : [e];
}
function tLe(n) {
  var e = eLe(n), t = OX(e, 2), r = t[0], i = t[1];
  return qNe.test(r) || (r = ""), [r, i];
}
function u0(n) {
  "@babel/helpers - typeof";
  return u0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, u0(n);
}
function nLe(n, e) {
  return oLe(n) || sLe(n, e) || iLe(n, e) || rLe();
}
function rLe() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function iLe(n, e) {
  if (n) {
    if (typeof n == "string") return TB(n, e);
    var t = {}.toString.call(n).slice(8, -1);
    return t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set" ? Array.from(n) : t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? TB(n, e) : void 0;
  }
}
function TB(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function sLe(n, e) {
  var t = n == null ? null : typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t != null) {
    var r, i, s, o, a = [], l = !0, c = !1;
    try {
      if (s = (t = t.call(n)).next, e !== 0) for (; !(l = (r = s.call(t)).done) && (a.push(r.value), a.length !== e); l = !0) ;
    } catch (u) {
      c = !0, i = u;
    } finally {
      try {
        if (!l && t.return != null && (o = t.return(), Object(o) !== o)) return;
      } finally {
        if (c) throw i;
      }
    }
    return a;
  }
}
function oLe(n) {
  if (Array.isArray(n)) return n;
}
function aLe(n, e) {
  if (!(n instanceof e)) throw new TypeError("Cannot call a class as a function");
}
function lLe(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, uLe(r.key), r);
  }
}
function cLe(n, e, t) {
  return e && lLe(n.prototype, e), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function uLe(n) {
  var e = dLe(n, "string");
  return u0(e) == "symbol" ? e : e + "";
}
function dLe(n, e) {
  if (u0(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (u0(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(n);
}
var Oh = /* @__PURE__ */ (function() {
  function n(e, t) {
    aLe(this, n), this.metadata = new ur(t);
    var r = this.getCountryAndCallingCode(e), i = nLe(r, 2), s = i[0], o = i[1];
    this.defaultCountry = s, this.defaultCallingCode = o, this.reset();
  }
  return cLe(n, [{
    key: "getCountryAndCallingCode",
    value: function(t) {
      var r, i;
      return t && (xu(t) ? (r = t.defaultCountry, i = t.defaultCallingCode) : r = t), r && !this.metadata.hasCountry(r) && (r = void 0), [r, i];
    }
    /**
     * Inputs "next" phone number characters.
     * @param  {string} text
     * @return {string} Formatted phone number characters that have been input so far.
     */
  }, {
    key: "input",
    value: function(t) {
      var r = this.parser.input(t, this.state), i = r.digits, s = r.justLeadingPlus;
      if (s)
        this.formattedOutput = "+";
      else if (i) {
        this.determineTheCountryIfNeeded(), this.state.nationalSignificantNumber && this.formatter.narrowDownMatchingFormats(this.state);
        var o;
        if (this.metadata.hasSelectedNumberingPlan() && (o = this.formatter.format(i, this.state)), o === void 0 && this.parser.reExtractNationalSignificantNumber(this.state)) {
          this.determineTheCountryIfNeeded();
          var a = this.state.getNationalDigits();
          a && (o = this.formatter.format(a, this.state));
        }
        this.formattedOutput = o ? this.getFullNumber(o) : this.getNonFormattedNumber();
      }
      return this.formattedOutput;
    }
  }, {
    key: "reset",
    value: function() {
      var t = this;
      return this.state = new eNe({
        onCountryChange: function(i) {
          t.country = i;
        },
        onCallingCodeChange: function(i, s) {
          t.metadata.selectNumberingPlan(s, i), t.formatter.reset(t.metadata.numberingPlan, t.state), t.parser.reset(t.metadata.numberingPlan);
        }
      }), this.formatter = new $Ne({
        state: this.state,
        metadata: this.metadata
      }), this.parser = new QNe({
        defaultCountry: this.defaultCountry,
        defaultCallingCode: this.defaultCallingCode,
        metadata: this.metadata,
        state: this.state,
        onNationalSignificantNumberChange: function() {
          t.determineTheCountryIfNeeded(), t.formatter.reset(t.metadata.numberingPlan, t.state);
        }
      }), this.state.reset({
        country: this.defaultCountry,
        callingCode: this.defaultCallingCode
      }), this.formattedOutput = "", this;
    }
    /**
     * Returns `true` if the phone number is being input in international format.
     * In other words, returns `true` if and only if the parsed phone number starts with a `"+"`.
     * @return {boolean}
     */
  }, {
    key: "isInternational",
    value: function() {
      return this.state.international;
    }
    /**
     * Returns the "calling code" part of the phone number when it's being input
     * in an international format.
     * If no valid calling code has been entered so far, returns `undefined`.
     * @return {string} [callingCode]
     */
  }, {
    key: "getCallingCode",
    value: function() {
      if (this.isInternational())
        return this.state.callingCode;
    }
    // A legacy alias.
  }, {
    key: "getCountryCallingCode",
    value: function() {
      return this.getCallingCode();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * Returns `undefined` if no phone number has been input yet.
     * @return {string} [country]
     */
  }, {
    key: "getCountry",
    value: function() {
      var t = this.state.digits;
      if (t)
        return this._getCountry();
    }
    /**
     * Returns a two-letter country code of the phone number.
     * Returns `undefined` for "non-geographic" phone numbering plans.
     * @return {string} [country]
     */
  }, {
    key: "_getCountry",
    value: function() {
      var t = this.state.country;
      return t;
    }
  }, {
    key: "determineTheCountryIfNeeded",
    value: function() {
      (!this.state.country || this.isCountryCallingCodeAmbiguous()) && this.determineTheCountry();
    }
    // Prepends `+CountryCode ` in case of an international phone number
  }, {
    key: "getFullNumber",
    value: function(t) {
      var r = this;
      if (this.isInternational()) {
        var i = function(a) {
          return r.formatter.getInternationalPrefixBeforeCountryCallingCode(r.state, {
            spacing: !!a
          }) + a;
        }, s = this.state.callingCode;
        return i(s ? t ? "".concat(s, " ").concat(t) : s : "".concat(this.state.getDigitsWithoutInternationalPrefix()));
      }
      return t;
    }
  }, {
    key: "getNonFormattedNationalNumberWithPrefix",
    value: function() {
      var t = this.state, r = t.nationalSignificantNumber, i = t.prefixBeforeNationalSignificantNumberThatIsNotNationalPrefix, s = t.nationalPrefix, o = r, a = i || s;
      return a && (o = a + o), o;
    }
  }, {
    key: "getNonFormattedNumber",
    value: function() {
      var t = this.state.nationalSignificantNumberIsModified;
      return this.getFullNumber(t ? this.state.getNationalDigits() : this.getNonFormattedNationalNumberWithPrefix());
    }
  }, {
    key: "getNonFormattedTemplate",
    value: function() {
      var t = this.getNonFormattedNumber();
      if (t)
        return t.replace(/[\+\d]/g, to);
    }
  }, {
    key: "isCountryCallingCodeAmbiguous",
    value: function() {
      var t = this.state.callingCode, r = this.metadata.getCountryCodesForCallingCode(t);
      return r && r.length > 1;
    }
    // Determines the exact country of the phone number
    // entered so far based on the country phone code
    // and the national phone number.
  }, {
    key: "determineTheCountry",
    value: function() {
      this.state.setCountry(QM(this.isInternational() ? this.state.callingCode : this.defaultCallingCode, {
        nationalNumber: this.state.nationalSignificantNumber,
        metadata: this.metadata
      }));
    }
    /**
     * Returns a E.164 phone number value for the user's input.
     *
     * For example, for country `"US"` and input `"(222) 333-4444"`
     * it will return `"+12223334444"`.
     *
     * For international phone number input, it will also auto-correct
     * some minor errors such as using a national prefix when writing
     * an international phone number. For example, if the user inputs
     * `"+44 0 7400 000000"` then it will return an auto-corrected
     * `"+447400000000"` phone number value.
     *
     * Will return `undefined` if no digits have been input,
     * or when inputting a phone number in national format and no
     * default country or default "country calling code" have been set.
     *
     * @return {string} [value]
     */
  }, {
    key: "getNumberValue",
    value: function() {
      var t = this.state, r = t.digits, i = t.callingCode, s = t.country, o = t.nationalSignificantNumber;
      if (r) {
        if (this.isInternational())
          return i ? "+" + i + o : "+" + r;
        if (s || i) {
          var a = s ? this.metadata.countryCallingCode() : i;
          return "+" + a + o;
        }
      }
    }
    /**
     * Returns an instance of `PhoneNumber` class.
     * Will return `undefined` if no national (significant) number
     * digits have been entered so far, or if no `defaultCountry` has been
     * set and the user enters a phone number not in international format.
     */
  }, {
    key: "getNumber",
    value: function() {
      var t = this.state, r = t.nationalSignificantNumber, i = t.carrierCode, s = t.callingCode, o = this._getCountry();
      if (r && !(!o && !s)) {
        if (o && o === this.defaultCountry) {
          var a = new ur(this.metadata.metadata);
          a.selectNumberingPlan(o);
          var l = a.numberingPlan.callingCode(), c = this.metadata.getCountryCodesForCallingCode(l);
          if (c.length > 1) {
            var u = bX(r, {
              countries: c,
              metadata: this.metadata.metadata
            });
            u && (o = u);
          }
        }
        var d = new AX(o || s, r, this.metadata.metadata);
        return i && (d.carrierCode = i), d;
      }
    }
    /**
     * Returns `true` if the phone number is "possible".
     * Is just a shortcut for `PhoneNumber.isPossible()`.
     * @return {boolean}
     */
  }, {
    key: "isPossible",
    value: function() {
      var t = this.getNumber();
      return t ? t.isPossible() : !1;
    }
    /**
     * Returns `true` if the phone number is "valid".
     * Is just a shortcut for `PhoneNumber.isValid()`.
     * @return {boolean}
     */
  }, {
    key: "isValid",
    value: function() {
      var t = this.getNumber();
      return t ? t.isValid() : !1;
    }
    /**
     * @deprecated
     * This method is used in `react-phone-number-input/source/input-control.js`
     * in versions before `3.0.16`.
     */
  }, {
    key: "getNationalNumber",
    value: function() {
      return this.state.nationalSignificantNumber;
    }
    /**
     * Returns the phone number characters entered by the user.
     * @return {string}
     */
  }, {
    key: "getChars",
    value: function() {
      return (this.state.international ? "+" : "") + this.state.digits;
    }
    /**
     * Returns the template for the formatted phone number.
     * @return {string}
     */
  }, {
    key: "getTemplate",
    value: function() {
      return this.formatter.getTemplate(this.state) || this.getNonFormattedTemplate() || "";
    }
  }]);
})();
function AB(n) {
  return new ur(n).getCountries();
}
function fLe(n, e, t) {
  return t || (t = e, e = void 0), new Oh(e, t).input(n);
}
function IX(n) {
  var e = n.inputFormat, t = n.country, r = n.metadata;
  return e === "NATIONAL_PART_OF_INTERNATIONAL" ? "+".concat(xl(t, r)) : "";
}
function VT(n, e) {
  return e && (n = n.slice(e.length), n[0] === " " && (n = n.slice(1))), n;
}
function hLe(n, e, t) {
  if (!(t && t.ignoreRest)) {
    var r = function(s) {
      if (t)
        switch (s) {
          case "end":
            t.ignoreRest = !0;
            break;
        }
    };
    return kX(n, e, r);
  }
}
function RX(n) {
  var e = n.onKeyDown, t = n.inputFormat;
  return Ft(function(r) {
    if (r.keyCode === mLe && t === "INTERNATIONAL" && r.target instanceof HTMLInputElement && pLe(r.target) === gLe.length) {
      r.preventDefault();
      return;
    }
    e && e(r);
  }, [e, t]);
}
function pLe(n) {
  return n.selectionStart;
}
var mLe = 8, gLe = "+", vLe = ["onKeyDown", "country", "inputFormat", "metadata", "international", "withCountryCallingCode"];
function jT() {
  return jT = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, jT.apply(this, arguments);
}
function yLe(n, e) {
  if (n == null) return {};
  var t = bLe(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function bLe(n, e) {
  if (n == null) return {};
  var t = {}, r = Object.keys(n), i, s;
  for (s = 0; s < r.length; s++)
    i = r[s], !(e.indexOf(i) >= 0) && (t[i] = n[i]);
  return t;
}
function wLe(n) {
  function e(t, r) {
    var i = t.onKeyDown, s = t.country, o = t.inputFormat, a = t.metadata, l = a === void 0 ? n : a;
    t.international, t.withCountryCallingCode;
    var c = yLe(t, vLe), u = Ft(function(f) {
      var h = new Oh(s, l), m = IX({
        inputFormat: o,
        country: s,
        metadata: l
      }), g = h.input(m + f), v = h.getTemplate();
      return m && (g = VT(g, m), v && (v = VT(v, m))), {
        text: g,
        template: v
      };
    }, [s, l]), d = RX({
      onKeyDown: i,
      inputFormat: o
    });
    return /* @__PURE__ */ p.createElement(yy, jT({}, c, {
      ref: r,
      parse: hLe,
      format: u,
      onKeyDown: d
    }));
  }
  return e = /* @__PURE__ */ p.forwardRef(e), e.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: pe.string.isRequired,
    /**
     * A function of `value: string`.
     * Updates the `value` property.
     */
    onChange: pe.func.isRequired,
    /**
     * A function of `event: Event`.
     * Handles `keydown` events.
     */
    onKeyDown: pe.func,
    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * This property should've been called `defaultCountry`
     * because it only applies when the user inputs a phone number in a national format
     * and is completely ignored when the user inputs a phone number in an international format.
     */
    country: pe.string,
    /**
     * The format that the input field value is being input/output in.
     */
    inputFormat: pe.oneOf(["INTERNATIONAL", "NATIONAL_PART_OF_INTERNATIONAL", "NATIONAL", "INTERNATIONAL_OR_NATIONAL"]).isRequired,
    /**
     * `libphonenumber-js` metadata.
     */
    metadata: pe.object
  }, e;
}
const xLe = wLe();
var ELe = ["value", "onChange", "onKeyDown", "country", "inputFormat", "metadata", "inputComponent", "international", "withCountryCallingCode"];
function WT() {
  return WT = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, WT.apply(this, arguments);
}
function SLe(n, e) {
  if (n == null) return {};
  var t = CLe(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function CLe(n, e) {
  if (n == null) return {};
  var t = {}, r = Object.keys(n), i, s;
  for (s = 0; s < r.length; s++)
    i = r[s], !(e.indexOf(i) >= 0) && (t[i] = n[i]);
  return t;
}
function TLe(n) {
  function e(t, r) {
    var i = t.value, s = t.onChange, o = t.onKeyDown, a = t.country, l = t.inputFormat, c = t.metadata, u = c === void 0 ? n : c, d = t.inputComponent, f = d === void 0 ? "input" : d;
    t.international, t.withCountryCallingCode;
    var h = SLe(t, ELe), m = IX({
      inputFormat: l,
      country: a,
      metadata: u
    }), g = Ft(function(y) {
      var b = FT(y.target.value);
      if (b === i) {
        var x = MB(m, b, a, u);
        x.indexOf(y.target.value) === 0 && (b = b.slice(0, -1));
      }
      s(b);
    }, [m, i, s, a, u]), v = RX({
      onKeyDown: o,
      inputFormat: l
    });
    return /* @__PURE__ */ p.createElement(f, WT({}, h, {
      ref: r,
      value: MB(m, i, a, u),
      onChange: g,
      onKeyDown: v
    }));
  }
  return e = /* @__PURE__ */ p.forwardRef(e), e.propTypes = {
    /**
     * The parsed phone number.
     * "Parsed" not in a sense of "E.164"
     * but rather in a sense of "having only
     * digits and possibly a leading plus character".
     * Examples: `""`, `"+"`, `"+123"`, `"123"`.
     */
    value: pe.string.isRequired,
    /**
     * A function of `value: string`.
     * Updates the `value` property.
     */
    onChange: pe.func.isRequired,
    /**
     * A function of `event: Event`.
     * Handles `keydown` events.
     */
    onKeyDown: pe.func,
    /**
     * A two-letter country code for formatting `value`
     * as a national phone number (e.g. `(800) 555 35 35`).
     * E.g. "US", "RU", etc.
     * If no `country` is passed then `value`
     * is formatted as an international phone number.
     * (e.g. `+7 800 555 35 35`)
     * This property should've been called `defaultCountry`
     * because it only applies when the user inputs a phone number in a national format
     * and is completely ignored when the user inputs a phone number in an international format.
     */
    country: pe.string,
    /**
     * The format that the input field value is being input/output in.
     */
    inputFormat: pe.oneOf(["INTERNATIONAL", "NATIONAL_PART_OF_INTERNATIONAL", "NATIONAL", "INTERNATIONAL_OR_NATIONAL"]).isRequired,
    /**
     * `libphonenumber-js` metadata.
     */
    metadata: pe.object,
    /**
     * The `<input/>` component.
     */
    inputComponent: pe.elementType
  }, e;
}
const ALe = TLe();
function MB(n, e, t, r) {
  return VT(fLe(n + e, t, r), n);
}
function MLe(n) {
  return kB(n[0]) + kB(n[1]);
}
function kB(n) {
  return String.fromCodePoint(127397 + n.toUpperCase().charCodeAt(0));
}
var kLe = ["value", "onChange", "options", "disabled", "readOnly"], _Le = ["value", "options", "className", "iconComponent", "getIconAspectRatio", "arrowComponent", "unicodeFlags"];
function OLe(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t) return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = ILe(n)) || e) {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function ILe(n, e) {
  if (n) {
    if (typeof n == "string") return _B(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return _B(n, e);
  }
}
function _B(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function xy() {
  return xy = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, xy.apply(this, arguments);
}
function PX(n, e) {
  if (n == null) return {};
  var t = RLe(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function RLe(n, e) {
  if (n == null) return {};
  var t = {}, r = Object.keys(n), i, s;
  for (s = 0; s < r.length; s++)
    i = r[s], !(e.indexOf(i) >= 0) && (t[i] = n[i]);
  return t;
}
function DX(n) {
  var e = n.value, t = n.onChange, r = n.options, i = n.disabled, s = n.readOnly, o = PX(n, kLe), a = Ft(function(l) {
    var c = l.target.value;
    t(c === "ZZ" ? void 0 : c);
  }, [t]);
  return ua(function() {
    return LX(r, e);
  }, [r, e]), /* @__PURE__ */ p.createElement("select", xy({}, o, {
    disabled: i || s,
    readOnly: s,
    value: e || "ZZ",
    onChange: a
  }), r.map(function(l) {
    var c = l.value, u = l.label, d = l.divider;
    return /* @__PURE__ */ p.createElement("option", {
      key: d ? "|" : c || "ZZ",
      value: d ? "|" : c || "ZZ",
      disabled: !!d,
      style: d ? PLe : void 0
    }, u);
  }));
}
DX.propTypes = {
  /**
   * A two-letter country code.
   * Example: "US", "RU", etc.
   */
  value: pe.string,
  /**
   * A function of `value: string`.
   * Updates the `value` property.
   */
  onChange: pe.func.isRequired,
  // `<select/>` options.
  options: pe.arrayOf(pe.shape({
    value: pe.string,
    label: pe.string,
    divider: pe.bool
  })).isRequired,
  // `readonly` attribute doesn't work on a `<select/>`.
  // https://github.com/catamphetamine/react-phone-number-input/issues/419#issuecomment-1764384480
  // https://www.delftstack.com/howto/html/html-select-readonly/
  // To work around that, if `readOnly: true` property is passed
  // to this component, it behaves analogous to `disabled: true`.
  disabled: pe.bool,
  readOnly: pe.bool
};
var PLe = {
  fontSize: "1px",
  backgroundColor: "currentColor",
  color: "inherit"
};
function NX(n) {
  var e = n.value, t = n.options, r = n.className, i = n.iconComponent;
  n.getIconAspectRatio;
  var s = n.arrowComponent, o = s === void 0 ? DLe : s, a = n.unicodeFlags, l = PX(n, _Le), c = ua(function() {
    return LX(t, e);
  }, [t, e]);
  return /* @__PURE__ */ p.createElement("div", {
    className: "PhoneInputCountry"
  }, /* @__PURE__ */ p.createElement(DX, xy({}, l, {
    value: e,
    options: t,
    className: vy("PhoneInputCountrySelect", r)
  })), c && (a && e ? /* @__PURE__ */ p.createElement("div", {
    className: "PhoneInputCountryIconUnicode"
  }, MLe(e)) : /* @__PURE__ */ p.createElement(i, {
    "aria-hidden": !0,
    country: e,
    label: c.label,
    aspectRatio: a ? 1 : void 0
  })), /* @__PURE__ */ p.createElement(o, null));
}
NX.propTypes = {
  // Country flag component.
  iconComponent: pe.elementType,
  // Select arrow component.
  arrowComponent: pe.elementType,
  // Set to `true` to render Unicode flag icons instead of SVG images.
  unicodeFlags: pe.bool
};
function DLe() {
  return /* @__PURE__ */ p.createElement("div", {
    className: "PhoneInputCountrySelectArrow"
  });
}
function LX(n, e) {
  for (var t = OLe(n), r; !(r = t()).done; ) {
    var i = r.value;
    if (!i.divider && NLe(i.value, e))
      return i;
  }
}
function NLe(n, e) {
  return n == null ? e == null : n === e;
}
var LLe = ["country", "countryName", "flags", "flagUrl"];
function GT() {
  return GT = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, GT.apply(this, arguments);
}
function $Le(n, e) {
  if (n == null) return {};
  var t = FLe(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function FLe(n, e) {
  if (n == null) return {};
  var t = {}, r = Object.keys(n), i, s;
  for (s = 0; s < r.length; s++)
    i = r[s], !(e.indexOf(i) >= 0) && (t[i] = n[i]);
  return t;
}
function tk(n) {
  var e = n.country, t = n.countryName, r = n.flags, i = n.flagUrl, s = $Le(n, LLe);
  return r && r[e] ? r[e]({
    title: t
  }) : /* @__PURE__ */ p.createElement("img", GT({}, s, {
    alt: t,
    role: t ? void 0 : "presentation",
    src: i.replace("{XX}", e).replace("{xx}", e.toLowerCase())
  }));
}
tk.propTypes = {
  // The country to be selected by default.
  // Two-letter country code ("ISO 3166-1 alpha-2").
  country: pe.string.isRequired,
  // Will be HTML `title` attribute of the `<img/>`.
  countryName: pe.string.isRequired,
  // Country flag icon components.
  // By default flag icons are inserted as `<img/>`s
  // with their `src` pointed to `country-flag-icons` gitlab pages website.
  // There might be cases (e.g. an offline application)
  // where having a large (3 megabyte) `<svg/>` flags
  // bundle is more appropriate.
  // `import flags from 'react-phone-number-input/flags'`.
  flags: pe.objectOf(pe.elementType),
  // A URL for a country flag icon.
  // By default it points to `country-flag-icons` gitlab pages website.
  flagUrl: pe.string.isRequired
};
var BLe = ["aspectRatio"], zLe = ["title"], HLe = ["title"];
function Ey() {
  return Ey = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, Ey.apply(this, arguments);
}
function nk(n, e) {
  if (n == null) return {};
  var t = ULe(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function ULe(n, e) {
  if (n == null) return {};
  var t = {}, r = Object.keys(n), i, s;
  for (s = 0; s < r.length; s++)
    i = r[s], !(e.indexOf(i) >= 0) && (t[i] = n[i]);
  return t;
}
function n3(n) {
  var e = n.aspectRatio, t = nk(n, BLe);
  return e === 1 ? /* @__PURE__ */ p.createElement(FX, t) : /* @__PURE__ */ p.createElement($X, t);
}
n3.propTypes = {
  title: pe.string.isRequired,
  aspectRatio: pe.number
};
function $X(n) {
  var e = n.title, t = nk(n, zLe);
  return /* @__PURE__ */ p.createElement("svg", Ey({}, t, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 50"
  }), /* @__PURE__ */ p.createElement("title", null, e), /* @__PURE__ */ p.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeMiterlimit: "10"
  }, /* @__PURE__ */ p.createElement("path", {
    strokeLinecap: "round",
    d: "M47.2,36.1C48.1,36,49,36,50,36c7.4,0,14,1.7,18.5,4.3"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M68.6,9.6C64.2,12.3,57.5,14,50,14c-7.4,0-14-1.7-18.5-4.3"
  }), /* @__PURE__ */ p.createElement("line", {
    x1: "26",
    y1: "25",
    x2: "74",
    y2: "25"
  }), /* @__PURE__ */ p.createElement("line", {
    x1: "50",
    y1: "1",
    x2: "50",
    y2: "49"
  }), /* @__PURE__ */ p.createElement("path", {
    strokeLinecap: "round",
    d: "M46.3,48.7c1.2,0.2,2.5,0.3,3.7,0.3c13.3,0,24-10.7,24-24S63.3,1,50,1S26,11.7,26,25c0,2,0.3,3.9,0.7,5.8"
  }), /* @__PURE__ */ p.createElement("path", {
    strokeLinecap: "round",
    d: "M46.8,48.2c1,0.6,2.1,0.8,3.2,0.8c6.6,0,12-10.7,12-24S56.6,1,50,1S38,11.7,38,25c0,1.4,0.1,2.7,0.2,4c0,0.1,0,0.2,0,0.2"
  })), /* @__PURE__ */ p.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "none",
    fill: "currentColor",
    d: "M12.4,17.9c2.9-2.9,5.4-4.8,0.3-11.2S4.1,5.2,1.3,8.1C-2,11.4,1.1,23.5,13.1,35.6s24.3,15.2,27.5,11.9c2.8-2.8,7.8-6.3,1.4-11.5s-8.3-2.6-11.2,0.3c-2,2-7.2-2.2-11.7-6.7S10.4,19.9,12.4,17.9z"
  }));
}
$X.propTypes = {
  title: pe.string.isRequired
};
function FX(n) {
  var e = n.title, t = nk(n, HLe);
  return /* @__PURE__ */ p.createElement("svg", Ey({}, t, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }), /* @__PURE__ */ p.createElement("title", null, e), /* @__PURE__ */ p.createElement("g", {
    className: "PhoneInputInternationalIconGlobe",
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2",
    strokeLinecap: "round"
  }, /* @__PURE__ */ p.createElement("path", {
    d: "M8.45,13A21.44,21.44,0,1,1,37.08,41.56"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M19.36,35.47a36.9,36.9,0,0,1-2.28-13.24C17.08,10.39,21.88.85,27.8.85s10.72,9.54,10.72,21.38c0,6.48-1.44,12.28-3.71,16.21"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M17.41,33.4A39,39,0,0,1,27.8,32.06c6.62,0,12.55,1.5,16.48,3.86"
  }), /* @__PURE__ */ p.createElement("path", {
    d: "M44.29,8.53c-3.93,2.37-9.86,3.88-16.49,3.88S15.25,10.9,11.31,8.54"
  }), /* @__PURE__ */ p.createElement("line", {
    x1: "27.8",
    y1: "0.85",
    x2: "27.8",
    y2: "34.61"
  }), /* @__PURE__ */ p.createElement("line", {
    x1: "15.2",
    y1: "22.23",
    x2: "49.15",
    y2: "22.23"
  })), /* @__PURE__ */ p.createElement("path", {
    className: "PhoneInputInternationalIconPhone",
    stroke: "transparent",
    fill: "currentColor",
    d: "M9.42,26.64c2.22-2.22,4.15-3.59.22-8.49S3.08,17,.93,19.17c-2.49,2.48-.13,11.74,9,20.89s18.41,11.5,20.89,9c2.15-2.15,5.91-4.77,1-8.71s-6.27-2-8.49.22c-1.55,1.55-5.48-1.69-8.86-5.08S7.87,28.19,9.42,26.64Z"
  }));
}
FX.propTypes = {
  title: pe.string.isRequired
};
function VLe(n) {
  if (n.length < 2 || n[0] !== "+")
    return !1;
  for (var e = 1; e < n.length; ) {
    var t = n.charCodeAt(e);
    if (!(t >= 48 && t <= 57)) return !1;
    e++;
  }
  return !0;
}
function BX(n) {
  VLe(n) || console.error("[react-phone-number-input] Expected the initial `value` to be a E.164 phone number. Got", n);
}
function jLe(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t) return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = WLe(n)) || e) {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function WLe(n, e) {
  if (n) {
    if (typeof n == "string") return OB(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return OB(n, e);
  }
}
function OB(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function GLe(n, e) {
  if (!e)
    return n;
  for (var t = [], r = [], i = t, s = function() {
    var c = a.value;
    if (c === "|")
      i.push({
        divider: !0
      });
    else if (c === "..." || c === "…")
      i = r;
    else {
      var u;
      c === "🌐" ? u = void 0 : u = c;
      var d = n.indexOf(n.filter(function(h) {
        return h.value === u;
      })[0]), f = n[d];
      n.splice(d, 1), i.push(f);
    }
  }, o = jLe(e), a; !(a = o()).done; )
    s();
  return t.concat(n).concat(r);
}
function KLe(n, e) {
  if (n && (n = n.filter(function(t) {
    switch (t) {
      case "🌐":
      case "|":
      case "...":
      case "…":
        return !0;
      default:
        return r3(t, e);
    }
  }), n.length > 0))
    return n;
}
function r3(n, e) {
  return mX(n, e) ? !0 : (console.error("Country not found: ".concat(n)), !1);
}
function zX(n, e) {
  return n && (n = n.filter(function(t) {
    return r3(t, e);
  }), n.length === 0 && (n = void 0)), n;
}
var qLe = ["country", "label", "aspectRatio"];
function KT() {
  return KT = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, KT.apply(this, arguments);
}
function YLe(n, e) {
  if (n == null) return {};
  var t = XLe(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function XLe(n, e) {
  if (n == null) return {};
  var t = {}, r = Object.keys(n), i, s;
  for (s = 0; s < r.length; s++)
    i = r[s], !(e.indexOf(i) >= 0) && (t[i] = n[i]);
  return t;
}
function HX(n) {
  var e = n.flags, t = n.flagUrl, r = n.flagComponent, i = n.internationalIcon;
  function s(o) {
    var a = o.country, l = o.label, c = o.aspectRatio, u = YLe(o, qLe), d = i === n3 ? c : void 0;
    return /* @__PURE__ */ p.createElement("div", KT({}, u, {
      className: vy("PhoneInputCountryIcon", {
        "PhoneInputCountryIcon--square": d === 1,
        "PhoneInputCountryIcon--border": a
      })
    }), a ? /* @__PURE__ */ p.createElement(r, {
      country: a,
      countryName: l,
      flags: e,
      flagUrl: t,
      className: "PhoneInputCountryIconImg"
    }) : /* @__PURE__ */ p.createElement(i, {
      title: l,
      aspectRatio: d,
      className: "PhoneInputCountryIconImg"
    }));
  }
  return s.propTypes = {
    country: pe.string,
    label: pe.string.isRequired,
    aspectRatio: pe.number
  }, s;
}
HX({
  // Must be equal to `defaultProps.flagUrl` in `./PhoneInputWithCountry.js`.
  flagUrl: "https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg",
  flagComponent: tk,
  internationalIcon: n3
});
function ZLe(n, e) {
  var t = typeof Symbol < "u" && n[Symbol.iterator] || n["@@iterator"];
  if (t) return (t = t.call(n)).next.bind(t);
  if (Array.isArray(n) || (t = QLe(n)) || e) {
    t && (n = t);
    var r = 0;
    return function() {
      return r >= n.length ? { done: !0 } : { done: !1, value: n[r++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function QLe(n, e) {
  if (n) {
    if (typeof n == "string") return IB(n, e);
    var t = Object.prototype.toString.call(n).slice(8, -1);
    if (t === "Object" && n.constructor && (t = n.constructor.name), t === "Map" || t === "Set") return Array.from(n);
    if (t === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return IB(n, e);
  }
}
function IB(n, e) {
  (e == null || e > n.length) && (e = n.length);
  for (var t = 0, r = new Array(e); t < e; t++) r[t] = n[t];
  return r;
}
function JLe(n, e) {
  for (var t = ZLe(n), r; !(r = t()).done; ) {
    var i = r.value;
    i && e$e(i, e);
  }
}
function e$e(n, e) {
  typeof n == "function" ? n(e) : n.current = e;
}
var UX = pe.shape({
  country_calling_codes: pe.object.isRequired,
  countries: pe.object.isRequired
}), VX = pe.objectOf(pe.string);
function sl(n, e) {
  var t = "+" + xl(n, e);
  return t;
}
function t$e(n) {
  var e = n.value, t = n.phoneNumber, r = n.defaultCountry, i = n.getAnyCountry, s = n.countries, o = n.required, a = n.metadata, l;
  return t && t.country ? l = t.country : r && (!e || af(e, r, a)) && (l = r), s && s.indexOf(l) < 0 && (l = void 0), !l && o && s && s.length > 0 && (l = i()), l;
}
function n$e(n) {
  var e = n.countries, t = n.countryNames, r = n.addInternationalOption, i = n.compareStringsLocales, s = n.compareStrings;
  s || (s = c$e);
  var o = e.map(function(a) {
    return {
      value: a,
      // All `locale` country names included in this library
      // include all countries (this is checked at build time).
      // The only case when a country name might be missing
      // is when a developer supplies their own `labels` property.
      // To guard against such cases, a missing country name
      // is substituted by country code.
      label: t[a] || a
    };
  });
  return o.sort(function(a, l) {
    return s(a.label, l.label, i);
  }), r && o.unshift({
    label: t.ZZ
  }), o;
}
function jX(n, e) {
  return qDe(n || "", e);
}
function r$e(n) {
  return n.formatNational().replace(/\D/g, "");
}
function i$e(n, e) {
  var t = e.prevCountry, r = e.newCountry, i = e.metadata, s = e.useNationalFormat;
  if (t === r)
    return n;
  if (!n)
    return s ? "" : r ? sl(r, i) : "";
  if (r) {
    if (n[0] === "+") {
      if (s)
        return n.indexOf("+" + xl(r, i)) === 0 ? u$e(n, r, i) : "";
      if (t) {
        var o = sl(r, i);
        return n.indexOf(o) === 0 ? n : o;
      } else {
        var a = sl(r, i);
        return n.indexOf(a) === 0 ? n : a;
      }
    }
  } else if (n[0] !== "+")
    return Yd(n, t, i) || "";
  return n;
}
function Yd(n, e, t) {
  if (n) {
    if (n[0] === "+") {
      if (n === "+")
        return;
      var r = new Oh(e, t);
      return r.input(n), r.getNumberValue();
    }
    if (e) {
      var i = GX(n, e, t);
      return "+".concat(xl(e, t)).concat(i || "");
    }
  }
}
function s$e(n, e, t) {
  var r = GX(n, e, t);
  if (r) {
    var i = r.length - o$e(e, t);
    if (i > 0)
      return n.slice(0, n.length - i);
  }
  return n;
}
function o$e(n, e) {
  return e = new ur(e), e.selectNumberingPlan(n), e.numberingPlan.possibleLengths()[e.numberingPlan.possibleLengths().length - 1];
}
function WX(n, e) {
  var t = e.country, r = e.countries, i = e.defaultCountry, s = e.latestCountrySelectedByUser, o = e.required, a = e.metadata;
  if (n === "+")
    return t;
  var l = l$e(n, a);
  if (l)
    return !r || r.indexOf(l) >= 0 ? l : void 0;
  if (t) {
    if (af(n, t, a)) {
      if (s && af(n, s, a))
        return s;
      if (i && af(n, i, a))
        return i;
      if (!o)
        return;
    } else if (!o)
      return;
  }
  return t;
}
function a$e(n, e) {
  var t = e.prevPhoneDigits, r = e.country, i = e.defaultCountry, s = e.latestCountrySelectedByUser, o = e.countryRequired, a = e.getAnyCountry, l = e.countries, c = e.international, u = e.limitMaxLength, d = e.countryCallingCodeEditable, f = e.metadata;
  if (c && d === !1 && r) {
    var h = sl(r, f);
    if (n.indexOf(h) !== 0) {
      var m, g = n && n[0] !== "+";
      return g ? (n = h + n, m = Yd(n, r, f)) : n = h, {
        phoneDigits: n,
        value: m,
        country: r
      };
    }
  }
  c === !1 && r && n && n[0] === "+" && (n = RB(n, r, f)), n && r && u && (n = s$e(n, r, f)), n && n[0] !== "+" && (!r || c) && (n = "+" + n), !n && t && t[0] === "+" && (c ? r = void 0 : r = i), n === "+" && t && t[0] === "+" && t.length > 1 && (r = void 0);
  var v;
  return n && (n[0] === "+" && (n === "+" || r && sl(r, f).indexOf(n) === 0) ? v = void 0 : v = Yd(n, r, f)), v && (r = WX(v, {
    country: r,
    countries: l,
    defaultCountry: i,
    latestCountrySelectedByUser: s,
    // `countryRequired` flag is not passed here.
    // Instead, it's explicitly checked a bit later in the code.
    required: !1,
    metadata: f
  }), c === !1 && r && n && n[0] === "+" && (n = RB(n, r, f), v = Yd(n, r, f))), !r && o && (r = i || a()), {
    // `phoneDigits` returned here are a "normalized" version of the original `phoneDigits`.
    // The returned `phoneDigits` shouldn't be used anywhere except for passing it as
    // `prevPhoneDigits` parameter to this same function on next input change event.
    phoneDigits: n,
    country: r,
    value: v
  };
}
function RB(n, e, t) {
  if (n.indexOf(sl(e, t)) === 0) {
    var r = new Oh(e, t);
    r.input(n);
    var i = r.getNumber();
    return i ? i.formatNational().replace(/\D/g, "") : "";
  } else
    return n.replace(/\D/g, "");
}
function l$e(n, e) {
  var t = new Oh(null, e);
  return t.input(n), t.getCountry();
}
function c$e(n, e, t) {
  return String.prototype.localeCompare ? n.localeCompare(e, t) : n < e ? -1 : n > e ? 1 : 0;
}
function u$e(n, e, t) {
  if (e) {
    var r = "+" + xl(e, t);
    if (n.length < r.length) {
      if (r.indexOf(n) === 0)
        return "";
    } else if (n.indexOf(r) === 0)
      return n.slice(r.length);
  }
  for (var i = 0, s = Object.keys(t.country_calling_codes); i < s.length; i++) {
    var o = s[i];
    if (n.indexOf(o) === 1)
      return n.slice(1 + o.length);
  }
  return "";
}
function GX(n, e, t) {
  var r = new Oh(e, t);
  r.input(n);
  var i = r.getNumber();
  return i && i.nationalNumber;
}
function af(n, e, t) {
  for (var r = sl(e, t), i = 0; i < n.length && i < r.length; ) {
    if (n[i] !== r[i])
      return !1;
    i++;
  }
  return !0;
}
function KX(n) {
  var e = n.value, t = n.phoneNumber, r = n.defaultCountry, i = n.international, s = n.useNationalFormat, o = n.metadata;
  return (i === !1 || s) && t && t.country ? r$e(t) : !e && i && r ? sl(r, o) : e;
}
function d0(n) {
  "@babel/helpers - typeof";
  return d0 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, d0(n);
}
function PB(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function Eg(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? PB(Object(t), !0).forEach(function(r) {
      d$e(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : PB(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function d$e(n, e, t) {
  return e = f$e(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function f$e(n) {
  var e = h$e(n, "string");
  return d0(e) == "symbol" ? e : e + "";
}
function h$e(n, e) {
  if (d0(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (d0(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function p$e(n, e, t) {
  var r = n.metadata, i = n.countries, s = n.defaultCountry, o = n.value, a = n.reset, l = n.international, c = n.displayInitialValueAsLocalNumber, u = n.initialValueFormat, d = e.defaultCountry, f = e.value, h = e.reset;
  t.country;
  var m = t.value, g = t.hasUserSelectedACountry, v = t.latestCountrySelectedByUser, y = function(O) {
    return KX(Eg(Eg({}, O), {}, {
      international: l,
      useNationalFormat: c || u === "national",
      metadata: r
    }));
  };
  if (a !== h)
    return {
      phoneDigits: y({
        value: void 0,
        defaultCountry: s
      }),
      value: void 0,
      country: s,
      latestCountrySelectedByUser: void 0,
      hasUserSelectedACountry: void 0
    };
  if (s !== d) {
    var b = !s || r3(s, r), x = (
      // By default, "no value has been entered" means `value` is `undefined`.
      !m || // When `international` is `true`, and some country has been pre-selected,
      // then the `<input/>` contains a pre-filled value of `+${countryCallingCode}${leadingDigits}`,
      // so in case of `international` being `true`, "the user hasn't entered anything" situation
      // doesn't just mean `value` is `undefined`, but could also mean `value` is `+${countryCallingCode}`.
      l && m === y({
        value: void 0,
        defaultCountry: d
      })
    ), E = !o && x;
    if (!g && b && E)
      return {
        country: s,
        // If `phoneDigits` is empty, then automatically select the new `country`
        // and set `phoneDigits` to `+{getCountryCallingCode(newCountry)}`.
        // The code assumes that "no phone number has been entered by the user",
        // and no `value` property has been passed, so the `phoneNumber` parameter
        // of `_getInitialPhoneDigits({ value, phoneNumber, ... })` is `undefined`.
        phoneDigits: y({
          value: void 0,
          defaultCountry: s
        }),
        // `value` is `undefined` and it stays so.
        value: void 0
      };
  }
  if (!DB(o, f) && !DB(o, m)) {
    var w, C;
    if (o) {
      o && BX(o), w = jX(o, r);
      var S = zX(i, r);
      w && w.country ? (!S || S.indexOf(w.country) >= 0) && (C = w.country) : (C = WX(o, {
        country: void 0,
        countries: S,
        metadata: r
      }), C || s && o.indexOf(sl(s, r)) === 0 && (C = s));
    }
    var M;
    if (o) {
      if (v) {
        var k = C ? v === C : af(o, v, r);
        k ? C || (C = v) : M = {
          latestCountrySelectedByUser: void 0
        };
      }
    } else
      M = {
        latestCountrySelectedByUser: void 0,
        hasUserSelectedACountry: void 0
      };
    return Eg(Eg({}, M), {}, {
      phoneDigits: y({
        phoneNumber: w,
        value: o,
        defaultCountry: s
      }),
      value: o,
      country: o ? C : s
    });
  }
}
function DB(n, e) {
  return n === null && (n = void 0), e === null && (e = void 0), n === e;
}
var m$e = ["name", "disabled", "readOnly", "autoComplete", "style", "className", "inputRef", "inputComponent", "numberInputProps", "smartCaret", "countrySelectComponent", "countrySelectProps", "containerComponent", "containerComponentProps", "defaultCountry", "countries", "countryOptionsOrder", "labels", "flags", "flagComponent", "flagUrl", "addInternationalOption", "internationalIcon", "displayInitialValueAsLocalNumber", "initialValueFormat", "onCountryChange", "limitMaxLength", "countryCallingCodeEditable", "focusInputOnCountrySelection", "reset", "metadata", "international", "locales"];
function Kf(n) {
  "@babel/helpers - typeof";
  return Kf = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, Kf(n);
}
function NB(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function qX(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? NB(Object(t), !0).forEach(function(r) {
      eo(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : NB(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function lf() {
  return lf = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, lf.apply(this, arguments);
}
function g$e(n, e) {
  if (n == null) return {};
  var t = v$e(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function v$e(n, e) {
  if (n == null) return {};
  var t = {}, r = Object.keys(n), i, s;
  for (s = 0; s < r.length; s++)
    i = r[s], !(e.indexOf(i) >= 0) && (t[i] = n[i]);
  return t;
}
function y$e(n, e) {
  if (!(n instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function LB(n, e) {
  for (var t = 0; t < e.length; t++) {
    var r = e[t];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(n, XX(r.key), r);
  }
}
function b$e(n, e, t) {
  return e && LB(n.prototype, e), t && LB(n, t), Object.defineProperty(n, "prototype", { writable: !1 }), n;
}
function w$e(n, e, t) {
  return e = Sy(e), x$e(n, YX() ? Reflect.construct(e, t || [], Sy(n).constructor) : e.apply(n, t));
}
function x$e(n, e) {
  if (e && (Kf(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return E$e(n);
}
function E$e(n) {
  if (n === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return n;
}
function YX() {
  try {
    var n = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (YX = function() {
    return !!n;
  })();
}
function Sy(n) {
  return Sy = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, Sy(n);
}
function S$e(n, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  n.prototype = Object.create(e && e.prototype, { constructor: { value: n, writable: !0, configurable: !0 } }), Object.defineProperty(n, "prototype", { writable: !1 }), e && qT(n, e);
}
function qT(n, e) {
  return qT = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, qT(n, e);
}
function eo(n, e, t) {
  return e = XX(e), e in n ? Object.defineProperty(n, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : n[e] = t, n;
}
function XX(n) {
  var e = C$e(n, "string");
  return Kf(e) == "symbol" ? e : e + "";
}
function C$e(n, e) {
  if (Kf(n) != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (Kf(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
var T$e = /* @__PURE__ */ (function(n) {
  function e(t) {
    var r;
    y$e(this, e), r = w$e(this, e, [t]), eo(r, "setInputRef", function(v) {
      JLe([r.props.inputRef, r.inputRef], v);
    }), eo(r, "isCountrySupportedWithError", function(v) {
      var y = r.props.metadata;
      return r3(v, y);
    }), eo(r, "onCountryChange", function(v) {
      var y = r.props, b = y.international, x = y.metadata, E = y.onChange, w = y.focusInputOnCountrySelection, C = r.state, S = C.phoneDigits, M = C.country, k = i$e(S, {
        prevCountry: M,
        newCountry: v,
        metadata: x,
        // Convert the phone number to "national" format
        // when the user changes the selected country by hand.
        useNationalFormat: !b
      }), _ = Yd(k, v, x);
      w && r.inputRef.current.focus(), r.setState({
        country: v,
        latestCountrySelectedByUser: v,
        hasUserSelectedACountry: !0,
        phoneDigits: k,
        value: _
      }, function() {
        E(_);
      });
    }), eo(r, "onChange", function(v) {
      var y = r.props, b = y.defaultCountry, x = y.onChange, E = y.addInternationalOption, w = y.international, C = y.limitMaxLength, S = y.countryCallingCodeEditable, M = y.metadata, k = r.state, _ = k.countries, O = k.phoneDigits, I = k.country, R = k.latestCountrySelectedByUser, P = a$e(v, {
        prevPhoneDigits: O,
        country: I,
        countryRequired: !E,
        defaultCountry: b,
        latestCountrySelectedByUser: R,
        getAnyCountry: function() {
          return r.getFirstSupportedCountry({
            countries: _
          });
        },
        countries: _,
        international: w,
        limitMaxLength: C,
        countryCallingCodeEditable: S,
        metadata: M
      }), D = P.phoneDigits, L = P.country, B = P.value, $ = {
        phoneDigits: D,
        value: B,
        country: L
      };
      R && B && !af(B, R, M) && ($.latestCountrySelectedByUser = void 0), S === !1 && !B && D === r.state.phoneDigits && ($.forceRerender = {}), r.setState(
        $,
        // Update the new `value` property.
        // Doing it after the `state` has been updated
        // because `onChange()` will trigger `getDerivedStateFromProps()`
        // with the new `value` which will be compared to `state.value` there.
        function() {
          return x(B);
        }
      );
    }), eo(r, "_onFocus", function() {
      return r.setState({
        isFocused: !0
      });
    }), eo(r, "_onBlur", function() {
      return r.setState({
        isFocused: !1
      });
    }), eo(r, "onFocus", function(v) {
      r._onFocus();
      var y = r.props.onFocus;
      y && y(v);
    }), eo(r, "onBlur", function(v) {
      var y = r.props.onBlur;
      r._onBlur(), y && y(v);
    }), eo(r, "onCountryFocus", function(v) {
      r._onFocus();
      var y = r.props.countrySelectProps;
      if (y) {
        var b = y.onFocus;
        b && b(v);
      }
    }), eo(r, "onCountryBlur", function(v) {
      r._onBlur();
      var y = r.props.countrySelectProps;
      if (y) {
        var b = y.onBlur;
        b && b(v);
      }
    }), r.inputRef = /* @__PURE__ */ p.createRef();
    var i = r.props, s = i.value;
    i.labels;
    var o = i.international, a = i.addInternationalOption, l = i.displayInitialValueAsLocalNumber, c = i.initialValueFormat, u = i.metadata, d = r.props, f = d.defaultCountry, h = d.countries;
    f && (r.isCountrySupportedWithError(f) || (f = void 0)), s && BX(s), h = zX(h, u);
    var m = jX(s, u);
    r.CountryIcon = HX(r.props);
    var g = t$e({
      value: s,
      phoneNumber: m,
      defaultCountry: f,
      required: !a,
      countries: h || AB(u),
      getAnyCountry: function() {
        return r.getFirstSupportedCountry({
          countries: h
        });
      },
      metadata: u
    });
    return r.state = {
      // Workaround for `this.props` inside `getDerivedStateFromProps()`.
      props: r.props,
      // The country selected.
      country: g,
      // `countries` are stored in `this.state` because they're filtered.
      // For example, a developer might theoretically pass some unsupported
      // countries as part of the `countries` property, and because of that
      // the component uses `this.state.countries` (which are filtered)
      // instead of `this.props.countries`
      // (which could potentially contain unsupported countries).
      countries: h,
      // `phoneDigits` state property holds non-formatted user's input.
      // The reason is that there's no way of finding out
      // in which form should `value` be displayed: international or national.
      // E.g. if `value` is `+78005553535` then it could be input
      // by a user both as `8 (800) 555-35-35` and `+7 800 555 35 35`.
      // Hence storing just `value` is not sufficient for correct formatting.
      // E.g. if a user entered `8 (800) 555-35-35`
      // then value is `+78005553535` and `phoneDigits` are `88005553535`
      // and if a user entered `+7 800 555 35 35`
      // then value is `+78005553535` and `phoneDigits` are `+78005553535`.
      phoneDigits: KX({
        value: s,
        phoneNumber: m,
        defaultCountry: f,
        international: o,
        useNationalFormat: l || c === "national",
        metadata: u
      }),
      // `value` property is duplicated in state.
      // The reason is that `getDerivedStateFromProps()`
      // needs this `value` to compare to the new `value` property
      // to find out if `phoneDigits` needs updating:
      // If the `value` property was changed externally
      // then it won't be equal to `state.value`
      // in which case `phoneDigits` and `country` should be updated.
      value: s
    }, r;
  }
  return S$e(e, n), b$e(e, [{
    key: "componentDidMount",
    value: function() {
      var r = this.props.onCountryChange, i = this.props.defaultCountry, s = this.state.country;
      r && (i && (this.isCountrySupportedWithError(i) || (i = void 0)), s !== i && r(s));
    }
  }, {
    key: "componentDidUpdate",
    value: function(r, i) {
      var s = this.props.onCountryChange, o = this.state.country;
      s && o !== i.country && s(o);
    }
  }, {
    key: "getCountrySelectOptions",
    value: function(r) {
      var i = r.countries, s = this.props, o = s.international, a = s.countryCallingCodeEditable, l = s.countryOptionsOrder, c = s.addInternationalOption, u = s.labels, d = s.locales, f = s.metadata;
      return this.useMemoCountrySelectOptions(function() {
        return GLe(n$e({
          countries: i || AB(f),
          countryNames: u,
          addInternationalOption: o && a === !1 ? !1 : c,
          compareStringsLocales: d
          // compareStrings
        }), KLe(l, f));
      }, [i, l, c, u, f]);
    }
  }, {
    key: "useMemoCountrySelectOptions",
    value: function(r, i) {
      return (!this.countrySelectOptionsMemoDependencies || !M$e(i, this.countrySelectOptionsMemoDependencies)) && (this.countrySelectOptionsMemo = r(), this.countrySelectOptionsMemoDependencies = i), this.countrySelectOptionsMemo;
    }
  }, {
    key: "getFirstSupportedCountry",
    value: function(r) {
      var i = r.countries, s = this.getCountrySelectOptions({
        countries: i
      });
      return s[0].value;
    }
  }, {
    key: "render",
    value: function() {
      var r = this.props, i = r.name, s = r.disabled, o = r.readOnly, a = r.autoComplete, l = r.style, c = r.className;
      r.inputRef;
      var u = r.inputComponent, d = r.numberInputProps, f = r.smartCaret, h = r.countrySelectComponent, m = r.countrySelectProps, g = r.containerComponent, v = r.containerComponentProps;
      r.defaultCountry, r.countries, r.countryOptionsOrder;
      var y = r.labels;
      r.flags, r.flagComponent, r.flagUrl, r.addInternationalOption, r.internationalIcon, r.displayInitialValueAsLocalNumber, r.initialValueFormat, r.onCountryChange, r.limitMaxLength, r.countryCallingCodeEditable, r.focusInputOnCountrySelection, r.reset;
      var b = r.metadata, x = r.international;
      r.locales;
      var E = g$e(r, m$e), w = this.state, C = w.country, S = w.countries, M = w.phoneDigits, k = w.isFocused, _ = f ? xLe : ALe, O = this.getCountrySelectOptions({
        countries: S
      });
      return /* @__PURE__ */ p.createElement(g, lf({
        style: l,
        className: vy(c, "PhoneInput", {
          "PhoneInput--focus": k,
          "PhoneInput--disabled": s,
          "PhoneInput--readOnly": o
        })
      }, v), /* @__PURE__ */ p.createElement(h, lf({
        name: i ? "".concat(i, "Country") : void 0,
        "aria-label": y.country
      }, m, {
        value: C,
        options: O,
        onChange: this.onCountryChange,
        onFocus: this.onCountryFocus,
        onBlur: this.onCountryBlur,
        disabled: s || m && m.disabled,
        readOnly: o || m && m.readOnly,
        iconComponent: this.CountryIcon
      })), /* @__PURE__ */ p.createElement(_, lf({
        ref: this.setInputRef,
        type: "tel",
        autoComplete: a
      }, d, E, {
        inputFormat: x === !0 ? "INTERNATIONAL" : x === !1 ? "NATIONAL" : "INTERNATIONAL_OR_NATIONAL",
        international: x ? !0 : void 0,
        withCountryCallingCode: x ? !0 : void 0,
        name: i,
        metadata: b,
        country: C,
        value: M || "",
        onChange: this.onChange,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        disabled: s,
        readOnly: o,
        inputComponent: u,
        className: vy("PhoneInputInput", d && d.className, E.className)
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: (
      // `state` holds previous props as `props`, and also:
      // * `country` — The currently selected country, e.g. `"RU"`.
      // * `value` — The currently entered phone number (E.164), e.g. `+78005553535`.
      // * `phoneDigits` — The parsed `<input/>` value, e.g. `8005553535`.
      // (and a couple of other less significant properties)
      function(r, i) {
        return qX({
          // Emulate `prevProps` via `state.props`.
          props: r
        }, p$e(r, i.props, i));
      }
    )
  }]);
})(p.PureComponent), ZX = /* @__PURE__ */ p.forwardRef(function(n, e) {
  return /* @__PURE__ */ p.createElement(T$e, lf({}, A$e(n), {
    inputRef: e
  }));
});
ZX.propTypes = {
  /**
   * Phone number in `E.164` format.
   *
   * Example:
   *
   * `"+12223333333"`
   *
   * Any "falsy" value like `undefined`, `null` or an empty string `""` is treated like "empty".
   */
  value: pe.string,
  /**
   * A function of `value: string?`.
   *
   * Updates the `value` property as the user inputs a phone number.
   *
   * If the user erases the input value, the argument is `undefined`.
   */
  onChange: pe.func.isRequired,
  /**
   * Toggles the `--focus` CSS class.
   * @ignore
   */
  onFocus: pe.func,
  /**
   * `onBlur` is usually passed by `redux-form`.
   * @ignore
   */
  onBlur: pe.func,
  /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `disabled`.
   */
  disabled: pe.bool,
  /**
   * Set to `true` to mark both the phone number `<input/>`
   * and the country `<select/>` as `readonly`.
   */
  readOnly: pe.bool,
  /**
   * Sets `autoComplete` property for phone number `<input/>`.
   *
   * Web browser's "autocomplete" feature
   * remembers the phone number being input
   * and can also autofill the `<input/>`
   * with previously remembered phone numbers.
   *
   * https://developers.google.com
   * /web/updates/2015/06/checkout-faster-with-autofill
   *
   * For example, can be used to turn it off:
   *
   * "So when should you use `autocomplete="off"`?
   *  One example is when you've implemented your own version
   *  of autocomplete for search. Another example is any form field
   *  where users will input and submit different kinds of information
   *  where it would not be useful to have the browser remember
   *  what was submitted previously".
   */
  // (is `"tel"` by default)
  autoComplete: pe.string,
  /**
   * Set to `"national"` to show the initial `value` in
   * "national" format rather than "international".
   *
   * For example, if `initialValueFormat` is `"national"`
   * and the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"(213) 373-4253"`.
   *
   * By default, `initialValueFormat` is `undefined`,
   * meaning that if the initial `value="+12133734253"` is passed
   * then the `<input/>` value will be `"+1 213 373 4253"`.
   *
   * The reason for such default behaviour is that
   * the newer generation grows up when there are no stationary phones
   * and therefore everyone inputs phone numbers in international format
   * in their smartphones so people gradually get more accustomed to
   * writing phone numbers in international format rather than in local format.
   * Future people won't be using "national" format, only "international".
   */
  // (is `undefined` by default)
  initialValueFormat: pe.oneOf(["national"]),
  // `displayInitialValueAsLocalNumber` property has been
  // superceded by `initialValueFormat` property.
  displayInitialValueAsLocalNumber: pe.bool,
  /**
   * The country to be selected by default.
   * For example, can be set after a GeoIP lookup.
   *
   * Example: `"US"`.
   */
  // A two-letter country code ("ISO 3166-1 alpha-2").
  defaultCountry: pe.string,
  /**
   * If specified, only these countries will be available for selection.
   *
   * Example:
   *
   * `["RU", "UA", "KZ"]`
   */
  countries: pe.arrayOf(pe.string),
  /**
   * Custom country `<select/>` option names.
   * Also some labels like "ext" and country `<select/>` `aria-label`.
   *
   * Example:
   *
   * `{ "ZZ": "Международный", RU: "Россия", US: "США", ... }`
   *
   * See the `locales` directory for examples.
   */
  labels: VX,
  /**
   * Country `<select/>` options are sorted by their labels.
   * The default sorting function uses `a.localeCompare(b, locales)`,
   * and, if that's not available, falls back to simple `a > b` / `a < b`.
   * Some languages, like Chinese, support multiple sorting variants
   * (called "collations"), and the user might prefer one or another.
   * Also, sometimes the Operating System language is not always
   * the preferred language for a person using a website or an application,
   * so there should be a way to specify custom locale.
   * This `locales` property mimicks the `locales` argument of `Intl` constructors,
   * and can be either a Unicode BCP 47 locale identifier or an array of such locale identifiers.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl#locales_argument
   */
  locales: pe.oneOfType([pe.string, pe.arrayOf(pe.string)]),
  /*
   * Custom country `<select/>` options sorting function.
   * The default one uses `a.localeCompare(b)`, and,
   * if that's not available, falls back to simple `a > b`/`a < b`.
   * There have been requests to add custom sorter for cases
   * like Chinese language and "pinyin" (non-default) sorting order.
   * https://stackoverflow.com/questions/22907288/chinese-sorting-by-pinyin-in-javascript-with-localecompare
  compareStrings: PropTypes.func,
   */
  /**
   * A URL template of a country flag, where
   * "{XX}" is a two-letter country code in upper case,
   * or where "{xx}" is a two-letter country code in lower case.
   * By default it points to `country-flag-icons` gitlab pages website.
   * I imagine someone might want to download those country flag icons
   * and host them on their own servers instead
   * (all flags are available in the `country-flag-icons` library).
   * There's a catch though: new countries may be added in future,
   * so when hosting country flag icons on your own server
   * one should check the `CHANGELOG.md` every time before updating this library,
   * otherwise there's a possibility that some new country flag would be missing.
   */
  flagUrl: pe.string,
  /**
   * Custom country flag icon components.
   * These flags will be used instead of the default ones.
   * The the "Flags" section of the readme for more info.
   *
   * The shape is an object where keys are country codes
   * and values are flag icon components.
   * Flag icon components receive the same properties
   * as `flagComponent` (see below).
   *
   * Example:
   *
   * `{ "RU": (props) => <img src="..."/> }`
   *
   * Example:
   *
   * `import flags from 'country-flag-icons/react/3x2'`
   *
   * `import PhoneInput from 'react-phone-number-input'`
   *
   * `<PhoneInput flags={flags} .../>`
   */
  flags: pe.objectOf(pe.elementType),
  /**
   * Country flag icon component.
   *
   * Takes properties:
   *
   * * `country: string` — The country code.
   * * `countryName: string` — The country name.
   * * `flagUrl: string` — The `flagUrl` property (see above).
   * * `flags: object` — The `flags` property (see above).
   */
  flagComponent: pe.elementType,
  /**
   * Set to `false` to remove the "International" option from country `<select/>`.
   */
  addInternationalOption: pe.bool,
  /**
   * "International" icon component.
   * Should have the same aspect ratio.
   *
   * Receives properties:
   *
   * * `title: string` — "International" country option label.
   */
  internationalIcon: pe.elementType,
  /**
   * Can be used to place some countries on top of the list of country `<select/>` options.
   *
   * * `"XX"` — inserts an option for "XX" country.
   * * `"🌐"` — inserts "International" option.
   * * `"|"` — inserts a separator.
   * * `"..."` — inserts options for the rest of the countries (can be omitted, in which case it will be automatically added at the end).
   *
   * Example:
   *
   * `["US", "CA", "AU", "|", "..."]`
   */
  countryOptionsOrder: pe.arrayOf(pe.string),
  /**
   * `<Phone/>` component CSS style object.
   */
  style: pe.object,
  /**
   * `<Phone/>` component CSS class.
   */
  className: pe.string,
  /**
   * Country `<select/>` component.
   *
   * Receives properties:
   *
   * * `name: string?` — HTML `name` attribute.
   * * `value: string?` — The currently selected country code.
   * * `onChange(value: string?)` — Updates the `value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * `options: object[]` — The list of all selectable countries (including "International") each being an object of shape `{ value: string?, label: string }`.
   * * `iconComponent: PropTypes.elementType` — React component that renders a country icon: `<Icon country={value}/>`. If `country` is `undefined` then it renders an "International" icon.
   * * `disabled: boolean?` — HTML `disabled` attribute.
   * * `readOnly: boolean?` — HTML `readOnly` attribute.
   * * `tabIndex: (number|string)?` — HTML `tabIndex` attribute.
   * * `className: string` — CSS class name.
   */
  countrySelectComponent: pe.elementType,
  /**
   * Country `<select/>` component props.
   * Along with the usual DOM properties such as `aria-label` and `tabIndex`,
   * some custom properties are supported, such as `arrowComponent` and `unicodeFlags`.
   */
  countrySelectProps: pe.object,
  /**
   * Phone number `<input/>` component.
   *
   * Receives properties:
   *
   * * `value: string` — The formatted `value`.
   * * `onChange(event: Event)` — Updates the formatted `value` from `event.target.value`.
   * * `onFocus()` — Is used to toggle the `--focus` CSS class.
   * * `onBlur()` — Is used to toggle the `--focus` CSS class.
   * * Other properties like `type="tel"` or `autoComplete="tel"` that should be passed through to the DOM `<input/>`.
   *
   * Must also either use `React.forwardRef()` to "forward" `ref` to the `<input/>` or implement `.focus()` method.
   */
  inputComponent: pe.elementType,
  /**
   * Phone number `<input/>` component props.
   */
  numberInputProps: pe.object,
  /**
   * Wrapping `<div/>` component.
   *
   * Receives properties:
   *
   * * `style: object` — A component CSS style object.
   * * `className: string` — Classes to attach to the component, typically changes when component focuses or blurs.
   */
  containerComponent: pe.elementType,
  /**
   * Wrapping `<div/>` component props.
   */
  containerComponentProps: pe.object,
  /**
   * When the user attempts to insert a digit somewhere in the middle of a phone number,
   * the caret position is moved right before the next available digit skipping
   * any punctuation in between. This is called "smart" caret positioning.
   * Another case would be the phone number format changing as a result of
   * the user inserting the digit somewhere in the middle, which would require
   * re-positioning the caret because all digit positions have changed.
   * This "smart" caret positioning feature can be turned off by passing
   * `smartCaret={false}` property: use it in case of any possible issues
   * with caret position during phone number input.
   */
  // Is `true` by default.
  smartCaret: pe.bool,
  /**
   * Set to `true` to force "international" phone number format.
   * Set to `false` to force "national" phone number format.
   * By default it's `undefined` meaning that it doesn't enforce any phone number format:
   * the user can input their phone number in either "national" or "international" format.
   */
  international: pe.bool,
  /**
   * If set to `true`, the phone number input will get trimmed
   * if it exceeds the maximum length for the country.
   */
  limitMaxLength: pe.bool,
  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: pe.bool,
  /**
   * `libphonenumber-js` metadata.
   *
   * Can be used to pass custom `libphonenumber-js` metadata
   * to reduce the overall bundle size for those who compile "custom" metadata.
   */
  metadata: UX,
  /**
   * Is called every time the selected country changes:
   * either programmatically or when user selects it manually from the list.
   */
  // People have been asking for a way to get the selected country.
  // @see  https://github.com/catamphetamine/react-phone-number-input/issues/128
  // For some it's just a "business requirement".
  // I guess it's about gathering as much info on the user as a website can
  // without introducing any addional fields that would complicate the form
  // therefore reducing "conversion" (that's a marketing term).
  // Assuming that the phone number's country is the user's country
  // is not 100% correct but in most cases I guess it's valid.
  onCountryChange: pe.func,
  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: pe.bool
};
var $B = {
  /**
   * Remember (and autofill) the value as a phone number.
   */
  autoComplete: "tel",
  /**
   * Country `<select/>` component.
   */
  countrySelectComponent: NX,
  /**
   * Flag icon component.
   */
  flagComponent: tk,
  /**
   * By default, uses icons from `country-flag-icons` gitlab pages website.
   */
  // Must be equal to `flagUrl` in `./CountryIcon.js`.
  flagUrl: "https://purecatamphetamine.github.io/country-flag-icons/3x2/{XX}.svg",
  /**
   * Default "International" country `<select/>` option icon.
   */
  internationalIcon: n3,
  /**
   * Phone number `<input/>` component.
   */
  inputComponent: "input",
  /**
   * Wrapping `<div/>` component.
   */
  containerComponent: "div",
  /**
   * Some users requested a way to reset the component:
   * both number `<input/>` and country `<select/>`.
   * Whenever `reset` property changes both number `<input/>`
   * and country `<select/>` are reset.
   * It's not implemented as some instance `.reset()` method
   * because `ref` is forwarded to `<input/>`.
   * It's also not replaced with just resetting `country` on
   * external `value` reset, because a user could select a country
   * and then not input any `value`, and so the selected country
   * would be "stuck", if not using this `reset` property.
   */
  // https://github.com/catamphetamine/react-phone-number-input/issues/300
  reset: pe.any,
  /**
   *
   */
  /**
   * Set to `false` to use "basic" caret instead of the "smart" one.
   */
  smartCaret: !0,
  /**
   * Whether to add the "International" option
   * to the list of countries.
   */
  addInternationalOption: !0,
  /**
   * If set to `false`, and `international` is `true`, then
   * users won't be able to erase the "country calling part"
   * of a phone number in the `<input/>`.
   */
  countryCallingCodeEditable: !0,
  /**
   * If set to `false`, will not focus the `<input/>` component
   * when the user selects a country from the list of countries.
   * This can be used to conform to the Web Content Accessibility Guidelines (WCAG).
   * Quote:
   * "On input: Changing the setting of any user interface component
   *  does not automatically cause a change of context unless the user
   *  has been advised of the behaviour before using the component."
   */
  focusInputOnCountrySelection: !0
};
function A$e(n) {
  n = qX({}, n);
  for (var e in $B)
    n[e] === void 0 && (n[e] = $B[e]);
  return n;
}
function M$e(n, e) {
  if (n.length !== e.length)
    return !1;
  for (var t = 0; t < n.length; ) {
    if (n[t] !== e[t])
      return !1;
    t++;
  }
  return !0;
}
const k$e = {
  ext: "ext.",
  country: "Phone number country",
  phone: "Phone",
  AB: "Abkhazia",
  AC: "Ascension Island",
  AD: "Andorra",
  AE: "United Arab Emirates",
  AF: "Afghanistan",
  AG: "Antigua and Barbuda",
  AI: "Anguilla",
  AL: "Albania",
  AM: "Armenia",
  AO: "Angola",
  AQ: "Antarctica",
  AR: "Argentina",
  AS: "American Samoa",
  AT: "Austria",
  AU: "Australia",
  AW: "Aruba",
  AX: "Åland Islands",
  AZ: "Azerbaijan",
  BA: "Bosnia and Herzegovina",
  BB: "Barbados",
  BD: "Bangladesh",
  BE: "Belgium",
  BF: "Burkina Faso",
  BG: "Bulgaria",
  BH: "Bahrain",
  BI: "Burundi",
  BJ: "Benin",
  BL: "Saint Barthélemy",
  BM: "Bermuda",
  BN: "Brunei Darussalam",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BR: "Brazil",
  BS: "Bahamas",
  BT: "Bhutan",
  BV: "Bouvet Island",
  BW: "Botswana",
  BY: "Belarus",
  BZ: "Belize",
  CA: "Canada",
  CC: "Cocos (Keeling) Islands",
  CD: "Congo, Democratic Republic of the",
  CF: "Central African Republic",
  CG: "Congo",
  CH: "Switzerland",
  CI: "Cote d'Ivoire",
  CK: "Cook Islands",
  CL: "Chile",
  CM: "Cameroon",
  CN: "China",
  CO: "Colombia",
  CR: "Costa Rica",
  CU: "Cuba",
  CV: "Cape Verde",
  CW: "Curaçao",
  CX: "Christmas Island",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DE: "Germany",
  DJ: "Djibouti",
  DK: "Denmark",
  DM: "Dominica",
  DO: "Dominican Republic",
  DZ: "Algeria",
  EC: "Ecuador",
  EE: "Estonia",
  EG: "Egypt",
  EH: "Western Sahara",
  ER: "Eritrea",
  ES: "Spain",
  ET: "Ethiopia",
  FI: "Finland",
  FJ: "Fiji",
  FK: "Falkland Islands",
  FM: "Federated States of Micronesia",
  FO: "Faroe Islands",
  FR: "France",
  GA: "Gabon",
  GB: "United Kingdom",
  GD: "Grenada",
  GE: "Georgia",
  GF: "French Guiana",
  GG: "Guernsey",
  GH: "Ghana",
  GI: "Gibraltar",
  GL: "Greenland",
  GM: "Gambia",
  GN: "Guinea",
  GP: "Guadeloupe",
  GQ: "Equatorial Guinea",
  GR: "Greece",
  GS: "South Georgia and the South Sandwich Islands",
  GT: "Guatemala",
  GU: "Guam",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HK: "Hong Kong",
  HM: "Heard Island and McDonald Islands",
  HN: "Honduras",
  HR: "Croatia",
  HT: "Haiti",
  HU: "Hungary",
  ID: "Indonesia",
  IE: "Ireland",
  IL: "Israel",
  IM: "Isle of Man",
  IN: "India",
  IO: "British Indian Ocean Territory",
  IQ: "Iraq",
  IR: "Iran",
  IS: "Iceland",
  IT: "Italy",
  JE: "Jersey",
  JM: "Jamaica",
  JO: "Jordan",
  JP: "Japan",
  KE: "Kenya",
  KG: "Kyrgyzstan",
  KH: "Cambodia",
  KI: "Kiribati",
  KM: "Comoros",
  KN: "Saint Kitts and Nevis",
  KP: "North Korea",
  KR: "South Korea",
  KW: "Kuwait",
  KY: "Cayman Islands",
  KZ: "Kazakhstan",
  LA: "Laos",
  LB: "Lebanon",
  LC: "Saint Lucia",
  LI: "Liechtenstein",
  LK: "Sri Lanka",
  LR: "Liberia",
  LS: "Lesotho",
  LT: "Lithuania",
  LU: "Luxembourg",
  LV: "Latvia",
  LY: "Libya",
  MA: "Morocco",
  MC: "Monaco",
  MD: "Moldova",
  ME: "Montenegro",
  MF: "Saint Martin (French Part)",
  MG: "Madagascar",
  MH: "Marshall Islands",
  MK: "North Macedonia",
  ML: "Mali",
  MM: "Myanmar",
  MN: "Mongolia",
  MO: "Macao",
  MP: "Northern Mariana Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MS: "Montserrat",
  MT: "Malta",
  MU: "Mauritius",
  MV: "Maldives",
  MW: "Malawi",
  MX: "Mexico",
  MY: "Malaysia",
  MZ: "Mozambique",
  NA: "Namibia",
  NC: "New Caledonia",
  NE: "Niger",
  NF: "Norfolk Island",
  NG: "Nigeria",
  NI: "Nicaragua",
  NL: "Netherlands",
  NO: "Norway",
  NP: "Nepal",
  NR: "Nauru",
  NU: "Niue",
  NZ: "New Zealand",
  OM: "Oman",
  OS: "South Ossetia",
  PA: "Panama",
  PE: "Peru",
  PF: "French Polynesia",
  PG: "Papua New Guinea",
  PH: "Philippines",
  PK: "Pakistan",
  PL: "Poland",
  PM: "Saint Pierre and Miquelon",
  PN: "Pitcairn",
  PR: "Puerto Rico",
  PS: "Palestine",
  PT: "Portugal",
  PW: "Palau",
  PY: "Paraguay",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RS: "Serbia",
  RU: "Russia",
  RW: "Rwanda",
  SA: "Saudi Arabia",
  SB: "Solomon Islands",
  SC: "Seychelles",
  SD: "Sudan",
  SE: "Sweden",
  SG: "Singapore",
  SH: "Saint Helena",
  SI: "Slovenia",
  SJ: "Svalbard and Jan Mayen",
  SK: "Slovakia",
  SL: "Sierra Leone",
  SM: "San Marino",
  SN: "Senegal",
  SO: "Somalia",
  SR: "Suriname",
  SS: "South Sudan",
  ST: "Sao Tome and Principe",
  SV: "El Salvador",
  SX: "Sint Maarten",
  SY: "Syria",
  SZ: "Swaziland",
  TA: "Tristan da Cunha",
  TC: "Turks and Caicos Islands",
  TD: "Chad",
  TF: "French Southern Territories",
  TG: "Togo",
  TH: "Thailand",
  TJ: "Tajikistan",
  TK: "Tokelau",
  TL: "Timor-Leste",
  TM: "Turkmenistan",
  TN: "Tunisia",
  TO: "Tonga",
  TR: "Turkey",
  TT: "Trinidad and Tobago",
  TV: "Tuvalu",
  TW: "Taiwan",
  TZ: "Tanzania",
  UA: "Ukraine",
  UG: "Uganda",
  UM: "United States Minor Outlying Islands",
  US: "United States",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VA: "Holy See (Vatican City State)",
  VC: "Saint Vincent and the Grenadines",
  VE: "Venezuela",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.S.",
  VN: "Vietnam",
  VU: "Vanuatu",
  WF: "Wallis and Futuna",
  WS: "Samoa",
  XK: "Kosovo",
  YE: "Yemen",
  YT: "Mayotte",
  ZA: "South Africa",
  ZM: "Zambia",
  ZW: "Zimbabwe",
  ZZ: "International"
};
var _$e = ["metadata", "labels"];
function YT() {
  return YT = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t)
        Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, YT.apply(this, arguments);
}
function O$e(n, e) {
  if (n == null) return {};
  var t = I$e(n, e), r, i;
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(n);
    for (i = 0; i < s.length; i++)
      r = s[i], !(e.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(n, r) && (t[r] = n[r]);
  }
  return t;
}
function I$e(n, e) {
  if (n == null) return {};
  var t = {}, r = Object.keys(n), i, s;
  for (s = 0; s < r.length; s++)
    i = r[s], !(e.indexOf(i) >= 0) && (t[i] = n[i]);
  return t;
}
function QX(n) {
  var e = /* @__PURE__ */ p.forwardRef(function(t, r) {
    var i = t.metadata, s = i === void 0 ? n : i, o = t.labels, a = o === void 0 ? k$e : o, l = O$e(t, _$e);
    return /* @__PURE__ */ p.createElement(ZX, YT({}, l, {
      ref: r,
      metadata: s,
      labels: a
    }));
  });
  return e.propTypes = {
    metadata: UX,
    labels: VX
  }, e;
}
QX();
function R$e(n, e) {
  var t = Array.prototype.slice.call(e);
  return t.push(fX), n.apply(this, t);
}
const P$e = QX(fX);
function D$e() {
  return R$e(xl, arguments);
}
var FB = 1, N$e = 0.9, L$e = 0.8, $$e = 0.17, n6 = 0.1, r6 = 0.999, F$e = 0.9999, B$e = 0.99, z$e = /[\\\/_+.#"@\[\(\{&]/, H$e = /[\\\/_+.#"@\[\(\{&]/g, U$e = /[\s-]/, JX = /[\s-]/g;
function XT(n, e, t, r, i, s, o) {
  if (s === e.length) return i === n.length ? FB : B$e;
  var a = `${i},${s}`;
  if (o[a] !== void 0) return o[a];
  for (var l = r.charAt(s), c = t.indexOf(l, i), u = 0, d, f, h, m; c >= 0; ) d = XT(n, e, t, r, c + 1, s + 1, o), d > u && (c === i ? d *= FB : z$e.test(n.charAt(c - 1)) ? (d *= L$e, h = n.slice(i, c - 1).match(H$e), h && i > 0 && (d *= Math.pow(r6, h.length))) : U$e.test(n.charAt(c - 1)) ? (d *= N$e, m = n.slice(i, c - 1).match(JX), m && i > 0 && (d *= Math.pow(r6, m.length))) : (d *= $$e, i > 0 && (d *= Math.pow(r6, c - i))), n.charAt(c) !== e.charAt(s) && (d *= F$e)), (d < n6 && t.charAt(c - 1) === r.charAt(s + 1) || r.charAt(s + 1) === r.charAt(s) && t.charAt(c - 1) !== r.charAt(s)) && (f = XT(n, e, t, r, c + 1, s + 2, o), f * n6 > d && (d = f * n6)), d > u && (u = d), c = t.indexOf(l, c + 1);
  return o[a] = u, u;
}
function BB(n) {
  return n.toLowerCase().replace(JX, " ");
}
function V$e(n, e, t) {
  return n = t && t.length > 0 ? `${n + " " + t.join(" ")}` : n, XT(n, e, BB(n), BB(e), 0, 0, {});
}
function Ce(n, e, { checkForDefaultPrevented: t = !0 } = {}) {
  return function(i) {
    if (n?.(i), t === !1 || !i.defaultPrevented)
      return e?.(i);
  };
}
function j$e(n, e) {
  const t = A.createContext(e), r = (s) => {
    const { children: o, ...a } = s, l = A.useMemo(() => a, Object.values(a));
    return /* @__PURE__ */ T(t.Provider, { value: l, children: o });
  };
  r.displayName = n + "Provider";
  function i(s) {
    const o = A.useContext(t);
    if (o) return o;
    if (e !== void 0) return e;
    throw new Error(`\`${s}\` must be used within \`${n}\``);
  }
  return [r, i];
}
function qr(n, e = []) {
  let t = [];
  function r(s, o) {
    const a = A.createContext(o), l = t.length;
    t = [...t, o];
    const c = (d) => {
      const { scope: f, children: h, ...m } = d, g = f?.[n]?.[l] || a, v = A.useMemo(() => m, Object.values(m));
      return /* @__PURE__ */ T(g.Provider, { value: v, children: h });
    };
    c.displayName = s + "Provider";
    function u(d, f) {
      const h = f?.[n]?.[l] || a, m = A.useContext(h);
      if (m) return m;
      if (o !== void 0) return o;
      throw new Error(`\`${d}\` must be used within \`${s}\``);
    }
    return [c, u];
  }
  const i = () => {
    const s = t.map((o) => A.createContext(o));
    return function(a) {
      const l = a?.[n] || s;
      return A.useMemo(
        () => ({ [`__scope${n}`]: { ...a, [n]: l } }),
        [a, l]
      );
    };
  };
  return i.scopeName = n, [r, W$e(i, ...e)];
}
function W$e(...n) {
  const e = n[0];
  if (n.length === 1) return e;
  const t = () => {
    const r = n.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(s) {
      const o = r.reduce((a, { useScope: l, scopeName: c }) => {
        const d = l(s)[`__scope${c}`];
        return { ...a, ...d };
      }, {});
      return A.useMemo(() => ({ [`__scope${e.scopeName}`]: o }), [o]);
    };
  };
  return t.scopeName = e.scopeName, t;
}
var Rr = globalThis?.document ? A.useLayoutEffect : () => {
}, G$e = A[" useId ".trim().toString()] || (() => {
}), K$e = 0;
function Xn(n) {
  const [e, t] = A.useState(G$e());
  return Rr(() => {
    t((r) => r ?? String(K$e++));
  }, [n]), e ? `radix-${e}` : "";
}
var q$e = A[" useInsertionEffect ".trim().toString()] || Rr;
function Kr({
  prop: n,
  defaultProp: e,
  onChange: t = () => {
  },
  caller: r
}) {
  const [i, s, o] = Y$e({
    defaultProp: e,
    onChange: t
  }), a = n !== void 0, l = a ? n : i;
  {
    const u = A.useRef(n !== void 0);
    A.useEffect(() => {
      const d = u.current;
      d !== a && console.warn(
        `${r} is changing from ${d ? "controlled" : "uncontrolled"} to ${a ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = a;
    }, [a, r]);
  }
  const c = A.useCallback(
    (u) => {
      if (a) {
        const d = X$e(u) ? u(n) : u;
        d !== n && o.current?.(d);
      } else
        s(u);
    },
    [a, n, s, o]
  );
  return [l, c];
}
function Y$e({
  defaultProp: n,
  onChange: e
}) {
  const [t, r] = A.useState(n), i = A.useRef(t), s = A.useRef(e);
  return q$e(() => {
    s.current = e;
  }, [e]), A.useEffect(() => {
    i.current !== t && (s.current?.(t), i.current = t);
  }, [t, i]), [t, r, s];
}
function X$e(n) {
  return typeof n == "function";
}
// @__NO_SIDE_EFFECTS__
function Z$e(n) {
  const e = /* @__PURE__ */ Q$e(n), t = A.forwardRef((r, i) => {
    const { children: s, ...o } = r, a = A.Children.toArray(s), l = a.find(eFe);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? A.Children.count(c) > 1 ? A.Children.only(null) : A.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ T(e, { ...o, ref: i, children: A.isValidElement(c) ? A.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ T(e, { ...o, ref: i, children: s });
  });
  return t.displayName = `${n}.Slot`, t;
}
// @__NO_SIDE_EFFECTS__
function Q$e(n) {
  const e = A.forwardRef((t, r) => {
    const { children: i, ...s } = t;
    if (A.isValidElement(i)) {
      const o = nFe(i), a = tFe(s, i.props);
      return i.type !== A.Fragment && (a.ref = r ? bi(r, o) : o), A.cloneElement(i, a);
    }
    return A.Children.count(i) > 1 ? A.Children.only(null) : null;
  });
  return e.displayName = `${n}.SlotClone`, e;
}
var J$e = Symbol("radix.slottable");
function eFe(n) {
  return A.isValidElement(n) && typeof n.type == "function" && "__radixId" in n.type && n.type.__radixId === J$e;
}
function tFe(n, e) {
  const t = { ...e };
  for (const r in e) {
    const i = n[r], s = e[r];
    /^on[A-Z]/.test(r) ? i && s ? t[r] = (...a) => {
      const l = s(...a);
      return i(...a), l;
    } : i && (t[r] = i) : r === "style" ? t[r] = { ...i, ...s } : r === "className" && (t[r] = [i, s].filter(Boolean).join(" "));
  }
  return { ...n, ...t };
}
function nFe(n) {
  let e = Object.getOwnPropertyDescriptor(n.props, "ref")?.get, t = e && "isReactWarning" in e && e.isReactWarning;
  return t ? n.ref : (e = Object.getOwnPropertyDescriptor(n, "ref")?.get, t = e && "isReactWarning" in e && e.isReactWarning, t ? n.props.ref : n.props.ref || n.ref);
}
var rFe = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Ve = rFe.reduce((n, e) => {
  const t = /* @__PURE__ */ Z$e(`Primitive.${e}`), r = A.forwardRef((i, s) => {
    const { asChild: o, ...a } = i, l = o ? t : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ T(l, { ...a, ref: s });
  });
  return r.displayName = `Primitive.${e}`, { ...n, [e]: r };
}, {});
function eZ(n, e) {
  n && mw.flushSync(() => n.dispatchEvent(e));
}
function Vr(n) {
  const e = A.useRef(n);
  return A.useEffect(() => {
    e.current = n;
  }), A.useMemo(() => (...t) => e.current?.(...t), []);
}
function iFe(n, e = globalThis?.document) {
  const t = Vr(n);
  A.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && t(i);
    };
    return e.addEventListener("keydown", r, { capture: !0 }), () => e.removeEventListener("keydown", r, { capture: !0 });
  }, [t, e]);
}
var sFe = "DismissableLayer", ZT = "dismissableLayer.update", oFe = "dismissableLayer.pointerDownOutside", aFe = "dismissableLayer.focusOutside", zB, tZ = A.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Ih = A.forwardRef(
  (n, e) => {
    const {
      disableOutsidePointerEvents: t = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: s,
      onInteractOutside: o,
      onDismiss: a,
      ...l
    } = n, c = A.useContext(tZ), [u, d] = A.useState(null), f = u?.ownerDocument ?? globalThis?.document, [, h] = A.useState({}), m = ht(e, (S) => d(S)), g = Array.from(c.layers), [v] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), y = g.indexOf(v), b = u ? g.indexOf(u) : -1, x = c.layersWithOutsidePointerEventsDisabled.size > 0, E = b >= y, w = uFe((S) => {
      const M = S.target, k = [...c.branches].some((_) => _.contains(M));
      !E || k || (i?.(S), o?.(S), S.defaultPrevented || a?.());
    }, f), C = dFe((S) => {
      const M = S.target;
      [...c.branches].some((_) => _.contains(M)) || (s?.(S), o?.(S), S.defaultPrevented || a?.());
    }, f);
    return iFe((S) => {
      b === c.layers.size - 1 && (r?.(S), !S.defaultPrevented && a && (S.preventDefault(), a()));
    }, f), A.useEffect(() => {
      if (u)
        return t && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (zB = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), HB(), () => {
          t && c.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = zB);
        };
    }, [u, f, t, c]), A.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), HB());
    }, [u, c]), A.useEffect(() => {
      const S = () => h({});
      return document.addEventListener(ZT, S), () => document.removeEventListener(ZT, S);
    }, []), /* @__PURE__ */ T(
      Ve.div,
      {
        ...l,
        ref: m,
        style: {
          pointerEvents: x ? E ? "auto" : "none" : void 0,
          ...n.style
        },
        onFocusCapture: Ce(n.onFocusCapture, C.onFocusCapture),
        onBlurCapture: Ce(n.onBlurCapture, C.onBlurCapture),
        onPointerDownCapture: Ce(
          n.onPointerDownCapture,
          w.onPointerDownCapture
        )
      }
    );
  }
);
Ih.displayName = sFe;
var lFe = "DismissableLayerBranch", cFe = A.forwardRef((n, e) => {
  const t = A.useContext(tZ), r = A.useRef(null), i = ht(e, r);
  return A.useEffect(() => {
    const s = r.current;
    if (s)
      return t.branches.add(s), () => {
        t.branches.delete(s);
      };
  }, [t.branches]), /* @__PURE__ */ T(Ve.div, { ...n, ref: i });
});
cFe.displayName = lFe;
function uFe(n, e = globalThis?.document) {
  const t = Vr(n), r = A.useRef(!1), i = A.useRef(() => {
  });
  return A.useEffect(() => {
    const s = (a) => {
      if (a.target && !r.current) {
        let l = function() {
          nZ(
            oFe,
            t,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: a };
        a.pointerType === "touch" ? (e.removeEventListener("click", i.current), i.current = l, e.addEventListener("click", i.current, { once: !0 })) : l();
      } else
        e.removeEventListener("click", i.current);
      r.current = !1;
    }, o = window.setTimeout(() => {
      e.addEventListener("pointerdown", s);
    }, 0);
    return () => {
      window.clearTimeout(o), e.removeEventListener("pointerdown", s), e.removeEventListener("click", i.current);
    };
  }, [e, t]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function dFe(n, e = globalThis?.document) {
  const t = Vr(n), r = A.useRef(!1);
  return A.useEffect(() => {
    const i = (s) => {
      s.target && !r.current && nZ(aFe, t, { originalEvent: s }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", i), () => e.removeEventListener("focusin", i);
  }, [e, t]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function HB() {
  const n = new CustomEvent(ZT);
  document.dispatchEvent(n);
}
function nZ(n, e, t, { discrete: r }) {
  const i = t.originalEvent.target, s = new CustomEvent(n, { bubbles: !1, cancelable: !0, detail: t });
  e && i.addEventListener(n, e, { once: !0 }), r ? eZ(i, s) : i.dispatchEvent(s);
}
var i6 = "focusScope.autoFocusOnMount", s6 = "focusScope.autoFocusOnUnmount", UB = { bubbles: !1, cancelable: !0 }, fFe = "FocusScope", v1 = A.forwardRef((n, e) => {
  const {
    loop: t = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: s,
    ...o
  } = n, [a, l] = A.useState(null), c = Vr(i), u = Vr(s), d = A.useRef(null), f = ht(e, (g) => l(g)), h = A.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  A.useEffect(() => {
    if (r) {
      let g = function(x) {
        if (h.paused || !a) return;
        const E = x.target;
        a.contains(E) ? d.current = E : Nl(d.current, { select: !0 });
      }, v = function(x) {
        if (h.paused || !a) return;
        const E = x.relatedTarget;
        E !== null && (a.contains(E) || Nl(d.current, { select: !0 }));
      }, y = function(x) {
        if (document.activeElement === document.body)
          for (const w of x)
            w.removedNodes.length > 0 && Nl(a);
      };
      document.addEventListener("focusin", g), document.addEventListener("focusout", v);
      const b = new MutationObserver(y);
      return a && b.observe(a, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", g), document.removeEventListener("focusout", v), b.disconnect();
      };
    }
  }, [r, a, h.paused]), A.useEffect(() => {
    if (a) {
      jB.add(h);
      const g = document.activeElement;
      if (!a.contains(g)) {
        const y = new CustomEvent(i6, UB);
        a.addEventListener(i6, c), a.dispatchEvent(y), y.defaultPrevented || (hFe(yFe(rZ(a)), { select: !0 }), document.activeElement === g && Nl(a));
      }
      return () => {
        a.removeEventListener(i6, c), setTimeout(() => {
          const y = new CustomEvent(s6, UB);
          a.addEventListener(s6, u), a.dispatchEvent(y), y.defaultPrevented || Nl(g ?? document.body, { select: !0 }), a.removeEventListener(s6, u), jB.remove(h);
        }, 0);
      };
    }
  }, [a, c, u, h]);
  const m = A.useCallback(
    (g) => {
      if (!t && !r || h.paused) return;
      const v = g.key === "Tab" && !g.altKey && !g.ctrlKey && !g.metaKey, y = document.activeElement;
      if (v && y) {
        const b = g.currentTarget, [x, E] = pFe(b);
        x && E ? !g.shiftKey && y === E ? (g.preventDefault(), t && Nl(x, { select: !0 })) : g.shiftKey && y === x && (g.preventDefault(), t && Nl(E, { select: !0 })) : y === b && g.preventDefault();
      }
    },
    [t, r, h.paused]
  );
  return /* @__PURE__ */ T(Ve.div, { tabIndex: -1, ...o, ref: f, onKeyDown: m });
});
v1.displayName = fFe;
function hFe(n, { select: e = !1 } = {}) {
  const t = document.activeElement;
  for (const r of n)
    if (Nl(r, { select: e }), document.activeElement !== t) return;
}
function pFe(n) {
  const e = rZ(n), t = VB(e, n), r = VB(e.reverse(), n);
  return [t, r];
}
function rZ(n) {
  const e = [], t = document.createTreeWalker(n, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; t.nextNode(); ) e.push(t.currentNode);
  return e;
}
function VB(n, e) {
  for (const t of n)
    if (!mFe(t, { upTo: e })) return t;
}
function mFe(n, { upTo: e }) {
  if (getComputedStyle(n).visibility === "hidden") return !0;
  for (; n; ) {
    if (e !== void 0 && n === e) return !1;
    if (getComputedStyle(n).display === "none") return !0;
    n = n.parentElement;
  }
  return !1;
}
function gFe(n) {
  return n instanceof HTMLInputElement && "select" in n;
}
function Nl(n, { select: e = !1 } = {}) {
  if (n && n.focus) {
    const t = document.activeElement;
    n.focus({ preventScroll: !0 }), n !== t && gFe(n) && e && n.select();
  }
}
var jB = vFe();
function vFe() {
  let n = [];
  return {
    add(e) {
      const t = n[0];
      e !== t && t?.pause(), n = WB(n, e), n.unshift(e);
    },
    remove(e) {
      n = WB(n, e), n[0]?.resume();
    }
  };
}
function WB(n, e) {
  const t = [...n], r = t.indexOf(e);
  return r !== -1 && t.splice(r, 1), t;
}
function yFe(n) {
  return n.filter((e) => e.tagName !== "A");
}
var bFe = "Portal", y1 = A.forwardRef((n, e) => {
  const { container: t, ...r } = n, [i, s] = A.useState(!1);
  Rr(() => s(!0), []);
  const o = t || i && globalThis?.document?.body;
  return o ? gw.createPortal(/* @__PURE__ */ T(Ve.div, { ...r, ref: e }), o) : null;
});
y1.displayName = bFe;
function wFe(n, e) {
  return A.useReducer((t, r) => e[t][r] ?? t, n);
}
var Yr = (n) => {
  const { present: e, children: t } = n, r = xFe(e), i = typeof t == "function" ? t({ present: r.isPresent }) : A.Children.only(t), s = ht(r.ref, EFe(i));
  return typeof t == "function" || r.isPresent ? A.cloneElement(i, { ref: s }) : null;
};
Yr.displayName = "Presence";
function xFe(n) {
  const [e, t] = A.useState(), r = A.useRef(null), i = A.useRef(n), s = A.useRef("none"), o = n ? "mounted" : "unmounted", [a, l] = wFe(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return A.useEffect(() => {
    const c = Sg(r.current);
    s.current = a === "mounted" ? c : "none";
  }, [a]), Rr(() => {
    const c = r.current, u = i.current;
    if (u !== n) {
      const f = s.current, h = Sg(c);
      n ? l("MOUNT") : h === "none" || c?.display === "none" ? l("UNMOUNT") : l(u && f !== h ? "ANIMATION_OUT" : "UNMOUNT"), i.current = n;
    }
  }, [n, l]), Rr(() => {
    if (e) {
      let c;
      const u = e.ownerDocument.defaultView ?? window, d = (h) => {
        const g = Sg(r.current).includes(CSS.escape(h.animationName));
        if (h.target === e && g && (l("ANIMATION_END"), !i.current)) {
          const v = e.style.animationFillMode;
          e.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            e.style.animationFillMode === "forwards" && (e.style.animationFillMode = v);
          });
        }
      }, f = (h) => {
        h.target === e && (s.current = Sg(r.current));
      };
      return e.addEventListener("animationstart", f), e.addEventListener("animationcancel", d), e.addEventListener("animationend", d), () => {
        u.clearTimeout(c), e.removeEventListener("animationstart", f), e.removeEventListener("animationcancel", d), e.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [e, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(a),
    ref: A.useCallback((c) => {
      r.current = c ? getComputedStyle(c) : null, t(c);
    }, [])
  };
}
function Sg(n) {
  return n?.animationName || "none";
}
function EFe(n) {
  let e = Object.getOwnPropertyDescriptor(n.props, "ref")?.get, t = e && "isReactWarning" in e && e.isReactWarning;
  return t ? n.ref : (e = Object.getOwnPropertyDescriptor(n, "ref")?.get, t = e && "isReactWarning" in e && e.isReactWarning, t ? n.props.ref : n.props.ref || n.ref);
}
var o6 = 0;
function i3() {
  A.useEffect(() => {
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", n[0] ?? GB()), document.body.insertAdjacentElement("beforeend", n[1] ?? GB()), o6++, () => {
      o6 === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((e) => e.remove()), o6--;
    };
  }, []);
}
function GB() {
  const n = document.createElement("span");
  return n.setAttribute("data-radix-focus-guard", ""), n.tabIndex = 0, n.style.outline = "none", n.style.opacity = "0", n.style.position = "fixed", n.style.pointerEvents = "none", n;
}
var Zo = function() {
  return Zo = Object.assign || function(e) {
    for (var t, r = 1, i = arguments.length; r < i; r++) {
      t = arguments[r];
      for (var s in t) Object.prototype.hasOwnProperty.call(t, s) && (e[s] = t[s]);
    }
    return e;
  }, Zo.apply(this, arguments);
};
function iZ(n, e) {
  var t = {};
  for (var r in n) Object.prototype.hasOwnProperty.call(n, r) && e.indexOf(r) < 0 && (t[r] = n[r]);
  if (n != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(n); i < r.length; i++)
      e.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(n, r[i]) && (t[r[i]] = n[r[i]]);
  return t;
}
function SFe(n, e, t) {
  if (t || arguments.length === 2) for (var r = 0, i = e.length, s; r < i; r++)
    (s || !(r in e)) && (s || (s = Array.prototype.slice.call(e, 0, r)), s[r] = e[r]);
  return n.concat(s || Array.prototype.slice.call(e));
}
var Bv = "right-scroll-bar-position", zv = "width-before-scroll-bar", CFe = "with-scroll-bars-hidden", TFe = "--removed-body-scroll-bar-size";
function a6(n, e) {
  return typeof n == "function" ? n(e) : n && (n.current = e), n;
}
function AFe(n, e) {
  var t = wt(function() {
    return {
      // value
      value: n,
      // last callback
      callback: e,
      // "memoized" public interface
      facade: {
        get current() {
          return t.value;
        },
        set current(r) {
          var i = t.value;
          i !== r && (t.value = r, t.callback(r, i));
        }
      }
    };
  })[0];
  return t.callback = e, t.facade;
}
var MFe = typeof window < "u" ? A.useLayoutEffect : A.useEffect, KB = /* @__PURE__ */ new WeakMap();
function kFe(n, e) {
  var t = AFe(null, function(r) {
    return n.forEach(function(i) {
      return a6(i, r);
    });
  });
  return MFe(function() {
    var r = KB.get(t);
    if (r) {
      var i = new Set(r), s = new Set(n), o = t.current;
      i.forEach(function(a) {
        s.has(a) || a6(a, null);
      }), s.forEach(function(a) {
        i.has(a) || a6(a, o);
      });
    }
    KB.set(t, n);
  }, [n]), t;
}
function _Fe(n) {
  return n;
}
function OFe(n, e) {
  e === void 0 && (e = _Fe);
  var t = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return t.length ? t[t.length - 1] : n;
    },
    useMedium: function(s) {
      var o = e(s, r);
      return t.push(o), function() {
        t = t.filter(function(a) {
          return a !== o;
        });
      };
    },
    assignSyncMedium: function(s) {
      for (r = !0; t.length; ) {
        var o = t;
        t = [], o.forEach(s);
      }
      t = {
        push: function(a) {
          return s(a);
        },
        filter: function() {
          return t;
        }
      };
    },
    assignMedium: function(s) {
      r = !0;
      var o = [];
      if (t.length) {
        var a = t;
        t = [], a.forEach(s), o = t;
      }
      var l = function() {
        var u = o;
        o = [], u.forEach(s);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), t = {
        push: function(u) {
          o.push(u), c();
        },
        filter: function(u) {
          return o = o.filter(u), t;
        }
      };
    }
  };
  return i;
}
function IFe(n) {
  n === void 0 && (n = {});
  var e = OFe(null);
  return e.options = Zo({ async: !0, ssr: !1 }, n), e;
}
var sZ = function(n) {
  var e = n.sideCar, t = iZ(n, ["sideCar"]);
  if (!e)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = e.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return A.createElement(r, Zo({}, t));
};
sZ.isSideCarExport = !0;
function RFe(n, e) {
  return n.useMedium(e), sZ;
}
var oZ = IFe(), l6 = function() {
}, s3 = A.forwardRef(function(n, e) {
  var t = A.useRef(null), r = A.useState({
    onScrollCapture: l6,
    onWheelCapture: l6,
    onTouchMoveCapture: l6
  }), i = r[0], s = r[1], o = n.forwardProps, a = n.children, l = n.className, c = n.removeScrollBar, u = n.enabled, d = n.shards, f = n.sideCar, h = n.noRelative, m = n.noIsolation, g = n.inert, v = n.allowPinchZoom, y = n.as, b = y === void 0 ? "div" : y, x = n.gapMode, E = iZ(n, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), w = f, C = kFe([t, e]), S = Zo(Zo({}, E), i);
  return A.createElement(
    A.Fragment,
    null,
    u && A.createElement(w, { sideCar: oZ, removeScrollBar: c, shards: d, noRelative: h, noIsolation: m, inert: g, setCallbacks: s, allowPinchZoom: !!v, lockRef: t, gapMode: x }),
    o ? A.cloneElement(A.Children.only(a), Zo(Zo({}, S), { ref: C })) : A.createElement(b, Zo({}, S, { className: l, ref: C }), a)
  );
});
s3.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
s3.classNames = {
  fullWidth: zv,
  zeroRight: Bv
};
var PFe = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function DFe() {
  if (!document)
    return null;
  var n = document.createElement("style");
  n.type = "text/css";
  var e = PFe();
  return e && n.setAttribute("nonce", e), n;
}
function NFe(n, e) {
  n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
function LFe(n) {
  var e = document.head || document.getElementsByTagName("head")[0];
  e.appendChild(n);
}
var $Fe = function() {
  var n = 0, e = null;
  return {
    add: function(t) {
      n == 0 && (e = DFe()) && (NFe(e, t), LFe(e)), n++;
    },
    remove: function() {
      n--, !n && e && (e.parentNode && e.parentNode.removeChild(e), e = null);
    }
  };
}, FFe = function() {
  var n = $Fe();
  return function(e, t) {
    A.useEffect(function() {
      return n.add(e), function() {
        n.remove();
      };
    }, [e && t]);
  };
}, aZ = function() {
  var n = FFe(), e = function(t) {
    var r = t.styles, i = t.dynamic;
    return n(r, i), null;
  };
  return e;
}, BFe = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, c6 = function(n) {
  return parseInt(n || "", 10) || 0;
}, zFe = function(n) {
  var e = window.getComputedStyle(document.body), t = e[n === "padding" ? "paddingLeft" : "marginLeft"], r = e[n === "padding" ? "paddingTop" : "marginTop"], i = e[n === "padding" ? "paddingRight" : "marginRight"];
  return [c6(t), c6(r), c6(i)];
}, HFe = function(n) {
  if (n === void 0 && (n = "margin"), typeof window > "u")
    return BFe;
  var e = zFe(n), t = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: e[0],
    top: e[1],
    right: e[2],
    gap: Math.max(0, r - t + e[2] - e[0])
  };
}, UFe = aZ(), cf = "data-scroll-locked", VFe = function(n, e, t, r) {
  var i = n.left, s = n.top, o = n.right, a = n.gap;
  return t === void 0 && (t = "margin"), `
  .`.concat(CFe, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(a, "px ").concat(r, `;
  }
  body[`).concat(cf, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    e && "position: relative ".concat(r, ";"),
    t === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(s, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(a, "px ").concat(r, `;
    `),
    t === "padding" && "padding-right: ".concat(a, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Bv, ` {
    right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(zv, ` {
    margin-right: `).concat(a, "px ").concat(r, `;
  }
  
  .`).concat(Bv, " .").concat(Bv, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(zv, " .").concat(zv, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(cf, `] {
    `).concat(TFe, ": ").concat(a, `px;
  }
`);
}, qB = function() {
  var n = parseInt(document.body.getAttribute(cf) || "0", 10);
  return isFinite(n) ? n : 0;
}, jFe = function() {
  A.useEffect(function() {
    return document.body.setAttribute(cf, (qB() + 1).toString()), function() {
      var n = qB() - 1;
      n <= 0 ? document.body.removeAttribute(cf) : document.body.setAttribute(cf, n.toString());
    };
  }, []);
}, WFe = function(n) {
  var e = n.noRelative, t = n.noImportant, r = n.gapMode, i = r === void 0 ? "margin" : r;
  jFe();
  var s = A.useMemo(function() {
    return HFe(i);
  }, [i]);
  return A.createElement(UFe, { styles: VFe(s, !e, i, t ? "" : "!important") });
}, QT = !1;
if (typeof window < "u")
  try {
    var Cg = Object.defineProperty({}, "passive", {
      get: function() {
        return QT = !0, !0;
      }
    });
    window.addEventListener("test", Cg, Cg), window.removeEventListener("test", Cg, Cg);
  } catch {
    QT = !1;
  }
var xd = QT ? { passive: !1 } : !1, GFe = function(n) {
  return n.tagName === "TEXTAREA";
}, lZ = function(n, e) {
  if (!(n instanceof Element))
    return !1;
  var t = window.getComputedStyle(n);
  return (
    // not-not-scrollable
    t[e] !== "hidden" && // contains scroll inside self
    !(t.overflowY === t.overflowX && !GFe(n) && t[e] === "visible")
  );
}, KFe = function(n) {
  return lZ(n, "overflowY");
}, qFe = function(n) {
  return lZ(n, "overflowX");
}, YB = function(n, e) {
  var t = e.ownerDocument, r = e;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = cZ(n, r);
    if (i) {
      var s = uZ(n, r), o = s[1], a = s[2];
      if (o > a)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== t.body);
  return !1;
}, YFe = function(n) {
  var e = n.scrollTop, t = n.scrollHeight, r = n.clientHeight;
  return [
    e,
    t,
    r
  ];
}, XFe = function(n) {
  var e = n.scrollLeft, t = n.scrollWidth, r = n.clientWidth;
  return [
    e,
    t,
    r
  ];
}, cZ = function(n, e) {
  return n === "v" ? KFe(e) : qFe(e);
}, uZ = function(n, e) {
  return n === "v" ? YFe(e) : XFe(e);
}, ZFe = function(n, e) {
  return n === "h" && e === "rtl" ? -1 : 1;
}, QFe = function(n, e, t, r, i) {
  var s = ZFe(n, window.getComputedStyle(e).direction), o = s * r, a = t.target, l = e.contains(a), c = !1, u = o > 0, d = 0, f = 0;
  do {
    if (!a)
      break;
    var h = uZ(n, a), m = h[0], g = h[1], v = h[2], y = g - v - s * m;
    (m || y) && cZ(n, a) && (d += y, f += m);
    var b = a.parentNode;
    a = b && b.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? b.host : b;
  } while (
    // portaled content
    !l && a !== document.body || // self content
    l && (e.contains(a) || e === a)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(f) < 1) && (c = !0), c;
}, Tg = function(n) {
  return "changedTouches" in n ? [n.changedTouches[0].clientX, n.changedTouches[0].clientY] : [0, 0];
}, XB = function(n) {
  return [n.deltaX, n.deltaY];
}, ZB = function(n) {
  return n && "current" in n ? n.current : n;
}, JFe = function(n, e) {
  return n[0] === e[0] && n[1] === e[1];
}, eBe = function(n) {
  return `
  .block-interactivity-`.concat(n, ` {pointer-events: none;}
  .allow-interactivity-`).concat(n, ` {pointer-events: all;}
`);
}, tBe = 0, Ed = [];
function nBe(n) {
  var e = A.useRef([]), t = A.useRef([0, 0]), r = A.useRef(), i = A.useState(tBe++)[0], s = A.useState(aZ)[0], o = A.useRef(n);
  A.useEffect(function() {
    o.current = n;
  }, [n]), A.useEffect(function() {
    if (n.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var g = SFe([n.lockRef.current], (n.shards || []).map(ZB), !0).filter(Boolean);
      return g.forEach(function(v) {
        return v.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), g.forEach(function(v) {
          return v.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [n.inert, n.lockRef.current, n.shards]);
  var a = A.useCallback(function(g, v) {
    if ("touches" in g && g.touches.length === 2 || g.type === "wheel" && g.ctrlKey)
      return !o.current.allowPinchZoom;
    var y = Tg(g), b = t.current, x = "deltaX" in g ? g.deltaX : b[0] - y[0], E = "deltaY" in g ? g.deltaY : b[1] - y[1], w, C = g.target, S = Math.abs(x) > Math.abs(E) ? "h" : "v";
    if ("touches" in g && S === "h" && C.type === "range")
      return !1;
    var M = YB(S, C);
    if (!M)
      return !0;
    if (M ? w = S : (w = S === "v" ? "h" : "v", M = YB(S, C)), !M)
      return !1;
    if (!r.current && "changedTouches" in g && (x || E) && (r.current = w), !w)
      return !0;
    var k = r.current || w;
    return QFe(k, v, g, k === "h" ? x : E);
  }, []), l = A.useCallback(function(g) {
    var v = g;
    if (!(!Ed.length || Ed[Ed.length - 1] !== s)) {
      var y = "deltaY" in v ? XB(v) : Tg(v), b = e.current.filter(function(w) {
        return w.name === v.type && (w.target === v.target || v.target === w.shadowParent) && JFe(w.delta, y);
      })[0];
      if (b && b.should) {
        v.cancelable && v.preventDefault();
        return;
      }
      if (!b) {
        var x = (o.current.shards || []).map(ZB).filter(Boolean).filter(function(w) {
          return w.contains(v.target);
        }), E = x.length > 0 ? a(v, x[0]) : !o.current.noIsolation;
        E && v.cancelable && v.preventDefault();
      }
    }
  }, []), c = A.useCallback(function(g, v, y, b) {
    var x = { name: g, delta: v, target: y, should: b, shadowParent: rBe(y) };
    e.current.push(x), setTimeout(function() {
      e.current = e.current.filter(function(E) {
        return E !== x;
      });
    }, 1);
  }, []), u = A.useCallback(function(g) {
    t.current = Tg(g), r.current = void 0;
  }, []), d = A.useCallback(function(g) {
    c(g.type, XB(g), g.target, a(g, n.lockRef.current));
  }, []), f = A.useCallback(function(g) {
    c(g.type, Tg(g), g.target, a(g, n.lockRef.current));
  }, []);
  A.useEffect(function() {
    return Ed.push(s), n.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", l, xd), document.addEventListener("touchmove", l, xd), document.addEventListener("touchstart", u, xd), function() {
      Ed = Ed.filter(function(g) {
        return g !== s;
      }), document.removeEventListener("wheel", l, xd), document.removeEventListener("touchmove", l, xd), document.removeEventListener("touchstart", u, xd);
    };
  }, []);
  var h = n.removeScrollBar, m = n.inert;
  return A.createElement(
    A.Fragment,
    null,
    m ? A.createElement(s, { styles: eBe(i) }) : null,
    h ? A.createElement(WFe, { noRelative: n.noRelative, gapMode: n.gapMode }) : null
  );
}
function rBe(n) {
  for (var e = null; n !== null; )
    n instanceof ShadowRoot && (e = n.host, n = n.host), n = n.parentNode;
  return e;
}
const iBe = RFe(oZ, nBe);
var b1 = A.forwardRef(function(n, e) {
  return A.createElement(s3, Zo({}, n, { ref: e, sideCar: iBe }));
});
b1.classNames = s3.classNames;
var sBe = function(n) {
  if (typeof document > "u")
    return null;
  var e = Array.isArray(n) ? n[0] : n;
  return e.ownerDocument.body;
}, Sd = /* @__PURE__ */ new WeakMap(), Ag = /* @__PURE__ */ new WeakMap(), Mg = {}, u6 = 0, dZ = function(n) {
  return n && (n.host || dZ(n.parentNode));
}, oBe = function(n, e) {
  return e.map(function(t) {
    if (n.contains(t))
      return t;
    var r = dZ(t);
    return r && n.contains(r) ? r : (console.error("aria-hidden", t, "in not contained inside", n, ". Doing nothing"), null);
  }).filter(function(t) {
    return !!t;
  });
}, aBe = function(n, e, t, r) {
  var i = oBe(e, Array.isArray(n) ? n : [n]);
  Mg[t] || (Mg[t] = /* @__PURE__ */ new WeakMap());
  var s = Mg[t], o = [], a = /* @__PURE__ */ new Set(), l = new Set(i), c = function(d) {
    !d || a.has(d) || (a.add(d), c(d.parentNode));
  };
  i.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(f) {
      if (a.has(f))
        u(f);
      else
        try {
          var h = f.getAttribute(r), m = h !== null && h !== "false", g = (Sd.get(f) || 0) + 1, v = (s.get(f) || 0) + 1;
          Sd.set(f, g), s.set(f, v), o.push(f), g === 1 && m && Ag.set(f, !0), v === 1 && f.setAttribute(t, "true"), m || f.setAttribute(r, "true");
        } catch (y) {
          console.error("aria-hidden: cannot operate on ", f, y);
        }
    });
  };
  return u(e), a.clear(), u6++, function() {
    o.forEach(function(d) {
      var f = Sd.get(d) - 1, h = s.get(d) - 1;
      Sd.set(d, f), s.set(d, h), f || (Ag.has(d) || d.removeAttribute(r), Ag.delete(d)), h || d.removeAttribute(t);
    }), u6--, u6 || (Sd = /* @__PURE__ */ new WeakMap(), Sd = /* @__PURE__ */ new WeakMap(), Ag = /* @__PURE__ */ new WeakMap(), Mg = {});
  };
}, o3 = function(n, e, t) {
  t === void 0 && (t = "data-aria-hidden");
  var r = Array.from(Array.isArray(n) ? n : [n]), i = sBe(n);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live], script"))), aBe(r, i, t, "aria-hidden")) : function() {
    return null;
  };
};
// @__NO_SIDE_EFFECTS__
function lBe(n) {
  const e = /* @__PURE__ */ cBe(n), t = A.forwardRef((r, i) => {
    const { children: s, ...o } = r, a = A.Children.toArray(s), l = a.find(dBe);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? A.Children.count(c) > 1 ? A.Children.only(null) : A.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ T(e, { ...o, ref: i, children: A.isValidElement(c) ? A.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ T(e, { ...o, ref: i, children: s });
  });
  return t.displayName = `${n}.Slot`, t;
}
// @__NO_SIDE_EFFECTS__
function cBe(n) {
  const e = A.forwardRef((t, r) => {
    const { children: i, ...s } = t;
    if (A.isValidElement(i)) {
      const o = hBe(i), a = fBe(s, i.props);
      return i.type !== A.Fragment && (a.ref = r ? bi(r, o) : o), A.cloneElement(i, a);
    }
    return A.Children.count(i) > 1 ? A.Children.only(null) : null;
  });
  return e.displayName = `${n}.SlotClone`, e;
}
var uBe = Symbol("radix.slottable");
function dBe(n) {
  return A.isValidElement(n) && typeof n.type == "function" && "__radixId" in n.type && n.type.__radixId === uBe;
}
function fBe(n, e) {
  const t = { ...e };
  for (const r in e) {
    const i = n[r], s = e[r];
    /^on[A-Z]/.test(r) ? i && s ? t[r] = (...a) => {
      const l = s(...a);
      return i(...a), l;
    } : i && (t[r] = i) : r === "style" ? t[r] = { ...i, ...s } : r === "className" && (t[r] = [i, s].filter(Boolean).join(" "));
  }
  return { ...n, ...t };
}
function hBe(n) {
  let e = Object.getOwnPropertyDescriptor(n.props, "ref")?.get, t = e && "isReactWarning" in e && e.isReactWarning;
  return t ? n.ref : (e = Object.getOwnPropertyDescriptor(n, "ref")?.get, t = e && "isReactWarning" in e && e.isReactWarning, t ? n.props.ref : n.props.ref || n.ref);
}
var a3 = "Dialog", [fZ] = qr(a3), [pBe, _o] = fZ(a3), hZ = (n) => {
  const {
    __scopeDialog: e,
    children: t,
    open: r,
    defaultOpen: i,
    onOpenChange: s,
    modal: o = !0
  } = n, a = A.useRef(null), l = A.useRef(null), [c, u] = Kr({
    prop: r,
    defaultProp: i ?? !1,
    onChange: s,
    caller: a3
  });
  return /* @__PURE__ */ T(
    pBe,
    {
      scope: e,
      triggerRef: a,
      contentRef: l,
      contentId: Xn(),
      titleId: Xn(),
      descriptionId: Xn(),
      open: c,
      onOpenChange: u,
      onOpenToggle: A.useCallback(() => u((d) => !d), [u]),
      modal: o,
      children: t
    }
  );
};
hZ.displayName = a3;
var pZ = "DialogTrigger", mZ = A.forwardRef(
  (n, e) => {
    const { __scopeDialog: t, ...r } = n, i = _o(pZ, t), s = ht(e, i.triggerRef);
    return /* @__PURE__ */ T(
      Ve.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": sk(i.open),
        ...r,
        ref: s,
        onClick: Ce(n.onClick, i.onOpenToggle)
      }
    );
  }
);
mZ.displayName = pZ;
var rk = "DialogPortal", [mBe, gZ] = fZ(rk, {
  forceMount: void 0
}), vZ = (n) => {
  const { __scopeDialog: e, forceMount: t, children: r, container: i } = n, s = _o(rk, e);
  return /* @__PURE__ */ T(mBe, { scope: e, forceMount: t, children: A.Children.map(r, (o) => /* @__PURE__ */ T(Yr, { present: t || s.open, children: /* @__PURE__ */ T(y1, { asChild: !0, container: i, children: o }) })) });
};
vZ.displayName = rk;
var Cy = "DialogOverlay", yZ = A.forwardRef(
  (n, e) => {
    const t = gZ(Cy, n.__scopeDialog), { forceMount: r = t.forceMount, ...i } = n, s = _o(Cy, n.__scopeDialog);
    return s.modal ? /* @__PURE__ */ T(Yr, { present: r || s.open, children: /* @__PURE__ */ T(vBe, { ...i, ref: e }) }) : null;
  }
);
yZ.displayName = Cy;
var gBe = /* @__PURE__ */ lBe("DialogOverlay.RemoveScroll"), vBe = A.forwardRef(
  (n, e) => {
    const { __scopeDialog: t, ...r } = n, i = _o(Cy, t);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ T(b1, { as: gBe, allowPinchZoom: !0, shards: [i.contentRef], children: /* @__PURE__ */ T(
        Ve.div,
        {
          "data-state": sk(i.open),
          ...r,
          ref: e,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Nu = "DialogContent", bZ = A.forwardRef(
  (n, e) => {
    const t = gZ(Nu, n.__scopeDialog), { forceMount: r = t.forceMount, ...i } = n, s = _o(Nu, n.__scopeDialog);
    return /* @__PURE__ */ T(Yr, { present: r || s.open, children: s.modal ? /* @__PURE__ */ T(yBe, { ...i, ref: e }) : /* @__PURE__ */ T(bBe, { ...i, ref: e }) });
  }
);
bZ.displayName = Nu;
var yBe = A.forwardRef(
  (n, e) => {
    const t = _o(Nu, n.__scopeDialog), r = A.useRef(null), i = ht(e, t.contentRef, r);
    return A.useEffect(() => {
      const s = r.current;
      if (s) return o3(s);
    }, []), /* @__PURE__ */ T(
      wZ,
      {
        ...n,
        ref: i,
        trapFocus: t.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Ce(n.onCloseAutoFocus, (s) => {
          s.preventDefault(), t.triggerRef.current?.focus();
        }),
        onPointerDownOutside: Ce(n.onPointerDownOutside, (s) => {
          const o = s.detail.originalEvent, a = o.button === 0 && o.ctrlKey === !0;
          (o.button === 2 || a) && s.preventDefault();
        }),
        onFocusOutside: Ce(
          n.onFocusOutside,
          (s) => s.preventDefault()
        )
      }
    );
  }
), bBe = A.forwardRef(
  (n, e) => {
    const t = _o(Nu, n.__scopeDialog), r = A.useRef(!1), i = A.useRef(!1);
    return /* @__PURE__ */ T(
      wZ,
      {
        ...n,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          n.onCloseAutoFocus?.(s), s.defaultPrevented || (r.current || t.triggerRef.current?.focus(), s.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (s) => {
          n.onInteractOutside?.(s), s.defaultPrevented || (r.current = !0, s.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const o = s.target;
          t.triggerRef.current?.contains(o) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && i.current && s.preventDefault();
        }
      }
    );
  }
), wZ = A.forwardRef(
  (n, e) => {
    const { __scopeDialog: t, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: s, ...o } = n, a = _o(Nu, t), l = A.useRef(null), c = ht(e, l);
    return i3(), /* @__PURE__ */ ee(ft, { children: [
      /* @__PURE__ */ T(
        v1,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: i,
          onUnmountAutoFocus: s,
          children: /* @__PURE__ */ T(
            Ih,
            {
              role: "dialog",
              id: a.contentId,
              "aria-describedby": a.descriptionId,
              "aria-labelledby": a.titleId,
              "data-state": sk(a.open),
              ...o,
              ref: c,
              onDismiss: () => a.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ ee(ft, { children: [
        /* @__PURE__ */ T(wBe, { titleId: a.titleId }),
        /* @__PURE__ */ T(EBe, { contentRef: l, descriptionId: a.descriptionId })
      ] })
    ] });
  }
), ik = "DialogTitle", xZ = A.forwardRef(
  (n, e) => {
    const { __scopeDialog: t, ...r } = n, i = _o(ik, t);
    return /* @__PURE__ */ T(Ve.h2, { id: i.titleId, ...r, ref: e });
  }
);
xZ.displayName = ik;
var EZ = "DialogDescription", SZ = A.forwardRef(
  (n, e) => {
    const { __scopeDialog: t, ...r } = n, i = _o(EZ, t);
    return /* @__PURE__ */ T(Ve.p, { id: i.descriptionId, ...r, ref: e });
  }
);
SZ.displayName = EZ;
var CZ = "DialogClose", TZ = A.forwardRef(
  (n, e) => {
    const { __scopeDialog: t, ...r } = n, i = _o(CZ, t);
    return /* @__PURE__ */ T(
      Ve.button,
      {
        type: "button",
        ...r,
        ref: e,
        onClick: Ce(n.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
TZ.displayName = CZ;
function sk(n) {
  return n ? "open" : "closed";
}
var AZ = "DialogTitleWarning", [Iwt, MZ] = j$e(AZ, {
  contentName: Nu,
  titleName: ik,
  docsSlug: "dialog"
}), wBe = ({ titleId: n }) => {
  const e = MZ(AZ), t = `\`${e.contentName}\` requires a \`${e.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${e.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${e.docsSlug}`;
  return A.useEffect(() => {
    n && (document.getElementById(n) || console.error(t));
  }, [t, n]), null;
}, xBe = "DialogDescriptionWarning", EBe = ({ contentRef: n, descriptionId: e }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${MZ(xBe).contentName}}.`;
  return A.useEffect(() => {
    const i = n.current?.getAttribute("aria-describedby");
    e && i && (document.getElementById(e) || console.warn(r));
  }, [r, n, e]), null;
}, l3 = hZ, ok = mZ, c3 = vZ, Rh = yZ, ad = bZ, w1 = xZ, x1 = SZ, u3 = TZ, op = '[cmdk-group=""]', d6 = '[cmdk-group-items=""]', SBe = '[cmdk-group-heading=""]', kZ = '[cmdk-item=""]', QB = `${kZ}:not([aria-disabled="true"])`, JT = "cmdk-item-select", Dd = "data-value", CBe = (n, e, t) => V$e(n, e, t), _Z = A.createContext(void 0), E1 = () => A.useContext(_Z), OZ = A.createContext(void 0), ak = () => A.useContext(OZ), IZ = A.createContext(void 0), RZ = A.forwardRef((n, e) => {
  let t = Nd(() => {
    var F, V;
    return { search: "", value: (V = (F = n.value) != null ? F : n.defaultValue) != null ? V : "", selectedItemId: void 0, filtered: { count: 0, items: /* @__PURE__ */ new Map(), groups: /* @__PURE__ */ new Set() } };
  }), r = Nd(() => /* @__PURE__ */ new Set()), i = Nd(() => /* @__PURE__ */ new Map()), s = Nd(() => /* @__PURE__ */ new Map()), o = Nd(() => /* @__PURE__ */ new Set()), a = PZ(n), { label: l, children: c, value: u, onValueChange: d, filter: f, shouldFilter: h, loop: m, disablePointerSelection: g = !1, vimBindings: v = !0, ...y } = n, b = Xn(), x = Xn(), E = Xn(), w = A.useRef(null), C = NBe();
  Lu(() => {
    if (u !== void 0) {
      let F = u.trim();
      t.current.value = F, S.emit();
    }
  }, [u]), Lu(() => {
    C(6, R);
  }, []);
  let S = A.useMemo(() => ({ subscribe: (F) => (o.current.add(F), () => o.current.delete(F)), snapshot: () => t.current, setState: (F, V, X) => {
    var Z, ie, J, se;
    if (!Object.is(t.current[F], V)) {
      if (t.current[F] = V, F === "search") I(), _(), C(1, O);
      else if (F === "value") {
        if (document.activeElement.hasAttribute("cmdk-input") || document.activeElement.hasAttribute("cmdk-root")) {
          let te = document.getElementById(E);
          te ? te.focus() : (Z = document.getElementById(b)) == null || Z.focus();
        }
        if (C(7, () => {
          var te;
          t.current.selectedItemId = (te = P()) == null ? void 0 : te.id, S.emit();
        }), X || C(5, R), ((ie = a.current) == null ? void 0 : ie.value) !== void 0) {
          let te = V ?? "";
          (se = (J = a.current).onValueChange) == null || se.call(J, te);
          return;
        }
      }
      S.emit();
    }
  }, emit: () => {
    o.current.forEach((F) => F());
  } }), []), M = A.useMemo(() => ({ value: (F, V, X) => {
    var Z;
    V !== ((Z = s.current.get(F)) == null ? void 0 : Z.value) && (s.current.set(F, { value: V, keywords: X }), t.current.filtered.items.set(F, k(V, X)), C(2, () => {
      _(), S.emit();
    }));
  }, item: (F, V) => (r.current.add(F), V && (i.current.has(V) ? i.current.get(V).add(F) : i.current.set(V, /* @__PURE__ */ new Set([F]))), C(3, () => {
    I(), _(), t.current.value || O(), S.emit();
  }), () => {
    s.current.delete(F), r.current.delete(F), t.current.filtered.items.delete(F);
    let X = P();
    C(4, () => {
      I(), X?.getAttribute("id") === F && O(), S.emit();
    });
  }), group: (F) => (i.current.has(F) || i.current.set(F, /* @__PURE__ */ new Set()), () => {
    s.current.delete(F), i.current.delete(F);
  }), filter: () => a.current.shouldFilter, label: l || n["aria-label"], getDisablePointerSelection: () => a.current.disablePointerSelection, listId: b, inputId: E, labelId: x, listInnerRef: w }), []);
  function k(F, V) {
    var X, Z;
    let ie = (Z = (X = a.current) == null ? void 0 : X.filter) != null ? Z : CBe;
    return F ? ie(F, t.current.search, V) : 0;
  }
  function _() {
    if (!t.current.search || a.current.shouldFilter === !1) return;
    let F = t.current.filtered.items, V = [];
    t.current.filtered.groups.forEach((Z) => {
      let ie = i.current.get(Z), J = 0;
      ie.forEach((se) => {
        let te = F.get(se);
        J = Math.max(te, J);
      }), V.push([Z, J]);
    });
    let X = w.current;
    D().sort((Z, ie) => {
      var J, se;
      let te = Z.getAttribute("id"), le = ie.getAttribute("id");
      return ((J = F.get(le)) != null ? J : 0) - ((se = F.get(te)) != null ? se : 0);
    }).forEach((Z) => {
      let ie = Z.closest(d6);
      ie ? ie.appendChild(Z.parentElement === ie ? Z : Z.closest(`${d6} > *`)) : X.appendChild(Z.parentElement === X ? Z : Z.closest(`${d6} > *`));
    }), V.sort((Z, ie) => ie[1] - Z[1]).forEach((Z) => {
      var ie;
      let J = (ie = w.current) == null ? void 0 : ie.querySelector(`${op}[${Dd}="${encodeURIComponent(Z[0])}"]`);
      J?.parentElement.appendChild(J);
    });
  }
  function O() {
    let F = D().find((X) => X.getAttribute("aria-disabled") !== "true"), V = F?.getAttribute(Dd);
    S.setState("value", V || void 0);
  }
  function I() {
    var F, V, X, Z;
    if (!t.current.search || a.current.shouldFilter === !1) {
      t.current.filtered.count = r.current.size;
      return;
    }
    t.current.filtered.groups = /* @__PURE__ */ new Set();
    let ie = 0;
    for (let J of r.current) {
      let se = (V = (F = s.current.get(J)) == null ? void 0 : F.value) != null ? V : "", te = (Z = (X = s.current.get(J)) == null ? void 0 : X.keywords) != null ? Z : [], le = k(se, te);
      t.current.filtered.items.set(J, le), le > 0 && ie++;
    }
    for (let [J, se] of i.current) for (let te of se) if (t.current.filtered.items.get(te) > 0) {
      t.current.filtered.groups.add(J);
      break;
    }
    t.current.filtered.count = ie;
  }
  function R() {
    var F, V, X;
    let Z = P();
    Z && (((F = Z.parentElement) == null ? void 0 : F.firstChild) === Z && ((X = (V = Z.closest(op)) == null ? void 0 : V.querySelector(SBe)) == null || X.scrollIntoView({ block: "nearest" })), Z.scrollIntoView({ block: "nearest" }));
  }
  function P() {
    var F;
    return (F = w.current) == null ? void 0 : F.querySelector(`${kZ}[aria-selected="true"]`);
  }
  function D() {
    var F;
    return Array.from(((F = w.current) == null ? void 0 : F.querySelectorAll(QB)) || []);
  }
  function L(F) {
    let V = D()[F];
    V && S.setState("value", V.getAttribute(Dd));
  }
  function B(F) {
    var V;
    let X = P(), Z = D(), ie = Z.findIndex((se) => se === X), J = Z[ie + F];
    (V = a.current) != null && V.loop && (J = ie + F < 0 ? Z[Z.length - 1] : ie + F === Z.length ? Z[0] : Z[ie + F]), J && S.setState("value", J.getAttribute(Dd));
  }
  function $(F) {
    let V = P(), X = V?.closest(op), Z;
    for (; X && !Z; ) X = F > 0 ? PBe(X, op) : DBe(X, op), Z = X?.querySelector(QB);
    Z ? S.setState("value", Z.getAttribute(Dd)) : B(F);
  }
  let z = () => L(D().length - 1), H = (F) => {
    F.preventDefault(), F.metaKey ? z() : F.altKey ? $(1) : B(1);
  }, U = (F) => {
    F.preventDefault(), F.metaKey ? L(0) : F.altKey ? $(-1) : B(-1);
  };
  return A.createElement(Ve.div, { ref: e, tabIndex: -1, ...y, "cmdk-root": "", onKeyDown: (F) => {
    var V;
    (V = y.onKeyDown) == null || V.call(y, F);
    let X = F.nativeEvent.isComposing || F.keyCode === 229;
    if (!(F.defaultPrevented || X)) switch (F.key) {
      case "n":
      case "j": {
        v && F.ctrlKey && H(F);
        break;
      }
      case "ArrowDown": {
        H(F);
        break;
      }
      case "p":
      case "k": {
        v && F.ctrlKey && U(F);
        break;
      }
      case "ArrowUp": {
        U(F);
        break;
      }
      case "Home": {
        F.preventDefault(), L(0);
        break;
      }
      case "End": {
        F.preventDefault(), z();
        break;
      }
      case "Enter": {
        F.preventDefault();
        let Z = P();
        if (Z) {
          let ie = new Event(JT);
          Z.dispatchEvent(ie);
        }
      }
    }
  } }, A.createElement("label", { "cmdk-label": "", htmlFor: M.inputId, id: M.labelId, style: $Be }, l), d3(n, (F) => A.createElement(OZ.Provider, { value: S }, A.createElement(_Z.Provider, { value: M }, F))));
}), TBe = A.forwardRef((n, e) => {
  var t, r;
  let i = Xn(), s = A.useRef(null), o = A.useContext(IZ), a = E1(), l = PZ(n), c = (r = (t = l.current) == null ? void 0 : t.forceMount) != null ? r : o?.forceMount;
  Lu(() => {
    if (!c) return a.item(i, o?.id);
  }, [c]);
  let u = DZ(i, s, [n.value, n.children, s], n.keywords), d = ak(), f = pc((C) => C.value && C.value === u.current), h = pc((C) => c || a.filter() === !1 ? !0 : C.search ? C.filtered.items.get(i) > 0 : !0);
  A.useEffect(() => {
    let C = s.current;
    if (!(!C || n.disabled)) return C.addEventListener(JT, m), () => C.removeEventListener(JT, m);
  }, [h, n.onSelect, n.disabled]);
  function m() {
    var C, S;
    g(), (S = (C = l.current).onSelect) == null || S.call(C, u.current);
  }
  function g() {
    d.setState("value", u.current, !0);
  }
  if (!h) return null;
  let { disabled: v, value: y, onSelect: b, forceMount: x, keywords: E, ...w } = n;
  return A.createElement(Ve.div, { ref: bi(s, e), ...w, id: i, "cmdk-item": "", role: "option", "aria-disabled": !!v, "aria-selected": !!f, "data-disabled": !!v, "data-selected": !!f, onPointerMove: v || a.getDisablePointerSelection() ? void 0 : g, onClick: v ? void 0 : m }, n.children);
}), ABe = A.forwardRef((n, e) => {
  let { heading: t, children: r, forceMount: i, ...s } = n, o = Xn(), a = A.useRef(null), l = A.useRef(null), c = Xn(), u = E1(), d = pc((h) => i || u.filter() === !1 ? !0 : h.search ? h.filtered.groups.has(o) : !0);
  Lu(() => u.group(o), []), DZ(o, a, [n.value, n.heading, l]);
  let f = A.useMemo(() => ({ id: o, forceMount: i }), [i]);
  return A.createElement(Ve.div, { ref: bi(a, e), ...s, "cmdk-group": "", role: "presentation", hidden: d ? void 0 : !0 }, t && A.createElement("div", { ref: l, "cmdk-group-heading": "", "aria-hidden": !0, id: c }, t), d3(n, (h) => A.createElement("div", { "cmdk-group-items": "", role: "group", "aria-labelledby": t ? c : void 0 }, A.createElement(IZ.Provider, { value: f }, h))));
}), MBe = A.forwardRef((n, e) => {
  let { alwaysRender: t, ...r } = n, i = A.useRef(null), s = pc((o) => !o.search);
  return !t && !s ? null : A.createElement(Ve.div, { ref: bi(i, e), ...r, "cmdk-separator": "", role: "separator" });
}), kBe = A.forwardRef((n, e) => {
  let { onValueChange: t, ...r } = n, i = n.value != null, s = ak(), o = pc((c) => c.search), a = pc((c) => c.selectedItemId), l = E1();
  return A.useEffect(() => {
    n.value != null && s.setState("search", n.value);
  }, [n.value]), A.createElement(Ve.input, { ref: e, ...r, "cmdk-input": "", autoComplete: "off", autoCorrect: "off", spellCheck: !1, "aria-autocomplete": "list", role: "combobox", "aria-expanded": !0, "aria-controls": l.listId, "aria-labelledby": l.labelId, "aria-activedescendant": a, id: l.inputId, type: "text", value: i ? n.value : o, onChange: (c) => {
    i || s.setState("search", c.target.value), t?.(c.target.value);
  } });
}), _Be = A.forwardRef((n, e) => {
  let { children: t, label: r = "Suggestions", ...i } = n, s = A.useRef(null), o = A.useRef(null), a = pc((c) => c.selectedItemId), l = E1();
  return A.useEffect(() => {
    if (o.current && s.current) {
      let c = o.current, u = s.current, d, f = new ResizeObserver(() => {
        d = requestAnimationFrame(() => {
          let h = c.offsetHeight;
          u.style.setProperty("--cmdk-list-height", h.toFixed(1) + "px");
        });
      });
      return f.observe(c), () => {
        cancelAnimationFrame(d), f.unobserve(c);
      };
    }
  }, []), A.createElement(Ve.div, { ref: bi(s, e), ...i, "cmdk-list": "", role: "listbox", tabIndex: -1, "aria-activedescendant": a, "aria-label": r, id: l.listId }, d3(n, (c) => A.createElement("div", { ref: bi(o, l.listInnerRef), "cmdk-list-sizer": "" }, c)));
}), OBe = A.forwardRef((n, e) => {
  let { open: t, onOpenChange: r, overlayClassName: i, contentClassName: s, container: o, ...a } = n;
  return A.createElement(l3, { open: t, onOpenChange: r }, A.createElement(c3, { container: o }, A.createElement(Rh, { "cmdk-overlay": "", className: i }), A.createElement(ad, { "aria-label": n.label, "cmdk-dialog": "", className: s }, A.createElement(RZ, { ref: e, ...a }))));
}), IBe = A.forwardRef((n, e) => pc((t) => t.filtered.count === 0) ? A.createElement(Ve.div, { ref: e, ...n, "cmdk-empty": "", role: "presentation" }) : null), RBe = A.forwardRef((n, e) => {
  let { progress: t, children: r, label: i = "Loading...", ...s } = n;
  return A.createElement(Ve.div, { ref: e, ...s, "cmdk-loading": "", role: "progressbar", "aria-valuenow": t, "aria-valuemin": 0, "aria-valuemax": 100, "aria-label": i }, d3(n, (o) => A.createElement("div", { "aria-hidden": !0 }, o)));
}), Ki = Object.assign(RZ, { List: _Be, Item: TBe, Input: kBe, Group: ABe, Separator: MBe, Dialog: OBe, Empty: IBe, Loading: RBe });
function PBe(n, e) {
  let t = n.nextElementSibling;
  for (; t; ) {
    if (t.matches(e)) return t;
    t = t.nextElementSibling;
  }
}
function DBe(n, e) {
  let t = n.previousElementSibling;
  for (; t; ) {
    if (t.matches(e)) return t;
    t = t.previousElementSibling;
  }
}
function PZ(n) {
  let e = A.useRef(n);
  return Lu(() => {
    e.current = n;
  }), e;
}
var Lu = typeof window > "u" ? A.useEffect : A.useLayoutEffect;
function Nd(n) {
  let e = A.useRef();
  return e.current === void 0 && (e.current = n()), e;
}
function pc(n) {
  let e = ak(), t = () => n(e.snapshot());
  return A.useSyncExternalStore(e.subscribe, t, t);
}
function DZ(n, e, t, r = []) {
  let i = A.useRef(), s = E1();
  return Lu(() => {
    var o;
    let a = (() => {
      var c;
      for (let u of t) {
        if (typeof u == "string") return u.trim();
        if (typeof u == "object" && "current" in u) return u.current ? (c = u.current.textContent) == null ? void 0 : c.trim() : i.current;
      }
    })(), l = r.map((c) => c.trim());
    s.value(n, a, l), (o = e.current) == null || o.setAttribute(Dd, a), i.current = a;
  }), i;
}
var NBe = () => {
  let [n, e] = A.useState(), t = Nd(() => /* @__PURE__ */ new Map());
  return Lu(() => {
    t.current.forEach((r) => r()), t.current = /* @__PURE__ */ new Map();
  }, [n]), (r, i) => {
    t.current.set(r, i), e({});
  };
};
function LBe(n) {
  let e = n.type;
  return typeof e == "function" ? e(n.props) : "render" in e ? e.render(n.props) : n;
}
function d3({ asChild: n, children: e }, t) {
  return n && A.isValidElement(e) ? A.cloneElement(LBe(e), { ref: e.ref }, t(e.props.children)) : t(e);
}
var $Be = { position: "absolute", width: "1px", height: "1px", padding: "0", margin: "-1px", overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0" };
const f3 = l3, NZ = ok, LZ = c3, FBe = u3, lk = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  Rh,
  {
    ref: t,
    className: Q(
      "tw:fixed tw:inset-0 tw:z-50 tw:bg-black/80 tw:data-[state=open]:animate-in tw:data-[state=closed]:animate-out tw:data-[state=closed]:fade-out-0 tw:data-[state=open]:fade-in-0",
      n
    ),
    ...e
  }
));
lk.displayName = Rh.displayName;
const h3 = A.forwardRef(({ className: n, children: e, ...t }, r) => /* @__PURE__ */ ee(LZ, { children: [
  /* @__PURE__ */ T(lk, {}),
  /* @__PURE__ */ ee(
    ad,
    {
      ref: r,
      className: Q(
        "tw:fixed tw:left-[50%] tw:top-[50%] tw:z-50 tw:grid tw:w-full tw:max-w-lg tw:translate-x-[-50%] tw:translate-y-[-50%] tw:gap-4 tw:border tw:bg-background tw:p-6 tw:shadow-lg tw:duration-200 tw:data-[state=open]:animate-in tw:data-[state=closed]:animate-out tw:data-[state=closed]:fade-out-0 tw:data-[state=open]:fade-in-0 tw:data-[state=closed]:zoom-out-95 tw:data-[state=open]:zoom-in-95 tw:data-[state=closed]:slide-out-to-left-1/2 tw:data-[state=closed]:slide-out-to-top-[48%] tw:data-[state=open]:slide-in-from-left-1/2 tw:data-[state=open]:slide-in-from-top-[48%] tw:sm:rounded-lg",
        n
      ),
      ...t,
      children: [
        e,
        /* @__PURE__ */ ee(u3, { className: "tw:absolute tw:right-4 tw:top-4 tw:rounded-sm tw:opacity-70 tw:ring-offset-background tw:transition-opacity tw:hover:opacity-100 tw:focus:outline-hidden tw:focus:ring-2 tw:focus:ring-ring tw:focus:ring-offset-2 tw:disabled:pointer-events-none tw:data-[state=open]:bg-accent tw:data-[state=open]:text-muted-foreground", children: [
          /* @__PURE__ */ T(YM, { className: "tw:h-4 tw:w-4" }),
          /* @__PURE__ */ T("span", { className: "tw:sr-only", children: "Close" })
        ] })
      ]
    }
  )
] }));
h3.displayName = ad.displayName;
const ck = ({
  className: n,
  ...e
}) => /* @__PURE__ */ T(
  "div",
  {
    className: Q(
      "tw:flex tw:flex-col tw:space-y-1.5 tw:text-center tw:sm:text-left",
      n
    ),
    ...e
  }
);
ck.displayName = "DialogHeader";
const $Z = ({
  className: n,
  ...e
}) => /* @__PURE__ */ T(
  "div",
  {
    className: Q(
      "tw:flex tw:flex-col-reverse tw:sm:flex-row tw:sm:justify-end tw:sm:space-x-2",
      n
    ),
    ...e
  }
);
$Z.displayName = "DialogFooter";
const p3 = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  w1,
  {
    ref: t,
    className: Q(
      "tw:text-lg tw:font-semibold tw:leading-none tw:tracking-tight",
      n
    ),
    ...e
  }
));
p3.displayName = w1.displayName;
const uk = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  x1,
  {
    ref: t,
    className: Q("tw:text-sm tw:text-muted-foreground", n),
    ...e
  }
));
uk.displayName = x1.displayName;
const m3 = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  Ki,
  {
    ref: t,
    className: Q(
      "tw:flex tw:h-full tw:w-full tw:flex-col tw:overflow-hidden tw:rounded-md tw:bg-popover tw:text-popover-foreground",
      n
    ),
    ...e
  }
));
m3.displayName = Ki.displayName;
const BBe = ({ children: n, ...e }) => /* @__PURE__ */ T(f3, { ...e, children: /* @__PURE__ */ T(h3, { className: "tw:overflow-hidden tw:p-0 tw:shadow-lg", children: /* @__PURE__ */ T(
  m3,
  {
    className: "tw:[[cmdk-group-heading]]:**:px-2 tw:[[cmdk-group-heading]]:**:font-medium tw:[[cmdk-group-heading]]:**:text-muted-foreground tw:[&_[cmdk-group]:not([hidden])_~[cmdk-group]]:pt-0 tw:[[cmdk-group]]:**:px-2 tw:[&_[cmdk-input-wrapper]_svg]:h-5 tw:[&_[cmdk-input-wrapper]_svg]:w-5 tw:[[cmdk-input]]:**:h-12 tw:[[cmdk-item]]:**:px-2 tw:[[cmdk-item]]:**:py-3 tw:[&_[cmdk-item]_svg]:h-5 tw:[&_[cmdk-item]_svg]:w-5",
    shouldFilter: !1,
    children: n
  }
) }) }), g3 = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ ee(
  "div",
  {
    className: "tw:flex tw:items-center tw:border-b tw:px-3",
    "cmdk-input-wrapper": "",
    children: [
      /* @__PURE__ */ T(iRe, { className: "tw:mr-2 tw:h-4 tw:w-4 tw:shrink-0 tw:opacity-50" }),
      /* @__PURE__ */ T(
        Ki.Input,
        {
          ref: t,
          className: Q(
            "tw:flex tw:h-11 tw:w-full tw:rounded-md tw:bg-transparent tw:py-3 tw:text-sm tw:outline-hidden tw:placeholder:text-muted-foreground tw:disabled:cursor-not-allowed tw:disabled:opacity-50",
            n
          ),
          ...e
        }
      )
    ]
  }
));
g3.displayName = Ki.Input.displayName;
const v3 = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  Ki.List,
  {
    ref: t,
    className: Q(
      "tw:max-h-[300px] tw:overflow-y-auto tw:overflow-x-hidden",
      n
    ),
    ...e
  }
));
v3.displayName = Ki.List.displayName;
const y3 = A.forwardRef((n, e) => /* @__PURE__ */ T(
  Ki.Empty,
  {
    ref: e,
    className: "tw:py-6 tw:text-center tw:text-sm",
    ...n
  }
));
y3.displayName = Ki.Empty.displayName;
const cu = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  Ki.Group,
  {
    ref: t,
    className: Q(
      "tw:overflow-hidden tw:p-1 tw:text-foreground tw:[[cmdk-group-heading]]:**:px-2 tw:[[cmdk-group-heading]]:**:py-1.5 tw:[[cmdk-group-heading]]:**:text-xs tw:[[cmdk-group-heading]]:**:font-medium tw:[[cmdk-group-heading]]:**:text-muted-foreground",
      n
    ),
    ...e
  }
));
cu.displayName = Ki.Group.displayName;
const FZ = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  Ki.Separator,
  {
    ref: t,
    className: Q("tw:-mx-1 tw:h-px tw:bg-border", n),
    ...e
  }
));
FZ.displayName = Ki.Separator.displayName;
const Ka = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  Ki.Item,
  {
    ref: t,
    className: Q(
      "tw:relative tw:flex tw:cursor-default tw:gap-2 tw:select-none tw:items-center tw:rounded-sm tw:px-2 tw:py-1.5 tw:text-sm tw:outline-hidden tw:data-[disabled=true]:pointer-events-none tw:data-[selected=true]:bg-accent tw:data-[selected=true]:text-accent-foreground tw:data-[disabled=true]:opacity-50 tw:[&_svg]:pointer-events-none tw:[&_svg]:size-4 tw:[&_svg]:shrink-0",
      n
    ),
    ...e
  }
));
Ka.displayName = Ki.Item.displayName;
const Ui = A.forwardRef(
  ({ className: n, type: e, ...t }, r) => /* @__PURE__ */ T(
    "input",
    {
      type: e,
      className: Q(
        "tw:flex tw:h-10 tw:w-full tw:rounded-md tw:border tw:border-input tw:bg-background tw:px-3 tw:py-2 tw:text-base tw:ring-offset-background tw:file:border-0 tw:file:bg-transparent tw:file:text-sm tw:file:font-medium tw:file:text-foreground tw:placeholder:text-muted-foreground tw:focus-visible:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-ring tw:focus-visible:ring-offset-2 tw:disabled:cursor-not-allowed tw:disabled:opacity-50 tw:md:text-sm",
        n
      ),
      ref: r,
      ...t
    }
  )
);
Ui.displayName = "Input";
const BZ = ["top", "right", "bottom", "left"], JB = ["start", "end"], ez = /* @__PURE__ */ BZ.reduce((n, e) => n.concat(e, e + "-" + JB[0], e + "-" + JB[1]), []), Eo = Math.min, ii = Math.max, Ty = Math.round, kg = Math.floor, ha = (n) => ({
  x: n,
  y: n
}), zBe = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, HBe = {
  start: "end",
  end: "start"
};
function e7(n, e, t) {
  return ii(n, Eo(e, t));
}
function So(n, e) {
  return typeof n == "function" ? n(e) : n;
}
function bs(n) {
  return n.split("-")[0];
}
function yo(n) {
  return n.split("-")[1];
}
function dk(n) {
  return n === "x" ? "y" : "x";
}
function fk(n) {
  return n === "y" ? "height" : "width";
}
const UBe = /* @__PURE__ */ new Set(["top", "bottom"]);
function uo(n) {
  return UBe.has(bs(n)) ? "y" : "x";
}
function hk(n) {
  return dk(uo(n));
}
function zZ(n, e, t) {
  t === void 0 && (t = !1);
  const r = yo(n), i = hk(n), s = fk(i);
  let o = i === "x" ? r === (t ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return e.reference[s] > e.floating[s] && (o = My(o)), [o, My(o)];
}
function VBe(n) {
  const e = My(n);
  return [Ay(n), e, Ay(e)];
}
function Ay(n) {
  return n.replace(/start|end/g, (e) => HBe[e]);
}
const tz = ["left", "right"], nz = ["right", "left"], jBe = ["top", "bottom"], WBe = ["bottom", "top"];
function GBe(n, e, t) {
  switch (n) {
    case "top":
    case "bottom":
      return t ? e ? nz : tz : e ? tz : nz;
    case "left":
    case "right":
      return e ? jBe : WBe;
    default:
      return [];
  }
}
function KBe(n, e, t, r) {
  const i = yo(n);
  let s = GBe(bs(n), t === "start", r);
  return i && (s = s.map((o) => o + "-" + i), e && (s = s.concat(s.map(Ay)))), s;
}
function My(n) {
  return n.replace(/left|right|bottom|top/g, (e) => zBe[e]);
}
function qBe(n) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...n
  };
}
function pk(n) {
  return typeof n != "number" ? qBe(n) : {
    top: n,
    right: n,
    bottom: n,
    left: n
  };
}
function qf(n) {
  const {
    x: e,
    y: t,
    width: r,
    height: i
  } = n;
  return {
    width: r,
    height: i,
    top: t,
    left: e,
    right: e + r,
    bottom: t + i,
    x: e,
    y: t
  };
}
function rz(n, e, t) {
  let {
    reference: r,
    floating: i
  } = n;
  const s = uo(e), o = hk(e), a = fk(o), l = bs(e), c = s === "y", u = r.x + r.width / 2 - i.width / 2, d = r.y + r.height / 2 - i.height / 2, f = r[a] / 2 - i[a] / 2;
  let h;
  switch (l) {
    case "top":
      h = {
        x: u,
        y: r.y - i.height
      };
      break;
    case "bottom":
      h = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      h = {
        x: r.x + r.width,
        y: d
      };
      break;
    case "left":
      h = {
        x: r.x - i.width,
        y: d
      };
      break;
    default:
      h = {
        x: r.x,
        y: r.y
      };
  }
  switch (yo(e)) {
    case "start":
      h[o] -= f * (t && c ? -1 : 1);
      break;
    case "end":
      h[o] += f * (t && c ? -1 : 1);
      break;
  }
  return h;
}
const YBe = async (n, e, t) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: s = [],
    platform: o
  } = t, a = s.filter(Boolean), l = await (o.isRTL == null ? void 0 : o.isRTL(e));
  let c = await o.getElementRects({
    reference: n,
    floating: e,
    strategy: i
  }), {
    x: u,
    y: d
  } = rz(c, r, l), f = r, h = {}, m = 0;
  for (let g = 0; g < a.length; g++) {
    const {
      name: v,
      fn: y
    } = a[g], {
      x: b,
      y: x,
      data: E,
      reset: w
    } = await y({
      x: u,
      y: d,
      initialPlacement: r,
      placement: f,
      strategy: i,
      middlewareData: h,
      rects: c,
      platform: o,
      elements: {
        reference: n,
        floating: e
      }
    });
    u = b ?? u, d = x ?? d, h = {
      ...h,
      [v]: {
        ...h[v],
        ...E
      }
    }, w && m <= 50 && (m++, typeof w == "object" && (w.placement && (f = w.placement), w.rects && (c = w.rects === !0 ? await o.getElementRects({
      reference: n,
      floating: e,
      strategy: i
    }) : w.rects), {
      x: u,
      y: d
    } = rz(c, f, l)), g = -1);
  }
  return {
    x: u,
    y: d,
    placement: f,
    strategy: i,
    middlewareData: h
  };
};
async function Yf(n, e) {
  var t;
  e === void 0 && (e = {});
  const {
    x: r,
    y: i,
    platform: s,
    rects: o,
    elements: a,
    strategy: l
  } = n, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: f = !1,
    padding: h = 0
  } = So(e, n), m = pk(h), v = a[f ? d === "floating" ? "reference" : "floating" : d], y = qf(await s.getClippingRect({
    element: (t = await (s.isElement == null ? void 0 : s.isElement(v))) == null || t ? v : v.contextElement || await (s.getDocumentElement == null ? void 0 : s.getDocumentElement(a.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), b = d === "floating" ? {
    x: r,
    y: i,
    width: o.floating.width,
    height: o.floating.height
  } : o.reference, x = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(a.floating)), E = await (s.isElement == null ? void 0 : s.isElement(x)) ? await (s.getScale == null ? void 0 : s.getScale(x)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, w = qf(s.convertOffsetParentRelativeRectToViewportRelativeRect ? await s.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: b,
    offsetParent: x,
    strategy: l
  }) : b);
  return {
    top: (y.top - w.top + m.top) / E.y,
    bottom: (w.bottom - y.bottom + m.bottom) / E.y,
    left: (y.left - w.left + m.left) / E.x,
    right: (w.right - y.right + m.right) / E.x
  };
}
const XBe = (n) => ({
  name: "arrow",
  options: n,
  async fn(e) {
    const {
      x: t,
      y: r,
      placement: i,
      rects: s,
      platform: o,
      elements: a,
      middlewareData: l
    } = e, {
      element: c,
      padding: u = 0
    } = So(n, e) || {};
    if (c == null)
      return {};
    const d = pk(u), f = {
      x: t,
      y: r
    }, h = hk(i), m = fk(h), g = await o.getDimensions(c), v = h === "y", y = v ? "top" : "left", b = v ? "bottom" : "right", x = v ? "clientHeight" : "clientWidth", E = s.reference[m] + s.reference[h] - f[h] - s.floating[m], w = f[h] - s.reference[h], C = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(c));
    let S = C ? C[x] : 0;
    (!S || !await (o.isElement == null ? void 0 : o.isElement(C))) && (S = a.floating[x] || s.floating[m]);
    const M = E / 2 - w / 2, k = S / 2 - g[m] / 2 - 1, _ = Eo(d[y], k), O = Eo(d[b], k), I = _, R = S - g[m] - O, P = S / 2 - g[m] / 2 + M, D = e7(I, P, R), L = !l.arrow && yo(i) != null && P !== D && s.reference[m] / 2 - (P < I ? _ : O) - g[m] / 2 < 0, B = L ? P < I ? P - I : P - R : 0;
    return {
      [h]: f[h] + B,
      data: {
        [h]: D,
        centerOffset: P - D - B,
        ...L && {
          alignmentOffset: B
        }
      },
      reset: L
    };
  }
});
function ZBe(n, e, t) {
  return (n ? [...t.filter((i) => yo(i) === n), ...t.filter((i) => yo(i) !== n)] : t.filter((i) => bs(i) === i)).filter((i) => n ? yo(i) === n || (e ? Ay(i) !== i : !1) : !0);
}
const QBe = function(n) {
  return n === void 0 && (n = {}), {
    name: "autoPlacement",
    options: n,
    async fn(e) {
      var t, r, i;
      const {
        rects: s,
        middlewareData: o,
        placement: a,
        platform: l,
        elements: c
      } = e, {
        crossAxis: u = !1,
        alignment: d,
        allowedPlacements: f = ez,
        autoAlignment: h = !0,
        ...m
      } = So(n, e), g = d !== void 0 || f === ez ? ZBe(d || null, h, f) : f, v = await Yf(e, m), y = ((t = o.autoPlacement) == null ? void 0 : t.index) || 0, b = g[y];
      if (b == null)
        return {};
      const x = zZ(b, s, await (l.isRTL == null ? void 0 : l.isRTL(c.floating)));
      if (a !== b)
        return {
          reset: {
            placement: g[0]
          }
        };
      const E = [v[bs(b)], v[x[0]], v[x[1]]], w = [...((r = o.autoPlacement) == null ? void 0 : r.overflows) || [], {
        placement: b,
        overflows: E
      }], C = g[y + 1];
      if (C)
        return {
          data: {
            index: y + 1,
            overflows: w
          },
          reset: {
            placement: C
          }
        };
      const S = w.map((_) => {
        const O = yo(_.placement);
        return [_.placement, O && u ? (
          // Check along the mainAxis and main crossAxis side.
          _.overflows.slice(0, 2).reduce((I, R) => I + R, 0)
        ) : (
          // Check only the mainAxis.
          _.overflows[0]
        ), _.overflows];
      }).sort((_, O) => _[1] - O[1]), k = ((i = S.filter((_) => _[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        yo(_[0]) ? 2 : 3
      ).every((O) => O <= 0))[0]) == null ? void 0 : i[0]) || S[0][0];
      return k !== a ? {
        data: {
          index: y + 1,
          overflows: w
        },
        reset: {
          placement: k
        }
      } : {};
    }
  };
}, JBe = function(n) {
  return n === void 0 && (n = {}), {
    name: "flip",
    options: n,
    async fn(e) {
      var t, r;
      const {
        placement: i,
        middlewareData: s,
        rects: o,
        initialPlacement: a,
        platform: l,
        elements: c
      } = e, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: f,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: g = !0,
        ...v
      } = So(n, e);
      if ((t = s.arrow) != null && t.alignmentOffset)
        return {};
      const y = bs(i), b = uo(a), x = bs(a) === a, E = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), w = f || (x || !g ? [My(a)] : VBe(a)), C = m !== "none";
      !f && C && w.push(...KBe(a, g, m, E));
      const S = [a, ...w], M = await Yf(e, v), k = [];
      let _ = ((r = s.flip) == null ? void 0 : r.overflows) || [];
      if (u && k.push(M[y]), d) {
        const P = zZ(i, o, E);
        k.push(M[P[0]], M[P[1]]);
      }
      if (_ = [..._, {
        placement: i,
        overflows: k
      }], !k.every((P) => P <= 0)) {
        var O, I;
        const P = (((O = s.flip) == null ? void 0 : O.index) || 0) + 1, D = S[P];
        if (D && (!(d === "alignment" ? b !== uo(D) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        _.every(($) => uo($.placement) === b ? $.overflows[0] > 0 : !0)))
          return {
            data: {
              index: P,
              overflows: _
            },
            reset: {
              placement: D
            }
          };
        let L = (I = _.filter((B) => B.overflows[0] <= 0).sort((B, $) => B.overflows[1] - $.overflows[1])[0]) == null ? void 0 : I.placement;
        if (!L)
          switch (h) {
            case "bestFit": {
              var R;
              const B = (R = _.filter(($) => {
                if (C) {
                  const z = uo($.placement);
                  return z === b || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  z === "y";
                }
                return !0;
              }).map(($) => [$.placement, $.overflows.filter((z) => z > 0).reduce((z, H) => z + H, 0)]).sort(($, z) => $[1] - z[1])[0]) == null ? void 0 : R[0];
              B && (L = B);
              break;
            }
            case "initialPlacement":
              L = a;
              break;
          }
        if (i !== L)
          return {
            reset: {
              placement: L
            }
          };
      }
      return {};
    }
  };
};
function iz(n, e) {
  return {
    top: n.top - e.height,
    right: n.right - e.width,
    bottom: n.bottom - e.height,
    left: n.left - e.width
  };
}
function sz(n) {
  return BZ.some((e) => n[e] >= 0);
}
const eze = function(n) {
  return n === void 0 && (n = {}), {
    name: "hide",
    options: n,
    async fn(e) {
      const {
        rects: t
      } = e, {
        strategy: r = "referenceHidden",
        ...i
      } = So(n, e);
      switch (r) {
        case "referenceHidden": {
          const s = await Yf(e, {
            ...i,
            elementContext: "reference"
          }), o = iz(s, t.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: sz(o)
            }
          };
        }
        case "escaped": {
          const s = await Yf(e, {
            ...i,
            altBoundary: !0
          }), o = iz(s, t.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: sz(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
function HZ(n) {
  const e = Eo(...n.map((s) => s.left)), t = Eo(...n.map((s) => s.top)), r = ii(...n.map((s) => s.right)), i = ii(...n.map((s) => s.bottom));
  return {
    x: e,
    y: t,
    width: r - e,
    height: i - t
  };
}
function tze(n) {
  const e = n.slice().sort((i, s) => i.y - s.y), t = [];
  let r = null;
  for (let i = 0; i < e.length; i++) {
    const s = e[i];
    !r || s.y - r.y > r.height / 2 ? t.push([s]) : t[t.length - 1].push(s), r = s;
  }
  return t.map((i) => qf(HZ(i)));
}
const nze = function(n) {
  return n === void 0 && (n = {}), {
    name: "inline",
    options: n,
    async fn(e) {
      const {
        placement: t,
        elements: r,
        rects: i,
        platform: s,
        strategy: o
      } = e, {
        padding: a = 2,
        x: l,
        y: c
      } = So(n, e), u = Array.from(await (s.getClientRects == null ? void 0 : s.getClientRects(r.reference)) || []), d = tze(u), f = qf(HZ(u)), h = pk(a);
      function m() {
        if (d.length === 2 && d[0].left > d[1].right && l != null && c != null)
          return d.find((v) => l > v.left - h.left && l < v.right + h.right && c > v.top - h.top && c < v.bottom + h.bottom) || f;
        if (d.length >= 2) {
          if (uo(t) === "y") {
            const _ = d[0], O = d[d.length - 1], I = bs(t) === "top", R = _.top, P = O.bottom, D = I ? _.left : O.left, L = I ? _.right : O.right, B = L - D, $ = P - R;
            return {
              top: R,
              bottom: P,
              left: D,
              right: L,
              width: B,
              height: $,
              x: D,
              y: R
            };
          }
          const v = bs(t) === "left", y = ii(...d.map((_) => _.right)), b = Eo(...d.map((_) => _.left)), x = d.filter((_) => v ? _.left === b : _.right === y), E = x[0].top, w = x[x.length - 1].bottom, C = b, S = y, M = S - C, k = w - E;
          return {
            top: E,
            bottom: w,
            left: C,
            right: S,
            width: M,
            height: k,
            x: C,
            y: E
          };
        }
        return f;
      }
      const g = await s.getElementRects({
        reference: {
          getBoundingClientRect: m
        },
        floating: r.floating,
        strategy: o
      });
      return i.reference.x !== g.reference.x || i.reference.y !== g.reference.y || i.reference.width !== g.reference.width || i.reference.height !== g.reference.height ? {
        reset: {
          rects: g
        }
      } : {};
    }
  };
}, UZ = /* @__PURE__ */ new Set(["left", "top"]);
async function rze(n, e) {
  const {
    placement: t,
    platform: r,
    elements: i
  } = n, s = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), o = bs(t), a = yo(t), l = uo(t) === "y", c = UZ.has(o) ? -1 : 1, u = s && l ? -1 : 1, d = So(e, n);
  let {
    mainAxis: f,
    crossAxis: h,
    alignmentAxis: m
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return a && typeof m == "number" && (h = a === "end" ? m * -1 : m), l ? {
    x: h * u,
    y: f * c
  } : {
    x: f * c,
    y: h * u
  };
}
const ize = function(n) {
  return n === void 0 && (n = 0), {
    name: "offset",
    options: n,
    async fn(e) {
      var t, r;
      const {
        x: i,
        y: s,
        placement: o,
        middlewareData: a
      } = e, l = await rze(e, n);
      return o === ((t = a.offset) == null ? void 0 : t.placement) && (r = a.arrow) != null && r.alignmentOffset ? {} : {
        x: i + l.x,
        y: s + l.y,
        data: {
          ...l,
          placement: o
        }
      };
    }
  };
}, sze = function(n) {
  return n === void 0 && (n = {}), {
    name: "shift",
    options: n,
    async fn(e) {
      const {
        x: t,
        y: r,
        placement: i
      } = e, {
        mainAxis: s = !0,
        crossAxis: o = !1,
        limiter: a = {
          fn: (v) => {
            let {
              x: y,
              y: b
            } = v;
            return {
              x: y,
              y: b
            };
          }
        },
        ...l
      } = So(n, e), c = {
        x: t,
        y: r
      }, u = await Yf(e, l), d = uo(bs(i)), f = dk(d);
      let h = c[f], m = c[d];
      if (s) {
        const v = f === "y" ? "top" : "left", y = f === "y" ? "bottom" : "right", b = h + u[v], x = h - u[y];
        h = e7(b, h, x);
      }
      if (o) {
        const v = d === "y" ? "top" : "left", y = d === "y" ? "bottom" : "right", b = m + u[v], x = m - u[y];
        m = e7(b, m, x);
      }
      const g = a.fn({
        ...e,
        [f]: h,
        [d]: m
      });
      return {
        ...g,
        data: {
          x: g.x - t,
          y: g.y - r,
          enabled: {
            [f]: s,
            [d]: o
          }
        }
      };
    }
  };
}, oze = function(n) {
  return n === void 0 && (n = {}), {
    options: n,
    fn(e) {
      const {
        x: t,
        y: r,
        placement: i,
        rects: s,
        middlewareData: o
      } = e, {
        offset: a = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = So(n, e), u = {
        x: t,
        y: r
      }, d = uo(i), f = dk(d);
      let h = u[f], m = u[d];
      const g = So(a, e), v = typeof g == "number" ? {
        mainAxis: g,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...g
      };
      if (l) {
        const x = f === "y" ? "height" : "width", E = s.reference[f] - s.floating[x] + v.mainAxis, w = s.reference[f] + s.reference[x] - v.mainAxis;
        h < E ? h = E : h > w && (h = w);
      }
      if (c) {
        var y, b;
        const x = f === "y" ? "width" : "height", E = UZ.has(bs(i)), w = s.reference[d] - s.floating[x] + (E && ((y = o.offset) == null ? void 0 : y[d]) || 0) + (E ? 0 : v.crossAxis), C = s.reference[d] + s.reference[x] + (E ? 0 : ((b = o.offset) == null ? void 0 : b[d]) || 0) - (E ? v.crossAxis : 0);
        m < w ? m = w : m > C && (m = C);
      }
      return {
        [f]: h,
        [d]: m
      };
    }
  };
}, aze = function(n) {
  return n === void 0 && (n = {}), {
    name: "size",
    options: n,
    async fn(e) {
      var t, r;
      const {
        placement: i,
        rects: s,
        platform: o,
        elements: a
      } = e, {
        apply: l = () => {
        },
        ...c
      } = So(n, e), u = await Yf(e, c), d = bs(i), f = yo(i), h = uo(i) === "y", {
        width: m,
        height: g
      } = s.floating;
      let v, y;
      d === "top" || d === "bottom" ? (v = d, y = f === (await (o.isRTL == null ? void 0 : o.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (y = d, v = f === "end" ? "top" : "bottom");
      const b = g - u.top - u.bottom, x = m - u.left - u.right, E = Eo(g - u[v], b), w = Eo(m - u[y], x), C = !e.middlewareData.shift;
      let S = E, M = w;
      if ((t = e.middlewareData.shift) != null && t.enabled.x && (M = x), (r = e.middlewareData.shift) != null && r.enabled.y && (S = b), C && !f) {
        const _ = ii(u.left, 0), O = ii(u.right, 0), I = ii(u.top, 0), R = ii(u.bottom, 0);
        h ? M = m - 2 * (_ !== 0 || O !== 0 ? _ + O : ii(u.left, u.right)) : S = g - 2 * (I !== 0 || R !== 0 ? I + R : ii(u.top, u.bottom));
      }
      await l({
        ...e,
        availableWidth: M,
        availableHeight: S
      });
      const k = await o.getDimensions(a.floating);
      return m !== k.width || g !== k.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function b3() {
  return typeof window < "u";
}
function Ph(n) {
  return VZ(n) ? (n.nodeName || "").toLowerCase() : "#document";
}
function ms(n) {
  var e;
  return (n == null || (e = n.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function Ca(n) {
  var e;
  return (e = (VZ(n) ? n.ownerDocument : n.document) || window.document) == null ? void 0 : e.documentElement;
}
function VZ(n) {
  return b3() ? n instanceof Node || n instanceof ms(n).Node : !1;
}
function Co(n) {
  return b3() ? n instanceof Element || n instanceof ms(n).Element : !1;
}
function va(n) {
  return b3() ? n instanceof HTMLElement || n instanceof ms(n).HTMLElement : !1;
}
function oz(n) {
  return !b3() || typeof ShadowRoot > "u" ? !1 : n instanceof ShadowRoot || n instanceof ms(n).ShadowRoot;
}
const lze = /* @__PURE__ */ new Set(["inline", "contents"]);
function S1(n) {
  const {
    overflow: e,
    overflowX: t,
    overflowY: r,
    display: i
  } = To(n);
  return /auto|scroll|overlay|hidden|clip/.test(e + r + t) && !lze.has(i);
}
const cze = /* @__PURE__ */ new Set(["table", "td", "th"]);
function uze(n) {
  return cze.has(Ph(n));
}
const dze = [":popover-open", ":modal"];
function w3(n) {
  return dze.some((e) => {
    try {
      return n.matches(e);
    } catch {
      return !1;
    }
  });
}
const fze = ["transform", "translate", "scale", "rotate", "perspective"], hze = ["transform", "translate", "scale", "rotate", "perspective", "filter"], pze = ["paint", "layout", "strict", "content"];
function mk(n) {
  const e = gk(), t = Co(n) ? To(n) : n;
  return fze.some((r) => t[r] ? t[r] !== "none" : !1) || (t.containerType ? t.containerType !== "normal" : !1) || !e && (t.backdropFilter ? t.backdropFilter !== "none" : !1) || !e && (t.filter ? t.filter !== "none" : !1) || hze.some((r) => (t.willChange || "").includes(r)) || pze.some((r) => (t.contain || "").includes(r));
}
function mze(n) {
  let e = mc(n);
  for (; va(e) && !Xf(e); ) {
    if (mk(e))
      return e;
    if (w3(e))
      return null;
    e = mc(e);
  }
  return null;
}
function gk() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const gze = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Xf(n) {
  return gze.has(Ph(n));
}
function To(n) {
  return ms(n).getComputedStyle(n);
}
function x3(n) {
  return Co(n) ? {
    scrollLeft: n.scrollLeft,
    scrollTop: n.scrollTop
  } : {
    scrollLeft: n.scrollX,
    scrollTop: n.scrollY
  };
}
function mc(n) {
  if (Ph(n) === "html")
    return n;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    n.assignedSlot || // DOM Element detected.
    n.parentNode || // ShadowRoot detected.
    oz(n) && n.host || // Fallback.
    Ca(n)
  );
  return oz(e) ? e.host : e;
}
function jZ(n) {
  const e = mc(n);
  return Xf(e) ? n.ownerDocument ? n.ownerDocument.body : n.body : va(e) && S1(e) ? e : jZ(e);
}
function f0(n, e, t) {
  var r;
  e === void 0 && (e = []), t === void 0 && (t = !0);
  const i = jZ(n), s = i === ((r = n.ownerDocument) == null ? void 0 : r.body), o = ms(i);
  if (s) {
    const a = t7(o);
    return e.concat(o, o.visualViewport || [], S1(i) ? i : [], a && t ? f0(a) : []);
  }
  return e.concat(i, f0(i, [], t));
}
function t7(n) {
  return n.parent && Object.getPrototypeOf(n.parent) ? n.frameElement : null;
}
function WZ(n) {
  const e = To(n);
  let t = parseFloat(e.width) || 0, r = parseFloat(e.height) || 0;
  const i = va(n), s = i ? n.offsetWidth : t, o = i ? n.offsetHeight : r, a = Ty(t) !== s || Ty(r) !== o;
  return a && (t = s, r = o), {
    width: t,
    height: r,
    $: a
  };
}
function vk(n) {
  return Co(n) ? n : n.contextElement;
}
function uf(n) {
  const e = vk(n);
  if (!va(e))
    return ha(1);
  const t = e.getBoundingClientRect(), {
    width: r,
    height: i,
    $: s
  } = WZ(e);
  let o = (s ? Ty(t.width) : t.width) / r, a = (s ? Ty(t.height) : t.height) / i;
  return (!o || !Number.isFinite(o)) && (o = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: o,
    y: a
  };
}
const vze = /* @__PURE__ */ ha(0);
function GZ(n) {
  const e = ms(n);
  return !gk() || !e.visualViewport ? vze : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function yze(n, e, t) {
  return e === void 0 && (e = !1), !t || e && t !== ms(n) ? !1 : e;
}
function $u(n, e, t, r) {
  e === void 0 && (e = !1), t === void 0 && (t = !1);
  const i = n.getBoundingClientRect(), s = vk(n);
  let o = ha(1);
  e && (r ? Co(r) && (o = uf(r)) : o = uf(n));
  const a = yze(s, t, r) ? GZ(s) : ha(0);
  let l = (i.left + a.x) / o.x, c = (i.top + a.y) / o.y, u = i.width / o.x, d = i.height / o.y;
  if (s) {
    const f = ms(s), h = r && Co(r) ? ms(r) : r;
    let m = f, g = t7(m);
    for (; g && r && h !== m; ) {
      const v = uf(g), y = g.getBoundingClientRect(), b = To(g), x = y.left + (g.clientLeft + parseFloat(b.paddingLeft)) * v.x, E = y.top + (g.clientTop + parseFloat(b.paddingTop)) * v.y;
      l *= v.x, c *= v.y, u *= v.x, d *= v.y, l += x, c += E, m = ms(g), g = t7(m);
    }
  }
  return qf({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function E3(n, e) {
  const t = x3(n).scrollLeft;
  return e ? e.left + t : $u(Ca(n)).left + t;
}
function KZ(n, e) {
  const t = n.getBoundingClientRect(), r = t.left + e.scrollLeft - E3(n, t), i = t.top + e.scrollTop;
  return {
    x: r,
    y: i
  };
}
function bze(n) {
  let {
    elements: e,
    rect: t,
    offsetParent: r,
    strategy: i
  } = n;
  const s = i === "fixed", o = Ca(r), a = e ? w3(e.floating) : !1;
  if (r === o || a && s)
    return t;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = ha(1);
  const u = ha(0), d = va(r);
  if ((d || !d && !s) && ((Ph(r) !== "body" || S1(o)) && (l = x3(r)), va(r))) {
    const h = $u(r);
    c = uf(r), u.x = h.x + r.clientLeft, u.y = h.y + r.clientTop;
  }
  const f = o && !d && !s ? KZ(o, l) : ha(0);
  return {
    width: t.width * c.x,
    height: t.height * c.y,
    x: t.x * c.x - l.scrollLeft * c.x + u.x + f.x,
    y: t.y * c.y - l.scrollTop * c.y + u.y + f.y
  };
}
function wze(n) {
  return Array.from(n.getClientRects());
}
function xze(n) {
  const e = Ca(n), t = x3(n), r = n.ownerDocument.body, i = ii(e.scrollWidth, e.clientWidth, r.scrollWidth, r.clientWidth), s = ii(e.scrollHeight, e.clientHeight, r.scrollHeight, r.clientHeight);
  let o = -t.scrollLeft + E3(n);
  const a = -t.scrollTop;
  return To(r).direction === "rtl" && (o += ii(e.clientWidth, r.clientWidth) - i), {
    width: i,
    height: s,
    x: o,
    y: a
  };
}
const az = 25;
function Eze(n, e) {
  const t = ms(n), r = Ca(n), i = t.visualViewport;
  let s = r.clientWidth, o = r.clientHeight, a = 0, l = 0;
  if (i) {
    s = i.width, o = i.height;
    const u = gk();
    (!u || u && e === "fixed") && (a = i.offsetLeft, l = i.offsetTop);
  }
  const c = E3(r);
  if (c <= 0) {
    const u = r.ownerDocument, d = u.body, f = getComputedStyle(d), h = u.compatMode === "CSS1Compat" && parseFloat(f.marginLeft) + parseFloat(f.marginRight) || 0, m = Math.abs(r.clientWidth - d.clientWidth - h);
    m <= az && (s -= m);
  } else c <= az && (s += c);
  return {
    width: s,
    height: o,
    x: a,
    y: l
  };
}
const Sze = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function Cze(n, e) {
  const t = $u(n, !0, e === "fixed"), r = t.top + n.clientTop, i = t.left + n.clientLeft, s = va(n) ? uf(n) : ha(1), o = n.clientWidth * s.x, a = n.clientHeight * s.y, l = i * s.x, c = r * s.y;
  return {
    width: o,
    height: a,
    x: l,
    y: c
  };
}
function lz(n, e, t) {
  let r;
  if (e === "viewport")
    r = Eze(n, t);
  else if (e === "document")
    r = xze(Ca(n));
  else if (Co(e))
    r = Cze(e, t);
  else {
    const i = GZ(n);
    r = {
      x: e.x - i.x,
      y: e.y - i.y,
      width: e.width,
      height: e.height
    };
  }
  return qf(r);
}
function qZ(n, e) {
  const t = mc(n);
  return t === e || !Co(t) || Xf(t) ? !1 : To(t).position === "fixed" || qZ(t, e);
}
function Tze(n, e) {
  const t = e.get(n);
  if (t)
    return t;
  let r = f0(n, [], !1).filter((a) => Co(a) && Ph(a) !== "body"), i = null;
  const s = To(n).position === "fixed";
  let o = s ? mc(n) : n;
  for (; Co(o) && !Xf(o); ) {
    const a = To(o), l = mk(o);
    !l && a.position === "fixed" && (i = null), (s ? !l && !i : !l && a.position === "static" && !!i && Sze.has(i.position) || S1(o) && !l && qZ(n, o)) ? r = r.filter((u) => u !== o) : i = a, o = mc(o);
  }
  return e.set(n, r), r;
}
function Aze(n) {
  let {
    element: e,
    boundary: t,
    rootBoundary: r,
    strategy: i
  } = n;
  const o = [...t === "clippingAncestors" ? w3(e) ? [] : Tze(e, this._c) : [].concat(t), r], a = o[0], l = o.reduce((c, u) => {
    const d = lz(e, u, i);
    return c.top = ii(d.top, c.top), c.right = Eo(d.right, c.right), c.bottom = Eo(d.bottom, c.bottom), c.left = ii(d.left, c.left), c;
  }, lz(e, a, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function Mze(n) {
  const {
    width: e,
    height: t
  } = WZ(n);
  return {
    width: e,
    height: t
  };
}
function kze(n, e, t) {
  const r = va(e), i = Ca(e), s = t === "fixed", o = $u(n, !0, s, e);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = ha(0);
  function c() {
    l.x = E3(i);
  }
  if (r || !r && !s)
    if ((Ph(e) !== "body" || S1(i)) && (a = x3(e)), r) {
      const h = $u(e, !0, s, e);
      l.x = h.x + e.clientLeft, l.y = h.y + e.clientTop;
    } else i && c();
  s && !r && i && c();
  const u = i && !r && !s ? KZ(i, a) : ha(0), d = o.left + a.scrollLeft - l.x - u.x, f = o.top + a.scrollTop - l.y - u.y;
  return {
    x: d,
    y: f,
    width: o.width,
    height: o.height
  };
}
function f6(n) {
  return To(n).position === "static";
}
function cz(n, e) {
  if (!va(n) || To(n).position === "fixed")
    return null;
  if (e)
    return e(n);
  let t = n.offsetParent;
  return Ca(n) === t && (t = t.ownerDocument.body), t;
}
function YZ(n, e) {
  const t = ms(n);
  if (w3(n))
    return t;
  if (!va(n)) {
    let i = mc(n);
    for (; i && !Xf(i); ) {
      if (Co(i) && !f6(i))
        return i;
      i = mc(i);
    }
    return t;
  }
  let r = cz(n, e);
  for (; r && uze(r) && f6(r); )
    r = cz(r, e);
  return r && Xf(r) && f6(r) && !mk(r) ? t : r || mze(n) || t;
}
const _ze = async function(n) {
  const e = this.getOffsetParent || YZ, t = this.getDimensions, r = await t(n.floating);
  return {
    reference: kze(n.reference, await e(n.floating), n.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Oze(n) {
  return To(n).direction === "rtl";
}
const Ize = {
  convertOffsetParentRelativeRectToViewportRelativeRect: bze,
  getDocumentElement: Ca,
  getClippingRect: Aze,
  getOffsetParent: YZ,
  getElementRects: _ze,
  getClientRects: wze,
  getDimensions: Mze,
  getScale: uf,
  isElement: Co,
  isRTL: Oze
};
function XZ(n, e) {
  return n.x === e.x && n.y === e.y && n.width === e.width && n.height === e.height;
}
function Rze(n, e) {
  let t = null, r;
  const i = Ca(n);
  function s() {
    var a;
    clearTimeout(r), (a = t) == null || a.disconnect(), t = null;
  }
  function o(a, l) {
    a === void 0 && (a = !1), l === void 0 && (l = 1), s();
    const c = n.getBoundingClientRect(), {
      left: u,
      top: d,
      width: f,
      height: h
    } = c;
    if (a || e(), !f || !h)
      return;
    const m = kg(d), g = kg(i.clientWidth - (u + f)), v = kg(i.clientHeight - (d + h)), y = kg(u), x = {
      rootMargin: -m + "px " + -g + "px " + -v + "px " + -y + "px",
      threshold: ii(0, Eo(1, l)) || 1
    };
    let E = !0;
    function w(C) {
      const S = C[0].intersectionRatio;
      if (S !== l) {
        if (!E)
          return o();
        S ? o(!1, S) : r = setTimeout(() => {
          o(!1, 1e-7);
        }, 1e3);
      }
      S === 1 && !XZ(c, n.getBoundingClientRect()) && o(), E = !1;
    }
    try {
      t = new IntersectionObserver(w, {
        ...x,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      t = new IntersectionObserver(w, x);
    }
    t.observe(n);
  }
  return o(!0), s;
}
function Pze(n, e, t, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: s = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, c = vk(n), u = i || s ? [...c ? f0(c) : [], ...f0(e)] : [];
  u.forEach((y) => {
    i && y.addEventListener("scroll", t, {
      passive: !0
    }), s && y.addEventListener("resize", t);
  });
  const d = c && a ? Rze(c, t) : null;
  let f = -1, h = null;
  o && (h = new ResizeObserver((y) => {
    let [b] = y;
    b && b.target === c && h && (h.unobserve(e), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var x;
      (x = h) == null || x.observe(e);
    })), t();
  }), c && !l && h.observe(c), h.observe(e));
  let m, g = l ? $u(n) : null;
  l && v();
  function v() {
    const y = $u(n);
    g && !XZ(g, y) && t(), g = y, m = requestAnimationFrame(v);
  }
  return t(), () => {
    var y;
    u.forEach((b) => {
      i && b.removeEventListener("scroll", t), s && b.removeEventListener("resize", t);
    }), d?.(), (y = h) == null || y.disconnect(), h = null, l && cancelAnimationFrame(m);
  };
}
const yk = ize, ZZ = QBe, bk = sze, wk = JBe, xk = aze, Ek = eze, ky = XBe, QZ = nze, Dze = oze, Sk = (n, e, t) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: Ize,
    ...t
  }, s = {
    ...i.platform,
    _c: r
  };
  return YBe(n, e, {
    ...i,
    platform: s
  });
};
var Nze = typeof document < "u", Lze = function() {
}, Hv = Nze ? vh : Lze;
function _y(n, e) {
  if (n === e)
    return !0;
  if (typeof n != typeof e)
    return !1;
  if (typeof n == "function" && n.toString() === e.toString())
    return !0;
  let t, r, i;
  if (n && e && typeof n == "object") {
    if (Array.isArray(n)) {
      if (t = n.length, t !== e.length) return !1;
      for (r = t; r-- !== 0; )
        if (!_y(n[r], e[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(n), t = i.length, t !== Object.keys(e).length)
      return !1;
    for (r = t; r-- !== 0; )
      if (!{}.hasOwnProperty.call(e, i[r]))
        return !1;
    for (r = t; r-- !== 0; ) {
      const s = i[r];
      if (!(s === "_owner" && n.$$typeof) && !_y(n[s], e[s]))
        return !1;
    }
    return !0;
  }
  return n !== n && e !== e;
}
function JZ(n) {
  return typeof window > "u" ? 1 : (n.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function uz(n, e) {
  const t = JZ(n);
  return Math.round(e * t) / t;
}
function h6(n) {
  const e = A.useRef(n);
  return Hv(() => {
    e.current = n;
  }), e;
}
function $ze(n) {
  n === void 0 && (n = {});
  const {
    placement: e = "bottom",
    strategy: t = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: s,
      floating: o
    } = {},
    transform: a = !0,
    whileElementsMounted: l,
    open: c
  } = n, [u, d] = A.useState({
    x: 0,
    y: 0,
    strategy: t,
    placement: e,
    middlewareData: {},
    isPositioned: !1
  }), [f, h] = A.useState(r);
  _y(f, r) || h(r);
  const [m, g] = A.useState(null), [v, y] = A.useState(null), b = A.useCallback(($) => {
    $ !== C.current && (C.current = $, g($));
  }, []), x = A.useCallback(($) => {
    $ !== S.current && (S.current = $, y($));
  }, []), E = s || m, w = o || v, C = A.useRef(null), S = A.useRef(null), M = A.useRef(u), k = l != null, _ = h6(l), O = h6(i), I = h6(c), R = A.useCallback(() => {
    if (!C.current || !S.current)
      return;
    const $ = {
      placement: e,
      strategy: t,
      middleware: f
    };
    O.current && ($.platform = O.current), Sk(C.current, S.current, $).then((z) => {
      const H = {
        ...z,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: I.current !== !1
      };
      P.current && !_y(M.current, H) && (M.current = H, mw.flushSync(() => {
        d(H);
      }));
    });
  }, [f, e, t, O, I]);
  Hv(() => {
    c === !1 && M.current.isPositioned && (M.current.isPositioned = !1, d(($) => ({
      ...$,
      isPositioned: !1
    })));
  }, [c]);
  const P = A.useRef(!1);
  Hv(() => (P.current = !0, () => {
    P.current = !1;
  }), []), Hv(() => {
    if (E && (C.current = E), w && (S.current = w), E && w) {
      if (_.current)
        return _.current(E, w, R);
      R();
    }
  }, [E, w, R, _, k]);
  const D = A.useMemo(() => ({
    reference: C,
    floating: S,
    setReference: b,
    setFloating: x
  }), [b, x]), L = A.useMemo(() => ({
    reference: E,
    floating: w
  }), [E, w]), B = A.useMemo(() => {
    const $ = {
      position: t,
      left: 0,
      top: 0
    };
    if (!L.floating)
      return $;
    const z = uz(L.floating, u.x), H = uz(L.floating, u.y);
    return a ? {
      ...$,
      transform: "translate(" + z + "px, " + H + "px)",
      ...JZ(L.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: t,
      left: z,
      top: H
    };
  }, [t, a, L.floating, u.x, u.y]);
  return A.useMemo(() => ({
    ...u,
    update: R,
    refs: D,
    elements: L,
    floatingStyles: B
  }), [u, R, D, L, B]);
}
const Fze = (n) => {
  function e(t) {
    return {}.hasOwnProperty.call(t, "current");
  }
  return {
    name: "arrow",
    options: n,
    fn(t) {
      const {
        element: r,
        padding: i
      } = typeof n == "function" ? n(t) : n;
      return r && e(r) ? r.current != null ? ky({
        element: r.current,
        padding: i
      }).fn(t) : {} : r ? ky({
        element: r,
        padding: i
      }).fn(t) : {};
    }
  };
}, Bze = (n, e) => ({
  ...yk(n),
  options: [n, e]
}), zze = (n, e) => ({
  ...bk(n),
  options: [n, e]
}), Hze = (n, e) => ({
  ...Dze(n),
  options: [n, e]
}), Uze = (n, e) => ({
  ...wk(n),
  options: [n, e]
}), Vze = (n, e) => ({
  ...xk(n),
  options: [n, e]
}), jze = (n, e) => ({
  ...Ek(n),
  options: [n, e]
}), Wze = (n, e) => ({
  ...Fze(n),
  options: [n, e]
});
var Gze = "Arrow", eQ = A.forwardRef((n, e) => {
  const { children: t, width: r = 10, height: i = 5, ...s } = n;
  return /* @__PURE__ */ T(
    Ve.svg,
    {
      ...s,
      ref: e,
      width: r,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: n.asChild ? t : /* @__PURE__ */ T("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
eQ.displayName = Gze;
var Kze = eQ;
function S3(n) {
  const [e, t] = A.useState(void 0);
  return Rr(() => {
    if (n) {
      t({ width: n.offsetWidth, height: n.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const s = i[0];
        let o, a;
        if ("borderBoxSize" in s) {
          const l = s.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          o = c.inlineSize, a = c.blockSize;
        } else
          o = n.offsetWidth, a = n.offsetHeight;
        t({ width: o, height: a });
      });
      return r.observe(n, { box: "border-box" }), () => r.unobserve(n);
    } else
      t(void 0);
  }, [n]), e;
}
var Ck = "Popper", [tQ, Oc] = qr(Ck), [qze, nQ] = tQ(Ck), rQ = (n) => {
  const { __scopePopper: e, children: t } = n, [r, i] = A.useState(null);
  return /* @__PURE__ */ T(qze, { scope: e, anchor: r, onAnchorChange: i, children: t });
};
rQ.displayName = Ck;
var iQ = "PopperAnchor", sQ = A.forwardRef(
  (n, e) => {
    const { __scopePopper: t, virtualRef: r, ...i } = n, s = nQ(iQ, t), o = A.useRef(null), a = ht(e, o), l = A.useRef(null);
    return A.useEffect(() => {
      const c = l.current;
      l.current = r?.current || o.current, c !== l.current && s.onAnchorChange(l.current);
    }), r ? null : /* @__PURE__ */ T(Ve.div, { ...i, ref: a });
  }
);
sQ.displayName = iQ;
var Tk = "PopperContent", [Yze, Xze] = tQ(Tk), oQ = A.forwardRef(
  (n, e) => {
    const {
      __scopePopper: t,
      side: r = "bottom",
      sideOffset: i = 0,
      align: s = "center",
      alignOffset: o = 0,
      arrowPadding: a = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: d = "partial",
      hideWhenDetached: f = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: m,
      ...g
    } = n, v = nQ(Tk, t), [y, b] = A.useState(null), x = ht(e, (J) => b(J)), [E, w] = A.useState(null), C = S3(E), S = C?.width ?? 0, M = C?.height ?? 0, k = r + (s !== "center" ? "-" + s : ""), _ = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, O = Array.isArray(c) ? c : [c], I = O.length > 0, R = {
      padding: _,
      boundary: O.filter(Qze),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: I
    }, { refs: P, floatingStyles: D, placement: L, isPositioned: B, middlewareData: $ } = $ze({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: k,
      whileElementsMounted: (...J) => Pze(...J, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: v.anchor
      },
      middleware: [
        Bze({ mainAxis: i + M, alignmentAxis: o }),
        l && zze({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? Hze() : void 0,
          ...R
        }),
        l && Uze({ ...R }),
        Vze({
          ...R,
          apply: ({ elements: J, rects: se, availableWidth: te, availableHeight: le }) => {
            const { width: de, height: j } = se.reference, xe = J.floating.style;
            xe.setProperty("--radix-popper-available-width", `${te}px`), xe.setProperty("--radix-popper-available-height", `${le}px`), xe.setProperty("--radix-popper-anchor-width", `${de}px`), xe.setProperty("--radix-popper-anchor-height", `${j}px`);
          }
        }),
        E && Wze({ element: E, padding: a }),
        Jze({ arrowWidth: S, arrowHeight: M }),
        f && jze({ strategy: "referenceHidden", ...R })
      ]
    }), [z, H] = cQ(L), U = Vr(m);
    Rr(() => {
      B && U?.();
    }, [B, U]);
    const F = $.arrow?.x, V = $.arrow?.y, X = $.arrow?.centerOffset !== 0, [Z, ie] = A.useState();
    return Rr(() => {
      y && ie(window.getComputedStyle(y).zIndex);
    }, [y]), /* @__PURE__ */ T(
      "div",
      {
        ref: P.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...D,
          transform: B ? D.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Z,
          "--radix-popper-transform-origin": [
            $.transformOrigin?.x,
            $.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...$.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: n.dir,
        children: /* @__PURE__ */ T(
          Yze,
          {
            scope: t,
            placedSide: z,
            onArrowChange: w,
            arrowX: F,
            arrowY: V,
            shouldHideArrow: X,
            children: /* @__PURE__ */ T(
              Ve.div,
              {
                "data-side": z,
                "data-align": H,
                ...g,
                ref: x,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: B ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
oQ.displayName = Tk;
var aQ = "PopperArrow", Zze = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, lQ = A.forwardRef(function(e, t) {
  const { __scopePopper: r, ...i } = e, s = Xze(aQ, r), o = Zze[s.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ T(
      "span",
      {
        ref: s.onArrowChange,
        style: {
          position: "absolute",
          left: s.arrowX,
          top: s.arrowY,
          [o]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[s.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[s.placedSide],
          visibility: s.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ T(
          Kze,
          {
            ...i,
            ref: t,
            style: {
              ...i.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
lQ.displayName = aQ;
function Qze(n) {
  return n !== null;
}
var Jze = (n) => ({
  name: "transformOrigin",
  options: n,
  fn(e) {
    const { placement: t, rects: r, middlewareData: i } = e, o = i.arrow?.centerOffset !== 0, a = o ? 0 : n.arrowWidth, l = o ? 0 : n.arrowHeight, [c, u] = cQ(t), d = { start: "0%", center: "50%", end: "100%" }[u], f = (i.arrow?.x ?? 0) + a / 2, h = (i.arrow?.y ?? 0) + l / 2;
    let m = "", g = "";
    return c === "bottom" ? (m = o ? d : `${f}px`, g = `${-l}px`) : c === "top" ? (m = o ? d : `${f}px`, g = `${r.floating.height + l}px`) : c === "right" ? (m = `${-l}px`, g = o ? d : `${h}px`) : c === "left" && (m = `${r.floating.width + l}px`, g = o ? d : `${h}px`), { data: { x: m, y: g } };
  }
});
function cQ(n) {
  const [e, t = "center"] = n.split("-");
  return [e, t];
}
var C3 = rQ, C1 = sQ, T3 = oQ, A3 = lQ;
// @__NO_SIDE_EFFECTS__
function eHe(n) {
  const e = /* @__PURE__ */ tHe(n), t = A.forwardRef((r, i) => {
    const { children: s, ...o } = r, a = A.Children.toArray(s), l = a.find(rHe);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? A.Children.count(c) > 1 ? A.Children.only(null) : A.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ T(e, { ...o, ref: i, children: A.isValidElement(c) ? A.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ T(e, { ...o, ref: i, children: s });
  });
  return t.displayName = `${n}.Slot`, t;
}
// @__NO_SIDE_EFFECTS__
function tHe(n) {
  const e = A.forwardRef((t, r) => {
    const { children: i, ...s } = t;
    if (A.isValidElement(i)) {
      const o = sHe(i), a = iHe(s, i.props);
      return i.type !== A.Fragment && (a.ref = r ? bi(r, o) : o), A.cloneElement(i, a);
    }
    return A.Children.count(i) > 1 ? A.Children.only(null) : null;
  });
  return e.displayName = `${n}.SlotClone`, e;
}
var nHe = Symbol("radix.slottable");
function rHe(n) {
  return A.isValidElement(n) && typeof n.type == "function" && "__radixId" in n.type && n.type.__radixId === nHe;
}
function iHe(n, e) {
  const t = { ...e };
  for (const r in e) {
    const i = n[r], s = e[r];
    /^on[A-Z]/.test(r) ? i && s ? t[r] = (...a) => {
      const l = s(...a);
      return i(...a), l;
    } : i && (t[r] = i) : r === "style" ? t[r] = { ...i, ...s } : r === "className" && (t[r] = [i, s].filter(Boolean).join(" "));
  }
  return { ...n, ...t };
}
function sHe(n) {
  let e = Object.getOwnPropertyDescriptor(n.props, "ref")?.get, t = e && "isReactWarning" in e && e.isReactWarning;
  return t ? n.ref : (e = Object.getOwnPropertyDescriptor(n, "ref")?.get, t = e && "isReactWarning" in e && e.isReactWarning, t ? n.props.ref : n.props.ref || n.ref);
}
var M3 = "Popover", [uQ] = qr(M3, [
  Oc
]), T1 = Oc(), [oHe, Ic] = uQ(M3), dQ = (n) => {
  const {
    __scopePopover: e,
    children: t,
    open: r,
    defaultOpen: i,
    onOpenChange: s,
    modal: o = !1
  } = n, a = T1(e), l = A.useRef(null), [c, u] = A.useState(!1), [d, f] = Kr({
    prop: r,
    defaultProp: i ?? !1,
    onChange: s,
    caller: M3
  });
  return /* @__PURE__ */ T(C3, { ...a, children: /* @__PURE__ */ T(
    oHe,
    {
      scope: e,
      contentId: Xn(),
      triggerRef: l,
      open: d,
      onOpenChange: f,
      onOpenToggle: A.useCallback(() => f((h) => !h), [f]),
      hasCustomAnchor: c,
      onCustomAnchorAdd: A.useCallback(() => u(!0), []),
      onCustomAnchorRemove: A.useCallback(() => u(!1), []),
      modal: o,
      children: t
    }
  ) });
};
dQ.displayName = M3;
var fQ = "PopoverAnchor", aHe = A.forwardRef(
  (n, e) => {
    const { __scopePopover: t, ...r } = n, i = Ic(fQ, t), s = T1(t), { onCustomAnchorAdd: o, onCustomAnchorRemove: a } = i;
    return A.useEffect(() => (o(), () => a()), [o, a]), /* @__PURE__ */ T(C1, { ...s, ...r, ref: e });
  }
);
aHe.displayName = fQ;
var hQ = "PopoverTrigger", pQ = A.forwardRef(
  (n, e) => {
    const { __scopePopover: t, ...r } = n, i = Ic(hQ, t), s = T1(t), o = ht(e, i.triggerRef), a = /* @__PURE__ */ T(
      Ve.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": i.open,
        "aria-controls": i.contentId,
        "data-state": bQ(i.open),
        ...r,
        ref: o,
        onClick: Ce(n.onClick, i.onOpenToggle)
      }
    );
    return i.hasCustomAnchor ? a : /* @__PURE__ */ T(C1, { asChild: !0, ...s, children: a });
  }
);
pQ.displayName = hQ;
var Ak = "PopoverPortal", [lHe, cHe] = uQ(Ak, {
  forceMount: void 0
}), mQ = (n) => {
  const { __scopePopover: e, forceMount: t, children: r, container: i } = n, s = Ic(Ak, e);
  return /* @__PURE__ */ T(lHe, { scope: e, forceMount: t, children: /* @__PURE__ */ T(Yr, { present: t || s.open, children: /* @__PURE__ */ T(y1, { asChild: !0, container: i, children: r }) }) });
};
mQ.displayName = Ak;
var Zf = "PopoverContent", gQ = A.forwardRef(
  (n, e) => {
    const t = cHe(Zf, n.__scopePopover), { forceMount: r = t.forceMount, ...i } = n, s = Ic(Zf, n.__scopePopover);
    return /* @__PURE__ */ T(Yr, { present: r || s.open, children: s.modal ? /* @__PURE__ */ T(dHe, { ...i, ref: e }) : /* @__PURE__ */ T(fHe, { ...i, ref: e }) });
  }
);
gQ.displayName = Zf;
var uHe = /* @__PURE__ */ eHe("PopoverContent.RemoveScroll"), dHe = A.forwardRef(
  (n, e) => {
    const t = Ic(Zf, n.__scopePopover), r = A.useRef(null), i = ht(e, r), s = A.useRef(!1);
    return A.useEffect(() => {
      const o = r.current;
      if (o) return o3(o);
    }, []), /* @__PURE__ */ T(b1, { as: uHe, allowPinchZoom: !0, children: /* @__PURE__ */ T(
      vQ,
      {
        ...n,
        ref: i,
        trapFocus: t.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: Ce(n.onCloseAutoFocus, (o) => {
          o.preventDefault(), s.current || t.triggerRef.current?.focus();
        }),
        onPointerDownOutside: Ce(
          n.onPointerDownOutside,
          (o) => {
            const a = o.detail.originalEvent, l = a.button === 0 && a.ctrlKey === !0, c = a.button === 2 || l;
            s.current = c;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: Ce(
          n.onFocusOutside,
          (o) => o.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), fHe = A.forwardRef(
  (n, e) => {
    const t = Ic(Zf, n.__scopePopover), r = A.useRef(!1), i = A.useRef(!1);
    return /* @__PURE__ */ T(
      vQ,
      {
        ...n,
        ref: e,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (s) => {
          n.onCloseAutoFocus?.(s), s.defaultPrevented || (r.current || t.triggerRef.current?.focus(), s.preventDefault()), r.current = !1, i.current = !1;
        },
        onInteractOutside: (s) => {
          n.onInteractOutside?.(s), s.defaultPrevented || (r.current = !0, s.detail.originalEvent.type === "pointerdown" && (i.current = !0));
          const o = s.target;
          t.triggerRef.current?.contains(o) && s.preventDefault(), s.detail.originalEvent.type === "focusin" && i.current && s.preventDefault();
        }
      }
    );
  }
), vQ = A.forwardRef(
  (n, e) => {
    const {
      __scopePopover: t,
      trapFocus: r,
      onOpenAutoFocus: i,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: o,
      onEscapeKeyDown: a,
      onPointerDownOutside: l,
      onFocusOutside: c,
      onInteractOutside: u,
      ...d
    } = n, f = Ic(Zf, t), h = T1(t);
    return i3(), /* @__PURE__ */ T(
      v1,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: i,
        onUnmountAutoFocus: s,
        children: /* @__PURE__ */ T(
          Ih,
          {
            asChild: !0,
            disableOutsidePointerEvents: o,
            onInteractOutside: u,
            onEscapeKeyDown: a,
            onPointerDownOutside: l,
            onFocusOutside: c,
            onDismiss: () => f.onOpenChange(!1),
            children: /* @__PURE__ */ T(
              T3,
              {
                "data-state": bQ(f.open),
                role: "dialog",
                id: f.contentId,
                ...h,
                ...d,
                ref: e,
                style: {
                  ...d.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), yQ = "PopoverClose", hHe = A.forwardRef(
  (n, e) => {
    const { __scopePopover: t, ...r } = n, i = Ic(yQ, t);
    return /* @__PURE__ */ T(
      Ve.button,
      {
        type: "button",
        ...r,
        ref: e,
        onClick: Ce(n.onClick, () => i.onOpenChange(!1))
      }
    );
  }
);
hHe.displayName = yQ;
var pHe = "PopoverArrow", mHe = A.forwardRef(
  (n, e) => {
    const { __scopePopover: t, ...r } = n, i = T1(t);
    return /* @__PURE__ */ T(A3, { ...i, ...r, ref: e });
  }
);
mHe.displayName = pHe;
function bQ(n) {
  return n ? "open" : "closed";
}
var gHe = dQ, vHe = pQ, yHe = mQ, wQ = gQ;
const Dh = gHe, Nh = vHe, ld = A.forwardRef(({ className: n, align: e = "center", sideOffset: t = 4, ...r }, i) => /* @__PURE__ */ T(yHe, { children: /* @__PURE__ */ T(
  wQ,
  {
    ref: i,
    align: e,
    sideOffset: t,
    className: Q(
      "tw:z-50 tw:rounded-md tw:border tw:bg-popover tw:p-0 tw:text-popover-foreground tw:shadow-md tw:outline-hidden tw:data-[state=open]:animate-in tw:data-[state=closed]:animate-out tw:data-[state=closed]:fade-out-0 tw:data-[state=open]:fade-in-0 tw:data-[state=closed]:zoom-out-95 tw:data-[state=open]:zoom-in-95 tw:data-[side=bottom]:slide-in-from-top-2 tw:data-[side=left]:slide-in-from-right-2 tw:data-[side=right]:slide-in-from-left-2 tw:data-[side=top]:slide-in-from-bottom-2",
      n
    ),
    ...r
  }
) }));
ld.displayName = wQ.displayName;
var bHe = A.createContext(void 0);
function Rc(n) {
  const e = A.useContext(bHe);
  return n || e || "ltr";
}
function h0(n, [e, t]) {
  return Math.min(t, Math.max(e, n));
}
function wHe(n, e) {
  return A.useReducer((t, r) => e[t][r] ?? t, n);
}
var Mk = "ScrollArea", [xQ] = qr(Mk), [xHe, Ks] = xQ(Mk), EQ = A.forwardRef(
  (n, e) => {
    const {
      __scopeScrollArea: t,
      type: r = "hover",
      dir: i,
      scrollHideDelay: s = 600,
      ...o
    } = n, [a, l] = A.useState(null), [c, u] = A.useState(null), [d, f] = A.useState(null), [h, m] = A.useState(null), [g, v] = A.useState(null), [y, b] = A.useState(0), [x, E] = A.useState(0), [w, C] = A.useState(!1), [S, M] = A.useState(!1), k = ht(e, (O) => l(O)), _ = Rc(i);
    return /* @__PURE__ */ T(
      xHe,
      {
        scope: t,
        type: r,
        dir: _,
        scrollHideDelay: s,
        scrollArea: a,
        viewport: c,
        onViewportChange: u,
        content: d,
        onContentChange: f,
        scrollbarX: h,
        onScrollbarXChange: m,
        scrollbarXEnabled: w,
        onScrollbarXEnabledChange: C,
        scrollbarY: g,
        onScrollbarYChange: v,
        scrollbarYEnabled: S,
        onScrollbarYEnabledChange: M,
        onCornerWidthChange: b,
        onCornerHeightChange: E,
        children: /* @__PURE__ */ T(
          Ve.div,
          {
            dir: _,
            ...o,
            ref: k,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": y + "px",
              "--radix-scroll-area-corner-height": x + "px",
              ...n.style
            }
          }
        )
      }
    );
  }
);
EQ.displayName = Mk;
var SQ = "ScrollAreaViewport", CQ = A.forwardRef(
  (n, e) => {
    const { __scopeScrollArea: t, children: r, nonce: i, ...s } = n, o = Ks(SQ, t), a = A.useRef(null), l = ht(e, a, o.onViewportChange);
    return /* @__PURE__ */ ee(ft, { children: [
      /* @__PURE__ */ T(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: i
        }
      ),
      /* @__PURE__ */ T(
        Ve.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...s,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: o.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: o.scrollbarYEnabled ? "scroll" : "hidden",
            ...n.style
          },
          children: /* @__PURE__ */ T("div", { ref: o.onContentChange, style: { minWidth: "100%", display: "table" }, children: r })
        }
      )
    ] });
  }
);
CQ.displayName = SQ;
var Ta = "ScrollAreaScrollbar", kk = A.forwardRef(
  (n, e) => {
    const { forceMount: t, ...r } = n, i = Ks(Ta, n.__scopeScrollArea), { onScrollbarXEnabledChange: s, onScrollbarYEnabledChange: o } = i, a = n.orientation === "horizontal";
    return A.useEffect(() => (a ? s(!0) : o(!0), () => {
      a ? s(!1) : o(!1);
    }), [a, s, o]), i.type === "hover" ? /* @__PURE__ */ T(EHe, { ...r, ref: e, forceMount: t }) : i.type === "scroll" ? /* @__PURE__ */ T(SHe, { ...r, ref: e, forceMount: t }) : i.type === "auto" ? /* @__PURE__ */ T(TQ, { ...r, ref: e, forceMount: t }) : i.type === "always" ? /* @__PURE__ */ T(_k, { ...r, ref: e }) : null;
  }
);
kk.displayName = Ta;
var EHe = A.forwardRef((n, e) => {
  const { forceMount: t, ...r } = n, i = Ks(Ta, n.__scopeScrollArea), [s, o] = A.useState(!1);
  return A.useEffect(() => {
    const a = i.scrollArea;
    let l = 0;
    if (a) {
      const c = () => {
        window.clearTimeout(l), o(!0);
      }, u = () => {
        l = window.setTimeout(() => o(!1), i.scrollHideDelay);
      };
      return a.addEventListener("pointerenter", c), a.addEventListener("pointerleave", u), () => {
        window.clearTimeout(l), a.removeEventListener("pointerenter", c), a.removeEventListener("pointerleave", u);
      };
    }
  }, [i.scrollArea, i.scrollHideDelay]), /* @__PURE__ */ T(Yr, { present: t || s, children: /* @__PURE__ */ T(
    TQ,
    {
      "data-state": s ? "visible" : "hidden",
      ...r,
      ref: e
    }
  ) });
}), SHe = A.forwardRef((n, e) => {
  const { forceMount: t, ...r } = n, i = Ks(Ta, n.__scopeScrollArea), s = n.orientation === "horizontal", o = _3(() => l("SCROLL_END"), 100), [a, l] = wHe("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return A.useEffect(() => {
    if (a === "idle") {
      const c = window.setTimeout(() => l("HIDE"), i.scrollHideDelay);
      return () => window.clearTimeout(c);
    }
  }, [a, i.scrollHideDelay, l]), A.useEffect(() => {
    const c = i.viewport, u = s ? "scrollLeft" : "scrollTop";
    if (c) {
      let d = c[u];
      const f = () => {
        const h = c[u];
        d !== h && (l("SCROLL"), o()), d = h;
      };
      return c.addEventListener("scroll", f), () => c.removeEventListener("scroll", f);
    }
  }, [i.viewport, s, l, o]), /* @__PURE__ */ T(Yr, { present: t || a !== "hidden", children: /* @__PURE__ */ T(
    _k,
    {
      "data-state": a === "hidden" ? "hidden" : "visible",
      ...r,
      ref: e,
      onPointerEnter: Ce(n.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: Ce(n.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), TQ = A.forwardRef((n, e) => {
  const t = Ks(Ta, n.__scopeScrollArea), { forceMount: r, ...i } = n, [s, o] = A.useState(!1), a = n.orientation === "horizontal", l = _3(() => {
    if (t.viewport) {
      const c = t.viewport.offsetWidth < t.viewport.scrollWidth, u = t.viewport.offsetHeight < t.viewport.scrollHeight;
      o(a ? c : u);
    }
  }, 10);
  return Qf(t.viewport, l), Qf(t.content, l), /* @__PURE__ */ T(Yr, { present: r || s, children: /* @__PURE__ */ T(
    _k,
    {
      "data-state": s ? "visible" : "hidden",
      ...i,
      ref: e
    }
  ) });
}), _k = A.forwardRef((n, e) => {
  const { orientation: t = "vertical", ...r } = n, i = Ks(Ta, n.__scopeScrollArea), s = A.useRef(null), o = A.useRef(0), [a, l] = A.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), c = OQ(a.viewport, a.content), u = {
    ...r,
    sizes: a,
    onSizesChange: l,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (f) => s.current = f,
    onThumbPointerUp: () => o.current = 0,
    onThumbPointerDown: (f) => o.current = f
  };
  function d(f, h) {
    return _He(f, o.current, a, h);
  }
  return t === "horizontal" ? /* @__PURE__ */ T(
    CHe,
    {
      ...u,
      ref: e,
      onThumbPositionChange: () => {
        if (i.viewport && s.current) {
          const f = i.viewport.scrollLeft, h = dz(f, a, i.dir);
          s.current.style.transform = `translate3d(${h}px, 0, 0)`;
        }
      },
      onWheelScroll: (f) => {
        i.viewport && (i.viewport.scrollLeft = f);
      },
      onDragScroll: (f) => {
        i.viewport && (i.viewport.scrollLeft = d(f, i.dir));
      }
    }
  ) : t === "vertical" ? /* @__PURE__ */ T(
    THe,
    {
      ...u,
      ref: e,
      onThumbPositionChange: () => {
        if (i.viewport && s.current) {
          const f = i.viewport.scrollTop, h = dz(f, a);
          s.current.style.transform = `translate3d(0, ${h}px, 0)`;
        }
      },
      onWheelScroll: (f) => {
        i.viewport && (i.viewport.scrollTop = f);
      },
      onDragScroll: (f) => {
        i.viewport && (i.viewport.scrollTop = d(f));
      }
    }
  ) : null;
}), CHe = A.forwardRef((n, e) => {
  const { sizes: t, onSizesChange: r, ...i } = n, s = Ks(Ta, n.__scopeScrollArea), [o, a] = A.useState(), l = A.useRef(null), c = ht(e, l, s.onScrollbarXChange);
  return A.useEffect(() => {
    l.current && a(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ T(
    MQ,
    {
      "data-orientation": "horizontal",
      ...i,
      ref: c,
      sizes: t,
      style: {
        bottom: 0,
        left: s.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: s.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": k3(t) + "px",
        ...n.style
      },
      onThumbPointerDown: (u) => n.onThumbPointerDown(u.x),
      onDragScroll: (u) => n.onDragScroll(u.x),
      onWheelScroll: (u, d) => {
        if (s.viewport) {
          const f = s.viewport.scrollLeft + u.deltaX;
          n.onWheelScroll(f), RQ(f, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && s.viewport && o && r({
          content: s.viewport.scrollWidth,
          viewport: s.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: Iy(o.paddingLeft),
            paddingEnd: Iy(o.paddingRight)
          }
        });
      }
    }
  );
}), THe = A.forwardRef((n, e) => {
  const { sizes: t, onSizesChange: r, ...i } = n, s = Ks(Ta, n.__scopeScrollArea), [o, a] = A.useState(), l = A.useRef(null), c = ht(e, l, s.onScrollbarYChange);
  return A.useEffect(() => {
    l.current && a(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ T(
    MQ,
    {
      "data-orientation": "vertical",
      ...i,
      ref: c,
      sizes: t,
      style: {
        top: 0,
        right: s.dir === "ltr" ? 0 : void 0,
        left: s.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": k3(t) + "px",
        ...n.style
      },
      onThumbPointerDown: (u) => n.onThumbPointerDown(u.y),
      onDragScroll: (u) => n.onDragScroll(u.y),
      onWheelScroll: (u, d) => {
        if (s.viewport) {
          const f = s.viewport.scrollTop + u.deltaY;
          n.onWheelScroll(f), RQ(f, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && s.viewport && o && r({
          content: s.viewport.scrollHeight,
          viewport: s.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: Iy(o.paddingTop),
            paddingEnd: Iy(o.paddingBottom)
          }
        });
      }
    }
  );
}), [AHe, AQ] = xQ(Ta), MQ = A.forwardRef((n, e) => {
  const {
    __scopeScrollArea: t,
    sizes: r,
    hasThumb: i,
    onThumbChange: s,
    onThumbPointerUp: o,
    onThumbPointerDown: a,
    onThumbPositionChange: l,
    onDragScroll: c,
    onWheelScroll: u,
    onResize: d,
    ...f
  } = n, h = Ks(Ta, t), [m, g] = A.useState(null), v = ht(e, (k) => g(k)), y = A.useRef(null), b = A.useRef(""), x = h.viewport, E = r.content - r.viewport, w = Vr(u), C = Vr(l), S = _3(d, 10);
  function M(k) {
    if (y.current) {
      const _ = k.clientX - y.current.left, O = k.clientY - y.current.top;
      c({ x: _, y: O });
    }
  }
  return A.useEffect(() => {
    const k = (_) => {
      const O = _.target;
      m?.contains(O) && w(_, E);
    };
    return document.addEventListener("wheel", k, { passive: !1 }), () => document.removeEventListener("wheel", k, { passive: !1 });
  }, [x, m, E, w]), A.useEffect(C, [r, C]), Qf(m, S), Qf(h.content, S), /* @__PURE__ */ T(
    AHe,
    {
      scope: t,
      scrollbar: m,
      hasThumb: i,
      onThumbChange: Vr(s),
      onThumbPointerUp: Vr(o),
      onThumbPositionChange: C,
      onThumbPointerDown: Vr(a),
      children: /* @__PURE__ */ T(
        Ve.div,
        {
          ...f,
          ref: v,
          style: { position: "absolute", ...f.style },
          onPointerDown: Ce(n.onPointerDown, (k) => {
            k.button === 0 && (k.target.setPointerCapture(k.pointerId), y.current = m.getBoundingClientRect(), b.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", h.viewport && (h.viewport.style.scrollBehavior = "auto"), M(k));
          }),
          onPointerMove: Ce(n.onPointerMove, M),
          onPointerUp: Ce(n.onPointerUp, (k) => {
            const _ = k.target;
            _.hasPointerCapture(k.pointerId) && _.releasePointerCapture(k.pointerId), document.body.style.webkitUserSelect = b.current, h.viewport && (h.viewport.style.scrollBehavior = ""), y.current = null;
          })
        }
      )
    }
  );
}), Oy = "ScrollAreaThumb", kQ = A.forwardRef(
  (n, e) => {
    const { forceMount: t, ...r } = n, i = AQ(Oy, n.__scopeScrollArea);
    return /* @__PURE__ */ T(Yr, { present: t || i.hasThumb, children: /* @__PURE__ */ T(MHe, { ref: e, ...r }) });
  }
), MHe = A.forwardRef(
  (n, e) => {
    const { __scopeScrollArea: t, style: r, ...i } = n, s = Ks(Oy, t), o = AQ(Oy, t), { onThumbPositionChange: a } = o, l = ht(
      e,
      (d) => o.onThumbChange(d)
    ), c = A.useRef(void 0), u = _3(() => {
      c.current && (c.current(), c.current = void 0);
    }, 100);
    return A.useEffect(() => {
      const d = s.viewport;
      if (d) {
        const f = () => {
          if (u(), !c.current) {
            const h = OHe(d, a);
            c.current = h, a();
          }
        };
        return a(), d.addEventListener("scroll", f), () => d.removeEventListener("scroll", f);
      }
    }, [s.viewport, u, a]), /* @__PURE__ */ T(
      Ve.div,
      {
        "data-state": o.hasThumb ? "visible" : "hidden",
        ...i,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...r
        },
        onPointerDownCapture: Ce(n.onPointerDownCapture, (d) => {
          const h = d.target.getBoundingClientRect(), m = d.clientX - h.left, g = d.clientY - h.top;
          o.onThumbPointerDown({ x: m, y: g });
        }),
        onPointerUp: Ce(n.onPointerUp, o.onThumbPointerUp)
      }
    );
  }
);
kQ.displayName = Oy;
var Ok = "ScrollAreaCorner", _Q = A.forwardRef(
  (n, e) => {
    const t = Ks(Ok, n.__scopeScrollArea), r = !!(t.scrollbarX && t.scrollbarY);
    return t.type !== "scroll" && r ? /* @__PURE__ */ T(kHe, { ...n, ref: e }) : null;
  }
);
_Q.displayName = Ok;
var kHe = A.forwardRef((n, e) => {
  const { __scopeScrollArea: t, ...r } = n, i = Ks(Ok, t), [s, o] = A.useState(0), [a, l] = A.useState(0), c = !!(s && a);
  return Qf(i.scrollbarX, () => {
    const u = i.scrollbarX?.offsetHeight || 0;
    i.onCornerHeightChange(u), l(u);
  }), Qf(i.scrollbarY, () => {
    const u = i.scrollbarY?.offsetWidth || 0;
    i.onCornerWidthChange(u), o(u);
  }), c ? /* @__PURE__ */ T(
    Ve.div,
    {
      ...r,
      ref: e,
      style: {
        width: s,
        height: a,
        position: "absolute",
        right: i.dir === "ltr" ? 0 : void 0,
        left: i.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...n.style
      }
    }
  ) : null;
});
function Iy(n) {
  return n ? parseInt(n, 10) : 0;
}
function OQ(n, e) {
  const t = n / e;
  return isNaN(t) ? 0 : t;
}
function k3(n) {
  const e = OQ(n.viewport, n.content), t = n.scrollbar.paddingStart + n.scrollbar.paddingEnd, r = (n.scrollbar.size - t) * e;
  return Math.max(r, 18);
}
function _He(n, e, t, r = "ltr") {
  const i = k3(t), s = i / 2, o = e || s, a = i - o, l = t.scrollbar.paddingStart + o, c = t.scrollbar.size - t.scrollbar.paddingEnd - a, u = t.content - t.viewport, d = r === "ltr" ? [0, u] : [u * -1, 0];
  return IQ([l, c], d)(n);
}
function dz(n, e, t = "ltr") {
  const r = k3(e), i = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, s = e.scrollbar.size - i, o = e.content - e.viewport, a = s - r, l = t === "ltr" ? [0, o] : [o * -1, 0], c = h0(n, l);
  return IQ([0, o], [0, a])(c);
}
function IQ(n, e) {
  return (t) => {
    if (n[0] === n[1] || e[0] === e[1]) return e[0];
    const r = (e[1] - e[0]) / (n[1] - n[0]);
    return e[0] + r * (t - n[0]);
  };
}
function RQ(n, e) {
  return n > 0 && n < e;
}
var OHe = (n, e = () => {
}) => {
  let t = { left: n.scrollLeft, top: n.scrollTop }, r = 0;
  return (function i() {
    const s = { left: n.scrollLeft, top: n.scrollTop }, o = t.left !== s.left, a = t.top !== s.top;
    (o || a) && e(), t = s, r = window.requestAnimationFrame(i);
  })(), () => window.cancelAnimationFrame(r);
};
function _3(n, e) {
  const t = Vr(n), r = A.useRef(0);
  return A.useEffect(() => () => window.clearTimeout(r.current), []), A.useCallback(() => {
    window.clearTimeout(r.current), r.current = window.setTimeout(t, e);
  }, [t, e]);
}
function Qf(n, e) {
  const t = Vr(e);
  Rr(() => {
    let r = 0;
    if (n) {
      const i = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(t);
      });
      return i.observe(n), () => {
        window.cancelAnimationFrame(r), i.unobserve(n);
      };
    }
  }, [n, t]);
}
var PQ = EQ, IHe = CQ, RHe = _Q;
const Kp = A.forwardRef(({ className: n, children: e, ...t }, r) => /* @__PURE__ */ ee(
  PQ,
  {
    ref: r,
    className: Q("tw:relative tw:overflow-hidden", n),
    ...t,
    children: [
      /* @__PURE__ */ T(IHe, { className: "tw:h-full tw:w-full tw:rounded-[inherit]", children: e }),
      /* @__PURE__ */ T(Ry, {}),
      /* @__PURE__ */ T(RHe, {})
    ]
  }
));
Kp.displayName = PQ.displayName;
const Ry = A.forwardRef(({ className: n, orientation: e = "vertical", ...t }, r) => /* @__PURE__ */ T(
  kk,
  {
    ref: r,
    orientation: e,
    className: Q(
      "tw:flex tw:touch-none tw:select-none tw:transition-colors",
      e === "vertical" && "tw:h-full tw:w-2.5 tw:border-l tw:border-l-transparent tw:p-px",
      e === "horizontal" && "tw:h-2.5 tw:flex-col tw:border-t tw:border-t-transparent tw:p-px",
      n
    ),
    ...t,
    children: /* @__PURE__ */ T(kQ, { className: "tw:relative tw:flex-1 tw:rounded-full tw:bg-border" })
  }
));
Ry.displayName = kk.displayName;
const DQ = A.forwardRef(
  ({ className: n, onChange: e, ...t }, r) => /* @__PURE__ */ T(
    P$e,
    {
      ref: r,
      className: Q("tw:flex", n),
      flagComponent: KM,
      countrySelectComponent: PHe,
      inputComponent: NQ,
      smartCaret: !1,
      onChange: (i) => e?.(i || ""),
      ...t
    }
  )
);
DQ.displayName = "PhoneInput";
const NQ = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  Ui,
  {
    ref: t,
    className: Q("tw:rounded-e-lg tw:rounded-s-none", n),
    ...e
  }
));
NQ.displayName = "InputComponent";
const PHe = ({
  disabled: n,
  value: e,
  options: t,
  onChange: r
}) => /* @__PURE__ */ ee(Dh, { children: [
  /* @__PURE__ */ T(Nh, { asChild: !0, children: /* @__PURE__ */ ee(
    Nt,
    {
      type: "button",
      variant: "outline",
      className: "tw:flex tw:gap-1 tw:rounded-e-none tw:rounded-s-lg tw:border-r-0 tw:px-3 tw:focus:z-10",
      disabled: n,
      children: [
        /* @__PURE__ */ T(
          KM,
          {
            country: e,
            countryName: e
          }
        ),
        /* @__PURE__ */ T(
          hIe,
          {
            className: Q(
              "tw:mr-2 tw:size-4 tw:opacity-50",
              n ? "tw:hidden" : "tw:opacity-100"
            )
          }
        )
      ]
    }
  ) }),
  /* @__PURE__ */ T(ld, { className: "tw:w-[300px] tw:p-0", children: /* @__PURE__ */ ee(m3, { children: [
    /* @__PURE__ */ T(g3, { placeholder: "Search country..." }),
    /* @__PURE__ */ T(v3, { children: /* @__PURE__ */ ee(Kp, { className: "tw:h-72", children: [
      /* @__PURE__ */ T(y3, { children: "No country found." }),
      /* @__PURE__ */ T(cu, { children: t.map(
        ({ value: i, label: s }) => i ? /* @__PURE__ */ T(
          DHe,
          {
            country: i,
            countryName: s,
            selectedCountry: e,
            onChange: r
          },
          i
        ) : null
      ) })
    ] }) })
  ] }) })
] }), DHe = ({
  country: n,
  countryName: e,
  selectedCountry: t,
  onChange: r
}) => /* @__PURE__ */ ee(Ka, { className: "tw:gap-2", onSelect: () => r(n), children: [
  /* @__PURE__ */ T(KM, { country: n, countryName: e }),
  /* @__PURE__ */ T("span", { className: "tw:flex-1 tw:text-sm", children: e }),
  /* @__PURE__ */ T("span", { className: "tw:text-sm tw:text-foreground/50", children: `+${D$e(
    n
  )}` }),
  /* @__PURE__ */ T(
    oc,
    {
      className: `tw:ml-auto tw:size-4 ${n === t ? "tw:opacity-100" : "tw:opacity-0"}`
    }
  )
] });
var NHe = "Label", LQ = A.forwardRef((n, e) => /* @__PURE__ */ T(
  Ve.label,
  {
    ...n,
    ref: e,
    onMouseDown: (t) => {
      t.target.closest("button, input, select, textarea") || (n.onMouseDown?.(t), !t.defaultPrevented && t.detail > 1 && t.preventDefault());
    }
  }
));
LQ.displayName = NHe;
var $Q = LQ;
const LHe = _c(
  "tw:text-sm tw:font-medium tw:leading-none tw:peer-disabled:cursor-not-allowed tw:peer-disabled:opacity-70"
), bo = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  $Q,
  {
    ref: t,
    className: Q(LHe(), n),
    ...e
  }
));
bo.displayName = $Q.displayName;
const Rwt = whe, FQ = A.createContext(
  {}
), xs = ({
  ...n
}) => /* @__PURE__ */ T(FQ.Provider, { value: { name: n.name }, children: /* @__PURE__ */ T(She, { ...n }) }), O3 = () => {
  const n = A.useContext(FQ), e = A.useContext(BQ), { getFieldState: t, formState: r } = Ju(), i = t(n.name, r);
  if (!n)
    throw new Error("useFormField should be used within <FormField>");
  const { id: s } = e;
  return {
    id: s,
    name: n.name,
    formItemId: `${s}-form-item`,
    formDescriptionId: `${s}-form-item-description`,
    formMessageId: `${s}-form-item-message`,
    ...i
  };
}, BQ = A.createContext(
  {}
), Ci = A.forwardRef(({ className: n, ...e }, t) => {
  const r = A.useId();
  return /* @__PURE__ */ T(BQ.Provider, { value: { id: r }, children: /* @__PURE__ */ T("div", { ref: t, className: Q("tw:space-y-2", n), ...e }) });
});
Ci.displayName = "FormItem";
const Ti = A.forwardRef(({ className: n, ...e }, t) => {
  const { error: r, formItemId: i } = O3();
  return /* @__PURE__ */ T(
    bo,
    {
      ref: t,
      className: Q(r && "tw:text-destructive", n),
      htmlFor: i,
      ...e
    }
  );
});
Ti.displayName = "FormLabel";
const qi = A.forwardRef(({ ...n }, e) => {
  const { error: t, formItemId: r, formDescriptionId: i, formMessageId: s } = O3();
  return /* @__PURE__ */ T(
    sd,
    {
      ref: e,
      id: r,
      "aria-describedby": t ? `${i} ${s}` : `${i}`,
      "aria-invalid": !!t,
      ...n
    }
  );
});
qi.displayName = "FormControl";
const Ai = A.forwardRef(({ className: n, ...e }, t) => {
  const { formDescriptionId: r } = O3();
  return /* @__PURE__ */ T(
    "p",
    {
      ref: t,
      id: r,
      className: Q("tw:text-sm tw:text-muted-foreground", n),
      ...e
    }
  );
});
Ai.displayName = "FormDescription";
const qs = A.forwardRef(({ className: n, children: e, ...t }, r) => {
  const { error: i, formMessageId: s } = O3(), o = i ? String(i?.message ?? "") : e;
  return o ? /* @__PURE__ */ T(
    "p",
    {
      ref: r,
      id: s,
      className: Q("tw:text-sm tw:font-medium tw:text-destructive", n),
      ...t,
      children: o
    }
  ) : null;
});
qs.displayName = "FormMessage";
function Pwt(n) {
  let e = n.label;
  return n.copyToClipboard && n.defaultValue ? e = /* @__PURE__ */ ee(ft, { children: [
    /* @__PURE__ */ T("span", { children: n.label }),
    /* @__PURE__ */ T(g1, { value: n.defaultValue })
  ] }) : e = n.label, /* @__PURE__ */ T(
    xs,
    {
      control: n.control,
      name: n.name,
      render: ({ field: t }) => {
        const r = t.onChange;
        return t.onChange = (i) => {
          n.onChange && n.onChange(i.target.value), r(i);
        }, /* @__PURE__ */ ee(Ci, { children: [
          /* @__PURE__ */ T(Ti, { children: e }),
          /* @__PURE__ */ T(qi, { className: "tw:grow", children: /* @__PURE__ */ T(
            DQ,
            {
              placeholder: "Enter a phone number",
              defaultCountry: n.defaultCountry || "AU",
              countryOptionsOrder: n.countryOptionsOrder,
              ...t
            }
          ) }),
          n.description && /* @__PURE__ */ T(Ai, { children: n.description }),
          /* @__PURE__ */ T(qs, {})
        ] });
      }
    }
  );
}
// @__NO_SIDE_EFFECTS__
function fz(n) {
  const e = /* @__PURE__ */ $He(n), t = A.forwardRef((r, i) => {
    const { children: s, ...o } = r, a = A.Children.toArray(s), l = a.find(BHe);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? A.Children.count(c) > 1 ? A.Children.only(null) : A.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ T(e, { ...o, ref: i, children: A.isValidElement(c) ? A.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ T(e, { ...o, ref: i, children: s });
  });
  return t.displayName = `${n}.Slot`, t;
}
// @__NO_SIDE_EFFECTS__
function $He(n) {
  const e = A.forwardRef((t, r) => {
    const { children: i, ...s } = t;
    if (A.isValidElement(i)) {
      const o = HHe(i), a = zHe(s, i.props);
      return i.type !== A.Fragment && (a.ref = r ? bi(r, o) : o), A.cloneElement(i, a);
    }
    return A.Children.count(i) > 1 ? A.Children.only(null) : null;
  });
  return e.displayName = `${n}.SlotClone`, e;
}
var FHe = Symbol("radix.slottable");
function BHe(n) {
  return A.isValidElement(n) && typeof n.type == "function" && "__radixId" in n.type && n.type.__radixId === FHe;
}
function zHe(n, e) {
  const t = { ...e };
  for (const r in e) {
    const i = n[r], s = e[r];
    /^on[A-Z]/.test(r) ? i && s ? t[r] = (...a) => {
      const l = s(...a);
      return i(...a), l;
    } : i && (t[r] = i) : r === "style" ? t[r] = { ...i, ...s } : r === "className" && (t[r] = [i, s].filter(Boolean).join(" "));
  }
  return { ...n, ...t };
}
function HHe(n) {
  let e = Object.getOwnPropertyDescriptor(n.props, "ref")?.get, t = e && "isReactWarning" in e && e.isReactWarning;
  return t ? n.ref : (e = Object.getOwnPropertyDescriptor(n, "ref")?.get, t = e && "isReactWarning" in e && e.isReactWarning, t ? n.props.ref : n.props.ref || n.ref);
}
function Lh(n) {
  const e = n + "CollectionProvider", [t, r] = qr(e), [i, s] = t(
    e,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), o = (g) => {
    const { scope: v, children: y } = g, b = p.useRef(null), x = p.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ T(i, { scope: v, itemMap: x, collectionRef: b, children: y });
  };
  o.displayName = e;
  const a = n + "CollectionSlot", l = /* @__PURE__ */ fz(a), c = p.forwardRef(
    (g, v) => {
      const { scope: y, children: b } = g, x = s(a, y), E = ht(v, x.collectionRef);
      return /* @__PURE__ */ T(l, { ref: E, children: b });
    }
  );
  c.displayName = a;
  const u = n + "CollectionItemSlot", d = "data-radix-collection-item", f = /* @__PURE__ */ fz(u), h = p.forwardRef(
    (g, v) => {
      const { scope: y, children: b, ...x } = g, E = p.useRef(null), w = ht(v, E), C = s(u, y);
      return p.useEffect(() => (C.itemMap.set(E, { ref: E, ...x }), () => void C.itemMap.delete(E))), /* @__PURE__ */ T(f, { [d]: "", ref: w, children: b });
    }
  );
  h.displayName = u;
  function m(g) {
    const v = s(n + "CollectionConsumer", g);
    return p.useCallback(() => {
      const b = v.collectionRef.current;
      if (!b) return [];
      const x = Array.from(b.querySelectorAll(`[${d}]`));
      return Array.from(v.itemMap.values()).sort(
        (C, S) => x.indexOf(C.ref.current) - x.indexOf(S.ref.current)
      );
    }, [v.collectionRef, v.itemMap]);
  }
  return [
    { Provider: o, Slot: c, ItemSlot: h },
    m,
    r
  ];
}
var I3 = "Collapsible", [UHe, zQ] = qr(I3), [VHe, Ik] = UHe(I3), HQ = A.forwardRef(
  (n, e) => {
    const {
      __scopeCollapsible: t,
      open: r,
      defaultOpen: i,
      disabled: s,
      onOpenChange: o,
      ...a
    } = n, [l, c] = Kr({
      prop: r,
      defaultProp: i ?? !1,
      onChange: o,
      caller: I3
    });
    return /* @__PURE__ */ T(
      VHe,
      {
        scope: t,
        disabled: s,
        contentId: Xn(),
        open: l,
        onOpenToggle: A.useCallback(() => c((u) => !u), [c]),
        children: /* @__PURE__ */ T(
          Ve.div,
          {
            "data-state": Nk(l),
            "data-disabled": s ? "" : void 0,
            ...a,
            ref: e
          }
        )
      }
    );
  }
);
HQ.displayName = I3;
var UQ = "CollapsibleTrigger", Rk = A.forwardRef(
  (n, e) => {
    const { __scopeCollapsible: t, ...r } = n, i = Ik(UQ, t);
    return /* @__PURE__ */ T(
      Ve.button,
      {
        type: "button",
        "aria-controls": i.contentId,
        "aria-expanded": i.open || !1,
        "data-state": Nk(i.open),
        "data-disabled": i.disabled ? "" : void 0,
        disabled: i.disabled,
        ...r,
        ref: e,
        onClick: Ce(n.onClick, i.onOpenToggle)
      }
    );
  }
);
Rk.displayName = UQ;
var Pk = "CollapsibleContent", Dk = A.forwardRef(
  (n, e) => {
    const { forceMount: t, ...r } = n, i = Ik(Pk, n.__scopeCollapsible);
    return /* @__PURE__ */ T(Yr, { present: t || i.open, children: ({ present: s }) => /* @__PURE__ */ T(jHe, { ...r, ref: e, present: s }) });
  }
);
Dk.displayName = Pk;
var jHe = A.forwardRef((n, e) => {
  const { __scopeCollapsible: t, present: r, children: i, ...s } = n, o = Ik(Pk, t), [a, l] = A.useState(r), c = A.useRef(null), u = ht(e, c), d = A.useRef(0), f = d.current, h = A.useRef(0), m = h.current, g = o.open || a, v = A.useRef(g), y = A.useRef(void 0);
  return A.useEffect(() => {
    const b = requestAnimationFrame(() => v.current = !1);
    return () => cancelAnimationFrame(b);
  }, []), Rr(() => {
    const b = c.current;
    if (b) {
      y.current = y.current || {
        transitionDuration: b.style.transitionDuration,
        animationName: b.style.animationName
      }, b.style.transitionDuration = "0s", b.style.animationName = "none";
      const x = b.getBoundingClientRect();
      d.current = x.height, h.current = x.width, v.current || (b.style.transitionDuration = y.current.transitionDuration, b.style.animationName = y.current.animationName), l(r);
    }
  }, [o.open, r]), /* @__PURE__ */ T(
    Ve.div,
    {
      "data-state": Nk(o.open),
      "data-disabled": o.disabled ? "" : void 0,
      id: o.contentId,
      hidden: !g,
      ...s,
      ref: u,
      style: {
        "--radix-collapsible-content-height": f ? `${f}px` : void 0,
        "--radix-collapsible-content-width": m ? `${m}px` : void 0,
        ...n.style
      },
      children: g && i
    }
  );
});
function Nk(n) {
  return n ? "open" : "closed";
}
var VQ = HQ, WHe = Rk, GHe = Dk, Oo = "Accordion", KHe = ["Home", "End", "ArrowDown", "ArrowUp", "ArrowLeft", "ArrowRight"], [Lk, qHe, YHe] = Lh(Oo), [R3] = qr(Oo, [
  YHe,
  zQ
]), $k = zQ(), jQ = p.forwardRef(
  (n, e) => {
    const { type: t, ...r } = n, i = r, s = r;
    return /* @__PURE__ */ T(Lk.Provider, { scope: n.__scopeAccordion, children: t === "multiple" ? /* @__PURE__ */ T(JHe, { ...s, ref: e }) : /* @__PURE__ */ T(QHe, { ...i, ref: e }) });
  }
);
jQ.displayName = Oo;
var [WQ, XHe] = R3(Oo), [GQ, ZHe] = R3(
  Oo,
  { collapsible: !1 }
), QHe = p.forwardRef(
  (n, e) => {
    const {
      value: t,
      defaultValue: r,
      onValueChange: i = () => {
      },
      collapsible: s = !1,
      ...o
    } = n, [a, l] = Kr({
      prop: t,
      defaultProp: r ?? "",
      onChange: i,
      caller: Oo
    });
    return /* @__PURE__ */ T(
      WQ,
      {
        scope: n.__scopeAccordion,
        value: p.useMemo(() => a ? [a] : [], [a]),
        onItemOpen: l,
        onItemClose: p.useCallback(() => s && l(""), [s, l]),
        children: /* @__PURE__ */ T(GQ, { scope: n.__scopeAccordion, collapsible: s, children: /* @__PURE__ */ T(KQ, { ...o, ref: e }) })
      }
    );
  }
), JHe = p.forwardRef((n, e) => {
  const {
    value: t,
    defaultValue: r,
    onValueChange: i = () => {
    },
    ...s
  } = n, [o, a] = Kr({
    prop: t,
    defaultProp: r ?? [],
    onChange: i,
    caller: Oo
  }), l = p.useCallback(
    (u) => a((d = []) => [...d, u]),
    [a]
  ), c = p.useCallback(
    (u) => a((d = []) => d.filter((f) => f !== u)),
    [a]
  );
  return /* @__PURE__ */ T(
    WQ,
    {
      scope: n.__scopeAccordion,
      value: o,
      onItemOpen: l,
      onItemClose: c,
      children: /* @__PURE__ */ T(GQ, { scope: n.__scopeAccordion, collapsible: !0, children: /* @__PURE__ */ T(KQ, { ...s, ref: e }) })
    }
  );
}), [eUe, P3] = R3(Oo), KQ = p.forwardRef(
  (n, e) => {
    const { __scopeAccordion: t, disabled: r, dir: i, orientation: s = "vertical", ...o } = n, a = p.useRef(null), l = ht(a, e), c = qHe(t), d = Rc(i) === "ltr", f = Ce(n.onKeyDown, (h) => {
      if (!KHe.includes(h.key)) return;
      const m = h.target, g = c().filter((M) => !M.ref.current?.disabled), v = g.findIndex((M) => M.ref.current === m), y = g.length;
      if (v === -1) return;
      h.preventDefault();
      let b = v;
      const x = 0, E = y - 1, w = () => {
        b = v + 1, b > E && (b = x);
      }, C = () => {
        b = v - 1, b < x && (b = E);
      };
      switch (h.key) {
        case "Home":
          b = x;
          break;
        case "End":
          b = E;
          break;
        case "ArrowRight":
          s === "horizontal" && (d ? w() : C());
          break;
        case "ArrowDown":
          s === "vertical" && w();
          break;
        case "ArrowLeft":
          s === "horizontal" && (d ? C() : w());
          break;
        case "ArrowUp":
          s === "vertical" && C();
          break;
      }
      const S = b % y;
      g[S].ref.current?.focus();
    });
    return /* @__PURE__ */ T(
      eUe,
      {
        scope: t,
        disabled: r,
        direction: i,
        orientation: s,
        children: /* @__PURE__ */ T(Lk.Slot, { scope: t, children: /* @__PURE__ */ T(
          Ve.div,
          {
            ...o,
            "data-orientation": s,
            ref: l,
            onKeyDown: r ? void 0 : f
          }
        ) })
      }
    );
  }
), Py = "AccordionItem", [tUe, Fk] = R3(Py), qQ = p.forwardRef(
  (n, e) => {
    const { __scopeAccordion: t, value: r, ...i } = n, s = P3(Py, t), o = XHe(Py, t), a = $k(t), l = Xn(), c = r && o.value.includes(r) || !1, u = s.disabled || n.disabled;
    return /* @__PURE__ */ T(
      tUe,
      {
        scope: t,
        open: c,
        disabled: u,
        triggerId: l,
        children: /* @__PURE__ */ T(
          VQ,
          {
            "data-orientation": s.orientation,
            "data-state": eJ(c),
            ...a,
            ...i,
            ref: e,
            disabled: u,
            open: c,
            onOpenChange: (d) => {
              d ? o.onItemOpen(r) : o.onItemClose(r);
            }
          }
        )
      }
    );
  }
);
qQ.displayName = Py;
var YQ = "AccordionHeader", XQ = p.forwardRef(
  (n, e) => {
    const { __scopeAccordion: t, ...r } = n, i = P3(Oo, t), s = Fk(YQ, t);
    return /* @__PURE__ */ T(
      Ve.h3,
      {
        "data-orientation": i.orientation,
        "data-state": eJ(s.open),
        "data-disabled": s.disabled ? "" : void 0,
        ...r,
        ref: e
      }
    );
  }
);
XQ.displayName = YQ;
var n7 = "AccordionTrigger", ZQ = p.forwardRef(
  (n, e) => {
    const { __scopeAccordion: t, ...r } = n, i = P3(Oo, t), s = Fk(n7, t), o = ZHe(n7, t), a = $k(t);
    return /* @__PURE__ */ T(Lk.ItemSlot, { scope: t, children: /* @__PURE__ */ T(
      WHe,
      {
        "aria-disabled": s.open && !o.collapsible || void 0,
        "data-orientation": i.orientation,
        id: s.triggerId,
        ...a,
        ...r,
        ref: e
      }
    ) });
  }
);
ZQ.displayName = n7;
var QQ = "AccordionContent", JQ = p.forwardRef(
  (n, e) => {
    const { __scopeAccordion: t, ...r } = n, i = P3(Oo, t), s = Fk(QQ, t), o = $k(t);
    return /* @__PURE__ */ T(
      GHe,
      {
        role: "region",
        "aria-labelledby": s.triggerId,
        "data-orientation": i.orientation,
        ...o,
        ...r,
        ref: e,
        style: {
          "--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
          "--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
          ...n.style
        }
      }
    );
  }
);
JQ.displayName = QQ;
function eJ(n) {
  return n ? "open" : "closed";
}
var nUe = jQ, rUe = qQ, iUe = XQ, tJ = ZQ, nJ = JQ;
const Dwt = nUe, sUe = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  rUe,
  {
    ref: t,
    className: Q("tw:border-b", n),
    ...e
  }
));
sUe.displayName = "AccordionItem";
const oUe = A.forwardRef(({ className: n, children: e, ...t }, r) => /* @__PURE__ */ T(iUe, { className: "tw:flex", children: /* @__PURE__ */ ee(
  tJ,
  {
    ref: r,
    className: Q(
      "tw:flex tw:flex-1 tw:items-center tw:justify-between tw:py-2 tw:font-medium tw:transition-all tw:hover:underline tw:[&[data-state=open]>svg]:rotate-180",
      n
    ),
    ...t,
    children: [
      e,
      /* @__PURE__ */ T(od, { className: "tw:h-4 tw:w-4 tw:shrink-0 tw:transition-transform tw:duration-200" })
    ]
  }
) }));
oUe.displayName = tJ.displayName;
const aUe = A.forwardRef(({ className: n, children: e, ...t }, r) => /* @__PURE__ */ T(
  nJ,
  {
    ref: r,
    className: "tw:overflow-hidden tw:text-sm tw:transition-all tw:data-[state=closed]:animate-accordion-up tw:data-[state=open]:animate-accordion-down",
    ...t,
    children: /* @__PURE__ */ T("div", { className: Q("tw:p-2 tw:pt-0", n), children: e })
  }
));
aUe.displayName = nJ.displayName;
const lUe = _c(
  "tw:relative tw:w-full tw:rounded-lg tw:border tw:p-4 tw:[&>svg~*]:pl-7 tw:[&>svg+div]:translate-y-[-3px] tw:[&>svg]:absolute tw:[&>svg]:left-4 tw:[&>svg]:top-4 tw:[&>svg]:text-foreground",
  {
    variants: {
      variant: {
        default: "tw:bg-background tw:text-foreground tw:hover:text-foreground",
        warning: "tw:border-primary/50 tw:text-primary tw:hover:text-primary tw:dark:border-primary tw:[&>svg]:text-primary",
        destructive: "tw:border-destructive/50 tw:text-destructive tw:hover:text-destructive tw:dark:border-destructive tw:[&>svg]:text-destructive"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
), rJ = A.forwardRef(({ className: n, variant: e, ...t }, r) => /* @__PURE__ */ T(
  "div",
  {
    ref: r,
    role: "alert",
    className: Q(lUe({ variant: e }), n),
    ...t
  }
));
rJ.displayName = "Alert";
const cUe = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  "h5",
  {
    ref: t,
    className: Q("tw:mb-1 tw:font-medium tw:leading-none tw:tracking-tight", n),
    ...e
  }
));
cUe.displayName = "AlertTitle";
const uUe = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  "div",
  {
    ref: t,
    className: Q("tw:text-sm tw:[&_p]:leading-relaxed", n),
    ...e
  }
));
uUe.displayName = "AlertDescription";
const dUe = _c(
  "tw:inline-flex tw:items-center tw:rounded-full tw:border tw:px-2.5 tw:py-0.5 tw:text-xs tw:font-semibold tw:transition-colors tw:focus:outline-hidden tw:focus:ring-2 tw:focus:ring-ring tw:focus:ring-offset-2",
  {
    variants: {
      variant: {
        default: "tw:border-transparent tw:bg-primary tw:text-primary-foreground tw:hover:bg-primary/80",
        secondary: "tw:border-transparent tw:bg-secondary tw:text-secondary-foreground tw:hover:bg-secondary/80",
        destructive: "tw:border-transparent tw:bg-destructive tw:text-destructive-foreground tw:hover:bg-destructive/80",
        outline: "tw:text-foreground"
      }
    },
    defaultVariants: {
      variant: "default"
    }
  }
);
function hz({ className: n, variant: e, ...t }) {
  return /* @__PURE__ */ T("div", { className: Q(dUe({ variant: e }), n), ...t });
}
function so(n) {
  const e = n.href?.includes("http") || !1, t = n.className ? n.className : n.foreground ? "tw:text-foreground" : void 0;
  return e ? /* @__PURE__ */ T(
    "a",
    {
      href: n.href,
      rel: "noopener noreferrer",
      target: "_blank",
      className: t,
      children: n.children
    }
  ) : n.href ? /* @__PURE__ */ T(Lfe, { to: n.href, className: t, children: n.children }) : /* @__PURE__ */ T(ft, { children: n.onClick ? /* @__PURE__ */ T("span", { onClick: n.onClick, className: "tw:cursor-pointer", children: n.children }) : n.children });
}
const fUe = A.forwardRef(({ className: n, href: e, onClick: t, ...r }, i) => e ? /* @__PURE__ */ T(so, { href: e, className: "tw:no-underline!", children: /* @__PURE__ */ T(
  "div",
  {
    ref: i,
    onClick: t,
    className: Q(
      "tw:rounded-lg tw:bg-card tw:text-card-foreground tw:shadow-sm tw:border-border tw:border tw:p-2",
      n
    ),
    ...r
  }
) }) : /* @__PURE__ */ T(
  "div",
  {
    ref: i,
    onClick: t,
    className: Q(
      "tw:rounded-lg tw:bg-card tw:text-card-foreground tw:shadow-sm tw:border-border tw:border tw:p-2",
      n,
      t ? "tw:cursor-pointer" : void 0
    ),
    ...r
  }
));
fUe.displayName = "Card";
const hUe = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  "div",
  {
    ref: t,
    className: Q("tw:flex tw:flex-col tw:space-y-1.5 tw:p-2", n),
    ...e
  }
));
hUe.displayName = "CardHeader";
const pUe = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  "div",
  {
    ref: t,
    className: Q(
      "tw:text-xl tw:font-semibold tw:leading-none tw:tracking-tight",
      n
    ),
    ...e
  }
));
pUe.displayName = "CardTitle";
const mUe = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  "div",
  {
    ref: t,
    className: Q("tw:text-sm tw:text-muted-foreground", n),
    ...e
  }
));
mUe.displayName = "CardDescription";
const gUe = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T("div", { ref: t, className: Q("tw:p-2 tw:pt-0", n), ...e }));
gUe.displayName = "CardContent";
const vUe = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  "div",
  {
    ref: t,
    className: Q("tw:flex tw:items-center tw:p-2 tw:pt-0", n),
    ...e
  }
));
vUe.displayName = "CardFooter";
function yUe(n) {
  return Object.prototype.toString.call(n) === "[object Object]";
}
function pz(n) {
  return yUe(n) || Array.isArray(n);
}
function bUe() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
function Bk(n, e) {
  const t = Object.keys(n), r = Object.keys(e);
  if (t.length !== r.length) return !1;
  const i = JSON.stringify(Object.keys(n.breakpoints || {})), s = JSON.stringify(Object.keys(e.breakpoints || {}));
  return i !== s ? !1 : t.every((o) => {
    const a = n[o], l = e[o];
    return typeof a == "function" ? `${a}` == `${l}` : !pz(a) || !pz(l) ? a === l : Bk(a, l);
  });
}
function mz(n) {
  return n.concat().sort((e, t) => e.name > t.name ? 1 : -1).map((e) => e.options);
}
function wUe(n, e) {
  if (n.length !== e.length) return !1;
  const t = mz(n), r = mz(e);
  return t.every((i, s) => {
    const o = r[s];
    return Bk(i, o);
  });
}
function zk(n) {
  return typeof n == "number";
}
function r7(n) {
  return typeof n == "string";
}
function D3(n) {
  return typeof n == "boolean";
}
function gz(n) {
  return Object.prototype.toString.call(n) === "[object Object]";
}
function Wn(n) {
  return Math.abs(n);
}
function Hk(n) {
  return Math.sign(n);
}
function qp(n, e) {
  return Wn(n - e);
}
function xUe(n, e) {
  if (n === 0 || e === 0 || Wn(n) <= Wn(e)) return 0;
  const t = qp(Wn(n), Wn(e));
  return Wn(t / n);
}
function EUe(n) {
  return Math.round(n * 100) / 100;
}
function p0(n) {
  return m0(n).map(Number);
}
function wo(n) {
  return n[A1(n)];
}
function A1(n) {
  return Math.max(0, n.length - 1);
}
function Uk(n, e) {
  return e === A1(n);
}
function vz(n, e = 0) {
  return Array.from(Array(n), (t, r) => e + r);
}
function m0(n) {
  return Object.keys(n);
}
function iJ(n, e) {
  return [n, e].reduce((t, r) => (m0(r).forEach((i) => {
    const s = t[i], o = r[i], a = gz(s) && gz(o);
    t[i] = a ? iJ(s, o) : o;
  }), t), {});
}
function i7(n, e) {
  return typeof e.MouseEvent < "u" && n instanceof e.MouseEvent;
}
function SUe(n, e) {
  const t = {
    start: r,
    center: i,
    end: s
  };
  function r() {
    return 0;
  }
  function i(l) {
    return s(l) / 2;
  }
  function s(l) {
    return e - l;
  }
  function o(l, c) {
    return r7(n) ? t[n](l) : n(e, l, c);
  }
  return {
    measure: o
  };
}
function g0() {
  let n = [];
  function e(i, s, o, a = {
    passive: !0
  }) {
    let l;
    if ("addEventListener" in i)
      i.addEventListener(s, o, a), l = () => i.removeEventListener(s, o, a);
    else {
      const c = i;
      c.addListener(o), l = () => c.removeListener(o);
    }
    return n.push(l), r;
  }
  function t() {
    n = n.filter((i) => i());
  }
  const r = {
    add: e,
    clear: t
  };
  return r;
}
function CUe(n, e, t, r) {
  const i = g0(), s = 1e3 / 60;
  let o = null, a = 0, l = 0;
  function c() {
    i.add(n, "visibilitychange", () => {
      n.hidden && m();
    });
  }
  function u() {
    h(), i.clear();
  }
  function d(v) {
    if (!l) return;
    o || (o = v, t(), t());
    const y = v - o;
    for (o = v, a += y; a >= s; )
      t(), a -= s;
    const b = a / s;
    r(b), l && (l = e.requestAnimationFrame(d));
  }
  function f() {
    l || (l = e.requestAnimationFrame(d));
  }
  function h() {
    e.cancelAnimationFrame(l), o = null, a = 0, l = 0;
  }
  function m() {
    o = null, a = 0;
  }
  return {
    init: c,
    destroy: u,
    start: f,
    stop: h,
    update: t,
    render: r
  };
}
function TUe(n, e) {
  const t = e === "rtl", r = n === "y", i = r ? "y" : "x", s = r ? "x" : "y", o = !r && t ? -1 : 1, a = u(), l = d();
  function c(m) {
    const {
      height: g,
      width: v
    } = m;
    return r ? g : v;
  }
  function u() {
    return r ? "top" : t ? "right" : "left";
  }
  function d() {
    return r ? "bottom" : t ? "left" : "right";
  }
  function f(m) {
    return m * o;
  }
  return {
    scroll: i,
    cross: s,
    startEdge: a,
    endEdge: l,
    measureSize: c,
    direction: f
  };
}
function Fu(n = 0, e = 0) {
  const t = Wn(n - e);
  function r(c) {
    return c < n;
  }
  function i(c) {
    return c > e;
  }
  function s(c) {
    return r(c) || i(c);
  }
  function o(c) {
    return s(c) ? r(c) ? n : e : c;
  }
  function a(c) {
    return t ? c - t * Math.ceil((c - e) / t) : c;
  }
  return {
    length: t,
    max: e,
    min: n,
    constrain: o,
    reachedAny: s,
    reachedMax: i,
    reachedMin: r,
    removeOffset: a
  };
}
function sJ(n, e, t) {
  const {
    constrain: r
  } = Fu(0, n), i = n + 1;
  let s = o(e);
  function o(f) {
    return t ? Wn((i + f) % i) : r(f);
  }
  function a() {
    return s;
  }
  function l(f) {
    return s = o(f), d;
  }
  function c(f) {
    return u().set(a() + f);
  }
  function u() {
    return sJ(n, a(), t);
  }
  const d = {
    get: a,
    set: l,
    add: c,
    clone: u
  };
  return d;
}
function AUe(n, e, t, r, i, s, o, a, l, c, u, d, f, h, m, g, v, y, b) {
  const {
    cross: x,
    direction: E
  } = n, w = ["INPUT", "SELECT", "TEXTAREA"], C = {
    passive: !1
  }, S = g0(), M = g0(), k = Fu(50, 225).constrain(h.measure(20)), _ = {
    mouse: 300,
    touch: 400
  }, O = {
    mouse: 500,
    touch: 600
  }, I = m ? 43 : 25;
  let R = !1, P = 0, D = 0, L = !1, B = !1, $ = !1, z = !1;
  function H(j) {
    if (!b) return;
    function xe(qe) {
      (D3(b) || b(j, qe)) && ie(qe);
    }
    const ne = e;
    S.add(ne, "dragstart", (qe) => qe.preventDefault(), C).add(ne, "touchmove", () => {
    }, C).add(ne, "touchend", () => {
    }).add(ne, "touchstart", xe).add(ne, "mousedown", xe).add(ne, "touchcancel", se).add(ne, "contextmenu", se).add(ne, "click", te, !0);
  }
  function U() {
    S.clear(), M.clear();
  }
  function F() {
    const j = z ? t : e;
    M.add(j, "touchmove", J, C).add(j, "touchend", se).add(j, "mousemove", J, C).add(j, "mouseup", se);
  }
  function V(j) {
    const xe = j.nodeName || "";
    return w.includes(xe);
  }
  function X() {
    return (m ? O : _)[z ? "mouse" : "touch"];
  }
  function Z(j, xe) {
    const ne = d.add(Hk(j) * -1), qe = u.byDistance(j, !m).distance;
    return m || Wn(j) < k ? qe : v && xe ? qe * 0.5 : u.byIndex(ne.get(), 0).distance;
  }
  function ie(j) {
    const xe = i7(j, r);
    z = xe, $ = m && xe && !j.buttons && R, R = qp(i.get(), o.get()) >= 2, !(xe && j.button !== 0) && (V(j.target) || (L = !0, s.pointerDown(j), c.useFriction(0).useDuration(0), i.set(o), F(), P = s.readPoint(j), D = s.readPoint(j, x), f.emit("pointerDown")));
  }
  function J(j) {
    if (!i7(j, r) && j.touches.length >= 2) return se(j);
    const ne = s.readPoint(j), qe = s.readPoint(j, x), ve = qp(ne, P), Ie = qp(qe, D);
    if (!B && !z && (!j.cancelable || (B = ve > Ie, !B)))
      return se(j);
    const mt = s.pointerMove(j);
    ve > g && ($ = !0), c.useFriction(0.3).useDuration(0.75), a.start(), i.add(E(mt)), j.preventDefault();
  }
  function se(j) {
    const ne = u.byDistance(0, !1).index !== d.get(), qe = s.pointerUp(j) * X(), ve = Z(E(qe), ne), Ie = xUe(qe, ve), mt = I - 10 * Ie, xt = y + Ie / 50;
    B = !1, L = !1, M.clear(), c.useDuration(mt).useFriction(xt), l.distance(ve, !m), z = !1, f.emit("pointerUp");
  }
  function te(j) {
    $ && (j.stopPropagation(), j.preventDefault(), $ = !1);
  }
  function le() {
    return L;
  }
  return {
    init: H,
    destroy: U,
    pointerDown: le
  };
}
function MUe(n, e) {
  let r, i;
  function s(d) {
    return d.timeStamp;
  }
  function o(d, f) {
    const m = `client${(f || n.scroll) === "x" ? "X" : "Y"}`;
    return (i7(d, e) ? d : d.touches[0])[m];
  }
  function a(d) {
    return r = d, i = d, o(d);
  }
  function l(d) {
    const f = o(d) - o(i), h = s(d) - s(r) > 170;
    return i = d, h && (r = d), f;
  }
  function c(d) {
    if (!r || !i) return 0;
    const f = o(i) - o(r), h = s(d) - s(r), m = s(d) - s(i) > 170, g = f / h;
    return h && !m && Wn(g) > 0.1 ? g : 0;
  }
  return {
    pointerDown: a,
    pointerMove: l,
    pointerUp: c,
    readPoint: o
  };
}
function kUe() {
  function n(t) {
    const {
      offsetTop: r,
      offsetLeft: i,
      offsetWidth: s,
      offsetHeight: o
    } = t;
    return {
      top: r,
      right: i + s,
      bottom: r + o,
      left: i,
      width: s,
      height: o
    };
  }
  return {
    measure: n
  };
}
function _Ue(n) {
  function e(r) {
    return n * (r / 100);
  }
  return {
    measure: e
  };
}
function OUe(n, e, t, r, i, s, o) {
  const a = [n].concat(r);
  let l, c, u = [], d = !1;
  function f(v) {
    return i.measureSize(o.measure(v));
  }
  function h(v) {
    if (!s) return;
    c = f(n), u = r.map(f);
    function y(b) {
      for (const x of b) {
        if (d) return;
        const E = x.target === n, w = r.indexOf(x.target), C = E ? c : u[w], S = f(E ? n : r[w]);
        if (Wn(S - C) >= 0.5) {
          v.reInit(), e.emit("resize");
          break;
        }
      }
    }
    l = new ResizeObserver((b) => {
      (D3(s) || s(v, b)) && y(b);
    }), t.requestAnimationFrame(() => {
      a.forEach((b) => l.observe(b));
    });
  }
  function m() {
    d = !0, l && l.disconnect();
  }
  return {
    init: h,
    destroy: m
  };
}
function IUe(n, e, t, r, i, s) {
  let o = 0, a = 0, l = i, c = s, u = n.get(), d = 0;
  function f() {
    const C = r.get() - n.get(), S = !l;
    let M = 0;
    return S ? (o = 0, t.set(r), n.set(r), M = C) : (t.set(n), o += C / l, o *= c, u += o, n.add(o), M = u - d), a = Hk(M), d = u, w;
  }
  function h() {
    const C = r.get() - e.get();
    return Wn(C) < 1e-3;
  }
  function m() {
    return l;
  }
  function g() {
    return a;
  }
  function v() {
    return o;
  }
  function y() {
    return x(i);
  }
  function b() {
    return E(s);
  }
  function x(C) {
    return l = C, w;
  }
  function E(C) {
    return c = C, w;
  }
  const w = {
    direction: g,
    duration: m,
    velocity: v,
    seek: f,
    settled: h,
    useBaseFriction: b,
    useBaseDuration: y,
    useFriction: E,
    useDuration: x
  };
  return w;
}
function RUe(n, e, t, r, i) {
  const s = i.measure(10), o = i.measure(50), a = Fu(0.1, 0.99);
  let l = !1;
  function c() {
    return !(l || !n.reachedAny(t.get()) || !n.reachedAny(e.get()));
  }
  function u(h) {
    if (!c()) return;
    const m = n.reachedMin(e.get()) ? "min" : "max", g = Wn(n[m] - e.get()), v = t.get() - e.get(), y = a.constrain(g / o);
    t.subtract(v * y), !h && Wn(v) < s && (t.set(n.constrain(t.get())), r.useDuration(25).useBaseFriction());
  }
  function d(h) {
    l = !h;
  }
  return {
    shouldConstrain: c,
    constrain: u,
    toggleActive: d
  };
}
function PUe(n, e, t, r, i) {
  const s = Fu(-e + n, 0), o = d(), a = u(), l = f();
  function c(m, g) {
    return qp(m, g) <= 1;
  }
  function u() {
    const m = o[0], g = wo(o), v = o.lastIndexOf(m), y = o.indexOf(g) + 1;
    return Fu(v, y);
  }
  function d() {
    return t.map((m, g) => {
      const {
        min: v,
        max: y
      } = s, b = s.constrain(m), x = !g, E = Uk(t, g);
      return x ? y : E || c(v, b) ? v : c(y, b) ? y : b;
    }).map((m) => parseFloat(m.toFixed(3)));
  }
  function f() {
    if (e <= n + i) return [s.max];
    if (r === "keepSnaps") return o;
    const {
      min: m,
      max: g
    } = a;
    return o.slice(m, g);
  }
  return {
    snapsContained: l,
    scrollContainLimit: a
  };
}
function DUe(n, e, t) {
  const r = e[0], i = t ? r - n : wo(e);
  return {
    limit: Fu(i, r)
  };
}
function NUe(n, e, t, r) {
  const s = e.min + 0.1, o = e.max + 0.1, {
    reachedMin: a,
    reachedMax: l
  } = Fu(s, o);
  function c(f) {
    return f === 1 ? l(t.get()) : f === -1 ? a(t.get()) : !1;
  }
  function u(f) {
    if (!c(f)) return;
    const h = n * (f * -1);
    r.forEach((m) => m.add(h));
  }
  return {
    loop: u
  };
}
function LUe(n) {
  const {
    max: e,
    length: t
  } = n;
  function r(s) {
    const o = s - e;
    return t ? o / -t : 0;
  }
  return {
    get: r
  };
}
function $Ue(n, e, t, r, i) {
  const {
    startEdge: s,
    endEdge: o
  } = n, {
    groupSlides: a
  } = i, l = d().map(e.measure), c = f(), u = h();
  function d() {
    return a(r).map((g) => wo(g)[o] - g[0][s]).map(Wn);
  }
  function f() {
    return r.map((g) => t[s] - g[s]).map((g) => -Wn(g));
  }
  function h() {
    return a(c).map((g) => g[0]).map((g, v) => g + l[v]);
  }
  return {
    snaps: c,
    snapsAligned: u
  };
}
function FUe(n, e, t, r, i, s) {
  const {
    groupSlides: o
  } = i, {
    min: a,
    max: l
  } = r, c = u();
  function u() {
    const f = o(s), h = !n || e === "keepSnaps";
    return t.length === 1 ? [s] : h ? f : f.slice(a, l).map((m, g, v) => {
      const y = !g, b = Uk(v, g);
      if (y) {
        const x = wo(v[0]) + 1;
        return vz(x);
      }
      if (b) {
        const x = A1(s) - wo(v)[0] + 1;
        return vz(x, wo(v)[0]);
      }
      return m;
    });
  }
  return {
    slideRegistry: c
  };
}
function BUe(n, e, t, r, i) {
  const {
    reachedAny: s,
    removeOffset: o,
    constrain: a
  } = r;
  function l(m) {
    return m.concat().sort((g, v) => Wn(g) - Wn(v))[0];
  }
  function c(m) {
    const g = n ? o(m) : a(m), v = e.map((b, x) => ({
      diff: u(b - g, 0),
      index: x
    })).sort((b, x) => Wn(b.diff) - Wn(x.diff)), {
      index: y
    } = v[0];
    return {
      index: y,
      distance: g
    };
  }
  function u(m, g) {
    const v = [m, m + t, m - t];
    if (!n) return m;
    if (!g) return l(v);
    const y = v.filter((b) => Hk(b) === g);
    return y.length ? l(y) : wo(v) - t;
  }
  function d(m, g) {
    const v = e[m] - i.get(), y = u(v, g);
    return {
      index: m,
      distance: y
    };
  }
  function f(m, g) {
    const v = i.get() + m, {
      index: y,
      distance: b
    } = c(v), x = !n && s(v);
    if (!g || x) return {
      index: y,
      distance: m
    };
    const E = e[y] - b, w = m + u(E, 0);
    return {
      index: y,
      distance: w
    };
  }
  return {
    byDistance: f,
    byIndex: d,
    shortcut: u
  };
}
function zUe(n, e, t, r, i, s, o) {
  function a(d) {
    const f = d.distance, h = d.index !== e.get();
    s.add(f), f && (r.duration() ? n.start() : (n.update(), n.render(1), n.update())), h && (t.set(e.get()), e.set(d.index), o.emit("select"));
  }
  function l(d, f) {
    const h = i.byDistance(d, f);
    a(h);
  }
  function c(d, f) {
    const h = e.clone().set(d), m = i.byIndex(h.get(), f);
    a(m);
  }
  return {
    distance: l,
    index: c
  };
}
function HUe(n, e, t, r, i, s, o, a) {
  const l = {
    passive: !0,
    capture: !0
  };
  let c = 0;
  function u(h) {
    if (!a) return;
    function m(g) {
      if ((/* @__PURE__ */ new Date()).getTime() - c > 10) return;
      o.emit("slideFocusStart"), n.scrollLeft = 0;
      const b = t.findIndex((x) => x.includes(g));
      zk(b) && (i.useDuration(0), r.index(b, 0), o.emit("slideFocus"));
    }
    s.add(document, "keydown", d, !1), e.forEach((g, v) => {
      s.add(g, "focus", (y) => {
        (D3(a) || a(h, y)) && m(v);
      }, l);
    });
  }
  function d(h) {
    h.code === "Tab" && (c = (/* @__PURE__ */ new Date()).getTime());
  }
  return {
    init: u
  };
}
function Mp(n) {
  let e = n;
  function t() {
    return e;
  }
  function r(l) {
    e = o(l);
  }
  function i(l) {
    e += o(l);
  }
  function s(l) {
    e -= o(l);
  }
  function o(l) {
    return zk(l) ? l : l.get();
  }
  return {
    get: t,
    set: r,
    add: i,
    subtract: s
  };
}
function oJ(n, e) {
  const t = n.scroll === "x" ? o : a, r = e.style;
  let i = null, s = !1;
  function o(f) {
    return `translate3d(${f}px,0px,0px)`;
  }
  function a(f) {
    return `translate3d(0px,${f}px,0px)`;
  }
  function l(f) {
    if (s) return;
    const h = EUe(n.direction(f));
    h !== i && (r.transform = t(h), i = h);
  }
  function c(f) {
    s = !f;
  }
  function u() {
    s || (r.transform = "", e.getAttribute("style") || e.removeAttribute("style"));
  }
  return {
    clear: u,
    to: l,
    toggleActive: c
  };
}
function UUe(n, e, t, r, i, s, o, a, l) {
  const u = p0(i), d = p0(i).reverse(), f = y().concat(b());
  function h(S, M) {
    return S.reduce((k, _) => k - i[_], M);
  }
  function m(S, M) {
    return S.reduce((k, _) => h(k, M) > 0 ? k.concat([_]) : k, []);
  }
  function g(S) {
    return s.map((M, k) => ({
      start: M - r[k] + 0.5 + S,
      end: M + e - 0.5 + S
    }));
  }
  function v(S, M, k) {
    const _ = g(M);
    return S.map((O) => {
      const I = k ? 0 : -t, R = k ? t : 0, P = k ? "end" : "start", D = _[O][P];
      return {
        index: O,
        loopPoint: D,
        slideLocation: Mp(-1),
        translate: oJ(n, l[O]),
        target: () => a.get() > D ? I : R
      };
    });
  }
  function y() {
    const S = o[0], M = m(d, S);
    return v(M, t, !1);
  }
  function b() {
    const S = e - o[0] - 1, M = m(u, S);
    return v(M, -t, !0);
  }
  function x() {
    return f.every(({
      index: S
    }) => {
      const M = u.filter((k) => k !== S);
      return h(M, e) <= 0.1;
    });
  }
  function E() {
    f.forEach((S) => {
      const {
        target: M,
        translate: k,
        slideLocation: _
      } = S, O = M();
      O !== _.get() && (k.to(O), _.set(O));
    });
  }
  function w() {
    f.forEach((S) => S.translate.clear());
  }
  return {
    canLoop: x,
    clear: w,
    loop: E,
    loopPoints: f
  };
}
function VUe(n, e, t) {
  let r, i = !1;
  function s(l) {
    if (!t) return;
    function c(u) {
      for (const d of u)
        if (d.type === "childList") {
          l.reInit(), e.emit("slidesChanged");
          break;
        }
    }
    r = new MutationObserver((u) => {
      i || (D3(t) || t(l, u)) && c(u);
    }), r.observe(n, {
      childList: !0
    });
  }
  function o() {
    r && r.disconnect(), i = !0;
  }
  return {
    init: s,
    destroy: o
  };
}
function jUe(n, e, t, r) {
  const i = {};
  let s = null, o = null, a, l = !1;
  function c() {
    a = new IntersectionObserver((m) => {
      l || (m.forEach((g) => {
        const v = e.indexOf(g.target);
        i[v] = g;
      }), s = null, o = null, t.emit("slidesInView"));
    }, {
      root: n.parentElement,
      threshold: r
    }), e.forEach((m) => a.observe(m));
  }
  function u() {
    a && a.disconnect(), l = !0;
  }
  function d(m) {
    return m0(i).reduce((g, v) => {
      const y = parseInt(v), {
        isIntersecting: b
      } = i[y];
      return (m && b || !m && !b) && g.push(y), g;
    }, []);
  }
  function f(m = !0) {
    if (m && s) return s;
    if (!m && o) return o;
    const g = d(m);
    return m && (s = g), m || (o = g), g;
  }
  return {
    init: c,
    destroy: u,
    get: f
  };
}
function WUe(n, e, t, r, i, s) {
  const {
    measureSize: o,
    startEdge: a,
    endEdge: l
  } = n, c = t[0] && i, u = m(), d = g(), f = t.map(o), h = v();
  function m() {
    if (!c) return 0;
    const b = t[0];
    return Wn(e[a] - b[a]);
  }
  function g() {
    if (!c) return 0;
    const b = s.getComputedStyle(wo(r));
    return parseFloat(b.getPropertyValue(`margin-${l}`));
  }
  function v() {
    return t.map((b, x, E) => {
      const w = !x, C = Uk(E, x);
      return w ? f[x] + u : C ? f[x] + d : E[x + 1][a] - b[a];
    }).map(Wn);
  }
  return {
    slideSizes: f,
    slideSizesWithGaps: h,
    startGap: u,
    endGap: d
  };
}
function GUe(n, e, t, r, i, s, o, a, l) {
  const {
    startEdge: c,
    endEdge: u,
    direction: d
  } = n, f = zk(t);
  function h(y, b) {
    return p0(y).filter((x) => x % b === 0).map((x) => y.slice(x, x + b));
  }
  function m(y) {
    return y.length ? p0(y).reduce((b, x, E) => {
      const w = wo(b) || 0, C = w === 0, S = x === A1(y), M = i[c] - s[w][c], k = i[c] - s[x][u], _ = !r && C ? d(o) : 0, O = !r && S ? d(a) : 0, I = Wn(k - O - (M + _));
      return E && I > e + l && b.push(x), S && b.push(y.length), b;
    }, []).map((b, x, E) => {
      const w = Math.max(E[x - 1] || 0);
      return y.slice(w, b);
    }) : [];
  }
  function g(y) {
    return f ? h(y, t) : m(y);
  }
  return {
    groupSlides: g
  };
}
function KUe(n, e, t, r, i, s, o) {
  const {
    align: a,
    axis: l,
    direction: c,
    startIndex: u,
    loop: d,
    duration: f,
    dragFree: h,
    dragThreshold: m,
    inViewThreshold: g,
    slidesToScroll: v,
    skipSnaps: y,
    containScroll: b,
    watchResize: x,
    watchSlides: E,
    watchDrag: w,
    watchFocus: C
  } = s, S = 2, M = kUe(), k = M.measure(e), _ = t.map(M.measure), O = TUe(l, c), I = O.measureSize(k), R = _Ue(I), P = SUe(a, I), D = !d && !!b, L = d || !!b, {
    slideSizes: B,
    slideSizesWithGaps: $,
    startGap: z,
    endGap: H
  } = WUe(O, k, _, t, L, i), U = GUe(O, I, v, d, k, _, z, H, S), {
    snaps: F,
    snapsAligned: V
  } = $Ue(O, P, k, _, U), X = -wo(F) + wo($), {
    snapsContained: Z,
    scrollContainLimit: ie
  } = PUe(I, X, V, b, S), J = D ? Z : V, {
    limit: se
  } = DUe(X, J, d), te = sJ(A1(J), u, d), le = te.clone(), de = p0(t), j = ({
    dragHandler: Wt,
    scrollBody: me,
    scrollBounds: Pe,
    options: {
      loop: yt
    }
  }) => {
    yt || Pe.constrain(Wt.pointerDown()), me.seek();
  }, xe = ({
    scrollBody: Wt,
    translate: me,
    location: Pe,
    offsetLocation: yt,
    previousLocation: kt,
    scrollLooper: rn,
    slideLooper: vn,
    dragHandler: Xi,
    animation: ot,
    eventHandler: Ae,
    scrollBounds: De,
    options: {
      loop: et
    }
  }, it) => {
    const Ge = Wt.settled(), W = !De.shouldConstrain(), ue = et ? Ge : Ge && W, we = ue && !Xi.pointerDown();
    we && ot.stop();
    const Le = Pe.get() * it + kt.get() * (1 - it);
    yt.set(Le), et && (rn.loop(Wt.direction()), vn.loop()), me.to(yt.get()), we && Ae.emit("settle"), ue || Ae.emit("scroll");
  }, ne = CUe(r, i, () => j(Yt), (Wt) => xe(Yt, Wt)), qe = 0.68, ve = J[te.get()], Ie = Mp(ve), mt = Mp(ve), xt = Mp(ve), G = Mp(ve), re = IUe(Ie, xt, mt, G, f, qe), oe = BUe(d, J, X, se, G), Se = zUe(ne, te, le, re, oe, G, o), ye = LUe(se), be = g0(), Oe = jUe(e, t, o, g), {
    slideRegistry: ut
  } = FUe(D, b, J, ie, U, de), Et = HUe(n, t, ut, Se, re, be, o, C), Yt = {
    ownerDocument: r,
    ownerWindow: i,
    eventHandler: o,
    containerRect: k,
    slideRects: _,
    animation: ne,
    axis: O,
    dragHandler: AUe(O, n, r, i, G, MUe(O, i), Ie, ne, Se, re, oe, te, o, R, h, m, y, qe, w),
    eventStore: be,
    percentOfView: R,
    index: te,
    indexPrevious: le,
    limit: se,
    location: Ie,
    offsetLocation: xt,
    previousLocation: mt,
    options: s,
    resizeHandler: OUe(e, o, i, t, O, x, M),
    scrollBody: re,
    scrollBounds: RUe(se, xt, G, re, R),
    scrollLooper: NUe(X, se, xt, [Ie, xt, mt, G]),
    scrollProgress: ye,
    scrollSnapList: J.map(ye.get),
    scrollSnaps: J,
    scrollTarget: oe,
    scrollTo: Se,
    slideLooper: UUe(O, I, X, B, $, F, J, xt, t),
    slideFocus: Et,
    slidesHandler: VUe(e, o, E),
    slidesInView: Oe,
    slideIndexes: de,
    slideRegistry: ut,
    slidesToScroll: U,
    target: G,
    translate: oJ(O, e)
  };
  return Yt;
}
function qUe() {
  let n = {}, e;
  function t(c) {
    e = c;
  }
  function r(c) {
    return n[c] || [];
  }
  function i(c) {
    return r(c).forEach((u) => u(e, c)), l;
  }
  function s(c, u) {
    return n[c] = r(c).concat([u]), l;
  }
  function o(c, u) {
    return n[c] = r(c).filter((d) => d !== u), l;
  }
  function a() {
    n = {};
  }
  const l = {
    init: t,
    emit: i,
    off: o,
    on: s,
    clear: a
  };
  return l;
}
const YUe = {
  align: "center",
  axis: "x",
  container: null,
  slides: null,
  containScroll: "trimSnaps",
  direction: "ltr",
  slidesToScroll: 1,
  inViewThreshold: 0,
  breakpoints: {},
  dragFree: !1,
  dragThreshold: 10,
  loop: !1,
  skipSnaps: !1,
  duration: 25,
  startIndex: 0,
  active: !0,
  watchDrag: !0,
  watchResize: !0,
  watchSlides: !0,
  watchFocus: !0
};
function XUe(n) {
  function e(s, o) {
    return iJ(s, o || {});
  }
  function t(s) {
    const o = s.breakpoints || {}, a = m0(o).filter((l) => n.matchMedia(l).matches).map((l) => o[l]).reduce((l, c) => e(l, c), {});
    return e(s, a);
  }
  function r(s) {
    return s.map((o) => m0(o.breakpoints || {})).reduce((o, a) => o.concat(a), []).map(n.matchMedia);
  }
  return {
    mergeOptions: e,
    optionsAtMedia: t,
    optionsMediaQueries: r
  };
}
function ZUe(n) {
  let e = [];
  function t(s, o) {
    return e = o.filter(({
      options: a
    }) => n.optionsAtMedia(a).active !== !1), e.forEach((a) => a.init(s, n)), o.reduce((a, l) => Object.assign(a, {
      [l.name]: l
    }), {});
  }
  function r() {
    e = e.filter((s) => s.destroy());
  }
  return {
    init: t,
    destroy: r
  };
}
function Dy(n, e, t) {
  const r = n.ownerDocument, i = r.defaultView, s = XUe(i), o = ZUe(s), a = g0(), l = qUe(), {
    mergeOptions: c,
    optionsAtMedia: u,
    optionsMediaQueries: d
  } = s, {
    on: f,
    off: h,
    emit: m
  } = l, g = O;
  let v = !1, y, b = c(YUe, Dy.globalOptions), x = c(b), E = [], w, C, S;
  function M() {
    const {
      container: de,
      slides: j
    } = x;
    C = (r7(de) ? n.querySelector(de) : de) || n.children[0];
    const ne = r7(j) ? C.querySelectorAll(j) : j;
    S = [].slice.call(ne || C.children);
  }
  function k(de) {
    const j = KUe(n, C, S, r, i, de, l);
    if (de.loop && !j.slideLooper.canLoop()) {
      const xe = Object.assign({}, de, {
        loop: !1
      });
      return k(xe);
    }
    return j;
  }
  function _(de, j) {
    v || (b = c(b, de), x = u(b), E = j || E, M(), y = k(x), d([b, ...E.map(({
      options: xe
    }) => xe)]).forEach((xe) => a.add(xe, "change", O)), x.active && (y.translate.to(y.location.get()), y.animation.init(), y.slidesInView.init(), y.slideFocus.init(le), y.eventHandler.init(le), y.resizeHandler.init(le), y.slidesHandler.init(le), y.options.loop && y.slideLooper.loop(), C.offsetParent && S.length && y.dragHandler.init(le), w = o.init(le, E)));
  }
  function O(de, j) {
    const xe = U();
    I(), _(c({
      startIndex: xe
    }, de), j), l.emit("reInit");
  }
  function I() {
    y.dragHandler.destroy(), y.eventStore.clear(), y.translate.clear(), y.slideLooper.clear(), y.resizeHandler.destroy(), y.slidesHandler.destroy(), y.slidesInView.destroy(), y.animation.destroy(), o.destroy(), a.clear();
  }
  function R() {
    v || (v = !0, a.clear(), I(), l.emit("destroy"), l.clear());
  }
  function P(de, j, xe) {
    !x.active || v || (y.scrollBody.useBaseFriction().useDuration(j === !0 ? 0 : x.duration), y.scrollTo.index(de, xe || 0));
  }
  function D(de) {
    const j = y.index.add(1).get();
    P(j, de, -1);
  }
  function L(de) {
    const j = y.index.add(-1).get();
    P(j, de, 1);
  }
  function B() {
    return y.index.add(1).get() !== U();
  }
  function $() {
    return y.index.add(-1).get() !== U();
  }
  function z() {
    return y.scrollSnapList;
  }
  function H() {
    return y.scrollProgress.get(y.offsetLocation.get());
  }
  function U() {
    return y.index.get();
  }
  function F() {
    return y.indexPrevious.get();
  }
  function V() {
    return y.slidesInView.get();
  }
  function X() {
    return y.slidesInView.get(!1);
  }
  function Z() {
    return w;
  }
  function ie() {
    return y;
  }
  function J() {
    return n;
  }
  function se() {
    return C;
  }
  function te() {
    return S;
  }
  const le = {
    canScrollNext: B,
    canScrollPrev: $,
    containerNode: se,
    internalEngine: ie,
    destroy: R,
    off: h,
    on: f,
    emit: m,
    plugins: Z,
    previousScrollSnap: F,
    reInit: g,
    rootNode: J,
    scrollNext: D,
    scrollPrev: L,
    scrollProgress: H,
    scrollSnapList: z,
    scrollTo: P,
    selectedScrollSnap: U,
    slideNodes: te,
    slidesInView: V,
    slidesNotInView: X
  };
  return _(e, t), setTimeout(() => l.emit("init"), 0), le;
}
Dy.globalOptions = void 0;
function Vk(n = {}, e = []) {
  const t = Gt(n), r = Gt(e), [i, s] = wt(), [o, a] = wt(), l = Ft(() => {
    i && i.reInit(t.current, r.current);
  }, [i]);
  return Tt(() => {
    Bk(t.current, n) || (t.current = n, l());
  }, [n, l]), Tt(() => {
    wUe(r.current, e) || (r.current = e, l());
  }, [e, l]), Tt(() => {
    if (bUe() && o) {
      Dy.globalOptions = Vk.globalOptions;
      const c = Dy(o, t.current, r.current);
      return s(c), () => c.destroy();
    } else
      s(void 0);
  }, [o, s]), [a, i];
}
Vk.globalOptions = void 0;
const aJ = A.createContext(null);
function N3() {
  const n = A.useContext(aJ);
  if (!n)
    throw new Error("useCarousel must be used within a <Carousel />");
  return n;
}
const QUe = A.forwardRef(
  ({
    orientation: n = "horizontal",
    opts: e,
    setApi: t,
    plugins: r,
    className: i,
    children: s,
    ...o
  }, a) => {
    const [l, c] = Vk(
      {
        ...e,
        axis: n === "horizontal" ? "x" : "y"
      },
      r
    ), [u, d] = A.useState(!1), [f, h] = A.useState(!1), m = A.useCallback((b) => {
      b && (d(b.canScrollPrev()), h(b.canScrollNext()));
    }, []), g = A.useCallback(() => {
      c?.scrollPrev();
    }, [c]), v = A.useCallback(() => {
      c?.scrollNext();
    }, [c]), y = A.useCallback(
      (b) => {
        b.key === "ArrowLeft" ? (b.preventDefault(), g()) : b.key === "ArrowRight" && (b.preventDefault(), v());
      },
      [g, v]
    );
    return A.useEffect(() => {
      !c || !t || t(c);
    }, [c, t]), A.useEffect(() => {
      if (c)
        return m(c), c.on("reInit", m), c.on("select", m), () => {
          c?.off("select", m);
        };
    }, [c, m]), /* @__PURE__ */ T(
      aJ.Provider,
      {
        value: {
          carouselRef: l,
          api: c,
          opts: e,
          orientation: n || (e?.axis === "y" ? "vertical" : "horizontal"),
          scrollPrev: g,
          scrollNext: v,
          canScrollPrev: u,
          canScrollNext: f
        },
        children: /* @__PURE__ */ T(
          "div",
          {
            ref: a,
            onKeyDownCapture: y,
            className: Q("tw:relative", i),
            role: "region",
            "aria-roledescription": "carousel",
            ...o,
            children: s
          }
        )
      }
    );
  }
);
QUe.displayName = "Carousel";
const JUe = A.forwardRef(({ className: n, ...e }, t) => {
  const { carouselRef: r, orientation: i } = N3();
  return /* @__PURE__ */ T("div", { ref: r, className: "tw:overflow-hidden", children: /* @__PURE__ */ T(
    "div",
    {
      ref: t,
      className: Q(
        "tw:flex",
        i === "horizontal" ? "tw:-ml-4" : "tw:-mt-4 tw:flex-col",
        n
      ),
      ...e
    }
  ) });
});
JUe.displayName = "CarouselContent";
const eVe = A.forwardRef(({ className: n, ...e }, t) => {
  const { orientation: r } = N3();
  return /* @__PURE__ */ T(
    "div",
    {
      ref: t,
      role: "group",
      "aria-roledescription": "slide",
      className: Q(
        "tw:min-w-0 tw:shrink-0 tw:grow-0 tw:basis-full",
        r === "horizontal" ? "tw:pl-4" : "tw:pt-4",
        n
      ),
      ...e
    }
  );
});
eVe.displayName = "CarouselItem";
const tVe = A.forwardRef(({ className: n, variant: e = "outline", size: t = "icon", ...r }, i) => {
  const { orientation: s, scrollPrev: o, canScrollPrev: a } = N3();
  return /* @__PURE__ */ ee(
    Nt,
    {
      ref: i,
      variant: e,
      size: t,
      className: Q(
        "tw:absolute tw: tw:h-8 tw:w-8 tw:rounded-full",
        s === "horizontal" ? "tw:-left-12 tw:top-1/2 tw:-translate-y-1/2" : "tw:-top-12 tw:left-1/2 tw:-translate-x-1/2 tw:rotate-90",
        n
      ),
      disabled: !a,
      onClick: o,
      ...r,
      children: [
        /* @__PURE__ */ T(KOe, { className: "tw:h-4 tw:w-4" }),
        /* @__PURE__ */ T("span", { className: "tw:sr-only", children: "Previous slide" })
      ]
    }
  );
});
tVe.displayName = "CarouselPrevious";
const nVe = A.forwardRef(({ className: n, variant: e = "outline", size: t = "icon", ...r }, i) => {
  const { orientation: s, scrollNext: o, canScrollNext: a } = N3();
  return /* @__PURE__ */ ee(
    Nt,
    {
      ref: i,
      variant: e,
      size: t,
      className: Q(
        "tw:absolute tw:h-8 tw:w-8 tw:rounded-full",
        s === "horizontal" ? "tw:-right-12 tw:top-1/2 tw:-translate-y-1/2" : "tw:-bottom-12 tw:left-1/2 tw:-translate-x-1/2 tw:rotate-90",
        n
      ),
      disabled: !a,
      onClick: o,
      ...r,
      children: [
        /* @__PURE__ */ T(YOe, { className: "tw:h-4 tw:w-4" }),
        /* @__PURE__ */ T("span", { className: "tw:sr-only", children: "Next slide" })
      ]
    }
  );
});
nVe.displayName = "CarouselNext";
const rVe = { light: "", dark: ".dark" }, lJ = A.createContext(null);
function cJ() {
  const n = A.useContext(lJ);
  if (!n)
    throw new Error("useChart must be used within a <ChartContainer />");
  return n;
}
const iVe = A.forwardRef(({ id: n, className: e, children: t, config: r, ...i }, s) => {
  const o = A.useId(), a = `chart-${n || o.replace(/:/g, "")}`;
  return /* @__PURE__ */ T(lJ.Provider, { value: { config: r }, children: /* @__PURE__ */ ee(
    "div",
    {
      "data-chart": a,
      ref: s,
      className: Q(
        "tw:flex tw:aspect-video tw:justify-center tw:text-xs tw:[&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground tw:[&_.recharts-cartesian-grid_line[stroke=#ccc]]:stroke-border/50 tw:[&_.recharts-curve.recharts-tooltip-cursor]:stroke-border tw:[&_.recharts-dot[stroke=#fff]]:stroke-transparent tw:[&_.recharts-layer]:outline-none tw:[&_.recharts-polar-grid_[stroke=#ccc]]:stroke-border tw:[&_.recharts-radial-bar-background-sector]:fill-muted tw:[&_.recharts-rectangle.recharts-tooltip-cursor]:fill-muted tw:[&_.recharts-reference-line_[stroke=#ccc]]:stroke-border tw:[&_.recharts-sector[stroke=#fff]]:stroke-transparent tw:[&_.recharts-sector]:outline-none tw:[&_.recharts-surface]:outline-none",
        e
      ),
      ...i,
      children: [
        /* @__PURE__ */ T(sVe, { id: a, config: r }),
        /* @__PURE__ */ T(Ege, { children: t })
      ]
    }
  ) });
});
iVe.displayName = "Chart";
const sVe = ({ id: n, config: e }) => {
  const t = Object.entries(e).filter(
    ([, r]) => r.theme || r.color
  );
  return t.length ? /* @__PURE__ */ T(
    "style",
    {
      dangerouslySetInnerHTML: {
        __html: Object.entries(rVe).map(
          ([r, i]) => `
${i} [data-chart=${n}] {
${t.map(([s, o]) => {
            const a = o.theme?.[r] || o.color;
            return a ? `  --color-${s}: ${a};` : null;
          }).join(`
`)}
}
`
        ).join(`
`)
      }
    }
  ) : null;
}, Nwt = Yo, oVe = A.forwardRef(
  ({
    active: n,
    payload: e,
    className: t,
    indicator: r = "dot",
    hideLabel: i = !1,
    hideIndicator: s = !1,
    label: o,
    labelFormatter: a,
    labelClassName: l,
    formatter: c,
    color: u,
    nameKey: d,
    labelKey: f
  }, h) => {
    const { config: m } = cJ(), g = A.useMemo(() => {
      if (i || !e?.length)
        return null;
      const [y] = e, b = `${f || y?.dataKey || y?.name || "value"}`, x = s7(m, y, b), E = !f && typeof o == "string" ? m[o]?.label || o : x?.label;
      return a ? /* @__PURE__ */ T("div", { className: Q("tw:font-medium", l), children: a(E, e) }) : E ? /* @__PURE__ */ T("div", { className: Q("tw:font-medium", l), children: E }) : null;
    }, [
      o,
      a,
      e,
      i,
      l,
      m,
      f
    ]);
    if (!n || !e?.length)
      return null;
    const v = e.length === 1 && r !== "dot";
    return /* @__PURE__ */ ee(
      "div",
      {
        ref: h,
        className: Q(
          "tw:grid tw:min-w-[8rem] tw:items-start tw:gap-1.5 tw:rounded-lg tw:border tw:border-border/50 tw:bg-background tw:px-2.5 tw:py-1.5 tw:text-xs tw:shadow-xl",
          t
        ),
        children: [
          v ? null : g,
          /* @__PURE__ */ T("div", { className: "tw:grid tw:gap-1.5", children: e.filter((y) => y.type !== "none").map((y, b) => {
            const x = `${d || y.name || y.dataKey || "value"}`, E = s7(m, y, x), w = u || y.payload.fill || y.color;
            return /* @__PURE__ */ T(
              "div",
              {
                className: Q(
                  "tw:flex tw:w-full tw:flex-wrap tw:items-stretch tw:gap-2 tw:[&>svg]:h-2.5 tw:[&>svg]:w-2.5 tw:[&>svg]:text-muted-foreground",
                  r === "dot" && "tw:items-center"
                ),
                children: c && y?.value !== void 0 && y.name ? c(y.value, y.name, y, b, y.payload) : /* @__PURE__ */ ee(ft, { children: [
                  E?.icon ? /* @__PURE__ */ T(E.icon, {}) : !s && /* @__PURE__ */ T(
                    "div",
                    {
                      className: Q(
                        "tw:shrink-0 tw:rounded-[2px] tw:border-[--color-border] tw:bg-[--color-bg]",
                        {
                          "h-2.5 w-2.5": r === "dot",
                          "w-1": r === "line",
                          "w-0 border-[1.5px] border-dashed bg-transparent": r === "dashed",
                          "my-0.5": v && r === "dashed"
                        }
                      ),
                      style: {
                        "--color-bg": w,
                        "--color-border": w
                      }
                    }
                  ),
                  /* @__PURE__ */ ee(
                    "div",
                    {
                      className: Q(
                        "tw:flex tw:flex-1 tw:justify-between tw:leading-none",
                        v ? "tw:items-end" : "tw:items-center"
                      ),
                      children: [
                        /* @__PURE__ */ ee("div", { className: "tw:grid tw:gap-1.5", children: [
                          v ? g : null,
                          /* @__PURE__ */ T("span", { className: "tw:text-muted-foreground", children: E?.label || y.name })
                        ] }),
                        y.value && /* @__PURE__ */ T("span", { className: "tw:font-mono tw:font-medium tw:tabular-nums tw:text-foreground", children: y.value.toLocaleString() })
                      ]
                    }
                  )
                ] })
              },
              y.dataKey
            );
          }) })
        ]
      }
    );
  }
);
oVe.displayName = "ChartTooltip";
const Lwt = yu, aVe = A.forwardRef(
  ({ className: n, hideIcon: e = !1, payload: t, verticalAlign: r = "bottom", nameKey: i }, s) => {
    const { config: o } = cJ();
    return t?.length ? /* @__PURE__ */ T(
      "div",
      {
        ref: s,
        className: Q(
          "tw:flex tw:items-center tw:justify-center tw:gap-4",
          r === "top" ? "tw:pb-3" : "tw:pt-3",
          n
        ),
        children: t.filter((a) => a.type !== "none").map((a) => {
          const l = `${i || a.dataKey || "value"}`, c = s7(o, a, l);
          return /* @__PURE__ */ ee(
            "div",
            {
              className: Q(
                "tw:flex tw:items-center tw:gap-1.5 tw:[&>svg]:h-3 tw:[&>svg]:w-3 tw:[&>svg]:text-muted-foreground"
              ),
              children: [
                c?.icon && !e ? /* @__PURE__ */ T(c.icon, {}) : /* @__PURE__ */ T(
                  "div",
                  {
                    className: "tw:h-2 tw:w-2 tw:shrink-0 tw:rounded-[2px]",
                    style: {
                      backgroundColor: a.color
                    }
                  }
                ),
                c?.label
              ]
            },
            a.value
          );
        })
      }
    ) : null;
  }
);
aVe.displayName = "ChartLegend";
function s7(n, e, t) {
  if (typeof e != "object" || e === null)
    return;
  const r = "payload" in e && typeof e.payload == "object" && e.payload !== null ? e.payload : void 0;
  let i = t;
  return t in e && typeof e[t] == "string" ? i = e[t] : r && t in r && typeof r[t] == "string" && (i = r[t]), i in n ? n[i] : n[t];
}
const lVe = VQ, cVe = Rk, uVe = Dk;
function dVe(n) {
  if (typeof document > "u") return;
  let e = document.head || document.getElementsByTagName("head")[0], t = document.createElement("style");
  t.type = "text/css", e.appendChild(t), t.styleSheet ? t.styleSheet.cssText = n : t.appendChild(document.createTextNode(n));
}
const uJ = p.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldAnimate: {
    current: !0
  },
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), M1 = () => {
  const n = p.useContext(uJ);
  if (!n)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return n;
};
dVe(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function fVe() {
  const n = navigator.userAgent;
  return typeof window < "u" && (/Firefox/.test(n) && /Mobile/.test(n) || // Android Firefox
  /FxiOS/.test(n));
}
function hVe() {
  return jk(/^Mac/);
}
function pVe() {
  return jk(/^iPhone/);
}
function yz() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function mVe() {
  return jk(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  hVe() && navigator.maxTouchPoints > 1;
}
function dJ() {
  return pVe() || mVe();
}
function jk(n) {
  return typeof window < "u" && window.navigator != null ? n.test(window.navigator.platform) : void 0;
}
const gVe = 24, vVe = typeof window < "u" ? vh : Tt;
function bz(...n) {
  return (...e) => {
    for (let t of n)
      typeof t == "function" && t(...e);
  };
}
const p6 = typeof document < "u" && window.visualViewport;
function wz(n) {
  let e = window.getComputedStyle(n);
  return /(auto|scroll)/.test(e.overflow + e.overflowX + e.overflowY);
}
function fJ(n) {
  for (wz(n) && (n = n.parentElement); n && !wz(n); )
    n = n.parentElement;
  return n || document.scrollingElement || document.documentElement;
}
const yVe = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let _g = 0, m6;
function bVe(n = {}) {
  let { isDisabled: e } = n;
  vVe(() => {
    if (!e)
      return _g++, _g === 1 && dJ() && (m6 = wVe()), () => {
        _g--, _g === 0 && m6?.();
      };
  }, [
    e
  ]);
}
function wVe() {
  let n, e = 0, t = (d) => {
    n = fJ(d.target), !(n === document.documentElement && n === document.body) && (e = d.changedTouches[0].pageY);
  }, r = (d) => {
    if (!n || n === document.documentElement || n === document.body) {
      d.preventDefault();
      return;
    }
    let f = d.changedTouches[0].pageY, h = n.scrollTop, m = n.scrollHeight - n.clientHeight;
    m !== 0 && ((h <= 0 && f > e || h >= m && f < e) && d.preventDefault(), e = f);
  }, i = (d) => {
    let f = d.target;
    o7(f) && f !== document.activeElement && (d.preventDefault(), f.style.transform = "translateY(-2000px)", f.focus(), requestAnimationFrame(() => {
      f.style.transform = "";
    }));
  }, s = (d) => {
    let f = d.target;
    o7(f) && (f.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      f.style.transform = "", p6 && (p6.height < window.innerHeight ? requestAnimationFrame(() => {
        xz(f);
      }) : p6.addEventListener("resize", () => xz(f), {
        once: !0
      }));
    }));
  }, o = () => {
    window.scrollTo(0, 0);
  }, a = window.pageXOffset, l = window.pageYOffset, c = bz(xVe(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let u = bz(ap(document, "touchstart", t, {
    passive: !1,
    capture: !0
  }), ap(document, "touchmove", r, {
    passive: !1,
    capture: !0
  }), ap(document, "touchend", i, {
    passive: !1,
    capture: !0
  }), ap(document, "focus", s, !0), ap(window, "scroll", o));
  return () => {
    c(), u(), window.scrollTo(a, l);
  };
}
function xVe(n, e, t) {
  let r = n.style[e];
  return n.style[e] = t, () => {
    n.style[e] = r;
  };
}
function ap(n, e, t, r) {
  return n.addEventListener(e, t, r), () => {
    n.removeEventListener(e, t, r);
  };
}
function xz(n) {
  let e = document.scrollingElement || document.documentElement;
  for (; n && n !== e; ) {
    let t = fJ(n);
    if (t !== document.documentElement && t !== document.body && t !== n) {
      let r = t.getBoundingClientRect().top, i = n.getBoundingClientRect().top, s = n.getBoundingClientRect().bottom;
      const o = t.getBoundingClientRect().bottom + gVe;
      s > o && (t.scrollTop += i - r);
    }
    n = t.parentElement;
  }
}
function o7(n) {
  return n instanceof HTMLInputElement && !yVe.has(n.type) || n instanceof HTMLTextAreaElement || n instanceof HTMLElement && n.isContentEditable;
}
function EVe(n, e) {
  typeof n == "function" ? n(e) : n != null && (n.current = e);
}
function SVe(...n) {
  return (e) => n.forEach((t) => EVe(t, e));
}
function hJ(...n) {
  return A.useCallback(SVe(...n), n);
}
const pJ = /* @__PURE__ */ new WeakMap();
function vr(n, e, t = !1) {
  if (!n || !(n instanceof HTMLElement)) return;
  let r = {};
  Object.entries(e).forEach(([i, s]) => {
    if (i.startsWith("--")) {
      n.style.setProperty(i, s);
      return;
    }
    r[i] = n.style[i], n.style[i] = s;
  }), !t && pJ.set(n, r);
}
function CVe(n, e) {
  if (!n || !(n instanceof HTMLElement)) return;
  let t = pJ.get(n);
  t && (n.style[e] = t[e]);
}
const ir = (n) => {
  switch (n) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return n;
  }
};
function Og(n, e) {
  if (!n)
    return null;
  const t = window.getComputedStyle(n), r = (
    // @ts-ignore
    t.transform || t.webkitTransform || t.mozTransform
  );
  let i = r.match(/^matrix3d\((.+)\)$/);
  return i ? parseFloat(i[1].split(", ")[ir(e) ? 13 : 12]) : (i = r.match(/^matrix\((.+)\)$/), i ? parseFloat(i[1].split(", ")[ir(e) ? 5 : 4]) : null);
}
function TVe(n) {
  return 8 * (Math.log(n + 1) - 2);
}
function g6(n, e) {
  if (!n) return () => {
  };
  const t = n.style.cssText;
  return Object.assign(n.style, e), () => {
    n.style.cssText = t;
  };
}
function AVe(...n) {
  return (...e) => {
    for (const t of n)
      typeof t == "function" && t(...e);
  };
}
const Hn = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, mJ = 0.4, MVe = 0.25, kVe = 100, gJ = 8, Vc = 16, a7 = 26, v6 = "vaul-dragging";
function vJ(n) {
  const e = p.useRef(n);
  return p.useEffect(() => {
    e.current = n;
  }), p.useMemo(() => (...t) => e.current == null ? void 0 : e.current.call(e, ...t), []);
}
function _Ve({ defaultProp: n, onChange: e }) {
  const t = p.useState(n), [r] = t, i = p.useRef(r), s = vJ(e);
  return p.useEffect(() => {
    i.current !== r && (s(r), i.current = r);
  }, [
    r,
    i,
    s
  ]), t;
}
function yJ({ prop: n, defaultProp: e, onChange: t = () => {
} }) {
  const [r, i] = _Ve({
    defaultProp: e,
    onChange: t
  }), s = n !== void 0, o = s ? n : r, a = vJ(t), l = p.useCallback((c) => {
    if (s) {
      const d = typeof c == "function" ? c(n) : c;
      d !== n && a(d);
    } else
      i(c);
  }, [
    s,
    n,
    i,
    a
  ]);
  return [
    o,
    l
  ];
}
function OVe({ activeSnapPointProp: n, setActiveSnapPointProp: e, snapPoints: t, drawerRef: r, overlayRef: i, fadeFromIndex: s, onSnapPointChange: o, direction: a = "bottom", container: l, snapToSequentialPoint: c }) {
  const [u, d] = yJ({
    prop: n,
    defaultProp: t?.[0],
    onChange: e
  }), [f, h] = p.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  p.useEffect(() => {
    function S() {
      h({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", S), () => window.removeEventListener("resize", S);
  }, []);
  const m = p.useMemo(() => u === t?.[t.length - 1] || null, [
    t,
    u
  ]), g = p.useMemo(() => {
    var S;
    return (S = t?.findIndex((M) => M === u)) != null ? S : null;
  }, [
    t,
    u
  ]), v = t && t.length > 0 && (s || s === 0) && !Number.isNaN(s) && t[s] === u || !t, y = p.useMemo(() => {
    const S = l ? {
      width: l.getBoundingClientRect().width,
      height: l.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var M;
    return (M = t?.map((k) => {
      const _ = typeof k == "string";
      let O = 0;
      if (_ && (O = parseInt(k, 10)), ir(a)) {
        const R = _ ? O : f ? k * S.height : 0;
        return f ? a === "bottom" ? S.height - R : -S.height + R : R;
      }
      const I = _ ? O : f ? k * S.width : 0;
      return f ? a === "right" ? S.width - I : -S.width + I : I;
    })) != null ? M : [];
  }, [
    t,
    f,
    l
  ]), b = p.useMemo(() => g !== null ? y?.[g] : null, [
    y,
    g
  ]), x = p.useCallback((S) => {
    var M;
    const k = (M = y?.findIndex((_) => _ === S)) != null ? M : null;
    o(k), vr(r.current, {
      transition: `transform ${Hn.DURATION}s cubic-bezier(${Hn.EASE.join(",")})`,
      transform: ir(a) ? `translate3d(0, ${S}px, 0)` : `translate3d(${S}px, 0, 0)`
    }), y && k !== y.length - 1 && s !== void 0 && k !== s && k < s ? vr(i.current, {
      transition: `opacity ${Hn.DURATION}s cubic-bezier(${Hn.EASE.join(",")})`,
      opacity: "0"
    }) : vr(i.current, {
      transition: `opacity ${Hn.DURATION}s cubic-bezier(${Hn.EASE.join(",")})`,
      opacity: "1"
    }), d(t?.[Math.max(k, 0)]);
  }, [
    r.current,
    t,
    y,
    s,
    i,
    d
  ]);
  p.useEffect(() => {
    if (u || n) {
      var S;
      const M = (S = t?.findIndex((k) => k === n || k === u)) != null ? S : -1;
      y && M !== -1 && typeof y[M] == "number" && x(y[M]);
    }
  }, [
    u,
    n,
    t,
    y,
    x
  ]);
  function E({ draggedDistance: S, closeDrawer: M, velocity: k, dismissible: _ }) {
    if (s === void 0) return;
    const O = a === "bottom" || a === "right" ? (b ?? 0) - S : (b ?? 0) + S, I = g === s - 1, R = g === 0, P = S > 0;
    if (I && vr(i.current, {
      transition: `opacity ${Hn.DURATION}s cubic-bezier(${Hn.EASE.join(",")})`
    }), !c && k > 2 && !P) {
      _ ? M() : x(y[0]);
      return;
    }
    if (!c && k > 2 && P && y && t) {
      x(y[t.length - 1]);
      return;
    }
    const D = y?.reduce((B, $) => typeof B != "number" || typeof $ != "number" ? B : Math.abs($ - O) < Math.abs(B - O) ? $ : B), L = ir(a) ? window.innerHeight : window.innerWidth;
    if (k > mJ && Math.abs(S) < L * 0.4) {
      const B = P ? 1 : -1;
      if (B > 0 && m && t) {
        x(y[t.length - 1]);
        return;
      }
      if (R && B < 0 && _ && M(), g === null) return;
      x(y[g + B]);
      return;
    }
    x(D);
  }
  function w({ draggedDistance: S }) {
    if (b === null) return;
    const M = a === "bottom" || a === "right" ? b - S : b + S;
    (a === "bottom" || a === "right") && M < y[y.length - 1] || (a === "top" || a === "left") && M > y[y.length - 1] || vr(r.current, {
      transform: ir(a) ? `translate3d(0, ${M}px, 0)` : `translate3d(${M}px, 0, 0)`
    });
  }
  function C(S, M) {
    if (!t || typeof g != "number" || !y || s === void 0) return null;
    const k = g === s - 1;
    if (g >= s && M)
      return 0;
    if (k && !M) return 1;
    if (!v && !k) return null;
    const O = k ? g + 1 : g - 1, I = k ? y[O] - y[O - 1] : y[O + 1] - y[O], R = S / Math.abs(I);
    return k ? 1 - R : R;
  }
  return {
    isLastSnapPoint: m,
    activeSnapPoint: u,
    shouldFade: v,
    getPercentageDragged: C,
    setActiveSnapPoint: d,
    activeSnapPointIndex: g,
    onRelease: E,
    onDrag: w,
    snapPointsOffset: y
  };
}
const IVe = () => () => {
};
function RVe() {
  const { direction: n, isOpen: e, shouldScaleBackground: t, setBackgroundColorOnScale: r, noBodyStyles: i } = M1(), s = p.useRef(null), o = ua(() => document.body.style.backgroundColor, []);
  function a() {
    return (window.innerWidth - a7) / window.innerWidth;
  }
  p.useEffect(() => {
    if (e && t) {
      s.current && clearTimeout(s.current);
      const l = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!l) return;
      AVe(r && !i ? g6(document.body, {
        background: "black"
      }) : IVe, g6(l, {
        transformOrigin: ir(n) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${Hn.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${Hn.EASE.join(",")})`
      }));
      const c = g6(l, {
        borderRadius: `${gJ}px`,
        overflow: "hidden",
        ...ir(n) ? {
          transform: `scale(${a()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${a()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        c(), s.current = window.setTimeout(() => {
          o ? document.body.style.background = o : document.body.style.removeProperty("background");
        }, Hn.DURATION * 1e3);
      };
    }
  }, [
    e,
    t,
    o
  ]);
}
let lp = null;
function PVe({ isOpen: n, modal: e, nested: t, hasBeenOpened: r, preventScrollRestoration: i, noBodyStyles: s }) {
  const [o, a] = p.useState(() => typeof window < "u" ? window.location.href : ""), l = p.useRef(0), c = p.useCallback(() => {
    if (yz() && lp === null && n && !s) {
      lp = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: d, innerHeight: f } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-l.current}px`,
        left: `${-d}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const h = f - window.innerHeight;
        h && l.current >= f && (document.body.style.top = `${-(l.current + h)}px`);
      }), 300);
    }
  }, [
    n
  ]), u = p.useCallback(() => {
    if (yz() && lp !== null && !s) {
      const d = -parseInt(document.body.style.top, 10), f = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, lp), window.requestAnimationFrame(() => {
        if (i && o !== window.location.href) {
          a(window.location.href);
          return;
        }
        window.scrollTo(f, d);
      }), lp = null;
    }
  }, [
    o
  ]);
  return p.useEffect(() => {
    function d() {
      l.current = window.scrollY;
    }
    return d(), window.addEventListener("scroll", d), () => {
      window.removeEventListener("scroll", d);
    };
  }, []), p.useEffect(() => {
    if (e)
      return () => {
        typeof document > "u" || document.querySelector("[data-vaul-drawer]") || u();
      };
  }, [
    e,
    u
  ]), p.useEffect(() => {
    t || !r || (n ? (!window.matchMedia("(display-mode: standalone)").matches && c(), e || window.setTimeout(() => {
      u();
    }, 500)) : u());
  }, [
    n,
    r,
    o,
    e,
    t,
    c,
    u
  ]), {
    restorePositionSetting: u
  };
}
function DVe({ open: n, onOpenChange: e, children: t, onDrag: r, onRelease: i, snapPoints: s, shouldScaleBackground: o = !1, setBackgroundColorOnScale: a = !0, closeThreshold: l = MVe, scrollLockTimeout: c = kVe, dismissible: u = !0, handleOnly: d = !1, fadeFromIndex: f = s && s.length - 1, activeSnapPoint: h, setActiveSnapPoint: m, fixed: g, modal: v = !0, onClose: y, nested: b, noBodyStyles: x = !1, direction: E = "bottom", defaultOpen: w = !1, disablePreventScroll: C = !0, snapToSequentialPoint: S = !1, preventScrollRestoration: M = !1, repositionInputs: k = !0, onAnimationEnd: _, container: O, autoFocus: I = !1 }) {
  var R, P;
  const [D = !1, L] = yJ({
    defaultProp: w,
    prop: n,
    onChange: (Ae) => {
      e?.(Ae), !Ae && !b && ut(), setTimeout(() => {
        _?.(Ae);
      }, Hn.DURATION * 1e3), Ae && !v && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), Ae || (document.body.style.pointerEvents = "auto");
    }
  }), [B, $] = p.useState(!1), [z, H] = p.useState(!1), [U, F] = p.useState(!1), V = p.useRef(null), X = p.useRef(null), Z = p.useRef(null), ie = p.useRef(null), J = p.useRef(null), se = p.useRef(!1), te = p.useRef(null), le = p.useRef(0), de = p.useRef(!1), j = p.useRef(!w), xe = p.useRef(0), ne = p.useRef(null), qe = p.useRef(((R = ne.current) == null ? void 0 : R.getBoundingClientRect().height) || 0), ve = p.useRef(((P = ne.current) == null ? void 0 : P.getBoundingClientRect().width) || 0), Ie = p.useRef(0), mt = p.useCallback((Ae) => {
    s && Ae === Se.length - 1 && (X.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: xt, activeSnapPointIndex: G, setActiveSnapPoint: re, onRelease: oe, snapPointsOffset: Se, onDrag: ye, shouldFade: be, getPercentageDragged: Oe } = OVe({
    snapPoints: s,
    activeSnapPointProp: h,
    setActiveSnapPointProp: m,
    drawerRef: ne,
    fadeFromIndex: f,
    overlayRef: V,
    onSnapPointChange: mt,
    direction: E,
    container: O,
    snapToSequentialPoint: S
  });
  bVe({
    isDisabled: !D || z || !v || U || !B || !k || !C
  });
  const { restorePositionSetting: ut } = PVe({
    isOpen: D,
    modal: v,
    nested: b ?? !1,
    hasBeenOpened: B,
    preventScrollRestoration: M,
    noBodyStyles: x
  });
  function Et() {
    return (window.innerWidth - a7) / window.innerWidth;
  }
  function Yt(Ae) {
    var De, et;
    !u && !s || ne.current && !ne.current.contains(Ae.target) || (qe.current = ((De = ne.current) == null ? void 0 : De.getBoundingClientRect().height) || 0, ve.current = ((et = ne.current) == null ? void 0 : et.getBoundingClientRect().width) || 0, H(!0), Z.current = /* @__PURE__ */ new Date(), dJ() && window.addEventListener("touchend", () => se.current = !1, {
      once: !0
    }), Ae.target.setPointerCapture(Ae.pointerId), le.current = ir(E) ? Ae.pageY : Ae.pageX);
  }
  function Wt(Ae, De) {
    var et;
    let it = Ae;
    const Ge = (et = window.getSelection()) == null ? void 0 : et.toString(), W = ne.current ? Og(ne.current, E) : null, ue = /* @__PURE__ */ new Date();
    if (it.tagName === "SELECT" || it.hasAttribute("data-vaul-no-drag") || it.closest("[data-vaul-no-drag]"))
      return !1;
    if (E === "right" || E === "left")
      return !0;
    if (X.current && ue.getTime() - X.current.getTime() < 500)
      return !1;
    if (W !== null && (E === "bottom" ? W > 0 : W < 0))
      return !0;
    if (Ge && Ge.length > 0)
      return !1;
    if (J.current && ue.getTime() - J.current.getTime() < c && W === 0 || De)
      return J.current = ue, !1;
    for (; it; ) {
      if (it.scrollHeight > it.clientHeight) {
        if (it.scrollTop !== 0)
          return J.current = /* @__PURE__ */ new Date(), !1;
        if (it.getAttribute("role") === "dialog")
          return !0;
      }
      it = it.parentNode;
    }
    return !0;
  }
  function me(Ae) {
    if (ne.current && z) {
      const De = E === "bottom" || E === "right" ? 1 : -1, et = (le.current - (ir(E) ? Ae.pageY : Ae.pageX)) * De, it = et > 0, Ge = s && !u && !it;
      if (Ge && G === 0) return;
      const W = Math.abs(et), ue = document.querySelector("[data-vaul-drawer-wrapper]"), we = E === "bottom" || E === "top" ? qe.current : ve.current;
      let Le = W / we;
      const Pt = Oe(W, it);
      if (Pt !== null && (Le = Pt), Ge && Le >= 1 || !se.current && !Wt(Ae.target, it)) return;
      if (ne.current.classList.add(v6), se.current = !0, vr(ne.current, {
        transition: "none"
      }), vr(V.current, {
        transition: "none"
      }), s && ye({
        draggedDistance: et
      }), it && !s) {
        const _e = TVe(et), $e = Math.min(_e * -1, 0) * De;
        vr(ne.current, {
          transform: ir(E) ? `translate3d(0, ${$e}px, 0)` : `translate3d(${$e}px, 0, 0)`
        });
        return;
      }
      const gt = 1 - Le;
      if ((be || f && G === f - 1) && (r?.(Ae, Le), vr(V.current, {
        opacity: `${gt}`,
        transition: "none"
      }, !0)), ue && V.current && o) {
        const _e = Math.min(Et() + Le * (1 - Et()), 1), $e = 8 - Le * 8, Qe = Math.max(0, 14 - Le * 14);
        vr(ue, {
          borderRadius: `${$e}px`,
          transform: ir(E) ? `scale(${_e}) translate3d(0, ${Qe}px, 0)` : `scale(${_e}) translate3d(${Qe}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!s) {
        const _e = W * De;
        vr(ne.current, {
          transform: ir(E) ? `translate3d(0, ${_e}px, 0)` : `translate3d(${_e}px, 0, 0)`
        });
      }
    }
  }
  p.useEffect(() => {
    window.requestAnimationFrame(() => {
      j.current = !0;
    });
  }, []), p.useEffect(() => {
    var Ae;
    function De() {
      if (!ne.current || !k) return;
      const et = document.activeElement;
      if (o7(et) || de.current) {
        var it;
        const Ge = ((it = window.visualViewport) == null ? void 0 : it.height) || 0, W = window.innerHeight;
        let ue = W - Ge;
        const we = ne.current.getBoundingClientRect().height || 0, Le = we > W * 0.8;
        Ie.current || (Ie.current = we);
        const Pt = ne.current.getBoundingClientRect().top;
        if (Math.abs(xe.current - ue) > 60 && (de.current = !de.current), s && s.length > 0 && Se && G) {
          const gt = Se[G] || 0;
          ue += gt;
        }
        if (xe.current = ue, we > Ge || de.current) {
          const gt = ne.current.getBoundingClientRect().height;
          let _e = gt;
          gt > Ge && (_e = Ge - (Le ? Pt : a7)), g ? ne.current.style.height = `${gt - Math.max(ue, 0)}px` : ne.current.style.height = `${Math.max(_e, Ge - Pt)}px`;
        } else fVe() || (ne.current.style.height = `${Ie.current}px`);
        s && s.length > 0 && !de.current ? ne.current.style.bottom = "0px" : ne.current.style.bottom = `${Math.max(ue, 0)}px`;
      }
    }
    return (Ae = window.visualViewport) == null || Ae.addEventListener("resize", De), () => {
      var et;
      return (et = window.visualViewport) == null ? void 0 : et.removeEventListener("resize", De);
    };
  }, [
    G,
    s,
    Se
  ]);
  function Pe(Ae) {
    kt(), y?.(), Ae || L(!1), setTimeout(() => {
      s && re(s[0]);
    }, Hn.DURATION * 1e3);
  }
  function yt() {
    if (!ne.current) return;
    const Ae = document.querySelector("[data-vaul-drawer-wrapper]"), De = Og(ne.current, E);
    vr(ne.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${Hn.DURATION}s cubic-bezier(${Hn.EASE.join(",")})`
    }), vr(V.current, {
      transition: `opacity ${Hn.DURATION}s cubic-bezier(${Hn.EASE.join(",")})`,
      opacity: "1"
    }), o && De && De > 0 && D && vr(Ae, {
      borderRadius: `${gJ}px`,
      overflow: "hidden",
      ...ir(E) ? {
        transform: `scale(${Et()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${Et()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${Hn.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${Hn.EASE.join(",")})`
    }, !0);
  }
  function kt() {
    !z || !ne.current || (ne.current.classList.remove(v6), se.current = !1, H(!1), ie.current = /* @__PURE__ */ new Date());
  }
  function rn(Ae) {
    if (!z || !ne.current) return;
    ne.current.classList.remove(v6), se.current = !1, H(!1), ie.current = /* @__PURE__ */ new Date();
    const De = Og(ne.current, E);
    if (!Ae || !Wt(Ae.target, !1) || !De || Number.isNaN(De) || Z.current === null) return;
    const et = ie.current.getTime() - Z.current.getTime(), it = le.current - (ir(E) ? Ae.pageY : Ae.pageX), Ge = Math.abs(it) / et;
    if (Ge > 0.05 && (F(!0), setTimeout(() => {
      F(!1);
    }, 200)), s) {
      oe({
        draggedDistance: it * (E === "bottom" || E === "right" ? 1 : -1),
        closeDrawer: Pe,
        velocity: Ge,
        dismissible: u
      }), i?.(Ae, !0);
      return;
    }
    if (E === "bottom" || E === "right" ? it > 0 : it < 0) {
      yt(), i?.(Ae, !0);
      return;
    }
    if (Ge > mJ) {
      Pe(), i?.(Ae, !1);
      return;
    }
    var W;
    const ue = Math.min((W = ne.current.getBoundingClientRect().height) != null ? W : 0, window.innerHeight);
    var we;
    const Le = Math.min((we = ne.current.getBoundingClientRect().width) != null ? we : 0, window.innerWidth), Pt = E === "left" || E === "right";
    if (Math.abs(De) >= (Pt ? Le : ue) * l) {
      Pe(), i?.(Ae, !1);
      return;
    }
    i?.(Ae, !0), yt();
  }
  p.useEffect(() => (D && (vr(document.documentElement, {
    scrollBehavior: "auto"
  }), X.current = /* @__PURE__ */ new Date()), () => {
    CVe(document.documentElement, "scrollBehavior");
  }), [
    D
  ]);
  function vn(Ae) {
    const De = Ae ? (window.innerWidth - Vc) / window.innerWidth : 1, et = Ae ? -Vc : 0;
    te.current && window.clearTimeout(te.current), vr(ne.current, {
      transition: `transform ${Hn.DURATION}s cubic-bezier(${Hn.EASE.join(",")})`,
      transform: ir(E) ? `scale(${De}) translate3d(0, ${et}px, 0)` : `scale(${De}) translate3d(${et}px, 0, 0)`
    }), !Ae && ne.current && (te.current = setTimeout(() => {
      const it = Og(ne.current, E);
      vr(ne.current, {
        transition: "none",
        transform: ir(E) ? `translate3d(0, ${it}px, 0)` : `translate3d(${it}px, 0, 0)`
      });
    }, 500));
  }
  function Xi(Ae, De) {
    if (De < 0) return;
    const et = (window.innerWidth - Vc) / window.innerWidth, it = et + De * (1 - et), Ge = -Vc + De * Vc;
    vr(ne.current, {
      transform: ir(E) ? `scale(${it}) translate3d(0, ${Ge}px, 0)` : `scale(${it}) translate3d(${Ge}px, 0, 0)`,
      transition: "none"
    });
  }
  function ot(Ae, De) {
    const et = ir(E) ? window.innerHeight : window.innerWidth, it = De ? (et - Vc) / et : 1, Ge = De ? -Vc : 0;
    De && vr(ne.current, {
      transition: `transform ${Hn.DURATION}s cubic-bezier(${Hn.EASE.join(",")})`,
      transform: ir(E) ? `scale(${it}) translate3d(0, ${Ge}px, 0)` : `scale(${it}) translate3d(${Ge}px, 0, 0)`
    });
  }
  return p.useEffect(() => {
    v || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [
    v
  ]), /* @__PURE__ */ p.createElement(l3, {
    defaultOpen: w,
    onOpenChange: (Ae) => {
      !u && !Ae || (Ae ? $(!0) : Pe(!0), L(Ae));
    },
    open: D
  }, /* @__PURE__ */ p.createElement(uJ.Provider, {
    value: {
      activeSnapPoint: xt,
      snapPoints: s,
      setActiveSnapPoint: re,
      drawerRef: ne,
      overlayRef: V,
      onOpenChange: e,
      onPress: Yt,
      onRelease: rn,
      onDrag: me,
      dismissible: u,
      shouldAnimate: j,
      handleOnly: d,
      isOpen: D,
      isDragging: z,
      shouldFade: be,
      closeDrawer: Pe,
      onNestedDrag: Xi,
      onNestedOpenChange: vn,
      onNestedRelease: ot,
      keyboardIsOpen: de,
      modal: v,
      snapPointsOffset: Se,
      activeSnapPointIndex: G,
      direction: E,
      shouldScaleBackground: o,
      setBackgroundColorOnScale: a,
      noBodyStyles: x,
      container: O,
      autoFocus: I
    }
  }, t));
}
const bJ = /* @__PURE__ */ p.forwardRef(function({ ...n }, e) {
  const { overlayRef: t, snapPoints: r, onRelease: i, shouldFade: s, isOpen: o, modal: a, shouldAnimate: l } = M1(), c = hJ(e, t), u = r && r.length > 0;
  if (!a)
    return null;
  const d = p.useCallback((f) => i(f), [
    i
  ]);
  return /* @__PURE__ */ p.createElement(Rh, {
    onMouseUp: d,
    ref: c,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": o && u ? "true" : "false",
    "data-vaul-snap-points-overlay": o && s ? "true" : "false",
    "data-vaul-animate": l?.current ? "true" : "false",
    ...n
  });
});
bJ.displayName = "Drawer.Overlay";
const wJ = /* @__PURE__ */ p.forwardRef(function({ onPointerDownOutside: n, style: e, onOpenAutoFocus: t, ...r }, i) {
  const { drawerRef: s, onPress: o, onRelease: a, onDrag: l, keyboardIsOpen: c, snapPointsOffset: u, activeSnapPointIndex: d, modal: f, isOpen: h, direction: m, snapPoints: g, container: v, handleOnly: y, shouldAnimate: b, autoFocus: x } = M1(), [E, w] = p.useState(!1), C = hJ(i, s), S = p.useRef(null), M = p.useRef(null), k = p.useRef(!1), _ = g && g.length > 0;
  RVe();
  const O = (R, P, D = 0) => {
    if (k.current) return !0;
    const L = Math.abs(R.y), B = Math.abs(R.x), $ = B > L, z = [
      "bottom",
      "right"
    ].includes(P) ? 1 : -1;
    if (P === "left" || P === "right") {
      if (!(R.x * z < 0) && B >= 0 && B <= D)
        return $;
    } else if (!(R.y * z < 0) && L >= 0 && L <= D)
      return !$;
    return k.current = !0, !0;
  };
  p.useEffect(() => {
    _ && window.requestAnimationFrame(() => {
      w(!0);
    });
  }, []);
  function I(R) {
    S.current = null, k.current = !1, a(R);
  }
  return /* @__PURE__ */ p.createElement(ad, {
    "data-vaul-drawer-direction": m,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": E ? "true" : "false",
    "data-vaul-snap-points": h && _ ? "true" : "false",
    "data-vaul-custom-container": v ? "true" : "false",
    "data-vaul-animate": b?.current ? "true" : "false",
    ...r,
    ref: C,
    style: u && u.length > 0 ? {
      "--snap-point-height": `${u[d ?? 0]}px`,
      ...e
    } : e,
    onPointerDown: (R) => {
      y || (r.onPointerDown == null || r.onPointerDown.call(r, R), S.current = {
        x: R.pageX,
        y: R.pageY
      }, o(R));
    },
    onOpenAutoFocus: (R) => {
      t?.(R), x || R.preventDefault();
    },
    onPointerDownOutside: (R) => {
      if (n?.(R), !f || R.defaultPrevented) {
        R.preventDefault();
        return;
      }
      c.current && (c.current = !1);
    },
    onFocusOutside: (R) => {
      if (!f) {
        R.preventDefault();
        return;
      }
    },
    onPointerMove: (R) => {
      if (M.current = R, y || (r.onPointerMove == null || r.onPointerMove.call(r, R), !S.current)) return;
      const P = R.pageY - S.current.y, D = R.pageX - S.current.x, L = R.pointerType === "touch" ? 10 : 2;
      O({
        x: D,
        y: P
      }, m, L) ? l(R) : (Math.abs(D) > L || Math.abs(P) > L) && (S.current = null);
    },
    onPointerUp: (R) => {
      r.onPointerUp == null || r.onPointerUp.call(r, R), S.current = null, k.current = !1, a(R);
    },
    onPointerOut: (R) => {
      r.onPointerOut == null || r.onPointerOut.call(r, R), I(M.current);
    },
    onContextMenu: (R) => {
      r.onContextMenu == null || r.onContextMenu.call(r, R), M.current && I(M.current);
    }
  });
});
wJ.displayName = "Drawer.Content";
const NVe = 250, LVe = 120, $Ve = /* @__PURE__ */ p.forwardRef(function({ preventCycle: n = !1, children: e, ...t }, r) {
  const { closeDrawer: i, isDragging: s, snapPoints: o, activeSnapPoint: a, setActiveSnapPoint: l, dismissible: c, handleOnly: u, isOpen: d, onPress: f, onDrag: h } = M1(), m = p.useRef(null), g = p.useRef(!1);
  function v() {
    if (g.current) {
      x();
      return;
    }
    window.setTimeout(() => {
      y();
    }, LVe);
  }
  function y() {
    if (s || n || g.current) {
      x();
      return;
    }
    if (x(), !o || o.length === 0) {
      c || i();
      return;
    }
    if (a === o[o.length - 1] && c) {
      i();
      return;
    }
    const w = o.findIndex((S) => S === a);
    if (w === -1) return;
    const C = o[w + 1];
    l(C);
  }
  function b() {
    m.current = window.setTimeout(() => {
      g.current = !0;
    }, NVe);
  }
  function x() {
    m.current && window.clearTimeout(m.current), g.current = !1;
  }
  return /* @__PURE__ */ p.createElement("div", {
    onClick: v,
    onPointerCancel: x,
    onPointerDown: (E) => {
      u && f(E), b();
    },
    onPointerMove: (E) => {
      u && h(E);
    },
    // onPointerUp is already handled by the content component
    ref: r,
    "data-vaul-drawer-visible": d ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...t
  }, /* @__PURE__ */ p.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, e));
});
$Ve.displayName = "Drawer.Handle";
function FVe(n) {
  const e = M1(), { container: t = e.container, ...r } = n;
  return /* @__PURE__ */ p.createElement(c3, {
    container: t,
    ...r
  });
}
const mi = {
  Root: DVe,
  Content: wJ,
  Overlay: bJ,
  Trigger: ok,
  Portal: FVe,
  Close: u3,
  Title: w1,
  Description: x1
}, Wk = ({
  shouldScaleBackground: n = !0,
  ...e
}) => /* @__PURE__ */ T(
  mi.Root,
  {
    shouldScaleBackground: n,
    ...e
  }
);
Wk.displayName = "Drawer";
const BVe = mi.Trigger, zVe = mi.Portal, $wt = mi.Close, xJ = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  mi.Overlay,
  {
    ref: t,
    className: Q("tw:fixed tw:inset-0 tw:z-50 tw:bg-black/30", n),
    ...e
  }
));
xJ.displayName = mi.Overlay.displayName;
const Gk = A.forwardRef(({ className: n, children: e, ...t }, r) => /* @__PURE__ */ ee(zVe, { children: [
  /* @__PURE__ */ T(xJ, {}),
  /* @__PURE__ */ ee(
    mi.Content,
    {
      ref: r,
      className: Q(
        // TM - Added tw:border-border, so the border is coloured.
        "tw:fixed tw:inset-x-0 tw:bottom-0 tw:z-50 tw:mt-24 tw:flex tw:h-auto tw:flex-col tw:rounded-t-[10px] tw:border tw:border-border tw:bg-background tw:sc-opaque",
        n
      ),
      ...t,
      children: [
        /* @__PURE__ */ T("div", { className: "tw:mx-auto tw:mt-4 tw:h-2 tw:w-[100px] tw:rounded-full tw:bg-muted" }),
        e
      ]
    }
  )
] }));
Gk.displayName = "DrawerContent";
const Kk = ({
  className: n,
  ...e
}) => /* @__PURE__ */ T(
  "div",
  {
    className: Q(
      "tw:grid tw:gap-1.5 tw:p-4 tw:text-center tw:sm:text-left",
      n
    ),
    ...e
  }
);
Kk.displayName = "DrawerHeader";
const EJ = ({
  className: n,
  ...e
}) => /* @__PURE__ */ T(
  "div",
  {
    className: Q(
      "tw:mt-auto tw:flex tw:flex-col tw:gap-2 tw:p-4",
      n
    ),
    ...e
  }
);
EJ.displayName = "DrawerFooter";
const qk = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  mi.Title,
  {
    ref: t,
    className: Q(
      "tw:text-lg tw:font-semibold tw:leading-none tw:tracking-tight",
      n
    ),
    ...e
  }
));
qk.displayName = mi.Title.displayName;
const Yk = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  mi.Description,
  {
    ref: t,
    className: Q("tw:text-sm tw:text-muted-foreground", n),
    ...e
  }
));
Yk.displayName = mi.Description.displayName;
var y6 = "rovingFocusGroup.onEntryFocus", HVe = { bubbles: !1, cancelable: !0 }, k1 = "RovingFocusGroup", [l7, SJ, UVe] = Lh(k1), [VVe, $h] = qr(
  k1,
  [UVe]
), [jVe, WVe] = VVe(k1), CJ = A.forwardRef(
  (n, e) => /* @__PURE__ */ T(l7.Provider, { scope: n.__scopeRovingFocusGroup, children: /* @__PURE__ */ T(l7.Slot, { scope: n.__scopeRovingFocusGroup, children: /* @__PURE__ */ T(GVe, { ...n, ref: e }) }) })
);
CJ.displayName = k1;
var GVe = A.forwardRef((n, e) => {
  const {
    __scopeRovingFocusGroup: t,
    orientation: r,
    loop: i = !1,
    dir: s,
    currentTabStopId: o,
    defaultCurrentTabStopId: a,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = n, f = A.useRef(null), h = ht(e, f), m = Rc(s), [g, v] = Kr({
    prop: o,
    defaultProp: a ?? null,
    onChange: l,
    caller: k1
  }), [y, b] = A.useState(!1), x = Vr(c), E = SJ(t), w = A.useRef(!1), [C, S] = A.useState(0);
  return A.useEffect(() => {
    const M = f.current;
    if (M)
      return M.addEventListener(y6, x), () => M.removeEventListener(y6, x);
  }, [x]), /* @__PURE__ */ T(
    jVe,
    {
      scope: t,
      orientation: r,
      dir: m,
      loop: i,
      currentTabStopId: g,
      onItemFocus: A.useCallback(
        (M) => v(M),
        [v]
      ),
      onItemShiftTab: A.useCallback(() => b(!0), []),
      onFocusableItemAdd: A.useCallback(
        () => S((M) => M + 1),
        []
      ),
      onFocusableItemRemove: A.useCallback(
        () => S((M) => M - 1),
        []
      ),
      children: /* @__PURE__ */ T(
        Ve.div,
        {
          tabIndex: y || C === 0 ? -1 : 0,
          "data-orientation": r,
          ...d,
          ref: h,
          style: { outline: "none", ...n.style },
          onMouseDown: Ce(n.onMouseDown, () => {
            w.current = !0;
          }),
          onFocus: Ce(n.onFocus, (M) => {
            const k = !w.current;
            if (M.target === M.currentTarget && k && !y) {
              const _ = new CustomEvent(y6, HVe);
              if (M.currentTarget.dispatchEvent(_), !_.defaultPrevented) {
                const O = E().filter((L) => L.focusable), I = O.find((L) => L.active), R = O.find((L) => L.id === g), D = [I, R, ...O].filter(
                  Boolean
                ).map((L) => L.ref.current);
                MJ(D, u);
              }
            }
            w.current = !1;
          }),
          onBlur: Ce(n.onBlur, () => b(!1))
        }
      )
    }
  );
}), TJ = "RovingFocusGroupItem", AJ = A.forwardRef(
  (n, e) => {
    const {
      __scopeRovingFocusGroup: t,
      focusable: r = !0,
      active: i = !1,
      tabStopId: s,
      children: o,
      ...a
    } = n, l = Xn(), c = s || l, u = WVe(TJ, t), d = u.currentTabStopId === c, f = SJ(t), { onFocusableItemAdd: h, onFocusableItemRemove: m, currentTabStopId: g } = u;
    return A.useEffect(() => {
      if (r)
        return h(), () => m();
    }, [r, h, m]), /* @__PURE__ */ T(
      l7.ItemSlot,
      {
        scope: t,
        id: c,
        focusable: r,
        active: i,
        children: /* @__PURE__ */ T(
          Ve.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": u.orientation,
            ...a,
            ref: e,
            onMouseDown: Ce(n.onMouseDown, (v) => {
              r ? u.onItemFocus(c) : v.preventDefault();
            }),
            onFocus: Ce(n.onFocus, () => u.onItemFocus(c)),
            onKeyDown: Ce(n.onKeyDown, (v) => {
              if (v.key === "Tab" && v.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (v.target !== v.currentTarget) return;
              const y = YVe(v, u.orientation, u.dir);
              if (y !== void 0) {
                if (v.metaKey || v.ctrlKey || v.altKey || v.shiftKey) return;
                v.preventDefault();
                let x = f().filter((E) => E.focusable).map((E) => E.ref.current);
                if (y === "last") x.reverse();
                else if (y === "prev" || y === "next") {
                  y === "prev" && x.reverse();
                  const E = x.indexOf(v.currentTarget);
                  x = u.loop ? XVe(x, E + 1) : x.slice(E + 1);
                }
                setTimeout(() => MJ(x));
              }
            }),
            children: typeof o == "function" ? o({ isCurrentTabStop: d, hasTabStop: g != null }) : o
          }
        )
      }
    );
  }
);
AJ.displayName = TJ;
var KVe = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function qVe(n, e) {
  return e !== "rtl" ? n : n === "ArrowLeft" ? "ArrowRight" : n === "ArrowRight" ? "ArrowLeft" : n;
}
function YVe(n, e, t) {
  const r = qVe(n.key, t);
  if (!(e === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(e === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return KVe[r];
}
function MJ(n, e = !1) {
  const t = document.activeElement;
  for (const r of n)
    if (r === t || (r.focus({ preventScroll: e }), document.activeElement !== t)) return;
}
function XVe(n, e) {
  return n.map((t, r) => n[(e + r) % n.length]);
}
var Xk = CJ, Zk = AJ;
// @__NO_SIDE_EFFECTS__
function ZVe(n) {
  const e = /* @__PURE__ */ QVe(n), t = A.forwardRef((r, i) => {
    const { children: s, ...o } = r, a = A.Children.toArray(s), l = a.find(eje);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? A.Children.count(c) > 1 ? A.Children.only(null) : A.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ T(e, { ...o, ref: i, children: A.isValidElement(c) ? A.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ T(e, { ...o, ref: i, children: s });
  });
  return t.displayName = `${n}.Slot`, t;
}
// @__NO_SIDE_EFFECTS__
function QVe(n) {
  const e = A.forwardRef((t, r) => {
    const { children: i, ...s } = t;
    if (A.isValidElement(i)) {
      const o = nje(i), a = tje(s, i.props);
      return i.type !== A.Fragment && (a.ref = r ? bi(r, o) : o), A.cloneElement(i, a);
    }
    return A.Children.count(i) > 1 ? A.Children.only(null) : null;
  });
  return e.displayName = `${n}.SlotClone`, e;
}
var JVe = Symbol("radix.slottable");
function eje(n) {
  return A.isValidElement(n) && typeof n.type == "function" && "__radixId" in n.type && n.type.__radixId === JVe;
}
function tje(n, e) {
  const t = { ...e };
  for (const r in e) {
    const i = n[r], s = e[r];
    /^on[A-Z]/.test(r) ? i && s ? t[r] = (...a) => {
      const l = s(...a);
      return i(...a), l;
    } : i && (t[r] = i) : r === "style" ? t[r] = { ...i, ...s } : r === "className" && (t[r] = [i, s].filter(Boolean).join(" "));
  }
  return { ...n, ...t };
}
function nje(n) {
  let e = Object.getOwnPropertyDescriptor(n.props, "ref")?.get, t = e && "isReactWarning" in e && e.isReactWarning;
  return t ? n.ref : (e = Object.getOwnPropertyDescriptor(n, "ref")?.get, t = e && "isReactWarning" in e && e.isReactWarning, t ? n.props.ref : n.props.ref || n.ref);
}
var c7 = ["Enter", " "], rje = ["ArrowDown", "PageUp", "Home"], kJ = ["ArrowUp", "PageDown", "End"], ije = [...rje, ...kJ], sje = {
  ltr: [...c7, "ArrowRight"],
  rtl: [...c7, "ArrowLeft"]
}, oje = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, _1 = "Menu", [v0, aje, lje] = Lh(_1), [cd, Qk] = qr(_1, [
  lje,
  Oc,
  $h
]), L3 = Oc(), _J = $h(), [cje, ud] = cd(_1), [uje, O1] = cd(_1), OJ = (n) => {
  const { __scopeMenu: e, open: t = !1, children: r, dir: i, onOpenChange: s, modal: o = !0 } = n, a = L3(e), [l, c] = A.useState(null), u = A.useRef(!1), d = Vr(s), f = Rc(i);
  return A.useEffect(() => {
    const h = () => {
      u.current = !0, document.addEventListener("pointerdown", m, { capture: !0, once: !0 }), document.addEventListener("pointermove", m, { capture: !0, once: !0 });
    }, m = () => u.current = !1;
    return document.addEventListener("keydown", h, { capture: !0 }), () => {
      document.removeEventListener("keydown", h, { capture: !0 }), document.removeEventListener("pointerdown", m, { capture: !0 }), document.removeEventListener("pointermove", m, { capture: !0 });
    };
  }, []), /* @__PURE__ */ T(C3, { ...a, children: /* @__PURE__ */ T(
    cje,
    {
      scope: e,
      open: t,
      onOpenChange: d,
      content: l,
      onContentChange: c,
      children: /* @__PURE__ */ T(
        uje,
        {
          scope: e,
          onClose: A.useCallback(() => d(!1), [d]),
          isUsingKeyboardRef: u,
          dir: f,
          modal: o,
          children: r
        }
      )
    }
  ) });
};
OJ.displayName = _1;
var dje = "MenuAnchor", Jk = A.forwardRef(
  (n, e) => {
    const { __scopeMenu: t, ...r } = n, i = L3(t);
    return /* @__PURE__ */ T(C1, { ...i, ...r, ref: e });
  }
);
Jk.displayName = dje;
var e_ = "MenuPortal", [fje, IJ] = cd(e_, {
  forceMount: void 0
}), RJ = (n) => {
  const { __scopeMenu: e, forceMount: t, children: r, container: i } = n, s = ud(e_, e);
  return /* @__PURE__ */ T(fje, { scope: e, forceMount: t, children: /* @__PURE__ */ T(Yr, { present: t || s.open, children: /* @__PURE__ */ T(y1, { asChild: !0, container: i, children: r }) }) });
};
RJ.displayName = e_;
var $s = "MenuContent", [hje, t_] = cd($s), PJ = A.forwardRef(
  (n, e) => {
    const t = IJ($s, n.__scopeMenu), { forceMount: r = t.forceMount, ...i } = n, s = ud($s, n.__scopeMenu), o = O1($s, n.__scopeMenu);
    return /* @__PURE__ */ T(v0.Provider, { scope: n.__scopeMenu, children: /* @__PURE__ */ T(Yr, { present: r || s.open, children: /* @__PURE__ */ T(v0.Slot, { scope: n.__scopeMenu, children: o.modal ? /* @__PURE__ */ T(pje, { ...i, ref: e }) : /* @__PURE__ */ T(mje, { ...i, ref: e }) }) }) });
  }
), pje = A.forwardRef(
  (n, e) => {
    const t = ud($s, n.__scopeMenu), r = A.useRef(null), i = ht(e, r);
    return A.useEffect(() => {
      const s = r.current;
      if (s) return o3(s);
    }, []), /* @__PURE__ */ T(
      n_,
      {
        ...n,
        ref: i,
        trapFocus: t.open,
        disableOutsidePointerEvents: t.open,
        disableOutsideScroll: !0,
        onFocusOutside: Ce(
          n.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => t.onOpenChange(!1)
      }
    );
  }
), mje = A.forwardRef((n, e) => {
  const t = ud($s, n.__scopeMenu);
  return /* @__PURE__ */ T(
    n_,
    {
      ...n,
      ref: e,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => t.onOpenChange(!1)
    }
  );
}), gje = /* @__PURE__ */ ZVe("MenuContent.ScrollLock"), n_ = A.forwardRef(
  (n, e) => {
    const {
      __scopeMenu: t,
      loop: r = !1,
      trapFocus: i,
      onOpenAutoFocus: s,
      onCloseAutoFocus: o,
      disableOutsidePointerEvents: a,
      onEntryFocus: l,
      onEscapeKeyDown: c,
      onPointerDownOutside: u,
      onFocusOutside: d,
      onInteractOutside: f,
      onDismiss: h,
      disableOutsideScroll: m,
      ...g
    } = n, v = ud($s, t), y = O1($s, t), b = L3(t), x = _J(t), E = aje(t), [w, C] = A.useState(null), S = A.useRef(null), M = ht(e, S, v.onContentChange), k = A.useRef(0), _ = A.useRef(""), O = A.useRef(0), I = A.useRef(null), R = A.useRef("right"), P = A.useRef(0), D = m ? b1 : A.Fragment, L = m ? { as: gje, allowPinchZoom: !0 } : void 0, B = (z) => {
      const H = _.current + z, U = E().filter((J) => !J.disabled), F = document.activeElement, V = U.find((J) => J.ref.current === F)?.textValue, X = U.map((J) => J.textValue), Z = kje(X, H, V), ie = U.find((J) => J.textValue === Z)?.ref.current;
      (function J(se) {
        _.current = se, window.clearTimeout(k.current), se !== "" && (k.current = window.setTimeout(() => J(""), 1e3));
      })(H), ie && setTimeout(() => ie.focus());
    };
    A.useEffect(() => () => window.clearTimeout(k.current), []), i3();
    const $ = A.useCallback((z) => R.current === I.current?.side && Oje(z, I.current?.area), []);
    return /* @__PURE__ */ T(
      hje,
      {
        scope: t,
        searchRef: _,
        onItemEnter: A.useCallback(
          (z) => {
            $(z) && z.preventDefault();
          },
          [$]
        ),
        onItemLeave: A.useCallback(
          (z) => {
            $(z) || (S.current?.focus(), C(null));
          },
          [$]
        ),
        onTriggerLeave: A.useCallback(
          (z) => {
            $(z) && z.preventDefault();
          },
          [$]
        ),
        pointerGraceTimerRef: O,
        onPointerGraceIntentChange: A.useCallback((z) => {
          I.current = z;
        }, []),
        children: /* @__PURE__ */ T(D, { ...L, children: /* @__PURE__ */ T(
          v1,
          {
            asChild: !0,
            trapped: i,
            onMountAutoFocus: Ce(s, (z) => {
              z.preventDefault(), S.current?.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: o,
            children: /* @__PURE__ */ T(
              Ih,
              {
                asChild: !0,
                disableOutsidePointerEvents: a,
                onEscapeKeyDown: c,
                onPointerDownOutside: u,
                onFocusOutside: d,
                onInteractOutside: f,
                onDismiss: h,
                children: /* @__PURE__ */ T(
                  Xk,
                  {
                    asChild: !0,
                    ...x,
                    dir: y.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: w,
                    onCurrentTabStopIdChange: C,
                    onEntryFocus: Ce(l, (z) => {
                      y.isUsingKeyboardRef.current || z.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ T(
                      T3,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": YJ(v.open),
                        "data-radix-menu-content": "",
                        dir: y.dir,
                        ...b,
                        ...g,
                        ref: M,
                        style: { outline: "none", ...g.style },
                        onKeyDown: Ce(g.onKeyDown, (z) => {
                          const U = z.target.closest("[data-radix-menu-content]") === z.currentTarget, F = z.ctrlKey || z.altKey || z.metaKey, V = z.key.length === 1;
                          U && (z.key === "Tab" && z.preventDefault(), !F && V && B(z.key));
                          const X = S.current;
                          if (z.target !== X || !ije.includes(z.key)) return;
                          z.preventDefault();
                          const ie = E().filter((J) => !J.disabled).map((J) => J.ref.current);
                          kJ.includes(z.key) && ie.reverse(), Aje(ie);
                        }),
                        onBlur: Ce(n.onBlur, (z) => {
                          z.currentTarget.contains(z.target) || (window.clearTimeout(k.current), _.current = "");
                        }),
                        onPointerMove: Ce(
                          n.onPointerMove,
                          y0((z) => {
                            const H = z.target, U = P.current !== z.clientX;
                            if (z.currentTarget.contains(H) && U) {
                              const F = z.clientX > P.current ? "right" : "left";
                              R.current = F, P.current = z.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
PJ.displayName = $s;
var vje = "MenuGroup", r_ = A.forwardRef(
  (n, e) => {
    const { __scopeMenu: t, ...r } = n;
    return /* @__PURE__ */ T(Ve.div, { role: "group", ...r, ref: e });
  }
);
r_.displayName = vje;
var yje = "MenuLabel", DJ = A.forwardRef(
  (n, e) => {
    const { __scopeMenu: t, ...r } = n;
    return /* @__PURE__ */ T(Ve.div, { ...r, ref: e });
  }
);
DJ.displayName = yje;
var Ny = "MenuItem", Ez = "menu.itemSelect", $3 = A.forwardRef(
  (n, e) => {
    const { disabled: t = !1, onSelect: r, ...i } = n, s = A.useRef(null), o = O1(Ny, n.__scopeMenu), a = t_(Ny, n.__scopeMenu), l = ht(e, s), c = A.useRef(!1), u = () => {
      const d = s.current;
      if (!t && d) {
        const f = new CustomEvent(Ez, { bubbles: !0, cancelable: !0 });
        d.addEventListener(Ez, (h) => r?.(h), { once: !0 }), eZ(d, f), f.defaultPrevented ? c.current = !1 : o.onClose();
      }
    };
    return /* @__PURE__ */ T(
      NJ,
      {
        ...i,
        ref: l,
        disabled: t,
        onClick: Ce(n.onClick, u),
        onPointerDown: (d) => {
          n.onPointerDown?.(d), c.current = !0;
        },
        onPointerUp: Ce(n.onPointerUp, (d) => {
          c.current || d.currentTarget?.click();
        }),
        onKeyDown: Ce(n.onKeyDown, (d) => {
          const f = a.searchRef.current !== "";
          t || f && d.key === " " || c7.includes(d.key) && (d.currentTarget.click(), d.preventDefault());
        })
      }
    );
  }
);
$3.displayName = Ny;
var NJ = A.forwardRef(
  (n, e) => {
    const { __scopeMenu: t, disabled: r = !1, textValue: i, ...s } = n, o = t_(Ny, t), a = _J(t), l = A.useRef(null), c = ht(e, l), [u, d] = A.useState(!1), [f, h] = A.useState("");
    return A.useEffect(() => {
      const m = l.current;
      m && h((m.textContent ?? "").trim());
    }, [s.children]), /* @__PURE__ */ T(
      v0.ItemSlot,
      {
        scope: t,
        disabled: r,
        textValue: i ?? f,
        children: /* @__PURE__ */ T(Zk, { asChild: !0, ...a, focusable: !r, children: /* @__PURE__ */ T(
          Ve.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...s,
            ref: c,
            onPointerMove: Ce(
              n.onPointerMove,
              y0((m) => {
                r ? o.onItemLeave(m) : (o.onItemEnter(m), m.defaultPrevented || m.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: Ce(
              n.onPointerLeave,
              y0((m) => o.onItemLeave(m))
            ),
            onFocus: Ce(n.onFocus, () => d(!0)),
            onBlur: Ce(n.onBlur, () => d(!1))
          }
        ) })
      }
    );
  }
), bje = "MenuCheckboxItem", LJ = A.forwardRef(
  (n, e) => {
    const { checked: t = !1, onCheckedChange: r, ...i } = n;
    return /* @__PURE__ */ T(HJ, { scope: n.__scopeMenu, checked: t, children: /* @__PURE__ */ T(
      $3,
      {
        role: "menuitemcheckbox",
        "aria-checked": Ly(t) ? "mixed" : t,
        ...i,
        ref: e,
        "data-state": s_(t),
        onSelect: Ce(
          i.onSelect,
          () => r?.(Ly(t) ? !0 : !t),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
LJ.displayName = bje;
var $J = "MenuRadioGroup", [wje, xje] = cd(
  $J,
  { value: void 0, onValueChange: () => {
  } }
), FJ = A.forwardRef(
  (n, e) => {
    const { value: t, onValueChange: r, ...i } = n, s = Vr(r);
    return /* @__PURE__ */ T(wje, { scope: n.__scopeMenu, value: t, onValueChange: s, children: /* @__PURE__ */ T(r_, { ...i, ref: e }) });
  }
);
FJ.displayName = $J;
var BJ = "MenuRadioItem", zJ = A.forwardRef(
  (n, e) => {
    const { value: t, ...r } = n, i = xje(BJ, n.__scopeMenu), s = t === i.value;
    return /* @__PURE__ */ T(HJ, { scope: n.__scopeMenu, checked: s, children: /* @__PURE__ */ T(
      $3,
      {
        role: "menuitemradio",
        "aria-checked": s,
        ...r,
        ref: e,
        "data-state": s_(s),
        onSelect: Ce(
          r.onSelect,
          () => i.onValueChange?.(t),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
zJ.displayName = BJ;
var i_ = "MenuItemIndicator", [HJ, Eje] = cd(
  i_,
  { checked: !1 }
), UJ = A.forwardRef(
  (n, e) => {
    const { __scopeMenu: t, forceMount: r, ...i } = n, s = Eje(i_, t);
    return /* @__PURE__ */ T(
      Yr,
      {
        present: r || Ly(s.checked) || s.checked === !0,
        children: /* @__PURE__ */ T(
          Ve.span,
          {
            ...i,
            ref: e,
            "data-state": s_(s.checked)
          }
        )
      }
    );
  }
);
UJ.displayName = i_;
var Sje = "MenuSeparator", VJ = A.forwardRef(
  (n, e) => {
    const { __scopeMenu: t, ...r } = n;
    return /* @__PURE__ */ T(
      Ve.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: e
      }
    );
  }
);
VJ.displayName = Sje;
var Cje = "MenuArrow", jJ = A.forwardRef(
  (n, e) => {
    const { __scopeMenu: t, ...r } = n, i = L3(t);
    return /* @__PURE__ */ T(A3, { ...i, ...r, ref: e });
  }
);
jJ.displayName = Cje;
var Tje = "MenuSub", [Fwt, WJ] = cd(Tje), kp = "MenuSubTrigger", GJ = A.forwardRef(
  (n, e) => {
    const t = ud(kp, n.__scopeMenu), r = O1(kp, n.__scopeMenu), i = WJ(kp, n.__scopeMenu), s = t_(kp, n.__scopeMenu), o = A.useRef(null), { pointerGraceTimerRef: a, onPointerGraceIntentChange: l } = s, c = { __scopeMenu: n.__scopeMenu }, u = A.useCallback(() => {
      o.current && window.clearTimeout(o.current), o.current = null;
    }, []);
    return A.useEffect(() => u, [u]), A.useEffect(() => {
      const d = a.current;
      return () => {
        window.clearTimeout(d), l(null);
      };
    }, [a, l]), /* @__PURE__ */ T(Jk, { asChild: !0, ...c, children: /* @__PURE__ */ T(
      NJ,
      {
        id: i.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": t.open,
        "aria-controls": i.contentId,
        "data-state": YJ(t.open),
        ...n,
        ref: bi(e, i.onTriggerChange),
        onClick: (d) => {
          n.onClick?.(d), !(n.disabled || d.defaultPrevented) && (d.currentTarget.focus(), t.open || t.onOpenChange(!0));
        },
        onPointerMove: Ce(
          n.onPointerMove,
          y0((d) => {
            s.onItemEnter(d), !d.defaultPrevented && !n.disabled && !t.open && !o.current && (s.onPointerGraceIntentChange(null), o.current = window.setTimeout(() => {
              t.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: Ce(
          n.onPointerLeave,
          y0((d) => {
            u();
            const f = t.content?.getBoundingClientRect();
            if (f) {
              const h = t.content?.dataset.side, m = h === "right", g = m ? -5 : 5, v = f[m ? "left" : "right"], y = f[m ? "right" : "left"];
              s.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: d.clientX + g, y: d.clientY },
                  { x: v, y: f.top },
                  { x: y, y: f.top },
                  { x: y, y: f.bottom },
                  { x: v, y: f.bottom }
                ],
                side: h
              }), window.clearTimeout(a.current), a.current = window.setTimeout(
                () => s.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (s.onTriggerLeave(d), d.defaultPrevented) return;
              s.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: Ce(n.onKeyDown, (d) => {
          const f = s.searchRef.current !== "";
          n.disabled || f && d.key === " " || sje[r.dir].includes(d.key) && (t.onOpenChange(!0), t.content?.focus(), d.preventDefault());
        })
      }
    ) });
  }
);
GJ.displayName = kp;
var KJ = "MenuSubContent", qJ = A.forwardRef(
  (n, e) => {
    const t = IJ($s, n.__scopeMenu), { forceMount: r = t.forceMount, ...i } = n, s = ud($s, n.__scopeMenu), o = O1($s, n.__scopeMenu), a = WJ(KJ, n.__scopeMenu), l = A.useRef(null), c = ht(e, l);
    return /* @__PURE__ */ T(v0.Provider, { scope: n.__scopeMenu, children: /* @__PURE__ */ T(Yr, { present: r || s.open, children: /* @__PURE__ */ T(v0.Slot, { scope: n.__scopeMenu, children: /* @__PURE__ */ T(
      n_,
      {
        id: a.contentId,
        "aria-labelledby": a.triggerId,
        ...i,
        ref: c,
        align: "start",
        side: o.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (u) => {
          o.isUsingKeyboardRef.current && l.current?.focus(), u.preventDefault();
        },
        onCloseAutoFocus: (u) => u.preventDefault(),
        onFocusOutside: Ce(n.onFocusOutside, (u) => {
          u.target !== a.trigger && s.onOpenChange(!1);
        }),
        onEscapeKeyDown: Ce(n.onEscapeKeyDown, (u) => {
          o.onClose(), u.preventDefault();
        }),
        onKeyDown: Ce(n.onKeyDown, (u) => {
          const d = u.currentTarget.contains(u.target), f = oje[o.dir].includes(u.key);
          d && f && (s.onOpenChange(!1), a.trigger?.focus(), u.preventDefault());
        })
      }
    ) }) }) });
  }
);
qJ.displayName = KJ;
function YJ(n) {
  return n ? "open" : "closed";
}
function Ly(n) {
  return n === "indeterminate";
}
function s_(n) {
  return Ly(n) ? "indeterminate" : n ? "checked" : "unchecked";
}
function Aje(n) {
  const e = document.activeElement;
  for (const t of n)
    if (t === e || (t.focus(), document.activeElement !== e)) return;
}
function Mje(n, e) {
  return n.map((t, r) => n[(e + r) % n.length]);
}
function kje(n, e, t) {
  const i = e.length > 1 && Array.from(e).every((c) => c === e[0]) ? e[0] : e, s = t ? n.indexOf(t) : -1;
  let o = Mje(n, Math.max(s, 0));
  i.length === 1 && (o = o.filter((c) => c !== t));
  const l = o.find(
    (c) => c.toLowerCase().startsWith(i.toLowerCase())
  );
  return l !== t ? l : void 0;
}
function _je(n, e) {
  const { x: t, y: r } = n;
  let i = !1;
  for (let s = 0, o = e.length - 1; s < e.length; o = s++) {
    const a = e[s], l = e[o], c = a.x, u = a.y, d = l.x, f = l.y;
    u > r != f > r && t < (d - c) * (r - u) / (f - u) + c && (i = !i);
  }
  return i;
}
function Oje(n, e) {
  if (!e) return !1;
  const t = { x: n.clientX, y: n.clientY };
  return _je(t, e);
}
function y0(n) {
  return (e) => e.pointerType === "mouse" ? n(e) : void 0;
}
var XJ = OJ, ZJ = Jk, QJ = RJ, JJ = PJ, eee = r_, tee = DJ, nee = $3, ree = LJ, iee = FJ, see = zJ, oee = UJ, aee = VJ, lee = jJ, cee = GJ, uee = qJ, I1 = "Menubar", [u7, Ije, Rje] = Lh(I1), [dee] = qr(I1, [
  Rje,
  $h
]), Mi = Qk(), fee = $h(), [Pje, o_] = dee(I1), hee = A.forwardRef(
  (n, e) => {
    const {
      __scopeMenubar: t,
      value: r,
      onValueChange: i,
      defaultValue: s,
      loop: o = !0,
      dir: a,
      ...l
    } = n, c = Rc(a), u = fee(t), [d, f] = Kr({
      prop: r,
      onChange: i,
      defaultProp: s ?? "",
      caller: I1
    }), [h, m] = A.useState(null);
    return /* @__PURE__ */ T(
      Pje,
      {
        scope: t,
        value: d,
        onMenuOpen: A.useCallback(
          (g) => {
            f(g), m(g);
          },
          [f]
        ),
        onMenuClose: A.useCallback(() => f(""), [f]),
        onMenuToggle: A.useCallback(
          (g) => {
            f((v) => v ? "" : g), m(g);
          },
          [f]
        ),
        dir: c,
        loop: o,
        children: /* @__PURE__ */ T(u7.Provider, { scope: t, children: /* @__PURE__ */ T(u7.Slot, { scope: t, children: /* @__PURE__ */ T(
          Xk,
          {
            asChild: !0,
            ...u,
            orientation: "horizontal",
            loop: o,
            dir: c,
            currentTabStopId: h,
            onCurrentTabStopIdChange: m,
            children: /* @__PURE__ */ T(Ve.div, { role: "menubar", ...l, ref: e })
          }
        ) }) })
      }
    );
  }
);
hee.displayName = I1;
var a_ = "MenubarMenu", [Dje, pee] = dee(a_), mee = (n) => {
  const { __scopeMenubar: e, value: t, ...r } = n, i = Xn(), s = t || i || "LEGACY_REACT_AUTO_VALUE", o = o_(a_, e), a = Mi(e), l = A.useRef(null), c = A.useRef(!1), u = o.value === s;
  return A.useEffect(() => {
    u || (c.current = !1);
  }, [u]), /* @__PURE__ */ T(
    Dje,
    {
      scope: e,
      value: s,
      triggerId: Xn(),
      triggerRef: l,
      contentId: Xn(),
      wasKeyboardTriggerOpenRef: c,
      children: /* @__PURE__ */ T(
        XJ,
        {
          ...a,
          open: u,
          onOpenChange: (d) => {
            d || o.onMenuClose();
          },
          modal: !1,
          dir: o.dir,
          ...r
        }
      )
    }
  );
};
mee.displayName = a_;
var d7 = "MenubarTrigger", gee = A.forwardRef(
  (n, e) => {
    const { __scopeMenubar: t, disabled: r = !1, ...i } = n, s = fee(t), o = Mi(t), a = o_(d7, t), l = pee(d7, t), c = A.useRef(null), u = ht(e, c, l.triggerRef), [d, f] = A.useState(!1), h = a.value === l.value;
    return /* @__PURE__ */ T(u7.ItemSlot, { scope: t, value: l.value, disabled: r, children: /* @__PURE__ */ T(
      Zk,
      {
        asChild: !0,
        ...s,
        focusable: !r,
        tabStopId: l.value,
        children: /* @__PURE__ */ T(ZJ, { asChild: !0, ...o, children: /* @__PURE__ */ T(
          Ve.button,
          {
            type: "button",
            role: "menuitem",
            id: l.triggerId,
            "aria-haspopup": "menu",
            "aria-expanded": h,
            "aria-controls": h ? l.contentId : void 0,
            "data-highlighted": d ? "" : void 0,
            "data-state": h ? "open" : "closed",
            "data-disabled": r ? "" : void 0,
            disabled: r,
            ...i,
            ref: u,
            onPointerDown: Ce(n.onPointerDown, (m) => {
              !r && m.button === 0 && m.ctrlKey === !1 && (a.onMenuOpen(l.value), h || m.preventDefault());
            }),
            onPointerEnter: Ce(n.onPointerEnter, () => {
              !!a.value && !h && (a.onMenuOpen(l.value), c.current?.focus());
            }),
            onKeyDown: Ce(n.onKeyDown, (m) => {
              r || (["Enter", " "].includes(m.key) && a.onMenuToggle(l.value), m.key === "ArrowDown" && a.onMenuOpen(l.value), ["Enter", " ", "ArrowDown"].includes(m.key) && (l.wasKeyboardTriggerOpenRef.current = !0, m.preventDefault()));
            }),
            onFocus: Ce(n.onFocus, () => f(!0)),
            onBlur: Ce(n.onBlur, () => f(!1))
          }
        ) })
      }
    ) });
  }
);
gee.displayName = d7;
var Nje = "MenubarPortal", vee = (n) => {
  const { __scopeMenubar: e, ...t } = n, r = Mi(e);
  return /* @__PURE__ */ T(QJ, { ...r, ...t });
};
vee.displayName = Nje;
var f7 = "MenubarContent", yee = A.forwardRef(
  (n, e) => {
    const { __scopeMenubar: t, align: r = "start", ...i } = n, s = Mi(t), o = o_(f7, t), a = pee(f7, t), l = Ije(t), c = A.useRef(!1);
    return /* @__PURE__ */ T(
      JJ,
      {
        id: a.contentId,
        "aria-labelledby": a.triggerId,
        "data-radix-menubar-content": "",
        ...s,
        ...i,
        ref: e,
        align: r,
        onCloseAutoFocus: Ce(n.onCloseAutoFocus, (u) => {
          !!!o.value && !c.current && a.triggerRef.current?.focus(), c.current = !1, u.preventDefault();
        }),
        onFocusOutside: Ce(n.onFocusOutside, (u) => {
          const d = u.target;
          l().some((h) => h.ref.current?.contains(d)) && u.preventDefault();
        }),
        onInteractOutside: Ce(n.onInteractOutside, () => {
          c.current = !0;
        }),
        onEntryFocus: (u) => {
          a.wasKeyboardTriggerOpenRef.current || u.preventDefault();
        },
        onKeyDown: Ce(
          n.onKeyDown,
          (u) => {
            if (["ArrowRight", "ArrowLeft"].includes(u.key)) {
              const d = u.target, f = d.hasAttribute("data-radix-menubar-subtrigger"), h = d.closest("[data-radix-menubar-content]") !== u.currentTarget, g = (o.dir === "rtl" ? "ArrowRight" : "ArrowLeft") === u.key;
              if (!g && f || h && g) return;
              let b = l().filter((w) => !w.disabled).map((w) => w.value);
              g && b.reverse();
              const x = b.indexOf(a.value);
              b = o.loop ? Xje(b, x + 1) : b.slice(x + 1);
              const [E] = b;
              E && o.onMenuOpen(E);
            }
          },
          { checkForDefaultPrevented: !1 }
        ),
        style: {
          ...n.style,
          "--radix-menubar-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-menubar-content-available-width": "var(--radix-popper-available-width)",
          "--radix-menubar-content-available-height": "var(--radix-popper-available-height)",
          "--radix-menubar-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-menubar-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
yee.displayName = f7;
var Lje = "MenubarGroup", $je = A.forwardRef(
  (n, e) => {
    const { __scopeMenubar: t, ...r } = n, i = Mi(t);
    return /* @__PURE__ */ T(eee, { ...i, ...r, ref: e });
  }
);
$je.displayName = Lje;
var Fje = "MenubarLabel", bee = A.forwardRef(
  (n, e) => {
    const { __scopeMenubar: t, ...r } = n, i = Mi(t);
    return /* @__PURE__ */ T(tee, { ...i, ...r, ref: e });
  }
);
bee.displayName = Fje;
var Bje = "MenubarItem", wee = A.forwardRef(
  (n, e) => {
    const { __scopeMenubar: t, ...r } = n, i = Mi(t);
    return /* @__PURE__ */ T(nee, { ...i, ...r, ref: e });
  }
);
wee.displayName = Bje;
var zje = "MenubarCheckboxItem", xee = A.forwardRef(
  (n, e) => {
    const { __scopeMenubar: t, ...r } = n, i = Mi(t);
    return /* @__PURE__ */ T(ree, { ...i, ...r, ref: e });
  }
);
xee.displayName = zje;
var Hje = "MenubarRadioGroup", Uje = A.forwardRef(
  (n, e) => {
    const { __scopeMenubar: t, ...r } = n, i = Mi(t);
    return /* @__PURE__ */ T(iee, { ...i, ...r, ref: e });
  }
);
Uje.displayName = Hje;
var Vje = "MenubarRadioItem", Eee = A.forwardRef(
  (n, e) => {
    const { __scopeMenubar: t, ...r } = n, i = Mi(t);
    return /* @__PURE__ */ T(see, { ...i, ...r, ref: e });
  }
);
Eee.displayName = Vje;
var jje = "MenubarItemIndicator", See = A.forwardRef((n, e) => {
  const { __scopeMenubar: t, ...r } = n, i = Mi(t);
  return /* @__PURE__ */ T(oee, { ...i, ...r, ref: e });
});
See.displayName = jje;
var Wje = "MenubarSeparator", Cee = A.forwardRef(
  (n, e) => {
    const { __scopeMenubar: t, ...r } = n, i = Mi(t);
    return /* @__PURE__ */ T(aee, { ...i, ...r, ref: e });
  }
);
Cee.displayName = Wje;
var Gje = "MenubarArrow", Kje = A.forwardRef(
  (n, e) => {
    const { __scopeMenubar: t, ...r } = n, i = Mi(t);
    return /* @__PURE__ */ T(lee, { ...i, ...r, ref: e });
  }
);
Kje.displayName = Gje;
var qje = "MenubarSubTrigger", Tee = A.forwardRef(
  (n, e) => {
    const { __scopeMenubar: t, ...r } = n, i = Mi(t);
    return /* @__PURE__ */ T(
      cee,
      {
        "data-radix-menubar-subtrigger": "",
        ...i,
        ...r,
        ref: e
      }
    );
  }
);
Tee.displayName = qje;
var Yje = "MenubarSubContent", Aee = A.forwardRef(
  (n, e) => {
    const { __scopeMenubar: t, ...r } = n, i = Mi(t);
    return /* @__PURE__ */ T(
      uee,
      {
        ...i,
        "data-radix-menubar-content": "",
        ...r,
        ref: e,
        style: {
          ...n.style,
          "--radix-menubar-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-menubar-content-available-width": "var(--radix-popper-available-width)",
          "--radix-menubar-content-available-height": "var(--radix-popper-available-height)",
          "--radix-menubar-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-menubar-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Aee.displayName = Yje;
function Xje(n, e) {
  return n.map((t, r) => n[(e + r) % n.length]);
}
var Mee = hee, Zje = mee, kee = gee, Qje = vee, _ee = yee, Oee = bee, Iee = wee, Ree = xee, Pee = Eee, Dee = See, Nee = Cee, Lee = Tee, $ee = Aee;
function Bwt({
  ...n
}) {
  return /* @__PURE__ */ T(Zje, { ...n });
}
const Jje = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  Mee,
  {
    ref: t,
    className: Q(
      "tw:flex tw:h-10 tw:items-center tw:space-x-1 tw:rounded-md tw:p-1 tw:justify-center",
      n
    ),
    ...e
  }
));
Jje.displayName = Mee.displayName;
const eWe = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  kee,
  {
    ref: t,
    className: Q(
      "tw:flex tw:cursor-pointer tw:select-none tw:items-center tw:bg-muted tw:border tw:border-border tw:rounded-sm tw:px-3 tw:py-1.5 tw:text-foreground tw:text-sm tw:font-medium tw:outline-hidden tw:focus:bg-accent tw:focus:text-accent-foreground tw:data-[state=open]:bg-accent tw:data-[state=open]:text-accent-foreground",
      n
    ),
    ...e
  }
));
eWe.displayName = kee.displayName;
const tWe = A.forwardRef(({ className: n, inset: e, children: t, ...r }, i) => /* @__PURE__ */ ee(
  Lee,
  {
    ref: i,
    className: Q(
      "tw:flex tw:cursor-default tw:select-none tw:items-center tw:rounded-sm tw:px-2 tw:py-1.5 tw:text-sm tw:outline-hidden tw:focus:bg-accent tw:focus:text-accent-foreground tw:data-[state=open]:bg-accent tw:data-[state=open]:text-accent-foreground",
      e && "tw:pl-8",
      n
    ),
    ...r,
    children: [
      t,
      /* @__PURE__ */ T(m1, { className: "tw:ml-auto tw:h-4 tw:w-4" })
    ]
  }
));
tWe.displayName = Lee.displayName;
const nWe = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  $ee,
  {
    ref: t,
    className: Q(
      "tw:z-50 tw:min-w-32 tw:overflow-hidden tw:rounded-md tw:border tw:bg-popover tw:p-1 tw:text-popover-foreground tw:data-[state=open]:animate-in tw:data-[state=closed]:animate-out tw:data-[state=closed]:fade-out-0 tw:data-[state=open]:fade-in-0 tw:data-[state=closed]:zoom-out-95 tw:data-[state=open]:zoom-in-95 tw:data-[side=bottom]:slide-in-from-top-2 tw:data-[side=left]:slide-in-from-right-2 tw:data-[side=right]:slide-in-from-left-2 tw:data-[side=top]:slide-in-from-bottom-2",
      n
    ),
    ...e
  }
));
nWe.displayName = $ee.displayName;
const rWe = A.forwardRef(
  ({
    className: n,
    align: e = "start",
    alignOffset: t = -4,
    sideOffset: r = 8,
    ...i
  }, s) => /* @__PURE__ */ T(Qje, { children: /* @__PURE__ */ T(
    _ee,
    {
      ref: s,
      align: e,
      alignOffset: t,
      sideOffset: r,
      className: Q(
        "tw:z-50 tw:min-w-48 tw:overflow-hidden tw:rounded-md tw:border tw:bg-popover tw:p-1 tw:text-popover-foreground tw:shadow-md tw:data-[state=open]:animate-in tw:data-[state=closed]:fade-out-0 tw:data-[state=open]:fade-in-0 tw:data-[state=closed]:zoom-out-95 tw:data-[state=open]:zoom-in-95 tw:data-[side=bottom]:slide-in-from-top-2 tw:data-[side=left]:slide-in-from-right-2 tw:data-[side=right]:slide-in-from-left-2 tw:data-[side=top]:slide-in-from-bottom-2",
        n
      ),
      ...i
    }
  ) })
);
rWe.displayName = _ee.displayName;
const iWe = A.forwardRef(({ className: n, inset: e, ...t }, r) => /* @__PURE__ */ T(
  Iee,
  {
    ref: r,
    className: Q(
      "tw:relative tw:flex tw:cursor-default tw:select-none tw:items-center tw:rounded-sm tw:px-2 tw:py-1.5 tw:text-sm tw:outline-hidden tw:focus:bg-accent tw:focus:text-accent-foreground tw:data-disabled:pointer-events-none tw:data-disabled:opacity-50",
      e && "tw:pl-8",
      n
    ),
    ...t
  }
));
iWe.displayName = Iee.displayName;
const sWe = A.forwardRef(({ className: n, children: e, checked: t, ...r }, i) => /* @__PURE__ */ ee(
  Ree,
  {
    ref: i,
    className: Q(
      "tw:relative tw:flex tw:cursor-default tw:select-none tw:items-center tw:rounded-sm tw:py-1.5 tw:pl-8 tw:pr-2 tw:text-sm tw:outline-hidden tw:focus:bg-accent tw:focus:text-accent-foreground tw:data-disabled:pointer-events-none tw:data-disabled:opacity-50",
      n
    ),
    checked: t,
    ...r,
    children: [
      /* @__PURE__ */ T("span", { className: "tw:absolute tw:left-2 tw:flex tw:h-3.5 tw:w-3.5 tw:items-center tw:justify-center", children: /* @__PURE__ */ T(Dee, { children: /* @__PURE__ */ T(oc, { className: "tw:h-4 tw:w-4" }) }) }),
      e
    ]
  }
));
sWe.displayName = Ree.displayName;
const oWe = A.forwardRef(({ className: n, children: e, ...t }, r) => /* @__PURE__ */ ee(
  Pee,
  {
    ref: r,
    className: Q(
      "tw:relative tw:flex tw:cursor-default tw:select-none tw:items-center tw:rounded-sm tw:py-1.5 tw:pl-8 tw:pr-2 tw:text-sm tw:outline-hidden tw:focus:bg-accent tw:focus:text-accent-foreground tw:data-disabled:pointer-events-none tw:data-disabled:opacity-50",
      n
    ),
    ...t,
    children: [
      /* @__PURE__ */ T("span", { className: "tw:absolute tw:left-2 tw:flex tw:h-3.5 tw:w-3.5 tw:items-center tw:justify-center", children: /* @__PURE__ */ T(Dee, { children: /* @__PURE__ */ T(uX, { className: "tw:h-2 tw:w-2 tw:fill-current" }) }) }),
      e
    ]
  }
));
oWe.displayName = Pee.displayName;
const aWe = A.forwardRef(({ className: n, inset: e, ...t }, r) => /* @__PURE__ */ T(
  Oee,
  {
    ref: r,
    className: Q(
      "tw:px-2 tw:py-1.5 tw:text-sm tw:font-semibold",
      e && "tw:pl-8",
      n
    ),
    ...t
  }
));
aWe.displayName = Oee.displayName;
const lWe = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  Nee,
  {
    ref: t,
    className: Q("tw:-mx-1 tw:my-1 tw:h-px tw:bg-muted", n),
    ...e
  }
));
lWe.displayName = Nee.displayName;
const cWe = ({
  className: n,
  ...e
}) => /* @__PURE__ */ T(
  "span",
  {
    className: Q(
      "tw:ml-auto tw:text-xs tw:tracking-widest tw:text-muted-foreground",
      n
    ),
    ...e
  }
);
cWe.displayname = "MenubarShortcut";
const uWe = "Left", dWe = "Right", fWe = "Up", hWe = "Down", Xd = {
  delta: 10,
  preventScrollOnSwipe: !1,
  rotationAngle: 0,
  trackMouse: !1,
  trackTouch: !0,
  swipeDuration: 1 / 0,
  touchEventOptions: { passive: !0 }
}, h7 = {
  first: !0,
  initial: [0, 0],
  start: 0,
  swiping: !1,
  xy: [0, 0]
}, Sz = "mousemove", Cz = "mouseup", pWe = "touchend", mWe = "touchmove", gWe = "touchstart";
function vWe(n, e, t, r) {
  return n > e ? t > 0 ? dWe : uWe : r > 0 ? hWe : fWe;
}
function Tz(n, e) {
  if (e === 0)
    return n;
  const t = Math.PI / 180 * e, r = n[0] * Math.cos(t) + n[1] * Math.sin(t), i = n[1] * Math.cos(t) - n[0] * Math.sin(t);
  return [r, i];
}
function yWe(n, e) {
  const t = (u) => {
    const d = "touches" in u;
    d && u.touches.length > 1 || n((f, h) => {
      h.trackMouse && !d && (document.addEventListener(Sz, r), document.addEventListener(Cz, o));
      const { clientX: m, clientY: g } = d ? u.touches[0] : u, v = Tz([m, g], h.rotationAngle);
      return h.onTouchStartOrOnMouseDown && h.onTouchStartOrOnMouseDown({ event: u }), Object.assign(Object.assign(Object.assign({}, f), h7), { initial: v.slice(), xy: v, start: u.timeStamp || 0 });
    });
  }, r = (u) => {
    n((d, f) => {
      const h = "touches" in u;
      if (h && u.touches.length > 1)
        return d;
      if (u.timeStamp - d.start > f.swipeDuration)
        return d.swiping ? Object.assign(Object.assign({}, d), { swiping: !1 }) : d;
      const { clientX: m, clientY: g } = h ? u.touches[0] : u, [v, y] = Tz([m, g], f.rotationAngle), b = v - d.xy[0], x = y - d.xy[1], E = Math.abs(b), w = Math.abs(x), C = (u.timeStamp || 0) - d.start, S = Math.sqrt(E * E + w * w) / (C || 1), M = [b / (C || 1), x / (C || 1)], k = vWe(E, w, b, x), _ = typeof f.delta == "number" ? f.delta : f.delta[k.toLowerCase()] || Xd.delta;
      if (E < _ && w < _ && !d.swiping)
        return d;
      const O = {
        absX: E,
        absY: w,
        deltaX: b,
        deltaY: x,
        dir: k,
        event: u,
        first: d.first,
        initial: d.initial,
        velocity: S,
        vxvy: M
      };
      O.first && f.onSwipeStart && f.onSwipeStart(O), f.onSwiping && f.onSwiping(O);
      let I = !1;
      return (f.onSwiping || f.onSwiped || f[`onSwiped${k}`]) && (I = !0), I && f.preventScrollOnSwipe && f.trackTouch && u.cancelable && u.preventDefault(), Object.assign(Object.assign({}, d), {
        // first is now always false
        first: !1,
        eventData: O,
        swiping: !0
      });
    });
  }, i = (u) => {
    n((d, f) => {
      let h;
      if (d.swiping && d.eventData) {
        if (u.timeStamp - d.start < f.swipeDuration) {
          h = Object.assign(Object.assign({}, d.eventData), { event: u }), f.onSwiped && f.onSwiped(h);
          const m = f[`onSwiped${h.dir}`];
          m && m(h);
        }
      } else
        f.onTap && f.onTap({ event: u });
      return f.onTouchEndOrOnMouseUp && f.onTouchEndOrOnMouseUp({ event: u }), Object.assign(Object.assign(Object.assign({}, d), h7), { eventData: h });
    });
  }, s = () => {
    document.removeEventListener(Sz, r), document.removeEventListener(Cz, o);
  }, o = (u) => {
    s(), i(u);
  }, a = (u, d) => {
    let f = () => {
    };
    if (u && u.addEventListener) {
      const h = Object.assign(Object.assign({}, Xd.touchEventOptions), d.touchEventOptions), m = [
        [gWe, t, h],
        // preventScrollOnSwipe option supersedes touchEventOptions.passive
        [
          mWe,
          r,
          Object.assign(Object.assign({}, h), d.preventScrollOnSwipe ? { passive: !1 } : {})
        ],
        [pWe, i, h]
      ];
      m.forEach(([g, v, y]) => u.addEventListener(g, v, y)), f = () => m.forEach(([g, v]) => u.removeEventListener(g, v));
    }
    return f;
  }, c = {
    ref: (u) => {
      u !== null && n((d, f) => {
        if (d.el === u)
          return d;
        const h = {};
        return d.el && d.el !== u && d.cleanUpTouch && (d.cleanUpTouch(), h.cleanUpTouch = void 0), f.trackTouch && u && (h.cleanUpTouch = a(u, f)), Object.assign(Object.assign(Object.assign({}, d), { el: u }), h);
      });
    }
  };
  return e.trackMouse && (c.onMouseDown = t), [c, a];
}
function bWe(n, e, t, r) {
  return !e.trackTouch || !n.el ? (n.cleanUpTouch && n.cleanUpTouch(), Object.assign(Object.assign({}, n), { cleanUpTouch: void 0 })) : n.cleanUpTouch ? e.preventScrollOnSwipe !== t.preventScrollOnSwipe || e.touchEventOptions.passive !== t.touchEventOptions.passive ? (n.cleanUpTouch(), Object.assign(Object.assign({}, n), { cleanUpTouch: r(n.el, e) })) : n : Object.assign(Object.assign({}, n), { cleanUpTouch: r(n.el, e) });
}
function Fee(n) {
  const { trackMouse: e } = n, t = A.useRef(Object.assign({}, h7)), r = A.useRef(Object.assign({}, Xd)), i = A.useRef(Object.assign({}, r.current));
  i.current = Object.assign({}, r.current), r.current = Object.assign(Object.assign({}, Xd), n);
  let s;
  for (s in Xd)
    r.current[s] === void 0 && (r.current[s] = Xd[s]);
  const [o, a] = A.useMemo(() => yWe((l) => t.current = l(t.current, r.current), { trackMouse: e }), [e]);
  return t.current = bWe(t.current, r.current, i.current, a), o;
}
const zwt = l3, Hwt = ok, wWe = c3, Bee = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  Rh,
  {
    className: Q(
      // TM - Adjust tw:bg-black/30, so the content is more visible
      "tw:fixed tw:inset-0 tw:z-50 tw:bg-black/30 tw:data-[state=open]:animate-in tw:data-[state=closed]:animate-out tw:data-[state=closed]:fade-out-0 tw:data-[state=open]:fade-in-0",
      n
    ),
    ...e,
    ref: t
  }
));
Bee.displayName = Rh.displayName;
const xWe = _c(
  "tw:fixed tw:z-50 tw:gap-4 tw:bg-sidebar tw:sc-opaque tw:p-6 tw:shadow-lg tw:transition tw:ease-in-out tw:data-[state=open]:animate-in tw:data-[state=closed]:animate-out tw:data-[state=closed]:duration-300 tw:data-[state=open]:duration-500",
  {
    variants: {
      side: {
        top: "tw:inset-x-0 tw:top-0 tw:border-b tw:data-[state=closed]:slide-out-to-top tw:data-[state=open]:slide-in-from-top",
        bottom: "tw:inset-x-0 tw:bottom-0 tw:border-t tw:data-[state=closed]:slide-out-to-bottom tw:data-[state=open]:slide-in-from-bottom",
        left: "tw:inset-y-0 tw:left-0 tw:h-full tw:w-3/4 tw:border-r tw:data-[state=closed]:slide-out-to-left tw:data-[state=open]:slide-in-from-left tw:sm:max-w-sm",
        // TM - Added tw:border-border, so the border is coloured.
        right: "tw:inset-y-0 tw:right-0 tw:h-full tw:w-3/4 tw:border-l tw:border-border tw:data-[state=closed]:slide-out-to-right tw:data-[state=open]:slide-in-from-right tw:sm:max-w-sm"
      }
    },
    defaultVariants: {
      side: "right"
    }
  }
), EWe = A.forwardRef(({ side: n = "right", className: e, children: t, ...r }, i) => {
  const s = Fee({
    onSwipedRight: () => {
      n === "right" && r && r.onOpenChange?.(!1);
    },
    onSwipedLeft: () => {
      n === "left" && r && r.onOpenChange?.(!1);
    },
    // You can add more handlers for top/bottom if needed
    trackMouse: !0
    // Optional: enables mouse swipe for desktop
  });
  return /* @__PURE__ */ ee(wWe, { children: [
    /* @__PURE__ */ T(Bee, {}),
    /* @__PURE__ */ ee(
      ad,
      {
        ref: (a) => {
          typeof i == "function" && a !== null ? i(a) : i && (i.current = a), s.ref(a);
        },
        className: Q(xWe({ side: n }), e),
        ...(() => {
          const { ref: a, ...l } = s;
          return l;
        })(),
        ...r,
        children: [
          t,
          /* @__PURE__ */ ee(u3, { className: "tw:absolute tw:right-4 tw:top-4 tw:rounded-sm tw:opacity-70 tw:ring-offset-background tw:transition-opacity tw:hover:opacity-100 tw:focus:outline-hidden tw:focus:ring-2 tw:focus:ring-ring tw:focus:ring-offset-2 tw:disabled:pointer-events-none tw:data-[state=open]:bg-secondary", children: [
            /* @__PURE__ */ T(YM, { className: "tw:h-4 tw:w-4" }),
            /* @__PURE__ */ T("span", { className: "tw:sr-only", children: "Close" })
          ] })
        ]
      }
    )
  ] });
});
EWe.displayName = ad.displayName;
const SWe = ({
  className: n,
  ...e
}) => /* @__PURE__ */ T(
  "div",
  {
    className: Q(
      "tw:flex tw:flex-col tw:space-y-2 tw:text-center tw:sm:text-left",
      n
    ),
    ...e
  }
);
SWe.displayName = "SheetHeader";
const CWe = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  w1,
  {
    ref: t,
    className: Q(
      "tw:text-lg tw:font-semibold tw:text-foreground",
      n
    ),
    ...e
  }
));
CWe.displayName = w1.displayName;
const TWe = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  x1,
  {
    ref: t,
    className: Q("tw:text-sm tw:text-muted-foreground", n),
    ...e
  }
));
TWe.displayName = x1.displayName;
var AWe = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], MWe = AWe.reduce((n, e) => {
  const t = /* @__PURE__ */ aX(`Primitive.${e}`), r = A.forwardRef((i, s) => {
    const { asChild: o, ...a } = i, l = o ? t : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ T(l, { ...a, ref: s });
  });
  return r.displayName = `Primitive.${e}`, { ...n, [e]: r };
}, {}), kWe = "Separator", Az = "horizontal", _We = ["horizontal", "vertical"], zee = A.forwardRef((n, e) => {
  const { decorative: t, orientation: r = Az, ...i } = n, s = OWe(r) ? r : Az, a = t ? { role: "none" } : { "aria-orientation": s === "vertical" ? s : void 0, role: "separator" };
  return /* @__PURE__ */ T(
    MWe.div,
    {
      "data-orientation": s,
      ...a,
      ...i,
      ref: e
    }
  );
});
zee.displayName = kWe;
function OWe(n) {
  return _We.includes(n);
}
var Hee = zee;
const ra = A.forwardRef(
  ({ className: n, orientation: e = "horizontal", decorative: t = !0, ...r }, i) => /* @__PURE__ */ T(
    Hee,
    {
      ref: i,
      decorative: t,
      orientation: e,
      className: Q(
        "tw:shrink-0 tw:bg-border",
        e === "horizontal" ? "tw:h-px tw:w-full" : "tw:h-full tw:w-px",
        n
      ),
      ...r
    }
  )
);
ra.displayName = Hee.displayName;
function Mz({
  className: n,
  ...e
}) {
  return /* @__PURE__ */ T(
    "div",
    {
      className: Q("tw:animate-pulse tw:rounded-md tw:bg-muted", n),
      ...e
    }
  );
}
var IWe = Symbol("radix.slottable");
// @__NO_SIDE_EFFECTS__
function RWe(n) {
  const e = ({ children: t }) => /* @__PURE__ */ T(ft, { children: t });
  return e.displayName = `${n}.Slottable`, e.__radixId = IWe, e;
}
var Uee = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), PWe = "VisuallyHidden", Vee = A.forwardRef(
  (n, e) => /* @__PURE__ */ T(
    Ve.span,
    {
      ...n,
      ref: e,
      style: { ...Uee, ...n.style }
    }
  )
);
Vee.displayName = PWe;
var DWe = Vee, [F3] = qr("Tooltip", [
  Oc
]), B3 = Oc(), jee = "TooltipProvider", NWe = 700, p7 = "tooltip.open", [LWe, l_] = F3(jee), Wee = (n) => {
  const {
    __scopeTooltip: e,
    delayDuration: t = NWe,
    skipDelayDuration: r = 300,
    disableHoverableContent: i = !1,
    children: s
  } = n, o = A.useRef(!0), a = A.useRef(!1), l = A.useRef(0);
  return A.useEffect(() => {
    const c = l.current;
    return () => window.clearTimeout(c);
  }, []), /* @__PURE__ */ T(
    LWe,
    {
      scope: e,
      isOpenDelayedRef: o,
      delayDuration: t,
      onOpen: A.useCallback(() => {
        window.clearTimeout(l.current), o.current = !1;
      }, []),
      onClose: A.useCallback(() => {
        window.clearTimeout(l.current), l.current = window.setTimeout(
          () => o.current = !0,
          r
        );
      }, [r]),
      isPointerInTransitRef: a,
      onPointerInTransitChange: A.useCallback((c) => {
        a.current = c;
      }, []),
      disableHoverableContent: i,
      children: s
    }
  );
};
Wee.displayName = jee;
var b0 = "Tooltip", [$We, z3] = F3(b0), Gee = (n) => {
  const {
    __scopeTooltip: e,
    children: t,
    open: r,
    defaultOpen: i,
    onOpenChange: s,
    disableHoverableContent: o,
    delayDuration: a
  } = n, l = l_(b0, n.__scopeTooltip), c = B3(e), [u, d] = A.useState(null), f = Xn(), h = A.useRef(0), m = o ?? l.disableHoverableContent, g = a ?? l.delayDuration, v = A.useRef(!1), [y, b] = Kr({
    prop: r,
    defaultProp: i ?? !1,
    onChange: (S) => {
      S ? (l.onOpen(), document.dispatchEvent(new CustomEvent(p7))) : l.onClose(), s?.(S);
    },
    caller: b0
  }), x = A.useMemo(() => y ? v.current ? "delayed-open" : "instant-open" : "closed", [y]), E = A.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, v.current = !1, b(!0);
  }, [b]), w = A.useCallback(() => {
    window.clearTimeout(h.current), h.current = 0, b(!1);
  }, [b]), C = A.useCallback(() => {
    window.clearTimeout(h.current), h.current = window.setTimeout(() => {
      v.current = !0, b(!0), h.current = 0;
    }, g);
  }, [g, b]);
  return A.useEffect(() => () => {
    h.current && (window.clearTimeout(h.current), h.current = 0);
  }, []), /* @__PURE__ */ T(C3, { ...c, children: /* @__PURE__ */ T(
    $We,
    {
      scope: e,
      contentId: f,
      open: y,
      stateAttribute: x,
      trigger: u,
      onTriggerChange: d,
      onTriggerEnter: A.useCallback(() => {
        l.isOpenDelayedRef.current ? C() : E();
      }, [l.isOpenDelayedRef, C, E]),
      onTriggerLeave: A.useCallback(() => {
        m ? w() : (window.clearTimeout(h.current), h.current = 0);
      }, [w, m]),
      onOpen: E,
      onClose: w,
      disableHoverableContent: m,
      children: t
    }
  ) });
};
Gee.displayName = b0;
var m7 = "TooltipTrigger", Kee = A.forwardRef(
  (n, e) => {
    const { __scopeTooltip: t, ...r } = n, i = z3(m7, t), s = l_(m7, t), o = B3(t), a = A.useRef(null), l = ht(e, a, i.onTriggerChange), c = A.useRef(!1), u = A.useRef(!1), d = A.useCallback(() => c.current = !1, []);
    return A.useEffect(() => () => document.removeEventListener("pointerup", d), [d]), /* @__PURE__ */ T(C1, { asChild: !0, ...o, children: /* @__PURE__ */ T(
      Ve.button,
      {
        "aria-describedby": i.open ? i.contentId : void 0,
        "data-state": i.stateAttribute,
        ...r,
        ref: l,
        onPointerMove: Ce(n.onPointerMove, (f) => {
          f.pointerType !== "touch" && !u.current && !s.isPointerInTransitRef.current && (i.onTriggerEnter(), u.current = !0);
        }),
        onPointerLeave: Ce(n.onPointerLeave, () => {
          i.onTriggerLeave(), u.current = !1;
        }),
        onPointerDown: Ce(n.onPointerDown, () => {
          i.open && i.onClose(), c.current = !0, document.addEventListener("pointerup", d, { once: !0 });
        }),
        onFocus: Ce(n.onFocus, () => {
          c.current || i.onOpen();
        }),
        onBlur: Ce(n.onBlur, i.onClose),
        onClick: Ce(n.onClick, i.onClose)
      }
    ) });
  }
);
Kee.displayName = m7;
var FWe = "TooltipPortal", [Uwt, BWe] = F3(FWe, {
  forceMount: void 0
}), Jf = "TooltipContent", qee = A.forwardRef(
  (n, e) => {
    const t = BWe(Jf, n.__scopeTooltip), { forceMount: r = t.forceMount, side: i = "top", ...s } = n, o = z3(Jf, n.__scopeTooltip);
    return /* @__PURE__ */ T(Yr, { present: r || o.open, children: o.disableHoverableContent ? /* @__PURE__ */ T(Yee, { side: i, ...s, ref: e }) : /* @__PURE__ */ T(zWe, { side: i, ...s, ref: e }) });
  }
), zWe = A.forwardRef((n, e) => {
  const t = z3(Jf, n.__scopeTooltip), r = l_(Jf, n.__scopeTooltip), i = A.useRef(null), s = ht(e, i), [o, a] = A.useState(null), { trigger: l, onClose: c } = t, u = i.current, { onPointerInTransitChange: d } = r, f = A.useCallback(() => {
    a(null), d(!1);
  }, [d]), h = A.useCallback(
    (m, g) => {
      const v = m.currentTarget, y = { x: m.clientX, y: m.clientY }, b = WWe(y, v.getBoundingClientRect()), x = GWe(y, b), E = KWe(g.getBoundingClientRect()), w = YWe([...x, ...E]);
      a(w), d(!0);
    },
    [d]
  );
  return A.useEffect(() => () => f(), [f]), A.useEffect(() => {
    if (l && u) {
      const m = (v) => h(v, u), g = (v) => h(v, l);
      return l.addEventListener("pointerleave", m), u.addEventListener("pointerleave", g), () => {
        l.removeEventListener("pointerleave", m), u.removeEventListener("pointerleave", g);
      };
    }
  }, [l, u, h, f]), A.useEffect(() => {
    if (o) {
      const m = (g) => {
        const v = g.target, y = { x: g.clientX, y: g.clientY }, b = l?.contains(v) || u?.contains(v), x = !qWe(y, o);
        b ? f() : x && (f(), c());
      };
      return document.addEventListener("pointermove", m), () => document.removeEventListener("pointermove", m);
    }
  }, [l, u, o, c, f]), /* @__PURE__ */ T(Yee, { ...n, ref: s });
}), [HWe, UWe] = F3(b0, { isInside: !1 }), VWe = /* @__PURE__ */ RWe("TooltipContent"), Yee = A.forwardRef(
  (n, e) => {
    const {
      __scopeTooltip: t,
      children: r,
      "aria-label": i,
      onEscapeKeyDown: s,
      onPointerDownOutside: o,
      ...a
    } = n, l = z3(Jf, t), c = B3(t), { onClose: u } = l;
    return A.useEffect(() => (document.addEventListener(p7, u), () => document.removeEventListener(p7, u)), [u]), A.useEffect(() => {
      if (l.trigger) {
        const d = (f) => {
          f.target?.contains(l.trigger) && u();
        };
        return window.addEventListener("scroll", d, { capture: !0 }), () => window.removeEventListener("scroll", d, { capture: !0 });
      }
    }, [l.trigger, u]), /* @__PURE__ */ T(
      Ih,
      {
        asChild: !0,
        disableOutsidePointerEvents: !1,
        onEscapeKeyDown: s,
        onPointerDownOutside: o,
        onFocusOutside: (d) => d.preventDefault(),
        onDismiss: u,
        children: /* @__PURE__ */ ee(
          T3,
          {
            "data-state": l.stateAttribute,
            ...c,
            ...a,
            ref: e,
            style: {
              ...a.style,
              "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
              "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
              "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
              "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
              "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            },
            children: [
              /* @__PURE__ */ T(VWe, { children: r }),
              /* @__PURE__ */ T(HWe, { scope: t, isInside: !0, children: /* @__PURE__ */ T(DWe, { id: l.contentId, role: "tooltip", children: i || r }) })
            ]
          }
        )
      }
    );
  }
);
qee.displayName = Jf;
var Xee = "TooltipArrow", jWe = A.forwardRef(
  (n, e) => {
    const { __scopeTooltip: t, ...r } = n, i = B3(t);
    return UWe(
      Xee,
      t
    ).isInside ? null : /* @__PURE__ */ T(A3, { ...i, ...r, ref: e });
  }
);
jWe.displayName = Xee;
function WWe(n, e) {
  const t = Math.abs(e.top - n.y), r = Math.abs(e.bottom - n.y), i = Math.abs(e.right - n.x), s = Math.abs(e.left - n.x);
  switch (Math.min(t, r, i, s)) {
    case s:
      return "left";
    case i:
      return "right";
    case t:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function GWe(n, e, t = 5) {
  const r = [];
  switch (e) {
    case "top":
      r.push(
        { x: n.x - t, y: n.y + t },
        { x: n.x + t, y: n.y + t }
      );
      break;
    case "bottom":
      r.push(
        { x: n.x - t, y: n.y - t },
        { x: n.x + t, y: n.y - t }
      );
      break;
    case "left":
      r.push(
        { x: n.x + t, y: n.y - t },
        { x: n.x + t, y: n.y + t }
      );
      break;
    case "right":
      r.push(
        { x: n.x - t, y: n.y - t },
        { x: n.x - t, y: n.y + t }
      );
      break;
  }
  return r;
}
function KWe(n) {
  const { top: e, right: t, bottom: r, left: i } = n;
  return [
    { x: i, y: e },
    { x: t, y: e },
    { x: t, y: r },
    { x: i, y: r }
  ];
}
function qWe(n, e) {
  const { x: t, y: r } = n;
  let i = !1;
  for (let s = 0, o = e.length - 1; s < e.length; o = s++) {
    const a = e[s], l = e[o], c = a.x, u = a.y, d = l.x, f = l.y;
    u > r != f > r && t < (d - c) * (r - u) / (f - u) + c && (i = !i);
  }
  return i;
}
function YWe(n) {
  const e = n.slice();
  return e.sort((t, r) => t.x < r.x ? -1 : t.x > r.x ? 1 : t.y < r.y ? -1 : t.y > r.y ? 1 : 0), XWe(e);
}
function XWe(n) {
  if (n.length <= 1) return n.slice();
  const e = [];
  for (let r = 0; r < n.length; r++) {
    const i = n[r];
    for (; e.length >= 2; ) {
      const s = e[e.length - 1], o = e[e.length - 2];
      if ((s.x - o.x) * (i.y - o.y) >= (s.y - o.y) * (i.x - o.x)) e.pop();
      else break;
    }
    e.push(i);
  }
  e.pop();
  const t = [];
  for (let r = n.length - 1; r >= 0; r--) {
    const i = n[r];
    for (; t.length >= 2; ) {
      const s = t[t.length - 1], o = t[t.length - 2];
      if ((s.x - o.x) * (i.y - o.y) >= (s.y - o.y) * (i.x - o.x)) t.pop();
      else break;
    }
    t.push(i);
  }
  return t.pop(), e.length === 1 && t.length === 1 && e[0].x === t[0].x && e[0].y === t[0].y ? e : e.concat(t);
}
var ZWe = Wee, QWe = Gee, JWe = Kee, Zee = qee;
const eGe = ZWe, H3 = QWe, U3 = JWe, R1 = A.forwardRef(({ className: n, sideOffset: e = 4, ...t }, r) => /* @__PURE__ */ T(
  Zee,
  {
    ref: r,
    sideOffset: e,
    className: Q(
      "tw:z-50 tw:overflow-hidden tw:rounded-md tw:border tw:bg-popover tw:px-3 tw:py-1.5 tw:text-sm tw:text-popover-foreground tw:shadow-md tw:animate-in tw:fade-in-0 tw:zoom-in-95 tw:data-[state=closed]:animate-out tw:data-[state=closed]:fade-out-0 tw:data-[state=closed]:zoom-out-95 tw:data-[side=bottom]:slide-in-from-top-2 tw:data-[side=left]:slide-in-from-right-2 tw:data-[side=right]:slide-in-from-left-2 tw:data-[side=top]:slide-in-from-bottom-2 tw:origin-(--radix-tooltip-content-transform-origin)",
      n
    ),
    ...t
  }
));
R1.displayName = Zee.displayName;
const Qee = A.forwardRef(
  ({
    children: n,
    axis: e = "y",
    hideScrollbar: t = !1,
    className: r,
    viewportClassName: i,
    ...s
  }, o) => {
    const a = e === "x" || e === "both" ? "auto" : "hidden", l = e === "y" || e === "both" ? "auto" : "hidden";
    return /* @__PURE__ */ T(
      "div",
      {
        "data-scrollarea-root": "",
        className: Q(
          // Container holds the viewport; relative allows future adornments (e.g., shadows)
          "tw:relative tw:flex tw:min-w-0 tw:min-h-0",
          r
        ),
        ...s,
        children: /* @__PURE__ */ T(
          "div",
          {
            ref: o,
            "data-scrollarea-viewport": "",
            className: Q(
              // The actual scrolling element
              "tw:h-full tw:w-full tw:rounded-[inherit] tw:min-w-0 tw:min-h-0",
              // Control overflow per-axis
              {
                "tw:overflow-x-auto": a === "auto",
                "tw:overflow-x-hidden": a === "hidden",
                "tw:overflow-y-auto": l === "auto",
                "tw:overflow-y-hidden": l === "hidden"
              },
              // Optional scrollbar hiding while preserving scroll behaviour
              t && "tw:[scrollbar-width:none] tw:[-ms-overflow-style:none] tw:[&::-webkit-scrollbar]:hidden",
              i
            ),
            children: n
          }
        )
      }
    );
  }
);
Qee.displayName = "ScrollArea";
const tGe = "16rem", nGe = "3rem", rGe = "b", Jee = A.createContext(null);
function Fh() {
  const n = A.useContext(Jee);
  if (!n)
    throw new Error("useSidebar must be used within a SidebarProvider.");
  return n;
}
const ete = A.forwardRef(
  ({
    defaultOpen: n = !0,
    open: e,
    onOpenChange: t,
    className: r,
    style: i,
    children: s,
    ...o
  }, a) => {
    const l = yw(), [c, u] = A.useState(n), d = e !== void 0, f = d ? e : c, h = A.useCallback(
      (y) => {
        const b = typeof y == "function" ? y : () => y;
        d ? t?.(b(e)) : u(b);
      },
      [d, e, t]
    ), m = A.useCallback(() => {
      h((y) => (console.log("toggleSidebar", !y), !y));
    }, [h]);
    A.useEffect(() => {
      const y = (b) => {
        b.key === rGe && (b.metaKey || b.ctrlKey) && (b.preventDefault(), m());
      };
      return window.addEventListener("keydown", y), () => window.removeEventListener("keydown", y);
    }, [m]);
    const g = f ? "expanded" : "collapsed", v = A.useMemo(
      () => ({
        state: g,
        open: f,
        setOpen: h,
        isMobile: l,
        toggleSidebar: m
      }),
      [g, f, h, l, m]
    );
    return /* @__PURE__ */ T(Jee.Provider, { value: v, children: /* @__PURE__ */ T(eGe, { delayDuration: 0, children: /* @__PURE__ */ T(
      "div",
      {
        style: {
          "--sidebar-width": tGe,
          "--sidebar-width-icon": nGe,
          ...i
        },
        className: Q(
          "tw:flex tw:w-full tw:has-data-[variant=inset]:bg-sidebar",
          r
        ),
        ref: a,
        ...o,
        children: s
      }
    ) }) });
  }
);
ete.displayName = "SidebarProvider";
const tte = A.forwardRef(
  ({
    side: n = "left",
    variant: e = "sidebar",
    collapsible: t = "offcanvas",
    className: r,
    disableScroll: i,
    children: s,
    ...o
  }, a) => {
    const { isMobile: l, state: c, setOpen: u, open: d } = Fh();
    return t === "none" ? /* @__PURE__ */ T(
      "div",
      {
        className: Q(
          "tw:flex tw:h-full tw:w-(--sidebar-width) tw:flex-col tw:bg-sidebar tw:text-sidebar-foreground",
          r
        ),
        ref: a,
        ...o,
        children: s
      }
    ) : l ? /* @__PURE__ */ T(Wk, { open: d, onOpenChange: u, children: /* @__PURE__ */ ee(Gk, { className: "tw:flex tw:max-h-[50vh] tw:flex-col tw:sc-ml-safe tw:sc-mr-safe tw:sc-mb-safe", children: [
      /* @__PURE__ */ ee(Kk, { className: "tw:sr-only", children: [
        /* @__PURE__ */ T(qk, { children: "Sidebar" }),
        /* @__PURE__ */ T(Yk, { children: "Displays the mobile sidebar." })
      ] }),
      /* @__PURE__ */ T(
        Qee,
        {
          className: (
            // TM - Some menus need to scroll (like the top menu, whereas virtual components/virtual scrolling doesnt)
            i ? "tw:flex-1" : "tw:flex-1 tw:overflow-y-auto"
          ),
          children: /* @__PURE__ */ T("div", { className: "tw:h-full tw:flex-col tw:flex tw:wrap-break-word", children: s })
        }
      )
    ] }) }) : /* @__PURE__ */ ee(
      "div",
      {
        ref: a,
        className: "tw:group tw:peer tw:hidden tw:text-sidebar-foreground tw:md:block",
        "data-state": c,
        "data-collapsible": c === "collapsed" ? t : "",
        "data-variant": e,
        "data-side": n,
        children: [
          /* @__PURE__ */ T(
            "div",
            {
              className: Q(
                "tw:relative tw:bg-transparent tw:transition-[width] tw:duration-200 tw:ease-linear",
                // Removed - tw:w-[--sidebar-width] Adds a right bar when it's on the left?
                "tw:group-data-[collapsible=offcanvas]:w-0",
                "tw:group-data-[side=right]:rotate-180",
                e === "floating" || e === "inset" ? "tw:group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4)))]" : "tw:group-data-[collapsible=icon]:w-(--sidebar-width-icon)"
              )
            }
          ),
          /* @__PURE__ */ T(
            "div",
            {
              className: Q(
                "tw:fixed tw:inset-y-0 tw:z-10 tw:hidden tw:h-svh tw:w-(--sidebar-width) tw:transition-[left,right,width] tw:duration-200 tw:ease-linear tw:md:flex",
                n === "left" ? "tw:left-0 tw:group-data-[collapsible=offcanvas]:left-[calc(var(--sidebar-width)*-1)]" : "tw:right-0 tw:group-data-[collapsible=offcanvas]:right-[calc(var(--sidebar-width)*-1)]",
                // Adjust the padding for floating and inset variants.
                e === "floating" || e === "inset" ? "tw:p-2 tw:group-data-[collapsible=icon]:w-[calc(var(--sidebar-width-icon)+(--spacing(4))+2px)]" : "tw:group-data-[collapsible=icon]:w-(--sidebar-width-icon)",
                r
              ),
              ...o,
              children: /* @__PURE__ */ T(
                "div",
                {
                  "data-sidebar": "sidebar",
                  className: "tw:flex tw:h-full tw:w-full tw:flex-col tw:bg-sidebar tw:sc-opaque tw:group-data-[variant=floating]:rounded-lg tw:group-data-[variant=floating]:border tw:group-data-[variant=floating]:border-sidebar-border tw:group-data-[variant=floating]:shadow",
                  children: s
                }
              )
            }
          )
        ]
      }
    );
  }
);
tte.displayName = "Sidebar";
const nte = A.forwardRef(({ className: n, onClick: e, ...t }, r) => {
  const { toggleSidebar: i } = Fh();
  return /* @__PURE__ */ ee(
    Nt,
    {
      ref: r,
      "data-sidebar": "trigger",
      variant: "ghost",
      size: "icon",
      className: Q("tw:h-7 tw:w-7", n),
      onClick: (s) => {
        e?.(s), i();
      },
      ...t,
      children: [
        /* @__PURE__ */ T(jIe, {}),
        /* @__PURE__ */ T("span", { className: "tw:sr-only", children: "Toggle Sidebar" })
      ]
    }
  );
});
nte.displayName = "SidebarTrigger";
const rte = A.forwardRef(({ className: n, ...e }, t) => {
  const { toggleSidebar: r } = Fh();
  return /* @__PURE__ */ T(
    "button",
    {
      ref: t,
      "data-sidebar": "rail",
      "aria-label": "Toggle Sidebar",
      tabIndex: -1,
      onClick: r,
      title: "Toggle Sidebar",
      className: Q(
        "tw:absolute tw:inset-y-0 tw:z-20 tw:hidden tw:w-4 tw:-translate-x-1/2 tw:transition-all tw:ease-linear tw:after:absolute tw:after:inset-y-0 tw:after:left-1/2 tw:after:w-[2px] tw:hover:after:bg-sidebar-border tw:group-data-[side=left]:-right-4 tw:group-data-[side=right]:left-0 tw:sm:flex",
        "tw:in-data-[side=left]:cursor-w-resize tw:in-data-[side=right]:cursor-e-resize",
        "tw:[[data-side=left][data-state=collapsed]_&]:cursor-e-resize tw:[[data-side=right][data-state=collapsed]_&]:cursor-w-resize",
        "tw:group-data-[collapsible=offcanvas]:translate-x-0 tw:group-data-[collapsible=offcanvas]:after:left-full tw:hover:group-data-[collapsible=offcanvas]:bg-sidebar",
        "tw:[[data-side=left][data-collapsible=offcanvas]_&]:-right-2",
        "tw:[[data-side=right][data-collapsible=offcanvas]_&]:-left-2",
        n
      ),
      ...e
    }
  );
});
rte.displayName = "SidebarRail";
const iGe = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  "main",
  {
    ref: t,
    className: Q(
      "tw:relative tw:flex tw:w-full tw:flex-1 tw:flex-col tw:bg-background",
      "tw:md:peer-data-[variant=inset]:m-2 tw:md:peer-data-[state=collapsed]:peer-data-[variant=inset]:ml-2 tw:md:peer-data-[variant=inset]:ml-0 tw:md:peer-data-[variant=inset]:rounded-xl tw:md:peer-data-[variant=inset]:shadow",
      n
    ),
    ...e
  }
));
iGe.displayName = "SidebarInset";
const sGe = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  Ui,
  {
    ref: t,
    "data-sidebar": "input",
    className: Q(
      "tw:h-8 tw:w-full tw:bg-background tw:shadow-none tw:focus-visible:ring-2 tw:focus-visible:ring-sidebar-ring",
      n
    ),
    ...e
  }
));
sGe.displayName = "SidebarInput";
const ite = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  "div",
  {
    ref: t,
    "data-sidebar": "header",
    className: Q("tw:flex tw:flex-col tw:p-2", n),
    ...e
  }
));
ite.displayName = "SidebarHeader";
const oGe = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  "div",
  {
    ref: t,
    "data-sidebar": "footer",
    className: Q("tw:flex tw:flex-col tw:gap-2 tw:p-2", n),
    ...e
  }
));
oGe.displayName = "SidebarFooter";
const aGe = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  ra,
  {
    ref: t,
    "data-sidebar": "separator",
    className: Q("tw:mx-2 tw:w-auto tw:bg-sidebar-border", n),
    ...e
  }
));
aGe.displayName = "SidebarSeparator";
const ste = A.forwardRef(({ className: n, ...e }, t) => {
  const { toggleSidebar: r } = Fh(), i = Fee({
    onSwipedLeft: () => {
      r();
    }
  });
  return /* @__PURE__ */ T(
    "div",
    {
      ref: (o) => {
        typeof t == "function" ? t(o) : t && (t.current = o), i.ref(o);
      },
      "data-sidebar": "content",
      className: Q(
        "tw:flex tw:h-full tw:flex-1 tw:flex-col tw:overflow-auto tw:group-data-[collapsible=icon]:overflow-hidden tw:wrap-break-word",
        n
      ),
      ...(() => {
        const { ref: o, ...a } = i;
        return a;
      })(),
      ...e
    }
  );
});
ste.displayName = "SidebarContent";
const ote = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  "div",
  {
    ref: t,
    "data-sidebar": "group",
    className: Q(
      "tw:relative tw:flex tw:w-full tw:min-w-0 tw:flex-col tw:p-0",
      n
    ),
    ...e
  }
));
ote.displayName = "SidebarGroup";
const ate = A.forwardRef(({ className: n, asChild: e = !1, ...t }, r) => /* @__PURE__ */ T(
  e ? sd : "div",
  {
    ref: r,
    "data-sidebar": "group-label",
    className: Q(
      "tw:flex tw:h-8 tw:shrink-0 tw:items-center tw:rounded-md tw:px-2 tw:text-xs tw:font-medium tw:text-sidebar-foreground/70 tw:outline-hidden tw:ring-sidebar-ring tw:transition-[margin,opacity] tw:duration-200 tw:ease-linear tw:focus-visible:ring-2 tw:[&>svg]:size-4 tw:[&>svg]:shrink-0",
      "tw:group-data-[collapsible=icon]:-mt-8 tw:group-data-[collapsible=icon]:opacity-0",
      n
    ),
    ...t
  }
));
ate.displayName = "SidebarGroupLabel";
const lGe = A.forwardRef(({ className: n, asChild: e = !1, ...t }, r) => /* @__PURE__ */ T(
  e ? sd : "button",
  {
    ref: r,
    "data-sidebar": "group-action",
    className: Q(
      "tw:absolute tw:right-3 tw:top-3.5 tw:flex tw:aspect-square tw:w-5 tw:items-center tw:justify-center tw:rounded-md tw:p-0 tw:text-sidebar-foreground tw:outline-hidden tw:ring-sidebar-ring tw:transition-transform tw:hover:bg-sidebar-accent tw:hover:text-sidebar-accent-foreground tw:focus-visible:ring-2 tw:[&>svg]:size-4 tw:[&>svg]:shrink-0",
      // Increases the hit area of the button on mobile.
      "tw:after:absolute tw:after:-inset-2 tw:md:after:hidden",
      "tw:group-data-[collapsible=icon]:hidden",
      n
    ),
    ...t
  }
));
lGe.displayName = "SidebarGroupAction";
const lte = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  "div",
  {
    ref: t,
    "data-sidebar": "group-content",
    className: Q("tw:w-full tw:text-sm", n),
    ...e
  }
));
lte.displayName = "SidebarGroupContent";
const cte = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  "ul",
  {
    ref: t,
    "data-sidebar": "menu",
    className: Q(
      "tw:flex tw:w-full tw:min-w-0 tw:flex-col tw:gap-1",
      n
    ),
    ...e
  }
));
cte.displayName = "SidebarMenu";
const cGe = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  "li",
  {
    ref: t,
    "data-sidebar": "menu-item",
    className: Q("tw:group/menu-item tw:relative", n),
    ...e
  }
));
cGe.displayName = "SidebarMenuItem";
const uGe = _c(
  "tw:peer/menu-button tw:flex tw:w-full tw:items-center tw:gap-2 tw:overflow-hidden tw:rounded-md tw:p-2 tw:text-left tw:text-sm tw:outline-hidden tw:ring-sidebar-ring tw:transition-[width,height,padding] tw:hover:bg-sidebar-accent tw:hover:text-sidebar-accent-foreground tw:focus-visible:ring-2 tw:active:bg-sidebar-accent tw:active:text-sidebar-accent-foreground tw:disabled:pointer-events-none tw:disabled:opacity-50 tw:group-has-[[data-sidebar=menu-action]]/menu-item:pr-8 tw:aria-disabled:pointer-events-none tw:aria-disabled:opacity-50 tw:data-[active=true]:bg-sidebar-accent tw:data-[active=true]:font-medium tw:data-[active=true]:text-sidebar-accent-foreground tw:data-[state=open]:hover:bg-sidebar-accent tw:data-[state=open]:hover:text-sidebar-accent-foreground group-data-[collapsible=icon]:tw:!size-8 group-data-[collapsible=icon]:tw:!p-2 tw:[&>span:last-child]:truncate tw:[&>svg]:size-4 tw:[&>svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "tw:hover:bg-sidebar-accent tw:hover:text-sidebar-accent-foreground",
        outline: "tw:bg-background tw:shadow-[0_0_0_1px_hsl(var(--sidebar-border))] tw:hover:bg-sidebar-accent tw:hover:text-sidebar-accent-foreground tw:hover:shadow-[0_0_0_1px_hsl(var(--sidebar-accent))]"
      },
      // TM - Adjust heights, to allow longer text
      size: {
        default: "tw:min-h-8 tw:text-sm",
        sm: "tw:h-7 tw:text-xs",
        lg: "tw:h-12 tw:text-sm group-data-[collapsible=icon]:tw:!p-0"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), ute = A.forwardRef(
  ({
    asChild: n = !1,
    isActive: e = !1,
    variant: t = "default",
    size: r = "default",
    tooltip: i,
    className: s,
    ...o
  }, a) => {
    const l = n ? sd : "button", { isMobile: c, state: u, setOpen: d } = Fh(), f = /* @__PURE__ */ T(
      l,
      {
        ref: a,
        "data-sidebar": "menu-button",
        "data-size": r,
        "data-active": e,
        className: Q(
          uGe({ variant: t, size: r }),
          s
        ),
        onClick: () => {
          d(!1);
        },
        ...o
      }
    );
    return i ? (typeof i == "string" && (i = {
      children: i
    }), /* @__PURE__ */ ee(H3, { children: [
      /* @__PURE__ */ T(U3, { asChild: !0, children: f }),
      /* @__PURE__ */ T(
        R1,
        {
          side: "right",
          align: "center",
          hidden: u !== "collapsed" || c,
          ...i
        }
      )
    ] })) : f;
  }
);
ute.displayName = "SidebarMenuButton";
const dGe = A.forwardRef(({ className: n, asChild: e = !1, showOnHover: t = !1, ...r }, i) => /* @__PURE__ */ T(
  e ? sd : "button",
  {
    ref: i,
    "data-sidebar": "menu-action",
    className: Q(
      "tw:absolute tw:right-1 tw:top-1.5 tw:flex tw:aspect-square tw:w-5 tw:items-center tw:justify-center tw:rounded-md tw:p-0 tw:text-sidebar-foreground tw:outline-hidden tw:ring-sidebar-ring tw:transition-transform tw:hover:bg-sidebar-accent tw:hover:text-sidebar-accent-foreground tw:focus-visible:ring-2 tw:peer-hover/menu-button:text-sidebar-accent-foreground tw:[&>svg]:size-4 tw:[&>svg]:shrink-0",
      // Increases the hit area of the button on mobile.
      "tw:after:absolute tw:after:-inset-2 tw:md:after:hidden",
      "tw:peer-data-[size=sm]/menu-button:top-1",
      "tw:peer-data-[size=default]/menu-button:top-1.5",
      "tw:peer-data-[size=lg]/menu-button:top-2.5",
      "tw:group-data-[collapsible=icon]:hidden",
      t && "tw:group-focus-within/menu-item:opacity-100 tw:group-hover/menu-item:opacity-100 tw:data-[state=open]:opacity-100 tw:peer-data-[active=true]/menu-button:text-sidebar-accent-foreground tw:md:opacity-0",
      n
    ),
    ...r
  }
));
dGe.displayName = "SidebarMenuAction";
const fGe = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  "div",
  {
    ref: t,
    "data-sidebar": "menu-badge",
    className: Q(
      "tw:pointer-events-none tw:absolute tw:right-1 tw:flex tw:h-5 tw:min-w-5 tw:select-none tw:items-center tw:justify-center tw:rounded-md tw:px-1 tw:text-xs tw:font-medium tw:tabular-nums tw:text-sidebar-foreground",
      "tw:peer-hover/menu-button:text-sidebar-accent-foreground tw:peer-data-[active=true]/menu-button:text-sidebar-accent-foreground",
      "tw:peer-data-[size=sm]/menu-button:top-1",
      "tw:peer-data-[size=default]/menu-button:top-1.5",
      "tw:peer-data-[size=lg]/menu-button:top-2.5",
      "tw:group-data-[collapsible=icon]:hidden",
      n
    ),
    ...e
  }
));
fGe.displayName = "SidebarMenuBadge";
const hGe = A.forwardRef(({ className: n, showIcon: e = !1, ...t }, r) => {
  const i = A.useMemo(() => `${Math.floor(Math.random() * 40) + 50}%`, []);
  return /* @__PURE__ */ ee(
    "div",
    {
      ref: r,
      "data-sidebar": "menu-skeleton",
      className: Q(
        "tw:flex tw:h-8 tw:items-center tw:gap-2 tw:rounded-md tw:px-2",
        n
      ),
      ...t,
      children: [
        e && /* @__PURE__ */ T(
          Mz,
          {
            className: "tw:size-4 tw:rounded-md",
            "data-sidebar": "menu-skeleton-icon"
          }
        ),
        /* @__PURE__ */ T(
          Mz,
          {
            className: "tw:h-4 tw:max-w-(--skeleton-width) tw:flex-1",
            "data-sidebar": "menu-skeleton-text",
            style: {
              "--skeleton-width": i
            }
          }
        )
      ]
    }
  );
});
hGe.displayName = "SidebarMenuSkeleton";
const dte = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  "ul",
  {
    ref: t,
    "data-sidebar": "menu-sub",
    className: Q(
      "tw:mx-3.5 tw:flex tw:min-w-0 tw:translate-x-px tw:flex-col tw:gap-1 tw:border-l tw:border-sidebar-border tw:px-2.5 tw:py-0.5",
      "tw:group-data-[collapsible=icon]:hidden",
      n
    ),
    ...e
  }
));
dte.displayName = "SidebarMenuSub";
const fte = A.forwardRef(({ ...n }, e) => /* @__PURE__ */ T("li", { ref: e, ...n }));
fte.displayName = "SidebarMenuSubItem";
const hte = A.forwardRef(({ asChild: n = !1, size: e = "md", isActive: t, className: r, ...i }, s) => {
  const o = n ? sd : "a", { setOpen: a } = Fh(), l = i.href?.includes("http") || !1;
  return /* @__PURE__ */ T(
    o,
    {
      ref: s,
      "data-sidebar": "menu-sub-button",
      "data-size": e,
      "data-active": t,
      rel: l ? "noopener noreferrer" : void 0,
      target: l ? "_blank" : void 0,
      className: Q(
        "tw:flex tw:min-h-7 tw:min-w-0 tw:-translate-x-px tw:items-center tw:gap-2 tw:overflow-hidden tw:rounded-md tw:px-2 tw:text-sidebar-foreground tw:outline-hidden tw:ring-sidebar-ring tw:hover:bg-sidebar-accent tw:hover:text-sidebar-accent-foreground tw:focus-visible:ring-2 tw:active:bg-sidebar-accent tw:active:text-sidebar-accent-foreground tw:disabled:pointer-events-none tw:disabled:opacity-50 tw:aria-disabled:pointer-events-none tw:aria-disabled:opacity-50 tw:[&>span:last-child]:truncate tw:[&>svg]:size-4 tw:[&>svg]:shrink-0 tw:[&>svg]:text-sidebar-accent-foreground",
        "tw:data-[active=true]:bg-sidebar-accent tw:data-[active=true]:text-sidebar-accent-foreground",
        e === "sm" && "tw:text-xs",
        e === "md" && "tw:text-sm",
        "tw:group-data-[collapsible=icon]:hidden",
        r
      ),
      onClick: () => {
        a(!1);
      },
      ...i
    }
  );
});
hte.displayName = "SidebarMenuSubButton";
const pGe = {
  theme: "system",
  setTheme: () => null,
  toggle: () => null,
  isDarkMode: !1
}, pte = Ws(pGe);
function Vwt({
  children: n,
  defaultTheme: e = "system",
  storageKey: t = "ui-theme",
  ...r
}) {
  const [i, s] = wt(
    () => localStorage.getItem(t) || e
  ), o = i === "dark" || i === "system" && window.matchMedia("(prefers-color-scheme: dark)").matches, a = (c) => {
    s((u) => {
      const d = c ? "dark" : "light";
      return localStorage.setItem(t, d), d;
    });
  };
  Tt(() => {
    const c = window.document.documentElement, u = window.matchMedia(
      "(prefers-color-scheme: dark)"
    ), d = (f) => {
      if (c.classList.remove("light", "dark"), f === "system") {
        const h = u.matches ? "dark" : "light";
        c.classList.add(h);
      } else
        c.classList.add(f);
    };
    if (d(i), i === "system") {
      const f = (h) => {
        d("system");
      };
      return u.addEventListener(
        "change",
        f
      ), () => {
        u.removeEventListener(
          "change",
          f
        );
      };
    }
  }, [i]);
  const l = {
    theme: i,
    setTheme: (c) => {
      localStorage.setItem(t, c), s(c);
    },
    toggle: a,
    isDarkMode: o
  };
  return /* @__PURE__ */ T(pte.Provider, { ...r, value: l, children: n });
}
const V3 = () => {
  const n = Wi(pte);
  if (n === void 0)
    throw new Error("useTheme must be used within a ThemeProvider");
  return n;
}, jwt = ({ ...n }) => {
  const { isDarkMode: e } = V3();
  return /* @__PURE__ */ T(
    d8e,
    {
      theme: e ? "dark" : "light",
      className: "tw:toaster tw:group",
      toastOptions: {
        classNames: {
          toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground"
        }
      },
      ...n
    }
  );
};
var mte = "Toggle", c_ = A.forwardRef((n, e) => {
  const { pressed: t, defaultPressed: r, onPressedChange: i, ...s } = n, [o, a] = Kr({
    prop: t,
    onChange: i,
    defaultProp: r ?? !1,
    caller: mte
  });
  return /* @__PURE__ */ T(
    Ve.button,
    {
      type: "button",
      "aria-pressed": o,
      "data-state": o ? "on" : "off",
      "data-disabled": n.disabled ? "" : void 0,
      ...s,
      ref: e,
      onClick: Ce(n.onClick, () => {
        n.disabled || a(!o);
      })
    }
  );
});
c_.displayName = mte;
var gte = c_, Pc = "ToggleGroup", [vte] = qr(Pc, [
  $h
]), yte = $h(), u_ = p.forwardRef((n, e) => {
  const { type: t, ...r } = n;
  if (t === "single")
    return /* @__PURE__ */ T(mGe, { ...r, ref: e });
  if (t === "multiple")
    return /* @__PURE__ */ T(gGe, { ...r, ref: e });
  throw new Error(`Missing prop \`type\` expected on \`${Pc}\``);
});
u_.displayName = Pc;
var [bte, wte] = vte(Pc), mGe = p.forwardRef((n, e) => {
  const {
    value: t,
    defaultValue: r,
    onValueChange: i = () => {
    },
    ...s
  } = n, [o, a] = Kr({
    prop: t,
    defaultProp: r ?? "",
    onChange: i,
    caller: Pc
  });
  return /* @__PURE__ */ T(
    bte,
    {
      scope: n.__scopeToggleGroup,
      type: "single",
      value: p.useMemo(() => o ? [o] : [], [o]),
      onItemActivate: a,
      onItemDeactivate: p.useCallback(() => a(""), [a]),
      children: /* @__PURE__ */ T(xte, { ...s, ref: e })
    }
  );
}), gGe = p.forwardRef((n, e) => {
  const {
    value: t,
    defaultValue: r,
    onValueChange: i = () => {
    },
    ...s
  } = n, [o, a] = Kr({
    prop: t,
    defaultProp: r ?? [],
    onChange: i,
    caller: Pc
  }), l = p.useCallback(
    (u) => a((d = []) => [...d, u]),
    [a]
  ), c = p.useCallback(
    (u) => a((d = []) => d.filter((f) => f !== u)),
    [a]
  );
  return /* @__PURE__ */ T(
    bte,
    {
      scope: n.__scopeToggleGroup,
      type: "multiple",
      value: o,
      onItemActivate: l,
      onItemDeactivate: c,
      children: /* @__PURE__ */ T(xte, { ...s, ref: e })
    }
  );
});
u_.displayName = Pc;
var [vGe, yGe] = vte(Pc), xte = p.forwardRef(
  (n, e) => {
    const {
      __scopeToggleGroup: t,
      disabled: r = !1,
      rovingFocus: i = !0,
      orientation: s,
      dir: o,
      loop: a = !0,
      ...l
    } = n, c = yte(t), u = Rc(o), d = { role: "group", dir: u, ...l };
    return /* @__PURE__ */ T(vGe, { scope: t, rovingFocus: i, disabled: r, children: i ? /* @__PURE__ */ T(
      Xk,
      {
        asChild: !0,
        ...c,
        orientation: s,
        dir: u,
        loop: a,
        children: /* @__PURE__ */ T(Ve.div, { ...d, ref: e })
      }
    ) : /* @__PURE__ */ T(Ve.div, { ...d, ref: e }) });
  }
), $y = "ToggleGroupItem", Ete = p.forwardRef(
  (n, e) => {
    const t = wte($y, n.__scopeToggleGroup), r = yGe($y, n.__scopeToggleGroup), i = yte(n.__scopeToggleGroup), s = t.value.includes(n.value), o = r.disabled || n.disabled, a = { ...n, pressed: s, disabled: o }, l = p.useRef(null);
    return r.rovingFocus ? /* @__PURE__ */ T(
      Zk,
      {
        asChild: !0,
        ...i,
        focusable: !o,
        active: s,
        ref: l,
        children: /* @__PURE__ */ T(kz, { ...a, ref: e })
      }
    ) : /* @__PURE__ */ T(kz, { ...a, ref: e });
  }
);
Ete.displayName = $y;
var kz = p.forwardRef(
  (n, e) => {
    const { __scopeToggleGroup: t, value: r, ...i } = n, s = wte($y, t), o = { role: "radio", "aria-checked": n.pressed, "aria-pressed": void 0 }, a = s.type === "single" ? o : void 0;
    return /* @__PURE__ */ T(
      c_,
      {
        ...a,
        ...i,
        ref: e,
        onPressedChange: (l) => {
          l ? s.onItemActivate(r) : s.onItemDeactivate(r);
        }
      }
    );
  }
), Ste = u_, Cte = Ete;
const Tte = _c(
  "tw:inline-flex tw:items-center tw:justify-center tw:rounded-md tw:text-sm tw:font-medium tw:ring-offset-background tw:transition-colors tw:hover:bg-muted tw:hover:text-muted-foreground tw:focus-visible:outline-hidden tw:focus-visible:ring-2 tw:focus-visible:ring-ring tw:focus-visible:ring-offset-2 tw:disabled:pointer-events-none tw:disabled:opacity-50 tw:data-[state=on]:bg-accent tw:data-[state=on]:text-accent-foreground tw:[&_svg]:pointer-events-none tw:[&_svg]:size-4 tw:[&_svg]:shrink-0 tw:gap-2",
  {
    variants: {
      variant: {
        default: "tw:bg-transparent",
        outline: "tw:border tw:border-input tw:bg-transparent tw:hover:bg-accent tw:hover:text-accent-foreground"
      },
      size: {
        default: "tw:h-10 tw:px-3 tw:min-w-10",
        sm: "tw:h-9 tw:px-2.5 tw:min-w-9",
        lg: "tw:h-11 tw:px-5 tw:min-w-11"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
), Ate = A.forwardRef(({ className: n, variant: e, size: t, ...r }, i) => /* @__PURE__ */ T(
  gte,
  {
    ref: i,
    className: Q(Tte({ variant: e, size: t, className: n })),
    ...r
  }
));
Ate.displayName = gte.displayName;
const Mte = A.createContext({
  size: "default",
  variant: "default"
}), kte = A.forwardRef(({ className: n, variant: e, size: t, children: r, ...i }, s) => /* @__PURE__ */ T(
  Ste,
  {
    ref: s,
    className: Q("tw:flex tw:items-center tw:justify-center tw:gap-1", n),
    ...i,
    children: /* @__PURE__ */ T(Mte.Provider, { value: { variant: e, size: t }, children: r })
  }
));
kte.displayName = Ste.displayName;
const _te = A.forwardRef(({ className: n, children: e, variant: t, size: r, ...i }, s) => {
  const o = A.useContext(Mte);
  return /* @__PURE__ */ T(
    Cte,
    {
      ref: s,
      className: Q(
        Tte({
          variant: o.variant || t,
          size: o.size || r
        }),
        n
      ),
      ...i,
      children: e
    }
  );
});
_te.displayName = Cte.displayName;
const bGe = ({
  src: n,
  refresh: e,
  alt: t,
  className: r,
  style: i,
  ...s
}) => {
  const [o, a] = wt(
    n
  ), l = Gt(!0), c = Gt(null);
  return Tt(() => (l.current = !0, a(n), () => {
    l.current = !1, c.current !== null && window.clearInterval(c.current);
  }), [n]), Tt(() => {
    if (!e || !n) return;
    const u = n, d = (h) => {
      try {
        const m = new URL(h, window.location.href);
        return m.searchParams.set("_t", Date.now().toString()), m.toString();
      } catch {
        return h;
      }
    }, f = () => {
      const h = d(u), m = new Image();
      m.onload = () => {
        l.current && a(h);
      }, m.onerror = () => {
      }, m.src = h;
    };
    return c.current = window.setInterval(
      f,
      Math.max(1e3, e * 1e3)
    ), () => {
      c.current !== null && window.clearInterval(c.current);
    };
  }, [e, n]), /* @__PURE__ */ T(
    "img",
    {
      src: o,
      alt: t,
      className: r,
      style: i,
      ...s
    }
  );
}, He = Number.isFinite || function(n) {
  return typeof n == "number" && isFinite(n);
}, wGe = Number.isSafeInteger || function(n) {
  return typeof n == "number" && Math.abs(n) <= xGe;
}, xGe = Number.MAX_SAFE_INTEGER || 9007199254740991;
let Je = /* @__PURE__ */ (function(n) {
  return n.NETWORK_ERROR = "networkError", n.MEDIA_ERROR = "mediaError", n.KEY_SYSTEM_ERROR = "keySystemError", n.MUX_ERROR = "muxError", n.OTHER_ERROR = "otherError", n;
})({}), ce = /* @__PURE__ */ (function(n) {
  return n.KEY_SYSTEM_NO_KEYS = "keySystemNoKeys", n.KEY_SYSTEM_NO_ACCESS = "keySystemNoAccess", n.KEY_SYSTEM_NO_SESSION = "keySystemNoSession", n.KEY_SYSTEM_NO_CONFIGURED_LICENSE = "keySystemNoConfiguredLicense", n.KEY_SYSTEM_LICENSE_REQUEST_FAILED = "keySystemLicenseRequestFailed", n.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED = "keySystemServerCertificateRequestFailed", n.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED = "keySystemServerCertificateUpdateFailed", n.KEY_SYSTEM_SESSION_UPDATE_FAILED = "keySystemSessionUpdateFailed", n.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED = "keySystemStatusOutputRestricted", n.KEY_SYSTEM_STATUS_INTERNAL_ERROR = "keySystemStatusInternalError", n.KEY_SYSTEM_DESTROY_MEDIA_KEYS_ERROR = "keySystemDestroyMediaKeysError", n.KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR = "keySystemDestroyCloseSessionError", n.KEY_SYSTEM_DESTROY_REMOVE_SESSION_ERROR = "keySystemDestroyRemoveSessionError", n.MANIFEST_LOAD_ERROR = "manifestLoadError", n.MANIFEST_LOAD_TIMEOUT = "manifestLoadTimeOut", n.MANIFEST_PARSING_ERROR = "manifestParsingError", n.MANIFEST_INCOMPATIBLE_CODECS_ERROR = "manifestIncompatibleCodecsError", n.LEVEL_EMPTY_ERROR = "levelEmptyError", n.LEVEL_LOAD_ERROR = "levelLoadError", n.LEVEL_LOAD_TIMEOUT = "levelLoadTimeOut", n.LEVEL_PARSING_ERROR = "levelParsingError", n.LEVEL_SWITCH_ERROR = "levelSwitchError", n.AUDIO_TRACK_LOAD_ERROR = "audioTrackLoadError", n.AUDIO_TRACK_LOAD_TIMEOUT = "audioTrackLoadTimeOut", n.SUBTITLE_LOAD_ERROR = "subtitleTrackLoadError", n.SUBTITLE_TRACK_LOAD_TIMEOUT = "subtitleTrackLoadTimeOut", n.FRAG_LOAD_ERROR = "fragLoadError", n.FRAG_LOAD_TIMEOUT = "fragLoadTimeOut", n.FRAG_DECRYPT_ERROR = "fragDecryptError", n.FRAG_PARSING_ERROR = "fragParsingError", n.FRAG_GAP = "fragGap", n.REMUX_ALLOC_ERROR = "remuxAllocError", n.KEY_LOAD_ERROR = "keyLoadError", n.KEY_LOAD_TIMEOUT = "keyLoadTimeOut", n.BUFFER_ADD_CODEC_ERROR = "bufferAddCodecError", n.BUFFER_INCOMPATIBLE_CODECS_ERROR = "bufferIncompatibleCodecsError", n.BUFFER_APPEND_ERROR = "bufferAppendError", n.BUFFER_APPENDING_ERROR = "bufferAppendingError", n.BUFFER_STALLED_ERROR = "bufferStalledError", n.BUFFER_FULL_ERROR = "bufferFullError", n.BUFFER_SEEK_OVER_HOLE = "bufferSeekOverHole", n.BUFFER_NUDGE_ON_STALL = "bufferNudgeOnStall", n.ASSET_LIST_LOAD_ERROR = "assetListLoadError", n.ASSET_LIST_LOAD_TIMEOUT = "assetListLoadTimeout", n.ASSET_LIST_PARSING_ERROR = "assetListParsingError", n.INTERSTITIAL_ASSET_ITEM_ERROR = "interstitialAssetItemError", n.INTERNAL_EXCEPTION = "internalException", n.INTERNAL_ABORTED = "aborted", n.ATTACH_MEDIA_ERROR = "attachMediaError", n.UNKNOWN = "unknown", n;
})({}), N = /* @__PURE__ */ (function(n) {
  return n.MEDIA_ATTACHING = "hlsMediaAttaching", n.MEDIA_ATTACHED = "hlsMediaAttached", n.MEDIA_DETACHING = "hlsMediaDetaching", n.MEDIA_DETACHED = "hlsMediaDetached", n.MEDIA_ENDED = "hlsMediaEnded", n.STALL_RESOLVED = "hlsStallResolved", n.BUFFER_RESET = "hlsBufferReset", n.BUFFER_CODECS = "hlsBufferCodecs", n.BUFFER_CREATED = "hlsBufferCreated", n.BUFFER_APPENDING = "hlsBufferAppending", n.BUFFER_APPENDED = "hlsBufferAppended", n.BUFFER_EOS = "hlsBufferEos", n.BUFFERED_TO_END = "hlsBufferedToEnd", n.BUFFER_FLUSHING = "hlsBufferFlushing", n.BUFFER_FLUSHED = "hlsBufferFlushed", n.MANIFEST_LOADING = "hlsManifestLoading", n.MANIFEST_LOADED = "hlsManifestLoaded", n.MANIFEST_PARSED = "hlsManifestParsed", n.LEVEL_SWITCHING = "hlsLevelSwitching", n.LEVEL_SWITCHED = "hlsLevelSwitched", n.LEVEL_LOADING = "hlsLevelLoading", n.LEVEL_LOADED = "hlsLevelLoaded", n.LEVEL_UPDATED = "hlsLevelUpdated", n.LEVEL_PTS_UPDATED = "hlsLevelPtsUpdated", n.LEVELS_UPDATED = "hlsLevelsUpdated", n.AUDIO_TRACKS_UPDATED = "hlsAudioTracksUpdated", n.AUDIO_TRACK_SWITCHING = "hlsAudioTrackSwitching", n.AUDIO_TRACK_SWITCHED = "hlsAudioTrackSwitched", n.AUDIO_TRACK_LOADING = "hlsAudioTrackLoading", n.AUDIO_TRACK_LOADED = "hlsAudioTrackLoaded", n.AUDIO_TRACK_UPDATED = "hlsAudioTrackUpdated", n.SUBTITLE_TRACKS_UPDATED = "hlsSubtitleTracksUpdated", n.SUBTITLE_TRACKS_CLEARED = "hlsSubtitleTracksCleared", n.SUBTITLE_TRACK_SWITCH = "hlsSubtitleTrackSwitch", n.SUBTITLE_TRACK_LOADING = "hlsSubtitleTrackLoading", n.SUBTITLE_TRACK_LOADED = "hlsSubtitleTrackLoaded", n.SUBTITLE_TRACK_UPDATED = "hlsSubtitleTrackUpdated", n.SUBTITLE_FRAG_PROCESSED = "hlsSubtitleFragProcessed", n.CUES_PARSED = "hlsCuesParsed", n.NON_NATIVE_TEXT_TRACKS_FOUND = "hlsNonNativeTextTracksFound", n.INIT_PTS_FOUND = "hlsInitPtsFound", n.FRAG_LOADING = "hlsFragLoading", n.FRAG_LOAD_EMERGENCY_ABORTED = "hlsFragLoadEmergencyAborted", n.FRAG_LOADED = "hlsFragLoaded", n.FRAG_DECRYPTED = "hlsFragDecrypted", n.FRAG_PARSING_INIT_SEGMENT = "hlsFragParsingInitSegment", n.FRAG_PARSING_USERDATA = "hlsFragParsingUserdata", n.FRAG_PARSING_METADATA = "hlsFragParsingMetadata", n.FRAG_PARSED = "hlsFragParsed", n.FRAG_BUFFERED = "hlsFragBuffered", n.FRAG_CHANGED = "hlsFragChanged", n.FPS_DROP = "hlsFpsDrop", n.FPS_DROP_LEVEL_CAPPING = "hlsFpsDropLevelCapping", n.MAX_AUTO_LEVEL_UPDATED = "hlsMaxAutoLevelUpdated", n.ERROR = "hlsError", n.DESTROYING = "hlsDestroying", n.KEY_LOADING = "hlsKeyLoading", n.KEY_LOADED = "hlsKeyLoaded", n.LIVE_BACK_BUFFER_REACHED = "hlsLiveBackBufferReached", n.BACK_BUFFER_REACHED = "hlsBackBufferReached", n.STEERING_MANIFEST_LOADED = "hlsSteeringManifestLoaded", n.ASSET_LIST_LOADING = "hlsAssetListLoading", n.ASSET_LIST_LOADED = "hlsAssetListLoaded", n.INTERSTITIALS_UPDATED = "hlsInterstitialsUpdated", n.INTERSTITIALS_BUFFERED_TO_BOUNDARY = "hlsInterstitialsBufferedToBoundary", n.INTERSTITIAL_ASSET_PLAYER_CREATED = "hlsInterstitialAssetPlayerCreated", n.INTERSTITIAL_STARTED = "hlsInterstitialStarted", n.INTERSTITIAL_ASSET_STARTED = "hlsInterstitialAssetStarted", n.INTERSTITIAL_ASSET_ENDED = "hlsInterstitialAssetEnded", n.INTERSTITIAL_ASSET_ERROR = "hlsInterstitialAssetError", n.INTERSTITIAL_ENDED = "hlsInterstitialEnded", n.INTERSTITIALS_PRIMARY_RESUMED = "hlsInterstitialsPrimaryResumed", n.PLAYOUT_LIMIT_REACHED = "hlsPlayoutLimitReached", n.EVENT_CUE_ENTER = "hlsEventCueEnter", n;
})({});
var Dt = {
  MANIFEST: "manifest",
  LEVEL: "level",
  AUDIO_TRACK: "audioTrack",
  SUBTITLE_TRACK: "subtitleTrack"
}, We = {
  MAIN: "main",
  AUDIO: "audio",
  SUBTITLE: "subtitle"
};
class Cd {
  //  About half of the estimated value will be from the last |halfLife| samples by weight.
  constructor(e, t = 0, r = 0) {
    this.halfLife = void 0, this.alpha_ = void 0, this.estimate_ = void 0, this.totalWeight_ = void 0, this.halfLife = e, this.alpha_ = e ? Math.exp(Math.log(0.5) / e) : 0, this.estimate_ = t, this.totalWeight_ = r;
  }
  sample(e, t) {
    const r = Math.pow(this.alpha_, e);
    this.estimate_ = t * (1 - r) + r * this.estimate_, this.totalWeight_ += e;
  }
  getTotalWeight() {
    return this.totalWeight_;
  }
  getEstimate() {
    if (this.alpha_) {
      const e = 1 - Math.pow(this.alpha_, this.totalWeight_);
      if (e)
        return this.estimate_ / e;
    }
    return this.estimate_;
  }
}
class EGe {
  constructor(e, t, r, i = 100) {
    this.defaultEstimate_ = void 0, this.minWeight_ = void 0, this.minDelayMs_ = void 0, this.slow_ = void 0, this.fast_ = void 0, this.defaultTTFB_ = void 0, this.ttfb_ = void 0, this.defaultEstimate_ = r, this.minWeight_ = 1e-3, this.minDelayMs_ = 50, this.slow_ = new Cd(e), this.fast_ = new Cd(t), this.defaultTTFB_ = i, this.ttfb_ = new Cd(e);
  }
  update(e, t) {
    const {
      slow_: r,
      fast_: i,
      ttfb_: s
    } = this;
    r.halfLife !== e && (this.slow_ = new Cd(e, r.getEstimate(), r.getTotalWeight())), i.halfLife !== t && (this.fast_ = new Cd(t, i.getEstimate(), i.getTotalWeight())), s.halfLife !== e && (this.ttfb_ = new Cd(e, s.getEstimate(), s.getTotalWeight()));
  }
  sample(e, t) {
    e = Math.max(e, this.minDelayMs_);
    const r = 8 * t, i = e / 1e3, s = r / i;
    this.fast_.sample(i, s), this.slow_.sample(i, s);
  }
  sampleTTFB(e) {
    const t = e / 1e3, r = Math.sqrt(2) * Math.exp(-Math.pow(t, 2) / 2);
    this.ttfb_.sample(r, Math.max(e, 5));
  }
  canEstimate() {
    return this.fast_.getTotalWeight() >= this.minWeight_;
  }
  getEstimate() {
    return this.canEstimate() ? Math.min(this.fast_.getEstimate(), this.slow_.getEstimate()) : this.defaultEstimate_;
  }
  getEstimateTTFB() {
    return this.ttfb_.getTotalWeight() >= this.minWeight_ ? this.ttfb_.getEstimate() : this.defaultTTFB_;
  }
  get defaultEstimate() {
    return this.defaultEstimate_;
  }
  destroy() {
  }
}
function SGe(n, e, t) {
  return (e = TGe(e)) in n ? Object.defineProperty(n, e, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[e] = t, n;
}
function mn() {
  return mn = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, mn.apply(null, arguments);
}
function _z(n, e) {
  var t = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(n);
    e && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(n, i).enumerable;
    })), t.push.apply(t, r);
  }
  return t;
}
function cn(n) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e] != null ? arguments[e] : {};
    e % 2 ? _z(Object(t), !0).forEach(function(r) {
      SGe(n, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(t)) : _z(Object(t)).forEach(function(r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return n;
}
function CGe(n, e) {
  if (typeof n != "object" || !n) return n;
  var t = n[Symbol.toPrimitive];
  if (t !== void 0) {
    var r = t.call(n, e);
    if (typeof r != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(n);
}
function TGe(n) {
  var e = CGe(n, "string");
  return typeof e == "symbol" ? e : e + "";
}
class Ys {
  constructor(e, t) {
    this.trace = void 0, this.debug = void 0, this.log = void 0, this.warn = void 0, this.info = void 0, this.error = void 0;
    const r = `[${e}]:`;
    this.trace = Fl, this.debug = t.debug.bind(null, r), this.log = t.log.bind(null, r), this.warn = t.warn.bind(null, r), this.info = t.info.bind(null, r), this.error = t.error.bind(null, r);
  }
}
const Fl = function() {
}, AGe = {
  trace: Fl,
  debug: Fl,
  log: Fl,
  warn: Fl,
  info: Fl,
  error: Fl
};
function g7() {
  return mn({}, AGe);
}
function MGe(n, e) {
  const t = self.console[n];
  return t ? t.bind(self.console, `${e ? "[" + e + "] " : ""}[${n}] >`) : Fl;
}
function Oz(n, e, t) {
  return e[n] ? e[n].bind(e) : MGe(n, t);
}
const v7 = g7();
function kGe(n, e, t) {
  const r = g7();
  if (typeof console == "object" && n === !0 || typeof n == "object") {
    const i = [
      // Remove out from list here to hard-disable a log-level
      // 'trace',
      "debug",
      "log",
      "info",
      "warn",
      "error"
    ];
    i.forEach((s) => {
      r[s] = Oz(s, n, t);
    });
    try {
      r.log(`Debug logs enabled for "${e}" in hls.js version 1.6.15`);
    } catch {
      return g7();
    }
    i.forEach((s) => {
      v7[s] = Oz(s, n);
    });
  } else
    mn(v7, r);
  return r;
}
const un = v7;
function gc(n = !0) {
  return typeof self > "u" ? void 0 : (n || !self.MediaSource) && self.ManagedMediaSource || self.MediaSource || self.WebKitMediaSource;
}
function _Ge(n) {
  return typeof self < "u" && n === self.ManagedMediaSource;
}
function Ote(n, e) {
  const t = Object.keys(n), r = Object.keys(e), i = t.length, s = r.length;
  return !i || !s || i === s && !t.some((o) => r.indexOf(o) === -1);
}
function gs(n, e = !1) {
  if (typeof TextDecoder < "u") {
    const c = new TextDecoder("utf-8").decode(n);
    if (e) {
      const u = c.indexOf("\0");
      return u !== -1 ? c.substring(0, u) : c;
    }
    return c.replace(/\0/g, "");
  }
  const t = n.length;
  let r, i, s, o = "", a = 0;
  for (; a < t; ) {
    if (r = n[a++], r === 0 && e)
      return o;
    if (r === 0 || r === 3)
      continue;
    switch (r >> 4) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
        o += String.fromCharCode(r);
        break;
      case 12:
      case 13:
        i = n[a++], o += String.fromCharCode((r & 31) << 6 | i & 63);
        break;
      case 14:
        i = n[a++], s = n[a++], o += String.fromCharCode((r & 15) << 12 | (i & 63) << 6 | (s & 63) << 0);
        break;
    }
  }
  return o;
}
function Br(n) {
  let e = "";
  for (let t = 0; t < n.length; t++) {
    let r = n[t].toString(16);
    r.length < 2 && (r = "0" + r), e += r;
  }
  return e;
}
function Ite(n) {
  return Uint8Array.from(n.replace(/^0x/, "").replace(/([\da-fA-F]{2}) ?/g, "0x$1 ").replace(/ +$/, "").split(" ")).buffer;
}
function OGe(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
var b6 = { exports: {} }, Iz;
function IGe() {
  return Iz || (Iz = 1, (function(n, e) {
    (function(t) {
      var r = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/, i = /^(?=([^\/?#]*))\1([^]*)$/, s = /(?:\/|^)\.(?=\/)/g, o = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, a = {
        // If opts.alwaysNormalize is true then the path will always be normalized even when it starts with / or //
        // E.g
        // With opts.alwaysNormalize = false (default, spec compliant)
        // http://a.com/b/cd + /e/f/../g => http://a.com/e/f/../g
        // With opts.alwaysNormalize = true (not spec compliant)
        // http://a.com/b/cd + /e/f/../g => http://a.com/e/g
        buildAbsoluteURL: function(l, c, u) {
          if (u = u || {}, l = l.trim(), c = c.trim(), !c) {
            if (!u.alwaysNormalize)
              return l;
            var d = a.parseURL(l);
            if (!d)
              throw new Error("Error trying to parse base URL.");
            return d.path = a.normalizePath(
              d.path
            ), a.buildURLFromParts(d);
          }
          var f = a.parseURL(c);
          if (!f)
            throw new Error("Error trying to parse relative URL.");
          if (f.scheme)
            return u.alwaysNormalize ? (f.path = a.normalizePath(f.path), a.buildURLFromParts(f)) : c;
          var h = a.parseURL(l);
          if (!h)
            throw new Error("Error trying to parse base URL.");
          if (!h.netLoc && h.path && h.path[0] !== "/") {
            var m = i.exec(h.path);
            h.netLoc = m[1], h.path = m[2];
          }
          h.netLoc && !h.path && (h.path = "/");
          var g = {
            // 2c) Otherwise, the embedded URL inherits the scheme of
            // the base URL.
            scheme: h.scheme,
            netLoc: f.netLoc,
            path: null,
            params: f.params,
            query: f.query,
            fragment: f.fragment
          };
          if (!f.netLoc && (g.netLoc = h.netLoc, f.path[0] !== "/"))
            if (!f.path)
              g.path = h.path, f.params || (g.params = h.params, f.query || (g.query = h.query));
            else {
              var v = h.path, y = v.substring(0, v.lastIndexOf("/") + 1) + f.path;
              g.path = a.normalizePath(y);
            }
          return g.path === null && (g.path = u.alwaysNormalize ? a.normalizePath(f.path) : f.path), a.buildURLFromParts(g);
        },
        parseURL: function(l) {
          var c = r.exec(l);
          return c ? {
            scheme: c[1] || "",
            netLoc: c[2] || "",
            path: c[3] || "",
            params: c[4] || "",
            query: c[5] || "",
            fragment: c[6] || ""
          } : null;
        },
        normalizePath: function(l) {
          for (l = l.split("").reverse().join("").replace(s, ""); l.length !== (l = l.replace(o, "")).length; )
            ;
          return l.split("").reverse().join("");
        },
        buildURLFromParts: function(l) {
          return l.scheme + l.netLoc + l.path + l.params + l.query + l.fragment;
        }
      };
      n.exports = a;
    })();
  })(b6)), b6.exports;
}
var d_ = IGe();
class f_ {
  constructor() {
    this.aborted = !1, this.loaded = 0, this.retry = 0, this.total = 0, this.chunkCount = 0, this.bwEstimate = 0, this.loading = {
      start: 0,
      first: 0,
      end: 0
    }, this.parsing = {
      start: 0,
      end: 0
    }, this.buffering = {
      start: 0,
      first: 0,
      end: 0
    };
  }
}
var wn = {
  AUDIO: "audio",
  VIDEO: "video",
  AUDIOVIDEO: "audiovideo"
};
class Rte {
  constructor(e) {
    this._byteRange = null, this._url = null, this._stats = null, this._streams = null, this.base = void 0, this.relurl = void 0, typeof e == "string" && (e = {
      url: e
    }), this.base = e, PGe(this, "stats");
  }
  // setByteRange converts a EXT-X-BYTERANGE attribute into a two element array
  setByteRange(e, t) {
    const r = e.split("@", 2);
    let i;
    r.length === 1 ? i = t?.byteRangeEndOffset || 0 : i = parseInt(r[1]), this._byteRange = [i, parseInt(r[0]) + i];
  }
  get baseurl() {
    return this.base.url;
  }
  get byteRange() {
    return this._byteRange === null ? [] : this._byteRange;
  }
  get byteRangeStartOffset() {
    return this.byteRange[0];
  }
  get byteRangeEndOffset() {
    return this.byteRange[1];
  }
  get elementaryStreams() {
    return this._streams === null && (this._streams = {
      [wn.AUDIO]: null,
      [wn.VIDEO]: null,
      [wn.AUDIOVIDEO]: null
    }), this._streams;
  }
  set elementaryStreams(e) {
    this._streams = e;
  }
  get hasStats() {
    return this._stats !== null;
  }
  get hasStreams() {
    return this._streams !== null;
  }
  get stats() {
    return this._stats === null && (this._stats = new f_()), this._stats;
  }
  set stats(e) {
    this._stats = e;
  }
  get url() {
    return !this._url && this.baseurl && this.relurl && (this._url = d_.buildAbsoluteURL(this.baseurl, this.relurl, {
      alwaysNormalize: !0
    })), this._url || "";
  }
  set url(e) {
    this._url = e;
  }
  clearElementaryStreamInfo() {
    const {
      elementaryStreams: e
    } = this;
    e[wn.AUDIO] = null, e[wn.VIDEO] = null, e[wn.AUDIOVIDEO] = null;
  }
}
function tr(n) {
  return n.sn !== "initSegment";
}
let w6 = class extends Rte {
  constructor(e, t) {
    super(t), this._decryptdata = null, this._programDateTime = null, this._ref = null, this._bitrate = void 0, this.rawProgramDateTime = null, this.tagList = [], this.duration = 0, this.sn = 0, this.levelkeys = void 0, this.type = void 0, this.loader = null, this.keyLoader = null, this.level = -1, this.cc = 0, this.startPTS = void 0, this.endPTS = void 0, this.startDTS = void 0, this.endDTS = void 0, this.start = 0, this.playlistOffset = 0, this.deltaPTS = void 0, this.maxStartPTS = void 0, this.minEndPTS = void 0, this.data = void 0, this.bitrateTest = !1, this.title = null, this.initSegment = null, this.endList = void 0, this.gap = void 0, this.urlId = 0, this.type = e;
  }
  get byteLength() {
    if (this.hasStats) {
      const e = this.stats.total;
      if (e)
        return e;
    }
    if (this.byteRange.length) {
      const e = this.byteRange[0], t = this.byteRange[1];
      if (He(e) && He(t))
        return t - e;
    }
    return null;
  }
  get bitrate() {
    return this.byteLength ? this.byteLength * 8 / this.duration : this._bitrate ? this._bitrate : null;
  }
  set bitrate(e) {
    this._bitrate = e;
  }
  get decryptdata() {
    var e;
    const {
      levelkeys: t
    } = this;
    if (!t || t.NONE)
      return null;
    if (t.identity)
      this._decryptdata || (this._decryptdata = t.identity.getDecryptData(this.sn));
    else if (!((e = this._decryptdata) != null && e.keyId)) {
      const r = Object.keys(t);
      if (r.length === 1) {
        const i = this._decryptdata = t[r[0]] || null;
        i && (this._decryptdata = i.getDecryptData(this.sn, t));
      }
    }
    return this._decryptdata;
  }
  get end() {
    return this.start + this.duration;
  }
  get endProgramDateTime() {
    if (this.programDateTime === null)
      return null;
    const e = He(this.duration) ? this.duration : 0;
    return this.programDateTime + e * 1e3;
  }
  get encrypted() {
    var e;
    if ((e = this._decryptdata) != null && e.encrypted)
      return !0;
    if (this.levelkeys) {
      var t;
      const r = Object.keys(this.levelkeys), i = r.length;
      if (i > 1 || i === 1 && (t = this.levelkeys[r[0]]) != null && t.encrypted)
        return !0;
    }
    return !1;
  }
  get programDateTime() {
    return this._programDateTime === null && this.rawProgramDateTime && (this.programDateTime = Date.parse(this.rawProgramDateTime)), this._programDateTime;
  }
  set programDateTime(e) {
    if (!He(e)) {
      this._programDateTime = this.rawProgramDateTime = null;
      return;
    }
    this._programDateTime = e;
  }
  get ref() {
    return tr(this) ? (this._ref || (this._ref = {
      base: this.base,
      start: this.start,
      duration: this.duration,
      sn: this.sn,
      programDateTime: this.programDateTime
    }), this._ref) : null;
  }
  addStart(e) {
    this.setStart(this.start + e);
  }
  setStart(e) {
    this.start = e, this._ref && (this._ref.start = e);
  }
  setDuration(e) {
    this.duration = e, this._ref && (this._ref.duration = e);
  }
  setKeyFormat(e) {
    const t = this.levelkeys;
    if (t) {
      var r;
      const i = t[e];
      i && !((r = this._decryptdata) != null && r.keyId) && (this._decryptdata = i.getDecryptData(this.sn, t));
    }
  }
  abortRequests() {
    var e, t;
    (e = this.loader) == null || e.abort(), (t = this.keyLoader) == null || t.abort();
  }
  setElementaryStreamInfo(e, t, r, i, s, o = !1) {
    const {
      elementaryStreams: a
    } = this, l = a[e];
    if (!l) {
      a[e] = {
        startPTS: t,
        endPTS: r,
        startDTS: i,
        endDTS: s,
        partial: o
      };
      return;
    }
    l.startPTS = Math.min(l.startPTS, t), l.endPTS = Math.max(l.endPTS, r), l.startDTS = Math.min(l.startDTS, i), l.endDTS = Math.max(l.endDTS, s);
  }
};
class RGe extends Rte {
  constructor(e, t, r, i, s) {
    super(r), this.fragOffset = 0, this.duration = 0, this.gap = !1, this.independent = !1, this.relurl = void 0, this.fragment = void 0, this.index = void 0, this.duration = e.decimalFloatingPoint("DURATION"), this.gap = e.bool("GAP"), this.independent = e.bool("INDEPENDENT"), this.relurl = e.enumeratedString("URI"), this.fragment = t, this.index = i;
    const o = e.enumeratedString("BYTERANGE");
    o && this.setByteRange(o, s), s && (this.fragOffset = s.fragOffset + s.duration);
  }
  get start() {
    return this.fragment.start + this.fragOffset;
  }
  get end() {
    return this.start + this.duration;
  }
  get loaded() {
    const {
      elementaryStreams: e
    } = this;
    return !!(e.audio || e.video || e.audiovideo);
  }
}
function Pte(n, e) {
  const t = Object.getPrototypeOf(n);
  if (t) {
    const r = Object.getOwnPropertyDescriptor(t, e);
    return r || Pte(t, e);
  }
}
function PGe(n, e) {
  const t = Pte(n, e);
  t && (t.enumerable = !0, Object.defineProperty(n, e, t));
}
const Rz = Math.pow(2, 32) - 1, DGe = [].push, Dte = {
  video: 1,
  audio: 2,
  id3: 3,
  text: 4
};
function yr(n) {
  return String.fromCharCode.apply(null, n);
}
function Nte(n, e) {
  const t = n[e] << 8 | n[e + 1];
  return t < 0 ? 65536 + t : t;
}
function bt(n, e) {
  const t = Lte(n, e);
  return t < 0 ? 4294967296 + t : t;
}
function Pz(n, e) {
  let t = bt(n, e);
  return t *= Math.pow(2, 32), t += bt(n, e + 4), t;
}
function Lte(n, e) {
  return n[e] << 24 | n[e + 1] << 16 | n[e + 2] << 8 | n[e + 3];
}
function NGe(n) {
  const e = n.byteLength;
  for (let t = 0; t < e; ) {
    const r = bt(n, t);
    if (r > 8 && n[t + 4] === 109 && n[t + 5] === 111 && n[t + 6] === 111 && n[t + 7] === 102)
      return !0;
    t = r > 1 ? t + r : e;
  }
  return !1;
}
function Rt(n, e) {
  const t = [];
  if (!e.length)
    return t;
  const r = n.byteLength;
  for (let i = 0; i < r; ) {
    const s = bt(n, i), o = yr(n.subarray(i + 4, i + 8)), a = s > 1 ? i + s : r;
    if (o === e[0])
      if (e.length === 1)
        t.push(n.subarray(i + 8, a));
      else {
        const l = Rt(n.subarray(i + 8, a), e.slice(1));
        l.length && DGe.apply(t, l);
      }
    i = a;
  }
  return t;
}
function LGe(n) {
  const e = [], t = n[0];
  let r = 8;
  const i = bt(n, r);
  r += 4;
  let s = 0, o = 0;
  t === 0 ? (s = bt(n, r), o = bt(n, r + 4), r += 8) : (s = Pz(n, r), o = Pz(n, r + 8), r += 16), r += 2;
  let a = n.length + o;
  const l = Nte(n, r);
  r += 2;
  for (let c = 0; c < l; c++) {
    let u = r;
    const d = bt(n, u);
    u += 4;
    const f = d & 2147483647;
    if ((d & 2147483648) >>> 31 === 1)
      return un.warn("SIDX has hierarchical references (not supported)"), null;
    const m = bt(n, u);
    u += 4, e.push({
      referenceSize: f,
      subsegmentDuration: m,
      // unscaled
      info: {
        duration: m / i,
        start: a,
        end: a + f - 1
      }
    }), a += f, u += 4, r = u;
  }
  return {
    earliestPresentationTime: s,
    timescale: i,
    version: t,
    referencesCount: l,
    references: e
  };
}
function $te(n) {
  const e = [], t = Rt(n, ["moov", "trak"]);
  for (let i = 0; i < t.length; i++) {
    const s = t[i], o = Rt(s, ["tkhd"])[0];
    if (o) {
      let a = o[0];
      const l = bt(o, a === 0 ? 12 : 20), c = Rt(s, ["mdia", "mdhd"])[0];
      if (c) {
        a = c[0];
        const u = bt(c, a === 0 ? 12 : 20), d = Rt(s, ["mdia", "hdlr"])[0];
        if (d) {
          const f = yr(d.subarray(8, 12)), h = {
            soun: wn.AUDIO,
            vide: wn.VIDEO
          }[f], m = Rt(s, ["mdia", "minf", "stbl", "stsd"])[0], g = $Ge(m);
          h ? (e[l] = {
            timescale: u,
            type: h,
            stsd: g
          }, e[h] = cn({
            timescale: u,
            id: l
          }, g)) : e[l] = {
            timescale: u,
            type: f,
            stsd: g
          };
        }
      }
    }
  }
  return Rt(n, ["moov", "mvex", "trex"]).forEach((i) => {
    const s = bt(i, 4), o = e[s];
    o && (o.default = {
      duration: bt(i, 12),
      flags: bt(i, 20)
    });
  }), e;
}
function $Ge(n) {
  const e = n.subarray(8), t = e.subarray(86), r = yr(e.subarray(4, 8));
  let i = r, s;
  const o = r === "enca" || r === "encv";
  if (o) {
    const c = Rt(e, [r])[0].subarray(r === "enca" ? 28 : 78);
    Rt(c, ["sinf"]).forEach((d) => {
      const f = Rt(d, ["schm"])[0];
      if (f) {
        const h = yr(f.subarray(4, 8));
        if (h === "cbcs" || h === "cenc") {
          const m = Rt(d, ["frma"])[0];
          m && (i = yr(m));
        }
      }
    });
  }
  const a = i;
  switch (i) {
    case "avc1":
    case "avc2":
    case "avc3":
    case "avc4": {
      const l = Rt(t, ["avcC"])[0];
      l && l.length > 3 && (i += "." + Rg(l[1]) + Rg(l[2]) + Rg(l[3]), s = Ig(a === "avc1" ? "dva1" : "dvav", t));
      break;
    }
    case "mp4a": {
      const l = Rt(e, [r])[0], c = Rt(l.subarray(28), ["esds"])[0];
      if (c && c.length > 7) {
        let u = 4;
        if (c[u++] !== 3)
          break;
        u = x6(c, u), u += 2;
        const d = c[u++];
        if (d & 128 && (u += 2), d & 64 && (u += c[u++]), c[u++] !== 4)
          break;
        u = x6(c, u);
        const f = c[u++];
        if (f === 64)
          i += "." + Rg(f);
        else
          break;
        if (u += 12, c[u++] !== 5)
          break;
        u = x6(c, u);
        const h = c[u++];
        let m = (h & 248) >> 3;
        m === 31 && (m += 1 + ((h & 7) << 3) + ((c[u] & 224) >> 5)), i += "." + m;
      }
      break;
    }
    case "hvc1":
    case "hev1": {
      const l = Rt(t, ["hvcC"])[0];
      if (l && l.length > 12) {
        const c = l[1], u = ["", "A", "B", "C"][c >> 6], d = c & 31, f = bt(l, 2), h = (c & 32) >> 5 ? "H" : "L", m = l[12], g = l.subarray(6, 12);
        i += "." + u + d, i += "." + FGe(f).toString(16).toUpperCase(), i += "." + h + m;
        let v = "";
        for (let y = g.length; y--; ) {
          const b = g[y];
          (b || v) && (v = "." + b.toString(16).toUpperCase() + v);
        }
        i += v;
      }
      s = Ig(a == "hev1" ? "dvhe" : "dvh1", t);
      break;
    }
    case "dvh1":
    case "dvhe":
    case "dvav":
    case "dva1":
    case "dav1": {
      i = Ig(i, t) || i;
      break;
    }
    case "vp09": {
      const l = Rt(t, ["vpcC"])[0];
      if (l && l.length > 6) {
        const c = l[4], u = l[5], d = l[6] >> 4 & 15;
        i += "." + Wo(c) + "." + Wo(u) + "." + Wo(d);
      }
      break;
    }
    case "av01": {
      const l = Rt(t, ["av1C"])[0];
      if (l && l.length > 2) {
        const c = l[1] >>> 5, u = l[1] & 31, d = l[2] >>> 7 ? "H" : "M", f = (l[2] & 64) >> 6, h = (l[2] & 32) >> 5, m = c === 2 && f ? h ? 12 : 10 : f ? 10 : 8, g = (l[2] & 16) >> 4, v = (l[2] & 8) >> 3, y = (l[2] & 4) >> 2, b = l[2] & 3;
        i += "." + c + "." + Wo(u) + d + "." + Wo(m) + "." + g + "." + v + y + b + "." + Wo(1) + "." + Wo(1) + "." + Wo(1) + "." + 0, s = Ig("dav1", t);
      }
      break;
    }
  }
  return {
    codec: i,
    encrypted: o,
    supplemental: s
  };
}
function Ig(n, e) {
  const t = Rt(e, ["dvvC"]), r = t.length ? t[0] : Rt(e, ["dvcC"])[0];
  if (r) {
    const i = r[2] >> 1 & 127, s = r[2] << 5 & 32 | r[3] >> 3 & 31;
    return n + "." + Wo(i) + "." + Wo(s);
  }
}
function FGe(n) {
  let e = 0;
  for (let t = 0; t < 32; t++)
    e |= (n >> t & 1) << 31 - t;
  return e >>> 0;
}
function x6(n, e) {
  const t = e + 5;
  for (; n[e++] & 128 && e < t; )
    ;
  return e;
}
function Rg(n) {
  return ("0" + n.toString(16).toUpperCase()).slice(-2);
}
function Wo(n) {
  return (n < 10 ? "0" : "") + n;
}
function BGe(n, e) {
  if (!n || !e)
    return;
  const t = e.keyId;
  t && e.isCommonEncryption && Fte(n, (r, i) => {
    const s = r.subarray(8, 24);
    s.some((o) => o !== 0) || (un.log(`[eme] Patching keyId in 'enc${i ? "a" : "v"}>sinf>>tenc' box: ${Br(s)} -> ${Br(t)}`), r.set(t, 8));
  });
}
function zGe(n) {
  const e = [];
  return Fte(n, (t) => e.push(t.subarray(8, 24))), e;
}
function Fte(n, e) {
  Rt(n, ["moov", "trak"]).forEach((r) => {
    const i = Rt(r, ["mdia", "minf", "stbl", "stsd"])[0];
    if (!i) return;
    const s = i.subarray(8);
    let o = Rt(s, ["enca"]);
    const a = o.length > 0;
    a || (o = Rt(s, ["encv"])), o.forEach((l) => {
      const c = a ? l.subarray(28) : l.subarray(78);
      Rt(c, ["sinf"]).forEach((d) => {
        const f = Bte(d);
        f && e(f, a);
      });
    });
  });
}
function Bte(n) {
  const e = Rt(n, ["schm"])[0];
  if (e) {
    const t = yr(e.subarray(4, 8));
    if (t === "cbcs" || t === "cenc") {
      const r = Rt(n, ["schi", "tenc"])[0];
      if (r)
        return r;
    }
  }
}
function HGe(n, e, t) {
  const r = {}, i = Rt(n, ["moof", "traf"]);
  for (let s = 0; s < i.length; s++) {
    const o = i[s], a = Rt(o, ["tfhd"])[0], l = bt(a, 4), c = e[l];
    if (!c)
      continue;
    r[l] || (r[l] = {
      start: NaN,
      duration: 0,
      sampleCount: 0,
      timescale: c.timescale,
      type: c.type
    });
    const u = r[l], d = Rt(o, ["tfdt"])[0];
    if (d) {
      const x = d[0];
      let E = bt(d, 4);
      x === 1 && (E === Rz ? t.warn("[mp4-demuxer]: Ignoring assumed invalid signed 64-bit track fragment decode time") : (E *= Rz + 1, E += bt(d, 8))), He(E) && (!He(u.start) || E < u.start) && (u.start = E);
    }
    const f = c.default, h = bt(a, 0) | f?.flags;
    let m = f?.duration || 0;
    h & 8 && (h & 2 ? m = bt(a, 12) : m = bt(a, 8));
    const g = Rt(o, ["trun"]);
    let v = u.start || 0, y = 0, b = m;
    for (let x = 0; x < g.length; x++) {
      const E = g[x], w = bt(E, 4), C = u.sampleCount;
      u.sampleCount += w;
      const S = E[3] & 1, M = E[3] & 4, k = E[2] & 1, _ = E[2] & 2, O = E[2] & 4, I = E[2] & 8;
      let R = 8, P = w;
      for (S && (R += 4), M && w && (!(E[R + 1] & 1) && u.keyFrameIndex === void 0 && (u.keyFrameIndex = C), R += 4, k ? (b = bt(E, R), R += 4) : b = m, _ && (R += 4), I && (R += 4), v += b, y += b, P--); P--; )
        k ? (b = bt(E, R), R += 4) : b = m, _ && (R += 4), O && (E[R + 1] & 1 || u.keyFrameIndex === void 0 && (u.keyFrameIndex = u.sampleCount - (P + 1), u.keyFrameStart = v), R += 4), I && (R += 4), v += b, y += b;
      !y && m && (y += m * w);
    }
    u.duration += y;
  }
  if (!Object.keys(r).some((s) => r[s].duration)) {
    let s = 1 / 0, o = 0;
    const a = Rt(n, ["sidx"]);
    for (let l = 0; l < a.length; l++) {
      const c = LGe(a[l]);
      if (c != null && c.references) {
        s = Math.min(s, c.earliestPresentationTime / c.timescale);
        const u = c.references.reduce((d, f) => d + f.info.duration || 0, 0);
        o = Math.max(o, u + c.earliestPresentationTime / c.timescale);
      }
    }
    o && He(o) && Object.keys(r).forEach((l) => {
      r[l].duration || (r[l].duration = o * r[l].timescale - r[l].start);
    });
  }
  return r;
}
function UGe(n) {
  const e = {
    valid: null,
    remainder: null
  }, t = Rt(n, ["moof"]);
  if (t.length < 2)
    return e.remainder = n, e;
  const r = t[t.length - 1];
  return e.valid = n.slice(0, r.byteOffset - 8), e.remainder = n.slice(r.byteOffset - 8), e;
}
function Vs(n, e) {
  const t = new Uint8Array(n.length + e.length);
  return t.set(n), t.set(e, n.length), t;
}
function Dz(n, e) {
  const t = [], r = e.samples, i = e.timescale, s = e.id;
  let o = !1;
  return Rt(r, ["moof"]).map((l) => {
    const c = l.byteOffset - 8;
    Rt(l, ["traf"]).map((d) => {
      const f = Rt(d, ["tfdt"]).map((h) => {
        const m = h[0];
        let g = bt(h, 4);
        return m === 1 && (g *= Math.pow(2, 32), g += bt(h, 8)), g / i;
      })[0];
      return f !== void 0 && (n = f), Rt(d, ["tfhd"]).map((h) => {
        const m = bt(h, 4), g = bt(h, 0) & 16777215, v = (g & 1) !== 0, y = (g & 2) !== 0, b = (g & 8) !== 0;
        let x = 0;
        const E = (g & 16) !== 0;
        let w = 0;
        const C = (g & 32) !== 0;
        let S = 8;
        m === s && (v && (S += 8), y && (S += 4), b && (x = bt(h, S), S += 4), E && (w = bt(h, S), S += 4), C && (S += 4), e.type === "video" && (o = j3(e.codec)), Rt(d, ["trun"]).map((M) => {
          const k = M[0], _ = bt(M, 0) & 16777215, O = (_ & 1) !== 0;
          let I = 0;
          const R = (_ & 4) !== 0, P = (_ & 256) !== 0;
          let D = 0;
          const L = (_ & 512) !== 0;
          let B = 0;
          const $ = (_ & 1024) !== 0, z = (_ & 2048) !== 0;
          let H = 0;
          const U = bt(M, 4);
          let F = 8;
          O && (I = bt(M, F), F += 4), R && (F += 4);
          let V = I + c;
          for (let X = 0; X < U; X++) {
            if (P ? (D = bt(M, F), F += 4) : D = x, L ? (B = bt(M, F), F += 4) : B = w, $ && (F += 4), z && (k === 0 ? H = bt(M, F) : H = Lte(M, F), F += 4), e.type === wn.VIDEO) {
              let Z = 0;
              for (; Z < B; ) {
                const ie = bt(r, V);
                if (V += 4, VGe(o, r[V])) {
                  const J = r.subarray(V, V + ie);
                  h_(J, o ? 2 : 1, n + H / i, t);
                }
                V += ie, Z += ie + 4;
              }
            }
            n += D / i;
          }
        }));
      });
    });
  }), t;
}
function j3(n) {
  if (!n)
    return !1;
  const e = n.substring(0, 4);
  return e === "hvc1" || e === "hev1" || // Dolby Vision
  e === "dvh1" || e === "dvhe";
}
function VGe(n, e) {
  if (n) {
    const t = e >> 1 & 63;
    return t === 39 || t === 40;
  } else
    return (e & 31) === 6;
}
function h_(n, e, t, r) {
  const i = zte(n);
  let s = 0;
  s += e;
  let o = 0, a = 0, l = 0;
  for (; s < i.length; ) {
    o = 0;
    do {
      if (s >= i.length)
        break;
      l = i[s++], o += l;
    } while (l === 255);
    a = 0;
    do {
      if (s >= i.length)
        break;
      l = i[s++], a += l;
    } while (l === 255);
    const c = i.length - s;
    let u = s;
    if (a < c)
      s += a;
    else if (a > c) {
      un.error(`Malformed SEI payload. ${a} is too small, only ${c} bytes left to parse.`);
      break;
    }
    if (o === 4) {
      if (i[u++] === 181) {
        const f = Nte(i, u);
        if (u += 2, f === 49) {
          const h = bt(i, u);
          if (u += 4, h === 1195456820) {
            const m = i[u++];
            if (m === 3) {
              const g = i[u++], v = 31 & g, y = 64 & g, b = y ? 2 + v * 3 : 0, x = new Uint8Array(b);
              if (y) {
                x[0] = g;
                for (let E = 1; E < b; E++)
                  x[E] = i[u++];
              }
              r.push({
                type: m,
                payloadType: o,
                pts: t,
                bytes: x
              });
            }
          }
        }
      }
    } else if (o === 5 && a > 16) {
      const d = [];
      for (let m = 0; m < 16; m++) {
        const g = i[u++].toString(16);
        d.push(g.length == 1 ? "0" + g : g), (m === 3 || m === 5 || m === 7 || m === 9) && d.push("-");
      }
      const f = a - 16, h = new Uint8Array(f);
      for (let m = 0; m < f; m++)
        h[m] = i[u++];
      r.push({
        payloadType: o,
        pts: t,
        uuid: d.join(""),
        userData: gs(h),
        userDataBytes: h
      });
    }
  }
}
function zte(n) {
  const e = n.byteLength, t = [];
  let r = 1;
  for (; r < e - 2; )
    n[r] === 0 && n[r + 1] === 0 && n[r + 2] === 3 ? (t.push(r + 2), r += 2) : r++;
  if (t.length === 0)
    return n;
  const i = e - t.length, s = new Uint8Array(i);
  let o = 0;
  for (r = 0; r < i; o++, r++)
    o === t[0] && (o++, t.shift()), s[r] = n[o];
  return s;
}
function jGe(n) {
  const e = n[0];
  let t = "", r = "", i = 0, s = 0, o = 0, a = 0, l = 0, c = 0;
  if (e === 0) {
    for (; yr(n.subarray(c, c + 1)) !== "\0"; )
      t += yr(n.subarray(c, c + 1)), c += 1;
    for (t += yr(n.subarray(c, c + 1)), c += 1; yr(n.subarray(c, c + 1)) !== "\0"; )
      r += yr(n.subarray(c, c + 1)), c += 1;
    r += yr(n.subarray(c, c + 1)), c += 1, i = bt(n, 12), s = bt(n, 16), a = bt(n, 20), l = bt(n, 24), c = 28;
  } else if (e === 1) {
    c += 4, i = bt(n, c), c += 4;
    const d = bt(n, c);
    c += 4;
    const f = bt(n, c);
    for (c += 4, o = 2 ** 32 * d + f, wGe(o) || (o = Number.MAX_SAFE_INTEGER, un.warn("Presentation time exceeds safe integer limit and wrapped to max safe integer in parsing emsg box")), a = bt(n, c), c += 4, l = bt(n, c), c += 4; yr(n.subarray(c, c + 1)) !== "\0"; )
      t += yr(n.subarray(c, c + 1)), c += 1;
    for (t += yr(n.subarray(c, c + 1)), c += 1; yr(n.subarray(c, c + 1)) !== "\0"; )
      r += yr(n.subarray(c, c + 1)), c += 1;
    r += yr(n.subarray(c, c + 1)), c += 1;
  }
  const u = n.subarray(c, n.byteLength);
  return {
    schemeIdUri: t,
    value: r,
    timeScale: i,
    presentationTime: o,
    presentationTimeDelta: s,
    eventDuration: a,
    id: l,
    payload: u
  };
}
function WGe(n, ...e) {
  const t = e.length;
  let r = 8, i = t;
  for (; i--; )
    r += e[i].byteLength;
  const s = new Uint8Array(r);
  for (s[0] = r >> 24 & 255, s[1] = r >> 16 & 255, s[2] = r >> 8 & 255, s[3] = r & 255, s.set(n, 4), i = 0, r = 8; i < t; i++)
    s.set(e[i], r), r += e[i].byteLength;
  return s;
}
function GGe(n, e, t) {
  if (n.byteLength !== 16)
    throw new RangeError("Invalid system id");
  let r, i;
  r = 0, i = new Uint8Array();
  let s;
  r > 0 ? (s = new Uint8Array(4), e.length > 0 && new DataView(s.buffer).setUint32(0, e.length, !1)) : s = new Uint8Array();
  const o = new Uint8Array(4);
  return t.byteLength > 0 && new DataView(o.buffer).setUint32(0, t.byteLength, !1), WGe(
    [112, 115, 115, 104],
    new Uint8Array([
      r,
      0,
      0,
      0
      // Flags
    ]),
    n,
    // 16 bytes
    s,
    i,
    o,
    t
  );
}
function KGe(n) {
  const e = [];
  if (n instanceof ArrayBuffer) {
    const t = n.byteLength;
    let r = 0;
    for (; r + 32 < t; ) {
      const i = new DataView(n, r), s = qGe(i);
      e.push(s), r += s.size;
    }
  }
  return e;
}
function qGe(n) {
  const e = n.getUint32(0), t = n.byteOffset, r = n.byteLength;
  if (r < e)
    return {
      offset: t,
      size: r
    };
  if (n.getUint32(4) !== 1886614376)
    return {
      offset: t,
      size: e
    };
  const s = n.getUint32(8) >>> 24;
  if (s !== 0 && s !== 1)
    return {
      offset: t,
      size: e
    };
  const o = n.buffer, a = Br(new Uint8Array(o, t + 12, 16));
  let l = null, c = null, u = 0;
  if (s === 0)
    u = 28;
  else {
    const f = n.getUint32(28);
    if (!f || r < 32 + f * 16)
      return {
        offset: t,
        size: e
      };
    l = [];
    for (let h = 0; h < f; h++)
      l.push(new Uint8Array(o, t + 32 + h * 16, 16));
    u = 32 + f * 16;
  }
  if (!u)
    return {
      offset: t,
      size: e
    };
  const d = n.getUint32(u);
  return e - 32 < d ? {
    offset: t,
    size: e
  } : (c = new Uint8Array(o, t + u + 4, d), {
    version: s,
    systemId: a,
    kids: l,
    data: c,
    offset: t,
    size: e
  });
}
const Hte = () => /\(Windows.+Firefox\//i.test(navigator.userAgent), eh = {
  audio: {
    a3ds: 1,
    "ac-3": 0.95,
    "ac-4": 1,
    alac: 0.9,
    alaw: 1,
    dra1: 1,
    "dts+": 1,
    "dts-": 1,
    dtsc: 1,
    dtse: 1,
    dtsh: 1,
    "ec-3": 0.9,
    enca: 1,
    fLaC: 0.9,
    // MP4-RA listed codec entry for FLAC
    flac: 0.9,
    // legacy browser codec name for FLAC
    FLAC: 0.9,
    // some manifests may list "FLAC" with Apple's tools
    g719: 1,
    g726: 1,
    m4ae: 1,
    mha1: 1,
    mha2: 1,
    mhm1: 1,
    mhm2: 1,
    mlpa: 1,
    mp4a: 1,
    "raw ": 1,
    Opus: 1,
    opus: 1,
    // browsers expect this to be lowercase despite MP4RA says 'Opus'
    samr: 1,
    sawb: 1,
    sawp: 1,
    sevc: 1,
    sqcp: 1,
    ssmv: 1,
    twos: 1,
    ulaw: 1
  },
  video: {
    avc1: 1,
    avc2: 1,
    avc3: 1,
    avc4: 1,
    avcp: 1,
    av01: 0.8,
    dav1: 0.8,
    drac: 1,
    dva1: 1,
    dvav: 1,
    dvh1: 0.7,
    dvhe: 0.7,
    encv: 1,
    hev1: 0.75,
    hvc1: 0.75,
    mjp2: 1,
    mp4v: 1,
    mvc1: 1,
    mvc2: 1,
    mvc3: 1,
    mvc4: 1,
    resv: 1,
    rv60: 1,
    s263: 1,
    svc1: 1,
    svc2: 1,
    "vc-1": 1,
    vp08: 1,
    vp09: 0.9
  },
  text: {
    stpp: 1,
    wvtt: 1
  }
};
function p_(n, e) {
  const t = eh[e];
  return !!t && !!t[n.slice(0, 4)];
}
function w0(n, e, t = !0) {
  return !n.split(",").some((r) => !m_(r, e, t));
}
function m_(n, e, t = !0) {
  var r;
  const i = gc(t);
  return (r = i?.isTypeSupported(x0(n, e))) != null ? r : !1;
}
function x0(n, e) {
  return `${e}/mp4;codecs=${n}`;
}
function Nz(n) {
  if (n) {
    const e = n.substring(0, 4);
    return eh.video[e];
  }
  return 2;
}
function Fy(n) {
  const e = Hte();
  return n.split(",").reduce((t, r) => {
    const s = e && j3(r) ? 9 : eh.video[r];
    return s ? (s * 2 + t) / (t ? 3 : 2) : (eh.audio[r] + t) / (t ? 2 : 1);
  }, 0);
}
const E6 = {};
function YGe(n, e = !0) {
  if (E6[n])
    return E6[n];
  const t = {
    // Idealy fLaC and Opus would be first (spec-compliant) but
    // some browsers will report that fLaC is supported then fail.
    // see: https://bugs.chromium.org/p/chromium/issues/detail?id=1422728
    flac: ["flac", "fLaC", "FLAC"],
    opus: ["opus", "Opus"],
    // Replace audio codec info if browser does not support mp4a.40.34,
    // and demuxer can fallback to 'audio/mpeg' or 'audio/mp4;codecs="mp3"'
    "mp4a.40.34": ["mp3"]
  }[n];
  for (let i = 0; i < t.length; i++) {
    var r;
    if (m_(t[i], "audio", e))
      return E6[n] = t[i], t[i];
    if (t[i] === "mp3" && (r = gc(e)) != null && r.isTypeSupported("audio/mpeg"))
      return "";
  }
  return n;
}
const XGe = /flac|opus|mp4a\.40\.34/i;
function By(n, e = !0) {
  return n.replace(XGe, (t) => YGe(t.toLowerCase(), e));
}
function ZGe(n, e) {
  const t = [];
  if (n) {
    const r = n.split(",");
    for (let i = 0; i < r.length; i++)
      p_(r[i], "video") || t.push(r[i]);
  }
  return e && t.push(e), t.join(",");
}
function Uv(n, e) {
  if (n && (n.length > 4 || ["ac-3", "ec-3", "alac", "fLaC", "Opus"].indexOf(n) !== -1) && (Lz(n, "audio") || Lz(n, "video")))
    return n;
  if (e) {
    const t = e.split(",");
    if (t.length > 1) {
      if (n) {
        for (let r = t.length; r--; )
          if (t[r].substring(0, 4) === n.substring(0, 4))
            return t[r];
      }
      return t[0];
    }
  }
  return e || n;
}
function Lz(n, e) {
  return p_(n, e) && m_(n, e);
}
function QGe(n) {
  const e = n.split(",");
  for (let t = 0; t < e.length; t++) {
    const r = e[t].split(".");
    r.length > 2 && r[0] === "avc1" && (e[t] = `avc1.${parseInt(r[1]).toString(16)}${("000" + parseInt(r[2]).toString(16)).slice(-4)}`);
  }
  return e.join(",");
}
function JGe(n) {
  if (n.startsWith("av01.")) {
    const e = n.split("."), t = ["0", "111", "01", "01", "01", "0"];
    for (let r = e.length; r > 4 && r < 10; r++)
      e[r] = t[r - 4];
    return e.join(".");
  }
  return n;
}
function $z(n) {
  const e = gc(n) || {
    isTypeSupported: () => !1
  };
  return {
    mpeg: e.isTypeSupported("audio/mpeg"),
    mp3: e.isTypeSupported('audio/mp4; codecs="mp3"'),
    ac3: e.isTypeSupported('audio/mp4; codecs="ac-3"')
  };
}
function y7(n) {
  return n.replace(/^.+codecs=["']?([^"']+).*$/, "$1");
}
const eKe = {
  supported: !0,
  powerEfficient: !0,
  smooth: !0
  // keySystemAccess: null,
}, tKe = {
  supported: !1,
  smooth: !1,
  powerEfficient: !1
  // keySystemAccess: null,
}, Ute = {
  supported: !0,
  configurations: [],
  decodingInfoResults: [eKe]
};
function Vte(n, e) {
  return {
    supported: !1,
    configurations: e,
    decodingInfoResults: [tKe],
    error: n
  };
}
function nKe(n, e, t, r, i, s) {
  const o = n.videoCodec, a = n.audioCodec ? n.audioGroups : null, l = s?.audioCodec, c = s?.channels, u = c ? parseInt(c) : l ? 1 / 0 : 2;
  let d = null;
  if (a != null && a.length)
    try {
      a.length === 1 && a[0] ? d = e.groups[a[0]].channels : d = a.reduce((f, h) => {
        if (h) {
          const m = e.groups[h];
          if (!m)
            throw new Error(`Audio track group ${h} not found`);
          Object.keys(m.channels).forEach((g) => {
            f[g] = (f[g] || 0) + m.channels[g];
          });
        }
        return f;
      }, {
        2: 0
      });
    } catch {
      return !0;
    }
  return o !== void 0 && // Force media capabilities check for HEVC to avoid failure on Windows
  (o.split(",").some((f) => j3(f)) || n.width > 1920 && n.height > 1088 || n.height > 1920 && n.width > 1088 || n.frameRate > Math.max(r, 30) || n.videoRange !== "SDR" && n.videoRange !== t || n.bitrate > Math.max(i, 8e6)) || !!d && He(u) && Object.keys(d).some((f) => parseInt(f) > u);
}
function jte(n, e, t, r = {}) {
  const i = n.videoCodec;
  if (!i && !n.audioCodec || !t)
    return Promise.resolve(Ute);
  const s = [], o = rKe(n), a = o.length, l = iKe(n, e, a > 0), c = l.length;
  for (let u = a || 1 * c || 1; u--; ) {
    const d = {
      type: "media-source"
    };
    if (a && (d.video = o[u % a]), c) {
      d.audio = l[u % c];
      const f = d.audio.bitrate;
      d.video && f && (d.video.bitrate -= f);
    }
    s.push(d);
  }
  if (i) {
    const u = navigator.userAgent;
    if (i.split(",").some((d) => j3(d)) && Hte())
      return Promise.resolve(Vte(new Error(`Overriding Windows Firefox HEVC MediaCapabilities result based on user-agent string: (${u})`), s));
  }
  return Promise.all(s.map((u) => {
    const d = oKe(u);
    return r[d] || (r[d] = t.decodingInfo(u));
  })).then((u) => ({
    supported: !u.some((d) => !d.supported),
    configurations: s,
    decodingInfoResults: u
  })).catch((u) => ({
    supported: !1,
    configurations: s,
    decodingInfoResults: [],
    error: u
  }));
}
function rKe(n) {
  var e;
  const t = (e = n.videoCodec) == null ? void 0 : e.split(","), r = Wte(n), i = n.width || 640, s = n.height || 480, o = n.frameRate || 30, a = n.videoRange.toLowerCase();
  return t ? t.map((l) => {
    const c = {
      contentType: x0(JGe(l), "video"),
      width: i,
      height: s,
      bitrate: r,
      framerate: o
    };
    return a !== "sdr" && (c.transferFunction = a), c;
  }) : [];
}
function iKe(n, e, t) {
  var r;
  const i = (r = n.audioCodec) == null ? void 0 : r.split(","), s = Wte(n);
  return i && n.audioGroups ? n.audioGroups.reduce((o, a) => {
    var l;
    const c = a ? (l = e.groups[a]) == null ? void 0 : l.tracks : null;
    return c ? c.reduce((u, d) => {
      if (d.groupId === a) {
        const f = parseFloat(d.channels || "");
        i.forEach((h) => {
          const m = {
            contentType: x0(h, "audio"),
            bitrate: t ? sKe(h, s) : s
          };
          f && (m.channels = "" + f), u.push(m);
        });
      }
      return u;
    }, o) : o;
  }, []) : [];
}
function sKe(n, e) {
  if (e <= 1)
    return 1;
  let t = 128e3;
  return n === "ec-3" ? t = 768e3 : n === "ac-3" && (t = 64e4), Math.min(e / 2, t);
}
function Wte(n) {
  return Math.ceil(Math.max(n.bitrate * 0.9, n.averageBitrate) / 1e3) * 1e3 || 1;
}
function oKe(n) {
  let e = "";
  const {
    audio: t,
    video: r
  } = n;
  if (r) {
    const i = y7(r.contentType);
    e += `${i}_r${r.height}x${r.width}f${Math.ceil(r.framerate)}${r.transferFunction || "sd"}_${Math.ceil(r.bitrate / 1e5)}`;
  }
  if (t) {
    const i = y7(t.contentType);
    e += `${r ? "_" : ""}${i}_c${t.channels}`;
  }
  return e;
}
const b7 = ["NONE", "TYPE-0", "TYPE-1", null];
function aKe(n) {
  return b7.indexOf(n) > -1;
}
const zy = ["SDR", "PQ", "HLG"];
function lKe(n) {
  return !!n && zy.indexOf(n) > -1;
}
var Vv = {
  No: "",
  Yes: "YES",
  v2: "v2"
};
function Fz(n) {
  const {
    canSkipUntil: e,
    canSkipDateRanges: t,
    age: r
  } = n, i = r < e / 2;
  return e && i ? t ? Vv.v2 : Vv.Yes : Vv.No;
}
class Bz {
  constructor(e, t, r) {
    this.msn = void 0, this.part = void 0, this.skip = void 0, this.msn = e, this.part = t, this.skip = r;
  }
  addDirectives(e) {
    const t = new self.URL(e);
    return this.msn !== void 0 && t.searchParams.set("_HLS_msn", this.msn.toString()), this.part !== void 0 && t.searchParams.set("_HLS_part", this.part.toString()), this.skip && t.searchParams.set("_HLS_skip", this.skip), t.href;
  }
}
class E0 {
  constructor(e) {
    if (this._attrs = void 0, this.audioCodec = void 0, this.bitrate = void 0, this.codecSet = void 0, this.url = void 0, this.frameRate = void 0, this.height = void 0, this.id = void 0, this.name = void 0, this.supplemental = void 0, this.videoCodec = void 0, this.width = void 0, this.details = void 0, this.fragmentError = 0, this.loadError = 0, this.loaded = void 0, this.realBitrate = 0, this.supportedPromise = void 0, this.supportedResult = void 0, this._avgBitrate = 0, this._audioGroups = void 0, this._subtitleGroups = void 0, this._urlId = 0, this.url = [e.url], this._attrs = [e.attrs], this.bitrate = e.bitrate, e.details && (this.details = e.details), this.id = e.id || 0, this.name = e.name, this.width = e.width || 0, this.height = e.height || 0, this.frameRate = e.attrs.optionalFloat("FRAME-RATE", 0), this._avgBitrate = e.attrs.decimalInteger("AVERAGE-BANDWIDTH"), this.audioCodec = e.audioCodec, this.videoCodec = e.videoCodec, this.codecSet = [e.videoCodec, e.audioCodec].filter((r) => !!r).map((r) => r.substring(0, 4)).join(","), "supplemental" in e) {
      var t;
      this.supplemental = e.supplemental;
      const r = (t = e.supplemental) == null ? void 0 : t.videoCodec;
      r && r !== e.videoCodec && (this.codecSet += `,${r.substring(0, 4)}`);
    }
    this.addGroupId("audio", e.attrs.AUDIO), this.addGroupId("text", e.attrs.SUBTITLES);
  }
  get maxBitrate() {
    return Math.max(this.realBitrate, this.bitrate);
  }
  get averageBitrate() {
    return this._avgBitrate || this.realBitrate || this.bitrate;
  }
  get attrs() {
    return this._attrs[0];
  }
  get codecs() {
    return this.attrs.CODECS || "";
  }
  get pathwayId() {
    return this.attrs["PATHWAY-ID"] || ".";
  }
  get videoRange() {
    return this.attrs["VIDEO-RANGE"] || "SDR";
  }
  get score() {
    return this.attrs.optionalFloat("SCORE", 0);
  }
  get uri() {
    return this.url[0] || "";
  }
  hasAudioGroup(e) {
    return zz(this._audioGroups, e);
  }
  hasSubtitleGroup(e) {
    return zz(this._subtitleGroups, e);
  }
  get audioGroups() {
    return this._audioGroups;
  }
  get subtitleGroups() {
    return this._subtitleGroups;
  }
  addGroupId(e, t) {
    if (t) {
      if (e === "audio") {
        let r = this._audioGroups;
        r || (r = this._audioGroups = []), r.indexOf(t) === -1 && r.push(t);
      } else if (e === "text") {
        let r = this._subtitleGroups;
        r || (r = this._subtitleGroups = []), r.indexOf(t) === -1 && r.push(t);
      }
    }
  }
  // Deprecated methods (retained for backwards compatibility)
  get urlId() {
    return 0;
  }
  set urlId(e) {
  }
  get audioGroupIds() {
    return this.audioGroups ? [this.audioGroupId] : void 0;
  }
  get textGroupIds() {
    return this.subtitleGroups ? [this.textGroupId] : void 0;
  }
  get audioGroupId() {
    var e;
    return (e = this.audioGroups) == null ? void 0 : e[0];
  }
  get textGroupId() {
    var e;
    return (e = this.subtitleGroups) == null ? void 0 : e[0];
  }
  addFallback() {
  }
}
function zz(n, e) {
  return !e || !n ? !1 : n.indexOf(e) !== -1;
}
function cKe() {
  if (typeof matchMedia == "function") {
    const n = matchMedia("(dynamic-range: high)"), e = matchMedia("bad query");
    if (n.media !== e.media)
      return n.matches === !0;
  }
  return !1;
}
function uKe(n, e) {
  let t = !1, r = [];
  if (n && (t = n !== "SDR", r = [n]), e) {
    r = e.allowedVideoRanges || zy.slice(0);
    const i = r.join("") !== "SDR" && !e.videoCodec;
    t = e.preferHDR !== void 0 ? e.preferHDR : i && cKe(), t || (r = ["SDR"]);
  }
  return {
    preferHDR: t,
    allowedVideoRanges: r
  };
}
const dKe = (n) => {
  const e = /* @__PURE__ */ new WeakSet();
  return (t, r) => {
    if (n && (r = n(t, r)), typeof r == "object" && r !== null) {
      if (e.has(r))
        return;
      e.add(r);
    }
    return r;
  };
}, Sn = (n, e) => JSON.stringify(n, dKe(e));
function fKe(n, e, t, r, i) {
  const s = Object.keys(n), o = r?.channels, a = r?.audioCodec, l = i?.videoCodec, c = o && parseInt(o) === 2;
  let u = !1, d = !1, f = 1 / 0, h = 1 / 0, m = 1 / 0, g = 1 / 0, v = 0, y = [];
  const {
    preferHDR: b,
    allowedVideoRanges: x
  } = uKe(e, i);
  for (let M = s.length; M--; ) {
    const k = n[s[M]];
    u || (u = k.channels[2] > 0), f = Math.min(f, k.minHeight), h = Math.min(h, k.minFramerate), m = Math.min(m, k.minBitrate), x.filter((O) => k.videoRanges[O] > 0).length > 0 && (d = !0);
  }
  f = He(f) ? f : 0, h = He(h) ? h : 0;
  const E = Math.max(1080, f), w = Math.max(30, h);
  m = He(m) ? m : t, t = Math.max(m, t), d || (e = void 0);
  const C = s.length > 1;
  return {
    codecSet: s.reduce((M, k) => {
      const _ = n[k];
      if (k === M)
        return M;
      if (y = d ? x.filter((O) => _.videoRanges[O] > 0) : [], C) {
        if (_.minBitrate > t)
          return Fo(k, `min bitrate of ${_.minBitrate} > current estimate of ${t}`), M;
        if (!_.hasDefaultAudio)
          return Fo(k, "no renditions with default or auto-select sound found"), M;
        if (a && k.indexOf(a.substring(0, 4)) % 5 !== 0)
          return Fo(k, `audio codec preference "${a}" not found`), M;
        if (o && !c) {
          if (!_.channels[o])
            return Fo(k, `no renditions with ${o} channel sound found (channels options: ${Object.keys(_.channels)})`), M;
        } else if ((!a || c) && u && _.channels[2] === 0)
          return Fo(k, "no renditions with stereo sound found"), M;
        if (_.minHeight > E)
          return Fo(k, `min resolution of ${_.minHeight} > maximum of ${E}`), M;
        if (_.minFramerate > w)
          return Fo(k, `min framerate of ${_.minFramerate} > maximum of ${w}`), M;
        if (!y.some((O) => _.videoRanges[O] > 0))
          return Fo(k, `no variants with VIDEO-RANGE of ${Sn(y)} found`), M;
        if (l && k.indexOf(l.substring(0, 4)) % 5 !== 0)
          return Fo(k, `video codec preference "${l}" not found`), M;
        if (_.maxScore < v)
          return Fo(k, `max score of ${_.maxScore} < selected max of ${v}`), M;
      }
      return M && (Fy(k) >= Fy(M) || _.fragmentError > n[M].fragmentError) ? M : (g = _.minIndex, v = _.maxScore, k);
    }, void 0),
    videoRanges: y,
    preferHDR: b,
    minFramerate: h,
    minBitrate: m,
    minIndex: g
  };
}
function Fo(n, e) {
  un.log(`[abr] start candidates with "${n}" ignored because ${e}`);
}
function Gte(n) {
  return n.reduce((e, t) => {
    let r = e.groups[t.groupId];
    r || (r = e.groups[t.groupId] = {
      tracks: [],
      channels: {
        2: 0
      },
      hasDefault: !1,
      hasAutoSelect: !1
    }), r.tracks.push(t);
    const i = t.channels || "2";
    return r.channels[i] = (r.channels[i] || 0) + 1, r.hasDefault = r.hasDefault || t.default, r.hasAutoSelect = r.hasAutoSelect || t.autoselect, r.hasDefault && (e.hasDefaultAudio = !0), r.hasAutoSelect && (e.hasAutoSelectAudio = !0), e;
  }, {
    hasDefaultAudio: !1,
    hasAutoSelectAudio: !1,
    groups: {}
  });
}
function hKe(n, e, t, r) {
  return n.slice(t, r + 1).reduce((i, s, o) => {
    if (!s.codecSet)
      return i;
    const a = s.audioGroups;
    let l = i[s.codecSet];
    l || (i[s.codecSet] = l = {
      minBitrate: 1 / 0,
      minHeight: 1 / 0,
      minFramerate: 1 / 0,
      minIndex: o,
      maxScore: 0,
      videoRanges: {
        SDR: 0
      },
      channels: {
        2: 0
      },
      hasDefaultAudio: !a,
      fragmentError: 0
    }), l.minBitrate = Math.min(l.minBitrate, s.bitrate);
    const c = Math.min(s.height, s.width);
    return l.minHeight = Math.min(l.minHeight, c), l.minFramerate = Math.min(l.minFramerate, s.frameRate), l.minIndex = Math.min(l.minIndex, o), l.maxScore = Math.max(l.maxScore, s.score), l.fragmentError += s.fragmentError, l.videoRanges[s.videoRange] = (l.videoRanges[s.videoRange] || 0) + 1, a && a.forEach((u) => {
      if (!u)
        return;
      const d = e.groups[u];
      d && (l.hasDefaultAudio = l.hasDefaultAudio || e.hasDefaultAudio ? d.hasDefault : d.hasAutoSelect || !e.hasDefaultAudio && !e.hasAutoSelectAudio, Object.keys(d.channels).forEach((f) => {
        l.channels[f] = (l.channels[f] || 0) + d.channels[f];
      }));
    }), i;
  }, {});
}
function Hz(n) {
  if (!n)
    return n;
  const {
    lang: e,
    assocLang: t,
    characteristics: r,
    channels: i,
    audioCodec: s
  } = n;
  return {
    lang: e,
    assocLang: t,
    characteristics: r,
    channels: i,
    audioCodec: s
  };
}
function ia(n, e, t) {
  if ("attrs" in n) {
    const r = e.indexOf(n);
    if (r !== -1)
      return r;
  }
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    if (Eu(n, i, t))
      return r;
  }
  return -1;
}
function Eu(n, e, t) {
  const {
    groupId: r,
    name: i,
    lang: s,
    assocLang: o,
    default: a
  } = n, l = n.forced;
  return (r === void 0 || e.groupId === r) && (i === void 0 || e.name === i) && (s === void 0 || pKe(s, e.lang)) && (s === void 0 || e.assocLang === o) && (a === void 0 || e.default === a) && (l === void 0 || e.forced === l) && (!("characteristics" in n) || mKe(n.characteristics || "", e.characteristics)) && (t === void 0 || t(n, e));
}
function pKe(n, e = "--") {
  return n.length === e.length ? n === e : n.startsWith(e) || e.startsWith(n);
}
function mKe(n, e = "") {
  const t = n.split(","), r = e.split(",");
  return t.length === r.length && !t.some((i) => r.indexOf(i) === -1);
}
function Xc(n, e) {
  const {
    audioCodec: t,
    channels: r
  } = n;
  return (t === void 0 || (e.audioCodec || "").substring(0, 4) === t.substring(0, 4)) && (r === void 0 || r === (e.channels || "2"));
}
function gKe(n, e, t, r, i) {
  const s = e[r], a = e.reduce((f, h, m) => {
    const g = h.uri;
    return (f[g] || (f[g] = [])).push(m), f;
  }, {})[s.uri];
  a.length > 1 && (r = Math.max.apply(Math, a));
  const l = s.videoRange, c = s.frameRate, u = s.codecSet.substring(0, 4), d = Uz(e, r, (f) => {
    if (f.videoRange !== l || f.frameRate !== c || f.codecSet.substring(0, 4) !== u)
      return !1;
    const h = f.audioGroups, m = t.filter((g) => !h || h.indexOf(g.groupId) !== -1);
    return ia(n, m, i) > -1;
  });
  return d > -1 ? d : Uz(e, r, (f) => {
    const h = f.audioGroups, m = t.filter((g) => !h || h.indexOf(g.groupId) !== -1);
    return ia(n, m, i) > -1;
  });
}
function Uz(n, e, t) {
  for (let r = e; r > -1; r--)
    if (t(n[r]))
      return r;
  for (let r = e + 1; r < n.length; r++)
    if (t(n[r]))
      return r;
  return -1;
}
function Hy(n, e) {
  var t;
  return !!n && n !== ((t = e.loadLevelObj) == null ? void 0 : t.uri);
}
class vKe extends Ys {
  constructor(e) {
    super("abr", e.logger), this.hls = void 0, this.lastLevelLoadSec = 0, this.lastLoadedFragLevel = -1, this.firstSelection = -1, this._nextAutoLevel = -1, this.nextAutoLevelKey = "", this.audioTracksByGroup = null, this.codecTiers = null, this.timer = -1, this.fragCurrent = null, this.partCurrent = null, this.bitrateTestDelay = 0, this.rebufferNotice = -1, this.supportedCache = {}, this.bwEstimator = void 0, this._abandonRulesCheck = (t) => {
      var r;
      const {
        fragCurrent: i,
        partCurrent: s,
        hls: o
      } = this, {
        autoLevelEnabled: a,
        media: l
      } = o;
      if (!i || !l)
        return;
      const c = performance.now(), u = s ? s.stats : i.stats, d = s ? s.duration : i.duration, f = c - u.loading.start, h = o.minAutoLevel, m = i.level, g = this._nextAutoLevel;
      if (u.aborted || u.loaded && u.loaded === u.total || m <= h) {
        this.clearTimer(), this._nextAutoLevel = -1;
        return;
      }
      if (!a)
        return;
      const v = g > -1 && g !== m, y = !!t || v;
      if (!y && (l.paused || !l.playbackRate || !l.readyState))
        return;
      const b = o.mainForwardBufferInfo;
      if (!y && b === null)
        return;
      const x = this.bwEstimator.getEstimateTTFB(), E = Math.abs(l.playbackRate);
      if (f <= Math.max(x, 1e3 * (d / (E * 2))))
        return;
      const w = b ? b.len / E : 0, C = u.loading.first ? u.loading.first - u.loading.start : -1, S = u.loaded && C > -1, M = this.getBwEstimate(), k = o.levels, _ = k[m], O = Math.max(u.loaded, Math.round(d * (i.bitrate || _.averageBitrate) / 8));
      let I = S ? f - C : f;
      I < 1 && S && (I = Math.min(f, u.loaded * 8 / M));
      const R = S ? u.loaded * 1e3 / I : 0, P = x / 1e3, D = R ? (O - u.loaded) / R : O * 8 / M + P;
      if (D <= w)
        return;
      const L = R ? R * 8 : M, B = ((r = t?.details || this.hls.latestLevelDetails) == null ? void 0 : r.live) === !0, $ = this.hls.config.abrBandWidthUpFactor;
      let z = Number.POSITIVE_INFINITY, H;
      for (H = m - 1; H > h; H--) {
        const X = k[H].maxBitrate, Z = !k[H].details || B;
        if (z = this.getTimeToLoadFrag(P, L, d * X, Z), z < Math.min(w, d + P))
          break;
      }
      if (z >= D || z > d * 10)
        return;
      S ? this.bwEstimator.sample(f - Math.min(x, C), u.loaded) : this.bwEstimator.sampleTTFB(f);
      const U = k[H].maxBitrate;
      this.getBwEstimate() * $ > U && this.resetEstimator(U);
      const F = this.findBestLevel(U, h, H, 0, w, 1, 1);
      F > -1 && (H = F), this.warn(`Fragment ${i.sn}${s ? " part " + s.index : ""} of level ${m} is loading too slowly;
      Fragment duration: ${i.duration.toFixed(3)}
      Time to underbuffer: ${w.toFixed(3)} s
      Estimated load time for current fragment: ${D.toFixed(3)} s
      Estimated load time for down switch fragment: ${z.toFixed(3)} s
      TTFB estimate: ${C | 0} ms
      Current BW estimate: ${He(M) ? M | 0 : "Unknown"} bps
      New BW estimate: ${this.getBwEstimate() | 0} bps
      Switching to level ${H} @ ${U | 0} bps`), o.nextLoadLevel = o.nextAutoLevel = H, this.clearTimer();
      const V = () => {
        if (this.clearTimer(), this.fragCurrent === i && this.hls.loadLevel === H && H > 0) {
          const X = this.getStarvationDelay();
          if (this.warn(`Aborting inflight request ${H > 0 ? "and switching down" : ""}
      Fragment duration: ${i.duration.toFixed(3)} s
      Time to underbuffer: ${X.toFixed(3)} s`), i.abortRequests(), this.fragCurrent = this.partCurrent = null, H > h) {
            let Z = this.findBestLevel(this.hls.levels[h].bitrate, h, H, 0, X, 1, 1);
            Z === -1 && (Z = h), this.hls.nextLoadLevel = this.hls.nextAutoLevel = Z, this.resetEstimator(this.hls.levels[Z].bitrate);
          }
        }
      };
      v || D > z * 2 ? V() : this.timer = self.setInterval(V, z * 1e3), o.trigger(N.FRAG_LOAD_EMERGENCY_ABORTED, {
        frag: i,
        part: s,
        stats: u
      });
    }, this.hls = e, this.bwEstimator = this.initEstimator(), this.registerListeners();
  }
  resetEstimator(e) {
    e && (this.log(`setting initial bwe to ${e}`), this.hls.config.abrEwmaDefaultEstimate = e), this.firstSelection = -1, this.bwEstimator = this.initEstimator();
  }
  initEstimator() {
    const e = this.hls.config;
    return new EGe(e.abrEwmaSlowVoD, e.abrEwmaFastVoD, e.abrEwmaDefaultEstimate);
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(N.MANIFEST_LOADING, this.onManifestLoading, this), e.on(N.FRAG_LOADING, this.onFragLoading, this), e.on(N.FRAG_LOADED, this.onFragLoaded, this), e.on(N.FRAG_BUFFERED, this.onFragBuffered, this), e.on(N.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(N.LEVEL_LOADED, this.onLevelLoaded, this), e.on(N.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(N.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this), e.on(N.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e && (e.off(N.MANIFEST_LOADING, this.onManifestLoading, this), e.off(N.FRAG_LOADING, this.onFragLoading, this), e.off(N.FRAG_LOADED, this.onFragLoaded, this), e.off(N.FRAG_BUFFERED, this.onFragBuffered, this), e.off(N.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(N.LEVEL_LOADED, this.onLevelLoaded, this), e.off(N.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(N.MAX_AUTO_LEVEL_UPDATED, this.onMaxAutoLevelUpdated, this), e.off(N.ERROR, this.onError, this));
  }
  destroy() {
    this.unregisterListeners(), this.clearTimer(), this.hls = this._abandonRulesCheck = this.supportedCache = null, this.fragCurrent = this.partCurrent = null;
  }
  onManifestLoading(e, t) {
    this.lastLoadedFragLevel = -1, this.firstSelection = -1, this.lastLevelLoadSec = 0, this.supportedCache = {}, this.fragCurrent = this.partCurrent = null, this.onLevelsUpdated(), this.clearTimer();
  }
  onLevelsUpdated() {
    this.lastLoadedFragLevel > -1 && this.fragCurrent && (this.lastLoadedFragLevel = this.fragCurrent.level), this._nextAutoLevel = -1, this.onMaxAutoLevelUpdated(), this.codecTiers = null, this.audioTracksByGroup = null;
  }
  onMaxAutoLevelUpdated() {
    this.firstSelection = -1, this.nextAutoLevelKey = "";
  }
  onFragLoading(e, t) {
    const r = t.frag;
    if (!this.ignoreFragment(r)) {
      if (!r.bitrateTest) {
        var i;
        this.fragCurrent = r, this.partCurrent = (i = t.part) != null ? i : null;
      }
      this.clearTimer(), this.timer = self.setInterval(this._abandonRulesCheck, 100);
    }
  }
  onLevelSwitching(e, t) {
    this.clearTimer();
  }
  onError(e, t) {
    if (!t.fatal)
      switch (t.details) {
        case ce.BUFFER_ADD_CODEC_ERROR:
        case ce.BUFFER_APPEND_ERROR:
          this.lastLoadedFragLevel = -1, this.firstSelection = -1;
          break;
        case ce.FRAG_LOAD_TIMEOUT: {
          const r = t.frag, {
            fragCurrent: i,
            partCurrent: s
          } = this;
          if (r && i && r.sn === i.sn && r.level === i.level) {
            const o = performance.now(), a = s ? s.stats : r.stats, l = o - a.loading.start, c = a.loading.first ? a.loading.first - a.loading.start : -1;
            if (a.loaded && c > -1) {
              const d = this.bwEstimator.getEstimateTTFB();
              this.bwEstimator.sample(l - Math.min(d, c), a.loaded);
            } else
              this.bwEstimator.sampleTTFB(l);
          }
          break;
        }
      }
  }
  getTimeToLoadFrag(e, t, r, i) {
    const s = e + r / t, o = i ? e + this.lastLevelLoadSec : 0;
    return s + o;
  }
  onLevelLoaded(e, t) {
    const r = this.hls.config, {
      loading: i
    } = t.stats, s = i.end - i.first;
    He(s) && (this.lastLevelLoadSec = s / 1e3), t.details.live ? this.bwEstimator.update(r.abrEwmaSlowLive, r.abrEwmaFastLive) : this.bwEstimator.update(r.abrEwmaSlowVoD, r.abrEwmaFastVoD), this.timer > -1 && this._abandonRulesCheck(t.levelInfo);
  }
  onFragLoaded(e, {
    frag: t,
    part: r
  }) {
    const i = r ? r.stats : t.stats;
    if (t.type === We.MAIN && this.bwEstimator.sampleTTFB(i.loading.first - i.loading.start), !this.ignoreFragment(t)) {
      if (this.clearTimer(), t.level === this._nextAutoLevel && (this._nextAutoLevel = -1), this.firstSelection = -1, this.hls.config.abrMaxWithRealBitrate) {
        const s = r ? r.duration : t.duration, o = this.hls.levels[t.level], a = (o.loaded ? o.loaded.bytes : 0) + i.loaded, l = (o.loaded ? o.loaded.duration : 0) + s;
        o.loaded = {
          bytes: a,
          duration: l
        }, o.realBitrate = Math.round(8 * a / l);
      }
      if (t.bitrateTest) {
        const s = {
          stats: i,
          frag: t,
          part: r,
          id: t.type
        };
        this.onFragBuffered(N.FRAG_BUFFERED, s), t.bitrateTest = !1;
      } else
        this.lastLoadedFragLevel = t.level;
    }
  }
  onFragBuffered(e, t) {
    const {
      frag: r,
      part: i
    } = t, s = i != null && i.stats.loaded ? i.stats : r.stats;
    if (s.aborted || this.ignoreFragment(r))
      return;
    const o = s.parsing.end - s.loading.start - Math.min(s.loading.first - s.loading.start, this.bwEstimator.getEstimateTTFB());
    this.bwEstimator.sample(o, s.loaded), s.bwEstimate = this.getBwEstimate(), r.bitrateTest ? this.bitrateTestDelay = o / 1e3 : this.bitrateTestDelay = 0;
  }
  ignoreFragment(e) {
    return e.type !== We.MAIN || e.sn === "initSegment";
  }
  clearTimer() {
    this.timer > -1 && (self.clearInterval(this.timer), this.timer = -1);
  }
  get firstAutoLevel() {
    const {
      maxAutoLevel: e,
      minAutoLevel: t
    } = this.hls, r = this.getBwEstimate(), i = this.hls.config.maxStarvationDelay, s = this.findBestLevel(r, t, e, 0, i, 1, 1);
    if (s > -1)
      return s;
    const o = this.hls.firstLevel, a = Math.min(Math.max(o, t), e);
    return this.warn(`Could not find best starting auto level. Defaulting to first in playlist ${o} clamped to ${a}`), a;
  }
  get forcedAutoLevel() {
    return this.nextAutoLevelKey ? -1 : this._nextAutoLevel;
  }
  // return next auto level
  get nextAutoLevel() {
    const e = this.forcedAutoLevel, r = this.bwEstimator.canEstimate(), i = this.lastLoadedFragLevel > -1;
    if (e !== -1 && (!r || !i || this.nextAutoLevelKey === this.getAutoLevelKey()))
      return e;
    const s = r && i ? this.getNextABRAutoLevel() : this.firstAutoLevel;
    if (e !== -1) {
      const o = this.hls.levels;
      if (o.length > Math.max(e, s) && o[e].loadError <= o[s].loadError)
        return e;
    }
    return this._nextAutoLevel = s, this.nextAutoLevelKey = this.getAutoLevelKey(), s;
  }
  getAutoLevelKey() {
    return `${this.getBwEstimate()}_${this.getStarvationDelay().toFixed(2)}`;
  }
  getNextABRAutoLevel() {
    const {
      fragCurrent: e,
      partCurrent: t,
      hls: r
    } = this;
    if (r.levels.length <= 1)
      return r.loadLevel;
    const {
      maxAutoLevel: i,
      config: s,
      minAutoLevel: o
    } = r, a = t ? t.duration : e ? e.duration : 0, l = this.getBwEstimate(), c = this.getStarvationDelay();
    let u = s.abrBandWidthFactor, d = s.abrBandWidthUpFactor;
    if (c) {
      const v = this.findBestLevel(l, o, i, c, 0, u, d);
      if (v >= 0)
        return this.rebufferNotice = -1, v;
    }
    let f = a ? Math.min(a, s.maxStarvationDelay) : s.maxStarvationDelay;
    if (!c) {
      const v = this.bitrateTestDelay;
      v && (f = (a ? Math.min(a, s.maxLoadingDelay) : s.maxLoadingDelay) - v, this.info(`bitrate test took ${Math.round(1e3 * v)}ms, set first fragment max fetchDuration to ${Math.round(1e3 * f)} ms`), u = d = 1);
    }
    const h = this.findBestLevel(l, o, i, c, f, u, d);
    if (this.rebufferNotice !== h && (this.rebufferNotice = h, this.info(`${c ? "rebuffering expected" : "buffer is empty"}, optimal quality level ${h}`)), h > -1)
      return h;
    const m = r.levels[o], g = r.loadLevelObj;
    return g && m?.bitrate < g.bitrate ? o : r.loadLevel;
  }
  getStarvationDelay() {
    const e = this.hls, t = e.media;
    if (!t)
      return 1 / 0;
    const r = t && t.playbackRate !== 0 ? Math.abs(t.playbackRate) : 1, i = e.mainForwardBufferInfo;
    return (i ? i.len : 0) / r;
  }
  getBwEstimate() {
    return this.bwEstimator.canEstimate() ? this.bwEstimator.getEstimate() : this.hls.config.abrEwmaDefaultEstimate;
  }
  findBestLevel(e, t, r, i, s, o, a) {
    var l;
    const c = i + s, u = this.lastLoadedFragLevel, d = u === -1 ? this.hls.firstLevel : u, {
      fragCurrent: f,
      partCurrent: h
    } = this, {
      levels: m,
      allAudioTracks: g,
      loadLevel: v,
      config: y
    } = this.hls;
    if (m.length === 1)
      return 0;
    const b = m[d], x = !!((l = this.hls.latestLevelDetails) != null && l.live), E = v === -1 || u === -1;
    let w, C = "SDR", S = b?.frameRate || 0;
    const {
      audioPreference: M,
      videoPreference: k
    } = y, _ = this.audioTracksByGroup || (this.audioTracksByGroup = Gte(g));
    let O = -1;
    if (E) {
      if (this.firstSelection !== -1)
        return this.firstSelection;
      const L = this.codecTiers || (this.codecTiers = hKe(m, _, t, r)), B = fKe(L, C, e, M, k), {
        codecSet: $,
        videoRanges: z,
        minFramerate: H,
        minBitrate: U,
        minIndex: F,
        preferHDR: V
      } = B;
      O = F, w = $, C = V ? z[z.length - 1] : z[0], S = H, e = Math.max(e, U), this.log(`picked start tier ${Sn(B)}`);
    } else
      w = b?.codecSet, C = b?.videoRange;
    const I = h ? h.duration : f ? f.duration : 0, R = this.bwEstimator.getEstimateTTFB() / 1e3, P = [];
    for (let L = r; L >= t; L--) {
      var D;
      const B = m[L], $ = L > d;
      if (!B)
        continue;
      if (y.useMediaCapabilities && !B.supportedResult && !B.supportedPromise) {
        const Z = navigator.mediaCapabilities;
        typeof Z?.decodingInfo == "function" && nKe(B, _, C, S, e, M) ? (B.supportedPromise = jte(B, _, Z, this.supportedCache), B.supportedPromise.then((ie) => {
          if (!this.hls)
            return;
          B.supportedResult = ie;
          const J = this.hls.levels, se = J.indexOf(B);
          ie.error ? this.warn(`MediaCapabilities decodingInfo error: "${ie.error}" for level ${se} ${Sn(ie)}`) : ie.supported ? ie.decodingInfoResults.some((te) => te.smooth === !1 || te.powerEfficient === !1) && this.log(`MediaCapabilities decodingInfo for level ${se} not smooth or powerEfficient: ${Sn(ie)}`) : (this.warn(`Unsupported MediaCapabilities decodingInfo result for level ${se} ${Sn(ie)}`), se > -1 && J.length > 1 && (this.log(`Removing unsupported level ${se}`), this.hls.removeLevel(se), this.hls.loadLevel === -1 && (this.hls.nextLoadLevel = 0)));
        }).catch((ie) => {
          this.warn(`Error handling MediaCapabilities decodingInfo: ${ie}`);
        })) : B.supportedResult = Ute;
      }
      if ((w && B.codecSet !== w || C && B.videoRange !== C || $ && S > B.frameRate || !$ && S > 0 && S < B.frameRate || (D = B.supportedResult) != null && (D = D.decodingInfoResults) != null && D.some((Z) => Z.smooth === !1)) && (!E || L !== O)) {
        P.push(L);
        continue;
      }
      const z = B.details, H = (h ? z?.partTarget : z?.averagetargetduration) || I;
      let U;
      $ ? U = a * e : U = o * e;
      const F = I && i >= I * 2 && s === 0 ? B.averageBitrate : B.maxBitrate, V = this.getTimeToLoadFrag(R, U, F * H, z === void 0);
      if (
        // if adjusted bw is greater than level bitrate AND
        U >= F && // no level change, or new level has no error history
        (L === u || B.loadError === 0 && B.fragmentError === 0) && // fragment fetchDuration unknown OR live stream OR fragment fetchDuration less than max allowed fetch duration, then this level matches
        // we don't account for max Fetch Duration for live streams, this is to avoid switching down when near the edge of live sliding window ...
        // special case to support startLevel = -1 (bitrateTest) on live streams : in that case we should not exit loop so that findBestLevel will return -1
        (V <= R || !He(V) || x && !this.bitrateTestDelay || V < c)
      ) {
        const Z = this.forcedAutoLevel;
        return L !== v && (Z === -1 || Z !== v) && (P.length && this.trace(`Skipped level(s) ${P.join(",")} of ${r} max with CODECS and VIDEO-RANGE:"${m[P[0]].codecs}" ${m[P[0]].videoRange}; not compatible with "${w}" ${C}`), this.info(`switch candidate:${d}->${L} adjustedbw(${Math.round(U)})-bitrate=${Math.round(U - F)} ttfb:${R.toFixed(1)} avgDuration:${H.toFixed(1)} maxFetchDuration:${c.toFixed(1)} fetchDuration:${V.toFixed(1)} firstSelection:${E} codecSet:${B.codecSet} videoRange:${B.videoRange} hls.loadLevel:${v}`)), E && (this.firstSelection = L), L;
      }
    }
    return -1;
  }
  set nextAutoLevel(e) {
    const t = this.deriveNextAutoLevel(e);
    this._nextAutoLevel !== t && (this.nextAutoLevelKey = "", this._nextAutoLevel = t);
  }
  deriveNextAutoLevel(e) {
    const {
      maxAutoLevel: t,
      minAutoLevel: r
    } = this.hls;
    return Math.min(Math.max(e, r), t);
  }
}
const Kte = {
  /**
   * Searches for an item in an array which matches a certain condition.
   * This requires the condition to only match one item in the array,
   * and for the array to be ordered.
   *
   * @param list The array to search.
   * @param comparisonFn
   *      Called and provided a candidate item as the first argument.
   *      Should return:
   *          > -1 if the item should be located at a lower index than the provided item.
   *          > 1 if the item should be located at a higher index than the provided item.
   *          > 0 if the item is the item you're looking for.
   *
   * @returns the object if found, otherwise returns null
   */
  search: function(n, e) {
    let t = 0, r = n.length - 1, i = null, s = null;
    for (; t <= r; ) {
      i = (t + r) / 2 | 0, s = n[i];
      const o = e(s);
      if (o > 0)
        t = i + 1;
      else if (o < 0)
        r = i - 1;
      else
        return s;
    }
    return null;
  }
};
function yKe(n, e, t) {
  if (e === null || !Array.isArray(n) || !n.length || !He(e))
    return null;
  const r = n[0].programDateTime;
  if (e < (r || 0))
    return null;
  const i = n[n.length - 1].endProgramDateTime;
  if (e >= (i || 0))
    return null;
  for (let s = 0; s < n.length; ++s) {
    const o = n[s];
    if (wKe(e, t, o))
      return o;
  }
  return null;
}
function Bu(n, e, t = 0, r = 0, i = 5e-3) {
  let s = null;
  if (n) {
    s = e[1 + n.sn - e[0].sn] || null;
    const a = n.endDTS - t;
    a > 0 && a < 15e-7 && (t += 15e-7), s && n.level !== s.level && s.end <= n.end && (s = e[2 + n.sn - e[0].sn] || null);
  } else t === 0 && e[0].start === 0 && (s = e[0]);
  if (s && ((!n || n.level === s.level) && Vz(t, r, s) === 0 || bKe(s, n, Math.min(i, r))))
    return s;
  const o = Kte.search(e, Vz.bind(null, t, r));
  return o && (o !== n || !s) ? o : s;
}
function bKe(n, e, t) {
  if (e && e.start === 0 && e.level < n.level && (e.endPTS || 0) > 0) {
    const r = e.tagList.reduce((i, s) => (s[0] === "INF" && (i += parseFloat(s[1])), i), t);
    return n.start <= r;
  }
  return !1;
}
function Vz(n = 0, e = 0, t) {
  if (t.start <= n && t.start + t.duration > n)
    return 0;
  const r = Math.min(e, t.duration + (t.deltaPTS ? t.deltaPTS : 0));
  return t.start + t.duration - r <= n ? 1 : t.start - r > n && t.start ? -1 : 0;
}
function wKe(n, e, t) {
  const r = Math.min(e, t.duration + (t.deltaPTS ? t.deltaPTS : 0)) * 1e3;
  return (t.endProgramDateTime || 0) - r > n;
}
function qte(n, e, t) {
  if (n && n.startCC <= e && n.endCC >= e) {
    let r = n.fragments;
    const {
      fragmentHint: i
    } = n;
    i && (r = r.concat(i));
    let s;
    return Kte.search(r, (o) => o.cc < e ? 1 : o.cc > e ? -1 : (s = o, o.end <= t ? 1 : o.start > t ? -1 : 0)), s || null;
  }
  return null;
}
function Uy(n) {
  switch (n.details) {
    case ce.FRAG_LOAD_TIMEOUT:
    case ce.KEY_LOAD_TIMEOUT:
    case ce.LEVEL_LOAD_TIMEOUT:
    case ce.MANIFEST_LOAD_TIMEOUT:
      return !0;
  }
  return !1;
}
function Yte(n) {
  return n.details.startsWith("key");
}
function Xte(n) {
  return Yte(n) && !!n.frag && !n.frag.decryptdata;
}
function jz(n, e) {
  const t = Uy(e);
  return n.default[`${t ? "timeout" : "error"}Retry`];
}
function g_(n, e) {
  const t = n.backoff === "linear" ? 1 : Math.pow(2, e);
  return Math.min(t * n.retryDelayMs, n.maxRetryDelayMs);
}
function Wz(n) {
  return cn(cn({}, n), {
    errorRetry: null,
    timeoutRetry: null
  });
}
function Vy(n, e, t, r) {
  if (!n)
    return !1;
  const i = r?.code, s = e < n.maxNumRetry && (xKe(i) || !!t);
  return n.shouldRetry ? n.shouldRetry(n, e, t, r, s) : s;
}
function xKe(n) {
  return w7(n) || !!n && (n < 400 || n > 499);
}
function w7(n) {
  return n === 0 && navigator.onLine === !1;
}
var $r = {
  DoNothing: 0,
  SendAlternateToPenaltyBox: 2,
  RemoveAlternatePermanently: 3,
  RetryRequest: 5
}, rs = {
  None: 0,
  MoveAllAlternatesMatchingHost: 1,
  MoveAllAlternatesMatchingHDCP: 2,
  MoveAllAlternatesMatchingKey: 4
};
class EKe extends Ys {
  constructor(e) {
    super("error-controller", e.logger), this.hls = void 0, this.playlistError = 0, this.hls = e, this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e.on(N.ERROR, this.onError, this), e.on(N.MANIFEST_LOADING, this.onManifestLoading, this), e.on(N.LEVEL_UPDATED, this.onLevelUpdated, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(N.ERROR, this.onError, this), e.off(N.ERROR, this.onErrorOut, this), e.off(N.MANIFEST_LOADING, this.onManifestLoading, this), e.off(N.LEVEL_UPDATED, this.onLevelUpdated, this));
  }
  destroy() {
    this.unregisterListeners(), this.hls = null;
  }
  startLoad(e) {
  }
  stopLoad() {
    this.playlistError = 0;
  }
  getVariantLevelIndex(e) {
    return e?.type === We.MAIN ? e.level : this.getVariantIndex();
  }
  getVariantIndex() {
    var e;
    const t = this.hls, r = t.currentLevel;
    return (e = t.loadLevelObj) != null && e.details || r === -1 ? t.loadLevel : r;
  }
  variantHasKey(e, t) {
    if (e) {
      var r;
      if ((r = e.details) != null && r.hasKey(t))
        return !0;
      const i = e.audioGroups;
      if (i)
        return this.hls.allAudioTracks.filter((o) => i.indexOf(o.groupId) >= 0).some((o) => {
          var a;
          return (a = o.details) == null ? void 0 : a.hasKey(t);
        });
    }
    return !1;
  }
  onManifestLoading() {
    this.playlistError = 0;
  }
  onLevelUpdated() {
    this.playlistError = 0;
  }
  onError(e, t) {
    var r;
    if (t.fatal)
      return;
    const i = this.hls, s = t.context;
    switch (t.details) {
      case ce.FRAG_LOAD_ERROR:
      case ce.FRAG_LOAD_TIMEOUT:
      case ce.KEY_LOAD_ERROR:
      case ce.KEY_LOAD_TIMEOUT:
        t.errorAction = this.getFragRetryOrSwitchAction(t);
        return;
      case ce.FRAG_PARSING_ERROR:
        if ((r = t.frag) != null && r.gap) {
          t.errorAction = df();
          return;
        }
      // falls through
      case ce.FRAG_GAP:
      case ce.FRAG_DECRYPT_ERROR: {
        t.errorAction = this.getFragRetryOrSwitchAction(t), t.errorAction.action = $r.SendAlternateToPenaltyBox;
        return;
      }
      case ce.LEVEL_EMPTY_ERROR:
      case ce.LEVEL_PARSING_ERROR:
        {
          var o;
          const l = t.parent === We.MAIN ? t.level : i.loadLevel;
          t.details === ce.LEVEL_EMPTY_ERROR && ((o = t.context) != null && (o = o.levelDetails) != null && o.live) ? t.errorAction = this.getPlaylistRetryOrSwitchAction(t, l) : (t.levelRetry = !1, t.errorAction = this.getLevelSwitchAction(t, l));
        }
        return;
      case ce.LEVEL_LOAD_ERROR:
      case ce.LEVEL_LOAD_TIMEOUT:
        typeof s?.level == "number" && (t.errorAction = this.getPlaylistRetryOrSwitchAction(t, s.level));
        return;
      case ce.AUDIO_TRACK_LOAD_ERROR:
      case ce.AUDIO_TRACK_LOAD_TIMEOUT:
      case ce.SUBTITLE_LOAD_ERROR:
      case ce.SUBTITLE_TRACK_LOAD_TIMEOUT:
        if (s) {
          const l = i.loadLevelObj;
          if (l && (s.type === Dt.AUDIO_TRACK && l.hasAudioGroup(s.groupId) || s.type === Dt.SUBTITLE_TRACK && l.hasSubtitleGroup(s.groupId))) {
            t.errorAction = this.getPlaylistRetryOrSwitchAction(t, i.loadLevel), t.errorAction.action = $r.SendAlternateToPenaltyBox, t.errorAction.flags = rs.MoveAllAlternatesMatchingHost;
            return;
          }
        }
        return;
      case ce.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED:
        t.errorAction = {
          action: $r.SendAlternateToPenaltyBox,
          flags: rs.MoveAllAlternatesMatchingHDCP
        };
        return;
      case ce.KEY_SYSTEM_SESSION_UPDATE_FAILED:
      case ce.KEY_SYSTEM_STATUS_INTERNAL_ERROR:
      case ce.KEY_SYSTEM_NO_SESSION:
        t.errorAction = {
          action: $r.SendAlternateToPenaltyBox,
          flags: rs.MoveAllAlternatesMatchingKey
        };
        return;
      case ce.BUFFER_ADD_CODEC_ERROR:
      case ce.REMUX_ALLOC_ERROR:
      case ce.BUFFER_APPEND_ERROR:
        if (!t.errorAction) {
          var a;
          t.errorAction = this.getLevelSwitchAction(t, (a = t.level) != null ? a : i.loadLevel);
        }
        return;
      case ce.INTERNAL_EXCEPTION:
      case ce.BUFFER_APPENDING_ERROR:
      case ce.BUFFER_FULL_ERROR:
      case ce.LEVEL_SWITCH_ERROR:
      case ce.BUFFER_STALLED_ERROR:
      case ce.BUFFER_SEEK_OVER_HOLE:
      case ce.BUFFER_NUDGE_ON_STALL:
        t.errorAction = df();
        return;
    }
    t.type === Je.KEY_SYSTEM_ERROR && (t.levelRetry = !1, t.errorAction = df());
  }
  getPlaylistRetryOrSwitchAction(e, t) {
    const r = this.hls, i = jz(r.config.playlistLoadPolicy, e), s = this.playlistError++;
    if (Vy(i, s, Uy(e), e.response))
      return {
        action: $r.RetryRequest,
        flags: rs.None,
        retryConfig: i,
        retryCount: s
      };
    const a = this.getLevelSwitchAction(e, t);
    return i && (a.retryConfig = i, a.retryCount = s), a;
  }
  getFragRetryOrSwitchAction(e) {
    const t = this.hls, r = this.getVariantLevelIndex(e.frag), i = t.levels[r], {
      fragLoadPolicy: s,
      keyLoadPolicy: o
    } = t.config, a = jz(Yte(e) ? o : s, e), l = t.levels.reduce((u, d) => u + d.fragmentError, 0);
    if (i && (e.details !== ce.FRAG_GAP && i.fragmentError++, !Xte(e) && Vy(a, l, Uy(e), e.response)))
      return {
        action: $r.RetryRequest,
        flags: rs.None,
        retryConfig: a,
        retryCount: l
      };
    const c = this.getLevelSwitchAction(e, r);
    return a && (c.retryConfig = a, c.retryCount = l), c;
  }
  getLevelSwitchAction(e, t) {
    const r = this.hls;
    t == null && (t = r.loadLevel);
    const i = this.hls.levels[t];
    if (i) {
      var s, o;
      const c = e.details;
      i.loadError++, c === ce.BUFFER_APPEND_ERROR && i.fragmentError++;
      let u = -1;
      const {
        levels: d,
        loadLevel: f,
        minAutoLevel: h,
        maxAutoLevel: m
      } = r;
      !r.autoLevelEnabled && !r.config.preserveManualLevelOnError && (r.loadLevel = -1);
      const g = (s = e.frag) == null ? void 0 : s.type, y = (g === We.AUDIO && c === ce.FRAG_PARSING_ERROR || e.sourceBufferName === "audio" && (c === ce.BUFFER_ADD_CODEC_ERROR || c === ce.BUFFER_APPEND_ERROR)) && d.some(({
        audioCodec: C
      }) => i.audioCodec !== C), x = e.sourceBufferName === "video" && (c === ce.BUFFER_ADD_CODEC_ERROR || c === ce.BUFFER_APPEND_ERROR) && d.some(({
        codecSet: C,
        audioCodec: S
      }) => i.codecSet !== C && i.audioCodec === S), {
        type: E,
        groupId: w
      } = (o = e.context) != null ? o : {};
      for (let C = d.length; C--; ) {
        const S = (C + f) % d.length;
        if (S !== f && S >= h && S <= m && d[S].loadError === 0) {
          var a, l;
          const M = d[S];
          if (c === ce.FRAG_GAP && g === We.MAIN && e.frag) {
            const k = d[S].details;
            if (k) {
              const _ = Bu(e.frag, k.fragments, e.frag.start);
              if (_ != null && _.gap)
                continue;
            }
          } else {
            if (E === Dt.AUDIO_TRACK && M.hasAudioGroup(w) || E === Dt.SUBTITLE_TRACK && M.hasSubtitleGroup(w))
              continue;
            if (g === We.AUDIO && (a = i.audioGroups) != null && a.some((k) => M.hasAudioGroup(k)) || g === We.SUBTITLE && (l = i.subtitleGroups) != null && l.some((k) => M.hasSubtitleGroup(k)) || y && i.audioCodec === M.audioCodec || x && i.codecSet === M.codecSet || !y && i.codecSet !== M.codecSet)
              continue;
          }
          u = S;
          break;
        }
      }
      if (u > -1 && r.loadLevel !== u)
        return e.levelRetry = !0, this.playlistError = 0, {
          action: $r.SendAlternateToPenaltyBox,
          flags: rs.None,
          nextAutoLevel: u
        };
    }
    return {
      action: $r.SendAlternateToPenaltyBox,
      flags: rs.MoveAllAlternatesMatchingHost
    };
  }
  onErrorOut(e, t) {
    var r;
    switch ((r = t.errorAction) == null ? void 0 : r.action) {
      case $r.DoNothing:
        break;
      case $r.SendAlternateToPenaltyBox:
        this.sendAlternateToPenaltyBox(t), !t.errorAction.resolved && t.details !== ce.FRAG_GAP ? t.fatal = !0 : /MediaSource readyState: ended/.test(t.error.message) && (this.warn(`MediaSource ended after "${t.sourceBufferName}" sourceBuffer append error. Attempting to recover from media error.`), this.hls.recoverMediaError());
        break;
    }
    if (t.fatal) {
      this.hls.stopLoad();
      return;
    }
  }
  sendAlternateToPenaltyBox(e) {
    const t = this.hls, r = e.errorAction;
    if (!r)
      return;
    const {
      flags: i
    } = r, s = r.nextAutoLevel;
    switch (i) {
      case rs.None:
        this.switchLevel(e, s);
        break;
      case rs.MoveAllAlternatesMatchingHDCP: {
        const l = this.getVariantLevelIndex(e.frag), c = t.levels[l], u = c?.attrs["HDCP-LEVEL"];
        if (r.hdcpLevel = u, u === "NONE")
          this.warn("HDCP policy resticted output with HDCP-LEVEL=NONE");
        else if (u) {
          t.maxHdcpLevel = b7[b7.indexOf(u) - 1], r.resolved = !0, this.warn(`Restricting playback to HDCP-LEVEL of "${t.maxHdcpLevel}" or lower`);
          break;
        }
      }
      // eslint-disable-next-line no-fallthrough
      case rs.MoveAllAlternatesMatchingKey: {
        const l = e.decryptdata;
        if (l) {
          const c = this.hls.levels, u = c.length;
          for (let f = u; f--; )
            if (this.variantHasKey(c[f], l)) {
              var o, a;
              this.log(`Banned key found in level ${f} (${c[f].bitrate}bps) or audio group "${(o = c[f].audioGroups) == null ? void 0 : o.join(",")}" (${(a = e.frag) == null ? void 0 : a.type} fragment) ${Br(l.keyId || [])}`), c[f].fragmentError++, c[f].loadError++, this.log(`Removing level ${f} with key error (${e.error})`), this.hls.removeLevel(f);
            }
          const d = e.frag;
          if (this.hls.levels.length < u)
            r.resolved = !0;
          else if (d && d.type !== We.MAIN) {
            const f = d.decryptdata;
            f && !l.matches(f) && (r.resolved = !0);
          }
        }
        break;
      }
    }
    r.resolved || this.switchLevel(e, s);
  }
  switchLevel(e, t) {
    if (t !== void 0 && e.errorAction && (this.warn(`switching to level ${t} after ${e.details}`), this.hls.nextAutoLevel = t, e.errorAction.resolved = !0, this.hls.nextLoadLevel = this.hls.nextAutoLevel, e.details === ce.BUFFER_ADD_CODEC_ERROR && e.mimeType && e.sourceBufferName !== "audiovideo")) {
      const r = y7(e.mimeType), i = this.hls.levels;
      for (let s = i.length; s--; )
        i[s][`${e.sourceBufferName}Codec`] === r && (this.log(`Removing level ${s} for ${e.details} ("${r}" not supported)`), this.hls.removeLevel(s));
    }
  }
}
function df(n) {
  const e = {
    action: $r.DoNothing,
    flags: rs.None
  };
  return n && (e.resolved = !0), e;
}
var wr = {
  NOT_LOADED: "NOT_LOADED",
  APPENDING: "APPENDING",
  PARTIAL: "PARTIAL",
  OK: "OK"
};
class SKe {
  constructor(e) {
    this.activePartLists = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.fragments = /* @__PURE__ */ Object.create(null), this.timeRanges = /* @__PURE__ */ Object.create(null), this.bufferPadding = 0.2, this.hls = void 0, this.hasGaps = !1, this.hls = e, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e && (e.on(N.MANIFEST_LOADING, this.onManifestLoading, this), e.on(N.BUFFER_APPENDED, this.onBufferAppended, this), e.on(N.FRAG_BUFFERED, this.onFragBuffered, this), e.on(N.FRAG_LOADED, this.onFragLoaded, this));
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e && (e.off(N.MANIFEST_LOADING, this.onManifestLoading, this), e.off(N.BUFFER_APPENDED, this.onBufferAppended, this), e.off(N.FRAG_BUFFERED, this.onFragBuffered, this), e.off(N.FRAG_LOADED, this.onFragLoaded, this));
  }
  destroy() {
    this._unregisterListeners(), this.hls = // @ts-ignore
    this.fragments = // @ts-ignore
    this.activePartLists = // @ts-ignore
    this.endListFragments = this.timeRanges = null;
  }
  /**
   * Return a Fragment or Part with an appended range that matches the position and levelType
   * Otherwise, return null
   */
  getAppendedFrag(e, t) {
    const r = this.activePartLists[t];
    if (r)
      for (let i = r.length; i--; ) {
        const s = r[i];
        if (!s)
          break;
        if (s.start <= e && e <= s.end && s.loaded)
          return s;
      }
    return this.getBufferedFrag(e, t);
  }
  /**
   * Return a buffered Fragment that matches the position and levelType.
   * A buffered Fragment is one whose loading, parsing and appending is done (completed or "partial" meaning aborted).
   * If not found any Fragment, return null
   */
  getBufferedFrag(e, t) {
    return this.getFragAtPos(e, t, !0);
  }
  getFragAtPos(e, t, r) {
    const {
      fragments: i
    } = this, s = Object.keys(i);
    for (let o = s.length; o--; ) {
      const a = i[s[o]];
      if (a?.body.type === t && (!r || a.buffered)) {
        const l = a.body;
        if (l.start <= e && e <= l.end)
          return l;
      }
    }
    return null;
  }
  /**
   * Partial fragments effected by coded frame eviction will be removed
   * The browser will unload parts of the buffer to free up memory for new buffer data
   * Fragments will need to be reloaded when the buffer is freed up, removing partial fragments will allow them to reload(since there might be parts that are still playable)
   */
  detectEvictedFragments(e, t, r, i, s) {
    this.timeRanges && (this.timeRanges[e] = t);
    const o = i?.fragment.sn || -1;
    Object.keys(this.fragments).forEach((a) => {
      const l = this.fragments[a];
      if (!l || o >= l.body.sn)
        return;
      if (!l.buffered && (!l.loaded || s)) {
        l.body.type === r && this.removeFragment(l.body);
        return;
      }
      const c = l.range[e];
      if (c) {
        if (c.time.length === 0) {
          this.removeFragment(l.body);
          return;
        }
        c.time.some((u) => {
          const d = !this.isTimeBuffered(u.startPTS, u.endPTS, t);
          return d && this.removeFragment(l.body), d;
        });
      }
    });
  }
  /**
   * Checks if the fragment passed in is loaded in the buffer properly
   * Partially loaded fragments will be registered as a partial fragment
   */
  detectPartialFragments(e) {
    const t = this.timeRanges;
    if (!t || e.frag.sn === "initSegment")
      return;
    const r = e.frag, i = Td(r), s = this.fragments[i];
    if (!s || s.buffered && r.gap)
      return;
    const o = !r.relurl;
    Object.keys(t).forEach((a) => {
      const l = r.elementaryStreams[a];
      if (!l)
        return;
      const c = t[a], u = o || l.partial === !0;
      s.range[a] = this.getBufferedTimes(r, e.part, u, c);
    }), s.loaded = null, Object.keys(s.range).length ? (this.bufferedEnd(s, r), Pg(s) || this.removeParts(r.sn - 1, r.type)) : this.removeFragment(s.body);
  }
  bufferedEnd(e, t) {
    e.buffered = !0, (e.body.endList = t.endList || e.body.endList) && (this.endListFragments[e.body.type] = e);
  }
  removeParts(e, t) {
    const r = this.activePartLists[t];
    r && (this.activePartLists[t] = Gz(r, (i) => i.fragment.sn >= e));
  }
  fragBuffered(e, t) {
    const r = Td(e);
    let i = this.fragments[r];
    !i && t && (i = this.fragments[r] = {
      body: e,
      appendedPTS: null,
      loaded: null,
      buffered: !1,
      range: /* @__PURE__ */ Object.create(null)
    }, e.gap && (this.hasGaps = !0)), i && (i.loaded = null, this.bufferedEnd(i, e));
  }
  getBufferedTimes(e, t, r, i) {
    const s = {
      time: [],
      partial: r
    }, o = e.start, a = e.end, l = e.minEndPTS || a, c = e.maxStartPTS || o;
    for (let u = 0; u < i.length; u++) {
      const d = i.start(u) - this.bufferPadding, f = i.end(u) + this.bufferPadding;
      if (c >= d && l <= f) {
        s.time.push({
          startPTS: Math.max(o, i.start(u)),
          endPTS: Math.min(a, i.end(u))
        });
        break;
      } else if (o < f && a > d) {
        const h = Math.max(o, i.start(u)), m = Math.min(a, i.end(u));
        m > h && (s.partial = !0, s.time.push({
          startPTS: h,
          endPTS: m
        }));
      } else if (a <= d)
        break;
    }
    return s;
  }
  /**
   * Gets the partial fragment for a certain time
   */
  getPartialFragment(e) {
    let t = null, r, i, s, o = 0;
    const {
      bufferPadding: a,
      fragments: l
    } = this;
    return Object.keys(l).forEach((c) => {
      const u = l[c];
      u && Pg(u) && (i = u.body.start - a, s = u.body.end + a, e >= i && e <= s && (r = Math.min(e - i, s - e), o <= r && (t = u.body, o = r)));
    }), t;
  }
  isEndListAppended(e) {
    const t = this.endListFragments[e];
    return t !== void 0 && (t.buffered || Pg(t));
  }
  getState(e) {
    const t = Td(e), r = this.fragments[t];
    return r ? r.buffered ? Pg(r) ? wr.PARTIAL : wr.OK : wr.APPENDING : wr.NOT_LOADED;
  }
  isTimeBuffered(e, t, r) {
    let i, s;
    for (let o = 0; o < r.length; o++) {
      if (i = r.start(o) - this.bufferPadding, s = r.end(o) + this.bufferPadding, e >= i && t <= s)
        return !0;
      if (t <= i)
        return !1;
    }
    return !1;
  }
  onManifestLoading() {
    this.removeAllFragments();
  }
  onFragLoaded(e, t) {
    if (t.frag.sn === "initSegment" || t.frag.bitrateTest)
      return;
    const r = t.frag, i = t.part ? null : t, s = Td(r);
    this.fragments[s] = {
      body: r,
      appendedPTS: null,
      loaded: i,
      buffered: !1,
      range: /* @__PURE__ */ Object.create(null)
    };
  }
  onBufferAppended(e, t) {
    const {
      frag: r,
      part: i,
      timeRanges: s,
      type: o
    } = t;
    if (r.sn === "initSegment")
      return;
    const a = r.type;
    if (i) {
      let c = this.activePartLists[a];
      c || (this.activePartLists[a] = c = []), c.push(i);
    }
    this.timeRanges = s;
    const l = s[o];
    this.detectEvictedFragments(o, l, a, i);
  }
  onFragBuffered(e, t) {
    this.detectPartialFragments(t);
  }
  hasFragment(e) {
    const t = Td(e);
    return !!this.fragments[t];
  }
  hasFragments(e) {
    const {
      fragments: t
    } = this, r = Object.keys(t);
    if (!e)
      return r.length > 0;
    for (let i = r.length; i--; ) {
      const s = t[r[i]];
      if (s?.body.type === e)
        return !0;
    }
    return !1;
  }
  hasParts(e) {
    var t;
    return !!((t = this.activePartLists[e]) != null && t.length);
  }
  removeFragmentsInRange(e, t, r, i, s) {
    i && !this.hasGaps || Object.keys(this.fragments).forEach((o) => {
      const a = this.fragments[o];
      if (!a)
        return;
      const l = a.body;
      l.type !== r || i && !l.gap || l.start < t && l.end > e && (a.buffered || s) && this.removeFragment(l);
    });
  }
  removeFragment(e) {
    const t = Td(e);
    e.clearElementaryStreamInfo();
    const r = this.activePartLists[e.type];
    if (r) {
      const i = e.sn;
      this.activePartLists[e.type] = Gz(r, (s) => s.fragment.sn !== i);
    }
    delete this.fragments[t], e.endList && delete this.endListFragments[e.type];
  }
  removeAllFragments() {
    var e;
    this.fragments = /* @__PURE__ */ Object.create(null), this.endListFragments = /* @__PURE__ */ Object.create(null), this.activePartLists = /* @__PURE__ */ Object.create(null), this.hasGaps = !1;
    const t = (e = this.hls) == null || (e = e.latestLevelDetails) == null ? void 0 : e.partList;
    t && t.forEach((r) => r.clearElementaryStreamInfo());
  }
}
function Pg(n) {
  var e, t, r;
  return n.buffered && !!(n.body.gap || (e = n.range.video) != null && e.partial || (t = n.range.audio) != null && t.partial || (r = n.range.audiovideo) != null && r.partial);
}
function Td(n) {
  return `${n.type}_${n.level}_${n.sn}`;
}
function Gz(n, e) {
  return n.filter((t) => {
    const r = e(t);
    return r || t.clearElementaryStreamInfo(), r;
  });
}
var vc = {
  cbc: 0,
  ctr: 1
};
class CKe {
  constructor(e, t, r) {
    this.subtle = void 0, this.aesIV = void 0, this.aesMode = void 0, this.subtle = e, this.aesIV = t, this.aesMode = r;
  }
  decrypt(e, t) {
    switch (this.aesMode) {
      case vc.cbc:
        return this.subtle.decrypt({
          name: "AES-CBC",
          iv: this.aesIV
        }, t, e);
      case vc.ctr:
        return this.subtle.decrypt(
          {
            name: "AES-CTR",
            counter: this.aesIV,
            length: 64
          },
          //64 : NIST SP800-38A standard suggests that the counter should occupy half of the counter block
          t,
          e
        );
      default:
        throw new Error(`[AESCrypto] invalid aes mode ${this.aesMode}`);
    }
  }
}
function TKe(n) {
  const e = n.byteLength, t = e && new DataView(n.buffer).getUint8(e - 1);
  return t ? n.slice(0, e - t) : n;
}
class AKe {
  constructor() {
    this.rcon = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], this.subMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.invSubMix = [new Uint32Array(256), new Uint32Array(256), new Uint32Array(256), new Uint32Array(256)], this.sBox = new Uint32Array(256), this.invSBox = new Uint32Array(256), this.key = new Uint32Array(0), this.ksRows = 0, this.keySize = 0, this.keySchedule = void 0, this.invKeySchedule = void 0, this.initTable();
  }
  // Using view.getUint32() also swaps the byte order.
  uint8ArrayToUint32Array_(e) {
    const t = new DataView(e), r = new Uint32Array(4);
    for (let i = 0; i < 4; i++)
      r[i] = t.getUint32(i * 4);
    return r;
  }
  initTable() {
    const e = this.sBox, t = this.invSBox, r = this.subMix, i = r[0], s = r[1], o = r[2], a = r[3], l = this.invSubMix, c = l[0], u = l[1], d = l[2], f = l[3], h = new Uint32Array(256);
    let m = 0, g = 0, v = 0;
    for (v = 0; v < 256; v++)
      v < 128 ? h[v] = v << 1 : h[v] = v << 1 ^ 283;
    for (v = 0; v < 256; v++) {
      let y = g ^ g << 1 ^ g << 2 ^ g << 3 ^ g << 4;
      y = y >>> 8 ^ y & 255 ^ 99, e[m] = y, t[y] = m;
      const b = h[m], x = h[b], E = h[x];
      let w = h[y] * 257 ^ y * 16843008;
      i[m] = w << 24 | w >>> 8, s[m] = w << 16 | w >>> 16, o[m] = w << 8 | w >>> 24, a[m] = w, w = E * 16843009 ^ x * 65537 ^ b * 257 ^ m * 16843008, c[y] = w << 24 | w >>> 8, u[y] = w << 16 | w >>> 16, d[y] = w << 8 | w >>> 24, f[y] = w, m ? (m = b ^ h[h[h[E ^ b]]], g ^= h[h[g]]) : m = g = 1;
    }
  }
  expandKey(e) {
    const t = this.uint8ArrayToUint32Array_(e);
    let r = !0, i = 0;
    for (; i < t.length && r; )
      r = t[i] === this.key[i], i++;
    if (r)
      return;
    this.key = t;
    const s = this.keySize = t.length;
    if (s !== 4 && s !== 6 && s !== 8)
      throw new Error("Invalid aes key size=" + s);
    const o = this.ksRows = (s + 6 + 1) * 4;
    let a, l;
    const c = this.keySchedule = new Uint32Array(o), u = this.invKeySchedule = new Uint32Array(o), d = this.sBox, f = this.rcon, h = this.invSubMix, m = h[0], g = h[1], v = h[2], y = h[3];
    let b, x;
    for (a = 0; a < o; a++) {
      if (a < s) {
        b = c[a] = t[a];
        continue;
      }
      x = b, a % s === 0 ? (x = x << 8 | x >>> 24, x = d[x >>> 24] << 24 | d[x >>> 16 & 255] << 16 | d[x >>> 8 & 255] << 8 | d[x & 255], x ^= f[a / s | 0] << 24) : s > 6 && a % s === 4 && (x = d[x >>> 24] << 24 | d[x >>> 16 & 255] << 16 | d[x >>> 8 & 255] << 8 | d[x & 255]), c[a] = b = (c[a - s] ^ x) >>> 0;
    }
    for (l = 0; l < o; l++)
      a = o - l, l & 3 ? x = c[a] : x = c[a - 4], l < 4 || a <= 4 ? u[l] = x : u[l] = m[d[x >>> 24]] ^ g[d[x >>> 16 & 255]] ^ v[d[x >>> 8 & 255]] ^ y[d[x & 255]], u[l] = u[l] >>> 0;
  }
  // Adding this as a method greatly improves performance.
  networkToHostOrderSwap(e) {
    return e << 24 | (e & 65280) << 8 | (e & 16711680) >> 8 | e >>> 24;
  }
  decrypt(e, t, r) {
    const i = this.keySize + 6, s = this.invKeySchedule, o = this.invSBox, a = this.invSubMix, l = a[0], c = a[1], u = a[2], d = a[3], f = this.uint8ArrayToUint32Array_(r);
    let h = f[0], m = f[1], g = f[2], v = f[3];
    const y = new Int32Array(e), b = new Int32Array(y.length);
    let x, E, w, C, S, M, k, _, O, I, R, P, D, L;
    const B = this.networkToHostOrderSwap;
    for (; t < y.length; ) {
      for (O = B(y[t]), I = B(y[t + 1]), R = B(y[t + 2]), P = B(y[t + 3]), S = O ^ s[0], M = P ^ s[1], k = R ^ s[2], _ = I ^ s[3], D = 4, L = 1; L < i; L++)
        x = l[S >>> 24] ^ c[M >> 16 & 255] ^ u[k >> 8 & 255] ^ d[_ & 255] ^ s[D], E = l[M >>> 24] ^ c[k >> 16 & 255] ^ u[_ >> 8 & 255] ^ d[S & 255] ^ s[D + 1], w = l[k >>> 24] ^ c[_ >> 16 & 255] ^ u[S >> 8 & 255] ^ d[M & 255] ^ s[D + 2], C = l[_ >>> 24] ^ c[S >> 16 & 255] ^ u[M >> 8 & 255] ^ d[k & 255] ^ s[D + 3], S = x, M = E, k = w, _ = C, D = D + 4;
      x = o[S >>> 24] << 24 ^ o[M >> 16 & 255] << 16 ^ o[k >> 8 & 255] << 8 ^ o[_ & 255] ^ s[D], E = o[M >>> 24] << 24 ^ o[k >> 16 & 255] << 16 ^ o[_ >> 8 & 255] << 8 ^ o[S & 255] ^ s[D + 1], w = o[k >>> 24] << 24 ^ o[_ >> 16 & 255] << 16 ^ o[S >> 8 & 255] << 8 ^ o[M & 255] ^ s[D + 2], C = o[_ >>> 24] << 24 ^ o[S >> 16 & 255] << 16 ^ o[M >> 8 & 255] << 8 ^ o[k & 255] ^ s[D + 3], b[t] = B(x ^ h), b[t + 1] = B(C ^ m), b[t + 2] = B(w ^ g), b[t + 3] = B(E ^ v), h = O, m = I, g = R, v = P, t = t + 4;
    }
    return b.buffer;
  }
}
class MKe {
  constructor(e, t, r) {
    this.subtle = void 0, this.key = void 0, this.aesMode = void 0, this.subtle = e, this.key = t, this.aesMode = r;
  }
  expandKey() {
    const e = kKe(this.aesMode);
    return this.subtle.importKey("raw", this.key, {
      name: e
    }, !1, ["encrypt", "decrypt"]);
  }
}
function kKe(n) {
  switch (n) {
    case vc.cbc:
      return "AES-CBC";
    case vc.ctr:
      return "AES-CTR";
    default:
      throw new Error(`[FastAESKey] invalid aes mode ${n}`);
  }
}
const _Ke = 16;
class v_ {
  constructor(e, {
    removePKCS7Padding: t = !0
  } = {}) {
    if (this.logEnabled = !0, this.removePKCS7Padding = void 0, this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null, this.useSoftware = void 0, this.enableSoftwareAES = void 0, this.enableSoftwareAES = e.enableSoftwareAES, this.removePKCS7Padding = t, t)
      try {
        const r = self.crypto;
        r && (this.subtle = r.subtle || r.webkitSubtle);
      } catch {
      }
    this.useSoftware = !this.subtle;
  }
  destroy() {
    this.subtle = null, this.softwareDecrypter = null, this.key = null, this.fastAesKey = null, this.remainderData = null, this.currentIV = null, this.currentResult = null;
  }
  isSync() {
    return this.useSoftware;
  }
  flush() {
    const {
      currentResult: e,
      remainderData: t
    } = this;
    if (!e || t)
      return this.reset(), null;
    const r = new Uint8Array(e);
    return this.reset(), this.removePKCS7Padding ? TKe(r) : r;
  }
  reset() {
    this.currentResult = null, this.currentIV = null, this.remainderData = null, this.softwareDecrypter && (this.softwareDecrypter = null);
  }
  decrypt(e, t, r, i) {
    return this.useSoftware ? new Promise((s, o) => {
      const a = ArrayBuffer.isView(e) ? e : new Uint8Array(e);
      this.softwareDecrypt(a, t, r, i);
      const l = this.flush();
      l ? s(l.buffer) : o(new Error("[softwareDecrypt] Failed to decrypt data"));
    }) : this.webCryptoDecrypt(new Uint8Array(e), t, r, i);
  }
  // Software decryption is progressive. Progressive decryption may not return a result on each call. Any cached
  // data is handled in the flush() call
  softwareDecrypt(e, t, r, i) {
    const {
      currentIV: s,
      currentResult: o,
      remainderData: a
    } = this;
    if (i !== vc.cbc || t.byteLength !== 16)
      return un.warn("SoftwareDecrypt: can only handle AES-128-CBC"), null;
    this.logOnce("JS AES decrypt"), a && (e = Vs(a, e), this.remainderData = null);
    const l = this.getValidChunk(e);
    if (!l.length)
      return null;
    s && (r = s);
    let c = this.softwareDecrypter;
    c || (c = this.softwareDecrypter = new AKe()), c.expandKey(t);
    const u = o;
    return this.currentResult = c.decrypt(l.buffer, 0, r), this.currentIV = l.slice(-16).buffer, u || null;
  }
  webCryptoDecrypt(e, t, r, i) {
    if (this.key !== t || !this.fastAesKey) {
      if (!this.subtle)
        return Promise.resolve(this.onWebCryptoError(e, t, r, i));
      this.key = t, this.fastAesKey = new MKe(this.subtle, t, i);
    }
    return this.fastAesKey.expandKey().then((s) => this.subtle ? (this.logOnce("WebCrypto AES decrypt"), new CKe(this.subtle, new Uint8Array(r), i).decrypt(e.buffer, s)) : Promise.reject(new Error("web crypto not initialized"))).catch((s) => (un.warn(`[decrypter]: WebCrypto Error, disable WebCrypto API, ${s.name}: ${s.message}`), this.onWebCryptoError(e, t, r, i)));
  }
  onWebCryptoError(e, t, r, i) {
    const s = this.enableSoftwareAES;
    if (s) {
      this.useSoftware = !0, this.logEnabled = !0, this.softwareDecrypt(e, t, r, i);
      const o = this.flush();
      if (o)
        return o.buffer;
    }
    throw new Error("WebCrypto" + (s ? " and softwareDecrypt" : "") + ": failed to decrypt data");
  }
  getValidChunk(e) {
    let t = e;
    const r = e.length - e.length % _Ke;
    return r !== e.length && (t = e.slice(0, r), this.remainderData = e.slice(r)), t;
  }
  logOnce(e) {
    this.logEnabled && (un.log(`[decrypter]: ${e}`), this.logEnabled = !1);
  }
}
const Kz = Math.pow(2, 17);
class OKe {
  constructor(e) {
    this.config = void 0, this.loader = null, this.partLoadTimeout = -1, this.config = e;
  }
  destroy() {
    this.loader && (this.loader.destroy(), this.loader = null);
  }
  abort() {
    this.loader && this.loader.abort();
  }
  load(e, t) {
    const r = e.url;
    if (!r)
      return Promise.reject(new za({
        type: Je.NETWORK_ERROR,
        details: ce.FRAG_LOAD_ERROR,
        fatal: !1,
        frag: e,
        error: new Error(`Fragment does not have a ${r ? "part list" : "url"}`),
        networkDetails: null
      }));
    this.abort();
    const i = this.config, s = i.fLoader, o = i.loader;
    return new Promise((a, l) => {
      if (this.loader && this.loader.destroy(), e.gap)
        if (e.tagList.some((m) => m[0] === "GAP")) {
          l(Yz(e));
          return;
        } else
          e.gap = !1;
      const c = this.loader = s ? new s(i) : new o(i), u = qz(e);
      e.loader = c;
      const d = Wz(i.fragLoadPolicy.default), f = {
        loadPolicy: d,
        timeout: d.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: e.sn === "initSegment" ? 1 / 0 : Kz
      };
      e.stats = c.stats;
      const h = {
        onSuccess: (m, g, v, y) => {
          this.resetLoader(e, c);
          let b = m.data;
          v.resetIV && e.decryptdata && (e.decryptdata.iv = new Uint8Array(b.slice(0, 16)), b = b.slice(16)), a({
            frag: e,
            part: null,
            payload: b,
            networkDetails: y
          });
        },
        onError: (m, g, v, y) => {
          this.resetLoader(e, c), l(new za({
            type: Je.NETWORK_ERROR,
            details: ce.FRAG_LOAD_ERROR,
            fatal: !1,
            frag: e,
            response: cn({
              url: r,
              data: void 0
            }, m),
            error: new Error(`HTTP Error ${m.code} ${m.text}`),
            networkDetails: v,
            stats: y
          }));
        },
        onAbort: (m, g, v) => {
          this.resetLoader(e, c), l(new za({
            type: Je.NETWORK_ERROR,
            details: ce.INTERNAL_ABORTED,
            fatal: !1,
            frag: e,
            error: new Error("Aborted"),
            networkDetails: v,
            stats: m
          }));
        },
        onTimeout: (m, g, v) => {
          this.resetLoader(e, c), l(new za({
            type: Je.NETWORK_ERROR,
            details: ce.FRAG_LOAD_TIMEOUT,
            fatal: !1,
            frag: e,
            error: new Error(`Timeout after ${f.timeout}ms`),
            networkDetails: v,
            stats: m
          }));
        }
      };
      t && (h.onProgress = (m, g, v, y) => t({
        frag: e,
        part: null,
        payload: v,
        networkDetails: y
      })), c.load(u, f, h);
    });
  }
  loadPart(e, t, r) {
    this.abort();
    const i = this.config, s = i.fLoader, o = i.loader;
    return new Promise((a, l) => {
      if (this.loader && this.loader.destroy(), e.gap || t.gap) {
        l(Yz(e, t));
        return;
      }
      const c = this.loader = s ? new s(i) : new o(i), u = qz(e, t);
      e.loader = c;
      const d = Wz(i.fragLoadPolicy.default), f = {
        loadPolicy: d,
        timeout: d.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0,
        highWaterMark: Kz
      };
      t.stats = c.stats, c.load(u, f, {
        onSuccess: (h, m, g, v) => {
          this.resetLoader(e, c), this.updateStatsFromPart(e, t);
          const y = {
            frag: e,
            part: t,
            payload: h.data,
            networkDetails: v
          };
          r(y), a(y);
        },
        onError: (h, m, g, v) => {
          this.resetLoader(e, c), l(new za({
            type: Je.NETWORK_ERROR,
            details: ce.FRAG_LOAD_ERROR,
            fatal: !1,
            frag: e,
            part: t,
            response: cn({
              url: u.url,
              data: void 0
            }, h),
            error: new Error(`HTTP Error ${h.code} ${h.text}`),
            networkDetails: g,
            stats: v
          }));
        },
        onAbort: (h, m, g) => {
          e.stats.aborted = t.stats.aborted, this.resetLoader(e, c), l(new za({
            type: Je.NETWORK_ERROR,
            details: ce.INTERNAL_ABORTED,
            fatal: !1,
            frag: e,
            part: t,
            error: new Error("Aborted"),
            networkDetails: g,
            stats: h
          }));
        },
        onTimeout: (h, m, g) => {
          this.resetLoader(e, c), l(new za({
            type: Je.NETWORK_ERROR,
            details: ce.FRAG_LOAD_TIMEOUT,
            fatal: !1,
            frag: e,
            part: t,
            error: new Error(`Timeout after ${f.timeout}ms`),
            networkDetails: g,
            stats: h
          }));
        }
      });
    });
  }
  updateStatsFromPart(e, t) {
    const r = e.stats, i = t.stats, s = i.total;
    if (r.loaded += i.loaded, s) {
      const l = Math.round(e.duration / t.duration), c = Math.min(Math.round(r.loaded / s), l), d = (l - c) * Math.round(r.loaded / c);
      r.total = r.loaded + d;
    } else
      r.total = Math.max(r.loaded, r.total);
    const o = r.loading, a = i.loading;
    o.start ? o.first += a.first - a.start : (o.start = a.start, o.first = a.first), o.end = a.end;
  }
  resetLoader(e, t) {
    e.loader = null, this.loader === t && (self.clearTimeout(this.partLoadTimeout), this.loader = null), t.destroy();
  }
}
function qz(n, e = null) {
  const t = e || n, r = {
    frag: n,
    part: e,
    responseType: "arraybuffer",
    url: t.url,
    headers: {},
    rangeStart: 0,
    rangeEnd: 0
  }, i = t.byteRangeStartOffset, s = t.byteRangeEndOffset;
  if (He(i) && He(s)) {
    var o;
    let a = i, l = s;
    if (n.sn === "initSegment" && IKe((o = n.decryptdata) == null ? void 0 : o.method)) {
      const c = s - i;
      c % 16 && (l = s + (16 - c % 16)), i !== 0 && (r.resetIV = !0, a = i - 16);
    }
    r.rangeStart = a, r.rangeEnd = l;
  }
  return r;
}
function Yz(n, e) {
  const t = new Error(`GAP ${n.gap ? "tag" : "attribute"} found`), r = {
    type: Je.MEDIA_ERROR,
    details: ce.FRAG_GAP,
    fatal: !1,
    frag: n,
    error: t,
    networkDetails: null
  };
  return e && (r.part = e), (e || n).stats.aborted = !0, new za(r);
}
function IKe(n) {
  return n === "AES-128" || n === "AES-256";
}
class za extends Error {
  constructor(e) {
    super(e.error.message), this.data = void 0, this.data = e;
  }
}
class Zte extends Ys {
  constructor(e, t) {
    super(e, t), this._boundTick = void 0, this._tickTimer = null, this._tickInterval = null, this._tickCallCount = 0, this._boundTick = this.tick.bind(this);
  }
  destroy() {
    this.onHandlerDestroying(), this.onHandlerDestroyed();
  }
  onHandlerDestroying() {
    this.clearNextTick(), this.clearInterval();
  }
  onHandlerDestroyed() {
  }
  hasInterval() {
    return !!this._tickInterval;
  }
  hasNextTick() {
    return !!this._tickTimer;
  }
  /**
   * @param millis - Interval time (ms)
   * @eturns True when interval has been scheduled, false when already scheduled (no effect)
   */
  setInterval(e) {
    return this._tickInterval ? !1 : (this._tickCallCount = 0, this._tickInterval = self.setInterval(this._boundTick, e), !0);
  }
  /**
   * @returns True when interval was cleared, false when none was set (no effect)
   */
  clearInterval() {
    return this._tickInterval ? (self.clearInterval(this._tickInterval), this._tickInterval = null, !0) : !1;
  }
  /**
   * @returns True when timeout was cleared, false when none was set (no effect)
   */
  clearNextTick() {
    return this._tickTimer ? (self.clearTimeout(this._tickTimer), this._tickTimer = null, !0) : !1;
  }
  /**
   * Will call the subclass doTick implementation in this main loop tick
   * or in the next one (via setTimeout(,0)) in case it has already been called
   * in this tick (in case this is a re-entrant call).
   */
  tick() {
    this._tickCallCount++, this._tickCallCount === 1 && (this.doTick(), this._tickCallCount > 1 && this.tickImmediate(), this._tickCallCount = 0);
  }
  tickImmediate() {
    this.clearNextTick(), this._tickTimer = self.setTimeout(this._boundTick, 0);
  }
  /**
   * For subclass to implement task logic
   * @abstract
   */
  doTick() {
  }
}
class y_ {
  constructor(e, t, r, i = 0, s = -1, o = !1) {
    this.level = void 0, this.sn = void 0, this.part = void 0, this.id = void 0, this.size = void 0, this.partial = void 0, this.transmuxing = Dg(), this.buffering = {
      audio: Dg(),
      video: Dg(),
      audiovideo: Dg()
    }, this.level = e, this.sn = t, this.id = r, this.size = i, this.part = s, this.partial = o;
  }
}
function Dg() {
  return {
    start: 0,
    executeStart: 0,
    executeEnd: 0,
    end: 0
  };
}
const Xz = {
  length: 0,
  start: () => 0,
  end: () => 0
};
class St {
  /**
   * Return true if `media`'s buffered include `position`
   */
  static isBuffered(e, t) {
    if (e) {
      const r = St.getBuffered(e);
      for (let i = r.length; i--; )
        if (t >= r.start(i) && t <= r.end(i))
          return !0;
    }
    return !1;
  }
  static bufferedRanges(e) {
    if (e) {
      const t = St.getBuffered(e);
      return St.timeRangesToArray(t);
    }
    return [];
  }
  static timeRangesToArray(e) {
    const t = [];
    for (let r = 0; r < e.length; r++)
      t.push({
        start: e.start(r),
        end: e.end(r)
      });
    return t;
  }
  static bufferInfo(e, t, r) {
    if (e) {
      const i = St.bufferedRanges(e);
      if (i.length)
        return St.bufferedInfo(i, t, r);
    }
    return {
      len: 0,
      start: t,
      end: t,
      bufferedIndex: -1
    };
  }
  static bufferedInfo(e, t, r) {
    t = Math.max(0, t), e.length > 1 && e.sort((u, d) => u.start - d.start || d.end - u.end);
    let i = -1, s = [];
    if (r)
      for (let u = 0; u < e.length; u++) {
        t >= e[u].start && t <= e[u].end && (i = u);
        const d = s.length;
        if (d) {
          const f = s[d - 1].end;
          e[u].start - f < r ? e[u].end > f && (s[d - 1].end = e[u].end) : s.push(e[u]);
        } else
          s.push(e[u]);
      }
    else
      s = e;
    let o = 0, a, l = t, c = t;
    for (let u = 0; u < s.length; u++) {
      const d = s[u].start, f = s[u].end;
      if (i === -1 && t >= d && t <= f && (i = u), t + r >= d && t < f)
        l = d, c = f, o = c - t;
      else if (t + r < d) {
        a = d;
        break;
      }
    }
    return {
      len: o,
      start: l || 0,
      end: c || 0,
      nextStart: a,
      buffered: e,
      bufferedIndex: i
    };
  }
  /**
   * Safe method to get buffered property.
   * SourceBuffer.buffered may throw if SourceBuffer is removed from it's MediaSource
   */
  static getBuffered(e) {
    try {
      return e.buffered || Xz;
    } catch (t) {
      return un.log("failed to get media.buffered", t), Xz;
    }
  }
}
const Qte = /\{\$([a-zA-Z0-9-_]+)\}/g;
function Zz(n) {
  return Qte.test(n);
}
function x7(n, e) {
  if (n.variableList !== null || n.hasVariableRefs) {
    const t = n.variableList;
    return e.replace(Qte, (r) => {
      const i = r.substring(2, r.length - 1), s = t?.[i];
      return s === void 0 ? (n.playlistParsingError || (n.playlistParsingError = new Error(`Missing preceding EXT-X-DEFINE tag for Variable Reference: "${i}"`)), r) : s;
    });
  }
  return e;
}
function Qz(n, e, t) {
  let r = n.variableList;
  r || (n.variableList = r = {});
  let i, s;
  if ("QUERYPARAM" in e) {
    i = e.QUERYPARAM;
    try {
      const o = new self.URL(t).searchParams;
      if (o.has(i))
        s = o.get(i);
      else
        throw new Error(`"${i}" does not match any query parameter in URI: "${t}"`);
    } catch (o) {
      n.playlistParsingError || (n.playlistParsingError = new Error(`EXT-X-DEFINE QUERYPARAM: ${o.message}`));
    }
  } else
    i = e.NAME, s = e.VALUE;
  i in r ? n.playlistParsingError || (n.playlistParsingError = new Error(`EXT-X-DEFINE duplicate Variable Name declarations: "${i}"`)) : r[i] = s || "";
}
function RKe(n, e, t) {
  const r = e.IMPORT;
  if (t && r in t) {
    let i = n.variableList;
    i || (n.variableList = i = {}), i[r] = t[r];
  } else
    n.playlistParsingError || (n.playlistParsingError = new Error(`EXT-X-DEFINE IMPORT attribute not found in Multivariant Playlist: "${r}"`));
}
const PKe = /^(\d+)x(\d+)$/, Jz = /(.+?)=(".*?"|.*?)(?:,|$)/g;
class zn {
  constructor(e, t) {
    typeof e == "string" && (e = zn.parseAttrList(e, t)), mn(this, e);
  }
  get clientAttrs() {
    return Object.keys(this).filter((e) => e.substring(0, 2) === "X-");
  }
  decimalInteger(e) {
    const t = parseInt(this[e], 10);
    return t > Number.MAX_SAFE_INTEGER ? 1 / 0 : t;
  }
  hexadecimalInteger(e) {
    if (this[e]) {
      let t = (this[e] || "0x").slice(2);
      t = (t.length & 1 ? "0" : "") + t;
      const r = new Uint8Array(t.length / 2);
      for (let i = 0; i < t.length / 2; i++)
        r[i] = parseInt(t.slice(i * 2, i * 2 + 2), 16);
      return r;
    }
    return null;
  }
  hexadecimalIntegerAsNumber(e) {
    const t = parseInt(this[e], 16);
    return t > Number.MAX_SAFE_INTEGER ? 1 / 0 : t;
  }
  decimalFloatingPoint(e) {
    return parseFloat(this[e]);
  }
  optionalFloat(e, t) {
    const r = this[e];
    return r ? parseFloat(r) : t;
  }
  enumeratedString(e) {
    return this[e];
  }
  enumeratedStringList(e, t) {
    const r = this[e];
    return (r ? r.split(/[ ,]+/) : []).reduce((i, s) => (i[s.toLowerCase()] = !0, i), t);
  }
  bool(e) {
    return this[e] === "YES";
  }
  decimalResolution(e) {
    const t = PKe.exec(this[e]);
    if (t !== null)
      return {
        width: parseInt(t[1], 10),
        height: parseInt(t[2], 10)
      };
  }
  static parseAttrList(e, t) {
    let r;
    const i = {};
    for (Jz.lastIndex = 0; (r = Jz.exec(e)) !== null; ) {
      const o = r[1].trim();
      let a = r[2];
      const l = a.indexOf('"') === 0 && a.lastIndexOf('"') === a.length - 1;
      let c = !1;
      if (l)
        a = a.slice(1, -1);
      else
        switch (o) {
          case "IV":
          case "SCTE35-CMD":
          case "SCTE35-IN":
          case "SCTE35-OUT":
            c = !0;
        }
      if (t && (l || c))
        a = x7(t, a);
      else if (!c && !l)
        switch (o) {
          case "CLOSED-CAPTIONS":
            if (a === "NONE")
              break;
          // falls through
          case "ALLOWED-CPC":
          case "CLASS":
          case "ASSOC-LANGUAGE":
          case "AUDIO":
          case "BYTERANGE":
          case "CHANNELS":
          case "CHARACTERISTICS":
          case "CODECS":
          case "DATA-ID":
          case "END-DATE":
          case "GROUP-ID":
          case "ID":
          case "IMPORT":
          case "INSTREAM-ID":
          case "KEYFORMAT":
          case "KEYFORMATVERSIONS":
          case "LANGUAGE":
          case "NAME":
          case "PATHWAY-ID":
          case "QUERYPARAM":
          case "RECENTLY-REMOVED-DATERANGES":
          case "SERVER-URI":
          case "STABLE-RENDITION-ID":
          case "STABLE-VARIANT-ID":
          case "START-DATE":
          case "SUBTITLES":
          case "SUPPLEMENTAL-CODECS":
          case "URI":
          case "VALUE":
          case "VIDEO":
          case "X-ASSET-LIST":
          case "X-ASSET-URI":
            un.warn(`${e}: attribute ${o} is missing quotes`);
        }
      i[o] = a;
    }
    return i;
  }
}
const DKe = "com.apple.hls.interstitial";
function NKe(n) {
  return n !== "ID" && n !== "CLASS" && n !== "CUE" && n !== "START-DATE" && n !== "DURATION" && n !== "END-DATE" && n !== "END-ON-NEXT";
}
function LKe(n) {
  return n === "SCTE35-OUT" || n === "SCTE35-IN" || n === "SCTE35-CMD";
}
class Jte {
  constructor(e, t, r = 0) {
    var i;
    if (this.attr = void 0, this.tagAnchor = void 0, this.tagOrder = void 0, this._startDate = void 0, this._endDate = void 0, this._dateAtEnd = void 0, this._cue = void 0, this._badValueForSameId = void 0, this.tagAnchor = t?.tagAnchor || null, this.tagOrder = (i = t?.tagOrder) != null ? i : r, t) {
      const s = t.attr;
      for (const o in s)
        if (Object.prototype.hasOwnProperty.call(e, o) && e[o] !== s[o]) {
          un.warn(`DATERANGE tag attribute: "${o}" does not match for tags with ID: "${e.ID}"`), this._badValueForSameId = o;
          break;
        }
      e = mn(new zn({}), s, e);
    }
    if (this.attr = e, t ? (this._startDate = t._startDate, this._cue = t._cue, this._endDate = t._endDate, this._dateAtEnd = t._dateAtEnd) : this._startDate = new Date(e["START-DATE"]), "END-DATE" in this.attr) {
      const s = t?.endDate || new Date(this.attr["END-DATE"]);
      He(s.getTime()) && (this._endDate = s);
    }
  }
  get id() {
    return this.attr.ID;
  }
  get class() {
    return this.attr.CLASS;
  }
  get cue() {
    const e = this._cue;
    return e === void 0 ? this._cue = this.attr.enumeratedStringList(this.attr.CUE ? "CUE" : "X-CUE", {
      pre: !1,
      post: !1,
      once: !1
    }) : e;
  }
  get startTime() {
    const {
      tagAnchor: e
    } = this;
    return e === null || e.programDateTime === null ? (un.warn(`Expected tagAnchor Fragment with PDT set for DateRange "${this.id}": ${e}`), NaN) : e.start + (this.startDate.getTime() - e.programDateTime) / 1e3;
  }
  get startDate() {
    return this._startDate;
  }
  get endDate() {
    const e = this._endDate || this._dateAtEnd;
    if (e)
      return e;
    const t = this.duration;
    return t !== null ? this._dateAtEnd = new Date(this._startDate.getTime() + t * 1e3) : null;
  }
  get duration() {
    if ("DURATION" in this.attr) {
      const e = this.attr.decimalFloatingPoint("DURATION");
      if (He(e))
        return e;
    } else if (this._endDate)
      return (this._endDate.getTime() - this._startDate.getTime()) / 1e3;
    return null;
  }
  get plannedDuration() {
    return "PLANNED-DURATION" in this.attr ? this.attr.decimalFloatingPoint("PLANNED-DURATION") : null;
  }
  get endOnNext() {
    return this.attr.bool("END-ON-NEXT");
  }
  get isInterstitial() {
    return this.class === DKe;
  }
  get isValid() {
    return !!this.id && !this._badValueForSameId && He(this.startDate.getTime()) && (this.duration === null || this.duration >= 0) && (!this.endOnNext || !!this.class) && (!this.attr.CUE || !this.cue.pre && !this.cue.post || this.cue.pre !== this.cue.post) && (!this.isInterstitial || "X-ASSET-URI" in this.attr || "X-ASSET-LIST" in this.attr);
  }
}
const $Ke = 10;
class FKe {
  constructor(e) {
    this.PTSKnown = !1, this.alignedSliding = !1, this.averagetargetduration = void 0, this.endCC = 0, this.endSN = 0, this.fragments = void 0, this.fragmentHint = void 0, this.partList = null, this.dateRanges = void 0, this.dateRangeTagCount = 0, this.live = !0, this.requestScheduled = -1, this.ageHeader = 0, this.advancedDateTime = void 0, this.updated = !0, this.advanced = !0, this.misses = 0, this.startCC = 0, this.startSN = 0, this.startTimeOffset = null, this.targetduration = 0, this.totalduration = 0, this.type = null, this.url = void 0, this.m3u8 = "", this.version = null, this.canBlockReload = !1, this.canSkipUntil = 0, this.canSkipDateRanges = !1, this.skippedSegments = 0, this.recentlyRemovedDateranges = void 0, this.partHoldBack = 0, this.holdBack = 0, this.partTarget = 0, this.preloadHint = void 0, this.renditionReports = void 0, this.tuneInGoal = 0, this.deltaUpdateFailed = void 0, this.driftStartTime = 0, this.driftEndTime = 0, this.driftStart = 0, this.driftEnd = 0, this.encryptedFragments = void 0, this.playlistParsingError = null, this.variableList = null, this.hasVariableRefs = !1, this.appliedTimelineOffset = void 0, this.fragments = [], this.encryptedFragments = [], this.dateRanges = {}, this.url = e;
  }
  reloaded(e) {
    if (!e) {
      this.advanced = !0, this.updated = !0;
      return;
    }
    const t = this.lastPartSn - e.lastPartSn, r = this.lastPartIndex - e.lastPartIndex;
    this.updated = this.endSN !== e.endSN || !!r || !!t || !this.live, this.advanced = this.endSN > e.endSN || t > 0 || t === 0 && r > 0, this.updated || this.advanced ? this.misses = Math.floor(e.misses * 0.6) : this.misses = e.misses + 1;
  }
  hasKey(e) {
    return this.encryptedFragments.some((t) => {
      let r = t.decryptdata;
      return r || (t.setKeyFormat(e.keyFormat), r = t.decryptdata), !!r && e.matches(r);
    });
  }
  get hasProgramDateTime() {
    return this.fragments.length ? He(this.fragments[this.fragments.length - 1].programDateTime) : !1;
  }
  get levelTargetDuration() {
    return this.averagetargetduration || this.targetduration || $Ke;
  }
  get drift() {
    const e = this.driftEndTime - this.driftStartTime;
    return e > 0 ? (this.driftEnd - this.driftStart) * 1e3 / e : 1;
  }
  get edge() {
    return this.partEnd || this.fragmentEnd;
  }
  get partEnd() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].end : this.fragmentEnd;
  }
  get fragmentEnd() {
    return this.fragments.length ? this.fragments[this.fragments.length - 1].end : 0;
  }
  get fragmentStart() {
    return this.fragments.length ? this.fragments[0].start : 0;
  }
  get age() {
    return this.advancedDateTime ? Math.max(Date.now() - this.advancedDateTime, 0) / 1e3 : 0;
  }
  get lastPartIndex() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].index : -1;
  }
  get maxPartIndex() {
    const e = this.partList;
    if (e) {
      const t = this.lastPartIndex;
      if (t !== -1) {
        for (let r = e.length; r--; )
          if (e[r].index > t)
            return e[r].index;
        return t;
      }
    }
    return 0;
  }
  get lastPartSn() {
    var e;
    return (e = this.partList) != null && e.length ? this.partList[this.partList.length - 1].fragment.sn : this.endSN;
  }
  get expired() {
    if (this.live && this.age && this.misses < 3) {
      const e = this.partEnd - this.fragmentStart;
      return this.age > Math.max(e, this.totalduration) + this.levelTargetDuration;
    }
    return !1;
  }
}
function jy(n, e) {
  return n.length === e.length ? !n.some((t, r) => t !== e[r]) : !1;
}
function eH(n, e) {
  return !n && !e ? !0 : !n || !e ? !1 : jy(n, e);
}
function ff(n) {
  return n === "AES-128" || n === "AES-256" || n === "AES-256-CTR";
}
function b_(n) {
  switch (n) {
    case "AES-128":
    case "AES-256":
      return vc.cbc;
    case "AES-256-CTR":
      return vc.ctr;
    default:
      throw new Error(`invalid full segment method ${n}`);
  }
}
function w_(n) {
  return Uint8Array.from(atob(n), (e) => e.charCodeAt(0));
}
function E7(n) {
  return Uint8Array.from(unescape(encodeURIComponent(n)), (e) => e.charCodeAt(0));
}
function BKe(n) {
  const e = E7(n).subarray(0, 16), t = new Uint8Array(16);
  return t.set(e, 16 - e.length), t;
}
function ene(n) {
  const e = function(r, i, s) {
    const o = r[i];
    r[i] = r[s], r[s] = o;
  };
  e(n, 0, 3), e(n, 1, 2), e(n, 4, 5), e(n, 6, 7);
}
function tne(n) {
  const e = n.split(":");
  let t = null;
  if (e[0] === "data" && e.length === 2) {
    const r = e[1].split(";"), i = r[r.length - 1].split(",");
    if (i.length === 2) {
      const s = i[0] === "base64", o = i[1];
      s ? (r.splice(-1, 1), t = w_(o)) : t = BKe(o);
    }
  }
  return t;
}
const Wy = typeof self < "u" ? self : void 0;
var Vn = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.fps",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "com.widevine.alpha"
}, zr = {
  CLEARKEY: "org.w3.clearkey",
  FAIRPLAY: "com.apple.streamingkeydelivery",
  PLAYREADY: "com.microsoft.playready",
  WIDEVINE: "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed"
};
function jv(n) {
  switch (n) {
    case zr.FAIRPLAY:
      return Vn.FAIRPLAY;
    case zr.PLAYREADY:
      return Vn.PLAYREADY;
    case zr.WIDEVINE:
      return Vn.WIDEVINE;
    case zr.CLEARKEY:
      return Vn.CLEARKEY;
  }
}
function S6(n) {
  switch (n) {
    case Vn.FAIRPLAY:
      return zr.FAIRPLAY;
    case Vn.PLAYREADY:
      return zr.PLAYREADY;
    case Vn.WIDEVINE:
      return zr.WIDEVINE;
    case Vn.CLEARKEY:
      return zr.CLEARKEY;
  }
}
function _p(n) {
  const {
    drmSystems: e,
    widevineLicenseUrl: t
  } = n, r = e ? [Vn.FAIRPLAY, Vn.WIDEVINE, Vn.PLAYREADY, Vn.CLEARKEY].filter((i) => !!e[i]) : [];
  return !r[Vn.WIDEVINE] && t && r.push(Vn.WIDEVINE), r;
}
const nne = (function(n) {
  return Wy != null && (n = Wy.navigator) != null && n.requestMediaKeySystemAccess ? self.navigator.requestMediaKeySystemAccess.bind(self.navigator) : null;
})();
function zKe(n, e, t, r) {
  let i;
  switch (n) {
    case Vn.FAIRPLAY:
      i = ["cenc", "sinf"];
      break;
    case Vn.WIDEVINE:
    case Vn.PLAYREADY:
      i = ["cenc"];
      break;
    case Vn.CLEARKEY:
      i = ["cenc", "keyids"];
      break;
    default:
      throw new Error(`Unknown key-system: ${n}`);
  }
  return HKe(i, e, t, r);
}
function HKe(n, e, t, r) {
  return [{
    initDataTypes: n,
    persistentState: r.persistentState || "optional",
    distinctiveIdentifier: r.distinctiveIdentifier || "optional",
    sessionTypes: r.sessionTypes || [r.sessionType || "temporary"],
    audioCapabilities: e.map((s) => ({
      contentType: `audio/mp4; codecs=${s}`,
      robustness: r.audioRobustness || "",
      encryptionScheme: r.audioEncryptionScheme || null
    })),
    videoCapabilities: t.map((s) => ({
      contentType: `video/mp4; codecs=${s}`,
      robustness: r.videoRobustness || "",
      encryptionScheme: r.videoEncryptionScheme || null
    }))
  }];
}
function UKe(n) {
  var e;
  return !!n && (n.sessionType === "persistent-license" || !!((e = n.sessionTypes) != null && e.some((t) => t === "persistent-license")));
}
function rne(n) {
  const e = new Uint16Array(n.buffer, n.byteOffset, n.byteLength / 2), t = String.fromCharCode.apply(null, Array.from(e)), r = t.substring(t.indexOf("<"), t.length), o = new DOMParser().parseFromString(r, "text/xml").getElementsByTagName("KID")[0];
  if (o) {
    const a = o.childNodes[0] ? o.childNodes[0].nodeValue : o.getAttribute("VALUE");
    if (a) {
      const l = w_(a).subarray(0, 16);
      return ene(l), l;
    }
  }
  return null;
}
let Ad = {};
class ac {
  static clearKeyUriToKeyIdMap() {
    Ad = {};
  }
  static setKeyIdForUri(e, t) {
    Ad[e] = t;
  }
  static addKeyIdForUri(e) {
    const t = Object.keys(Ad).length % Number.MAX_SAFE_INTEGER, r = new Uint8Array(16);
    return new DataView(r.buffer, 12, 4).setUint32(0, t), Ad[e] = r, r;
  }
  constructor(e, t, r, i = [1], s = null, o) {
    this.uri = void 0, this.method = void 0, this.keyFormat = void 0, this.keyFormatVersions = void 0, this.encrypted = void 0, this.isCommonEncryption = void 0, this.iv = null, this.key = null, this.keyId = null, this.pssh = null, this.method = e, this.uri = t, this.keyFormat = r, this.keyFormatVersions = i, this.iv = s, this.encrypted = e ? e !== "NONE" : !1, this.isCommonEncryption = this.encrypted && !ff(e), o != null && o.startsWith("0x") && (this.keyId = new Uint8Array(Ite(o)));
  }
  matches(e) {
    return e.uri === this.uri && e.method === this.method && e.encrypted === this.encrypted && e.keyFormat === this.keyFormat && jy(e.keyFormatVersions, this.keyFormatVersions) && eH(e.iv, this.iv) && eH(e.keyId, this.keyId);
  }
  isSupported() {
    if (this.method) {
      if (ff(this.method) || this.method === "NONE")
        return !0;
      if (this.keyFormat === "identity")
        return this.method === "SAMPLE-AES";
      switch (this.keyFormat) {
        case zr.FAIRPLAY:
        case zr.WIDEVINE:
        case zr.PLAYREADY:
        case zr.CLEARKEY:
          return ["SAMPLE-AES", "SAMPLE-AES-CENC", "SAMPLE-AES-CTR"].indexOf(this.method) !== -1;
      }
    }
    return !1;
  }
  getDecryptData(e, t) {
    if (!this.encrypted || !this.uri)
      return null;
    if (ff(this.method)) {
      let s = this.iv;
      return s || (typeof e != "number" && (un.warn(`missing IV for initialization segment with method="${this.method}" - compliance issue`), e = 0), s = jKe(e)), new ac(this.method, this.uri, "identity", this.keyFormatVersions, s);
    }
    if (this.keyId) {
      const s = Ad[this.uri];
      if (s && !jy(this.keyId, s) && ac.setKeyIdForUri(this.uri, this.keyId), this.pssh)
        return this;
    }
    const r = tne(this.uri);
    if (r)
      switch (this.keyFormat) {
        case zr.WIDEVINE:
          if (this.pssh = r, !this.keyId) {
            const s = KGe(r.buffer);
            if (s.length) {
              var i;
              const o = s[0];
              this.keyId = (i = o.kids) != null && i.length ? o.kids[0] : null;
            }
          }
          this.keyId || (this.keyId = tH(t));
          break;
        case zr.PLAYREADY: {
          const s = new Uint8Array([154, 4, 240, 121, 152, 64, 66, 134, 171, 146, 230, 91, 224, 136, 95, 149]);
          this.pssh = GGe(s, null, r), this.keyId = rne(r);
          break;
        }
        default: {
          let s = r.subarray(0, 16);
          if (s.length !== 16) {
            const o = new Uint8Array(16);
            o.set(s, 16 - s.length), s = o;
          }
          this.keyId = s;
          break;
        }
      }
    if (!this.keyId || this.keyId.byteLength !== 16) {
      let s;
      s = VKe(t), s || (s = tH(t), s || (s = Ad[this.uri])), s && (this.keyId = s, ac.setKeyIdForUri(this.uri, s));
    }
    return this;
  }
}
function VKe(n) {
  const e = n?.[zr.WIDEVINE];
  return e ? e.keyId : null;
}
function tH(n) {
  const e = n?.[zr.PLAYREADY];
  if (e) {
    const t = tne(e.uri);
    if (t)
      return rne(t);
  }
  return null;
}
function jKe(n) {
  const e = new Uint8Array(16);
  for (let t = 12; t < 16; t++)
    e[t] = n >> 8 * (15 - t) & 255;
  return e;
}
const nH = /#EXT-X-STREAM-INF:([^\r\n]*)(?:[\r\n](?:#[^\r\n]*)?)*([^\r\n]+)|#EXT-X-(SESSION-DATA|SESSION-KEY|DEFINE|CONTENT-STEERING|START):([^\r\n]*)[\r\n]+/g, rH = /#EXT-X-MEDIA:(.*)/g, WKe = /^#EXT(?:INF|-X-TARGETDURATION):/m, C6 = new RegExp([
  /#EXTINF:\s*(\d*(?:\.\d+)?)(?:,(.*)\s+)?/.source,
  // duration (#EXTINF:<duration>,<title>), group 1 => duration, group 2 => title
  /(?!#) *(\S[^\r\n]*)/.source,
  // segment URI, group 3 => the URI (note newline is not eaten)
  /#.*/.source
  // All other non-segment oriented tags will match with all groups empty
].join("|"), "g"), GKe = new RegExp([/#EXT-X-(PROGRAM-DATE-TIME|BYTERANGE|DATERANGE|DEFINE|KEY|MAP|PART|PART-INF|PLAYLIST-TYPE|PRELOAD-HINT|RENDITION-REPORT|SERVER-CONTROL|SKIP|START):(.+)/.source, /#EXT-X-(BITRATE|DISCONTINUITY-SEQUENCE|MEDIA-SEQUENCE|TARGETDURATION|VERSION): *(\d+)/.source, /#EXT-X-(DISCONTINUITY|ENDLIST|GAP|INDEPENDENT-SEGMENTS)/.source, /(#)([^:]*):(.*)/.source, /(#)(.*)(?:.*)\r?\n?/.source].join("|"));
class sa {
  static findGroup(e, t) {
    for (let r = 0; r < e.length; r++) {
      const i = e[r];
      if (i.id === t)
        return i;
    }
  }
  static resolve(e, t) {
    return d_.buildAbsoluteURL(t, e, {
      alwaysNormalize: !0
    });
  }
  static isMediaPlaylist(e) {
    return WKe.test(e);
  }
  static parseMasterPlaylist(e, t) {
    const r = Zz(e), i = {
      contentSteering: null,
      levels: [],
      playlistParsingError: null,
      sessionData: null,
      sessionKeys: null,
      startTimeOffset: null,
      variableList: null,
      hasVariableRefs: r
    }, s = [];
    if (nH.lastIndex = 0, !e.startsWith("#EXTM3U"))
      return i.playlistParsingError = new Error("no EXTM3U delimiter"), i;
    let o;
    for (; (o = nH.exec(e)) != null; )
      if (o[1]) {
        var a;
        const c = new zn(o[1], i), u = x7(i, o[2]), d = {
          attrs: c,
          bitrate: c.decimalInteger("BANDWIDTH") || c.decimalInteger("AVERAGE-BANDWIDTH"),
          name: c.NAME,
          url: sa.resolve(u, t)
        }, f = c.decimalResolution("RESOLUTION");
        f && (d.width = f.width, d.height = f.height), oH(c.CODECS, d);
        const h = c["SUPPLEMENTAL-CODECS"];
        h && (d.supplemental = {}, oH(h, d.supplemental)), (a = d.unknownCodecs) != null && a.length || s.push(d), i.levels.push(d);
      } else if (o[3]) {
        const c = o[3], u = o[4];
        switch (c) {
          case "SESSION-DATA": {
            const d = new zn(u, i), f = d["DATA-ID"];
            f && (i.sessionData === null && (i.sessionData = {}), i.sessionData[f] = d);
            break;
          }
          case "SESSION-KEY": {
            const d = iH(u, t, i);
            d.encrypted && d.isSupported() ? (i.sessionKeys === null && (i.sessionKeys = []), i.sessionKeys.push(d)) : un.warn(`[Keys] Ignoring invalid EXT-X-SESSION-KEY tag: "${u}"`);
            break;
          }
          case "DEFINE": {
            {
              const d = new zn(u, i);
              Qz(i, d, t);
            }
            break;
          }
          case "CONTENT-STEERING": {
            const d = new zn(u, i);
            i.contentSteering = {
              uri: sa.resolve(d["SERVER-URI"], t),
              pathwayId: d["PATHWAY-ID"] || "."
            };
            break;
          }
          case "START": {
            i.startTimeOffset = sH(u);
            break;
          }
        }
      }
    const l = s.length > 0 && s.length < i.levels.length;
    return i.levels = l ? s : i.levels, i.levels.length === 0 && (i.playlistParsingError = new Error("no levels found in manifest")), i;
  }
  static parseMasterPlaylistMedia(e, t, r) {
    let i;
    const s = {}, o = r.levels, a = {
      AUDIO: o.map((c) => ({
        id: c.attrs.AUDIO,
        audioCodec: c.audioCodec
      })),
      SUBTITLES: o.map((c) => ({
        id: c.attrs.SUBTITLES,
        textCodec: c.textCodec
      })),
      "CLOSED-CAPTIONS": []
    };
    let l = 0;
    for (rH.lastIndex = 0; (i = rH.exec(e)) !== null; ) {
      const c = new zn(i[1], r), u = c.TYPE;
      if (u) {
        const d = a[u], f = s[u] || [];
        s[u] = f;
        const h = c.LANGUAGE, m = c["ASSOC-LANGUAGE"], g = c.CHANNELS, v = c.CHARACTERISTICS, y = c["INSTREAM-ID"], b = {
          attrs: c,
          bitrate: 0,
          id: l++,
          groupId: c["GROUP-ID"] || "",
          name: c.NAME || h || "",
          type: u,
          default: c.bool("DEFAULT"),
          autoselect: c.bool("AUTOSELECT"),
          forced: c.bool("FORCED"),
          lang: h,
          url: c.URI ? sa.resolve(c.URI, t) : ""
        };
        if (m && (b.assocLang = m), g && (b.channels = g), v && (b.characteristics = v), y && (b.instreamId = y), d != null && d.length) {
          const x = sa.findGroup(d, b.groupId) || d[0];
          aH(b, x, "audioCodec"), aH(b, x, "textCodec");
        }
        f.push(b);
      }
    }
    return s;
  }
  static parseLevelPlaylist(e, t, r, i, s, o) {
    var a;
    const l = {
      url: t
    }, c = new FKe(t), u = c.fragments, d = [];
    let f = null, h = 0, m = 0, g = 0, v = 0, y = 0, b = null, x = new w6(i, l), E, w, C, S = -1, M = !1, k = null, _;
    if (C6.lastIndex = 0, c.m3u8 = e, c.hasVariableRefs = Zz(e), ((a = C6.exec(e)) == null ? void 0 : a[0]) !== "#EXTM3U")
      return c.playlistParsingError = new Error("Missing format identifier #EXTM3U"), c;
    for (; (E = C6.exec(e)) !== null; ) {
      M && (M = !1, x = new w6(i, l), x.playlistOffset = g, x.setStart(g), x.sn = h, x.cc = v, y && (x.bitrate = y), x.level = r, f && (x.initSegment = f, f.rawProgramDateTime && (x.rawProgramDateTime = f.rawProgramDateTime, f.rawProgramDateTime = null), k && (x.setByteRange(k), k = null)));
      const P = E[1];
      if (P) {
        x.duration = parseFloat(P);
        const D = (" " + E[2]).slice(1);
        x.title = D || null, x.tagList.push(D ? ["INF", P, D] : ["INF", P]);
      } else if (E[3]) {
        if (He(x.duration)) {
          x.playlistOffset = g, x.setStart(g), C && cH(x, C, c), x.sn = h, x.level = r, x.cc = v, u.push(x);
          const D = (" " + E[3]).slice(1);
          x.relurl = x7(c, D), S7(x, b, d), b = x, g += x.duration, h++, m = 0, M = !0;
        }
      } else {
        if (E = E[0].match(GKe), !E) {
          un.warn("No matches on slow regex match for level playlist!");
          continue;
        }
        for (w = 1; w < E.length && E[w] === void 0; w++)
          ;
        const D = (" " + E[w]).slice(1), L = (" " + E[w + 1]).slice(1), B = E[w + 2] ? (" " + E[w + 2]).slice(1) : null;
        switch (D) {
          case "BYTERANGE":
            b ? x.setByteRange(L, b) : x.setByteRange(L);
            break;
          case "PROGRAM-DATE-TIME":
            x.rawProgramDateTime = L, x.tagList.push(["PROGRAM-DATE-TIME", L]), S === -1 && (S = u.length);
            break;
          case "PLAYLIST-TYPE":
            c.type && Pa(c, D, E), c.type = L.toUpperCase();
            break;
          case "MEDIA-SEQUENCE":
            c.startSN !== 0 ? Pa(c, D, E) : u.length > 0 && uH(c, D, E), h = c.startSN = parseInt(L);
            break;
          case "SKIP": {
            c.skippedSegments && Pa(c, D, E);
            const $ = new zn(L, c), z = $.decimalInteger("SKIPPED-SEGMENTS");
            if (He(z)) {
              c.skippedSegments += z;
              for (let U = z; U--; )
                u.push(null);
              h += z;
            }
            const H = $.enumeratedString("RECENTLY-REMOVED-DATERANGES");
            H && (c.recentlyRemovedDateranges = (c.recentlyRemovedDateranges || []).concat(H.split("	")));
            break;
          }
          case "TARGETDURATION":
            c.targetduration !== 0 && Pa(c, D, E), c.targetduration = Math.max(parseInt(L), 1);
            break;
          case "VERSION":
            c.version !== null && Pa(c, D, E), c.version = parseInt(L);
            break;
          case "INDEPENDENT-SEGMENTS":
            break;
          case "ENDLIST":
            c.live || Pa(c, D, E), c.live = !1;
            break;
          case "#":
            (L || B) && x.tagList.push(B ? [L, B] : [L]);
            break;
          case "DISCONTINUITY":
            v++, x.tagList.push(["DIS"]);
            break;
          case "GAP":
            x.gap = !0, x.tagList.push([D]);
            break;
          case "BITRATE":
            x.tagList.push([D, L]), y = parseInt(L) * 1e3, He(y) ? x.bitrate = y : y = 0;
            break;
          case "DATERANGE": {
            const $ = new zn(L, c), z = new Jte($, c.dateRanges[$.ID], c.dateRangeTagCount);
            c.dateRangeTagCount++, z.isValid || c.skippedSegments ? c.dateRanges[z.id] = z : un.warn(`Ignoring invalid DATERANGE tag: "${L}"`), x.tagList.push(["EXT-X-DATERANGE", L]);
            break;
          }
          case "DEFINE": {
            {
              const $ = new zn(L, c);
              "IMPORT" in $ ? RKe(c, $, o) : Qz(c, $, t);
            }
            break;
          }
          case "DISCONTINUITY-SEQUENCE":
            c.startCC !== 0 ? Pa(c, D, E) : u.length > 0 && uH(c, D, E), c.startCC = v = parseInt(L);
            break;
          case "KEY": {
            const $ = iH(L, t, c);
            if ($.isSupported()) {
              if ($.method === "NONE") {
                C = void 0;
                break;
              }
              C || (C = {});
              const z = C[$.keyFormat];
              z != null && z.matches($) || (z && (C = mn({}, C)), C[$.keyFormat] = $);
            } else
              un.warn(`[Keys] Ignoring unsupported EXT-X-KEY tag: "${L}"`);
            break;
          }
          case "START":
            c.startTimeOffset = sH(L);
            break;
          case "MAP": {
            const $ = new zn(L, c);
            if (x.duration) {
              const z = new w6(i, l);
              lH(z, $, r, C), f = z, x.initSegment = f, f.rawProgramDateTime && !x.rawProgramDateTime && (x.rawProgramDateTime = f.rawProgramDateTime);
            } else {
              const z = x.byteRangeEndOffset;
              if (z) {
                const H = x.byteRangeStartOffset;
                k = `${z - H}@${H}`;
              } else
                k = null;
              lH(x, $, r, C), f = x, M = !0;
            }
            f.cc = v;
            break;
          }
          case "SERVER-CONTROL": {
            _ && Pa(c, D, E), _ = new zn(L), c.canBlockReload = _.bool("CAN-BLOCK-RELOAD"), c.canSkipUntil = _.optionalFloat("CAN-SKIP-UNTIL", 0), c.canSkipDateRanges = c.canSkipUntil > 0 && _.bool("CAN-SKIP-DATERANGES"), c.partHoldBack = _.optionalFloat("PART-HOLD-BACK", 0), c.holdBack = _.optionalFloat("HOLD-BACK", 0);
            break;
          }
          case "PART-INF": {
            c.partTarget && Pa(c, D, E);
            const $ = new zn(L);
            c.partTarget = $.decimalFloatingPoint("PART-TARGET");
            break;
          }
          case "PART": {
            let $ = c.partList;
            $ || ($ = c.partList = []);
            const z = m > 0 ? $[$.length - 1] : void 0, H = m++, U = new zn(L, c), F = new RGe(U, x, l, H, z);
            $.push(F), x.duration += F.duration;
            break;
          }
          case "PRELOAD-HINT": {
            const $ = new zn(L, c);
            c.preloadHint = $;
            break;
          }
          case "RENDITION-REPORT": {
            const $ = new zn(L, c);
            c.renditionReports = c.renditionReports || [], c.renditionReports.push($);
            break;
          }
          default:
            un.warn(`line parsed but not handled: ${E}`);
            break;
        }
      }
    }
    b && !b.relurl ? (u.pop(), g -= b.duration, c.partList && (c.fragmentHint = b)) : c.partList && (S7(x, b, d), x.cc = v, c.fragmentHint = x, C && cH(x, C, c)), c.targetduration || (c.playlistParsingError = new Error("Missing Target Duration"));
    const O = u.length, I = u[0], R = u[O - 1];
    if (g += c.skippedSegments * c.targetduration, g > 0 && O && R) {
      c.averagetargetduration = g / O;
      const P = R.sn;
      c.endSN = P !== "initSegment" ? P : 0, c.live || (R.endList = !0), S > 0 && (qKe(u, S), I && d.unshift(I));
    }
    return c.fragmentHint && (g += c.fragmentHint.duration), c.totalduration = g, d.length && c.dateRangeTagCount && I && ine(d, c), c.endCC = v, c;
  }
}
function ine(n, e) {
  let t = n.length;
  if (!t)
    if (e.hasProgramDateTime) {
      const a = e.fragments[e.fragments.length - 1];
      n.push(a), t++;
    } else
      return;
  const r = n[t - 1], i = e.live ? 1 / 0 : e.totalduration, s = Object.keys(e.dateRanges);
  for (let a = s.length; a--; ) {
    const l = e.dateRanges[s[a]], c = l.startDate.getTime();
    l.tagAnchor = r.ref;
    for (let u = t; u--; ) {
      var o;
      if (((o = n[u]) == null ? void 0 : o.sn) < e.startSN)
        break;
      const d = KKe(e, c, n, u, i);
      if (d !== -1) {
        l.tagAnchor = e.fragments[d].ref;
        break;
      }
    }
  }
}
function KKe(n, e, t, r, i) {
  const s = t[r];
  if (s) {
    const a = s.programDateTime;
    if (e >= a || r === 0) {
      var o;
      const l = (((o = t[r + 1]) == null ? void 0 : o.start) || i) - s.start;
      if (e <= a + l * 1e3) {
        const c = t[r].sn - n.startSN;
        if (c < 0)
          return -1;
        const u = n.fragments;
        if (u.length > t.length) {
          const f = (t[r + 1] || u[u.length - 1]).sn - n.startSN;
          for (let h = f; h > c; h--) {
            const m = u[h].programDateTime;
            if (e >= m && e < m + u[h].duration * 1e3)
              return h;
          }
        }
        return c;
      }
    }
  }
  return -1;
}
function iH(n, e, t) {
  var r, i;
  const s = new zn(n, t), o = (r = s.METHOD) != null ? r : "", a = s.URI, l = s.hexadecimalInteger("IV"), c = s.KEYFORMATVERSIONS, u = (i = s.KEYFORMAT) != null ? i : "identity";
  a && s.IV && !l && un.error(`Invalid IV: ${s.IV}`);
  const d = a ? sa.resolve(a, e) : "", f = (c || "1").split("/").map(Number).filter(Number.isFinite);
  return new ac(o, d, u, f, l, s.KEYID);
}
function sH(n) {
  const t = new zn(n).decimalFloatingPoint("TIME-OFFSET");
  return He(t) ? t : null;
}
function oH(n, e) {
  let t = (n || "").split(/[ ,]+/).filter((r) => r);
  ["video", "audio", "text"].forEach((r) => {
    const i = t.filter((s) => p_(s, r));
    i.length && (e[`${r}Codec`] = i.map((s) => s.split("/")[0]).join(","), t = t.filter((s) => i.indexOf(s) === -1));
  }), e.unknownCodecs = t;
}
function aH(n, e, t) {
  const r = e[t];
  r && (n[t] = r);
}
function qKe(n, e) {
  let t = n[e];
  for (let r = e; r--; ) {
    const i = n[r];
    if (!i)
      return;
    i.programDateTime = t.programDateTime - i.duration * 1e3, t = i;
  }
}
function S7(n, e, t) {
  n.rawProgramDateTime ? t.push(n) : e != null && e.programDateTime && (n.programDateTime = e.endProgramDateTime);
}
function lH(n, e, t, r) {
  n.relurl = e.URI, e.BYTERANGE && n.setByteRange(e.BYTERANGE), n.level = t, n.sn = "initSegment", r && (n.levelkeys = r), n.initSegment = null;
}
function cH(n, e, t) {
  n.levelkeys = e;
  const {
    encryptedFragments: r
  } = t;
  (!r.length || r[r.length - 1].levelkeys !== e) && Object.keys(e).some((i) => e[i].isCommonEncryption) && r.push(n);
}
function Pa(n, e, t) {
  n.playlistParsingError = new Error(`#EXT-X-${e} must not appear more than once (${t[0]})`);
}
function uH(n, e, t) {
  n.playlistParsingError = new Error(`#EXT-X-${e} must appear before the first Media Segment (${t[0]})`);
}
function T6(n, e) {
  const t = e.startPTS;
  if (He(t)) {
    let r = 0, i;
    e.sn > n.sn ? (r = t - n.start, i = n) : (r = n.start - t, i = e), i.duration !== r && i.setDuration(r);
  } else e.sn > n.sn ? n.cc === e.cc && n.minEndPTS ? e.setStart(n.start + (n.minEndPTS - n.start)) : e.setStart(n.start + n.duration) : e.setStart(Math.max(n.start - e.duration, 0));
}
function sne(n, e, t, r, i, s, o) {
  r - t <= 0 && (o.warn("Fragment should have a positive duration", e), r = t + e.duration, s = i + e.duration);
  let l = t, c = r;
  const u = e.startPTS, d = e.endPTS;
  if (He(u)) {
    const y = Math.abs(u - t);
    n && y > n.totalduration ? o.warn(`media timestamps and playlist times differ by ${y}s for level ${e.level} ${n.url}`) : He(e.deltaPTS) ? e.deltaPTS = Math.max(y, e.deltaPTS) : e.deltaPTS = y, l = Math.max(t, u), t = Math.min(t, u), i = e.startDTS !== void 0 ? Math.min(i, e.startDTS) : i, c = Math.min(r, d), r = Math.max(r, d), s = e.endDTS !== void 0 ? Math.max(s, e.endDTS) : s;
  }
  const f = t - e.start;
  e.start !== 0 && e.setStart(t), e.setDuration(r - e.start), e.startPTS = t, e.maxStartPTS = l, e.startDTS = i, e.endPTS = r, e.minEndPTS = c, e.endDTS = s;
  const h = e.sn;
  if (!n || h < n.startSN || h > n.endSN)
    return 0;
  let m;
  const g = h - n.startSN, v = n.fragments;
  for (v[g] = e, m = g; m > 0; m--)
    T6(v[m], v[m - 1]);
  for (m = g; m < v.length - 1; m++)
    T6(v[m], v[m + 1]);
  return n.fragmentHint && T6(v[v.length - 1], n.fragmentHint), n.PTSKnown = n.alignedSliding = !0, f;
}
function YKe(n, e, t) {
  if (n === e)
    return;
  let r = null;
  const i = n.fragments;
  for (let u = i.length - 1; u >= 0; u--) {
    const d = i[u].initSegment;
    if (d) {
      r = d;
      break;
    }
  }
  n.fragmentHint && delete n.fragmentHint.endPTS;
  let s;
  QKe(n, e, (u, d, f, h) => {
    if ((!e.startCC || e.skippedSegments) && d.cc !== u.cc) {
      const m = u.cc - d.cc;
      for (let g = f; g < h.length; g++)
        h[g].cc += m;
      e.endCC = h[h.length - 1].cc;
    }
    He(u.startPTS) && He(u.endPTS) && (d.setStart(d.startPTS = u.startPTS), d.startDTS = u.startDTS, d.maxStartPTS = u.maxStartPTS, d.endPTS = u.endPTS, d.endDTS = u.endDTS, d.minEndPTS = u.minEndPTS, d.setDuration(u.endPTS - u.startPTS), d.duration && (s = d), e.PTSKnown = e.alignedSliding = !0), u.hasStreams && (d.elementaryStreams = u.elementaryStreams), d.loader = u.loader, u.hasStats && (d.stats = u.stats), u.initSegment && (d.initSegment = u.initSegment, r = u.initSegment);
  });
  const o = e.fragments, a = e.fragmentHint ? o.concat(e.fragmentHint) : o;
  if (r && a.forEach((u) => {
    var d;
    u && (!u.initSegment || u.initSegment.relurl === ((d = r) == null ? void 0 : d.relurl)) && (u.initSegment = r);
  }), e.skippedSegments) {
    if (e.deltaUpdateFailed = o.some((u) => !u), e.deltaUpdateFailed) {
      t.warn("[level-helper] Previous playlist missing segments skipped in delta playlist");
      for (let u = e.skippedSegments; u--; )
        o.shift();
      e.startSN = o[0].sn;
    } else {
      e.canSkipDateRanges && (e.dateRanges = XKe(n.dateRanges, e, t));
      const u = n.fragments.filter((d) => d.rawProgramDateTime);
      if (n.hasProgramDateTime && !e.hasProgramDateTime)
        for (let d = 1; d < a.length; d++)
          a[d].programDateTime === null && S7(a[d], a[d - 1], u);
      ine(u, e);
    }
    e.endCC = o[o.length - 1].cc;
  }
  if (!e.startCC) {
    var l;
    const u = lne(n, e.startSN - 1);
    e.startCC = (l = u?.cc) != null ? l : o[0].cc;
  }
  ZKe(n.partList, e.partList, (u, d) => {
    d.elementaryStreams = u.elementaryStreams, d.stats = u.stats;
  }), s ? sne(e, s, s.startPTS, s.endPTS, s.startDTS, s.endDTS, t) : one(n, e), o.length && (e.totalduration = e.edge - o[0].start), e.driftStartTime = n.driftStartTime, e.driftStart = n.driftStart;
  const c = e.advancedDateTime;
  if (e.advanced && c) {
    const u = e.edge;
    e.driftStart || (e.driftStartTime = c, e.driftStart = u), e.driftEndTime = c, e.driftEnd = u;
  } else
    e.driftEndTime = n.driftEndTime, e.driftEnd = n.driftEnd, e.advancedDateTime = n.advancedDateTime;
  e.requestScheduled === -1 && (e.requestScheduled = n.requestScheduled);
}
function XKe(n, e, t) {
  const {
    dateRanges: r,
    recentlyRemovedDateranges: i
  } = e, s = mn({}, n);
  i && i.forEach((l) => {
    delete s[l];
  });
  const a = Object.keys(s).length;
  return a ? (Object.keys(r).forEach((l) => {
    const c = s[l], u = new Jte(r[l].attr, c);
    u.isValid ? (s[l] = u, c || (u.tagOrder += a)) : t.warn(`Ignoring invalid Playlist Delta Update DATERANGE tag: "${Sn(r[l].attr)}"`);
  }), s) : r;
}
function ZKe(n, e, t) {
  if (n && e) {
    let r = 0;
    for (let i = 0, s = n.length; i <= s; i++) {
      const o = n[i], a = e[i + r];
      o && a && o.index === a.index && o.fragment.sn === a.fragment.sn ? t(o, a) : r--;
    }
  }
}
function QKe(n, e, t) {
  const r = e.skippedSegments, i = Math.max(n.startSN, e.startSN) - e.startSN, s = (n.fragmentHint ? 1 : 0) + (r ? e.endSN : Math.min(n.endSN, e.endSN)) - e.startSN, o = e.startSN - n.startSN, a = e.fragmentHint ? e.fragments.concat(e.fragmentHint) : e.fragments, l = n.fragmentHint ? n.fragments.concat(n.fragmentHint) : n.fragments;
  for (let c = i; c <= s; c++) {
    const u = l[o + c];
    let d = a[c];
    if (r && !d && u && (d = e.fragments[c] = u), u && d) {
      t(u, d, c, a);
      const f = u.relurl, h = d.relurl;
      if (f && JKe(f, h)) {
        e.playlistParsingError = dH(`media sequence mismatch ${d.sn}:`, n, e, u, d);
        return;
      } else if (u.cc !== d.cc) {
        e.playlistParsingError = dH(`discontinuity sequence mismatch (${u.cc}!=${d.cc})`, n, e, u, d);
        return;
      }
    }
  }
}
function dH(n, e, t, r, i) {
  return new Error(`${n} ${i.url}
Playlist starting @${e.startSN}
${e.m3u8}

Playlist starting @${t.startSN}
${t.m3u8}`);
}
function one(n, e, t = !0) {
  const r = e.startSN + e.skippedSegments - n.startSN, i = n.fragments, s = r >= 0;
  let o = 0;
  if (s && r < i.length)
    o = i[r].start;
  else if (s && e.startSN === n.endSN + 1)
    o = n.fragmentEnd;
  else if (s && t)
    o = n.fragmentStart + r * e.levelTargetDuration;
  else if (!e.skippedSegments && e.fragmentStart === 0)
    o = n.fragmentStart;
  else
    return;
  C7(e, o);
}
function C7(n, e) {
  if (e) {
    const t = n.fragments;
    for (let r = n.skippedSegments; r < t.length; r++)
      t[r].addStart(e);
    n.fragmentHint && n.fragmentHint.addStart(e);
  }
}
function ane(n, e = 1 / 0) {
  let t = 1e3 * n.targetduration;
  if (n.updated) {
    const r = n.fragments;
    if (r.length && t * 4 > e) {
      const s = r[r.length - 1].duration * 1e3;
      s < t && (t = s);
    }
  } else
    t /= 2;
  return Math.round(t);
}
function lne(n, e, t) {
  if (!n)
    return null;
  let r = n.fragments[e - n.startSN];
  return r || (r = n.fragmentHint, r && r.sn === e) ? r : e < n.startSN && t && t.sn === e ? t : null;
}
function fH(n, e, t) {
  return n ? cne(n.partList, e, t) : null;
}
function cne(n, e, t) {
  if (n)
    for (let r = n.length; r--; ) {
      const i = n[r];
      if (i.index === t && i.fragment.sn === e)
        return i;
    }
  return null;
}
function une(n) {
  n.forEach((e, t) => {
    var r;
    (r = e.details) == null || r.fragments.forEach((i) => {
      i.level = t, i.initSegment && (i.initSegment.level = t);
    });
  });
}
function JKe(n, e) {
  return n !== e && e ? hH(n) !== hH(e) : !1;
}
function hH(n) {
  return n.replace(/\?[^?]*$/, "");
}
function Yp(n, e) {
  for (let r = 0, i = n.length; r < i; r++) {
    var t;
    if (((t = n[r]) == null ? void 0 : t.cc) === e)
      return n[r];
  }
  return null;
}
function eqe(n, e) {
  return !!(n && e.startCC < n.endCC && e.endCC > n.startCC);
}
function pH(n, e) {
  const t = n.start + e;
  n.startPTS = t, n.setStart(t), n.endPTS = t + n.duration;
}
function dne(n, e) {
  const t = e.fragments;
  for (let r = 0, i = t.length; r < i; r++)
    pH(t[r], n);
  e.fragmentHint && pH(e.fragmentHint, n), e.alignedSliding = !0;
}
function tqe(n, e) {
  n && (fne(e, n), e.alignedSliding || Gy(e, n), !e.alignedSliding && !e.skippedSegments && one(n, e, !1));
}
function fne(n, e) {
  if (!eqe(e, n))
    return;
  const t = Math.min(e.endCC, n.endCC), r = Yp(e.fragments, t), i = Yp(n.fragments, t);
  if (!r || !i)
    return;
  un.log(`Aligning playlist at start of dicontinuity sequence ${t}`);
  const s = r.start - i.start;
  dne(s, n);
}
function Gy(n, e) {
  if (!n.hasProgramDateTime || !e.hasProgramDateTime)
    return;
  const t = n.fragments, r = e.fragments;
  if (!t.length || !r.length)
    return;
  let i, s;
  const o = Math.min(e.endCC, n.endCC);
  e.startCC < o && n.startCC < o && (i = Yp(r, o), s = Yp(t, o)), (!i || !s) && (i = r[Math.floor(r.length / 2)], s = Yp(t, i.cc) || t[Math.floor(t.length / 2)]);
  const a = i.programDateTime, l = s.programDateTime;
  if (!a || !l)
    return;
  const c = (l - a) / 1e3 - (s.start - i.start);
  dne(c, n);
}
function gi(n, e, t) {
  Bi(n, e, t), n.addEventListener(e, t);
}
function Bi(n, e, t) {
  n.removeEventListener(e, t);
}
const nqe = {
  toString: function(n) {
    let e = "";
    const t = n.length;
    for (let r = 0; r < t; r++)
      e += `[${n.start(r).toFixed(3)}-${n.end(r).toFixed(3)}]`;
    return e;
  }
}, he = {
  STOPPED: "STOPPED",
  IDLE: "IDLE",
  KEY_LOADING: "KEY_LOADING",
  FRAG_LOADING: "FRAG_LOADING",
  FRAG_LOADING_WAITING_RETRY: "FRAG_LOADING_WAITING_RETRY",
  WAITING_TRACK: "WAITING_TRACK",
  PARSING: "PARSING",
  PARSED: "PARSED",
  ENDED: "ENDED",
  ERROR: "ERROR",
  WAITING_INIT_PTS: "WAITING_INIT_PTS",
  WAITING_LEVEL: "WAITING_LEVEL"
};
class x_ extends Zte {
  constructor(e, t, r, i, s) {
    super(i, e.logger), this.hls = void 0, this.fragPrevious = null, this.fragCurrent = null, this.fragmentTracker = void 0, this.transmuxer = null, this._state = he.STOPPED, this.playlistType = void 0, this.media = null, this.mediaBuffer = null, this.config = void 0, this.bitrateTest = !1, this.lastCurrentTime = 0, this.nextLoadPosition = 0, this.startPosition = 0, this.startTimeOffset = null, this.retryDate = 0, this.levels = null, this.fragmentLoader = void 0, this.keyLoader = void 0, this.levelLastLoaded = null, this.startFragRequested = !1, this.decrypter = void 0, this.initPTS = [], this.buffering = !0, this.loadingParts = !1, this.loopSn = void 0, this.onMediaSeeking = () => {
      const {
        config: o,
        fragCurrent: a,
        media: l,
        mediaBuffer: c,
        state: u
      } = this, d = l ? l.currentTime : 0, f = St.bufferInfo(c || l, d, o.maxBufferHole), h = !f.len;
      if (this.log(`Media seeking to ${He(d) ? d.toFixed(3) : d}, state: ${u}, ${h ? "out of" : "in"} buffer`), this.state === he.ENDED)
        this.resetLoadingState();
      else if (a) {
        const m = o.maxFragLookUpTolerance, g = a.start - m, v = a.start + a.duration + m;
        if (h || v < f.start || g > f.end) {
          const y = d > v;
          (d < g || y) && (y && a.loader && (this.log(`Cancelling fragment load for seek (sn: ${a.sn})`), a.abortRequests(), this.resetLoadingState()), this.fragPrevious = null);
        }
      }
      if (l) {
        this.fragmentTracker.removeFragmentsInRange(d, 1 / 0, this.playlistType, !0);
        const m = this.lastCurrentTime;
        if (d > m && (this.lastCurrentTime = d), !this.loadingParts) {
          const g = Math.max(f.end, d), v = this.shouldLoadParts(this.getLevelDetails(), g);
          v && (this.log(`LL-Part loading ON after seeking to ${d.toFixed(2)} with buffer @${g.toFixed(2)}`), this.loadingParts = v);
        }
      }
      this.hls.hasEnoughToStart || (this.log(`Setting ${h ? "startPosition" : "nextLoadPosition"} to ${d} for seek without enough to start`), this.nextLoadPosition = d, h && (this.startPosition = d)), h && this.state === he.IDLE && this.tickImmediate();
    }, this.onMediaEnded = () => {
      this.log("setting startPosition to 0 because media ended"), this.startPosition = this.lastCurrentTime = 0;
    }, this.playlistType = s, this.hls = e, this.fragmentLoader = new OKe(e.config), this.keyLoader = r, this.fragmentTracker = t, this.config = e.config, this.decrypter = new v_(e.config);
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(N.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(N.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(N.MANIFEST_LOADING, this.onManifestLoading, this), e.on(N.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(N.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(N.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(N.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(N.MANIFEST_LOADING, this.onManifestLoading, this), e.off(N.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(N.ERROR, this.onError, this);
  }
  doTick() {
    this.onTickEnd();
  }
  onTickEnd() {
  }
  startLoad(e) {
  }
  stopLoad() {
    if (this.state === he.STOPPED)
      return;
    this.fragmentLoader.abort(), this.keyLoader.abort(this.playlistType);
    const e = this.fragCurrent;
    e != null && e.loader && (e.abortRequests(), this.fragmentTracker.removeFragment(e)), this.resetTransmuxer(), this.fragCurrent = null, this.fragPrevious = null, this.clearInterval(), this.clearNextTick(), this.state = he.STOPPED;
  }
  get startPositionValue() {
    const {
      nextLoadPosition: e,
      startPosition: t
    } = this;
    return t === -1 && e ? e : t;
  }
  get bufferingEnabled() {
    return this.buffering;
  }
  pauseBuffering() {
    this.buffering = !1;
  }
  resumeBuffering() {
    this.buffering = !0;
  }
  get inFlightFrag() {
    return {
      frag: this.fragCurrent,
      state: this.state
    };
  }
  _streamEnded(e, t) {
    if (t.live || !this.media)
      return !1;
    const r = e.end || 0, i = this.config.timelineOffset || 0;
    if (r <= i)
      return !1;
    const s = e.buffered;
    this.config.maxBufferHole && s && s.length > 1 && (e = St.bufferedInfo(s, e.start, 0));
    const o = e.nextStart;
    if (o && o > i && o < t.edge || this.media.currentTime < e.start)
      return !1;
    const l = t.partList;
    if (l != null && l.length) {
      const u = l[l.length - 1];
      return St.isBuffered(this.media, u.start + u.duration / 2);
    }
    const c = t.fragments[t.fragments.length - 1].type;
    return this.fragmentTracker.isEndListAppended(c);
  }
  getLevelDetails() {
    if (this.levels && this.levelLastLoaded !== null)
      return this.levelLastLoaded.details;
  }
  get timelineOffset() {
    const e = this.config.timelineOffset;
    if (e) {
      var t;
      return ((t = this.getLevelDetails()) == null ? void 0 : t.appliedTimelineOffset) || e;
    }
    return 0;
  }
  onMediaAttached(e, t) {
    const r = this.media = this.mediaBuffer = t.media;
    gi(r, "seeking", this.onMediaSeeking), gi(r, "ended", this.onMediaEnded);
    const i = this.config;
    this.levels && i.autoStartLoad && this.state === he.STOPPED && this.startLoad(i.startPosition);
  }
  onMediaDetaching(e, t) {
    const r = !!t.transferMedia, i = this.media;
    if (i !== null) {
      if (i.ended && (this.log("MSE detaching and video ended, reset startPosition"), this.startPosition = this.lastCurrentTime = 0), Bi(i, "seeking", this.onMediaSeeking), Bi(i, "ended", this.onMediaEnded), this.keyLoader && !r && this.keyLoader.detach(), this.media = this.mediaBuffer = null, this.loopSn = void 0, r) {
        this.resetLoadingState(), this.resetTransmuxer();
        return;
      }
      this.loadingParts = !1, this.fragmentTracker.removeAllFragments(), this.stopLoad();
    }
  }
  onManifestLoading() {
    this.initPTS = [], this.levels = this.levelLastLoaded = this.fragCurrent = null, this.lastCurrentTime = this.startPosition = 0, this.startFragRequested = !1;
  }
  onError(e, t) {
  }
  onManifestLoaded(e, t) {
    this.startTimeOffset = t.startTimeOffset;
  }
  onHandlerDestroying() {
    this.stopLoad(), this.transmuxer && (this.transmuxer.destroy(), this.transmuxer = null), super.onHandlerDestroying(), this.hls = this.onMediaSeeking = this.onMediaEnded = null;
  }
  onHandlerDestroyed() {
    this.state = he.STOPPED, this.fragmentLoader && this.fragmentLoader.destroy(), this.keyLoader && this.keyLoader.destroy(), this.decrypter && this.decrypter.destroy(), this.hls = this.log = this.warn = this.decrypter = this.keyLoader = this.fragmentLoader = this.fragmentTracker = null, super.onHandlerDestroyed();
  }
  loadFragment(e, t, r) {
    this.startFragRequested = !0, this._loadFragForPlayback(e, t, r);
  }
  _loadFragForPlayback(e, t, r) {
    const i = (s) => {
      const o = s.frag;
      if (this.fragContextChanged(o)) {
        this.warn(`${o.type} sn: ${o.sn}${s.part ? " part: " + s.part.index : ""} of ${this.fragInfo(o, !1, s.part)}) was dropped during download.`), this.fragmentTracker.removeFragment(o);
        return;
      }
      o.stats.chunkCount++, this._handleFragmentLoadProgress(s);
    };
    this._doFragLoad(e, t, r, i).then((s) => {
      if (!s)
        return;
      const o = this.state, a = s.frag;
      if (this.fragContextChanged(a)) {
        (o === he.FRAG_LOADING || !this.fragCurrent && o === he.PARSING) && (this.fragmentTracker.removeFragment(a), this.state = he.IDLE);
        return;
      }
      "payload" in s && (this.log(`Loaded ${a.type} sn: ${a.sn} of ${this.playlistLabel()} ${a.level}`), this.hls.trigger(N.FRAG_LOADED, s)), this._handleFragmentLoadComplete(s);
    }).catch((s) => {
      this.state === he.STOPPED || this.state === he.ERROR || (this.warn(`Frag error: ${s?.message || s}`), this.resetFragmentLoading(e));
    });
  }
  clearTrackerIfNeeded(e) {
    var t;
    const {
      fragmentTracker: r
    } = this;
    if (r.getState(e) === wr.APPENDING) {
      const s = e.type, o = this.getFwdBufferInfo(this.mediaBuffer, s), a = Math.max(e.duration, o ? o.len : this.config.maxBufferLength), l = this.backtrackFragment;
      ((l ? e.sn - l.sn : 0) === 1 || this.reduceMaxBufferLength(a, e.duration)) && r.removeFragment(e);
    } else ((t = this.mediaBuffer) == null ? void 0 : t.buffered.length) === 0 ? r.removeAllFragments() : r.hasParts(e.type) && (r.detectPartialFragments({
      frag: e,
      part: null,
      stats: e.stats,
      id: e.type
    }), r.getState(e) === wr.PARTIAL && r.removeFragment(e));
  }
  checkLiveUpdate(e) {
    if (e.updated && !e.live) {
      const t = e.fragments[e.fragments.length - 1];
      this.fragmentTracker.detectPartialFragments({
        frag: t,
        part: null,
        stats: t.stats,
        id: t.type
      });
    }
    e.fragments[0] || (e.deltaUpdateFailed = !0);
  }
  waitForLive(e) {
    const t = e.details;
    return t?.live && t.type !== "EVENT" && (this.levelLastLoaded !== e || t.expired);
  }
  flushMainBuffer(e, t, r = null) {
    if (!(e - t))
      return;
    const i = {
      startOffset: e,
      endOffset: t,
      type: r
    };
    this.hls.trigger(N.BUFFER_FLUSHING, i);
  }
  _loadInitSegment(e, t) {
    this._doFragLoad(e, t).then((r) => {
      const i = r?.frag;
      if (!i || this.fragContextChanged(i) || !this.levels)
        throw new Error("init load aborted");
      return r;
    }).then((r) => {
      const {
        hls: i
      } = this, {
        frag: s,
        payload: o
      } = r, a = s.decryptdata;
      if (o && o.byteLength > 0 && a != null && a.key && a.iv && ff(a.method)) {
        const l = self.performance.now();
        return this.decrypter.decrypt(new Uint8Array(o), a.key.buffer, a.iv.buffer, b_(a.method)).catch((c) => {
          throw i.trigger(N.ERROR, {
            type: Je.MEDIA_ERROR,
            details: ce.FRAG_DECRYPT_ERROR,
            fatal: !1,
            error: c,
            reason: c.message,
            frag: s
          }), c;
        }).then((c) => {
          const u = self.performance.now();
          return i.trigger(N.FRAG_DECRYPTED, {
            frag: s,
            payload: c,
            stats: {
              tstart: l,
              tdecrypt: u
            }
          }), r.payload = c, this.completeInitSegmentLoad(r);
        });
      }
      return this.completeInitSegmentLoad(r);
    }).catch((r) => {
      this.state === he.STOPPED || this.state === he.ERROR || (this.warn(r), this.resetFragmentLoading(e));
    });
  }
  completeInitSegmentLoad(e) {
    const {
      levels: t
    } = this;
    if (!t)
      throw new Error("init load aborted, missing levels");
    const r = e.frag.stats;
    this.state !== he.STOPPED && (this.state = he.IDLE), e.frag.data = new Uint8Array(e.payload), r.parsing.start = r.buffering.start = self.performance.now(), r.parsing.end = r.buffering.end = self.performance.now(), this.tick();
  }
  unhandledEncryptionError(e, t) {
    var r, i;
    const s = e.tracks;
    if (s && !t.encrypted && ((r = s.audio) != null && r.encrypted || (i = s.video) != null && i.encrypted) && (!this.config.emeEnabled || !this.keyLoader.emeController)) {
      const o = this.media, a = new Error(`Encrypted track with no key in ${this.fragInfo(t)} (media ${o ? "attached mediaKeys: " + o.mediaKeys : "detached"})`);
      return this.warn(a.message), !o || o.mediaKeys ? !1 : (this.hls.trigger(N.ERROR, {
        type: Je.KEY_SYSTEM_ERROR,
        details: ce.KEY_SYSTEM_NO_KEYS,
        fatal: !1,
        error: a,
        frag: t
      }), this.resetTransmuxer(), !0);
    }
    return !1;
  }
  fragContextChanged(e) {
    const {
      fragCurrent: t
    } = this;
    return !e || !t || e.sn !== t.sn || e.level !== t.level;
  }
  fragBufferedComplete(e, t) {
    const r = this.mediaBuffer ? this.mediaBuffer : this.media;
    if (this.log(`Buffered ${e.type} sn: ${e.sn}${t ? " part: " + t.index : ""} of ${this.fragInfo(e, !1, t)} > buffer:${r ? nqe.toString(St.getBuffered(r)) : "(detached)"})`), tr(e)) {
      var i;
      if (e.type !== We.SUBTITLE) {
        const o = e.elementaryStreams;
        if (!Object.keys(o).some((a) => !!o[a])) {
          this.state = he.IDLE;
          return;
        }
      }
      const s = (i = this.levels) == null ? void 0 : i[e.level];
      s != null && s.fragmentError && (this.log(`Resetting level fragment error count of ${s.fragmentError} on frag buffered`), s.fragmentError = 0);
    }
    this.state = he.IDLE;
  }
  _handleFragmentLoadComplete(e) {
    const {
      transmuxer: t
    } = this;
    if (!t)
      return;
    const {
      frag: r,
      part: i,
      partsLoaded: s
    } = e, o = !s || s.length === 0 || s.some((l) => !l), a = new y_(r.level, r.sn, r.stats.chunkCount + 1, 0, i ? i.index : -1, !o);
    t.flush(a);
  }
  _handleFragmentLoadProgress(e) {
  }
  _doFragLoad(e, t, r = null, i) {
    var s;
    this.fragCurrent = e;
    const o = t.details;
    if (!this.levels || !o)
      throw new Error(`frag load aborted, missing level${o ? "" : " detail"}s`);
    let a = null;
    if (e.encrypted && !((s = e.decryptdata) != null && s.key)) {
      if (this.log(`Loading key for ${e.sn} of [${o.startSN}-${o.endSN}], ${this.playlistLabel()} ${e.level}`), this.state = he.KEY_LOADING, this.fragCurrent = e, a = this.keyLoader.load(e).then((f) => {
        if (!this.fragContextChanged(f.frag))
          return this.hls.trigger(N.KEY_LOADED, f), this.state === he.KEY_LOADING && (this.state = he.IDLE), f;
      }), this.hls.trigger(N.KEY_LOADING, {
        frag: e
      }), this.fragCurrent === null)
        return this.log("context changed in KEY_LOADING"), Promise.resolve(null);
    } else e.encrypted || (a = this.keyLoader.loadClear(e, o.encryptedFragments, this.startFragRequested), a && this.log("[eme] blocking frag load until media-keys acquired"));
    const l = this.fragPrevious;
    if (tr(e) && (!l || e.sn !== l.sn)) {
      const f = this.shouldLoadParts(t.details, e.end);
      f !== this.loadingParts && (this.log(`LL-Part loading ${f ? "ON" : "OFF"} loading sn ${l?.sn}->${e.sn}`), this.loadingParts = f);
    }
    if (r = Math.max(e.start, r || 0), this.loadingParts && tr(e)) {
      const f = o.partList;
      if (f && i) {
        r > o.fragmentEnd && o.fragmentHint && (e = o.fragmentHint);
        const h = this.getNextPart(f, e, r);
        if (h > -1) {
          const m = f[h];
          e = this.fragCurrent = m.fragment, this.log(`Loading ${e.type} sn: ${e.sn} part: ${m.index} (${h}/${f.length - 1}) of ${this.fragInfo(e, !1, m)}) cc: ${e.cc} [${o.startSN}-${o.endSN}], target: ${parseFloat(r.toFixed(3))}`), this.nextLoadPosition = m.start + m.duration, this.state = he.FRAG_LOADING;
          let g;
          return a ? g = a.then((v) => !v || this.fragContextChanged(v.frag) ? null : this.doFragPartsLoad(e, m, t, i)).catch((v) => this.handleFragLoadError(v)) : g = this.doFragPartsLoad(e, m, t, i).catch((v) => this.handleFragLoadError(v)), this.hls.trigger(N.FRAG_LOADING, {
            frag: e,
            part: m,
            targetBufferTime: r
          }), this.fragCurrent === null ? Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING parts")) : g;
        } else if (!e.url || this.loadedEndOfParts(f, r))
          return Promise.resolve(null);
      }
    }
    if (tr(e) && this.loadingParts) {
      var c;
      this.log(`LL-Part loading OFF after next part miss @${r.toFixed(2)} Check buffer at sn: ${e.sn} loaded parts: ${(c = o.partList) == null ? void 0 : c.filter((f) => f.loaded).map((f) => `[${f.start}-${f.end}]`)}`), this.loadingParts = !1;
    } else if (!e.url)
      return Promise.resolve(null);
    this.log(`Loading ${e.type} sn: ${e.sn} of ${this.fragInfo(e, !1)}) cc: ${e.cc} ${"[" + o.startSN + "-" + o.endSN + "]"}, target: ${parseFloat(r.toFixed(3))}`), He(e.sn) && !this.bitrateTest && (this.nextLoadPosition = e.start + e.duration), this.state = he.FRAG_LOADING;
    const u = this.config.progressive && e.type !== We.SUBTITLE;
    let d;
    return u && a ? d = a.then((f) => !f || this.fragContextChanged(f.frag) ? null : this.fragmentLoader.load(e, i)).catch((f) => this.handleFragLoadError(f)) : d = Promise.all([this.fragmentLoader.load(e, u ? i : void 0), a]).then(([f]) => (!u && i && i(f), f)).catch((f) => this.handleFragLoadError(f)), this.hls.trigger(N.FRAG_LOADING, {
      frag: e,
      targetBufferTime: r
    }), this.fragCurrent === null ? Promise.reject(new Error("frag load aborted, context changed in FRAG_LOADING")) : d;
  }
  doFragPartsLoad(e, t, r, i) {
    return new Promise((s, o) => {
      var a;
      const l = [], c = (a = r.details) == null ? void 0 : a.partList, u = (d) => {
        this.fragmentLoader.loadPart(e, d, i).then((f) => {
          l[d.index] = f;
          const h = f.part;
          this.hls.trigger(N.FRAG_LOADED, f);
          const m = fH(r.details, e.sn, d.index + 1) || cne(c, e.sn, d.index + 1);
          if (m)
            u(m);
          else
            return s({
              frag: e,
              part: h,
              partsLoaded: l
            });
        }).catch(o);
      };
      u(t);
    });
  }
  handleFragLoadError(e) {
    if ("data" in e) {
      const t = e.data;
      t.frag && t.details === ce.INTERNAL_ABORTED ? this.handleFragLoadAborted(t.frag, t.part) : t.frag && t.type === Je.KEY_SYSTEM_ERROR ? (t.frag.abortRequests(), this.resetStartWhenNotLoaded(), this.resetFragmentLoading(t.frag)) : this.hls.trigger(N.ERROR, t);
    } else
      this.hls.trigger(N.ERROR, {
        type: Je.OTHER_ERROR,
        details: ce.INTERNAL_EXCEPTION,
        err: e,
        error: e,
        fatal: !0
      });
    return null;
  }
  _handleTransmuxerFlush(e) {
    const t = this.getCurrentContext(e);
    if (!t || this.state !== he.PARSING) {
      !this.fragCurrent && this.state !== he.STOPPED && this.state !== he.ERROR && (this.state = he.IDLE);
      return;
    }
    const {
      frag: r,
      part: i,
      level: s
    } = t, o = self.performance.now();
    r.stats.parsing.end = o, i && (i.stats.parsing.end = o);
    const a = this.getLevelDetails(), c = a && r.sn > a.endSN || this.shouldLoadParts(a, r.end);
    c !== this.loadingParts && (this.log(`LL-Part loading ${c ? "ON" : "OFF"} after parsing segment ending @${r.end.toFixed(2)}`), this.loadingParts = c), this.updateLevelTiming(r, i, s, e.partial);
  }
  shouldLoadParts(e, t) {
    if (this.config.lowLatencyMode) {
      if (!e)
        return this.loadingParts;
      if (e.partList) {
        var r;
        const s = e.partList[0];
        if (s.fragment.type === We.SUBTITLE)
          return !1;
        const o = s.end + (((r = e.fragmentHint) == null ? void 0 : r.duration) || 0);
        if (t >= o) {
          var i;
          if ((this.hls.hasEnoughToStart ? ((i = this.media) == null ? void 0 : i.currentTime) || this.lastCurrentTime : this.getLoadPosition()) > s.start - s.fragment.duration)
            return !0;
        }
      }
    }
    return !1;
  }
  getCurrentContext(e) {
    const {
      levels: t,
      fragCurrent: r
    } = this, {
      level: i,
      sn: s,
      part: o
    } = e;
    if (!(t != null && t[i]))
      return this.warn(`Levels object was unset while buffering fragment ${s} of ${this.playlistLabel()} ${i}. The current chunk will not be buffered.`), null;
    const a = t[i], l = a.details, c = o > -1 ? fH(l, s, o) : null, u = c ? c.fragment : lne(l, s, r);
    return u ? (r && r !== u && (u.stats = r.stats), {
      frag: u,
      part: c,
      level: a
    }) : null;
  }
  bufferFragmentData(e, t, r, i, s) {
    if (this.state !== he.PARSING)
      return;
    const {
      data1: o,
      data2: a
    } = e;
    let l = o;
    if (a && (l = Vs(o, a)), !l.length)
      return;
    const c = this.initPTS[t.cc], u = c ? -c.baseTime / c.timescale : void 0, d = {
      type: e.type,
      frag: t,
      part: r,
      chunkMeta: i,
      offset: u,
      parent: t.type,
      data: l
    };
    if (this.hls.trigger(N.BUFFER_APPENDING, d), e.dropped && e.independent && !r) {
      if (s)
        return;
      this.flushBufferGap(t);
    }
  }
  flushBufferGap(e) {
    const t = this.media;
    if (!t)
      return;
    if (!St.isBuffered(t, t.currentTime)) {
      this.flushMainBuffer(0, e.start);
      return;
    }
    const r = t.currentTime, i = St.bufferInfo(t, r, 0), s = e.duration, o = Math.min(this.config.maxFragLookUpTolerance * 2, s * 0.25), a = Math.max(Math.min(e.start - o, i.end - o), r + o);
    e.start - a > o && this.flushMainBuffer(a, e.start);
  }
  getFwdBufferInfo(e, t) {
    var r;
    const i = this.getLoadPosition();
    if (!He(i))
      return null;
    const o = this.lastCurrentTime > i || (r = this.media) != null && r.paused ? 0 : this.config.maxBufferHole;
    return this.getFwdBufferInfoAtPos(e, i, t, o);
  }
  getFwdBufferInfoAtPos(e, t, r, i) {
    const s = St.bufferInfo(e, t, i);
    if (s.len === 0 && s.nextStart !== void 0) {
      const o = this.fragmentTracker.getBufferedFrag(t, r);
      if (o && (s.nextStart <= o.end || o.gap)) {
        const a = Math.max(Math.min(s.nextStart, o.end) - t, i);
        return St.bufferInfo(e, t, a);
      }
    }
    return s;
  }
  getMaxBufferLength(e) {
    const {
      config: t
    } = this;
    let r;
    return e ? r = Math.max(8 * t.maxBufferSize / e, t.maxBufferLength) : r = t.maxBufferLength, Math.min(r, t.maxMaxBufferLength);
  }
  reduceMaxBufferLength(e, t) {
    const r = this.config, i = Math.max(Math.min(e - t, r.maxBufferLength), t), s = Math.max(e - t * 3, r.maxMaxBufferLength / 2, i);
    return s >= i ? (r.maxMaxBufferLength = s, this.warn(`Reduce max buffer length to ${s}s`), !0) : !1;
  }
  getAppendedFrag(e, t = We.MAIN) {
    const r = this.fragmentTracker ? this.fragmentTracker.getAppendedFrag(e, t) : null;
    return r && "fragment" in r ? r.fragment : r;
  }
  getNextFragment(e, t) {
    const r = t.fragments, i = r.length;
    if (!i)
      return null;
    const {
      config: s
    } = this, o = r[0].start, a = s.lowLatencyMode && !!t.partList;
    let l = null;
    if (t.live) {
      const d = s.initialLiveManifestSize;
      if (i < d)
        return this.warn(`Not enough fragments to start playback (have: ${i}, need: ${d})`), null;
      if (!t.PTSKnown && !this.startFragRequested && this.startPosition === -1 || e < o) {
        var c;
        a && !this.loadingParts && (this.log("LL-Part loading ON for initial live fragment"), this.loadingParts = !0), l = this.getInitialLiveFragment(t);
        const f = this.hls.startPosition, h = this.hls.liveSyncPosition, m = l ? (f !== -1 && f >= o ? f : h) || l.start : e;
        this.log(`Setting startPosition to ${m} to match start frag at live edge. mainStart: ${f} liveSyncPosition: ${h} frag.start: ${(c = l) == null ? void 0 : c.start}`), this.startPosition = this.nextLoadPosition = m;
      }
    } else e <= o && (l = r[0]);
    if (!l) {
      const d = this.loadingParts ? t.partEnd : t.fragmentEnd;
      l = this.getFragmentAtPosition(e, d, t);
    }
    let u = this.filterReplacedPrimary(l, t);
    if (!u && l) {
      const d = l.sn - t.startSN;
      u = this.filterReplacedPrimary(r[d + 1] || null, t);
    }
    return this.mapToInitFragWhenRequired(u);
  }
  isLoopLoading(e, t) {
    const r = this.fragmentTracker.getState(e);
    return (r === wr.OK || r === wr.PARTIAL && !!e.gap) && this.nextLoadPosition > t;
  }
  getNextFragmentLoopLoading(e, t, r, i, s) {
    let o = null;
    if (e.gap && (o = this.getNextFragment(this.nextLoadPosition, t), o && !o.gap && r.nextStart)) {
      const a = this.getFwdBufferInfoAtPos(this.mediaBuffer ? this.mediaBuffer : this.media, r.nextStart, i, 0);
      if (a !== null && r.len + a.len >= s) {
        const l = o.sn;
        return this.loopSn !== l && (this.log(`buffer full after gaps in "${i}" playlist starting at sn: ${l}`), this.loopSn = l), null;
      }
    }
    return this.loopSn = void 0, o;
  }
  get primaryPrefetch() {
    if (mH(this.config)) {
      var e;
      if ((e = this.hls.interstitialsManager) == null || (e = e.playingItem) == null ? void 0 : e.event)
        return !0;
    }
    return !1;
  }
  filterReplacedPrimary(e, t) {
    if (!e)
      return e;
    if (mH(this.config) && e.type !== We.SUBTITLE) {
      const r = this.hls.interstitialsManager, i = r?.bufferingItem;
      if (i) {
        const o = i.event;
        if (o) {
          if (o.appendInPlace || Math.abs(e.start - i.start) > 1 || i.start === 0)
            return null;
        } else if (e.end <= i.start && t?.live === !1 || e.start > i.end && i.nextEvent && (i.nextEvent.appendInPlace || e.start - i.end > 1))
          return null;
      }
      const s = r?.playerQueue;
      if (s)
        for (let o = s.length; o--; ) {
          const a = s[o].interstitial;
          if (a.appendInPlace && e.start >= a.startTime && e.end <= a.resumeTime)
            return null;
        }
    }
    return e;
  }
  mapToInitFragWhenRequired(e) {
    return e != null && e.initSegment && !e.initSegment.data && !this.bitrateTest ? e.initSegment : e;
  }
  getNextPart(e, t, r) {
    let i = -1, s = !1, o = !0;
    for (let a = 0, l = e.length; a < l; a++) {
      const c = e[a];
      if (o = o && !c.independent, i > -1 && r < c.start)
        break;
      const u = c.loaded;
      u ? i = -1 : (s || (c.independent || o) && c.fragment === t) && (c.fragment !== t && this.warn(`Need buffer at ${r} but next unloaded part starts at ${c.start}`), i = a), s = u;
    }
    return i;
  }
  loadedEndOfParts(e, t) {
    let r;
    for (let i = e.length; i--; ) {
      if (r = e[i], !r.loaded)
        return !1;
      if (t > r.start)
        return !0;
    }
    return !1;
  }
  /*
   This method is used find the best matching first fragment for a live playlist. This fragment is used to calculate the
   "sliding" of the playlist, which is its offset from the start of playback. After sliding we can compute the real
   start and end times for each fragment in the playlist (after which this method will not need to be called).
  */
  getInitialLiveFragment(e) {
    const t = e.fragments, r = this.fragPrevious;
    let i = null;
    if (r) {
      if (e.hasProgramDateTime && (this.log(`Live playlist, switching playlist, load frag with same PDT: ${r.programDateTime}`), i = yKe(t, r.endProgramDateTime, this.config.maxFragLookUpTolerance)), !i) {
        const s = r.sn + 1;
        if (s >= e.startSN && s <= e.endSN) {
          const o = t[s - e.startSN];
          r.cc === o.cc && (i = o, this.log(`Live playlist, switching playlist, load frag with next SN: ${i.sn}`));
        }
        i || (i = qte(e, r.cc, r.end), i && this.log(`Live playlist, switching playlist, load frag with same CC: ${i.sn}`));
      }
    } else {
      const s = this.hls.liveSyncPosition;
      s !== null && (i = this.getFragmentAtPosition(s, this.bitrateTest ? e.fragmentEnd : e.edge, e));
    }
    return i;
  }
  /*
  This method finds the best matching fragment given the provided position.
   */
  getFragmentAtPosition(e, t, r) {
    const {
      config: i
    } = this;
    let {
      fragPrevious: s
    } = this, {
      fragments: o,
      endSN: a
    } = r;
    const {
      fragmentHint: l
    } = r, {
      maxFragLookUpTolerance: c
    } = i, u = r.partList, d = !!(this.loadingParts && u != null && u.length && l);
    d && !this.bitrateTest && u[u.length - 1].fragment.sn === l.sn && (o = o.concat(l), a = l.sn);
    let f;
    if (e < t) {
      var h;
      const g = e < this.lastCurrentTime || e > t - c || (h = this.media) != null && h.paused || !this.startFragRequested ? 0 : c;
      f = Bu(s, o, e, g);
    } else
      f = o[o.length - 1];
    if (f) {
      const m = f.sn - r.startSN, g = this.fragmentTracker.getState(f);
      if ((g === wr.OK || g === wr.PARTIAL && f.gap) && (s = f), s && f.sn === s.sn && (!d || u[0].fragment.sn > f.sn || !r.live) && f.level === s.level) {
        const y = o[m + 1];
        f.sn < a && this.fragmentTracker.getState(y) !== wr.OK ? f = y : f = null;
      }
    }
    return f;
  }
  alignPlaylists(e, t, r) {
    const i = e.fragments.length;
    if (!i)
      return this.warn("No fragments in live playlist"), 0;
    const s = e.fragmentStart, o = !t, a = e.alignedSliding && He(s);
    if (o || !a && !s) {
      tqe(r, e);
      const l = e.fragmentStart;
      return this.log(`Live playlist sliding: ${l.toFixed(2)} start-sn: ${t ? t.startSN : "na"}->${e.startSN} fragments: ${i}`), l;
    }
    return s;
  }
  waitForCdnTuneIn(e) {
    return e.live && e.canBlockReload && e.partTarget && e.tuneInGoal > Math.max(e.partHoldBack, e.partTarget * 3);
  }
  setStartPosition(e, t) {
    let r = this.startPosition;
    r < t && (r = -1);
    const i = this.timelineOffset;
    if (r === -1) {
      const s = this.startTimeOffset !== null, o = s ? this.startTimeOffset : e.startTimeOffset;
      o !== null && He(o) ? (r = t + o, o < 0 && (r += e.edge), r = Math.min(Math.max(t, r), t + e.totalduration), this.log(`Setting startPosition to ${r} for start time offset ${o} found in ${s ? "multivariant" : "media"} playlist`), this.startPosition = r) : e.live ? (r = this.hls.liveSyncPosition || t, this.log(`Setting startPosition to -1 to start at live edge ${r}`), this.startPosition = -1) : (this.log("setting startPosition to 0 by default"), this.startPosition = r = 0), this.lastCurrentTime = r + i;
    }
    this.nextLoadPosition = r + i;
  }
  getLoadPosition() {
    var e;
    const {
      media: t
    } = this;
    let r = 0;
    return (e = this.hls) != null && e.hasEnoughToStart && t ? r = t.currentTime : this.nextLoadPosition >= 0 && (r = this.nextLoadPosition), r;
  }
  handleFragLoadAborted(e, t) {
    this.transmuxer && e.type === this.playlistType && tr(e) && e.stats.aborted && (this.log(`Fragment ${e.sn}${t ? " part " + t.index : ""} of ${this.playlistLabel()} ${e.level} was aborted`), this.resetFragmentLoading(e));
  }
  resetFragmentLoading(e) {
    (!this.fragCurrent || !this.fragContextChanged(e) && this.state !== he.FRAG_LOADING_WAITING_RETRY) && (this.state = he.IDLE);
  }
  onFragmentOrKeyLoadError(e, t) {
    var r;
    if (t.chunkMeta && !t.frag) {
      const y = this.getCurrentContext(t.chunkMeta);
      y && (t.frag = y.frag);
    }
    const i = t.frag;
    if (!i || i.type !== e || !this.levels)
      return;
    if (this.fragContextChanged(i)) {
      var s;
      this.warn(`Frag load error must match current frag to retry ${i.url} > ${(s = this.fragCurrent) == null ? void 0 : s.url}`);
      return;
    }
    const o = t.details === ce.FRAG_GAP;
    o && this.fragmentTracker.fragBuffered(i, !0);
    const a = t.errorAction;
    if (!a) {
      this.state = he.ERROR;
      return;
    }
    const {
      action: l,
      flags: c,
      retryCount: u = 0,
      retryConfig: d
    } = a, f = !!d, h = f && l === $r.RetryRequest, m = f && !a.resolved && c === rs.MoveAllAlternatesMatchingHost, g = (r = this.hls.latestLevelDetails) == null ? void 0 : r.live;
    if (!h && m && tr(i) && !i.endList && g && !Xte(t))
      this.resetFragmentErrors(e), this.treatAsGap(i), a.resolved = !0;
    else if ((h || m) && u < d.maxNumRetry) {
      var v;
      const y = w7((v = t.response) == null ? void 0 : v.code), b = g_(d, u);
      if (this.resetStartWhenNotLoaded(), this.retryDate = self.performance.now() + b, this.state = he.FRAG_LOADING_WAITING_RETRY, a.resolved = !0, y) {
        this.log("Waiting for connection (offline)"), this.retryDate = 1 / 0, t.reason = "offline";
        return;
      }
      this.warn(`Fragment ${i.sn} of ${e} ${i.level} errored with ${t.details}, retrying loading ${u + 1}/${d.maxNumRetry} in ${b}ms`);
    } else if (d)
      if (this.resetFragmentErrors(e), u < d.maxNumRetry)
        !o && l !== $r.RemoveAlternatePermanently && (a.resolved = !0);
      else {
        this.warn(`${t.details} reached or exceeded max retry (${u})`);
        return;
      }
    else l === $r.SendAlternateToPenaltyBox ? this.state = he.WAITING_LEVEL : this.state = he.ERROR;
    this.tickImmediate();
  }
  checkRetryDate() {
    const e = self.performance.now(), t = this.retryDate, r = t === 1 / 0;
    (!t || e >= t || r && !w7(0)) && (r && this.log("Connection restored (online)"), this.resetStartWhenNotLoaded(), this.state = he.IDLE);
  }
  reduceLengthAndFlushBuffer(e) {
    if (this.state === he.PARSING || this.state === he.PARSED) {
      const t = e.frag, r = e.parent, i = this.getFwdBufferInfo(this.mediaBuffer, r), s = i && i.len > 0.5;
      s && this.reduceMaxBufferLength(i.len, t?.duration || 10);
      const o = !s;
      return o && this.warn(`Buffer full error while media.currentTime (${this.getLoadPosition()}) is not buffered, flush ${r} buffer`), t && (this.fragmentTracker.removeFragment(t), this.nextLoadPosition = t.start), this.resetLoadingState(), o;
    }
    return !1;
  }
  resetFragmentErrors(e) {
    e === We.AUDIO && (this.fragCurrent = null), this.hls.hasEnoughToStart || (this.startFragRequested = !1), this.state !== he.STOPPED && (this.state = he.IDLE);
  }
  afterBufferFlushed(e, t, r) {
    if (!e)
      return;
    const i = St.getBuffered(e);
    this.fragmentTracker.detectEvictedFragments(t, i, r), this.state === he.ENDED && this.resetLoadingState();
  }
  resetLoadingState() {
    this.log("Reset loading state"), this.fragCurrent = null, this.fragPrevious = null, this.state !== he.STOPPED && (this.state = he.IDLE);
  }
  resetStartWhenNotLoaded() {
    if (!this.hls.hasEnoughToStart) {
      this.startFragRequested = !1;
      const e = this.levelLastLoaded, t = e ? e.details : null;
      t != null && t.live ? (this.log("resetting startPosition for live start"), this.startPosition = -1, this.setStartPosition(t, t.fragmentStart), this.resetLoadingState()) : this.nextLoadPosition = this.startPosition;
    }
  }
  resetWhenMissingContext(e) {
    this.log(`Loading context changed while buffering sn ${e.sn} of ${this.playlistLabel()} ${e.level === -1 ? "<removed>" : e.level}. This chunk will not be buffered.`), this.removeUnbufferedFrags(), this.resetStartWhenNotLoaded(), this.resetLoadingState();
  }
  removeUnbufferedFrags(e = 0) {
    this.fragmentTracker.removeFragmentsInRange(e, 1 / 0, this.playlistType, !1, !0);
  }
  updateLevelTiming(e, t, r, i) {
    const s = r.details;
    if (!s) {
      this.warn("level.details undefined");
      return;
    }
    if (!Object.keys(e.elementaryStreams).reduce((l, c) => {
      const u = e.elementaryStreams[c];
      if (u) {
        const d = u.endPTS - u.startPTS;
        if (d <= 0)
          return this.warn(`Could not parse fragment ${e.sn} ${c} duration reliably (${d})`), l || !1;
        const f = i ? 0 : sne(s, e, u.startPTS, u.endPTS, u.startDTS, u.endDTS, this);
        return this.hls.trigger(N.LEVEL_PTS_UPDATED, {
          details: s,
          level: r,
          drift: f,
          type: c,
          frag: e,
          start: u.startPTS,
          end: u.endPTS
        }), !0;
      }
      return l;
    }, !1)) {
      var a;
      const l = ((a = this.transmuxer) == null ? void 0 : a.error) === null;
      if ((r.fragmentError === 0 || l && (r.fragmentError < 2 || e.endList)) && this.treatAsGap(e, r), l) {
        const c = new Error(`Found no media in fragment ${e.sn} of ${this.playlistLabel()} ${e.level} resetting transmuxer to fallback to playlist timing`);
        if (this.warn(c.message), this.hls.trigger(N.ERROR, {
          type: Je.MEDIA_ERROR,
          details: ce.FRAG_PARSING_ERROR,
          fatal: !1,
          error: c,
          frag: e,
          reason: `Found no media in msn ${e.sn} of ${this.playlistLabel()} "${r.url}"`
        }), !this.hls)
          return;
        this.resetTransmuxer();
      }
    }
    this.state = he.PARSED, this.log(`Parsed ${e.type} sn: ${e.sn}${t ? " part: " + t.index : ""} of ${this.fragInfo(e, !1, t)})`), this.hls.trigger(N.FRAG_PARSED, {
      frag: e,
      part: t
    });
  }
  playlistLabel() {
    return this.playlistType === We.MAIN ? "level" : "track";
  }
  fragInfo(e, t = !0, r) {
    var i, s;
    return `${this.playlistLabel()} ${e.level} (${r ? "part" : "frag"}:[${((i = t && !r ? e.startPTS : (r || e).start) != null ? i : NaN).toFixed(3)}-${((s = t && !r ? e.endPTS : (r || e).end) != null ? s : NaN).toFixed(3)}]${r && e.type === "main" ? "INDEPENDENT=" + (r.independent ? "YES" : "NO") : ""}`;
  }
  treatAsGap(e, t) {
    t && t.fragmentError++, e.gap = !0, this.fragmentTracker.removeFragment(e), this.fragmentTracker.fragBuffered(e, !0);
  }
  resetTransmuxer() {
    var e;
    (e = this.transmuxer) == null || e.reset();
  }
  recoverWorkerError(e) {
    e.event === "demuxerWorker" && (this.fragmentTracker.removeAllFragments(), this.transmuxer && (this.transmuxer.destroy(), this.transmuxer = null), this.resetStartWhenNotLoaded(), this.resetLoadingState());
  }
  set state(e) {
    const t = this._state;
    t !== e && (this._state = e, this.log(`${t}->${e}`));
  }
  get state() {
    return this._state;
  }
}
function mH(n) {
  return !!n.interstitialsController && n.enableInterstitialPlayback !== !1;
}
class hne {
  constructor() {
    this.chunks = [], this.dataLength = 0;
  }
  push(e) {
    this.chunks.push(e), this.dataLength += e.length;
  }
  flush() {
    const {
      chunks: e,
      dataLength: t
    } = this;
    let r;
    if (e.length)
      e.length === 1 ? r = e[0] : r = rqe(e, t);
    else return new Uint8Array(0);
    return this.reset(), r;
  }
  reset() {
    this.chunks.length = 0, this.dataLength = 0;
  }
}
function rqe(n, e) {
  const t = new Uint8Array(e);
  let r = 0;
  for (let i = 0; i < n.length; i++) {
    const s = n[i];
    t.set(s, r), r += s.length;
  }
  return t;
}
var A6 = { exports: {} }, gH;
function iqe() {
  return gH || (gH = 1, (function(n) {
    var e = Object.prototype.hasOwnProperty, t = "~";
    function r() {
    }
    Object.create && (r.prototype = /* @__PURE__ */ Object.create(null), new r().__proto__ || (t = !1));
    function i(l, c, u) {
      this.fn = l, this.context = c, this.once = u || !1;
    }
    function s(l, c, u, d, f) {
      if (typeof u != "function")
        throw new TypeError("The listener must be a function");
      var h = new i(u, d || l, f), m = t ? t + c : c;
      return l._events[m] ? l._events[m].fn ? l._events[m] = [l._events[m], h] : l._events[m].push(h) : (l._events[m] = h, l._eventsCount++), l;
    }
    function o(l, c) {
      --l._eventsCount === 0 ? l._events = new r() : delete l._events[c];
    }
    function a() {
      this._events = new r(), this._eventsCount = 0;
    }
    a.prototype.eventNames = function() {
      var c = [], u, d;
      if (this._eventsCount === 0) return c;
      for (d in u = this._events)
        e.call(u, d) && c.push(t ? d.slice(1) : d);
      return Object.getOwnPropertySymbols ? c.concat(Object.getOwnPropertySymbols(u)) : c;
    }, a.prototype.listeners = function(c) {
      var u = t ? t + c : c, d = this._events[u];
      if (!d) return [];
      if (d.fn) return [d.fn];
      for (var f = 0, h = d.length, m = new Array(h); f < h; f++)
        m[f] = d[f].fn;
      return m;
    }, a.prototype.listenerCount = function(c) {
      var u = t ? t + c : c, d = this._events[u];
      return d ? d.fn ? 1 : d.length : 0;
    }, a.prototype.emit = function(c, u, d, f, h, m) {
      var g = t ? t + c : c;
      if (!this._events[g]) return !1;
      var v = this._events[g], y = arguments.length, b, x;
      if (v.fn) {
        switch (v.once && this.removeListener(c, v.fn, void 0, !0), y) {
          case 1:
            return v.fn.call(v.context), !0;
          case 2:
            return v.fn.call(v.context, u), !0;
          case 3:
            return v.fn.call(v.context, u, d), !0;
          case 4:
            return v.fn.call(v.context, u, d, f), !0;
          case 5:
            return v.fn.call(v.context, u, d, f, h), !0;
          case 6:
            return v.fn.call(v.context, u, d, f, h, m), !0;
        }
        for (x = 1, b = new Array(y - 1); x < y; x++)
          b[x - 1] = arguments[x];
        v.fn.apply(v.context, b);
      } else {
        var E = v.length, w;
        for (x = 0; x < E; x++)
          switch (v[x].once && this.removeListener(c, v[x].fn, void 0, !0), y) {
            case 1:
              v[x].fn.call(v[x].context);
              break;
            case 2:
              v[x].fn.call(v[x].context, u);
              break;
            case 3:
              v[x].fn.call(v[x].context, u, d);
              break;
            case 4:
              v[x].fn.call(v[x].context, u, d, f);
              break;
            default:
              if (!b) for (w = 1, b = new Array(y - 1); w < y; w++)
                b[w - 1] = arguments[w];
              v[x].fn.apply(v[x].context, b);
          }
      }
      return !0;
    }, a.prototype.on = function(c, u, d) {
      return s(this, c, u, d, !1);
    }, a.prototype.once = function(c, u, d) {
      return s(this, c, u, d, !0);
    }, a.prototype.removeListener = function(c, u, d, f) {
      var h = t ? t + c : c;
      if (!this._events[h]) return this;
      if (!u)
        return o(this, h), this;
      var m = this._events[h];
      if (m.fn)
        m.fn === u && (!f || m.once) && (!d || m.context === d) && o(this, h);
      else {
        for (var g = 0, v = [], y = m.length; g < y; g++)
          (m[g].fn !== u || f && !m[g].once || d && m[g].context !== d) && v.push(m[g]);
        v.length ? this._events[h] = v.length === 1 ? v[0] : v : o(this, h);
      }
      return this;
    }, a.prototype.removeAllListeners = function(c) {
      var u;
      return c ? (u = t ? t + c : c, this._events[u] && o(this, u)) : (this._events = new r(), this._eventsCount = 0), this;
    }, a.prototype.off = a.prototype.removeListener, a.prototype.addListener = a.prototype.on, a.prefixed = t, a.EventEmitter = a, n.exports = a;
  })(A6)), A6.exports;
}
var sqe = iqe(), E_ = /* @__PURE__ */ OGe(sqe);
const S0 = "1.6.15", th = {};
function oqe() {
  return typeof __HLS_WORKER_BUNDLE__ == "function";
}
function aqe() {
  const n = th[S0];
  if (n)
    return n.clientCount++, n;
  const e = new self.Blob([`var exports={};var module={exports:exports};function define(f){f()};define.amd=true;(${__HLS_WORKER_BUNDLE__.toString()})(true);`], {
    type: "text/javascript"
  }), t = self.URL.createObjectURL(e), i = {
    worker: new self.Worker(t),
    objectURL: t,
    clientCount: 1
  };
  return th[S0] = i, i;
}
function lqe(n) {
  const e = th[n];
  if (e)
    return e.clientCount++, e;
  const t = new self.URL(n, self.location.href).href, i = {
    worker: new self.Worker(t),
    scriptURL: t,
    clientCount: 1
  };
  return th[n] = i, i;
}
function cqe(n) {
  const e = th[n || S0];
  if (e && e.clientCount-- === 1) {
    const {
      worker: r,
      objectURL: i
    } = e;
    delete th[n || S0], i && self.URL.revokeObjectURL(i), r.terminate();
  }
}
function pne(n, e) {
  return e + 10 <= n.length && n[e] === 51 && n[e + 1] === 68 && n[e + 2] === 73 && n[e + 3] < 255 && n[e + 4] < 255 && n[e + 6] < 128 && n[e + 7] < 128 && n[e + 8] < 128 && n[e + 9] < 128;
}
function S_(n, e) {
  return e + 10 <= n.length && n[e] === 73 && n[e + 1] === 68 && n[e + 2] === 51 && n[e + 3] < 255 && n[e + 4] < 255 && n[e + 6] < 128 && n[e + 7] < 128 && n[e + 8] < 128 && n[e + 9] < 128;
}
function W3(n, e) {
  let t = 0;
  return t = (n[e] & 127) << 21, t |= (n[e + 1] & 127) << 14, t |= (n[e + 2] & 127) << 7, t |= n[e + 3] & 127, t;
}
function C0(n, e) {
  const t = e;
  let r = 0;
  for (; S_(n, e); ) {
    r += 10;
    const i = W3(n, e + 6);
    r += i, pne(n, e + 10) && (r += 10), e += r;
  }
  if (r > 0)
    return n.subarray(t, t + r);
}
function uqe(n, e, t, r) {
  const i = [96e3, 88200, 64e3, 48e3, 44100, 32e3, 24e3, 22050, 16e3, 12e3, 11025, 8e3, 7350], s = e[t + 2], o = s >> 2 & 15;
  if (o > 12) {
    const h = new Error(`invalid ADTS sampling index:${o}`);
    n.emit(N.ERROR, N.ERROR, {
      type: Je.MEDIA_ERROR,
      details: ce.FRAG_PARSING_ERROR,
      fatal: !0,
      error: h,
      reason: h.message
    });
    return;
  }
  const a = (s >> 6 & 3) + 1, l = e[t + 3] >> 6 & 3 | (s & 1) << 2, c = "mp4a.40." + a, u = i[o];
  let d = o;
  (a === 5 || a === 29) && (d -= 3);
  const f = [a << 3 | (d & 14) >> 1, (d & 1) << 7 | l << 3];
  return un.log(`manifest codec:${r}, parsed codec:${c}, channels:${l}, rate:${u} (ADTS object type:${a} sampling index:${o})`), {
    config: f,
    samplerate: u,
    channelCount: l,
    codec: c,
    parsedCodec: c,
    manifestCodec: r
  };
}
function mne(n, e) {
  return n[e] === 255 && (n[e + 1] & 246) === 240;
}
function gne(n, e) {
  return n[e + 1] & 1 ? 7 : 9;
}
function C_(n, e) {
  return (n[e + 3] & 3) << 11 | n[e + 4] << 3 | (n[e + 5] & 224) >>> 5;
}
function dqe(n, e) {
  return e + 5 < n.length;
}
function Ky(n, e) {
  return e + 1 < n.length && mne(n, e);
}
function fqe(n, e) {
  return dqe(n, e) && mne(n, e) && C_(n, e) <= n.length - e;
}
function hqe(n, e) {
  if (Ky(n, e)) {
    const t = gne(n, e);
    if (e + t >= n.length)
      return !1;
    const r = C_(n, e);
    if (r <= t)
      return !1;
    const i = e + r;
    return i === n.length || Ky(n, i);
  }
  return !1;
}
function vne(n, e, t, r, i) {
  if (!n.samplerate) {
    const s = uqe(e, t, r, i);
    if (!s)
      return;
    mn(n, s);
  }
}
function yne(n) {
  return 1024 * 9e4 / n;
}
function pqe(n, e) {
  const t = gne(n, e);
  if (e + t <= n.length) {
    const r = C_(n, e) - t;
    if (r > 0)
      return {
        headerLength: t,
        frameLength: r
      };
  }
}
function bne(n, e, t, r, i) {
  const s = yne(n.samplerate), o = r + i * s, a = pqe(e, t);
  let l;
  if (a) {
    const {
      frameLength: d,
      headerLength: f
    } = a, h = f + d, m = Math.max(0, t + h - e.length);
    m ? (l = new Uint8Array(h - f), l.set(e.subarray(t + f, e.length), 0)) : l = e.subarray(t + f, t + h);
    const g = {
      unit: l,
      pts: o
    };
    return m || n.samples.push(g), {
      sample: g,
      length: h,
      missing: m
    };
  }
  const c = e.length - t;
  return l = new Uint8Array(c), l.set(e.subarray(t, e.length), 0), {
    sample: {
      unit: l,
      pts: o
    },
    length: c,
    missing: -1
  };
}
function mqe(n, e) {
  return S_(n, e) && W3(n, e + 6) + 10 <= n.length - e;
}
function gqe(n) {
  return n instanceof ArrayBuffer ? n : n.byteOffset == 0 && n.byteLength == n.buffer.byteLength ? n.buffer : new Uint8Array(n).buffer;
}
function M6(n, e = 0, t = 1 / 0) {
  return vqe(n, e, t, Uint8Array);
}
function vqe(n, e, t, r) {
  const i = yqe(n);
  let s = 1;
  "BYTES_PER_ELEMENT" in r && (s = r.BYTES_PER_ELEMENT);
  const o = bqe(n) ? n.byteOffset : 0, a = (o + n.byteLength) / s, l = (o + e) / s, c = Math.floor(Math.max(0, Math.min(l, a))), u = Math.floor(Math.min(c + Math.max(t, 0), a));
  return new r(i, c, u - c);
}
function yqe(n) {
  return n instanceof ArrayBuffer ? n : n.buffer;
}
function bqe(n) {
  return n && n.buffer instanceof ArrayBuffer && n.byteLength !== void 0 && n.byteOffset !== void 0;
}
function wqe(n) {
  const e = {
    key: n.type,
    description: "",
    data: "",
    mimeType: null,
    pictureType: null
  }, t = 3;
  if (n.size < 2)
    return;
  if (n.data[0] !== t) {
    console.log("Ignore frame with unrecognized character encoding");
    return;
  }
  const r = n.data.subarray(1).indexOf(0);
  if (r === -1)
    return;
  const i = gs(M6(n.data, 1, r)), s = n.data[2 + r], o = n.data.subarray(3 + r).indexOf(0);
  if (o === -1)
    return;
  const a = gs(M6(n.data, 3 + r, o));
  let l;
  return i === "-->" ? l = gs(M6(n.data, 4 + r + o)) : l = gqe(n.data.subarray(4 + r + o)), e.mimeType = i, e.pictureType = s, e.description = a, e.data = l, e;
}
function xqe(n) {
  if (n.size < 2)
    return;
  const e = gs(n.data, !0), t = new Uint8Array(n.data.subarray(e.length + 1));
  return {
    key: n.type,
    info: e,
    data: t.buffer
  };
}
function Eqe(n) {
  if (n.size < 2)
    return;
  if (n.type === "TXXX") {
    let t = 1;
    const r = gs(n.data.subarray(t), !0);
    t += r.length + 1;
    const i = gs(n.data.subarray(t));
    return {
      key: n.type,
      info: r,
      data: i
    };
  }
  const e = gs(n.data.subarray(1));
  return {
    key: n.type,
    info: "",
    data: e
  };
}
function Sqe(n) {
  if (n.type === "WXXX") {
    if (n.size < 2)
      return;
    let t = 1;
    const r = gs(n.data.subarray(t), !0);
    t += r.length + 1;
    const i = gs(n.data.subarray(t));
    return {
      key: n.type,
      info: r,
      data: i
    };
  }
  const e = gs(n.data);
  return {
    key: n.type,
    info: "",
    data: e
  };
}
function Cqe(n) {
  return n.type === "PRIV" ? xqe(n) : n.type[0] === "W" ? Sqe(n) : n.type === "APIC" ? wqe(n) : Eqe(n);
}
function Tqe(n) {
  const e = String.fromCharCode(n[0], n[1], n[2], n[3]), t = W3(n, 4), r = 10;
  return {
    type: e,
    size: t,
    data: n.subarray(r, r + t)
  };
}
const Ng = 10, Aqe = 10;
function wne(n) {
  let e = 0;
  const t = [];
  for (; S_(n, e); ) {
    const r = W3(n, e + 6);
    n[e + 5] >> 6 & 1 && (e += Ng), e += Ng;
    const i = e + r;
    for (; e + Aqe < i; ) {
      const s = Tqe(n.subarray(e)), o = Cqe(s);
      o && t.push(o), e += s.size + Ng;
    }
    pne(n, e) && (e += Ng);
  }
  return t;
}
function xne(n) {
  return n && n.key === "PRIV" && n.info === "com.apple.streaming.transportStreamTimestamp";
}
function Mqe(n) {
  if (n.data.byteLength === 8) {
    const e = new Uint8Array(n.data), t = e[3] & 1;
    let r = (e[4] << 23) + (e[5] << 15) + (e[6] << 7) + e[7];
    return r /= 45, t && (r += 4772185884e-2), Math.round(r);
  }
}
function T_(n) {
  const e = wne(n);
  for (let t = 0; t < e.length; t++) {
    const r = e[t];
    if (xne(r))
      return Mqe(r);
  }
}
let us = /* @__PURE__ */ (function(n) {
  return n.audioId3 = "org.id3", n.dateRange = "com.apple.quicktime.HLS", n.emsg = "https://aomedia.org/emsg/ID3", n.misbklv = "urn:misb:KLV:bin:1910.1", n;
})({});
function Xo(n = "", e = 9e4) {
  return {
    type: n,
    id: -1,
    pid: -1,
    inputTimeScale: e,
    sequenceNumber: -1,
    samples: [],
    dropped: 0
  };
}
class A_ {
  constructor() {
    this._audioTrack = void 0, this._id3Track = void 0, this.frameIndex = 0, this.cachedData = null, this.basePTS = null, this.initPTS = null, this.lastPTS = null;
  }
  resetInitSegment(e, t, r, i) {
    this._id3Track = {
      type: "id3",
      id: 3,
      pid: -1,
      inputTimeScale: 9e4,
      sequenceNumber: 0,
      samples: [],
      dropped: 0
    };
  }
  resetTimeStamp(e) {
    this.initPTS = e, this.resetContiguity();
  }
  resetContiguity() {
    this.basePTS = null, this.lastPTS = null, this.frameIndex = 0;
  }
  canParse(e, t) {
    return !1;
  }
  appendFrame(e, t, r) {
  }
  // feed incoming data to the front of the parsing pipeline
  demux(e, t) {
    this.cachedData && (e = Vs(this.cachedData, e), this.cachedData = null);
    let r = C0(e, 0), i = r ? r.length : 0, s;
    const o = this._audioTrack, a = this._id3Track, l = r ? T_(r) : void 0, c = e.length;
    for ((this.basePTS === null || this.frameIndex === 0 && He(l)) && (this.basePTS = kqe(l, t, this.initPTS), this.lastPTS = this.basePTS), this.lastPTS === null && (this.lastPTS = this.basePTS), r && r.length > 0 && a.samples.push({
      pts: this.lastPTS,
      dts: this.lastPTS,
      data: r,
      type: us.audioId3,
      duration: Number.POSITIVE_INFINITY
    }); i < c; ) {
      if (this.canParse(e, i)) {
        const u = this.appendFrame(o, e, i);
        u ? (this.frameIndex++, this.lastPTS = u.sample.pts, i += u.length, s = i) : i = c;
      } else mqe(e, i) ? (r = C0(e, i), a.samples.push({
        pts: this.lastPTS,
        dts: this.lastPTS,
        data: r,
        type: us.audioId3,
        duration: Number.POSITIVE_INFINITY
      }), i += r.length, s = i) : i++;
      if (i === c && s !== c) {
        const u = e.slice(s);
        this.cachedData ? this.cachedData = Vs(this.cachedData, u) : this.cachedData = u;
      }
    }
    return {
      audioTrack: o,
      videoTrack: Xo(),
      id3Track: a,
      textTrack: Xo()
    };
  }
  demuxSampleAes(e, t, r) {
    return Promise.reject(new Error(`[${this}] This demuxer does not support Sample-AES decryption`));
  }
  flush(e) {
    const t = this.cachedData;
    return t && (this.cachedData = null, this.demux(t, 0)), {
      audioTrack: this._audioTrack,
      videoTrack: Xo(),
      id3Track: this._id3Track,
      textTrack: Xo()
    };
  }
  destroy() {
    this.cachedData = null, this._audioTrack = this._id3Track = void 0;
  }
}
const kqe = (n, e, t) => {
  if (He(n))
    return n * 90;
  const r = t ? t.baseTime * 9e4 / t.timescale : 0;
  return e * 9e4 + r;
};
let Lg = null;
const _qe = [32, 64, 96, 128, 160, 192, 224, 256, 288, 320, 352, 384, 416, 448, 32, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 384, 32, 40, 48, 56, 64, 80, 96, 112, 128, 160, 192, 224, 256, 320, 32, 48, 56, 64, 80, 96, 112, 128, 144, 160, 176, 192, 224, 256, 8, 16, 24, 32, 40, 48, 56, 64, 80, 96, 112, 128, 144, 160], Oqe = [44100, 48e3, 32e3, 22050, 24e3, 16e3, 11025, 12e3, 8e3], Iqe = [
  // MPEG 2.5
  [
    0,
    // Reserved
    72,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ],
  // Reserved
  [
    0,
    // Reserved
    0,
    // Layer3
    0,
    // Layer2
    0
    // Layer1
  ],
  // MPEG 2
  [
    0,
    // Reserved
    72,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ],
  // MPEG 1
  [
    0,
    // Reserved
    144,
    // Layer3
    144,
    // Layer2
    12
    // Layer1
  ]
], Rqe = [
  0,
  // Reserved
  1,
  // Layer3
  1,
  // Layer2
  4
  // Layer1
];
function Ene(n, e, t, r, i) {
  if (t + 24 > e.length)
    return;
  const s = Sne(e, t);
  if (s && t + s.frameLength <= e.length) {
    const o = s.samplesPerFrame * 9e4 / s.sampleRate, a = r + i * o, l = {
      unit: e.subarray(t, t + s.frameLength),
      pts: a,
      dts: a
    };
    return n.config = [], n.channelCount = s.channelCount, n.samplerate = s.sampleRate, n.samples.push(l), {
      sample: l,
      length: s.frameLength,
      missing: 0
    };
  }
}
function Sne(n, e) {
  const t = n[e + 1] >> 3 & 3, r = n[e + 1] >> 1 & 3, i = n[e + 2] >> 4 & 15, s = n[e + 2] >> 2 & 3;
  if (t !== 1 && i !== 0 && i !== 15 && s !== 3) {
    const o = n[e + 2] >> 1 & 1, a = n[e + 3] >> 6, l = t === 3 ? 3 - r : r === 3 ? 3 : 4, c = _qe[l * 14 + i - 1] * 1e3, d = Oqe[(t === 3 ? 0 : t === 2 ? 1 : 2) * 3 + s], f = a === 3 ? 1 : 2, h = Iqe[t][r], m = Rqe[r], g = h * 8 * m, v = Math.floor(h * c / d + o) * m;
    if (Lg === null) {
      const x = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
      Lg = x ? parseInt(x[1]) : 0;
    }
    return !!Lg && Lg <= 87 && r === 2 && c >= 224e3 && a === 0 && (n[e + 3] = n[e + 3] | 128), {
      sampleRate: d,
      channelCount: f,
      frameLength: v,
      samplesPerFrame: g
    };
  }
}
function M_(n, e) {
  return n[e] === 255 && (n[e + 1] & 224) === 224 && (n[e + 1] & 6) !== 0;
}
function Cne(n, e) {
  return e + 1 < n.length && M_(n, e);
}
function Pqe(n, e) {
  return M_(n, e) && 4 <= n.length - e;
}
function Tne(n, e) {
  if (e + 1 < n.length && M_(n, e)) {
    const r = Sne(n, e);
    let i = 4;
    r != null && r.frameLength && (i = r.frameLength);
    const s = e + i;
    return s === n.length || Cne(n, s);
  }
  return !1;
}
class Dqe extends A_ {
  constructor(e, t) {
    super(), this.observer = void 0, this.config = void 0, this.observer = e, this.config = t;
  }
  resetInitSegment(e, t, r, i) {
    super.resetInitSegment(e, t, r, i), this._audioTrack = {
      container: "audio/adts",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "aac",
      samples: [],
      manifestCodec: t,
      duration: i,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  // Source for probe info - https://wiki.multimedia.cx/index.php?title=ADTS
  static probe(e, t) {
    if (!e)
      return !1;
    const r = C0(e, 0);
    let i = r?.length || 0;
    if (Tne(e, i))
      return !1;
    for (let s = e.length; i < s; i++)
      if (hqe(e, i))
        return t.log("ADTS sync word found !"), !0;
    return !1;
  }
  canParse(e, t) {
    return fqe(e, t);
  }
  appendFrame(e, t, r) {
    vne(e, this.observer, t, r, e.manifestCodec);
    const i = bne(e, t, r, this.basePTS, this.frameIndex);
    if (i && i.missing === 0)
      return i;
  }
}
const Ane = (n, e) => {
  let t = 0, r = 5;
  e += r;
  const i = new Uint32Array(1), s = new Uint32Array(1), o = new Uint8Array(1);
  for (; r > 0; ) {
    o[0] = n[e];
    const a = Math.min(r, 8), l = 8 - a;
    s[0] = 4278190080 >>> 24 + l << l, i[0] = (o[0] & s[0]) >> l, t = t ? t << a | i[0] : i[0], e += 1, r -= a;
  }
  return t;
};
class Nqe extends A_ {
  constructor(e) {
    super(), this.observer = void 0, this.observer = e;
  }
  resetInitSegment(e, t, r, i) {
    super.resetInitSegment(e, t, r, i), this._audioTrack = {
      container: "audio/ac-3",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "ac3",
      samples: [],
      manifestCodec: t,
      duration: i,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  canParse(e, t) {
    return t + 64 < e.length;
  }
  appendFrame(e, t, r) {
    const i = Mne(e, t, r, this.basePTS, this.frameIndex);
    if (i !== -1)
      return {
        sample: e.samples[e.samples.length - 1],
        length: i,
        missing: 0
      };
  }
  static probe(e) {
    if (!e)
      return !1;
    const t = C0(e, 0);
    if (!t)
      return !1;
    const r = t.length;
    return e[r] === 11 && e[r + 1] === 119 && T_(t) !== void 0 && // check the bsid to confirm ac-3
    Ane(e, r) < 16;
  }
}
function Mne(n, e, t, r, i) {
  if (t + 8 > e.length || e[t] !== 11 || e[t + 1] !== 119)
    return -1;
  const s = e[t + 4] >> 6;
  if (s >= 3)
    return -1;
  const a = [48e3, 44100, 32e3][s], l = e[t + 4] & 63, u = [64, 69, 96, 64, 70, 96, 80, 87, 120, 80, 88, 120, 96, 104, 144, 96, 105, 144, 112, 121, 168, 112, 122, 168, 128, 139, 192, 128, 140, 192, 160, 174, 240, 160, 175, 240, 192, 208, 288, 192, 209, 288, 224, 243, 336, 224, 244, 336, 256, 278, 384, 256, 279, 384, 320, 348, 480, 320, 349, 480, 384, 417, 576, 384, 418, 576, 448, 487, 672, 448, 488, 672, 512, 557, 768, 512, 558, 768, 640, 696, 960, 640, 697, 960, 768, 835, 1152, 768, 836, 1152, 896, 975, 1344, 896, 976, 1344, 1024, 1114, 1536, 1024, 1115, 1536, 1152, 1253, 1728, 1152, 1254, 1728, 1280, 1393, 1920, 1280, 1394, 1920][l * 3 + s] * 2;
  if (t + u > e.length)
    return -1;
  const d = e[t + 6] >> 5;
  let f = 0;
  d === 2 ? f += 2 : (d & 1 && d !== 1 && (f += 2), d & 4 && (f += 2));
  const h = (e[t + 6] << 8 | e[t + 7]) >> 12 - f & 1, g = [2, 1, 2, 3, 3, 4, 4, 5][d] + h, v = e[t + 5] >> 3, y = e[t + 5] & 7, b = new Uint8Array([s << 6 | v << 1 | y >> 2, (y & 3) << 6 | d << 3 | h << 2 | l >> 4, l << 4 & 224]), x = 1536 / a * 9e4, E = r + i * x, w = e.subarray(t, t + u);
  return n.config = b, n.channelCount = g, n.samplerate = a, n.samples.push({
    unit: w,
    pts: E
  }), u;
}
class Lqe extends A_ {
  resetInitSegment(e, t, r, i) {
    super.resetInitSegment(e, t, r, i), this._audioTrack = {
      container: "audio/mpeg",
      type: "audio",
      id: 2,
      pid: -1,
      sequenceNumber: 0,
      segmentCodec: "mp3",
      samples: [],
      manifestCodec: t,
      duration: i,
      inputTimeScale: 9e4,
      dropped: 0
    };
  }
  static probe(e) {
    if (!e)
      return !1;
    const t = C0(e, 0);
    let r = t?.length || 0;
    if (t && e[r] === 11 && e[r + 1] === 119 && T_(t) !== void 0 && // check the bsid to confirm ac-3 or ec-3 (not mp3)
    Ane(e, r) <= 16)
      return !1;
    for (let i = e.length; r < i; r++)
      if (Tne(e, r))
        return un.log("MPEG Audio sync word found !"), !0;
    return !1;
  }
  canParse(e, t) {
    return Pqe(e, t);
  }
  appendFrame(e, t, r) {
    if (this.basePTS !== null)
      return Ene(e, t, r, this.basePTS, this.frameIndex);
  }
}
const $qe = /\/emsg[-/]ID3/i;
class Fqe {
  constructor(e, t) {
    this.remainderData = null, this.timeOffset = 0, this.config = void 0, this.videoTrack = void 0, this.audioTrack = void 0, this.id3Track = void 0, this.txtTrack = void 0, this.config = t;
  }
  resetTimeStamp() {
  }
  resetInitSegment(e, t, r, i) {
    const s = this.videoTrack = Xo("video", 1), o = this.audioTrack = Xo("audio", 1), a = this.txtTrack = Xo("text", 1);
    if (this.id3Track = Xo("id3", 1), this.timeOffset = 0, !(e != null && e.byteLength))
      return;
    const l = $te(e);
    if (l.video) {
      const {
        id: c,
        timescale: u,
        codec: d,
        supplemental: f
      } = l.video;
      s.id = c, s.timescale = a.timescale = u, s.codec = d, s.supplemental = f;
    }
    if (l.audio) {
      const {
        id: c,
        timescale: u,
        codec: d
      } = l.audio;
      o.id = c, o.timescale = u, o.codec = d;
    }
    a.id = Dte.text, s.sampleDuration = 0, s.duration = o.duration = i;
  }
  resetContiguity() {
    this.remainderData = null;
  }
  static probe(e) {
    return NGe(e);
  }
  demux(e, t) {
    this.timeOffset = t;
    let r = e;
    const i = this.videoTrack, s = this.txtTrack;
    if (this.config.progressive) {
      this.remainderData && (r = Vs(this.remainderData, e));
      const a = UGe(r);
      this.remainderData = a.remainder, i.samples = a.valid || new Uint8Array();
    } else
      i.samples = r;
    const o = this.extractID3Track(i, t);
    return s.samples = Dz(t, i), {
      videoTrack: i,
      audioTrack: this.audioTrack,
      id3Track: o,
      textTrack: this.txtTrack
    };
  }
  flush() {
    const e = this.timeOffset, t = this.videoTrack, r = this.txtTrack;
    t.samples = this.remainderData || new Uint8Array(), this.remainderData = null;
    const i = this.extractID3Track(t, this.timeOffset);
    return r.samples = Dz(e, t), {
      videoTrack: t,
      audioTrack: Xo(),
      id3Track: i,
      textTrack: Xo()
    };
  }
  extractID3Track(e, t) {
    const r = this.id3Track;
    if (e.samples.length) {
      const i = Rt(e.samples, ["emsg"]);
      i && i.forEach((s) => {
        const o = jGe(s);
        if ($qe.test(o.schemeIdUri)) {
          const a = vH(o, t);
          let l = o.eventDuration === 4294967295 ? Number.POSITIVE_INFINITY : o.eventDuration / o.timeScale;
          l <= 1e-3 && (l = Number.POSITIVE_INFINITY);
          const c = o.payload;
          r.samples.push({
            data: c,
            len: c.byteLength,
            dts: a,
            pts: a,
            type: us.emsg,
            duration: l
          });
        } else if (this.config.enableEmsgKLVMetadata && o.schemeIdUri.startsWith("urn:misb:KLV:bin:1910.1")) {
          const a = vH(o, t);
          r.samples.push({
            data: o.payload,
            len: o.payload.byteLength,
            dts: a,
            pts: a,
            type: us.misbklv,
            duration: Number.POSITIVE_INFINITY
          });
        }
      });
    }
    return r;
  }
  demuxSampleAes(e, t, r) {
    return Promise.reject(new Error("The MP4 demuxer does not support SAMPLE-AES decryption"));
  }
  destroy() {
    this.config = null, this.remainderData = null, this.videoTrack = this.audioTrack = this.id3Track = this.txtTrack = void 0;
  }
}
function vH(n, e) {
  return He(n.presentationTime) ? n.presentationTime / n.timeScale : e + n.presentationTimeDelta / n.timeScale;
}
class Bqe {
  constructor(e, t, r) {
    this.keyData = void 0, this.decrypter = void 0, this.keyData = r, this.decrypter = new v_(t, {
      removePKCS7Padding: !1
    });
  }
  decryptBuffer(e) {
    return this.decrypter.decrypt(e, this.keyData.key.buffer, this.keyData.iv.buffer, vc.cbc);
  }
  // AAC - encrypt all full 16 bytes blocks starting from offset 16
  decryptAacSample(e, t, r) {
    const i = e[t].unit;
    if (i.length <= 16)
      return;
    const s = i.subarray(16, i.length - i.length % 16), o = s.buffer.slice(s.byteOffset, s.byteOffset + s.length);
    this.decryptBuffer(o).then((a) => {
      const l = new Uint8Array(a);
      i.set(l, 16), this.decrypter.isSync() || this.decryptAacSamples(e, t + 1, r);
    }).catch(r);
  }
  decryptAacSamples(e, t, r) {
    for (; ; t++) {
      if (t >= e.length) {
        r();
        return;
      }
      if (!(e[t].unit.length < 32) && (this.decryptAacSample(e, t, r), !this.decrypter.isSync()))
        return;
    }
  }
  // AVC - encrypt one 16 bytes block out of ten, starting from offset 32
  getAvcEncryptedData(e) {
    const t = Math.floor((e.length - 48) / 160) * 16 + 16, r = new Int8Array(t);
    let i = 0;
    for (let s = 32; s < e.length - 16; s += 160, i += 16)
      r.set(e.subarray(s, s + 16), i);
    return r;
  }
  getAvcDecryptedUnit(e, t) {
    const r = new Uint8Array(t);
    let i = 0;
    for (let s = 32; s < e.length - 16; s += 160, i += 16)
      e.set(r.subarray(i, i + 16), s);
    return e;
  }
  decryptAvcSample(e, t, r, i, s) {
    const o = zte(s.data), a = this.getAvcEncryptedData(o);
    this.decryptBuffer(a.buffer).then((l) => {
      s.data = this.getAvcDecryptedUnit(o, l), this.decrypter.isSync() || this.decryptAvcSamples(e, t, r + 1, i);
    }).catch(i);
  }
  decryptAvcSamples(e, t, r, i) {
    if (e instanceof Uint8Array)
      throw new Error("Cannot decrypt samples of type Uint8Array");
    for (; ; t++, r = 0) {
      if (t >= e.length) {
        i();
        return;
      }
      const s = e[t].units;
      for (; !(r >= s.length); r++) {
        const o = s[r];
        if (!(o.data.length <= 48 || o.type !== 1 && o.type !== 5) && (this.decryptAvcSample(e, t, r, i, o), !this.decrypter.isSync()))
          return;
      }
    }
  }
}
class kne {
  constructor() {
    this.VideoSample = null;
  }
  createVideoSample(e, t, r) {
    return {
      key: e,
      frame: !1,
      pts: t,
      dts: r,
      units: [],
      length: 0
    };
  }
  getLastNalUnit(e) {
    var t;
    let r = this.VideoSample, i;
    if ((!r || r.units.length === 0) && (r = e[e.length - 1]), (t = r) != null && t.units) {
      const s = r.units;
      i = s[s.length - 1];
    }
    return i;
  }
  pushAccessUnit(e, t) {
    if (e.units.length && e.frame) {
      if (e.pts === void 0) {
        const r = t.samples, i = r.length;
        if (i) {
          const s = r[i - 1];
          e.pts = s.pts, e.dts = s.dts;
        } else {
          t.dropped++;
          return;
        }
      }
      t.samples.push(e);
    }
  }
  parseNALu(e, t, r) {
    const i = t.byteLength;
    let s = e.naluState || 0;
    const o = s, a = [];
    let l = 0, c, u, d, f = -1, h = 0;
    for (s === -1 && (f = 0, h = this.getNALuType(t, 0), s = 0, l = 1); l < i; ) {
      if (c = t[l++], !s) {
        s = c ? 0 : 1;
        continue;
      }
      if (s === 1) {
        s = c ? 0 : 2;
        continue;
      }
      if (!c)
        s = 3;
      else if (c === 1) {
        if (u = l - s - 1, f >= 0) {
          const m = {
            data: t.subarray(f, u),
            type: h
          };
          a.push(m);
        } else {
          const m = this.getLastNalUnit(e.samples);
          m && (o && l <= 4 - o && m.state && (m.data = m.data.subarray(0, m.data.byteLength - o)), u > 0 && (m.data = Vs(m.data, t.subarray(0, u)), m.state = 0));
        }
        l < i ? (d = this.getNALuType(t, l), f = l, h = d, s = 0) : s = -1;
      } else
        s = 0;
    }
    if (f >= 0 && s >= 0) {
      const m = {
        data: t.subarray(f, i),
        type: h,
        state: s
      };
      a.push(m);
    }
    if (a.length === 0) {
      const m = this.getLastNalUnit(e.samples);
      m && (m.data = Vs(m.data, t));
    }
    return e.naluState = s, a;
  }
}
class Xp {
  constructor(e) {
    this.data = void 0, this.bytesAvailable = void 0, this.word = void 0, this.bitsAvailable = void 0, this.data = e, this.bytesAvailable = e.byteLength, this.word = 0, this.bitsAvailable = 0;
  }
  // ():void
  loadWord() {
    const e = this.data, t = this.bytesAvailable, r = e.byteLength - t, i = new Uint8Array(4), s = Math.min(4, t);
    if (s === 0)
      throw new Error("no bytes available");
    i.set(e.subarray(r, r + s)), this.word = new DataView(i.buffer).getUint32(0), this.bitsAvailable = s * 8, this.bytesAvailable -= s;
  }
  // (count:int):void
  skipBits(e) {
    let t;
    e = Math.min(e, this.bytesAvailable * 8 + this.bitsAvailable), this.bitsAvailable > e ? (this.word <<= e, this.bitsAvailable -= e) : (e -= this.bitsAvailable, t = e >> 3, e -= t << 3, this.bytesAvailable -= t, this.loadWord(), this.word <<= e, this.bitsAvailable -= e);
  }
  // (size:int):uint
  readBits(e) {
    let t = Math.min(this.bitsAvailable, e);
    const r = this.word >>> 32 - t;
    if (e > 32 && un.error("Cannot read more than 32 bits at a time"), this.bitsAvailable -= t, this.bitsAvailable > 0)
      this.word <<= t;
    else if (this.bytesAvailable > 0)
      this.loadWord();
    else
      throw new Error("no bits available");
    return t = e - t, t > 0 && this.bitsAvailable ? r << t | this.readBits(t) : r;
  }
  // ():uint
  skipLZ() {
    let e;
    for (e = 0; e < this.bitsAvailable; ++e)
      if ((this.word & 2147483648 >>> e) !== 0)
        return this.word <<= e, this.bitsAvailable -= e, e;
    return this.loadWord(), e + this.skipLZ();
  }
  // ():void
  skipUEG() {
    this.skipBits(1 + this.skipLZ());
  }
  // ():void
  skipEG() {
    this.skipBits(1 + this.skipLZ());
  }
  // ():uint
  readUEG() {
    const e = this.skipLZ();
    return this.readBits(e + 1) - 1;
  }
  // ():int
  readEG() {
    const e = this.readUEG();
    return 1 & e ? 1 + e >>> 1 : -1 * (e >>> 1);
  }
  // Some convenience functions
  // :Boolean
  readBoolean() {
    return this.readBits(1) === 1;
  }
  // ():int
  readUByte() {
    return this.readBits(8);
  }
  // ():int
  readUShort() {
    return this.readBits(16);
  }
  // ():int
  readUInt() {
    return this.readBits(32);
  }
}
class zqe extends kne {
  parsePES(e, t, r, i) {
    const s = this.parseNALu(e, r.data, i);
    let o = this.VideoSample, a, l = !1;
    r.data = null, o && s.length && !e.audFound && (this.pushAccessUnit(o, e), o = this.VideoSample = this.createVideoSample(!1, r.pts, r.dts)), s.forEach((c) => {
      var u, d;
      switch (c.type) {
        // NDR
        case 1: {
          let g = !1;
          a = !0;
          const v = c.data;
          if (l && v.length > 4) {
            const y = this.readSliceType(v);
            (y === 2 || y === 4 || y === 7 || y === 9) && (g = !0);
          }
          if (g) {
            var f;
            (f = o) != null && f.frame && !o.key && (this.pushAccessUnit(o, e), o = this.VideoSample = null);
          }
          o || (o = this.VideoSample = this.createVideoSample(!0, r.pts, r.dts)), o.frame = !0, o.key = g;
          break;
        }
        case 5:
          a = !0, (u = o) != null && u.frame && !o.key && (this.pushAccessUnit(o, e), o = this.VideoSample = null), o || (o = this.VideoSample = this.createVideoSample(!0, r.pts, r.dts)), o.key = !0, o.frame = !0;
          break;
        // SEI
        case 6: {
          a = !0, h_(c.data, 1, r.pts, t.samples);
          break;
        }
        case 7: {
          var h, m;
          a = !0, l = !0;
          const g = c.data, v = this.readSPS(g);
          if (!e.sps || e.width !== v.width || e.height !== v.height || ((h = e.pixelRatio) == null ? void 0 : h[0]) !== v.pixelRatio[0] || ((m = e.pixelRatio) == null ? void 0 : m[1]) !== v.pixelRatio[1]) {
            e.width = v.width, e.height = v.height, e.pixelRatio = v.pixelRatio, e.sps = [g];
            const y = g.subarray(1, 4);
            let b = "avc1.";
            for (let x = 0; x < 3; x++) {
              let E = y[x].toString(16);
              E.length < 2 && (E = "0" + E), b += E;
            }
            e.codec = b;
          }
          break;
        }
        // PPS
        case 8:
          a = !0, e.pps = [c.data];
          break;
        // AUD
        case 9:
          a = !0, e.audFound = !0, (d = o) != null && d.frame && (this.pushAccessUnit(o, e), o = null), o || (o = this.VideoSample = this.createVideoSample(!1, r.pts, r.dts));
          break;
        // Filler Data
        case 12:
          a = !0;
          break;
        default:
          a = !1;
          break;
      }
      o && a && o.units.push(c);
    }), i && o && (this.pushAccessUnit(o, e), this.VideoSample = null);
  }
  getNALuType(e, t) {
    return e[t] & 31;
  }
  readSliceType(e) {
    const t = new Xp(e);
    return t.readUByte(), t.readUEG(), t.readUEG();
  }
  /**
   * The scaling list is optionally transmitted as part of a sequence parameter
   * set and is not relevant to transmuxing.
   * @param count the number of entries in this scaling list
   * @see Recommendation ITU-T H.264, Section 7.3.2.1.1.1
   */
  skipScalingList(e, t) {
    let r = 8, i = 8, s;
    for (let o = 0; o < e; o++)
      i !== 0 && (s = t.readEG(), i = (r + s + 256) % 256), r = i === 0 ? r : i;
  }
  /**
   * Read a sequence parameter set and return some interesting video
   * properties. A sequence parameter set is the H264 metadata that
   * describes the properties of upcoming video frames.
   * @returns an object with configuration parsed from the
   * sequence parameter set, including the dimensions of the
   * associated video frames.
   */
  readSPS(e) {
    const t = new Xp(e);
    let r = 0, i = 0, s = 0, o = 0, a, l, c;
    const u = t.readUByte.bind(t), d = t.readBits.bind(t), f = t.readUEG.bind(t), h = t.readBoolean.bind(t), m = t.skipBits.bind(t), g = t.skipEG.bind(t), v = t.skipUEG.bind(t), y = this.skipScalingList.bind(this);
    u();
    const b = u();
    if (d(5), m(3), u(), v(), b === 100 || b === 110 || b === 122 || b === 244 || b === 44 || b === 83 || b === 86 || b === 118 || b === 128) {
      const M = f();
      if (M === 3 && m(1), v(), v(), m(1), h())
        for (l = M !== 3 ? 8 : 12, c = 0; c < l; c++)
          h() && (c < 6 ? y(16, t) : y(64, t));
    }
    v();
    const x = f();
    if (x === 0)
      f();
    else if (x === 1)
      for (m(1), g(), g(), a = f(), c = 0; c < a; c++)
        g();
    v(), m(1);
    const E = f(), w = f(), C = d(1);
    C === 0 && m(1), m(1), h() && (r = f(), i = f(), s = f(), o = f());
    let S = [1, 1];
    if (h() && h())
      switch (u()) {
        case 1:
          S = [1, 1];
          break;
        case 2:
          S = [12, 11];
          break;
        case 3:
          S = [10, 11];
          break;
        case 4:
          S = [16, 11];
          break;
        case 5:
          S = [40, 33];
          break;
        case 6:
          S = [24, 11];
          break;
        case 7:
          S = [20, 11];
          break;
        case 8:
          S = [32, 11];
          break;
        case 9:
          S = [80, 33];
          break;
        case 10:
          S = [18, 11];
          break;
        case 11:
          S = [15, 11];
          break;
        case 12:
          S = [64, 33];
          break;
        case 13:
          S = [160, 99];
          break;
        case 14:
          S = [4, 3];
          break;
        case 15:
          S = [3, 2];
          break;
        case 16:
          S = [2, 1];
          break;
        case 255: {
          S = [u() << 8 | u(), u() << 8 | u()];
          break;
        }
      }
    return {
      width: Math.ceil((E + 1) * 16 - r * 2 - i * 2),
      height: (2 - C) * (w + 1) * 16 - (C ? 2 : 4) * (s + o),
      pixelRatio: S
    };
  }
}
class Hqe extends kne {
  constructor(...e) {
    super(...e), this.initVPS = null;
  }
  parsePES(e, t, r, i) {
    const s = this.parseNALu(e, r.data, i);
    let o = this.VideoSample, a, l = !1;
    r.data = null, o && s.length && !e.audFound && (this.pushAccessUnit(o, e), o = this.VideoSample = this.createVideoSample(!1, r.pts, r.dts)), s.forEach((c) => {
      var u, d;
      switch (c.type) {
        // NON-IDR, NON RANDOM ACCESS SLICE
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
          o || (o = this.VideoSample = this.createVideoSample(!1, r.pts, r.dts)), o.frame = !0, a = !0;
          break;
        // CRA, BLA (random access picture)
        case 16:
        case 17:
        case 18:
        case 21:
          if (a = !0, l) {
            var f;
            (f = o) != null && f.frame && !o.key && (this.pushAccessUnit(o, e), o = this.VideoSample = null);
          }
          o || (o = this.VideoSample = this.createVideoSample(!0, r.pts, r.dts)), o.key = !0, o.frame = !0;
          break;
        // IDR
        case 19:
        case 20:
          a = !0, (u = o) != null && u.frame && !o.key && (this.pushAccessUnit(o, e), o = this.VideoSample = null), o || (o = this.VideoSample = this.createVideoSample(!0, r.pts, r.dts)), o.key = !0, o.frame = !0;
          break;
        // SEI
        case 39:
          a = !0, h_(
            c.data,
            2,
            // NALu header size
            r.pts,
            t.samples
          );
          break;
        // VPS
        case 32:
          a = !0, e.vps || (typeof e.params != "object" && (e.params = {}), e.params = mn(e.params, this.readVPS(c.data)), this.initVPS = c.data), e.vps = [c.data];
          break;
        // SPS
        case 33:
          if (a = !0, l = !0, e.vps !== void 0 && e.vps[0] !== this.initVPS && e.sps !== void 0 && !this.matchSPS(e.sps[0], c.data) && (this.initVPS = e.vps[0], e.sps = e.pps = void 0), !e.sps) {
            const h = this.readSPS(c.data);
            e.width = h.width, e.height = h.height, e.pixelRatio = h.pixelRatio, e.codec = h.codecString, e.sps = [], typeof e.params != "object" && (e.params = {});
            for (const m in h.params)
              e.params[m] = h.params[m];
          }
          this.pushParameterSet(e.sps, c.data, e.vps), o || (o = this.VideoSample = this.createVideoSample(!0, r.pts, r.dts)), o.key = !0;
          break;
        // PPS
        case 34:
          if (a = !0, typeof e.params == "object") {
            if (!e.pps) {
              e.pps = [];
              const h = this.readPPS(c.data);
              for (const m in h)
                e.params[m] = h[m];
            }
            this.pushParameterSet(e.pps, c.data, e.vps);
          }
          break;
        // ACCESS UNIT DELIMITER
        case 35:
          a = !0, e.audFound = !0, (d = o) != null && d.frame && (this.pushAccessUnit(o, e), o = null), o || (o = this.VideoSample = this.createVideoSample(!1, r.pts, r.dts));
          break;
        default:
          a = !1;
          break;
      }
      o && a && o.units.push(c);
    }), i && o && (this.pushAccessUnit(o, e), this.VideoSample = null);
  }
  pushParameterSet(e, t, r) {
    (r && r[0] === this.initVPS || !r && !e.length) && e.push(t);
  }
  getNALuType(e, t) {
    return (e[t] & 126) >>> 1;
  }
  ebsp2rbsp(e) {
    const t = new Uint8Array(e.byteLength);
    let r = 0;
    for (let i = 0; i < e.byteLength; i++)
      i >= 2 && e[i] === 3 && e[i - 1] === 0 && e[i - 2] === 0 || (t[r] = e[i], r++);
    return new Uint8Array(t.buffer, 0, r);
  }
  pushAccessUnit(e, t) {
    super.pushAccessUnit(e, t), this.initVPS && (this.initVPS = null);
  }
  readVPS(e) {
    const t = new Xp(e);
    t.readUByte(), t.readUByte(), t.readBits(4), t.skipBits(2), t.readBits(6);
    const r = t.readBits(3), i = t.readBoolean();
    return {
      numTemporalLayers: r + 1,
      temporalIdNested: i
    };
  }
  readSPS(e) {
    const t = new Xp(this.ebsp2rbsp(e));
    t.readUByte(), t.readUByte(), t.readBits(4);
    const r = t.readBits(3);
    t.readBoolean();
    const i = t.readBits(2), s = t.readBoolean(), o = t.readBits(5), a = t.readUByte(), l = t.readUByte(), c = t.readUByte(), u = t.readUByte(), d = t.readUByte(), f = t.readUByte(), h = t.readUByte(), m = t.readUByte(), g = t.readUByte(), v = t.readUByte(), y = t.readUByte(), b = [], x = [];
    for (let ve = 0; ve < r; ve++)
      b.push(t.readBoolean()), x.push(t.readBoolean());
    if (r > 0)
      for (let ve = r; ve < 8; ve++)
        t.readBits(2);
    for (let ve = 0; ve < r; ve++)
      b[ve] && (t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte(), t.readUByte()), x[ve] && t.readUByte();
    t.readUEG();
    const E = t.readUEG();
    E == 3 && t.skipBits(1);
    const w = t.readUEG(), C = t.readUEG(), S = t.readBoolean();
    let M = 0, k = 0, _ = 0, O = 0;
    S && (M += t.readUEG(), k += t.readUEG(), _ += t.readUEG(), O += t.readUEG());
    const I = t.readUEG(), R = t.readUEG(), P = t.readUEG(), D = t.readBoolean();
    for (let ve = D ? 0 : r; ve <= r; ve++)
      t.skipUEG(), t.skipUEG(), t.skipUEG();
    if (t.skipUEG(), t.skipUEG(), t.skipUEG(), t.skipUEG(), t.skipUEG(), t.skipUEG(), t.readBoolean() && t.readBoolean())
      for (let Ie = 0; Ie < 4; Ie++)
        for (let mt = 0; mt < (Ie === 3 ? 2 : 6); mt++)
          if (!t.readBoolean())
            t.readUEG();
          else {
            const G = Math.min(64, 1 << 4 + (Ie << 1));
            Ie > 1 && t.readEG();
            for (let re = 0; re < G; re++)
              t.readEG();
          }
    t.readBoolean(), t.readBoolean(), t.readBoolean() && (t.readUByte(), t.skipUEG(), t.skipUEG(), t.readBoolean());
    const $ = t.readUEG();
    let z = 0;
    for (let ve = 0; ve < $; ve++) {
      let Ie = !1;
      if (ve !== 0 && (Ie = t.readBoolean()), Ie) {
        ve === $ && t.readUEG(), t.readBoolean(), t.readUEG();
        let mt = 0;
        for (let xt = 0; xt <= z; xt++) {
          const G = t.readBoolean();
          let re = !1;
          G || (re = t.readBoolean()), (G || re) && mt++;
        }
        z = mt;
      } else {
        const mt = t.readUEG(), xt = t.readUEG();
        z = mt + xt;
        for (let G = 0; G < mt; G++)
          t.readUEG(), t.readBoolean();
        for (let G = 0; G < xt; G++)
          t.readUEG(), t.readBoolean();
      }
    }
    if (t.readBoolean()) {
      const ve = t.readUEG();
      for (let Ie = 0; Ie < ve; Ie++) {
        for (let mt = 0; mt < P + 4; mt++)
          t.readBits(1);
        t.readBits(1);
      }
    }
    let U = 0, F = 1, V = 1, X = !0, Z = 1, ie = 0;
    t.readBoolean(), t.readBoolean();
    let J = !1;
    if (t.readBoolean()) {
      if (t.readBoolean()) {
        const oe = t.readUByte(), Se = [1, 12, 10, 16, 40, 24, 20, 32, 80, 18, 15, 64, 160, 4, 3, 2], ye = [1, 11, 11, 11, 33, 11, 11, 11, 33, 11, 11, 33, 99, 3, 2, 1];
        oe > 0 && oe < 16 ? (F = Se[oe - 1], V = ye[oe - 1]) : oe === 255 && (F = t.readBits(16), V = t.readBits(16));
      }
      if (t.readBoolean() && t.readBoolean(), t.readBoolean() && (t.readBits(3), t.readBoolean(), t.readBoolean() && (t.readUByte(), t.readUByte(), t.readUByte())), t.readBoolean() && (t.readUEG(), t.readUEG()), t.readBoolean(), t.readBoolean(), t.readBoolean(), J = t.readBoolean(), J && (t.skipUEG(), t.skipUEG(), t.skipUEG(), t.skipUEG()), t.readBoolean() && (Z = t.readBits(32), ie = t.readBits(32), t.readBoolean() && t.readUEG(), t.readBoolean())) {
        const ye = t.readBoolean(), be = t.readBoolean();
        let Oe = !1;
        (ye || be) && (Oe = t.readBoolean(), Oe && (t.readUByte(), t.readBits(5), t.readBoolean(), t.readBits(5)), t.readBits(4), t.readBits(4), Oe && t.readBits(4), t.readBits(5), t.readBits(5), t.readBits(5));
        for (let ut = 0; ut <= r; ut++) {
          X = t.readBoolean();
          const Et = X || t.readBoolean();
          let Yt = !1;
          Et ? t.readEG() : Yt = t.readBoolean();
          const Wt = Yt ? 1 : t.readUEG() + 1;
          if (ye)
            for (let me = 0; me < Wt; me++)
              t.readUEG(), t.readUEG(), Oe && (t.readUEG(), t.readUEG()), t.skipBits(1);
          if (be)
            for (let me = 0; me < Wt; me++)
              t.readUEG(), t.readUEG(), Oe && (t.readUEG(), t.readUEG()), t.skipBits(1);
        }
      }
      t.readBoolean() && (t.readBoolean(), t.readBoolean(), t.readBoolean(), U = t.readUEG());
    }
    let te = w, le = C;
    if (S) {
      let ve = 1, Ie = 1;
      E === 1 ? ve = Ie = 2 : E == 2 && (ve = 2), te = w - ve * k - ve * M, le = C - Ie * O - Ie * _;
    }
    const de = i ? ["A", "B", "C"][i] : "", j = a << 24 | l << 16 | c << 8 | u;
    let xe = 0;
    for (let ve = 0; ve < 32; ve++)
      xe = (xe | (j >> ve & 1) << 31 - ve) >>> 0;
    let ne = xe.toString(16);
    return o === 1 && ne === "2" && (ne = "6"), {
      codecString: `hvc1.${de}${o}.${ne}.${s ? "H" : "L"}${y}.B0`,
      params: {
        general_tier_flag: s,
        general_profile_idc: o,
        general_profile_space: i,
        general_profile_compatibility_flags: [a, l, c, u],
        general_constraint_indicator_flags: [d, f, h, m, g, v],
        general_level_idc: y,
        bit_depth: I + 8,
        bit_depth_luma_minus8: I,
        bit_depth_chroma_minus8: R,
        min_spatial_segmentation_idc: U,
        chroma_format_idc: E,
        frame_rate: {
          fixed: X,
          fps: ie / Z
        }
      },
      width: te,
      height: le,
      pixelRatio: [F, V]
    };
  }
  readPPS(e) {
    const t = new Xp(this.ebsp2rbsp(e));
    t.readUByte(), t.readUByte(), t.skipUEG(), t.skipUEG(), t.skipBits(2), t.skipBits(3), t.skipBits(2), t.skipUEG(), t.skipUEG(), t.skipEG(), t.skipBits(2), t.readBoolean() && t.skipUEG(), t.skipEG(), t.skipEG(), t.skipBits(4);
    const i = t.readBoolean(), s = t.readBoolean();
    let o = 1;
    return s && i ? o = 0 : s ? o = 3 : i && (o = 2), {
      parallelismType: o
    };
  }
  matchSPS(e, t) {
    return String.fromCharCode.apply(null, e).substr(3) === String.fromCharCode.apply(null, t).substr(3);
  }
}
const Ar = 188;
class Bl {
  constructor(e, t, r, i) {
    this.logger = void 0, this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.sampleAes = null, this.pmtParsed = !1, this.audioCodec = void 0, this.videoCodec = void 0, this._pmtId = -1, this._videoTrack = void 0, this._audioTrack = void 0, this._id3Track = void 0, this._txtTrack = void 0, this.aacOverFlow = null, this.remainderData = null, this.videoParser = void 0, this.observer = e, this.config = t, this.typeSupported = r, this.logger = i, this.videoParser = null;
  }
  static probe(e, t) {
    const r = Bl.syncOffset(e);
    return r > 0 && t.warn(`MPEG2-TS detected but first sync word found @ offset ${r}`), r !== -1;
  }
  static syncOffset(e) {
    const t = e.length;
    let r = Math.min(Ar * 5, t - Ar) + 1, i = 0;
    for (; i < r; ) {
      let s = !1, o = -1, a = 0;
      for (let l = i; l < t; l += Ar)
        if (e[l] === 71 && (t - l === Ar || e[l + Ar] === 71)) {
          if (a++, o === -1 && (o = l, o !== 0 && (r = Math.min(o + Ar * 99, e.length - Ar) + 1)), s || (s = T7(e, l) === 0), s && a > 1 && (o === 0 && a > 2 || l + Ar > r))
            return o;
        } else {
          if (a)
            return -1;
          break;
        }
      i++;
    }
    return -1;
  }
  /**
   * Creates a track model internal to demuxer used to drive remuxing input
   */
  static createTrack(e, t) {
    return {
      container: e === "video" || e === "audio" ? "video/mp2t" : void 0,
      type: e,
      id: Dte[e],
      pid: -1,
      inputTimeScale: 9e4,
      sequenceNumber: 0,
      samples: [],
      dropped: 0,
      duration: e === "audio" ? t : void 0
    };
  }
  /**
   * Initializes a new init segment on the demuxer/remuxer interface. Needed for discontinuities/track-switches (or at stream start)
   * Resets all internal track instances of the demuxer.
   */
  resetInitSegment(e, t, r, i) {
    this.pmtParsed = !1, this._pmtId = -1, this._videoTrack = Bl.createTrack("video"), this._videoTrack.duration = i, this._audioTrack = Bl.createTrack("audio", i), this._id3Track = Bl.createTrack("id3"), this._txtTrack = Bl.createTrack("text"), this._audioTrack.segmentCodec = "aac", this.videoParser = null, this.aacOverFlow = null, this.remainderData = null, this.audioCodec = t, this.videoCodec = r;
  }
  resetTimeStamp() {
  }
  resetContiguity() {
    const {
      _audioTrack: e,
      _videoTrack: t,
      _id3Track: r
    } = this;
    e && (e.pesData = null), t && (t.pesData = null), r && (r.pesData = null), this.aacOverFlow = null, this.remainderData = null;
  }
  demux(e, t, r = !1, i = !1) {
    r || (this.sampleAes = null);
    let s;
    const o = this._videoTrack, a = this._audioTrack, l = this._id3Track, c = this._txtTrack;
    let u = o.pid, d = o.pesData, f = a.pid, h = l.pid, m = a.pesData, g = l.pesData, v = null, y = this.pmtParsed, b = this._pmtId, x = e.length;
    if (this.remainderData && (e = Vs(this.remainderData, e), x = e.length, this.remainderData = null), x < Ar && !i)
      return this.remainderData = e, {
        audioTrack: a,
        videoTrack: o,
        id3Track: l,
        textTrack: c
      };
    const E = Math.max(0, Bl.syncOffset(e));
    x -= (x - E) % Ar, x < e.byteLength && !i && (this.remainderData = new Uint8Array(e.buffer, x, e.buffer.byteLength - x));
    let w = 0;
    for (let S = E; S < x; S += Ar)
      if (e[S] === 71) {
        const M = !!(e[S + 1] & 64), k = T7(e, S), _ = (e[S + 3] & 48) >> 4;
        let O;
        if (_ > 1) {
          if (O = S + 5 + e[S + 4], O === S + Ar)
            continue;
        } else
          O = S + 4;
        switch (k) {
          case u:
            M && (d && (s = Md(d, this.logger)) && (this.readyVideoParser(o.segmentCodec), this.videoParser !== null && this.videoParser.parsePES(o, c, s, !1)), d = {
              data: [],
              size: 0
            }), d && (d.data.push(e.subarray(O, S + Ar)), d.size += S + Ar - O);
            break;
          case f:
            if (M) {
              if (m && (s = Md(m, this.logger)))
                switch (a.segmentCodec) {
                  case "aac":
                    this.parseAACPES(a, s);
                    break;
                  case "mp3":
                    this.parseMPEGPES(a, s);
                    break;
                  case "ac3":
                    this.parseAC3PES(a, s);
                    break;
                }
              m = {
                data: [],
                size: 0
              };
            }
            m && (m.data.push(e.subarray(O, S + Ar)), m.size += S + Ar - O);
            break;
          case h:
            M && (g && (s = Md(g, this.logger)) && this.parseID3PES(l, s), g = {
              data: [],
              size: 0
            }), g && (g.data.push(e.subarray(O, S + Ar)), g.size += S + Ar - O);
            break;
          case 0:
            M && (O += e[O] + 1), b = this._pmtId = Uqe(e, O);
            break;
          case b: {
            M && (O += e[O] + 1);
            const I = Vqe(e, O, this.typeSupported, r, this.observer, this.logger);
            u = I.videoPid, u > 0 && (o.pid = u, o.segmentCodec = I.segmentVideoCodec), f = I.audioPid, f > 0 && (a.pid = f, a.segmentCodec = I.segmentAudioCodec), h = I.id3Pid, h > 0 && (l.pid = h), v !== null && !y && (this.logger.warn(`MPEG-TS PMT found at ${S} after unknown PID '${v}'. Backtracking to sync byte @${E} to parse all TS packets.`), v = null, S = E - 188), y = this.pmtParsed = !0;
            break;
          }
          case 17:
          case 8191:
            break;
          default:
            v = k;
            break;
        }
      } else
        w++;
    w > 0 && A7(this.observer, new Error(`Found ${w} TS packet/s that do not start with 0x47`), void 0, this.logger), o.pesData = d, a.pesData = m, l.pesData = g;
    const C = {
      audioTrack: a,
      videoTrack: o,
      id3Track: l,
      textTrack: c
    };
    return i && this.extractRemainingSamples(C), C;
  }
  flush() {
    const {
      remainderData: e
    } = this;
    this.remainderData = null;
    let t;
    return e ? t = this.demux(e, -1, !1, !0) : t = {
      videoTrack: this._videoTrack,
      audioTrack: this._audioTrack,
      id3Track: this._id3Track,
      textTrack: this._txtTrack
    }, this.extractRemainingSamples(t), this.sampleAes ? this.decrypt(t, this.sampleAes) : t;
  }
  extractRemainingSamples(e) {
    const {
      audioTrack: t,
      videoTrack: r,
      id3Track: i,
      textTrack: s
    } = e, o = r.pesData, a = t.pesData, l = i.pesData;
    let c;
    if (o && (c = Md(o, this.logger)) ? (this.readyVideoParser(r.segmentCodec), this.videoParser !== null && (this.videoParser.parsePES(r, s, c, !0), r.pesData = null)) : r.pesData = o, a && (c = Md(a, this.logger))) {
      switch (t.segmentCodec) {
        case "aac":
          this.parseAACPES(t, c);
          break;
        case "mp3":
          this.parseMPEGPES(t, c);
          break;
        case "ac3":
          this.parseAC3PES(t, c);
          break;
      }
      t.pesData = null;
    } else
      a != null && a.size && this.logger.log("last AAC PES packet truncated,might overlap between fragments"), t.pesData = a;
    l && (c = Md(l, this.logger)) ? (this.parseID3PES(i, c), i.pesData = null) : i.pesData = l;
  }
  demuxSampleAes(e, t, r) {
    const i = this.demux(e, r, !0, !this.config.progressive), s = this.sampleAes = new Bqe(this.observer, this.config, t);
    return this.decrypt(i, s);
  }
  readyVideoParser(e) {
    this.videoParser === null && (e === "avc" ? this.videoParser = new zqe() : e === "hevc" && (this.videoParser = new Hqe()));
  }
  decrypt(e, t) {
    return new Promise((r) => {
      const {
        audioTrack: i,
        videoTrack: s
      } = e;
      i.samples && i.segmentCodec === "aac" ? t.decryptAacSamples(i.samples, 0, () => {
        s.samples ? t.decryptAvcSamples(s.samples, 0, 0, () => {
          r(e);
        }) : r(e);
      }) : s.samples && t.decryptAvcSamples(s.samples, 0, 0, () => {
        r(e);
      });
    });
  }
  destroy() {
    this.observer && this.observer.removeAllListeners(), this.config = this.logger = this.observer = null, this.aacOverFlow = this.videoParser = this.remainderData = this.sampleAes = null, this._videoTrack = this._audioTrack = this._id3Track = this._txtTrack = void 0;
  }
  parseAACPES(e, t) {
    let r = 0;
    const i = this.aacOverFlow;
    let s = t.data;
    if (i) {
      this.aacOverFlow = null;
      const d = i.missing, f = i.sample.unit.byteLength;
      if (d === -1)
        s = Vs(i.sample.unit, s);
      else {
        const h = f - d;
        i.sample.unit.set(s.subarray(0, d), h), e.samples.push(i.sample), r = i.missing;
      }
    }
    let o, a;
    for (o = r, a = s.length; o < a - 1 && !Ky(s, o); o++)
      ;
    if (o !== r) {
      let d;
      const f = o < a - 1;
      if (f ? d = `AAC PES did not start with ADTS header,offset:${o}` : d = "No ADTS header found in AAC PES", A7(this.observer, new Error(d), f, this.logger), !f)
        return;
    }
    vne(e, this.observer, s, o, this.audioCodec);
    let l;
    if (t.pts !== void 0)
      l = t.pts;
    else if (i) {
      const d = yne(e.samplerate);
      l = i.sample.pts + d;
    } else {
      this.logger.warn("[tsdemuxer]: AAC PES unknown PTS");
      return;
    }
    let c = 0, u;
    for (; o < a; )
      if (u = bne(e, s, o, l, c), o += u.length, u.missing) {
        this.aacOverFlow = u;
        break;
      } else
        for (c++; o < a - 1 && !Ky(s, o); o++)
          ;
  }
  parseMPEGPES(e, t) {
    const r = t.data, i = r.length;
    let s = 0, o = 0;
    const a = t.pts;
    if (a === void 0) {
      this.logger.warn("[tsdemuxer]: MPEG PES unknown PTS");
      return;
    }
    for (; o < i; )
      if (Cne(r, o)) {
        const l = Ene(e, r, o, a, s);
        if (l)
          o += l.length, s++;
        else
          break;
      } else
        o++;
  }
  parseAC3PES(e, t) {
    {
      const r = t.data, i = t.pts;
      if (i === void 0) {
        this.logger.warn("[tsdemuxer]: AC3 PES unknown PTS");
        return;
      }
      const s = r.length;
      let o = 0, a = 0, l;
      for (; a < s && (l = Mne(e, r, a, i, o++)) > 0; )
        a += l;
    }
  }
  parseID3PES(e, t) {
    if (t.pts === void 0) {
      this.logger.warn("[tsdemuxer]: ID3 PES unknown PTS");
      return;
    }
    const r = mn({}, t, {
      type: this._videoTrack ? us.emsg : us.audioId3,
      duration: Number.POSITIVE_INFINITY
    });
    e.samples.push(r);
  }
}
function T7(n, e) {
  return ((n[e + 1] & 31) << 8) + n[e + 2];
}
function Uqe(n, e) {
  return (n[e + 10] & 31) << 8 | n[e + 11];
}
function Vqe(n, e, t, r, i, s) {
  const o = {
    audioPid: -1,
    videoPid: -1,
    id3Pid: -1,
    segmentVideoCodec: "avc",
    segmentAudioCodec: "aac"
  }, a = (n[e + 1] & 15) << 8 | n[e + 2], l = e + 3 + a - 4, c = (n[e + 10] & 15) << 8 | n[e + 11];
  for (e += 12 + c; e < l; ) {
    const u = T7(n, e), d = (n[e + 3] & 15) << 8 | n[e + 4];
    switch (n[e]) {
      case 207:
        if (!r) {
          k6("ADTS AAC", s);
          break;
        }
      /* falls through */
      case 15:
        o.audioPid === -1 && (o.audioPid = u);
        break;
      // Packetized metadata (ID3)
      case 21:
        o.id3Pid === -1 && (o.id3Pid = u);
        break;
      case 219:
        if (!r) {
          k6("H.264", s);
          break;
        }
      /* falls through */
      case 27:
        o.videoPid === -1 && (o.videoPid = u);
        break;
      // ISO/IEC 11172-3 (MPEG-1 audio)
      // or ISO/IEC 13818-3 (MPEG-2 halved sample rate audio)
      case 3:
      case 4:
        !t.mpeg && !t.mp3 ? s.log("MPEG audio found, not supported in this browser") : o.audioPid === -1 && (o.audioPid = u, o.segmentAudioCodec = "mp3");
        break;
      case 193:
        if (!r) {
          k6("AC-3", s);
          break;
        }
      /* falls through */
      case 129:
        t.ac3 ? o.audioPid === -1 && (o.audioPid = u, o.segmentAudioCodec = "ac3") : s.log("AC-3 audio found, not supported in this browser");
        break;
      case 6:
        if (o.audioPid === -1 && d > 0) {
          let f = e + 5, h = d;
          for (; h > 2; ) {
            switch (n[f]) {
              case 106:
                t.ac3 !== !0 ? s.log("AC-3 audio found, not supported in this browser for now") : (o.audioPid = u, o.segmentAudioCodec = "ac3");
                break;
            }
            const g = n[f + 1] + 2;
            f += g, h -= g;
          }
        }
        break;
      case 194:
      // SAMPLE-AES EC3
      /* falls through */
      case 135:
        return A7(i, new Error("Unsupported EC-3 in M2TS found"), void 0, s), o;
      case 36:
        o.videoPid === -1 && (o.videoPid = u, o.segmentVideoCodec = "hevc", s.log("HEVC in M2TS found"));
        break;
    }
    e += d + 5;
  }
  return o;
}
function A7(n, e, t, r) {
  r.warn(`parsing error: ${e.message}`), n.emit(N.ERROR, N.ERROR, {
    type: Je.MEDIA_ERROR,
    details: ce.FRAG_PARSING_ERROR,
    fatal: !1,
    levelRetry: t,
    error: e,
    reason: e.message
  });
}
function k6(n, e) {
  e.log(`${n} with AES-128-CBC encryption found in unencrypted stream`);
}
function Md(n, e) {
  let t = 0, r, i, s, o, a;
  const l = n.data;
  if (!n || n.size === 0)
    return null;
  for (; l[0].length < 19 && l.length > 1; )
    l[0] = Vs(l[0], l[1]), l.splice(1, 1);
  if (r = l[0], (r[0] << 16) + (r[1] << 8) + r[2] === 1) {
    if (i = (r[4] << 8) + r[5], i && i > n.size - 6)
      return null;
    const u = r[7];
    u & 192 && (o = (r[9] & 14) * 536870912 + // 1 << 29
    (r[10] & 255) * 4194304 + // 1 << 22
    (r[11] & 254) * 16384 + // 1 << 14
    (r[12] & 255) * 128 + // 1 << 7
    (r[13] & 254) / 2, u & 64 ? (a = (r[14] & 14) * 536870912 + // 1 << 29
    (r[15] & 255) * 4194304 + // 1 << 22
    (r[16] & 254) * 16384 + // 1 << 14
    (r[17] & 255) * 128 + // 1 << 7
    (r[18] & 254) / 2, o - a > 60 * 9e4 && (e.warn(`${Math.round((o - a) / 9e4)}s delta between PTS and DTS, align them`), o = a)) : a = o), s = r[8];
    let d = s + 9;
    if (n.size <= d)
      return null;
    n.size -= d;
    const f = new Uint8Array(n.size);
    for (let h = 0, m = l.length; h < m; h++) {
      r = l[h];
      let g = r.byteLength;
      if (d)
        if (d > g) {
          d -= g;
          continue;
        } else
          r = r.subarray(d), g -= d, d = 0;
      f.set(r, t), t += g;
    }
    return i && (i -= s + 3), {
      data: f,
      pts: o,
      dts: a,
      len: i
    };
  }
  return null;
}
class jqe {
  static getSilentFrame(e, t) {
    switch (e) {
      case "mp4a.40.2":
        if (t === 1)
          return new Uint8Array([0, 200, 0, 128, 35, 128]);
        if (t === 2)
          return new Uint8Array([33, 0, 73, 144, 2, 25, 0, 35, 128]);
        if (t === 3)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 142]);
        if (t === 4)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 128, 44, 128, 8, 2, 56]);
        if (t === 5)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 56]);
        if (t === 6)
          return new Uint8Array([0, 200, 0, 128, 32, 132, 1, 38, 64, 8, 100, 0, 130, 48, 4, 153, 0, 33, 144, 2, 0, 178, 0, 32, 8, 224]);
        break;
      // handle HE-AAC below (mp4a.40.5 / mp4a.40.29)
      default:
        if (t === 1)
          return new Uint8Array([1, 64, 34, 128, 163, 78, 230, 128, 186, 8, 0, 0, 0, 28, 6, 241, 193, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        if (t === 2)
          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        if (t === 3)
          return new Uint8Array([1, 64, 34, 128, 163, 94, 230, 128, 186, 8, 0, 0, 0, 0, 149, 0, 6, 241, 161, 10, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 90, 94]);
        break;
    }
  }
}
const kl = Math.pow(2, 32) - 1;
class ae {
  static init() {
    ae.types = {
      avc1: [],
      // codingname
      avcC: [],
      hvc1: [],
      hvcC: [],
      btrt: [],
      dinf: [],
      dref: [],
      esds: [],
      ftyp: [],
      hdlr: [],
      mdat: [],
      mdhd: [],
      mdia: [],
      mfhd: [],
      minf: [],
      moof: [],
      moov: [],
      mp4a: [],
      ".mp3": [],
      dac3: [],
      "ac-3": [],
      mvex: [],
      mvhd: [],
      pasp: [],
      sdtp: [],
      stbl: [],
      stco: [],
      stsc: [],
      stsd: [],
      stsz: [],
      stts: [],
      tfdt: [],
      tfhd: [],
      traf: [],
      trak: [],
      trun: [],
      trex: [],
      tkhd: [],
      vmhd: [],
      smhd: []
    };
    let e;
    for (e in ae.types)
      ae.types.hasOwnProperty(e) && (ae.types[e] = [e.charCodeAt(0), e.charCodeAt(1), e.charCodeAt(2), e.charCodeAt(3)]);
    const t = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // pre_defined
      118,
      105,
      100,
      101,
      // handler_type: 'vide'
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      86,
      105,
      100,
      101,
      111,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
      // name: 'VideoHandler'
    ]), r = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // pre_defined
      115,
      111,
      117,
      110,
      // handler_type: 'soun'
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      83,
      111,
      117,
      110,
      100,
      72,
      97,
      110,
      100,
      108,
      101,
      114,
      0
      // name: 'SoundHandler'
    ]);
    ae.HDLR_TYPES = {
      video: t,
      audio: r
    };
    const i = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1,
      // entry_count
      0,
      0,
      0,
      12,
      // entry_size
      117,
      114,
      108,
      32,
      // 'url' type
      0,
      // version 0
      0,
      0,
      1
      // entry_flags
    ]), s = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0
      // entry_count
    ]);
    ae.STTS = ae.STSC = ae.STCO = s, ae.STSZ = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      // sample_size
      0,
      0,
      0,
      0
      // sample_count
    ]), ae.VMHD = new Uint8Array([
      0,
      // version
      0,
      0,
      1,
      // flags
      0,
      0,
      // graphicsmode
      0,
      0,
      0,
      0,
      0,
      0
      // opcolor
    ]), ae.SMHD = new Uint8Array([
      0,
      // version
      0,
      0,
      0,
      // flags
      0,
      0,
      // balance
      0,
      0
      // reserved
    ]), ae.STSD = new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      1
    ]);
    const o = new Uint8Array([105, 115, 111, 109]), a = new Uint8Array([97, 118, 99, 49]), l = new Uint8Array([0, 0, 0, 1]);
    ae.FTYP = ae.box(ae.types.ftyp, o, l, o, a), ae.DINF = ae.box(ae.types.dinf, ae.box(ae.types.dref, i));
  }
  static box(e, ...t) {
    let r = 8, i = t.length;
    const s = i;
    for (; i--; )
      r += t[i].byteLength;
    const o = new Uint8Array(r);
    for (o[0] = r >> 24 & 255, o[1] = r >> 16 & 255, o[2] = r >> 8 & 255, o[3] = r & 255, o.set(e, 4), i = 0, r = 8; i < s; i++)
      o.set(t[i], r), r += t[i].byteLength;
    return o;
  }
  static hdlr(e) {
    return ae.box(ae.types.hdlr, ae.HDLR_TYPES[e]);
  }
  static mdat(e) {
    return ae.box(ae.types.mdat, e);
  }
  static mdhd(e, t) {
    t *= e;
    const r = Math.floor(t / (kl + 1)), i = Math.floor(t % (kl + 1));
    return ae.box(ae.types.mdhd, new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      e >> 24 & 255,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255,
      // timescale
      r >> 24,
      r >> 16 & 255,
      r >> 8 & 255,
      r & 255,
      i >> 24,
      i >> 16 & 255,
      i >> 8 & 255,
      i & 255,
      85,
      196,
      // 'und' language (undetermined)
      0,
      0
    ]));
  }
  static mdia(e) {
    return ae.box(ae.types.mdia, ae.mdhd(e.timescale || 0, e.duration || 0), ae.hdlr(e.type), ae.minf(e));
  }
  static mfhd(e) {
    return ae.box(ae.types.mfhd, new Uint8Array([
      0,
      0,
      0,
      0,
      // flags
      e >> 24,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255
      // sequence_number
    ]));
  }
  static minf(e) {
    return e.type === "audio" ? ae.box(ae.types.minf, ae.box(ae.types.smhd, ae.SMHD), ae.DINF, ae.stbl(e)) : ae.box(ae.types.minf, ae.box(ae.types.vmhd, ae.VMHD), ae.DINF, ae.stbl(e));
  }
  static moof(e, t, r) {
    return ae.box(ae.types.moof, ae.mfhd(e), ae.traf(r, t));
  }
  static moov(e) {
    let t = e.length;
    const r = [];
    for (; t--; )
      r[t] = ae.trak(e[t]);
    return ae.box.apply(null, [ae.types.moov, ae.mvhd(e[0].timescale || 0, e[0].duration || 0)].concat(r).concat(ae.mvex(e)));
  }
  static mvex(e) {
    let t = e.length;
    const r = [];
    for (; t--; )
      r[t] = ae.trex(e[t]);
    return ae.box.apply(null, [ae.types.mvex, ...r]);
  }
  static mvhd(e, t) {
    t *= e;
    const r = Math.floor(t / (kl + 1)), i = Math.floor(t % (kl + 1)), s = new Uint8Array([
      1,
      // version 1
      0,
      0,
      0,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      e >> 24 & 255,
      e >> 16 & 255,
      e >> 8 & 255,
      e & 255,
      // timescale
      r >> 24,
      r >> 16 & 255,
      r >> 8 & 255,
      r & 255,
      i >> 24,
      i >> 16 & 255,
      i >> 8 & 255,
      i & 255,
      0,
      1,
      0,
      0,
      // 1.0 rate
      1,
      0,
      // 1.0 volume
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // pre_defined
      255,
      255,
      255,
      255
      // next_track_ID
    ]);
    return ae.box(ae.types.mvhd, s);
  }
  static sdtp(e) {
    const t = e.samples || [], r = new Uint8Array(4 + t.length);
    let i, s;
    for (i = 0; i < t.length; i++)
      s = t[i].flags, r[i + 4] = s.dependsOn << 4 | s.isDependedOn << 2 | s.hasRedundancy;
    return ae.box(ae.types.sdtp, r);
  }
  static stbl(e) {
    return ae.box(ae.types.stbl, ae.stsd(e), ae.box(ae.types.stts, ae.STTS), ae.box(ae.types.stsc, ae.STSC), ae.box(ae.types.stsz, ae.STSZ), ae.box(ae.types.stco, ae.STCO));
  }
  static avc1(e) {
    let t = [], r = [], i, s, o;
    for (i = 0; i < e.sps.length; i++)
      s = e.sps[i], o = s.byteLength, t.push(o >>> 8 & 255), t.push(o & 255), t = t.concat(Array.prototype.slice.call(s));
    for (i = 0; i < e.pps.length; i++)
      s = e.pps[i], o = s.byteLength, r.push(o >>> 8 & 255), r.push(o & 255), r = r.concat(Array.prototype.slice.call(s));
    const a = ae.box(ae.types.avcC, new Uint8Array([
      1,
      // version
      t[3],
      // profile
      t[4],
      // profile compat
      t[5],
      // level
      255,
      // lengthSizeMinusOne, hard-coded to 4 bytes
      224 | e.sps.length
      // 3bit reserved (111) + numOfSequenceParameterSets
    ].concat(t).concat([
      e.pps.length
      // numOfPictureParameterSets
    ]).concat(r))), l = e.width, c = e.height, u = e.pixelRatio[0], d = e.pixelRatio[1];
    return ae.box(
      ae.types.avc1,
      new Uint8Array([
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // pre_defined
        l >> 8 & 255,
        l & 255,
        // width
        c >> 8 & 255,
        c & 255,
        // height
        0,
        72,
        0,
        0,
        // horizresolution
        0,
        72,
        0,
        0,
        // vertresolution
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // frame_count
        18,
        100,
        97,
        105,
        108,
        // dailymotion/hls.js
        121,
        109,
        111,
        116,
        105,
        111,
        110,
        47,
        104,
        108,
        115,
        46,
        106,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // compressorname
        0,
        24,
        // depth = 24
        17,
        17
      ]),
      // pre_defined = -1
      a,
      ae.box(ae.types.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        // bufferSizeDB
        0,
        45,
        198,
        192,
        // maxBitrate
        0,
        45,
        198,
        192
      ])),
      // avgBitrate
      ae.box(ae.types.pasp, new Uint8Array([
        u >> 24,
        // hSpacing
        u >> 16 & 255,
        u >> 8 & 255,
        u & 255,
        d >> 24,
        // vSpacing
        d >> 16 & 255,
        d >> 8 & 255,
        d & 255
      ]))
    );
  }
  static esds(e) {
    const t = e.config;
    return new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      3,
      // descriptor_type
      25,
      // length
      0,
      1,
      // es_id
      0,
      // stream_priority
      4,
      // descriptor_type
      17,
      // length
      64,
      // codec : mpeg4_audio
      21,
      // stream_type
      0,
      0,
      0,
      // buffer_size
      0,
      0,
      0,
      0,
      // maxBitrate
      0,
      0,
      0,
      0,
      // avgBitrate
      5,
      // descriptor_type
      2,
      // length
      ...t,
      6,
      1,
      2
      // GASpecificConfig)); // length + audio config descriptor
    ]);
  }
  static audioStsd(e) {
    const t = e.samplerate || 0;
    return new Uint8Array([
      0,
      0,
      0,
      // reserved
      0,
      0,
      0,
      // reserved
      0,
      1,
      // data_reference_index
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      e.channelCount || 0,
      // channelcount
      0,
      16,
      // sampleSize:16bits
      0,
      0,
      0,
      0,
      // reserved2
      t >> 8 & 255,
      t & 255,
      //
      0,
      0
    ]);
  }
  static mp4a(e) {
    return ae.box(ae.types.mp4a, ae.audioStsd(e), ae.box(ae.types.esds, ae.esds(e)));
  }
  static mp3(e) {
    return ae.box(ae.types[".mp3"], ae.audioStsd(e));
  }
  static ac3(e) {
    return ae.box(ae.types["ac-3"], ae.audioStsd(e), ae.box(ae.types.dac3, e.config));
  }
  static stsd(e) {
    const {
      segmentCodec: t
    } = e;
    if (e.type === "audio") {
      if (t === "aac")
        return ae.box(ae.types.stsd, ae.STSD, ae.mp4a(e));
      if (t === "ac3" && e.config)
        return ae.box(ae.types.stsd, ae.STSD, ae.ac3(e));
      if (t === "mp3" && e.codec === "mp3")
        return ae.box(ae.types.stsd, ae.STSD, ae.mp3(e));
    } else if (e.pps && e.sps) {
      if (t === "avc")
        return ae.box(ae.types.stsd, ae.STSD, ae.avc1(e));
      if (t === "hevc" && e.vps)
        return ae.box(ae.types.stsd, ae.STSD, ae.hvc1(e));
    } else
      throw new Error("video track missing pps or sps");
    throw new Error(`unsupported ${e.type} segment codec (${t}/${e.codec})`);
  }
  static tkhd(e) {
    const t = e.id, r = (e.duration || 0) * (e.timescale || 0), i = e.width || 0, s = e.height || 0, o = Math.floor(r / (kl + 1)), a = Math.floor(r % (kl + 1));
    return ae.box(ae.types.tkhd, new Uint8Array([
      1,
      // version 1
      0,
      0,
      7,
      // flags
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      2,
      // creation_time
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      3,
      // modification_time
      t >> 24 & 255,
      t >> 16 & 255,
      t >> 8 & 255,
      t & 255,
      // track_ID
      0,
      0,
      0,
      0,
      // reserved
      o >> 24,
      o >> 16 & 255,
      o >> 8 & 255,
      o & 255,
      a >> 24,
      a >> 16 & 255,
      a >> 8 & 255,
      a & 255,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      // reserved
      0,
      0,
      // layer
      0,
      0,
      // alternate_group
      0,
      0,
      // non-audio track volume
      0,
      0,
      // reserved
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      0,
      64,
      0,
      0,
      0,
      // transformation: unity matrix
      i >> 8 & 255,
      i & 255,
      0,
      0,
      // width
      s >> 8 & 255,
      s & 255,
      0,
      0
      // height
    ]));
  }
  static traf(e, t) {
    const r = ae.sdtp(e), i = e.id, s = Math.floor(t / (kl + 1)), o = Math.floor(t % (kl + 1));
    return ae.box(
      ae.types.traf,
      ae.box(ae.types.tfhd, new Uint8Array([
        0,
        // version 0
        0,
        0,
        0,
        // flags
        i >> 24,
        i >> 16 & 255,
        i >> 8 & 255,
        i & 255
        // track_ID
      ])),
      ae.box(ae.types.tfdt, new Uint8Array([
        1,
        // version 1
        0,
        0,
        0,
        // flags
        s >> 24,
        s >> 16 & 255,
        s >> 8 & 255,
        s & 255,
        o >> 24,
        o >> 16 & 255,
        o >> 8 & 255,
        o & 255
      ])),
      ae.trun(e, r.length + 16 + // tfhd
      20 + // tfdt
      8 + // traf header
      16 + // mfhd
      8 + // moof header
      8),
      // mdat header
      r
    );
  }
  /**
   * Generate a track box.
   * @param track a track definition
   */
  static trak(e) {
    return e.duration = e.duration || 4294967295, ae.box(ae.types.trak, ae.tkhd(e), ae.mdia(e));
  }
  static trex(e) {
    const t = e.id;
    return ae.box(ae.types.trex, new Uint8Array([
      0,
      // version 0
      0,
      0,
      0,
      // flags
      t >> 24,
      t >> 16 & 255,
      t >> 8 & 255,
      t & 255,
      // track_ID
      0,
      0,
      0,
      1,
      // default_sample_description_index
      0,
      0,
      0,
      0,
      // default_sample_duration
      0,
      0,
      0,
      0,
      // default_sample_size
      0,
      1,
      0,
      1
      // default_sample_flags
    ]));
  }
  static trun(e, t) {
    const r = e.samples || [], i = r.length, s = 12 + 16 * i, o = new Uint8Array(s);
    let a, l, c, u, d, f;
    for (t += 8 + s, o.set([
      e.type === "video" ? 1 : 0,
      // version 1 for video with signed-int sample_composition_time_offset
      0,
      15,
      1,
      // flags
      i >>> 24 & 255,
      i >>> 16 & 255,
      i >>> 8 & 255,
      i & 255,
      // sample_count
      t >>> 24 & 255,
      t >>> 16 & 255,
      t >>> 8 & 255,
      t & 255
      // data_offset
    ], 0), a = 0; a < i; a++)
      l = r[a], c = l.duration, u = l.size, d = l.flags, f = l.cts, o.set([
        c >>> 24 & 255,
        c >>> 16 & 255,
        c >>> 8 & 255,
        c & 255,
        // sample_duration
        u >>> 24 & 255,
        u >>> 16 & 255,
        u >>> 8 & 255,
        u & 255,
        // sample_size
        d.isLeading << 2 | d.dependsOn,
        d.isDependedOn << 6 | d.hasRedundancy << 4 | d.paddingValue << 1 | d.isNonSync,
        d.degradPrio & 61440,
        d.degradPrio & 15,
        // sample_flags
        f >>> 24 & 255,
        f >>> 16 & 255,
        f >>> 8 & 255,
        f & 255
        // sample_composition_time_offset
      ], 12 + 16 * a);
    return ae.box(ae.types.trun, o);
  }
  static initSegment(e) {
    ae.types || ae.init();
    const t = ae.moov(e);
    return Vs(ae.FTYP, t);
  }
  static hvc1(e) {
    const t = e.params, r = [e.vps, e.sps, e.pps], i = 4, s = new Uint8Array([1, t.general_profile_space << 6 | (t.general_tier_flag ? 32 : 0) | t.general_profile_idc, t.general_profile_compatibility_flags[0], t.general_profile_compatibility_flags[1], t.general_profile_compatibility_flags[2], t.general_profile_compatibility_flags[3], t.general_constraint_indicator_flags[0], t.general_constraint_indicator_flags[1], t.general_constraint_indicator_flags[2], t.general_constraint_indicator_flags[3], t.general_constraint_indicator_flags[4], t.general_constraint_indicator_flags[5], t.general_level_idc, 240 | t.min_spatial_segmentation_idc >> 8, 255 & t.min_spatial_segmentation_idc, 252 | t.parallelismType, 252 | t.chroma_format_idc, 248 | t.bit_depth_luma_minus8, 248 | t.bit_depth_chroma_minus8, 0, parseInt(t.frame_rate.fps), i - 1 | t.temporal_id_nested << 2 | t.num_temporal_layers << 3 | (t.frame_rate.fixed ? 64 : 0), r.length]);
    let o = s.length;
    for (let m = 0; m < r.length; m += 1) {
      o += 3;
      for (let g = 0; g < r[m].length; g += 1)
        o += 2 + r[m][g].length;
    }
    const a = new Uint8Array(o);
    a.set(s, 0), o = s.length;
    const l = r.length - 1;
    for (let m = 0; m < r.length; m += 1) {
      a.set(new Uint8Array([32 + m | (m === l ? 128 : 0), 0, r[m].length]), o), o += 3;
      for (let g = 0; g < r[m].length; g += 1)
        a.set(new Uint8Array([r[m][g].length >> 8, r[m][g].length & 255]), o), o += 2, a.set(r[m][g], o), o += r[m][g].length;
    }
    const c = ae.box(ae.types.hvcC, a), u = e.width, d = e.height, f = e.pixelRatio[0], h = e.pixelRatio[1];
    return ae.box(
      ae.types.hvc1,
      new Uint8Array([
        0,
        0,
        0,
        // reserved
        0,
        0,
        0,
        // reserved
        0,
        1,
        // data_reference_index
        0,
        0,
        // pre_defined
        0,
        0,
        // reserved
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // pre_defined
        u >> 8 & 255,
        u & 255,
        // width
        d >> 8 & 255,
        d & 255,
        // height
        0,
        72,
        0,
        0,
        // horizresolution
        0,
        72,
        0,
        0,
        // vertresolution
        0,
        0,
        0,
        0,
        // reserved
        0,
        1,
        // frame_count
        18,
        100,
        97,
        105,
        108,
        // dailymotion/hls.js
        121,
        109,
        111,
        116,
        105,
        111,
        110,
        47,
        104,
        108,
        115,
        46,
        106,
        115,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        // compressorname
        0,
        24,
        // depth = 24
        17,
        17
      ]),
      // pre_defined = -1
      c,
      ae.box(ae.types.btrt, new Uint8Array([
        0,
        28,
        156,
        128,
        // bufferSizeDB
        0,
        45,
        198,
        192,
        // maxBitrate
        0,
        45,
        198,
        192
      ])),
      // avgBitrate
      ae.box(ae.types.pasp, new Uint8Array([
        f >> 24,
        // hSpacing
        f >> 16 & 255,
        f >> 8 & 255,
        f & 255,
        h >> 24,
        // vSpacing
        h >> 16 & 255,
        h >> 8 & 255,
        h & 255
      ]))
    );
  }
}
ae.types = void 0;
ae.HDLR_TYPES = void 0;
ae.STTS = void 0;
ae.STSC = void 0;
ae.STCO = void 0;
ae.STSZ = void 0;
ae.VMHD = void 0;
ae.SMHD = void 0;
ae.STSD = void 0;
ae.FTYP = void 0;
ae.DINF = void 0;
const _ne = 9e4;
function k_(n, e, t = 1, r = !1) {
  const i = n * e * t;
  return r ? Math.round(i) : i;
}
function Wqe(n, e, t = 1, r = !1) {
  return k_(n, e, 1 / t, r);
}
function cp(n, e = !1) {
  return k_(n, 1e3, 1 / _ne, e);
}
function Gqe(n, e = 1) {
  return k_(n, _ne, 1 / e);
}
function yH(n) {
  const {
    baseTime: e,
    timescale: t,
    trackId: r
  } = n;
  return `${e / t} (${e}/${t}) trackId: ${r}`;
}
const Kqe = 10 * 1e3, qqe = 1024, Yqe = 1152, Xqe = 1536;
let kd = null, _6 = null;
function bH(n, e, t, r) {
  return {
    duration: e,
    size: t,
    cts: r,
    flags: {
      isLeading: 0,
      isDependedOn: 0,
      hasRedundancy: 0,
      degradPrio: 0,
      dependsOn: n ? 2 : 1,
      isNonSync: n ? 0 : 1
    }
  };
}
class Wv extends Ys {
  constructor(e, t, r, i) {
    if (super("mp4-remuxer", i), this.observer = void 0, this.config = void 0, this.typeSupported = void 0, this.ISGenerated = !1, this._initPTS = null, this._initDTS = null, this.nextVideoTs = null, this.nextAudioTs = null, this.videoSampleDuration = null, this.isAudioContiguous = !1, this.isVideoContiguous = !1, this.videoTrackConfig = void 0, this.observer = e, this.config = t, this.typeSupported = r, this.ISGenerated = !1, kd === null) {
      const o = (navigator.userAgent || "").match(/Chrome\/(\d+)/i);
      kd = o ? parseInt(o[1]) : 0;
    }
    if (_6 === null) {
      const s = navigator.userAgent.match(/Safari\/(\d+)/i);
      _6 = s ? parseInt(s[1]) : 0;
    }
  }
  destroy() {
    this.config = this.videoTrackConfig = this._initPTS = this._initDTS = null;
  }
  resetTimeStamp(e) {
    const t = this._initPTS;
    (!t || !e || e.trackId !== t.trackId || e.baseTime !== t.baseTime || e.timescale !== t.timescale) && this.log(`Reset initPTS: ${t && yH(t)} > ${e && yH(e)}`), this._initPTS = this._initDTS = e;
  }
  resetNextTimestamp() {
    this.log("reset next timestamp"), this.isVideoContiguous = !1, this.isAudioContiguous = !1;
  }
  resetInitSegment() {
    this.log("ISGenerated flag reset"), this.ISGenerated = !1, this.videoTrackConfig = void 0;
  }
  getVideoStartPts(e) {
    let t = !1;
    const r = e[0].pts, i = e.reduce((s, o) => {
      let a = o.pts, l = a - s;
      return l < -4294967296 && (t = !0, a = is(a, r), l = a - s), l > 0 ? s : a;
    }, r);
    return t && this.debug("PTS rollover detected"), i;
  }
  remux(e, t, r, i, s, o, a, l) {
    let c, u, d, f, h, m, g = s, v = s;
    const y = e.pid > -1, b = t.pid > -1, x = t.samples.length, E = e.samples.length > 0, w = a && x > 0 || x > 1;
    if ((!y || E) && (!b || w) || this.ISGenerated || a) {
      if (this.ISGenerated) {
        var S, M, k, _;
        const P = this.videoTrackConfig;
        (P && (t.width !== P.width || t.height !== P.height || ((S = t.pixelRatio) == null ? void 0 : S[0]) !== ((M = P.pixelRatio) == null ? void 0 : M[0]) || ((k = t.pixelRatio) == null ? void 0 : k[1]) !== ((_ = P.pixelRatio) == null ? void 0 : _[1])) || !P && w || this.nextAudioTs === null && E) && this.resetInitSegment();
      }
      this.ISGenerated || (d = this.generateIS(e, t, s, o));
      const O = this.isVideoContiguous;
      let I = -1, R;
      if (w && (I = Zqe(t.samples), !O && this.config.forceKeyFrameOnDiscontinuity))
        if (m = !0, I > 0) {
          this.warn(`Dropped ${I} out of ${x} video samples due to a missing keyframe`);
          const P = this.getVideoStartPts(t.samples);
          t.samples = t.samples.slice(I), t.dropped += I, v += (t.samples[0].pts - P) / t.inputTimeScale, R = v;
        } else I === -1 && (this.warn(`No keyframe found out of ${x} video samples`), m = !1);
      if (this.ISGenerated) {
        if (E && w) {
          const P = this.getVideoStartPts(t.samples), L = (is(e.samples[0].pts, P) - P) / t.inputTimeScale;
          g += Math.max(0, L), v += Math.max(0, -L);
        }
        if (E) {
          if (e.samplerate || (this.warn("regenerate InitSegment as audio detected"), d = this.generateIS(e, t, s, o)), u = this.remuxAudio(e, g, this.isAudioContiguous, o, b || w || l === We.AUDIO ? v : void 0), w) {
            const P = u ? u.endPTS - u.startPTS : 0;
            t.inputTimeScale || (this.warn("regenerate InitSegment as video detected"), d = this.generateIS(e, t, s, o)), c = this.remuxVideo(t, v, O, P);
          }
        } else w && (c = this.remuxVideo(t, v, O, 0));
        c && (c.firstKeyFrame = I, c.independent = I !== -1, c.firstKeyFramePTS = R);
      }
    }
    return this.ISGenerated && this._initPTS && this._initDTS && (r.samples.length && (h = One(r, s, this._initPTS, this._initDTS)), i.samples.length && (f = Ine(i, s, this._initPTS))), {
      audio: u,
      video: c,
      initSegment: d,
      independent: m,
      text: f,
      id3: h
    };
  }
  computeInitPts(e, t, r, i) {
    const s = Math.round(r * t);
    let o = is(e, s);
    if (o < s + t)
      for (this.log(`Adjusting PTS for rollover in timeline near ${(s - o) / t} ${i}`); o < s + t; )
        o += 8589934592;
    return o - s;
  }
  generateIS(e, t, r, i) {
    const s = e.samples, o = t.samples, a = this.typeSupported, l = {}, c = this._initPTS;
    let u = !c || i, d = "audio/mp4", f, h, m, g = -1;
    if (u && (f = h = 1 / 0), e.config && s.length) {
      switch (e.timescale = e.samplerate, e.segmentCodec) {
        case "mp3":
          a.mpeg ? (d = "audio/mpeg", e.codec = "") : a.mp3 && (e.codec = "mp3");
          break;
        case "ac3":
          e.codec = "ac-3";
          break;
      }
      l.audio = {
        id: "audio",
        container: d,
        codec: e.codec,
        initSegment: e.segmentCodec === "mp3" && a.mpeg ? new Uint8Array(0) : ae.initSegment([e]),
        metadata: {
          channelCount: e.channelCount
        }
      }, u && (g = e.id, m = e.inputTimeScale, !c || m !== c.timescale ? f = h = this.computeInitPts(s[0].pts, m, r, "audio") : u = !1);
    }
    if (t.sps && t.pps && o.length) {
      if (t.timescale = t.inputTimeScale, l.video = {
        id: "main",
        container: "video/mp4",
        codec: t.codec,
        initSegment: ae.initSegment([t]),
        metadata: {
          width: t.width,
          height: t.height
        }
      }, u)
        if (g = t.id, m = t.inputTimeScale, !c || m !== c.timescale) {
          const v = this.getVideoStartPts(o), y = is(o[0].dts, v), b = this.computeInitPts(y, m, r, "video"), x = this.computeInitPts(v, m, r, "video");
          h = Math.min(h, b), f = Math.min(f, x);
        } else
          u = !1;
      this.videoTrackConfig = {
        width: t.width,
        height: t.height,
        pixelRatio: t.pixelRatio
      };
    }
    if (Object.keys(l).length)
      return this.ISGenerated = !0, u ? (c && this.warn(`Timestamps at playlist time: ${i ? "" : "~"}${r} ${f / m} != initPTS: ${c.baseTime / c.timescale} (${c.baseTime}/${c.timescale}) trackId: ${c.trackId}`), this.log(`Found initPTS at playlist time: ${r} offset: ${f / m} (${f}/${m}) trackId: ${g}`), this._initPTS = {
        baseTime: f,
        timescale: m,
        trackId: g
      }, this._initDTS = {
        baseTime: h,
        timescale: m,
        trackId: g
      }) : f = m = void 0, {
        tracks: l,
        initPTS: f,
        timescale: m,
        trackId: g
      };
  }
  remuxVideo(e, t, r, i) {
    const s = e.inputTimeScale, o = e.samples, a = [], l = o.length, c = this._initPTS, u = c.baseTime * s / c.timescale;
    let d = this.nextVideoTs, f = 8, h = this.videoSampleDuration, m, g, v = Number.POSITIVE_INFINITY, y = Number.NEGATIVE_INFINITY, b = !1;
    if (!r || d === null) {
      const U = u + t * s, F = o[0].pts - is(o[0].dts, o[0].pts);
      kd && d !== null && Math.abs(U - F - (d + u)) < 15e3 ? r = !0 : d = U - F - u;
    }
    const x = d + u;
    for (let U = 0; U < l; U++) {
      const F = o[U];
      F.pts = is(F.pts, x), F.dts = is(F.dts, x), F.dts < o[U > 0 ? U - 1 : U].dts && (b = !0);
    }
    b && o.sort(function(U, F) {
      const V = U.dts - F.dts, X = U.pts - F.pts;
      return V || X;
    }), m = o[0].dts, g = o[o.length - 1].dts;
    const E = g - m, w = E ? Math.round(E / (l - 1)) : h || e.inputTimeScale / 30;
    if (r) {
      const U = m - x, F = U > w, V = U < -1;
      if ((F || V) && (F ? this.warn(`${(e.segmentCodec || "").toUpperCase()}: ${cp(U, !0)} ms (${U}dts) hole between fragments detected at ${t.toFixed(3)}`) : this.warn(`${(e.segmentCodec || "").toUpperCase()}: ${cp(-U, !0)} ms (${U}dts) overlapping between fragments detected at ${t.toFixed(3)}`), !V || x >= o[0].pts || kd)) {
        m = x;
        const X = o[0].pts - U;
        if (F)
          o[0].dts = m, o[0].pts = X;
        else {
          let Z = !0;
          for (let ie = 0; ie < o.length && !(o[ie].dts > X && Z); ie++) {
            const J = o[ie].pts;
            if (o[ie].dts -= U, o[ie].pts -= U, ie < o.length - 1) {
              const se = o[ie + 1].pts, te = o[ie].pts, le = se <= te, de = se <= J;
              Z = le == de;
            }
          }
        }
        this.log(`Video: Initial PTS/DTS adjusted: ${cp(X, !0)}/${cp(m, !0)}, delta: ${cp(U, !0)} ms`);
      }
    }
    m = Math.max(0, m);
    let C = 0, S = 0, M = m;
    for (let U = 0; U < l; U++) {
      const F = o[U], V = F.units, X = V.length;
      let Z = 0;
      for (let ie = 0; ie < X; ie++)
        Z += V[ie].data.length;
      S += Z, C += X, F.length = Z, F.dts < M ? (F.dts = M, M += w / 4 | 0 || 1) : M = F.dts, v = Math.min(F.pts, v), y = Math.max(F.pts, y);
    }
    g = o[l - 1].dts;
    const k = S + 4 * C + 8;
    let _;
    try {
      _ = new Uint8Array(k);
    } catch (U) {
      this.observer.emit(N.ERROR, N.ERROR, {
        type: Je.MUX_ERROR,
        details: ce.REMUX_ALLOC_ERROR,
        fatal: !1,
        error: U,
        bytes: k,
        reason: `fail allocating video mdat ${k}`
      });
      return;
    }
    const O = new DataView(_.buffer);
    O.setUint32(0, k), _.set(ae.types.mdat, 4);
    let I = !1, R = Number.POSITIVE_INFINITY, P = Number.POSITIVE_INFINITY, D = Number.NEGATIVE_INFINITY, L = Number.NEGATIVE_INFINITY;
    for (let U = 0; U < l; U++) {
      const F = o[U], V = F.units;
      let X = 0;
      for (let J = 0, se = V.length; J < se; J++) {
        const te = V[J], le = te.data, de = te.data.byteLength;
        O.setUint32(f, de), f += 4, _.set(le, f), f += de, X += 4 + de;
      }
      let Z;
      if (U < l - 1)
        h = o[U + 1].dts - F.dts, Z = o[U + 1].pts - F.pts;
      else {
        const J = this.config, se = U > 0 ? F.dts - o[U - 1].dts : w;
        if (Z = U > 0 ? F.pts - o[U - 1].pts : w, J.stretchShortVideoTrack && this.nextAudioTs !== null) {
          const te = Math.floor(J.maxBufferHole * s), le = (i ? v + i * s : this.nextAudioTs + u) - F.pts;
          le > te ? (h = le - se, h < 0 ? h = se : I = !0, this.log(`It is approximately ${le / 90} ms to the next segment; using duration ${h / 90} ms for the last video frame.`)) : h = se;
        } else
          h = se;
      }
      const ie = Math.round(F.pts - F.dts);
      R = Math.min(R, h), D = Math.max(D, h), P = Math.min(P, Z), L = Math.max(L, Z), a.push(bH(F.key, h, X, ie));
    }
    if (a.length) {
      if (kd) {
        if (kd < 70) {
          const U = a[0].flags;
          U.dependsOn = 2, U.isNonSync = 0;
        }
      } else if (_6 && L - P < D - R && w / D < 0.025 && a[0].cts === 0) {
        this.warn("Found irregular gaps in sample duration. Using PTS instead of DTS to determine MP4 sample duration.");
        let U = m;
        for (let F = 0, V = a.length; F < V; F++) {
          const X = U + a[F].duration, Z = U + a[F].cts;
          if (F < V - 1) {
            const ie = X + a[F + 1].cts;
            a[F].duration = ie - Z;
          } else
            a[F].duration = F ? a[F - 1].duration : w;
          a[F].cts = 0, U = X;
        }
      }
    }
    h = I || !h ? w : h;
    const B = g + h;
    this.nextVideoTs = d = B - u, this.videoSampleDuration = h, this.isVideoContiguous = !0;
    const H = {
      data1: ae.moof(e.sequenceNumber++, m, mn(e, {
        samples: a
      })),
      data2: _,
      startPTS: (v - u) / s,
      endPTS: (y + h - u) / s,
      startDTS: (m - u) / s,
      endDTS: d / s,
      type: "video",
      hasAudio: !1,
      hasVideo: !0,
      nb: a.length,
      dropped: e.dropped
    };
    return e.samples = [], e.dropped = 0, H;
  }
  getSamplesPerFrame(e) {
    switch (e.segmentCodec) {
      case "mp3":
        return Yqe;
      case "ac3":
        return Xqe;
      default:
        return qqe;
    }
  }
  remuxAudio(e, t, r, i, s) {
    const o = e.inputTimeScale, a = e.samplerate ? e.samplerate : o, l = o / a, c = this.getSamplesPerFrame(e), u = c * l, d = this._initPTS, f = e.segmentCodec === "mp3" && this.typeSupported.mpeg, h = [], m = s !== void 0;
    let g = e.samples, v = f ? 0 : 8, y = this.nextAudioTs || -1;
    const b = d.baseTime * o / d.timescale, x = b + t * o;
    if (this.isAudioContiguous = r = r || g.length && y > 0 && (i && Math.abs(x - (y + b)) < 9e3 || Math.abs(is(g[0].pts, x) - (y + b)) < 20 * u), g.forEach(function(L) {
      L.pts = is(L.pts, x);
    }), !r || y < 0) {
      const L = g.length;
      if (g = g.filter((B) => B.pts >= 0), L !== g.length && this.warn(`Removed ${g.length - L} of ${L} samples (initPTS ${b} / ${o})`), !g.length)
        return;
      s === 0 ? y = 0 : i && !m ? y = Math.max(0, x - b) : y = g[0].pts - b;
    }
    if (e.segmentCodec === "aac") {
      const L = this.config.maxAudioFramesDrift;
      for (let B = 0, $ = y + b; B < g.length; B++) {
        const z = g[B], H = z.pts, U = H - $, F = Math.abs(1e3 * U / o);
        if (U <= -L * u && m)
          B === 0 && (this.warn(`Audio frame @ ${(H / o).toFixed(3)}s overlaps marker by ${Math.round(1e3 * U / o)} ms.`), this.nextAudioTs = y = H - b, $ = H);
        else if (U >= L * u && F < Kqe && m) {
          let V = Math.round(U / u);
          for ($ = H - V * u; $ < 0 && V && u; )
            V--, $ += u;
          B === 0 && (this.nextAudioTs = y = $ - b), this.warn(`Injecting ${V} audio frames @ ${(($ - b) / o).toFixed(3)}s due to ${Math.round(1e3 * U / o)} ms gap.`);
          for (let X = 0; X < V; X++) {
            let Z = jqe.getSilentFrame(e.parsedCodec || e.manifestCodec || e.codec, e.channelCount);
            Z || (this.log("Unable to get silent frame for given audio codec; duplicating last frame instead."), Z = z.unit.subarray()), g.splice(B, 0, {
              unit: Z,
              pts: $
            }), $ += u, B++;
          }
        }
        z.pts = $, $ += u;
      }
    }
    let E = null, w = null, C, S = 0, M = g.length;
    for (; M--; )
      S += g[M].unit.byteLength;
    for (let L = 0, B = g.length; L < B; L++) {
      const $ = g[L], z = $.unit;
      let H = $.pts;
      if (w !== null) {
        const F = h[L - 1];
        F.duration = Math.round((H - w) / l);
      } else if (r && e.segmentCodec === "aac" && (H = y + b), E = H, S > 0) {
        S += v;
        try {
          C = new Uint8Array(S);
        } catch (F) {
          this.observer.emit(N.ERROR, N.ERROR, {
            type: Je.MUX_ERROR,
            details: ce.REMUX_ALLOC_ERROR,
            fatal: !1,
            error: F,
            bytes: S,
            reason: `fail allocating audio mdat ${S}`
          });
          return;
        }
        f || (new DataView(C.buffer).setUint32(0, S), C.set(ae.types.mdat, 4));
      } else
        return;
      C.set(z, v);
      const U = z.byteLength;
      v += U, h.push(bH(!0, c, U, 0)), w = H;
    }
    const k = h.length;
    if (!k)
      return;
    const _ = h[h.length - 1];
    y = w - b, this.nextAudioTs = y + l * _.duration;
    const O = f ? new Uint8Array(0) : ae.moof(e.sequenceNumber++, E / l, mn({}, e, {
      samples: h
    }));
    e.samples = [];
    const I = (E - b) / o, R = this.nextAudioTs / o, D = {
      data1: O,
      data2: C,
      startPTS: I,
      endPTS: R,
      startDTS: I,
      endDTS: R,
      type: "audio",
      hasAudio: !0,
      hasVideo: !1,
      nb: k
    };
    return this.isAudioContiguous = !0, D;
  }
}
function is(n, e) {
  let t;
  if (e === null)
    return n;
  for (e < n ? t = -8589934592 : t = 8589934592; Math.abs(n - e) > 4294967296; )
    n += t;
  return n;
}
function Zqe(n) {
  for (let e = 0; e < n.length; e++)
    if (n[e].key)
      return e;
  return -1;
}
function One(n, e, t, r) {
  const i = n.samples.length;
  if (!i)
    return;
  const s = n.inputTimeScale;
  for (let a = 0; a < i; a++) {
    const l = n.samples[a];
    l.pts = is(l.pts - t.baseTime * s / t.timescale, e * s) / s, l.dts = is(l.dts - r.baseTime * s / r.timescale, e * s) / s;
  }
  const o = n.samples;
  return n.samples = [], {
    samples: o
  };
}
function Ine(n, e, t) {
  const r = n.samples.length;
  if (!r)
    return;
  const i = n.inputTimeScale;
  for (let o = 0; o < r; o++) {
    const a = n.samples[o];
    a.pts = is(a.pts - t.baseTime * i / t.timescale, e * i) / i;
  }
  n.samples.sort((o, a) => o.pts - a.pts);
  const s = n.samples;
  return n.samples = [], {
    samples: s
  };
}
class Qqe extends Ys {
  constructor(e, t, r, i) {
    super("passthrough-remuxer", i), this.emitInitSegment = !1, this.audioCodec = void 0, this.videoCodec = void 0, this.initData = void 0, this.initPTS = null, this.initTracks = void 0, this.lastEndTime = null, this.isVideoContiguous = !1;
  }
  destroy() {
  }
  resetTimeStamp(e) {
    this.lastEndTime = null;
    const t = this.initPTS;
    t && e && t.baseTime === e.baseTime && t.timescale === e.timescale || (this.initPTS = e);
  }
  resetNextTimestamp() {
    this.isVideoContiguous = !1, this.lastEndTime = null;
  }
  resetInitSegment(e, t, r, i) {
    this.audioCodec = t, this.videoCodec = r, this.generateInitSegment(e, i), this.emitInitSegment = !0;
  }
  generateInitSegment(e, t) {
    let {
      audioCodec: r,
      videoCodec: i
    } = this;
    if (!(e != null && e.byteLength)) {
      this.initTracks = void 0, this.initData = void 0;
      return;
    }
    const {
      audio: s,
      video: o
    } = this.initData = $te(e);
    if (t)
      BGe(e, t);
    else {
      const l = s || o;
      l != null && l.encrypted && this.warn(`Init segment with encrypted track with has no key ("${l.codec}")!`);
    }
    s && (r = wH(s, wn.AUDIO, this)), o && (i = wH(o, wn.VIDEO, this));
    const a = {};
    s && o ? a.audiovideo = {
      container: "video/mp4",
      codec: r + "," + i,
      supplemental: o.supplemental,
      encrypted: o.encrypted,
      initSegment: e,
      id: "main"
    } : s ? a.audio = {
      container: "audio/mp4",
      codec: r,
      encrypted: s.encrypted,
      initSegment: e,
      id: "audio"
    } : o ? a.video = {
      container: "video/mp4",
      codec: i,
      supplemental: o.supplemental,
      encrypted: o.encrypted,
      initSegment: e,
      id: "main"
    } : this.warn("initSegment does not contain moov or trak boxes."), this.initTracks = a;
  }
  remux(e, t, r, i, s, o) {
    var a, l;
    let {
      initPTS: c,
      lastEndTime: u
    } = this;
    const d = {
      audio: void 0,
      video: void 0,
      text: i,
      id3: r,
      initSegment: void 0
    };
    He(u) || (u = this.lastEndTime = s || 0);
    const f = t.samples;
    if (!f.length)
      return d;
    const h = {
      initPTS: void 0,
      timescale: void 0,
      trackId: void 0
    };
    let m = this.initData;
    if ((a = m) != null && a.length || (this.generateInitSegment(f), m = this.initData), !((l = m) != null && l.length))
      return this.warn("Failed to generate initSegment."), d;
    this.emitInitSegment && (h.tracks = this.initTracks, this.emitInitSegment = !1);
    const g = HGe(f, m, this), v = m.audio ? g[m.audio.id] : null, y = m.video ? g[m.video.id] : null, b = $g(y, 1 / 0), x = $g(v, 1 / 0), E = $g(y, 0, !0), w = $g(v, 0, !0);
    let C = s, S = 0;
    const M = v && (!y || !c && x < b || c && c.trackId === m.audio.id), k = M ? v : y;
    if (k) {
      const $ = k.timescale, z = k.start - s * $, H = M ? m.audio.id : m.video.id;
      C = k.start / $, S = M ? w - x : E - b, (o || !c) && (Jqe(c, C, s, S) || $ !== c.timescale) && (c && this.warn(`Timestamps at playlist time: ${o ? "" : "~"}${s} ${z / $} != initPTS: ${c.baseTime / c.timescale} (${c.baseTime}/${c.timescale}) trackId: ${c.trackId}`), this.log(`Found initPTS at playlist time: ${s} offset: ${C - s} (${z}/${$}) trackId: ${H}`), c = null, h.initPTS = z, h.timescale = $, h.trackId = H);
    } else
      this.warn(`No audio or video samples found for initPTS at playlist time: ${s}`);
    c ? (h.initPTS = c.baseTime, h.timescale = c.timescale, h.trackId = c.trackId) : ((!h.timescale || h.trackId === void 0 || h.initPTS === void 0) && (this.warn("Could not set initPTS"), h.initPTS = C, h.timescale = 1, h.trackId = -1), this.initPTS = c = {
      baseTime: h.initPTS,
      timescale: h.timescale,
      trackId: h.trackId
    });
    const _ = C - c.baseTime / c.timescale, O = _ + S;
    S > 0 ? this.lastEndTime = O : (this.warn("Duration parsed from mp4 should be greater than zero"), this.resetNextTimestamp());
    const I = !!m.audio, R = !!m.video;
    let P = "";
    I && (P += "audio"), R && (P += "video");
    const D = (m.audio ? m.audio.encrypted : !1) || (m.video ? m.video.encrypted : !1), L = {
      data1: f,
      startPTS: _,
      startDTS: _,
      endPTS: O,
      endDTS: O,
      type: P,
      hasAudio: I,
      hasVideo: R,
      nb: 1,
      dropped: 0,
      encrypted: D
    };
    d.audio = I && !R ? L : void 0, d.video = R ? L : void 0;
    const B = y?.sampleCount;
    if (B) {
      const $ = y.keyFrameIndex, z = $ !== -1;
      L.nb = B, L.dropped = $ === 0 || this.isVideoContiguous ? 0 : z ? $ : B, L.independent = z, L.firstKeyFrame = $, z && y.keyFrameStart && (L.firstKeyFramePTS = (y.keyFrameStart - c.baseTime) / c.timescale), this.isVideoContiguous || (d.independent = z), this.isVideoContiguous || (this.isVideoContiguous = z), L.dropped && this.warn(`fmp4 does not start with IDR: firstIDR ${$}/${B} dropped: ${L.dropped} start: ${L.firstKeyFramePTS || "NA"}`);
    }
    return d.initSegment = h, d.id3 = One(r, s, c, c), i.samples.length && (d.text = Ine(i, s, c)), d;
  }
}
function $g(n, e, t = !1) {
  return n?.start !== void 0 ? (n.start + (t ? n.duration : 0)) / n.timescale : e;
}
function Jqe(n, e, t, r) {
  if (n === null)
    return !0;
  const i = Math.max(r, 1), s = e - n.baseTime / n.timescale;
  return Math.abs(s - t) > i;
}
function wH(n, e, t) {
  const r = n.codec;
  return r && r.length > 4 ? r : e === wn.AUDIO ? r === "ec-3" || r === "ac-3" || r === "alac" ? r : r === "fLaC" || r === "Opus" ? By(r, !1) : (t.warn(`Unhandled audio codec "${r}" in mp4 MAP`), r || "mp4a") : (t.warn(`Unhandled video codec "${r}" in mp4 MAP`), r || "avc1");
}
let Ha;
try {
  Ha = self.performance.now.bind(self.performance);
} catch {
  Ha = Date.now;
}
const Gv = [{
  demux: Fqe,
  remux: Qqe
}, {
  demux: Bl,
  remux: Wv
}, {
  demux: Dqe,
  remux: Wv
}, {
  demux: Lqe,
  remux: Wv
}];
Gv.splice(2, 0, {
  demux: Nqe,
  remux: Wv
});
class xH {
  constructor(e, t, r, i, s, o) {
    this.asyncResult = !1, this.logger = void 0, this.observer = void 0, this.typeSupported = void 0, this.config = void 0, this.id = void 0, this.demuxer = void 0, this.remuxer = void 0, this.decrypter = void 0, this.probe = void 0, this.decryptionPromise = null, this.transmuxConfig = void 0, this.currentTransmuxState = void 0, this.observer = e, this.typeSupported = t, this.config = r, this.id = s, this.logger = o;
  }
  configure(e) {
    this.transmuxConfig = e, this.decrypter && this.decrypter.reset();
  }
  push(e, t, r, i) {
    const s = r.transmuxing;
    s.executeStart = Ha();
    let o = new Uint8Array(e);
    const {
      currentTransmuxState: a,
      transmuxConfig: l
    } = this;
    i && (this.currentTransmuxState = i);
    const {
      contiguous: c,
      discontinuity: u,
      trackSwitch: d,
      accurateTimeOffset: f,
      timeOffset: h,
      initSegmentChange: m
    } = i || a, {
      audioCodec: g,
      videoCodec: v,
      defaultInitPts: y,
      duration: b,
      initSegmentData: x
    } = l, E = eYe(o, t);
    if (E && ff(E.method)) {
      const M = this.getDecrypter(), k = b_(E.method);
      if (M.isSync()) {
        let _ = M.softwareDecrypt(o, E.key.buffer, E.iv.buffer, k);
        if (r.part > -1) {
          const I = M.flush();
          _ = I && I.buffer;
        }
        if (!_)
          return s.executeEnd = Ha(), O6(r);
        o = new Uint8Array(_);
      } else
        return this.asyncResult = !0, this.decryptionPromise = M.webCryptoDecrypt(o, E.key.buffer, E.iv.buffer, k).then((_) => {
          const O = this.push(_, null, r);
          return this.decryptionPromise = null, O;
        }), this.decryptionPromise;
    }
    const w = this.needsProbing(u, d);
    if (w) {
      const M = this.configureTransmuxer(o);
      if (M)
        return this.logger.warn(`[transmuxer] ${M.message}`), this.observer.emit(N.ERROR, N.ERROR, {
          type: Je.MEDIA_ERROR,
          details: ce.FRAG_PARSING_ERROR,
          fatal: !1,
          error: M,
          reason: M.message
        }), s.executeEnd = Ha(), O6(r);
    }
    (u || d || m || w) && this.resetInitSegment(x, g, v, b, t), (u || m || w) && this.resetInitialTimestamp(y), c || this.resetContiguity();
    const C = this.transmux(o, E, h, f, r);
    this.asyncResult = T0(C);
    const S = this.currentTransmuxState;
    return S.contiguous = !0, S.discontinuity = !1, S.trackSwitch = !1, s.executeEnd = Ha(), C;
  }
  // Due to data caching, flush calls can produce more than one TransmuxerResult (hence the Array type)
  flush(e) {
    const t = e.transmuxing;
    t.executeStart = Ha();
    const {
      decrypter: r,
      currentTransmuxState: i,
      decryptionPromise: s
    } = this;
    if (s)
      return this.asyncResult = !0, s.then(() => this.flush(e));
    const o = [], {
      timeOffset: a
    } = i;
    if (r) {
      const d = r.flush();
      d && o.push(this.push(d.buffer, null, e));
    }
    const {
      demuxer: l,
      remuxer: c
    } = this;
    if (!l || !c) {
      t.executeEnd = Ha();
      const d = [O6(e)];
      return this.asyncResult ? Promise.resolve(d) : d;
    }
    const u = l.flush(a);
    return T0(u) ? (this.asyncResult = !0, u.then((d) => (this.flushRemux(o, d, e), o))) : (this.flushRemux(o, u, e), this.asyncResult ? Promise.resolve(o) : o);
  }
  flushRemux(e, t, r) {
    const {
      audioTrack: i,
      videoTrack: s,
      id3Track: o,
      textTrack: a
    } = t, {
      accurateTimeOffset: l,
      timeOffset: c
    } = this.currentTransmuxState;
    this.logger.log(`[transmuxer.ts]: Flushed ${this.id} sn: ${r.sn}${r.part > -1 ? " part: " + r.part : ""} of ${this.id === We.MAIN ? "level" : "track"} ${r.level}`);
    const u = this.remuxer.remux(i, s, o, a, c, l, !0, this.id);
    e.push({
      remuxResult: u,
      chunkMeta: r
    }), r.transmuxing.executeEnd = Ha();
  }
  resetInitialTimestamp(e) {
    const {
      demuxer: t,
      remuxer: r
    } = this;
    !t || !r || (t.resetTimeStamp(e), r.resetTimeStamp(e));
  }
  resetContiguity() {
    const {
      demuxer: e,
      remuxer: t
    } = this;
    !e || !t || (e.resetContiguity(), t.resetNextTimestamp());
  }
  resetInitSegment(e, t, r, i, s) {
    const {
      demuxer: o,
      remuxer: a
    } = this;
    !o || !a || (o.resetInitSegment(e, t, r, i), a.resetInitSegment(e, t, r, s));
  }
  destroy() {
    this.demuxer && (this.demuxer.destroy(), this.demuxer = void 0), this.remuxer && (this.remuxer.destroy(), this.remuxer = void 0);
  }
  transmux(e, t, r, i, s) {
    let o;
    return t && t.method === "SAMPLE-AES" ? o = this.transmuxSampleAes(e, t, r, i, s) : o = this.transmuxUnencrypted(e, r, i, s), o;
  }
  transmuxUnencrypted(e, t, r, i) {
    const {
      audioTrack: s,
      videoTrack: o,
      id3Track: a,
      textTrack: l
    } = this.demuxer.demux(e, t, !1, !this.config.progressive);
    return {
      remuxResult: this.remuxer.remux(s, o, a, l, t, r, !1, this.id),
      chunkMeta: i
    };
  }
  transmuxSampleAes(e, t, r, i, s) {
    return this.demuxer.demuxSampleAes(e, t, r).then((o) => ({
      remuxResult: this.remuxer.remux(o.audioTrack, o.videoTrack, o.id3Track, o.textTrack, r, i, !1, this.id),
      chunkMeta: s
    }));
  }
  configureTransmuxer(e) {
    const {
      config: t,
      observer: r,
      typeSupported: i
    } = this;
    let s;
    for (let d = 0, f = Gv.length; d < f; d++) {
      var o;
      if ((o = Gv[d].demux) != null && o.probe(e, this.logger)) {
        s = Gv[d];
        break;
      }
    }
    if (!s)
      return new Error("Failed to find demuxer by probing fragment data");
    const a = this.demuxer, l = this.remuxer, c = s.remux, u = s.demux;
    (!l || !(l instanceof c)) && (this.remuxer = new c(r, t, i, this.logger)), (!a || !(a instanceof u)) && (this.demuxer = new u(r, t, i, this.logger), this.probe = u.probe);
  }
  needsProbing(e, t) {
    return !this.demuxer || !this.remuxer || e || t;
  }
  getDecrypter() {
    let e = this.decrypter;
    return e || (e = this.decrypter = new v_(this.config)), e;
  }
}
function eYe(n, e) {
  let t = null;
  return n.byteLength > 0 && e?.key != null && e.iv !== null && e.method != null && (t = e), t;
}
const O6 = (n) => ({
  remuxResult: {},
  chunkMeta: n
});
function T0(n) {
  return "then" in n && n.then instanceof Function;
}
class tYe {
  constructor(e, t, r, i, s) {
    this.audioCodec = void 0, this.videoCodec = void 0, this.initSegmentData = void 0, this.duration = void 0, this.defaultInitPts = void 0, this.audioCodec = e, this.videoCodec = t, this.initSegmentData = r, this.duration = i, this.defaultInitPts = s || null;
  }
}
class nYe {
  constructor(e, t, r, i, s, o) {
    this.discontinuity = void 0, this.contiguous = void 0, this.accurateTimeOffset = void 0, this.trackSwitch = void 0, this.timeOffset = void 0, this.initSegmentChange = void 0, this.discontinuity = e, this.contiguous = t, this.accurateTimeOffset = r, this.trackSwitch = i, this.timeOffset = s, this.initSegmentChange = o;
  }
}
let EH = 0;
class Rne {
  constructor(e, t, r, i) {
    this.error = null, this.hls = void 0, this.id = void 0, this.instanceNo = EH++, this.observer = void 0, this.frag = null, this.part = null, this.useWorker = void 0, this.workerContext = null, this.transmuxer = null, this.onTransmuxComplete = void 0, this.onFlush = void 0, this.onWorkerMessage = (l) => {
      const c = l.data, u = this.hls;
      if (!(!u || !(c != null && c.event) || c.instanceNo !== this.instanceNo))
        switch (c.event) {
          case "init": {
            var d;
            const f = (d = this.workerContext) == null ? void 0 : d.objectURL;
            f && self.URL.revokeObjectURL(f);
            break;
          }
          case "transmuxComplete": {
            this.handleTransmuxComplete(c.data);
            break;
          }
          case "flush": {
            this.onFlush(c.data);
            break;
          }
          // pass logs from the worker thread to the main logger
          case "workerLog": {
            u.logger[c.data.logType] && u.logger[c.data.logType](c.data.message);
            break;
          }
          default: {
            c.data = c.data || {}, c.data.frag = this.frag, c.data.part = this.part, c.data.id = this.id, u.trigger(c.event, c.data);
            break;
          }
        }
    }, this.onWorkerError = (l) => {
      if (!this.hls)
        return;
      const c = new Error(`${l.message}  (${l.filename}:${l.lineno})`);
      this.hls.config.enableWorker = !1, this.hls.logger.warn(`Error in "${this.id}" Web Worker, fallback to inline`), this.hls.trigger(N.ERROR, {
        type: Je.OTHER_ERROR,
        details: ce.INTERNAL_EXCEPTION,
        fatal: !1,
        event: "demuxerWorker",
        error: c
      });
    };
    const s = e.config;
    this.hls = e, this.id = t, this.useWorker = !!s.enableWorker, this.onTransmuxComplete = r, this.onFlush = i;
    const o = (l, c) => {
      c = c || {}, c.frag = this.frag || void 0, l === N.ERROR && (c = c, c.parent = this.id, c.part = this.part, this.error = c.error), this.hls.trigger(l, c);
    };
    this.observer = new E_(), this.observer.on(N.FRAG_DECRYPTED, o), this.observer.on(N.ERROR, o);
    const a = $z(s.preferManagedMediaSource);
    if (this.useWorker && typeof Worker < "u") {
      const l = this.hls.logger;
      if (s.workerPath || oqe()) {
        try {
          s.workerPath ? (l.log(`loading Web Worker ${s.workerPath} for "${t}"`), this.workerContext = lqe(s.workerPath)) : (l.log(`injecting Web Worker for "${t}"`), this.workerContext = aqe());
          const {
            worker: u
          } = this.workerContext;
          u.addEventListener("message", this.onWorkerMessage), u.addEventListener("error", this.onWorkerError), u.postMessage({
            instanceNo: this.instanceNo,
            cmd: "init",
            typeSupported: a,
            id: t,
            config: Sn(s)
          });
        } catch (u) {
          l.warn(`Error setting up "${t}" Web Worker, fallback to inline`, u), this.terminateWorker(), this.error = null, this.transmuxer = new xH(this.observer, a, s, "", t, e.logger);
        }
        return;
      }
    }
    this.transmuxer = new xH(this.observer, a, s, "", t, e.logger);
  }
  reset() {
    if (this.frag = null, this.part = null, this.workerContext) {
      const e = this.instanceNo;
      this.instanceNo = EH++;
      const t = this.hls.config, r = $z(t.preferManagedMediaSource);
      this.workerContext.worker.postMessage({
        instanceNo: this.instanceNo,
        cmd: "reset",
        resetNo: e,
        typeSupported: r,
        id: this.id,
        config: Sn(t)
      });
    }
  }
  terminateWorker() {
    if (this.workerContext) {
      const {
        worker: e
      } = this.workerContext;
      this.workerContext = null, e.removeEventListener("message", this.onWorkerMessage), e.removeEventListener("error", this.onWorkerError), cqe(this.hls.config.workerPath);
    }
  }
  destroy() {
    if (this.workerContext)
      this.terminateWorker(), this.onWorkerMessage = this.onWorkerError = null;
    else {
      const t = this.transmuxer;
      t && (t.destroy(), this.transmuxer = null);
    }
    const e = this.observer;
    e && e.removeAllListeners(), this.frag = null, this.part = null, this.observer = null, this.hls = null;
  }
  push(e, t, r, i, s, o, a, l, c, u) {
    var d, f;
    c.transmuxing.start = self.performance.now();
    const {
      instanceNo: h,
      transmuxer: m
    } = this, g = o ? o.start : s.start, v = s.decryptdata, y = this.frag, b = !(y && s.cc === y.cc), x = !(y && c.level === y.level), E = y ? c.sn - y.sn : -1, w = this.part ? c.part - this.part.index : -1, C = E === 0 && c.id > 1 && c.id === y?.stats.chunkCount, S = !x && (E === 1 || E === 0 && (w === 1 || C && w <= 0)), M = self.performance.now();
    (x || E || s.stats.parsing.start === 0) && (s.stats.parsing.start = M), o && (w || !S) && (o.stats.parsing.start = M);
    const k = !(y && ((d = s.initSegment) == null ? void 0 : d.url) === ((f = y.initSegment) == null ? void 0 : f.url)), _ = new nYe(b, S, l, x, g, k);
    if (!S || b || k) {
      this.hls.logger.log(`[transmuxer-interface]: Starting new transmux session for ${s.type} sn: ${c.sn}${c.part > -1 ? " part: " + c.part : ""} ${this.id === We.MAIN ? "level" : "track"}: ${c.level} id: ${c.id}
        discontinuity: ${b}
        trackSwitch: ${x}
        contiguous: ${S}
        accurateTimeOffset: ${l}
        timeOffset: ${g}
        initSegmentChange: ${k}`);
      const O = new tYe(r, i, t, a, u);
      this.configureTransmuxer(O);
    }
    if (this.frag = s, this.part = o, this.workerContext)
      this.workerContext.worker.postMessage({
        instanceNo: h,
        cmd: "demux",
        data: e,
        decryptdata: v,
        chunkMeta: c,
        state: _
      }, e instanceof ArrayBuffer ? [e] : []);
    else if (m) {
      const O = m.push(e, v, c, _);
      T0(O) ? O.then((I) => {
        this.handleTransmuxComplete(I);
      }).catch((I) => {
        this.transmuxerError(I, c, "transmuxer-interface push error");
      }) : this.handleTransmuxComplete(O);
    }
  }
  flush(e) {
    e.transmuxing.start = self.performance.now();
    const {
      instanceNo: t,
      transmuxer: r
    } = this;
    if (this.workerContext)
      this.workerContext.worker.postMessage({
        instanceNo: t,
        cmd: "flush",
        chunkMeta: e
      });
    else if (r) {
      const i = r.flush(e);
      T0(i) ? i.then((s) => {
        this.handleFlushResult(s, e);
      }).catch((s) => {
        this.transmuxerError(s, e, "transmuxer-interface flush error");
      }) : this.handleFlushResult(i, e);
    }
  }
  transmuxerError(e, t, r) {
    this.hls && (this.error = e, this.hls.trigger(N.ERROR, {
      type: Je.MEDIA_ERROR,
      details: ce.FRAG_PARSING_ERROR,
      chunkMeta: t,
      frag: this.frag || void 0,
      part: this.part || void 0,
      fatal: !1,
      error: e,
      err: e,
      reason: r
    }));
  }
  handleFlushResult(e, t) {
    e.forEach((r) => {
      this.handleTransmuxComplete(r);
    }), this.onFlush(t);
  }
  configureTransmuxer(e) {
    const {
      instanceNo: t,
      transmuxer: r
    } = this;
    this.workerContext ? this.workerContext.worker.postMessage({
      instanceNo: t,
      cmd: "configure",
      config: e
    }) : r && r.configure(e);
  }
  handleTransmuxComplete(e) {
    e.chunkMeta.transmuxing.end = self.performance.now(), this.onTransmuxComplete(e);
  }
}
const SH = 100;
class rYe extends x_ {
  constructor(e, t, r) {
    super(e, t, r, "audio-stream-controller", We.AUDIO), this.mainAnchor = null, this.mainFragLoading = null, this.audioOnly = !1, this.bufferedTrack = null, this.switchingTrack = null, this.trackId = -1, this.waitingData = null, this.mainDetails = null, this.flushing = !1, this.bufferFlushed = !1, this.cachedTrackLoadedData = null, this.registerListeners();
  }
  onHandlerDestroying() {
    this.unregisterListeners(), super.onHandlerDestroying(), this.resetItem();
  }
  resetItem() {
    this.mainDetails = this.mainAnchor = this.mainFragLoading = this.bufferedTrack = this.switchingTrack = this.waitingData = this.cachedTrackLoadedData = null;
  }
  registerListeners() {
    super.registerListeners();
    const {
      hls: e
    } = this;
    e.on(N.LEVEL_LOADED, this.onLevelLoaded, this), e.on(N.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), e.on(N.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(N.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.on(N.BUFFER_RESET, this.onBufferReset, this), e.on(N.BUFFER_CREATED, this.onBufferCreated, this), e.on(N.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(N.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(N.INIT_PTS_FOUND, this.onInitPtsFound, this), e.on(N.FRAG_LOADING, this.onFragLoading, this), e.on(N.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e && (super.unregisterListeners(), e.off(N.LEVEL_LOADED, this.onLevelLoaded, this), e.off(N.AUDIO_TRACKS_UPDATED, this.onAudioTracksUpdated, this), e.off(N.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(N.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.off(N.BUFFER_RESET, this.onBufferReset, this), e.off(N.BUFFER_CREATED, this.onBufferCreated, this), e.off(N.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(N.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(N.INIT_PTS_FOUND, this.onInitPtsFound, this), e.off(N.FRAG_LOADING, this.onFragLoading, this), e.off(N.FRAG_BUFFERED, this.onFragBuffered, this));
  }
  // INIT_PTS_FOUND is triggered when the video track parsed in the stream-controller has a new PTS value
  onInitPtsFound(e, {
    frag: t,
    id: r,
    initPTS: i,
    timescale: s,
    trackId: o
  }) {
    if (r === We.MAIN) {
      const a = t.cc, l = this.fragCurrent;
      if (this.initPTS[a] = {
        baseTime: i,
        timescale: s,
        trackId: o
      }, this.log(`InitPTS for cc: ${a} found from main: ${i / s} (${i}/${s}) trackId: ${o}`), this.mainAnchor = t, this.state === he.WAITING_INIT_PTS) {
        const c = this.waitingData;
        (!c && !this.loadingParts || c && c.frag.cc !== a) && this.syncWithAnchor(t, c?.frag);
      } else !this.hls.hasEnoughToStart && l && l.cc !== a ? (l.abortRequests(), this.syncWithAnchor(t, l)) : this.state === he.IDLE && this.tick();
    }
  }
  getLoadPosition() {
    return !this.startFragRequested && this.nextLoadPosition >= 0 ? this.nextLoadPosition : super.getLoadPosition();
  }
  syncWithAnchor(e, t) {
    var r;
    const i = ((r = this.mainFragLoading) == null ? void 0 : r.frag) || null;
    if (t && i?.cc === t.cc)
      return;
    const s = (i || e).cc, o = this.getLevelDetails(), a = this.getLoadPosition(), l = qte(o, s, a);
    l && (this.log(`Syncing with main frag at ${l.start} cc ${l.cc}`), this.startFragRequested = !1, this.nextLoadPosition = l.start, this.resetLoadingState(), this.state === he.IDLE && this.doTickIdle());
  }
  startLoad(e, t) {
    if (!this.levels) {
      this.startPosition = e, this.state = he.STOPPED;
      return;
    }
    const r = this.lastCurrentTime;
    this.stopLoad(), this.setInterval(SH), r > 0 && e === -1 ? (this.log(`Override startPosition with lastCurrentTime @${r.toFixed(3)}`), e = r, this.state = he.IDLE) : this.state = he.WAITING_TRACK, this.nextLoadPosition = this.lastCurrentTime = e + this.timelineOffset, this.startPosition = t ? -1 : e, this.tick();
  }
  doTick() {
    switch (this.state) {
      case he.IDLE:
        this.doTickIdle();
        break;
      case he.WAITING_TRACK: {
        const {
          levels: e,
          trackId: t
        } = this, r = e?.[t], i = r?.details;
        if (i && !this.waitForLive(r)) {
          if (this.waitForCdnTuneIn(i))
            break;
          this.state = he.WAITING_INIT_PTS;
        }
        break;
      }
      case he.FRAG_LOADING_WAITING_RETRY: {
        this.checkRetryDate();
        break;
      }
      case he.WAITING_INIT_PTS: {
        const e = this.waitingData;
        if (e) {
          const {
            frag: t,
            part: r,
            cache: i,
            complete: s
          } = e, o = this.mainAnchor;
          if (this.initPTS[t.cc] !== void 0) {
            this.waitingData = null, this.state = he.FRAG_LOADING;
            const a = i.flush().buffer, l = {
              frag: t,
              part: r,
              payload: a,
              networkDetails: null
            };
            this._handleFragmentLoadProgress(l), s && super._handleFragmentLoadComplete(l);
          } else o && o.cc !== e.frag.cc && this.syncWithAnchor(o, e.frag);
        } else
          this.state = he.IDLE;
      }
    }
    this.onTickEnd();
  }
  resetLoadingState() {
    const e = this.waitingData;
    e && (this.fragmentTracker.removeFragment(e.frag), this.waitingData = null), super.resetLoadingState();
  }
  onTickEnd() {
    const {
      media: e
    } = this;
    e != null && e.readyState && (this.lastCurrentTime = e.currentTime);
  }
  doTickIdle() {
    var e;
    const {
      hls: t,
      levels: r,
      media: i,
      trackId: s
    } = this, o = t.config;
    if (!this.buffering || !i && !this.primaryPrefetch && (this.startFragRequested || !o.startFragPrefetch) || !(r != null && r[s]))
      return;
    const a = r[s], l = a.details;
    if (!l || this.waitForLive(a) || this.waitForCdnTuneIn(l)) {
      this.state = he.WAITING_TRACK, this.startFragRequested = !1;
      return;
    }
    const c = this.mediaBuffer ? this.mediaBuffer : this.media;
    this.bufferFlushed && c && (this.bufferFlushed = !1, this.afterBufferFlushed(c, wn.AUDIO, We.AUDIO));
    const u = this.getFwdBufferInfo(c, We.AUDIO);
    if (u === null)
      return;
    if (!this.switchingTrack && this._streamEnded(u, l)) {
      t.trigger(N.BUFFER_EOS, {
        type: "audio"
      }), this.state = he.ENDED;
      return;
    }
    const d = u.len, f = t.maxBufferLength, h = l.fragments, m = h[0].start, g = this.getLoadPosition(), v = this.flushing ? g : u.end;
    if (this.switchingTrack && i) {
      const x = g;
      l.PTSKnown && x < m && (u.end > m || u.nextStart) && (this.log("Alt audio track ahead of main track, seek to start of alt audio track"), i.currentTime = m + 0.05);
    }
    if (d >= f && !this.switchingTrack && v < h[h.length - 1].start)
      return;
    let y = this.getNextFragment(v, l);
    if (y && this.isLoopLoading(y, v) && (y = this.getNextFragmentLoopLoading(y, l, u, We.MAIN, f)), !y) {
      this.bufferFlushed = !0;
      return;
    }
    let b = ((e = this.mainFragLoading) == null ? void 0 : e.frag) || null;
    if (!this.audioOnly && this.startFragRequested && b && tr(y) && !y.endList && (!l.live || !this.loadingParts && v < this.hls.liveSyncPosition) && (this.fragmentTracker.getState(b) === wr.OK && (this.mainFragLoading = b = null), b && tr(b))) {
      if (y.start > b.end) {
        const E = this.fragmentTracker.getFragAtPos(v, We.MAIN);
        E && E.end > b.end && (b = E, this.mainFragLoading = {
          frag: E,
          targetBufferTime: null
        });
      }
      if (y.start > b.end)
        return;
    }
    this.loadFragment(y, a, v);
  }
  onMediaDetaching(e, t) {
    this.bufferFlushed = this.flushing = !1, super.onMediaDetaching(e, t);
  }
  onAudioTracksUpdated(e, {
    audioTracks: t
  }) {
    this.resetTransmuxer(), this.levels = t.map((r) => new E0(r));
  }
  onAudioTrackSwitching(e, t) {
    const r = !!t.url;
    this.trackId = t.id;
    const {
      fragCurrent: i
    } = this;
    i && (i.abortRequests(), this.removeUnbufferedFrags(i.start)), this.resetLoadingState(), r ? (this.switchingTrack = t, this.flushAudioIfNeeded(t), this.state !== he.STOPPED && (this.setInterval(SH), this.state = he.IDLE, this.tick())) : (this.resetTransmuxer(), this.switchingTrack = null, this.bufferedTrack = t, this.clearInterval());
  }
  onManifestLoading() {
    super.onManifestLoading(), this.bufferFlushed = this.flushing = this.audioOnly = !1, this.resetItem(), this.trackId = -1;
  }
  onLevelLoaded(e, t) {
    this.mainDetails = t.details;
    const r = this.cachedTrackLoadedData;
    r && (this.cachedTrackLoadedData = null, this.onAudioTrackLoaded(N.AUDIO_TRACK_LOADED, r));
  }
  onAudioTrackLoaded(e, t) {
    var r;
    const {
      levels: i
    } = this, {
      details: s,
      id: o,
      groupId: a,
      track: l
    } = t;
    if (!i) {
      this.warn(`Audio tracks reset while loading track ${o} "${l.name}" of "${a}"`);
      return;
    }
    const c = this.mainDetails;
    if (!c || s.endCC > c.endCC || c.expired) {
      this.cachedTrackLoadedData = t, this.state !== he.STOPPED && (this.state = he.WAITING_TRACK);
      return;
    }
    this.cachedTrackLoadedData = null, this.log(`Audio track ${o} "${l.name}" of "${a}" loaded [${s.startSN},${s.endSN}]${s.lastPartSn ? `[part-${s.lastPartSn}-${s.lastPartIndex}]` : ""},duration:${s.totalduration}`);
    const u = i[o];
    let d = 0;
    if (s.live || (r = u.details) != null && r.live) {
      if (this.checkLiveUpdate(s), s.deltaUpdateFailed)
        return;
      if (u.details) {
        var f;
        d = this.alignPlaylists(s, u.details, (f = this.levelLastLoaded) == null ? void 0 : f.details);
      }
      s.alignedSliding || (fne(s, c), s.alignedSliding || Gy(s, c), d = s.fragmentStart);
    }
    u.details = s, this.levelLastLoaded = u, this.startFragRequested || this.setStartPosition(c, d), this.hls.trigger(N.AUDIO_TRACK_UPDATED, {
      details: s,
      id: o,
      groupId: t.groupId
    }), this.state === he.WAITING_TRACK && !this.waitForCdnTuneIn(s) && (this.state = he.IDLE), this.tick();
  }
  _handleFragmentLoadProgress(e) {
    var t;
    const r = e.frag, {
      part: i,
      payload: s
    } = e, {
      config: o,
      trackId: a,
      levels: l
    } = this;
    if (!l) {
      this.warn(`Audio tracks were reset while fragment load was in progress. Fragment ${r.sn} of level ${r.level} will not be buffered`);
      return;
    }
    const c = l[a];
    if (!c) {
      this.warn("Audio track is undefined on fragment load progress");
      return;
    }
    const u = c.details;
    if (!u) {
      this.warn("Audio track details undefined on fragment load progress"), this.removeUnbufferedFrags(r.start);
      return;
    }
    const d = o.defaultAudioCodec || c.audioCodec || "mp4a.40.2";
    let f = this.transmuxer;
    f || (f = this.transmuxer = new Rne(this.hls, We.AUDIO, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)));
    const h = this.initPTS[r.cc], m = (t = r.initSegment) == null ? void 0 : t.data;
    if (h !== void 0) {
      const v = i ? i.index : -1, y = v !== -1, b = new y_(r.level, r.sn, r.stats.chunkCount, s.byteLength, v, y);
      f.push(s, m, d, "", r, i, u.totalduration, !1, b, h);
    } else {
      this.log(`Unknown video PTS for cc ${r.cc}, waiting for video PTS before demuxing audio frag ${r.sn} of [${u.startSN} ,${u.endSN}],track ${a}`);
      const {
        cache: g
      } = this.waitingData = this.waitingData || {
        frag: r,
        part: i,
        cache: new hne(),
        complete: !1
      };
      g.push(new Uint8Array(s)), this.state !== he.STOPPED && (this.state = he.WAITING_INIT_PTS);
    }
  }
  _handleFragmentLoadComplete(e) {
    if (this.waitingData) {
      this.waitingData.complete = !0;
      return;
    }
    super._handleFragmentLoadComplete(e);
  }
  onBufferReset() {
    this.mediaBuffer = null;
  }
  onBufferCreated(e, t) {
    this.bufferFlushed = this.flushing = !1;
    const r = t.tracks.audio;
    r && (this.mediaBuffer = r.buffer || null);
  }
  onFragLoading(e, t) {
    !this.audioOnly && t.frag.type === We.MAIN && tr(t.frag) && (this.mainFragLoading = t, this.state === he.IDLE && this.tick());
  }
  onFragBuffered(e, t) {
    const {
      frag: r,
      part: i
    } = t;
    if (r.type !== We.AUDIO) {
      !this.audioOnly && r.type === We.MAIN && !r.elementaryStreams.video && !r.elementaryStreams.audiovideo && (this.audioOnly = !0, this.mainFragLoading = null);
      return;
    }
    if (this.fragContextChanged(r)) {
      this.warn(`Fragment ${r.sn}${i ? " p: " + i.index : ""} of level ${r.level} finished buffering, but was aborted. state: ${this.state}, audioSwitch: ${this.switchingTrack ? this.switchingTrack.name : "false"}`);
      return;
    }
    if (tr(r)) {
      this.fragPrevious = r;
      const s = this.switchingTrack;
      s && (this.bufferedTrack = s, this.switchingTrack = null, this.hls.trigger(N.AUDIO_TRACK_SWITCHED, cn({}, s)));
    }
    this.fragBufferedComplete(r, i), this.media && this.tick();
  }
  onError(e, t) {
    var r;
    if (t.fatal) {
      this.state = he.ERROR;
      return;
    }
    switch (t.details) {
      case ce.FRAG_GAP:
      case ce.FRAG_PARSING_ERROR:
      case ce.FRAG_DECRYPT_ERROR:
      case ce.FRAG_LOAD_ERROR:
      case ce.FRAG_LOAD_TIMEOUT:
      case ce.KEY_LOAD_ERROR:
      case ce.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(We.AUDIO, t);
        break;
      case ce.AUDIO_TRACK_LOAD_ERROR:
      case ce.AUDIO_TRACK_LOAD_TIMEOUT:
      case ce.LEVEL_PARSING_ERROR:
        !t.levelRetry && this.state === he.WAITING_TRACK && ((r = t.context) == null ? void 0 : r.type) === Dt.AUDIO_TRACK && (this.state = he.IDLE);
        break;
      case ce.BUFFER_ADD_CODEC_ERROR:
      case ce.BUFFER_APPEND_ERROR:
        if (t.parent !== "audio")
          return;
        this.reduceLengthAndFlushBuffer(t) || this.resetLoadingState();
        break;
      case ce.BUFFER_FULL_ERROR:
        if (t.parent !== "audio")
          return;
        this.reduceLengthAndFlushBuffer(t) && (this.bufferedTrack = null, super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio"));
        break;
      case ce.INTERNAL_EXCEPTION:
        this.recoverWorkerError(t);
        break;
    }
  }
  onBufferFlushing(e, {
    type: t
  }) {
    t !== wn.VIDEO && (this.flushing = !0);
  }
  onBufferFlushed(e, {
    type: t
  }) {
    if (t !== wn.VIDEO) {
      this.flushing = !1, this.bufferFlushed = !0, this.state === he.ENDED && (this.state = he.IDLE);
      const r = this.mediaBuffer || this.media;
      r && (this.afterBufferFlushed(r, t, We.AUDIO), this.tick());
    }
  }
  _handleTransmuxComplete(e) {
    var t;
    const r = "audio", {
      hls: i
    } = this, {
      remuxResult: s,
      chunkMeta: o
    } = e, a = this.getCurrentContext(o);
    if (!a) {
      this.resetWhenMissingContext(o);
      return;
    }
    const {
      frag: l,
      part: c,
      level: u
    } = a, {
      details: d
    } = u, {
      audio: f,
      text: h,
      id3: m,
      initSegment: g
    } = s;
    if (this.fragContextChanged(l) || !d) {
      this.fragmentTracker.removeFragment(l);
      return;
    }
    if (this.state = he.PARSING, this.switchingTrack && f && this.completeAudioSwitch(this.switchingTrack), g != null && g.tracks) {
      const v = l.initSegment || l;
      if (this.unhandledEncryptionError(g, l))
        return;
      this._bufferInitSegment(u, g.tracks, v, o), i.trigger(N.FRAG_PARSING_INIT_SEGMENT, {
        frag: v,
        id: r,
        tracks: g.tracks
      });
    }
    if (f) {
      const {
        startPTS: v,
        endPTS: y,
        startDTS: b,
        endDTS: x
      } = f;
      c && (c.elementaryStreams[wn.AUDIO] = {
        startPTS: v,
        endPTS: y,
        startDTS: b,
        endDTS: x
      }), l.setElementaryStreamInfo(wn.AUDIO, v, y, b, x), this.bufferFragmentData(f, l, c, o);
    }
    if (m != null && (t = m.samples) != null && t.length) {
      const v = mn({
        id: r,
        frag: l,
        details: d
      }, m);
      i.trigger(N.FRAG_PARSING_METADATA, v);
    }
    if (h) {
      const v = mn({
        id: r,
        frag: l,
        details: d
      }, h);
      i.trigger(N.FRAG_PARSING_USERDATA, v);
    }
  }
  _bufferInitSegment(e, t, r, i) {
    if (this.state !== he.PARSING || (t.video && delete t.video, t.audiovideo && delete t.audiovideo, !t.audio))
      return;
    const s = t.audio;
    s.id = We.AUDIO;
    const o = e.audioCodec;
    this.log(`Init audio buffer, container:${s.container}, codecs[level/parsed]=[${o}/${s.codec}]`), o && o.split(",").length === 1 && (s.levelCodec = o), this.hls.trigger(N.BUFFER_CODECS, t);
    const a = s.initSegment;
    if (a != null && a.byteLength) {
      const l = {
        type: "audio",
        frag: r,
        part: null,
        chunkMeta: i,
        parent: r.type,
        data: a
      };
      this.hls.trigger(N.BUFFER_APPENDING, l);
    }
    this.tickImmediate();
  }
  loadFragment(e, t, r) {
    const i = this.fragmentTracker.getState(e);
    if (this.switchingTrack || i === wr.NOT_LOADED || i === wr.PARTIAL) {
      var s;
      if (!tr(e))
        this._loadInitSegment(e, t);
      else if ((s = t.details) != null && s.live && !this.initPTS[e.cc]) {
        this.log(`Waiting for video PTS in continuity counter ${e.cc} of live stream before loading audio fragment ${e.sn} of level ${this.trackId}`), this.state = he.WAITING_INIT_PTS;
        const o = this.mainDetails;
        o && o.fragmentStart !== t.details.fragmentStart && Gy(t.details, o);
      } else
        super.loadFragment(e, t, r);
    } else
      this.clearTrackerIfNeeded(e);
  }
  flushAudioIfNeeded(e) {
    if (this.media && this.bufferedTrack) {
      const {
        name: t,
        lang: r,
        assocLang: i,
        characteristics: s,
        audioCodec: o,
        channels: a
      } = this.bufferedTrack;
      Eu({
        name: t,
        lang: r,
        assocLang: i,
        characteristics: s,
        audioCodec: o,
        channels: a
      }, e, Xc) || (Hy(e.url, this.hls) ? (this.log("Switching audio track : flushing all audio"), super.flushMainBuffer(0, Number.POSITIVE_INFINITY, "audio"), this.bufferedTrack = null) : this.bufferedTrack = e);
    }
  }
  completeAudioSwitch(e) {
    const {
      hls: t
    } = this;
    this.flushAudioIfNeeded(e), this.bufferedTrack = e, this.switchingTrack = null, t.trigger(N.AUDIO_TRACK_SWITCHED, cn({}, e));
  }
}
class __ extends Ys {
  constructor(e, t) {
    super(t, e.logger), this.hls = void 0, this.canLoad = !1, this.timer = -1, this.hls = e;
  }
  destroy() {
    this.clearTimer(), this.hls = this.log = this.warn = null;
  }
  clearTimer() {
    this.timer !== -1 && (self.clearTimeout(this.timer), this.timer = -1);
  }
  startLoad() {
    this.canLoad = !0, this.loadPlaylist();
  }
  stopLoad() {
    this.canLoad = !1, this.clearTimer();
  }
  switchParams(e, t, r) {
    const i = t?.renditionReports;
    if (i) {
      let s = -1;
      for (let o = 0; o < i.length; o++) {
        const a = i[o];
        let l;
        try {
          l = new self.URL(a.URI, t.url).href;
        } catch (c) {
          this.warn(`Could not construct new URL for Rendition Report: ${c}`), l = a.URI || "";
        }
        if (l === e) {
          s = o;
          break;
        } else l === e.substring(0, l.length) && (s = o);
      }
      if (s !== -1) {
        const o = i[s], a = parseInt(o["LAST-MSN"]) || t.lastPartSn;
        let l = parseInt(o["LAST-PART"]) || t.lastPartIndex;
        if (this.hls.config.lowLatencyMode) {
          const u = Math.min(t.age - t.partTarget, t.targetduration);
          l >= 0 && u > t.partTarget && (l += 1);
        }
        const c = r && Fz(r);
        return new Bz(a, l >= 0 ? l : void 0, c);
      }
    }
  }
  loadPlaylist(e) {
    this.clearTimer();
  }
  loadingPlaylist(e, t) {
    this.clearTimer();
  }
  shouldLoadPlaylist(e) {
    return this.canLoad && !!e && !!e.url && (!e.details || e.details.live);
  }
  getUrlWithDirectives(e, t) {
    if (t)
      try {
        return t.addDirectives(e);
      } catch (r) {
        this.warn(`Could not construct new URL with HLS Delivery Directives: ${r}`);
      }
    return e;
  }
  playlistLoaded(e, t, r) {
    const {
      details: i,
      stats: s
    } = t, o = self.performance.now(), a = s.loading.first ? Math.max(0, o - s.loading.first) : 0;
    i.advancedDateTime = Date.now() - a;
    const l = this.hls.config.timelineOffset;
    if (l !== i.appliedTimelineOffset) {
      const u = Math.max(l || 0, 0);
      i.appliedTimelineOffset = u, i.fragments.forEach((d) => {
        d.setStart(d.playlistOffset + u);
      });
    }
    if (i.live || r != null && r.live) {
      const u = "levelInfo" in t ? t.levelInfo : t.track;
      if (i.reloaded(r), r && i.fragments.length > 0) {
        YKe(r, i, this);
        const b = i.playlistParsingError;
        if (b) {
          this.warn(b);
          const x = this.hls;
          if (!x.config.ignorePlaylistParsingErrors) {
            var c;
            const {
              networkDetails: E
            } = t;
            x.trigger(N.ERROR, {
              type: Je.NETWORK_ERROR,
              details: ce.LEVEL_PARSING_ERROR,
              fatal: !1,
              url: i.url,
              error: b,
              reason: b.message,
              level: t.level || void 0,
              parent: (c = i.fragments[0]) == null ? void 0 : c.type,
              networkDetails: E,
              stats: s
            });
            return;
          }
          i.playlistParsingError = null;
        }
      }
      i.requestScheduled === -1 && (i.requestScheduled = s.loading.start);
      const d = this.hls.mainForwardBufferInfo, f = d ? d.end - d.len : 0, h = (i.edge - f) * 1e3, m = ane(i, h);
      if (i.requestScheduled + m < o ? i.requestScheduled = o : i.requestScheduled += m, this.log(`live playlist ${e} ${i.advanced ? "REFRESHED " + i.lastPartSn + "-" + i.lastPartIndex : i.updated ? "UPDATED" : "MISSED"}`), !this.canLoad || !i.live)
        return;
      let g, v, y;
      if (i.canBlockReload && i.endSN && i.advanced) {
        const b = this.hls.config.lowLatencyMode, x = i.lastPartSn, E = i.endSN, w = i.lastPartIndex, C = w !== -1, S = x === E;
        C ? S ? (v = E + 1, y = b ? 0 : w) : (v = x, y = b ? w + 1 : i.maxPartIndex) : v = E + 1;
        const M = i.age, k = M + i.ageHeader;
        let _ = Math.min(k - i.partTarget, i.targetduration * 1.5);
        if (_ > 0) {
          if (k > i.targetduration * 3)
            this.log(`Playlist last advanced ${M.toFixed(2)}s ago. Omitting segment and part directives.`), v = void 0, y = void 0;
          else if (r != null && r.tuneInGoal && k - i.partTarget > r.tuneInGoal)
            this.warn(`CDN Tune-in goal increased from: ${r.tuneInGoal} to: ${_} with playlist age: ${i.age}`), _ = 0;
          else {
            const O = Math.floor(_ / i.targetduration);
            if (v += O, y !== void 0) {
              const I = Math.round(_ % i.targetduration / i.partTarget);
              y += I;
            }
            this.log(`CDN Tune-in age: ${i.ageHeader}s last advanced ${M.toFixed(2)}s goal: ${_} skip sn ${O} to part ${y}`);
          }
          i.tuneInGoal = _;
        }
        if (g = this.getDeliveryDirectives(i, t.deliveryDirectives, v, y), b || !S) {
          i.requestScheduled = o, this.loadingPlaylist(u, g);
          return;
        }
      } else (i.canBlockReload || i.canSkipUntil) && (g = this.getDeliveryDirectives(i, t.deliveryDirectives, v, y));
      g && v !== void 0 && i.canBlockReload && (i.requestScheduled = s.loading.first + Math.max(m - a * 2, m / 2)), this.scheduleLoading(u, g, i);
    } else
      this.clearTimer();
  }
  scheduleLoading(e, t, r) {
    const i = r || e.details;
    if (!i) {
      this.loadingPlaylist(e, t);
      return;
    }
    const s = self.performance.now(), o = i.requestScheduled;
    if (s >= o) {
      this.loadingPlaylist(e, t);
      return;
    }
    const a = o - s;
    this.log(`reload live playlist ${e.name || e.bitrate + "bps"} in ${Math.round(a)} ms`), this.clearTimer(), this.timer = self.setTimeout(() => this.loadingPlaylist(e, t), a);
  }
  getDeliveryDirectives(e, t, r, i) {
    let s = Fz(e);
    return t != null && t.skip && e.deltaUpdateFailed && (r = t.msn, i = t.part, s = Vv.No), new Bz(r, i, s);
  }
  checkRetry(e) {
    const t = e.details, r = Uy(e), i = e.errorAction, {
      action: s,
      retryCount: o = 0,
      retryConfig: a
    } = i || {}, l = !!i && !!a && (s === $r.RetryRequest || !i.resolved && s === $r.SendAlternateToPenaltyBox);
    if (l) {
      var c;
      if (o >= a.maxNumRetry)
        return !1;
      if (r && (c = e.context) != null && c.deliveryDirectives)
        this.warn(`Retrying playlist loading ${o + 1}/${a.maxNumRetry} after "${t}" without delivery-directives`), this.loadPlaylist();
      else {
        const u = g_(a, o);
        this.clearTimer(), this.timer = self.setTimeout(() => this.loadPlaylist(), u), this.warn(`Retrying playlist loading ${o + 1}/${a.maxNumRetry} after "${t}" in ${u}ms`);
      }
      e.levelRetry = !0, i.resolved = !0;
    }
    return l;
  }
}
function Pne(n, e) {
  if (n.length !== e.length)
    return !1;
  for (let t = 0; t < n.length; t++)
    if (!A0(n[t].attrs, e[t].attrs))
      return !1;
  return !0;
}
function A0(n, e, t) {
  const r = n["STABLE-RENDITION-ID"];
  return r && !t ? r === e["STABLE-RENDITION-ID"] : !(t || ["LANGUAGE", "NAME", "CHARACTERISTICS", "AUTOSELECT", "DEFAULT", "FORCED", "ASSOC-LANGUAGE"]).some((i) => n[i] !== e[i]);
}
function M7(n, e) {
  return e.label.toLowerCase() === n.name.toLowerCase() && (!e.language || e.language.toLowerCase() === (n.lang || "").toLowerCase());
}
class iYe extends __ {
  constructor(e) {
    super(e, "audio-track-controller"), this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0, this.registerListeners();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(N.MANIFEST_LOADING, this.onManifestLoading, this), e.on(N.MANIFEST_PARSED, this.onManifestParsed, this), e.on(N.LEVEL_LOADING, this.onLevelLoading, this), e.on(N.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(N.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.on(N.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(N.MANIFEST_LOADING, this.onManifestLoading, this), e.off(N.MANIFEST_PARSED, this.onManifestParsed, this), e.off(N.LEVEL_LOADING, this.onLevelLoading, this), e.off(N.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(N.AUDIO_TRACK_LOADED, this.onAudioTrackLoaded, this), e.off(N.ERROR, this.onError, this);
  }
  destroy() {
    this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.currentTrack = null, super.destroy();
  }
  onManifestLoading() {
    this.tracks = [], this.tracksInGroup = [], this.groupIds = null, this.currentTrack = null, this.trackId = -1, this.selectDefaultTrack = !0;
  }
  onManifestParsed(e, t) {
    this.tracks = t.audioTracks || [];
  }
  onAudioTrackLoaded(e, t) {
    const {
      id: r,
      groupId: i,
      details: s
    } = t, o = this.tracksInGroup[r];
    if (!o || o.groupId !== i) {
      this.warn(`Audio track with id:${r} and group:${i} not found in active group ${o?.groupId}`);
      return;
    }
    const a = o.details;
    o.details = t.details, this.log(`Audio track ${r} "${o.name}" lang:${o.lang} group:${i} loaded [${s.startSN}-${s.endSN}]`), r === this.trackId && this.playlistLoaded(r, t, a);
  }
  onLevelLoading(e, t) {
    this.switchLevel(t.level);
  }
  onLevelSwitching(e, t) {
    this.switchLevel(t.level);
  }
  switchLevel(e) {
    const t = this.hls.levels[e];
    if (!t)
      return;
    const r = t.audioGroups || null, i = this.groupIds;
    let s = this.currentTrack;
    if (!r || i?.length !== r?.length || r != null && r.some((a) => i?.indexOf(a) === -1)) {
      this.groupIds = r, this.trackId = -1, this.currentTrack = null;
      const a = this.tracks.filter((f) => !r || r.indexOf(f.groupId) !== -1);
      if (a.length)
        this.selectDefaultTrack && !a.some((f) => f.default) && (this.selectDefaultTrack = !1), a.forEach((f, h) => {
          f.id = h;
        });
      else if (!s && !this.tracksInGroup.length)
        return;
      this.tracksInGroup = a;
      const l = this.hls.config.audioPreference;
      if (!s && l) {
        const f = ia(l, a, Xc);
        if (f > -1)
          s = a[f];
        else {
          const h = ia(l, this.tracks);
          s = this.tracks[h];
        }
      }
      let c = this.findTrackId(s);
      c === -1 && s && (c = this.findTrackId(null));
      const u = {
        audioTracks: a
      };
      this.log(`Updating audio tracks, ${a.length} track(s) found in group(s): ${r?.join(",")}`), this.hls.trigger(N.AUDIO_TRACKS_UPDATED, u);
      const d = this.trackId;
      if (c !== -1 && d === -1)
        this.setAudioTrack(c);
      else if (a.length && d === -1) {
        var o;
        const f = new Error(`No audio track selected for current audio group-ID(s): ${(o = this.groupIds) == null ? void 0 : o.join(",")} track count: ${a.length}`);
        this.warn(f.message), this.hls.trigger(N.ERROR, {
          type: Je.MEDIA_ERROR,
          details: ce.AUDIO_TRACK_LOAD_ERROR,
          fatal: !0,
          error: f
        });
      }
    }
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === Dt.AUDIO_TRACK && t.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(t.context.groupId) !== -1) && this.checkRetry(t);
  }
  get allAudioTracks() {
    return this.tracks;
  }
  get audioTracks() {
    return this.tracksInGroup;
  }
  get audioTrack() {
    return this.trackId;
  }
  set audioTrack(e) {
    this.selectDefaultTrack = !1, this.setAudioTrack(e);
  }
  setAudioOption(e) {
    const t = this.hls;
    if (t.config.audioPreference = e, e) {
      const r = this.allAudioTracks;
      if (this.selectDefaultTrack = !1, r.length) {
        const i = this.currentTrack;
        if (i && Eu(e, i, Xc))
          return i;
        const s = ia(e, this.tracksInGroup, Xc);
        if (s > -1) {
          const o = this.tracksInGroup[s];
          return this.setAudioTrack(s), o;
        } else if (i) {
          let o = t.loadLevel;
          o === -1 && (o = t.firstAutoLevel);
          const a = gKe(e, t.levels, r, o, Xc);
          if (a === -1)
            return null;
          t.nextLoadLevel = a;
        }
        if (e.channels || e.audioCodec) {
          const o = ia(e, r);
          if (o > -1)
            return r[o];
        }
      }
    }
    return null;
  }
  setAudioTrack(e) {
    const t = this.tracksInGroup;
    if (e < 0 || e >= t.length) {
      this.warn(`Invalid audio track id: ${e}`);
      return;
    }
    this.selectDefaultTrack = !1;
    const r = this.currentTrack, i = t[e], s = i.details && !i.details.live;
    if (e === this.trackId && i === r && s || (this.log(`Switching to audio-track ${e} "${i.name}" lang:${i.lang} group:${i.groupId} channels:${i.channels}`), this.trackId = e, this.currentTrack = i, this.hls.trigger(N.AUDIO_TRACK_SWITCHING, cn({}, i)), s))
      return;
    const o = this.switchParams(i.url, r?.details, i.details);
    this.loadPlaylist(o);
  }
  findTrackId(e) {
    const t = this.tracksInGroup;
    for (let r = 0; r < t.length; r++) {
      const i = t[r];
      if (!(this.selectDefaultTrack && !i.default) && (!e || Eu(e, i, Xc)))
        return r;
    }
    if (e) {
      const {
        name: r,
        lang: i,
        assocLang: s,
        characteristics: o,
        audioCodec: a,
        channels: l
      } = e;
      for (let c = 0; c < t.length; c++) {
        const u = t[c];
        if (Eu({
          name: r,
          lang: i,
          assocLang: s,
          characteristics: o,
          audioCodec: a,
          channels: l
        }, u, Xc))
          return c;
      }
      for (let c = 0; c < t.length; c++) {
        const u = t[c];
        if (A0(e.attrs, u.attrs, ["LANGUAGE", "ASSOC-LANGUAGE", "CHARACTERISTICS"]))
          return c;
      }
      for (let c = 0; c < t.length; c++) {
        const u = t[c];
        if (A0(e.attrs, u.attrs, ["LANGUAGE"]))
          return c;
      }
    }
    return -1;
  }
  loadPlaylist(e) {
    super.loadPlaylist();
    const t = this.currentTrack;
    this.shouldLoadPlaylist(t) && Hy(t.url, this.hls) && this.scheduleLoading(t, e);
  }
  loadingPlaylist(e, t) {
    super.loadingPlaylist(e, t);
    const r = e.id, i = e.groupId, s = this.getUrlWithDirectives(e.url, t), o = e.details, a = o?.age;
    this.log(`Loading audio-track ${r} "${e.name}" lang:${e.lang} group:${i}${t?.msn !== void 0 ? " at sn " + t.msn + " part " + t.part : ""}${a && o.live ? " age " + a.toFixed(1) + (o.type && " " + o.type || "") : ""} ${s}`), this.hls.trigger(N.AUDIO_TRACK_LOADING, {
      url: s,
      id: r,
      groupId: i,
      deliveryDirectives: t || null,
      track: e
    });
  }
}
class sYe {
  constructor(e) {
    this.tracks = void 0, this.queues = {
      video: [],
      audio: [],
      audiovideo: []
    }, this.tracks = e;
  }
  destroy() {
    this.tracks = this.queues = null;
  }
  append(e, t, r) {
    if (this.queues === null || this.tracks === null)
      return;
    const i = this.queues[t];
    i.push(e), i.length === 1 && !r && this.executeNext(t);
  }
  appendBlocker(e) {
    return new Promise((t) => {
      const r = {
        label: "async-blocker",
        execute: t,
        onStart: () => {
        },
        onComplete: () => {
        },
        onError: () => {
        }
      };
      this.append(r, e);
    });
  }
  prependBlocker(e) {
    return new Promise((t) => {
      if (this.queues) {
        const r = {
          label: "async-blocker-prepend",
          execute: t,
          onStart: () => {
          },
          onComplete: () => {
          },
          onError: () => {
          }
        };
        this.queues[e].unshift(r);
      }
    });
  }
  removeBlockers() {
    this.queues !== null && [this.queues.video, this.queues.audio, this.queues.audiovideo].forEach((e) => {
      var t;
      const r = (t = e[0]) == null ? void 0 : t.label;
      (r === "async-blocker" || r === "async-blocker-prepend") && (e[0].execute(), e.splice(0, 1));
    });
  }
  unblockAudio(e) {
    if (this.queues === null)
      return;
    this.queues.audio[0] === e && this.shiftAndExecuteNext("audio");
  }
  executeNext(e) {
    if (this.queues === null || this.tracks === null)
      return;
    const t = this.queues[e];
    if (t.length) {
      const i = t[0];
      try {
        i.execute();
      } catch (s) {
        var r;
        if (i.onError(s), this.queues === null || this.tracks === null)
          return;
        const o = (r = this.tracks[e]) == null ? void 0 : r.buffer;
        o != null && o.updating || this.shiftAndExecuteNext(e);
      }
    }
  }
  shiftAndExecuteNext(e) {
    this.queues !== null && (this.queues[e].shift(), this.executeNext(e));
  }
  current(e) {
    var t;
    return ((t = this.queues) == null ? void 0 : t[e][0]) || null;
  }
  toString() {
    const {
      queues: e,
      tracks: t
    } = this;
    return e === null || t === null ? "<destroyed>" : `
${this.list("video")}
${this.list("audio")}
${this.list("audiovideo")}}`;
  }
  list(e) {
    var t, r;
    return (t = this.queues) != null && t[e] || (r = this.tracks) != null && r[e] ? `${e}: (${this.listSbInfo(e)}) ${this.listOps(e)}` : "";
  }
  listSbInfo(e) {
    var t;
    const r = (t = this.tracks) == null ? void 0 : t[e], i = r?.buffer;
    return i ? `SourceBuffer${i.updating ? " updating" : ""}${r.ended ? " ended" : ""}${r.ending ? " ending" : ""}` : "none";
  }
  listOps(e) {
    var t;
    return ((t = this.queues) == null ? void 0 : t[e].map((r) => r.label).join(", ")) || "";
  }
}
const CH = /(avc[1234]|hvc1|hev1|dvh[1e]|vp09|av01)(?:\.[^.,]+)+/, Dne = "HlsJsTrackRemovedError";
class oYe extends Error {
  constructor(e) {
    super(e), this.name = Dne;
  }
}
class aYe extends Ys {
  constructor(e, t) {
    super("buffer-controller", e.logger), this.hls = void 0, this.fragmentTracker = void 0, this.details = null, this._objectUrl = null, this.operationQueue = null, this.bufferCodecEventsTotal = 0, this.media = null, this.mediaSource = null, this.lastMpegAudioChunk = null, this.blockedAudioAppend = null, this.lastVideoAppendEnd = 0, this.appendSource = void 0, this.transferData = void 0, this.overrides = void 0, this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    }, this.tracks = {}, this.sourceBuffers = [[null, null], [null, null]], this._onEndStreaming = (r) => {
      var i;
      this.hls && ((i = this.mediaSource) == null ? void 0 : i.readyState) === "open" && this.hls.pauseBuffering();
    }, this._onStartStreaming = (r) => {
      this.hls && this.hls.resumeBuffering();
    }, this._onMediaSourceOpen = (r) => {
      const {
        media: i,
        mediaSource: s
      } = this;
      r && this.log("Media source opened"), !(!i || !s) && (s.removeEventListener("sourceopen", this._onMediaSourceOpen), i.removeEventListener("emptied", this._onMediaEmptied), this.updateDuration(), this.hls.trigger(N.MEDIA_ATTACHED, {
        media: i,
        mediaSource: s
      }), this.mediaSource !== null && this.checkPendingTracks());
    }, this._onMediaSourceClose = () => {
      this.log("Media source closed");
    }, this._onMediaSourceEnded = () => {
      this.log("Media source ended");
    }, this._onMediaEmptied = () => {
      const {
        mediaSrc: r,
        _objectUrl: i
      } = this;
      r !== i && this.error(`Media element src was set while attaching MediaSource (${i} > ${r})`);
    }, this.hls = e, this.fragmentTracker = t, this.appendSource = _Ge(gc(e.config.preferManagedMediaSource)), this.initTracks(), this.registerListeners();
  }
  hasSourceTypes() {
    return Object.keys(this.tracks).length > 0;
  }
  destroy() {
    this.unregisterListeners(), this.details = null, this.lastMpegAudioChunk = this.blockedAudioAppend = null, this.transferData = this.overrides = void 0, this.operationQueue && (this.operationQueue.destroy(), this.operationQueue = null), this.hls = this.fragmentTracker = null, this._onMediaSourceOpen = this._onMediaSourceClose = null, this._onMediaSourceEnded = null, this._onStartStreaming = this._onEndStreaming = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(N.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(N.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(N.MANIFEST_LOADING, this.onManifestLoading, this), e.on(N.MANIFEST_PARSED, this.onManifestParsed, this), e.on(N.BUFFER_RESET, this.onBufferReset, this), e.on(N.BUFFER_APPENDING, this.onBufferAppending, this), e.on(N.BUFFER_CODECS, this.onBufferCodecs, this), e.on(N.BUFFER_EOS, this.onBufferEos, this), e.on(N.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(N.LEVEL_UPDATED, this.onLevelUpdated, this), e.on(N.FRAG_PARSED, this.onFragParsed, this), e.on(N.FRAG_CHANGED, this.onFragChanged, this), e.on(N.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(N.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(N.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(N.MANIFEST_LOADING, this.onManifestLoading, this), e.off(N.MANIFEST_PARSED, this.onManifestParsed, this), e.off(N.BUFFER_RESET, this.onBufferReset, this), e.off(N.BUFFER_APPENDING, this.onBufferAppending, this), e.off(N.BUFFER_CODECS, this.onBufferCodecs, this), e.off(N.BUFFER_EOS, this.onBufferEos, this), e.off(N.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(N.LEVEL_UPDATED, this.onLevelUpdated, this), e.off(N.FRAG_PARSED, this.onFragParsed, this), e.off(N.FRAG_CHANGED, this.onFragChanged, this), e.off(N.ERROR, this.onError, this);
  }
  transferMedia() {
    const {
      media: e,
      mediaSource: t
    } = this;
    if (!e)
      return null;
    const r = {};
    if (this.operationQueue) {
      const s = this.isUpdating();
      s || this.operationQueue.removeBlockers();
      const o = this.isQueued();
      (s || o) && this.warn(`Transfering MediaSource with${o ? " operations in queue" : ""}${s ? " updating SourceBuffer(s)" : ""} ${this.operationQueue}`), this.operationQueue.destroy();
    }
    const i = this.transferData;
    return !this.sourceBufferCount && i && i.mediaSource === t ? mn(r, i.tracks) : this.sourceBuffers.forEach((s) => {
      const [o] = s;
      o && (r[o] = mn({}, this.tracks[o]), this.removeBuffer(o)), s[0] = s[1] = null;
    }), {
      media: e,
      mediaSource: t,
      tracks: r
    };
  }
  initTracks() {
    const e = {};
    this.sourceBuffers = [[null, null], [null, null]], this.tracks = e, this.resetQueue(), this.resetAppendErrors(), this.lastMpegAudioChunk = this.blockedAudioAppend = null, this.lastVideoAppendEnd = 0;
  }
  onManifestLoading() {
    this.bufferCodecEventsTotal = 0, this.details = null;
  }
  onManifestParsed(e, t) {
    var r;
    let i = 2;
    (t.audio && !t.video || !t.altAudio) && (i = 1), this.bufferCodecEventsTotal = i, this.log(`${i} bufferCodec event(s) expected.`), (r = this.transferData) != null && r.mediaSource && this.sourceBufferCount && i && this.bufferCreated();
  }
  onMediaAttaching(e, t) {
    const r = this.media = t.media;
    this.transferData = this.overrides = void 0;
    const i = gc(this.appendSource);
    if (i) {
      const s = !!t.mediaSource;
      (s || t.overrides) && (this.transferData = t, this.overrides = t.overrides);
      const o = this.mediaSource = t.mediaSource || new i();
      if (this.assignMediaSource(o), s)
        this._objectUrl = r.src, this.attachTransferred();
      else {
        const a = this._objectUrl = self.URL.createObjectURL(o);
        if (this.appendSource)
          try {
            r.removeAttribute("src");
            const l = self.ManagedMediaSource;
            r.disableRemotePlayback = r.disableRemotePlayback || l && o instanceof l, TH(r), lYe(r, a), r.load();
          } catch {
            r.src = a;
          }
        else
          r.src = a;
      }
      r.addEventListener("emptied", this._onMediaEmptied);
    }
  }
  assignMediaSource(e) {
    var t, r;
    this.log(`${((t = this.transferData) == null ? void 0 : t.mediaSource) === e ? "transferred" : "created"} media source: ${(r = e.constructor) == null ? void 0 : r.name}`), e.addEventListener("sourceopen", this._onMediaSourceOpen), e.addEventListener("sourceended", this._onMediaSourceEnded), e.addEventListener("sourceclose", this._onMediaSourceClose), this.appendSource && (e.addEventListener("startstreaming", this._onStartStreaming), e.addEventListener("endstreaming", this._onEndStreaming));
  }
  attachTransferred() {
    const e = this.media, t = this.transferData;
    if (!t || !e)
      return;
    const r = this.tracks, i = t.tracks, s = i ? Object.keys(i) : null, o = s ? s.length : 0, a = () => {
      Promise.resolve().then(() => {
        this.media && this.mediaSourceOpenOrEnded && this._onMediaSourceOpen();
      });
    };
    if (i && s && o) {
      if (!this.tracksReady) {
        this.hls.config.startFragPrefetch = !0, this.log("attachTransferred: waiting for SourceBuffer track info");
        return;
      }
      if (this.log(`attachTransferred: (bufferCodecEventsTotal ${this.bufferCodecEventsTotal})
required tracks: ${Sn(r, (l, c) => l === "initSegment" ? void 0 : c)};
transfer tracks: ${Sn(i, (l, c) => l === "initSegment" ? void 0 : c)}}`), !Ote(i, r)) {
        t.mediaSource = null, t.tracks = void 0;
        const l = e.currentTime, c = this.details, u = Math.max(l, c?.fragments[0].start || 0);
        if (u - l > 1) {
          this.log(`attachTransferred: waiting for playback to reach new tracks start time ${l} -> ${u}`);
          return;
        }
        this.warn(`attachTransferred: resetting MediaSource for incompatible tracks ("${Object.keys(i)}"->"${Object.keys(r)}") start time: ${u} currentTime: ${l}`), this.onMediaDetaching(N.MEDIA_DETACHING, {}), this.onMediaAttaching(N.MEDIA_ATTACHING, t), e.currentTime = u;
        return;
      }
      this.transferData = void 0, s.forEach((l) => {
        const c = l, u = i[c];
        if (u) {
          const d = u.buffer;
          if (d) {
            const f = this.fragmentTracker, h = u.id;
            if (f.hasFragments(h) || f.hasParts(h)) {
              const v = St.getBuffered(d);
              f.detectEvictedFragments(c, v, h, null, !0);
            }
            const m = I6(c), g = [c, d];
            this.sourceBuffers[m] = g, d.updating && this.operationQueue && this.operationQueue.prependBlocker(c), this.trackSourceBuffer(c, u);
          }
        }
      }), a(), this.bufferCreated();
    } else
      this.log("attachTransferred: MediaSource w/o SourceBuffers"), a();
  }
  get mediaSourceOpenOrEnded() {
    var e;
    const t = (e = this.mediaSource) == null ? void 0 : e.readyState;
    return t === "open" || t === "ended";
  }
  onMediaDetaching(e, t) {
    const r = !!t.transferMedia;
    this.transferData = this.overrides = void 0;
    const {
      media: i,
      mediaSource: s,
      _objectUrl: o
    } = this;
    if (s) {
      if (this.log(`media source ${r ? "transferring" : "detaching"}`), r)
        this.sourceBuffers.forEach(([a]) => {
          a && this.removeBuffer(a);
        }), this.resetQueue();
      else {
        if (this.mediaSourceOpenOrEnded) {
          const a = s.readyState === "open";
          try {
            const l = s.sourceBuffers;
            for (let c = l.length; c--; )
              a && l[c].abort(), s.removeSourceBuffer(l[c]);
            a && s.endOfStream();
          } catch (l) {
            this.warn(`onMediaDetaching: ${l.message} while calling endOfStream`);
          }
        }
        this.sourceBufferCount && this.onBufferReset();
      }
      s.removeEventListener("sourceopen", this._onMediaSourceOpen), s.removeEventListener("sourceended", this._onMediaSourceEnded), s.removeEventListener("sourceclose", this._onMediaSourceClose), this.appendSource && (s.removeEventListener("startstreaming", this._onStartStreaming), s.removeEventListener("endstreaming", this._onEndStreaming)), this.mediaSource = null, this._objectUrl = null;
    }
    i && (i.removeEventListener("emptied", this._onMediaEmptied), r || (o && self.URL.revokeObjectURL(o), this.mediaSrc === o ? (i.removeAttribute("src"), this.appendSource && TH(i), i.load()) : this.warn("media|source.src was changed by a third party - skip cleanup")), this.media = null), this.hls.trigger(N.MEDIA_DETACHED, t);
  }
  onBufferReset() {
    this.sourceBuffers.forEach(([e]) => {
      e && this.resetBuffer(e);
    }), this.initTracks();
  }
  resetBuffer(e) {
    var t;
    const r = (t = this.tracks[e]) == null ? void 0 : t.buffer;
    if (this.removeBuffer(e), r)
      try {
        var i;
        (i = this.mediaSource) != null && i.sourceBuffers.length && this.mediaSource.removeSourceBuffer(r);
      } catch (s) {
        this.warn(`onBufferReset ${e}`, s);
      }
    delete this.tracks[e];
  }
  removeBuffer(e) {
    this.removeBufferListeners(e), this.sourceBuffers[I6(e)] = [null, null];
    const t = this.tracks[e];
    t && (t.buffer = void 0);
  }
  resetQueue() {
    this.operationQueue && this.operationQueue.destroy(), this.operationQueue = new sYe(this.tracks);
  }
  onBufferCodecs(e, t) {
    var r;
    const i = this.tracks, s = Object.keys(t);
    this.log(`BUFFER_CODECS: "${s}" (current SB count ${this.sourceBufferCount})`);
    const o = "audiovideo" in t && (i.audio || i.video) || i.audiovideo && ("audio" in t || "video" in t), a = !o && this.sourceBufferCount && this.media && s.some((l) => !i[l]);
    if (o || a) {
      this.warn(`Unsupported transition between "${Object.keys(i)}" and "${s}" SourceBuffers`);
      return;
    }
    s.forEach((l) => {
      var c, u;
      const d = t[l], {
        id: f,
        codec: h,
        levelCodec: m,
        container: g,
        metadata: v,
        supplemental: y
      } = d;
      let b = i[l];
      const x = (c = this.transferData) == null || (c = c.tracks) == null ? void 0 : c[l], E = x != null && x.buffer ? x : b, w = E?.pendingCodec || E?.codec, C = E?.levelCodec;
      b || (b = i[l] = {
        buffer: void 0,
        listeners: [],
        codec: h,
        supplemental: y,
        container: g,
        levelCodec: m,
        metadata: v,
        id: f
      });
      const S = Uv(w, C), M = S?.replace(CH, "$1");
      let k = Uv(h, m);
      const _ = (u = k) == null ? void 0 : u.replace(CH, "$1");
      k && S && M !== _ && (l.slice(0, 5) === "audio" && (k = By(k, this.appendSource)), this.log(`switching codec ${w} to ${k}`), k !== (b.pendingCodec || b.codec) && (b.pendingCodec = k), b.container = g, this.appendChangeType(l, g, k));
    }), (this.tracksReady || this.sourceBufferCount) && (t.tracks = this.sourceBufferTracks), !this.sourceBufferCount && (this.bufferCodecEventsTotal > 1 && !this.tracks.video && !t.video && ((r = t.audio) == null ? void 0 : r.id) === "main" && (this.log("Main audio-only"), this.bufferCodecEventsTotal = 1), this.mediaSourceOpenOrEnded && this.checkPendingTracks());
  }
  get sourceBufferTracks() {
    return Object.keys(this.tracks).reduce((e, t) => {
      const r = this.tracks[t];
      return e[t] = {
        id: r.id,
        container: r.container,
        codec: r.codec,
        levelCodec: r.levelCodec
      }, e;
    }, {});
  }
  appendChangeType(e, t, r) {
    const i = `${t};codecs=${r}`, s = {
      label: `change-type=${i}`,
      execute: () => {
        const o = this.tracks[e];
        if (o) {
          const a = o.buffer;
          a != null && a.changeType && (this.log(`changing ${e} sourceBuffer type to ${i}`), a.changeType(i), o.codec = r, o.container = t);
        }
        this.shiftAndExecuteNext(e);
      },
      onStart: () => {
      },
      onComplete: () => {
      },
      onError: (o) => {
        this.warn(`Failed to change ${e} SourceBuffer type`, o);
      }
    };
    this.append(s, e, this.isPending(this.tracks[e]));
  }
  blockAudio(e) {
    var t;
    const r = e.start, i = r + e.duration * 0.05;
    if (((t = this.fragmentTracker.getAppendedFrag(r, We.MAIN)) == null ? void 0 : t.gap) === !0)
      return;
    const o = {
      label: "block-audio",
      execute: () => {
        var a;
        const l = this.tracks.video;
        (this.lastVideoAppendEnd > i || l != null && l.buffer && St.isBuffered(l.buffer, i) || ((a = this.fragmentTracker.getAppendedFrag(i, We.MAIN)) == null ? void 0 : a.gap) === !0) && (this.blockedAudioAppend = null, this.shiftAndExecuteNext("audio"));
      },
      onStart: () => {
      },
      onComplete: () => {
      },
      onError: (a) => {
        this.warn("Error executing block-audio operation", a);
      }
    };
    this.blockedAudioAppend = {
      op: o,
      frag: e
    }, this.append(o, "audio", !0);
  }
  unblockAudio() {
    const {
      blockedAudioAppend: e,
      operationQueue: t
    } = this;
    e && t && (this.blockedAudioAppend = null, t.unblockAudio(e.op));
  }
  onBufferAppending(e, t) {
    const {
      tracks: r
    } = this, {
      data: i,
      type: s,
      parent: o,
      frag: a,
      part: l,
      chunkMeta: c,
      offset: u
    } = t, d = c.buffering[s], {
      sn: f,
      cc: h
    } = a, m = self.performance.now();
    d.start = m;
    const g = a.stats.buffering, v = l ? l.stats.buffering : null;
    g.start === 0 && (g.start = m), v && v.start === 0 && (v.start = m);
    const y = r.audio;
    let b = !1;
    s === "audio" && y?.container === "audio/mpeg" && (b = !this.lastMpegAudioChunk || c.id === 1 || this.lastMpegAudioChunk.sn !== c.sn, this.lastMpegAudioChunk = c);
    const x = r.video, E = x?.buffer;
    if (E && f !== "initSegment") {
      const S = l || a, M = this.blockedAudioAppend;
      if (s === "audio" && o !== "main" && !this.blockedAudioAppend && !(x.ending || x.ended)) {
        const _ = S.start + S.duration * 0.05, O = E.buffered, I = this.currentOp("video");
        !O.length && !I ? this.blockAudio(S) : !I && !St.isBuffered(E, _) && this.lastVideoAppendEnd < _ && this.blockAudio(S);
      } else if (s === "video") {
        const k = S.end;
        if (M) {
          const _ = M.frag.start;
          (k > _ || k < this.lastVideoAppendEnd || St.isBuffered(E, _)) && this.unblockAudio();
        }
        this.lastVideoAppendEnd = k;
      }
    }
    const w = (l || a).start, C = {
      label: `append-${s}`,
      execute: () => {
        var S;
        d.executeStart = self.performance.now();
        const M = (S = this.tracks[s]) == null ? void 0 : S.buffer;
        M && (b ? this.updateTimestampOffset(M, w, 0.1, s, f, h) : u !== void 0 && He(u) && this.updateTimestampOffset(M, u, 1e-6, s, f, h)), this.appendExecutor(i, s);
      },
      onStart: () => {
      },
      onComplete: () => {
        const S = self.performance.now();
        d.executeEnd = d.end = S, g.first === 0 && (g.first = S), v && v.first === 0 && (v.first = S);
        const M = {};
        this.sourceBuffers.forEach(([k, _]) => {
          k && (M[k] = St.getBuffered(_));
        }), this.appendErrors[s] = 0, s === "audio" || s === "video" ? this.appendErrors.audiovideo = 0 : (this.appendErrors.audio = 0, this.appendErrors.video = 0), this.hls.trigger(N.BUFFER_APPENDED, {
          type: s,
          frag: a,
          part: l,
          chunkMeta: c,
          parent: a.type,
          timeRanges: M
        });
      },
      onError: (S) => {
        var M;
        const k = {
          type: Je.MEDIA_ERROR,
          parent: a.type,
          details: ce.BUFFER_APPEND_ERROR,
          sourceBufferName: s,
          frag: a,
          part: l,
          chunkMeta: c,
          error: S,
          err: S,
          fatal: !1
        }, _ = (M = this.media) == null ? void 0 : M.error;
        if (S.code === DOMException.QUOTA_EXCEEDED_ERR || S.name == "QuotaExceededError" || "quota" in S)
          k.details = ce.BUFFER_FULL_ERROR;
        else if (S.code === DOMException.INVALID_STATE_ERR && this.mediaSourceOpenOrEnded && !_)
          k.errorAction = df(!0);
        else if (S.name === Dne && this.sourceBufferCount === 0)
          k.errorAction = df(!0);
        else {
          const O = ++this.appendErrors[s];
          this.warn(`Failed ${O}/${this.hls.config.appendErrorMaxRetry} times to append segment in "${s}" sourceBuffer (${_ || "no media error"})`), (O >= this.hls.config.appendErrorMaxRetry || _) && (k.fatal = !0);
        }
        this.hls.trigger(N.ERROR, k);
      }
    };
    this.log(`queuing "${s}" append sn: ${f}${l ? " p: " + l.index : ""} of ${a.type === We.MAIN ? "level" : "track"} ${a.level} cc: ${h}`), this.append(C, s, this.isPending(this.tracks[s]));
  }
  getFlushOp(e, t, r) {
    return this.log(`queuing "${e}" remove ${t}-${r}`), {
      label: "remove",
      execute: () => {
        this.removeExecutor(e, t, r);
      },
      onStart: () => {
      },
      onComplete: () => {
        this.hls.trigger(N.BUFFER_FLUSHED, {
          type: e
        });
      },
      onError: (i) => {
        this.warn(`Failed to remove ${t}-${r} from "${e}" SourceBuffer`, i);
      }
    };
  }
  onBufferFlushing(e, t) {
    const {
      type: r,
      startOffset: i,
      endOffset: s
    } = t;
    r ? this.append(this.getFlushOp(r, i, s), r) : this.sourceBuffers.forEach(([o]) => {
      o && this.append(this.getFlushOp(o, i, s), o);
    });
  }
  onFragParsed(e, t) {
    const {
      frag: r,
      part: i
    } = t, s = [], o = i ? i.elementaryStreams : r.elementaryStreams;
    o[wn.AUDIOVIDEO] ? s.push("audiovideo") : (o[wn.AUDIO] && s.push("audio"), o[wn.VIDEO] && s.push("video"));
    const a = () => {
      const l = self.performance.now();
      r.stats.buffering.end = l, i && (i.stats.buffering.end = l);
      const c = i ? i.stats : r.stats;
      this.hls.trigger(N.FRAG_BUFFERED, {
        frag: r,
        part: i,
        stats: c,
        id: r.type
      });
    };
    s.length === 0 && this.warn(`Fragments must have at least one ElementaryStreamType set. type: ${r.type} level: ${r.level} sn: ${r.sn}`), this.blockBuffers(a, s).catch((l) => {
      this.warn(`Fragment buffered callback ${l}`), this.stepOperationQueue(this.sourceBufferTypes);
    });
  }
  onFragChanged(e, t) {
    this.trimBuffers();
  }
  get bufferedToEnd() {
    return this.sourceBufferCount > 0 && !this.sourceBuffers.some(([e]) => {
      if (e) {
        const t = this.tracks[e];
        if (t)
          return !t.ended || t.ending;
      }
      return !1;
    });
  }
  // on BUFFER_EOS mark matching sourcebuffer(s) as "ending" and "ended" and queue endOfStream after remaining operations(s)
  // an undefined data.type will mark all buffers as EOS.
  onBufferEos(e, t) {
    var r;
    this.sourceBuffers.forEach(([o]) => {
      if (o) {
        const a = this.tracks[o];
        (!t.type || t.type === o) && (a.ending = !0, a.ended || (a.ended = !0, this.log(`${o} buffer reached EOS`)));
      }
    });
    const i = ((r = this.overrides) == null ? void 0 : r.endOfStream) !== !1;
    this.sourceBufferCount > 0 && !this.sourceBuffers.some(([o]) => {
      var a;
      return o && !((a = this.tracks[o]) != null && a.ended);
    }) ? i ? (this.log("Queueing EOS"), this.blockUntilOpen(() => {
      this.tracksEnded();
      const {
        mediaSource: o
      } = this;
      if (!o || o.readyState !== "open") {
        o && this.log(`Could not call mediaSource.endOfStream(). mediaSource.readyState: ${o.readyState}`);
        return;
      }
      this.log("Calling mediaSource.endOfStream()"), o.endOfStream(), this.hls.trigger(N.BUFFERED_TO_END, void 0);
    })) : (this.tracksEnded(), this.hls.trigger(N.BUFFERED_TO_END, void 0)) : t.type === "video" && this.unblockAudio();
  }
  tracksEnded() {
    this.sourceBuffers.forEach(([e]) => {
      if (e !== null) {
        const t = this.tracks[e];
        t && (t.ending = !1);
      }
    });
  }
  onLevelUpdated(e, {
    details: t
  }) {
    t.fragments.length && (this.details = t, this.updateDuration());
  }
  updateDuration() {
    this.blockUntilOpen(() => {
      const e = this.getDurationAndRange();
      e && this.updateMediaSource(e);
    });
  }
  onError(e, t) {
    if (t.details === ce.BUFFER_APPEND_ERROR && t.frag) {
      var r;
      const i = (r = t.errorAction) == null ? void 0 : r.nextAutoLevel;
      He(i) && i !== t.frag.level && this.resetAppendErrors();
    }
  }
  resetAppendErrors() {
    this.appendErrors = {
      audio: 0,
      video: 0,
      audiovideo: 0
    };
  }
  trimBuffers() {
    const {
      hls: e,
      details: t,
      media: r
    } = this;
    if (!r || t === null || !this.sourceBufferCount)
      return;
    const i = e.config, s = r.currentTime, o = t.levelTargetDuration, a = t.live && i.liveBackBufferLength !== null ? i.liveBackBufferLength : i.backBufferLength;
    if (He(a) && a >= 0) {
      const c = Math.max(a, o), u = Math.floor(s / o) * o - c;
      this.flushBackBuffer(s, o, u);
    }
    const l = i.frontBufferFlushThreshold;
    if (He(l) && l > 0) {
      const c = Math.max(i.maxBufferLength, l), u = Math.max(c, o), d = Math.floor(s / o) * o + u;
      this.flushFrontBuffer(s, o, d);
    }
  }
  flushBackBuffer(e, t, r) {
    this.sourceBuffers.forEach(([i, s]) => {
      if (s) {
        const a = St.getBuffered(s);
        if (a.length > 0 && r > a.start(0)) {
          var o;
          this.hls.trigger(N.BACK_BUFFER_REACHED, {
            bufferEnd: r
          });
          const l = this.tracks[i];
          if ((o = this.details) != null && o.live)
            this.hls.trigger(N.LIVE_BACK_BUFFER_REACHED, {
              bufferEnd: r
            });
          else if (l != null && l.ended) {
            this.log(`Cannot flush ${i} back buffer while SourceBuffer is in ended state`);
            return;
          }
          this.hls.trigger(N.BUFFER_FLUSHING, {
            startOffset: 0,
            endOffset: r,
            type: i
          });
        }
      }
    });
  }
  flushFrontBuffer(e, t, r) {
    this.sourceBuffers.forEach(([i, s]) => {
      if (s) {
        const o = St.getBuffered(s), a = o.length;
        if (a < 2)
          return;
        const l = o.start(a - 1), c = o.end(a - 1);
        if (r > l || e >= l && e <= c)
          return;
        this.hls.trigger(N.BUFFER_FLUSHING, {
          startOffset: l,
          endOffset: 1 / 0,
          type: i
        });
      }
    });
  }
  /**
   * Update Media Source duration to current level duration or override to Infinity if configuration parameter
   * 'liveDurationInfinity` is set to `true`
   * More details: https://github.com/video-dev/hls.js/issues/355
   */
  getDurationAndRange() {
    var e;
    const {
      details: t,
      mediaSource: r
    } = this;
    if (!t || !this.media || r?.readyState !== "open")
      return null;
    const i = t.edge;
    if (t.live && this.hls.config.liveDurationInfinity) {
      if (t.fragments.length && r.setLiveSeekableRange) {
        const c = Math.max(0, t.fragmentStart), u = Math.max(c, i);
        return {
          duration: 1 / 0,
          start: c,
          end: u
        };
      }
      return {
        duration: 1 / 0
      };
    }
    const s = (e = this.overrides) == null ? void 0 : e.duration;
    if (s)
      return He(s) ? {
        duration: s
      } : null;
    const o = this.media.duration, a = He(r.duration) ? r.duration : 0;
    return i > a && i > o || !He(o) ? {
      duration: i
    } : null;
  }
  updateMediaSource({
    duration: e,
    start: t,
    end: r
  }) {
    const i = this.mediaSource;
    !this.media || !i || i.readyState !== "open" || (i.duration !== e && (He(e) && this.log(`Updating MediaSource duration to ${e.toFixed(3)}`), i.duration = e), t !== void 0 && r !== void 0 && (this.log(`MediaSource duration is set to ${i.duration}. Setting seekable range to ${t}-${r}.`), i.setLiveSeekableRange(t, r)));
  }
  get tracksReady() {
    const e = this.pendingTrackCount;
    return e > 0 && (e >= this.bufferCodecEventsTotal || this.isPending(this.tracks.audiovideo));
  }
  checkPendingTracks() {
    const {
      bufferCodecEventsTotal: e,
      pendingTrackCount: t,
      tracks: r
    } = this;
    if (this.log(`checkPendingTracks (pending: ${t} codec events expected: ${e}) ${Sn(r)}`), this.tracksReady) {
      var i;
      const s = (i = this.transferData) == null ? void 0 : i.tracks;
      s && Object.keys(s).length ? this.attachTransferred() : this.createSourceBuffers();
    }
  }
  bufferCreated() {
    if (this.sourceBufferCount) {
      const e = {};
      this.sourceBuffers.forEach(([t, r]) => {
        if (t) {
          const i = this.tracks[t];
          e[t] = {
            buffer: r,
            container: i.container,
            codec: i.codec,
            supplemental: i.supplemental,
            levelCodec: i.levelCodec,
            id: i.id,
            metadata: i.metadata
          };
        }
      }), this.hls.trigger(N.BUFFER_CREATED, {
        tracks: e
      }), this.log(`SourceBuffers created. Running queue: ${this.operationQueue}`), this.sourceBuffers.forEach(([t]) => {
        this.executeNext(t);
      });
    } else {
      const e = new Error("could not create source buffer for media codec(s)");
      this.hls.trigger(N.ERROR, {
        type: Je.MEDIA_ERROR,
        details: ce.BUFFER_INCOMPATIBLE_CODECS_ERROR,
        fatal: !0,
        error: e,
        reason: e.message
      });
    }
  }
  createSourceBuffers() {
    const {
      tracks: e,
      sourceBuffers: t,
      mediaSource: r
    } = this;
    if (!r)
      throw new Error("createSourceBuffers called when mediaSource was null");
    for (const s in e) {
      const o = s, a = e[o];
      if (this.isPending(a)) {
        const l = this.getTrackCodec(a, o), c = `${a.container};codecs=${l}`;
        a.codec = l, this.log(`creating sourceBuffer(${c})${this.currentOp(o) ? " Queued" : ""} ${Sn(a)}`);
        try {
          const u = r.addSourceBuffer(c), d = I6(o), f = [o, u];
          t[d] = f, a.buffer = u;
        } catch (u) {
          var i;
          this.error(`error while trying to add sourceBuffer: ${u.message}`), this.shiftAndExecuteNext(o), (i = this.operationQueue) == null || i.removeBlockers(), delete this.tracks[o], this.hls.trigger(N.ERROR, {
            type: Je.MEDIA_ERROR,
            details: ce.BUFFER_ADD_CODEC_ERROR,
            fatal: !1,
            error: u,
            sourceBufferName: o,
            mimeType: c,
            parent: a.id
          });
          return;
        }
        this.trackSourceBuffer(o, a);
      }
    }
    this.bufferCreated();
  }
  getTrackCodec(e, t) {
    const r = e.supplemental;
    let i = e.codec;
    r && (t === "video" || t === "audiovideo") && w0(r, "video") && (i = ZGe(i, r));
    const s = Uv(i, e.levelCodec);
    return s ? t.slice(0, 5) === "audio" ? By(s, this.appendSource) : s : "";
  }
  trackSourceBuffer(e, t) {
    const r = t.buffer;
    if (!r)
      return;
    const i = this.getTrackCodec(t, e);
    this.tracks[e] = {
      buffer: r,
      codec: i,
      container: t.container,
      levelCodec: t.levelCodec,
      supplemental: t.supplemental,
      metadata: t.metadata,
      id: t.id,
      listeners: []
    }, this.removeBufferListeners(e), this.addBufferListener(e, "updatestart", this.onSBUpdateStart), this.addBufferListener(e, "updateend", this.onSBUpdateEnd), this.addBufferListener(e, "error", this.onSBUpdateError), this.appendSource && this.addBufferListener(e, "bufferedchange", (s, o) => {
      const a = o.removedRanges;
      a != null && a.length && this.hls.trigger(N.BUFFER_FLUSHED, {
        type: s
      });
    });
  }
  get mediaSrc() {
    var e, t;
    const r = ((e = this.media) == null || (t = e.querySelector) == null ? void 0 : t.call(e, "source")) || this.media;
    return r?.src;
  }
  onSBUpdateStart(e) {
    const t = this.currentOp(e);
    t && t.onStart();
  }
  onSBUpdateEnd(e) {
    var t;
    if (((t = this.mediaSource) == null ? void 0 : t.readyState) === "closed") {
      this.resetBuffer(e);
      return;
    }
    const r = this.currentOp(e);
    r && (r.onComplete(), this.shiftAndExecuteNext(e));
  }
  onSBUpdateError(e, t) {
    var r;
    const i = new Error(`${e} SourceBuffer error. MediaSource readyState: ${(r = this.mediaSource) == null ? void 0 : r.readyState}`);
    this.error(`${i}`, t), this.hls.trigger(N.ERROR, {
      type: Je.MEDIA_ERROR,
      details: ce.BUFFER_APPENDING_ERROR,
      sourceBufferName: e,
      error: i,
      fatal: !1
    });
    const s = this.currentOp(e);
    s && s.onError(i);
  }
  updateTimestampOffset(e, t, r, i, s, o) {
    const a = t - e.timestampOffset;
    Math.abs(a) >= r && (this.log(`Updating ${i} SourceBuffer timestampOffset to ${t} (sn: ${s} cc: ${o})`), e.timestampOffset = t);
  }
  // This method must result in an updateend event; if remove is not called, onSBUpdateEnd must be called manually
  removeExecutor(e, t, r) {
    const {
      media: i,
      mediaSource: s
    } = this, o = this.tracks[e], a = o?.buffer;
    if (!i || !s || !a) {
      this.warn(`Attempting to remove from the ${e} SourceBuffer, but it does not exist`), this.shiftAndExecuteNext(e);
      return;
    }
    const l = He(i.duration) ? i.duration : 1 / 0, c = He(s.duration) ? s.duration : 1 / 0, u = Math.max(0, t), d = Math.min(r, l, c);
    d > u && (!o.ending || o.ended) ? (o.ended = !1, this.log(`Removing [${u},${d}] from the ${e} SourceBuffer`), a.remove(u, d)) : this.shiftAndExecuteNext(e);
  }
  // This method must result in an updateend event; if append is not called, onSBUpdateEnd must be called manually
  appendExecutor(e, t) {
    const r = this.tracks[t], i = r?.buffer;
    if (!i)
      throw new oYe(`Attempting to append to the ${t} SourceBuffer, but it does not exist`);
    r.ending = !1, r.ended = !1, i.appendBuffer(e);
  }
  blockUntilOpen(e) {
    if (this.isUpdating() || this.isQueued())
      this.blockBuffers(e).catch((t) => {
        this.warn(`SourceBuffer blocked callback ${t}`), this.stepOperationQueue(this.sourceBufferTypes);
      });
    else
      try {
        e();
      } catch (t) {
        this.warn(`Callback run without blocking ${this.operationQueue} ${t}`);
      }
  }
  isUpdating() {
    return this.sourceBuffers.some(([e, t]) => e && t.updating);
  }
  isQueued() {
    return this.sourceBuffers.some(([e]) => e && !!this.currentOp(e));
  }
  isPending(e) {
    return !!e && !e.buffer;
  }
  // Enqueues an operation to each SourceBuffer queue which, upon execution, resolves a promise. When all promises
  // resolve, the onUnblocked function is executed. Functions calling this method do not need to unblock the queue
  // upon completion, since we already do it here
  blockBuffers(e, t = this.sourceBufferTypes) {
    if (!t.length)
      return this.log("Blocking operation requested, but no SourceBuffers exist"), Promise.resolve().then(e);
    const {
      operationQueue: r
    } = this, i = t.map((o) => this.appendBlocker(o));
    return t.length > 1 && !!this.blockedAudioAppend && this.unblockAudio(), Promise.all(i).then((o) => {
      r === this.operationQueue && (e(), this.stepOperationQueue(this.sourceBufferTypes));
    });
  }
  stepOperationQueue(e) {
    e.forEach((t) => {
      var r;
      const i = (r = this.tracks[t]) == null ? void 0 : r.buffer;
      !i || i.updating || this.shiftAndExecuteNext(t);
    });
  }
  append(e, t, r) {
    this.operationQueue && this.operationQueue.append(e, t, r);
  }
  appendBlocker(e) {
    if (this.operationQueue)
      return this.operationQueue.appendBlocker(e);
  }
  currentOp(e) {
    return this.operationQueue ? this.operationQueue.current(e) : null;
  }
  executeNext(e) {
    e && this.operationQueue && this.operationQueue.executeNext(e);
  }
  shiftAndExecuteNext(e) {
    this.operationQueue && this.operationQueue.shiftAndExecuteNext(e);
  }
  get pendingTrackCount() {
    return Object.keys(this.tracks).reduce((e, t) => e + (this.isPending(this.tracks[t]) ? 1 : 0), 0);
  }
  get sourceBufferCount() {
    return this.sourceBuffers.reduce((e, [t]) => e + (t ? 1 : 0), 0);
  }
  get sourceBufferTypes() {
    return this.sourceBuffers.map(([e]) => e).filter((e) => !!e);
  }
  addBufferListener(e, t, r) {
    const i = this.tracks[e];
    if (!i)
      return;
    const s = i.buffer;
    if (!s)
      return;
    const o = r.bind(this, e);
    i.listeners.push({
      event: t,
      listener: o
    }), s.addEventListener(t, o);
  }
  removeBufferListeners(e) {
    const t = this.tracks[e];
    if (!t)
      return;
    const r = t.buffer;
    r && (t.listeners.forEach((i) => {
      r.removeEventListener(i.event, i.listener);
    }), t.listeners.length = 0);
  }
}
function TH(n) {
  const e = n.querySelectorAll("source");
  [].slice.call(e).forEach((t) => {
    n.removeChild(t);
  });
}
function lYe(n, e) {
  const t = self.document.createElement("source");
  t.type = "video/mp4", t.src = e, n.appendChild(t);
}
function I6(n) {
  return n === "audio" ? 1 : 0;
}
class O_ {
  constructor(e) {
    this.hls = void 0, this.autoLevelCapping = void 0, this.firstLevel = void 0, this.media = void 0, this.restrictedLevels = void 0, this.timer = void 0, this.clientRect = void 0, this.streamController = void 0, this.hls = e, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.firstLevel = -1, this.media = null, this.restrictedLevels = [], this.timer = void 0, this.clientRect = null, this.registerListeners();
  }
  setStreamController(e) {
    this.streamController = e;
  }
  destroy() {
    this.hls && this.unregisterListener(), this.timer && this.stopCapping(), this.media = null, this.clientRect = null, this.hls = this.streamController = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(N.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), e.on(N.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(N.MANIFEST_PARSED, this.onManifestParsed, this), e.on(N.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(N.BUFFER_CODECS, this.onBufferCodecs, this), e.on(N.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  unregisterListener() {
    const {
      hls: e
    } = this;
    e.off(N.FPS_DROP_LEVEL_CAPPING, this.onFpsDropLevelCapping, this), e.off(N.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(N.MANIFEST_PARSED, this.onManifestParsed, this), e.off(N.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(N.BUFFER_CODECS, this.onBufferCodecs, this), e.off(N.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  onFpsDropLevelCapping(e, t) {
    const r = this.hls.levels[t.droppedLevel];
    this.isLevelAllowed(r) && this.restrictedLevels.push({
      bitrate: r.bitrate,
      height: r.height,
      width: r.width
    });
  }
  onMediaAttaching(e, t) {
    this.media = t.media instanceof HTMLVideoElement ? t.media : null, this.clientRect = null, this.timer && this.hls.levels.length && this.detectPlayerSize();
  }
  onManifestParsed(e, t) {
    const r = this.hls;
    this.restrictedLevels = [], this.firstLevel = t.firstLevel, r.config.capLevelToPlayerSize && t.video && this.startCapping();
  }
  onLevelsUpdated(e, t) {
    this.timer && He(this.autoLevelCapping) && this.detectPlayerSize();
  }
  // Only activate capping when playing a video stream; otherwise, multi-bitrate audio-only streams will be restricted
  // to the first level
  onBufferCodecs(e, t) {
    this.hls.config.capLevelToPlayerSize && t.video && this.startCapping();
  }
  onMediaDetaching() {
    this.stopCapping(), this.media = null;
  }
  detectPlayerSize() {
    if (this.media) {
      if (this.mediaHeight <= 0 || this.mediaWidth <= 0) {
        this.clientRect = null;
        return;
      }
      const e = this.hls.levels;
      if (e.length) {
        const t = this.hls, r = this.getMaxLevel(e.length - 1);
        r !== this.autoLevelCapping && t.logger.log(`Setting autoLevelCapping to ${r}: ${e[r].height}p@${e[r].bitrate} for media ${this.mediaWidth}x${this.mediaHeight}`), t.autoLevelCapping = r, t.autoLevelEnabled && t.autoLevelCapping > this.autoLevelCapping && this.streamController && this.streamController.nextLevelSwitch(), this.autoLevelCapping = t.autoLevelCapping;
      }
    }
  }
  /*
   * returns level should be the one with the dimensions equal or greater than the media (player) dimensions (so the video will be downscaled)
   */
  getMaxLevel(e) {
    const t = this.hls.levels;
    if (!t.length)
      return -1;
    const r = t.filter((i, s) => this.isLevelAllowed(i) && s <= e);
    return this.clientRect = null, O_.getMaxLevelByMediaSize(r, this.mediaWidth, this.mediaHeight);
  }
  startCapping() {
    this.timer || (this.autoLevelCapping = Number.POSITIVE_INFINITY, self.clearInterval(this.timer), this.timer = self.setInterval(this.detectPlayerSize.bind(this), 1e3), this.detectPlayerSize());
  }
  stopCapping() {
    this.restrictedLevels = [], this.firstLevel = -1, this.autoLevelCapping = Number.POSITIVE_INFINITY, this.timer && (self.clearInterval(this.timer), this.timer = void 0);
  }
  getDimensions() {
    if (this.clientRect)
      return this.clientRect;
    const e = this.media, t = {
      width: 0,
      height: 0
    };
    if (e) {
      const r = e.getBoundingClientRect();
      t.width = r.width, t.height = r.height, !t.width && !t.height && (t.width = r.right - r.left || e.width || 0, t.height = r.bottom - r.top || e.height || 0);
    }
    return this.clientRect = t, t;
  }
  get mediaWidth() {
    return this.getDimensions().width * this.contentScaleFactor;
  }
  get mediaHeight() {
    return this.getDimensions().height * this.contentScaleFactor;
  }
  get contentScaleFactor() {
    let e = 1;
    if (!this.hls.config.ignoreDevicePixelRatio)
      try {
        e = self.devicePixelRatio;
      } catch {
      }
    return Math.min(e, this.hls.config.maxDevicePixelRatio);
  }
  isLevelAllowed(e) {
    return !this.restrictedLevels.some((r) => e.bitrate === r.bitrate && e.width === r.width && e.height === r.height);
  }
  static getMaxLevelByMediaSize(e, t, r) {
    if (!(e != null && e.length))
      return -1;
    const i = (a, l) => l ? a.width !== l.width || a.height !== l.height : !0;
    let s = e.length - 1;
    const o = Math.max(t, r);
    for (let a = 0; a < e.length; a += 1) {
      const l = e[a];
      if ((l.width >= o || l.height >= o) && i(l, e[a + 1])) {
        s = a;
        break;
      }
    }
    return s;
  }
}
const cYe = {
  /**
   * text file, such as a manifest or playlist
   */
  MANIFEST: "m",
  /**
   * audio only
   */
  AUDIO: "a",
  /**
   * video only
   */
  VIDEO: "v",
  /**
   * muxed audio and video
   */
  MUXED: "av",
  /**
   * init segment
   */
  INIT: "i",
  /**
   * caption or subtitle
   */
  CAPTION: "c",
  /**
   * ISOBMFF timed text track
   */
  TIMED_TEXT: "tt",
  /**
   * cryptographic key, license or certificate.
   */
  KEY: "k",
  /**
   * other
   */
  OTHER: "o"
}, _i = cYe, uYe = {
  /**
   * HTTP Live Streaming (HLS)
   */
  HLS: "h"
}, dYe = uYe;
class ya {
  constructor(e, t) {
    Array.isArray(e) && (e = e.map((r) => r instanceof ya ? r : new ya(r))), this.value = e, this.params = t;
  }
}
const fYe = "Dict";
function hYe(n) {
  return Array.isArray(n) ? JSON.stringify(n) : n instanceof Map ? "Map{}" : n instanceof Set ? "Set{}" : typeof n == "object" ? JSON.stringify(n) : String(n);
}
function pYe(n, e, t, r) {
  return new Error(`failed to ${n} "${hYe(e)}" as ${t}`, {
    cause: r
  });
}
function ba(n, e, t) {
  return pYe("serialize", n, e, t);
}
class Nne {
  constructor(e) {
    this.description = e;
  }
}
const AH = "Bare Item", mYe = "Boolean";
function gYe(n) {
  if (typeof n != "boolean")
    throw ba(n, mYe);
  return n ? "?1" : "?0";
}
function vYe(n) {
  return btoa(String.fromCharCode(...n));
}
const yYe = "Byte Sequence";
function bYe(n) {
  if (ArrayBuffer.isView(n) === !1)
    throw ba(n, yYe);
  return `:${vYe(n)}:`;
}
const wYe = "Integer";
function xYe(n) {
  return n < -999999999999999 || 999999999999999 < n;
}
function Lne(n) {
  if (xYe(n))
    throw ba(n, wYe);
  return n.toString();
}
function EYe(n) {
  return `@${Lne(n.getTime() / 1e3)}`;
}
function $ne(n, e) {
  if (n < 0)
    return -$ne(-n, e);
  const t = Math.pow(10, e);
  if (Math.abs(n * t % 1 - 0.5) < Number.EPSILON) {
    const i = Math.floor(n * t);
    return (i % 2 === 0 ? i : i + 1) / t;
  } else
    return Math.round(n * t) / t;
}
const SYe = "Decimal";
function CYe(n) {
  const e = $ne(n, 3);
  if (Math.floor(Math.abs(e)).toString().length > 12)
    throw ba(n, SYe);
  const t = e.toString();
  return t.includes(".") ? t : `${t}.0`;
}
const TYe = "String", AYe = /[\x00-\x1f\x7f]+/;
function MYe(n) {
  if (AYe.test(n))
    throw ba(n, TYe);
  return `"${n.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
}
function kYe(n) {
  return n.description || n.toString().slice(7, -1);
}
const _Ye = "Token";
function MH(n) {
  const e = kYe(n);
  if (/^([a-zA-Z*])([!#$%&'*+\-.^_`|~\w:/]*)$/.test(e) === !1)
    throw ba(e, _Ye);
  return e;
}
function k7(n) {
  switch (typeof n) {
    case "number":
      if (!He(n))
        throw ba(n, AH);
      return Number.isInteger(n) ? Lne(n) : CYe(n);
    case "string":
      return MYe(n);
    case "symbol":
      return MH(n);
    case "boolean":
      return gYe(n);
    case "object":
      if (n instanceof Date)
        return EYe(n);
      if (n instanceof Uint8Array)
        return bYe(n);
      if (n instanceof Nne)
        return MH(n);
    default:
      throw ba(n, AH);
  }
}
const OYe = "Key";
function _7(n) {
  if (/^[a-z*][a-z0-9\-_.*]*$/.test(n) === !1)
    throw ba(n, OYe);
  return n;
}
function I_(n) {
  return n == null ? "" : Object.entries(n).map(([e, t]) => t === !0 ? `;${_7(e)}` : `;${_7(e)}=${k7(t)}`).join("");
}
function Fne(n) {
  return n instanceof ya ? `${k7(n.value)}${I_(n.params)}` : k7(n);
}
function IYe(n) {
  return `(${n.value.map(Fne).join(" ")})${I_(n.params)}`;
}
function RYe(n, e = {
  whitespace: !0
}) {
  if (typeof n != "object" || n == null)
    throw ba(n, fYe);
  const t = n instanceof Map ? n.entries() : Object.entries(n), r = e?.whitespace ? " " : "";
  return Array.from(t).map(([i, s]) => {
    s instanceof ya || (s = new ya(s));
    let o = _7(i);
    return s.value === !0 ? o += I_(s.params) : (o += "=", Array.isArray(s.value) ? o += IYe(s) : o += Fne(s)), o;
  }).join(`,${r}`);
}
function Bne(n, e) {
  return RYe(n, e);
}
const Bo = "CMCD-Object", Kn = "CMCD-Request", jc = "CMCD-Session", _l = "CMCD-Status", PYe = {
  // Object
  br: Bo,
  ab: Bo,
  d: Bo,
  ot: Bo,
  tb: Bo,
  tpb: Bo,
  lb: Bo,
  tab: Bo,
  lab: Bo,
  url: Bo,
  // Request
  pb: Kn,
  bl: Kn,
  tbl: Kn,
  dl: Kn,
  ltc: Kn,
  mtp: Kn,
  nor: Kn,
  nrr: Kn,
  rc: Kn,
  sn: Kn,
  sta: Kn,
  su: Kn,
  ttfb: Kn,
  ttfbb: Kn,
  ttlb: Kn,
  cmsdd: Kn,
  cmsds: Kn,
  smrt: Kn,
  df: Kn,
  cs: Kn,
  // TODO: Which header to put the `ts` field is not defined yet.
  ts: Kn,
  // Session
  cid: jc,
  pr: jc,
  sf: jc,
  sid: jc,
  st: jc,
  v: jc,
  msd: jc,
  // Status
  bs: _l,
  bsd: _l,
  cdn: _l,
  rtp: _l,
  bg: _l,
  pt: _l,
  ec: _l,
  e: _l
}, DYe = {
  /**
   * keys whose values vary with each request.
   */
  REQUEST: Kn
};
function NYe(n) {
  return Object.keys(n).reduce((e, t) => {
    var r;
    return (r = n[t]) === null || r === void 0 || r.forEach((i) => e[i] = t), e;
  }, {});
}
function LYe(n, e) {
  const t = {};
  if (!n)
    return t;
  const r = Object.keys(n), i = e ? NYe(e) : {};
  return r.reduce((s, o) => {
    var a;
    const l = PYe[o] || i[o] || DYe.REQUEST, c = (a = s[l]) !== null && a !== void 0 ? a : s[l] = {};
    return c[o] = n[o], s;
  }, t);
}
function $Ye(n) {
  return ["ot", "sf", "st", "e", "sta"].includes(n);
}
function FYe(n) {
  return typeof n == "number" ? He(n) : n != null && n !== "" && n !== !1;
}
const zne = "event";
function BYe(n, e) {
  const t = new URL(n), r = new URL(e);
  if (t.origin !== r.origin)
    return n;
  const i = t.pathname.split("/").slice(1), s = r.pathname.split("/").slice(1, -1);
  for (; i[0] === s[0]; )
    i.shift(), s.shift();
  for (; s.length; )
    s.shift(), i.unshift("..");
  return i.join("/") + t.search + t.hash;
}
const Kv = (n) => Math.round(n), O7 = (n, e) => Array.isArray(n) ? n.map((t) => O7(t, e)) : n instanceof ya && typeof n.value == "string" ? new ya(O7(n.value, e), n.params) : (e.baseUrl && (n = BYe(n, e.baseUrl)), e.version === 1 ? encodeURIComponent(n) : n), Fg = (n) => Kv(n / 100) * 100, zYe = (n, e) => {
  let t = n;
  return e.version >= 2 && (n instanceof ya && typeof n.value == "string" ? t = new ya([n]) : typeof n == "string" && (t = [n])), O7(t, e);
}, HYe = {
  /**
   * Bitrate (kbps) rounded integer
   */
  br: Kv,
  /**
   * Duration (milliseconds) rounded integer
   */
  d: Kv,
  /**
   * Buffer Length (milliseconds) rounded nearest 100ms
   */
  bl: Fg,
  /**
   * Deadline (milliseconds) rounded nearest 100ms
   */
  dl: Fg,
  /**
   * Measured Throughput (kbps) rounded nearest 100kbps
   */
  mtp: Fg,
  /**
   * Next Object Request URL encoded
   */
  nor: zYe,
  /**
   * Requested maximum throughput (kbps) rounded nearest 100kbps
   */
  rtp: Fg,
  /**
   * Top Bitrate (kbps) rounded integer
   */
  tb: Kv
}, Hne = "request", Une = "response", R_ = ["ab", "bg", "bl", "br", "bs", "bsd", "cdn", "cid", "cs", "df", "ec", "lab", "lb", "ltc", "msd", "mtp", "pb", "pr", "pt", "sf", "sid", "sn", "st", "sta", "tab", "tb", "tbl", "tpb", "ts", "v"], UYe = ["e"], VYe = /^[a-zA-Z0-9-.]+-[a-zA-Z0-9-.]+$/;
function G3(n) {
  return VYe.test(n);
}
function jYe(n) {
  return R_.includes(n) || UYe.includes(n) || G3(n);
}
const Vne = ["d", "dl", "nor", "ot", "rtp", "su"];
function WYe(n) {
  return R_.includes(n) || Vne.includes(n) || G3(n);
}
const GYe = ["cmsdd", "cmsds", "rc", "smrt", "ttfb", "ttfbb", "ttlb", "url"];
function KYe(n) {
  return R_.includes(n) || Vne.includes(n) || GYe.includes(n) || G3(n);
}
const qYe = ["bl", "br", "bs", "cid", "d", "dl", "mtp", "nor", "nrr", "ot", "pr", "rtp", "sf", "sid", "st", "su", "tb", "v"];
function YYe(n) {
  return qYe.includes(n) || G3(n);
}
const XYe = {
  [Une]: KYe,
  [zne]: jYe,
  [Hne]: WYe
};
function jne(n, e = {}) {
  const t = {};
  if (n == null || typeof n != "object")
    return t;
  const r = e.version || n.v || 1, i = e.reportingMode || Hne, s = r === 1 ? YYe : XYe[i];
  let o = Object.keys(n).filter(s);
  const a = e.filter;
  typeof a == "function" && (o = o.filter(a));
  const l = i === Une || i === zne;
  l && !o.includes("ts") && o.push("ts"), r > 1 && !o.includes("v") && o.push("v");
  const c = mn({}, HYe, e.formatters), u = {
    version: r,
    reportingMode: i,
    baseUrl: e.baseUrl
  };
  return o.sort().forEach((d) => {
    let f = n[d];
    const h = c[d];
    if (typeof h == "function" && (f = h(f, u)), d === "v") {
      if (r === 1)
        return;
      f = r;
    }
    d == "pr" && f === 1 || (l && d === "ts" && !He(f) && (f = Date.now()), FYe(f) && ($Ye(d) && typeof f == "string" && (f = new Nne(f)), t[d] = f));
  }), t;
}
function ZYe(n, e = {}) {
  const t = {};
  if (!n)
    return t;
  const r = jne(n, e), i = LYe(r, e?.customHeaderMap);
  return Object.entries(i).reduce((s, [o, a]) => {
    const l = Bne(a, {
      whitespace: !1
    });
    return l && (s[o] = l), s;
  }, t);
}
function QYe(n, e, t) {
  return mn(n, ZYe(e, t));
}
const JYe = "CMCD";
function eXe(n, e = {}) {
  return n ? Bne(jne(n, e), {
    whitespace: !1
  }) : "";
}
function tXe(n, e = {}) {
  if (!n)
    return "";
  const t = eXe(n, e);
  return encodeURIComponent(t);
}
function nXe(n, e = {}) {
  if (!n)
    return "";
  const t = tXe(n, e);
  return `${JYe}=${t}`;
}
const kH = /CMCD=[^&#]+/;
function rXe(n, e, t) {
  const r = nXe(e, t);
  if (!r)
    return n;
  if (kH.test(n))
    return n.replace(kH, r);
  const i = n.includes("?") ? "&" : "?";
  return `${n}${i}${r}`;
}
class iXe {
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = void 0, this.sid = void 0, this.cid = void 0, this.useHeaders = !1, this.includeKeys = void 0, this.initialized = !1, this.starved = !1, this.buffering = !0, this.audioBuffer = void 0, this.videoBuffer = void 0, this.onWaiting = () => {
      this.initialized && (this.starved = !0), this.buffering = !0;
    }, this.onPlaying = () => {
      this.initialized || (this.initialized = !0), this.buffering = !1;
    }, this.applyPlaylistData = (i) => {
      try {
        this.apply(i, {
          ot: _i.MANIFEST,
          su: !this.initialized
        });
      } catch (s) {
        this.hls.logger.warn("Could not generate manifest CMCD data.", s);
      }
    }, this.applyFragmentData = (i) => {
      try {
        const {
          frag: s,
          part: o
        } = i, a = this.hls.levels[s.level], l = this.getObjectType(s), c = {
          d: (o || s).duration * 1e3,
          ot: l
        };
        (l === _i.VIDEO || l === _i.AUDIO || l == _i.MUXED) && (c.br = a.bitrate / 1e3, c.tb = this.getTopBandwidth(l) / 1e3, c.bl = this.getBufferLength(l));
        const u = o ? this.getNextPart(o) : this.getNextFrag(s);
        u != null && u.url && u.url !== s.url && (c.nor = u.url), this.apply(i, c);
      } catch (s) {
        this.hls.logger.warn("Could not generate segment CMCD data.", s);
      }
    }, this.hls = e;
    const t = this.config = e.config, {
      cmcd: r
    } = t;
    r != null && (t.pLoader = this.createPlaylistLoader(), t.fLoader = this.createFragmentLoader(), this.sid = r.sessionId || e.sessionId, this.cid = r.contentId, this.useHeaders = r.useHeaders === !0, this.includeKeys = r.includeKeys, this.registerListeners());
  }
  registerListeners() {
    const e = this.hls;
    e.on(N.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(N.MEDIA_DETACHED, this.onMediaDetached, this), e.on(N.BUFFER_CREATED, this.onBufferCreated, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e.off(N.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(N.MEDIA_DETACHED, this.onMediaDetached, this), e.off(N.BUFFER_CREATED, this.onBufferCreated, this);
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetached(), this.hls = this.config = this.audioBuffer = this.videoBuffer = null, this.onWaiting = this.onPlaying = this.media = null;
  }
  onMediaAttached(e, t) {
    this.media = t.media, this.media.addEventListener("waiting", this.onWaiting), this.media.addEventListener("playing", this.onPlaying);
  }
  onMediaDetached() {
    this.media && (this.media.removeEventListener("waiting", this.onWaiting), this.media.removeEventListener("playing", this.onPlaying), this.media = null);
  }
  onBufferCreated(e, t) {
    var r, i;
    this.audioBuffer = (r = t.tracks.audio) == null ? void 0 : r.buffer, this.videoBuffer = (i = t.tracks.video) == null ? void 0 : i.buffer;
  }
  /**
   * Create baseline CMCD data
   */
  createData() {
    var e;
    return {
      v: 1,
      sf: dYe.HLS,
      sid: this.sid,
      cid: this.cid,
      pr: (e = this.media) == null ? void 0 : e.playbackRate,
      mtp: this.hls.bandwidthEstimate / 1e3
    };
  }
  /**
   * Apply CMCD data to a request.
   */
  apply(e, t = {}) {
    mn(t, this.createData());
    const r = t.ot === _i.INIT || t.ot === _i.VIDEO || t.ot === _i.MUXED;
    this.starved && r && (t.bs = !0, t.su = !0, this.starved = !1), t.su == null && (t.su = this.buffering);
    const {
      includeKeys: i
    } = this;
    i && (t = Object.keys(t).reduce((o, a) => (i.includes(a) && (o[a] = t[a]), o), {}));
    const s = {
      baseUrl: e.url
    };
    this.useHeaders ? (e.headers || (e.headers = {}), QYe(e.headers, t, s)) : e.url = rXe(e.url, t, s);
  }
  getNextFrag(e) {
    var t;
    const r = (t = this.hls.levels[e.level]) == null ? void 0 : t.details;
    if (r) {
      const i = e.sn - r.startSN;
      return r.fragments[i + 1];
    }
  }
  getNextPart(e) {
    var t;
    const {
      index: r,
      fragment: i
    } = e, s = (t = this.hls.levels[i.level]) == null || (t = t.details) == null ? void 0 : t.partList;
    if (s) {
      const {
        sn: o
      } = i;
      for (let a = s.length - 1; a >= 0; a--) {
        const l = s[a];
        if (l.index === r && l.fragment.sn === o)
          return s[a + 1];
      }
    }
  }
  /**
   * The CMCD object type.
   */
  getObjectType(e) {
    const {
      type: t
    } = e;
    if (t === "subtitle")
      return _i.TIMED_TEXT;
    if (e.sn === "initSegment")
      return _i.INIT;
    if (t === "audio")
      return _i.AUDIO;
    if (t === "main")
      return this.hls.audioTracks.length ? _i.VIDEO : _i.MUXED;
  }
  /**
   * Get the highest bitrate.
   */
  getTopBandwidth(e) {
    let t = 0, r;
    const i = this.hls;
    if (e === _i.AUDIO)
      r = i.audioTracks;
    else {
      const s = i.maxAutoLevel, o = s > -1 ? s + 1 : i.levels.length;
      r = i.levels.slice(0, o);
    }
    return r.forEach((s) => {
      s.bitrate > t && (t = s.bitrate);
    }), t > 0 ? t : NaN;
  }
  /**
   * Get the buffer length for a media type in milliseconds
   */
  getBufferLength(e) {
    const t = this.media, r = e === _i.AUDIO ? this.audioBuffer : this.videoBuffer;
    return !r || !t ? NaN : St.bufferInfo(r, t.currentTime, this.config.maxBufferHole).len * 1e3;
  }
  /**
   * Create a playlist loader
   */
  createPlaylistLoader() {
    const {
      pLoader: e
    } = this.config, t = this.applyPlaylistData, r = e || this.config.loader;
    return class {
      constructor(s) {
        this.loader = void 0, this.loader = new r(s);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(s, o, a) {
        t(s), this.loader.load(s, o, a);
      }
    };
  }
  /**
   * Create a playlist loader
   */
  createFragmentLoader() {
    const {
      fLoader: e
    } = this.config, t = this.applyFragmentData, r = e || this.config.loader;
    return class {
      constructor(s) {
        this.loader = void 0, this.loader = new r(s);
      }
      get stats() {
        return this.loader.stats;
      }
      get context() {
        return this.loader.context;
      }
      destroy() {
        this.loader.destroy();
      }
      abort() {
        this.loader.abort();
      }
      load(s, o, a) {
        t(s), this.loader.load(s, o, a);
      }
    };
  }
}
const sXe = 3e5;
class oXe extends Ys {
  constructor(e) {
    super("content-steering", e.logger), this.hls = void 0, this.loader = null, this.uri = null, this.pathwayId = ".", this._pathwayPriority = null, this.timeToLoad = 300, this.reloadTimer = -1, this.updated = 0, this.started = !1, this.enabled = !0, this.levels = null, this.audioTracks = null, this.subtitleTracks = null, this.penalizedPathways = {}, this.hls = e, this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e.on(N.MANIFEST_LOADING, this.onManifestLoading, this), e.on(N.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(N.MANIFEST_PARSED, this.onManifestParsed, this), e.on(N.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(N.MANIFEST_LOADING, this.onManifestLoading, this), e.off(N.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(N.MANIFEST_PARSED, this.onManifestParsed, this), e.off(N.ERROR, this.onError, this));
  }
  pathways() {
    return (this.levels || []).reduce((e, t) => (e.indexOf(t.pathwayId) === -1 && e.push(t.pathwayId), e), []);
  }
  get pathwayPriority() {
    return this._pathwayPriority;
  }
  set pathwayPriority(e) {
    this.updatePathwayPriority(e);
  }
  startLoad() {
    if (this.started = !0, this.clearTimeout(), this.enabled && this.uri) {
      if (this.updated) {
        const e = this.timeToLoad * 1e3 - (performance.now() - this.updated);
        if (e > 0) {
          this.scheduleRefresh(this.uri, e);
          return;
        }
      }
      this.loadSteeringManifest(this.uri);
    }
  }
  stopLoad() {
    this.started = !1, this.loader && (this.loader.destroy(), this.loader = null), this.clearTimeout();
  }
  clearTimeout() {
    this.reloadTimer !== -1 && (self.clearTimeout(this.reloadTimer), this.reloadTimer = -1);
  }
  destroy() {
    this.unregisterListeners(), this.stopLoad(), this.hls = null, this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  removeLevel(e) {
    const t = this.levels;
    t && (this.levels = t.filter((r) => r !== e));
  }
  onManifestLoading() {
    this.stopLoad(), this.enabled = !0, this.timeToLoad = 300, this.updated = 0, this.uri = null, this.pathwayId = ".", this.levels = this.audioTracks = this.subtitleTracks = null;
  }
  onManifestLoaded(e, t) {
    const {
      contentSteering: r
    } = t;
    r !== null && (this.pathwayId = r.pathwayId, this.uri = r.uri, this.started && this.startLoad());
  }
  onManifestParsed(e, t) {
    this.audioTracks = t.audioTracks, this.subtitleTracks = t.subtitleTracks;
  }
  onError(e, t) {
    const {
      errorAction: r
    } = t;
    if (r?.action === $r.SendAlternateToPenaltyBox && r.flags === rs.MoveAllAlternatesMatchingHost) {
      const i = this.levels;
      let s = this._pathwayPriority, o = this.pathwayId;
      if (t.context) {
        const {
          groupId: a,
          pathwayId: l,
          type: c
        } = t.context;
        a && i ? o = this.getPathwayForGroupId(a, c, o) : l && (o = l);
      }
      o in this.penalizedPathways || (this.penalizedPathways[o] = performance.now()), !s && i && (s = this.pathways()), s && s.length > 1 && (this.updatePathwayPriority(s), r.resolved = this.pathwayId !== o), t.details === ce.BUFFER_APPEND_ERROR && !t.fatal ? r.resolved = !0 : r.resolved || this.warn(`Could not resolve ${t.details} ("${t.error.message}") with content-steering for Pathway: ${o} levels: ${i && i.length} priorities: ${Sn(s)} penalized: ${Sn(this.penalizedPathways)}`);
    }
  }
  filterParsedLevels(e) {
    this.levels = e;
    let t = this.getLevelsForPathway(this.pathwayId);
    if (t.length === 0) {
      const r = e[0].pathwayId;
      this.log(`No levels found in Pathway ${this.pathwayId}. Setting initial Pathway to "${r}"`), t = this.getLevelsForPathway(r), this.pathwayId = r;
    }
    return t.length !== e.length && this.log(`Found ${t.length}/${e.length} levels in Pathway "${this.pathwayId}"`), t;
  }
  getLevelsForPathway(e) {
    return this.levels === null ? [] : this.levels.filter((t) => e === t.pathwayId);
  }
  updatePathwayPriority(e) {
    this._pathwayPriority = e;
    let t;
    const r = this.penalizedPathways, i = performance.now();
    Object.keys(r).forEach((s) => {
      i - r[s] > sXe && delete r[s];
    });
    for (let s = 0; s < e.length; s++) {
      const o = e[s];
      if (o in r)
        continue;
      if (o === this.pathwayId)
        return;
      const a = this.hls.nextLoadLevel, l = this.hls.levels[a];
      if (t = this.getLevelsForPathway(o), t.length > 0) {
        this.log(`Setting Pathway to "${o}"`), this.pathwayId = o, une(t), this.hls.trigger(N.LEVELS_UPDATED, {
          levels: t
        });
        const c = this.hls.levels[a];
        l && c && this.levels && (c.attrs["STABLE-VARIANT-ID"] !== l.attrs["STABLE-VARIANT-ID"] && c.bitrate !== l.bitrate && this.log(`Unstable Pathways change from bitrate ${l.bitrate} to ${c.bitrate}`), this.hls.nextLoadLevel = a);
        break;
      }
    }
  }
  getPathwayForGroupId(e, t, r) {
    const i = this.getLevelsForPathway(r).concat(this.levels || []);
    for (let s = 0; s < i.length; s++)
      if (t === Dt.AUDIO_TRACK && i[s].hasAudioGroup(e) || t === Dt.SUBTITLE_TRACK && i[s].hasSubtitleGroup(e))
        return i[s].pathwayId;
    return r;
  }
  clonePathways(e) {
    const t = this.levels;
    if (!t)
      return;
    const r = {}, i = {};
    e.forEach((s) => {
      const {
        ID: o,
        "BASE-ID": a,
        "URI-REPLACEMENT": l
      } = s;
      if (t.some((u) => u.pathwayId === o))
        return;
      const c = this.getLevelsForPathway(a).map((u) => {
        const d = new zn(u.attrs);
        d["PATHWAY-ID"] = o;
        const f = d.AUDIO && `${d.AUDIO}_clone_${o}`, h = d.SUBTITLES && `${d.SUBTITLES}_clone_${o}`;
        f && (r[d.AUDIO] = f, d.AUDIO = f), h && (i[d.SUBTITLES] = h, d.SUBTITLES = h);
        const m = Wne(u.uri, d["STABLE-VARIANT-ID"], "PER-VARIANT-URIS", l), g = new E0({
          attrs: d,
          audioCodec: u.audioCodec,
          bitrate: u.bitrate,
          height: u.height,
          name: u.name,
          url: m,
          videoCodec: u.videoCodec,
          width: u.width
        });
        if (u.audioGroups)
          for (let v = 1; v < u.audioGroups.length; v++)
            g.addGroupId("audio", `${u.audioGroups[v]}_clone_${o}`);
        if (u.subtitleGroups)
          for (let v = 1; v < u.subtitleGroups.length; v++)
            g.addGroupId("text", `${u.subtitleGroups[v]}_clone_${o}`);
        return g;
      });
      t.push(...c), _H(this.audioTracks, r, l, o), _H(this.subtitleTracks, i, l, o);
    });
  }
  loadSteeringManifest(e) {
    const t = this.hls.config, r = t.loader;
    this.loader && this.loader.destroy(), this.loader = new r(t);
    let i;
    try {
      i = new self.URL(e);
    } catch {
      this.enabled = !1, this.log(`Failed to parse Steering Manifest URI: ${e}`);
      return;
    }
    if (i.protocol !== "data:") {
      const u = (this.hls.bandwidthEstimate || t.abrEwmaDefaultEstimate) | 0;
      i.searchParams.set("_HLS_pathway", this.pathwayId), i.searchParams.set("_HLS_throughput", "" + u);
    }
    const s = {
      responseType: "json",
      url: i.href
    }, o = t.steeringManifestLoadPolicy.default, a = o.errorRetry || o.timeoutRetry || {}, l = {
      loadPolicy: o,
      timeout: o.maxLoadTimeMs,
      maxRetry: a.maxNumRetry || 0,
      retryDelay: a.retryDelayMs || 0,
      maxRetryDelay: a.maxRetryDelayMs || 0
    }, c = {
      onSuccess: (u, d, f, h) => {
        this.log(`Loaded steering manifest: "${i}"`);
        const m = u.data;
        if (m?.VERSION !== 1) {
          this.log(`Steering VERSION ${m.VERSION} not supported!`);
          return;
        }
        this.updated = performance.now(), this.timeToLoad = m.TTL;
        const {
          "RELOAD-URI": g,
          "PATHWAY-CLONES": v,
          "PATHWAY-PRIORITY": y
        } = m;
        if (g)
          try {
            this.uri = new self.URL(g, i).href;
          } catch {
            this.enabled = !1, this.log(`Failed to parse Steering Manifest RELOAD-URI: ${g}`);
            return;
          }
        this.scheduleRefresh(this.uri || f.url), v && this.clonePathways(v);
        const b = {
          steeringManifest: m,
          url: i.toString()
        };
        this.hls.trigger(N.STEERING_MANIFEST_LOADED, b), y && this.updatePathwayPriority(y);
      },
      onError: (u, d, f, h) => {
        if (this.log(`Error loading steering manifest: ${u.code} ${u.text} (${d.url})`), this.stopLoad(), u.code === 410) {
          this.enabled = !1, this.log(`Steering manifest ${d.url} no longer available`);
          return;
        }
        let m = this.timeToLoad * 1e3;
        if (u.code === 429) {
          const g = this.loader;
          if (typeof g?.getResponseHeader == "function") {
            const v = g.getResponseHeader("Retry-After");
            v && (m = parseFloat(v) * 1e3);
          }
          this.log(`Steering manifest ${d.url} rate limited`);
          return;
        }
        this.scheduleRefresh(this.uri || d.url, m);
      },
      onTimeout: (u, d, f) => {
        this.log(`Timeout loading steering manifest (${d.url})`), this.scheduleRefresh(this.uri || d.url);
      }
    };
    this.log(`Requesting steering manifest: ${i}`), this.loader.load(s, l, c);
  }
  scheduleRefresh(e, t = this.timeToLoad * 1e3) {
    this.clearTimeout(), this.reloadTimer = self.setTimeout(() => {
      var r;
      const i = (r = this.hls) == null ? void 0 : r.media;
      if (i && !i.ended) {
        this.loadSteeringManifest(e);
        return;
      }
      this.scheduleRefresh(e, this.timeToLoad * 1e3);
    }, t);
  }
}
function _H(n, e, t, r) {
  n && Object.keys(e).forEach((i) => {
    const s = n.filter((o) => o.groupId === i).map((o) => {
      const a = mn({}, o);
      return a.details = void 0, a.attrs = new zn(a.attrs), a.url = a.attrs.URI = Wne(o.url, o.attrs["STABLE-RENDITION-ID"], "PER-RENDITION-URIS", t), a.groupId = a.attrs["GROUP-ID"] = e[i], a.attrs["PATHWAY-ID"] = r, a;
    });
    n.push(...s);
  });
}
function Wne(n, e, t, r) {
  const {
    HOST: i,
    PARAMS: s,
    [t]: o
  } = r;
  let a;
  e && (a = o?.[e], a && (n = a));
  const l = new self.URL(n);
  return i && !a && (l.host = i), s && Object.keys(s).sort().forEach((c) => {
    c && l.searchParams.set(c, s[c]);
  }), l.href;
}
class hf extends Ys {
  constructor(e) {
    super("eme", e.logger), this.hls = void 0, this.config = void 0, this.media = null, this.mediaResolved = void 0, this.keyFormatPromise = null, this.keySystemAccessPromises = {}, this._requestLicenseFailureCount = 0, this.mediaKeySessions = [], this.keyIdToKeySessionPromise = {}, this.mediaKeys = null, this.setMediaKeysQueue = hf.CDMCleanupPromise ? [hf.CDMCleanupPromise] : [], this.bannedKeyIds = {}, this.onMediaEncrypted = (t) => {
      const {
        initDataType: r,
        initData: i
      } = t, s = `"${t.type}" event: init data type: "${r}"`;
      if (this.debug(s), i !== null) {
        if (!this.keyFormatPromise) {
          let o = Object.keys(this.keySystemAccessPromises);
          o.length || (o = _p(this.config));
          const a = o.map(S6).filter((l) => !!l);
          this.keyFormatPromise = this.getKeyFormatPromise(a);
        }
        this.keyFormatPromise.then((o) => {
          const a = jv(o);
          if (r !== "sinf" || a !== Vn.FAIRPLAY) {
            this.log(`Ignoring "${t.type}" event with init data type: "${r}" for selected key-system ${a}`);
            return;
          }
          let l;
          try {
            const h = yr(new Uint8Array(i)), m = w_(JSON.parse(h).sinf), g = Bte(m);
            if (!g)
              throw new Error("'schm' box missing or not cbcs/cenc with schi > tenc");
            l = new Uint8Array(g.subarray(8, 24));
          } catch (h) {
            this.warn(`${s} Failed to parse sinf: ${h}`);
            return;
          }
          const c = Br(l), {
            keyIdToKeySessionPromise: u,
            mediaKeySessions: d
          } = this;
          let f = u[c];
          for (let h = 0; h < d.length; h++) {
            const m = d[h], g = m.decryptdata;
            if (!g.keyId)
              continue;
            const v = Br(g.keyId);
            if (jy(l, g.keyId) || g.uri.replace(/-/g, "").indexOf(c) !== -1) {
              if (f = u[v], !f)
                continue;
              if (g.pssh)
                break;
              delete u[v], g.pssh = new Uint8Array(i), g.keyId = l, f = u[c] = f.then(() => this.generateRequestWithPreferredKeySession(m, r, i, "encrypted-event-key-match")), f.catch((y) => this.handleError(y));
              break;
            }
          }
          f || this.handleError(new Error(`Key ID ${c} not encountered in playlist. Key-system sessions ${d.length}.`));
        }).catch((o) => this.handleError(o));
      }
    }, this.onWaitingForKey = (t) => {
      this.log(`"${t.type}" event`);
    }, this.hls = e, this.config = e.config, this.registerListeners();
  }
  destroy() {
    this.onDestroying(), this.onMediaDetached();
    const e = this.config;
    e.requestMediaKeySystemAccessFunc = null, e.licenseXhrSetup = e.licenseResponseCallback = void 0, e.drmSystems = e.drmSystemOptions = {}, this.hls = this.config = this.keyIdToKeySessionPromise = null, this.onMediaEncrypted = this.onWaitingForKey = null;
  }
  registerListeners() {
    this.hls.on(N.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.on(N.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.on(N.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.on(N.MANIFEST_LOADED, this.onManifestLoaded, this), this.hls.on(N.DESTROYING, this.onDestroying, this);
  }
  unregisterListeners() {
    this.hls.off(N.MEDIA_ATTACHED, this.onMediaAttached, this), this.hls.off(N.MEDIA_DETACHED, this.onMediaDetached, this), this.hls.off(N.MANIFEST_LOADING, this.onManifestLoading, this), this.hls.off(N.MANIFEST_LOADED, this.onManifestLoaded, this), this.hls.off(N.DESTROYING, this.onDestroying, this);
  }
  getLicenseServerUrl(e) {
    const {
      drmSystems: t,
      widevineLicenseUrl: r
    } = this.config, i = t?.[e];
    if (i)
      return i.licenseUrl;
    if (e === Vn.WIDEVINE && r)
      return r;
  }
  getLicenseServerUrlOrThrow(e) {
    const t = this.getLicenseServerUrl(e);
    if (t === void 0)
      throw new Error(`no license server URL configured for key-system "${e}"`);
    return t;
  }
  getServerCertificateUrl(e) {
    const {
      drmSystems: t
    } = this.config, r = t?.[e];
    if (r)
      return r.serverCertificateUrl;
    this.log(`No Server Certificate in config.drmSystems["${e}"]`);
  }
  attemptKeySystemAccess(e) {
    const t = this.hls.levels, r = (o, a, l) => !!o && l.indexOf(o) === a, i = t.map((o) => o.audioCodec).filter(r), s = t.map((o) => o.videoCodec).filter(r);
    return i.length + s.length === 0 && s.push("avc1.42e01e"), new Promise((o, a) => {
      const l = (c) => {
        const u = c.shift();
        this.getMediaKeysPromise(u, i, s).then((d) => o({
          keySystem: u,
          mediaKeys: d
        })).catch((d) => {
          c.length ? l(c) : d instanceof ts ? a(d) : a(new ts({
            type: Je.KEY_SYSTEM_ERROR,
            details: ce.KEY_SYSTEM_NO_ACCESS,
            error: d,
            fatal: !0
          }, d.message));
        });
      };
      l(e);
    });
  }
  requestMediaKeySystemAccess(e, t) {
    const {
      requestMediaKeySystemAccessFunc: r
    } = this.config;
    if (typeof r != "function") {
      let i = `Configured requestMediaKeySystemAccess is not a function ${r}`;
      return nne === null && self.location.protocol === "http:" && (i = `navigator.requestMediaKeySystemAccess is not available over insecure protocol ${location.protocol}`), Promise.reject(new Error(i));
    }
    return r(e, t);
  }
  getMediaKeysPromise(e, t, r) {
    var i;
    const s = zKe(e, t, r, this.config.drmSystemOptions || {});
    let o = this.keySystemAccessPromises[e], a = (i = o) == null ? void 0 : i.keySystemAccess;
    if (!a) {
      this.log(`Requesting encrypted media "${e}" key-system access with config: ${Sn(s)}`), a = this.requestMediaKeySystemAccess(e, s);
      const l = o = this.keySystemAccessPromises[e] = {
        keySystemAccess: a
      };
      return a.catch((c) => {
        this.log(`Failed to obtain access to key-system "${e}": ${c}`);
      }), a.then((c) => {
        this.log(`Access for key-system "${c.keySystem}" obtained`);
        const u = this.fetchServerCertificate(e);
        this.log(`Create media-keys for "${e}"`);
        const d = l.mediaKeys = c.createMediaKeys().then((f) => (this.log(`Media-keys created for "${e}"`), l.hasMediaKeys = !0, u.then((h) => h ? this.setMediaKeysServerCertificate(f, e, h) : f)));
        return d.catch((f) => {
          this.error(`Failed to create media-keys for "${e}"}: ${f}`);
        }), d;
      });
    }
    return a.then(() => o.mediaKeys);
  }
  createMediaKeySessionContext({
    decryptdata: e,
    keySystem: t,
    mediaKeys: r
  }) {
    this.log(`Creating key-system session "${t}" keyId: ${Br(e.keyId || [])} keyUri: ${e.uri}`);
    const i = r.createSession(), s = {
      decryptdata: e,
      keySystem: t,
      mediaKeys: r,
      mediaKeysSession: i,
      keyStatus: "status-pending"
    };
    return this.mediaKeySessions.push(s), s;
  }
  renewKeySession(e) {
    const t = e.decryptdata;
    if (t.pssh) {
      const r = this.createMediaKeySessionContext(e), i = Bg(t), s = "cenc";
      this.keyIdToKeySessionPromise[i] = this.generateRequestWithPreferredKeySession(r, s, t.pssh.buffer, "expired");
    } else
      this.warn("Could not renew expired session. Missing pssh initData.");
    this.removeSession(e);
  }
  updateKeySession(e, t) {
    const r = e.mediaKeysSession;
    return this.log(`Updating key-session "${r.sessionId}" for keyId ${Br(e.decryptdata.keyId || [])}
      } (data length: ${t.byteLength})`), r.update(t);
  }
  getSelectedKeySystemFormats() {
    return Object.keys(this.keySystemAccessPromises).map((e) => ({
      keySystem: e,
      hasMediaKeys: this.keySystemAccessPromises[e].hasMediaKeys
    })).filter(({
      hasMediaKeys: e
    }) => !!e).map(({
      keySystem: e
    }) => S6(e)).filter((e) => !!e);
  }
  getKeySystemAccess(e) {
    return this.getKeySystemSelectionPromise(e).then(({
      keySystem: t,
      mediaKeys: r
    }) => this.attemptSetMediaKeys(t, r));
  }
  selectKeySystem(e) {
    return new Promise((t, r) => {
      this.getKeySystemSelectionPromise(e).then(({
        keySystem: i
      }) => {
        const s = S6(i);
        s ? t(s) : r(new Error(`Unable to find format for key-system "${i}"`));
      }).catch(r);
    });
  }
  selectKeySystemFormat(e) {
    const t = Object.keys(e.levelkeys || {});
    return this.keyFormatPromise || (this.log(`Selecting key-system from fragment (sn: ${e.sn} ${e.type}: ${e.level}) key formats ${t.join(", ")}`), this.keyFormatPromise = this.getKeyFormatPromise(t)), this.keyFormatPromise;
  }
  getKeyFormatPromise(e) {
    const t = _p(this.config), r = e.map(jv).filter((i) => !!i && t.indexOf(i) !== -1);
    return this.selectKeySystem(r);
  }
  getKeyStatus(e) {
    const {
      mediaKeySessions: t
    } = this;
    for (let r = 0; r < t.length; r++) {
      const i = aXe(e, t[r]);
      if (i)
        return i;
    }
  }
  loadKey(e) {
    const t = e.keyInfo.decryptdata, r = Bg(t), i = this.bannedKeyIds[r];
    if (i || this.getKeyStatus(t) === "internal-error") {
      const a = OH(i || "internal-error", t);
      return this.handleError(a, e.frag), Promise.reject(a);
    }
    const s = `(keyId: ${r} format: "${t.keyFormat}" method: ${t.method} uri: ${t.uri})`;
    this.log(`Starting session for key ${s}`);
    const o = this.keyIdToKeySessionPromise[r];
    if (!o) {
      const a = this.getKeySystemForKeyPromise(t).then(({
        keySystem: l,
        mediaKeys: c
      }) => (this.throwIfDestroyed(), this.log(`Handle encrypted media sn: ${e.frag.sn} ${e.frag.type}: ${e.frag.level} using key ${s}`), this.attemptSetMediaKeys(l, c).then(() => (this.throwIfDestroyed(), this.createMediaKeySessionContext({
        keySystem: l,
        mediaKeys: c,
        decryptdata: t
      }))))).then((l) => {
        const c = "cenc", u = t.pssh ? t.pssh.buffer : null;
        return this.generateRequestWithPreferredKeySession(l, c, u, "playlist-key");
      });
      return a.catch((l) => this.handleError(l, e.frag)), this.keyIdToKeySessionPromise[r] = a, a;
    }
    return o.catch((a) => {
      if (a instanceof ts) {
        const l = cn({}, a.data);
        this.getKeyStatus(t) === "internal-error" && (l.decryptdata = t);
        const c = new ts(l, a.message);
        this.handleError(c, e.frag);
      }
    }), o;
  }
  throwIfDestroyed(e = "Invalid state") {
    if (!this.hls)
      throw new Error("invalid state");
  }
  handleError(e, t) {
    if (this.hls)
      if (e instanceof ts) {
        t && (e.data.frag = t);
        const r = e.data.decryptdata;
        this.error(`${e.message}${r ? ` (${Br(r.keyId || [])})` : ""}`), this.hls.trigger(N.ERROR, e.data);
      } else
        this.error(e.message), this.hls.trigger(N.ERROR, {
          type: Je.KEY_SYSTEM_ERROR,
          details: ce.KEY_SYSTEM_NO_KEYS,
          error: e,
          fatal: !0
        });
  }
  getKeySystemForKeyPromise(e) {
    const t = Bg(e), r = this.keyIdToKeySessionPromise[t];
    if (!r) {
      const i = jv(e.keyFormat), s = i ? [i] : _p(this.config);
      return this.attemptKeySystemAccess(s);
    }
    return r;
  }
  getKeySystemSelectionPromise(e) {
    if (e.length || (e = _p(this.config)), e.length === 0)
      throw new ts({
        type: Je.KEY_SYSTEM_ERROR,
        details: ce.KEY_SYSTEM_NO_CONFIGURED_LICENSE,
        fatal: !0
      }, `Missing key-system license configuration options ${Sn({
        drmSystems: this.config.drmSystems
      })}`);
    return this.attemptKeySystemAccess(e);
  }
  attemptSetMediaKeys(e, t) {
    if (this.mediaResolved = void 0, this.mediaKeys === t)
      return Promise.resolve();
    const r = this.setMediaKeysQueue.slice();
    this.log(`Setting media-keys for "${e}"`);
    const i = Promise.all(r).then(() => this.media ? this.media.setMediaKeys(t) : new Promise((s, o) => {
      this.mediaResolved = () => {
        if (this.mediaResolved = void 0, !this.media)
          return o(new Error("Attempted to set mediaKeys without media element attached"));
        this.mediaKeys = t, this.media.setMediaKeys(t).then(s).catch(o);
      };
    }));
    return this.mediaKeys = t, this.setMediaKeysQueue.push(i), i.then(() => {
      this.log(`Media-keys set for "${e}"`), r.push(i), this.setMediaKeysQueue = this.setMediaKeysQueue.filter((s) => r.indexOf(s) === -1);
    });
  }
  generateRequestWithPreferredKeySession(e, t, r, i) {
    var s;
    const o = (s = this.config.drmSystems) == null || (s = s[e.keySystem]) == null ? void 0 : s.generateRequest;
    if (o)
      try {
        const m = o.call(this.hls, t, r, e);
        if (!m)
          throw new Error("Invalid response from configured generateRequest filter");
        t = m.initDataType, r = m.initData ? m.initData : null, e.decryptdata.pssh = r ? new Uint8Array(r) : null;
      } catch (m) {
        if (this.warn(m.message), this.hls && this.hls.config.debug)
          throw m;
      }
    if (r === null)
      return this.log(`Skipping key-session request for "${i}" (no initData)`), Promise.resolve(e);
    const a = Bg(e.decryptdata), l = e.decryptdata.uri;
    this.log(`Generating key-session request for "${i}" keyId: ${a} URI: ${l} (init data type: ${t} length: ${r.byteLength})`);
    const c = new E_(), u = e._onmessage = (m) => {
      const g = e.mediaKeysSession;
      if (!g) {
        c.emit("error", new Error("invalid state"));
        return;
      }
      const {
        messageType: v,
        message: y
      } = m;
      this.log(`"${v}" message event for session "${g.sessionId}" message size: ${y.byteLength}`), v === "license-request" || v === "license-renewal" ? this.renewLicense(e, y).catch((b) => {
        c.eventNames().length ? c.emit("error", b) : this.handleError(b);
      }) : v === "license-release" ? e.keySystem === Vn.FAIRPLAY && this.updateKeySession(e, E7("acknowledged")).then(() => this.removeSession(e)).catch((b) => this.handleError(b)) : this.warn(`unhandled media key message type "${v}"`);
    }, d = (m, g) => {
      g.keyStatus = m;
      let v;
      m.startsWith("usable") ? c.emit("resolved") : m === "internal-error" || m === "output-restricted" || m === "output-downscaled" ? v = OH(m, g.decryptdata) : m === "expired" ? v = new Error(`key expired (keyId: ${a})`) : m === "released" ? v = new Error("key released") : m === "status-pending" || this.warn(`unhandled key status change "${m}" (keyId: ${a})`), v && (c.eventNames().length ? c.emit("error", v) : this.handleError(v));
    }, f = e._onkeystatuseschange = (m) => {
      if (!e.mediaKeysSession) {
        c.emit("error", new Error("invalid state"));
        return;
      }
      const v = this.getKeyStatuses(e);
      if (!Object.keys(v).some((E) => v[E] !== "status-pending"))
        return;
      if (v[a] === "expired") {
        this.log(`Expired key ${Sn(v)} in key-session "${e.mediaKeysSession.sessionId}"`), this.renewKeySession(e);
        return;
      }
      let b = v[a];
      if (b)
        d(b, e);
      else {
        var x;
        e.keyStatusTimeouts || (e.keyStatusTimeouts = {}), (x = e.keyStatusTimeouts)[a] || (x[a] = self.setTimeout(() => {
          if (!e.mediaKeysSession || !this.mediaKeys)
            return;
          const w = this.getKeyStatus(e.decryptdata);
          if (w && w !== "status-pending")
            return this.log(`No status for keyId ${a} in key-session "${e.mediaKeysSession.sessionId}". Using session key-status ${w} from other session.`), d(w, e);
          this.log(`key status for ${a} in key-session "${e.mediaKeysSession.sessionId}" timed out after 1000ms`), b = "internal-error", d(b, e);
        }, 1e3)), this.log(`No status for keyId ${a} (${Sn(v)}).`);
      }
    };
    gi(e.mediaKeysSession, "message", u), gi(e.mediaKeysSession, "keystatuseschange", f);
    const h = new Promise((m, g) => {
      c.on("error", g), c.on("resolved", m);
    });
    return e.mediaKeysSession.generateRequest(t, r).then(() => {
      this.log(`Request generated for key-session "${e.mediaKeysSession.sessionId}" keyId: ${a} URI: ${l}`);
    }).catch((m) => {
      throw new ts({
        type: Je.KEY_SYSTEM_ERROR,
        details: ce.KEY_SYSTEM_NO_SESSION,
        error: m,
        decryptdata: e.decryptdata,
        fatal: !1
      }, `Error generating key-session request: ${m}`);
    }).then(() => h).catch((m) => (c.removeAllListeners(), this.removeSession(e).then(() => {
      throw m;
    }))).then(() => (c.removeAllListeners(), e));
  }
  getKeyStatuses(e) {
    const t = {};
    return e.mediaKeysSession.keyStatuses.forEach((r, i) => {
      if (typeof i == "string" && typeof r == "object") {
        const a = i;
        i = r, r = a;
      }
      const s = "buffer" in i ? new Uint8Array(i.buffer, i.byteOffset, i.byteLength) : new Uint8Array(i);
      if (e.keySystem === Vn.PLAYREADY && s.length === 16) {
        const a = Br(s);
        t[a] = r, ene(s);
      }
      const o = Br(s);
      r === "internal-error" && (this.bannedKeyIds[o] = r), this.log(`key status change "${r}" for keyStatuses keyId: ${o} key-session "${e.mediaKeysSession.sessionId}"`), t[o] = r;
    }), t;
  }
  fetchServerCertificate(e) {
    const t = this.config, r = t.loader, i = new r(t), s = this.getServerCertificateUrl(e);
    return s ? (this.log(`Fetching server certificate for "${e}"`), new Promise((o, a) => {
      const l = {
        responseType: "arraybuffer",
        url: s
      }, c = t.certLoadPolicy.default, u = {
        loadPolicy: c,
        timeout: c.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      }, d = {
        onSuccess: (f, h, m, g) => {
          o(f.data);
        },
        onError: (f, h, m, g) => {
          a(new ts({
            type: Je.KEY_SYSTEM_ERROR,
            details: ce.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: !0,
            networkDetails: m,
            response: cn({
              url: l.url,
              data: void 0
            }, f)
          }, `"${e}" certificate request failed (${s}). Status: ${f.code} (${f.text})`));
        },
        onTimeout: (f, h, m) => {
          a(new ts({
            type: Je.KEY_SYSTEM_ERROR,
            details: ce.KEY_SYSTEM_SERVER_CERTIFICATE_REQUEST_FAILED,
            fatal: !0,
            networkDetails: m,
            response: {
              url: l.url,
              data: void 0
            }
          }, `"${e}" certificate request timed out (${s})`));
        },
        onAbort: (f, h, m) => {
          a(new Error("aborted"));
        }
      };
      i.load(l, u, d);
    })) : Promise.resolve();
  }
  setMediaKeysServerCertificate(e, t, r) {
    return new Promise((i, s) => {
      e.setServerCertificate(r).then((o) => {
        this.log(`setServerCertificate ${o ? "success" : "not supported by CDM"} (${r.byteLength}) on "${t}"`), i(e);
      }).catch((o) => {
        s(new ts({
          type: Je.KEY_SYSTEM_ERROR,
          details: ce.KEY_SYSTEM_SERVER_CERTIFICATE_UPDATE_FAILED,
          error: o,
          fatal: !0
        }, o.message));
      });
    });
  }
  renewLicense(e, t) {
    return this.requestLicense(e, new Uint8Array(t)).then((r) => this.updateKeySession(e, new Uint8Array(r)).catch((i) => {
      throw new ts({
        type: Je.KEY_SYSTEM_ERROR,
        details: ce.KEY_SYSTEM_SESSION_UPDATE_FAILED,
        decryptdata: e.decryptdata,
        error: i,
        fatal: !1
      }, i.message);
    }));
  }
  unpackPlayReadyKeyMessage(e, t) {
    const r = String.fromCharCode.apply(null, new Uint16Array(t.buffer));
    if (!r.includes("PlayReadyKeyMessage"))
      return e.setRequestHeader("Content-Type", "text/xml; charset=utf-8"), t;
    const i = new DOMParser().parseFromString(r, "application/xml"), s = i.querySelectorAll("HttpHeader");
    if (s.length > 0) {
      let u;
      for (let d = 0, f = s.length; d < f; d++) {
        var o, a;
        u = s[d];
        const h = (o = u.querySelector("name")) == null ? void 0 : o.textContent, m = (a = u.querySelector("value")) == null ? void 0 : a.textContent;
        h && m && e.setRequestHeader(h, m);
      }
    }
    const l = i.querySelector("Challenge"), c = l?.textContent;
    if (!c)
      throw new Error("Cannot find <Challenge> in key message");
    return E7(atob(c));
  }
  setupLicenseXHR(e, t, r, i) {
    const s = this.config.licenseXhrSetup;
    return s ? Promise.resolve().then(() => {
      if (!r.decryptdata)
        throw new Error("Key removed");
      return s.call(this.hls, e, t, r, i);
    }).catch((o) => {
      if (!r.decryptdata)
        throw o;
      return e.open("POST", t, !0), s.call(this.hls, e, t, r, i);
    }).then((o) => (e.readyState || e.open("POST", t, !0), {
      xhr: e,
      licenseChallenge: o || i
    })) : (e.open("POST", t, !0), Promise.resolve({
      xhr: e,
      licenseChallenge: i
    }));
  }
  requestLicense(e, t) {
    const r = this.config.keyLoadPolicy.default;
    return new Promise((i, s) => {
      const o = this.getLicenseServerUrlOrThrow(e.keySystem);
      this.log(`Sending license request to URL: ${o}`);
      const a = new XMLHttpRequest();
      a.responseType = "arraybuffer", a.onreadystatechange = () => {
        if (!this.hls || !e.mediaKeysSession)
          return s(new Error("invalid state"));
        if (a.readyState === 4)
          if (a.status === 200) {
            this._requestLicenseFailureCount = 0;
            let l = a.response;
            this.log(`License received ${l instanceof ArrayBuffer ? l.byteLength : l}`);
            const c = this.config.licenseResponseCallback;
            if (c)
              try {
                l = c.call(this.hls, a, o, e);
              } catch (u) {
                this.error(u);
              }
            i(l);
          } else {
            const l = r.errorRetry, c = l ? l.maxNumRetry : 0;
            if (this._requestLicenseFailureCount++, this._requestLicenseFailureCount > c || a.status >= 400 && a.status < 500)
              s(new ts({
                type: Je.KEY_SYSTEM_ERROR,
                details: ce.KEY_SYSTEM_LICENSE_REQUEST_FAILED,
                decryptdata: e.decryptdata,
                fatal: !0,
                networkDetails: a,
                response: {
                  url: o,
                  data: void 0,
                  code: a.status,
                  text: a.statusText
                }
              }, `License Request XHR failed (${o}). Status: ${a.status} (${a.statusText})`));
            else {
              const u = c - this._requestLicenseFailureCount + 1;
              this.warn(`Retrying license request, ${u} attempts left`), this.requestLicense(e, t).then(i, s);
            }
          }
      }, e.licenseXhr && e.licenseXhr.readyState !== XMLHttpRequest.DONE && e.licenseXhr.abort(), e.licenseXhr = a, this.setupLicenseXHR(a, o, e, t).then(({
        xhr: l,
        licenseChallenge: c
      }) => {
        e.keySystem == Vn.PLAYREADY && (c = this.unpackPlayReadyKeyMessage(l, c)), l.send(c);
      }).catch(s);
    });
  }
  onDestroying() {
    this.unregisterListeners(), this._clear();
  }
  onMediaAttached(e, t) {
    if (!this.config.emeEnabled)
      return;
    const r = t.media;
    this.media = r, gi(r, "encrypted", this.onMediaEncrypted), gi(r, "waitingforkey", this.onWaitingForKey);
    const i = this.mediaResolved;
    i ? i() : this.mediaKeys = r.mediaKeys;
  }
  onMediaDetached() {
    const e = this.media;
    e && (Bi(e, "encrypted", this.onMediaEncrypted), Bi(e, "waitingforkey", this.onWaitingForKey), this.media = null, this.mediaKeys = null);
  }
  _clear() {
    var e;
    this._requestLicenseFailureCount = 0, this.keyIdToKeySessionPromise = {}, this.bannedKeyIds = {};
    const t = this.mediaResolved;
    if (t && t(), !this.mediaKeys && !this.mediaKeySessions.length)
      return;
    const r = this.media, i = this.mediaKeySessions.slice();
    this.mediaKeySessions = [], this.mediaKeys = null, ac.clearKeyUriToKeyIdMap();
    const s = i.length;
    hf.CDMCleanupPromise = Promise.all(i.map((o) => this.removeSession(o)).concat((r == null || (e = r.setMediaKeys(null)) == null ? void 0 : e.catch((o) => {
      this.log(`Could not clear media keys: ${o}`), this.hls && this.hls.trigger(N.ERROR, {
        type: Je.OTHER_ERROR,
        details: ce.KEY_SYSTEM_DESTROY_MEDIA_KEYS_ERROR,
        fatal: !1,
        error: new Error(`Could not clear media keys: ${o}`)
      });
    })) || Promise.resolve())).catch((o) => {
      this.log(`Could not close sessions and clear media keys: ${o}`), this.hls && this.hls.trigger(N.ERROR, {
        type: Je.OTHER_ERROR,
        details: ce.KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR,
        fatal: !1,
        error: new Error(`Could not close sessions and clear media keys: ${o}`)
      });
    }).then(() => {
      s && this.log("finished closing key sessions and clearing media keys");
    });
  }
  onManifestLoading() {
    this._clear();
  }
  onManifestLoaded(e, {
    sessionKeys: t
  }) {
    if (!(!t || !this.config.emeEnabled) && !this.keyFormatPromise) {
      const r = t.reduce((i, s) => (i.indexOf(s.keyFormat) === -1 && i.push(s.keyFormat), i), []);
      this.log(`Selecting key-system from session-keys ${r.join(", ")}`), this.keyFormatPromise = this.getKeyFormatPromise(r);
    }
  }
  removeSession(e) {
    const {
      mediaKeysSession: t,
      licenseXhr: r,
      decryptdata: i
    } = e;
    if (t) {
      this.log(`Remove licenses and keys and close session "${t.sessionId}" keyId: ${Br(i?.keyId || [])}`), e._onmessage && (t.removeEventListener("message", e._onmessage), e._onmessage = void 0), e._onkeystatuseschange && (t.removeEventListener("keystatuseschange", e._onkeystatuseschange), e._onkeystatuseschange = void 0), r && r.readyState !== XMLHttpRequest.DONE && r.abort(), e.mediaKeysSession = e.decryptdata = e.licenseXhr = void 0;
      const s = this.mediaKeySessions.indexOf(e);
      s > -1 && this.mediaKeySessions.splice(s, 1);
      const {
        keyStatusTimeouts: o
      } = e;
      o && Object.keys(o).forEach((c) => self.clearTimeout(o[c]));
      const {
        drmSystemOptions: a
      } = this.config;
      return (UKe(a) ? new Promise((c, u) => {
        self.setTimeout(() => u(new Error("MediaKeySession.remove() timeout")), 8e3), t.remove().then(c).catch(u);
      }) : Promise.resolve()).catch((c) => {
        this.log(`Could not remove session: ${c}`), this.hls && this.hls.trigger(N.ERROR, {
          type: Je.OTHER_ERROR,
          details: ce.KEY_SYSTEM_DESTROY_REMOVE_SESSION_ERROR,
          fatal: !1,
          error: new Error(`Could not remove session: ${c}`)
        });
      }).then(() => t.close()).catch((c) => {
        this.log(`Could not close session: ${c}`), this.hls && this.hls.trigger(N.ERROR, {
          type: Je.OTHER_ERROR,
          details: ce.KEY_SYSTEM_DESTROY_CLOSE_SESSION_ERROR,
          fatal: !1,
          error: new Error(`Could not close session: ${c}`)
        });
      });
    }
    return Promise.resolve();
  }
}
hf.CDMCleanupPromise = void 0;
function Bg(n) {
  if (!n)
    throw new Error("Could not read keyId of undefined decryptdata");
  if (n.keyId === null)
    throw new Error("keyId is null");
  return Br(n.keyId);
}
function aXe(n, e) {
  if (n.keyId && e.mediaKeysSession.keyStatuses.has(n.keyId))
    return e.mediaKeysSession.keyStatuses.get(n.keyId);
  if (n.matches(e.decryptdata))
    return e.keyStatus;
}
class ts extends Error {
  constructor(e, t) {
    super(t), this.data = void 0, e.error || (e.error = new Error(t)), this.data = e, e.err = e.error;
  }
}
function OH(n, e) {
  const t = n === "output-restricted", r = t ? ce.KEY_SYSTEM_STATUS_OUTPUT_RESTRICTED : ce.KEY_SYSTEM_STATUS_INTERNAL_ERROR;
  return new ts({
    type: Je.KEY_SYSTEM_ERROR,
    details: r,
    fatal: !1,
    decryptdata: e
  }, t ? "HDCP level output restricted" : `key status changed to "${n}"`);
}
class lXe {
  constructor(e) {
    this.hls = void 0, this.isVideoPlaybackQualityAvailable = !1, this.timer = void 0, this.media = null, this.lastTime = void 0, this.lastDroppedFrames = 0, this.lastDecodedFrames = 0, this.streamController = void 0, this.hls = e, this.registerListeners();
  }
  setStreamController(e) {
    this.streamController = e;
  }
  registerListeners() {
    this.hls.on(N.MEDIA_ATTACHING, this.onMediaAttaching, this), this.hls.on(N.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  unregisterListeners() {
    this.hls.off(N.MEDIA_ATTACHING, this.onMediaAttaching, this), this.hls.off(N.MEDIA_DETACHING, this.onMediaDetaching, this);
  }
  destroy() {
    this.timer && clearInterval(this.timer), this.unregisterListeners(), this.isVideoPlaybackQualityAvailable = !1, this.media = null;
  }
  onMediaAttaching(e, t) {
    const r = this.hls.config;
    if (r.capLevelOnFPSDrop) {
      const i = t.media instanceof self.HTMLVideoElement ? t.media : null;
      this.media = i, i && typeof i.getVideoPlaybackQuality == "function" && (this.isVideoPlaybackQualityAvailable = !0), self.clearInterval(this.timer), this.timer = self.setInterval(this.checkFPSInterval.bind(this), r.fpsDroppedMonitoringPeriod);
    }
  }
  onMediaDetaching() {
    this.media = null;
  }
  checkFPS(e, t, r) {
    const i = performance.now();
    if (t) {
      if (this.lastTime) {
        const s = i - this.lastTime, o = r - this.lastDroppedFrames, a = t - this.lastDecodedFrames, l = 1e3 * o / s, c = this.hls;
        if (c.trigger(N.FPS_DROP, {
          currentDropped: o,
          currentDecoded: a,
          totalDroppedFrames: r
        }), l > 0 && o > c.config.fpsDroppedMonitoringThreshold * a) {
          let u = c.currentLevel;
          c.logger.warn("drop FPS ratio greater than max allowed value for currentLevel: " + u), u > 0 && (c.autoLevelCapping === -1 || c.autoLevelCapping >= u) && (u = u - 1, c.trigger(N.FPS_DROP_LEVEL_CAPPING, {
            level: u,
            droppedLevel: c.currentLevel
          }), c.autoLevelCapping = u, this.streamController.nextLevelSwitch());
        }
      }
      this.lastTime = i, this.lastDroppedFrames = r, this.lastDecodedFrames = t;
    }
  }
  checkFPSInterval() {
    const e = this.media;
    if (e)
      if (this.isVideoPlaybackQualityAvailable) {
        const t = e.getVideoPlaybackQuality();
        this.checkFPS(e, t.totalVideoFrames, t.droppedVideoFrames);
      } else
        this.checkFPS(e, e.webkitDecodedFrameCount, e.webkitDroppedFrameCount);
  }
}
function Gne(n, e) {
  let t;
  try {
    t = new Event("addtrack");
  } catch {
    t = document.createEvent("Event"), t.initEvent("addtrack", !1, !1);
  }
  t.track = n, e.dispatchEvent(t);
}
function Kne(n, e) {
  const t = n.mode;
  if (t === "disabled" && (n.mode = "hidden"), n.cues && !n.cues.getCueById(e.id))
    try {
      if (n.addCue(e), !n.cues.getCueById(e.id))
        throw new Error(`addCue is failed for: ${e}`);
    } catch (r) {
      un.debug(`[texttrack-utils]: ${r}`);
      try {
        const i = new self.TextTrackCue(e.startTime, e.endTime, e.text);
        i.id = e.id, n.addCue(i);
      } catch (i) {
        un.debug(`[texttrack-utils]: Legacy TextTrackCue fallback failed: ${i}`);
      }
    }
  t === "disabled" && (n.mode = t);
}
function Zd(n, e) {
  const t = n.mode;
  if (t === "disabled" && (n.mode = "hidden"), n.cues)
    for (let r = n.cues.length; r--; )
      e && n.cues[r].removeEventListener("enter", e), n.removeCue(n.cues[r]);
  t === "disabled" && (n.mode = t);
}
function I7(n, e, t, r) {
  const i = n.mode;
  if (i === "disabled" && (n.mode = "hidden"), n.cues && n.cues.length > 0) {
    const s = uXe(n.cues, e, t);
    for (let o = 0; o < s.length; o++)
      (!r || r(s[o])) && n.removeCue(s[o]);
  }
  i === "disabled" && (n.mode = i);
}
function cXe(n, e) {
  if (e <= n[0].startTime)
    return 0;
  const t = n.length - 1;
  if (e > n[t].endTime)
    return -1;
  let r = 0, i = t, s;
  for (; r <= i; )
    if (s = Math.floor((i + r) / 2), e < n[s].startTime)
      i = s - 1;
    else if (e > n[s].startTime && r < t)
      r = s + 1;
    else
      return s;
  return n[r].startTime - e < e - n[i].startTime ? r : i;
}
function uXe(n, e, t) {
  const r = [], i = cXe(n, e);
  if (i > -1)
    for (let s = i, o = n.length; s < o; s++) {
      const a = n[s];
      if (a.startTime >= e && a.endTime <= t)
        r.push(a);
      else if (a.startTime > t)
        return r;
    }
  return r;
}
function qv(n) {
  const e = [];
  for (let t = 0; t < n.length; t++) {
    const r = n[t];
    (r.kind === "subtitles" || r.kind === "captions") && r.label && e.push(n[t]);
  }
  return e;
}
class dXe extends __ {
  constructor(e) {
    super(e, "subtitle-track-controller"), this.media = null, this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0, this.queuedDefaultTrack = -1, this.useTextTrackPolling = !1, this.subtitlePollingInterval = -1, this._subtitleDisplay = !0, this.asyncPollTrackChange = () => this.pollTrackChange(0), this.onTextTracksChanged = () => {
      if (this.useTextTrackPolling || self.clearInterval(this.subtitlePollingInterval), !this.media || !this.hls.config.renderTextTracksNatively)
        return;
      let t = null;
      const r = qv(this.media.textTracks);
      for (let s = 0; s < r.length; s++)
        if (r[s].mode === "hidden")
          t = r[s];
        else if (r[s].mode === "showing") {
          t = r[s];
          break;
        }
      const i = this.findTrackForTextTrack(t);
      this.subtitleTrack !== i && this.setSubtitleTrack(i);
    }, this.registerListeners();
  }
  destroy() {
    this.unregisterListeners(), this.tracks.length = 0, this.tracksInGroup.length = 0, this.currentTrack = null, this.onTextTracksChanged = this.asyncPollTrackChange = null, super.destroy();
  }
  get subtitleDisplay() {
    return this._subtitleDisplay;
  }
  set subtitleDisplay(e) {
    this._subtitleDisplay = e, this.trackId > -1 && this.toggleTrackModes();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(N.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(N.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(N.MANIFEST_LOADING, this.onManifestLoading, this), e.on(N.MANIFEST_PARSED, this.onManifestParsed, this), e.on(N.LEVEL_LOADING, this.onLevelLoading, this), e.on(N.LEVEL_SWITCHING, this.onLevelSwitching, this), e.on(N.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.on(N.ERROR, this.onError, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(N.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(N.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(N.MANIFEST_LOADING, this.onManifestLoading, this), e.off(N.MANIFEST_PARSED, this.onManifestParsed, this), e.off(N.LEVEL_LOADING, this.onLevelLoading, this), e.off(N.LEVEL_SWITCHING, this.onLevelSwitching, this), e.off(N.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.off(N.ERROR, this.onError, this);
  }
  // Listen for subtitle track change, then extract the current track ID.
  onMediaAttached(e, t) {
    this.media = t.media, this.media && (this.queuedDefaultTrack > -1 && (this.subtitleTrack = this.queuedDefaultTrack, this.queuedDefaultTrack = -1), this.useTextTrackPolling = !(this.media.textTracks && "onchange" in this.media.textTracks), this.useTextTrackPolling ? this.pollTrackChange(500) : this.media.textTracks.addEventListener("change", this.asyncPollTrackChange));
  }
  pollTrackChange(e) {
    self.clearInterval(this.subtitlePollingInterval), this.subtitlePollingInterval = self.setInterval(this.onTextTracksChanged, e);
  }
  onMediaDetaching(e, t) {
    const r = this.media;
    if (!r)
      return;
    const i = !!t.transferMedia;
    if (self.clearInterval(this.subtitlePollingInterval), this.useTextTrackPolling || r.textTracks.removeEventListener("change", this.asyncPollTrackChange), this.trackId > -1 && (this.queuedDefaultTrack = this.trackId), this.subtitleTrack = -1, this.media = null, i)
      return;
    qv(r.textTracks).forEach((o) => {
      Zd(o);
    });
  }
  onManifestLoading() {
    this.tracks = [], this.groupIds = null, this.tracksInGroup = [], this.trackId = -1, this.currentTrack = null, this.selectDefaultTrack = !0;
  }
  // Fired whenever a new manifest is loaded.
  onManifestParsed(e, t) {
    this.tracks = t.subtitleTracks;
  }
  onSubtitleTrackLoaded(e, t) {
    const {
      id: r,
      groupId: i,
      details: s
    } = t, o = this.tracksInGroup[r];
    if (!o || o.groupId !== i) {
      this.warn(`Subtitle track with id:${r} and group:${i} not found in active group ${o?.groupId}`);
      return;
    }
    const a = o.details;
    o.details = t.details, this.log(`Subtitle track ${r} "${o.name}" lang:${o.lang} group:${i} loaded [${s.startSN}-${s.endSN}]`), r === this.trackId && this.playlistLoaded(r, t, a);
  }
  onLevelLoading(e, t) {
    this.switchLevel(t.level);
  }
  onLevelSwitching(e, t) {
    this.switchLevel(t.level);
  }
  switchLevel(e) {
    const t = this.hls.levels[e];
    if (!t)
      return;
    const r = t.subtitleGroups || null, i = this.groupIds;
    let s = this.currentTrack;
    if (!r || i?.length !== r?.length || r != null && r.some((o) => i?.indexOf(o) === -1)) {
      this.groupIds = r, this.trackId = -1, this.currentTrack = null;
      const o = this.tracks.filter((u) => !r || r.indexOf(u.groupId) !== -1);
      if (o.length)
        this.selectDefaultTrack && !o.some((u) => u.default) && (this.selectDefaultTrack = !1), o.forEach((u, d) => {
          u.id = d;
        });
      else if (!s && !this.tracksInGroup.length)
        return;
      this.tracksInGroup = o;
      const a = this.hls.config.subtitlePreference;
      if (!s && a) {
        this.selectDefaultTrack = !1;
        const u = ia(a, o);
        if (u > -1)
          s = o[u];
        else {
          const d = ia(a, this.tracks);
          s = this.tracks[d];
        }
      }
      let l = this.findTrackId(s);
      l === -1 && s && (l = this.findTrackId(null));
      const c = {
        subtitleTracks: o
      };
      this.log(`Updating subtitle tracks, ${o.length} track(s) found in "${r?.join(",")}" group-id`), this.hls.trigger(N.SUBTITLE_TRACKS_UPDATED, c), l !== -1 && this.trackId === -1 && this.setSubtitleTrack(l);
    }
  }
  findTrackId(e) {
    const t = this.tracksInGroup, r = this.selectDefaultTrack;
    for (let i = 0; i < t.length; i++) {
      const s = t[i];
      if (!(r && !s.default || !r && !e) && (!e || Eu(s, e)))
        return i;
    }
    if (e) {
      for (let i = 0; i < t.length; i++) {
        const s = t[i];
        if (A0(e.attrs, s.attrs, ["LANGUAGE", "ASSOC-LANGUAGE", "CHARACTERISTICS"]))
          return i;
      }
      for (let i = 0; i < t.length; i++) {
        const s = t[i];
        if (A0(e.attrs, s.attrs, ["LANGUAGE"]))
          return i;
      }
    }
    return -1;
  }
  findTrackForTextTrack(e) {
    if (e) {
      const t = this.tracksInGroup;
      for (let r = 0; r < t.length; r++) {
        const i = t[r];
        if (M7(i, e))
          return r;
      }
    }
    return -1;
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === Dt.SUBTITLE_TRACK && t.context.id === this.trackId && (!this.groupIds || this.groupIds.indexOf(t.context.groupId) !== -1) && this.checkRetry(t);
  }
  get allSubtitleTracks() {
    return this.tracks;
  }
  /** get alternate subtitle tracks list from playlist **/
  get subtitleTracks() {
    return this.tracksInGroup;
  }
  /** get/set index of the selected subtitle track (based on index in subtitle track lists) **/
  get subtitleTrack() {
    return this.trackId;
  }
  set subtitleTrack(e) {
    this.selectDefaultTrack = !1, this.setSubtitleTrack(e);
  }
  setSubtitleOption(e) {
    if (this.hls.config.subtitlePreference = e, e) {
      if (e.id === -1)
        return this.setSubtitleTrack(-1), null;
      const t = this.allSubtitleTracks;
      if (this.selectDefaultTrack = !1, t.length) {
        const r = this.currentTrack;
        if (r && Eu(e, r))
          return r;
        const i = ia(e, this.tracksInGroup);
        if (i > -1) {
          const s = this.tracksInGroup[i];
          return this.setSubtitleTrack(i), s;
        } else {
          if (r)
            return null;
          {
            const s = ia(e, t);
            if (s > -1)
              return t[s];
          }
        }
      }
    }
    return null;
  }
  loadPlaylist(e) {
    super.loadPlaylist(), this.shouldLoadPlaylist(this.currentTrack) && this.scheduleLoading(this.currentTrack, e);
  }
  loadingPlaylist(e, t) {
    super.loadingPlaylist(e, t);
    const r = e.id, i = e.groupId, s = this.getUrlWithDirectives(e.url, t), o = e.details, a = o?.age;
    this.log(`Loading subtitle ${r} "${e.name}" lang:${e.lang} group:${i}${t?.msn !== void 0 ? " at sn " + t.msn + " part " + t.part : ""}${a && o.live ? " age " + a.toFixed(1) + (o.type && " " + o.type || "") : ""} ${s}`), this.hls.trigger(N.SUBTITLE_TRACK_LOADING, {
      url: s,
      id: r,
      groupId: i,
      deliveryDirectives: t || null,
      track: e
    });
  }
  /**
   * Disables the old subtitleTrack and sets current mode on the next subtitleTrack.
   * This operates on the DOM textTracks.
   * A value of -1 will disable all subtitle tracks.
   */
  toggleTrackModes() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = qv(e.textTracks), r = this.currentTrack;
    let i;
    if (r && (i = t.filter((s) => M7(r, s))[0], i || this.warn(`Unable to find subtitle TextTrack with name "${r.name}" and language "${r.lang}"`)), [].slice.call(t).forEach((s) => {
      s.mode !== "disabled" && s !== i && (s.mode = "disabled");
    }), i) {
      const s = this.subtitleDisplay ? "showing" : "hidden";
      i.mode !== s && (i.mode = s);
    }
  }
  /**
   * This method is responsible for validating the subtitle index and periodically reloading if live.
   * Dispatches the SUBTITLE_TRACK_SWITCH event, which instructs the subtitle-stream-controller to load the selected track.
   */
  setSubtitleTrack(e) {
    const t = this.tracksInGroup;
    if (!this.media) {
      this.queuedDefaultTrack = e;
      return;
    }
    if (e < -1 || e >= t.length || !He(e)) {
      this.warn(`Invalid subtitle track id: ${e}`);
      return;
    }
    this.selectDefaultTrack = !1;
    const r = this.currentTrack, i = t[e] || null;
    if (this.trackId = e, this.currentTrack = i, this.toggleTrackModes(), !i) {
      this.hls.trigger(N.SUBTITLE_TRACK_SWITCH, {
        id: e
      });
      return;
    }
    const s = !!i.details && !i.details.live;
    if (e === this.trackId && i === r && s)
      return;
    this.log(`Switching to subtitle-track ${e}` + (i ? ` "${i.name}" lang:${i.lang} group:${i.groupId}` : ""));
    const {
      id: o,
      groupId: a = "",
      name: l,
      type: c,
      url: u
    } = i;
    this.hls.trigger(N.SUBTITLE_TRACK_SWITCH, {
      id: o,
      groupId: a,
      name: l,
      type: c,
      url: u
    });
    const d = this.switchParams(i.url, r?.details, i.details);
    this.loadPlaylist(d);
  }
}
function fXe() {
  try {
    return crypto.randomUUID();
  } catch {
    try {
      const e = URL.createObjectURL(new Blob()), t = e.toString();
      return URL.revokeObjectURL(e), t.slice(t.lastIndexOf("/") + 1);
    } catch {
      let t = (/* @__PURE__ */ new Date()).getTime();
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (i) => {
        const s = (t + Math.random() * 16) % 16 | 0;
        return t = Math.floor(t / 16), (i == "x" ? s : s & 3 | 8).toString(16);
      });
    }
  }
}
function Zp(n) {
  let e = 5381, t = n.length;
  for (; t; )
    e = e * 33 ^ n.charCodeAt(--t);
  return (e >>> 0).toString();
}
const pf = 0.025;
let qy = /* @__PURE__ */ (function(n) {
  return n[n.Point = 0] = "Point", n[n.Range = 1] = "Range", n;
})({});
function hXe(n, e, t) {
  return `${n.identifier}-${t + 1}-${Zp(e)}`;
}
class pXe {
  constructor(e, t) {
    this.base = void 0, this._duration = null, this._timelineStart = null, this.appendInPlaceDisabled = void 0, this.appendInPlaceStarted = void 0, this.dateRange = void 0, this.hasPlayed = !1, this.cumulativeDuration = 0, this.resumeOffset = NaN, this.playoutLimit = NaN, this.restrictions = {
      skip: !1,
      jump: !1
    }, this.snapOptions = {
      out: !1,
      in: !1
    }, this.assetList = [], this.assetListLoader = void 0, this.assetListResponse = null, this.resumeAnchor = void 0, this.error = void 0, this.resetOnResume = void 0, this.base = t, this.dateRange = e, this.setDateRange(e);
  }
  setDateRange(e) {
    this.dateRange = e, this.resumeOffset = e.attr.optionalFloat("X-RESUME-OFFSET", this.resumeOffset), this.playoutLimit = e.attr.optionalFloat("X-PLAYOUT-LIMIT", this.playoutLimit), this.restrictions = e.attr.enumeratedStringList("X-RESTRICT", this.restrictions), this.snapOptions = e.attr.enumeratedStringList("X-SNAP", this.snapOptions);
  }
  reset() {
    var e;
    this.appendInPlaceStarted = !1, (e = this.assetListLoader) == null || e.destroy(), this.assetListLoader = void 0, this.supplementsPrimary || (this.assetListResponse = null, this.assetList = [], this._duration = null);
  }
  isAssetPastPlayoutLimit(e) {
    var t;
    if (e > 0 && e >= this.assetList.length)
      return !0;
    const r = this.playoutLimit;
    return e <= 0 || isNaN(r) ? !1 : r === 0 ? !0 : (((t = this.assetList[e]) == null ? void 0 : t.startOffset) || 0) > r;
  }
  findAssetIndex(e) {
    return this.assetList.indexOf(e);
  }
  get identifier() {
    return this.dateRange.id;
  }
  get startDate() {
    return this.dateRange.startDate;
  }
  get startTime() {
    const e = this.dateRange.startTime;
    if (this.snapOptions.out) {
      const t = this.dateRange.tagAnchor;
      if (t)
        return R6(e, t);
    }
    return e;
  }
  get startOffset() {
    return this.cue.pre ? 0 : this.startTime;
  }
  get startIsAligned() {
    if (this.startTime === 0 || this.snapOptions.out)
      return !0;
    const e = this.dateRange.tagAnchor;
    if (e) {
      const t = this.dateRange.startTime, r = R6(t, e);
      return t - r < 0.1;
    }
    return !1;
  }
  get resumptionOffset() {
    const e = this.resumeOffset, t = He(e) ? e : this.duration;
    return this.cumulativeDuration + t;
  }
  get resumeTime() {
    const e = this.startOffset + this.resumptionOffset;
    if (this.snapOptions.in) {
      const t = this.resumeAnchor;
      if (t)
        return R6(e, t);
    }
    return e;
  }
  get appendInPlace() {
    return this.appendInPlaceStarted ? !0 : this.appendInPlaceDisabled ? !1 : !!(!this.cue.once && !this.cue.pre && // preroll starts at startPosition before startPosition is known (live)
    this.startIsAligned && (isNaN(this.playoutLimit) && isNaN(this.resumeOffset) || this.resumeOffset && this.duration && Math.abs(this.resumeOffset - this.duration) < pf));
  }
  set appendInPlace(e) {
    if (this.appendInPlaceStarted) {
      this.resetOnResume = !e;
      return;
    }
    this.appendInPlaceDisabled = !e;
  }
  // Extended timeline start time
  get timelineStart() {
    return this._timelineStart !== null ? this._timelineStart : this.startTime;
  }
  set timelineStart(e) {
    this._timelineStart = e;
  }
  get duration() {
    const e = this.playoutLimit;
    let t;
    return this._duration !== null ? t = this._duration : this.dateRange.duration ? t = this.dateRange.duration : t = this.dateRange.plannedDuration || 0, !isNaN(e) && e < t && (t = e), t;
  }
  set duration(e) {
    this._duration = e;
  }
  get cue() {
    return this.dateRange.cue;
  }
  get timelineOccupancy() {
    return this.dateRange.attr["X-TIMELINE-OCCUPIES"] === "RANGE" ? qy.Range : qy.Point;
  }
  get supplementsPrimary() {
    return this.dateRange.attr["X-TIMELINE-STYLE"] === "PRIMARY";
  }
  get contentMayVary() {
    return this.dateRange.attr["X-CONTENT-MAY-VARY"] !== "NO";
  }
  get assetUrl() {
    return this.dateRange.attr["X-ASSET-URI"];
  }
  get assetListUrl() {
    return this.dateRange.attr["X-ASSET-LIST"];
  }
  get baseUrl() {
    return this.base.url;
  }
  get assetListLoaded() {
    return this.assetList.length > 0 || this.assetListResponse !== null;
  }
  toString() {
    return mXe(this);
  }
}
function R6(n, e) {
  return n - e.start < e.duration / 2 && !(Math.abs(n - (e.start + e.duration)) < pf) ? e.start : e.start + e.duration;
}
function qne(n, e, t) {
  const r = new self.URL(n, t);
  return r.protocol !== "data:" && r.searchParams.set("_HLS_primary_id", e), r;
}
function P6(n, e) {
  for (; (t = n.assetList[++e]) != null && t.error; )
    var t;
  return e;
}
function mXe(n) {
  return `["${n.identifier}" ${n.cue.pre ? "<pre>" : n.cue.post ? "<post>" : ""}${n.timelineStart.toFixed(2)}-${n.resumeTime.toFixed(2)}]`;
}
function Ld(n) {
  const e = n.timelineStart, t = n.duration || 0;
  return `["${n.identifier}" ${e.toFixed(2)}-${(e + t).toFixed(2)}]`;
}
class gXe {
  constructor(e, t, r, i) {
    this.hls = void 0, this.interstitial = void 0, this.assetItem = void 0, this.tracks = null, this.hasDetails = !1, this.mediaAttached = null, this._currentTime = void 0, this._bufferedEosTime = void 0, this.checkPlayout = () => {
      this.reachedPlayout(this.currentTime) && this.hls && this.hls.trigger(N.PLAYOUT_LIMIT_REACHED, {});
    };
    const s = this.hls = new e(t);
    this.interstitial = r, this.assetItem = i;
    const o = () => {
      this.hasDetails = !0;
    };
    s.once(N.LEVEL_LOADED, o), s.once(N.AUDIO_TRACK_LOADED, o), s.once(N.SUBTITLE_TRACK_LOADED, o), s.on(N.MEDIA_ATTACHING, (a, {
      media: l
    }) => {
      this.removeMediaListeners(), this.mediaAttached = l, this.interstitial.playoutLimit && (l.addEventListener("timeupdate", this.checkPlayout), this.appendInPlace && s.on(N.BUFFER_APPENDED, () => {
        const u = this.bufferedEnd;
        this.reachedPlayout(u) && (this._bufferedEosTime = u, s.trigger(N.BUFFERED_TO_END, void 0));
      }));
    });
  }
  get appendInPlace() {
    return this.interstitial.appendInPlace;
  }
  loadSource() {
    const e = this.hls;
    if (e)
      if (e.url)
        e.levels.length && !e.started && e.startLoad(-1, !0);
      else {
        let t = this.assetItem.uri;
        try {
          t = qne(t, e.config.primarySessionId || "").href;
        } catch {
        }
        e.loadSource(t);
      }
  }
  bufferedInPlaceToEnd(e) {
    var t;
    if (!this.appendInPlace)
      return !1;
    if ((t = this.hls) != null && t.bufferedToEnd)
      return !0;
    if (!e)
      return !1;
    const r = Math.min(this._bufferedEosTime || 1 / 0, this.duration), i = this.timelineOffset, s = St.bufferInfo(e, i, 0);
    return this.getAssetTime(s.end) >= r - 0.02;
  }
  reachedPlayout(e) {
    const r = this.interstitial.playoutLimit;
    return this.startOffset + e >= r;
  }
  get destroyed() {
    var e;
    return !((e = this.hls) != null && e.userConfig);
  }
  get assetId() {
    return this.assetItem.identifier;
  }
  get interstitialId() {
    return this.assetItem.parentIdentifier;
  }
  get media() {
    var e;
    return ((e = this.hls) == null ? void 0 : e.media) || null;
  }
  get bufferedEnd() {
    const e = this.media || this.mediaAttached;
    if (!e)
      return this._bufferedEosTime ? this._bufferedEosTime : this.currentTime;
    const t = St.bufferInfo(e, e.currentTime, 1e-3);
    return this.getAssetTime(t.end);
  }
  get currentTime() {
    const e = this.media || this.mediaAttached;
    return e ? this.getAssetTime(e.currentTime) : this._currentTime || 0;
  }
  get duration() {
    const e = this.assetItem.duration;
    if (!e)
      return 0;
    const t = this.interstitial.playoutLimit;
    if (t) {
      const r = t - this.startOffset;
      if (r > 0 && r < e)
        return r;
    }
    return e;
  }
  get remaining() {
    const e = this.duration;
    return e ? Math.max(0, e - this.currentTime) : 0;
  }
  get startOffset() {
    return this.assetItem.startOffset;
  }
  get timelineOffset() {
    var e;
    return ((e = this.hls) == null ? void 0 : e.config.timelineOffset) || 0;
  }
  set timelineOffset(e) {
    const t = this.timelineOffset;
    if (e !== t) {
      const r = e - t;
      if (Math.abs(r) > 1 / 9e4 && this.hls) {
        if (this.hasDetails)
          throw new Error("Cannot set timelineOffset after playlists are loaded");
        this.hls.config.timelineOffset = e;
      }
    }
  }
  getAssetTime(e) {
    const t = this.timelineOffset, r = this.duration;
    return Math.min(Math.max(0, e - t), r);
  }
  removeMediaListeners() {
    const e = this.mediaAttached;
    e && (this._currentTime = e.currentTime, this.bufferSnapShot(), e.removeEventListener("timeupdate", this.checkPlayout));
  }
  bufferSnapShot() {
    if (this.mediaAttached) {
      var e;
      (e = this.hls) != null && e.bufferedToEnd && (this._bufferedEosTime = this.bufferedEnd);
    }
  }
  destroy() {
    this.removeMediaListeners(), this.hls && this.hls.destroy(), this.hls = null, this.tracks = this.mediaAttached = this.checkPlayout = null;
  }
  attachMedia(e) {
    var t;
    this.loadSource(), (t = this.hls) == null || t.attachMedia(e);
  }
  detachMedia() {
    var e;
    this.removeMediaListeners(), this.mediaAttached = null, (e = this.hls) == null || e.detachMedia();
  }
  resumeBuffering() {
    var e;
    (e = this.hls) == null || e.resumeBuffering();
  }
  pauseBuffering() {
    var e;
    (e = this.hls) == null || e.pauseBuffering();
  }
  transferMedia() {
    var e;
    return this.bufferSnapShot(), ((e = this.hls) == null ? void 0 : e.transferMedia()) || null;
  }
  resetDetails() {
    const e = this.hls;
    if (e && this.hasDetails) {
      e.stopLoad();
      const t = (r) => delete r.details;
      e.levels.forEach(t), e.allAudioTracks.forEach(t), e.allSubtitleTracks.forEach(t), this.hasDetails = !1;
    }
  }
  on(e, t, r) {
    var i;
    (i = this.hls) == null || i.on(e, t);
  }
  once(e, t, r) {
    var i;
    (i = this.hls) == null || i.once(e, t);
  }
  off(e, t, r) {
    var i;
    (i = this.hls) == null || i.off(e, t);
  }
  toString() {
    var e;
    return `HlsAssetPlayer: ${Ld(this.assetItem)} ${(e = this.hls) == null ? void 0 : e.sessionId} ${this.appendInPlace ? "append-in-place" : ""}`;
  }
}
const IH = 0.033;
class vXe extends Ys {
  constructor(e, t) {
    super("interstitials-sched", t), this.onScheduleUpdate = void 0, this.eventMap = {}, this.events = null, this.items = null, this.durations = {
      primary: 0,
      playout: 0,
      integrated: 0
    }, this.onScheduleUpdate = e;
  }
  destroy() {
    this.reset(), this.onScheduleUpdate = null;
  }
  reset() {
    this.eventMap = {}, this.setDurations(0, 0, 0), this.events && this.events.forEach((e) => e.reset()), this.events = this.items = null;
  }
  resetErrorsInRange(e, t) {
    return this.events ? this.events.reduce((r, i) => e <= i.startOffset && t > i.startOffset ? (delete i.error, r + 1) : r, 0) : 0;
  }
  get duration() {
    const e = this.items;
    return e ? e[e.length - 1].end : 0;
  }
  get length() {
    return this.items ? this.items.length : 0;
  }
  getEvent(e) {
    return e && this.eventMap[e] || null;
  }
  hasEvent(e) {
    return e in this.eventMap;
  }
  findItemIndex(e, t) {
    if (e.event)
      return this.findEventIndex(e.event.identifier);
    let r = -1;
    e.nextEvent ? r = this.findEventIndex(e.nextEvent.identifier) - 1 : e.previousEvent && (r = this.findEventIndex(e.previousEvent.identifier) + 1);
    const i = this.items;
    if (i)
      for (i[r] || (t === void 0 && (t = e.start), r = this.findItemIndexAtTime(t)); r >= 0 && (s = i[r]) != null && s.event; ) {
        var s;
        r--;
      }
    return r;
  }
  findItemIndexAtTime(e, t) {
    const r = this.items;
    if (r)
      for (let i = 0; i < r.length; i++) {
        let s = r[i];
        if (t && t !== "primary" && (s = s[t]), e === s.start || e > s.start && e < s.end)
          return i;
      }
    return -1;
  }
  findJumpRestrictedIndex(e, t) {
    const r = this.items;
    if (r)
      for (let i = e; i <= t && r[i]; i++) {
        const s = r[i].event;
        if (s != null && s.restrictions.jump && !s.appendInPlace)
          return i;
      }
    return -1;
  }
  findEventIndex(e) {
    const t = this.items;
    if (t)
      for (let i = t.length; i--; ) {
        var r;
        if (((r = t[i].event) == null ? void 0 : r.identifier) === e)
          return i;
      }
    return -1;
  }
  findAssetIndex(e, t) {
    const r = e.assetList, i = r.length;
    if (i > 1)
      for (let s = 0; s < i; s++) {
        const o = r[s];
        if (!o.error) {
          const a = o.timelineStart;
          if (t === a || t > a && (t < a + (o.duration || 0) || s === i - 1))
            return s;
        }
      }
    return 0;
  }
  get assetIdAtEnd() {
    var e;
    const t = (e = this.items) == null || (e = e[this.length - 1]) == null ? void 0 : e.event;
    if (t) {
      const r = t.assetList, i = r[r.length - 1];
      if (i)
        return i.identifier;
    }
    return null;
  }
  parseInterstitialDateRanges(e, t) {
    const r = e.main.details, {
      dateRanges: i
    } = r, s = this.events, o = this.parseDateRanges(i, {
      url: r.url
    }, t), a = Object.keys(i), l = s ? s.filter((c) => !a.includes(c.identifier)) : [];
    o.length && o.sort((c, u) => {
      const d = c.cue.pre, f = c.cue.post, h = u.cue.pre, m = u.cue.post;
      if (d && !h)
        return -1;
      if (h && !d || f && !m)
        return 1;
      if (m && !f)
        return -1;
      if (!d && !h && !f && !m) {
        const g = c.startTime, v = u.startTime;
        if (g !== v)
          return g - v;
      }
      return c.dateRange.tagOrder - u.dateRange.tagOrder;
    }), this.events = o, l.forEach((c) => {
      this.removeEvent(c);
    }), this.updateSchedule(e, l);
  }
  updateSchedule(e, t = [], r = !1) {
    const i = this.events || [];
    if (i.length || t.length || this.length < 2) {
      const s = this.items, o = this.parseSchedule(i, e);
      (r || t.length || s?.length !== o.length || o.some((l, c) => Math.abs(l.playout.start - s[c].playout.start) > 5e-3 || Math.abs(l.playout.end - s[c].playout.end) > 5e-3)) && (this.items = o, this.onScheduleUpdate(t, s));
    }
  }
  parseDateRanges(e, t, r) {
    const i = [], s = Object.keys(e);
    for (let o = 0; o < s.length; o++) {
      const a = s[o], l = e[a];
      if (l.isInterstitial) {
        let c = this.eventMap[a];
        c ? c.setDateRange(l) : (c = new pXe(l, t), this.eventMap[a] = c, r === !1 && (c.appendInPlace = r)), i.push(c);
      }
    }
    return i;
  }
  parseSchedule(e, t) {
    const r = [], i = t.main.details, s = i.live ? 1 / 0 : i.edge;
    let o = 0;
    if (e = e.filter((l) => !l.error && !(l.cue.once && l.hasPlayed)), e.length) {
      this.resolveOffsets(e, t);
      let l = 0, c = 0;
      if (e.forEach((u, d) => {
        const f = u.cue.pre, h = u.cue.post, m = e[d - 1] || null, g = u.appendInPlace, v = h ? s : u.startOffset, y = u.duration, b = u.timelineOccupancy === qy.Range ? y : 0, x = u.resumptionOffset, E = m?.startTime === v, w = v + u.cumulativeDuration;
        let C = g ? w + y : v + x;
        if (f || !h && v <= 0) {
          const M = c;
          c += b, u.timelineStart = w;
          const k = o;
          o += y, r.push({
            event: u,
            start: w,
            end: C,
            playout: {
              start: k,
              end: o
            },
            integrated: {
              start: M,
              end: c
            }
          });
        } else if (v <= s) {
          if (!E) {
            const _ = v - l;
            if (_ > IH) {
              const O = l, I = c;
              c += _;
              const R = o;
              o += _;
              const P = {
                previousEvent: e[d - 1] || null,
                nextEvent: u,
                start: O,
                end: O + _,
                playout: {
                  start: R,
                  end: o
                },
                integrated: {
                  start: I,
                  end: c
                }
              };
              r.push(P);
            } else _ > 0 && m && (m.cumulativeDuration += _, r[r.length - 1].end = v);
          }
          h && (C = w), u.timelineStart = w;
          const M = c;
          c += b;
          const k = o;
          o += y, r.push({
            event: u,
            start: w,
            end: C,
            playout: {
              start: k,
              end: o
            },
            integrated: {
              start: M,
              end: c
            }
          });
        } else
          return;
        const S = u.resumeTime;
        h || S > s ? l = s : l = S;
      }), l < s) {
        var a;
        const u = l, d = c, f = s - l;
        c += f;
        const h = o;
        o += f, r.push({
          previousEvent: ((a = r[r.length - 1]) == null ? void 0 : a.event) || null,
          nextEvent: null,
          start: l,
          end: u + f,
          playout: {
            start: h,
            end: o
          },
          integrated: {
            start: d,
            end: c
          }
        });
      }
      this.setDurations(s, o, c);
    } else
      r.push({
        previousEvent: null,
        nextEvent: null,
        start: 0,
        end: s,
        playout: {
          start: 0,
          end: s
        },
        integrated: {
          start: 0,
          end: s
        }
      }), this.setDurations(s, s, s);
    return r;
  }
  setDurations(e, t, r) {
    this.durations = {
      primary: e,
      playout: t,
      integrated: r
    };
  }
  resolveOffsets(e, t) {
    const r = t.main.details, i = r.live ? 1 / 0 : r.edge;
    let s = 0, o = -1;
    e.forEach((a, l) => {
      const c = a.cue.pre, u = a.cue.post, d = c ? 0 : u ? i : a.startTime;
      this.updateAssetDurations(a), o === d ? a.cumulativeDuration = s : (s = 0, o = d), !u && a.snapOptions.in && (a.resumeAnchor = Bu(null, r.fragments, a.startOffset + a.resumptionOffset, 0, 0) || void 0), a.appendInPlace && !a.appendInPlaceStarted && (this.primaryCanResumeInPlaceAt(a, t) || (a.appendInPlace = !1)), !a.appendInPlace && l + 1 < e.length && e[l + 1].startTime - e[l].resumeTime < IH && (e[l + 1].appendInPlace = !1, e[l + 1].appendInPlace && this.warn(`Could not change append strategy for abutting event ${a}`));
      const h = He(a.resumeOffset) ? a.resumeOffset : a.duration;
      s += h;
    });
  }
  primaryCanResumeInPlaceAt(e, t) {
    const r = e.resumeTime, i = e.startTime + e.resumptionOffset;
    return Math.abs(r - i) > pf ? (this.log(`"${e.identifier}" resumption ${r} not aligned with estimated timeline end ${i}`), !1) : !Object.keys(t).some((o) => {
      const a = t[o].details, l = a.edge;
      if (r >= l)
        return this.log(`"${e.identifier}" resumption ${r} past ${o} playlist end ${l}`), !1;
      const c = Bu(null, a.fragments, r);
      if (!c)
        return this.log(`"${e.identifier}" resumption ${r} does not align with any fragments in ${o} playlist (${a.fragStart}-${a.fragmentEnd})`), !0;
      const u = o === "audio" ? 0.175 : 0;
      return Math.abs(c.start - r) < pf + u || Math.abs(c.end - r) < pf + u ? !1 : (this.log(`"${e.identifier}" resumption ${r} not aligned with ${o} fragment bounds (${c.start}-${c.end} sn: ${c.sn} cc: ${c.cc})`), !0);
    });
  }
  updateAssetDurations(e) {
    if (!e.assetListLoaded)
      return;
    const t = e.timelineStart;
    let r = 0, i = !1, s = !1;
    for (let o = 0; o < e.assetList.length; o++) {
      const a = e.assetList[o], l = t + r;
      a.startOffset = r, a.timelineStart = l, i || (i = a.duration === null), s || (s = !!a.error);
      const c = a.error ? 0 : a.duration || 0;
      r += c;
    }
    i && !s ? e.duration = Math.max(r, e.duration) : e.duration = r;
  }
  removeEvent(e) {
    e.reset(), delete this.eventMap[e.identifier];
  }
}
function Js(n) {
  return `[${n.event ? '"' + n.event.identifier + '"' : "primary"}: ${n.start.toFixed(2)}-${n.end.toFixed(2)}]`;
}
class yXe {
  constructor(e) {
    this.hls = void 0, this.hls = e;
  }
  destroy() {
    this.hls = null;
  }
  loadAssetList(e, t) {
    const r = e.assetListUrl;
    let i;
    try {
      i = qne(r, this.hls.sessionId, e.baseUrl);
    } catch (f) {
      const h = this.assignAssetListError(e, ce.ASSET_LIST_LOAD_ERROR, f, r);
      this.hls.trigger(N.ERROR, h);
      return;
    }
    t && i.protocol !== "data:" && i.searchParams.set("_HLS_start_offset", "" + t);
    const s = this.hls.config, o = s.loader, a = new o(s), l = {
      responseType: "json",
      url: i.href
    }, c = s.interstitialAssetListLoadPolicy.default, u = {
      loadPolicy: c,
      timeout: c.maxLoadTimeMs,
      maxRetry: 0,
      retryDelay: 0,
      maxRetryDelay: 0
    }, d = {
      onSuccess: (f, h, m, g) => {
        const v = f.data, y = v?.ASSETS;
        if (!Array.isArray(y)) {
          const b = this.assignAssetListError(e, ce.ASSET_LIST_PARSING_ERROR, new Error("Invalid interstitial asset list"), m.url, h, g);
          this.hls.trigger(N.ERROR, b);
          return;
        }
        e.assetListResponse = v, this.hls.trigger(N.ASSET_LIST_LOADED, {
          event: e,
          assetListResponse: v,
          networkDetails: g
        });
      },
      onError: (f, h, m, g) => {
        const v = this.assignAssetListError(e, ce.ASSET_LIST_LOAD_ERROR, new Error(`Error loading X-ASSET-LIST: HTTP status ${f.code} ${f.text} (${h.url})`), h.url, g, m);
        this.hls.trigger(N.ERROR, v);
      },
      onTimeout: (f, h, m) => {
        const g = this.assignAssetListError(e, ce.ASSET_LIST_LOAD_TIMEOUT, new Error(`Timeout loading X-ASSET-LIST (${h.url})`), h.url, f, m);
        this.hls.trigger(N.ERROR, g);
      }
    };
    return a.load(l, u, d), this.hls.trigger(N.ASSET_LIST_LOADING, {
      event: e
    }), a;
  }
  assignAssetListError(e, t, r, i, s, o) {
    return e.error = r, {
      type: Je.NETWORK_ERROR,
      details: t,
      fatal: !1,
      interstitial: e,
      url: i,
      error: r,
      networkDetails: o,
      stats: s
    };
  }
}
function RH(n) {
  var e;
  n == null || (e = n.play()) == null || e.catch(() => {
  });
}
function zg(n, e) {
  return `[${n}] Advancing timeline position to ${e}`;
}
class bXe extends Ys {
  constructor(e, t) {
    super("interstitials", e.logger), this.HlsPlayerClass = void 0, this.hls = void 0, this.assetListLoader = void 0, this.mediaSelection = null, this.altSelection = null, this.media = null, this.detachedData = null, this.requiredTracks = null, this.manager = null, this.playerQueue = [], this.bufferedPos = -1, this.timelinePos = -1, this.schedule = void 0, this.playingItem = null, this.bufferingItem = null, this.waitingItem = null, this.endedItem = null, this.playingAsset = null, this.endedAsset = null, this.bufferingAsset = null, this.shouldPlay = !1, this.onPlay = () => {
      this.shouldPlay = !0;
    }, this.onPause = () => {
      this.shouldPlay = !1;
    }, this.onSeeking = () => {
      const r = this.currentTime;
      if (r === void 0 || this.playbackDisabled || !this.schedule)
        return;
      const i = r - this.timelinePos;
      if (Math.abs(i) < 1 / 7056e5)
        return;
      const o = i <= -0.01;
      this.timelinePos = r, this.bufferedPos = r;
      const a = this.playingItem;
      if (!a) {
        this.checkBuffer();
        return;
      }
      if (o && this.schedule.resetErrorsInRange(r, r - i) && this.updateSchedule(!0), this.checkBuffer(), o && r < a.start || r >= a.end) {
        var l;
        const h = this.findItemIndex(a);
        let m = this.schedule.findItemIndexAtTime(r);
        if (m === -1 && (m = h + (o ? -1 : 1), this.log(`seeked ${o ? "back " : ""}to position not covered by schedule ${r} (resolving from ${h} to ${m})`)), !this.isInterstitial(a) && (l = this.media) != null && l.paused && (this.shouldPlay = !1), !o && m > h) {
          const g = this.schedule.findJumpRestrictedIndex(h + 1, m);
          if (g > h) {
            this.setSchedulePosition(g);
            return;
          }
        }
        this.setSchedulePosition(m);
        return;
      }
      const c = this.playingAsset;
      if (!c) {
        if (this.playingLastItem && this.isInterstitial(a)) {
          const h = a.event.assetList[0];
          h && (this.endedItem = this.playingItem, this.playingItem = null, this.setScheduleToAssetAtTime(r, h));
        }
        return;
      }
      const u = c.timelineStart, d = c.duration || 0;
      if (o && r < u || r >= u + d) {
        var f;
        (f = a.event) != null && f.appendInPlace && (this.clearAssetPlayers(a.event, a), this.flushFrontBuffer(r)), this.setScheduleToAssetAtTime(r, c);
      }
    }, this.onTimeupdate = () => {
      const r = this.currentTime;
      if (r === void 0 || this.playbackDisabled)
        return;
      if (r > this.timelinePos)
        this.timelinePos = r, r > this.bufferedPos && this.checkBuffer();
      else
        return;
      const i = this.playingItem;
      if (!i || this.playingLastItem)
        return;
      if (r >= i.end) {
        this.timelinePos = i.end;
        const a = this.findItemIndex(i);
        this.setSchedulePosition(a + 1);
      }
      const s = this.playingAsset;
      if (!s)
        return;
      const o = s.timelineStart + (s.duration || 0);
      r >= o && this.setScheduleToAssetAtTime(r, s);
    }, this.onScheduleUpdate = (r, i) => {
      const s = this.schedule;
      if (!s)
        return;
      const o = this.playingItem, a = s.events || [], l = s.items || [], c = s.durations, u = r.map((g) => g.identifier), d = !!(a.length || u.length);
      (d || i) && this.log(`INTERSTITIALS_UPDATED (${a.length}): ${a}
Schedule: ${l.map((g) => Js(g))} pos: ${this.timelinePos}`), u.length && this.log(`Removed events ${u}`);
      let f = null, h = null;
      o && (f = this.updateItem(o, this.timelinePos), this.itemsMatch(o, f) ? this.playingItem = f : this.waitingItem = this.endedItem = null), this.waitingItem = this.updateItem(this.waitingItem), this.endedItem = this.updateItem(this.endedItem);
      const m = this.bufferingItem;
      if (m && (h = this.updateItem(m, this.bufferedPos), this.itemsMatch(m, h) ? this.bufferingItem = h : m.event && (this.bufferingItem = this.playingItem, this.clearInterstitial(m.event, null))), r.forEach((g) => {
        g.assetList.forEach((v) => {
          this.clearAssetPlayer(v.identifier, null);
        });
      }), this.playerQueue.forEach((g) => {
        if (g.interstitial.appendInPlace) {
          const v = g.assetItem.timelineStart, y = g.timelineOffset - v;
          if (y)
            try {
              g.timelineOffset = v;
            } catch (b) {
              Math.abs(y) > pf && this.warn(`${b} ("${g.assetId}" ${g.timelineOffset}->${v})`);
            }
        }
      }), d || i) {
        if (this.hls.trigger(N.INTERSTITIALS_UPDATED, {
          events: a.slice(0),
          schedule: l.slice(0),
          durations: c,
          removedIds: u
        }), this.isInterstitial(o) && u.includes(o.event.identifier)) {
          this.warn(`Interstitial "${o.event.identifier}" removed while playing`), this.primaryFallback(o.event);
          return;
        }
        o && this.trimInPlace(f, o), m && h !== f && this.trimInPlace(h, m), this.checkBuffer();
      }
    }, this.hls = e, this.HlsPlayerClass = t, this.assetListLoader = new yXe(e), this.schedule = new vXe(this.onScheduleUpdate, e.logger), this.registerListeners();
  }
  registerListeners() {
    const e = this.hls;
    e && (e.on(N.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(N.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(N.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(N.MANIFEST_LOADING, this.onManifestLoading, this), e.on(N.LEVEL_UPDATED, this.onLevelUpdated, this), e.on(N.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(N.AUDIO_TRACK_UPDATED, this.onAudioTrackUpdated, this), e.on(N.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.on(N.SUBTITLE_TRACK_UPDATED, this.onSubtitleTrackUpdated, this), e.on(N.EVENT_CUE_ENTER, this.onInterstitialCueEnter, this), e.on(N.ASSET_LIST_LOADED, this.onAssetListLoaded, this), e.on(N.BUFFER_APPENDED, this.onBufferAppended, this), e.on(N.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(N.BUFFERED_TO_END, this.onBufferedToEnd, this), e.on(N.MEDIA_ENDED, this.onMediaEnded, this), e.on(N.ERROR, this.onError, this), e.on(N.DESTROYING, this.onDestroying, this));
  }
  unregisterListeners() {
    const e = this.hls;
    e && (e.off(N.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(N.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(N.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(N.MANIFEST_LOADING, this.onManifestLoading, this), e.off(N.LEVEL_UPDATED, this.onLevelUpdated, this), e.off(N.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(N.AUDIO_TRACK_UPDATED, this.onAudioTrackUpdated, this), e.off(N.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.off(N.SUBTITLE_TRACK_UPDATED, this.onSubtitleTrackUpdated, this), e.off(N.EVENT_CUE_ENTER, this.onInterstitialCueEnter, this), e.off(N.ASSET_LIST_LOADED, this.onAssetListLoaded, this), e.off(N.BUFFER_CODECS, this.onBufferCodecs, this), e.off(N.BUFFER_APPENDED, this.onBufferAppended, this), e.off(N.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(N.BUFFERED_TO_END, this.onBufferedToEnd, this), e.off(N.MEDIA_ENDED, this.onMediaEnded, this), e.off(N.ERROR, this.onError, this), e.off(N.DESTROYING, this.onDestroying, this));
  }
  startLoad() {
    this.resumeBuffering();
  }
  stopLoad() {
    this.pauseBuffering();
  }
  resumeBuffering() {
    var e;
    (e = this.getBufferingPlayer()) == null || e.resumeBuffering();
  }
  pauseBuffering() {
    var e;
    (e = this.getBufferingPlayer()) == null || e.pauseBuffering();
  }
  destroy() {
    this.unregisterListeners(), this.stopLoad(), this.assetListLoader && this.assetListLoader.destroy(), this.emptyPlayerQueue(), this.clearScheduleState(), this.schedule && this.schedule.destroy(), this.media = this.detachedData = this.mediaSelection = this.requiredTracks = this.altSelection = this.schedule = this.manager = null, this.hls = this.HlsPlayerClass = this.log = null, this.assetListLoader = null, this.onPlay = this.onPause = this.onSeeking = this.onTimeupdate = null, this.onScheduleUpdate = null;
  }
  onDestroying() {
    const e = this.primaryMedia || this.media;
    e && this.removeMediaListeners(e);
  }
  removeMediaListeners(e) {
    Bi(e, "play", this.onPlay), Bi(e, "pause", this.onPause), Bi(e, "seeking", this.onSeeking), Bi(e, "timeupdate", this.onTimeupdate);
  }
  onMediaAttaching(e, t) {
    const r = this.media = t.media;
    gi(r, "seeking", this.onSeeking), gi(r, "timeupdate", this.onTimeupdate), gi(r, "play", this.onPlay), gi(r, "pause", this.onPause);
  }
  onMediaAttached(e, t) {
    const r = this.effectivePlayingItem, i = this.detachedData;
    if (this.detachedData = null, r === null)
      this.checkStart();
    else if (!i) {
      this.clearScheduleState();
      const s = this.findItemIndex(r);
      this.setSchedulePosition(s);
    }
  }
  clearScheduleState() {
    this.log("clear schedule state"), this.playingItem = this.bufferingItem = this.waitingItem = this.endedItem = this.playingAsset = this.endedAsset = this.bufferingAsset = null;
  }
  onMediaDetaching(e, t) {
    const r = !!t.transferMedia, i = this.media;
    if (this.media = null, !r && (i && this.removeMediaListeners(i), this.detachedData)) {
      const s = this.getBufferingPlayer();
      s && (this.log(`Removing schedule state for detachedData and ${s}`), this.playingAsset = this.endedAsset = this.bufferingAsset = this.bufferingItem = this.waitingItem = this.detachedData = null, s.detachMedia()), this.shouldPlay = !1;
    }
  }
  get interstitialsManager() {
    if (!this.hls)
      return null;
    if (this.manager)
      return this.manager;
    const e = this, t = () => e.bufferingItem || e.waitingItem, r = (d) => d && e.getAssetPlayer(d.identifier), i = (d, f, h, m, g) => {
      if (d) {
        let v = d[f].start;
        const y = d.event;
        if (y) {
          if (f === "playout" || y.timelineOccupancy !== qy.Point) {
            const b = r(h);
            b?.interstitial === y && (v += b.assetItem.startOffset + b[g]);
          }
        } else {
          const b = m === "bufferedPos" ? o() : e[m];
          v += b - d.start;
        }
        return v;
      }
      return 0;
    }, s = (d, f) => {
      var h;
      if (d !== 0 && f !== "primary" && (h = e.schedule) != null && h.length) {
        var m;
        const g = e.schedule.findItemIndexAtTime(d), v = (m = e.schedule.items) == null ? void 0 : m[g];
        if (v) {
          const y = v[f].start - v.start;
          return d + y;
        }
      }
      return d;
    }, o = () => {
      const d = e.bufferedPos;
      return d === Number.MAX_VALUE ? a("primary") : Math.max(d, 0);
    }, a = (d) => {
      var f, h;
      return (f = e.primaryDetails) != null && f.live ? e.primaryDetails.edge : ((h = e.schedule) == null ? void 0 : h.durations[d]) || 0;
    }, l = (d, f) => {
      var h, m;
      const g = e.effectivePlayingItem;
      if (g != null && (h = g.event) != null && h.restrictions.skip || !e.schedule)
        return;
      e.log(`seek to ${d} "${f}"`);
      const v = e.effectivePlayingItem, y = e.schedule.findItemIndexAtTime(d, f), b = (m = e.schedule.items) == null ? void 0 : m[y], x = e.getBufferingPlayer(), E = x?.interstitial, w = E?.appendInPlace, C = v && e.itemsMatch(v, b);
      if (v && (w || C)) {
        const S = r(e.playingAsset), M = S?.media || e.primaryMedia;
        if (M) {
          const k = f === "primary" ? M.currentTime : i(v, f, e.playingAsset, "timelinePos", "currentTime"), _ = d - k, O = (w ? k : M.currentTime) + _;
          if (O >= 0 && (!S || w || O <= S.duration)) {
            M.currentTime = O;
            return;
          }
        }
      }
      if (b) {
        let S = d;
        if (f !== "primary") {
          const k = b[f].start, _ = d - k;
          S = b.start + _;
        }
        const M = !e.isInterstitial(b);
        if ((!e.isInterstitial(v) || v.event.appendInPlace) && (M || b.event.appendInPlace)) {
          const k = e.media || (w ? x?.media : null);
          k && (k.currentTime = S);
        } else if (v) {
          const k = e.findItemIndex(v);
          if (y > k) {
            const O = e.schedule.findJumpRestrictedIndex(k + 1, y);
            if (O > k) {
              e.setSchedulePosition(O);
              return;
            }
          }
          let _ = 0;
          if (M)
            e.timelinePos = S, e.checkBuffer();
          else {
            const O = b.event.assetList, I = d - (b[f] || b).start;
            for (let R = O.length; R--; ) {
              const P = O[R];
              if (P.duration && I >= P.startOffset && I < P.startOffset + P.duration) {
                _ = R;
                break;
              }
            }
          }
          e.setSchedulePosition(y, _);
        }
      }
    }, c = () => {
      const d = e.effectivePlayingItem;
      if (e.isInterstitial(d))
        return d;
      const f = t();
      return e.isInterstitial(f) ? f : null;
    }, u = {
      get bufferedEnd() {
        const d = t(), f = e.bufferingItem;
        if (f && f === d) {
          var h;
          return i(f, "playout", e.bufferingAsset, "bufferedPos", "bufferedEnd") - f.playout.start || ((h = e.bufferingAsset) == null ? void 0 : h.startOffset) || 0;
        }
        return 0;
      },
      get currentTime() {
        const d = c(), f = e.effectivePlayingItem;
        return f && f === d ? i(f, "playout", e.effectivePlayingAsset, "timelinePos", "currentTime") - f.playout.start : 0;
      },
      set currentTime(d) {
        const f = c(), h = e.effectivePlayingItem;
        h && h === f && l(d + h.playout.start, "playout");
      },
      get duration() {
        const d = c();
        return d ? d.playout.end - d.playout.start : 0;
      },
      get assetPlayers() {
        var d;
        const f = (d = c()) == null ? void 0 : d.event.assetList;
        return f ? f.map((h) => e.getAssetPlayer(h.identifier)) : [];
      },
      get playingIndex() {
        var d;
        const f = (d = c()) == null ? void 0 : d.event;
        return f && e.effectivePlayingAsset ? f.findAssetIndex(e.effectivePlayingAsset) : -1;
      },
      get scheduleItem() {
        return c();
      }
    };
    return this.manager = {
      get events() {
        var d;
        return ((d = e.schedule) == null || (d = d.events) == null ? void 0 : d.slice(0)) || [];
      },
      get schedule() {
        var d;
        return ((d = e.schedule) == null || (d = d.items) == null ? void 0 : d.slice(0)) || [];
      },
      get interstitialPlayer() {
        return c() ? u : null;
      },
      get playerQueue() {
        return e.playerQueue.slice(0);
      },
      get bufferingAsset() {
        return e.bufferingAsset;
      },
      get bufferingItem() {
        return t();
      },
      get bufferingIndex() {
        const d = t();
        return e.findItemIndex(d);
      },
      get playingAsset() {
        return e.effectivePlayingAsset;
      },
      get playingItem() {
        return e.effectivePlayingItem;
      },
      get playingIndex() {
        const d = e.effectivePlayingItem;
        return e.findItemIndex(d);
      },
      primary: {
        get bufferedEnd() {
          return o();
        },
        get currentTime() {
          const d = e.timelinePos;
          return d > 0 ? d : 0;
        },
        set currentTime(d) {
          l(d, "primary");
        },
        get duration() {
          return a("primary");
        },
        get seekableStart() {
          var d;
          return ((d = e.primaryDetails) == null ? void 0 : d.fragmentStart) || 0;
        }
      },
      integrated: {
        get bufferedEnd() {
          return i(t(), "integrated", e.bufferingAsset, "bufferedPos", "bufferedEnd");
        },
        get currentTime() {
          return i(e.effectivePlayingItem, "integrated", e.effectivePlayingAsset, "timelinePos", "currentTime");
        },
        set currentTime(d) {
          l(d, "integrated");
        },
        get duration() {
          return a("integrated");
        },
        get seekableStart() {
          var d;
          return s(((d = e.primaryDetails) == null ? void 0 : d.fragmentStart) || 0, "integrated");
        }
      },
      skip: () => {
        const d = e.effectivePlayingItem, f = d?.event;
        if (f && !f.restrictions.skip) {
          const h = e.findItemIndex(d);
          if (f.appendInPlace) {
            const m = d.playout.start + d.event.duration;
            l(m + 1e-3, "playout");
          } else
            e.advanceAfterAssetEnded(f, h, 1 / 0);
        }
      }
    };
  }
  // Schedule getters
  get effectivePlayingItem() {
    return this.waitingItem || this.playingItem || this.endedItem;
  }
  get effectivePlayingAsset() {
    return this.playingAsset || this.endedAsset;
  }
  get playingLastItem() {
    var e;
    const t = this.playingItem, r = (e = this.schedule) == null ? void 0 : e.items;
    return !this.playbackStarted || !t || !r ? !1 : this.findItemIndex(t) === r.length - 1;
  }
  get playbackStarted() {
    return this.effectivePlayingItem !== null;
  }
  // Media getters and event callbacks
  get currentTime() {
    var e, t;
    if (this.mediaSelection === null)
      return;
    const r = this.waitingItem || this.playingItem;
    if (this.isInterstitial(r) && !r.event.appendInPlace)
      return;
    let i = this.media;
    !i && (e = this.bufferingItem) != null && (e = e.event) != null && e.appendInPlace && (i = this.primaryMedia);
    const s = (t = i) == null ? void 0 : t.currentTime;
    if (!(s === void 0 || !He(s)))
      return s;
  }
  get primaryMedia() {
    var e;
    return this.media || ((e = this.detachedData) == null ? void 0 : e.media) || null;
  }
  isInterstitial(e) {
    return !!(e != null && e.event);
  }
  retreiveMediaSource(e, t) {
    const r = this.getAssetPlayer(e);
    r && this.transferMediaFromPlayer(r, t);
  }
  transferMediaFromPlayer(e, t) {
    const r = e.interstitial.appendInPlace, i = e.media;
    if (r && i === this.primaryMedia) {
      if (this.bufferingAsset = null, (!t || this.isInterstitial(t) && !t.event.appendInPlace) && t && i) {
        this.detachedData = {
          media: i
        };
        return;
      }
      const s = e.transferMedia();
      this.log(`transfer MediaSource from ${e} ${Sn(s)}`), this.detachedData = s;
    } else t && i && (this.shouldPlay || (this.shouldPlay = !i.paused));
  }
  transferMediaTo(e, t) {
    var r, i;
    if (e.media === t)
      return;
    let s = null;
    const o = this.hls, a = e !== o, l = a && e.interstitial.appendInPlace, c = (r = this.detachedData) == null ? void 0 : r.mediaSource;
    let u;
    if (o.media)
      l && (s = o.transferMedia(), this.detachedData = s), u = "Primary";
    else if (c) {
      const m = this.getBufferingPlayer();
      m ? (s = m.transferMedia(), u = `${m}`) : u = "detached MediaSource";
    } else
      u = "detached media";
    if (!s) {
      if (c)
        s = this.detachedData, this.log(`using detachedData: MediaSource ${Sn(s)}`);
      else if (!this.detachedData || o.media === t) {
        const m = this.playerQueue;
        m.length > 1 && m.forEach((g) => {
          if (a && g.interstitial.appendInPlace !== l) {
            const v = g.interstitial;
            this.clearInterstitial(g.interstitial, null), v.appendInPlace = !1, v.appendInPlace && this.warn(`Could not change append strategy for queued assets ${v}`);
          }
        }), this.hls.detachMedia(), this.detachedData = {
          media: t
        };
      }
    }
    const d = s && "mediaSource" in s && ((i = s.mediaSource) == null ? void 0 : i.readyState) !== "closed", f = d && s ? s : t;
    this.log(`${d ? "transfering MediaSource" : "attaching media"} to ${a ? e : "Primary"} from ${u} (media.currentTime: ${t.currentTime})`);
    const h = this.schedule;
    if (f === s && h) {
      const m = a && e.assetId === h.assetIdAtEnd;
      f.overrides = {
        duration: h.duration,
        endOfStream: !a || m,
        cueRemoval: !a
      };
    }
    e.attachMedia(f);
  }
  onInterstitialCueEnter() {
    this.onTimeupdate();
  }
  // Scheduling methods
  checkStart() {
    const e = this.schedule, t = e?.events;
    if (!t || this.playbackDisabled || !this.media)
      return;
    this.bufferedPos === -1 && (this.bufferedPos = 0);
    const r = this.timelinePos, i = this.effectivePlayingItem;
    if (r === -1) {
      const s = this.hls.startPosition;
      if (this.log(zg("checkStart", s)), this.timelinePos = s, t.length && t[0].cue.pre) {
        const o = e.findEventIndex(t[0].identifier);
        this.setSchedulePosition(o);
      } else if (s >= 0 || !this.primaryLive) {
        const o = this.timelinePos = s > 0 ? s : 0, a = e.findItemIndexAtTime(o);
        this.setSchedulePosition(a);
      }
    } else if (i && !this.playingItem) {
      const s = e.findItemIndex(i);
      this.setSchedulePosition(s);
    }
  }
  advanceAssetBuffering(e, t) {
    const r = e.event, i = r.findAssetIndex(t), s = P6(r, i);
    if (!r.isAssetPastPlayoutLimit(s))
      this.bufferedToEvent(e, s);
    else if (this.schedule) {
      var o;
      const a = (o = this.schedule.items) == null ? void 0 : o[this.findItemIndex(e) + 1];
      a && this.bufferedToItem(a);
    }
  }
  advanceAfterAssetEnded(e, t, r) {
    const i = P6(e, r);
    if (e.isAssetPastPlayoutLimit(i)) {
      if (this.schedule) {
        const s = this.schedule.items;
        if (s) {
          const o = t + 1, a = s.length;
          if (o >= a) {
            this.setSchedulePosition(-1);
            return;
          }
          const l = e.resumeTime;
          this.timelinePos < l && (this.log(zg("advanceAfterAssetEnded", l)), this.timelinePos = l, e.appendInPlace && this.advanceInPlace(l), this.checkBuffer(this.bufferedPos < l)), this.setSchedulePosition(o);
        }
      }
    } else {
      if (e.appendInPlace) {
        const s = e.assetList[i];
        s && this.advanceInPlace(s.timelineStart);
      }
      this.setSchedulePosition(t, i);
    }
  }
  setScheduleToAssetAtTime(e, t) {
    const r = this.schedule;
    if (!r)
      return;
    const i = t.parentIdentifier, s = r.getEvent(i);
    if (s) {
      const o = r.findEventIndex(i), a = r.findAssetIndex(s, e);
      this.advanceAfterAssetEnded(s, o, a - 1);
    }
  }
  setSchedulePosition(e, t) {
    var r;
    const i = (r = this.schedule) == null ? void 0 : r.items;
    if (!i || this.playbackDisabled)
      return;
    const s = e >= 0 ? i[e] : null;
    this.log(`setSchedulePosition ${e}, ${t} (${s && Js(s)}) pos: ${this.timelinePos}`);
    const o = this.waitingItem || this.playingItem, a = this.playingLastItem;
    if (this.isInterstitial(o)) {
      const u = o.event, d = this.playingAsset, f = d?.identifier, h = f ? this.getAssetPlayer(f) : null;
      if (h && f && (!this.eventItemsMatch(o, s) || t !== void 0 && f !== u.assetList[t].identifier)) {
        var l;
        const m = u.findAssetIndex(d);
        if (this.log(`INTERSTITIAL_ASSET_ENDED ${m + 1}/${u.assetList.length} ${Ld(d)}`), this.endedAsset = d, this.playingAsset = null, this.hls.trigger(N.INTERSTITIAL_ASSET_ENDED, {
          asset: d,
          assetListIndex: m,
          event: u,
          schedule: i.slice(0),
          scheduleIndex: e,
          player: h
        }), o !== this.playingItem) {
          this.itemsMatch(o, this.playingItem) && // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          !this.playingAsset && this.advanceAfterAssetEnded(u, this.findItemIndex(this.playingItem), m);
          return;
        }
        this.retreiveMediaSource(f, s), h.media && !((l = this.detachedData) != null && l.mediaSource) && h.detachMedia();
      }
      if (!this.eventItemsMatch(o, s) && (this.endedItem = o, this.playingItem = null, this.log(`INTERSTITIAL_ENDED ${u} ${Js(o)}`), u.hasPlayed = !0, this.hls.trigger(N.INTERSTITIAL_ENDED, {
        event: u,
        schedule: i.slice(0),
        scheduleIndex: e
      }), u.cue.once)) {
        var c;
        this.updateSchedule();
        const m = (c = this.schedule) == null ? void 0 : c.items;
        if (s && m) {
          const g = this.findItemIndex(s);
          this.advanceSchedule(g, m, t, o, a);
        }
        return;
      }
    }
    this.advanceSchedule(e, i, t, o, a);
  }
  advanceSchedule(e, t, r, i, s) {
    const o = this.schedule;
    if (!o)
      return;
    const a = t[e] || null, l = this.primaryMedia, c = this.playerQueue;
    if (c.length && c.forEach((u) => {
      const d = u.interstitial, f = o.findEventIndex(d.identifier);
      (f < e || f > e + 1) && this.clearInterstitial(d, a);
    }), this.isInterstitial(a)) {
      this.timelinePos = Math.min(Math.max(this.timelinePos, a.start), a.end);
      const u = a.event;
      if (r === void 0) {
        r = o.findAssetIndex(u, this.timelinePos);
        const m = P6(u, r - 1);
        if (u.isAssetPastPlayoutLimit(m) || u.appendInPlace && this.timelinePos === a.end) {
          this.advanceAfterAssetEnded(u, e, r);
          return;
        }
        r = m;
      }
      const d = this.waitingItem;
      this.assetsBuffered(a, l) || this.setBufferingItem(a);
      let f = this.preloadAssets(u, r);
      if (this.eventItemsMatch(a, d || i) || (this.waitingItem = a, this.log(`INTERSTITIAL_STARTED ${Js(a)} ${u.appendInPlace ? "append in place" : ""}`), this.hls.trigger(N.INTERSTITIAL_STARTED, {
        event: u,
        schedule: t.slice(0),
        scheduleIndex: e
      })), !u.assetListLoaded) {
        this.log(`Waiting for ASSET-LIST to complete loading ${u}`);
        return;
      }
      if (u.assetListLoader && (u.assetListLoader.destroy(), u.assetListLoader = void 0), !l) {
        this.log(`Waiting for attachMedia to start Interstitial ${u}`);
        return;
      }
      this.waitingItem = this.endedItem = null, this.playingItem = a;
      const h = u.assetList[r];
      if (!h) {
        this.advanceAfterAssetEnded(u, e, r || 0);
        return;
      }
      if (f || (f = this.getAssetPlayer(h.identifier)), f === null || f.destroyed) {
        const m = u.assetList.length;
        this.warn(`asset ${r + 1}/${m} player destroyed ${u}`), f = this.createAssetPlayer(u, h, r), f.loadSource();
      }
      if (!this.eventItemsMatch(a, this.bufferingItem) && u.appendInPlace && this.isAssetBuffered(h))
        return;
      this.startAssetPlayer(f, r, t, e, l), this.shouldPlay && RH(f.media);
    } else a ? (this.resumePrimary(a, e, i), this.shouldPlay && RH(this.hls.media)) : s && this.isInterstitial(i) && (this.endedItem = null, this.playingItem = i, i.event.appendInPlace || this.attachPrimary(o.durations.primary, null));
  }
  get playbackDisabled() {
    return this.hls.config.enableInterstitialPlayback === !1;
  }
  get primaryDetails() {
    var e;
    return (e = this.mediaSelection) == null ? void 0 : e.main.details;
  }
  get primaryLive() {
    var e;
    return !!((e = this.primaryDetails) != null && e.live);
  }
  resumePrimary(e, t, r) {
    var i, s;
    if (this.playingItem = e, this.playingAsset = this.endedAsset = null, this.waitingItem = this.endedItem = null, this.bufferedToItem(e), this.log(`resuming ${Js(e)}`), !((i = this.detachedData) != null && i.mediaSource)) {
      let a = this.timelinePos;
      (a < e.start || a >= e.end) && (a = this.getPrimaryResumption(e, t), this.log(zg("resumePrimary", a)), this.timelinePos = a), this.attachPrimary(a, e);
    }
    if (!r)
      return;
    const o = (s = this.schedule) == null ? void 0 : s.items;
    o && (this.log(`INTERSTITIALS_PRIMARY_RESUMED ${Js(e)}`), this.hls.trigger(N.INTERSTITIALS_PRIMARY_RESUMED, {
      schedule: o.slice(0),
      scheduleIndex: t
    }), this.checkBuffer());
  }
  getPrimaryResumption(e, t) {
    const r = e.start;
    if (this.primaryLive) {
      const i = this.primaryDetails;
      if (t === 0)
        return this.hls.startPosition;
      if (i && (r < i.fragmentStart || r > i.edge))
        return this.hls.liveSyncPosition || -1;
    }
    return r;
  }
  isAssetBuffered(e) {
    const t = this.getAssetPlayer(e.identifier);
    return t != null && t.hls ? t.hls.bufferedToEnd : St.bufferInfo(this.primaryMedia, this.timelinePos, 0).end + 1 >= e.timelineStart + (e.duration || 0);
  }
  attachPrimary(e, t, r) {
    t ? this.setBufferingItem(t) : this.bufferingItem = this.playingItem, this.bufferingAsset = null;
    const i = this.primaryMedia;
    if (!i)
      return;
    const s = this.hls;
    s.media ? this.checkBuffer() : (this.transferMediaTo(s, i), r && this.startLoadingPrimaryAt(e, r)), r || (this.log(zg("attachPrimary", e)), this.timelinePos = e, this.startLoadingPrimaryAt(e, r));
  }
  startLoadingPrimaryAt(e, t) {
    var r;
    const i = this.hls;
    !i.loadingEnabled || !i.media || Math.abs((((r = i.mainForwardBufferInfo) == null ? void 0 : r.start) || i.media.currentTime) - e) > 0.5 ? i.startLoad(e, t) : i.bufferingEnabled || i.resumeBuffering();
  }
  // HLS.js event callbacks
  onManifestLoading() {
    var e;
    this.stopLoad(), (e = this.schedule) == null || e.reset(), this.emptyPlayerQueue(), this.clearScheduleState(), this.shouldPlay = !1, this.bufferedPos = this.timelinePos = -1, this.mediaSelection = this.altSelection = this.manager = this.requiredTracks = null, this.hls.off(N.BUFFER_CODECS, this.onBufferCodecs, this), this.hls.on(N.BUFFER_CODECS, this.onBufferCodecs, this);
  }
  onLevelUpdated(e, t) {
    if (t.level === -1 || !this.schedule)
      return;
    const r = this.hls.levels[t.level];
    if (!r.details)
      return;
    const i = cn(cn({}, this.mediaSelection || this.altSelection), {}, {
      main: r
    });
    this.mediaSelection = i, this.schedule.parseInterstitialDateRanges(i, this.hls.config.interstitialAppendInPlace), !this.effectivePlayingItem && this.schedule.items && this.checkStart();
  }
  onAudioTrackUpdated(e, t) {
    const r = this.hls.audioTracks[t.id], i = this.mediaSelection;
    if (!i) {
      this.altSelection = cn(cn({}, this.altSelection), {}, {
        audio: r
      });
      return;
    }
    const s = cn(cn({}, i), {}, {
      audio: r
    });
    this.mediaSelection = s;
  }
  onSubtitleTrackUpdated(e, t) {
    const r = this.hls.subtitleTracks[t.id], i = this.mediaSelection;
    if (!i) {
      this.altSelection = cn(cn({}, this.altSelection), {}, {
        subtitles: r
      });
      return;
    }
    const s = cn(cn({}, i), {}, {
      subtitles: r
    });
    this.mediaSelection = s;
  }
  onAudioTrackSwitching(e, t) {
    const r = Hz(t);
    this.playerQueue.forEach(({
      hls: i
    }) => i && (i.setAudioOption(t) || i.setAudioOption(r)));
  }
  onSubtitleTrackSwitch(e, t) {
    const r = Hz(t);
    this.playerQueue.forEach(({
      hls: i
    }) => i && (i.setSubtitleOption(t) || t.id !== -1 && i.setSubtitleOption(r)));
  }
  onBufferCodecs(e, t) {
    const r = t.tracks;
    r && (this.requiredTracks = r);
  }
  onBufferAppended(e, t) {
    this.checkBuffer();
  }
  onBufferFlushed(e, t) {
    const r = this.playingItem;
    if (r && !this.itemsMatch(r, this.bufferingItem) && !this.isInterstitial(r)) {
      const i = this.timelinePos;
      this.bufferedPos = i, this.checkBuffer();
    }
  }
  onBufferedToEnd(e) {
    if (!this.schedule)
      return;
    const t = this.schedule.events;
    if (this.bufferedPos < Number.MAX_VALUE && t) {
      for (let i = 0; i < t.length; i++) {
        const s = t[i];
        if (s.cue.post) {
          var r;
          const o = this.schedule.findEventIndex(s.identifier), a = (r = this.schedule.items) == null ? void 0 : r[o];
          this.isInterstitial(a) && this.eventItemsMatch(a, this.bufferingItem) && this.bufferedToItem(a, 0);
          break;
        }
      }
      this.bufferedPos = Number.MAX_VALUE;
    }
  }
  onMediaEnded(e) {
    const t = this.playingItem;
    if (!this.playingLastItem && t) {
      const r = this.findItemIndex(t);
      this.setSchedulePosition(r + 1);
    } else
      this.shouldPlay = !1;
  }
  updateItem(e, t) {
    var r;
    const i = (r = this.schedule) == null ? void 0 : r.items;
    if (e && i) {
      const s = this.findItemIndex(e, t);
      return i[s] || null;
    }
    return null;
  }
  trimInPlace(e, t) {
    if (this.isInterstitial(e) && e.event.appendInPlace && t.end - e.end > 0.25) {
      e.event.assetList.forEach((s, o) => {
        e.event.isAssetPastPlayoutLimit(o) && this.clearAssetPlayer(s.identifier, null);
      });
      const r = e.end + 0.25, i = St.bufferInfo(this.primaryMedia, r, 0);
      (i.end > r || (i.nextStart || 0) > r) && (this.log(`trim buffered interstitial ${Js(e)} (was ${Js(t)})`), this.attachPrimary(r, null, !0), this.flushFrontBuffer(r));
    }
  }
  itemsMatch(e, t) {
    return !!t && (e === t || e.event && t.event && this.eventItemsMatch(e, t) || !e.event && !t.event && this.findItemIndex(e) === this.findItemIndex(t));
  }
  eventItemsMatch(e, t) {
    var r;
    return !!t && (e === t || e.event.identifier === ((r = t.event) == null ? void 0 : r.identifier));
  }
  findItemIndex(e, t) {
    return e && this.schedule ? this.schedule.findItemIndex(e, t) : -1;
  }
  updateSchedule(e = !1) {
    var t;
    const r = this.mediaSelection;
    r && ((t = this.schedule) == null || t.updateSchedule(r, [], e));
  }
  // Schedule buffer control
  checkBuffer(e) {
    var t;
    const r = (t = this.schedule) == null ? void 0 : t.items;
    if (!r)
      return;
    const i = St.bufferInfo(this.primaryMedia, this.timelinePos, 0);
    e && (this.bufferedPos = this.timelinePos), e || (e = i.len < 1), this.updateBufferedPos(i.end, r, e);
  }
  updateBufferedPos(e, t, r) {
    const i = this.schedule, s = this.bufferingItem;
    if (this.bufferedPos > e || !i)
      return;
    if (t.length === 1 && this.itemsMatch(t[0], s)) {
      this.bufferedPos = e;
      return;
    }
    const o = this.playingItem, a = this.findItemIndex(o);
    let l = i.findItemIndexAtTime(e);
    if (this.bufferedPos < e) {
      var c;
      const u = this.findItemIndex(s), d = Math.min(u + 1, t.length - 1), f = t[d];
      if ((l === -1 && s && e >= s.end || (c = f.event) != null && c.appendInPlace && e + 0.01 >= f.start) && (l = d), this.isInterstitial(s)) {
        const h = s.event;
        if (d - a > 1 && h.appendInPlace === !1 || h.assetList.length === 0 && h.assetListLoader)
          return;
      }
      if (this.bufferedPos = e, l > u && l > a)
        this.bufferedToItem(f);
      else {
        const h = this.primaryDetails;
        this.primaryLive && h && e > h.edge - h.targetduration && f.start < h.edge + this.hls.config.interstitialLiveLookAhead && this.isInterstitial(f) && this.preloadAssets(f.event, 0);
      }
    } else r && o && !this.itemsMatch(o, s) && (l === a ? this.bufferedToItem(o) : l === a + 1 && this.bufferedToItem(t[l]));
  }
  assetsBuffered(e, t) {
    return e.event.assetList.length === 0 ? !1 : !e.event.assetList.some((i) => {
      const s = this.getAssetPlayer(i.identifier);
      return !(s != null && s.bufferedInPlaceToEnd(t));
    });
  }
  setBufferingItem(e) {
    const t = this.bufferingItem, r = this.schedule;
    if (!this.itemsMatch(e, t) && r) {
      const {
        items: i,
        events: s
      } = r;
      if (!i || !s)
        return t;
      const o = this.isInterstitial(e), a = this.getBufferingPlayer();
      this.bufferingItem = e, this.bufferedPos = Math.max(e.start, Math.min(e.end, this.timelinePos));
      const l = a ? a.remaining : t ? t.end - this.timelinePos : 0;
      if (this.log(`INTERSTITIALS_BUFFERED_TO_BOUNDARY ${Js(e)}` + (t ? ` (${l.toFixed(2)} remaining)` : "")), !this.playbackDisabled)
        if (o) {
          const c = r.findAssetIndex(e.event, this.bufferedPos);
          e.event.assetList.forEach((u, d) => {
            const f = this.getAssetPlayer(u.identifier);
            f && (d === c && f.loadSource(), f.resumeBuffering());
          });
        } else
          this.hls.resumeBuffering(), this.playerQueue.forEach((c) => c.pauseBuffering());
      this.hls.trigger(N.INTERSTITIALS_BUFFERED_TO_BOUNDARY, {
        events: s.slice(0),
        schedule: i.slice(0),
        bufferingIndex: this.findItemIndex(e),
        playingIndex: this.findItemIndex(this.playingItem)
      });
    } else this.bufferingItem !== e && (this.bufferingItem = e);
    return t;
  }
  bufferedToItem(e, t = 0) {
    const r = this.setBufferingItem(e);
    if (!this.playbackDisabled) {
      if (this.isInterstitial(e))
        this.bufferedToEvent(e, t);
      else if (r !== null) {
        this.bufferingAsset = null;
        const i = this.detachedData;
        i ? i.mediaSource ? this.attachPrimary(e.start, e, !0) : this.preloadPrimary(e) : this.preloadPrimary(e);
      }
    }
  }
  preloadPrimary(e) {
    const t = this.findItemIndex(e), r = this.getPrimaryResumption(e, t);
    this.startLoadingPrimaryAt(r);
  }
  bufferedToEvent(e, t) {
    const r = e.event, i = r.assetList.length === 0 && !r.assetListLoader, s = r.cue.once;
    if (i || !s) {
      const o = this.preloadAssets(r, t);
      if (o != null && o.interstitial.appendInPlace) {
        const a = this.primaryMedia;
        a && this.bufferAssetPlayer(o, a);
      }
    }
  }
  preloadAssets(e, t) {
    const r = e.assetUrl, i = e.assetList.length, s = i === 0 && !e.assetListLoader, o = e.cue.once;
    if (s) {
      const l = e.timelineStart;
      if (e.appendInPlace) {
        var a;
        const f = this.playingItem;
        !this.isInterstitial(f) && (f == null || (a = f.nextEvent) == null ? void 0 : a.identifier) === e.identifier && this.flushFrontBuffer(l + 0.25);
      }
      let c, u = 0;
      if (!this.playingItem && this.primaryLive && (u = this.hls.startPosition, u === -1 && (u = this.hls.liveSyncPosition || 0)), u && !(e.cue.pre || e.cue.post)) {
        const f = u - l;
        f > 0 && (c = Math.round(f * 1e3) / 1e3);
      }
      if (this.log(`Load interstitial asset ${t + 1}/${r ? 1 : i} ${e}${c ? ` live-start: ${u} start-offset: ${c}` : ""}`), r)
        return this.createAsset(e, 0, 0, l, e.duration, r);
      const d = this.assetListLoader.loadAssetList(e, c);
      d && (e.assetListLoader = d);
    } else if (!o && i) {
      for (let c = t; c < i; c++) {
        const u = e.assetList[c], d = this.getAssetPlayerQueueIndex(u.identifier);
        (d === -1 || this.playerQueue[d].destroyed) && !u.error && this.createAssetPlayer(e, u, c);
      }
      const l = e.assetList[t];
      if (l) {
        const c = this.getAssetPlayer(l.identifier);
        return c && c.loadSource(), c;
      }
    }
    return null;
  }
  flushFrontBuffer(e) {
    const t = this.requiredTracks;
    if (!t)
      return;
    this.log(`Removing front buffer starting at ${e}`), Object.keys(t).forEach((i) => {
      this.hls.trigger(N.BUFFER_FLUSHING, {
        startOffset: e,
        endOffset: 1 / 0,
        type: i
      });
    });
  }
  // Interstitial Asset Player control
  getAssetPlayerQueueIndex(e) {
    const t = this.playerQueue;
    for (let r = 0; r < t.length; r++)
      if (e === t[r].assetId)
        return r;
    return -1;
  }
  getAssetPlayer(e) {
    const t = this.getAssetPlayerQueueIndex(e);
    return this.playerQueue[t] || null;
  }
  getBufferingPlayer() {
    const {
      playerQueue: e,
      primaryMedia: t
    } = this;
    if (t) {
      for (let r = 0; r < e.length; r++)
        if (e[r].media === t)
          return e[r];
    }
    return null;
  }
  createAsset(e, t, r, i, s, o) {
    const a = {
      parentIdentifier: e.identifier,
      identifier: hXe(e, o, t),
      duration: s,
      startOffset: r,
      timelineStart: i,
      uri: o
    };
    return this.createAssetPlayer(e, a, t);
  }
  createAssetPlayer(e, t, r) {
    const i = this.hls, s = i.userConfig;
    let o = s.videoPreference;
    const a = i.loadLevelObj || i.levels[i.currentLevel];
    (o || a) && (o = mn({}, o), a.videoCodec && (o.videoCodec = a.videoCodec), a.videoRange && (o.allowedVideoRanges = [a.videoRange]));
    const l = i.audioTracks[i.audioTrack], c = i.subtitleTracks[i.subtitleTrack];
    let u = 0;
    if (this.primaryLive || e.appendInPlace) {
      const E = this.timelinePos - t.timelineStart;
      if (E > 1) {
        const w = t.duration;
        w && E < w && (u = E);
      }
    }
    const d = t.identifier, f = cn(cn({}, s), {}, {
      maxMaxBufferLength: Math.min(180, i.config.maxMaxBufferLength),
      autoStartLoad: !0,
      startFragPrefetch: !0,
      primarySessionId: i.sessionId,
      assetPlayerId: d,
      abrEwmaDefaultEstimate: i.bandwidthEstimate,
      interstitialsController: void 0,
      startPosition: u,
      liveDurationInfinity: !1,
      testBandwidth: !1,
      videoPreference: o,
      audioPreference: l || s.audioPreference,
      subtitlePreference: c || s.subtitlePreference
    });
    e.appendInPlace && (e.appendInPlaceStarted = !0, t.timelineStart && (f.timelineOffset = t.timelineStart));
    const h = f.cmcd;
    h != null && h.sessionId && h.contentId && (f.cmcd = mn({}, h, {
      contentId: Zp(t.uri)
    })), this.getAssetPlayer(d) && this.warn(`Duplicate date range identifier ${e} and asset ${d}`);
    const m = new gXe(this.HlsPlayerClass, f, e, t);
    this.playerQueue.push(m), e.assetList[r] = t;
    let g = !0;
    const v = (E) => {
      if (E.live) {
        var w;
        const M = new Error(`Interstitials MUST be VOD assets ${e}`), k = {
          fatal: !0,
          type: Je.OTHER_ERROR,
          details: ce.INTERSTITIAL_ASSET_ITEM_ERROR,
          error: M
        }, _ = ((w = this.schedule) == null ? void 0 : w.findEventIndex(e.identifier)) || -1;
        this.handleAssetItemError(k, e, _, r, M.message);
        return;
      }
      const C = E.edge - E.fragmentStart, S = t.duration;
      (g || S === null || C > S) && (g = !1, this.log(`Interstitial asset "${d}" duration change ${S} > ${C}`), t.duration = C, this.updateSchedule());
    };
    m.on(N.LEVEL_UPDATED, (E, {
      details: w
    }) => v(w)), m.on(N.LEVEL_PTS_UPDATED, (E, {
      details: w
    }) => v(w)), m.on(N.EVENT_CUE_ENTER, () => this.onInterstitialCueEnter());
    const y = (E, w) => {
      const C = this.getAssetPlayer(d);
      if (C && w.tracks) {
        C.off(N.BUFFER_CODECS, y), C.tracks = w.tracks;
        const S = this.primaryMedia;
        this.bufferingAsset === C.assetItem && S && !C.media && this.bufferAssetPlayer(C, S);
      }
    };
    m.on(N.BUFFER_CODECS, y);
    const b = () => {
      var E;
      const w = this.getAssetPlayer(d);
      if (this.log(`buffered to end of asset ${w}`), !w || !this.schedule)
        return;
      const C = this.schedule.findEventIndex(e.identifier), S = (E = this.schedule.items) == null ? void 0 : E[C];
      this.isInterstitial(S) && this.advanceAssetBuffering(S, t);
    };
    m.on(N.BUFFERED_TO_END, b);
    const x = (E) => () => {
      if (!this.getAssetPlayer(d) || !this.schedule)
        return;
      this.shouldPlay = !0;
      const C = this.schedule.findEventIndex(e.identifier);
      this.advanceAfterAssetEnded(e, C, E);
    };
    return m.once(N.MEDIA_ENDED, x(r)), m.once(N.PLAYOUT_LIMIT_REACHED, x(1 / 0)), m.on(N.ERROR, (E, w) => {
      if (!this.schedule)
        return;
      const C = this.getAssetPlayer(d);
      if (w.details === ce.BUFFER_STALLED_ERROR) {
        if (C != null && C.appendInPlace) {
          this.handleInPlaceStall(e);
          return;
        }
        this.onTimeupdate(), this.checkBuffer(!0);
        return;
      }
      this.handleAssetItemError(w, e, this.schedule.findEventIndex(e.identifier), r, `Asset player error ${w.error} ${e}`);
    }), m.on(N.DESTROYING, () => {
      if (!this.getAssetPlayer(d) || !this.schedule)
        return;
      const w = new Error(`Asset player destroyed unexpectedly ${d}`), C = {
        fatal: !0,
        type: Je.OTHER_ERROR,
        details: ce.INTERSTITIAL_ASSET_ITEM_ERROR,
        error: w
      };
      this.handleAssetItemError(C, e, this.schedule.findEventIndex(e.identifier), r, w.message);
    }), this.log(`INTERSTITIAL_ASSET_PLAYER_CREATED ${Ld(t)}`), this.hls.trigger(N.INTERSTITIAL_ASSET_PLAYER_CREATED, {
      asset: t,
      assetListIndex: r,
      event: e,
      player: m
    }), m;
  }
  clearInterstitial(e, t) {
    this.clearAssetPlayers(e, t), e.reset();
  }
  clearAssetPlayers(e, t) {
    e.assetList.forEach((r) => {
      this.clearAssetPlayer(r.identifier, t);
    });
  }
  resetAssetPlayer(e) {
    const t = this.getAssetPlayerQueueIndex(e);
    if (t !== -1) {
      this.log(`reset asset player "${e}" after error`);
      const r = this.playerQueue[t];
      this.transferMediaFromPlayer(r, null), r.resetDetails();
    }
  }
  clearAssetPlayer(e, t) {
    const r = this.getAssetPlayerQueueIndex(e);
    if (r !== -1) {
      const i = this.playerQueue[r];
      this.log(`clear ${i} toSegment: ${t && Js(t)}`), this.transferMediaFromPlayer(i, t), this.playerQueue.splice(r, 1), i.destroy();
    }
  }
  emptyPlayerQueue() {
    let e;
    for (; e = this.playerQueue.pop(); )
      e.destroy();
    this.playerQueue = [];
  }
  startAssetPlayer(e, t, r, i, s) {
    const {
      interstitial: o,
      assetItem: a,
      assetId: l
    } = e, c = o.assetList.length, u = this.playingAsset;
    this.endedAsset = null, this.playingAsset = a, (!u || u.identifier !== l) && (u && (this.clearAssetPlayer(u.identifier, r[i]), delete u.error), this.log(`INTERSTITIAL_ASSET_STARTED ${t + 1}/${c} ${Ld(a)}`), this.hls.trigger(N.INTERSTITIAL_ASSET_STARTED, {
      asset: a,
      assetListIndex: t,
      event: o,
      schedule: r.slice(0),
      scheduleIndex: i,
      player: e
    })), this.bufferAssetPlayer(e, s);
  }
  bufferAssetPlayer(e, t) {
    var r, i;
    if (!this.schedule)
      return;
    const {
      interstitial: s,
      assetItem: o
    } = e, a = this.schedule.findEventIndex(s.identifier), l = (r = this.schedule.items) == null ? void 0 : r[a];
    if (!l)
      return;
    e.loadSource(), this.setBufferingItem(l), this.bufferingAsset = o;
    const c = this.getBufferingPlayer();
    if (c === e)
      return;
    const u = s.appendInPlace;
    if (u && c?.interstitial.appendInPlace === !1)
      return;
    const d = c?.tracks || ((i = this.detachedData) == null ? void 0 : i.tracks) || this.requiredTracks;
    if (u && o !== this.playingAsset) {
      if (!e.tracks) {
        this.log(`Waiting for track info before buffering ${e}`);
        return;
      }
      if (d && !Ote(d, e.tracks)) {
        const f = new Error(`Asset ${Ld(o)} SourceBuffer tracks ('${Object.keys(e.tracks)}') are not compatible with primary content tracks ('${Object.keys(d)}')`), h = {
          fatal: !0,
          type: Je.OTHER_ERROR,
          details: ce.INTERSTITIAL_ASSET_ITEM_ERROR,
          error: f
        }, m = s.findAssetIndex(o);
        this.handleAssetItemError(h, s, a, m, f.message);
        return;
      }
    }
    this.transferMediaTo(e, t);
  }
  handleInPlaceStall(e) {
    const t = this.schedule, r = this.primaryMedia;
    if (!t || !r)
      return;
    const i = r.currentTime, s = t.findAssetIndex(e, i), o = e.assetList[s];
    if (o) {
      const a = this.getAssetPlayer(o.identifier);
      if (a) {
        const l = a.currentTime || i - o.timelineStart, c = a.duration - l;
        if (this.warn(`Stalled at ${l} of ${l + c} in ${a} ${e} (media.currentTime: ${i})`), l && (c / r.playbackRate < 0.5 || a.bufferedInPlaceToEnd(r)) && a.hls) {
          const u = t.findEventIndex(e.identifier);
          this.advanceAfterAssetEnded(e, u, s);
        }
      }
    }
  }
  advanceInPlace(e) {
    const t = this.primaryMedia;
    t && t.currentTime < e && (t.currentTime = e);
  }
  handleAssetItemError(e, t, r, i, s) {
    if (e.details === ce.BUFFER_STALLED_ERROR)
      return;
    const o = t.assetList[i] || null;
    if (this.warn(`INTERSTITIAL_ASSET_ERROR ${o && Ld(o)} ${e.error}`), !this.schedule)
      return;
    const a = o?.identifier || "", l = this.getAssetPlayerQueueIndex(a), c = this.playerQueue[l] || null, u = this.schedule.items, d = mn({}, e, {
      fatal: !1,
      errorAction: df(!0),
      asset: o,
      assetListIndex: i,
      event: t,
      schedule: u,
      scheduleIndex: r,
      player: c
    });
    if (this.hls.trigger(N.INTERSTITIAL_ASSET_ERROR, d), !e.fatal)
      return;
    const f = this.playingAsset, h = this.bufferingAsset, m = new Error(s);
    if (o && (this.clearAssetPlayer(a, null), o.error = m), !t.assetList.some((g) => !g.error))
      t.error = m;
    else
      for (let g = i; g < t.assetList.length; g++)
        this.resetAssetPlayer(t.assetList[g].identifier);
    this.updateSchedule(!0), t.error ? this.primaryFallback(t) : f && f.identifier === a ? this.advanceAfterAssetEnded(t, r, i) : h && h.identifier === a && this.isInterstitial(this.bufferingItem) && this.advanceAssetBuffering(this.bufferingItem, h);
  }
  primaryFallback(e) {
    const t = e.timelineStart, r = this.effectivePlayingItem;
    let i = this.timelinePos;
    if (r) {
      this.log(`Fallback to primary from event "${e.identifier}" start: ${t} pos: ${i} playing: ${Js(r)} error: ${e.error}`), i === -1 && (i = this.hls.startPosition);
      const o = this.updateItem(r, i);
      this.itemsMatch(r, o) && this.clearInterstitial(e, null), e.appendInPlace && (this.attachPrimary(t, null), this.flushFrontBuffer(t));
    } else if (i === -1) {
      this.checkStart();
      return;
    }
    if (!this.schedule)
      return;
    const s = this.schedule.findItemIndexAtTime(i);
    this.setSchedulePosition(s);
  }
  // Asset List loading
  onAssetListLoaded(e, t) {
    var r, i;
    const s = t.event, o = s.identifier, a = t.assetListResponse.ASSETS;
    if (!((r = this.schedule) != null && r.hasEvent(o)))
      return;
    const l = s.timelineStart, c = s.duration;
    let u = 0;
    a.forEach((g, v) => {
      const y = parseFloat(g.DURATION);
      this.createAsset(s, v, u, l + u, y, g.URI), u += y;
    }), s.duration = u, this.log(`Loaded asset-list with duration: ${u} (was: ${c}) ${s}`);
    const d = this.waitingItem, f = d?.event.identifier === o;
    this.updateSchedule();
    const h = (i = this.bufferingItem) == null ? void 0 : i.event;
    if (f) {
      var m;
      const g = this.schedule.findEventIndex(o), v = (m = this.schedule.items) == null ? void 0 : m[g];
      if (v) {
        if (!this.playingItem && this.timelinePos > v.end && this.schedule.findItemIndexAtTime(this.timelinePos) !== g) {
          s.error = new Error(`Interstitial ${a.length ? "no longer within playback range" : "asset-list is empty"} ${this.timelinePos} ${s}`), this.log(s.error.message), this.updateSchedule(!0), this.primaryFallback(s);
          return;
        }
        this.setBufferingItem(v);
      }
      this.setSchedulePosition(g);
    } else if (h?.identifier === o) {
      const g = s.assetList[0];
      if (g) {
        const v = this.getAssetPlayer(g.identifier);
        if (h.appendInPlace) {
          const y = this.primaryMedia;
          v && y && this.bufferAssetPlayer(v, y);
        } else v && v.loadSource();
      }
    }
  }
  onError(e, t) {
    if (this.schedule)
      switch (t.details) {
        case ce.ASSET_LIST_PARSING_ERROR:
        case ce.ASSET_LIST_LOAD_ERROR:
        case ce.ASSET_LIST_LOAD_TIMEOUT: {
          const r = t.interstitial;
          r && (this.updateSchedule(!0), this.primaryFallback(r));
          break;
        }
        case ce.BUFFER_STALLED_ERROR: {
          const r = this.endedItem || this.waitingItem || this.playingItem;
          if (this.isInterstitial(r) && r.event.appendInPlace) {
            this.handleInPlaceStall(r.event);
            return;
          }
          this.log(`Primary player stall @${this.timelinePos} bufferedPos: ${this.bufferedPos}`), this.onTimeupdate(), this.checkBuffer(!0);
          break;
        }
      }
  }
}
const PH = 500;
class wXe extends x_ {
  constructor(e, t, r) {
    super(e, t, r, "subtitle-stream-controller", We.SUBTITLE), this.currentTrackId = -1, this.tracksBuffered = [], this.mainDetails = null, this.registerListeners();
  }
  onHandlerDestroying() {
    this.unregisterListeners(), super.onHandlerDestroying(), this.mainDetails = null;
  }
  registerListeners() {
    super.registerListeners();
    const {
      hls: e
    } = this;
    e.on(N.LEVEL_LOADED, this.onLevelLoaded, this), e.on(N.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.on(N.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.on(N.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.on(N.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), e.on(N.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  unregisterListeners() {
    super.unregisterListeners();
    const {
      hls: e
    } = this;
    e.off(N.LEVEL_LOADED, this.onLevelLoaded, this), e.off(N.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.off(N.SUBTITLE_TRACK_SWITCH, this.onSubtitleTrackSwitch, this), e.off(N.SUBTITLE_TRACK_LOADED, this.onSubtitleTrackLoaded, this), e.off(N.SUBTITLE_FRAG_PROCESSED, this.onSubtitleFragProcessed, this), e.off(N.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  startLoad(e, t) {
    this.stopLoad(), this.state = he.IDLE, this.setInterval(PH), this.nextLoadPosition = this.lastCurrentTime = e + this.timelineOffset, this.startPosition = t ? -1 : e, this.tick();
  }
  onManifestLoading() {
    super.onManifestLoading(), this.mainDetails = null;
  }
  onMediaDetaching(e, t) {
    this.tracksBuffered = [], super.onMediaDetaching(e, t);
  }
  onLevelLoaded(e, t) {
    this.mainDetails = t.details;
  }
  onSubtitleFragProcessed(e, t) {
    const {
      frag: r,
      success: i
    } = t;
    if (this.fragContextChanged(r) || (tr(r) && (this.fragPrevious = r), this.state = he.IDLE), !i)
      return;
    const s = this.tracksBuffered[this.currentTrackId];
    if (!s)
      return;
    let o;
    const a = r.start;
    for (let c = 0; c < s.length; c++)
      if (a >= s[c].start && a <= s[c].end) {
        o = s[c];
        break;
      }
    const l = r.start + r.duration;
    o ? o.end = l : (o = {
      start: a,
      end: l
    }, s.push(o)), this.fragmentTracker.fragBuffered(r), this.fragBufferedComplete(r, null), this.media && this.tick();
  }
  onBufferFlushing(e, t) {
    const {
      startOffset: r,
      endOffset: i
    } = t;
    if (r === 0 && i !== Number.POSITIVE_INFINITY) {
      const s = i - 1;
      if (s <= 0)
        return;
      t.endOffsetSubtitles = Math.max(0, s), this.tracksBuffered.forEach((o) => {
        for (let a = 0; a < o.length; ) {
          if (o[a].end <= s) {
            o.shift();
            continue;
          } else if (o[a].start < s)
            o[a].start = s;
          else
            break;
          a++;
        }
      }), this.fragmentTracker.removeFragmentsInRange(r, s, We.SUBTITLE);
    }
  }
  // If something goes wrong, proceed to next frag, if we were processing one.
  onError(e, t) {
    const r = t.frag;
    r?.type === We.SUBTITLE && (t.details === ce.FRAG_GAP && this.fragmentTracker.fragBuffered(r, !0), this.fragCurrent && this.fragCurrent.abortRequests(), this.state !== he.STOPPED && (this.state = he.IDLE));
  }
  // Got all new subtitle levels.
  onSubtitleTracksUpdated(e, {
    subtitleTracks: t
  }) {
    if (this.levels && Pne(this.levels, t)) {
      this.levels = t.map((r) => new E0(r));
      return;
    }
    this.tracksBuffered = [], this.levels = t.map((r) => {
      const i = new E0(r);
      return this.tracksBuffered[i.id] = [], i;
    }), this.fragmentTracker.removeFragmentsInRange(0, Number.POSITIVE_INFINITY, We.SUBTITLE), this.fragPrevious = null, this.mediaBuffer = null;
  }
  onSubtitleTrackSwitch(e, t) {
    var r;
    if (this.currentTrackId = t.id, !((r = this.levels) != null && r.length) || this.currentTrackId === -1) {
      this.clearInterval();
      return;
    }
    const i = this.levels[this.currentTrackId];
    i != null && i.details ? this.mediaBuffer = this.mediaBufferTimeRanges : this.mediaBuffer = null, i && this.state !== he.STOPPED && this.setInterval(PH);
  }
  // Got a new set of subtitle fragments.
  onSubtitleTrackLoaded(e, t) {
    var r;
    const {
      currentTrackId: i,
      levels: s
    } = this, {
      details: o,
      id: a
    } = t;
    if (!s) {
      this.warn(`Subtitle tracks were reset while loading level ${a}`);
      return;
    }
    const l = s[a];
    if (a >= s.length || !l)
      return;
    this.log(`Subtitle track ${a} loaded [${o.startSN},${o.endSN}]${o.lastPartSn ? `[part-${o.lastPartSn}-${o.lastPartIndex}]` : ""},duration:${o.totalduration}`), this.mediaBuffer = this.mediaBufferTimeRanges;
    let c = 0;
    if (o.live || (r = l.details) != null && r.live) {
      if (o.deltaUpdateFailed)
        return;
      const d = this.mainDetails;
      if (!d) {
        this.startFragRequested = !1;
        return;
      }
      const f = d.fragments[0];
      if (!l.details)
        o.hasProgramDateTime && d.hasProgramDateTime ? (Gy(o, d), c = o.fragmentStart) : f && (c = f.start, C7(o, c));
      else {
        var u;
        c = this.alignPlaylists(o, l.details, (u = this.levelLastLoaded) == null ? void 0 : u.details), c === 0 && f && (c = f.start, C7(o, c));
      }
      d && !this.startFragRequested && this.setStartPosition(d, c);
    }
    l.details = o, this.levelLastLoaded = l, a === i && (this.hls.trigger(N.SUBTITLE_TRACK_UPDATED, {
      details: o,
      id: a,
      groupId: t.groupId
    }), this.tick(), o.live && !this.fragCurrent && this.media && this.state === he.IDLE && (Bu(null, o.fragments, this.media.currentTime, 0) || (this.warn("Subtitle playlist not aligned with playback"), l.details = void 0)));
  }
  _handleFragmentLoadComplete(e) {
    const {
      frag: t,
      payload: r
    } = e, i = t.decryptdata, s = this.hls;
    if (!this.fragContextChanged(t) && r && r.byteLength > 0 && i != null && i.key && i.iv && ff(i.method)) {
      const o = performance.now();
      this.decrypter.decrypt(new Uint8Array(r), i.key.buffer, i.iv.buffer, b_(i.method)).catch((a) => {
        throw s.trigger(N.ERROR, {
          type: Je.MEDIA_ERROR,
          details: ce.FRAG_DECRYPT_ERROR,
          fatal: !1,
          error: a,
          reason: a.message,
          frag: t
        }), a;
      }).then((a) => {
        const l = performance.now();
        s.trigger(N.FRAG_DECRYPTED, {
          frag: t,
          payload: a,
          stats: {
            tstart: o,
            tdecrypt: l
          }
        });
      }).catch((a) => {
        this.warn(`${a.name}: ${a.message}`), this.state = he.IDLE;
      });
    }
  }
  doTick() {
    if (!this.media) {
      this.state = he.IDLE;
      return;
    }
    if (this.state === he.IDLE) {
      const {
        currentTrackId: e,
        levels: t
      } = this, r = t?.[e];
      if (!r || !t.length || !r.details || this.waitForLive(r))
        return;
      const {
        config: i
      } = this, s = this.getLoadPosition(), o = St.bufferedInfo(this.tracksBuffered[this.currentTrackId] || [], s, i.maxBufferHole), {
        end: a,
        len: l
      } = o, c = r.details, u = this.hls.maxBufferLength + c.levelTargetDuration;
      if (l > u)
        return;
      const d = c.fragments, f = d.length, h = c.edge;
      let m = null;
      const g = this.fragPrevious;
      if (a < h) {
        const b = i.maxFragLookUpTolerance, x = a > h - b ? 0 : b;
        m = Bu(g, d, Math.max(d[0].start, a), x), !m && g && g.start < d[0].start && (m = d[0]);
      } else
        m = d[f - 1];
      if (m = this.filterReplacedPrimary(m, r.details), !m)
        return;
      const v = m.sn - c.startSN, y = d[v - 1];
      if (y && y.cc === m.cc && this.fragmentTracker.getState(y) === wr.NOT_LOADED && (m = y), this.fragmentTracker.getState(m) === wr.NOT_LOADED) {
        const b = this.mapToInitFragWhenRequired(m);
        b && this.loadFragment(b, r, a);
      }
    }
  }
  loadFragment(e, t, r) {
    tr(e) ? super.loadFragment(e, t, r) : this._loadInitSegment(e, t);
  }
  get mediaBufferTimeRanges() {
    return new xXe(this.tracksBuffered[this.currentTrackId] || []);
  }
}
class xXe {
  constructor(e) {
    this.buffered = void 0;
    const t = (r, i, s) => {
      if (i = i >>> 0, i > s - 1)
        throw new DOMException(`Failed to execute '${r}' on 'TimeRanges': The index provided (${i}) is greater than the maximum bound (${s})`);
      return e[i][r];
    };
    this.buffered = {
      get length() {
        return e.length;
      },
      end(r) {
        return t("end", r, e.length);
      },
      start(r) {
        return t("start", r, e.length);
      }
    };
  }
}
const EXe = {
  42: 225,
  // lowercase a, acute accent
  92: 233,
  // lowercase e, acute accent
  94: 237,
  // lowercase i, acute accent
  95: 243,
  // lowercase o, acute accent
  96: 250,
  // lowercase u, acute accent
  123: 231,
  // lowercase c with cedilla
  124: 247,
  // division symbol
  125: 209,
  // uppercase N tilde
  126: 241,
  // lowercase n tilde
  127: 9608,
  // Full block
  // THIS BLOCK INCLUDES THE 16 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x11 AND LOW BETWEEN 0x30 AND 0x3F
  // THIS MEANS THAT \x50 MUST BE ADDED TO THE VALUES
  128: 174,
  // Registered symbol (R)
  129: 176,
  // degree sign
  130: 189,
  // 1/2 symbol
  131: 191,
  // Inverted (open) question mark
  132: 8482,
  // Trademark symbol (TM)
  133: 162,
  // Cents symbol
  134: 163,
  // Pounds sterling
  135: 9834,
  // Music 8'th note
  136: 224,
  // lowercase a, grave accent
  137: 32,
  // transparent space (regular)
  138: 232,
  // lowercase e, grave accent
  139: 226,
  // lowercase a, circumflex accent
  140: 234,
  // lowercase e, circumflex accent
  141: 238,
  // lowercase i, circumflex accent
  142: 244,
  // lowercase o, circumflex accent
  143: 251,
  // lowercase u, circumflex accent
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x12 AND LOW BETWEEN 0x20 AND 0x3F
  144: 193,
  // capital letter A with acute
  145: 201,
  // capital letter E with acute
  146: 211,
  // capital letter O with acute
  147: 218,
  // capital letter U with acute
  148: 220,
  // capital letter U with diaresis
  149: 252,
  // lowercase letter U with diaeresis
  150: 8216,
  // opening single quote
  151: 161,
  // inverted exclamation mark
  152: 42,
  // asterisk
  153: 8217,
  // closing single quote
  154: 9473,
  // box drawings heavy horizontal
  155: 169,
  // copyright sign
  156: 8480,
  // Service mark
  157: 8226,
  // (round) bullet
  158: 8220,
  // Left double quotation mark
  159: 8221,
  // Right double quotation mark
  160: 192,
  // uppercase A, grave accent
  161: 194,
  // uppercase A, circumflex
  162: 199,
  // uppercase C with cedilla
  163: 200,
  // uppercase E, grave accent
  164: 202,
  // uppercase E, circumflex
  165: 203,
  // capital letter E with diaresis
  166: 235,
  // lowercase letter e with diaresis
  167: 206,
  // uppercase I, circumflex
  168: 207,
  // uppercase I, with diaresis
  169: 239,
  // lowercase i, with diaresis
  170: 212,
  // uppercase O, circumflex
  171: 217,
  // uppercase U, grave accent
  172: 249,
  // lowercase u, grave accent
  173: 219,
  // uppercase U, circumflex
  174: 171,
  // left-pointing double angle quotation mark
  175: 187,
  // right-pointing double angle quotation mark
  // THIS BLOCK INCLUDES THE 32 EXTENDED (TWO-BYTE) LINE 21 CHARACTERS
  // THAT COME FROM HI BYTE=0x13 AND LOW BETWEEN 0x20 AND 0x3F
  176: 195,
  // Uppercase A, tilde
  177: 227,
  // Lowercase a, tilde
  178: 205,
  // Uppercase I, acute accent
  179: 204,
  // Uppercase I, grave accent
  180: 236,
  // Lowercase i, grave accent
  181: 210,
  // Uppercase O, grave accent
  182: 242,
  // Lowercase o, grave accent
  183: 213,
  // Uppercase O, tilde
  184: 245,
  // Lowercase o, tilde
  185: 123,
  // Open curly brace
  186: 125,
  // Closing curly brace
  187: 92,
  // Backslash
  188: 94,
  // Caret
  189: 95,
  // Underscore
  190: 124,
  // Pipe (vertical line)
  191: 8764,
  // Tilde operator
  192: 196,
  // Uppercase A, umlaut
  193: 228,
  // Lowercase A, umlaut
  194: 214,
  // Uppercase O, umlaut
  195: 246,
  // Lowercase o, umlaut
  196: 223,
  // Esszett (sharp S)
  197: 165,
  // Yen symbol
  198: 164,
  // Generic currency sign
  199: 9475,
  // Box drawings heavy vertical
  200: 197,
  // Uppercase A, ring
  201: 229,
  // Lowercase A, ring
  202: 216,
  // Uppercase O, stroke
  203: 248,
  // Lowercase o, strok
  204: 9487,
  // Box drawings heavy down and right
  205: 9491,
  // Box drawings heavy down and left
  206: 9495,
  // Box drawings heavy up and right
  207: 9499
  // Box drawings heavy up and left
}, Yne = (n) => String.fromCharCode(EXe[n] || n), no = 15, Da = 100, SXe = {
  17: 1,
  18: 3,
  21: 5,
  22: 7,
  23: 9,
  16: 11,
  19: 12,
  20: 14
}, CXe = {
  17: 2,
  18: 4,
  21: 6,
  22: 8,
  23: 10,
  19: 13,
  20: 15
}, TXe = {
  25: 1,
  26: 3,
  29: 5,
  30: 7,
  31: 9,
  24: 11,
  27: 12,
  28: 14
}, AXe = {
  25: 2,
  26: 4,
  29: 6,
  30: 8,
  31: 10,
  27: 13,
  28: 15
}, MXe = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "black", "transparent"];
class kXe {
  constructor() {
    this.time = null, this.verboseLevel = 0;
  }
  log(e, t) {
    if (this.verboseLevel >= e) {
      const r = typeof t == "function" ? t() : t;
      un.log(`${this.time} [${e}] ${r}`);
    }
  }
}
const Wc = function(e) {
  const t = [];
  for (let r = 0; r < e.length; r++)
    t.push(e[r].toString(16));
  return t;
};
class Xne {
  constructor() {
    this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
  }
  reset() {
    this.foreground = "white", this.underline = !1, this.italics = !1, this.background = "black", this.flash = !1;
  }
  setStyles(e) {
    const t = ["foreground", "underline", "italics", "background", "flash"];
    for (let r = 0; r < t.length; r++) {
      const i = t[r];
      e.hasOwnProperty(i) && (this[i] = e[i]);
    }
  }
  isDefault() {
    return this.foreground === "white" && !this.underline && !this.italics && this.background === "black" && !this.flash;
  }
  equals(e) {
    return this.foreground === e.foreground && this.underline === e.underline && this.italics === e.italics && this.background === e.background && this.flash === e.flash;
  }
  copy(e) {
    this.foreground = e.foreground, this.underline = e.underline, this.italics = e.italics, this.background = e.background, this.flash = e.flash;
  }
  toString() {
    return "color=" + this.foreground + ", underline=" + this.underline + ", italics=" + this.italics + ", background=" + this.background + ", flash=" + this.flash;
  }
}
class _Xe {
  constructor() {
    this.uchar = " ", this.penState = new Xne();
  }
  reset() {
    this.uchar = " ", this.penState.reset();
  }
  setChar(e, t) {
    this.uchar = e, this.penState.copy(t);
  }
  setPenState(e) {
    this.penState.copy(e);
  }
  equals(e) {
    return this.uchar === e.uchar && this.penState.equals(e.penState);
  }
  copy(e) {
    this.uchar = e.uchar, this.penState.copy(e.penState);
  }
  isEmpty() {
    return this.uchar === " " && this.penState.isDefault();
  }
}
class OXe {
  constructor(e) {
    this.chars = [], this.pos = 0, this.currPenState = new Xne(), this.cueStartTime = null, this.logger = void 0;
    for (let t = 0; t < Da; t++)
      this.chars.push(new _Xe());
    this.logger = e;
  }
  equals(e) {
    for (let t = 0; t < Da; t++)
      if (!this.chars[t].equals(e.chars[t]))
        return !1;
    return !0;
  }
  copy(e) {
    for (let t = 0; t < Da; t++)
      this.chars[t].copy(e.chars[t]);
  }
  isEmpty() {
    let e = !0;
    for (let t = 0; t < Da; t++)
      if (!this.chars[t].isEmpty()) {
        e = !1;
        break;
      }
    return e;
  }
  /**
   *  Set the cursor to a valid column.
   */
  setCursor(e) {
    this.pos !== e && (this.pos = e), this.pos < 0 ? (this.logger.log(3, "Negative cursor position " + this.pos), this.pos = 0) : this.pos > Da && (this.logger.log(3, "Too large cursor position " + this.pos), this.pos = Da);
  }
  /**
   * Move the cursor relative to current position.
   */
  moveCursor(e) {
    const t = this.pos + e;
    if (e > 1)
      for (let r = this.pos + 1; r < t + 1; r++)
        this.chars[r].setPenState(this.currPenState);
    this.setCursor(t);
  }
  /**
   * Backspace, move one step back and clear character.
   */
  backSpace() {
    this.moveCursor(-1), this.chars[this.pos].setChar(" ", this.currPenState);
  }
  insertChar(e) {
    e >= 144 && this.backSpace();
    const t = Yne(e);
    if (this.pos >= Da) {
      this.logger.log(0, () => "Cannot insert " + e.toString(16) + " (" + t + ") at position " + this.pos + ". Skipping it!");
      return;
    }
    this.chars[this.pos].setChar(t, this.currPenState), this.moveCursor(1);
  }
  clearFromPos(e) {
    let t;
    for (t = e; t < Da; t++)
      this.chars[t].reset();
  }
  clear() {
    this.clearFromPos(0), this.pos = 0, this.currPenState.reset();
  }
  clearToEndOfRow() {
    this.clearFromPos(this.pos);
  }
  getTextString() {
    const e = [];
    let t = !0;
    for (let r = 0; r < Da; r++) {
      const i = this.chars[r].uchar;
      i !== " " && (t = !1), e.push(i);
    }
    return t ? "" : e.join("");
  }
  setPenStyles(e) {
    this.currPenState.setStyles(e), this.chars[this.pos].setPenState(this.currPenState);
  }
}
class D6 {
  constructor(e) {
    this.rows = [], this.currRow = no - 1, this.nrRollUpRows = null, this.lastOutputScreen = null, this.logger = void 0;
    for (let t = 0; t < no; t++)
      this.rows.push(new OXe(e));
    this.logger = e;
  }
  reset() {
    for (let e = 0; e < no; e++)
      this.rows[e].clear();
    this.currRow = no - 1;
  }
  equals(e) {
    let t = !0;
    for (let r = 0; r < no; r++)
      if (!this.rows[r].equals(e.rows[r])) {
        t = !1;
        break;
      }
    return t;
  }
  copy(e) {
    for (let t = 0; t < no; t++)
      this.rows[t].copy(e.rows[t]);
  }
  isEmpty() {
    let e = !0;
    for (let t = 0; t < no; t++)
      if (!this.rows[t].isEmpty()) {
        e = !1;
        break;
      }
    return e;
  }
  backSpace() {
    this.rows[this.currRow].backSpace();
  }
  clearToEndOfRow() {
    this.rows[this.currRow].clearToEndOfRow();
  }
  /**
   * Insert a character (without styling) in the current row.
   */
  insertChar(e) {
    this.rows[this.currRow].insertChar(e);
  }
  setPen(e) {
    this.rows[this.currRow].setPenStyles(e);
  }
  moveCursor(e) {
    this.rows[this.currRow].moveCursor(e);
  }
  setCursor(e) {
    this.logger.log(2, "setCursor: " + e), this.rows[this.currRow].setCursor(e);
  }
  setPAC(e) {
    this.logger.log(2, () => "pacData = " + Sn(e));
    let t = e.row - 1;
    if (this.nrRollUpRows && t < this.nrRollUpRows - 1 && (t = this.nrRollUpRows - 1), this.nrRollUpRows && this.currRow !== t) {
      for (let a = 0; a < no; a++)
        this.rows[a].clear();
      const s = this.currRow + 1 - this.nrRollUpRows, o = this.lastOutputScreen;
      if (o) {
        const a = o.rows[s].cueStartTime, l = this.logger.time;
        if (a !== null && l !== null && a < l)
          for (let c = 0; c < this.nrRollUpRows; c++)
            this.rows[t - this.nrRollUpRows + c + 1].copy(o.rows[s + c]);
      }
    }
    this.currRow = t;
    const r = this.rows[this.currRow];
    if (e.indent !== null) {
      const s = e.indent, o = Math.max(s - 1, 0);
      r.setCursor(e.indent), e.color = r.chars[o].penState.foreground;
    }
    const i = {
      foreground: e.color,
      underline: e.underline,
      italics: e.italics,
      background: "black",
      flash: !1
    };
    this.setPen(i);
  }
  /**
   * Set background/extra foreground, but first do back_space, and then insert space (backwards compatibility).
   */
  setBkgData(e) {
    this.logger.log(2, () => "bkgData = " + Sn(e)), this.backSpace(), this.setPen(e), this.insertChar(32);
  }
  setRollUpRows(e) {
    this.nrRollUpRows = e;
  }
  rollUp() {
    if (this.nrRollUpRows === null) {
      this.logger.log(3, "roll_up but nrRollUpRows not set yet");
      return;
    }
    this.logger.log(1, () => this.getDisplayText());
    const e = this.currRow + 1 - this.nrRollUpRows, t = this.rows.splice(e, 1)[0];
    t.clear(), this.rows.splice(this.currRow, 0, t), this.logger.log(2, "Rolling up");
  }
  /**
   * Get all non-empty rows with as unicode text.
   */
  getDisplayText(e) {
    e = e || !1;
    const t = [];
    let r = "", i = -1;
    for (let s = 0; s < no; s++) {
      const o = this.rows[s].getTextString();
      o && (i = s + 1, e ? t.push("Row " + i + ": '" + o + "'") : t.push(o.trim()));
    }
    return t.length > 0 && (e ? r = "[" + t.join(" | ") + "]" : r = t.join(`
`)), r;
  }
  getTextAndFormat() {
    return this.rows;
  }
}
class DH {
  constructor(e, t, r) {
    this.chNr = void 0, this.outputFilter = void 0, this.mode = void 0, this.verbose = void 0, this.displayedMemory = void 0, this.nonDisplayedMemory = void 0, this.lastOutputScreen = void 0, this.currRollUpRow = void 0, this.writeScreen = void 0, this.cueStartTime = void 0, this.logger = void 0, this.chNr = e, this.outputFilter = t, this.mode = null, this.verbose = 0, this.displayedMemory = new D6(r), this.nonDisplayedMemory = new D6(r), this.lastOutputScreen = new D6(r), this.currRollUpRow = this.displayedMemory.rows[no - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null, this.logger = r;
  }
  reset() {
    this.mode = null, this.displayedMemory.reset(), this.nonDisplayedMemory.reset(), this.lastOutputScreen.reset(), this.outputFilter.reset(), this.currRollUpRow = this.displayedMemory.rows[no - 1], this.writeScreen = this.displayedMemory, this.mode = null, this.cueStartTime = null;
  }
  getHandler() {
    return this.outputFilter;
  }
  setHandler(e) {
    this.outputFilter = e;
  }
  setPAC(e) {
    this.writeScreen.setPAC(e);
  }
  setBkgData(e) {
    this.writeScreen.setBkgData(e);
  }
  setMode(e) {
    e !== this.mode && (this.mode = e, this.logger.log(2, () => "MODE=" + e), this.mode === "MODE_POP-ON" ? this.writeScreen = this.nonDisplayedMemory : (this.writeScreen = this.displayedMemory, this.writeScreen.reset()), this.mode !== "MODE_ROLL-UP" && (this.displayedMemory.nrRollUpRows = null, this.nonDisplayedMemory.nrRollUpRows = null), this.mode = e);
  }
  insertChars(e) {
    for (let r = 0; r < e.length; r++)
      this.writeScreen.insertChar(e[r]);
    const t = this.writeScreen === this.displayedMemory ? "DISP" : "NON_DISP";
    this.logger.log(2, () => t + ": " + this.writeScreen.getDisplayText(!0)), (this.mode === "MODE_PAINT-ON" || this.mode === "MODE_ROLL-UP") && (this.logger.log(1, () => "DISPLAYED: " + this.displayedMemory.getDisplayText(!0)), this.outputDataUpdate());
  }
  ccRCL() {
    this.logger.log(2, "RCL - Resume Caption Loading"), this.setMode("MODE_POP-ON");
  }
  ccBS() {
    this.logger.log(2, "BS - BackSpace"), this.mode !== "MODE_TEXT" && (this.writeScreen.backSpace(), this.writeScreen === this.displayedMemory && this.outputDataUpdate());
  }
  ccAOF() {
  }
  ccAON() {
  }
  ccDER() {
    this.logger.log(2, "DER- Delete to End of Row"), this.writeScreen.clearToEndOfRow(), this.outputDataUpdate();
  }
  ccRU(e) {
    this.logger.log(2, "RU(" + e + ") - Roll Up"), this.writeScreen = this.displayedMemory, this.setMode("MODE_ROLL-UP"), this.writeScreen.setRollUpRows(e);
  }
  ccFON() {
    this.logger.log(2, "FON - Flash On"), this.writeScreen.setPen({
      flash: !0
    });
  }
  ccRDC() {
    this.logger.log(2, "RDC - Resume Direct Captioning"), this.setMode("MODE_PAINT-ON");
  }
  ccTR() {
    this.logger.log(2, "TR"), this.setMode("MODE_TEXT");
  }
  ccRTD() {
    this.logger.log(2, "RTD"), this.setMode("MODE_TEXT");
  }
  ccEDM() {
    this.logger.log(2, "EDM - Erase Displayed Memory"), this.displayedMemory.reset(), this.outputDataUpdate(!0);
  }
  ccCR() {
    this.logger.log(2, "CR - Carriage Return"), this.writeScreen.rollUp(), this.outputDataUpdate(!0);
  }
  ccENM() {
    this.logger.log(2, "ENM - Erase Non-displayed Memory"), this.nonDisplayedMemory.reset();
  }
  ccEOC() {
    if (this.logger.log(2, "EOC - End Of Caption"), this.mode === "MODE_POP-ON") {
      const e = this.displayedMemory;
      this.displayedMemory = this.nonDisplayedMemory, this.nonDisplayedMemory = e, this.writeScreen = this.nonDisplayedMemory, this.logger.log(1, () => "DISP: " + this.displayedMemory.getDisplayText());
    }
    this.outputDataUpdate(!0);
  }
  ccTO(e) {
    this.logger.log(2, "TO(" + e + ") - Tab Offset"), this.writeScreen.moveCursor(e);
  }
  ccMIDROW(e) {
    const t = {
      flash: !1
    };
    if (t.underline = e % 2 === 1, t.italics = e >= 46, t.italics)
      t.foreground = "white";
    else {
      const r = Math.floor(e / 2) - 16, i = ["white", "green", "blue", "cyan", "red", "yellow", "magenta"];
      t.foreground = i[r];
    }
    this.logger.log(2, "MIDROW: " + Sn(t)), this.writeScreen.setPen(t);
  }
  outputDataUpdate(e = !1) {
    const t = this.logger.time;
    t !== null && this.outputFilter && (this.cueStartTime === null && !this.displayedMemory.isEmpty() ? this.cueStartTime = t : this.displayedMemory.equals(this.lastOutputScreen) || (this.outputFilter.newCue(this.cueStartTime, t, this.lastOutputScreen), e && this.outputFilter.dispatchCue && this.outputFilter.dispatchCue(), this.cueStartTime = this.displayedMemory.isEmpty() ? null : t), this.lastOutputScreen.copy(this.displayedMemory));
  }
  cueSplitAtTime(e) {
    this.outputFilter && (this.displayedMemory.isEmpty() || (this.outputFilter.newCue && this.outputFilter.newCue(this.cueStartTime, e, this.displayedMemory), this.cueStartTime = e));
  }
}
class NH {
  constructor(e, t, r) {
    this.channels = void 0, this.currentChannel = 0, this.cmdHistory = RXe(), this.logger = void 0;
    const i = this.logger = new kXe();
    this.channels = [null, new DH(e, t, i), new DH(e + 1, r, i)];
  }
  getHandler(e) {
    return this.channels[e].getHandler();
  }
  setHandler(e, t) {
    this.channels[e].setHandler(t);
  }
  /**
   * Add data for time t in forms of list of bytes (unsigned ints). The bytes are treated as pairs.
   */
  addData(e, t) {
    this.logger.time = e;
    for (let r = 0; r < t.length; r += 2) {
      const i = t[r] & 127, s = t[r + 1] & 127;
      let o = !1, a = null;
      if (i === 0 && s === 0)
        continue;
      this.logger.log(3, () => "[" + Wc([t[r], t[r + 1]]) + "] -> (" + Wc([i, s]) + ")");
      const l = this.cmdHistory;
      if (i >= 16 && i <= 31) {
        if (IXe(i, s, l)) {
          Hg(null, null, l), this.logger.log(3, () => "Repeated command (" + Wc([i, s]) + ") is dropped");
          continue;
        }
        Hg(i, s, this.cmdHistory), o = this.parseCmd(i, s), o || (o = this.parseMidrow(i, s)), o || (o = this.parsePAC(i, s)), o || (o = this.parseBackgroundAttributes(i, s));
      } else
        Hg(null, null, l);
      if (!o && (a = this.parseChars(i, s), a)) {
        const u = this.currentChannel;
        u && u > 0 ? this.channels[u].insertChars(a) : this.logger.log(2, "No channel found yet. TEXT-MODE?");
      }
      !o && !a && this.logger.log(2, () => "Couldn't parse cleaned data " + Wc([i, s]) + " orig: " + Wc([t[r], t[r + 1]]));
    }
  }
  /**
   * Parse Command.
   * @returns True if a command was found
   */
  parseCmd(e, t) {
    const r = (e === 20 || e === 28 || e === 21 || e === 29) && t >= 32 && t <= 47, i = (e === 23 || e === 31) && t >= 33 && t <= 35;
    if (!(r || i))
      return !1;
    const s = e === 20 || e === 21 || e === 23 ? 1 : 2, o = this.channels[s];
    return e === 20 || e === 21 || e === 28 || e === 29 ? t === 32 ? o.ccRCL() : t === 33 ? o.ccBS() : t === 34 ? o.ccAOF() : t === 35 ? o.ccAON() : t === 36 ? o.ccDER() : t === 37 ? o.ccRU(2) : t === 38 ? o.ccRU(3) : t === 39 ? o.ccRU(4) : t === 40 ? o.ccFON() : t === 41 ? o.ccRDC() : t === 42 ? o.ccTR() : t === 43 ? o.ccRTD() : t === 44 ? o.ccEDM() : t === 45 ? o.ccCR() : t === 46 ? o.ccENM() : t === 47 && o.ccEOC() : o.ccTO(t - 32), this.currentChannel = s, !0;
  }
  /**
   * Parse midrow styling command
   */
  parseMidrow(e, t) {
    let r = 0;
    if ((e === 17 || e === 25) && t >= 32 && t <= 47) {
      if (e === 17 ? r = 1 : r = 2, r !== this.currentChannel)
        return this.logger.log(0, "Mismatch channel in midrow parsing"), !1;
      const i = this.channels[r];
      return i ? (i.ccMIDROW(t), this.logger.log(3, () => "MIDROW (" + Wc([e, t]) + ")"), !0) : !1;
    }
    return !1;
  }
  /**
   * Parse Preable Access Codes (Table 53).
   * @returns {Boolean} Tells if PAC found
   */
  parsePAC(e, t) {
    let r;
    const i = (e >= 17 && e <= 23 || e >= 25 && e <= 31) && t >= 64 && t <= 127, s = (e === 16 || e === 24) && t >= 64 && t <= 95;
    if (!(i || s))
      return !1;
    const o = e <= 23 ? 1 : 2;
    t >= 64 && t <= 95 ? r = o === 1 ? SXe[e] : TXe[e] : r = o === 1 ? CXe[e] : AXe[e];
    const a = this.channels[o];
    return a ? (a.setPAC(this.interpretPAC(r, t)), this.currentChannel = o, !0) : !1;
  }
  /**
   * Interpret the second byte of the pac, and return the information.
   * @returns pacData with style parameters
   */
  interpretPAC(e, t) {
    let r;
    const i = {
      color: null,
      italics: !1,
      indent: null,
      underline: !1,
      row: e
    };
    return t > 95 ? r = t - 96 : r = t - 64, i.underline = (r & 1) === 1, r <= 13 ? i.color = ["white", "green", "blue", "cyan", "red", "yellow", "magenta", "white"][Math.floor(r / 2)] : r <= 15 ? (i.italics = !0, i.color = "white") : i.indent = Math.floor((r - 16) / 2) * 4, i;
  }
  /**
   * Parse characters.
   * @returns An array with 1 to 2 codes corresponding to chars, if found. null otherwise.
   */
  parseChars(e, t) {
    let r, i = null, s = null;
    if (e >= 25 ? (r = 2, s = e - 8) : (r = 1, s = e), s >= 17 && s <= 19) {
      let o;
      s === 17 ? o = t + 80 : s === 18 ? o = t + 112 : o = t + 144, this.logger.log(2, () => "Special char '" + Yne(o) + "' in channel " + r), i = [o];
    } else e >= 32 && e <= 127 && (i = t === 0 ? [e] : [e, t]);
    return i && this.logger.log(3, () => "Char codes =  " + Wc(i).join(",")), i;
  }
  /**
   * Parse extended background attributes as well as new foreground color black.
   * @returns True if background attributes are found
   */
  parseBackgroundAttributes(e, t) {
    const r = (e === 16 || e === 24) && t >= 32 && t <= 47, i = (e === 23 || e === 31) && t >= 45 && t <= 47;
    if (!(r || i))
      return !1;
    let s;
    const o = {};
    e === 16 || e === 24 ? (s = Math.floor((t - 32) / 2), o.background = MXe[s], t % 2 === 1 && (o.background = o.background + "_semi")) : t === 45 ? o.background = "transparent" : (o.foreground = "black", t === 47 && (o.underline = !0));
    const a = e <= 23 ? 1 : 2;
    return this.channels[a].setBkgData(o), !0;
  }
  /**
   * Reset state of parser and its channels.
   */
  reset() {
    for (let e = 0; e < Object.keys(this.channels).length; e++) {
      const t = this.channels[e];
      t && t.reset();
    }
    Hg(null, null, this.cmdHistory);
  }
  /**
   * Trigger the generation of a cue, and the start of a new one if displayScreens are not empty.
   */
  cueSplitAtTime(e) {
    for (let t = 0; t < this.channels.length; t++) {
      const r = this.channels[t];
      r && r.cueSplitAtTime(e);
    }
  }
}
function Hg(n, e, t) {
  t.a = n, t.b = e;
}
function IXe(n, e, t) {
  return t.a === n && t.b === e;
}
function RXe() {
  return {
    a: null,
    b: null
  };
}
var P_ = (function() {
  if (Wy != null && Wy.VTTCue)
    return self.VTTCue;
  const n = ["", "lr", "rl"], e = ["start", "middle", "end", "left", "right"];
  function t(a, l) {
    if (typeof l != "string" || !Array.isArray(a))
      return !1;
    const c = l.toLowerCase();
    return ~a.indexOf(c) ? c : !1;
  }
  function r(a) {
    return t(n, a);
  }
  function i(a) {
    return t(e, a);
  }
  function s(a, ...l) {
    let c = 1;
    for (; c < arguments.length; c++) {
      const u = arguments[c];
      for (const d in u)
        a[d] = u[d];
    }
    return a;
  }
  function o(a, l, c) {
    const u = this, d = {
      enumerable: !0
    };
    u.hasBeenReset = !1;
    let f = "", h = !1, m = a, g = l, v = c, y = null, b = "", x = !0, E = "auto", w = "start", C = 50, S = "middle", M = 50, k = "middle";
    Object.defineProperty(u, "id", s({}, d, {
      get: function() {
        return f;
      },
      set: function(_) {
        f = "" + _;
      }
    })), Object.defineProperty(u, "pauseOnExit", s({}, d, {
      get: function() {
        return h;
      },
      set: function(_) {
        h = !!_;
      }
    })), Object.defineProperty(u, "startTime", s({}, d, {
      get: function() {
        return m;
      },
      set: function(_) {
        if (typeof _ != "number")
          throw new TypeError("Start time must be set to a number.");
        m = _, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "endTime", s({}, d, {
      get: function() {
        return g;
      },
      set: function(_) {
        if (typeof _ != "number")
          throw new TypeError("End time must be set to a number.");
        g = _, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "text", s({}, d, {
      get: function() {
        return v;
      },
      set: function(_) {
        v = "" + _, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "region", s({}, d, {
      get: function() {
        return y;
      },
      set: function(_) {
        y = _, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "vertical", s({}, d, {
      get: function() {
        return b;
      },
      set: function(_) {
        const O = r(_);
        if (O === !1)
          throw new SyntaxError("An invalid or illegal string was specified.");
        b = O, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "snapToLines", s({}, d, {
      get: function() {
        return x;
      },
      set: function(_) {
        x = !!_, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "line", s({}, d, {
      get: function() {
        return E;
      },
      set: function(_) {
        if (typeof _ != "number" && _ !== "auto")
          throw new SyntaxError("An invalid number or illegal string was specified.");
        E = _, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "lineAlign", s({}, d, {
      get: function() {
        return w;
      },
      set: function(_) {
        const O = i(_);
        if (!O)
          throw new SyntaxError("An invalid or illegal string was specified.");
        w = O, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "position", s({}, d, {
      get: function() {
        return C;
      },
      set: function(_) {
        if (_ < 0 || _ > 100)
          throw new Error("Position must be between 0 and 100.");
        C = _, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "positionAlign", s({}, d, {
      get: function() {
        return S;
      },
      set: function(_) {
        const O = i(_);
        if (!O)
          throw new SyntaxError("An invalid or illegal string was specified.");
        S = O, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "size", s({}, d, {
      get: function() {
        return M;
      },
      set: function(_) {
        if (_ < 0 || _ > 100)
          throw new Error("Size must be between 0 and 100.");
        M = _, this.hasBeenReset = !0;
      }
    })), Object.defineProperty(u, "align", s({}, d, {
      get: function() {
        return k;
      },
      set: function(_) {
        const O = i(_);
        if (!O)
          throw new SyntaxError("An invalid or illegal string was specified.");
        k = O, this.hasBeenReset = !0;
      }
    })), u.displayState = void 0;
  }
  return o.prototype.getCueAsHTML = function() {
    return self.WebVTT.convertCueToDOMTree(self, this.text);
  }, o;
})();
class PXe {
  decode(e, t) {
    if (!e)
      return "";
    if (typeof e != "string")
      throw new Error("Error - expected string data.");
    return decodeURIComponent(encodeURIComponent(e));
  }
}
function Zne(n) {
  function e(r, i, s, o) {
    return (r | 0) * 3600 + (i | 0) * 60 + (s | 0) + parseFloat(o || 0);
  }
  const t = n.match(/^(?:(\d+):)?(\d{2}):(\d{2})(\.\d+)?/);
  return t ? parseFloat(t[2]) > 59 ? e(t[2], t[3], 0, t[4]) : e(t[1], t[2], t[3], t[4]) : null;
}
class DXe {
  constructor() {
    this.values = /* @__PURE__ */ Object.create(null);
  }
  // Only accept the first assignment to any key.
  set(e, t) {
    !this.get(e) && t !== "" && (this.values[e] = t);
  }
  // Return the value for a key, or a default value.
  // If 'defaultKey' is passed then 'dflt' is assumed to be an object with
  // a number of possible default values as properties where 'defaultKey' is
  // the key of the property that will be chosen; otherwise it's assumed to be
  // a single value.
  get(e, t, r) {
    return r ? this.has(e) ? this.values[e] : t[r] : this.has(e) ? this.values[e] : t;
  }
  // Check whether we have a value for a key.
  has(e) {
    return e in this.values;
  }
  // Accept a setting if its one of the given alternatives.
  alt(e, t, r) {
    for (let i = 0; i < r.length; ++i)
      if (t === r[i]) {
        this.set(e, t);
        break;
      }
  }
  // Accept a setting if its a valid (signed) integer.
  integer(e, t) {
    /^-?\d+$/.test(t) && this.set(e, parseInt(t, 10));
  }
  // Accept a setting if its a valid percentage.
  percent(e, t) {
    if (/^([\d]{1,3})(\.[\d]*)?%$/.test(t)) {
      const r = parseFloat(t);
      if (r >= 0 && r <= 100)
        return this.set(e, r), !0;
    }
    return !1;
  }
}
function Qne(n, e, t, r) {
  const i = r ? n.split(r) : [n];
  for (const s in i) {
    if (typeof i[s] != "string")
      continue;
    const o = i[s].split(t);
    if (o.length !== 2)
      continue;
    const a = o[0], l = o[1];
    e(a, l);
  }
}
const R7 = new P_(0, 0, ""), Ug = R7.align === "middle" ? "middle" : "center";
function NXe(n, e, t) {
  const r = n;
  function i() {
    const a = Zne(n);
    if (a === null)
      throw new Error("Malformed timestamp: " + r);
    return n = n.replace(/^[^\sa-zA-Z-]+/, ""), a;
  }
  function s(a, l) {
    const c = new DXe();
    Qne(a, function(f, h) {
      let m;
      switch (f) {
        case "region":
          for (let g = t.length - 1; g >= 0; g--)
            if (t[g].id === h) {
              c.set(f, t[g].region);
              break;
            }
          break;
        case "vertical":
          c.alt(f, h, ["rl", "lr"]);
          break;
        case "line":
          m = h.split(","), c.integer(f, m[0]), c.percent(f, m[0]) && c.set("snapToLines", !1), c.alt(f, m[0], ["auto"]), m.length === 2 && c.alt("lineAlign", m[1], ["start", Ug, "end"]);
          break;
        case "position":
          m = h.split(","), c.percent(f, m[0]), m.length === 2 && c.alt("positionAlign", m[1], ["start", Ug, "end", "line-left", "line-right", "auto"]);
          break;
        case "size":
          c.percent(f, h);
          break;
        case "align":
          c.alt(f, h, ["start", Ug, "end", "left", "right"]);
          break;
      }
    }, /:/, /\s/), l.region = c.get("region", null), l.vertical = c.get("vertical", "");
    let u = c.get("line", "auto");
    u === "auto" && R7.line === -1 && (u = -1), l.line = u, l.lineAlign = c.get("lineAlign", "start"), l.snapToLines = c.get("snapToLines", !0), l.size = c.get("size", 100), l.align = c.get("align", Ug);
    let d = c.get("position", "auto");
    d === "auto" && R7.position === 50 && (d = l.align === "start" || l.align === "left" ? 0 : l.align === "end" || l.align === "right" ? 100 : 50), l.position = d;
  }
  function o() {
    n = n.replace(/^\s+/, "");
  }
  if (o(), e.startTime = i(), o(), n.slice(0, 3) !== "-->")
    throw new Error("Malformed time stamp (time stamps must be separated by '-->'): " + r);
  n = n.slice(3), o(), e.endTime = i(), o(), s(n, e);
}
function Jne(n) {
  return n.replace(/<br(?: \/)?>/gi, `
`);
}
class LXe {
  constructor() {
    this.state = "INITIAL", this.buffer = "", this.decoder = new PXe(), this.regionList = [], this.cue = null, this.oncue = void 0, this.onparsingerror = void 0, this.onflush = void 0;
  }
  parse(e) {
    const t = this;
    e && (t.buffer += t.decoder.decode(e, {
      stream: !0
    }));
    function r() {
      let s = t.buffer, o = 0;
      for (s = Jne(s); o < s.length && s[o] !== "\r" && s[o] !== `
`; )
        ++o;
      const a = s.slice(0, o);
      return s[o] === "\r" && ++o, s[o] === `
` && ++o, t.buffer = s.slice(o), a;
    }
    function i(s) {
      Qne(s, function(o, a) {
      }, /:/);
    }
    try {
      let s = "";
      if (t.state === "INITIAL") {
        if (!/\r\n|\n/.test(t.buffer))
          return this;
        s = r();
        const a = s.match(/^(ï»¿)?WEBVTT([ \t].*)?$/);
        if (!(a != null && a[0]))
          throw new Error("Malformed WebVTT signature.");
        t.state = "HEADER";
      }
      let o = !1;
      for (; t.buffer; ) {
        if (!/\r\n|\n/.test(t.buffer))
          return this;
        switch (o ? o = !1 : s = r(), t.state) {
          case "HEADER":
            /:/.test(s) ? i(s) : s || (t.state = "ID");
            continue;
          case "NOTE":
            s || (t.state = "ID");
            continue;
          case "ID":
            if (/^NOTE($|[ \t])/.test(s)) {
              t.state = "NOTE";
              break;
            }
            if (!s)
              continue;
            if (t.cue = new P_(0, 0, ""), t.state = "CUE", s.indexOf("-->") === -1) {
              t.cue.id = s;
              continue;
            }
          // Process line as start of a cue.
          /* falls through */
          case "CUE":
            if (!t.cue) {
              t.state = "BADCUE";
              continue;
            }
            try {
              NXe(s, t.cue, t.regionList);
            } catch {
              t.cue = null, t.state = "BADCUE";
              continue;
            }
            t.state = "CUETEXT";
            continue;
          case "CUETEXT":
            {
              const a = s.indexOf("-->") !== -1;
              if (!s || a && (o = !0)) {
                t.oncue && t.cue && t.oncue(t.cue), t.cue = null, t.state = "ID";
                continue;
              }
              if (t.cue === null)
                continue;
              t.cue.text && (t.cue.text += `
`), t.cue.text += s;
            }
            continue;
          case "BADCUE":
            s || (t.state = "ID");
        }
      }
    } catch {
      t.state === "CUETEXT" && t.cue && t.oncue && t.oncue(t.cue), t.cue = null, t.state = t.state === "INITIAL" ? "BADWEBVTT" : "BADCUE";
    }
    return this;
  }
  flush() {
    const e = this;
    try {
      if ((e.cue || e.state === "HEADER") && (e.buffer += `

`, e.parse()), e.state === "INITIAL" || e.state === "BADWEBVTT")
        throw new Error("Malformed WebVTT signature.");
    } catch (t) {
      e.onparsingerror && e.onparsingerror(t);
    }
    return e.onflush && e.onflush(), this;
  }
}
const $Xe = /\r\n|\n\r|\n|\r/g, N6 = function(e, t, r = 0) {
  return e.slice(r, r + t.length) === t;
}, FXe = function(e) {
  let t = parseInt(e.slice(-3));
  const r = parseInt(e.slice(-6, -4)), i = parseInt(e.slice(-9, -7)), s = e.length > 9 ? parseInt(e.substring(0, e.indexOf(":"))) : 0;
  if (!He(t) || !He(r) || !He(i) || !He(s))
    throw Error(`Malformed X-TIMESTAMP-MAP: Local:${e}`);
  return t += 1e3 * r, t += 60 * 1e3 * i, t += 3600 * 1e3 * s, t;
};
function D_(n, e, t) {
  return Zp(n.toString()) + Zp(e.toString()) + Zp(t);
}
const BXe = function(e, t, r) {
  let i = e[t], s = e[i.prevCC];
  if (!s || !s.new && i.new) {
    e.ccOffset = e.presentationOffset = i.start, i.new = !1;
    return;
  }
  for (; (o = s) != null && o.new; ) {
    var o;
    e.ccOffset += i.start - s.start, i.new = !1, i = s, s = e[i.prevCC];
  }
  e.presentationOffset = r;
};
function zXe(n, e, t, r, i, s, o) {
  const a = new LXe(), l = gs(new Uint8Array(n)).trim().replace($Xe, `
`).split(`
`), c = [], u = e ? Gqe(e.baseTime, e.timescale) : 0;
  let d = "00:00.000", f = 0, h = 0, m, g = !0;
  a.oncue = function(v) {
    const y = t[r];
    let b = t.ccOffset;
    const x = (f - u) / 9e4;
    if (y != null && y.new && (h !== void 0 ? b = t.ccOffset = y.start : BXe(t, r, x)), x) {
      if (!e) {
        m = new Error("Missing initPTS for VTT MPEGTS");
        return;
      }
      b = x - t.presentationOffset;
    }
    const E = v.endTime - v.startTime, w = is((v.startTime + b - h) * 9e4, i * 9e4) / 9e4;
    v.startTime = Math.max(w, 0), v.endTime = Math.max(w + E, 0);
    const C = v.text.trim();
    v.text = decodeURIComponent(encodeURIComponent(C)), v.id || (v.id = D_(v.startTime, v.endTime, C)), v.endTime > 0 && c.push(v);
  }, a.onparsingerror = function(v) {
    m = v;
  }, a.onflush = function() {
    if (m) {
      o(m);
      return;
    }
    s(c);
  }, l.forEach((v) => {
    if (g)
      if (N6(v, "X-TIMESTAMP-MAP=")) {
        g = !1, v.slice(16).split(",").forEach((y) => {
          N6(y, "LOCAL:") ? d = y.slice(6) : N6(y, "MPEGTS:") && (f = parseInt(y.slice(7)));
        });
        try {
          h = FXe(d) / 1e3;
        } catch (y) {
          m = y;
        }
        return;
      } else v === "" && (g = !1);
    a.parse(v + `
`);
  }), a.flush();
}
const L6 = "stpp.ttml.im1t", ere = /^(\d{2,}):(\d{2}):(\d{2}):(\d{2})\.?(\d+)?$/, tre = /^(\d*(?:\.\d*)?)(h|m|s|ms|f|t)$/, HXe = {
  left: "start",
  center: "center",
  right: "end",
  start: "start",
  end: "end"
};
function LH(n, e, t, r) {
  const i = Rt(new Uint8Array(n), ["mdat"]);
  if (i.length === 0) {
    r(new Error("Could not parse IMSC1 mdat"));
    return;
  }
  const s = i.map((a) => gs(a)), o = Wqe(e.baseTime, 1, e.timescale);
  try {
    s.forEach((a) => t(UXe(a, o)));
  } catch (a) {
    r(a);
  }
}
function UXe(n, e) {
  const i = new DOMParser().parseFromString(n, "text/xml").getElementsByTagName("tt")[0];
  if (!i)
    throw new Error("Invalid ttml");
  const s = {
    frameRate: 30,
    subFrameRate: 1,
    frameRateMultiplier: 0,
    tickRate: 0
  }, o = Object.keys(s).reduce((d, f) => (d[f] = i.getAttribute(`ttp:${f}`) || s[f], d), {}), a = i.getAttribute("xml:space") !== "preserve", l = $H($6(i, "styling", "style")), c = $H($6(i, "layout", "region")), u = $6(i, "body", "[begin]");
  return [].map.call(u, (d) => {
    const f = nre(d, a);
    if (!f || !d.hasAttribute("begin"))
      return null;
    const h = B6(d.getAttribute("begin"), o), m = B6(d.getAttribute("dur"), o);
    let g = B6(d.getAttribute("end"), o);
    if (h === null)
      throw FH(d);
    if (g === null) {
      if (m === null)
        throw FH(d);
      g = h + m;
    }
    const v = new P_(h - e, g - e, f);
    v.id = D_(v.startTime, v.endTime, v.text);
    const y = c[d.getAttribute("region")], b = l[d.getAttribute("style")], x = VXe(y, b, l), {
      textAlign: E
    } = x;
    if (E) {
      const w = HXe[E];
      w && (v.lineAlign = w), v.align = E;
    }
    return mn(v, x), v;
  }).filter((d) => d !== null);
}
function $6(n, e, t) {
  const r = n.getElementsByTagName(e)[0];
  return r ? [].slice.call(r.querySelectorAll(t)) : [];
}
function $H(n) {
  return n.reduce((e, t) => {
    const r = t.getAttribute("xml:id");
    return r && (e[r] = t), e;
  }, {});
}
function nre(n, e) {
  return [].slice.call(n.childNodes).reduce((t, r, i) => {
    var s;
    return r.nodeName === "br" && i ? t + `
` : (s = r.childNodes) != null && s.length ? nre(r, e) : e ? t + r.textContent.trim().replace(/\s+/g, " ") : t + r.textContent;
  }, "");
}
function VXe(n, e, t) {
  const r = "http://www.w3.org/ns/ttml#styling";
  let i = null;
  const s = [
    "displayAlign",
    "textAlign",
    "color",
    "backgroundColor",
    "fontSize",
    "fontFamily"
    // 'fontWeight',
    // 'lineHeight',
    // 'wrapOption',
    // 'fontStyle',
    // 'direction',
    // 'writingMode'
  ], o = n != null && n.hasAttribute("style") ? n.getAttribute("style") : null;
  return o && t.hasOwnProperty(o) && (i = t[o]), s.reduce((a, l) => {
    const c = F6(e, r, l) || F6(n, r, l) || F6(i, r, l);
    return c && (a[l] = c), a;
  }, {});
}
function F6(n, e, t) {
  return n && n.hasAttributeNS(e, t) ? n.getAttributeNS(e, t) : null;
}
function FH(n) {
  return new Error(`Could not parse ttml timestamp ${n}`);
}
function B6(n, e) {
  if (!n)
    return null;
  let t = Zne(n);
  return t === null && (ere.test(n) ? t = jXe(n, e) : tre.test(n) && (t = WXe(n, e))), t;
}
function jXe(n, e) {
  const t = ere.exec(n), r = (t[4] | 0) + (t[5] | 0) / e.subFrameRate;
  return (t[1] | 0) * 3600 + (t[2] | 0) * 60 + (t[3] | 0) + r / e.frameRate;
}
function WXe(n, e) {
  const t = tre.exec(n), r = Number(t[1]);
  switch (t[2]) {
    case "h":
      return r * 3600;
    case "m":
      return r * 60;
    case "ms":
      return r * 1e3;
    case "f":
      return r / e.frameRate;
    case "t":
      return r / e.tickRate;
  }
  return r;
}
class Vg {
  constructor(e, t) {
    this.timelineController = void 0, this.cueRanges = [], this.trackName = void 0, this.startTime = null, this.endTime = null, this.screen = null, this.timelineController = e, this.trackName = t;
  }
  dispatchCue() {
    this.startTime !== null && (this.timelineController.addCues(this.trackName, this.startTime, this.endTime, this.screen, this.cueRanges), this.startTime = null);
  }
  newCue(e, t, r) {
    (this.startTime === null || this.startTime > e) && (this.startTime = e), this.endTime = t, this.screen = r, this.timelineController.createCaptionsTrack(this.trackName);
  }
  reset() {
    this.cueRanges = [], this.startTime = null;
  }
}
class GXe {
  constructor(e) {
    this.hls = void 0, this.media = null, this.config = void 0, this.enabled = !0, this.Cues = void 0, this.textTracks = [], this.tracks = [], this.initPTS = [], this.unparsedVttFrags = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.cea608Parser1 = void 0, this.cea608Parser2 = void 0, this.lastCc = -1, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = zH(), this.captionsProperties = void 0, this.hls = e, this.config = e.config, this.Cues = e.config.cueHandler, this.captionsProperties = {
      textTrack1: {
        label: this.config.captionsTextTrack1Label,
        languageCode: this.config.captionsTextTrack1LanguageCode
      },
      textTrack2: {
        label: this.config.captionsTextTrack2Label,
        languageCode: this.config.captionsTextTrack2LanguageCode
      },
      textTrack3: {
        label: this.config.captionsTextTrack3Label,
        languageCode: this.config.captionsTextTrack3LanguageCode
      },
      textTrack4: {
        label: this.config.captionsTextTrack4Label,
        languageCode: this.config.captionsTextTrack4LanguageCode
      }
    }, e.on(N.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(N.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(N.MANIFEST_LOADING, this.onManifestLoading, this), e.on(N.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(N.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.on(N.FRAG_LOADING, this.onFragLoading, this), e.on(N.FRAG_LOADED, this.onFragLoaded, this), e.on(N.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), e.on(N.FRAG_DECRYPTED, this.onFragDecrypted, this), e.on(N.INIT_PTS_FOUND, this.onInitPtsFound, this), e.on(N.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), e.on(N.BUFFER_FLUSHING, this.onBufferFlushing, this);
  }
  destroy() {
    const {
      hls: e
    } = this;
    e.off(N.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(N.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(N.MANIFEST_LOADING, this.onManifestLoading, this), e.off(N.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(N.SUBTITLE_TRACKS_UPDATED, this.onSubtitleTracksUpdated, this), e.off(N.FRAG_LOADING, this.onFragLoading, this), e.off(N.FRAG_LOADED, this.onFragLoaded, this), e.off(N.FRAG_PARSING_USERDATA, this.onFragParsingUserdata, this), e.off(N.FRAG_DECRYPTED, this.onFragDecrypted, this), e.off(N.INIT_PTS_FOUND, this.onInitPtsFound, this), e.off(N.SUBTITLE_TRACKS_CLEARED, this.onSubtitleTracksCleared, this), e.off(N.BUFFER_FLUSHING, this.onBufferFlushing, this), this.hls = this.config = this.media = null, this.cea608Parser1 = this.cea608Parser2 = void 0;
  }
  initCea608Parsers() {
    const e = new Vg(this, "textTrack1"), t = new Vg(this, "textTrack2"), r = new Vg(this, "textTrack3"), i = new Vg(this, "textTrack4");
    this.cea608Parser1 = new NH(1, e, t), this.cea608Parser2 = new NH(3, r, i);
  }
  addCues(e, t, r, i, s) {
    let o = !1;
    for (let a = s.length; a--; ) {
      const l = s[a], c = KXe(l[0], l[1], t, r);
      if (c >= 0 && (l[0] = Math.min(l[0], t), l[1] = Math.max(l[1], r), o = !0, c / (r - t) > 0.5))
        return;
    }
    if (o || s.push([t, r]), this.config.renderTextTracksNatively) {
      const a = this.captionsTracks[e];
      this.Cues.newCue(a, t, r, i);
    } else {
      const a = this.Cues.newCue(null, t, r, i);
      this.hls.trigger(N.CUES_PARSED, {
        type: "captions",
        cues: a,
        track: e
      });
    }
  }
  // Triggered when an initial PTS is found; used for synchronisation of WebVTT.
  onInitPtsFound(e, {
    frag: t,
    id: r,
    initPTS: i,
    timescale: s,
    trackId: o
  }) {
    const {
      unparsedVttFrags: a
    } = this;
    r === We.MAIN && (this.initPTS[t.cc] = {
      baseTime: i,
      timescale: s,
      trackId: o
    }), a.length && (this.unparsedVttFrags = [], a.forEach((l) => {
      this.initPTS[l.frag.cc] ? this.onFragLoaded(N.FRAG_LOADED, l) : this.hls.trigger(N.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: l.frag,
        error: new Error("Subtitle discontinuity domain does not match main")
      });
    }));
  }
  getExistingTrack(e, t) {
    const {
      media: r
    } = this;
    if (r)
      for (let i = 0; i < r.textTracks.length; i++) {
        const s = r.textTracks[i];
        if (BH(s, {
          name: e,
          lang: t,
          characteristics: "transcribes-spoken-dialog,describes-music-and-sound"
        }))
          return s;
      }
    return null;
  }
  createCaptionsTrack(e) {
    this.config.renderTextTracksNatively ? this.createNativeTrack(e) : this.createNonNativeTrack(e);
  }
  createNativeTrack(e) {
    if (this.captionsTracks[e])
      return;
    const {
      captionsProperties: t,
      captionsTracks: r,
      media: i
    } = this, {
      label: s,
      languageCode: o
    } = t[e], a = this.getExistingTrack(s, o);
    if (a)
      r[e] = a, Zd(r[e]), Gne(r[e], i);
    else {
      const l = this.createTextTrack("captions", s, o);
      l && (l[e] = !0, r[e] = l);
    }
  }
  createNonNativeTrack(e) {
    if (this.nonNativeCaptionsTracks[e])
      return;
    const t = this.captionsProperties[e];
    if (!t)
      return;
    const r = t.label, i = {
      _id: e,
      label: r,
      kind: "captions",
      default: t.media ? !!t.media.default : !1,
      closedCaptions: t.media
    };
    this.nonNativeCaptionsTracks[e] = i, this.hls.trigger(N.NON_NATIVE_TEXT_TRACKS_FOUND, {
      tracks: [i]
    });
  }
  createTextTrack(e, t, r) {
    const i = this.media;
    if (i)
      return i.addTextTrack(e, t, r);
  }
  onMediaAttaching(e, t) {
    this.media = t.media, t.mediaSource || this._cleanTracks();
  }
  onMediaDetaching(e, t) {
    const r = !!t.transferMedia;
    if (this.media = null, r)
      return;
    const {
      captionsTracks: i
    } = this;
    Object.keys(i).forEach((s) => {
      Zd(i[s]), delete i[s];
    }), this.nonNativeCaptionsTracks = {};
  }
  onManifestLoading() {
    this.lastCc = -1, this.lastSn = -1, this.lastPartIndex = -1, this.prevCC = -1, this.vttCCs = zH(), this._cleanTracks(), this.tracks = [], this.captionsTracks = {}, this.nonNativeCaptionsTracks = {}, this.textTracks = [], this.unparsedVttFrags = [], this.initPTS = [], this.cea608Parser1 && this.cea608Parser2 && (this.cea608Parser1.reset(), this.cea608Parser2.reset());
  }
  _cleanTracks() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = e.textTracks;
    if (t)
      for (let r = 0; r < t.length; r++)
        Zd(t[r]);
  }
  onSubtitleTracksUpdated(e, t) {
    const r = t.subtitleTracks || [], i = r.some((s) => s.textCodec === L6);
    if (this.config.enableWebVTT || i && this.config.enableIMSC1) {
      if (Pne(this.tracks, r)) {
        this.tracks = r;
        return;
      }
      if (this.textTracks = [], this.tracks = r, this.config.renderTextTracksNatively) {
        const o = this.media, a = o ? qv(o.textTracks) : null;
        if (this.tracks.forEach((l, c) => {
          let u;
          if (a) {
            let d = null;
            for (let f = 0; f < a.length; f++)
              if (a[f] && BH(a[f], l)) {
                d = a[f], a[f] = null;
                break;
              }
            d && (u = d);
          }
          if (u)
            Zd(u);
          else {
            const d = rre(l);
            u = this.createTextTrack(d, l.name, l.lang), u && (u.mode = "disabled");
          }
          u && this.textTracks.push(u);
        }), a != null && a.length) {
          const l = a.filter((c) => c !== null).map((c) => c.label);
          l.length && this.hls.logger.warn(`Media element contains unused subtitle tracks: ${l.join(", ")}. Replace media element for each source to clear TextTracks and captions menu.`);
        }
      } else if (this.tracks.length) {
        const o = this.tracks.map((a) => ({
          label: a.name,
          kind: a.type.toLowerCase(),
          default: a.default,
          subtitleTrack: a
        }));
        this.hls.trigger(N.NON_NATIVE_TEXT_TRACKS_FOUND, {
          tracks: o
        });
      }
    }
  }
  onManifestLoaded(e, t) {
    this.config.enableCEA708Captions && t.captions && t.captions.forEach((r) => {
      const i = /(?:CC|SERVICE)([1-4])/.exec(r.instreamId);
      if (!i)
        return;
      const s = `textTrack${i[1]}`, o = this.captionsProperties[s];
      o && (o.label = r.name, r.lang && (o.languageCode = r.lang), o.media = r);
    });
  }
  closedCaptionsForLevel(e) {
    const t = this.hls.levels[e.level];
    return t?.attrs["CLOSED-CAPTIONS"];
  }
  onFragLoading(e, t) {
    if (this.enabled && t.frag.type === We.MAIN) {
      var r, i;
      const {
        cea608Parser1: s,
        cea608Parser2: o,
        lastSn: a
      } = this, {
        cc: l,
        sn: c
      } = t.frag, u = (r = (i = t.part) == null ? void 0 : i.index) != null ? r : -1;
      s && o && (c !== a + 1 || c === a && u !== this.lastPartIndex + 1 || l !== this.lastCc) && (s.reset(), o.reset()), this.lastCc = l, this.lastSn = c, this.lastPartIndex = u;
    }
  }
  onFragLoaded(e, t) {
    const {
      frag: r,
      payload: i
    } = t;
    if (r.type === We.SUBTITLE)
      if (i.byteLength) {
        const s = r.decryptdata, o = "stats" in t;
        if (s == null || !s.encrypted || o) {
          const a = this.tracks[r.level], l = this.vttCCs;
          l[r.cc] || (l[r.cc] = {
            start: r.start,
            prevCC: this.prevCC,
            new: !0
          }, this.prevCC = r.cc), a && a.textCodec === L6 ? this._parseIMSC1(r, i) : this._parseVTTs(t);
        }
      } else
        this.hls.trigger(N.SUBTITLE_FRAG_PROCESSED, {
          success: !1,
          frag: r,
          error: new Error("Empty subtitle payload")
        });
  }
  _parseIMSC1(e, t) {
    const r = this.hls;
    LH(t, this.initPTS[e.cc], (i) => {
      this._appendCues(i, e.level), r.trigger(N.SUBTITLE_FRAG_PROCESSED, {
        success: !0,
        frag: e
      });
    }, (i) => {
      r.logger.log(`Failed to parse IMSC1: ${i}`), r.trigger(N.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: e,
        error: i
      });
    });
  }
  _parseVTTs(e) {
    var t;
    const {
      frag: r,
      payload: i
    } = e, {
      initPTS: s,
      unparsedVttFrags: o
    } = this, a = s.length - 1;
    if (!s[r.cc] && a === -1) {
      o.push(e);
      return;
    }
    const l = this.hls, c = (t = r.initSegment) != null && t.data ? Vs(r.initSegment.data, new Uint8Array(i)).buffer : i;
    zXe(c, this.initPTS[r.cc], this.vttCCs, r.cc, r.start, (u) => {
      this._appendCues(u, r.level), l.trigger(N.SUBTITLE_FRAG_PROCESSED, {
        success: !0,
        frag: r
      });
    }, (u) => {
      const d = u.message === "Missing initPTS for VTT MPEGTS";
      d ? o.push(e) : this._fallbackToIMSC1(r, i), l.logger.log(`Failed to parse VTT cue: ${u}`), !(d && a > r.cc) && l.trigger(N.SUBTITLE_FRAG_PROCESSED, {
        success: !1,
        frag: r,
        error: u
      });
    });
  }
  _fallbackToIMSC1(e, t) {
    const r = this.tracks[e.level];
    r.textCodec || LH(t, this.initPTS[e.cc], () => {
      r.textCodec = L6, this._parseIMSC1(e, t);
    }, () => {
      r.textCodec = "wvtt";
    });
  }
  _appendCues(e, t) {
    const r = this.hls;
    if (this.config.renderTextTracksNatively) {
      const i = this.textTracks[t];
      if (!i || i.mode === "disabled")
        return;
      e.forEach((s) => Kne(i, s));
    } else {
      const i = this.tracks[t];
      if (!i)
        return;
      const s = i.default ? "default" : "subtitles" + t;
      r.trigger(N.CUES_PARSED, {
        type: "subtitles",
        cues: e,
        track: s
      });
    }
  }
  onFragDecrypted(e, t) {
    const {
      frag: r
    } = t;
    r.type === We.SUBTITLE && this.onFragLoaded(N.FRAG_LOADED, t);
  }
  onSubtitleTracksCleared() {
    this.tracks = [], this.captionsTracks = {};
  }
  onFragParsingUserdata(e, t) {
    if (!this.enabled || !this.config.enableCEA708Captions)
      return;
    const {
      frag: r,
      samples: i
    } = t;
    if (!(r.type === We.MAIN && this.closedCaptionsForLevel(r) === "NONE"))
      for (let s = 0; s < i.length; s++) {
        const o = i[s].bytes;
        if (o) {
          this.cea608Parser1 || this.initCea608Parsers();
          const a = this.extractCea608Data(o);
          this.cea608Parser1.addData(i[s].pts, a[0]), this.cea608Parser2.addData(i[s].pts, a[1]);
        }
      }
  }
  onBufferFlushing(e, {
    startOffset: t,
    endOffset: r,
    endOffsetSubtitles: i,
    type: s
  }) {
    const {
      media: o
    } = this;
    if (!(!o || o.currentTime < r)) {
      if (!s || s === "video") {
        const {
          captionsTracks: a
        } = this;
        Object.keys(a).forEach((l) => I7(a[l], t, r));
      }
      if (this.config.renderTextTracksNatively && t === 0 && i !== void 0) {
        const {
          textTracks: a
        } = this;
        Object.keys(a).forEach((l) => I7(a[l], t, i));
      }
    }
  }
  extractCea608Data(e) {
    const t = [[], []], r = e[0] & 31;
    let i = 2;
    for (let s = 0; s < r; s++) {
      const o = e[i++], a = 127 & e[i++], l = 127 & e[i++];
      if (a === 0 && l === 0)
        continue;
      if ((4 & o) !== 0) {
        const u = 3 & o;
        (u === 0 || u === 1) && (t[u].push(a), t[u].push(l));
      }
    }
    return t;
  }
}
function rre(n) {
  return n.characteristics && /transcribes-spoken-dialog/gi.test(n.characteristics) && /describes-music-and-sound/gi.test(n.characteristics) ? "captions" : "subtitles";
}
function BH(n, e) {
  return !!n && n.kind === rre(e) && M7(e, n);
}
function KXe(n, e, t, r) {
  return Math.min(e, r) - Math.max(n, t);
}
function zH() {
  return {
    ccOffset: 0,
    presentationOffset: 0,
    0: {
      start: 0,
      prevCC: -1,
      new: !0
    }
  };
}
const qXe = /\s/, YXe = {
  newCue(n, e, t, r) {
    const i = [];
    let s, o, a, l, c;
    const u = self.VTTCue || self.TextTrackCue;
    for (let f = 0; f < r.rows.length; f++)
      if (s = r.rows[f], a = !0, l = 0, c = "", !s.isEmpty()) {
        var d;
        for (let g = 0; g < s.chars.length; g++)
          qXe.test(s.chars[g].uchar) && a ? l++ : (c += s.chars[g].uchar, a = !1);
        s.cueStartTime = e, e === t && (t += 1e-4), l >= 16 ? l-- : l++;
        const h = Jne(c.trim()), m = D_(e, t, h);
        n != null && (d = n.cues) != null && d.getCueById(m) || (o = new u(e, t, h), o.id = m, o.line = f + 1, o.align = "left", o.position = 10 + Math.min(80, Math.floor(l * 8 / 32) * 10), i.push(o));
      }
    return n && i.length && (i.sort((f, h) => f.line === "auto" || h.line === "auto" ? 0 : f.line > 8 && h.line > 8 ? h.line - f.line : f.line - h.line), i.forEach((f) => Kne(n, f))), i;
  }
};
function XXe() {
  if (
    // @ts-ignore
    self.fetch && self.AbortController && self.ReadableStream && self.Request
  )
    try {
      return new self.ReadableStream({}), !0;
    } catch {
    }
  return !1;
}
const ZXe = /(\d+)-(\d+)\/(\d+)/;
class HH {
  constructor(e) {
    this.fetchSetup = void 0, this.requestTimeout = void 0, this.request = null, this.response = null, this.controller = void 0, this.context = null, this.config = null, this.callbacks = null, this.stats = void 0, this.loader = null, this.fetchSetup = e.fetchSetup || tZe, this.controller = new self.AbortController(), this.stats = new f_();
  }
  destroy() {
    this.loader = this.callbacks = this.context = this.config = this.request = null, this.abortInternal(), this.response = null, this.fetchSetup = this.controller = this.stats = null;
  }
  abortInternal() {
    this.controller && !this.stats.loading.end && (this.stats.aborted = !0, this.controller.abort());
  }
  abort() {
    var e;
    this.abortInternal(), (e = this.callbacks) != null && e.onAbort && this.callbacks.onAbort(this.stats, this.context, this.response);
  }
  load(e, t, r) {
    const i = this.stats;
    if (i.loading.start)
      throw new Error("Loader can only be used once.");
    i.loading.start = self.performance.now();
    const s = QXe(e, this.controller.signal), o = e.responseType === "arraybuffer", a = o ? "byteLength" : "length", {
      maxTimeToFirstByteMs: l,
      maxLoadTimeMs: c
    } = t.loadPolicy;
    this.context = e, this.config = t, this.callbacks = r, this.request = this.fetchSetup(e, s), self.clearTimeout(this.requestTimeout), t.timeout = l && He(l) ? l : c, this.requestTimeout = self.setTimeout(() => {
      this.callbacks && (this.abortInternal(), this.callbacks.onTimeout(i, e, this.response));
    }, t.timeout), (T0(this.request) ? this.request.then(self.fetch) : self.fetch(this.request)).then((d) => {
      var f;
      this.response = this.loader = d;
      const h = Math.max(self.performance.now(), i.loading.start);
      if (self.clearTimeout(this.requestTimeout), t.timeout = c, this.requestTimeout = self.setTimeout(() => {
        this.callbacks && (this.abortInternal(), this.callbacks.onTimeout(i, e, this.response));
      }, c - (h - i.loading.start)), !d.ok) {
        const {
          status: g,
          statusText: v
        } = d;
        throw new nZe(v || "fetch, bad network response", g, d);
      }
      i.loading.first = h, i.total = eZe(d.headers) || i.total;
      const m = (f = this.callbacks) == null ? void 0 : f.onProgress;
      return m && He(t.highWaterMark) ? this.loadProgressively(d, i, e, t.highWaterMark, m) : o ? d.arrayBuffer() : e.responseType === "json" ? d.json() : d.text();
    }).then((d) => {
      var f, h;
      const m = this.response;
      if (!m)
        throw new Error("loader destroyed");
      self.clearTimeout(this.requestTimeout), i.loading.end = Math.max(self.performance.now(), i.loading.first);
      const g = d[a];
      g && (i.loaded = i.total = g);
      const v = {
        url: m.url,
        data: d,
        code: m.status
      }, y = (f = this.callbacks) == null ? void 0 : f.onProgress;
      y && !He(t.highWaterMark) && y(i, e, d, m), (h = this.callbacks) == null || h.onSuccess(v, i, e, m);
    }).catch((d) => {
      var f;
      if (self.clearTimeout(this.requestTimeout), i.aborted)
        return;
      const h = d && d.code || 0, m = d ? d.message : null;
      (f = this.callbacks) == null || f.onError({
        code: h,
        text: m
      }, e, d ? d.details : null, i);
    });
  }
  getCacheAge() {
    let e = null;
    if (this.response) {
      const t = this.response.headers.get("age");
      e = t ? parseFloat(t) : null;
    }
    return e;
  }
  getResponseHeader(e) {
    return this.response ? this.response.headers.get(e) : null;
  }
  loadProgressively(e, t, r, i = 0, s) {
    const o = new hne(), a = e.body.getReader(), l = () => a.read().then((c) => {
      if (c.done)
        return o.dataLength && s(t, r, o.flush().buffer, e), Promise.resolve(new ArrayBuffer(0));
      const u = c.value, d = u.length;
      return t.loaded += d, d < i || o.dataLength ? (o.push(u), o.dataLength >= i && s(t, r, o.flush().buffer, e)) : s(t, r, u.buffer, e), l();
    }).catch(() => Promise.reject());
    return l();
  }
}
function QXe(n, e) {
  const t = {
    method: "GET",
    mode: "cors",
    credentials: "same-origin",
    signal: e,
    headers: new self.Headers(mn({}, n.headers))
  };
  return n.rangeEnd && t.headers.set("Range", "bytes=" + n.rangeStart + "-" + String(n.rangeEnd - 1)), t;
}
function JXe(n) {
  const e = ZXe.exec(n);
  if (e)
    return parseInt(e[2]) - parseInt(e[1]) + 1;
}
function eZe(n) {
  const e = n.get("Content-Range");
  if (e) {
    const r = JXe(e);
    if (He(r))
      return r;
  }
  const t = n.get("Content-Length");
  if (t)
    return parseInt(t);
}
function tZe(n, e) {
  return new self.Request(n.url, e);
}
class nZe extends Error {
  constructor(e, t, r) {
    super(e), this.code = void 0, this.details = void 0, this.code = t, this.details = r;
  }
}
const rZe = /^age:\s*[\d.]+\s*$/im;
class ire {
  constructor(e) {
    this.xhrSetup = void 0, this.requestTimeout = void 0, this.retryTimeout = void 0, this.retryDelay = void 0, this.config = null, this.callbacks = null, this.context = null, this.loader = null, this.stats = void 0, this.xhrSetup = e && e.xhrSetup || null, this.stats = new f_(), this.retryDelay = 0;
  }
  destroy() {
    this.callbacks = null, this.abortInternal(), this.loader = null, this.config = null, this.context = null, this.xhrSetup = null;
  }
  abortInternal() {
    const e = this.loader;
    self.clearTimeout(this.requestTimeout), self.clearTimeout(this.retryTimeout), e && (e.onreadystatechange = null, e.onprogress = null, e.readyState !== 4 && (this.stats.aborted = !0, e.abort()));
  }
  abort() {
    var e;
    this.abortInternal(), (e = this.callbacks) != null && e.onAbort && this.callbacks.onAbort(this.stats, this.context, this.loader);
  }
  load(e, t, r) {
    if (this.stats.loading.start)
      throw new Error("Loader can only be used once.");
    this.stats.loading.start = self.performance.now(), this.context = e, this.config = t, this.callbacks = r, this.loadInternal();
  }
  loadInternal() {
    const {
      config: e,
      context: t
    } = this;
    if (!e || !t)
      return;
    const r = this.loader = new self.XMLHttpRequest(), i = this.stats;
    i.loading.first = 0, i.loaded = 0, i.aborted = !1;
    const s = this.xhrSetup;
    s ? Promise.resolve().then(() => {
      if (!(this.loader !== r || this.stats.aborted))
        return s(r, t.url);
    }).catch((o) => {
      if (!(this.loader !== r || this.stats.aborted))
        return r.open("GET", t.url, !0), s(r, t.url);
    }).then(() => {
      this.loader !== r || this.stats.aborted || this.openAndSendXhr(r, t, e);
    }).catch((o) => {
      var a;
      (a = this.callbacks) == null || a.onError({
        code: r.status,
        text: o.message
      }, t, r, i);
    }) : this.openAndSendXhr(r, t, e);
  }
  openAndSendXhr(e, t, r) {
    e.readyState || e.open("GET", t.url, !0);
    const i = t.headers, {
      maxTimeToFirstByteMs: s,
      maxLoadTimeMs: o
    } = r.loadPolicy;
    if (i)
      for (const a in i)
        e.setRequestHeader(a, i[a]);
    t.rangeEnd && e.setRequestHeader("Range", "bytes=" + t.rangeStart + "-" + (t.rangeEnd - 1)), e.onreadystatechange = this.readystatechange.bind(this), e.onprogress = this.loadprogress.bind(this), e.responseType = t.responseType, self.clearTimeout(this.requestTimeout), r.timeout = s && He(s) ? s : o, this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), r.timeout), e.send();
  }
  readystatechange() {
    const {
      context: e,
      loader: t,
      stats: r
    } = this;
    if (!e || !t)
      return;
    const i = t.readyState, s = this.config;
    if (!r.aborted && i >= 2 && (r.loading.first === 0 && (r.loading.first = Math.max(self.performance.now(), r.loading.start), s.timeout !== s.loadPolicy.maxLoadTimeMs && (self.clearTimeout(this.requestTimeout), s.timeout = s.loadPolicy.maxLoadTimeMs, this.requestTimeout = self.setTimeout(this.loadtimeout.bind(this), s.loadPolicy.maxLoadTimeMs - (r.loading.first - r.loading.start)))), i === 4)) {
      self.clearTimeout(this.requestTimeout), t.onreadystatechange = null, t.onprogress = null;
      const c = t.status, u = t.responseType === "text" ? t.responseText : null;
      if (c >= 200 && c < 300) {
        const m = u ?? t.response;
        if (m != null) {
          var o, a;
          r.loading.end = Math.max(self.performance.now(), r.loading.first);
          const g = t.responseType === "arraybuffer" ? m.byteLength : m.length;
          r.loaded = r.total = g, r.bwEstimate = r.total * 8e3 / (r.loading.end - r.loading.first);
          const v = (o = this.callbacks) == null ? void 0 : o.onProgress;
          v && v(r, e, m, t);
          const y = {
            url: t.responseURL,
            data: m,
            code: c
          };
          (a = this.callbacks) == null || a.onSuccess(y, r, e, t);
          return;
        }
      }
      const d = s.loadPolicy.errorRetry, f = r.retry, h = {
        url: e.url,
        data: void 0,
        code: c
      };
      if (Vy(d, f, !1, h))
        this.retry(d);
      else {
        var l;
        un.error(`${c} while loading ${e.url}`), (l = this.callbacks) == null || l.onError({
          code: c,
          text: t.statusText
        }, e, t, r);
      }
    }
  }
  loadtimeout() {
    if (!this.config) return;
    const e = this.config.loadPolicy.timeoutRetry, t = this.stats.retry;
    if (Vy(e, t, !0))
      this.retry(e);
    else {
      var r;
      un.warn(`timeout while loading ${(r = this.context) == null ? void 0 : r.url}`);
      const i = this.callbacks;
      i && (this.abortInternal(), i.onTimeout(this.stats, this.context, this.loader));
    }
  }
  retry(e) {
    const {
      context: t,
      stats: r
    } = this;
    this.retryDelay = g_(e, r.retry), r.retry++, un.warn(`${status ? "HTTP Status " + status : "Timeout"} while loading ${t?.url}, retrying ${r.retry}/${e.maxNumRetry} in ${this.retryDelay}ms`), this.abortInternal(), this.loader = null, self.clearTimeout(this.retryTimeout), this.retryTimeout = self.setTimeout(this.loadInternal.bind(this), this.retryDelay);
  }
  loadprogress(e) {
    const t = this.stats;
    t.loaded = e.loaded, e.lengthComputable && (t.total = e.total);
  }
  getCacheAge() {
    let e = null;
    if (this.loader && rZe.test(this.loader.getAllResponseHeaders())) {
      const t = this.loader.getResponseHeader("age");
      e = t ? parseFloat(t) : null;
    }
    return e;
  }
  getResponseHeader(e) {
    return this.loader && new RegExp(`^${e}:\\s*[\\d.]+\\s*$`, "im").test(this.loader.getAllResponseHeaders()) ? this.loader.getResponseHeader(e) : null;
  }
}
const iZe = {
  maxTimeToFirstByteMs: 8e3,
  maxLoadTimeMs: 2e4,
  timeoutRetry: null,
  errorRetry: null
}, sZe = cn(cn({
  autoStartLoad: !0,
  // used by stream-controller
  startPosition: -1,
  // used by stream-controller
  defaultAudioCodec: void 0,
  // used by stream-controller
  debug: !1,
  // used by logger
  capLevelOnFPSDrop: !1,
  // used by fps-controller
  capLevelToPlayerSize: !1,
  // used by cap-level-controller
  ignoreDevicePixelRatio: !1,
  // used by cap-level-controller
  maxDevicePixelRatio: Number.POSITIVE_INFINITY,
  // used by cap-level-controller
  preferManagedMediaSource: !0,
  initialLiveManifestSize: 1,
  // used by stream-controller
  maxBufferLength: 30,
  // used by stream-controller
  backBufferLength: 1 / 0,
  // used by buffer-controller
  frontBufferFlushThreshold: 1 / 0,
  startOnSegmentBoundary: !1,
  // used by stream-controller
  maxBufferSize: 60 * 1e3 * 1e3,
  // used by stream-controller
  maxFragLookUpTolerance: 0.25,
  // used by stream-controller
  maxBufferHole: 0.1,
  // used by stream-controller and gap-controller
  detectStallWithCurrentTimeMs: 1250,
  // used by gap-controller
  highBufferWatchdogPeriod: 2,
  // used by gap-controller
  nudgeOffset: 0.1,
  // used by gap-controller
  nudgeMaxRetry: 3,
  // used by gap-controller
  nudgeOnVideoHole: !0,
  // used by gap-controller
  liveSyncMode: "edge",
  // used by stream-controller
  liveSyncDurationCount: 3,
  // used by latency-controller
  liveSyncOnStallIncrease: 1,
  // used by latency-controller
  liveMaxLatencyDurationCount: 1 / 0,
  // used by latency-controller
  liveSyncDuration: void 0,
  // used by latency-controller
  liveMaxLatencyDuration: void 0,
  // used by latency-controller
  maxLiveSyncPlaybackRate: 1,
  // used by latency-controller
  liveDurationInfinity: !1,
  // used by buffer-controller
  /**
   * @deprecated use backBufferLength
   */
  liveBackBufferLength: null,
  // used by buffer-controller
  maxMaxBufferLength: 600,
  // used by stream-controller
  enableWorker: !0,
  // used by transmuxer
  workerPath: null,
  // used by transmuxer
  enableSoftwareAES: !0,
  // used by decrypter
  startLevel: void 0,
  // used by level-controller
  startFragPrefetch: !1,
  // used by stream-controller
  fpsDroppedMonitoringPeriod: 5e3,
  // used by fps-controller
  fpsDroppedMonitoringThreshold: 0.2,
  // used by fps-controller
  appendErrorMaxRetry: 3,
  // used by buffer-controller
  ignorePlaylistParsingErrors: !1,
  loader: ire,
  // loader: FetchLoader,
  fLoader: void 0,
  // used by fragment-loader
  pLoader: void 0,
  // used by playlist-loader
  xhrSetup: void 0,
  // used by xhr-loader
  licenseXhrSetup: void 0,
  // used by eme-controller
  licenseResponseCallback: void 0,
  // used by eme-controller
  abrController: vKe,
  bufferController: aYe,
  capLevelController: O_,
  errorController: EKe,
  fpsController: lXe,
  stretchShortVideoTrack: !1,
  // used by mp4-remuxer
  maxAudioFramesDrift: 1,
  // used by mp4-remuxer
  forceKeyFrameOnDiscontinuity: !0,
  // used by ts-demuxer
  abrEwmaFastLive: 3,
  // used by abr-controller
  abrEwmaSlowLive: 9,
  // used by abr-controller
  abrEwmaFastVoD: 3,
  // used by abr-controller
  abrEwmaSlowVoD: 9,
  // used by abr-controller
  abrEwmaDefaultEstimate: 5e5,
  // 500 kbps  // used by abr-controller
  abrEwmaDefaultEstimateMax: 5e6,
  // 5 mbps
  abrBandWidthFactor: 0.95,
  // used by abr-controller
  abrBandWidthUpFactor: 0.7,
  // used by abr-controller
  abrMaxWithRealBitrate: !1,
  // used by abr-controller
  maxStarvationDelay: 4,
  // used by abr-controller
  maxLoadingDelay: 4,
  // used by abr-controller
  minAutoBitrate: 0,
  // used by hls
  emeEnabled: !1,
  // used by eme-controller
  widevineLicenseUrl: void 0,
  // used by eme-controller
  drmSystems: {},
  // used by eme-controller
  drmSystemOptions: {},
  // used by eme-controller
  requestMediaKeySystemAccessFunc: nne,
  // used by eme-controller
  requireKeySystemAccessOnStart: !1,
  // used by eme-controller
  testBandwidth: !0,
  progressive: !1,
  lowLatencyMode: !0,
  cmcd: void 0,
  enableDateRangeMetadataCues: !0,
  enableEmsgMetadataCues: !0,
  enableEmsgKLVMetadata: !1,
  enableID3MetadataCues: !0,
  enableInterstitialPlayback: !0,
  interstitialAppendInPlace: !0,
  interstitialLiveLookAhead: 10,
  useMediaCapabilities: !0,
  preserveManualLevelOnError: !1,
  certLoadPolicy: {
    default: iZe
  },
  keyLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 8e3,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 2e4,
        backoff: "linear"
      },
      errorRetry: {
        maxNumRetry: 8,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 2e4,
        backoff: "linear"
      }
    }
  },
  manifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1 / 0,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  playlistLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 2,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  fragLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 12e4,
      timeoutRetry: {
        maxNumRetry: 4,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 6,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  steeringManifestLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 2e4,
      timeoutRetry: {
        maxNumRetry: 2,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 1,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  interstitialAssetListLoadPolicy: {
    default: {
      maxTimeToFirstByteMs: 1e4,
      maxLoadTimeMs: 3e4,
      timeoutRetry: {
        maxNumRetry: 0,
        retryDelayMs: 0,
        maxRetryDelayMs: 0
      },
      errorRetry: {
        maxNumRetry: 0,
        retryDelayMs: 1e3,
        maxRetryDelayMs: 8e3
      }
    }
  },
  // These default settings are deprecated in favor of the above policies
  // and are maintained for backwards compatibility
  manifestLoadingTimeOut: 1e4,
  manifestLoadingMaxRetry: 1,
  manifestLoadingRetryDelay: 1e3,
  manifestLoadingMaxRetryTimeout: 64e3,
  levelLoadingTimeOut: 1e4,
  levelLoadingMaxRetry: 4,
  levelLoadingRetryDelay: 1e3,
  levelLoadingMaxRetryTimeout: 64e3,
  fragLoadingTimeOut: 2e4,
  fragLoadingMaxRetry: 6,
  fragLoadingRetryDelay: 1e3,
  fragLoadingMaxRetryTimeout: 64e3
}, oZe()), {}, {
  subtitleStreamController: wXe,
  subtitleTrackController: dXe,
  timelineController: GXe,
  audioStreamController: rYe,
  audioTrackController: iYe,
  emeController: hf,
  cmcdController: iXe,
  contentSteeringController: oXe,
  interstitialsController: bXe
});
function oZe() {
  return {
    cueHandler: YXe,
    // used by timeline-controller
    enableWebVTT: !0,
    // used by timeline-controller
    enableIMSC1: !0,
    // used by timeline-controller
    enableCEA708Captions: !0,
    // used by timeline-controller
    captionsTextTrack1Label: "English",
    // used by timeline-controller
    captionsTextTrack1LanguageCode: "en",
    // used by timeline-controller
    captionsTextTrack2Label: "Spanish",
    // used by timeline-controller
    captionsTextTrack2LanguageCode: "es",
    // used by timeline-controller
    captionsTextTrack3Label: "Unknown CC",
    // used by timeline-controller
    captionsTextTrack3LanguageCode: "",
    // used by timeline-controller
    captionsTextTrack4Label: "Unknown CC",
    // used by timeline-controller
    captionsTextTrack4LanguageCode: "",
    // used by timeline-controller
    renderTextTracksNatively: !0
  };
}
function aZe(n, e, t) {
  if ((e.liveSyncDurationCount || e.liveMaxLatencyDurationCount) && (e.liveSyncDuration || e.liveMaxLatencyDuration))
    throw new Error("Illegal hls.js config: don't mix up liveSyncDurationCount/liveMaxLatencyDurationCount and liveSyncDuration/liveMaxLatencyDuration");
  if (e.liveMaxLatencyDurationCount !== void 0 && (e.liveSyncDurationCount === void 0 || e.liveMaxLatencyDurationCount <= e.liveSyncDurationCount))
    throw new Error('Illegal hls.js config: "liveMaxLatencyDurationCount" must be greater than "liveSyncDurationCount"');
  if (e.liveMaxLatencyDuration !== void 0 && (e.liveSyncDuration === void 0 || e.liveMaxLatencyDuration <= e.liveSyncDuration))
    throw new Error('Illegal hls.js config: "liveMaxLatencyDuration" must be greater than "liveSyncDuration"');
  const r = P7(n), i = ["manifest", "level", "frag"], s = ["TimeOut", "MaxRetry", "RetryDelay", "MaxRetryTimeout"];
  return i.forEach((o) => {
    const a = `${o === "level" ? "playlist" : o}LoadPolicy`, l = e[a] === void 0, c = [];
    s.forEach((u) => {
      const d = `${o}Loading${u}`, f = e[d];
      if (f !== void 0 && l) {
        c.push(d);
        const h = r[a].default;
        switch (e[a] = {
          default: h
        }, u) {
          case "TimeOut":
            h.maxLoadTimeMs = f, h.maxTimeToFirstByteMs = f;
            break;
          case "MaxRetry":
            h.errorRetry.maxNumRetry = f, h.timeoutRetry.maxNumRetry = f;
            break;
          case "RetryDelay":
            h.errorRetry.retryDelayMs = f, h.timeoutRetry.retryDelayMs = f;
            break;
          case "MaxRetryTimeout":
            h.errorRetry.maxRetryDelayMs = f, h.timeoutRetry.maxRetryDelayMs = f;
            break;
        }
      }
    }), c.length && t.warn(`hls.js config: "${c.join('", "')}" setting(s) are deprecated, use "${a}": ${Sn(e[a])}`);
  }), cn(cn({}, r), e);
}
function P7(n) {
  return n && typeof n == "object" ? Array.isArray(n) ? n.map(P7) : Object.keys(n).reduce((e, t) => (e[t] = P7(n[t]), e), {}) : n;
}
function lZe(n, e) {
  const t = n.loader;
  t !== HH && t !== ire ? (e.log("[config]: Custom loader detected, cannot enable progressive streaming"), n.progressive = !1) : XXe() && (n.loader = HH, n.progressive = !0, n.enableSoftwareAES = !0, e.log("[config]: Progressive streaming enabled, using FetchLoader"));
}
const Yv = 2, cZe = 0.1, uZe = 0.05, dZe = 100;
class fZe extends Zte {
  constructor(e, t) {
    super("gap-controller", e.logger), this.hls = void 0, this.fragmentTracker = void 0, this.media = null, this.mediaSource = void 0, this.nudgeRetry = 0, this.stallReported = !1, this.stalled = null, this.moved = !1, this.seeking = !1, this.buffered = {}, this.lastCurrentTime = 0, this.ended = 0, this.waiting = 0, this.onMediaPlaying = () => {
      this.ended = 0, this.waiting = 0;
    }, this.onMediaWaiting = () => {
      var r;
      (r = this.media) != null && r.seeking || (this.waiting = self.performance.now(), this.tick());
    }, this.onMediaEnded = () => {
      if (this.hls) {
        var r;
        this.ended = ((r = this.media) == null ? void 0 : r.currentTime) || 1, this.hls.trigger(N.MEDIA_ENDED, {
          stalled: !1
        });
      }
    }, this.hls = e, this.fragmentTracker = t, this.registerListeners();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e && (e.on(N.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(N.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(N.BUFFER_APPENDED, this.onBufferAppended, this));
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e && (e.off(N.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(N.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(N.BUFFER_APPENDED, this.onBufferAppended, this));
  }
  destroy() {
    super.destroy(), this.unregisterListeners(), this.media = this.hls = this.fragmentTracker = null, this.mediaSource = void 0;
  }
  onMediaAttached(e, t) {
    this.setInterval(dZe), this.mediaSource = t.mediaSource;
    const r = this.media = t.media;
    gi(r, "playing", this.onMediaPlaying), gi(r, "waiting", this.onMediaWaiting), gi(r, "ended", this.onMediaEnded);
  }
  onMediaDetaching(e, t) {
    this.clearInterval();
    const {
      media: r
    } = this;
    r && (Bi(r, "playing", this.onMediaPlaying), Bi(r, "waiting", this.onMediaWaiting), Bi(r, "ended", this.onMediaEnded), this.media = null), this.mediaSource = void 0;
  }
  onBufferAppended(e, t) {
    this.buffered = t.timeRanges;
  }
  get hasBuffered() {
    return Object.keys(this.buffered).length > 0;
  }
  tick() {
    var e;
    if (!((e = this.media) != null && e.readyState) || !this.hasBuffered)
      return;
    const t = this.media.currentTime;
    this.poll(t, this.lastCurrentTime), this.lastCurrentTime = t;
  }
  /**
   * Checks if the playhead is stuck within a gap, and if so, attempts to free it.
   * A gap is an unbuffered range between two buffered ranges (or the start and the first buffered range).
   *
   * @param lastCurrentTime - Previously read playhead position
   */
  poll(e, t) {
    var r, i;
    const s = (r = this.hls) == null ? void 0 : r.config;
    if (!s)
      return;
    const o = this.media;
    if (!o)
      return;
    const {
      seeking: a
    } = o, l = this.seeking && !a, c = !this.seeking && a, u = o.paused && !a || o.ended || o.playbackRate === 0;
    if (this.seeking = a, e !== t) {
      t && (this.ended = 0), this.moved = !0, a || (this.nudgeRetry = 0, s.nudgeOnVideoHole && !u && e > t && this.nudgeOnVideoHole(e, t)), this.waiting === 0 && this.stallResolved(e);
      return;
    }
    if (c || l) {
      l && this.stallResolved(e);
      return;
    }
    if (u) {
      this.nudgeRetry = 0, this.stallResolved(e), !this.ended && o.ended && this.hls && (this.ended = e || 1, this.hls.trigger(N.MEDIA_ENDED, {
        stalled: !1
      }));
      return;
    }
    if (!St.getBuffered(o).length) {
      this.nudgeRetry = 0;
      return;
    }
    const d = St.bufferInfo(o, e, 0), f = d.nextStart || 0, h = this.fragmentTracker;
    if (a && h && this.hls) {
      const C = UH(this.hls.inFlightFragments, e), S = d.len > Yv, M = !f || C || f - e > Yv && !h.getPartialFragment(e);
      if (S || M)
        return;
      this.moved = !1;
    }
    const m = (i = this.hls) == null ? void 0 : i.latestLevelDetails;
    if (!this.moved && this.stalled !== null && h) {
      if (!(d.len > 0) && !f)
        return;
      const S = Math.max(f, d.start || 0) - e, k = !!(m != null && m.live) ? m.targetduration * 2 : Yv, _ = jg(e, h);
      if (S > 0 && (S <= k || _)) {
        o.paused || this._trySkipBufferHole(_);
        return;
      }
    }
    const g = s.detectStallWithCurrentTimeMs, v = self.performance.now(), y = this.waiting;
    let b = this.stalled;
    if (b === null)
      if (y > 0 && v - y < g)
        b = this.stalled = y;
      else {
        this.stalled = v;
        return;
      }
    const x = v - b;
    if (!a && (x >= g || y) && this.hls) {
      var E;
      if (((E = this.mediaSource) == null ? void 0 : E.readyState) === "ended" && !(m != null && m.live) && Math.abs(e - (m?.edge || 0)) < 1) {
        if (this.ended)
          return;
        this.ended = e || 1, this.hls.trigger(N.MEDIA_ENDED, {
          stalled: !0
        });
        return;
      }
      if (this._reportStall(d), !this.media || !this.hls)
        return;
    }
    const w = St.bufferInfo(o, e, s.maxBufferHole);
    this._tryFixBufferStall(w, x, e);
  }
  stallResolved(e) {
    const t = this.stalled;
    if (t && this.hls && (this.stalled = null, this.stallReported)) {
      const r = self.performance.now() - t;
      this.log(`playback not stuck anymore @${e}, after ${Math.round(r)}ms`), this.stallReported = !1, this.waiting = 0, this.hls.trigger(N.STALL_RESOLVED, {});
    }
  }
  nudgeOnVideoHole(e, t) {
    var r;
    const i = this.buffered.video;
    if (this.hls && this.media && this.fragmentTracker && (r = this.buffered.audio) != null && r.length && i && i.length > 1 && e > i.end(0)) {
      const s = St.bufferedInfo(St.timeRangesToArray(this.buffered.audio), e, 0);
      if (s.len > 1 && t >= s.start) {
        const o = St.timeRangesToArray(i), a = St.bufferedInfo(o, t, 0).bufferedIndex;
        if (a > -1 && a < o.length - 1) {
          const l = St.bufferedInfo(o, e, 0).bufferedIndex, c = o[a].end, u = o[a + 1].start;
          if ((l === -1 || l > a) && u - c < 1 && // `maxBufferHole` may be too small and setting it to 0 should not disable this feature
          e - c < 2) {
            const d = new Error(`nudging playhead to flush pipeline after video hole. currentTime: ${e} hole: ${c} -> ${u} buffered index: ${l}`);
            this.warn(d.message), this.media.currentTime += 1e-6;
            let f = jg(e, this.fragmentTracker);
            f && "fragment" in f ? f = f.fragment : f || (f = void 0);
            const h = St.bufferInfo(this.media, e, 0);
            this.hls.trigger(N.ERROR, {
              type: Je.MEDIA_ERROR,
              details: ce.BUFFER_SEEK_OVER_HOLE,
              fatal: !1,
              error: d,
              reason: d.message,
              frag: f,
              buffer: h.len,
              bufferInfo: h
            });
          }
        }
      }
    }
  }
  /**
   * Detects and attempts to fix known buffer stalling issues.
   * @param bufferInfo - The properties of the current buffer.
   * @param stalledDurationMs - The amount of time Hls.js has been stalling for.
   * @private
   */
  _tryFixBufferStall(e, t, r) {
    var i, s;
    const {
      fragmentTracker: o,
      media: a
    } = this, l = (i = this.hls) == null ? void 0 : i.config;
    if (!a || !o || !l)
      return;
    const c = (s = this.hls) == null ? void 0 : s.latestLevelDetails, u = jg(r, o);
    if ((u || c != null && c.live && r < c.fragmentStart) && (this._trySkipBufferHole(u) || !this.media))
      return;
    const d = e.buffered, f = this.adjacentTraversal(e, r);
    (d && d.length > 1 && e.len > l.maxBufferHole || e.nextStart && (e.nextStart - r < l.maxBufferHole || f)) && (t > l.highBufferWatchdogPeriod * 1e3 || this.waiting) && (this.warn("Trying to nudge playhead over buffer-hole"), this._tryNudgeBuffer(e));
  }
  adjacentTraversal(e, t) {
    const r = this.fragmentTracker, i = e.nextStart;
    if (r && i) {
      const s = r.getFragAtPos(t, We.MAIN), o = r.getFragAtPos(i, We.MAIN);
      if (s && o)
        return o.sn - s.sn < 2;
    }
    return !1;
  }
  /**
   * Triggers a BUFFER_STALLED_ERROR event, but only once per stall period.
   * @param bufferLen - The playhead distance from the end of the current buffer segment.
   * @private
   */
  _reportStall(e) {
    const {
      hls: t,
      media: r,
      stallReported: i,
      stalled: s
    } = this;
    if (!i && s !== null && r && t) {
      this.stallReported = !0;
      const o = new Error(`Playback stalling at @${r.currentTime} due to low buffer (${Sn(e)})`);
      this.warn(o.message), t.trigger(N.ERROR, {
        type: Je.MEDIA_ERROR,
        details: ce.BUFFER_STALLED_ERROR,
        fatal: !1,
        error: o,
        buffer: e.len,
        bufferInfo: e,
        stalled: {
          start: s
        }
      });
    }
  }
  /**
   * Attempts to fix buffer stalls by jumping over known gaps caused by partial fragments
   * @param appended - The fragment or part found at the current time (where playback is stalling).
   * @private
   */
  _trySkipBufferHole(e) {
    var t;
    const {
      fragmentTracker: r,
      media: i
    } = this, s = (t = this.hls) == null ? void 0 : t.config;
    if (!i || !r || !s)
      return 0;
    const o = i.currentTime, a = St.bufferInfo(i, o, 0), l = o < a.start ? a.start : a.nextStart;
    if (l && this.hls) {
      const u = a.len <= s.maxBufferHole, d = a.len > 0 && a.len < 1 && i.readyState < 3, f = l - o;
      if (f > 0 && (u || d)) {
        if (f > s.maxBufferHole) {
          let m = !1;
          if (o === 0) {
            const g = r.getAppendedFrag(0, We.MAIN);
            g && l < g.end && (m = !0);
          }
          if (!m && e) {
            var c;
            if (!((c = this.hls.loadLevelObj) != null && c.details) || UH(this.hls.inFlightFragments, l))
              return 0;
            let v = !1, y = e.end;
            for (; y < l; ) {
              const b = jg(y, r);
              if (b)
                y += b.duration;
              else {
                v = !0;
                break;
              }
            }
            if (v)
              return 0;
          }
        }
        const h = Math.max(l + uZe, o + cZe);
        if (this.warn(`skipping hole, adjusting currentTime from ${o} to ${h}`), this.moved = !0, i.currentTime = h, !(e != null && e.gap)) {
          const m = new Error(`fragment loaded with buffer holes, seeking from ${o} to ${h}`), g = {
            type: Je.MEDIA_ERROR,
            details: ce.BUFFER_SEEK_OVER_HOLE,
            fatal: !1,
            error: m,
            reason: m.message,
            buffer: a.len,
            bufferInfo: a
          };
          e && ("fragment" in e ? g.part = e : g.frag = e), this.hls.trigger(N.ERROR, g);
        }
        return h;
      }
    }
    return 0;
  }
  /**
   * Attempts to fix buffer stalls by advancing the mediaElement's current time by a small amount.
   * @private
   */
  _tryNudgeBuffer(e) {
    const {
      hls: t,
      media: r,
      nudgeRetry: i
    } = this, s = t?.config;
    if (!r || !s)
      return 0;
    const o = r.currentTime;
    if (this.nudgeRetry++, i < s.nudgeMaxRetry) {
      const a = o + (i + 1) * s.nudgeOffset, l = new Error(`Nudging 'currentTime' from ${o} to ${a}`);
      this.warn(l.message), r.currentTime = a, t.trigger(N.ERROR, {
        type: Je.MEDIA_ERROR,
        details: ce.BUFFER_NUDGE_ON_STALL,
        error: l,
        fatal: !1,
        buffer: e.len,
        bufferInfo: e
      });
    } else {
      const a = new Error(`Playhead still not moving while enough data buffered @${o} after ${s.nudgeMaxRetry} nudges`);
      this.error(a.message), t.trigger(N.ERROR, {
        type: Je.MEDIA_ERROR,
        details: ce.BUFFER_STALLED_ERROR,
        error: a,
        fatal: !0,
        buffer: e.len,
        bufferInfo: e
      });
    }
  }
}
function UH(n, e) {
  const t = VH(n.main);
  if (t && t.start <= e)
    return t;
  const r = VH(n.audio);
  return r && r.start <= e ? r : null;
}
function VH(n) {
  if (!n)
    return null;
  switch (n.state) {
    case he.IDLE:
    case he.STOPPED:
    case he.ENDED:
    case he.ERROR:
      return null;
  }
  return n.frag;
}
function jg(n, e) {
  return e.getAppendedFrag(n, We.MAIN) || e.getPartialFragment(n);
}
const hZe = 0.25;
function D7() {
  if (!(typeof self > "u"))
    return self.VTTCue || self.TextTrackCue;
}
function z6(n, e, t, r, i) {
  let s = new n(e, t, "");
  try {
    s.value = r, i && (s.type = i);
  } catch {
    s = new n(e, t, Sn(i ? cn({
      type: i
    }, r) : r));
  }
  return s;
}
const Wg = (() => {
  const n = D7();
  try {
    n && new n(0, Number.POSITIVE_INFINITY, "");
  } catch {
    return Number.MAX_VALUE;
  }
  return Number.POSITIVE_INFINITY;
})();
class pZe {
  constructor(e) {
    this.hls = void 0, this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.removeCues = !0, this.assetCue = void 0, this.onEventCueEnter = () => {
      this.hls && this.hls.trigger(N.EVENT_CUE_ENTER, {});
    }, this.hls = e, this._registerListeners();
  }
  destroy() {
    this._unregisterListeners(), this.id3Track = null, this.media = null, this.dateRangeCuesAppended = {}, this.hls = this.onEventCueEnter = null;
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e && (e.on(N.MEDIA_ATTACHING, this.onMediaAttaching, this), e.on(N.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(N.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(N.MANIFEST_LOADING, this.onManifestLoading, this), e.on(N.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), e.on(N.BUFFER_FLUSHING, this.onBufferFlushing, this), e.on(N.LEVEL_UPDATED, this.onLevelUpdated, this), e.on(N.LEVEL_PTS_UPDATED, this.onLevelPtsUpdated, this));
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e && (e.off(N.MEDIA_ATTACHING, this.onMediaAttaching, this), e.off(N.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(N.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(N.MANIFEST_LOADING, this.onManifestLoading, this), e.off(N.FRAG_PARSING_METADATA, this.onFragParsingMetadata, this), e.off(N.BUFFER_FLUSHING, this.onBufferFlushing, this), e.off(N.LEVEL_UPDATED, this.onLevelUpdated, this), e.off(N.LEVEL_PTS_UPDATED, this.onLevelPtsUpdated, this));
  }
  // Add ID3 metatadata text track.
  onMediaAttaching(e, t) {
    var r;
    this.media = t.media, ((r = t.overrides) == null ? void 0 : r.cueRemoval) === !1 && (this.removeCues = !1);
  }
  onMediaAttached() {
    var e;
    const t = (e = this.hls) == null ? void 0 : e.latestLevelDetails;
    t && this.updateDateRangeCues(t);
  }
  onMediaDetaching(e, t) {
    this.media = null, !t.transferMedia && (this.id3Track && (this.removeCues && Zd(this.id3Track, this.onEventCueEnter), this.id3Track = null), this.dateRangeCuesAppended = {});
  }
  onManifestLoading() {
    this.dateRangeCuesAppended = {};
  }
  createTrack(e) {
    const t = this.getID3Track(e.textTracks);
    return t.mode = "hidden", t;
  }
  getID3Track(e) {
    if (this.media) {
      for (let t = 0; t < e.length; t++) {
        const r = e[t];
        if (r.kind === "metadata" && r.label === "id3")
          return Gne(r, this.media), r;
      }
      return this.media.addTextTrack("metadata", "id3");
    }
  }
  onFragParsingMetadata(e, t) {
    if (!this.media || !this.hls)
      return;
    const {
      enableEmsgMetadataCues: r,
      enableID3MetadataCues: i
    } = this.hls.config;
    if (!r && !i)
      return;
    const {
      samples: s
    } = t;
    this.id3Track || (this.id3Track = this.createTrack(this.media));
    const o = D7();
    if (o)
      for (let a = 0; a < s.length; a++) {
        const l = s[a].type;
        if (l === us.emsg && !r || !i)
          continue;
        const c = wne(s[a].data), u = s[a].pts;
        let d = u + s[a].duration;
        d > Wg && (d = Wg), d - u <= 0 && (d = u + hZe);
        for (let h = 0; h < c.length; h++) {
          const m = c[h];
          if (!xne(m)) {
            this.updateId3CueEnds(u, l);
            const g = z6(o, u, d, m, l);
            g && this.id3Track.addCue(g);
          }
        }
      }
  }
  updateId3CueEnds(e, t) {
    var r;
    const i = (r = this.id3Track) == null ? void 0 : r.cues;
    if (i)
      for (let s = i.length; s--; ) {
        const o = i[s];
        o.type === t && o.startTime < e && o.endTime === Wg && (o.endTime = e);
      }
  }
  onBufferFlushing(e, {
    startOffset: t,
    endOffset: r,
    type: i
  }) {
    const {
      id3Track: s,
      hls: o
    } = this;
    if (!o)
      return;
    const {
      config: {
        enableEmsgMetadataCues: a,
        enableID3MetadataCues: l
      }
    } = o;
    if (s && (a || l)) {
      let c;
      i === "audio" ? c = (u) => u.type === us.audioId3 && l : i === "video" ? c = (u) => u.type === us.emsg && a : c = (u) => u.type === us.audioId3 && l || u.type === us.emsg && a, I7(s, t, r, c);
    }
  }
  onLevelUpdated(e, {
    details: t
  }) {
    this.updateDateRangeCues(t, !0);
  }
  onLevelPtsUpdated(e, t) {
    Math.abs(t.drift) > 0.01 && this.updateDateRangeCues(t.details);
  }
  updateDateRangeCues(e, t) {
    if (!this.hls || !this.media)
      return;
    const {
      assetPlayerId: r,
      timelineOffset: i,
      enableDateRangeMetadataCues: s,
      interstitialsController: o
    } = this.hls.config;
    if (!s)
      return;
    const a = D7();
    if (r && i && !o) {
      const {
        fragmentStart: g,
        fragmentEnd: v
      } = e;
      let y = this.assetCue;
      y ? (y.startTime = g, y.endTime = v) : a && (y = this.assetCue = z6(a, g, v, {
        assetPlayerId: this.hls.config.assetPlayerId
      }, "hlsjs.interstitial.asset"), y && (y.id = r, this.id3Track || (this.id3Track = this.createTrack(this.media)), this.id3Track.addCue(y), y.addEventListener("enter", this.onEventCueEnter)));
    }
    if (!e.hasProgramDateTime)
      return;
    const {
      id3Track: l
    } = this, {
      dateRanges: c
    } = e, u = Object.keys(c);
    let d = this.dateRangeCuesAppended;
    if (l && t) {
      var f;
      if ((f = l.cues) != null && f.length) {
        const g = Object.keys(d).filter((v) => !u.includes(v));
        for (let v = g.length; v--; ) {
          var h;
          const y = g[v], b = (h = d[y]) == null ? void 0 : h.cues;
          delete d[y], b && Object.keys(b).forEach((x) => {
            const E = b[x];
            if (E) {
              E.removeEventListener("enter", this.onEventCueEnter);
              try {
                l.removeCue(E);
              } catch {
              }
            }
          });
        }
      } else
        d = this.dateRangeCuesAppended = {};
    }
    const m = e.fragments[e.fragments.length - 1];
    if (!(u.length === 0 || !He(m?.programDateTime))) {
      this.id3Track || (this.id3Track = this.createTrack(this.media));
      for (let g = 0; g < u.length; g++) {
        const v = u[g], y = c[v], b = y.startTime, x = d[v], E = x?.cues || {};
        let w = x?.durationKnown || !1, C = Wg;
        const {
          duration: S,
          endDate: M
        } = y;
        if (M && S !== null)
          C = b + S, w = !0;
        else if (y.endOnNext && !w) {
          const _ = u.reduce((O, I) => {
            if (I !== y.id) {
              const R = c[I];
              if (R.class === y.class && R.startDate > y.startDate && (!O || y.startDate < O.startDate))
                return R;
            }
            return O;
          }, null);
          _ && (C = _.startTime, w = !0);
        }
        const k = Object.keys(y.attr);
        for (let _ = 0; _ < k.length; _++) {
          const O = k[_];
          if (!NKe(O))
            continue;
          const I = E[O];
          if (I)
            w && !(x != null && x.durationKnown) ? I.endTime = C : Math.abs(I.startTime - b) > 0.01 && (I.startTime = b, I.endTime = C);
          else if (a) {
            let R = y.attr[O];
            LKe(O) && (R = Ite(R));
            const D = z6(a, b, C, {
              key: O,
              data: R
            }, us.dateRange);
            D && (D.id = v, this.id3Track.addCue(D), E[O] = D, o && (O === "X-ASSET-LIST" || O === "X-ASSET-URL") && D.addEventListener("enter", this.onEventCueEnter));
          }
        }
        d[v] = {
          cues: E,
          dateRange: y,
          durationKnown: w
        };
      }
    }
  }
}
class mZe {
  constructor(e) {
    this.hls = void 0, this.config = void 0, this.media = null, this.currentTime = 0, this.stallCount = 0, this._latency = null, this._targetLatencyUpdated = !1, this.onTimeupdate = () => {
      const {
        media: t
      } = this, r = this.levelDetails;
      if (!t || !r)
        return;
      this.currentTime = t.currentTime;
      const i = this.computeLatency();
      if (i === null)
        return;
      this._latency = i;
      const {
        lowLatencyMode: s,
        maxLiveSyncPlaybackRate: o
      } = this.config;
      if (!s || o === 1 || !r.live)
        return;
      const a = this.targetLatency;
      if (a === null)
        return;
      const l = i - a, c = Math.min(this.maxLatency, a + r.targetduration);
      if (l < c && l > 0.05 && this.forwardBufferLength > 1) {
        const d = Math.min(2, Math.max(1, o)), f = Math.round(2 / (1 + Math.exp(-0.75 * l - this.edgeStalled)) * 20) / 20, h = Math.min(d, Math.max(1, f));
        this.changeMediaPlaybackRate(t, h);
      } else t.playbackRate !== 1 && t.playbackRate !== 0 && this.changeMediaPlaybackRate(t, 1);
    }, this.hls = e, this.config = e.config, this.registerListeners();
  }
  get levelDetails() {
    var e;
    return ((e = this.hls) == null ? void 0 : e.latestLevelDetails) || null;
  }
  get latency() {
    return this._latency || 0;
  }
  get maxLatency() {
    const {
      config: e
    } = this;
    if (e.liveMaxLatencyDuration !== void 0)
      return e.liveMaxLatencyDuration;
    const t = this.levelDetails;
    return t ? e.liveMaxLatencyDurationCount * t.targetduration : 0;
  }
  get targetLatency() {
    const e = this.levelDetails;
    if (e === null || this.hls === null)
      return null;
    const {
      holdBack: t,
      partHoldBack: r,
      targetduration: i
    } = e, {
      liveSyncDuration: s,
      liveSyncDurationCount: o,
      lowLatencyMode: a
    } = this.config, l = this.hls.userConfig;
    let c = a && r || t;
    (this._targetLatencyUpdated || l.liveSyncDuration || l.liveSyncDurationCount || c === 0) && (c = s !== void 0 ? s : o * i);
    const u = i;
    return c + Math.min(this.stallCount * this.config.liveSyncOnStallIncrease, u);
  }
  set targetLatency(e) {
    this.stallCount = 0, this.config.liveSyncDuration = e, this._targetLatencyUpdated = !0;
  }
  get liveSyncPosition() {
    const e = this.estimateLiveEdge(), t = this.targetLatency;
    if (e === null || t === null)
      return null;
    const r = this.levelDetails;
    if (r === null)
      return null;
    const i = r.edge, s = e - t - this.edgeStalled, o = i - r.totalduration, a = i - (this.config.lowLatencyMode && r.partTarget || r.targetduration);
    return Math.min(Math.max(o, s), a);
  }
  get drift() {
    const e = this.levelDetails;
    return e === null ? 1 : e.drift;
  }
  get edgeStalled() {
    const e = this.levelDetails;
    if (e === null)
      return 0;
    const t = (this.config.lowLatencyMode && e.partTarget || e.targetduration) * 3;
    return Math.max(e.age - t, 0);
  }
  get forwardBufferLength() {
    const {
      media: e
    } = this, t = this.levelDetails;
    if (!e || !t)
      return 0;
    const r = e.buffered.length;
    return (r ? e.buffered.end(r - 1) : t.edge) - this.currentTime;
  }
  destroy() {
    this.unregisterListeners(), this.onMediaDetaching(), this.hls = null;
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e && (e.on(N.MEDIA_ATTACHED, this.onMediaAttached, this), e.on(N.MEDIA_DETACHING, this.onMediaDetaching, this), e.on(N.MANIFEST_LOADING, this.onManifestLoading, this), e.on(N.LEVEL_UPDATED, this.onLevelUpdated, this), e.on(N.ERROR, this.onError, this));
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e && (e.off(N.MEDIA_ATTACHED, this.onMediaAttached, this), e.off(N.MEDIA_DETACHING, this.onMediaDetaching, this), e.off(N.MANIFEST_LOADING, this.onManifestLoading, this), e.off(N.LEVEL_UPDATED, this.onLevelUpdated, this), e.off(N.ERROR, this.onError, this));
  }
  onMediaAttached(e, t) {
    this.media = t.media, this.media.addEventListener("timeupdate", this.onTimeupdate);
  }
  onMediaDetaching() {
    this.media && (this.media.removeEventListener("timeupdate", this.onTimeupdate), this.media = null);
  }
  onManifestLoading() {
    this._latency = null, this.stallCount = 0;
  }
  onLevelUpdated(e, {
    details: t
  }) {
    t.advanced && this.onTimeupdate(), !t.live && this.media && this.media.removeEventListener("timeupdate", this.onTimeupdate);
  }
  onError(e, t) {
    var r;
    t.details === ce.BUFFER_STALLED_ERROR && (this.stallCount++, this.hls && (r = this.levelDetails) != null && r.live && this.hls.logger.warn("[latency-controller]: Stall detected, adjusting target latency"));
  }
  changeMediaPlaybackRate(e, t) {
    var r, i;
    e.playbackRate !== t && ((r = this.hls) == null || r.logger.debug(`[latency-controller]: latency=${this.latency.toFixed(3)}, targetLatency=${(i = this.targetLatency) == null ? void 0 : i.toFixed(3)}, forwardBufferLength=${this.forwardBufferLength.toFixed(3)}: adjusting playback rate from ${e.playbackRate} to ${t}`), e.playbackRate = t);
  }
  estimateLiveEdge() {
    const e = this.levelDetails;
    return e === null ? null : e.edge + e.age;
  }
  computeLatency() {
    const e = this.estimateLiveEdge();
    return e === null ? null : e - this.currentTime;
  }
}
class gZe extends __ {
  constructor(e, t) {
    super(e, "level-controller"), this._levels = [], this._firstLevel = -1, this._maxAutoLevel = -1, this._startLevel = void 0, this.currentLevel = null, this.currentLevelIndex = -1, this.manualLevelIndex = -1, this.steering = void 0, this.onParsedComplete = void 0, this.steering = t, this._registerListeners();
  }
  _registerListeners() {
    const {
      hls: e
    } = this;
    e.on(N.MANIFEST_LOADING, this.onManifestLoading, this), e.on(N.MANIFEST_LOADED, this.onManifestLoaded, this), e.on(N.LEVEL_LOADED, this.onLevelLoaded, this), e.on(N.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(N.FRAG_BUFFERED, this.onFragBuffered, this), e.on(N.ERROR, this.onError, this);
  }
  _unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(N.MANIFEST_LOADING, this.onManifestLoading, this), e.off(N.MANIFEST_LOADED, this.onManifestLoaded, this), e.off(N.LEVEL_LOADED, this.onLevelLoaded, this), e.off(N.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(N.FRAG_BUFFERED, this.onFragBuffered, this), e.off(N.ERROR, this.onError, this);
  }
  destroy() {
    this._unregisterListeners(), this.steering = null, this.resetLevels(), super.destroy();
  }
  stopLoad() {
    this._levels.forEach((t) => {
      t.loadError = 0, t.fragmentError = 0;
    }), super.stopLoad();
  }
  resetLevels() {
    this._startLevel = void 0, this.manualLevelIndex = -1, this.currentLevelIndex = -1, this.currentLevel = null, this._levels = [], this._maxAutoLevel = -1;
  }
  onManifestLoading(e, t) {
    this.resetLevels();
  }
  onManifestLoaded(e, t) {
    const r = this.hls.config.preferManagedMediaSource, i = [], s = {}, o = {};
    let a = !1, l = !1, c = !1;
    t.levels.forEach((u) => {
      const d = u.attrs;
      let {
        audioCodec: f,
        videoCodec: h
      } = u;
      f && (u.audioCodec = f = By(f, r) || void 0), h && (h = u.videoCodec = QGe(h));
      const {
        width: m,
        height: g,
        unknownCodecs: v
      } = u, y = v?.length || 0;
      if (a || (a = !!(m && g)), l || (l = !!h), c || (c = !!f), y || f && !this.isAudioSupported(f) || h && !this.isVideoSupported(h)) {
        this.log(`Some or all CODECS not supported "${d.CODECS}"`);
        return;
      }
      const {
        CODECS: b,
        "FRAME-RATE": x,
        "HDCP-LEVEL": E,
        "PATHWAY-ID": w,
        RESOLUTION: C,
        "VIDEO-RANGE": S
      } = d, k = `${`${w || "."}-`}${u.bitrate}-${C}-${x}-${b}-${S}-${E}`;
      if (s[k])
        if (s[k].uri !== u.url && !u.attrs["PATHWAY-ID"]) {
          const _ = o[k] += 1;
          u.attrs["PATHWAY-ID"] = new Array(_ + 1).join(".");
          const O = this.createLevel(u);
          s[k] = O, i.push(O);
        } else
          s[k].addGroupId("audio", d.AUDIO), s[k].addGroupId("text", d.SUBTITLES);
      else {
        const _ = this.createLevel(u);
        s[k] = _, o[k] = 1, i.push(_);
      }
    }), this.filterAndSortMediaOptions(i, t, a, l, c);
  }
  createLevel(e) {
    const t = new E0(e), r = e.supplemental;
    if (r != null && r.videoCodec && !this.isVideoSupported(r.videoCodec)) {
      const i = new Error(`SUPPLEMENTAL-CODECS not supported "${r.videoCodec}"`);
      this.log(i.message), t.supportedResult = Vte(i, []);
    }
    return t;
  }
  isAudioSupported(e) {
    return w0(e, "audio", this.hls.config.preferManagedMediaSource);
  }
  isVideoSupported(e) {
    return w0(e, "video", this.hls.config.preferManagedMediaSource);
  }
  filterAndSortMediaOptions(e, t, r, i, s) {
    var o;
    let a = [], l = [], c = e;
    const u = ((o = t.stats) == null ? void 0 : o.parsing) || {};
    if ((r || i) && s && (c = c.filter(({
      videoCodec: b,
      videoRange: x,
      width: E,
      height: w
    }) => (!!b || !!(E && w)) && lKe(x))), c.length === 0) {
      Promise.resolve().then(() => {
        if (this.hls) {
          let b = "no level with compatible codecs found in manifest", x = b;
          t.levels.length && (x = `one or more CODECS in variant not supported: ${Sn(t.levels.map((w) => w.attrs.CODECS).filter((w, C, S) => S.indexOf(w) === C))}`, this.warn(x), b += ` (${x})`);
          const E = new Error(b);
          this.hls.trigger(N.ERROR, {
            type: Je.MEDIA_ERROR,
            details: ce.MANIFEST_INCOMPATIBLE_CODECS_ERROR,
            fatal: !0,
            url: t.url,
            error: E,
            reason: x
          });
        }
      }), u.end = performance.now();
      return;
    }
    t.audioTracks && (a = t.audioTracks.filter((b) => !b.audioCodec || this.isAudioSupported(b.audioCodec)), jH(a)), t.subtitles && (l = t.subtitles, jH(l));
    const d = c.slice(0);
    c.sort((b, x) => {
      if (b.attrs["HDCP-LEVEL"] !== x.attrs["HDCP-LEVEL"])
        return (b.attrs["HDCP-LEVEL"] || "") > (x.attrs["HDCP-LEVEL"] || "") ? 1 : -1;
      if (r && b.height !== x.height)
        return b.height - x.height;
      if (b.frameRate !== x.frameRate)
        return b.frameRate - x.frameRate;
      if (b.videoRange !== x.videoRange)
        return zy.indexOf(b.videoRange) - zy.indexOf(x.videoRange);
      if (b.videoCodec !== x.videoCodec) {
        const E = Nz(b.videoCodec), w = Nz(x.videoCodec);
        if (E !== w)
          return w - E;
      }
      if (b.uri === x.uri && b.codecSet !== x.codecSet) {
        const E = Fy(b.codecSet), w = Fy(x.codecSet);
        if (E !== w)
          return w - E;
      }
      return b.averageBitrate !== x.averageBitrate ? b.averageBitrate - x.averageBitrate : 0;
    });
    let f = d[0];
    if (this.steering && (c = this.steering.filterParsedLevels(c), c.length !== d.length)) {
      for (let b = 0; b < d.length; b++)
        if (d[b].pathwayId === c[0].pathwayId) {
          f = d[b];
          break;
        }
    }
    this._levels = c;
    for (let b = 0; b < c.length; b++)
      if (c[b] === f) {
        var h;
        this._firstLevel = b;
        const x = f.bitrate, E = this.hls.bandwidthEstimate;
        if (this.log(`manifest loaded, ${c.length} level(s) found, first bitrate: ${x}`), ((h = this.hls.userConfig) == null ? void 0 : h.abrEwmaDefaultEstimate) === void 0) {
          const w = Math.min(x, this.hls.config.abrEwmaDefaultEstimateMax);
          w > E && E === this.hls.abrEwmaDefaultEstimate && (this.hls.bandwidthEstimate = w);
        }
        break;
      }
    const m = s && !i, g = this.hls.config, v = !!(g.audioStreamController && g.audioTrackController), y = {
      levels: c,
      audioTracks: a,
      subtitleTracks: l,
      sessionData: t.sessionData,
      sessionKeys: t.sessionKeys,
      firstLevel: this._firstLevel,
      stats: t.stats,
      audio: s,
      video: i,
      altAudio: v && !m && a.some((b) => !!b.url)
    };
    u.end = performance.now(), this.hls.trigger(N.MANIFEST_PARSED, y);
  }
  get levels() {
    return this._levels.length === 0 ? null : this._levels;
  }
  get loadLevelObj() {
    return this.currentLevel;
  }
  get level() {
    return this.currentLevelIndex;
  }
  set level(e) {
    const t = this._levels;
    if (t.length === 0)
      return;
    if (e < 0 || e >= t.length) {
      const u = new Error("invalid level idx"), d = e < 0;
      if (this.hls.trigger(N.ERROR, {
        type: Je.OTHER_ERROR,
        details: ce.LEVEL_SWITCH_ERROR,
        level: e,
        fatal: d,
        error: u,
        reason: u.message
      }), d)
        return;
      e = Math.min(e, t.length - 1);
    }
    const r = this.currentLevelIndex, i = this.currentLevel, s = i ? i.attrs["PATHWAY-ID"] : void 0, o = t[e], a = o.attrs["PATHWAY-ID"];
    if (this.currentLevelIndex = e, this.currentLevel = o, r === e && i && s === a)
      return;
    this.log(`Switching to level ${e} (${o.height ? o.height + "p " : ""}${o.videoRange ? o.videoRange + " " : ""}${o.codecSet ? o.codecSet + " " : ""}@${o.bitrate})${a ? " with Pathway " + a : ""} from level ${r}${s ? " with Pathway " + s : ""}`);
    const l = {
      level: e,
      attrs: o.attrs,
      details: o.details,
      bitrate: o.bitrate,
      averageBitrate: o.averageBitrate,
      maxBitrate: o.maxBitrate,
      realBitrate: o.realBitrate,
      width: o.width,
      height: o.height,
      codecSet: o.codecSet,
      audioCodec: o.audioCodec,
      videoCodec: o.videoCodec,
      audioGroups: o.audioGroups,
      subtitleGroups: o.subtitleGroups,
      loaded: o.loaded,
      loadError: o.loadError,
      fragmentError: o.fragmentError,
      name: o.name,
      id: o.id,
      uri: o.uri,
      url: o.url,
      urlId: 0,
      audioGroupIds: o.audioGroupIds,
      textGroupIds: o.textGroupIds
    };
    this.hls.trigger(N.LEVEL_SWITCHING, l);
    const c = o.details;
    if (!c || c.live) {
      const u = this.switchParams(o.uri, i?.details, c);
      this.loadPlaylist(u);
    }
  }
  get manualLevel() {
    return this.manualLevelIndex;
  }
  set manualLevel(e) {
    this.manualLevelIndex = e, this._startLevel === void 0 && (this._startLevel = e), e !== -1 && (this.level = e);
  }
  get firstLevel() {
    return this._firstLevel;
  }
  set firstLevel(e) {
    this._firstLevel = e;
  }
  get startLevel() {
    if (this._startLevel === void 0) {
      const e = this.hls.config.startLevel;
      return e !== void 0 ? e : this.hls.firstAutoLevel;
    }
    return this._startLevel;
  }
  set startLevel(e) {
    this._startLevel = e;
  }
  get pathways() {
    return this.steering ? this.steering.pathways() : [];
  }
  get pathwayPriority() {
    return this.steering ? this.steering.pathwayPriority : null;
  }
  set pathwayPriority(e) {
    if (this.steering) {
      const t = this.steering.pathways(), r = e.filter((i) => t.indexOf(i) !== -1);
      if (e.length < 1) {
        this.warn(`pathwayPriority ${e} should contain at least one pathway from list: ${t}`);
        return;
      }
      this.steering.pathwayPriority = r;
    }
  }
  onError(e, t) {
    t.fatal || !t.context || t.context.type === Dt.LEVEL && t.context.level === this.level && this.checkRetry(t);
  }
  // reset errors on the successful load of a fragment
  onFragBuffered(e, {
    frag: t
  }) {
    if (t !== void 0 && t.type === We.MAIN) {
      const r = t.elementaryStreams;
      if (!Object.keys(r).some((s) => !!r[s]))
        return;
      const i = this._levels[t.level];
      i != null && i.loadError && (this.log(`Resetting level error count of ${i.loadError} on frag buffered`), i.loadError = 0);
    }
  }
  onLevelLoaded(e, t) {
    var r;
    const {
      level: i,
      details: s
    } = t, o = t.levelInfo;
    if (!o) {
      var a;
      this.warn(`Invalid level index ${i}`), (a = t.deliveryDirectives) != null && a.skip && (s.deltaUpdateFailed = !0);
      return;
    }
    if (o === this.currentLevel || t.withoutMultiVariant) {
      o.fragmentError === 0 && (o.loadError = 0);
      let l = o.details;
      l === t.details && l.advanced && (l = void 0), this.playlistLoaded(i, t, l);
    } else (r = t.deliveryDirectives) != null && r.skip && (s.deltaUpdateFailed = !0);
  }
  loadPlaylist(e) {
    super.loadPlaylist(), this.shouldLoadPlaylist(this.currentLevel) && this.scheduleLoading(this.currentLevel, e);
  }
  loadingPlaylist(e, t) {
    super.loadingPlaylist(e, t);
    const r = this.getUrlWithDirectives(e.uri, t), i = this.currentLevelIndex, s = e.attrs["PATHWAY-ID"], o = e.details, a = o?.age;
    this.log(`Loading level index ${i}${t?.msn !== void 0 ? " at sn " + t.msn + " part " + t.part : ""}${s ? " Pathway " + s : ""}${a && o.live ? " age " + a.toFixed(1) + (o.type && " " + o.type || "") : ""} ${r}`), this.hls.trigger(N.LEVEL_LOADING, {
      url: r,
      level: i,
      levelInfo: e,
      pathwayId: e.attrs["PATHWAY-ID"],
      id: 0,
      // Deprecated Level urlId
      deliveryDirectives: t || null
    });
  }
  get nextLoadLevel() {
    return this.manualLevelIndex !== -1 ? this.manualLevelIndex : this.hls.nextAutoLevel;
  }
  set nextLoadLevel(e) {
    this.level = e, this.manualLevelIndex === -1 && (this.hls.nextAutoLevel = e);
  }
  removeLevel(e) {
    var t;
    if (this._levels.length === 1)
      return;
    const r = this._levels.filter((s, o) => o !== e ? !0 : (this.steering && this.steering.removeLevel(s), s === this.currentLevel && (this.currentLevel = null, this.currentLevelIndex = -1, s.details && s.details.fragments.forEach((a) => a.level = -1)), !1));
    une(r), this._levels = r, this.currentLevelIndex > -1 && (t = this.currentLevel) != null && t.details && (this.currentLevelIndex = this.currentLevel.details.fragments[0].level), this.manualLevelIndex > -1 && (this.manualLevelIndex = this.currentLevelIndex);
    const i = r.length - 1;
    this._firstLevel = Math.min(this._firstLevel, i), this._startLevel && (this._startLevel = Math.min(this._startLevel, i)), this.hls.trigger(N.LEVELS_UPDATED, {
      levels: r
    });
  }
  onLevelsUpdated(e, {
    levels: t
  }) {
    this._levels = t;
  }
  checkMaxAutoUpdated() {
    const {
      autoLevelCapping: e,
      maxAutoLevel: t,
      maxHdcpLevel: r
    } = this.hls;
    this._maxAutoLevel !== t && (this._maxAutoLevel = t, this.hls.trigger(N.MAX_AUTO_LEVEL_UPDATED, {
      autoLevelCapping: e,
      levels: this.levels,
      maxAutoLevel: t,
      minAutoLevel: this.hls.minAutoLevel,
      maxHdcpLevel: r
    }));
  }
}
function jH(n) {
  const e = {};
  n.forEach((t) => {
    const r = t.groupId || "";
    t.id = e[r] = e[r] || 0, e[r]++;
  });
}
function sre() {
  return self.SourceBuffer || self.WebKitSourceBuffer;
}
function ore() {
  if (!gc())
    return !1;
  const e = sre();
  return !e || e.prototype && typeof e.prototype.appendBuffer == "function" && typeof e.prototype.remove == "function";
}
function vZe() {
  if (!ore())
    return !1;
  const n = gc();
  return typeof n?.isTypeSupported == "function" && (["avc1.42E01E,mp4a.40.2", "av01.0.01M.08", "vp09.00.50.08"].some((e) => n.isTypeSupported(x0(e, "video"))) || ["mp4a.40.2", "fLaC"].some((e) => n.isTypeSupported(x0(e, "audio"))));
}
function yZe() {
  var n;
  const e = sre();
  return typeof (e == null || (n = e.prototype) == null ? void 0 : n.changeType) == "function";
}
const bZe = 100;
class wZe extends x_ {
  constructor(e, t, r) {
    super(e, t, r, "stream-controller", We.MAIN), this.audioCodecSwap = !1, this.level = -1, this._forceStartLoad = !1, this._hasEnoughToStart = !1, this.altAudio = 0, this.audioOnly = !1, this.fragPlaying = null, this.fragLastKbps = 0, this.couldBacktrack = !1, this.backtrackFragment = null, this.audioCodecSwitch = !1, this.videoBuffer = null, this.onMediaPlaying = () => {
      this.tick();
    }, this.onMediaSeeked = () => {
      const i = this.media, s = i ? i.currentTime : null;
      if (s === null || !He(s) || (this.log(`Media seeked to ${s.toFixed(3)}`), !this.getBufferedFrag(s)))
        return;
      const o = this.getFwdBufferInfoAtPos(i, s, We.MAIN, 0);
      if (o === null || o.len === 0) {
        this.warn(`Main forward buffer length at ${s} on "seeked" event ${o ? o.len : "empty"})`);
        return;
      }
      this.tick();
    }, this.registerListeners();
  }
  registerListeners() {
    super.registerListeners();
    const {
      hls: e
    } = this;
    e.on(N.MANIFEST_PARSED, this.onManifestParsed, this), e.on(N.LEVEL_LOADING, this.onLevelLoading, this), e.on(N.LEVEL_LOADED, this.onLevelLoaded, this), e.on(N.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), e.on(N.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.on(N.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.on(N.BUFFER_CREATED, this.onBufferCreated, this), e.on(N.BUFFER_FLUSHED, this.onBufferFlushed, this), e.on(N.LEVELS_UPDATED, this.onLevelsUpdated, this), e.on(N.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  unregisterListeners() {
    super.unregisterListeners();
    const {
      hls: e
    } = this;
    e.off(N.MANIFEST_PARSED, this.onManifestParsed, this), e.off(N.LEVEL_LOADED, this.onLevelLoaded, this), e.off(N.FRAG_LOAD_EMERGENCY_ABORTED, this.onFragLoadEmergencyAborted, this), e.off(N.AUDIO_TRACK_SWITCHING, this.onAudioTrackSwitching, this), e.off(N.AUDIO_TRACK_SWITCHED, this.onAudioTrackSwitched, this), e.off(N.BUFFER_CREATED, this.onBufferCreated, this), e.off(N.BUFFER_FLUSHED, this.onBufferFlushed, this), e.off(N.LEVELS_UPDATED, this.onLevelsUpdated, this), e.off(N.FRAG_BUFFERED, this.onFragBuffered, this);
  }
  onHandlerDestroying() {
    this.onMediaPlaying = this.onMediaSeeked = null, this.unregisterListeners(), super.onHandlerDestroying();
  }
  startLoad(e, t) {
    if (this.levels) {
      const {
        lastCurrentTime: r,
        hls: i
      } = this;
      if (this.stopLoad(), this.setInterval(bZe), this.level = -1, !this.startFragRequested) {
        let s = i.startLevel;
        s === -1 && (i.config.testBandwidth && this.levels.length > 1 ? (s = 0, this.bitrateTest = !0) : s = i.firstAutoLevel), i.nextLoadLevel = s, this.level = i.loadLevel, this._hasEnoughToStart = !!t;
      }
      r > 0 && e === -1 && !t && (this.log(`Override startPosition with lastCurrentTime @${r.toFixed(3)}`), e = r), this.state = he.IDLE, this.nextLoadPosition = this.lastCurrentTime = e + this.timelineOffset, this.startPosition = t ? -1 : e, this.tick();
    } else
      this._forceStartLoad = !0, this.state = he.STOPPED;
  }
  stopLoad() {
    this._forceStartLoad = !1, super.stopLoad();
  }
  doTick() {
    switch (this.state) {
      case he.WAITING_LEVEL: {
        const {
          levels: e,
          level: t
        } = this, r = e?.[t], i = r?.details;
        if (i && (!i.live || this.levelLastLoaded === r && !this.waitForLive(r))) {
          if (this.waitForCdnTuneIn(i))
            break;
          this.state = he.IDLE;
          break;
        } else if (this.hls.nextLoadLevel !== this.level) {
          this.state = he.IDLE;
          break;
        }
        break;
      }
      case he.FRAG_LOADING_WAITING_RETRY:
        this.checkRetryDate();
        break;
    }
    this.state === he.IDLE && this.doTickIdle(), this.onTickEnd();
  }
  onTickEnd() {
    var e;
    super.onTickEnd(), (e = this.media) != null && e.readyState && this.media.seeking === !1 && (this.lastCurrentTime = this.media.currentTime), this.checkFragmentChanged();
  }
  doTickIdle() {
    const {
      hls: e,
      levelLastLoaded: t,
      levels: r,
      media: i
    } = this;
    if (t === null || !i && !this.primaryPrefetch && (this.startFragRequested || !e.config.startFragPrefetch) || this.altAudio && this.audioOnly)
      return;
    const s = this.buffering ? e.nextLoadLevel : e.loadLevel;
    if (!(r != null && r[s]))
      return;
    const o = r[s], a = this.getMainFwdBufferInfo();
    if (a === null)
      return;
    const l = this.getLevelDetails();
    if (l && this._streamEnded(a, l)) {
      const g = {};
      this.altAudio === 2 && (g.type = "video"), this.hls.trigger(N.BUFFER_EOS, g), this.state = he.ENDED;
      return;
    }
    if (!this.buffering)
      return;
    e.loadLevel !== s && e.manualLevel === -1 && this.log(`Adapting to level ${s} from level ${this.level}`), this.level = e.nextLoadLevel = s;
    const c = o.details;
    if (!c || this.state === he.WAITING_LEVEL || this.waitForLive(o)) {
      this.level = s, this.state = he.WAITING_LEVEL, this.startFragRequested = !1;
      return;
    }
    const u = a.len, d = this.getMaxBufferLength(o.maxBitrate);
    if (u >= d)
      return;
    this.backtrackFragment && this.backtrackFragment.start > a.end && (this.backtrackFragment = null);
    const f = this.backtrackFragment ? this.backtrackFragment.start : a.end;
    let h = this.getNextFragment(f, c);
    if (this.couldBacktrack && !this.fragPrevious && h && tr(h) && this.fragmentTracker.getState(h) !== wr.OK) {
      var m;
      const v = ((m = this.backtrackFragment) != null ? m : h).sn - c.startSN, y = c.fragments[v - 1];
      y && h.cc === y.cc && (h = y, this.fragmentTracker.removeFragment(y));
    } else this.backtrackFragment && a.len && (this.backtrackFragment = null);
    if (h && this.isLoopLoading(h, f)) {
      if (!h.gap) {
        const v = this.audioOnly && !this.altAudio ? wn.AUDIO : wn.VIDEO, y = (v === wn.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
        y && this.afterBufferFlushed(y, v, We.MAIN);
      }
      h = this.getNextFragmentLoopLoading(h, c, a, We.MAIN, d);
    }
    h && (h.initSegment && !h.initSegment.data && !this.bitrateTest && (h = h.initSegment), this.loadFragment(h, o, f));
  }
  loadFragment(e, t, r) {
    const i = this.fragmentTracker.getState(e);
    i === wr.NOT_LOADED || i === wr.PARTIAL ? tr(e) ? this.bitrateTest ? (this.log(`Fragment ${e.sn} of level ${e.level} is being downloaded to test bitrate and will not be buffered`), this._loadBitrateTestFrag(e, t)) : super.loadFragment(e, t, r) : this._loadInitSegment(e, t) : this.clearTrackerIfNeeded(e);
  }
  getBufferedFrag(e) {
    return this.fragmentTracker.getBufferedFrag(e, We.MAIN);
  }
  followingBufferedFrag(e) {
    return e ? this.getBufferedFrag(e.end + 0.5) : null;
  }
  /*
    on immediate level switch :
     - pause playback if playing
     - cancel any pending load request
     - and trigger a buffer flush
  */
  immediateLevelSwitch() {
    this.abortCurrentFrag(), this.flushMainBuffer(0, Number.POSITIVE_INFINITY);
  }
  /**
   * try to switch ASAP without breaking video playback:
   * in order to ensure smooth but quick level switching,
   * we need to find the next flushable buffer range
   * we should take into account new segment fetch time
   */
  nextLevelSwitch() {
    const {
      levels: e,
      media: t
    } = this;
    if (t != null && t.readyState) {
      let r;
      const i = this.getAppendedFrag(t.currentTime);
      i && i.start > 1 && this.flushMainBuffer(0, i.start - 1);
      const s = this.getLevelDetails();
      if (s != null && s.live) {
        const a = this.getMainFwdBufferInfo();
        if (!a || a.len < s.targetduration * 2)
          return;
      }
      if (!t.paused && e) {
        const a = this.hls.nextLoadLevel, l = e[a], c = this.fragLastKbps;
        c && this.fragCurrent ? r = this.fragCurrent.duration * l.maxBitrate / (1e3 * c) + 1 : r = 0;
      } else
        r = 0;
      const o = this.getBufferedFrag(t.currentTime + r);
      if (o) {
        const a = this.followingBufferedFrag(o);
        if (a) {
          this.abortCurrentFrag();
          const l = a.maxStartPTS ? a.maxStartPTS : a.start, c = a.duration, u = Math.max(o.end, l + Math.min(Math.max(c - this.config.maxFragLookUpTolerance, c * (this.couldBacktrack ? 0.5 : 0.125)), c * (this.couldBacktrack ? 0.75 : 0.25)));
          this.flushMainBuffer(u, Number.POSITIVE_INFINITY);
        }
      }
    }
  }
  abortCurrentFrag() {
    const e = this.fragCurrent;
    switch (this.fragCurrent = null, this.backtrackFragment = null, e && (e.abortRequests(), this.fragmentTracker.removeFragment(e)), this.state) {
      case he.KEY_LOADING:
      case he.FRAG_LOADING:
      case he.FRAG_LOADING_WAITING_RETRY:
      case he.PARSING:
      case he.PARSED:
        this.state = he.IDLE;
        break;
    }
    this.nextLoadPosition = this.getLoadPosition();
  }
  flushMainBuffer(e, t) {
    super.flushMainBuffer(e, t, this.altAudio === 2 ? "video" : null);
  }
  onMediaAttached(e, t) {
    super.onMediaAttached(e, t);
    const r = t.media;
    gi(r, "playing", this.onMediaPlaying), gi(r, "seeked", this.onMediaSeeked);
  }
  onMediaDetaching(e, t) {
    const {
      media: r
    } = this;
    r && (Bi(r, "playing", this.onMediaPlaying), Bi(r, "seeked", this.onMediaSeeked)), this.videoBuffer = null, this.fragPlaying = null, super.onMediaDetaching(e, t), !t.transferMedia && (this._hasEnoughToStart = !1);
  }
  onManifestLoading() {
    super.onManifestLoading(), this.log("Trigger BUFFER_RESET"), this.hls.trigger(N.BUFFER_RESET, void 0), this.couldBacktrack = !1, this.fragLastKbps = 0, this.fragPlaying = this.backtrackFragment = null, this.altAudio = 0, this.audioOnly = !1;
  }
  onManifestParsed(e, t) {
    let r = !1, i = !1;
    for (let s = 0; s < t.levels.length; s++) {
      const o = t.levels[s].audioCodec;
      o && (r = r || o.indexOf("mp4a.40.2") !== -1, i = i || o.indexOf("mp4a.40.5") !== -1);
    }
    this.audioCodecSwitch = r && i && !yZe(), this.audioCodecSwitch && this.log("Both AAC/HE-AAC audio found in levels; declaring level codec as HE-AAC"), this.levels = t.levels, this.startFragRequested = !1;
  }
  onLevelLoading(e, t) {
    const {
      levels: r
    } = this;
    if (!r || this.state !== he.IDLE)
      return;
    const i = t.levelInfo;
    (!i.details || i.details.live && (this.levelLastLoaded !== i || i.details.expired) || this.waitForCdnTuneIn(i.details)) && (this.state = he.WAITING_LEVEL);
  }
  onLevelLoaded(e, t) {
    var r;
    const {
      levels: i,
      startFragRequested: s
    } = this, o = t.level, a = t.details, l = a.totalduration;
    if (!i) {
      this.warn(`Levels were reset while loading level ${o}`);
      return;
    }
    this.log(`Level ${o} loaded [${a.startSN},${a.endSN}]${a.lastPartSn ? `[part-${a.lastPartSn}-${a.lastPartIndex}]` : ""}, cc [${a.startCC}, ${a.endCC}] duration:${l}`);
    const c = t.levelInfo, u = this.fragCurrent;
    u && (this.state === he.FRAG_LOADING || this.state === he.FRAG_LOADING_WAITING_RETRY) && u.level !== t.level && u.loader && this.abortCurrentFrag();
    let d = 0;
    if (a.live || (r = c.details) != null && r.live) {
      var f;
      if (this.checkLiveUpdate(a), a.deltaUpdateFailed)
        return;
      d = this.alignPlaylists(a, c.details, (f = this.levelLastLoaded) == null ? void 0 : f.details);
    }
    if (c.details = a, this.levelLastLoaded = c, s || this.setStartPosition(a, d), this.hls.trigger(N.LEVEL_UPDATED, {
      details: a,
      level: o
    }), this.state === he.WAITING_LEVEL) {
      if (this.waitForCdnTuneIn(a))
        return;
      this.state = he.IDLE;
    }
    s && a.live && this.synchronizeToLiveEdge(a), this.tick();
  }
  synchronizeToLiveEdge(e) {
    const {
      config: t,
      media: r
    } = this;
    if (!r)
      return;
    const i = this.hls.liveSyncPosition, s = this.getLoadPosition(), o = e.fragmentStart, a = e.edge, l = s >= o - t.maxFragLookUpTolerance && s <= a;
    if (i !== null && r.duration > i && (s < i || !l)) {
      const u = t.liveMaxLatencyDuration !== void 0 ? t.liveMaxLatencyDuration : t.liveMaxLatencyDurationCount * e.targetduration;
      if ((!l && r.readyState < 4 || s < a - u) && (this._hasEnoughToStart || (this.nextLoadPosition = i), r.readyState))
        if (this.warn(`Playback: ${s.toFixed(3)} is located too far from the end of live sliding playlist: ${a}, reset currentTime to : ${i.toFixed(3)}`), this.config.liveSyncMode === "buffered") {
          var c;
          const d = St.bufferInfo(r, i, 0);
          if (!((c = d.buffered) != null && c.length)) {
            r.currentTime = i;
            return;
          }
          if (d.start <= s) {
            r.currentTime = i;
            return;
          }
          const {
            nextStart: h
          } = St.bufferedInfo(d.buffered, s, 0);
          h && (r.currentTime = h);
        } else
          r.currentTime = i;
    }
  }
  _handleFragmentLoadProgress(e) {
    var t;
    const r = e.frag, {
      part: i,
      payload: s
    } = e, {
      levels: o
    } = this;
    if (!o) {
      this.warn(`Levels were reset while fragment load was in progress. Fragment ${r.sn} of level ${r.level} will not be buffered`);
      return;
    }
    const a = o[r.level];
    if (!a) {
      this.warn(`Level ${r.level} not found on progress`);
      return;
    }
    const l = a.details;
    if (!l) {
      this.warn(`Dropping fragment ${r.sn} of level ${r.level} after level details were reset`), this.fragmentTracker.removeFragment(r);
      return;
    }
    const c = a.videoCodec, u = l.PTSKnown || !l.live, d = (t = r.initSegment) == null ? void 0 : t.data, f = this._getAudioCodec(a), h = this.transmuxer = this.transmuxer || new Rne(this.hls, We.MAIN, this._handleTransmuxComplete.bind(this), this._handleTransmuxerFlush.bind(this)), m = i ? i.index : -1, g = m !== -1, v = new y_(r.level, r.sn, r.stats.chunkCount, s.byteLength, m, g), y = this.initPTS[r.cc];
    h.push(s, d, f, c, r, i, l.totalduration, u, v, y);
  }
  onAudioTrackSwitching(e, t) {
    const r = this.hls, i = this.altAudio !== 0;
    if (Hy(t.url, r))
      this.altAudio = 1;
    else {
      if (this.mediaBuffer !== this.media) {
        this.log("Switching on main audio, use media.buffered to schedule main fragment loading"), this.mediaBuffer = this.media;
        const o = this.fragCurrent;
        o && (this.log("Switching to main audio track, cancel main fragment load"), o.abortRequests(), this.fragmentTracker.removeFragment(o)), this.resetTransmuxer(), this.resetLoadingState();
      } else this.audioOnly && this.resetTransmuxer();
      if (i) {
        this.altAudio = 0, this.fragmentTracker.removeAllFragments(), r.once(N.BUFFER_FLUSHED, () => {
          this.hls && this.hls.trigger(N.AUDIO_TRACK_SWITCHED, t);
        }), r.trigger(N.BUFFER_FLUSHING, {
          startOffset: 0,
          endOffset: Number.POSITIVE_INFINITY,
          type: null
        });
        return;
      }
      r.trigger(N.AUDIO_TRACK_SWITCHED, t);
    }
  }
  onAudioTrackSwitched(e, t) {
    const r = Hy(t.url, this.hls);
    if (r) {
      const i = this.videoBuffer;
      i && this.mediaBuffer !== i && (this.log("Switching on alternate audio, use video.buffered to schedule main fragment loading"), this.mediaBuffer = i);
    }
    this.altAudio = r ? 2 : 0, this.tick();
  }
  onBufferCreated(e, t) {
    const r = t.tracks;
    let i, s, o = !1;
    for (const a in r) {
      const l = r[a];
      if (l.id === "main") {
        if (s = a, i = l, a === "video") {
          const c = r[a];
          c && (this.videoBuffer = c.buffer);
        }
      } else
        o = !0;
    }
    o && i ? (this.log(`Alternate track found, use ${s}.buffered to schedule main fragment loading`), this.mediaBuffer = i.buffer) : this.mediaBuffer = this.media;
  }
  onFragBuffered(e, t) {
    const {
      frag: r,
      part: i
    } = t, s = r.type === We.MAIN;
    if (s) {
      if (this.fragContextChanged(r)) {
        this.warn(`Fragment ${r.sn}${i ? " p: " + i.index : ""} of level ${r.level} finished buffering, but was aborted. state: ${this.state}`), this.state === he.PARSED && (this.state = he.IDLE);
        return;
      }
      const a = i ? i.stats : r.stats;
      this.fragLastKbps = Math.round(8 * a.total / (a.buffering.end - a.loading.first)), tr(r) && (this.fragPrevious = r), this.fragBufferedComplete(r, i);
    }
    const o = this.media;
    o && (!this._hasEnoughToStart && St.getBuffered(o).length && (this._hasEnoughToStart = !0, this.seekToStartPos()), s && this.tick());
  }
  get hasEnoughToStart() {
    return this._hasEnoughToStart;
  }
  onError(e, t) {
    var r;
    if (t.fatal) {
      this.state = he.ERROR;
      return;
    }
    switch (t.details) {
      case ce.FRAG_GAP:
      case ce.FRAG_PARSING_ERROR:
      case ce.FRAG_DECRYPT_ERROR:
      case ce.FRAG_LOAD_ERROR:
      case ce.FRAG_LOAD_TIMEOUT:
      case ce.KEY_LOAD_ERROR:
      case ce.KEY_LOAD_TIMEOUT:
        this.onFragmentOrKeyLoadError(We.MAIN, t);
        break;
      case ce.LEVEL_LOAD_ERROR:
      case ce.LEVEL_LOAD_TIMEOUT:
      case ce.LEVEL_PARSING_ERROR:
        !t.levelRetry && this.state === he.WAITING_LEVEL && ((r = t.context) == null ? void 0 : r.type) === Dt.LEVEL && (this.state = he.IDLE);
        break;
      case ce.BUFFER_ADD_CODEC_ERROR:
      case ce.BUFFER_APPEND_ERROR:
        if (t.parent !== "main")
          return;
        this.reduceLengthAndFlushBuffer(t) && this.resetLoadingState();
        break;
      case ce.BUFFER_FULL_ERROR:
        if (t.parent !== "main")
          return;
        this.reduceLengthAndFlushBuffer(t) && (!this.config.interstitialsController && this.config.assetPlayerId ? this._hasEnoughToStart = !0 : this.flushMainBuffer(0, Number.POSITIVE_INFINITY));
        break;
      case ce.INTERNAL_EXCEPTION:
        this.recoverWorkerError(t);
        break;
    }
  }
  onFragLoadEmergencyAborted() {
    this.state = he.IDLE, this._hasEnoughToStart || (this.startFragRequested = !1, this.nextLoadPosition = this.lastCurrentTime), this.tickImmediate();
  }
  onBufferFlushed(e, {
    type: t
  }) {
    if (t !== wn.AUDIO || !this.altAudio) {
      const r = (t === wn.VIDEO ? this.videoBuffer : this.mediaBuffer) || this.media;
      r && (this.afterBufferFlushed(r, t, We.MAIN), this.tick());
    }
  }
  onLevelsUpdated(e, t) {
    this.level > -1 && this.fragCurrent && (this.level = this.fragCurrent.level, this.level === -1 && this.resetWhenMissingContext(this.fragCurrent)), this.levels = t.levels;
  }
  swapAudioCodec() {
    this.audioCodecSwap = !this.audioCodecSwap;
  }
  /**
   * Seeks to the set startPosition if not equal to the mediaElement's current time.
   */
  seekToStartPos() {
    const {
      media: e
    } = this;
    if (!e)
      return;
    const t = e.currentTime;
    let r = this.startPosition;
    if (r >= 0 && t < r) {
      if (e.seeking) {
        this.log(`could not seek to ${r}, already seeking at ${t}`);
        return;
      }
      const i = this.timelineOffset;
      i && r && (r += i);
      const s = this.getLevelDetails(), o = St.getBuffered(e), a = o.length ? o.start(0) : 0, l = a - r, c = Math.max(this.config.maxBufferHole, this.config.maxFragLookUpTolerance);
      (this.config.startOnSegmentBoundary || l > 0 && (l < c || this.loadingParts && l < 2 * (s?.partTarget || 0))) && (this.log(`adjusting start position by ${l} to match buffer start`), r += l, this.startPosition = r), t < r && (this.log(`seek to target start position ${r} from current time ${t} buffer start ${a}`), e.currentTime = r);
    }
  }
  _getAudioCodec(e) {
    let t = this.config.defaultAudioCodec || e.audioCodec;
    return this.audioCodecSwap && t && (this.log("Swapping audio codec"), t.indexOf("mp4a.40.5") !== -1 ? t = "mp4a.40.2" : t = "mp4a.40.5"), t;
  }
  _loadBitrateTestFrag(e, t) {
    e.bitrateTest = !0, this._doFragLoad(e, t).then((r) => {
      const {
        hls: i
      } = this, s = r?.frag;
      if (!s || this.fragContextChanged(s))
        return;
      t.fragmentError = 0, this.state = he.IDLE, this.startFragRequested = !1, this.bitrateTest = !1;
      const o = s.stats;
      o.parsing.start = o.parsing.end = o.buffering.start = o.buffering.end = self.performance.now(), i.trigger(N.FRAG_LOADED, r), s.bitrateTest = !1;
    }).catch((r) => {
      this.state === he.STOPPED || this.state === he.ERROR || (this.warn(r), this.resetFragmentLoading(e));
    });
  }
  _handleTransmuxComplete(e) {
    const t = this.playlistType, {
      hls: r
    } = this, {
      remuxResult: i,
      chunkMeta: s
    } = e, o = this.getCurrentContext(s);
    if (!o) {
      this.resetWhenMissingContext(s);
      return;
    }
    const {
      frag: a,
      part: l,
      level: c
    } = o, {
      video: u,
      text: d,
      id3: f,
      initSegment: h
    } = i, {
      details: m
    } = c, g = this.altAudio ? void 0 : i.audio;
    if (this.fragContextChanged(a)) {
      this.fragmentTracker.removeFragment(a);
      return;
    }
    if (this.state = he.PARSING, h) {
      const v = h.tracks;
      if (v) {
        const E = a.initSegment || a;
        if (this.unhandledEncryptionError(h, a))
          return;
        this._bufferInitSegment(c, v, E, s), r.trigger(N.FRAG_PARSING_INIT_SEGMENT, {
          frag: E,
          id: t,
          tracks: v
        });
      }
      const y = h.initPTS, b = h.timescale, x = this.initPTS[a.cc];
      if (He(y) && (!x || x.baseTime !== y || x.timescale !== b)) {
        const E = h.trackId;
        this.initPTS[a.cc] = {
          baseTime: y,
          timescale: b,
          trackId: E
        }, r.trigger(N.INIT_PTS_FOUND, {
          frag: a,
          id: t,
          initPTS: y,
          timescale: b,
          trackId: E
        });
      }
    }
    if (u && m) {
      g && u.type === "audiovideo" && this.logMuxedErr(a);
      const v = m.fragments[a.sn - 1 - m.startSN], y = a.sn === m.startSN, b = !v || a.cc > v.cc;
      if (i.independent !== !1) {
        const {
          startPTS: x,
          endPTS: E,
          startDTS: w,
          endDTS: C
        } = u;
        if (l)
          l.elementaryStreams[u.type] = {
            startPTS: x,
            endPTS: E,
            startDTS: w,
            endDTS: C
          };
        else if (u.firstKeyFrame && u.independent && s.id === 1 && !b && (this.couldBacktrack = !0), u.dropped && u.independent) {
          const S = this.getMainFwdBufferInfo(), M = (S ? S.end : this.getLoadPosition()) + this.config.maxBufferHole, k = u.firstKeyFramePTS ? u.firstKeyFramePTS : x;
          if (!y && M < k - this.config.maxBufferHole && !b) {
            this.backtrack(a);
            return;
          } else b && (a.gap = !0);
          a.setElementaryStreamInfo(u.type, a.start, E, a.start, C, !0);
        } else y && x - (m.appliedTimelineOffset || 0) > Yv && (a.gap = !0);
        a.setElementaryStreamInfo(u.type, x, E, w, C), this.backtrackFragment && (this.backtrackFragment = a), this.bufferFragmentData(u, a, l, s, y || b);
      } else if (y || b)
        a.gap = !0;
      else {
        this.backtrack(a);
        return;
      }
    }
    if (g) {
      const {
        startPTS: v,
        endPTS: y,
        startDTS: b,
        endDTS: x
      } = g;
      l && (l.elementaryStreams[wn.AUDIO] = {
        startPTS: v,
        endPTS: y,
        startDTS: b,
        endDTS: x
      }), a.setElementaryStreamInfo(wn.AUDIO, v, y, b, x), this.bufferFragmentData(g, a, l, s);
    }
    if (m && f != null && f.samples.length) {
      const v = {
        id: t,
        frag: a,
        details: m,
        samples: f.samples
      };
      r.trigger(N.FRAG_PARSING_METADATA, v);
    }
    if (m && d) {
      const v = {
        id: t,
        frag: a,
        details: m,
        samples: d.samples
      };
      r.trigger(N.FRAG_PARSING_USERDATA, v);
    }
  }
  logMuxedErr(e) {
    this.warn(`${tr(e) ? "Media" : "Init"} segment with muxed audiovideo where only video expected: ${e.url}`);
  }
  _bufferInitSegment(e, t, r, i) {
    if (this.state !== he.PARSING)
      return;
    this.audioOnly = !!t.audio && !t.video, this.altAudio && !this.audioOnly && (delete t.audio, t.audiovideo && this.logMuxedErr(r));
    const {
      audio: s,
      video: o,
      audiovideo: a
    } = t;
    if (s) {
      const c = e.audioCodec;
      let u = Uv(s.codec, c);
      u === "mp4a" && (u = "mp4a.40.5");
      const d = navigator.userAgent.toLowerCase();
      if (this.audioCodecSwitch) {
        u && (u.indexOf("mp4a.40.5") !== -1 ? u = "mp4a.40.2" : u = "mp4a.40.5");
        const f = s.metadata;
        f && "channelCount" in f && (f.channelCount || 1) !== 1 && d.indexOf("firefox") === -1 && (u = "mp4a.40.5");
      }
      u && u.indexOf("mp4a.40.5") !== -1 && d.indexOf("android") !== -1 && s.container !== "audio/mpeg" && (u = "mp4a.40.2", this.log(`Android: force audio codec to ${u}`)), c && c !== u && this.log(`Swapping manifest audio codec "${c}" for "${u}"`), s.levelCodec = u, s.id = We.MAIN, this.log(`Init audio buffer, container:${s.container}, codecs[selected/level/parsed]=[${u || ""}/${c || ""}/${s.codec}]`), delete t.audiovideo;
    }
    if (o) {
      o.levelCodec = e.videoCodec, o.id = We.MAIN;
      const c = o.codec;
      if (c?.length === 4)
        switch (c) {
          case "hvc1":
          case "hev1":
            o.codec = "hvc1.1.6.L120.90";
            break;
          case "av01":
            o.codec = "av01.0.04M.08";
            break;
          case "avc1":
            o.codec = "avc1.42e01e";
            break;
        }
      this.log(`Init video buffer, container:${o.container}, codecs[level/parsed]=[${e.videoCodec || ""}/${c}]${o.codec !== c ? " parsed-corrected=" + o.codec : ""}${o.supplemental ? " supplemental=" + o.supplemental : ""}`), delete t.audiovideo;
    }
    a && (this.log(`Init audiovideo buffer, container:${a.container}, codecs[level/parsed]=[${e.codecs}/${a.codec}]`), delete t.video, delete t.audio);
    const l = Object.keys(t);
    if (l.length) {
      if (this.hls.trigger(N.BUFFER_CODECS, t), !this.hls)
        return;
      l.forEach((c) => {
        const d = t[c].initSegment;
        d != null && d.byteLength && this.hls.trigger(N.BUFFER_APPENDING, {
          type: c,
          data: d,
          frag: r,
          part: null,
          chunkMeta: i,
          parent: r.type
        });
      });
    }
    this.tickImmediate();
  }
  getMainFwdBufferInfo() {
    const e = this.mediaBuffer && this.altAudio === 2 ? this.mediaBuffer : this.media;
    return this.getFwdBufferInfo(e, We.MAIN);
  }
  get maxBufferLength() {
    const {
      levels: e,
      level: t
    } = this, r = e?.[t];
    return r ? this.getMaxBufferLength(r.maxBitrate) : this.config.maxBufferLength;
  }
  backtrack(e) {
    this.couldBacktrack = !0, this.backtrackFragment = e, this.resetTransmuxer(), this.flushBufferGap(e), this.fragmentTracker.removeFragment(e), this.fragPrevious = null, this.nextLoadPosition = e.start, this.state = he.IDLE;
  }
  checkFragmentChanged() {
    const e = this.media;
    let t = null;
    if (e && e.readyState > 1 && e.seeking === !1) {
      const r = e.currentTime;
      if (St.isBuffered(e, r) ? t = this.getAppendedFrag(r) : St.isBuffered(e, r + 0.1) && (t = this.getAppendedFrag(r + 0.1)), t) {
        this.backtrackFragment = null;
        const i = this.fragPlaying, s = t.level;
        (!i || t.sn !== i.sn || i.level !== s) && (this.fragPlaying = t, this.hls.trigger(N.FRAG_CHANGED, {
          frag: t
        }), (!i || i.level !== s) && this.hls.trigger(N.LEVEL_SWITCHED, {
          level: s
        }));
      }
    }
  }
  get nextLevel() {
    const e = this.nextBufferedFrag;
    return e ? e.level : -1;
  }
  get currentFrag() {
    var e;
    if (this.fragPlaying)
      return this.fragPlaying;
    const t = ((e = this.media) == null ? void 0 : e.currentTime) || this.lastCurrentTime;
    return He(t) ? this.getAppendedFrag(t) : null;
  }
  get currentProgramDateTime() {
    var e;
    const t = ((e = this.media) == null ? void 0 : e.currentTime) || this.lastCurrentTime;
    if (He(t)) {
      const r = this.getLevelDetails(), i = this.currentFrag || (r ? Bu(null, r.fragments, t) : null);
      if (i) {
        const s = i.programDateTime;
        if (s !== null) {
          const o = s + (t - i.start) * 1e3;
          return new Date(o);
        }
      }
    }
    return null;
  }
  get currentLevel() {
    const e = this.currentFrag;
    return e ? e.level : -1;
  }
  get nextBufferedFrag() {
    const e = this.currentFrag;
    return e ? this.followingBufferedFrag(e) : null;
  }
  get forceStartLoad() {
    return this._forceStartLoad;
  }
}
class xZe extends Ys {
  constructor(e, t) {
    super("key-loader", t), this.config = void 0, this.keyIdToKeyInfo = {}, this.emeController = null, this.config = e;
  }
  abort(e) {
    for (const r in this.keyIdToKeyInfo) {
      const i = this.keyIdToKeyInfo[r].loader;
      if (i) {
        var t;
        if (e && e !== ((t = i.context) == null ? void 0 : t.frag.type))
          return;
        i.abort();
      }
    }
  }
  detach() {
    for (const e in this.keyIdToKeyInfo) {
      const t = this.keyIdToKeyInfo[e];
      (t.mediaKeySessionContext || t.decryptdata.isCommonEncryption) && delete this.keyIdToKeyInfo[e];
    }
  }
  destroy() {
    this.detach();
    for (const e in this.keyIdToKeyInfo) {
      const t = this.keyIdToKeyInfo[e].loader;
      t && t.destroy();
    }
    this.keyIdToKeyInfo = {};
  }
  createKeyLoadError(e, t = ce.KEY_LOAD_ERROR, r, i, s) {
    return new za({
      type: Je.NETWORK_ERROR,
      details: t,
      fatal: !1,
      frag: e,
      response: s,
      error: r,
      networkDetails: i
    });
  }
  loadClear(e, t, r) {
    if (this.emeController && this.config.emeEnabled && !this.emeController.getSelectedKeySystemFormats().length) {
      if (t.length)
        for (let i = 0, s = t.length; i < s; i++) {
          const o = t[i];
          if (e.cc <= o.cc && (!tr(e) || !tr(o) || e.sn < o.sn) || !r && i == s - 1)
            return this.emeController.selectKeySystemFormat(o).then((a) => {
              if (!this.emeController)
                return;
              o.setKeyFormat(a);
              const l = jv(a);
              if (l)
                return this.emeController.getKeySystemAccess([l]);
            });
        }
      if (this.config.requireKeySystemAccessOnStart) {
        const i = _p(this.config);
        if (i.length)
          return this.emeController.getKeySystemAccess(i);
      }
    }
    return null;
  }
  load(e) {
    return !e.decryptdata && e.encrypted && this.emeController && this.config.emeEnabled ? this.emeController.selectKeySystemFormat(e).then((t) => this.loadInternal(e, t)) : this.loadInternal(e);
  }
  loadInternal(e, t) {
    var r, i;
    t && e.setKeyFormat(t);
    const s = e.decryptdata;
    if (!s) {
      const c = new Error(t ? `Expected frag.decryptdata to be defined after setting format ${t}` : `Missing decryption data on fragment in onKeyLoading (emeEnabled with controller: ${this.emeController && this.config.emeEnabled})`);
      return Promise.reject(this.createKeyLoadError(e, ce.KEY_LOAD_ERROR, c));
    }
    const o = s.uri;
    if (!o)
      return Promise.reject(this.createKeyLoadError(e, ce.KEY_LOAD_ERROR, new Error(`Invalid key URI: "${o}"`)));
    const a = H6(s);
    let l = this.keyIdToKeyInfo[a];
    if ((r = l) != null && r.decryptdata.key)
      return s.key = l.decryptdata.key, Promise.resolve({
        frag: e,
        keyInfo: l
      });
    if (this.emeController && (i = l) != null && i.keyLoadPromise)
      switch (this.emeController.getKeyStatus(l.decryptdata)) {
        case "usable":
        case "usable-in-future":
          return l.keyLoadPromise.then((u) => {
            const {
              keyInfo: d
            } = u;
            return s.key = d.decryptdata.key, {
              frag: e,
              keyInfo: d
            };
          });
      }
    switch (this.log(`${this.keyIdToKeyInfo[a] ? "Rel" : "L"}oading${s.keyId ? " keyId: " + Br(s.keyId) : ""} URI: ${s.uri} from ${e.type} ${e.level}`), l = this.keyIdToKeyInfo[a] = {
      decryptdata: s,
      keyLoadPromise: null,
      loader: null,
      mediaKeySessionContext: null
    }, s.method) {
      case "SAMPLE-AES":
      case "SAMPLE-AES-CENC":
      case "SAMPLE-AES-CTR":
        return s.keyFormat === "identity" ? this.loadKeyHTTP(l, e) : this.loadKeyEME(l, e);
      case "AES-128":
      case "AES-256":
      case "AES-256-CTR":
        return this.loadKeyHTTP(l, e);
      default:
        return Promise.reject(this.createKeyLoadError(e, ce.KEY_LOAD_ERROR, new Error(`Key supplied with unsupported METHOD: "${s.method}"`)));
    }
  }
  loadKeyEME(e, t) {
    const r = {
      frag: t,
      keyInfo: e
    };
    if (this.emeController && this.config.emeEnabled) {
      var i;
      if (!e.decryptdata.keyId && (i = t.initSegment) != null && i.data) {
        const o = zGe(t.initSegment.data);
        if (o.length) {
          let a = o[0];
          a.some((l) => l !== 0) ? (this.log(`Using keyId found in init segment ${Br(a)}`), ac.setKeyIdForUri(e.decryptdata.uri, a)) : (a = ac.addKeyIdForUri(e.decryptdata.uri), this.log(`Generating keyId to patch media ${Br(a)}`)), e.decryptdata.keyId = a;
        }
      }
      if (!e.decryptdata.keyId && !tr(t))
        return Promise.resolve(r);
      const s = this.emeController.loadKey(r);
      return (e.keyLoadPromise = s.then((o) => (e.mediaKeySessionContext = o, r))).catch((o) => {
        throw e.keyLoadPromise = null, "data" in o && (o.data.frag = t), o;
      });
    }
    return Promise.resolve(r);
  }
  loadKeyHTTP(e, t) {
    const r = this.config, i = r.loader, s = new i(r);
    return t.keyLoader = e.loader = s, e.keyLoadPromise = new Promise((o, a) => {
      const l = {
        keyInfo: e,
        frag: t,
        responseType: "arraybuffer",
        url: e.decryptdata.uri
      }, c = r.keyLoadPolicy.default, u = {
        loadPolicy: c,
        timeout: c.maxLoadTimeMs,
        maxRetry: 0,
        retryDelay: 0,
        maxRetryDelay: 0
      }, d = {
        onSuccess: (f, h, m, g) => {
          const {
            frag: v,
            keyInfo: y
          } = m, b = H6(y.decryptdata);
          if (!v.decryptdata || y !== this.keyIdToKeyInfo[b])
            return a(this.createKeyLoadError(v, ce.KEY_LOAD_ERROR, new Error("after key load, decryptdata unset or changed"), g));
          y.decryptdata.key = v.decryptdata.key = new Uint8Array(f.data), v.keyLoader = null, y.loader = null, o({
            frag: v,
            keyInfo: y
          });
        },
        onError: (f, h, m, g) => {
          this.resetLoader(h), a(this.createKeyLoadError(t, ce.KEY_LOAD_ERROR, new Error(`HTTP Error ${f.code} loading key ${f.text}`), m, cn({
            url: l.url,
            data: void 0
          }, f)));
        },
        onTimeout: (f, h, m) => {
          this.resetLoader(h), a(this.createKeyLoadError(t, ce.KEY_LOAD_TIMEOUT, new Error("key loading timed out"), m));
        },
        onAbort: (f, h, m) => {
          this.resetLoader(h), a(this.createKeyLoadError(t, ce.INTERNAL_ABORTED, new Error("key loading aborted"), m));
        }
      };
      s.load(l, u, d);
    });
  }
  resetLoader(e) {
    const {
      frag: t,
      keyInfo: r,
      url: i
    } = e, s = r.loader;
    t.keyLoader === s && (t.keyLoader = null, r.loader = null);
    const o = H6(r.decryptdata) || i;
    delete this.keyIdToKeyInfo[o], s && s.destroy();
  }
}
function H6(n) {
  if (n.keyFormat !== zr.FAIRPLAY) {
    const e = n.keyId;
    if (e)
      return Br(e);
  }
  return n.uri;
}
function WH(n) {
  const {
    type: e
  } = n;
  switch (e) {
    case Dt.AUDIO_TRACK:
      return We.AUDIO;
    case Dt.SUBTITLE_TRACK:
      return We.SUBTITLE;
    default:
      return We.MAIN;
  }
}
function U6(n, e) {
  let t = n.url;
  return (t === void 0 || t.indexOf("data:") === 0) && (t = e.url), t;
}
class EZe {
  constructor(e) {
    this.hls = void 0, this.loaders = /* @__PURE__ */ Object.create(null), this.variableList = null, this.onManifestLoaded = this.checkAutostartLoad, this.hls = e, this.registerListeners();
  }
  startLoad(e) {
  }
  stopLoad() {
    this.destroyInternalLoaders();
  }
  registerListeners() {
    const {
      hls: e
    } = this;
    e.on(N.MANIFEST_LOADING, this.onManifestLoading, this), e.on(N.LEVEL_LOADING, this.onLevelLoading, this), e.on(N.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), e.on(N.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this), e.on(N.LEVELS_UPDATED, this.onLevelsUpdated, this);
  }
  unregisterListeners() {
    const {
      hls: e
    } = this;
    e.off(N.MANIFEST_LOADING, this.onManifestLoading, this), e.off(N.LEVEL_LOADING, this.onLevelLoading, this), e.off(N.AUDIO_TRACK_LOADING, this.onAudioTrackLoading, this), e.off(N.SUBTITLE_TRACK_LOADING, this.onSubtitleTrackLoading, this), e.off(N.LEVELS_UPDATED, this.onLevelsUpdated, this);
  }
  /**
   * Returns defaults or configured loader-type overloads (pLoader and loader config params)
   */
  createInternalLoader(e) {
    const t = this.hls.config, r = t.pLoader, i = t.loader, s = r || i, o = new s(t);
    return this.loaders[e.type] = o, o;
  }
  getInternalLoader(e) {
    return this.loaders[e.type];
  }
  resetInternalLoader(e) {
    this.loaders[e] && delete this.loaders[e];
  }
  /**
   * Call `destroy` on all internal loader instances mapped (one per context type)
   */
  destroyInternalLoaders() {
    for (const e in this.loaders) {
      const t = this.loaders[e];
      t && t.destroy(), this.resetInternalLoader(e);
    }
  }
  destroy() {
    this.variableList = null, this.unregisterListeners(), this.destroyInternalLoaders();
  }
  onManifestLoading(e, t) {
    const {
      url: r
    } = t;
    this.variableList = null, this.load({
      id: null,
      level: 0,
      responseType: "text",
      type: Dt.MANIFEST,
      url: r,
      deliveryDirectives: null,
      levelOrTrack: null
    });
  }
  onLevelLoading(e, t) {
    const {
      id: r,
      level: i,
      pathwayId: s,
      url: o,
      deliveryDirectives: a,
      levelInfo: l
    } = t;
    this.load({
      id: r,
      level: i,
      pathwayId: s,
      responseType: "text",
      type: Dt.LEVEL,
      url: o,
      deliveryDirectives: a,
      levelOrTrack: l
    });
  }
  onAudioTrackLoading(e, t) {
    const {
      id: r,
      groupId: i,
      url: s,
      deliveryDirectives: o,
      track: a
    } = t;
    this.load({
      id: r,
      groupId: i,
      level: null,
      responseType: "text",
      type: Dt.AUDIO_TRACK,
      url: s,
      deliveryDirectives: o,
      levelOrTrack: a
    });
  }
  onSubtitleTrackLoading(e, t) {
    const {
      id: r,
      groupId: i,
      url: s,
      deliveryDirectives: o,
      track: a
    } = t;
    this.load({
      id: r,
      groupId: i,
      level: null,
      responseType: "text",
      type: Dt.SUBTITLE_TRACK,
      url: s,
      deliveryDirectives: o,
      levelOrTrack: a
    });
  }
  onLevelsUpdated(e, t) {
    const r = this.loaders[Dt.LEVEL];
    if (r) {
      const i = r.context;
      i && !t.levels.some((s) => s === i.levelOrTrack) && (r.abort(), delete this.loaders[Dt.LEVEL]);
    }
  }
  load(e) {
    var t;
    const r = this.hls.config;
    let i = this.getInternalLoader(e);
    if (i) {
      const c = this.hls.logger, u = i.context;
      if (u && u.levelOrTrack === e.levelOrTrack && (u.url === e.url || u.deliveryDirectives && !e.deliveryDirectives)) {
        u.url === e.url ? c.log(`[playlist-loader]: ignore ${e.url} ongoing request`) : c.log(`[playlist-loader]: ignore ${e.url} in favor of ${u.url}`);
        return;
      }
      c.log(`[playlist-loader]: aborting previous loader for type: ${e.type}`), i.abort();
    }
    let s;
    if (e.type === Dt.MANIFEST ? s = r.manifestLoadPolicy.default : s = mn({}, r.playlistLoadPolicy.default, {
      timeoutRetry: null,
      errorRetry: null
    }), i = this.createInternalLoader(e), He((t = e.deliveryDirectives) == null ? void 0 : t.part)) {
      let c;
      if (e.type === Dt.LEVEL && e.level !== null ? c = this.hls.levels[e.level].details : e.type === Dt.AUDIO_TRACK && e.id !== null ? c = this.hls.audioTracks[e.id].details : e.type === Dt.SUBTITLE_TRACK && e.id !== null && (c = this.hls.subtitleTracks[e.id].details), c) {
        const u = c.partTarget, d = c.targetduration;
        if (u && d) {
          const f = Math.max(u * 3, d * 0.8) * 1e3;
          s = mn({}, s, {
            maxTimeToFirstByteMs: Math.min(f, s.maxTimeToFirstByteMs),
            maxLoadTimeMs: Math.min(f, s.maxTimeToFirstByteMs)
          });
        }
      }
    }
    const o = s.errorRetry || s.timeoutRetry || {}, a = {
      loadPolicy: s,
      timeout: s.maxLoadTimeMs,
      maxRetry: o.maxNumRetry || 0,
      retryDelay: o.retryDelayMs || 0,
      maxRetryDelay: o.maxRetryDelayMs || 0
    }, l = {
      onSuccess: (c, u, d, f) => {
        const h = this.getInternalLoader(d);
        this.resetInternalLoader(d.type);
        const m = c.data;
        u.parsing.start = performance.now(), sa.isMediaPlaylist(m) || d.type !== Dt.MANIFEST ? this.handleTrackOrLevelPlaylist(c, u, d, f || null, h) : this.handleMasterPlaylist(c, u, d, f);
      },
      onError: (c, u, d, f) => {
        this.handleNetworkError(u, d, !1, c, f);
      },
      onTimeout: (c, u, d) => {
        this.handleNetworkError(u, d, !0, void 0, c);
      }
    };
    i.load(e, a, l);
  }
  checkAutostartLoad() {
    if (!this.hls)
      return;
    const {
      config: {
        autoStartLoad: e,
        startPosition: t
      },
      forceStartLoad: r
    } = this.hls;
    (e || r) && (this.hls.logger.log(`${e ? "auto" : "force"} startLoad with configured startPosition ${t}`), this.hls.startLoad(t));
  }
  handleMasterPlaylist(e, t, r, i) {
    const s = this.hls, o = e.data, a = U6(e, r), l = sa.parseMasterPlaylist(o, a);
    if (l.playlistParsingError) {
      t.parsing.end = performance.now(), this.handleManifestParsingError(e, r, l.playlistParsingError, i, t);
      return;
    }
    const {
      contentSteering: c,
      levels: u,
      sessionData: d,
      sessionKeys: f,
      startTimeOffset: h,
      variableList: m
    } = l;
    this.variableList = m, u.forEach((b) => {
      const {
        unknownCodecs: x
      } = b;
      if (x) {
        const {
          preferManagedMediaSource: E
        } = this.hls.config;
        let {
          audioCodec: w,
          videoCodec: C
        } = b;
        for (let S = x.length; S--; ) {
          const M = x[S];
          w0(M, "audio", E) ? (b.audioCodec = w = w ? `${w},${M}` : M, eh.audio[w.substring(0, 4)] = 2, x.splice(S, 1)) : w0(M, "video", E) && (b.videoCodec = C = C ? `${C},${M}` : M, eh.video[C.substring(0, 4)] = 2, x.splice(S, 1));
        }
      }
    });
    const {
      AUDIO: g = [],
      SUBTITLES: v,
      "CLOSED-CAPTIONS": y
    } = sa.parseMasterPlaylistMedia(o, a, l);
    g.length && !g.some((x) => !x.url) && u[0].audioCodec && !u[0].attrs.AUDIO && (this.hls.logger.log("[playlist-loader]: audio codec signaled in quality level, but no embedded audio track signaled, create one"), g.unshift({
      type: "main",
      name: "main",
      groupId: "main",
      default: !1,
      autoselect: !1,
      forced: !1,
      id: -1,
      attrs: new zn({}),
      bitrate: 0,
      url: ""
    })), s.trigger(N.MANIFEST_LOADED, {
      levels: u,
      audioTracks: g,
      subtitles: v,
      captions: y,
      contentSteering: c,
      url: a,
      stats: t,
      networkDetails: i,
      sessionData: d,
      sessionKeys: f,
      startTimeOffset: h,
      variableList: m
    });
  }
  handleTrackOrLevelPlaylist(e, t, r, i, s) {
    const o = this.hls, {
      id: a,
      level: l,
      type: c
    } = r, u = U6(e, r), d = He(l) ? l : He(a) ? a : 0, f = WH(r), h = sa.parseLevelPlaylist(e.data, u, d, f, 0, this.variableList);
    if (c === Dt.MANIFEST) {
      const m = {
        attrs: new zn({}),
        bitrate: 0,
        details: h,
        name: "",
        url: u
      };
      h.requestScheduled = t.loading.start + ane(h, 0), o.trigger(N.MANIFEST_LOADED, {
        levels: [m],
        audioTracks: [],
        url: u,
        stats: t,
        networkDetails: i,
        sessionData: null,
        sessionKeys: null,
        contentSteering: null,
        startTimeOffset: null,
        variableList: null
      });
    }
    t.parsing.end = performance.now(), r.levelDetails = h, this.handlePlaylistLoaded(h, e, t, r, i, s);
  }
  handleManifestParsingError(e, t, r, i, s) {
    this.hls.trigger(N.ERROR, {
      type: Je.NETWORK_ERROR,
      details: ce.MANIFEST_PARSING_ERROR,
      fatal: t.type === Dt.MANIFEST,
      url: e.url,
      err: r,
      error: r,
      reason: r.message,
      response: e,
      context: t,
      networkDetails: i,
      stats: s
    });
  }
  handleNetworkError(e, t, r = !1, i, s) {
    let o = `A network ${r ? "timeout" : "error" + (i ? " (status " + i.code + ")" : "")} occurred while loading ${e.type}`;
    e.type === Dt.LEVEL ? o += `: ${e.level} id: ${e.id}` : (e.type === Dt.AUDIO_TRACK || e.type === Dt.SUBTITLE_TRACK) && (o += ` id: ${e.id} group-id: "${e.groupId}"`);
    const a = new Error(o);
    this.hls.logger.warn(`[playlist-loader]: ${o}`);
    let l = ce.UNKNOWN, c = !1;
    const u = this.getInternalLoader(e);
    switch (e.type) {
      case Dt.MANIFEST:
        l = r ? ce.MANIFEST_LOAD_TIMEOUT : ce.MANIFEST_LOAD_ERROR, c = !0;
        break;
      case Dt.LEVEL:
        l = r ? ce.LEVEL_LOAD_TIMEOUT : ce.LEVEL_LOAD_ERROR, c = !1;
        break;
      case Dt.AUDIO_TRACK:
        l = r ? ce.AUDIO_TRACK_LOAD_TIMEOUT : ce.AUDIO_TRACK_LOAD_ERROR, c = !1;
        break;
      case Dt.SUBTITLE_TRACK:
        l = r ? ce.SUBTITLE_TRACK_LOAD_TIMEOUT : ce.SUBTITLE_LOAD_ERROR, c = !1;
        break;
    }
    u && this.resetInternalLoader(e.type);
    const d = {
      type: Je.NETWORK_ERROR,
      details: l,
      fatal: c,
      url: e.url,
      loader: u,
      context: e,
      error: a,
      networkDetails: t,
      stats: s
    };
    if (i) {
      const f = t?.url || e.url;
      d.response = cn({
        url: f,
        data: void 0
      }, i);
    }
    this.hls.trigger(N.ERROR, d);
  }
  handlePlaylistLoaded(e, t, r, i, s, o) {
    const a = this.hls, {
      type: l,
      level: c,
      levelOrTrack: u,
      id: d,
      groupId: f,
      deliveryDirectives: h
    } = i, m = U6(t, i), g = WH(i);
    let v = typeof i.level == "number" && g === We.MAIN ? c : void 0;
    const y = e.playlistParsingError;
    if (y) {
      if (this.hls.logger.warn(`${y} ${e.url}`), !a.config.ignorePlaylistParsingErrors) {
        a.trigger(N.ERROR, {
          type: Je.NETWORK_ERROR,
          details: ce.LEVEL_PARSING_ERROR,
          fatal: !1,
          url: m,
          error: y,
          reason: y.message,
          response: t,
          context: i,
          level: v,
          parent: g,
          networkDetails: s,
          stats: r
        });
        return;
      }
      e.playlistParsingError = null;
    }
    if (!e.fragments.length) {
      const b = e.playlistParsingError = new Error("No Segments found in Playlist");
      a.trigger(N.ERROR, {
        type: Je.NETWORK_ERROR,
        details: ce.LEVEL_EMPTY_ERROR,
        fatal: !1,
        url: m,
        error: b,
        reason: b.message,
        response: t,
        context: i,
        level: v,
        parent: g,
        networkDetails: s,
        stats: r
      });
      return;
    }
    switch (e.live && o && (o.getCacheAge && (e.ageHeader = o.getCacheAge() || 0), (!o.getCacheAge || isNaN(e.ageHeader)) && (e.ageHeader = 0)), l) {
      case Dt.MANIFEST:
      case Dt.LEVEL:
        if (v) {
          if (!u)
            v = 0;
          else if (u !== a.levels[v]) {
            const b = a.levels.indexOf(u);
            b > -1 && (v = b);
          }
        }
        a.trigger(N.LEVEL_LOADED, {
          details: e,
          levelInfo: u || a.levels[0],
          level: v || 0,
          id: d || 0,
          stats: r,
          networkDetails: s,
          deliveryDirectives: h,
          withoutMultiVariant: l === Dt.MANIFEST
        });
        break;
      case Dt.AUDIO_TRACK:
        a.trigger(N.AUDIO_TRACK_LOADED, {
          details: e,
          track: u,
          id: d || 0,
          groupId: f || "",
          stats: r,
          networkDetails: s,
          deliveryDirectives: h
        });
        break;
      case Dt.SUBTITLE_TRACK:
        a.trigger(N.SUBTITLE_TRACK_LOADED, {
          details: e,
          track: u,
          id: d || 0,
          groupId: f || "",
          stats: r,
          networkDetails: s,
          deliveryDirectives: h
        });
        break;
    }
  }
}
class Ni {
  /**
   * Get the video-dev/hls.js package version.
   */
  static get version() {
    return S0;
  }
  /**
   * Check if the required MediaSource Extensions are available.
   */
  static isMSESupported() {
    return ore();
  }
  /**
   * Check if MediaSource Extensions are available and isTypeSupported checks pass for any baseline codecs.
   */
  static isSupported() {
    return vZe();
  }
  /**
   * Get the MediaSource global used for MSE playback (ManagedMediaSource, MediaSource, or WebKitMediaSource).
   */
  static getMediaSource() {
    return gc();
  }
  static get Events() {
    return N;
  }
  static get MetadataSchema() {
    return us;
  }
  static get ErrorTypes() {
    return Je;
  }
  static get ErrorDetails() {
    return ce;
  }
  /**
   * Get the default configuration applied to new instances.
   */
  static get DefaultConfig() {
    return Ni.defaultConfig ? Ni.defaultConfig : sZe;
  }
  /**
   * Replace the default configuration applied to new instances.
   */
  static set DefaultConfig(e) {
    Ni.defaultConfig = e;
  }
  /**
   * Creates an instance of an HLS client that can attach to exactly one `HTMLMediaElement`.
   * @param userConfig - Configuration options applied over `Hls.DefaultConfig`
   */
  constructor(e = {}) {
    this.config = void 0, this.userConfig = void 0, this.logger = void 0, this.coreComponents = void 0, this.networkControllers = void 0, this._emitter = new E_(), this._autoLevelCapping = -1, this._maxHdcpLevel = null, this.abrController = void 0, this.bufferController = void 0, this.capLevelController = void 0, this.latencyController = void 0, this.levelController = void 0, this.streamController = void 0, this.audioStreamController = void 0, this.subtititleStreamController = void 0, this.audioTrackController = void 0, this.subtitleTrackController = void 0, this.interstitialsController = void 0, this.gapController = void 0, this.emeController = void 0, this.cmcdController = void 0, this._media = null, this._url = null, this._sessionId = void 0, this.triggeringException = void 0, this.started = !1;
    const t = this.logger = kGe(e.debug || !1, "Hls instance", e.assetPlayerId), r = this.config = aZe(Ni.DefaultConfig, e, t);
    this.userConfig = e, r.progressive && lZe(r, t);
    const {
      abrController: i,
      bufferController: s,
      capLevelController: o,
      errorController: a,
      fpsController: l
    } = r, c = new a(this), u = this.abrController = new i(this), d = new SKe(this), f = r.interstitialsController, h = f ? this.interstitialsController = new f(this, Ni) : null, m = this.bufferController = new s(this, d), g = this.capLevelController = new o(this), v = new l(this), y = new EZe(this), b = r.contentSteeringController, x = b ? new b(this) : null, E = this.levelController = new gZe(this, x), w = new pZe(this), C = new xZe(this.config, this.logger), S = this.streamController = new wZe(this, d, C), M = this.gapController = new fZe(this, d);
    g.setStreamController(S), v.setStreamController(S);
    const k = [y, E, S];
    h && k.splice(1, 0, h), x && k.splice(1, 0, x), this.networkControllers = k;
    const _ = [u, m, M, g, v, w, d];
    this.audioTrackController = this.createController(r.audioTrackController, k);
    const O = r.audioStreamController;
    O && k.push(this.audioStreamController = new O(this, d, C)), this.subtitleTrackController = this.createController(r.subtitleTrackController, k);
    const I = r.subtitleStreamController;
    I && k.push(this.subtititleStreamController = new I(this, d, C)), this.createController(r.timelineController, _), C.emeController = this.emeController = this.createController(r.emeController, _), this.cmcdController = this.createController(r.cmcdController, _), this.latencyController = this.createController(mZe, _), this.coreComponents = _, k.push(c);
    const R = c.onErrorOut;
    typeof R == "function" && this.on(N.ERROR, R, c), this.on(N.MANIFEST_LOADED, y.onManifestLoaded, y);
  }
  createController(e, t) {
    if (e) {
      const r = new e(this);
      return t && t.push(r), r;
    }
    return null;
  }
  // Delegate the EventEmitter through the public API of Hls.js
  on(e, t, r = this) {
    this._emitter.on(e, t, r);
  }
  once(e, t, r = this) {
    this._emitter.once(e, t, r);
  }
  removeAllListeners(e) {
    this._emitter.removeAllListeners(e);
  }
  off(e, t, r = this, i) {
    this._emitter.off(e, t, r, i);
  }
  listeners(e) {
    return this._emitter.listeners(e);
  }
  emit(e, t, r) {
    return this._emitter.emit(e, t, r);
  }
  trigger(e, t) {
    if (this.config.debug)
      return this.emit(e, e, t);
    try {
      return this.emit(e, e, t);
    } catch (r) {
      if (this.logger.error("An internal error happened while handling event " + e + '. Error message: "' + r.message + '". Here is a stacktrace:', r), !this.triggeringException) {
        this.triggeringException = !0;
        const i = e === N.ERROR;
        this.trigger(N.ERROR, {
          type: Je.OTHER_ERROR,
          details: ce.INTERNAL_EXCEPTION,
          fatal: i,
          event: e,
          error: r
        }), this.triggeringException = !1;
      }
    }
    return !1;
  }
  listenerCount(e) {
    return this._emitter.listenerCount(e);
  }
  /**
   * Dispose of the instance
   */
  destroy() {
    this.logger.log("destroy"), this.trigger(N.DESTROYING, void 0), this.detachMedia(), this.removeAllListeners(), this._autoLevelCapping = -1, this._url = null, this.networkControllers.forEach((t) => t.destroy()), this.networkControllers.length = 0, this.coreComponents.forEach((t) => t.destroy()), this.coreComponents.length = 0;
    const e = this.config;
    e.xhrSetup = e.fetchSetup = void 0, this.userConfig = null;
  }
  /**
   * Attaches Hls.js to a media element
   */
  attachMedia(e) {
    if (!e || "media" in e && !e.media) {
      const s = new Error(`attachMedia failed: invalid argument (${e})`);
      this.trigger(N.ERROR, {
        type: Je.OTHER_ERROR,
        details: ce.ATTACH_MEDIA_ERROR,
        fatal: !0,
        error: s
      });
      return;
    }
    this.logger.log("attachMedia"), this._media && (this.logger.warn("media must be detached before attaching"), this.detachMedia());
    const t = "media" in e, r = t ? e.media : e, i = t ? e : {
      media: r
    };
    this._media = r, this.trigger(N.MEDIA_ATTACHING, i);
  }
  /**
   * Detach Hls.js from the media
   */
  detachMedia() {
    this.logger.log("detachMedia"), this.trigger(N.MEDIA_DETACHING, {}), this._media = null;
  }
  /**
   * Detach HTMLMediaElement, MediaSource, and SourceBuffers without reset, for attaching to another instance
   */
  transferMedia() {
    this._media = null;
    const e = this.bufferController.transferMedia();
    return this.trigger(N.MEDIA_DETACHING, {
      transferMedia: e
    }), e;
  }
  /**
   * Set the source URL. Can be relative or absolute.
   */
  loadSource(e) {
    this.stopLoad();
    const t = this.media, r = this._url, i = this._url = d_.buildAbsoluteURL(self.location.href, e, {
      alwaysNormalize: !0
    });
    this._autoLevelCapping = -1, this._maxHdcpLevel = null, this.logger.log(`loadSource:${i}`), t && r && (r !== i || this.bufferController.hasSourceTypes()) && (this.detachMedia(), this.attachMedia(t)), this.trigger(N.MANIFEST_LOADING, {
      url: e
    });
  }
  /**
   * Gets the currently loaded URL
   */
  get url() {
    return this._url;
  }
  /**
   * Whether or not enough has been buffered to seek to start position or use `media.currentTime` to determine next load position
   */
  get hasEnoughToStart() {
    return this.streamController.hasEnoughToStart;
  }
  /**
   * Get the startPosition set on startLoad(position) or on autostart with config.startPosition
   */
  get startPosition() {
    return this.streamController.startPositionValue;
  }
  /**
   * Start loading data from the stream source.
   * Depending on default config, client starts loading automatically when a source is set.
   *
   * @param startPosition - Set the start position to stream from.
   * Defaults to -1 (None: starts from earliest point)
   */
  startLoad(e = -1, t) {
    this.logger.log(`startLoad(${e + (t ? ", <skip seek to start>" : "")})`), this.started = !0, this.resumeBuffering();
    for (let r = 0; r < this.networkControllers.length && (this.networkControllers[r].startLoad(e, t), !(!this.started || !this.networkControllers)); r++)
      ;
  }
  /**
   * Stop loading of any stream data.
   */
  stopLoad() {
    this.logger.log("stopLoad"), this.started = !1;
    for (let e = 0; e < this.networkControllers.length && (this.networkControllers[e].stopLoad(), !(this.started || !this.networkControllers)); e++)
      ;
  }
  /**
   * Returns whether loading, toggled with `startLoad()` and `stopLoad()`, is active or not`.
   */
  get loadingEnabled() {
    return this.started;
  }
  /**
   * Returns state of fragment loading toggled by calling `pauseBuffering()` and `resumeBuffering()`.
   */
  get bufferingEnabled() {
    return this.streamController.bufferingEnabled;
  }
  /**
   * Resumes stream controller segment loading after `pauseBuffering` has been called.
   */
  resumeBuffering() {
    this.bufferingEnabled || (this.logger.log("resume buffering"), this.networkControllers.forEach((e) => {
      e.resumeBuffering && e.resumeBuffering();
    }));
  }
  /**
   * Prevents stream controller from loading new segments until `resumeBuffering` is called.
   * This allows for media buffering to be paused without interupting playlist loading.
   */
  pauseBuffering() {
    this.bufferingEnabled && (this.logger.log("pause buffering"), this.networkControllers.forEach((e) => {
      e.pauseBuffering && e.pauseBuffering();
    }));
  }
  get inFlightFragments() {
    const e = {
      [We.MAIN]: this.streamController.inFlightFrag
    };
    return this.audioStreamController && (e[We.AUDIO] = this.audioStreamController.inFlightFrag), this.subtititleStreamController && (e[We.SUBTITLE] = this.subtititleStreamController.inFlightFrag), e;
  }
  /**
   * Swap through possible audio codecs in the stream (for example to switch from stereo to 5.1)
   */
  swapAudioCodec() {
    this.logger.log("swapAudioCodec"), this.streamController.swapAudioCodec();
  }
  /**
   * When the media-element fails, this allows to detach and then re-attach it
   * as one call (convenience method).
   *
   * Automatic recovery of media-errors by this process is configurable.
   */
  recoverMediaError() {
    this.logger.log("recoverMediaError");
    const e = this._media, t = e?.currentTime;
    this.detachMedia(), e && (this.attachMedia(e), t && this.startLoad(t));
  }
  removeLevel(e) {
    this.levelController.removeLevel(e);
  }
  /**
   * @returns a UUID for this player instance
   */
  get sessionId() {
    let e = this._sessionId;
    return e || (e = this._sessionId = fXe()), e;
  }
  /**
   * @returns an array of levels (variants) sorted by HDCP-LEVEL, RESOLUTION (height), FRAME-RATE, CODECS, VIDEO-RANGE, and BANDWIDTH
   */
  get levels() {
    const e = this.levelController.levels;
    return e || [];
  }
  /**
   * @returns LevelDetails of last loaded level (variant) or `null` prior to loading a media playlist.
   */
  get latestLevelDetails() {
    return this.streamController.getLevelDetails() || null;
  }
  /**
   * @returns Level object of selected level (variant) or `null` prior to selecting a level or once the level is removed.
   */
  get loadLevelObj() {
    return this.levelController.loadLevelObj;
  }
  /**
   * Index of quality level (variant) currently played
   */
  get currentLevel() {
    return this.streamController.currentLevel;
  }
  /**
   * Set quality level index immediately. This will flush the current buffer to replace the quality asap. That means playback will interrupt at least shortly to re-buffer and re-sync eventually. Set to -1 for automatic level selection.
   */
  set currentLevel(e) {
    this.logger.log(`set currentLevel:${e}`), this.levelController.manualLevel = e, this.streamController.immediateLevelSwitch();
  }
  /**
   * Index of next quality level loaded as scheduled by stream controller.
   */
  get nextLevel() {
    return this.streamController.nextLevel;
  }
  /**
   * Set quality level index for next loaded data.
   * This will switch the video quality asap, without interrupting playback.
   * May abort current loading of data, and flush parts of buffer (outside currently played fragment region).
   * @param newLevel - Pass -1 for automatic level selection
   */
  set nextLevel(e) {
    this.logger.log(`set nextLevel:${e}`), this.levelController.manualLevel = e, this.streamController.nextLevelSwitch();
  }
  /**
   * Return the quality level of the currently or last (of none is loaded currently) segment
   */
  get loadLevel() {
    return this.levelController.level;
  }
  /**
   * Set quality level index for next loaded data in a conservative way.
   * This will switch the quality without flushing, but interrupt current loading.
   * Thus the moment when the quality switch will appear in effect will only be after the already existing buffer.
   * @param newLevel - Pass -1 for automatic level selection
   */
  set loadLevel(e) {
    this.logger.log(`set loadLevel:${e}`), this.levelController.manualLevel = e;
  }
  /**
   * get next quality level loaded
   */
  get nextLoadLevel() {
    return this.levelController.nextLoadLevel;
  }
  /**
   * Set quality level of next loaded segment in a fully "non-destructive" way.
   * Same as `loadLevel` but will wait for next switch (until current loading is done).
   */
  set nextLoadLevel(e) {
    this.levelController.nextLoadLevel = e;
  }
  /**
   * Return "first level": like a default level, if not set,
   * falls back to index of first level referenced in manifest
   */
  get firstLevel() {
    return Math.max(this.levelController.firstLevel, this.minAutoLevel);
  }
  /**
   * Sets "first-level", see getter.
   */
  set firstLevel(e) {
    this.logger.log(`set firstLevel:${e}`), this.levelController.firstLevel = e;
  }
  /**
   * Return the desired start level for the first fragment that will be loaded.
   * The default value of -1 indicates automatic start level selection.
   * Setting hls.nextAutoLevel without setting a startLevel will result in
   * the nextAutoLevel value being used for one fragment load.
   */
  get startLevel() {
    const e = this.levelController.startLevel;
    return e === -1 && this.abrController.forcedAutoLevel > -1 ? this.abrController.forcedAutoLevel : e;
  }
  /**
   * set  start level (level of first fragment that will be played back)
   * if not overrided by user, first level appearing in manifest will be used as start level
   * if -1 : automatic start level selection, playback will start from level matching download bandwidth
   * (determined from download of first segment)
   */
  set startLevel(e) {
    this.logger.log(`set startLevel:${e}`), e !== -1 && (e = Math.max(e, this.minAutoLevel)), this.levelController.startLevel = e;
  }
  /**
   * Whether level capping is enabled.
   * Default value is set via `config.capLevelToPlayerSize`.
   */
  get capLevelToPlayerSize() {
    return this.config.capLevelToPlayerSize;
  }
  /**
   * Enables or disables level capping. If disabled after previously enabled, `nextLevelSwitch` will be immediately called.
   */
  set capLevelToPlayerSize(e) {
    const t = !!e;
    t !== this.config.capLevelToPlayerSize && (t ? this.capLevelController.startCapping() : (this.capLevelController.stopCapping(), this.autoLevelCapping = -1, this.streamController.nextLevelSwitch()), this.config.capLevelToPlayerSize = t);
  }
  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  get autoLevelCapping() {
    return this._autoLevelCapping;
  }
  /**
   * Returns the current bandwidth estimate in bits per second, when available. Otherwise, `NaN` is returned.
   */
  get bandwidthEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.getEstimate() : NaN;
  }
  set bandwidthEstimate(e) {
    this.abrController.resetEstimator(e);
  }
  get abrEwmaDefaultEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.defaultEstimate : NaN;
  }
  /**
   * get time to first byte estimate
   * @type {number}
   */
  get ttfbEstimate() {
    const {
      bwEstimator: e
    } = this.abrController;
    return e ? e.getEstimateTTFB() : NaN;
  }
  /**
   * Capping/max level value that should be used by automatic level selection algorithm (`ABRController`)
   */
  set autoLevelCapping(e) {
    this._autoLevelCapping !== e && (this.logger.log(`set autoLevelCapping:${e}`), this._autoLevelCapping = e, this.levelController.checkMaxAutoUpdated());
  }
  get maxHdcpLevel() {
    return this._maxHdcpLevel;
  }
  set maxHdcpLevel(e) {
    aKe(e) && this._maxHdcpLevel !== e && (this._maxHdcpLevel = e, this.levelController.checkMaxAutoUpdated());
  }
  /**
   * True when automatic level selection enabled
   */
  get autoLevelEnabled() {
    return this.levelController.manualLevel === -1;
  }
  /**
   * Level set manually (if any)
   */
  get manualLevel() {
    return this.levelController.manualLevel;
  }
  /**
   * min level selectable in auto mode according to config.minAutoBitrate
   */
  get minAutoLevel() {
    const {
      levels: e,
      config: {
        minAutoBitrate: t
      }
    } = this;
    if (!e) return 0;
    const r = e.length;
    for (let i = 0; i < r; i++)
      if (e[i].maxBitrate >= t)
        return i;
    return 0;
  }
  /**
   * max level selectable in auto mode according to autoLevelCapping
   */
  get maxAutoLevel() {
    const {
      levels: e,
      autoLevelCapping: t,
      maxHdcpLevel: r
    } = this;
    let i;
    if (t === -1 && e != null && e.length ? i = e.length - 1 : i = t, r)
      for (let s = i; s--; ) {
        const o = e[s].attrs["HDCP-LEVEL"];
        if (o && o <= r)
          return s;
      }
    return i;
  }
  get firstAutoLevel() {
    return this.abrController.firstAutoLevel;
  }
  /**
   * next automatically selected quality level
   */
  get nextAutoLevel() {
    return this.abrController.nextAutoLevel;
  }
  /**
   * this setter is used to force next auto level.
   * this is useful to force a switch down in auto mode:
   * in case of load error on level N, hls.js can set nextAutoLevel to N-1 for example)
   * forced value is valid for one fragment. upon successful frag loading at forced level,
   * this value will be resetted to -1 by ABR controller.
   */
  set nextAutoLevel(e) {
    this.abrController.nextAutoLevel = e;
  }
  /**
   * get the datetime value relative to media.currentTime for the active level Program Date Time if present
   */
  get playingDate() {
    return this.streamController.currentProgramDateTime;
  }
  get mainForwardBufferInfo() {
    return this.streamController.getMainFwdBufferInfo();
  }
  get maxBufferLength() {
    return this.streamController.maxBufferLength;
  }
  /**
   * Find and select the best matching audio track, making a level switch when a Group change is necessary.
   * Updates `hls.config.audioPreference`. Returns the selected track, or null when no matching track is found.
   */
  setAudioOption(e) {
    var t;
    return ((t = this.audioTrackController) == null ? void 0 : t.setAudioOption(e)) || null;
  }
  /**
   * Find and select the best matching subtitle track, making a level switch when a Group change is necessary.
   * Updates `hls.config.subtitlePreference`. Returns the selected track, or null when no matching track is found.
   */
  setSubtitleOption(e) {
    var t;
    return ((t = this.subtitleTrackController) == null ? void 0 : t.setSubtitleOption(e)) || null;
  }
  /**
   * Get the complete list of audio tracks across all media groups
   */
  get allAudioTracks() {
    const e = this.audioTrackController;
    return e ? e.allAudioTracks : [];
  }
  /**
   * Get the list of selectable audio tracks
   */
  get audioTracks() {
    const e = this.audioTrackController;
    return e ? e.audioTracks : [];
  }
  /**
   * index of the selected audio track (index in audio track lists)
   */
  get audioTrack() {
    const e = this.audioTrackController;
    return e ? e.audioTrack : -1;
  }
  /**
   * selects an audio track, based on its index in audio track lists
   */
  set audioTrack(e) {
    const t = this.audioTrackController;
    t && (t.audioTrack = e);
  }
  /**
   * get the complete list of subtitle tracks across all media groups
   */
  get allSubtitleTracks() {
    const e = this.subtitleTrackController;
    return e ? e.allSubtitleTracks : [];
  }
  /**
   * get alternate subtitle tracks list from playlist
   */
  get subtitleTracks() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleTracks : [];
  }
  /**
   * index of the selected subtitle track (index in subtitle track lists)
   */
  get subtitleTrack() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleTrack : -1;
  }
  get media() {
    return this._media;
  }
  /**
   * select an subtitle track, based on its index in subtitle track lists
   */
  set subtitleTrack(e) {
    const t = this.subtitleTrackController;
    t && (t.subtitleTrack = e);
  }
  /**
   * Whether subtitle display is enabled or not
   */
  get subtitleDisplay() {
    const e = this.subtitleTrackController;
    return e ? e.subtitleDisplay : !1;
  }
  /**
   * Enable/disable subtitle display rendering
   */
  set subtitleDisplay(e) {
    const t = this.subtitleTrackController;
    t && (t.subtitleDisplay = e);
  }
  /**
   * get mode for Low-Latency HLS loading
   */
  get lowLatencyMode() {
    return this.config.lowLatencyMode;
  }
  /**
   * Enable/disable Low-Latency HLS part playlist and segment loading, and start live streams at playlist PART-HOLD-BACK rather than HOLD-BACK.
   */
  set lowLatencyMode(e) {
    this.config.lowLatencyMode = e;
  }
  /**
   * Position (in seconds) of live sync point (ie edge of live position minus safety delay defined by ```hls.config.liveSyncDuration```)
   * @returns null prior to loading live Playlist
   */
  get liveSyncPosition() {
    return this.latencyController.liveSyncPosition;
  }
  /**
   * Estimated position (in seconds) of live edge (ie edge of live playlist plus time sync playlist advanced)
   * @returns 0 before first playlist is loaded
   */
  get latency() {
    return this.latencyController.latency;
  }
  /**
   * maximum distance from the edge before the player seeks forward to ```hls.liveSyncPosition```
   * configured using ```liveMaxLatencyDurationCount``` (multiple of target duration) or ```liveMaxLatencyDuration```
   * @returns 0 before first playlist is loaded
   */
  get maxLatency() {
    return this.latencyController.maxLatency;
  }
  /**
   * target distance from the edge as calculated by the latency controller
   */
  get targetLatency() {
    return this.latencyController.targetLatency;
  }
  set targetLatency(e) {
    this.latencyController.targetLatency = e;
  }
  /**
   * the rate at which the edge of the current live playlist is advancing or 1 if there is none
   */
  get drift() {
    return this.latencyController.drift;
  }
  /**
   * set to true when startLoad is called before MANIFEST_PARSED event
   */
  get forceStartLoad() {
    return this.streamController.forceStartLoad;
  }
  /**
   * ContentSteering pathways getter
   */
  get pathways() {
    return this.levelController.pathways;
  }
  /**
   * ContentSteering pathwayPriority getter/setter
   */
  get pathwayPriority() {
    return this.levelController.pathwayPriority;
  }
  set pathwayPriority(e) {
    this.levelController.pathwayPriority = e;
  }
  /**
   * returns true when all SourceBuffers are buffered to the end
   */
  get bufferedToEnd() {
    var e;
    return !!((e = this.bufferController) != null && e.bufferedToEnd);
  }
  /**
   * returns Interstitials Program Manager
   */
  get interstitialsManager() {
    var e;
    return ((e = this.interstitialsController) == null ? void 0 : e.interstitialsManager) || null;
  }
  /**
   * returns mediaCapabilities.decodingInfo for a variant/rendition
   */
  getMediaDecodingInfo(e, t = this.allAudioTracks) {
    const r = Gte(t);
    return jte(e, r, navigator.mediaCapabilities);
  }
}
Ni.defaultConfig = void 0;
const qwt = ({
  url: n,
  name: e,
  title: t,
  className: r,
  refresh: i,
  footer: s
}) => {
  const o = Gt(null), [a, l] = wt(!1), [c, u] = wt(!0), [d, f] = wt(!1), h = Gt(null), m = ua(() => n.replace("{ts}", Date.now().toString()), [n]), g = m.includes(".m3u8"), v = m.includes("youtube.com") || m.includes("youtu.be"), y = (S) => {
    let M = "";
    if (S.includes("youtu.be/"))
      M = S.split("youtu.be/")[1]?.split("?")[0];
    else if (S.includes("watch?v="))
      M = S.split("watch?v=")[1]?.split("&")[0];
    else if (S.includes("/embed/"))
      return S;
    return M ? `https://www.youtube.com/embed/${M}?autoplay=1&mute=1&playsinline=1&controls=1` : S;
  };
  Tt(() => {
    if (!g || !o.current) return;
    const S = o.current;
    let M = null;
    return Ni.isSupported() ? (M = new Ni(), M.loadSource(m), M.attachMedia(S), M.on(Ni.Events.MANIFEST_PARSED, () => {
      S.play().catch((k) => console.error("Auto-play failed", k));
    }), M.on(Ni.Events.ERROR, (k, _) => {
      _.fatal && (console.error("HLS fatal error", _), l(!0));
    })) : S.canPlayType("application/vnd.apple.mpegurl") ? (S.src = m, S.addEventListener("loadedmetadata", () => {
      S.play().catch((k) => console.error("Auto-play failed", k));
    }), S.addEventListener("error", () => l(!0))) : (console.error("HLS not supported"), l(!0)), () => {
      M && M.destroy();
    };
  }, [m, g]);
  const b = () => {
    h.current && (document.fullscreenElement ? document.exitFullscreen() : h.current.requestFullscreen().catch((S) => {
      console.error(
        `Error attempting to enable fullscreen: ${S.message}`
      );
    }));
  }, x = Gt(null), [E, w] = wt(!1);
  Tt(() => {
    const S = new IntersectionObserver(
      ([M]) => {
        w(M.isIntersecting);
      },
      {
        rootMargin: "200px"
        // Load slightly before it comes into view
      }
    );
    return x.current && S.observe(x.current), () => {
      S.disconnect();
    };
  }, []), Tt(() => {
    l(!1), u(!0);
  }, [m]);
  const C = (S) => {
    if (!S && !E)
      return /* @__PURE__ */ T(
        "div",
        {
          className: Q(
            "tw:bg-muted tw:text-muted-foreground tw:flex tw:items-center tw:justify-center tw:animate-pulse",
            r
          ),
          children: /* @__PURE__ */ T("div", { className: "tw:text-center", children: /* @__PURE__ */ T("span", { className: "tw:text-xs", children: "Loading..." }) })
        }
      );
    if (a)
      return /* @__PURE__ */ T(
        "div",
        {
          className: `tw:bg-muted tw:text-muted-foreground tw:flex tw:items-center tw:justify-center ${S ? "h-full min-h-[300px] w-full" : r}`,
          children: /* @__PURE__ */ ee("div", { className: "tw:text-center", children: [
            /* @__PURE__ */ T(mIe, { className: "tw:mx-auto tw:mb-2 tw:h-8 tw:w-8 tw:opacity-50 tw:p-2" }),
            /* @__PURE__ */ T("span", { className: "tw:text-xs", children: "Stream unavailable" })
          ] })
        }
      );
    if (g)
      return /* @__PURE__ */ ee(ft, { children: [
        c && /* @__PURE__ */ T(
          "div",
          {
            className: Q(
              "tw:absolute tw:inset-0 tw:bg-muted tw:animate-pulse tw:flex tw:items-center tw:justify-center",
              S ? "tw:h-full tw:w-full" : r
            ),
            children: /* @__PURE__ */ T("span", { className: "tw:text-xs tw:text-muted-foreground", children: "Loading video..." })
          }
        ),
        /* @__PURE__ */ T(
          SZe,
          {
            url: m,
            className: Q(
              S ? "tw:h-full tw:w-full tw:object-contain" : r
            ),
            onLoadStart: () => u(!0),
            onCanPlay: () => u(!1)
          }
        )
      ] });
    if (v) {
      const M = y(m);
      return /* @__PURE__ */ ee("div", { className: "tw:relative tw:w-full tw:h-full", children: [
        c && /* @__PURE__ */ T(
          "div",
          {
            className: Q(
              "tw:absolute tw:inset-0 tw:bg-muted tw:animate-pulse tw:flex tw:items-center tw:justify-center tw:z-10",
              S ? "tw:h-full tw:w-full" : r
            ),
            children: /* @__PURE__ */ T("span", { className: "tw:text-xs tw:text-muted-foreground", children: "Loading video..." })
          }
        ),
        /* @__PURE__ */ T(
          "iframe",
          {
            src: M,
            title: e,
            className: S ? "tw:h-full tw:w-full" : r,
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: !0,
            loading: "lazy",
            onLoad: () => u(!1)
          }
        )
      ] });
    }
    return /* @__PURE__ */ ee("div", { className: "tw:relative tw:w-full tw:h-full", children: [
      c && /* @__PURE__ */ T(
        "div",
        {
          className: Q(
            "tw:absolute tw:inset-0 tw:bg-muted tw:animate-pulse tw:flex tw:items-center tw:justify-center tw:z-10",
            S ? "tw:h-full tw:w-full" : r
          ),
          children: /* @__PURE__ */ T("span", { className: "tw:text-xs tw:text-muted-foreground", children: "Loading image..." })
        }
      ),
      /* @__PURE__ */ T(
        bGe,
        {
          src: m,
          alt: e,
          className: Q(
            S ? "tw:h-full tw:w-full tw:object-contain" : r
          ),
          onError: () => l(!0),
          onLoad: () => u(!1),
          refresh: i
        }
      )
    ] });
  };
  return /* @__PURE__ */ ee(ft, { children: [
    /* @__PURE__ */ ee(
      "div",
      {
        ref: x,
        className: Q(
          "tw:group tw:relative tw:cursor-pointer",
          r
        ),
        onClick: () => f(!0),
        children: [
          t,
          C(!1),
          /* @__PURE__ */ T("div", { className: "tw:absolute tw:inset-0 tw:flex tw:bg-black/0 tw:opacity-0 tw:transition-colors group-hover:tw:bg-black/10 group-hover:tw:opacity-100" })
        ]
      }
    ),
    /* @__PURE__ */ T(
      f3,
      {
        open: d,
        onOpenChange: (S) => f(S),
        children: /* @__PURE__ */ ee(LZ, { children: [
          /* @__PURE__ */ T(lk, {}),
          /* @__PURE__ */ T(
            ad,
            {
              className: Q(
                "tw:fixed tw:left-[50%] tw:top-[50%] tw:z-50 tw:grid tw:w-full tw:max-w-lg tw:translate-x-[-50%] tw:translate-y-[-50%] tw:gap-4 tw:bg-background tw:shadow-lg tw:duration-200 tw:data-[state=open]:animate-in tw:data-[state=closed]:animate-out tw:data-[state=closed]:fade-out-0 tw:data-[state=open]:fade-in-0 tw:data-[state=closed]:zoom-out-95 tw:data-[state=open]:zoom-in-95 tw:data-[state=closed]:slide-out-to-left-1/2 tw:data-[state=closed]:slide-out-to-top-[48%] tw:data-[state=open]:slide-in-from-left-1/2 tw:data-[state=open]:slide-in-from-top-[48%] tw:sm:rounded-lg",
                "tw:aspect-video tw:w-full tw:max-w-5xl"
              ),
              children: /* @__PURE__ */ ee(
                "div",
                {
                  ref: h,
                  className: "tw:relative tw:flex tw:flex-col tw:h-full tw:w-full tw:gap-y-4 tw:p-2",
                  children: [
                    /* @__PURE__ */ ee("div", { className: "tw:absolute tw:top-1 tw:right-3 tw:flex tw:gap-2 tw:z-10", children: [
                      /* @__PURE__ */ T(
                        Nt,
                        {
                          variant: "ghost",
                          size: "icon",
                          onClick: b,
                          className: "tw:h-8 tw:w-8 tw:rounded-full tw:bg-black/60 tw:text-white/80 hover:tw:bg-black/80 hover:tw:text-white",
                          title: "Toggle Fullscreen",
                          children: /* @__PURE__ */ T(UIe, { className: "tw:h-5 tw:w-5" })
                        }
                      ),
                      /* @__PURE__ */ T(
                        Nt,
                        {
                          variant: "ghost",
                          size: "icon",
                          onClick: () => f(!1),
                          className: "tw:h-8 tw:w-8 tw:rounded-full tw:bg-black/60 tw:text-white/80 hover:tw:bg-black/80 hover:tw:text-white",
                          title: "Close",
                          children: "✕"
                        }
                      )
                    ] }),
                    /* @__PURE__ */ T(p3, { children: t }),
                    C(!0),
                    s && /* @__PURE__ */ T(ft, { children: s })
                  ]
                }
              )
            }
          )
        ] })
      }
    )
  ] });
}, SZe = ({ url: n, className: e, onLoadStart: t, onCanPlay: r }) => {
  const i = Gt(null);
  return Tt(() => {
    if (!i.current) return;
    const s = i.current;
    let o = null;
    return t?.(), Ni.isSupported() ? (o = new Ni(), o.loadSource(n), o.attachMedia(s), o.on(Ni.Events.MANIFEST_PARSED, () => {
      s.play().catch(() => {
      });
    })) : s.canPlayType("application/vnd.apple.mpegurl") && (s.src = n, s.addEventListener("loadedmetadata", () => {
      s.play().catch(() => {
      });
    })), () => {
      o && o.destroy();
    };
  }, [n, t]), /* @__PURE__ */ T(
    "video",
    {
      ref: i,
      className: e,
      controls: !0,
      muted: !0,
      playsInline: !0,
      autoPlay: !0,
      onCanPlay: r
    }
  );
}, Ywt = (n) => /* @__PURE__ */ T(so, { href: n.href, onClick: n.onClick, foreground: !0, children: /* @__PURE__ */ T(vIe, { className: "tw:inline" }) }), CZe = () => {
  const { pathname: n } = $fe();
  return Tt(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [n]), null;
}, Xwt = (n) => /* @__PURE__ */ ee(ft, { children: [
  /* @__PURE__ */ T(CZe, {}),
  /* @__PURE__ */ T(
    "div",
    {
      className: Q(
        "tw:sc-mt-safe-main tw:px-[5%] tw:left-0 tw:right-0 tw:sc-mb-safe-main",
        n.className
      ),
      children: n.children
    }
  )
] }), Zwt = (n) => /* @__PURE__ */ T("div", { className: "tw:sc-mt-safe-main tw:mx-auto tw:max-w-4xl tw:w-full", children: n.children }), Qwt = (n) => /* @__PURE__ */ ee("div", { children: [
  /* @__PURE__ */ ee("div", { className: "tw:flex", children: [
    n.left && /* @__PURE__ */ T("div", { className: "tw:align-middle", children: n.left }),
    /* @__PURE__ */ T("div", { className: "tw:grow tw:align-middle", children: n.title }),
    n.right && /* @__PURE__ */ T("div", { className: "tw:align-middle", children: n.right })
  ] }),
  n.subtitle && /* @__PURE__ */ T("p", { className: "tw:sc-lead tw:text-muted-foreground", children: n.subtitle }),
  n.children
] });
var K3 = "DropdownMenu", [TZe] = qr(
  K3,
  [Qk]
), ki = Qk(), [AZe, are] = TZe(K3), lre = (n) => {
  const {
    __scopeDropdownMenu: e,
    children: t,
    dir: r,
    open: i,
    defaultOpen: s,
    onOpenChange: o,
    modal: a = !0
  } = n, l = ki(e), c = A.useRef(null), [u, d] = Kr({
    prop: i,
    defaultProp: s ?? !1,
    onChange: o,
    caller: K3
  });
  return /* @__PURE__ */ T(
    AZe,
    {
      scope: e,
      triggerId: Xn(),
      triggerRef: c,
      contentId: Xn(),
      open: u,
      onOpenChange: d,
      onOpenToggle: A.useCallback(() => d((f) => !f), [d]),
      modal: a,
      children: /* @__PURE__ */ T(XJ, { ...l, open: u, onOpenChange: d, dir: r, modal: a, children: t })
    }
  );
};
lre.displayName = K3;
var cre = "DropdownMenuTrigger", ure = A.forwardRef(
  (n, e) => {
    const { __scopeDropdownMenu: t, disabled: r = !1, ...i } = n, s = are(cre, t), o = ki(t);
    return /* @__PURE__ */ T(ZJ, { asChild: !0, ...o, children: /* @__PURE__ */ T(
      Ve.button,
      {
        type: "button",
        id: s.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": s.open,
        "aria-controls": s.open ? s.contentId : void 0,
        "data-state": s.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...i,
        ref: bi(e, s.triggerRef),
        onPointerDown: Ce(n.onPointerDown, (a) => {
          !r && a.button === 0 && a.ctrlKey === !1 && (s.onOpenToggle(), s.open || a.preventDefault());
        }),
        onKeyDown: Ce(n.onKeyDown, (a) => {
          r || (["Enter", " "].includes(a.key) && s.onOpenToggle(), a.key === "ArrowDown" && s.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(a.key) && a.preventDefault());
        })
      }
    ) });
  }
);
ure.displayName = cre;
var MZe = "DropdownMenuPortal", dre = (n) => {
  const { __scopeDropdownMenu: e, ...t } = n, r = ki(e);
  return /* @__PURE__ */ T(QJ, { ...r, ...t });
};
dre.displayName = MZe;
var fre = "DropdownMenuContent", hre = A.forwardRef(
  (n, e) => {
    const { __scopeDropdownMenu: t, ...r } = n, i = are(fre, t), s = ki(t), o = A.useRef(!1);
    return /* @__PURE__ */ T(
      JJ,
      {
        id: i.contentId,
        "aria-labelledby": i.triggerId,
        ...s,
        ...r,
        ref: e,
        onCloseAutoFocus: Ce(n.onCloseAutoFocus, (a) => {
          o.current || i.triggerRef.current?.focus(), o.current = !1, a.preventDefault();
        }),
        onInteractOutside: Ce(n.onInteractOutside, (a) => {
          const l = a.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, u = l.button === 2 || c;
          (!i.modal || u) && (o.current = !0);
        }),
        style: {
          ...n.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
hre.displayName = fre;
var kZe = "DropdownMenuGroup", _Ze = A.forwardRef(
  (n, e) => {
    const { __scopeDropdownMenu: t, ...r } = n, i = ki(t);
    return /* @__PURE__ */ T(eee, { ...i, ...r, ref: e });
  }
);
_Ze.displayName = kZe;
var OZe = "DropdownMenuLabel", pre = A.forwardRef(
  (n, e) => {
    const { __scopeDropdownMenu: t, ...r } = n, i = ki(t);
    return /* @__PURE__ */ T(tee, { ...i, ...r, ref: e });
  }
);
pre.displayName = OZe;
var IZe = "DropdownMenuItem", mre = A.forwardRef(
  (n, e) => {
    const { __scopeDropdownMenu: t, ...r } = n, i = ki(t);
    return /* @__PURE__ */ T(nee, { ...i, ...r, ref: e });
  }
);
mre.displayName = IZe;
var RZe = "DropdownMenuCheckboxItem", gre = A.forwardRef((n, e) => {
  const { __scopeDropdownMenu: t, ...r } = n, i = ki(t);
  return /* @__PURE__ */ T(ree, { ...i, ...r, ref: e });
});
gre.displayName = RZe;
var PZe = "DropdownMenuRadioGroup", DZe = A.forwardRef((n, e) => {
  const { __scopeDropdownMenu: t, ...r } = n, i = ki(t);
  return /* @__PURE__ */ T(iee, { ...i, ...r, ref: e });
});
DZe.displayName = PZe;
var NZe = "DropdownMenuRadioItem", vre = A.forwardRef((n, e) => {
  const { __scopeDropdownMenu: t, ...r } = n, i = ki(t);
  return /* @__PURE__ */ T(see, { ...i, ...r, ref: e });
});
vre.displayName = NZe;
var LZe = "DropdownMenuItemIndicator", yre = A.forwardRef((n, e) => {
  const { __scopeDropdownMenu: t, ...r } = n, i = ki(t);
  return /* @__PURE__ */ T(oee, { ...i, ...r, ref: e });
});
yre.displayName = LZe;
var $Ze = "DropdownMenuSeparator", bre = A.forwardRef((n, e) => {
  const { __scopeDropdownMenu: t, ...r } = n, i = ki(t);
  return /* @__PURE__ */ T(aee, { ...i, ...r, ref: e });
});
bre.displayName = $Ze;
var FZe = "DropdownMenuArrow", BZe = A.forwardRef(
  (n, e) => {
    const { __scopeDropdownMenu: t, ...r } = n, i = ki(t);
    return /* @__PURE__ */ T(lee, { ...i, ...r, ref: e });
  }
);
BZe.displayName = FZe;
var zZe = "DropdownMenuSubTrigger", wre = A.forwardRef((n, e) => {
  const { __scopeDropdownMenu: t, ...r } = n, i = ki(t);
  return /* @__PURE__ */ T(cee, { ...i, ...r, ref: e });
});
wre.displayName = zZe;
var HZe = "DropdownMenuSubContent", xre = A.forwardRef((n, e) => {
  const { __scopeDropdownMenu: t, ...r } = n, i = ki(t);
  return /* @__PURE__ */ T(
    uee,
    {
      ...i,
      ...r,
      ref: e,
      style: {
        ...n.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
xre.displayName = HZe;
var UZe = lre, VZe = ure, jZe = dre, Ere = hre, Sre = pre, Cre = mre, Tre = gre, Are = vre, Mre = yre, kre = bre, _re = wre, Ore = xre;
const Bh = UZe, zh = VZe, WZe = A.forwardRef(({ className: n, inset: e, children: t, ...r }, i) => /* @__PURE__ */ ee(
  _re,
  {
    ref: i,
    className: Q(
      "tw:flex tw:cursor-default tw:gap-2 tw:select-none tw:items-center tw:rounded-sm tw:px-2 tw:py-1.5 tw:text-sm tw:outline-hidden tw:focus:bg-accent tw:data-[state=open]:bg-accent tw:[&_svg]:pointer-events-none tw:[&_svg]:size-4 tw:[&_svg]:shrink-0",
      e && "tw:pl-8",
      n
    ),
    ...r,
    children: [
      t,
      /* @__PURE__ */ T(m1, { className: "tw:ml-auto" })
    ]
  }
));
WZe.displayName = _re.displayName;
const GZe = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  Ore,
  {
    ref: t,
    className: Q(
      "tw:z-50 tw:min-w-32 tw:overflow-hidden tw:rounded-md tw:border tw:bg-popover tw:p-1 tw:text-popover-foreground tw:shadow-lg tw:data-[state=open]:animate-in tw:data-[state=closed]:animate-out tw:data-[state=closed]:fade-out-0 tw:data-[state=open]:fade-in-0 tw:data-[state=closed]:zoom-out-95 tw:data-[state=open]:zoom-in-95 tw:data-[side=bottom]:slide-in-from-top-2 tw:data-[side=left]:slide-in-from-right-2 tw:data-[side=right]:slide-in-from-left-2 tw:data-[side=top]:slide-in-from-bottom-2",
      n
    ),
    ...e
  }
));
GZe.displayName = Ore.displayName;
const dd = A.forwardRef(({ className: n, sideOffset: e = 4, ...t }, r) => /* @__PURE__ */ T(jZe, { children: /* @__PURE__ */ T(
  Ere,
  {
    ref: r,
    sideOffset: e,
    className: Q(
      "tw:z-50 tw:min-w-32 tw:overflow-hidden tw:rounded-md tw:border tw:bg-popover tw:p-1 tw:text-popover-foreground tw:shadow-md tw:data-[state=open]:animate-in tw:data-[state=closed]:animate-out tw:data-[state=closed]:fade-out-0 tw:data-[state=open]:fade-in-0 tw:data-[state=closed]:zoom-out-95 tw:data-[state=open]:zoom-in-95 tw:data-[side=bottom]:slide-in-from-top-2 tw:data-[side=left]:slide-in-from-right-2 tw:data-[side=right]:slide-in-from-left-2 tw:data-[side=top]:slide-in-from-bottom-2",
      n
    ),
    ...t
  }
) }));
dd.displayName = Ere.displayName;
const xo = A.forwardRef(({ className: n, inset: e, ...t }, r) => /* @__PURE__ */ T(
  Cre,
  {
    ref: r,
    className: Q(
      "tw:relative tw:flex tw:cursor-default tw:select-none tw:items-center tw:gap-2 tw:rounded-sm tw:px-2 tw:py-1.5 tw:text-sm tw:outline-hidden tw:transition-colors tw:focus:bg-accent tw:focus:text-accent-foreground tw:data-disabled:pointer-events-none tw:data-disabled:opacity-50 tw:[&_svg]:pointer-events-none tw:[&_svg]:size-4 tw:[&_svg]:shrink-0",
      e && "tw:pl-8",
      n
    ),
    ...t
  }
));
xo.displayName = Cre.displayName;
const KZe = A.forwardRef(({ className: n, children: e, checked: t, ...r }, i) => /* @__PURE__ */ ee(
  Tre,
  {
    ref: i,
    className: Q(
      "tw:relative tw:flex tw:cursor-default tw:select-none tw:items-center tw:rounded-sm tw:py-1.5 tw:pl-8 tw:pr-2 tw:text-sm tw:outline-hidden tw:transition-colors tw:focus:bg-accent tw:focus:text-accent-foreground tw:data-disabled:pointer-events-none tw:data-disabled:opacity-50",
      n
    ),
    checked: t,
    ...r,
    children: [
      /* @__PURE__ */ T("span", { className: "tw:absolute tw:left-2 tw:flex tw:h-3.5 tw:w-3.5 tw:items-center tw:justify-center", children: /* @__PURE__ */ T(Mre, { children: /* @__PURE__ */ T(oc, { className: "tw:h-4 tw:w-4" }) }) }),
      e
    ]
  }
));
KZe.displayName = Tre.displayName;
const qZe = A.forwardRef(({ className: n, children: e, ...t }, r) => /* @__PURE__ */ ee(
  Are,
  {
    ref: r,
    className: Q(
      "tw:relative tw:flex tw:cursor-default tw:select-none tw:items-center tw:rounded-sm tw:py-1.5 tw:pl-8 tw:pr-2 tw:text-sm tw:outline-hidden tw:transition-colors tw:focus:bg-accent tw:focus:text-accent-foreground tw:data-disabled:pointer-events-none tw:data-disabled:opacity-50",
      n
    ),
    ...t,
    children: [
      /* @__PURE__ */ T("span", { className: "tw:absolute tw:left-2 tw:flex tw:h-3.5 tw:w-3.5 tw:items-center tw:justify-center", children: /* @__PURE__ */ T(Mre, { children: /* @__PURE__ */ T(uX, { className: "tw:h-2 tw:w-2 tw:fill-current" }) }) }),
      e
    ]
  }
));
qZe.displayName = Are.displayName;
const N_ = A.forwardRef(({ className: n, inset: e, ...t }, r) => /* @__PURE__ */ T(
  Sre,
  {
    ref: r,
    className: Q(
      "tw:px-2 tw:py-1.5 tw:text-sm tw:font-semibold",
      e && "tw:pl-8",
      n
    ),
    ...t
  }
));
N_.displayName = Sre.displayName;
const Yy = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  kre,
  {
    ref: t,
    className: Q("tw:-mx-1 tw:my-1 tw:h-px tw:bg-muted", n),
    ...e
  }
));
Yy.displayName = kre.displayName;
function Jwt(n) {
  return n.items.some((t) => t.show !== !1) ? /* @__PURE__ */ ee(Bh, { children: [
    /* @__PURE__ */ T(zh, { asChild: !0, children: /* @__PURE__ */ ee(Nt, { className: n.className, size: n.size, children: [
      n.label,
      /* @__PURE__ */ T(
        od,
        {
          className: "tw:inline tw:text-foreground",
          height: 20
        }
      )
    ] }) }),
    /* @__PURE__ */ T(dd, { children: n.items.map((t, r) => t.show !== void 0 && !t.show ? /* @__PURE__ */ T(oC, {}, r) : t.disabled ? /* @__PURE__ */ T(xo, { disabled: !0, children: t.title }, r) : t.href ? /* @__PURE__ */ T(
      so,
      {
        href: t.href,
        className: "tw:text-foreground",
        children: /* @__PURE__ */ T(xo, { children: t.title })
      },
      r
    ) : t.onClick ? /* @__PURE__ */ T(xo, { onClick: t.onClick, children: t.title }, r) : t.title ? /* @__PURE__ */ T(N_, { children: t.title }, r) : /* @__PURE__ */ T(Yy, {}, r)) })
  ] }) : /* @__PURE__ */ T(ft, {});
}
const Ire = ({ text: n, className: e }) => /* @__PURE__ */ T(ft, { children: /* @__PURE__ */ ee("div", { className: Q("tw:inline-flex", e), children: [
  /* @__PURE__ */ ee(
    "svg",
    {
      className: "tw:animate-spin tw:h-7 tw:w-7 tw:mr-3",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ T(
          "circle",
          {
            className: "tw:opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            strokeWidth: "4"
          }
        ),
        /* @__PURE__ */ T(
          "path",
          {
            className: "tw:opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          }
        )
      ]
    }
  ),
  n && /* @__PURE__ */ T(ft, { children: n })
] }) }), YZe = ({
  onUpload: n,
  accept: e,
  multiple: t = !1,
  className: r,
  description: i = "Drag and drop files here, or click to upload"
}) => {
  const [s, o] = wt(!1), [a, l] = wt(!1), c = (h) => {
    const m = h.target.files;
    m && (o(!0), Array.from(m).forEach((g) => {
      n(g).finally(() => {
        o(!1);
      }).catch((v) => {
        console.error("Error uploading file:", v), o(!1);
      });
    }));
  }, u = (h) => {
    h.preventDefault(), l(!0);
  }, d = () => {
    l(!1);
  }, f = (h) => {
    h.preventDefault(), l(!1);
    const m = h.dataTransfer.files;
    m && (o(!0), Array.from(m).forEach((g) => {
      n(g).finally(() => {
        o(!1);
      }).catch((v) => {
        console.error("Error uploading file:", v), o(!1);
      });
    }));
  };
  return /* @__PURE__ */ T(
    "div",
    {
      className: Q(
        "tw:flex tw:flex-col tw:items-center tw:gap-8 tw:rounded tw:p-4",
        a ? "tw:bg-accent" : "tw:bg-background",
        r
      ),
      onDragOver: u,
      onDragLeave: d,
      onDrop: f,
      children: /* @__PURE__ */ ee("label", { className: "tw:w-full", children: [
        i && /* @__PURE__ */ T("p", { className: "tw:text-sm tw:text-muted-foreground tw:pb-8", children: i }),
        /* @__PURE__ */ T(
          Ui,
          {
            type: "file",
            accept: e,
            multiple: t,
            onChange: c
          }
        ),
        s && /* @__PURE__ */ T(Ire, {})
      ] })
    }
  );
};
YZe.displayName = "FileUploader";
function e3t({ items: n }) {
  return !yw() || !n || n.length === 0 ? /* @__PURE__ */ T(ft, {}) : /* @__PURE__ */ T("footer", { className: "tw:sticky tw:bottom-0 tw:left-0 tw:z-20 tw:w-full tw:p-2 tw:sc-footer", children: /* @__PURE__ */ T("div", { className: "tw:flex tw:justify-evenly tw:items-center tw:text-xs tw:sc-mb-safe", children: n?.filter((t) => t.show || t.show === void 0).map((t, r) => /* @__PURE__ */ T(so, { href: t.href, foreground: !0, children: /* @__PURE__ */ ee("div", { className: "tw:flex tw:flex-col tw:items-center", children: [
    t.image && /* @__PURE__ */ T("div", { className: "tw:mb-1", children: t.image }),
    /* @__PURE__ */ T("div", { children: t.title })
  ] }) }, r)) }) });
}
function q3(n) {
  const e = A.useRef({ value: n, previous: n });
  return A.useMemo(() => (e.current.value !== n && (e.current.previous = e.current.value, e.current.value = n), e.current.previous), [n]);
}
var Y3 = "Switch", [XZe] = qr(Y3), [ZZe, QZe] = XZe(Y3), Rre = A.forwardRef(
  (n, e) => {
    const {
      __scopeSwitch: t,
      name: r,
      checked: i,
      defaultChecked: s,
      required: o,
      disabled: a,
      value: l = "on",
      onCheckedChange: c,
      form: u,
      ...d
    } = n, [f, h] = A.useState(null), m = ht(e, (x) => h(x)), g = A.useRef(!1), v = f ? u || !!f.closest("form") : !0, [y, b] = Kr({
      prop: i,
      defaultProp: s ?? !1,
      onChange: c,
      caller: Y3
    });
    return /* @__PURE__ */ ee(ZZe, { scope: t, checked: y, disabled: a, children: [
      /* @__PURE__ */ T(
        Ve.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": y,
          "aria-required": o,
          "data-state": Lre(y),
          "data-disabled": a ? "" : void 0,
          disabled: a,
          value: l,
          ...d,
          ref: m,
          onClick: Ce(n.onClick, (x) => {
            b((E) => !E), v && (g.current = x.isPropagationStopped(), g.current || x.stopPropagation());
          })
        }
      ),
      v && /* @__PURE__ */ T(
        Nre,
        {
          control: f,
          bubbles: !g.current,
          name: r,
          value: l,
          checked: y,
          required: o,
          disabled: a,
          form: u,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
Rre.displayName = Y3;
var Pre = "SwitchThumb", Dre = A.forwardRef(
  (n, e) => {
    const { __scopeSwitch: t, ...r } = n, i = QZe(Pre, t);
    return /* @__PURE__ */ T(
      Ve.span,
      {
        "data-state": Lre(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: e
      }
    );
  }
);
Dre.displayName = Pre;
var JZe = "SwitchBubbleInput", Nre = A.forwardRef(
  ({
    __scopeSwitch: n,
    control: e,
    checked: t,
    bubbles: r = !0,
    ...i
  }, s) => {
    const o = A.useRef(null), a = ht(o, s), l = q3(t), c = S3(e);
    return A.useEffect(() => {
      const u = o.current;
      if (!u) return;
      const d = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(
        d,
        "checked"
      ).set;
      if (l !== t && h) {
        const m = new Event("click", { bubbles: r });
        h.call(u, t), u.dispatchEvent(m);
      }
    }, [l, t, r]), /* @__PURE__ */ T(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: t,
        ...i,
        tabIndex: -1,
        ref: a,
        style: {
          ...i.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Nre.displayName = JZe;
function Lre(n) {
  return n ? "checked" : "unchecked";
}
var $re = Rre, eQe = Dre;
const M0 = A.forwardRef(({ className: n, glyph: e, ...t }, r) => /* @__PURE__ */ T(
  $re,
  {
    className: Q(
      "tw:peer tw:inline-flex tw:h-6 tw:w-11 tw:shrink-0 tw:cursor-pointer tw:items-center tw:rounded-full tw:border-2 tw:border-transparent tw:transition-colors tw:focus-visible:outline-hidden tw:focus-visible:ring-2 tw:focus-visible:ring-ring tw:focus-visible:ring-offset-2 tw:focus-visible:ring-offset-background tw:disabled:cursor-not-allowed tw:disabled:opacity-50 tw:data-[state=checked]:bg-primary tw:data-[state=unchecked]:bg-input",
      n
    ),
    ...t,
    ref: r,
    children: /* @__PURE__ */ T(
      eQe,
      {
        className: Q(
          "tw:pointer-events-none tw:h-5 tw:w-5 tw:rounded-full tw:bg-background tw:shadow-lg tw:ring-0 tw:transition-transform tw:data-[state=checked]:translate-x-5 tw:data-[state=unchecked]:translate-x-0 tw:p-1 tw:flex tw:items-center tw:justify-center",
          e && "tw:data-[state=checked]:bg-background tw:data-[state=unchecked]:bg-neutral-900"
        ),
        children: e
      }
    )
  }
));
M0.displayName = $re.displayName;
function tQe(n) {
  return n.control ? /* @__PURE__ */ T(
    xs,
    {
      control: n.control,
      name: n.name,
      render: ({ field: e }) => /* @__PURE__ */ ee(Ci, { className: "tw:flex tw:flex-row tw:items-center tw:justify-between tw:rounded-lg", children: [
        /* @__PURE__ */ T(Ti, { children: n.label }),
        n.description && /* @__PURE__ */ T(Ai, { children: n.description }),
        /* @__PURE__ */ T(qi, { children: /* @__PURE__ */ T(
          M0,
          {
            checked: e.value,
            onCheckedChange: (t) => {
              e.onChange(t), n.onChange && n.onChange(t);
            },
            disabled: n.disabled,
            glyph: n.glyph
          }
        ) })
      ] })
    }
  ) : /* @__PURE__ */ T(ft, { children: /* @__PURE__ */ ee("div", { className: "tw:flex tw:flex-row tw:items-center tw:justify-between tw:rounded-lg tw:space-x-2", children: [
    /* @__PURE__ */ T(bo, { htmlFor: n.name, className: n.className, children: n.label }),
    /* @__PURE__ */ T(
      M0,
      {
        checked: n.checked,
        defaultChecked: n.defaultChecked,
        onCheckedChange: (e) => {
          n.onChange && n.onChange(e);
        },
        disabled: n.disabled,
        glyph: n.glyph
      }
    )
  ] }) });
}
var Xv = { exports: {} }, nQe = Xv.exports, GH;
function rQe() {
  return GH || (GH = 1, (function(n) {
    (function(e) {
      function t(w, C) {
        var S = (w & 65535) + (C & 65535), M = (w >> 16) + (C >> 16) + (S >> 16);
        return M << 16 | S & 65535;
      }
      function r(w, C) {
        return w << C | w >>> 32 - C;
      }
      function i(w, C, S, M, k, _) {
        return t(r(t(t(C, w), t(M, _)), k), S);
      }
      function s(w, C, S, M, k, _, O) {
        return i(C & S | ~C & M, w, C, k, _, O);
      }
      function o(w, C, S, M, k, _, O) {
        return i(C & M | S & ~M, w, C, k, _, O);
      }
      function a(w, C, S, M, k, _, O) {
        return i(C ^ S ^ M, w, C, k, _, O);
      }
      function l(w, C, S, M, k, _, O) {
        return i(S ^ (C | ~M), w, C, k, _, O);
      }
      function c(w, C) {
        w[C >> 5] |= 128 << C % 32, w[(C + 64 >>> 9 << 4) + 14] = C;
        var S, M, k, _, O, I = 1732584193, R = -271733879, P = -1732584194, D = 271733878;
        for (S = 0; S < w.length; S += 16)
          M = I, k = R, _ = P, O = D, I = s(I, R, P, D, w[S], 7, -680876936), D = s(D, I, R, P, w[S + 1], 12, -389564586), P = s(P, D, I, R, w[S + 2], 17, 606105819), R = s(R, P, D, I, w[S + 3], 22, -1044525330), I = s(I, R, P, D, w[S + 4], 7, -176418897), D = s(D, I, R, P, w[S + 5], 12, 1200080426), P = s(P, D, I, R, w[S + 6], 17, -1473231341), R = s(R, P, D, I, w[S + 7], 22, -45705983), I = s(I, R, P, D, w[S + 8], 7, 1770035416), D = s(D, I, R, P, w[S + 9], 12, -1958414417), P = s(P, D, I, R, w[S + 10], 17, -42063), R = s(R, P, D, I, w[S + 11], 22, -1990404162), I = s(I, R, P, D, w[S + 12], 7, 1804603682), D = s(D, I, R, P, w[S + 13], 12, -40341101), P = s(P, D, I, R, w[S + 14], 17, -1502002290), R = s(R, P, D, I, w[S + 15], 22, 1236535329), I = o(I, R, P, D, w[S + 1], 5, -165796510), D = o(D, I, R, P, w[S + 6], 9, -1069501632), P = o(P, D, I, R, w[S + 11], 14, 643717713), R = o(R, P, D, I, w[S], 20, -373897302), I = o(I, R, P, D, w[S + 5], 5, -701558691), D = o(D, I, R, P, w[S + 10], 9, 38016083), P = o(P, D, I, R, w[S + 15], 14, -660478335), R = o(R, P, D, I, w[S + 4], 20, -405537848), I = o(I, R, P, D, w[S + 9], 5, 568446438), D = o(D, I, R, P, w[S + 14], 9, -1019803690), P = o(P, D, I, R, w[S + 3], 14, -187363961), R = o(R, P, D, I, w[S + 8], 20, 1163531501), I = o(I, R, P, D, w[S + 13], 5, -1444681467), D = o(D, I, R, P, w[S + 2], 9, -51403784), P = o(P, D, I, R, w[S + 7], 14, 1735328473), R = o(R, P, D, I, w[S + 12], 20, -1926607734), I = a(I, R, P, D, w[S + 5], 4, -378558), D = a(D, I, R, P, w[S + 8], 11, -2022574463), P = a(P, D, I, R, w[S + 11], 16, 1839030562), R = a(R, P, D, I, w[S + 14], 23, -35309556), I = a(I, R, P, D, w[S + 1], 4, -1530992060), D = a(D, I, R, P, w[S + 4], 11, 1272893353), P = a(P, D, I, R, w[S + 7], 16, -155497632), R = a(R, P, D, I, w[S + 10], 23, -1094730640), I = a(I, R, P, D, w[S + 13], 4, 681279174), D = a(D, I, R, P, w[S], 11, -358537222), P = a(P, D, I, R, w[S + 3], 16, -722521979), R = a(R, P, D, I, w[S + 6], 23, 76029189), I = a(I, R, P, D, w[S + 9], 4, -640364487), D = a(D, I, R, P, w[S + 12], 11, -421815835), P = a(P, D, I, R, w[S + 15], 16, 530742520), R = a(R, P, D, I, w[S + 2], 23, -995338651), I = l(I, R, P, D, w[S], 6, -198630844), D = l(D, I, R, P, w[S + 7], 10, 1126891415), P = l(P, D, I, R, w[S + 14], 15, -1416354905), R = l(R, P, D, I, w[S + 5], 21, -57434055), I = l(I, R, P, D, w[S + 12], 6, 1700485571), D = l(D, I, R, P, w[S + 3], 10, -1894986606), P = l(P, D, I, R, w[S + 10], 15, -1051523), R = l(R, P, D, I, w[S + 1], 21, -2054922799), I = l(I, R, P, D, w[S + 8], 6, 1873313359), D = l(D, I, R, P, w[S + 15], 10, -30611744), P = l(P, D, I, R, w[S + 6], 15, -1560198380), R = l(R, P, D, I, w[S + 13], 21, 1309151649), I = l(I, R, P, D, w[S + 4], 6, -145523070), D = l(D, I, R, P, w[S + 11], 10, -1120210379), P = l(P, D, I, R, w[S + 2], 15, 718787259), R = l(R, P, D, I, w[S + 9], 21, -343485551), I = t(I, M), R = t(R, k), P = t(P, _), D = t(D, O);
        return [I, R, P, D];
      }
      function u(w) {
        var C, S = "", M = w.length * 32;
        for (C = 0; C < M; C += 8)
          S += String.fromCharCode(w[C >> 5] >>> C % 32 & 255);
        return S;
      }
      function d(w) {
        var C, S = [];
        for (S[(w.length >> 2) - 1] = void 0, C = 0; C < S.length; C += 1)
          S[C] = 0;
        var M = w.length * 8;
        for (C = 0; C < M; C += 8)
          S[C >> 5] |= (w.charCodeAt(C / 8) & 255) << C % 32;
        return S;
      }
      function f(w) {
        return u(c(d(w), w.length * 8));
      }
      function h(w, C) {
        var S, M = d(w), k = [], _ = [], O;
        for (k[15] = _[15] = void 0, M.length > 16 && (M = c(M, w.length * 8)), S = 0; S < 16; S += 1)
          k[S] = M[S] ^ 909522486, _[S] = M[S] ^ 1549556828;
        return O = c(k.concat(d(C)), 512 + C.length * 8), u(c(_.concat(O), 640));
      }
      function m(w) {
        var C = "0123456789abcdef", S = "", M, k;
        for (k = 0; k < w.length; k += 1)
          M = w.charCodeAt(k), S += C.charAt(M >>> 4 & 15) + C.charAt(M & 15);
        return S;
      }
      function g(w) {
        return unescape(encodeURIComponent(w));
      }
      function v(w) {
        return f(g(w));
      }
      function y(w) {
        return m(v(w));
      }
      function b(w, C) {
        return h(g(w), g(C));
      }
      function x(w, C) {
        return m(b(w, C));
      }
      function E(w, C, S) {
        return C ? S ? b(C, w) : x(C, w) : S ? v(w) : y(w);
      }
      n.exports ? n.exports = E : e.md5 = E;
    })(nQe);
  })(Xv)), Xv.exports;
}
var iQe = rQe();
const KH = /* @__PURE__ */ nn(iQe);
function sQe({
  name: n,
  email: e,
  className: t,
  link: r,
  navigateToEditAvatar: i = !1,
  size: s = 64
}) {
  const o = Ft(() => e ? `https://gravatar.com/avatar/${KH(e.trim().toLowerCase())}?s=${s}&d=identicon` : void 0, [e, s]), a = Ft(() => e ? `https://gravatar.com/${KH(e.trim().toLowerCase())}` : void 0, [e]), l = o();
  let c = r;
  return i && (c = a()), l ? c ? /* @__PURE__ */ T(so, { href: c, children: /* @__PURE__ */ T(
    "img",
    {
      src: l,
      alt: n,
      title: `${n} (${e})`,
      className: t
    }
  ) }) : /* @__PURE__ */ T(
    "img",
    {
      src: l,
      alt: n,
      title: `${n} (${e})`,
      className: t,
      onError: (u) => {
        u.target.src = "https://www.gravatar.com/avatar/?d=mp";
      }
    }
  ) : /* @__PURE__ */ T(ft, {});
}
function Fre(n, e) {
  const [t, r] = wt(n);
  return Tt(() => {
    const i = setTimeout(() => r(n), e);
    return () => {
      clearTimeout(i);
    };
  }, [n, e]), t;
}
function t3t({
  logoSm: n,
  logo: e,
  items: t,
  onSearch: r,
  onSearchSelect: i,
  searchPlaceholder: s,
  searchPlaceholderOpen: o,
  searchNoResults: a,
  searchFirstSearch: l,
  warningHint: c,
  name: u,
  email: d,
  link: f,
  showDarkMode: h
}) {
  const [m, g] = wt(!1), [v, y] = wt(
    null
  ), [b, x] = wt(""), [E, w] = wt(!1), [C, S] = wt(null), M = Fre(b, 500), { isDarkMode: k, toggle: _ } = V3(), O = Ft(
    (P) => {
      P !== C && (r && P.trim() !== "" ? r(P).then((D) => {
        w(!0), S(P), D.length === 0 ? y(null) : y(D);
      }).catch((D) => {
        console.warn(D), y(null);
      }) : w(!1));
    },
    [r, C]
  );
  Tt(() => {
    M ? O(M) : (y(null), w(!1), S(null));
  }, [M, O]);
  const I = Ft((P) => {
    g(P);
  }, []), R = u && d ? /* @__PURE__ */ T(
    sQe,
    {
      name: u,
      email: d,
      link: f,
      className: "tw:ml-6 tw:h-8 tw:w-auto tw:rounded-full"
    }
  ) : null;
  return /* @__PURE__ */ ee(ft, { children: [
    /* @__PURE__ */ ee(ete, { defaultOpen: !1, children: [
      /* @__PURE__ */ T(
        "header",
        {
          "data-app-drag": "",
          className: Q(
            "tw:fixed tw:top-0 tw:left-0 tw:right-0 tw:z-50 tw:mx-auto tw:max-w-[97%] tw:rounded-full tw:sc-mt-safe",
            c ? "tw:sc-opaque-warning" : "tw:sc-opaque"
          ),
          children: /* @__PURE__ */ ee("div", { className: "tw:flex tw:h-14 tw:items-center tw:px-4", children: [
            (e || n) && /* @__PURE__ */ ee(so, { href: "/", children: [
              e && /* @__PURE__ */ T(
                "img",
                {
                  src: e,
                  alt: "logo",
                  className: "tw:mr-6 tw:h-10 tw:w-auto tw:hidden tw:lg:flex"
                }
              ),
              n && /* @__PURE__ */ T(
                "img",
                {
                  src: n,
                  alt: "logo",
                  className: "tw:h-8 tw:mr-2 tw:w-auto tw:flex tw:lg:hidden!"
                }
              )
            ] }),
            /* @__PURE__ */ T("div", { className: "tw:mr-4 tw:hidden tw:md:flex", children: /* @__PURE__ */ T("nav", { className: "tw:flex tw:items-center tw:space-x-6 tw:text-sm tw:font-medium", children: t?.map((P, D) => P.show !== void 0 && !P.show ? /* @__PURE__ */ T(ft, {}, D) : P.items ? /* @__PURE__ */ ee(Bh, { children: [
              /* @__PURE__ */ ee(zh, { className: "tw:flex tw:items-center tw:gap-1 tw:whitespace-nowrap", children: [
                P.image,
                P.title,
                /* @__PURE__ */ T(
                  od,
                  {
                    className: "tw:hidden tw:xl:inline tw:shrink-0",
                    height: 20
                  }
                )
              ] }),
              /* @__PURE__ */ ee(dd, { children: [
                P.itemsTitle && /* @__PURE__ */ ee(ft, { children: [
                  /* @__PURE__ */ T(N_, { children: P.itemsTitle }),
                  /* @__PURE__ */ T(Yy, {})
                ] }),
                P.items.map(
                  (L, B) => L.show !== void 0 && !L.show ? /* @__PURE__ */ T(
                    ft,
                    {},
                    D
                  ) : L.href ? /* @__PURE__ */ T(
                    so,
                    {
                      href: L.href,
                      className: "",
                      children: /* @__PURE__ */ ee(xo, { children: [
                        L.image,
                        L.title
                      ] })
                    },
                    B
                  ) : /* @__PURE__ */ T(
                    Yy,
                    {},
                    B
                  )
                )
              ] })
            ] }, D) : /* @__PURE__ */ T(
              so,
              {
                href: P.href,
                className: "tw:whitespace-nowrap",
                children: /* @__PURE__ */ ee(ft, { children: [
                  P.image,
                  P.title
                ] })
              },
              D
            )) }) }),
            /* @__PURE__ */ T("div", { className: "tw:md:hidden", children: /* @__PURE__ */ T(nte, {}) }),
            /* @__PURE__ */ T("div", { className: "tw:flex tw:flex-1 tw:items-center tw:justify-between tw:space-x-2 tw:md:justify-end", children: /* @__PURE__ */ T("div", { className: "tw:w-full tw:flex-1 tw:min-w-0", children: r && /* @__PURE__ */ T(
              Nt,
              {
                className: "tw:h-9 tw:bg-white/20 tw:w-full tw:xl:w-[400px] tw:justify-start! tw:font-normal! tw:cursor-text tw:text-white",
                variant: "secondary",
                onClick: () => g(!0),
                children: s || "Search"
              }
            ) }) }),
            h && /* @__PURE__ */ T("div", { className: "tw:hidden tw:lg:block", children: /* @__PURE__ */ T(
              tQe,
              {
                name: "theme",
                glyph: /* @__PURE__ */ T(KIe, {}),
                defaultChecked: k,
                onChange: (P) => {
                  _(P);
                }
              }
            ) }),
            R
          ] })
        }
      ),
      /* @__PURE__ */ ee(tte, { children: [
        /* @__PURE__ */ T(ite, { className: "sc-mt-safe", children: e && /* @__PURE__ */ T(so, { href: "/", children: e && /* @__PURE__ */ T(
          "img",
          {
            src: e,
            alt: "logo",
            className: "tw:h-8"
          }
        ) }) }),
        /* @__PURE__ */ T(ste, { children: /* @__PURE__ */ T(cte, { children: t?.map(
          (P, D) => P.show !== void 0 && !P.show ? /* @__PURE__ */ T(ft, {}, D) : /* @__PURE__ */ T(
            lVe,
            {
              defaultOpen: !P.collapsed,
              className: "group/collapsible",
              children: /* @__PURE__ */ T(ote, { children: P.items?.length ? /* @__PURE__ */ ee(ft, { children: [
                /* @__PURE__ */ T(
                  ate,
                  {
                    asChild: !0,
                    className: "group/label",
                    children: /* @__PURE__ */ ee(cVe, { children: [
                      P.image,
                      P.title,
                      /* @__PURE__ */ T(m1, { className: "tw:ml-auto tw:transform tw:transition-transform tw:group-data-[state=open]/collapsible:rotate-90" })
                    ] })
                  }
                ),
                /* @__PURE__ */ T(uVe, { children: /* @__PURE__ */ T(lte, { children: /* @__PURE__ */ T(dte, { children: /* @__PURE__ */ T(fte, { children: P.items.map(
                  (L, B) => L.href ? /* @__PURE__ */ ee(
                    hte,
                    {
                      href: L.href,
                      children: [
                        L.image,
                        L.title
                      ]
                    },
                    B
                  ) : /* @__PURE__ */ T(
                    ft,
                    {},
                    B
                  )
                ) }) }) }) })
              ] }) : /* @__PURE__ */ T(so, { href: P.href, children: /* @__PURE__ */ ee(ute, { children: [
                P.image,
                P.title
              ] }) }) })
            },
            D
          )
        ) }) }),
        /* @__PURE__ */ T(rte, {})
      ] })
    ] }),
    /* @__PURE__ */ ee(BBe, { open: m, onOpenChange: I, children: [
      /* @__PURE__ */ T(
        g3,
        {
          placeholder: o || "Find a location, or event...",
          onValueChange: (P) => x(P)
        }
      ),
      /* @__PURE__ */ T(v3, { children: v ? v?.map((P, D) => /* @__PURE__ */ T(cu, { heading: P.title, children: P.items.map(
        (L, B) => L.href ? /* @__PURE__ */ T(so, { href: L.href, children: /* @__PURE__ */ T(Ka, { id: L.id, children: /* @__PURE__ */ ee("div", { className: "tw:flex tw:gap-4 tw:items-center", children: [
          /* @__PURE__ */ T("div", { children: L.image }),
          /* @__PURE__ */ ee("div", { className: "tw:flex tw:flex-col", children: [
            L.title,
            L.subtitle && /* @__PURE__ */ T("div", { className: "tw:text-sm tw:text-muted-foreground", children: L.subtitle })
          ] })
        ] }) }) }, B) : /* @__PURE__ */ T(ft, { children: /* @__PURE__ */ T(
          Ka,
          {
            id: L.id,
            onSelect: () => {
              i && L.payload && (i(
                L.payload
              ), g(!1));
            },
            children: /* @__PURE__ */ ee("div", { className: "tw:flex tw:gap-4 tw:items-center", children: [
              /* @__PURE__ */ T("div", { children: L.image }),
              /* @__PURE__ */ ee("div", { className: "tw:flex tw:flex-col", children: [
                L.title,
                L.subtitle && /* @__PURE__ */ T("div", { className: "tw:text-sm tw:text-muted-foreground", children: L.subtitle })
              ] })
            ] })
          },
          B
        ) })
      ) }, D)) : /* @__PURE__ */ T(y3, { children: E ? l || "No results found." : a || "Start typing to search..." }) })
    ] })
  ] });
}
function X3() {
  return (X3 = Object.assign || function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) Object.prototype.hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }).apply(this, arguments);
}
function Bre(n, e) {
  if (n == null) return {};
  var t, r, i = {}, s = Object.keys(n);
  for (r = 0; r < s.length; r++) e.indexOf(t = s[r]) >= 0 || (i[t] = n[t]);
  return i;
}
function N7(n) {
  var e = Gt(n), t = Gt(function(r) {
    e.current && e.current(r);
  });
  return e.current = n, t.current;
}
var k0 = function(n, e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = 1), n > t ? t : n < e ? e : n;
}, Qp = function(n) {
  return "touches" in n;
}, L7 = function(n) {
  return n && n.ownerDocument.defaultView || self;
}, qH = function(n, e, t) {
  var r = n.getBoundingClientRect(), i = Qp(e) ? (function(s, o) {
    for (var a = 0; a < s.length; a++) if (s[a].identifier === o) return s[a];
    return s[0];
  })(e.touches, t) : e;
  return { left: k0((i.pageX - (r.left + L7(n).pageXOffset)) / r.width), top: k0((i.pageY - (r.top + L7(n).pageYOffset)) / r.height) };
}, YH = function(n) {
  !Qp(n) && n.preventDefault();
}, zre = p.memo(function(n) {
  var e = n.onMove, t = n.onKey, r = Bre(n, ["onMove", "onKey"]), i = Gt(null), s = N7(e), o = N7(t), a = Gt(null), l = Gt(!1), c = ua(function() {
    var h = function(v) {
      YH(v), (Qp(v) ? v.touches.length > 0 : v.buttons > 0) && i.current ? s(qH(i.current, v, a.current)) : g(!1);
    }, m = function() {
      return g(!1);
    };
    function g(v) {
      var y = l.current, b = L7(i.current), x = v ? b.addEventListener : b.removeEventListener;
      x(y ? "touchmove" : "mousemove", h), x(y ? "touchend" : "mouseup", m);
    }
    return [function(v) {
      var y = v.nativeEvent, b = i.current;
      if (b && (YH(y), !(function(E, w) {
        return w && !Qp(E);
      })(y, l.current) && b)) {
        if (Qp(y)) {
          l.current = !0;
          var x = y.changedTouches || [];
          x.length && (a.current = x[0].identifier);
        }
        b.focus(), s(qH(b, y, a.current)), g(!0);
      }
    }, function(v) {
      var y = v.which || v.keyCode;
      y < 37 || y > 40 || (v.preventDefault(), o({ left: y === 39 ? 0.05 : y === 37 ? -0.05 : 0, top: y === 40 ? 0.05 : y === 38 ? -0.05 : 0 }));
    }, g];
  }, [o, s]), u = c[0], d = c[1], f = c[2];
  return Tt(function() {
    return f;
  }, [f]), p.createElement("div", X3({}, r, { onTouchStart: u, onMouseDown: u, className: "react-colorful__interactive", ref: i, onKeyDown: d, tabIndex: 0, role: "slider" }));
}), L_ = function(n) {
  return n.filter(Boolean).join(" ");
}, Hre = function(n) {
  var e = n.color, t = n.left, r = n.top, i = r === void 0 ? 0.5 : r, s = L_(["react-colorful__pointer", n.className]);
  return p.createElement("div", { className: s, style: { top: 100 * i + "%", left: 100 * t + "%" } }, p.createElement("div", { className: "react-colorful__pointer-fill", style: { backgroundColor: e } }));
}, Wr = function(n, e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = Math.pow(10, e)), Math.round(t * n) / t;
}, oQe = function(n) {
  return dQe($7(n));
}, $7 = function(n) {
  return n[0] === "#" && (n = n.substring(1)), n.length < 6 ? { r: parseInt(n[0] + n[0], 16), g: parseInt(n[1] + n[1], 16), b: parseInt(n[2] + n[2], 16), a: n.length === 4 ? Wr(parseInt(n[3] + n[3], 16) / 255, 2) : 1 } : { r: parseInt(n.substring(0, 2), 16), g: parseInt(n.substring(2, 4), 16), b: parseInt(n.substring(4, 6), 16), a: n.length === 8 ? Wr(parseInt(n.substring(6, 8), 16) / 255, 2) : 1 };
}, aQe = function(n) {
  return uQe(cQe(n));
}, lQe = function(n) {
  var e = n.s, t = n.v, r = n.a, i = (200 - e) * t / 100;
  return { h: Wr(n.h), s: Wr(i > 0 && i < 200 ? e * t / 100 / (i <= 100 ? i : 200 - i) * 100 : 0), l: Wr(i / 2), a: Wr(r, 2) };
}, F7 = function(n) {
  var e = lQe(n);
  return "hsl(" + e.h + ", " + e.s + "%, " + e.l + "%)";
}, cQe = function(n) {
  var e = n.h, t = n.s, r = n.v, i = n.a;
  e = e / 360 * 6, t /= 100, r /= 100;
  var s = Math.floor(e), o = r * (1 - t), a = r * (1 - (e - s) * t), l = r * (1 - (1 - e + s) * t), c = s % 6;
  return { r: Wr(255 * [r, a, o, o, l, r][c]), g: Wr(255 * [l, r, r, a, o, o][c]), b: Wr(255 * [o, o, l, r, r, a][c]), a: Wr(i, 2) };
}, Gg = function(n) {
  var e = n.toString(16);
  return e.length < 2 ? "0" + e : e;
}, uQe = function(n) {
  var e = n.r, t = n.g, r = n.b, i = n.a, s = i < 1 ? Gg(Wr(255 * i)) : "";
  return "#" + Gg(e) + Gg(t) + Gg(r) + s;
}, dQe = function(n) {
  var e = n.r, t = n.g, r = n.b, i = n.a, s = Math.max(e, t, r), o = s - Math.min(e, t, r), a = o ? s === e ? (t - r) / o : s === t ? 2 + (r - e) / o : 4 + (e - t) / o : 0;
  return { h: Wr(60 * (a < 0 ? a + 6 : a)), s: Wr(s ? o / s * 100 : 0), v: Wr(s / 255 * 100), a: i };
}, fQe = p.memo(function(n) {
  var e = n.hue, t = n.onChange, r = L_(["react-colorful__hue", n.className]);
  return p.createElement("div", { className: r }, p.createElement(zre, { onMove: function(i) {
    t({ h: 360 * i.left });
  }, onKey: function(i) {
    t({ h: k0(e + 360 * i.left, 0, 360) });
  }, "aria-label": "Hue", "aria-valuenow": Wr(e), "aria-valuemax": "360", "aria-valuemin": "0" }, p.createElement(Hre, { className: "react-colorful__hue-pointer", left: e / 360, color: F7({ h: e, s: 100, v: 100, a: 1 }) })));
}), hQe = p.memo(function(n) {
  var e = n.hsva, t = n.onChange, r = { backgroundColor: F7({ h: e.h, s: 100, v: 100, a: 1 }) };
  return p.createElement("div", { className: "react-colorful__saturation", style: r }, p.createElement(zre, { onMove: function(i) {
    t({ s: 100 * i.left, v: 100 - 100 * i.top });
  }, onKey: function(i) {
    t({ s: k0(e.s + 100 * i.left, 0, 100), v: k0(e.v - 100 * i.top, 0, 100) });
  }, "aria-label": "Color", "aria-valuetext": "Saturation " + Wr(e.s) + "%, Brightness " + Wr(e.v) + "%" }, p.createElement(Hre, { className: "react-colorful__saturation-pointer", top: 1 - e.v / 100, left: e.s / 100, color: F7(e) })));
}), Ure = function(n, e) {
  if (n === e) return !0;
  for (var t in n) if (n[t] !== e[t]) return !1;
  return !0;
}, pQe = function(n, e) {
  return n.toLowerCase() === e.toLowerCase() || Ure($7(n), $7(e));
};
function mQe(n, e, t) {
  var r = N7(t), i = wt(function() {
    return n.toHsva(e);
  }), s = i[0], o = i[1], a = Gt({ color: e, hsva: s });
  Tt(function() {
    if (!n.equal(e, a.current.color)) {
      var c = n.toHsva(e);
      a.current = { hsva: c, color: e }, o(c);
    }
  }, [e, n]), Tt(function() {
    var c;
    Ure(s, a.current.hsva) || n.equal(c = n.fromHsva(s), a.current.color) || (a.current = { hsva: s, color: c }, r(c));
  }, [s, n, r]);
  var l = Ft(function(c) {
    o(function(u) {
      return Object.assign({}, u, c);
    });
  }, []);
  return [s, l];
}
var gQe = typeof window < "u" ? vh : Tt, vQe = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : void 0;
}, XH = /* @__PURE__ */ new Map(), yQe = function(n) {
  gQe(function() {
    var e = n.current ? n.current.ownerDocument : document;
    if (e !== void 0 && !XH.has(e)) {
      var t = e.createElement("style");
      t.innerHTML = `.react-colorful{position:relative;display:flex;flex-direction:column;width:200px;height:200px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:default}.react-colorful__saturation{position:relative;flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(0deg,#000,transparent),linear-gradient(90deg,#fff,hsla(0,0%,100%,0))}.react-colorful__alpha-gradient,.react-colorful__pointer-fill{content:"";position:absolute;left:0;top:0;right:0;bottom:0;pointer-events:none;border-radius:inherit}.react-colorful__alpha-gradient,.react-colorful__saturation{box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}.react-colorful__alpha,.react-colorful__hue{position:relative;height:24px}.react-colorful__hue{background:linear-gradient(90deg,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red)}.react-colorful__last-control{border-radius:0 0 8px 8px}.react-colorful__interactive{position:absolute;left:0;top:0;right:0;bottom:0;border-radius:inherit;outline:none;touch-action:none}.react-colorful__pointer{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}.react-colorful__interactive:focus .react-colorful__pointer{transform:translate(-50%,-50%) scale(1.1)}.react-colorful__alpha,.react-colorful__alpha-pointer{background-color:#fff;background-image:url('data:image/svg+xml;charset=utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill-opacity=".05"><path d="M8 0h8v8H8zM0 8h8v8H0z"/></svg>')}.react-colorful__saturation-pointer{z-index:3}.react-colorful__hue-pointer{z-index:2}`, XH.set(e, t);
      var r = vQe();
      r && t.setAttribute("nonce", r), e.head.appendChild(t);
    }
  }, []);
}, bQe = function(n) {
  var e = n.className, t = n.colorModel, r = n.color, i = r === void 0 ? t.defaultColor : r, s = n.onChange, o = Bre(n, ["className", "colorModel", "color", "onChange"]), a = Gt(null);
  yQe(a);
  var l = mQe(t, i, s), c = l[0], u = l[1], d = L_(["react-colorful", e]);
  return p.createElement("div", X3({}, o, { ref: a, className: d }), p.createElement(hQe, { hsva: c, onChange: u }), p.createElement(fQe, { hue: c.h, onChange: u, className: "react-colorful__last-control" }));
}, wQe = { defaultColor: "000", toHsva: oQe, fromHsva: function(n) {
  return aQe({ h: n.h, s: n.s, v: n.v, a: 1 });
}, equal: pQe }, xQe = function(n) {
  return p.createElement(bQe, X3({}, n, { colorModel: wQe }));
};
function n3t(n) {
  return /* @__PURE__ */ T(
    xs,
    {
      control: n.control,
      name: n.name,
      render: ({ field: e }) => {
        let t = e.value || "";
        return (typeof t != "string" || !/^#([0-9A-F]{3}){1,2}$/i.test(t)) && t !== null && t !== "" && (t = "#FF00FF", e.onChange(t)), /* @__PURE__ */ ee(Ci, { className: "tw:flex tw:flex-col", children: [
          /* @__PURE__ */ T(Ti, { children: n.label }),
          /* @__PURE__ */ ee(Dh, { children: [
            /* @__PURE__ */ T(Nh, { asChild: !0, children: /* @__PURE__ */ T(qi, { children: /* @__PURE__ */ T(
              Nt,
              {
                type: "button",
                className: Q(
                  "block tw:w-10 tw:h-10 p-0"
                ),
                style: {
                  backgroundColor: t
                },
                variant: "outline",
                children: /* @__PURE__ */ T("div", {})
              }
            ) }) }),
            /* @__PURE__ */ ee(ld, { className: "tw:flex tw:flex-col", children: [
              /* @__PURE__ */ T(
                xQe,
                {
                  color: t,
                  onChange: e.onChange
                }
              ),
              /* @__PURE__ */ T(
                Ui,
                {
                  maxLength: 7,
                  onChange: (r) => e.onChange(r.currentTarget.value),
                  value: t,
                  className: "tw:mt-2"
                }
              ),
              !n.required && /* @__PURE__ */ T(
                Nt,
                {
                  type: "button",
                  variant: "outline",
                  className: "tw:mt-2",
                  onClick: () => e.onChange(null),
                  children: "Reset"
                }
              )
            ] })
          ] }),
          n.description && /* @__PURE__ */ T(Ai, { children: n.description }),
          /* @__PURE__ */ T(qs, {})
        ] });
      }
    }
  );
}
function EQe(n, e, t = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: n,
    timeZoneName: t
  }).format(e).split(/\s/g).slice(2).join(" ");
}
const SQe = {}, Op = {};
function uu(n, e) {
  try {
    const r = (SQe[n] ||= new Intl.DateTimeFormat("en-US", {
      timeZone: n,
      timeZoneName: "longOffset"
    }).format)(e).split("GMT")[1];
    return r in Op ? Op[r] : ZH(r, r.split(":"));
  } catch {
    if (n in Op) return Op[n];
    const t = n?.match(CQe);
    return t ? ZH(n, t.slice(1)) : NaN;
  }
}
const CQe = /([+-]\d\d):?(\d\d)?/;
function ZH(n, e) {
  const t = +(e[0] || 0), r = +(e[1] || 0), i = +(e[2] || 0) / 60;
  return Op[n] = t * 60 + r > 0 ? t * 60 + r + i : t * 60 - r - i;
}
class oa extends Date {
  //#region static
  constructor(...e) {
    super(), e.length > 1 && typeof e[e.length - 1] == "string" && (this.timeZone = e.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(uu(this.timeZone, this)) ? this.setTime(NaN) : e.length ? typeof e[0] == "number" && (e.length === 1 || e.length === 2 && typeof e[1] != "number") ? this.setTime(e[0]) : typeof e[0] == "string" ? this.setTime(+new Date(e[0])) : e[0] instanceof Date ? this.setTime(+e[0]) : (this.setTime(+new Date(...e)), Vre(this), B7(this)) : this.setTime(Date.now());
  }
  static tz(e, ...t) {
    return t.length ? new oa(...t, e) : new oa(Date.now(), e);
  }
  //#endregion
  //#region time zone
  withTimeZone(e) {
    return new oa(+this, e);
  }
  getTimezoneOffset() {
    const e = -uu(this.timeZone, this);
    return e > 0 ? Math.floor(e) : Math.ceil(e);
  }
  //#endregion
  //#region time
  setTime(e) {
    return Date.prototype.setTime.apply(this, arguments), B7(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](e) {
    return new oa(+new Date(e), this.timeZone);
  }
  //#endregion
}
const QH = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((n) => {
  if (!QH.test(n)) return;
  const e = n.replace(QH, "$1UTC");
  oa.prototype[e] && (n.startsWith("get") ? oa.prototype[n] = function() {
    return this.internal[e]();
  } : (oa.prototype[n] = function() {
    return Date.prototype[e].apply(this.internal, arguments), TQe(this), +this;
  }, oa.prototype[e] = function() {
    return Date.prototype[e].apply(this, arguments), B7(this), +this;
  }));
});
function B7(n) {
  n.internal.setTime(+n), n.internal.setUTCSeconds(n.internal.getUTCSeconds() - Math.round(-uu(n.timeZone, n) * 60));
}
function TQe(n) {
  Date.prototype.setFullYear.call(n, n.internal.getUTCFullYear(), n.internal.getUTCMonth(), n.internal.getUTCDate()), Date.prototype.setHours.call(n, n.internal.getUTCHours(), n.internal.getUTCMinutes(), n.internal.getUTCSeconds(), n.internal.getUTCMilliseconds()), Vre(n);
}
function Vre(n) {
  const e = uu(n.timeZone, n), t = e > 0 ? Math.floor(e) : Math.ceil(e), r = /* @__PURE__ */ new Date(+n);
  r.setUTCHours(r.getUTCHours() - 1);
  const i = -(/* @__PURE__ */ new Date(+n)).getTimezoneOffset(), s = -(/* @__PURE__ */ new Date(+r)).getTimezoneOffset(), o = i - s, a = Date.prototype.getHours.apply(n) !== n.internal.getUTCHours();
  o && a && n.internal.setUTCMinutes(n.internal.getUTCMinutes() + o);
  const l = i - t;
  l && Date.prototype.setUTCMinutes.call(n, Date.prototype.getUTCMinutes.call(n) + l);
  const c = /* @__PURE__ */ new Date(+n);
  c.setUTCSeconds(0);
  const u = i > 0 ? c.getSeconds() : (c.getSeconds() - 60) % 60, d = Math.round(-(uu(n.timeZone, n) * 60)) % 60;
  (d || u) && (n.internal.setUTCSeconds(n.internal.getUTCSeconds() + d), Date.prototype.setUTCSeconds.call(n, Date.prototype.getUTCSeconds.call(n) + d + u));
  const f = uu(n.timeZone, n), h = f > 0 ? Math.floor(f) : Math.ceil(f), g = -(/* @__PURE__ */ new Date(+n)).getTimezoneOffset() - h, v = h !== t, y = g - l;
  if (v && y) {
    Date.prototype.setUTCMinutes.call(n, Date.prototype.getUTCMinutes.call(n) + y);
    const b = uu(n.timeZone, n), x = b > 0 ? Math.floor(b) : Math.ceil(b), E = h - x;
    E && (n.internal.setUTCMinutes(n.internal.getUTCMinutes() + E), Date.prototype.setUTCMinutes.call(n, Date.prototype.getUTCMinutes.call(n) + E));
  }
}
class ei extends oa {
  //#region static
  static tz(e, ...t) {
    return t.length ? new ei(...t, e) : new ei(Date.now(), e);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [e, t, r] = this.tzComponents(), i = `${e}${t}:${r}`;
    return this.internal.toISOString().slice(0, -1) + i;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [e, t, r, i] = this.internal.toUTCString().split(" ");
    return `${e?.slice(0, -1)} ${r} ${t} ${i}`;
  }
  toTimeString() {
    const e = this.internal.toUTCString().split(" ")[4], [t, r, i] = this.tzComponents();
    return `${e} GMT${t}${r}${i} (${EQe(this.timeZone, this)})`;
  }
  toLocaleString(e, t) {
    return Date.prototype.toLocaleString.call(this, e, {
      ...t,
      timeZone: t?.timeZone || this.timeZone
    });
  }
  toLocaleDateString(e, t) {
    return Date.prototype.toLocaleDateString.call(this, e, {
      ...t,
      timeZone: t?.timeZone || this.timeZone
    });
  }
  toLocaleTimeString(e, t) {
    return Date.prototype.toLocaleTimeString.call(this, e, {
      ...t,
      timeZone: t?.timeZone || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const e = this.getTimezoneOffset(), t = e > 0 ? "-" : "+", r = String(Math.floor(Math.abs(e) / 60)).padStart(2, "0"), i = String(Math.abs(e) % 60).padStart(2, "0");
    return [t, r, i];
  }
  //#endregion
  withTimeZone(e) {
    return new ei(+this, e);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](e) {
    return new ei(+new Date(e), this.timeZone);
  }
  //#endregion
}
const jre = 6048e5, AQe = 864e5, JH = Symbol.for("constructDateFrom");
function dr(n, e) {
  return typeof n == "function" ? n(e) : n && typeof n == "object" && JH in n ? n[JH](e) : n instanceof Date ? new n.constructor(e) : new Date(e);
}
function gn(n, e) {
  return dr(e || n, n);
}
function Wre(n, e, t) {
  const r = gn(n, t?.in);
  return isNaN(e) ? dr(n, NaN) : (e && r.setDate(r.getDate() + e), r);
}
function Gre(n, e, t) {
  const r = gn(n, t?.in);
  if (isNaN(e)) return dr(n, NaN);
  if (!e)
    return r;
  const i = r.getDate(), s = dr(n, r.getTime());
  s.setMonth(r.getMonth() + e + 1, 0);
  const o = s.getDate();
  return i >= o ? s : (r.setFullYear(
    s.getFullYear(),
    s.getMonth(),
    i
  ), r);
}
let MQe = {};
function P1() {
  return MQe;
}
function nh(n, e) {
  const t = P1(), r = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? t.weekStartsOn ?? t.locale?.options?.weekStartsOn ?? 0, i = gn(n, e?.in), s = i.getDay(), o = (s < r ? 7 : 0) + s - r;
  return i.setDate(i.getDate() - o), i.setHours(0, 0, 0, 0), i;
}
function _0(n, e) {
  return nh(n, { ...e, weekStartsOn: 1 });
}
function Kre(n, e) {
  const t = gn(n, e?.in), r = t.getFullYear(), i = dr(t, 0);
  i.setFullYear(r + 1, 0, 4), i.setHours(0, 0, 0, 0);
  const s = _0(i), o = dr(t, 0);
  o.setFullYear(r, 0, 4), o.setHours(0, 0, 0, 0);
  const a = _0(o);
  return t.getTime() >= s.getTime() ? r + 1 : t.getTime() >= a.getTime() ? r : r - 1;
}
function eU(n) {
  const e = gn(n), t = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return t.setUTCFullYear(e.getFullYear()), +n - +t;
}
function Hh(n, ...e) {
  const t = dr.bind(
    null,
    e.find((r) => typeof r == "object")
  );
  return e.map(t);
}
function O0(n, e) {
  const t = gn(n, e?.in);
  return t.setHours(0, 0, 0, 0), t;
}
function qre(n, e, t) {
  const [r, i] = Hh(
    t?.in,
    n,
    e
  ), s = O0(r), o = O0(i), a = +s - eU(s), l = +o - eU(o);
  return Math.round((a - l) / AQe);
}
function kQe(n, e) {
  const t = Kre(n, e), r = dr(n, 0);
  return r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0), _0(r);
}
function _Qe(n, e, t) {
  return Wre(n, e * 7, t);
}
function OQe(n, e, t) {
  return Gre(n, e * 12, t);
}
function IQe(n, e) {
  let t, r = e?.in;
  return n.forEach((i) => {
    !r && typeof i == "object" && (r = dr.bind(null, i));
    const s = gn(i, r);
    (!t || t < s || isNaN(+s)) && (t = s);
  }), dr(r, t || NaN);
}
function RQe(n, e) {
  let t, r = e?.in;
  return n.forEach((i) => {
    !r && typeof i == "object" && (r = dr.bind(null, i));
    const s = gn(i, r);
    (!t || t > s || isNaN(+s)) && (t = s);
  }), dr(r, t || NaN);
}
function PQe(n, e, t) {
  const [r, i] = Hh(
    t?.in,
    n,
    e
  );
  return +O0(r) == +O0(i);
}
function Yre(n) {
  return n instanceof Date || typeof n == "object" && Object.prototype.toString.call(n) === "[object Date]";
}
function DQe(n) {
  return !(!Yre(n) && typeof n != "number" || isNaN(+gn(n)));
}
function NQe(n, e, t) {
  const [r, i] = Hh(
    t?.in,
    n,
    e
  ), s = r.getFullYear() - i.getFullYear(), o = r.getMonth() - i.getMonth();
  return s * 12 + o;
}
function LQe(n, e) {
  const t = gn(n, e?.in), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function Xre(n, e) {
  const [t, r] = Hh(n, e.start, e.end);
  return { start: t, end: r };
}
function $Qe(n, e) {
  const { start: t, end: r } = Xre(e?.in, n);
  let i = +t > +r;
  const s = i ? +t : +r, o = i ? r : t;
  o.setHours(0, 0, 0, 0), o.setDate(1);
  let a = 1;
  const l = [];
  for (; +o <= s; )
    l.push(dr(t, o)), o.setMonth(o.getMonth() + a);
  return i ? l.reverse() : l;
}
function FQe(n, e) {
  const t = gn(n, e?.in);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function BQe(n, e) {
  const t = gn(n, e?.in), r = t.getFullYear();
  return t.setFullYear(r + 1, 0, 0), t.setHours(23, 59, 59, 999), t;
}
function Zre(n, e) {
  const t = gn(n, e?.in);
  return t.setFullYear(t.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function zQe(n, e) {
  const { start: t, end: r } = Xre(e?.in, n);
  let i = +t > +r;
  const s = i ? +t : +r, o = i ? r : t;
  o.setHours(0, 0, 0, 0), o.setMonth(0, 1);
  let a = 1;
  const l = [];
  for (; +o <= s; )
    l.push(dr(t, o)), o.setFullYear(o.getFullYear() + a);
  return i ? l.reverse() : l;
}
function Qre(n, e) {
  const t = P1(), r = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? t.weekStartsOn ?? t.locale?.options?.weekStartsOn ?? 0, i = gn(n, e?.in), s = i.getDay(), o = (s < r ? -7 : 0) + 6 - (s - r);
  return i.setDate(i.getDate() + o), i.setHours(23, 59, 59, 999), i;
}
function HQe(n, e) {
  return Qre(n, { ...e, weekStartsOn: 1 });
}
const UQe = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, VQe = (n, e, t) => {
  let r;
  const i = UQe[n];
  return typeof i == "string" ? r = i : e === 1 ? r = i.one : r = i.other.replace("{{count}}", e.toString()), t?.addSuffix ? t.comparison && t.comparison > 0 ? "in " + r : r + " ago" : r;
};
function V6(n) {
  return (e = {}) => {
    const t = e.width ? String(e.width) : n.defaultWidth;
    return n.formats[t] || n.formats[n.defaultWidth];
  };
}
const jQe = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, WQe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, GQe = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, KQe = {
  date: V6({
    formats: jQe,
    defaultWidth: "full"
  }),
  time: V6({
    formats: WQe,
    defaultWidth: "full"
  }),
  dateTime: V6({
    formats: GQe,
    defaultWidth: "full"
  })
}, qQe = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, YQe = (n, e, t, r) => qQe[n];
function up(n) {
  return (e, t) => {
    const r = t?.context ? String(t.context) : "standalone";
    let i;
    if (r === "formatting" && n.formattingValues) {
      const o = n.defaultFormattingWidth || n.defaultWidth, a = t?.width ? String(t.width) : o;
      i = n.formattingValues[a] || n.formattingValues[o];
    } else {
      const o = n.defaultWidth, a = t?.width ? String(t.width) : n.defaultWidth;
      i = n.values[a] || n.values[o];
    }
    const s = n.argumentCallback ? n.argumentCallback(e) : e;
    return i[s];
  };
}
const XQe = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, ZQe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, QQe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, JQe = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, eJe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, tJe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, nJe = (n, e) => {
  const t = Number(n), r = t % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, rJe = {
  ordinalNumber: nJe,
  era: up({
    values: XQe,
    defaultWidth: "wide"
  }),
  quarter: up({
    values: ZQe,
    defaultWidth: "wide",
    argumentCallback: (n) => n - 1
  }),
  month: up({
    values: QQe,
    defaultWidth: "wide"
  }),
  day: up({
    values: JQe,
    defaultWidth: "wide"
  }),
  dayPeriod: up({
    values: eJe,
    defaultWidth: "wide",
    formattingValues: tJe,
    defaultFormattingWidth: "wide"
  })
};
function dp(n) {
  return (e, t = {}) => {
    const r = t.width, i = r && n.matchPatterns[r] || n.matchPatterns[n.defaultMatchWidth], s = e.match(i);
    if (!s)
      return null;
    const o = s[0], a = r && n.parsePatterns[r] || n.parsePatterns[n.defaultParseWidth], l = Array.isArray(a) ? sJe(a, (d) => d.test(o)) : (
      // [TODO] -- I challenge you to fix the type
      iJe(a, (d) => d.test(o))
    );
    let c;
    c = n.valueCallback ? n.valueCallback(l) : l, c = t.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      t.valueCallback(c)
    ) : c;
    const u = e.slice(o.length);
    return { value: c, rest: u };
  };
}
function iJe(n, e) {
  for (const t in n)
    if (Object.prototype.hasOwnProperty.call(n, t) && e(n[t]))
      return t;
}
function sJe(n, e) {
  for (let t = 0; t < n.length; t++)
    if (e(n[t]))
      return t;
}
function oJe(n) {
  return (e, t = {}) => {
    const r = e.match(n.matchPattern);
    if (!r) return null;
    const i = r[0], s = e.match(n.parsePattern);
    if (!s) return null;
    let o = n.valueCallback ? n.valueCallback(s[0]) : s[0];
    o = t.valueCallback ? t.valueCallback(o) : o;
    const a = e.slice(i.length);
    return { value: o, rest: a };
  };
}
const aJe = /^(\d+)(th|st|nd|rd)?/i, lJe = /\d+/i, cJe = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, uJe = {
  any: [/^b/i, /^(a|c)/i]
}, dJe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, fJe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, hJe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, pJe = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, mJe = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, gJe = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, vJe = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, yJe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, bJe = {
  ordinalNumber: oJe({
    matchPattern: aJe,
    parsePattern: lJe,
    valueCallback: (n) => parseInt(n, 10)
  }),
  era: dp({
    matchPatterns: cJe,
    defaultMatchWidth: "wide",
    parsePatterns: uJe,
    defaultParseWidth: "any"
  }),
  quarter: dp({
    matchPatterns: dJe,
    defaultMatchWidth: "wide",
    parsePatterns: fJe,
    defaultParseWidth: "any",
    valueCallback: (n) => n + 1
  }),
  month: dp({
    matchPatterns: hJe,
    defaultMatchWidth: "wide",
    parsePatterns: pJe,
    defaultParseWidth: "any"
  }),
  day: dp({
    matchPatterns: mJe,
    defaultMatchWidth: "wide",
    parsePatterns: gJe,
    defaultParseWidth: "any"
  }),
  dayPeriod: dp({
    matchPatterns: vJe,
    defaultMatchWidth: "any",
    parsePatterns: yJe,
    defaultParseWidth: "any"
  })
}, $_ = {
  code: "en-US",
  formatDistance: VQe,
  formatLong: KQe,
  formatRelative: YQe,
  localize: rJe,
  match: bJe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function wJe(n, e) {
  const t = gn(n, e?.in);
  return qre(t, Zre(t)) + 1;
}
function Jre(n, e) {
  const t = gn(n, e?.in), r = +_0(t) - +kQe(t);
  return Math.round(r / jre) + 1;
}
function eie(n, e) {
  const t = gn(n, e?.in), r = t.getFullYear(), i = P1(), s = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? i.firstWeekContainsDate ?? i.locale?.options?.firstWeekContainsDate ?? 1, o = dr(e?.in || n, 0);
  o.setFullYear(r + 1, 0, s), o.setHours(0, 0, 0, 0);
  const a = nh(o, e), l = dr(e?.in || n, 0);
  l.setFullYear(r, 0, s), l.setHours(0, 0, 0, 0);
  const c = nh(l, e);
  return +t >= +a ? r + 1 : +t >= +c ? r : r - 1;
}
function xJe(n, e) {
  const t = P1(), r = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? t.firstWeekContainsDate ?? t.locale?.options?.firstWeekContainsDate ?? 1, i = eie(n, e), s = dr(e?.in || n, 0);
  return s.setFullYear(i, 0, r), s.setHours(0, 0, 0, 0), nh(s, e);
}
function tie(n, e) {
  const t = gn(n, e?.in), r = +nh(t, e) - +xJe(t, e);
  return Math.round(r / jre) + 1;
}
function an(n, e) {
  const t = n < 0 ? "-" : "", r = Math.abs(n).toString().padStart(e, "0");
  return t + r;
}
const Ol = {
  // Year
  y(n, e) {
    const t = n.getFullYear(), r = t > 0 ? t : 1 - t;
    return an(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M(n, e) {
    const t = n.getMonth();
    return e === "M" ? String(t + 1) : an(t + 1, 2);
  },
  // Day of the month
  d(n, e) {
    return an(n.getDate(), e.length);
  },
  // AM or PM
  a(n, e) {
    const t = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(n, e) {
    return an(n.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(n, e) {
    return an(n.getHours(), e.length);
  },
  // Minute
  m(n, e) {
    return an(n.getMinutes(), e.length);
  },
  // Second
  s(n, e) {
    return an(n.getSeconds(), e.length);
  },
  // Fraction of second
  S(n, e) {
    const t = e.length, r = n.getMilliseconds(), i = Math.trunc(
      r * Math.pow(10, t - 3)
    );
    return an(i, e.length);
  }
}, _d = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, tU = {
  // Era
  G: function(n, e, t) {
    const r = n.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return t.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return t.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(n, e, t) {
    if (e === "yo") {
      const r = n.getFullYear(), i = r > 0 ? r : 1 - r;
      return t.ordinalNumber(i, { unit: "year" });
    }
    return Ol.y(n, e);
  },
  // Local week-numbering year
  Y: function(n, e, t, r) {
    const i = eie(n, r), s = i > 0 ? i : 1 - i;
    if (e === "YY") {
      const o = s % 100;
      return an(o, 2);
    }
    return e === "Yo" ? t.ordinalNumber(s, { unit: "year" }) : an(s, e.length);
  },
  // ISO week-numbering year
  R: function(n, e) {
    const t = Kre(n);
    return an(t, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(n, e) {
    const t = n.getFullYear();
    return an(t, e.length);
  },
  // Quarter
  Q: function(n, e, t) {
    const r = Math.ceil((n.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return an(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(n, e, t) {
    const r = Math.ceil((n.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return an(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(n, e, t) {
    const r = n.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return Ol.M(n, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return t.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return t.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(n, e, t) {
    const r = n.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return an(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return t.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return t.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(n, e, t, r) {
    const i = tie(n, r);
    return e === "wo" ? t.ordinalNumber(i, { unit: "week" }) : an(i, e.length);
  },
  // ISO week of year
  I: function(n, e, t) {
    const r = Jre(n);
    return e === "Io" ? t.ordinalNumber(r, { unit: "week" }) : an(r, e.length);
  },
  // Day of the month
  d: function(n, e, t) {
    return e === "do" ? t.ordinalNumber(n.getDate(), { unit: "date" }) : Ol.d(n, e);
  },
  // Day of year
  D: function(n, e, t) {
    const r = wJe(n);
    return e === "Do" ? t.ordinalNumber(r, { unit: "dayOfYear" }) : an(r, e.length);
  },
  // Day of week
  E: function(n, e, t) {
    const r = n.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(n, e, t, r) {
    const i = n.getDay(), s = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(s);
      // Padded numerical value
      case "ee":
        return an(s, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return t.ordinalNumber(s, { unit: "day" });
      case "eee":
        return t.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return t.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return t.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(n, e, t, r) {
    const i = n.getDay(), s = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(s);
      // Padded numerical value
      case "cc":
        return an(s, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return t.ordinalNumber(s, { unit: "day" });
      case "ccc":
        return t.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return t.day(i, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(i, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return t.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(n, e, t) {
    const r = n.getDay(), i = r === 0 ? 7 : r;
    switch (e) {
      // 2
      case "i":
        return String(i);
      // 02
      case "ii":
        return an(i, e.length);
      // 2nd
      case "io":
        return t.ordinalNumber(i, { unit: "day" });
      // Tue
      case "iii":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(n, e, t) {
    const i = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(n, e, t) {
    const r = n.getHours();
    let i;
    switch (r === 12 ? i = _d.noon : r === 0 ? i = _d.midnight : i = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(n, e, t) {
    const r = n.getHours();
    let i;
    switch (r >= 17 ? i = _d.evening : r >= 12 ? i = _d.afternoon : r >= 4 ? i = _d.morning : i = _d.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(n, e, t) {
    if (e === "ho") {
      let r = n.getHours() % 12;
      return r === 0 && (r = 12), t.ordinalNumber(r, { unit: "hour" });
    }
    return Ol.h(n, e);
  },
  // Hour [0-23]
  H: function(n, e, t) {
    return e === "Ho" ? t.ordinalNumber(n.getHours(), { unit: "hour" }) : Ol.H(n, e);
  },
  // Hour [0-11]
  K: function(n, e, t) {
    const r = n.getHours() % 12;
    return e === "Ko" ? t.ordinalNumber(r, { unit: "hour" }) : an(r, e.length);
  },
  // Hour [1-24]
  k: function(n, e, t) {
    let r = n.getHours();
    return r === 0 && (r = 24), e === "ko" ? t.ordinalNumber(r, { unit: "hour" }) : an(r, e.length);
  },
  // Minute
  m: function(n, e, t) {
    return e === "mo" ? t.ordinalNumber(n.getMinutes(), { unit: "minute" }) : Ol.m(n, e);
  },
  // Second
  s: function(n, e, t) {
    return e === "so" ? t.ordinalNumber(n.getSeconds(), { unit: "second" }) : Ol.s(n, e);
  },
  // Fraction of second
  S: function(n, e) {
    return Ol.S(n, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(n, e, t) {
    const r = n.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return rU(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Zc(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Zc(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return rU(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Zc(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Zc(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + nU(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Zc(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + nU(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Zc(r, ":");
    }
  },
  // Seconds timestamp
  t: function(n, e, t) {
    const r = Math.trunc(+n / 1e3);
    return an(r, e.length);
  },
  // Milliseconds timestamp
  T: function(n, e, t) {
    return an(+n, e.length);
  }
};
function nU(n, e = "") {
  const t = n > 0 ? "-" : "+", r = Math.abs(n), i = Math.trunc(r / 60), s = r % 60;
  return s === 0 ? t + String(i) : t + String(i) + e + an(s, 2);
}
function rU(n, e) {
  return n % 60 === 0 ? (n > 0 ? "-" : "+") + an(Math.abs(n) / 60, 2) : Zc(n, e);
}
function Zc(n, e = "") {
  const t = n > 0 ? "-" : "+", r = Math.abs(n), i = an(Math.trunc(r / 60), 2), s = an(r % 60, 2);
  return t + i + e + s;
}
const iU = (n, e) => {
  switch (n) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, nie = (n, e) => {
  switch (n) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, EJe = (n, e) => {
  const t = n.match(/(P+)(p+)?/) || [], r = t[1], i = t[2];
  if (!i)
    return iU(n, e);
  let s;
  switch (r) {
    case "P":
      s = e.dateTime({ width: "short" });
      break;
    case "PP":
      s = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      s = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      s = e.dateTime({ width: "full" });
      break;
  }
  return s.replace("{{date}}", iU(r, e)).replace("{{time}}", nie(i, e));
}, SJe = {
  p: nie,
  P: EJe
}, CJe = /^D+$/, TJe = /^Y+$/, AJe = ["D", "DD", "YY", "YYYY"];
function MJe(n) {
  return CJe.test(n);
}
function kJe(n) {
  return TJe.test(n);
}
function _Je(n, e, t) {
  const r = OJe(n, e, t);
  if (console.warn(r), AJe.includes(n)) throw new RangeError(r);
}
function OJe(n, e, t) {
  const r = n[0] === "Y" ? "years" : "days of the month";
  return `Use \`${n.toLowerCase()}\` instead of \`${n}\` (in \`${e}\`) for formatting ${r} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const IJe = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, RJe = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, PJe = /^'([^]*?)'?$/, DJe = /''/g, NJe = /[a-zA-Z]/;
function LJe(n, e, t) {
  const r = P1(), i = t?.locale ?? r.locale ?? $_, s = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, o = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, a = gn(n, t?.in);
  if (!DQe(a))
    throw new RangeError("Invalid time value");
  let l = e.match(RJe).map((u) => {
    const d = u[0];
    if (d === "p" || d === "P") {
      const f = SJe[d];
      return f(u, i.formatLong);
    }
    return u;
  }).join("").match(IJe).map((u) => {
    if (u === "''")
      return { isToken: !1, value: "'" };
    const d = u[0];
    if (d === "'")
      return { isToken: !1, value: $Je(u) };
    if (tU[d])
      return { isToken: !0, value: u };
    if (d.match(NJe))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + d + "`"
      );
    return { isToken: !1, value: u };
  });
  i.localize.preprocessor && (l = i.localize.preprocessor(a, l));
  const c = {
    firstWeekContainsDate: s,
    weekStartsOn: o,
    locale: i
  };
  return l.map((u) => {
    if (!u.isToken) return u.value;
    const d = u.value;
    (!t?.useAdditionalWeekYearTokens && kJe(d) || !t?.useAdditionalDayOfYearTokens && MJe(d)) && _Je(d, e, String(n));
    const f = tU[d[0]];
    return f(a, d, i.localize, c);
  }).join("");
}
function $Je(n) {
  const e = n.match(PJe);
  return e ? e[1].replace(DJe, "'") : n;
}
function FJe(n, e) {
  const t = gn(n, e?.in), r = t.getFullYear(), i = t.getMonth(), s = dr(t, 0);
  return s.setFullYear(r, i + 1, 0), s.setHours(0, 0, 0, 0), s.getDate();
}
function BJe(n, e) {
  return gn(n, e?.in).getMonth();
}
function zJe(n, e) {
  return gn(n, e?.in).getFullYear();
}
function HJe(n, e) {
  return +gn(n) > +gn(e);
}
function UJe(n, e) {
  return +gn(n) < +gn(e);
}
function VJe(n, e, t) {
  const [r, i] = Hh(
    t?.in,
    n,
    e
  );
  return r.getFullYear() === i.getFullYear() && r.getMonth() === i.getMonth();
}
function jJe(n, e, t) {
  const [r, i] = Hh(
    t?.in,
    n,
    e
  );
  return r.getFullYear() === i.getFullYear();
}
function WJe(n, e, t) {
  const r = gn(n, t?.in), i = r.getFullYear(), s = r.getDate(), o = dr(n, 0);
  o.setFullYear(i, e, 15), o.setHours(0, 0, 0, 0);
  const a = FJe(o);
  return r.setMonth(e, Math.min(s, a)), r;
}
function GJe(n, e, t) {
  const r = gn(n, t?.in);
  return isNaN(+r) ? dr(n, NaN) : (r.setFullYear(e), r);
}
const sU = 5, KJe = 4;
function qJe(n, e) {
  const t = e.startOfMonth(n), r = t.getDay() > 0 ? t.getDay() : 7, i = e.addDays(n, -r + 1), s = e.addDays(i, sU * 7 - 1);
  return e.getMonth(n) === e.getMonth(s) ? sU : KJe;
}
function rie(n, e) {
  const t = e.startOfMonth(n), r = t.getDay();
  return r === 1 ? t : r === 0 ? e.addDays(t, -6) : e.addDays(t, -1 * (r - 1));
}
function YJe(n, e) {
  const t = rie(n, e), r = qJe(n, e);
  return e.addDays(t, r * 7 - 1);
}
class ws {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(e, t) {
    this.Date = Date, this.today = () => this.overrides?.today ? this.overrides.today() : this.options.timeZone ? ei.tz(this.options.timeZone) : new this.Date(), this.newDate = (r, i, s) => this.overrides?.newDate ? this.overrides.newDate(r, i, s) : this.options.timeZone ? new ei(r, i, s, this.options.timeZone) : new Date(r, i, s), this.addDays = (r, i) => this.overrides?.addDays ? this.overrides.addDays(r, i) : Wre(r, i), this.addMonths = (r, i) => this.overrides?.addMonths ? this.overrides.addMonths(r, i) : Gre(r, i), this.addWeeks = (r, i) => this.overrides?.addWeeks ? this.overrides.addWeeks(r, i) : _Qe(r, i), this.addYears = (r, i) => this.overrides?.addYears ? this.overrides.addYears(r, i) : OQe(r, i), this.differenceInCalendarDays = (r, i) => this.overrides?.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, i) : qre(r, i), this.differenceInCalendarMonths = (r, i) => this.overrides?.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, i) : NQe(r, i), this.eachMonthOfInterval = (r) => this.overrides?.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(r) : $Qe(r), this.eachYearOfInterval = (r) => {
      const i = this.overrides?.eachYearOfInterval ? this.overrides.eachYearOfInterval(r) : zQe(r), s = new Set(i.map((a) => this.getYear(a)));
      if (s.size === i.length)
        return i;
      const o = [];
      return s.forEach((a) => {
        o.push(new Date(a, 0, 1));
      }), o;
    }, this.endOfBroadcastWeek = (r) => this.overrides?.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(r) : YJe(r, this), this.endOfISOWeek = (r) => this.overrides?.endOfISOWeek ? this.overrides.endOfISOWeek(r) : HQe(r), this.endOfMonth = (r) => this.overrides?.endOfMonth ? this.overrides.endOfMonth(r) : LQe(r), this.endOfWeek = (r, i) => this.overrides?.endOfWeek ? this.overrides.endOfWeek(r, i) : Qre(r, this.options), this.endOfYear = (r) => this.overrides?.endOfYear ? this.overrides.endOfYear(r) : BQe(r), this.format = (r, i, s) => {
      const o = this.overrides?.format ? this.overrides.format(r, i, this.options) : LJe(r, i, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(o) : o;
    }, this.getISOWeek = (r) => this.overrides?.getISOWeek ? this.overrides.getISOWeek(r) : Jre(r), this.getMonth = (r, i) => this.overrides?.getMonth ? this.overrides.getMonth(r, this.options) : BJe(r, this.options), this.getYear = (r, i) => this.overrides?.getYear ? this.overrides.getYear(r, this.options) : zJe(r, this.options), this.getWeek = (r, i) => this.overrides?.getWeek ? this.overrides.getWeek(r, this.options) : tie(r, this.options), this.isAfter = (r, i) => this.overrides?.isAfter ? this.overrides.isAfter(r, i) : HJe(r, i), this.isBefore = (r, i) => this.overrides?.isBefore ? this.overrides.isBefore(r, i) : UJe(r, i), this.isDate = (r) => this.overrides?.isDate ? this.overrides.isDate(r) : Yre(r), this.isSameDay = (r, i) => this.overrides?.isSameDay ? this.overrides.isSameDay(r, i) : PQe(r, i), this.isSameMonth = (r, i) => this.overrides?.isSameMonth ? this.overrides.isSameMonth(r, i) : VJe(r, i), this.isSameYear = (r, i) => this.overrides?.isSameYear ? this.overrides.isSameYear(r, i) : jJe(r, i), this.max = (r) => this.overrides?.max ? this.overrides.max(r) : IQe(r), this.min = (r) => this.overrides?.min ? this.overrides.min(r) : RQe(r), this.setMonth = (r, i) => this.overrides?.setMonth ? this.overrides.setMonth(r, i) : WJe(r, i), this.setYear = (r, i) => this.overrides?.setYear ? this.overrides.setYear(r, i) : GJe(r, i), this.startOfBroadcastWeek = (r, i) => this.overrides?.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(r, this) : rie(r, this), this.startOfDay = (r) => this.overrides?.startOfDay ? this.overrides.startOfDay(r) : O0(r), this.startOfISOWeek = (r) => this.overrides?.startOfISOWeek ? this.overrides.startOfISOWeek(r) : _0(r), this.startOfMonth = (r) => this.overrides?.startOfMonth ? this.overrides.startOfMonth(r) : FQe(r), this.startOfWeek = (r, i) => this.overrides?.startOfWeek ? this.overrides.startOfWeek(r, this.options) : nh(r, this.options), this.startOfYear = (r) => this.overrides?.startOfYear ? this.overrides.startOfYear(r) : Zre(r), this.options = { locale: $_, ...e }, this.overrides = t;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: e = "latn" } = this.options, t = new Intl.NumberFormat("en-US", {
      numberingSystem: e
    }), r = {};
    for (let i = 0; i < 10; i++)
      r[i.toString()] = t.format(i);
    return r;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(e) {
    const t = this.getDigitMap();
    return e.replace(/\d/g, (r) => t[r] || r);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(e) {
    return this.replaceDigits(e.toString());
  }
  /**
   * Returns the preferred ordering for month and year labels for the current
   * locale.
   */
  getMonthYearOrder() {
    const e = this.options.locale?.code;
    return e && ws.yearFirstLocales.has(e) ? "year-first" : "month-first";
  }
  /**
   * Formats the month/year pair respecting locale conventions.
   *
   * @since 9.11.0
   */
  formatMonthYear(e) {
    const { locale: t, timeZone: r, numerals: i } = this.options, s = t?.code;
    if (s && ws.yearFirstLocales.has(s))
      try {
        return new Intl.DateTimeFormat(s, {
          month: "long",
          year: "numeric",
          timeZone: r,
          numberingSystem: i
        }).format(e);
      } catch {
      }
    const o = this.getMonthYearOrder() === "year-first" ? "y LLLL" : "LLLL y";
    return this.format(e, o);
  }
}
ws.yearFirstLocales = /* @__PURE__ */ new Set([
  "eu",
  "hu",
  "ja",
  "ja-Hira",
  "ja-JP",
  "ko",
  "ko-KR",
  "lt",
  "lt-LT",
  "lv",
  "lv-LV",
  "mn",
  "mn-MN",
  "zh",
  "zh-CN",
  "zh-HK",
  "zh-TW"
]);
const Aa = new ws();
class iie {
  constructor(e, t, r = Aa) {
    this.date = e, this.displayMonth = t, this.outside = !!(t && !r.isSameMonth(e, t)), this.dateLib = r;
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(e) {
    return this.dateLib.isSameDay(e.date, this.date) && this.dateLib.isSameMonth(e.displayMonth, this.displayMonth);
  }
}
class XJe {
  constructor(e, t) {
    this.date = e, this.weeks = t;
  }
}
class ZJe {
  constructor(e, t) {
    this.days = t, this.weekNumber = e;
  }
}
function QJe(n) {
  return p.createElement("button", { ...n });
}
function JJe(n) {
  return p.createElement("span", { ...n });
}
function eet(n) {
  const { size: e = 24, orientation: t = "left", className: r } = n;
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: handled by the parent component
    p.createElement(
      "svg",
      { className: r, width: e, height: e, viewBox: "0 0 24 24" },
      t === "up" && p.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
      t === "down" && p.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
      t === "left" && p.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
      t === "right" && p.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
    )
  );
}
function tet(n) {
  const { day: e, modifiers: t, ...r } = n;
  return p.createElement("td", { ...r });
}
function net(n) {
  const { day: e, modifiers: t, ...r } = n, i = p.useRef(null);
  return p.useEffect(() => {
    t.focused && i.current?.focus();
  }, [t.focused]), p.createElement("button", { ref: i, ...r });
}
var rt;
(function(n) {
  n.Root = "root", n.Chevron = "chevron", n.Day = "day", n.DayButton = "day_button", n.CaptionLabel = "caption_label", n.Dropdowns = "dropdowns", n.Dropdown = "dropdown", n.DropdownRoot = "dropdown_root", n.Footer = "footer", n.MonthGrid = "month_grid", n.MonthCaption = "month_caption", n.MonthsDropdown = "months_dropdown", n.Month = "month", n.Months = "months", n.Nav = "nav", n.NextMonthButton = "button_next", n.PreviousMonthButton = "button_previous", n.Week = "week", n.Weeks = "weeks", n.Weekday = "weekday", n.Weekdays = "weekdays", n.WeekNumber = "week_number", n.WeekNumberHeader = "week_number_header", n.YearsDropdown = "years_dropdown";
})(rt || (rt = {}));
var Un;
(function(n) {
  n.disabled = "disabled", n.hidden = "hidden", n.outside = "outside", n.focused = "focused", n.today = "today";
})(Un || (Un = {}));
var fo;
(function(n) {
  n.range_end = "range_end", n.range_middle = "range_middle", n.range_start = "range_start", n.selected = "selected";
})(fo || (fo = {}));
var as;
(function(n) {
  n.weeks_before_enter = "weeks_before_enter", n.weeks_before_exit = "weeks_before_exit", n.weeks_after_enter = "weeks_after_enter", n.weeks_after_exit = "weeks_after_exit", n.caption_after_enter = "caption_after_enter", n.caption_after_exit = "caption_after_exit", n.caption_before_enter = "caption_before_enter", n.caption_before_exit = "caption_before_exit";
})(as || (as = {}));
function ret(n) {
  const { options: e, className: t, components: r, classNames: i, ...s } = n, o = [i[rt.Dropdown], t].join(" "), a = e?.find(({ value: l }) => l === s.value);
  return p.createElement(
    "span",
    { "data-disabled": s.disabled, className: i[rt.DropdownRoot] },
    p.createElement(r.Select, { className: o, ...s }, e?.map(({ value: l, label: c, disabled: u }) => p.createElement(r.Option, { key: l, value: l, disabled: u }, c))),
    p.createElement(
      "span",
      { className: i[rt.CaptionLabel], "aria-hidden": !0 },
      a?.label,
      p.createElement(r.Chevron, { orientation: "down", size: 18, className: i[rt.Chevron] })
    )
  );
}
function iet(n) {
  return p.createElement("div", { ...n });
}
function set(n) {
  return p.createElement("div", { ...n });
}
function oet(n) {
  const { calendarMonth: e, displayIndex: t, ...r } = n;
  return p.createElement("div", { ...r }, n.children);
}
function aet(n) {
  const { calendarMonth: e, displayIndex: t, ...r } = n;
  return p.createElement("div", { ...r });
}
function cet(n) {
  return p.createElement("table", { ...n });
}
function uet(n) {
  return p.createElement("div", { ...n });
}
const sie = Ws(void 0);
function D1() {
  const n = Wi(sie);
  if (n === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return n;
}
function det(n) {
  const { components: e } = D1();
  return p.createElement(e.Dropdown, { ...n });
}
function fet(n) {
  const { onPreviousClick: e, onNextClick: t, previousMonth: r, nextMonth: i, ...s } = n, { components: o, classNames: a, labels: { labelPrevious: l, labelNext: c } } = D1(), u = Ft((f) => {
    i && t?.(f);
  }, [i, t]), d = Ft((f) => {
    r && e?.(f);
  }, [r, e]);
  return p.createElement(
    "nav",
    { ...s },
    p.createElement(
      o.PreviousMonthButton,
      { type: "button", className: a[rt.PreviousMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": l(r), onClick: d },
      p.createElement(o.Chevron, { disabled: r ? void 0 : !0, className: a[rt.Chevron], orientation: "left" })
    ),
    p.createElement(
      o.NextMonthButton,
      { type: "button", className: a[rt.NextMonthButton], tabIndex: i ? void 0 : -1, "aria-disabled": i ? void 0 : !0, "aria-label": c(i), onClick: u },
      p.createElement(o.Chevron, { disabled: i ? void 0 : !0, orientation: "right", className: a[rt.Chevron] })
    )
  );
}
function het(n) {
  const { components: e } = D1();
  return p.createElement(e.Button, { ...n });
}
function pet(n) {
  return p.createElement("option", { ...n });
}
function met(n) {
  const { components: e } = D1();
  return p.createElement(e.Button, { ...n });
}
function get(n) {
  const { rootRef: e, ...t } = n;
  return p.createElement("div", { ...t, ref: e });
}
function vet(n) {
  return p.createElement("select", { ...n });
}
function yet(n) {
  const { week: e, ...t } = n;
  return p.createElement("tr", { ...t });
}
function bet(n) {
  return p.createElement("th", { ...n });
}
function wet(n) {
  return p.createElement(
    "thead",
    { "aria-hidden": !0 },
    p.createElement("tr", { ...n })
  );
}
function xet(n) {
  const { week: e, ...t } = n;
  return p.createElement("th", { ...t });
}
function Eet(n) {
  return p.createElement("th", { ...n });
}
function Cet(n) {
  return p.createElement("tbody", { ...n });
}
function Tet(n) {
  const { components: e } = D1();
  return p.createElement(e.Dropdown, { ...n });
}
const Aet = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: QJe,
  CaptionLabel: JJe,
  Chevron: eet,
  Day: tet,
  DayButton: net,
  Dropdown: ret,
  DropdownNav: iet,
  Footer: set,
  Month: oet,
  MonthCaption: aet,
  MonthGrid: cet,
  Months: uet,
  MonthsDropdown: det,
  Nav: fet,
  NextMonthButton: het,
  Option: pet,
  PreviousMonthButton: met,
  Root: get,
  Select: vet,
  Week: yet,
  WeekNumber: xet,
  WeekNumberHeader: Eet,
  Weekday: bet,
  Weekdays: wet,
  Weeks: Cet,
  YearsDropdown: Tet
}, Symbol.toStringTag, { value: "Module" }));
function Qa(n, e, t = !1, r = Aa) {
  let { from: i, to: s } = n;
  const { differenceInCalendarDays: o, isSameDay: a } = r;
  return i && s ? (o(s, i) < 0 && ([i, s] = [s, i]), o(e, i) >= (t ? 1 : 0) && o(s, e) >= (t ? 1 : 0)) : !t && s ? a(s, e) : !t && i ? a(i, e) : !1;
}
function oie(n) {
  return !!(n && typeof n == "object" && "before" in n && "after" in n);
}
function F_(n) {
  return !!(n && typeof n == "object" && "from" in n);
}
function aie(n) {
  return !!(n && typeof n == "object" && "after" in n);
}
function lie(n) {
  return !!(n && typeof n == "object" && "before" in n);
}
function cie(n) {
  return !!(n && typeof n == "object" && "dayOfWeek" in n);
}
function uie(n, e) {
  return Array.isArray(n) && n.every(e.isDate);
}
function Ja(n, e, t = Aa) {
  const r = Array.isArray(e) ? e : [e], { isSameDay: i, differenceInCalendarDays: s, isAfter: o } = t;
  return r.some((a) => {
    if (typeof a == "boolean")
      return a;
    if (t.isDate(a))
      return i(n, a);
    if (uie(a, t))
      return a.includes(n);
    if (F_(a))
      return Qa(a, n, !1, t);
    if (cie(a))
      return Array.isArray(a.dayOfWeek) ? a.dayOfWeek.includes(n.getDay()) : a.dayOfWeek === n.getDay();
    if (oie(a)) {
      const l = s(a.before, n), c = s(a.after, n), u = l > 0, d = c < 0;
      return o(a.before, a.after) ? d && u : u || d;
    }
    return aie(a) ? s(n, a.after) > 0 : lie(a) ? s(a.before, n) > 0 : typeof a == "function" ? a(n) : !1;
  });
}
function Met(n, e, t, r, i) {
  const { disabled: s, hidden: o, modifiers: a, showOutsideDays: l, broadcastCalendar: c, today: u } = e, { isSameDay: d, isSameMonth: f, startOfMonth: h, isBefore: m, endOfMonth: g, isAfter: v } = i, y = t && h(t), b = r && g(r), x = {
    [Un.focused]: [],
    [Un.outside]: [],
    [Un.disabled]: [],
    [Un.hidden]: [],
    [Un.today]: []
  }, E = {};
  for (const w of n) {
    const { date: C, displayMonth: S } = w, M = !!(S && !f(C, S)), k = !!(y && m(C, y)), _ = !!(b && v(C, b)), O = !!(s && Ja(C, s, i)), I = !!(o && Ja(C, o, i)) || k || _ || // Broadcast calendar will show outside days as default
    !c && !l && M || c && l === !1 && M, R = d(C, u ?? i.today());
    M && x.outside.push(w), O && x.disabled.push(w), I && x.hidden.push(w), R && x.today.push(w), a && Object.keys(a).forEach((P) => {
      const D = a?.[P];
      D && Ja(C, D, i) && (E[P] ? E[P].push(w) : E[P] = [w]);
    });
  }
  return (w) => {
    const C = {
      [Un.focused]: !1,
      [Un.disabled]: !1,
      [Un.hidden]: !1,
      [Un.outside]: !1,
      [Un.today]: !1
    }, S = {};
    for (const M in x) {
      const k = x[M];
      C[M] = k.some((_) => _ === w);
    }
    for (const M in E)
      S[M] = E[M].some((k) => k === w);
    return {
      ...C,
      // custom modifiers should override all the previous ones
      ...S
    };
  };
}
function ket(n, e, t = {}) {
  return Object.entries(n).filter(([, i]) => i === !0).reduce((i, [s]) => (t[s] ? i.push(t[s]) : e[Un[s]] ? i.push(e[Un[s]]) : e[fo[s]] && i.push(e[fo[s]]), i), [e[rt.Day]]);
}
function _et(n) {
  return {
    ...Aet,
    ...n
  };
}
function Oet(n) {
  const e = {
    "data-mode": n.mode ?? void 0,
    "data-required": "required" in n ? n.required : void 0,
    "data-multiple-months": n.numberOfMonths && n.numberOfMonths > 1 || void 0,
    "data-week-numbers": n.showWeekNumber || void 0,
    "data-broadcast-calendar": n.broadcastCalendar || void 0,
    "data-nav-layout": n.navLayout || void 0
  };
  return Object.entries(n).forEach(([t, r]) => {
    t.startsWith("data-") && (e[t] = r);
  }), e;
}
function B_() {
  const n = {};
  for (const e in rt)
    n[rt[e]] = `rdp-${rt[e]}`;
  for (const e in Un)
    n[Un[e]] = `rdp-${Un[e]}`;
  for (const e in fo)
    n[fo[e]] = `rdp-${fo[e]}`;
  for (const e in as)
    n[as[e]] = `rdp-${as[e]}`;
  return n;
}
function die(n, e, t) {
  return (t ?? new ws(e)).formatMonthYear(n);
}
const Iet = die;
function Ret(n, e, t) {
  return (t ?? new ws(e)).format(n, "d");
}
function Pet(n, e = Aa) {
  return e.format(n, "LLLL");
}
function Det(n, e, t) {
  return (t ?? new ws(e)).format(n, "cccccc");
}
function Net(n, e = Aa) {
  return n < 10 ? e.formatNumber(`0${n.toLocaleString()}`) : e.formatNumber(`${n.toLocaleString()}`);
}
function Let() {
  return "";
}
function fie(n, e = Aa) {
  return e.format(n, "yyyy");
}
const $et = fie, Fet = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: die,
  formatDay: Ret,
  formatMonthCaption: Iet,
  formatMonthDropdown: Pet,
  formatWeekNumber: Net,
  formatWeekNumberHeader: Let,
  formatWeekdayName: Det,
  formatYearCaption: $et,
  formatYearDropdown: fie
}, Symbol.toStringTag, { value: "Module" }));
function Bet(n) {
  return n?.formatMonthCaption && !n.formatCaption && (n.formatCaption = n.formatMonthCaption), n?.formatYearCaption && !n.formatYearDropdown && (n.formatYearDropdown = n.formatYearCaption), {
    ...Fet,
    ...n
  };
}
function zet(n, e, t, r, i) {
  const { startOfMonth: s, startOfYear: o, endOfYear: a, eachMonthOfInterval: l, getMonth: c } = i;
  return l({
    start: o(n),
    end: a(n)
  }).map((f) => {
    const h = r.formatMonthDropdown(f, i), m = c(f), g = e && f < s(e) || t && f > s(t) || !1;
    return { value: m, label: h, disabled: g };
  });
}
function Het(n, e = {}, t = {}) {
  let r = { ...e?.[rt.Day] };
  return Object.entries(n).filter(([, i]) => i === !0).forEach(([i]) => {
    r = {
      ...r,
      ...t?.[i]
    };
  }), r;
}
function Uet(n, e, t) {
  const r = n.today(), i = e ? n.startOfISOWeek(r) : n.startOfWeek(r), s = [];
  for (let o = 0; o < 7; o++) {
    const a = n.addDays(i, o);
    s.push(a);
  }
  return s;
}
function Vet(n, e, t, r, i = !1) {
  if (!n || !e)
    return;
  const { startOfYear: s, endOfYear: o, eachYearOfInterval: a, getYear: l } = r, c = s(n), u = o(e), d = a({ start: c, end: u });
  return i && d.reverse(), d.map((f) => {
    const h = t.formatYearDropdown(f, r);
    return {
      value: l(f),
      label: h,
      disabled: !1
    };
  });
}
function hie(n, e, t, r) {
  let i = (r ?? new ws(t)).format(n, "PPPP");
  return e.today && (i = `Today, ${i}`), e.selected && (i = `${i}, selected`), i;
}
const jet = hie;
function pie(n, e, t) {
  return (t ?? new ws(e)).formatMonthYear(n);
}
const Wet = pie;
function Get(n, e, t, r) {
  let i = (r ?? new ws(t)).format(n, "PPPP");
  return e?.today && (i = `Today, ${i}`), i;
}
function Ket(n) {
  return "Choose the Month";
}
function qet() {
  return "";
}
function Yet(n) {
  return "Go to the Next Month";
}
function Xet(n) {
  return "Go to the Previous Month";
}
function Zet(n, e, t) {
  return (t ?? new ws(e)).format(n, "cccc");
}
function Qet(n, e) {
  return `Week ${n}`;
}
function Jet(n) {
  return "Week Number";
}
function ett(n) {
  return "Choose the Year";
}
const ttt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: Wet,
  labelDay: jet,
  labelDayButton: hie,
  labelGrid: pie,
  labelGridcell: Get,
  labelMonthDropdown: Ket,
  labelNav: qet,
  labelNext: Yet,
  labelPrevious: Xet,
  labelWeekNumber: Qet,
  labelWeekNumberHeader: Jet,
  labelWeekday: Zet,
  labelYearDropdown: ett
}, Symbol.toStringTag, { value: "Module" })), N1 = (n) => n instanceof HTMLElement ? n : null, j6 = (n) => [
  ...n.querySelectorAll("[data-animated-month]") ?? []
], ntt = (n) => N1(n.querySelector("[data-animated-month]")), W6 = (n) => N1(n.querySelector("[data-animated-caption]")), G6 = (n) => N1(n.querySelector("[data-animated-weeks]")), rtt = (n) => N1(n.querySelector("[data-animated-nav]")), itt = (n) => N1(n.querySelector("[data-animated-weekdays]"));
function stt(n, e, { classNames: t, months: r, focused: i, dateLib: s }) {
  const o = Gt(null), a = Gt(r), l = Gt(!1);
  vh(() => {
    const c = a.current;
    if (a.current = r, !e || !n.current || // safety check because the ref can be set to anything by consumers
    !(n.current instanceof HTMLElement) || // validation required for the animation to work as expected
    r.length === 0 || c.length === 0 || r.length !== c.length)
      return;
    const u = s.isSameMonth(r[0].date, c[0].date), d = s.isAfter(r[0].date, c[0].date), f = d ? t[as.caption_after_enter] : t[as.caption_before_enter], h = d ? t[as.weeks_after_enter] : t[as.weeks_before_enter], m = o.current, g = n.current.cloneNode(!0);
    if (g instanceof HTMLElement ? (j6(g).forEach((x) => {
      if (!(x instanceof HTMLElement))
        return;
      const E = ntt(x);
      E && x.contains(E) && x.removeChild(E);
      const w = W6(x);
      w && w.classList.remove(f);
      const C = G6(x);
      C && C.classList.remove(h);
    }), o.current = g) : o.current = null, l.current || u || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    i)
      return;
    const v = m instanceof HTMLElement ? j6(m) : [], y = j6(n.current);
    if (y?.every((b) => b instanceof HTMLElement) && v && v.every((b) => b instanceof HTMLElement)) {
      l.current = !0, n.current.style.isolation = "isolate";
      const b = rtt(n.current);
      b && (b.style.zIndex = "1"), y.forEach((x, E) => {
        const w = v[E];
        if (!w)
          return;
        x.style.position = "relative", x.style.overflow = "hidden";
        const C = W6(x);
        C && C.classList.add(f);
        const S = G6(x);
        S && S.classList.add(h);
        const M = () => {
          l.current = !1, n.current && (n.current.style.isolation = ""), b && (b.style.zIndex = ""), C && C.classList.remove(f), S && S.classList.remove(h), x.style.position = "", x.style.overflow = "", x.contains(w) && x.removeChild(w);
        };
        w.style.pointerEvents = "none", w.style.position = "absolute", w.style.overflow = "hidden", w.setAttribute("aria-hidden", "true");
        const k = itt(w);
        k && (k.style.opacity = "0");
        const _ = W6(w);
        _ && (_.classList.add(d ? t[as.caption_before_exit] : t[as.caption_after_exit]), _.addEventListener("animationend", M));
        const O = G6(w);
        O && O.classList.add(d ? t[as.weeks_before_exit] : t[as.weeks_after_exit]), x.insertBefore(w, x.firstChild);
      });
    }
  });
}
function ott(n, e, t, r) {
  const i = n[0], s = n[n.length - 1], { ISOWeek: o, fixedWeeks: a, broadcastCalendar: l } = t ?? {}, { addDays: c, differenceInCalendarDays: u, differenceInCalendarMonths: d, endOfBroadcastWeek: f, endOfISOWeek: h, endOfMonth: m, endOfWeek: g, isAfter: v, startOfBroadcastWeek: y, startOfISOWeek: b, startOfWeek: x } = r, E = l ? y(i, r) : o ? b(i) : x(i), w = l ? f(s) : o ? h(m(s)) : g(m(s)), C = u(w, E), S = d(s, i) + 1, M = [];
  for (let O = 0; O <= C; O++) {
    const I = c(E, O);
    if (e && v(I, e))
      break;
    M.push(I);
  }
  const _ = (l ? 35 : 42) * S;
  if (a && M.length < _) {
    const O = _ - M.length;
    for (let I = 0; I < O; I++) {
      const R = c(M[M.length - 1], 1);
      M.push(R);
    }
  }
  return M;
}
function att(n) {
  const e = [];
  return n.reduce((t, r) => {
    const i = r.weeks.reduce((s, o) => s.concat(o.days.slice()), e.slice());
    return t.concat(i.slice());
  }, e.slice());
}
function ltt(n, e, t, r) {
  const { numberOfMonths: i = 1 } = t, s = [];
  for (let o = 0; o < i; o++) {
    const a = r.addMonths(n, o);
    if (e && a > e)
      break;
    s.push(a);
  }
  return s;
}
function oU(n, e, t, r) {
  const { month: i, defaultMonth: s, today: o = r.today(), numberOfMonths: a = 1 } = n;
  let l = i || s || o;
  const { differenceInCalendarMonths: c, addMonths: u, startOfMonth: d } = r;
  if (t && c(t, l) < a - 1) {
    const f = -1 * (a - 1);
    l = u(t, f);
  }
  return e && c(l, e) < 0 && (l = e), d(l);
}
function ctt(n, e, t, r) {
  const { addDays: i, endOfBroadcastWeek: s, endOfISOWeek: o, endOfMonth: a, endOfWeek: l, getISOWeek: c, getWeek: u, startOfBroadcastWeek: d, startOfISOWeek: f, startOfWeek: h } = r, m = n.reduce((g, v) => {
    const y = t.broadcastCalendar ? d(v, r) : t.ISOWeek ? f(v) : h(v), b = t.broadcastCalendar ? s(v) : t.ISOWeek ? o(a(v)) : l(a(v)), x = e.filter((S) => S >= y && S <= b), E = t.broadcastCalendar ? 35 : 42;
    if (t.fixedWeeks && x.length < E) {
      const S = e.filter((M) => {
        const k = E - x.length;
        return M > b && M <= i(b, k);
      });
      x.push(...S);
    }
    const w = x.reduce((S, M) => {
      const k = t.ISOWeek ? c(M) : u(M), _ = S.find((I) => I.weekNumber === k), O = new iie(M, v, r);
      return _ ? _.days.push(O) : S.push(new ZJe(k, [O])), S;
    }, []), C = new XJe(v, w);
    return g.push(C), g;
  }, []);
  return t.reverseMonths ? m.reverse() : m;
}
function utt(n, e) {
  let { startMonth: t, endMonth: r } = n;
  const { startOfYear: i, startOfDay: s, startOfMonth: o, endOfMonth: a, addYears: l, endOfYear: c, newDate: u, today: d } = e, { fromYear: f, toYear: h, fromMonth: m, toMonth: g } = n;
  !t && m && (t = m), !t && f && (t = e.newDate(f, 0, 1)), !r && g && (r = g), !r && h && (r = u(h, 11, 31));
  const v = n.captionLayout === "dropdown" || n.captionLayout === "dropdown-years";
  return t ? t = o(t) : f ? t = u(f, 0, 1) : !t && v && (t = i(l(n.today ?? d(), -100))), r ? r = a(r) : h ? r = u(h, 11, 31) : !r && v && (r = c(n.today ?? d())), [
    t && s(t),
    r && s(r)
  ];
}
function dtt(n, e, t, r) {
  if (t.disableNavigation)
    return;
  const { pagedNavigation: i, numberOfMonths: s = 1 } = t, { startOfMonth: o, addMonths: a, differenceInCalendarMonths: l } = r, c = i ? s : 1, u = o(n);
  if (!e)
    return a(u, c);
  if (!(l(e, n) < s))
    return a(u, c);
}
function ftt(n, e, t, r) {
  if (t.disableNavigation)
    return;
  const { pagedNavigation: i, numberOfMonths: s } = t, { startOfMonth: o, addMonths: a, differenceInCalendarMonths: l } = r, c = i ? s ?? 1 : 1, u = o(n);
  if (!e)
    return a(u, -c);
  if (!(l(u, e) <= 0))
    return a(u, -c);
}
function htt(n) {
  const e = [];
  return n.reduce((t, r) => t.concat(r.weeks.slice()), e.slice());
}
function Z3(n, e) {
  const [t, r] = wt(n);
  return [e === void 0 ? t : e, r];
}
function ptt(n, e) {
  const [t, r] = utt(n, e), { startOfMonth: i, endOfMonth: s } = e, o = oU(n, t, r, e), [a, l] = Z3(
    o,
    // initialMonth is always computed from props.month if provided
    n.month ? o : void 0
  );
  Tt(() => {
    const C = oU(n, t, r, e);
    l(C);
  }, [n.timeZone]);
  const c = ltt(a, r, n, e), u = ott(c, n.endMonth ? s(n.endMonth) : void 0, n, e), d = ctt(c, u, n, e), f = htt(d), h = att(d), m = ftt(a, t, n, e), g = dtt(a, r, n, e), { disableNavigation: v, onMonthChange: y } = n, b = (C) => f.some((S) => S.days.some((M) => M.isEqualTo(C))), x = (C) => {
    if (v)
      return;
    let S = i(C);
    t && S < i(t) && (S = i(t)), r && S > i(r) && (S = i(r)), l(S), y?.(S);
  };
  return {
    months: d,
    weeks: f,
    days: h,
    navStart: t,
    navEnd: r,
    previousMonth: m,
    nextMonth: g,
    goToMonth: x,
    goToDay: (C) => {
      b(C) || x(C.date);
    }
  };
}
var Go;
(function(n) {
  n[n.Today = 0] = "Today", n[n.Selected = 1] = "Selected", n[n.LastFocused = 2] = "LastFocused", n[n.FocusedModifier = 3] = "FocusedModifier";
})(Go || (Go = {}));
function aU(n) {
  return !n[Un.disabled] && !n[Un.hidden] && !n[Un.outside];
}
function mtt(n, e, t, r) {
  let i, s = -1;
  for (const o of n) {
    const a = e(o);
    aU(a) && (a[Un.focused] && s < Go.FocusedModifier ? (i = o, s = Go.FocusedModifier) : r?.isEqualTo(o) && s < Go.LastFocused ? (i = o, s = Go.LastFocused) : t(o.date) && s < Go.Selected ? (i = o, s = Go.Selected) : a[Un.today] && s < Go.Today && (i = o, s = Go.Today));
  }
  return i || (i = n.find((o) => aU(e(o)))), i;
}
function gtt(n, e, t, r, i, s, o) {
  const { ISOWeek: a, broadcastCalendar: l } = s, { addDays: c, addMonths: u, addWeeks: d, addYears: f, endOfBroadcastWeek: h, endOfISOWeek: m, endOfWeek: g, max: v, min: y, startOfBroadcastWeek: b, startOfISOWeek: x, startOfWeek: E } = o;
  let C = {
    day: c,
    week: d,
    month: u,
    year: f,
    startOfWeek: (S) => l ? b(S, o) : a ? x(S) : E(S),
    endOfWeek: (S) => l ? h(S) : a ? m(S) : g(S)
  }[n](t, e === "after" ? 1 : -1);
  return e === "before" && r ? C = v([r, C]) : e === "after" && i && (C = y([i, C])), C;
}
function mie(n, e, t, r, i, s, o, a = 0) {
  if (a > 365)
    return;
  const l = gtt(n, e, t.date, r, i, s, o), c = !!(s.disabled && Ja(l, s.disabled, o)), u = !!(s.hidden && Ja(l, s.hidden, o)), d = l, f = new iie(l, d, o);
  return !c && !u ? f : mie(n, e, f, r, i, s, o, a + 1);
}
function vtt(n, e, t, r, i) {
  const { autoFocus: s } = n, [o, a] = wt(), l = mtt(e.days, t, r || (() => !1), o), [c, u] = wt(s ? l : void 0);
  return {
    isFocusTarget: (g) => !!l?.isEqualTo(g),
    setFocused: u,
    focused: c,
    blur: () => {
      a(c), u(void 0);
    },
    moveFocus: (g, v) => {
      if (!c)
        return;
      const y = mie(g, v, c, e.navStart, e.navEnd, n, i);
      y && (n.disableNavigation && !e.days.some((x) => x.isEqualTo(y)) || (e.goToDay(y), u(y)));
    }
  };
}
function ytt(n, e) {
  const { selected: t, required: r, onSelect: i } = n, [s, o] = Z3(t, i ? t : void 0), a = i ? t : s, { isSameDay: l } = e, c = (h) => a?.some((m) => l(m, h)) ?? !1, { min: u, max: d } = n;
  return {
    selected: a,
    select: (h, m, g) => {
      let v = [...a ?? []];
      if (c(h)) {
        if (a?.length === u || r && a?.length === 1)
          return;
        v = a?.filter((y) => !l(y, h));
      } else
        a?.length === d ? v = [h] : v = [...v, h];
      return i || o(v), i?.(v, h, m, g), v;
    },
    isSelected: c
  };
}
function btt(n, e, t = 0, r = 0, i = !1, s = Aa) {
  const { from: o, to: a } = e || {}, { isSameDay: l, isAfter: c, isBefore: u } = s;
  let d;
  if (!o && !a)
    d = { from: n, to: t > 0 ? void 0 : n };
  else if (o && !a)
    l(o, n) ? t === 0 ? d = { from: o, to: n } : i ? d = { from: o, to: void 0 } : d = void 0 : u(n, o) ? d = { from: n, to: o } : d = { from: o, to: n };
  else if (o && a)
    if (l(o, n) && l(a, n))
      i ? d = { from: o, to: a } : d = void 0;
    else if (l(o, n))
      d = { from: o, to: t > 0 ? void 0 : n };
    else if (l(a, n))
      d = { from: n, to: t > 0 ? void 0 : n };
    else if (u(n, o))
      d = { from: n, to: a };
    else if (c(n, o))
      d = { from: o, to: n };
    else if (c(n, a))
      d = { from: o, to: n };
    else
      throw new Error("Invalid range");
  if (d?.from && d?.to) {
    const f = s.differenceInCalendarDays(d.to, d.from);
    r > 0 && f > r ? d = { from: n, to: void 0 } : t > 1 && f < t && (d = { from: n, to: void 0 });
  }
  return d;
}
function wtt(n, e, t = Aa) {
  const r = Array.isArray(e) ? e : [e];
  let i = n.from;
  const s = t.differenceInCalendarDays(n.to, n.from), o = Math.min(s, 6);
  for (let a = 0; a <= o; a++) {
    if (r.includes(i.getDay()))
      return !0;
    i = t.addDays(i, 1);
  }
  return !1;
}
function lU(n, e, t = Aa) {
  return Qa(n, e.from, !1, t) || Qa(n, e.to, !1, t) || Qa(e, n.from, !1, t) || Qa(e, n.to, !1, t);
}
function xtt(n, e, t = Aa) {
  const r = Array.isArray(e) ? e : [e];
  if (r.filter((a) => typeof a != "function").some((a) => typeof a == "boolean" ? a : t.isDate(a) ? Qa(n, a, !1, t) : uie(a, t) ? a.some((l) => Qa(n, l, !1, t)) : F_(a) ? a.from && a.to ? lU(n, { from: a.from, to: a.to }, t) : !1 : cie(a) ? wtt(n, a.dayOfWeek, t) : oie(a) ? t.isAfter(a.before, a.after) ? lU(n, {
    from: t.addDays(a.after, 1),
    to: t.addDays(a.before, -1)
  }, t) : Ja(n.from, a, t) || Ja(n.to, a, t) : aie(a) || lie(a) ? Ja(n.from, a, t) || Ja(n.to, a, t) : !1))
    return !0;
  const o = r.filter((a) => typeof a == "function");
  if (o.length) {
    let a = n.from;
    const l = t.differenceInCalendarDays(n.to, n.from);
    for (let c = 0; c <= l; c++) {
      if (o.some((u) => u(a)))
        return !0;
      a = t.addDays(a, 1);
    }
  }
  return !1;
}
function Ett(n, e) {
  const { disabled: t, excludeDisabled: r, selected: i, required: s, onSelect: o } = n, [a, l] = Z3(i, o ? i : void 0), c = o ? i : a;
  return {
    selected: c,
    select: (f, h, m) => {
      const { min: g, max: v } = n, y = f ? btt(f, c, g, v, s, e) : void 0;
      return r && t && y?.from && y.to && xtt({ from: y.from, to: y.to }, t, e) && (y.from = f, y.to = void 0), o || l(y), o?.(y, f, h, m), y;
    },
    isSelected: (f) => c && Qa(c, f, !1, e)
  };
}
function Stt(n, e) {
  const { selected: t, required: r, onSelect: i } = n, [s, o] = Z3(t, i ? t : void 0), a = i ? t : s, { isSameDay: l } = e;
  return {
    selected: a,
    select: (d, f, h) => {
      let m = d;
      return !r && a && a && l(d, a) && (m = void 0), i || o(m), i?.(m, d, f, h), m;
    },
    isSelected: (d) => a ? l(a, d) : !1
  };
}
function Ctt(n, e) {
  const t = Stt(n, e), r = ytt(n, e), i = Ett(n, e);
  switch (n.mode) {
    case "single":
      return t;
    case "multiple":
      return r;
    case "range":
      return i;
    default:
      return;
  }
}
function Ttt(n) {
  let e = n;
  e.timeZone && (e = {
    ...n
  }, e.today && (e.today = new ei(e.today, e.timeZone)), e.month && (e.month = new ei(e.month, e.timeZone)), e.defaultMonth && (e.defaultMonth = new ei(e.defaultMonth, e.timeZone)), e.startMonth && (e.startMonth = new ei(e.startMonth, e.timeZone)), e.endMonth && (e.endMonth = new ei(e.endMonth, e.timeZone)), e.mode === "single" && e.selected ? e.selected = new ei(e.selected, e.timeZone) : e.mode === "multiple" && e.selected ? e.selected = e.selected?.map((ot) => new ei(ot, e.timeZone)) : e.mode === "range" && e.selected && (e.selected = {
    from: e.selected.from ? new ei(e.selected.from, e.timeZone) : void 0,
    to: e.selected.to ? new ei(e.selected.to, e.timeZone) : void 0
  }));
  const { components: t, formatters: r, labels: i, dateLib: s, locale: o, classNames: a } = ua(() => {
    const ot = { ...$_, ...e.locale };
    return {
      dateLib: new ws({
        locale: ot,
        weekStartsOn: e.broadcastCalendar ? 1 : e.weekStartsOn,
        firstWeekContainsDate: e.firstWeekContainsDate,
        useAdditionalWeekYearTokens: e.useAdditionalWeekYearTokens,
        useAdditionalDayOfYearTokens: e.useAdditionalDayOfYearTokens,
        timeZone: e.timeZone,
        numerals: e.numerals
      }, e.dateLib),
      components: _et(e.components),
      formatters: Bet(e.formatters),
      labels: { ...ttt, ...e.labels },
      locale: ot,
      classNames: { ...B_(), ...e.classNames }
    };
  }, [
    e.locale,
    e.broadcastCalendar,
    e.weekStartsOn,
    e.firstWeekContainsDate,
    e.useAdditionalWeekYearTokens,
    e.useAdditionalDayOfYearTokens,
    e.timeZone,
    e.numerals,
    e.dateLib,
    e.components,
    e.formatters,
    e.labels,
    e.classNames
  ]), { captionLayout: l, mode: c, navLayout: u, numberOfMonths: d = 1, onDayBlur: f, onDayClick: h, onDayFocus: m, onDayKeyDown: g, onDayMouseEnter: v, onDayMouseLeave: y, onNextClick: b, onPrevClick: x, showWeekNumber: E, styles: w } = e, { formatCaption: C, formatDay: S, formatMonthDropdown: M, formatWeekNumber: k, formatWeekNumberHeader: _, formatWeekdayName: O, formatYearDropdown: I } = r, R = ptt(e, s), { days: P, months: D, navStart: L, navEnd: B, previousMonth: $, nextMonth: z, goToMonth: H } = R, U = Met(P, e, L, B, s), { isSelected: F, select: V, selected: X } = Ctt(e, s) ?? {}, { blur: Z, focused: ie, isFocusTarget: J, moveFocus: se, setFocused: te } = vtt(e, R, U, F ?? (() => !1), s), { labelDayButton: le, labelGridcell: de, labelGrid: j, labelMonthDropdown: xe, labelNav: ne, labelPrevious: qe, labelNext: ve, labelWeekday: Ie, labelWeekNumber: mt, labelWeekNumberHeader: xt, labelYearDropdown: G } = i, re = ua(() => Uet(s, e.ISOWeek), [s, e.ISOWeek]), oe = c !== void 0 || h !== void 0, Se = Ft(() => {
    $ && (H($), x?.($));
  }, [$, H, x]), ye = Ft(() => {
    z && (H(z), b?.(z));
  }, [H, z, b]), be = Ft((ot, Ae) => (De) => {
    De.preventDefault(), De.stopPropagation(), te(ot), V?.(ot.date, Ae, De), h?.(ot.date, Ae, De);
  }, [V, h, te]), Oe = Ft((ot, Ae) => (De) => {
    te(ot), m?.(ot.date, Ae, De);
  }, [m, te]), ut = Ft((ot, Ae) => (De) => {
    Z(), f?.(ot.date, Ae, De);
  }, [Z, f]), Et = Ft((ot, Ae) => (De) => {
    const et = {
      ArrowLeft: [
        De.shiftKey ? "month" : "day",
        e.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        De.shiftKey ? "month" : "day",
        e.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [De.shiftKey ? "year" : "week", "after"],
      ArrowUp: [De.shiftKey ? "year" : "week", "before"],
      PageUp: [De.shiftKey ? "year" : "month", "before"],
      PageDown: [De.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (et[De.key]) {
      De.preventDefault(), De.stopPropagation();
      const [it, Ge] = et[De.key];
      se(it, Ge);
    }
    g?.(ot.date, Ae, De);
  }, [se, g, e.dir]), Yt = Ft((ot, Ae) => (De) => {
    v?.(ot.date, Ae, De);
  }, [v]), Wt = Ft((ot, Ae) => (De) => {
    y?.(ot.date, Ae, De);
  }, [y]), me = Ft((ot) => (Ae) => {
    const De = Number(Ae.target.value), et = s.setMonth(s.startOfMonth(ot), De);
    H(et);
  }, [s, H]), Pe = Ft((ot) => (Ae) => {
    const De = Number(Ae.target.value), et = s.setYear(s.startOfMonth(ot), De);
    H(et);
  }, [s, H]), { className: yt, style: kt } = ua(() => ({
    className: [a[rt.Root], e.className].filter(Boolean).join(" "),
    style: { ...w?.[rt.Root], ...e.style }
  }), [a, e.className, e.style, w]), rn = Oet(e), vn = Gt(null);
  stt(vn, !!e.animate, {
    classNames: a,
    months: D,
    focused: ie,
    dateLib: s
  });
  const Xi = {
    dayPickerProps: e,
    selected: X,
    select: V,
    isSelected: F,
    months: D,
    nextMonth: z,
    previousMonth: $,
    goToMonth: H,
    getModifiers: U,
    components: t,
    classNames: a,
    styles: w,
    labels: i,
    formatters: r
  };
  return p.createElement(
    sie.Provider,
    { value: Xi },
    p.createElement(
      t.Root,
      { rootRef: e.animate ? vn : void 0, className: yt, style: kt, dir: e.dir, id: e.id, lang: e.lang, nonce: e.nonce, title: e.title, role: e.role, "aria-label": e["aria-label"], "aria-labelledby": e["aria-labelledby"], ...rn },
      p.createElement(
        t.Months,
        { className: a[rt.Months], style: w?.[rt.Months] },
        !e.hideNavigation && !u && p.createElement(t.Nav, { "data-animated-nav": e.animate ? "true" : void 0, className: a[rt.Nav], style: w?.[rt.Nav], "aria-label": ne(), onPreviousClick: Se, onNextClick: ye, previousMonth: $, nextMonth: z }),
        D.map((ot, Ae) => p.createElement(
          t.Month,
          {
            "data-animated-month": e.animate ? "true" : void 0,
            className: a[rt.Month],
            style: w?.[rt.Month],
            // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
            key: Ae,
            displayIndex: Ae,
            calendarMonth: ot
          },
          u === "around" && !e.hideNavigation && Ae === 0 && p.createElement(
            t.PreviousMonthButton,
            { type: "button", className: a[rt.PreviousMonthButton], tabIndex: $ ? void 0 : -1, "aria-disabled": $ ? void 0 : !0, "aria-label": qe($), onClick: Se, "data-animated-button": e.animate ? "true" : void 0 },
            p.createElement(t.Chevron, { disabled: $ ? void 0 : !0, className: a[rt.Chevron], orientation: e.dir === "rtl" ? "right" : "left" })
          ),
          p.createElement(t.MonthCaption, { "data-animated-caption": e.animate ? "true" : void 0, className: a[rt.MonthCaption], style: w?.[rt.MonthCaption], calendarMonth: ot, displayIndex: Ae }, l?.startsWith("dropdown") ? p.createElement(
            t.DropdownNav,
            { className: a[rt.Dropdowns], style: w?.[rt.Dropdowns] },
            (() => {
              const De = l === "dropdown" || l === "dropdown-months" ? p.createElement(t.MonthsDropdown, { key: "month", className: a[rt.MonthsDropdown], "aria-label": xe(), classNames: a, components: t, disabled: !!e.disableNavigation, onChange: me(ot.date), options: zet(ot.date, L, B, r, s), style: w?.[rt.Dropdown], value: s.getMonth(ot.date) }) : p.createElement("span", { key: "month" }, M(ot.date, s)), et = l === "dropdown" || l === "dropdown-years" ? p.createElement(t.YearsDropdown, { key: "year", className: a[rt.YearsDropdown], "aria-label": G(s.options), classNames: a, components: t, disabled: !!e.disableNavigation, onChange: Pe(ot.date), options: Vet(L, B, r, s, !!e.reverseYears), style: w?.[rt.Dropdown], value: s.getYear(ot.date) }) : p.createElement("span", { key: "year" }, I(ot.date, s));
              return s.getMonthYearOrder() === "year-first" ? [et, De] : [De, et];
            })(),
            p.createElement("span", { role: "status", "aria-live": "polite", style: {
              border: 0,
              clip: "rect(0 0 0 0)",
              height: "1px",
              margin: "-1px",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              width: "1px",
              whiteSpace: "nowrap",
              wordWrap: "normal"
            } }, C(ot.date, s.options, s))
          ) : (
            // biome-ignore lint/a11y/useSemanticElements: breaking change
            p.createElement(t.CaptionLabel, { className: a[rt.CaptionLabel], role: "status", "aria-live": "polite" }, C(ot.date, s.options, s))
          )),
          u === "around" && !e.hideNavigation && Ae === d - 1 && p.createElement(
            t.NextMonthButton,
            { type: "button", className: a[rt.NextMonthButton], tabIndex: z ? void 0 : -1, "aria-disabled": z ? void 0 : !0, "aria-label": ve(z), onClick: ye, "data-animated-button": e.animate ? "true" : void 0 },
            p.createElement(t.Chevron, { disabled: z ? void 0 : !0, className: a[rt.Chevron], orientation: e.dir === "rtl" ? "left" : "right" })
          ),
          Ae === d - 1 && u === "after" && !e.hideNavigation && p.createElement(t.Nav, { "data-animated-nav": e.animate ? "true" : void 0, className: a[rt.Nav], style: w?.[rt.Nav], "aria-label": ne(), onPreviousClick: Se, onNextClick: ye, previousMonth: $, nextMonth: z }),
          p.createElement(
            t.MonthGrid,
            { role: "grid", "aria-multiselectable": c === "multiple" || c === "range", "aria-label": j(ot.date, s.options, s) || void 0, className: a[rt.MonthGrid], style: w?.[rt.MonthGrid] },
            !e.hideWeekdays && p.createElement(
              t.Weekdays,
              { "data-animated-weekdays": e.animate ? "true" : void 0, className: a[rt.Weekdays], style: w?.[rt.Weekdays] },
              E && p.createElement(t.WeekNumberHeader, { "aria-label": xt(s.options), className: a[rt.WeekNumberHeader], style: w?.[rt.WeekNumberHeader], scope: "col" }, _()),
              re.map((De) => p.createElement(t.Weekday, { "aria-label": Ie(De, s.options, s), className: a[rt.Weekday], key: String(De), style: w?.[rt.Weekday], scope: "col" }, O(De, s.options, s)))
            ),
            p.createElement(t.Weeks, { "data-animated-weeks": e.animate ? "true" : void 0, className: a[rt.Weeks], style: w?.[rt.Weeks] }, ot.weeks.map((De) => p.createElement(
              t.Week,
              { className: a[rt.Week], key: De.weekNumber, style: w?.[rt.Week], week: De },
              E && // biome-ignore lint/a11y/useSemanticElements: react component
              p.createElement(t.WeekNumber, { week: De, style: w?.[rt.WeekNumber], "aria-label": mt(De.weekNumber, {
                locale: o
              }), className: a[rt.WeekNumber], scope: "row", role: "rowheader" }, k(De.weekNumber, s)),
              De.days.map((et) => {
                const { date: it } = et, Ge = U(et);
                if (Ge[Un.focused] = !Ge.hidden && !!ie?.isEqualTo(et), Ge[fo.selected] = F?.(it) || Ge.selected, F_(X)) {
                  const { from: Le, to: Pt } = X;
                  Ge[fo.range_start] = !!(Le && Pt && s.isSameDay(it, Le)), Ge[fo.range_end] = !!(Le && Pt && s.isSameDay(it, Pt)), Ge[fo.range_middle] = Qa(X, it, !0, s);
                }
                const W = Het(Ge, w, e.modifiersStyles), ue = ket(Ge, a, e.modifiersClassNames), we = !oe && !Ge.hidden ? de(it, Ge, s.options, s) : void 0;
                return (
                  // biome-ignore lint/a11y/useSemanticElements: react component
                  p.createElement(t.Day, { key: `${s.format(it, "yyyy-MM-dd")}_${s.format(et.displayMonth, "yyyy-MM")}`, day: et, modifiers: Ge, className: ue.join(" "), style: W, role: "gridcell", "aria-selected": Ge.selected || void 0, "aria-label": we, "data-day": s.format(it, "yyyy-MM-dd"), "data-month": et.outside ? s.format(it, "yyyy-MM") : void 0, "data-selected": Ge.selected || void 0, "data-disabled": Ge.disabled || void 0, "data-hidden": Ge.hidden || void 0, "data-outside": et.outside || void 0, "data-focused": Ge.focused || void 0, "data-today": Ge.today || void 0 }, !Ge.hidden && oe ? p.createElement(t.DayButton, { className: a[rt.DayButton], style: w?.[rt.DayButton], type: "button", day: et, modifiers: Ge, disabled: Ge.disabled || void 0, tabIndex: J(et) ? 0 : -1, "aria-label": le(it, Ge, s.options, s), onClick: be(et, Ge), onBlur: ut(et, Ge), onFocus: Oe(et, Ge), onKeyDown: Et(et, Ge), onMouseEnter: Yt(et, Ge), onMouseLeave: Wt(et, Ge) }, S(it, s.options, s)) : !Ge.hidden && S(et.date, s.options, s))
                );
              })
            )))
          )
        ))
      ),
      e.footer && // biome-ignore lint/a11y/useSemanticElements: react component
      p.createElement(t.Footer, { className: a[rt.Footer], style: w?.[rt.Footer], role: "status", "aria-live": "polite" }, e.footer)
    )
  );
}
function Att({
  className: n,
  classNames: e,
  showOutsideDays: t = !0,
  captionLayout: r = "label",
  buttonVariant: i = "ghost",
  formatters: s,
  components: o,
  ...a
}) {
  const l = B_();
  return /* @__PURE__ */ T(
    Ttt,
    {
      showOutsideDays: t,
      className: Q(
        "tw:bg-background tw:group/calendar tw:p-3 tw:[--cell-size:2rem] tw:in-data-[slot=card-content]:bg-transparent tw:in-data-[slot=popover-content]:bg-transparent",
        String.raw`rtl:**:[.rdp-button\_next>svg]:rotate-180`,
        String.raw`rtl:**:[.rdp-button\_previous>svg]:rotate-180`,
        n
      ),
      captionLayout: r,
      formatters: {
        formatMonthDropdown: (c) => c.toLocaleString("default", { month: "short" }),
        ...s
      },
      classNames: {
        root: Q("tw:w-fit", l.root),
        months: Q(
          "tw:relative tw:flex tw:flex-col tw:gap-4 tw:md:flex-row",
          l.months
        ),
        month: Q("tw:flex tw:w-full tw:flex-col tw:gap-4", l.month),
        nav: Q(
          "tw:absolute tw:inset-x-0 tw:top-0 tw:flex tw:w-full tw:items-center tw:justify-between tw:gap-1",
          l.nav
        ),
        button_previous: Q(
          IT({ variant: i }),
          "tw:h-(--cell-size) tw:w-(--cell-size) tw:select-none tw:p-0 tw:aria-disabled:opacity-50",
          l.button_previous
        ),
        button_next: Q(
          IT({ variant: i }),
          "tw:h-(--cell-size) tw:w-(--cell-size) tw:select-none tw:p-0 tw:aria-disabled:opacity-50",
          l.button_next
        ),
        month_caption: Q(
          "tw:flex tw:h-(--cell-size) tw:w-full tw:items-center tw:justify-center tw:px-(--cell-size)",
          l.month_caption
        ),
        dropdowns: Q(
          "tw:flex tw:h-(--cell-size) tw:w-full tw:items-center tw:justify-center tw:gap-1.5 tw:text-sm tw:font-medium",
          l.dropdowns
        ),
        dropdown_root: Q(
          "tw:has-focus:border-ring tw:border-input tw:shadow-xs tw:has-focus:ring-ring/50 tw:has-focus:ring-[3px] tw:relative tw:rounded-md tw:border",
          l.dropdown_root
        ),
        dropdown: Q(
          "tw:bg-popover tw:absolute tw:inset-0 tw:opacity-0",
          l.dropdown
        ),
        caption_label: Q(
          "tw:select-none tw:font-medium",
          r === "label" ? "tw:text-sm" : "tw:[&>svg]:text-muted-foreground tw:flex tw:h-8 tw:items-center tw:gap-1 tw:rounded-md tw:pl-2 tw:pr-1 tw:text-sm tw:[&>svg]:size-3.5",
          l.caption_label
        ),
        table: "tw:w-full tw:border-collapse",
        weekdays: Q("tw:flex", l.weekdays),
        weekday: Q(
          "tw:text-muted-foreground tw:flex-1 tw:select-none tw:rounded-md tw:text-[0.8rem] tw:font-normal",
          l.weekday
        ),
        week: Q("tw:mt-2 tw:flex tw:w-full", l.week),
        week_number_header: Q(
          "tw:w-(--cell-size) tw:select-none",
          l.week_number_header
        ),
        week_number: Q(
          "tw:text-muted-foreground tw:select-none tw:text-[0.8rem]",
          l.week_number
        ),
        day: Q(
          "tw:group/day tw:relative tw:aspect-square tw:h-full tw:w-full tw:select-none tw:p-0 tw:text-center tw:[&:first-child[data-selected=true]_button]:rounded-l-md tw:[&:last-child[data-selected=true]_button]:rounded-r-md",
          l.day
        ),
        range_start: Q(
          "tw:bg-accent tw:rounded-l-md",
          l.range_start
        ),
        range_middle: Q("tw:rounded-none", l.range_middle),
        range_end: Q("tw:bg-accent tw:rounded-r-md", l.range_end),
        today: Q(
          "tw:bg-accent tw:text-accent-foreground tw:rounded-md tw:data-[selected=true]:rounded-none",
          l.today
        ),
        outside: Q(
          "tw:text-muted-foreground tw:aria-selected:text-muted-foreground",
          l.outside
        ),
        disabled: Q(
          "tw:text-muted-foreground tw:opacity-50",
          l.disabled
        ),
        hidden: Q("tw:invisible", l.hidden),
        ...e
      },
      components: {
        Root: ({ className: c, rootRef: u, ...d }) => /* @__PURE__ */ T(
          "div",
          {
            "data-slot": "calendar",
            ref: u,
            className: Q(c),
            ...d
          }
        ),
        Chevron: ({ className: c, orientation: u, ...d }) => u === "left" ? /* @__PURE__ */ T(cX, { className: Q("tw:size-4", c), ...d }) : u === "right" ? /* @__PURE__ */ T(
          m1,
          {
            className: Q("tw:size-4", c),
            ...d
          }
        ) : /* @__PURE__ */ T(od, { className: Q("tw:size-4", c), ...d }),
        DayButton: Mtt,
        WeekNumber: ({ children: c, ...u }) => /* @__PURE__ */ T("td", { ...u, children: /* @__PURE__ */ T("div", { className: "tw:flex tw:size-(--cell-size) tw:items-center tw:justify-center tw:text-center", children: c }) }),
        ...o
      },
      ...a
    }
  );
}
function Mtt({
  className: n,
  day: e,
  modifiers: t,
  ...r
}) {
  const i = B_(), s = A.useRef(null);
  return A.useEffect(() => {
    t.focused && s.current?.focus();
  }, [t.focused]), /* @__PURE__ */ T(
    Nt,
    {
      ref: s,
      variant: "ghost",
      size: "icon",
      "data-day": e.date.toLocaleDateString(),
      "data-selected-single": t.selected && !t.range_start && !t.range_end && !t.range_middle,
      "data-range-start": t.range_start,
      "data-range-end": t.range_end,
      "data-range-middle": t.range_middle,
      className: Q(
        "tw:data-[selected-single=true]:bg-primary tw:data-[selected-single=true]:text-primary-foreground tw:data-[range-middle=true]:bg-accent tw:data-[range-middle=true]:text-accent-foreground tw:data-[range-start=true]:bg-primary tw:data-[range-start=true]:text-primary-foreground tw:data-[range-end=true]:bg-primary tw:data-[range-end=true]:text-primary-foreground tw:group-data-[focused=true]/day:border-ring tw:group-data-[focused=true]/day:ring-ring/50 tw:flex tw:aspect-square tw:h-auto tw:w-full tw:min-w-(--cell-size) tw:flex-col tw:gap-1 tw:font-normal tw:leading-none tw:data-[range-end=true]:rounded-md tw:data-[range-middle=true]:rounded-none tw:data-[range-start=true]:rounded-md tw:group-data-[focused=true]/day:relative tw:group-data-[focused=true]/day:z-10 tw:group-data-[focused=true]/day:ring-[3px] tw:[&>span]:text-xs tw:[&>span]:opacity-70",
        i.day,
        n
      ),
      ...r
    }
  );
}
function Io(n) {
  const e = Object.prototype.toString.call(n);
  return n instanceof Date || typeof n == "object" && e === "[object Date]" ? new n.constructor(+n) : typeof n == "number" || e === "[object Number]" || typeof n == "string" || e === "[object String]" ? new Date(n) : /* @__PURE__ */ new Date(NaN);
}
function zu(n, e) {
  return n instanceof Date ? new n.constructor(e) : new Date(e);
}
const gie = 6048e5, ktt = 864e5;
let _tt = {};
function Q3() {
  return _tt;
}
function I0(n, e) {
  const t = Q3(), r = e?.weekStartsOn ?? e?.locale?.options?.weekStartsOn ?? t.weekStartsOn ?? t.locale?.options?.weekStartsOn ?? 0, i = Io(n), s = i.getDay(), o = (s < r ? 7 : 0) + s - r;
  return i.setDate(i.getDate() - o), i.setHours(0, 0, 0, 0), i;
}
function Xy(n) {
  return I0(n, { weekStartsOn: 1 });
}
function vie(n) {
  const e = Io(n), t = e.getFullYear(), r = zu(n, 0);
  r.setFullYear(t + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const i = Xy(r), s = zu(n, 0);
  s.setFullYear(t, 0, 4), s.setHours(0, 0, 0, 0);
  const o = Xy(s);
  return e.getTime() >= i.getTime() ? t + 1 : e.getTime() >= o.getTime() ? t : t - 1;
}
function cU(n) {
  const e = Io(n);
  return e.setHours(0, 0, 0, 0), e;
}
function uU(n) {
  const e = Io(n), t = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return t.setUTCFullYear(e.getFullYear()), +n - +t;
}
function Ott(n, e) {
  const t = cU(n), r = cU(e), i = +t - uU(t), s = +r - uU(r);
  return Math.round((i - s) / ktt);
}
function Itt(n) {
  const e = vie(n), t = zu(n, 0);
  return t.setFullYear(e, 0, 4), t.setHours(0, 0, 0, 0), Xy(t);
}
function Rtt(n) {
  return n instanceof Date || typeof n == "object" && Object.prototype.toString.call(n) === "[object Date]";
}
function Ptt(n) {
  if (!Rtt(n) && typeof n != "number")
    return !1;
  const e = Io(n);
  return !isNaN(Number(e));
}
function Dtt(n) {
  const e = Io(n), t = zu(n, 0);
  return t.setFullYear(e.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
const Ntt = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Ltt = (n, e, t) => {
  let r;
  const i = Ntt[n];
  return typeof i == "string" ? r = i : e === 1 ? r = i.one : r = i.other.replace("{{count}}", e.toString()), t?.addSuffix ? t.comparison && t.comparison > 0 ? "in " + r : r + " ago" : r;
};
function K6(n) {
  return (e = {}) => {
    const t = e.width ? String(e.width) : n.defaultWidth;
    return n.formats[t] || n.formats[n.defaultWidth];
  };
}
const $tt = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Ftt = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Btt = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, ztt = {
  date: K6({
    formats: $tt,
    defaultWidth: "full"
  }),
  time: K6({
    formats: Ftt,
    defaultWidth: "full"
  }),
  dateTime: K6({
    formats: Btt,
    defaultWidth: "full"
  })
}, Htt = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, Utt = (n, e, t, r) => Htt[n];
function fp(n) {
  return (e, t) => {
    const r = t?.context ? String(t.context) : "standalone";
    let i;
    if (r === "formatting" && n.formattingValues) {
      const o = n.defaultFormattingWidth || n.defaultWidth, a = t?.width ? String(t.width) : o;
      i = n.formattingValues[a] || n.formattingValues[o];
    } else {
      const o = n.defaultWidth, a = t?.width ? String(t.width) : n.defaultWidth;
      i = n.values[a] || n.values[o];
    }
    const s = n.argumentCallback ? n.argumentCallback(e) : e;
    return i[s];
  };
}
const Vtt = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, jtt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Wtt = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Gtt = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, Ktt = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, qtt = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, Ytt = (n, e) => {
  const t = Number(n), r = t % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, Xtt = {
  ordinalNumber: Ytt,
  era: fp({
    values: Vtt,
    defaultWidth: "wide"
  }),
  quarter: fp({
    values: jtt,
    defaultWidth: "wide",
    argumentCallback: (n) => n - 1
  }),
  month: fp({
    values: Wtt,
    defaultWidth: "wide"
  }),
  day: fp({
    values: Gtt,
    defaultWidth: "wide"
  }),
  dayPeriod: fp({
    values: Ktt,
    defaultWidth: "wide",
    formattingValues: qtt,
    defaultFormattingWidth: "wide"
  })
};
function hp(n) {
  return (e, t = {}) => {
    const r = t.width, i = r && n.matchPatterns[r] || n.matchPatterns[n.defaultMatchWidth], s = e.match(i);
    if (!s)
      return null;
    const o = s[0], a = r && n.parsePatterns[r] || n.parsePatterns[n.defaultParseWidth], l = Array.isArray(a) ? Qtt(a, (d) => d.test(o)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      Ztt(a, (d) => d.test(o))
    );
    let c;
    c = n.valueCallback ? n.valueCallback(l) : l, c = t.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      t.valueCallback(c)
    ) : c;
    const u = e.slice(o.length);
    return { value: c, rest: u };
  };
}
function Ztt(n, e) {
  for (const t in n)
    if (Object.prototype.hasOwnProperty.call(n, t) && e(n[t]))
      return t;
}
function Qtt(n, e) {
  for (let t = 0; t < n.length; t++)
    if (e(n[t]))
      return t;
}
function Jtt(n) {
  return (e, t = {}) => {
    const r = e.match(n.matchPattern);
    if (!r) return null;
    const i = r[0], s = e.match(n.parsePattern);
    if (!s) return null;
    let o = n.valueCallback ? n.valueCallback(s[0]) : s[0];
    o = t.valueCallback ? t.valueCallback(o) : o;
    const a = e.slice(i.length);
    return { value: o, rest: a };
  };
}
const ent = /^(\d+)(th|st|nd|rd)?/i, tnt = /\d+/i, nnt = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, rnt = {
  any: [/^b/i, /^(a|c)/i]
}, int = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, snt = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ont = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, ant = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, lnt = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, cnt = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, unt = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, dnt = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, fnt = {
  ordinalNumber: Jtt({
    matchPattern: ent,
    parsePattern: tnt,
    valueCallback: (n) => parseInt(n, 10)
  }),
  era: hp({
    matchPatterns: nnt,
    defaultMatchWidth: "wide",
    parsePatterns: rnt,
    defaultParseWidth: "any"
  }),
  quarter: hp({
    matchPatterns: int,
    defaultMatchWidth: "wide",
    parsePatterns: snt,
    defaultParseWidth: "any",
    valueCallback: (n) => n + 1
  }),
  month: hp({
    matchPatterns: ont,
    defaultMatchWidth: "wide",
    parsePatterns: ant,
    defaultParseWidth: "any"
  }),
  day: hp({
    matchPatterns: lnt,
    defaultMatchWidth: "wide",
    parsePatterns: cnt,
    defaultParseWidth: "any"
  }),
  dayPeriod: hp({
    matchPatterns: unt,
    defaultMatchWidth: "any",
    parsePatterns: dnt,
    defaultParseWidth: "any"
  })
}, hnt = {
  code: "en-US",
  formatDistance: Ltt,
  formatLong: ztt,
  formatRelative: Utt,
  localize: Xtt,
  match: fnt,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function pnt(n) {
  const e = Io(n);
  return Ott(e, Dtt(e)) + 1;
}
function mnt(n) {
  const e = Io(n), t = +Xy(e) - +Itt(e);
  return Math.round(t / gie) + 1;
}
function yie(n, e) {
  const t = Io(n), r = t.getFullYear(), i = Q3(), s = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? i.firstWeekContainsDate ?? i.locale?.options?.firstWeekContainsDate ?? 1, o = zu(n, 0);
  o.setFullYear(r + 1, 0, s), o.setHours(0, 0, 0, 0);
  const a = I0(o, e), l = zu(n, 0);
  l.setFullYear(r, 0, s), l.setHours(0, 0, 0, 0);
  const c = I0(l, e);
  return t.getTime() >= a.getTime() ? r + 1 : t.getTime() >= c.getTime() ? r : r - 1;
}
function gnt(n, e) {
  const t = Q3(), r = e?.firstWeekContainsDate ?? e?.locale?.options?.firstWeekContainsDate ?? t.firstWeekContainsDate ?? t.locale?.options?.firstWeekContainsDate ?? 1, i = yie(n, e), s = zu(n, 0);
  return s.setFullYear(i, 0, r), s.setHours(0, 0, 0, 0), I0(s, e);
}
function vnt(n, e) {
  const t = Io(n), r = +I0(t, e) - +gnt(t, e);
  return Math.round(r / gie) + 1;
}
function ln(n, e) {
  const t = n < 0 ? "-" : "", r = Math.abs(n).toString().padStart(e, "0");
  return t + r;
}
const Il = {
  // Year
  y(n, e) {
    const t = n.getFullYear(), r = t > 0 ? t : 1 - t;
    return ln(e === "yy" ? r % 100 : r, e.length);
  },
  // Month
  M(n, e) {
    const t = n.getMonth();
    return e === "M" ? String(t + 1) : ln(t + 1, 2);
  },
  // Day of the month
  d(n, e) {
    return ln(n.getDate(), e.length);
  },
  // AM or PM
  a(n, e) {
    const t = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(n, e) {
    return ln(n.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(n, e) {
    return ln(n.getHours(), e.length);
  },
  // Minute
  m(n, e) {
    return ln(n.getMinutes(), e.length);
  },
  // Second
  s(n, e) {
    return ln(n.getSeconds(), e.length);
  },
  // Fraction of second
  S(n, e) {
    const t = e.length, r = n.getMilliseconds(), i = Math.trunc(
      r * Math.pow(10, t - 3)
    );
    return ln(i, e.length);
  }
}, Od = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, dU = {
  // Era
  G: function(n, e, t) {
    const r = n.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return t.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return t.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return t.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(n, e, t) {
    if (e === "yo") {
      const r = n.getFullYear(), i = r > 0 ? r : 1 - r;
      return t.ordinalNumber(i, { unit: "year" });
    }
    return Il.y(n, e);
  },
  // Local week-numbering year
  Y: function(n, e, t, r) {
    const i = yie(n, r), s = i > 0 ? i : 1 - i;
    if (e === "YY") {
      const o = s % 100;
      return ln(o, 2);
    }
    return e === "Yo" ? t.ordinalNumber(s, { unit: "year" }) : ln(s, e.length);
  },
  // ISO week-numbering year
  R: function(n, e) {
    const t = vie(n);
    return ln(t, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(n, e) {
    const t = n.getFullYear();
    return ln(t, e.length);
  },
  // Quarter
  Q: function(n, e, t) {
    const r = Math.ceil((n.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return ln(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return t.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return t.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(n, e, t) {
    const r = Math.ceil((n.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return ln(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return t.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return t.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return t.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return t.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(n, e, t) {
    const r = n.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return Il.M(n, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return t.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return t.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return t.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(n, e, t) {
    const r = n.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return ln(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return t.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return t.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return t.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return t.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(n, e, t, r) {
    const i = vnt(n, r);
    return e === "wo" ? t.ordinalNumber(i, { unit: "week" }) : ln(i, e.length);
  },
  // ISO week of year
  I: function(n, e, t) {
    const r = mnt(n);
    return e === "Io" ? t.ordinalNumber(r, { unit: "week" }) : ln(r, e.length);
  },
  // Day of the month
  d: function(n, e, t) {
    return e === "do" ? t.ordinalNumber(n.getDate(), { unit: "date" }) : Il.d(n, e);
  },
  // Day of year
  D: function(n, e, t) {
    const r = pnt(n);
    return e === "Do" ? t.ordinalNumber(r, { unit: "dayOfYear" }) : ln(r, e.length);
  },
  // Day of week
  E: function(n, e, t) {
    const r = n.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(n, e, t, r) {
    const i = n.getDay(), s = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(s);
      // Padded numerical value
      case "ee":
        return ln(s, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return t.ordinalNumber(s, { unit: "day" });
      case "eee":
        return t.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return t.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return t.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return t.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(n, e, t, r) {
    const i = n.getDay(), s = (i - r.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(s);
      // Padded numerical value
      case "cc":
        return ln(s, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return t.ordinalNumber(s, { unit: "day" });
      case "ccc":
        return t.day(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return t.day(i, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return t.day(i, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return t.day(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(n, e, t) {
    const r = n.getDay(), i = r === 0 ? 7 : r;
    switch (e) {
      // 2
      case "i":
        return String(i);
      // 02
      case "ii":
        return ln(i, e.length);
      // 2nd
      case "io":
        return t.ordinalNumber(i, { unit: "day" });
      // Tue
      case "iii":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(n, e, t) {
    const i = n.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(n, e, t) {
    const r = n.getHours();
    let i;
    switch (r === 12 ? i = Od.noon : r === 0 ? i = Od.midnight : i = r / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(n, e, t) {
    const r = n.getHours();
    let i;
    switch (r >= 17 ? i = Od.evening : r >= 12 ? i = Od.afternoon : r >= 4 ? i = Od.morning : i = Od.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(i, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(n, e, t) {
    if (e === "ho") {
      let r = n.getHours() % 12;
      return r === 0 && (r = 12), t.ordinalNumber(r, { unit: "hour" });
    }
    return Il.h(n, e);
  },
  // Hour [0-23]
  H: function(n, e, t) {
    return e === "Ho" ? t.ordinalNumber(n.getHours(), { unit: "hour" }) : Il.H(n, e);
  },
  // Hour [0-11]
  K: function(n, e, t) {
    const r = n.getHours() % 12;
    return e === "Ko" ? t.ordinalNumber(r, { unit: "hour" }) : ln(r, e.length);
  },
  // Hour [1-24]
  k: function(n, e, t) {
    let r = n.getHours();
    return r === 0 && (r = 24), e === "ko" ? t.ordinalNumber(r, { unit: "hour" }) : ln(r, e.length);
  },
  // Minute
  m: function(n, e, t) {
    return e === "mo" ? t.ordinalNumber(n.getMinutes(), { unit: "minute" }) : Il.m(n, e);
  },
  // Second
  s: function(n, e, t) {
    return e === "so" ? t.ordinalNumber(n.getSeconds(), { unit: "second" }) : Il.s(n, e);
  },
  // Fraction of second
  S: function(n, e) {
    return Il.S(n, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(n, e, t) {
    const r = n.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return hU(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Qc(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Qc(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return hU(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Qc(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Qc(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + fU(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Qc(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(n, e, t) {
    const r = n.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + fU(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Qc(r, ":");
    }
  },
  // Seconds timestamp
  t: function(n, e, t) {
    const r = Math.trunc(n.getTime() / 1e3);
    return ln(r, e.length);
  },
  // Milliseconds timestamp
  T: function(n, e, t) {
    const r = n.getTime();
    return ln(r, e.length);
  }
};
function fU(n, e = "") {
  const t = n > 0 ? "-" : "+", r = Math.abs(n), i = Math.trunc(r / 60), s = r % 60;
  return s === 0 ? t + String(i) : t + String(i) + e + ln(s, 2);
}
function hU(n, e) {
  return n % 60 === 0 ? (n > 0 ? "-" : "+") + ln(Math.abs(n) / 60, 2) : Qc(n, e);
}
function Qc(n, e = "") {
  const t = n > 0 ? "-" : "+", r = Math.abs(n), i = ln(Math.trunc(r / 60), 2), s = ln(r % 60, 2);
  return t + i + e + s;
}
const pU = (n, e) => {
  switch (n) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, bie = (n, e) => {
  switch (n) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, ynt = (n, e) => {
  const t = n.match(/(P+)(p+)?/) || [], r = t[1], i = t[2];
  if (!i)
    return pU(n, e);
  let s;
  switch (r) {
    case "P":
      s = e.dateTime({ width: "short" });
      break;
    case "PP":
      s = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      s = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      s = e.dateTime({ width: "full" });
      break;
  }
  return s.replace("{{date}}", pU(r, e)).replace("{{time}}", bie(i, e));
}, bnt = {
  p: bie,
  P: ynt
}, wnt = /^D+$/, xnt = /^Y+$/, Ent = ["D", "DD", "YY", "YYYY"];
function Snt(n) {
  return wnt.test(n);
}
function Cnt(n) {
  return xnt.test(n);
}
function Tnt(n, e, t) {
  const r = Ant(n, e, t);
  if (console.warn(r), Ent.includes(n)) throw new RangeError(r);
}
function Ant(n, e, t) {
  const r = n[0] === "Y" ? "years" : "days of the month";
  return `Use \`${n.toLowerCase()}\` instead of \`${n}\` (in \`${e}\`) for formatting ${r} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Mnt = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, knt = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, _nt = /^'([^]*?)'?$/, Ont = /''/g, Int = /[a-zA-Z]/;
function Rnt(n, e, t) {
  const r = Q3(), i = r.locale ?? hnt, s = r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, o = r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0, a = Io(n);
  if (!Ptt(a))
    throw new RangeError("Invalid time value");
  let l = e.match(knt).map((u) => {
    const d = u[0];
    if (d === "p" || d === "P") {
      const f = bnt[d];
      return f(u, i.formatLong);
    }
    return u;
  }).join("").match(Mnt).map((u) => {
    if (u === "''")
      return { isToken: !1, value: "'" };
    const d = u[0];
    if (d === "'")
      return { isToken: !1, value: Pnt(u) };
    if (dU[d])
      return { isToken: !0, value: u };
    if (d.match(Int))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + d + "`"
      );
    return { isToken: !1, value: u };
  });
  i.localize.preprocessor && (l = i.localize.preprocessor(a, l));
  const c = {
    firstWeekContainsDate: s,
    weekStartsOn: o,
    locale: i
  };
  return l.map((u) => {
    if (!u.isToken) return u.value;
    const d = u.value;
    (Cnt(d) || Snt(d)) && Tnt(d, e, String(n));
    const f = dU[d[0]];
    return f(a, d, i.localize, c);
  }).join("");
}
function Pnt(n) {
  const e = n.match(_nt);
  return e ? e[1].replace(Ont, "'") : n;
}
function r3t(n) {
  const { field: e } = wh({
    name: n.name,
    control: n.control
  });
  function t(o) {
    if (!o) return null;
    if (o instanceof Date) return o;
    if (typeof o == "string") {
      const a = new Date(o);
      return isNaN(a.getTime()) ? null : a;
    }
    return null;
  }
  function r(o) {
    o && e.onChange(o);
  }
  function i(o, a) {
    const l = t(e.value) || /* @__PURE__ */ new Date(), c = new Date(l);
    if (o === "hour") {
      const u = parseInt(a, 10);
      c.setHours(c.getHours() >= 12 ? u + 12 : u);
    } else if (o === "minute")
      c.setMinutes(parseInt(a, 10));
    else if (o === "ampm") {
      const u = c.getHours();
      a === "AM" && u >= 12 ? c.setHours(u - 12) : a === "PM" && u < 12 && c.setHours(u + 12);
    }
    e.onChange(c);
  }
  const s = Ft(
    (o, a) => {
      const l = t(e.value) || /* @__PURE__ */ new Date(), c = new Date(l);
      if (a === "hour" && c.setHours(l.getHours() + o), a === "day" && c.setDate(l.getDate() + o), n.fromDate && c < n.fromDate) {
        e.onChange(n.fromDate);
        return;
      } else if (n.toDate && c > n.toDate) {
        e.onChange(n.toDate);
        return;
      } else
        e.onChange(c);
    },
    [e, n.fromDate, n.toDate]
  );
  return /* @__PURE__ */ T(
    xs,
    {
      control: n.control,
      name: n.name,
      render: ({ field: o }) => {
        const a = t(o.value);
        return /* @__PURE__ */ ee(Ci, { className: "tw:flex tw:flex-col", children: [
          /* @__PURE__ */ T(Ti, { children: n.label }),
          /* @__PURE__ */ ee("div", { className: "tw:flex tw:gap-1", children: [
            n.showButtons && /* @__PURE__ */ ee(ft, { children: [
              /* @__PURE__ */ T(
                Nt,
                {
                  type: "button",
                  variant: "outline",
                  className: "tw:p-1",
                  onClick: () => s(-1, "day"),
                  disabled: !a,
                  children: /* @__PURE__ */ T(cIe, {})
                }
              ),
              /* @__PURE__ */ T(
                Nt,
                {
                  type: "button",
                  variant: "outline",
                  className: "tw:p-1",
                  onClick: () => s(-1, "hour"),
                  disabled: !a,
                  children: /* @__PURE__ */ T(cX, {})
                }
              )
            ] }),
            /* @__PURE__ */ ee(Dh, { modal: !0, children: [
              /* @__PURE__ */ T(Nh, { asChild: !0, children: /* @__PURE__ */ T(qi, { children: /* @__PURE__ */ ee(
                Nt,
                {
                  variant: "outline",
                  className: Q(
                    "tw:w-full tw:pl-3 tw:text-left tw:font-normal",
                    !a && "tw:text-muted-foreground"
                  ),
                  children: [
                    a ? Rnt(
                      a,
                      "dd/MM/yyyy hh:mm aa"
                    ) : /* @__PURE__ */ T("span", { children: "DD/MM/YYYY hh:mm aa" }),
                    /* @__PURE__ */ T(tIe, { className: "tw:ml-auto tw:h-4 tw:w-4 tw:opacity-50" }),
                    !n.required && /* @__PURE__ */ T(
                      Nt,
                      {
                        variant: "ghost",
                        type: "button",
                        size: "none",
                        className: "",
                        onClick: (l) => {
                          o.onChange(null), l.preventDefault(), l.stopPropagation();
                        },
                        children: /* @__PURE__ */ T(AIe, { className: "tw:h-4 tw:opacity-50" })
                      }
                    )
                  ]
                }
              ) }) }),
              /* @__PURE__ */ T(ld, { className: "tw:w-auto tw:p-2", children: /* @__PURE__ */ ee("div", { className: "tw:sm:flex", children: [
                /* @__PURE__ */ T(
                  Att,
                  {
                    mode: "single",
                    selected: a || void 0,
                    onSelect: r,
                    hidden: n.minDate && n.maxDate && {
                      after: n.minDate,
                      before: n.maxDate
                    }
                  }
                ),
                /* @__PURE__ */ ee("div", { className: "tw:flex tw:flex-col tw:sm:flex-row! tw:sm:h-[300px] tw:divide-y tw:sm:divide-y-0 tw:sm:divide-x", children: [
                  /* @__PURE__ */ ee(Kp, { className: "tw:w-64 tw:sm:w-auto", children: [
                    /* @__PURE__ */ T("div", { className: "tw:flex tw:sm:flex-col tw:p-2", children: Array.from(
                      { length: 12 },
                      (l, c) => c + 1
                    ).map((l) => /* @__PURE__ */ T(
                      Nt,
                      {
                        size: "icon",
                        variant: a && a.getHours() % 12 === l % 12 ? "default" : "ghost",
                        className: "tw:sm:w-full tw:shrink-0 tw:aspect-square",
                        onClick: () => i(
                          "hour",
                          l.toString()
                        ),
                        children: l
                      },
                      l
                    )) }),
                    /* @__PURE__ */ T(
                      Ry,
                      {
                        orientation: "horizontal",
                        className: "tw:sm:hidden"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ ee(Kp, { className: "tw:w-64 tw:sm:w-auto", children: [
                    /* @__PURE__ */ T("div", { className: "tw:flex tw:sm:flex-col tw:p-2", children: Array.from(
                      { length: 6 },
                      (l, c) => c * 10
                    ).map((l) => /* @__PURE__ */ T(
                      Nt,
                      {
                        size: "icon",
                        variant: a && a.getMinutes() === l ? "default" : "ghost",
                        className: "tw:sm:w-full tw:shrink-0 tw:aspect-square",
                        onClick: () => i(
                          "minute",
                          l.toString()
                        ),
                        children: l.toString().padStart(
                          2,
                          "0"
                        )
                      },
                      l
                    )) }),
                    /* @__PURE__ */ T(
                      Ry,
                      {
                        orientation: "horizontal",
                        className: "tw:sm:hidden"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ T(Kp, { className: "tw:w-64 tw:sm:w-auto", children: /* @__PURE__ */ T("div", { className: "tw:flex tw:sm:flex-col tw:p-2", children: ["AM", "PM"].map(
                    (l) => /* @__PURE__ */ T(
                      Nt,
                      {
                        size: "icon",
                        variant: a && (l === "AM" && a.getHours() < 12 || l === "PM" && a.getHours() >= 12) ? "default" : "ghost",
                        className: "tw:sm:w-full tw:shrink-0 tw:aspect-square",
                        onClick: () => i(
                          "ampm",
                          l
                        ),
                        children: l
                      },
                      l
                    )
                  ) }) })
                ] })
              ] }) })
            ] }),
            n.showButtons && /* @__PURE__ */ ee(ft, { children: [
              /* @__PURE__ */ T(
                Nt,
                {
                  type: "button",
                  className: "tw:p-1",
                  variant: "outline",
                  onClick: () => s(1, "hour"),
                  disabled: !a,
                  children: /* @__PURE__ */ T(m1, {})
                }
              ),
              /* @__PURE__ */ T(
                Nt,
                {
                  type: "button",
                  className: "tw:p-1",
                  variant: "outline",
                  onClick: () => s(1, "day"),
                  disabled: !a,
                  children: /* @__PURE__ */ T(dIe, {})
                }
              )
            ] })
          ] }),
          n.description && /* @__PURE__ */ T(Ai, { children: n.description }),
          /* @__PURE__ */ T(qs, {})
        ] });
      }
    }
  );
}
var Kg = { exports: {} }, q6 = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var mU;
function Dnt() {
  if (mU) return q6;
  mU = 1;
  var n = p;
  function e(d, f) {
    return d === f && (d !== 0 || 1 / d === 1 / f) || d !== d && f !== f;
  }
  var t = typeof Object.is == "function" ? Object.is : e, r = n.useState, i = n.useEffect, s = n.useLayoutEffect, o = n.useDebugValue;
  function a(d, f) {
    var h = f(), m = r({ inst: { value: h, getSnapshot: f } }), g = m[0].inst, v = m[1];
    return s(
      function() {
        g.value = h, g.getSnapshot = f, l(g) && v({ inst: g });
      },
      [d, h, f]
    ), i(
      function() {
        return l(g) && v({ inst: g }), d(function() {
          l(g) && v({ inst: g });
        });
      },
      [d]
    ), o(h), h;
  }
  function l(d) {
    var f = d.getSnapshot;
    d = d.value;
    try {
      var h = f();
      return !t(d, h);
    } catch {
      return !0;
    }
  }
  function c(d, f) {
    return f();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : a;
  return q6.useSyncExternalStore = n.useSyncExternalStore !== void 0 ? n.useSyncExternalStore : u, q6;
}
var Y6 = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gU;
function Nnt() {
  return gU || (gU = 1, process.env.NODE_ENV !== "production" && (function() {
    function n(h, m) {
      return h === m && (h !== 0 || 1 / h === 1 / m) || h !== h && m !== m;
    }
    function e(h, m) {
      u || i.startTransition === void 0 || (u = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var g = m();
      if (!d) {
        var v = m();
        s(g, v) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), d = !0);
      }
      v = o({
        inst: { value: g, getSnapshot: m }
      });
      var y = v[0].inst, b = v[1];
      return l(
        function() {
          y.value = g, y.getSnapshot = m, t(y) && b({ inst: y });
        },
        [h, g, m]
      ), a(
        function() {
          return t(y) && b({ inst: y }), h(function() {
            t(y) && b({ inst: y });
          });
        },
        [h]
      ), c(g), g;
    }
    function t(h) {
      var m = h.getSnapshot;
      h = h.value;
      try {
        var g = m();
        return !s(h, g);
      } catch {
        return !0;
      }
    }
    function r(h, m) {
      return m();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = p, s = typeof Object.is == "function" ? Object.is : n, o = i.useState, a = i.useEffect, l = i.useLayoutEffect, c = i.useDebugValue, u = !1, d = !1, f = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : e;
    Y6.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : f, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), Y6;
}
var vU;
function z_() {
  return vU || (vU = 1, process.env.NODE_ENV === "production" ? Kg.exports = Dnt() : Kg.exports = Nnt()), Kg.exports;
}
var wie = z_();
function Lr(n) {
  this.content = n;
}
Lr.prototype = {
  constructor: Lr,
  find: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === n) return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(n) {
    var e = this.find(n);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(n, e, t) {
    var r = t && t != n ? this.remove(t) : this, i = r.find(n), s = r.content.slice();
    return i == -1 ? s.push(t || n, e) : (s[i + 1] = e, t && (s[i] = t)), new Lr(s);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(n) {
    var e = this.find(n);
    if (e == -1) return this;
    var t = this.content.slice();
    return t.splice(e, 2), new Lr(t);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(n, e) {
    return new Lr([n, e].concat(this.remove(n).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(n, e) {
    var t = this.remove(n).content.slice();
    return t.push(n, e), new Lr(t);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(n, e, t) {
    var r = this.remove(e), i = r.content.slice(), s = r.find(n);
    return i.splice(s == -1 ? i.length : s, 0, e, t), new Lr(i);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(n) {
    for (var e = 0; e < this.content.length; e += 2)
      n(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(n) {
    return n = Lr.from(n), n.size ? new Lr(n.content.concat(this.subtract(n).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(n) {
    return n = Lr.from(n), n.size ? new Lr(this.subtract(n).content.concat(n.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(n) {
    var e = this;
    n = Lr.from(n);
    for (var t = 0; t < n.content.length; t += 2)
      e = e.remove(n.content[t]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var n = {};
    return this.forEach(function(e, t) {
      n[e] = t;
    }), n;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
Lr.from = function(n) {
  if (n instanceof Lr) return n;
  var e = [];
  if (n) for (var t in n) e.push(t, n[t]);
  return new Lr(e);
};
function xie(n, e, t) {
  for (let r = 0; ; r++) {
    if (r == n.childCount || r == e.childCount)
      return n.childCount == e.childCount ? null : t;
    let i = n.child(r), s = e.child(r);
    if (i == s) {
      t += i.nodeSize;
      continue;
    }
    if (!i.sameMarkup(s))
      return t;
    if (i.isText && i.text != s.text) {
      for (let o = 0; i.text[o] == s.text[o]; o++)
        t++;
      return t;
    }
    if (i.content.size || s.content.size) {
      let o = xie(i.content, s.content, t + 1);
      if (o != null)
        return o;
    }
    t += i.nodeSize;
  }
}
function Eie(n, e, t, r) {
  for (let i = n.childCount, s = e.childCount; ; ) {
    if (i == 0 || s == 0)
      return i == s ? null : { a: t, b: r };
    let o = n.child(--i), a = e.child(--s), l = o.nodeSize;
    if (o == a) {
      t -= l, r -= l;
      continue;
    }
    if (!o.sameMarkup(a))
      return { a: t, b: r };
    if (o.isText && o.text != a.text) {
      let c = 0, u = Math.min(o.text.length, a.text.length);
      for (; c < u && o.text[o.text.length - c - 1] == a.text[a.text.length - c - 1]; )
        c++, t--, r--;
      return { a: t, b: r };
    }
    if (o.content.size || a.content.size) {
      let c = Eie(o.content, a.content, t - 1, r - 1);
      if (c)
        return c;
    }
    t -= l, r -= l;
  }
}
class Ee {
  /**
  @internal
  */
  constructor(e, t) {
    if (this.content = e, this.size = t || 0, t == null)
      for (let r = 0; r < e.length; r++)
        this.size += e[r].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, t, r, i = 0, s) {
    for (let o = 0, a = 0; a < t; o++) {
      let l = this.content[o], c = a + l.nodeSize;
      if (c > e && r(l, i + a, s || null, o) !== !1 && l.content.size) {
        let u = a + 1;
        l.nodesBetween(Math.max(0, e - u), Math.min(l.content.size, t - u), r, i + u);
      }
      a = c;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, t, r, i) {
    let s = "", o = !0;
    return this.nodesBetween(e, t, (a, l) => {
      let c = a.isText ? a.text.slice(Math.max(e, l) - l, t - l) : a.isLeaf ? i ? typeof i == "function" ? i(a) : i : a.type.spec.leafText ? a.type.spec.leafText(a) : "" : "";
      a.isBlock && (a.isLeaf && c || a.isTextblock) && r && (o ? o = !1 : s += r), s += c;
    }, 0), s;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let t = this.lastChild, r = e.firstChild, i = this.content.slice(), s = 0;
    for (t.isText && t.sameMarkup(r) && (i[i.length - 1] = t.withText(t.text + r.text), s = 1); s < e.content.length; s++)
      i.push(e.content[s]);
    return new Ee(i, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, t = this.size) {
    if (e == 0 && t == this.size)
      return this;
    let r = [], i = 0;
    if (t > e)
      for (let s = 0, o = 0; o < t; s++) {
        let a = this.content[s], l = o + a.nodeSize;
        l > e && ((o < e || l > t) && (a.isText ? a = a.cut(Math.max(0, e - o), Math.min(a.text.length, t - o)) : a = a.cut(Math.max(0, e - o - 1), Math.min(a.content.size, t - o - 1))), r.push(a), i += a.nodeSize), o = l;
      }
    return new Ee(r, i);
  }
  /**
  @internal
  */
  cutByIndex(e, t) {
    return e == t ? Ee.empty : e == 0 && t == this.content.length ? this : new Ee(this.content.slice(e, t));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, t) {
    let r = this.content[e];
    if (r == t)
      return this;
    let i = this.content.slice(), s = this.size + t.nodeSize - r.nodeSize;
    return i[e] = t, new Ee(i, s);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new Ee([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new Ee(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let t = 0; t < this.content.length; t++)
      if (!this.content[t].eq(e.content[t]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let t = this.content[e];
    if (!t)
      throw new RangeError("Index " + e + " out of range for " + this);
    return t;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let t = 0, r = 0; t < this.content.length; t++) {
      let i = this.content[t];
      e(i, r, t), r += i.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, t = 0) {
    return xie(this, e, t);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, t = this.size, r = e.size) {
    return Eie(this, e, t, r);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e) {
    if (e == 0)
      return qg(0, e);
    if (e == this.size)
      return qg(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let t = 0, r = 0; ; t++) {
      let i = this.child(t), s = r + i.nodeSize;
      if (s >= e)
        return s == e ? qg(t + 1, s) : qg(t, r);
      r = s;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return Ee.empty;
    if (!Array.isArray(t))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new Ee(t.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return Ee.empty;
    let t, r = 0;
    for (let i = 0; i < e.length; i++) {
      let s = e[i];
      r += s.nodeSize, i && s.isText && e[i - 1].sameMarkup(s) ? (t || (t = e.slice(0, i)), t[t.length - 1] = s.withText(t[t.length - 1].text + s.text)) : t && t.push(s);
    }
    return new Ee(t || e, r);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return Ee.empty;
    if (e instanceof Ee)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new Ee([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
Ee.empty = new Ee([], 0);
const X6 = { index: 0, offset: 0 };
function qg(n, e) {
  return X6.index = n, X6.offset = e, X6;
}
function Zy(n, e) {
  if (n === e)
    return !0;
  if (!(n && typeof n == "object") || !(e && typeof e == "object"))
    return !1;
  let t = Array.isArray(n);
  if (Array.isArray(e) != t)
    return !1;
  if (t) {
    if (n.length != e.length)
      return !1;
    for (let r = 0; r < n.length; r++)
      if (!Zy(n[r], e[r]))
        return !1;
  } else {
    for (let r in n)
      if (!(r in e) || !Zy(n[r], e[r]))
        return !1;
    for (let r in e)
      if (!(r in n))
        return !1;
  }
  return !0;
}
let xn = class z7 {
  /**
  @internal
  */
  constructor(e, t) {
    this.type = e, this.attrs = t;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let t, r = !1;
    for (let i = 0; i < e.length; i++) {
      let s = e[i];
      if (this.eq(s))
        return e;
      if (this.type.excludes(s.type))
        t || (t = e.slice(0, i));
      else {
        if (s.type.excludes(this.type))
          return e;
        !r && s.type.rank > this.type.rank && (t || (t = e.slice(0, i)), t.push(this), r = !0), t && t.push(s);
      }
    }
    return t || (t = e.slice()), r || t.push(this), t;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return e.slice(0, t).concat(e.slice(t + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (this.eq(e[t]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && Zy(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let r = e.marks[t.type];
    if (!r)
      throw new RangeError(`There is no mark type ${t.type} in this schema`);
    let i = r.create(t.attrs);
    return r.checkAttrs(i.attrs), i;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, t) {
    if (e == t)
      return !0;
    if (e.length != t.length)
      return !1;
    for (let r = 0; r < e.length; r++)
      if (!e[r].eq(t[r]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return z7.none;
    if (e instanceof z7)
      return [e];
    let t = e.slice();
    return t.sort((r, i) => r.type.rank - i.type.rank), t;
  }
};
xn.none = [];
class Qy extends Error {
}
class Fe {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, t, r) {
    this.content = e, this.openStart = t, this.openEnd = r;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, t) {
    let r = Cie(this.content, e + this.openStart, t);
    return r && new Fe(r, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, t) {
    return new Fe(Sie(this.content, e + this.openStart, t + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      return Fe.empty;
    let r = t.openStart || 0, i = t.openEnd || 0;
    if (typeof r != "number" || typeof i != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new Fe(Ee.fromJSON(e, t.content), r, i);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, t = !0) {
    let r = 0, i = 0;
    for (let s = e.firstChild; s && !s.isLeaf && (t || !s.type.spec.isolating); s = s.firstChild)
      r++;
    for (let s = e.lastChild; s && !s.isLeaf && (t || !s.type.spec.isolating); s = s.lastChild)
      i++;
    return new Fe(e, r, i);
  }
}
Fe.empty = new Fe(Ee.empty, 0, 0);
function Sie(n, e, t) {
  let { index: r, offset: i } = n.findIndex(e), s = n.maybeChild(r), { index: o, offset: a } = n.findIndex(t);
  if (i == e || s.isText) {
    if (a != t && !n.child(o).isText)
      throw new RangeError("Removing non-flat range");
    return n.cut(0, e).append(n.cut(t));
  }
  if (r != o)
    throw new RangeError("Removing non-flat range");
  return n.replaceChild(r, s.copy(Sie(s.content, e - i - 1, t - i - 1)));
}
function Cie(n, e, t, r) {
  let { index: i, offset: s } = n.findIndex(e), o = n.maybeChild(i);
  if (s == e || o.isText)
    return r && !r.canReplace(i, i, t) ? null : n.cut(0, e).append(t).append(n.cut(e));
  let a = Cie(o.content, e - s - 1, t, o);
  return a && n.replaceChild(i, o.copy(a));
}
function Lnt(n, e, t) {
  if (t.openStart > n.depth)
    throw new Qy("Inserted content deeper than insertion position");
  if (n.depth - t.openStart != e.depth - t.openEnd)
    throw new Qy("Inconsistent open depths");
  return Tie(n, e, t, 0);
}
function Tie(n, e, t, r) {
  let i = n.index(r), s = n.node(r);
  if (i == e.index(r) && r < n.depth - t.openStart) {
    let o = Tie(n, e, t, r + 1);
    return s.copy(s.content.replaceChild(i, o));
  } else if (t.content.size)
    if (!t.openStart && !t.openEnd && n.depth == r && e.depth == r) {
      let o = n.parent, a = o.content;
      return Cu(o, a.cut(0, n.parentOffset).append(t.content).append(a.cut(e.parentOffset)));
    } else {
      let { start: o, end: a } = $nt(t, n);
      return Cu(s, Mie(n, o, a, e, r));
    }
  else return Cu(s, Jy(n, e, r));
}
function Aie(n, e) {
  if (!e.type.compatibleContent(n.type))
    throw new Qy("Cannot join " + e.type.name + " onto " + n.type.name);
}
function H7(n, e, t) {
  let r = n.node(t);
  return Aie(r, e.node(t)), r;
}
function Su(n, e) {
  let t = e.length - 1;
  t >= 0 && n.isText && n.sameMarkup(e[t]) ? e[t] = n.withText(e[t].text + n.text) : e.push(n);
}
function Jp(n, e, t, r) {
  let i = (e || n).node(t), s = 0, o = e ? e.index(t) : i.childCount;
  n && (s = n.index(t), n.depth > t ? s++ : n.textOffset && (Su(n.nodeAfter, r), s++));
  for (let a = s; a < o; a++)
    Su(i.child(a), r);
  e && e.depth == t && e.textOffset && Su(e.nodeBefore, r);
}
function Cu(n, e) {
  return n.type.checkContent(e), n.copy(e);
}
function Mie(n, e, t, r, i) {
  let s = n.depth > i && H7(n, e, i + 1), o = r.depth > i && H7(t, r, i + 1), a = [];
  return Jp(null, n, i, a), s && o && e.index(i) == t.index(i) ? (Aie(s, o), Su(Cu(s, Mie(n, e, t, r, i + 1)), a)) : (s && Su(Cu(s, Jy(n, e, i + 1)), a), Jp(e, t, i, a), o && Su(Cu(o, Jy(t, r, i + 1)), a)), Jp(r, null, i, a), new Ee(a);
}
function Jy(n, e, t) {
  let r = [];
  if (Jp(null, n, t, r), n.depth > t) {
    let i = H7(n, e, t + 1);
    Su(Cu(i, Jy(n, e, t + 1)), r);
  }
  return Jp(e, null, t, r), new Ee(r);
}
function $nt(n, e) {
  let t = e.depth - n.openStart, i = e.node(t).copy(n.content);
  for (let s = t - 1; s >= 0; s--)
    i = e.node(s).copy(Ee.from(i));
  return {
    start: i.resolveNoCache(n.openStart + t),
    end: i.resolveNoCache(i.content.size - n.openEnd - t)
  };
}
class R0 {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.pos = e, this.path = t, this.parentOffset = r, this.depth = t.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, t = this.index(this.depth);
    if (t == e.childCount)
      return null;
    let r = this.pos - this.path[this.path.length - 1], i = e.child(t);
    return r ? e.child(t).cut(r) : i;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), t = this.pos - this.path[this.path.length - 1];
    return t ? this.parent.child(e).cut(0, t) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, t) {
    t = this.resolveDepth(t);
    let r = this.path[t * 3], i = t == 0 ? 0 : this.path[t * 3 - 1] + 1;
    for (let s = 0; s < e; s++)
      i += r.child(s).nodeSize;
    return i;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, t = this.index();
    if (e.content.size == 0)
      return xn.none;
    if (this.textOffset)
      return e.child(t).marks;
    let r = e.maybeChild(t - 1), i = e.maybeChild(t);
    if (!r) {
      let a = r;
      r = i, i = a;
    }
    let s = r.marks;
    for (var o = 0; o < s.length; o++)
      s[o].type.spec.inclusive === !1 && (!i || !s[o].isInSet(i.marks)) && (s = s[o--].removeFromSet(s));
    return s;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let t = this.parent.maybeChild(this.index());
    if (!t || !t.isInline)
      return null;
    let r = t.marks, i = e.parent.maybeChild(e.index());
    for (var s = 0; s < r.length; s++)
      r[s].type.spec.inclusive === !1 && (!i || !r[s].isInSet(i.marks)) && (r = r[s--].removeFromSet(r));
    return r;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let t = this.depth; t > 0; t--)
      if (this.start(t) <= e && this.end(t) >= e)
        return t;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, t) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let r = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); r >= 0; r--)
      if (e.pos <= this.end(r) && (!t || t(this.node(r))))
        return new eb(this, e, r);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let t = 1; t <= this.depth; t++)
      e += (e ? "/" : "") + this.node(t).type.name + "_" + this.index(t - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, t) {
    if (!(t >= 0 && t <= e.content.size))
      throw new RangeError("Position " + t + " out of range");
    let r = [], i = 0, s = t;
    for (let o = e; ; ) {
      let { index: a, offset: l } = o.content.findIndex(s), c = s - l;
      if (r.push(o, a, i + l), !c || (o = o.child(a), o.isText))
        break;
      s = c - 1, i += l + 1;
    }
    return new R0(t, r, s);
  }
  /**
  @internal
  */
  static resolveCached(e, t) {
    let r = yU.get(e);
    if (r)
      for (let s = 0; s < r.elts.length; s++) {
        let o = r.elts[s];
        if (o.pos == t)
          return o;
      }
    else
      yU.set(e, r = new Fnt());
    let i = r.elts[r.i] = R0.resolve(e, t);
    return r.i = (r.i + 1) % Bnt, i;
  }
}
class Fnt {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const Bnt = 12, yU = /* @__PURE__ */ new WeakMap();
class eb {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, t, r) {
    this.$from = e, this.$to = t, this.depth = r;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const znt = /* @__PURE__ */ Object.create(null);
let lc = class U7 {
  /**
  @internal
  */
  constructor(e, t, r, i = xn.none) {
    this.type = e, this.attrs = t, this.marks = i, this.content = r || Ee.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, t, r, i = 0) {
    this.content.nodesBetween(e, t, r, i, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
  */
  textBetween(e, t, r, i) {
    return this.content.textBetween(e, t, r, i);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, t, r) {
    return this.type == e && Zy(this.attrs, t || e.defaultAttrs || znt) && xn.sameSet(this.marks, r || xn.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new U7(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new U7(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, t = this.content.size) {
    return e == 0 && t == this.content.size ? this : this.copy(this.content.cut(e, t));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, t = this.content.size, r = !1) {
    if (e == t)
      return Fe.empty;
    let i = this.resolve(e), s = this.resolve(t), o = r ? 0 : i.sharedDepth(t), a = i.start(o), c = i.node(o).content.cut(i.pos - a, s.pos - a);
    return new Fe(c, i.depth - o, s.depth - o);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, t, r) {
    return Lnt(this.resolve(e), this.resolve(t), r);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let t = this; ; ) {
      let { index: r, offset: i } = t.content.findIndex(e);
      if (t = t.maybeChild(r), !t)
        return null;
      if (i == e || t.isText)
        return t;
      e -= i + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: t, offset: r } = this.content.findIndex(e);
    return { node: this.content.maybeChild(t), index: t, offset: r };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: t, offset: r } = this.content.findIndex(e);
    if (r < e)
      return { node: this.content.child(t), index: t, offset: r };
    let i = this.content.child(t - 1);
    return { node: i, index: t - 1, offset: r - i.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return R0.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return R0.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, t, r) {
    let i = !1;
    return t > e && this.nodesBetween(e, t, (s) => (r.isInSet(s.marks) && (i = !0), !i)), i;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), kie(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let t = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!t)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return t;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, t, r = Ee.empty, i = 0, s = r.childCount) {
    let o = this.contentMatchAt(e).matchFragment(r, i, s), a = o && o.matchFragment(this.content, t);
    if (!a || !a.validEnd)
      return !1;
    for (let l = i; l < s; l++)
      if (!this.type.allowsMarks(r.child(l).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, t, r, i) {
    if (i && !this.type.allowsMarks(i))
      return !1;
    let s = this.contentMatchAt(e).matchType(r), o = s && s.matchFragment(this.content, t);
    return o ? o.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = xn.none;
    for (let t = 0; t < this.marks.length; t++) {
      let r = this.marks[t];
      r.type.checkAttrs(r.attrs), e = r.addToSet(e);
    }
    if (!xn.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((t) => t.type.name)}`);
    this.content.forEach((t) => t.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let t in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((t) => t.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, t) {
    if (!t)
      throw new RangeError("Invalid input for Node.fromJSON");
    let r;
    if (t.marks) {
      if (!Array.isArray(t.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      r = t.marks.map(e.markFromJSON);
    }
    if (t.type == "text") {
      if (typeof t.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(t.text, r);
    }
    let i = Ee.fromJSON(e, t.content), s = e.nodeType(t.type).create(t.attrs, i, r);
    return s.type.checkAttrs(s.attrs), s;
  }
};
lc.prototype.text = void 0;
let Hnt = class V7 extends lc {
  /**
  @internal
  */
  constructor(e, t, r, i) {
    if (super(e, t, null, i), !r)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = r;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : kie(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, t) {
    return this.text.slice(e, t);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new V7(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new V7(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, t = this.text.length) {
    return e == 0 && t == this.text.length ? this : this.withText(this.text.slice(e, t));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
};
function kie(n, e) {
  for (let t = n.length - 1; t >= 0; t--)
    e = n[t].type.name + "(" + e + ")";
  return e;
}
class Hu {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, t) {
    let r = new Unt(e, t);
    if (r.next == null)
      return Hu.empty;
    let i = _ie(r);
    r.next && r.err("Unexpected trailing text");
    let s = Ynt(qnt(i));
    return Xnt(s, r), s;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let t = 0; t < this.next.length; t++)
      if (this.next[t].type == e)
        return this.next[t].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, t = 0, r = e.childCount) {
    let i = this;
    for (let s = t; i && s < r; s++)
      i = i.matchType(e.child(s).type);
    return i;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: t } = this.next[e];
      if (!(t.isText || t.hasRequiredAttrs()))
        return t;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let t = 0; t < this.next.length; t++)
      for (let r = 0; r < e.next.length; r++)
        if (this.next[t].type == e.next[r].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, t = !1, r = 0) {
    let i = [this];
    function s(o, a) {
      let l = o.matchFragment(e, r);
      if (l && (!t || l.validEnd))
        return Ee.from(a.map((c) => c.createAndFill()));
      for (let c = 0; c < o.next.length; c++) {
        let { type: u, next: d } = o.next[c];
        if (!(u.isText || u.hasRequiredAttrs()) && i.indexOf(d) == -1) {
          i.push(d);
          let f = s(d, a.concat(u));
          if (f)
            return f;
        }
      }
      return null;
    }
    return s(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let r = 0; r < this.wrapCache.length; r += 2)
      if (this.wrapCache[r] == e)
        return this.wrapCache[r + 1];
    let t = this.computeWrapping(e);
    return this.wrapCache.push(e, t), t;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let t = /* @__PURE__ */ Object.create(null), r = [{ match: this, type: null, via: null }];
    for (; r.length; ) {
      let i = r.shift(), s = i.match;
      if (s.matchType(e)) {
        let o = [];
        for (let a = i; a.type; a = a.via)
          o.push(a.type);
        return o.reverse();
      }
      for (let o = 0; o < s.next.length; o++) {
        let { type: a, next: l } = s.next[o];
        !a.isLeaf && !a.hasRequiredAttrs() && !(a.name in t) && (!i.type || l.validEnd) && (r.push({ match: a.contentMatch, type: a, via: i }), t[a.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function t(r) {
      e.push(r);
      for (let i = 0; i < r.next.length; i++)
        e.indexOf(r.next[i].next) == -1 && t(r.next[i].next);
    }
    return t(this), e.map((r, i) => {
      let s = i + (r.validEnd ? "*" : " ") + " ";
      for (let o = 0; o < r.next.length; o++)
        s += (o ? ", " : "") + r.next[o].type.name + "->" + e.indexOf(r.next[o].next);
      return s;
    }).join(`
`);
  }
}
Hu.empty = new Hu(!0);
class Unt {
  constructor(e, t) {
    this.string = e, this.nodeTypes = t, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function _ie(n) {
  let e = [];
  do
    e.push(Vnt(n));
  while (n.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function Vnt(n) {
  let e = [];
  do
    e.push(jnt(n));
  while (n.next && n.next != ")" && n.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function jnt(n) {
  let e = Knt(n);
  for (; ; )
    if (n.eat("+"))
      e = { type: "plus", expr: e };
    else if (n.eat("*"))
      e = { type: "star", expr: e };
    else if (n.eat("?"))
      e = { type: "opt", expr: e };
    else if (n.eat("{"))
      e = Wnt(n, e);
    else
      break;
  return e;
}
function bU(n) {
  /\D/.test(n.next) && n.err("Expected number, got '" + n.next + "'");
  let e = Number(n.next);
  return n.pos++, e;
}
function Wnt(n, e) {
  let t = bU(n), r = t;
  return n.eat(",") && (n.next != "}" ? r = bU(n) : r = -1), n.eat("}") || n.err("Unclosed braced range"), { type: "range", min: t, max: r, expr: e };
}
function Gnt(n, e) {
  let t = n.nodeTypes, r = t[e];
  if (r)
    return [r];
  let i = [];
  for (let s in t) {
    let o = t[s];
    o.isInGroup(e) && i.push(o);
  }
  return i.length == 0 && n.err("No node type or group '" + e + "' found"), i;
}
function Knt(n) {
  if (n.eat("(")) {
    let e = _ie(n);
    return n.eat(")") || n.err("Missing closing paren"), e;
  } else if (/\W/.test(n.next))
    n.err("Unexpected token '" + n.next + "'");
  else {
    let e = Gnt(n, n.next).map((t) => (n.inline == null ? n.inline = t.isInline : n.inline != t.isInline && n.err("Mixing inline and block content"), { type: "name", value: t }));
    return n.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function qnt(n) {
  let e = [[]];
  return i(s(n, 0), t()), e;
  function t() {
    return e.push([]) - 1;
  }
  function r(o, a, l) {
    let c = { term: l, to: a };
    return e[o].push(c), c;
  }
  function i(o, a) {
    o.forEach((l) => l.to = a);
  }
  function s(o, a) {
    if (o.type == "choice")
      return o.exprs.reduce((l, c) => l.concat(s(c, a)), []);
    if (o.type == "seq")
      for (let l = 0; ; l++) {
        let c = s(o.exprs[l], a);
        if (l == o.exprs.length - 1)
          return c;
        i(c, a = t());
      }
    else if (o.type == "star") {
      let l = t();
      return r(a, l), i(s(o.expr, l), l), [r(l)];
    } else if (o.type == "plus") {
      let l = t();
      return i(s(o.expr, a), l), i(s(o.expr, l), l), [r(l)];
    } else {
      if (o.type == "opt")
        return [r(a)].concat(s(o.expr, a));
      if (o.type == "range") {
        let l = a;
        for (let c = 0; c < o.min; c++) {
          let u = t();
          i(s(o.expr, l), u), l = u;
        }
        if (o.max == -1)
          i(s(o.expr, l), l);
        else
          for (let c = o.min; c < o.max; c++) {
            let u = t();
            r(l, u), i(s(o.expr, l), u), l = u;
          }
        return [r(l)];
      } else {
        if (o.type == "name")
          return [r(a, void 0, o.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function Oie(n, e) {
  return e - n;
}
function wU(n, e) {
  let t = [];
  return r(e), t.sort(Oie);
  function r(i) {
    let s = n[i];
    if (s.length == 1 && !s[0].term)
      return r(s[0].to);
    t.push(i);
    for (let o = 0; o < s.length; o++) {
      let { term: a, to: l } = s[o];
      !a && t.indexOf(l) == -1 && r(l);
    }
  }
}
function Ynt(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return t(wU(n, 0));
  function t(r) {
    let i = [];
    r.forEach((o) => {
      n[o].forEach(({ term: a, to: l }) => {
        if (!a)
          return;
        let c;
        for (let u = 0; u < i.length; u++)
          i[u][0] == a && (c = i[u][1]);
        wU(n, l).forEach((u) => {
          c || i.push([a, c = []]), c.indexOf(u) == -1 && c.push(u);
        });
      });
    });
    let s = e[r.join(",")] = new Hu(r.indexOf(n.length - 1) > -1);
    for (let o = 0; o < i.length; o++) {
      let a = i[o][1].sort(Oie);
      s.next.push({ type: i[o][0], next: e[a.join(",")] || t(a) });
    }
    return s;
  }
}
function Xnt(n, e) {
  for (let t = 0, r = [n]; t < r.length; t++) {
    let i = r[t], s = !i.validEnd, o = [];
    for (let a = 0; a < i.next.length; a++) {
      let { type: l, next: c } = i.next[a];
      o.push(l.name), s && !(l.isText || l.hasRequiredAttrs()) && (s = !1), r.indexOf(c) == -1 && r.push(c);
    }
    s && e.err("Only non-generatable nodes (" + o.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function Iie(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n) {
    let r = n[t];
    if (!r.hasDefault)
      return null;
    e[t] = r.default;
  }
  return e;
}
function Rie(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let r in n) {
    let i = e && e[r];
    if (i === void 0) {
      let s = n[r];
      if (s.hasDefault)
        i = s.default;
      else
        throw new RangeError("No value supplied for attribute " + r);
    }
    t[r] = i;
  }
  return t;
}
function Pie(n, e, t, r) {
  for (let i in e)
    if (!(i in n))
      throw new RangeError(`Unsupported attribute ${i} for ${t} of type ${i}`);
  for (let i in n) {
    let s = n[i];
    s.validate && s.validate(e[i]);
  }
}
function Die(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let r in e)
      t[r] = new Qnt(n, r, e[r]);
  return t;
}
let xU = class Nie {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.name = e, this.schema = t, this.spec = r, this.markSet = null, this.groups = r.group ? r.group.split(" ") : [], this.attrs = Die(e, r.attrs), this.defaultAttrs = Iie(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(r.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == Hu.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : Rie(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, t, r) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new lc(this, this.computeAttrs(e), Ee.from(t), xn.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, t, r) {
    return t = Ee.from(t), this.checkContent(t), new lc(this, this.computeAttrs(e), t, xn.setFrom(r));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, t, r) {
    if (e = this.computeAttrs(e), t = Ee.from(t), t.size) {
      let o = this.contentMatch.fillBefore(t);
      if (!o)
        return null;
      t = o.append(t);
    }
    let i = this.contentMatch.matchFragment(t), s = i && i.fillBefore(Ee.empty, !0);
    return s ? new lc(this, e, t.append(s), xn.setFrom(r)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let t = this.contentMatch.matchFragment(e);
    if (!t || !t.validEnd)
      return !1;
    for (let r = 0; r < e.childCount; r++)
      if (!this.allowsMarks(e.child(r).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    Pie(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let t = 0; t < e.length; t++)
      if (!this.allowsMarkType(e[t].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let t;
    for (let r = 0; r < e.length; r++)
      this.allowsMarkType(e[r].type) ? t && t.push(e[r]) : t || (t = e.slice(0, r));
    return t ? t.length ? t : xn.none : e;
  }
  /**
  @internal
  */
  static compile(e, t) {
    let r = /* @__PURE__ */ Object.create(null);
    e.forEach((s, o) => r[s] = new Nie(s, t, o));
    let i = t.spec.topNode || "doc";
    if (!r[i])
      throw new RangeError("Schema is missing its top node type ('" + i + "')");
    if (!r.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let s in r.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return r;
  }
};
function Znt(n, e, t) {
  let r = t.split("|");
  return (i) => {
    let s = i === null ? "null" : typeof i;
    if (r.indexOf(s) < 0)
      throw new RangeError(`Expected value of type ${r} for attribute ${e} on type ${n}, got ${s}`);
  };
}
class Qnt {
  constructor(e, t, r) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(r, "default"), this.default = r.default, this.validate = typeof r.validate == "string" ? Znt(e, t, r.validate) : r.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class J3 {
  /**
  @internal
  */
  constructor(e, t, r, i) {
    this.name = e, this.rank = t, this.schema = r, this.spec = i, this.attrs = Die(e, i.attrs), this.excluded = null;
    let s = Iie(this.attrs);
    this.instance = s ? new xn(this, s) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new xn(this, Rie(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, t) {
    let r = /* @__PURE__ */ Object.create(null), i = 0;
    return e.forEach((s, o) => r[s] = new J3(s, i++, t, o)), r;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var t = 0; t < e.length; t++)
      e[t].type == this && (e = e.slice(0, t).concat(e.slice(t + 1)), t--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let t = 0; t < e.length; t++)
      if (e[t].type == this)
        return e[t];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    Pie(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class Lie {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let t = this.spec = {};
    for (let i in e)
      t[i] = e[i];
    t.nodes = Lr.from(e.nodes), t.marks = Lr.from(e.marks || {}), this.nodes = xU.compile(this.spec.nodes, this), this.marks = J3.compile(this.spec.marks, this);
    let r = /* @__PURE__ */ Object.create(null);
    for (let i in this.nodes) {
      if (i in this.marks)
        throw new RangeError(i + " can not be both a node and a mark");
      let s = this.nodes[i], o = s.spec.content || "", a = s.spec.marks;
      if (s.contentMatch = r[o] || (r[o] = Hu.parse(o, this.nodes)), s.inlineContent = s.contentMatch.inlineContent, s.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!s.isInline || !s.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = s;
      }
      s.markSet = a == "_" ? null : a ? EU(this, a.split(" ")) : a == "" || !s.inlineContent ? [] : null;
    }
    for (let i in this.marks) {
      let s = this.marks[i], o = s.spec.excludes;
      s.excluded = o == null ? [s] : o == "" ? [] : EU(this, o.split(" "));
    }
    this.nodeFromJSON = (i) => lc.fromJSON(this, i), this.markFromJSON = (i) => xn.fromJSON(this, i), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, t = null, r, i) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof xU) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else throw new RangeError("Invalid node type: " + e);
    return e.createChecked(t, r, i);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, t) {
    let r = this.nodes.text;
    return new Hnt(r, r.defaultAttrs, e, xn.setFrom(t));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, t) {
    return typeof e == "string" && (e = this.marks[e]), e.create(t);
  }
  /**
  @internal
  */
  nodeType(e) {
    let t = this.nodes[e];
    if (!t)
      throw new RangeError("Unknown node type: " + e);
    return t;
  }
}
function EU(n, e) {
  let t = [];
  for (let r = 0; r < e.length; r++) {
    let i = e[r], s = n.marks[i], o = s;
    if (s)
      t.push(s);
    else
      for (let a in n.marks) {
        let l = n.marks[a];
        (i == "_" || l.spec.group && l.spec.group.split(" ").indexOf(i) > -1) && t.push(o = l);
      }
    if (!o)
      throw new SyntaxError("Unknown mark type: '" + e[r] + "'");
  }
  return t;
}
function Jnt(n) {
  return n.tag != null;
}
function ert(n) {
  return n.style != null;
}
let em = class j7 {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, t) {
    this.schema = e, this.rules = t, this.tags = [], this.styles = [];
    let r = this.matchedStyles = [];
    t.forEach((i) => {
      if (Jnt(i))
        this.tags.push(i);
      else if (ert(i)) {
        let s = /[^=]*/.exec(i.style)[0];
        r.indexOf(s) < 0 && r.push(s), this.styles.push(i);
      }
    }), this.normalizeLists = !this.tags.some((i) => {
      if (!/^(ul|ol)\b/.test(i.tag) || !i.node)
        return !1;
      let s = e.nodes[i.node];
      return s.contentMatch.matchType(s);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, t = {}) {
    let r = new CU(this, t, !1);
    return r.addAll(e, xn.none, t.from, t.to), r.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, t = {}) {
    let r = new CU(this, t, !0);
    return r.addAll(e, xn.none, t.from, t.to), Fe.maxOpen(r.finish());
  }
  /**
  @internal
  */
  matchTag(e, t, r) {
    for (let i = r ? this.tags.indexOf(r) + 1 : 0; i < this.tags.length; i++) {
      let s = this.tags[i];
      if (rrt(e, s.tag) && (s.namespace === void 0 || e.namespaceURI == s.namespace) && (!s.context || t.matchesContext(s.context))) {
        if (s.getAttrs) {
          let o = s.getAttrs(e);
          if (o === !1)
            continue;
          s.attrs = o || void 0;
        }
        return s;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, t, r, i) {
    for (let s = i ? this.styles.indexOf(i) + 1 : 0; s < this.styles.length; s++) {
      let o = this.styles[s], a = o.style;
      if (!(a.indexOf(e) != 0 || o.context && !r.matchesContext(o.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      a.length > e.length && (a.charCodeAt(e.length) != 61 || a.slice(e.length + 1) != t))) {
        if (o.getAttrs) {
          let l = o.getAttrs(t);
          if (l === !1)
            continue;
          o.attrs = l || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let t = [];
    function r(i) {
      let s = i.priority == null ? 50 : i.priority, o = 0;
      for (; o < t.length; o++) {
        let a = t[o];
        if ((a.priority == null ? 50 : a.priority) < s)
          break;
      }
      t.splice(o, 0, i);
    }
    for (let i in e.marks) {
      let s = e.marks[i].spec.parseDOM;
      s && s.forEach((o) => {
        r(o = TU(o)), o.mark || o.ignore || o.clearMark || (o.mark = i);
      });
    }
    for (let i in e.nodes) {
      let s = e.nodes[i].spec.parseDOM;
      s && s.forEach((o) => {
        r(o = TU(o)), o.node || o.ignore || o.mark || (o.node = i);
      });
    }
    return t;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new j7(e, j7.schemaRules(e)));
  }
};
const $ie = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, trt = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, Fie = { ol: !0, ul: !0 }, P0 = 1, W7 = 2, tm = 4;
function SU(n, e, t) {
  return e != null ? (e ? P0 : 0) | (e === "full" ? W7 : 0) : n && n.whitespace == "pre" ? P0 | W7 : t & ~tm;
}
class Yg {
  constructor(e, t, r, i, s, o) {
    this.type = e, this.attrs = t, this.marks = r, this.solid = i, this.options = o, this.content = [], this.activeMarks = xn.none, this.match = s || (o & tm ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let t = this.type.contentMatch.fillBefore(Ee.from(e));
      if (t)
        this.match = this.type.contentMatch.matchFragment(t);
      else {
        let r = this.type.contentMatch, i;
        return (i = r.findWrapping(e.type)) ? (this.match = r, i) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & P0)) {
      let r = this.content[this.content.length - 1], i;
      if (r && r.isText && (i = /[ \t\r\n\u000c]+$/.exec(r.text))) {
        let s = r;
        r.text.length == i[0].length ? this.content.pop() : this.content[this.content.length - 1] = s.withText(s.text.slice(0, s.text.length - i[0].length));
      }
    }
    let t = Ee.from(this.content);
    return !e && this.match && (t = t.append(this.match.fillBefore(Ee.empty, !0))), this.type ? this.type.create(this.attrs, t, this.marks) : t;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !$ie.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
let CU = class {
  constructor(e, t, r) {
    this.parser = e, this.options = t, this.isOpen = r, this.open = 0, this.localPreserveWS = !1;
    let i = t.topNode, s, o = SU(null, t.preserveWhitespace, 0) | (r ? tm : 0);
    i ? s = new Yg(i.type, i.attrs, xn.none, !0, t.topMatch || i.type.contentMatch, o) : r ? s = new Yg(null, null, xn.none, !0, null, o) : s = new Yg(e.schema.topNodeType, null, xn.none, !0, null, o), this.nodes = [s], this.find = t.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, t) {
    e.nodeType == 3 ? this.addTextNode(e, t) : e.nodeType == 1 && this.addElement(e, t);
  }
  addTextNode(e, t) {
    let r = e.nodeValue, i = this.top, s = i.options & W7 ? "full" : this.localPreserveWS || (i.options & P0) > 0, { schema: o } = this.parser;
    if (s === "full" || i.inlineContext(e) || /[^ \t\r\n\u000c]/.test(r)) {
      if (s)
        if (s === "full")
          r = r.replace(/\r\n?/g, `
`);
        else if (o.linebreakReplacement && /[\r\n]/.test(r) && this.top.findWrapping(o.linebreakReplacement.create())) {
          let a = r.split(/\r?\n|\r/);
          for (let l = 0; l < a.length; l++)
            l && this.insertNode(o.linebreakReplacement.create(), t, !0), a[l] && this.insertNode(o.text(a[l]), t, !/\S/.test(a[l]));
          r = "";
        } else
          r = r.replace(/\r?\n|\r/g, " ");
      else if (r = r.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(r) && this.open == this.nodes.length - 1) {
        let a = i.content[i.content.length - 1], l = e.previousSibling;
        (!a || l && l.nodeName == "BR" || a.isText && /[ \t\r\n\u000c]$/.test(a.text)) && (r = r.slice(1));
      }
      r && this.insertNode(o.text(r), t, !/\S/.test(r)), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, t, r) {
    let i = this.localPreserveWS, s = this.top;
    (e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
    let o = e.nodeName.toLowerCase(), a;
    Fie.hasOwnProperty(o) && this.parser.normalizeLists && nrt(e);
    let l = this.options.ruleFromNode && this.options.ruleFromNode(e) || (a = this.parser.matchTag(e, this, r));
    e: if (l ? l.ignore : trt.hasOwnProperty(o))
      this.findInside(e), this.ignoreFallback(e, t);
    else if (!l || l.skip || l.closeParent) {
      l && l.closeParent ? this.open = Math.max(0, this.open - 1) : l && l.skip.nodeType && (e = l.skip);
      let c, u = this.needsBlock;
      if ($ie.hasOwnProperty(o))
        s.content.length && s.content[0].isInline && this.open && (this.open--, s = this.top), c = !0, s.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e, t);
        break e;
      }
      let d = l && l.skip ? t : this.readStyles(e, t);
      d && this.addAll(e, d), c && this.sync(s), this.needsBlock = u;
    } else {
      let c = this.readStyles(e, t);
      c && this.addElementByRule(e, l, c, l.consuming === !1 ? a : void 0);
    }
    this.localPreserveWS = i;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, t) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), t);
  }
  // Called for ignored nodes
  ignoreFallback(e, t) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), t, !0);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, t) {
    let r = e.style;
    if (r && r.length)
      for (let i = 0; i < this.parser.matchedStyles.length; i++) {
        let s = this.parser.matchedStyles[i], o = r.getPropertyValue(s);
        if (o)
          for (let a = void 0; ; ) {
            let l = this.parser.matchStyle(s, o, this, a);
            if (!l)
              break;
            if (l.ignore)
              return null;
            if (l.clearMark ? t = t.filter((c) => !l.clearMark(c)) : t = t.concat(this.parser.schema.marks[l.mark].create(l.attrs)), l.consuming === !1)
              a = l;
            else
              break;
          }
      }
    return t;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, t, r, i) {
    let s, o;
    if (t.node)
      if (o = this.parser.schema.nodes[t.node], o.isLeaf)
        this.insertNode(o.create(t.attrs), r, e.nodeName == "BR") || this.leafFallback(e, r);
      else {
        let l = this.enter(o, t.attrs || null, r, t.preserveWhitespace);
        l && (s = !0, r = l);
      }
    else {
      let l = this.parser.schema.marks[t.mark];
      r = r.concat(l.create(t.attrs));
    }
    let a = this.top;
    if (o && o.isLeaf)
      this.findInside(e);
    else if (i)
      this.addElement(e, r, i);
    else if (t.getContent)
      this.findInside(e), t.getContent(e, this.parser.schema).forEach((l) => this.insertNode(l, r, !1));
    else {
      let l = e;
      typeof t.contentElement == "string" ? l = e.querySelector(t.contentElement) : typeof t.contentElement == "function" ? l = t.contentElement(e) : t.contentElement && (l = t.contentElement), this.findAround(e, l, !0), this.addAll(l, r), this.findAround(e, l, !1);
    }
    s && this.sync(a) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, t, r, i) {
    let s = r || 0;
    for (let o = r ? e.childNodes[r] : e.firstChild, a = i == null ? null : e.childNodes[i]; o != a; o = o.nextSibling, ++s)
      this.findAtPoint(e, s), this.addDOM(o, t);
    this.findAtPoint(e, s);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, t, r) {
    let i, s;
    for (let o = this.open, a = 0; o >= 0; o--) {
      let l = this.nodes[o], c = l.findWrapping(e);
      if (c && (!i || i.length > c.length + a) && (i = c, s = l, !c.length))
        break;
      if (l.solid) {
        if (r)
          break;
        a += 2;
      }
    }
    if (!i)
      return null;
    this.sync(s);
    for (let o = 0; o < i.length; o++)
      t = this.enterInner(i[o], null, t, !1);
    return t;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, t, r) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let s = this.textblockFromContext();
      s && (t = this.enterInner(s, null, t));
    }
    let i = this.findPlace(e, t, r);
    if (i) {
      this.closeExtra();
      let s = this.top;
      s.match && (s.match = s.match.matchType(e.type));
      let o = xn.none;
      for (let a of i.concat(e.marks))
        (s.type ? s.type.allowsMarkType(a.type) : AU(a.type, e.type)) && (o = a.addToSet(o));
      return s.content.push(e.mark(o)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, t, r, i) {
    let s = this.findPlace(e.create(t), r, !1);
    return s && (s = this.enterInner(e, t, r, !0, i)), s;
  }
  // Open a node of the given type
  enterInner(e, t, r, i = !1, s) {
    this.closeExtra();
    let o = this.top;
    o.match = o.match && o.match.matchType(e);
    let a = SU(e, s, o.options);
    o.options & tm && o.content.length == 0 && (a |= tm);
    let l = xn.none;
    return r = r.filter((c) => (o.type ? o.type.allowsMarkType(c.type) : AU(c.type, e)) ? (l = c.addToSet(l), !1) : !0), this.nodes.push(new Yg(e, t, l, i, null, a)), this.open++, r;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let t = this.nodes.length - 1;
    if (t > this.open) {
      for (; t > this.open; t--)
        this.nodes[t - 1].content.push(this.nodes[t].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(e) {
    for (let t = this.open; t >= 0; t--) {
      if (this.nodes[t] == e)
        return this.open = t, !0;
      this.localPreserveWS && (this.nodes[t].options |= P0);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let t = this.open; t >= 0; t--) {
      let r = this.nodes[t].content;
      for (let i = r.length - 1; i >= 0; i--)
        e += r[i].nodeSize;
      t && e++;
    }
    return e;
  }
  findAtPoint(e, t) {
    if (this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].node == e && this.find[r].offset == t && (this.find[r].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].pos == null && e.nodeType == 1 && e.contains(this.find[t].node) && (this.find[t].pos = this.currentPos);
  }
  findAround(e, t, r) {
    if (e != t && this.find)
      for (let i = 0; i < this.find.length; i++)
        this.find[i].pos == null && e.nodeType == 1 && e.contains(this.find[i].node) && t.compareDocumentPosition(this.find[i].node) & (r ? 2 : 4) && (this.find[i].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let t = 0; t < this.find.length; t++)
        this.find[t].node == e && (this.find[t].pos = this.currentPos - (e.nodeValue.length - this.find[t].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let t = e.split("/"), r = this.options.context, i = !this.isOpen && (!r || r.parent.type == this.nodes[0].type), s = -(r ? r.depth + 1 : 0) + (i ? 0 : 1), o = (a, l) => {
      for (; a >= 0; a--) {
        let c = t[a];
        if (c == "") {
          if (a == t.length - 1 || a == 0)
            continue;
          for (; l >= s; l--)
            if (o(a - 1, l))
              return !0;
          return !1;
        } else {
          let u = l > 0 || l == 0 && i ? this.nodes[l].type : r && l >= s ? r.node(l - s).type : null;
          if (!u || u.name != c && !u.isInGroup(c))
            return !1;
          l--;
        }
      }
      return !0;
    };
    return o(t.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let t = e.depth; t >= 0; t--) {
        let r = e.node(t).contentMatchAt(e.indexAfter(t)).defaultType;
        if (r && r.isTextblock && r.defaultAttrs)
          return r;
      }
    for (let t in this.parser.schema.nodes) {
      let r = this.parser.schema.nodes[t];
      if (r.isTextblock && r.defaultAttrs)
        return r;
    }
  }
};
function nrt(n) {
  for (let e = n.firstChild, t = null; e; e = e.nextSibling) {
    let r = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    r && Fie.hasOwnProperty(r) && t ? (t.appendChild(e), e = t) : r == "li" ? t = e : r && (t = null);
  }
}
function rrt(n, e) {
  return (n.matches || n.msMatchesSelector || n.webkitMatchesSelector || n.mozMatchesSelector).call(n, e);
}
function TU(n) {
  let e = {};
  for (let t in n)
    e[t] = n[t];
  return e;
}
function AU(n, e) {
  let t = e.schema.nodes;
  for (let r in t) {
    let i = t[r];
    if (!i.allowsMarkType(n))
      continue;
    let s = [], o = (a) => {
      s.push(a);
      for (let l = 0; l < a.edgeCount; l++) {
        let { type: c, next: u } = a.edge(l);
        if (c == e || s.indexOf(u) < 0 && o(u))
          return !0;
      }
    };
    if (o(i.contentMatch))
      return !0;
  }
}
class fd {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, t) {
    this.nodes = e, this.marks = t;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, t = {}, r) {
    r || (r = Z6(t).createDocumentFragment());
    let i = r, s = [];
    return e.forEach((o) => {
      if (s.length || o.marks.length) {
        let a = 0, l = 0;
        for (; a < s.length && l < o.marks.length; ) {
          let c = o.marks[l];
          if (!this.marks[c.type.name]) {
            l++;
            continue;
          }
          if (!c.eq(s[a][0]) || c.type.spec.spanning === !1)
            break;
          a++, l++;
        }
        for (; a < s.length; )
          i = s.pop()[1];
        for (; l < o.marks.length; ) {
          let c = o.marks[l++], u = this.serializeMark(c, o.isInline, t);
          u && (s.push([c, i]), i.appendChild(u.dom), i = u.contentDOM || u.dom);
        }
      }
      i.appendChild(this.serializeNodeInner(o, t));
    }), r;
  }
  /**
  @internal
  */
  serializeNodeInner(e, t) {
    let { dom: r, contentDOM: i } = Zv(Z6(t), this.nodes[e.type.name](e), null, e.attrs);
    if (i) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, t, i);
    }
    return r;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, t = {}) {
    let r = this.serializeNodeInner(e, t);
    for (let i = e.marks.length - 1; i >= 0; i--) {
      let s = this.serializeMark(e.marks[i], e.isInline, t);
      s && ((s.contentDOM || s.dom).appendChild(r), r = s.dom);
    }
    return r;
  }
  /**
  @internal
  */
  serializeMark(e, t, r = {}) {
    let i = this.marks[e.type.name];
    return i && Zv(Z6(r), i(e, t), null, e.attrs);
  }
  static renderSpec(e, t, r = null, i) {
    return Zv(e, t, r, i);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new fd(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let t = MU(e.nodes);
    return t.text || (t.text = (r) => r.text), t;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return MU(e.marks);
  }
}
function MU(n) {
  let e = {};
  for (let t in n) {
    let r = n[t].spec.toDOM;
    r && (e[t] = r);
  }
  return e;
}
function Z6(n) {
  return n.document || window.document;
}
const kU = /* @__PURE__ */ new WeakMap();
function irt(n) {
  let e = kU.get(n);
  return e === void 0 && kU.set(n, e = srt(n)), e;
}
function srt(n) {
  let e = null;
  function t(r) {
    if (r && typeof r == "object")
      if (Array.isArray(r))
        if (typeof r[0] == "string")
          e || (e = []), e.push(r);
        else
          for (let i = 0; i < r.length; i++)
            t(r[i]);
      else
        for (let i in r)
          t(r[i]);
  }
  return t(n), e;
}
function Zv(n, e, t, r) {
  if (typeof e == "string")
    return { dom: n.createTextNode(e) };
  if (e.nodeType != null)
    return { dom: e };
  if (e.dom && e.dom.nodeType != null)
    return e;
  let i = e[0], s;
  if (typeof i != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (r && (s = irt(r)) && s.indexOf(e) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let o = i.indexOf(" ");
  o > 0 && (t = i.slice(0, o), i = i.slice(o + 1));
  let a, l = t ? n.createElementNS(t, i) : n.createElement(i), c = e[1], u = 1;
  if (c && typeof c == "object" && c.nodeType == null && !Array.isArray(c)) {
    u = 2;
    for (let d in c)
      if (c[d] != null) {
        let f = d.indexOf(" ");
        f > 0 ? l.setAttributeNS(d.slice(0, f), d.slice(f + 1), c[d]) : d == "style" && l.style ? l.style.cssText = c[d] : l.setAttribute(d, c[d]);
      }
  }
  for (let d = u; d < e.length; d++) {
    let f = e[d];
    if (f === 0) {
      if (d < e.length - 1 || d > u)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: l, contentDOM: l };
    } else {
      let { dom: h, contentDOM: m } = Zv(n, f, t, r);
      if (l.appendChild(h), m) {
        if (a)
          throw new RangeError("Multiple content holes");
        a = m;
      }
    }
  }
  return { dom: l, contentDOM: a };
}
const Bie = 65535, zie = Math.pow(2, 16);
function ort(n, e) {
  return n + e * zie;
}
function _U(n) {
  return n & Bie;
}
function art(n) {
  return (n - (n & Bie)) / zie;
}
const Hie = 1, Uie = 2, Qv = 4, Vie = 8;
class G7 {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.pos = e, this.delInfo = t, this.recover = r;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & Vie) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (Hie | Qv)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (Uie | Qv)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & Qv) > 0;
  }
}
class hs {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, t = !1) {
    if (this.ranges = e, this.inverted = t, !e.length && hs.empty)
      return hs.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let t = 0, r = _U(e);
    if (!this.inverted)
      for (let i = 0; i < r; i++)
        t += this.ranges[i * 3 + 2] - this.ranges[i * 3 + 1];
    return this.ranges[r * 3] + t + art(e);
  }
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  map(e, t = 1) {
    return this._map(e, t, !0);
  }
  /**
  @internal
  */
  _map(e, t, r) {
    let i = 0, s = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let l = this.ranges[a] - (this.inverted ? i : 0);
      if (l > e)
        break;
      let c = this.ranges[a + s], u = this.ranges[a + o], d = l + c;
      if (e <= d) {
        let f = c ? e == l ? -1 : e == d ? 1 : t : t, h = l + i + (f < 0 ? 0 : u);
        if (r)
          return h;
        let m = e == (t < 0 ? l : d) ? null : ort(a / 3, e - l), g = e == l ? Uie : e == d ? Hie : Qv;
        return (t < 0 ? e != l : e != d) && (g |= Vie), new G7(h, g, m);
      }
      i += u - c;
    }
    return r ? e + i : new G7(e + i, 0, null);
  }
  /**
  @internal
  */
  touches(e, t) {
    let r = 0, i = _U(t), s = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let a = 0; a < this.ranges.length; a += 3) {
      let l = this.ranges[a] - (this.inverted ? r : 0);
      if (l > e)
        break;
      let c = this.ranges[a + s], u = l + c;
      if (e <= u && a == i * 3)
        return !0;
      r += this.ranges[a + o] - c;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let t = this.inverted ? 2 : 1, r = this.inverted ? 1 : 2;
    for (let i = 0, s = 0; i < this.ranges.length; i += 3) {
      let o = this.ranges[i], a = o - (this.inverted ? s : 0), l = o + (this.inverted ? 0 : s), c = this.ranges[i + t], u = this.ranges[i + r];
      e(a, a + c, l, l + u), s += u - c;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new hs(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? hs.empty : new hs(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
hs.empty = new hs([]);
class D0 {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e, t, r = 0, i = e ? e.length : 0) {
    this.mirror = t, this.from = r, this.to = i, this._maps = e || [], this.ownData = !(e || t);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, t = this.maps.length) {
    return new D0(this._maps, this.mirror, e, t);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, t) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(e), t != null && this.setMirror(this._maps.length - 1, t);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let t = 0, r = this._maps.length; t < e._maps.length; t++) {
      let i = e.getMirror(t);
      this.appendMap(e._maps[t], i != null && i < t ? r + i : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let t = 0; t < this.mirror.length; t++)
        if (this.mirror[t] == e)
          return this.mirror[t + (t % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, t) {
    this.mirror || (this.mirror = []), this.mirror.push(e, t);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let t = e.maps.length - 1, r = this._maps.length + e._maps.length; t >= 0; t--) {
      let i = e.getMirror(t);
      this.appendMap(e._maps[t].invert(), i != null && i > t ? r - i - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new D0();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, t = 1) {
    if (this.mirror)
      return this._map(e, t, !0);
    for (let r = this.from; r < this.to; r++)
      e = this._maps[r].map(e, t);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, t = 1) {
    return this._map(e, t, !1);
  }
  /**
  @internal
  */
  _map(e, t, r) {
    let i = 0;
    for (let s = this.from; s < this.to; s++) {
      let o = this._maps[s], a = o.mapResult(e, t);
      if (a.recover != null) {
        let l = this.getMirror(s);
        if (l != null && l > s && l < this.to) {
          s = l, e = this._maps[l].recover(a.recover);
          continue;
        }
      }
      i |= a.delInfo, e = a.pos;
    }
    return r ? e : new G7(e, i, null);
  }
}
const Q6 = /* @__PURE__ */ Object.create(null);
class li {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return hs.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, t) {
    if (!t || !t.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let r = Q6[t.stepType];
    if (!r)
      throw new RangeError(`No step type ${t.stepType} defined`);
    return r.fromJSON(e, t);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, t) {
    if (e in Q6)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return Q6[e] = t, t.prototype.jsonID = e, t;
  }
}
class or {
  /**
  @internal
  */
  constructor(e, t) {
    this.doc = e, this.failed = t;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new or(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new or(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, t, r, i) {
    try {
      return or.ok(e.replace(t, r, i));
    } catch (s) {
      if (s instanceof Qy)
        return or.fail(s.message);
      throw s;
    }
  }
}
function H_(n, e, t) {
  let r = [];
  for (let i = 0; i < n.childCount; i++) {
    let s = n.child(i);
    s.content.size && (s = s.copy(H_(s.content, e, s))), s.isInline && (s = e(s, t, i)), r.push(s);
  }
  return Ee.fromArray(r);
}
class Zl extends li {
  /**
  Create a mark step.
  */
  constructor(e, t, r) {
    super(), this.from = e, this.to = t, this.mark = r;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), r = e.resolve(this.from), i = r.node(r.sharedDepth(this.to)), s = new Fe(H_(t.content, (o, a) => !o.isAtom || !a.type.allowsMarkType(this.mark.type) ? o : o.mark(this.mark.addToSet(o.marks)), i), t.openStart, t.openEnd);
    return or.fromReplace(e, this.from, this.to, s);
  }
  invert() {
    return new ho(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deleted && r.deleted || t.pos >= r.pos ? null : new Zl(t.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof Zl && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Zl(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Zl(t.from, t.to, e.markFromJSON(t.mark));
  }
}
li.jsonID("addMark", Zl);
class ho extends li {
  /**
  Create a mark-removing step.
  */
  constructor(e, t, r) {
    super(), this.from = e, this.to = t, this.mark = r;
  }
  apply(e) {
    let t = e.slice(this.from, this.to), r = new Fe(H_(t.content, (i) => i.mark(this.mark.removeFromSet(i.marks)), e), t.openStart, t.openEnd);
    return or.fromReplace(e, this.from, this.to, r);
  }
  invert() {
    return new Zl(this.from, this.to, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deleted && r.deleted || t.pos >= r.pos ? null : new ho(t.pos, r.pos, this.mark);
  }
  merge(e) {
    return e instanceof ho && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new ho(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new ho(t.from, t.to, e.markFromJSON(t.mark));
  }
}
li.jsonID("removeMark", ho);
class Ql extends li {
  /**
  Create a node mark step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return or.fail("No node at mark step's position");
    let r = t.type.create(t.attrs, null, this.mark.addToSet(t.marks));
    return or.fromReplace(e, this.pos, this.pos + 1, new Fe(Ee.from(r), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    if (t) {
      let r = this.mark.addToSet(t.marks);
      if (r.length == t.marks.length) {
        for (let i = 0; i < t.marks.length; i++)
          if (!t.marks[i].isInSet(r))
            return new Ql(this.pos, t.marks[i]);
        return new Ql(this.pos, this.mark);
      }
    }
    return new Uu(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Ql(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new Ql(t.pos, e.markFromJSON(t.mark));
  }
}
li.jsonID("addNodeMark", Ql);
class Uu extends li {
  /**
  Create a mark-removing step.
  */
  constructor(e, t) {
    super(), this.pos = e, this.mark = t;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return or.fail("No node at mark step's position");
    let r = t.type.create(t.attrs, null, this.mark.removeFromSet(t.marks));
    return or.fromReplace(e, this.pos, this.pos + 1, new Fe(Ee.from(r), 0, t.isLeaf ? 0 : 1));
  }
  invert(e) {
    let t = e.nodeAt(this.pos);
    return !t || !this.mark.isInSet(t.marks) ? this : new Ql(this.pos, this.mark);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new Uu(t.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new Uu(t.pos, e.markFromJSON(t.mark));
  }
}
li.jsonID("removeNodeMark", Uu);
class Er extends li {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, t, r, i = !1) {
    super(), this.from = e, this.to = t, this.slice = r, this.structure = i;
  }
  apply(e) {
    return this.structure && K7(e, this.from, this.to) ? or.fail("Structure replace would overwrite content") : or.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new hs([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new Er(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1);
    return t.deletedAcross && r.deletedAcross ? null : new Er(t.pos, Math.max(t.pos, r.pos), this.slice, this.structure);
  }
  merge(e) {
    if (!(e instanceof Er) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let t = this.slice.size + e.slice.size == 0 ? Fe.empty : new Fe(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new Er(this.from, this.to + (e.to - e.from), t, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let t = this.slice.size + e.slice.size == 0 ? Fe.empty : new Fe(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new Er(e.from, this.to, t, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new Er(t.from, t.to, Fe.fromJSON(e, t.slice), !!t.structure);
  }
}
li.jsonID("replace", Er);
class Or extends li {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, t, r, i, s, o, a = !1) {
    super(), this.from = e, this.to = t, this.gapFrom = r, this.gapTo = i, this.slice = s, this.insert = o, this.structure = a;
  }
  apply(e) {
    if (this.structure && (K7(e, this.from, this.gapFrom) || K7(e, this.gapTo, this.to)))
      return or.fail("Structure gap-replace would overwrite content");
    let t = e.slice(this.gapFrom, this.gapTo);
    if (t.openStart || t.openEnd)
      return or.fail("Gap is not a flat range");
    let r = this.slice.insertAt(this.insert, t.content);
    return r ? or.fromReplace(e, this.from, this.to, r) : or.fail("Content does not fit in gap");
  }
  getMap() {
    return new hs([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let t = this.gapTo - this.gapFrom;
    return new Or(this.from, this.from + this.slice.size + t, this.from + this.insert, this.from + this.insert + t, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let t = e.mapResult(this.from, 1), r = e.mapResult(this.to, -1), i = this.from == this.gapFrom ? t.pos : e.map(this.gapFrom, -1), s = this.to == this.gapTo ? r.pos : e.map(this.gapTo, 1);
    return t.deletedAcross && r.deletedAcross || i < t.pos || s > r.pos ? null : new Or(t.pos, r.pos, i, s, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.from != "number" || typeof t.to != "number" || typeof t.gapFrom != "number" || typeof t.gapTo != "number" || typeof t.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new Or(t.from, t.to, t.gapFrom, t.gapTo, Fe.fromJSON(e, t.slice), t.insert, !!t.structure);
  }
}
li.jsonID("replaceAround", Or);
function K7(n, e, t) {
  let r = n.resolve(e), i = t - e, s = r.depth;
  for (; i > 0 && s > 0 && r.indexAfter(s) == r.node(s).childCount; )
    s--, i--;
  if (i > 0) {
    let o = r.node(s).maybeChild(r.indexAfter(s));
    for (; i > 0; ) {
      if (!o || o.isLeaf)
        return !0;
      o = o.firstChild, i--;
    }
  }
  return !1;
}
function lrt(n, e, t, r) {
  let i = [], s = [], o, a;
  n.doc.nodesBetween(e, t, (l, c, u) => {
    if (!l.isInline)
      return;
    let d = l.marks;
    if (!r.isInSet(d) && u.type.allowsMarkType(r.type)) {
      let f = Math.max(c, e), h = Math.min(c + l.nodeSize, t), m = r.addToSet(d);
      for (let g = 0; g < d.length; g++)
        d[g].isInSet(m) || (o && o.to == f && o.mark.eq(d[g]) ? o.to = h : i.push(o = new ho(f, h, d[g])));
      a && a.to == f ? a.to = h : s.push(a = new Zl(f, h, r));
    }
  }), i.forEach((l) => n.step(l)), s.forEach((l) => n.step(l));
}
function crt(n, e, t, r) {
  let i = [], s = 0;
  n.doc.nodesBetween(e, t, (o, a) => {
    if (!o.isInline)
      return;
    s++;
    let l = null;
    if (r instanceof J3) {
      let c = o.marks, u;
      for (; u = r.isInSet(c); )
        (l || (l = [])).push(u), c = u.removeFromSet(c);
    } else r ? r.isInSet(o.marks) && (l = [r]) : l = o.marks;
    if (l && l.length) {
      let c = Math.min(a + o.nodeSize, t);
      for (let u = 0; u < l.length; u++) {
        let d = l[u], f;
        for (let h = 0; h < i.length; h++) {
          let m = i[h];
          m.step == s - 1 && d.eq(i[h].style) && (f = m);
        }
        f ? (f.to = c, f.step = s) : i.push({ style: d, from: Math.max(a, e), to: c, step: s });
      }
    }
  }), i.forEach((o) => n.step(new ho(o.from, o.to, o.style)));
}
function U_(n, e, t, r = t.contentMatch, i = !0) {
  let s = n.doc.nodeAt(e), o = [], a = e + 1;
  for (let l = 0; l < s.childCount; l++) {
    let c = s.child(l), u = a + c.nodeSize, d = r.matchType(c.type);
    if (!d)
      o.push(new Er(a, u, Fe.empty));
    else {
      r = d;
      for (let f = 0; f < c.marks.length; f++)
        t.allowsMarkType(c.marks[f].type) || n.step(new ho(a, u, c.marks[f]));
      if (i && c.isText && t.whitespace != "pre") {
        let f, h = /\r?\n|\r/g, m;
        for (; f = h.exec(c.text); )
          m || (m = new Fe(Ee.from(t.schema.text(" ", t.allowedMarks(c.marks))), 0, 0)), o.push(new Er(a + f.index, a + f.index + f[0].length, m));
      }
    }
    a = u;
  }
  if (!r.validEnd) {
    let l = r.fillBefore(Ee.empty, !0);
    n.replace(a, a, new Fe(l, 0, 0));
  }
  for (let l = o.length - 1; l >= 0; l--)
    n.step(o[l]);
}
function urt(n, e, t) {
  return (e == 0 || n.canReplace(e, n.childCount)) && (t == n.childCount || n.canReplace(0, t));
}
function Uh(n) {
  let t = n.parent.content.cutByIndex(n.startIndex, n.endIndex);
  for (let r = n.depth; ; --r) {
    let i = n.$from.node(r), s = n.$from.index(r), o = n.$to.indexAfter(r);
    if (r < n.depth && i.canReplace(s, o, t))
      return r;
    if (r == 0 || i.type.spec.isolating || !urt(i, s, o))
      break;
  }
  return null;
}
function drt(n, e, t) {
  let { $from: r, $to: i, depth: s } = e, o = r.before(s + 1), a = i.after(s + 1), l = o, c = a, u = Ee.empty, d = 0;
  for (let m = s, g = !1; m > t; m--)
    g || r.index(m) > 0 ? (g = !0, u = Ee.from(r.node(m).copy(u)), d++) : l--;
  let f = Ee.empty, h = 0;
  for (let m = s, g = !1; m > t; m--)
    g || i.after(m + 1) < i.end(m) ? (g = !0, f = Ee.from(i.node(m).copy(f)), h++) : c++;
  n.step(new Or(l, c, o, a, new Fe(u.append(f), d, h), u.size - d, !0));
}
function V_(n, e, t = null, r = n) {
  let i = frt(n, e), s = i && hrt(r, e);
  return s ? i.map(OU).concat({ type: e, attrs: t }).concat(s.map(OU)) : null;
}
function OU(n) {
  return { type: n, attrs: null };
}
function frt(n, e) {
  let { parent: t, startIndex: r, endIndex: i } = n, s = t.contentMatchAt(r).findWrapping(e);
  if (!s)
    return null;
  let o = s.length ? s[0] : e;
  return t.canReplaceWith(r, i, o) ? s : null;
}
function hrt(n, e) {
  let { parent: t, startIndex: r, endIndex: i } = n, s = t.child(r), o = e.contentMatch.findWrapping(s.type);
  if (!o)
    return null;
  let l = (o.length ? o[o.length - 1] : e).contentMatch;
  for (let c = r; l && c < i; c++)
    l = l.matchType(t.child(c).type);
  return !l || !l.validEnd ? null : o;
}
function prt(n, e, t) {
  let r = Ee.empty;
  for (let o = t.length - 1; o >= 0; o--) {
    if (r.size) {
      let a = t[o].type.contentMatch.matchFragment(r);
      if (!a || !a.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    r = Ee.from(t[o].type.create(t[o].attrs, r));
  }
  let i = e.start, s = e.end;
  n.step(new Or(i, s, i, s, new Fe(r, 0, 0), t.length, !0));
}
function mrt(n, e, t, r, i) {
  if (!r.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let s = n.steps.length;
  n.doc.nodesBetween(e, t, (o, a) => {
    let l = typeof i == "function" ? i(o) : i;
    if (o.isTextblock && !o.hasMarkup(r, l) && grt(n.doc, n.mapping.slice(s).map(a), r)) {
      let c = null;
      if (r.schema.linebreakReplacement) {
        let h = r.whitespace == "pre", m = !!r.contentMatch.matchType(r.schema.linebreakReplacement);
        h && !m ? c = !1 : !h && m && (c = !0);
      }
      c === !1 && Wie(n, o, a, s), U_(n, n.mapping.slice(s).map(a, 1), r, void 0, c === null);
      let u = n.mapping.slice(s), d = u.map(a, 1), f = u.map(a + o.nodeSize, 1);
      return n.step(new Or(d, f, d + 1, f - 1, new Fe(Ee.from(r.create(l, null, o.marks)), 0, 0), 1, !0)), c === !0 && jie(n, o, a, s), !1;
    }
  });
}
function jie(n, e, t, r) {
  e.forEach((i, s) => {
    if (i.isText) {
      let o, a = /\r?\n|\r/g;
      for (; o = a.exec(i.text); ) {
        let l = n.mapping.slice(r).map(t + 1 + s + o.index);
        n.replaceWith(l, l + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function Wie(n, e, t, r) {
  e.forEach((i, s) => {
    if (i.type == i.type.schema.linebreakReplacement) {
      let o = n.mapping.slice(r).map(t + 1 + s);
      n.replaceWith(o, o + 1, e.type.schema.text(`
`));
    }
  });
}
function grt(n, e, t) {
  let r = n.resolve(e), i = r.index();
  return r.parent.canReplaceWith(i, i + 1, t);
}
function vrt(n, e, t, r, i) {
  let s = n.doc.nodeAt(e);
  if (!s)
    throw new RangeError("No node at given position");
  t || (t = s.type);
  let o = t.create(r, null, i || s.marks);
  if (s.isLeaf)
    return n.replaceWith(e, e + s.nodeSize, o);
  if (!t.validContent(s.content))
    throw new RangeError("Invalid content for node type " + t.name);
  n.step(new Or(e, e + s.nodeSize, e + 1, e + s.nodeSize - 1, new Fe(Ee.from(o), 0, 0), 1, !0));
}
function ol(n, e, t = 1, r) {
  let i = n.resolve(e), s = i.depth - t, o = r && r[r.length - 1] || i.parent;
  if (s < 0 || i.parent.type.spec.isolating || !i.parent.canReplace(i.index(), i.parent.childCount) || !o.type.validContent(i.parent.content.cutByIndex(i.index(), i.parent.childCount)))
    return !1;
  for (let c = i.depth - 1, u = t - 2; c > s; c--, u--) {
    let d = i.node(c), f = i.index(c);
    if (d.type.spec.isolating)
      return !1;
    let h = d.content.cutByIndex(f, d.childCount), m = r && r[u + 1];
    m && (h = h.replaceChild(0, m.type.create(m.attrs)));
    let g = r && r[u] || d;
    if (!d.canReplace(f + 1, d.childCount) || !g.type.validContent(h))
      return !1;
  }
  let a = i.indexAfter(s), l = r && r[0];
  return i.node(s).canReplaceWith(a, a, l ? l.type : i.node(s + 1).type);
}
function yrt(n, e, t = 1, r) {
  let i = n.doc.resolve(e), s = Ee.empty, o = Ee.empty;
  for (let a = i.depth, l = i.depth - t, c = t - 1; a > l; a--, c--) {
    s = Ee.from(i.node(a).copy(s));
    let u = r && r[c];
    o = Ee.from(u ? u.type.create(u.attrs, o) : i.node(a).copy(o));
  }
  n.step(new Er(e, e, new Fe(s.append(o), t, t), !0));
}
function Dc(n, e) {
  let t = n.resolve(e), r = t.index();
  return Gie(t.nodeBefore, t.nodeAfter) && t.parent.canReplace(r, r + 1);
}
function brt(n, e) {
  e.content.size || n.type.compatibleContent(e.type);
  let t = n.contentMatchAt(n.childCount), { linebreakReplacement: r } = n.type.schema;
  for (let i = 0; i < e.childCount; i++) {
    let s = e.child(i), o = s.type == r ? n.type.schema.nodes.text : s.type;
    if (t = t.matchType(o), !t || !n.type.allowsMarks(s.marks))
      return !1;
  }
  return t.validEnd;
}
function Gie(n, e) {
  return !!(n && e && !n.isLeaf && brt(n, e));
}
function ex(n, e, t = -1) {
  let r = n.resolve(e);
  for (let i = r.depth; ; i--) {
    let s, o, a = r.index(i);
    if (i == r.depth ? (s = r.nodeBefore, o = r.nodeAfter) : t > 0 ? (s = r.node(i + 1), a++, o = r.node(i).maybeChild(a)) : (s = r.node(i).maybeChild(a - 1), o = r.node(i + 1)), s && !s.isTextblock && Gie(s, o) && r.node(i).canReplace(a, a + 1))
      return e;
    if (i == 0)
      break;
    e = t < 0 ? r.before(i) : r.after(i);
  }
}
function wrt(n, e, t) {
  let r = null, { linebreakReplacement: i } = n.doc.type.schema, s = n.doc.resolve(e - t), o = s.node().type;
  if (i && o.inlineContent) {
    let u = o.whitespace == "pre", d = !!o.contentMatch.matchType(i);
    u && !d ? r = !1 : !u && d && (r = !0);
  }
  let a = n.steps.length;
  if (r === !1) {
    let u = n.doc.resolve(e + t);
    Wie(n, u.node(), u.before(), a);
  }
  o.inlineContent && U_(n, e + t - 1, o, s.node().contentMatchAt(s.index()), r == null);
  let l = n.mapping.slice(a), c = l.map(e - t);
  if (n.step(new Er(c, l.map(e + t, -1), Fe.empty, !0)), r === !0) {
    let u = n.doc.resolve(c);
    jie(n, u.node(), u.before(), n.steps.length);
  }
  return n;
}
function xrt(n, e, t) {
  let r = n.resolve(e);
  if (r.parent.canReplaceWith(r.index(), r.index(), t))
    return e;
  if (r.parentOffset == 0)
    for (let i = r.depth - 1; i >= 0; i--) {
      let s = r.index(i);
      if (r.node(i).canReplaceWith(s, s, t))
        return r.before(i + 1);
      if (s > 0)
        return null;
    }
  if (r.parentOffset == r.parent.content.size)
    for (let i = r.depth - 1; i >= 0; i--) {
      let s = r.indexAfter(i);
      if (r.node(i).canReplaceWith(s, s, t))
        return r.after(i + 1);
      if (s < r.node(i).childCount)
        return null;
    }
  return null;
}
function Kie(n, e, t) {
  let r = n.resolve(e);
  if (!t.content.size)
    return e;
  let i = t.content;
  for (let s = 0; s < t.openStart; s++)
    i = i.firstChild.content;
  for (let s = 1; s <= (t.openStart == 0 && t.size ? 2 : 1); s++)
    for (let o = r.depth; o >= 0; o--) {
      let a = o == r.depth ? 0 : r.pos <= (r.start(o + 1) + r.end(o + 1)) / 2 ? -1 : 1, l = r.index(o) + (a > 0 ? 1 : 0), c = r.node(o), u = !1;
      if (s == 1)
        u = c.canReplace(l, l, i);
      else {
        let d = c.contentMatchAt(l).findWrapping(i.firstChild.type);
        u = d && c.canReplaceWith(l, l, d[0]);
      }
      if (u)
        return a == 0 ? r.pos : a < 0 ? r.before(o + 1) : r.after(o + 1);
    }
  return null;
}
function tx(n, e, t = e, r = Fe.empty) {
  if (e == t && !r.size)
    return null;
  let i = n.resolve(e), s = n.resolve(t);
  return qie(i, s, r) ? new Er(e, t, r) : new Ert(i, s, r).fit();
}
function qie(n, e, t) {
  return !t.openStart && !t.openEnd && n.start() == e.start() && n.parent.canReplace(n.index(), e.index(), t.content);
}
class Ert {
  constructor(e, t, r) {
    this.$from = e, this.$to = t, this.unplaced = r, this.frontier = [], this.placed = Ee.empty;
    for (let i = 0; i <= e.depth; i++) {
      let s = e.node(i);
      this.frontier.push({
        type: s.type,
        match: s.contentMatchAt(e.indexAfter(i))
      });
    }
    for (let i = e.depth; i > 0; i--)
      this.placed = Ee.from(e.node(i).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let c = this.findFittable();
      c ? this.placeNodes(c) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), t = this.placed.size - this.depth - this.$from.depth, r = this.$from, i = this.close(e < 0 ? this.$to : r.doc.resolve(e));
    if (!i)
      return null;
    let s = this.placed, o = r.depth, a = i.depth;
    for (; o && a && s.childCount == 1; )
      s = s.firstChild.content, o--, a--;
    let l = new Fe(s, o, a);
    return e > -1 ? new Or(r.pos, e, this.$to.pos, this.$to.end(), l, t) : l.size || r.pos != this.$to.pos ? new Er(r.pos, i.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let t = this.unplaced.content, r = 0, i = this.unplaced.openEnd; r < e; r++) {
      let s = t.firstChild;
      if (t.childCount > 1 && (i = 0), s.type.spec.isolating && i <= r) {
        e = r;
        break;
      }
      t = s.content;
    }
    for (let t = 1; t <= 2; t++)
      for (let r = t == 1 ? e : this.unplaced.openStart; r >= 0; r--) {
        let i, s = null;
        r ? (s = J6(this.unplaced.content, r - 1).firstChild, i = s.content) : i = this.unplaced.content;
        let o = i.firstChild;
        for (let a = this.depth; a >= 0; a--) {
          let { type: l, match: c } = this.frontier[a], u, d = null;
          if (t == 1 && (o ? c.matchType(o.type) || (d = c.fillBefore(Ee.from(o), !1)) : s && l.compatibleContent(s.type)))
            return { sliceDepth: r, frontierDepth: a, parent: s, inject: d };
          if (t == 2 && o && (u = c.findWrapping(o.type)))
            return { sliceDepth: r, frontierDepth: a, parent: s, wrap: u };
          if (s && c.matchType(s.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: t, openEnd: r } = this.unplaced, i = J6(e, t);
    return !i.childCount || i.firstChild.isLeaf ? !1 : (this.unplaced = new Fe(e, t + 1, Math.max(r, i.size + t >= e.size - r ? t + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: t, openEnd: r } = this.unplaced, i = J6(e, t);
    if (i.childCount <= 1 && t > 0) {
      let s = e.size - t <= t + i.size;
      this.unplaced = new Fe(Ip(e, t - 1, 1), t - 1, s ? t - 1 : r);
    } else
      this.unplaced = new Fe(Ip(e, t, 1), t, r);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: t, parent: r, inject: i, wrap: s }) {
    for (; this.depth > t; )
      this.closeFrontierNode();
    if (s)
      for (let g = 0; g < s.length; g++)
        this.openFrontierNode(s[g]);
    let o = this.unplaced, a = r ? r.content : o.content, l = o.openStart - e, c = 0, u = [], { match: d, type: f } = this.frontier[t];
    if (i) {
      for (let g = 0; g < i.childCount; g++)
        u.push(i.child(g));
      d = d.matchFragment(i);
    }
    let h = a.size + e - (o.content.size - o.openEnd);
    for (; c < a.childCount; ) {
      let g = a.child(c), v = d.matchType(g.type);
      if (!v)
        break;
      c++, (c > 1 || l == 0 || g.content.size) && (d = v, u.push(Yie(g.mark(f.allowedMarks(g.marks)), c == 1 ? l : 0, c == a.childCount ? h : -1)));
    }
    let m = c == a.childCount;
    m || (h = -1), this.placed = Rp(this.placed, t, Ee.from(u)), this.frontier[t].match = d, m && h < 0 && r && r.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let g = 0, v = a; g < h; g++) {
      let y = v.lastChild;
      this.frontier.push({ type: y.type, match: y.contentMatchAt(y.childCount) }), v = y.content;
    }
    this.unplaced = m ? e == 0 ? Fe.empty : new Fe(Ip(o.content, e - 1, 1), e - 1, h < 0 ? o.openEnd : e - 1) : new Fe(Ip(o.content, e, c), o.openStart, o.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], t;
    if (!e.type.isTextblock || !e8(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (t = this.findCloseLevel(this.$to)) && t.depth == this.depth)
      return -1;
    let { depth: r } = this.$to, i = this.$to.after(r);
    for (; r > 1 && i == this.$to.end(--r); )
      ++i;
    return i;
  }
  findCloseLevel(e) {
    e: for (let t = Math.min(this.depth, e.depth); t >= 0; t--) {
      let { match: r, type: i } = this.frontier[t], s = t < e.depth && e.end(t + 1) == e.pos + (e.depth - (t + 1)), o = e8(e, t, i, r, s);
      if (o) {
        for (let a = t - 1; a >= 0; a--) {
          let { match: l, type: c } = this.frontier[a], u = e8(e, a, c, l, !0);
          if (!u || u.childCount)
            continue e;
        }
        return { depth: t, fit: o, move: s ? e.doc.resolve(e.after(t + 1)) : e };
      }
    }
  }
  close(e) {
    let t = this.findCloseLevel(e);
    if (!t)
      return null;
    for (; this.depth > t.depth; )
      this.closeFrontierNode();
    t.fit.childCount && (this.placed = Rp(this.placed, t.depth, t.fit)), e = t.move;
    for (let r = t.depth + 1; r <= e.depth; r++) {
      let i = e.node(r), s = i.type.contentMatch.fillBefore(i.content, !0, e.index(r));
      this.openFrontierNode(i.type, i.attrs, s);
    }
    return e;
  }
  openFrontierNode(e, t = null, r) {
    let i = this.frontier[this.depth];
    i.match = i.match.matchType(e), this.placed = Rp(this.placed, this.depth, Ee.from(e.create(t, r))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let t = this.frontier.pop().match.fillBefore(Ee.empty, !0);
    t.childCount && (this.placed = Rp(this.placed, this.frontier.length, t));
  }
}
function Ip(n, e, t) {
  return e == 0 ? n.cutByIndex(t, n.childCount) : n.replaceChild(0, n.firstChild.copy(Ip(n.firstChild.content, e - 1, t)));
}
function Rp(n, e, t) {
  return e == 0 ? n.append(t) : n.replaceChild(n.childCount - 1, n.lastChild.copy(Rp(n.lastChild.content, e - 1, t)));
}
function J6(n, e) {
  for (let t = 0; t < e; t++)
    n = n.firstChild.content;
  return n;
}
function Yie(n, e, t) {
  if (e <= 0)
    return n;
  let r = n.content;
  return e > 1 && (r = r.replaceChild(0, Yie(r.firstChild, e - 1, r.childCount == 1 ? t - 1 : 0))), e > 0 && (r = n.type.contentMatch.fillBefore(r).append(r), t <= 0 && (r = r.append(n.type.contentMatch.matchFragment(r).fillBefore(Ee.empty, !0)))), n.copy(r);
}
function e8(n, e, t, r, i) {
  let s = n.node(e), o = i ? n.indexAfter(e) : n.index(e);
  if (o == s.childCount && !t.compatibleContent(s.type))
    return null;
  let a = r.fillBefore(s.content, !0, o);
  return a && !Srt(t, s.content, o) ? a : null;
}
function Srt(n, e, t) {
  for (let r = t; r < e.childCount; r++)
    if (!n.allowsMarks(e.child(r).marks))
      return !0;
  return !1;
}
function Crt(n) {
  return n.spec.defining || n.spec.definingForContent;
}
function Trt(n, e, t, r) {
  if (!r.size)
    return n.deleteRange(e, t);
  let i = n.doc.resolve(e), s = n.doc.resolve(t);
  if (qie(i, s, r))
    return n.step(new Er(e, t, r));
  let o = Zie(i, n.doc.resolve(t));
  o[o.length - 1] == 0 && o.pop();
  let a = -(i.depth + 1);
  o.unshift(a);
  for (let f = i.depth, h = i.pos - 1; f > 0; f--, h--) {
    let m = i.node(f).type.spec;
    if (m.defining || m.definingAsContext || m.isolating)
      break;
    o.indexOf(f) > -1 ? a = f : i.before(f) == h && o.splice(1, 0, -f);
  }
  let l = o.indexOf(a), c = [], u = r.openStart;
  for (let f = r.content, h = 0; ; h++) {
    let m = f.firstChild;
    if (c.push(m), h == r.openStart)
      break;
    f = m.content;
  }
  for (let f = u - 1; f >= 0; f--) {
    let h = c[f], m = Crt(h.type);
    if (m && !h.sameMarkup(i.node(Math.abs(a) - 1)))
      u = f;
    else if (m || !h.type.isTextblock)
      break;
  }
  for (let f = r.openStart; f >= 0; f--) {
    let h = (f + u + 1) % (r.openStart + 1), m = c[h];
    if (m)
      for (let g = 0; g < o.length; g++) {
        let v = o[(g + l) % o.length], y = !0;
        v < 0 && (y = !1, v = -v);
        let b = i.node(v - 1), x = i.index(v - 1);
        if (b.canReplaceWith(x, x, m.type, m.marks))
          return n.replace(i.before(v), y ? s.after(v) : t, new Fe(Xie(r.content, 0, r.openStart, h), h, r.openEnd));
      }
  }
  let d = n.steps.length;
  for (let f = o.length - 1; f >= 0 && (n.replace(e, t, r), !(n.steps.length > d)); f--) {
    let h = o[f];
    h < 0 || (e = i.before(h), t = s.after(h));
  }
}
function Xie(n, e, t, r, i) {
  if (e < t) {
    let s = n.firstChild;
    n = n.replaceChild(0, s.copy(Xie(s.content, e + 1, t, r, s)));
  }
  if (e > r) {
    let s = i.contentMatchAt(0), o = s.fillBefore(n).append(n);
    n = o.append(s.matchFragment(o).fillBefore(Ee.empty, !0));
  }
  return n;
}
function Art(n, e, t, r) {
  if (!r.isInline && e == t && n.doc.resolve(e).parent.content.size) {
    let i = xrt(n.doc, e, r.type);
    i != null && (e = t = i);
  }
  n.replaceRange(e, t, new Fe(Ee.from(r), 0, 0));
}
function Mrt(n, e, t) {
  let r = n.doc.resolve(e), i = n.doc.resolve(t), s = Zie(r, i);
  for (let o = 0; o < s.length; o++) {
    let a = s[o], l = o == s.length - 1;
    if (l && a == 0 || r.node(a).type.contentMatch.validEnd)
      return n.delete(r.start(a), i.end(a));
    if (a > 0 && (l || r.node(a - 1).canReplace(r.index(a - 1), i.indexAfter(a - 1))))
      return n.delete(r.before(a), i.after(a));
  }
  for (let o = 1; o <= r.depth && o <= i.depth; o++)
    if (e - r.start(o) == r.depth - o && t > r.end(o) && i.end(o) - t != i.depth - o && r.start(o - 1) == i.start(o - 1) && r.node(o - 1).canReplace(r.index(o - 1), i.index(o - 1)))
      return n.delete(r.before(o), t);
  n.delete(e, t);
}
function Zie(n, e) {
  let t = [], r = Math.min(n.depth, e.depth);
  for (let i = r; i >= 0; i--) {
    let s = n.start(i);
    if (s < n.pos - (n.depth - i) || e.end(i) > e.pos + (e.depth - i) || n.node(i).type.spec.isolating || e.node(i).type.spec.isolating)
      break;
    (s == e.start(i) || i == n.depth && i == e.depth && n.parent.inlineContent && e.parent.inlineContent && i && e.start(i - 1) == s - 1) && t.push(i);
  }
  return t;
}
class mf extends li {
  /**
  Construct an attribute step.
  */
  constructor(e, t, r) {
    super(), this.pos = e, this.attr = t, this.value = r;
  }
  apply(e) {
    let t = e.nodeAt(this.pos);
    if (!t)
      return or.fail("No node at attribute step's position");
    let r = /* @__PURE__ */ Object.create(null);
    for (let s in t.attrs)
      r[s] = t.attrs[s];
    r[this.attr] = this.value;
    let i = t.type.create(r, null, t.marks);
    return or.fromReplace(e, this.pos, this.pos + 1, new Fe(Ee.from(i), 0, t.isLeaf ? 0 : 1));
  }
  getMap() {
    return hs.empty;
  }
  invert(e) {
    return new mf(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let t = e.mapResult(this.pos, 1);
    return t.deletedAfter ? null : new mf(t.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.pos != "number" || typeof t.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new mf(t.pos, t.attr, t.value);
  }
}
li.jsonID("attr", mf);
class N0 extends li {
  /**
  Construct an attribute step.
  */
  constructor(e, t) {
    super(), this.attr = e, this.value = t;
  }
  apply(e) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let i in e.attrs)
      t[i] = e.attrs[i];
    t[this.attr] = this.value;
    let r = e.type.create(t, e.content, e.marks);
    return or.ok(r);
  }
  getMap() {
    return hs.empty;
  }
  invert(e) {
    return new N0(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, t) {
    if (typeof t.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new N0(t.attr, t.value);
  }
}
li.jsonID("docAttr", N0);
let rh = class extends Error {
};
rh = function n(e) {
  let t = Error.call(this, e);
  return t.__proto__ = n.prototype, t;
};
rh.prototype = Object.create(Error.prototype);
rh.prototype.constructor = rh;
rh.prototype.name = "TransformError";
class Qie {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new D0();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let t = this.maybeStep(e);
    if (t.failed)
      throw new rh(t.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let t = e.apply(this.doc);
    return t.failed || this.addStep(e, t.doc), t;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = t;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, t = e, r = Fe.empty) {
    let i = tx(this.doc, e, t, r);
    return i && this.step(i), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, t, r) {
    return this.replace(e, t, new Fe(Ee.from(r), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, t) {
    return this.replace(e, t, Fe.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, t) {
    return this.replaceWith(e, e, t);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, t, r) {
    return Trt(this, e, t, r), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, t, r) {
    return Art(this, e, t, r), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, t) {
    return Mrt(this, e, t), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, t) {
    return drt(this, e, t), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, t = 1) {
    return wrt(this, e, t), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, t) {
    return prt(this, e, t), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, t = e, r, i = null) {
    return mrt(this, e, t, r, i), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, t, r = null, i) {
    return vrt(this, e, t, r, i), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, t, r) {
    return this.step(new mf(e, t, r)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, t) {
    return this.step(new N0(e, t)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, t) {
    return this.step(new Ql(e, t)), this;
  }
  /**
  Remove a mark (or all marks of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, t) {
    let r = this.doc.nodeAt(e);
    if (!r)
      throw new RangeError("No node at position " + e);
    if (t instanceof xn)
      t.isInSet(r.marks) && this.step(new Uu(e, t));
    else {
      let i = r.marks, s, o = [];
      for (; s = t.isInSet(i); )
        o.push(new Uu(e, s)), i = s.removeFromSet(i);
      for (let a = o.length - 1; a >= 0; a--)
        this.step(o[a]);
    }
    return this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(e, t = 1, r) {
    return yrt(this, e, t, r), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, t, r) {
    return lrt(this, e, t, r), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, t, r) {
    return crt(this, e, t, r), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, t, r) {
    return U_(this, e, t, r), this;
  }
}
const t8 = /* @__PURE__ */ Object.create(null);
let pt = class {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, t, r) {
    this.$anchor = e, this.$head = t, this.ranges = r || [new Jie(e.min(t), e.max(t))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let t = 0; t < e.length; t++)
      if (e[t].$from.pos != e[t].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, t = Fe.empty) {
    let r = t.content.lastChild, i = null;
    for (let a = 0; a < t.openEnd; a++)
      i = r, r = r.lastChild;
    let s = e.steps.length, o = this.ranges;
    for (let a = 0; a < o.length; a++) {
      let { $from: l, $to: c } = o[a], u = e.mapping.slice(s);
      e.replaceRange(u.map(l.pos), u.map(c.pos), a ? Fe.empty : t), a == 0 && PU(e, s, (r ? r.isInline : i && i.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, t) {
    let r = e.steps.length, i = this.ranges;
    for (let s = 0; s < i.length; s++) {
      let { $from: o, $to: a } = i[s], l = e.mapping.slice(r), c = l.map(o.pos), u = l.map(a.pos);
      s ? e.deleteRange(c, u) : (e.replaceRangeWith(c, u, t), PU(e, r, t.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, t, r = !1) {
    let i = e.parent.inlineContent ? new vt(e) : $d(e.node(0), e.parent, e.pos, e.index(), t, r);
    if (i)
      return i;
    for (let s = e.depth - 1; s >= 0; s--) {
      let o = t < 0 ? $d(e.node(0), e.node(s), e.before(s + 1), e.index(s), t, r) : $d(e.node(0), e.node(s), e.after(s + 1), e.index(s) + 1, t, r);
      if (o)
        return o;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, t = 1) {
    return this.findFrom(e, t) || this.findFrom(e, -t) || new vs(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return $d(e, e, 0, 0, 1) || new vs(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return $d(e, e, e.content.size, e.childCount, -1) || new vs(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, t) {
    if (!t || !t.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let r = t8[t.type];
    if (!r)
      throw new RangeError(`No selection type ${t.type} defined`);
    return r.fromJSON(e, t);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, t) {
    if (e in t8)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return t8[e] = t, t.prototype.jsonID = e, t;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return vt.between(this.$anchor, this.$head).getBookmark();
  }
};
pt.prototype.visible = !0;
let Jie = class {
  /**
  Create a range.
  */
  constructor(e, t) {
    this.$from = e, this.$to = t;
  }
}, IU = !1;
function RU(n) {
  !IU && !n.parent.inlineContent && (IU = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + n.parent.type.name + ")"));
}
class vt extends pt {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, t = e) {
    RU(e), RU(t), super(e, t);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, t) {
    let r = e.resolve(t.map(this.head));
    if (!r.parent.inlineContent)
      return pt.near(r);
    let i = e.resolve(t.map(this.anchor));
    return new vt(i.parent.inlineContent ? i : r, r);
  }
  replace(e, t = Fe.empty) {
    if (super.replace(e, t), t == Fe.empty) {
      let r = this.$from.marksAcross(this.$to);
      r && e.ensureMarks(r);
    }
  }
  eq(e) {
    return e instanceof vt && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new nx(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number" || typeof t.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new vt(e.resolve(t.anchor), e.resolve(t.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, t, r = t) {
    let i = e.resolve(t);
    return new this(i, r == t ? i : e.resolve(r));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, t, r) {
    let i = e.pos - t.pos;
    if ((!r || i) && (r = i >= 0 ? 1 : -1), !t.parent.inlineContent) {
      let s = pt.findFrom(t, r, !0) || pt.findFrom(t, -r, !0);
      if (s)
        t = s.$head;
      else
        return pt.near(t, r);
    }
    return e.parent.inlineContent || (i == 0 ? e = t : (e = (pt.findFrom(e, -r, !0) || pt.findFrom(e, r, !0)).$anchor, e.pos < t.pos != i < 0 && (e = t))), new vt(e, t);
  }
}
pt.jsonID("text", vt);
class nx {
  constructor(e, t) {
    this.anchor = e, this.head = t;
  }
  map(e) {
    return new nx(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return vt.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class nt extends pt {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let t = e.nodeAfter, r = e.node(0).resolve(e.pos + t.nodeSize);
    super(e, r), this.node = t;
  }
  map(e, t) {
    let { deleted: r, pos: i } = t.mapResult(this.anchor), s = e.resolve(i);
    return r ? pt.near(s) : new nt(s);
  }
  content() {
    return new Fe(Ee.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof nt && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new j_(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new nt(e.resolve(t.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, t) {
    return new nt(e.resolve(t));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
nt.prototype.visible = !1;
pt.jsonID("node", nt);
class j_ {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: t, pos: r } = e.mapResult(this.anchor);
    return t ? new nx(r, r) : new j_(r);
  }
  resolve(e) {
    let t = e.resolve(this.anchor), r = t.nodeAfter;
    return r && nt.isSelectable(r) ? new nt(t) : pt.near(t);
  }
}
class vs extends pt {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, t = Fe.empty) {
    if (t == Fe.empty) {
      e.delete(0, e.doc.content.size);
      let r = pt.atStart(e.doc);
      r.eq(e.selection) || e.setSelection(r);
    } else
      super.replace(e, t);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new vs(e);
  }
  map(e) {
    return new vs(e);
  }
  eq(e) {
    return e instanceof vs;
  }
  getBookmark() {
    return krt;
  }
}
pt.jsonID("all", vs);
const krt = {
  map() {
    return this;
  },
  resolve(n) {
    return new vs(n);
  }
};
function $d(n, e, t, r, i, s = !1) {
  if (e.inlineContent)
    return vt.create(n, t);
  for (let o = r - (i > 0 ? 0 : 1); i > 0 ? o < e.childCount : o >= 0; o += i) {
    let a = e.child(o);
    if (a.isAtom) {
      if (!s && nt.isSelectable(a))
        return nt.create(n, t - (i < 0 ? a.nodeSize : 0));
    } else {
      let l = $d(n, a, t + i, i < 0 ? a.childCount : 0, i, s);
      if (l)
        return l;
    }
    t += a.nodeSize * i;
  }
  return null;
}
function PU(n, e, t) {
  let r = n.steps.length - 1;
  if (r < e)
    return;
  let i = n.steps[r];
  if (!(i instanceof Er || i instanceof Or))
    return;
  let s = n.mapping.maps[r], o;
  s.forEach((a, l, c, u) => {
    o == null && (o = u);
  }), n.setSelection(pt.near(n.doc.resolve(o), t));
}
const DU = 1, Xg = 2, NU = 4;
let _rt = class extends Qie {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | DU) & ~Xg, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & DU) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= Xg, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return xn.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & Xg) > 0;
  }
  /**
  @internal
  */
  addStep(e, t) {
    super.addStep(e, t), this.updated = this.updated & ~Xg, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, t = !0) {
    let r = this.selection;
    return t && (e = e.mark(this.storedMarks || (r.empty ? r.$from.marks() : r.$from.marksAcross(r.$to) || xn.none))), r.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, t, r) {
    let i = this.doc.type.schema;
    if (t == null)
      return e ? this.replaceSelectionWith(i.text(e), !0) : this.deleteSelection();
    {
      if (r == null && (r = t), !e)
        return this.deleteRange(t, r);
      let s = this.storedMarks;
      if (!s) {
        let o = this.doc.resolve(t);
        s = r == t ? o.marks() : o.marksAcross(this.doc.resolve(r));
      }
      return this.replaceRangeWith(t, r, i.text(e, s)), !this.selection.empty && this.selection.to == t + e.length && this.setSelection(pt.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, t) {
    return this.meta[typeof e == "string" ? e : e.key] = t, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= NU, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & NU) > 0;
  }
};
function LU(n, e) {
  return !e || !n ? n : n.bind(e);
}
class Pp {
  constructor(e, t, r) {
    this.name = e, this.init = LU(t.init, r), this.apply = LU(t.apply, r);
  }
}
const Ort = [
  new Pp("doc", {
    init(n) {
      return n.doc || n.schema.topNodeType.createAndFill();
    },
    apply(n) {
      return n.doc;
    }
  }),
  new Pp("selection", {
    init(n, e) {
      return n.selection || pt.atStart(e.doc);
    },
    apply(n) {
      return n.selection;
    }
  }),
  new Pp("storedMarks", {
    init(n) {
      return n.storedMarks || null;
    },
    apply(n, e, t, r) {
      return r.selection.$cursor ? n.storedMarks : null;
    }
  }),
  new Pp("scrollToSelection", {
    init() {
      return 0;
    },
    apply(n, e) {
      return n.scrolledIntoView ? e + 1 : e;
    }
  })
];
let n8 = class {
  constructor(e, t) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = Ort.slice(), t && t.forEach((r) => {
      if (this.pluginsByKey[r.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + r.key + ")");
      this.plugins.push(r), this.pluginsByKey[r.key] = r, r.spec.state && this.fields.push(new Pp(r.key, r.spec.state, r));
    });
  }
}, Irt = class Dp {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, t = -1) {
    for (let r = 0; r < this.config.plugins.length; r++)
      if (r != t) {
        let i = this.config.plugins[r];
        if (i.spec.filterTransaction && !i.spec.filterTransaction.call(i, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let t = [e], r = this.applyInner(e), i = null;
    for (; ; ) {
      let s = !1;
      for (let o = 0; o < this.config.plugins.length; o++) {
        let a = this.config.plugins[o];
        if (a.spec.appendTransaction) {
          let l = i ? i[o].n : 0, c = i ? i[o].state : this, u = l < t.length && a.spec.appendTransaction.call(a, l ? t.slice(l) : t, c, r);
          if (u && r.filterTransaction(u, o)) {
            if (u.setMeta("appendedTransaction", e), !i) {
              i = [];
              for (let d = 0; d < this.config.plugins.length; d++)
                i.push(d < o ? { state: r, n: t.length } : { state: this, n: 0 });
            }
            t.push(u), r = r.applyInner(u), s = !0;
          }
          i && (i[o] = { state: r, n: t.length });
        }
      }
      if (!s)
        return { state: r, transactions: t };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let t = new Dp(this.config), r = this.config.fields;
    for (let i = 0; i < r.length; i++) {
      let s = r[i];
      t[s.name] = s.apply(e, this[s.name], this, t);
    }
    return t;
  }
  /**
  Accessor that constructs and returns a new [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new _rt(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let t = new n8(e.doc ? e.doc.type.schema : e.schema, e.plugins), r = new Dp(t);
    for (let i = 0; i < t.fields.length; i++)
      r[t.fields[i].name] = t.fields[i].init(e, r);
    return r;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let t = new n8(this.schema, e.plugins), r = t.fields, i = new Dp(t);
    for (let s = 0; s < r.length; s++) {
      let o = r[s].name;
      i[o] = this.hasOwnProperty(o) ? this[o] : r[s].init(e, i);
    }
    return i;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let t = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (t.storedMarks = this.storedMarks.map((r) => r.toJSON())), e && typeof e == "object")
      for (let r in e) {
        if (r == "doc" || r == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let i = e[r], s = i.spec.state;
        s && s.toJSON && (t[r] = s.toJSON.call(i, this[i.key]));
      }
    return t;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, t, r) {
    if (!t)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let i = new n8(e.schema, e.plugins), s = new Dp(i);
    return i.fields.forEach((o) => {
      if (o.name == "doc")
        s.doc = lc.fromJSON(e.schema, t.doc);
      else if (o.name == "selection")
        s.selection = pt.fromJSON(s.doc, t.selection);
      else if (o.name == "storedMarks")
        t.storedMarks && (s.storedMarks = t.storedMarks.map(e.schema.markFromJSON));
      else {
        if (r)
          for (let a in r) {
            let l = r[a], c = l.spec.state;
            if (l.key == o.name && c && c.fromJSON && Object.prototype.hasOwnProperty.call(t, a)) {
              s[o.name] = c.fromJSON.call(l, e, t[a], s);
              return;
            }
          }
        s[o.name] = o.init(e, s);
      }
    }), s;
  }
};
function ese(n, e, t) {
  for (let r in n) {
    let i = n[r];
    i instanceof Function ? i = i.bind(e) : r == "handleDOMEvents" && (i = ese(i, e, {})), t[r] = i;
  }
  return t;
}
class Cn {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && ese(e.props, this, this.props), this.key = e.key ? e.key.key : tse("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const r8 = /* @__PURE__ */ Object.create(null);
function tse(n) {
  return n in r8 ? n + "$" + ++r8[n] : (r8[n] = 0, n + "$");
}
class _n {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = tse(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const W_ = (n, e) => n.selection.empty ? !1 : (e && e(n.tr.deleteSelection().scrollIntoView()), !0);
function nse(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("backward", n) : t.parentOffset > 0) ? null : t;
}
const rse = (n, e, t) => {
  let r = nse(n, t);
  if (!r)
    return !1;
  let i = G_(r);
  if (!i) {
    let o = r.blockRange(), a = o && Uh(o);
    return a == null ? !1 : (e && e(n.tr.lift(o, a).scrollIntoView()), !0);
  }
  let s = i.nodeBefore;
  if (fse(n, i, e, -1))
    return !0;
  if (r.parent.content.size == 0 && (ih(s, "end") || nt.isSelectable(s)))
    for (let o = r.depth; ; o--) {
      let a = tx(n.doc, r.before(o), r.after(o), Fe.empty);
      if (a && a.slice.size < a.to - a.from) {
        if (e) {
          let l = n.tr.step(a);
          l.setSelection(ih(s, "end") ? pt.findFrom(l.doc.resolve(l.mapping.map(i.pos, -1)), -1) : nt.create(l.doc, i.pos - s.nodeSize)), e(l.scrollIntoView());
        }
        return !0;
      }
      if (o == 1 || r.node(o - 1).childCount > 1)
        break;
    }
  return s.isAtom && i.depth == r.depth - 1 ? (e && e(n.tr.delete(i.pos - s.nodeSize, i.pos).scrollIntoView()), !0) : !1;
}, Rrt = (n, e, t) => {
  let r = nse(n, t);
  if (!r)
    return !1;
  let i = G_(r);
  return i ? ise(n, i, e) : !1;
}, Prt = (n, e, t) => {
  let r = ose(n, t);
  if (!r)
    return !1;
  let i = K_(r);
  return i ? ise(n, i, e) : !1;
};
function ise(n, e, t) {
  let r = e.nodeBefore, i = r, s = e.pos - 1;
  for (; !i.isTextblock; s--) {
    if (i.type.spec.isolating)
      return !1;
    let u = i.lastChild;
    if (!u)
      return !1;
    i = u;
  }
  let o = e.nodeAfter, a = o, l = e.pos + 1;
  for (; !a.isTextblock; l++) {
    if (a.type.spec.isolating)
      return !1;
    let u = a.firstChild;
    if (!u)
      return !1;
    a = u;
  }
  let c = tx(n.doc, s, l, Fe.empty);
  if (!c || c.from != s || c instanceof Er && c.slice.size >= l - s)
    return !1;
  if (t) {
    let u = n.tr.step(c);
    u.setSelection(vt.create(u.doc, s)), t(u.scrollIntoView());
  }
  return !0;
}
function ih(n, e, t = !1) {
  for (let r = n; r; r = e == "start" ? r.firstChild : r.lastChild) {
    if (r.isTextblock)
      return !0;
    if (t && r.childCount != 1)
      return !1;
  }
  return !1;
}
const sse = (n, e, t) => {
  let { $head: r, empty: i } = n.selection, s = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (t ? !t.endOfTextblock("backward", n) : r.parentOffset > 0)
      return !1;
    s = G_(r);
  }
  let o = s && s.nodeBefore;
  return !o || !nt.isSelectable(o) ? !1 : (e && e(n.tr.setSelection(nt.create(n.doc, s.pos - o.nodeSize)).scrollIntoView()), !0);
};
function G_(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      if (n.index(e) > 0)
        return n.doc.resolve(n.before(e + 1));
      if (n.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function ose(n, e) {
  let { $cursor: t } = n.selection;
  return !t || (e ? !e.endOfTextblock("forward", n) : t.parentOffset < t.parent.content.size) ? null : t;
}
const ase = (n, e, t) => {
  let r = ose(n, t);
  if (!r)
    return !1;
  let i = K_(r);
  if (!i)
    return !1;
  let s = i.nodeAfter;
  if (fse(n, i, e, 1))
    return !0;
  if (r.parent.content.size == 0 && (ih(s, "start") || nt.isSelectable(s))) {
    let o = tx(n.doc, r.before(), r.after(), Fe.empty);
    if (o && o.slice.size < o.to - o.from) {
      if (e) {
        let a = n.tr.step(o);
        a.setSelection(ih(s, "start") ? pt.findFrom(a.doc.resolve(a.mapping.map(i.pos)), 1) : nt.create(a.doc, a.mapping.map(i.pos))), e(a.scrollIntoView());
      }
      return !0;
    }
  }
  return s.isAtom && i.depth == r.depth - 1 ? (e && e(n.tr.delete(i.pos, i.pos + s.nodeSize).scrollIntoView()), !0) : !1;
}, lse = (n, e, t) => {
  let { $head: r, empty: i } = n.selection, s = r;
  if (!i)
    return !1;
  if (r.parent.isTextblock) {
    if (t ? !t.endOfTextblock("forward", n) : r.parentOffset < r.parent.content.size)
      return !1;
    s = K_(r);
  }
  let o = s && s.nodeAfter;
  return !o || !nt.isSelectable(o) ? !1 : (e && e(n.tr.setSelection(nt.create(n.doc, s.pos)).scrollIntoView()), !0);
};
function K_(n) {
  if (!n.parent.type.spec.isolating)
    for (let e = n.depth - 1; e >= 0; e--) {
      let t = n.node(e);
      if (n.index(e) + 1 < t.childCount)
        return n.doc.resolve(n.after(e + 1));
      if (t.type.spec.isolating)
        break;
    }
  return null;
}
const Drt = (n, e) => {
  let t = n.selection, r = t instanceof nt, i;
  if (r) {
    if (t.node.isTextblock || !Dc(n.doc, t.from))
      return !1;
    i = t.from;
  } else if (i = ex(n.doc, t.from, -1), i == null)
    return !1;
  if (e) {
    let s = n.tr.join(i);
    r && s.setSelection(nt.create(s.doc, i - n.doc.resolve(i).nodeBefore.nodeSize)), e(s.scrollIntoView());
  }
  return !0;
}, Nrt = (n, e) => {
  let t = n.selection, r;
  if (t instanceof nt) {
    if (t.node.isTextblock || !Dc(n.doc, t.to))
      return !1;
    r = t.to;
  } else if (r = ex(n.doc, t.to, 1), r == null)
    return !1;
  return e && e(n.tr.join(r).scrollIntoView()), !0;
}, Lrt = (n, e) => {
  let { $from: t, $to: r } = n.selection, i = t.blockRange(r), s = i && Uh(i);
  return s == null ? !1 : (e && e(n.tr.lift(i, s).scrollIntoView()), !0);
}, cse = (n, e) => {
  let { $head: t, $anchor: r } = n.selection;
  return !t.parent.type.spec.code || !t.sameParent(r) ? !1 : (e && e(n.tr.insertText(`
`).scrollIntoView()), !0);
};
function q_(n) {
  for (let e = 0; e < n.edgeCount; e++) {
    let { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
const $rt = (n, e) => {
  let { $head: t, $anchor: r } = n.selection;
  if (!t.parent.type.spec.code || !t.sameParent(r))
    return !1;
  let i = t.node(-1), s = t.indexAfter(-1), o = q_(i.contentMatchAt(s));
  if (!o || !i.canReplaceWith(s, s, o))
    return !1;
  if (e) {
    let a = t.after(), l = n.tr.replaceWith(a, a, o.createAndFill());
    l.setSelection(pt.near(l.doc.resolve(a), 1)), e(l.scrollIntoView());
  }
  return !0;
}, use = (n, e) => {
  let t = n.selection, { $from: r, $to: i } = t;
  if (t instanceof vs || r.parent.inlineContent || i.parent.inlineContent)
    return !1;
  let s = q_(i.parent.contentMatchAt(i.indexAfter()));
  if (!s || !s.isTextblock)
    return !1;
  if (e) {
    let o = (!r.parentOffset && i.index() < i.parent.childCount ? r : i).pos, a = n.tr.insert(o, s.createAndFill());
    a.setSelection(vt.create(a.doc, o + 1)), e(a.scrollIntoView());
  }
  return !0;
}, dse = (n, e) => {
  let { $cursor: t } = n.selection;
  if (!t || t.parent.content.size)
    return !1;
  if (t.depth > 1 && t.after() != t.end(-1)) {
    let s = t.before();
    if (ol(n.doc, s))
      return e && e(n.tr.split(s).scrollIntoView()), !0;
  }
  let r = t.blockRange(), i = r && Uh(r);
  return i == null ? !1 : (e && e(n.tr.lift(r, i).scrollIntoView()), !0);
};
function Frt(n) {
  return (e, t) => {
    let { $from: r, $to: i } = e.selection;
    if (e.selection instanceof nt && e.selection.node.isBlock)
      return !r.parentOffset || !ol(e.doc, r.pos) ? !1 : (t && t(e.tr.split(r.pos).scrollIntoView()), !0);
    if (!r.depth)
      return !1;
    let s = [], o, a, l = !1, c = !1;
    for (let h = r.depth; ; h--)
      if (r.node(h).isBlock) {
        l = r.end(h) == r.pos + (r.depth - h), c = r.start(h) == r.pos - (r.depth - h), a = q_(r.node(h - 1).contentMatchAt(r.indexAfter(h - 1))), s.unshift(l && a ? { type: a } : null), o = h;
        break;
      } else {
        if (h == 1)
          return !1;
        s.unshift(null);
      }
    let u = e.tr;
    (e.selection instanceof vt || e.selection instanceof vs) && u.deleteSelection();
    let d = u.mapping.map(r.pos), f = ol(u.doc, d, s.length, s);
    if (f || (s[0] = a ? { type: a } : null, f = ol(u.doc, d, s.length, s)), !f)
      return !1;
    if (u.split(d, s.length, s), !l && c && r.node(o).type != a) {
      let h = u.mapping.map(r.before(o)), m = u.doc.resolve(h);
      a && r.node(o - 1).canReplaceWith(m.index(), m.index() + 1, a) && u.setNodeMarkup(u.mapping.map(r.before(o)), a);
    }
    return t && t(u.scrollIntoView()), !0;
  };
}
const Brt = Frt(), zrt = (n, e) => {
  let { $from: t, to: r } = n.selection, i, s = t.sharedDepth(r);
  return s == 0 ? !1 : (i = t.before(s), e && e(n.tr.setSelection(nt.create(n.doc, i))), !0);
};
function Hrt(n, e, t) {
  let r = e.nodeBefore, i = e.nodeAfter, s = e.index();
  return !r || !i || !r.type.compatibleContent(i.type) ? !1 : !r.content.size && e.parent.canReplace(s - 1, s) ? (t && t(n.tr.delete(e.pos - r.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(s, s + 1) || !(i.isTextblock || Dc(n.doc, e.pos)) ? !1 : (t && t(n.tr.join(e.pos).scrollIntoView()), !0);
}
function fse(n, e, t, r) {
  let i = e.nodeBefore, s = e.nodeAfter, o, a, l = i.type.spec.isolating || s.type.spec.isolating;
  if (!l && Hrt(n, e, t))
    return !0;
  let c = !l && e.parent.canReplace(e.index(), e.index() + 1);
  if (c && (o = (a = i.contentMatchAt(i.childCount)).findWrapping(s.type)) && a.matchType(o[0] || s.type).validEnd) {
    if (t) {
      let h = e.pos + s.nodeSize, m = Ee.empty;
      for (let y = o.length - 1; y >= 0; y--)
        m = Ee.from(o[y].create(null, m));
      m = Ee.from(i.copy(m));
      let g = n.tr.step(new Or(e.pos - 1, h, e.pos, h, new Fe(m, 1, 0), o.length, !0)), v = g.doc.resolve(h + 2 * o.length);
      v.nodeAfter && v.nodeAfter.type == i.type && Dc(g.doc, v.pos) && g.join(v.pos), t(g.scrollIntoView());
    }
    return !0;
  }
  let u = s.type.spec.isolating || r > 0 && l ? null : pt.findFrom(e, 1), d = u && u.$from.blockRange(u.$to), f = d && Uh(d);
  if (f != null && f >= e.depth)
    return t && t(n.tr.lift(d, f).scrollIntoView()), !0;
  if (c && ih(s, "start", !0) && ih(i, "end")) {
    let h = i, m = [];
    for (; m.push(h), !h.isTextblock; )
      h = h.lastChild;
    let g = s, v = 1;
    for (; !g.isTextblock; g = g.firstChild)
      v++;
    if (h.canReplace(h.childCount, h.childCount, g.content)) {
      if (t) {
        let y = Ee.empty;
        for (let x = m.length - 1; x >= 0; x--)
          y = Ee.from(m[x].copy(y));
        let b = n.tr.step(new Or(e.pos - m.length, e.pos + s.nodeSize, e.pos + v, e.pos + s.nodeSize - v, new Fe(y, m.length, 0), 0, !0));
        t(b.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function hse(n) {
  return function(e, t) {
    let r = e.selection, i = n < 0 ? r.$from : r.$to, s = i.depth;
    for (; i.node(s).isInline; ) {
      if (!s)
        return !1;
      s--;
    }
    return i.node(s).isTextblock ? (t && t(e.tr.setSelection(vt.create(e.doc, n < 0 ? i.start(s) : i.end(s)))), !0) : !1;
  };
}
const Urt = hse(-1), Vrt = hse(1);
function jrt(n, e = null) {
  return function(t, r) {
    let { $from: i, $to: s } = t.selection, o = i.blockRange(s), a = o && V_(o, n, e);
    return a ? (r && r(t.tr.wrap(o, a).scrollIntoView()), !0) : !1;
  };
}
function $U(n, e = null) {
  return function(t, r) {
    let i = !1;
    for (let s = 0; s < t.selection.ranges.length && !i; s++) {
      let { $from: { pos: o }, $to: { pos: a } } = t.selection.ranges[s];
      t.doc.nodesBetween(o, a, (l, c) => {
        if (i)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(n, e)))
          if (l.type == n)
            i = !0;
          else {
            let u = t.doc.resolve(c), d = u.index();
            i = u.parent.canReplaceWith(d, d + 1, n);
          }
      });
    }
    if (!i)
      return !1;
    if (r) {
      let s = t.tr;
      for (let o = 0; o < t.selection.ranges.length; o++) {
        let { $from: { pos: a }, $to: { pos: l } } = t.selection.ranges[o];
        s.setBlockType(a, l, n, e);
      }
      r(s.scrollIntoView());
    }
    return !0;
  };
}
function Y_(...n) {
  return function(e, t, r) {
    for (let i = 0; i < n.length; i++)
      if (n[i](e, t, r))
        return !0;
    return !1;
  };
}
Y_(W_, rse, sse);
Y_(W_, ase, lse);
Y_(cse, use, dse, Brt);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function Wrt(n, e = null) {
  return function(t, r) {
    let { $from: i, $to: s } = t.selection, o = i.blockRange(s);
    if (!o)
      return !1;
    let a = r ? t.tr : null;
    return Grt(a, o, n, e) ? (r && r(a.scrollIntoView()), !0) : !1;
  };
}
function Grt(n, e, t, r = null) {
  let i = !1, s = e, o = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(t) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let l = o.resolve(e.start - 2);
    s = new eb(l, l, e.depth), e.endIndex < e.parent.childCount && (e = new eb(e.$from, o.resolve(e.$to.end(e.depth)), e.depth)), i = !0;
  }
  let a = V_(s, t, r, e);
  return a ? (n && Krt(n, e, a, i, t), !0) : !1;
}
function Krt(n, e, t, r, i) {
  let s = Ee.empty;
  for (let u = t.length - 1; u >= 0; u--)
    s = Ee.from(t[u].type.create(t[u].attrs, s));
  n.step(new Or(e.start - (r ? 2 : 0), e.end, e.start, e.end, new Fe(s, 0, 0), t.length, !0));
  let o = 0;
  for (let u = 0; u < t.length; u++)
    t[u].type == i && (o = u + 1);
  let a = t.length - o, l = e.start + t.length - (r ? 2 : 0), c = e.parent;
  for (let u = e.startIndex, d = e.endIndex, f = !0; u < d; u++, f = !1)
    !f && ol(n.doc, l, a) && (n.split(l, a), l += 2 * a), l += c.child(u).nodeSize;
  return n;
}
function qrt(n) {
  return function(e, t) {
    let { $from: r, $to: i } = e.selection, s = r.blockRange(i, (o) => o.childCount > 0 && o.firstChild.type == n);
    return s ? t ? r.node(s.depth - 1).type == n ? Yrt(e, t, n, s) : Xrt(e, t, s) : !0 : !1;
  };
}
function Yrt(n, e, t, r) {
  let i = n.tr, s = r.end, o = r.$to.end(r.depth);
  s < o && (i.step(new Or(s - 1, o, s, o, new Fe(Ee.from(t.create(null, r.parent.copy())), 1, 0), 1, !0)), r = new eb(i.doc.resolve(r.$from.pos), i.doc.resolve(o), r.depth));
  const a = Uh(r);
  if (a == null)
    return !1;
  i.lift(r, a);
  let l = i.doc.resolve(i.mapping.map(s, -1) - 1);
  return Dc(i.doc, l.pos) && l.nodeBefore.type == l.nodeAfter.type && i.join(l.pos), e(i.scrollIntoView()), !0;
}
function Xrt(n, e, t) {
  let r = n.tr, i = t.parent;
  for (let h = t.end, m = t.endIndex - 1, g = t.startIndex; m > g; m--)
    h -= i.child(m).nodeSize, r.delete(h - 1, h + 1);
  let s = r.doc.resolve(t.start), o = s.nodeAfter;
  if (r.mapping.map(t.end) != t.start + s.nodeAfter.nodeSize)
    return !1;
  let a = t.startIndex == 0, l = t.endIndex == i.childCount, c = s.node(-1), u = s.index(-1);
  if (!c.canReplace(u + (a ? 0 : 1), u + 1, o.content.append(l ? Ee.empty : Ee.from(i))))
    return !1;
  let d = s.pos, f = d + o.nodeSize;
  return r.step(new Or(d - (a ? 1 : 0), f + (l ? 1 : 0), d + 1, f - 1, new Fe((a ? Ee.empty : Ee.from(i.copy(Ee.empty))).append(l ? Ee.empty : Ee.from(i.copy(Ee.empty))), a ? 0 : 1, l ? 0 : 1), a ? 0 : 1)), e(r.scrollIntoView()), !0;
}
function Zrt(n) {
  return function(e, t) {
    let { $from: r, $to: i } = e.selection, s = r.blockRange(i, (c) => c.childCount > 0 && c.firstChild.type == n);
    if (!s)
      return !1;
    let o = s.startIndex;
    if (o == 0)
      return !1;
    let a = s.parent, l = a.child(o - 1);
    if (l.type != n)
      return !1;
    if (t) {
      let c = l.lastChild && l.lastChild.type == a.type, u = Ee.from(c ? n.create() : null), d = new Fe(Ee.from(n.create(null, Ee.from(a.type.create(null, u)))), c ? 3 : 1, 0), f = s.start, h = s.end;
      t(e.tr.step(new Or(f - (c ? 3 : 1), h, f, h, d, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
const Hr = function(n) {
  for (var e = 0; ; e++)
    if (n = n.previousSibling, !n)
      return e;
}, sh = function(n) {
  let e = n.assignedSlot || n.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let q7 = null;
const Ua = function(n, e, t) {
  let r = q7 || (q7 = document.createRange());
  return r.setEnd(n, t ?? n.nodeValue.length), r.setStart(n, e || 0), r;
}, Qrt = function() {
  q7 = null;
}, Vu = function(n, e, t, r) {
  return t && (FU(n, e, t, r, -1) || FU(n, e, t, r, 1));
}, Jrt = /^(img|br|input|textarea|hr)$/i;
function FU(n, e, t, r, i) {
  for (var s; ; ) {
    if (n == t && e == r)
      return !0;
    if (e == (i < 0 ? 0 : Rs(n))) {
      let o = n.parentNode;
      if (!o || o.nodeType != 1 || L1(n) || Jrt.test(n.nodeName) || n.contentEditable == "false")
        return !1;
      e = Hr(n) + (i < 0 ? 0 : 1), n = o;
    } else if (n.nodeType == 1) {
      let o = n.childNodes[e + (i < 0 ? -1 : 0)];
      if (o.nodeType == 1 && o.contentEditable == "false")
        if (!((s = o.pmViewDesc) === null || s === void 0) && s.ignoreForSelection)
          e += i;
        else
          return !1;
      else
        n = o, e = i < 0 ? Rs(n) : 0;
    } else
      return !1;
  }
}
function Rs(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function eit(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e)
      return n;
    if (n.nodeType == 1 && e > 0) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e - 1], e = Rs(n);
    } else if (n.parentNode && !L1(n))
      e = Hr(n), n = n.parentNode;
    else
      return null;
  }
}
function tit(n, e) {
  for (; ; ) {
    if (n.nodeType == 3 && e < n.nodeValue.length)
      return n;
    if (n.nodeType == 1 && e < n.childNodes.length) {
      if (n.contentEditable == "false")
        return null;
      n = n.childNodes[e], e = 0;
    } else if (n.parentNode && !L1(n))
      e = Hr(n) + 1, n = n.parentNode;
    else
      return null;
  }
}
function nit(n, e, t) {
  for (let r = e == 0, i = e == Rs(n); r || i; ) {
    if (n == t)
      return !0;
    let s = Hr(n);
    if (n = n.parentNode, !n)
      return !1;
    r = r && s == 0, i = i && s == Rs(n);
  }
}
function L1(n) {
  let e;
  for (let t = n; t && !(e = t.pmViewDesc); t = t.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == n || e.contentDOM == n);
}
const rx = function(n) {
  return n.focusNode && Vu(n.focusNode, n.focusOffset, n.anchorNode, n.anchorOffset);
};
function eu(n, e) {
  let t = document.createEvent("Event");
  return t.initEvent("keydown", !0, !0), t.keyCode = n, t.key = t.code = e, t;
}
function rit(n) {
  let e = n.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function iit(n, e, t) {
  if (n.caretPositionFromPoint)
    try {
      let r = n.caretPositionFromPoint(e, t);
      if (r)
        return { node: r.offsetNode, offset: Math.min(Rs(r.offsetNode), r.offset) };
    } catch {
    }
  if (n.caretRangeFromPoint) {
    let r = n.caretRangeFromPoint(e, t);
    if (r)
      return { node: r.startContainer, offset: Math.min(Rs(r.startContainer), r.startOffset) };
  }
}
const wa = typeof navigator < "u" ? navigator : null, BU = typeof document < "u" ? document : null, Nc = wa && wa.userAgent || "", Y7 = /Edge\/(\d+)/.exec(Nc), pse = /MSIE \d/.exec(Nc), X7 = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Nc), Vi = !!(pse || X7 || Y7), cc = pse ? document.documentMode : X7 ? +X7[1] : Y7 ? +Y7[1] : 0, Fs = !Vi && /gecko\/(\d+)/i.test(Nc);
Fs && +(/Firefox\/(\d+)/.exec(Nc) || [0, 0])[1];
const Z7 = !Vi && /Chrome\/(\d+)/.exec(Nc), oi = !!Z7, mse = Z7 ? +Z7[1] : 0, xi = !Vi && !!wa && /Apple Computer/.test(wa.vendor), oh = xi && (/Mobile\/\w+/.test(Nc) || !!wa && wa.maxTouchPoints > 2), ks = oh || (wa ? /Mac/.test(wa.platform) : !1), sit = wa ? /Win/.test(wa.platform) : !1, el = /Android \d/.test(Nc), $1 = !!BU && "webkitFontSmoothing" in BU.documentElement.style, oit = $1 ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function ait(n) {
  let e = n.defaultView && n.defaultView.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: n.documentElement.clientWidth,
    top: 0,
    bottom: n.documentElement.clientHeight
  };
}
function Na(n, e) {
  return typeof n == "number" ? n : n[e];
}
function lit(n) {
  let e = n.getBoundingClientRect(), t = e.width / n.offsetWidth || 1, r = e.height / n.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + n.clientWidth * t,
    top: e.top,
    bottom: e.top + n.clientHeight * r
  };
}
function zU(n, e, t) {
  let r = n.someProp("scrollThreshold") || 0, i = n.someProp("scrollMargin") || 5, s = n.dom.ownerDocument;
  for (let o = t || n.dom; o; ) {
    if (o.nodeType != 1) {
      o = sh(o);
      continue;
    }
    let a = o, l = a == s.body, c = l ? ait(s) : lit(a), u = 0, d = 0;
    if (e.top < c.top + Na(r, "top") ? d = -(c.top - e.top + Na(i, "top")) : e.bottom > c.bottom - Na(r, "bottom") && (d = e.bottom - e.top > c.bottom - c.top ? e.top + Na(i, "top") - c.top : e.bottom - c.bottom + Na(i, "bottom")), e.left < c.left + Na(r, "left") ? u = -(c.left - e.left + Na(i, "left")) : e.right > c.right - Na(r, "right") && (u = e.right - c.right + Na(i, "right")), u || d)
      if (l)
        s.defaultView.scrollBy(u, d);
      else {
        let h = a.scrollLeft, m = a.scrollTop;
        d && (a.scrollTop += d), u && (a.scrollLeft += u);
        let g = a.scrollLeft - h, v = a.scrollTop - m;
        e = { left: e.left - g, top: e.top - v, right: e.right - g, bottom: e.bottom - v };
      }
    let f = l ? "fixed" : getComputedStyle(o).position;
    if (/^(fixed|sticky)$/.test(f))
      break;
    o = f == "absolute" ? o.offsetParent : sh(o);
  }
}
function cit(n) {
  let e = n.dom.getBoundingClientRect(), t = Math.max(0, e.top), r, i;
  for (let s = (e.left + e.right) / 2, o = t + 1; o < Math.min(innerHeight, e.bottom); o += 5) {
    let a = n.root.elementFromPoint(s, o);
    if (!a || a == n.dom || !n.dom.contains(a))
      continue;
    let l = a.getBoundingClientRect();
    if (l.top >= t - 20) {
      r = a, i = l.top;
      break;
    }
  }
  return { refDOM: r, refTop: i, stack: gse(n.dom) };
}
function gse(n) {
  let e = [], t = n.ownerDocument;
  for (let r = n; r && (e.push({ dom: r, top: r.scrollTop, left: r.scrollLeft }), n != t); r = sh(r))
    ;
  return e;
}
function uit({ refDOM: n, refTop: e, stack: t }) {
  let r = n ? n.getBoundingClientRect().top : 0;
  vse(t, r == 0 ? 0 : r - e);
}
function vse(n, e) {
  for (let t = 0; t < n.length; t++) {
    let { dom: r, top: i, left: s } = n[t];
    r.scrollTop != i + e && (r.scrollTop = i + e), r.scrollLeft != s && (r.scrollLeft = s);
  }
}
let Id = null;
function dit(n) {
  if (n.setActive)
    return n.setActive();
  if (Id)
    return n.focus(Id);
  let e = gse(n);
  n.focus(Id == null ? {
    get preventScroll() {
      return Id = { preventScroll: !0 }, !0;
    }
  } : void 0), Id || (Id = !1, vse(e, 0));
}
function yse(n, e) {
  let t, r = 2e8, i, s = 0, o = e.top, a = e.top, l, c;
  for (let u = n.firstChild, d = 0; u; u = u.nextSibling, d++) {
    let f;
    if (u.nodeType == 1)
      f = u.getClientRects();
    else if (u.nodeType == 3)
      f = Ua(u).getClientRects();
    else
      continue;
    for (let h = 0; h < f.length; h++) {
      let m = f[h];
      if (m.top <= o && m.bottom >= a) {
        o = Math.max(m.bottom, o), a = Math.min(m.top, a);
        let g = m.left > e.left ? m.left - e.left : m.right < e.left ? e.left - m.right : 0;
        if (g < r) {
          t = u, r = g, i = g && t.nodeType == 3 ? {
            left: m.right < e.left ? m.right : m.left,
            top: e.top
          } : e, u.nodeType == 1 && g && (s = d + (e.left >= (m.left + m.right) / 2 ? 1 : 0));
          continue;
        }
      } else m.top > e.top && !l && m.left <= e.left && m.right >= e.left && (l = u, c = { left: Math.max(m.left, Math.min(m.right, e.left)), top: m.top });
      !t && (e.left >= m.right && e.top >= m.top || e.left >= m.left && e.top >= m.bottom) && (s = d + 1);
    }
  }
  return !t && l && (t = l, i = c, r = 0), t && t.nodeType == 3 ? fit(t, i) : !t || r && t.nodeType == 1 ? { node: n, offset: s } : yse(t, i);
}
function fit(n, e) {
  let t = n.nodeValue.length, r = document.createRange();
  for (let i = 0; i < t; i++) {
    r.setEnd(n, i + 1), r.setStart(n, i);
    let s = Ll(r, 1);
    if (s.top != s.bottom && X_(e, s))
      return { node: n, offset: i + (e.left >= (s.left + s.right) / 2 ? 1 : 0) };
  }
  return { node: n, offset: 0 };
}
function X_(n, e) {
  return n.left >= e.left - 1 && n.left <= e.right + 1 && n.top >= e.top - 1 && n.top <= e.bottom + 1;
}
function hit(n, e) {
  let t = n.parentNode;
  return t && /^li$/i.test(t.nodeName) && e.left < n.getBoundingClientRect().left ? t : n;
}
function pit(n, e, t) {
  let { node: r, offset: i } = yse(e, t), s = -1;
  if (r.nodeType == 1 && !r.firstChild) {
    let o = r.getBoundingClientRect();
    s = o.left != o.right && t.left > (o.left + o.right) / 2 ? 1 : -1;
  }
  return n.docView.posFromDOM(r, i, s);
}
function mit(n, e, t, r) {
  let i = -1;
  for (let s = e, o = !1; s != n.dom; ) {
    let a = n.docView.nearestDesc(s, !0), l;
    if (!a)
      return null;
    if (a.dom.nodeType == 1 && (a.node.isBlock && a.parent || !a.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((l = a.dom.getBoundingClientRect()).width || l.height) && (a.node.isBlock && a.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(a.dom.nodeName) && (!o && l.left > r.left || l.top > r.top ? i = a.posBefore : (!o && l.right < r.left || l.bottom < r.top) && (i = a.posAfter), o = !0), !a.contentDOM && i < 0 && !a.node.isText))
      return (a.node.isBlock ? r.top < (l.top + l.bottom) / 2 : r.left < (l.left + l.right) / 2) ? a.posBefore : a.posAfter;
    s = a.dom.parentNode;
  }
  return i > -1 ? i : n.docView.posFromDOM(e, t, -1);
}
function bse(n, e, t) {
  let r = n.childNodes.length;
  if (r && t.top < t.bottom)
    for (let i = Math.max(0, Math.min(r - 1, Math.floor(r * (e.top - t.top) / (t.bottom - t.top)) - 2)), s = i; ; ) {
      let o = n.childNodes[s];
      if (o.nodeType == 1) {
        let a = o.getClientRects();
        for (let l = 0; l < a.length; l++) {
          let c = a[l];
          if (X_(e, c))
            return bse(o, e, c);
        }
      }
      if ((s = (s + 1) % r) == i)
        break;
    }
  return n;
}
function git(n, e) {
  let t = n.dom.ownerDocument, r, i = 0, s = iit(t, e.left, e.top);
  s && ({ node: r, offset: i } = s);
  let o = (n.root.elementFromPoint ? n.root : t).elementFromPoint(e.left, e.top), a;
  if (!o || !n.dom.contains(o.nodeType != 1 ? o.parentNode : o)) {
    let c = n.dom.getBoundingClientRect();
    if (!X_(e, c) || (o = bse(n.dom, e, c), !o))
      return null;
  }
  if (xi)
    for (let c = o; r && c; c = sh(c))
      c.draggable && (r = void 0);
  if (o = hit(o, e), r) {
    if (Fs && r.nodeType == 1 && (i = Math.min(i, r.childNodes.length), i < r.childNodes.length)) {
      let u = r.childNodes[i], d;
      u.nodeName == "IMG" && (d = u.getBoundingClientRect()).right <= e.left && d.bottom > e.top && i++;
    }
    let c;
    $1 && i && r.nodeType == 1 && (c = r.childNodes[i - 1]).nodeType == 1 && c.contentEditable == "false" && c.getBoundingClientRect().top >= e.top && i--, r == n.dom && i == r.childNodes.length - 1 && r.lastChild.nodeType == 1 && e.top > r.lastChild.getBoundingClientRect().bottom ? a = n.state.doc.content.size : (i == 0 || r.nodeType != 1 || r.childNodes[i - 1].nodeName != "BR") && (a = mit(n, r, i, e));
  }
  a == null && (a = pit(n, o, e));
  let l = n.docView.nearestDesc(o, !0);
  return { pos: a, inside: l ? l.posAtStart - l.border : -1 };
}
function HU(n) {
  return n.top < n.bottom || n.left < n.right;
}
function Ll(n, e) {
  let t = n.getClientRects();
  if (t.length) {
    let r = t[e < 0 ? 0 : t.length - 1];
    if (HU(r))
      return r;
  }
  return Array.prototype.find.call(t, HU) || n.getBoundingClientRect();
}
const vit = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function wse(n, e, t) {
  let { node: r, offset: i, atom: s } = n.docView.domFromPos(e, t < 0 ? -1 : 1), o = $1 || Fs;
  if (r.nodeType == 3)
    if (o && (vit.test(r.nodeValue) || (t < 0 ? !i : i == r.nodeValue.length))) {
      let l = Ll(Ua(r, i, i), t);
      if (Fs && i && /\s/.test(r.nodeValue[i - 1]) && i < r.nodeValue.length) {
        let c = Ll(Ua(r, i - 1, i - 1), -1);
        if (c.top == l.top) {
          let u = Ll(Ua(r, i, i + 1), -1);
          if (u.top != l.top)
            return pp(u, u.left < c.left);
        }
      }
      return l;
    } else {
      let l = i, c = i, u = t < 0 ? 1 : -1;
      return t < 0 && !i ? (c++, u = -1) : t >= 0 && i == r.nodeValue.length ? (l--, u = 1) : t < 0 ? l-- : c++, pp(Ll(Ua(r, l, c), u), u < 0);
    }
  if (!n.state.doc.resolve(e - (s || 0)).parent.inlineContent) {
    if (s == null && i && (t < 0 || i == Rs(r))) {
      let l = r.childNodes[i - 1];
      if (l.nodeType == 1)
        return i8(l.getBoundingClientRect(), !1);
    }
    if (s == null && i < Rs(r)) {
      let l = r.childNodes[i];
      if (l.nodeType == 1)
        return i8(l.getBoundingClientRect(), !0);
    }
    return i8(r.getBoundingClientRect(), t >= 0);
  }
  if (s == null && i && (t < 0 || i == Rs(r))) {
    let l = r.childNodes[i - 1], c = l.nodeType == 3 ? Ua(l, Rs(l) - (o ? 0 : 1)) : l.nodeType == 1 && (l.nodeName != "BR" || !l.nextSibling) ? l : null;
    if (c)
      return pp(Ll(c, 1), !1);
  }
  if (s == null && i < Rs(r)) {
    let l = r.childNodes[i];
    for (; l.pmViewDesc && l.pmViewDesc.ignoreForCoords; )
      l = l.nextSibling;
    let c = l ? l.nodeType == 3 ? Ua(l, 0, o ? 0 : 1) : l.nodeType == 1 ? l : null : null;
    if (c)
      return pp(Ll(c, -1), !0);
  }
  return pp(Ll(r.nodeType == 3 ? Ua(r) : r, -t), t >= 0);
}
function pp(n, e) {
  if (n.width == 0)
    return n;
  let t = e ? n.left : n.right;
  return { top: n.top, bottom: n.bottom, left: t, right: t };
}
function i8(n, e) {
  if (n.height == 0)
    return n;
  let t = e ? n.top : n.bottom;
  return { top: t, bottom: t, left: n.left, right: n.right };
}
function xse(n, e, t) {
  let r = n.state, i = n.root.activeElement;
  r != e && n.updateState(e), i != n.dom && n.focus();
  try {
    return t();
  } finally {
    r != e && n.updateState(r), i != n.dom && i && i.focus();
  }
}
function yit(n, e, t) {
  let r = e.selection, i = t == "up" ? r.$from : r.$to;
  return xse(n, e, () => {
    let { node: s } = n.docView.domFromPos(i.pos, t == "up" ? -1 : 1);
    for (; ; ) {
      let a = n.docView.nearestDesc(s, !0);
      if (!a)
        break;
      if (a.node.isBlock) {
        s = a.contentDOM || a.dom;
        break;
      }
      s = a.dom.parentNode;
    }
    let o = wse(n, i.pos, 1);
    for (let a = s.firstChild; a; a = a.nextSibling) {
      let l;
      if (a.nodeType == 1)
        l = a.getClientRects();
      else if (a.nodeType == 3)
        l = Ua(a, 0, a.nodeValue.length).getClientRects();
      else
        continue;
      for (let c = 0; c < l.length; c++) {
        let u = l[c];
        if (u.bottom > u.top + 1 && (t == "up" ? o.top - u.top > (u.bottom - o.top) * 2 : u.bottom - o.bottom > (o.bottom - u.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const bit = /[\u0590-\u08ac]/;
function wit(n, e, t) {
  let { $head: r } = e.selection;
  if (!r.parent.isTextblock)
    return !1;
  let i = r.parentOffset, s = !i, o = i == r.parent.content.size, a = n.domSelection();
  return a ? !bit.test(r.parent.textContent) || !a.modify ? t == "left" || t == "backward" ? s : o : xse(n, e, () => {
    let { focusNode: l, focusOffset: c, anchorNode: u, anchorOffset: d } = n.domSelectionRange(), f = a.caretBidiLevel;
    a.modify("move", t, "character");
    let h = r.depth ? n.docView.domAfterPos(r.before()) : n.dom, { focusNode: m, focusOffset: g } = n.domSelectionRange(), v = m && !h.contains(m.nodeType == 1 ? m : m.parentNode) || l == m && c == g;
    try {
      a.collapse(u, d), l && (l != u || c != d) && a.extend && a.extend(l, c);
    } catch {
    }
    return f != null && (a.caretBidiLevel = f), v;
  }) : r.pos == r.start() || r.pos == r.end();
}
let UU = null, VU = null, jU = !1;
function xit(n, e, t) {
  return UU == e && VU == t ? jU : (UU = e, VU = t, jU = t == "up" || t == "down" ? yit(n, e, t) : wit(n, e, t));
}
const Bs = 0, WU = 1, du = 2, xa = 3;
class F1 {
  constructor(e, t, r, i) {
    this.parent = e, this.children = t, this.dom = r, this.contentDOM = i, this.dirty = Bs, r.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, t, r) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let t = 0; t < this.children.length; t++)
      e += this.children[t].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let t = 0, r = this.posAtStart; ; t++) {
      let i = this.children[t];
      if (i == e)
        return r;
      r += i.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, t, r) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (r < 0) {
        let s, o;
        if (e == this.contentDOM)
          s = e.childNodes[t - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          s = e.previousSibling;
        }
        for (; s && !((o = s.pmViewDesc) && o.parent == this); )
          s = s.previousSibling;
        return s ? this.posBeforeChild(o) + o.size : this.posAtStart;
      } else {
        let s, o;
        if (e == this.contentDOM)
          s = e.childNodes[t];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          s = e.nextSibling;
        }
        for (; s && !((o = s.pmViewDesc) && o.parent == this); )
          s = s.nextSibling;
        return s ? this.posBeforeChild(o) : this.posAtEnd;
      }
    let i;
    if (e == this.dom && this.contentDOM)
      i = t > Hr(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      i = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (t == 0)
        for (let s = e; ; s = s.parentNode) {
          if (s == this.dom) {
            i = !1;
            break;
          }
          if (s.previousSibling)
            break;
        }
      if (i == null && t == e.childNodes.length)
        for (let s = e; ; s = s.parentNode) {
          if (s == this.dom) {
            i = !0;
            break;
          }
          if (s.nextSibling)
            break;
        }
    }
    return i ?? r > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, t = !1) {
    for (let r = !0, i = e; i; i = i.parentNode) {
      let s = this.getDesc(i), o;
      if (s && (!t || s.node))
        if (r && (o = s.nodeDOM) && !(o.nodeType == 1 ? o.contains(e.nodeType == 1 ? e : e.parentNode) : o == e))
          r = !1;
        else
          return s;
    }
  }
  getDesc(e) {
    let t = e.pmViewDesc;
    for (let r = t; r; r = r.parent)
      if (r == this)
        return t;
  }
  posFromDOM(e, t, r) {
    for (let i = e; i; i = i.parentNode) {
      let s = this.getDesc(i);
      if (s)
        return s.localPosFromDOM(e, t, r);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let t = 0, r = 0; t < this.children.length; t++) {
      let i = this.children[t], s = r + i.size;
      if (r == e && s != r) {
        for (; !i.border && i.children.length; )
          for (let o = 0; o < i.children.length; o++) {
            let a = i.children[o];
            if (a.size) {
              i = a;
              break;
            }
          }
        return i;
      }
      if (e < s)
        return i.descAt(e - r - i.border);
      r = s;
    }
  }
  domFromPos(e, t) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let r = 0, i = 0;
    for (let s = 0; r < this.children.length; r++) {
      let o = this.children[r], a = s + o.size;
      if (a > e || o instanceof Sse) {
        i = e - s;
        break;
      }
      s = a;
    }
    if (i)
      return this.children[r].domFromPos(i - this.children[r].border, t);
    for (let s; r && !(s = this.children[r - 1]).size && s instanceof Ese && s.side >= 0; r--)
      ;
    if (t <= 0) {
      let s, o = !0;
      for (; s = r ? this.children[r - 1] : null, !(!s || s.dom.parentNode == this.contentDOM); r--, o = !1)
        ;
      return s && t && o && !s.border && !s.domAtom ? s.domFromPos(s.size, t) : { node: this.contentDOM, offset: s ? Hr(s.dom) + 1 : 0 };
    } else {
      let s, o = !0;
      for (; s = r < this.children.length ? this.children[r] : null, !(!s || s.dom.parentNode == this.contentDOM); r++, o = !1)
        ;
      return s && o && !s.border && !s.domAtom ? s.domFromPos(0, t) : { node: this.contentDOM, offset: s ? Hr(s.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, t, r = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: t, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let i = -1, s = -1;
    for (let o = r, a = 0; ; a++) {
      let l = this.children[a], c = o + l.size;
      if (i == -1 && e <= c) {
        let u = o + l.border;
        if (e >= u && t <= c - l.border && l.node && l.contentDOM && this.contentDOM.contains(l.contentDOM))
          return l.parseRange(e, t, u);
        e = o;
        for (let d = a; d > 0; d--) {
          let f = this.children[d - 1];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(1)) {
            i = Hr(f.dom) + 1;
            break;
          }
          e -= f.size;
        }
        i == -1 && (i = 0);
      }
      if (i > -1 && (c > t || a == this.children.length - 1)) {
        t = c;
        for (let u = a + 1; u < this.children.length; u++) {
          let d = this.children[u];
          if (d.size && d.dom.parentNode == this.contentDOM && !d.emptyChildAt(-1)) {
            s = Hr(d.dom);
            break;
          }
          t += d.size;
        }
        s == -1 && (s = this.contentDOM.childNodes.length);
        break;
      }
      o = c;
    }
    return { node: this.contentDOM, from: e, to: t, fromOffset: i, toOffset: s };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let t = this.children[e < 0 ? 0 : this.children.length - 1];
    return t.size == 0 || t.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: t, offset: r } = this.domFromPos(e, 0);
    if (t.nodeType != 1 || r == t.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return t.childNodes[r];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, t, r, i = !1) {
    let s = Math.min(e, t), o = Math.max(e, t);
    for (let h = 0, m = 0; h < this.children.length; h++) {
      let g = this.children[h], v = m + g.size;
      if (s > m && o < v)
        return g.setSelection(e - m - g.border, t - m - g.border, r, i);
      m = v;
    }
    let a = this.domFromPos(e, e ? -1 : 1), l = t == e ? a : this.domFromPos(t, t ? -1 : 1), c = r.root.getSelection(), u = r.domSelectionRange(), d = !1;
    if ((Fs || xi) && e == t) {
      let { node: h, offset: m } = a;
      if (h.nodeType == 3) {
        if (d = !!(m && h.nodeValue[m - 1] == `
`), d && m == h.nodeValue.length)
          for (let g = h, v; g; g = g.parentNode) {
            if (v = g.nextSibling) {
              v.nodeName == "BR" && (a = l = { node: v.parentNode, offset: Hr(v) + 1 });
              break;
            }
            let y = g.pmViewDesc;
            if (y && y.node && y.node.isBlock)
              break;
          }
      } else {
        let g = h.childNodes[m - 1];
        d = g && (g.nodeName == "BR" || g.contentEditable == "false");
      }
    }
    if (Fs && u.focusNode && u.focusNode != l.node && u.focusNode.nodeType == 1) {
      let h = u.focusNode.childNodes[u.focusOffset];
      h && h.contentEditable == "false" && (i = !0);
    }
    if (!(i || d && xi) && Vu(a.node, a.offset, u.anchorNode, u.anchorOffset) && Vu(l.node, l.offset, u.focusNode, u.focusOffset))
      return;
    let f = !1;
    if ((c.extend || e == t) && !(d && Fs)) {
      c.collapse(a.node, a.offset);
      try {
        e != t && c.extend(l.node, l.offset), f = !0;
      } catch {
      }
    }
    if (!f) {
      if (e > t) {
        let m = a;
        a = l, l = m;
      }
      let h = document.createRange();
      h.setEnd(l.node, l.offset), h.setStart(a.node, a.offset), c.removeAllRanges(), c.addRange(h);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, t) {
    for (let r = 0, i = 0; i < this.children.length; i++) {
      let s = this.children[i], o = r + s.size;
      if (r == o ? e <= o && t >= r : e < o && t > r) {
        let a = r + s.border, l = o - s.border;
        if (e >= a && t <= l) {
          this.dirty = e == r || t == o ? du : WU, e == a && t == l && (s.contentLost || s.dom.parentNode != this.contentDOM) ? s.dirty = xa : s.markDirty(e - a, t - a);
          return;
        } else
          s.dirty = s.dom == s.contentDOM && s.dom.parentNode == this.contentDOM && !s.children.length ? du : xa;
      }
      r = o;
    }
    this.dirty = du;
  }
  markParentsDirty() {
    let e = 1;
    for (let t = this.parent; t; t = t.parent, e++) {
      let r = e == 1 ? du : WU;
      t.dirty < r && (t.dirty = r);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  get ignoreForSelection() {
    return !1;
  }
  isText(e) {
    return !1;
  }
}
class Ese extends F1 {
  constructor(e, t, r, i) {
    let s, o = t.type.toDOM;
    if (typeof o == "function" && (o = o(r, () => {
      if (!s)
        return i;
      if (s.parent)
        return s.parent.posBeforeChild(s);
    })), !t.type.spec.raw) {
      if (o.nodeType != 1) {
        let a = document.createElement("span");
        a.appendChild(o), o = a;
      }
      o.contentEditable = "false", o.classList.add("ProseMirror-widget");
    }
    super(e, [], o, null), this.widget = t, this.widget = t, s = this;
  }
  matchesWidget(e) {
    return this.dirty == Bs && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let t = this.widget.spec.stopEvent;
    return t ? t(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get ignoreForSelection() {
    return !!this.widget.type.spec.relaxedSide;
  }
  get side() {
    return this.widget.type.side;
  }
}
class Eit extends F1 {
  constructor(e, t, r, i) {
    super(e, [], t, null), this.textDOM = r, this.text = i;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, t) {
    return e != this.textDOM ? this.posAtStart + (t ? this.size : 0) : this.posAtStart + t;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class ju extends F1 {
  constructor(e, t, r, i, s) {
    super(e, [], r, i), this.mark = t, this.spec = s;
  }
  static create(e, t, r, i) {
    let s = i.nodeViews[t.type.name], o = s && s(t, i, r);
    return (!o || !o.dom) && (o = fd.renderSpec(document, t.type.spec.toDOM(t, r), null, t.attrs)), new ju(e, t, o.dom, o.contentDOM || o.dom, o);
  }
  parseRule() {
    return this.dirty & xa || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != xa && this.mark.eq(e);
  }
  markDirty(e, t) {
    if (super.markDirty(e, t), this.dirty != Bs) {
      let r = this.parent;
      for (; !r.node; )
        r = r.parent;
      r.dirty < this.dirty && (r.dirty = this.dirty), this.dirty = Bs;
    }
  }
  slice(e, t, r) {
    let i = ju.create(this.parent, this.mark, !0, r), s = this.children, o = this.size;
    t < o && (s = J7(s, t, o, r)), e > 0 && (s = J7(s, 0, e, r));
    for (let a = 0; a < s.length; a++)
      s[a].parent = i;
    return i.children = s, i;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class uc extends F1 {
  constructor(e, t, r, i, s, o, a, l, c) {
    super(e, [], s, o), this.node = t, this.outerDeco = r, this.innerDeco = i, this.nodeDOM = a;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, t, r, i, s, o) {
    let a = s.nodeViews[t.type.name], l, c = a && a(t, s, () => {
      if (!l)
        return o;
      if (l.parent)
        return l.parent.posBeforeChild(l);
    }, r, i), u = c && c.dom, d = c && c.contentDOM;
    if (t.isText) {
      if (!u)
        u = document.createTextNode(t.text);
      else if (u.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else u || ({ dom: u, contentDOM: d } = fd.renderSpec(document, t.type.spec.toDOM(t), null, t.attrs));
    !d && !t.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), t.type.spec.draggable && (u.draggable = !0));
    let f = u;
    return u = Ase(u, r, t), c ? l = new Sit(e, t, r, i, u, d || null, f, c, s, o + 1) : t.isText ? new ix(e, t, r, i, u, f, s) : new uc(e, t, r, i, u, d || null, f, s, o + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let t = this.children.length - 1; t >= 0; t--) {
        let r = this.children[t];
        if (this.dom.contains(r.dom.parentNode)) {
          e.contentElement = r.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => Ee.empty);
    }
    return e;
  }
  matchesNode(e, t, r) {
    return this.dirty == Bs && e.eq(this.node) && tb(t, this.outerDeco) && r.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, t) {
    let r = this.node.inlineContent, i = t, s = e.composing ? this.localCompositionInfo(e, t) : null, o = s && s.pos > -1 ? s : null, a = s && s.pos < 0, l = new Tit(this, o && o.node, e);
    kit(this.node, this.innerDeco, (c, u, d) => {
      c.spec.marks ? l.syncToMarks(c.spec.marks, r, e) : c.type.side >= 0 && !d && l.syncToMarks(u == this.node.childCount ? xn.none : this.node.child(u).marks, r, e), l.placeWidget(c, e, i);
    }, (c, u, d, f) => {
      l.syncToMarks(c.marks, r, e);
      let h;
      l.findNodeMatch(c, u, d, f) || a && e.state.selection.from > i && e.state.selection.to < i + c.nodeSize && (h = l.findIndexWithChild(s.node)) > -1 && l.updateNodeAt(c, u, d, h, e) || l.updateNextNode(c, u, d, e, f, i) || l.addNode(c, u, d, e, i), i += c.nodeSize;
    }), l.syncToMarks([], r, e), this.node.isTextblock && l.addTextblockHacks(), l.destroyRest(), (l.changed || this.dirty == du) && (o && this.protectLocalComposition(e, o), Cse(this.contentDOM, this.children, e), oh && _it(this.dom));
  }
  localCompositionInfo(e, t) {
    let { from: r, to: i } = e.state.selection;
    if (!(e.state.selection instanceof vt) || r < t || i > t + this.node.content.size)
      return null;
    let s = e.input.compositionNode;
    if (!s || !this.dom.contains(s.parentNode))
      return null;
    if (this.node.inlineContent) {
      let o = s.nodeValue, a = Oit(this.node.content, o, r - t, i - t);
      return a < 0 ? null : { node: s, pos: a, text: o };
    } else
      return { node: s, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: t, pos: r, text: i }) {
    if (this.getDesc(t))
      return;
    let s = t;
    for (; s.parentNode != this.contentDOM; s = s.parentNode) {
      for (; s.previousSibling; )
        s.parentNode.removeChild(s.previousSibling);
      for (; s.nextSibling; )
        s.parentNode.removeChild(s.nextSibling);
      s.pmViewDesc && (s.pmViewDesc = void 0);
    }
    let o = new Eit(this, s, t, i);
    e.input.compositionNodes.push(o), this.children = J7(this.children, r, r + i.length, e, o);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, t, r, i) {
    return this.dirty == xa || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, t, r, i), !0);
  }
  updateInner(e, t, r, i) {
    this.updateOuterDeco(t), this.node = e, this.innerDeco = r, this.contentDOM && this.updateChildren(i, this.posAtStart), this.dirty = Bs;
  }
  updateOuterDeco(e) {
    if (tb(e, this.outerDeco))
      return;
    let t = this.nodeDOM.nodeType != 1, r = this.dom;
    this.dom = Tse(this.dom, this.nodeDOM, Q7(this.outerDeco, this.node, t), Q7(e, this.node, t)), this.dom != r && (r.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.nodeDOM.draggable = !0));
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.nodeDOM.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function GU(n, e, t, r, i) {
  Ase(r, e, n);
  let s = new uc(void 0, n, e, t, r, r, r, i, 0);
  return s.contentDOM && s.updateChildren(i, 0), s;
}
class ix extends uc {
  constructor(e, t, r, i, s, o, a) {
    super(e, t, r, i, s, null, o, a, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, t, r, i) {
    return this.dirty == xa || this.dirty != Bs && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(t), (this.dirty != Bs || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, i.trackWrites == this.nodeDOM && (i.trackWrites = null)), this.node = e, this.dirty = Bs, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let t = this.nodeDOM; t; t = t.parentNode)
      if (t == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, t, r) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(t, this.node.text.length) : super.localPosFromDOM(e, t, r);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, t, r) {
    let i = this.node.cut(e, t), s = document.createTextNode(i.text);
    return new ix(this.parent, i, this.outerDeco, this.innerDeco, s, s, r);
  }
  markDirty(e, t) {
    super.markDirty(e, t), this.dom != this.nodeDOM && (e == 0 || t == this.nodeDOM.nodeValue.length) && (this.dirty = xa);
  }
  get domAtom() {
    return !1;
  }
  isText(e) {
    return this.node.text == e;
  }
}
class Sse extends F1 {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == Bs && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class Sit extends uc {
  constructor(e, t, r, i, s, o, a, l, c, u) {
    super(e, t, r, i, s, o, a, c, u), this.spec = l;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, t, r, i) {
    if (this.dirty == xa)
      return !1;
    if (this.spec.update && (this.node.type == e.type || this.spec.multiType)) {
      let s = this.spec.update(e, t, r);
      return s && this.updateInner(e, t, r, i), s;
    } else return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, t, r, i);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, t, r, i) {
    this.spec.setSelection ? this.spec.setSelection(e, t, r.root) : super.setSelection(e, t, r, i);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function Cse(n, e, t) {
  let r = n.firstChild, i = !1;
  for (let s = 0; s < e.length; s++) {
    let o = e[s], a = o.dom;
    if (a.parentNode == n) {
      for (; a != r; )
        r = KU(r), i = !0;
      r = r.nextSibling;
    } else
      i = !0, n.insertBefore(a, r);
    if (o instanceof ju) {
      let l = r ? r.previousSibling : n.lastChild;
      Cse(o.contentDOM, o.children, t), r = l ? l.nextSibling : n.firstChild;
    }
  }
  for (; r; )
    r = KU(r), i = !0;
  i && t.trackWrites == n && (t.trackWrites = null);
}
const nm = function(n) {
  n && (this.nodeName = n);
};
nm.prototype = /* @__PURE__ */ Object.create(null);
const fu = [new nm()];
function Q7(n, e, t) {
  if (n.length == 0)
    return fu;
  let r = t ? fu[0] : new nm(), i = [r];
  for (let s = 0; s < n.length; s++) {
    let o = n[s].type.attrs;
    if (o) {
      o.nodeName && i.push(r = new nm(o.nodeName));
      for (let a in o) {
        let l = o[a];
        l != null && (t && i.length == 1 && i.push(r = new nm(e.isInline ? "span" : "div")), a == "class" ? r.class = (r.class ? r.class + " " : "") + l : a == "style" ? r.style = (r.style ? r.style + ";" : "") + l : a != "nodeName" && (r[a] = l));
      }
    }
  }
  return i;
}
function Tse(n, e, t, r) {
  if (t == fu && r == fu)
    return e;
  let i = e;
  for (let s = 0; s < r.length; s++) {
    let o = r[s], a = t[s];
    if (s) {
      let l;
      a && a.nodeName == o.nodeName && i != n && (l = i.parentNode) && l.nodeName.toLowerCase() == o.nodeName || (l = document.createElement(o.nodeName), l.pmIsDeco = !0, l.appendChild(i), a = fu[0]), i = l;
    }
    Cit(i, a || fu[0], o);
  }
  return i;
}
function Cit(n, e, t) {
  for (let r in e)
    r != "class" && r != "style" && r != "nodeName" && !(r in t) && n.removeAttribute(r);
  for (let r in t)
    r != "class" && r != "style" && r != "nodeName" && t[r] != e[r] && n.setAttribute(r, t[r]);
  if (e.class != t.class) {
    let r = e.class ? e.class.split(" ").filter(Boolean) : [], i = t.class ? t.class.split(" ").filter(Boolean) : [];
    for (let s = 0; s < r.length; s++)
      i.indexOf(r[s]) == -1 && n.classList.remove(r[s]);
    for (let s = 0; s < i.length; s++)
      r.indexOf(i[s]) == -1 && n.classList.add(i[s]);
    n.classList.length == 0 && n.removeAttribute("class");
  }
  if (e.style != t.style) {
    if (e.style) {
      let r = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, i;
      for (; i = r.exec(e.style); )
        n.style.removeProperty(i[1]);
    }
    t.style && (n.style.cssText += t.style);
  }
}
function Ase(n, e, t) {
  return Tse(n, n, fu, Q7(e, t, n.nodeType != 1));
}
function tb(n, e) {
  if (n.length != e.length)
    return !1;
  for (let t = 0; t < n.length; t++)
    if (!n[t].type.eq(e[t].type))
      return !1;
  return !0;
}
function KU(n) {
  let e = n.nextSibling;
  return n.parentNode.removeChild(n), e;
}
class Tit {
  constructor(e, t, r) {
    this.lock = t, this.view = r, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = Ait(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, t) {
    if (e != t) {
      for (let r = e; r < t; r++)
        this.top.children[r].destroy();
      this.top.children.splice(e, t - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, t, r) {
    let i = 0, s = this.stack.length >> 1, o = Math.min(s, e.length);
    for (; i < o && (i == s - 1 ? this.top : this.stack[i + 1 << 1]).matchesMark(e[i]) && e[i].type.spec.spanning !== !1; )
      i++;
    for (; i < s; )
      this.destroyRest(), this.top.dirty = Bs, this.index = this.stack.pop(), this.top = this.stack.pop(), s--;
    for (; s < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let a = -1;
      for (let l = this.index; l < Math.min(this.index + 3, this.top.children.length); l++) {
        let c = this.top.children[l];
        if (c.matchesMark(e[s]) && !this.isLocked(c.dom)) {
          a = l;
          break;
        }
      }
      if (a > -1)
        a > this.index && (this.changed = !0, this.destroyBetween(this.index, a)), this.top = this.top.children[this.index];
      else {
        let l = ju.create(this.top, e[s], t, r);
        this.top.children.splice(this.index, 0, l), this.top = l, this.changed = !0;
      }
      this.index = 0, s++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, t, r, i) {
    let s = -1, o;
    if (i >= this.preMatch.index && (o = this.preMatch.matches[i - this.preMatch.index]).parent == this.top && o.matchesNode(e, t, r))
      s = this.top.children.indexOf(o, this.index);
    else
      for (let a = this.index, l = Math.min(this.top.children.length, a + 5); a < l; a++) {
        let c = this.top.children[a];
        if (c.matchesNode(e, t, r) && !this.preMatch.matched.has(c)) {
          s = a;
          break;
        }
      }
    return s < 0 ? !1 : (this.destroyBetween(this.index, s), this.index++, !0);
  }
  updateNodeAt(e, t, r, i, s) {
    let o = this.top.children[i];
    return o.dirty == xa && o.dom == o.contentDOM && (o.dirty = du), o.update(e, t, r, s) ? (this.destroyBetween(this.index, i), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let t = e.parentNode;
      if (!t)
        return -1;
      if (t == this.top.contentDOM) {
        let r = e.pmViewDesc;
        if (r) {
          for (let i = this.index; i < this.top.children.length; i++)
            if (this.top.children[i] == r)
              return i;
        }
        return -1;
      }
      e = t;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, t, r, i, s, o) {
    for (let a = this.index; a < this.top.children.length; a++) {
      let l = this.top.children[a];
      if (l instanceof uc) {
        let c = this.preMatch.matched.get(l);
        if (c != null && c != s)
          return !1;
        let u = l.dom, d, f = this.isLocked(u) && !(e.isText && l.node && l.node.isText && l.nodeDOM.nodeValue == e.text && l.dirty != xa && tb(t, l.outerDeco));
        if (!f && l.update(e, t, r, i))
          return this.destroyBetween(this.index, a), l.dom != u && (this.changed = !0), this.index++, !0;
        if (!f && (d = this.recreateWrapper(l, e, t, r, i, o)))
          return this.destroyBetween(this.index, a), this.top.children[this.index] = d, d.contentDOM && (d.dirty = du, d.updateChildren(i, o + 1), d.dirty = Bs), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(e, t, r, i, s, o) {
    if (e.dirty || t.isAtom || !e.children.length || !e.node.content.eq(t.content) || !tb(r, e.outerDeco) || !i.eq(e.innerDeco))
      return null;
    let a = uc.create(this.top, t, r, i, s, o);
    if (a.contentDOM) {
      a.children = e.children, e.children = [];
      for (let l of a.children)
        l.parent = a;
    }
    return e.destroy(), a;
  }
  // Insert the node as a newly created node desc.
  addNode(e, t, r, i, s) {
    let o = uc.create(this.top, e, t, r, i, s);
    o.contentDOM && o.updateChildren(i, s + 1), this.top.children.splice(this.index++, 0, o), this.changed = !0;
  }
  placeWidget(e, t, r) {
    let i = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (i && i.matchesWidget(e) && (e == i.widget || !i.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let s = new Ese(this.top, e, t, r);
      this.top.children.splice(this.index++, 0, s), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], t = this.top;
    for (; e instanceof ju; )
      t = e, e = t.children[t.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof ix) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((xi || oi) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", t), this.addHackNode("BR", this.top));
  }
  addHackNode(e, t) {
    if (t == this.top && this.index < t.children.length && t.children[this.index].matchesHack(e))
      this.index++;
    else {
      let r = document.createElement(e);
      e == "IMG" && (r.className = "ProseMirror-separator", r.alt = ""), e == "BR" && (r.className = "ProseMirror-trailingBreak");
      let i = new Sse(this.top, [], r, null);
      t != this.top ? t.children.push(i) : t.children.splice(this.index++, 0, i), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function Ait(n, e) {
  let t = e, r = t.children.length, i = n.childCount, s = /* @__PURE__ */ new Map(), o = [];
  e: for (; i > 0; ) {
    let a;
    for (; ; )
      if (r) {
        let c = t.children[r - 1];
        if (c instanceof ju)
          t = c, r = c.children.length;
        else {
          a = c, r--;
          break;
        }
      } else {
        if (t == e)
          break e;
        r = t.parent.children.indexOf(t), t = t.parent;
      }
    let l = a.node;
    if (l) {
      if (l != n.child(i - 1))
        break;
      --i, s.set(a, i), o.push(a);
    }
  }
  return { index: i, matched: s, matches: o.reverse() };
}
function Mit(n, e) {
  return n.type.side - e.type.side;
}
function kit(n, e, t, r) {
  let i = e.locals(n), s = 0;
  if (i.length == 0) {
    for (let c = 0; c < n.childCount; c++) {
      let u = n.child(c);
      r(u, i, e.forChild(s, u), c), s += u.nodeSize;
    }
    return;
  }
  let o = 0, a = [], l = null;
  for (let c = 0; ; ) {
    let u, d;
    for (; o < i.length && i[o].to == s; ) {
      let v = i[o++];
      v.widget && (u ? (d || (d = [u])).push(v) : u = v);
    }
    if (u)
      if (d) {
        d.sort(Mit);
        for (let v = 0; v < d.length; v++)
          t(d[v], c, !!l);
      } else
        t(u, c, !!l);
    let f, h;
    if (l)
      h = -1, f = l, l = null;
    else if (c < n.childCount)
      h = c, f = n.child(c++);
    else
      break;
    for (let v = 0; v < a.length; v++)
      a[v].to <= s && a.splice(v--, 1);
    for (; o < i.length && i[o].from <= s && i[o].to > s; )
      a.push(i[o++]);
    let m = s + f.nodeSize;
    if (f.isText) {
      let v = m;
      o < i.length && i[o].from < v && (v = i[o].from);
      for (let y = 0; y < a.length; y++)
        a[y].to < v && (v = a[y].to);
      v < m && (l = f.cut(v - s), f = f.cut(0, v - s), m = v, h = -1);
    } else
      for (; o < i.length && i[o].to < m; )
        o++;
    let g = f.isInline && !f.isLeaf ? a.filter((v) => !v.inline) : a.slice();
    r(f, g, e.forChild(s, f), h), s = m;
  }
}
function _it(n) {
  if (n.nodeName == "UL" || n.nodeName == "OL") {
    let e = n.style.cssText;
    n.style.cssText = e + "; list-style: square !important", window.getComputedStyle(n).listStyle, n.style.cssText = e;
  }
}
function Oit(n, e, t, r) {
  for (let i = 0, s = 0; i < n.childCount && s <= r; ) {
    let o = n.child(i++), a = s;
    if (s += o.nodeSize, !o.isText)
      continue;
    let l = o.text;
    for (; i < n.childCount; ) {
      let c = n.child(i++);
      if (s += c.nodeSize, !c.isText)
        break;
      l += c.text;
    }
    if (s >= t) {
      if (s >= r && l.slice(r - e.length - a, r - a) == e)
        return r - e.length;
      let c = a < r ? l.lastIndexOf(e, r - a - 1) : -1;
      if (c >= 0 && c + e.length + a >= t)
        return a + c;
      if (t == r && l.length >= r + e.length - a && l.slice(r - a, r - a + e.length) == e)
        return r;
    }
  }
  return -1;
}
function J7(n, e, t, r, i) {
  let s = [];
  for (let o = 0, a = 0; o < n.length; o++) {
    let l = n[o], c = a, u = a += l.size;
    c >= t || u <= e ? s.push(l) : (c < e && s.push(l.slice(0, e - c, r)), i && (s.push(i), i = void 0), u > t && s.push(l.slice(t - c, l.size, r)));
  }
  return s;
}
function Z_(n, e = null) {
  let t = n.domSelectionRange(), r = n.state.doc;
  if (!t.focusNode)
    return null;
  let i = n.docView.nearestDesc(t.focusNode), s = i && i.size == 0, o = n.docView.posFromDOM(t.focusNode, t.focusOffset, 1);
  if (o < 0)
    return null;
  let a = r.resolve(o), l, c;
  if (rx(t)) {
    for (l = o; i && !i.node; )
      i = i.parent;
    let d = i.node;
    if (i && d.isAtom && nt.isSelectable(d) && i.parent && !(d.isInline && nit(t.focusNode, t.focusOffset, i.dom))) {
      let f = i.posBefore;
      c = new nt(o == f ? a : r.resolve(f));
    }
  } else {
    if (t instanceof n.dom.ownerDocument.defaultView.Selection && t.rangeCount > 1) {
      let d = o, f = o;
      for (let h = 0; h < t.rangeCount; h++) {
        let m = t.getRangeAt(h);
        d = Math.min(d, n.docView.posFromDOM(m.startContainer, m.startOffset, 1)), f = Math.max(f, n.docView.posFromDOM(m.endContainer, m.endOffset, -1));
      }
      if (d < 0)
        return null;
      [l, o] = f == n.state.selection.anchor ? [f, d] : [d, f], a = r.resolve(o);
    } else
      l = n.docView.posFromDOM(t.anchorNode, t.anchorOffset, 1);
    if (l < 0)
      return null;
  }
  let u = r.resolve(l);
  if (!c) {
    let d = e == "pointer" || n.state.selection.head < a.pos && !s ? 1 : -1;
    c = Q_(n, u, a, d);
  }
  return c;
}
function Mse(n) {
  return n.editable ? n.hasFocus() : _se(n) && document.activeElement && document.activeElement.contains(n.dom);
}
function al(n, e = !1) {
  let t = n.state.selection;
  if (kse(n, t), !!Mse(n)) {
    if (!e && n.input.mouseDown && n.input.mouseDown.allowDefault && oi) {
      let r = n.domSelectionRange(), i = n.domObserver.currentSelection;
      if (r.anchorNode && i.anchorNode && Vu(r.anchorNode, r.anchorOffset, i.anchorNode, i.anchorOffset)) {
        n.input.mouseDown.delayedSelectionSync = !0, n.domObserver.setCurSelection();
        return;
      }
    }
    if (n.domObserver.disconnectSelection(), n.cursorWrapper)
      Rit(n);
    else {
      let { anchor: r, head: i } = t, s, o;
      qU && !(t instanceof vt) && (t.$from.parent.inlineContent || (s = YU(n, t.from)), !t.empty && !t.$from.parent.inlineContent && (o = YU(n, t.to))), n.docView.setSelection(r, i, n, e), qU && (s && XU(s), o && XU(o)), t.visible ? n.dom.classList.remove("ProseMirror-hideselection") : (n.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && Iit(n));
    }
    n.domObserver.setCurSelection(), n.domObserver.connectSelection();
  }
}
const qU = xi || oi && mse < 63;
function YU(n, e) {
  let { node: t, offset: r } = n.docView.domFromPos(e, 0), i = r < t.childNodes.length ? t.childNodes[r] : null, s = r ? t.childNodes[r - 1] : null;
  if (xi && i && i.contentEditable == "false")
    return s8(i);
  if ((!i || i.contentEditable == "false") && (!s || s.contentEditable == "false")) {
    if (i)
      return s8(i);
    if (s)
      return s8(s);
  }
}
function s8(n) {
  return n.contentEditable = "true", xi && n.draggable && (n.draggable = !1, n.wasDraggable = !0), n;
}
function XU(n) {
  n.contentEditable = "false", n.wasDraggable && (n.draggable = !0, n.wasDraggable = null);
}
function Iit(n) {
  let e = n.dom.ownerDocument;
  e.removeEventListener("selectionchange", n.input.hideSelectionGuard);
  let t = n.domSelectionRange(), r = t.anchorNode, i = t.anchorOffset;
  e.addEventListener("selectionchange", n.input.hideSelectionGuard = () => {
    (t.anchorNode != r || t.anchorOffset != i) && (e.removeEventListener("selectionchange", n.input.hideSelectionGuard), setTimeout(() => {
      (!Mse(n) || n.state.selection.visible) && n.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function Rit(n) {
  let e = n.domSelection();
  if (!e)
    return;
  let t = n.cursorWrapper.dom, r = t.nodeName == "IMG";
  r ? e.collapse(t.parentNode, Hr(t) + 1) : e.collapse(t, 0), !r && !n.state.selection.visible && Vi && cc <= 11 && (t.disabled = !0, t.disabled = !1);
}
function kse(n, e) {
  if (e instanceof nt) {
    let t = n.docView.descAt(e.from);
    t != n.lastSelectedViewDesc && (ZU(n), t && t.selectNode(), n.lastSelectedViewDesc = t);
  } else
    ZU(n);
}
function ZU(n) {
  n.lastSelectedViewDesc && (n.lastSelectedViewDesc.parent && n.lastSelectedViewDesc.deselectNode(), n.lastSelectedViewDesc = void 0);
}
function Q_(n, e, t, r) {
  return n.someProp("createSelectionBetween", (i) => i(n, e, t)) || vt.between(e, t, r);
}
function QU(n) {
  return n.editable && !n.hasFocus() ? !1 : _se(n);
}
function _se(n) {
  let e = n.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return n.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (n.editable || n.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function Pit(n) {
  let e = n.docView.domFromPos(n.state.selection.anchor, 0), t = n.domSelectionRange();
  return Vu(e.node, e.offset, t.anchorNode, t.anchorOffset);
}
function e9(n, e) {
  let { $anchor: t, $head: r } = n.selection, i = e > 0 ? t.max(r) : t.min(r), s = i.parent.inlineContent ? i.depth ? n.doc.resolve(e > 0 ? i.after() : i.before()) : null : i;
  return s && pt.findFrom(s, e);
}
function zl(n, e) {
  return n.dispatch(n.state.tr.setSelection(e).scrollIntoView()), !0;
}
function JU(n, e, t) {
  let r = n.state.selection;
  if (r instanceof vt)
    if (t.indexOf("s") > -1) {
      let { $head: i } = r, s = i.textOffset ? null : e < 0 ? i.nodeBefore : i.nodeAfter;
      if (!s || s.isText || !s.isLeaf)
        return !1;
      let o = n.state.doc.resolve(i.pos + s.nodeSize * (e < 0 ? -1 : 1));
      return zl(n, new vt(r.$anchor, o));
    } else if (r.empty) {
      if (n.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let i = e9(n.state, e);
        return i && i instanceof nt ? zl(n, i) : !1;
      } else if (!(ks && t.indexOf("m") > -1)) {
        let i = r.$head, s = i.textOffset ? null : e < 0 ? i.nodeBefore : i.nodeAfter, o;
        if (!s || s.isText)
          return !1;
        let a = e < 0 ? i.pos - s.nodeSize : i.pos;
        return s.isAtom || (o = n.docView.descAt(a)) && !o.contentDOM ? nt.isSelectable(s) ? zl(n, new nt(e < 0 ? n.state.doc.resolve(i.pos - s.nodeSize) : i)) : $1 ? zl(n, new vt(n.state.doc.resolve(e < 0 ? a : a + s.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (r instanceof nt && r.node.isInline)
      return zl(n, new vt(e > 0 ? r.$to : r.$from));
    {
      let i = e9(n.state, e);
      return i ? zl(n, i) : !1;
    }
  }
}
function nb(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function rm(n, e) {
  let t = n.pmViewDesc;
  return t && t.size == 0 && (e < 0 || n.nextSibling || n.nodeName != "BR");
}
function Rd(n, e) {
  return e < 0 ? Dit(n) : Nit(n);
}
function Dit(n) {
  let e = n.domSelectionRange(), t = e.focusNode, r = e.focusOffset;
  if (!t)
    return;
  let i, s, o = !1;
  for (Fs && t.nodeType == 1 && r < nb(t) && rm(t.childNodes[r], -1) && (o = !0); ; )
    if (r > 0) {
      if (t.nodeType != 1)
        break;
      {
        let a = t.childNodes[r - 1];
        if (rm(a, -1))
          i = t, s = --r;
        else if (a.nodeType == 3)
          t = a, r = t.nodeValue.length;
        else
          break;
      }
    } else {
      if (Ose(t))
        break;
      {
        let a = t.previousSibling;
        for (; a && rm(a, -1); )
          i = t.parentNode, s = Hr(a), a = a.previousSibling;
        if (a)
          t = a, r = nb(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          r = 0;
        }
      }
    }
  o ? t9(n, t, r) : i && t9(n, i, s);
}
function Nit(n) {
  let e = n.domSelectionRange(), t = e.focusNode, r = e.focusOffset;
  if (!t)
    return;
  let i = nb(t), s, o;
  for (; ; )
    if (r < i) {
      if (t.nodeType != 1)
        break;
      let a = t.childNodes[r];
      if (rm(a, 1))
        s = t, o = ++r;
      else
        break;
    } else {
      if (Ose(t))
        break;
      {
        let a = t.nextSibling;
        for (; a && rm(a, 1); )
          s = a.parentNode, o = Hr(a) + 1, a = a.nextSibling;
        if (a)
          t = a, r = 0, i = nb(t);
        else {
          if (t = t.parentNode, t == n.dom)
            break;
          r = i = 0;
        }
      }
    }
  s && t9(n, s, o);
}
function Ose(n) {
  let e = n.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function Lit(n, e) {
  for (; n && e == n.childNodes.length && !L1(n); )
    e = Hr(n) + 1, n = n.parentNode;
  for (; n && e < n.childNodes.length; ) {
    let t = n.childNodes[e];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = 0;
  }
}
function $it(n, e) {
  for (; n && !e && !L1(n); )
    e = Hr(n), n = n.parentNode;
  for (; n && e; ) {
    let t = n.childNodes[e - 1];
    if (t.nodeType == 3)
      return t;
    if (t.nodeType == 1 && t.contentEditable == "false")
      break;
    n = t, e = n.childNodes.length;
  }
}
function t9(n, e, t) {
  if (e.nodeType != 3) {
    let s, o;
    (o = Lit(e, t)) ? (e = o, t = 0) : (s = $it(e, t)) && (e = s, t = s.nodeValue.length);
  }
  let r = n.domSelection();
  if (!r)
    return;
  if (rx(r)) {
    let s = document.createRange();
    s.setEnd(e, t), s.setStart(e, t), r.removeAllRanges(), r.addRange(s);
  } else r.extend && r.extend(e, t);
  n.domObserver.setCurSelection();
  let { state: i } = n;
  setTimeout(() => {
    n.state == i && al(n);
  }, 50);
}
function eV(n, e) {
  let t = n.state.doc.resolve(e);
  if (!(oi || sit) && t.parent.inlineContent) {
    let i = n.coordsAtPos(e);
    if (e > t.start()) {
      let s = n.coordsAtPos(e - 1), o = (s.top + s.bottom) / 2;
      if (o > i.top && o < i.bottom && Math.abs(s.left - i.left) > 1)
        return s.left < i.left ? "ltr" : "rtl";
    }
    if (e < t.end()) {
      let s = n.coordsAtPos(e + 1), o = (s.top + s.bottom) / 2;
      if (o > i.top && o < i.bottom && Math.abs(s.left - i.left) > 1)
        return s.left > i.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(n.dom).direction == "rtl" ? "rtl" : "ltr";
}
function tV(n, e, t) {
  let r = n.state.selection;
  if (r instanceof vt && !r.empty || t.indexOf("s") > -1 || ks && t.indexOf("m") > -1)
    return !1;
  let { $from: i, $to: s } = r;
  if (!i.parent.inlineContent || n.endOfTextblock(e < 0 ? "up" : "down")) {
    let o = e9(n.state, e);
    if (o && o instanceof nt)
      return zl(n, o);
  }
  if (!i.parent.inlineContent) {
    let o = e < 0 ? i : s, a = r instanceof vs ? pt.near(o, e) : pt.findFrom(o, e);
    return a ? zl(n, a) : !1;
  }
  return !1;
}
function nV(n, e) {
  if (!(n.state.selection instanceof vt))
    return !0;
  let { $head: t, $anchor: r, empty: i } = n.state.selection;
  if (!t.sameParent(r))
    return !0;
  if (!i)
    return !1;
  if (n.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let s = !t.textOffset && (e < 0 ? t.nodeBefore : t.nodeAfter);
  if (s && !s.isText) {
    let o = n.state.tr;
    return e < 0 ? o.delete(t.pos - s.nodeSize, t.pos) : o.delete(t.pos, t.pos + s.nodeSize), n.dispatch(o), !0;
  }
  return !1;
}
function rV(n, e, t) {
  n.domObserver.stop(), e.contentEditable = t, n.domObserver.start();
}
function Fit(n) {
  if (!xi || n.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: t } = n.domSelectionRange();
  if (e && e.nodeType == 1 && t == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let r = e.firstChild;
    rV(n, r, "true"), setTimeout(() => rV(n, r, "false"), 20);
  }
  return !1;
}
function Bit(n) {
  let e = "";
  return n.ctrlKey && (e += "c"), n.metaKey && (e += "m"), n.altKey && (e += "a"), n.shiftKey && (e += "s"), e;
}
function zit(n, e) {
  let t = e.keyCode, r = Bit(e);
  if (t == 8 || ks && t == 72 && r == "c")
    return nV(n, -1) || Rd(n, -1);
  if (t == 46 && !e.shiftKey || ks && t == 68 && r == "c")
    return nV(n, 1) || Rd(n, 1);
  if (t == 13 || t == 27)
    return !0;
  if (t == 37 || ks && t == 66 && r == "c") {
    let i = t == 37 ? eV(n, n.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return JU(n, i, r) || Rd(n, i);
  } else if (t == 39 || ks && t == 70 && r == "c") {
    let i = t == 39 ? eV(n, n.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return JU(n, i, r) || Rd(n, i);
  } else {
    if (t == 38 || ks && t == 80 && r == "c")
      return tV(n, -1, r) || Rd(n, -1);
    if (t == 40 || ks && t == 78 && r == "c")
      return Fit(n) || tV(n, 1, r) || Rd(n, 1);
    if (r == (ks ? "m" : "c") && (t == 66 || t == 73 || t == 89 || t == 90))
      return !0;
  }
  return !1;
}
function J_(n, e) {
  n.someProp("transformCopied", (h) => {
    e = h(e, n);
  });
  let t = [], { content: r, openStart: i, openEnd: s } = e;
  for (; i > 1 && s > 1 && r.childCount == 1 && r.firstChild.childCount == 1; ) {
    i--, s--;
    let h = r.firstChild;
    t.push(h.type.name, h.attrs != h.type.defaultAttrs ? h.attrs : null), r = h.content;
  }
  let o = n.someProp("clipboardSerializer") || fd.fromSchema(n.state.schema), a = Lse(), l = a.createElement("div");
  l.appendChild(o.serializeFragment(r, { document: a }));
  let c = l.firstChild, u, d = 0;
  for (; c && c.nodeType == 1 && (u = Nse[c.nodeName.toLowerCase()]); ) {
    for (let h = u.length - 1; h >= 0; h--) {
      let m = a.createElement(u[h]);
      for (; l.firstChild; )
        m.appendChild(l.firstChild);
      l.appendChild(m), d++;
    }
    c = l.firstChild;
  }
  c && c.nodeType == 1 && c.setAttribute("data-pm-slice", `${i} ${s}${d ? ` -${d}` : ""} ${JSON.stringify(t)}`);
  let f = n.someProp("clipboardTextSerializer", (h) => h(e, n)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: l, text: f, slice: e };
}
function Ise(n, e, t, r, i) {
  let s = i.parent.type.spec.code, o, a;
  if (!t && !e)
    return null;
  let l = !!e && (r || s || !t);
  if (l) {
    if (n.someProp("transformPastedText", (f) => {
      e = f(e, s || r, n);
    }), s)
      return a = new Fe(Ee.from(n.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0), n.someProp("transformPasted", (f) => {
        a = f(a, n, !0);
      }), a;
    let d = n.someProp("clipboardTextParser", (f) => f(e, i, r, n));
    if (d)
      a = d;
    else {
      let f = i.marks(), { schema: h } = n.state, m = fd.fromSchema(h);
      o = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((g) => {
        let v = o.appendChild(document.createElement("p"));
        g && v.appendChild(m.serializeNode(h.text(g, f)));
      });
    }
  } else
    n.someProp("transformPastedHTML", (d) => {
      t = d(t, n);
    }), o = jit(t), $1 && Wit(o);
  let c = o && o.querySelector("[data-pm-slice]"), u = c && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(c.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let d = +u[3]; d > 0; d--) {
      let f = o.firstChild;
      for (; f && f.nodeType != 1; )
        f = f.nextSibling;
      if (!f)
        break;
      o = f;
    }
  if (a || (a = (n.someProp("clipboardParser") || n.someProp("domParser") || em.fromSchema(n.state.schema)).parseSlice(o, {
    preserveWhitespace: !!(l || u),
    context: i,
    ruleFromNode(f) {
      return f.nodeName == "BR" && !f.nextSibling && f.parentNode && !Hit.test(f.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    a = Git(iV(a, +u[1], +u[2]), u[4]);
  else if (a = Fe.maxOpen(Uit(a.content, i), !0), a.openStart || a.openEnd) {
    let d = 0, f = 0;
    for (let h = a.content.firstChild; d < a.openStart && !h.type.spec.isolating; d++, h = h.firstChild)
      ;
    for (let h = a.content.lastChild; f < a.openEnd && !h.type.spec.isolating; f++, h = h.lastChild)
      ;
    a = iV(a, d, f);
  }
  return n.someProp("transformPasted", (d) => {
    a = d(a, n, l);
  }), a;
}
const Hit = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function Uit(n, e) {
  if (n.childCount < 2)
    return n;
  for (let t = e.depth; t >= 0; t--) {
    let i = e.node(t).contentMatchAt(e.index(t)), s, o = [];
    if (n.forEach((a) => {
      if (!o)
        return;
      let l = i.findWrapping(a.type), c;
      if (!l)
        return o = null;
      if (c = o.length && s.length && Pse(l, s, a, o[o.length - 1], 0))
        o[o.length - 1] = c;
      else {
        o.length && (o[o.length - 1] = Dse(o[o.length - 1], s.length));
        let u = Rse(a, l);
        o.push(u), i = i.matchType(u.type), s = l;
      }
    }), o)
      return Ee.from(o);
  }
  return n;
}
function Rse(n, e, t = 0) {
  for (let r = e.length - 1; r >= t; r--)
    n = e[r].create(null, Ee.from(n));
  return n;
}
function Pse(n, e, t, r, i) {
  if (i < n.length && i < e.length && n[i] == e[i]) {
    let s = Pse(n, e, t, r.lastChild, i + 1);
    if (s)
      return r.copy(r.content.replaceChild(r.childCount - 1, s));
    if (r.contentMatchAt(r.childCount).matchType(i == n.length - 1 ? t.type : n[i + 1]))
      return r.copy(r.content.append(Ee.from(Rse(t, n, i + 1))));
  }
}
function Dse(n, e) {
  if (e == 0)
    return n;
  let t = n.content.replaceChild(n.childCount - 1, Dse(n.lastChild, e - 1)), r = n.contentMatchAt(n.childCount).fillBefore(Ee.empty, !0);
  return n.copy(t.append(r));
}
function n9(n, e, t, r, i, s) {
  let o = e < 0 ? n.firstChild : n.lastChild, a = o.content;
  return n.childCount > 1 && (s = 0), i < r - 1 && (a = n9(a, e, t, r, i + 1, s)), i >= t && (a = e < 0 ? o.contentMatchAt(0).fillBefore(a, s <= i).append(a) : a.append(o.contentMatchAt(o.childCount).fillBefore(Ee.empty, !0))), n.replaceChild(e < 0 ? 0 : n.childCount - 1, o.copy(a));
}
function iV(n, e, t) {
  return e < n.openStart && (n = new Fe(n9(n.content, -1, e, n.openStart, 0, n.openEnd), e, n.openEnd)), t < n.openEnd && (n = new Fe(n9(n.content, 1, t, n.openEnd, 0, 0), n.openStart, t)), n;
}
const Nse = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let sV = null;
function Lse() {
  return sV || (sV = document.implementation.createHTMLDocument("title"));
}
let o8 = null;
function Vit(n) {
  let e = window.trustedTypes;
  return e ? (o8 || (o8 = e.defaultPolicy || e.createPolicy("ProseMirrorClipboard", { createHTML: (t) => t })), o8.createHTML(n)) : n;
}
function jit(n) {
  let e = /^(\s*<meta [^>]*>)*/.exec(n);
  e && (n = n.slice(e[0].length));
  let t = Lse().createElement("div"), r = /<([a-z][^>\s]+)/i.exec(n), i;
  if ((i = r && Nse[r[1].toLowerCase()]) && (n = i.map((s) => "<" + s + ">").join("") + n + i.map((s) => "</" + s + ">").reverse().join("")), t.innerHTML = Vit(n), i)
    for (let s = 0; s < i.length; s++)
      t = t.querySelector(i[s]) || t;
  return t;
}
function Wit(n) {
  let e = n.querySelectorAll(oi ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let t = 0; t < e.length; t++) {
    let r = e[t];
    r.childNodes.length == 1 && r.textContent == " " && r.parentNode && r.parentNode.replaceChild(n.ownerDocument.createTextNode(" "), r);
  }
}
function Git(n, e) {
  if (!n.size)
    return n;
  let t = n.content.firstChild.type.schema, r;
  try {
    r = JSON.parse(e);
  } catch {
    return n;
  }
  let { content: i, openStart: s, openEnd: o } = n;
  for (let a = r.length - 2; a >= 0; a -= 2) {
    let l = t.nodes[r[a]];
    if (!l || l.hasRequiredAttrs())
      break;
    i = Ee.from(l.create(r[a + 1], i)), s++, o++;
  }
  return new Fe(i, s, o);
}
const Ei = {}, Si = {}, Kit = { touchstart: !0, touchmove: !0 };
let qit = class {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "", button: 0 }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
};
function Yit(n) {
  for (let e in Ei) {
    let t = Ei[e];
    n.dom.addEventListener(e, n.input.eventHandlers[e] = (r) => {
      Zit(n, r) && !eO(n, r) && (n.editable || !(r.type in Si)) && t(n, r);
    }, Kit[e] ? { passive: !0 } : void 0);
  }
  xi && n.dom.addEventListener("input", () => null), r9(n);
}
function Jl(n, e) {
  n.input.lastSelectionOrigin = e, n.input.lastSelectionTime = Date.now();
}
function Xit(n) {
  n.domObserver.stop();
  for (let e in n.input.eventHandlers)
    n.dom.removeEventListener(e, n.input.eventHandlers[e]);
  clearTimeout(n.input.composingTimeout), clearTimeout(n.input.lastIOSEnterFallbackTimeout);
}
function r9(n) {
  n.someProp("handleDOMEvents", (e) => {
    for (let t in e)
      n.input.eventHandlers[t] || n.dom.addEventListener(t, n.input.eventHandlers[t] = (r) => eO(n, r));
  });
}
function eO(n, e) {
  return n.someProp("handleDOMEvents", (t) => {
    let r = t[e.type];
    return r ? r(n, e) || e.defaultPrevented : !1;
  });
}
function Zit(n, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let t = e.target; t != n.dom; t = t.parentNode)
    if (!t || t.nodeType == 11 || t.pmViewDesc && t.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function Qit(n, e) {
  !eO(n, e) && Ei[e.type] && (n.editable || !(e.type in Si)) && Ei[e.type](n, e);
}
Si.keydown = (n, e) => {
  let t = e;
  if (n.input.shiftKey = t.keyCode == 16 || t.shiftKey, !Fse(n, t) && (n.input.lastKeyCode = t.keyCode, n.input.lastKeyCodeTime = Date.now(), !(el && oi && t.keyCode == 13)))
    if (t.keyCode != 229 && n.domObserver.forceFlush(), oh && t.keyCode == 13 && !t.ctrlKey && !t.altKey && !t.metaKey) {
      let r = Date.now();
      n.input.lastIOSEnter = r, n.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        n.input.lastIOSEnter == r && (n.someProp("handleKeyDown", (i) => i(n, eu(13, "Enter"))), n.input.lastIOSEnter = 0);
      }, 200);
    } else n.someProp("handleKeyDown", (r) => r(n, t)) || zit(n, t) ? t.preventDefault() : Jl(n, "key");
};
Si.keyup = (n, e) => {
  e.keyCode == 16 && (n.input.shiftKey = !1);
};
Si.keypress = (n, e) => {
  let t = e;
  if (Fse(n, t) || !t.charCode || t.ctrlKey && !t.altKey || ks && t.metaKey)
    return;
  if (n.someProp("handleKeyPress", (i) => i(n, t))) {
    t.preventDefault();
    return;
  }
  let r = n.state.selection;
  if (!(r instanceof vt) || !r.$from.sameParent(r.$to)) {
    let i = String.fromCharCode(t.charCode), s = () => n.state.tr.insertText(i).scrollIntoView();
    !/[\r\n]/.test(i) && !n.someProp("handleTextInput", (o) => o(n, r.$from.pos, r.$to.pos, i, s)) && n.dispatch(s()), t.preventDefault();
  }
};
function sx(n) {
  return { left: n.clientX, top: n.clientY };
}
function Jit(n, e) {
  let t = e.x - n.clientX, r = e.y - n.clientY;
  return t * t + r * r < 100;
}
function tO(n, e, t, r, i) {
  if (r == -1)
    return !1;
  let s = n.state.doc.resolve(r);
  for (let o = s.depth + 1; o > 0; o--)
    if (n.someProp(e, (a) => o > s.depth ? a(n, t, s.nodeAfter, s.before(o), i, !0) : a(n, t, s.node(o), s.before(o), i, !1)))
      return !0;
  return !1;
}
function gf(n, e, t) {
  if (n.focused || n.focus(), n.state.selection.eq(e))
    return;
  let r = n.state.tr.setSelection(e);
  r.setMeta("pointer", !0), n.dispatch(r);
}
function est(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.doc.resolve(e), r = t.nodeAfter;
  return r && r.isAtom && nt.isSelectable(r) ? (gf(n, new nt(t)), !0) : !1;
}
function tst(n, e) {
  if (e == -1)
    return !1;
  let t = n.state.selection, r, i;
  t instanceof nt && (r = t.node);
  let s = n.state.doc.resolve(e);
  for (let o = s.depth + 1; o > 0; o--) {
    let a = o > s.depth ? s.nodeAfter : s.node(o);
    if (nt.isSelectable(a)) {
      r && t.$from.depth > 0 && o >= t.$from.depth && s.before(t.$from.depth + 1) == t.$from.pos ? i = s.before(t.$from.depth) : i = s.before(o);
      break;
    }
  }
  return i != null ? (gf(n, nt.create(n.state.doc, i)), !0) : !1;
}
function nst(n, e, t, r, i) {
  return tO(n, "handleClickOn", e, t, r) || n.someProp("handleClick", (s) => s(n, e, r)) || (i ? tst(n, t) : est(n, t));
}
function rst(n, e, t, r) {
  return tO(n, "handleDoubleClickOn", e, t, r) || n.someProp("handleDoubleClick", (i) => i(n, e, r));
}
function ist(n, e, t, r) {
  return tO(n, "handleTripleClickOn", e, t, r) || n.someProp("handleTripleClick", (i) => i(n, e, r)) || sst(n, t, r);
}
function sst(n, e, t) {
  if (t.button != 0)
    return !1;
  let r = n.state.doc;
  if (e == -1)
    return r.inlineContent ? (gf(n, vt.create(r, 0, r.content.size)), !0) : !1;
  let i = r.resolve(e);
  for (let s = i.depth + 1; s > 0; s--) {
    let o = s > i.depth ? i.nodeAfter : i.node(s), a = i.before(s);
    if (o.inlineContent)
      gf(n, vt.create(r, a + 1, a + 1 + o.content.size));
    else if (nt.isSelectable(o))
      gf(n, nt.create(r, a));
    else
      continue;
    return !0;
  }
}
function nO(n) {
  return rb(n);
}
const $se = ks ? "metaKey" : "ctrlKey";
Ei.mousedown = (n, e) => {
  let t = e;
  n.input.shiftKey = t.shiftKey;
  let r = nO(n), i = Date.now(), s = "singleClick";
  i - n.input.lastClick.time < 500 && Jit(t, n.input.lastClick) && !t[$se] && n.input.lastClick.button == t.button && (n.input.lastClick.type == "singleClick" ? s = "doubleClick" : n.input.lastClick.type == "doubleClick" && (s = "tripleClick")), n.input.lastClick = { time: i, x: t.clientX, y: t.clientY, type: s, button: t.button };
  let o = n.posAtCoords(sx(t));
  o && (s == "singleClick" ? (n.input.mouseDown && n.input.mouseDown.done(), n.input.mouseDown = new ost(n, o, t, !!r)) : (s == "doubleClick" ? rst : ist)(n, o.pos, o.inside, t) ? t.preventDefault() : Jl(n, "pointer"));
};
class ost {
  constructor(e, t, r, i) {
    this.view = e, this.pos = t, this.event = r, this.flushed = i, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!r[$se], this.allowDefault = r.shiftKey;
    let s, o;
    if (t.inside > -1)
      s = e.state.doc.nodeAt(t.inside), o = t.inside;
    else {
      let u = e.state.doc.resolve(t.pos);
      s = u.parent, o = u.depth ? u.before() : 0;
    }
    const a = i ? null : r.target, l = a ? e.docView.nearestDesc(a, !0) : null;
    this.target = l && l.nodeDOM.nodeType == 1 ? l.nodeDOM : null;
    let { selection: c } = e.state;
    (r.button == 0 && s.type.spec.draggable && s.type.spec.selectable !== !1 || c instanceof nt && c.from <= o && c.to > o) && (this.mightDrag = {
      node: s,
      pos: o,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && Fs && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), Jl(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => al(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let t = this.pos;
    this.view.state.doc != this.startDoc && (t = this.view.posAtCoords(sx(e))), this.updateAllowDefault(e), this.allowDefault || !t ? Jl(this.view, "pointer") : nst(this.view, t.pos, t.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    xi && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    oi && !this.view.state.selection.visible && Math.min(Math.abs(t.pos - this.view.state.selection.from), Math.abs(t.pos - this.view.state.selection.to)) <= 2) ? (gf(this.view, pt.near(this.view.state.doc.resolve(t.pos))), e.preventDefault()) : Jl(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), Jl(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
Ei.touchstart = (n) => {
  n.input.lastTouch = Date.now(), nO(n), Jl(n, "pointer");
};
Ei.touchmove = (n) => {
  n.input.lastTouch = Date.now(), Jl(n, "pointer");
};
Ei.contextmenu = (n) => nO(n);
function Fse(n, e) {
  return n.composing ? !0 : xi && Math.abs(e.timeStamp - n.input.compositionEndedAt) < 500 ? (n.input.compositionEndedAt = -2e8, !0) : !1;
}
const ast = el ? 5e3 : -1;
Si.compositionstart = Si.compositionupdate = (n) => {
  if (!n.composing) {
    n.domObserver.flush();
    let { state: e } = n, t = e.selection.$to;
    if (e.selection instanceof vt && (e.storedMarks || !t.textOffset && t.parentOffset && t.nodeBefore.marks.some((r) => r.type.spec.inclusive === !1)))
      n.markCursor = n.state.storedMarks || t.marks(), rb(n, !0), n.markCursor = null;
    else if (rb(n, !e.selection.empty), Fs && e.selection.empty && t.parentOffset && !t.textOffset && t.nodeBefore.marks.length) {
      let r = n.domSelectionRange();
      for (let i = r.focusNode, s = r.focusOffset; i && i.nodeType == 1 && s != 0; ) {
        let o = s < 0 ? i.lastChild : i.childNodes[s - 1];
        if (!o)
          break;
        if (o.nodeType == 3) {
          let a = n.domSelection();
          a && a.collapse(o, o.nodeValue.length);
          break;
        } else
          i = o, s = -1;
      }
    }
    n.input.composing = !0;
  }
  Bse(n, ast);
};
Si.compositionend = (n, e) => {
  n.composing && (n.input.composing = !1, n.input.compositionEndedAt = e.timeStamp, n.input.compositionPendingChanges = n.domObserver.pendingRecords().length ? n.input.compositionID : 0, n.input.compositionNode = null, n.input.compositionPendingChanges && Promise.resolve().then(() => n.domObserver.flush()), n.input.compositionID++, Bse(n, 20));
};
function Bse(n, e) {
  clearTimeout(n.input.composingTimeout), e > -1 && (n.input.composingTimeout = setTimeout(() => rb(n), e));
}
function zse(n) {
  for (n.composing && (n.input.composing = !1, n.input.compositionEndedAt = cst()); n.input.compositionNodes.length > 0; )
    n.input.compositionNodes.pop().markParentsDirty();
}
function lst(n) {
  let e = n.domSelectionRange();
  if (!e.focusNode)
    return null;
  let t = eit(e.focusNode, e.focusOffset), r = tit(e.focusNode, e.focusOffset);
  if (t && r && t != r) {
    let i = r.pmViewDesc, s = n.domObserver.lastChangedTextNode;
    if (t == s || r == s)
      return s;
    if (!i || !i.isText(r.nodeValue))
      return r;
    if (n.input.compositionNode == r) {
      let o = t.pmViewDesc;
      if (!(!o || !o.isText(t.nodeValue)))
        return r;
    }
  }
  return t || r;
}
function cst() {
  let n = document.createEvent("Event");
  return n.initEvent("event", !0, !0), n.timeStamp;
}
function rb(n, e = !1) {
  if (!(el && n.domObserver.flushingSoon >= 0)) {
    if (n.domObserver.forceFlush(), zse(n), e || n.docView && n.docView.dirty) {
      let t = Z_(n), r = n.state.selection;
      return t && !t.eq(r) ? n.dispatch(n.state.tr.setSelection(t)) : (n.markCursor || e) && !r.$from.node(r.$from.sharedDepth(r.to)).inlineContent ? n.dispatch(n.state.tr.deleteSelection()) : n.updateState(n.state), !0;
    }
    return !1;
  }
}
function ust(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.dom.parentNode.appendChild(document.createElement("div"));
  t.appendChild(e), t.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let r = getSelection(), i = document.createRange();
  i.selectNodeContents(e), n.dom.blur(), r.removeAllRanges(), r.addRange(i), setTimeout(() => {
    t.parentNode && t.parentNode.removeChild(t), n.focus();
  }, 50);
}
const L0 = Vi && cc < 15 || oh && oit < 604;
Ei.copy = Si.cut = (n, e) => {
  let t = e, r = n.state.selection, i = t.type == "cut";
  if (r.empty)
    return;
  let s = L0 ? null : t.clipboardData, o = r.content(), { dom: a, text: l } = J_(n, o);
  s ? (t.preventDefault(), s.clearData(), s.setData("text/html", a.innerHTML), s.setData("text/plain", l)) : ust(n, a), i && n.dispatch(n.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function dst(n) {
  return n.openStart == 0 && n.openEnd == 0 && n.content.childCount == 1 ? n.content.firstChild : null;
}
function fst(n, e) {
  if (!n.dom.parentNode)
    return;
  let t = n.input.shiftKey || n.state.selection.$from.parent.type.spec.code, r = n.dom.parentNode.appendChild(document.createElement(t ? "textarea" : "div"));
  t || (r.contentEditable = "true"), r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.focus();
  let i = n.input.shiftKey && n.input.lastKeyCode != 45;
  setTimeout(() => {
    n.focus(), r.parentNode && r.parentNode.removeChild(r), t ? $0(n, r.value, null, i, e) : $0(n, r.textContent, r.innerHTML, i, e);
  }, 50);
}
function $0(n, e, t, r, i) {
  let s = Ise(n, e, t, r, n.state.selection.$from);
  if (n.someProp("handlePaste", (l) => l(n, i, s || Fe.empty)))
    return !0;
  if (!s)
    return !1;
  let o = dst(s), a = o ? n.state.tr.replaceSelectionWith(o, r) : n.state.tr.replaceSelection(s);
  return n.dispatch(a.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function Hse(n) {
  let e = n.getData("text/plain") || n.getData("Text");
  if (e)
    return e;
  let t = n.getData("text/uri-list");
  return t ? t.replace(/\r?\n/g, " ") : "";
}
Si.paste = (n, e) => {
  let t = e;
  if (n.composing && !el)
    return;
  let r = L0 ? null : t.clipboardData, i = n.input.shiftKey && n.input.lastKeyCode != 45;
  r && $0(n, Hse(r), r.getData("text/html"), i, t) ? t.preventDefault() : fst(n, t);
};
class Use {
  constructor(e, t, r) {
    this.slice = e, this.move = t, this.node = r;
  }
}
const hst = ks ? "altKey" : "ctrlKey";
function Vse(n, e) {
  let t = n.someProp("dragCopies", (r) => !r(e));
  return t ?? !e[hst];
}
Ei.dragstart = (n, e) => {
  let t = e, r = n.input.mouseDown;
  if (r && r.done(), !t.dataTransfer)
    return;
  let i = n.state.selection, s = i.empty ? null : n.posAtCoords(sx(t)), o;
  if (!(s && s.pos >= i.from && s.pos <= (i instanceof nt ? i.to - 1 : i.to))) {
    if (r && r.mightDrag)
      o = nt.create(n.state.doc, r.mightDrag.pos);
    else if (t.target && t.target.nodeType == 1) {
      let d = n.docView.nearestDesc(t.target, !0);
      d && d.node.type.spec.draggable && d != n.docView && (o = nt.create(n.state.doc, d.posBefore));
    }
  }
  let a = (o || n.state.selection).content(), { dom: l, text: c, slice: u } = J_(n, a);
  (!t.dataTransfer.files.length || !oi || mse > 120) && t.dataTransfer.clearData(), t.dataTransfer.setData(L0 ? "Text" : "text/html", l.innerHTML), t.dataTransfer.effectAllowed = "copyMove", L0 || t.dataTransfer.setData("text/plain", c), n.dragging = new Use(u, Vse(n, t), o);
};
Ei.dragend = (n) => {
  let e = n.dragging;
  window.setTimeout(() => {
    n.dragging == e && (n.dragging = null);
  }, 50);
};
Si.dragover = Si.dragenter = (n, e) => e.preventDefault();
Si.drop = (n, e) => {
  let t = e, r = n.dragging;
  if (n.dragging = null, !t.dataTransfer)
    return;
  let i = n.posAtCoords(sx(t));
  if (!i)
    return;
  let s = n.state.doc.resolve(i.pos), o = r && r.slice;
  o ? n.someProp("transformPasted", (m) => {
    o = m(o, n, !1);
  }) : o = Ise(n, Hse(t.dataTransfer), L0 ? null : t.dataTransfer.getData("text/html"), !1, s);
  let a = !!(r && Vse(n, t));
  if (n.someProp("handleDrop", (m) => m(n, t, o || Fe.empty, a))) {
    t.preventDefault();
    return;
  }
  if (!o)
    return;
  t.preventDefault();
  let l = o ? Kie(n.state.doc, s.pos, o) : s.pos;
  l == null && (l = s.pos);
  let c = n.state.tr;
  if (a) {
    let { node: m } = r;
    m ? m.replace(c) : c.deleteSelection();
  }
  let u = c.mapping.map(l), d = o.openStart == 0 && o.openEnd == 0 && o.content.childCount == 1, f = c.doc;
  if (d ? c.replaceRangeWith(u, u, o.content.firstChild) : c.replaceRange(u, u, o), c.doc.eq(f))
    return;
  let h = c.doc.resolve(u);
  if (d && nt.isSelectable(o.content.firstChild) && h.nodeAfter && h.nodeAfter.sameMarkup(o.content.firstChild))
    c.setSelection(new nt(h));
  else {
    let m = c.mapping.map(l);
    c.mapping.maps[c.mapping.maps.length - 1].forEach((g, v, y, b) => m = b), c.setSelection(Q_(n, h, c.doc.resolve(m)));
  }
  n.focus(), n.dispatch(c.setMeta("uiEvent", "drop"));
};
Ei.focus = (n) => {
  n.input.lastFocus = Date.now(), n.focused || (n.domObserver.stop(), n.dom.classList.add("ProseMirror-focused"), n.domObserver.start(), n.focused = !0, setTimeout(() => {
    n.docView && n.hasFocus() && !n.domObserver.currentSelection.eq(n.domSelectionRange()) && al(n);
  }, 20));
};
Ei.blur = (n, e) => {
  let t = e;
  n.focused && (n.domObserver.stop(), n.dom.classList.remove("ProseMirror-focused"), n.domObserver.start(), t.relatedTarget && n.dom.contains(t.relatedTarget) && n.domObserver.currentSelection.clear(), n.focused = !1);
};
Ei.beforeinput = (n, e) => {
  if (oi && el && e.inputType == "deleteContentBackward") {
    n.domObserver.flushSoon();
    let { domChangeCount: r } = n.input;
    setTimeout(() => {
      if (n.input.domChangeCount != r || (n.dom.blur(), n.focus(), n.someProp("handleKeyDown", (s) => s(n, eu(8, "Backspace")))))
        return;
      let { $cursor: i } = n.state.selection;
      i && i.pos > 0 && n.dispatch(n.state.tr.delete(i.pos - 1, i.pos).scrollIntoView());
    }, 50);
  }
};
for (let n in Si)
  Ei[n] = Si[n];
function F0(n, e) {
  if (n == e)
    return !0;
  for (let t in n)
    if (n[t] !== e[t])
      return !1;
  for (let t in e)
    if (!(t in n))
      return !1;
  return !0;
}
let oV = class jse {
  constructor(e, t) {
    this.toDOM = e, this.spec = t || Tu, this.side = this.spec.side || 0;
  }
  map(e, t, r, i) {
    let { pos: s, deleted: o } = e.mapResult(t.from + i, this.side < 0 ? -1 : 1);
    return o ? null : new Ro(s - r, s - r, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof jse && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && F0(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
};
class dc {
  constructor(e, t) {
    this.attrs = e, this.spec = t || Tu;
  }
  map(e, t, r, i) {
    let s = e.map(t.from + i, this.spec.inclusiveStart ? -1 : 1) - r, o = e.map(t.to + i, this.spec.inclusiveEnd ? 1 : -1) - r;
    return s >= o ? null : new Ro(s, o, this);
  }
  valid(e, t) {
    return t.from < t.to;
  }
  eq(e) {
    return this == e || e instanceof dc && F0(this.attrs, e.attrs) && F0(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof dc;
  }
  destroy() {
  }
}
let pst = class Wse {
  constructor(e, t) {
    this.attrs = e, this.spec = t || Tu;
  }
  map(e, t, r, i) {
    let s = e.mapResult(t.from + i, 1);
    if (s.deleted)
      return null;
    let o = e.mapResult(t.to + i, -1);
    return o.deleted || o.pos <= s.pos ? null : new Ro(s.pos - r, o.pos - r, this);
  }
  valid(e, t) {
    let { index: r, offset: i } = e.content.findIndex(t.from), s;
    return i == t.from && !(s = e.child(r)).isText && i + s.nodeSize == t.to;
  }
  eq(e) {
    return this == e || e instanceof Wse && F0(this.attrs, e.attrs) && F0(this.spec, e.spec);
  }
  destroy() {
  }
}, Ro = class Np {
  /**
  @internal
  */
  constructor(e, t, r) {
    this.from = e, this.to = t, this.type = r;
  }
  /**
  @internal
  */
  copy(e, t) {
    return new Np(e, t, this.type);
  }
  /**
  @internal
  */
  eq(e, t = 0) {
    return this.type.eq(e.type) && this.from + t == e.from && this.to + t == e.to;
  }
  /**
  @internal
  */
  map(e, t, r) {
    return this.type.map(e, this, t, r);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, t, r) {
    return new Np(e, e, new oV(t, r));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, t, r, i) {
    return new Np(e, t, new dc(r, i));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, t, r, i) {
    return new Np(e, t, new pst(r, i));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof dc;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof oV;
  }
};
const Fd = [], Tu = {};
class Nn {
  /**
  @internal
  */
  constructor(e, t) {
    this.local = e.length ? e : Fd, this.children = t.length ? t : Fd;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, t) {
    return t.length ? ib(t, e, 0, Tu) : Jr;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, t, r) {
    let i = [];
    return this.findInner(e ?? 0, t ?? 1e9, i, 0, r), i;
  }
  findInner(e, t, r, i, s) {
    for (let o = 0; o < this.local.length; o++) {
      let a = this.local[o];
      a.from <= t && a.to >= e && (!s || s(a.spec)) && r.push(a.copy(a.from + i, a.to + i));
    }
    for (let o = 0; o < this.children.length; o += 3)
      if (this.children[o] < t && this.children[o + 1] > e) {
        let a = this.children[o] + 1;
        this.children[o + 2].findInner(e - a, t - a, r, i + a, s);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, t, r) {
    return this == Jr || e.maps.length == 0 ? this : this.mapInner(e, t, 0, 0, r || Tu);
  }
  /**
  @internal
  */
  mapInner(e, t, r, i, s) {
    let o;
    for (let a = 0; a < this.local.length; a++) {
      let l = this.local[a].map(e, r, i);
      l && l.type.valid(t, l) ? (o || (o = [])).push(l) : s.onRemove && s.onRemove(this.local[a].spec);
    }
    return this.children.length ? mst(this.children, o || [], e, t, r, i, s) : o ? new Nn(o.sort(Au), Fd) : Jr;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, t) {
    return t.length ? this == Jr ? Nn.create(e, t) : this.addInner(e, t, 0) : this;
  }
  addInner(e, t, r) {
    let i, s = 0;
    e.forEach((a, l) => {
      let c = l + r, u;
      if (u = Kse(t, a, c)) {
        for (i || (i = this.children.slice()); s < i.length && i[s] < l; )
          s += 3;
        i[s] == l ? i[s + 2] = i[s + 2].addInner(a, u, c + 1) : i.splice(s, 0, l, l + a.nodeSize, ib(u, a, c + 1, Tu)), s += 3;
      }
    });
    let o = Gse(s ? qse(t) : t, -r);
    for (let a = 0; a < o.length; a++)
      o[a].type.valid(e, o[a]) || o.splice(a--, 1);
    return new Nn(o.length ? this.local.concat(o).sort(Au) : this.local, i || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == Jr ? this : this.removeInner(e, 0);
  }
  removeInner(e, t) {
    let r = this.children, i = this.local;
    for (let s = 0; s < r.length; s += 3) {
      let o, a = r[s] + t, l = r[s + 1] + t;
      for (let u = 0, d; u < e.length; u++)
        (d = e[u]) && d.from > a && d.to < l && (e[u] = null, (o || (o = [])).push(d));
      if (!o)
        continue;
      r == this.children && (r = this.children.slice());
      let c = r[s + 2].removeInner(o, a + 1);
      c != Jr ? r[s + 2] = c : (r.splice(s, 3), s -= 3);
    }
    if (i.length) {
      for (let s = 0, o; s < e.length; s++)
        if (o = e[s])
          for (let a = 0; a < i.length; a++)
            i[a].eq(o, t) && (i == this.local && (i = this.local.slice()), i.splice(a--, 1));
    }
    return r == this.children && i == this.local ? this : i.length || r.length ? new Nn(i, r) : Jr;
  }
  forChild(e, t) {
    if (this == Jr)
      return this;
    if (t.isLeaf)
      return Nn.empty;
    let r, i;
    for (let a = 0; a < this.children.length; a += 3)
      if (this.children[a] >= e) {
        this.children[a] == e && (r = this.children[a + 2]);
        break;
      }
    let s = e + 1, o = s + t.content.size;
    for (let a = 0; a < this.local.length; a++) {
      let l = this.local[a];
      if (l.from < o && l.to > s && l.type instanceof dc) {
        let c = Math.max(s, l.from) - s, u = Math.min(o, l.to) - s;
        c < u && (i || (i = [])).push(l.copy(c, u));
      }
    }
    if (i) {
      let a = new Nn(i.sort(Au), Fd);
      return r ? new Gl([a, r]) : a;
    }
    return r || Jr;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof Nn) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let t = 0; t < this.local.length; t++)
      if (!this.local[t].eq(e.local[t]))
        return !1;
    for (let t = 0; t < this.children.length; t += 3)
      if (this.children[t] != e.children[t] || this.children[t + 1] != e.children[t + 1] || !this.children[t + 2].eq(e.children[t + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return rO(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == Jr)
      return Fd;
    if (e.inlineContent || !this.local.some(dc.is))
      return this.local;
    let t = [];
    for (let r = 0; r < this.local.length; r++)
      this.local[r].type instanceof dc || t.push(this.local[r]);
    return t;
  }
  forEachSet(e) {
    e(this);
  }
}
Nn.empty = new Nn([], []);
Nn.removeOverlap = rO;
const Jr = Nn.empty;
class Gl {
  constructor(e) {
    this.members = e;
  }
  map(e, t) {
    const r = this.members.map((i) => i.map(e, t, Tu));
    return Gl.from(r);
  }
  forChild(e, t) {
    if (t.isLeaf)
      return Nn.empty;
    let r = [];
    for (let i = 0; i < this.members.length; i++) {
      let s = this.members[i].forChild(e, t);
      s != Jr && (s instanceof Gl ? r = r.concat(s.members) : r.push(s));
    }
    return Gl.from(r);
  }
  eq(e) {
    if (!(e instanceof Gl) || e.members.length != this.members.length)
      return !1;
    for (let t = 0; t < this.members.length; t++)
      if (!this.members[t].eq(e.members[t]))
        return !1;
    return !0;
  }
  locals(e) {
    let t, r = !0;
    for (let i = 0; i < this.members.length; i++) {
      let s = this.members[i].localsInner(e);
      if (s.length)
        if (!t)
          t = s;
        else {
          r && (t = t.slice(), r = !1);
          for (let o = 0; o < s.length; o++)
            t.push(s[o]);
        }
    }
    return t ? rO(r ? t : t.sort(Au)) : Fd;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return Jr;
      case 1:
        return e[0];
      default:
        return new Gl(e.every((t) => t instanceof Nn) ? e : e.reduce((t, r) => t.concat(r instanceof Nn ? r : r.members), []));
    }
  }
  forEachSet(e) {
    for (let t = 0; t < this.members.length; t++)
      this.members[t].forEachSet(e);
  }
}
function mst(n, e, t, r, i, s, o) {
  let a = n.slice();
  for (let c = 0, u = s; c < t.maps.length; c++) {
    let d = 0;
    t.maps[c].forEach((f, h, m, g) => {
      let v = g - m - (h - f);
      for (let y = 0; y < a.length; y += 3) {
        let b = a[y + 1];
        if (b < 0 || f > b + u - d)
          continue;
        let x = a[y] + u - d;
        h >= x ? a[y + 1] = f <= x ? -2 : -1 : f >= u && v && (a[y] += v, a[y + 1] += v);
      }
      d += v;
    }), u = t.maps[c].map(u, -1);
  }
  let l = !1;
  for (let c = 0; c < a.length; c += 3)
    if (a[c + 1] < 0) {
      if (a[c + 1] == -2) {
        l = !0, a[c + 1] = -1;
        continue;
      }
      let u = t.map(n[c] + s), d = u - i;
      if (d < 0 || d >= r.content.size) {
        l = !0;
        continue;
      }
      let f = t.map(n[c + 1] + s, -1), h = f - i, { index: m, offset: g } = r.content.findIndex(d), v = r.maybeChild(m);
      if (v && g == d && g + v.nodeSize == h) {
        let y = a[c + 2].mapInner(t, v, u + 1, n[c] + s + 1, o);
        y != Jr ? (a[c] = d, a[c + 1] = h, a[c + 2] = y) : (a[c + 1] = -2, l = !0);
      } else
        l = !0;
    }
  if (l) {
    let c = gst(a, n, e, t, i, s, o), u = ib(c, r, 0, o);
    e = u.local;
    for (let d = 0; d < a.length; d += 3)
      a[d + 1] < 0 && (a.splice(d, 3), d -= 3);
    for (let d = 0, f = 0; d < u.children.length; d += 3) {
      let h = u.children[d];
      for (; f < a.length && a[f] < h; )
        f += 3;
      a.splice(f, 0, u.children[d], u.children[d + 1], u.children[d + 2]);
    }
  }
  return new Nn(e.sort(Au), a);
}
function Gse(n, e) {
  if (!e || !n.length)
    return n;
  let t = [];
  for (let r = 0; r < n.length; r++) {
    let i = n[r];
    t.push(new Ro(i.from + e, i.to + e, i.type));
  }
  return t;
}
function gst(n, e, t, r, i, s, o) {
  function a(l, c) {
    for (let u = 0; u < l.local.length; u++) {
      let d = l.local[u].map(r, i, c);
      d ? t.push(d) : o.onRemove && o.onRemove(l.local[u].spec);
    }
    for (let u = 0; u < l.children.length; u += 3)
      a(l.children[u + 2], l.children[u] + c + 1);
  }
  for (let l = 0; l < n.length; l += 3)
    n[l + 1] == -1 && a(n[l + 2], e[l] + s + 1);
  return t;
}
function Kse(n, e, t) {
  if (e.isLeaf)
    return null;
  let r = t + e.nodeSize, i = null;
  for (let s = 0, o; s < n.length; s++)
    (o = n[s]) && o.from > t && o.to < r && ((i || (i = [])).push(o), n[s] = null);
  return i;
}
function qse(n) {
  let e = [];
  for (let t = 0; t < n.length; t++)
    n[t] != null && e.push(n[t]);
  return e;
}
function ib(n, e, t, r) {
  let i = [], s = !1;
  e.forEach((a, l) => {
    let c = Kse(n, a, l + t);
    if (c) {
      s = !0;
      let u = ib(c, a, t + l + 1, r);
      u != Jr && i.push(l, l + a.nodeSize, u);
    }
  });
  let o = Gse(s ? qse(n) : n, -t).sort(Au);
  for (let a = 0; a < o.length; a++)
    o[a].type.valid(e, o[a]) || (r.onRemove && r.onRemove(o[a].spec), o.splice(a--, 1));
  return o.length || i.length ? new Nn(o, i) : Jr;
}
function Au(n, e) {
  return n.from - e.from || n.to - e.to;
}
function rO(n) {
  let e = n;
  for (let t = 0; t < e.length - 1; t++) {
    let r = e[t];
    if (r.from != r.to)
      for (let i = t + 1; i < e.length; i++) {
        let s = e[i];
        if (s.from == r.from) {
          s.to != r.to && (e == n && (e = n.slice()), e[i] = s.copy(s.from, r.to), aV(e, i + 1, s.copy(r.to, s.to)));
          continue;
        } else {
          s.from < r.to && (e == n && (e = n.slice()), e[t] = r.copy(r.from, s.from), aV(e, i, r.copy(s.from, r.to)));
          break;
        }
      }
  }
  return e;
}
function aV(n, e, t) {
  for (; e < n.length && Au(t, n[e]) > 0; )
    e++;
  n.splice(e, 0, t);
}
function a8(n) {
  let e = [];
  return n.someProp("decorations", (t) => {
    let r = t(n.state);
    r && r != Jr && e.push(r);
  }), n.cursorWrapper && e.push(Nn.create(n.state.doc, [n.cursorWrapper.deco])), Gl.from(e);
}
const vst = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, yst = Vi && cc <= 11;
class bst {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
let wst = class {
  constructor(e, t) {
    this.view = e, this.handleDOMChange = t, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new bst(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((r) => {
      for (let i = 0; i < r.length; i++)
        this.queue.push(r[i]);
      Vi && cc <= 11 && r.some((i) => i.type == "childList" && i.removedNodes.length || i.type == "characterData" && i.oldValue.length > i.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), yst && (this.onCharData = (r) => {
      this.queue.push({ target: r.target, type: "characterData", oldValue: r.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, vst)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let t = 0; t < e.length; t++)
          this.queue.push(e[t]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (QU(this.view)) {
      if (this.suppressingSelectionUpdates)
        return al(this.view);
      if (Vi && cc <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && Vu(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let t = /* @__PURE__ */ new Set(), r;
    for (let s = e.focusNode; s; s = sh(s))
      t.add(s);
    for (let s = e.anchorNode; s; s = sh(s))
      if (t.has(s)) {
        r = s;
        break;
      }
    let i = r && this.view.docView.nearestDesc(r);
    if (i && i.ignoreMutation({
      type: "selection",
      target: r.nodeType == 3 ? r.parentNode : r
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let t = this.pendingRecords();
    t.length && (this.queue = []);
    let r = e.domSelectionRange(), i = !this.suppressingSelectionUpdates && !this.currentSelection.eq(r) && QU(e) && !this.ignoreSelectionChange(r), s = -1, o = -1, a = !1, l = [];
    if (e.editable)
      for (let u = 0; u < t.length; u++) {
        let d = this.registerMutation(t[u], l);
        d && (s = s < 0 ? d.from : Math.min(d.from, s), o = o < 0 ? d.to : Math.max(d.to, o), d.typeOver && (a = !0));
      }
    if (Fs && l.length) {
      let u = l.filter((d) => d.nodeName == "BR");
      if (u.length == 2) {
        let [d, f] = u;
        d.parentNode && d.parentNode.parentNode == f.parentNode ? f.remove() : d.remove();
      } else {
        let { focusNode: d } = this.currentSelection;
        for (let f of u) {
          let h = f.parentNode;
          h && h.nodeName == "LI" && (!d || Sst(e, d) != h) && f.remove();
        }
      }
    }
    let c = null;
    s < 0 && i && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && rx(r) && (c = Z_(e)) && c.eq(pt.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, al(e), this.currentSelection.set(r), e.scrollToSelection()) : (s > -1 || i) && (s > -1 && (e.docView.markDirty(s, o), xst(e)), this.handleDOMChange(s, o, a, l), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(r) || al(e), this.currentSelection.set(r));
  }
  registerMutation(e, t) {
    if (t.indexOf(e.target) > -1)
      return null;
    let r = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (r == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !r || r.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let u = 0; u < e.addedNodes.length; u++) {
        let d = e.addedNodes[u];
        t.push(d), d.nodeType == 3 && (this.lastChangedTextNode = d);
      }
      if (r.contentDOM && r.contentDOM != r.dom && !r.contentDOM.contains(e.target))
        return { from: r.posBefore, to: r.posAfter };
      let i = e.previousSibling, s = e.nextSibling;
      if (Vi && cc <= 11 && e.addedNodes.length)
        for (let u = 0; u < e.addedNodes.length; u++) {
          let { previousSibling: d, nextSibling: f } = e.addedNodes[u];
          (!d || Array.prototype.indexOf.call(e.addedNodes, d) < 0) && (i = d), (!f || Array.prototype.indexOf.call(e.addedNodes, f) < 0) && (s = f);
        }
      let o = i && i.parentNode == e.target ? Hr(i) + 1 : 0, a = r.localPosFromDOM(e.target, o, -1), l = s && s.parentNode == e.target ? Hr(s) : e.target.childNodes.length, c = r.localPosFromDOM(e.target, l, 1);
      return { from: a, to: c };
    } else return e.type == "attributes" ? { from: r.posAtStart - r.border, to: r.posAtEnd + r.border } : (this.lastChangedTextNode = e.target, {
      from: r.posAtStart,
      to: r.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: e.target.nodeValue == e.oldValue
    });
  }
}, lV = /* @__PURE__ */ new WeakMap(), cV = !1;
function xst(n) {
  if (!lV.has(n) && (lV.set(n, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(n.dom).whiteSpace) !== -1)) {
    if (n.requiresGeckoHackNode = Fs, cV)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), cV = !0;
  }
}
function uV(n, e) {
  let t = e.startContainer, r = e.startOffset, i = e.endContainer, s = e.endOffset, o = n.domAtPos(n.state.selection.anchor);
  return Vu(o.node, o.offset, i, s) && ([t, r, i, s] = [i, s, t, r]), { anchorNode: t, anchorOffset: r, focusNode: i, focusOffset: s };
}
function Est(n, e) {
  if (e.getComposedRanges) {
    let i = e.getComposedRanges(n.root)[0];
    if (i)
      return uV(n, i);
  }
  let t;
  function r(i) {
    i.preventDefault(), i.stopImmediatePropagation(), t = i.getTargetRanges()[0];
  }
  return n.dom.addEventListener("beforeinput", r, !0), document.execCommand("indent"), n.dom.removeEventListener("beforeinput", r, !0), t ? uV(n, t) : null;
}
function Sst(n, e) {
  for (let t = e.parentNode; t && t != n.dom; t = t.parentNode) {
    let r = n.docView.nearestDesc(t, !0);
    if (r && r.node.isBlock)
      return t;
  }
  return null;
}
function Cst(n, e, t) {
  let { node: r, fromOffset: i, toOffset: s, from: o, to: a } = n.docView.parseRange(e, t), l = n.domSelectionRange(), c, u = l.anchorNode;
  if (u && n.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (c = [{ node: u, offset: l.anchorOffset }], rx(l) || c.push({ node: l.focusNode, offset: l.focusOffset })), oi && n.input.lastKeyCode === 8)
    for (let v = s; v > i; v--) {
      let y = r.childNodes[v - 1], b = y.pmViewDesc;
      if (y.nodeName == "BR" && !b) {
        s = v;
        break;
      }
      if (!b || b.size)
        break;
    }
  let d = n.state.doc, f = n.someProp("domParser") || em.fromSchema(n.state.schema), h = d.resolve(o), m = null, g = f.parse(r, {
    topNode: h.parent,
    topMatch: h.parent.contentMatchAt(h.index()),
    topOpen: !0,
    from: i,
    to: s,
    preserveWhitespace: h.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: c,
    ruleFromNode: Tst,
    context: h
  });
  if (c && c[0].pos != null) {
    let v = c[0].pos, y = c[1] && c[1].pos;
    y == null && (y = v), m = { anchor: v + o, head: y + o };
  }
  return { doc: g, sel: m, from: o, to: a };
}
function Tst(n) {
  let e = n.pmViewDesc;
  if (e)
    return e.parseRule();
  if (n.nodeName == "BR" && n.parentNode) {
    if (xi && /^(ul|ol)$/i.test(n.parentNode.nodeName)) {
      let t = document.createElement("div");
      return t.appendChild(document.createElement("li")), { skip: t };
    } else if (n.parentNode.lastChild == n || xi && /^(tr|table)$/i.test(n.parentNode.nodeName))
      return { ignore: !0 };
  } else if (n.nodeName == "IMG" && n.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const Ast = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function Mst(n, e, t, r, i) {
  let s = n.input.compositionPendingChanges || (n.composing ? n.input.compositionID : 0);
  if (n.input.compositionPendingChanges = 0, e < 0) {
    let S = n.input.lastSelectionTime > Date.now() - 50 ? n.input.lastSelectionOrigin : null, M = Z_(n, S);
    if (M && !n.state.selection.eq(M)) {
      if (oi && el && n.input.lastKeyCode === 13 && Date.now() - 100 < n.input.lastKeyCodeTime && n.someProp("handleKeyDown", (_) => _(n, eu(13, "Enter"))))
        return;
      let k = n.state.tr.setSelection(M);
      S == "pointer" ? k.setMeta("pointer", !0) : S == "key" && k.scrollIntoView(), s && k.setMeta("composition", s), n.dispatch(k);
    }
    return;
  }
  let o = n.state.doc.resolve(e), a = o.sharedDepth(t);
  e = o.before(a + 1), t = n.state.doc.resolve(t).after(a + 1);
  let l = n.state.selection, c = Cst(n, e, t), u = n.state.doc, d = u.slice(c.from, c.to), f, h;
  n.input.lastKeyCode === 8 && Date.now() - 100 < n.input.lastKeyCodeTime ? (f = n.state.selection.to, h = "end") : (f = n.state.selection.from, h = "start"), n.input.lastKeyCode = null;
  let m = Ost(d.content, c.doc.content, c.from, f, h);
  if (m && n.input.domChangeCount++, (oh && n.input.lastIOSEnter > Date.now() - 225 || el) && i.some((S) => S.nodeType == 1 && !Ast.test(S.nodeName)) && (!m || m.endA >= m.endB) && n.someProp("handleKeyDown", (S) => S(n, eu(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (!m)
    if (r && l instanceof vt && !l.empty && l.$head.sameParent(l.$anchor) && !n.composing && !(c.sel && c.sel.anchor != c.sel.head))
      m = { start: l.from, endA: l.to, endB: l.to };
    else {
      if (c.sel) {
        let S = dV(n, n.state.doc, c.sel);
        if (S && !S.eq(n.state.selection)) {
          let M = n.state.tr.setSelection(S);
          s && M.setMeta("composition", s), n.dispatch(M);
        }
      }
      return;
    }
  n.state.selection.from < n.state.selection.to && m.start == m.endB && n.state.selection instanceof vt && (m.start > n.state.selection.from && m.start <= n.state.selection.from + 2 && n.state.selection.from >= c.from ? m.start = n.state.selection.from : m.endA < n.state.selection.to && m.endA >= n.state.selection.to - 2 && n.state.selection.to <= c.to && (m.endB += n.state.selection.to - m.endA, m.endA = n.state.selection.to)), Vi && cc <= 11 && m.endB == m.start + 1 && m.endA == m.start && m.start > c.from && c.doc.textBetween(m.start - c.from - 1, m.start - c.from + 1) == "  " && (m.start--, m.endA--, m.endB--);
  let g = c.doc.resolveNoCache(m.start - c.from), v = c.doc.resolveNoCache(m.endB - c.from), y = u.resolve(m.start), b = g.sameParent(v) && g.parent.inlineContent && y.end() >= m.endA;
  if ((oh && n.input.lastIOSEnter > Date.now() - 225 && (!b || i.some((S) => S.nodeName == "DIV" || S.nodeName == "P")) || !b && g.pos < c.doc.content.size && (!g.sameParent(v) || !g.parent.inlineContent) && g.pos < v.pos && !/\S/.test(c.doc.textBetween(g.pos, v.pos, "", ""))) && n.someProp("handleKeyDown", (S) => S(n, eu(13, "Enter")))) {
    n.input.lastIOSEnter = 0;
    return;
  }
  if (n.state.selection.anchor > m.start && _st(u, m.start, m.endA, g, v) && n.someProp("handleKeyDown", (S) => S(n, eu(8, "Backspace")))) {
    el && oi && n.domObserver.suppressSelectionUpdates();
    return;
  }
  oi && m.endB == m.start && (n.input.lastChromeDelete = Date.now()), el && !b && g.start() != v.start() && v.parentOffset == 0 && g.depth == v.depth && c.sel && c.sel.anchor == c.sel.head && c.sel.head == m.endA && (m.endB -= 2, v = c.doc.resolveNoCache(m.endB - c.from), setTimeout(() => {
    n.someProp("handleKeyDown", function(S) {
      return S(n, eu(13, "Enter"));
    });
  }, 20));
  let x = m.start, E = m.endA, w = (S) => {
    let M = S || n.state.tr.replace(x, E, c.doc.slice(m.start - c.from, m.endB - c.from));
    if (c.sel) {
      let k = dV(n, M.doc, c.sel);
      k && !(oi && n.composing && k.empty && (m.start != m.endB || n.input.lastChromeDelete < Date.now() - 100) && (k.head == x || k.head == M.mapping.map(E) - 1) || Vi && k.empty && k.head == x) && M.setSelection(k);
    }
    return s && M.setMeta("composition", s), M.scrollIntoView();
  }, C;
  if (b)
    if (g.pos == v.pos) {
      Vi && cc <= 11 && g.parentOffset == 0 && (n.domObserver.suppressSelectionUpdates(), setTimeout(() => al(n), 20));
      let S = w(n.state.tr.delete(x, E)), M = u.resolve(m.start).marksAcross(u.resolve(m.endA));
      M && S.ensureMarks(M), n.dispatch(S);
    } else if (
      // Adding or removing a mark
      m.endA == m.endB && (C = kst(g.parent.content.cut(g.parentOffset, v.parentOffset), y.parent.content.cut(y.parentOffset, m.endA - y.start())))
    ) {
      let S = w(n.state.tr);
      C.type == "add" ? S.addMark(x, E, C.mark) : S.removeMark(x, E, C.mark), n.dispatch(S);
    } else if (g.parent.child(g.index()).isText && g.index() == v.index() - (v.textOffset ? 0 : 1)) {
      let S = g.parent.textBetween(g.parentOffset, v.parentOffset), M = () => w(n.state.tr.insertText(S, x, E));
      n.someProp("handleTextInput", (k) => k(n, x, E, S, M)) || n.dispatch(M());
    } else
      n.dispatch(w());
  else
    n.dispatch(w());
}
function dV(n, e, t) {
  return Math.max(t.anchor, t.head) > e.content.size ? null : Q_(n, e.resolve(t.anchor), e.resolve(t.head));
}
function kst(n, e) {
  let t = n.firstChild.marks, r = e.firstChild.marks, i = t, s = r, o, a, l;
  for (let u = 0; u < r.length; u++)
    i = r[u].removeFromSet(i);
  for (let u = 0; u < t.length; u++)
    s = t[u].removeFromSet(s);
  if (i.length == 1 && s.length == 0)
    a = i[0], o = "add", l = (u) => u.mark(a.addToSet(u.marks));
  else if (i.length == 0 && s.length == 1)
    a = s[0], o = "remove", l = (u) => u.mark(a.removeFromSet(u.marks));
  else
    return null;
  let c = [];
  for (let u = 0; u < e.childCount; u++)
    c.push(l(e.child(u)));
  if (Ee.from(c).eq(n))
    return { mark: a, type: o };
}
function _st(n, e, t, r, i) {
  if (
    // The content must have shrunk
    t - e <= i.pos - r.pos || // newEnd must point directly at or after the end of the block that newStart points into
    l8(r, !0, !1) < i.pos
  )
    return !1;
  let s = n.resolve(e);
  if (!r.parent.isTextblock) {
    let a = s.nodeAfter;
    return a != null && t == e + a.nodeSize;
  }
  if (s.parentOffset < s.parent.content.size || !s.parent.isTextblock)
    return !1;
  let o = n.resolve(l8(s, !0, !0));
  return !o.parent.isTextblock || o.pos > t || l8(o, !0, !1) < t ? !1 : r.parent.content.cut(r.parentOffset).eq(o.parent.content);
}
function l8(n, e, t) {
  let r = n.depth, i = e ? n.end() : n.pos;
  for (; r > 0 && (e || n.indexAfter(r) == n.node(r).childCount); )
    r--, i++, e = !1;
  if (t) {
    let s = n.node(r).maybeChild(n.indexAfter(r));
    for (; s && !s.isLeaf; )
      s = s.firstChild, i++;
  }
  return i;
}
function Ost(n, e, t, r, i) {
  let s = n.findDiffStart(e, t);
  if (s == null)
    return null;
  let { a: o, b: a } = n.findDiffEnd(e, t + n.size, t + e.size);
  if (i == "end") {
    let l = Math.max(0, s - Math.min(o, a));
    r -= o + l - s;
  }
  if (o < s && n.size < e.size) {
    let l = r <= s && r >= o ? s - r : 0;
    s -= l, s && s < e.size && fV(e.textBetween(s - 1, s + 1)) && (s += l ? 1 : -1), a = s + (a - o), o = s;
  } else if (a < s) {
    let l = r <= s && r >= a ? s - r : 0;
    s -= l, s && s < n.size && fV(n.textBetween(s - 1, s + 1)) && (s += l ? 1 : -1), o = s + (o - a), a = s;
  }
  return { start: s, endA: o, endB: a };
}
function fV(n) {
  if (n.length != 2)
    return !1;
  let e = n.charCodeAt(0), t = n.charCodeAt(1);
  return e >= 56320 && e <= 57343 && t >= 55296 && t <= 56319;
}
let Yse = class {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, t) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new qit(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = t, this.state = t.state, this.directPlugins = t.plugins || [], this.directPlugins.forEach(vV), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = mV(this), pV(this), this.nodeViews = gV(this), this.docView = GU(this.state.doc, hV(this), a8(this), this.dom, this), this.domObserver = new wst(this, (r, i, s, o) => Mst(this, r, i, s, o)), this.domObserver.start(), Yit(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let t in e)
        this._props[t] = e[t];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && r9(this);
    let t = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(vV), this.directPlugins = e.plugins), this.updateStateInner(e.state, t);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let t = {};
    for (let r in this._props)
      t[r] = this._props[r];
    t.state = this.state;
    for (let r in e)
      t[r] = e[r];
    this.update(t);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, t) {
    var r;
    let i = this.state, s = !1, o = !1;
    e.storedMarks && this.composing && (zse(this), o = !0), this.state = e;
    let a = i.plugins != e.plugins || this._props.plugins != t.plugins;
    if (a || this._props.plugins != t.plugins || this._props.nodeViews != t.nodeViews) {
      let h = gV(this);
      Rst(h, this.nodeViews) && (this.nodeViews = h, s = !0);
    }
    (a || t.handleDOMEvents != this._props.handleDOMEvents) && r9(this), this.editable = mV(this), pV(this);
    let l = a8(this), c = hV(this), u = i.plugins != e.plugins && !i.doc.eq(e.doc) ? "reset" : e.scrollToSelection > i.scrollToSelection ? "to selection" : "preserve", d = s || !this.docView.matchesNode(e.doc, c, l);
    (d || !e.selection.eq(i.selection)) && (o = !0);
    let f = u == "preserve" && o && this.dom.style.overflowAnchor == null && cit(this);
    if (o) {
      this.domObserver.stop();
      let h = d && (Vi || oi) && !this.composing && !i.selection.empty && !e.selection.empty && Ist(i.selection, e.selection);
      if (d) {
        let m = oi ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = lst(this)), (s || !this.docView.update(e.doc, c, l, this)) && (this.docView.updateOuterDeco(c), this.docView.destroy(), this.docView = GU(e.doc, c, l, this.dom, this)), m && !this.trackWrites && (h = !0);
      }
      h || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && Pit(this)) ? al(this, h) : (kse(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(i), !((r = this.dragging) === null || r === void 0) && r.node && !i.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, i), u == "reset" ? this.dom.scrollTop = 0 : u == "to selection" ? this.scrollToSelection() : f && uit(f);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!(!e || !this.dom.contains(e.nodeType == 1 ? e : e.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (t) => t(this))) if (this.state.selection instanceof nt) {
        let t = this.docView.domAfterPos(this.state.selection.from);
        t.nodeType == 1 && zU(this, t.getBoundingClientRect(), e);
      } else
        zU(this, this.coordsAtPos(this.state.selection.head, 1), e);
    }
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let t = 0; t < this.directPlugins.length; t++) {
        let r = this.directPlugins[t];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
      for (let t = 0; t < this.state.plugins.length; t++) {
        let r = this.state.plugins[t];
        r.spec.view && this.pluginViews.push(r.spec.view(this));
      }
    } else
      for (let t = 0; t < this.pluginViews.length; t++) {
        let r = this.pluginViews[t];
        r.update && r.update(this, e);
      }
  }
  updateDraggedNode(e, t) {
    let r = e.node, i = -1;
    if (this.state.doc.nodeAt(r.from) == r.node)
      i = r.from;
    else {
      let s = r.from + (this.state.doc.content.size - t.doc.content.size);
      (s > 0 && this.state.doc.nodeAt(s)) == r.node && (i = s);
    }
    this.dragging = new Use(e.slice, e.move, i < 0 ? void 0 : nt.create(this.state.doc, i));
  }
  someProp(e, t) {
    let r = this._props && this._props[e], i;
    if (r != null && (i = t ? t(r) : r))
      return i;
    for (let o = 0; o < this.directPlugins.length; o++) {
      let a = this.directPlugins[o].props[e];
      if (a != null && (i = t ? t(a) : a))
        return i;
    }
    let s = this.state.plugins;
    if (s)
      for (let o = 0; o < s.length; o++) {
        let a = s[o].props[e];
        if (a != null && (i = t ? t(a) : a))
          return i;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (Vi) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && dit(this.dom), al(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let t = this.dom.parentNode; t; t = t.parentNode)
        if (t.nodeType == 9 || t.nodeType == 11 && t.host)
          return t.getSelection || (Object.getPrototypeOf(t).getSelection = () => t.ownerDocument.getSelection()), this._root = t;
    }
    return e || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return git(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, t = 1) {
    return wse(this, e, t);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, t = 0) {
    return this.docView.domFromPos(e, t);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let t = this.docView.descAt(e);
    return t ? t.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, t, r = -1) {
    let i = this.docView.posFromDOM(e, t, r);
    if (i == null)
      throw new RangeError("DOM position not inside the editor");
    return i;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, t) {
    return xit(this, t || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, t) {
    return $0(this, "", e, !1, t || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, t) {
    return $0(this, e, null, !0, t || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(e) {
    return J_(this, e);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (Xit(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], a8(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, Qrt());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return Qit(this, e);
  }
  /**
  @internal
  */
  domSelectionRange() {
    let e = this.domSelection();
    return e ? xi && this.root.nodeType === 11 && rit(this.dom.ownerDocument) == this.dom && Est(this, e) || e : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
};
Yse.prototype.dispatch = function(n) {
  let e = this._props.dispatchTransaction;
  e ? e.call(this, n) : this.updateState(this.state.apply(n));
};
function hV(n) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(n.editable), n.someProp("attributes", (t) => {
    if (typeof t == "function" && (t = t(n.state)), t)
      for (let r in t)
        r == "class" ? e.class += " " + t[r] : r == "style" ? e.style = (e.style ? e.style + ";" : "") + t[r] : !e[r] && r != "contenteditable" && r != "nodeName" && (e[r] = String(t[r]));
  }), e.translate || (e.translate = "no"), [Ro.node(0, n.state.doc.content.size, e)];
}
function pV(n) {
  if (n.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), n.cursorWrapper = { dom: e, deco: Ro.widget(n.state.selection.from, e, { raw: !0, marks: n.markCursor }) };
  } else
    n.cursorWrapper = null;
}
function mV(n) {
  return !n.someProp("editable", (e) => e(n.state) === !1);
}
function Ist(n, e) {
  let t = Math.min(n.$anchor.sharedDepth(n.head), e.$anchor.sharedDepth(e.head));
  return n.$anchor.start(t) != e.$anchor.start(t);
}
function gV(n) {
  let e = /* @__PURE__ */ Object.create(null);
  function t(r) {
    for (let i in r)
      Object.prototype.hasOwnProperty.call(e, i) || (e[i] = r[i]);
  }
  return n.someProp("nodeViews", t), n.someProp("markViews", t), e;
}
function Rst(n, e) {
  let t = 0, r = 0;
  for (let i in n) {
    if (n[i] != e[i])
      return !0;
    t++;
  }
  for (let i in e)
    r++;
  return t != r;
}
function vV(n) {
  if (n.spec.state || n.spec.filterTransaction || n.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var pl = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, B0 = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, Pst = typeof navigator < "u" && /Mac/.test(navigator.platform), Dst = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var Ur = 0; Ur < 10; Ur++) pl[48 + Ur] = pl[96 + Ur] = String(Ur);
for (var Ur = 1; Ur <= 24; Ur++) pl[Ur + 111] = "F" + Ur;
for (var Ur = 65; Ur <= 90; Ur++)
  pl[Ur] = String.fromCharCode(Ur + 32), B0[Ur] = String.fromCharCode(Ur);
for (var c8 in pl) B0.hasOwnProperty(c8) || (B0[c8] = pl[c8]);
function Xse(n) {
  var e = Pst && n.metaKey && n.shiftKey && !n.ctrlKey && !n.altKey || Dst && n.shiftKey && n.key && n.key.length == 1 || n.key == "Unidentified", t = !e && n.key || (n.shiftKey ? B0 : pl)[n.keyCode] || n.key || "Unidentified";
  return t == "Esc" && (t = "Escape"), t == "Del" && (t = "Delete"), t == "Left" && (t = "ArrowLeft"), t == "Up" && (t = "ArrowUp"), t == "Right" && (t = "ArrowRight"), t == "Down" && (t = "ArrowDown"), t;
}
const Nst = typeof navigator < "u" && /Mac|iP(hone|[oa]d)/.test(navigator.platform), Lst = typeof navigator < "u" && /Win/.test(navigator.platform);
function $st(n) {
  let e = n.split(/-(?!$)/), t = e[e.length - 1];
  t == "Space" && (t = " ");
  let r, i, s, o;
  for (let a = 0; a < e.length - 1; a++) {
    let l = e[a];
    if (/^(cmd|meta|m)$/i.test(l))
      o = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      i = !0;
    else if (/^s(hift)?$/i.test(l))
      s = !0;
    else if (/^mod$/i.test(l))
      Nst ? o = !0 : i = !0;
    else
      throw new Error("Unrecognized modifier name: " + l);
  }
  return r && (t = "Alt-" + t), i && (t = "Ctrl-" + t), o && (t = "Meta-" + t), s && (t = "Shift-" + t), t;
}
function Fst(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n)
    e[$st(t)] = n[t];
  return e;
}
function u8(n, e, t = !0) {
  return e.altKey && (n = "Alt-" + n), e.ctrlKey && (n = "Ctrl-" + n), e.metaKey && (n = "Meta-" + n), t && e.shiftKey && (n = "Shift-" + n), n;
}
function Bst(n) {
  return new Cn({ props: { handleKeyDown: iO(n) } });
}
function iO(n) {
  let e = Fst(n);
  return function(t, r) {
    let i = Xse(r), s, o = e[u8(i, r)];
    if (o && o(t.state, t.dispatch, t))
      return !0;
    if (i.length == 1 && i != " ") {
      if (r.shiftKey) {
        let a = e[u8(i, r, !1)];
        if (a && a(t.state, t.dispatch, t))
          return !0;
      }
      if ((r.altKey || r.metaKey || r.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
      !(Lst && r.ctrlKey && r.altKey) && (s = pl[r.keyCode]) && s != i) {
        let a = e[u8(s, r)];
        if (a && a(t.state, t.dispatch, t))
          return !0;
      }
    }
    return !1;
  };
}
var zst = Object.defineProperty, sO = (n, e) => {
  for (var t in e)
    zst(n, t, { get: e[t], enumerable: !0 });
};
function ox(n) {
  const { state: e, transaction: t } = n;
  let { selection: r } = t, { doc: i } = t, { storedMarks: s } = t;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return s;
    },
    get selection() {
      return r;
    },
    get doc() {
      return i;
    },
    get tr() {
      return r = t.selection, i = t.doc, s = t.storedMarks, t;
    }
  };
}
var ax = class {
  constructor(n) {
    this.editor = n.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = n.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: n, editor: e, state: t } = this, { view: r } = e, { tr: i } = t, s = this.buildProps(i);
    return Object.fromEntries(
      Object.entries(n).map(([o, a]) => [o, (...c) => {
        const u = a(...c)(s);
        return !i.getMeta("preventDispatch") && !this.hasCustomState && r.dispatch(i), u;
      }])
    );
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(n, e = !0) {
    const { rawCommands: t, editor: r, state: i } = this, { view: s } = r, o = [], a = !!n, l = n || i.tr, c = () => (!a && e && !l.getMeta("preventDispatch") && !this.hasCustomState && s.dispatch(l), o.every((d) => d === !0)), u = {
      ...Object.fromEntries(
        Object.entries(t).map(([d, f]) => [d, (...m) => {
          const g = this.buildProps(l, e), v = f(...m)(g);
          return o.push(v), u;
        }])
      ),
      run: c
    };
    return u;
  }
  createCan(n) {
    const { rawCommands: e, state: t } = this, r = !1, i = n || t.tr, s = this.buildProps(i, r);
    return {
      ...Object.fromEntries(
        Object.entries(e).map(([a, l]) => [a, (...c) => l(...c)({ ...s, dispatch: void 0 })])
      ),
      chain: () => this.createChain(i, r)
    };
  }
  buildProps(n, e = !0) {
    const { rawCommands: t, editor: r, state: i } = this, { view: s } = r, o = {
      tr: n,
      editor: r,
      view: s,
      state: ox({
        state: i,
        transaction: n
      }),
      dispatch: e ? () => {
      } : void 0,
      chain: () => this.createChain(n, e),
      can: () => this.createCan(n),
      get commands() {
        return Object.fromEntries(
          Object.entries(t).map(([a, l]) => [a, (...c) => l(...c)(o)])
        );
      }
    };
    return o;
  }
}, Zse = {};
sO(Zse, {
  blur: () => Hst,
  clearContent: () => Ust,
  clearNodes: () => Vst,
  command: () => jst,
  createParagraphNear: () => Wst,
  cut: () => Gst,
  deleteCurrentNode: () => Kst,
  deleteNode: () => qst,
  deleteRange: () => Yst,
  deleteSelection: () => Xst,
  enter: () => Zst,
  exitCode: () => Qst,
  extendMarkRange: () => Jst,
  first: () => eot,
  focus: () => tot,
  forEach: () => not,
  insertContent: () => rot,
  insertContentAt: () => oot,
  joinBackward: () => cot,
  joinDown: () => lot,
  joinForward: () => uot,
  joinItemBackward: () => dot,
  joinItemForward: () => fot,
  joinTextblockBackward: () => hot,
  joinTextblockForward: () => pot,
  joinUp: () => aot,
  keyboardShortcut: () => got,
  lift: () => vot,
  liftEmptyBlock: () => yot,
  liftListItem: () => bot,
  newlineInCode: () => wot,
  resetAttributes: () => xot,
  scrollIntoView: () => Eot,
  selectAll: () => Sot,
  selectNodeBackward: () => Cot,
  selectNodeForward: () => Tot,
  selectParentNode: () => Aot,
  selectTextblockEnd: () => Mot,
  selectTextblockStart: () => kot,
  setContent: () => _ot,
  setMark: () => Got,
  setMeta: () => Kot,
  setNode: () => qot,
  setNodeSelection: () => Yot,
  setTextSelection: () => Xot,
  sinkListItem: () => Zot,
  splitBlock: () => Qot,
  splitListItem: () => Jot,
  toggleList: () => eat,
  toggleMark: () => tat,
  toggleNode: () => nat,
  toggleWrap: () => rat,
  undoInputRule: () => iat,
  unsetAllMarks: () => sat,
  unsetMark: () => oat,
  updateAttributes: () => aat,
  wrapIn: () => lat,
  wrapInList: () => cat
});
var Hst = () => ({ editor: n, view: e }) => (requestAnimationFrame(() => {
  var t;
  n.isDestroyed || (e.dom.blur(), (t = window?.getSelection()) == null || t.removeAllRanges());
}), !0), Ust = (n = !0) => ({ commands: e }) => e.setContent("", { emitUpdate: n }), Vst = () => ({ state: n, tr: e, dispatch: t }) => {
  const { selection: r } = e, { ranges: i } = r;
  return t && i.forEach(({ $from: s, $to: o }) => {
    n.doc.nodesBetween(s.pos, o.pos, (a, l) => {
      if (a.type.isText)
        return;
      const { doc: c, mapping: u } = e, d = c.resolve(u.map(l)), f = c.resolve(u.map(l + a.nodeSize)), h = d.blockRange(f);
      if (!h)
        return;
      const m = Uh(h);
      if (a.type.isTextblock) {
        const { defaultType: g } = d.parent.contentMatchAt(d.index());
        e.setNodeMarkup(h.start, g);
      }
      (m || m === 0) && e.lift(h, m);
    });
  }), !0;
}, jst = (n) => (e) => n(e), Wst = () => ({ state: n, dispatch: e }) => use(n, e), Gst = (n, e) => ({ editor: t, tr: r }) => {
  const { state: i } = t, s = i.doc.slice(n.from, n.to);
  r.deleteRange(n.from, n.to);
  const o = r.mapping.map(e);
  return r.insert(o, s.content), r.setSelection(new vt(r.doc.resolve(Math.max(o - 1, 0)))), !0;
}, Kst = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, r = t.$anchor.node();
  if (r.content.size > 0)
    return !1;
  const i = n.selection.$anchor;
  for (let s = i.depth; s > 0; s -= 1)
    if (i.node(s).type === r.type) {
      if (e) {
        const a = i.before(s), l = i.after(s);
        n.delete(a, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
};
function fr(n, e) {
  if (typeof n == "string") {
    if (!e.nodes[n])
      throw Error(`There is no node type named '${n}'. Maybe you forgot to add the extension?`);
    return e.nodes[n];
  }
  return n;
}
var qst = (n) => ({ tr: e, state: t, dispatch: r }) => {
  const i = fr(n, t.schema), s = e.selection.$anchor;
  for (let o = s.depth; o > 0; o -= 1)
    if (s.node(o).type === i) {
      if (r) {
        const l = s.before(o), c = s.after(o);
        e.delete(l, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, Yst = (n) => ({ tr: e, dispatch: t }) => {
  const { from: r, to: i } = n;
  return t && e.delete(r, i), !0;
}, Xst = () => ({ state: n, dispatch: e }) => W_(n, e), Zst = () => ({ commands: n }) => n.keyboardShortcut("Enter"), Qst = () => ({ state: n, dispatch: e }) => $rt(n, e);
function oO(n) {
  return Object.prototype.toString.call(n) === "[object RegExp]";
}
function sb(n, e, t = { strict: !0 }) {
  const r = Object.keys(e);
  return r.length ? r.every((i) => t.strict ? e[i] === n[i] : oO(e[i]) ? e[i].test(n[i]) : e[i] === n[i]) : !0;
}
function Qse(n, e, t = {}) {
  return n.find((r) => r.type === e && sb(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(t).map((i) => [i, r.attrs[i]])),
    t
  ));
}
function yV(n, e, t = {}) {
  return !!Qse(n, e, t);
}
function aO(n, e, t) {
  var r;
  if (!n || !e)
    return;
  let i = n.parent.childAfter(n.parentOffset);
  if ((!i.node || !i.node.marks.some((u) => u.type === e)) && (i = n.parent.childBefore(n.parentOffset)), !i.node || !i.node.marks.some((u) => u.type === e) || (t = t || ((r = i.node.marks[0]) == null ? void 0 : r.attrs), !Qse([...i.node.marks], e, t)))
    return;
  let o = i.index, a = n.start() + i.offset, l = o + 1, c = a + i.node.nodeSize;
  for (; o > 0 && yV([...n.parent.child(o - 1).marks], e, t); )
    o -= 1, a -= n.parent.child(o).nodeSize;
  for (; l < n.parent.childCount && yV([...n.parent.child(l).marks], e, t); )
    c += n.parent.child(l).nodeSize, l += 1;
  return {
    from: a,
    to: c
  };
}
function El(n, e) {
  if (typeof n == "string") {
    if (!e.marks[n])
      throw Error(`There is no mark type named '${n}'. Maybe you forgot to add the extension?`);
    return e.marks[n];
  }
  return n;
}
var Jst = (n, e = {}) => ({ tr: t, state: r, dispatch: i }) => {
  const s = El(n, r.schema), { doc: o, selection: a } = t, { $from: l, from: c, to: u } = a;
  if (i) {
    const d = aO(l, s, e);
    if (d && d.from <= c && d.to >= u) {
      const f = vt.create(o, d.from, d.to);
      t.setSelection(f);
    }
  }
  return !0;
}, eot = (n) => (e) => {
  const t = typeof n == "function" ? n(e) : n;
  for (let r = 0; r < t.length; r += 1)
    if (t[r](e))
      return !0;
  return !1;
};
function lO(n) {
  return n instanceof vt;
}
function tl(n = 0, e = 0, t = 0) {
  return Math.min(Math.max(n, e), t);
}
function Jse(n, e = null) {
  if (!e)
    return null;
  const t = pt.atStart(n), r = pt.atEnd(n);
  if (e === "start" || e === !0)
    return t;
  if (e === "end")
    return r;
  const i = t.from, s = r.to;
  return e === "all" ? vt.create(n, tl(0, i, s), tl(n.content.size, i, s)) : vt.create(n, tl(e, i, s), tl(e, i, s));
}
function eoe() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function lx() {
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
  navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
var tot = (n = null, e = {}) => ({ editor: t, view: r, tr: i, dispatch: s }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const o = () => {
    (lx() || eoe()) && r.dom.focus(), requestAnimationFrame(() => {
      t.isDestroyed || (r.focus(), e?.scrollIntoView && t.commands.scrollIntoView());
    });
  };
  if (r.hasFocus() && n === null || n === !1)
    return !0;
  if (s && n === null && !lO(t.state.selection))
    return o(), !0;
  const a = Jse(i.doc, n) || t.state.selection, l = t.state.selection.eq(a);
  return s && (l || i.setSelection(a), l && i.storedMarks && i.setStoredMarks(i.storedMarks), o()), !0;
}, not = (n, e) => (t) => n.every((r, i) => e(r, { ...t, index: i })), rot = (n, e) => ({ tr: t, commands: r }) => r.insertContentAt({ from: t.selection.from, to: t.selection.to }, n, e), toe = (n) => {
  const e = n.childNodes;
  for (let t = e.length - 1; t >= 0; t -= 1) {
    const r = e[t];
    r.nodeType === 3 && r.nodeValue && /^(\n\s\s|\n)$/.test(r.nodeValue) ? n.removeChild(r) : r.nodeType === 1 && toe(r);
  }
  return n;
};
function Zg(n) {
  if (typeof window > "u")
    throw new Error("[tiptap error]: there is no window object available, so this function cannot be used");
  const e = `<body>${n}</body>`, t = new window.DOMParser().parseFromString(e, "text/html").body;
  return toe(t);
}
function z0(n, e, t) {
  if (n instanceof lc || n instanceof Ee)
    return n;
  t = {
    slice: !0,
    parseOptions: {},
    ...t
  };
  const r = typeof n == "object" && n !== null, i = typeof n == "string";
  if (r)
    try {
      if (Array.isArray(n) && n.length > 0)
        return Ee.fromArray(n.map((a) => e.nodeFromJSON(a)));
      const o = e.nodeFromJSON(n);
      return t.errorOnInvalidContent && o.check(), o;
    } catch (s) {
      if (t.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: s });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", n, "Error:", s), z0("", e, t);
    }
  if (i) {
    if (t.errorOnInvalidContent) {
      let o = !1, a = "";
      const l = new Lie({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (c) => (o = !0, a = typeof c == "string" ? c : c.outerHTML, null)
              }
            ]
          }
        })
      });
      if (t.slice ? em.fromSchema(l).parseSlice(Zg(n), t.parseOptions) : em.fromSchema(l).parse(Zg(n), t.parseOptions), t.errorOnInvalidContent && o)
        throw new Error("[tiptap error]: Invalid HTML content", {
          cause: new Error(`Invalid element found: ${a}`)
        });
    }
    const s = em.fromSchema(e);
    return t.slice ? s.parseSlice(Zg(n), t.parseOptions).content : s.parse(Zg(n), t.parseOptions);
  }
  return z0("", e, t);
}
function iot(n, e, t) {
  const r = n.steps.length - 1;
  if (r < e)
    return;
  const i = n.steps[r];
  if (!(i instanceof Er || i instanceof Or))
    return;
  const s = n.mapping.maps[r];
  let o = 0;
  s.forEach((a, l, c, u) => {
    o === 0 && (o = u);
  }), n.setSelection(pt.near(n.doc.resolve(o), t));
}
var sot = (n) => !("type" in n), oot = (n, e, t) => ({ tr: r, dispatch: i, editor: s }) => {
  var o;
  if (i) {
    t = {
      parseOptions: s.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...t
    };
    let a;
    const l = (v) => {
      s.emit("contentError", {
        editor: s,
        error: v,
        disableCollaboration: () => {
          "collaboration" in s.storage && typeof s.storage.collaboration == "object" && s.storage.collaboration && (s.storage.collaboration.isDisabled = !0);
        }
      });
    }, c = {
      preserveWhitespace: "full",
      ...t.parseOptions
    };
    if (!t.errorOnInvalidContent && !s.options.enableContentCheck && s.options.emitContentError)
      try {
        z0(e, s.schema, {
          parseOptions: c,
          errorOnInvalidContent: !0
        });
      } catch (v) {
        l(v);
      }
    try {
      a = z0(e, s.schema, {
        parseOptions: c,
        errorOnInvalidContent: (o = t.errorOnInvalidContent) != null ? o : s.options.enableContentCheck
      });
    } catch (v) {
      return l(v), !1;
    }
    let { from: u, to: d } = typeof n == "number" ? { from: n, to: n } : { from: n.from, to: n.to }, f = !0, h = !0;
    if ((sot(a) ? a : [a]).forEach((v) => {
      v.check(), f = f ? v.isText && v.marks.length === 0 : !1, h = h ? v.isBlock : !1;
    }), u === d && h) {
      const { parent: v } = r.doc.resolve(u);
      v.isTextblock && !v.type.spec.code && !v.childCount && (u -= 1, d += 1);
    }
    let g;
    if (f) {
      if (Array.isArray(e))
        g = e.map((v) => v.text || "").join("");
      else if (e instanceof Ee) {
        let v = "";
        e.forEach((y) => {
          y.text && (v += y.text);
        }), g = v;
      } else typeof e == "object" && e && e.text ? g = e.text : g = e;
      r.insertText(g, u, d);
    } else {
      g = a;
      const v = r.doc.resolve(u), y = v.node(), b = v.parentOffset === 0, x = y.isText || y.isTextblock, E = y.content.size > 0;
      b && x && E && (u = Math.max(0, u - 1)), r.replaceWith(u, d, g);
    }
    t.updateSelection && iot(r, r.steps.length - 1, -1), t.applyInputRules && r.setMeta("applyInputRules", { from: u, text: g }), t.applyPasteRules && r.setMeta("applyPasteRules", { from: u, text: g });
  }
  return !0;
}, aot = () => ({ state: n, dispatch: e }) => Drt(n, e), lot = () => ({ state: n, dispatch: e }) => Nrt(n, e), cot = () => ({ state: n, dispatch: e }) => rse(n, e), uot = () => ({ state: n, dispatch: e }) => ase(n, e), dot = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const r = ex(n.doc, n.selection.$from.pos, -1);
    return r == null ? !1 : (t.join(r, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, fot = () => ({ state: n, dispatch: e, tr: t }) => {
  try {
    const r = ex(n.doc, n.selection.$from.pos, 1);
    return r == null ? !1 : (t.join(r, 2), e && e(t), !0);
  } catch {
    return !1;
  }
}, hot = () => ({ state: n, dispatch: e }) => Rrt(n, e), pot = () => ({ state: n, dispatch: e }) => Prt(n, e);
function noe() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function mot(n) {
  const e = n.split(/-(?!$)/);
  let t = e[e.length - 1];
  t === "Space" && (t = " ");
  let r, i, s, o;
  for (let a = 0; a < e.length - 1; a += 1) {
    const l = e[a];
    if (/^(cmd|meta|m)$/i.test(l))
      o = !0;
    else if (/^a(lt)?$/i.test(l))
      r = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      i = !0;
    else if (/^s(hift)?$/i.test(l))
      s = !0;
    else if (/^mod$/i.test(l))
      lx() || noe() ? o = !0 : i = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return r && (t = `Alt-${t}`), i && (t = `Ctrl-${t}`), o && (t = `Meta-${t}`), s && (t = `Shift-${t}`), t;
}
var got = (n) => ({ editor: e, view: t, tr: r, dispatch: i }) => {
  const s = mot(n).split(/-(?!$)/), o = s.find((c) => !["Alt", "Ctrl", "Meta", "Shift"].includes(c)), a = new KeyboardEvent("keydown", {
    key: o === "Space" ? " " : o,
    altKey: s.includes("Alt"),
    ctrlKey: s.includes("Ctrl"),
    metaKey: s.includes("Meta"),
    shiftKey: s.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = e.captureTransaction(() => {
    t.someProp("handleKeyDown", (c) => c(t, a));
  });
  return l?.steps.forEach((c) => {
    const u = c.map(r.mapping);
    u && i && r.maybeStep(u);
  }), !0;
};
function yc(n, e, t = {}) {
  const { from: r, to: i, empty: s } = n.selection, o = e ? fr(e, n.schema) : null, a = [];
  n.doc.nodesBetween(r, i, (d, f) => {
    if (d.isText)
      return;
    const h = Math.max(r, f), m = Math.min(i, f + d.nodeSize);
    a.push({
      node: d,
      from: h,
      to: m
    });
  });
  const l = i - r, c = a.filter((d) => o ? o.name === d.node.type.name : !0).filter((d) => sb(d.node.attrs, t, { strict: !1 }));
  return s ? !!c.length : c.reduce((d, f) => d + f.to - f.from, 0) >= l;
}
var vot = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const i = fr(n, t.schema);
  return yc(t, i, e) ? Lrt(t, r) : !1;
}, yot = () => ({ state: n, dispatch: e }) => dse(n, e), bot = (n) => ({ state: e, dispatch: t }) => {
  const r = fr(n, e.schema);
  return qrt(r)(e, t);
}, wot = () => ({ state: n, dispatch: e }) => cse(n, e);
function cx(n, e) {
  return e.nodes[n] ? "node" : e.marks[n] ? "mark" : null;
}
function bV(n, e) {
  const t = typeof e == "string" ? [e] : e;
  return Object.keys(n).reduce((r, i) => (t.includes(i) || (r[i] = n[i]), r), {});
}
var xot = (n, e) => ({ tr: t, state: r, dispatch: i }) => {
  let s = null, o = null;
  const a = cx(
    typeof n == "string" ? n : n.name,
    r.schema
  );
  return a ? (a === "node" && (s = fr(n, r.schema)), a === "mark" && (o = El(n, r.schema)), i && t.selection.ranges.forEach((l) => {
    r.doc.nodesBetween(l.$from.pos, l.$to.pos, (c, u) => {
      s && s === c.type && t.setNodeMarkup(u, void 0, bV(c.attrs, e)), o && c.marks.length && c.marks.forEach((d) => {
        o === d.type && t.addMark(u, u + c.nodeSize, o.create(bV(d.attrs, e)));
      });
    });
  }), !0) : !1;
}, Eot = () => ({ tr: n, dispatch: e }) => (e && n.scrollIntoView(), !0), Sot = () => ({ tr: n, dispatch: e }) => {
  if (e) {
    const t = new vs(n.doc);
    n.setSelection(t);
  }
  return !0;
}, Cot = () => ({ state: n, dispatch: e }) => sse(n, e), Tot = () => ({ state: n, dispatch: e }) => lse(n, e), Aot = () => ({ state: n, dispatch: e }) => zrt(n, e), Mot = () => ({ state: n, dispatch: e }) => Vrt(n, e), kot = () => ({ state: n, dispatch: e }) => Urt(n, e);
function i9(n, e, t = {}, r = {}) {
  return z0(n, e, {
    slice: !1,
    parseOptions: t,
    errorOnInvalidContent: r.errorOnInvalidContent
  });
}
var _ot = (n, { errorOnInvalidContent: e, emitUpdate: t = !0, parseOptions: r = {} } = {}) => ({ editor: i, tr: s, dispatch: o, commands: a }) => {
  const { doc: l } = s;
  if (r.preserveWhitespace !== "full") {
    const c = i9(n, i.schema, r, {
      errorOnInvalidContent: e ?? i.options.enableContentCheck
    });
    return o && s.replaceWith(0, l.content.size, c).setMeta("preventUpdate", !t), !0;
  }
  return o && s.setMeta("preventUpdate", !t), a.insertContentAt({ from: 0, to: l.content.size }, n, {
    parseOptions: r,
    errorOnInvalidContent: e ?? i.options.enableContentCheck
  });
};
function roe(n, e) {
  const t = El(e, n.schema), { from: r, to: i, empty: s } = n.selection, o = [];
  s ? (n.storedMarks && o.push(...n.storedMarks), o.push(...n.selection.$head.marks())) : n.doc.nodesBetween(r, i, (l) => {
    o.push(...l.marks);
  });
  const a = o.find((l) => l.type.name === t.name);
  return a ? { ...a.attrs } : {};
}
function ioe(n, e) {
  const t = new Qie(n);
  return e.forEach((r) => {
    r.steps.forEach((i) => {
      t.step(i);
    });
  }), t;
}
function Oot(n) {
  for (let e = 0; e < n.edgeCount; e += 1) {
    const { type: t } = n.edge(e);
    if (t.isTextblock && !t.hasRequiredAttrs())
      return t;
  }
  return null;
}
function s9(n, e) {
  const t = [];
  return n.descendants((r, i) => {
    e(r) && t.push({
      node: r,
      pos: i
    });
  }), t;
}
function Iot(n, e, t) {
  const r = [];
  return n.nodesBetween(e.from, e.to, (i, s) => {
    t(i) && r.push({
      node: i,
      pos: s
    });
  }), r;
}
function Rot(n, e) {
  for (let t = n.depth; t > 0; t -= 1) {
    const r = n.node(t);
    if (e(r))
      return {
        pos: t > 0 ? n.before(t) : 0,
        start: n.start(t),
        depth: t,
        node: r
      };
  }
}
function ux(n) {
  return (e) => Rot(e.$from, n);
}
function st(n, e, t) {
  return n.config[e] === void 0 && n.parent ? st(n.parent, e, t) : typeof n.config[e] == "function" ? n.config[e].bind({
    ...t,
    parent: n.parent ? st(n.parent, e, t) : null
  }) : n.config[e];
}
function cO(n) {
  return n.map((e) => {
    const t = {
      name: e.name,
      options: e.options,
      storage: e.storage
    }, r = st(e, "addExtensions", t);
    return r ? [e, ...cO(r())] : e;
  }).flat(10);
}
function uO(n, e) {
  const t = fd.fromSchema(e).serializeFragment(n), i = document.implementation.createHTMLDocument().createElement("div");
  return i.appendChild(t), i.innerHTML;
}
function soe(n) {
  return typeof n == "function";
}
function on(n, e = void 0, ...t) {
  return soe(n) ? e ? n.bind(e)(...t) : n(...t) : n;
}
function Pot(n = {}) {
  return Object.keys(n).length === 0 && n.constructor === Object;
}
function H0(n) {
  const e = n.filter((i) => i.type === "extension"), t = n.filter((i) => i.type === "node"), r = n.filter((i) => i.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: t,
    markExtensions: r
  };
}
function ooe(n) {
  const e = [], { nodeExtensions: t, markExtensions: r } = H0(n), i = [...t, ...r], s = {
    default: null,
    validate: void 0,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return n.forEach((o) => {
    const a = {
      name: o.name,
      options: o.options,
      storage: o.storage,
      extensions: i
    }, l = st(
      o,
      "addGlobalAttributes",
      a
    );
    if (!l)
      return;
    l().forEach((u) => {
      u.types.forEach((d) => {
        Object.entries(u.attributes).forEach(([f, h]) => {
          e.push({
            type: d,
            name: f,
            attribute: {
              ...s,
              ...h
            }
          });
        });
      });
    });
  }), i.forEach((o) => {
    const a = {
      name: o.name,
      options: o.options,
      storage: o.storage
    }, l = st(
      o,
      "addAttributes",
      a
    );
    if (!l)
      return;
    const c = l();
    Object.entries(c).forEach(([u, d]) => {
      const f = {
        ...s,
        ...d
      };
      typeof f?.default == "function" && (f.default = f.default()), f?.isRequired && f?.default === void 0 && delete f.default, e.push({
        type: o.name,
        name: u,
        attribute: f
      });
    });
  }), e;
}
function Zn(...n) {
  return n.filter((e) => !!e).reduce((e, t) => {
    const r = { ...e };
    return Object.entries(t).forEach(([i, s]) => {
      if (!r[i]) {
        r[i] = s;
        return;
      }
      if (i === "class") {
        const a = s ? String(s).split(" ") : [], l = r[i] ? r[i].split(" ") : [], c = a.filter((u) => !l.includes(u));
        r[i] = [...l, ...c].join(" ");
      } else if (i === "style") {
        const a = s ? s.split(";").map((u) => u.trim()).filter(Boolean) : [], l = r[i] ? r[i].split(";").map((u) => u.trim()).filter(Boolean) : [], c = /* @__PURE__ */ new Map();
        l.forEach((u) => {
          const [d, f] = u.split(":").map((h) => h.trim());
          c.set(d, f);
        }), a.forEach((u) => {
          const [d, f] = u.split(":").map((h) => h.trim());
          c.set(d, f);
        }), r[i] = Array.from(c.entries()).map(([u, d]) => `${u}: ${d}`).join("; ");
      } else
        r[i] = s;
    }), r;
  }, {});
}
function U0(n, e) {
  return e.filter((t) => t.type === n.type.name).filter((t) => t.attribute.rendered).map((t) => t.attribute.renderHTML ? t.attribute.renderHTML(n.attrs) || {} : {
    [t.name]: n.attrs[t.name]
  }).reduce((t, r) => Zn(t, r), {});
}
function Dot(n) {
  return typeof n != "string" ? n : n.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(n) : n === "true" ? !0 : n === "false" ? !1 : n;
}
function wV(n, e) {
  return "style" in n ? n : {
    ...n,
    getAttrs: (t) => {
      const r = n.getAttrs ? n.getAttrs(t) : n.attrs;
      if (r === !1)
        return !1;
      const i = e.reduce((s, o) => {
        const a = o.attribute.parseHTML ? o.attribute.parseHTML(t) : Dot(t.getAttribute(o.name));
        return a == null ? s : {
          ...s,
          [o.name]: a
        };
      }, {});
      return { ...r, ...i };
    }
  };
}
function xV(n) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(n).filter(([e, t]) => e === "attrs" && Pot(t) ? !1 : t != null)
  );
}
function Not(n, e) {
  var t;
  const r = ooe(n), { nodeExtensions: i, markExtensions: s } = H0(n), o = (t = i.find((c) => st(c, "topNode"))) == null ? void 0 : t.name, a = Object.fromEntries(
    i.map((c) => {
      const u = r.filter((y) => y.type === c.name), d = {
        name: c.name,
        options: c.options,
        storage: c.storage,
        editor: e
      }, f = n.reduce((y, b) => {
        const x = st(b, "extendNodeSchema", d);
        return {
          ...y,
          ...x ? x(c) : {}
        };
      }, {}), h = xV({
        ...f,
        content: on(st(c, "content", d)),
        marks: on(st(c, "marks", d)),
        group: on(st(c, "group", d)),
        inline: on(st(c, "inline", d)),
        atom: on(st(c, "atom", d)),
        selectable: on(st(c, "selectable", d)),
        draggable: on(st(c, "draggable", d)),
        code: on(st(c, "code", d)),
        whitespace: on(st(c, "whitespace", d)),
        linebreakReplacement: on(
          st(c, "linebreakReplacement", d)
        ),
        defining: on(st(c, "defining", d)),
        isolating: on(st(c, "isolating", d)),
        attrs: Object.fromEntries(
          u.map((y) => {
            var b, x;
            return [
              y.name,
              { default: (b = y?.attribute) == null ? void 0 : b.default, validate: (x = y?.attribute) == null ? void 0 : x.validate }
            ];
          })
        )
      }), m = on(st(c, "parseHTML", d));
      m && (h.parseDOM = m.map(
        (y) => wV(y, u)
      ));
      const g = st(c, "renderHTML", d);
      g && (h.toDOM = (y) => g({
        node: y,
        HTMLAttributes: U0(y, u)
      }));
      const v = st(c, "renderText", d);
      return v && (h.toText = v), [c.name, h];
    })
  ), l = Object.fromEntries(
    s.map((c) => {
      const u = r.filter((v) => v.type === c.name), d = {
        name: c.name,
        options: c.options,
        storage: c.storage,
        editor: e
      }, f = n.reduce((v, y) => {
        const b = st(y, "extendMarkSchema", d);
        return {
          ...v,
          ...b ? b(c) : {}
        };
      }, {}), h = xV({
        ...f,
        inclusive: on(st(c, "inclusive", d)),
        excludes: on(st(c, "excludes", d)),
        group: on(st(c, "group", d)),
        spanning: on(st(c, "spanning", d)),
        code: on(st(c, "code", d)),
        attrs: Object.fromEntries(
          u.map((v) => {
            var y, b;
            return [
              v.name,
              { default: (y = v?.attribute) == null ? void 0 : y.default, validate: (b = v?.attribute) == null ? void 0 : b.validate }
            ];
          })
        )
      }), m = on(st(c, "parseHTML", d));
      m && (h.parseDOM = m.map(
        (v) => wV(v, u)
      ));
      const g = st(c, "renderHTML", d);
      return g && (h.toDOM = (v) => g({
        mark: v,
        HTMLAttributes: U0(v, u)
      })), [c.name, h];
    })
  );
  return new Lie({
    topNode: o,
    nodes: a,
    marks: l
  });
}
function Lot(n) {
  const e = n.filter((t, r) => n.indexOf(t) !== r);
  return Array.from(new Set(e));
}
function dO(n) {
  return n.sort((t, r) => {
    const i = st(t, "priority") || 100, s = st(r, "priority") || 100;
    return i > s ? -1 : i < s ? 1 : 0;
  });
}
function aoe(n) {
  const e = dO(cO(n)), t = Lot(e.map((r) => r.name));
  return t.length && console.warn(
    `[tiptap warn]: Duplicate extension names found: [${t.map((r) => `'${r}'`).join(", ")}]. This can lead to issues.`
  ), e;
}
function loe(n, e, t) {
  const { from: r, to: i } = e, { blockSeparator: s = `

`, textSerializers: o = {} } = t || {};
  let a = "";
  return n.nodesBetween(r, i, (l, c, u, d) => {
    var f;
    l.isBlock && c > r && (a += s);
    const h = o?.[l.type.name];
    if (h)
      return u && (a += h({
        node: l,
        pos: c,
        parent: u,
        index: d,
        range: e
      })), !1;
    l.isText && (a += (f = l?.text) == null ? void 0 : f.slice(Math.max(r, c) - c, i - c));
  }), a;
}
function coe(n, e) {
  const t = {
    from: 0,
    to: n.content.size
  };
  return loe(n, t, e);
}
function fO(n) {
  return Object.fromEntries(
    Object.entries(n.nodes).filter(([, e]) => e.spec.toText).map(([e, t]) => [e, t.spec.toText])
  );
}
function $ot(n, e) {
  const t = fr(e, n.schema), { from: r, to: i } = n.selection, s = [];
  n.doc.nodesBetween(r, i, (a) => {
    s.push(a);
  });
  const o = s.reverse().find((a) => a.type.name === t.name);
  return o ? { ...o.attrs } : {};
}
function uoe(n, e) {
  const t = cx(
    typeof e == "string" ? e : e.name,
    n.schema
  );
  return t === "node" ? $ot(n, e) : t === "mark" ? roe(n, e) : {};
}
function Fot(n, e = JSON.stringify) {
  const t = {};
  return n.filter((r) => {
    const i = e(r);
    return Object.prototype.hasOwnProperty.call(t, i) ? !1 : t[i] = !0;
  });
}
function Bot(n) {
  const e = Fot(n);
  return e.length === 1 ? e : e.filter((t, r) => !e.filter((s, o) => o !== r).some((s) => t.oldRange.from >= s.oldRange.from && t.oldRange.to <= s.oldRange.to && t.newRange.from >= s.newRange.from && t.newRange.to <= s.newRange.to));
}
function doe(n) {
  const { mapping: e, steps: t } = n, r = [];
  return e.maps.forEach((i, s) => {
    const o = [];
    if (i.ranges.length)
      i.forEach((a, l) => {
        o.push({ from: a, to: l });
      });
    else {
      const { from: a, to: l } = t[s];
      if (a === void 0 || l === void 0)
        return;
      o.push({ from: a, to: l });
    }
    o.forEach(({ from: a, to: l }) => {
      const c = e.slice(s).map(a, -1), u = e.slice(s).map(l), d = e.invert().map(c, -1), f = e.invert().map(u);
      r.push({
        oldRange: {
          from: d,
          to: f
        },
        newRange: {
          from: c,
          to: u
        }
      });
    });
  }), Bot(r);
}
function hO(n, e, t) {
  const r = [];
  return n === e ? t.resolve(n).marks().forEach((i) => {
    const s = t.resolve(n), o = aO(s, i.type);
    o && r.push({
      mark: i,
      ...o
    });
  }) : t.nodesBetween(n, e, (i, s) => {
    !i || i?.nodeSize === void 0 || r.push(
      ...i.marks.map((o) => ({
        from: s,
        to: s + i.nodeSize,
        mark: o
      }))
    );
  }), r;
}
var zot = (n, e, t, r = 20) => {
  const i = n.doc.resolve(t);
  let s = r, o = null;
  for (; s > 0 && o === null; ) {
    const a = i.node(s);
    a?.type.name === e ? o = a : s -= 1;
  }
  return [o, s];
};
function d8(n, e) {
  return e.nodes[n] || e.marks[n] || null;
}
function Jv(n, e, t) {
  return Object.fromEntries(
    Object.entries(t).filter(([r]) => {
      const i = n.find((s) => s.type === e && s.name === r);
      return i ? i.attribute.keepOnSplit : !1;
    })
  );
}
var Hot = (n, e = 500) => {
  let t = "";
  const r = n.parentOffset;
  return n.parent.nodesBetween(Math.max(0, r - e), r, (i, s, o, a) => {
    var l, c;
    const u = ((c = (l = i.type.spec).toText) == null ? void 0 : c.call(l, {
      node: i,
      pos: s,
      parent: o,
      index: a
    })) || i.textContent || "%leaf%";
    t += i.isAtom && !i.isText ? u : u.slice(0, Math.max(0, r - s));
  }), t;
};
function o9(n, e, t = {}) {
  const { empty: r, ranges: i } = n.selection, s = e ? El(e, n.schema) : null;
  if (r)
    return !!(n.storedMarks || n.selection.$from.marks()).filter((d) => s ? s.name === d.type.name : !0).find((d) => sb(d.attrs, t, { strict: !1 }));
  let o = 0;
  const a = [];
  if (i.forEach(({ $from: d, $to: f }) => {
    const h = d.pos, m = f.pos;
    n.doc.nodesBetween(h, m, (g, v) => {
      if (!g.isText && !g.marks.length)
        return;
      const y = Math.max(h, v), b = Math.min(m, v + g.nodeSize), x = b - y;
      o += x, a.push(
        ...g.marks.map((E) => ({
          mark: E,
          from: y,
          to: b
        }))
      );
    });
  }), o === 0)
    return !1;
  const l = a.filter((d) => s ? s.name === d.mark.type.name : !0).filter((d) => sb(d.mark.attrs, t, { strict: !1 })).reduce((d, f) => d + f.to - f.from, 0), c = a.filter((d) => s ? d.mark.type !== s && d.mark.type.excludes(s) : !0).reduce((d, f) => d + f.to - f.from, 0);
  return (l > 0 ? l + c : l) >= o;
}
function Uot(n, e, t = {}) {
  if (!e)
    return yc(n, null, t) || o9(n, null, t);
  const r = cx(e, n.schema);
  return r === "node" ? yc(n, e, t) : r === "mark" ? o9(n, e, t) : !1;
}
var Vot = (n, e) => {
  const { $from: t, $to: r, $anchor: i } = n.selection;
  if (e) {
    const s = ux((a) => a.type.name === e)(n.selection);
    if (!s)
      return !1;
    const o = n.doc.resolve(s.pos + 1);
    return i.pos + 1 === o.end();
  }
  return !(r.parentOffset < r.parent.nodeSize - 2 || t.pos !== r.pos);
}, jot = (n) => {
  const { $from: e, $to: t } = n.selection;
  return !(e.parentOffset > 0 || e.pos !== t.pos);
};
function EV(n, e) {
  return Array.isArray(e) ? e.some((t) => (typeof t == "string" ? t : t.name) === n.name) : e;
}
function SV(n, e) {
  const { nodeExtensions: t } = H0(e), r = t.find((o) => o.name === n);
  if (!r)
    return !1;
  const i = {
    name: r.name,
    options: r.options,
    storage: r.storage
  }, s = on(st(r, "group", i));
  return typeof s != "string" ? !1 : s.split(" ").includes("list");
}
function dx(n, {
  checkChildren: e = !0,
  ignoreWhitespace: t = !1
} = {}) {
  var r;
  if (t) {
    if (n.type.name === "hardBreak")
      return !0;
    if (n.isText)
      return /^\s*$/m.test((r = n.text) != null ? r : "");
  }
  if (n.isText)
    return !n.text;
  if (n.isAtom || n.isLeaf)
    return !1;
  if (n.content.childCount === 0)
    return !0;
  if (e) {
    let i = !0;
    return n.content.forEach((s) => {
      i !== !1 && (dx(s, { ignoreWhitespace: t, checkChildren: e }) || (i = !1));
    }), i;
  }
  return !1;
}
function foe(n) {
  return n instanceof nt;
}
function hoe(n, e, t) {
  const i = n.state.doc.content.size, s = tl(e, 0, i), o = tl(t, 0, i), a = n.coordsAtPos(s), l = n.coordsAtPos(o, -1), c = Math.min(a.top, l.top), u = Math.max(a.bottom, l.bottom), d = Math.min(a.left, l.left), f = Math.max(a.right, l.right), h = f - d, m = u - c, y = {
    top: c,
    bottom: u,
    left: d,
    right: f,
    width: h,
    height: m,
    x: d,
    y: c
  };
  return {
    ...y,
    toJSON: () => y
  };
}
function Wot(n, e, t) {
  var r;
  const { selection: i } = e;
  let s = null;
  if (lO(i) && (s = i.$cursor), s) {
    const a = (r = n.storedMarks) != null ? r : s.marks();
    return s.parent.type.allowsMarkType(t) && (!!t.isInSet(a) || !a.some((c) => c.type.excludes(t)));
  }
  const { ranges: o } = i;
  return o.some(({ $from: a, $to: l }) => {
    let c = a.depth === 0 ? n.doc.inlineContent && n.doc.type.allowsMarkType(t) : !1;
    return n.doc.nodesBetween(a.pos, l.pos, (u, d, f) => {
      if (c)
        return !1;
      if (u.isInline) {
        const h = !f || f.type.allowsMarkType(t), m = !!t.isInSet(u.marks) || !u.marks.some((g) => g.type.excludes(t));
        c = h && m;
      }
      return !c;
    }), c;
  });
}
var Got = (n, e = {}) => ({ tr: t, state: r, dispatch: i }) => {
  const { selection: s } = t, { empty: o, ranges: a } = s, l = El(n, r.schema);
  if (i)
    if (o) {
      const c = roe(r, l);
      t.addStoredMark(
        l.create({
          ...c,
          ...e
        })
      );
    } else
      a.forEach((c) => {
        const u = c.$from.pos, d = c.$to.pos;
        r.doc.nodesBetween(u, d, (f, h) => {
          const m = Math.max(h, u), g = Math.min(h + f.nodeSize, d);
          f.marks.find((y) => y.type === l) ? f.marks.forEach((y) => {
            l === y.type && t.addMark(
              m,
              g,
              l.create({
                ...y.attrs,
                ...e
              })
            );
          }) : t.addMark(m, g, l.create(e));
        });
      });
  return Wot(r, t, l);
}, Kot = (n, e) => ({ tr: t }) => (t.setMeta(n, e), !0), qot = (n, e = {}) => ({ state: t, dispatch: r, chain: i }) => {
  const s = fr(n, t.schema);
  let o;
  return t.selection.$anchor.sameParent(t.selection.$head) && (o = t.selection.$anchor.parent.attrs), s.isTextblock ? i().command(({ commands: a }) => $U(s, { ...o, ...e })(t) ? !0 : a.clearNodes()).command(({ state: a }) => $U(s, { ...o, ...e })(a, r)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, Yot = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: r } = e, i = tl(n, 0, r.content.size), s = nt.create(r, i);
    e.setSelection(s);
  }
  return !0;
}, Xot = (n) => ({ tr: e, dispatch: t }) => {
  if (t) {
    const { doc: r } = e, { from: i, to: s } = typeof n == "number" ? { from: n, to: n } : n, o = vt.atStart(r).from, a = vt.atEnd(r).to, l = tl(i, o, a), c = tl(s, o, a), u = vt.create(r, l, c);
    e.setSelection(u);
  }
  return !0;
}, Zot = (n) => ({ state: e, dispatch: t }) => {
  const r = fr(n, e.schema);
  return Zrt(r)(e, t);
};
function CV(n, e) {
  const t = n.storedMarks || n.selection.$to.parentOffset && n.selection.$from.marks();
  if (t) {
    const r = t.filter((i) => e?.includes(i.type.name));
    n.tr.ensureMarks(r);
  }
}
var Qot = ({ keepMarks: n = !0 } = {}) => ({ tr: e, state: t, dispatch: r, editor: i }) => {
  const { selection: s, doc: o } = e, { $from: a, $to: l } = s, c = i.extensionManager.attributes, u = Jv(c, a.node().type.name, a.node().attrs);
  if (s instanceof nt && s.node.isBlock)
    return !a.parentOffset || !ol(o, a.pos) ? !1 : (r && (n && CV(t, i.extensionManager.splittableMarks), e.split(a.pos).scrollIntoView()), !0);
  if (!a.parent.isBlock)
    return !1;
  const d = l.parentOffset === l.parent.content.size, f = a.depth === 0 ? void 0 : Oot(a.node(-1).contentMatchAt(a.indexAfter(-1)));
  let h = d && f ? [
    {
      type: f,
      attrs: u
    }
  ] : void 0, m = ol(e.doc, e.mapping.map(a.pos), 1, h);
  if (!h && !m && ol(e.doc, e.mapping.map(a.pos), 1, f ? [{ type: f }] : void 0) && (m = !0, h = f ? [
    {
      type: f,
      attrs: u
    }
  ] : void 0), r) {
    if (m && (s instanceof vt && e.deleteSelection(), e.split(e.mapping.map(a.pos), 1, h), f && !d && !a.parentOffset && a.parent.type !== f)) {
      const g = e.mapping.map(a.before()), v = e.doc.resolve(g);
      a.node(-1).canReplaceWith(v.index(), v.index() + 1, f) && e.setNodeMarkup(e.mapping.map(a.before()), f);
    }
    n && CV(t, i.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return m;
}, Jot = (n, e = {}) => ({ tr: t, state: r, dispatch: i, editor: s }) => {
  var o;
  const a = fr(n, r.schema), { $from: l, $to: c } = r.selection, u = r.selection.node;
  if (u && u.isBlock || l.depth < 2 || !l.sameParent(c))
    return !1;
  const d = l.node(-1);
  if (d.type !== a)
    return !1;
  const f = s.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== a || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (i) {
      let y = Ee.empty;
      const b = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let M = l.depth - b; M >= l.depth - 3; M -= 1)
        y = Ee.from(l.node(M).copy(y));
      const x = (
        // eslint-disable-next-line no-nested-ternary
        l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3
      ), E = {
        ...Jv(f, l.node().type.name, l.node().attrs),
        ...e
      }, w = ((o = a.contentMatch.defaultType) == null ? void 0 : o.createAndFill(E)) || void 0;
      y = y.append(Ee.from(a.createAndFill(null, w) || void 0));
      const C = l.before(l.depth - (b - 1));
      t.replace(C, l.after(-x), new Fe(y, 4 - b, 0));
      let S = -1;
      t.doc.nodesBetween(C, t.doc.content.size, (M, k) => {
        if (S > -1)
          return !1;
        M.isTextblock && M.content.size === 0 && (S = k + 1);
      }), S > -1 && t.setSelection(vt.near(t.doc.resolve(S))), t.scrollIntoView();
    }
    return !0;
  }
  const h = c.pos === l.end() ? d.contentMatchAt(0).defaultType : null, m = {
    ...Jv(f, d.type.name, d.attrs),
    ...e
  }, g = {
    ...Jv(f, l.node().type.name, l.node().attrs),
    ...e
  };
  t.delete(l.pos, c.pos);
  const v = h ? [
    { type: a, attrs: m },
    { type: h, attrs: g }
  ] : [{ type: a, attrs: m }];
  if (!ol(t.doc, l.pos, 2))
    return !1;
  if (i) {
    const { selection: y, storedMarks: b } = r, { splittableMarks: x } = s.extensionManager, E = b || y.$to.parentOffset && y.$from.marks();
    if (t.split(l.pos, 2, v).scrollIntoView(), !E || !i)
      return !0;
    const w = E.filter((C) => x.includes(C.type.name));
    t.ensureMarks(w);
  }
  return !0;
}, f8 = (n, e) => {
  const t = ux((o) => o.type === e)(n.selection);
  if (!t)
    return !0;
  const r = n.doc.resolve(Math.max(0, t.pos - 1)).before(t.depth);
  if (r === void 0)
    return !0;
  const i = n.doc.nodeAt(r);
  return t.node.type === i?.type && Dc(n.doc, t.pos) && n.join(t.pos), !0;
}, h8 = (n, e) => {
  const t = ux((o) => o.type === e)(n.selection);
  if (!t)
    return !0;
  const r = n.doc.resolve(t.start).after(t.depth);
  if (r === void 0)
    return !0;
  const i = n.doc.nodeAt(r);
  return t.node.type === i?.type && Dc(n.doc, r) && n.join(r), !0;
}, eat = (n, e, t, r = {}) => ({ editor: i, tr: s, state: o, dispatch: a, chain: l, commands: c, can: u }) => {
  const { extensions: d, splittableMarks: f } = i.extensionManager, h = fr(n, o.schema), m = fr(e, o.schema), { selection: g, storedMarks: v } = o, { $from: y, $to: b } = g, x = y.blockRange(b), E = v || g.$to.parentOffset && g.$from.marks();
  if (!x)
    return !1;
  const w = ux((C) => SV(C.type.name, d))(g);
  if (x.depth >= 1 && w && x.depth - w.depth <= 1) {
    if (w.node.type === h)
      return c.liftListItem(m);
    if (SV(w.node.type.name, d) && h.validContent(w.node.content) && a)
      return l().command(() => (s.setNodeMarkup(w.pos, h), !0)).command(() => f8(s, h)).command(() => h8(s, h)).run();
  }
  return !t || !E || !a ? l().command(() => u().wrapInList(h, r) ? !0 : c.clearNodes()).wrapInList(h, r).command(() => f8(s, h)).command(() => h8(s, h)).run() : l().command(() => {
    const C = u().wrapInList(h, r), S = E.filter((M) => f.includes(M.type.name));
    return s.ensureMarks(S), C ? !0 : c.clearNodes();
  }).wrapInList(h, r).command(() => f8(s, h)).command(() => h8(s, h)).run();
}, tat = (n, e = {}, t = {}) => ({ state: r, commands: i }) => {
  const { extendEmptyMarkRange: s = !1 } = t, o = El(n, r.schema);
  return o9(r, o, e) ? i.unsetMark(o, { extendEmptyMarkRange: s }) : i.setMark(o, e);
}, nat = (n, e, t = {}) => ({ state: r, commands: i }) => {
  const s = fr(n, r.schema), o = fr(e, r.schema), a = yc(r, s, t);
  let l;
  return r.selection.$anchor.sameParent(r.selection.$head) && (l = r.selection.$anchor.parent.attrs), a ? i.setNode(o, l) : i.setNode(s, { ...l, ...t });
}, rat = (n, e = {}) => ({ state: t, commands: r }) => {
  const i = fr(n, t.schema);
  return yc(t, i, e) ? r.lift(i) : r.wrapIn(i, e);
}, iat = () => ({ state: n, dispatch: e }) => {
  const t = n.plugins;
  for (let r = 0; r < t.length; r += 1) {
    const i = t[r];
    let s;
    if (i.spec.isInputRules && (s = i.getState(n))) {
      if (e) {
        const o = n.tr, a = s.transform;
        for (let l = a.steps.length - 1; l >= 0; l -= 1)
          o.step(a.steps[l].invert(a.docs[l]));
        if (s.text) {
          const l = o.doc.resolve(s.from).marks();
          o.replaceWith(s.from, s.to, n.schema.text(s.text, l));
        } else
          o.delete(s.from, s.to);
      }
      return !0;
    }
  }
  return !1;
}, sat = () => ({ tr: n, dispatch: e }) => {
  const { selection: t } = n, { empty: r, ranges: i } = t;
  return r || e && i.forEach((s) => {
    n.removeMark(s.$from.pos, s.$to.pos);
  }), !0;
}, oat = (n, e = {}) => ({ tr: t, state: r, dispatch: i }) => {
  var s;
  const { extendEmptyMarkRange: o = !1 } = e, { selection: a } = t, l = El(n, r.schema), { $from: c, empty: u, ranges: d } = a;
  if (!i)
    return !0;
  if (u && o) {
    let { from: f, to: h } = a;
    const m = (s = c.marks().find((v) => v.type === l)) == null ? void 0 : s.attrs, g = aO(c, l, m);
    g && (f = g.from, h = g.to), t.removeMark(f, h, l);
  } else
    d.forEach((f) => {
      t.removeMark(f.$from.pos, f.$to.pos, l);
    });
  return t.removeStoredMark(l), !0;
}, aat = (n, e = {}) => ({ tr: t, state: r, dispatch: i }) => {
  let s = null, o = null;
  const a = cx(
    typeof n == "string" ? n : n.name,
    r.schema
  );
  return a ? (a === "node" && (s = fr(n, r.schema)), a === "mark" && (o = El(n, r.schema)), i && t.selection.ranges.forEach((l) => {
    const c = l.$from.pos, u = l.$to.pos;
    let d, f, h, m;
    t.selection.empty ? r.doc.nodesBetween(c, u, (g, v) => {
      s && s === g.type && (h = Math.max(v, c), m = Math.min(v + g.nodeSize, u), d = v, f = g);
    }) : r.doc.nodesBetween(c, u, (g, v) => {
      v < c && s && s === g.type && (h = Math.max(v, c), m = Math.min(v + g.nodeSize, u), d = v, f = g), v >= c && v <= u && (s && s === g.type && t.setNodeMarkup(v, void 0, {
        ...g.attrs,
        ...e
      }), o && g.marks.length && g.marks.forEach((y) => {
        if (o === y.type) {
          const b = Math.max(v, c), x = Math.min(v + g.nodeSize, u);
          t.addMark(
            b,
            x,
            o.create({
              ...y.attrs,
              ...e
            })
          );
        }
      }));
    }), f && (d !== void 0 && t.setNodeMarkup(d, void 0, {
      ...f.attrs,
      ...e
    }), o && f.marks.length && f.marks.forEach((g) => {
      o === g.type && t.addMark(
        h,
        m,
        o.create({
          ...g.attrs,
          ...e
        })
      );
    }));
  }), !0) : !1;
}, lat = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const i = fr(n, t.schema);
  return jrt(i, e)(t, r);
}, cat = (n, e = {}) => ({ state: t, dispatch: r }) => {
  const i = fr(n, t.schema);
  return Wrt(i, e)(t, r);
}, uat = class {
  constructor() {
    this.callbacks = {};
  }
  on(n, e) {
    return this.callbacks[n] || (this.callbacks[n] = []), this.callbacks[n].push(e), this;
  }
  emit(n, ...e) {
    const t = this.callbacks[n];
    return t && t.forEach((r) => r.apply(this, e)), this;
  }
  off(n, e) {
    const t = this.callbacks[n];
    return t && (e ? this.callbacks[n] = t.filter((r) => r !== e) : delete this.callbacks[n]), this;
  }
  once(n, e) {
    const t = (...r) => {
      this.off(n, t), e.apply(this, r);
    };
    return this.on(n, t);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}, B1 = class {
  constructor(n) {
    var e;
    this.find = n.find, this.handler = n.handler, this.undoable = (e = n.undoable) != null ? e : !0;
  }
}, dat = (n, e) => {
  if (oO(e))
    return e.exec(n);
  const t = e(n);
  if (!t)
    return null;
  const r = [t.text];
  return r.index = t.index, r.input = n, r.data = t.data, t.replaceWith && (t.text.includes(t.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), r.push(t.replaceWith)), r;
};
function Qg(n) {
  var e;
  const { editor: t, from: r, to: i, text: s, rules: o, plugin: a } = n, { view: l } = t;
  if (l.composing)
    return !1;
  const c = l.state.doc.resolve(r);
  if (
    // check for code node
    c.parent.type.spec.code || (e = c.nodeBefore || c.nodeAfter) != null && e.marks.find((f) => f.type.spec.code)
  )
    return !1;
  let u = !1;
  const d = Hot(c) + s;
  return o.forEach((f) => {
    if (u)
      return;
    const h = dat(d, f.find);
    if (!h)
      return;
    const m = l.state.tr, g = ox({
      state: l.state,
      transaction: m
    }), v = {
      from: r - (h[0].length - s.length),
      to: i
    }, { commands: y, chain: b, can: x } = new ax({
      editor: t,
      state: g
    });
    f.handler({
      state: g,
      range: v,
      match: h,
      commands: y,
      chain: b,
      can: x
    }) === null || !m.steps.length || (f.undoable && m.setMeta(a, {
      transform: m,
      from: r,
      to: i,
      text: s
    }), l.dispatch(m), u = !0);
  }), u;
}
function fat(n) {
  const { editor: e, rules: t } = n, r = new Cn({
    state: {
      init() {
        return null;
      },
      apply(i, s, o) {
        const a = i.getMeta(r);
        if (a)
          return a;
        const l = i.getMeta("applyInputRules");
        return !!l && setTimeout(() => {
          let { text: u } = l;
          typeof u == "string" ? u = u : u = uO(Ee.from(u), o.schema);
          const { from: d } = l, f = d + u.length;
          Qg({
            editor: e,
            from: d,
            to: f,
            text: u,
            rules: t,
            plugin: r
          });
        }), i.selectionSet || i.docChanged ? null : s;
      }
    },
    props: {
      handleTextInput(i, s, o, a) {
        return Qg({
          editor: e,
          from: s,
          to: o,
          text: a,
          rules: t,
          plugin: r
        });
      },
      handleDOMEvents: {
        compositionend: (i) => (setTimeout(() => {
          const { $cursor: s } = i.state.selection;
          s && Qg({
            editor: e,
            from: s.pos,
            to: s.pos,
            text: "",
            rules: t,
            plugin: r
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(i, s) {
        if (s.key !== "Enter")
          return !1;
        const { $cursor: o } = i.state.selection;
        return o ? Qg({
          editor: e,
          from: o.pos,
          to: o.pos,
          text: `
`,
          rules: t,
          plugin: r
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return r;
}
function hat(n) {
  return Object.prototype.toString.call(n).slice(8, -1);
}
function Jg(n) {
  return hat(n) !== "Object" ? !1 : n.constructor === Object && Object.getPrototypeOf(n) === Object.prototype;
}
function poe(n, e) {
  const t = { ...n };
  return Jg(n) && Jg(e) && Object.keys(e).forEach((r) => {
    Jg(e[r]) && Jg(n[r]) ? t[r] = poe(n[r], e[r]) : t[r] = e[r];
  }), t;
}
var pO = class {
  constructor(n = {}) {
    this.type = "extendable", this.parent = null, this.child = null, this.name = "", this.config = {
      name: this.name
    }, this.config = {
      ...this.config,
      ...n
    }, this.name = this.config.name;
  }
  get options() {
    return {
      ...on(
        st(this, "addOptions", {
          name: this.name
        })
      ) || {}
    };
  }
  get storage() {
    return {
      ...on(
        st(this, "addStorage", {
          name: this.name,
          options: this.options
        })
      ) || {}
    };
  }
  configure(n = {}) {
    const e = this.extend({
      ...this.config,
      addOptions: () => poe(this.options, n)
    });
    return e.name = this.name, e.parent = this.parent, e;
  }
  extend(n = {}) {
    const e = new this.constructor({ ...this.config, ...n });
    return e.parent = this, this.child = e, e.name = "name" in n ? n.name : e.parent.name, e;
  }
}, Lc = class moe extends pO {
  constructor() {
    super(...arguments), this.type = "mark";
  }
  /**
   * Create a new Mark instance
   * @param config - Mark configuration object or a function that returns a configuration object
   */
  static create(e = {}) {
    const t = typeof e == "function" ? e() : e;
    return new moe(t);
  }
  static handleExit({ editor: e, mark: t }) {
    const { tr: r } = e.state, i = e.state.selection.$from;
    if (i.pos === i.end()) {
      const o = i.marks();
      if (!!!o.find((c) => c?.type.name === t.name))
        return !1;
      const l = o.find((c) => c?.type.name === t.name);
      return l && r.removeStoredMark(l), r.insertText(" ", i.pos), e.view.dispatch(r), !0;
    }
    return !1;
  }
  configure(e) {
    return super.configure(e);
  }
  extend(e) {
    const t = typeof e == "function" ? e() : e;
    return super.extend(t);
  }
};
function pat(n) {
  return typeof n == "number";
}
var mat = class {
  constructor(n) {
    this.find = n.find, this.handler = n.handler;
  }
}, gat = (n, e, t) => {
  if (oO(e))
    return [...n.matchAll(e)];
  const r = e(n, t);
  return r ? r.map((i) => {
    const s = [i.text];
    return s.index = i.index, s.input = n, s.data = i.data, i.replaceWith && (i.text.includes(i.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), s.push(i.replaceWith)), s;
  }) : [];
};
function vat(n) {
  const { editor: e, state: t, from: r, to: i, rule: s, pasteEvent: o, dropEvent: a } = n, { commands: l, chain: c, can: u } = new ax({
    editor: e,
    state: t
  }), d = [];
  return t.doc.nodesBetween(r, i, (h, m) => {
    var g, v, y, b, x;
    if ((v = (g = h.type) == null ? void 0 : g.spec) != null && v.code || !(h.isText || h.isTextblock || h.isInline))
      return;
    const E = (x = (b = (y = h.content) == null ? void 0 : y.size) != null ? b : h.nodeSize) != null ? x : 0, w = Math.max(r, m), C = Math.min(i, m + E);
    if (w >= C)
      return;
    const S = h.isText ? h.text || "" : h.textBetween(w - m, C - m, void 0, "￼");
    gat(S, s.find, o).forEach((k) => {
      if (k.index === void 0)
        return;
      const _ = w + k.index + 1, O = _ + k[0].length, I = {
        from: t.tr.mapping.map(_),
        to: t.tr.mapping.map(O)
      }, R = s.handler({
        state: t,
        range: I,
        match: k,
        commands: l,
        chain: c,
        can: u,
        pasteEvent: o,
        dropEvent: a
      });
      d.push(R);
    });
  }), d.every((h) => h !== null);
}
var ev = null, yat = (n) => {
  var e;
  const t = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (e = t.clipboardData) == null || e.setData("text/html", n), t;
};
function bat(n) {
  const { editor: e, rules: t } = n;
  let r = null, i = !1, s = !1, o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, a;
  try {
    a = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    a = null;
  }
  const l = ({
    state: u,
    from: d,
    to: f,
    rule: h,
    pasteEvt: m
  }) => {
    const g = u.tr, v = ox({
      state: u,
      transaction: g
    });
    if (!(!vat({
      editor: e,
      state: v,
      from: Math.max(d - 1, 0),
      to: f.b - 1,
      rule: h,
      pasteEvent: m,
      dropEvent: a
    }) || !g.steps.length)) {
      try {
        a = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        a = null;
      }
      return o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, g;
    }
  };
  return t.map((u) => new Cn({
    // we register a global drag handler to track the current drag source element
    view(d) {
      const f = (m) => {
        var g;
        r = (g = d.dom.parentElement) != null && g.contains(m.target) ? d.dom.parentElement : null, r && (ev = e);
      }, h = () => {
        ev && (ev = null);
      };
      return window.addEventListener("dragstart", f), window.addEventListener("dragend", h), {
        destroy() {
          window.removeEventListener("dragstart", f), window.removeEventListener("dragend", h);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (d, f) => {
          if (s = r === d.dom.parentElement, a = f, !s) {
            const h = ev;
            h?.isEditable && setTimeout(() => {
              const m = h.state.selection;
              m && h.commands.deleteRange({ from: m.from, to: m.to });
            }, 10);
          }
          return !1;
        },
        paste: (d, f) => {
          var h;
          const m = (h = f.clipboardData) == null ? void 0 : h.getData("text/html");
          return o = f, i = !!m?.includes("data-pm-slice"), !1;
        }
      }
    },
    appendTransaction: (d, f, h) => {
      const m = d[0], g = m.getMeta("uiEvent") === "paste" && !i, v = m.getMeta("uiEvent") === "drop" && !s, y = m.getMeta("applyPasteRules"), b = !!y;
      if (!g && !v && !b)
        return;
      if (b) {
        let { text: w } = y;
        typeof w == "string" ? w = w : w = uO(Ee.from(w), h.schema);
        const { from: C } = y, S = C + w.length, M = yat(w);
        return l({
          rule: u,
          state: h,
          from: C,
          to: { b: S },
          pasteEvt: M
        });
      }
      const x = f.doc.content.findDiffStart(h.doc.content), E = f.doc.content.findDiffEnd(h.doc.content);
      if (!(!pat(x) || !E || x === E.b))
        return l({
          rule: u,
          state: h,
          from: x,
          to: E,
          pasteEvt: o
        });
    }
  }));
}
var fx = class {
  constructor(n, e) {
    this.splittableMarks = [], this.editor = e, this.baseExtensions = n, this.extensions = aoe(n), this.schema = Not(this.extensions, e), this.setupExtensions();
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((n, e) => {
      const t = {
        name: e.name,
        options: e.options,
        storage: this.editor.extensionStorage[e.name],
        editor: this.editor,
        type: d8(e.name, this.schema)
      }, r = st(e, "addCommands", t);
      return r ? {
        ...n,
        ...r()
      } : n;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: n } = this;
    return dO([...this.extensions].reverse()).flatMap((r) => {
      const i = {
        name: r.name,
        options: r.options,
        storage: this.editor.extensionStorage[r.name],
        editor: n,
        type: d8(r.name, this.schema)
      }, s = [], o = st(
        r,
        "addKeyboardShortcuts",
        i
      );
      let a = {};
      if (r.type === "mark" && st(r, "exitable", i) && (a.ArrowRight = () => Lc.handleExit({ editor: n, mark: r })), o) {
        const f = Object.fromEntries(
          Object.entries(o()).map(([h, m]) => [h, () => m({ editor: n })])
        );
        a = { ...a, ...f };
      }
      const l = Bst(a);
      s.push(l);
      const c = st(r, "addInputRules", i);
      if (EV(r, n.options.enableInputRules) && c) {
        const f = c();
        if (f && f.length) {
          const h = fat({
            editor: n,
            rules: f
          }), m = Array.isArray(h) ? h : [h];
          s.push(...m);
        }
      }
      const u = st(r, "addPasteRules", i);
      if (EV(r, n.options.enablePasteRules) && u) {
        const f = u();
        if (f && f.length) {
          const h = bat({ editor: n, rules: f });
          s.push(...h);
        }
      }
      const d = st(
        r,
        "addProseMirrorPlugins",
        i
      );
      if (d) {
        const f = d();
        s.push(...f);
      }
      return s;
    });
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return ooe(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: n } = this, { nodeExtensions: e } = H0(this.extensions);
    return Object.fromEntries(
      e.filter((t) => !!st(t, "addNodeView")).map((t) => {
        const r = this.attributes.filter((a) => a.type === t.name), i = {
          name: t.name,
          options: t.options,
          storage: this.editor.extensionStorage[t.name],
          editor: n,
          type: fr(t.name, this.schema)
        }, s = st(t, "addNodeView", i);
        if (!s)
          return [];
        const o = (a, l, c, u, d) => {
          const f = U0(a, r);
          return s()({
            // pass-through
            node: a,
            view: l,
            getPos: c,
            decorations: u,
            innerDecorations: d,
            // tiptap-specific
            editor: n,
            extension: t,
            HTMLAttributes: f
          });
        };
        return [t.name, o];
      })
    );
  }
  get markViews() {
    const { editor: n } = this, { markExtensions: e } = H0(this.extensions);
    return Object.fromEntries(
      e.filter((t) => !!st(t, "addMarkView")).map((t) => {
        const r = this.attributes.filter((a) => a.type === t.name), i = {
          name: t.name,
          options: t.options,
          storage: this.editor.extensionStorage[t.name],
          editor: n,
          type: El(t.name, this.schema)
        }, s = st(t, "addMarkView", i);
        if (!s)
          return [];
        const o = (a, l, c) => {
          const u = U0(a, r);
          return s()({
            // pass-through
            mark: a,
            view: l,
            inline: c,
            // tiptap-specific
            editor: n,
            extension: t,
            HTMLAttributes: u,
            updateAttributes: (d) => {
              Rat(a, n, d);
            }
          });
        };
        return [t.name, o];
      })
    );
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    const n = this.extensions;
    this.editor.extensionStorage = Object.fromEntries(
      n.map((e) => [e.name, e.storage])
    ), n.forEach((e) => {
      var t;
      const r = {
        name: e.name,
        options: e.options,
        storage: this.editor.extensionStorage[e.name],
        editor: this.editor,
        type: d8(e.name, this.schema)
      };
      e.type === "mark" && ((t = on(st(e, "keepOnSplit", r))) == null || t) && this.splittableMarks.push(e.name);
      const i = st(e, "onBeforeCreate", r), s = st(e, "onCreate", r), o = st(e, "onUpdate", r), a = st(
        e,
        "onSelectionUpdate",
        r
      ), l = st(e, "onTransaction", r), c = st(e, "onFocus", r), u = st(e, "onBlur", r), d = st(e, "onDestroy", r);
      i && this.editor.on("beforeCreate", i), s && this.editor.on("create", s), o && this.editor.on("update", o), a && this.editor.on("selectionUpdate", a), l && this.editor.on("transaction", l), c && this.editor.on("focus", c), u && this.editor.on("blur", u), d && this.editor.on("destroy", d);
    });
  }
};
fx.resolve = aoe;
fx.sort = dO;
fx.flatten = cO;
var wat = {};
sO(wat, {
  ClipboardTextSerializer: () => voe,
  Commands: () => yoe,
  Delete: () => boe,
  Drop: () => woe,
  Editable: () => xoe,
  FocusEvents: () => Soe,
  Keymap: () => Coe,
  Paste: () => Toe,
  Tabindex: () => Aoe,
  focusEventsPluginKey: () => Eoe
});
var qt = class goe extends pO {
  constructor() {
    super(...arguments), this.type = "extension";
  }
  /**
   * Create a new Extension instance
   * @param config - Extension configuration object or a function that returns a configuration object
   */
  static create(e = {}) {
    const t = typeof e == "function" ? e() : e;
    return new goe(t);
  }
  configure(e) {
    return super.configure(e);
  }
  extend(e) {
    const t = typeof e == "function" ? e() : e;
    return super.extend(t);
  }
}, voe = qt.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new Cn({
        key: new _n("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: n } = this, { state: e, schema: t } = n, { doc: r, selection: i } = e, { ranges: s } = i, o = Math.min(...s.map((u) => u.$from.pos)), a = Math.max(...s.map((u) => u.$to.pos)), l = fO(t);
            return loe(r, { from: o, to: a }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
}), yoe = qt.create({
  name: "commands",
  addCommands() {
    return {
      ...Zse
    };
  }
}), boe = qt.create({
  name: "delete",
  onUpdate({ transaction: n, appendedTransactions: e }) {
    var t, r, i;
    const s = () => {
      var o, a, l, c;
      if ((c = (l = (a = (o = this.editor.options.coreExtensionOptions) == null ? void 0 : o.delete) == null ? void 0 : a.filterTransaction) == null ? void 0 : l.call(a, n)) != null ? c : n.getMeta("y-sync$"))
        return;
      const u = ioe(n.before, [n, ...e]);
      doe(u).forEach((h) => {
        u.mapping.mapResult(h.oldRange.from).deletedAfter && u.mapping.mapResult(h.oldRange.to).deletedBefore && u.before.nodesBetween(h.oldRange.from, h.oldRange.to, (m, g) => {
          const v = g + m.nodeSize - 2, y = h.oldRange.from <= g && v <= h.oldRange.to;
          this.editor.emit("delete", {
            type: "node",
            node: m,
            from: g,
            to: v,
            newFrom: u.mapping.map(g),
            newTo: u.mapping.map(v),
            deletedRange: h.oldRange,
            newRange: h.newRange,
            partial: !y,
            editor: this.editor,
            transaction: n,
            combinedTransform: u
          });
        });
      });
      const f = u.mapping;
      u.steps.forEach((h, m) => {
        var g, v;
        if (h instanceof ho) {
          const y = f.slice(m).map(h.from, -1), b = f.slice(m).map(h.to), x = f.invert().map(y, -1), E = f.invert().map(b), w = (g = u.doc.nodeAt(y - 1)) == null ? void 0 : g.marks.some((S) => S.eq(h.mark)), C = (v = u.doc.nodeAt(b)) == null ? void 0 : v.marks.some((S) => S.eq(h.mark));
          this.editor.emit("delete", {
            type: "mark",
            mark: h.mark,
            from: h.from,
            to: h.to,
            deletedRange: {
              from: x,
              to: E
            },
            newRange: {
              from: y,
              to: b
            },
            partial: !!(C || w),
            editor: this.editor,
            transaction: n,
            combinedTransform: u
          });
        }
      });
    };
    (i = (r = (t = this.editor.options.coreExtensionOptions) == null ? void 0 : t.delete) == null ? void 0 : r.async) == null || i ? setTimeout(s, 0) : s();
  }
}), woe = qt.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new Cn({
        key: new _n("tiptapDrop"),
        props: {
          handleDrop: (n, e, t, r) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: t,
              moved: r
            });
          }
        }
      })
    ];
  }
}), xoe = qt.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new Cn({
        key: new _n("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), Eoe = new _n("focusEvents"), Soe = qt.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: n } = this;
    return [
      new Cn({
        key: Eoe,
        props: {
          handleDOMEvents: {
            focus: (e, t) => {
              n.isFocused = !0;
              const r = n.state.tr.setMeta("focus", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            },
            blur: (e, t) => {
              n.isFocused = !1;
              const r = n.state.tr.setMeta("blur", { event: t }).setMeta("addToHistory", !1);
              return e.dispatch(r), !1;
            }
          }
        }
      })
    ];
  }
}), Coe = qt.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const n = () => this.editor.commands.first(({ commands: o }) => [
      () => o.undoInputRule(),
      // maybe convert first text block node to default node
      () => o.command(({ tr: a }) => {
        const { selection: l, doc: c } = a, { empty: u, $anchor: d } = l, { pos: f, parent: h } = d, m = d.parent.isTextblock && f > 0 ? a.doc.resolve(f - 1) : d, g = m.parent.type.spec.isolating, v = d.pos - d.parentOffset, y = g && m.parent.childCount === 1 ? v === d.pos : pt.atStart(c).from === f;
        return !u || !h.type.isTextblock || h.textContent.length || !y || y && d.parent.type.name === "paragraph" ? !1 : o.clearNodes();
      }),
      () => o.deleteSelection(),
      () => o.joinBackward(),
      () => o.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: o }) => [
      () => o.deleteSelection(),
      () => o.deleteCurrentNode(),
      () => o.joinForward(),
      () => o.selectNodeForward()
    ]), r = {
      Enter: () => this.editor.commands.first(({ commands: o }) => [
        () => o.newlineInCode(),
        () => o.createParagraphNear(),
        () => o.liftEmptyBlock(),
        () => o.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: n,
      "Mod-Backspace": n,
      "Shift-Backspace": n,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, i = {
      ...r
    }, s = {
      ...r,
      "Ctrl-h": n,
      "Alt-Backspace": n,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return lx() || noe() ? s : i;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new Cn({
        key: new _n("clearDocument"),
        appendTransaction: (n, e, t) => {
          if (n.some((g) => g.getMeta("composition")))
            return;
          const r = n.some((g) => g.docChanged) && !e.doc.eq(t.doc), i = n.some((g) => g.getMeta("preventClearDocument"));
          if (!r || i)
            return;
          const { empty: s, from: o, to: a } = e.selection, l = pt.atStart(e.doc).from, c = pt.atEnd(e.doc).to;
          if (s || !(o === l && a === c) || !dx(t.doc))
            return;
          const f = t.tr, h = ox({
            state: t,
            transaction: f
          }), { commands: m } = new ax({
            editor: this.editor,
            state: h
          });
          if (m.clearNodes(), !!f.steps.length)
            return f;
        }
      })
    ];
  }
}), Toe = qt.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new Cn({
        key: new _n("tiptapPaste"),
        props: {
          handlePaste: (n, e, t) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: t
            });
          }
        }
      })
    ];
  }
}), Aoe = qt.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new Cn({
        key: new _n("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
}), xat = class Bd {
  constructor(e, t, r = !1, i = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = r, this.resolvedPos = e, this.editor = t, this.currentNode = i;
  }
  get name() {
    return this.node.type.name;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var e;
    return (e = this.actualDepth) != null ? e : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(e) {
    let t = this.from, r = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      t = this.from + 1, r = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: t, to: r }, e);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const e = this.resolvedPos.start(this.resolvedPos.depth - 1), t = this.resolvedPos.doc.resolve(e);
    return new Bd(t, this.editor);
  }
  get before() {
    let e = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.from - 3)), new Bd(e, this.editor);
  }
  get after() {
    let e = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.to + 3)), new Bd(e, this.editor);
  }
  get children() {
    const e = [];
    return this.node.content.forEach((t, r) => {
      const i = t.isBlock && !t.isTextblock, s = t.isAtom && !t.isText, o = this.pos + r + (s ? 0 : 1);
      if (o < 0 || o > this.resolvedPos.doc.nodeSize - 2)
        return;
      const a = this.resolvedPos.doc.resolve(o);
      if (!i && a.depth <= this.depth)
        return;
      const l = new Bd(a, this.editor, i, i ? t : null);
      i && (l.actualDepth = this.depth + 1), e.push(new Bd(a, this.editor, i, i ? t : null));
    }), e;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const e = this.children;
    return e[e.length - 1] || null;
  }
  closest(e, t = {}) {
    let r = null, i = this.parent;
    for (; i && !r; ) {
      if (i.node.type.name === e)
        if (Object.keys(t).length > 0) {
          const s = i.node.attrs, o = Object.keys(t);
          for (let a = 0; a < o.length; a += 1) {
            const l = o[a];
            if (s[l] !== t[l])
              break;
          }
        } else
          r = i;
      i = i.parent;
    }
    return r;
  }
  querySelector(e, t = {}) {
    return this.querySelectorAll(e, t, !0)[0] || null;
  }
  querySelectorAll(e, t = {}, r = !1) {
    let i = [];
    if (!this.children || this.children.length === 0)
      return i;
    const s = Object.keys(t);
    return this.children.forEach((o) => {
      r && i.length > 0 || (o.node.type.name === e && s.every((l) => t[l] === o.node.attrs[l]) && i.push(o), !(r && i.length > 0) && (i = i.concat(o.querySelectorAll(e, t, r))));
    }), i;
  }
  setAttribute(e) {
    const { tr: t } = this.editor.state;
    t.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...e
    }), this.editor.view.dispatch(t);
  }
}, Eat = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}`;
function Sat(n, e, t) {
  const r = document.querySelector("style[data-tiptap-style]");
  if (r !== null)
    return r;
  const i = document.createElement("style");
  return e && i.setAttribute("nonce", e), i.setAttribute("data-tiptap-style", ""), i.innerHTML = n, document.getElementsByTagName("head")[0].appendChild(i), i;
}
var Cat = class extends uat {
  constructor(n = {}) {
    super(), this.css = null, this.editorView = null, this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.instanceId = Math.random().toString(36).slice(2, 9), this.options = {
      element: typeof document < "u" ? document.createElement("div") : null,
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      emitContentError: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onMount: () => null,
      onUnmount: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: r }) => {
        throw r;
      },
      onPaste: () => null,
      onDrop: () => null,
      onDelete: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(n), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("mount", this.options.onMount), this.on("unmount", this.options.onUnmount), this.on("contentError", this.options.onContentError), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: r, slice: i, moved: s }) => this.options.onDrop(r, i, s)), this.on("paste", ({ event: r, slice: i }) => this.options.onPaste(r, i)), this.on("delete", this.options.onDelete);
    const e = this.createDoc(), t = Jse(e, this.options.autofocus);
    this.editorState = Irt.create({
      doc: e,
      schema: this.schema,
      selection: t || void 0
    }), this.options.element && this.mount(this.options.element);
  }
  /**
   * Attach the editor to the DOM, creating a new editor view.
   */
  mount(n) {
    if (typeof document > "u")
      throw new Error(
        "[tiptap error]: The editor cannot be mounted because there is no 'document' defined in this environment."
      );
    this.createView(n), this.emit("mount", { editor: this }), this.css && !document.head.contains(this.css) && document.head.appendChild(this.css), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Remove the editor from the DOM, but still allow remounting at a different point in time
   */
  unmount() {
    if (this.editorView) {
      const n = this.editorView.dom;
      n?.editor && delete n.editor, this.editorView.destroy();
    }
    if (this.editorView = null, this.isInitialized = !1, this.css)
      try {
        typeof this.css.remove == "function" ? this.css.remove() : this.css.parentNode && this.css.parentNode.removeChild(this.css);
      } catch (n) {
        console.warn("Failed to remove CSS element:", n);
      }
    this.css = null, this.emit("unmount", { editor: this });
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && typeof document < "u" && (this.css = Sat(Eat, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(n = {}) {
    this.options = {
      ...this.options,
      ...n
    }, !(!this.editorView || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(n, e = !0) {
    this.setOptions({ editable: n }), e && this.emit("update", { editor: this, transaction: this.state.tr, appendedTransactions: [] });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get view() {
    return this.editorView ? this.editorView : new Proxy(
      {
        state: this.editorState,
        updateState: (n) => {
          this.editorState = n;
        },
        dispatch: (n) => {
          this.dispatchTransaction(n);
        },
        // Stub some commonly accessed properties to prevent errors
        composing: !1,
        dragging: null,
        editable: !0,
        isDestroyed: !1
      },
      {
        get: (n, e) => {
          if (this.editorView)
            return this.editorView[e];
          if (e === "state")
            return this.editorState;
          if (e in n)
            return Reflect.get(n, e);
          throw new Error(
            `[tiptap error]: The editor view is not available. Cannot access view['${e}']. The editor may not be mounted yet.`
          );
        }
      }
    );
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.editorView && (this.editorState = this.view.state), this.editorState;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(n, e) {
    const t = soe(e) ? e(n, [...this.state.plugins]) : [...this.state.plugins, n], r = this.state.reconfigure({ plugins: t });
    return this.view.updateState(r), r;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(n) {
    if (this.isDestroyed)
      return;
    const e = this.state.plugins;
    let t = e;
    if ([].concat(n).forEach((i) => {
      const s = typeof i == "string" ? `${i}$` : i.key;
      t = t.filter((o) => !o.key.startsWith(s));
    }), e.length === t.length)
      return;
    const r = this.state.reconfigure({
      plugins: t
    });
    return this.view.updateState(r), r;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var n, e;
    const r = [...this.options.enableCoreExtensions ? [
      xoe,
      voe.configure({
        blockSeparator: (e = (n = this.options.coreExtensionOptions) == null ? void 0 : n.clipboardTextSerializer) == null ? void 0 : e.blockSeparator
      }),
      yoe,
      Soe,
      Coe,
      Aoe,
      woe,
      Toe,
      boe
    ].filter((i) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[i.name] !== !1 : !0) : [], ...this.options.extensions].filter((i) => ["extension", "node", "mark"].includes(i?.type));
    this.extensionManager = new fx(r, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new ax({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates the initial document.
   */
  createDoc() {
    let n;
    try {
      n = i9(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: this.options.enableContentCheck
      });
    } catch (e) {
      if (!(e instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(e.message))
        throw e;
      this.emit("contentError", {
        editor: this,
        error: e,
        disableCollaboration: () => {
          "collaboration" in this.storage && typeof this.storage.collaboration == "object" && this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((t) => t.name !== "collaboration"), this.createExtensionManager();
        }
      }), n = i9(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: !1
      });
    }
    return n;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView(n) {
    var e;
    this.editorView = new Yse(n, {
      ...this.options.editorProps,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...(e = this.options.editorProps) == null ? void 0 : e.attributes
      },
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: this.editorState,
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
    const t = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(t), this.prependClass(), this.injectCSS();
    const r = this.view.dom;
    r.editor = this;
  }
  /**
   * Creates all node and mark views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(n) {
    this.isCapturingTransaction = !0, n(), this.isCapturingTransaction = !1;
    const e = this.capturedTransaction;
    return this.capturedTransaction = null, e;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(n) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = n;
        return;
      }
      n.steps.forEach((c) => {
        var u;
        return (u = this.capturedTransaction) == null ? void 0 : u.step(c);
      });
      return;
    }
    const { state: e, transactions: t } = this.state.applyTransaction(n), r = !this.state.selection.eq(e.selection), i = t.includes(n), s = this.state;
    if (this.emit("beforeTransaction", {
      editor: this,
      transaction: n,
      nextState: e
    }), !i)
      return;
    this.view.updateState(e), this.emit("transaction", {
      editor: this,
      transaction: n,
      appendedTransactions: t.slice(1)
    }), r && this.emit("selectionUpdate", {
      editor: this,
      transaction: n
    });
    const o = t.findLast((c) => c.getMeta("focus") || c.getMeta("blur")), a = o?.getMeta("focus"), l = o?.getMeta("blur");
    a && this.emit("focus", {
      editor: this,
      event: a.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: o
    }), l && this.emit("blur", {
      editor: this,
      event: l.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: o
    }), !(n.getMeta("preventUpdate") || !t.some((c) => c.docChanged) || s.doc.eq(e.doc)) && this.emit("update", {
      editor: this,
      transaction: n,
      appendedTransactions: t.slice(1)
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(n) {
    return uoe(this.state, n);
  }
  isActive(n, e) {
    const t = typeof n == "string" ? n : null, r = typeof n == "string" ? e : n;
    return Uot(this.state, t, r);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return uO(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(n) {
    const { blockSeparator: e = `

`, textSerializers: t = {} } = n || {};
    return coe(this.state.doc, {
      blockSeparator: e,
      textSerializers: {
        ...fO(this.schema),
        ...t
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return dx(this.state.doc);
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    this.emit("destroy"), this.unmount(), this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var n, e;
    return (e = (n = this.editorView) == null ? void 0 : n.isDestroyed) != null ? e : !0;
  }
  $node(n, e) {
    var t;
    return ((t = this.$doc) == null ? void 0 : t.querySelector(n, e)) || null;
  }
  $nodes(n, e) {
    var t;
    return ((t = this.$doc) == null ? void 0 : t.querySelectorAll(n, e)) || null;
  }
  $pos(n) {
    const e = this.state.doc.resolve(n);
    return new xat(e, this);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function ah(n) {
  return new B1({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const i = on(n.getAttributes, void 0, r);
      if (i === !1 || i === null)
        return null;
      const { tr: s } = e, o = r[r.length - 1], a = r[0];
      if (o) {
        const l = a.search(/\S/), c = t.from + a.indexOf(o), u = c + o.length;
        if (hO(t.from, t.to, e.doc).filter((h) => h.mark.type.excluded.find((g) => g === n.type && g !== h.mark.type)).filter((h) => h.to > c).length)
          return null;
        u < t.to && s.delete(u, t.to), c > t.from && s.delete(t.from + l, c);
        const f = t.from + l + o.length;
        s.addMark(t.from + l, f, n.type.create(i || {})), s.removeStoredMark(n.type);
      }
    },
    undoable: n.undoable
  });
}
function Moe(n) {
  return new B1({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const i = on(n.getAttributes, void 0, r) || {}, { tr: s } = e, o = t.from;
      let a = t.to;
      const l = n.type.create(i);
      if (r[1]) {
        const c = r[0].lastIndexOf(r[1]);
        let u = o + c;
        u > a ? u = a : a = u + r[1].length;
        const d = r[0][r[0].length - 1];
        s.insertText(d, o + r[0].length - 1), s.replaceWith(u, a, l);
      } else if (r[0]) {
        const c = n.type.isInline ? o : o - 1;
        s.insert(c, n.type.create(i)).delete(s.mapping.map(o), s.mapping.map(a));
      }
      s.scrollIntoView();
    },
    undoable: n.undoable
  });
}
function a9(n) {
  return new B1({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      const i = e.doc.resolve(t.from), s = on(n.getAttributes, void 0, r) || {};
      if (!i.node(-1).canReplaceWith(i.index(-1), i.indexAfter(-1), n.type))
        return null;
      e.tr.delete(t.from, t.to).setBlockType(t.from, t.from, n.type, s);
    },
    undoable: n.undoable
  });
}
function Qn(n) {
  return new B1({
    find: n.find,
    handler: ({ state: e, range: t, match: r }) => {
      let i = n.replace, s = t.from;
      const o = t.to;
      if (r[1]) {
        const a = r[0].lastIndexOf(r[1]);
        i += r[0].slice(a + r[1].length), s += a;
        const l = s - o;
        l > 0 && (i = r[0].slice(a - l, a) + i, s = o);
      }
      e.tr.insertText(i, s, o);
    },
    undoable: n.undoable
  });
}
function lh(n) {
  return new B1({
    find: n.find,
    handler: ({ state: e, range: t, match: r, chain: i }) => {
      const s = on(n.getAttributes, void 0, r) || {}, o = e.tr.delete(t.from, t.to), l = o.doc.resolve(t.from).blockRange(), c = l && V_(l, n.type, s);
      if (!c)
        return null;
      if (o.wrap(l, c), n.keepMarks && n.editor) {
        const { selection: d, storedMarks: f } = e, { splittableMarks: h } = n.editor.extensionManager, m = f || d.$to.parentOffset && d.$from.marks();
        if (m) {
          const g = m.filter((v) => h.includes(v.type.name));
          o.ensureMarks(g);
        }
      }
      if (n.keepAttributes) {
        const d = n.type.name === "bulletList" || n.type.name === "orderedList" ? "listItem" : "taskList";
        i().updateAttributes(d, s).run();
      }
      const u = o.doc.resolve(t.from - 1).nodeBefore;
      u && u.type === n.type && Dc(o.doc, t.from - 1) && (!n.joinPredicate || n.joinPredicate(r, u)) && o.join(t.from - 1);
    },
    undoable: n.undoable
  });
}
function Tat(n, e) {
  const { selection: t } = n, { $from: r } = t;
  if (t instanceof nt) {
    const s = r.index();
    return r.parent.canReplaceWith(s, s + 1, e);
  }
  let i = r.depth;
  for (; i >= 0; ) {
    const s = r.index(i);
    if (r.node(i).contentMatchAt(s).matchType(e))
      return !0;
    i -= 1;
  }
  return !1;
}
var Aat = {};
sO(Aat, {
  createAtomBlockMarkdownSpec: () => Mat,
  createBlockMarkdownSpec: () => kat,
  createInlineMarkdownSpec: () => Iat,
  parseAttributes: () => mO,
  parseIndentedBlocks: () => l9,
  renderNestedMarkdownContent: () => vO,
  serializeAttributes: () => gO
});
function mO(n) {
  if (!n?.trim())
    return {};
  const e = {}, t = [], r = n.replace(/["']([^"']*)["']/g, (c) => (t.push(c), `__QUOTED_${t.length - 1}__`)), i = r.match(/(?:^|\s)\.([a-zA-Z][\w-]*)/g);
  if (i) {
    const c = i.map((u) => u.trim().slice(1));
    e.class = c.join(" ");
  }
  const s = r.match(/(?:^|\s)#([a-zA-Z][\w-]*)/);
  s && (e.id = s[1]);
  const o = /([a-zA-Z][\w-]*)\s*=\s*(__QUOTED_\d+__)/g;
  Array.from(r.matchAll(o)).forEach(([, c, u]) => {
    var d;
    const f = parseInt(((d = u.match(/__QUOTED_(\d+)__/)) == null ? void 0 : d[1]) || "0", 10), h = t[f];
    h && (e[c] = h.slice(1, -1));
  });
  const l = r.replace(/(?:^|\s)\.([a-zA-Z][\w-]*)/g, "").replace(/(?:^|\s)#([a-zA-Z][\w-]*)/g, "").replace(/([a-zA-Z][\w-]*)\s*=\s*__QUOTED_\d+__/g, "").trim();
  return l && l.split(/\s+/).filter(Boolean).forEach((u) => {
    u.match(/^[a-zA-Z][\w-]*$/) && (e[u] = !0);
  }), e;
}
function gO(n) {
  if (!n || Object.keys(n).length === 0)
    return "";
  const e = [];
  return n.class && String(n.class).split(/\s+/).filter(Boolean).forEach((r) => e.push(`.${r}`)), n.id && e.push(`#${n.id}`), Object.entries(n).forEach(([t, r]) => {
    t === "class" || t === "id" || (r === !0 ? e.push(t) : r !== !1 && r != null && e.push(`${t}="${String(r)}"`));
  }), e.join(" ");
}
function Mat(n) {
  const {
    nodeName: e,
    name: t,
    parseAttributes: r = mO,
    serializeAttributes: i = gO,
    defaultAttributes: s = {},
    requiredAttributes: o = [],
    allowedAttributes: a
  } = n, l = t || e, c = (u) => {
    if (!a)
      return u;
    const d = {};
    return a.forEach((f) => {
      f in u && (d[f] = u[f]);
    }), d;
  };
  return {
    parseMarkdown: (u, d) => {
      const f = { ...s, ...u.attributes };
      return d.createNode(e, f, []);
    },
    markdownTokenizer: {
      name: e,
      level: "block",
      start(u) {
        var d;
        const f = new RegExp(`^:::${l}(?:\\s|$)`, "m"), h = (d = u.match(f)) == null ? void 0 : d.index;
        return h !== void 0 ? h : -1;
      },
      tokenize(u, d, f) {
        const h = new RegExp(`^:::${l}(?:\\s+\\{([^}]*)\\})?\\s*:::(?:\\n|$)`), m = u.match(h);
        if (!m)
          return;
        const g = m[1] || "", v = r(g);
        if (!o.find((b) => !(b in v)))
          return {
            type: e,
            raw: m[0],
            attributes: v
          };
      }
    },
    renderMarkdown: (u) => {
      const d = c(u.attrs || {}), f = i(d), h = f ? ` {${f}}` : "";
      return `:::${l}${h} :::`;
    }
  };
}
function kat(n) {
  const {
    nodeName: e,
    name: t,
    getContent: r,
    parseAttributes: i = mO,
    serializeAttributes: s = gO,
    defaultAttributes: o = {},
    content: a = "block",
    allowedAttributes: l
  } = n, c = t || e, u = (d) => {
    if (!l)
      return d;
    const f = {};
    return l.forEach((h) => {
      h in d && (f[h] = d[h]);
    }), f;
  };
  return {
    parseMarkdown: (d, f) => {
      let h;
      if (r) {
        const g = r(d);
        h = typeof g == "string" ? [{ type: "text", text: g }] : g;
      } else a === "block" ? h = f.parseChildren(d.tokens || []) : h = f.parseInline(d.tokens || []);
      const m = { ...o, ...d.attributes };
      return f.createNode(e, m, h);
    },
    markdownTokenizer: {
      name: e,
      level: "block",
      start(d) {
        var f;
        const h = new RegExp(`^:::${c}`, "m"), m = (f = d.match(h)) == null ? void 0 : f.index;
        return m !== void 0 ? m : -1;
      },
      tokenize(d, f, h) {
        var m;
        const g = new RegExp(`^:::${c}(?:\\s+\\{([^}]*)\\})?\\s*\\n`), v = d.match(g);
        if (!v)
          return;
        const [y, b = ""] = v, x = i(b);
        let E = 1;
        const w = y.length;
        let C = "";
        const S = /^:::([\w-]*)(\s.*)?/gm, M = d.slice(w);
        for (S.lastIndex = 0; ; ) {
          const k = S.exec(M);
          if (k === null)
            break;
          const _ = k.index, O = k[1];
          if (!((m = k[2]) != null && m.endsWith(":::"))) {
            if (O)
              E += 1;
            else if (E -= 1, E === 0) {
              const I = M.slice(0, _);
              C = I.trim();
              const R = d.slice(0, w + _ + k[0].length);
              let P = [];
              if (C)
                if (a === "block")
                  for (P = h.blockTokens(I), P.forEach((D) => {
                    D.text && (!D.tokens || D.tokens.length === 0) && (D.tokens = h.inlineTokens(D.text));
                  }); P.length > 0; ) {
                    const D = P[P.length - 1];
                    if (D.type === "paragraph" && (!D.text || D.text.trim() === ""))
                      P.pop();
                    else
                      break;
                  }
                else
                  P = h.inlineTokens(C);
              return {
                type: e,
                raw: R,
                attributes: x,
                content: C,
                tokens: P
              };
            }
          }
        }
      }
    },
    renderMarkdown: (d, f) => {
      const h = u(d.attrs || {}), m = s(h), g = m ? ` {${m}}` : "", v = f.renderChildren(d.content || [], `

`);
      return `:::${c}${g}

${v}

:::`;
    }
  };
}
function _at(n) {
  if (!n.trim())
    return {};
  const e = {}, t = /(\w+)=(?:"([^"]*)"|'([^']*)')/g;
  let r = t.exec(n);
  for (; r !== null; ) {
    const [, i, s, o] = r;
    e[i] = s || o, r = t.exec(n);
  }
  return e;
}
function Oat(n) {
  return Object.entries(n).filter(([, e]) => e != null).map(([e, t]) => `${e}="${t}"`).join(" ");
}
function Iat(n) {
  const {
    nodeName: e,
    name: t,
    getContent: r,
    parseAttributes: i = _at,
    serializeAttributes: s = Oat,
    defaultAttributes: o = {},
    selfClosing: a = !1,
    allowedAttributes: l
  } = n, c = t || e, u = (f) => {
    if (!l)
      return f;
    const h = {};
    return l.forEach((m) => {
      m in f && (h[m] = f[m]);
    }), h;
  }, d = c.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return {
    parseMarkdown: (f, h) => {
      const m = { ...o, ...f.attributes };
      if (a)
        return h.createNode(e, m);
      const g = r ? r(f) : f.content || "";
      return g ? h.createNode(e, m, [h.createTextNode(g)]) : h.createNode(e, m, []);
    },
    markdownTokenizer: {
      name: e,
      level: "inline",
      start(f) {
        const h = a ? new RegExp(`\\[${d}\\s*[^\\]]*\\]`) : new RegExp(`\\[${d}\\s*[^\\]]*\\][\\s\\S]*?\\[\\/${d}\\]`), m = f.match(h), g = m?.index;
        return g !== void 0 ? g : -1;
      },
      tokenize(f, h, m) {
        const g = a ? new RegExp(`^\\[${d}\\s*([^\\]]*)\\]`) : new RegExp(`^\\[${d}\\s*([^\\]]*)\\]([\\s\\S]*?)\\[\\/${d}\\]`), v = f.match(g);
        if (!v)
          return;
        let y = "", b = "";
        if (a) {
          const [, E] = v;
          b = E;
        } else {
          const [, E, w] = v;
          b = E, y = w || "";
        }
        const x = i(b.trim());
        return {
          type: e,
          raw: v[0],
          content: y.trim(),
          attributes: x
        };
      }
    },
    renderMarkdown: (f) => {
      let h = "";
      r ? h = r(f) : f.content && f.content.length > 0 && (h = f.content.filter((y) => y.type === "text").map((y) => y.text).join(""));
      const m = u(f.attrs || {}), g = s(m), v = g ? ` ${g}` : "";
      return a ? `[${c}${v}]` : `[${c}${v}]${h}[/${c}]`;
    }
  };
}
function l9(n, e, t) {
  var r, i, s, o;
  const a = n.split(`
`), l = [];
  let c = "", u = 0;
  const d = e.baseIndentSize || 2;
  for (; u < a.length; ) {
    const f = a[u], h = f.match(e.itemPattern);
    if (!h) {
      if (l.length > 0)
        break;
      if (f.trim() === "") {
        u += 1;
        continue;
      } else
        return;
    }
    const m = e.extractItemData(h), { indentLevel: g, mainContent: v } = m;
    c = `${c}${f}
`;
    const y = [v];
    for (u += 1; u < a.length; ) {
      const w = a[u];
      if (w.trim() === "") {
        const S = a.slice(u + 1).findIndex((_) => _.trim() !== "");
        if (S === -1)
          break;
        if ((((i = (r = a[u + 1 + S].match(/^(\s*)/)) == null ? void 0 : r[1]) == null ? void 0 : i.length) || 0) > g) {
          y.push(w), c = `${c}${w}
`, u += 1;
          continue;
        } else
          break;
      }
      if ((((o = (s = w.match(/^(\s*)/)) == null ? void 0 : s[1]) == null ? void 0 : o.length) || 0) > g)
        y.push(w), c = `${c}${w}
`, u += 1;
      else
        break;
    }
    let b;
    const x = y.slice(1);
    if (x.length > 0) {
      const w = x.map((C) => C.slice(g + d)).join(`
`);
      w.trim() && (e.customNestedParser ? b = e.customNestedParser(w) : b = t.blockTokens(w));
    }
    const E = e.createToken(m, b);
    l.push(E);
  }
  if (l.length !== 0)
    return {
      items: l,
      raw: c.trim()
    };
}
function vO(n, e, t, r) {
  if (!n || !Array.isArray(n.content))
    return "";
  const i = typeof t == "function" ? t(r) : t, [s, ...o] = n.content, a = e.renderChildren([s]), l = [`${i}${a}`];
  return o && o.length > 0 && o.forEach((c) => {
    const u = e.renderChildren([c]);
    if (u) {
      const d = u.split(`
`).map((f) => f ? e.indent(f) : "").join(`
`);
      l.push(d);
    }
  }), l.join(`
`);
}
function Rat(n, e, t = {}) {
  const { state: r } = e, { doc: i, tr: s } = r, o = n;
  i.descendants((a, l) => {
    const c = s.mapping.map(l), u = s.mapping.map(l) + a.nodeSize;
    let d = null;
    if (a.marks.forEach((h) => {
      if (h !== o)
        return !1;
      d = h;
    }), !d)
      return;
    let f = !1;
    if (Object.keys(t).forEach((h) => {
      t[h] !== d.attrs[h] && (f = !0);
    }), f) {
      const h = n.type.create({
        ...n.attrs,
        ...t
      });
      s.removeMark(c, u, n.type), s.addMark(c, u, h);
    }
  }), s.docChanged && e.view.dispatch(s);
}
var Yi = class koe extends pO {
  constructor() {
    super(...arguments), this.type = "node";
  }
  /**
   * Create a new Node instance
   * @param config - Node configuration object or a function that returns a configuration object
   */
  static create(e = {}) {
    const t = typeof e == "function" ? e() : e;
    return new koe(t);
  }
  configure(e) {
    return super.configure(e);
  }
  extend(e) {
    const t = typeof e == "function" ? e() : e;
    return super.extend(t);
  }
}, Pat = class {
  constructor(n, e, t) {
    this.isDragging = !1, this.component = n, this.editor = e.editor, this.options = {
      stopEvent: null,
      ignoreMutation: null,
      ...t
    }, this.extension = e.extension, this.node = e.node, this.decorations = e.decorations, this.innerDecorations = e.innerDecorations, this.view = e.view, this.HTMLAttributes = e.HTMLAttributes, this.getPos = e.getPos, this.mount();
  }
  mount() {
  }
  get dom() {
    return this.editor.view.dom;
  }
  get contentDOM() {
    return null;
  }
  onDragStart(n) {
    var e, t, r, i, s, o, a;
    const { view: l } = this.editor, c = n.target, u = c.nodeType === 3 ? (e = c.parentElement) == null ? void 0 : e.closest("[data-drag-handle]") : c.closest("[data-drag-handle]");
    if (!this.dom || (t = this.contentDOM) != null && t.contains(c) || !u)
      return;
    let d = 0, f = 0;
    if (this.dom !== u) {
      const b = this.dom.getBoundingClientRect(), x = u.getBoundingClientRect(), E = (i = n.offsetX) != null ? i : (r = n.nativeEvent) == null ? void 0 : r.offsetX, w = (o = n.offsetY) != null ? o : (s = n.nativeEvent) == null ? void 0 : s.offsetY;
      d = x.x - b.x + E, f = x.y - b.y + w;
    }
    const h = this.dom.cloneNode(!0);
    try {
      const b = this.dom.getBoundingClientRect();
      h.style.width = `${Math.round(b.width)}px`, h.style.height = `${Math.round(b.height)}px`, h.style.boxSizing = "border-box", h.style.pointerEvents = "none";
    } catch {
    }
    let m = null;
    try {
      m = document.createElement("div"), m.style.position = "absolute", m.style.top = "-9999px", m.style.left = "-9999px", m.style.pointerEvents = "none", m.appendChild(h), document.body.appendChild(m), (a = n.dataTransfer) == null || a.setDragImage(h, d, f);
    } finally {
      m && setTimeout(() => {
        try {
          m?.remove();
        } catch {
        }
      }, 0);
    }
    const g = this.getPos();
    if (typeof g != "number")
      return;
    const v = nt.create(l.state.doc, g), y = l.state.tr.setSelection(v);
    l.dispatch(y);
  }
  stopEvent(n) {
    var e;
    if (!this.dom)
      return !1;
    if (typeof this.options.stopEvent == "function")
      return this.options.stopEvent({ event: n });
    const t = n.target;
    if (!(this.dom.contains(t) && !((e = this.contentDOM) != null && e.contains(t))))
      return !1;
    const i = n.type.startsWith("drag"), s = n.type === "drop";
    if ((["INPUT", "BUTTON", "SELECT", "TEXTAREA"].includes(t.tagName) || t.isContentEditable) && !s && !i)
      return !0;
    const { isEditable: a } = this.editor, { isDragging: l } = this, c = !!this.node.type.spec.draggable, u = nt.isSelectable(this.node), d = n.type === "copy", f = n.type === "paste", h = n.type === "cut", m = n.type === "mousedown";
    if (!c && u && i && n.target === this.dom && n.preventDefault(), c && i && !l && n.target === this.dom)
      return n.preventDefault(), !1;
    if (c && a && !l && m) {
      const g = t.closest("[data-drag-handle]");
      g && (this.dom === g || this.dom.contains(g)) && (this.isDragging = !0, document.addEventListener(
        "dragend",
        () => {
          this.isDragging = !1;
        },
        { once: !0 }
      ), document.addEventListener(
        "drop",
        () => {
          this.isDragging = !1;
        },
        { once: !0 }
      ), document.addEventListener(
        "mouseup",
        () => {
          this.isDragging = !1;
        },
        { once: !0 }
      ));
    }
    return !(l || s || d || f || h || m && u);
  }
  /**
   * Called when a DOM [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver) or a selection change happens within the view.
   * @return `false` if the editor should re-read the selection or re-parse the range around the mutation
   * @return `true` if it can safely be ignored.
   */
  ignoreMutation(n) {
    return !this.dom || !this.contentDOM ? !0 : typeof this.options.ignoreMutation == "function" ? this.options.ignoreMutation({ mutation: n }) : this.node.isLeaf || this.node.isAtom ? !0 : n.type === "selection" || this.dom.contains(n.target) && n.type === "childList" && (lx() || eoe()) && this.editor.isFocused && [...Array.from(n.addedNodes), ...Array.from(n.removedNodes)].every((t) => t.isContentEditable) ? !1 : this.contentDOM === n.target && n.type === "attributes" ? !0 : !this.contentDOM.contains(n.target);
  }
  /**
   * Update the attributes of the prosemirror node.
   */
  updateAttributes(n) {
    this.editor.commands.command(({ tr: e }) => {
      const t = this.getPos();
      return typeof t != "number" ? !1 : (e.setNodeMarkup(t, void 0, {
        ...this.node.attrs,
        ...n
      }), !0);
    });
  }
  /**
   * Delete the node.
   */
  deleteNode() {
    const n = this.getPos();
    if (typeof n != "number")
      return;
    const e = n + this.node.nodeSize;
    this.editor.commands.deleteRange({ from: n, to: e });
  }
};
function Wu(n) {
  return new mat({
    find: n.find,
    handler: ({ state: e, range: t, match: r, pasteEvent: i }) => {
      const s = on(n.getAttributes, void 0, r, i);
      if (s === !1 || s === null)
        return null;
      const { tr: o } = e, a = r[r.length - 1], l = r[0];
      let c = t.to;
      if (a) {
        const u = l.search(/\S/), d = t.from + l.indexOf(a), f = d + a.length;
        if (hO(t.from, t.to, e.doc).filter((m) => m.mark.type.excluded.find((v) => v === n.type && v !== m.mark.type)).filter((m) => m.to > d).length)
          return null;
        f < t.to && o.delete(f, t.to), d > t.from && o.delete(t.from + u, d), c = t.from + u + a.length, o.addMark(t.from + u, c, n.type.create(s || {})), o.removeStoredMark(n.type);
      }
    }
  });
}
var p8, TV;
function Dat() {
  return TV || (TV = 1, p8 = function n(e, t) {
    if (e === t) return !0;
    if (e && t && typeof e == "object" && typeof t == "object") {
      if (e.constructor !== t.constructor) return !1;
      var r, i, s;
      if (Array.isArray(e)) {
        if (r = e.length, r != t.length) return !1;
        for (i = r; i-- !== 0; )
          if (!n(e[i], t[i])) return !1;
        return !0;
      }
      if (e instanceof Map && t instanceof Map) {
        if (e.size !== t.size) return !1;
        for (i of e.entries())
          if (!t.has(i[0])) return !1;
        for (i of e.entries())
          if (!n(i[1], t.get(i[0]))) return !1;
        return !0;
      }
      if (e instanceof Set && t instanceof Set) {
        if (e.size !== t.size) return !1;
        for (i of e.entries())
          if (!t.has(i[0])) return !1;
        return !0;
      }
      if (ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
        if (r = e.length, r != t.length) return !1;
        for (i = r; i-- !== 0; )
          if (e[i] !== t[i]) return !1;
        return !0;
      }
      if (e.constructor === RegExp) return e.source === t.source && e.flags === t.flags;
      if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === t.valueOf();
      if (e.toString !== Object.prototype.toString) return e.toString() === t.toString();
      if (s = Object.keys(e), r = s.length, r !== Object.keys(t).length) return !1;
      for (i = r; i-- !== 0; )
        if (!Object.prototype.hasOwnProperty.call(t, s[i])) return !1;
      for (i = r; i-- !== 0; ) {
        var o = s[i];
        if (!(o === "_owner" && e.$$typeof) && !n(e[o], t[o]))
          return !1;
      }
      return !0;
    }
    return e !== e && t !== t;
  }), p8;
}
var Nat = Dat();
const Lat = /* @__PURE__ */ nn(Nat);
var tv = { exports: {} }, m8 = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var AV;
function $at() {
  if (AV) return m8;
  AV = 1;
  var n = p, e = z_();
  function t(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var r = typeof Object.is == "function" ? Object.is : t, i = e.useSyncExternalStore, s = n.useRef, o = n.useEffect, a = n.useMemo, l = n.useDebugValue;
  return m8.useSyncExternalStoreWithSelector = function(c, u, d, f, h) {
    var m = s(null);
    if (m.current === null) {
      var g = { hasValue: !1, value: null };
      m.current = g;
    } else g = m.current;
    m = a(
      function() {
        function y(C) {
          if (!b) {
            if (b = !0, x = C, C = f(C), h !== void 0 && g.hasValue) {
              var S = g.value;
              if (h(S, C))
                return E = S;
            }
            return E = C;
          }
          if (S = E, r(x, C)) return S;
          var M = f(C);
          return h !== void 0 && h(S, M) ? (x = C, S) : (x = C, E = M);
        }
        var b = !1, x, E, w = d === void 0 ? null : d;
        return [
          function() {
            return y(u());
          },
          w === null ? void 0 : function() {
            return y(w());
          }
        ];
      },
      [u, d, f, h]
    );
    var v = i(c, m[0], m[1]);
    return o(
      function() {
        g.hasValue = !0, g.value = v;
      },
      [v]
    ), l(v), v;
  }, m8;
}
var g8 = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var MV;
function Fat() {
  return MV || (MV = 1, process.env.NODE_ENV !== "production" && (function() {
    function n(c, u) {
      return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var e = p, t = z_(), r = typeof Object.is == "function" ? Object.is : n, i = t.useSyncExternalStore, s = e.useRef, o = e.useEffect, a = e.useMemo, l = e.useDebugValue;
    g8.useSyncExternalStoreWithSelector = function(c, u, d, f, h) {
      var m = s(null);
      if (m.current === null) {
        var g = { hasValue: !1, value: null };
        m.current = g;
      } else g = m.current;
      m = a(
        function() {
          function y(C) {
            if (!b) {
              if (b = !0, x = C, C = f(C), h !== void 0 && g.hasValue) {
                var S = g.value;
                if (h(S, C))
                  return E = S;
              }
              return E = C;
            }
            if (S = E, r(x, C))
              return S;
            var M = f(C);
            return h !== void 0 && h(S, M) ? (x = C, S) : (x = C, E = M);
          }
          var b = !1, x, E, w = d === void 0 ? null : d;
          return [
            function() {
              return y(u());
            },
            w === null ? void 0 : function() {
              return y(w());
            }
          ];
        },
        [u, d, f, h]
      );
      var v = i(c, m[0], m[1]);
      return o(
        function() {
          g.hasValue = !0, g.value = v;
        },
        [v]
      ), l(v), v;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })()), g8;
}
var kV;
function Bat() {
  return kV || (kV = 1, process.env.NODE_ENV === "production" ? tv.exports = $at() : tv.exports = Fat()), tv.exports;
}
var zat = Bat(), Hat = (...n) => (e) => {
  n.forEach((t) => {
    typeof t == "function" ? t(e) : t && (t.current = e);
  });
}, Uat = ({ contentComponent: n }) => {
  const e = wie.useSyncExternalStore(
    n.subscribe,
    n.getSnapshot,
    n.getServerSnapshot
  );
  return /* @__PURE__ */ T(ft, { children: Object.values(e) });
};
function Vat() {
  const n = /* @__PURE__ */ new Set();
  let e = {};
  return {
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(t) {
      return n.add(t), () => {
        n.delete(t);
      };
    },
    getSnapshot() {
      return e;
    },
    getServerSnapshot() {
      return e;
    },
    /**
     * Adds a new NodeView Renderer to the editor.
     */
    setRenderer(t, r) {
      e = {
        ...e,
        [t]: gw.createPortal(r.reactElement, r.element, t)
      }, n.forEach((i) => i());
    },
    /**
     * Removes a NodeView Renderer from the editor.
     */
    removeRenderer(t) {
      const r = { ...e };
      delete r[t], e = r, n.forEach((i) => i());
    }
  };
}
var jat = class extends p.Component {
  constructor(n) {
    var e;
    super(n), this.editorContentRef = p.createRef(), this.initialized = !1, this.state = {
      hasContentComponentInitialized: !!((e = n.editor) != null && e.contentComponent)
    };
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate() {
    this.init();
  }
  init() {
    const n = this.props.editor;
    if (n && !n.isDestroyed && n.options.element) {
      if (n.contentComponent)
        return;
      const e = this.editorContentRef.current;
      e.append(n.view.dom), n.setOptions({
        element: e
      }), n.contentComponent = Vat(), this.state.hasContentComponentInitialized || (this.unsubscribeToContentComponent = n.contentComponent.subscribe(() => {
        this.setState((t) => t.hasContentComponentInitialized ? t : {
          hasContentComponentInitialized: !0
        }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent();
      })), n.createNodeViews(), this.initialized = !0;
    }
  }
  componentWillUnmount() {
    var n;
    const e = this.props.editor;
    if (e) {
      this.initialized = !1, e.isDestroyed || e.view.setProps({
        nodeViews: {}
      }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent(), e.contentComponent = null;
      try {
        if (!((n = e.view.dom) != null && n.firstChild))
          return;
        const t = document.createElement("div");
        t.append(e.view.dom), e.setOptions({
          element: t
        });
      } catch {
      }
    }
  }
  render() {
    const { editor: n, innerRef: e, ...t } = this.props;
    return /* @__PURE__ */ ee(ft, { children: [
      /* @__PURE__ */ T("div", { ref: Hat(e, this.editorContentRef), ...t }),
      n?.contentComponent && /* @__PURE__ */ T(Uat, { contentComponent: n.contentComponent })
    ] });
  }
}, Wat = tn(
  (n, e) => {
    const t = p.useMemo(() => Math.floor(Math.random() * 4294967295).toString(), [n.editor]);
    return p.createElement(jat, {
      key: t,
      innerRef: e,
      ...n
    });
  }
), Gat = p.memo(Wat), Kat = typeof window < "u" ? vh : Tt, qat = class {
  constructor(n) {
    this.transactionNumber = 0, this.lastTransactionNumber = 0, this.subscribers = /* @__PURE__ */ new Set(), this.editor = n, this.lastSnapshot = { editor: n, transactionNumber: 0 }, this.getSnapshot = this.getSnapshot.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.watch = this.watch.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  /**
   * Get the current editor instance.
   */
  getSnapshot() {
    return this.transactionNumber === this.lastTransactionNumber ? this.lastSnapshot : (this.lastTransactionNumber = this.transactionNumber, this.lastSnapshot = { editor: this.editor, transactionNumber: this.transactionNumber }, this.lastSnapshot);
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return { editor: null, transactionNumber: 0 };
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(n) {
    return this.subscribers.add(n), () => {
      this.subscribers.delete(n);
    };
  }
  /**
   * Watch the editor instance for changes.
   */
  watch(n) {
    if (this.editor = n, this.editor) {
      const e = () => {
        this.transactionNumber += 1, this.subscribers.forEach((r) => r());
      }, t = this.editor;
      return t.on("transaction", e), () => {
        t.off("transaction", e);
      };
    }
  }
};
function _oe(n) {
  var e;
  const [t] = wt(() => new qat(n.editor)), r = zat.useSyncExternalStoreWithSelector(
    t.subscribe,
    t.getSnapshot,
    t.getServerSnapshot,
    n.selector,
    (e = n.equalityFn) != null ? e : Lat
  );
  return Kat(() => t.watch(n.editor), [n.editor, t]), SG(r), r;
}
var _V = process.env.NODE_ENV !== "production", c9 = typeof window > "u", Yat = c9 || !!(typeof window < "u" && window.next), Xat = class Ooe {
  constructor(e) {
    this.editor = null, this.subscriptions = /* @__PURE__ */ new Set(), this.isComponentMounted = !1, this.previousDeps = null, this.instanceId = "", this.options = e, this.subscriptions = /* @__PURE__ */ new Set(), this.setEditor(this.getInitialEditor()), this.scheduleDestroy(), this.getEditor = this.getEditor.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.subscribe = this.subscribe.bind(this), this.refreshEditorInstance = this.refreshEditorInstance.bind(this), this.scheduleDestroy = this.scheduleDestroy.bind(this), this.onRender = this.onRender.bind(this), this.createEditor = this.createEditor.bind(this);
  }
  setEditor(e) {
    this.editor = e, this.instanceId = Math.random().toString(36).slice(2, 9), this.subscriptions.forEach((t) => t());
  }
  getInitialEditor() {
    if (this.options.current.immediatelyRender === void 0) {
      if (c9 || Yat) {
        if (_V)
          throw new Error(
            "Tiptap Error: SSR has been detected, please set `immediatelyRender` explicitly to `false` to avoid hydration mismatches."
          );
        return null;
      }
      return this.createEditor();
    }
    if (this.options.current.immediatelyRender && c9 && _V)
      throw new Error(
        "Tiptap Error: SSR has been detected, and `immediatelyRender` has been set to `true` this is an unsupported configuration that may result in errors, explicitly set `immediatelyRender` to `false` to avoid hydration mismatches."
      );
    return this.options.current.immediatelyRender ? this.createEditor() : null;
  }
  /**
   * Create a new editor instance. And attach event listeners.
   */
  createEditor() {
    const e = {
      ...this.options.current,
      // Always call the most recent version of the callback function by default
      onBeforeCreate: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onBeforeCreate) == null ? void 0 : s.call(i, ...r);
      },
      onBlur: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onBlur) == null ? void 0 : s.call(i, ...r);
      },
      onCreate: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onCreate) == null ? void 0 : s.call(i, ...r);
      },
      onDestroy: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onDestroy) == null ? void 0 : s.call(i, ...r);
      },
      onFocus: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onFocus) == null ? void 0 : s.call(i, ...r);
      },
      onSelectionUpdate: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onSelectionUpdate) == null ? void 0 : s.call(i, ...r);
      },
      onTransaction: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onTransaction) == null ? void 0 : s.call(i, ...r);
      },
      onUpdate: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onUpdate) == null ? void 0 : s.call(i, ...r);
      },
      onContentError: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onContentError) == null ? void 0 : s.call(i, ...r);
      },
      onDrop: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onDrop) == null ? void 0 : s.call(i, ...r);
      },
      onPaste: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onPaste) == null ? void 0 : s.call(i, ...r);
      },
      onDelete: (...r) => {
        var i, s;
        return (s = (i = this.options.current).onDelete) == null ? void 0 : s.call(i, ...r);
      }
    };
    return new Cat(e);
  }
  /**
   * Get the current editor instance.
   */
  getEditor() {
    return this.editor;
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return null;
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(e) {
    return this.subscriptions.add(e), () => {
      this.subscriptions.delete(e);
    };
  }
  static compareOptions(e, t) {
    return Object.keys(e).every((r) => [
      "onCreate",
      "onBeforeCreate",
      "onDestroy",
      "onUpdate",
      "onTransaction",
      "onFocus",
      "onBlur",
      "onSelectionUpdate",
      "onContentError",
      "onDrop",
      "onPaste"
    ].includes(r) ? !0 : r === "extensions" && e.extensions && t.extensions ? e.extensions.length !== t.extensions.length ? !1 : e.extensions.every((i, s) => {
      var o;
      return i === ((o = t.extensions) == null ? void 0 : o[s]);
    }) : e[r] === t[r]);
  }
  /**
   * On each render, we will create, update, or destroy the editor instance.
   * @param deps The dependencies to watch for changes
   * @returns A cleanup function
   */
  onRender(e) {
    return () => (this.isComponentMounted = !0, clearTimeout(this.scheduledDestructionTimeout), this.editor && !this.editor.isDestroyed && e.length === 0 ? Ooe.compareOptions(this.options.current, this.editor.options) || this.editor.setOptions({
      ...this.options.current,
      editable: this.editor.isEditable
    }) : this.refreshEditorInstance(e), () => {
      this.isComponentMounted = !1, this.scheduleDestroy();
    });
  }
  /**
   * Recreate the editor instance if the dependencies have changed.
   */
  refreshEditorInstance(e) {
    if (this.editor && !this.editor.isDestroyed) {
      if (this.previousDeps === null) {
        this.previousDeps = e;
        return;
      }
      if (this.previousDeps.length === e.length && this.previousDeps.every((r, i) => r === e[i]))
        return;
    }
    this.editor && !this.editor.isDestroyed && this.editor.destroy(), this.setEditor(this.createEditor()), this.previousDeps = e;
  }
  /**
   * Schedule the destruction of the editor instance.
   * This will only destroy the editor if it was not mounted on the next tick.
   * This is to avoid destroying the editor instance when it's actually still mounted.
   */
  scheduleDestroy() {
    const e = this.instanceId, t = this.editor;
    this.scheduledDestructionTimeout = setTimeout(() => {
      if (this.isComponentMounted && this.instanceId === e) {
        t && t.setOptions(this.options.current);
        return;
      }
      t && !t.isDestroyed && (t.destroy(), this.instanceId === e && this.setEditor(null));
    }, 1);
  }
};
function Zat(n = {}, e = []) {
  const t = Gt(n);
  t.current = n;
  const [r] = wt(() => new Xat(t)), i = wie.useSyncExternalStore(
    r.subscribe,
    r.getEditor,
    r.getServerSnapshot
  );
  return SG(i), Tt(r.onRender(e)), _oe({
    editor: i,
    selector: ({ transactionNumber: s }) => n.shouldRerenderOnTransaction === !1 || n.shouldRerenderOnTransaction === void 0 ? null : n.immediatelyRender && s === 0 ? 0 : s + 1
  }), i;
}
var Ioe = Ws({
  editor: null
});
Ioe.Consumer;
var Roe = () => Wi(Ioe), Poe = Ws({
  onDragStart: () => {
  },
  nodeViewContentChildren: void 0,
  nodeViewContentRef: () => {
  }
}), Qat = () => Wi(Poe), Jat = p.forwardRef((n, e) => {
  const { onDragStart: t } = Qat(), r = n.as || "div";
  return (
    // @ts-ignore
    /* @__PURE__ */ T(
      r,
      {
        ...n,
        ref: e,
        "data-node-view-wrapper": "",
        onDragStart: t,
        style: {
          whiteSpace: "normal",
          ...n.style
        }
      }
    )
  );
});
function OV(n) {
  return !!(typeof n == "function" && n.prototype && n.prototype.isReactComponent);
}
function IV(n) {
  return !!(typeof n == "object" && n.$$typeof && (n.$$typeof.toString() === "Symbol(react.forward_ref)" || n.$$typeof.description === "react.forward_ref"));
}
function elt(n) {
  return !!(typeof n == "object" && n.$$typeof && (n.$$typeof.toString() === "Symbol(react.memo)" || n.$$typeof.description === "react.memo"));
}
function tlt(n) {
  if (OV(n) || IV(n))
    return !0;
  if (elt(n)) {
    const e = n.type;
    if (e)
      return OV(e) || IV(e);
  }
  return !1;
}
function nlt() {
  try {
    if (_I)
      return parseInt(_I.split(".")[0], 10) >= 19;
  } catch {
  }
  return !1;
}
var rlt = class {
  /**
   * Immediately creates element and renders the provided React component.
   */
  constructor(n, { editor: e, props: t = {}, as: r = "div", className: i = "" }) {
    this.ref = null, this.id = Math.floor(Math.random() * 4294967295).toString(), this.component = n, this.editor = e, this.props = t, this.element = document.createElement(r), this.element.classList.add("react-renderer"), i && this.element.classList.add(...i.split(" ")), this.editor.isInitialized ? Nfe(() => {
      this.render();
    }) : queueMicrotask(() => {
      this.render();
    });
  }
  /**
   * Render the React component.
   */
  render() {
    var n;
    const e = this.component, t = this.props, r = this.editor, i = nlt(), s = tlt(e), o = { ...t };
    o.ref && !(i || s) && delete o.ref, !o.ref && (i || s) && (o.ref = (a) => {
      this.ref = a;
    }), this.reactElement = /* @__PURE__ */ T(e, { ...o }), (n = r?.contentComponent) == null || n.setRenderer(this.id, this);
  }
  /**
   * Re-renders the React component with new props.
   */
  updateProps(n = {}) {
    this.props = {
      ...this.props,
      ...n
    }, this.render();
  }
  /**
   * Destroy the React component.
   */
  destroy() {
    var n;
    const e = this.editor;
    (n = e?.contentComponent) == null || n.removeRenderer(this.id);
    try {
      this.element && this.element.parentNode && this.element.parentNode.removeChild(this.element);
    } catch {
    }
  }
  /**
   * Update the attributes of the element that holds the React component.
   */
  updateAttributes(n) {
    Object.keys(n).forEach((e) => {
      this.element.setAttribute(e, n[e]);
    });
  }
};
p.createContext({
  markViewContentRef: () => {
  }
});
var ilt = class extends Pat {
  constructor(n, e, t) {
    if (super(n, e, t), !this.node.isLeaf) {
      this.options.contentDOMElementTag ? this.contentDOMElement = document.createElement(this.options.contentDOMElementTag) : this.contentDOMElement = document.createElement(this.node.isInline ? "span" : "div"), this.contentDOMElement.dataset.nodeViewContentReact = "", this.contentDOMElement.dataset.nodeViewWrapper = "", this.contentDOMElement.style.whiteSpace = "inherit";
      const r = this.dom.querySelector("[data-node-view-content]");
      if (!r)
        return;
      r.appendChild(this.contentDOMElement);
    }
  }
  /**
   * Setup the React component.
   * Called on initialization.
   */
  mount() {
    const n = {
      editor: this.editor,
      node: this.node,
      decorations: this.decorations,
      innerDecorations: this.innerDecorations,
      view: this.view,
      selected: !1,
      extension: this.extension,
      HTMLAttributes: this.HTMLAttributes,
      getPos: () => this.getPos(),
      updateAttributes: (l = {}) => this.updateAttributes(l),
      deleteNode: () => this.deleteNode(),
      ref: Rfe()
    };
    if (!this.component.displayName) {
      const l = (c) => c.charAt(0).toUpperCase() + c.substring(1);
      this.component.displayName = l(this.extension.name);
    }
    const r = { onDragStart: this.onDragStart.bind(this), nodeViewContentRef: (l) => {
      l && this.contentDOMElement && l.firstChild !== this.contentDOMElement && (l.hasAttribute("data-node-view-wrapper") && l.removeAttribute("data-node-view-wrapper"), l.appendChild(this.contentDOMElement));
    } }, i = this.component, s = Pfe((l) => /* @__PURE__ */ T(Poe.Provider, { value: r, children: lt(i, l) }));
    s.displayName = "ReactNodeView";
    let o = this.node.isInline ? "span" : "div";
    this.options.as && (o = this.options.as);
    const { className: a = "" } = this.options;
    this.handleSelectionUpdate = this.handleSelectionUpdate.bind(this), this.renderer = new rlt(s, {
      editor: this.editor,
      props: n,
      as: o,
      className: `node-${this.node.type.name} ${a}`.trim()
    }), this.editor.on("selectionUpdate", this.handleSelectionUpdate), this.updateElementAttributes();
  }
  /**
   * Return the DOM element.
   * This is the element that will be used to display the node view.
   */
  get dom() {
    var n;
    if (this.renderer.element.firstElementChild && !((n = this.renderer.element.firstElementChild) != null && n.hasAttribute("data-node-view-wrapper")))
      throw Error("Please use the NodeViewWrapper component for your node view.");
    return this.renderer.element;
  }
  /**
   * Return the content DOM element.
   * This is the element that will be used to display the rich-text content of the node.
   */
  get contentDOM() {
    return this.node.isLeaf ? null : this.contentDOMElement;
  }
  /**
   * On editor selection update, check if the node is selected.
   * If it is, call `selectNode`, otherwise call `deselectNode`.
   */
  handleSelectionUpdate() {
    const { from: n, to: e } = this.editor.state.selection, t = this.getPos();
    if (typeof t == "number")
      if (n <= t && e >= t + this.node.nodeSize) {
        if (this.renderer.props.selected)
          return;
        this.selectNode();
      } else {
        if (!this.renderer.props.selected)
          return;
        this.deselectNode();
      }
  }
  /**
   * On update, update the React component.
   * To prevent unnecessary updates, the `update` option can be used.
   */
  update(n, e, t) {
    const r = (i) => {
      this.renderer.updateProps(i), typeof this.options.attrs == "function" && this.updateElementAttributes();
    };
    if (n.type !== this.node.type)
      return !1;
    if (typeof this.options.update == "function") {
      const i = this.node, s = this.decorations, o = this.innerDecorations;
      return this.node = n, this.decorations = e, this.innerDecorations = t, this.options.update({
        oldNode: i,
        oldDecorations: s,
        newNode: n,
        newDecorations: e,
        oldInnerDecorations: o,
        innerDecorations: t,
        updateProps: () => r({ node: n, decorations: e, innerDecorations: t })
      });
    }
    return n === this.node && this.decorations === e && this.innerDecorations === t || (this.node = n, this.decorations = e, this.innerDecorations = t, r({ node: n, decorations: e, innerDecorations: t })), !0;
  }
  /**
   * Select the node.
   * Add the `selected` prop and the `ProseMirror-selectednode` class.
   */
  selectNode() {
    this.renderer.updateProps({
      selected: !0
    }), this.renderer.element.classList.add("ProseMirror-selectednode");
  }
  /**
   * Deselect the node.
   * Remove the `selected` prop and the `ProseMirror-selectednode` class.
   */
  deselectNode() {
    this.renderer.updateProps({
      selected: !1
    }), this.renderer.element.classList.remove("ProseMirror-selectednode");
  }
  /**
   * Destroy the React component instance.
   */
  destroy() {
    this.renderer.destroy(), this.editor.off("selectionUpdate", this.handleSelectionUpdate), this.contentDOMElement = null;
  }
  /**
   * Update the attributes of the top-level element that holds the React component.
   * Applying the attributes defined in the `attrs` option.
   */
  updateElementAttributes() {
    if (this.options.attrs) {
      let n = {};
      if (typeof this.options.attrs == "function") {
        const e = this.editor.extensionManager.attributes, t = U0(this.node, e);
        n = this.options.attrs({ node: this.node, HTMLAttributes: t });
      } else
        n = this.options.attrs;
      this.renderer.updateAttributes(n);
    }
  }
};
function slt(n, e) {
  return (t) => t.editor.contentComponent ? new ilt(n, t, e) : {};
}
function Fn(n, e) {
  if (n == null) return {};
  var t = {}, r = Object.keys(n), i, s;
  for (s = 0; s < r.length; s++)
    i = r[s], !(e.indexOf(i) >= 0) && (t[i] = n[i]);
  return t;
}
var olt = ["color"], z1 = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, olt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M4.18179 6.18181C4.35753 6.00608 4.64245 6.00608 4.81819 6.18181L7.49999 8.86362L10.1818 6.18181C10.3575 6.00608 10.6424 6.00608 10.8182 6.18181C10.9939 6.35755 10.9939 6.64247 10.8182 6.81821L7.81819 9.81821C7.73379 9.9026 7.61934 9.95001 7.49999 9.95001C7.38064 9.95001 7.26618 9.9026 7.18179 9.81821L4.18179 6.81821C4.00605 6.64247 4.00605 6.35755 4.18179 6.18181Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), alt = ["color"], llt = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, alt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M11.4669 3.72684C11.7558 3.91574 11.8369 4.30308 11.648 4.59198L7.39799 11.092C7.29783 11.2452 7.13556 11.3467 6.95402 11.3699C6.77247 11.3931 6.58989 11.3355 6.45446 11.2124L3.70446 8.71241C3.44905 8.48022 3.43023 8.08494 3.66242 7.82953C3.89461 7.57412 4.28989 7.55529 4.5453 7.78749L6.75292 9.79441L10.6018 3.90792C10.7907 3.61902 11.178 3.53795 11.4669 3.72684Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), clt = ["color"], ult = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, clt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M5 2V1H10V2H5ZM4.75 0C4.33579 0 4 0.335786 4 0.75V1H3.5C2.67157 1 2 1.67157 2 2.5V12.5C2 13.3284 2.67157 14 3.5 14H7V13H3.5C3.22386 13 3 12.7761 3 12.5V2.5C3 2.22386 3.22386 2 3.5 2H4V2.25C4 2.66421 4.33579 3 4.75 3H10.25C10.6642 3 11 2.66421 11 2.25V2H11.5C11.7761 2 12 2.22386 12 2.5V7H13V2.5C13 1.67157 12.3284 1 11.5 1H11V0.75C11 0.335786 10.6642 0 10.25 0H4.75ZM9 8.5C9 8.77614 8.77614 9 8.5 9C8.22386 9 8 8.77614 8 8.5C8 8.22386 8.22386 8 8.5 8C8.77614 8 9 8.22386 9 8.5ZM10.5 9C10.7761 9 11 8.77614 11 8.5C11 8.22386 10.7761 8 10.5 8C10.2239 8 10 8.22386 10 8.5C10 8.77614 10.2239 9 10.5 9ZM13 8.5C13 8.77614 12.7761 9 12.5 9C12.2239 9 12 8.77614 12 8.5C12 8.22386 12.2239 8 12.5 8C12.7761 8 13 8.22386 13 8.5ZM14.5 9C14.7761 9 15 8.77614 15 8.5C15 8.22386 14.7761 8 14.5 8C14.2239 8 14 8.22386 14 8.5C14 8.77614 14.2239 9 14.5 9ZM15 10.5C15 10.7761 14.7761 11 14.5 11C14.2239 11 14 10.7761 14 10.5C14 10.2239 14.2239 10 14.5 10C14.7761 10 15 10.2239 15 10.5ZM14.5 13C14.7761 13 15 12.7761 15 12.5C15 12.2239 14.7761 12 14.5 12C14.2239 12 14 12.2239 14 12.5C14 12.7761 14.2239 13 14.5 13ZM14.5 15C14.7761 15 15 14.7761 15 14.5C15 14.2239 14.7761 14 14.5 14C14.2239 14 14 14.2239 14 14.5C14 14.7761 14.2239 15 14.5 15ZM8.5 11C8.77614 11 9 10.7761 9 10.5C9 10.2239 8.77614 10 8.5 10C8.22386 10 8 10.2239 8 10.5C8 10.7761 8.22386 11 8.5 11ZM9 12.5C9 12.7761 8.77614 13 8.5 13C8.22386 13 8 12.7761 8 12.5C8 12.2239 8.22386 12 8.5 12C8.77614 12 9 12.2239 9 12.5ZM8.5 15C8.77614 15 9 14.7761 9 14.5C9 14.2239 8.77614 14 8.5 14C8.22386 14 8 14.2239 8 14.5C8 14.7761 8.22386 15 8.5 15ZM11 14.5C11 14.7761 10.7761 15 10.5 15C10.2239 15 10 14.7761 10 14.5C10 14.2239 10.2239 14 10.5 14C10.7761 14 11 14.2239 11 14.5ZM12.5 15C12.7761 15 13 14.7761 13 14.5C13 14.2239 12.7761 14 12.5 14C12.2239 14 12 14.2239 12 14.5C12 14.7761 12.2239 15 12.5 15Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), dlt = ["color"], Doe = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, dlt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M9.96424 2.68571C10.0668 2.42931 9.94209 2.13833 9.6857 2.03577C9.4293 1.93322 9.13832 2.05792 9.03576 2.31432L5.03576 12.3143C4.9332 12.5707 5.05791 12.8617 5.3143 12.9642C5.5707 13.0668 5.86168 12.9421 5.96424 12.6857L9.96424 2.68571ZM3.85355 5.14646C4.04882 5.34172 4.04882 5.6583 3.85355 5.85356L2.20711 7.50001L3.85355 9.14646C4.04882 9.34172 4.04882 9.6583 3.85355 9.85356C3.65829 10.0488 3.34171 10.0488 3.14645 9.85356L1.14645 7.85356C0.951184 7.6583 0.951184 7.34172 1.14645 7.14646L3.14645 5.14646C3.34171 4.9512 3.65829 4.9512 3.85355 5.14646ZM11.1464 5.14646C11.3417 4.9512 11.6583 4.9512 11.8536 5.14646L13.8536 7.14646C14.0488 7.34172 14.0488 7.6583 13.8536 7.85356L11.8536 9.85356C11.6583 10.0488 11.3417 10.0488 11.1464 9.85356C10.9512 9.6583 10.9512 9.34172 11.1464 9.14646L12.7929 7.50001L11.1464 5.85356C10.9512 5.6583 10.9512 5.34172 11.1464 5.14646Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), flt = ["color"], hlt = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, flt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M1 9.50006C1 10.3285 1.67157 11.0001 2.5 11.0001H4L4 10.0001H2.5C2.22386 10.0001 2 9.7762 2 9.50006L2 2.50006C2 2.22392 2.22386 2.00006 2.5 2.00006L9.5 2.00006C9.77614 2.00006 10 2.22392 10 2.50006V4.00002H5.5C4.67158 4.00002 4 4.67159 4 5.50002V12.5C4 13.3284 4.67158 14 5.5 14H12.5C13.3284 14 14 13.3284 14 12.5V5.50002C14 4.67159 13.3284 4.00002 12.5 4.00002H11V2.50006C11 1.67163 10.3284 1.00006 9.5 1.00006H2.5C1.67157 1.00006 1 1.67163 1 2.50006V9.50006ZM5 5.50002C5 5.22388 5.22386 5.00002 5.5 5.00002H12.5C12.7761 5.00002 13 5.22388 13 5.50002V12.5C13 12.7762 12.7761 13 12.5 13H5.5C5.22386 13 5 12.7762 5 12.5V5.50002Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), plt = ["color"], mlt = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, plt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M2 7.5C2 7.22386 2.22386 7 2.5 7H12.5C12.7761 7 13 7.22386 13 7.5C13 7.77614 12.7761 8 12.5 8H2.5C2.22386 8 2 7.77614 2 7.5Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), glt = ["color"], Noe = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, glt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M3.625 7.5C3.625 8.12132 3.12132 8.625 2.5 8.625C1.87868 8.625 1.375 8.12132 1.375 7.5C1.375 6.87868 1.87868 6.375 2.5 6.375C3.12132 6.375 3.625 6.87868 3.625 7.5ZM8.625 7.5C8.625 8.12132 8.12132 8.625 7.5 8.625C6.87868 8.625 6.375 8.12132 6.375 7.5C6.375 6.87868 6.87868 6.375 7.5 6.375C8.12132 6.375 8.625 6.87868 8.625 7.5ZM12.5 8.625C13.1213 8.625 13.625 8.12132 13.625 7.5C13.625 6.87868 13.1213 6.375 12.5 6.375C11.8787 6.375 11.375 6.87868 11.375 7.5C11.375 8.12132 11.8787 8.625 12.5 8.625Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), vlt = ["color"], ylt = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, vlt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M7.50005 1.04999C7.74858 1.04999 7.95005 1.25146 7.95005 1.49999V8.41359L10.1819 6.18179C10.3576 6.00605 10.6425 6.00605 10.8182 6.18179C10.994 6.35753 10.994 6.64245 10.8182 6.81819L7.81825 9.81819C7.64251 9.99392 7.35759 9.99392 7.18185 9.81819L4.18185 6.81819C4.00611 6.64245 4.00611 6.35753 4.18185 6.18179C4.35759 6.00605 4.64251 6.00605 4.81825 6.18179L7.05005 8.41359V1.49999C7.05005 1.25146 7.25152 1.04999 7.50005 1.04999ZM2.5 10C2.77614 10 3 10.2239 3 10.5V12C3 12.5539 3.44565 13 3.99635 13H11.0012C11.5529 13 12 12.5528 12 12V10.5C12 10.2239 12.2239 10 12.5 10C12.7761 10 13 10.2239 13 10.5V12C13 13.1041 12.1062 14 11.0012 14H3.99635C2.89019 14 2 13.103 2 12V10.5C2 10.2239 2.22386 10 2.5 10Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), blt = ["color"], wlt = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, blt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M3 2C2.44772 2 2 2.44772 2 3V12C2 12.5523 2.44772 13 3 13H12C12.5523 13 13 12.5523 13 12V8.5C13 8.22386 12.7761 8 12.5 8C12.2239 8 12 8.22386 12 8.5V12H3V3L6.5 3C6.77614 3 7 2.77614 7 2.5C7 2.22386 6.77614 2 6.5 2H3ZM12.8536 2.14645C12.9015 2.19439 12.9377 2.24964 12.9621 2.30861C12.9861 2.36669 12.9996 2.4303 13 2.497L13 2.5V2.50049V5.5C13 5.77614 12.7761 6 12.5 6C12.2239 6 12 5.77614 12 5.5V3.70711L6.85355 8.85355C6.65829 9.04882 6.34171 9.04882 6.14645 8.85355C5.95118 8.65829 5.95118 8.34171 6.14645 8.14645L11.2929 3H9.5C9.22386 3 9 2.77614 9 2.5C9 2.22386 9.22386 2 9.5 2H12.4999H12.5C12.5678 2 12.6324 2.01349 12.6914 2.03794C12.7504 2.06234 12.8056 2.09851 12.8536 2.14645Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), xlt = ["color"], Elt = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, xlt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M5.10505 12C4.70805 12 4.4236 11.912 4.25171 11.736C4.0839 11.5559 4 11.2715 4 10.8827V4.11733C4 3.72033 4.08595 3.43588 4.25784 3.26398C4.43383 3.08799 4.71623 3 5.10505 3C6.42741 3 8.25591 3 9.02852 3C10.1373 3 11.0539 3.98153 11.0539 5.1846C11.0539 6.08501 10.6037 6.81855 9.70327 7.23602C10.8657 7.44851 11.5176 8.62787 11.5176 9.48128C11.5176 10.5125 10.9902 12 9.27734 12C8.77742 12 6.42626 12 5.10505 12ZM8.37891 8.00341H5.8V10.631H8.37891C8.9 10.631 9.6296 10.1211 9.6296 9.29877C9.6296 8.47643 8.9 8.00341 8.37891 8.00341ZM5.8 4.36903V6.69577H8.17969C8.53906 6.69577 9.27734 6.35939 9.27734 5.50002C9.27734 4.64064 8.48047 4.36903 8.17969 4.36903H5.8Z",
    fill: r
  }));
}), Slt = ["color"], Clt = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, Slt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M5.67494 3.50017C5.67494 3.25164 5.87641 3.05017 6.12494 3.05017H10.6249C10.8735 3.05017 11.0749 3.25164 11.0749 3.50017C11.0749 3.7487 10.8735 3.95017 10.6249 3.95017H9.00587L7.2309 11.05H8.87493C9.12345 11.05 9.32493 11.2515 9.32493 11.5C9.32493 11.7486 9.12345 11.95 8.87493 11.95H4.37493C4.1264 11.95 3.92493 11.7486 3.92493 11.5C3.92493 11.2515 4.1264 11.05 4.37493 11.05H5.99397L7.76894 3.95017H6.12494C5.87641 3.95017 5.67494 3.7487 5.67494 3.50017Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), Tlt = ["color"], Alt = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, Tlt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M2.5 1H12.5C13.3284 1 14 1.67157 14 2.5V12.5C14 13.3284 13.3284 14 12.5 14H2.5C1.67157 14 1 13.3284 1 12.5V2.5C1 1.67157 1.67157 1 2.5 1ZM2.5 2C2.22386 2 2 2.22386 2 2.5V8.3636L3.6818 6.6818C3.76809 6.59551 3.88572 6.54797 4.00774 6.55007C4.12975 6.55216 4.24568 6.60372 4.32895 6.69293L7.87355 10.4901L10.6818 7.6818C10.8575 7.50607 11.1425 7.50607 11.3182 7.6818L13 9.3636V2.5C13 2.22386 12.7761 2 12.5 2H2.5ZM2 12.5V9.6364L3.98887 7.64753L7.5311 11.4421L8.94113 13H2.5C2.22386 13 2 12.7761 2 12.5ZM12.5 13H10.155L8.48336 11.153L11 8.6364L13 10.6364V12.5C13 12.7761 12.7761 13 12.5 13ZM6.64922 5.5C6.64922 5.03013 7.03013 4.64922 7.5 4.64922C7.96987 4.64922 8.35078 5.03013 8.35078 5.5C8.35078 5.96987 7.96987 6.35078 7.5 6.35078C7.03013 6.35078 6.64922 5.96987 6.64922 5.5ZM7.5 3.74922C6.53307 3.74922 5.74922 4.53307 5.74922 5.5C5.74922 6.46693 6.53307 7.25078 7.5 7.25078C8.46693 7.25078 9.25078 6.46693 9.25078 5.5C9.25078 4.53307 8.46693 3.74922 7.5 3.74922Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), Mlt = ["color"], klt = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, Mlt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M7.49991 0.876892C3.84222 0.876892 0.877075 3.84204 0.877075 7.49972C0.877075 11.1574 3.84222 14.1226 7.49991 14.1226C11.1576 14.1226 14.1227 11.1574 14.1227 7.49972C14.1227 3.84204 11.1576 0.876892 7.49991 0.876892ZM1.82707 7.49972C1.82707 4.36671 4.36689 1.82689 7.49991 1.82689C10.6329 1.82689 13.1727 4.36671 13.1727 7.49972C13.1727 10.6327 10.6329 13.1726 7.49991 13.1726C4.36689 13.1726 1.82707 10.6327 1.82707 7.49972ZM8.24992 4.49999C8.24992 4.9142 7.91413 5.24999 7.49992 5.24999C7.08571 5.24999 6.74992 4.9142 6.74992 4.49999C6.74992 4.08577 7.08571 3.74999 7.49992 3.74999C7.91413 3.74999 8.24992 4.08577 8.24992 4.49999ZM6.00003 5.99999H6.50003H7.50003C7.77618 5.99999 8.00003 6.22384 8.00003 6.49999V9.99999H8.50003H9.00003V11H8.50003H7.50003H6.50003H6.00003V9.99999H6.50003H7.00003V6.99999H6.50003H6.00003V5.99999Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), _lt = ["color"], Olt = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, _lt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M3.68979 2.75C3.89667 2.74979 4.08232 2.87701 4.15679 3.07003L7.36662 11.39C7.46602 11.6477 7.33774 11.9371 7.0801 12.0365C6.82247 12.1359 6.53304 12.0076 6.43365 11.75L5.3825 9.02537H2.01133L0.966992 11.749C0.868128 12.0068 0.578964 12.1357 0.321126 12.0369C0.0632878 11.938 -0.0655864 11.6488 0.0332774 11.391L3.22344 3.07099C3.29751 2.87782 3.4829 2.75021 3.68979 2.75ZM3.69174 4.64284L5.05458 8.17537H2.33724L3.69174 4.64284ZM10.8989 5.20703C9.25818 5.20703 8.00915 6.68569 8.00915 8.60972C8.00915 10.6337 9.35818 12.0124 10.8989 12.0124C11.7214 12.0124 12.5744 11.6692 13.1543 11.0219V11.53C13.1543 11.7785 13.3557 11.98 13.6043 11.98C13.8528 11.98 14.0543 11.7785 14.0543 11.53V5.72C14.0543 5.47147 13.8528 5.27 13.6043 5.27C13.3557 5.27 13.1543 5.47147 13.1543 5.72V6.22317C12.6054 5.60095 11.7924 5.20703 10.8989 5.20703ZM13.1543 9.79823V7.30195C12.7639 6.58101 11.9414 6.05757 11.0868 6.05757C10.1088 6.05757 9.03503 6.96581 9.03503 8.60955C9.03503 10.1533 10.0088 11.1615 11.0868 11.1615C11.9701 11.1615 12.7719 10.4952 13.1543 9.79823Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), Ilt = ["color"], Loe = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, Ilt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M8.51194 3.00541C9.18829 2.54594 10.0435 2.53694 10.6788 2.95419C10.8231 3.04893 10.9771 3.1993 11.389 3.61119C11.8009 4.02307 11.9513 4.17714 12.046 4.32141C12.4633 4.95675 12.4543 5.81192 11.9948 6.48827C11.8899 6.64264 11.7276 6.80811 11.3006 7.23511L10.6819 7.85383C10.4867 8.04909 10.4867 8.36567 10.6819 8.56093C10.8772 8.7562 11.1938 8.7562 11.389 8.56093L12.0077 7.94221L12.0507 7.89929C12.4203 7.52976 12.6568 7.2933 12.822 7.0502C13.4972 6.05623 13.5321 4.76252 12.8819 3.77248C12.7233 3.53102 12.4922 3.30001 12.1408 2.94871L12.0961 2.90408L12.0515 2.85942C11.7002 2.508 11.4692 2.27689 11.2277 2.11832C10.2377 1.46813 8.94398 1.50299 7.95001 2.17822C7.70691 2.34336 7.47044 2.57991 7.1009 2.94955L7.058 2.99247L6.43928 3.61119C6.24401 3.80645 6.24401 4.12303 6.43928 4.31829C6.63454 4.51355 6.95112 4.51355 7.14638 4.31829L7.7651 3.69957C8.1921 3.27257 8.35757 3.11027 8.51194 3.00541ZM4.31796 7.14672C4.51322 6.95146 4.51322 6.63487 4.31796 6.43961C4.12269 6.24435 3.80611 6.24435 3.61085 6.43961L2.99213 7.05833L2.94922 7.10124C2.57957 7.47077 2.34303 7.70724 2.17788 7.95035C1.50265 8.94432 1.4678 10.238 2.11799 11.2281C2.27656 11.4695 2.50766 11.7005 2.8591 12.0518L2.90374 12.0965L2.94837 12.1411C3.29967 12.4925 3.53068 12.7237 3.77214 12.8822C4.76219 13.5324 6.05589 13.4976 7.04986 12.8223C7.29296 12.6572 7.52943 12.4206 7.89896 12.051L7.89897 12.051L7.94188 12.0081L8.5606 11.3894C8.75586 11.1941 8.75586 10.8775 8.5606 10.6823C8.36533 10.487 8.04875 10.487 7.85349 10.6823L7.23477 11.301C6.80777 11.728 6.6423 11.8903 6.48794 11.9951C5.81158 12.4546 4.95642 12.4636 4.32107 12.0464C4.17681 11.9516 4.02274 11.8012 3.61085 11.3894C3.19896 10.9775 3.0486 10.8234 2.95385 10.6791C2.53661 10.0438 2.54561 9.18863 3.00507 8.51227C3.10993 8.35791 3.27224 8.19244 3.69924 7.76544L4.31796 7.14672ZM9.62172 6.08558C9.81698 5.89032 9.81698 5.57373 9.62172 5.37847C9.42646 5.18321 9.10988 5.18321 8.91461 5.37847L5.37908 8.91401C5.18382 9.10927 5.18382 9.42585 5.37908 9.62111C5.57434 9.81637 5.89092 9.81637 6.08619 9.62111L9.62172 6.08558Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), Rlt = ["color"], Plt = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, Rlt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M4.50021 0C4.77635 0 5.0002 0.223853 5.0002 0.49999V2.49995C5.0002 2.77609 4.77635 2.99994 4.50021 2.99994C4.22408 2.99994 4.00022 2.77609 4.00022 2.49995V0.49999C4.00022 0.223853 4.22408 0 4.50021 0ZM0.646451 0.64647C0.84171 0.451212 1.15829 0.451212 1.35354 0.64647L2.85351 2.14644C3.04877 2.3417 3.04877 2.65827 2.85351 2.85353C2.65826 3.04879 2.34168 3.04879 2.14642 2.85353L0.646452 1.35356C0.451193 1.1583 0.451193 0.841728 0.646451 0.64647ZM0.00030517 4.49991C0.00030517 4.22377 0.224158 3.99992 0.500295 3.99992H2.50025C2.77639 3.99992 3.00024 4.22377 3.00024 4.49991C3.00024 4.77605 2.77639 4.9999 2.50025 4.9999H0.500295C0.224158 4.9999 0.00030517 4.77605 0.00030517 4.49991ZM12.0001 10.4998C12.0001 10.2236 12.2239 9.9998 12.5001 9.9998H14.5C14.7761 9.9998 15 10.2236 15 10.4998C15 10.7759 14.7761 10.9998 14.5 10.9998H12.5001C12.2239 10.9998 12.0001 10.7759 12.0001 10.4998ZM10.5001 11.9998C10.7762 11.9998 11.0001 12.2236 11.0001 12.4997V14.4997C11.0001 14.7758 10.7762 14.9997 10.5001 14.9997C10.224 14.9997 10.0001 14.7758 10.0001 14.4997V12.4997C10.0001 12.2236 10.224 11.9998 10.5001 11.9998ZM12.1462 12.1462C12.3415 11.951 12.658 11.951 12.8533 12.1462L14.3533 13.6462C14.5485 13.8415 14.5485 14.158 14.3533 14.3533C14.158 14.5485 13.8414 14.5485 13.6462 14.3533L12.1462 12.8533C11.951 12.6581 11.951 12.3415 12.1462 12.1462ZM7.76478 3.69938C8.19177 3.27238 8.35724 3.11008 8.5116 3.00522C9.18794 2.54577 10.0431 2.53677 10.6784 2.95401C10.8227 3.04875 10.9767 3.19911 11.3886 3.61099C11.8005 4.02287 11.9509 4.17694 12.0456 4.3212C12.4628 4.95653 12.4539 5.81168 11.9944 6.48802C11.8895 6.64238 11.7272 6.80785 11.3002 7.23484L10.6815 7.85354C10.4863 8.0488 10.4863 8.36538 10.6815 8.56064C10.8768 8.75589 11.1934 8.75589 11.3886 8.56064L12.0073 7.94193L12.0502 7.89903C12.4199 7.5295 12.6564 7.29303 12.8216 7.04993C13.4968 6.05598 13.5316 4.7623 12.8815 3.77228C12.7229 3.53083 12.4918 3.29982 12.1404 2.94853L12.0957 2.9039L12.0511 2.85925C11.6998 2.50782 11.4688 2.27672 11.2273 2.11816C10.2373 1.46798 8.94364 1.50284 7.94968 2.17805C7.70659 2.34319 7.47012 2.57973 7.1006 2.94936L7.1006 2.94937L7.05769 2.99228L6.43898 3.61099C6.24372 3.80625 6.24372 4.12282 6.43898 4.31808C6.63424 4.51334 6.95081 4.51334 7.14607 4.31808L7.76478 3.69938ZM2.99191 7.05807L2.94899 7.10097C2.57935 7.4705 2.34282 7.70697 2.17767 7.95006C1.50246 8.94401 1.4676 10.2377 2.11778 11.2277C2.27634 11.4692 2.50744 11.7002 2.85886 12.0515L2.85888 12.0515L2.90352 12.0961L2.94815 12.1407L2.94815 12.1407L2.94817 12.1408C3.29945 12.4922 3.53045 12.7233 3.7719 12.8818C4.76193 13.532 6.0556 13.4972 7.04956 12.8219C7.29265 12.6568 7.52912 12.4203 7.89865 12.0506L7.94155 12.0077L8.56026 11.389C8.75552 11.1937 8.75552 10.8772 8.56026 10.6819C8.365 10.4867 8.04842 10.4867 7.85317 10.6819L7.23446 11.3006C6.80747 11.7276 6.642 11.8899 6.48764 11.9948C5.8113 12.4542 4.95615 12.4632 4.32082 12.046C4.17656 11.9512 4.02249 11.8009 3.61061 11.389C3.19873 10.9771 3.04837 10.8231 2.95363 10.6788C2.53639 10.0435 2.54539 9.18832 3.00484 8.51198C3.10971 8.35761 3.27201 8.19215 3.699 7.76516L4.3177 7.14645C4.51296 6.95119 4.51296 6.63462 4.3177 6.43936C4.12245 6.2441 3.80587 6.2441 3.61061 6.43936L2.99191 7.05807Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), Dlt = ["color"], $oe = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, Dlt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M1.5 5.25C1.91421 5.25 2.25 4.91421 2.25 4.5C2.25 4.08579 1.91421 3.75 1.5 3.75C1.08579 3.75 0.75 4.08579 0.75 4.5C0.75 4.91421 1.08579 5.25 1.5 5.25ZM4 4.5C4 4.22386 4.22386 4 4.5 4H13.5C13.7761 4 14 4.22386 14 4.5C14 4.77614 13.7761 5 13.5 5H4.5C4.22386 5 4 4.77614 4 4.5ZM4.5 7C4.22386 7 4 7.22386 4 7.5C4 7.77614 4.22386 8 4.5 8H13.5C13.7761 8 14 7.77614 14 7.5C14 7.22386 13.7761 7 13.5 7H4.5ZM4.5 10C4.22386 10 4 10.2239 4 10.5C4 10.7761 4.22386 11 4.5 11H13.5C13.7761 11 14 10.7761 14 10.5C14 10.2239 13.7761 10 13.5 10H4.5ZM2.25 7.5C2.25 7.91421 1.91421 8.25 1.5 8.25C1.08579 8.25 0.75 7.91421 0.75 7.5C0.75 7.08579 1.08579 6.75 1.5 6.75C1.91421 6.75 2.25 7.08579 2.25 7.5ZM1.5 11.25C1.91421 11.25 2.25 10.9142 2.25 10.5C2.25 10.0858 1.91421 9.75 1.5 9.75C1.08579 9.75 0.75 10.0858 0.75 10.5C0.75 10.9142 1.08579 11.25 1.5 11.25Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), Nlt = ["color"], Llt = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, Nlt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M8 2.75C8 2.47386 7.77614 2.25 7.5 2.25C7.22386 2.25 7 2.47386 7 2.75V7H2.75C2.47386 7 2.25 7.22386 2.25 7.5C2.25 7.77614 2.47386 8 2.75 8H7V12.25C7 12.5261 7.22386 12.75 7.5 12.75C7.77614 12.75 8 12.5261 8 12.25V8H12.25C12.5261 8 12.75 7.77614 12.75 7.5C12.75 7.22386 12.5261 7 12.25 7H8V2.75Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), $lt = ["color"], Flt = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, $lt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M9.42503 3.44136C10.0561 3.23654 10.7837 3.2402 11.3792 3.54623C12.7532 4.25224 13.3477 6.07191 12.7946 8C12.5465 8.8649 12.1102 9.70472 11.1861 10.5524C10.262 11.4 8.98034 11.9 8.38571 11.9C8.17269 11.9 8 11.7321 8 11.525C8 11.3179 8.17644 11.15 8.38571 11.15C9.06497 11.15 9.67189 10.7804 10.3906 10.236C10.9406 9.8193 11.3701 9.28633 11.608 8.82191C12.0628 7.93367 12.0782 6.68174 11.3433 6.34901C10.9904 6.73455 10.5295 6.95946 9.97725 6.95946C8.7773 6.95946 8.0701 5.99412 8.10051 5.12009C8.12957 4.28474 8.66032 3.68954 9.42503 3.44136ZM3.42503 3.44136C4.05614 3.23654 4.78366 3.2402 5.37923 3.54623C6.7532 4.25224 7.34766 6.07191 6.79462 8C6.54654 8.8649 6.11019 9.70472 5.1861 10.5524C4.26201 11.4 2.98034 11.9 2.38571 11.9C2.17269 11.9 2 11.7321 2 11.525C2 11.3179 2.17644 11.15 2.38571 11.15C3.06497 11.15 3.67189 10.7804 4.39058 10.236C4.94065 9.8193 5.37014 9.28633 5.60797 8.82191C6.06282 7.93367 6.07821 6.68174 5.3433 6.34901C4.99037 6.73455 4.52948 6.95946 3.97725 6.95946C2.7773 6.95946 2.0701 5.99412 2.10051 5.12009C2.12957 4.28474 2.66032 3.68954 3.42503 3.44136Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), Blt = ["color"], zlt = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, Blt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M11.5 3.04999C11.7485 3.04999 11.95 3.25146 11.95 3.49999V7.49999C11.95 7.74852 11.7485 7.94999 11.5 7.94999C11.2515 7.94999 11.05 7.74852 11.05 7.49999V4.58639L4.58638 11.05H7.49999C7.74852 11.05 7.94999 11.2515 7.94999 11.5C7.94999 11.7485 7.74852 11.95 7.49999 11.95L3.49999 11.95C3.38064 11.95 3.26618 11.9026 3.18179 11.8182C3.0974 11.7338 3.04999 11.6193 3.04999 11.5L3.04999 7.49999C3.04999 7.25146 3.25146 7.04999 3.49999 7.04999C3.74852 7.04999 3.94999 7.25146 3.94999 7.49999L3.94999 10.4136L10.4136 3.94999L7.49999 3.94999C7.25146 3.94999 7.04999 3.74852 7.04999 3.49999C7.04999 3.25146 7.25146 3.04999 7.49999 3.04999L11.5 3.04999Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), Hlt = ["color"], Ult = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, Hlt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M5.00003 3.25C5.00003 2.97386 4.77617 2.75 4.50003 2.75C4.22389 2.75 4.00003 2.97386 4.00003 3.25V7.10003H2.49998C2.27906 7.10003 2.09998 7.27912 2.09998 7.50003C2.09998 7.72094 2.27906 7.90003 2.49998 7.90003H4.00003V8.55C4.00003 10.483 5.56703 12.05 7.50003 12.05C9.43303 12.05 11 10.483 11 8.55V7.90003H12.5C12.7209 7.90003 12.9 7.72094 12.9 7.50003C12.9 7.27912 12.7209 7.10003 12.5 7.10003H11V3.25C11 2.97386 10.7762 2.75 10.5 2.75C10.2239 2.75 10 2.97386 10 3.25V7.10003H5.00003V3.25ZM5.00003 7.90003V8.55C5.00003 9.93071 6.11932 11.05 7.50003 11.05C8.88074 11.05 10 9.93071 10 8.55V7.90003H5.00003Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), Vlt = ["color"], jlt = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, Vlt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M13.3536 2.35355C13.5488 2.15829 13.5488 1.84171 13.3536 1.64645C13.1583 1.45118 12.8417 1.45118 12.6464 1.64645L11.9291 2.36383C11.9159 2.32246 11.897 2.28368 11.8732 2.24845C11.7923 2.12875 11.6554 2.05005 11.5001 2.05005H3.50005C3.29909 2.05005 3.1289 2.18178 3.07111 2.3636C3.05743 2.40665 3.05005 2.45249 3.05005 2.50007V4.50001C3.05005 4.74854 3.25152 4.95001 3.50005 4.95001C3.74858 4.95001 3.95005 4.74854 3.95005 4.50001V2.95005H6.95006V7.34284L1.64645 12.6464C1.45118 12.8417 1.45118 13.1583 1.64645 13.3536C1.84171 13.5488 2.15829 13.5488 2.35355 13.3536L6.95006 8.75705V12.0501H5.7544C5.50587 12.0501 5.3044 12.2515 5.3044 12.5001C5.3044 12.7486 5.50587 12.9501 5.7544 12.9501H9.2544C9.50293 12.9501 9.7044 12.7486 9.7044 12.5001C9.7044 12.2515 9.50293 12.0501 9.2544 12.0501H8.05006V7.65705L13.3536 2.35355ZM8.05006 6.24284L11.0501 3.24283V2.95005H8.05006V6.24284Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), Wlt = ["color"], Glt = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, Wlt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M5.5 1C5.22386 1 5 1.22386 5 1.5C5 1.77614 5.22386 2 5.5 2H9.5C9.77614 2 10 1.77614 10 1.5C10 1.22386 9.77614 1 9.5 1H5.5ZM3 3.5C3 3.22386 3.22386 3 3.5 3H5H10H11.5C11.7761 3 12 3.22386 12 3.5C12 3.77614 11.7761 4 11.5 4H11V12C11 12.5523 10.5523 13 10 13H5C4.44772 13 4 12.5523 4 12V4L3.5 4C3.22386 4 3 3.77614 3 3.5ZM5 4H10V12H5V4Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
}), Klt = ["color"], qlt = /* @__PURE__ */ tn(function(n, e) {
  var t = n.color, r = t === void 0 ? "currentColor" : t, i = Fn(n, Klt);
  return lt("svg", Object.assign({
    width: "15",
    height: "15",
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, i, {
    ref: e
  }), lt("path", {
    d: "M5.00001 2.75C5.00001 2.47386 4.77615 2.25 4.50001 2.25C4.22387 2.25 4.00001 2.47386 4.00001 2.75V8.05C4.00001 9.983 5.56702 11.55 7.50001 11.55C9.43301 11.55 11 9.983 11 8.05V2.75C11 2.47386 10.7762 2.25 10.5 2.25C10.2239 2.25 10 2.47386 10 2.75V8.05C10 9.43071 8.88072 10.55 7.50001 10.55C6.1193 10.55 5.00001 9.43071 5.00001 8.05V2.75ZM3.49998 13.1001C3.27906 13.1001 3.09998 13.2791 3.09998 13.5001C3.09998 13.721 3.27906 13.9001 3.49998 13.9001H11.5C11.7209 13.9001 11.9 13.721 11.9 13.5001C11.9 13.2791 11.7209 13.1001 11.5 13.1001H3.49998Z",
    fill: r,
    fillRule: "evenodd",
    clipRule: "evenodd"
  }));
});
const po = ({
  isActive: n,
  children: e,
  tooltip: t,
  className: r,
  tooltipOptions: i,
  ...s
}) => {
  const o = /* @__PURE__ */ T(Ate, { className: Q({ "bg-accent": n }, r), ...s, children: e });
  return t ? /* @__PURE__ */ ee(H3, { children: [
    /* @__PURE__ */ T(U3, { asChild: !0, children: o }),
    /* @__PURE__ */ T(R1, { ...i, children: /* @__PURE__ */ T("div", { className: "tw:flex tw:flex-col tw:items-center tw:text-center", children: t }) })
  ] }) : o;
};
po.displayName = "ToolbarButton";
const Ylt = () => typeof window < "u", RV = () => Ylt() && window.navigator.platform === "MacIntel", Xlt = {
  mod: RV() ? { symbol: "⌘", readable: "Command" } : { symbol: "Ctrl", readable: "Control" },
  alt: RV() ? { symbol: "⌥", readable: "Option" } : { symbol: "Alt", readable: "Alt" },
  shift: { symbol: "⇧", readable: "Shift" }
}, Foe = (n) => Xlt[n.toLowerCase()] || { symbol: n, readable: n }, PV = (n, e) => {
  switch (e) {
    case "json":
      return n.getJSON();
    case "html":
      return n.isEmpty ? "" : n.getHTML();
    default:
      return n.getText();
  }
}, u9 = (n, e = {
  requireHostname: !1
}) => {
  if (n.includes(`
`)) return !1;
  try {
    const t = new URL(n);
    return [
      "javascript:",
      "file:",
      "vbscript:",
      ...e.allowBase64 ? [] : ["data:"]
    ].includes(t.protocol) ? !1 : e.allowBase64 && t.protocol === "data:" ? /^data:image\/[a-z]+;base64,/.test(n) : t.hostname ? !0 : t.protocol !== "" && (t.pathname.startsWith("//") || t.pathname.startsWith("http")) && !e.requireHostname;
  } catch {
    return !1;
  }
}, Zlt = (n, e = {}) => {
  if (n)
    return e.allowBase64 && n.startsWith("data:image") ? u9(n, { requireHostname: !1, allowBase64: !0 }) ? n : void 0 : u9(n, {
      requireHostname: !1,
      allowBase64: e.allowBase64
    }) || /^(\/|#|mailto:|sms:|fax:|tel:)/.test(n) ? n : `https://${n}`;
}, Qlt = async (n) => {
  const t = await (await fetch(n)).blob();
  return new Promise((r, i) => {
    const s = new FileReader();
    s.onloadend = () => {
      typeof s.result == "string" ? r(s.result) : i(new Error("Failed to convert Blob to base64"));
    }, s.onerror = i, s.readAsDataURL(t);
  });
}, ob = () => Math.random().toString(36).slice(2, 11), d9 = (n) => new Promise((e, t) => {
  const r = new FileReader();
  r.onloadend = () => {
    typeof r.result == "string" ? e(r.result) : t(new Error("Failed to convert File to base64"));
  }, r.onerror = t, r.readAsDataURL(n);
}), DV = (n, e, t, r, i) => {
  const { isValidType: s, isValidSize: o } = Jlt(n, e);
  s && o ? r.push(t) : (s || i.push({ file: n, reason: "type" }), o || i.push({ file: n, reason: "size" }));
}, Jlt = (n, { allowedMimeTypes: e, maxFileSize: t }) => {
  const r = n instanceof File ? n.type : ect(n), i = n instanceof File ? n.size : atob(n.split(",")[1]).length, s = e.length === 0 || e.includes(r) || e.includes(`${r.split("/")[0]}/*`), o = !t || i <= t;
  return { isValidType: s, isValidSize: o };
}, ect = (n) => {
  const e = n.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);
  return e && e.length > 1 ? e[1] : "unknown";
}, tct = (n) => {
  if (n.startsWith("data:")) {
    const e = n.match(/^data:[^;]+;base64,(.+)$/);
    if (e && e[1])
      n = e[1];
    else
      return !1;
  }
  try {
    return btoa(atob(n)) === n;
  } catch {
    return !1;
  }
}, ab = (n, e) => {
  const t = [], r = [];
  return n.forEach((i) => {
    const s = "src" in i ? i.src : i;
    s instanceof File ? DV(s, e, i, t, r) : typeof s == "string" && (tct(s) ? e.allowBase64 ? DV(s, e, i, t, r) : r.push({ file: s, reason: "base64NotAllowed" }) : Zlt(s, { allowBase64: e.allowBase64 }) ? t.push(i) : r.push({ file: s, reason: "invalidBase64" }));
  }), [t, r];
}, yO = ({
  ref: n,
  className: e,
  keys: t,
  ...r
}) => {
  const i = t.map((o) => Foe(o)), s = i.map((o) => o.readable).join(" + ");
  return /* @__PURE__ */ T(
    "span",
    {
      "aria-label": s,
      className: Q("tw:inline-flex tw:items-center tw:gap-0.5", e),
      ...r,
      ref: n,
      children: i.map((o) => /* @__PURE__ */ T(
        "kbd",
        {
          className: Q(
            "tw:inline-block tw:min-w-2.5 tw:text-center tw:align-baseline tw:font-sans tw:text-xs tw:font-medium tw:text-[rgb(156,157,160)] tw:capitalize",
            e
          ),
          ...r,
          ref: n,
          children: o.symbol
        },
        o.symbol
      ))
    }
  );
};
yO.displayName = "ShortcutKey";
const nct = [
  {
    label: "Normal Text",
    element: "span",
    className: "grow",
    shortcuts: ["mod", "alt", "0"]
  },
  {
    label: "Heading 1",
    element: "h1",
    level: 1,
    className: "m-0 grow text-3xl font-extrabold",
    shortcuts: ["mod", "alt", "1"]
  },
  {
    label: "Heading 2",
    element: "h2",
    level: 2,
    className: "m-0 grow text-xl font-bold",
    shortcuts: ["mod", "alt", "2"]
  },
  {
    label: "Heading 3",
    element: "h3",
    level: 3,
    className: "m-0 grow text-lg font-semibold",
    shortcuts: ["mod", "alt", "3"]
  },
  {
    label: "Heading 4",
    element: "h4",
    level: 4,
    className: "m-0 grow text-base font-semibold",
    shortcuts: ["mod", "alt", "4"]
  },
  {
    label: "Heading 5",
    element: "h5",
    level: 5,
    className: "m-0 grow text-sm font-normal",
    shortcuts: ["mod", "alt", "5"]
  },
  {
    label: "Heading 6",
    element: "h6",
    level: 6,
    className: "m-0 grow text-sm font-normal",
    shortcuts: ["mod", "alt", "6"]
  }
], Boe = ({
  editor: n,
  activeLevels: e = [1, 2, 3, 4, 5, 6],
  size: t,
  variant: r
}) => {
  const i = A.useMemo(
    () => nct.filter(
      (a) => !a.level || e.includes(a.level)
    ),
    [e]
  ), s = A.useCallback(
    (a) => {
      a ? n.chain().focus().toggleHeading({ level: a }).run() : n.chain().focus().setParagraph().run();
    },
    [n]
  ), o = A.useCallback(
    ({ label: a, element: l, level: c, className: u, shortcuts: d }) => /* @__PURE__ */ ee(
      xo,
      {
        onClick: () => s(c),
        className: Q("tw:flex tw:flex-row tw:items-center tw:justify-between tw:gap-4", {
          "bg-accent": c ? n.isActive("heading", { level: c }) : n.isActive("paragraph")
        }),
        "aria-label": a,
        children: [
          /* @__PURE__ */ T(l, { className: u, children: a }),
          /* @__PURE__ */ T(yO, { keys: d })
        ]
      },
      a
    ),
    [n, s]
  );
  return /* @__PURE__ */ ee(Bh, { children: [
    /* @__PURE__ */ T(zh, { asChild: !0, children: /* @__PURE__ */ ee(
      po,
      {
        isActive: n.isActive("heading"),
        tooltip: "Text styles",
        "aria-label": "Text styles",
        pressed: n.isActive("heading"),
        disabled: n.isActive("codeBlock"),
        size: t,
        variant: r,
        className: "tw:gap-0",
        children: [
          /* @__PURE__ */ T(Olt, { className: "tw:size-5" }),
          /* @__PURE__ */ T(z1, { className: "tw:size-5" })
        ]
      }
    ) }),
    /* @__PURE__ */ T(dd, { align: "start", className: "tw:w-full", children: i.map(o) })
  ] });
};
Boe.displayName = "SectionOne";
const bO = ({
  editor: n,
  actions: e,
  activeActions: t = e.map((c) => c.value),
  mainActionCount: r = 0,
  dropdownIcon: i,
  dropdownTooltip: s = "More options",
  dropdownClassName: o = "w-12",
  size: a,
  variant: l
}) => {
  const { mainActions: c, dropdownActions: u } = A.useMemo(() => {
    const m = e.filter((g) => t.includes(g.value)).sort(
      (g, v) => t.indexOf(g.value) - t.indexOf(v.value)
    );
    return {
      mainActions: m.slice(0, r),
      dropdownActions: m.slice(r)
    };
  }, [e, t, r]), d = A.useCallback(
    (m) => /* @__PURE__ */ T(
      po,
      {
        onClick: () => m.action(n),
        disabled: !m.canExecute(n),
        isActive: m.isActive(n),
        tooltip: `${m.label} ${m.shortcuts.map((g) => Foe(g).symbol).join(" ")}`,
        "aria-label": m.label,
        size: a,
        variant: l,
        children: m.icon
      },
      m.label
    ),
    [n, a, l]
  ), f = A.useCallback(
    (m) => /* @__PURE__ */ ee(
      xo,
      {
        onClick: () => m.action(n),
        disabled: !m.canExecute(n),
        className: Q("tw:flex tw:flex-row tw:items-center tw:justify-between tw:gap-4", {
          "bg-accent": m.isActive(n)
        }),
        "aria-label": m.label,
        children: [
          /* @__PURE__ */ T("span", { className: "tw:grow", children: m.label }),
          /* @__PURE__ */ T(yO, { keys: m.shortcuts })
        ]
      },
      m.label
    ),
    [n]
  ), h = u.some(
    (m) => m.isActive(n)
  );
  return /* @__PURE__ */ ee(ft, { children: [
    c.map(d),
    u.length > 0 && /* @__PURE__ */ ee(Bh, { children: [
      /* @__PURE__ */ T(zh, { asChild: !0, children: /* @__PURE__ */ T(
        po,
        {
          isActive: h,
          tooltip: s,
          "aria-label": s,
          className: Q("tw:gap-0", o),
          size: a,
          variant: l,
          children: i || /* @__PURE__ */ T(z1, { className: "tw:size-5" })
        }
      ) }),
      /* @__PURE__ */ T(dd, { align: "start", className: "tw:w-full", children: u.map(f) })
    ] })
  ] });
}, NV = [
  {
    value: "bold",
    label: "Bold",
    icon: /* @__PURE__ */ T(Elt, { className: "tw:size-5" }),
    action: (n) => n.chain().focus().toggleBold().run(),
    isActive: (n) => n.isActive("bold"),
    canExecute: (n) => n.can().chain().focus().toggleBold().run() && !n.isActive("codeBlock"),
    shortcuts: ["mod", "B"]
  },
  {
    value: "italic",
    label: "Italic",
    icon: /* @__PURE__ */ T(Clt, { className: "tw:size-5" }),
    action: (n) => n.chain().focus().toggleItalic().run(),
    isActive: (n) => n.isActive("italic"),
    canExecute: (n) => n.can().chain().focus().toggleItalic().run() && !n.isActive("codeBlock"),
    shortcuts: ["mod", "I"]
  },
  {
    value: "underline",
    label: "Underline",
    icon: /* @__PURE__ */ T(qlt, { className: "tw:size-5" }),
    action: (n) => n.chain().focus().toggleUnderline().run(),
    isActive: (n) => n.isActive("underline"),
    canExecute: (n) => n.can().chain().focus().toggleUnderline().run() && !n.isActive("codeBlock"),
    shortcuts: ["mod", "U"]
  },
  {
    value: "strikethrough",
    label: "Strikethrough",
    icon: /* @__PURE__ */ T(Ult, { className: "tw:size-5" }),
    action: (n) => n.chain().focus().toggleStrike().run(),
    isActive: (n) => n.isActive("strike"),
    canExecute: (n) => n.can().chain().focus().toggleStrike().run() && !n.isActive("codeBlock"),
    shortcuts: ["mod", "shift", "S"]
  },
  {
    value: "code",
    label: "Code",
    icon: /* @__PURE__ */ T(Doe, { className: "tw:size-5" }),
    action: (n) => n.chain().focus().toggleCode().run(),
    isActive: (n) => n.isActive("code"),
    canExecute: (n) => n.can().chain().focus().toggleCode().run() && !n.isActive("codeBlock"),
    shortcuts: ["mod", "E"]
  },
  {
    value: "clearFormatting",
    label: "Clear formatting",
    icon: /* @__PURE__ */ T(jlt, { className: "tw:size-5" }),
    action: (n) => n.chain().focus().unsetAllMarks().run(),
    isActive: () => !1,
    canExecute: (n) => n.can().chain().focus().unsetAllMarks().run() && !n.isActive("codeBlock"),
    shortcuts: ["mod", "\\"]
  }
], zoe = ({
  editor: n,
  activeActions: e = NV.map((s) => s.value),
  mainActionCount: t = 2,
  size: r,
  variant: i
}) => /* @__PURE__ */ T(
  bO,
  {
    editor: n,
    actions: NV,
    activeActions: e,
    mainActionCount: t,
    dropdownIcon: /* @__PURE__ */ T(Noe, { className: "tw:size-5" }),
    dropdownTooltip: "More formatting",
    dropdownClassName: "w-8",
    size: r,
    variant: i
  }
);
zoe.displayName = "SectionTwo";
const rct = [
  {
    label: "Palette 1",
    inverse: "hsl(var(--background))",
    colors: [
      { cssVar: "hsl(var(--foreground))", label: "Default" },
      { cssVar: "var(--mt-accent-bold-blue)", label: "Bold blue" },
      { cssVar: "var(--mt-accent-bold-teal)", label: "Bold teal" },
      { cssVar: "var(--mt-accent-bold-green)", label: "Bold green" },
      { cssVar: "var(--mt-accent-bold-orange)", label: "Bold orange" },
      { cssVar: "var(--mt-accent-bold-red)", label: "Bold red" },
      { cssVar: "var(--mt-accent-bold-purple)", label: "Bold purple" }
    ]
  },
  {
    label: "Palette 2",
    inverse: "hsl(var(--background))",
    colors: [
      { cssVar: "var(--mt-accent-gray)", label: "Gray" },
      { cssVar: "var(--mt-accent-blue)", label: "Blue" },
      { cssVar: "var(--mt-accent-teal)", label: "Teal" },
      { cssVar: "var(--mt-accent-green)", label: "Green" },
      { cssVar: "var(--mt-accent-orange)", label: "Orange" },
      { cssVar: "var(--mt-accent-red)", label: "Red" },
      { cssVar: "var(--mt-accent-purple)", label: "Purple" }
    ]
  },
  {
    label: "Palette 3",
    inverse: "hsl(var(--foreground))",
    colors: [
      {
        cssVar: "hsl(var(--background))",
        label: "White",
        darkLabel: "Black"
      },
      { cssVar: "var(--mt-accent-blue-subtler)", label: "Blue subtle" },
      { cssVar: "var(--mt-accent-teal-subtler)", label: "Teal subtle" },
      { cssVar: "var(--mt-accent-green-subtler)", label: "Green subtle" },
      {
        cssVar: "var(--mt-accent-yellow-subtler)",
        label: "Yellow subtle"
      },
      { cssVar: "var(--mt-accent-red-subtler)", label: "Red subtle" },
      {
        cssVar: "var(--mt-accent-purple-subtler)",
        label: "Purple subtle"
      }
    ]
  }
], Hoe = A.memo(({ color: n, isSelected: e, inverse: t, onClick: r }) => {
  const { isDarkMode: i } = V3(), s = i && n.darkLabel ? n.darkLabel : n.label;
  return /* @__PURE__ */ ee(H3, { children: [
    /* @__PURE__ */ T(U3, { asChild: !0, children: /* @__PURE__ */ T(
      _te,
      {
        tabIndex: 0,
        className: "tw:relative tw:size-7 tw:rounded-md tw:p-0",
        value: n.cssVar,
        "aria-label": s,
        style: { backgroundColor: n.cssVar },
        onClick: (o) => {
          o.preventDefault(), r(n.cssVar);
        },
        children: e && /* @__PURE__ */ T(
          llt,
          {
            className: "tw:absolute tw:inset-0 tw:m-auto tw:size-6",
            style: { color: t }
          }
        )
      }
    ) }),
    /* @__PURE__ */ T(R1, { side: "bottom", children: /* @__PURE__ */ T("p", { children: s }) })
  ] });
});
Hoe.displayName = "MemoizedColorButton";
const Uoe = A.memo(({ palette: n, selectedColor: e, inverse: t, onColorChange: r }) => /* @__PURE__ */ T(
  kte,
  {
    type: "single",
    value: e,
    onValueChange: (i) => {
      i && r(i);
    },
    className: "tw:gap-1.5",
    children: n.colors.map((i, s) => /* @__PURE__ */ T(
      Hoe,
      {
        inverse: t,
        color: i,
        isSelected: e === i.cssVar,
        onClick: r
      },
      s
    ))
  }
));
Uoe.displayName = "MemoizedColorPicker";
const Voe = ({
  editor: n,
  size: e,
  variant: t
}) => {
  const r = n.getAttributes("textStyle")?.color || "hsl(var(--foreground))", [i, s] = A.useState(r), o = A.useCallback(
    (a) => {
      if (s(a), n.state.storedMarks) {
        const l = n.schema.marks.textStyle;
        l && n.view.dispatch(
          n.state.tr.removeStoredMark(l)
        );
      }
      setTimeout(() => {
        n.chain().setColor(a).run();
      }, 0);
    },
    [n]
  );
  return A.useEffect(() => {
    s(r);
  }, [r]), /* @__PURE__ */ ee(Dh, { children: [
    /* @__PURE__ */ T(Nh, { asChild: !0, children: /* @__PURE__ */ ee(
      po,
      {
        tooltip: "Text color",
        "aria-label": "Text color",
        className: "tw:gap-0",
        size: e,
        variant: t,
        children: [
          /* @__PURE__ */ ee(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round",
              className: "tw:size-5",
              style: { color: i },
              children: [
                /* @__PURE__ */ T("path", { d: "M4 20h16" }),
                /* @__PURE__ */ T("path", { d: "m6 16 6-12 6 12" }),
                /* @__PURE__ */ T("path", { d: "M8 12h8" })
              ]
            }
          ),
          /* @__PURE__ */ T(z1, { className: "tw:size-5" })
        ]
      }
    ) }),
    /* @__PURE__ */ T(ld, { align: "start", className: "tw:w-full", children: /* @__PURE__ */ T("div", { className: "tw:space-y-1.5", children: rct.map((a, l) => /* @__PURE__ */ T(
      Uoe,
      {
        palette: a,
        inverse: a.inverse,
        selectedColor: i,
        onColorChange: o
      },
      l
    )) }) })
  ] });
};
Voe.displayName = "SectionThree";
const LV = [
  {
    value: "orderedList",
    label: "Numbered list",
    icon: /* @__PURE__ */ T(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        height: "20px",
        viewBox: "0 -960 960 960",
        width: "20px",
        fill: "currentColor",
        children: /* @__PURE__ */ T("path", { d: "M144-144v-48h96v-24h-48v-48h48v-24h-96v-48h120q10.2 0 17.1 6.9 6.9 6.9 6.9 17.1v48q0 10.2-6.9 17.1-6.9 6.9-17.1 6.9 10.2 0 17.1 6.9 6.9 6.9 6.9 17.1v48q0 10.2-6.9 17.1-6.9 6.9-17.1 6.9H144Zm0-240v-96q0-10.2 6.9-17.1 6.9-6.9 17.1-6.9h72v-24h-96v-48h120q10.2 0 17.1 6.9 6.9 6.9 6.9 17.1v72q0 10.2-6.9 17.1-6.9 6.9-17.1 6.9h-72v24h96v48H144Zm48-240v-144h-48v-48h96v192h-48Zm168 384v-72h456v72H360Zm0-204v-72h456v72H360Zm0-204v-72h456v72H360Z" })
      }
    ),
    isActive: (n) => n.isActive("orderedList"),
    action: (n) => n.chain().focus().toggleOrderedList().run(),
    canExecute: (n) => n.can().chain().focus().toggleOrderedList().run(),
    shortcuts: ["mod", "shift", "7"]
  },
  {
    value: "bulletList",
    label: "Bullet list",
    icon: /* @__PURE__ */ T($oe, { className: "tw:size-5" }),
    isActive: (n) => n.isActive("bulletList"),
    action: (n) => n.chain().focus().toggleBulletList().run(),
    canExecute: (n) => n.can().chain().focus().toggleBulletList().run(),
    shortcuts: ["mod", "shift", "8"]
  }
], joe = ({
  editor: n,
  activeActions: e = LV.map((s) => s.value),
  mainActionCount: t = 0,
  size: r,
  variant: i
}) => /* @__PURE__ */ T(
  bO,
  {
    editor: n,
    actions: LV,
    activeActions: e,
    mainActionCount: t,
    dropdownIcon: /* @__PURE__ */ ee(ft, { children: [
      /* @__PURE__ */ T($oe, { className: "tw:size-5" }),
      /* @__PURE__ */ T(z1, { className: "tw:size-5" })
    ] }),
    dropdownTooltip: "Lists",
    size: r,
    variant: i
  }
);
joe.displayName = "SectionFour";
const wO = ({
  onSave: n,
  defaultIsNewTab: e,
  defaultUrl: t,
  defaultText: r,
  className: i
}) => {
  const s = A.useRef(null), [o, a] = A.useState(t || ""), [l, c] = A.useState(r || ""), [u, d] = A.useState(e || !1), f = A.useCallback(
    (h) => {
      h.preventDefault(), s.current && (Array.from(
        s.current.querySelectorAll("input")
      ).every((g) => g.checkValidity()) ? n(o, l, u) : s.current.querySelectorAll("input").forEach((g) => {
        g.checkValidity() || g.reportValidity();
      }));
    },
    [n, o, l, u]
  );
  return /* @__PURE__ */ T("div", { ref: s, children: /* @__PURE__ */ ee("div", { className: Q("tw:space-y-4", i), children: [
    /* @__PURE__ */ ee("div", { className: "tw:space-y-1", children: [
      /* @__PURE__ */ T(bo, { children: "URL" }),
      /* @__PURE__ */ T(
        Ui,
        {
          type: "url",
          required: !0,
          placeholder: "Enter URL",
          value: o,
          onChange: (h) => a(h.target.value)
        }
      )
    ] }),
    /* @__PURE__ */ ee("div", { className: "tw:space-y-1", children: [
      /* @__PURE__ */ T(bo, { children: "Display Text (optional)" }),
      /* @__PURE__ */ T(
        Ui,
        {
          type: "text",
          placeholder: "Enter display text",
          value: l,
          onChange: (h) => c(h.target.value)
        }
      )
    ] }),
    /* @__PURE__ */ ee("div", { className: "tw:flex tw:items-center tw:space-x-2", children: [
      /* @__PURE__ */ T(bo, { children: "Open in New Tab" }),
      /* @__PURE__ */ T(M0, { checked: u, onCheckedChange: d })
    ] }),
    /* @__PURE__ */ T("div", { className: "tw:flex tw:justify-end tw:space-x-2", children: /* @__PURE__ */ T(Nt, { type: "button", onClick: f, children: "Save" }) })
  ] }) });
};
wO.displayName = "LinkEditBlock";
const ict = ({ editor: n, size: e, variant: t }) => {
  const [r, i] = A.useState(!1), { from: s, to: o } = n.state.selection, a = n.state.doc.textBetween(s, o, " "), l = A.useCallback(
    (c, u, d) => {
      n.chain().focus().extendMarkRange("link").insertContent({
        type: "text",
        text: u || c,
        marks: [
          {
            type: "link",
            attrs: {
              href: c,
              target: d ? "_blank" : ""
            }
          }
        ]
      }).setLink({ href: c }).run(), n.commands.enter();
    },
    [n]
  );
  return /* @__PURE__ */ ee(Dh, { open: r, onOpenChange: i, children: [
    /* @__PURE__ */ T(Nh, { asChild: !0, children: /* @__PURE__ */ T(
      po,
      {
        isActive: n.isActive("link"),
        tooltip: "Link",
        "aria-label": "Insert link",
        disabled: n.isActive("codeBlock"),
        size: e,
        variant: t,
        children: /* @__PURE__ */ T(Loe, { className: "tw:size-5" })
      }
    ) }),
    /* @__PURE__ */ T(ld, { align: "end", side: "bottom", children: /* @__PURE__ */ T(wO, { onSave: l, defaultText: a }) })
  ] });
}, sct = ({
  editor: n,
  close: e
}) => {
  const t = A.useRef(null), [r, i] = A.useState(""), s = A.useCallback(() => {
    t.current?.click();
  }, []), o = A.useCallback(
    async (l) => {
      const c = l.target.files;
      if (!c?.length) return;
      await (async () => {
        const d = [], f = Array.from(c);
        for (const h of f)
          d.push({ src: h });
        n.commands.setImages(d);
      })(), e();
    },
    [n, e]
  ), a = A.useCallback(
    (l) => {
      l.preventDefault(), l.stopPropagation(), r && (n.commands.setImages([{ src: r }]), e());
    },
    [n, r, e]
  );
  return /* @__PURE__ */ ee("form", { onSubmit: a, className: "tw:space-y-6", children: [
    /* @__PURE__ */ ee("div", { className: "tw:space-y-1", children: [
      /* @__PURE__ */ T(bo, { htmlFor: "image-link", children: "Attach an image link" }),
      /* @__PURE__ */ ee("div", { className: "tw:flex", children: [
        /* @__PURE__ */ T(
          Ui,
          {
            id: "image-link",
            type: "url",
            required: !0,
            placeholder: "https://example.com",
            value: r,
            className: "tw:grow",
            onChange: (l) => i(l.target.value)
          }
        ),
        /* @__PURE__ */ T(Nt, { type: "submit", className: "tw:ml-2", children: "Submit" })
      ] })
    ] }),
    /* @__PURE__ */ T(Nt, { type: "button", className: "tw:w-full", onClick: s, children: "Upload from your computer" }),
    /* @__PURE__ */ T(
      "input",
      {
        type: "file",
        accept: "image/*",
        ref: t,
        multiple: !0,
        className: "tw:hidden",
        onChange: o
      }
    )
  ] });
}, oct = ({ editor: n, size: e, variant: t }) => {
  const [r, i] = wt(!1);
  return /* @__PURE__ */ ee(f3, { open: r, onOpenChange: i, children: [
    /* @__PURE__ */ T(NZ, { asChild: !0, children: /* @__PURE__ */ T(
      po,
      {
        isActive: n.isActive("image"),
        tooltip: "Image",
        "aria-label": "Image",
        size: e,
        variant: t,
        children: /* @__PURE__ */ T(Alt, { className: "tw:size-5" })
      }
    ) }),
    /* @__PURE__ */ ee(h3, { className: "tw:sm:max-w-lg", children: [
      /* @__PURE__ */ ee(ck, { children: [
        /* @__PURE__ */ T(p3, { children: "Select image" }),
        /* @__PURE__ */ T(uk, { className: "tw:sr-only", children: "Upload an image from your computer" })
      ] }),
      /* @__PURE__ */ T(sct, { editor: n, close: () => i(!1) })
    ] })
  ] });
}, $V = [
  {
    value: "codeBlock",
    label: "Code block",
    icon: /* @__PURE__ */ T(Doe, { className: "tw:size-5" }),
    action: (n) => n.chain().focus().toggleCodeBlock().run(),
    isActive: (n) => n.isActive("codeBlock"),
    canExecute: (n) => n.can().chain().focus().toggleCodeBlock().run(),
    shortcuts: ["mod", "alt", "C"]
  },
  {
    value: "blockquote",
    label: "Blockquote",
    icon: /* @__PURE__ */ T(Flt, { className: "tw:size-5" }),
    action: (n) => n.chain().focus().toggleBlockquote().run(),
    isActive: (n) => n.isActive("blockquote"),
    canExecute: (n) => n.can().chain().focus().toggleBlockquote().run(),
    shortcuts: ["mod", "shift", "B"]
  },
  {
    value: "horizontalRule",
    label: "Divider",
    icon: /* @__PURE__ */ T(mlt, { className: "tw:size-5" }),
    action: (n) => n.chain().focus().setHorizontalRule().run(),
    isActive: () => !1,
    canExecute: (n) => n.can().chain().focus().setHorizontalRule().run(),
    shortcuts: ["mod", "alt", "-"]
  }
], Woe = ({
  editor: n,
  activeActions: e = $V.map((s) => s.value),
  mainActionCount: t = 0,
  size: r,
  variant: i
}) => /* @__PURE__ */ ee(ft, { children: [
  /* @__PURE__ */ T(ict, { editor: n, size: r, variant: i }),
  /* @__PURE__ */ T(oct, { editor: n, size: r, variant: i }),
  /* @__PURE__ */ T(
    bO,
    {
      editor: n,
      actions: $V,
      activeActions: e,
      mainActionCount: t,
      dropdownIcon: /* @__PURE__ */ ee(ft, { children: [
        /* @__PURE__ */ T(Llt, { className: "tw:size-5" }),
        /* @__PURE__ */ T(z1, { className: "tw:size-5" })
      ] }),
      dropdownTooltip: "Insert elements",
      size: r,
      variant: i
    }
  )
] });
Woe.displayName = "SectionFive";
var f9, h9;
if (typeof WeakMap < "u") {
  let n = /* @__PURE__ */ new WeakMap();
  f9 = (e) => n.get(e), h9 = (e, t) => (n.set(e, t), t);
} else {
  const n = [];
  let t = 0;
  f9 = (r) => {
    for (let i = 0; i < n.length; i += 2)
      if (n[i] == r) return n[i + 1];
  }, h9 = (r, i) => (t == 10 && (t = 0), n[t++] = r, n[t++] = i);
}
var ja = class {
  constructor(n, e, t, r) {
    this.width = n, this.height = e, this.map = t, this.problems = r;
  }
  // Find the dimensions of the cell at the given position.
  findCell(n) {
    for (let e = 0; e < this.map.length; e++) {
      const t = this.map[e];
      if (t != n) continue;
      const r = e % this.width, i = e / this.width | 0;
      let s = r + 1, o = i + 1;
      for (let a = 1; s < this.width && this.map[e + a] == t; a++)
        s++;
      for (let a = 1; o < this.height && this.map[e + this.width * a] == t; a++)
        o++;
      return { left: r, top: i, right: s, bottom: o };
    }
    throw new RangeError(`No cell with offset ${n} found`);
  }
  // Find the left side of the cell at the given position.
  colCount(n) {
    for (let e = 0; e < this.map.length; e++)
      if (this.map[e] == n)
        return e % this.width;
    throw new RangeError(`No cell with offset ${n} found`);
  }
  // Find the next cell in the given direction, starting from the cell
  // at `pos`, if any.
  nextCell(n, e, t) {
    const { left: r, right: i, top: s, bottom: o } = this.findCell(n);
    return e == "horiz" ? (t < 0 ? r == 0 : i == this.width) ? null : this.map[s * this.width + (t < 0 ? r - 1 : i)] : (t < 0 ? s == 0 : o == this.height) ? null : this.map[r + this.width * (t < 0 ? s - 1 : o)];
  }
  // Get the rectangle spanning the two given cells.
  rectBetween(n, e) {
    const {
      left: t,
      right: r,
      top: i,
      bottom: s
    } = this.findCell(n), {
      left: o,
      right: a,
      top: l,
      bottom: c
    } = this.findCell(e);
    return {
      left: Math.min(t, o),
      top: Math.min(i, l),
      right: Math.max(r, a),
      bottom: Math.max(s, c)
    };
  }
  // Return the position of all cells that have the top left corner in
  // the given rectangle.
  cellsInRect(n) {
    const e = [], t = {};
    for (let r = n.top; r < n.bottom; r++)
      for (let i = n.left; i < n.right; i++) {
        const s = r * this.width + i, o = this.map[s];
        t[o] || (t[o] = !0, !(i == n.left && i && this.map[s - 1] == o || r == n.top && r && this.map[s - this.width] == o) && e.push(o));
      }
    return e;
  }
  // Return the position at which the cell at the given row and column
  // starts, or would start, if a cell started there.
  positionAt(n, e, t) {
    for (let r = 0, i = 0; ; r++) {
      const s = i + t.child(r).nodeSize;
      if (r == n) {
        let o = e + n * this.width;
        const a = (n + 1) * this.width;
        for (; o < a && this.map[o] < i; ) o++;
        return o == a ? s - 1 : this.map[o];
      }
      i = s;
    }
  }
  // Find the table map for the given table node.
  static get(n) {
    return f9(n) || h9(n, act(n));
  }
};
function act(n) {
  if (n.type.spec.tableRole != "table")
    throw new RangeError("Not a table node: " + n.type.name);
  const e = lct(n), t = n.childCount, r = [];
  let i = 0, s = null;
  const o = [];
  for (let c = 0, u = e * t; c < u; c++) r[c] = 0;
  for (let c = 0, u = 0; c < t; c++) {
    const d = n.child(c);
    u++;
    for (let m = 0; ; m++) {
      for (; i < r.length && r[i] != 0; ) i++;
      if (m == d.childCount) break;
      const g = d.child(m), { colspan: v, rowspan: y, colwidth: b } = g.attrs;
      for (let x = 0; x < y; x++) {
        if (x + c >= t) {
          (s || (s = [])).push({
            type: "overlong_rowspan",
            pos: u,
            n: y - x
          });
          break;
        }
        const E = i + x * e;
        for (let w = 0; w < v; w++) {
          r[E + w] == 0 ? r[E + w] = u : (s || (s = [])).push({
            type: "collision",
            row: c,
            pos: u,
            n: v - w
          });
          const C = b && b[w];
          if (C) {
            const S = (E + w) % e * 2, M = o[S];
            M == null || M != C && o[S + 1] == 1 ? (o[S] = C, o[S + 1] = 1) : M == C && o[S + 1]++;
          }
        }
      }
      i += v, u += g.nodeSize;
    }
    const f = (c + 1) * e;
    let h = 0;
    for (; i < f; ) r[i++] == 0 && h++;
    h && (s || (s = [])).push({ type: "missing", row: c, n: h }), u++;
  }
  (e === 0 || t === 0) && (s || (s = [])).push({ type: "zero_sized" });
  const a = new ja(e, t, r, s);
  let l = !1;
  for (let c = 0; !l && c < o.length; c += 2)
    o[c] != null && o[c + 1] < t && (l = !0);
  return l && cct(a, o, n), a;
}
function lct(n) {
  let e = -1, t = !1;
  for (let r = 0; r < n.childCount; r++) {
    const i = n.child(r);
    let s = 0;
    if (t)
      for (let o = 0; o < r; o++) {
        const a = n.child(o);
        for (let l = 0; l < a.childCount; l++) {
          const c = a.child(l);
          o + c.attrs.rowspan > r && (s += c.attrs.colspan);
        }
      }
    for (let o = 0; o < i.childCount; o++) {
      const a = i.child(o);
      s += a.attrs.colspan, a.attrs.rowspan > 1 && (t = !0);
    }
    e == -1 ? e = s : e != s && (e = Math.max(e, s));
  }
  return e;
}
function cct(n, e, t) {
  n.problems || (n.problems = []);
  const r = {};
  for (let i = 0; i < n.map.length; i++) {
    const s = n.map[i];
    if (r[s]) continue;
    r[s] = !0;
    const o = t.nodeAt(s);
    if (!o)
      throw new RangeError(`No cell with offset ${s} found`);
    let a = null;
    const l = o.attrs;
    for (let c = 0; c < l.colspan; c++) {
      const u = (i + c) % n.width, d = e[u * 2];
      d != null && (!l.colwidth || l.colwidth[c] != d) && ((a || (a = uct(l)))[c] = d);
    }
    a && n.problems.unshift({
      type: "colwidth mismatch",
      pos: s,
      colwidth: a
    });
  }
}
function uct(n) {
  if (n.colwidth) return n.colwidth.slice();
  const e = [];
  for (let t = 0; t < n.colspan; t++) e.push(0);
  return e;
}
function xO(n) {
  let e = n.cached.tableNodeTypes;
  if (!e) {
    e = n.cached.tableNodeTypes = {};
    for (const t in n.nodes) {
      const r = n.nodes[t], i = r.spec.tableRole;
      i && (e[i] = r);
    }
  }
  return e;
}
new _n("selectingCells");
function dct(n) {
  for (let e = n.depth - 1; e > 0; e--)
    if (n.node(e).type.spec.tableRole == "row")
      return n.node(0).resolve(n.before(e + 1));
  return null;
}
function Goe(n) {
  const e = n.selection.$head;
  for (let t = e.depth; t > 0; t--)
    if (e.node(t).type.spec.tableRole == "row") return !0;
  return !1;
}
function fct(n) {
  const e = n.selection;
  if ("$anchorCell" in e && e.$anchorCell)
    return e.$anchorCell.pos > e.$headCell.pos ? e.$anchorCell : e.$headCell;
  if ("node" in e && e.node && e.node.type.spec.tableRole == "cell")
    return e.$anchor;
  const t = dct(e.$head) || hct(e.$head);
  if (t)
    return t;
  throw new RangeError(`No cell found around position ${e.head}`);
}
function hct(n) {
  for (let e = n.nodeAfter, t = n.pos; e; e = e.firstChild, t++) {
    const r = e.type.spec.tableRole;
    if (r == "cell" || r == "header_cell") return n.doc.resolve(t);
  }
  for (let e = n.nodeBefore, t = n.pos; e; e = e.lastChild, t--) {
    const r = e.type.spec.tableRole;
    if (r == "cell" || r == "header_cell")
      return n.doc.resolve(t - e.nodeSize);
  }
}
function FV(n) {
  return n.parent.type.spec.tableRole == "row" && !!n.nodeAfter;
}
function Koe(n, e) {
  return n.depth == e.depth && n.pos >= e.start(-1) && n.pos <= e.end(-1);
}
function qoe(n, e, t) {
  const r = n.node(-1), i = ja.get(r), s = n.start(-1), o = i.nextCell(n.pos - s, e, t);
  return o == null ? null : n.node(0).resolve(s + o);
}
function BV(n, e, t = 1) {
  const r = { ...n, colspan: n.colspan - t };
  return r.colwidth && (r.colwidth = r.colwidth.slice(), r.colwidth.splice(e, t), r.colwidth.some((i) => i > 0) || (r.colwidth = null)), r;
}
var pa = class Fa extends pt {
  // A table selection is identified by its anchor and head cells. The
  // positions given to this constructor should point _before_ two
  // cells in the same table. They may be the same, to select a single
  // cell.
  constructor(e, t = e) {
    const r = e.node(-1), i = ja.get(r), s = e.start(-1), o = i.rectBetween(
      e.pos - s,
      t.pos - s
    ), a = e.node(0), l = i.cellsInRect(o).filter((u) => u != t.pos - s);
    l.unshift(t.pos - s);
    const c = l.map((u) => {
      const d = r.nodeAt(u);
      if (!d)
        throw RangeError(`No cell with offset ${u} found`);
      const f = s + u + 1;
      return new Jie(
        a.resolve(f),
        a.resolve(f + d.content.size)
      );
    });
    super(c[0].$from, c[0].$to, c), this.$anchorCell = e, this.$headCell = t;
  }
  map(e, t) {
    const r = e.resolve(t.map(this.$anchorCell.pos)), i = e.resolve(t.map(this.$headCell.pos));
    if (FV(r) && FV(i) && Koe(r, i)) {
      const s = this.$anchorCell.node(-1) != r.node(-1);
      return s && this.isRowSelection() ? Fa.rowSelection(r, i) : s && this.isColSelection() ? Fa.colSelection(r, i) : new Fa(r, i);
    }
    return vt.between(r, i);
  }
  // Returns a rectangular slice of table rows containing the selected
  // cells.
  content() {
    const e = this.$anchorCell.node(-1), t = ja.get(e), r = this.$anchorCell.start(-1), i = t.rectBetween(
      this.$anchorCell.pos - r,
      this.$headCell.pos - r
    ), s = {}, o = [];
    for (let l = i.top; l < i.bottom; l++) {
      const c = [];
      for (let u = l * t.width + i.left, d = i.left; d < i.right; d++, u++) {
        const f = t.map[u];
        if (s[f]) continue;
        s[f] = !0;
        const h = t.findCell(f);
        let m = e.nodeAt(f);
        if (!m)
          throw RangeError(`No cell with offset ${f} found`);
        const g = i.left - h.left, v = h.right - i.right;
        if (g > 0 || v > 0) {
          let y = m.attrs;
          if (g > 0 && (y = BV(y, 0, g)), v > 0 && (y = BV(
            y,
            y.colspan - v,
            v
          )), h.left < i.left) {
            if (m = m.type.createAndFill(y), !m)
              throw RangeError(
                `Could not create cell with attrs ${JSON.stringify(y)}`
              );
          } else
            m = m.type.create(y, m.content);
        }
        if (h.top < i.top || h.bottom > i.bottom) {
          const y = {
            ...m.attrs,
            rowspan: Math.min(h.bottom, i.bottom) - Math.max(h.top, i.top)
          };
          h.top < i.top ? m = m.type.createAndFill(y) : m = m.type.create(y, m.content);
        }
        c.push(m);
      }
      o.push(e.child(l).copy(Ee.from(c)));
    }
    const a = this.isColSelection() && this.isRowSelection() ? e : o;
    return new Fe(Ee.from(a), 1, 1);
  }
  replace(e, t = Fe.empty) {
    const r = e.steps.length, i = this.ranges;
    for (let o = 0; o < i.length; o++) {
      const { $from: a, $to: l } = i[o], c = e.mapping.slice(r);
      e.replace(
        c.map(a.pos),
        c.map(l.pos),
        o ? Fe.empty : t
      );
    }
    const s = pt.findFrom(
      e.doc.resolve(e.mapping.slice(r).map(this.to)),
      -1
    );
    s && e.setSelection(s);
  }
  replaceWith(e, t) {
    this.replace(e, new Fe(Ee.from(t), 0, 0));
  }
  forEachCell(e) {
    const t = this.$anchorCell.node(-1), r = ja.get(t), i = this.$anchorCell.start(-1), s = r.cellsInRect(
      r.rectBetween(
        this.$anchorCell.pos - i,
        this.$headCell.pos - i
      )
    );
    for (let o = 0; o < s.length; o++)
      e(t.nodeAt(s[o]), i + s[o]);
  }
  // True if this selection goes all the way from the top to the
  // bottom of the table.
  isColSelection() {
    const e = this.$anchorCell.index(-1), t = this.$headCell.index(-1);
    if (Math.min(e, t) > 0) return !1;
    const r = e + this.$anchorCell.nodeAfter.attrs.rowspan, i = t + this.$headCell.nodeAfter.attrs.rowspan;
    return Math.max(r, i) == this.$headCell.node(-1).childCount;
  }
  // Returns the smallest column selection that covers the given anchor
  // and head cell.
  static colSelection(e, t = e) {
    const r = e.node(-1), i = ja.get(r), s = e.start(-1), o = i.findCell(e.pos - s), a = i.findCell(t.pos - s), l = e.node(0);
    return o.top <= a.top ? (o.top > 0 && (e = l.resolve(s + i.map[o.left])), a.bottom < i.height && (t = l.resolve(
      s + i.map[i.width * (i.height - 1) + a.right - 1]
    ))) : (a.top > 0 && (t = l.resolve(s + i.map[a.left])), o.bottom < i.height && (e = l.resolve(
      s + i.map[i.width * (i.height - 1) + o.right - 1]
    ))), new Fa(e, t);
  }
  // True if this selection goes all the way from the left to the
  // right of the table.
  isRowSelection() {
    const e = this.$anchorCell.node(-1), t = ja.get(e), r = this.$anchorCell.start(-1), i = t.colCount(this.$anchorCell.pos - r), s = t.colCount(this.$headCell.pos - r);
    if (Math.min(i, s) > 0) return !1;
    const o = i + this.$anchorCell.nodeAfter.attrs.colspan, a = s + this.$headCell.nodeAfter.attrs.colspan;
    return Math.max(o, a) == t.width;
  }
  eq(e) {
    return e instanceof Fa && e.$anchorCell.pos == this.$anchorCell.pos && e.$headCell.pos == this.$headCell.pos;
  }
  // Returns the smallest row selection that covers the given anchor
  // and head cell.
  static rowSelection(e, t = e) {
    const r = e.node(-1), i = ja.get(r), s = e.start(-1), o = i.findCell(e.pos - s), a = i.findCell(t.pos - s), l = e.node(0);
    return o.left <= a.left ? (o.left > 0 && (e = l.resolve(
      s + i.map[o.top * i.width]
    )), a.right < i.width && (t = l.resolve(
      s + i.map[i.width * (a.top + 1) - 1]
    ))) : (a.left > 0 && (t = l.resolve(s + i.map[a.top * i.width])), o.right < i.width && (e = l.resolve(
      s + i.map[i.width * (o.top + 1) - 1]
    ))), new Fa(e, t);
  }
  toJSON() {
    return {
      type: "cell",
      anchor: this.$anchorCell.pos,
      head: this.$headCell.pos
    };
  }
  static fromJSON(e, t) {
    return new Fa(e.resolve(t.anchor), e.resolve(t.head));
  }
  static create(e, t, r = t) {
    return new Fa(e.resolve(t), e.resolve(r));
  }
  getBookmark() {
    return new pct(this.$anchorCell.pos, this.$headCell.pos);
  }
};
pa.prototype.visible = !1;
pt.jsonID("cell", pa);
var pct = class Yoe {
  constructor(e, t) {
    this.anchor = e, this.head = t;
  }
  map(e) {
    return new Yoe(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    const t = e.resolve(this.anchor), r = e.resolve(this.head);
    return t.parent.type.spec.tableRole == "row" && r.parent.type.spec.tableRole == "row" && t.index() < t.parent.childCount && r.index() < r.parent.childCount && Koe(t, r) ? new pa(t, r) : pt.near(r, 1);
  }
};
new _n("fix-tables");
function Xoe(n) {
  const e = n.selection, t = fct(n), r = t.node(-1), i = t.start(-1), s = ja.get(r);
  return { ...e instanceof pa ? s.rectBetween(
    e.$anchorCell.pos - i,
    e.$headCell.pos - i
  ) : s.findCell(t.pos - i), tableStart: i, map: s, table: r };
}
function mct(n) {
  return function(e, t) {
    if (!Goe(e)) return !1;
    if (t) {
      const r = xO(e.schema), i = Xoe(e), s = e.tr, o = i.map.cellsInRect(
        n == "column" ? {
          left: i.left,
          top: 0,
          right: i.right,
          bottom: i.map.height
        } : n == "row" ? {
          left: 0,
          top: i.top,
          right: i.map.width,
          bottom: i.bottom
        } : i
      ), a = o.map((l) => i.table.nodeAt(l));
      for (let l = 0; l < o.length; l++)
        a[l].type == r.header_cell && s.setNodeMarkup(
          i.tableStart + o[l],
          r.cell,
          a[l].attrs
        );
      if (s.steps.length == 0)
        for (let l = 0; l < o.length; l++)
          s.setNodeMarkup(
            i.tableStart + o[l],
            r.header_cell,
            a[l].attrs
          );
      t(s);
    }
    return !0;
  };
}
function zV(n, e, t) {
  const r = e.map.cellsInRect({
    left: 0,
    top: 0,
    right: n == "row" ? e.map.width : 1,
    bottom: n == "column" ? e.map.height : 1
  });
  for (let i = 0; i < r.length; i++) {
    const s = e.table.nodeAt(r[i]);
    if (s && s.type !== t.header_cell)
      return !1;
  }
  return !0;
}
function EO(n, e) {
  return e = e || { useDeprecatedLogic: !1 }, e.useDeprecatedLogic ? mct(n) : function(t, r) {
    if (!Goe(t)) return !1;
    if (r) {
      const i = xO(t.schema), s = Xoe(t), o = t.tr, a = zV("row", s, i), l = zV(
        "column",
        s,
        i
      ), u = (n === "column" ? a : n === "row" ? l : !1) ? 1 : 0, d = n == "column" ? {
        left: 0,
        top: u,
        right: 1,
        bottom: s.map.height
      } : n == "row" ? {
        left: u,
        top: 0,
        right: s.map.width,
        bottom: 1
      } : s, f = n == "column" ? l ? i.cell : i.header_cell : n == "row" ? a ? i.cell : i.header_cell : i.cell;
      s.map.cellsInRect(d).forEach((h) => {
        const m = h + s.tableStart, g = o.doc.nodeAt(m);
        g && o.setNodeMarkup(m, f, g.attrs);
      }), r(o);
    }
    return !0;
  };
}
EO("row", {
  useDeprecatedLogic: !0
});
EO("column", {
  useDeprecatedLogic: !0
});
EO("cell", {
  useDeprecatedLogic: !0
});
function nv(n, e) {
  const t = n.selection;
  if (!(t instanceof pa)) return !1;
  if (e) {
    const r = n.tr, i = xO(n.schema).cell.createAndFill().content;
    t.forEachCell((s, o) => {
      s.content.eq(i) || r.replace(
        r.mapping.map(o + 1),
        r.mapping.map(o + s.nodeSize - 1),
        new Fe(i, 0, 0)
      );
    }), r.docChanged && e(r);
  }
  return !0;
}
iO({
  ArrowLeft: rv("horiz", -1),
  ArrowRight: rv("horiz", 1),
  ArrowUp: rv("vert", -1),
  ArrowDown: rv("vert", 1),
  "Shift-ArrowLeft": iv("horiz", -1),
  "Shift-ArrowRight": iv("horiz", 1),
  "Shift-ArrowUp": iv("vert", -1),
  "Shift-ArrowDown": iv("vert", 1),
  Backspace: nv,
  "Mod-Backspace": nv,
  Delete: nv,
  "Mod-Delete": nv
});
function e2(n, e, t) {
  return t.eq(n.selection) ? !1 : (e && e(n.tr.setSelection(t).scrollIntoView()), !0);
}
function rv(n, e) {
  return (t, r, i) => {
    if (!i) return !1;
    const s = t.selection;
    if (s instanceof pa)
      return e2(
        t,
        r,
        pt.near(s.$headCell, e)
      );
    if (n != "horiz" && !s.empty) return !1;
    const o = Zoe(i, n, e);
    if (o == null) return !1;
    if (n == "horiz")
      return e2(
        t,
        r,
        pt.near(t.doc.resolve(s.head + e), e)
      );
    {
      const a = t.doc.resolve(o), l = qoe(a, n, e);
      let c;
      return l ? c = pt.near(l, 1) : e < 0 ? c = pt.near(t.doc.resolve(a.before(-1)), -1) : c = pt.near(t.doc.resolve(a.after(-1)), 1), e2(t, r, c);
    }
  };
}
function iv(n, e) {
  return (t, r, i) => {
    if (!i) return !1;
    const s = t.selection;
    let o;
    if (s instanceof pa)
      o = s;
    else {
      const l = Zoe(i, n, e);
      if (l == null) return !1;
      o = new pa(t.doc.resolve(l));
    }
    const a = qoe(o.$headCell, n, e);
    return a ? e2(
      t,
      r,
      new pa(o.$anchorCell, a)
    ) : !1;
  };
}
function Zoe(n, e, t) {
  if (!(n.state.selection instanceof vt)) return null;
  const { $head: r } = n.state.selection;
  for (let i = r.depth - 1; i >= 0; i--) {
    const s = r.node(i);
    if ((t < 0 ? r.index(i) : r.indexAfter(i)) != (t < 0 ? 0 : s.childCount)) return null;
    if (s.type.spec.tableRole == "cell" || s.type.spec.tableRole == "header_cell") {
      const a = r.before(i), l = e == "vert" ? t > 0 ? "down" : "up" : t > 0 ? "right" : "left";
      return n.endOfTextblock(l) ? a : null;
    }
  }
  return null;
}
new _n(
  "tableColumnResizing"
);
function gct(n, e) {
  const t = Math.min(n.top, e.top), r = Math.max(n.bottom, e.bottom), i = Math.min(n.left, e.left), o = Math.max(n.right, e.right) - i, a = r - t, l = i, c = t;
  return new DOMRect(l, c, o, a);
}
var vct = class {
  constructor({
    editor: n,
    element: e,
    view: t,
    updateDelay: r = 250,
    resizeDelay: i = 60,
    shouldShow: s,
    appendTo: o,
    getReferencedVirtualElement: a,
    options: l
  }) {
    this.preventHide = !1, this.isVisible = !1, this.scrollTarget = window, this.floatingUIOptions = {
      strategy: "absolute",
      placement: "top",
      offset: 8,
      flip: {},
      shift: {},
      arrow: !1,
      size: !1,
      autoPlacement: !1,
      hide: !1,
      inline: !1,
      onShow: void 0,
      onHide: void 0,
      onUpdate: void 0,
      onDestroy: void 0
    }, this.shouldShow = ({ view: u, state: d, from: f, to: h }) => {
      const { doc: m, selection: g } = d, { empty: v } = g, y = !m.textBetween(f, h).length && lO(d.selection), b = this.element.contains(document.activeElement);
      return !(!(u.hasFocus() || b) || v || y || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.resizeHandler = () => {
      this.resizeDebounceTimer && clearTimeout(this.resizeDebounceTimer), this.resizeDebounceTimer = window.setTimeout(() => {
        this.updatePosition();
      }, this.resizeDelay);
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: u }) => {
      var d;
      if (this.editor.isDestroyed) {
        this.destroy();
        return;
      }
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      u?.relatedTarget && ((d = this.element.parentNode) != null && d.contains(u.relatedTarget)) || u?.relatedTarget !== this.editor.view.dom && this.hide();
    }, this.handleDebouncedUpdate = (u, d) => {
      const f = !d?.selection.eq(u.state.selection), h = !d?.doc.eq(u.state.doc);
      !f && !h || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(u, f, h, d);
      }, this.updateDelay));
    }, this.updateHandler = (u, d, f, h) => {
      const { composing: m } = u;
      if (m || !d && !f)
        return;
      if (!this.getShouldShow(h)) {
        this.hide();
        return;
      }
      this.updatePosition(), this.show();
    }, this.transactionHandler = ({ transaction: u }) => {
      u.getMeta("bubbleMenu") === "updatePosition" && this.updatePosition();
    };
    var c;
    this.editor = n, this.element = e, this.view = t, this.updateDelay = r, this.resizeDelay = i, this.appendTo = o, this.scrollTarget = (c = l?.scrollTarget) != null ? c : window, this.getReferencedVirtualElement = a, this.floatingUIOptions = {
      ...this.floatingUIOptions,
      ...l
    }, this.element.tabIndex = 0, s && (this.shouldShow = s), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.editor.on("transaction", this.transactionHandler), window.addEventListener("resize", this.resizeHandler), this.scrollTarget.addEventListener("scroll", this.resizeHandler), this.update(t, t.state), this.getShouldShow() && (this.show(), this.updatePosition());
  }
  get middlewares() {
    const n = [];
    return this.floatingUIOptions.flip && n.push(wk(typeof this.floatingUIOptions.flip != "boolean" ? this.floatingUIOptions.flip : void 0)), this.floatingUIOptions.shift && n.push(
      bk(typeof this.floatingUIOptions.shift != "boolean" ? this.floatingUIOptions.shift : void 0)
    ), this.floatingUIOptions.offset && n.push(
      yk(typeof this.floatingUIOptions.offset != "boolean" ? this.floatingUIOptions.offset : void 0)
    ), this.floatingUIOptions.arrow && n.push(ky(this.floatingUIOptions.arrow)), this.floatingUIOptions.size && n.push(xk(typeof this.floatingUIOptions.size != "boolean" ? this.floatingUIOptions.size : void 0)), this.floatingUIOptions.autoPlacement && n.push(
      ZZ(
        typeof this.floatingUIOptions.autoPlacement != "boolean" ? this.floatingUIOptions.autoPlacement : void 0
      )
    ), this.floatingUIOptions.hide && n.push(Ek(typeof this.floatingUIOptions.hide != "boolean" ? this.floatingUIOptions.hide : void 0)), this.floatingUIOptions.inline && n.push(
      QZ(typeof this.floatingUIOptions.inline != "boolean" ? this.floatingUIOptions.inline : void 0)
    ), n;
  }
  get virtualElement() {
    var n;
    const { selection: e } = this.editor.state, t = (n = this.getReferencedVirtualElement) == null ? void 0 : n.call(this);
    if (t)
      return t;
    const r = hoe(this.view, e.from, e.to);
    let i = {
      getBoundingClientRect: () => r,
      getClientRects: () => [r]
    };
    if (e instanceof nt) {
      let s = this.view.nodeDOM(e.from);
      const o = s.dataset.nodeViewWrapper ? s : s.querySelector("[data-node-view-wrapper]");
      o && (s = o), s && (i = {
        getBoundingClientRect: () => s.getBoundingClientRect(),
        getClientRects: () => [s.getBoundingClientRect()]
      });
    }
    if (e instanceof pa) {
      const { $anchorCell: s, $headCell: o } = e, a = s ? s.pos : o.pos, l = o ? o.pos : s.pos, c = this.view.nodeDOM(a), u = this.view.nodeDOM(l);
      if (!c || !u)
        return;
      const d = c === u ? c.getBoundingClientRect() : gct(
        c.getBoundingClientRect(),
        u.getBoundingClientRect()
      );
      i = {
        getBoundingClientRect: () => d,
        getClientRects: () => [d]
      };
    }
    return i;
  }
  updatePosition() {
    const n = this.virtualElement;
    n && Sk(n, this.element, {
      placement: this.floatingUIOptions.placement,
      strategy: this.floatingUIOptions.strategy,
      middleware: this.middlewares
    }).then(({ x: e, y: t, strategy: r }) => {
      this.element.style.width = "max-content", this.element.style.position = r, this.element.style.left = `${e}px`, this.element.style.top = `${t}px`, this.isVisible && this.floatingUIOptions.onUpdate && this.floatingUIOptions.onUpdate();
    });
  }
  update(n, e) {
    const { state: t } = n, r = t.selection.from !== t.selection.to;
    if (this.updateDelay > 0 && r) {
      this.handleDebouncedUpdate(n, e);
      return;
    }
    const i = !e?.selection.eq(n.state.selection), s = !e?.doc.eq(n.state.doc);
    this.updateHandler(n, i, s, e);
  }
  getShouldShow(n) {
    var e;
    const { state: t } = this.view, { selection: r } = t, { ranges: i } = r, s = Math.min(...i.map((l) => l.$from.pos)), o = Math.max(...i.map((l) => l.$to.pos));
    return ((e = this.shouldShow) == null ? void 0 : e.call(this, {
      editor: this.editor,
      element: this.element,
      view: this.view,
      state: t,
      oldState: n,
      from: s,
      to: o
    })) || !1;
  }
  show() {
    var n;
    if (this.isVisible)
      return;
    this.element.style.visibility = "visible", this.element.style.opacity = "1";
    const e = typeof this.appendTo == "function" ? this.appendTo() : this.appendTo;
    (n = e ?? this.view.dom.parentElement) == null || n.appendChild(this.element), this.floatingUIOptions.onShow && this.floatingUIOptions.onShow(), this.isVisible = !0;
  }
  hide() {
    this.isVisible && (this.element.style.visibility = "hidden", this.element.style.opacity = "0", this.element.remove(), this.floatingUIOptions.onHide && this.floatingUIOptions.onHide(), this.isVisible = !1);
  }
  destroy() {
    this.hide(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), window.removeEventListener("resize", this.resizeHandler), this.scrollTarget.removeEventListener("scroll", this.resizeHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler), this.editor.off("transaction", this.transactionHandler), this.floatingUIOptions.onDestroy && this.floatingUIOptions.onDestroy();
  }
}, Qoe = (n) => new Cn({
  key: typeof n.pluginKey == "string" ? new _n(n.pluginKey) : n.pluginKey,
  view: (e) => new vct({ view: e, ...n })
});
qt.create({
  name: "bubbleMenu",
  addOptions() {
    return {
      element: null,
      pluginKey: "bubbleMenu",
      updateDelay: void 0,
      appendTo: void 0,
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      Qoe({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        updateDelay: this.options.updateDelay,
        options: this.options.options,
        appendTo: this.options.appendTo,
        getReferencedVirtualElement: this.options.getReferencedVirtualElement,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
var yct = class {
  constructor({ editor: n, element: e, view: t, options: r, appendTo: i, shouldShow: s }) {
    this.preventHide = !1, this.isVisible = !1, this.shouldShow = ({ view: o, state: a }) => {
      const { selection: l } = a, { $anchor: c, empty: u } = l, d = c.depth === 1, f = c.parent.isTextblock && !c.parent.type.spec.code && !c.parent.textContent && c.parent.childCount === 0 && !this.getTextContent(c.parent);
      return !(!o.hasFocus() || !u || !d || !f || !this.editor.isEditable);
    }, this.floatingUIOptions = {
      strategy: "absolute",
      placement: "right",
      offset: 8,
      flip: {},
      shift: {},
      arrow: !1,
      size: !1,
      autoPlacement: !1,
      hide: !1,
      inline: !1
    }, this.updateHandler = (o, a, l, c) => {
      const { composing: u } = o;
      if (u || !a && !l)
        return;
      if (!this.getShouldShow(c)) {
        this.hide();
        return;
      }
      this.updatePosition(), this.show();
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: o }) => {
      var a;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      o?.relatedTarget && ((a = this.element.parentNode) != null && a.contains(o.relatedTarget)) || o?.relatedTarget !== this.editor.view.dom && this.hide();
    }, this.editor = n, this.element = e, this.view = t, this.appendTo = i, this.floatingUIOptions = {
      ...this.floatingUIOptions,
      ...r
    }, this.element.tabIndex = 0, s && (this.shouldShow = s), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.update(t, t.state), this.getShouldShow() && (this.show(), this.updatePosition());
  }
  getTextContent(n) {
    return coe(n, { textSerializers: fO(this.editor.schema) });
  }
  get middlewares() {
    const n = [];
    return this.floatingUIOptions.flip && n.push(wk(typeof this.floatingUIOptions.flip != "boolean" ? this.floatingUIOptions.flip : void 0)), this.floatingUIOptions.shift && n.push(
      bk(typeof this.floatingUIOptions.shift != "boolean" ? this.floatingUIOptions.shift : void 0)
    ), this.floatingUIOptions.offset && n.push(
      yk(typeof this.floatingUIOptions.offset != "boolean" ? this.floatingUIOptions.offset : void 0)
    ), this.floatingUIOptions.arrow && n.push(ky(this.floatingUIOptions.arrow)), this.floatingUIOptions.size && n.push(xk(typeof this.floatingUIOptions.size != "boolean" ? this.floatingUIOptions.size : void 0)), this.floatingUIOptions.autoPlacement && n.push(
      ZZ(
        typeof this.floatingUIOptions.autoPlacement != "boolean" ? this.floatingUIOptions.autoPlacement : void 0
      )
    ), this.floatingUIOptions.hide && n.push(Ek(typeof this.floatingUIOptions.hide != "boolean" ? this.floatingUIOptions.hide : void 0)), this.floatingUIOptions.inline && n.push(
      QZ(typeof this.floatingUIOptions.inline != "boolean" ? this.floatingUIOptions.inline : void 0)
    ), n;
  }
  getShouldShow(n) {
    var e;
    const { state: t } = this.view, { selection: r } = t, { ranges: i } = r, s = Math.min(...i.map((l) => l.$from.pos)), o = Math.max(...i.map((l) => l.$to.pos));
    return (e = this.shouldShow) == null ? void 0 : e.call(this, {
      editor: this.editor,
      view: this.view,
      state: t,
      oldState: n,
      from: s,
      to: o
    });
  }
  updatePosition() {
    const { selection: n } = this.editor.state, e = hoe(this.view, n.from, n.to);
    Sk({
      getBoundingClientRect: () => e,
      getClientRects: () => [e]
    }, this.element, {
      placement: this.floatingUIOptions.placement,
      strategy: this.floatingUIOptions.strategy,
      middleware: this.middlewares
    }).then(({ x: r, y: i, strategy: s }) => {
      this.element.style.width = "max-content", this.element.style.position = s, this.element.style.left = `${r}px`, this.element.style.top = `${i}px`, this.isVisible && this.floatingUIOptions.onUpdate && this.floatingUIOptions.onUpdate();
    });
  }
  update(n, e) {
    const t = !e?.selection.eq(n.state.selection), r = !e?.doc.eq(n.state.doc);
    this.updateHandler(n, t, r, e);
  }
  show() {
    var n;
    if (this.isVisible)
      return;
    this.element.style.visibility = "visible", this.element.style.opacity = "1";
    const e = typeof this.appendTo == "function" ? this.appendTo() : this.appendTo;
    (n = e ?? this.view.dom.parentElement) == null || n.appendChild(this.element), this.floatingUIOptions.onShow && this.floatingUIOptions.onShow(), this.isVisible = !0;
  }
  hide() {
    this.isVisible && (this.element.style.visibility = "hidden", this.element.style.opacity = "0", this.element.remove(), this.floatingUIOptions.onHide && this.floatingUIOptions.onHide(), this.isVisible = !1);
  }
  destroy() {
    this.hide(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler), this.floatingUIOptions.onDestroy && this.floatingUIOptions.onDestroy();
  }
}, Joe = (n) => new Cn({
  key: typeof n.pluginKey == "string" ? new _n(n.pluginKey) : n.pluginKey,
  view: (e) => new yct({ view: e, ...n })
});
qt.create({
  name: "floatingMenu",
  addOptions() {
    return {
      element: null,
      options: {},
      pluginKey: "floatingMenu",
      appendTo: void 0,
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      Joe({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        options: this.options.options,
        appendTo: this.options.appendTo,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
var bct = p.forwardRef(
  ({
    pluginKey: n = "bubbleMenu",
    editor: e,
    updateDelay: t,
    resizeDelay: r,
    appendTo: i,
    shouldShow: s = null,
    getReferencedVirtualElement: o,
    options: a,
    children: l,
    ...c
  }, u) => {
    const d = Gt(document.createElement("div"));
    typeof u == "function" ? u(d.current) : u && (u.current = d.current);
    const { editor: f } = Roe(), h = e || f, m = {
      updateDelay: t,
      resizeDelay: r,
      appendTo: i,
      pluginKey: n,
      shouldShow: s,
      getReferencedVirtualElement: o,
      options: a
    }, g = Gt(m);
    return g.current = m, Tt(() => {
      if (h?.isDestroyed)
        return;
      if (!h) {
        console.warn("BubbleMenu component is not rendered inside of an editor component or does not have editor prop.");
        return;
      }
      const v = d.current;
      v.style.visibility = "hidden", v.style.position = "absolute";
      const y = Qoe({
        ...g.current,
        editor: h,
        element: v
      });
      h.registerPlugin(y);
      const b = g.current.pluginKey;
      return () => {
        h.unregisterPlugin(b), window.requestAnimationFrame(() => {
          v.parentNode && v.parentNode.removeChild(v);
        });
      };
    }, [h]), vw(/* @__PURE__ */ T("div", { ...c, children: l }), d.current);
  }
);
p.forwardRef(
  ({ pluginKey: n = "floatingMenu", editor: e, appendTo: t, shouldShow: r = null, options: i, children: s, ...o }, a) => {
    const l = Gt(document.createElement("div"));
    typeof a == "function" ? a(l.current) : a && (a.current = l.current);
    const { editor: c } = Roe();
    return Tt(() => {
      const u = l.current;
      if (u.style.visibility = "hidden", u.style.position = "absolute", e?.isDestroyed || c?.isDestroyed)
        return;
      const d = e || c;
      if (!d) {
        console.warn(
          "FloatingMenu component is not rendered inside of an editor component or does not have editor prop."
        );
        return;
      }
      const f = Joe({
        editor: d,
        element: u,
        pluginKey: n,
        appendTo: t,
        shouldShow: r,
        options: i
      });
      return d.registerPlugin(f), () => {
        d.unregisterPlugin(n), window.requestAnimationFrame(() => {
          u.parentNode && u.parentNode.removeChild(u);
        });
      };
    }, [e, c, t, n, r, i]), vw(/* @__PURE__ */ T("div", { ...o, children: s }), l.current);
  }
);
const wct = ({
  url: n,
  onClear: e,
  onEdit: t
}) => {
  const [r, i] = A.useState("Copy"), s = A.useCallback(
    (a) => {
      a.preventDefault(), navigator.clipboard.writeText(n).then(() => {
        i("Copied!"), setTimeout(() => i("Copy"), 1e3);
      }).catch(console.error);
    },
    [n]
  ), o = A.useCallback(() => {
    window.open(n, "_blank", "noopener,noreferrer");
  }, [n]);
  return /* @__PURE__ */ T("div", { className: "tw:bg-background tw:flex tw:overflow-hidden tw:rounded tw:p-2 tw:shadow-lg", children: /* @__PURE__ */ ee("div", { className: "tw:inline-flex tw:items-center tw:gap-1", children: [
    /* @__PURE__ */ T(po, { tooltip: "Edit link", onClick: t, children: "Edit link" }),
    /* @__PURE__ */ T(ra, { orientation: "vertical" }),
    /* @__PURE__ */ T(
      po,
      {
        tooltip: "Open link in a new tab",
        onClick: o,
        children: /* @__PURE__ */ T(wlt, {})
      }
    ),
    /* @__PURE__ */ T(ra, { orientation: "vertical" }),
    /* @__PURE__ */ T(po, { tooltip: "Clear link", onClick: e, children: /* @__PURE__ */ T(Plt, {}) }),
    /* @__PURE__ */ T(ra, { orientation: "vertical" }),
    /* @__PURE__ */ T(
      po,
      {
        tooltip: r,
        onClick: s,
        tooltipOptions: {
          onPointerDownOutside: (a) => {
            a.target === a.currentTarget && a.preventDefault();
          }
        },
        children: /* @__PURE__ */ T(hlt, {})
      }
    )
  ] }) });
}, xct = ({ editor: n }) => {
  const [e, t] = A.useState(!1), [r, i] = A.useState({
    href: "",
    target: ""
  }), [s, o] = A.useState(""), a = A.useCallback(() => {
    const { from: f, to: h } = n.state.selection, { href: m, target: g } = n.getAttributes("link"), v = n.state.doc.textBetween(f, h, " ");
    i({ href: m, target: g }), o(v);
  }, [n]), l = A.useCallback(
    ({ editor: f, from: h, to: m }) => {
      if (h === m)
        return !1;
      const { href: g } = f.getAttributes("link");
      return !f.isActive("link") || !f.isEditable ? !1 : g ? (a(), !0) : !1;
    },
    [a]
  ), c = A.useCallback(() => {
    t(!0);
  }, []), u = A.useCallback(
    (f, h, m) => {
      n.chain().focus().extendMarkRange("link").insertContent({
        type: "text",
        text: h || f,
        marks: [
          {
            type: "link",
            attrs: {
              href: f,
              target: m ? "_blank" : ""
            }
          }
        ]
      }).setLink({ href: f, target: m ? "_blank" : "" }).run(), t(!1), a();
    },
    [n, a]
  ), d = A.useCallback(() => {
    n.chain().focus().extendMarkRange("link").unsetLink().run(), t(!1), a();
  }, [n, a]);
  return /* @__PURE__ */ T(
    bct,
    {
      editor: n,
      shouldShow: l,
      options: {
        placement: "bottom-start",
        onHide: () => t(!1)
      },
      children: e ? /* @__PURE__ */ T(
        wO,
        {
          defaultUrl: r.href,
          defaultText: s,
          defaultIsNewTab: r.target === "_blank",
          onSave: u,
          className: "tw:bg-popover tw:text-popover-foreground tw:w-full tw:min-w-80 tw:rounded-md tw:border tw:p-4 tw:shadow-md tw:outline-hidden"
        }
      ) : /* @__PURE__ */ T(
        wct,
        {
          onClear: d,
          url: r.href,
          onEdit: c
        }
      )
    }
  );
};
var lb = (n, e) => {
  if (n === "slot")
    return 0;
  if (n instanceof Function)
    return n(e);
  const { children: t, ...r } = e ?? {};
  if (n === "svg")
    throw new Error("SVG elements are not supported in the JSX syntax, use the array syntax instead");
  return [n, r, t];
}, Ect = /^\s*>\s$/, Sct = Yi.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [{ tag: "blockquote" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return /* @__PURE__ */ lb("blockquote", { ...Zn(this.options.HTMLAttributes, n), children: /* @__PURE__ */ lb("slot", {}) });
  },
  parseMarkdown: (n, e) => e.createNode("blockquote", void 0, e.parseChildren(n.tokens || [])),
  renderMarkdown: (n, e) => {
    if (!n.content)
      return "";
    const t = [];
    return n.content.forEach((i) => {
      const o = e.renderChildren(i).split(`
`).map((a) => `> ${a}`).join(`
`);
      t.push(o);
    }), t.flatMap((i) => [i, "> "]).slice(0, -1).join(`
`);
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: n }) => n.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: n }) => n.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: n }) => n.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      lh({
        find: Ect,
        type: this.type
      })
    ];
  }
}), Cct = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, Tct = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, Act = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, Mct = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, kct = Lc.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (n) => n.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (n) => n.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (n) => /^(bold(er)?|[5-9]\d{2,})$/.test(n) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return /* @__PURE__ */ lb("strong", { ...Zn(this.options.HTMLAttributes, n), children: /* @__PURE__ */ lb("slot", {}) });
  },
  markdownTokenName: "strong",
  parseMarkdown: (n, e) => e.applyMark("bold", e.parseInline(n.tokens || [])),
  renderMarkdown: (n, e) => `**${e.renderChildren(n)}**`,
  addCommands() {
    return {
      setBold: () => ({ commands: n }) => n.setMark(this.name),
      toggleBold: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetBold: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      ah({
        find: Cct,
        type: this.type
      }),
      ah({
        find: Act,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Wu({
        find: Tct,
        type: this.type
      }),
      Wu({
        find: Mct,
        type: this.type
      })
    ];
  }
}), _ct = /(^|[^`])`([^`]+)`(?!`)$/, Oct = /(^|[^`])`([^`]+)`(?!`)/g, Ict = Lc.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [{ tag: "code" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["code", Zn(this.options.HTMLAttributes, n), 0];
  },
  markdownTokenName: "codespan",
  parseMarkdown: (n, e) => e.applyMark("code", [{ type: "text", text: n.text || "" }]),
  renderMarkdown: (n, e) => n.content ? `\`${e.renderChildren(n.content)}\`` : "",
  addCommands() {
    return {
      setCode: () => ({ commands: n }) => n.setMark(this.name),
      toggleCode: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetCode: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      ah({
        find: _ct,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Wu({
        find: Oct,
        type: this.type
      })
    ];
  }
}), v8 = 4, Rct = /^```([a-z]+)?[\s\n]$/, Pct = /^~~~([a-z]+)?[\s\n]$/, eae = Yi.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      enableTabIndentation: !1,
      tabSize: v8,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (n) => {
          var e;
          const { languageClassPrefix: t } = this.options;
          if (!t)
            return null;
          const s = [...((e = n.firstElementChild) == null ? void 0 : e.classList) || []].filter((o) => o.startsWith(t)).map((o) => o.replace(t, ""))[0];
          return s || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [
      "pre",
      Zn(this.options.HTMLAttributes, e),
      [
        "code",
        {
          class: n.attrs.language ? this.options.languageClassPrefix + n.attrs.language : null
        },
        0
      ]
    ];
  },
  markdownTokenName: "code",
  parseMarkdown: (n, e) => {
    var t;
    return ((t = n.raw) == null ? void 0 : t.startsWith("```")) === !1 && n.codeBlockStyle !== "indented" ? [] : e.createNode(
      "codeBlock",
      { language: n.lang || null },
      n.text ? [e.createTextNode(n.text)] : []
    );
  },
  renderMarkdown: (n, e) => {
    var t;
    let r = "";
    const i = ((t = n.attrs) == null ? void 0 : t.language) || "";
    return n.content ? r = [`\`\`\`${i}`, e.renderChildren(n.content), "```"].join(`
`) : r = `\`\`\`${i}

\`\`\``, r;
  },
  addCommands() {
    return {
      setCodeBlock: (n) => ({ commands: e }) => e.setNode(this.name, n),
      toggleCodeBlock: (n) => ({ commands: e }) => e.toggleNode(this.name, "paragraph", n)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: n, $anchor: e } = this.editor.state.selection, t = e.pos === 1;
        return !n || e.parent.type.name !== this.name ? !1 : t || !e.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // handle tab indentation
      Tab: ({ editor: n }) => {
        var e;
        if (!this.options.enableTabIndentation)
          return !1;
        const t = (e = this.options.tabSize) != null ? e : v8, { state: r } = n, { selection: i } = r, { $from: s, empty: o } = i;
        if (s.parent.type !== this.type)
          return !1;
        const a = " ".repeat(t);
        return o ? n.commands.insertContent(a) : n.commands.command(({ tr: l }) => {
          const { from: c, to: u } = i, h = r.doc.textBetween(c, u, `
`, `
`).split(`
`).map((m) => a + m).join(`
`);
          return l.replaceWith(c, u, r.schema.text(h)), !0;
        });
      },
      // handle shift+tab reverse indentation
      "Shift-Tab": ({ editor: n }) => {
        var e;
        if (!this.options.enableTabIndentation)
          return !1;
        const t = (e = this.options.tabSize) != null ? e : v8, { state: r } = n, { selection: i } = r, { $from: s, empty: o } = i;
        return s.parent.type !== this.type ? !1 : o ? n.commands.command(({ tr: a }) => {
          var l;
          const { pos: c } = s, u = s.start(), d = s.end(), h = r.doc.textBetween(u, d, `
`, `
`).split(`
`);
          let m = 0, g = 0;
          const v = c - u;
          for (let C = 0; C < h.length; C += 1) {
            if (g + h[C].length >= v) {
              m = C;
              break;
            }
            g += h[C].length + 1;
          }
          const b = ((l = h[m].match(/^ */)) == null ? void 0 : l[0]) || "", x = Math.min(b.length, t);
          if (x === 0)
            return !0;
          let E = u;
          for (let C = 0; C < m; C += 1)
            E += h[C].length + 1;
          return a.delete(E, E + x), c - E <= x && a.setSelection(vt.create(a.doc, E)), !0;
        }) : n.commands.command(({ tr: a }) => {
          const { from: l, to: c } = i, f = r.doc.textBetween(l, c, `
`, `
`).split(`
`).map((h) => {
            var m;
            const g = ((m = h.match(/^ */)) == null ? void 0 : m[0]) || "", v = Math.min(g.length, t);
            return h.slice(v);
          }).join(`
`);
          return a.replaceWith(l, c, r.schema.text(f)), !0;
        });
      },
      // exit node on triple enter
      Enter: ({ editor: n }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: e } = n, { selection: t } = e, { $from: r, empty: i } = t;
        if (!i || r.parent.type !== this.type)
          return !1;
        const s = r.parentOffset === r.parent.nodeSize - 2, o = r.parent.textContent.endsWith(`

`);
        return !s || !o ? !1 : n.chain().command(({ tr: a }) => (a.delete(r.pos - 2, r.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: n }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: e } = n, { selection: t, doc: r } = e, { $from: i, empty: s } = t;
        if (!s || i.parent.type !== this.type || !(i.parentOffset === i.parent.nodeSize - 2))
          return !1;
        const a = i.after();
        return a === void 0 ? !1 : r.nodeAt(a) ? n.commands.command(({ tr: c }) => (c.setSelection(pt.near(r.resolve(a))), !0)) : n.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      a9({
        find: Rct,
        type: this.type,
        getAttributes: (n) => ({
          language: n[1]
        })
      }),
      a9({
        find: Pct,
        type: this.type,
        getAttributes: (n) => ({
          language: n[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new Cn({
        key: new _n("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (n, e) => {
            if (!e.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const t = e.clipboardData.getData("text/plain"), r = e.clipboardData.getData("vscode-editor-data"), i = r ? JSON.parse(r) : void 0, s = i?.mode;
            if (!t || !s)
              return !1;
            const { tr: o, schema: a } = n.state, l = a.text(t.replace(/\r\n?/g, `
`));
            return o.replaceSelectionWith(this.type.create({ language: s }, l)), o.selection.$from.parent.type !== this.type && o.setSelection(vt.near(o.doc.resolve(Math.max(0, o.selection.from - 2)))), o.setMeta("paste", !0), n.dispatch(o), !0;
          }
        }
      })
    ];
  }
}), Dct = eae, Nct = Yi.create({
  name: "doc",
  topNode: !0,
  content: "block+",
  renderMarkdown: (n, e) => n.content ? e.renderChildren(n.content, `

`) : ""
}), Lct = Yi.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [{ tag: "br" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["br", Zn(this.options.HTMLAttributes, n)];
  },
  renderText() {
    return `
`;
  },
  renderMarkdown: (n, e) => e.indent(`
`),
  addCommands() {
    return {
      setHardBreak: () => ({ commands: n, chain: e, state: t, editor: r }) => n.first([
        () => n.exitCode(),
        () => n.command(() => {
          const { selection: i, storedMarks: s } = t;
          if (i.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: o } = this.options, { splittableMarks: a } = r.extensionManager, l = s || i.$to.parentOffset && i.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: c, dispatch: u }) => {
            if (u && l && o) {
              const d = l.filter((f) => a.includes(f.type.name));
              c.ensureMarks(d);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), $ct = Yi.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((n) => ({
      tag: `h${n}`,
      attrs: { level: n }
    }));
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(n.attrs.level) ? n.attrs.level : this.options.levels[0]}`, Zn(this.options.HTMLAttributes, e), 0];
  },
  parseMarkdown: (n, e) => e.createNode("heading", { level: n.depth || 1 }, e.parseInline(n.tokens || [])),
  renderMarkdown: (n, e) => {
    var t;
    const r = (t = n.attrs) != null && t.level ? parseInt(n.attrs.level, 10) : 1, i = "#".repeat(r);
    return n.content ? `${i} ${e.renderChildren(n.content)}` : "";
  },
  addCommands() {
    return {
      setHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.setNode(this.name, n) : !1,
      toggleHeading: (n) => ({ commands: e }) => this.options.levels.includes(n.level) ? e.toggleNode(this.name, "paragraph", n) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce(
      (n, e) => ({
        ...n,
        [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
      }),
      {}
    );
  },
  addInputRules() {
    return this.options.levels.map((n) => a9({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${n}})\\s$`),
      type: this.type,
      getAttributes: {
        level: n
      }
    }));
  }
}), tae = Yi.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {},
      nextNodeType: "paragraph"
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["hr", Zn(this.options.HTMLAttributes, n)];
  },
  markdownTokenName: "hr",
  parseMarkdown: (n, e) => e.createNode("horizontalRule"),
  renderMarkdown: () => "---",
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: n, state: e }) => {
        if (!Tat(e, e.schema.nodes[this.name]))
          return !1;
        const { selection: t } = e, { $to: r } = t, i = n();
        return foe(t) ? i.insertContentAt(r.pos, {
          type: this.name
        }) : i.insertContent({ type: this.name }), i.command(({ state: s, tr: o, dispatch: a }) => {
          if (a) {
            const { $to: l } = o.selection, c = l.end();
            if (l.nodeAfter)
              l.nodeAfter.isTextblock ? o.setSelection(vt.create(o.doc, l.pos + 1)) : l.nodeAfter.isBlock ? o.setSelection(nt.create(o.doc, l.pos)) : o.setSelection(vt.create(o.doc, l.pos));
            else {
              const u = s.schema.nodes[this.options.nextNodeType] || l.parent.type.contentMatch.defaultType, d = u?.create();
              d && (o.insert(c, d), o.setSelection(vt.create(o.doc, c + 1)));
            }
            o.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      Moe({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), Fct = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, Bct = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, zct = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, Hct = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, Uct = Lc.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (n) => n.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (n) => n.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["em", Zn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: n }) => n.setMark(this.name),
      toggleItalic: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetItalic: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  markdownTokenName: "em",
  parseMarkdown: (n, e) => e.applyMark("italic", e.parseInline(n.tokens || [])),
  renderMarkdown: (n, e) => `*${e.renderChildren(n)}*`,
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      ah({
        find: Fct,
        type: this.type
      }),
      ah({
        find: zct,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Wu({
        find: Bct,
        type: this.type
      }),
      Wu({
        find: Hct,
        type: this.type
      })
    ];
  }
});
const Vct = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", jct = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", p9 = "numeric", m9 = "ascii", g9 = "alpha", im = "asciinumeric", Lp = "alphanumeric", v9 = "domain", nae = "emoji", Wct = "scheme", Gct = "slashscheme", y8 = "whitespace";
function Kct(n, e) {
  return n in e || (e[n] = []), e[n];
}
function hu(n, e, t) {
  e[p9] && (e[im] = !0, e[Lp] = !0), e[m9] && (e[im] = !0, e[g9] = !0), e[im] && (e[Lp] = !0), e[g9] && (e[Lp] = !0), e[Lp] && (e[v9] = !0), e[nae] && (e[v9] = !0);
  for (const r in e) {
    const i = Kct(r, t);
    i.indexOf(n) < 0 && i.push(n);
  }
}
function qct(n, e) {
  const t = {};
  for (const r in e)
    e[r].indexOf(n) >= 0 && (t[r] = !0);
  return t;
}
function Ri(n = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = n;
}
Ri.groups = {};
Ri.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(n) {
    const e = this, t = e.j[n];
    if (t)
      return t;
    for (let r = 0; r < e.jr.length; r++) {
      const i = e.jr[r][0], s = e.jr[r][1];
      if (s && i.test(n))
        return s;
    }
    return e.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(n, e = !1) {
    return e ? n in this.j : !!this.go(n);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(n, e, t, r) {
    for (let i = 0; i < n.length; i++)
      this.tt(n[i], e, t, r);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(n, e, t, r) {
    r = r || Ri.groups;
    let i;
    return e && e.j ? i = e : (i = new Ri(e), t && r && hu(e, t, r)), this.jr.push([n, i]), i;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(n, e, t, r) {
    let i = this;
    const s = n.length;
    if (!s)
      return i;
    for (let o = 0; o < s - 1; o++)
      i = i.tt(n[o]);
    return i.tt(n[s - 1], e, t, r);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(n, e, t, r) {
    r = r || Ri.groups;
    const i = this;
    if (e && e.j)
      return i.j[n] = e, e;
    const s = e;
    let o, a = i.go(n);
    if (a ? (o = new Ri(), Object.assign(o.j, a.j), o.jr.push.apply(o.jr, a.jr), o.jd = a.jd, o.t = a.t) : o = new Ri(), s) {
      if (r)
        if (o.t && typeof o.t == "string") {
          const l = Object.assign(qct(o.t, r), t);
          hu(s, l, r);
        } else t && hu(s, t, r);
      o.t = s;
    }
    return i.j[n] = o, o;
  }
};
const _t = (n, e, t, r, i) => n.ta(e, t, r, i), Gn = (n, e, t, r, i) => n.tr(e, t, r, i), HV = (n, e, t, r, i) => n.ts(e, t, r, i), Te = (n, e, t, r, i) => n.tt(e, t, r, i), Ba = "WORD", y9 = "UWORD", rae = "ASCIINUMERICAL", iae = "ALPHANUMERICAL", V0 = "LOCALHOST", b9 = "TLD", w9 = "UTLD", t2 = "SCHEME", zd = "SLASH_SCHEME", SO = "NUM", x9 = "WS", CO = "NL", sm = "OPENBRACE", om = "CLOSEBRACE", cb = "OPENBRACKET", ub = "CLOSEBRACKET", db = "OPENPAREN", fb = "CLOSEPAREN", hb = "OPENANGLEBRACKET", pb = "CLOSEANGLEBRACKET", mb = "FULLWIDTHLEFTPAREN", gb = "FULLWIDTHRIGHTPAREN", vb = "LEFTCORNERBRACKET", yb = "RIGHTCORNERBRACKET", bb = "LEFTWHITECORNERBRACKET", wb = "RIGHTWHITECORNERBRACKET", xb = "FULLWIDTHLESSTHAN", Eb = "FULLWIDTHGREATERTHAN", Sb = "AMPERSAND", Cb = "APOSTROPHE", Tb = "ASTERISK", Hl = "AT", Ab = "BACKSLASH", Mb = "BACKTICK", kb = "CARET", Kl = "COLON", TO = "COMMA", _b = "DOLLAR", Ko = "DOT", Ob = "EQUALS", AO = "EXCLAMATION", As = "HYPHEN", am = "PERCENT", Ib = "PIPE", Rb = "PLUS", Pb = "POUND", lm = "QUERY", MO = "QUOTE", sae = "FULLWIDTHMIDDLEDOT", kO = "SEMI", qo = "SLASH", cm = "TILDE", Db = "UNDERSCORE", oae = "EMOJI", Nb = "SYM";
var aae = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ALPHANUMERICAL: iae,
  AMPERSAND: Sb,
  APOSTROPHE: Cb,
  ASCIINUMERICAL: rae,
  ASTERISK: Tb,
  AT: Hl,
  BACKSLASH: Ab,
  BACKTICK: Mb,
  CARET: kb,
  CLOSEANGLEBRACKET: pb,
  CLOSEBRACE: om,
  CLOSEBRACKET: ub,
  CLOSEPAREN: fb,
  COLON: Kl,
  COMMA: TO,
  DOLLAR: _b,
  DOT: Ko,
  EMOJI: oae,
  EQUALS: Ob,
  EXCLAMATION: AO,
  FULLWIDTHGREATERTHAN: Eb,
  FULLWIDTHLEFTPAREN: mb,
  FULLWIDTHLESSTHAN: xb,
  FULLWIDTHMIDDLEDOT: sae,
  FULLWIDTHRIGHTPAREN: gb,
  HYPHEN: As,
  LEFTCORNERBRACKET: vb,
  LEFTWHITECORNERBRACKET: bb,
  LOCALHOST: V0,
  NL: CO,
  NUM: SO,
  OPENANGLEBRACKET: hb,
  OPENBRACE: sm,
  OPENBRACKET: cb,
  OPENPAREN: db,
  PERCENT: am,
  PIPE: Ib,
  PLUS: Rb,
  POUND: Pb,
  QUERY: lm,
  QUOTE: MO,
  RIGHTCORNERBRACKET: yb,
  RIGHTWHITECORNERBRACKET: wb,
  SCHEME: t2,
  SEMI: kO,
  SLASH: qo,
  SLASH_SCHEME: zd,
  SYM: Nb,
  TILDE: cm,
  TLD: b9,
  UNDERSCORE: Db,
  UTLD: w9,
  UWORD: y9,
  WORD: Ba,
  WS: x9
});
const La = /[a-z]/, mp = new RegExp("\\p{L}", "u"), b8 = new RegExp("\\p{Emoji}", "u"), $a = /\d/, w8 = /\s/, UV = "\r", x8 = `
`, Yct = "️", Xct = "‍", E8 = "￼";
let sv = null, ov = null;
function Zct(n = []) {
  const e = {};
  Ri.groups = e;
  const t = new Ri();
  sv == null && (sv = VV(Vct)), ov == null && (ov = VV(jct)), Te(t, "'", Cb), Te(t, "{", sm), Te(t, "}", om), Te(t, "[", cb), Te(t, "]", ub), Te(t, "(", db), Te(t, ")", fb), Te(t, "<", hb), Te(t, ">", pb), Te(t, "（", mb), Te(t, "）", gb), Te(t, "「", vb), Te(t, "」", yb), Te(t, "『", bb), Te(t, "』", wb), Te(t, "＜", xb), Te(t, "＞", Eb), Te(t, "&", Sb), Te(t, "*", Tb), Te(t, "@", Hl), Te(t, "`", Mb), Te(t, "^", kb), Te(t, ":", Kl), Te(t, ",", TO), Te(t, "$", _b), Te(t, ".", Ko), Te(t, "=", Ob), Te(t, "!", AO), Te(t, "-", As), Te(t, "%", am), Te(t, "|", Ib), Te(t, "+", Rb), Te(t, "#", Pb), Te(t, "?", lm), Te(t, '"', MO), Te(t, "/", qo), Te(t, ";", kO), Te(t, "~", cm), Te(t, "_", Db), Te(t, "\\", Ab), Te(t, "・", sae);
  const r = Gn(t, $a, SO, {
    [p9]: !0
  });
  Gn(r, $a, r);
  const i = Gn(r, La, rae, {
    [im]: !0
  }), s = Gn(r, mp, iae, {
    [Lp]: !0
  }), o = Gn(t, La, Ba, {
    [m9]: !0
  });
  Gn(o, $a, i), Gn(o, La, o), Gn(i, $a, i), Gn(i, La, i);
  const a = Gn(t, mp, y9, {
    [g9]: !0
  });
  Gn(a, La), Gn(a, $a, s), Gn(a, mp, a), Gn(s, $a, s), Gn(s, La), Gn(s, mp, s);
  const l = Te(t, x8, CO, {
    [y8]: !0
  }), c = Te(t, UV, x9, {
    [y8]: !0
  }), u = Gn(t, w8, x9, {
    [y8]: !0
  });
  Te(t, E8, u), Te(c, x8, l), Te(c, E8, u), Gn(c, w8, u), Te(u, UV), Te(u, x8), Gn(u, w8, u), Te(u, E8, u);
  const d = Gn(t, b8, oae, {
    [nae]: !0
  });
  Te(d, "#"), Gn(d, b8, d), Te(d, Yct, d);
  const f = Te(d, Xct);
  Te(f, "#"), Gn(f, b8, d);
  const h = [[La, o], [$a, i]], m = [[La, null], [mp, a], [$a, s]];
  for (let g = 0; g < sv.length; g++)
    Rl(t, sv[g], b9, Ba, h);
  for (let g = 0; g < ov.length; g++)
    Rl(t, ov[g], w9, y9, m);
  hu(b9, {
    tld: !0,
    ascii: !0
  }, e), hu(w9, {
    utld: !0,
    alpha: !0
  }, e), Rl(t, "file", t2, Ba, h), Rl(t, "mailto", t2, Ba, h), Rl(t, "http", zd, Ba, h), Rl(t, "https", zd, Ba, h), Rl(t, "ftp", zd, Ba, h), Rl(t, "ftps", zd, Ba, h), hu(t2, {
    scheme: !0,
    ascii: !0
  }, e), hu(zd, {
    slashscheme: !0,
    ascii: !0
  }, e), n = n.sort((g, v) => g[0] > v[0] ? 1 : -1);
  for (let g = 0; g < n.length; g++) {
    const v = n[g][0], b = n[g][1] ? {
      [Wct]: !0
    } : {
      [Gct]: !0
    };
    v.indexOf("-") >= 0 ? b[v9] = !0 : La.test(v) ? $a.test(v) ? b[im] = !0 : b[m9] = !0 : b[p9] = !0, HV(t, v, v, b);
  }
  return HV(t, "localhost", V0, {
    ascii: !0
  }), t.jd = new Ri(Nb), {
    start: t,
    tokens: Object.assign({
      groups: e
    }, aae)
  };
}
function lae(n, e) {
  const t = Qct(e.replace(/[A-Z]/g, (a) => a.toLowerCase())), r = t.length, i = [];
  let s = 0, o = 0;
  for (; o < r; ) {
    let a = n, l = null, c = 0, u = null, d = -1, f = -1;
    for (; o < r && (l = a.go(t[o])); )
      a = l, a.accepts() ? (d = 0, f = 0, u = a) : d >= 0 && (d += t[o].length, f++), c += t[o].length, s += t[o].length, o++;
    s -= d, o -= f, c -= d, i.push({
      t: u.t,
      // token type/name
      v: e.slice(s - c, s),
      // string value
      s: s - c,
      // start index
      e: s
      // end index (excluding)
    });
  }
  return i;
}
function Qct(n) {
  const e = [], t = n.length;
  let r = 0;
  for (; r < t; ) {
    let i = n.charCodeAt(r), s, o = i < 55296 || i > 56319 || r + 1 === t || (s = n.charCodeAt(r + 1)) < 56320 || s > 57343 ? n[r] : n.slice(r, r + 2);
    e.push(o), r += o.length;
  }
  return e;
}
function Rl(n, e, t, r, i) {
  let s;
  const o = e.length;
  for (let a = 0; a < o - 1; a++) {
    const l = e[a];
    n.j[l] ? s = n.j[l] : (s = new Ri(r), s.jr = i.slice(), n.j[l] = s), n = s;
  }
  return s = new Ri(t), s.jr = i.slice(), n.j[e[o - 1]] = s, s;
}
function VV(n) {
  const e = [], t = [];
  let r = 0, i = "0123456789";
  for (; r < n.length; ) {
    let s = 0;
    for (; i.indexOf(n[r + s]) >= 0; )
      s++;
    if (s > 0) {
      e.push(t.join(""));
      for (let o = parseInt(n.substring(r, r + s), 10); o > 0; o--)
        t.pop();
      r += s;
    } else
      t.push(n[r]), r++;
  }
  return e;
}
const j0 = {
  defaultProtocol: "http",
  events: null,
  format: jV,
  formatHref: jV,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function _O(n, e = null) {
  let t = Object.assign({}, j0);
  n && (t = Object.assign(t, n instanceof _O ? n.o : n));
  const r = t.ignoreTags, i = [];
  for (let s = 0; s < r.length; s++)
    i.push(r[s].toUpperCase());
  this.o = t, e && (this.defaultRender = e), this.ignoreTags = i;
}
_O.prototype = {
  o: j0,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(n) {
    return n;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(n) {
    return this.get("validate", n.toString(), n);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(n, e, t) {
    const r = e != null;
    let i = this.o[n];
    return i && (typeof i == "object" ? (i = t.t in i ? i[t.t] : j0[n], typeof i == "function" && r && (i = i(e, t))) : typeof i == "function" && r && (i = i(e, t.t, t)), i);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(n, e, t) {
    let r = this.o[n];
    return typeof r == "function" && e != null && (r = r(e, t.t, t)), r;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(n) {
    const e = n.render(this);
    return (this.get("render", null, n) || this.defaultRender)(e, n.t, n);
  }
};
function jV(n) {
  return n;
}
function cae(n, e) {
  this.t = "token", this.v = n, this.tk = e;
}
cae.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(n) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(n) {
    const e = this.toString(), t = n.get("truncate", e, this), r = n.get("format", e, this);
    return t && r.length > t ? r.substring(0, t) + "…" : r;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(n) {
    return n.get("formatHref", this.toHref(n.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(n = j0.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(n) {
    return {
      type: this.t,
      value: this.toFormattedString(n),
      isLink: this.isLink,
      href: this.toFormattedHref(n),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(n) {
    return n.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(n) {
    const e = this, t = this.toHref(n.get("defaultProtocol")), r = n.get("formatHref", t, this), i = n.get("tagName", t, e), s = this.toFormattedString(n), o = {}, a = n.get("className", t, e), l = n.get("target", t, e), c = n.get("rel", t, e), u = n.getObj("attributes", t, e), d = n.getObj("events", t, e);
    return o.href = r, a && (o.class = a), l && (o.target = l), c && (o.rel = c), u && Object.assign(o, u), {
      tagName: i,
      attributes: o,
      content: s,
      eventListeners: d
    };
  }
};
function hx(n, e) {
  class t extends cae {
    constructor(i, s) {
      super(i, s), this.t = n;
    }
  }
  for (const r in e)
    t.prototype[r] = e[r];
  return t.t = n, t;
}
const WV = hx("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), GV = hx("text"), Jct = hx("nl"), av = hx("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(n = j0.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${n}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const n = this.tk;
    return n.length >= 2 && n[0].t !== V0 && n[1].t === Kl;
  }
}), Ts = (n) => new Ri(n);
function eut({
  groups: n
}) {
  const e = n.domain.concat([Sb, Tb, Hl, Ab, Mb, kb, _b, Ob, As, SO, am, Ib, Rb, Pb, qo, Nb, cm, Db]), t = [Cb, Kl, TO, Ko, AO, am, lm, MO, kO, hb, pb, sm, om, ub, cb, db, fb, mb, gb, vb, yb, bb, wb, xb, Eb], r = [Sb, Cb, Tb, Ab, Mb, kb, _b, Ob, As, sm, om, am, Ib, Rb, Pb, lm, qo, Nb, cm, Db], i = Ts(), s = Te(i, cm);
  _t(s, r, s), _t(s, n.domain, s);
  const o = Ts(), a = Ts(), l = Ts();
  _t(i, n.domain, o), _t(i, n.scheme, a), _t(i, n.slashscheme, l), _t(o, r, s), _t(o, n.domain, o);
  const c = Te(o, Hl);
  Te(s, Hl, c), Te(a, Hl, c), Te(l, Hl, c);
  const u = Te(s, Ko);
  _t(u, r, s), _t(u, n.domain, s);
  const d = Ts();
  _t(c, n.domain, d), _t(d, n.domain, d);
  const f = Te(d, Ko);
  _t(f, n.domain, d);
  const h = Ts(WV);
  _t(f, n.tld, h), _t(f, n.utld, h), Te(c, V0, h);
  const m = Te(d, As);
  Te(m, As, m), _t(m, n.domain, d), _t(h, n.domain, d), Te(h, Ko, f), Te(h, As, m);
  const g = Te(h, Kl);
  _t(g, n.numeric, WV);
  const v = Te(o, As), y = Te(o, Ko);
  Te(v, As, v), _t(v, n.domain, o), _t(y, r, s), _t(y, n.domain, o);
  const b = Ts(av);
  _t(y, n.tld, b), _t(y, n.utld, b), _t(b, n.domain, o), _t(b, r, s), Te(b, Ko, y), Te(b, As, v), Te(b, Hl, c);
  const x = Te(b, Kl), E = Ts(av);
  _t(x, n.numeric, E);
  const w = Ts(av), C = Ts();
  _t(w, e, w), _t(w, t, C), _t(C, e, w), _t(C, t, C), Te(b, qo, w), Te(E, qo, w);
  const S = Te(a, Kl), M = Te(l, Kl), k = Te(M, qo), _ = Te(k, qo);
  _t(a, n.domain, o), Te(a, Ko, y), Te(a, As, v), _t(l, n.domain, o), Te(l, Ko, y), Te(l, As, v), _t(S, n.domain, w), Te(S, qo, w), Te(S, lm, w), _t(_, n.domain, w), _t(_, e, w), Te(_, qo, w);
  const O = [
    [sm, om],
    // {}
    [cb, ub],
    // []
    [db, fb],
    // ()
    [hb, pb],
    // <>
    [mb, gb],
    // （）
    [vb, yb],
    // 「」
    [bb, wb],
    // 『』
    [xb, Eb]
    // ＜＞
  ];
  for (let I = 0; I < O.length; I++) {
    const [R, P] = O[I], D = Te(w, R);
    Te(C, R, D), Te(D, P, w);
    const L = Ts(av);
    _t(D, e, L);
    const B = Ts();
    _t(D, t), _t(L, e, L), _t(L, t, B), _t(B, e, L), _t(B, t, B), Te(L, P, w), Te(B, P, w);
  }
  return Te(i, V0, b), Te(i, CO, Jct), {
    start: i,
    tokens: aae
  };
}
function tut(n, e, t) {
  let r = t.length, i = 0, s = [], o = [];
  for (; i < r; ) {
    let a = n, l = null, c = null, u = 0, d = null, f = -1;
    for (; i < r && !(l = a.go(t[i].t)); )
      o.push(t[i++]);
    for (; i < r && (c = l || a.go(t[i].t)); )
      l = null, a = c, a.accepts() ? (f = 0, d = a) : f >= 0 && f++, i++, u++;
    if (f < 0)
      i -= u, i < r && (o.push(t[i]), i++);
    else {
      o.length > 0 && (s.push(S8(GV, e, o)), o = []), i -= f, u -= f;
      const h = d.t, m = t.slice(i - u, i);
      s.push(S8(h, e, m));
    }
  }
  return o.length > 0 && s.push(S8(GV, e, o)), s;
}
function S8(n, e, t) {
  const r = t[0].s, i = t[t.length - 1].e, s = e.slice(r, i);
  return new n(s, t);
}
const nut = typeof console < "u" && console && console.warn || (() => {
}), rut = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", In = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function iut() {
  return Ri.groups = {}, In.scanner = null, In.parser = null, In.tokenQueue = [], In.pluginQueue = [], In.customSchemes = [], In.initialized = !1, In;
}
function KV(n, e = !1) {
  if (In.initialized && nut(`linkifyjs: already initialized - will not register custom scheme "${n}" ${rut}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(n))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  In.customSchemes.push([n, e]);
}
function sut() {
  In.scanner = Zct(In.customSchemes);
  for (let n = 0; n < In.tokenQueue.length; n++)
    In.tokenQueue[n][1]({
      scanner: In.scanner
    });
  In.parser = eut(In.scanner.tokens);
  for (let n = 0; n < In.pluginQueue.length; n++)
    In.pluginQueue[n][1]({
      scanner: In.scanner,
      parser: In.parser
    });
  return In.initialized = !0, In;
}
function OO(n) {
  return In.initialized || sut(), tut(In.parser.start, n, lae(In.scanner.start, n));
}
OO.scan = lae;
function uae(n, e = null, t = null) {
  if (e && typeof e == "object") {
    if (t)
      throw Error(`linkifyjs: Invalid link type ${e}; must be a string`);
    t = e, e = null;
  }
  const r = new _O(t), i = OO(n), s = [];
  for (let o = 0; o < i.length; o++) {
    const a = i[o];
    a.isLink && (!e || a.t === e) && r.check(a) && s.push(a.toFormattedObject(r));
  }
  return s;
}
var IO = "[\0-   ᠎ -\u2029 　]", out = new RegExp(IO), aut = new RegExp(`${IO}$`), lut = new RegExp(IO, "g");
function cut(n) {
  return n.length === 1 ? n[0].isLink : n.length === 3 && n[1].isLink ? ["()", "[]"].includes(n[0].value + n[2].value) : !1;
}
function uut(n) {
  return new Cn({
    key: new _n("autolink"),
    appendTransaction: (e, t, r) => {
      const i = e.some((c) => c.docChanged) && !t.doc.eq(r.doc), s = e.some((c) => c.getMeta("preventAutolink"));
      if (!i || s)
        return;
      const { tr: o } = r, a = ioe(t.doc, [...e]);
      if (doe(a).forEach(({ newRange: c }) => {
        const u = Iot(r.doc, c, (h) => h.isTextblock);
        let d, f;
        if (u.length > 1)
          d = u[0], f = r.doc.textBetween(
            d.pos,
            d.pos + d.node.nodeSize,
            void 0,
            " "
          );
        else if (u.length) {
          const h = r.doc.textBetween(c.from, c.to, " ", " ");
          if (!aut.test(h))
            return;
          d = u[0], f = r.doc.textBetween(d.pos, c.to, void 0, " ");
        }
        if (d && f) {
          const h = f.split(out).filter(Boolean);
          if (h.length <= 0)
            return !1;
          const m = h[h.length - 1], g = d.pos + f.lastIndexOf(m);
          if (!m)
            return !1;
          const v = OO(m).map((y) => y.toObject(n.defaultProtocol));
          if (!cut(v))
            return !1;
          v.filter((y) => y.isLink).map((y) => ({
            ...y,
            from: g + y.start + 1,
            to: g + y.end + 1
          })).filter((y) => r.schema.marks.code ? !r.doc.rangeHasMark(y.from, y.to, r.schema.marks.code) : !0).filter((y) => n.validate(y.value)).filter((y) => n.shouldAutoLink(y.value)).forEach((y) => {
            hO(y.from, y.to, r.doc).some((b) => b.mark.type === n.type) || o.addMark(
              y.from,
              y.to,
              n.type.create({
                href: y.href
              })
            );
          });
        }
      }), !!o.steps.length)
        return o;
    }
  });
}
function dut(n) {
  return new Cn({
    key: new _n("handleClickLink"),
    props: {
      handleClick: (e, t, r) => {
        var i, s;
        if (r.button !== 0 || !e.editable)
          return !1;
        let o = null;
        if (r.target instanceof HTMLAnchorElement)
          o = r.target;
        else {
          let u = r.target;
          const d = [];
          for (; u.nodeName !== "DIV"; )
            d.push(u), u = u.parentNode;
          o = d.find((f) => f.nodeName === "A");
        }
        if (!o)
          return !1;
        const a = uoe(e.state, n.type.name), l = (i = o?.href) != null ? i : a.href, c = (s = o?.target) != null ? s : a.target;
        return n.enableClickSelection && n.editor.commands.extendMarkRange(n.type.name), o && l ? (window.open(l, c), !0) : !1;
      }
    }
  });
}
function fut(n) {
  return new Cn({
    key: new _n("handlePasteLink"),
    props: {
      handlePaste: (e, t, r) => {
        const { shouldAutoLink: i } = n, { state: s } = e, { selection: o } = s, { empty: a } = o;
        if (a)
          return !1;
        let l = "";
        r.content.forEach((u) => {
          l += u.textContent;
        });
        const c = uae(l, { defaultProtocol: n.defaultProtocol }).find(
          (u) => u.isLink && u.value === l
        );
        return !l || !c || i !== void 0 && !i(c.href) ? !1 : n.editor.commands.setMark(n.type, {
          href: c.href
        });
      }
    }
  });
}
function Gc(n, e) {
  const t = ["http", "https", "ftp", "ftps", "mailto", "tel", "callto", "sms", "cid", "xmpp"];
  return e && e.forEach((r) => {
    const i = typeof r == "string" ? r : r.scheme;
    i && t.push(i);
  }), !n || n.replace(lut, "").match(
    new RegExp(
      // eslint-disable-next-line no-useless-escape
      `^(?:(?:${t.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
      "i"
    )
  );
}
var hut = Lc.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((n) => {
      if (typeof n == "string") {
        KV(n);
        return;
      }
      KV(n.scheme, n.optionalSlashes);
    });
  },
  onDestroy() {
    iut();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      enableClickSelection: !1,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (n, e) => !!Gc(n, e.protocols),
      validate: (n) => !!n,
      shouldAutoLink: (n) => !!n
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(n) {
          return n.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (n) => {
          const e = n.getAttribute("href");
          return !e || !this.options.isAllowedUri(e, {
            defaultValidate: (t) => !!Gc(t, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return this.options.isAllowedUri(n.href, {
      defaultValidate: (e) => !!Gc(e, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", Zn(this.options.HTMLAttributes, n), 0] : ["a", Zn(this.options.HTMLAttributes, { ...n, href: "" }), 0];
  },
  markdownTokenName: "link",
  parseMarkdown: (n, e) => e.applyMark("link", e.parseInline(n.tokens || []), {
    href: n.href,
    title: n.title || null
  }),
  renderMarkdown: (n, e) => {
    var t;
    const r = ((t = n.attrs) == null ? void 0 : t.href) || "";
    return `[${e.renderChildren(n)}](${r})`;
  },
  addCommands() {
    return {
      setLink: (n) => ({ chain: e }) => {
        const { href: t } = n;
        return this.options.isAllowedUri(t, {
          defaultValidate: (r) => !!Gc(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().setMark(this.name, n).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (n) => ({ chain: e }) => {
        const { href: t } = n || {};
        return t && !this.options.isAllowedUri(t, {
          defaultValidate: (r) => !!Gc(r, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? !1 : e().toggleMark(this.name, n, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run();
      },
      unsetLink: () => ({ chain: n }) => n().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      Wu({
        find: (n) => {
          const e = [];
          if (n) {
            const { protocols: t, defaultProtocol: r } = this.options, i = uae(n).filter(
              (s) => s.isLink && this.options.isAllowedUri(s.value, {
                defaultValidate: (o) => !!Gc(o, t),
                protocols: t,
                defaultProtocol: r
              })
            );
            i.length && i.forEach((s) => {
              this.options.shouldAutoLink(s.value) && e.push({
                text: s.value,
                data: {
                  href: s.href
                },
                index: s.start
              });
            });
          }
          return e;
        },
        type: this.type,
        getAttributes: (n) => {
          var e;
          return {
            href: (e = n.data) == null ? void 0 : e.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const n = [], { protocols: e, defaultProtocol: t } = this.options;
    return this.options.autolink && n.push(
      uut({
        type: this.type,
        defaultProtocol: this.options.defaultProtocol,
        validate: (r) => this.options.isAllowedUri(r, {
          defaultValidate: (i) => !!Gc(i, e),
          protocols: e,
          defaultProtocol: t
        }),
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), this.options.openOnClick === !0 && n.push(
      dut({
        type: this.type,
        editor: this.editor,
        enableClickSelection: this.options.enableClickSelection
      })
    ), this.options.linkOnPaste && n.push(
      fut({
        editor: this.editor,
        defaultProtocol: this.options.defaultProtocol,
        type: this.type,
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), n;
  }
}), put = Object.defineProperty, mut = (n, e) => {
  for (var t in e)
    put(n, t, { get: e[t], enumerable: !0 });
}, gut = "listItem", qV = "textStyle", YV = /^\s*([-+*])\s$/, dae = Yi.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [{ tag: "ul" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["ul", Zn(this.options.HTMLAttributes, n), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (n, e) => n.type !== "list" || n.ordered ? [] : {
    type: "bulletList",
    content: n.items ? e.parseChildren(n.items) : []
  },
  renderMarkdown: (n, e) => n.content ? e.renderChildren(n.content, `
`) : "",
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(gut, this.editor.getAttributes(qV)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let n = lh({
      find: YV,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = lh({
      find: YV,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(qV),
      editor: this.editor
    })), [n];
  }
}), fae = Yi.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["li", Zn(this.options.HTMLAttributes, n), 0];
  },
  markdownTokenName: "list_item",
  parseMarkdown: (n, e) => {
    if (n.type !== "list_item")
      return [];
    let t = [];
    if (n.tokens && n.tokens.length > 0)
      if (n.tokens.some((i) => i.type === "paragraph"))
        t = e.parseChildren(n.tokens);
      else {
        const i = n.tokens[0];
        if (i && i.type === "text" && i.tokens && i.tokens.length > 0) {
          if (t = [
            {
              type: "paragraph",
              content: e.parseInline(i.tokens)
            }
          ], n.tokens.length > 1) {
            const o = n.tokens.slice(1), a = e.parseChildren(o);
            t.push(...a);
          }
        } else
          t = e.parseChildren(n.tokens);
      }
    return t.length === 0 && (t = [
      {
        type: "paragraph",
        content: []
      }
    ]), {
      type: "listItem",
      content: t
    };
  },
  renderMarkdown: (n, e, t) => vO(
    n,
    e,
    (r) => r.parentType === "bulletList" ? "- " : r.parentType === "orderedList" ? `${r.index + 1}. ` : "- ",
    t
  ),
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), vut = {};
mut(vut, {
  findListItemPos: () => H1,
  getNextListDepth: () => RO,
  handleBackspace: () => E9,
  handleDelete: () => S9,
  hasListBefore: () => hae,
  hasListItemAfter: () => yut,
  hasListItemBefore: () => pae,
  listItemHasSubList: () => mae,
  nextListIsDeeper: () => gae,
  nextListIsHigher: () => vae
});
var H1 = (n, e) => {
  const { $from: t } = e.selection, r = fr(n, e.schema);
  let i = null, s = t.depth, o = t.pos, a = null;
  for (; s > 0 && a === null; )
    i = t.node(s), i.type === r ? a = s : (s -= 1, o -= 1);
  return a === null ? null : { $pos: e.doc.resolve(o), depth: a };
}, RO = (n, e) => {
  const t = H1(n, e);
  if (!t)
    return !1;
  const [, r] = zot(e, n, t.$pos.pos + 4);
  return r;
}, hae = (n, e, t) => {
  const { $anchor: r } = n.selection, i = Math.max(0, r.pos - 2), s = n.doc.resolve(i).node();
  return !(!s || !t.includes(s.type.name));
}, pae = (n, e) => {
  var t;
  const { $anchor: r } = e.selection, i = e.doc.resolve(r.pos - 2);
  return !(i.index() === 0 || ((t = i.nodeBefore) == null ? void 0 : t.type.name) !== n);
}, mae = (n, e, t) => {
  if (!t)
    return !1;
  const r = fr(n, e.schema);
  let i = !1;
  return t.descendants((s) => {
    s.type === r && (i = !0);
  }), i;
}, E9 = (n, e, t) => {
  if (n.commands.undoInputRule())
    return !0;
  if (n.state.selection.from !== n.state.selection.to)
    return !1;
  if (!yc(n.state, e) && hae(n.state, e, t)) {
    const { $anchor: a } = n.state.selection, l = n.state.doc.resolve(a.before() - 1), c = [];
    l.node().descendants((f, h) => {
      f.type.name === e && c.push({ node: f, pos: h });
    });
    const u = c.at(-1);
    if (!u)
      return !1;
    const d = n.state.doc.resolve(l.start() + u.pos + 1);
    return n.chain().cut({ from: a.start() - 1, to: a.end() + 1 }, d.end()).joinForward().run();
  }
  if (!yc(n.state, e) || !jot(n.state))
    return !1;
  const r = H1(e, n.state);
  if (!r)
    return !1;
  const s = n.state.doc.resolve(r.$pos.pos - 2).node(r.depth), o = mae(e, n.state, s);
  return pae(e, n.state) && !o ? n.commands.joinItemBackward() : n.chain().liftListItem(e).run();
}, gae = (n, e) => {
  const t = RO(n, e), r = H1(n, e);
  return !r || !t ? !1 : t > r.depth;
}, vae = (n, e) => {
  const t = RO(n, e), r = H1(n, e);
  return !r || !t ? !1 : t < r.depth;
}, S9 = (n, e) => {
  if (!yc(n.state, e) || !Vot(n.state, e))
    return !1;
  const { selection: t } = n.state, { $from: r, $to: i } = t;
  return !t.empty && r.sameParent(i) ? !1 : gae(e, n.state) ? n.chain().focus(n.state.selection.from + 4).lift(e).joinBackward().run() : vae(e, n.state) ? n.chain().joinForward().joinBackward().run() : n.commands.joinItemForward();
}, yut = (n, e) => {
  var t;
  const { $anchor: r } = e.selection, i = e.doc.resolve(r.pos - r.parentOffset - 2);
  return !(i.index() === i.parent.childCount - 1 || ((t = i.nodeAfter) == null ? void 0 : t.type.name) !== n);
}, yae = qt.create({
  name: "listKeymap",
  addOptions() {
    return {
      listTypes: [
        {
          itemName: "listItem",
          wrapperNames: ["bulletList", "orderedList"]
        },
        {
          itemName: "taskItem",
          wrapperNames: ["taskList"]
        }
      ]
    };
  },
  addKeyboardShortcuts() {
    return {
      Delete: ({ editor: n }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: t }) => {
          n.state.schema.nodes[t] !== void 0 && S9(n, t) && (e = !0);
        }), e;
      },
      "Mod-Delete": ({ editor: n }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: t }) => {
          n.state.schema.nodes[t] !== void 0 && S9(n, t) && (e = !0);
        }), e;
      },
      Backspace: ({ editor: n }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: t, wrapperNames: r }) => {
          n.state.schema.nodes[t] !== void 0 && E9(n, t, r) && (e = !0);
        }), e;
      },
      "Mod-Backspace": ({ editor: n }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: t, wrapperNames: r }) => {
          n.state.schema.nodes[t] !== void 0 && E9(n, t, r) && (e = !0);
        }), e;
      }
    };
  }
}), XV = /^(\s*)(\d+)\.\s+(.*)$/, but = /^\s/;
function wut(n) {
  const e = [];
  let t = 0, r = 0;
  for (; t < n.length; ) {
    const i = n[t], s = i.match(XV);
    if (!s)
      break;
    const [, o, a, l] = s, c = o.length;
    let u = l, d = t + 1;
    const f = [i];
    for (; d < n.length; ) {
      const h = n[d];
      if (h.match(XV))
        break;
      if (h.trim() === "")
        f.push(h), u += `
`, d += 1;
      else if (h.match(but))
        f.push(h), u += `
${h.slice(c + 2)}`, d += 1;
      else
        break;
    }
    e.push({
      indent: c,
      number: parseInt(a, 10),
      content: u.trim(),
      raw: f.join(`
`)
    }), r = d, t = d;
  }
  return [e, r];
}
function bae(n, e, t) {
  var r;
  const i = [];
  let s = 0;
  for (; s < n.length; ) {
    const o = n[s];
    if (o.indent === e) {
      const a = o.content.split(`
`), l = ((r = a[0]) == null ? void 0 : r.trim()) || "", c = [];
      l && c.push({
        type: "paragraph",
        raw: l,
        tokens: t.inlineTokens(l)
      });
      const u = a.slice(1).join(`
`).trim();
      if (u) {
        const h = t.blockTokens(u);
        c.push(...h);
      }
      let d = s + 1;
      const f = [];
      for (; d < n.length && n[d].indent > e; )
        f.push(n[d]), d += 1;
      if (f.length > 0) {
        const h = Math.min(...f.map((g) => g.indent)), m = bae(f, h, t);
        c.push({
          type: "list",
          ordered: !0,
          start: f[0].number,
          items: m,
          raw: f.map((g) => g.raw).join(`
`)
        });
      }
      i.push({
        type: "list_item",
        raw: o.raw,
        tokens: c
      }), s = d;
    } else
      s += 1;
  }
  return i;
}
function xut(n, e) {
  return n.map((t) => {
    if (t.type !== "list_item")
      return e.parseChildren([t])[0];
    const r = [];
    return t.tokens && t.tokens.length > 0 && t.tokens.forEach((i) => {
      if (i.type === "paragraph" || i.type === "list" || i.type === "blockquote" || i.type === "code")
        r.push(...e.parseChildren([i]));
      else if (i.type === "text" && i.tokens) {
        const s = e.parseChildren([i]);
        r.push({
          type: "paragraph",
          content: s
        });
      } else {
        const s = e.parseChildren([i]);
        s.length > 0 && r.push(...s);
      }
    }), {
      type: "listItem",
      content: r
    };
  });
}
var Eut = "listItem", ZV = "textStyle", QV = /^(\d+)\.\s$/, wae = Yi.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (n) => n.hasAttribute("start") ? parseInt(n.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (n) => n.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    const { start: e, ...t } = n;
    return e === 1 ? ["ol", Zn(this.options.HTMLAttributes, t), 0] : ["ol", Zn(this.options.HTMLAttributes, n), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (n, e) => {
    if (n.type !== "list" || !n.ordered)
      return [];
    const t = n.start || 1, r = n.items ? xut(n.items, e) : [];
    return t !== 1 ? {
      type: "orderedList",
      attrs: { start: t },
      content: r
    } : {
      type: "orderedList",
      content: r
    };
  },
  renderMarkdown: (n, e) => n.content ? e.renderChildren(n.content, `
`) : "",
  markdownTokenizer: {
    name: "orderedList",
    level: "block",
    start: (n) => {
      const e = n.match(/^(\s*)(\d+)\.\s+/), t = e?.index;
      return t !== void 0 ? t : -1;
    },
    tokenize: (n, e, t) => {
      var r;
      const i = n.split(`
`), [s, o] = wut(i);
      if (s.length === 0)
        return;
      const a = bae(s, 0, t);
      return a.length === 0 ? void 0 : {
        type: "list",
        ordered: !0,
        start: ((r = s[0]) == null ? void 0 : r.number) || 1,
        items: a,
        raw: i.slice(0, o).join(`
`)
      };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: n, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(Eut, this.editor.getAttributes(ZV)).run() : n.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let n = lh({
      find: QV,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (n = lh({
      find: QV,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes(ZV) }),
      joinPredicate: (e, t) => t.childCount + t.attrs.start === +e[1],
      editor: this.editor
    })), [n];
  }
}), Sut = /^\s*(\[([( |x])?\])\s$/, Cut = Yi.create({
  name: "taskItem",
  addOptions() {
    return {
      nested: !1,
      HTMLAttributes: {},
      taskListTypeName: "taskList",
      a11y: void 0
    };
  },
  content() {
    return this.options.nested ? "paragraph block*" : "paragraph+";
  },
  defining: !0,
  addAttributes() {
    return {
      checked: {
        default: !1,
        keepOnSplit: !1,
        parseHTML: (n) => {
          const e = n.getAttribute("data-checked");
          return e === "" || e === "true";
        },
        renderHTML: (n) => ({
          "data-checked": n.checked
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: `li[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ node: n, HTMLAttributes: e }) {
    return [
      "li",
      Zn(this.options.HTMLAttributes, e, {
        "data-type": this.name
      }),
      [
        "label",
        [
          "input",
          {
            type: "checkbox",
            checked: n.attrs.checked ? "checked" : null
          }
        ],
        ["span"]
      ],
      ["div", 0]
    ];
  },
  parseMarkdown: (n, e) => {
    const t = [];
    if (n.tokens && n.tokens.length > 0 ? t.push(e.createNode("paragraph", {}, e.parseInline(n.tokens))) : n.text ? t.push(e.createNode("paragraph", {}, [e.createNode("text", { text: n.text })])) : t.push(e.createNode("paragraph", {}, [])), n.nestedTokens && n.nestedTokens.length > 0) {
      const r = e.parseChildren(n.nestedTokens);
      t.push(...r);
    }
    return e.createNode("taskItem", { checked: n.checked || !1 }, t);
  },
  renderMarkdown: (n, e) => {
    var t;
    const i = `- [${(t = n.attrs) != null && t.checked ? "x" : " "}] `;
    return vO(n, e, i);
  },
  addKeyboardShortcuts() {
    const n = {
      Enter: () => this.editor.commands.splitListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
    return this.options.nested ? {
      ...n,
      Tab: () => this.editor.commands.sinkListItem(this.name)
    } : n;
  },
  addNodeView() {
    return ({ node: n, HTMLAttributes: e, getPos: t, editor: r }) => {
      const i = document.createElement("li"), s = document.createElement("label"), o = document.createElement("span"), a = document.createElement("input"), l = document.createElement("div"), c = (u) => {
        var d, f;
        a.ariaLabel = ((f = (d = this.options.a11y) == null ? void 0 : d.checkboxLabel) == null ? void 0 : f.call(d, u, a.checked)) || `Task item checkbox for ${u.textContent || "empty task item"}`;
      };
      return c(n), s.contentEditable = "false", a.type = "checkbox", a.addEventListener("mousedown", (u) => u.preventDefault()), a.addEventListener("change", (u) => {
        if (!r.isEditable && !this.options.onReadOnlyChecked) {
          a.checked = !a.checked;
          return;
        }
        const { checked: d } = u.target;
        r.isEditable && typeof t == "function" && r.chain().focus(void 0, { scrollIntoView: !1 }).command(({ tr: f }) => {
          const h = t();
          if (typeof h != "number")
            return !1;
          const m = f.doc.nodeAt(h);
          return f.setNodeMarkup(h, void 0, {
            ...m?.attrs,
            checked: d
          }), !0;
        }).run(), !r.isEditable && this.options.onReadOnlyChecked && (this.options.onReadOnlyChecked(n, d) || (a.checked = !a.checked));
      }), Object.entries(this.options.HTMLAttributes).forEach(([u, d]) => {
        i.setAttribute(u, d);
      }), i.dataset.checked = n.attrs.checked, a.checked = n.attrs.checked, s.append(a, o), i.append(s, l), Object.entries(e).forEach(([u, d]) => {
        i.setAttribute(u, d);
      }), {
        dom: i,
        contentDOM: l,
        update: (u) => u.type !== this.type ? !1 : (i.dataset.checked = u.attrs.checked, a.checked = u.attrs.checked, c(u), !0)
      };
    };
  },
  addInputRules() {
    return [
      lh({
        find: Sut,
        type: this.type,
        getAttributes: (n) => ({
          checked: n[n.length - 1] === "x"
        })
      })
    ];
  }
}), Tut = Yi.create({
  name: "taskList",
  addOptions() {
    return {
      itemTypeName: "taskItem",
      HTMLAttributes: {}
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      {
        tag: `ul[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["ul", Zn(this.options.HTMLAttributes, n, { "data-type": this.name }), 0];
  },
  parseMarkdown: (n, e) => e.createNode("taskList", {}, e.parseChildren(n.items || [])),
  renderMarkdown: (n, e) => n.content ? e.renderChildren(n.content, `
`) : "",
  markdownTokenizer: {
    name: "taskList",
    level: "block",
    start(n) {
      var e;
      const t = (e = n.match(/^\s*[-+*]\s+\[([ xX])\]\s+/)) == null ? void 0 : e.index;
      return t !== void 0 ? t : -1;
    },
    tokenize(n, e, t) {
      const r = (s) => {
        const o = l9(
          s,
          {
            itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
            extractItemData: (a) => ({
              indentLevel: a[1].length,
              mainContent: a[4],
              checked: a[3].toLowerCase() === "x"
            }),
            createToken: (a, l) => ({
              type: "taskItem",
              raw: "",
              mainContent: a.mainContent,
              indentLevel: a.indentLevel,
              checked: a.checked,
              text: a.mainContent,
              tokens: t.inlineTokens(a.mainContent),
              nestedTokens: l
            }),
            // Allow recursive nesting
            customNestedParser: r
          },
          t
        );
        return o ? [
          {
            type: "taskList",
            raw: o.raw,
            items: o.items
          }
        ] : t.blockTokens(s);
      }, i = l9(
        n,
        {
          itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
          extractItemData: (s) => ({
            indentLevel: s[1].length,
            mainContent: s[4],
            checked: s[3].toLowerCase() === "x"
          }),
          createToken: (s, o) => ({
            type: "taskItem",
            raw: "",
            mainContent: s.mainContent,
            indentLevel: s.indentLevel,
            checked: s.checked,
            text: s.mainContent,
            tokens: t.inlineTokens(s.mainContent),
            nestedTokens: o
          }),
          // Use the recursive parser for nested content
          customNestedParser: r
        },
        t
      );
      if (i)
        return {
          type: "taskList",
          raw: i.raw,
          items: i.items
        };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleTaskList: () => ({ commands: n }) => n.toggleList(this.name, this.options.itemTypeName)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-9": () => this.editor.commands.toggleTaskList()
    };
  }
});
qt.create({
  name: "listKit",
  addExtensions() {
    const n = [];
    return this.options.bulletList !== !1 && n.push(dae.configure(this.options.bulletList)), this.options.listItem !== !1 && n.push(fae.configure(this.options.listItem)), this.options.listKeymap !== !1 && n.push(yae.configure(this.options.listKeymap)), this.options.orderedList !== !1 && n.push(wae.configure(this.options.orderedList)), this.options.taskItem !== !1 && n.push(Cut.configure(this.options.taskItem)), this.options.taskList !== !1 && n.push(Tut.configure(this.options.taskList)), n;
  }
});
var Aut = Yi.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [{ tag: "p" }];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["p", Zn(this.options.HTMLAttributes, n), 0];
  },
  parseMarkdown: (n, e) => {
    const t = n.tokens || [];
    return t.length === 1 && t[0].type === "image" ? e.parseChildren([t[0]]) : e.createNode(
      "paragraph",
      void 0,
      // no attributes for paragraph
      e.parseInline(t)
    );
  },
  renderMarkdown: (n, e) => !n || !Array.isArray(n.content) ? "" : e.renderChildren(n.content),
  addCommands() {
    return {
      setParagraph: () => ({ commands: n }) => n.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), Mut = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, kut = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, _ut = Lc.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["s", Zn(this.options.HTMLAttributes, n), 0];
  },
  markdownTokenName: "del",
  parseMarkdown: (n, e) => e.applyMark("strike", e.parseInline(n.tokens || [])),
  renderMarkdown: (n, e) => `~~${e.renderChildren(n)}~~`,
  addCommands() {
    return {
      setStrike: () => ({ commands: n }) => n.setMark(this.name),
      toggleStrike: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetStrike: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      ah({
        find: Mut,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Wu({
        find: kut,
        type: this.type
      })
    ];
  }
}), Out = Yi.create({
  name: "text",
  group: "inline",
  parseMarkdown: (n) => ({
    type: "text",
    text: n.text || ""
  }),
  renderMarkdown: (n) => n.text || ""
}), Iut = Lc.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (n) => n.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["u", Zn(this.options.HTMLAttributes, n), 0];
  },
  parseMarkdown(n, e) {
    return e.applyMark(this.name || "underline", e.parseInline(n.tokens || []));
  },
  renderMarkdown(n, e) {
    return `++${e.renderChildren(n)}++`;
  },
  markdownTokenizer: {
    name: "underline",
    level: "inline",
    start(n) {
      return n.indexOf("++");
    },
    tokenize(n, e, t) {
      const i = /^(\+\+)([\s\S]+?)(\+\+)/.exec(n);
      if (!i)
        return;
      const s = i[2].trim();
      return {
        type: "underline",
        raw: i[0],
        text: s,
        tokens: t.inlineTokens(s)
      };
    }
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: n }) => n.setMark(this.name),
      toggleUnderline: () => ({ commands: n }) => n.toggleMark(this.name),
      unsetUnderline: () => ({ commands: n }) => n.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
});
function Rut(n = {}) {
  return new Cn({
    view(e) {
      return new Put(e, n);
    }
  });
}
class Put {
  constructor(e, t) {
    var r;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (r = t.width) !== null && r !== void 0 ? r : 1, this.color = t.color === !1 ? void 0 : t.color || "black", this.class = t.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((i) => {
      let s = (o) => {
        this[i](o);
      };
      return e.dom.addEventListener(i, s), { name: i, handler: s };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: t }) => this.editorView.dom.removeEventListener(e, t));
  }
  update(e, t) {
    this.cursorPos != null && t.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), t = !e.parent.inlineContent, r, i = this.editorView.dom, s = i.getBoundingClientRect(), o = s.width / i.offsetWidth, a = s.height / i.offsetHeight;
    if (t) {
      let d = e.nodeBefore, f = e.nodeAfter;
      if (d || f) {
        let h = this.editorView.nodeDOM(this.cursorPos - (d ? d.nodeSize : 0));
        if (h) {
          let m = h.getBoundingClientRect(), g = d ? m.bottom : m.top;
          d && f && (g = (g + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2);
          let v = this.width / 2 * a;
          r = { left: m.left, right: m.right, top: g - v, bottom: g + v };
        }
      }
    }
    if (!r) {
      let d = this.editorView.coordsAtPos(this.cursorPos), f = this.width / 2 * o;
      r = { left: d.left - f, right: d.left + f, top: d.top, bottom: d.bottom };
    }
    let l = this.editorView.dom.offsetParent;
    this.element || (this.element = l.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", t), this.element.classList.toggle("prosemirror-dropcursor-inline", !t);
    let c, u;
    if (!l || l == document.body && getComputedStyle(l).position == "static")
      c = -pageXOffset, u = -pageYOffset;
    else {
      let d = l.getBoundingClientRect(), f = d.width / l.offsetWidth, h = d.height / l.offsetHeight;
      c = d.left - l.scrollLeft * f, u = d.top - l.scrollTop * h;
    }
    this.element.style.left = (r.left - c) / o + "px", this.element.style.top = (r.top - u) / a + "px", this.element.style.width = (r.right - r.left) / o + "px", this.element.style.height = (r.bottom - r.top) / a + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let t = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), r = t && t.inside >= 0 && this.editorView.state.doc.nodeAt(t.inside), i = r && r.type.spec.disableDropCursor, s = typeof i == "function" ? i(this.editorView, t, e) : i;
    if (t && !s) {
      let o = t.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let a = Kie(this.editorView.state.doc, o, this.editorView.dragging.slice);
        a != null && (o = a);
      }
      this.setCursor(o), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    this.editorView.dom.contains(e.relatedTarget) || this.setCursor(null);
  }
}
class Yn extends pt {
  /**
  Create a gap cursor.
  */
  constructor(e) {
    super(e, e);
  }
  map(e, t) {
    let r = e.resolve(t.map(this.head));
    return Yn.valid(r) ? new Yn(r) : pt.near(r);
  }
  content() {
    return Fe.empty;
  }
  eq(e) {
    return e instanceof Yn && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, t) {
    if (typeof t.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new Yn(e.resolve(t.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new PO(this.anchor);
  }
  /**
  @internal
  */
  static valid(e) {
    let t = e.parent;
    if (t.isTextblock || !Dut(e) || !Nut(e))
      return !1;
    let r = t.type.spec.allowGapCursor;
    if (r != null)
      return r;
    let i = t.contentMatchAt(e.index()).defaultType;
    return i && i.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(e, t, r = !1) {
    e: for (; ; ) {
      if (!r && Yn.valid(e))
        return e;
      let i = e.pos, s = null;
      for (let o = e.depth; ; o--) {
        let a = e.node(o);
        if (t > 0 ? e.indexAfter(o) < a.childCount : e.index(o) > 0) {
          s = a.child(t > 0 ? e.indexAfter(o) : e.index(o) - 1);
          break;
        } else if (o == 0)
          return null;
        i += t;
        let l = e.doc.resolve(i);
        if (Yn.valid(l))
          return l;
      }
      for (; ; ) {
        let o = t > 0 ? s.firstChild : s.lastChild;
        if (!o) {
          if (s.isAtom && !s.isText && !nt.isSelectable(s)) {
            e = e.doc.resolve(i + s.nodeSize * t), r = !1;
            continue e;
          }
          break;
        }
        s = o, i += t;
        let a = e.doc.resolve(i);
        if (Yn.valid(a))
          return a;
      }
      return null;
    }
  }
}
Yn.prototype.visible = !1;
Yn.findFrom = Yn.findGapCursorFrom;
pt.jsonID("gapcursor", Yn);
class PO {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new PO(e.map(this.pos));
  }
  resolve(e) {
    let t = e.resolve(this.pos);
    return Yn.valid(t) ? new Yn(t) : pt.near(t);
  }
}
function xae(n) {
  return n.isAtom || n.spec.isolating || n.spec.createGapCursor;
}
function Dut(n) {
  for (let e = n.depth; e >= 0; e--) {
    let t = n.index(e), r = n.node(e);
    if (t == 0) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(t - 1); ; i = i.lastChild) {
      if (i.childCount == 0 && !i.inlineContent || xae(i.type))
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function Nut(n) {
  for (let e = n.depth; e >= 0; e--) {
    let t = n.indexAfter(e), r = n.node(e);
    if (t == r.childCount) {
      if (r.type.spec.isolating)
        return !0;
      continue;
    }
    for (let i = r.child(t); ; i = i.firstChild) {
      if (i.childCount == 0 && !i.inlineContent || xae(i.type))
        return !0;
      if (i.inlineContent)
        return !1;
    }
  }
  return !0;
}
function Lut() {
  return new Cn({
    props: {
      decorations: zut,
      createSelectionBetween(n, e, t) {
        return e.pos == t.pos && Yn.valid(t) ? new Yn(t) : null;
      },
      handleClick: Fut,
      handleKeyDown: $ut,
      handleDOMEvents: { beforeinput: But }
    }
  });
}
const $ut = iO({
  ArrowLeft: lv("horiz", -1),
  ArrowRight: lv("horiz", 1),
  ArrowUp: lv("vert", -1),
  ArrowDown: lv("vert", 1)
});
function lv(n, e) {
  const t = n == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(r, i, s) {
    let o = r.selection, a = e > 0 ? o.$to : o.$from, l = o.empty;
    if (o instanceof vt) {
      if (!s.endOfTextblock(t) || a.depth == 0)
        return !1;
      l = !1, a = r.doc.resolve(e > 0 ? a.after() : a.before());
    }
    let c = Yn.findGapCursorFrom(a, e, l);
    return c ? (i && i(r.tr.setSelection(new Yn(c))), !0) : !1;
  };
}
function Fut(n, e, t) {
  if (!n || !n.editable)
    return !1;
  let r = n.state.doc.resolve(e);
  if (!Yn.valid(r))
    return !1;
  let i = n.posAtCoords({ left: t.clientX, top: t.clientY });
  return i && i.inside > -1 && nt.isSelectable(n.state.doc.nodeAt(i.inside)) ? !1 : (n.dispatch(n.state.tr.setSelection(new Yn(r))), !0);
}
function But(n, e) {
  if (e.inputType != "insertCompositionText" || !(n.state.selection instanceof Yn))
    return !1;
  let { $from: t } = n.state.selection, r = t.parent.contentMatchAt(t.index()).findWrapping(n.state.schema.nodes.text);
  if (!r)
    return !1;
  let i = Ee.empty;
  for (let o = r.length - 1; o >= 0; o--)
    i = Ee.from(r[o].createAndFill(null, i));
  let s = n.state.tr.replace(t.pos, t.pos, new Fe(i, 0, 0));
  return s.setSelection(vt.near(s.doc.resolve(t.pos + 1))), n.dispatch(s), !1;
}
function zut(n) {
  if (!(n.selection instanceof Yn))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", Nn.create(n.doc, [Ro.widget(n.selection.head, e, { key: "gapcursor" })]);
}
var Lb = 200, Ir = function() {
};
Ir.prototype.append = function(e) {
  return e.length ? (e = Ir.from(e), !this.length && e || e.length < Lb && this.leafAppend(e) || this.length < Lb && e.leafPrepend(this) || this.appendInner(e)) : this;
};
Ir.prototype.prepend = function(e) {
  return e.length ? Ir.from(e).append(this) : this;
};
Ir.prototype.appendInner = function(e) {
  return new Hut(this, e);
};
Ir.prototype.slice = function(e, t) {
  return e === void 0 && (e = 0), t === void 0 && (t = this.length), e >= t ? Ir.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, t));
};
Ir.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
Ir.prototype.forEach = function(e, t, r) {
  t === void 0 && (t = 0), r === void 0 && (r = this.length), t <= r ? this.forEachInner(e, t, r, 0) : this.forEachInvertedInner(e, t, r, 0);
};
Ir.prototype.map = function(e, t, r) {
  t === void 0 && (t = 0), r === void 0 && (r = this.length);
  var i = [];
  return this.forEach(function(s, o) {
    return i.push(e(s, o));
  }, t, r), i;
};
Ir.from = function(e) {
  return e instanceof Ir ? e : e && e.length ? new Eae(e) : Ir.empty;
};
var Eae = /* @__PURE__ */ (function(n) {
  function e(r) {
    n.call(this), this.values = r;
  }
  n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e;
  var t = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(i, s) {
    return i == 0 && s == this.length ? this : new e(this.values.slice(i, s));
  }, e.prototype.getInner = function(i) {
    return this.values[i];
  }, e.prototype.forEachInner = function(i, s, o, a) {
    for (var l = s; l < o; l++)
      if (i(this.values[l], a + l) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(i, s, o, a) {
    for (var l = s - 1; l >= o; l--)
      if (i(this.values[l], a + l) === !1)
        return !1;
  }, e.prototype.leafAppend = function(i) {
    if (this.length + i.length <= Lb)
      return new e(this.values.concat(i.flatten()));
  }, e.prototype.leafPrepend = function(i) {
    if (this.length + i.length <= Lb)
      return new e(i.flatten().concat(this.values));
  }, t.length.get = function() {
    return this.values.length;
  }, t.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, t), e;
})(Ir);
Ir.empty = new Eae([]);
var Hut = /* @__PURE__ */ (function(n) {
  function e(t, r) {
    n.call(this), this.left = t, this.right = r, this.length = t.length + r.length, this.depth = Math.max(t.depth, r.depth) + 1;
  }
  return n && (e.__proto__ = n), e.prototype = Object.create(n && n.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(r) {
    return r < this.left.length ? this.left.get(r) : this.right.get(r - this.left.length);
  }, e.prototype.forEachInner = function(r, i, s, o) {
    var a = this.left.length;
    if (i < a && this.left.forEachInner(r, i, Math.min(s, a), o) === !1 || s > a && this.right.forEachInner(r, Math.max(i - a, 0), Math.min(this.length, s) - a, o + a) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(r, i, s, o) {
    var a = this.left.length;
    if (i > a && this.right.forEachInvertedInner(r, i - a, Math.max(s, a) - a, o + a) === !1 || s < a && this.left.forEachInvertedInner(r, Math.min(i, a), s, o) === !1)
      return !1;
  }, e.prototype.sliceInner = function(r, i) {
    if (r == 0 && i == this.length)
      return this;
    var s = this.left.length;
    return i <= s ? this.left.slice(r, i) : r >= s ? this.right.slice(r - s, i - s) : this.left.slice(r, s).append(this.right.slice(0, i - s));
  }, e.prototype.leafAppend = function(r) {
    var i = this.right.leafAppend(r);
    if (i)
      return new e(this.left, i);
  }, e.prototype.leafPrepend = function(r) {
    var i = this.left.leafPrepend(r);
    if (i)
      return new e(i, this.right);
  }, e.prototype.appendInner = function(r) {
    return this.left.depth >= Math.max(this.right.depth, r.depth) + 1 ? new e(this.left, new e(this.right, r)) : new e(this, r);
  }, e;
})(Ir);
const Uut = 500;
class lo {
  constructor(e, t) {
    this.items = e, this.eventCount = t;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, t) {
    if (this.eventCount == 0)
      return null;
    let r = this.items.length;
    for (; ; r--)
      if (this.items.get(r - 1).selection) {
        --r;
        break;
      }
    let i, s;
    t && (i = this.remapping(r, this.items.length), s = i.maps.length);
    let o = e.tr, a, l, c = [], u = [];
    return this.items.forEach((d, f) => {
      if (!d.step) {
        i || (i = this.remapping(r, f + 1), s = i.maps.length), s--, u.push(d);
        return;
      }
      if (i) {
        u.push(new Pl(d.map));
        let h = d.step.map(i.slice(s)), m;
        h && o.maybeStep(h).doc && (m = o.mapping.maps[o.mapping.maps.length - 1], c.push(new Pl(m, void 0, void 0, c.length + u.length))), s--, m && i.appendMap(m, s);
      } else
        o.maybeStep(d.step);
      if (d.selection)
        return a = i ? d.selection.map(i.slice(s)) : d.selection, l = new lo(this.items.slice(0, r).append(u.reverse().concat(c)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: l, transform: o, selection: a };
  }
  // Create a new branch with the given transform added.
  addTransform(e, t, r, i) {
    let s = [], o = this.eventCount, a = this.items, l = !i && a.length ? a.get(a.length - 1) : null;
    for (let u = 0; u < e.steps.length; u++) {
      let d = e.steps[u].invert(e.docs[u]), f = new Pl(e.mapping.maps[u], d, t), h;
      (h = l && l.merge(f)) && (f = h, u ? s.pop() : a = a.slice(0, a.length - 1)), s.push(f), t && (o++, t = void 0), i || (l = f);
    }
    let c = o - r.depth;
    return c > jut && (a = Vut(a, c), o -= c), new lo(a.append(s), o);
  }
  remapping(e, t) {
    let r = new D0();
    return this.items.forEach((i, s) => {
      let o = i.mirrorOffset != null && s - i.mirrorOffset >= e ? r.maps.length - i.mirrorOffset : void 0;
      r.appendMap(i.map, o);
    }, e, t), r;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new lo(this.items.append(e.map((t) => new Pl(t))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, t) {
    if (!this.eventCount)
      return this;
    let r = [], i = Math.max(0, this.items.length - t), s = e.mapping, o = e.steps.length, a = this.eventCount;
    this.items.forEach((f) => {
      f.selection && a--;
    }, i);
    let l = t;
    this.items.forEach((f) => {
      let h = s.getMirror(--l);
      if (h == null)
        return;
      o = Math.min(o, h);
      let m = s.maps[h];
      if (f.step) {
        let g = e.steps[h].invert(e.docs[h]), v = f.selection && f.selection.map(s.slice(l + 1, h));
        v && a++, r.push(new Pl(m, g, v));
      } else
        r.push(new Pl(m));
    }, i);
    let c = [];
    for (let f = t; f < o; f++)
      c.push(new Pl(s.maps[f]));
    let u = this.items.slice(0, i).append(c).append(r), d = new lo(u, a);
    return d.emptyItemCount() > Uut && (d = d.compress(this.items.length - r.length)), d;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((t) => {
      t.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let t = this.remapping(0, e), r = t.maps.length, i = [], s = 0;
    return this.items.forEach((o, a) => {
      if (a >= e)
        i.push(o), o.selection && s++;
      else if (o.step) {
        let l = o.step.map(t.slice(r)), c = l && l.getMap();
        if (r--, c && t.appendMap(c, r), l) {
          let u = o.selection && o.selection.map(t.slice(r));
          u && s++;
          let d = new Pl(c.invert(), l, u), f, h = i.length - 1;
          (f = i.length && i[h].merge(d)) ? i[h] = f : i.push(d);
        }
      } else o.map && r--;
    }, this.items.length, 0), new lo(Ir.from(i.reverse()), s);
  }
}
lo.empty = new lo(Ir.empty, 0);
function Vut(n, e) {
  let t;
  return n.forEach((r, i) => {
    if (r.selection && e-- == 0)
      return t = i, !1;
  }), n.slice(t);
}
let Pl = class Sae {
  constructor(e, t, r, i) {
    this.map = e, this.step = t, this.selection = r, this.mirrorOffset = i;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let t = e.step.merge(this.step);
      if (t)
        return new Sae(t.getMap().invert(), t, this.selection);
    }
  }
}, Ul = class {
  constructor(e, t, r, i, s) {
    this.done = e, this.undone = t, this.prevRanges = r, this.prevTime = i, this.prevComposition = s;
  }
};
const jut = 20;
function Wut(n, e, t, r) {
  let i = t.getMeta(Mu), s;
  if (i)
    return i.historyState;
  t.getMeta(qut) && (n = new Ul(n.done, n.undone, null, 0, -1));
  let o = t.getMeta("appendedTransaction");
  if (t.steps.length == 0)
    return n;
  if (o && o.getMeta(Mu))
    return o.getMeta(Mu).redo ? new Ul(n.done.addTransform(t, void 0, r, n2(e)), n.undone, JV(t.mapping.maps), n.prevTime, n.prevComposition) : new Ul(n.done, n.undone.addTransform(t, void 0, r, n2(e)), null, n.prevTime, n.prevComposition);
  if (t.getMeta("addToHistory") !== !1 && !(o && o.getMeta("addToHistory") === !1)) {
    let a = t.getMeta("composition"), l = n.prevTime == 0 || !o && n.prevComposition != a && (n.prevTime < (t.time || 0) - r.newGroupDelay || !Gut(t, n.prevRanges)), c = o ? C8(n.prevRanges, t.mapping) : JV(t.mapping.maps);
    return new Ul(n.done.addTransform(t, l ? e.selection.getBookmark() : void 0, r, n2(e)), lo.empty, c, t.time, a ?? n.prevComposition);
  } else return (s = t.getMeta("rebased")) ? new Ul(n.done.rebased(t, s), n.undone.rebased(t, s), C8(n.prevRanges, t.mapping), n.prevTime, n.prevComposition) : new Ul(n.done.addMaps(t.mapping.maps), n.undone.addMaps(t.mapping.maps), C8(n.prevRanges, t.mapping), n.prevTime, n.prevComposition);
}
function Gut(n, e) {
  if (!e)
    return !1;
  if (!n.docChanged)
    return !0;
  let t = !1;
  return n.mapping.maps[0].forEach((r, i) => {
    for (let s = 0; s < e.length; s += 2)
      r <= e[s + 1] && i >= e[s] && (t = !0);
  }), t;
}
function JV(n) {
  let e = [];
  for (let t = n.length - 1; t >= 0 && e.length == 0; t--)
    n[t].forEach((r, i, s, o) => e.push(s, o));
  return e;
}
function C8(n, e) {
  if (!n)
    return null;
  let t = [];
  for (let r = 0; r < n.length; r += 2) {
    let i = e.map(n[r], 1), s = e.map(n[r + 1], -1);
    i <= s && t.push(i, s);
  }
  return t;
}
function Kut(n, e, t) {
  let r = n2(e), i = Mu.get(e).spec.config, s = (t ? n.undone : n.done).popEvent(e, r);
  if (!s)
    return null;
  let o = s.selection.resolve(s.transform.doc), a = (t ? n.done : n.undone).addTransform(s.transform, e.selection.getBookmark(), i, r), l = new Ul(t ? a : s.remaining, t ? s.remaining : a, null, 0, -1);
  return s.transform.setSelection(o).setMeta(Mu, { redo: t, historyState: l });
}
let T8 = !1, ej = null;
function n2(n) {
  let e = n.plugins;
  if (ej != e) {
    T8 = !1, ej = e;
    for (let t = 0; t < e.length; t++)
      if (e[t].spec.historyPreserveItems) {
        T8 = !0;
        break;
      }
  }
  return T8;
}
const Mu = new _n("history"), qut = new _n("closeHistory");
function Yut(n = {}) {
  return n = {
    depth: n.depth || 100,
    newGroupDelay: n.newGroupDelay || 500
  }, new Cn({
    key: Mu,
    state: {
      init() {
        return new Ul(lo.empty, lo.empty, null, 0, -1);
      },
      apply(e, t, r) {
        return Wut(t, r, e, n);
      }
    },
    config: n,
    props: {
      handleDOMEvents: {
        beforeinput(e, t) {
          let r = t.inputType, i = r == "historyUndo" ? Tae : r == "historyRedo" ? Aae : null;
          return i ? (t.preventDefault(), i(e.state, e.dispatch)) : !1;
        }
      }
    }
  });
}
function Cae(n, e) {
  return (t, r) => {
    let i = Mu.getState(t);
    if (!i || (n ? i.undone : i.done).eventCount == 0)
      return !1;
    if (r) {
      let s = Kut(i, t, n);
      s && r(e ? s.scrollIntoView() : s);
    }
    return !0;
  };
}
const Tae = Cae(!1, !0), Aae = Cae(!0, !0);
qt.create({
  name: "characterCount",
  addOptions() {
    return {
      limit: null,
      mode: "textSize",
      textCounter: (n) => n.length,
      wordCounter: (n) => n.split(" ").filter((e) => e !== "").length
    };
  },
  addStorage() {
    return {
      characters: () => 0,
      words: () => 0
    };
  },
  onBeforeCreate() {
    this.storage.characters = (n) => {
      const e = n?.node || this.editor.state.doc;
      if ((n?.mode || this.options.mode) === "textSize") {
        const r = e.textBetween(0, e.content.size, void 0, " ");
        return this.options.textCounter(r);
      }
      return e.nodeSize;
    }, this.storage.words = (n) => {
      const e = n?.node || this.editor.state.doc, t = e.textBetween(0, e.content.size, " ", " ");
      return this.options.wordCounter(t);
    };
  },
  addProseMirrorPlugins() {
    let n = !1;
    return [
      new Cn({
        key: new _n("characterCount"),
        appendTransaction: (e, t, r) => {
          if (n)
            return;
          const i = this.options.limit;
          if (i == null || i === 0) {
            n = !0;
            return;
          }
          const s = this.storage.characters({ node: r.doc });
          if (s > i) {
            const o = s - i, a = 0, l = o;
            console.warn(
              `[CharacterCount] Initial content exceeded limit of ${i} characters. Content was automatically trimmed.`
            );
            const c = r.tr.deleteRange(a, l);
            return n = !0, c;
          }
          n = !0;
        },
        filterTransaction: (e, t) => {
          const r = this.options.limit;
          if (!e.docChanged || r === 0 || r === null || r === void 0)
            return !0;
          const i = this.storage.characters({ node: t.doc }), s = this.storage.characters({ node: e.doc });
          if (s <= r || i > r && s > r && s <= i)
            return !0;
          if (i > r && s > r && s > i || !e.getMeta("paste"))
            return !1;
          const a = e.selection.$head.pos, l = s - r, c = a - l, u = a;
          return e.deleteRange(c, u), !(this.storage.characters({ node: e.doc }) > r);
        }
      })
    ];
  }
});
var Xut = qt.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [Rut(this.options)];
  }
});
qt.create({
  name: "focus",
  addOptions() {
    return {
      className: "has-focus",
      mode: "all"
    };
  },
  addProseMirrorPlugins() {
    return [
      new Cn({
        key: new _n("focus"),
        props: {
          decorations: ({ doc: n, selection: e }) => {
            const { isEditable: t, isFocused: r } = this.editor, { anchor: i } = e, s = [];
            if (!t || !r)
              return Nn.create(n, []);
            let o = 0;
            this.options.mode === "deepest" && n.descendants((l, c) => {
              if (l.isText)
                return;
              if (!(i >= c && i <= c + l.nodeSize - 1))
                return !1;
              o += 1;
            });
            let a = 0;
            return n.descendants((l, c) => {
              if (l.isText || !(i >= c && i <= c + l.nodeSize - 1))
                return !1;
              if (a += 1, this.options.mode === "deepest" && o - a > 0 || this.options.mode === "shallowest" && a > 1)
                return this.options.mode === "deepest";
              s.push(
                Ro.node(c, c + l.nodeSize, {
                  class: this.options.className
                })
              );
            }), Nn.create(n, s);
          }
        }
      })
    ];
  }
});
var Zut = qt.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [Lut()];
  },
  extendNodeSchema(n) {
    var e;
    const t = {
      name: n.name,
      options: n.options,
      storage: n.storage
    };
    return {
      allowGapCursor: (e = on(st(n, "allowGapCursor", t))) != null ? e : null
    };
  }
}), Qut = qt.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    return [
      new Cn({
        key: new _n("placeholder"),
        props: {
          decorations: ({ doc: n, selection: e }) => {
            const t = this.editor.isEditable || !this.options.showOnlyWhenEditable, { anchor: r } = e, i = [];
            if (!t)
              return null;
            const s = this.editor.isEmpty;
            return n.descendants((o, a) => {
              const l = r >= a && r <= a + o.nodeSize, c = !o.isLeaf && dx(o);
              if ((l || !this.options.showOnlyCurrent) && c) {
                const u = [this.options.emptyNodeClass];
                s && u.push(this.options.emptyEditorClass);
                const d = Ro.node(a, a + o.nodeSize, {
                  class: u.join(" "),
                  "data-placeholder": typeof this.options.placeholder == "function" ? this.options.placeholder({
                    editor: this.editor,
                    node: o,
                    pos: a,
                    hasAnchor: l
                  }) : this.options.placeholder
                });
                i.push(d);
              }
              return this.options.includeChildren;
            }), Nn.create(n, i);
          }
        }
      })
    ];
  }
}), Jut = qt.create({
  name: "selection",
  addOptions() {
    return {
      className: "selection"
    };
  },
  addProseMirrorPlugins() {
    const { editor: n, options: e } = this;
    return [
      new Cn({
        key: new _n("selection"),
        props: {
          decorations(t) {
            return t.selection.empty || n.isFocused || !n.isEditable || foe(t.selection) || n.view.dragging ? null : Nn.create(t.doc, [
              Ro.inline(t.selection.from, t.selection.to, {
                class: e.className
              })
            ]);
          }
        }
      })
    ];
  }
});
function tj({ types: n, node: e }) {
  return e && Array.isArray(n) && n.includes(e.type) || e?.type === n;
}
var edt = qt.create({
  name: "trailingNode",
  addOptions() {
    return {
      node: void 0,
      notAfter: []
    };
  },
  addProseMirrorPlugins() {
    var n;
    const e = new _n(this.name), t = ((n = this.editor.schema.topNodeType.contentMatch.defaultType) == null ? void 0 : n.name) || this.options.node || "paragraph", r = Object.entries(this.editor.schema.nodes).map(([, i]) => i).filter((i) => (this.options.notAfter || []).concat(t).includes(i.name));
    return [
      new Cn({
        key: e,
        appendTransaction: (i, s, o) => {
          const { doc: a, tr: l, schema: c } = o, u = e.getState(o), d = a.content.size, f = c.nodes[t];
          if (u)
            return l.insert(d, f.create());
        },
        state: {
          init: (i, s) => {
            const o = s.tr.doc.lastChild;
            return !tj({ node: o, types: r });
          },
          apply: (i, s) => {
            if (!i.docChanged)
              return s;
            const o = i.doc.lastChild;
            return !tj({ node: o, types: r });
          }
        }
      })
    ];
  }
}), tdt = qt.create({
  name: "undoRedo",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: n, dispatch: e }) => Tae(n, e),
      redo: () => ({ state: n, dispatch: e }) => Aae(n, e)
    };
  },
  addProseMirrorPlugins() {
    return [Yut(this.options)];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), ndt = qt.create({
  name: "starterKit",
  addExtensions() {
    var n, e, t, r;
    const i = [];
    return this.options.bold !== !1 && i.push(kct.configure(this.options.bold)), this.options.blockquote !== !1 && i.push(Sct.configure(this.options.blockquote)), this.options.bulletList !== !1 && i.push(dae.configure(this.options.bulletList)), this.options.code !== !1 && i.push(Ict.configure(this.options.code)), this.options.codeBlock !== !1 && i.push(eae.configure(this.options.codeBlock)), this.options.document !== !1 && i.push(Nct.configure(this.options.document)), this.options.dropcursor !== !1 && i.push(Xut.configure(this.options.dropcursor)), this.options.gapcursor !== !1 && i.push(Zut.configure(this.options.gapcursor)), this.options.hardBreak !== !1 && i.push(Lct.configure(this.options.hardBreak)), this.options.heading !== !1 && i.push($ct.configure(this.options.heading)), this.options.undoRedo !== !1 && i.push(tdt.configure(this.options.undoRedo)), this.options.horizontalRule !== !1 && i.push(tae.configure(this.options.horizontalRule)), this.options.italic !== !1 && i.push(Uct.configure(this.options.italic)), this.options.listItem !== !1 && i.push(fae.configure(this.options.listItem)), this.options.listKeymap !== !1 && i.push(yae.configure((n = this.options) == null ? void 0 : n.listKeymap)), this.options.link !== !1 && i.push(hut.configure((e = this.options) == null ? void 0 : e.link)), this.options.orderedList !== !1 && i.push(wae.configure(this.options.orderedList)), this.options.paragraph !== !1 && i.push(Aut.configure(this.options.paragraph)), this.options.strike !== !1 && i.push(_ut.configure(this.options.strike)), this.options.text !== !1 && i.push(Out.configure(this.options.text)), this.options.underline !== !1 && i.push(Iut.configure((t = this.options) == null ? void 0 : t.underline)), this.options.trailingNode !== !1 && i.push(edt.configure((r = this.options) == null ? void 0 : r.trailingNode)), i;
  }
}), rdt = (n) => Qn({
  find: /--$/,
  replace: n ?? "—"
}), idt = (n) => Qn({
  find: /\.\.\.$/,
  replace: n ?? "…"
}), sdt = (n) => Qn({
  find: /(?:^|[\s{[(<'"\u2018\u201C])(")$/,
  replace: n ?? "“"
}), odt = (n) => Qn({
  find: /"$/,
  replace: n ?? "”"
}), adt = (n) => Qn({
  find: /(?:^|[\s{[(<'"\u2018\u201C])(')$/,
  replace: n ?? "‘"
}), ldt = (n) => Qn({
  find: /'$/,
  replace: n ?? "’"
}), cdt = (n) => Qn({
  find: /<-$/,
  replace: n ?? "←"
}), udt = (n) => Qn({
  find: /->$/,
  replace: n ?? "→"
}), ddt = (n) => Qn({
  find: /\(c\)$/,
  replace: n ?? "©"
}), fdt = (n) => Qn({
  find: /\(tm\)$/,
  replace: n ?? "™"
}), hdt = (n) => Qn({
  find: /\(sm\)$/,
  replace: n ?? "℠"
}), pdt = (n) => Qn({
  find: /\(r\)$/,
  replace: n ?? "®"
}), mdt = (n) => Qn({
  find: /(?:^|\s)(1\/2)\s$/,
  replace: n ?? "½"
}), gdt = (n) => Qn({
  find: /\+\/-$/,
  replace: n ?? "±"
}), vdt = (n) => Qn({
  find: /!=$/,
  replace: n ?? "≠"
}), ydt = (n) => Qn({
  find: /<<$/,
  replace: n ?? "«"
}), bdt = (n) => Qn({
  find: />>$/,
  replace: n ?? "»"
}), wdt = (n) => Qn({
  find: /\d+\s?([*x])\s?\d+$/,
  replace: n ?? "×"
}), xdt = (n) => Qn({
  find: /\^2$/,
  replace: n ?? "²"
}), Edt = (n) => Qn({
  find: /\^3$/,
  replace: n ?? "³"
}), Sdt = (n) => Qn({
  find: /(?:^|\s)(1\/4)\s$/,
  replace: n ?? "¼"
}), Cdt = (n) => Qn({
  find: /(?:^|\s)(3\/4)\s$/,
  replace: n ?? "¾"
}), Tdt = qt.create({
  name: "typography",
  addOptions() {
    return {
      closeDoubleQuote: "”",
      closeSingleQuote: "’",
      copyright: "©",
      ellipsis: "…",
      emDash: "—",
      laquo: "«",
      leftArrow: "←",
      multiplication: "×",
      notEqual: "≠",
      oneHalf: "½",
      oneQuarter: "¼",
      openDoubleQuote: "“",
      openSingleQuote: "‘",
      plusMinus: "±",
      raquo: "»",
      registeredTrademark: "®",
      rightArrow: "→",
      servicemark: "℠",
      superscriptThree: "³",
      superscriptTwo: "²",
      threeQuarters: "¾",
      trademark: "™"
    };
  },
  addInputRules() {
    const n = [];
    return this.options.emDash !== !1 && n.push(rdt(this.options.emDash)), this.options.ellipsis !== !1 && n.push(idt(this.options.ellipsis)), this.options.openDoubleQuote !== !1 && n.push(sdt(this.options.openDoubleQuote)), this.options.closeDoubleQuote !== !1 && n.push(odt(this.options.closeDoubleQuote)), this.options.openSingleQuote !== !1 && n.push(adt(this.options.openSingleQuote)), this.options.closeSingleQuote !== !1 && n.push(ldt(this.options.closeSingleQuote)), this.options.leftArrow !== !1 && n.push(cdt(this.options.leftArrow)), this.options.rightArrow !== !1 && n.push(udt(this.options.rightArrow)), this.options.copyright !== !1 && n.push(ddt(this.options.copyright)), this.options.trademark !== !1 && n.push(fdt(this.options.trademark)), this.options.servicemark !== !1 && n.push(hdt(this.options.servicemark)), this.options.registeredTrademark !== !1 && n.push(pdt(this.options.registeredTrademark)), this.options.oneHalf !== !1 && n.push(mdt(this.options.oneHalf)), this.options.plusMinus !== !1 && n.push(gdt(this.options.plusMinus)), this.options.notEqual !== !1 && n.push(vdt(this.options.notEqual)), this.options.laquo !== !1 && n.push(ydt(this.options.laquo)), this.options.raquo !== !1 && n.push(bdt(this.options.raquo)), this.options.multiplication !== !1 && n.push(wdt(this.options.multiplication)), this.options.superscriptTwo !== !1 && n.push(xdt(this.options.superscriptTwo)), this.options.superscriptThree !== !1 && n.push(Edt(this.options.superscriptThree)), this.options.oneQuarter !== !1 && n.push(Sdt(this.options.oneQuarter)), this.options.threeQuarters !== !1 && n.push(Cdt(this.options.threeQuarters)), n;
  }
}), Adt = 20, Mae = (n, e = 0) => {
  const t = [];
  return !n.children.length || e > Adt || Array.from(n.children).forEach((r) => {
    r.tagName === "SPAN" ? t.push(r) : r.children.length && t.push(...Mae(r, e + 1));
  }), t;
}, Mdt = (n) => {
  if (!n.children.length)
    return;
  const e = Mae(n);
  e && e.forEach((t) => {
    var r, i;
    const s = t.getAttribute("style"), o = (i = (r = t.parentElement) == null ? void 0 : r.closest("span")) == null ? void 0 : i.getAttribute("style");
    t.setAttribute("style", `${o};${s}`);
  });
}, kae = Lc.create({
  name: "textStyle",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      mergeNestedSpanStyles: !0
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        consuming: !1,
        getAttrs: (n) => n.hasAttribute("style") ? (this.options.mergeNestedSpanStyles && Mdt(n), {}) : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["span", Zn(this.options.HTMLAttributes, n), 0];
  },
  addCommands() {
    return {
      toggleTextStyle: (n) => ({ commands: e }) => e.toggleMark(this.name, n),
      removeEmptyTextStyle: () => ({ tr: n }) => {
        const { selection: e } = n;
        return n.doc.nodesBetween(e.from, e.to, (t, r) => {
          if (t.isTextblock)
            return !0;
          t.marks.filter((i) => i.type === this.type).some((i) => Object.values(i.attrs).some((s) => !!s)) || n.removeMark(r, r + t.nodeSize, this.type);
        }), !0;
      }
    };
  }
}), kdt = qt.create({
  name: "backgroundColor",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          backgroundColor: {
            default: null,
            parseHTML: (n) => {
              var e;
              const t = n.getAttribute("style");
              if (t) {
                const r = t.split(";").map((i) => i.trim()).filter(Boolean);
                for (let i = r.length - 1; i >= 0; i -= 1) {
                  const s = r[i].split(":");
                  if (s.length >= 2) {
                    const o = s[0].trim().toLowerCase(), a = s.slice(1).join(":").trim();
                    if (o === "background-color")
                      return a.replace(/['"]+/g, "");
                  }
                }
              }
              return (e = n.style.backgroundColor) == null ? void 0 : e.replace(/['"]+/g, "");
            },
            renderHTML: (n) => n.backgroundColor ? {
              style: `background-color: ${n.backgroundColor}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setBackgroundColor: (n) => ({ chain: e }) => e().setMark("textStyle", { backgroundColor: n }).run(),
      unsetBackgroundColor: () => ({ chain: n }) => n().setMark("textStyle", { backgroundColor: null }).removeEmptyTextStyle().run()
    };
  }
}), _ae = qt.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (n) => {
              var e;
              const t = n.getAttribute("style");
              if (t) {
                const r = t.split(";").map((i) => i.trim()).filter(Boolean);
                for (let i = r.length - 1; i >= 0; i -= 1) {
                  const s = r[i].split(":");
                  if (s.length >= 2) {
                    const o = s[0].trim().toLowerCase(), a = s.slice(1).join(":").trim();
                    if (o === "color")
                      return a.replace(/['"]+/g, "");
                  }
                }
              }
              return (e = n.style.color) == null ? void 0 : e.replace(/['"]+/g, "");
            },
            renderHTML: (n) => n.color ? {
              style: `color: ${n.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (n) => ({ chain: e }) => e().setMark("textStyle", { color: n }).run(),
      unsetColor: () => ({ chain: n }) => n().setMark("textStyle", { color: null }).removeEmptyTextStyle().run()
    };
  }
}), _dt = qt.create({
  name: "fontFamily",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            parseHTML: (n) => n.style.fontFamily,
            renderHTML: (n) => n.fontFamily ? {
              style: `font-family: ${n.fontFamily}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontFamily: (n) => ({ chain: e }) => e().setMark("textStyle", { fontFamily: n }).run(),
      unsetFontFamily: () => ({ chain: n }) => n().setMark("textStyle", { fontFamily: null }).removeEmptyTextStyle().run()
    };
  }
}), Odt = qt.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (n) => n.style.fontSize,
            renderHTML: (n) => n.fontSize ? {
              style: `font-size: ${n.fontSize}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (n) => ({ chain: e }) => e().setMark("textStyle", { fontSize: n }).run(),
      unsetFontSize: () => ({ chain: n }) => n().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run()
    };
  }
}), Idt = qt.create({
  name: "lineHeight",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          lineHeight: {
            default: null,
            parseHTML: (n) => n.style.lineHeight,
            renderHTML: (n) => n.lineHeight ? {
              style: `line-height: ${n.lineHeight}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setLineHeight: (n) => ({ chain: e }) => e().setMark("textStyle", { lineHeight: n }).run(),
      unsetLineHeight: () => ({ chain: n }) => n().setMark("textStyle", { lineHeight: null }).removeEmptyTextStyle().run()
    };
  }
});
qt.create({
  name: "textStyleKit",
  addExtensions() {
    const n = [];
    return this.options.backgroundColor !== !1 && n.push(kdt.configure(this.options.backgroundColor)), this.options.color !== !1 && n.push(_ae.configure(this.options.color)), this.options.fontFamily !== !1 && n.push(_dt.configure(this.options.fontFamily)), this.options.fontSize !== !1 && n.push(Odt.configure(this.options.fontSize)), this.options.lineHeight !== !1 && n.push(Idt.configure(this.options.lineHeight)), this.options.textStyle !== !1 && n.push(kae.configure(this.options.textStyle)), n;
  }
});
var A8, nj;
function Rdt() {
  if (nj) return A8;
  nj = 1;
  function n(W) {
    return W instanceof Map ? W.clear = W.delete = W.set = function() {
      throw new Error("map is read-only");
    } : W instanceof Set && (W.add = W.clear = W.delete = function() {
      throw new Error("set is read-only");
    }), Object.freeze(W), Object.getOwnPropertyNames(W).forEach((ue) => {
      const we = W[ue], Le = typeof we;
      (Le === "object" || Le === "function") && !Object.isFrozen(we) && n(we);
    }), W;
  }
  class e {
    /**
     * @param {CompiledMode} mode
     */
    constructor(ue) {
      ue.data === void 0 && (ue.data = {}), this.data = ue.data, this.isMatchIgnored = !1;
    }
    ignoreMatch() {
      this.isMatchIgnored = !0;
    }
  }
  function t(W) {
    return W.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
  }
  function r(W, ...ue) {
    const we = /* @__PURE__ */ Object.create(null);
    for (const Le in W)
      we[Le] = W[Le];
    return ue.forEach(function(Le) {
      for (const Pt in Le)
        we[Pt] = Le[Pt];
    }), /** @type {T} */
    we;
  }
  const i = "</span>", s = (W) => !!W.scope, o = (W, { prefix: ue }) => {
    if (W.startsWith("language:"))
      return W.replace("language:", "language-");
    if (W.includes(".")) {
      const we = W.split(".");
      return [
        `${ue}${we.shift()}`,
        ...we.map((Le, Pt) => `${Le}${"_".repeat(Pt + 1)}`)
      ].join(" ");
    }
    return `${ue}${W}`;
  };
  class a {
    /**
     * Creates a new HTMLRenderer
     *
     * @param {Tree} parseTree - the parse tree (must support `walk` API)
     * @param {{classPrefix: string}} options
     */
    constructor(ue, we) {
      this.buffer = "", this.classPrefix = we.classPrefix, ue.walk(this);
    }
    /**
     * Adds texts to the output stream
     *
     * @param {string} text */
    addText(ue) {
      this.buffer += t(ue);
    }
    /**
     * Adds a node open to the output stream (if needed)
     *
     * @param {Node} node */
    openNode(ue) {
      if (!s(ue)) return;
      const we = o(
        ue.scope,
        { prefix: this.classPrefix }
      );
      this.span(we);
    }
    /**
     * Adds a node close to the output stream (if needed)
     *
     * @param {Node} node */
    closeNode(ue) {
      s(ue) && (this.buffer += i);
    }
    /**
     * returns the accumulated buffer
    */
    value() {
      return this.buffer;
    }
    // helpers
    /**
     * Builds a span element
     *
     * @param {string} className */
    span(ue) {
      this.buffer += `<span class="${ue}">`;
    }
  }
  const l = (W = {}) => {
    const ue = { children: [] };
    return Object.assign(ue, W), ue;
  };
  class c {
    constructor() {
      this.rootNode = l(), this.stack = [this.rootNode];
    }
    get top() {
      return this.stack[this.stack.length - 1];
    }
    get root() {
      return this.rootNode;
    }
    /** @param {Node} node */
    add(ue) {
      this.top.children.push(ue);
    }
    /** @param {string} scope */
    openNode(ue) {
      const we = l({ scope: ue });
      this.add(we), this.stack.push(we);
    }
    closeNode() {
      if (this.stack.length > 1)
        return this.stack.pop();
    }
    closeAllNodes() {
      for (; this.closeNode(); ) ;
    }
    toJSON() {
      return JSON.stringify(this.rootNode, null, 4);
    }
    /**
     * @typedef { import("./html_renderer").Renderer } Renderer
     * @param {Renderer} builder
     */
    walk(ue) {
      return this.constructor._walk(ue, this.rootNode);
    }
    /**
     * @param {Renderer} builder
     * @param {Node} node
     */
    static _walk(ue, we) {
      return typeof we == "string" ? ue.addText(we) : we.children && (ue.openNode(we), we.children.forEach((Le) => this._walk(ue, Le)), ue.closeNode(we)), ue;
    }
    /**
     * @param {Node} node
     */
    static _collapse(ue) {
      typeof ue != "string" && ue.children && (ue.children.every((we) => typeof we == "string") ? ue.children = [ue.children.join("")] : ue.children.forEach((we) => {
        c._collapse(we);
      }));
    }
  }
  class u extends c {
    /**
     * @param {*} options
     */
    constructor(ue) {
      super(), this.options = ue;
    }
    /**
     * @param {string} text
     */
    addText(ue) {
      ue !== "" && this.add(ue);
    }
    /** @param {string} scope */
    startScope(ue) {
      this.openNode(ue);
    }
    endScope() {
      this.closeNode();
    }
    /**
     * @param {Emitter & {root: DataNode}} emitter
     * @param {string} name
     */
    __addSublanguage(ue, we) {
      const Le = ue.root;
      we && (Le.scope = `language:${we}`), this.add(Le);
    }
    toHTML() {
      return new a(this, this.options).value();
    }
    finalize() {
      return this.closeAllNodes(), !0;
    }
  }
  function d(W) {
    return W ? typeof W == "string" ? W : W.source : null;
  }
  function f(W) {
    return g("(?=", W, ")");
  }
  function h(W) {
    return g("(?:", W, ")*");
  }
  function m(W) {
    return g("(?:", W, ")?");
  }
  function g(...W) {
    return W.map((we) => d(we)).join("");
  }
  function v(W) {
    const ue = W[W.length - 1];
    return typeof ue == "object" && ue.constructor === Object ? (W.splice(W.length - 1, 1), ue) : {};
  }
  function y(...W) {
    return "(" + (v(W).capture ? "" : "?:") + W.map((Le) => d(Le)).join("|") + ")";
  }
  function b(W) {
    return new RegExp(W.toString() + "|").exec("").length - 1;
  }
  function x(W, ue) {
    const we = W && W.exec(ue);
    return we && we.index === 0;
  }
  const E = /\[(?:[^\\\]]|\\.)*\]|\(\??|\\([1-9][0-9]*)|\\./;
  function w(W, { joinWith: ue }) {
    let we = 0;
    return W.map((Le) => {
      we += 1;
      const Pt = we;
      let gt = d(Le), _e = "";
      for (; gt.length > 0; ) {
        const $e = E.exec(gt);
        if (!$e) {
          _e += gt;
          break;
        }
        _e += gt.substring(0, $e.index), gt = gt.substring($e.index + $e[0].length), $e[0][0] === "\\" && $e[1] ? _e += "\\" + String(Number($e[1]) + Pt) : (_e += $e[0], $e[0] === "(" && we++);
      }
      return _e;
    }).map((Le) => `(${Le})`).join(ue);
  }
  const C = /\b\B/, S = "[a-zA-Z]\\w*", M = "[a-zA-Z_]\\w*", k = "\\b\\d+(\\.\\d+)?", _ = "(-?)(\\b0[xX][a-fA-F0-9]+|(\\b\\d+(\\.\\d*)?|\\.\\d+)([eE][-+]?\\d+)?)", O = "\\b(0b[01]+)", I = "!|!=|!==|%|%=|&|&&|&=|\\*|\\*=|\\+|\\+=|,|-|-=|/=|/|:|;|<<|<<=|<=|<|===|==|=|>>>=|>>=|>=|>>>|>>|>|\\?|\\[|\\{|\\(|\\^|\\^=|\\||\\|=|\\|\\||~", R = (W = {}) => {
    const ue = /^#![ ]*\//;
    return W.binary && (W.begin = g(
      ue,
      /.*\b/,
      W.binary,
      /\b.*/
    )), r({
      scope: "meta",
      begin: ue,
      end: /$/,
      relevance: 0,
      /** @type {ModeCallback} */
      "on:begin": (we, Le) => {
        we.index !== 0 && Le.ignoreMatch();
      }
    }, W);
  }, P = {
    begin: "\\\\[\\s\\S]",
    relevance: 0
  }, D = {
    scope: "string",
    begin: "'",
    end: "'",
    illegal: "\\n",
    contains: [P]
  }, L = {
    scope: "string",
    begin: '"',
    end: '"',
    illegal: "\\n",
    contains: [P]
  }, B = {
    begin: /\b(a|an|the|are|I'm|isn't|don't|doesn't|won't|but|just|should|pretty|simply|enough|gonna|going|wtf|so|such|will|you|your|they|like|more)\b/
  }, $ = function(W, ue, we = {}) {
    const Le = r(
      {
        scope: "comment",
        begin: W,
        end: ue,
        contains: []
      },
      we
    );
    Le.contains.push({
      scope: "doctag",
      // hack to avoid the space from being included. the space is necessary to
      // match here to prevent the plain text rule below from gobbling up doctags
      begin: "[ ]*(?=(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):)",
      end: /(TODO|FIXME|NOTE|BUG|OPTIMIZE|HACK|XXX):/,
      excludeBegin: !0,
      relevance: 0
    });
    const Pt = y(
      // list of common 1 and 2 letter words in English
      "I",
      "a",
      "is",
      "so",
      "us",
      "to",
      "at",
      "if",
      "in",
      "it",
      "on",
      // note: this is not an exhaustive list of contractions, just popular ones
      /[A-Za-z]+['](d|ve|re|ll|t|s|n)/,
      // contractions - can't we'd they're let's, etc
      /[A-Za-z]+[-][a-z]+/,
      // `no-way`, etc.
      /[A-Za-z][a-z]{2,}/
      // allow capitalized words at beginning of sentences
    );
    return Le.contains.push(
      {
        // TODO: how to include ", (, ) without breaking grammars that use these for
        // comment delimiters?
        // begin: /[ ]+([()"]?([A-Za-z'-]{3,}|is|a|I|so|us|[tT][oO]|at|if|in|it|on)[.]?[()":]?([.][ ]|[ ]|\))){3}/
        // ---
        // this tries to find sequences of 3 english words in a row (without any
        // "programming" type syntax) this gives us a strong signal that we've
        // TRULY found a comment - vs perhaps scanning with the wrong language.
        // It's possible to find something that LOOKS like the start of the
        // comment - but then if there is no readable text - good chance it is a
        // false match and not a comment.
        //
        // for a visual example please see:
        // https://github.com/highlightjs/highlight.js/issues/2827
        begin: g(
          /[ ]+/,
          // necessary to prevent us gobbling up doctags like /* @author Bob Mcgill */
          "(",
          Pt,
          /[.]?[:]?([.][ ]|[ ])/,
          "){3}"
        )
        // look for 3 words in a row
      }
    ), Le;
  }, z = $("//", "$"), H = $("/\\*", "\\*/"), U = $("#", "$"), F = {
    scope: "number",
    begin: k,
    relevance: 0
  }, V = {
    scope: "number",
    begin: _,
    relevance: 0
  }, X = {
    scope: "number",
    begin: O,
    relevance: 0
  }, Z = {
    scope: "regexp",
    begin: /\/(?=[^/\n]*\/)/,
    end: /\/[gimuy]*/,
    contains: [
      P,
      {
        begin: /\[/,
        end: /\]/,
        relevance: 0,
        contains: [P]
      }
    ]
  }, ie = {
    scope: "title",
    begin: S,
    relevance: 0
  }, J = {
    scope: "title",
    begin: M,
    relevance: 0
  }, se = {
    // excludes method names from keyword processing
    begin: "\\.\\s*" + M,
    relevance: 0
  };
  var le = /* @__PURE__ */ Object.freeze({
    __proto__: null,
    APOS_STRING_MODE: D,
    BACKSLASH_ESCAPE: P,
    BINARY_NUMBER_MODE: X,
    BINARY_NUMBER_RE: O,
    COMMENT: $,
    C_BLOCK_COMMENT_MODE: H,
    C_LINE_COMMENT_MODE: z,
    C_NUMBER_MODE: V,
    C_NUMBER_RE: _,
    END_SAME_AS_BEGIN: function(W) {
      return Object.assign(
        W,
        {
          /** @type {ModeCallback} */
          "on:begin": (ue, we) => {
            we.data._beginMatch = ue[1];
          },
          /** @type {ModeCallback} */
          "on:end": (ue, we) => {
            we.data._beginMatch !== ue[1] && we.ignoreMatch();
          }
        }
      );
    },
    HASH_COMMENT_MODE: U,
    IDENT_RE: S,
    MATCH_NOTHING_RE: C,
    METHOD_GUARD: se,
    NUMBER_MODE: F,
    NUMBER_RE: k,
    PHRASAL_WORDS_MODE: B,
    QUOTE_STRING_MODE: L,
    REGEXP_MODE: Z,
    RE_STARTERS_RE: I,
    SHEBANG: R,
    TITLE_MODE: ie,
    UNDERSCORE_IDENT_RE: M,
    UNDERSCORE_TITLE_MODE: J
  });
  function de(W, ue) {
    W.input[W.index - 1] === "." && ue.ignoreMatch();
  }
  function j(W, ue) {
    W.className !== void 0 && (W.scope = W.className, delete W.className);
  }
  function xe(W, ue) {
    ue && W.beginKeywords && (W.begin = "\\b(" + W.beginKeywords.split(" ").join("|") + ")(?!\\.)(?=\\b|\\s)", W.__beforeBegin = de, W.keywords = W.keywords || W.beginKeywords, delete W.beginKeywords, W.relevance === void 0 && (W.relevance = 0));
  }
  function ne(W, ue) {
    Array.isArray(W.illegal) && (W.illegal = y(...W.illegal));
  }
  function qe(W, ue) {
    if (W.match) {
      if (W.begin || W.end) throw new Error("begin & end are not supported with match");
      W.begin = W.match, delete W.match;
    }
  }
  function ve(W, ue) {
    W.relevance === void 0 && (W.relevance = 1);
  }
  const Ie = (W, ue) => {
    if (!W.beforeMatch) return;
    if (W.starts) throw new Error("beforeMatch cannot be used with starts");
    const we = Object.assign({}, W);
    Object.keys(W).forEach((Le) => {
      delete W[Le];
    }), W.keywords = we.keywords, W.begin = g(we.beforeMatch, f(we.begin)), W.starts = {
      relevance: 0,
      contains: [
        Object.assign(we, { endsParent: !0 })
      ]
    }, W.relevance = 0, delete we.beforeMatch;
  }, mt = [
    "of",
    "and",
    "for",
    "in",
    "not",
    "or",
    "if",
    "then",
    "parent",
    // common variable name
    "list",
    // common variable name
    "value"
    // common variable name
  ], xt = "keyword";
  function G(W, ue, we = xt) {
    const Le = /* @__PURE__ */ Object.create(null);
    return typeof W == "string" ? Pt(we, W.split(" ")) : Array.isArray(W) ? Pt(we, W) : Object.keys(W).forEach(function(gt) {
      Object.assign(
        Le,
        G(W[gt], ue, gt)
      );
    }), Le;
    function Pt(gt, _e) {
      ue && (_e = _e.map(($e) => $e.toLowerCase())), _e.forEach(function($e) {
        const Qe = $e.split("|");
        Le[Qe[0]] = [gt, re(Qe[0], Qe[1])];
      });
    }
  }
  function re(W, ue) {
    return ue ? Number(ue) : oe(W) ? 0 : 1;
  }
  function oe(W) {
    return mt.includes(W.toLowerCase());
  }
  const Se = {}, ye = (W) => {
    console.error(W);
  }, be = (W, ...ue) => {
    console.log(`WARN: ${W}`, ...ue);
  }, Oe = (W, ue) => {
    Se[`${W}/${ue}`] || (console.log(`Deprecated as of ${W}. ${ue}`), Se[`${W}/${ue}`] = !0);
  }, ut = new Error();
  function Et(W, ue, { key: we }) {
    let Le = 0;
    const Pt = W[we], gt = {}, _e = {};
    for (let $e = 1; $e <= ue.length; $e++)
      _e[$e + Le] = Pt[$e], gt[$e + Le] = !0, Le += b(ue[$e - 1]);
    W[we] = _e, W[we]._emit = gt, W[we]._multi = !0;
  }
  function Yt(W) {
    if (Array.isArray(W.begin)) {
      if (W.skip || W.excludeBegin || W.returnBegin)
        throw ye("skip, excludeBegin, returnBegin not compatible with beginScope: {}"), ut;
      if (typeof W.beginScope != "object" || W.beginScope === null)
        throw ye("beginScope must be object"), ut;
      Et(W, W.begin, { key: "beginScope" }), W.begin = w(W.begin, { joinWith: "" });
    }
  }
  function Wt(W) {
    if (Array.isArray(W.end)) {
      if (W.skip || W.excludeEnd || W.returnEnd)
        throw ye("skip, excludeEnd, returnEnd not compatible with endScope: {}"), ut;
      if (typeof W.endScope != "object" || W.endScope === null)
        throw ye("endScope must be object"), ut;
      Et(W, W.end, { key: "endScope" }), W.end = w(W.end, { joinWith: "" });
    }
  }
  function me(W) {
    W.scope && typeof W.scope == "object" && W.scope !== null && (W.beginScope = W.scope, delete W.scope);
  }
  function Pe(W) {
    me(W), typeof W.beginScope == "string" && (W.beginScope = { _wrap: W.beginScope }), typeof W.endScope == "string" && (W.endScope = { _wrap: W.endScope }), Yt(W), Wt(W);
  }
  function yt(W) {
    function ue(_e, $e) {
      return new RegExp(
        d(_e),
        "m" + (W.case_insensitive ? "i" : "") + (W.unicodeRegex ? "u" : "") + ($e ? "g" : "")
      );
    }
    class we {
      constructor() {
        this.matchIndexes = {}, this.regexes = [], this.matchAt = 1, this.position = 0;
      }
      // @ts-ignore
      addRule($e, Qe) {
        Qe.position = this.position++, this.matchIndexes[this.matchAt] = Qe, this.regexes.push([Qe, $e]), this.matchAt += b($e) + 1;
      }
      compile() {
        this.regexes.length === 0 && (this.exec = () => null);
        const $e = this.regexes.map((Qe) => Qe[1]);
        this.matcherRe = ue(w($e, { joinWith: "|" }), !0), this.lastIndex = 0;
      }
      /** @param {string} s */
      exec($e) {
        this.matcherRe.lastIndex = this.lastIndex;
        const Qe = this.matcherRe.exec($e);
        if (!Qe)
          return null;
        const Xt = Qe.findIndex((Zi, X1) => X1 > 0 && Zi !== void 0), Bn = this.matchIndexes[Xt];
        return Qe.splice(0, Xt), Object.assign(Qe, Bn);
      }
    }
    class Le {
      constructor() {
        this.rules = [], this.multiRegexes = [], this.count = 0, this.lastIndex = 0, this.regexIndex = 0;
      }
      // @ts-ignore
      getMatcher($e) {
        if (this.multiRegexes[$e]) return this.multiRegexes[$e];
        const Qe = new we();
        return this.rules.slice($e).forEach(([Xt, Bn]) => Qe.addRule(Xt, Bn)), Qe.compile(), this.multiRegexes[$e] = Qe, Qe;
      }
      resumingScanAtSamePosition() {
        return this.regexIndex !== 0;
      }
      considerAll() {
        this.regexIndex = 0;
      }
      // @ts-ignore
      addRule($e, Qe) {
        this.rules.push([$e, Qe]), Qe.type === "begin" && this.count++;
      }
      /** @param {string} s */
      exec($e) {
        const Qe = this.getMatcher(this.regexIndex);
        Qe.lastIndex = this.lastIndex;
        let Xt = Qe.exec($e);
        if (this.resumingScanAtSamePosition() && !(Xt && Xt.index === this.lastIndex)) {
          const Bn = this.getMatcher(0);
          Bn.lastIndex = this.lastIndex + 1, Xt = Bn.exec($e);
        }
        return Xt && (this.regexIndex += Xt.position + 1, this.regexIndex === this.count && this.considerAll()), Xt;
      }
    }
    function Pt(_e) {
      const $e = new Le();
      return _e.contains.forEach((Qe) => $e.addRule(Qe.begin, { rule: Qe, type: "begin" })), _e.terminatorEnd && $e.addRule(_e.terminatorEnd, { type: "end" }), _e.illegal && $e.addRule(_e.illegal, { type: "illegal" }), $e;
    }
    function gt(_e, $e) {
      const Qe = (
        /** @type CompiledMode */
        _e
      );
      if (_e.isCompiled) return Qe;
      [
        j,
        // do this early so compiler extensions generally don't have to worry about
        // the distinction between match/begin
        qe,
        Pe,
        Ie
      ].forEach((Bn) => Bn(_e, $e)), W.compilerExtensions.forEach((Bn) => Bn(_e, $e)), _e.__beforeBegin = null, [
        xe,
        // do this later so compiler extensions that come earlier have access to the
        // raw array if they wanted to perhaps manipulate it, etc.
        ne,
        // default to 1 relevance if not specified
        ve
      ].forEach((Bn) => Bn(_e, $e)), _e.isCompiled = !0;
      let Xt = null;
      return typeof _e.keywords == "object" && _e.keywords.$pattern && (_e.keywords = Object.assign({}, _e.keywords), Xt = _e.keywords.$pattern, delete _e.keywords.$pattern), Xt = Xt || /\w+/, _e.keywords && (_e.keywords = G(_e.keywords, W.case_insensitive)), Qe.keywordPatternRe = ue(Xt, !0), $e && (_e.begin || (_e.begin = /\B|\b/), Qe.beginRe = ue(Qe.begin), !_e.end && !_e.endsWithParent && (_e.end = /\B|\b/), _e.end && (Qe.endRe = ue(Qe.end)), Qe.terminatorEnd = d(Qe.end) || "", _e.endsWithParent && $e.terminatorEnd && (Qe.terminatorEnd += (_e.end ? "|" : "") + $e.terminatorEnd)), _e.illegal && (Qe.illegalRe = ue(
        /** @type {RegExp | string} */
        _e.illegal
      )), _e.contains || (_e.contains = []), _e.contains = [].concat(..._e.contains.map(function(Bn) {
        return rn(Bn === "self" ? _e : Bn);
      })), _e.contains.forEach(function(Bn) {
        gt(
          /** @type Mode */
          Bn,
          Qe
        );
      }), _e.starts && gt(_e.starts, $e), Qe.matcher = Pt(Qe), Qe;
    }
    if (W.compilerExtensions || (W.compilerExtensions = []), W.contains && W.contains.includes("self"))
      throw new Error("ERR: contains `self` is not supported at the top-level of a language.  See documentation.");
    return W.classNameAliases = r(W.classNameAliases || {}), gt(
      /** @type Mode */
      W
    );
  }
  function kt(W) {
    return W ? W.endsWithParent || kt(W.starts) : !1;
  }
  function rn(W) {
    return W.variants && !W.cachedVariants && (W.cachedVariants = W.variants.map(function(ue) {
      return r(W, { variants: null }, ue);
    })), W.cachedVariants ? W.cachedVariants : kt(W) ? r(W, { starts: W.starts ? r(W.starts) : null }) : Object.isFrozen(W) ? r(W) : W;
  }
  var vn = "11.11.1";
  class Xi extends Error {
    constructor(ue, we) {
      super(ue), this.name = "HTMLInjectionError", this.html = we;
    }
  }
  const ot = t, Ae = r, De = Symbol("nomatch"), et = 7, it = function(W) {
    const ue = /* @__PURE__ */ Object.create(null), we = /* @__PURE__ */ Object.create(null), Le = [];
    let Pt = !0;
    const gt = "Could not find the language '{}', did you forget to load/include a language module?", _e = { disableAutodetect: !0, name: "Plain text", contains: [] };
    let $e = {
      ignoreUnescapedHTML: !1,
      throwUnescapedHTML: !1,
      noHighlightRe: /^(no-?highlight)$/i,
      languageDetectRe: /\blang(?:uage)?-([\w-]+)\b/i,
      classPrefix: "hljs-",
      cssSelector: "pre code",
      languages: null,
      // beta configuration options, subject to change, welcome to discuss
      // https://github.com/highlightjs/highlight.js/issues/1086
      __emitter: u
    };
    function Qe(Me) {
      return $e.noHighlightRe.test(Me);
    }
    function Xt(Me) {
      let at = Me.className + " ";
      at += Me.parentNode ? Me.parentNode.className : "";
      const zt = $e.languageDetectRe.exec(at);
      if (zt) {
        const Tn = Cl(zt[1]);
        return Tn || (be(gt.replace("{}", zt[1])), be("Falling back to no-highlight mode for this block.", Me)), Tn ? zt[1] : "no-highlight";
      }
      return at.split(/\s+/).find((Tn) => Qe(Tn) || Cl(Tn));
    }
    function Bn(Me, at, zt) {
      let Tn = "", hr = "";
      typeof at == "object" ? (Tn = Me, zt = at.ignoreIllegals, hr = at.language) : (Oe("10.7.0", "highlight(lang, code, ...args) has been deprecated."), Oe("10.7.0", `Please use highlight(code, options) instead.
https://github.com/highlightjs/highlight.js/issues/2277`), hr = Me, Tn = at), zt === void 0 && (zt = !0);
      const Zs = {
        code: Tn,
        language: hr
      };
      Q1("before:highlight", Zs);
      const Tl = Zs.result ? Zs.result : Zi(Zs.language, Zs.code, zt);
      return Tl.code = Zs.code, Q1("after:highlight", Tl), Tl;
    }
    function Zi(Me, at, zt, Tn) {
      const hr = /* @__PURE__ */ Object.create(null);
      function Zs(Ue, tt) {
        return Ue.keywords[tt];
      }
      function Tl() {
        if (!Ct.keywords) {
          Dr.addText(An);
          return;
        }
        let Ue = 0;
        Ct.keywordPatternRe.lastIndex = 0;
        let tt = Ct.keywordPatternRe.exec(An), Ot = "";
        for (; tt; ) {
          Ot += An.substring(Ue, tt.index);
          const sn = Lo.case_insensitive ? tt[0].toLowerCase() : tt[0], Zr = Zs(Ct, sn);
          if (Zr) {
            const [_a, Ofe] = Zr;
            if (Dr.addText(Ot), Ot = "", hr[sn] = (hr[sn] || 0) + 1, hr[sn] <= et && (tg += Ofe), _a.startsWith("_"))
              Ot += tt[0];
            else {
              const Ife = Lo.classNameAliases[_a] || _a;
              No(tt[0], Ife);
            }
          } else
            Ot += tt[0];
          Ue = Ct.keywordPatternRe.lastIndex, tt = Ct.keywordPatternRe.exec(An);
        }
        Ot += An.substring(Ue), Dr.addText(Ot);
      }
      function J1() {
        if (An === "") return;
        let Ue = null;
        if (typeof Ct.subLanguage == "string") {
          if (!ue[Ct.subLanguage]) {
            Dr.addText(An);
            return;
          }
          Ue = Zi(Ct.subLanguage, An, !0, kI[Ct.subLanguage]), kI[Ct.subLanguage] = /** @type {CompiledMode} */
          Ue._top;
        } else
          Ue = Rx(An, Ct.subLanguage.length ? Ct.subLanguage : null);
        Ct.relevance > 0 && (tg += Ue.relevance), Dr.__addSublanguage(Ue._emitter, Ue.language);
      }
      function Qi() {
        Ct.subLanguage != null ? J1() : Tl(), An = "";
      }
      function No(Ue, tt) {
        Ue !== "" && (Dr.startScope(tt), Dr.addText(Ue), Dr.endScope());
      }
      function CI(Ue, tt) {
        let Ot = 1;
        const sn = tt.length - 1;
        for (; Ot <= sn; ) {
          if (!Ue._emit[Ot]) {
            Ot++;
            continue;
          }
          const Zr = Lo.classNameAliases[Ue[Ot]] || Ue[Ot], _a = tt[Ot];
          Zr ? No(_a, Zr) : (An = _a, Tl(), An = ""), Ot++;
        }
      }
      function TI(Ue, tt) {
        return Ue.scope && typeof Ue.scope == "string" && Dr.openNode(Lo.classNameAliases[Ue.scope] || Ue.scope), Ue.beginScope && (Ue.beginScope._wrap ? (No(An, Lo.classNameAliases[Ue.beginScope._wrap] || Ue.beginScope._wrap), An = "") : Ue.beginScope._multi && (CI(Ue.beginScope, tt), An = "")), Ct = Object.create(Ue, { parent: { value: Ct } }), Ct;
      }
      function AI(Ue, tt, Ot) {
        let sn = x(Ue.endRe, Ot);
        if (sn) {
          if (Ue["on:end"]) {
            const Zr = new e(Ue);
            Ue["on:end"](tt, Zr), Zr.isMatchIgnored && (sn = !1);
          }
          if (sn) {
            for (; Ue.endsParent && Ue.parent; )
              Ue = Ue.parent;
            return Ue;
          }
        }
        if (Ue.endsWithParent)
          return AI(Ue.parent, tt, Ot);
      }
      function Tfe(Ue) {
        return Ct.matcher.regexIndex === 0 ? (An += Ue[0], 1) : (Lx = !0, 0);
      }
      function Afe(Ue) {
        const tt = Ue[0], Ot = Ue.rule, sn = new e(Ot), Zr = [Ot.__beforeBegin, Ot["on:begin"]];
        for (const _a of Zr)
          if (_a && (_a(Ue, sn), sn.isMatchIgnored))
            return Tfe(tt);
        return Ot.skip ? An += tt : (Ot.excludeBegin && (An += tt), Qi(), !Ot.returnBegin && !Ot.excludeBegin && (An = tt)), TI(Ot, Ue), Ot.returnBegin ? 0 : tt.length;
      }
      function Mfe(Ue) {
        const tt = Ue[0], Ot = at.substring(Ue.index), sn = AI(Ct, Ue, Ot);
        if (!sn)
          return De;
        const Zr = Ct;
        Ct.endScope && Ct.endScope._wrap ? (Qi(), No(tt, Ct.endScope._wrap)) : Ct.endScope && Ct.endScope._multi ? (Qi(), CI(Ct.endScope, Ue)) : Zr.skip ? An += tt : (Zr.returnEnd || Zr.excludeEnd || (An += tt), Qi(), Zr.excludeEnd && (An = tt));
        do
          Ct.scope && Dr.closeNode(), !Ct.skip && !Ct.subLanguage && (tg += Ct.relevance), Ct = Ct.parent;
        while (Ct !== sn.parent);
        return sn.starts && TI(sn.starts, Ue), Zr.returnEnd ? 0 : tt.length;
      }
      function kfe() {
        const Ue = [];
        for (let tt = Ct; tt !== Lo; tt = tt.parent)
          tt.scope && Ue.unshift(tt.scope);
        Ue.forEach((tt) => Dr.openNode(tt));
      }
      let eg = {};
      function MI(Ue, tt) {
        const Ot = tt && tt[0];
        if (An += Ue, Ot == null)
          return Qi(), 0;
        if (eg.type === "begin" && tt.type === "end" && eg.index === tt.index && Ot === "") {
          if (An += at.slice(tt.index, tt.index + 1), !Pt) {
            const sn = new Error(`0 width match regex (${Me})`);
            throw sn.languageName = Me, sn.badRule = eg.rule, sn;
          }
          return 1;
        }
        if (eg = tt, tt.type === "begin")
          return Afe(tt);
        if (tt.type === "illegal" && !zt) {
          const sn = new Error('Illegal lexeme "' + Ot + '" for mode "' + (Ct.scope || "<unnamed>") + '"');
          throw sn.mode = Ct, sn;
        } else if (tt.type === "end") {
          const sn = Mfe(tt);
          if (sn !== De)
            return sn;
        }
        if (tt.type === "illegal" && Ot === "")
          return An += `
`, 1;
        if (Nx > 1e5 && Nx > tt.index * 3)
          throw new Error("potential infinite loop, way more iterations than matches");
        return An += Ot, Ot.length;
      }
      const Lo = Cl(Me);
      if (!Lo)
        throw ye(gt.replace("{}", Me)), new Error('Unknown language: "' + Me + '"');
      const _fe = yt(Lo);
      let Dx = "", Ct = Tn || _fe;
      const kI = {}, Dr = new $e.__emitter($e);
      kfe();
      let An = "", tg = 0, zc = 0, Nx = 0, Lx = !1;
      try {
        if (Lo.__emitTokens)
          Lo.__emitTokens(at, Dr);
        else {
          for (Ct.matcher.considerAll(); ; ) {
            Nx++, Lx ? Lx = !1 : Ct.matcher.considerAll(), Ct.matcher.lastIndex = zc;
            const Ue = Ct.matcher.exec(at);
            if (!Ue) break;
            const tt = at.substring(zc, Ue.index), Ot = MI(tt, Ue);
            zc = Ue.index + Ot;
          }
          MI(at.substring(zc));
        }
        return Dr.finalize(), Dx = Dr.toHTML(), {
          language: Me,
          value: Dx,
          relevance: tg,
          illegal: !1,
          _emitter: Dr,
          _top: Ct
        };
      } catch (Ue) {
        if (Ue.message && Ue.message.includes("Illegal"))
          return {
            language: Me,
            value: ot(at),
            illegal: !0,
            relevance: 0,
            _illegalBy: {
              message: Ue.message,
              index: zc,
              context: at.slice(zc - 100, zc + 100),
              mode: Ue.mode,
              resultSoFar: Dx
            },
            _emitter: Dr
          };
        if (Pt)
          return {
            language: Me,
            value: ot(at),
            illegal: !1,
            relevance: 0,
            errorRaised: Ue,
            _emitter: Dr,
            _top: Ct
          };
        throw Ue;
      }
    }
    function X1(Me) {
      const at = {
        value: ot(Me),
        illegal: !1,
        relevance: 0,
        _top: _e,
        _emitter: new $e.__emitter($e)
      };
      return at._emitter.addText(Me), at;
    }
    function Rx(Me, at) {
      at = at || $e.languages || Object.keys(ue);
      const zt = X1(Me), Tn = at.filter(Cl).filter(SI).map(
        (Qi) => Zi(Qi, Me, !1)
      );
      Tn.unshift(zt);
      const hr = Tn.sort((Qi, No) => {
        if (Qi.relevance !== No.relevance) return No.relevance - Qi.relevance;
        if (Qi.language && No.language) {
          if (Cl(Qi.language).supersetOf === No.language)
            return 1;
          if (Cl(No.language).supersetOf === Qi.language)
            return -1;
        }
        return 0;
      }), [Zs, Tl] = hr, J1 = Zs;
      return J1.secondBest = Tl, J1;
    }
    function pfe(Me, at, zt) {
      const Tn = at && we[at] || zt;
      Me.classList.add("hljs"), Me.classList.add(`language-${Tn}`);
    }
    function Px(Me) {
      let at = null;
      const zt = Xt(Me);
      if (Qe(zt)) return;
      if (Q1(
        "before:highlightElement",
        { el: Me, language: zt }
      ), Me.dataset.highlighted) {
        console.log("Element previously highlighted. To highlight again, first unset `dataset.highlighted`.", Me);
        return;
      }
      if (Me.children.length > 0 && ($e.ignoreUnescapedHTML || (console.warn("One of your code blocks includes unescaped HTML. This is a potentially serious security risk."), console.warn("https://github.com/highlightjs/highlight.js/wiki/security"), console.warn("The element with unescaped HTML:"), console.warn(Me)), $e.throwUnescapedHTML))
        throw new Xi(
          "One of your code blocks includes unescaped HTML.",
          Me.innerHTML
        );
      at = Me;
      const Tn = at.textContent, hr = zt ? Bn(Tn, { language: zt, ignoreIllegals: !0 }) : Rx(Tn);
      Me.innerHTML = hr.value, Me.dataset.highlighted = "yes", pfe(Me, zt, hr.language), Me.result = {
        language: hr.language,
        // TODO: remove with version 11.0
        re: hr.relevance,
        relevance: hr.relevance
      }, hr.secondBest && (Me.secondBest = {
        language: hr.secondBest.language,
        relevance: hr.secondBest.relevance
      }), Q1("after:highlightElement", { el: Me, result: hr, text: Tn });
    }
    function mfe(Me) {
      $e = Ae($e, Me);
    }
    const gfe = () => {
      Z1(), Oe("10.6.0", "initHighlighting() deprecated.  Use highlightAll() now.");
    };
    function vfe() {
      Z1(), Oe("10.6.0", "initHighlightingOnLoad() deprecated.  Use highlightAll() now.");
    }
    let xI = !1;
    function Z1() {
      function Me() {
        Z1();
      }
      if (document.readyState === "loading") {
        xI || window.addEventListener("DOMContentLoaded", Me, !1), xI = !0;
        return;
      }
      document.querySelectorAll($e.cssSelector).forEach(Px);
    }
    function yfe(Me, at) {
      let zt = null;
      try {
        zt = at(W);
      } catch (Tn) {
        if (ye("Language definition for '{}' could not be registered.".replace("{}", Me)), Pt)
          ye(Tn);
        else
          throw Tn;
        zt = _e;
      }
      zt.name || (zt.name = Me), ue[Me] = zt, zt.rawDefinition = at.bind(null, W), zt.aliases && EI(zt.aliases, { languageName: Me });
    }
    function bfe(Me) {
      delete ue[Me];
      for (const at of Object.keys(we))
        we[at] === Me && delete we[at];
    }
    function wfe() {
      return Object.keys(ue);
    }
    function Cl(Me) {
      return Me = (Me || "").toLowerCase(), ue[Me] || ue[we[Me]];
    }
    function EI(Me, { languageName: at }) {
      typeof Me == "string" && (Me = [Me]), Me.forEach((zt) => {
        we[zt.toLowerCase()] = at;
      });
    }
    function SI(Me) {
      const at = Cl(Me);
      return at && !at.disableAutodetect;
    }
    function xfe(Me) {
      Me["before:highlightBlock"] && !Me["before:highlightElement"] && (Me["before:highlightElement"] = (at) => {
        Me["before:highlightBlock"](
          Object.assign({ block: at.el }, at)
        );
      }), Me["after:highlightBlock"] && !Me["after:highlightElement"] && (Me["after:highlightElement"] = (at) => {
        Me["after:highlightBlock"](
          Object.assign({ block: at.el }, at)
        );
      });
    }
    function Efe(Me) {
      xfe(Me), Le.push(Me);
    }
    function Sfe(Me) {
      const at = Le.indexOf(Me);
      at !== -1 && Le.splice(at, 1);
    }
    function Q1(Me, at) {
      const zt = Me;
      Le.forEach(function(Tn) {
        Tn[zt] && Tn[zt](at);
      });
    }
    function Cfe(Me) {
      return Oe("10.7.0", "highlightBlock will be removed entirely in v12.0"), Oe("10.7.0", "Please use highlightElement now."), Px(Me);
    }
    Object.assign(W, {
      highlight: Bn,
      highlightAuto: Rx,
      highlightAll: Z1,
      highlightElement: Px,
      // TODO: Remove with v12 API
      highlightBlock: Cfe,
      configure: mfe,
      initHighlighting: gfe,
      initHighlightingOnLoad: vfe,
      registerLanguage: yfe,
      unregisterLanguage: bfe,
      listLanguages: wfe,
      getLanguage: Cl,
      registerAliases: EI,
      autoDetection: SI,
      inherit: Ae,
      addPlugin: Efe,
      removePlugin: Sfe
    }), W.debugMode = function() {
      Pt = !1;
    }, W.safeMode = function() {
      Pt = !0;
    }, W.versionString = vn, W.regex = {
      concat: g,
      lookahead: f,
      either: y,
      optional: m,
      anyNumberOfTimes: h
    };
    for (const Me in le)
      typeof le[Me] == "object" && n(le[Me]);
    return Object.assign(W, le), W;
  }, Ge = it({});
  return Ge.newInstance = () => it({}), A8 = Ge, Ge.HighlightJS = Ge, Ge.default = Ge, A8;
}
var Pdt = /* @__PURE__ */ Rdt();
const Oae = /* @__PURE__ */ nn(Pdt);
function Iae(n, e = []) {
  return n.flatMap((t) => {
    const r = [...e, ...t.properties ? t.properties.className : []];
    return t.children ? Iae(t.children, r) : {
      text: t.value,
      classes: r
    };
  });
}
function rj(n) {
  return n.value || n.children || [];
}
function Ddt(n) {
  return !!Oae.getLanguage(n);
}
function ij({
  doc: n,
  name: e,
  lowlight: t,
  defaultLanguage: r
}) {
  const i = [];
  return s9(n, (s) => s.type.name === e).forEach((s) => {
    var o;
    let a = s.pos + 1;
    const l = s.node.attrs.language || r, c = t.listLanguages(), u = l && (c.includes(l) || Ddt(l) || (o = t.registered) != null && o.call(t, l)) ? rj(t.highlight(l, s.node.textContent)) : rj(t.highlightAuto(s.node.textContent));
    Iae(u).forEach((d) => {
      const f = a + d.text.length;
      if (d.classes.length) {
        const h = Ro.inline(a, f, {
          class: d.classes.join(" ")
        });
        i.push(h);
      }
      a = f;
    });
  }), Nn.create(n, i);
}
function Ndt(n) {
  return typeof n == "function";
}
function Ldt({
  name: n,
  lowlight: e,
  defaultLanguage: t
}) {
  if (!["highlight", "highlightAuto", "listLanguages"].every((i) => Ndt(e[i])))
    throw Error("You should provide an instance of lowlight to use the code-block-lowlight extension");
  const r = new Cn({
    key: new _n("lowlight"),
    state: {
      init: (i, { doc: s }) => ij({
        doc: s,
        name: n,
        lowlight: e,
        defaultLanguage: t
      }),
      apply: (i, s, o, a) => {
        const l = o.selection.$head.parent.type.name, c = a.selection.$head.parent.type.name, u = s9(o.doc, (f) => f.type.name === n), d = s9(a.doc, (f) => f.type.name === n);
        return i.docChanged && // Apply decorations if:
        // selection includes named node,
        ([l, c].includes(n) || // OR transaction adds/removes named node,
        d.length !== u.length || // OR transaction has changes that completely encapsulte a node
        // (for example, a transaction that affects the entire document).
        // Such transactions can happen during collab syncing via y-prosemirror, for example.
        i.steps.some((f) => (
          // @ts-ignore
          f.from !== void 0 && // @ts-ignore
          f.to !== void 0 && u.some((h) => (
            // @ts-ignore
            h.pos >= f.from && // @ts-ignore
            h.pos + h.node.nodeSize <= f.to
          ))
        ))) ? ij({
          doc: i.doc,
          name: n,
          lowlight: e,
          defaultLanguage: t
        }) : s.map(i.mapping, i.doc);
      }
    },
    props: {
      decorations(i) {
        return r.getState(i);
      }
    }
  });
  return r;
}
var $dt = Dct.extend({
  addOptions() {
    var n;
    return {
      ...(n = this.parent) == null ? void 0 : n.call(this),
      lowlight: {},
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      enableTabIndentation: !1,
      tabSize: 4,
      HTMLAttributes: {}
    };
  },
  addProseMirrorPlugins() {
    var n;
    return [
      ...((n = this.parent) == null ? void 0 : n.call(this)) || [],
      Ldt({
        name: this.name,
        lowlight: this.options.lowlight,
        defaultLanguage: this.options.defaultLanguage
      })
    ];
  }
});
function Fdt(n) {
  const e = n.regex, t = n.COMMENT("//", "$", { contains: [{ begin: /\\\n/ }] }), r = "decltype\\(auto\\)", i = "[a-zA-Z_]\\w*::", o = "(?!struct)(" + r + "|" + e.optional(i) + "[a-zA-Z_]\\w*" + e.optional("<[^<>]+>") + ")", a = {
    className: "type",
    begin: "\\b[a-z\\d_]*_t\\b"
  }, c = {
    className: "string",
    variants: [
      {
        begin: '(u8?|U|L)?"',
        end: '"',
        illegal: "\\n",
        contains: [n.BACKSLASH_ESCAPE]
      },
      {
        begin: "(u8?|U|L)?'(" + "\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)" + "|.)",
        end: "'",
        illegal: "."
      },
      n.END_SAME_AS_BEGIN({
        begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
        end: /\)([^()\\ ]{0,16})"/
      })
    ]
  }, u = {
    className: "number",
    variants: [
      // Floating-point literal.
      {
        begin: "[+-]?(?:(?:[0-9](?:'?[0-9])*\\.(?:[0-9](?:'?[0-9])*)?|\\.[0-9](?:'?[0-9])*)(?:[Ee][+-]?[0-9](?:'?[0-9])*)?|[0-9](?:'?[0-9])*[Ee][+-]?[0-9](?:'?[0-9])*|0[Xx](?:[0-9A-Fa-f](?:'?[0-9A-Fa-f])*(?:\\.(?:[0-9A-Fa-f](?:'?[0-9A-Fa-f])*)?)?|\\.[0-9A-Fa-f](?:'?[0-9A-Fa-f])*)[Pp][+-]?[0-9](?:'?[0-9])*)(?:[Ff](?:16|32|64|128)?|(BF|bf)16|[Ll]|)"
      },
      // Integer literal.
      {
        begin: "[+-]?\\b(?:0[Bb][01](?:'?[01])*|0[Xx][0-9A-Fa-f](?:'?[0-9A-Fa-f])*|0(?:'?[0-7])*|[1-9](?:'?[0-9])*)(?:[Uu](?:LL?|ll?)|[Uu][Zz]?|(?:LL?|ll?)[Uu]?|[Zz][Uu]|)"
        // Note: there are user-defined literal suffixes too, but perhaps having the custom suffix not part of the
        // literal highlight actually makes it stand out more.
      }
    ],
    relevance: 0
  }, d = {
    className: "meta",
    begin: /#\s*[a-z]+\b/,
    end: /$/,
    keywords: { keyword: "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include" },
    contains: [
      {
        begin: /\\\n/,
        relevance: 0
      },
      n.inherit(c, { className: "string" }),
      {
        className: "string",
        begin: /<.*?>/
      },
      t,
      n.C_BLOCK_COMMENT_MODE
    ]
  }, f = {
    className: "title",
    begin: e.optional(i) + n.IDENT_RE,
    relevance: 0
  }, h = e.optional(i) + n.IDENT_RE + "\\s*\\(", m = [
    "alignas",
    "alignof",
    "and",
    "and_eq",
    "asm",
    "atomic_cancel",
    "atomic_commit",
    "atomic_noexcept",
    "auto",
    "bitand",
    "bitor",
    "break",
    "case",
    "catch",
    "class",
    "co_await",
    "co_return",
    "co_yield",
    "compl",
    "concept",
    "const_cast|10",
    "consteval",
    "constexpr",
    "constinit",
    "continue",
    "decltype",
    "default",
    "delete",
    "do",
    "dynamic_cast|10",
    "else",
    "enum",
    "explicit",
    "export",
    "extern",
    "false",
    "final",
    "for",
    "friend",
    "goto",
    "if",
    "import",
    "inline",
    "module",
    "mutable",
    "namespace",
    "new",
    "noexcept",
    "not",
    "not_eq",
    "nullptr",
    "operator",
    "or",
    "or_eq",
    "override",
    "private",
    "protected",
    "public",
    "reflexpr",
    "register",
    "reinterpret_cast|10",
    "requires",
    "return",
    "sizeof",
    "static_assert",
    "static_cast|10",
    "struct",
    "switch",
    "synchronized",
    "template",
    "this",
    "thread_local",
    "throw",
    "transaction_safe",
    "transaction_safe_dynamic",
    "true",
    "try",
    "typedef",
    "typeid",
    "typename",
    "union",
    "using",
    "virtual",
    "volatile",
    "while",
    "xor",
    "xor_eq"
  ], g = [
    "bool",
    "char",
    "char16_t",
    "char32_t",
    "char8_t",
    "double",
    "float",
    "int",
    "long",
    "short",
    "void",
    "wchar_t",
    "unsigned",
    "signed",
    "const",
    "static"
  ], v = [
    "any",
    "auto_ptr",
    "barrier",
    "binary_semaphore",
    "bitset",
    "complex",
    "condition_variable",
    "condition_variable_any",
    "counting_semaphore",
    "deque",
    "false_type",
    "flat_map",
    "flat_set",
    "future",
    "imaginary",
    "initializer_list",
    "istringstream",
    "jthread",
    "latch",
    "lock_guard",
    "multimap",
    "multiset",
    "mutex",
    "optional",
    "ostringstream",
    "packaged_task",
    "pair",
    "promise",
    "priority_queue",
    "queue",
    "recursive_mutex",
    "recursive_timed_mutex",
    "scoped_lock",
    "set",
    "shared_future",
    "shared_lock",
    "shared_mutex",
    "shared_timed_mutex",
    "shared_ptr",
    "stack",
    "string_view",
    "stringstream",
    "timed_mutex",
    "thread",
    "true_type",
    "tuple",
    "unique_lock",
    "unique_ptr",
    "unordered_map",
    "unordered_multimap",
    "unordered_multiset",
    "unordered_set",
    "variant",
    "vector",
    "weak_ptr",
    "wstring",
    "wstring_view"
  ], y = [
    "abort",
    "abs",
    "acos",
    "apply",
    "as_const",
    "asin",
    "atan",
    "atan2",
    "calloc",
    "ceil",
    "cerr",
    "cin",
    "clog",
    "cos",
    "cosh",
    "cout",
    "declval",
    "endl",
    "exchange",
    "exit",
    "exp",
    "fabs",
    "floor",
    "fmod",
    "forward",
    "fprintf",
    "fputs",
    "free",
    "frexp",
    "fscanf",
    "future",
    "invoke",
    "isalnum",
    "isalpha",
    "iscntrl",
    "isdigit",
    "isgraph",
    "islower",
    "isprint",
    "ispunct",
    "isspace",
    "isupper",
    "isxdigit",
    "labs",
    "launder",
    "ldexp",
    "log",
    "log10",
    "make_pair",
    "make_shared",
    "make_shared_for_overwrite",
    "make_tuple",
    "make_unique",
    "malloc",
    "memchr",
    "memcmp",
    "memcpy",
    "memset",
    "modf",
    "move",
    "pow",
    "printf",
    "putchar",
    "puts",
    "realloc",
    "scanf",
    "sin",
    "sinh",
    "snprintf",
    "sprintf",
    "sqrt",
    "sscanf",
    "std",
    "stderr",
    "stdin",
    "stdout",
    "strcat",
    "strchr",
    "strcmp",
    "strcpy",
    "strcspn",
    "strlen",
    "strncat",
    "strncmp",
    "strncpy",
    "strpbrk",
    "strrchr",
    "strspn",
    "strstr",
    "swap",
    "tan",
    "tanh",
    "terminate",
    "to_underlying",
    "tolower",
    "toupper",
    "vfprintf",
    "visit",
    "vprintf",
    "vsprintf"
  ], E = {
    type: g,
    keyword: m,
    literal: [
      "NULL",
      "false",
      "nullopt",
      "nullptr",
      "true"
    ],
    built_in: ["_Pragma"],
    _type_hints: v
  }, w = {
    className: "function.dispatch",
    relevance: 0,
    keywords: {
      // Only for relevance, not highlighting.
      _hint: y
    },
    begin: e.concat(
      /\b/,
      /(?!decltype)/,
      /(?!if)/,
      /(?!for)/,
      /(?!switch)/,
      /(?!while)/,
      n.IDENT_RE,
      e.lookahead(/(<[^<>]+>|)\s*\(/)
    )
  }, C = [
    w,
    d,
    a,
    t,
    n.C_BLOCK_COMMENT_MODE,
    u,
    c
  ], S = {
    // This mode covers expression context where we can't expect a function
    // definition and shouldn't highlight anything that looks like one:
    // `return some()`, `else if()`, `(x*sum(1, 2))`
    variants: [
      {
        begin: /=/,
        end: /;/
      },
      {
        begin: /\(/,
        end: /\)/
      },
      {
        beginKeywords: "new throw return else",
        end: /;/
      }
    ],
    keywords: E,
    contains: C.concat([
      {
        begin: /\(/,
        end: /\)/,
        keywords: E,
        contains: C.concat(["self"]),
        relevance: 0
      }
    ]),
    relevance: 0
  }, M = {
    className: "function",
    begin: "(" + o + "[\\*&\\s]+)+" + h,
    returnBegin: !0,
    end: /[{;=]/,
    excludeEnd: !0,
    keywords: E,
    illegal: /[^\w\s\*&:<>.]/,
    contains: [
      {
        // to prevent it from being confused as the function title
        begin: r,
        keywords: E,
        relevance: 0
      },
      {
        begin: h,
        returnBegin: !0,
        contains: [f],
        relevance: 0
      },
      // needed because we do not have look-behind on the below rule
      // to prevent it from grabbing the final : in a :: pair
      {
        begin: /::/,
        relevance: 0
      },
      // initializers
      {
        begin: /:/,
        endsWithParent: !0,
        contains: [
          c,
          u
        ]
      },
      // allow for multiple declarations, e.g.:
      // extern void f(int), g(char);
      {
        relevance: 0,
        match: /,/
      },
      {
        className: "params",
        begin: /\(/,
        end: /\)/,
        keywords: E,
        relevance: 0,
        contains: [
          t,
          n.C_BLOCK_COMMENT_MODE,
          c,
          u,
          a,
          // Count matching parentheses.
          {
            begin: /\(/,
            end: /\)/,
            keywords: E,
            relevance: 0,
            contains: [
              "self",
              t,
              n.C_BLOCK_COMMENT_MODE,
              c,
              u,
              a
            ]
          }
        ]
      },
      a,
      t,
      n.C_BLOCK_COMMENT_MODE,
      d
    ]
  };
  return {
    name: "C++",
    aliases: [
      "cc",
      "c++",
      "h++",
      "hpp",
      "hh",
      "hxx",
      "cxx"
    ],
    keywords: E,
    illegal: "</",
    classNameAliases: { "function.dispatch": "built_in" },
    contains: [].concat(
      S,
      M,
      w,
      C,
      [
        d,
        {
          // containers: ie, `vector <int> rooms (9);`
          begin: "\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array|tuple|optional|variant|function|flat_map|flat_set)\\s*<(?!<)",
          end: ">",
          keywords: E,
          contains: [
            "self",
            a
          ]
        },
        {
          begin: n.IDENT_RE + "::",
          keywords: E
        },
        {
          match: [
            // extra complexity to deal with `enum class` and `enum struct`
            /\b(?:enum(?:\s+(?:class|struct))?|class|struct|union)/,
            /\s+/,
            /\w+/
          ],
          className: {
            1: "keyword",
            3: "title.class"
          }
        }
      ]
    )
  };
}
function Bdt(n) {
  const e = {
    type: [
      "boolean",
      "byte",
      "word",
      "String"
    ],
    built_in: [
      "KeyboardController",
      "MouseController",
      "SoftwareSerial",
      "EthernetServer",
      "EthernetClient",
      "LiquidCrystal",
      "RobotControl",
      "GSMVoiceCall",
      "EthernetUDP",
      "EsploraTFT",
      "HttpClient",
      "RobotMotor",
      "WiFiClient",
      "GSMScanner",
      "FileSystem",
      "Scheduler",
      "GSMServer",
      "YunClient",
      "YunServer",
      "IPAddress",
      "GSMClient",
      "GSMModem",
      "Keyboard",
      "Ethernet",
      "Console",
      "GSMBand",
      "Esplora",
      "Stepper",
      "Process",
      "WiFiUDP",
      "GSM_SMS",
      "Mailbox",
      "USBHost",
      "Firmata",
      "PImage",
      "Client",
      "Server",
      "GSMPIN",
      "FileIO",
      "Bridge",
      "Serial",
      "EEPROM",
      "Stream",
      "Mouse",
      "Audio",
      "Servo",
      "File",
      "Task",
      "GPRS",
      "WiFi",
      "Wire",
      "TFT",
      "GSM",
      "SPI",
      "SD"
    ],
    _hints: [
      "setup",
      "loop",
      "runShellCommandAsynchronously",
      "analogWriteResolution",
      "retrieveCallingNumber",
      "printFirmwareVersion",
      "analogReadResolution",
      "sendDigitalPortPair",
      "noListenOnLocalhost",
      "readJoystickButton",
      "setFirmwareVersion",
      "readJoystickSwitch",
      "scrollDisplayRight",
      "getVoiceCallStatus",
      "scrollDisplayLeft",
      "writeMicroseconds",
      "delayMicroseconds",
      "beginTransmission",
      "getSignalStrength",
      "runAsynchronously",
      "getAsynchronously",
      "listenOnLocalhost",
      "getCurrentCarrier",
      "readAccelerometer",
      "messageAvailable",
      "sendDigitalPorts",
      "lineFollowConfig",
      "countryNameWrite",
      "runShellCommand",
      "readStringUntil",
      "rewindDirectory",
      "readTemperature",
      "setClockDivider",
      "readLightSensor",
      "endTransmission",
      "analogReference",
      "detachInterrupt",
      "countryNameRead",
      "attachInterrupt",
      "encryptionType",
      "readBytesUntil",
      "robotNameWrite",
      "readMicrophone",
      "robotNameRead",
      "cityNameWrite",
      "userNameWrite",
      "readJoystickY",
      "readJoystickX",
      "mouseReleased",
      "openNextFile",
      "scanNetworks",
      "noInterrupts",
      "digitalWrite",
      "beginSpeaker",
      "mousePressed",
      "isActionDone",
      "mouseDragged",
      "displayLogos",
      "noAutoscroll",
      "addParameter",
      "remoteNumber",
      "getModifiers",
      "keyboardRead",
      "userNameRead",
      "waitContinue",
      "processInput",
      "parseCommand",
      "printVersion",
      "readNetworks",
      "writeMessage",
      "blinkVersion",
      "cityNameRead",
      "readMessage",
      "setDataMode",
      "parsePacket",
      "isListening",
      "setBitOrder",
      "beginPacket",
      "isDirectory",
      "motorsWrite",
      "drawCompass",
      "digitalRead",
      "clearScreen",
      "serialEvent",
      "rightToLeft",
      "setTextSize",
      "leftToRight",
      "requestFrom",
      "keyReleased",
      "compassRead",
      "analogWrite",
      "interrupts",
      "WiFiServer",
      "disconnect",
      "playMelody",
      "parseFloat",
      "autoscroll",
      "getPINUsed",
      "setPINUsed",
      "setTimeout",
      "sendAnalog",
      "readSlider",
      "analogRead",
      "beginWrite",
      "createChar",
      "motorsStop",
      "keyPressed",
      "tempoWrite",
      "readButton",
      "subnetMask",
      "debugPrint",
      "macAddress",
      "writeGreen",
      "randomSeed",
      "attachGPRS",
      "readString",
      "sendString",
      "remotePort",
      "releaseAll",
      "mouseMoved",
      "background",
      "getXChange",
      "getYChange",
      "answerCall",
      "getResult",
      "voiceCall",
      "endPacket",
      "constrain",
      "getSocket",
      "writeJSON",
      "getButton",
      "available",
      "connected",
      "findUntil",
      "readBytes",
      "exitValue",
      "readGreen",
      "writeBlue",
      "startLoop",
      "IPAddress",
      "isPressed",
      "sendSysex",
      "pauseMode",
      "gatewayIP",
      "setCursor",
      "getOemKey",
      "tuneWrite",
      "noDisplay",
      "loadImage",
      "switchPIN",
      "onRequest",
      "onReceive",
      "changePIN",
      "playFile",
      "noBuffer",
      "parseInt",
      "overflow",
      "checkPIN",
      "knobRead",
      "beginTFT",
      "bitClear",
      "updateIR",
      "bitWrite",
      "position",
      "writeRGB",
      "highByte",
      "writeRed",
      "setSpeed",
      "readBlue",
      "noStroke",
      "remoteIP",
      "transfer",
      "shutdown",
      "hangCall",
      "beginSMS",
      "endWrite",
      "attached",
      "maintain",
      "noCursor",
      "checkReg",
      "checkPUK",
      "shiftOut",
      "isValid",
      "shiftIn",
      "pulseIn",
      "connect",
      "println",
      "localIP",
      "pinMode",
      "getIMEI",
      "display",
      "noBlink",
      "process",
      "getBand",
      "running",
      "beginSD",
      "drawBMP",
      "lowByte",
      "setBand",
      "release",
      "bitRead",
      "prepare",
      "pointTo",
      "readRed",
      "setMode",
      "noFill",
      "remove",
      "listen",
      "stroke",
      "detach",
      "attach",
      "noTone",
      "exists",
      "buffer",
      "height",
      "bitSet",
      "circle",
      "config",
      "cursor",
      "random",
      "IRread",
      "setDNS",
      "endSMS",
      "getKey",
      "micros",
      "millis",
      "begin",
      "print",
      "write",
      "ready",
      "flush",
      "width",
      "isPIN",
      "blink",
      "clear",
      "press",
      "mkdir",
      "rmdir",
      "close",
      "point",
      "yield",
      "image",
      "BSSID",
      "click",
      "delay",
      "read",
      "text",
      "move",
      "peek",
      "beep",
      "rect",
      "line",
      "open",
      "seek",
      "fill",
      "size",
      "turn",
      "stop",
      "home",
      "find",
      "step",
      "tone",
      "sqrt",
      "RSSI",
      "SSID",
      "end",
      "bit",
      "tan",
      "cos",
      "sin",
      "pow",
      "map",
      "abs",
      "max",
      "min",
      "get",
      "run",
      "put"
    ],
    literal: [
      "DIGITAL_MESSAGE",
      "FIRMATA_STRING",
      "ANALOG_MESSAGE",
      "REPORT_DIGITAL",
      "REPORT_ANALOG",
      "INPUT_PULLUP",
      "SET_PIN_MODE",
      "INTERNAL2V56",
      "SYSTEM_RESET",
      "LED_BUILTIN",
      "INTERNAL1V1",
      "SYSEX_START",
      "INTERNAL",
      "EXTERNAL",
      "DEFAULT",
      "OUTPUT",
      "INPUT",
      "HIGH",
      "LOW"
    ]
  }, t = Fdt(n), r = (
    /** @type {Record<string,any>} */
    t.keywords
  );
  return r.type = [
    ...r.type,
    ...e.type
  ], r.literal = [
    ...r.literal,
    ...e.literal
  ], r.built_in = [
    ...r.built_in,
    ...e.built_in
  ], r._hints = e._hints, t.name = "Arduino", t.aliases = ["ino"], t.supersetOf = "cpp", t;
}
function zdt(n) {
  const e = n.regex, t = {}, r = {
    begin: /\$\{/,
    end: /\}/,
    contains: [
      "self",
      {
        begin: /:-/,
        contains: [t]
      }
      // default values
    ]
  };
  Object.assign(t, {
    className: "variable",
    variants: [
      { begin: e.concat(
        /\$[\w\d#@][\w\d_]*/,
        // negative look-ahead tries to avoid matching patterns that are not
        // Perl at all like $ident$, @ident@, etc.
        "(?![\\w\\d])(?![$])"
      ) },
      r
    ]
  });
  const i = {
    className: "subst",
    begin: /\$\(/,
    end: /\)/,
    contains: [n.BACKSLASH_ESCAPE]
  }, s = n.inherit(
    n.COMMENT(),
    {
      match: [
        /(^|\s)/,
        /#.*$/
      ],
      scope: {
        2: "comment"
      }
    }
  ), o = {
    begin: /<<-?\s*(?=\w+)/,
    starts: { contains: [
      n.END_SAME_AS_BEGIN({
        begin: /(\w+)/,
        end: /(\w+)/,
        className: "string"
      })
    ] }
  }, a = {
    className: "string",
    begin: /"/,
    end: /"/,
    contains: [
      n.BACKSLASH_ESCAPE,
      t,
      i
    ]
  };
  i.contains.push(a);
  const l = {
    match: /\\"/
  }, c = {
    className: "string",
    begin: /'/,
    end: /'/
  }, u = {
    match: /\\'/
  }, d = {
    begin: /\$?\(\(/,
    end: /\)\)/,
    contains: [
      {
        begin: /\d+#[0-9a-f]+/,
        className: "number"
      },
      n.NUMBER_MODE,
      t
    ]
  }, f = [
    "fish",
    "bash",
    "zsh",
    "sh",
    "csh",
    "ksh",
    "tcsh",
    "dash",
    "scsh"
  ], h = n.SHEBANG({
    binary: `(${f.join("|")})`,
    relevance: 10
  }), m = {
    className: "function",
    begin: /\w[\w\d_]*\s*\(\s*\)\s*\{/,
    returnBegin: !0,
    contains: [n.inherit(n.TITLE_MODE, { begin: /\w[\w\d_]*/ })],
    relevance: 0
  }, g = [
    "if",
    "then",
    "else",
    "elif",
    "fi",
    "time",
    "for",
    "while",
    "until",
    "in",
    "do",
    "done",
    "case",
    "esac",
    "coproc",
    "function",
    "select"
  ], v = [
    "true",
    "false"
  ], y = { match: /(\/[a-z._-]+)+/ }, b = [
    "break",
    "cd",
    "continue",
    "eval",
    "exec",
    "exit",
    "export",
    "getopts",
    "hash",
    "pwd",
    "readonly",
    "return",
    "shift",
    "test",
    "times",
    "trap",
    "umask",
    "unset"
  ], x = [
    "alias",
    "bind",
    "builtin",
    "caller",
    "command",
    "declare",
    "echo",
    "enable",
    "help",
    "let",
    "local",
    "logout",
    "mapfile",
    "printf",
    "read",
    "readarray",
    "source",
    "sudo",
    "type",
    "typeset",
    "ulimit",
    "unalias"
  ], E = [
    "autoload",
    "bg",
    "bindkey",
    "bye",
    "cap",
    "chdir",
    "clone",
    "comparguments",
    "compcall",
    "compctl",
    "compdescribe",
    "compfiles",
    "compgroups",
    "compquote",
    "comptags",
    "comptry",
    "compvalues",
    "dirs",
    "disable",
    "disown",
    "echotc",
    "echoti",
    "emulate",
    "fc",
    "fg",
    "float",
    "functions",
    "getcap",
    "getln",
    "history",
    "integer",
    "jobs",
    "kill",
    "limit",
    "log",
    "noglob",
    "popd",
    "print",
    "pushd",
    "pushln",
    "rehash",
    "sched",
    "setcap",
    "setopt",
    "stat",
    "suspend",
    "ttyctl",
    "unfunction",
    "unhash",
    "unlimit",
    "unsetopt",
    "vared",
    "wait",
    "whence",
    "where",
    "which",
    "zcompile",
    "zformat",
    "zftp",
    "zle",
    "zmodload",
    "zparseopts",
    "zprof",
    "zpty",
    "zregexparse",
    "zsocket",
    "zstyle",
    "ztcp"
  ], w = [
    "chcon",
    "chgrp",
    "chown",
    "chmod",
    "cp",
    "dd",
    "df",
    "dir",
    "dircolors",
    "ln",
    "ls",
    "mkdir",
    "mkfifo",
    "mknod",
    "mktemp",
    "mv",
    "realpath",
    "rm",
    "rmdir",
    "shred",
    "sync",
    "touch",
    "truncate",
    "vdir",
    "b2sum",
    "base32",
    "base64",
    "cat",
    "cksum",
    "comm",
    "csplit",
    "cut",
    "expand",
    "fmt",
    "fold",
    "head",
    "join",
    "md5sum",
    "nl",
    "numfmt",
    "od",
    "paste",
    "ptx",
    "pr",
    "sha1sum",
    "sha224sum",
    "sha256sum",
    "sha384sum",
    "sha512sum",
    "shuf",
    "sort",
    "split",
    "sum",
    "tac",
    "tail",
    "tr",
    "tsort",
    "unexpand",
    "uniq",
    "wc",
    "arch",
    "basename",
    "chroot",
    "date",
    "dirname",
    "du",
    "echo",
    "env",
    "expr",
    "factor",
    // "false", // keyword literal already
    "groups",
    "hostid",
    "id",
    "link",
    "logname",
    "nice",
    "nohup",
    "nproc",
    "pathchk",
    "pinky",
    "printenv",
    "printf",
    "pwd",
    "readlink",
    "runcon",
    "seq",
    "sleep",
    "stat",
    "stdbuf",
    "stty",
    "tee",
    "test",
    "timeout",
    // "true", // keyword literal already
    "tty",
    "uname",
    "unlink",
    "uptime",
    "users",
    "who",
    "whoami",
    "yes"
  ];
  return {
    name: "Bash",
    aliases: [
      "sh",
      "zsh"
    ],
    keywords: {
      $pattern: /\b[a-z][a-z0-9._-]+\b/,
      keyword: g,
      literal: v,
      built_in: [
        ...b,
        ...x,
        // Shell modifiers
        "set",
        "shopt",
        ...E,
        ...w
      ]
    },
    contains: [
      h,
      // to catch known shells and boost relevancy
      n.SHEBANG(),
      // to catch unknown shells but still highlight the shebang
      m,
      d,
      s,
      o,
      y,
      a,
      l,
      c,
      u,
      t
    ]
  };
}
function Hdt(n) {
  const e = n.regex, t = n.COMMENT("//", "$", { contains: [{ begin: /\\\n/ }] }), r = "decltype\\(auto\\)", i = "[a-zA-Z_]\\w*::", o = "(" + r + "|" + e.optional(i) + "[a-zA-Z_]\\w*" + e.optional("<[^<>]+>") + ")", a = {
    className: "type",
    variants: [
      { begin: "\\b[a-z\\d_]*_t\\b" },
      { match: /\batomic_[a-z]{3,6}\b/ }
    ]
  }, c = {
    className: "string",
    variants: [
      {
        begin: '(u8?|U|L)?"',
        end: '"',
        illegal: "\\n",
        contains: [n.BACKSLASH_ESCAPE]
      },
      {
        begin: "(u8?|U|L)?'(" + "\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)" + "|.)",
        end: "'",
        illegal: "."
      },
      n.END_SAME_AS_BEGIN({
        begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
        end: /\)([^()\\ ]{0,16})"/
      })
    ]
  }, u = {
    className: "number",
    variants: [
      { match: /\b(0b[01']+)/ },
      { match: /(-?)\b([\d']+(\.[\d']*)?|\.[\d']+)((ll|LL|l|L)(u|U)?|(u|U)(ll|LL|l|L)?|f|F|b|B)/ },
      { match: /(-?)\b(0[xX][a-fA-F0-9]+(?:'[a-fA-F0-9]+)*(?:\.[a-fA-F0-9]*(?:'[a-fA-F0-9]*)*)?(?:[pP][-+]?[0-9]+)?(l|L)?(u|U)?)/ },
      { match: /(-?)\b\d+(?:'\d+)*(?:\.\d*(?:'\d*)*)?(?:[eE][-+]?\d+)?/ }
    ],
    relevance: 0
  }, d = {
    className: "meta",
    begin: /#\s*[a-z]+\b/,
    end: /$/,
    keywords: { keyword: "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef elifdef elifndef include" },
    contains: [
      {
        begin: /\\\n/,
        relevance: 0
      },
      n.inherit(c, { className: "string" }),
      {
        className: "string",
        begin: /<.*?>/
      },
      t,
      n.C_BLOCK_COMMENT_MODE
    ]
  }, f = {
    className: "title",
    begin: e.optional(i) + n.IDENT_RE,
    relevance: 0
  }, h = e.optional(i) + n.IDENT_RE + "\\s*\\(", v = {
    keyword: [
      "asm",
      "auto",
      "break",
      "case",
      "continue",
      "default",
      "do",
      "else",
      "enum",
      "extern",
      "for",
      "fortran",
      "goto",
      "if",
      "inline",
      "register",
      "restrict",
      "return",
      "sizeof",
      "typeof",
      "typeof_unqual",
      "struct",
      "switch",
      "typedef",
      "union",
      "volatile",
      "while",
      "_Alignas",
      "_Alignof",
      "_Atomic",
      "_Generic",
      "_Noreturn",
      "_Static_assert",
      "_Thread_local",
      // aliases
      "alignas",
      "alignof",
      "noreturn",
      "static_assert",
      "thread_local",
      // not a C keyword but is, for all intents and purposes, treated exactly like one.
      "_Pragma"
    ],
    type: [
      "float",
      "double",
      "signed",
      "unsigned",
      "int",
      "short",
      "long",
      "char",
      "void",
      "_Bool",
      "_BitInt",
      "_Complex",
      "_Imaginary",
      "_Decimal32",
      "_Decimal64",
      "_Decimal96",
      "_Decimal128",
      "_Decimal64x",
      "_Decimal128x",
      "_Float16",
      "_Float32",
      "_Float64",
      "_Float128",
      "_Float32x",
      "_Float64x",
      "_Float128x",
      // modifiers
      "const",
      "static",
      "constexpr",
      // aliases
      "complex",
      "bool",
      "imaginary"
    ],
    literal: "true false NULL",
    // TODO: apply hinting work similar to what was done in cpp.js
    built_in: "std string wstring cin cout cerr clog stdin stdout stderr stringstream istringstream ostringstream auto_ptr deque list queue stack vector map set pair bitset multiset multimap unordered_set unordered_map unordered_multiset unordered_multimap priority_queue make_pair array shared_ptr abort terminate abs acos asin atan2 atan calloc ceil cosh cos exit exp fabs floor fmod fprintf fputs free frexp fscanf future isalnum isalpha iscntrl isdigit isgraph islower isprint ispunct isspace isupper isxdigit tolower toupper labs ldexp log10 log malloc realloc memchr memcmp memcpy memset modf pow printf putchar puts scanf sinh sin snprintf sprintf sqrt sscanf strcat strchr strcmp strcpy strcspn strlen strncat strncmp strncpy strpbrk strrchr strspn strstr tanh tan vfprintf vprintf vsprintf endl initializer_list unique_ptr"
  }, y = [
    d,
    a,
    t,
    n.C_BLOCK_COMMENT_MODE,
    u,
    c
  ], b = {
    // This mode covers expression context where we can't expect a function
    // definition and shouldn't highlight anything that looks like one:
    // `return some()`, `else if()`, `(x*sum(1, 2))`
    variants: [
      {
        begin: /=/,
        end: /;/
      },
      {
        begin: /\(/,
        end: /\)/
      },
      {
        beginKeywords: "new throw return else",
        end: /;/
      }
    ],
    keywords: v,
    contains: y.concat([
      {
        begin: /\(/,
        end: /\)/,
        keywords: v,
        contains: y.concat(["self"]),
        relevance: 0
      }
    ]),
    relevance: 0
  }, x = {
    begin: "(" + o + "[\\*&\\s]+)+" + h,
    returnBegin: !0,
    end: /[{;=]/,
    excludeEnd: !0,
    keywords: v,
    illegal: /[^\w\s\*&:<>.]/,
    contains: [
      {
        // to prevent it from being confused as the function title
        begin: r,
        keywords: v,
        relevance: 0
      },
      {
        begin: h,
        returnBegin: !0,
        contains: [n.inherit(f, { className: "title.function" })],
        relevance: 0
      },
      // allow for multiple declarations, e.g.:
      // extern void f(int), g(char);
      {
        relevance: 0,
        match: /,/
      },
      {
        className: "params",
        begin: /\(/,
        end: /\)/,
        keywords: v,
        relevance: 0,
        contains: [
          t,
          n.C_BLOCK_COMMENT_MODE,
          c,
          u,
          a,
          // Count matching parentheses.
          {
            begin: /\(/,
            end: /\)/,
            keywords: v,
            relevance: 0,
            contains: [
              "self",
              t,
              n.C_BLOCK_COMMENT_MODE,
              c,
              u,
              a
            ]
          }
        ]
      },
      a,
      t,
      n.C_BLOCK_COMMENT_MODE,
      d
    ]
  };
  return {
    name: "C",
    aliases: ["h"],
    keywords: v,
    // Until differentiations are added between `c` and `cpp`, `c` will
    // not be auto-detected to avoid auto-detect conflicts between C and C++
    disableAutodetect: !0,
    illegal: "</",
    contains: [].concat(
      b,
      x,
      y,
      [
        d,
        {
          begin: n.IDENT_RE + "::",
          keywords: v
        },
        {
          className: "class",
          beginKeywords: "enum class struct union",
          end: /[{;:<>=]/,
          contains: [
            { beginKeywords: "final class struct" },
            n.TITLE_MODE
          ]
        }
      ]
    ),
    exports: {
      preprocessor: d,
      strings: c,
      keywords: v
    }
  };
}
function Udt(n) {
  const e = n.regex, t = n.COMMENT("//", "$", { contains: [{ begin: /\\\n/ }] }), r = "decltype\\(auto\\)", i = "[a-zA-Z_]\\w*::", o = "(?!struct)(" + r + "|" + e.optional(i) + "[a-zA-Z_]\\w*" + e.optional("<[^<>]+>") + ")", a = {
    className: "type",
    begin: "\\b[a-z\\d_]*_t\\b"
  }, c = {
    className: "string",
    variants: [
      {
        begin: '(u8?|U|L)?"',
        end: '"',
        illegal: "\\n",
        contains: [n.BACKSLASH_ESCAPE]
      },
      {
        begin: "(u8?|U|L)?'(" + "\\\\(x[0-9A-Fa-f]{2}|u[0-9A-Fa-f]{4,8}|[0-7]{3}|\\S)" + "|.)",
        end: "'",
        illegal: "."
      },
      n.END_SAME_AS_BEGIN({
        begin: /(?:u8?|U|L)?R"([^()\\ ]{0,16})\(/,
        end: /\)([^()\\ ]{0,16})"/
      })
    ]
  }, u = {
    className: "number",
    variants: [
      // Floating-point literal.
      {
        begin: "[+-]?(?:(?:[0-9](?:'?[0-9])*\\.(?:[0-9](?:'?[0-9])*)?|\\.[0-9](?:'?[0-9])*)(?:[Ee][+-]?[0-9](?:'?[0-9])*)?|[0-9](?:'?[0-9])*[Ee][+-]?[0-9](?:'?[0-9])*|0[Xx](?:[0-9A-Fa-f](?:'?[0-9A-Fa-f])*(?:\\.(?:[0-9A-Fa-f](?:'?[0-9A-Fa-f])*)?)?|\\.[0-9A-Fa-f](?:'?[0-9A-Fa-f])*)[Pp][+-]?[0-9](?:'?[0-9])*)(?:[Ff](?:16|32|64|128)?|(BF|bf)16|[Ll]|)"
      },
      // Integer literal.
      {
        begin: "[+-]?\\b(?:0[Bb][01](?:'?[01])*|0[Xx][0-9A-Fa-f](?:'?[0-9A-Fa-f])*|0(?:'?[0-7])*|[1-9](?:'?[0-9])*)(?:[Uu](?:LL?|ll?)|[Uu][Zz]?|(?:LL?|ll?)[Uu]?|[Zz][Uu]|)"
        // Note: there are user-defined literal suffixes too, but perhaps having the custom suffix not part of the
        // literal highlight actually makes it stand out more.
      }
    ],
    relevance: 0
  }, d = {
    className: "meta",
    begin: /#\s*[a-z]+\b/,
    end: /$/,
    keywords: { keyword: "if else elif endif define undef warning error line pragma _Pragma ifdef ifndef include" },
    contains: [
      {
        begin: /\\\n/,
        relevance: 0
      },
      n.inherit(c, { className: "string" }),
      {
        className: "string",
        begin: /<.*?>/
      },
      t,
      n.C_BLOCK_COMMENT_MODE
    ]
  }, f = {
    className: "title",
    begin: e.optional(i) + n.IDENT_RE,
    relevance: 0
  }, h = e.optional(i) + n.IDENT_RE + "\\s*\\(", m = [
    "alignas",
    "alignof",
    "and",
    "and_eq",
    "asm",
    "atomic_cancel",
    "atomic_commit",
    "atomic_noexcept",
    "auto",
    "bitand",
    "bitor",
    "break",
    "case",
    "catch",
    "class",
    "co_await",
    "co_return",
    "co_yield",
    "compl",
    "concept",
    "const_cast|10",
    "consteval",
    "constexpr",
    "constinit",
    "continue",
    "decltype",
    "default",
    "delete",
    "do",
    "dynamic_cast|10",
    "else",
    "enum",
    "explicit",
    "export",
    "extern",
    "false",
    "final",
    "for",
    "friend",
    "goto",
    "if",
    "import",
    "inline",
    "module",
    "mutable",
    "namespace",
    "new",
    "noexcept",
    "not",
    "not_eq",
    "nullptr",
    "operator",
    "or",
    "or_eq",
    "override",
    "private",
    "protected",
    "public",
    "reflexpr",
    "register",
    "reinterpret_cast|10",
    "requires",
    "return",
    "sizeof",
    "static_assert",
    "static_cast|10",
    "struct",
    "switch",
    "synchronized",
    "template",
    "this",
    "thread_local",
    "throw",
    "transaction_safe",
    "transaction_safe_dynamic",
    "true",
    "try",
    "typedef",
    "typeid",
    "typename",
    "union",
    "using",
    "virtual",
    "volatile",
    "while",
    "xor",
    "xor_eq"
  ], g = [
    "bool",
    "char",
    "char16_t",
    "char32_t",
    "char8_t",
    "double",
    "float",
    "int",
    "long",
    "short",
    "void",
    "wchar_t",
    "unsigned",
    "signed",
    "const",
    "static"
  ], v = [
    "any",
    "auto_ptr",
    "barrier",
    "binary_semaphore",
    "bitset",
    "complex",
    "condition_variable",
    "condition_variable_any",
    "counting_semaphore",
    "deque",
    "false_type",
    "flat_map",
    "flat_set",
    "future",
    "imaginary",
    "initializer_list",
    "istringstream",
    "jthread",
    "latch",
    "lock_guard",
    "multimap",
    "multiset",
    "mutex",
    "optional",
    "ostringstream",
    "packaged_task",
    "pair",
    "promise",
    "priority_queue",
    "queue",
    "recursive_mutex",
    "recursive_timed_mutex",
    "scoped_lock",
    "set",
    "shared_future",
    "shared_lock",
    "shared_mutex",
    "shared_timed_mutex",
    "shared_ptr",
    "stack",
    "string_view",
    "stringstream",
    "timed_mutex",
    "thread",
    "true_type",
    "tuple",
    "unique_lock",
    "unique_ptr",
    "unordered_map",
    "unordered_multimap",
    "unordered_multiset",
    "unordered_set",
    "variant",
    "vector",
    "weak_ptr",
    "wstring",
    "wstring_view"
  ], y = [
    "abort",
    "abs",
    "acos",
    "apply",
    "as_const",
    "asin",
    "atan",
    "atan2",
    "calloc",
    "ceil",
    "cerr",
    "cin",
    "clog",
    "cos",
    "cosh",
    "cout",
    "declval",
    "endl",
    "exchange",
    "exit",
    "exp",
    "fabs",
    "floor",
    "fmod",
    "forward",
    "fprintf",
    "fputs",
    "free",
    "frexp",
    "fscanf",
    "future",
    "invoke",
    "isalnum",
    "isalpha",
    "iscntrl",
    "isdigit",
    "isgraph",
    "islower",
    "isprint",
    "ispunct",
    "isspace",
    "isupper",
    "isxdigit",
    "labs",
    "launder",
    "ldexp",
    "log",
    "log10",
    "make_pair",
    "make_shared",
    "make_shared_for_overwrite",
    "make_tuple",
    "make_unique",
    "malloc",
    "memchr",
    "memcmp",
    "memcpy",
    "memset",
    "modf",
    "move",
    "pow",
    "printf",
    "putchar",
    "puts",
    "realloc",
    "scanf",
    "sin",
    "sinh",
    "snprintf",
    "sprintf",
    "sqrt",
    "sscanf",
    "std",
    "stderr",
    "stdin",
    "stdout",
    "strcat",
    "strchr",
    "strcmp",
    "strcpy",
    "strcspn",
    "strlen",
    "strncat",
    "strncmp",
    "strncpy",
    "strpbrk",
    "strrchr",
    "strspn",
    "strstr",
    "swap",
    "tan",
    "tanh",
    "terminate",
    "to_underlying",
    "tolower",
    "toupper",
    "vfprintf",
    "visit",
    "vprintf",
    "vsprintf"
  ], E = {
    type: g,
    keyword: m,
    literal: [
      "NULL",
      "false",
      "nullopt",
      "nullptr",
      "true"
    ],
    built_in: ["_Pragma"],
    _type_hints: v
  }, w = {
    className: "function.dispatch",
    relevance: 0,
    keywords: {
      // Only for relevance, not highlighting.
      _hint: y
    },
    begin: e.concat(
      /\b/,
      /(?!decltype)/,
      /(?!if)/,
      /(?!for)/,
      /(?!switch)/,
      /(?!while)/,
      n.IDENT_RE,
      e.lookahead(/(<[^<>]+>|)\s*\(/)
    )
  }, C = [
    w,
    d,
    a,
    t,
    n.C_BLOCK_COMMENT_MODE,
    u,
    c
  ], S = {
    // This mode covers expression context where we can't expect a function
    // definition and shouldn't highlight anything that looks like one:
    // `return some()`, `else if()`, `(x*sum(1, 2))`
    variants: [
      {
        begin: /=/,
        end: /;/
      },
      {
        begin: /\(/,
        end: /\)/
      },
      {
        beginKeywords: "new throw return else",
        end: /;/
      }
    ],
    keywords: E,
    contains: C.concat([
      {
        begin: /\(/,
        end: /\)/,
        keywords: E,
        contains: C.concat(["self"]),
        relevance: 0
      }
    ]),
    relevance: 0
  }, M = {
    className: "function",
    begin: "(" + o + "[\\*&\\s]+)+" + h,
    returnBegin: !0,
    end: /[{;=]/,
    excludeEnd: !0,
    keywords: E,
    illegal: /[^\w\s\*&:<>.]/,
    contains: [
      {
        // to prevent it from being confused as the function title
        begin: r,
        keywords: E,
        relevance: 0
      },
      {
        begin: h,
        returnBegin: !0,
        contains: [f],
        relevance: 0
      },
      // needed because we do not have look-behind on the below rule
      // to prevent it from grabbing the final : in a :: pair
      {
        begin: /::/,
        relevance: 0
      },
      // initializers
      {
        begin: /:/,
        endsWithParent: !0,
        contains: [
          c,
          u
        ]
      },
      // allow for multiple declarations, e.g.:
      // extern void f(int), g(char);
      {
        relevance: 0,
        match: /,/
      },
      {
        className: "params",
        begin: /\(/,
        end: /\)/,
        keywords: E,
        relevance: 0,
        contains: [
          t,
          n.C_BLOCK_COMMENT_MODE,
          c,
          u,
          a,
          // Count matching parentheses.
          {
            begin: /\(/,
            end: /\)/,
            keywords: E,
            relevance: 0,
            contains: [
              "self",
              t,
              n.C_BLOCK_COMMENT_MODE,
              c,
              u,
              a
            ]
          }
        ]
      },
      a,
      t,
      n.C_BLOCK_COMMENT_MODE,
      d
    ]
  };
  return {
    name: "C++",
    aliases: [
      "cc",
      "c++",
      "h++",
      "hpp",
      "hh",
      "hxx",
      "cxx"
    ],
    keywords: E,
    illegal: "</",
    classNameAliases: { "function.dispatch": "built_in" },
    contains: [].concat(
      S,
      M,
      w,
      C,
      [
        d,
        {
          // containers: ie, `vector <int> rooms (9);`
          begin: "\\b(deque|list|queue|priority_queue|pair|stack|vector|map|set|bitset|multiset|multimap|unordered_map|unordered_set|unordered_multiset|unordered_multimap|array|tuple|optional|variant|function|flat_map|flat_set)\\s*<(?!<)",
          end: ">",
          keywords: E,
          contains: [
            "self",
            a
          ]
        },
        {
          begin: n.IDENT_RE + "::",
          keywords: E
        },
        {
          match: [
            // extra complexity to deal with `enum class` and `enum struct`
            /\b(?:enum(?:\s+(?:class|struct))?|class|struct|union)/,
            /\s+/,
            /\w+/
          ],
          className: {
            1: "keyword",
            3: "title.class"
          }
        }
      ]
    )
  };
}
function Vdt(n) {
  const e = [
    "bool",
    "byte",
    "char",
    "decimal",
    "delegate",
    "double",
    "dynamic",
    "enum",
    "float",
    "int",
    "long",
    "nint",
    "nuint",
    "object",
    "sbyte",
    "short",
    "string",
    "ulong",
    "uint",
    "ushort"
  ], t = [
    "public",
    "private",
    "protected",
    "static",
    "internal",
    "protected",
    "abstract",
    "async",
    "extern",
    "override",
    "unsafe",
    "virtual",
    "new",
    "sealed",
    "partial"
  ], r = [
    "default",
    "false",
    "null",
    "true"
  ], i = [
    "abstract",
    "as",
    "base",
    "break",
    "case",
    "catch",
    "class",
    "const",
    "continue",
    "do",
    "else",
    "event",
    "explicit",
    "extern",
    "finally",
    "fixed",
    "for",
    "foreach",
    "goto",
    "if",
    "implicit",
    "in",
    "interface",
    "internal",
    "is",
    "lock",
    "namespace",
    "new",
    "operator",
    "out",
    "override",
    "params",
    "private",
    "protected",
    "public",
    "readonly",
    "record",
    "ref",
    "return",
    "scoped",
    "sealed",
    "sizeof",
    "stackalloc",
    "static",
    "struct",
    "switch",
    "this",
    "throw",
    "try",
    "typeof",
    "unchecked",
    "unsafe",
    "using",
    "virtual",
    "void",
    "volatile",
    "while"
  ], s = [
    "add",
    "alias",
    "and",
    "ascending",
    "args",
    "async",
    "await",
    "by",
    "descending",
    "dynamic",
    "equals",
    "file",
    "from",
    "get",
    "global",
    "group",
    "init",
    "into",
    "join",
    "let",
    "nameof",
    "not",
    "notnull",
    "on",
    "or",
    "orderby",
    "partial",
    "record",
    "remove",
    "required",
    "scoped",
    "select",
    "set",
    "unmanaged",
    "value|0",
    "var",
    "when",
    "where",
    "with",
    "yield"
  ], o = {
    keyword: i.concat(s),
    built_in: e,
    literal: r
  }, a = n.inherit(n.TITLE_MODE, { begin: "[a-zA-Z](\\.?\\w)*" }), l = {
    className: "number",
    variants: [
      { begin: "\\b(0b[01']+)" },
      { begin: "(-?)\\b([\\d']+(\\.[\\d']*)?|\\.[\\d']+)(u|U|l|L|ul|UL|f|F|b|B)" },
      { begin: "(-?)(\\b0[xX][a-fA-F0-9']+|(\\b[\\d']+(\\.[\\d']*)?|\\.[\\d']+)([eE][-+]?[\\d']+)?)" }
    ],
    relevance: 0
  }, c = {
    className: "string",
    begin: /"""("*)(?!")(.|\n)*?"""\1/,
    relevance: 1
  }, u = {
    className: "string",
    begin: '@"',
    end: '"',
    contains: [{ begin: '""' }]
  }, d = n.inherit(u, { illegal: /\n/ }), f = {
    className: "subst",
    begin: /\{/,
    end: /\}/,
    keywords: o
  }, h = n.inherit(f, { illegal: /\n/ }), m = {
    className: "string",
    begin: /\$"/,
    end: '"',
    illegal: /\n/,
    contains: [
      { begin: /\{\{/ },
      { begin: /\}\}/ },
      n.BACKSLASH_ESCAPE,
      h
    ]
  }, g = {
    className: "string",
    begin: /\$@"/,
    end: '"',
    contains: [
      { begin: /\{\{/ },
      { begin: /\}\}/ },
      { begin: '""' },
      f
    ]
  }, v = n.inherit(g, {
    illegal: /\n/,
    contains: [
      { begin: /\{\{/ },
      { begin: /\}\}/ },
      { begin: '""' },
      h
    ]
  });
  f.contains = [
    g,
    m,
    u,
    n.APOS_STRING_MODE,
    n.QUOTE_STRING_MODE,
    l,
    n.C_BLOCK_COMMENT_MODE
  ], h.contains = [
    v,
    m,
    d,
    n.APOS_STRING_MODE,
    n.QUOTE_STRING_MODE,
    l,
    n.inherit(n.C_BLOCK_COMMENT_MODE, { illegal: /\n/ })
  ];
  const y = { variants: [
    c,
    g,
    m,
    u,
    n.APOS_STRING_MODE,
    n.QUOTE_STRING_MODE
  ] }, b = {
    begin: "<",
    end: ">",
    contains: [
      { beginKeywords: "in out" },
      a
    ]
  }, x = n.IDENT_RE + "(<" + n.IDENT_RE + "(\\s*,\\s*" + n.IDENT_RE + ")*>)?(\\[\\])?", E = {
    // prevents expressions like `@class` from incorrect flagging
    // `class` as a keyword
    begin: "@" + n.IDENT_RE,
    relevance: 0
  };
  return {
    name: "C#",
    aliases: [
      "cs",
      "c#"
    ],
    keywords: o,
    illegal: /::/,
    contains: [
      n.COMMENT(
        "///",
        "$",
        {
          returnBegin: !0,
          contains: [
            {
              className: "doctag",
              variants: [
                {
                  begin: "///",
                  relevance: 0
                },
                { begin: "<!--|-->" },
                {
                  begin: "</?",
                  end: ">"
                }
              ]
            }
          ]
        }
      ),
      n.C_LINE_COMMENT_MODE,
      n.C_BLOCK_COMMENT_MODE,
      {
        className: "meta",
        begin: "#",
        end: "$",
        keywords: { keyword: "if else elif endif define undef warning error line region endregion pragma checksum" }
      },
      y,
      l,
      {
        beginKeywords: "class interface",
        relevance: 0,
        end: /[{;=]/,
        illegal: /[^\s:,]/,
        contains: [
          { beginKeywords: "where class" },
          a,
          b,
          n.C_LINE_COMMENT_MODE,
          n.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        beginKeywords: "namespace",
        relevance: 0,
        end: /[{;=]/,
        illegal: /[^\s:]/,
        contains: [
          a,
          n.C_LINE_COMMENT_MODE,
          n.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        beginKeywords: "record",
        relevance: 0,
        end: /[{;=]/,
        illegal: /[^\s:]/,
        contains: [
          a,
          b,
          n.C_LINE_COMMENT_MODE,
          n.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        // [Attributes("")]
        className: "meta",
        begin: "^\\s*\\[(?=[\\w])",
        excludeBegin: !0,
        end: "\\]",
        excludeEnd: !0,
        contains: [
          {
            className: "string",
            begin: /"/,
            end: /"/
          }
        ]
      },
      {
        // Expression keywords prevent 'keyword Name(...)' from being
        // recognized as a function definition
        beginKeywords: "new return throw await else",
        relevance: 0
      },
      {
        className: "function",
        begin: "(" + x + "\\s+)+" + n.IDENT_RE + "\\s*(<[^=]+>\\s*)?\\(",
        returnBegin: !0,
        end: /\s*[{;=]/,
        excludeEnd: !0,
        keywords: o,
        contains: [
          // prevents these from being highlighted `title`
          {
            beginKeywords: t.join(" "),
            relevance: 0
          },
          {
            begin: n.IDENT_RE + "\\s*(<[^=]+>\\s*)?\\(",
            returnBegin: !0,
            contains: [
              n.TITLE_MODE,
              b
            ],
            relevance: 0
          },
          { match: /\(\)/ },
          {
            className: "params",
            begin: /\(/,
            end: /\)/,
            excludeBegin: !0,
            excludeEnd: !0,
            keywords: o,
            relevance: 0,
            contains: [
              y,
              l,
              n.C_BLOCK_COMMENT_MODE
            ]
          },
          n.C_LINE_COMMENT_MODE,
          n.C_BLOCK_COMMENT_MODE
        ]
      },
      E
    ]
  };
}
const jdt = (n) => ({
  IMPORTANT: {
    scope: "meta",
    begin: "!important"
  },
  BLOCK_COMMENT: n.C_BLOCK_COMMENT_MODE,
  HEXCOLOR: {
    scope: "number",
    begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
  },
  FUNCTION_DISPATCH: {
    className: "built_in",
    begin: /[\w-]+(?=\()/
  },
  ATTRIBUTE_SELECTOR_MODE: {
    scope: "selector-attr",
    begin: /\[/,
    end: /\]/,
    illegal: "$",
    contains: [
      n.APOS_STRING_MODE,
      n.QUOTE_STRING_MODE
    ]
  },
  CSS_NUMBER_MODE: {
    scope: "number",
    begin: n.NUMBER_RE + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
    relevance: 0
  },
  CSS_VARIABLE: {
    className: "attr",
    begin: /--[A-Za-z_][A-Za-z0-9_-]*/
  }
}), Wdt = [
  "a",
  "abbr",
  "address",
  "article",
  "aside",
  "audio",
  "b",
  "blockquote",
  "body",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "dd",
  "del",
  "details",
  "dfn",
  "div",
  "dl",
  "dt",
  "em",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "hgroup",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "main",
  "mark",
  "menu",
  "nav",
  "object",
  "ol",
  "optgroup",
  "option",
  "p",
  "picture",
  "q",
  "quote",
  "samp",
  "section",
  "select",
  "source",
  "span",
  "strong",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "tr",
  "ul",
  "var",
  "video"
], Gdt = [
  "defs",
  "g",
  "marker",
  "mask",
  "pattern",
  "svg",
  "switch",
  "symbol",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feFlood",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMorphology",
  "feOffset",
  "feSpecularLighting",
  "feTile",
  "feTurbulence",
  "linearGradient",
  "radialGradient",
  "stop",
  "circle",
  "ellipse",
  "image",
  "line",
  "path",
  "polygon",
  "polyline",
  "rect",
  "text",
  "use",
  "textPath",
  "tspan",
  "foreignObject",
  "clipPath"
], Kdt = [
  ...Wdt,
  ...Gdt
], qdt = [
  "any-hover",
  "any-pointer",
  "aspect-ratio",
  "color",
  "color-gamut",
  "color-index",
  "device-aspect-ratio",
  "device-height",
  "device-width",
  "display-mode",
  "forced-colors",
  "grid",
  "height",
  "hover",
  "inverted-colors",
  "monochrome",
  "orientation",
  "overflow-block",
  "overflow-inline",
  "pointer",
  "prefers-color-scheme",
  "prefers-contrast",
  "prefers-reduced-motion",
  "prefers-reduced-transparency",
  "resolution",
  "scan",
  "scripting",
  "update",
  "width",
  // TODO: find a better solution?
  "min-width",
  "max-width",
  "min-height",
  "max-height"
].sort().reverse(), Ydt = [
  "active",
  "any-link",
  "blank",
  "checked",
  "current",
  "default",
  "defined",
  "dir",
  // dir()
  "disabled",
  "drop",
  "empty",
  "enabled",
  "first",
  "first-child",
  "first-of-type",
  "fullscreen",
  "future",
  "focus",
  "focus-visible",
  "focus-within",
  "has",
  // has()
  "host",
  // host or host()
  "host-context",
  // host-context()
  "hover",
  "indeterminate",
  "in-range",
  "invalid",
  "is",
  // is()
  "lang",
  // lang()
  "last-child",
  "last-of-type",
  "left",
  "link",
  "local-link",
  "not",
  // not()
  "nth-child",
  // nth-child()
  "nth-col",
  // nth-col()
  "nth-last-child",
  // nth-last-child()
  "nth-last-col",
  // nth-last-col()
  "nth-last-of-type",
  //nth-last-of-type()
  "nth-of-type",
  //nth-of-type()
  "only-child",
  "only-of-type",
  "optional",
  "out-of-range",
  "past",
  "placeholder-shown",
  "read-only",
  "read-write",
  "required",
  "right",
  "root",
  "scope",
  "target",
  "target-within",
  "user-invalid",
  "valid",
  "visited",
  "where"
  // where()
].sort().reverse(), Xdt = [
  "after",
  "backdrop",
  "before",
  "cue",
  "cue-region",
  "first-letter",
  "first-line",
  "grammar-error",
  "marker",
  "part",
  "placeholder",
  "selection",
  "slotted",
  "spelling-error"
].sort().reverse(), Zdt = [
  "accent-color",
  "align-content",
  "align-items",
  "align-self",
  "alignment-baseline",
  "all",
  "anchor-name",
  "animation",
  "animation-composition",
  "animation-delay",
  "animation-direction",
  "animation-duration",
  "animation-fill-mode",
  "animation-iteration-count",
  "animation-name",
  "animation-play-state",
  "animation-range",
  "animation-range-end",
  "animation-range-start",
  "animation-timeline",
  "animation-timing-function",
  "appearance",
  "aspect-ratio",
  "backdrop-filter",
  "backface-visibility",
  "background",
  "background-attachment",
  "background-blend-mode",
  "background-clip",
  "background-color",
  "background-image",
  "background-origin",
  "background-position",
  "background-position-x",
  "background-position-y",
  "background-repeat",
  "background-size",
  "baseline-shift",
  "block-size",
  "border",
  "border-block",
  "border-block-color",
  "border-block-end",
  "border-block-end-color",
  "border-block-end-style",
  "border-block-end-width",
  "border-block-start",
  "border-block-start-color",
  "border-block-start-style",
  "border-block-start-width",
  "border-block-style",
  "border-block-width",
  "border-bottom",
  "border-bottom-color",
  "border-bottom-left-radius",
  "border-bottom-right-radius",
  "border-bottom-style",
  "border-bottom-width",
  "border-collapse",
  "border-color",
  "border-end-end-radius",
  "border-end-start-radius",
  "border-image",
  "border-image-outset",
  "border-image-repeat",
  "border-image-slice",
  "border-image-source",
  "border-image-width",
  "border-inline",
  "border-inline-color",
  "border-inline-end",
  "border-inline-end-color",
  "border-inline-end-style",
  "border-inline-end-width",
  "border-inline-start",
  "border-inline-start-color",
  "border-inline-start-style",
  "border-inline-start-width",
  "border-inline-style",
  "border-inline-width",
  "border-left",
  "border-left-color",
  "border-left-style",
  "border-left-width",
  "border-radius",
  "border-right",
  "border-right-color",
  "border-right-style",
  "border-right-width",
  "border-spacing",
  "border-start-end-radius",
  "border-start-start-radius",
  "border-style",
  "border-top",
  "border-top-color",
  "border-top-left-radius",
  "border-top-right-radius",
  "border-top-style",
  "border-top-width",
  "border-width",
  "bottom",
  "box-align",
  "box-decoration-break",
  "box-direction",
  "box-flex",
  "box-flex-group",
  "box-lines",
  "box-ordinal-group",
  "box-orient",
  "box-pack",
  "box-shadow",
  "box-sizing",
  "break-after",
  "break-before",
  "break-inside",
  "caption-side",
  "caret-color",
  "clear",
  "clip",
  "clip-path",
  "clip-rule",
  "color",
  "color-interpolation",
  "color-interpolation-filters",
  "color-profile",
  "color-rendering",
  "color-scheme",
  "column-count",
  "column-fill",
  "column-gap",
  "column-rule",
  "column-rule-color",
  "column-rule-style",
  "column-rule-width",
  "column-span",
  "column-width",
  "columns",
  "contain",
  "contain-intrinsic-block-size",
  "contain-intrinsic-height",
  "contain-intrinsic-inline-size",
  "contain-intrinsic-size",
  "contain-intrinsic-width",
  "container",
  "container-name",
  "container-type",
  "content",
  "content-visibility",
  "counter-increment",
  "counter-reset",
  "counter-set",
  "cue",
  "cue-after",
  "cue-before",
  "cursor",
  "cx",
  "cy",
  "direction",
  "display",
  "dominant-baseline",
  "empty-cells",
  "enable-background",
  "field-sizing",
  "fill",
  "fill-opacity",
  "fill-rule",
  "filter",
  "flex",
  "flex-basis",
  "flex-direction",
  "flex-flow",
  "flex-grow",
  "flex-shrink",
  "flex-wrap",
  "float",
  "flood-color",
  "flood-opacity",
  "flow",
  "font",
  "font-display",
  "font-family",
  "font-feature-settings",
  "font-kerning",
  "font-language-override",
  "font-optical-sizing",
  "font-palette",
  "font-size",
  "font-size-adjust",
  "font-smooth",
  "font-smoothing",
  "font-stretch",
  "font-style",
  "font-synthesis",
  "font-synthesis-position",
  "font-synthesis-small-caps",
  "font-synthesis-style",
  "font-synthesis-weight",
  "font-variant",
  "font-variant-alternates",
  "font-variant-caps",
  "font-variant-east-asian",
  "font-variant-emoji",
  "font-variant-ligatures",
  "font-variant-numeric",
  "font-variant-position",
  "font-variation-settings",
  "font-weight",
  "forced-color-adjust",
  "gap",
  "glyph-orientation-horizontal",
  "glyph-orientation-vertical",
  "grid",
  "grid-area",
  "grid-auto-columns",
  "grid-auto-flow",
  "grid-auto-rows",
  "grid-column",
  "grid-column-end",
  "grid-column-start",
  "grid-gap",
  "grid-row",
  "grid-row-end",
  "grid-row-start",
  "grid-template",
  "grid-template-areas",
  "grid-template-columns",
  "grid-template-rows",
  "hanging-punctuation",
  "height",
  "hyphenate-character",
  "hyphenate-limit-chars",
  "hyphens",
  "icon",
  "image-orientation",
  "image-rendering",
  "image-resolution",
  "ime-mode",
  "initial-letter",
  "initial-letter-align",
  "inline-size",
  "inset",
  "inset-area",
  "inset-block",
  "inset-block-end",
  "inset-block-start",
  "inset-inline",
  "inset-inline-end",
  "inset-inline-start",
  "isolation",
  "justify-content",
  "justify-items",
  "justify-self",
  "kerning",
  "left",
  "letter-spacing",
  "lighting-color",
  "line-break",
  "line-height",
  "line-height-step",
  "list-style",
  "list-style-image",
  "list-style-position",
  "list-style-type",
  "margin",
  "margin-block",
  "margin-block-end",
  "margin-block-start",
  "margin-bottom",
  "margin-inline",
  "margin-inline-end",
  "margin-inline-start",
  "margin-left",
  "margin-right",
  "margin-top",
  "margin-trim",
  "marker",
  "marker-end",
  "marker-mid",
  "marker-start",
  "marks",
  "mask",
  "mask-border",
  "mask-border-mode",
  "mask-border-outset",
  "mask-border-repeat",
  "mask-border-slice",
  "mask-border-source",
  "mask-border-width",
  "mask-clip",
  "mask-composite",
  "mask-image",
  "mask-mode",
  "mask-origin",
  "mask-position",
  "mask-repeat",
  "mask-size",
  "mask-type",
  "masonry-auto-flow",
  "math-depth",
  "math-shift",
  "math-style",
  "max-block-size",
  "max-height",
  "max-inline-size",
  "max-width",
  "min-block-size",
  "min-height",
  "min-inline-size",
  "min-width",
  "mix-blend-mode",
  "nav-down",
  "nav-index",
  "nav-left",
  "nav-right",
  "nav-up",
  "none",
  "normal",
  "object-fit",
  "object-position",
  "offset",
  "offset-anchor",
  "offset-distance",
  "offset-path",
  "offset-position",
  "offset-rotate",
  "opacity",
  "order",
  "orphans",
  "outline",
  "outline-color",
  "outline-offset",
  "outline-style",
  "outline-width",
  "overflow",
  "overflow-anchor",
  "overflow-block",
  "overflow-clip-margin",
  "overflow-inline",
  "overflow-wrap",
  "overflow-x",
  "overflow-y",
  "overlay",
  "overscroll-behavior",
  "overscroll-behavior-block",
  "overscroll-behavior-inline",
  "overscroll-behavior-x",
  "overscroll-behavior-y",
  "padding",
  "padding-block",
  "padding-block-end",
  "padding-block-start",
  "padding-bottom",
  "padding-inline",
  "padding-inline-end",
  "padding-inline-start",
  "padding-left",
  "padding-right",
  "padding-top",
  "page",
  "page-break-after",
  "page-break-before",
  "page-break-inside",
  "paint-order",
  "pause",
  "pause-after",
  "pause-before",
  "perspective",
  "perspective-origin",
  "place-content",
  "place-items",
  "place-self",
  "pointer-events",
  "position",
  "position-anchor",
  "position-visibility",
  "print-color-adjust",
  "quotes",
  "r",
  "resize",
  "rest",
  "rest-after",
  "rest-before",
  "right",
  "rotate",
  "row-gap",
  "ruby-align",
  "ruby-position",
  "scale",
  "scroll-behavior",
  "scroll-margin",
  "scroll-margin-block",
  "scroll-margin-block-end",
  "scroll-margin-block-start",
  "scroll-margin-bottom",
  "scroll-margin-inline",
  "scroll-margin-inline-end",
  "scroll-margin-inline-start",
  "scroll-margin-left",
  "scroll-margin-right",
  "scroll-margin-top",
  "scroll-padding",
  "scroll-padding-block",
  "scroll-padding-block-end",
  "scroll-padding-block-start",
  "scroll-padding-bottom",
  "scroll-padding-inline",
  "scroll-padding-inline-end",
  "scroll-padding-inline-start",
  "scroll-padding-left",
  "scroll-padding-right",
  "scroll-padding-top",
  "scroll-snap-align",
  "scroll-snap-stop",
  "scroll-snap-type",
  "scroll-timeline",
  "scroll-timeline-axis",
  "scroll-timeline-name",
  "scrollbar-color",
  "scrollbar-gutter",
  "scrollbar-width",
  "shape-image-threshold",
  "shape-margin",
  "shape-outside",
  "shape-rendering",
  "speak",
  "speak-as",
  "src",
  // @font-face
  "stop-color",
  "stop-opacity",
  "stroke",
  "stroke-dasharray",
  "stroke-dashoffset",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-miterlimit",
  "stroke-opacity",
  "stroke-width",
  "tab-size",
  "table-layout",
  "text-align",
  "text-align-all",
  "text-align-last",
  "text-anchor",
  "text-combine-upright",
  "text-decoration",
  "text-decoration-color",
  "text-decoration-line",
  "text-decoration-skip",
  "text-decoration-skip-ink",
  "text-decoration-style",
  "text-decoration-thickness",
  "text-emphasis",
  "text-emphasis-color",
  "text-emphasis-position",
  "text-emphasis-style",
  "text-indent",
  "text-justify",
  "text-orientation",
  "text-overflow",
  "text-rendering",
  "text-shadow",
  "text-size-adjust",
  "text-transform",
  "text-underline-offset",
  "text-underline-position",
  "text-wrap",
  "text-wrap-mode",
  "text-wrap-style",
  "timeline-scope",
  "top",
  "touch-action",
  "transform",
  "transform-box",
  "transform-origin",
  "transform-style",
  "transition",
  "transition-behavior",
  "transition-delay",
  "transition-duration",
  "transition-property",
  "transition-timing-function",
  "translate",
  "unicode-bidi",
  "user-modify",
  "user-select",
  "vector-effect",
  "vertical-align",
  "view-timeline",
  "view-timeline-axis",
  "view-timeline-inset",
  "view-timeline-name",
  "view-transition-name",
  "visibility",
  "voice-balance",
  "voice-duration",
  "voice-family",
  "voice-pitch",
  "voice-range",
  "voice-rate",
  "voice-stress",
  "voice-volume",
  "white-space",
  "white-space-collapse",
  "widows",
  "width",
  "will-change",
  "word-break",
  "word-spacing",
  "word-wrap",
  "writing-mode",
  "x",
  "y",
  "z-index",
  "zoom"
].sort().reverse();
function Qdt(n) {
  const e = n.regex, t = jdt(n), r = { begin: /-(webkit|moz|ms|o)-(?=[a-z])/ }, i = "and or not only", s = /@-?\w[\w]*(-\w+)*/, o = "[a-zA-Z-][a-zA-Z0-9_-]*", a = [
    n.APOS_STRING_MODE,
    n.QUOTE_STRING_MODE
  ];
  return {
    name: "CSS",
    case_insensitive: !0,
    illegal: /[=|'\$]/,
    keywords: { keyframePosition: "from to" },
    classNameAliases: {
      // for visual continuity with `tag {}` and because we
      // don't have a great class for this?
      keyframePosition: "selector-tag"
    },
    contains: [
      t.BLOCK_COMMENT,
      r,
      // to recognize keyframe 40% etc which are outside the scope of our
      // attribute value mode
      t.CSS_NUMBER_MODE,
      {
        className: "selector-id",
        begin: /#[A-Za-z0-9_-]+/,
        relevance: 0
      },
      {
        className: "selector-class",
        begin: "\\." + o,
        relevance: 0
      },
      t.ATTRIBUTE_SELECTOR_MODE,
      {
        className: "selector-pseudo",
        variants: [
          { begin: ":(" + Ydt.join("|") + ")" },
          { begin: ":(:)?(" + Xdt.join("|") + ")" }
        ]
      },
      // we may actually need this (12/2020)
      // { // pseudo-selector params
      //   begin: /\(/,
      //   end: /\)/,
      //   contains: [ hljs.CSS_NUMBER_MODE ]
      // },
      t.CSS_VARIABLE,
      {
        className: "attribute",
        begin: "\\b(" + Zdt.join("|") + ")\\b"
      },
      // attribute values
      {
        begin: /:/,
        end: /[;}{]/,
        contains: [
          t.BLOCK_COMMENT,
          t.HEXCOLOR,
          t.IMPORTANT,
          t.CSS_NUMBER_MODE,
          ...a,
          // needed to highlight these as strings and to avoid issues with
          // illegal characters that might be inside urls that would tigger the
          // languages illegal stack
          {
            begin: /(url|data-uri)\(/,
            end: /\)/,
            relevance: 0,
            // from keywords
            keywords: { built_in: "url data-uri" },
            contains: [
              ...a,
              {
                className: "string",
                // any character other than `)` as in `url()` will be the start
                // of a string, which ends with `)` (from the parent mode)
                begin: /[^)]/,
                endsWithParent: !0,
                excludeEnd: !0
              }
            ]
          },
          t.FUNCTION_DISPATCH
        ]
      },
      {
        begin: e.lookahead(/@/),
        end: "[{;]",
        relevance: 0,
        illegal: /:/,
        // break on Less variables @var: ...
        contains: [
          {
            className: "keyword",
            begin: s
          },
          {
            begin: /\s/,
            endsWithParent: !0,
            excludeEnd: !0,
            relevance: 0,
            keywords: {
              $pattern: /[a-z-]+/,
              keyword: i,
              attribute: qdt.join(" ")
            },
            contains: [
              {
                begin: /[a-z-]+(?=:)/,
                className: "attribute"
              },
              ...a,
              t.CSS_NUMBER_MODE
            ]
          }
        ]
      },
      {
        className: "selector-tag",
        begin: "\\b(" + Kdt.join("|") + ")\\b"
      }
    ]
  };
}
function Jdt(n) {
  const e = n.regex;
  return {
    name: "Diff",
    aliases: ["patch"],
    contains: [
      {
        className: "meta",
        relevance: 10,
        match: e.either(
          /^@@ +-\d+,\d+ +\+\d+,\d+ +@@/,
          /^\*\*\* +\d+,\d+ +\*\*\*\*$/,
          /^--- +\d+,\d+ +----$/
        )
      },
      {
        className: "comment",
        variants: [
          {
            begin: e.either(
              /Index: /,
              /^index/,
              /={3,}/,
              /^-{3}/,
              /^\*{3} /,
              /^\+{3}/,
              /^diff --git/
            ),
            end: /$/
          },
          { match: /^\*{15}$/ }
        ]
      },
      {
        className: "addition",
        begin: /^\+/,
        end: /$/
      },
      {
        className: "deletion",
        begin: /^-/,
        end: /$/
      },
      {
        className: "addition",
        begin: /^!/,
        end: /$/
      }
    ]
  };
}
function eft(n) {
  const s = {
    keyword: [
      "break",
      "case",
      "chan",
      "const",
      "continue",
      "default",
      "defer",
      "else",
      "fallthrough",
      "for",
      "func",
      "go",
      "goto",
      "if",
      "import",
      "interface",
      "map",
      "package",
      "range",
      "return",
      "select",
      "struct",
      "switch",
      "type",
      "var"
    ],
    type: [
      "bool",
      "byte",
      "complex64",
      "complex128",
      "error",
      "float32",
      "float64",
      "int8",
      "int16",
      "int32",
      "int64",
      "string",
      "uint8",
      "uint16",
      "uint32",
      "uint64",
      "int",
      "uint",
      "uintptr",
      "rune"
    ],
    literal: [
      "true",
      "false",
      "iota",
      "nil"
    ],
    built_in: [
      "append",
      "cap",
      "close",
      "complex",
      "copy",
      "imag",
      "len",
      "make",
      "new",
      "panic",
      "print",
      "println",
      "real",
      "recover",
      "delete"
    ]
  };
  return {
    name: "Go",
    aliases: ["golang"],
    keywords: s,
    illegal: "</",
    contains: [
      n.C_LINE_COMMENT_MODE,
      n.C_BLOCK_COMMENT_MODE,
      {
        className: "string",
        variants: [
          n.QUOTE_STRING_MODE,
          n.APOS_STRING_MODE,
          {
            begin: "`",
            end: "`"
          }
        ]
      },
      {
        className: "number",
        variants: [
          {
            match: /-?\b0[xX]\.[a-fA-F0-9](_?[a-fA-F0-9])*[pP][+-]?\d(_?\d)*i?/,
            // hex without a present digit before . (making a digit afterwards required)
            relevance: 0
          },
          {
            match: /-?\b0[xX](_?[a-fA-F0-9])+((\.([a-fA-F0-9](_?[a-fA-F0-9])*)?)?[pP][+-]?\d(_?\d)*)?i?/,
            // hex with a present digit before . (making a digit afterwards optional)
            relevance: 0
          },
          {
            match: /-?\b0[oO](_?[0-7])*i?/,
            // leading 0o octal
            relevance: 0
          },
          {
            match: /-?\.\d(_?\d)*([eE][+-]?\d(_?\d)*)?i?/,
            // decimal without a present digit before . (making a digit afterwards required)
            relevance: 0
          },
          {
            match: /-?\b\d(_?\d)*(\.(\d(_?\d)*)?)?([eE][+-]?\d(_?\d)*)?i?/,
            // decimal with a present digit before . (making a digit afterwards optional)
            relevance: 0
          }
        ]
      },
      {
        begin: /:=/
        // relevance booster
      },
      {
        className: "function",
        beginKeywords: "func",
        end: "\\s*(\\{|$)",
        excludeEnd: !0,
        contains: [
          n.TITLE_MODE,
          {
            className: "params",
            begin: /\(/,
            end: /\)/,
            endsParent: !0,
            keywords: s,
            illegal: /["']/
          }
        ]
      }
    ]
  };
}
function tft(n) {
  const e = n.regex, t = /[_A-Za-z][_0-9A-Za-z]*/;
  return {
    name: "GraphQL",
    aliases: ["gql"],
    case_insensitive: !0,
    disableAutodetect: !1,
    keywords: {
      keyword: [
        "query",
        "mutation",
        "subscription",
        "type",
        "input",
        "schema",
        "directive",
        "interface",
        "union",
        "scalar",
        "fragment",
        "enum",
        "on"
      ],
      literal: [
        "true",
        "false",
        "null"
      ]
    },
    contains: [
      n.HASH_COMMENT_MODE,
      n.QUOTE_STRING_MODE,
      n.NUMBER_MODE,
      {
        scope: "punctuation",
        match: /[.]{3}/,
        relevance: 0
      },
      {
        scope: "punctuation",
        begin: /[\!\(\)\:\=\[\]\{\|\}]{1}/,
        relevance: 0
      },
      {
        scope: "variable",
        begin: /\$/,
        end: /\W/,
        excludeEnd: !0,
        relevance: 0
      },
      {
        scope: "meta",
        match: /@\w+/,
        excludeEnd: !0
      },
      {
        scope: "symbol",
        begin: e.concat(t, e.lookahead(/\s*:/)),
        relevance: 0
      }
    ],
    illegal: [
      /[;<']/,
      /BEGIN/
    ]
  };
}
function nft(n) {
  const e = n.regex, t = {
    className: "number",
    relevance: 0,
    variants: [
      { begin: /([+-]+)?[\d]+_[\d_]+/ },
      { begin: n.NUMBER_RE }
    ]
  }, r = n.COMMENT();
  r.variants = [
    {
      begin: /;/,
      end: /$/
    },
    {
      begin: /#/,
      end: /$/
    }
  ];
  const i = {
    className: "variable",
    variants: [
      { begin: /\$[\w\d"][\w\d_]*/ },
      { begin: /\$\{(.*?)\}/ }
    ]
  }, s = {
    className: "literal",
    begin: /\bon|off|true|false|yes|no\b/
  }, o = {
    className: "string",
    contains: [n.BACKSLASH_ESCAPE],
    variants: [
      {
        begin: "'''",
        end: "'''",
        relevance: 10
      },
      {
        begin: '"""',
        end: '"""',
        relevance: 10
      },
      {
        begin: '"',
        end: '"'
      },
      {
        begin: "'",
        end: "'"
      }
    ]
  }, a = {
    begin: /\[/,
    end: /\]/,
    contains: [
      r,
      s,
      i,
      o,
      t,
      "self"
    ],
    relevance: 0
  }, l = /[A-Za-z0-9_-]+/, c = /"(\\"|[^"])*"/, u = /'[^']*'/, d = e.either(
    l,
    c,
    u
  ), f = e.concat(
    d,
    "(\\s*\\.\\s*",
    d,
    ")*",
    e.lookahead(/\s*=\s*[^#\s]/)
  );
  return {
    name: "TOML, also INI",
    aliases: ["toml"],
    case_insensitive: !0,
    illegal: /\S/,
    contains: [
      r,
      {
        className: "section",
        begin: /\[+/,
        end: /\]+/
      },
      {
        begin: f,
        className: "attr",
        starts: {
          end: /$/,
          contains: [
            r,
            a,
            s,
            i,
            o,
            t
          ]
        }
      }
    ]
  };
}
var Hd = "[0-9](_*[0-9])*", cv = `\\.(${Hd})`, uv = "[0-9a-fA-F](_*[0-9a-fA-F])*", sj = {
  className: "number",
  variants: [
    // DecimalFloatingPointLiteral
    // including ExponentPart
    { begin: `(\\b(${Hd})((${cv})|\\.)?|(${cv}))[eE][+-]?(${Hd})[fFdD]?\\b` },
    // excluding ExponentPart
    { begin: `\\b(${Hd})((${cv})[fFdD]?\\b|\\.([fFdD]\\b)?)` },
    { begin: `(${cv})[fFdD]?\\b` },
    { begin: `\\b(${Hd})[fFdD]\\b` },
    // HexadecimalFloatingPointLiteral
    { begin: `\\b0[xX]((${uv})\\.?|(${uv})?\\.(${uv}))[pP][+-]?(${Hd})[fFdD]?\\b` },
    // DecimalIntegerLiteral
    { begin: "\\b(0|[1-9](_*[0-9])*)[lL]?\\b" },
    // HexIntegerLiteral
    { begin: `\\b0[xX](${uv})[lL]?\\b` },
    // OctalIntegerLiteral
    { begin: "\\b0(_*[0-7])*[lL]?\\b" },
    // BinaryIntegerLiteral
    { begin: "\\b0[bB][01](_*[01])*[lL]?\\b" }
  ],
  relevance: 0
};
function Rae(n, e, t) {
  return t === -1 ? "" : n.replace(e, (r) => Rae(n, e, t - 1));
}
function rft(n) {
  const e = n.regex, t = "[À-ʸa-zA-Z_$][À-ʸa-zA-Z_$0-9]*", r = t + Rae("(?:<" + t + "~~~(?:\\s*,\\s*" + t + "~~~)*>)?", /~~~/g, 2), l = {
    keyword: [
      "synchronized",
      "abstract",
      "private",
      "var",
      "static",
      "if",
      "const ",
      "for",
      "while",
      "strictfp",
      "finally",
      "protected",
      "import",
      "native",
      "final",
      "void",
      "enum",
      "else",
      "break",
      "transient",
      "catch",
      "instanceof",
      "volatile",
      "case",
      "assert",
      "package",
      "default",
      "public",
      "try",
      "switch",
      "continue",
      "throws",
      "protected",
      "public",
      "private",
      "module",
      "requires",
      "exports",
      "do",
      "sealed",
      "yield",
      "permits",
      "goto",
      "when"
    ],
    literal: [
      "false",
      "true",
      "null"
    ],
    type: [
      "char",
      "boolean",
      "long",
      "float",
      "int",
      "byte",
      "short",
      "double"
    ],
    built_in: [
      "super",
      "this"
    ]
  }, c = {
    className: "meta",
    begin: "@" + t,
    contains: [
      {
        begin: /\(/,
        end: /\)/,
        contains: ["self"]
        // allow nested () inside our annotation
      }
    ]
  }, u = {
    className: "params",
    begin: /\(/,
    end: /\)/,
    keywords: l,
    relevance: 0,
    contains: [n.C_BLOCK_COMMENT_MODE],
    endsParent: !0
  };
  return {
    name: "Java",
    aliases: ["jsp"],
    keywords: l,
    illegal: /<\/|#/,
    contains: [
      n.COMMENT(
        "/\\*\\*",
        "\\*/",
        {
          relevance: 0,
          contains: [
            {
              // eat up @'s in emails to prevent them to be recognized as doctags
              begin: /\w+@/,
              relevance: 0
            },
            {
              className: "doctag",
              begin: "@[A-Za-z]+"
            }
          ]
        }
      ),
      // relevance boost
      {
        begin: /import java\.[a-z]+\./,
        keywords: "import",
        relevance: 2
      },
      n.C_LINE_COMMENT_MODE,
      n.C_BLOCK_COMMENT_MODE,
      {
        begin: /"""/,
        end: /"""/,
        className: "string",
        contains: [n.BACKSLASH_ESCAPE]
      },
      n.APOS_STRING_MODE,
      n.QUOTE_STRING_MODE,
      {
        match: [
          /\b(?:class|interface|enum|extends|implements|new)/,
          /\s+/,
          t
        ],
        className: {
          1: "keyword",
          3: "title.class"
        }
      },
      {
        // Exceptions for hyphenated keywords
        match: /non-sealed/,
        scope: "keyword"
      },
      {
        begin: [
          e.concat(/(?!else)/, t),
          /\s+/,
          t,
          /\s+/,
          /=(?!=)/
        ],
        className: {
          1: "type",
          3: "variable",
          5: "operator"
        }
      },
      {
        begin: [
          /record/,
          /\s+/,
          t
        ],
        className: {
          1: "keyword",
          3: "title.class"
        },
        contains: [
          u,
          n.C_LINE_COMMENT_MODE,
          n.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        // Expression keywords prevent 'keyword Name(...)' from being
        // recognized as a function definition
        beginKeywords: "new throw return else",
        relevance: 0
      },
      {
        begin: [
          "(?:" + r + "\\s+)",
          n.UNDERSCORE_IDENT_RE,
          /\s*(?=\()/
        ],
        className: { 2: "title.function" },
        keywords: l,
        contains: [
          {
            className: "params",
            begin: /\(/,
            end: /\)/,
            keywords: l,
            relevance: 0,
            contains: [
              c,
              n.APOS_STRING_MODE,
              n.QUOTE_STRING_MODE,
              sj,
              n.C_BLOCK_COMMENT_MODE
            ]
          },
          n.C_LINE_COMMENT_MODE,
          n.C_BLOCK_COMMENT_MODE
        ]
      },
      sj,
      c
    ]
  };
}
const oj = "[A-Za-z$_][0-9A-Za-z$_]*", ift = [
  "as",
  // for exports
  "in",
  "of",
  "if",
  "for",
  "while",
  "finally",
  "var",
  "new",
  "function",
  "do",
  "return",
  "void",
  "else",
  "break",
  "catch",
  "instanceof",
  "with",
  "throw",
  "case",
  "default",
  "try",
  "switch",
  "continue",
  "typeof",
  "delete",
  "let",
  "yield",
  "const",
  "class",
  // JS handles these with a special rule
  // "get",
  // "set",
  "debugger",
  "async",
  "await",
  "static",
  "import",
  "from",
  "export",
  "extends",
  // It's reached stage 3, which is "recommended for implementation":
  "using"
], sft = [
  "true",
  "false",
  "null",
  "undefined",
  "NaN",
  "Infinity"
], Pae = [
  // Fundamental objects
  "Object",
  "Function",
  "Boolean",
  "Symbol",
  // numbers and dates
  "Math",
  "Date",
  "Number",
  "BigInt",
  // text
  "String",
  "RegExp",
  // Indexed collections
  "Array",
  "Float32Array",
  "Float64Array",
  "Int8Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Int16Array",
  "Int32Array",
  "Uint16Array",
  "Uint32Array",
  "BigInt64Array",
  "BigUint64Array",
  // Keyed collections
  "Set",
  "Map",
  "WeakSet",
  "WeakMap",
  // Structured data
  "ArrayBuffer",
  "SharedArrayBuffer",
  "Atomics",
  "DataView",
  "JSON",
  // Control abstraction objects
  "Promise",
  "Generator",
  "GeneratorFunction",
  "AsyncFunction",
  // Reflection
  "Reflect",
  "Proxy",
  // Internationalization
  "Intl",
  // WebAssembly
  "WebAssembly"
], Dae = [
  "Error",
  "EvalError",
  "InternalError",
  "RangeError",
  "ReferenceError",
  "SyntaxError",
  "TypeError",
  "URIError"
], Nae = [
  "setInterval",
  "setTimeout",
  "clearInterval",
  "clearTimeout",
  "require",
  "exports",
  "eval",
  "isFinite",
  "isNaN",
  "parseFloat",
  "parseInt",
  "decodeURI",
  "decodeURIComponent",
  "encodeURI",
  "encodeURIComponent",
  "escape",
  "unescape"
], oft = [
  "arguments",
  "this",
  "super",
  "console",
  "window",
  "document",
  "localStorage",
  "sessionStorage",
  "module",
  "global"
  // Node.js
], aft = [].concat(
  Nae,
  Pae,
  Dae
);
function lft(n) {
  const e = n.regex, t = ($, { after: z }) => {
    const H = "</" + $[0].slice(1);
    return $.input.indexOf(H, z) !== -1;
  }, r = oj, i = {
    begin: "<>",
    end: "</>"
  }, s = /<[A-Za-z0-9\\._:-]+\s*\/>/, o = {
    begin: /<[A-Za-z0-9\\._:-]+/,
    end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
    /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */
    isTrulyOpeningTag: ($, z) => {
      const H = $[0].length + $.index, U = $.input[H];
      if (
        // HTML should not include another raw `<` inside a tag
        // nested type?
        // `<Array<Array<number>>`, etc.
        U === "<" || // the , gives away that this is not HTML
        // `<T, A extends keyof T, V>`
        U === ","
      ) {
        z.ignoreMatch();
        return;
      }
      U === ">" && (t($, { after: H }) || z.ignoreMatch());
      let F;
      const V = $.input.substring(H);
      if (F = V.match(/^\s*=/)) {
        z.ignoreMatch();
        return;
      }
      if ((F = V.match(/^\s+extends\s+/)) && F.index === 0) {
        z.ignoreMatch();
        return;
      }
    }
  }, a = {
    $pattern: oj,
    keyword: ift,
    literal: sft,
    built_in: aft,
    "variable.language": oft
  }, l = "[0-9](_?[0-9])*", c = `\\.(${l})`, u = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", d = {
    className: "number",
    variants: [
      // DecimalLiteral
      { begin: `(\\b(${u})((${c})|\\.)?|(${c}))[eE][+-]?(${l})\\b` },
      { begin: `\\b(${u})\\b((${c})\\b|\\.)?|(${c})\\b` },
      // DecimalBigIntegerLiteral
      { begin: "\\b(0|[1-9](_?[0-9])*)n\\b" },
      // NonDecimalIntegerLiteral
      { begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b" },
      { begin: "\\b0[bB][0-1](_?[0-1])*n?\\b" },
      { begin: "\\b0[oO][0-7](_?[0-7])*n?\\b" },
      // LegacyOctalIntegerLiteral (does not include underscore separators)
      // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
      { begin: "\\b0[0-7]+n?\\b" }
    ],
    relevance: 0
  }, f = {
    className: "subst",
    begin: "\\$\\{",
    end: "\\}",
    keywords: a,
    contains: []
    // defined later
  }, h = {
    begin: ".?html`",
    end: "",
    starts: {
      end: "`",
      returnEnd: !1,
      contains: [
        n.BACKSLASH_ESCAPE,
        f
      ],
      subLanguage: "xml"
    }
  }, m = {
    begin: ".?css`",
    end: "",
    starts: {
      end: "`",
      returnEnd: !1,
      contains: [
        n.BACKSLASH_ESCAPE,
        f
      ],
      subLanguage: "css"
    }
  }, g = {
    begin: ".?gql`",
    end: "",
    starts: {
      end: "`",
      returnEnd: !1,
      contains: [
        n.BACKSLASH_ESCAPE,
        f
      ],
      subLanguage: "graphql"
    }
  }, v = {
    className: "string",
    begin: "`",
    end: "`",
    contains: [
      n.BACKSLASH_ESCAPE,
      f
    ]
  }, b = {
    className: "comment",
    variants: [
      n.COMMENT(
        /\/\*\*(?!\/)/,
        "\\*/",
        {
          relevance: 0,
          contains: [
            {
              begin: "(?=@[A-Za-z]+)",
              relevance: 0,
              contains: [
                {
                  className: "doctag",
                  begin: "@[A-Za-z]+"
                },
                {
                  className: "type",
                  begin: "\\{",
                  end: "\\}",
                  excludeEnd: !0,
                  excludeBegin: !0,
                  relevance: 0
                },
                {
                  className: "variable",
                  begin: r + "(?=\\s*(-)|$)",
                  endsParent: !0,
                  relevance: 0
                },
                // eat spaces (not newlines) so we can find
                // types or variables
                {
                  begin: /(?=[^\n])\s/,
                  relevance: 0
                }
              ]
            }
          ]
        }
      ),
      n.C_BLOCK_COMMENT_MODE,
      n.C_LINE_COMMENT_MODE
    ]
  }, x = [
    n.APOS_STRING_MODE,
    n.QUOTE_STRING_MODE,
    h,
    m,
    g,
    v,
    // Skip numbers when they are part of a variable name
    { match: /\$\d+/ },
    d
    // This is intentional:
    // See https://github.com/highlightjs/highlight.js/issues/3288
    // hljs.REGEXP_MODE
  ];
  f.contains = x.concat({
    // we need to pair up {} inside our subst to prevent
    // it from ending too early by matching another }
    begin: /\{/,
    end: /\}/,
    keywords: a,
    contains: [
      "self"
    ].concat(x)
  });
  const E = [].concat(b, f.contains), w = E.concat([
    // eat recursive parens in sub expressions
    {
      begin: /(\s*)\(/,
      end: /\)/,
      keywords: a,
      contains: ["self"].concat(E)
    }
  ]), C = {
    className: "params",
    // convert this to negative lookbehind in v12
    begin: /(\s*)\(/,
    // to match the parms with
    end: /\)/,
    excludeBegin: !0,
    excludeEnd: !0,
    keywords: a,
    contains: w
  }, S = {
    variants: [
      // class Car extends vehicle
      {
        match: [
          /class/,
          /\s+/,
          r,
          /\s+/,
          /extends/,
          /\s+/,
          e.concat(r, "(", e.concat(/\./, r), ")*")
        ],
        scope: {
          1: "keyword",
          3: "title.class",
          5: "keyword",
          7: "title.class.inherited"
        }
      },
      // class Car
      {
        match: [
          /class/,
          /\s+/,
          r
        ],
        scope: {
          1: "keyword",
          3: "title.class"
        }
      }
    ]
  }, M = {
    relevance: 0,
    match: e.either(
      // Hard coded exceptions
      /\bJSON/,
      // Float32Array, OutT
      /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/,
      // CSSFactory, CSSFactoryT
      /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/,
      // FPs, FPsT
      /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/
      // P
      // single letters are not highlighted
      // BLAH
      // this will be flagged as a UPPER_CASE_CONSTANT instead
    ),
    className: "title.class",
    keywords: {
      _: [
        // se we still get relevance credit for JS library classes
        ...Pae,
        ...Dae
      ]
    }
  }, k = {
    label: "use_strict",
    className: "meta",
    relevance: 10,
    begin: /^\s*['"]use (strict|asm)['"]/
  }, _ = {
    variants: [
      {
        match: [
          /function/,
          /\s+/,
          r,
          /(?=\s*\()/
        ]
      },
      // anonymous function
      {
        match: [
          /function/,
          /\s*(?=\()/
        ]
      }
    ],
    className: {
      1: "keyword",
      3: "title.function"
    },
    label: "func.def",
    contains: [C],
    illegal: /%/
  }, O = {
    relevance: 0,
    match: /\b[A-Z][A-Z_0-9]+\b/,
    className: "variable.constant"
  };
  function I($) {
    return e.concat("(?!", $.join("|"), ")");
  }
  const R = {
    match: e.concat(
      /\b/,
      I([
        ...Nae,
        "super",
        "import"
      ].map(($) => `${$}\\s*\\(`)),
      r,
      e.lookahead(/\s*\(/)
    ),
    className: "title.function",
    relevance: 0
  }, P = {
    begin: e.concat(/\./, e.lookahead(
      e.concat(r, /(?![0-9A-Za-z$_(])/)
    )),
    end: r,
    excludeBegin: !0,
    keywords: "prototype",
    className: "property",
    relevance: 0
  }, D = {
    match: [
      /get|set/,
      /\s+/,
      r,
      /(?=\()/
    ],
    className: {
      1: "keyword",
      3: "title.function"
    },
    contains: [
      {
        // eat to avoid empty params
        begin: /\(\)/
      },
      C
    ]
  }, L = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + n.UNDERSCORE_IDENT_RE + ")\\s*=>", B = {
    match: [
      /const|var|let/,
      /\s+/,
      r,
      /\s*/,
      /=\s*/,
      /(async\s*)?/,
      // async is optional
      e.lookahead(L)
    ],
    keywords: "async",
    className: {
      1: "keyword",
      3: "title.function"
    },
    contains: [
      C
    ]
  };
  return {
    name: "JavaScript",
    aliases: ["js", "jsx", "mjs", "cjs"],
    keywords: a,
    // this will be extended by TypeScript
    exports: { PARAMS_CONTAINS: w, CLASS_REFERENCE: M },
    illegal: /#(?![$_A-z])/,
    contains: [
      n.SHEBANG({
        label: "shebang",
        binary: "node",
        relevance: 5
      }),
      k,
      n.APOS_STRING_MODE,
      n.QUOTE_STRING_MODE,
      h,
      m,
      g,
      v,
      b,
      // Skip numbers when they are part of a variable name
      { match: /\$\d+/ },
      d,
      M,
      {
        scope: "attr",
        match: r + e.lookahead(":"),
        relevance: 0
      },
      B,
      {
        // "value" container
        begin: "(" + n.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
        keywords: "return throw case",
        relevance: 0,
        contains: [
          b,
          n.REGEXP_MODE,
          {
            className: "function",
            // we have to count the parens to make sure we actually have the
            // correct bounding ( ) before the =>.  There could be any number of
            // sub-expressions inside also surrounded by parens.
            begin: L,
            returnBegin: !0,
            end: "\\s*=>",
            contains: [
              {
                className: "params",
                variants: [
                  {
                    begin: n.UNDERSCORE_IDENT_RE,
                    relevance: 0
                  },
                  {
                    className: null,
                    begin: /\(\s*\)/,
                    skip: !0
                  },
                  {
                    begin: /(\s*)\(/,
                    end: /\)/,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    keywords: a,
                    contains: w
                  }
                ]
              }
            ]
          },
          {
            // could be a comma delimited list of params to a function call
            begin: /,/,
            relevance: 0
          },
          {
            match: /\s+/,
            relevance: 0
          },
          {
            // JSX
            variants: [
              { begin: i.begin, end: i.end },
              { match: s },
              {
                begin: o.begin,
                // we carefully check the opening tag to see if it truly
                // is a tag and not a false positive
                "on:begin": o.isTrulyOpeningTag,
                end: o.end
              }
            ],
            subLanguage: "xml",
            contains: [
              {
                begin: o.begin,
                end: o.end,
                skip: !0,
                contains: ["self"]
              }
            ]
          }
        ]
      },
      _,
      {
        // prevent this from getting swallowed up by function
        // since they appear "function like"
        beginKeywords: "while if switch catch for"
      },
      {
        // we have to count the parens to make sure we actually have the correct
        // bounding ( ).  There could be any number of sub-expressions inside
        // also surrounded by parens.
        begin: "\\b(?!function)" + n.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
        // end parens
        returnBegin: !0,
        label: "func.def",
        contains: [
          C,
          n.inherit(n.TITLE_MODE, { begin: r, className: "title.function" })
        ]
      },
      // catch ... so it won't trigger the property rule below
      {
        match: /\.\.\./,
        relevance: 0
      },
      P,
      // hack: prevents detection of keywords in some circumstances
      // .keyword()
      // $keyword = x
      {
        match: "\\$" + r,
        relevance: 0
      },
      {
        match: [/\bconstructor(?=\s*\()/],
        className: { 1: "title.function" },
        contains: [C]
      },
      R,
      O,
      S,
      D,
      {
        match: /\$[(.]/
        // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
      }
    ]
  };
}
function cft(n) {
  const e = {
    className: "attr",
    begin: /"(\\.|[^\\"\r\n])*"(?=\s*:)/,
    relevance: 1.01
  }, t = {
    match: /[{}[\],:]/,
    className: "punctuation",
    relevance: 0
  }, r = [
    "true",
    "false",
    "null"
  ], i = {
    scope: "literal",
    beginKeywords: r.join(" ")
  };
  return {
    name: "JSON",
    aliases: ["jsonc"],
    keywords: {
      literal: r
    },
    contains: [
      e,
      t,
      n.QUOTE_STRING_MODE,
      i,
      n.C_NUMBER_MODE,
      n.C_LINE_COMMENT_MODE,
      n.C_BLOCK_COMMENT_MODE
    ],
    illegal: "\\S"
  };
}
var Ud = "[0-9](_*[0-9])*", dv = `\\.(${Ud})`, fv = "[0-9a-fA-F](_*[0-9a-fA-F])*", uft = {
  className: "number",
  variants: [
    // DecimalFloatingPointLiteral
    // including ExponentPart
    { begin: `(\\b(${Ud})((${dv})|\\.)?|(${dv}))[eE][+-]?(${Ud})[fFdD]?\\b` },
    // excluding ExponentPart
    { begin: `\\b(${Ud})((${dv})[fFdD]?\\b|\\.([fFdD]\\b)?)` },
    { begin: `(${dv})[fFdD]?\\b` },
    { begin: `\\b(${Ud})[fFdD]\\b` },
    // HexadecimalFloatingPointLiteral
    { begin: `\\b0[xX]((${fv})\\.?|(${fv})?\\.(${fv}))[pP][+-]?(${Ud})[fFdD]?\\b` },
    // DecimalIntegerLiteral
    { begin: "\\b(0|[1-9](_*[0-9])*)[lL]?\\b" },
    // HexIntegerLiteral
    { begin: `\\b0[xX](${fv})[lL]?\\b` },
    // OctalIntegerLiteral
    { begin: "\\b0(_*[0-7])*[lL]?\\b" },
    // BinaryIntegerLiteral
    { begin: "\\b0[bB][01](_*[01])*[lL]?\\b" }
  ],
  relevance: 0
};
function dft(n) {
  const e = {
    keyword: "abstract as val var vararg get set class object open private protected public noinline crossinline dynamic final enum if else do while for when throw try catch finally import package is in fun override companion reified inline lateinit init interface annotation data sealed internal infix operator out by constructor super tailrec where const inner suspend typealias external expect actual",
    built_in: "Byte Short Char Int Long Boolean Float Double Void Unit Nothing",
    literal: "true false null"
  }, t = {
    className: "keyword",
    begin: /\b(break|continue|return|this)\b/,
    starts: { contains: [
      {
        className: "symbol",
        begin: /@\w+/
      }
    ] }
  }, r = {
    className: "symbol",
    begin: n.UNDERSCORE_IDENT_RE + "@"
  }, i = {
    className: "subst",
    begin: /\$\{/,
    end: /\}/,
    contains: [n.C_NUMBER_MODE]
  }, s = {
    className: "variable",
    begin: "\\$" + n.UNDERSCORE_IDENT_RE
  }, o = {
    className: "string",
    variants: [
      {
        begin: '"""',
        end: '"""(?=[^"])',
        contains: [
          s,
          i
        ]
      },
      // Can't use built-in modes easily, as we want to use STRING in the meta
      // context as 'meta-string' and there's no syntax to remove explicitly set
      // classNames in built-in modes.
      {
        begin: "'",
        end: "'",
        illegal: /\n/,
        contains: [n.BACKSLASH_ESCAPE]
      },
      {
        begin: '"',
        end: '"',
        illegal: /\n/,
        contains: [
          n.BACKSLASH_ESCAPE,
          s,
          i
        ]
      }
    ]
  };
  i.contains.push(o);
  const a = {
    className: "meta",
    begin: "@(?:file|property|field|get|set|receiver|param|setparam|delegate)\\s*:(?:\\s*" + n.UNDERSCORE_IDENT_RE + ")?"
  }, l = {
    className: "meta",
    begin: "@" + n.UNDERSCORE_IDENT_RE,
    contains: [
      {
        begin: /\(/,
        end: /\)/,
        contains: [
          n.inherit(o, { className: "string" }),
          "self"
        ]
      }
    ]
  }, c = uft, u = n.COMMENT(
    "/\\*",
    "\\*/",
    { contains: [n.C_BLOCK_COMMENT_MODE] }
  ), d = { variants: [
    {
      className: "type",
      begin: n.UNDERSCORE_IDENT_RE
    },
    {
      begin: /\(/,
      end: /\)/,
      contains: []
      // defined later
    }
  ] }, f = d;
  return f.variants[1].contains = [d], d.variants[1].contains = [f], {
    name: "Kotlin",
    aliases: [
      "kt",
      "kts"
    ],
    keywords: e,
    contains: [
      n.COMMENT(
        "/\\*\\*",
        "\\*/",
        {
          relevance: 0,
          contains: [
            {
              className: "doctag",
              begin: "@[A-Za-z]+"
            }
          ]
        }
      ),
      n.C_LINE_COMMENT_MODE,
      u,
      t,
      r,
      a,
      l,
      {
        className: "function",
        beginKeywords: "fun",
        end: "[(]|$",
        returnBegin: !0,
        excludeEnd: !0,
        keywords: e,
        relevance: 5,
        contains: [
          {
            begin: n.UNDERSCORE_IDENT_RE + "\\s*\\(",
            returnBegin: !0,
            relevance: 0,
            contains: [n.UNDERSCORE_TITLE_MODE]
          },
          {
            className: "type",
            begin: /</,
            end: />/,
            keywords: "reified",
            relevance: 0
          },
          {
            className: "params",
            begin: /\(/,
            end: /\)/,
            endsParent: !0,
            keywords: e,
            relevance: 0,
            contains: [
              {
                begin: /:/,
                end: /[=,\/]/,
                endsWithParent: !0,
                contains: [
                  d,
                  n.C_LINE_COMMENT_MODE,
                  u
                ],
                relevance: 0
              },
              n.C_LINE_COMMENT_MODE,
              u,
              a,
              l,
              o,
              n.C_NUMBER_MODE
            ]
          },
          u
        ]
      },
      {
        begin: [
          /class|interface|trait/,
          /\s+/,
          n.UNDERSCORE_IDENT_RE
        ],
        beginScope: {
          3: "title.class"
        },
        keywords: "class interface trait",
        end: /[:\{(]|$/,
        excludeEnd: !0,
        illegal: "extends implements",
        contains: [
          { beginKeywords: "public protected internal private constructor" },
          n.UNDERSCORE_TITLE_MODE,
          {
            className: "type",
            begin: /</,
            end: />/,
            excludeBegin: !0,
            excludeEnd: !0,
            relevance: 0
          },
          {
            className: "type",
            begin: /[,:]\s*/,
            end: /[<\(,){\s]|$/,
            excludeBegin: !0,
            returnEnd: !0
          },
          a,
          l
        ]
      },
      o,
      {
        className: "meta",
        begin: "^#!/usr/bin/env",
        end: "$",
        illegal: `
`
      },
      c
    ]
  };
}
const fft = (n) => ({
  IMPORTANT: {
    scope: "meta",
    begin: "!important"
  },
  BLOCK_COMMENT: n.C_BLOCK_COMMENT_MODE,
  HEXCOLOR: {
    scope: "number",
    begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
  },
  FUNCTION_DISPATCH: {
    className: "built_in",
    begin: /[\w-]+(?=\()/
  },
  ATTRIBUTE_SELECTOR_MODE: {
    scope: "selector-attr",
    begin: /\[/,
    end: /\]/,
    illegal: "$",
    contains: [
      n.APOS_STRING_MODE,
      n.QUOTE_STRING_MODE
    ]
  },
  CSS_NUMBER_MODE: {
    scope: "number",
    begin: n.NUMBER_RE + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
    relevance: 0
  },
  CSS_VARIABLE: {
    className: "attr",
    begin: /--[A-Za-z_][A-Za-z0-9_-]*/
  }
}), hft = [
  "a",
  "abbr",
  "address",
  "article",
  "aside",
  "audio",
  "b",
  "blockquote",
  "body",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "dd",
  "del",
  "details",
  "dfn",
  "div",
  "dl",
  "dt",
  "em",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "hgroup",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "main",
  "mark",
  "menu",
  "nav",
  "object",
  "ol",
  "optgroup",
  "option",
  "p",
  "picture",
  "q",
  "quote",
  "samp",
  "section",
  "select",
  "source",
  "span",
  "strong",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "tr",
  "ul",
  "var",
  "video"
], pft = [
  "defs",
  "g",
  "marker",
  "mask",
  "pattern",
  "svg",
  "switch",
  "symbol",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feFlood",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMorphology",
  "feOffset",
  "feSpecularLighting",
  "feTile",
  "feTurbulence",
  "linearGradient",
  "radialGradient",
  "stop",
  "circle",
  "ellipse",
  "image",
  "line",
  "path",
  "polygon",
  "polyline",
  "rect",
  "text",
  "use",
  "textPath",
  "tspan",
  "foreignObject",
  "clipPath"
], mft = [
  ...hft,
  ...pft
], gft = [
  "any-hover",
  "any-pointer",
  "aspect-ratio",
  "color",
  "color-gamut",
  "color-index",
  "device-aspect-ratio",
  "device-height",
  "device-width",
  "display-mode",
  "forced-colors",
  "grid",
  "height",
  "hover",
  "inverted-colors",
  "monochrome",
  "orientation",
  "overflow-block",
  "overflow-inline",
  "pointer",
  "prefers-color-scheme",
  "prefers-contrast",
  "prefers-reduced-motion",
  "prefers-reduced-transparency",
  "resolution",
  "scan",
  "scripting",
  "update",
  "width",
  // TODO: find a better solution?
  "min-width",
  "max-width",
  "min-height",
  "max-height"
].sort().reverse(), Lae = [
  "active",
  "any-link",
  "blank",
  "checked",
  "current",
  "default",
  "defined",
  "dir",
  // dir()
  "disabled",
  "drop",
  "empty",
  "enabled",
  "first",
  "first-child",
  "first-of-type",
  "fullscreen",
  "future",
  "focus",
  "focus-visible",
  "focus-within",
  "has",
  // has()
  "host",
  // host or host()
  "host-context",
  // host-context()
  "hover",
  "indeterminate",
  "in-range",
  "invalid",
  "is",
  // is()
  "lang",
  // lang()
  "last-child",
  "last-of-type",
  "left",
  "link",
  "local-link",
  "not",
  // not()
  "nth-child",
  // nth-child()
  "nth-col",
  // nth-col()
  "nth-last-child",
  // nth-last-child()
  "nth-last-col",
  // nth-last-col()
  "nth-last-of-type",
  //nth-last-of-type()
  "nth-of-type",
  //nth-of-type()
  "only-child",
  "only-of-type",
  "optional",
  "out-of-range",
  "past",
  "placeholder-shown",
  "read-only",
  "read-write",
  "required",
  "right",
  "root",
  "scope",
  "target",
  "target-within",
  "user-invalid",
  "valid",
  "visited",
  "where"
  // where()
].sort().reverse(), $ae = [
  "after",
  "backdrop",
  "before",
  "cue",
  "cue-region",
  "first-letter",
  "first-line",
  "grammar-error",
  "marker",
  "part",
  "placeholder",
  "selection",
  "slotted",
  "spelling-error"
].sort().reverse(), vft = [
  "accent-color",
  "align-content",
  "align-items",
  "align-self",
  "alignment-baseline",
  "all",
  "anchor-name",
  "animation",
  "animation-composition",
  "animation-delay",
  "animation-direction",
  "animation-duration",
  "animation-fill-mode",
  "animation-iteration-count",
  "animation-name",
  "animation-play-state",
  "animation-range",
  "animation-range-end",
  "animation-range-start",
  "animation-timeline",
  "animation-timing-function",
  "appearance",
  "aspect-ratio",
  "backdrop-filter",
  "backface-visibility",
  "background",
  "background-attachment",
  "background-blend-mode",
  "background-clip",
  "background-color",
  "background-image",
  "background-origin",
  "background-position",
  "background-position-x",
  "background-position-y",
  "background-repeat",
  "background-size",
  "baseline-shift",
  "block-size",
  "border",
  "border-block",
  "border-block-color",
  "border-block-end",
  "border-block-end-color",
  "border-block-end-style",
  "border-block-end-width",
  "border-block-start",
  "border-block-start-color",
  "border-block-start-style",
  "border-block-start-width",
  "border-block-style",
  "border-block-width",
  "border-bottom",
  "border-bottom-color",
  "border-bottom-left-radius",
  "border-bottom-right-radius",
  "border-bottom-style",
  "border-bottom-width",
  "border-collapse",
  "border-color",
  "border-end-end-radius",
  "border-end-start-radius",
  "border-image",
  "border-image-outset",
  "border-image-repeat",
  "border-image-slice",
  "border-image-source",
  "border-image-width",
  "border-inline",
  "border-inline-color",
  "border-inline-end",
  "border-inline-end-color",
  "border-inline-end-style",
  "border-inline-end-width",
  "border-inline-start",
  "border-inline-start-color",
  "border-inline-start-style",
  "border-inline-start-width",
  "border-inline-style",
  "border-inline-width",
  "border-left",
  "border-left-color",
  "border-left-style",
  "border-left-width",
  "border-radius",
  "border-right",
  "border-right-color",
  "border-right-style",
  "border-right-width",
  "border-spacing",
  "border-start-end-radius",
  "border-start-start-radius",
  "border-style",
  "border-top",
  "border-top-color",
  "border-top-left-radius",
  "border-top-right-radius",
  "border-top-style",
  "border-top-width",
  "border-width",
  "bottom",
  "box-align",
  "box-decoration-break",
  "box-direction",
  "box-flex",
  "box-flex-group",
  "box-lines",
  "box-ordinal-group",
  "box-orient",
  "box-pack",
  "box-shadow",
  "box-sizing",
  "break-after",
  "break-before",
  "break-inside",
  "caption-side",
  "caret-color",
  "clear",
  "clip",
  "clip-path",
  "clip-rule",
  "color",
  "color-interpolation",
  "color-interpolation-filters",
  "color-profile",
  "color-rendering",
  "color-scheme",
  "column-count",
  "column-fill",
  "column-gap",
  "column-rule",
  "column-rule-color",
  "column-rule-style",
  "column-rule-width",
  "column-span",
  "column-width",
  "columns",
  "contain",
  "contain-intrinsic-block-size",
  "contain-intrinsic-height",
  "contain-intrinsic-inline-size",
  "contain-intrinsic-size",
  "contain-intrinsic-width",
  "container",
  "container-name",
  "container-type",
  "content",
  "content-visibility",
  "counter-increment",
  "counter-reset",
  "counter-set",
  "cue",
  "cue-after",
  "cue-before",
  "cursor",
  "cx",
  "cy",
  "direction",
  "display",
  "dominant-baseline",
  "empty-cells",
  "enable-background",
  "field-sizing",
  "fill",
  "fill-opacity",
  "fill-rule",
  "filter",
  "flex",
  "flex-basis",
  "flex-direction",
  "flex-flow",
  "flex-grow",
  "flex-shrink",
  "flex-wrap",
  "float",
  "flood-color",
  "flood-opacity",
  "flow",
  "font",
  "font-display",
  "font-family",
  "font-feature-settings",
  "font-kerning",
  "font-language-override",
  "font-optical-sizing",
  "font-palette",
  "font-size",
  "font-size-adjust",
  "font-smooth",
  "font-smoothing",
  "font-stretch",
  "font-style",
  "font-synthesis",
  "font-synthesis-position",
  "font-synthesis-small-caps",
  "font-synthesis-style",
  "font-synthesis-weight",
  "font-variant",
  "font-variant-alternates",
  "font-variant-caps",
  "font-variant-east-asian",
  "font-variant-emoji",
  "font-variant-ligatures",
  "font-variant-numeric",
  "font-variant-position",
  "font-variation-settings",
  "font-weight",
  "forced-color-adjust",
  "gap",
  "glyph-orientation-horizontal",
  "glyph-orientation-vertical",
  "grid",
  "grid-area",
  "grid-auto-columns",
  "grid-auto-flow",
  "grid-auto-rows",
  "grid-column",
  "grid-column-end",
  "grid-column-start",
  "grid-gap",
  "grid-row",
  "grid-row-end",
  "grid-row-start",
  "grid-template",
  "grid-template-areas",
  "grid-template-columns",
  "grid-template-rows",
  "hanging-punctuation",
  "height",
  "hyphenate-character",
  "hyphenate-limit-chars",
  "hyphens",
  "icon",
  "image-orientation",
  "image-rendering",
  "image-resolution",
  "ime-mode",
  "initial-letter",
  "initial-letter-align",
  "inline-size",
  "inset",
  "inset-area",
  "inset-block",
  "inset-block-end",
  "inset-block-start",
  "inset-inline",
  "inset-inline-end",
  "inset-inline-start",
  "isolation",
  "justify-content",
  "justify-items",
  "justify-self",
  "kerning",
  "left",
  "letter-spacing",
  "lighting-color",
  "line-break",
  "line-height",
  "line-height-step",
  "list-style",
  "list-style-image",
  "list-style-position",
  "list-style-type",
  "margin",
  "margin-block",
  "margin-block-end",
  "margin-block-start",
  "margin-bottom",
  "margin-inline",
  "margin-inline-end",
  "margin-inline-start",
  "margin-left",
  "margin-right",
  "margin-top",
  "margin-trim",
  "marker",
  "marker-end",
  "marker-mid",
  "marker-start",
  "marks",
  "mask",
  "mask-border",
  "mask-border-mode",
  "mask-border-outset",
  "mask-border-repeat",
  "mask-border-slice",
  "mask-border-source",
  "mask-border-width",
  "mask-clip",
  "mask-composite",
  "mask-image",
  "mask-mode",
  "mask-origin",
  "mask-position",
  "mask-repeat",
  "mask-size",
  "mask-type",
  "masonry-auto-flow",
  "math-depth",
  "math-shift",
  "math-style",
  "max-block-size",
  "max-height",
  "max-inline-size",
  "max-width",
  "min-block-size",
  "min-height",
  "min-inline-size",
  "min-width",
  "mix-blend-mode",
  "nav-down",
  "nav-index",
  "nav-left",
  "nav-right",
  "nav-up",
  "none",
  "normal",
  "object-fit",
  "object-position",
  "offset",
  "offset-anchor",
  "offset-distance",
  "offset-path",
  "offset-position",
  "offset-rotate",
  "opacity",
  "order",
  "orphans",
  "outline",
  "outline-color",
  "outline-offset",
  "outline-style",
  "outline-width",
  "overflow",
  "overflow-anchor",
  "overflow-block",
  "overflow-clip-margin",
  "overflow-inline",
  "overflow-wrap",
  "overflow-x",
  "overflow-y",
  "overlay",
  "overscroll-behavior",
  "overscroll-behavior-block",
  "overscroll-behavior-inline",
  "overscroll-behavior-x",
  "overscroll-behavior-y",
  "padding",
  "padding-block",
  "padding-block-end",
  "padding-block-start",
  "padding-bottom",
  "padding-inline",
  "padding-inline-end",
  "padding-inline-start",
  "padding-left",
  "padding-right",
  "padding-top",
  "page",
  "page-break-after",
  "page-break-before",
  "page-break-inside",
  "paint-order",
  "pause",
  "pause-after",
  "pause-before",
  "perspective",
  "perspective-origin",
  "place-content",
  "place-items",
  "place-self",
  "pointer-events",
  "position",
  "position-anchor",
  "position-visibility",
  "print-color-adjust",
  "quotes",
  "r",
  "resize",
  "rest",
  "rest-after",
  "rest-before",
  "right",
  "rotate",
  "row-gap",
  "ruby-align",
  "ruby-position",
  "scale",
  "scroll-behavior",
  "scroll-margin",
  "scroll-margin-block",
  "scroll-margin-block-end",
  "scroll-margin-block-start",
  "scroll-margin-bottom",
  "scroll-margin-inline",
  "scroll-margin-inline-end",
  "scroll-margin-inline-start",
  "scroll-margin-left",
  "scroll-margin-right",
  "scroll-margin-top",
  "scroll-padding",
  "scroll-padding-block",
  "scroll-padding-block-end",
  "scroll-padding-block-start",
  "scroll-padding-bottom",
  "scroll-padding-inline",
  "scroll-padding-inline-end",
  "scroll-padding-inline-start",
  "scroll-padding-left",
  "scroll-padding-right",
  "scroll-padding-top",
  "scroll-snap-align",
  "scroll-snap-stop",
  "scroll-snap-type",
  "scroll-timeline",
  "scroll-timeline-axis",
  "scroll-timeline-name",
  "scrollbar-color",
  "scrollbar-gutter",
  "scrollbar-width",
  "shape-image-threshold",
  "shape-margin",
  "shape-outside",
  "shape-rendering",
  "speak",
  "speak-as",
  "src",
  // @font-face
  "stop-color",
  "stop-opacity",
  "stroke",
  "stroke-dasharray",
  "stroke-dashoffset",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-miterlimit",
  "stroke-opacity",
  "stroke-width",
  "tab-size",
  "table-layout",
  "text-align",
  "text-align-all",
  "text-align-last",
  "text-anchor",
  "text-combine-upright",
  "text-decoration",
  "text-decoration-color",
  "text-decoration-line",
  "text-decoration-skip",
  "text-decoration-skip-ink",
  "text-decoration-style",
  "text-decoration-thickness",
  "text-emphasis",
  "text-emphasis-color",
  "text-emphasis-position",
  "text-emphasis-style",
  "text-indent",
  "text-justify",
  "text-orientation",
  "text-overflow",
  "text-rendering",
  "text-shadow",
  "text-size-adjust",
  "text-transform",
  "text-underline-offset",
  "text-underline-position",
  "text-wrap",
  "text-wrap-mode",
  "text-wrap-style",
  "timeline-scope",
  "top",
  "touch-action",
  "transform",
  "transform-box",
  "transform-origin",
  "transform-style",
  "transition",
  "transition-behavior",
  "transition-delay",
  "transition-duration",
  "transition-property",
  "transition-timing-function",
  "translate",
  "unicode-bidi",
  "user-modify",
  "user-select",
  "vector-effect",
  "vertical-align",
  "view-timeline",
  "view-timeline-axis",
  "view-timeline-inset",
  "view-timeline-name",
  "view-transition-name",
  "visibility",
  "voice-balance",
  "voice-duration",
  "voice-family",
  "voice-pitch",
  "voice-range",
  "voice-rate",
  "voice-stress",
  "voice-volume",
  "white-space",
  "white-space-collapse",
  "widows",
  "width",
  "will-change",
  "word-break",
  "word-spacing",
  "word-wrap",
  "writing-mode",
  "x",
  "y",
  "z-index",
  "zoom"
].sort().reverse(), yft = Lae.concat($ae).sort().reverse();
function bft(n) {
  const e = fft(n), t = yft, r = "and or not only", i = "[\\w-]+", s = "(" + i + "|@\\{" + i + "\\})", o = [], a = [], l = function(x) {
    return {
      // Less strings are not multiline (also include '~' for more consistent coloring of "escaped" strings)
      className: "string",
      begin: "~?" + x + ".*?" + x
    };
  }, c = function(x, E, w) {
    return {
      className: x,
      begin: E,
      relevance: w
    };
  }, u = {
    $pattern: /[a-z-]+/,
    keyword: r,
    attribute: gft.join(" ")
  }, d = {
    // used only to properly balance nested parens inside mixin call, def. arg list
    begin: "\\(",
    end: "\\)",
    contains: a,
    keywords: u,
    relevance: 0
  };
  a.push(
    n.C_LINE_COMMENT_MODE,
    n.C_BLOCK_COMMENT_MODE,
    l("'"),
    l('"'),
    e.CSS_NUMBER_MODE,
    // fixme: it does not include dot for numbers like .5em :(
    {
      begin: "(url|data-uri)\\(",
      starts: {
        className: "string",
        end: "[\\)\\n]",
        excludeEnd: !0
      }
    },
    e.HEXCOLOR,
    d,
    c("variable", "@@?" + i, 10),
    c("variable", "@\\{" + i + "\\}"),
    c("built_in", "~?`[^`]*?`"),
    // inline javascript (or whatever host language) *multiline* string
    {
      // @media features (it’s here to not duplicate things in AT_RULE_MODE with extra PARENS_MODE overriding):
      className: "attribute",
      begin: i + "\\s*:",
      end: ":",
      returnBegin: !0,
      excludeEnd: !0
    },
    e.IMPORTANT,
    { beginKeywords: "and not" },
    e.FUNCTION_DISPATCH
  );
  const f = a.concat({
    begin: /\{/,
    end: /\}/,
    contains: o
  }), h = {
    beginKeywords: "when",
    endsWithParent: !0,
    contains: [{ beginKeywords: "and not" }].concat(a)
    // using this form to override VALUE’s 'function' match
  }, m = {
    begin: s + "\\s*:",
    returnBegin: !0,
    end: /[;}]/,
    relevance: 0,
    contains: [
      { begin: /-(webkit|moz|ms|o)-/ },
      e.CSS_VARIABLE,
      {
        className: "attribute",
        begin: "\\b(" + vft.join("|") + ")\\b",
        end: /(?=:)/,
        starts: {
          endsWithParent: !0,
          illegal: "[<=$]",
          relevance: 0,
          contains: a
        }
      }
    ]
  }, g = {
    className: "keyword",
    begin: "@(import|media|charset|font-face|(-[a-z]+-)?keyframes|supports|document|namespace|page|viewport|host)\\b",
    starts: {
      end: "[;{}]",
      keywords: u,
      returnEnd: !0,
      contains: a,
      relevance: 0
    }
  }, v = {
    className: "variable",
    variants: [
      // using more strict pattern for higher relevance to increase chances of Less detection.
      // this is *the only* Less specific statement used in most of the sources, so...
      // (we’ll still often loose to the css-parser unless there's '//' comment,
      // simply because 1 variable just can't beat 99 properties :)
      {
        begin: "@" + i + "\\s*:",
        relevance: 15
      },
      { begin: "@" + i }
    ],
    starts: {
      end: "[;}]",
      returnEnd: !0,
      contains: f
    }
  }, y = {
    // first parse unambiguous selectors (i.e. those not starting with tag)
    // then fall into the scary lookahead-discriminator variant.
    // this mode also handles mixin definitions and calls
    variants: [
      {
        begin: "[\\.#:&\\[>]",
        end: "[;{}]"
        // mixin calls end with ';'
      },
      {
        begin: s,
        end: /\{/
      }
    ],
    returnBegin: !0,
    returnEnd: !0,
    illegal: `[<='$"]`,
    relevance: 0,
    contains: [
      n.C_LINE_COMMENT_MODE,
      n.C_BLOCK_COMMENT_MODE,
      h,
      c("keyword", "all\\b"),
      c("variable", "@\\{" + i + "\\}"),
      // otherwise it’s identified as tag
      {
        begin: "\\b(" + mft.join("|") + ")\\b",
        className: "selector-tag"
      },
      e.CSS_NUMBER_MODE,
      c("selector-tag", s, 0),
      c("selector-id", "#" + s),
      c("selector-class", "\\." + s, 0),
      c("selector-tag", "&", 0),
      e.ATTRIBUTE_SELECTOR_MODE,
      {
        className: "selector-pseudo",
        begin: ":(" + Lae.join("|") + ")"
      },
      {
        className: "selector-pseudo",
        begin: ":(:)?(" + $ae.join("|") + ")"
      },
      {
        begin: /\(/,
        end: /\)/,
        relevance: 0,
        contains: f
      },
      // argument list of parametric mixins
      { begin: "!important" },
      // eat !important after mixin call or it will be colored as tag
      e.FUNCTION_DISPATCH
    ]
  }, b = {
    begin: i + `:(:)?(${t.join("|")})`,
    returnBegin: !0,
    contains: [y]
  };
  return o.push(
    n.C_LINE_COMMENT_MODE,
    n.C_BLOCK_COMMENT_MODE,
    g,
    v,
    b,
    m,
    y,
    h,
    e.FUNCTION_DISPATCH
  ), {
    name: "Less",
    case_insensitive: !0,
    illegal: `[=>'/<($"]`,
    contains: o
  };
}
function wft(n) {
  const e = "\\[=*\\[", t = "\\]=*\\]", r = {
    begin: e,
    end: t,
    contains: ["self"]
  }, i = [
    n.COMMENT("--(?!" + e + ")", "$"),
    n.COMMENT(
      "--" + e,
      t,
      {
        contains: [r],
        relevance: 10
      }
    )
  ];
  return {
    name: "Lua",
    aliases: ["pluto"],
    keywords: {
      $pattern: n.UNDERSCORE_IDENT_RE,
      literal: "true false nil",
      keyword: "and break do else elseif end for goto if in local not or repeat return then until while",
      built_in: (
        // Metatags and globals:
        "_G _ENV _VERSION __index __newindex __mode __call __metatable __tostring __len __gc __add __sub __mul __div __mod __pow __concat __unm __eq __lt __le assert collectgarbage dofile error getfenv getmetatable ipairs load loadfile loadstring module next pairs pcall print rawequal rawget rawset require select setfenv setmetatable tonumber tostring type unpack xpcall arg self coroutine resume yield status wrap create running debug getupvalue debug sethook getmetatable gethook setmetatable setlocal traceback setfenv getinfo setupvalue getlocal getregistry getfenv io lines write close flush open output type read stderr stdin input stdout popen tmpfile math log max acos huge ldexp pi cos tanh pow deg tan cosh sinh random randomseed frexp ceil floor rad abs sqrt modf asin min mod fmod log10 atan2 exp sin atan os exit setlocale date getenv difftime remove time clock tmpname rename execute package preload loadlib loaded loaders cpath config path seeall string sub upper len gfind rep find match char dump gmatch reverse byte format gsub lower table setn insert getn foreachi maxn foreach concat sort remove"
      )
    },
    contains: i.concat([
      {
        className: "function",
        beginKeywords: "function",
        end: "\\)",
        contains: [
          n.inherit(n.TITLE_MODE, { begin: "([_a-zA-Z]\\w*\\.)*([_a-zA-Z]\\w*:)?[_a-zA-Z]\\w*" }),
          {
            className: "params",
            begin: "\\(",
            endsWithParent: !0,
            contains: i
          }
        ].concat(i)
      },
      n.C_NUMBER_MODE,
      n.APOS_STRING_MODE,
      n.QUOTE_STRING_MODE,
      {
        className: "string",
        begin: e,
        end: t,
        contains: [r],
        relevance: 5
      }
    ])
  };
}
function xft(n) {
  const e = {
    className: "variable",
    variants: [
      {
        begin: "\\$\\(" + n.UNDERSCORE_IDENT_RE + "\\)",
        contains: [n.BACKSLASH_ESCAPE]
      },
      { begin: /\$[@%<?\^\+\*]/ }
    ]
  }, t = {
    className: "string",
    begin: /"/,
    end: /"/,
    contains: [
      n.BACKSLASH_ESCAPE,
      e
    ]
  }, r = {
    className: "variable",
    begin: /\$\([\w-]+\s/,
    end: /\)/,
    keywords: { built_in: "subst patsubst strip findstring filter filter-out sort word wordlist firstword lastword dir notdir suffix basename addsuffix addprefix join wildcard realpath abspath error warning shell origin flavor foreach if or and call eval file value" },
    contains: [
      e,
      t
      // Added QUOTE_STRING as they can be a part of functions
    ]
  }, i = { begin: "^" + n.UNDERSCORE_IDENT_RE + "\\s*(?=[:+?]?=)" }, s = {
    className: "meta",
    begin: /^\.PHONY:/,
    end: /$/,
    keywords: {
      $pattern: /[\.\w]+/,
      keyword: ".PHONY"
    }
  }, o = {
    className: "section",
    begin: /^[^\s]+:/,
    end: /$/,
    contains: [e]
  };
  return {
    name: "Makefile",
    aliases: [
      "mk",
      "mak",
      "make"
    ],
    keywords: {
      $pattern: /[\w-]+/,
      keyword: "define endef undefine ifdef ifndef ifeq ifneq else endif include -include sinclude override export unexport private vpath"
    },
    contains: [
      n.HASH_COMMENT_MODE,
      e,
      t,
      r,
      i,
      s,
      o
    ]
  };
}
function Eft(n) {
  const e = n.regex, t = {
    begin: /<\/?[A-Za-z_]/,
    end: ">",
    subLanguage: "xml",
    relevance: 0
  }, r = {
    begin: "^[-\\*]{3,}",
    end: "$"
  }, i = {
    className: "code",
    variants: [
      // TODO: fix to allow these to work with sublanguage also
      { begin: "(`{3,})[^`](.|\\n)*?\\1`*[ ]*" },
      { begin: "(~{3,})[^~](.|\\n)*?\\1~*[ ]*" },
      // needed to allow markdown as a sublanguage to work
      {
        begin: "```",
        end: "```+[ ]*$"
      },
      {
        begin: "~~~",
        end: "~~~+[ ]*$"
      },
      { begin: "`.+?`" },
      {
        begin: "(?=^( {4}|\\t))",
        // use contains to gobble up multiple lines to allow the block to be whatever size
        // but only have a single open/close tag vs one per line
        contains: [
          {
            begin: "^( {4}|\\t)",
            end: "(\\n)$"
          }
        ],
        relevance: 0
      }
    ]
  }, s = {
    className: "bullet",
    begin: "^[ 	]*([*+-]|(\\d+\\.))(?=\\s+)",
    end: "\\s+",
    excludeEnd: !0
  }, o = {
    begin: /^\[[^\n]+\]:/,
    returnBegin: !0,
    contains: [
      {
        className: "symbol",
        begin: /\[/,
        end: /\]/,
        excludeBegin: !0,
        excludeEnd: !0
      },
      {
        className: "link",
        begin: /:\s*/,
        end: /$/,
        excludeBegin: !0
      }
    ]
  }, a = /[A-Za-z][A-Za-z0-9+.-]*/, l = {
    variants: [
      // too much like nested array access in so many languages
      // to have any real relevance
      {
        begin: /\[.+?\]\[.*?\]/,
        relevance: 0
      },
      // popular internet URLs
      {
        begin: /\[.+?\]\(((data|javascript|mailto):|(?:http|ftp)s?:\/\/).*?\)/,
        relevance: 2
      },
      {
        begin: e.concat(/\[.+?\]\(/, a, /:\/\/.*?\)/),
        relevance: 2
      },
      // relative urls
      {
        begin: /\[.+?\]\([./?&#].*?\)/,
        relevance: 1
      },
      // whatever else, lower relevance (might not be a link at all)
      {
        begin: /\[.*?\]\(.*?\)/,
        relevance: 0
      }
    ],
    returnBegin: !0,
    contains: [
      {
        // empty strings for alt or link text
        match: /\[(?=\])/
      },
      {
        className: "string",
        relevance: 0,
        begin: "\\[",
        end: "\\]",
        excludeBegin: !0,
        returnEnd: !0
      },
      {
        className: "link",
        relevance: 0,
        begin: "\\]\\(",
        end: "\\)",
        excludeBegin: !0,
        excludeEnd: !0
      },
      {
        className: "symbol",
        relevance: 0,
        begin: "\\]\\[",
        end: "\\]",
        excludeBegin: !0,
        excludeEnd: !0
      }
    ]
  }, c = {
    className: "strong",
    contains: [],
    // defined later
    variants: [
      {
        begin: /_{2}(?!\s)/,
        end: /_{2}/
      },
      {
        begin: /\*{2}(?!\s)/,
        end: /\*{2}/
      }
    ]
  }, u = {
    className: "emphasis",
    contains: [],
    // defined later
    variants: [
      {
        begin: /\*(?![*\s])/,
        end: /\*/
      },
      {
        begin: /_(?![_\s])/,
        end: /_/,
        relevance: 0
      }
    ]
  }, d = n.inherit(c, { contains: [] }), f = n.inherit(u, { contains: [] });
  c.contains.push(f), u.contains.push(d);
  let h = [
    t,
    l
  ];
  return [
    c,
    u,
    d,
    f
  ].forEach((y) => {
    y.contains = y.contains.concat(h);
  }), h = h.concat(c, u), {
    name: "Markdown",
    aliases: [
      "md",
      "mkdown",
      "mkd"
    ],
    contains: [
      {
        className: "section",
        variants: [
          {
            begin: "^#{1,6}",
            end: "$",
            contains: h
          },
          {
            begin: "(?=^.+?\\n[=-]{2,}$)",
            contains: [
              { begin: "^[=-]*$" },
              {
                begin: "^",
                end: "\\n",
                contains: h
              }
            ]
          }
        ]
      },
      t,
      s,
      c,
      u,
      {
        className: "quote",
        begin: "^>\\s+",
        contains: h,
        end: "$"
      },
      i,
      r,
      l,
      o,
      {
        //https://spec.commonmark.org/0.31.2/#entity-references
        scope: "literal",
        match: /&([a-zA-Z0-9]+|#[0-9]{1,7}|#[Xx][0-9a-fA-F]{1,6});/
      }
    ]
  };
}
function Sft(n) {
  const e = {
    className: "built_in",
    begin: "\\b(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)\\w+"
  }, t = /[a-zA-Z@][a-zA-Z0-9_]*/, a = {
    "variable.language": [
      "this",
      "super"
    ],
    $pattern: t,
    keyword: [
      "while",
      "export",
      "sizeof",
      "typedef",
      "const",
      "struct",
      "for",
      "union",
      "volatile",
      "static",
      "mutable",
      "if",
      "do",
      "return",
      "goto",
      "enum",
      "else",
      "break",
      "extern",
      "asm",
      "case",
      "default",
      "register",
      "explicit",
      "typename",
      "switch",
      "continue",
      "inline",
      "readonly",
      "assign",
      "readwrite",
      "self",
      "@synchronized",
      "id",
      "typeof",
      "nonatomic",
      "IBOutlet",
      "IBAction",
      "strong",
      "weak",
      "copy",
      "in",
      "out",
      "inout",
      "bycopy",
      "byref",
      "oneway",
      "__strong",
      "__weak",
      "__block",
      "__autoreleasing",
      "@private",
      "@protected",
      "@public",
      "@try",
      "@property",
      "@end",
      "@throw",
      "@catch",
      "@finally",
      "@autoreleasepool",
      "@synthesize",
      "@dynamic",
      "@selector",
      "@optional",
      "@required",
      "@encode",
      "@package",
      "@import",
      "@defs",
      "@compatibility_alias",
      "__bridge",
      "__bridge_transfer",
      "__bridge_retained",
      "__bridge_retain",
      "__covariant",
      "__contravariant",
      "__kindof",
      "_Nonnull",
      "_Nullable",
      "_Null_unspecified",
      "__FUNCTION__",
      "__PRETTY_FUNCTION__",
      "__attribute__",
      "getter",
      "setter",
      "retain",
      "unsafe_unretained",
      "nonnull",
      "nullable",
      "null_unspecified",
      "null_resettable",
      "class",
      "instancetype",
      "NS_DESIGNATED_INITIALIZER",
      "NS_UNAVAILABLE",
      "NS_REQUIRES_SUPER",
      "NS_RETURNS_INNER_POINTER",
      "NS_INLINE",
      "NS_AVAILABLE",
      "NS_DEPRECATED",
      "NS_ENUM",
      "NS_OPTIONS",
      "NS_SWIFT_UNAVAILABLE",
      "NS_ASSUME_NONNULL_BEGIN",
      "NS_ASSUME_NONNULL_END",
      "NS_REFINED_FOR_SWIFT",
      "NS_SWIFT_NAME",
      "NS_SWIFT_NOTHROW",
      "NS_DURING",
      "NS_HANDLER",
      "NS_ENDHANDLER",
      "NS_VALUERETURN",
      "NS_VOIDRETURN"
    ],
    literal: [
      "false",
      "true",
      "FALSE",
      "TRUE",
      "nil",
      "YES",
      "NO",
      "NULL"
    ],
    built_in: [
      "dispatch_once_t",
      "dispatch_queue_t",
      "dispatch_sync",
      "dispatch_async",
      "dispatch_once"
    ],
    type: [
      "int",
      "float",
      "char",
      "unsigned",
      "signed",
      "short",
      "long",
      "double",
      "wchar_t",
      "unichar",
      "void",
      "bool",
      "BOOL",
      "id|0",
      "_Bool"
    ]
  }, l = {
    $pattern: t,
    keyword: [
      "@interface",
      "@class",
      "@protocol",
      "@implementation"
    ]
  };
  return {
    name: "Objective-C",
    aliases: [
      "mm",
      "objc",
      "obj-c",
      "obj-c++",
      "objective-c++"
    ],
    keywords: a,
    illegal: "</",
    contains: [
      e,
      n.C_LINE_COMMENT_MODE,
      n.C_BLOCK_COMMENT_MODE,
      n.C_NUMBER_MODE,
      n.QUOTE_STRING_MODE,
      n.APOS_STRING_MODE,
      {
        className: "string",
        variants: [
          {
            begin: '@"',
            end: '"',
            illegal: "\\n",
            contains: [n.BACKSLASH_ESCAPE]
          }
        ]
      },
      {
        className: "meta",
        begin: /#\s*[a-z]+\b/,
        end: /$/,
        keywords: { keyword: "if else elif endif define undef warning error line pragma ifdef ifndef include" },
        contains: [
          {
            begin: /\\\n/,
            relevance: 0
          },
          n.inherit(n.QUOTE_STRING_MODE, { className: "string" }),
          {
            className: "string",
            begin: /<.*?>/,
            end: /$/,
            illegal: "\\n"
          },
          n.C_LINE_COMMENT_MODE,
          n.C_BLOCK_COMMENT_MODE
        ]
      },
      {
        className: "class",
        begin: "(" + l.keyword.join("|") + ")\\b",
        end: /(\{|$)/,
        excludeEnd: !0,
        keywords: l,
        contains: [n.UNDERSCORE_TITLE_MODE]
      },
      {
        begin: "\\." + n.UNDERSCORE_IDENT_RE,
        relevance: 0
      }
    ]
  };
}
function Cft(n) {
  const e = n.regex, t = [
    "abs",
    "accept",
    "alarm",
    "and",
    "atan2",
    "bind",
    "binmode",
    "bless",
    "break",
    "caller",
    "chdir",
    "chmod",
    "chomp",
    "chop",
    "chown",
    "chr",
    "chroot",
    "class",
    "close",
    "closedir",
    "connect",
    "continue",
    "cos",
    "crypt",
    "dbmclose",
    "dbmopen",
    "defined",
    "delete",
    "die",
    "do",
    "dump",
    "each",
    "else",
    "elsif",
    "endgrent",
    "endhostent",
    "endnetent",
    "endprotoent",
    "endpwent",
    "endservent",
    "eof",
    "eval",
    "exec",
    "exists",
    "exit",
    "exp",
    "fcntl",
    "field",
    "fileno",
    "flock",
    "for",
    "foreach",
    "fork",
    "format",
    "formline",
    "getc",
    "getgrent",
    "getgrgid",
    "getgrnam",
    "gethostbyaddr",
    "gethostbyname",
    "gethostent",
    "getlogin",
    "getnetbyaddr",
    "getnetbyname",
    "getnetent",
    "getpeername",
    "getpgrp",
    "getpriority",
    "getprotobyname",
    "getprotobynumber",
    "getprotoent",
    "getpwent",
    "getpwnam",
    "getpwuid",
    "getservbyname",
    "getservbyport",
    "getservent",
    "getsockname",
    "getsockopt",
    "given",
    "glob",
    "gmtime",
    "goto",
    "grep",
    "gt",
    "hex",
    "if",
    "index",
    "int",
    "ioctl",
    "join",
    "keys",
    "kill",
    "last",
    "lc",
    "lcfirst",
    "length",
    "link",
    "listen",
    "local",
    "localtime",
    "log",
    "lstat",
    "lt",
    "ma",
    "map",
    "method",
    "mkdir",
    "msgctl",
    "msgget",
    "msgrcv",
    "msgsnd",
    "my",
    "ne",
    "next",
    "no",
    "not",
    "oct",
    "open",
    "opendir",
    "or",
    "ord",
    "our",
    "pack",
    "package",
    "pipe",
    "pop",
    "pos",
    "print",
    "printf",
    "prototype",
    "push",
    "q|0",
    "qq",
    "quotemeta",
    "qw",
    "qx",
    "rand",
    "read",
    "readdir",
    "readline",
    "readlink",
    "readpipe",
    "recv",
    "redo",
    "ref",
    "rename",
    "require",
    "reset",
    "return",
    "reverse",
    "rewinddir",
    "rindex",
    "rmdir",
    "say",
    "scalar",
    "seek",
    "seekdir",
    "select",
    "semctl",
    "semget",
    "semop",
    "send",
    "setgrent",
    "sethostent",
    "setnetent",
    "setpgrp",
    "setpriority",
    "setprotoent",
    "setpwent",
    "setservent",
    "setsockopt",
    "shift",
    "shmctl",
    "shmget",
    "shmread",
    "shmwrite",
    "shutdown",
    "sin",
    "sleep",
    "socket",
    "socketpair",
    "sort",
    "splice",
    "split",
    "sprintf",
    "sqrt",
    "srand",
    "stat",
    "state",
    "study",
    "sub",
    "substr",
    "symlink",
    "syscall",
    "sysopen",
    "sysread",
    "sysseek",
    "system",
    "syswrite",
    "tell",
    "telldir",
    "tie",
    "tied",
    "time",
    "times",
    "tr",
    "truncate",
    "uc",
    "ucfirst",
    "umask",
    "undef",
    "unless",
    "unlink",
    "unpack",
    "unshift",
    "untie",
    "until",
    "use",
    "utime",
    "values",
    "vec",
    "wait",
    "waitpid",
    "wantarray",
    "warn",
    "when",
    "while",
    "write",
    "x|0",
    "xor",
    "y|0"
  ], r = /[dualxmsipngr]{0,12}/, i = {
    $pattern: /[\w.]+/,
    keyword: t.join(" ")
  }, s = {
    className: "subst",
    begin: "[$@]\\{",
    end: "\\}",
    keywords: i
  }, o = {
    begin: /->\{/,
    end: /\}/
    // contains defined later
  }, a = {
    scope: "attr",
    match: /\s+:\s*\w+(\s*\(.*?\))?/
  }, l = {
    scope: "variable",
    variants: [
      { begin: /\$\d/ },
      {
        begin: e.concat(
          /[$%@](?!")(\^\w\b|#\w+(::\w+)*|\{\w+\}|\w+(::\w*)*)/,
          // negative look-ahead tries to avoid matching patterns that are not
          // Perl at all like $ident$, @ident@, etc.
          "(?![A-Za-z])(?![@$%])"
        )
      },
      {
        // Only $= is a special Perl variable and one can't declare @= or %=.
        begin: /[$%@](?!")[^\s\w{=]|\$=/,
        relevance: 0
      }
    ],
    contains: [a]
  }, c = {
    className: "number",
    variants: [
      // decimal numbers:
      // include the case where a number starts with a dot (eg. .9), and
      // the leading 0? avoids mixing the first and second match on 0.x cases
      { match: /0?\.[0-9][0-9_]+\b/ },
      // include the special versioned number (eg. v5.38)
      { match: /\bv?(0|[1-9][0-9_]*(\.[0-9_]+)?|[1-9][0-9_]*)\b/ },
      // non-decimal numbers:
      { match: /\b0[0-7][0-7_]*\b/ },
      { match: /\b0x[0-9a-fA-F][0-9a-fA-F_]*\b/ },
      { match: /\b0b[0-1][0-1_]*\b/ }
    ],
    relevance: 0
  }, u = [
    n.BACKSLASH_ESCAPE,
    s,
    l
  ], d = [
    /!/,
    /\//,
    /\|/,
    /\?/,
    /'/,
    /"/,
    // valid but infrequent and weird
    /#/
    // valid but infrequent and weird
  ], f = (g, v, y = "\\1") => {
    const b = y === "\\1" ? y : e.concat(y, v);
    return e.concat(
      e.concat("(?:", g, ")"),
      v,
      /(?:\\.|[^\\\/])*?/,
      b,
      /(?:\\.|[^\\\/])*?/,
      y,
      r
    );
  }, h = (g, v, y) => e.concat(
    e.concat("(?:", g, ")"),
    v,
    /(?:\\.|[^\\\/])*?/,
    y,
    r
  ), m = [
    l,
    n.HASH_COMMENT_MODE,
    n.COMMENT(
      /^=\w/,
      /=cut/,
      { endsWithParent: !0 }
    ),
    o,
    {
      className: "string",
      contains: u,
      variants: [
        {
          begin: "q[qwxr]?\\s*\\(",
          end: "\\)",
          relevance: 5
        },
        {
          begin: "q[qwxr]?\\s*\\[",
          end: "\\]",
          relevance: 5
        },
        {
          begin: "q[qwxr]?\\s*\\{",
          end: "\\}",
          relevance: 5
        },
        {
          begin: "q[qwxr]?\\s*\\|",
          end: "\\|",
          relevance: 5
        },
        {
          begin: "q[qwxr]?\\s*<",
          end: ">",
          relevance: 5
        },
        {
          begin: "qw\\s+q",
          end: "q",
          relevance: 5
        },
        {
          begin: "'",
          end: "'",
          contains: [n.BACKSLASH_ESCAPE]
        },
        {
          begin: '"',
          end: '"'
        },
        {
          begin: "`",
          end: "`",
          contains: [n.BACKSLASH_ESCAPE]
        },
        {
          begin: /\{\w+\}/,
          relevance: 0
        },
        {
          begin: "-?\\w+\\s*=>",
          relevance: 0
        }
      ]
    },
    c,
    {
      // regexp container
      begin: "(\\/\\/|" + n.RE_STARTERS_RE + "|\\b(split|return|print|reverse|grep)\\b)\\s*",
      keywords: "split return print reverse grep",
      relevance: 0,
      contains: [
        n.HASH_COMMENT_MODE,
        {
          className: "regexp",
          variants: [
            // allow matching common delimiters
            { begin: f("s|tr|y", e.either(...d, { capture: !0 })) },
            // and then paired delmis
            { begin: f("s|tr|y", "\\(", "\\)") },
            { begin: f("s|tr|y", "\\[", "\\]") },
            { begin: f("s|tr|y", "\\{", "\\}") }
          ],
          relevance: 2
        },
        {
          className: "regexp",
          variants: [
            {
              // could be a comment in many languages so do not count
              // as relevant
              begin: /(m|qr)\/\//,
              relevance: 0
            },
            // prefix is optional with /regex/
            { begin: h("(?:m|qr)?", /\//, /\//) },
            // allow matching common delimiters
            { begin: h("m|qr", e.either(...d, { capture: !0 }), /\1/) },
            // allow common paired delmins
            { begin: h("m|qr", /\(/, /\)/) },
            { begin: h("m|qr", /\[/, /\]/) },
            { begin: h("m|qr", /\{/, /\}/) }
          ]
        }
      ]
    },
    {
      className: "function",
      beginKeywords: "sub method",
      end: "(\\s*\\(.*?\\))?[;{]",
      excludeEnd: !0,
      relevance: 5,
      contains: [n.TITLE_MODE, a]
    },
    {
      className: "class",
      beginKeywords: "class",
      end: "[;{]",
      excludeEnd: !0,
      relevance: 5,
      contains: [n.TITLE_MODE, a, c]
    },
    {
      begin: "-\\w\\b",
      relevance: 0
    },
    {
      begin: "^__DATA__$",
      end: "^__END__$",
      subLanguage: "mojolicious",
      contains: [
        {
          begin: "^@@.*",
          end: "$",
          className: "comment"
        }
      ]
    }
  ];
  return s.contains = m, o.contains = m, {
    name: "Perl",
    aliases: [
      "pl",
      "pm"
    ],
    keywords: i,
    contains: m
  };
}
function Tft(n) {
  const e = n.regex, t = /(?![A-Za-z0-9])(?![$])/, r = e.concat(
    /[a-zA-Z_\x7f-\xff][a-zA-Z0-9_\x7f-\xff]*/,
    t
  ), i = e.concat(
    /(\\?[A-Z][a-z0-9_\x7f-\xff]+|\\?[A-Z]+(?=[A-Z][a-z0-9_\x7f-\xff])){1,}/,
    t
  ), s = e.concat(
    /[A-Z]+/,
    t
  ), o = {
    scope: "variable",
    match: "\\$+" + r
  }, a = {
    scope: "meta",
    variants: [
      { begin: /<\?php/, relevance: 10 },
      // boost for obvious PHP
      { begin: /<\?=/ },
      // less relevant per PSR-1 which says not to use short-tags
      { begin: /<\?/, relevance: 0.1 },
      { begin: /\?>/ }
      // end php tag
    ]
  }, l = {
    scope: "subst",
    variants: [
      { begin: /\$\w+/ },
      {
        begin: /\{\$/,
        end: /\}/
      }
    ]
  }, c = n.inherit(n.APOS_STRING_MODE, { illegal: null }), u = n.inherit(n.QUOTE_STRING_MODE, {
    illegal: null,
    contains: n.QUOTE_STRING_MODE.contains.concat(l)
  }), d = {
    begin: /<<<[ \t]*(?:(\w+)|"(\w+)")\n/,
    end: /[ \t]*(\w+)\b/,
    contains: n.QUOTE_STRING_MODE.contains.concat(l),
    "on:begin": (P, D) => {
      D.data._beginMatch = P[1] || P[2];
    },
    "on:end": (P, D) => {
      D.data._beginMatch !== P[1] && D.ignoreMatch();
    }
  }, f = n.END_SAME_AS_BEGIN({
    begin: /<<<[ \t]*'(\w+)'\n/,
    end: /[ \t]*(\w+)\b/
  }), h = `[ 	
]`, m = {
    scope: "string",
    variants: [
      u,
      c,
      d,
      f
    ]
  }, g = {
    scope: "number",
    variants: [
      { begin: "\\b0[bB][01]+(?:_[01]+)*\\b" },
      // Binary w/ underscore support
      { begin: "\\b0[oO][0-7]+(?:_[0-7]+)*\\b" },
      // Octals w/ underscore support
      { begin: "\\b0[xX][\\da-fA-F]+(?:_[\\da-fA-F]+)*\\b" },
      // Hex w/ underscore support
      // Decimals w/ underscore support, with optional fragments and scientific exponent (e) suffix.
      { begin: "(?:\\b\\d+(?:_\\d+)*(\\.(?:\\d+(?:_\\d+)*))?|\\B\\.\\d+)(?:[eE][+-]?\\d+)?" }
    ],
    relevance: 0
  }, v = [
    "false",
    "null",
    "true"
  ], y = [
    // Magic constants:
    // <https://www.php.net/manual/en/language.constants.predefined.php>
    "__CLASS__",
    "__DIR__",
    "__FILE__",
    "__FUNCTION__",
    "__COMPILER_HALT_OFFSET__",
    "__LINE__",
    "__METHOD__",
    "__NAMESPACE__",
    "__TRAIT__",
    // Function that look like language construct or language construct that look like function:
    // List of keywords that may not require parenthesis
    "die",
    "echo",
    "exit",
    "include",
    "include_once",
    "print",
    "require",
    "require_once",
    // These are not language construct (function) but operate on the currently-executing function and can access the current symbol table
    // 'compact extract func_get_arg func_get_args func_num_args get_called_class get_parent_class ' +
    // Other keywords:
    // <https://www.php.net/manual/en/reserved.php>
    // <https://www.php.net/manual/en/language.types.type-juggling.php>
    "array",
    "abstract",
    "and",
    "as",
    "binary",
    "bool",
    "boolean",
    "break",
    "callable",
    "case",
    "catch",
    "class",
    "clone",
    "const",
    "continue",
    "declare",
    "default",
    "do",
    "double",
    "else",
    "elseif",
    "empty",
    "enddeclare",
    "endfor",
    "endforeach",
    "endif",
    "endswitch",
    "endwhile",
    "enum",
    "eval",
    "extends",
    "final",
    "finally",
    "float",
    "for",
    "foreach",
    "from",
    "global",
    "goto",
    "if",
    "implements",
    "instanceof",
    "insteadof",
    "int",
    "integer",
    "interface",
    "isset",
    "iterable",
    "list",
    "match|0",
    "mixed",
    "new",
    "never",
    "object",
    "or",
    "private",
    "protected",
    "public",
    "readonly",
    "real",
    "return",
    "string",
    "switch",
    "throw",
    "trait",
    "try",
    "unset",
    "use",
    "var",
    "void",
    "while",
    "xor",
    "yield"
  ], b = [
    // Standard PHP library:
    // <https://www.php.net/manual/en/book.spl.php>
    "Error|0",
    "AppendIterator",
    "ArgumentCountError",
    "ArithmeticError",
    "ArrayIterator",
    "ArrayObject",
    "AssertionError",
    "BadFunctionCallException",
    "BadMethodCallException",
    "CachingIterator",
    "CallbackFilterIterator",
    "CompileError",
    "Countable",
    "DirectoryIterator",
    "DivisionByZeroError",
    "DomainException",
    "EmptyIterator",
    "ErrorException",
    "Exception",
    "FilesystemIterator",
    "FilterIterator",
    "GlobIterator",
    "InfiniteIterator",
    "InvalidArgumentException",
    "IteratorIterator",
    "LengthException",
    "LimitIterator",
    "LogicException",
    "MultipleIterator",
    "NoRewindIterator",
    "OutOfBoundsException",
    "OutOfRangeException",
    "OuterIterator",
    "OverflowException",
    "ParentIterator",
    "ParseError",
    "RangeException",
    "RecursiveArrayIterator",
    "RecursiveCachingIterator",
    "RecursiveCallbackFilterIterator",
    "RecursiveDirectoryIterator",
    "RecursiveFilterIterator",
    "RecursiveIterator",
    "RecursiveIteratorIterator",
    "RecursiveRegexIterator",
    "RecursiveTreeIterator",
    "RegexIterator",
    "RuntimeException",
    "SeekableIterator",
    "SplDoublyLinkedList",
    "SplFileInfo",
    "SplFileObject",
    "SplFixedArray",
    "SplHeap",
    "SplMaxHeap",
    "SplMinHeap",
    "SplObjectStorage",
    "SplObserver",
    "SplPriorityQueue",
    "SplQueue",
    "SplStack",
    "SplSubject",
    "SplTempFileObject",
    "TypeError",
    "UnderflowException",
    "UnexpectedValueException",
    "UnhandledMatchError",
    // Reserved interfaces:
    // <https://www.php.net/manual/en/reserved.interfaces.php>
    "ArrayAccess",
    "BackedEnum",
    "Closure",
    "Fiber",
    "Generator",
    "Iterator",
    "IteratorAggregate",
    "Serializable",
    "Stringable",
    "Throwable",
    "Traversable",
    "UnitEnum",
    "WeakReference",
    "WeakMap",
    // Reserved classes:
    // <https://www.php.net/manual/en/reserved.classes.php>
    "Directory",
    "__PHP_Incomplete_Class",
    "parent",
    "php_user_filter",
    "self",
    "static",
    "stdClass"
  ], E = {
    keyword: y,
    literal: ((P) => {
      const D = [];
      return P.forEach((L) => {
        D.push(L), L.toLowerCase() === L ? D.push(L.toUpperCase()) : D.push(L.toLowerCase());
      }), D;
    })(v),
    built_in: b
  }, w = (P) => P.map((D) => D.replace(/\|\d+$/, "")), C = { variants: [
    {
      match: [
        /new/,
        e.concat(h, "+"),
        // to prevent built ins from being confused as the class constructor call
        e.concat("(?!", w(b).join("\\b|"), "\\b)"),
        i
      ],
      scope: {
        1: "keyword",
        4: "title.class"
      }
    }
  ] }, S = e.concat(r, "\\b(?!\\()"), M = { variants: [
    {
      match: [
        e.concat(
          /::/,
          e.lookahead(/(?!class\b)/)
        ),
        S
      ],
      scope: { 2: "variable.constant" }
    },
    {
      match: [
        /::/,
        /class/
      ],
      scope: { 2: "variable.language" }
    },
    {
      match: [
        i,
        e.concat(
          /::/,
          e.lookahead(/(?!class\b)/)
        ),
        S
      ],
      scope: {
        1: "title.class",
        3: "variable.constant"
      }
    },
    {
      match: [
        i,
        e.concat(
          "::",
          e.lookahead(/(?!class\b)/)
        )
      ],
      scope: { 1: "title.class" }
    },
    {
      match: [
        i,
        /::/,
        /class/
      ],
      scope: {
        1: "title.class",
        3: "variable.language"
      }
    }
  ] }, k = {
    scope: "attr",
    match: e.concat(r, e.lookahead(":"), e.lookahead(/(?!::)/))
  }, _ = {
    relevance: 0,
    begin: /\(/,
    end: /\)/,
    keywords: E,
    contains: [
      k,
      o,
      M,
      n.C_BLOCK_COMMENT_MODE,
      m,
      g,
      C
    ]
  }, O = {
    relevance: 0,
    match: [
      /\b/,
      // to prevent keywords from being confused as the function title
      e.concat("(?!fn\\b|function\\b|", w(y).join("\\b|"), "|", w(b).join("\\b|"), "\\b)"),
      r,
      e.concat(h, "*"),
      e.lookahead(/(?=\()/)
    ],
    scope: { 3: "title.function.invoke" },
    contains: [_]
  };
  _.contains.push(O);
  const I = [
    k,
    M,
    n.C_BLOCK_COMMENT_MODE,
    m,
    g,
    C
  ], R = {
    begin: e.concat(
      /#\[\s*\\?/,
      e.either(
        i,
        s
      )
    ),
    beginScope: "meta",
    end: /]/,
    endScope: "meta",
    keywords: {
      literal: v,
      keyword: [
        "new",
        "array"
      ]
    },
    contains: [
      {
        begin: /\[/,
        end: /]/,
        keywords: {
          literal: v,
          keyword: [
            "new",
            "array"
          ]
        },
        contains: [
          "self",
          ...I
        ]
      },
      ...I,
      {
        scope: "meta",
        variants: [
          { match: i },
          { match: s }
        ]
      }
    ]
  };
  return {
    case_insensitive: !1,
    keywords: E,
    contains: [
      R,
      n.HASH_COMMENT_MODE,
      n.COMMENT("//", "$"),
      n.COMMENT(
        "/\\*",
        "\\*/",
        { contains: [
          {
            scope: "doctag",
            match: "@[A-Za-z]+"
          }
        ] }
      ),
      {
        match: /__halt_compiler\(\);/,
        keywords: "__halt_compiler",
        starts: {
          scope: "comment",
          end: n.MATCH_NOTHING_RE,
          contains: [
            {
              match: /\?>/,
              scope: "meta",
              endsParent: !0
            }
          ]
        }
      },
      a,
      {
        scope: "variable.language",
        match: /\$this\b/
      },
      o,
      O,
      M,
      {
        match: [
          /const/,
          /\s/,
          r
        ],
        scope: {
          1: "keyword",
          3: "variable.constant"
        }
      },
      C,
      {
        scope: "function",
        relevance: 0,
        beginKeywords: "fn function",
        end: /[;{]/,
        excludeEnd: !0,
        illegal: "[$%\\[]",
        contains: [
          { beginKeywords: "use" },
          n.UNDERSCORE_TITLE_MODE,
          {
            begin: "=>",
            // No markup, just a relevance booster
            endsParent: !0
          },
          {
            scope: "params",
            begin: "\\(",
            end: "\\)",
            excludeBegin: !0,
            excludeEnd: !0,
            keywords: E,
            contains: [
              "self",
              R,
              o,
              M,
              n.C_BLOCK_COMMENT_MODE,
              m,
              g
            ]
          }
        ]
      },
      {
        scope: "class",
        variants: [
          {
            beginKeywords: "enum",
            illegal: /[($"]/
          },
          {
            beginKeywords: "class interface trait",
            illegal: /[:($"]/
          }
        ],
        relevance: 0,
        end: /\{/,
        excludeEnd: !0,
        contains: [
          { beginKeywords: "extends implements" },
          n.UNDERSCORE_TITLE_MODE
        ]
      },
      // both use and namespace still use "old style" rules (vs multi-match)
      // because the namespace name can include `\` and we still want each
      // element to be treated as its own *individual* title
      {
        beginKeywords: "namespace",
        relevance: 0,
        end: ";",
        illegal: /[.']/,
        contains: [n.inherit(n.UNDERSCORE_TITLE_MODE, { scope: "title.class" })]
      },
      {
        beginKeywords: "use",
        relevance: 0,
        end: ";",
        contains: [
          // TODO: title.function vs title.class
          {
            match: /\b(as|const|function)\b/,
            scope: "keyword"
          },
          // TODO: could be title.class or title.function
          n.UNDERSCORE_TITLE_MODE
        ]
      },
      m,
      g
    ]
  };
}
function Aft(n) {
  return {
    name: "PHP template",
    subLanguage: "xml",
    contains: [
      {
        begin: /<\?(php|=)?/,
        end: /\?>/,
        subLanguage: "php",
        contains: [
          // We don't want the php closing tag ?> to close the PHP block when
          // inside any of the following blocks:
          {
            begin: "/\\*",
            end: "\\*/",
            skip: !0
          },
          {
            begin: 'b"',
            end: '"',
            skip: !0
          },
          {
            begin: "b'",
            end: "'",
            skip: !0
          },
          n.inherit(n.APOS_STRING_MODE, {
            illegal: null,
            className: null,
            contains: null,
            skip: !0
          }),
          n.inherit(n.QUOTE_STRING_MODE, {
            illegal: null,
            className: null,
            contains: null,
            skip: !0
          })
        ]
      }
    ]
  };
}
function Mft(n) {
  return {
    name: "Plain text",
    aliases: [
      "text",
      "txt"
    ],
    disableAutodetect: !0
  };
}
function kft(n) {
  const e = n.regex, t = new RegExp("[\\p{XID_Start}_]\\p{XID_Continue}*", "u"), r = [
    "and",
    "as",
    "assert",
    "async",
    "await",
    "break",
    "case",
    "class",
    "continue",
    "def",
    "del",
    "elif",
    "else",
    "except",
    "finally",
    "for",
    "from",
    "global",
    "if",
    "import",
    "in",
    "is",
    "lambda",
    "match",
    "nonlocal|10",
    "not",
    "or",
    "pass",
    "raise",
    "return",
    "try",
    "while",
    "with",
    "yield"
  ], a = {
    $pattern: /[A-Za-z]\w+|__\w+__/,
    keyword: r,
    built_in: [
      "__import__",
      "abs",
      "all",
      "any",
      "ascii",
      "bin",
      "bool",
      "breakpoint",
      "bytearray",
      "bytes",
      "callable",
      "chr",
      "classmethod",
      "compile",
      "complex",
      "delattr",
      "dict",
      "dir",
      "divmod",
      "enumerate",
      "eval",
      "exec",
      "filter",
      "float",
      "format",
      "frozenset",
      "getattr",
      "globals",
      "hasattr",
      "hash",
      "help",
      "hex",
      "id",
      "input",
      "int",
      "isinstance",
      "issubclass",
      "iter",
      "len",
      "list",
      "locals",
      "map",
      "max",
      "memoryview",
      "min",
      "next",
      "object",
      "oct",
      "open",
      "ord",
      "pow",
      "print",
      "property",
      "range",
      "repr",
      "reversed",
      "round",
      "set",
      "setattr",
      "slice",
      "sorted",
      "staticmethod",
      "str",
      "sum",
      "super",
      "tuple",
      "type",
      "vars",
      "zip"
    ],
    literal: [
      "__debug__",
      "Ellipsis",
      "False",
      "None",
      "NotImplemented",
      "True"
    ],
    type: [
      "Any",
      "Callable",
      "Coroutine",
      "Dict",
      "List",
      "Literal",
      "Generic",
      "Optional",
      "Sequence",
      "Set",
      "Tuple",
      "Type",
      "Union"
    ]
  }, l = {
    className: "meta",
    begin: /^(>>>|\.\.\.) /
  }, c = {
    className: "subst",
    begin: /\{/,
    end: /\}/,
    keywords: a,
    illegal: /#/
  }, u = {
    begin: /\{\{/,
    relevance: 0
  }, d = {
    className: "string",
    contains: [n.BACKSLASH_ESCAPE],
    variants: [
      {
        begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?'''/,
        end: /'''/,
        contains: [
          n.BACKSLASH_ESCAPE,
          l
        ],
        relevance: 10
      },
      {
        begin: /([uU]|[bB]|[rR]|[bB][rR]|[rR][bB])?"""/,
        end: /"""/,
        contains: [
          n.BACKSLASH_ESCAPE,
          l
        ],
        relevance: 10
      },
      {
        begin: /([fF][rR]|[rR][fF]|[fF])'''/,
        end: /'''/,
        contains: [
          n.BACKSLASH_ESCAPE,
          l,
          u,
          c
        ]
      },
      {
        begin: /([fF][rR]|[rR][fF]|[fF])"""/,
        end: /"""/,
        contains: [
          n.BACKSLASH_ESCAPE,
          l,
          u,
          c
        ]
      },
      {
        begin: /([uU]|[rR])'/,
        end: /'/,
        relevance: 10
      },
      {
        begin: /([uU]|[rR])"/,
        end: /"/,
        relevance: 10
      },
      {
        begin: /([bB]|[bB][rR]|[rR][bB])'/,
        end: /'/
      },
      {
        begin: /([bB]|[bB][rR]|[rR][bB])"/,
        end: /"/
      },
      {
        begin: /([fF][rR]|[rR][fF]|[fF])'/,
        end: /'/,
        contains: [
          n.BACKSLASH_ESCAPE,
          u,
          c
        ]
      },
      {
        begin: /([fF][rR]|[rR][fF]|[fF])"/,
        end: /"/,
        contains: [
          n.BACKSLASH_ESCAPE,
          u,
          c
        ]
      },
      n.APOS_STRING_MODE,
      n.QUOTE_STRING_MODE
    ]
  }, f = "[0-9](_?[0-9])*", h = `(\\b(${f}))?\\.(${f})|\\b(${f})\\.`, m = `\\b|${r.join("|")}`, g = {
    className: "number",
    relevance: 0,
    variants: [
      // exponentfloat, pointfloat
      // https://docs.python.org/3.9/reference/lexical_analysis.html#floating-point-literals
      // optionally imaginary
      // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
      // Note: no leading \b because floats can start with a decimal point
      // and we don't want to mishandle e.g. `fn(.5)`,
      // no trailing \b for pointfloat because it can end with a decimal point
      // and we don't want to mishandle e.g. `0..hex()`; this should be safe
      // because both MUST contain a decimal point and so cannot be confused with
      // the interior part of an identifier
      {
        begin: `(\\b(${f})|(${h}))[eE][+-]?(${f})[jJ]?(?=${m})`
      },
      {
        begin: `(${h})[jJ]?`
      },
      // decinteger, bininteger, octinteger, hexinteger
      // https://docs.python.org/3.9/reference/lexical_analysis.html#integer-literals
      // optionally "long" in Python 2
      // https://docs.python.org/2.7/reference/lexical_analysis.html#integer-and-long-integer-literals
      // decinteger is optionally imaginary
      // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
      {
        begin: `\\b([1-9](_?[0-9])*|0+(_?0)*)[lLjJ]?(?=${m})`
      },
      {
        begin: `\\b0[bB](_?[01])+[lL]?(?=${m})`
      },
      {
        begin: `\\b0[oO](_?[0-7])+[lL]?(?=${m})`
      },
      {
        begin: `\\b0[xX](_?[0-9a-fA-F])+[lL]?(?=${m})`
      },
      // imagnumber (digitpart-based)
      // https://docs.python.org/3.9/reference/lexical_analysis.html#imaginary-literals
      {
        begin: `\\b(${f})[jJ](?=${m})`
      }
    ]
  }, v = {
    className: "comment",
    begin: e.lookahead(/# type:/),
    end: /$/,
    keywords: a,
    contains: [
      {
        // prevent keywords from coloring `type`
        begin: /# type:/
      },
      // comment within a datatype comment includes no keywords
      {
        begin: /#/,
        end: /\b\B/,
        endsWithParent: !0
      }
    ]
  }, y = {
    className: "params",
    variants: [
      // Exclude params in functions without params
      {
        className: "",
        begin: /\(\s*\)/,
        skip: !0
      },
      {
        begin: /\(/,
        end: /\)/,
        excludeBegin: !0,
        excludeEnd: !0,
        keywords: a,
        contains: [
          "self",
          l,
          g,
          d,
          n.HASH_COMMENT_MODE
        ]
      }
    ]
  };
  return c.contains = [
    d,
    g,
    l
  ], {
    name: "Python",
    aliases: [
      "py",
      "gyp",
      "ipython"
    ],
    unicodeRegex: !0,
    keywords: a,
    illegal: /(<\/|\?)|=>/,
    contains: [
      l,
      g,
      {
        // very common convention
        scope: "variable.language",
        match: /\bself\b/
      },
      {
        // eat "if" prior to string so that it won't accidentally be
        // labeled as an f-string
        beginKeywords: "if",
        relevance: 0
      },
      { match: /\bor\b/, scope: "keyword" },
      d,
      v,
      n.HASH_COMMENT_MODE,
      {
        match: [
          /\bdef/,
          /\s+/,
          t
        ],
        scope: {
          1: "keyword",
          3: "title.function"
        },
        contains: [y]
      },
      {
        variants: [
          {
            match: [
              /\bclass/,
              /\s+/,
              t,
              /\s*/,
              /\(\s*/,
              t,
              /\s*\)/
            ]
          },
          {
            match: [
              /\bclass/,
              /\s+/,
              t
            ]
          }
        ],
        scope: {
          1: "keyword",
          3: "title.class",
          6: "title.class.inherited"
        }
      },
      {
        className: "meta",
        begin: /^[\t ]*@/,
        end: /(?=#)|$/,
        contains: [
          g,
          y,
          d
        ]
      }
    ]
  };
}
function _ft(n) {
  return {
    aliases: ["pycon"],
    contains: [
      {
        className: "meta.prompt",
        starts: {
          // a space separates the REPL prefix from the actual code
          // this is purely for cleaner HTML output
          end: / |$/,
          starts: {
            end: "$",
            subLanguage: "python"
          }
        },
        variants: [
          { begin: /^>>>(?=[ ]|$)/ },
          { begin: /^\.\.\.(?=[ ]|$)/ }
        ]
      }
    ]
  };
}
function Oft(n) {
  const e = n.regex, t = /(?:(?:[a-zA-Z]|\.[._a-zA-Z])[._a-zA-Z0-9]*)|\.(?!\d)/, r = e.either(
    // Special case: only hexadecimal binary powers can contain fractions
    /0[xX][0-9a-fA-F]+\.[0-9a-fA-F]*[pP][+-]?\d+i?/,
    // Hexadecimal numbers without fraction and optional binary power
    /0[xX][0-9a-fA-F]+(?:[pP][+-]?\d+)?[Li]?/,
    // Decimal numbers
    /(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?[Li]?/
  ), i = /[=!<>:]=|\|\||&&|:::?|<-|<<-|->>|->|\|>|[-+*\/?!$&|:<=>@^~]|\*\*/, s = e.either(
    /[()]/,
    /[{}]/,
    /\[\[/,
    /[[\]]/,
    /\\/,
    /,/
  );
  return {
    name: "R",
    keywords: {
      $pattern: t,
      keyword: "function if in break next repeat else for while",
      literal: "NULL NA TRUE FALSE Inf NaN NA_integer_|10 NA_real_|10 NA_character_|10 NA_complex_|10",
      built_in: (
        // Builtin constants
        "LETTERS letters month.abb month.name pi T F abs acos acosh all any anyNA Arg as.call as.character as.complex as.double as.environment as.integer as.logical as.null.default as.numeric as.raw asin asinh atan atanh attr attributes baseenv browser c call ceiling class Conj cos cosh cospi cummax cummin cumprod cumsum digamma dim dimnames emptyenv exp expression floor forceAndCall gamma gc.time globalenv Im interactive invisible is.array is.atomic is.call is.character is.complex is.double is.environment is.expression is.finite is.function is.infinite is.integer is.language is.list is.logical is.matrix is.na is.name is.nan is.null is.numeric is.object is.pairlist is.raw is.recursive is.single is.symbol lazyLoadDBfetch length lgamma list log max min missing Mod names nargs nzchar oldClass on.exit pos.to.env proc.time prod quote range Re rep retracemem return round seq_along seq_len seq.int sign signif sin sinh sinpi sqrt standardGeneric substitute sum switch tan tanh tanpi tracemem trigamma trunc unclass untracemem UseMethod xtfrm"
      )
    },
    contains: [
      // Roxygen comments
      n.COMMENT(
        /#'/,
        /$/,
        { contains: [
          {
            // Handle `@examples` separately to cause all subsequent code
            // until the next `@`-tag on its own line to be kept as-is,
            // preventing highlighting. This code is example R code, so nested
            // doctags shouldn’t be treated as such. See
            // `test/markup/r/roxygen.txt` for an example.
            scope: "doctag",
            match: /@examples/,
            starts: {
              end: e.lookahead(e.either(
                // end if another doc comment
                /\n^#'\s*(?=@[a-zA-Z]+)/,
                // or a line with no comment
                /\n^(?!#')/
              )),
              endsParent: !0
            }
          },
          {
            // Handle `@param` to highlight the parameter name following
            // after.
            scope: "doctag",
            begin: "@param",
            end: /$/,
            contains: [
              {
                scope: "variable",
                variants: [
                  { match: t },
                  { match: /`(?:\\.|[^`\\])+`/ }
                ],
                endsParent: !0
              }
            ]
          },
          {
            scope: "doctag",
            match: /@[a-zA-Z]+/
          },
          {
            scope: "keyword",
            match: /\\[a-zA-Z]+/
          }
        ] }
      ),
      n.HASH_COMMENT_MODE,
      {
        scope: "string",
        contains: [n.BACKSLASH_ESCAPE],
        variants: [
          n.END_SAME_AS_BEGIN({
            begin: /[rR]"(-*)\(/,
            end: /\)(-*)"/
          }),
          n.END_SAME_AS_BEGIN({
            begin: /[rR]"(-*)\{/,
            end: /\}(-*)"/
          }),
          n.END_SAME_AS_BEGIN({
            begin: /[rR]"(-*)\[/,
            end: /\](-*)"/
          }),
          n.END_SAME_AS_BEGIN({
            begin: /[rR]'(-*)\(/,
            end: /\)(-*)'/
          }),
          n.END_SAME_AS_BEGIN({
            begin: /[rR]'(-*)\{/,
            end: /\}(-*)'/
          }),
          n.END_SAME_AS_BEGIN({
            begin: /[rR]'(-*)\[/,
            end: /\](-*)'/
          }),
          {
            begin: '"',
            end: '"',
            relevance: 0
          },
          {
            begin: "'",
            end: "'",
            relevance: 0
          }
        ]
      },
      // Matching numbers immediately following punctuation and operators is
      // tricky since we need to look at the character ahead of a number to
      // ensure the number is not part of an identifier, and we cannot use
      // negative look-behind assertions. So instead we explicitly handle all
      // possible combinations of (operator|punctuation), number.
      // TODO: replace with negative look-behind when available
      // { begin: /(?<![a-zA-Z0-9._])0[xX][0-9a-fA-F]+\.[0-9a-fA-F]*[pP][+-]?\d+i?/ },
      // { begin: /(?<![a-zA-Z0-9._])0[xX][0-9a-fA-F]+([pP][+-]?\d+)?[Li]?/ },
      // { begin: /(?<![a-zA-Z0-9._])(\d+(\.\d*)?|\.\d+)([eE][+-]?\d+)?[Li]?/ }
      {
        relevance: 0,
        variants: [
          {
            scope: {
              1: "operator",
              2: "number"
            },
            match: [
              i,
              r
            ]
          },
          {
            scope: {
              1: "operator",
              2: "number"
            },
            match: [
              /%[^%]*%/,
              r
            ]
          },
          {
            scope: {
              1: "punctuation",
              2: "number"
            },
            match: [
              s,
              r
            ]
          },
          {
            scope: { 2: "number" },
            match: [
              /[^a-zA-Z0-9._]|^/,
              // not part of an identifier, or start of document
              r
            ]
          }
        ]
      },
      // Operators/punctuation when they're not directly followed by numbers
      {
        // Relevance boost for the most common assignment form.
        scope: { 3: "operator" },
        match: [
          t,
          /\s+/,
          /<-/,
          /\s+/
        ]
      },
      {
        scope: "operator",
        relevance: 0,
        variants: [
          { match: i },
          { match: /%[^%]*%/ }
        ]
      },
      {
        scope: "punctuation",
        relevance: 0,
        match: s
      },
      {
        // Escaped identifier
        begin: "`",
        end: "`",
        contains: [{ begin: /\\./ }]
      }
    ]
  };
}
function Ift(n) {
  const e = n.regex, t = "([a-zA-Z_]\\w*[!?=]?|[-+~]@|<<|>>|=~|===?|<=>|[<>]=?|\\*\\*|[-/+%^&*~`|]|\\[\\]=?)", r = e.either(
    /\b([A-Z]+[a-z0-9]+)+/,
    // ends in caps
    /\b([A-Z]+[a-z0-9]+)+[A-Z]+/
  ), i = e.concat(r, /(::\w+)*/), o = {
    "variable.constant": [
      "__FILE__",
      "__LINE__",
      "__ENCODING__"
    ],
    "variable.language": [
      "self",
      "super"
    ],
    keyword: [
      "alias",
      "and",
      "begin",
      "BEGIN",
      "break",
      "case",
      "class",
      "defined",
      "do",
      "else",
      "elsif",
      "end",
      "END",
      "ensure",
      "for",
      "if",
      "in",
      "module",
      "next",
      "not",
      "or",
      "redo",
      "require",
      "rescue",
      "retry",
      "return",
      "then",
      "undef",
      "unless",
      "until",
      "when",
      "while",
      "yield",
      ...[
        "include",
        "extend",
        "prepend",
        "public",
        "private",
        "protected",
        "raise",
        "throw"
      ]
    ],
    built_in: [
      "proc",
      "lambda",
      "attr_accessor",
      "attr_reader",
      "attr_writer",
      "define_method",
      "private_constant",
      "module_function"
    ],
    literal: [
      "true",
      "false",
      "nil"
    ]
  }, a = {
    className: "doctag",
    begin: "@[A-Za-z]+"
  }, l = {
    begin: "#<",
    end: ">"
  }, c = [
    n.COMMENT(
      "#",
      "$",
      { contains: [a] }
    ),
    n.COMMENT(
      "^=begin",
      "^=end",
      {
        contains: [a],
        relevance: 10
      }
    ),
    n.COMMENT("^__END__", n.MATCH_NOTHING_RE)
  ], u = {
    className: "subst",
    begin: /#\{/,
    end: /\}/,
    keywords: o
  }, d = {
    className: "string",
    contains: [
      n.BACKSLASH_ESCAPE,
      u
    ],
    variants: [
      {
        begin: /'/,
        end: /'/
      },
      {
        begin: /"/,
        end: /"/
      },
      {
        begin: /`/,
        end: /`/
      },
      {
        begin: /%[qQwWx]?\(/,
        end: /\)/
      },
      {
        begin: /%[qQwWx]?\[/,
        end: /\]/
      },
      {
        begin: /%[qQwWx]?\{/,
        end: /\}/
      },
      {
        begin: /%[qQwWx]?</,
        end: />/
      },
      {
        begin: /%[qQwWx]?\//,
        end: /\//
      },
      {
        begin: /%[qQwWx]?%/,
        end: /%/
      },
      {
        begin: /%[qQwWx]?-/,
        end: /-/
      },
      {
        begin: /%[qQwWx]?\|/,
        end: /\|/
      },
      // in the following expressions, \B in the beginning suppresses recognition of ?-sequences
      // where ? is the last character of a preceding identifier, as in: `func?4`
      { begin: /\B\?(\\\d{1,3})/ },
      { begin: /\B\?(\\x[A-Fa-f0-9]{1,2})/ },
      { begin: /\B\?(\\u\{?[A-Fa-f0-9]{1,6}\}?)/ },
      { begin: /\B\?(\\M-\\C-|\\M-\\c|\\c\\M-|\\M-|\\C-\\M-)[\x20-\x7e]/ },
      { begin: /\B\?\\(c|C-)[\x20-\x7e]/ },
      { begin: /\B\?\\?\S/ },
      // heredocs
      {
        // this guard makes sure that we have an entire heredoc and not a false
        // positive (auto-detect, etc.)
        begin: e.concat(
          /<<[-~]?'?/,
          e.lookahead(/(\w+)(?=\W)[^\n]*\n(?:[^\n]*\n)*?\s*\1\b/)
        ),
        contains: [
          n.END_SAME_AS_BEGIN({
            begin: /(\w+)/,
            end: /(\w+)/,
            contains: [
              n.BACKSLASH_ESCAPE,
              u
            ]
          })
        ]
      }
    ]
  }, f = "[1-9](_?[0-9])*|0", h = "[0-9](_?[0-9])*", m = {
    className: "number",
    relevance: 0,
    variants: [
      // decimal integer/float, optionally exponential or rational, optionally imaginary
      { begin: `\\b(${f})(\\.(${h}))?([eE][+-]?(${h})|r)?i?\\b` },
      // explicit decimal/binary/octal/hexadecimal integer,
      // optionally rational and/or imaginary
      { begin: "\\b0[dD][0-9](_?[0-9])*r?i?\\b" },
      { begin: "\\b0[bB][0-1](_?[0-1])*r?i?\\b" },
      { begin: "\\b0[oO][0-7](_?[0-7])*r?i?\\b" },
      { begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*r?i?\\b" },
      // 0-prefixed implicit octal integer, optionally rational and/or imaginary
      { begin: "\\b0(_?[0-7])+r?i?\\b" }
    ]
  }, g = {
    variants: [
      {
        match: /\(\)/
      },
      {
        className: "params",
        begin: /\(/,
        end: /(?=\))/,
        excludeBegin: !0,
        endsParent: !0,
        keywords: o
      }
    ]
  }, C = [
    d,
    {
      variants: [
        {
          match: [
            /class\s+/,
            i,
            /\s+<\s+/,
            i
          ]
        },
        {
          match: [
            /\b(class|module)\s+/,
            i
          ]
        }
      ],
      scope: {
        2: "title.class",
        4: "title.class.inherited"
      },
      keywords: o
    },
    {
      match: [
        /(include|extend)\s+/,
        i
      ],
      scope: {
        2: "title.class"
      },
      keywords: o
    },
    {
      relevance: 0,
      match: [
        i,
        /\.new[. (]/
      ],
      scope: {
        1: "title.class"
      }
    },
    {
      relevance: 0,
      match: /\b[A-Z][A-Z_0-9]+\b/,
      className: "variable.constant"
    },
    {
      relevance: 0,
      match: r,
      scope: "title.class"
    },
    {
      match: [
        /def/,
        /\s+/,
        t
      ],
      scope: {
        1: "keyword",
        3: "title.function"
      },
      contains: [
        g
      ]
    },
    {
      // swallow namespace qualifiers before symbols
      begin: n.IDENT_RE + "::"
    },
    {
      className: "symbol",
      begin: n.UNDERSCORE_IDENT_RE + "(!|\\?)?:",
      relevance: 0
    },
    {
      className: "symbol",
      begin: ":(?!\\s)",
      contains: [
        d,
        { begin: t }
      ],
      relevance: 0
    },
    m,
    {
      // negative-look forward attempts to prevent false matches like:
      // @ident@ or $ident$ that might indicate this is not ruby at all
      className: "variable",
      begin: "(\\$\\W)|((\\$|@@?)(\\w+))(?=[^@$?])(?![A-Za-z])(?![@$?'])"
    },
    {
      className: "params",
      begin: /\|(?!=)/,
      end: /\|/,
      excludeBegin: !0,
      excludeEnd: !0,
      relevance: 0,
      // this could be a lot of things (in other languages) other than params
      keywords: o
    },
    {
      // regexp container
      begin: "(" + n.RE_STARTERS_RE + "|unless)\\s*",
      keywords: "unless",
      contains: [
        {
          className: "regexp",
          contains: [
            n.BACKSLASH_ESCAPE,
            u
          ],
          illegal: /\n/,
          variants: [
            {
              begin: "/",
              end: "/[a-z]*"
            },
            {
              begin: /%r\{/,
              end: /\}[a-z]*/
            },
            {
              begin: "%r\\(",
              end: "\\)[a-z]*"
            },
            {
              begin: "%r!",
              end: "![a-z]*"
            },
            {
              begin: "%r\\[",
              end: "\\][a-z]*"
            }
          ]
        }
      ].concat(l, c),
      relevance: 0
    }
  ].concat(l, c);
  u.contains = C, g.contains = C;
  const _ = [
    {
      begin: /^\s*=>/,
      starts: {
        end: "$",
        contains: C
      }
    },
    {
      className: "meta.prompt",
      begin: "^(" + "[>?]>" + "|" + "[\\w#]+\\(\\w+\\):\\d+:\\d+[>*]" + "|" + "(\\w+-)?\\d+\\.\\d+\\.\\d+(p\\d+)?[^\\d][^>]+>" + ")(?=[ ])",
      starts: {
        end: "$",
        keywords: o,
        contains: C
      }
    }
  ];
  return c.unshift(l), {
    name: "Ruby",
    aliases: [
      "rb",
      "gemspec",
      "podspec",
      "thor",
      "irb"
    ],
    keywords: o,
    illegal: /\/\*/,
    contains: [n.SHEBANG({ binary: "ruby" })].concat(_).concat(c).concat(C)
  };
}
function Rft(n) {
  const e = n.regex, t = /(r#)?/, r = e.concat(t, n.UNDERSCORE_IDENT_RE), i = e.concat(t, n.IDENT_RE), s = {
    className: "title.function.invoke",
    relevance: 0,
    begin: e.concat(
      /\b/,
      /(?!let|for|while|if|else|match\b)/,
      i,
      e.lookahead(/\s*\(/)
    )
  }, o = "([ui](8|16|32|64|128|size)|f(32|64))?", a = [
    "abstract",
    "as",
    "async",
    "await",
    "become",
    "box",
    "break",
    "const",
    "continue",
    "crate",
    "do",
    "dyn",
    "else",
    "enum",
    "extern",
    "false",
    "final",
    "fn",
    "for",
    "if",
    "impl",
    "in",
    "let",
    "loop",
    "macro",
    "match",
    "mod",
    "move",
    "mut",
    "override",
    "priv",
    "pub",
    "ref",
    "return",
    "self",
    "Self",
    "static",
    "struct",
    "super",
    "trait",
    "true",
    "try",
    "type",
    "typeof",
    "union",
    "unsafe",
    "unsized",
    "use",
    "virtual",
    "where",
    "while",
    "yield"
  ], l = [
    "true",
    "false",
    "Some",
    "None",
    "Ok",
    "Err"
  ], c = [
    // functions
    "drop ",
    // traits
    "Copy",
    "Send",
    "Sized",
    "Sync",
    "Drop",
    "Fn",
    "FnMut",
    "FnOnce",
    "ToOwned",
    "Clone",
    "Debug",
    "PartialEq",
    "PartialOrd",
    "Eq",
    "Ord",
    "AsRef",
    "AsMut",
    "Into",
    "From",
    "Default",
    "Iterator",
    "Extend",
    "IntoIterator",
    "DoubleEndedIterator",
    "ExactSizeIterator",
    "SliceConcatExt",
    "ToString",
    // macros
    "assert!",
    "assert_eq!",
    "bitflags!",
    "bytes!",
    "cfg!",
    "col!",
    "concat!",
    "concat_idents!",
    "debug_assert!",
    "debug_assert_eq!",
    "env!",
    "eprintln!",
    "panic!",
    "file!",
    "format!",
    "format_args!",
    "include_bytes!",
    "include_str!",
    "line!",
    "local_data_key!",
    "module_path!",
    "option_env!",
    "print!",
    "println!",
    "select!",
    "stringify!",
    "try!",
    "unimplemented!",
    "unreachable!",
    "vec!",
    "write!",
    "writeln!",
    "macro_rules!",
    "assert_ne!",
    "debug_assert_ne!"
  ], u = [
    "i8",
    "i16",
    "i32",
    "i64",
    "i128",
    "isize",
    "u8",
    "u16",
    "u32",
    "u64",
    "u128",
    "usize",
    "f32",
    "f64",
    "str",
    "char",
    "bool",
    "Box",
    "Option",
    "Result",
    "String",
    "Vec"
  ];
  return {
    name: "Rust",
    aliases: ["rs"],
    keywords: {
      $pattern: n.IDENT_RE + "!?",
      type: u,
      keyword: a,
      literal: l,
      built_in: c
    },
    illegal: "</",
    contains: [
      n.C_LINE_COMMENT_MODE,
      n.COMMENT("/\\*", "\\*/", { contains: ["self"] }),
      n.inherit(n.QUOTE_STRING_MODE, {
        begin: /b?"/,
        illegal: null
      }),
      {
        className: "symbol",
        // negative lookahead to avoid matching `'`
        begin: /'[a-zA-Z_][a-zA-Z0-9_]*(?!')/
      },
      {
        scope: "string",
        variants: [
          { begin: /b?r(#*)"(.|\n)*?"\1(?!#)/ },
          {
            begin: /b?'/,
            end: /'/,
            contains: [
              {
                scope: "char.escape",
                match: /\\('|\w|x\w{2}|u\w{4}|U\w{8})/
              }
            ]
          }
        ]
      },
      {
        className: "number",
        variants: [
          { begin: "\\b0b([01_]+)" + o },
          { begin: "\\b0o([0-7_]+)" + o },
          { begin: "\\b0x([A-Fa-f0-9_]+)" + o },
          { begin: "\\b(\\d[\\d_]*(\\.[0-9_]+)?([eE][+-]?[0-9_]+)?)" + o }
        ],
        relevance: 0
      },
      {
        begin: [
          /fn/,
          /\s+/,
          r
        ],
        className: {
          1: "keyword",
          3: "title.function"
        }
      },
      {
        className: "meta",
        begin: "#!?\\[",
        end: "\\]",
        contains: [
          {
            className: "string",
            begin: /"/,
            end: /"/,
            contains: [
              n.BACKSLASH_ESCAPE
            ]
          }
        ]
      },
      {
        begin: [
          /let/,
          /\s+/,
          /(?:mut\s+)?/,
          r
        ],
        className: {
          1: "keyword",
          3: "keyword",
          4: "variable"
        }
      },
      // must come before impl/for rule later
      {
        begin: [
          /for/,
          /\s+/,
          r,
          /\s+/,
          /in/
        ],
        className: {
          1: "keyword",
          3: "variable",
          5: "keyword"
        }
      },
      {
        begin: [
          /type/,
          /\s+/,
          r
        ],
        className: {
          1: "keyword",
          3: "title.class"
        }
      },
      {
        begin: [
          /(?:trait|enum|struct|union|impl|for)/,
          /\s+/,
          r
        ],
        className: {
          1: "keyword",
          3: "title.class"
        }
      },
      {
        begin: n.IDENT_RE + "::",
        keywords: {
          keyword: "Self",
          built_in: c,
          type: u
        }
      },
      {
        className: "punctuation",
        begin: "->"
      },
      s
    ]
  };
}
const Pft = (n) => ({
  IMPORTANT: {
    scope: "meta",
    begin: "!important"
  },
  BLOCK_COMMENT: n.C_BLOCK_COMMENT_MODE,
  HEXCOLOR: {
    scope: "number",
    begin: /#(([0-9a-fA-F]{3,4})|(([0-9a-fA-F]{2}){3,4}))\b/
  },
  FUNCTION_DISPATCH: {
    className: "built_in",
    begin: /[\w-]+(?=\()/
  },
  ATTRIBUTE_SELECTOR_MODE: {
    scope: "selector-attr",
    begin: /\[/,
    end: /\]/,
    illegal: "$",
    contains: [
      n.APOS_STRING_MODE,
      n.QUOTE_STRING_MODE
    ]
  },
  CSS_NUMBER_MODE: {
    scope: "number",
    begin: n.NUMBER_RE + "(%|em|ex|ch|rem|vw|vh|vmin|vmax|cm|mm|in|pt|pc|px|deg|grad|rad|turn|s|ms|Hz|kHz|dpi|dpcm|dppx)?",
    relevance: 0
  },
  CSS_VARIABLE: {
    className: "attr",
    begin: /--[A-Za-z_][A-Za-z0-9_-]*/
  }
}), Dft = [
  "a",
  "abbr",
  "address",
  "article",
  "aside",
  "audio",
  "b",
  "blockquote",
  "body",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "dd",
  "del",
  "details",
  "dfn",
  "div",
  "dl",
  "dt",
  "em",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "hgroup",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "label",
  "legend",
  "li",
  "main",
  "mark",
  "menu",
  "nav",
  "object",
  "ol",
  "optgroup",
  "option",
  "p",
  "picture",
  "q",
  "quote",
  "samp",
  "section",
  "select",
  "source",
  "span",
  "strong",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "tr",
  "ul",
  "var",
  "video"
], Nft = [
  "defs",
  "g",
  "marker",
  "mask",
  "pattern",
  "svg",
  "switch",
  "symbol",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feFlood",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMorphology",
  "feOffset",
  "feSpecularLighting",
  "feTile",
  "feTurbulence",
  "linearGradient",
  "radialGradient",
  "stop",
  "circle",
  "ellipse",
  "image",
  "line",
  "path",
  "polygon",
  "polyline",
  "rect",
  "text",
  "use",
  "textPath",
  "tspan",
  "foreignObject",
  "clipPath"
], Lft = [
  ...Dft,
  ...Nft
], $ft = [
  "any-hover",
  "any-pointer",
  "aspect-ratio",
  "color",
  "color-gamut",
  "color-index",
  "device-aspect-ratio",
  "device-height",
  "device-width",
  "display-mode",
  "forced-colors",
  "grid",
  "height",
  "hover",
  "inverted-colors",
  "monochrome",
  "orientation",
  "overflow-block",
  "overflow-inline",
  "pointer",
  "prefers-color-scheme",
  "prefers-contrast",
  "prefers-reduced-motion",
  "prefers-reduced-transparency",
  "resolution",
  "scan",
  "scripting",
  "update",
  "width",
  // TODO: find a better solution?
  "min-width",
  "max-width",
  "min-height",
  "max-height"
].sort().reverse(), Fft = [
  "active",
  "any-link",
  "blank",
  "checked",
  "current",
  "default",
  "defined",
  "dir",
  // dir()
  "disabled",
  "drop",
  "empty",
  "enabled",
  "first",
  "first-child",
  "first-of-type",
  "fullscreen",
  "future",
  "focus",
  "focus-visible",
  "focus-within",
  "has",
  // has()
  "host",
  // host or host()
  "host-context",
  // host-context()
  "hover",
  "indeterminate",
  "in-range",
  "invalid",
  "is",
  // is()
  "lang",
  // lang()
  "last-child",
  "last-of-type",
  "left",
  "link",
  "local-link",
  "not",
  // not()
  "nth-child",
  // nth-child()
  "nth-col",
  // nth-col()
  "nth-last-child",
  // nth-last-child()
  "nth-last-col",
  // nth-last-col()
  "nth-last-of-type",
  //nth-last-of-type()
  "nth-of-type",
  //nth-of-type()
  "only-child",
  "only-of-type",
  "optional",
  "out-of-range",
  "past",
  "placeholder-shown",
  "read-only",
  "read-write",
  "required",
  "right",
  "root",
  "scope",
  "target",
  "target-within",
  "user-invalid",
  "valid",
  "visited",
  "where"
  // where()
].sort().reverse(), Bft = [
  "after",
  "backdrop",
  "before",
  "cue",
  "cue-region",
  "first-letter",
  "first-line",
  "grammar-error",
  "marker",
  "part",
  "placeholder",
  "selection",
  "slotted",
  "spelling-error"
].sort().reverse(), zft = [
  "accent-color",
  "align-content",
  "align-items",
  "align-self",
  "alignment-baseline",
  "all",
  "anchor-name",
  "animation",
  "animation-composition",
  "animation-delay",
  "animation-direction",
  "animation-duration",
  "animation-fill-mode",
  "animation-iteration-count",
  "animation-name",
  "animation-play-state",
  "animation-range",
  "animation-range-end",
  "animation-range-start",
  "animation-timeline",
  "animation-timing-function",
  "appearance",
  "aspect-ratio",
  "backdrop-filter",
  "backface-visibility",
  "background",
  "background-attachment",
  "background-blend-mode",
  "background-clip",
  "background-color",
  "background-image",
  "background-origin",
  "background-position",
  "background-position-x",
  "background-position-y",
  "background-repeat",
  "background-size",
  "baseline-shift",
  "block-size",
  "border",
  "border-block",
  "border-block-color",
  "border-block-end",
  "border-block-end-color",
  "border-block-end-style",
  "border-block-end-width",
  "border-block-start",
  "border-block-start-color",
  "border-block-start-style",
  "border-block-start-width",
  "border-block-style",
  "border-block-width",
  "border-bottom",
  "border-bottom-color",
  "border-bottom-left-radius",
  "border-bottom-right-radius",
  "border-bottom-style",
  "border-bottom-width",
  "border-collapse",
  "border-color",
  "border-end-end-radius",
  "border-end-start-radius",
  "border-image",
  "border-image-outset",
  "border-image-repeat",
  "border-image-slice",
  "border-image-source",
  "border-image-width",
  "border-inline",
  "border-inline-color",
  "border-inline-end",
  "border-inline-end-color",
  "border-inline-end-style",
  "border-inline-end-width",
  "border-inline-start",
  "border-inline-start-color",
  "border-inline-start-style",
  "border-inline-start-width",
  "border-inline-style",
  "border-inline-width",
  "border-left",
  "border-left-color",
  "border-left-style",
  "border-left-width",
  "border-radius",
  "border-right",
  "border-right-color",
  "border-right-style",
  "border-right-width",
  "border-spacing",
  "border-start-end-radius",
  "border-start-start-radius",
  "border-style",
  "border-top",
  "border-top-color",
  "border-top-left-radius",
  "border-top-right-radius",
  "border-top-style",
  "border-top-width",
  "border-width",
  "bottom",
  "box-align",
  "box-decoration-break",
  "box-direction",
  "box-flex",
  "box-flex-group",
  "box-lines",
  "box-ordinal-group",
  "box-orient",
  "box-pack",
  "box-shadow",
  "box-sizing",
  "break-after",
  "break-before",
  "break-inside",
  "caption-side",
  "caret-color",
  "clear",
  "clip",
  "clip-path",
  "clip-rule",
  "color",
  "color-interpolation",
  "color-interpolation-filters",
  "color-profile",
  "color-rendering",
  "color-scheme",
  "column-count",
  "column-fill",
  "column-gap",
  "column-rule",
  "column-rule-color",
  "column-rule-style",
  "column-rule-width",
  "column-span",
  "column-width",
  "columns",
  "contain",
  "contain-intrinsic-block-size",
  "contain-intrinsic-height",
  "contain-intrinsic-inline-size",
  "contain-intrinsic-size",
  "contain-intrinsic-width",
  "container",
  "container-name",
  "container-type",
  "content",
  "content-visibility",
  "counter-increment",
  "counter-reset",
  "counter-set",
  "cue",
  "cue-after",
  "cue-before",
  "cursor",
  "cx",
  "cy",
  "direction",
  "display",
  "dominant-baseline",
  "empty-cells",
  "enable-background",
  "field-sizing",
  "fill",
  "fill-opacity",
  "fill-rule",
  "filter",
  "flex",
  "flex-basis",
  "flex-direction",
  "flex-flow",
  "flex-grow",
  "flex-shrink",
  "flex-wrap",
  "float",
  "flood-color",
  "flood-opacity",
  "flow",
  "font",
  "font-display",
  "font-family",
  "font-feature-settings",
  "font-kerning",
  "font-language-override",
  "font-optical-sizing",
  "font-palette",
  "font-size",
  "font-size-adjust",
  "font-smooth",
  "font-smoothing",
  "font-stretch",
  "font-style",
  "font-synthesis",
  "font-synthesis-position",
  "font-synthesis-small-caps",
  "font-synthesis-style",
  "font-synthesis-weight",
  "font-variant",
  "font-variant-alternates",
  "font-variant-caps",
  "font-variant-east-asian",
  "font-variant-emoji",
  "font-variant-ligatures",
  "font-variant-numeric",
  "font-variant-position",
  "font-variation-settings",
  "font-weight",
  "forced-color-adjust",
  "gap",
  "glyph-orientation-horizontal",
  "glyph-orientation-vertical",
  "grid",
  "grid-area",
  "grid-auto-columns",
  "grid-auto-flow",
  "grid-auto-rows",
  "grid-column",
  "grid-column-end",
  "grid-column-start",
  "grid-gap",
  "grid-row",
  "grid-row-end",
  "grid-row-start",
  "grid-template",
  "grid-template-areas",
  "grid-template-columns",
  "grid-template-rows",
  "hanging-punctuation",
  "height",
  "hyphenate-character",
  "hyphenate-limit-chars",
  "hyphens",
  "icon",
  "image-orientation",
  "image-rendering",
  "image-resolution",
  "ime-mode",
  "initial-letter",
  "initial-letter-align",
  "inline-size",
  "inset",
  "inset-area",
  "inset-block",
  "inset-block-end",
  "inset-block-start",
  "inset-inline",
  "inset-inline-end",
  "inset-inline-start",
  "isolation",
  "justify-content",
  "justify-items",
  "justify-self",
  "kerning",
  "left",
  "letter-spacing",
  "lighting-color",
  "line-break",
  "line-height",
  "line-height-step",
  "list-style",
  "list-style-image",
  "list-style-position",
  "list-style-type",
  "margin",
  "margin-block",
  "margin-block-end",
  "margin-block-start",
  "margin-bottom",
  "margin-inline",
  "margin-inline-end",
  "margin-inline-start",
  "margin-left",
  "margin-right",
  "margin-top",
  "margin-trim",
  "marker",
  "marker-end",
  "marker-mid",
  "marker-start",
  "marks",
  "mask",
  "mask-border",
  "mask-border-mode",
  "mask-border-outset",
  "mask-border-repeat",
  "mask-border-slice",
  "mask-border-source",
  "mask-border-width",
  "mask-clip",
  "mask-composite",
  "mask-image",
  "mask-mode",
  "mask-origin",
  "mask-position",
  "mask-repeat",
  "mask-size",
  "mask-type",
  "masonry-auto-flow",
  "math-depth",
  "math-shift",
  "math-style",
  "max-block-size",
  "max-height",
  "max-inline-size",
  "max-width",
  "min-block-size",
  "min-height",
  "min-inline-size",
  "min-width",
  "mix-blend-mode",
  "nav-down",
  "nav-index",
  "nav-left",
  "nav-right",
  "nav-up",
  "none",
  "normal",
  "object-fit",
  "object-position",
  "offset",
  "offset-anchor",
  "offset-distance",
  "offset-path",
  "offset-position",
  "offset-rotate",
  "opacity",
  "order",
  "orphans",
  "outline",
  "outline-color",
  "outline-offset",
  "outline-style",
  "outline-width",
  "overflow",
  "overflow-anchor",
  "overflow-block",
  "overflow-clip-margin",
  "overflow-inline",
  "overflow-wrap",
  "overflow-x",
  "overflow-y",
  "overlay",
  "overscroll-behavior",
  "overscroll-behavior-block",
  "overscroll-behavior-inline",
  "overscroll-behavior-x",
  "overscroll-behavior-y",
  "padding",
  "padding-block",
  "padding-block-end",
  "padding-block-start",
  "padding-bottom",
  "padding-inline",
  "padding-inline-end",
  "padding-inline-start",
  "padding-left",
  "padding-right",
  "padding-top",
  "page",
  "page-break-after",
  "page-break-before",
  "page-break-inside",
  "paint-order",
  "pause",
  "pause-after",
  "pause-before",
  "perspective",
  "perspective-origin",
  "place-content",
  "place-items",
  "place-self",
  "pointer-events",
  "position",
  "position-anchor",
  "position-visibility",
  "print-color-adjust",
  "quotes",
  "r",
  "resize",
  "rest",
  "rest-after",
  "rest-before",
  "right",
  "rotate",
  "row-gap",
  "ruby-align",
  "ruby-position",
  "scale",
  "scroll-behavior",
  "scroll-margin",
  "scroll-margin-block",
  "scroll-margin-block-end",
  "scroll-margin-block-start",
  "scroll-margin-bottom",
  "scroll-margin-inline",
  "scroll-margin-inline-end",
  "scroll-margin-inline-start",
  "scroll-margin-left",
  "scroll-margin-right",
  "scroll-margin-top",
  "scroll-padding",
  "scroll-padding-block",
  "scroll-padding-block-end",
  "scroll-padding-block-start",
  "scroll-padding-bottom",
  "scroll-padding-inline",
  "scroll-padding-inline-end",
  "scroll-padding-inline-start",
  "scroll-padding-left",
  "scroll-padding-right",
  "scroll-padding-top",
  "scroll-snap-align",
  "scroll-snap-stop",
  "scroll-snap-type",
  "scroll-timeline",
  "scroll-timeline-axis",
  "scroll-timeline-name",
  "scrollbar-color",
  "scrollbar-gutter",
  "scrollbar-width",
  "shape-image-threshold",
  "shape-margin",
  "shape-outside",
  "shape-rendering",
  "speak",
  "speak-as",
  "src",
  // @font-face
  "stop-color",
  "stop-opacity",
  "stroke",
  "stroke-dasharray",
  "stroke-dashoffset",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-miterlimit",
  "stroke-opacity",
  "stroke-width",
  "tab-size",
  "table-layout",
  "text-align",
  "text-align-all",
  "text-align-last",
  "text-anchor",
  "text-combine-upright",
  "text-decoration",
  "text-decoration-color",
  "text-decoration-line",
  "text-decoration-skip",
  "text-decoration-skip-ink",
  "text-decoration-style",
  "text-decoration-thickness",
  "text-emphasis",
  "text-emphasis-color",
  "text-emphasis-position",
  "text-emphasis-style",
  "text-indent",
  "text-justify",
  "text-orientation",
  "text-overflow",
  "text-rendering",
  "text-shadow",
  "text-size-adjust",
  "text-transform",
  "text-underline-offset",
  "text-underline-position",
  "text-wrap",
  "text-wrap-mode",
  "text-wrap-style",
  "timeline-scope",
  "top",
  "touch-action",
  "transform",
  "transform-box",
  "transform-origin",
  "transform-style",
  "transition",
  "transition-behavior",
  "transition-delay",
  "transition-duration",
  "transition-property",
  "transition-timing-function",
  "translate",
  "unicode-bidi",
  "user-modify",
  "user-select",
  "vector-effect",
  "vertical-align",
  "view-timeline",
  "view-timeline-axis",
  "view-timeline-inset",
  "view-timeline-name",
  "view-transition-name",
  "visibility",
  "voice-balance",
  "voice-duration",
  "voice-family",
  "voice-pitch",
  "voice-range",
  "voice-rate",
  "voice-stress",
  "voice-volume",
  "white-space",
  "white-space-collapse",
  "widows",
  "width",
  "will-change",
  "word-break",
  "word-spacing",
  "word-wrap",
  "writing-mode",
  "x",
  "y",
  "z-index",
  "zoom"
].sort().reverse();
function Hft(n) {
  const e = Pft(n), t = Bft, r = Fft, i = "@[a-z-]+", s = "and or not only", a = {
    className: "variable",
    begin: "(\\$" + "[a-zA-Z-][a-zA-Z0-9_-]*" + ")\\b",
    relevance: 0
  };
  return {
    name: "SCSS",
    case_insensitive: !0,
    illegal: "[=/|']",
    contains: [
      n.C_LINE_COMMENT_MODE,
      n.C_BLOCK_COMMENT_MODE,
      // to recognize keyframe 40% etc which are outside the scope of our
      // attribute value mode
      e.CSS_NUMBER_MODE,
      {
        className: "selector-id",
        begin: "#[A-Za-z0-9_-]+",
        relevance: 0
      },
      {
        className: "selector-class",
        begin: "\\.[A-Za-z0-9_-]+",
        relevance: 0
      },
      e.ATTRIBUTE_SELECTOR_MODE,
      {
        className: "selector-tag",
        begin: "\\b(" + Lft.join("|") + ")\\b",
        // was there, before, but why?
        relevance: 0
      },
      {
        className: "selector-pseudo",
        begin: ":(" + r.join("|") + ")"
      },
      {
        className: "selector-pseudo",
        begin: ":(:)?(" + t.join("|") + ")"
      },
      a,
      {
        // pseudo-selector params
        begin: /\(/,
        end: /\)/,
        contains: [e.CSS_NUMBER_MODE]
      },
      e.CSS_VARIABLE,
      {
        className: "attribute",
        begin: "\\b(" + zft.join("|") + ")\\b"
      },
      { begin: "\\b(whitespace|wait|w-resize|visible|vertical-text|vertical-ideographic|uppercase|upper-roman|upper-alpha|underline|transparent|top|thin|thick|text|text-top|text-bottom|tb-rl|table-header-group|table-footer-group|sw-resize|super|strict|static|square|solid|small-caps|separate|se-resize|scroll|s-resize|rtl|row-resize|ridge|right|repeat|repeat-y|repeat-x|relative|progress|pointer|overline|outside|outset|oblique|nowrap|not-allowed|normal|none|nw-resize|no-repeat|no-drop|newspaper|ne-resize|n-resize|move|middle|medium|ltr|lr-tb|lowercase|lower-roman|lower-alpha|loose|list-item|line|line-through|line-edge|lighter|left|keep-all|justify|italic|inter-word|inter-ideograph|inside|inset|inline|inline-block|inherit|inactive|ideograph-space|ideograph-parenthesis|ideograph-numeric|ideograph-alpha|horizontal|hidden|help|hand|groove|fixed|ellipsis|e-resize|double|dotted|distribute|distribute-space|distribute-letter|distribute-all-lines|disc|disabled|default|decimal|dashed|crosshair|collapse|col-resize|circle|char|center|capitalize|break-word|break-all|bottom|both|bolder|bold|block|bidi-override|below|baseline|auto|always|all-scroll|absolute|table|table-cell)\\b" },
      {
        begin: /:/,
        end: /[;}{]/,
        relevance: 0,
        contains: [
          e.BLOCK_COMMENT,
          a,
          e.HEXCOLOR,
          e.CSS_NUMBER_MODE,
          n.QUOTE_STRING_MODE,
          n.APOS_STRING_MODE,
          e.IMPORTANT,
          e.FUNCTION_DISPATCH
        ]
      },
      // matching these here allows us to treat them more like regular CSS
      // rules so everything between the {} gets regular rule highlighting,
      // which is what we want for page and font-face
      {
        begin: "@(page|font-face)",
        keywords: {
          $pattern: i,
          keyword: "@page @font-face"
        }
      },
      {
        begin: "@",
        end: "[{;]",
        returnBegin: !0,
        keywords: {
          $pattern: /[a-z-]+/,
          keyword: s,
          attribute: $ft.join(" ")
        },
        contains: [
          {
            begin: i,
            className: "keyword"
          },
          {
            begin: /[a-z-]+(?=:)/,
            className: "attribute"
          },
          a,
          n.QUOTE_STRING_MODE,
          n.APOS_STRING_MODE,
          e.HEXCOLOR,
          e.CSS_NUMBER_MODE
        ]
      },
      e.FUNCTION_DISPATCH
    ]
  };
}
function Uft(n) {
  return {
    name: "Shell Session",
    aliases: [
      "console",
      "shellsession"
    ],
    contains: [
      {
        className: "meta.prompt",
        // We cannot add \s (spaces) in the regular expression otherwise it will be too broad and produce unexpected result.
        // For instance, in the following example, it would match "echo /path/to/home >" as a prompt:
        // echo /path/to/home > t.exe
        begin: /^\s{0,3}[/~\w\d[\]()@-]*[>%$#][ ]?/,
        starts: {
          end: /[^\\](?=\s*$)/,
          subLanguage: "bash"
        }
      }
    ]
  };
}
function Vft(n) {
  const e = n.regex, t = n.COMMENT("--", "$"), r = {
    scope: "string",
    variants: [
      {
        begin: /'/,
        end: /'/,
        contains: [{ match: /''/ }]
      }
    ]
  }, i = {
    begin: /"/,
    end: /"/,
    contains: [{ match: /""/ }]
  }, s = [
    "true",
    "false",
    // Not sure it's correct to call NULL literal, and clauses like IS [NOT] NULL look strange that way.
    // "null",
    "unknown"
  ], o = [
    "double precision",
    "large object",
    "with timezone",
    "without timezone"
  ], a = [
    "bigint",
    "binary",
    "blob",
    "boolean",
    "char",
    "character",
    "clob",
    "date",
    "dec",
    "decfloat",
    "decimal",
    "float",
    "int",
    "integer",
    "interval",
    "nchar",
    "nclob",
    "national",
    "numeric",
    "real",
    "row",
    "smallint",
    "time",
    "timestamp",
    "varchar",
    "varying",
    // modifier (character varying)
    "varbinary"
  ], l = [
    "add",
    "asc",
    "collation",
    "desc",
    "final",
    "first",
    "last",
    "view"
  ], c = [
    "abs",
    "acos",
    "all",
    "allocate",
    "alter",
    "and",
    "any",
    "are",
    "array",
    "array_agg",
    "array_max_cardinality",
    "as",
    "asensitive",
    "asin",
    "asymmetric",
    "at",
    "atan",
    "atomic",
    "authorization",
    "avg",
    "begin",
    "begin_frame",
    "begin_partition",
    "between",
    "bigint",
    "binary",
    "blob",
    "boolean",
    "both",
    "by",
    "call",
    "called",
    "cardinality",
    "cascaded",
    "case",
    "cast",
    "ceil",
    "ceiling",
    "char",
    "char_length",
    "character",
    "character_length",
    "check",
    "classifier",
    "clob",
    "close",
    "coalesce",
    "collate",
    "collect",
    "column",
    "commit",
    "condition",
    "connect",
    "constraint",
    "contains",
    "convert",
    "copy",
    "corr",
    "corresponding",
    "cos",
    "cosh",
    "count",
    "covar_pop",
    "covar_samp",
    "create",
    "cross",
    "cube",
    "cume_dist",
    "current",
    "current_catalog",
    "current_date",
    "current_default_transform_group",
    "current_path",
    "current_role",
    "current_row",
    "current_schema",
    "current_time",
    "current_timestamp",
    "current_path",
    "current_role",
    "current_transform_group_for_type",
    "current_user",
    "cursor",
    "cycle",
    "date",
    "day",
    "deallocate",
    "dec",
    "decimal",
    "decfloat",
    "declare",
    "default",
    "define",
    "delete",
    "dense_rank",
    "deref",
    "describe",
    "deterministic",
    "disconnect",
    "distinct",
    "double",
    "drop",
    "dynamic",
    "each",
    "element",
    "else",
    "empty",
    "end",
    "end_frame",
    "end_partition",
    "end-exec",
    "equals",
    "escape",
    "every",
    "except",
    "exec",
    "execute",
    "exists",
    "exp",
    "external",
    "extract",
    "false",
    "fetch",
    "filter",
    "first_value",
    "float",
    "floor",
    "for",
    "foreign",
    "frame_row",
    "free",
    "from",
    "full",
    "function",
    "fusion",
    "get",
    "global",
    "grant",
    "group",
    "grouping",
    "groups",
    "having",
    "hold",
    "hour",
    "identity",
    "in",
    "indicator",
    "initial",
    "inner",
    "inout",
    "insensitive",
    "insert",
    "int",
    "integer",
    "intersect",
    "intersection",
    "interval",
    "into",
    "is",
    "join",
    "json_array",
    "json_arrayagg",
    "json_exists",
    "json_object",
    "json_objectagg",
    "json_query",
    "json_table",
    "json_table_primitive",
    "json_value",
    "lag",
    "language",
    "large",
    "last_value",
    "lateral",
    "lead",
    "leading",
    "left",
    "like",
    "like_regex",
    "listagg",
    "ln",
    "local",
    "localtime",
    "localtimestamp",
    "log",
    "log10",
    "lower",
    "match",
    "match_number",
    "match_recognize",
    "matches",
    "max",
    "member",
    "merge",
    "method",
    "min",
    "minute",
    "mod",
    "modifies",
    "module",
    "month",
    "multiset",
    "national",
    "natural",
    "nchar",
    "nclob",
    "new",
    "no",
    "none",
    "normalize",
    "not",
    "nth_value",
    "ntile",
    "null",
    "nullif",
    "numeric",
    "octet_length",
    "occurrences_regex",
    "of",
    "offset",
    "old",
    "omit",
    "on",
    "one",
    "only",
    "open",
    "or",
    "order",
    "out",
    "outer",
    "over",
    "overlaps",
    "overlay",
    "parameter",
    "partition",
    "pattern",
    "per",
    "percent",
    "percent_rank",
    "percentile_cont",
    "percentile_disc",
    "period",
    "portion",
    "position",
    "position_regex",
    "power",
    "precedes",
    "precision",
    "prepare",
    "primary",
    "procedure",
    "ptf",
    "range",
    "rank",
    "reads",
    "real",
    "recursive",
    "ref",
    "references",
    "referencing",
    "regr_avgx",
    "regr_avgy",
    "regr_count",
    "regr_intercept",
    "regr_r2",
    "regr_slope",
    "regr_sxx",
    "regr_sxy",
    "regr_syy",
    "release",
    "result",
    "return",
    "returns",
    "revoke",
    "right",
    "rollback",
    "rollup",
    "row",
    "row_number",
    "rows",
    "running",
    "savepoint",
    "scope",
    "scroll",
    "search",
    "second",
    "seek",
    "select",
    "sensitive",
    "session_user",
    "set",
    "show",
    "similar",
    "sin",
    "sinh",
    "skip",
    "smallint",
    "some",
    "specific",
    "specifictype",
    "sql",
    "sqlexception",
    "sqlstate",
    "sqlwarning",
    "sqrt",
    "start",
    "static",
    "stddev_pop",
    "stddev_samp",
    "submultiset",
    "subset",
    "substring",
    "substring_regex",
    "succeeds",
    "sum",
    "symmetric",
    "system",
    "system_time",
    "system_user",
    "table",
    "tablesample",
    "tan",
    "tanh",
    "then",
    "time",
    "timestamp",
    "timezone_hour",
    "timezone_minute",
    "to",
    "trailing",
    "translate",
    "translate_regex",
    "translation",
    "treat",
    "trigger",
    "trim",
    "trim_array",
    "true",
    "truncate",
    "uescape",
    "union",
    "unique",
    "unknown",
    "unnest",
    "update",
    "upper",
    "user",
    "using",
    "value",
    "values",
    "value_of",
    "var_pop",
    "var_samp",
    "varbinary",
    "varchar",
    "varying",
    "versioning",
    "when",
    "whenever",
    "where",
    "width_bucket",
    "window",
    "with",
    "within",
    "without",
    "year"
  ], u = [
    "abs",
    "acos",
    "array_agg",
    "asin",
    "atan",
    "avg",
    "cast",
    "ceil",
    "ceiling",
    "coalesce",
    "corr",
    "cos",
    "cosh",
    "count",
    "covar_pop",
    "covar_samp",
    "cume_dist",
    "dense_rank",
    "deref",
    "element",
    "exp",
    "extract",
    "first_value",
    "floor",
    "json_array",
    "json_arrayagg",
    "json_exists",
    "json_object",
    "json_objectagg",
    "json_query",
    "json_table",
    "json_table_primitive",
    "json_value",
    "lag",
    "last_value",
    "lead",
    "listagg",
    "ln",
    "log",
    "log10",
    "lower",
    "max",
    "min",
    "mod",
    "nth_value",
    "ntile",
    "nullif",
    "percent_rank",
    "percentile_cont",
    "percentile_disc",
    "position",
    "position_regex",
    "power",
    "rank",
    "regr_avgx",
    "regr_avgy",
    "regr_count",
    "regr_intercept",
    "regr_r2",
    "regr_slope",
    "regr_sxx",
    "regr_sxy",
    "regr_syy",
    "row_number",
    "sin",
    "sinh",
    "sqrt",
    "stddev_pop",
    "stddev_samp",
    "substring",
    "substring_regex",
    "sum",
    "tan",
    "tanh",
    "translate",
    "translate_regex",
    "treat",
    "trim",
    "trim_array",
    "unnest",
    "upper",
    "value_of",
    "var_pop",
    "var_samp",
    "width_bucket"
  ], d = [
    "current_catalog",
    "current_date",
    "current_default_transform_group",
    "current_path",
    "current_role",
    "current_schema",
    "current_transform_group_for_type",
    "current_user",
    "session_user",
    "system_time",
    "system_user",
    "current_time",
    "localtime",
    "current_timestamp",
    "localtimestamp"
  ], f = [
    "create table",
    "insert into",
    "primary key",
    "foreign key",
    "not null",
    "alter table",
    "add constraint",
    "grouping sets",
    "on overflow",
    "character set",
    "respect nulls",
    "ignore nulls",
    "nulls first",
    "nulls last",
    "depth first",
    "breadth first"
  ], h = u, m = [
    ...c,
    ...l
  ].filter((w) => !u.includes(w)), g = {
    scope: "variable",
    match: /@[a-z0-9][a-z0-9_]*/
  }, v = {
    scope: "operator",
    match: /[-+*/=%^~]|&&?|\|\|?|!=?|<(?:=>?|<|>)?|>[>=]?/,
    relevance: 0
  }, y = {
    match: e.concat(/\b/, e.either(...h), /\s*\(/),
    relevance: 0,
    keywords: { built_in: h }
  };
  function b(w) {
    return e.concat(
      /\b/,
      e.either(...w.map((C) => C.replace(/\s+/, "\\s+"))),
      /\b/
    );
  }
  const x = {
    scope: "keyword",
    match: b(f),
    relevance: 0
  };
  function E(w, {
    exceptions: C,
    when: S
  } = {}) {
    const M = S;
    return C = C || [], w.map((k) => k.match(/\|\d+$/) || C.includes(k) ? k : M(k) ? `${k}|0` : k);
  }
  return {
    name: "SQL",
    case_insensitive: !0,
    // does not include {} or HTML tags `</`
    illegal: /[{}]|<\//,
    keywords: {
      $pattern: /\b[\w\.]+/,
      keyword: E(m, { when: (w) => w.length < 3 }),
      literal: s,
      type: a,
      built_in: d
    },
    contains: [
      {
        scope: "type",
        match: b(o)
      },
      x,
      y,
      g,
      r,
      i,
      n.C_NUMBER_MODE,
      n.C_BLOCK_COMMENT_MODE,
      t,
      v
    ]
  };
}
function Fae(n) {
  return n ? typeof n == "string" ? n : n.source : null;
}
function gp(n) {
  return fn("(?=", n, ")");
}
function fn(...n) {
  return n.map((t) => Fae(t)).join("");
}
function jft(n) {
  const e = n[n.length - 1];
  return typeof e == "object" && e.constructor === Object ? (n.splice(n.length - 1, 1), e) : {};
}
function di(...n) {
  return "(" + (jft(n).capture ? "" : "?:") + n.map((r) => Fae(r)).join("|") + ")";
}
const DO = (n) => fn(
  /\b/,
  n,
  /\w$/.test(n) ? /\b/ : /\B/
), Wft = [
  "Protocol",
  // contextual
  "Type"
  // contextual
].map(DO), aj = [
  "init",
  "self"
].map(DO), Gft = [
  "Any",
  "Self"
], M8 = [
  // strings below will be fed into the regular `keywords` engine while regex
  // will result in additional modes being created to scan for those keywords to
  // avoid conflicts with other rules
  "actor",
  "any",
  // contextual
  "associatedtype",
  "async",
  "await",
  /as\?/,
  // operator
  /as!/,
  // operator
  "as",
  // operator
  "borrowing",
  // contextual
  "break",
  "case",
  "catch",
  "class",
  "consume",
  // contextual
  "consuming",
  // contextual
  "continue",
  "convenience",
  // contextual
  "copy",
  // contextual
  "default",
  "defer",
  "deinit",
  "didSet",
  // contextual
  "distributed",
  "do",
  "dynamic",
  // contextual
  "each",
  "else",
  "enum",
  "extension",
  "fallthrough",
  /fileprivate\(set\)/,
  "fileprivate",
  "final",
  // contextual
  "for",
  "func",
  "get",
  // contextual
  "guard",
  "if",
  "import",
  "indirect",
  // contextual
  "infix",
  // contextual
  /init\?/,
  /init!/,
  "inout",
  /internal\(set\)/,
  "internal",
  "in",
  "is",
  // operator
  "isolated",
  // contextual
  "nonisolated",
  // contextual
  "lazy",
  // contextual
  "let",
  "macro",
  "mutating",
  // contextual
  "nonmutating",
  // contextual
  /open\(set\)/,
  // contextual
  "open",
  // contextual
  "operator",
  "optional",
  // contextual
  "override",
  // contextual
  "package",
  "postfix",
  // contextual
  "precedencegroup",
  "prefix",
  // contextual
  /private\(set\)/,
  "private",
  "protocol",
  /public\(set\)/,
  "public",
  "repeat",
  "required",
  // contextual
  "rethrows",
  "return",
  "set",
  // contextual
  "some",
  // contextual
  "static",
  "struct",
  "subscript",
  "super",
  "switch",
  "throws",
  "throw",
  /try\?/,
  // operator
  /try!/,
  // operator
  "try",
  // operator
  "typealias",
  /unowned\(safe\)/,
  // contextual
  /unowned\(unsafe\)/,
  // contextual
  "unowned",
  // contextual
  "var",
  "weak",
  // contextual
  "where",
  "while",
  "willSet"
  // contextual
], lj = [
  "false",
  "nil",
  "true"
], Kft = [
  "assignment",
  "associativity",
  "higherThan",
  "left",
  "lowerThan",
  "none",
  "right"
], qft = [
  "#colorLiteral",
  "#column",
  "#dsohandle",
  "#else",
  "#elseif",
  "#endif",
  "#error",
  "#file",
  "#fileID",
  "#fileLiteral",
  "#filePath",
  "#function",
  "#if",
  "#imageLiteral",
  "#keyPath",
  "#line",
  "#selector",
  "#sourceLocation",
  "#warning"
], cj = [
  "abs",
  "all",
  "any",
  "assert",
  "assertionFailure",
  "debugPrint",
  "dump",
  "fatalError",
  "getVaList",
  "isKnownUniquelyReferenced",
  "max",
  "min",
  "numericCast",
  "pointwiseMax",
  "pointwiseMin",
  "precondition",
  "preconditionFailure",
  "print",
  "readLine",
  "repeatElement",
  "sequence",
  "stride",
  "swap",
  "swift_unboxFromSwiftValueWithType",
  "transcode",
  "type",
  "unsafeBitCast",
  "unsafeDowncast",
  "withExtendedLifetime",
  "withUnsafeMutablePointer",
  "withUnsafePointer",
  "withVaList",
  "withoutActuallyEscaping",
  "zip"
], Bae = di(
  /[/=\-+!*%<>&|^~?]/,
  /[\u00A1-\u00A7]/,
  /[\u00A9\u00AB]/,
  /[\u00AC\u00AE]/,
  /[\u00B0\u00B1]/,
  /[\u00B6\u00BB\u00BF\u00D7\u00F7]/,
  /[\u2016-\u2017]/,
  /[\u2020-\u2027]/,
  /[\u2030-\u203E]/,
  /[\u2041-\u2053]/,
  /[\u2055-\u205E]/,
  /[\u2190-\u23FF]/,
  /[\u2500-\u2775]/,
  /[\u2794-\u2BFF]/,
  /[\u2E00-\u2E7F]/,
  /[\u3001-\u3003]/,
  /[\u3008-\u3020]/,
  /[\u3030]/
), zae = di(
  Bae,
  /[\u0300-\u036F]/,
  /[\u1DC0-\u1DFF]/,
  /[\u20D0-\u20FF]/,
  /[\uFE00-\uFE0F]/,
  /[\uFE20-\uFE2F]/
  // TODO: The following characters are also allowed, but the regex isn't supported yet.
  // /[\u{E0100}-\u{E01EF}]/u
), k8 = fn(Bae, zae, "*"), Hae = di(
  /[a-zA-Z_]/,
  /[\u00A8\u00AA\u00AD\u00AF\u00B2-\u00B5\u00B7-\u00BA]/,
  /[\u00BC-\u00BE\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u00FF]/,
  /[\u0100-\u02FF\u0370-\u167F\u1681-\u180D\u180F-\u1DBF]/,
  /[\u1E00-\u1FFF]/,
  /[\u200B-\u200D\u202A-\u202E\u203F-\u2040\u2054\u2060-\u206F]/,
  /[\u2070-\u20CF\u2100-\u218F\u2460-\u24FF\u2776-\u2793]/,
  /[\u2C00-\u2DFF\u2E80-\u2FFF]/,
  /[\u3004-\u3007\u3021-\u302F\u3031-\u303F\u3040-\uD7FF]/,
  /[\uF900-\uFD3D\uFD40-\uFDCF\uFDF0-\uFE1F\uFE30-\uFE44]/,
  /[\uFE47-\uFEFE\uFF00-\uFFFD]/
  // Should be /[\uFE47-\uFFFD]/, but we have to exclude FEFF.
  // The following characters are also allowed, but the regexes aren't supported yet.
  // /[\u{10000}-\u{1FFFD}\u{20000-\u{2FFFD}\u{30000}-\u{3FFFD}\u{40000}-\u{4FFFD}]/u,
  // /[\u{50000}-\u{5FFFD}\u{60000-\u{6FFFD}\u{70000}-\u{7FFFD}\u{80000}-\u{8FFFD}]/u,
  // /[\u{90000}-\u{9FFFD}\u{A0000-\u{AFFFD}\u{B0000}-\u{BFFFD}\u{C0000}-\u{CFFFD}]/u,
  // /[\u{D0000}-\u{DFFFD}\u{E0000-\u{EFFFD}]/u
), $b = di(
  Hae,
  /\d/,
  /[\u0300-\u036F\u1DC0-\u1DFF\u20D0-\u20FF\uFE20-\uFE2F]/
), Vo = fn(Hae, $b, "*"), hv = fn(/[A-Z]/, $b, "*"), Yft = [
  "attached",
  "autoclosure",
  fn(/convention\(/, di("swift", "block", "c"), /\)/),
  "discardableResult",
  "dynamicCallable",
  "dynamicMemberLookup",
  "escaping",
  "freestanding",
  "frozen",
  "GKInspectable",
  "IBAction",
  "IBDesignable",
  "IBInspectable",
  "IBOutlet",
  "IBSegueAction",
  "inlinable",
  "main",
  "nonobjc",
  "NSApplicationMain",
  "NSCopying",
  "NSManaged",
  fn(/objc\(/, Vo, /\)/),
  "objc",
  "objcMembers",
  "propertyWrapper",
  "requires_stored_property_inits",
  "resultBuilder",
  "Sendable",
  "testable",
  "UIApplicationMain",
  "unchecked",
  "unknown",
  "usableFromInline",
  "warn_unqualified_access"
], Xft = [
  "iOS",
  "iOSApplicationExtension",
  "macOS",
  "macOSApplicationExtension",
  "macCatalyst",
  "macCatalystApplicationExtension",
  "watchOS",
  "watchOSApplicationExtension",
  "tvOS",
  "tvOSApplicationExtension",
  "swift"
];
function Zft(n) {
  const e = {
    match: /\s+/,
    relevance: 0
  }, t = n.COMMENT(
    "/\\*",
    "\\*/",
    { contains: ["self"] }
  ), r = [
    n.C_LINE_COMMENT_MODE,
    t
  ], i = {
    match: [
      /\./,
      di(...Wft, ...aj)
    ],
    className: { 2: "keyword" }
  }, s = {
    // Consume .keyword to prevent highlighting properties and methods as keywords.
    match: fn(/\./, di(...M8)),
    relevance: 0
  }, o = M8.filter((ve) => typeof ve == "string").concat(["_|0"]), a = M8.filter((ve) => typeof ve != "string").concat(Gft).map(DO), l = { variants: [
    {
      className: "keyword",
      match: di(...a, ...aj)
    }
  ] }, c = {
    $pattern: di(
      /\b\w+/,
      // regular keywords
      /#\w+/
      // number keywords
    ),
    keyword: o.concat(qft),
    literal: lj
  }, u = [
    i,
    s,
    l
  ], d = {
    // Consume .built_in to prevent highlighting properties and methods.
    match: fn(/\./, di(...cj)),
    relevance: 0
  }, f = {
    className: "built_in",
    match: fn(/\b/, di(...cj), /(?=\()/)
  }, h = [
    d,
    f
  ], m = {
    // Prevent -> from being highlighting as an operator.
    match: /->/,
    relevance: 0
  }, g = {
    className: "operator",
    relevance: 0,
    variants: [
      { match: k8 },
      {
        // dot-operator: only operators that start with a dot are allowed to use dots as
        // characters (..., ...<, .*, etc). So there rule here is: a dot followed by one or more
        // characters that may also include dots.
        match: `\\.(\\.|${zae})+`
      }
    ]
  }, v = [
    m,
    g
  ], y = "([0-9]_*)+", b = "([0-9a-fA-F]_*)+", x = {
    className: "number",
    relevance: 0,
    variants: [
      // decimal floating-point-literal (subsumes decimal-literal)
      { match: `\\b(${y})(\\.(${y}))?([eE][+-]?(${y}))?\\b` },
      // hexadecimal floating-point-literal (subsumes hexadecimal-literal)
      { match: `\\b0x(${b})(\\.(${b}))?([pP][+-]?(${y}))?\\b` },
      // octal-literal
      { match: /\b0o([0-7]_*)+\b/ },
      // binary-literal
      { match: /\b0b([01]_*)+\b/ }
    ]
  }, E = (ve = "") => ({
    className: "subst",
    variants: [
      { match: fn(/\\/, ve, /[0\\tnr"']/) },
      { match: fn(/\\/, ve, /u\{[0-9a-fA-F]{1,8}\}/) }
    ]
  }), w = (ve = "") => ({
    className: "subst",
    match: fn(/\\/, ve, /[\t ]*(?:[\r\n]|\r\n)/)
  }), C = (ve = "") => ({
    className: "subst",
    label: "interpol",
    begin: fn(/\\/, ve, /\(/),
    end: /\)/
  }), S = (ve = "") => ({
    begin: fn(ve, /"""/),
    end: fn(/"""/, ve),
    contains: [
      E(ve),
      w(ve),
      C(ve)
    ]
  }), M = (ve = "") => ({
    begin: fn(ve, /"/),
    end: fn(/"/, ve),
    contains: [
      E(ve),
      C(ve)
    ]
  }), k = {
    className: "string",
    variants: [
      S(),
      S("#"),
      S("##"),
      S("###"),
      M(),
      M("#"),
      M("##"),
      M("###")
    ]
  }, _ = [
    n.BACKSLASH_ESCAPE,
    {
      begin: /\[/,
      end: /\]/,
      relevance: 0,
      contains: [n.BACKSLASH_ESCAPE]
    }
  ], O = {
    begin: /\/[^\s](?=[^/\n]*\/)/,
    end: /\//,
    contains: _
  }, I = (ve) => {
    const Ie = fn(ve, /\//), mt = fn(/\//, ve);
    return {
      begin: Ie,
      end: mt,
      contains: [
        ..._,
        {
          scope: "comment",
          begin: `#(?!.*${mt})`,
          end: /$/
        }
      ]
    };
  }, R = {
    scope: "regexp",
    variants: [
      I("###"),
      I("##"),
      I("#"),
      O
    ]
  }, P = { match: fn(/`/, Vo, /`/) }, D = {
    className: "variable",
    match: /\$\d+/
  }, L = {
    className: "variable",
    match: `\\$${$b}+`
  }, B = [
    P,
    D,
    L
  ], $ = {
    match: /(@|#(un)?)available/,
    scope: "keyword",
    starts: { contains: [
      {
        begin: /\(/,
        end: /\)/,
        keywords: Xft,
        contains: [
          ...v,
          x,
          k
        ]
      }
    ] }
  }, z = {
    scope: "keyword",
    match: fn(/@/, di(...Yft), gp(di(/\(/, /\s+/)))
  }, H = {
    scope: "meta",
    match: fn(/@/, Vo)
  }, U = [
    $,
    z,
    H
  ], F = {
    match: gp(/\b[A-Z]/),
    relevance: 0,
    contains: [
      {
        // Common Apple frameworks, for relevance boost
        className: "type",
        match: fn(/(AV|CA|CF|CG|CI|CL|CM|CN|CT|MK|MP|MTK|MTL|NS|SCN|SK|UI|WK|XC)/, $b, "+")
      },
      {
        // Type identifier
        className: "type",
        match: hv,
        relevance: 0
      },
      {
        // Optional type
        match: /[?!]+/,
        relevance: 0
      },
      {
        // Variadic parameter
        match: /\.\.\./,
        relevance: 0
      },
      {
        // Protocol composition
        match: fn(/\s+&\s+/, gp(hv)),
        relevance: 0
      }
    ]
  }, V = {
    begin: /</,
    end: />/,
    keywords: c,
    contains: [
      ...r,
      ...u,
      ...U,
      m,
      F
    ]
  };
  F.contains.push(V);
  const X = {
    match: fn(Vo, /\s*:/),
    keywords: "_|0",
    relevance: 0
  }, Z = {
    begin: /\(/,
    end: /\)/,
    relevance: 0,
    keywords: c,
    contains: [
      "self",
      X,
      ...r,
      R,
      ...u,
      ...h,
      ...v,
      x,
      k,
      ...B,
      ...U,
      F
    ]
  }, ie = {
    begin: /</,
    end: />/,
    keywords: "repeat each",
    contains: [
      ...r,
      F
    ]
  }, J = {
    begin: di(
      gp(fn(Vo, /\s*:/)),
      gp(fn(Vo, /\s+/, Vo, /\s*:/))
    ),
    end: /:/,
    relevance: 0,
    contains: [
      {
        className: "keyword",
        match: /\b_\b/
      },
      {
        className: "params",
        match: Vo
      }
    ]
  }, se = {
    begin: /\(/,
    end: /\)/,
    keywords: c,
    contains: [
      J,
      ...r,
      ...u,
      ...v,
      x,
      k,
      ...U,
      F,
      Z
    ],
    endsParent: !0,
    illegal: /["']/
  }, te = {
    match: [
      /(func|macro)/,
      /\s+/,
      di(P.match, Vo, k8)
    ],
    className: {
      1: "keyword",
      3: "title.function"
    },
    contains: [
      ie,
      se,
      e
    ],
    illegal: [
      /\[/,
      /%/
    ]
  }, le = {
    match: [
      /\b(?:subscript|init[?!]?)/,
      /\s*(?=[<(])/
    ],
    className: { 1: "keyword" },
    contains: [
      ie,
      se,
      e
    ],
    illegal: /\[|%/
  }, de = {
    match: [
      /operator/,
      /\s+/,
      k8
    ],
    className: {
      1: "keyword",
      3: "title"
    }
  }, j = {
    begin: [
      /precedencegroup/,
      /\s+/,
      hv
    ],
    className: {
      1: "keyword",
      3: "title"
    },
    contains: [F],
    keywords: [
      ...Kft,
      ...lj
    ],
    end: /}/
  }, xe = {
    match: [
      /class\b/,
      /\s+/,
      /func\b/,
      /\s+/,
      /\b[A-Za-z_][A-Za-z0-9_]*\b/
    ],
    scope: {
      1: "keyword",
      3: "keyword",
      5: "title.function"
    }
  }, ne = {
    match: [
      /class\b/,
      /\s+/,
      /var\b/
    ],
    scope: {
      1: "keyword",
      3: "keyword"
    }
  }, qe = {
    begin: [
      /(struct|protocol|class|extension|enum|actor)/,
      /\s+/,
      Vo,
      /\s*/
    ],
    beginScope: {
      1: "keyword",
      3: "title.class"
    },
    keywords: c,
    contains: [
      ie,
      ...u,
      {
        begin: /:/,
        end: /\{/,
        keywords: c,
        contains: [
          {
            scope: "title.class.inherited",
            match: hv
          },
          ...u
        ],
        relevance: 0
      }
    ]
  };
  for (const ve of k.variants) {
    const Ie = ve.contains.find((xt) => xt.label === "interpol");
    Ie.keywords = c;
    const mt = [
      ...u,
      ...h,
      ...v,
      x,
      k,
      ...B
    ];
    Ie.contains = [
      ...mt,
      {
        begin: /\(/,
        end: /\)/,
        contains: [
          "self",
          ...mt
        ]
      }
    ];
  }
  return {
    name: "Swift",
    keywords: c,
    contains: [
      ...r,
      te,
      le,
      xe,
      ne,
      qe,
      de,
      j,
      {
        beginKeywords: "import",
        end: /$/,
        contains: [...r],
        relevance: 0
      },
      R,
      ...u,
      ...h,
      ...v,
      x,
      k,
      ...B,
      ...U,
      F,
      Z
    ]
  };
}
const Fb = "[A-Za-z$_][0-9A-Za-z$_]*", Uae = [
  "as",
  // for exports
  "in",
  "of",
  "if",
  "for",
  "while",
  "finally",
  "var",
  "new",
  "function",
  "do",
  "return",
  "void",
  "else",
  "break",
  "catch",
  "instanceof",
  "with",
  "throw",
  "case",
  "default",
  "try",
  "switch",
  "continue",
  "typeof",
  "delete",
  "let",
  "yield",
  "const",
  "class",
  // JS handles these with a special rule
  // "get",
  // "set",
  "debugger",
  "async",
  "await",
  "static",
  "import",
  "from",
  "export",
  "extends",
  // It's reached stage 3, which is "recommended for implementation":
  "using"
], Vae = [
  "true",
  "false",
  "null",
  "undefined",
  "NaN",
  "Infinity"
], jae = [
  // Fundamental objects
  "Object",
  "Function",
  "Boolean",
  "Symbol",
  // numbers and dates
  "Math",
  "Date",
  "Number",
  "BigInt",
  // text
  "String",
  "RegExp",
  // Indexed collections
  "Array",
  "Float32Array",
  "Float64Array",
  "Int8Array",
  "Uint8Array",
  "Uint8ClampedArray",
  "Int16Array",
  "Int32Array",
  "Uint16Array",
  "Uint32Array",
  "BigInt64Array",
  "BigUint64Array",
  // Keyed collections
  "Set",
  "Map",
  "WeakSet",
  "WeakMap",
  // Structured data
  "ArrayBuffer",
  "SharedArrayBuffer",
  "Atomics",
  "DataView",
  "JSON",
  // Control abstraction objects
  "Promise",
  "Generator",
  "GeneratorFunction",
  "AsyncFunction",
  // Reflection
  "Reflect",
  "Proxy",
  // Internationalization
  "Intl",
  // WebAssembly
  "WebAssembly"
], Wae = [
  "Error",
  "EvalError",
  "InternalError",
  "RangeError",
  "ReferenceError",
  "SyntaxError",
  "TypeError",
  "URIError"
], Gae = [
  "setInterval",
  "setTimeout",
  "clearInterval",
  "clearTimeout",
  "require",
  "exports",
  "eval",
  "isFinite",
  "isNaN",
  "parseFloat",
  "parseInt",
  "decodeURI",
  "decodeURIComponent",
  "encodeURI",
  "encodeURIComponent",
  "escape",
  "unescape"
], Kae = [
  "arguments",
  "this",
  "super",
  "console",
  "window",
  "document",
  "localStorage",
  "sessionStorage",
  "module",
  "global"
  // Node.js
], qae = [].concat(
  Gae,
  jae,
  Wae
);
function Qft(n) {
  const e = n.regex, t = ($, { after: z }) => {
    const H = "</" + $[0].slice(1);
    return $.input.indexOf(H, z) !== -1;
  }, r = Fb, i = {
    begin: "<>",
    end: "</>"
  }, s = /<[A-Za-z0-9\\._:-]+\s*\/>/, o = {
    begin: /<[A-Za-z0-9\\._:-]+/,
    end: /\/[A-Za-z0-9\\._:-]+>|\/>/,
    /**
     * @param {RegExpMatchArray} match
     * @param {CallbackResponse} response
     */
    isTrulyOpeningTag: ($, z) => {
      const H = $[0].length + $.index, U = $.input[H];
      if (
        // HTML should not include another raw `<` inside a tag
        // nested type?
        // `<Array<Array<number>>`, etc.
        U === "<" || // the , gives away that this is not HTML
        // `<T, A extends keyof T, V>`
        U === ","
      ) {
        z.ignoreMatch();
        return;
      }
      U === ">" && (t($, { after: H }) || z.ignoreMatch());
      let F;
      const V = $.input.substring(H);
      if (F = V.match(/^\s*=/)) {
        z.ignoreMatch();
        return;
      }
      if ((F = V.match(/^\s+extends\s+/)) && F.index === 0) {
        z.ignoreMatch();
        return;
      }
    }
  }, a = {
    $pattern: Fb,
    keyword: Uae,
    literal: Vae,
    built_in: qae,
    "variable.language": Kae
  }, l = "[0-9](_?[0-9])*", c = `\\.(${l})`, u = "0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*", d = {
    className: "number",
    variants: [
      // DecimalLiteral
      { begin: `(\\b(${u})((${c})|\\.)?|(${c}))[eE][+-]?(${l})\\b` },
      { begin: `\\b(${u})\\b((${c})\\b|\\.)?|(${c})\\b` },
      // DecimalBigIntegerLiteral
      { begin: "\\b(0|[1-9](_?[0-9])*)n\\b" },
      // NonDecimalIntegerLiteral
      { begin: "\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b" },
      { begin: "\\b0[bB][0-1](_?[0-1])*n?\\b" },
      { begin: "\\b0[oO][0-7](_?[0-7])*n?\\b" },
      // LegacyOctalIntegerLiteral (does not include underscore separators)
      // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
      { begin: "\\b0[0-7]+n?\\b" }
    ],
    relevance: 0
  }, f = {
    className: "subst",
    begin: "\\$\\{",
    end: "\\}",
    keywords: a,
    contains: []
    // defined later
  }, h = {
    begin: ".?html`",
    end: "",
    starts: {
      end: "`",
      returnEnd: !1,
      contains: [
        n.BACKSLASH_ESCAPE,
        f
      ],
      subLanguage: "xml"
    }
  }, m = {
    begin: ".?css`",
    end: "",
    starts: {
      end: "`",
      returnEnd: !1,
      contains: [
        n.BACKSLASH_ESCAPE,
        f
      ],
      subLanguage: "css"
    }
  }, g = {
    begin: ".?gql`",
    end: "",
    starts: {
      end: "`",
      returnEnd: !1,
      contains: [
        n.BACKSLASH_ESCAPE,
        f
      ],
      subLanguage: "graphql"
    }
  }, v = {
    className: "string",
    begin: "`",
    end: "`",
    contains: [
      n.BACKSLASH_ESCAPE,
      f
    ]
  }, b = {
    className: "comment",
    variants: [
      n.COMMENT(
        /\/\*\*(?!\/)/,
        "\\*/",
        {
          relevance: 0,
          contains: [
            {
              begin: "(?=@[A-Za-z]+)",
              relevance: 0,
              contains: [
                {
                  className: "doctag",
                  begin: "@[A-Za-z]+"
                },
                {
                  className: "type",
                  begin: "\\{",
                  end: "\\}",
                  excludeEnd: !0,
                  excludeBegin: !0,
                  relevance: 0
                },
                {
                  className: "variable",
                  begin: r + "(?=\\s*(-)|$)",
                  endsParent: !0,
                  relevance: 0
                },
                // eat spaces (not newlines) so we can find
                // types or variables
                {
                  begin: /(?=[^\n])\s/,
                  relevance: 0
                }
              ]
            }
          ]
        }
      ),
      n.C_BLOCK_COMMENT_MODE,
      n.C_LINE_COMMENT_MODE
    ]
  }, x = [
    n.APOS_STRING_MODE,
    n.QUOTE_STRING_MODE,
    h,
    m,
    g,
    v,
    // Skip numbers when they are part of a variable name
    { match: /\$\d+/ },
    d
    // This is intentional:
    // See https://github.com/highlightjs/highlight.js/issues/3288
    // hljs.REGEXP_MODE
  ];
  f.contains = x.concat({
    // we need to pair up {} inside our subst to prevent
    // it from ending too early by matching another }
    begin: /\{/,
    end: /\}/,
    keywords: a,
    contains: [
      "self"
    ].concat(x)
  });
  const E = [].concat(b, f.contains), w = E.concat([
    // eat recursive parens in sub expressions
    {
      begin: /(\s*)\(/,
      end: /\)/,
      keywords: a,
      contains: ["self"].concat(E)
    }
  ]), C = {
    className: "params",
    // convert this to negative lookbehind in v12
    begin: /(\s*)\(/,
    // to match the parms with
    end: /\)/,
    excludeBegin: !0,
    excludeEnd: !0,
    keywords: a,
    contains: w
  }, S = {
    variants: [
      // class Car extends vehicle
      {
        match: [
          /class/,
          /\s+/,
          r,
          /\s+/,
          /extends/,
          /\s+/,
          e.concat(r, "(", e.concat(/\./, r), ")*")
        ],
        scope: {
          1: "keyword",
          3: "title.class",
          5: "keyword",
          7: "title.class.inherited"
        }
      },
      // class Car
      {
        match: [
          /class/,
          /\s+/,
          r
        ],
        scope: {
          1: "keyword",
          3: "title.class"
        }
      }
    ]
  }, M = {
    relevance: 0,
    match: e.either(
      // Hard coded exceptions
      /\bJSON/,
      // Float32Array, OutT
      /\b[A-Z][a-z]+([A-Z][a-z]*|\d)*/,
      // CSSFactory, CSSFactoryT
      /\b[A-Z]{2,}([A-Z][a-z]+|\d)+([A-Z][a-z]*)*/,
      // FPs, FPsT
      /\b[A-Z]{2,}[a-z]+([A-Z][a-z]+|\d)*([A-Z][a-z]*)*/
      // P
      // single letters are not highlighted
      // BLAH
      // this will be flagged as a UPPER_CASE_CONSTANT instead
    ),
    className: "title.class",
    keywords: {
      _: [
        // se we still get relevance credit for JS library classes
        ...jae,
        ...Wae
      ]
    }
  }, k = {
    label: "use_strict",
    className: "meta",
    relevance: 10,
    begin: /^\s*['"]use (strict|asm)['"]/
  }, _ = {
    variants: [
      {
        match: [
          /function/,
          /\s+/,
          r,
          /(?=\s*\()/
        ]
      },
      // anonymous function
      {
        match: [
          /function/,
          /\s*(?=\()/
        ]
      }
    ],
    className: {
      1: "keyword",
      3: "title.function"
    },
    label: "func.def",
    contains: [C],
    illegal: /%/
  }, O = {
    relevance: 0,
    match: /\b[A-Z][A-Z_0-9]+\b/,
    className: "variable.constant"
  };
  function I($) {
    return e.concat("(?!", $.join("|"), ")");
  }
  const R = {
    match: e.concat(
      /\b/,
      I([
        ...Gae,
        "super",
        "import"
      ].map(($) => `${$}\\s*\\(`)),
      r,
      e.lookahead(/\s*\(/)
    ),
    className: "title.function",
    relevance: 0
  }, P = {
    begin: e.concat(/\./, e.lookahead(
      e.concat(r, /(?![0-9A-Za-z$_(])/)
    )),
    end: r,
    excludeBegin: !0,
    keywords: "prototype",
    className: "property",
    relevance: 0
  }, D = {
    match: [
      /get|set/,
      /\s+/,
      r,
      /(?=\()/
    ],
    className: {
      1: "keyword",
      3: "title.function"
    },
    contains: [
      {
        // eat to avoid empty params
        begin: /\(\)/
      },
      C
    ]
  }, L = "(\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)|" + n.UNDERSCORE_IDENT_RE + ")\\s*=>", B = {
    match: [
      /const|var|let/,
      /\s+/,
      r,
      /\s*/,
      /=\s*/,
      /(async\s*)?/,
      // async is optional
      e.lookahead(L)
    ],
    keywords: "async",
    className: {
      1: "keyword",
      3: "title.function"
    },
    contains: [
      C
    ]
  };
  return {
    name: "JavaScript",
    aliases: ["js", "jsx", "mjs", "cjs"],
    keywords: a,
    // this will be extended by TypeScript
    exports: { PARAMS_CONTAINS: w, CLASS_REFERENCE: M },
    illegal: /#(?![$_A-z])/,
    contains: [
      n.SHEBANG({
        label: "shebang",
        binary: "node",
        relevance: 5
      }),
      k,
      n.APOS_STRING_MODE,
      n.QUOTE_STRING_MODE,
      h,
      m,
      g,
      v,
      b,
      // Skip numbers when they are part of a variable name
      { match: /\$\d+/ },
      d,
      M,
      {
        scope: "attr",
        match: r + e.lookahead(":"),
        relevance: 0
      },
      B,
      {
        // "value" container
        begin: "(" + n.RE_STARTERS_RE + "|\\b(case|return|throw)\\b)\\s*",
        keywords: "return throw case",
        relevance: 0,
        contains: [
          b,
          n.REGEXP_MODE,
          {
            className: "function",
            // we have to count the parens to make sure we actually have the
            // correct bounding ( ) before the =>.  There could be any number of
            // sub-expressions inside also surrounded by parens.
            begin: L,
            returnBegin: !0,
            end: "\\s*=>",
            contains: [
              {
                className: "params",
                variants: [
                  {
                    begin: n.UNDERSCORE_IDENT_RE,
                    relevance: 0
                  },
                  {
                    className: null,
                    begin: /\(\s*\)/,
                    skip: !0
                  },
                  {
                    begin: /(\s*)\(/,
                    end: /\)/,
                    excludeBegin: !0,
                    excludeEnd: !0,
                    keywords: a,
                    contains: w
                  }
                ]
              }
            ]
          },
          {
            // could be a comma delimited list of params to a function call
            begin: /,/,
            relevance: 0
          },
          {
            match: /\s+/,
            relevance: 0
          },
          {
            // JSX
            variants: [
              { begin: i.begin, end: i.end },
              { match: s },
              {
                begin: o.begin,
                // we carefully check the opening tag to see if it truly
                // is a tag and not a false positive
                "on:begin": o.isTrulyOpeningTag,
                end: o.end
              }
            ],
            subLanguage: "xml",
            contains: [
              {
                begin: o.begin,
                end: o.end,
                skip: !0,
                contains: ["self"]
              }
            ]
          }
        ]
      },
      _,
      {
        // prevent this from getting swallowed up by function
        // since they appear "function like"
        beginKeywords: "while if switch catch for"
      },
      {
        // we have to count the parens to make sure we actually have the correct
        // bounding ( ).  There could be any number of sub-expressions inside
        // also surrounded by parens.
        begin: "\\b(?!function)" + n.UNDERSCORE_IDENT_RE + "\\([^()]*(\\([^()]*(\\([^()]*\\)[^()]*)*\\)[^()]*)*\\)\\s*\\{",
        // end parens
        returnBegin: !0,
        label: "func.def",
        contains: [
          C,
          n.inherit(n.TITLE_MODE, { begin: r, className: "title.function" })
        ]
      },
      // catch ... so it won't trigger the property rule below
      {
        match: /\.\.\./,
        relevance: 0
      },
      P,
      // hack: prevents detection of keywords in some circumstances
      // .keyword()
      // $keyword = x
      {
        match: "\\$" + r,
        relevance: 0
      },
      {
        match: [/\bconstructor(?=\s*\()/],
        className: { 1: "title.function" },
        contains: [C]
      },
      R,
      O,
      S,
      D,
      {
        match: /\$[(.]/
        // relevance booster for a pattern common to JS libs: `$(something)` and `$.something`
      }
    ]
  };
}
function Jft(n) {
  const e = n.regex, t = Qft(n), r = Fb, i = [
    "any",
    "void",
    "number",
    "boolean",
    "string",
    "object",
    "never",
    "symbol",
    "bigint",
    "unknown"
  ], s = {
    begin: [
      /namespace/,
      /\s+/,
      n.IDENT_RE
    ],
    beginScope: {
      1: "keyword",
      3: "title.class"
    }
  }, o = {
    beginKeywords: "interface",
    end: /\{/,
    excludeEnd: !0,
    keywords: {
      keyword: "interface extends",
      built_in: i
    },
    contains: [t.exports.CLASS_REFERENCE]
  }, a = {
    className: "meta",
    relevance: 10,
    begin: /^\s*['"]use strict['"]/
  }, l = [
    "type",
    // "namespace",
    "interface",
    "public",
    "private",
    "protected",
    "implements",
    "declare",
    "abstract",
    "readonly",
    "enum",
    "override",
    "satisfies"
  ], c = {
    $pattern: Fb,
    keyword: Uae.concat(l),
    literal: Vae,
    built_in: qae.concat(i),
    "variable.language": Kae
  }, u = {
    className: "meta",
    begin: "@" + r
  }, d = (g, v, y) => {
    const b = g.contains.findIndex((x) => x.label === v);
    if (b === -1)
      throw new Error("can not find mode to replace");
    g.contains.splice(b, 1, y);
  };
  Object.assign(t.keywords, c), t.exports.PARAMS_CONTAINS.push(u);
  const f = t.contains.find((g) => g.scope === "attr"), h = Object.assign(
    {},
    f,
    { match: e.concat(r, e.lookahead(/\s*\?:/)) }
  );
  t.exports.PARAMS_CONTAINS.push([
    t.exports.CLASS_REFERENCE,
    // class reference for highlighting the params types
    f,
    // highlight the params key
    h
    // Added for optional property assignment highlighting
  ]), t.contains = t.contains.concat([
    u,
    s,
    o,
    h
    // Added for optional property assignment highlighting
  ]), d(t, "shebang", n.SHEBANG()), d(t, "use_strict", a);
  const m = t.contains.find((g) => g.label === "func.def");
  return m.relevance = 0, Object.assign(t, {
    name: "TypeScript",
    aliases: [
      "ts",
      "tsx",
      "mts",
      "cts"
    ]
  }), t;
}
function eht(n) {
  const e = n.regex, t = {
    className: "string",
    begin: /"(""|[^/n])"C\b/
  }, r = {
    className: "string",
    begin: /"/,
    end: /"/,
    illegal: /\n/,
    contains: [
      {
        // double quote escape
        begin: /""/
      }
    ]
  }, i = /\d{1,2}\/\d{1,2}\/\d{4}/, s = /\d{4}-\d{1,2}-\d{1,2}/, o = /(\d|1[012])(:\d+){0,2} *(AM|PM)/, a = /\d{1,2}(:\d{1,2}){1,2}/, l = {
    className: "literal",
    variants: [
      {
        // #YYYY-MM-DD# (ISO-Date) or #M/D/YYYY# (US-Date)
        begin: e.concat(/# */, e.either(s, i), / *#/)
      },
      {
        // #H:mm[:ss]# (24h Time)
        begin: e.concat(/# */, a, / *#/)
      },
      {
        // #h[:mm[:ss]] A# (12h Time)
        begin: e.concat(/# */, o, / *#/)
      },
      {
        // date plus time
        begin: e.concat(
          /# */,
          e.either(s, i),
          / +/,
          e.either(o, a),
          / *#/
        )
      }
    ]
  }, c = {
    className: "number",
    relevance: 0,
    variants: [
      {
        // Float
        begin: /\b\d[\d_]*((\.[\d_]+(E[+-]?[\d_]+)?)|(E[+-]?[\d_]+))[RFD@!#]?/
      },
      {
        // Integer (base 10)
        begin: /\b\d[\d_]*((U?[SIL])|[%&])?/
      },
      {
        // Integer (base 16)
        begin: /&H[\dA-F_]+((U?[SIL])|[%&])?/
      },
      {
        // Integer (base 8)
        begin: /&O[0-7_]+((U?[SIL])|[%&])?/
      },
      {
        // Integer (base 2)
        begin: /&B[01_]+((U?[SIL])|[%&])?/
      }
    ]
  }, u = {
    className: "label",
    begin: /^\w+:/
  }, d = n.COMMENT(/'''/, /$/, { contains: [
    {
      className: "doctag",
      begin: /<\/?/,
      end: />/
    }
  ] }), f = n.COMMENT(null, /$/, { variants: [
    { begin: /'/ },
    {
      // TODO: Use multi-class for leading spaces
      begin: /([\t ]|^)REM(?=\s)/
    }
  ] });
  return {
    name: "Visual Basic .NET",
    aliases: ["vb"],
    case_insensitive: !0,
    classNameAliases: { label: "symbol" },
    keywords: {
      keyword: "addhandler alias aggregate ansi as async assembly auto binary by byref byval call case catch class compare const continue custom declare default delegate dim distinct do each equals else elseif end enum erase error event exit explicit finally for friend from function get global goto group handles if implements imports in inherits interface into iterator join key let lib loop me mid module mustinherit mustoverride mybase myclass namespace narrowing new next notinheritable notoverridable of off on operator option optional order overloads overridable overrides paramarray partial preserve private property protected public raiseevent readonly redim removehandler resume return select set shadows shared skip static step stop structure strict sub synclock take text then throw to try unicode until using when where while widening with withevents writeonly yield",
      built_in: (
        // Operators https://docs.microsoft.com/dotnet/visual-basic/language-reference/operators
        "addressof and andalso await directcast gettype getxmlnamespace is isfalse isnot istrue like mod nameof new not or orelse trycast typeof xor cbool cbyte cchar cdate cdbl cdec cint clng cobj csbyte cshort csng cstr cuint culng cushort"
      ),
      type: (
        // Data types https://docs.microsoft.com/dotnet/visual-basic/language-reference/data-types
        "boolean byte char date decimal double integer long object sbyte short single string uinteger ulong ushort"
      ),
      literal: "true false nothing"
    },
    illegal: "//|\\{|\\}|endif|gosub|variant|wend|^\\$ ",
    contains: [
      t,
      r,
      l,
      c,
      u,
      d,
      f,
      {
        className: "meta",
        // TODO: Use multi-class for indentation once available
        begin: /[\t ]*#(const|disable|else|elseif|enable|end|externalsource|if|region)\b/,
        end: /$/,
        keywords: { keyword: "const disable else elseif enable end externalsource if region then" },
        contains: [f]
      }
    ]
  };
}
function tht(n) {
  n.regex;
  const e = n.COMMENT(/\(;/, /;\)/);
  e.contains.push("self");
  const t = n.COMMENT(/;;/, /$/), r = [
    "anyfunc",
    "block",
    "br",
    "br_if",
    "br_table",
    "call",
    "call_indirect",
    "data",
    "drop",
    "elem",
    "else",
    "end",
    "export",
    "func",
    "global.get",
    "global.set",
    "local.get",
    "local.set",
    "local.tee",
    "get_global",
    "get_local",
    "global",
    "if",
    "import",
    "local",
    "loop",
    "memory",
    "memory.grow",
    "memory.size",
    "module",
    "mut",
    "nop",
    "offset",
    "param",
    "result",
    "return",
    "select",
    "set_global",
    "set_local",
    "start",
    "table",
    "tee_local",
    "then",
    "type",
    "unreachable"
  ], i = {
    begin: [
      /(?:func|call|call_indirect)/,
      /\s+/,
      /\$[^\s)]+/
    ],
    className: {
      1: "keyword",
      3: "title.function"
    }
  }, s = {
    className: "variable",
    begin: /\$[\w_]+/
  }, o = {
    match: /(\((?!;)|\))+/,
    className: "punctuation",
    relevance: 0
  }, a = {
    className: "number",
    relevance: 0,
    // borrowed from Prism, TODO: split out into variants
    match: /[+-]?\b(?:\d(?:_?\d)*(?:\.\d(?:_?\d)*)?(?:[eE][+-]?\d(?:_?\d)*)?|0x[\da-fA-F](?:_?[\da-fA-F])*(?:\.[\da-fA-F](?:_?[\da-fA-D])*)?(?:[pP][+-]?\d(?:_?\d)*)?)\b|\binf\b|\bnan(?::0x[\da-fA-F](?:_?[\da-fA-D])*)?\b/
  }, l = {
    // look-ahead prevents us from gobbling up opcodes
    match: /(i32|i64|f32|f64)(?!\.)/,
    className: "type"
  }, c = {
    className: "keyword",
    // borrowed from Prism, TODO: split out into variants
    match: /\b(f32|f64|i32|i64)(?:\.(?:abs|add|and|ceil|clz|const|convert_[su]\/i(?:32|64)|copysign|ctz|demote\/f64|div(?:_[su])?|eqz?|extend_[su]\/i32|floor|ge(?:_[su])?|gt(?:_[su])?|le(?:_[su])?|load(?:(?:8|16|32)_[su])?|lt(?:_[su])?|max|min|mul|nearest|neg?|or|popcnt|promote\/f32|reinterpret\/[fi](?:32|64)|rem_[su]|rot[lr]|shl|shr_[su]|store(?:8|16|32)?|sqrt|sub|trunc(?:_[su]\/f(?:32|64))?|wrap\/i64|xor))\b/
  };
  return {
    name: "WebAssembly",
    keywords: {
      $pattern: /[\w.]+/,
      keyword: r
    },
    contains: [
      t,
      e,
      {
        match: [
          /(?:offset|align)/,
          /\s*/,
          /=/
        ],
        className: {
          1: "keyword",
          3: "operator"
        }
      },
      s,
      o,
      i,
      n.QUOTE_STRING_MODE,
      l,
      c,
      a
    ]
  };
}
function nht(n) {
  const e = n.regex, t = e.concat(/[\p{L}_]/u, e.optional(/[\p{L}0-9_.-]*:/u), /[\p{L}0-9_.-]*/u), r = /[\p{L}0-9._:-]+/u, i = {
    className: "symbol",
    begin: /&[a-z]+;|&#[0-9]+;|&#x[a-f0-9]+;/
  }, s = {
    begin: /\s/,
    contains: [
      {
        className: "keyword",
        begin: /#?[a-z_][a-z1-9_-]+/,
        illegal: /\n/
      }
    ]
  }, o = n.inherit(s, {
    begin: /\(/,
    end: /\)/
  }), a = n.inherit(n.APOS_STRING_MODE, { className: "string" }), l = n.inherit(n.QUOTE_STRING_MODE, { className: "string" }), c = {
    endsWithParent: !0,
    illegal: /</,
    relevance: 0,
    contains: [
      {
        className: "attr",
        begin: r,
        relevance: 0
      },
      {
        begin: /=\s*/,
        relevance: 0,
        contains: [
          {
            className: "string",
            endsParent: !0,
            variants: [
              {
                begin: /"/,
                end: /"/,
                contains: [i]
              },
              {
                begin: /'/,
                end: /'/,
                contains: [i]
              },
              { begin: /[^\s"'=<>`]+/ }
            ]
          }
        ]
      }
    ]
  };
  return {
    name: "HTML, XML",
    aliases: [
      "html",
      "xhtml",
      "rss",
      "atom",
      "xjb",
      "xsd",
      "xsl",
      "plist",
      "wsf",
      "svg"
    ],
    case_insensitive: !0,
    unicodeRegex: !0,
    contains: [
      {
        className: "meta",
        begin: /<![a-z]/,
        end: />/,
        relevance: 10,
        contains: [
          s,
          l,
          a,
          o,
          {
            begin: /\[/,
            end: /\]/,
            contains: [
              {
                className: "meta",
                begin: /<![a-z]/,
                end: />/,
                contains: [
                  s,
                  o,
                  l,
                  a
                ]
              }
            ]
          }
        ]
      },
      n.COMMENT(
        /<!--/,
        /-->/,
        { relevance: 10 }
      ),
      {
        begin: /<!\[CDATA\[/,
        end: /\]\]>/,
        relevance: 10
      },
      i,
      // xml processing instructions
      {
        className: "meta",
        end: /\?>/,
        variants: [
          {
            begin: /<\?xml/,
            relevance: 10,
            contains: [
              l
            ]
          },
          {
            begin: /<\?[a-z][a-z0-9]+/
          }
        ]
      },
      {
        className: "tag",
        /*
        The lookahead pattern (?=...) ensures that 'begin' only matches
        '<style' as a single word, followed by a whitespace or an
        ending bracket.
        */
        begin: /<style(?=\s|>)/,
        end: />/,
        keywords: { name: "style" },
        contains: [c],
        starts: {
          end: /<\/style>/,
          returnEnd: !0,
          subLanguage: [
            "css",
            "xml"
          ]
        }
      },
      {
        className: "tag",
        // See the comment in the <style tag about the lookahead pattern
        begin: /<script(?=\s|>)/,
        end: />/,
        keywords: { name: "script" },
        contains: [c],
        starts: {
          end: /<\/script>/,
          returnEnd: !0,
          subLanguage: [
            "javascript",
            "handlebars",
            "xml"
          ]
        }
      },
      // we need this for now for jSX
      {
        className: "tag",
        begin: /<>|<\/>/
      },
      // open tag
      {
        className: "tag",
        begin: e.concat(
          /</,
          e.lookahead(e.concat(
            t,
            // <tag/>
            // <tag>
            // <tag ...
            e.either(/\/>/, />/, /\s/)
          ))
        ),
        end: /\/?>/,
        contains: [
          {
            className: "name",
            begin: t,
            relevance: 0,
            starts: c
          }
        ]
      },
      // close tag
      {
        className: "tag",
        begin: e.concat(
          /<\//,
          e.lookahead(e.concat(
            t,
            />/
          ))
        ),
        contains: [
          {
            className: "name",
            begin: t,
            relevance: 0
          },
          {
            begin: />/,
            relevance: 0,
            endsParent: !0
          }
        ]
      }
    ]
  };
}
function rht(n) {
  const e = "true false yes no null", t = "[\\w#;/?:@&=+$,.~*'()[\\]]+", r = {
    className: "attr",
    variants: [
      // added brackets support and special char support
      { begin: /[\w*@][\w*@ :()\./-]*:(?=[ \t]|$)/ },
      {
        // double quoted keys - with brackets and special char support
        begin: /"[\w*@][\w*@ :()\./-]*":(?=[ \t]|$)/
      },
      {
        // single quoted keys - with brackets and special char support
        begin: /'[\w*@][\w*@ :()\./-]*':(?=[ \t]|$)/
      }
    ]
  }, i = {
    className: "template-variable",
    variants: [
      {
        // jinja templates Ansible
        begin: /\{\{/,
        end: /\}\}/
      },
      {
        // Ruby i18n
        begin: /%\{/,
        end: /\}/
      }
    ]
  }, s = {
    className: "string",
    relevance: 0,
    begin: /'/,
    end: /'/,
    contains: [
      {
        match: /''/,
        scope: "char.escape",
        relevance: 0
      }
    ]
  }, o = {
    className: "string",
    relevance: 0,
    variants: [
      {
        begin: /"/,
        end: /"/
      },
      { begin: /\S+/ }
    ],
    contains: [
      n.BACKSLASH_ESCAPE,
      i
    ]
  }, a = n.inherit(o, { variants: [
    {
      begin: /'/,
      end: /'/,
      contains: [
        {
          begin: /''/,
          relevance: 0
        }
      ]
    },
    {
      begin: /"/,
      end: /"/
    },
    { begin: /[^\s,{}[\]]+/ }
  ] }), f = {
    className: "number",
    begin: "\\b" + "[0-9]{4}(-[0-9][0-9]){0,2}" + "([Tt \\t][0-9][0-9]?(:[0-9][0-9]){2})?" + "(\\.[0-9]*)?" + "([ \\t])*(Z|[-+][0-9][0-9]?(:[0-9][0-9])?)?" + "\\b"
  }, h = {
    end: ",",
    endsWithParent: !0,
    excludeEnd: !0,
    keywords: e,
    relevance: 0
  }, m = {
    begin: /\{/,
    end: /\}/,
    contains: [h],
    illegal: "\\n",
    relevance: 0
  }, g = {
    begin: "\\[",
    end: "\\]",
    contains: [h],
    illegal: "\\n",
    relevance: 0
  }, v = [
    r,
    {
      className: "meta",
      begin: "^---\\s*$",
      relevance: 10
    },
    {
      // multi line string
      // Blocks start with a | or > followed by a newline
      //
      // Indentation of subsequent lines must be the same to
      // be considered part of the block
      className: "string",
      begin: "[\\|>]([1-9]?[+-])?[ ]*\\n( +)[^ ][^\\n]*\\n(\\2[^\\n]+\\n?)*"
    },
    {
      // Ruby/Rails erb
      begin: "<%[%=-]?",
      end: "[%-]?%>",
      subLanguage: "ruby",
      excludeBegin: !0,
      excludeEnd: !0,
      relevance: 0
    },
    {
      // named tags
      className: "type",
      begin: "!\\w+!" + t
    },
    // https://yaml.org/spec/1.2/spec.html#id2784064
    {
      // verbatim tags
      className: "type",
      begin: "!<" + t + ">"
    },
    {
      // primary tags
      className: "type",
      begin: "!" + t
    },
    {
      // secondary tags
      className: "type",
      begin: "!!" + t
    },
    {
      // fragment id &ref
      className: "meta",
      begin: "&" + n.UNDERSCORE_IDENT_RE + "$"
    },
    {
      // fragment reference *ref
      className: "meta",
      begin: "\\*" + n.UNDERSCORE_IDENT_RE + "$"
    },
    {
      // array listing
      className: "bullet",
      // TODO: remove |$ hack when we have proper look-ahead support
      begin: "-(?=[ ]|$)",
      relevance: 0
    },
    n.HASH_COMMENT_MODE,
    {
      beginKeywords: e,
      keywords: { literal: e }
    },
    f,
    // numbers are any valid C-style number that
    // sit isolated from other words
    {
      className: "number",
      begin: n.C_NUMBER_RE + "\\b",
      relevance: 0
    },
    m,
    g,
    s,
    o
  ], y = [...v];
  return y.pop(), y.push(a), h.contains = y, {
    name: "YAML",
    case_insensitive: !0,
    aliases: ["yml"],
    contains: v
  };
}
const iht = {
  arduino: Bdt,
  bash: zdt,
  c: Hdt,
  cpp: Udt,
  csharp: Vdt,
  css: Qdt,
  diff: Jdt,
  go: eft,
  graphql: tft,
  ini: nft,
  java: rft,
  javascript: lft,
  json: cft,
  kotlin: dft,
  less: bft,
  lua: wft,
  makefile: xft,
  markdown: Eft,
  objectivec: Sft,
  perl: Cft,
  php: Tft,
  "php-template": Aft,
  plaintext: Mft,
  python: kft,
  "python-repl": _ft,
  r: Oft,
  ruby: Ift,
  rust: Rft,
  scss: Hft,
  shell: Uft,
  sql: Vft,
  swift: Zft,
  typescript: Jft,
  vbnet: eht,
  wasm: tht,
  xml: nht,
  yaml: rht
}, uj = {}, sht = "hljs-";
function oht(n) {
  const e = Oae.newInstance();
  return n && s(n), {
    highlight: t,
    highlightAuto: r,
    listLanguages: i,
    register: s,
    registerAlias: o,
    registered: a
  };
  function t(l, c, u) {
    const d = u || uj, f = typeof d.prefix == "string" ? d.prefix : sht;
    if (!e.getLanguage(l))
      throw new Error("Unknown language: `" + l + "` is not registered");
    e.configure({ __emitter: aht, classPrefix: f });
    const h = (
      /** @type {HighlightResult & {_emitter: HastEmitter}} */
      e.highlight(c, { ignoreIllegals: !0, language: l })
    );
    if (h.errorRaised)
      throw new Error("Could not highlight with `Highlight.js`", {
        cause: h.errorRaised
      });
    const m = h._emitter.root, g = (
      /** @type {RootData} */
      m.data
    );
    return g.language = h.language, g.relevance = h.relevance, m;
  }
  function r(l, c) {
    const d = (c || uj).subset || i();
    let f = -1, h = 0, m;
    for (; ++f < d.length; ) {
      const g = d[f];
      if (!e.getLanguage(g)) continue;
      const v = t(g, l, c);
      v.data && v.data.relevance !== void 0 && v.data.relevance > h && (h = v.data.relevance, m = v);
    }
    return m || {
      type: "root",
      children: [],
      data: { language: void 0, relevance: h }
    };
  }
  function i() {
    return e.listLanguages();
  }
  function s(l, c) {
    if (typeof l == "string")
      e.registerLanguage(l, c);
    else {
      let u;
      for (u in l)
        Object.hasOwn(l, u) && e.registerLanguage(u, l[u]);
    }
  }
  function o(l, c) {
    if (typeof l == "string")
      e.registerAliases(
        // Note: copy needed because hljs doesn’t accept readonly arrays yet.
        typeof c == "string" ? c : [...c],
        { languageName: l }
      );
    else {
      let u;
      for (u in l)
        if (Object.hasOwn(l, u)) {
          const d = l[u];
          e.registerAliases(
            // Note: copy needed because hljs doesn’t accept readonly arrays yet.
            typeof d == "string" ? d : [...d],
            { languageName: u }
          );
        }
    }
  }
  function a(l) {
    return !!e.getLanguage(l);
  }
}
class aht {
  /**
   * @param {Readonly<HljsOptions>} options
   *   Configuration.
   * @returns
   *   Instance.
   */
  constructor(e) {
    this.options = e, this.root = {
      type: "root",
      children: [],
      data: { language: void 0, relevance: 0 }
    }, this.stack = [this.root];
  }
  /**
   * @param {string} value
   *   Text to add.
   * @returns {undefined}
   *   Nothing.
   *
   */
  addText(e) {
    if (e === "") return;
    const t = this.stack[this.stack.length - 1], r = t.children[t.children.length - 1];
    r && r.type === "text" ? r.value += e : t.children.push({ type: "text", value: e });
  }
  /**
   *
   * @param {unknown} rawName
   *   Name to add.
   * @returns {undefined}
   *   Nothing.
   */
  startScope(e) {
    this.openNode(String(e));
  }
  /**
   * @returns {undefined}
   *   Nothing.
   */
  endScope() {
    this.closeNode();
  }
  /**
   * @param {HastEmitter} other
   *   Other emitter.
   * @param {string} name
   *   Name of the sublanguage.
   * @returns {undefined}
   *   Nothing.
   */
  __addSublanguage(e, t) {
    const r = this.stack[this.stack.length - 1], i = (
      /** @type {Array<ElementContent>} */
      e.root.children
    );
    t ? r.children.push({
      type: "element",
      tagName: "span",
      properties: { className: [t] },
      children: i
    }) : r.children.push(...i);
  }
  /**
   * @param {string} name
   *   Name to add.
   * @returns {undefined}
   *   Nothing.
   */
  openNode(e) {
    const t = this, r = e.split(".").map(function(o, a) {
      return a ? o + "_".repeat(a) : t.options.classPrefix + o;
    }), i = this.stack[this.stack.length - 1], s = {
      type: "element",
      tagName: "span",
      properties: { className: r },
      children: []
    };
    i.children.push(s), this.stack.push(s);
  }
  /**
   * @returns {undefined}
   *   Nothing.
   */
  closeNode() {
    this.stack.pop();
  }
  /**
   * @returns {undefined}
   *   Nothing.
   */
  finalize() {
  }
  /**
   * @returns {string}
   *   Nothing.
   */
  toHTML() {
    return "";
  }
}
const lht = $dt.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      lowlight: oht(iht),
      defaultLanguage: null,
      HTMLAttributes: {
        class: "block-node"
      }
    };
  }
}), cht = _ae.extend({
  addProseMirrorPlugins() {
    return [
      ...this.parent?.() || [],
      new Cn({
        props: {
          handleKeyDown: (n, e) => (e.key === "Enter" && this.editor.commands.unsetColor(), !1)
        }
      })
    ];
  }
}), uht = tae.extend({
  addKeyboardShortcuts() {
    return {
      "Mod-Alt--": () => this.editor.commands.insertContent({
        type: this.name
      })
    };
  }
});
var dht = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, fht = Yi.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {}
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: n }) {
    return ["img", Zn(this.options.HTMLAttributes, n)];
  },
  parseMarkdown: (n, e) => e.createNode("image", {
    src: n.href,
    title: n.title,
    alt: n.text
  }),
  renderMarkdown: (n) => {
    var e, t, r, i, s, o;
    const a = (t = (e = n.attrs) == null ? void 0 : e.src) != null ? t : "", l = (i = (r = n.attrs) == null ? void 0 : r.alt) != null ? i : "", c = (o = (s = n.attrs) == null ? void 0 : s.title) != null ? o : "";
    return c ? `![${l}](${a} "${c}")` : `![${l}](${a})`;
  },
  addCommands() {
    return {
      setImage: (n) => ({ commands: e }) => e.insertContent({
        type: this.name,
        attrs: n
      })
    };
  },
  addInputRules() {
    return [
      Moe({
        find: dht,
        type: this.type,
        getAttributes: (n) => {
          const [, , e, t, r] = n;
          return { src: t, alt: e, title: r };
        }
      })
    ];
  }
});
function hht({
  initialWidth: n,
  initialHeight: e,
  contentWidth: t,
  contentHeight: r,
  gridInterval: i,
  minWidth: s,
  minHeight: o,
  maxWidth: a,
  onDimensionsChange: l
}) {
  const [c, u] = wt({
    width: Math.max(n ?? s, s),
    height: Math.max(e ?? o, o)
  }), [d, f] = wt(1 / 0), [h, m] = wt(0), [g, v] = wt(c), [y, b] = wt(), x = Ft(
    (M, k) => {
      const _ = Math.max(
        s,
        Math.min(
          t ?? s,
          i / 100 * k
        )
      );
      return Math.min(
        k,
        Math.max(M, _)
      );
    },
    [i, t, s]
  ), E = Ft(
    (M) => {
      M.preventDefault();
      const k = (y === "left" ? h - M.pageX : M.pageX - h) * 2, _ = i / 100 * d, O = g.width + k, I = Math.round(O / _) * _, R = x(I, d), P = r && t ? r / t : 1;
      u({
        width: Math.max(R, s),
        height: Math.max(
          t ? R * P : r ?? o,
          o
        )
      });
    },
    [
      x,
      y,
      d,
      h,
      i,
      r,
      t,
      g.width,
      s,
      o
    ]
  ), w = Ft(
    (M) => {
      M.preventDefault(), M.stopPropagation(), m(0), b(void 0), l?.(c);
    },
    [l, c]
  ), C = Ft(
    (M) => {
      M.key === "Escape" && (M.preventDefault(), M.stopPropagation(), u({
        width: Math.max(g.width, s),
        height: Math.max(g.height, o)
      }), b(void 0));
    },
    [g, s, o]
  ), S = Ft(
    (M) => (k) => {
      k.preventDefault(), k.stopPropagation(), f(a), v({
        width: Math.max(
          x(c.width, a),
          s
        ),
        height: Math.max(c.height, o)
      }), m(k.pageX), b(M);
    },
    [
      a,
      x,
      c.width,
      c.height,
      s,
      o
    ]
  );
  return Tt(() => {
    if (y)
      return document.addEventListener("keydown", C), document.addEventListener("pointermove", E), document.addEventListener("pointerup", w), () => {
        document.removeEventListener("keydown", C), document.removeEventListener("pointermove", E), document.removeEventListener("pointerup", w);
      };
  }, [y, C, E, w]), {
    initiateResize: S,
    isResizing: !!y,
    updateDimensions: u,
    currentWidth: Math.max(c.width, s),
    currentHeight: Math.max(c.height, o)
  };
}
const C9 = ({
  ref: n,
  className: e,
  isResizing: t = !1,
  ...r
}) => /* @__PURE__ */ T(
  "div",
  {
    className: Q(
      "tw:absolute tw:top-1/2 tw:h-10 tw:max-h-full tw:w-1.5 tw:-translate-y-1/2 tw:transform tw:cursor-col-resize tw:rounded tw:border tw:border-solid tw:border-(--mt-transparent-foreground) tw:bg-(--mt-bg-secondary) tw:p-px tw:transition-all",
      "tw:opacity-0 tw:[backdrop-filter:saturate(1.8)_blur(20px)]",
      {
        "opacity-80": t,
        "group-hover/node-image:opacity-80": !t
      },
      "tw:before:absolute tw:before:inset-y-0 tw:before:-right-1 tw:before:-left-1",
      e
    ),
    ref: n,
    ...r
  }
);
C9.displayName = "ResizeHandle";
function pht() {
  return p.createElement(
    "svg",
    { "aria-hidden": "true", "data-rmiz-btn-unzoom-icon": !0, fill: "currentColor", focusable: "false", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" },
    p.createElement("path", { d: "M 14.144531 1.148438 L 9 6.292969 L 9 3 L 8 3 L 8 8 L 13 8 L 13 7 L 9.707031 7 L 14.855469 1.851563 Z M 8 8 L 3 8 L 3 9 L 6.292969 9 L 1.148438 14.144531 L 1.851563 14.855469 L 7 9.707031 L 7 13 L 8 13 Z" })
  );
}
function mht() {
  return p.createElement(
    "svg",
    { "aria-hidden": "true", "data-rmiz-btn-zoom-icon": !0, fill: "currentColor", focusable: "false", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" },
    p.createElement("path", { d: "M 9 1 L 9 2 L 12.292969 2 L 2 12.292969 L 2 9 L 1 9 L 1 14 L 6 14 L 6 13 L 2.707031 13 L 13 2.707031 L 13 6 L 14 6 L 14 1 Z" })
  );
}
const Bb = (n, e) => n === e?.tagName?.toUpperCase?.(), NO = (n) => Bb("DIV", n) || Bb("SPAN", n), zb = (n) => Bb("IMG", n), dj = (n) => n.complete && n.naturalHeight !== 0, r2 = (n) => Bb("SVG", n), Yae = ({ height: n, offset: e, width: t }) => Math.min((window.innerWidth - e * 2) / t, (window.innerHeight - e * 2) / n), ght = ({ containerHeight: n, containerWidth: e, offset: t, targetHeight: r, targetWidth: i }) => {
  const s = Yae({
    height: r,
    offset: t,
    width: i
  }), o = i > r ? i / e : r / n;
  return s > 1 ? o : s * o;
}, ku = ({ containerHeight: n, containerWidth: e, hasScalableSrc: t, offset: r, targetHeight: i, targetWidth: s }) => !n || !e ? 1 : !t && i && s ? ght({
  containerHeight: n,
  containerWidth: e,
  offset: r,
  targetHeight: i,
  targetWidth: s
}) : Yae({
  height: n,
  offset: r,
  width: e
}), vht = /url(?:\(['"]?)(.*?)(?:['"]?\))/, fj = (n) => {
  if (n) {
    if (zb(n))
      return n.currentSrc;
    if (NO(n)) {
      const e = window.getComputedStyle(n).backgroundImage;
      if (e)
        return vht.exec(e)?.[1];
    }
  }
}, yht = (n) => {
  if (n)
    return zb(n) ? n.alt ?? void 0 : n.getAttribute("aria-label") ?? void 0;
}, bht = ({ containerHeight: n, containerLeft: e, containerTop: t, containerWidth: r, hasScalableSrc: i, offset: s, targetHeight: o, targetWidth: a }) => {
  const l = ku({
    containerHeight: n,
    containerWidth: r,
    hasScalableSrc: i,
    offset: s,
    targetHeight: o,
    targetWidth: a
  });
  return {
    top: t,
    left: e,
    width: r * l,
    height: n * l,
    transform: `translate(0,0) scale(${1 / l})`
  };
}, Ms = ({ position: n, relativeNum: e }) => {
  const t = parseFloat(n);
  return n.endsWith("%") ? e * t / 100 : t;
}, wht = ({ containerHeight: n, containerLeft: e, containerTop: t, containerWidth: r, hasScalableSrc: i, objectFit: s, objectPosition: o, offset: a, targetHeight: l, targetWidth: c }) => {
  if (s === "scale-down" && (c <= r && l <= n ? s = "none" : s = "contain"), s === "cover" || s === "contain") {
    const u = r / c, d = n / l, f = s === "cover" ? Math.max(u, d) : Math.min(u, d), [h = "50%", m = "50%"] = o.split(" "), g = Ms({ position: h, relativeNum: r - c * f }), v = Ms({ position: m, relativeNum: n - l * f }), y = ku({
      containerHeight: l * f,
      containerWidth: c * f,
      hasScalableSrc: i,
      offset: a,
      targetHeight: l,
      targetWidth: c
    });
    return {
      top: t + v,
      left: e + g,
      width: c * f * y,
      height: l * f * y,
      transform: `translate(0,0) scale(${1 / y})`
    };
  } else if (s === "none") {
    const [u = "50%", d = "50%"] = o.split(" "), f = Ms({ position: u, relativeNum: r - c }), h = Ms({ position: d, relativeNum: n - l }), m = ku({
      containerHeight: l,
      containerWidth: c,
      hasScalableSrc: i,
      offset: a,
      targetHeight: l,
      targetWidth: c
    });
    return {
      top: t + h,
      left: e + f,
      width: c * m,
      height: l * m,
      transform: `translate(0,0) scale(${1 / m})`
    };
  } else if (s === "fill") {
    const u = r / c, d = n / l, f = Math.max(u, d), h = ku({
      containerHeight: l * f,
      containerWidth: c * f,
      hasScalableSrc: i,
      offset: a,
      targetHeight: l,
      targetWidth: c
    });
    return {
      width: r * h,
      height: n * h,
      transform: `translate(0,0) scale(${1 / h})`
    };
  } else
    return {};
}, xht = ({ backgroundPosition: n, backgroundSize: e, containerHeight: t, containerLeft: r, containerTop: i, containerWidth: s, hasScalableSrc: o, offset: a, targetHeight: l, targetWidth: c }) => {
  if (e === "cover" || e === "contain") {
    const u = s / c, d = t / l, f = e === "cover" ? Math.max(u, d) : Math.min(u, d), [h = "50%", m = "50%"] = n.split(" "), g = Ms({ position: h, relativeNum: s - c * f }), v = Ms({ position: m, relativeNum: t - l * f }), y = ku({
      containerHeight: l * f,
      containerWidth: c * f,
      hasScalableSrc: o,
      offset: a,
      targetHeight: l,
      targetWidth: c
    });
    return {
      top: i + v,
      left: r + g,
      width: c * f * y,
      height: l * f * y,
      transform: `translate(0,0) scale(${1 / y})`
    };
  } else if (e === "auto") {
    const [u = "50%", d = "50%"] = n.split(" "), f = Ms({ position: u, relativeNum: s - c }), h = Ms({ position: d, relativeNum: t - l }), m = ku({
      containerHeight: l,
      containerWidth: c,
      hasScalableSrc: o,
      offset: a,
      targetHeight: l,
      targetWidth: c
    });
    return {
      top: i + h,
      left: r + f,
      width: c * m,
      height: l * m,
      transform: `translate(0,0) scale(${1 / m})`
    };
  } else {
    const [u = "50%", d = "50%"] = e.split(" "), f = Ms({ position: u, relativeNum: s }), h = Ms({ position: d, relativeNum: t }), m = f / c, g = h / l, v = Math.min(m, g), [y = "50%", b = "50%"] = n.split(" "), x = Ms({ position: y, relativeNum: s - c * v }), E = Ms({ position: b, relativeNum: t - l * v }), w = ku({
      containerHeight: l * v,
      containerWidth: c * v,
      hasScalableSrc: o,
      offset: a,
      targetHeight: l,
      targetWidth: c
    });
    return {
      top: i + E,
      left: r + x,
      width: c * v * w,
      height: l * v * w,
      transform: `translate(0,0) scale(${1 / w})`
    };
  }
}, Eht = /\.svg$/i, Sht = ({ hasZoomImg: n, imgSrc: e, isSvg: t, isZoomed: r, loadedImgEl: i, offset: s, shouldRefresh: o, targetEl: a }) => {
  const l = t || e?.slice?.(0, 18) === "data:image/svg+xml" || n || !!(e && Eht.test(e)), c = a.getBoundingClientRect(), u = window.getComputedStyle(a), d = i != null && NO(a), f = i != null && !d, h = bht({
    containerHeight: c.height,
    containerLeft: c.left,
    containerTop: c.top,
    containerWidth: c.width,
    hasScalableSrc: l,
    offset: s,
    targetHeight: i?.naturalHeight || c.height,
    targetWidth: i?.naturalWidth || c.width
  }), m = f ? wht({
    containerHeight: c.height,
    containerLeft: c.left,
    containerTop: c.top,
    containerWidth: c.width,
    hasScalableSrc: l,
    objectFit: u.objectFit,
    objectPosition: u.objectPosition,
    offset: s,
    targetHeight: i?.naturalHeight || c.height,
    targetWidth: i?.naturalWidth || c.width
  }) : void 0, g = d ? xht({
    backgroundPosition: u.backgroundPosition,
    backgroundSize: u.backgroundSize,
    containerHeight: c.height,
    containerLeft: c.left,
    containerTop: c.top,
    containerWidth: c.width,
    hasScalableSrc: l,
    offset: s,
    targetHeight: i?.naturalHeight || c.height,
    targetWidth: i?.naturalWidth || c.width
  }) : void 0, v = Object.assign({}, h, m, g);
  if (r) {
    const y = window.innerWidth / 2, b = window.innerHeight / 2, x = parseFloat(String(v.left || 0)) + parseFloat(String(v.width || 0)) / 2, E = parseFloat(String(v.top || 0)) + parseFloat(String(v.height || 0)) / 2, w = y - x, C = b - E;
    o && (v.transitionDuration = "0.01ms"), v.transform = `translate(${w}px,${C}px) scale(1)`;
  }
  return v;
}, _8 = (n) => {
  if (!n)
    return {};
  if (r2(n)) {
    const e = n.parentElement, t = n.getBoundingClientRect();
    if (e) {
      const r = e.getBoundingClientRect();
      return {
        height: t.height,
        left: r.left - t.left,
        top: r.top - t.top,
        width: t.width
      };
    } else
      return {
        height: t.height,
        left: t.left,
        width: t.width,
        top: t.top
      };
  } else
    return {
      height: n.offsetHeight,
      left: n.offsetLeft,
      width: n.offsetWidth,
      top: n.offsetTop
    };
}, Cht = (n) => {
  const e = "-zoom", t = [
    "clip-path",
    "fill",
    "mask",
    "marker-start",
    "marker-mid",
    "marker-end"
  ], r = /* @__PURE__ */ new Map();
  if (n.hasAttribute("id")) {
    const i = n.id, s = i + e;
    r.set(i, s), n.id = s;
  }
  n.querySelectorAll("[id]").forEach((i) => {
    const s = i.id, o = s + e;
    r.set(s, o), i.id = o;
  }), r.forEach((i, s) => {
    const o = `url(#${s})`, a = `url(#${i})`, l = t.map((c) => `[${c}="${o}"]`).join(", ");
    n.querySelectorAll(l).forEach((c) => {
      t.forEach((u) => {
        c.getAttribute(u) === o && c.setAttribute(u, a);
      });
    });
  }), n.querySelectorAll("style").forEach((i) => {
    r.forEach((s, o) => {
      i.textContent && (i.textContent = i.textContent.replaceAll(`#${o}`, `#${s}`));
    });
  });
}, Tht = ["img", "svg", '[role="img"]', "[data-zoom]"].map((n) => `${n}:not([aria-hidden="true"])`).join(","), hj = {
  overflow: "",
  width: ""
};
function Aht(n) {
  return p.createElement(Xae, { ...n });
}
class Xae extends p.Component {
  constructor() {
    super(...arguments), this.state = {
      id: "",
      isZoomImgLoaded: !1,
      loadedImgEl: void 0,
      modalState: "UNLOADED",
      shouldRefresh: !1,
      styleGhost: {}
    }, this.refContent = p.createRef(), this.refDialog = p.createRef(), this.refModalContent = p.createRef(), this.refModalImg = p.createRef(), this.refWrap = p.createRef(), this.imgEl = null, this.isScaling = !1, this.prevBodyAttrs = hj, this.styleModalImg = {}, this.handleModalStateChange = (e) => {
      const { modalState: t } = this.state;
      e !== "LOADING" && t === "LOADING" ? (this.loadZoomImg(), window.addEventListener("resize", this.handleResize, { passive: !0 }), window.addEventListener("touchstart", this.handleTouchStart, { passive: !0 }), window.addEventListener("touchmove", this.handleTouchMove, { passive: !0 }), window.addEventListener("touchend", this.handleTouchEnd, { passive: !0 }), window.addEventListener("touchcancel", this.handleTouchCancel, { passive: !0 }), document.addEventListener("keydown", this.handleKeyDown, !0)) : e !== "LOADED" && t === "LOADED" ? window.addEventListener("wheel", this.handleWheel, { passive: !0 }) : e !== "UNLOADING" && t === "UNLOADING" ? (this.ensureImgTransitionEnd(), window.removeEventListener("wheel", this.handleWheel), window.removeEventListener("touchstart", this.handleTouchStart), window.removeEventListener("touchmove", this.handleTouchMove), window.removeEventListener("touchend", this.handleTouchEnd), window.removeEventListener("touchcancel", this.handleTouchCancel), document.removeEventListener("keydown", this.handleKeyDown, !0)) : e !== "UNLOADED" && t === "UNLOADED" && (this.bodyScrollEnable(), window.removeEventListener("resize", this.handleResize), this.refModalImg.current?.removeEventListener?.("transitionend", this.handleImgTransitionEnd), this.refDialog.current?.close?.());
    }, this.getDialogContainer = () => {
      let e = document.querySelector("[data-rmiz-portal]");
      return e == null && (e = document.createElement("div"), e.setAttribute("data-rmiz-portal", ""), document.body.appendChild(e)), e;
    }, this.setId = () => {
      const e = () => Math.random().toString(16).slice(-4);
      this.setState({ id: e() + e() + e() });
    }, this.setAndTrackImg = () => {
      const e = this.refContent.current;
      e && (this.imgEl = e.querySelector(Tht), this.imgEl ? (this.contentNotFoundChangeObserver?.disconnect?.(), this.imgEl.addEventListener("load", this.handleImgLoad), this.imgEl.addEventListener("click", this.handleZoom), this.state.loadedImgEl || this.handleImgLoad(), this.imgElResizeObserver = new ResizeObserver((t) => {
        const r = t[0];
        r?.target && (this.imgEl = r.target, this.setState({ styleGhost: _8(this.imgEl) }));
      }), this.imgElResizeObserver.observe(this.imgEl), this.contentChangeObserver || (this.contentChangeObserver = new MutationObserver(() => {
        this.setState({ styleGhost: _8(this.imgEl) });
      }), this.contentChangeObserver.observe(e, { attributes: !0, childList: !0, subtree: !0 }))) : this.contentNotFoundChangeObserver || (this.contentNotFoundChangeObserver = new MutationObserver(this.setAndTrackImg), this.contentNotFoundChangeObserver.observe(e, { childList: !0, subtree: !0 })));
    }, this.handleIfZoomChanged = (e) => {
      const { isZoomed: t } = this.props;
      !e && t ? this.zoom() : e && !t && this.unzoom();
    }, this.handleImgLoad = () => {
      const e = fj(this.imgEl);
      if (!e)
        return;
      const t = new Image();
      zb(this.imgEl) && (t.sizes = this.imgEl.sizes, t.srcset = this.imgEl.srcset, t.crossOrigin = this.imgEl.crossOrigin), t.src = e;
      const r = () => {
        this.setState({
          loadedImgEl: t,
          styleGhost: _8(this.imgEl)
        });
      };
      t.decode().then(r).catch(() => {
        if (dj(t)) {
          r();
          return;
        }
        t.onload = r;
      });
    }, this.handleZoom = (e) => {
      !this.props.isDisabled && this.hasImage() && this.props.onZoomChange?.(!0, { event: e });
    }, this.handleUnzoom = (e) => {
      this.props.isDisabled || this.props.onZoomChange?.(!1, { event: e });
    }, this.handleBtnUnzoomClick = (e) => {
      e.preventDefault(), e.stopPropagation(), this.handleUnzoom(e);
    }, this.handleDialogCancel = (e) => {
      e.preventDefault();
    }, this.handleDialogClick = (e) => {
      (e.target === this.refModalContent.current || e.target === this.refModalImg.current) && (e.stopPropagation(), this.handleUnzoom(e));
    }, this.handleDialogClose = (e) => {
      e.stopPropagation(), this.handleUnzoom(e);
    }, this.handleKeyDown = (e) => {
      (e.key === "Escape" || e.keyCode === 27) && (e.preventDefault(), e.stopPropagation(), this.handleUnzoom(e));
    }, this.handleWheel = (e) => {
      e.ctrlKey || (e.stopPropagation(), queueMicrotask(() => {
        this.handleUnzoom(e);
      }));
    }, this.handleTouchStart = (e) => {
      if (e.touches.length > 1) {
        this.isScaling = !0;
        return;
      }
      e.changedTouches.length === 1 && e.changedTouches[0] && (this.touchYStart = e.changedTouches[0].screenY);
    }, this.handleTouchMove = (e) => {
      const t = window.visualViewport?.scale ?? 1;
      if (this.props.canSwipeToUnzoom && !this.isScaling && t <= 1 && this.touchYStart != null && e.changedTouches[0]) {
        this.touchYEnd = e.changedTouches[0].screenY;
        const r = Math.max(this.touchYStart, this.touchYEnd), i = Math.min(this.touchYStart, this.touchYEnd);
        Math.abs(r - i) > this.props.swipeToUnzoomThreshold && (this.touchYStart = void 0, this.touchYEnd = void 0, this.handleUnzoom(e));
      }
    }, this.handleTouchEnd = () => {
      this.isScaling = !1, this.touchYStart = void 0, this.touchYEnd = void 0;
    }, this.handleTouchCancel = () => {
      this.isScaling = !1, this.touchYStart = void 0, this.touchYEnd = void 0;
    }, this.handleResize = () => {
      this.setState({ shouldRefresh: !0 });
    }, this.hasImage = () => this.imgEl && (this.state.loadedImgEl || r2(this.imgEl)) && window.getComputedStyle(this.imgEl).display !== "none", this.zoom = () => {
      this.bodyScrollDisable(), this.refDialog.current?.showModal?.(), this.refModalImg.current?.addEventListener?.("transitionend", this.handleImgTransitionEnd), this.setState({ modalState: "LOADING" });
    }, this.unzoom = () => {
      this.setState({ modalState: "UNLOADING" });
    }, this.handleImgTransitionEnd = () => {
      clearTimeout(this.timeoutTransitionEnd), this.state.modalState === "LOADING" ? this.setState({ modalState: "LOADED" }) : this.state.modalState === "UNLOADING" && this.setState({ shouldRefresh: !1, modalState: "UNLOADED" });
    }, this.ensureImgTransitionEnd = () => {
      if (this.refModalImg.current) {
        const e = window.getComputedStyle(this.refModalImg.current).transitionDuration, t = parseFloat(e);
        if (t) {
          const r = t * (e.endsWith("ms") ? 1 : 1e3) + 50;
          this.timeoutTransitionEnd = setTimeout(this.handleImgTransitionEnd, r);
        }
      }
    }, this.bodyScrollDisable = () => {
      this.prevBodyAttrs = {
        overflow: document.body.style.overflow,
        width: document.body.style.width
      };
      const e = document.body.clientWidth;
      document.body.style.overflow = "hidden", document.body.style.width = `${e}px`;
    }, this.bodyScrollEnable = () => {
      document.body.style.width = this.prevBodyAttrs.width, document.body.style.overflow = this.prevBodyAttrs.overflow, this.prevBodyAttrs = hj;
    }, this.loadZoomImg = () => {
      const { props: { zoomImg: e } } = this, t = e?.src;
      if (t) {
        const r = new Image();
        r.sizes = e?.sizes ?? "", r.srcset = e?.srcSet ?? "", r.crossOrigin = e?.crossOrigin ?? void 0, r.src = t;
        const i = () => {
          this.setState({ isZoomImgLoaded: !0 });
        };
        r.decode().then(i).catch(() => {
          if (dj(r)) {
            i();
            return;
          }
          r.onload = i;
        });
      }
    }, this.UNSAFE_handleSvg = () => {
      const { imgEl: e, refModalImg: t, styleModalImg: r } = this;
      if (r2(e)) {
        const i = e.cloneNode(!0);
        Cht(i), i.style.width = `${r.width || 0}px`, i.style.height = `${r.height || 0}px`, i.addEventListener("click", this.handleUnzoom), t.current?.firstChild?.remove?.(), t.current?.appendChild?.(i);
      }
    };
  }
  render() {
    const { handleBtnUnzoomClick: e, handleDialogCancel: t, handleDialogClick: r, handleDialogClose: i, handleUnzoom: s, handleZoom: o, imgEl: a, props: { a11yNameButtonUnzoom: l, a11yNameButtonZoom: c, children: u, classDialog: d, IconUnzoom: f, IconZoom: h, isZoomed: m, wrapElement: g, ZoomContent: v, zoomImg: y, zoomMargin: b }, refContent: x, refDialog: E, refModalContent: w, refModalImg: C, refWrap: S, state: { id: M, isZoomImgLoaded: k, loadedImgEl: _, modalState: O, shouldRefresh: I, styleGhost: R } } = this, P = `rmiz-modal-${M}`, D = `rmiz-modal-img-${M}`, L = NO(a), B = zb(a), $ = r2(a), z = yht(a), H = fj(a), U = B ? a.sizes : void 0, F = B ? a.srcset : void 0, V = B ? a.crossOrigin : void 0, X = !!y?.src, Z = this.hasImage(), ie = z ? `${c}: ${z}` : c, J = O === "LOADING" || O === "LOADED", se = Z ? "found" : "not-found", te = O === "UNLOADED" || O === "UNLOADING" ? "hidden" : "visible", le = {
      visibility: O === "UNLOADED" ? "visible" : "hidden"
    };
    this.styleModalImg = Z ? Sht({
      hasZoomImg: X,
      imgSrc: H,
      isSvg: $,
      isZoomed: m && J,
      loadedImgEl: _,
      offset: b,
      shouldRefresh: I,
      targetEl: a
    }) : {};
    let de = null;
    if (Z) {
      const j = B || L ? p.createElement("img", { alt: z, crossOrigin: V, sizes: U, src: H, srcSet: F, ...k && O === "LOADED" ? y : {}, "data-rmiz-modal-img": "", height: this.styleModalImg.height || void 0, id: D, ref: C, style: this.styleModalImg, width: this.styleModalImg.width || void 0 }) : $ ? p.createElement("div", { "data-rmiz-modal-img": !0, ref: C, style: this.styleModalImg }) : null, xe = p.createElement(
        "button",
        { "aria-label": l, "data-rmiz-btn-unzoom": "", onClick: e, type: "button" },
        p.createElement(f, null)
      );
      de = v ? p.createElement(v, { buttonUnzoom: xe, modalState: O, img: j, isZoomImgLoaded: k, onUnzoom: s }) : p.createElement(
        p.Fragment,
        null,
        j,
        xe
      );
    }
    return p.createElement(
      g,
      { "aria-owns": P, "data-rmiz": "", ref: S },
      p.createElement(g, { "data-rmiz-content": se, ref: x, style: le }, u),
      Z && p.createElement(
        g,
        { "data-rmiz-ghost": "", style: R },
        p.createElement(
          "button",
          { "aria-label": ie, "data-rmiz-btn-zoom": "", onClick: o, type: "button" },
          p.createElement(h, null)
        )
      ),
      Z && gw.createPortal(p.createElement(
        "dialog",
        { "aria-labelledby": D, "aria-modal": "true", className: d, "data-rmiz-modal": "", id: P, onClick: r, onClose: i, onCancel: t, ref: E, role: "dialog" },
        p.createElement("div", { "data-rmiz-modal-overlay": te }),
        p.createElement("div", { "data-rmiz-modal-content": "", ref: w }, de)
      ), this.getDialogContainer())
    );
  }
  componentDidMount() {
    this.setId(), this.setAndTrackImg(), this.handleImgLoad(), this.UNSAFE_handleSvg();
  }
  componentWillUnmount() {
    this.state.modalState !== "UNLOADED" && this.bodyScrollEnable(), this.contentChangeObserver?.disconnect?.(), this.contentNotFoundChangeObserver?.disconnect?.(), this.imgElResizeObserver?.disconnect?.(), this.imgEl?.removeEventListener?.("load", this.handleImgLoad), this.imgEl?.removeEventListener?.("click", this.handleZoom), this.refModalImg.current?.removeEventListener?.("transitionend", this.handleImgTransitionEnd), window.removeEventListener("wheel", this.handleWheel), window.removeEventListener("touchstart", this.handleTouchStart), window.removeEventListener("touchmove", this.handleTouchMove), window.removeEventListener("touchend", this.handleTouchEnd), window.removeEventListener("touchcancel", this.handleTouchCancel), window.removeEventListener("resize", this.handleResize), document.removeEventListener("keydown", this.handleKeyDown, !0);
  }
  componentDidUpdate(e, t) {
    this.handleModalStateChange(t.modalState), this.UNSAFE_handleSvg(), this.handleIfZoomChanged(e.isZoomed);
  }
}
Xae.defaultProps = {
  a11yNameButtonUnzoom: "Minimize image",
  a11yNameButtonZoom: "Expand image",
  canSwipeToUnzoom: !0,
  IconUnzoom: pht,
  IconZoom: mht,
  isDisabled: !1,
  swipeToUnzoomThreshold: 10,
  wrapElement: "div",
  zoomMargin: 0
};
const LO = ({
  children: n,
  className: e,
  ...t
}) => /* @__PURE__ */ T(
  "div",
  {
    className: Q(
      "tw:absolute tw:top-3 tw:right-3 tw:flex tw:flex-row tw:rounded tw:px-0.5 tw:opacity-0 tw:group-hover/node-image:opacity-100",
      "tw:border-[0.5px] tw:bg-(--mt-bg-secondary) tw:[backdrop-filter:saturate(1.8)_blur(20px)]",
      e
    ),
    ...t,
    children: n
  }
);
LO.displayName = "ActionWrapper";
const Hb = ({
  icon: n,
  tooltip: e,
  className: t,
  ...r
}) => /* @__PURE__ */ ee(H3, { children: [
  /* @__PURE__ */ T(U3, { asChild: !0, children: /* @__PURE__ */ T(
    Nt,
    {
      variant: "ghost",
      className: Q(
        "tw:text-muted-foreground tw:hover:text-foreground tw:relative tw:flex tw:h-7 tw:w-7 tw:flex-row tw:rounded-none tw:p-0",
        "tw:bg-transparent tw:hover:bg-transparent",
        t
      ),
      ...r,
      children: n
    }
  ) }),
  /* @__PURE__ */ T(R1, { side: "bottom", children: e })
] });
Hb.displayName = "ActionButton";
const Mht = [
  {
    key: "onView",
    icon: /* @__PURE__ */ T(zlt, {}),
    tooltip: "View image"
  },
  {
    key: "onDownload",
    icon: /* @__PURE__ */ T(ylt, {}),
    tooltip: "Download image"
  },
  {
    key: "onCopy",
    icon: /* @__PURE__ */ T(ult, {}),
    tooltip: "Copy image to clipboard"
  },
  {
    key: "onCopyLink",
    icon: /* @__PURE__ */ T(Loe, {}),
    tooltip: "Copy image link",
    isLink: !0
  }
], Zae = ({
  shouldMerge: n = !1,
  isLink: e = !1,
  ...t
}) => {
  const [r, i] = A.useState(!1), s = A.useCallback(
    (a, l) => {
      a.preventDefault(), a.stopPropagation(), l?.();
    },
    []
  ), o = A.useMemo(
    () => Mht.filter((a) => e || !a.isLink),
    [e]
  );
  return /* @__PURE__ */ T(LO, { className: Q({ "opacity-100": r }), children: n ? /* @__PURE__ */ ee(Bh, { open: r, onOpenChange: i, children: [
    /* @__PURE__ */ T(zh, { asChild: !0, children: /* @__PURE__ */ T(
      Hb,
      {
        icon: /* @__PURE__ */ T(Noe, {}),
        tooltip: "Open menu",
        onClick: (a) => a.preventDefault()
      }
    ) }),
    /* @__PURE__ */ T(dd, { className: "tw:w-56", align: "end", children: o.map(({ key: a, icon: l, tooltip: c }) => /* @__PURE__ */ T(
      xo,
      {
        onClick: (u) => s(u, t[a]),
        children: /* @__PURE__ */ ee("div", { className: "tw:flex tw:flex-row tw:items-center tw:gap-2", children: [
          l,
          /* @__PURE__ */ T("span", { children: c })
        ] })
      },
      a
    )) })
  ] }) : o.map(({ key: a, icon: l, tooltip: c }) => /* @__PURE__ */ T(
    Hb,
    {
      icon: l,
      tooltip: c,
      onClick: (u) => s(u, t[a])
    },
    a
  )) });
};
Zae.displayName = "ImageActions";
const kht = ({
  editor: n,
  node: e,
  src: t,
  onViewClick: r
}) => {
  const i = u9(t), s = A.useCallback(() => {
    r(!0);
  }, [r]), o = A.useCallback(() => {
    n.commands.downloadImage({ src: e.attrs.src, alt: e.attrs.alt });
  }, [n.commands, e.attrs.alt, e.attrs.src]), a = A.useCallback(() => {
    n.commands.copyImage({ src: e.attrs.src });
  }, [n.commands, e.attrs.src]), l = A.useCallback(() => {
    n.commands.copyLink({ src: e.attrs.src });
  }, [n.commands, e.attrs.src]), c = A.useCallback(() => {
    n.commands.command(({ tr: u, dispatch: d }) => {
      const { selection: f } = u, h = u.doc.nodeAt(f.from);
      return h && h.type.name === "image" && d ? (u.deleteSelection(), !0) : !1;
    });
  }, [n.commands]);
  return { isLink: i, onView: s, onDownload: o, onCopy: a, onCopyLink: l, onRemoveImg: c };
}, Qae = function({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ ee(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 24 24",
      className: Q("tw:animate-spin", e),
      ...t,
      children: [
        /* @__PURE__ */ T(
          "circle",
          {
            className: "tw:opacity-25",
            cx: "12",
            cy: "12",
            r: "10",
            stroke: "currentColor",
            strokeWidth: "4"
          }
        ),
        /* @__PURE__ */ T(
          "path",
          {
            className: "tw:opacity-75",
            fill: "currentColor",
            d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
          }
        )
      ]
    }
  );
};
Qae.displayName = "Spinner";
const Jae = A.memo(Qae), ele = A.memo(() => /* @__PURE__ */ T(
  "div",
  {
    className: Q(
      "tw:flex tw:flex-row tw:items-center tw:justify-center",
      "tw:absolute tw:inset-0 tw:rounded tw:bg-(--mt-overlay) tw:opacity-100 tw:transition-opacity"
    ),
    children: /* @__PURE__ */ T(Jae, { className: "tw:size-7" })
  }
));
ele.displayName = "ImageOverlay";
const O8 = 600, _ht = 120, pj = 120, Oht = (n) => ({
  src: typeof n == "string" ? n : n.src,
  id: typeof n == "string" ? ob() : n.id
}), Iht = ({
  editor: n,
  node: e,
  selected: t,
  updateAttributes: r
}) => {
  const {
    src: i,
    width: s,
    height: o,
    fileName: a
  } = e.attrs, l = A.useRef(!1), c = A.useMemo(() => typeof i == "string" ? i : i.src, [i]), [u, d] = A.useState({
    src: c,
    isServerUploading: !1,
    imageLoaded: !1,
    isZoomed: !1,
    error: !1,
    naturalSize: { width: s, height: o }
  }), f = A.useRef(null), [h, m] = A.useState(null), g = A.useCallback(
    ({ width: z, height: H }) => {
      r({ width: z, height: H });
    },
    [r]
  ), v = u.naturalSize.width / u.naturalSize.height, y = O8 * v, b = f.current ? parseFloat(
    getComputedStyle(f.current).getPropertyValue(
      "--editor-width"
    )
  ) : 1 / 0, { isLink: x, onView: E, onDownload: w, onCopy: C, onCopyLink: S, onRemoveImg: M } = kht({
    editor: n,
    node: e,
    src: u.src,
    onViewClick: (z) => d((H) => ({ ...H, isZoomed: z }))
  }), {
    currentWidth: k,
    currentHeight: _,
    updateDimensions: O,
    initiateResize: I,
    isResizing: R
  } = hht({
    initialWidth: s ?? u.naturalSize.width,
    initialHeight: o ?? u.naturalSize.height,
    contentWidth: u.naturalSize.width,
    contentHeight: u.naturalSize.height,
    gridInterval: 0.1,
    onDimensionsChange: g,
    minWidth: pj,
    minHeight: _ht,
    maxWidth: b > 0 ? b : y
  }), P = A.useMemo(() => k <= 180, [k]), D = A.useCallback(
    (z) => {
      const H = z.target, U = {
        width: H.naturalWidth,
        height: H.naturalHeight
      };
      d((F) => ({
        ...F,
        naturalSize: U,
        imageLoaded: !0
      })), r({
        width: H.width || U.width,
        height: H.height || U.height,
        alt: H.alt,
        title: H.title
      }), s || O((F) => ({ ...F, width: U.width }));
    },
    [s, r, O]
  ), L = A.useCallback(() => {
    d((z) => ({ ...z, error: !0, imageLoaded: !0 }));
  }, []), B = A.useCallback(
    (z) => (H) => {
      m(z), I(z)(H);
    },
    [I]
  ), $ = A.useCallback(() => {
    m(null);
  }, []);
  return A.useEffect(() => {
    R || $();
  }, [R, $]), A.useEffect(() => {
    (async () => {
      if (!c.startsWith("blob:") || l.current)
        return;
      l.current = !0;
      const H = n.options.extensions.find(
        (F) => F.name === "image"
      ), { uploadFn: U } = H?.options ?? {};
      if (!U) {
        try {
          const F = await Qlt(c);
          d((V) => ({ ...V, src: F })), r({ src: F });
        } catch {
          d((F) => ({ ...F, error: !0 }));
        }
        return;
      }
      try {
        d((J) => ({ ...J, isServerUploading: !0 }));
        const V = await (await fetch(c)).blob(), X = new File([V], a, { type: V.type }), Z = await U(X, n), ie = Oht(Z);
        d((J) => ({
          ...J,
          ...ie,
          isServerUploading: !1
        })), r(ie);
      } catch {
        d((F) => ({
          ...F,
          error: !0,
          isServerUploading: !1
        }));
      }
    })();
  }, [n, a, c, r]), /* @__PURE__ */ T(
    Jat,
    {
      ref: f,
      "data-drag-handle": !0,
      className: "tw:relative tw:text-center tw:leading-none",
      children: /* @__PURE__ */ T(
        "div",
        {
          className: "tw:group/node-image tw:relative tw:mx-auto tw:rounded-md tw:object-contain",
          style: {
            maxWidth: `min(${y}px, 100%)`,
            width: k,
            maxHeight: O8,
            aspectRatio: `${u.naturalSize.width} / ${u.naturalSize.height}`
          },
          children: /* @__PURE__ */ ee(
            "div",
            {
              className: Q(
                "tw:relative tw:flex tw:h-full tw:cursor-default tw:flex-col tw:items-center tw:gap-2 tw:rounded",
                {
                  "outline-primary outline-2 outline-offset-1": t || R
                }
              ),
              children: [
                /* @__PURE__ */ ee("div", { className: "tw:h-full tw:contain-paint", children: [
                  /* @__PURE__ */ ee("div", { className: "tw:relative tw:h-full", children: [
                    u.isServerUploading && !u.error && /* @__PURE__ */ T("div", { className: "tw:absolute tw:inset-0 tw:flex tw:items-center tw:justify-center", children: /* @__PURE__ */ T(Jae, { className: "tw:size-7" }) }),
                    u.error && /* @__PURE__ */ ee("div", { className: "tw:absolute tw:inset-0 tw:flex tw:flex-col tw:items-center tw:justify-center", children: [
                      /* @__PURE__ */ T(klt, { className: "tw:text-destructive tw:size-8" }),
                      /* @__PURE__ */ T("p", { className: "tw:text-muted-foreground tw:mt-2 tw:text-sm", children: "Failed to load image" })
                    ] }),
                    /* @__PURE__ */ T(
                      Aht,
                      {
                        isZoomed: u.isZoomed,
                        onZoomChange: () => d((z) => ({ ...z, isZoomed: !1 })),
                        children: /* @__PURE__ */ T(
                          "img",
                          {
                            className: Q(
                              "tw:h-auto tw:rounded tw:object-contain tw:transition-shadow",
                              {
                                "opacity-0": !u.imageLoaded || u.error
                              }
                            ),
                            style: {
                              maxWidth: `min(100%, ${y}px)`,
                              minWidth: `${pj}px`,
                              maxHeight: O8
                            },
                            width: k,
                            height: _,
                            src: u.src,
                            onError: L,
                            onLoad: D,
                            alt: e.attrs.alt || "",
                            title: e.attrs.title || "",
                            id: e.attrs.id
                          }
                        )
                      }
                    )
                  ] }),
                  u.isServerUploading && /* @__PURE__ */ T(ele, {}),
                  n.isEditable && u.imageLoaded && !u.error && !u.isServerUploading && /* @__PURE__ */ ee(ft, { children: [
                    /* @__PURE__ */ T(
                      C9,
                      {
                        onPointerDown: B("left"),
                        className: Q("tw:left-1", {
                          hidden: R && h === "right"
                        }),
                        isResizing: R && h === "left"
                      }
                    ),
                    /* @__PURE__ */ T(
                      C9,
                      {
                        onPointerDown: B("right"),
                        className: Q("tw:right-1", {
                          hidden: R && h === "left"
                        }),
                        isResizing: R && h === "right"
                      }
                    )
                  ] })
                ] }),
                u.error && /* @__PURE__ */ T(LO, { children: /* @__PURE__ */ T(
                  Hb,
                  {
                    icon: /* @__PURE__ */ T(Glt, {}),
                    tooltip: "Remove image",
                    onClick: M
                  }
                ) }),
                !R && !u.error && !u.isServerUploading && /* @__PURE__ */ T(
                  Zae,
                  {
                    shouldMerge: P,
                    isLink: x,
                    onView: E,
                    onDownload: w,
                    onCopy: C,
                    onCopyLink: S
                  }
                )
              ]
            }
          )
        }
      )
    }
  );
}, $O = (n, e, t) => {
  const r = n instanceof Error ? n : new Error("Unknown error");
  t?.(r, e);
}, Rht = (n) => {
  const [e, t] = n.split(","), r = e.split(":")[1].split(";")[0], i = r.split("/")[1], s = atob(t), o = new Uint8Array(s.length);
  for (let l = 0; l < s.length; l++)
    o[l] = s.charCodeAt(l);
  return { blob: new Blob([o], { type: r }), extension: i };
}, Pht = async (n) => {
  const e = await fetch(n);
  if (!e.ok) throw new Error("Failed to fetch image");
  const t = await e.blob(), r = t.type.split(/\/|\+/)[1];
  return { blob: t, extension: r };
}, Dht = async (n) => n.startsWith("data:") ? Rht(n) : Pht(n), Nht = async (n, e, t) => {
  const r = URL.createObjectURL(n), i = document.createElement("a");
  i.href = r, i.download = `${e}.${t}`, document.body.appendChild(i), i.click(), document.body.removeChild(i), URL.revokeObjectURL(r);
}, Lht = async (n, e) => {
  const { src: t, alt: r } = n, i = r || "image";
  try {
    const { blob: s, extension: o } = await Dht(t);
    await Nht(s, i, o), e.onActionSuccess?.({ ...n, action: "download" });
  } catch (s) {
    $O(s, { ...n, action: "download" }, e.onActionError);
  }
}, $ht = async (n, e) => {
  const { src: t } = n;
  try {
    const i = await (await fetch(t)).blob();
    await navigator.clipboard.write([new ClipboardItem({ [i.type]: i })]), e.onActionSuccess?.({ ...n, action: "copyImage" });
  } catch (r) {
    $O(r, { ...n, action: "copyImage" }, e.onActionError);
  }
}, Fht = async (n, e) => {
  const { src: t } = n;
  try {
    await navigator.clipboard.writeText(t), e.onActionSuccess?.({ ...n, action: "copyLink" });
  } catch (r) {
    $O(r, { ...n, action: "copyLink" }, e.onActionError);
  }
}, Bht = fht.extend({
  atom: !0,
  addOptions() {
    return {
      ...this.parent?.(),
      allowedMimeTypes: [],
      maxFileSize: 0,
      uploadFn: void 0,
      onToggle: void 0,
      downloadImage: void 0,
      copyImage: void 0,
      copyLink: void 0,
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      id: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      },
      fileName: {
        default: null
      }
    };
  },
  addCommands() {
    return {
      setImages: (n) => ({ commands: e }) => {
        const [t, r] = ab(n, {
          allowedMimeTypes: this.options.allowedMimeTypes,
          maxFileSize: this.options.maxFileSize,
          allowBase64: this.options.allowBase64
        });
        return r.length > 0 && this.options.onValidationError && this.options.onValidationError(r), t.length > 0 ? e.insertContent(
          t.map((i) => {
            if (i.src instanceof File) {
              const s = URL.createObjectURL(i.src), o = ob();
              return {
                type: this.type.name,
                attrs: {
                  id: o,
                  src: s,
                  alt: i.alt,
                  title: i.title,
                  fileName: i.src.name
                }
              };
            } else
              return {
                type: this.type.name,
                attrs: {
                  id: ob(),
                  src: i.src,
                  alt: i.alt,
                  title: i.title,
                  fileName: null
                }
              };
          })
        ) : !1;
      },
      downloadImage: (n) => () => ((this.options.downloadImage || Lht)({ ...n, action: "download" }, this.options), !0),
      copyImage: (n) => () => ((this.options.copyImage || $ht)({ ...n, action: "copyImage" }, this.options), !0),
      copyLink: (n) => () => ((this.options.copyLink || Fht)({ ...n, action: "copyLink" }, this.options), !0),
      toggleImage: () => ({ editor: n }) => {
        const e = document.createElement("input");
        return e.type = "file", e.accept = this.options.allowedMimeTypes.join(","), e.onchange = () => {
          const t = e.files;
          if (!t) return;
          const [r, i] = ab(Array.from(t), {
            allowedMimeTypes: this.options.allowedMimeTypes,
            maxFileSize: this.options.maxFileSize,
            allowBase64: this.options.allowBase64
          });
          return i.length > 0 && this.options.onValidationError ? (this.options.onValidationError(i), !1) : (r.length === 0 || this.options.onToggle && this.options.onToggle(
            n,
            r,
            n.state.selection.from
          ), !1);
        }, e.click(), !0;
      }
    };
  },
  onTransaction({ transaction: n }) {
    n.steps.forEach((e) => {
      e instanceof Er && e.slice.size === 0 && n.before.content.cut(e.from, e.to).forEach((r) => {
        if (r.type.name === "image") {
          const i = r.attrs;
          i.src.startsWith("blob:") && URL.revokeObjectURL(i.src), this.options.onImageRemoved?.(i);
        }
      });
    });
  },
  addNodeView() {
    return slt(Iht, {
      className: "block-node"
    });
  }
}), zht = qt.create({
  addKeyboardShortcuts() {
    return {
      "Mod-\\": () => this.editor.commands.unsetAllMarks()
    };
  }
}), Hht = qt.create({
  name: "resetMarksOnEnter",
  addKeyboardShortcuts() {
    return {
      Enter: ({ editor: n }) => n.isActive("bold") || n.isActive("italic") || n.isActive("strike") || n.isActive("underline") || n.isActive("code") ? (n.commands.splitBlock({ keepMarks: !1 }), !0) : !1
    };
  }
}), Uht = (n) => {
  const {
    key: e,
    editor: t,
    onPaste: r,
    onDrop: i,
    onValidationError: s,
    allowedMimeTypes: o,
    maxFileSize: a
  } = n;
  return new Cn({
    key: e || new _n("fileHandler"),
    props: {
      handleDrop(l, c) {
        c.preventDefault(), c.stopPropagation();
        const { dataTransfer: u } = c;
        if (!u?.files.length)
          return;
        const d = l.posAtCoords({
          left: c.clientX,
          top: c.clientY
        }), [f, h] = ab(
          Array.from(u.files),
          {
            allowedMimeTypes: o,
            maxFileSize: a,
            allowBase64: n.allowBase64
          }
        );
        h.length > 0 && s && s(h), f.length > 0 && i && i(t, f, d?.pos ?? 0);
      },
      handlePaste(l, c) {
        c.preventDefault(), c.stopPropagation();
        const { clipboardData: u } = c;
        if (!u?.files.length)
          return;
        const [d, f] = ab(
          Array.from(u.files),
          {
            allowedMimeTypes: o,
            maxFileSize: a,
            allowBase64: n.allowBase64
          }
        ), h = u.getData("text/html");
        f.length > 0 && s && s(f), d.length > 0 && r && r(t, d, h);
      }
    }
  });
}, Vht = qt.create({
  name: "fileHandler",
  addOptions() {
    return {
      allowBase64: !1,
      allowedMimeTypes: [],
      maxFileSize: 0
    };
  },
  addProseMirrorPlugins() {
    return [
      Uht({
        key: new _n(this.name),
        editor: this.editor,
        ...this.options
      })
    ];
  }
});
function jht(n, e) {
  const t = Gt(Date.now()), r = Gt(null);
  return Ft(
    (...i) => {
      (() => {
        Date.now() - t.current >= e ? (n(...i), t.current = Date.now()) : (r.current && clearTimeout(r.current), r.current = setTimeout(
          () => {
            n(...i), t.current = Date.now();
          },
          e - (Date.now() - t.current)
        ));
      })();
    },
    [n, e]
  );
}
async function Wht(n) {
  return await new Promise((t) => setTimeout(t, 3e3)), await d9(n);
}
const Ght = ({
  placeholder: n,
  uploader: e
}) => [
  ndt.configure({
    blockquote: { HTMLAttributes: { class: "block-node" } },
    // bold
    bulletList: { HTMLAttributes: { class: "list-node" } },
    code: { HTMLAttributes: { class: "inline", spellcheck: "false" } },
    codeBlock: !1,
    // document
    dropcursor: { width: 2, class: "ProseMirror-dropcursor border" },
    // gapcursor
    // hardBreak
    heading: { HTMLAttributes: { class: "heading-node" } },
    // undoRedo
    horizontalRule: !1,
    // italic
    // listItem
    // listKeymap
    link: {
      enableClickSelection: !0,
      openOnClick: !1,
      HTMLAttributes: {
        class: "link"
      }
    },
    orderedList: { HTMLAttributes: { class: "list-node" } },
    paragraph: { HTMLAttributes: { class: "text-node" } }
    // strike
    // text
    // underline
    // trailingNode
  }),
  Bht.configure({
    allowedMimeTypes: ["image/*"],
    maxFileSize: 5 * 1024 * 1024,
    allowBase64: !0,
    uploadFn: async (t) => e ? await e(t) : await Wht(t),
    onToggle(t, r, i) {
      t.commands.insertContentAt(
        i,
        r.map((s) => {
          const o = URL.createObjectURL(s);
          return {
            type: "image",
            attrs: {
              id: ob(),
              src: o,
              alt: s.name,
              title: s.name,
              fileName: s.name
            }
          };
        })
      );
    },
    onImageRemoved({ id: t, src: r }) {
      console.log("Image removed", { id: t, src: r });
    },
    onValidationError(t) {
      t.forEach((r) => {
        Ap.error("Image validation error", {
          position: "bottom-right",
          description: r.reason
        });
      });
    },
    onActionSuccess({ action: t }) {
      const r = {
        copyImage: "Copy Image",
        copyLink: "Copy Link",
        download: "Download"
      };
      Ap.success(r[t], {
        position: "bottom-right",
        description: "Image action success"
      });
    },
    onActionError(t, { action: r }) {
      const i = {
        copyImage: "Copy Image",
        copyLink: "Copy Link",
        download: "Download"
      };
      Ap.error(`Failed to ${i[r]}`, {
        position: "bottom-right",
        description: t.message
      });
    }
  }),
  Vht.configure({
    allowBase64: !0,
    allowedMimeTypes: ["image/*"],
    maxFileSize: 5 * 1024 * 1024,
    onDrop: (t, r, i) => {
      r.forEach(async (s) => {
        const o = await d9(s);
        t.commands.insertContentAt(i, {
          type: "image",
          attrs: { src: o }
        });
      });
    },
    onPaste: (t, r) => {
      r.forEach(async (i) => {
        const s = await d9(i);
        t.commands.insertContent({
          type: "image",
          attrs: { src: s }
        });
      });
    },
    onValidationError: (t) => {
      t.forEach((r) => {
        Ap.error("Image validation error", {
          position: "bottom-right",
          description: r.reason
        });
      });
    }
  }),
  cht,
  kae,
  Jut,
  Tdt,
  zht,
  uht,
  Hht,
  lht,
  Qut.configure({ placeholder: () => n })
], Kht = ({
  value: n,
  output: e = "html",
  placeholder: t = "",
  editorClassName: r,
  throttleDelay: i = 0,
  onUpdate: s,
  onBlur: o,
  uploader: a,
  ...l
}) => {
  const c = jht(
    (g) => s?.(g),
    i
  ), u = A.useCallback(
    (g) => c(PV(g, e)),
    [e, c]
  ), d = A.useCallback(
    (g) => {
      n && g.isEmpty && g.commands.setContent(n);
    },
    [n]
  ), f = A.useCallback(
    (g) => o?.(PV(g, e)),
    [e, o]
  ), h = Zat({
    immediatelyRender: !1,
    extensions: Ght({ placeholder: t, uploader: a }),
    editorProps: {
      attributes: {
        autocomplete: "off",
        autocorrect: "off",
        autocapitalize: "off",
        class: Q("focus:outline-hidden", r)
      }
    },
    onUpdate: ({ editor: g }) => u(g),
    onCreate: ({ editor: g }) => d(g),
    onBlur: ({ editor: g }) => f(g),
    ...l
  }), { editor: m } = _oe({
    editor: h,
    selector(g) {
      return g.editor ? {
        editor: g.editor,
        editorState: g.editor.state,
        canCommand: g.editor.can
      } : {
        editor: null,
        editorState: void 0,
        canCommand: void 0
      };
    }
  });
  return m;
}, qht = {
  top: 0,
  left: 0,
  bottom: 0,
  right: 0,
  x: 0,
  y: 0,
  width: 0,
  height: 0,
  toJSON: () => "{}"
};
function Yht(n) {
  const [e, t] = wt(
    () => n?.getBoundingClientRect() ?? qht
  ), r = Ft(() => {
    if (!n) return;
    const i = n.getBoundingClientRect();
    t((s) => Math.round(s.width) === Math.round(i.width) && Math.round(s.height) === Math.round(i.height) && Math.round(s.x) === Math.round(i.x) && Math.round(s.y) === Math.round(i.y) ? s : i);
  }, [n]);
  return Tt(() => {
    if (!n) return;
    const i = new ResizeObserver(r);
    return i.observe(n), window.addEventListener("click", r), window.addEventListener("resize", r), () => {
      i.disconnect(), window.removeEventListener("click", r), window.removeEventListener("resize", r);
    };
  }, [n, r]), e;
}
const tle = ({
  as: n,
  name: e,
  children: t,
  style: r = {},
  ...i
}) => {
  const s = A.useRef(null), o = Yht(s.current), a = {
    [`--${e}-width`]: `${o.width}px`,
    [`--${e}-height`]: `${o.height}px`
  };
  return /* @__PURE__ */ T(n, { ...i, ref: s, style: { ...a, ...r }, children: t });
};
tle.displayName = "MeasuredContainer";
const Xht = ({ editor: n }) => /* @__PURE__ */ T("div", { className: "tw:border-border tw:flex tw:h-12 tw:shrink-0 tw:overflow-x-auto tw:border-b tw:p-2", children: /* @__PURE__ */ ee("div", { className: "tw:flex tw:w-max tw:items-center tw:gap-px", children: [
  /* @__PURE__ */ T(Boe, { editor: n, activeLevels: [1, 2, 3, 4, 5, 6] }),
  /* @__PURE__ */ T(ra, { orientation: "vertical", className: "tw:mx-2" }),
  /* @__PURE__ */ T(
    zoe,
    {
      editor: n,
      activeActions: [
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "code",
        "clearFormatting"
      ],
      mainActionCount: 3
    }
  ),
  /* @__PURE__ */ T(ra, { orientation: "vertical", className: "tw:mx-2" }),
  /* @__PURE__ */ T(Voe, { editor: n }),
  /* @__PURE__ */ T(ra, { orientation: "vertical", className: "tw:mx-2" }),
  /* @__PURE__ */ T(
    joe,
    {
      editor: n,
      activeActions: ["orderedList", "bulletList"],
      mainActionCount: 0
    }
  ),
  /* @__PURE__ */ T(ra, { orientation: "vertical", className: "tw:mx-2" }),
  /* @__PURE__ */ T(
    Woe,
    {
      editor: n,
      activeActions: ["codeBlock", "blockquote", "horizontalRule"],
      mainActionCount: 0
    }
  )
] }) }), nle = ({
  value: n,
  onChange: e,
  className: t,
  editorContentClassName: r,
  ...i
}) => {
  const s = Kht({
    value: n,
    onUpdate: e,
    ...i
  });
  return s ? /* @__PURE__ */ ee(
    tle,
    {
      as: "div",
      name: "editor",
      className: Q(
        "tw:border-input tw:min-data-[orientation=vertical]:h-72 tw:flex tw:h-auto tw:w-full tw:flex-col tw:rounded-md tw:border tw:shadow-xs",
        "tw:focus-within:border-ring tw:focus-within:ring-ring/50 tw:focus-within:ring-[3px]",
        t
      ),
      children: [
        /* @__PURE__ */ T(Xht, { editor: s }),
        /* @__PURE__ */ T(
          Gat,
          {
            editor: s,
            className: Q("tw:minimal-tiptap-editor", r)
          }
        ),
        /* @__PURE__ */ T(xct, { editor: s })
      ]
    }
  ) : null;
};
nle.displayName = "MinimalTiptapEditor";
function h3t(n) {
  const { field: e } = wh({
    name: n.name,
    control: n.control
  }), t = (r) => {
    e.onChange(r);
  };
  return /* @__PURE__ */ T(
    xs,
    {
      control: n.control,
      name: n.name,
      render: () => /* @__PURE__ */ ee(Ci, { className: "tw:flex tw:flex-col", children: [
        /* @__PURE__ */ T(Ti, { children: n.label }),
        /* @__PURE__ */ T(qi, { children: /* @__PURE__ */ T(
          nle,
          {
            value: e.value,
            onChange: t,
            className: Q("tw:w-full", n.className),
            editorContentClassName: Q(
              "tw:p-5",
              n.editorContentClassName
            ),
            output: "html",
            placeholder: n.placeholder || "Enter text...",
            editable: n.editable && !n.disabled,
            editorClassName: Q(
              "tw:focus:outline-hidden",
              n.editorClassName
            )
          }
        ) }),
        n.description && /* @__PURE__ */ T(Ai, { children: n.description }),
        /* @__PURE__ */ T(qs, {})
      ] })
    }
  );
}
const rle = 1024;
let Zht = 0, I8 = class {
  constructor(e, t) {
    this.from = e, this.to = t;
  }
};
class Lt {
  /**
  Create a new node prop type.
  */
  constructor(e = {}) {
    this.id = Zht++, this.perNode = !!e.perNode, this.deserialize = e.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    }), this.combine = e.combine || null;
  }
  /**
  This is meant to be used with
  [`NodeSet.extend`](#common.NodeSet.extend) or
  [`LRParser.configure`](#lr.ParserConfig.props) to compute
  prop values for each node type in the set. Takes a [match
  object](#common.NodeType^match) or function that returns undefined
  if the node type doesn't get this prop, and the prop's value if
  it does.
  */
  add(e) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    return typeof e != "function" && (e = ji.match(e)), (t) => {
      let r = e(t);
      return r === void 0 ? null : [this, r];
    };
  }
}
Lt.closedBy = new Lt({ deserialize: (n) => n.split(" ") });
Lt.openedBy = new Lt({ deserialize: (n) => n.split(" ") });
Lt.group = new Lt({ deserialize: (n) => n.split(" ") });
Lt.isolate = new Lt({ deserialize: (n) => {
  if (n && n != "rtl" && n != "ltr" && n != "auto")
    throw new RangeError("Invalid value for isolate: " + n);
  return n || "auto";
} });
Lt.contextHash = new Lt({ perNode: !0 });
Lt.lookAhead = new Lt({ perNode: !0 });
Lt.mounted = new Lt({ perNode: !0 });
class Ub {
  constructor(e, t, r) {
    this.tree = e, this.overlay = t, this.parser = r;
  }
  /**
  @internal
  */
  static get(e) {
    return e && e.props && e.props[Lt.mounted.id];
  }
}
const Qht = /* @__PURE__ */ Object.create(null);
class ji {
  /**
  @internal
  */
  constructor(e, t, r, i = 0) {
    this.name = e, this.props = t, this.id = r, this.flags = i;
  }
  /**
  Define a node type.
  */
  static define(e) {
    let t = e.props && e.props.length ? /* @__PURE__ */ Object.create(null) : Qht, r = (e.top ? 1 : 0) | (e.skipped ? 2 : 0) | (e.error ? 4 : 0) | (e.name == null ? 8 : 0), i = new ji(e.name || "", t, e.id, r);
    if (e.props) {
      for (let s of e.props)
        if (Array.isArray(s) || (s = s(i)), s) {
          if (s[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          t[s[0].id] = s[1];
        }
    }
    return i;
  }
  /**
  Retrieves a node prop for this type. Will return `undefined` if
  the prop isn't present on this node.
  */
  prop(e) {
    return this.props[e.id];
  }
  /**
  True when this is the top node of a grammar.
  */
  get isTop() {
    return (this.flags & 1) > 0;
  }
  /**
  True when this node is produced by a skip rule.
  */
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  /**
  Indicates whether this is an error node.
  */
  get isError() {
    return (this.flags & 4) > 0;
  }
  /**
  When true, this node type doesn't correspond to a user-declared
  named node, for example because it is used to cache repetition.
  */
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  /**
  Returns true when this node's name or one of its
  [groups](#common.NodeProp^group) matches the given string.
  */
  is(e) {
    if (typeof e == "string") {
      if (this.name == e)
        return !0;
      let t = this.prop(Lt.group);
      return t ? t.indexOf(e) > -1 : !1;
    }
    return this.id == e;
  }
  /**
  Create a function from node types to arbitrary values by
  specifying an object whose property names are node or
  [group](#common.NodeProp^group) names. Often useful with
  [`NodeProp.add`](#common.NodeProp.add). You can put multiple
  names, separated by spaces, in a single property name to map
  multiple node names to a single value.
  */
  static match(e) {
    let t = /* @__PURE__ */ Object.create(null);
    for (let r in e)
      for (let i of r.split(" "))
        t[i] = e[r];
    return (r) => {
      for (let i = r.prop(Lt.group), s = -1; s < (i ? i.length : 0); s++) {
        let o = t[s < 0 ? r.name : i[s]];
        if (o)
          return o;
      }
    };
  }
}
ji.none = new ji(
  "",
  /* @__PURE__ */ Object.create(null),
  0,
  8
  /* NodeFlag.Anonymous */
);
class FO {
  /**
  Create a set with the given types. The `id` property of each
  type should correspond to its position within the array.
  */
  constructor(e) {
    this.types = e;
    for (let t = 0; t < e.length; t++)
      if (e[t].id != t)
        throw new RangeError("Node type ids should correspond to array positions when creating a node set");
  }
  /**
  Create a copy of this set with some node properties added. The
  arguments to this method can be created with
  [`NodeProp.add`](#common.NodeProp.add).
  */
  extend(...e) {
    let t = [];
    for (let r of this.types) {
      let i = null;
      for (let s of e) {
        let o = s(r);
        if (o) {
          i || (i = Object.assign({}, r.props));
          let a = o[1], l = o[0];
          l.combine && l.id in i && (a = l.combine(i[l.id], a)), i[l.id] = a;
        }
      }
      t.push(i ? new ji(r.name, i, r.id, r.flags) : r);
    }
    return new FO(t);
  }
}
const pv = /* @__PURE__ */ new WeakMap(), mj = /* @__PURE__ */ new WeakMap();
var kr;
(function(n) {
  n[n.ExcludeBuffers = 1] = "ExcludeBuffers", n[n.IncludeAnonymous = 2] = "IncludeAnonymous", n[n.IgnoreMounts = 4] = "IgnoreMounts", n[n.IgnoreOverlays = 8] = "IgnoreOverlays";
})(kr || (kr = {}));
class ar {
  /**
  Construct a new tree. See also [`Tree.build`](#common.Tree^build).
  */
  constructor(e, t, r, i, s) {
    if (this.type = e, this.children = t, this.positions = r, this.length = i, this.props = null, s && s.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      for (let [o, a] of s)
        this.props[typeof o == "number" ? o : o.id] = a;
    }
  }
  /**
  @internal
  */
  toString() {
    let e = Ub.get(this);
    if (e && !e.overlay)
      return e.tree.toString();
    let t = "";
    for (let r of this.children) {
      let i = r.toString();
      i && (t && (t += ","), t += i);
    }
    return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (t.length ? "(" + t + ")" : "") : t;
  }
  /**
  Get a [tree cursor](#common.TreeCursor) positioned at the top of
  the tree. Mode can be used to [control](#common.IterMode) which
  nodes the cursor visits.
  */
  cursor(e = 0) {
    return new A9(this.topNode, e);
  }
  /**
  Get a [tree cursor](#common.TreeCursor) pointing into this tree
  at the given position and side (see
  [`moveTo`](#common.TreeCursor.moveTo).
  */
  cursorAt(e, t = 0, r = 0) {
    let i = pv.get(this) || this.topNode, s = new A9(i);
    return s.moveTo(e, t), pv.set(this, s._tree), s;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) object for the top of the
  tree.
  */
  get topNode() {
    return new zs(this, 0, 0, null);
  }
  /**
  Get the [syntax node](#common.SyntaxNode) at the given position.
  If `side` is -1, this will move into nodes that end at the
  position. If 1, it'll move into nodes that start at the
  position. With 0, it'll only enter nodes that cover the position
  from both sides.
  
  Note that this will not enter
  [overlays](#common.MountedTree.overlay), and you often want
  [`resolveInner`](#common.Tree.resolveInner) instead.
  */
  resolve(e, t = 0) {
    let r = W0(pv.get(this) || this.topNode, e, t, !1);
    return pv.set(this, r), r;
  }
  /**
  Like [`resolve`](#common.Tree.resolve), but will enter
  [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
  pointing into the innermost overlaid tree at the given position
  (with parent links going through all parent structure, including
  the host trees).
  */
  resolveInner(e, t = 0) {
    let r = W0(mj.get(this) || this.topNode, e, t, !0);
    return mj.set(this, r), r;
  }
  /**
  In some situations, it can be useful to iterate through all
  nodes around a position, including those in overlays that don't
  directly cover the position. This method gives you an iterator
  that will produce all nodes, from small to big, around the given
  position.
  */
  resolveStack(e, t = 0) {
    return tpt(this, e, t);
  }
  /**
  Iterate over the tree and its children, calling `enter` for any
  node that touches the `from`/`to` region (if given) before
  running over such a node's children, and `leave` (if given) when
  leaving the node. When `enter` returns `false`, that node will
  not have its children iterated over (or `leave` called).
  */
  iterate(e) {
    let { enter: t, leave: r, from: i = 0, to: s = this.length } = e, o = e.mode || 0, a = (o & kr.IncludeAnonymous) > 0;
    for (let l = this.cursor(o | kr.IncludeAnonymous); ; ) {
      let c = !1;
      if (l.from <= s && l.to >= i && (!a && l.type.isAnonymous || t(l) !== !1)) {
        if (l.firstChild())
          continue;
        c = !0;
      }
      for (; c && r && (a || !l.type.isAnonymous) && r(l), !l.nextSibling(); ) {
        if (!l.parent())
          return;
        c = !0;
      }
    }
  }
  /**
  Get the value of the given [node prop](#common.NodeProp) for this
  node. Works with both per-node and per-type props.
  */
  prop(e) {
    return e.perNode ? this.props ? this.props[e.id] : void 0 : this.type.prop(e);
  }
  /**
  Returns the node's [per-node props](#common.NodeProp.perNode) in a
  format that can be passed to the [`Tree`](#common.Tree)
  constructor.
  */
  get propValues() {
    let e = [];
    if (this.props)
      for (let t in this.props)
        e.push([+t, this.props[t]]);
    return e;
  }
  /**
  Balance the direct children of this tree, producing a copy of
  which may have children grouped into subtrees with type
  [`NodeType.none`](#common.NodeType^none).
  */
  balance(e = {}) {
    return this.children.length <= 8 ? this : HO(ji.none, this.children, this.positions, 0, this.children.length, 0, this.length, (t, r, i) => new ar(this.type, t, r, i, this.propValues), e.makeTree || ((t, r, i) => new ar(ji.none, t, r, i)));
  }
  /**
  Build a tree from a postfix-ordered buffer of node information,
  or a cursor over such a buffer.
  */
  static build(e) {
    return npt(e);
  }
}
ar.empty = new ar(ji.none, [], [], 0);
class BO {
  constructor(e, t) {
    this.buffer = e, this.index = t;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new BO(this.buffer, this.index);
  }
}
class bc {
  /**
  Create a tree buffer.
  */
  constructor(e, t, r) {
    this.buffer = e, this.length = t, this.set = r;
  }
  /**
  @internal
  */
  get type() {
    return ji.none;
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    for (let t = 0; t < this.buffer.length; )
      e.push(this.childString(t)), t = this.buffer[t + 3];
    return e.join(",");
  }
  /**
  @internal
  */
  childString(e) {
    let t = this.buffer[e], r = this.buffer[e + 3], i = this.set.types[t], s = i.name;
    if (/\W/.test(s) && !i.isError && (s = JSON.stringify(s)), e += 4, r == e)
      return s;
    let o = [];
    for (; e < r; )
      o.push(this.childString(e)), e = this.buffer[e + 3];
    return s + "(" + o.join(",") + ")";
  }
  /**
  @internal
  */
  findChild(e, t, r, i, s) {
    let { buffer: o } = this, a = -1;
    for (let l = e; l != t && !(ile(s, i, o[l + 1], o[l + 2]) && (a = l, r > 0)); l = o[l + 3])
      ;
    return a;
  }
  /**
  @internal
  */
  slice(e, t, r) {
    let i = this.buffer, s = new Uint16Array(t - e), o = 0;
    for (let a = e, l = 0; a < t; ) {
      s[l++] = i[a++], s[l++] = i[a++] - r;
      let c = s[l++] = i[a++] - r;
      s[l++] = i[a++] - e, o = Math.max(o, c);
    }
    return new bc(s, o, this.set);
  }
}
function ile(n, e, t, r) {
  switch (n) {
    case -2:
      return t < e;
    case -1:
      return r >= e && t < e;
    case 0:
      return t < e && r > e;
    case 1:
      return t <= e && r > e;
    case 2:
      return r > e;
    case 4:
      return !0;
  }
}
function W0(n, e, t, r) {
  for (var i; n.from == n.to || (t < 1 ? n.from >= e : n.from > e) || (t > -1 ? n.to <= e : n.to < e); ) {
    let o = !r && n instanceof zs && n.index < 0 ? null : n.parent;
    if (!o)
      return n;
    n = o;
  }
  let s = r ? 0 : kr.IgnoreOverlays;
  if (r)
    for (let o = n, a = o.parent; a; o = a, a = o.parent)
      o instanceof zs && o.index < 0 && ((i = a.enter(e, t, s)) === null || i === void 0 ? void 0 : i.from) != o.from && (n = a);
  for (; ; ) {
    let o = n.enter(e, t, s);
    if (!o)
      return n;
    n = o;
  }
}
class sle {
  cursor(e = 0) {
    return new A9(this, e);
  }
  getChild(e, t = null, r = null) {
    let i = gj(this, e, t, r);
    return i.length ? i[0] : null;
  }
  getChildren(e, t = null, r = null) {
    return gj(this, e, t, r);
  }
  resolve(e, t = 0) {
    return W0(this, e, t, !1);
  }
  resolveInner(e, t = 0) {
    return W0(this, e, t, !0);
  }
  matchContext(e) {
    return T9(this.parent, e);
  }
  enterUnfinishedNodesBefore(e) {
    let t = this.childBefore(e), r = this;
    for (; t; ) {
      let i = t.lastChild;
      if (!i || i.to != t.to)
        break;
      i.type.isError && i.from == i.to ? (r = t, t = i.prevSibling) : t = i;
    }
    return r;
  }
  get node() {
    return this;
  }
  get next() {
    return this.parent;
  }
}
class zs extends sle {
  constructor(e, t, r, i) {
    super(), this._tree = e, this.from = t, this.index = r, this._parent = i;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(e, t, r, i, s = 0) {
    for (let o = this; ; ) {
      for (let { children: a, positions: l } = o._tree, c = t > 0 ? a.length : -1; e != c; e += t) {
        let u = a[e], d = l[e] + o.from;
        if (ile(i, r, d, d + u.length)) {
          if (u instanceof bc) {
            if (s & kr.ExcludeBuffers)
              continue;
            let f = u.findChild(0, u.buffer.length, t, r - d, i);
            if (f > -1)
              return new ec(new Jht(o, u, e, d), null, f);
          } else if (s & kr.IncludeAnonymous || !u.type.isAnonymous || zO(u)) {
            let f;
            if (!(s & kr.IgnoreMounts) && (f = Ub.get(u)) && !f.overlay)
              return new zs(f.tree, d, e, o);
            let h = new zs(u, d, e, o);
            return s & kr.IncludeAnonymous || !h.type.isAnonymous ? h : h.nextChild(t < 0 ? u.children.length - 1 : 0, t, r, i);
          }
        }
      }
      if (s & kr.IncludeAnonymous || !o.type.isAnonymous || (o.index >= 0 ? e = o.index + t : e = t < 0 ? -1 : o._parent._tree.children.length, o = o._parent, !o))
        return null;
    }
  }
  get firstChild() {
    return this.nextChild(
      0,
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(e) {
    return this.nextChild(
      0,
      1,
      e,
      2
      /* Side.After */
    );
  }
  childBefore(e) {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  enter(e, t, r = 0) {
    let i;
    if (!(r & kr.IgnoreOverlays) && (i = Ub.get(this._tree)) && i.overlay) {
      let s = e - this.from;
      for (let { from: o, to: a } of i.overlay)
        if ((t > 0 ? o <= s : o < s) && (t < 0 ? a >= s : a > s))
          return new zs(i.tree, i.overlay[0].from + this.from, -1, this);
    }
    return this.nextChild(0, 1, e, t, r);
  }
  nextSignificantParent() {
    let e = this;
    for (; e.type.isAnonymous && e._parent; )
      e = e._parent;
    return e;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index + 1,
      1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  /**
  @internal
  */
  toString() {
    return this._tree.toString();
  }
}
function gj(n, e, t, r) {
  let i = n.cursor(), s = [];
  if (!i.firstChild())
    return s;
  if (t != null) {
    for (let o = !1; !o; )
      if (o = i.type.is(t), !i.nextSibling())
        return s;
  }
  for (; ; ) {
    if (r != null && i.type.is(r))
      return s;
    if (i.type.is(e) && s.push(i.node), !i.nextSibling())
      return r == null ? s : [];
  }
}
function T9(n, e, t = e.length - 1) {
  for (let r = n; t >= 0; r = r.parent) {
    if (!r)
      return !1;
    if (!r.type.isAnonymous) {
      if (e[t] && e[t] != r.name)
        return !1;
      t--;
    }
  }
  return !0;
}
class Jht {
  constructor(e, t, r, i) {
    this.parent = e, this.buffer = t, this.index = r, this.start = i;
  }
}
class ec extends sle {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(e, t, r) {
    super(), this.context = e, this._parent = t, this.index = r, this.type = e.buffer.set.types[e.buffer.buffer[r]];
  }
  child(e, t, r) {
    let { buffer: i } = this.context, s = i.findChild(this.index + 4, i.buffer[this.index + 3], e, t - this.context.start, r);
    return s < 0 ? null : new ec(this.context, this, s);
  }
  get firstChild() {
    return this.child(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.child(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(e) {
    return this.child(
      1,
      e,
      2
      /* Side.After */
    );
  }
  childBefore(e) {
    return this.child(
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  enter(e, t, r = 0) {
    if (r & kr.ExcludeBuffers)
      return null;
    let { buffer: i } = this.context, s = i.findChild(this.index + 4, i.buffer[this.index + 3], t > 0 ? 1 : -1, e - this.context.start, t);
    return s < 0 ? null : new ec(this.context, this, s);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(e) {
    return this._parent ? null : this.context.parent.nextChild(
      this.context.index + e,
      e,
      0,
      4
      /* Side.DontCare */
    );
  }
  get nextSibling() {
    let { buffer: e } = this.context, t = e.buffer[this.index + 3];
    return t < (this._parent ? e.buffer[this._parent.index + 3] : e.buffer.length) ? new ec(this.context, this._parent, t) : this.externalSibling(1);
  }
  get prevSibling() {
    let { buffer: e } = this.context, t = this._parent ? this._parent.index + 4 : 0;
    return this.index == t ? this.externalSibling(-1) : new ec(this.context, this._parent, e.findChild(
      t,
      this.index,
      -1,
      0,
      4
      /* Side.DontCare */
    ));
  }
  get tree() {
    return null;
  }
  toTree() {
    let e = [], t = [], { buffer: r } = this.context, i = this.index + 4, s = r.buffer[this.index + 3];
    if (s > i) {
      let o = r.buffer[this.index + 1];
      e.push(r.slice(i, s, o)), t.push(0);
    }
    return new ar(this.type, e, t, this.to - this.from);
  }
  /**
  @internal
  */
  toString() {
    return this.context.buffer.childString(this.index);
  }
}
function ole(n) {
  if (!n.length)
    return null;
  let e = 0, t = n[0];
  for (let s = 1; s < n.length; s++) {
    let o = n[s];
    (o.from > t.from || o.to < t.to) && (t = o, e = s);
  }
  let r = t instanceof zs && t.index < 0 ? null : t.parent, i = n.slice();
  return r ? i[e] = r : i.splice(e, 1), new ept(i, t);
}
class ept {
  constructor(e, t) {
    this.heads = e, this.node = t;
  }
  get next() {
    return ole(this.heads);
  }
}
function tpt(n, e, t) {
  let r = n.resolveInner(e, t), i = null;
  for (let s = r instanceof zs ? r : r.context.parent; s; s = s.parent)
    if (s.index < 0) {
      let o = s.parent;
      (i || (i = [r])).push(o.resolve(e, t)), s = o;
    } else {
      let o = Ub.get(s.tree);
      if (o && o.overlay && o.overlay[0].from <= e && o.overlay[o.overlay.length - 1].to >= e) {
        let a = new zs(o.tree, o.overlay[0].from + s.from, -1, s);
        (i || (i = [r])).push(W0(a, e, t, !1));
      }
    }
  return i ? ole(i) : r;
}
class A9 {
  /**
  Shorthand for `.type.name`.
  */
  get name() {
    return this.type.name;
  }
  /**
  @internal
  */
  constructor(e, t = 0) {
    if (this.mode = t, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, e instanceof zs)
      this.yieldNode(e);
    else {
      this._tree = e.context.parent, this.buffer = e.context;
      for (let r = e._parent; r; r = r._parent)
        this.stack.unshift(r.index);
      this.bufferNode = e, this.yieldBuf(e.index);
    }
  }
  yieldNode(e) {
    return e ? (this._tree = e, this.type = e.type, this.from = e.from, this.to = e.to, !0) : !1;
  }
  yieldBuf(e, t) {
    this.index = e;
    let { start: r, buffer: i } = this.buffer;
    return this.type = t || i.set.types[i.buffer[e]], this.from = r + i.buffer[e + 1], this.to = r + i.buffer[e + 2], !0;
  }
  /**
  @internal
  */
  yield(e) {
    return e ? e instanceof zs ? (this.buffer = null, this.yieldNode(e)) : (this.buffer = e.context, this.yieldBuf(e.index, e.type)) : !1;
  }
  /**
  @internal
  */
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  /**
  @internal
  */
  enterChild(e, t, r) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(e < 0 ? this._tree._tree.children.length - 1 : 0, e, t, r, this.mode));
    let { buffer: i } = this.buffer, s = i.findChild(this.index + 4, i.buffer[this.index + 3], e, t - this.buffer.start, r);
    return s < 0 ? !1 : (this.stack.push(this.index), this.yieldBuf(s));
  }
  /**
  Move the cursor to this node's first child. When this returns
  false, the node has no child, and the cursor has not been moved.
  */
  firstChild() {
    return this.enterChild(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to this node's last child.
  */
  lastChild() {
    return this.enterChild(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to the first child that ends after `pos`.
  */
  childAfter(e) {
    return this.enterChild(
      1,
      e,
      2
      /* Side.After */
    );
  }
  /**
  Move to the last child that starts before `pos`.
  */
  childBefore(e) {
    return this.enterChild(
      -1,
      e,
      -2
      /* Side.Before */
    );
  }
  /**
  Move the cursor to the child around `pos`. If side is -1 the
  child may end at that position, when 1 it may start there. This
  will also enter [overlaid](#common.MountedTree.overlay)
  [mounted](#common.NodeProp^mounted) trees unless `overlays` is
  set to false.
  */
  enter(e, t, r = this.mode) {
    return this.buffer ? r & kr.ExcludeBuffers ? !1 : this.enterChild(1, e, t) : this.yield(this._tree.enter(e, t, r));
  }
  /**
  Move to the node's parent node, if this isn't the top node.
  */
  parent() {
    if (!this.buffer)
      return this.yieldNode(this.mode & kr.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    let e = this.mode & kr.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    return this.buffer = null, this.yieldNode(e);
  }
  /**
  @internal
  */
  sibling(e) {
    if (!this.buffer)
      return this._tree._parent ? this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + e, e, 0, 4, this.mode)) : !1;
    let { buffer: t } = this.buffer, r = this.stack.length - 1;
    if (e < 0) {
      let i = r < 0 ? 0 : this.stack[r] + 4;
      if (this.index != i)
        return this.yieldBuf(t.findChild(
          i,
          this.index,
          -1,
          0,
          4
          /* Side.DontCare */
        ));
    } else {
      let i = t.buffer[this.index + 3];
      if (i < (r < 0 ? t.buffer.length : t.buffer[this.stack[r] + 3]))
        return this.yieldBuf(i);
    }
    return r < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + e, e, 0, 4, this.mode)) : !1;
  }
  /**
  Move to this node's next sibling, if any.
  */
  nextSibling() {
    return this.sibling(1);
  }
  /**
  Move to this node's previous sibling, if any.
  */
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(e) {
    let t, r, { buffer: i } = this;
    if (i) {
      if (e > 0) {
        if (this.index < i.buffer.buffer.length)
          return !1;
      } else
        for (let s = 0; s < this.index; s++)
          if (i.buffer.buffer[s + 3] < this.index)
            return !1;
      ({ index: t, parent: r } = i);
    } else
      ({ index: t, _parent: r } = this._tree);
    for (; r; { index: t, _parent: r } = r)
      if (t > -1)
        for (let s = t + e, o = e < 0 ? -1 : r._tree.children.length; s != o; s += e) {
          let a = r._tree.children[s];
          if (this.mode & kr.IncludeAnonymous || a instanceof bc || !a.type.isAnonymous || zO(a))
            return !1;
        }
    return !0;
  }
  move(e, t) {
    if (t && this.enterChild(
      e,
      0,
      4
      /* Side.DontCare */
    ))
      return !0;
    for (; ; ) {
      if (this.sibling(e))
        return !0;
      if (this.atLastNode(e) || !this.parent())
        return !1;
    }
  }
  /**
  Move to the next node in a
  [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
  traversal, going from a node to its first child or, if the
  current node is empty or `enter` is false, its next sibling or
  the next sibling of the first parent node that has one.
  */
  next(e = !0) {
    return this.move(1, e);
  }
  /**
  Move to the next node in a last-to-first pre-order traversal. A
  node is followed by its last child or, if it has none, its
  previous sibling or the previous sibling of the first parent
  node that has one.
  */
  prev(e = !0) {
    return this.move(-1, e);
  }
  /**
  Move the cursor to the innermost node that covers `pos`. If
  `side` is -1, it will enter nodes that end at `pos`. If it is 1,
  it will enter nodes that start at `pos`.
  */
  moveTo(e, t = 0) {
    for (; (this.from == this.to || (t < 1 ? this.from >= e : this.from > e) || (t > -1 ? this.to <= e : this.to < e)) && this.parent(); )
      ;
    for (; this.enterChild(1, e, t); )
      ;
    return this;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) at the cursor's current
  position.
  */
  get node() {
    if (!this.buffer)
      return this._tree;
    let e = this.bufferNode, t = null, r = 0;
    if (e && e.context == this.buffer)
      e: for (let i = this.index, s = this.stack.length; s >= 0; ) {
        for (let o = e; o; o = o._parent)
          if (o.index == i) {
            if (i == this.index)
              return o;
            t = o, r = s + 1;
            break e;
          }
        i = this.stack[--s];
      }
    for (let i = r; i < this.stack.length; i++)
      t = new ec(this.buffer, t, this.stack[i]);
    return this.bufferNode = new ec(this.buffer, t, this.index);
  }
  /**
  Get the [tree](#common.Tree) that represents the current node, if
  any. Will return null when the node is in a [tree
  buffer](#common.TreeBuffer).
  */
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  /**
  Iterate over the current node and all its descendants, calling
  `enter` when entering a node and `leave`, if given, when leaving
  one. When `enter` returns `false`, any children of that node are
  skipped, and `leave` isn't called for it.
  */
  iterate(e, t) {
    for (let r = 0; ; ) {
      let i = !1;
      if (this.type.isAnonymous || e(this) !== !1) {
        if (this.firstChild()) {
          r++;
          continue;
        }
        this.type.isAnonymous || (i = !0);
      }
      for (; ; ) {
        if (i && t && t(this), i = this.type.isAnonymous, !r)
          return;
        if (this.nextSibling())
          break;
        this.parent(), r--, i = !0;
      }
    }
  }
  /**
  Test whether the current node matches a given context—a sequence
  of direct parent node names. Empty strings in the context array
  are treated as wildcards.
  */
  matchContext(e) {
    if (!this.buffer)
      return T9(this.node.parent, e);
    let { buffer: t } = this.buffer, { types: r } = t.set;
    for (let i = e.length - 1, s = this.stack.length - 1; i >= 0; s--) {
      if (s < 0)
        return T9(this._tree, e, i);
      let o = r[t.buffer[this.stack[s]]];
      if (!o.isAnonymous) {
        if (e[i] && e[i] != o.name)
          return !1;
        i--;
      }
    }
    return !0;
  }
}
function zO(n) {
  return n.children.some((e) => e instanceof bc || !e.type.isAnonymous || zO(e));
}
function npt(n) {
  var e;
  let { buffer: t, nodeSet: r, maxBufferLength: i = rle, reused: s = [], minRepeatType: o = r.types.length } = n, a = Array.isArray(t) ? new BO(t, t.length) : t, l = r.types, c = 0, u = 0;
  function d(w, C, S, M, k, _) {
    let { id: O, start: I, end: R, size: P } = a, D = u, L = c;
    if (P < 0)
      if (a.next(), P == -1) {
        let U = s[O];
        S.push(U), M.push(I - w);
        return;
      } else if (P == -3) {
        c = O;
        return;
      } else if (P == -4) {
        u = O;
        return;
      } else
        throw new RangeError(`Unrecognized record size: ${P}`);
    let B = l[O], $, z, H = I - w;
    if (R - I <= i && (z = v(a.pos - C, k))) {
      let U = new Uint16Array(z.size - z.skip), F = a.pos - z.size, V = U.length;
      for (; a.pos > F; )
        V = y(z.start, U, V);
      $ = new bc(U, R - z.start, r), H = z.start - w;
    } else {
      let U = a.pos - P;
      a.next();
      let F = [], V = [], X = O >= o ? O : -1, Z = 0, ie = R;
      for (; a.pos > U; )
        X >= 0 && a.id == X && a.size >= 0 ? (a.end <= ie - i && (m(F, V, I, Z, a.end, ie, X, D, L), Z = F.length, ie = a.end), a.next()) : _ > 2500 ? f(I, U, F, V) : d(I, U, F, V, X, _ + 1);
      if (X >= 0 && Z > 0 && Z < F.length && m(F, V, I, Z, I, ie, X, D, L), F.reverse(), V.reverse(), X > -1 && Z > 0) {
        let J = h(B, L);
        $ = HO(B, F, V, 0, F.length, 0, R - I, J, J);
      } else
        $ = g(B, F, V, R - I, D - R, L);
    }
    S.push($), M.push(H);
  }
  function f(w, C, S, M) {
    let k = [], _ = 0, O = -1;
    for (; a.pos > C; ) {
      let { id: I, start: R, end: P, size: D } = a;
      if (D > 4)
        a.next();
      else {
        if (O > -1 && R < O)
          break;
        O < 0 && (O = P - i), k.push(I, R, P), _++, a.next();
      }
    }
    if (_) {
      let I = new Uint16Array(_ * 4), R = k[k.length - 2];
      for (let P = k.length - 3, D = 0; P >= 0; P -= 3)
        I[D++] = k[P], I[D++] = k[P + 1] - R, I[D++] = k[P + 2] - R, I[D++] = D;
      S.push(new bc(I, k[2] - R, r)), M.push(R - w);
    }
  }
  function h(w, C) {
    return (S, M, k) => {
      let _ = 0, O = S.length - 1, I, R;
      if (O >= 0 && (I = S[O]) instanceof ar) {
        if (!O && I.type == w && I.length == k)
          return I;
        (R = I.prop(Lt.lookAhead)) && (_ = M[O] + I.length + R);
      }
      return g(w, S, M, k, _, C);
    };
  }
  function m(w, C, S, M, k, _, O, I, R) {
    let P = [], D = [];
    for (; w.length > M; )
      P.push(w.pop()), D.push(C.pop() + S - k);
    w.push(g(r.types[O], P, D, _ - k, I - _, R)), C.push(k - S);
  }
  function g(w, C, S, M, k, _, O) {
    if (_) {
      let I = [Lt.contextHash, _];
      O = O ? [I].concat(O) : [I];
    }
    if (k > 25) {
      let I = [Lt.lookAhead, k];
      O = O ? [I].concat(O) : [I];
    }
    return new ar(w, C, S, M, O);
  }
  function v(w, C) {
    let S = a.fork(), M = 0, k = 0, _ = 0, O = S.end - i, I = { size: 0, start: 0, skip: 0 };
    e: for (let R = S.pos - w; S.pos > R; ) {
      let P = S.size;
      if (S.id == C && P >= 0) {
        I.size = M, I.start = k, I.skip = _, _ += 4, M += 4, S.next();
        continue;
      }
      let D = S.pos - P;
      if (P < 0 || D < R || S.start < O)
        break;
      let L = S.id >= o ? 4 : 0, B = S.start;
      for (S.next(); S.pos > D; ) {
        if (S.size < 0)
          if (S.size == -3)
            L += 4;
          else
            break e;
        else S.id >= o && (L += 4);
        S.next();
      }
      k = B, M += P, _ += L;
    }
    return (C < 0 || M == w) && (I.size = M, I.start = k, I.skip = _), I.size > 4 ? I : void 0;
  }
  function y(w, C, S) {
    let { id: M, start: k, end: _, size: O } = a;
    if (a.next(), O >= 0 && M < o) {
      let I = S;
      if (O > 4) {
        let R = a.pos - (O - 4);
        for (; a.pos > R; )
          S = y(w, C, S);
      }
      C[--S] = I, C[--S] = _ - w, C[--S] = k - w, C[--S] = M;
    } else O == -3 ? c = M : O == -4 && (u = M);
    return S;
  }
  let b = [], x = [];
  for (; a.pos > 0; )
    d(n.start || 0, n.bufferStart || 0, b, x, -1, 0);
  let E = (e = n.length) !== null && e !== void 0 ? e : b.length ? x[0] + b[0].length : 0;
  return new ar(l[n.topID], b.reverse(), x.reverse(), E);
}
const vj = /* @__PURE__ */ new WeakMap();
function i2(n, e) {
  if (!n.isAnonymous || e instanceof bc || e.type != n)
    return 1;
  let t = vj.get(e);
  if (t == null) {
    t = 1;
    for (let r of e.children) {
      if (r.type != n || !(r instanceof ar)) {
        t = 1;
        break;
      }
      t += i2(n, r);
    }
    vj.set(e, t);
  }
  return t;
}
function HO(n, e, t, r, i, s, o, a, l) {
  let c = 0;
  for (let m = r; m < i; m++)
    c += i2(n, e[m]);
  let u = Math.ceil(
    c * 1.5 / 8
    /* Balance.BranchFactor */
  ), d = [], f = [];
  function h(m, g, v, y, b) {
    for (let x = v; x < y; ) {
      let E = x, w = g[x], C = i2(n, m[x]);
      for (x++; x < y; x++) {
        let S = i2(n, m[x]);
        if (C + S >= u)
          break;
        C += S;
      }
      if (x == E + 1) {
        if (C > u) {
          let S = m[E];
          h(S.children, S.positions, 0, S.children.length, g[E] + b);
          continue;
        }
        d.push(m[E]);
      } else {
        let S = g[x - 1] + m[x - 1].length - w;
        d.push(HO(n, m, g, E, x, w, S, null, l));
      }
      f.push(w + b - s);
    }
  }
  return h(e, t, r, i, 0), (a || l)(d, f, o);
}
class _u {
  /**
  Construct a tree fragment. You'll usually want to use
  [`addTree`](#common.TreeFragment^addTree) and
  [`applyChanges`](#common.TreeFragment^applyChanges) instead of
  calling this directly.
  */
  constructor(e, t, r, i, s = !1, o = !1) {
    this.from = e, this.to = t, this.tree = r, this.offset = i, this.open = (s ? 1 : 0) | (o ? 2 : 0);
  }
  /**
  Whether the start of the fragment represents the start of a
  parse, or the end of a change. (In the second case, it may not
  be safe to reuse some nodes at the start, depending on the
  parsing algorithm.)
  */
  get openStart() {
    return (this.open & 1) > 0;
  }
  /**
  Whether the end of the fragment represents the end of a
  full-document parse, or the start of a change.
  */
  get openEnd() {
    return (this.open & 2) > 0;
  }
  /**
  Create a set of fragments from a freshly parsed tree, or update
  an existing set of fragments by replacing the ones that overlap
  with a tree with content from the new tree. When `partial` is
  true, the parse is treated as incomplete, and the resulting
  fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
  true.
  */
  static addTree(e, t = [], r = !1) {
    let i = [new _u(0, e.length, e, 0, !1, r)];
    for (let s of t)
      s.to > e.length && i.push(s);
    return i;
  }
  /**
  Apply a set of edits to an array of fragments, removing or
  splitting fragments as necessary to remove edited ranges, and
  adjusting offsets for fragments that moved.
  */
  static applyChanges(e, t, r = 128) {
    if (!t.length)
      return e;
    let i = [], s = 1, o = e.length ? e[0] : null;
    for (let a = 0, l = 0, c = 0; ; a++) {
      let u = a < t.length ? t[a] : null, d = u ? u.fromA : 1e9;
      if (d - l >= r)
        for (; o && o.from < d; ) {
          let f = o;
          if (l >= f.from || d <= f.to || c) {
            let h = Math.max(f.from, l) - c, m = Math.min(f.to, d) - c;
            f = h >= m ? null : new _u(h, m, f.tree, f.offset + c, a > 0, !!u);
          }
          if (f && i.push(f), o.to > d)
            break;
          o = s < e.length ? e[s++] : null;
        }
      if (!u)
        break;
      l = u.toA, c = u.toA - u.toB;
    }
    return i;
  }
}
class ale {
  /**
  Start a parse, returning a [partial parse](#common.PartialParse)
  object. [`fragments`](#common.TreeFragment) can be passed in to
  make the parse incremental.
  
  By default, the entire input is parsed. You can pass `ranges`,
  which should be a sorted array of non-empty, non-overlapping
  ranges, to parse only those ranges. The tree returned in that
  case will start at `ranges[0].from`.
  */
  startParse(e, t, r) {
    return typeof e == "string" && (e = new rpt(e)), r = r ? r.length ? r.map((i) => new I8(i.from, i.to)) : [new I8(0, 0)] : [new I8(0, e.length)], this.createParse(e, t || [], r);
  }
  /**
  Run a full parse, returning the resulting tree.
  */
  parse(e, t, r) {
    let i = this.startParse(e, t, r);
    for (; ; ) {
      let s = i.advance();
      if (s)
        return s;
    }
  }
}
class rpt {
  constructor(e) {
    this.string = e;
  }
  get length() {
    return this.string.length;
  }
  chunk(e) {
    return this.string.slice(e);
  }
  get lineChunks() {
    return !1;
  }
  read(e, t) {
    return this.string.slice(e, t);
  }
}
new Lt({ perNode: !0 });
class Vb {
  /**
  @internal
  */
  constructor(e, t, r, i, s, o, a, l, c, u = 0, d) {
    this.p = e, this.stack = t, this.state = r, this.reducePos = i, this.pos = s, this.score = o, this.buffer = a, this.bufferBase = l, this.curContext = c, this.lookAhead = u, this.parent = d;
  }
  /**
  @internal
  */
  toString() {
    return `[${this.stack.filter((e, t) => t % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
  }
  // Start an empty stack
  /**
  @internal
  */
  static start(e, t, r = 0) {
    let i = e.parser.context;
    return new Vb(e, [], t, r, r, 0, [], 0, i ? new yj(i, i.start) : null, 0, null);
  }
  /**
  The stack's current [context](#lr.ContextTracker) value, if
  any. Its type will depend on the context tracker's type
  parameter, or it will be `null` if there is no context
  tracker.
  */
  get context() {
    return this.curContext ? this.curContext.context : null;
  }
  // Push a state onto the stack, tracking its start position as well
  // as the buffer base at that point.
  /**
  @internal
  */
  pushState(e, t) {
    this.stack.push(this.state, t, this.bufferBase + this.buffer.length), this.state = e;
  }
  // Apply a reduce action
  /**
  @internal
  */
  reduce(e) {
    var t;
    let r = e >> 19, i = e & 65535, { parser: s } = this.p, o = this.reducePos < this.pos - 25;
    o && this.setLookAhead(this.pos);
    let a = s.dynamicPrecedence(i);
    if (a && (this.score += a), r == 0) {
      this.pushState(s.getGoto(this.state, i, !0), this.reducePos), i < s.minRepeatTerm && this.storeNode(i, this.reducePos, this.reducePos, o ? 8 : 4, !0), this.reduceContext(i, this.reducePos);
      return;
    }
    let l = this.stack.length - (r - 1) * 3 - (e & 262144 ? 6 : 0), c = l ? this.stack[l - 2] : this.p.ranges[0].from, u = this.reducePos - c;
    u >= 2e3 && !(!((t = this.p.parser.nodeSet.types[i]) === null || t === void 0) && t.isAnonymous) && (c == this.p.lastBigReductionStart ? (this.p.bigReductionCount++, this.p.lastBigReductionSize = u) : this.p.lastBigReductionSize < u && (this.p.bigReductionCount = 1, this.p.lastBigReductionStart = c, this.p.lastBigReductionSize = u));
    let d = l ? this.stack[l - 1] : 0, f = this.bufferBase + this.buffer.length - d;
    if (i < s.minRepeatTerm || e & 131072) {
      let h = s.stateFlag(
        this.state,
        1
        /* StateFlag.Skipped */
      ) ? this.pos : this.reducePos;
      this.storeNode(i, c, h, f + 4, !0);
    }
    if (e & 262144)
      this.state = this.stack[l];
    else {
      let h = this.stack[l - 3];
      this.state = s.getGoto(h, i, !0);
    }
    for (; this.stack.length > l; )
      this.stack.pop();
    this.reduceContext(i, c);
  }
  // Shift a value into the buffer
  /**
  @internal
  */
  storeNode(e, t, r, i = 4, s = !1) {
    if (e == 0 && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
      let o = this, a = this.buffer.length;
      if (a == 0 && o.parent && (a = o.bufferBase - o.parent.bufferBase, o = o.parent), a > 0 && o.buffer[a - 4] == 0 && o.buffer[a - 1] > -1) {
        if (t == r)
          return;
        if (o.buffer[a - 2] >= t) {
          o.buffer[a - 2] = r;
          return;
        }
      }
    }
    if (!s || this.pos == r)
      this.buffer.push(e, t, r, i);
    else {
      let o = this.buffer.length;
      if (o > 0 && this.buffer[o - 4] != 0) {
        let a = !1;
        for (let l = o; l > 0 && this.buffer[l - 2] > r; l -= 4)
          if (this.buffer[l - 1] >= 0) {
            a = !0;
            break;
          }
        if (a)
          for (; o > 0 && this.buffer[o - 2] > r; )
            this.buffer[o] = this.buffer[o - 4], this.buffer[o + 1] = this.buffer[o - 3], this.buffer[o + 2] = this.buffer[o - 2], this.buffer[o + 3] = this.buffer[o - 1], o -= 4, i > 4 && (i -= 4);
      }
      this.buffer[o] = e, this.buffer[o + 1] = t, this.buffer[o + 2] = r, this.buffer[o + 3] = i;
    }
  }
  // Apply a shift action
  /**
  @internal
  */
  shift(e, t, r, i) {
    if (e & 131072)
      this.pushState(e & 65535, this.pos);
    else if ((e & 262144) == 0) {
      let s = e, { parser: o } = this.p;
      (i > this.pos || t <= o.maxNode) && (this.pos = i, o.stateFlag(
        s,
        1
        /* StateFlag.Skipped */
      ) || (this.reducePos = i)), this.pushState(s, r), this.shiftContext(t, r), t <= o.maxNode && this.buffer.push(t, r, i, 4);
    } else
      this.pos = i, this.shiftContext(t, r), t <= this.p.parser.maxNode && this.buffer.push(t, r, i, 4);
  }
  // Apply an action
  /**
  @internal
  */
  apply(e, t, r, i) {
    e & 65536 ? this.reduce(e) : this.shift(e, t, r, i);
  }
  // Add a prebuilt (reused) node into the buffer.
  /**
  @internal
  */
  useNode(e, t) {
    let r = this.p.reused.length - 1;
    (r < 0 || this.p.reused[r] != e) && (this.p.reused.push(e), r++);
    let i = this.pos;
    this.reducePos = this.pos = i + e.length, this.pushState(t, i), this.buffer.push(
      r,
      i,
      this.reducePos,
      -1
      /* size == -1 means this is a reused value */
    ), this.curContext && this.updateContext(this.curContext.tracker.reuse(this.curContext.context, e, this, this.p.stream.reset(this.pos - e.length)));
  }
  // Split the stack. Due to the buffer sharing and the fact
  // that `this.stack` tends to stay quite shallow, this isn't very
  // expensive.
  /**
  @internal
  */
  split() {
    let e = this, t = e.buffer.length;
    for (; t > 0 && e.buffer[t - 2] > e.reducePos; )
      t -= 4;
    let r = e.buffer.slice(t), i = e.bufferBase + t;
    for (; e && i == e.bufferBase; )
      e = e.parent;
    return new Vb(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, r, i, this.curContext, this.lookAhead, e);
  }
  // Try to recover from an error by 'deleting' (ignoring) one token.
  /**
  @internal
  */
  recoverByDelete(e, t) {
    let r = e <= this.p.parser.maxNode;
    r && this.storeNode(e, this.pos, t, 4), this.storeNode(0, this.pos, t, r ? 8 : 4), this.pos = this.reducePos = t, this.score -= 190;
  }
  /**
  Check if the given term would be able to be shifted (optionally
  after some reductions) on this stack. This can be useful for
  external tokenizers that want to make sure they only provide a
  given token when it applies.
  */
  canShift(e) {
    for (let t = new ipt(this); ; ) {
      let r = this.p.parser.stateSlot(
        t.state,
        4
        /* ParseState.DefaultReduce */
      ) || this.p.parser.hasAction(t.state, e);
      if (r == 0)
        return !1;
      if ((r & 65536) == 0)
        return !0;
      t.reduce(r);
    }
  }
  // Apply up to Recover.MaxNext recovery actions that conceptually
  // inserts some missing token or rule.
  /**
  @internal
  */
  recoverByInsert(e) {
    if (this.stack.length >= 300)
      return [];
    let t = this.p.parser.nextStates(this.state);
    if (t.length > 8 || this.stack.length >= 120) {
      let i = [];
      for (let s = 0, o; s < t.length; s += 2)
        (o = t[s + 1]) != this.state && this.p.parser.hasAction(o, e) && i.push(t[s], o);
      if (this.stack.length < 120)
        for (let s = 0; i.length < 8 && s < t.length; s += 2) {
          let o = t[s + 1];
          i.some((a, l) => l & 1 && a == o) || i.push(t[s], o);
        }
      t = i;
    }
    let r = [];
    for (let i = 0; i < t.length && r.length < 4; i += 2) {
      let s = t[i + 1];
      if (s == this.state)
        continue;
      let o = this.split();
      o.pushState(s, this.pos), o.storeNode(0, o.pos, o.pos, 4, !0), o.shiftContext(t[i], this.pos), o.reducePos = this.pos, o.score -= 200, r.push(o);
    }
    return r;
  }
  // Force a reduce, if possible. Return false if that can't
  // be done.
  /**
  @internal
  */
  forceReduce() {
    let { parser: e } = this.p, t = e.stateSlot(
      this.state,
      5
      /* ParseState.ForcedReduce */
    );
    if ((t & 65536) == 0)
      return !1;
    if (!e.validAction(this.state, t)) {
      let r = t >> 19, i = t & 65535, s = this.stack.length - r * 3;
      if (s < 0 || e.getGoto(this.stack[s], i, !1) < 0) {
        let o = this.findForcedReduction();
        if (o == null)
          return !1;
        t = o;
      }
      this.storeNode(0, this.pos, this.pos, 4, !0), this.score -= 100;
    }
    return this.reducePos = this.pos, this.reduce(t), !0;
  }
  /**
  Try to scan through the automaton to find some kind of reduction
  that can be applied. Used when the regular ForcedReduce field
  isn't a valid action. @internal
  */
  findForcedReduction() {
    let { parser: e } = this.p, t = [], r = (i, s) => {
      if (!t.includes(i))
        return t.push(i), e.allActions(i, (o) => {
          if (!(o & 393216)) if (o & 65536) {
            let a = (o >> 19) - s;
            if (a > 1) {
              let l = o & 65535, c = this.stack.length - a * 3;
              if (c >= 0 && e.getGoto(this.stack[c], l, !1) >= 0)
                return a << 19 | 65536 | l;
            }
          } else {
            let a = r(o, s + 1);
            if (a != null)
              return a;
          }
        });
    };
    return r(this.state, 0);
  }
  /**
  @internal
  */
  forceAll() {
    for (; !this.p.parser.stateFlag(
      this.state,
      2
      /* StateFlag.Accepting */
    ); )
      if (!this.forceReduce()) {
        this.storeNode(0, this.pos, this.pos, 4, !0);
        break;
      }
    return this;
  }
  /**
  Check whether this state has no further actions (assumed to be a direct descendant of the
  top state, since any other states must be able to continue
  somehow). @internal
  */
  get deadEnd() {
    if (this.stack.length != 3)
      return !1;
    let { parser: e } = this.p;
    return e.data[e.stateSlot(
      this.state,
      1
      /* ParseState.Actions */
    )] == 65535 && !e.stateSlot(
      this.state,
      4
      /* ParseState.DefaultReduce */
    );
  }
  /**
  Restart the stack (put it back in its start state). Only safe
  when this.stack.length == 3 (state is directly below the top
  state). @internal
  */
  restart() {
    this.storeNode(0, this.pos, this.pos, 4, !0), this.state = this.stack[0], this.stack.length = 0;
  }
  /**
  @internal
  */
  sameState(e) {
    if (this.state != e.state || this.stack.length != e.stack.length)
      return !1;
    for (let t = 0; t < this.stack.length; t += 3)
      if (this.stack[t] != e.stack[t])
        return !1;
    return !0;
  }
  /**
  Get the parser used by this stack.
  */
  get parser() {
    return this.p.parser;
  }
  /**
  Test whether a given dialect (by numeric ID, as exported from
  the terms file) is enabled.
  */
  dialectEnabled(e) {
    return this.p.parser.dialect.flags[e];
  }
  shiftContext(e, t) {
    this.curContext && this.updateContext(this.curContext.tracker.shift(this.curContext.context, e, this, this.p.stream.reset(t)));
  }
  reduceContext(e, t) {
    this.curContext && this.updateContext(this.curContext.tracker.reduce(this.curContext.context, e, this, this.p.stream.reset(t)));
  }
  /**
  @internal
  */
  emitContext() {
    let e = this.buffer.length - 1;
    (e < 0 || this.buffer[e] != -3) && this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
  }
  /**
  @internal
  */
  emitLookAhead() {
    let e = this.buffer.length - 1;
    (e < 0 || this.buffer[e] != -4) && this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
  }
  updateContext(e) {
    if (e != this.curContext.context) {
      let t = new yj(this.curContext.tracker, e);
      t.hash != this.curContext.hash && this.emitContext(), this.curContext = t;
    }
  }
  /**
  @internal
  */
  setLookAhead(e) {
    e > this.lookAhead && (this.emitLookAhead(), this.lookAhead = e);
  }
  /**
  @internal
  */
  close() {
    this.curContext && this.curContext.tracker.strict && this.emitContext(), this.lookAhead > 0 && this.emitLookAhead();
  }
}
class yj {
  constructor(e, t) {
    this.tracker = e, this.context = t, this.hash = e.strict ? e.hash(t) : 0;
  }
}
class ipt {
  constructor(e) {
    this.start = e, this.state = e.state, this.stack = e.stack, this.base = this.stack.length;
  }
  reduce(e) {
    let t = e & 65535, r = e >> 19;
    r == 0 ? (this.stack == this.start.stack && (this.stack = this.stack.slice()), this.stack.push(this.state, 0, 0), this.base += 3) : this.base -= (r - 1) * 3;
    let i = this.start.p.parser.getGoto(this.stack[this.base - 3], t, !0);
    this.state = i;
  }
}
class jb {
  constructor(e, t, r) {
    this.stack = e, this.pos = t, this.index = r, this.buffer = e.buffer, this.index == 0 && this.maybeNext();
  }
  static create(e, t = e.bufferBase + e.buffer.length) {
    return new jb(e, t, t - e.bufferBase);
  }
  maybeNext() {
    let e = this.stack.parent;
    e != null && (this.index = this.stack.bufferBase - e.bufferBase, this.stack = e, this.buffer = e.buffer);
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  next() {
    this.index -= 4, this.pos -= 4, this.index == 0 && this.maybeNext();
  }
  fork() {
    return new jb(this.stack, this.pos, this.index);
  }
}
function mv(n, e = Uint16Array) {
  if (typeof n != "string")
    return n;
  let t = null;
  for (let r = 0, i = 0; r < n.length; ) {
    let s = 0;
    for (; ; ) {
      let o = n.charCodeAt(r++), a = !1;
      if (o == 126) {
        s = 65535;
        break;
      }
      o >= 92 && o--, o >= 34 && o--;
      let l = o - 32;
      if (l >= 46 && (l -= 46, a = !0), s += l, a)
        break;
      s *= 46;
    }
    t ? t[i++] = s : t = new e(s);
  }
  return t;
}
class s2 {
  constructor() {
    this.start = -1, this.value = -1, this.end = -1, this.extended = -1, this.lookAhead = 0, this.mask = 0, this.context = 0;
  }
}
const bj = new s2();
class spt {
  /**
  @internal
  */
  constructor(e, t) {
    this.input = e, this.ranges = t, this.chunk = "", this.chunkOff = 0, this.chunk2 = "", this.chunk2Pos = 0, this.next = -1, this.token = bj, this.rangeIndex = 0, this.pos = this.chunkPos = t[0].from, this.range = t[0], this.end = t[t.length - 1].to, this.readNext();
  }
  /**
  @internal
  */
  resolveOffset(e, t) {
    let r = this.range, i = this.rangeIndex, s = this.pos + e;
    for (; s < r.from; ) {
      if (!i)
        return null;
      let o = this.ranges[--i];
      s -= r.from - o.to, r = o;
    }
    for (; t < 0 ? s > r.to : s >= r.to; ) {
      if (i == this.ranges.length - 1)
        return null;
      let o = this.ranges[++i];
      s += o.from - r.to, r = o;
    }
    return s;
  }
  /**
  @internal
  */
  clipPos(e) {
    if (e >= this.range.from && e < this.range.to)
      return e;
    for (let t of this.ranges)
      if (t.to > e)
        return Math.max(e, t.from);
    return this.end;
  }
  /**
  Look at a code unit near the stream position. `.peek(0)` equals
  `.next`, `.peek(-1)` gives you the previous character, and so
  on.
  
  Note that looking around during tokenizing creates dependencies
  on potentially far-away content, which may reduce the
  effectiveness incremental parsing—when looking forward—or even
  cause invalid reparses when looking backward more than 25 code
  units, since the library does not track lookbehind.
  */
  peek(e) {
    let t = this.chunkOff + e, r, i;
    if (t >= 0 && t < this.chunk.length)
      r = this.pos + e, i = this.chunk.charCodeAt(t);
    else {
      let s = this.resolveOffset(e, 1);
      if (s == null)
        return -1;
      if (r = s, r >= this.chunk2Pos && r < this.chunk2Pos + this.chunk2.length)
        i = this.chunk2.charCodeAt(r - this.chunk2Pos);
      else {
        let o = this.rangeIndex, a = this.range;
        for (; a.to <= r; )
          a = this.ranges[++o];
        this.chunk2 = this.input.chunk(this.chunk2Pos = r), r + this.chunk2.length > a.to && (this.chunk2 = this.chunk2.slice(0, a.to - r)), i = this.chunk2.charCodeAt(0);
      }
    }
    return r >= this.token.lookAhead && (this.token.lookAhead = r + 1), i;
  }
  /**
  Accept a token. By default, the end of the token is set to the
  current stream position, but you can pass an offset (relative to
  the stream position) to change that.
  */
  acceptToken(e, t = 0) {
    let r = t ? this.resolveOffset(t, -1) : this.pos;
    if (r == null || r < this.token.start)
      throw new RangeError("Token end out of bounds");
    this.token.value = e, this.token.end = r;
  }
  /**
  Accept a token ending at a specific given position.
  */
  acceptTokenTo(e, t) {
    this.token.value = e, this.token.end = t;
  }
  getChunk() {
    if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
      let { chunk: e, chunkPos: t } = this;
      this.chunk = this.chunk2, this.chunkPos = this.chunk2Pos, this.chunk2 = e, this.chunk2Pos = t, this.chunkOff = this.pos - this.chunkPos;
    } else {
      this.chunk2 = this.chunk, this.chunk2Pos = this.chunkPos;
      let e = this.input.chunk(this.pos), t = this.pos + e.length;
      this.chunk = t > this.range.to ? e.slice(0, this.range.to - this.pos) : e, this.chunkPos = this.pos, this.chunkOff = 0;
    }
  }
  readNext() {
    return this.chunkOff >= this.chunk.length && (this.getChunk(), this.chunkOff == this.chunk.length) ? this.next = -1 : this.next = this.chunk.charCodeAt(this.chunkOff);
  }
  /**
  Move the stream forward N (defaults to 1) code units. Returns
  the new value of [`next`](#lr.InputStream.next).
  */
  advance(e = 1) {
    for (this.chunkOff += e; this.pos + e >= this.range.to; ) {
      if (this.rangeIndex == this.ranges.length - 1)
        return this.setDone();
      e -= this.range.to - this.pos, this.range = this.ranges[++this.rangeIndex], this.pos = this.range.from;
    }
    return this.pos += e, this.pos >= this.token.lookAhead && (this.token.lookAhead = this.pos + 1), this.readNext();
  }
  setDone() {
    return this.pos = this.chunkPos = this.end, this.range = this.ranges[this.rangeIndex = this.ranges.length - 1], this.chunk = "", this.next = -1;
  }
  /**
  @internal
  */
  reset(e, t) {
    if (t ? (this.token = t, t.start = e, t.lookAhead = e + 1, t.value = t.extended = -1) : this.token = bj, this.pos != e) {
      if (this.pos = e, e == this.end)
        return this.setDone(), this;
      for (; e < this.range.from; )
        this.range = this.ranges[--this.rangeIndex];
      for (; e >= this.range.to; )
        this.range = this.ranges[++this.rangeIndex];
      e >= this.chunkPos && e < this.chunkPos + this.chunk.length ? this.chunkOff = e - this.chunkPos : (this.chunk = "", this.chunkOff = 0), this.readNext();
    }
    return this;
  }
  /**
  @internal
  */
  read(e, t) {
    if (e >= this.chunkPos && t <= this.chunkPos + this.chunk.length)
      return this.chunk.slice(e - this.chunkPos, t - this.chunkPos);
    if (e >= this.chunk2Pos && t <= this.chunk2Pos + this.chunk2.length)
      return this.chunk2.slice(e - this.chunk2Pos, t - this.chunk2Pos);
    if (e >= this.range.from && t <= this.range.to)
      return this.input.read(e, t);
    let r = "";
    for (let i of this.ranges) {
      if (i.from >= t)
        break;
      i.to > e && (r += this.input.read(Math.max(i.from, e), Math.min(i.to, t)));
    }
    return r;
  }
}
class vf {
  constructor(e, t) {
    this.data = e, this.id = t;
  }
  token(e, t) {
    let { parser: r } = t.p;
    opt(this.data, e, t, this.id, r.data, r.tokenPrecTable);
  }
}
vf.prototype.contextual = vf.prototype.fallback = vf.prototype.extend = !1;
vf.prototype.fallback = vf.prototype.extend = !1;
function opt(n, e, t, r, i, s) {
  let o = 0, a = 1 << r, { dialect: l } = t.p.parser;
  e: for (; (a & n[o]) != 0; ) {
    let c = n[o + 1];
    for (let h = o + 3; h < c; h += 2)
      if ((n[h + 1] & a) > 0) {
        let m = n[h];
        if (l.allows(m) && (e.token.value == -1 || e.token.value == m || apt(m, e.token.value, i, s))) {
          e.acceptToken(m);
          break;
        }
      }
    let u = e.next, d = 0, f = n[o + 2];
    if (e.next < 0 && f > d && n[c + f * 3 - 3] == 65535) {
      o = n[c + f * 3 - 1];
      continue e;
    }
    for (; d < f; ) {
      let h = d + f >> 1, m = c + h + (h << 1), g = n[m], v = n[m + 1] || 65536;
      if (u < g)
        f = h;
      else if (u >= v)
        d = h + 1;
      else {
        o = n[m + 2], e.advance();
        continue e;
      }
    }
    break;
  }
}
function wj(n, e, t) {
  for (let r = e, i; (i = n[r]) != 65535; r++)
    if (i == t)
      return r - e;
  return -1;
}
function apt(n, e, t, r) {
  let i = wj(t, r, e);
  return i < 0 || wj(t, r, n) < i;
}
const Ji = typeof process < "u" && process.env && /\bparse\b/.test(process.env.LOG);
let R8 = null;
function xj(n, e, t) {
  let r = n.cursor(kr.IncludeAnonymous);
  for (r.moveTo(e); ; )
    if (!(t < 0 ? r.childBefore(e) : r.childAfter(e)))
      for (; ; ) {
        if ((t < 0 ? r.to < e : r.from > e) && !r.type.isError)
          return t < 0 ? Math.max(0, Math.min(
            r.to - 1,
            e - 25
            /* Lookahead.Margin */
          )) : Math.min(n.length, Math.max(
            r.from + 1,
            e + 25
            /* Lookahead.Margin */
          ));
        if (t < 0 ? r.prevSibling() : r.nextSibling())
          break;
        if (!r.parent())
          return t < 0 ? 0 : n.length;
      }
}
class lpt {
  constructor(e, t) {
    this.fragments = e, this.nodeSet = t, this.i = 0, this.fragment = null, this.safeFrom = -1, this.safeTo = -1, this.trees = [], this.start = [], this.index = [], this.nextFragment();
  }
  nextFragment() {
    let e = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
    if (e) {
      for (this.safeFrom = e.openStart ? xj(e.tree, e.from + e.offset, 1) - e.offset : e.from, this.safeTo = e.openEnd ? xj(e.tree, e.to + e.offset, -1) - e.offset : e.to; this.trees.length; )
        this.trees.pop(), this.start.pop(), this.index.pop();
      this.trees.push(e.tree), this.start.push(-e.offset), this.index.push(0), this.nextStart = this.safeFrom;
    } else
      this.nextStart = 1e9;
  }
  // `pos` must be >= any previously given `pos` for this cursor
  nodeAt(e) {
    if (e < this.nextStart)
      return null;
    for (; this.fragment && this.safeTo <= e; )
      this.nextFragment();
    if (!this.fragment)
      return null;
    for (; ; ) {
      let t = this.trees.length - 1;
      if (t < 0)
        return this.nextFragment(), null;
      let r = this.trees[t], i = this.index[t];
      if (i == r.children.length) {
        this.trees.pop(), this.start.pop(), this.index.pop();
        continue;
      }
      let s = r.children[i], o = this.start[t] + r.positions[i];
      if (o > e)
        return this.nextStart = o, null;
      if (s instanceof ar) {
        if (o == e) {
          if (o < this.safeFrom)
            return null;
          let a = o + s.length;
          if (a <= this.safeTo) {
            let l = s.prop(Lt.lookAhead);
            if (!l || a + l < this.fragment.to)
              return s;
          }
        }
        this.index[t]++, o + s.length >= Math.max(this.safeFrom, e) && (this.trees.push(s), this.start.push(o), this.index.push(0));
      } else
        this.index[t]++, this.nextStart = o + s.length;
    }
  }
}
class cpt {
  constructor(e, t) {
    this.stream = t, this.tokens = [], this.mainToken = null, this.actions = [], this.tokens = e.tokenizers.map((r) => new s2());
  }
  getActions(e) {
    let t = 0, r = null, { parser: i } = e.p, { tokenizers: s } = i, o = i.stateSlot(
      e.state,
      3
      /* ParseState.TokenizerMask */
    ), a = e.curContext ? e.curContext.hash : 0, l = 0;
    for (let c = 0; c < s.length; c++) {
      if ((1 << c & o) == 0)
        continue;
      let u = s[c], d = this.tokens[c];
      if (!(r && !u.fallback) && ((u.contextual || d.start != e.pos || d.mask != o || d.context != a) && (this.updateCachedToken(d, u, e), d.mask = o, d.context = a), d.lookAhead > d.end + 25 && (l = Math.max(d.lookAhead, l)), d.value != 0)) {
        let f = t;
        if (d.extended > -1 && (t = this.addActions(e, d.extended, d.end, t)), t = this.addActions(e, d.value, d.end, t), !u.extend && (r = d, t > f))
          break;
      }
    }
    for (; this.actions.length > t; )
      this.actions.pop();
    return l && e.setLookAhead(l), !r && e.pos == this.stream.end && (r = new s2(), r.value = e.p.parser.eofTerm, r.start = r.end = e.pos, t = this.addActions(e, r.value, r.end, t)), this.mainToken = r, this.actions;
  }
  getMainToken(e) {
    if (this.mainToken)
      return this.mainToken;
    let t = new s2(), { pos: r, p: i } = e;
    return t.start = r, t.end = Math.min(r + 1, i.stream.end), t.value = r == i.stream.end ? i.parser.eofTerm : 0, t;
  }
  updateCachedToken(e, t, r) {
    let i = this.stream.clipPos(r.pos);
    if (t.token(this.stream.reset(i, e), r), e.value > -1) {
      let { parser: s } = r.p;
      for (let o = 0; o < s.specialized.length; o++)
        if (s.specialized[o] == e.value) {
          let a = s.specializers[o](this.stream.read(e.start, e.end), r);
          if (a >= 0 && r.p.parser.dialect.allows(a >> 1)) {
            (a & 1) == 0 ? e.value = a >> 1 : e.extended = a >> 1;
            break;
          }
        }
    } else
      e.value = 0, e.end = this.stream.clipPos(i + 1);
  }
  putAction(e, t, r, i) {
    for (let s = 0; s < i; s += 3)
      if (this.actions[s] == e)
        return i;
    return this.actions[i++] = e, this.actions[i++] = t, this.actions[i++] = r, i;
  }
  addActions(e, t, r, i) {
    let { state: s } = e, { parser: o } = e.p, { data: a } = o;
    for (let l = 0; l < 2; l++)
      for (let c = o.stateSlot(
        s,
        l ? 2 : 1
        /* ParseState.Actions */
      ); ; c += 3) {
        if (a[c] == 65535)
          if (a[c + 1] == 1)
            c = Wa(a, c + 2);
          else {
            i == 0 && a[c + 1] == 2 && (i = this.putAction(Wa(a, c + 2), t, r, i));
            break;
          }
        a[c] == t && (i = this.putAction(Wa(a, c + 1), t, r, i));
      }
    return i;
  }
}
class upt {
  constructor(e, t, r, i) {
    this.parser = e, this.input = t, this.ranges = i, this.recovering = 0, this.nextStackID = 9812, this.minStackPos = 0, this.reused = [], this.stoppedAt = null, this.lastBigReductionStart = -1, this.lastBigReductionSize = 0, this.bigReductionCount = 0, this.stream = new spt(t, i), this.tokens = new cpt(e, this.stream), this.topTerm = e.top[1];
    let { from: s } = i[0];
    this.stacks = [Vb.start(this, e.top[0], s)], this.fragments = r.length && this.stream.end - s > e.bufferLength * 4 ? new lpt(r, e.nodeSet) : null;
  }
  get parsedPos() {
    return this.minStackPos;
  }
  // Move the parser forward. This will process all parse stacks at
  // `this.pos` and try to advance them to a further position. If no
  // stack for such a position is found, it'll start error-recovery.
  //
  // When the parse is finished, this will return a syntax tree. When
  // not, it returns `null`.
  advance() {
    let e = this.stacks, t = this.minStackPos, r = this.stacks = [], i, s;
    if (this.bigReductionCount > 300 && e.length == 1) {
      let [o] = e;
      for (; o.forceReduce() && o.stack.length && o.stack[o.stack.length - 2] >= this.lastBigReductionStart; )
        ;
      this.bigReductionCount = this.lastBigReductionSize = 0;
    }
    for (let o = 0; o < e.length; o++) {
      let a = e[o];
      for (; ; ) {
        if (this.tokens.mainToken = null, a.pos > t)
          r.push(a);
        else {
          if (this.advanceStack(a, r, e))
            continue;
          {
            i || (i = [], s = []), i.push(a);
            let l = this.tokens.getMainToken(a);
            s.push(l.value, l.end);
          }
        }
        break;
      }
    }
    if (!r.length) {
      let o = i && fpt(i);
      if (o)
        return Ji && console.log("Finish with " + this.stackID(o)), this.stackToTree(o);
      if (this.parser.strict)
        throw Ji && i && console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none")), new SyntaxError("No parse at " + t);
      this.recovering || (this.recovering = 5);
    }
    if (this.recovering && i) {
      let o = this.stoppedAt != null && i[0].pos > this.stoppedAt ? i[0] : this.runRecovery(i, s, r);
      if (o)
        return Ji && console.log("Force-finish " + this.stackID(o)), this.stackToTree(o.forceAll());
    }
    if (this.recovering) {
      let o = this.recovering == 1 ? 1 : this.recovering * 3;
      if (r.length > o)
        for (r.sort((a, l) => l.score - a.score); r.length > o; )
          r.pop();
      r.some((a) => a.reducePos > t) && this.recovering--;
    } else if (r.length > 1) {
      e: for (let o = 0; o < r.length - 1; o++) {
        let a = r[o];
        for (let l = o + 1; l < r.length; l++) {
          let c = r[l];
          if (a.sameState(c) || a.buffer.length > 500 && c.buffer.length > 500)
            if ((a.score - c.score || a.buffer.length - c.buffer.length) > 0)
              r.splice(l--, 1);
            else {
              r.splice(o--, 1);
              continue e;
            }
        }
      }
      r.length > 12 && r.splice(
        12,
        r.length - 12
        /* Rec.MaxStackCount */
      );
    }
    this.minStackPos = r[0].pos;
    for (let o = 1; o < r.length; o++)
      r[o].pos < this.minStackPos && (this.minStackPos = r[o].pos);
    return null;
  }
  stopAt(e) {
    if (this.stoppedAt != null && this.stoppedAt < e)
      throw new RangeError("Can't move stoppedAt forward");
    this.stoppedAt = e;
  }
  // Returns an updated version of the given stack, or null if the
  // stack can't advance normally. When `split` and `stacks` are
  // given, stacks split off by ambiguous operations will be pushed to
  // `split`, or added to `stacks` if they move `pos` forward.
  advanceStack(e, t, r) {
    let i = e.pos, { parser: s } = this, o = Ji ? this.stackID(e) + " -> " : "";
    if (this.stoppedAt != null && i > this.stoppedAt)
      return e.forceReduce() ? e : null;
    if (this.fragments) {
      let c = e.curContext && e.curContext.tracker.strict, u = c ? e.curContext.hash : 0;
      for (let d = this.fragments.nodeAt(i); d; ) {
        let f = this.parser.nodeSet.types[d.type.id] == d.type ? s.getGoto(e.state, d.type.id) : -1;
        if (f > -1 && d.length && (!c || (d.prop(Lt.contextHash) || 0) == u))
          return e.useNode(d, f), Ji && console.log(o + this.stackID(e) + ` (via reuse of ${s.getName(d.type.id)})`), !0;
        if (!(d instanceof ar) || d.children.length == 0 || d.positions[0] > 0)
          break;
        let h = d.children[0];
        if (h instanceof ar && d.positions[0] == 0)
          d = h;
        else
          break;
      }
    }
    let a = s.stateSlot(
      e.state,
      4
      /* ParseState.DefaultReduce */
    );
    if (a > 0)
      return e.reduce(a), Ji && console.log(o + this.stackID(e) + ` (via always-reduce ${s.getName(
        a & 65535
        /* Action.ValueMask */
      )})`), !0;
    if (e.stack.length >= 8400)
      for (; e.stack.length > 6e3 && e.forceReduce(); )
        ;
    let l = this.tokens.getActions(e);
    for (let c = 0; c < l.length; ) {
      let u = l[c++], d = l[c++], f = l[c++], h = c == l.length || !r, m = h ? e : e.split(), g = this.tokens.mainToken;
      if (m.apply(u, d, g ? g.start : m.pos, f), Ji && console.log(o + this.stackID(m) + ` (via ${(u & 65536) == 0 ? "shift" : `reduce of ${s.getName(
        u & 65535
        /* Action.ValueMask */
      )}`} for ${s.getName(d)} @ ${i}${m == e ? "" : ", split"})`), h)
        return !0;
      m.pos > i ? t.push(m) : r.push(m);
    }
    return !1;
  }
  // Advance a given stack forward as far as it will go. Returns the
  // (possibly updated) stack if it got stuck, or null if it moved
  // forward and was given to `pushStackDedup`.
  advanceFully(e, t) {
    let r = e.pos;
    for (; ; ) {
      if (!this.advanceStack(e, null, null))
        return !1;
      if (e.pos > r)
        return Ej(e, t), !0;
    }
  }
  runRecovery(e, t, r) {
    let i = null, s = !1;
    for (let o = 0; o < e.length; o++) {
      let a = e[o], l = t[o << 1], c = t[(o << 1) + 1], u = Ji ? this.stackID(a) + " -> " : "";
      if (a.deadEnd && (s || (s = !0, a.restart(), Ji && console.log(u + this.stackID(a) + " (restarted)"), this.advanceFully(a, r))))
        continue;
      let d = a.split(), f = u;
      for (let h = 0; d.forceReduce() && h < 10 && (Ji && console.log(f + this.stackID(d) + " (via force-reduce)"), !this.advanceFully(d, r)); h++)
        Ji && (f = this.stackID(d) + " -> ");
      for (let h of a.recoverByInsert(l))
        Ji && console.log(u + this.stackID(h) + " (via recover-insert)"), this.advanceFully(h, r);
      this.stream.end > a.pos ? (c == a.pos && (c++, l = 0), a.recoverByDelete(l, c), Ji && console.log(u + this.stackID(a) + ` (via recover-delete ${this.parser.getName(l)})`), Ej(a, r)) : (!i || i.score < a.score) && (i = a);
    }
    return i;
  }
  // Convert the stack's buffer to a syntax tree.
  stackToTree(e) {
    return e.close(), ar.build({
      buffer: jb.create(e),
      nodeSet: this.parser.nodeSet,
      topID: this.topTerm,
      maxBufferLength: this.parser.bufferLength,
      reused: this.reused,
      start: this.ranges[0].from,
      length: e.pos - this.ranges[0].from,
      minRepeatType: this.parser.minRepeatTerm
    });
  }
  stackID(e) {
    let t = (R8 || (R8 = /* @__PURE__ */ new WeakMap())).get(e);
    return t || R8.set(e, t = String.fromCodePoint(this.nextStackID++)), t + e;
  }
}
function Ej(n, e) {
  for (let t = 0; t < e.length; t++) {
    let r = e[t];
    if (r.pos == n.pos && r.sameState(n)) {
      e[t].score < n.score && (e[t] = n);
      return;
    }
  }
  e.push(n);
}
class dpt {
  constructor(e, t, r) {
    this.source = e, this.flags = t, this.disabled = r;
  }
  allows(e) {
    return !this.disabled || this.disabled[e] == 0;
  }
}
class Wb extends ale {
  /**
  @internal
  */
  constructor(e) {
    if (super(), this.wrappers = [], e.version != 14)
      throw new RangeError(`Parser version (${e.version}) doesn't match runtime version (14)`);
    let t = e.nodeNames.split(" ");
    this.minRepeatTerm = t.length;
    for (let a = 0; a < e.repeatNodeCount; a++)
      t.push("");
    let r = Object.keys(e.topRules).map((a) => e.topRules[a][1]), i = [];
    for (let a = 0; a < t.length; a++)
      i.push([]);
    function s(a, l, c) {
      i[a].push([l, l.deserialize(String(c))]);
    }
    if (e.nodeProps)
      for (let a of e.nodeProps) {
        let l = a[0];
        typeof l == "string" && (l = Lt[l]);
        for (let c = 1; c < a.length; ) {
          let u = a[c++];
          if (u >= 0)
            s(u, l, a[c++]);
          else {
            let d = a[c + -u];
            for (let f = -u; f > 0; f--)
              s(a[c++], l, d);
            c++;
          }
        }
      }
    this.nodeSet = new FO(t.map((a, l) => ji.define({
      name: l >= this.minRepeatTerm ? void 0 : a,
      id: l,
      props: i[l],
      top: r.indexOf(l) > -1,
      error: l == 0,
      skipped: e.skippedNodes && e.skippedNodes.indexOf(l) > -1
    }))), e.propSources && (this.nodeSet = this.nodeSet.extend(...e.propSources)), this.strict = !1, this.bufferLength = rle;
    let o = mv(e.tokenData);
    this.context = e.context, this.specializerSpecs = e.specialized || [], this.specialized = new Uint16Array(this.specializerSpecs.length);
    for (let a = 0; a < this.specializerSpecs.length; a++)
      this.specialized[a] = this.specializerSpecs[a].term;
    this.specializers = this.specializerSpecs.map(Sj), this.states = mv(e.states, Uint32Array), this.data = mv(e.stateData), this.goto = mv(e.goto), this.maxTerm = e.maxTerm, this.tokenizers = e.tokenizers.map((a) => typeof a == "number" ? new vf(o, a) : a), this.topRules = e.topRules, this.dialects = e.dialects || {}, this.dynamicPrecedences = e.dynamicPrecedences || null, this.tokenPrecTable = e.tokenPrec, this.termNames = e.termNames || null, this.maxNode = this.nodeSet.types.length - 1, this.dialect = this.parseDialect(), this.top = this.topRules[Object.keys(this.topRules)[0]];
  }
  createParse(e, t, r) {
    let i = new upt(this, e, t, r);
    for (let s of this.wrappers)
      i = s(i, e, t, r);
    return i;
  }
  /**
  Get a goto table entry @internal
  */
  getGoto(e, t, r = !1) {
    let i = this.goto;
    if (t >= i[0])
      return -1;
    for (let s = i[t + 1]; ; ) {
      let o = i[s++], a = o & 1, l = i[s++];
      if (a && r)
        return l;
      for (let c = s + (o >> 1); s < c; s++)
        if (i[s] == e)
          return l;
      if (a)
        return -1;
    }
  }
  /**
  Check if this state has an action for a given terminal @internal
  */
  hasAction(e, t) {
    let r = this.data;
    for (let i = 0; i < 2; i++)
      for (let s = this.stateSlot(
        e,
        i ? 2 : 1
        /* ParseState.Actions */
      ), o; ; s += 3) {
        if ((o = r[s]) == 65535)
          if (r[s + 1] == 1)
            o = r[s = Wa(r, s + 2)];
          else {
            if (r[s + 1] == 2)
              return Wa(r, s + 2);
            break;
          }
        if (o == t || o == 0)
          return Wa(r, s + 1);
      }
    return 0;
  }
  /**
  @internal
  */
  stateSlot(e, t) {
    return this.states[e * 6 + t];
  }
  /**
  @internal
  */
  stateFlag(e, t) {
    return (this.stateSlot(
      e,
      0
      /* ParseState.Flags */
    ) & t) > 0;
  }
  /**
  @internal
  */
  validAction(e, t) {
    return !!this.allActions(e, (r) => r == t ? !0 : null);
  }
  /**
  @internal
  */
  allActions(e, t) {
    let r = this.stateSlot(
      e,
      4
      /* ParseState.DefaultReduce */
    ), i = r ? t(r) : void 0;
    for (let s = this.stateSlot(
      e,
      1
      /* ParseState.Actions */
    ); i == null; s += 3) {
      if (this.data[s] == 65535)
        if (this.data[s + 1] == 1)
          s = Wa(this.data, s + 2);
        else
          break;
      i = t(Wa(this.data, s + 1));
    }
    return i;
  }
  /**
  Get the states that can follow this one through shift actions or
  goto jumps. @internal
  */
  nextStates(e) {
    let t = [];
    for (let r = this.stateSlot(
      e,
      1
      /* ParseState.Actions */
    ); ; r += 3) {
      if (this.data[r] == 65535)
        if (this.data[r + 1] == 1)
          r = Wa(this.data, r + 2);
        else
          break;
      if ((this.data[r + 2] & 1) == 0) {
        let i = this.data[r + 1];
        t.some((s, o) => o & 1 && s == i) || t.push(this.data[r], i);
      }
    }
    return t;
  }
  /**
  Configure the parser. Returns a new parser instance that has the
  given settings modified. Settings not provided in `config` are
  kept from the original parser.
  */
  configure(e) {
    let t = Object.assign(Object.create(Wb.prototype), this);
    if (e.props && (t.nodeSet = this.nodeSet.extend(...e.props)), e.top) {
      let r = this.topRules[e.top];
      if (!r)
        throw new RangeError(`Invalid top rule name ${e.top}`);
      t.top = r;
    }
    return e.tokenizers && (t.tokenizers = this.tokenizers.map((r) => {
      let i = e.tokenizers.find((s) => s.from == r);
      return i ? i.to : r;
    })), e.specializers && (t.specializers = this.specializers.slice(), t.specializerSpecs = this.specializerSpecs.map((r, i) => {
      let s = e.specializers.find((a) => a.from == r.external);
      if (!s)
        return r;
      let o = Object.assign(Object.assign({}, r), { external: s.to });
      return t.specializers[i] = Sj(o), o;
    })), e.contextTracker && (t.context = e.contextTracker), e.dialect && (t.dialect = this.parseDialect(e.dialect)), e.strict != null && (t.strict = e.strict), e.wrap && (t.wrappers = t.wrappers.concat(e.wrap)), e.bufferLength != null && (t.bufferLength = e.bufferLength), t;
  }
  /**
  Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
  are registered for this parser.
  */
  hasWrappers() {
    return this.wrappers.length > 0;
  }
  /**
  Returns the name associated with a given term. This will only
  work for all terms when the parser was generated with the
  `--names` option. By default, only the names of tagged terms are
  stored.
  */
  getName(e) {
    return this.termNames ? this.termNames[e] : String(e <= this.maxNode && this.nodeSet.types[e].name || e);
  }
  /**
  The eof term id is always allocated directly after the node
  types. @internal
  */
  get eofTerm() {
    return this.maxNode + 1;
  }
  /**
  The type of top node produced by the parser.
  */
  get topNode() {
    return this.nodeSet.types[this.top[1]];
  }
  /**
  @internal
  */
  dynamicPrecedence(e) {
    let t = this.dynamicPrecedences;
    return t == null ? 0 : t[e] || 0;
  }
  /**
  @internal
  */
  parseDialect(e) {
    let t = Object.keys(this.dialects), r = t.map(() => !1);
    if (e)
      for (let s of e.split(" ")) {
        let o = t.indexOf(s);
        o >= 0 && (r[o] = !0);
      }
    let i = null;
    for (let s = 0; s < t.length; s++)
      if (!r[s])
        for (let o = this.dialects[t[s]], a; (a = this.data[o++]) != 65535; )
          (i || (i = new Uint8Array(this.maxTerm + 1)))[a] = 1;
    return new dpt(e, r, i);
  }
  /**
  Used by the output of the parser generator. Not available to
  user code. @hide
  */
  static deserialize(e) {
    return new Wb(e);
  }
}
function Wa(n, e) {
  return n[e] | n[e + 1] << 16;
}
function fpt(n) {
  let e = null;
  for (let t of n) {
    let r = t.p.stoppedAt;
    (t.pos == t.p.stream.end || r != null && t.pos > r) && t.p.parser.stateFlag(
      t.state,
      2
      /* StateFlag.Accepting */
    ) && (!e || e.score < t.score) && (e = t);
  }
  return e;
}
function Sj(n) {
  if (n.external) {
    let e = n.extend ? 1 : 0;
    return (t, r) => n.external(t, r) << 1 | e;
  }
  return n.get;
}
let hpt = 0;
class Os {
  /**
  @internal
  */
  constructor(e, t, r, i) {
    this.name = e, this.set = t, this.base = r, this.modified = i, this.id = hpt++;
  }
  toString() {
    let { name: e } = this;
    for (let t of this.modified)
      t.name && (e = `${t.name}(${e})`);
    return e;
  }
  static define(e, t) {
    let r = typeof e == "string" ? e : "?";
    if (e instanceof Os && (t = e), t?.base)
      throw new Error("Can not derive from a modified tag");
    let i = new Os(r, [], null, []);
    if (i.set.push(i), t)
      for (let s of t.set)
        i.set.push(s);
    return i;
  }
  /**
  Define a tag _modifier_, which is a function that, given a tag,
  will return a tag that is a subtag of the original. Applying the
  same modifier to a twice tag will return the same value (`m1(t1)
  == m1(t1)`) and applying multiple modifiers will, regardless or
  order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
  
  When multiple modifiers are applied to a given base tag, each
  smaller set of modifiers is registered as a parent, so that for
  example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
  `m1(m3(t1)`, and so on.
  */
  static defineModifier(e) {
    let t = new Gb(e);
    return (r) => r.modified.indexOf(t) > -1 ? r : Gb.get(r.base || r, r.modified.concat(t).sort((i, s) => i.id - s.id));
  }
}
let ppt = 0;
class Gb {
  constructor(e) {
    this.name = e, this.instances = [], this.id = ppt++;
  }
  static get(e, t) {
    if (!t.length)
      return e;
    let r = t[0].instances.find((a) => a.base == e && mpt(t, a.modified));
    if (r)
      return r;
    let i = [], s = new Os(e.name, i, e, t);
    for (let a of t)
      a.instances.push(s);
    let o = gpt(t);
    for (let a of e.set)
      if (!a.modified.length)
        for (let l of o)
          i.push(Gb.get(a, l));
    return s;
  }
}
function mpt(n, e) {
  return n.length == e.length && n.every((t, r) => t == e[r]);
}
function gpt(n) {
  let e = [[]];
  for (let t = 0; t < n.length; t++)
    for (let r = 0, i = e.length; r < i; r++)
      e.push(e[r].concat(n[t]));
  return e.sort((t, r) => r.length - t.length);
}
function lle(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t in n) {
    let r = n[t];
    Array.isArray(r) || (r = [r]);
    for (let i of t.split(" "))
      if (i) {
        let s = [], o = 2, a = i;
        for (let d = 0; ; ) {
          if (a == "..." && d > 0 && d + 3 == i.length) {
            o = 1;
            break;
          }
          let f = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(a);
          if (!f)
            throw new RangeError("Invalid path: " + i);
          if (s.push(f[0] == "*" ? "" : f[0][0] == '"' ? JSON.parse(f[0]) : f[0]), d += f[0].length, d == i.length)
            break;
          let h = i[d++];
          if (d == i.length && h == "!") {
            o = 0;
            break;
          }
          if (h != "/")
            throw new RangeError("Invalid path: " + i);
          a = i.slice(d);
        }
        let l = s.length - 1, c = s[l];
        if (!c)
          throw new RangeError("Invalid path: " + i);
        let u = new G0(r, o, l > 0 ? s.slice(0, l) : null);
        e[c] = u.sort(e[c]);
      }
  }
  return cle.add(e);
}
const cle = new Lt({
  combine(n, e) {
    let t, r, i;
    for (; n || e; ) {
      if (!n || e && n.depth >= e.depth ? (i = e, e = e.next) : (i = n, n = n.next), t && t.mode == i.mode && !i.context && !t.context)
        continue;
      let s = new G0(i.tags, i.mode, i.context);
      t ? t.next = s : r = s, t = s;
    }
    return r;
  }
});
class G0 {
  constructor(e, t, r, i) {
    this.tags = e, this.mode = t, this.context = r, this.next = i;
  }
  get opaque() {
    return this.mode == 0;
  }
  get inherit() {
    return this.mode == 1;
  }
  sort(e) {
    return !e || e.depth < this.depth ? (this.next = e, this) : (e.next = this.sort(e.next), e);
  }
  get depth() {
    return this.context ? this.context.length : 0;
  }
}
G0.empty = new G0([], 2, null);
function ule(n, e) {
  let t = /* @__PURE__ */ Object.create(null);
  for (let s of n)
    if (!Array.isArray(s.tag))
      t[s.tag.id] = s.class;
    else
      for (let o of s.tag)
        t[o.id] = s.class;
  let { scope: r, all: i = null } = e || {};
  return {
    style: (s) => {
      let o = i;
      for (let a of s)
        for (let l of a.set) {
          let c = t[l.id];
          if (c) {
            o = o ? o + " " + c : c;
            break;
          }
        }
      return o;
    },
    scope: r
  };
}
function vpt(n, e) {
  let t = null;
  for (let r of n) {
    let i = r.style(e);
    i && (t = t ? t + " " + i : i);
  }
  return t;
}
function ypt(n, e, t, r = 0, i = n.length) {
  let s = new bpt(r, Array.isArray(e) ? e : [e], t);
  s.highlightRange(n.cursor(), r, i, "", s.highlighters), s.flush(i);
}
class bpt {
  constructor(e, t, r) {
    this.at = e, this.highlighters = t, this.span = r, this.class = "";
  }
  startSpan(e, t) {
    t != this.class && (this.flush(e), e > this.at && (this.at = e), this.class = t);
  }
  flush(e) {
    e > this.at && this.class && this.span(this.at, e, this.class);
  }
  highlightRange(e, t, r, i, s) {
    let { type: o, from: a, to: l } = e;
    if (a >= r || l <= t)
      return;
    o.isTop && (s = this.highlighters.filter((h) => !h.scope || h.scope(o)));
    let c = i, u = wpt(e) || G0.empty, d = vpt(s, u.tags);
    if (d && (c && (c += " "), c += d, u.mode == 1 && (i += (i ? " " : "") + d)), this.startSpan(Math.max(t, a), c), u.opaque)
      return;
    let f = e.tree && e.tree.prop(Lt.mounted);
    if (f && f.overlay) {
      let h = e.node.enter(f.overlay[0].from + a, 1), m = this.highlighters.filter((v) => !v.scope || v.scope(f.tree.type)), g = e.firstChild();
      for (let v = 0, y = a; ; v++) {
        let b = v < f.overlay.length ? f.overlay[v] : null, x = b ? b.from + a : l, E = Math.max(t, y), w = Math.min(r, x);
        if (E < w && g)
          for (; e.from < w && (this.highlightRange(e, E, w, i, s), this.startSpan(Math.min(w, e.to), c), !(e.to >= x || !e.nextSibling())); )
            ;
        if (!b || x > r)
          break;
        y = b.to + a, y > t && (this.highlightRange(h.cursor(), Math.max(t, b.from + a), Math.min(r, y), "", m), this.startSpan(Math.min(r, y), c));
      }
      g && e.parent();
    } else if (e.firstChild()) {
      f && (i = "");
      do
        if (!(e.to <= t)) {
          if (e.from >= r)
            break;
          this.highlightRange(e, t, r, i, s), this.startSpan(Math.min(r, e.to), c);
        }
      while (e.nextSibling());
      e.parent();
    }
  }
}
function wpt(n) {
  let e = n.type.prop(cle);
  for (; e && e.context && !n.matchContext(e.context); )
    e = e.next;
  return e || null;
}
const Ne = Os.define, gv = Ne(), Vl = Ne(), Cj = Ne(Vl), Tj = Ne(Vl), jl = Ne(), vv = Ne(jl), P8 = Ne(jl), jo = Ne(), Kc = Ne(jo), zo = Ne(), Ho = Ne(), M9 = Ne(), vp = Ne(M9), yv = Ne(), Y = {
  /**
  A comment.
  */
  comment: gv,
  /**
  A line [comment](#highlight.tags.comment).
  */
  lineComment: Ne(gv),
  /**
  A block [comment](#highlight.tags.comment).
  */
  blockComment: Ne(gv),
  /**
  A documentation [comment](#highlight.tags.comment).
  */
  docComment: Ne(gv),
  /**
  Any kind of identifier.
  */
  name: Vl,
  /**
  The [name](#highlight.tags.name) of a variable.
  */
  variableName: Ne(Vl),
  /**
  A type [name](#highlight.tags.name).
  */
  typeName: Cj,
  /**
  A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
  */
  tagName: Ne(Cj),
  /**
  A property or field [name](#highlight.tags.name).
  */
  propertyName: Tj,
  /**
  An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
  */
  attributeName: Ne(Tj),
  /**
  The [name](#highlight.tags.name) of a class.
  */
  className: Ne(Vl),
  /**
  A label [name](#highlight.tags.name).
  */
  labelName: Ne(Vl),
  /**
  A namespace [name](#highlight.tags.name).
  */
  namespace: Ne(Vl),
  /**
  The [name](#highlight.tags.name) of a macro.
  */
  macroName: Ne(Vl),
  /**
  A literal value.
  */
  literal: jl,
  /**
  A string [literal](#highlight.tags.literal).
  */
  string: vv,
  /**
  A documentation [string](#highlight.tags.string).
  */
  docString: Ne(vv),
  /**
  A character literal (subtag of [string](#highlight.tags.string)).
  */
  character: Ne(vv),
  /**
  An attribute value (subtag of [string](#highlight.tags.string)).
  */
  attributeValue: Ne(vv),
  /**
  A number [literal](#highlight.tags.literal).
  */
  number: P8,
  /**
  An integer [number](#highlight.tags.number) literal.
  */
  integer: Ne(P8),
  /**
  A floating-point [number](#highlight.tags.number) literal.
  */
  float: Ne(P8),
  /**
  A boolean [literal](#highlight.tags.literal).
  */
  bool: Ne(jl),
  /**
  Regular expression [literal](#highlight.tags.literal).
  */
  regexp: Ne(jl),
  /**
  An escape [literal](#highlight.tags.literal), for example a
  backslash escape in a string.
  */
  escape: Ne(jl),
  /**
  A color [literal](#highlight.tags.literal).
  */
  color: Ne(jl),
  /**
  A URL [literal](#highlight.tags.literal).
  */
  url: Ne(jl),
  /**
  A language keyword.
  */
  keyword: zo,
  /**
  The [keyword](#highlight.tags.keyword) for the self or this
  object.
  */
  self: Ne(zo),
  /**
  The [keyword](#highlight.tags.keyword) for null.
  */
  null: Ne(zo),
  /**
  A [keyword](#highlight.tags.keyword) denoting some atomic value.
  */
  atom: Ne(zo),
  /**
  A [keyword](#highlight.tags.keyword) that represents a unit.
  */
  unit: Ne(zo),
  /**
  A modifier [keyword](#highlight.tags.keyword).
  */
  modifier: Ne(zo),
  /**
  A [keyword](#highlight.tags.keyword) that acts as an operator.
  */
  operatorKeyword: Ne(zo),
  /**
  A control-flow related [keyword](#highlight.tags.keyword).
  */
  controlKeyword: Ne(zo),
  /**
  A [keyword](#highlight.tags.keyword) that defines something.
  */
  definitionKeyword: Ne(zo),
  /**
  A [keyword](#highlight.tags.keyword) related to defining or
  interfacing with modules.
  */
  moduleKeyword: Ne(zo),
  /**
  An operator.
  */
  operator: Ho,
  /**
  An [operator](#highlight.tags.operator) that dereferences something.
  */
  derefOperator: Ne(Ho),
  /**
  Arithmetic-related [operator](#highlight.tags.operator).
  */
  arithmeticOperator: Ne(Ho),
  /**
  Logical [operator](#highlight.tags.operator).
  */
  logicOperator: Ne(Ho),
  /**
  Bit [operator](#highlight.tags.operator).
  */
  bitwiseOperator: Ne(Ho),
  /**
  Comparison [operator](#highlight.tags.operator).
  */
  compareOperator: Ne(Ho),
  /**
  [Operator](#highlight.tags.operator) that updates its operand.
  */
  updateOperator: Ne(Ho),
  /**
  [Operator](#highlight.tags.operator) that defines something.
  */
  definitionOperator: Ne(Ho),
  /**
  Type-related [operator](#highlight.tags.operator).
  */
  typeOperator: Ne(Ho),
  /**
  Control-flow [operator](#highlight.tags.operator).
  */
  controlOperator: Ne(Ho),
  /**
  Program or markup punctuation.
  */
  punctuation: M9,
  /**
  [Punctuation](#highlight.tags.punctuation) that separates
  things.
  */
  separator: Ne(M9),
  /**
  Bracket-style [punctuation](#highlight.tags.punctuation).
  */
  bracket: vp,
  /**
  Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
  tokens).
  */
  angleBracket: Ne(vp),
  /**
  Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
  tokens).
  */
  squareBracket: Ne(vp),
  /**
  Parentheses (usually `(` and `)` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  paren: Ne(vp),
  /**
  Braces (usually `{` and `}` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  brace: Ne(vp),
  /**
  Content, for example plain text in XML or markup documents.
  */
  content: jo,
  /**
  [Content](#highlight.tags.content) that represents a heading.
  */
  heading: Kc,
  /**
  A level 1 [heading](#highlight.tags.heading).
  */
  heading1: Ne(Kc),
  /**
  A level 2 [heading](#highlight.tags.heading).
  */
  heading2: Ne(Kc),
  /**
  A level 3 [heading](#highlight.tags.heading).
  */
  heading3: Ne(Kc),
  /**
  A level 4 [heading](#highlight.tags.heading).
  */
  heading4: Ne(Kc),
  /**
  A level 5 [heading](#highlight.tags.heading).
  */
  heading5: Ne(Kc),
  /**
  A level 6 [heading](#highlight.tags.heading).
  */
  heading6: Ne(Kc),
  /**
  A prose [content](#highlight.tags.content) separator (such as a horizontal rule).
  */
  contentSeparator: Ne(jo),
  /**
  [Content](#highlight.tags.content) that represents a list.
  */
  list: Ne(jo),
  /**
  [Content](#highlight.tags.content) that represents a quote.
  */
  quote: Ne(jo),
  /**
  [Content](#highlight.tags.content) that is emphasized.
  */
  emphasis: Ne(jo),
  /**
  [Content](#highlight.tags.content) that is styled strong.
  */
  strong: Ne(jo),
  /**
  [Content](#highlight.tags.content) that is part of a link.
  */
  link: Ne(jo),
  /**
  [Content](#highlight.tags.content) that is styled as code or
  monospace.
  */
  monospace: Ne(jo),
  /**
  [Content](#highlight.tags.content) that has a strike-through
  style.
  */
  strikethrough: Ne(jo),
  /**
  Inserted text in a change-tracking format.
  */
  inserted: Ne(),
  /**
  Deleted text.
  */
  deleted: Ne(),
  /**
  Changed text.
  */
  changed: Ne(),
  /**
  An invalid or unsyntactic element.
  */
  invalid: Ne(),
  /**
  Metadata or meta-instruction.
  */
  meta: yv,
  /**
  [Metadata](#highlight.tags.meta) that applies to the entire
  document.
  */
  documentMeta: Ne(yv),
  /**
  [Metadata](#highlight.tags.meta) that annotates or adds
  attributes to a given syntactic element.
  */
  annotation: Ne(yv),
  /**
  Processing instruction or preprocessor directive. Subtag of
  [meta](#highlight.tags.meta).
  */
  processingInstruction: Ne(yv),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that a
  given element is being defined. Expected to be used with the
  various [name](#highlight.tags.name) tags.
  */
  definition: Os.defineModifier("definition"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that
  something is constant. Mostly expected to be used with
  [variable names](#highlight.tags.variableName).
  */
  constant: Os.defineModifier("constant"),
  /**
  [Modifier](#highlight.Tag^defineModifier) used to indicate that
  a [variable](#highlight.tags.variableName) or [property
  name](#highlight.tags.propertyName) is being called or defined
  as a function.
  */
  function: Os.defineModifier("function"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that can be applied to
  [names](#highlight.tags.name) to indicate that they belong to
  the language's standard environment.
  */
  standard: Os.defineModifier("standard"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates a given
  [names](#highlight.tags.name) is local to some scope.
  */
  local: Os.defineModifier("local"),
  /**
  A generic variant [modifier](#highlight.Tag^defineModifier) that
  can be used to tag language-specific alternative variants of
  some common tag. It is recommended for themes to define special
  forms of at least the [string](#highlight.tags.string) and
  [variable name](#highlight.tags.variableName) tags, since those
  come up a lot.
  */
  special: Os.defineModifier("special")
};
for (let n in Y) {
  let e = Y[n];
  e instanceof Os && (e.name = n);
}
ule([
  { tag: Y.link, class: "tok-link" },
  { tag: Y.heading, class: "tok-heading" },
  { tag: Y.emphasis, class: "tok-emphasis" },
  { tag: Y.strong, class: "tok-strong" },
  { tag: Y.keyword, class: "tok-keyword" },
  { tag: Y.atom, class: "tok-atom" },
  { tag: Y.bool, class: "tok-bool" },
  { tag: Y.url, class: "tok-url" },
  { tag: Y.labelName, class: "tok-labelName" },
  { tag: Y.inserted, class: "tok-inserted" },
  { tag: Y.deleted, class: "tok-deleted" },
  { tag: Y.literal, class: "tok-literal" },
  { tag: Y.string, class: "tok-string" },
  { tag: Y.number, class: "tok-number" },
  { tag: [Y.regexp, Y.escape, Y.special(Y.string)], class: "tok-string2" },
  { tag: Y.variableName, class: "tok-variableName" },
  { tag: Y.local(Y.variableName), class: "tok-variableName tok-local" },
  { tag: Y.definition(Y.variableName), class: "tok-variableName tok-definition" },
  { tag: Y.special(Y.variableName), class: "tok-variableName2" },
  { tag: Y.definition(Y.propertyName), class: "tok-propertyName tok-definition" },
  { tag: Y.typeName, class: "tok-typeName" },
  { tag: Y.namespace, class: "tok-namespace" },
  { tag: Y.className, class: "tok-className" },
  { tag: Y.macroName, class: "tok-macroName" },
  { tag: Y.propertyName, class: "tok-propertyName" },
  { tag: Y.operator, class: "tok-operator" },
  { tag: Y.comment, class: "tok-comment" },
  { tag: Y.meta, class: "tok-meta" },
  { tag: Y.invalid, class: "tok-invalid" },
  { tag: Y.punctuation, class: "tok-punctuation" }
]);
const xpt = lle({
  String: Y.string,
  Number: Y.number,
  "True False": Y.bool,
  PropertyName: Y.propertyName,
  Null: Y.null,
  ", :": Y.separator,
  "[ ]": Y.squareBracket,
  "{ }": Y.brace
}), Ept = Wb.deserialize({
  version: 14,
  states: "$bOVQPOOOOQO'#Cb'#CbOnQPO'#CeOvQPO'#ClOOQO'#Cr'#CrQOQPOOOOQO'#Cg'#CgO}QPO'#CfO!SQPO'#CtOOQO,59P,59PO![QPO,59PO!aQPO'#CuOOQO,59W,59WO!iQPO,59WOVQPO,59QOqQPO'#CmO!nQPO,59`OOQO1G.k1G.kOVQPO'#CnO!vQPO,59aOOQO1G.r1G.rOOQO1G.l1G.lOOQO,59X,59XOOQO-E6k-E6kOOQO,59Y,59YOOQO-E6l-E6l",
  stateData: "#O~OeOS~OQSORSOSSOTSOWQO_ROgPO~OVXOgUO~O^[O~PVO[^O~O]_OVhX~OVaO~O]bO^iX~O^dO~O]_OVha~O]bO^ia~O",
  goto: "!kjPPPPPPkPPkqwPPPPk{!RPPP!XP!e!hXSOR^bQWQRf_TVQ_Q`WRg`QcZRicQTOQZRQe^RhbRYQR]R",
  nodeNames: "⚠ JsonText True False Null Number String } { Object Property PropertyName : , ] [ Array",
  maxTerm: 25,
  nodeProps: [
    ["isolate", -2, 6, 11, ""],
    ["openedBy", 7, "{", 14, "["],
    ["closedBy", 8, "}", 15, "]"]
  ],
  propSources: [xpt],
  skippedNodes: [0],
  repeatNodeCount: 2,
  tokenData: "(|~RaXY!WYZ!W]^!Wpq!Wrs!]|}$u}!O$z!Q!R%T!R![&c![!]&t!}#O&y#P#Q'O#Y#Z'T#b#c'r#h#i(Z#o#p(r#q#r(w~!]Oe~~!`Wpq!]qr!]rs!xs#O!]#O#P!}#P;'S!];'S;=`$o<%lO!]~!}Og~~#QXrs!]!P!Q!]#O#P!]#U#V!]#Y#Z!]#b#c!]#f#g!]#h#i!]#i#j#m~#pR!Q![#y!c!i#y#T#Z#y~#|R!Q![$V!c!i$V#T#Z$V~$YR!Q![$c!c!i$c#T#Z$c~$fR!Q![!]!c!i!]#T#Z!]~$rP;=`<%l!]~$zO]~~$}Q!Q!R%T!R![&c~%YRT~!O!P%c!g!h%w#X#Y%w~%fP!Q![%i~%nRT~!Q![%i!g!h%w#X#Y%w~%zR{|&T}!O&T!Q![&Z~&WP!Q![&Z~&`PT~!Q![&Z~&hST~!O!P%c!Q![&c!g!h%w#X#Y%w~&yO[~~'OO_~~'TO^~~'WP#T#U'Z~'^P#`#a'a~'dP#g#h'g~'jP#X#Y'm~'rOR~~'uP#i#j'x~'{P#`#a(O~(RP#`#a(U~(ZOS~~(^P#f#g(a~(dP#i#j(g~(jP#X#Y(m~(rOQ~~(wOW~~(|OV~",
  tokenizers: [0],
  topRules: { JsonText: [0, 1] },
  tokenPrec: 0
});
let k9 = [], dle = [];
(() => {
  let n = "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((e) => e ? parseInt(e, 36) : 1);
  for (let e = 0, t = 0; e < n.length; e++)
    (e % 2 ? dle : k9).push(t = t + n[e]);
})();
function Spt(n) {
  if (n < 768) return !1;
  for (let e = 0, t = k9.length; ; ) {
    let r = e + t >> 1;
    if (n < k9[r]) t = r;
    else if (n >= dle[r]) e = r + 1;
    else return !0;
    if (e == t) return !1;
  }
}
function Aj(n) {
  return n >= 127462 && n <= 127487;
}
const Mj = 8205;
function Cpt(n, e, t = !0, r = !0) {
  return (t ? fle : Tpt)(n, e, r);
}
function fle(n, e, t) {
  if (e == n.length) return e;
  e && hle(n.charCodeAt(e)) && ple(n.charCodeAt(e - 1)) && e--;
  let r = D8(n, e);
  for (e += kj(r); e < n.length; ) {
    let i = D8(n, e);
    if (r == Mj || i == Mj || t && Spt(i))
      e += kj(i), r = i;
    else if (Aj(i)) {
      let s = 0, o = e - 2;
      for (; o >= 0 && Aj(D8(n, o)); )
        s++, o -= 2;
      if (s % 2 == 0) break;
      e += 2;
    } else
      break;
  }
  return e;
}
function Tpt(n, e, t) {
  for (; e > 0; ) {
    let r = fle(n, e - 2, t);
    if (r < e) return r;
    e--;
  }
  return 0;
}
function D8(n, e) {
  let t = n.charCodeAt(e);
  if (!ple(t) || e + 1 == n.length) return t;
  let r = n.charCodeAt(e + 1);
  return hle(r) ? (t - 55296 << 10) + (r - 56320) + 65536 : t;
}
function hle(n) {
  return n >= 56320 && n < 57344;
}
function ple(n) {
  return n >= 55296 && n < 56320;
}
function kj(n) {
  return n < 65536 ? 1 : 2;
}
class jt {
  /**
  Get the line description around the given position.
  */
  lineAt(e) {
    if (e < 0 || e > this.length)
      throw new RangeError(`Invalid position ${e} in document of length ${this.length}`);
    return this.lineInner(e, !1, 1, 0);
  }
  /**
  Get the description for the given (1-based) line number.
  */
  line(e) {
    if (e < 1 || e > this.lines)
      throw new RangeError(`Invalid line number ${e} in ${this.lines}-line document`);
    return this.lineInner(e, !0, 1, 0);
  }
  /**
  Replace a range of the text with the given content.
  */
  replace(e, t, r) {
    [e, t] = ch(this, e, t);
    let i = [];
    return this.decompose(
      0,
      e,
      i,
      2
      /* Open.To */
    ), r.length && r.decompose(
      0,
      r.length,
      i,
      3
      /* Open.To */
    ), this.decompose(
      t,
      this.length,
      i,
      1
      /* Open.From */
    ), Qo.from(i, this.length - (t - e) + r.length);
  }
  /**
  Append another document to this one.
  */
  append(e) {
    return this.replace(this.length, this.length, e);
  }
  /**
  Retrieve the text between the given points.
  */
  slice(e, t = this.length) {
    [e, t] = ch(this, e, t);
    let r = [];
    return this.decompose(e, t, r, 0), Qo.from(r, t - e);
  }
  /**
  Test whether this text is equal to another instance.
  */
  eq(e) {
    if (e == this)
      return !0;
    if (e.length != this.length || e.lines != this.lines)
      return !1;
    let t = this.scanIdentical(e, 1), r = this.length - this.scanIdentical(e, -1), i = new um(this), s = new um(e);
    for (let o = t, a = t; ; ) {
      if (i.next(o), s.next(o), o = 0, i.lineBreak != s.lineBreak || i.done != s.done || i.value != s.value)
        return !1;
      if (a += i.value.length, i.done || a >= r)
        return !0;
    }
  }
  /**
  Iterate over the text. When `dir` is `-1`, iteration happens
  from end to start. This will return lines and the breaks between
  them as separate strings.
  */
  iter(e = 1) {
    return new um(this, e);
  }
  /**
  Iterate over a range of the text. When `from` > `to`, the
  iterator will run in reverse.
  */
  iterRange(e, t = this.length) {
    return new mle(this, e, t);
  }
  /**
  Return a cursor that iterates over the given range of lines,
  _without_ returning the line breaks between, and yielding empty
  strings for empty lines.
  
  When `from` and `to` are given, they should be 1-based line numbers.
  */
  iterLines(e, t) {
    let r;
    if (e == null)
      r = this.iter();
    else {
      t == null && (t = this.lines + 1);
      let i = this.line(e).from;
      r = this.iterRange(i, Math.max(i, t == this.lines + 1 ? this.length : t <= 1 ? 0 : this.line(t - 1).to));
    }
    return new gle(r);
  }
  /**
  Return the document as a string, using newline characters to
  separate lines.
  */
  toString() {
    return this.sliceString(0);
  }
  /**
  Convert the document to an array of lines (which can be
  deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
  */
  toJSON() {
    let e = [];
    return this.flatten(e), e;
  }
  /**
  @internal
  */
  constructor() {
  }
  /**
  Create a `Text` instance for the given array of lines.
  */
  static of(e) {
    if (e.length == 0)
      throw new RangeError("A document must have at least one line");
    return e.length == 1 && !e[0] ? jt.empty : e.length <= 32 ? new er(e) : Qo.from(er.split(e, []));
  }
}
class er extends jt {
  constructor(e, t = Apt(e)) {
    super(), this.text = e, this.length = t;
  }
  get lines() {
    return this.text.length;
  }
  get children() {
    return null;
  }
  lineInner(e, t, r, i) {
    for (let s = 0; ; s++) {
      let o = this.text[s], a = i + o.length;
      if ((t ? r : a) >= e)
        return new Mpt(i, a, r, o);
      i = a + 1, r++;
    }
  }
  decompose(e, t, r, i) {
    let s = e <= 0 && t >= this.length ? this : new er(_j(this.text, e, t), Math.min(t, this.length) - Math.max(0, e));
    if (i & 1) {
      let o = r.pop(), a = o2(s.text, o.text.slice(), 0, s.length);
      if (a.length <= 32)
        r.push(new er(a, o.length + s.length));
      else {
        let l = a.length >> 1;
        r.push(new er(a.slice(0, l)), new er(a.slice(l)));
      }
    } else
      r.push(s);
  }
  replace(e, t, r) {
    if (!(r instanceof er))
      return super.replace(e, t, r);
    [e, t] = ch(this, e, t);
    let i = o2(this.text, o2(r.text, _j(this.text, 0, e)), t), s = this.length + r.length - (t - e);
    return i.length <= 32 ? new er(i, s) : Qo.from(er.split(i, []), s);
  }
  sliceString(e, t = this.length, r = `
`) {
    [e, t] = ch(this, e, t);
    let i = "";
    for (let s = 0, o = 0; s <= t && o < this.text.length; o++) {
      let a = this.text[o], l = s + a.length;
      s > e && o && (i += r), e < l && t > s && (i += a.slice(Math.max(0, e - s), t - s)), s = l + 1;
    }
    return i;
  }
  flatten(e) {
    for (let t of this.text)
      e.push(t);
  }
  scanIdentical() {
    return 0;
  }
  static split(e, t) {
    let r = [], i = -1;
    for (let s of e)
      r.push(s), i += s.length + 1, r.length == 32 && (t.push(new er(r, i)), r = [], i = -1);
    return i > -1 && t.push(new er(r, i)), t;
  }
}
class Qo extends jt {
  constructor(e, t) {
    super(), this.children = e, this.length = t, this.lines = 0;
    for (let r of e)
      this.lines += r.lines;
  }
  lineInner(e, t, r, i) {
    for (let s = 0; ; s++) {
      let o = this.children[s], a = i + o.length, l = r + o.lines - 1;
      if ((t ? l : a) >= e)
        return o.lineInner(e, t, r, i);
      i = a + 1, r = l + 1;
    }
  }
  decompose(e, t, r, i) {
    for (let s = 0, o = 0; o <= t && s < this.children.length; s++) {
      let a = this.children[s], l = o + a.length;
      if (e <= l && t >= o) {
        let c = i & ((o <= e ? 1 : 0) | (l >= t ? 2 : 0));
        o >= e && l <= t && !c ? r.push(a) : a.decompose(e - o, t - o, r, c);
      }
      o = l + 1;
    }
  }
  replace(e, t, r) {
    if ([e, t] = ch(this, e, t), r.lines < this.lines)
      for (let i = 0, s = 0; i < this.children.length; i++) {
        let o = this.children[i], a = s + o.length;
        if (e >= s && t <= a) {
          let l = o.replace(e - s, t - s, r), c = this.lines - o.lines + l.lines;
          if (l.lines < c >> 4 && l.lines > c >> 6) {
            let u = this.children.slice();
            return u[i] = l, new Qo(u, this.length - (t - e) + r.length);
          }
          return super.replace(s, a, l);
        }
        s = a + 1;
      }
    return super.replace(e, t, r);
  }
  sliceString(e, t = this.length, r = `
`) {
    [e, t] = ch(this, e, t);
    let i = "";
    for (let s = 0, o = 0; s < this.children.length && o <= t; s++) {
      let a = this.children[s], l = o + a.length;
      o > e && s && (i += r), e < l && t > o && (i += a.sliceString(e - o, t - o, r)), o = l + 1;
    }
    return i;
  }
  flatten(e) {
    for (let t of this.children)
      t.flatten(e);
  }
  scanIdentical(e, t) {
    if (!(e instanceof Qo))
      return 0;
    let r = 0, [i, s, o, a] = t > 0 ? [0, 0, this.children.length, e.children.length] : [this.children.length - 1, e.children.length - 1, -1, -1];
    for (; ; i += t, s += t) {
      if (i == o || s == a)
        return r;
      let l = this.children[i], c = e.children[s];
      if (l != c)
        return r + l.scanIdentical(c, t);
      r += l.length + 1;
    }
  }
  static from(e, t = e.reduce((r, i) => r + i.length + 1, -1)) {
    let r = 0;
    for (let h of e)
      r += h.lines;
    if (r < 32) {
      let h = [];
      for (let m of e)
        m.flatten(h);
      return new er(h, t);
    }
    let i = Math.max(
      32,
      r >> 5
      /* Tree.BranchShift */
    ), s = i << 1, o = i >> 1, a = [], l = 0, c = -1, u = [];
    function d(h) {
      let m;
      if (h.lines > s && h instanceof Qo)
        for (let g of h.children)
          d(g);
      else h.lines > o && (l > o || !l) ? (f(), a.push(h)) : h instanceof er && l && (m = u[u.length - 1]) instanceof er && h.lines + m.lines <= 32 ? (l += h.lines, c += h.length + 1, u[u.length - 1] = new er(m.text.concat(h.text), m.length + 1 + h.length)) : (l + h.lines > i && f(), l += h.lines, c += h.length + 1, u.push(h));
    }
    function f() {
      l != 0 && (a.push(u.length == 1 ? u[0] : Qo.from(u, c)), c = -1, l = u.length = 0);
    }
    for (let h of e)
      d(h);
    return f(), a.length == 1 ? a[0] : new Qo(a, t);
  }
}
jt.empty = /* @__PURE__ */ new er([""], 0);
function Apt(n) {
  let e = -1;
  for (let t of n)
    e += t.length + 1;
  return e;
}
function o2(n, e, t = 0, r = 1e9) {
  for (let i = 0, s = 0, o = !0; s < n.length && i <= r; s++) {
    let a = n[s], l = i + a.length;
    l >= t && (l > r && (a = a.slice(0, r - i)), i < t && (a = a.slice(t - i)), o ? (e[e.length - 1] += a, o = !1) : e.push(a)), i = l + 1;
  }
  return e;
}
function _j(n, e, t) {
  return o2(n, [""], e, t);
}
class um {
  constructor(e, t = 1) {
    this.dir = t, this.done = !1, this.lineBreak = !1, this.value = "", this.nodes = [e], this.offsets = [t > 0 ? 1 : (e instanceof er ? e.text.length : e.children.length) << 1];
  }
  nextInner(e, t) {
    for (this.done = this.lineBreak = !1; ; ) {
      let r = this.nodes.length - 1, i = this.nodes[r], s = this.offsets[r], o = s >> 1, a = i instanceof er ? i.text.length : i.children.length;
      if (o == (t > 0 ? a : 0)) {
        if (r == 0)
          return this.done = !0, this.value = "", this;
        t > 0 && this.offsets[r - 1]++, this.nodes.pop(), this.offsets.pop();
      } else if ((s & 1) == (t > 0 ? 0 : 1)) {
        if (this.offsets[r] += t, e == 0)
          return this.lineBreak = !0, this.value = `
`, this;
        e--;
      } else if (i instanceof er) {
        let l = i.text[o + (t < 0 ? -1 : 0)];
        if (this.offsets[r] += t, l.length > Math.max(0, e))
          return this.value = e == 0 ? l : t > 0 ? l.slice(e) : l.slice(0, l.length - e), this;
        e -= l.length;
      } else {
        let l = i.children[o + (t < 0 ? -1 : 0)];
        e > l.length ? (e -= l.length, this.offsets[r] += t) : (t < 0 && this.offsets[r]--, this.nodes.push(l), this.offsets.push(t > 0 ? 1 : (l instanceof er ? l.text.length : l.children.length) << 1));
      }
    }
  }
  next(e = 0) {
    return e < 0 && (this.nextInner(-e, -this.dir), e = this.value.length), this.nextInner(e, this.dir);
  }
}
class mle {
  constructor(e, t, r) {
    this.value = "", this.done = !1, this.cursor = new um(e, t > r ? -1 : 1), this.pos = t > r ? e.length : 0, this.from = Math.min(t, r), this.to = Math.max(t, r);
  }
  nextInner(e, t) {
    if (t < 0 ? this.pos <= this.from : this.pos >= this.to)
      return this.value = "", this.done = !0, this;
    e += Math.max(0, t < 0 ? this.pos - this.to : this.from - this.pos);
    let r = t < 0 ? this.pos - this.from : this.to - this.pos;
    e > r && (e = r), r -= e;
    let { value: i } = this.cursor.next(e);
    return this.pos += (i.length + e) * t, this.value = i.length <= r ? i : t < 0 ? i.slice(i.length - r) : i.slice(0, r), this.done = !this.value, this;
  }
  next(e = 0) {
    return e < 0 ? e = Math.max(e, this.from - this.pos) : e > 0 && (e = Math.min(e, this.to - this.pos)), this.nextInner(e, this.cursor.dir);
  }
  get lineBreak() {
    return this.cursor.lineBreak && this.value != "";
  }
}
class gle {
  constructor(e) {
    this.inner = e, this.afterBreak = !0, this.value = "", this.done = !1;
  }
  next(e = 0) {
    let { done: t, lineBreak: r, value: i } = this.inner.next(e);
    return t && this.afterBreak ? (this.value = "", this.afterBreak = !1) : t ? (this.done = !0, this.value = "") : r ? this.afterBreak ? this.value = "" : (this.afterBreak = !0, this.next()) : (this.value = i, this.afterBreak = !1), this;
  }
  get lineBreak() {
    return !1;
  }
}
typeof Symbol < "u" && (jt.prototype[Symbol.iterator] = function() {
  return this.iter();
}, um.prototype[Symbol.iterator] = mle.prototype[Symbol.iterator] = gle.prototype[Symbol.iterator] = function() {
  return this;
});
class Mpt {
  /**
  @internal
  */
  constructor(e, t, r, i) {
    this.from = e, this.to = t, this.number = r, this.text = i;
  }
  /**
  The length of the line (not including any line break after it).
  */
  get length() {
    return this.to - this.from;
  }
}
function ch(n, e, t) {
  return e = Math.max(0, Math.min(n.length, e)), [e, Math.max(e, Math.min(n.length, t))];
}
function Gr(n, e, t = !0, r = !0) {
  return Cpt(n, e, t, r);
}
function kpt(n) {
  return n >= 56320 && n < 57344;
}
function _pt(n) {
  return n >= 55296 && n < 56320;
}
function Pi(n, e) {
  let t = n.charCodeAt(e);
  if (!_pt(t) || e + 1 == n.length)
    return t;
  let r = n.charCodeAt(e + 1);
  return kpt(r) ? (t - 55296 << 10) + (r - 56320) + 65536 : t;
}
function UO(n) {
  return n <= 65535 ? String.fromCharCode(n) : (n -= 65536, String.fromCharCode((n >> 10) + 55296, (n & 1023) + 56320));
}
function Jo(n) {
  return n < 65536 ? 1 : 2;
}
const _9 = /\r\n?|\n/;
var hi = /* @__PURE__ */ (function(n) {
  return n[n.Simple = 0] = "Simple", n[n.TrackDel = 1] = "TrackDel", n[n.TrackBefore = 2] = "TrackBefore", n[n.TrackAfter = 3] = "TrackAfter", n;
})(hi || (hi = {}));
class ma {
  // Sections are encoded as pairs of integers. The first is the
  // length in the current document, and the second is -1 for
  // unaffected sections, and the length of the replacement content
  // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
  // 0), and a replacement two positive numbers.
  /**
  @internal
  */
  constructor(e) {
    this.sections = e;
  }
  /**
  The length of the document before the change.
  */
  get length() {
    let e = 0;
    for (let t = 0; t < this.sections.length; t += 2)
      e += this.sections[t];
    return e;
  }
  /**
  The length of the document after the change.
  */
  get newLength() {
    let e = 0;
    for (let t = 0; t < this.sections.length; t += 2) {
      let r = this.sections[t + 1];
      e += r < 0 ? this.sections[t] : r;
    }
    return e;
  }
  /**
  False when there are actual changes in this set.
  */
  get empty() {
    return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
  }
  /**
  Iterate over the unchanged parts left by these changes. `posA`
  provides the position of the range in the old document, `posB`
  the new position in the changed document.
  */
  iterGaps(e) {
    for (let t = 0, r = 0, i = 0; t < this.sections.length; ) {
      let s = this.sections[t++], o = this.sections[t++];
      o < 0 ? (e(r, i, s), i += s) : i += o, r += s;
    }
  }
  /**
  Iterate over the ranges changed by these changes. (See
  [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
  variant that also provides you with the inserted text.)
  `fromA`/`toA` provides the extent of the change in the starting
  document, `fromB`/`toB` the extent of the replacement in the
  changed document.
  
  When `individual` is true, adjacent changes (which are kept
  separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
  reported separately.
  */
  iterChangedRanges(e, t = !1) {
    O9(this, e, t);
  }
  /**
  Get a description of the inverted form of these changes.
  */
  get invertedDesc() {
    let e = [];
    for (let t = 0; t < this.sections.length; ) {
      let r = this.sections[t++], i = this.sections[t++];
      i < 0 ? e.push(r, i) : e.push(i, r);
    }
    return new ma(e);
  }
  /**
  Compute the combined effect of applying another set of changes
  after this one. The length of the document after this set should
  match the length before `other`.
  */
  composeDesc(e) {
    return this.empty ? e : e.empty ? this : vle(this, e);
  }
  /**
  Map this description, which should start with the same document
  as `other`, over another set of changes, so that it can be
  applied after it. When `before` is true, map as if the changes
  in `this` happened before the ones in `other`.
  */
  mapDesc(e, t = !1) {
    return e.empty ? this : I9(this, e, t);
  }
  mapPos(e, t = -1, r = hi.Simple) {
    let i = 0, s = 0;
    for (let o = 0; o < this.sections.length; ) {
      let a = this.sections[o++], l = this.sections[o++], c = i + a;
      if (l < 0) {
        if (c > e)
          return s + (e - i);
        s += a;
      } else {
        if (r != hi.Simple && c >= e && (r == hi.TrackDel && i < e && c > e || r == hi.TrackBefore && i < e || r == hi.TrackAfter && c > e))
          return null;
        if (c > e || c == e && t < 0 && !a)
          return e == i || t < 0 ? s : s + l;
        s += l;
      }
      i = c;
    }
    if (e > i)
      throw new RangeError(`Position ${e} is out of range for changeset of length ${i}`);
    return s;
  }
  /**
  Check whether these changes touch a given range. When one of the
  changes entirely covers the range, the string `"cover"` is
  returned.
  */
  touchesRange(e, t = e) {
    for (let r = 0, i = 0; r < this.sections.length && i <= t; ) {
      let s = this.sections[r++], o = this.sections[r++], a = i + s;
      if (o >= 0 && i <= t && a >= e)
        return i < e && a > t ? "cover" : !0;
      i = a;
    }
    return !1;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let t = 0; t < this.sections.length; ) {
      let r = this.sections[t++], i = this.sections[t++];
      e += (e ? " " : "") + r + (i >= 0 ? ":" + i : "");
    }
    return e;
  }
  /**
  Serialize this change desc to a JSON-representable value.
  */
  toJSON() {
    return this.sections;
  }
  /**
  Create a change desc from its JSON representation (as produced
  by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
  */
  static fromJSON(e) {
    if (!Array.isArray(e) || e.length % 2 || e.some((t) => typeof t != "number"))
      throw new RangeError("Invalid JSON representation of ChangeDesc");
    return new ma(e);
  }
  /**
  @internal
  */
  static create(e) {
    return new ma(e);
  }
}
class xr extends ma {
  constructor(e, t) {
    super(e), this.inserted = t;
  }
  /**
  Apply the changes to a document, returning the modified
  document.
  */
  apply(e) {
    if (this.length != e.length)
      throw new RangeError("Applying change set to a document with the wrong length");
    return O9(this, (t, r, i, s, o) => e = e.replace(i, i + (r - t), o), !1), e;
  }
  mapDesc(e, t = !1) {
    return I9(this, e, t, !0);
  }
  /**
  Given the document as it existed _before_ the changes, return a
  change set that represents the inverse of this set, which could
  be used to go from the document created by the changes back to
  the document as it existed before the changes.
  */
  invert(e) {
    let t = this.sections.slice(), r = [];
    for (let i = 0, s = 0; i < t.length; i += 2) {
      let o = t[i], a = t[i + 1];
      if (a >= 0) {
        t[i] = a, t[i + 1] = o;
        let l = i >> 1;
        for (; r.length < l; )
          r.push(jt.empty);
        r.push(o ? e.slice(s, s + o) : jt.empty);
      }
      s += o;
    }
    return new xr(t, r);
  }
  /**
  Combine two subsequent change sets into a single set. `other`
  must start in the document produced by `this`. If `this` goes
  `docA` → `docB` and `other` represents `docB` → `docC`, the
  returned value will represent the change `docA` → `docC`.
  */
  compose(e) {
    return this.empty ? e : e.empty ? this : vle(this, e, !0);
  }
  /**
  Given another change set starting in the same document, maps this
  change set over the other, producing a new change set that can be
  applied to the document produced by applying `other`. When
  `before` is `true`, order changes as if `this` comes before
  `other`, otherwise (the default) treat `other` as coming first.
  
  Given two changes `A` and `B`, `A.compose(B.map(A))` and
  `B.compose(A.map(B, true))` will produce the same document. This
  provides a basic form of [operational
  transformation](https://en.wikipedia.org/wiki/Operational_transformation),
  and can be used for collaborative editing.
  */
  map(e, t = !1) {
    return e.empty ? this : I9(this, e, t, !0);
  }
  /**
  Iterate over the changed ranges in the document, calling `f` for
  each, with the range in the original document (`fromA`-`toA`)
  and the range that replaces it in the new document
  (`fromB`-`toB`).
  
  When `individual` is true, adjacent changes are reported
  separately.
  */
  iterChanges(e, t = !1) {
    O9(this, e, t);
  }
  /**
  Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
  set.
  */
  get desc() {
    return ma.create(this.sections);
  }
  /**
  @internal
  */
  filter(e) {
    let t = [], r = [], i = [], s = new K0(this);
    e: for (let o = 0, a = 0; ; ) {
      let l = o == e.length ? 1e9 : e[o++];
      for (; a < l || a == l && s.len == 0; ) {
        if (s.done)
          break e;
        let u = Math.min(s.len, l - a);
        ti(i, u, -1);
        let d = s.ins == -1 ? -1 : s.off == 0 ? s.ins : 0;
        ti(t, u, d), d > 0 && tc(r, t, s.text), s.forward(u), a += u;
      }
      let c = e[o++];
      for (; a < c; ) {
        if (s.done)
          break e;
        let u = Math.min(s.len, c - a);
        ti(t, u, -1), ti(i, u, s.ins == -1 ? -1 : s.off == 0 ? s.ins : 0), s.forward(u), a += u;
      }
    }
    return {
      changes: new xr(t, r),
      filtered: ma.create(i)
    };
  }
  /**
  Serialize this change set to a JSON-representable value.
  */
  toJSON() {
    let e = [];
    for (let t = 0; t < this.sections.length; t += 2) {
      let r = this.sections[t], i = this.sections[t + 1];
      i < 0 ? e.push(r) : i == 0 ? e.push([r]) : e.push([r].concat(this.inserted[t >> 1].toJSON()));
    }
    return e;
  }
  /**
  Create a change set for the given changes, for a document of the
  given length, using `lineSep` as line separator.
  */
  static of(e, t, r) {
    let i = [], s = [], o = 0, a = null;
    function l(u = !1) {
      if (!u && !i.length)
        return;
      o < t && ti(i, t - o, -1);
      let d = new xr(i, s);
      a = a ? a.compose(d.map(a)) : d, i = [], s = [], o = 0;
    }
    function c(u) {
      if (Array.isArray(u))
        for (let d of u)
          c(d);
      else if (u instanceof xr) {
        if (u.length != t)
          throw new RangeError(`Mismatched change set length (got ${u.length}, expected ${t})`);
        l(), a = a ? a.compose(u.map(a)) : u;
      } else {
        let { from: d, to: f = d, insert: h } = u;
        if (d > f || d < 0 || f > t)
          throw new RangeError(`Invalid change range ${d} to ${f} (in doc of length ${t})`);
        let m = h ? typeof h == "string" ? jt.of(h.split(r || _9)) : h : jt.empty, g = m.length;
        if (d == f && g == 0)
          return;
        d < o && l(), d > o && ti(i, d - o, -1), ti(i, f - d, g), tc(s, i, m), o = f;
      }
    }
    return c(e), l(!a), a;
  }
  /**
  Create an empty changeset of the given length.
  */
  static empty(e) {
    return new xr(e ? [e, -1] : [], []);
  }
  /**
  Create a changeset from its JSON representation (as produced by
  [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
  */
  static fromJSON(e) {
    if (!Array.isArray(e))
      throw new RangeError("Invalid JSON representation of ChangeSet");
    let t = [], r = [];
    for (let i = 0; i < e.length; i++) {
      let s = e[i];
      if (typeof s == "number")
        t.push(s, -1);
      else {
        if (!Array.isArray(s) || typeof s[0] != "number" || s.some((o, a) => a && typeof o != "string"))
          throw new RangeError("Invalid JSON representation of ChangeSet");
        if (s.length == 1)
          t.push(s[0], 0);
        else {
          for (; r.length < i; )
            r.push(jt.empty);
          r[i] = jt.of(s.slice(1)), t.push(s[0], r[i].length);
        }
      }
    }
    return new xr(t, r);
  }
  /**
  @internal
  */
  static createSet(e, t) {
    return new xr(e, t);
  }
}
function ti(n, e, t, r = !1) {
  if (e == 0 && t <= 0)
    return;
  let i = n.length - 2;
  i >= 0 && t <= 0 && t == n[i + 1] ? n[i] += e : i >= 0 && e == 0 && n[i] == 0 ? n[i + 1] += t : r ? (n[i] += e, n[i + 1] += t) : n.push(e, t);
}
function tc(n, e, t) {
  if (t.length == 0)
    return;
  let r = e.length - 2 >> 1;
  if (r < n.length)
    n[n.length - 1] = n[n.length - 1].append(t);
  else {
    for (; n.length < r; )
      n.push(jt.empty);
    n.push(t);
  }
}
function O9(n, e, t) {
  let r = n.inserted;
  for (let i = 0, s = 0, o = 0; o < n.sections.length; ) {
    let a = n.sections[o++], l = n.sections[o++];
    if (l < 0)
      i += a, s += a;
    else {
      let c = i, u = s, d = jt.empty;
      for (; c += a, u += l, l && r && (d = d.append(r[o - 2 >> 1])), !(t || o == n.sections.length || n.sections[o + 1] < 0); )
        a = n.sections[o++], l = n.sections[o++];
      e(i, c, s, u, d), i = c, s = u;
    }
  }
}
function I9(n, e, t, r = !1) {
  let i = [], s = r ? [] : null, o = new K0(n), a = new K0(e);
  for (let l = -1; ; ) {
    if (o.done && a.len || a.done && o.len)
      throw new Error("Mismatched change set lengths");
    if (o.ins == -1 && a.ins == -1) {
      let c = Math.min(o.len, a.len);
      ti(i, c, -1), o.forward(c), a.forward(c);
    } else if (a.ins >= 0 && (o.ins < 0 || l == o.i || o.off == 0 && (a.len < o.len || a.len == o.len && !t))) {
      let c = a.len;
      for (ti(i, a.ins, -1); c; ) {
        let u = Math.min(o.len, c);
        o.ins >= 0 && l < o.i && o.len <= u && (ti(i, 0, o.ins), s && tc(s, i, o.text), l = o.i), o.forward(u), c -= u;
      }
      a.next();
    } else if (o.ins >= 0) {
      let c = 0, u = o.len;
      for (; u; )
        if (a.ins == -1) {
          let d = Math.min(u, a.len);
          c += d, u -= d, a.forward(d);
        } else if (a.ins == 0 && a.len < u)
          u -= a.len, a.next();
        else
          break;
      ti(i, c, l < o.i ? o.ins : 0), s && l < o.i && tc(s, i, o.text), l = o.i, o.forward(o.len - u);
    } else {
      if (o.done && a.done)
        return s ? xr.createSet(i, s) : ma.create(i);
      throw new Error("Mismatched change set lengths");
    }
  }
}
function vle(n, e, t = !1) {
  let r = [], i = t ? [] : null, s = new K0(n), o = new K0(e);
  for (let a = !1; ; ) {
    if (s.done && o.done)
      return i ? xr.createSet(r, i) : ma.create(r);
    if (s.ins == 0)
      ti(r, s.len, 0, a), s.next();
    else if (o.len == 0 && !o.done)
      ti(r, 0, o.ins, a), i && tc(i, r, o.text), o.next();
    else {
      if (s.done || o.done)
        throw new Error("Mismatched change set lengths");
      {
        let l = Math.min(s.len2, o.len), c = r.length;
        if (s.ins == -1) {
          let u = o.ins == -1 ? -1 : o.off ? 0 : o.ins;
          ti(r, l, u, a), i && u && tc(i, r, o.text);
        } else o.ins == -1 ? (ti(r, s.off ? 0 : s.len, l, a), i && tc(i, r, s.textBit(l))) : (ti(r, s.off ? 0 : s.len, o.off ? 0 : o.ins, a), i && !o.off && tc(i, r, o.text));
        a = (s.ins > l || o.ins >= 0 && o.len > l) && (a || r.length > c), s.forward2(l), o.forward(l);
      }
    }
  }
}
class K0 {
  constructor(e) {
    this.set = e, this.i = 0, this.next();
  }
  next() {
    let { sections: e } = this.set;
    this.i < e.length ? (this.len = e[this.i++], this.ins = e[this.i++]) : (this.len = 0, this.ins = -2), this.off = 0;
  }
  get done() {
    return this.ins == -2;
  }
  get len2() {
    return this.ins < 0 ? this.len : this.ins;
  }
  get text() {
    let { inserted: e } = this.set, t = this.i - 2 >> 1;
    return t >= e.length ? jt.empty : e[t];
  }
  textBit(e) {
    let { inserted: t } = this.set, r = this.i - 2 >> 1;
    return r >= t.length && !e ? jt.empty : t[r].slice(this.off, e == null ? void 0 : this.off + e);
  }
  forward(e) {
    e == this.len ? this.next() : (this.len -= e, this.off += e);
  }
  forward2(e) {
    this.ins == -1 ? this.forward(e) : e == this.ins ? this.next() : (this.ins -= e, this.off += e);
  }
}
class pu {
  constructor(e, t, r) {
    this.from = e, this.to = t, this.flags = r;
  }
  /**
  The anchor of the range—the side that doesn't move when you
  extend it.
  */
  get anchor() {
    return this.flags & 32 ? this.to : this.from;
  }
  /**
  The head of the range, which is moved when the range is
  [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
  */
  get head() {
    return this.flags & 32 ? this.from : this.to;
  }
  /**
  True when `anchor` and `head` are at the same position.
  */
  get empty() {
    return this.from == this.to;
  }
  /**
  If this is a cursor that is explicitly associated with the
  character on one of its sides, this returns the side. -1 means
  the character before its position, 1 the character after, and 0
  means no association.
  */
  get assoc() {
    return this.flags & 8 ? -1 : this.flags & 16 ? 1 : 0;
  }
  /**
  The bidirectional text level associated with this cursor, if
  any.
  */
  get bidiLevel() {
    let e = this.flags & 7;
    return e == 7 ? null : e;
  }
  /**
  The goal column (stored vertical offset) associated with a
  cursor. This is used to preserve the vertical position when
  [moving](https://codemirror.net/6/docs/ref/#view.EditorView.moveVertically) across
  lines of different length.
  */
  get goalColumn() {
    let e = this.flags >> 6;
    return e == 16777215 ? void 0 : e;
  }
  /**
  Map this range through a change, producing a valid range in the
  updated document.
  */
  map(e, t = -1) {
    let r, i;
    return this.empty ? r = i = e.mapPos(this.from, t) : (r = e.mapPos(this.from, 1), i = e.mapPos(this.to, -1)), r == this.from && i == this.to ? this : new pu(r, i, this.flags);
  }
  /**
  Extend this range to cover at least `from` to `to`.
  */
  extend(e, t = e) {
    if (e <= this.anchor && t >= this.anchor)
      return ge.range(e, t);
    let r = Math.abs(e - this.anchor) > Math.abs(t - this.anchor) ? e : t;
    return ge.range(this.anchor, r);
  }
  /**
  Compare this range to another range.
  */
  eq(e, t = !1) {
    return this.anchor == e.anchor && this.head == e.head && (!t || !this.empty || this.assoc == e.assoc);
  }
  /**
  Return a JSON-serializable object representing the range.
  */
  toJSON() {
    return { anchor: this.anchor, head: this.head };
  }
  /**
  Convert a JSON representation of a range to a `SelectionRange`
  instance.
  */
  static fromJSON(e) {
    if (!e || typeof e.anchor != "number" || typeof e.head != "number")
      throw new RangeError("Invalid JSON representation for SelectionRange");
    return ge.range(e.anchor, e.head);
  }
  /**
  @internal
  */
  static create(e, t, r) {
    return new pu(e, t, r);
  }
}
class ge {
  constructor(e, t) {
    this.ranges = e, this.mainIndex = t;
  }
  /**
  Map a selection through a change. Used to adjust the selection
  position for changes.
  */
  map(e, t = -1) {
    return e.empty ? this : ge.create(this.ranges.map((r) => r.map(e, t)), this.mainIndex);
  }
  /**
  Compare this selection to another selection. By default, ranges
  are compared only by position. When `includeAssoc` is true,
  cursor ranges must also have the same
  [`assoc`](https://codemirror.net/6/docs/ref/#state.SelectionRange.assoc) value.
  */
  eq(e, t = !1) {
    if (this.ranges.length != e.ranges.length || this.mainIndex != e.mainIndex)
      return !1;
    for (let r = 0; r < this.ranges.length; r++)
      if (!this.ranges[r].eq(e.ranges[r], t))
        return !1;
    return !0;
  }
  /**
  Get the primary selection range. Usually, you should make sure
  your code applies to _all_ ranges, by using methods like
  [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
  */
  get main() {
    return this.ranges[this.mainIndex];
  }
  /**
  Make sure the selection only has one range. Returns a selection
  holding only the main range from this selection.
  */
  asSingle() {
    return this.ranges.length == 1 ? this : new ge([this.main], 0);
  }
  /**
  Extend this selection with an extra range.
  */
  addRange(e, t = !0) {
    return ge.create([e].concat(this.ranges), t ? 0 : this.mainIndex + 1);
  }
  /**
  Replace a given range with another range, and then normalize the
  selection to merge and sort ranges if necessary.
  */
  replaceRange(e, t = this.mainIndex) {
    let r = this.ranges.slice();
    return r[t] = e, ge.create(r, this.mainIndex);
  }
  /**
  Convert this selection to an object that can be serialized to
  JSON.
  */
  toJSON() {
    return { ranges: this.ranges.map((e) => e.toJSON()), main: this.mainIndex };
  }
  /**
  Create a selection from a JSON representation.
  */
  static fromJSON(e) {
    if (!e || !Array.isArray(e.ranges) || typeof e.main != "number" || e.main >= e.ranges.length)
      throw new RangeError("Invalid JSON representation for EditorSelection");
    return new ge(e.ranges.map((t) => pu.fromJSON(t)), e.main);
  }
  /**
  Create a selection holding a single range.
  */
  static single(e, t = e) {
    return new ge([ge.range(e, t)], 0);
  }
  /**
  Sort and merge the given set of ranges, creating a valid
  selection.
  */
  static create(e, t = 0) {
    if (e.length == 0)
      throw new RangeError("A selection needs at least one range");
    for (let r = 0, i = 0; i < e.length; i++) {
      let s = e[i];
      if (s.empty ? s.from <= r : s.from < r)
        return ge.normalized(e.slice(), t);
      r = s.to;
    }
    return new ge(e, t);
  }
  /**
  Create a cursor selection range at the given position. You can
  safely ignore the optional arguments in most situations.
  */
  static cursor(e, t = 0, r, i) {
    return pu.create(e, e, (t == 0 ? 0 : t < 0 ? 8 : 16) | (r == null ? 7 : Math.min(6, r)) | (i ?? 16777215) << 6);
  }
  /**
  Create a selection range.
  */
  static range(e, t, r, i) {
    let s = (r ?? 16777215) << 6 | (i == null ? 7 : Math.min(6, i));
    return t < e ? pu.create(t, e, 48 | s) : pu.create(e, t, (t > e ? 8 : 0) | s);
  }
  /**
  @internal
  */
  static normalized(e, t = 0) {
    let r = e[t];
    e.sort((i, s) => i.from - s.from), t = e.indexOf(r);
    for (let i = 1; i < e.length; i++) {
      let s = e[i], o = e[i - 1];
      if (s.empty ? s.from <= o.to : s.from < o.to) {
        let a = o.from, l = Math.max(s.to, o.to);
        i <= t && t--, e.splice(--i, 2, s.anchor > s.head ? ge.range(l, a) : ge.range(a, l));
      }
    }
    return new ge(e, t);
  }
}
function yle(n, e) {
  for (let t of n.ranges)
    if (t.to > e)
      throw new RangeError("Selection points outside of document");
}
let VO = 0;
class je {
  constructor(e, t, r, i, s) {
    this.combine = e, this.compareInput = t, this.compare = r, this.isStatic = i, this.id = VO++, this.default = e([]), this.extensions = typeof s == "function" ? s(this) : s;
  }
  /**
  Returns a facet reader for this facet, which can be used to
  [read](https://codemirror.net/6/docs/ref/#state.EditorState.facet) it but not to define values for it.
  */
  get reader() {
    return this;
  }
  /**
  Define a new facet.
  */
  static define(e = {}) {
    return new je(e.combine || ((t) => t), e.compareInput || ((t, r) => t === r), e.compare || (e.combine ? (t, r) => t === r : jO), !!e.static, e.enables);
  }
  /**
  Returns an extension that adds the given value to this facet.
  */
  of(e) {
    return new a2([], this, 0, e);
  }
  /**
  Create an extension that computes a value for the facet from a
  state. You must take care to declare the parts of the state that
  this value depends on, since your function is only called again
  for a new state when one of those parts changed.
  
  In cases where your value depends only on a single field, you'll
  want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
  */
  compute(e, t) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new a2(e, this, 1, t);
  }
  /**
  Create an extension that computes zero or more values for this
  facet from a state.
  */
  computeN(e, t) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new a2(e, this, 2, t);
  }
  from(e, t) {
    return t || (t = (r) => r), this.compute([e], (r) => t(r.field(e)));
  }
}
function jO(n, e) {
  return n == e || n.length == e.length && n.every((t, r) => t === e[r]);
}
class a2 {
  constructor(e, t, r, i) {
    this.dependencies = e, this.facet = t, this.type = r, this.value = i, this.id = VO++;
  }
  dynamicSlot(e) {
    var t;
    let r = this.value, i = this.facet.compareInput, s = this.id, o = e[s] >> 1, a = this.type == 2, l = !1, c = !1, u = [];
    for (let d of this.dependencies)
      d == "doc" ? l = !0 : d == "selection" ? c = !0 : (((t = e[d.id]) !== null && t !== void 0 ? t : 1) & 1) == 0 && u.push(e[d.id]);
    return {
      create(d) {
        return d.values[o] = r(d), 1;
      },
      update(d, f) {
        if (l && f.docChanged || c && (f.docChanged || f.selection) || R9(d, u)) {
          let h = r(d);
          if (a ? !Oj(h, d.values[o], i) : !i(h, d.values[o]))
            return d.values[o] = h, 1;
        }
        return 0;
      },
      reconfigure: (d, f) => {
        let h, m = f.config.address[s];
        if (m != null) {
          let g = qb(f, m);
          if (this.dependencies.every((v) => v instanceof je ? f.facet(v) === d.facet(v) : v instanceof Xr ? f.field(v, !1) == d.field(v, !1) : !0) || (a ? Oj(h = r(d), g, i) : i(h = r(d), g)))
            return d.values[o] = g, 0;
        } else
          h = r(d);
        return d.values[o] = h, 1;
      }
    };
  }
}
function Oj(n, e, t) {
  if (n.length != e.length)
    return !1;
  for (let r = 0; r < n.length; r++)
    if (!t(n[r], e[r]))
      return !1;
  return !0;
}
function R9(n, e) {
  let t = !1;
  for (let r of e)
    dm(n, r) & 1 && (t = !0);
  return t;
}
function Opt(n, e, t) {
  let r = t.map((l) => n[l.id]), i = t.map((l) => l.type), s = r.filter((l) => !(l & 1)), o = n[e.id] >> 1;
  function a(l) {
    let c = [];
    for (let u = 0; u < r.length; u++) {
      let d = qb(l, r[u]);
      if (i[u] == 2)
        for (let f of d)
          c.push(f);
      else
        c.push(d);
    }
    return e.combine(c);
  }
  return {
    create(l) {
      for (let c of r)
        dm(l, c);
      return l.values[o] = a(l), 1;
    },
    update(l, c) {
      if (!R9(l, s))
        return 0;
      let u = a(l);
      return e.compare(u, l.values[o]) ? 0 : (l.values[o] = u, 1);
    },
    reconfigure(l, c) {
      let u = R9(l, r), d = c.config.facets[e.id], f = c.facet(e);
      if (d && !u && jO(t, d))
        return l.values[o] = f, 0;
      let h = a(l);
      return e.compare(h, f) ? (l.values[o] = f, 0) : (l.values[o] = h, 1);
    }
  };
}
const bv = /* @__PURE__ */ je.define({ static: !0 });
class Xr {
  constructor(e, t, r, i, s) {
    this.id = e, this.createF = t, this.updateF = r, this.compareF = i, this.spec = s, this.provides = void 0;
  }
  /**
  Define a state field.
  */
  static define(e) {
    let t = new Xr(VO++, e.create, e.update, e.compare || ((r, i) => r === i), e);
    return e.provide && (t.provides = e.provide(t)), t;
  }
  create(e) {
    let t = e.facet(bv).find((r) => r.field == this);
    return (t?.create || this.createF)(e);
  }
  /**
  @internal
  */
  slot(e) {
    let t = e[this.id] >> 1;
    return {
      create: (r) => (r.values[t] = this.create(r), 1),
      update: (r, i) => {
        let s = r.values[t], o = this.updateF(s, i);
        return this.compareF(s, o) ? 0 : (r.values[t] = o, 1);
      },
      reconfigure: (r, i) => {
        let s = r.facet(bv), o = i.facet(bv), a;
        return (a = s.find((l) => l.field == this)) && a != o.find((l) => l.field == this) ? (r.values[t] = a.create(r), 1) : i.config.address[this.id] != null ? (r.values[t] = i.field(this), 0) : (r.values[t] = this.create(r), 1);
      }
    };
  }
  /**
  Returns an extension that enables this field and overrides the
  way it is initialized. Can be useful when you need to provide a
  non-default starting value for the field.
  */
  init(e) {
    return [this, bv.of({ field: this, create: e })];
  }
  /**
  State field instances can be used as
  [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
  given state.
  */
  get extension() {
    return this;
  }
}
const tu = { lowest: 4, low: 3, default: 2, high: 1, highest: 0 };
function yp(n) {
  return (e) => new ble(e, n);
}
const hd = {
  /**
  The highest precedence level, for extensions that should end up
  near the start of the precedence ordering.
  */
  highest: /* @__PURE__ */ yp(tu.highest),
  /**
  A higher-than-default precedence, for extensions that should
  come before those with default precedence.
  */
  high: /* @__PURE__ */ yp(tu.high),
  /**
  The default precedence, which is also used for extensions
  without an explicit precedence.
  */
  default: /* @__PURE__ */ yp(tu.default),
  /**
  A lower-than-default precedence.
  */
  low: /* @__PURE__ */ yp(tu.low),
  /**
  The lowest precedence level. Meant for things that should end up
  near the end of the extension order.
  */
  lowest: /* @__PURE__ */ yp(tu.lowest)
};
class ble {
  constructor(e, t) {
    this.inner = e, this.prec = t;
  }
}
class px {
  /**
  Create an instance of this compartment to add to your [state
  configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
  */
  of(e) {
    return new P9(this, e);
  }
  /**
  Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
  reconfigures this compartment.
  */
  reconfigure(e) {
    return px.reconfigure.of({ compartment: this, extension: e });
  }
  /**
  Get the current content of the compartment in the state, or
  `undefined` if it isn't present.
  */
  get(e) {
    return e.config.compartments.get(this);
  }
}
class P9 {
  constructor(e, t) {
    this.compartment = e, this.inner = t;
  }
}
class Kb {
  constructor(e, t, r, i, s, o) {
    for (this.base = e, this.compartments = t, this.dynamicSlots = r, this.address = i, this.staticValues = s, this.facets = o, this.statusTemplate = []; this.statusTemplate.length < r.length; )
      this.statusTemplate.push(
        0
        /* SlotStatus.Unresolved */
      );
  }
  staticFacet(e) {
    let t = this.address[e.id];
    return t == null ? e.default : this.staticValues[t >> 1];
  }
  static resolve(e, t, r) {
    let i = [], s = /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ new Map();
    for (let f of Ipt(e, t, o))
      f instanceof Xr ? i.push(f) : (s[f.facet.id] || (s[f.facet.id] = [])).push(f);
    let a = /* @__PURE__ */ Object.create(null), l = [], c = [];
    for (let f of i)
      a[f.id] = c.length << 1, c.push((h) => f.slot(h));
    let u = r?.config.facets;
    for (let f in s) {
      let h = s[f], m = h[0].facet, g = u && u[f] || [];
      if (h.every(
        (v) => v.type == 0
        /* Provider.Static */
      ))
        if (a[m.id] = l.length << 1 | 1, jO(g, h))
          l.push(r.facet(m));
        else {
          let v = m.combine(h.map((y) => y.value));
          l.push(r && m.compare(v, r.facet(m)) ? r.facet(m) : v);
        }
      else {
        for (let v of h)
          v.type == 0 ? (a[v.id] = l.length << 1 | 1, l.push(v.value)) : (a[v.id] = c.length << 1, c.push((y) => v.dynamicSlot(y)));
        a[m.id] = c.length << 1, c.push((v) => Opt(v, m, h));
      }
    }
    let d = c.map((f) => f(a));
    return new Kb(e, o, d, a, l, s);
  }
}
function Ipt(n, e, t) {
  let r = [[], [], [], [], []], i = /* @__PURE__ */ new Map();
  function s(o, a) {
    let l = i.get(o);
    if (l != null) {
      if (l <= a)
        return;
      let c = r[l].indexOf(o);
      c > -1 && r[l].splice(c, 1), o instanceof P9 && t.delete(o.compartment);
    }
    if (i.set(o, a), Array.isArray(o))
      for (let c of o)
        s(c, a);
    else if (o instanceof P9) {
      if (t.has(o.compartment))
        throw new RangeError("Duplicate use of compartment in extensions");
      let c = e.get(o.compartment) || o.inner;
      t.set(o.compartment, c), s(c, a);
    } else if (o instanceof ble)
      s(o.inner, o.prec);
    else if (o instanceof Xr)
      r[a].push(o), o.provides && s(o.provides, a);
    else if (o instanceof a2)
      r[a].push(o), o.facet.extensions && s(o.facet.extensions, tu.default);
    else {
      let c = o.extension;
      if (!c)
        throw new Error(`Unrecognized extension value in extension set (${o}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
      s(c, a);
    }
  }
  return s(n, tu.default), r.reduce((o, a) => o.concat(a));
}
function dm(n, e) {
  if (e & 1)
    return 2;
  let t = e >> 1, r = n.status[t];
  if (r == 4)
    throw new Error("Cyclic dependency between fields and/or facets");
  if (r & 2)
    return r;
  n.status[t] = 4;
  let i = n.computeSlot(n, n.config.dynamicSlots[t]);
  return n.status[t] = 2 | i;
}
function qb(n, e) {
  return e & 1 ? n.config.staticValues[e >> 1] : n.values[e >> 1];
}
const wle = /* @__PURE__ */ je.define(), D9 = /* @__PURE__ */ je.define({
  combine: (n) => n.some((e) => e),
  static: !0
}), xle = /* @__PURE__ */ je.define({
  combine: (n) => n.length ? n[0] : void 0,
  static: !0
}), Ele = /* @__PURE__ */ je.define(), Sle = /* @__PURE__ */ je.define(), Cle = /* @__PURE__ */ je.define(), Tle = /* @__PURE__ */ je.define({
  combine: (n) => n.length ? n[0] : !1
});
class Ma {
  /**
  @internal
  */
  constructor(e, t) {
    this.type = e, this.value = t;
  }
  /**
  Define a new type of annotation.
  */
  static define() {
    return new Rpt();
  }
}
class Rpt {
  /**
  Create an instance of this annotation.
  */
  of(e) {
    return new Ma(this, e);
  }
}
class Ppt {
  /**
  @internal
  */
  constructor(e) {
    this.map = e;
  }
  /**
  Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
  type.
  */
  of(e) {
    return new At(this, e);
  }
}
class At {
  /**
  @internal
  */
  constructor(e, t) {
    this.type = e, this.value = t;
  }
  /**
  Map this effect through a position mapping. Will return
  `undefined` when that ends up deleting the effect.
  */
  map(e) {
    let t = this.type.map(this.value, e);
    return t === void 0 ? void 0 : t == this.value ? this : new At(this.type, t);
  }
  /**
  Tells you whether this effect object is of a given
  [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
  */
  is(e) {
    return this.type == e;
  }
  /**
  Define a new effect type. The type parameter indicates the type
  of values that his effect holds. It should be a type that
  doesn't include `undefined`, since that is used in
  [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
  removed.
  */
  static define(e = {}) {
    return new Ppt(e.map || ((t) => t));
  }
  /**
  Map an array of effects through a change set.
  */
  static mapEffects(e, t) {
    if (!e.length)
      return e;
    let r = [];
    for (let i of e) {
      let s = i.map(t);
      s && r.push(s);
    }
    return r;
  }
}
At.reconfigure = /* @__PURE__ */ At.define();
At.appendConfig = /* @__PURE__ */ At.define();
class Cr {
  constructor(e, t, r, i, s, o) {
    this.startState = e, this.changes = t, this.selection = r, this.effects = i, this.annotations = s, this.scrollIntoView = o, this._doc = null, this._state = null, r && yle(r, t.newLength), s.some((a) => a.type == Cr.time) || (this.annotations = s.concat(Cr.time.of(Date.now())));
  }
  /**
  @internal
  */
  static create(e, t, r, i, s, o) {
    return new Cr(e, t, r, i, s, o);
  }
  /**
  The new document produced by the transaction. Contrary to
  [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
  force the entire new state to be computed right away, so it is
  recommended that [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
  when they need to look at the new document.
  */
  get newDoc() {
    return this._doc || (this._doc = this.changes.apply(this.startState.doc));
  }
  /**
  The new selection produced by the transaction. If
  [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
  this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
  current selection through the changes made by the transaction.
  */
  get newSelection() {
    return this.selection || this.startState.selection.map(this.changes);
  }
  /**
  The new state created by the transaction. Computed on demand
  (but retained for subsequent access), so it is recommended not to
  access it in [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
  */
  get state() {
    return this._state || this.startState.applyTransaction(this), this._state;
  }
  /**
  Get the value of the given annotation type, if any.
  */
  annotation(e) {
    for (let t of this.annotations)
      if (t.type == e)
        return t.value;
  }
  /**
  Indicates whether the transaction changed the document.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Indicates whether this transaction reconfigures the state
  (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
  with a top-level configuration
  [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
  */
  get reconfigured() {
    return this.startState.config != this.state.config;
  }
  /**
  Returns true if the transaction has a [user
  event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
  or more specific than `event`. For example, if the transaction
  has `"select.pointer"` as user event, `"select"` and
  `"select.pointer"` will match it.
  */
  isUserEvent(e) {
    let t = this.annotation(Cr.userEvent);
    return !!(t && (t == e || t.length > e.length && t.slice(0, e.length) == e && t[e.length] == "."));
  }
}
Cr.time = /* @__PURE__ */ Ma.define();
Cr.userEvent = /* @__PURE__ */ Ma.define();
Cr.addToHistory = /* @__PURE__ */ Ma.define();
Cr.remote = /* @__PURE__ */ Ma.define();
function Dpt(n, e) {
  let t = [];
  for (let r = 0, i = 0; ; ) {
    let s, o;
    if (r < n.length && (i == e.length || e[i] >= n[r]))
      s = n[r++], o = n[r++];
    else if (i < e.length)
      s = e[i++], o = e[i++];
    else
      return t;
    !t.length || t[t.length - 1] < s ? t.push(s, o) : t[t.length - 1] < o && (t[t.length - 1] = o);
  }
}
function Ale(n, e, t) {
  var r;
  let i, s, o;
  return t ? (i = e.changes, s = xr.empty(e.changes.length), o = n.changes.compose(e.changes)) : (i = e.changes.map(n.changes), s = n.changes.mapDesc(e.changes, !0), o = n.changes.compose(i)), {
    changes: o,
    selection: e.selection ? e.selection.map(s) : (r = n.selection) === null || r === void 0 ? void 0 : r.map(i),
    effects: At.mapEffects(n.effects, i).concat(At.mapEffects(e.effects, s)),
    annotations: n.annotations.length ? n.annotations.concat(e.annotations) : e.annotations,
    scrollIntoView: n.scrollIntoView || e.scrollIntoView
  };
}
function N9(n, e, t) {
  let r = e.selection, i = yf(e.annotations);
  return e.userEvent && (i = i.concat(Cr.userEvent.of(e.userEvent))), {
    changes: e.changes instanceof xr ? e.changes : xr.of(e.changes || [], t, n.facet(xle)),
    selection: r && (r instanceof ge ? r : ge.single(r.anchor, r.head)),
    effects: yf(e.effects),
    annotations: i,
    scrollIntoView: !!e.scrollIntoView
  };
}
function Mle(n, e, t) {
  let r = N9(n, e.length ? e[0] : {}, n.doc.length);
  e.length && e[0].filter === !1 && (t = !1);
  for (let s = 1; s < e.length; s++) {
    e[s].filter === !1 && (t = !1);
    let o = !!e[s].sequential;
    r = Ale(r, N9(n, e[s], o ? r.changes.newLength : n.doc.length), o);
  }
  let i = Cr.create(n, r.changes, r.selection, r.effects, r.annotations, r.scrollIntoView);
  return Lpt(t ? Npt(i) : i);
}
function Npt(n) {
  let e = n.startState, t = !0;
  for (let i of e.facet(Ele)) {
    let s = i(n);
    if (s === !1) {
      t = !1;
      break;
    }
    Array.isArray(s) && (t = t === !0 ? s : Dpt(t, s));
  }
  if (t !== !0) {
    let i, s;
    if (t === !1)
      s = n.changes.invertedDesc, i = xr.empty(e.doc.length);
    else {
      let o = n.changes.filter(t);
      i = o.changes, s = o.filtered.mapDesc(o.changes).invertedDesc;
    }
    n = Cr.create(e, i, n.selection && n.selection.map(s), At.mapEffects(n.effects, s), n.annotations, n.scrollIntoView);
  }
  let r = e.facet(Sle);
  for (let i = r.length - 1; i >= 0; i--) {
    let s = r[i](n);
    s instanceof Cr ? n = s : Array.isArray(s) && s.length == 1 && s[0] instanceof Cr ? n = s[0] : n = Mle(e, yf(s), !1);
  }
  return n;
}
function Lpt(n) {
  let e = n.startState, t = e.facet(Cle), r = n;
  for (let i = t.length - 1; i >= 0; i--) {
    let s = t[i](n);
    s && Object.keys(s).length && (r = Ale(r, N9(e, s, n.changes.newLength), !0));
  }
  return r == n ? n : Cr.create(e, n.changes, n.selection, r.effects, r.annotations, r.scrollIntoView);
}
const $pt = [];
function yf(n) {
  return n == null ? $pt : Array.isArray(n) ? n : [n];
}
var $n = /* @__PURE__ */ (function(n) {
  return n[n.Word = 0] = "Word", n[n.Space = 1] = "Space", n[n.Other = 2] = "Other", n;
})($n || ($n = {}));
const Fpt = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let L9;
try {
  L9 = /* @__PURE__ */ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch {
}
function Bpt(n) {
  if (L9)
    return L9.test(n);
  for (let e = 0; e < n.length; e++) {
    let t = n[e];
    if (/\w/.test(t) || t > "" && (t.toUpperCase() != t.toLowerCase() || Fpt.test(t)))
      return !0;
  }
  return !1;
}
function zpt(n) {
  return (e) => {
    if (!/\S/.test(e))
      return $n.Space;
    if (Bpt(e))
      return $n.Word;
    for (let t = 0; t < n.length; t++)
      if (e.indexOf(n[t]) > -1)
        return $n.Word;
    return $n.Other;
  };
}
class Ht {
  constructor(e, t, r, i, s, o) {
    this.config = e, this.doc = t, this.selection = r, this.values = i, this.status = e.statusTemplate.slice(), this.computeSlot = s, o && (o._state = this);
    for (let a = 0; a < this.config.dynamicSlots.length; a++)
      dm(this, a << 1);
    this.computeSlot = null;
  }
  field(e, t = !0) {
    let r = this.config.address[e.id];
    if (r == null) {
      if (t)
        throw new RangeError("Field is not present in this state");
      return;
    }
    return dm(this, r), qb(this, r);
  }
  /**
  Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
  state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
  can be passed. Unless
  [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
  [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
  are assumed to start in the _current_ document (not the document
  produced by previous specs), and its
  [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
  [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
  to the document created by its _own_ changes. The resulting
  transaction contains the combined effect of all the different
  specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
  specs take precedence over earlier ones.
  */
  update(...e) {
    return Mle(this, e, !0);
  }
  /**
  @internal
  */
  applyTransaction(e) {
    let t = this.config, { base: r, compartments: i } = t;
    for (let a of e.effects)
      a.is(px.reconfigure) ? (t && (i = /* @__PURE__ */ new Map(), t.compartments.forEach((l, c) => i.set(c, l)), t = null), i.set(a.value.compartment, a.value.extension)) : a.is(At.reconfigure) ? (t = null, r = a.value) : a.is(At.appendConfig) && (t = null, r = yf(r).concat(a.value));
    let s;
    t ? s = e.startState.values.slice() : (t = Kb.resolve(r, i, this), s = new Ht(t, this.doc, this.selection, t.dynamicSlots.map(() => null), (l, c) => c.reconfigure(l, this), null).values);
    let o = e.startState.facet(D9) ? e.newSelection : e.newSelection.asSingle();
    new Ht(t, e.newDoc, o, s, (a, l) => l.update(a, e), e);
  }
  /**
  Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
  replaces every selection range with the given content.
  */
  replaceSelection(e) {
    return typeof e == "string" && (e = this.toText(e)), this.changeByRange((t) => ({
      changes: { from: t.from, to: t.to, insert: e },
      range: ge.cursor(t.from + e.length)
    }));
  }
  /**
  Create a set of changes and a new selection by running the given
  function for each range in the active selection. The function
  can return an optional set of changes (in the coordinate space
  of the start document), plus an updated range (in the coordinate
  space of the document produced by the call's own changes). This
  method will merge all the changes and ranges into a single
  changeset and selection, and return it as a [transaction
  spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
  [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
  */
  changeByRange(e) {
    let t = this.selection, r = e(t.ranges[0]), i = this.changes(r.changes), s = [r.range], o = yf(r.effects);
    for (let a = 1; a < t.ranges.length; a++) {
      let l = e(t.ranges[a]), c = this.changes(l.changes), u = c.map(i);
      for (let f = 0; f < a; f++)
        s[f] = s[f].map(u);
      let d = i.mapDesc(c, !0);
      s.push(l.range.map(d)), i = i.compose(u), o = At.mapEffects(o, u).concat(At.mapEffects(yf(l.effects), d));
    }
    return {
      changes: i,
      selection: ge.create(s, t.mainIndex),
      effects: o
    };
  }
  /**
  Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
  description, taking the state's document length and line
  separator into account.
  */
  changes(e = []) {
    return e instanceof xr ? e : xr.of(e, this.doc.length, this.facet(Ht.lineSeparator));
  }
  /**
  Using the state's [line
  separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
  [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
  */
  toText(e) {
    return jt.of(e.split(this.facet(Ht.lineSeparator) || _9));
  }
  /**
  Return the given range of the document as a string.
  */
  sliceDoc(e = 0, t = this.doc.length) {
    return this.doc.sliceString(e, t, this.lineBreak);
  }
  /**
  Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
  */
  facet(e) {
    let t = this.config.address[e.id];
    return t == null ? e.default : (dm(this, t), qb(this, t));
  }
  /**
  Convert this state to a JSON-serializable object. When custom
  fields should be serialized, you can pass them in as an object
  mapping property names (in the resulting object, which should
  not use `doc` or `selection`) to fields.
  */
  toJSON(e) {
    let t = {
      doc: this.sliceDoc(),
      selection: this.selection.toJSON()
    };
    if (e)
      for (let r in e) {
        let i = e[r];
        i instanceof Xr && this.config.address[i.id] != null && (t[r] = i.spec.toJSON(this.field(e[r]), this));
      }
    return t;
  }
  /**
  Deserialize a state from its JSON representation. When custom
  fields should be deserialized, pass the same object you passed
  to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
  third argument.
  */
  static fromJSON(e, t = {}, r) {
    if (!e || typeof e.doc != "string")
      throw new RangeError("Invalid JSON representation for EditorState");
    let i = [];
    if (r) {
      for (let s in r)
        if (Object.prototype.hasOwnProperty.call(e, s)) {
          let o = r[s], a = e[s];
          i.push(o.init((l) => o.spec.fromJSON(a, l)));
        }
    }
    return Ht.create({
      doc: e.doc,
      selection: ge.fromJSON(e.selection),
      extensions: t.extensions ? i.concat([t.extensions]) : i
    });
  }
  /**
  Create a new state. You'll usually only need this when
  initializing an editor—updated states are created by applying
  transactions.
  */
  static create(e = {}) {
    let t = Kb.resolve(e.extensions || [], /* @__PURE__ */ new Map()), r = e.doc instanceof jt ? e.doc : jt.of((e.doc || "").split(t.staticFacet(Ht.lineSeparator) || _9)), i = e.selection ? e.selection instanceof ge ? e.selection : ge.single(e.selection.anchor, e.selection.head) : ge.single(0);
    return yle(i, r.length), t.staticFacet(D9) || (i = i.asSingle()), new Ht(t, r, i, t.dynamicSlots.map(() => null), (s, o) => o.create(s), null);
  }
  /**
  The size (in columns) of a tab in the document, determined by
  the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
  */
  get tabSize() {
    return this.facet(Ht.tabSize);
  }
  /**
  Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
  string for this state.
  */
  get lineBreak() {
    return this.facet(Ht.lineSeparator) || `
`;
  }
  /**
  Returns true when the editor is
  [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
  */
  get readOnly() {
    return this.facet(Tle);
  }
  /**
  Look up a translation for the given phrase (via the
  [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
  original string if no translation is found.
  
  If additional arguments are passed, they will be inserted in
  place of markers like `$1` (for the first value) and `$2`, etc.
  A single `$` is equivalent to `$1`, and `$$` will produce a
  literal dollar sign.
  */
  phrase(e, ...t) {
    for (let r of this.facet(Ht.phrases))
      if (Object.prototype.hasOwnProperty.call(r, e)) {
        e = r[e];
        break;
      }
    return t.length && (e = e.replace(/\$(\$|\d*)/g, (r, i) => {
      if (i == "$")
        return "$";
      let s = +(i || 1);
      return !s || s > t.length ? r : t[s - 1];
    })), e;
  }
  /**
  Find the values for a given language data field, provided by the
  the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
  
  Examples of language data fields are...
  
  - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
    comment syntax.
  - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
    for providing language-specific completion sources.
  - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
    characters that should be considered part of words in this
    language.
  - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
    bracket closing behavior.
  */
  languageDataAt(e, t, r = -1) {
    let i = [];
    for (let s of this.facet(wle))
      for (let o of s(this, t, r))
        Object.prototype.hasOwnProperty.call(o, e) && i.push(o[e]);
    return i;
  }
  /**
  Return a function that can categorize strings (expected to
  represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
  into one of:
  
   - Word (contains an alphanumeric character or a character
     explicitly listed in the local language's `"wordChars"`
     language data, which should be a string)
   - Space (contains only whitespace)
   - Other (anything else)
  */
  charCategorizer(e) {
    return zpt(this.languageDataAt("wordChars", e).join(""));
  }
  /**
  Find the word at the given position, meaning the range
  containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
  around it. If no word characters are adjacent to the position,
  this returns null.
  */
  wordAt(e) {
    let { text: t, from: r, length: i } = this.doc.lineAt(e), s = this.charCategorizer(e), o = e - r, a = e - r;
    for (; o > 0; ) {
      let l = Gr(t, o, !1);
      if (s(t.slice(l, o)) != $n.Word)
        break;
      o = l;
    }
    for (; a < i; ) {
      let l = Gr(t, a);
      if (s(t.slice(a, l)) != $n.Word)
        break;
      a = l;
    }
    return o == a ? null : ge.range(o + r, a + r);
  }
}
Ht.allowMultipleSelections = D9;
Ht.tabSize = /* @__PURE__ */ je.define({
  combine: (n) => n.length ? n[0] : 4
});
Ht.lineSeparator = xle;
Ht.readOnly = Tle;
Ht.phrases = /* @__PURE__ */ je.define({
  compare(n, e) {
    let t = Object.keys(n), r = Object.keys(e);
    return t.length == r.length && t.every((i) => n[i] == e[i]);
  }
});
Ht.languageData = wle;
Ht.changeFilter = Ele;
Ht.transactionFilter = Sle;
Ht.transactionExtender = Cle;
px.reconfigure = /* @__PURE__ */ At.define();
function ka(n, e, t = {}) {
  let r = {};
  for (let i of n)
    for (let s of Object.keys(i)) {
      let o = i[s], a = r[s];
      if (a === void 0)
        r[s] = o;
      else if (!(a === o || o === void 0)) if (Object.hasOwnProperty.call(t, s))
        r[s] = t[s](a, o);
      else
        throw new Error("Config merge conflict for field " + s);
    }
  for (let i in e)
    r[i] === void 0 && (r[i] = e[i]);
  return r;
}
class Gu {
  /**
  Compare this value with another value. Used when comparing
  rangesets. The default implementation compares by identity.
  Unless you are only creating a fixed number of unique instances
  of your value type, it is a good idea to implement this
  properly.
  */
  eq(e) {
    return this == e;
  }
  /**
  Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
  */
  range(e, t = e) {
    return $9.create(e, t, this);
  }
}
Gu.prototype.startSide = Gu.prototype.endSide = 0;
Gu.prototype.point = !1;
Gu.prototype.mapMode = hi.TrackDel;
let $9 = class kle {
  constructor(e, t, r) {
    this.from = e, this.to = t, this.value = r;
  }
  /**
  @internal
  */
  static create(e, t, r) {
    return new kle(e, t, r);
  }
};
function F9(n, e) {
  return n.from - e.from || n.value.startSide - e.value.startSide;
}
class WO {
  constructor(e, t, r, i) {
    this.from = e, this.to = t, this.value = r, this.maxPoint = i;
  }
  get length() {
    return this.to[this.to.length - 1];
  }
  // Find the index of the given position and side. Use the ranges'
  // `from` pos when `end == false`, `to` when `end == true`.
  findIndex(e, t, r, i = 0) {
    let s = r ? this.to : this.from;
    for (let o = i, a = s.length; ; ) {
      if (o == a)
        return o;
      let l = o + a >> 1, c = s[l] - e || (r ? this.value[l].endSide : this.value[l].startSide) - t;
      if (l == o)
        return c >= 0 ? o : a;
      c >= 0 ? a = l : o = l + 1;
    }
  }
  between(e, t, r, i) {
    for (let s = this.findIndex(t, -1e9, !0), o = this.findIndex(r, 1e9, !1, s); s < o; s++)
      if (i(this.from[s] + e, this.to[s] + e, this.value[s]) === !1)
        return !1;
  }
  map(e, t) {
    let r = [], i = [], s = [], o = -1, a = -1;
    for (let l = 0; l < this.value.length; l++) {
      let c = this.value[l], u = this.from[l] + e, d = this.to[l] + e, f, h;
      if (u == d) {
        let m = t.mapPos(u, c.startSide, c.mapMode);
        if (m == null || (f = h = m, c.startSide != c.endSide && (h = t.mapPos(u, c.endSide), h < f)))
          continue;
      } else if (f = t.mapPos(u, c.startSide), h = t.mapPos(d, c.endSide), f > h || f == h && c.startSide > 0 && c.endSide <= 0)
        continue;
      (h - f || c.endSide - c.startSide) < 0 || (o < 0 && (o = f), c.point && (a = Math.max(a, h - f)), r.push(c), i.push(f - o), s.push(h - o));
    }
    return { mapped: r.length ? new WO(i, s, r, a) : null, pos: o };
  }
}
class Vt {
  constructor(e, t, r, i) {
    this.chunkPos = e, this.chunk = t, this.nextLayer = r, this.maxPoint = i;
  }
  /**
  @internal
  */
  static create(e, t, r, i) {
    return new Vt(e, t, r, i);
  }
  /**
  @internal
  */
  get length() {
    let e = this.chunk.length - 1;
    return e < 0 ? 0 : Math.max(this.chunkEnd(e), this.nextLayer.length);
  }
  /**
  The number of ranges in the set.
  */
  get size() {
    if (this.isEmpty)
      return 0;
    let e = this.nextLayer.size;
    for (let t of this.chunk)
      e += t.value.length;
    return e;
  }
  /**
  @internal
  */
  chunkEnd(e) {
    return this.chunkPos[e] + this.chunk[e].length;
  }
  /**
  Update the range set, optionally adding new ranges or filtering
  out existing ones.
  
  (Note: The type parameter is just there as a kludge to work
  around TypeScript variance issues that prevented `RangeSet<X>`
  from being a subtype of `RangeSet<Y>` when `X` is a subtype of
  `Y`.)
  */
  update(e) {
    let { add: t = [], sort: r = !1, filterFrom: i = 0, filterTo: s = this.length } = e, o = e.filter;
    if (t.length == 0 && !o)
      return this;
    if (r && (t = t.slice().sort(F9)), this.isEmpty)
      return t.length ? Vt.of(t) : this;
    let a = new _le(this, null, -1).goto(0), l = 0, c = [], u = new ml();
    for (; a.value || l < t.length; )
      if (l < t.length && (a.from - t[l].from || a.startSide - t[l].value.startSide) >= 0) {
        let d = t[l++];
        u.addInner(d.from, d.to, d.value) || c.push(d);
      } else a.rangeIndex == 1 && a.chunkIndex < this.chunk.length && (l == t.length || this.chunkEnd(a.chunkIndex) < t[l].from) && (!o || i > this.chunkEnd(a.chunkIndex) || s < this.chunkPos[a.chunkIndex]) && u.addChunk(this.chunkPos[a.chunkIndex], this.chunk[a.chunkIndex]) ? a.nextChunk() : ((!o || i > a.to || s < a.from || o(a.from, a.to, a.value)) && (u.addInner(a.from, a.to, a.value) || c.push($9.create(a.from, a.to, a.value))), a.next());
    return u.finishInner(this.nextLayer.isEmpty && !c.length ? Vt.empty : this.nextLayer.update({ add: c, filter: o, filterFrom: i, filterTo: s }));
  }
  /**
  Map this range set through a set of changes, return the new set.
  */
  map(e) {
    if (e.empty || this.isEmpty)
      return this;
    let t = [], r = [], i = -1;
    for (let o = 0; o < this.chunk.length; o++) {
      let a = this.chunkPos[o], l = this.chunk[o], c = e.touchesRange(a, a + l.length);
      if (c === !1)
        i = Math.max(i, l.maxPoint), t.push(l), r.push(e.mapPos(a));
      else if (c === !0) {
        let { mapped: u, pos: d } = l.map(a, e);
        u && (i = Math.max(i, u.maxPoint), t.push(u), r.push(d));
      }
    }
    let s = this.nextLayer.map(e);
    return t.length == 0 ? s : new Vt(r, t, s || Vt.empty, i);
  }
  /**
  Iterate over the ranges that touch the region `from` to `to`,
  calling `f` for each. There is no guarantee that the ranges will
  be reported in any specific order. When the callback returns
  `false`, iteration stops.
  */
  between(e, t, r) {
    if (!this.isEmpty) {
      for (let i = 0; i < this.chunk.length; i++) {
        let s = this.chunkPos[i], o = this.chunk[i];
        if (t >= s && e <= s + o.length && o.between(s, e - s, t - s, r) === !1)
          return;
      }
      this.nextLayer.between(e, t, r);
    }
  }
  /**
  Iterate over the ranges in this set, in order, including all
  ranges that end at or after `from`.
  */
  iter(e = 0) {
    return q0.from([this]).goto(e);
  }
  /**
  @internal
  */
  get isEmpty() {
    return this.nextLayer == this;
  }
  /**
  Iterate over the ranges in a collection of sets, in order,
  starting from `from`.
  */
  static iter(e, t = 0) {
    return q0.from(e).goto(t);
  }
  /**
  Iterate over two groups of sets, calling methods on `comparator`
  to notify it of possible differences.
  */
  static compare(e, t, r, i, s = -1) {
    let o = e.filter((d) => d.maxPoint > 0 || !d.isEmpty && d.maxPoint >= s), a = t.filter((d) => d.maxPoint > 0 || !d.isEmpty && d.maxPoint >= s), l = Ij(o, a, r), c = new bp(o, l, s), u = new bp(a, l, s);
    r.iterGaps((d, f, h) => Rj(c, d, u, f, h, i)), r.empty && r.length == 0 && Rj(c, 0, u, 0, 0, i);
  }
  /**
  Compare the contents of two groups of range sets, returning true
  if they are equivalent in the given range.
  */
  static eq(e, t, r = 0, i) {
    i == null && (i = 999999999);
    let s = e.filter((u) => !u.isEmpty && t.indexOf(u) < 0), o = t.filter((u) => !u.isEmpty && e.indexOf(u) < 0);
    if (s.length != o.length)
      return !1;
    if (!s.length)
      return !0;
    let a = Ij(s, o), l = new bp(s, a, 0).goto(r), c = new bp(o, a, 0).goto(r);
    for (; ; ) {
      if (l.to != c.to || !B9(l.active, c.active) || l.point && (!c.point || !l.point.eq(c.point)))
        return !1;
      if (l.to > i)
        return !0;
      l.next(), c.next();
    }
  }
  /**
  Iterate over a group of range sets at the same time, notifying
  the iterator about the ranges covering every given piece of
  content. Returns the open count (see
  [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
  of the iteration.
  */
  static spans(e, t, r, i, s = -1) {
    let o = new bp(e, null, s).goto(t), a = t, l = o.openStart;
    for (; ; ) {
      let c = Math.min(o.to, r);
      if (o.point) {
        let u = o.activeForPoint(o.to), d = o.pointFrom < t ? u.length + 1 : o.point.startSide < 0 ? u.length : Math.min(u.length, l);
        i.point(a, c, o.point, u, d, o.pointRank), l = Math.min(o.openEnd(c), u.length);
      } else c > a && (i.span(a, c, o.active, l), l = o.openEnd(c));
      if (o.to > r)
        return l + (o.point && o.to > r ? 1 : 0);
      a = o.to, o.next();
    }
  }
  /**
  Create a range set for the given range or array of ranges. By
  default, this expects the ranges to be _sorted_ (by start
  position and, if two start at the same position,
  `value.startSide`). You can pass `true` as second argument to
  cause the method to sort them.
  */
  static of(e, t = !1) {
    let r = new ml();
    for (let i of e instanceof $9 ? [e] : t ? Hpt(e) : e)
      r.add(i.from, i.to, i.value);
    return r.finish();
  }
  /**
  Join an array of range sets into a single set.
  */
  static join(e) {
    if (!e.length)
      return Vt.empty;
    let t = e[e.length - 1];
    for (let r = e.length - 2; r >= 0; r--)
      for (let i = e[r]; i != Vt.empty; i = i.nextLayer)
        t = new Vt(i.chunkPos, i.chunk, t, Math.max(i.maxPoint, t.maxPoint));
    return t;
  }
}
Vt.empty = /* @__PURE__ */ new Vt([], [], null, -1);
function Hpt(n) {
  if (n.length > 1)
    for (let e = n[0], t = 1; t < n.length; t++) {
      let r = n[t];
      if (F9(e, r) > 0)
        return n.slice().sort(F9);
      e = r;
    }
  return n;
}
Vt.empty.nextLayer = Vt.empty;
class ml {
  finishChunk(e) {
    this.chunks.push(new WO(this.from, this.to, this.value, this.maxPoint)), this.chunkPos.push(this.chunkStart), this.chunkStart = -1, this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint), this.maxPoint = -1, e && (this.from = [], this.to = [], this.value = []);
  }
  /**
  Create an empty builder.
  */
  constructor() {
    this.chunks = [], this.chunkPos = [], this.chunkStart = -1, this.last = null, this.lastFrom = -1e9, this.lastTo = -1e9, this.from = [], this.to = [], this.value = [], this.maxPoint = -1, this.setMaxPoint = -1, this.nextLayer = null;
  }
  /**
  Add a range. Ranges should be added in sorted (by `from` and
  `value.startSide`) order.
  */
  add(e, t, r) {
    this.addInner(e, t, r) || (this.nextLayer || (this.nextLayer = new ml())).add(e, t, r);
  }
  /**
  @internal
  */
  addInner(e, t, r) {
    let i = e - this.lastTo || r.startSide - this.last.endSide;
    if (i <= 0 && (e - this.lastFrom || r.startSide - this.last.startSide) < 0)
      throw new Error("Ranges must be added sorted by `from` position and `startSide`");
    return i < 0 ? !1 : (this.from.length == 250 && this.finishChunk(!0), this.chunkStart < 0 && (this.chunkStart = e), this.from.push(e - this.chunkStart), this.to.push(t - this.chunkStart), this.last = r, this.lastFrom = e, this.lastTo = t, this.value.push(r), r.point && (this.maxPoint = Math.max(this.maxPoint, t - e)), !0);
  }
  /**
  @internal
  */
  addChunk(e, t) {
    if ((e - this.lastTo || t.value[0].startSide - this.last.endSide) < 0)
      return !1;
    this.from.length && this.finishChunk(!0), this.setMaxPoint = Math.max(this.setMaxPoint, t.maxPoint), this.chunks.push(t), this.chunkPos.push(e);
    let r = t.value.length - 1;
    return this.last = t.value[r], this.lastFrom = t.from[r] + e, this.lastTo = t.to[r] + e, !0;
  }
  /**
  Finish the range set. Returns the new set. The builder can't be
  used anymore after this has been called.
  */
  finish() {
    return this.finishInner(Vt.empty);
  }
  /**
  @internal
  */
  finishInner(e) {
    if (this.from.length && this.finishChunk(!1), this.chunks.length == 0)
      return e;
    let t = Vt.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(e) : e, this.setMaxPoint);
    return this.from = null, t;
  }
}
function Ij(n, e, t) {
  let r = /* @__PURE__ */ new Map();
  for (let s of n)
    for (let o = 0; o < s.chunk.length; o++)
      s.chunk[o].maxPoint <= 0 && r.set(s.chunk[o], s.chunkPos[o]);
  let i = /* @__PURE__ */ new Set();
  for (let s of e)
    for (let o = 0; o < s.chunk.length; o++) {
      let a = r.get(s.chunk[o]);
      a != null && (t ? t.mapPos(a) : a) == s.chunkPos[o] && !t?.touchesRange(a, a + s.chunk[o].length) && i.add(s.chunk[o]);
    }
  return i;
}
class _le {
  constructor(e, t, r, i = 0) {
    this.layer = e, this.skip = t, this.minPoint = r, this.rank = i;
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  get endSide() {
    return this.value ? this.value.endSide : 0;
  }
  goto(e, t = -1e9) {
    return this.chunkIndex = this.rangeIndex = 0, this.gotoInner(e, t, !1), this;
  }
  gotoInner(e, t, r) {
    for (; this.chunkIndex < this.layer.chunk.length; ) {
      let i = this.layer.chunk[this.chunkIndex];
      if (!(this.skip && this.skip.has(i) || this.layer.chunkEnd(this.chunkIndex) < e || i.maxPoint < this.minPoint))
        break;
      this.chunkIndex++, r = !1;
    }
    if (this.chunkIndex < this.layer.chunk.length) {
      let i = this.layer.chunk[this.chunkIndex].findIndex(e - this.layer.chunkPos[this.chunkIndex], t, !0);
      (!r || this.rangeIndex < i) && this.setRangeIndex(i);
    }
    this.next();
  }
  forward(e, t) {
    (this.to - e || this.endSide - t) < 0 && this.gotoInner(e, t, !0);
  }
  next() {
    for (; ; )
      if (this.chunkIndex == this.layer.chunk.length) {
        this.from = this.to = 1e9, this.value = null;
        break;
      } else {
        let e = this.layer.chunkPos[this.chunkIndex], t = this.layer.chunk[this.chunkIndex], r = e + t.from[this.rangeIndex];
        if (this.from = r, this.to = e + t.to[this.rangeIndex], this.value = t.value[this.rangeIndex], this.setRangeIndex(this.rangeIndex + 1), this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint)
          break;
      }
  }
  setRangeIndex(e) {
    if (e == this.layer.chunk[this.chunkIndex].value.length) {
      if (this.chunkIndex++, this.skip)
        for (; this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]); )
          this.chunkIndex++;
      this.rangeIndex = 0;
    } else
      this.rangeIndex = e;
  }
  nextChunk() {
    this.chunkIndex++, this.rangeIndex = 0, this.next();
  }
  compare(e) {
    return this.from - e.from || this.startSide - e.startSide || this.rank - e.rank || this.to - e.to || this.endSide - e.endSide;
  }
}
class q0 {
  constructor(e) {
    this.heap = e;
  }
  static from(e, t = null, r = -1) {
    let i = [];
    for (let s = 0; s < e.length; s++)
      for (let o = e[s]; !o.isEmpty; o = o.nextLayer)
        o.maxPoint >= r && i.push(new _le(o, t, r, s));
    return i.length == 1 ? i[0] : new q0(i);
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  goto(e, t = -1e9) {
    for (let r of this.heap)
      r.goto(e, t);
    for (let r = this.heap.length >> 1; r >= 0; r--)
      N8(this.heap, r);
    return this.next(), this;
  }
  forward(e, t) {
    for (let r of this.heap)
      r.forward(e, t);
    for (let r = this.heap.length >> 1; r >= 0; r--)
      N8(this.heap, r);
    (this.to - e || this.value.endSide - t) < 0 && this.next();
  }
  next() {
    if (this.heap.length == 0)
      this.from = this.to = 1e9, this.value = null, this.rank = -1;
    else {
      let e = this.heap[0];
      this.from = e.from, this.to = e.to, this.value = e.value, this.rank = e.rank, e.value && e.next(), N8(this.heap, 0);
    }
  }
}
function N8(n, e) {
  for (let t = n[e]; ; ) {
    let r = (e << 1) + 1;
    if (r >= n.length)
      break;
    let i = n[r];
    if (r + 1 < n.length && i.compare(n[r + 1]) >= 0 && (i = n[r + 1], r++), t.compare(i) < 0)
      break;
    n[r] = t, n[e] = i, e = r;
  }
}
class bp {
  constructor(e, t, r) {
    this.minPoint = r, this.active = [], this.activeTo = [], this.activeRank = [], this.minActive = -1, this.point = null, this.pointFrom = 0, this.pointRank = 0, this.to = -1e9, this.endSide = 0, this.openStart = -1, this.cursor = q0.from(e, t, r);
  }
  goto(e, t = -1e9) {
    return this.cursor.goto(e, t), this.active.length = this.activeTo.length = this.activeRank.length = 0, this.minActive = -1, this.to = e, this.endSide = t, this.openStart = -1, this.next(), this;
  }
  forward(e, t) {
    for (; this.minActive > -1 && (this.activeTo[this.minActive] - e || this.active[this.minActive].endSide - t) < 0; )
      this.removeActive(this.minActive);
    this.cursor.forward(e, t);
  }
  removeActive(e) {
    wv(this.active, e), wv(this.activeTo, e), wv(this.activeRank, e), this.minActive = Pj(this.active, this.activeTo);
  }
  addActive(e) {
    let t = 0, { value: r, to: i, rank: s } = this.cursor;
    for (; t < this.activeRank.length && (s - this.activeRank[t] || i - this.activeTo[t]) > 0; )
      t++;
    xv(this.active, t, r), xv(this.activeTo, t, i), xv(this.activeRank, t, s), e && xv(e, t, this.cursor.from), this.minActive = Pj(this.active, this.activeTo);
  }
  // After calling this, if `this.point` != null, the next range is a
  // point. Otherwise, it's a regular range, covered by `this.active`.
  next() {
    let e = this.to, t = this.point;
    this.point = null;
    let r = this.openStart < 0 ? [] : null;
    for (; ; ) {
      let i = this.minActive;
      if (i > -1 && (this.activeTo[i] - this.cursor.from || this.active[i].endSide - this.cursor.startSide) < 0) {
        if (this.activeTo[i] > e) {
          this.to = this.activeTo[i], this.endSide = this.active[i].endSide;
          break;
        }
        this.removeActive(i), r && wv(r, i);
      } else if (this.cursor.value)
        if (this.cursor.from > e) {
          this.to = this.cursor.from, this.endSide = this.cursor.startSide;
          break;
        } else {
          let s = this.cursor.value;
          if (!s.point)
            this.addActive(r), this.cursor.next();
          else if (t && this.cursor.to == this.to && this.cursor.from < this.cursor.to)
            this.cursor.next();
          else {
            this.point = s, this.pointFrom = this.cursor.from, this.pointRank = this.cursor.rank, this.to = this.cursor.to, this.endSide = s.endSide, this.cursor.next(), this.forward(this.to, this.endSide);
            break;
          }
        }
      else {
        this.to = this.endSide = 1e9;
        break;
      }
    }
    if (r) {
      this.openStart = 0;
      for (let i = r.length - 1; i >= 0 && r[i] < e; i--)
        this.openStart++;
    }
  }
  activeForPoint(e) {
    if (!this.active.length)
      return this.active;
    let t = [];
    for (let r = this.active.length - 1; r >= 0 && !(this.activeRank[r] < this.pointRank); r--)
      (this.activeTo[r] > e || this.activeTo[r] == e && this.active[r].endSide >= this.point.endSide) && t.push(this.active[r]);
    return t.reverse();
  }
  openEnd(e) {
    let t = 0;
    for (let r = this.activeTo.length - 1; r >= 0 && this.activeTo[r] > e; r--)
      t++;
    return t;
  }
}
function Rj(n, e, t, r, i, s) {
  n.goto(e), t.goto(r);
  let o = r + i, a = r, l = r - e;
  for (; ; ) {
    let c = n.to + l - t.to, u = c || n.endSide - t.endSide, d = u < 0 ? n.to + l : t.to, f = Math.min(d, o);
    if (n.point || t.point ? n.point && t.point && (n.point == t.point || n.point.eq(t.point)) && B9(n.activeForPoint(n.to), t.activeForPoint(t.to)) || s.comparePoint(a, f, n.point, t.point) : f > a && !B9(n.active, t.active) && s.compareRange(a, f, n.active, t.active), d > o)
      break;
    (c || n.openEnd != t.openEnd) && s.boundChange && s.boundChange(d), a = d, u <= 0 && n.next(), u >= 0 && t.next();
  }
}
function B9(n, e) {
  if (n.length != e.length)
    return !1;
  for (let t = 0; t < n.length; t++)
    if (n[t] != e[t] && !n[t].eq(e[t]))
      return !1;
  return !0;
}
function wv(n, e) {
  for (let t = e, r = n.length - 1; t < r; t++)
    n[t] = n[t + 1];
  n.pop();
}
function xv(n, e, t) {
  for (let r = n.length - 1; r >= e; r--)
    n[r + 1] = n[r];
  n[e] = t;
}
function Pj(n, e) {
  let t = -1, r = 1e9;
  for (let i = 0; i < e.length; i++)
    (e[i] - r || n[i].endSide - n[t].endSide) < 0 && (t = i, r = e[i]);
  return t;
}
function Vh(n, e, t = n.length) {
  let r = 0;
  for (let i = 0; i < t && i < n.length; )
    n.charCodeAt(i) == 9 ? (r += e - r % e, i++) : (r++, i = Gr(n, i));
  return r;
}
function z9(n, e, t, r) {
  for (let i = 0, s = 0; ; ) {
    if (s >= e)
      return i;
    if (i == n.length)
      break;
    s += n.charCodeAt(i) == 9 ? t - s % t : 1, i = Gr(n, i);
  }
  return r === !0 ? -1 : n.length;
}
const H9 = "ͼ", Dj = typeof Symbol > "u" ? "__" + H9 : Symbol.for(H9), U9 = typeof Symbol > "u" ? "__styleSet" + Math.floor(Math.random() * 1e8) : Symbol("styleSet"), Nj = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : {};
class wc {
  // :: (Object<Style>, ?{finish: ?(string) → string})
  // Create a style module from the given spec.
  //
  // When `finish` is given, it is called on regular (non-`@`)
  // selectors (after `&` expansion) to compute the final selector.
  constructor(e, t) {
    this.rules = [];
    let { finish: r } = t || {};
    function i(o) {
      return /^@/.test(o) ? [o] : o.split(/,\s*/);
    }
    function s(o, a, l, c) {
      let u = [], d = /^@(\w+)\b/.exec(o[0]), f = d && d[1] == "keyframes";
      if (d && a == null) return l.push(o[0] + ";");
      for (let h in a) {
        let m = a[h];
        if (/&/.test(h))
          s(
            h.split(/,\s*/).map((g) => o.map((v) => g.replace(/&/, v))).reduce((g, v) => g.concat(v)),
            m,
            l
          );
        else if (m && typeof m == "object") {
          if (!d) throw new RangeError("The value of a property (" + h + ") should be a primitive value.");
          s(i(h), m, u, f);
        } else m != null && u.push(h.replace(/_.*/, "").replace(/[A-Z]/g, (g) => "-" + g.toLowerCase()) + ": " + m + ";");
      }
      (u.length || f) && l.push((r && !d && !c ? o.map(r) : o).join(", ") + " {" + u.join(" ") + "}");
    }
    for (let o in e) s(i(o), e[o], this.rules);
  }
  // :: () → string
  // Returns a string containing the module's CSS rules.
  getRules() {
    return this.rules.join(`
`);
  }
  // :: () → string
  // Generate a new unique CSS class name.
  static newName() {
    let e = Nj[Dj] || 1;
    return Nj[Dj] = e + 1, H9 + e.toString(36);
  }
  // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>, ?{nonce: ?string})
  //
  // Mount the given set of modules in the given DOM root, which ensures
  // that the CSS rules defined by the module are available in that
  // context.
  //
  // Rules are only added to the document once per root.
  //
  // Rule order will follow the order of the modules, so that rules from
  // modules later in the array take precedence of those from earlier
  // modules. If you call this function multiple times for the same root
  // in a way that changes the order of already mounted modules, the old
  // order will be changed.
  //
  // If a Content Security Policy nonce is provided, it is added to
  // the `<style>` tag generated by the library.
  static mount(e, t, r) {
    let i = e[U9], s = r && r.nonce;
    i ? s && i.setNonce(s) : i = new Upt(e, s), i.mount(Array.isArray(t) ? t : [t], e);
  }
}
let Lj = /* @__PURE__ */ new Map();
class Upt {
  constructor(e, t) {
    let r = e.ownerDocument || e, i = r.defaultView;
    if (!e.head && e.adoptedStyleSheets && i.CSSStyleSheet) {
      let s = Lj.get(r);
      if (s) return e[U9] = s;
      this.sheet = new i.CSSStyleSheet(), Lj.set(r, this);
    } else
      this.styleTag = r.createElement("style"), t && this.styleTag.setAttribute("nonce", t);
    this.modules = [], e[U9] = this;
  }
  mount(e, t) {
    let r = this.sheet, i = 0, s = 0;
    for (let o = 0; o < e.length; o++) {
      let a = e[o], l = this.modules.indexOf(a);
      if (l < s && l > -1 && (this.modules.splice(l, 1), s--, l = -1), l == -1) {
        if (this.modules.splice(s++, 0, a), r) for (let c = 0; c < a.rules.length; c++)
          r.insertRule(a.rules[c], i++);
      } else {
        for (; s < l; ) i += this.modules[s++].rules.length;
        i += a.rules.length, s++;
      }
    }
    if (r)
      t.adoptedStyleSheets.indexOf(this.sheet) < 0 && (t.adoptedStyleSheets = [this.sheet, ...t.adoptedStyleSheets]);
    else {
      let o = "";
      for (let l = 0; l < this.modules.length; l++)
        o += this.modules[l].getRules() + `
`;
      this.styleTag.textContent = o;
      let a = t.head || t;
      this.styleTag.parentNode != a && a.insertBefore(this.styleTag, a.firstChild);
    }
  }
  setNonce(e) {
    this.styleTag && this.styleTag.getAttribute("nonce") != e && this.styleTag.setAttribute("nonce", e);
  }
}
function yn() {
  var n = arguments[0];
  typeof n == "string" && (n = document.createElement(n));
  var e = 1, t = arguments[1];
  if (t && typeof t == "object" && t.nodeType == null && !Array.isArray(t)) {
    for (var r in t) if (Object.prototype.hasOwnProperty.call(t, r)) {
      var i = t[r];
      typeof i == "string" ? n.setAttribute(r, i) : i != null && (n[r] = i);
    }
    e++;
  }
  for (; e < arguments.length; e++) Ole(n, arguments[e]);
  return n;
}
function Ole(n, e) {
  if (typeof e == "string")
    n.appendChild(document.createTextNode(e));
  else if (e != null) if (e.nodeType != null)
    n.appendChild(e);
  else if (Array.isArray(e))
    for (var t = 0; t < e.length; t++) Ole(n, e[t]);
  else
    throw new RangeError("Unsupported child node: " + e);
}
let fi = typeof navigator < "u" ? navigator : { userAgent: "", vendor: "", platform: "" }, V9 = typeof document < "u" ? document : { documentElement: { style: {} } };
const j9 = /* @__PURE__ */ /Edge\/(\d+)/.exec(fi.userAgent), Ile = /* @__PURE__ */ /MSIE \d/.test(fi.userAgent), W9 = /* @__PURE__ */ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(fi.userAgent), mx = !!(Ile || W9 || j9), $j = !mx && /* @__PURE__ */ /gecko\/(\d+)/i.test(fi.userAgent), L8 = !mx && /* @__PURE__ */ /Chrome\/(\d+)/.exec(fi.userAgent), Vpt = "webkitFontSmoothing" in V9.documentElement.style, G9 = !mx && /* @__PURE__ */ /Apple Computer/.test(fi.vendor), Fj = G9 && (/* @__PURE__ */ /Mobile\/\w+/.test(fi.userAgent) || fi.maxTouchPoints > 2);
var ze = {
  mac: Fj || /* @__PURE__ */ /Mac/.test(fi.platform),
  windows: /* @__PURE__ */ /Win/.test(fi.platform),
  linux: /* @__PURE__ */ /Linux|X11/.test(fi.platform),
  ie: mx,
  ie_version: Ile ? V9.documentMode || 6 : W9 ? +W9[1] : j9 ? +j9[1] : 0,
  gecko: $j,
  gecko_version: $j ? +(/* @__PURE__ */ /Firefox\/(\d+)/.exec(fi.userAgent) || [0, 0])[1] : 0,
  chrome: !!L8,
  chrome_version: L8 ? +L8[1] : 0,
  ios: Fj,
  android: /* @__PURE__ */ /Android\b/.test(fi.userAgent),
  webkit_version: Vpt ? +(/* @__PURE__ */ /\bAppleWebKit\/(\d+)/.exec(fi.userAgent) || [0, 0])[1] : 0,
  safari: G9,
  safari_version: G9 ? +(/* @__PURE__ */ /\bVersion\/(\d+(\.\d+)?)/.exec(fi.userAgent) || [0, 0])[1] : 0,
  tabSize: V9.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
function Y0(n) {
  let e;
  return n.nodeType == 11 ? e = n.getSelection ? n : n.ownerDocument : e = n, e.getSelection();
}
function K9(n, e) {
  return e ? n == e || n.contains(e.nodeType != 1 ? e.parentNode : e) : !1;
}
function l2(n, e) {
  if (!e.anchorNode)
    return !1;
  try {
    return K9(n, e.anchorNode);
  } catch {
    return !1;
  }
}
function uh(n) {
  return n.nodeType == 3 ? qu(n, 0, n.nodeValue.length).getClientRects() : n.nodeType == 1 ? n.getClientRects() : [];
}
function fm(n, e, t, r) {
  return t ? Bj(n, e, t, r, -1) || Bj(n, e, t, r, 1) : !1;
}
function Ku(n) {
  for (var e = 0; ; e++)
    if (n = n.previousSibling, !n)
      return e;
}
function Yb(n) {
  return n.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(n.nodeName);
}
function Bj(n, e, t, r, i) {
  for (; ; ) {
    if (n == t && e == r)
      return !0;
    if (e == (i < 0 ? 0 : Ea(n))) {
      if (n.nodeName == "DIV")
        return !1;
      let s = n.parentNode;
      if (!s || s.nodeType != 1)
        return !1;
      e = Ku(n) + (i < 0 ? 0 : 1), n = s;
    } else if (n.nodeType == 1) {
      if (n = n.childNodes[e + (i < 0 ? -1 : 0)], n.nodeType == 1 && n.contentEditable == "false")
        return !1;
      e = i < 0 ? Ea(n) : 0;
    } else
      return !1;
  }
}
function Ea(n) {
  return n.nodeType == 3 ? n.nodeValue.length : n.childNodes.length;
}
function U1(n, e) {
  let t = e ? n.left : n.right;
  return { left: t, right: t, top: n.top, bottom: n.bottom };
}
function jpt(n) {
  let e = n.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: n.innerWidth,
    top: 0,
    bottom: n.innerHeight
  };
}
function Rle(n, e) {
  let t = e.width / n.offsetWidth, r = e.height / n.offsetHeight;
  return (t > 0.995 && t < 1.005 || !isFinite(t) || Math.abs(e.width - n.offsetWidth) < 1) && (t = 1), (r > 0.995 && r < 1.005 || !isFinite(r) || Math.abs(e.height - n.offsetHeight) < 1) && (r = 1), { scaleX: t, scaleY: r };
}
function Wpt(n, e, t, r, i, s, o, a) {
  let l = n.ownerDocument, c = l.defaultView || window;
  for (let u = n, d = !1; u && !d; )
    if (u.nodeType == 1) {
      let f, h = u == l.body, m = 1, g = 1;
      if (h)
        f = jpt(c);
      else {
        if (/^(fixed|sticky)$/.test(getComputedStyle(u).position) && (d = !0), u.scrollHeight <= u.clientHeight && u.scrollWidth <= u.clientWidth) {
          u = u.assignedSlot || u.parentNode;
          continue;
        }
        let b = u.getBoundingClientRect();
        ({ scaleX: m, scaleY: g } = Rle(u, b)), f = {
          left: b.left,
          right: b.left + u.clientWidth * m,
          top: b.top,
          bottom: b.top + u.clientHeight * g
        };
      }
      let v = 0, y = 0;
      if (i == "nearest")
        e.top < f.top ? (y = e.top - (f.top + o), t > 0 && e.bottom > f.bottom + y && (y = e.bottom - f.bottom + o)) : e.bottom > f.bottom && (y = e.bottom - f.bottom + o, t < 0 && e.top - y < f.top && (y = e.top - (f.top + o)));
      else {
        let b = e.bottom - e.top, x = f.bottom - f.top;
        y = (i == "center" && b <= x ? e.top + b / 2 - x / 2 : i == "start" || i == "center" && t < 0 ? e.top - o : e.bottom - x + o) - f.top;
      }
      if (r == "nearest" ? e.left < f.left ? (v = e.left - (f.left + s), t > 0 && e.right > f.right + v && (v = e.right - f.right + s)) : e.right > f.right && (v = e.right - f.right + s, t < 0 && e.left < f.left + v && (v = e.left - (f.left + s))) : v = (r == "center" ? e.left + (e.right - e.left) / 2 - (f.right - f.left) / 2 : r == "start" == a ? e.left - s : e.right - (f.right - f.left) + s) - f.left, v || y)
        if (h)
          c.scrollBy(v, y);
        else {
          let b = 0, x = 0;
          if (y) {
            let E = u.scrollTop;
            u.scrollTop += y / g, x = (u.scrollTop - E) * g;
          }
          if (v) {
            let E = u.scrollLeft;
            u.scrollLeft += v / m, b = (u.scrollLeft - E) * m;
          }
          e = {
            left: e.left - b,
            top: e.top - x,
            right: e.right - b,
            bottom: e.bottom - x
          }, b && Math.abs(b - v) < 1 && (r = "nearest"), x && Math.abs(x - y) < 1 && (i = "nearest");
        }
      if (h)
        break;
      (e.top < f.top || e.bottom > f.bottom || e.left < f.left || e.right > f.right) && (e = {
        left: Math.max(e.left, f.left),
        right: Math.min(e.right, f.right),
        top: Math.max(e.top, f.top),
        bottom: Math.min(e.bottom, f.bottom)
      }), u = u.assignedSlot || u.parentNode;
    } else if (u.nodeType == 11)
      u = u.host;
    else
      break;
}
function Gpt(n) {
  let e = n.ownerDocument, t, r;
  for (let i = n.parentNode; i && !(i == e.body || t && r); )
    if (i.nodeType == 1)
      !r && i.scrollHeight > i.clientHeight && (r = i), !t && i.scrollWidth > i.clientWidth && (t = i), i = i.assignedSlot || i.parentNode;
    else if (i.nodeType == 11)
      i = i.host;
    else
      break;
  return { x: t, y: r };
}
class Kpt {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  eq(e) {
    return this.anchorNode == e.anchorNode && this.anchorOffset == e.anchorOffset && this.focusNode == e.focusNode && this.focusOffset == e.focusOffset;
  }
  setRange(e) {
    let { anchorNode: t, focusNode: r } = e;
    this.set(t, Math.min(e.anchorOffset, t ? Ea(t) : 0), r, Math.min(e.focusOffset, r ? Ea(r) : 0));
  }
  set(e, t, r, i) {
    this.anchorNode = e, this.anchorOffset = t, this.focusNode = r, this.focusOffset = i;
  }
}
let Jc = null;
ze.safari && ze.safari_version >= 26 && (Jc = !1);
function Ple(n) {
  if (n.setActive)
    return n.setActive();
  if (Jc)
    return n.focus(Jc);
  let e = [];
  for (let t = n; t && (e.push(t, t.scrollTop, t.scrollLeft), t != t.ownerDocument); t = t.parentNode)
    ;
  if (n.focus(Jc == null ? {
    get preventScroll() {
      return Jc = { preventScroll: !0 }, !0;
    }
  } : void 0), !Jc) {
    Jc = !1;
    for (let t = 0; t < e.length; ) {
      let r = e[t++], i = e[t++], s = e[t++];
      r.scrollTop != i && (r.scrollTop = i), r.scrollLeft != s && (r.scrollLeft = s);
    }
  }
}
let zj;
function qu(n, e, t = e) {
  let r = zj || (zj = document.createRange());
  return r.setEnd(n, t), r.setStart(n, e), r;
}
function bf(n, e, t, r) {
  let i = { key: e, code: e, keyCode: t, which: t, cancelable: !0 };
  r && ({ altKey: i.altKey, ctrlKey: i.ctrlKey, shiftKey: i.shiftKey, metaKey: i.metaKey } = r);
  let s = new KeyboardEvent("keydown", i);
  s.synthetic = !0, n.dispatchEvent(s);
  let o = new KeyboardEvent("keyup", i);
  return o.synthetic = !0, n.dispatchEvent(o), s.defaultPrevented || o.defaultPrevented;
}
function qpt(n) {
  for (; n; ) {
    if (n && (n.nodeType == 9 || n.nodeType == 11 && n.host))
      return n;
    n = n.assignedSlot || n.parentNode;
  }
  return null;
}
function Dle(n) {
  for (; n.attributes.length; )
    n.removeAttributeNode(n.attributes[0]);
}
function Ypt(n, e) {
  let t = e.focusNode, r = e.focusOffset;
  if (!t || e.anchorNode != t || e.anchorOffset != r)
    return !1;
  for (r = Math.min(r, Ea(t)); ; )
    if (r) {
      if (t.nodeType != 1)
        return !1;
      let i = t.childNodes[r - 1];
      i.contentEditable == "false" ? r-- : (t = i, r = Ea(t));
    } else {
      if (t == n)
        return !0;
      r = Ku(t), t = t.parentNode;
    }
}
function Nle(n) {
  return n.scrollTop > Math.max(1, n.scrollHeight - n.clientHeight - 4);
}
function Lle(n, e) {
  for (let t = n, r = e; ; ) {
    if (t.nodeType == 3 && r > 0)
      return { node: t, offset: r };
    if (t.nodeType == 1 && r > 0) {
      if (t.contentEditable == "false")
        return null;
      t = t.childNodes[r - 1], r = Ea(t);
    } else if (t.parentNode && !Yb(t))
      r = Ku(t), t = t.parentNode;
    else
      return null;
  }
}
function $le(n, e) {
  for (let t = n, r = e; ; ) {
    if (t.nodeType == 3 && r < t.nodeValue.length)
      return { node: t, offset: r };
    if (t.nodeType == 1 && r < t.childNodes.length) {
      if (t.contentEditable == "false")
        return null;
      t = t.childNodes[r], r = 0;
    } else if (t.parentNode && !Yb(t))
      r = Ku(t) + 1, t = t.parentNode;
    else
      return null;
  }
}
class si {
  constructor(e, t, r = !0) {
    this.node = e, this.offset = t, this.precise = r;
  }
  static before(e, t) {
    return new si(e.parentNode, Ku(e), t);
  }
  static after(e, t) {
    return new si(e.parentNode, Ku(e) + 1, t);
  }
}
const GO = [];
class pn {
  constructor() {
    this.parent = null, this.dom = null, this.flags = 2;
  }
  get overrideDOMText() {
    return null;
  }
  get posAtStart() {
    return this.parent ? this.parent.posBefore(this) : 0;
  }
  get posAtEnd() {
    return this.posAtStart + this.length;
  }
  posBefore(e) {
    let t = this.posAtStart;
    for (let r of this.children) {
      if (r == e)
        return t;
      t += r.length + r.breakAfter;
    }
    throw new RangeError("Invalid child in posBefore");
  }
  posAfter(e) {
    return this.posBefore(e) + e.length;
  }
  sync(e, t) {
    if (this.flags & 2) {
      let r = this.dom, i = null, s;
      for (let o of this.children) {
        if (o.flags & 7) {
          if (!o.dom && (s = i ? i.nextSibling : r.firstChild)) {
            let a = pn.get(s);
            (!a || !a.parent && a.canReuseDOM(o)) && o.reuseDOM(s);
          }
          o.sync(e, t), o.flags &= -8;
        }
        if (s = i ? i.nextSibling : r.firstChild, t && !t.written && t.node == r && s != o.dom && (t.written = !0), o.dom.parentNode == r)
          for (; s && s != o.dom; )
            s = Hj(s);
        else
          r.insertBefore(o.dom, s);
        i = o.dom;
      }
      for (s = i ? i.nextSibling : r.firstChild, s && t && t.node == r && (t.written = !0); s; )
        s = Hj(s);
    } else if (this.flags & 1)
      for (let r of this.children)
        r.flags & 7 && (r.sync(e, t), r.flags &= -8);
  }
  reuseDOM(e) {
  }
  localPosFromDOM(e, t) {
    let r;
    if (e == this.dom)
      r = this.dom.childNodes[t];
    else {
      let i = Ea(e) == 0 ? 0 : t == 0 ? -1 : 1;
      for (; ; ) {
        let s = e.parentNode;
        if (s == this.dom)
          break;
        i == 0 && s.firstChild != s.lastChild && (e == s.firstChild ? i = -1 : i = 1), e = s;
      }
      i < 0 ? r = e : r = e.nextSibling;
    }
    if (r == this.dom.firstChild)
      return 0;
    for (; r && !pn.get(r); )
      r = r.nextSibling;
    if (!r)
      return this.length;
    for (let i = 0, s = 0; ; i++) {
      let o = this.children[i];
      if (o.dom == r)
        return s;
      s += o.length + o.breakAfter;
    }
  }
  domBoundsAround(e, t, r = 0) {
    let i = -1, s = -1, o = -1, a = -1;
    for (let l = 0, c = r, u = r; l < this.children.length; l++) {
      let d = this.children[l], f = c + d.length;
      if (c < e && f > t)
        return d.domBoundsAround(e, t, c);
      if (f >= e && i == -1 && (i = l, s = c), c > t && d.dom.parentNode == this.dom) {
        o = l, a = u;
        break;
      }
      u = f, c = f + d.breakAfter;
    }
    return {
      from: s,
      to: a < 0 ? r + this.length : a,
      startDOM: (i ? this.children[i - 1].dom.nextSibling : null) || this.dom.firstChild,
      endDOM: o < this.children.length && o >= 0 ? this.children[o].dom : null
    };
  }
  markDirty(e = !1) {
    this.flags |= 2, this.markParentsDirty(e);
  }
  markParentsDirty(e) {
    for (let t = this.parent; t; t = t.parent) {
      if (e && (t.flags |= 2), t.flags & 1)
        return;
      t.flags |= 1, e = !1;
    }
  }
  setParent(e) {
    this.parent != e && (this.parent = e, this.flags & 7 && this.markParentsDirty(!0));
  }
  setDOM(e) {
    this.dom != e && (this.dom && (this.dom.cmView = null), this.dom = e, e.cmView = this);
  }
  get rootView() {
    for (let e = this; ; ) {
      let t = e.parent;
      if (!t)
        return e;
      e = t;
    }
  }
  replaceChildren(e, t, r = GO) {
    this.markDirty();
    for (let i = e; i < t; i++) {
      let s = this.children[i];
      s.parent == this && r.indexOf(s) < 0 && s.destroy();
    }
    r.length < 250 ? this.children.splice(e, t - e, ...r) : this.children = [].concat(this.children.slice(0, e), r, this.children.slice(t));
    for (let i = 0; i < r.length; i++)
      r[i].setParent(this);
  }
  ignoreMutation(e) {
    return !1;
  }
  ignoreEvent(e) {
    return !1;
  }
  childCursor(e = this.length) {
    return new Fle(this.children, e, this.children.length);
  }
  childPos(e, t = 1) {
    return this.childCursor().findPos(e, t);
  }
  toString() {
    let e = this.constructor.name.replace("View", "");
    return e + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (e == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
  }
  static get(e) {
    return e.cmView;
  }
  get isEditable() {
    return !0;
  }
  get isWidget() {
    return !1;
  }
  get isHidden() {
    return !1;
  }
  merge(e, t, r, i, s, o) {
    return !1;
  }
  become(e) {
    return !1;
  }
  canReuseDOM(e) {
    return e.constructor == this.constructor && !((this.flags | e.flags) & 8);
  }
  // When this is a zero-length view with a side, this should return a
  // number <= 0 to indicate it is before its position, or a
  // number > 0 when after its position.
  getSide() {
    return 0;
  }
  destroy() {
    for (let e of this.children)
      e.parent == this && e.destroy();
    this.parent = null;
  }
}
pn.prototype.breakAfter = 0;
function Hj(n) {
  let e = n.nextSibling;
  return n.parentNode.removeChild(n), e;
}
class Fle {
  constructor(e, t, r) {
    this.children = e, this.pos = t, this.i = r, this.off = 0;
  }
  findPos(e, t = 1) {
    for (; ; ) {
      if (e > this.pos || e == this.pos && (t > 0 || this.i == 0 || this.children[this.i - 1].breakAfter))
        return this.off = e - this.pos, this;
      let r = this.children[--this.i];
      this.pos -= r.length + r.breakAfter;
    }
  }
}
function Ble(n, e, t, r, i, s, o, a, l) {
  let { children: c } = n, u = c.length ? c[e] : null, d = s.length ? s[s.length - 1] : null, f = d ? d.breakAfter : o;
  if (!(e == r && u && !o && !f && s.length < 2 && u.merge(t, i, s.length ? d : null, t == 0, a, l))) {
    if (r < c.length) {
      let h = c[r];
      h && (i < h.length || h.breakAfter && d?.breakAfter) ? (e == r && (h = h.split(i), i = 0), !f && d && h.merge(0, i, d, !0, 0, l) ? s[s.length - 1] = h : ((i || h.children.length && !h.children[0].length) && h.merge(0, i, null, !1, 0, l), s.push(h))) : h?.breakAfter && (d ? d.breakAfter = 1 : o = 1), r++;
    }
    for (u && (u.breakAfter = o, t > 0 && (!o && s.length && u.merge(t, u.length, s[0], !1, a, 0) ? u.breakAfter = s.shift().breakAfter : (t < u.length || u.children.length && u.children[u.children.length - 1].length == 0) && u.merge(t, u.length, null, !1, a, 0), e++)); e < r && s.length; )
      if (c[r - 1].become(s[s.length - 1]))
        r--, s.pop(), l = s.length ? 0 : a;
      else if (c[e].become(s[0]))
        e++, s.shift(), a = s.length ? 0 : l;
      else
        break;
    !s.length && e && r < c.length && !c[e - 1].breakAfter && c[r].merge(0, 0, c[e - 1], !1, a, l) && e--, (e < r || s.length) && n.replaceChildren(e, r, s);
  }
}
function zle(n, e, t, r, i, s) {
  let o = n.childCursor(), { i: a, off: l } = o.findPos(t, 1), { i: c, off: u } = o.findPos(e, -1), d = e - t;
  for (let f of r)
    d += f.length;
  n.length += d, Ble(n, c, u, a, l, r, 0, i, s);
}
const Xpt = 256;
class Ao extends pn {
  constructor(e) {
    super(), this.text = e;
  }
  get length() {
    return this.text.length;
  }
  createDOM(e) {
    this.setDOM(e || document.createTextNode(this.text));
  }
  sync(e, t) {
    this.dom || this.createDOM(), this.dom.nodeValue != this.text && (t && t.node == this.dom && (t.written = !0), this.dom.nodeValue = this.text);
  }
  reuseDOM(e) {
    e.nodeType == 3 && this.createDOM(e);
  }
  merge(e, t, r) {
    return this.flags & 8 || r && (!(r instanceof Ao) || this.length - (t - e) + r.length > Xpt || r.flags & 8) ? !1 : (this.text = this.text.slice(0, e) + (r ? r.text : "") + this.text.slice(t), this.markDirty(), !0);
  }
  split(e) {
    let t = new Ao(this.text.slice(e));
    return this.text = this.text.slice(0, e), this.markDirty(), t.flags |= this.flags & 8, t;
  }
  localPosFromDOM(e, t) {
    return e == this.dom ? t : t ? this.text.length : 0;
  }
  domAtPos(e) {
    return new si(this.dom, e);
  }
  domBoundsAround(e, t, r) {
    return { from: r, to: r + this.length, startDOM: this.dom, endDOM: this.dom.nextSibling };
  }
  coordsAt(e, t) {
    return Zpt(this.dom, e, t);
  }
}
class gl extends pn {
  constructor(e, t = [], r = 0) {
    super(), this.mark = e, this.children = t, this.length = r;
    for (let i of t)
      i.setParent(this);
  }
  setAttrs(e) {
    if (Dle(e), this.mark.class && (e.className = this.mark.class), this.mark.attrs)
      for (let t in this.mark.attrs)
        e.setAttribute(t, this.mark.attrs[t]);
    return e;
  }
  canReuseDOM(e) {
    return super.canReuseDOM(e) && !((this.flags | e.flags) & 8);
  }
  reuseDOM(e) {
    e.nodeName == this.mark.tagName.toUpperCase() && (this.setDOM(e), this.flags |= 6);
  }
  sync(e, t) {
    this.dom ? this.flags & 4 && this.setAttrs(this.dom) : this.setDOM(this.setAttrs(document.createElement(this.mark.tagName))), super.sync(e, t);
  }
  merge(e, t, r, i, s, o) {
    return r && (!(r instanceof gl && r.mark.eq(this.mark)) || e && s <= 0 || t < this.length && o <= 0) ? !1 : (zle(this, e, t, r ? r.children.slice() : [], s - 1, o - 1), this.markDirty(), !0);
  }
  split(e) {
    let t = [], r = 0, i = -1, s = 0;
    for (let a of this.children) {
      let l = r + a.length;
      l > e && t.push(r < e ? a.split(e - r) : a), i < 0 && r >= e && (i = s), r = l, s++;
    }
    let o = this.length - e;
    return this.length = e, i > -1 && (this.children.length = i, this.markDirty()), new gl(this.mark, t, o);
  }
  domAtPos(e) {
    return Hle(this, e);
  }
  coordsAt(e, t) {
    return Vle(this, e, t);
  }
}
function Zpt(n, e, t) {
  let r = n.nodeValue.length;
  e > r && (e = r);
  let i = e, s = e, o = 0;
  e == 0 && t < 0 || e == r && t >= 0 ? ze.chrome || ze.gecko || (e ? (i--, o = 1) : s < r && (s++, o = -1)) : t < 0 ? i-- : s < r && s++;
  let a = qu(n, i, s).getClientRects();
  if (!a.length)
    return null;
  let l = a[(o ? o < 0 : t >= 0) ? 0 : a.length - 1];
  return ze.safari && !o && l.width == 0 && (l = Array.prototype.find.call(a, (c) => c.width) || l), o ? U1(l, o < 0) : l || null;
}
class nc extends pn {
  static create(e, t, r) {
    return new nc(e, t, r);
  }
  constructor(e, t, r) {
    super(), this.widget = e, this.length = t, this.side = r, this.prevWidget = null;
  }
  split(e) {
    let t = nc.create(this.widget, this.length - e, this.side);
    return this.length -= e, t;
  }
  sync(e) {
    (!this.dom || !this.widget.updateDOM(this.dom, e)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(e)), this.widget.editable || (this.dom.contentEditable = "false"));
  }
  getSide() {
    return this.side;
  }
  merge(e, t, r, i, s, o) {
    return r && (!(r instanceof nc) || !this.widget.compare(r.widget) || e > 0 && s <= 0 || t < this.length && o <= 0) ? !1 : (this.length = e + (r ? r.length : 0) + (this.length - t), !0);
  }
  become(e) {
    return e instanceof nc && e.side == this.side && this.widget.constructor == e.widget.constructor ? (this.widget.compare(e.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = e.widget, this.length = e.length, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(e) {
    return this.widget.ignoreEvent(e);
  }
  get overrideDOMText() {
    if (this.length == 0)
      return jt.empty;
    let e = this;
    for (; e.parent; )
      e = e.parent;
    let { view: t } = e, r = t && t.state.doc, i = this.posAtStart;
    return r ? r.slice(i, i + this.length) : jt.empty;
  }
  domAtPos(e) {
    return (this.length ? e == 0 : this.side > 0) ? si.before(this.dom) : si.after(this.dom, e == this.length);
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(e, t) {
    let r = this.widget.coordsAt(this.dom, e, t);
    if (r)
      return r;
    let i = this.dom.getClientRects(), s = null;
    if (!i.length)
      return null;
    let o = this.side ? this.side < 0 : e > 0;
    for (let a = o ? i.length - 1 : 0; s = i[a], !(e > 0 ? a == 0 : a == i.length - 1 || s.top < s.bottom); a += o ? -1 : 1)
      ;
    return U1(s, !o);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  get isHidden() {
    return this.widget.isHidden;
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
}
class dh extends pn {
  constructor(e) {
    super(), this.side = e;
  }
  get length() {
    return 0;
  }
  merge() {
    return !1;
  }
  become(e) {
    return e instanceof dh && e.side == this.side;
  }
  split() {
    return new dh(this.side);
  }
  sync() {
    if (!this.dom) {
      let e = document.createElement("img");
      e.className = "cm-widgetBuffer", e.setAttribute("aria-hidden", "true"), this.setDOM(e);
    }
  }
  getSide() {
    return this.side;
  }
  domAtPos(e) {
    return this.side > 0 ? si.before(this.dom) : si.after(this.dom);
  }
  localPosFromDOM() {
    return 0;
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(e) {
    return this.dom.getBoundingClientRect();
  }
  get overrideDOMText() {
    return jt.empty;
  }
  get isHidden() {
    return !0;
  }
}
Ao.prototype.children = nc.prototype.children = dh.prototype.children = GO;
function Hle(n, e) {
  let t = n.dom, { children: r } = n, i = 0;
  for (let s = 0; i < r.length; i++) {
    let o = r[i], a = s + o.length;
    if (!(a == s && o.getSide() <= 0)) {
      if (e > s && e < a && o.dom.parentNode == t)
        return o.domAtPos(e - s);
      if (e <= s)
        break;
      s = a;
    }
  }
  for (let s = i; s > 0; s--) {
    let o = r[s - 1];
    if (o.dom.parentNode == t)
      return o.domAtPos(o.length);
  }
  for (let s = i; s < r.length; s++) {
    let o = r[s];
    if (o.dom.parentNode == t)
      return o.domAtPos(0);
  }
  return new si(t, 0);
}
function Ule(n, e, t) {
  let r, { children: i } = n;
  t > 0 && e instanceof gl && i.length && (r = i[i.length - 1]) instanceof gl && r.mark.eq(e.mark) ? Ule(r, e.children[0], t - 1) : (i.push(e), e.setParent(n)), n.length += e.length;
}
function Vle(n, e, t) {
  let r = null, i = -1, s = null, o = -1;
  function a(c, u) {
    for (let d = 0, f = 0; d < c.children.length && f <= u; d++) {
      let h = c.children[d], m = f + h.length;
      m >= u && (h.children.length ? a(h, u - f) : (!s || s.isHidden && (t > 0 || Jpt(s, h))) && (m > u || f == m && h.getSide() > 0) ? (s = h, o = u - f) : (f < u || f == m && h.getSide() < 0 && !h.isHidden) && (r = h, i = u - f)), f = m;
    }
  }
  a(n, e);
  let l = (t < 0 ? r : s) || r || s;
  return l ? l.coordsAt(Math.max(0, l == r ? i : o), t) : Qpt(n);
}
function Qpt(n) {
  let e = n.dom.lastChild;
  if (!e)
    return n.dom.getBoundingClientRect();
  let t = uh(e);
  return t[t.length - 1] || null;
}
function Jpt(n, e) {
  let t = n.coordsAt(0, 1), r = e.coordsAt(0, 1);
  return t && r && r.top < t.bottom;
}
function q9(n, e) {
  for (let t in n)
    t == "class" && e.class ? e.class += " " + n.class : t == "style" && e.style ? e.style += ";" + n.style : e[t] = n[t];
  return e;
}
const Uj = /* @__PURE__ */ Object.create(null);
function Xb(n, e, t) {
  if (n == e)
    return !0;
  n || (n = Uj), e || (e = Uj);
  let r = Object.keys(n), i = Object.keys(e);
  if (r.length - (t && r.indexOf(t) > -1 ? 1 : 0) != i.length - (t && i.indexOf(t) > -1 ? 1 : 0))
    return !1;
  for (let s of r)
    if (s != t && (i.indexOf(s) == -1 || n[s] !== e[s]))
      return !1;
  return !0;
}
function Y9(n, e, t) {
  let r = !1;
  if (e)
    for (let i in e)
      t && i in t || (r = !0, i == "style" ? n.style.cssText = "" : n.removeAttribute(i));
  if (t)
    for (let i in t)
      e && e[i] == t[i] || (r = !0, i == "style" ? n.style.cssText = t[i] : n.setAttribute(i, t[i]));
  return r;
}
function emt(n) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let t = 0; t < n.attributes.length; t++) {
    let r = n.attributes[t];
    e[r.name] = r.value;
  }
  return e;
}
class Sl {
  /**
  Compare this instance to another instance of the same type.
  (TypeScript can't express this, but only instances of the same
  specific class will be passed to this method.) This is used to
  avoid redrawing widgets when they are replaced by a new
  decoration of the same type. The default implementation just
  returns `false`, which will cause new instances of the widget to
  always be redrawn.
  */
  eq(e) {
    return !1;
  }
  /**
  Update a DOM element created by a widget of the same type (but
  different, non-`eq` content) to reflect this widget. May return
  true to indicate that it could update, false to indicate it
  couldn't (in which case the widget will be redrawn). The default
  implementation just returns false.
  */
  updateDOM(e, t) {
    return !1;
  }
  /**
  @internal
  */
  compare(e) {
    return this == e || this.constructor == e.constructor && this.eq(e);
  }
  /**
  The estimated height this widget will have, to be used when
  estimating the height of content that hasn't been drawn. May
  return -1 to indicate you don't know. The default implementation
  returns -1.
  */
  get estimatedHeight() {
    return -1;
  }
  /**
  For inline widgets that are displayed inline (as opposed to
  `inline-block`) and introduce line breaks (through `<br>` tags
  or textual newlines), this must indicate the amount of line
  breaks they introduce. Defaults to 0.
  */
  get lineBreaks() {
    return 0;
  }
  /**
  Can be used to configure which kinds of events inside the widget
  should be ignored by the editor. The default is to ignore all
  events.
  */
  ignoreEvent(e) {
    return !0;
  }
  /**
  Override the way screen coordinates for positions at/in the
  widget are found. `pos` will be the offset into the widget, and
  `side` the side of the position that is being queried—less than
  zero for before, greater than zero for after, and zero for
  directly at that position.
  */
  coordsAt(e, t, r) {
    return null;
  }
  /**
  @internal
  */
  get isHidden() {
    return !1;
  }
  /**
  @internal
  */
  get editable() {
    return !1;
  }
  /**
  This is called when the an instance of the widget is removed
  from the editor view.
  */
  destroy(e) {
  }
}
var vi = /* @__PURE__ */ (function(n) {
  return n[n.Text = 0] = "Text", n[n.WidgetBefore = 1] = "WidgetBefore", n[n.WidgetAfter = 2] = "WidgetAfter", n[n.WidgetRange = 3] = "WidgetRange", n;
})(vi || (vi = {}));
class ct extends Gu {
  constructor(e, t, r, i) {
    super(), this.startSide = e, this.endSide = t, this.widget = r, this.spec = i;
  }
  /**
  @internal
  */
  get heightRelevant() {
    return !1;
  }
  /**
  Create a mark decoration, which influences the styling of the
  content in its range. Nested mark decorations will cause nested
  DOM elements to be created. Nesting order is determined by
  precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
  the higher-precedence decorations creating the inner DOM nodes.
  Such elements are split on line boundaries and on the boundaries
  of lower-precedence decorations.
  */
  static mark(e) {
    return new V1(e);
  }
  /**
  Create a widget decoration, which displays a DOM element at the
  given position.
  */
  static widget(e) {
    let t = Math.max(-1e4, Math.min(1e4, e.side || 0)), r = !!e.block;
    return t += r && !e.inlineOrder ? t > 0 ? 3e8 : -4e8 : t > 0 ? 1e8 : -1e8, new xc(e, t, t, r, e.widget || null, !1);
  }
  /**
  Create a replace decoration which replaces the given range with
  a widget, or simply hides it.
  */
  static replace(e) {
    let t = !!e.block, r, i;
    if (e.isBlockGap)
      r = -5e8, i = 4e8;
    else {
      let { start: s, end: o } = jle(e, t);
      r = (s ? t ? -3e8 : -1 : 5e8) - 1, i = (o ? t ? 2e8 : 1 : -6e8) + 1;
    }
    return new xc(e, r, i, t, e.widget || null, !0);
  }
  /**
  Create a line decoration, which can add DOM attributes to the
  line starting at the given position.
  */
  static line(e) {
    return new j1(e);
  }
  /**
  Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
  decorated range or ranges. If the ranges aren't already sorted,
  pass `true` for `sort` to make the library sort them for you.
  */
  static set(e, t = !1) {
    return Vt.of(e, t);
  }
  /**
  @internal
  */
  hasHeight() {
    return this.widget ? this.widget.estimatedHeight > -1 : !1;
  }
}
ct.none = Vt.empty;
class V1 extends ct {
  constructor(e) {
    let { start: t, end: r } = jle(e);
    super(t ? -1 : 5e8, r ? 1 : -6e8, null, e), this.tagName = e.tagName || "span", this.class = e.class || "", this.attrs = e.attributes || null;
  }
  eq(e) {
    var t, r;
    return this == e || e instanceof V1 && this.tagName == e.tagName && (this.class || ((t = this.attrs) === null || t === void 0 ? void 0 : t.class)) == (e.class || ((r = e.attrs) === null || r === void 0 ? void 0 : r.class)) && Xb(this.attrs, e.attrs, "class");
  }
  range(e, t = e) {
    if (e >= t)
      throw new RangeError("Mark decorations may not be empty");
    return super.range(e, t);
  }
}
V1.prototype.point = !1;
class j1 extends ct {
  constructor(e) {
    super(-2e8, -2e8, null, e);
  }
  eq(e) {
    return e instanceof j1 && this.spec.class == e.spec.class && Xb(this.spec.attributes, e.spec.attributes);
  }
  range(e, t = e) {
    if (t != e)
      throw new RangeError("Line decoration ranges must be zero-length");
    return super.range(e, t);
  }
}
j1.prototype.mapMode = hi.TrackBefore;
j1.prototype.point = !0;
class xc extends ct {
  constructor(e, t, r, i, s, o) {
    super(t, r, s, e), this.block = i, this.isReplace = o, this.mapMode = i ? t <= 0 ? hi.TrackBefore : hi.TrackAfter : hi.TrackDel;
  }
  // Only relevant when this.block == true
  get type() {
    return this.startSide != this.endSide ? vi.WidgetRange : this.startSide <= 0 ? vi.WidgetBefore : vi.WidgetAfter;
  }
  get heightRelevant() {
    return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
  }
  eq(e) {
    return e instanceof xc && tmt(this.widget, e.widget) && this.block == e.block && this.startSide == e.startSide && this.endSide == e.endSide;
  }
  range(e, t = e) {
    if (this.isReplace && (e > t || e == t && this.startSide > 0 && this.endSide <= 0))
      throw new RangeError("Invalid range for replacement decoration");
    if (!this.isReplace && t != e)
      throw new RangeError("Widget decorations can only have zero-length ranges");
    return super.range(e, t);
  }
}
xc.prototype.point = !0;
function jle(n, e = !1) {
  let { inclusiveStart: t, inclusiveEnd: r } = n;
  return t == null && (t = n.inclusive), r == null && (r = n.inclusive), { start: t ?? e, end: r ?? e };
}
function tmt(n, e) {
  return n == e || !!(n && e && n.compare(e));
}
function c2(n, e, t, r = 0) {
  let i = t.length - 1;
  i >= 0 && t[i] + r >= n ? t[i] = Math.max(t[i], e) : t.push(n, e);
}
class sr extends pn {
  constructor() {
    super(...arguments), this.children = [], this.length = 0, this.prevAttrs = void 0, this.attrs = null, this.breakAfter = 0;
  }
  // Consumes source
  merge(e, t, r, i, s, o) {
    if (r) {
      if (!(r instanceof sr))
        return !1;
      this.dom || r.transferDOM(this);
    }
    return i && this.setDeco(r ? r.attrs : null), zle(this, e, t, r ? r.children.slice() : [], s, o), !0;
  }
  split(e) {
    let t = new sr();
    if (t.breakAfter = this.breakAfter, this.length == 0)
      return t;
    let { i: r, off: i } = this.childPos(e);
    i && (t.append(this.children[r].split(i), 0), this.children[r].merge(i, this.children[r].length, null, !1, 0, 0), r++);
    for (let s = r; s < this.children.length; s++)
      t.append(this.children[s], 0);
    for (; r > 0 && this.children[r - 1].length == 0; )
      this.children[--r].destroy();
    return this.children.length = r, this.markDirty(), this.length = e, t;
  }
  transferDOM(e) {
    this.dom && (this.markDirty(), e.setDOM(this.dom), e.prevAttrs = this.prevAttrs === void 0 ? this.attrs : this.prevAttrs, this.prevAttrs = void 0, this.dom = null);
  }
  setDeco(e) {
    Xb(this.attrs, e) || (this.dom && (this.prevAttrs = this.attrs, this.markDirty()), this.attrs = e);
  }
  append(e, t) {
    Ule(this, e, t);
  }
  // Only called when building a line view in ContentBuilder
  addLineDeco(e) {
    let t = e.spec.attributes, r = e.spec.class;
    t && (this.attrs = q9(t, this.attrs || {})), r && (this.attrs = q9({ class: r }, this.attrs || {}));
  }
  domAtPos(e) {
    return Hle(this, e);
  }
  reuseDOM(e) {
    e.nodeName == "DIV" && (this.setDOM(e), this.flags |= 6);
  }
  sync(e, t) {
    var r;
    this.dom ? this.flags & 4 && (Dle(this.dom), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0) : (this.setDOM(document.createElement("div")), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0), this.prevAttrs !== void 0 && (Y9(this.dom, this.prevAttrs, this.attrs), this.dom.classList.add("cm-line"), this.prevAttrs = void 0), super.sync(e, t);
    let i = this.dom.lastChild;
    for (; i && pn.get(i) instanceof gl; )
      i = i.lastChild;
    if (!i || !this.length || i.nodeName != "BR" && ((r = pn.get(i)) === null || r === void 0 ? void 0 : r.isEditable) == !1 && (!ze.ios || !this.children.some((s) => s instanceof Ao))) {
      let s = document.createElement("BR");
      s.cmIgnore = !0, this.dom.appendChild(s);
    }
  }
  measureTextSize() {
    if (this.children.length == 0 || this.length > 20)
      return null;
    let e = 0, t;
    for (let r of this.children) {
      if (!(r instanceof Ao) || /[^ -~]/.test(r.text))
        return null;
      let i = uh(r.dom);
      if (i.length != 1)
        return null;
      e += i[0].width, t = i[0].height;
    }
    return e ? {
      lineHeight: this.dom.getBoundingClientRect().height,
      charWidth: e / this.length,
      textHeight: t
    } : null;
  }
  coordsAt(e, t) {
    let r = Vle(this, e, t);
    if (!this.children.length && r && this.parent) {
      let { heightOracle: i } = this.parent.view.viewState, s = r.bottom - r.top;
      if (Math.abs(s - i.lineHeight) < 2 && i.textHeight < s) {
        let o = (s - i.textHeight) / 2;
        return { top: r.top + o, bottom: r.bottom - o, left: r.left, right: r.left };
      }
    }
    return r;
  }
  become(e) {
    return e instanceof sr && this.children.length == 0 && e.children.length == 0 && Xb(this.attrs, e.attrs) && this.breakAfter == e.breakAfter;
  }
  covers() {
    return !0;
  }
  static find(e, t) {
    for (let r = 0, i = 0; r < e.children.length; r++) {
      let s = e.children[r], o = i + s.length;
      if (o >= t) {
        if (s instanceof sr)
          return s;
        if (o > t)
          break;
      }
      i = o + s.breakAfter;
    }
    return null;
  }
}
class ll extends pn {
  constructor(e, t, r) {
    super(), this.widget = e, this.length = t, this.deco = r, this.breakAfter = 0, this.prevWidget = null;
  }
  merge(e, t, r, i, s, o) {
    return r && (!(r instanceof ll) || !this.widget.compare(r.widget) || e > 0 && s <= 0 || t < this.length && o <= 0) ? !1 : (this.length = e + (r ? r.length : 0) + (this.length - t), !0);
  }
  domAtPos(e) {
    return e == 0 ? si.before(this.dom) : si.after(this.dom, e == this.length);
  }
  split(e) {
    let t = this.length - e;
    this.length = e;
    let r = new ll(this.widget, t, this.deco);
    return r.breakAfter = this.breakAfter, r;
  }
  get children() {
    return GO;
  }
  sync(e) {
    (!this.dom || !this.widget.updateDOM(this.dom, e)) && (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(e)), this.widget.editable || (this.dom.contentEditable = "false"));
  }
  get overrideDOMText() {
    return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : jt.empty;
  }
  domBoundsAround() {
    return null;
  }
  become(e) {
    return e instanceof ll && e.widget.constructor == this.widget.constructor ? (e.widget.compare(this.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = e.widget, this.length = e.length, this.deco = e.deco, this.breakAfter = e.breakAfter, !0) : !1;
  }
  ignoreMutation() {
    return !0;
  }
  ignoreEvent(e) {
    return this.widget.ignoreEvent(e);
  }
  get isEditable() {
    return !1;
  }
  get isWidget() {
    return !0;
  }
  coordsAt(e, t) {
    let r = this.widget.coordsAt(this.dom, e, t);
    return r || (this.widget instanceof X9 ? null : U1(this.dom.getBoundingClientRect(), this.length ? e == 0 : t <= 0));
  }
  destroy() {
    super.destroy(), this.dom && this.widget.destroy(this.dom);
  }
  covers(e) {
    let { startSide: t, endSide: r } = this.deco;
    return t == r ? !1 : e < 0 ? t < 0 : r > 0;
  }
}
class X9 extends Sl {
  constructor(e) {
    super(), this.height = e;
  }
  toDOM() {
    let e = document.createElement("div");
    return e.className = "cm-gap", this.updateDOM(e), e;
  }
  eq(e) {
    return e.height == this.height;
  }
  updateDOM(e) {
    return e.style.height = this.height + "px", !0;
  }
  get editable() {
    return !0;
  }
  get estimatedHeight() {
    return this.height;
  }
  ignoreEvent() {
    return !1;
  }
}
class hm {
  constructor(e, t, r, i) {
    this.doc = e, this.pos = t, this.end = r, this.disallowBlockEffectsFor = i, this.content = [], this.curLine = null, this.breakAtStart = 0, this.pendingBuffer = 0, this.bufferMarks = [], this.atCursorPos = !0, this.openStart = -1, this.openEnd = -1, this.text = "", this.textOff = 0, this.cursor = e.iter(), this.skip = t;
  }
  posCovered() {
    if (this.content.length == 0)
      return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
    let e = this.content[this.content.length - 1];
    return !(e.breakAfter || e instanceof ll && e.deco.endSide < 0);
  }
  getLine() {
    return this.curLine || (this.content.push(this.curLine = new sr()), this.atCursorPos = !0), this.curLine;
  }
  flushBuffer(e = this.bufferMarks) {
    this.pendingBuffer && (this.curLine.append(Ev(new dh(-1), e), e.length), this.pendingBuffer = 0);
  }
  addBlockWidget(e) {
    this.flushBuffer(), this.curLine = null, this.content.push(e);
  }
  finish(e) {
    this.pendingBuffer && e <= this.bufferMarks.length ? this.flushBuffer() : this.pendingBuffer = 0, !this.posCovered() && !(e && this.content.length && this.content[this.content.length - 1] instanceof ll) && this.getLine();
  }
  buildText(e, t, r) {
    for (; e > 0; ) {
      if (this.textOff == this.text.length) {
        let { value: o, lineBreak: a, done: l } = this.cursor.next(this.skip);
        if (this.skip = 0, l)
          throw new Error("Ran out of text content when drawing inline views");
        if (a) {
          this.posCovered() || this.getLine(), this.content.length ? this.content[this.content.length - 1].breakAfter = 1 : this.breakAtStart = 1, this.flushBuffer(), this.curLine = null, this.atCursorPos = !0, e--;
          continue;
        } else
          this.text = o, this.textOff = 0;
      }
      let i = Math.min(this.text.length - this.textOff, e), s = Math.min(
        i,
        512
        /* T.Chunk */
      );
      this.flushBuffer(t.slice(t.length - r)), this.getLine().append(Ev(new Ao(this.text.slice(this.textOff, this.textOff + s)), t), r), this.atCursorPos = !0, this.textOff += s, e -= s, r = i <= s ? 0 : t.length;
    }
  }
  span(e, t, r, i) {
    this.buildText(t - e, r, i), this.pos = t, this.openStart < 0 && (this.openStart = i);
  }
  point(e, t, r, i, s, o) {
    if (this.disallowBlockEffectsFor[o] && r instanceof xc) {
      if (r.block)
        throw new RangeError("Block decorations may not be specified via plugins");
      if (t > this.doc.lineAt(this.pos).to)
        throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
    }
    let a = t - e;
    if (r instanceof xc)
      if (r.block)
        r.startSide > 0 && !this.posCovered() && this.getLine(), this.addBlockWidget(new ll(r.widget || fh.block, a, r));
      else {
        let l = nc.create(r.widget || fh.inline, a, a ? 0 : r.startSide), c = this.atCursorPos && !l.isEditable && s <= i.length && (e < t || r.startSide > 0), u = !l.isEditable && (e < t || s > i.length || r.startSide <= 0), d = this.getLine();
        this.pendingBuffer == 2 && !c && !l.isEditable && (this.pendingBuffer = 0), this.flushBuffer(i), c && (d.append(Ev(new dh(1), i), s), s = i.length + Math.max(0, s - i.length)), d.append(Ev(l, i), s), this.atCursorPos = u, this.pendingBuffer = u ? e < t || s > i.length ? 1 : 2 : 0, this.pendingBuffer && (this.bufferMarks = i.slice());
      }
    else this.doc.lineAt(this.pos).from == this.pos && this.getLine().addLineDeco(r);
    a && (this.textOff + a <= this.text.length ? this.textOff += a : (this.skip += a - (this.text.length - this.textOff), this.text = "", this.textOff = 0), this.pos = t), this.openStart < 0 && (this.openStart = s);
  }
  static build(e, t, r, i, s) {
    let o = new hm(e, t, r, s);
    return o.openEnd = Vt.spans(i, t, r, o), o.openStart < 0 && (o.openStart = o.openEnd), o.finish(o.openEnd), o;
  }
}
function Ev(n, e) {
  for (let t of e)
    n = new gl(t, [n], n.length);
  return n;
}
class fh extends Sl {
  constructor(e) {
    super(), this.tag = e;
  }
  eq(e) {
    return e.tag == this.tag;
  }
  toDOM() {
    return document.createElement(this.tag);
  }
  updateDOM(e) {
    return e.nodeName.toLowerCase() == this.tag;
  }
  get isHidden() {
    return !0;
  }
}
fh.inline = /* @__PURE__ */ new fh("span");
fh.block = /* @__PURE__ */ new fh("div");
var Dn = /* @__PURE__ */ (function(n) {
  return n[n.LTR = 0] = "LTR", n[n.RTL = 1] = "RTL", n;
})(Dn || (Dn = {}));
const Yu = Dn.LTR, KO = Dn.RTL;
function Wle(n) {
  let e = [];
  for (let t = 0; t < n.length; t++)
    e.push(1 << +n[t]);
  return e;
}
const nmt = /* @__PURE__ */ Wle("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008"), rmt = /* @__PURE__ */ Wle("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333"), Z9 = /* @__PURE__ */ Object.create(null), Uo = [];
for (let n of ["()", "[]", "{}"]) {
  let e = /* @__PURE__ */ n.charCodeAt(0), t = /* @__PURE__ */ n.charCodeAt(1);
  Z9[e] = t, Z9[t] = -e;
}
function Gle(n) {
  return n <= 247 ? nmt[n] : 1424 <= n && n <= 1524 ? 2 : 1536 <= n && n <= 1785 ? rmt[n - 1536] : 1774 <= n && n <= 2220 ? 4 : 8192 <= n && n <= 8204 ? 256 : 64336 <= n && n <= 65023 ? 4 : 1;
}
const imt = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
class rc {
  /**
  The direction of this span.
  */
  get dir() {
    return this.level % 2 ? KO : Yu;
  }
  /**
  @internal
  */
  constructor(e, t, r) {
    this.from = e, this.to = t, this.level = r;
  }
  /**
  @internal
  */
  side(e, t) {
    return this.dir == t == e ? this.to : this.from;
  }
  /**
  @internal
  */
  forward(e, t) {
    return e == (this.dir == t);
  }
  /**
  @internal
  */
  static find(e, t, r, i) {
    let s = -1;
    for (let o = 0; o < e.length; o++) {
      let a = e[o];
      if (a.from <= t && a.to >= t) {
        if (a.level == r)
          return o;
        (s < 0 || (i != 0 ? i < 0 ? a.from < t : a.to > t : e[s].level > a.level)) && (s = o);
      }
    }
    if (s < 0)
      throw new RangeError("Index out of range");
    return s;
  }
}
function Kle(n, e) {
  if (n.length != e.length)
    return !1;
  for (let t = 0; t < n.length; t++) {
    let r = n[t], i = e[t];
    if (r.from != i.from || r.to != i.to || r.direction != i.direction || !Kle(r.inner, i.inner))
      return !1;
  }
  return !0;
}
const bn = [];
function smt(n, e, t, r, i) {
  for (let s = 0; s <= r.length; s++) {
    let o = s ? r[s - 1].to : e, a = s < r.length ? r[s].from : t, l = s ? 256 : i;
    for (let c = o, u = l, d = l; c < a; c++) {
      let f = Gle(n.charCodeAt(c));
      f == 512 ? f = u : f == 8 && d == 4 && (f = 16), bn[c] = f == 4 ? 2 : f, f & 7 && (d = f), u = f;
    }
    for (let c = o, u = l, d = l; c < a; c++) {
      let f = bn[c];
      if (f == 128)
        c < a - 1 && u == bn[c + 1] && u & 24 ? f = bn[c] = u : bn[c] = 256;
      else if (f == 64) {
        let h = c + 1;
        for (; h < a && bn[h] == 64; )
          h++;
        let m = c && u == 8 || h < t && bn[h] == 8 ? d == 1 ? 1 : 8 : 256;
        for (let g = c; g < h; g++)
          bn[g] = m;
        c = h - 1;
      } else f == 8 && d == 1 && (bn[c] = 1);
      u = f, f & 7 && (d = f);
    }
  }
}
function omt(n, e, t, r, i) {
  let s = i == 1 ? 2 : 1;
  for (let o = 0, a = 0, l = 0; o <= r.length; o++) {
    let c = o ? r[o - 1].to : e, u = o < r.length ? r[o].from : t;
    for (let d = c, f, h, m; d < u; d++)
      if (h = Z9[f = n.charCodeAt(d)])
        if (h < 0) {
          for (let g = a - 3; g >= 0; g -= 3)
            if (Uo[g + 1] == -h) {
              let v = Uo[g + 2], y = v & 2 ? i : v & 4 ? v & 1 ? s : i : 0;
              y && (bn[d] = bn[Uo[g]] = y), a = g;
              break;
            }
        } else {
          if (Uo.length == 189)
            break;
          Uo[a++] = d, Uo[a++] = f, Uo[a++] = l;
        }
      else if ((m = bn[d]) == 2 || m == 1) {
        let g = m == i;
        l = g ? 0 : 1;
        for (let v = a - 3; v >= 0; v -= 3) {
          let y = Uo[v + 2];
          if (y & 2)
            break;
          if (g)
            Uo[v + 2] |= 2;
          else {
            if (y & 4)
              break;
            Uo[v + 2] |= 4;
          }
        }
      }
  }
}
function amt(n, e, t, r) {
  for (let i = 0, s = r; i <= t.length; i++) {
    let o = i ? t[i - 1].to : n, a = i < t.length ? t[i].from : e;
    for (let l = o; l < a; ) {
      let c = bn[l];
      if (c == 256) {
        let u = l + 1;
        for (; ; )
          if (u == a) {
            if (i == t.length)
              break;
            u = t[i++].to, a = i < t.length ? t[i].from : e;
          } else if (bn[u] == 256)
            u++;
          else
            break;
        let d = s == 1, f = (u < e ? bn[u] : r) == 1, h = d == f ? d ? 1 : 2 : r;
        for (let m = u, g = i, v = g ? t[g - 1].to : n; m > l; )
          m == v && (m = t[--g].from, v = g ? t[g - 1].to : n), bn[--m] = h;
        l = u;
      } else
        s = c, l++;
    }
  }
}
function Q9(n, e, t, r, i, s, o) {
  let a = r % 2 ? 2 : 1;
  if (r % 2 == i % 2)
    for (let l = e, c = 0; l < t; ) {
      let u = !0, d = !1;
      if (c == s.length || l < s[c].from) {
        let g = bn[l];
        g != a && (u = !1, d = g == 16);
      }
      let f = !u && a == 1 ? [] : null, h = u ? r : r + 1, m = l;
      e: for (; ; )
        if (c < s.length && m == s[c].from) {
          if (d)
            break e;
          let g = s[c];
          if (!u)
            for (let v = g.to, y = c + 1; ; ) {
              if (v == t)
                break e;
              if (y < s.length && s[y].from == v)
                v = s[y++].to;
              else {
                if (bn[v] == a)
                  break e;
                break;
              }
            }
          if (c++, f)
            f.push(g);
          else {
            g.from > l && o.push(new rc(l, g.from, h));
            let v = g.direction == Yu != !(h % 2);
            J9(n, v ? r + 1 : r, i, g.inner, g.from, g.to, o), l = g.to;
          }
          m = g.to;
        } else {
          if (m == t || (u ? bn[m] != a : bn[m] == a))
            break;
          m++;
        }
      f ? Q9(n, l, m, r + 1, i, f, o) : l < m && o.push(new rc(l, m, h)), l = m;
    }
  else
    for (let l = t, c = s.length; l > e; ) {
      let u = !0, d = !1;
      if (!c || l > s[c - 1].to) {
        let g = bn[l - 1];
        g != a && (u = !1, d = g == 16);
      }
      let f = !u && a == 1 ? [] : null, h = u ? r : r + 1, m = l;
      e: for (; ; )
        if (c && m == s[c - 1].to) {
          if (d)
            break e;
          let g = s[--c];
          if (!u)
            for (let v = g.from, y = c; ; ) {
              if (v == e)
                break e;
              if (y && s[y - 1].to == v)
                v = s[--y].from;
              else {
                if (bn[v - 1] == a)
                  break e;
                break;
              }
            }
          if (f)
            f.push(g);
          else {
            g.to < l && o.push(new rc(g.to, l, h));
            let v = g.direction == Yu != !(h % 2);
            J9(n, v ? r + 1 : r, i, g.inner, g.from, g.to, o), l = g.from;
          }
          m = g.from;
        } else {
          if (m == e || (u ? bn[m - 1] != a : bn[m - 1] == a))
            break;
          m--;
        }
      f ? Q9(n, m, l, r + 1, i, f, o) : m < l && o.push(new rc(m, l, h)), l = m;
    }
}
function J9(n, e, t, r, i, s, o) {
  let a = e % 2 ? 2 : 1;
  smt(n, i, s, r, a), omt(n, i, s, r, a), amt(i, s, r, a), Q9(n, i, s, e, t, r, o);
}
function lmt(n, e, t) {
  if (!n)
    return [new rc(0, 0, e == KO ? 1 : 0)];
  if (e == Yu && !t.length && !imt.test(n))
    return qle(n.length);
  if (t.length)
    for (; n.length > bn.length; )
      bn[bn.length] = 256;
  let r = [], i = e == Yu ? 0 : 1;
  return J9(n, i, i, t, 0, n.length, r), r;
}
function qle(n) {
  return [new rc(0, n, 0)];
}
let Yle = "";
function cmt(n, e, t, r, i) {
  var s;
  let o = r.head - n.from, a = rc.find(e, o, (s = r.bidiLevel) !== null && s !== void 0 ? s : -1, r.assoc), l = e[a], c = l.side(i, t);
  if (o == c) {
    let f = a += i ? 1 : -1;
    if (f < 0 || f >= e.length)
      return null;
    l = e[a = f], o = l.side(!i, t), c = l.side(i, t);
  }
  let u = Gr(n.text, o, l.forward(i, t));
  (u < l.from || u > l.to) && (u = c), Yle = n.text.slice(Math.min(o, u), Math.max(o, u));
  let d = a == (i ? e.length - 1 : 0) ? null : e[a + (i ? 1 : -1)];
  return d && u == c && d.level + (i ? 0 : 1) < l.level ? ge.cursor(d.side(!i, t) + n.from, d.forward(i, t) ? 1 : -1, d.level) : ge.cursor(u + n.from, l.forward(i, t) ? -1 : 1, l.level);
}
function umt(n, e, t) {
  for (let r = e; r < t; r++) {
    let i = Gle(n.charCodeAt(r));
    if (i == 1)
      return Yu;
    if (i == 2 || i == 4)
      return KO;
  }
  return Yu;
}
const Xle = /* @__PURE__ */ je.define(), Zle = /* @__PURE__ */ je.define(), Qle = /* @__PURE__ */ je.define(), Jle = /* @__PURE__ */ je.define(), eA = /* @__PURE__ */ je.define(), ece = /* @__PURE__ */ je.define(), tce = /* @__PURE__ */ je.define(), qO = /* @__PURE__ */ je.define(), YO = /* @__PURE__ */ je.define(), nce = /* @__PURE__ */ je.define({
  combine: (n) => n.some((e) => e)
}), rce = /* @__PURE__ */ je.define({
  combine: (n) => n.some((e) => e)
}), ice = /* @__PURE__ */ je.define();
class wf {
  constructor(e, t = "nearest", r = "nearest", i = 5, s = 5, o = !1) {
    this.range = e, this.y = t, this.x = r, this.yMargin = i, this.xMargin = s, this.isSnapshot = o;
  }
  map(e) {
    return e.empty ? this : new wf(this.range.map(e), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
  clip(e) {
    return this.range.to <= e.doc.length ? this : new wf(ge.cursor(e.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
}
const Sv = /* @__PURE__ */ At.define({ map: (n, e) => n.map(e) }), sce = /* @__PURE__ */ At.define();
function zi(n, e, t) {
  let r = n.facet(Jle);
  r.length ? r[0](e) : window.onerror && window.onerror(String(e), t, void 0, void 0, e) || (t ? console.error(t + ":", e) : console.error(e));
}
const qa = /* @__PURE__ */ je.define({ combine: (n) => n.length ? n[0] : !0 });
let dmt = 0;
const Qd = /* @__PURE__ */ je.define({
  combine(n) {
    return n.filter((e, t) => {
      for (let r = 0; r < t; r++)
        if (n[r].plugin == e.plugin)
          return !1;
      return !0;
    });
  }
});
class nr {
  constructor(e, t, r, i, s) {
    this.id = e, this.create = t, this.domEventHandlers = r, this.domEventObservers = i, this.baseExtensions = s(this), this.extension = this.baseExtensions.concat(Qd.of({ plugin: this, arg: void 0 }));
  }
  /**
  Create an extension for this plugin with the given argument.
  */
  of(e) {
    return this.baseExtensions.concat(Qd.of({ plugin: this, arg: e }));
  }
  /**
  Define a plugin from a constructor function that creates the
  plugin's value, given an editor view.
  */
  static define(e, t) {
    const { eventHandlers: r, eventObservers: i, provide: s, decorations: o } = t || {};
    return new nr(dmt++, e, r, i, (a) => {
      let l = [];
      return o && l.push(X0.of((c) => {
        let u = c.plugin(a);
        return u ? o(u) : ct.none;
      })), s && l.push(s(a)), l;
    });
  }
  /**
  Create a plugin for a class whose constructor takes a single
  editor view as argument.
  */
  static fromClass(e, t) {
    return nr.define((r, i) => new e(r, i), t);
  }
}
class $8 {
  constructor(e) {
    this.spec = e, this.mustUpdate = null, this.value = null;
  }
  get plugin() {
    return this.spec && this.spec.plugin;
  }
  update(e) {
    if (this.value) {
      if (this.mustUpdate) {
        let t = this.mustUpdate;
        if (this.mustUpdate = null, this.value.update)
          try {
            this.value.update(t);
          } catch (r) {
            if (zi(t.state, r, "CodeMirror plugin crashed"), this.value.destroy)
              try {
                this.value.destroy();
              } catch {
              }
            this.deactivate();
          }
      }
    } else if (this.spec)
      try {
        this.value = this.spec.plugin.create(e, this.spec.arg);
      } catch (t) {
        zi(e.state, t, "CodeMirror plugin crashed"), this.deactivate();
      }
    return this;
  }
  destroy(e) {
    var t;
    if (!((t = this.value) === null || t === void 0) && t.destroy)
      try {
        this.value.destroy();
      } catch (r) {
        zi(e.state, r, "CodeMirror plugin crashed");
      }
  }
  deactivate() {
    this.spec = this.value = null;
  }
}
const oce = /* @__PURE__ */ je.define(), XO = /* @__PURE__ */ je.define(), X0 = /* @__PURE__ */ je.define(), ace = /* @__PURE__ */ je.define(), W1 = /* @__PURE__ */ je.define(), lce = /* @__PURE__ */ je.define();
function Vj(n, e) {
  let t = n.state.facet(lce);
  if (!t.length)
    return t;
  let r = t.map((s) => s instanceof Function ? s(n) : s), i = [];
  return Vt.spans(r, e.from, e.to, {
    point() {
    },
    span(s, o, a, l) {
      let c = s - e.from, u = o - e.from, d = i;
      for (let f = a.length - 1; f >= 0; f--, l--) {
        let h = a[f].spec.bidiIsolate, m;
        if (h == null && (h = umt(e.text, c, u)), l > 0 && d.length && (m = d[d.length - 1]).to == c && m.direction == h)
          m.to = u, d = m.inner;
        else {
          let g = { from: c, to: u, direction: h, inner: [] };
          d.push(g), d = g.inner;
        }
      }
    }
  }), i;
}
const cce = /* @__PURE__ */ je.define();
function ZO(n) {
  let e = 0, t = 0, r = 0, i = 0;
  for (let s of n.state.facet(cce)) {
    let o = s(n);
    o && (o.left != null && (e = Math.max(e, o.left)), o.right != null && (t = Math.max(t, o.right)), o.top != null && (r = Math.max(r, o.top)), o.bottom != null && (i = Math.max(i, o.bottom)));
  }
  return { left: e, right: t, top: r, bottom: i };
}
const $p = /* @__PURE__ */ je.define();
class Hs {
  constructor(e, t, r, i) {
    this.fromA = e, this.toA = t, this.fromB = r, this.toB = i;
  }
  join(e) {
    return new Hs(Math.min(this.fromA, e.fromA), Math.max(this.toA, e.toA), Math.min(this.fromB, e.fromB), Math.max(this.toB, e.toB));
  }
  addToSet(e) {
    let t = e.length, r = this;
    for (; t > 0; t--) {
      let i = e[t - 1];
      if (!(i.fromA > r.toA)) {
        if (i.toA < r.fromA)
          break;
        r = r.join(i), e.splice(t - 1, 1);
      }
    }
    return e.splice(t, 0, r), e;
  }
  static extendWithRanges(e, t) {
    if (t.length == 0)
      return e;
    let r = [];
    for (let i = 0, s = 0, o = 0, a = 0; ; i++) {
      let l = i == e.length ? null : e[i], c = o - a, u = l ? l.fromB : 1e9;
      for (; s < t.length && t[s] < u; ) {
        let d = t[s], f = t[s + 1], h = Math.max(a, d), m = Math.min(u, f);
        if (h <= m && new Hs(h + c, m + c, h, m).addToSet(r), f > u)
          break;
        s += 2;
      }
      if (!l)
        return r;
      new Hs(l.fromA, l.toA, l.fromB, l.toB).addToSet(r), o = l.toA, a = l.toB;
    }
  }
}
class Zb {
  constructor(e, t, r) {
    this.view = e, this.state = t, this.transactions = r, this.flags = 0, this.startState = e.state, this.changes = xr.empty(this.startState.doc.length);
    for (let s of r)
      this.changes = this.changes.compose(s.changes);
    let i = [];
    this.changes.iterChangedRanges((s, o, a, l) => i.push(new Hs(s, o, a, l))), this.changedRanges = i;
  }
  /**
  @internal
  */
  static create(e, t, r) {
    return new Zb(e, t, r);
  }
  /**
  Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
  [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
  update.
  */
  get viewportChanged() {
    return (this.flags & 4) > 0;
  }
  /**
  Returns true when
  [`viewportChanged`](https://codemirror.net/6/docs/ref/#view.ViewUpdate.viewportChanged) is true
  and the viewport change is not just the result of mapping it in
  response to document changes.
  */
  get viewportMoved() {
    return (this.flags & 8) > 0;
  }
  /**
  Indicates whether the height of a block element in the editor
  changed in this update.
  */
  get heightChanged() {
    return (this.flags & 2) > 0;
  }
  /**
  Returns true when the document was modified or the size of the
  editor, or elements within the editor, changed.
  */
  get geometryChanged() {
    return this.docChanged || (this.flags & 18) > 0;
  }
  /**
  True when this update indicates a focus change.
  */
  get focusChanged() {
    return (this.flags & 1) > 0;
  }
  /**
  Whether the document changed in this update.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Whether the selection was explicitly set in this update.
  */
  get selectionSet() {
    return this.transactions.some((e) => e.selection);
  }
  /**
  @internal
  */
  get empty() {
    return this.flags == 0 && this.transactions.length == 0;
  }
}
class jj extends pn {
  get length() {
    return this.view.state.doc.length;
  }
  constructor(e) {
    super(), this.view = e, this.decorations = [], this.dynamicDecorationMap = [!1], this.domChanged = null, this.hasComposition = null, this.markedForComposition = /* @__PURE__ */ new Set(), this.editContextFormatting = ct.none, this.lastCompositionAfterCursor = !1, this.minWidth = 0, this.minWidthFrom = 0, this.minWidthTo = 0, this.impreciseAnchor = null, this.impreciseHead = null, this.forceSelection = !1, this.lastUpdate = Date.now(), this.setDOM(e.contentDOM), this.children = [new sr()], this.children[0].setParent(this), this.updateDeco(), this.updateInner([new Hs(0, 0, 0, e.state.doc.length)], 0, null);
  }
  // Update the document view to a given state.
  update(e) {
    var t;
    let r = e.changedRanges;
    this.minWidth > 0 && r.length && (r.every(({ fromA: c, toA: u }) => u < this.minWidthFrom || c > this.minWidthTo) ? (this.minWidthFrom = e.changes.mapPos(this.minWidthFrom, 1), this.minWidthTo = e.changes.mapPos(this.minWidthTo, 1)) : this.minWidth = this.minWidthFrom = this.minWidthTo = 0), this.updateEditContextFormatting(e);
    let i = -1;
    this.view.inputState.composing >= 0 && !this.view.observer.editContext && (!((t = this.domChanged) === null || t === void 0) && t.newSel ? i = this.domChanged.newSel.head : !ymt(e.changes, this.hasComposition) && !e.selectionSet && (i = e.state.selection.main.head));
    let s = i > -1 ? hmt(this.view, e.changes, i) : null;
    if (this.domChanged = null, this.hasComposition) {
      this.markedForComposition.clear();
      let { from: c, to: u } = this.hasComposition;
      r = new Hs(c, u, e.changes.mapPos(c, -1), e.changes.mapPos(u, 1)).addToSet(r.slice());
    }
    this.hasComposition = s ? { from: s.range.fromB, to: s.range.toB } : null, (ze.ie || ze.chrome) && !s && e && e.state.doc.lines != e.startState.doc.lines && (this.forceSelection = !0);
    let o = this.decorations, a = this.updateDeco(), l = gmt(o, a, e.changes);
    return r = Hs.extendWithRanges(r, l), !(this.flags & 7) && r.length == 0 ? !1 : (this.updateInner(r, e.startState.doc.length, s), e.transactions.length && (this.lastUpdate = Date.now()), !0);
  }
  // Used by update and the constructor do perform the actual DOM
  // update
  updateInner(e, t, r) {
    this.view.viewState.mustMeasureContent = !0, this.updateChildren(e, t, r);
    let { observer: i } = this.view;
    i.ignore(() => {
      this.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px", this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
      let o = ze.chrome || ze.ios ? { node: i.selectionRange.focusNode, written: !1 } : void 0;
      this.sync(this.view, o), this.flags &= -8, o && (o.written || i.selectionRange.focusNode != o.node) && (this.forceSelection = !0), this.dom.style.height = "";
    }), this.markedForComposition.forEach(
      (o) => o.flags &= -9
      /* ViewFlag.Composition */
    );
    let s = [];
    if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length)
      for (let o of this.children)
        o instanceof ll && o.widget instanceof X9 && s.push(o.dom);
    i.updateGaps(s);
  }
  updateChildren(e, t, r) {
    let i = r ? r.range.addToSet(e.slice()) : e, s = this.childCursor(t);
    for (let o = i.length - 1; ; o--) {
      let a = o >= 0 ? i[o] : null;
      if (!a)
        break;
      let { fromA: l, toA: c, fromB: u, toB: d } = a, f, h, m, g;
      if (r && r.range.fromB < d && r.range.toB > u) {
        let E = hm.build(this.view.state.doc, u, r.range.fromB, this.decorations, this.dynamicDecorationMap), w = hm.build(this.view.state.doc, r.range.toB, d, this.decorations, this.dynamicDecorationMap);
        h = E.breakAtStart, m = E.openStart, g = w.openEnd;
        let C = this.compositionView(r);
        w.breakAtStart ? C.breakAfter = 1 : w.content.length && C.merge(C.length, C.length, w.content[0], !1, w.openStart, 0) && (C.breakAfter = w.content[0].breakAfter, w.content.shift()), E.content.length && C.merge(0, 0, E.content[E.content.length - 1], !0, 0, E.openEnd) && E.content.pop(), f = E.content.concat(C).concat(w.content);
      } else
        ({ content: f, breakAtStart: h, openStart: m, openEnd: g } = hm.build(this.view.state.doc, u, d, this.decorations, this.dynamicDecorationMap));
      let { i: v, off: y } = s.findPos(c, 1), { i: b, off: x } = s.findPos(l, -1);
      Ble(this, b, x, v, y, f, h, m, g);
    }
    r && this.fixCompositionDOM(r);
  }
  updateEditContextFormatting(e) {
    this.editContextFormatting = this.editContextFormatting.map(e.changes);
    for (let t of e.transactions)
      for (let r of t.effects)
        r.is(sce) && (this.editContextFormatting = r.value);
  }
  compositionView(e) {
    let t = new Ao(e.text.nodeValue);
    t.flags |= 8;
    for (let { deco: i } of e.marks)
      t = new gl(i, [t], t.length);
    let r = new sr();
    return r.append(t, 0), r;
  }
  fixCompositionDOM(e) {
    let t = (s, o) => {
      o.flags |= 8 | (o.children.some(
        (l) => l.flags & 7
        /* ViewFlag.Dirty */
      ) ? 1 : 0), this.markedForComposition.add(o);
      let a = pn.get(s);
      a && a != o && (a.dom = null), o.setDOM(s);
    }, r = this.childPos(e.range.fromB, 1), i = this.children[r.i];
    t(e.line, i);
    for (let s = e.marks.length - 1; s >= -1; s--)
      r = i.childPos(r.off, 1), i = i.children[r.i], t(s >= 0 ? e.marks[s].node : e.text, i);
  }
  // Sync the DOM selection to this.state.selection
  updateSelection(e = !1, t = !1) {
    (e || !this.view.observer.selectionRange.focusNode) && this.view.observer.readSelectionRange();
    let r = this.view.root.activeElement, i = r == this.dom, s = !i && !(this.view.state.facet(qa) || this.dom.tabIndex > -1) && l2(this.dom, this.view.observer.selectionRange) && !(r && this.dom.contains(r));
    if (!(i || t || s))
      return;
    let o = this.forceSelection;
    this.forceSelection = !1;
    let a = this.view.state.selection.main, l = this.moveToLine(this.domAtPos(a.anchor)), c = a.empty ? l : this.moveToLine(this.domAtPos(a.head));
    if (ze.gecko && a.empty && !this.hasComposition && fmt(l)) {
      let d = document.createTextNode("");
      this.view.observer.ignore(() => l.node.insertBefore(d, l.node.childNodes[l.offset] || null)), l = c = new si(d, 0), o = !0;
    }
    let u = this.view.observer.selectionRange;
    (o || !u.focusNode || (!fm(l.node, l.offset, u.anchorNode, u.anchorOffset) || !fm(c.node, c.offset, u.focusNode, u.focusOffset)) && !this.suppressWidgetCursorChange(u, a)) && (this.view.observer.ignore(() => {
      ze.android && ze.chrome && this.dom.contains(u.focusNode) && vmt(u.focusNode, this.dom) && (this.dom.blur(), this.dom.focus({ preventScroll: !0 }));
      let d = Y0(this.view.root);
      if (d) if (a.empty) {
        if (ze.gecko) {
          let f = pmt(l.node, l.offset);
          if (f && f != 3) {
            let h = (f == 1 ? Lle : $le)(l.node, l.offset);
            h && (l = new si(h.node, h.offset));
          }
        }
        d.collapse(l.node, l.offset), a.bidiLevel != null && d.caretBidiLevel !== void 0 && (d.caretBidiLevel = a.bidiLevel);
      } else if (d.extend) {
        d.collapse(l.node, l.offset);
        try {
          d.extend(c.node, c.offset);
        } catch {
        }
      } else {
        let f = document.createRange();
        a.anchor > a.head && ([l, c] = [c, l]), f.setEnd(c.node, c.offset), f.setStart(l.node, l.offset), d.removeAllRanges(), d.addRange(f);
      }
      s && this.view.root.activeElement == this.dom && (this.dom.blur(), r && r.focus());
    }), this.view.observer.setSelectionRange(l, c)), this.impreciseAnchor = l.precise ? null : new si(u.anchorNode, u.anchorOffset), this.impreciseHead = c.precise ? null : new si(u.focusNode, u.focusOffset);
  }
  // If a zero-length widget is inserted next to the cursor during
  // composition, avoid moving it across it and disrupting the
  // composition.
  suppressWidgetCursorChange(e, t) {
    return this.hasComposition && t.empty && fm(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset) && this.posFromDOM(e.focusNode, e.focusOffset) == t.head;
  }
  enforceCursorAssoc() {
    if (this.hasComposition)
      return;
    let { view: e } = this, t = e.state.selection.main, r = Y0(e.root), { anchorNode: i, anchorOffset: s } = e.observer.selectionRange;
    if (!r || !t.empty || !t.assoc || !r.modify)
      return;
    let o = sr.find(this, t.head);
    if (!o)
      return;
    let a = o.posAtStart;
    if (t.head == a || t.head == a + o.length)
      return;
    let l = this.coordsAt(t.head, -1), c = this.coordsAt(t.head, 1);
    if (!l || !c || l.bottom > c.top)
      return;
    let u = this.domAtPos(t.head + t.assoc);
    r.collapse(u.node, u.offset), r.modify("move", t.assoc < 0 ? "forward" : "backward", "lineboundary"), e.observer.readSelectionRange();
    let d = e.observer.selectionRange;
    e.docView.posFromDOM(d.anchorNode, d.anchorOffset) != t.from && r.collapse(i, s);
  }
  // If a position is in/near a block widget, move it to a nearby text
  // line, since we don't want the cursor inside a block widget.
  moveToLine(e) {
    let t = this.dom, r;
    if (e.node != t)
      return e;
    for (let i = e.offset; !r && i < t.childNodes.length; i++) {
      let s = pn.get(t.childNodes[i]);
      s instanceof sr && (r = s.domAtPos(0));
    }
    for (let i = e.offset - 1; !r && i >= 0; i--) {
      let s = pn.get(t.childNodes[i]);
      s instanceof sr && (r = s.domAtPos(s.length));
    }
    return r ? new si(r.node, r.offset, !0) : e;
  }
  nearest(e) {
    for (let t = e; t; ) {
      let r = pn.get(t);
      if (r && r.rootView == this)
        return r;
      t = t.parentNode;
    }
    return null;
  }
  posFromDOM(e, t) {
    let r = this.nearest(e);
    if (!r)
      throw new RangeError("Trying to find position for a DOM position outside of the document");
    return r.localPosFromDOM(e, t) + r.posAtStart;
  }
  domAtPos(e) {
    let { i: t, off: r } = this.childCursor().findPos(e, -1);
    for (; t < this.children.length - 1; ) {
      let i = this.children[t];
      if (r < i.length || i instanceof sr)
        break;
      t++, r = 0;
    }
    return this.children[t].domAtPos(r);
  }
  coordsAt(e, t) {
    let r = null, i = 0;
    for (let s = this.length, o = this.children.length - 1; o >= 0; o--) {
      let a = this.children[o], l = s - a.breakAfter, c = l - a.length;
      if (l < e)
        break;
      if (c <= e && (c < e || a.covers(-1)) && (l > e || a.covers(1)) && (!r || a instanceof sr && !(r instanceof sr && t >= 0)))
        r = a, i = c;
      else if (r && c == e && l == e && a instanceof ll && Math.abs(t) < 2) {
        if (a.deco.startSide < 0)
          break;
        o && (r = null);
      }
      s = c;
    }
    return r ? r.coordsAt(e - i, t) : null;
  }
  coordsForChar(e) {
    let { i: t, off: r } = this.childPos(e, 1), i = this.children[t];
    if (!(i instanceof sr))
      return null;
    for (; i.children.length; ) {
      let { i: a, off: l } = i.childPos(r, 1);
      for (; ; a++) {
        if (a == i.children.length)
          return null;
        if ((i = i.children[a]).length)
          break;
      }
      r = l;
    }
    if (!(i instanceof Ao))
      return null;
    let s = Gr(i.text, r);
    if (s == r)
      return null;
    let o = qu(i.dom, r, s).getClientRects();
    for (let a = 0; a < o.length; a++) {
      let l = o[a];
      if (a == o.length - 1 || l.top < l.bottom && l.left < l.right)
        return l;
    }
    return null;
  }
  measureVisibleLineHeights(e) {
    let t = [], { from: r, to: i } = e, s = this.view.contentDOM.clientWidth, o = s > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1, a = -1, l = this.view.textDirection == Dn.LTR;
    for (let c = 0, u = 0; u < this.children.length; u++) {
      let d = this.children[u], f = c + d.length;
      if (f > i)
        break;
      if (c >= r) {
        let h = d.dom.getBoundingClientRect();
        if (t.push(h.height), o) {
          let m = d.dom.lastChild, g = m ? uh(m) : [];
          if (g.length) {
            let v = g[g.length - 1], y = l ? v.right - h.left : h.right - v.left;
            y > a && (a = y, this.minWidth = s, this.minWidthFrom = c, this.minWidthTo = f);
          }
        }
      }
      c = f + d.breakAfter;
    }
    return t;
  }
  textDirectionAt(e) {
    let { i: t } = this.childPos(e, 1);
    return getComputedStyle(this.children[t].dom).direction == "rtl" ? Dn.RTL : Dn.LTR;
  }
  measureTextSize() {
    for (let s of this.children)
      if (s instanceof sr) {
        let o = s.measureTextSize();
        if (o)
          return o;
      }
    let e = document.createElement("div"), t, r, i;
    return e.className = "cm-line", e.style.width = "99999px", e.style.position = "absolute", e.textContent = "abc def ghi jkl mno pqr stu", this.view.observer.ignore(() => {
      this.dom.appendChild(e);
      let s = uh(e.firstChild)[0];
      t = e.getBoundingClientRect().height, r = s ? s.width / 27 : 7, i = s ? s.height : t, e.remove();
    }), { lineHeight: t, charWidth: r, textHeight: i };
  }
  childCursor(e = this.length) {
    let t = this.children.length;
    return t && (e -= this.children[--t].length), new Fle(this.children, e, t);
  }
  computeBlockGapDeco() {
    let e = [], t = this.view.viewState;
    for (let r = 0, i = 0; ; i++) {
      let s = i == t.viewports.length ? null : t.viewports[i], o = s ? s.from - 1 : this.length;
      if (o > r) {
        let a = (t.lineBlockAt(o).bottom - t.lineBlockAt(r).top) / this.view.scaleY;
        e.push(ct.replace({
          widget: new X9(a),
          block: !0,
          inclusive: !0,
          isBlockGap: !0
        }).range(r, o));
      }
      if (!s)
        break;
      r = s.to + 1;
    }
    return ct.set(e);
  }
  updateDeco() {
    let e = 1, t = this.view.state.facet(X0).map((s) => (this.dynamicDecorationMap[e++] = typeof s == "function") ? s(this.view) : s), r = !1, i = this.view.state.facet(ace).map((s, o) => {
      let a = typeof s == "function";
      return a && (r = !0), a ? s(this.view) : s;
    });
    for (i.length && (this.dynamicDecorationMap[e++] = r, t.push(Vt.join(i))), this.decorations = [
      this.editContextFormatting,
      ...t,
      this.computeBlockGapDeco(),
      this.view.viewState.lineGapDeco
    ]; e < this.decorations.length; )
      this.dynamicDecorationMap[e++] = !1;
    return this.decorations;
  }
  scrollIntoView(e) {
    if (e.isSnapshot) {
      let c = this.view.viewState.lineBlockAt(e.range.head);
      this.view.scrollDOM.scrollTop = c.top - e.yMargin, this.view.scrollDOM.scrollLeft = e.xMargin;
      return;
    }
    for (let c of this.view.state.facet(ice))
      try {
        if (c(this.view, e.range, e))
          return !0;
      } catch (u) {
        zi(this.view.state, u, "scroll handler");
      }
    let { range: t } = e, r = this.coordsAt(t.head, t.empty ? t.assoc : t.head > t.anchor ? -1 : 1), i;
    if (!r)
      return;
    !t.empty && (i = this.coordsAt(t.anchor, t.anchor > t.head ? -1 : 1)) && (r = {
      left: Math.min(r.left, i.left),
      top: Math.min(r.top, i.top),
      right: Math.max(r.right, i.right),
      bottom: Math.max(r.bottom, i.bottom)
    });
    let s = ZO(this.view), o = {
      left: r.left - s.left,
      top: r.top - s.top,
      right: r.right + s.right,
      bottom: r.bottom + s.bottom
    }, { offsetWidth: a, offsetHeight: l } = this.view.scrollDOM;
    Wpt(this.view.scrollDOM, o, t.head < t.anchor ? -1 : 1, e.x, e.y, Math.max(Math.min(e.xMargin, a), -a), Math.max(Math.min(e.yMargin, l), -l), this.view.textDirection == Dn.LTR);
  }
}
function fmt(n) {
  return n.node.nodeType == 1 && n.node.firstChild && (n.offset == 0 || n.node.childNodes[n.offset - 1].contentEditable == "false") && (n.offset == n.node.childNodes.length || n.node.childNodes[n.offset].contentEditable == "false");
}
function uce(n, e) {
  let t = n.observer.selectionRange;
  if (!t.focusNode)
    return null;
  let r = Lle(t.focusNode, t.focusOffset), i = $le(t.focusNode, t.focusOffset), s = r || i;
  if (i && r && i.node != r.node) {
    let a = pn.get(i.node);
    if (!a || a instanceof Ao && a.text != i.node.nodeValue)
      s = i;
    else if (n.docView.lastCompositionAfterCursor) {
      let l = pn.get(r.node);
      !l || l instanceof Ao && l.text != r.node.nodeValue || (s = i);
    }
  }
  if (n.docView.lastCompositionAfterCursor = s != r, !s)
    return null;
  let o = e - s.offset;
  return { from: o, to: o + s.node.nodeValue.length, node: s.node };
}
function hmt(n, e, t) {
  let r = uce(n, t);
  if (!r)
    return null;
  let { node: i, from: s, to: o } = r, a = i.nodeValue;
  if (/[\n\r]/.test(a) || n.state.doc.sliceString(r.from, r.to) != a)
    return null;
  let l = e.invertedDesc, c = new Hs(l.mapPos(s), l.mapPos(o), s, o), u = [];
  for (let d = i.parentNode; ; d = d.parentNode) {
    let f = pn.get(d);
    if (f instanceof gl)
      u.push({ node: d, deco: f.mark });
    else {
      if (f instanceof sr || d.nodeName == "DIV" && d.parentNode == n.contentDOM)
        return { range: c, text: i, marks: u, line: d };
      if (d != n.contentDOM)
        u.push({ node: d, deco: new V1({
          inclusive: !0,
          attributes: emt(d),
          tagName: d.tagName.toLowerCase()
        }) });
      else
        return null;
    }
  }
}
function pmt(n, e) {
  return n.nodeType != 1 ? 0 : (e && n.childNodes[e - 1].contentEditable == "false" ? 1 : 0) | (e < n.childNodes.length && n.childNodes[e].contentEditable == "false" ? 2 : 0);
}
let mmt = class {
  constructor() {
    this.changes = [];
  }
  compareRange(e, t) {
    c2(e, t, this.changes);
  }
  comparePoint(e, t) {
    c2(e, t, this.changes);
  }
  boundChange(e) {
    c2(e, e, this.changes);
  }
};
function gmt(n, e, t) {
  let r = new mmt();
  return Vt.compare(n, e, t, r), r.changes;
}
function vmt(n, e) {
  for (let t = n; t && t != e; t = t.assignedSlot || t.parentNode)
    if (t.nodeType == 1 && t.contentEditable == "false")
      return !0;
  return !1;
}
function ymt(n, e) {
  let t = !1;
  return e && n.iterChangedRanges((r, i) => {
    r < e.to && i > e.from && (t = !0);
  }), t;
}
function bmt(n, e, t = 1) {
  let r = n.charCategorizer(e), i = n.doc.lineAt(e), s = e - i.from;
  if (i.length == 0)
    return ge.cursor(e);
  s == 0 ? t = 1 : s == i.length && (t = -1);
  let o = s, a = s;
  t < 0 ? o = Gr(i.text, s, !1) : a = Gr(i.text, s);
  let l = r(i.text.slice(o, a));
  for (; o > 0; ) {
    let c = Gr(i.text, o, !1);
    if (r(i.text.slice(c, o)) != l)
      break;
    o = c;
  }
  for (; a < i.length; ) {
    let c = Gr(i.text, a);
    if (r(i.text.slice(a, c)) != l)
      break;
    a = c;
  }
  return ge.range(o + i.from, a + i.from);
}
function wmt(n, e) {
  return e.left > n ? e.left - n : Math.max(0, n - e.right);
}
function xmt(n, e) {
  return e.top > n ? e.top - n : Math.max(0, n - e.bottom);
}
function F8(n, e) {
  return n.top < e.bottom - 1 && n.bottom > e.top + 1;
}
function Wj(n, e) {
  return e < n.top ? { top: e, left: n.left, right: n.right, bottom: n.bottom } : n;
}
function Gj(n, e) {
  return e > n.bottom ? { top: n.top, left: n.left, right: n.right, bottom: e } : n;
}
function tA(n, e, t) {
  let r, i, s, o, a = !1, l, c, u, d;
  for (let m = n.firstChild; m; m = m.nextSibling) {
    let g = uh(m);
    for (let v = 0; v < g.length; v++) {
      let y = g[v];
      i && F8(i, y) && (y = Wj(Gj(y, i.bottom), i.top));
      let b = wmt(e, y), x = xmt(t, y);
      if (b == 0 && x == 0)
        return m.nodeType == 3 ? Kj(m, e, t) : tA(m, e, t);
      (!r || o > x || o == x && s > b) && (r = m, i = y, s = b, o = x, a = b ? e < y.left ? v > 0 : v < g.length - 1 : !0), b == 0 ? t > y.bottom && (!u || u.bottom < y.bottom) ? (l = m, u = y) : t < y.top && (!d || d.top > y.top) && (c = m, d = y) : u && F8(u, y) ? u = Gj(u, y.bottom) : d && F8(d, y) && (d = Wj(d, y.top));
    }
  }
  if (u && u.bottom >= t ? (r = l, i = u) : d && d.top <= t && (r = c, i = d), !r)
    return { node: n, offset: 0 };
  let f = Math.max(i.left, Math.min(i.right, e));
  if (r.nodeType == 3)
    return Kj(r, f, t);
  if (a && r.contentEditable != "false")
    return tA(r, f, t);
  let h = Array.prototype.indexOf.call(n.childNodes, r) + (e >= (i.left + i.right) / 2 ? 1 : 0);
  return { node: n, offset: h };
}
function Kj(n, e, t) {
  let r = n.nodeValue.length, i = -1, s = 1e9, o = 0;
  for (let a = 0; a < r; a++) {
    let l = qu(n, a, a + 1).getClientRects();
    for (let c = 0; c < l.length; c++) {
      let u = l[c];
      if (u.top == u.bottom)
        continue;
      o || (o = e - u.left);
      let d = (u.top > t ? u.top - t : t - u.bottom) - 1;
      if (u.left - 1 <= e && u.right + 1 >= e && d < s) {
        let f = e >= (u.left + u.right) / 2, h = f;
        if ((ze.chrome || ze.gecko) && qu(n, a).getBoundingClientRect().left == u.right && (h = !f), d <= 0)
          return { node: n, offset: a + (h ? 1 : 0) };
        i = a + (h ? 1 : 0), s = d;
      }
    }
  }
  return { node: n, offset: i > -1 ? i : o > 0 ? n.nodeValue.length : 0 };
}
function dce(n, e, t, r = -1) {
  var i, s;
  let o = n.contentDOM.getBoundingClientRect(), a = o.top + n.viewState.paddingTop, l, { docHeight: c } = n.viewState, { x: u, y: d } = e, f = d - a;
  if (f < 0)
    return 0;
  if (f > c)
    return n.state.doc.length;
  for (let E = n.viewState.heightOracle.textHeight / 2, w = !1; l = n.elementAtHeight(f), l.type != vi.Text; )
    for (; f = r > 0 ? l.bottom + E : l.top - E, !(f >= 0 && f <= c); ) {
      if (w)
        return t ? null : 0;
      w = !0, r = -r;
    }
  d = a + f;
  let h = l.from;
  if (h < n.viewport.from)
    return n.viewport.from == 0 ? 0 : t ? null : qj(n, o, l, u, d);
  if (h > n.viewport.to)
    return n.viewport.to == n.state.doc.length ? n.state.doc.length : t ? null : qj(n, o, l, u, d);
  let m = n.dom.ownerDocument, g = n.root.elementFromPoint ? n.root : m, v = g.elementFromPoint(u, d);
  v && !n.contentDOM.contains(v) && (v = null), v || (u = Math.max(o.left + 1, Math.min(o.right - 1, u)), v = g.elementFromPoint(u, d), v && !n.contentDOM.contains(v) && (v = null));
  let y, b = -1;
  if (v && ((i = n.docView.nearest(v)) === null || i === void 0 ? void 0 : i.isEditable) != !1) {
    if (m.caretPositionFromPoint) {
      let E = m.caretPositionFromPoint(u, d);
      E && ({ offsetNode: y, offset: b } = E);
    } else if (m.caretRangeFromPoint) {
      let E = m.caretRangeFromPoint(u, d);
      E && ({ startContainer: y, startOffset: b } = E);
    }
    y && (!n.contentDOM.contains(y) || ze.safari && Emt(y, b, u) || ze.chrome && Smt(y, b, u)) && (y = void 0), y && (b = Math.min(Ea(y), b));
  }
  if (!y || !n.docView.dom.contains(y)) {
    let E = sr.find(n.docView, h);
    if (!E)
      return f > l.top + l.height / 2 ? l.to : l.from;
    ({ node: y, offset: b } = tA(E.dom, u, d));
  }
  let x = n.docView.nearest(y);
  if (!x)
    return null;
  if (x.isWidget && ((s = x.dom) === null || s === void 0 ? void 0 : s.nodeType) == 1) {
    let E = x.dom.getBoundingClientRect();
    return e.y < E.top || e.y <= E.bottom && e.x <= (E.left + E.right) / 2 ? x.posAtStart : x.posAtEnd;
  } else
    return x.localPosFromDOM(y, b) + x.posAtStart;
}
function qj(n, e, t, r, i) {
  let s = Math.round((r - e.left) * n.defaultCharacterWidth);
  if (n.lineWrapping && t.height > n.defaultLineHeight * 1.5) {
    let a = n.viewState.heightOracle.textHeight, l = Math.floor((i - t.top - (n.defaultLineHeight - a) * 0.5) / a);
    s += l * n.viewState.heightOracle.lineLength;
  }
  let o = n.state.sliceDoc(t.from, t.to);
  return t.from + z9(o, s, n.state.tabSize);
}
function fce(n, e, t) {
  let r, i = n;
  if (n.nodeType != 3 || e != (r = n.nodeValue.length))
    return !1;
  for (; ; ) {
    let s = i.nextSibling;
    if (s) {
      if (s.nodeName == "BR")
        break;
      return !1;
    } else {
      let o = i.parentNode;
      if (!o || o.nodeName == "DIV")
        break;
      i = o;
    }
  }
  return qu(n, r - 1, r).getBoundingClientRect().right > t;
}
function Emt(n, e, t) {
  return fce(n, e, t);
}
function Smt(n, e, t) {
  if (e != 0)
    return fce(n, e, t);
  for (let i = n; ; ) {
    let s = i.parentNode;
    if (!s || s.nodeType != 1 || s.firstChild != i)
      return !1;
    if (s.classList.contains("cm-line"))
      break;
    i = s;
  }
  let r = n.nodeType == 1 ? n.getBoundingClientRect() : qu(n, 0, Math.max(n.nodeValue.length, 1)).getBoundingClientRect();
  return t - r.left > 5;
}
function nA(n, e, t) {
  let r = n.lineBlockAt(e);
  if (Array.isArray(r.type)) {
    let i;
    for (let s of r.type) {
      if (s.from > e)
        break;
      if (!(s.to < e)) {
        if (s.from < e && s.to > e)
          return s;
        (!i || s.type == vi.Text && (i.type != s.type || (t < 0 ? s.from < e : s.to > e))) && (i = s);
      }
    }
    return i || r;
  }
  return r;
}
function Cmt(n, e, t, r) {
  let i = nA(n, e.head, e.assoc || -1), s = !r || i.type != vi.Text || !(n.lineWrapping || i.widgetLineBreaks) ? null : n.coordsAtPos(e.assoc < 0 && e.head > i.from ? e.head - 1 : e.head);
  if (s) {
    let o = n.dom.getBoundingClientRect(), a = n.textDirectionAt(i.from), l = n.posAtCoords({
      x: t == (a == Dn.LTR) ? o.right - 1 : o.left + 1,
      y: (s.top + s.bottom) / 2
    });
    if (l != null)
      return ge.cursor(l, t ? -1 : 1);
  }
  return ge.cursor(t ? i.to : i.from, t ? -1 : 1);
}
function Yj(n, e, t, r) {
  let i = n.state.doc.lineAt(e.head), s = n.bidiSpans(i), o = n.textDirectionAt(i.from);
  for (let a = e, l = null; ; ) {
    let c = cmt(i, s, o, a, t), u = Yle;
    if (!c) {
      if (i.number == (t ? n.state.doc.lines : 1))
        return a;
      u = `
`, i = n.state.doc.line(i.number + (t ? 1 : -1)), s = n.bidiSpans(i), c = n.visualLineSide(i, !t);
    }
    if (l) {
      if (!l(u))
        return a;
    } else {
      if (!r)
        return c;
      l = r(u);
    }
    a = c;
  }
}
function Tmt(n, e, t) {
  let r = n.state.charCategorizer(e), i = r(t);
  return (s) => {
    let o = r(s);
    return i == $n.Space && (i = o), i == o;
  };
}
function Amt(n, e, t, r) {
  let i = e.head, s = t ? 1 : -1;
  if (i == (t ? n.state.doc.length : 0))
    return ge.cursor(i, e.assoc);
  let o = e.goalColumn, a, l = n.contentDOM.getBoundingClientRect(), c = n.coordsAtPos(i, e.assoc || -1), u = n.documentTop;
  if (c)
    o == null && (o = c.left - l.left), a = s < 0 ? c.top : c.bottom;
  else {
    let h = n.viewState.lineBlockAt(i);
    o == null && (o = Math.min(l.right - l.left, n.defaultCharacterWidth * (i - h.from))), a = (s < 0 ? h.top : h.bottom) + u;
  }
  let d = l.left + o, f = r ?? n.viewState.heightOracle.textHeight >> 1;
  for (let h = 0; ; h += 10) {
    let m = a + (f + h) * s, g = dce(n, { x: d, y: m }, !1, s);
    if (m < l.top || m > l.bottom || (s < 0 ? g < i : g > i)) {
      let v = n.docView.coordsForChar(g), y = !v || m < v.top ? -1 : 1;
      return ge.cursor(g, y, void 0, o);
    }
  }
}
function pm(n, e, t) {
  for (; ; ) {
    let r = 0;
    for (let i of n)
      i.between(e - 1, e + 1, (s, o, a) => {
        if (e > s && e < o) {
          let l = r || t || (e - s < o - e ? -1 : 1);
          e = l < 0 ? s : o, r = l;
        }
      });
    if (!r)
      return e;
  }
}
function hce(n, e) {
  let t = null;
  for (let r = 0; r < e.ranges.length; r++) {
    let i = e.ranges[r], s = null;
    if (i.empty) {
      let o = pm(n, i.from, 0);
      o != i.from && (s = ge.cursor(o, -1));
    } else {
      let o = pm(n, i.from, -1), a = pm(n, i.to, 1);
      (o != i.from || a != i.to) && (s = ge.range(i.from == i.anchor ? o : a, i.from == i.head ? o : a));
    }
    s && (t || (t = e.ranges.slice()), t[r] = s);
  }
  return t ? ge.create(t, e.mainIndex) : e;
}
function B8(n, e, t) {
  let r = pm(n.state.facet(W1).map((i) => i(n)), t.from, e.head > t.from ? -1 : 1);
  return r == t.from ? t : ge.cursor(r, r < t.from ? 1 : -1);
}
const Fp = "￿";
class Mmt {
  constructor(e, t) {
    this.points = e, this.text = "", this.lineSeparator = t.facet(Ht.lineSeparator);
  }
  append(e) {
    this.text += e;
  }
  lineBreak() {
    this.text += Fp;
  }
  readRange(e, t) {
    if (!e)
      return this;
    let r = e.parentNode;
    for (let i = e; ; ) {
      this.findPointBefore(r, i);
      let s = this.text.length;
      this.readNode(i);
      let o = i.nextSibling;
      if (o == t)
        break;
      let a = pn.get(i), l = pn.get(o);
      (a && l ? a.breakAfter : (a ? a.breakAfter : Yb(i)) || Yb(o) && (i.nodeName != "BR" || i.cmIgnore) && this.text.length > s) && !_mt(o, t) && this.lineBreak(), i = o;
    }
    return this.findPointBefore(r, t), this;
  }
  readTextNode(e) {
    let t = e.nodeValue;
    for (let r of this.points)
      r.node == e && (r.pos = this.text.length + Math.min(r.offset, t.length));
    for (let r = 0, i = this.lineSeparator ? null : /\r\n?|\n/g; ; ) {
      let s = -1, o = 1, a;
      if (this.lineSeparator ? (s = t.indexOf(this.lineSeparator, r), o = this.lineSeparator.length) : (a = i.exec(t)) && (s = a.index, o = a[0].length), this.append(t.slice(r, s < 0 ? t.length : s)), s < 0)
        break;
      if (this.lineBreak(), o > 1)
        for (let l of this.points)
          l.node == e && l.pos > this.text.length && (l.pos -= o - 1);
      r = s + o;
    }
  }
  readNode(e) {
    if (e.cmIgnore)
      return;
    let t = pn.get(e), r = t && t.overrideDOMText;
    if (r != null) {
      this.findPointInside(e, r.length);
      for (let i = r.iter(); !i.next().done; )
        i.lineBreak ? this.lineBreak() : this.append(i.value);
    } else e.nodeType == 3 ? this.readTextNode(e) : e.nodeName == "BR" ? e.nextSibling && this.lineBreak() : e.nodeType == 1 && this.readRange(e.firstChild, null);
  }
  findPointBefore(e, t) {
    for (let r of this.points)
      r.node == e && e.childNodes[r.offset] == t && (r.pos = this.text.length);
  }
  findPointInside(e, t) {
    for (let r of this.points)
      (e.nodeType == 3 ? r.node == e : e.contains(r.node)) && (r.pos = this.text.length + (kmt(e, r.node, r.offset) ? t : 0));
  }
}
function kmt(n, e, t) {
  for (; ; ) {
    if (!e || t < Ea(e))
      return !1;
    if (e == n)
      return !0;
    t = Ku(e) + 1, e = e.parentNode;
  }
}
function _mt(n, e) {
  let t;
  for (; !(n == e || !n); n = n.nextSibling) {
    let r = pn.get(n);
    if (!(r?.isWidget || n.cmIgnore))
      return !1;
    r && (t || (t = [])).push(r);
  }
  if (t)
    for (let r of t) {
      let i = r.overrideDOMText;
      if (i?.length)
        return !1;
    }
  return !0;
}
class Xj {
  constructor(e, t) {
    this.node = e, this.offset = t, this.pos = -1;
  }
}
class Omt {
  constructor(e, t, r, i) {
    this.typeOver = i, this.bounds = null, this.text = "", this.domChanged = t > -1;
    let { impreciseHead: s, impreciseAnchor: o } = e.docView;
    if (e.state.readOnly && t > -1)
      this.newSel = null;
    else if (t > -1 && (this.bounds = e.docView.domBoundsAround(t, r, 0))) {
      let a = s || o ? [] : Rmt(e), l = new Mmt(a, e.state);
      l.readRange(this.bounds.startDOM, this.bounds.endDOM), this.text = l.text, this.newSel = Pmt(a, this.bounds.from);
    } else {
      let a = e.observer.selectionRange, l = s && s.node == a.focusNode && s.offset == a.focusOffset || !K9(e.contentDOM, a.focusNode) ? e.state.selection.main.head : e.docView.posFromDOM(a.focusNode, a.focusOffset), c = o && o.node == a.anchorNode && o.offset == a.anchorOffset || !K9(e.contentDOM, a.anchorNode) ? e.state.selection.main.anchor : e.docView.posFromDOM(a.anchorNode, a.anchorOffset), u = e.viewport;
      if ((ze.ios || ze.chrome) && e.state.selection.main.empty && l != c && (u.from > 0 || u.to < e.state.doc.length)) {
        let d = Math.min(l, c), f = Math.max(l, c), h = u.from - d, m = u.to - f;
        (h == 0 || h == 1 || d == 0) && (m == 0 || m == -1 || f == e.state.doc.length) && (l = 0, c = e.state.doc.length);
      }
      this.newSel = ge.single(c, l);
    }
  }
}
function pce(n, e) {
  let t, { newSel: r } = e, i = n.state.selection.main, s = n.inputState.lastKeyTime > Date.now() - 100 ? n.inputState.lastKeyCode : -1;
  if (e.bounds) {
    let { from: o, to: a } = e.bounds, l = i.from, c = null;
    (s === 8 || ze.android && e.text.length < a - o) && (l = i.to, c = "end");
    let u = mce(n.state.doc.sliceString(o, a, Fp), e.text, l - o, c);
    u && (ze.chrome && s == 13 && u.toB == u.from + 2 && e.text.slice(u.from, u.toB) == Fp + Fp && u.toB--, t = {
      from: o + u.from,
      to: o + u.toA,
      insert: jt.of(e.text.slice(u.from, u.toB).split(Fp))
    });
  } else r && (!n.hasFocus && n.state.facet(qa) || r.main.eq(i)) && (r = null);
  if (!t && !r)
    return !1;
  if (!t && e.typeOver && !i.empty && r && r.main.empty ? t = { from: i.from, to: i.to, insert: n.state.doc.slice(i.from, i.to) } : (ze.mac || ze.android) && t && t.from == t.to && t.from == i.head - 1 && /^\. ?$/.test(t.insert.toString()) && n.contentDOM.getAttribute("autocorrect") == "off" ? (r && t.insert.length == 2 && (r = ge.single(r.main.anchor - 1, r.main.head - 1)), t = { from: t.from, to: t.to, insert: jt.of([t.insert.toString().replace(".", " ")]) }) : t && t.from >= i.from && t.to <= i.to && (t.from != i.from || t.to != i.to) && i.to - i.from - (t.to - t.from) <= 4 ? t = {
    from: i.from,
    to: i.to,
    insert: n.state.doc.slice(i.from, t.from).append(t.insert).append(n.state.doc.slice(t.to, i.to))
  } : ze.chrome && t && t.from == t.to && t.from == i.head && t.insert.toString() == `
 ` && n.lineWrapping && (r && (r = ge.single(r.main.anchor - 1, r.main.head - 1)), t = { from: i.from, to: i.to, insert: jt.of([" "]) }), t)
    return QO(n, t, r, s);
  if (r && !r.main.eq(i)) {
    let o = !1, a = "select";
    return n.inputState.lastSelectionTime > Date.now() - 50 && (n.inputState.lastSelectionOrigin == "select" && (o = !0), a = n.inputState.lastSelectionOrigin, a == "select.pointer" && (r = hce(n.state.facet(W1).map((l) => l(n)), r))), n.dispatch({ selection: r, scrollIntoView: o, userEvent: a }), !0;
  } else
    return !1;
}
function QO(n, e, t, r = -1) {
  if (ze.ios && n.inputState.flushIOSKey(e))
    return !0;
  let i = n.state.selection.main;
  if (ze.android && (e.to == i.to && // GBoard will sometimes remove a space it just inserted
  // after a completion when you press enter
  (e.from == i.from || e.from == i.from - 1 && n.state.sliceDoc(e.from, i.from) == " ") && e.insert.length == 1 && e.insert.lines == 2 && bf(n.contentDOM, "Enter", 13) || (e.from == i.from - 1 && e.to == i.to && e.insert.length == 0 || r == 8 && e.insert.length < e.to - e.from && e.to > i.head) && bf(n.contentDOM, "Backspace", 8) || e.from == i.from && e.to == i.to + 1 && e.insert.length == 0 && bf(n.contentDOM, "Delete", 46)))
    return !0;
  let s = e.insert.toString();
  n.inputState.composing >= 0 && n.inputState.composing++;
  let o, a = () => o || (o = Imt(n, e, t));
  return n.state.facet(ece).some((l) => l(n, e.from, e.to, s, a)) || n.dispatch(a()), !0;
}
function Imt(n, e, t) {
  let r, i = n.state, s = i.selection.main, o = -1;
  if (e.from == e.to && e.from < s.from || e.from > s.to) {
    let l = e.from < s.from ? -1 : 1, c = l < 0 ? s.from : s.to, u = pm(i.facet(W1).map((d) => d(n)), c, l);
    e.from == u && (o = u);
  }
  if (o > -1)
    r = {
      changes: e,
      selection: ge.cursor(e.from + e.insert.length, -1)
    };
  else if (e.from >= s.from && e.to <= s.to && e.to - e.from >= (s.to - s.from) / 3 && (!t || t.main.empty && t.main.from == e.from + e.insert.length) && n.inputState.composing < 0) {
    let l = s.from < e.from ? i.sliceDoc(s.from, e.from) : "", c = s.to > e.to ? i.sliceDoc(e.to, s.to) : "";
    r = i.replaceSelection(n.state.toText(l + e.insert.sliceString(0, void 0, n.state.lineBreak) + c));
  } else {
    let l = i.changes(e), c = t && t.main.to <= l.newLength ? t.main : void 0;
    if (i.selection.ranges.length > 1 && n.inputState.composing >= 0 && e.to <= s.to && e.to >= s.to - 10) {
      let u = n.state.sliceDoc(e.from, e.to), d, f = t && uce(n, t.main.head);
      if (f) {
        let g = e.insert.length - (e.to - e.from);
        d = { from: f.from, to: f.to - g };
      } else
        d = n.state.doc.lineAt(s.head);
      let h = s.to - e.to, m = s.to - s.from;
      r = i.changeByRange((g) => {
        if (g.from == s.from && g.to == s.to)
          return { changes: l, range: c || g.map(l) };
        let v = g.to - h, y = v - u.length;
        if (g.to - g.from != m || n.state.sliceDoc(y, v) != u || // Unfortunately, there's no way to make multiple
        // changes in the same node work without aborting
        // composition, so cursors in the composition range are
        // ignored.
        g.to >= d.from && g.from <= d.to)
          return { range: g };
        let b = i.changes({ from: y, to: v, insert: e.insert }), x = g.to - s.to;
        return {
          changes: b,
          range: c ? ge.range(Math.max(0, c.anchor + x), Math.max(0, c.head + x)) : g.map(b)
        };
      });
    } else
      r = {
        changes: l,
        selection: c && i.selection.replaceRange(c)
      };
  }
  let a = "input.type";
  return (n.composing || n.inputState.compositionPendingChange && n.inputState.compositionEndedAt > Date.now() - 50) && (n.inputState.compositionPendingChange = !1, a += ".compose", n.inputState.compositionFirstChange && (a += ".start", n.inputState.compositionFirstChange = !1)), i.update(r, { userEvent: a, scrollIntoView: !0 });
}
function mce(n, e, t, r) {
  let i = Math.min(n.length, e.length), s = 0;
  for (; s < i && n.charCodeAt(s) == e.charCodeAt(s); )
    s++;
  if (s == i && n.length == e.length)
    return null;
  let o = n.length, a = e.length;
  for (; o > 0 && a > 0 && n.charCodeAt(o - 1) == e.charCodeAt(a - 1); )
    o--, a--;
  if (r == "end") {
    let l = Math.max(0, s - Math.min(o, a));
    t -= o + l - s;
  }
  if (o < s && n.length < e.length) {
    let l = t <= s && t >= o ? s - t : 0;
    s -= l, a = s + (a - o), o = s;
  } else if (a < s) {
    let l = t <= s && t >= a ? s - t : 0;
    s -= l, o = s + (o - a), a = s;
  }
  return { from: s, toA: o, toB: a };
}
function Rmt(n) {
  let e = [];
  if (n.root.activeElement != n.contentDOM)
    return e;
  let { anchorNode: t, anchorOffset: r, focusNode: i, focusOffset: s } = n.observer.selectionRange;
  return t && (e.push(new Xj(t, r)), (i != t || s != r) && e.push(new Xj(i, s))), e;
}
function Pmt(n, e) {
  if (n.length == 0)
    return null;
  let t = n[0].pos, r = n.length == 2 ? n[1].pos : t;
  return t > -1 && r > -1 ? ge.single(t + e, r + e) : null;
}
class Dmt {
  setSelectionOrigin(e) {
    this.lastSelectionOrigin = e, this.lastSelectionTime = Date.now();
  }
  constructor(e) {
    this.view = e, this.lastKeyCode = 0, this.lastKeyTime = 0, this.lastTouchTime = 0, this.lastFocusTime = 0, this.lastScrollTop = 0, this.lastScrollLeft = 0, this.pendingIOSKey = void 0, this.tabFocusMode = -1, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastContextMenu = 0, this.scrollHandlers = [], this.handlers = /* @__PURE__ */ Object.create(null), this.composing = -1, this.compositionFirstChange = null, this.compositionEndedAt = 0, this.compositionPendingKey = !1, this.compositionPendingChange = !1, this.mouseSelection = null, this.draggedContent = null, this.handleEvent = this.handleEvent.bind(this), this.notifiedFocused = e.hasFocus, ze.safari && e.contentDOM.addEventListener("input", () => null), ze.gecko && Xmt(e.contentDOM.ownerDocument);
  }
  handleEvent(e) {
    !Umt(this.view, e) || this.ignoreDuringComposition(e) || e.type == "keydown" && this.keydown(e) || (this.view.updateState != 0 ? Promise.resolve().then(() => this.runHandlers(e.type, e)) : this.runHandlers(e.type, e));
  }
  runHandlers(e, t) {
    let r = this.handlers[e];
    if (r) {
      for (let i of r.observers)
        i(this.view, t);
      for (let i of r.handlers) {
        if (t.defaultPrevented)
          break;
        if (i(this.view, t)) {
          t.preventDefault();
          break;
        }
      }
    }
  }
  ensureHandlers(e) {
    let t = Nmt(e), r = this.handlers, i = this.view.contentDOM;
    for (let s in t)
      if (s != "scroll") {
        let o = !t[s].handlers.length, a = r[s];
        a && o != !a.handlers.length && (i.removeEventListener(s, this.handleEvent), a = null), a || i.addEventListener(s, this.handleEvent, { passive: o });
      }
    for (let s in r)
      s != "scroll" && !t[s] && i.removeEventListener(s, this.handleEvent);
    this.handlers = t;
  }
  keydown(e) {
    if (this.lastKeyCode = e.keyCode, this.lastKeyTime = Date.now(), e.keyCode == 9 && this.tabFocusMode > -1 && (!this.tabFocusMode || Date.now() <= this.tabFocusMode))
      return !0;
    if (this.tabFocusMode > 0 && e.keyCode != 27 && vce.indexOf(e.keyCode) < 0 && (this.tabFocusMode = -1), ze.android && ze.chrome && !e.synthetic && (e.keyCode == 13 || e.keyCode == 8))
      return this.view.observer.delayAndroidKey(e.key, e.keyCode), !0;
    let t;
    return ze.ios && !e.synthetic && !e.altKey && !e.metaKey && ((t = gce.find((r) => r.keyCode == e.keyCode)) && !e.ctrlKey || Lmt.indexOf(e.key) > -1 && e.ctrlKey && !e.shiftKey) ? (this.pendingIOSKey = t || e, setTimeout(() => this.flushIOSKey(), 250), !0) : (e.keyCode != 229 && this.view.observer.forceFlush(), !1);
  }
  flushIOSKey(e) {
    let t = this.pendingIOSKey;
    return !t || t.key == "Enter" && e && e.from < e.to && /^\S+$/.test(e.insert.toString()) ? !1 : (this.pendingIOSKey = void 0, bf(this.view.contentDOM, t.key, t.keyCode, t instanceof KeyboardEvent ? t : void 0));
  }
  ignoreDuringComposition(e) {
    return !/^key/.test(e.type) || e.synthetic ? !1 : this.composing > 0 ? !0 : ze.safari && !ze.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100 ? (this.compositionPendingKey = !1, !0) : !1;
  }
  startMouseSelection(e) {
    this.mouseSelection && this.mouseSelection.destroy(), this.mouseSelection = e;
  }
  update(e) {
    this.view.observer.update(e), this.mouseSelection && this.mouseSelection.update(e), this.draggedContent && e.docChanged && (this.draggedContent = this.draggedContent.map(e.changes)), e.transactions.length && (this.lastKeyCode = this.lastSelectionTime = 0);
  }
  destroy() {
    this.mouseSelection && this.mouseSelection.destroy();
  }
}
function Zj(n, e) {
  return (t, r) => {
    try {
      return e.call(n, r, t);
    } catch (i) {
      zi(t.state, i);
    }
  };
}
function Nmt(n) {
  let e = /* @__PURE__ */ Object.create(null);
  function t(r) {
    return e[r] || (e[r] = { observers: [], handlers: [] });
  }
  for (let r of n) {
    let i = r.spec, s = i && i.plugin.domEventHandlers, o = i && i.plugin.domEventObservers;
    if (s)
      for (let a in s) {
        let l = s[a];
        l && t(a).handlers.push(Zj(r.value, l));
      }
    if (o)
      for (let a in o) {
        let l = o[a];
        l && t(a).observers.push(Zj(r.value, l));
      }
  }
  for (let r in Mo)
    t(r).handlers.push(Mo[r]);
  for (let r in js)
    t(r).observers.push(js[r]);
  return e;
}
const gce = [
  { key: "Backspace", keyCode: 8, inputType: "deleteContentBackward" },
  { key: "Enter", keyCode: 13, inputType: "insertParagraph" },
  { key: "Enter", keyCode: 13, inputType: "insertLineBreak" },
  { key: "Delete", keyCode: 46, inputType: "deleteContentForward" }
], Lmt = "dthko", vce = [16, 17, 18, 20, 91, 92, 224, 225], Cv = 6;
function Tv(n) {
  return Math.max(0, n) * 0.7 + 8;
}
function $mt(n, e) {
  return Math.max(Math.abs(n.clientX - e.clientX), Math.abs(n.clientY - e.clientY));
}
class Fmt {
  constructor(e, t, r, i) {
    this.view = e, this.startEvent = t, this.style = r, this.mustSelect = i, this.scrollSpeed = { x: 0, y: 0 }, this.scrolling = -1, this.lastEvent = t, this.scrollParents = Gpt(e.contentDOM), this.atoms = e.state.facet(W1).map((o) => o(e));
    let s = e.contentDOM.ownerDocument;
    s.addEventListener("mousemove", this.move = this.move.bind(this)), s.addEventListener("mouseup", this.up = this.up.bind(this)), this.extend = t.shiftKey, this.multiple = e.state.facet(Ht.allowMultipleSelections) && Bmt(e, t), this.dragging = Hmt(e, t) && wce(t) == 1 ? null : !1;
  }
  start(e) {
    this.dragging === !1 && this.select(e);
  }
  move(e) {
    if (e.buttons == 0)
      return this.destroy();
    if (this.dragging || this.dragging == null && $mt(this.startEvent, e) < 10)
      return;
    this.select(this.lastEvent = e);
    let t = 0, r = 0, i = 0, s = 0, o = this.view.win.innerWidth, a = this.view.win.innerHeight;
    this.scrollParents.x && ({ left: i, right: o } = this.scrollParents.x.getBoundingClientRect()), this.scrollParents.y && ({ top: s, bottom: a } = this.scrollParents.y.getBoundingClientRect());
    let l = ZO(this.view);
    e.clientX - l.left <= i + Cv ? t = -Tv(i - e.clientX) : e.clientX + l.right >= o - Cv && (t = Tv(e.clientX - o)), e.clientY - l.top <= s + Cv ? r = -Tv(s - e.clientY) : e.clientY + l.bottom >= a - Cv && (r = Tv(e.clientY - a)), this.setScrollSpeed(t, r);
  }
  up(e) {
    this.dragging == null && this.select(this.lastEvent), this.dragging || e.preventDefault(), this.destroy();
  }
  destroy() {
    this.setScrollSpeed(0, 0);
    let e = this.view.contentDOM.ownerDocument;
    e.removeEventListener("mousemove", this.move), e.removeEventListener("mouseup", this.up), this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
  }
  setScrollSpeed(e, t) {
    this.scrollSpeed = { x: e, y: t }, e || t ? this.scrolling < 0 && (this.scrolling = setInterval(() => this.scroll(), 50)) : this.scrolling > -1 && (clearInterval(this.scrolling), this.scrolling = -1);
  }
  scroll() {
    let { x: e, y: t } = this.scrollSpeed;
    e && this.scrollParents.x && (this.scrollParents.x.scrollLeft += e, e = 0), t && this.scrollParents.y && (this.scrollParents.y.scrollTop += t, t = 0), (e || t) && this.view.win.scrollBy(e, t), this.dragging === !1 && this.select(this.lastEvent);
  }
  select(e) {
    let { view: t } = this, r = hce(this.atoms, this.style.get(e, this.extend, this.multiple));
    (this.mustSelect || !r.eq(t.state.selection, this.dragging === !1)) && this.view.dispatch({
      selection: r,
      userEvent: "select.pointer"
    }), this.mustSelect = !1;
  }
  update(e) {
    e.transactions.some((t) => t.isUserEvent("input.type")) ? this.destroy() : this.style.update(e) && setTimeout(() => this.select(this.lastEvent), 20);
  }
}
function Bmt(n, e) {
  let t = n.state.facet(Xle);
  return t.length ? t[0](e) : ze.mac ? e.metaKey : e.ctrlKey;
}
function zmt(n, e) {
  let t = n.state.facet(Zle);
  return t.length ? t[0](e) : ze.mac ? !e.altKey : !e.ctrlKey;
}
function Hmt(n, e) {
  let { main: t } = n.state.selection;
  if (t.empty)
    return !1;
  let r = Y0(n.root);
  if (!r || r.rangeCount == 0)
    return !0;
  let i = r.getRangeAt(0).getClientRects();
  for (let s = 0; s < i.length; s++) {
    let o = i[s];
    if (o.left <= e.clientX && o.right >= e.clientX && o.top <= e.clientY && o.bottom >= e.clientY)
      return !0;
  }
  return !1;
}
function Umt(n, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let t = e.target, r; t != n.contentDOM; t = t.parentNode)
    if (!t || t.nodeType == 11 || (r = pn.get(t)) && r.ignoreEvent(e))
      return !1;
  return !0;
}
const Mo = /* @__PURE__ */ Object.create(null), js = /* @__PURE__ */ Object.create(null), yce = ze.ie && ze.ie_version < 15 || ze.ios && ze.webkit_version < 604;
function Vmt(n) {
  let e = n.dom.parentNode;
  if (!e)
    return;
  let t = e.appendChild(document.createElement("textarea"));
  t.style.cssText = "position: fixed; left: -10000px; top: 10px", t.focus(), setTimeout(() => {
    n.focus(), t.remove(), bce(n, t.value);
  }, 50);
}
function gx(n, e, t) {
  for (let r of n.facet(e))
    t = r(t, n);
  return t;
}
function bce(n, e) {
  e = gx(n.state, qO, e);
  let { state: t } = n, r, i = 1, s = t.toText(e), o = s.lines == t.selection.ranges.length;
  if (rA != null && t.selection.ranges.every((l) => l.empty) && rA == s.toString()) {
    let l = -1;
    r = t.changeByRange((c) => {
      let u = t.doc.lineAt(c.from);
      if (u.from == l)
        return { range: c };
      l = u.from;
      let d = t.toText((o ? s.line(i++).text : e) + t.lineBreak);
      return {
        changes: { from: u.from, insert: d },
        range: ge.cursor(c.from + d.length)
      };
    });
  } else o ? r = t.changeByRange((l) => {
    let c = s.line(i++);
    return {
      changes: { from: l.from, to: l.to, insert: c.text },
      range: ge.cursor(l.from + c.length)
    };
  }) : r = t.replaceSelection(s);
  n.dispatch(r, {
    userEvent: "input.paste",
    scrollIntoView: !0
  });
}
js.scroll = (n) => {
  n.inputState.lastScrollTop = n.scrollDOM.scrollTop, n.inputState.lastScrollLeft = n.scrollDOM.scrollLeft;
};
Mo.keydown = (n, e) => (n.inputState.setSelectionOrigin("select"), e.keyCode == 27 && n.inputState.tabFocusMode != 0 && (n.inputState.tabFocusMode = Date.now() + 2e3), !1);
js.touchstart = (n, e) => {
  n.inputState.lastTouchTime = Date.now(), n.inputState.setSelectionOrigin("select.pointer");
};
js.touchmove = (n) => {
  n.inputState.setSelectionOrigin("select.pointer");
};
Mo.mousedown = (n, e) => {
  if (n.observer.flush(), n.inputState.lastTouchTime > Date.now() - 2e3)
    return !1;
  let t = null;
  for (let r of n.state.facet(Qle))
    if (t = r(n, e), t)
      break;
  if (!t && e.button == 0 && (t = Gmt(n, e)), t) {
    let r = !n.hasFocus;
    n.inputState.startMouseSelection(new Fmt(n, e, t, r)), r && n.observer.ignore(() => {
      Ple(n.contentDOM);
      let s = n.root.activeElement;
      s && !s.contains(n.contentDOM) && s.blur();
    });
    let i = n.inputState.mouseSelection;
    if (i)
      return i.start(e), i.dragging === !1;
  } else
    n.inputState.setSelectionOrigin("select.pointer");
  return !1;
};
function Qj(n, e, t, r) {
  if (r == 1)
    return ge.cursor(e, t);
  if (r == 2)
    return bmt(n.state, e, t);
  {
    let i = sr.find(n.docView, e), s = n.state.doc.lineAt(i ? i.posAtEnd : e), o = i ? i.posAtStart : s.from, a = i ? i.posAtEnd : s.to;
    return a < n.state.doc.length && a == s.to && a++, ge.range(o, a);
  }
}
let Jj = (n, e, t) => e >= t.top && e <= t.bottom && n >= t.left && n <= t.right;
function jmt(n, e, t, r) {
  let i = sr.find(n.docView, e);
  if (!i)
    return 1;
  let s = e - i.posAtStart;
  if (s == 0)
    return 1;
  if (s == i.length)
    return -1;
  let o = i.coordsAt(s, -1);
  if (o && Jj(t, r, o))
    return -1;
  let a = i.coordsAt(s, 1);
  return a && Jj(t, r, a) ? 1 : o && o.bottom >= r ? -1 : 1;
}
function eW(n, e) {
  let t = n.posAtCoords({ x: e.clientX, y: e.clientY }, !1);
  return { pos: t, bias: jmt(n, t, e.clientX, e.clientY) };
}
const Wmt = ze.ie && ze.ie_version <= 11;
let tW = null, nW = 0, rW = 0;
function wce(n) {
  if (!Wmt)
    return n.detail;
  let e = tW, t = rW;
  return tW = n, rW = Date.now(), nW = !e || t > Date.now() - 400 && Math.abs(e.clientX - n.clientX) < 2 && Math.abs(e.clientY - n.clientY) < 2 ? (nW + 1) % 3 : 1;
}
function Gmt(n, e) {
  let t = eW(n, e), r = wce(e), i = n.state.selection;
  return {
    update(s) {
      s.docChanged && (t.pos = s.changes.mapPos(t.pos), i = i.map(s.changes));
    },
    get(s, o, a) {
      let l = eW(n, s), c, u = Qj(n, l.pos, l.bias, r);
      if (t.pos != l.pos && !o) {
        let d = Qj(n, t.pos, t.bias, r), f = Math.min(d.from, u.from), h = Math.max(d.to, u.to);
        u = f < u.from ? ge.range(f, h) : ge.range(h, f);
      }
      return o ? i.replaceRange(i.main.extend(u.from, u.to)) : a && r == 1 && i.ranges.length > 1 && (c = Kmt(i, l.pos)) ? c : a ? i.addRange(u) : ge.create([u]);
    }
  };
}
function Kmt(n, e) {
  for (let t = 0; t < n.ranges.length; t++) {
    let { from: r, to: i } = n.ranges[t];
    if (r <= e && i >= e)
      return ge.create(n.ranges.slice(0, t).concat(n.ranges.slice(t + 1)), n.mainIndex == t ? 0 : n.mainIndex - (n.mainIndex > t ? 1 : 0));
  }
  return null;
}
Mo.dragstart = (n, e) => {
  let { selection: { main: t } } = n.state;
  if (e.target.draggable) {
    let i = n.docView.nearest(e.target);
    if (i && i.isWidget) {
      let s = i.posAtStart, o = s + i.length;
      (s >= t.to || o <= t.from) && (t = ge.range(s, o));
    }
  }
  let { inputState: r } = n;
  return r.mouseSelection && (r.mouseSelection.dragging = !0), r.draggedContent = t, e.dataTransfer && (e.dataTransfer.setData("Text", gx(n.state, YO, n.state.sliceDoc(t.from, t.to))), e.dataTransfer.effectAllowed = "copyMove"), !1;
};
Mo.dragend = (n) => (n.inputState.draggedContent = null, !1);
function iW(n, e, t, r) {
  if (t = gx(n.state, qO, t), !t)
    return;
  let i = n.posAtCoords({ x: e.clientX, y: e.clientY }, !1), { draggedContent: s } = n.inputState, o = r && s && zmt(n, e) ? { from: s.from, to: s.to } : null, a = { from: i, insert: t }, l = n.state.changes(o ? [o, a] : a);
  n.focus(), n.dispatch({
    changes: l,
    selection: { anchor: l.mapPos(i, -1), head: l.mapPos(i, 1) },
    userEvent: o ? "move.drop" : "input.drop"
  }), n.inputState.draggedContent = null;
}
Mo.drop = (n, e) => {
  if (!e.dataTransfer)
    return !1;
  if (n.state.readOnly)
    return !0;
  let t = e.dataTransfer.files;
  if (t && t.length) {
    let r = Array(t.length), i = 0, s = () => {
      ++i == t.length && iW(n, e, r.filter((o) => o != null).join(n.state.lineBreak), !1);
    };
    for (let o = 0; o < t.length; o++) {
      let a = new FileReader();
      a.onerror = s, a.onload = () => {
        /[\x00-\x08\x0e-\x1f]{2}/.test(a.result) || (r[o] = a.result), s();
      }, a.readAsText(t[o]);
    }
    return !0;
  } else {
    let r = e.dataTransfer.getData("Text");
    if (r)
      return iW(n, e, r, !0), !0;
  }
  return !1;
};
Mo.paste = (n, e) => {
  if (n.state.readOnly)
    return !0;
  n.observer.flush();
  let t = yce ? null : e.clipboardData;
  return t ? (bce(n, t.getData("text/plain") || t.getData("text/uri-list")), !0) : (Vmt(n), !1);
};
function qmt(n, e) {
  let t = n.dom.parentNode;
  if (!t)
    return;
  let r = t.appendChild(document.createElement("textarea"));
  r.style.cssText = "position: fixed; left: -10000px; top: 10px", r.value = e, r.focus(), r.selectionEnd = e.length, r.selectionStart = 0, setTimeout(() => {
    r.remove(), n.focus();
  }, 50);
}
function Ymt(n) {
  let e = [], t = [], r = !1;
  for (let i of n.selection.ranges)
    i.empty || (e.push(n.sliceDoc(i.from, i.to)), t.push(i));
  if (!e.length) {
    let i = -1;
    for (let { from: s } of n.selection.ranges) {
      let o = n.doc.lineAt(s);
      o.number > i && (e.push(o.text), t.push({ from: o.from, to: Math.min(n.doc.length, o.to + 1) })), i = o.number;
    }
    r = !0;
  }
  return { text: gx(n, YO, e.join(n.lineBreak)), ranges: t, linewise: r };
}
let rA = null;
Mo.copy = Mo.cut = (n, e) => {
  let { text: t, ranges: r, linewise: i } = Ymt(n.state);
  if (!t && !i)
    return !1;
  rA = i ? t : null, e.type == "cut" && !n.state.readOnly && n.dispatch({
    changes: r,
    scrollIntoView: !0,
    userEvent: "delete.cut"
  });
  let s = yce ? null : e.clipboardData;
  return s ? (s.clearData(), s.setData("text/plain", t), !0) : (qmt(n, t), !1);
};
const xce = /* @__PURE__ */ Ma.define();
function Ece(n, e) {
  let t = [];
  for (let r of n.facet(tce)) {
    let i = r(n, e);
    i && t.push(i);
  }
  return t.length ? n.update({ effects: t, annotations: xce.of(!0) }) : null;
}
function Sce(n) {
  setTimeout(() => {
    let e = n.hasFocus;
    if (e != n.inputState.notifiedFocused) {
      let t = Ece(n.state, e);
      t ? n.dispatch(t) : n.update([]);
    }
  }, 10);
}
js.focus = (n) => {
  n.inputState.lastFocusTime = Date.now(), !n.scrollDOM.scrollTop && (n.inputState.lastScrollTop || n.inputState.lastScrollLeft) && (n.scrollDOM.scrollTop = n.inputState.lastScrollTop, n.scrollDOM.scrollLeft = n.inputState.lastScrollLeft), Sce(n);
};
js.blur = (n) => {
  n.observer.clearSelectionRange(), Sce(n);
};
js.compositionstart = js.compositionupdate = (n) => {
  n.observer.editContext || (n.inputState.compositionFirstChange == null && (n.inputState.compositionFirstChange = !0), n.inputState.composing < 0 && (n.inputState.composing = 0));
};
js.compositionend = (n) => {
  n.observer.editContext || (n.inputState.composing = -1, n.inputState.compositionEndedAt = Date.now(), n.inputState.compositionPendingKey = !0, n.inputState.compositionPendingChange = n.observer.pendingRecords().length > 0, n.inputState.compositionFirstChange = null, ze.chrome && ze.android ? n.observer.flushSoon() : n.inputState.compositionPendingChange ? Promise.resolve().then(() => n.observer.flush()) : setTimeout(() => {
    n.inputState.composing < 0 && n.docView.hasComposition && n.update([]);
  }, 50));
};
js.contextmenu = (n) => {
  n.inputState.lastContextMenu = Date.now();
};
Mo.beforeinput = (n, e) => {
  var t, r;
  if (e.inputType == "insertReplacementText" && n.observer.editContext) {
    let s = (t = e.dataTransfer) === null || t === void 0 ? void 0 : t.getData("text/plain"), o = e.getTargetRanges();
    if (s && o.length) {
      let a = o[0], l = n.posAtDOM(a.startContainer, a.startOffset), c = n.posAtDOM(a.endContainer, a.endOffset);
      return QO(n, { from: l, to: c, insert: n.state.toText(s) }, null), !0;
    }
  }
  let i;
  if (ze.chrome && ze.android && (i = gce.find((s) => s.inputType == e.inputType)) && (n.observer.delayAndroidKey(i.key, i.keyCode), i.key == "Backspace" || i.key == "Delete")) {
    let s = ((r = window.visualViewport) === null || r === void 0 ? void 0 : r.height) || 0;
    setTimeout(() => {
      var o;
      (((o = window.visualViewport) === null || o === void 0 ? void 0 : o.height) || 0) > s + 10 && n.hasFocus && (n.contentDOM.blur(), n.focus());
    }, 100);
  }
  return ze.ios && e.inputType == "deleteContentForward" && n.observer.flushSoon(), ze.safari && e.inputType == "insertText" && n.inputState.composing >= 0 && setTimeout(() => js.compositionend(n, e), 20), !1;
};
const sW = /* @__PURE__ */ new Set();
function Xmt(n) {
  sW.has(n) || (sW.add(n), n.addEventListener("copy", () => {
  }), n.addEventListener("cut", () => {
  }));
}
const oW = ["pre-wrap", "normal", "pre-line", "break-spaces"];
let hh = !1;
function aW() {
  hh = !1;
}
class Zmt {
  constructor(e) {
    this.lineWrapping = e, this.doc = jt.empty, this.heightSamples = {}, this.lineHeight = 14, this.charWidth = 7, this.textHeight = 14, this.lineLength = 30;
  }
  heightForGap(e, t) {
    let r = this.doc.lineAt(t).number - this.doc.lineAt(e).number + 1;
    return this.lineWrapping && (r += Math.max(0, Math.ceil((t - e - r * this.lineLength * 0.5) / this.lineLength))), this.lineHeight * r;
  }
  heightForLine(e) {
    return this.lineWrapping ? (1 + Math.max(0, Math.ceil((e - this.lineLength) / Math.max(1, this.lineLength - 5)))) * this.lineHeight : this.lineHeight;
  }
  setDoc(e) {
    return this.doc = e, this;
  }
  mustRefreshForWrapping(e) {
    return oW.indexOf(e) > -1 != this.lineWrapping;
  }
  mustRefreshForHeights(e) {
    let t = !1;
    for (let r = 0; r < e.length; r++) {
      let i = e[r];
      i < 0 ? r++ : this.heightSamples[Math.floor(i * 10)] || (t = !0, this.heightSamples[Math.floor(i * 10)] = !0);
    }
    return t;
  }
  refresh(e, t, r, i, s, o) {
    let a = oW.indexOf(e) > -1, l = Math.round(t) != Math.round(this.lineHeight) || this.lineWrapping != a;
    if (this.lineWrapping = a, this.lineHeight = t, this.charWidth = r, this.textHeight = i, this.lineLength = s, l) {
      this.heightSamples = {};
      for (let c = 0; c < o.length; c++) {
        let u = o[c];
        u < 0 ? c++ : this.heightSamples[Math.floor(u * 10)] = !0;
      }
    }
    return l;
  }
}
class Qmt {
  constructor(e, t) {
    this.from = e, this.heights = t, this.index = 0;
  }
  get more() {
    return this.index < this.heights.length;
  }
}
class ea {
  /**
  @internal
  */
  constructor(e, t, r, i, s) {
    this.from = e, this.length = t, this.top = r, this.height = i, this._content = s;
  }
  /**
  The type of element this is. When querying lines, this may be
  an array of all the blocks that make up the line.
  */
  get type() {
    return typeof this._content == "number" ? vi.Text : Array.isArray(this._content) ? this._content : this._content.type;
  }
  /**
  The end of the element as a document position.
  */
  get to() {
    return this.from + this.length;
  }
  /**
  The bottom position of the element.
  */
  get bottom() {
    return this.top + this.height;
  }
  /**
  If this is a widget block, this will return the widget
  associated with it.
  */
  get widget() {
    return this._content instanceof xc ? this._content.widget : null;
  }
  /**
  If this is a textblock, this holds the number of line breaks
  that appear in widgets inside the block.
  */
  get widgetLineBreaks() {
    return typeof this._content == "number" ? this._content : 0;
  }
  /**
  @internal
  */
  join(e) {
    let t = (Array.isArray(this._content) ? this._content : [this]).concat(Array.isArray(e._content) ? e._content : [e]);
    return new ea(this.from, this.length + e.length, this.top, this.height + e.height, t);
  }
}
var Rn = /* @__PURE__ */ (function(n) {
  return n[n.ByPos = 0] = "ByPos", n[n.ByHeight = 1] = "ByHeight", n[n.ByPosNoHeight = 2] = "ByPosNoHeight", n;
})(Rn || (Rn = {}));
const u2 = 1e-3;
class yi {
  constructor(e, t, r = 2) {
    this.length = e, this.height = t, this.flags = r;
  }
  get outdated() {
    return (this.flags & 2) > 0;
  }
  set outdated(e) {
    this.flags = (e ? 2 : 0) | this.flags & -3;
  }
  setHeight(e) {
    this.height != e && (Math.abs(this.height - e) > u2 && (hh = !0), this.height = e);
  }
  // Base case is to replace a leaf node, which simply builds a tree
  // from the new nodes and returns that (HeightMapBranch and
  // HeightMapGap override this to actually use from/to)
  replace(e, t, r) {
    return yi.of(r);
  }
  // Again, these are base cases, and are overridden for branch and gap nodes.
  decomposeLeft(e, t) {
    t.push(this);
  }
  decomposeRight(e, t) {
    t.push(this);
  }
  applyChanges(e, t, r, i) {
    let s = this, o = r.doc;
    for (let a = i.length - 1; a >= 0; a--) {
      let { fromA: l, toA: c, fromB: u, toB: d } = i[a], f = s.lineAt(l, Rn.ByPosNoHeight, r.setDoc(t), 0, 0), h = f.to >= c ? f : s.lineAt(c, Rn.ByPosNoHeight, r, 0, 0);
      for (d += h.to - c, c = h.to; a > 0 && f.from <= i[a - 1].toA; )
        l = i[a - 1].fromA, u = i[a - 1].fromB, a--, l < f.from && (f = s.lineAt(l, Rn.ByPosNoHeight, r, 0, 0));
      u += f.from - l, l = f.from;
      let m = JO.build(r.setDoc(o), e, u, d);
      s = Qb(s, s.replace(l, c, m));
    }
    return s.updateHeight(r, 0);
  }
  static empty() {
    return new ls(0, 0);
  }
  // nodes uses null values to indicate the position of line breaks.
  // There are never line breaks at the start or end of the array, or
  // two line breaks next to each other, and the array isn't allowed
  // to be empty (same restrictions as return value from the builder).
  static of(e) {
    if (e.length == 1)
      return e[0];
    let t = 0, r = e.length, i = 0, s = 0;
    for (; ; )
      if (t == r)
        if (i > s * 2) {
          let a = e[t - 1];
          a.break ? e.splice(--t, 1, a.left, null, a.right) : e.splice(--t, 1, a.left, a.right), r += 1 + a.break, i -= a.size;
        } else if (s > i * 2) {
          let a = e[r];
          a.break ? e.splice(r, 1, a.left, null, a.right) : e.splice(r, 1, a.left, a.right), r += 2 + a.break, s -= a.size;
        } else
          break;
      else if (i < s) {
        let a = e[t++];
        a && (i += a.size);
      } else {
        let a = e[--r];
        a && (s += a.size);
      }
    let o = 0;
    return e[t - 1] == null ? (o = 1, t--) : e[t] == null && (o = 1, r++), new Jmt(yi.of(e.slice(0, t)), o, yi.of(e.slice(r)));
  }
}
function Qb(n, e) {
  return n == e ? n : (n.constructor != e.constructor && (hh = !0), e);
}
yi.prototype.size = 1;
class Cce extends yi {
  constructor(e, t, r) {
    super(e, t), this.deco = r;
  }
  blockAt(e, t, r, i) {
    return new ea(i, this.length, r, this.height, this.deco || 0);
  }
  lineAt(e, t, r, i, s) {
    return this.blockAt(0, r, i, s);
  }
  forEachLine(e, t, r, i, s, o) {
    e <= s + this.length && t >= s && o(this.blockAt(0, r, i, s));
  }
  updateHeight(e, t = 0, r = !1, i) {
    return i && i.from <= t && i.more && this.setHeight(i.heights[i.index++]), this.outdated = !1, this;
  }
  toString() {
    return `block(${this.length})`;
  }
}
class ls extends Cce {
  constructor(e, t) {
    super(e, t, null), this.collapsed = 0, this.widgetHeight = 0, this.breaks = 0;
  }
  blockAt(e, t, r, i) {
    return new ea(i, this.length, r, this.height, this.breaks);
  }
  replace(e, t, r) {
    let i = r[0];
    return r.length == 1 && (i instanceof ls || i instanceof Fr && i.flags & 4) && Math.abs(this.length - i.length) < 10 ? (i instanceof Fr ? i = new ls(i.length, this.height) : i.height = this.height, this.outdated || (i.outdated = !1), i) : yi.of(r);
  }
  updateHeight(e, t = 0, r = !1, i) {
    return i && i.from <= t && i.more ? this.setHeight(i.heights[i.index++]) : (r || this.outdated) && this.setHeight(Math.max(this.widgetHeight, e.heightForLine(this.length - this.collapsed)) + this.breaks * e.lineHeight), this.outdated = !1, this;
  }
  toString() {
    return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
  }
}
class Fr extends yi {
  constructor(e) {
    super(e, 0);
  }
  heightMetrics(e, t) {
    let r = e.doc.lineAt(t).number, i = e.doc.lineAt(t + this.length).number, s = i - r + 1, o, a = 0;
    if (e.lineWrapping) {
      let l = Math.min(this.height, e.lineHeight * s);
      o = l / s, this.length > s + 1 && (a = (this.height - l) / (this.length - s - 1));
    } else
      o = this.height / s;
    return { firstLine: r, lastLine: i, perLine: o, perChar: a };
  }
  blockAt(e, t, r, i) {
    let { firstLine: s, lastLine: o, perLine: a, perChar: l } = this.heightMetrics(t, i);
    if (t.lineWrapping) {
      let c = i + (e < t.lineHeight ? 0 : Math.round(Math.max(0, Math.min(1, (e - r) / this.height)) * this.length)), u = t.doc.lineAt(c), d = a + u.length * l, f = Math.max(r, e - d / 2);
      return new ea(u.from, u.length, f, d, 0);
    } else {
      let c = Math.max(0, Math.min(o - s, Math.floor((e - r) / a))), { from: u, length: d } = t.doc.line(s + c);
      return new ea(u, d, r + a * c, a, 0);
    }
  }
  lineAt(e, t, r, i, s) {
    if (t == Rn.ByHeight)
      return this.blockAt(e, r, i, s);
    if (t == Rn.ByPosNoHeight) {
      let { from: h, to: m } = r.doc.lineAt(e);
      return new ea(h, m - h, 0, 0, 0);
    }
    let { firstLine: o, perLine: a, perChar: l } = this.heightMetrics(r, s), c = r.doc.lineAt(e), u = a + c.length * l, d = c.number - o, f = i + a * d + l * (c.from - s - d);
    return new ea(c.from, c.length, Math.max(i, Math.min(f, i + this.height - u)), u, 0);
  }
  forEachLine(e, t, r, i, s, o) {
    e = Math.max(e, s), t = Math.min(t, s + this.length);
    let { firstLine: a, perLine: l, perChar: c } = this.heightMetrics(r, s);
    for (let u = e, d = i; u <= t; ) {
      let f = r.doc.lineAt(u);
      if (u == e) {
        let m = f.number - a;
        d += l * m + c * (e - s - m);
      }
      let h = l + c * f.length;
      o(new ea(f.from, f.length, d, h, 0)), d += h, u = f.to + 1;
    }
  }
  replace(e, t, r) {
    let i = this.length - t;
    if (i > 0) {
      let s = r[r.length - 1];
      s instanceof Fr ? r[r.length - 1] = new Fr(s.length + i) : r.push(null, new Fr(i - 1));
    }
    if (e > 0) {
      let s = r[0];
      s instanceof Fr ? r[0] = new Fr(e + s.length) : r.unshift(new Fr(e - 1), null);
    }
    return yi.of(r);
  }
  decomposeLeft(e, t) {
    t.push(new Fr(e - 1), null);
  }
  decomposeRight(e, t) {
    t.push(null, new Fr(this.length - e - 1));
  }
  updateHeight(e, t = 0, r = !1, i) {
    let s = t + this.length;
    if (i && i.from <= t + this.length && i.more) {
      let o = [], a = Math.max(t, i.from), l = -1;
      for (i.from > t && o.push(new Fr(i.from - t - 1).updateHeight(e, t)); a <= s && i.more; ) {
        let u = e.doc.lineAt(a).length;
        o.length && o.push(null);
        let d = i.heights[i.index++];
        l == -1 ? l = d : Math.abs(d - l) >= u2 && (l = -2);
        let f = new ls(u, d);
        f.outdated = !1, o.push(f), a += u + 1;
      }
      a <= s && o.push(null, new Fr(s - a).updateHeight(e, a));
      let c = yi.of(o);
      return (l < 0 || Math.abs(c.height - this.height) >= u2 || Math.abs(l - this.heightMetrics(e, t).perLine) >= u2) && (hh = !0), Qb(this, c);
    } else (r || this.outdated) && (this.setHeight(e.heightForGap(t, t + this.length)), this.outdated = !1);
    return this;
  }
  toString() {
    return `gap(${this.length})`;
  }
}
class Jmt extends yi {
  constructor(e, t, r) {
    super(e.length + t + r.length, e.height + r.height, t | (e.outdated || r.outdated ? 2 : 0)), this.left = e, this.right = r, this.size = e.size + r.size;
  }
  get break() {
    return this.flags & 1;
  }
  blockAt(e, t, r, i) {
    let s = r + this.left.height;
    return e < s ? this.left.blockAt(e, t, r, i) : this.right.blockAt(e, t, s, i + this.left.length + this.break);
  }
  lineAt(e, t, r, i, s) {
    let o = i + this.left.height, a = s + this.left.length + this.break, l = t == Rn.ByHeight ? e < o : e < a, c = l ? this.left.lineAt(e, t, r, i, s) : this.right.lineAt(e, t, r, o, a);
    if (this.break || (l ? c.to < a : c.from > a))
      return c;
    let u = t == Rn.ByPosNoHeight ? Rn.ByPosNoHeight : Rn.ByPos;
    return l ? c.join(this.right.lineAt(a, u, r, o, a)) : this.left.lineAt(a, u, r, i, s).join(c);
  }
  forEachLine(e, t, r, i, s, o) {
    let a = i + this.left.height, l = s + this.left.length + this.break;
    if (this.break)
      e < l && this.left.forEachLine(e, t, r, i, s, o), t >= l && this.right.forEachLine(e, t, r, a, l, o);
    else {
      let c = this.lineAt(l, Rn.ByPos, r, i, s);
      e < c.from && this.left.forEachLine(e, c.from - 1, r, i, s, o), c.to >= e && c.from <= t && o(c), t > c.to && this.right.forEachLine(c.to + 1, t, r, a, l, o);
    }
  }
  replace(e, t, r) {
    let i = this.left.length + this.break;
    if (t < i)
      return this.balanced(this.left.replace(e, t, r), this.right);
    if (e > this.left.length)
      return this.balanced(this.left, this.right.replace(e - i, t - i, r));
    let s = [];
    e > 0 && this.decomposeLeft(e, s);
    let o = s.length;
    for (let a of r)
      s.push(a);
    if (e > 0 && lW(s, o - 1), t < this.length) {
      let a = s.length;
      this.decomposeRight(t, s), lW(s, a);
    }
    return yi.of(s);
  }
  decomposeLeft(e, t) {
    let r = this.left.length;
    if (e <= r)
      return this.left.decomposeLeft(e, t);
    t.push(this.left), this.break && (r++, e >= r && t.push(null)), e > r && this.right.decomposeLeft(e - r, t);
  }
  decomposeRight(e, t) {
    let r = this.left.length, i = r + this.break;
    if (e >= i)
      return this.right.decomposeRight(e - i, t);
    e < r && this.left.decomposeRight(e, t), this.break && e < i && t.push(null), t.push(this.right);
  }
  balanced(e, t) {
    return e.size > 2 * t.size || t.size > 2 * e.size ? yi.of(this.break ? [e, null, t] : [e, t]) : (this.left = Qb(this.left, e), this.right = Qb(this.right, t), this.setHeight(e.height + t.height), this.outdated = e.outdated || t.outdated, this.size = e.size + t.size, this.length = e.length + this.break + t.length, this);
  }
  updateHeight(e, t = 0, r = !1, i) {
    let { left: s, right: o } = this, a = t + s.length + this.break, l = null;
    return i && i.from <= t + s.length && i.more ? l = s = s.updateHeight(e, t, r, i) : s.updateHeight(e, t, r), i && i.from <= a + o.length && i.more ? l = o = o.updateHeight(e, a, r, i) : o.updateHeight(e, a, r), l ? this.balanced(s, o) : (this.height = this.left.height + this.right.height, this.outdated = !1, this);
  }
  toString() {
    return this.left + (this.break ? " " : "-") + this.right;
  }
}
function lW(n, e) {
  let t, r;
  n[e] == null && (t = n[e - 1]) instanceof Fr && (r = n[e + 1]) instanceof Fr && n.splice(e - 1, 3, new Fr(t.length + 1 + r.length));
}
const e0t = 5;
class JO {
  constructor(e, t) {
    this.pos = e, this.oracle = t, this.nodes = [], this.lineStart = -1, this.lineEnd = -1, this.covering = null, this.writtenTo = e;
  }
  get isCovered() {
    return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
  }
  span(e, t) {
    if (this.lineStart > -1) {
      let r = Math.min(t, this.lineEnd), i = this.nodes[this.nodes.length - 1];
      i instanceof ls ? i.length += r - this.pos : (r > this.pos || !this.isCovered) && this.nodes.push(new ls(r - this.pos, -1)), this.writtenTo = r, t > r && (this.nodes.push(null), this.writtenTo++, this.lineStart = -1);
    }
    this.pos = t;
  }
  point(e, t, r) {
    if (e < t || r.heightRelevant) {
      let i = r.widget ? r.widget.estimatedHeight : 0, s = r.widget ? r.widget.lineBreaks : 0;
      i < 0 && (i = this.oracle.lineHeight);
      let o = t - e;
      r.block ? this.addBlock(new Cce(o, i, r)) : (o || s || i >= e0t) && this.addLineDeco(i, s, o);
    } else t > e && this.span(e, t);
    this.lineEnd > -1 && this.lineEnd < this.pos && (this.lineEnd = this.oracle.doc.lineAt(this.pos).to);
  }
  enterLine() {
    if (this.lineStart > -1)
      return;
    let { from: e, to: t } = this.oracle.doc.lineAt(this.pos);
    this.lineStart = e, this.lineEnd = t, this.writtenTo < e && ((this.writtenTo < e - 1 || this.nodes[this.nodes.length - 1] == null) && this.nodes.push(this.blankContent(this.writtenTo, e - 1)), this.nodes.push(null)), this.pos > e && this.nodes.push(new ls(this.pos - e, -1)), this.writtenTo = this.pos;
  }
  blankContent(e, t) {
    let r = new Fr(t - e);
    return this.oracle.doc.lineAt(e).to == t && (r.flags |= 4), r;
  }
  ensureLine() {
    this.enterLine();
    let e = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
    if (e instanceof ls)
      return e;
    let t = new ls(0, -1);
    return this.nodes.push(t), t;
  }
  addBlock(e) {
    this.enterLine();
    let t = e.deco;
    t && t.startSide > 0 && !this.isCovered && this.ensureLine(), this.nodes.push(e), this.writtenTo = this.pos = this.pos + e.length, t && t.endSide > 0 && (this.covering = e);
  }
  addLineDeco(e, t, r) {
    let i = this.ensureLine();
    i.length += r, i.collapsed += r, i.widgetHeight = Math.max(i.widgetHeight, e), i.breaks += t, this.writtenTo = this.pos = this.pos + r;
  }
  finish(e) {
    let t = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
    this.lineStart > -1 && !(t instanceof ls) && !this.isCovered ? this.nodes.push(new ls(0, -1)) : (this.writtenTo < this.pos || t == null) && this.nodes.push(this.blankContent(this.writtenTo, this.pos));
    let r = e;
    for (let i of this.nodes)
      i instanceof ls && i.updateHeight(this.oracle, r), r += i ? i.length : 1;
    return this.nodes;
  }
  // Always called with a region that on both sides either stretches
  // to a line break or the end of the document.
  // The returned array uses null to indicate line breaks, but never
  // starts or ends in a line break, or has multiple line breaks next
  // to each other.
  static build(e, t, r, i) {
    let s = new JO(r, e);
    return Vt.spans(t, r, i, s, 0), s.finish(r);
  }
}
function t0t(n, e, t) {
  let r = new n0t();
  return Vt.compare(n, e, t, r, 0), r.changes;
}
class n0t {
  constructor() {
    this.changes = [];
  }
  compareRange() {
  }
  comparePoint(e, t, r, i) {
    (e < t || r && r.heightRelevant || i && i.heightRelevant) && c2(e, t, this.changes, 5);
  }
}
function r0t(n, e) {
  let t = n.getBoundingClientRect(), r = n.ownerDocument, i = r.defaultView || window, s = Math.max(0, t.left), o = Math.min(i.innerWidth, t.right), a = Math.max(0, t.top), l = Math.min(i.innerHeight, t.bottom);
  for (let c = n.parentNode; c && c != r.body; )
    if (c.nodeType == 1) {
      let u = c, d = window.getComputedStyle(u);
      if ((u.scrollHeight > u.clientHeight || u.scrollWidth > u.clientWidth) && d.overflow != "visible") {
        let f = u.getBoundingClientRect();
        s = Math.max(s, f.left), o = Math.min(o, f.right), a = Math.max(a, f.top), l = Math.min(c == n.parentNode ? i.innerHeight : l, f.bottom);
      }
      c = d.position == "absolute" || d.position == "fixed" ? u.offsetParent : u.parentNode;
    } else if (c.nodeType == 11)
      c = c.host;
    else
      break;
  return {
    left: s - t.left,
    right: Math.max(s, o) - t.left,
    top: a - (t.top + e),
    bottom: Math.max(a, l) - (t.top + e)
  };
}
function i0t(n) {
  let e = n.getBoundingClientRect(), t = n.ownerDocument.defaultView || window;
  return e.left < t.innerWidth && e.right > 0 && e.top < t.innerHeight && e.bottom > 0;
}
function s0t(n, e) {
  let t = n.getBoundingClientRect();
  return {
    left: 0,
    right: t.right - t.left,
    top: e,
    bottom: t.bottom - (t.top + e)
  };
}
class z8 {
  constructor(e, t, r, i) {
    this.from = e, this.to = t, this.size = r, this.displaySize = i;
  }
  static same(e, t) {
    if (e.length != t.length)
      return !1;
    for (let r = 0; r < e.length; r++) {
      let i = e[r], s = t[r];
      if (i.from != s.from || i.to != s.to || i.size != s.size)
        return !1;
    }
    return !0;
  }
  draw(e, t) {
    return ct.replace({
      widget: new o0t(this.displaySize * (t ? e.scaleY : e.scaleX), t)
    }).range(this.from, this.to);
  }
}
class o0t extends Sl {
  constructor(e, t) {
    super(), this.size = e, this.vertical = t;
  }
  eq(e) {
    return e.size == this.size && e.vertical == this.vertical;
  }
  toDOM() {
    let e = document.createElement("div");
    return this.vertical ? e.style.height = this.size + "px" : (e.style.width = this.size + "px", e.style.height = "2px", e.style.display = "inline-block"), e;
  }
  get estimatedHeight() {
    return this.vertical ? this.size : -1;
  }
}
class cW {
  constructor(e) {
    this.state = e, this.pixelViewport = { left: 0, right: window.innerWidth, top: 0, bottom: 0 }, this.inView = !0, this.paddingTop = 0, this.paddingBottom = 0, this.contentDOMWidth = 0, this.contentDOMHeight = 0, this.editorHeight = 0, this.editorWidth = 0, this.scrollTop = 0, this.scrolledToBottom = !1, this.scaleX = 1, this.scaleY = 1, this.scrollAnchorPos = 0, this.scrollAnchorHeight = -1, this.scaler = uW, this.scrollTarget = null, this.printing = !1, this.mustMeasureContent = !0, this.defaultTextDirection = Dn.LTR, this.visibleRanges = [], this.mustEnforceCursorAssoc = !1;
    let t = e.facet(XO).some((r) => typeof r != "function" && r.class == "cm-lineWrapping");
    this.heightOracle = new Zmt(t), this.stateDeco = e.facet(X0).filter((r) => typeof r != "function"), this.heightMap = yi.empty().applyChanges(this.stateDeco, jt.empty, this.heightOracle.setDoc(e.doc), [new Hs(0, 0, 0, e.doc.length)]);
    for (let r = 0; r < 2 && (this.viewport = this.getViewport(0, null), !!this.updateForViewport()); r++)
      ;
    this.updateViewportLines(), this.lineGaps = this.ensureLineGaps([]), this.lineGapDeco = ct.set(this.lineGaps.map((r) => r.draw(this, !1))), this.computeVisibleRanges();
  }
  updateForViewport() {
    let e = [this.viewport], { main: t } = this.state.selection;
    for (let r = 0; r <= 1; r++) {
      let i = r ? t.head : t.anchor;
      if (!e.some(({ from: s, to: o }) => i >= s && i <= o)) {
        let { from: s, to: o } = this.lineBlockAt(i);
        e.push(new Av(s, o));
      }
    }
    return this.viewports = e.sort((r, i) => r.from - i.from), this.updateScaler();
  }
  updateScaler() {
    let e = this.scaler;
    return this.scaler = this.heightMap.height <= 7e6 ? uW : new eI(this.heightOracle, this.heightMap, this.viewports), e.eq(this.scaler) ? 0 : 2;
  }
  updateViewportLines() {
    this.viewportLines = [], this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (e) => {
      this.viewportLines.push(Bp(e, this.scaler));
    });
  }
  update(e, t = null) {
    this.state = e.state;
    let r = this.stateDeco;
    this.stateDeco = this.state.facet(X0).filter((u) => typeof u != "function");
    let i = e.changedRanges, s = Hs.extendWithRanges(i, t0t(r, this.stateDeco, e ? e.changes : xr.empty(this.state.doc.length))), o = this.heightMap.height, a = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
    aW(), this.heightMap = this.heightMap.applyChanges(this.stateDeco, e.startState.doc, this.heightOracle.setDoc(this.state.doc), s), (this.heightMap.height != o || hh) && (e.flags |= 2), a ? (this.scrollAnchorPos = e.changes.mapPos(a.from, -1), this.scrollAnchorHeight = a.top) : (this.scrollAnchorPos = -1, this.scrollAnchorHeight = o);
    let l = s.length ? this.mapViewport(this.viewport, e.changes) : this.viewport;
    (t && (t.range.head < l.from || t.range.head > l.to) || !this.viewportIsAppropriate(l)) && (l = this.getViewport(0, t));
    let c = l.from != this.viewport.from || l.to != this.viewport.to;
    this.viewport = l, e.flags |= this.updateForViewport(), (c || !e.changes.empty || e.flags & 2) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, e.changes))), e.flags |= this.computeVisibleRanges(e.changes), t && (this.scrollTarget = t), !this.mustEnforceCursorAssoc && e.selectionSet && e.view.lineWrapping && e.state.selection.main.empty && e.state.selection.main.assoc && !e.state.facet(rce) && (this.mustEnforceCursorAssoc = !0);
  }
  measure(e) {
    let t = e.contentDOM, r = window.getComputedStyle(t), i = this.heightOracle, s = r.whiteSpace;
    this.defaultTextDirection = r.direction == "rtl" ? Dn.RTL : Dn.LTR;
    let o = this.heightOracle.mustRefreshForWrapping(s), a = t.getBoundingClientRect(), l = o || this.mustMeasureContent || this.contentDOMHeight != a.height;
    this.contentDOMHeight = a.height, this.mustMeasureContent = !1;
    let c = 0, u = 0;
    if (a.width && a.height) {
      let { scaleX: E, scaleY: w } = Rle(t, a);
      (E > 5e-3 && Math.abs(this.scaleX - E) > 5e-3 || w > 5e-3 && Math.abs(this.scaleY - w) > 5e-3) && (this.scaleX = E, this.scaleY = w, c |= 16, o = l = !0);
    }
    let d = (parseInt(r.paddingTop) || 0) * this.scaleY, f = (parseInt(r.paddingBottom) || 0) * this.scaleY;
    (this.paddingTop != d || this.paddingBottom != f) && (this.paddingTop = d, this.paddingBottom = f, c |= 18), this.editorWidth != e.scrollDOM.clientWidth && (i.lineWrapping && (l = !0), this.editorWidth = e.scrollDOM.clientWidth, c |= 16);
    let h = e.scrollDOM.scrollTop * this.scaleY;
    this.scrollTop != h && (this.scrollAnchorHeight = -1, this.scrollTop = h), this.scrolledToBottom = Nle(e.scrollDOM);
    let m = (this.printing ? s0t : r0t)(t, this.paddingTop), g = m.top - this.pixelViewport.top, v = m.bottom - this.pixelViewport.bottom;
    this.pixelViewport = m;
    let y = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
    if (y != this.inView && (this.inView = y, y && (l = !0)), !this.inView && !this.scrollTarget && !i0t(e.dom))
      return 0;
    let b = a.width;
    if ((this.contentDOMWidth != b || this.editorHeight != e.scrollDOM.clientHeight) && (this.contentDOMWidth = a.width, this.editorHeight = e.scrollDOM.clientHeight, c |= 16), l) {
      let E = e.docView.measureVisibleLineHeights(this.viewport);
      if (i.mustRefreshForHeights(E) && (o = !0), o || i.lineWrapping && Math.abs(b - this.contentDOMWidth) > i.charWidth) {
        let { lineHeight: w, charWidth: C, textHeight: S } = e.docView.measureTextSize();
        o = w > 0 && i.refresh(s, w, C, S, Math.max(5, b / C), E), o && (e.docView.minWidth = 0, c |= 16);
      }
      g > 0 && v > 0 ? u = Math.max(g, v) : g < 0 && v < 0 && (u = Math.min(g, v)), aW();
      for (let w of this.viewports) {
        let C = w.from == this.viewport.from ? E : e.docView.measureVisibleLineHeights(w);
        this.heightMap = (o ? yi.empty().applyChanges(this.stateDeco, jt.empty, this.heightOracle, [new Hs(0, 0, 0, e.state.doc.length)]) : this.heightMap).updateHeight(i, 0, o, new Qmt(w.from, C));
      }
      hh && (c |= 2);
    }
    let x = !this.viewportIsAppropriate(this.viewport, u) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
    return x && (c & 2 && (c |= this.updateScaler()), this.viewport = this.getViewport(u, this.scrollTarget), c |= this.updateForViewport()), (c & 2 || x) && this.updateViewportLines(), (this.lineGaps.length || this.viewport.to - this.viewport.from > 4e3) && this.updateLineGaps(this.ensureLineGaps(o ? [] : this.lineGaps, e)), c |= this.computeVisibleRanges(), this.mustEnforceCursorAssoc && (this.mustEnforceCursorAssoc = !1, e.docView.enforceCursorAssoc()), c;
  }
  get visibleTop() {
    return this.scaler.fromDOM(this.pixelViewport.top);
  }
  get visibleBottom() {
    return this.scaler.fromDOM(this.pixelViewport.bottom);
  }
  getViewport(e, t) {
    let r = 0.5 - Math.max(-0.5, Math.min(0.5, e / 1e3 / 2)), i = this.heightMap, s = this.heightOracle, { visibleTop: o, visibleBottom: a } = this, l = new Av(i.lineAt(o - r * 1e3, Rn.ByHeight, s, 0, 0).from, i.lineAt(a + (1 - r) * 1e3, Rn.ByHeight, s, 0, 0).to);
    if (t) {
      let { head: c } = t.range;
      if (c < l.from || c > l.to) {
        let u = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top), d = i.lineAt(c, Rn.ByPos, s, 0, 0), f;
        t.y == "center" ? f = (d.top + d.bottom) / 2 - u / 2 : t.y == "start" || t.y == "nearest" && c < l.from ? f = d.top : f = d.bottom - u, l = new Av(i.lineAt(f - 1e3 / 2, Rn.ByHeight, s, 0, 0).from, i.lineAt(f + u + 1e3 / 2, Rn.ByHeight, s, 0, 0).to);
      }
    }
    return l;
  }
  mapViewport(e, t) {
    let r = t.mapPos(e.from, -1), i = t.mapPos(e.to, 1);
    return new Av(this.heightMap.lineAt(r, Rn.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(i, Rn.ByPos, this.heightOracle, 0, 0).to);
  }
  // Checks if a given viewport covers the visible part of the
  // document and not too much beyond that.
  viewportIsAppropriate({ from: e, to: t }, r = 0) {
    if (!this.inView)
      return !0;
    let { top: i } = this.heightMap.lineAt(e, Rn.ByPos, this.heightOracle, 0, 0), { bottom: s } = this.heightMap.lineAt(t, Rn.ByPos, this.heightOracle, 0, 0), { visibleTop: o, visibleBottom: a } = this;
    return (e == 0 || i <= o - Math.max(10, Math.min(
      -r,
      250
      /* VP.MaxCoverMargin */
    ))) && (t == this.state.doc.length || s >= a + Math.max(10, Math.min(
      r,
      250
      /* VP.MaxCoverMargin */
    ))) && i > o - 2 * 1e3 && s < a + 2 * 1e3;
  }
  mapLineGaps(e, t) {
    if (!e.length || t.empty)
      return e;
    let r = [];
    for (let i of e)
      t.touchesRange(i.from, i.to) || r.push(new z8(t.mapPos(i.from), t.mapPos(i.to), i.size, i.displaySize));
    return r;
  }
  // Computes positions in the viewport where the start or end of a
  // line should be hidden, trying to reuse existing line gaps when
  // appropriate to avoid unneccesary redraws.
  // Uses crude character-counting for the positioning and sizing,
  // since actual DOM coordinates aren't always available and
  // predictable. Relies on generous margins (see LG.Margin) to hide
  // the artifacts this might produce from the user.
  ensureLineGaps(e, t) {
    let r = this.heightOracle.lineWrapping, i = r ? 1e4 : 2e3, s = i >> 1, o = i << 1;
    if (this.defaultTextDirection != Dn.LTR && !r)
      return [];
    let a = [], l = (u, d, f, h) => {
      if (d - u < s)
        return;
      let m = this.state.selection.main, g = [m.from];
      m.empty || g.push(m.to);
      for (let y of g)
        if (y > u && y < d) {
          l(u, y - 10, f, h), l(y + 10, d, f, h);
          return;
        }
      let v = l0t(e, (y) => y.from >= f.from && y.to <= f.to && Math.abs(y.from - u) < s && Math.abs(y.to - d) < s && !g.some((b) => y.from < b && y.to > b));
      if (!v) {
        if (d < f.to && t && r && t.visibleRanges.some((x) => x.from <= d && x.to >= d)) {
          let x = t.moveToLineBoundary(ge.cursor(d), !1, !0).head;
          x > u && (d = x);
        }
        let y = this.gapSize(f, u, d, h), b = r || y < 2e6 ? y : 2e6;
        v = new z8(u, d, y, b);
      }
      a.push(v);
    }, c = (u) => {
      if (u.length < o || u.type != vi.Text)
        return;
      let d = a0t(u.from, u.to, this.stateDeco);
      if (d.total < o)
        return;
      let f = this.scrollTarget ? this.scrollTarget.range.head : null, h, m;
      if (r) {
        let g = i / this.heightOracle.lineLength * this.heightOracle.lineHeight, v, y;
        if (f != null) {
          let b = kv(d, f), x = ((this.visibleBottom - this.visibleTop) / 2 + g) / u.height;
          v = b - x, y = b + x;
        } else
          v = (this.visibleTop - u.top - g) / u.height, y = (this.visibleBottom - u.top + g) / u.height;
        h = Mv(d, v), m = Mv(d, y);
      } else {
        let g = d.total * this.heightOracle.charWidth, v = i * this.heightOracle.charWidth, y = 0;
        if (g > 2e6)
          for (let C of e)
            C.from >= u.from && C.from < u.to && C.size != C.displaySize && C.from * this.heightOracle.charWidth + y < this.pixelViewport.left && (y = C.size - C.displaySize);
        let b = this.pixelViewport.left + y, x = this.pixelViewport.right + y, E, w;
        if (f != null) {
          let C = kv(d, f), S = ((x - b) / 2 + v) / g;
          E = C - S, w = C + S;
        } else
          E = (b - v) / g, w = (x + v) / g;
        h = Mv(d, E), m = Mv(d, w);
      }
      h > u.from && l(u.from, h, u, d), m < u.to && l(m, u.to, u, d);
    };
    for (let u of this.viewportLines)
      Array.isArray(u.type) ? u.type.forEach(c) : c(u);
    return a;
  }
  gapSize(e, t, r, i) {
    let s = kv(i, r) - kv(i, t);
    return this.heightOracle.lineWrapping ? e.height * s : i.total * this.heightOracle.charWidth * s;
  }
  updateLineGaps(e) {
    z8.same(e, this.lineGaps) || (this.lineGaps = e, this.lineGapDeco = ct.set(e.map((t) => t.draw(this, this.heightOracle.lineWrapping))));
  }
  computeVisibleRanges(e) {
    let t = this.stateDeco;
    this.lineGaps.length && (t = t.concat(this.lineGapDeco));
    let r = [];
    Vt.spans(t, this.viewport.from, this.viewport.to, {
      span(s, o) {
        r.push({ from: s, to: o });
      },
      point() {
      }
    }, 20);
    let i = 0;
    if (r.length != this.visibleRanges.length)
      i = 12;
    else
      for (let s = 0; s < r.length && !(i & 8); s++) {
        let o = this.visibleRanges[s], a = r[s];
        (o.from != a.from || o.to != a.to) && (i |= 4, e && e.mapPos(o.from, -1) == a.from && e.mapPos(o.to, 1) == a.to || (i |= 8));
      }
    return this.visibleRanges = r, i;
  }
  lineBlockAt(e) {
    return e >= this.viewport.from && e <= this.viewport.to && this.viewportLines.find((t) => t.from <= e && t.to >= e) || Bp(this.heightMap.lineAt(e, Rn.ByPos, this.heightOracle, 0, 0), this.scaler);
  }
  lineBlockAtHeight(e) {
    return e >= this.viewportLines[0].top && e <= this.viewportLines[this.viewportLines.length - 1].bottom && this.viewportLines.find((t) => t.top <= e && t.bottom >= e) || Bp(this.heightMap.lineAt(this.scaler.fromDOM(e), Rn.ByHeight, this.heightOracle, 0, 0), this.scaler);
  }
  scrollAnchorAt(e) {
    let t = this.lineBlockAtHeight(e + 8);
    return t.from >= this.viewport.from || this.viewportLines[0].top - e > 200 ? t : this.viewportLines[0];
  }
  elementAtHeight(e) {
    return Bp(this.heightMap.blockAt(this.scaler.fromDOM(e), this.heightOracle, 0, 0), this.scaler);
  }
  get docHeight() {
    return this.scaler.toDOM(this.heightMap.height);
  }
  get contentHeight() {
    return this.docHeight + this.paddingTop + this.paddingBottom;
  }
}
let Av = class {
  constructor(e, t) {
    this.from = e, this.to = t;
  }
};
function a0t(n, e, t) {
  let r = [], i = n, s = 0;
  return Vt.spans(t, n, e, {
    span() {
    },
    point(o, a) {
      o > i && (r.push({ from: i, to: o }), s += o - i), i = a;
    }
  }, 20), i < e && (r.push({ from: i, to: e }), s += e - i), { total: s, ranges: r };
}
function Mv({ total: n, ranges: e }, t) {
  if (t <= 0)
    return e[0].from;
  if (t >= 1)
    return e[e.length - 1].to;
  let r = Math.floor(n * t);
  for (let i = 0; ; i++) {
    let { from: s, to: o } = e[i], a = o - s;
    if (r <= a)
      return s + r;
    r -= a;
  }
}
function kv(n, e) {
  let t = 0;
  for (let { from: r, to: i } of n.ranges) {
    if (e <= i) {
      t += e - r;
      break;
    }
    t += i - r;
  }
  return t / n.total;
}
function l0t(n, e) {
  for (let t of n)
    if (e(t))
      return t;
}
const uW = {
  toDOM(n) {
    return n;
  },
  fromDOM(n) {
    return n;
  },
  scale: 1,
  eq(n) {
    return n == this;
  }
};
class eI {
  constructor(e, t, r) {
    let i = 0, s = 0, o = 0;
    this.viewports = r.map(({ from: a, to: l }) => {
      let c = t.lineAt(a, Rn.ByPos, e, 0, 0).top, u = t.lineAt(l, Rn.ByPos, e, 0, 0).bottom;
      return i += u - c, { from: a, to: l, top: c, bottom: u, domTop: 0, domBottom: 0 };
    }), this.scale = (7e6 - i) / (t.height - i);
    for (let a of this.viewports)
      a.domTop = o + (a.top - s) * this.scale, o = a.domBottom = a.domTop + (a.bottom - a.top), s = a.bottom;
  }
  toDOM(e) {
    for (let t = 0, r = 0, i = 0; ; t++) {
      let s = t < this.viewports.length ? this.viewports[t] : null;
      if (!s || e < s.top)
        return i + (e - r) * this.scale;
      if (e <= s.bottom)
        return s.domTop + (e - s.top);
      r = s.bottom, i = s.domBottom;
    }
  }
  fromDOM(e) {
    for (let t = 0, r = 0, i = 0; ; t++) {
      let s = t < this.viewports.length ? this.viewports[t] : null;
      if (!s || e < s.domTop)
        return r + (e - i) / this.scale;
      if (e <= s.domBottom)
        return s.top + (e - s.domTop);
      r = s.bottom, i = s.domBottom;
    }
  }
  eq(e) {
    return e instanceof eI ? this.scale == e.scale && this.viewports.length == e.viewports.length && this.viewports.every((t, r) => t.from == e.viewports[r].from && t.to == e.viewports[r].to) : !1;
  }
}
function Bp(n, e) {
  if (e.scale == 1)
    return n;
  let t = e.toDOM(n.top), r = e.toDOM(n.bottom);
  return new ea(n.from, n.length, t, r - t, Array.isArray(n._content) ? n._content.map((i) => Bp(i, e)) : n._content);
}
const _v = /* @__PURE__ */ je.define({ combine: (n) => n.join(" ") }), iA = /* @__PURE__ */ je.define({ combine: (n) => n.indexOf(!0) > -1 }), sA = /* @__PURE__ */ wc.newName(), Tce = /* @__PURE__ */ wc.newName(), Ace = /* @__PURE__ */ wc.newName(), Mce = { "&light": "." + Tce, "&dark": "." + Ace };
function oA(n, e, t) {
  return new wc(e, {
    finish(r) {
      return /&/.test(r) ? r.replace(/&\w*/, (i) => {
        if (i == "&")
          return n;
        if (!t || !t[i])
          throw new RangeError(`Unsupported selector: ${i}`);
        return t[i];
      }) : n + " " + r;
    }
  });
}
const c0t = /* @__PURE__ */ oA("." + sA, {
  "&": {
    position: "relative !important",
    boxSizing: "border-box",
    "&.cm-focused": {
      // Provide a simple default outline to make sure a focused
      // editor is visually distinct. Can't leave the default behavior
      // because that will apply to the content element, which is
      // inside the scrollable container and doesn't include the
      // gutters. We also can't use an 'auto' outline, since those
      // are, for some reason, drawn behind the element content, which
      // will cause things like the active line background to cover
      // the outline (#297).
      outline: "1px dotted #212121"
    },
    display: "flex !important",
    flexDirection: "column"
  },
  ".cm-scroller": {
    display: "flex !important",
    alignItems: "flex-start !important",
    fontFamily: "monospace",
    lineHeight: 1.4,
    height: "100%",
    overflowX: "auto",
    position: "relative",
    zIndex: 0,
    overflowAnchor: "none"
  },
  ".cm-content": {
    margin: 0,
    flexGrow: 2,
    flexShrink: 0,
    display: "block",
    whiteSpace: "pre",
    wordWrap: "normal",
    // https://github.com/codemirror/dev/issues/456
    boxSizing: "border-box",
    minHeight: "100%",
    padding: "4px 0",
    outline: "none",
    "&[contenteditable=true]": {
      WebkitUserModify: "read-write-plaintext-only"
    }
  },
  ".cm-lineWrapping": {
    whiteSpace_fallback: "pre-wrap",
    // For IE
    whiteSpace: "break-spaces",
    wordBreak: "break-word",
    // For Safari, which doesn't support overflow-wrap: anywhere
    overflowWrap: "anywhere",
    flexShrink: 1
  },
  "&light .cm-content": { caretColor: "black" },
  "&dark .cm-content": { caretColor: "white" },
  ".cm-line": {
    display: "block",
    padding: "0 2px 0 6px"
  },
  ".cm-layer": {
    position: "absolute",
    left: 0,
    top: 0,
    contain: "size style",
    "& > *": {
      position: "absolute"
    }
  },
  "&light .cm-selectionBackground": {
    background: "#d9d9d9"
  },
  "&dark .cm-selectionBackground": {
    background: "#222"
  },
  "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#d7d4f0"
  },
  "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#233"
  },
  ".cm-cursorLayer": {
    pointerEvents: "none"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
    animation: "steps(1) cm-blink 1.2s infinite"
  },
  // Two animations defined so that we can switch between them to
  // restart the animation without forcing another style
  // recomputation.
  "@keyframes cm-blink": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  "@keyframes cm-blink2": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  ".cm-cursor, .cm-dropCursor": {
    borderLeft: "1.2px solid black",
    marginLeft: "-0.6px",
    pointerEvents: "none"
  },
  ".cm-cursor": {
    display: "none"
  },
  "&dark .cm-cursor": {
    borderLeftColor: "#ddd"
  },
  ".cm-dropCursor": {
    position: "absolute"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
    display: "block"
  },
  ".cm-iso": {
    unicodeBidi: "isolate"
  },
  ".cm-announced": {
    position: "fixed",
    top: "-10000px"
  },
  "@media print": {
    ".cm-announced": { display: "none" }
  },
  "&light .cm-activeLine": { backgroundColor: "#cceeff44" },
  "&dark .cm-activeLine": { backgroundColor: "#99eeff33" },
  "&light .cm-specialChar": { color: "red" },
  "&dark .cm-specialChar": { color: "#f78" },
  ".cm-gutters": {
    flexShrink: 0,
    display: "flex",
    height: "100%",
    boxSizing: "border-box",
    zIndex: 200
  },
  ".cm-gutters-before": { insetInlineStart: 0 },
  ".cm-gutters-after": { insetInlineEnd: 0 },
  "&light .cm-gutters": {
    backgroundColor: "#f5f5f5",
    color: "#6c6c6c",
    border: "0px solid #ddd",
    "&.cm-gutters-before": { borderRightWidth: "1px" },
    "&.cm-gutters-after": { borderLeftWidth: "1px" }
  },
  "&dark .cm-gutters": {
    backgroundColor: "#333338",
    color: "#ccc"
  },
  ".cm-gutter": {
    display: "flex !important",
    // Necessary -- prevents margin collapsing
    flexDirection: "column",
    flexShrink: 0,
    boxSizing: "border-box",
    minHeight: "100%",
    overflow: "hidden"
  },
  ".cm-gutterElement": {
    boxSizing: "border-box"
  },
  ".cm-lineNumbers .cm-gutterElement": {
    padding: "0 3px 0 5px",
    minWidth: "20px",
    textAlign: "right",
    whiteSpace: "nowrap"
  },
  "&light .cm-activeLineGutter": {
    backgroundColor: "#e2f2ff"
  },
  "&dark .cm-activeLineGutter": {
    backgroundColor: "#222227"
  },
  ".cm-panels": {
    boxSizing: "border-box",
    position: "sticky",
    left: 0,
    right: 0,
    zIndex: 300
  },
  "&light .cm-panels": {
    backgroundColor: "#f5f5f5",
    color: "black"
  },
  "&light .cm-panels-top": {
    borderBottom: "1px solid #ddd"
  },
  "&light .cm-panels-bottom": {
    borderTop: "1px solid #ddd"
  },
  "&dark .cm-panels": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-dialog": {
    padding: "2px 19px 4px 6px",
    position: "relative",
    "& label": { fontSize: "80%" }
  },
  ".cm-dialog-close": {
    position: "absolute",
    top: "3px",
    right: "4px",
    backgroundColor: "inherit",
    border: "none",
    font: "inherit",
    fontSize: "14px",
    padding: "0"
  },
  ".cm-tab": {
    display: "inline-block",
    overflow: "hidden",
    verticalAlign: "bottom"
  },
  ".cm-widgetBuffer": {
    verticalAlign: "text-top",
    height: "1em",
    width: 0,
    display: "inline"
  },
  ".cm-placeholder": {
    color: "#888",
    display: "inline-block",
    verticalAlign: "top",
    userSelect: "none"
  },
  ".cm-highlightSpace": {
    backgroundImage: "radial-gradient(circle at 50% 55%, #aaa 20%, transparent 5%)",
    backgroundPosition: "center"
  },
  ".cm-highlightTab": {
    backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
    backgroundSize: "auto 100%",
    backgroundPosition: "right 90%",
    backgroundRepeat: "no-repeat"
  },
  ".cm-trailingSpace": {
    backgroundColor: "#ff332255"
  },
  ".cm-button": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    padding: ".2em 1em",
    borderRadius: "1px"
  },
  "&light .cm-button": {
    backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
    }
  },
  "&dark .cm-button": {
    backgroundImage: "linear-gradient(#393939, #111)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#111, #333)"
    }
  },
  ".cm-textfield": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    border: "1px solid silver",
    padding: ".2em .5em"
  },
  "&light .cm-textfield": {
    backgroundColor: "white"
  },
  "&dark .cm-textfield": {
    border: "1px solid #555",
    backgroundColor: "inherit"
  }
}, Mce), u0t = {
  childList: !0,
  characterData: !0,
  subtree: !0,
  attributes: !0,
  characterDataOldValue: !0
}, H8 = ze.ie && ze.ie_version <= 11;
class d0t {
  constructor(e) {
    this.view = e, this.active = !1, this.editContext = null, this.selectionRange = new Kpt(), this.selectionChanged = !1, this.delayedFlush = -1, this.resizeTimeout = -1, this.queue = [], this.delayedAndroidKey = null, this.flushingAndroidKey = -1, this.lastChange = 0, this.scrollTargets = [], this.intersection = null, this.resizeScroll = null, this.intersecting = !1, this.gapIntersection = null, this.gaps = [], this.printQuery = null, this.parentCheck = -1, this.dom = e.contentDOM, this.observer = new MutationObserver((t) => {
      for (let r of t)
        this.queue.push(r);
      (ze.ie && ze.ie_version <= 11 || ze.ios && e.composing) && t.some((r) => r.type == "childList" && r.removedNodes.length || r.type == "characterData" && r.oldValue.length > r.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), window.EditContext && ze.android && e.constructor.EDIT_CONTEXT !== !1 && // Chrome <126 doesn't support inverted selections in edit context (#1392)
    !(ze.chrome && ze.chrome_version < 126) && (this.editContext = new h0t(e), e.state.facet(qa) && (e.contentDOM.editContext = this.editContext.editContext)), H8 && (this.onCharData = (t) => {
      this.queue.push({
        target: t.target,
        type: "characterData",
        oldValue: t.prevValue
      }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this), this.onResize = this.onResize.bind(this), this.onPrint = this.onPrint.bind(this), this.onScroll = this.onScroll.bind(this), window.matchMedia && (this.printQuery = window.matchMedia("print")), typeof ResizeObserver == "function" && (this.resizeScroll = new ResizeObserver(() => {
      var t;
      ((t = this.view.docView) === null || t === void 0 ? void 0 : t.lastUpdate) < Date.now() - 75 && this.onResize();
    }), this.resizeScroll.observe(e.scrollDOM)), this.addWindowListeners(this.win = e.win), this.start(), typeof IntersectionObserver == "function" && (this.intersection = new IntersectionObserver((t) => {
      this.parentCheck < 0 && (this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1e3)), t.length > 0 && t[t.length - 1].intersectionRatio > 0 != this.intersecting && (this.intersecting = !this.intersecting, this.intersecting != this.view.inView && this.onScrollChanged(document.createEvent("Event")));
    }, { threshold: [0, 1e-3] }), this.intersection.observe(this.dom), this.gapIntersection = new IntersectionObserver((t) => {
      t.length > 0 && t[t.length - 1].intersectionRatio > 0 && this.onScrollChanged(document.createEvent("Event"));
    }, {})), this.listenForScroll(), this.readSelectionRange();
  }
  onScrollChanged(e) {
    this.view.inputState.runHandlers("scroll", e), this.intersecting && this.view.measure();
  }
  onScroll(e) {
    this.intersecting && this.flush(!1), this.editContext && this.view.requestMeasure(this.editContext.measureReq), this.onScrollChanged(e);
  }
  onResize() {
    this.resizeTimeout < 0 && (this.resizeTimeout = setTimeout(() => {
      this.resizeTimeout = -1, this.view.requestMeasure();
    }, 50));
  }
  onPrint(e) {
    (e.type == "change" || !e.type) && !e.matches || (this.view.viewState.printing = !0, this.view.measure(), setTimeout(() => {
      this.view.viewState.printing = !1, this.view.requestMeasure();
    }, 500));
  }
  updateGaps(e) {
    if (this.gapIntersection && (e.length != this.gaps.length || this.gaps.some((t, r) => t != e[r]))) {
      this.gapIntersection.disconnect();
      for (let t of e)
        this.gapIntersection.observe(t);
      this.gaps = e;
    }
  }
  onSelectionChange(e) {
    let t = this.selectionChanged;
    if (!this.readSelectionRange() || this.delayedAndroidKey)
      return;
    let { view: r } = this, i = this.selectionRange;
    if (r.state.facet(qa) ? r.root.activeElement != this.dom : !l2(this.dom, i))
      return;
    let s = i.anchorNode && r.docView.nearest(i.anchorNode);
    if (s && s.ignoreEvent(e)) {
      t || (this.selectionChanged = !1);
      return;
    }
    (ze.ie && ze.ie_version <= 11 || ze.android && ze.chrome) && !r.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
    i.focusNode && fm(i.focusNode, i.focusOffset, i.anchorNode, i.anchorOffset) ? this.flushSoon() : this.flush(!1);
  }
  readSelectionRange() {
    let { view: e } = this, t = Y0(e.root);
    if (!t)
      return !1;
    let r = ze.safari && e.root.nodeType == 11 && e.root.activeElement == this.dom && f0t(this.view, t) || t;
    if (!r || this.selectionRange.eq(r))
      return !1;
    let i = l2(this.dom, r);
    return i && !this.selectionChanged && e.inputState.lastFocusTime > Date.now() - 200 && e.inputState.lastTouchTime < Date.now() - 300 && Ypt(this.dom, r) ? (this.view.inputState.lastFocusTime = 0, e.docView.updateSelection(), !1) : (this.selectionRange.setRange(r), i && (this.selectionChanged = !0), !0);
  }
  setSelectionRange(e, t) {
    this.selectionRange.set(e.node, e.offset, t.node, t.offset), this.selectionChanged = !1;
  }
  clearSelectionRange() {
    this.selectionRange.set(null, 0, null, 0);
  }
  listenForScroll() {
    this.parentCheck = -1;
    let e = 0, t = null;
    for (let r = this.dom; r; )
      if (r.nodeType == 1)
        !t && e < this.scrollTargets.length && this.scrollTargets[e] == r ? e++ : t || (t = this.scrollTargets.slice(0, e)), t && t.push(r), r = r.assignedSlot || r.parentNode;
      else if (r.nodeType == 11)
        r = r.host;
      else
        break;
    if (e < this.scrollTargets.length && !t && (t = this.scrollTargets.slice(0, e)), t) {
      for (let r of this.scrollTargets)
        r.removeEventListener("scroll", this.onScroll);
      for (let r of this.scrollTargets = t)
        r.addEventListener("scroll", this.onScroll);
    }
  }
  ignore(e) {
    if (!this.active)
      return e();
    try {
      return this.stop(), e();
    } finally {
      this.start(), this.clear();
    }
  }
  start() {
    this.active || (this.observer.observe(this.dom, u0t), H8 && this.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.active = !0);
  }
  stop() {
    this.active && (this.active = !1, this.observer.disconnect(), H8 && this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData));
  }
  // Throw away any pending changes
  clear() {
    this.processRecords(), this.queue.length = 0, this.selectionChanged = !1;
  }
  // Chrome Android, especially in combination with GBoard, not only
  // doesn't reliably fire regular key events, but also often
  // surrounds the effect of enter or backspace with a bunch of
  // composition events that, when interrupted, cause text duplication
  // or other kinds of corruption. This hack makes the editor back off
  // from handling DOM changes for a moment when such a key is
  // detected (via beforeinput or keydown), and then tries to flush
  // them or, if that has no effect, dispatches the given key.
  delayAndroidKey(e, t) {
    var r;
    if (!this.delayedAndroidKey) {
      let i = () => {
        let s = this.delayedAndroidKey;
        s && (this.clearDelayedAndroidKey(), this.view.inputState.lastKeyCode = s.keyCode, this.view.inputState.lastKeyTime = Date.now(), !this.flush() && s.force && bf(this.dom, s.key, s.keyCode));
      };
      this.flushingAndroidKey = this.view.win.requestAnimationFrame(i);
    }
    (!this.delayedAndroidKey || e == "Enter") && (this.delayedAndroidKey = {
      key: e,
      keyCode: t,
      // Only run the key handler when no changes are detected if
      // this isn't coming right after another change, in which case
      // it is probably part of a weird chain of updates, and should
      // be ignored if it returns the DOM to its previous state.
      force: this.lastChange < Date.now() - 50 || !!(!((r = this.delayedAndroidKey) === null || r === void 0) && r.force)
    });
  }
  clearDelayedAndroidKey() {
    this.win.cancelAnimationFrame(this.flushingAndroidKey), this.delayedAndroidKey = null, this.flushingAndroidKey = -1;
  }
  flushSoon() {
    this.delayedFlush < 0 && (this.delayedFlush = this.view.win.requestAnimationFrame(() => {
      this.delayedFlush = -1, this.flush();
    }));
  }
  forceFlush() {
    this.delayedFlush >= 0 && (this.view.win.cancelAnimationFrame(this.delayedFlush), this.delayedFlush = -1), this.flush();
  }
  pendingRecords() {
    for (let e of this.observer.takeRecords())
      this.queue.push(e);
    return this.queue;
  }
  processRecords() {
    let e = this.pendingRecords();
    e.length && (this.queue = []);
    let t = -1, r = -1, i = !1;
    for (let s of e) {
      let o = this.readMutation(s);
      o && (o.typeOver && (i = !0), t == -1 ? { from: t, to: r } = o : (t = Math.min(o.from, t), r = Math.max(o.to, r)));
    }
    return { from: t, to: r, typeOver: i };
  }
  readChange() {
    let { from: e, to: t, typeOver: r } = this.processRecords(), i = this.selectionChanged && l2(this.dom, this.selectionRange);
    if (e < 0 && !i)
      return null;
    e > -1 && (this.lastChange = Date.now()), this.view.inputState.lastFocusTime = 0, this.selectionChanged = !1;
    let s = new Omt(this.view, e, t, r);
    return this.view.docView.domChanged = { newSel: s.newSel ? s.newSel.main : null }, s;
  }
  // Apply pending changes, if any
  flush(e = !0) {
    if (this.delayedFlush >= 0 || this.delayedAndroidKey)
      return !1;
    e && this.readSelectionRange();
    let t = this.readChange();
    if (!t)
      return this.view.requestMeasure(), !1;
    let r = this.view.state, i = pce(this.view, t);
    return this.view.state == r && (t.domChanged || t.newSel && !t.newSel.main.eq(this.view.state.selection.main)) && this.view.update([]), i;
  }
  readMutation(e) {
    let t = this.view.docView.nearest(e.target);
    if (!t || t.ignoreMutation(e))
      return null;
    if (t.markDirty(e.type == "attributes"), e.type == "attributes" && (t.flags |= 4), e.type == "childList") {
      let r = dW(t, e.previousSibling || e.target.previousSibling, -1), i = dW(t, e.nextSibling || e.target.nextSibling, 1);
      return {
        from: r ? t.posAfter(r) : t.posAtStart,
        to: i ? t.posBefore(i) : t.posAtEnd,
        typeOver: !1
      };
    } else return e.type == "characterData" ? { from: t.posAtStart, to: t.posAtEnd, typeOver: e.target.nodeValue == e.oldValue } : null;
  }
  setWindow(e) {
    e != this.win && (this.removeWindowListeners(this.win), this.win = e, this.addWindowListeners(this.win));
  }
  addWindowListeners(e) {
    e.addEventListener("resize", this.onResize), this.printQuery ? this.printQuery.addEventListener ? this.printQuery.addEventListener("change", this.onPrint) : this.printQuery.addListener(this.onPrint) : e.addEventListener("beforeprint", this.onPrint), e.addEventListener("scroll", this.onScroll), e.document.addEventListener("selectionchange", this.onSelectionChange);
  }
  removeWindowListeners(e) {
    e.removeEventListener("scroll", this.onScroll), e.removeEventListener("resize", this.onResize), this.printQuery ? this.printQuery.removeEventListener ? this.printQuery.removeEventListener("change", this.onPrint) : this.printQuery.removeListener(this.onPrint) : e.removeEventListener("beforeprint", this.onPrint), e.document.removeEventListener("selectionchange", this.onSelectionChange);
  }
  update(e) {
    this.editContext && (this.editContext.update(e), e.startState.facet(qa) != e.state.facet(qa) && (e.view.contentDOM.editContext = e.state.facet(qa) ? this.editContext.editContext : null));
  }
  destroy() {
    var e, t, r;
    this.stop(), (e = this.intersection) === null || e === void 0 || e.disconnect(), (t = this.gapIntersection) === null || t === void 0 || t.disconnect(), (r = this.resizeScroll) === null || r === void 0 || r.disconnect();
    for (let i of this.scrollTargets)
      i.removeEventListener("scroll", this.onScroll);
    this.removeWindowListeners(this.win), clearTimeout(this.parentCheck), clearTimeout(this.resizeTimeout), this.win.cancelAnimationFrame(this.delayedFlush), this.win.cancelAnimationFrame(this.flushingAndroidKey), this.editContext && (this.view.contentDOM.editContext = null, this.editContext.destroy());
  }
}
function dW(n, e, t) {
  for (; e; ) {
    let r = pn.get(e);
    if (r && r.parent == n)
      return r;
    let i = e.parentNode;
    e = i != n.dom ? i : t > 0 ? e.nextSibling : e.previousSibling;
  }
  return null;
}
function fW(n, e) {
  let t = e.startContainer, r = e.startOffset, i = e.endContainer, s = e.endOffset, o = n.docView.domAtPos(n.state.selection.main.anchor);
  return fm(o.node, o.offset, i, s) && ([t, r, i, s] = [i, s, t, r]), { anchorNode: t, anchorOffset: r, focusNode: i, focusOffset: s };
}
function f0t(n, e) {
  if (e.getComposedRanges) {
    let i = e.getComposedRanges(n.root)[0];
    if (i)
      return fW(n, i);
  }
  let t = null;
  function r(i) {
    i.preventDefault(), i.stopImmediatePropagation(), t = i.getTargetRanges()[0];
  }
  return n.contentDOM.addEventListener("beforeinput", r, !0), n.dom.ownerDocument.execCommand("indent"), n.contentDOM.removeEventListener("beforeinput", r, !0), t ? fW(n, t) : null;
}
class h0t {
  constructor(e) {
    this.from = 0, this.to = 0, this.pendingContextChange = null, this.handlers = /* @__PURE__ */ Object.create(null), this.composing = null, this.resetRange(e.state);
    let t = this.editContext = new window.EditContext({
      text: e.state.doc.sliceString(this.from, this.to),
      selectionStart: this.toContextPos(Math.max(this.from, Math.min(this.to, e.state.selection.main.anchor))),
      selectionEnd: this.toContextPos(e.state.selection.main.head)
    });
    this.handlers.textupdate = (r) => {
      let i = e.state.selection.main, { anchor: s, head: o } = i, a = this.toEditorPos(r.updateRangeStart), l = this.toEditorPos(r.updateRangeEnd);
      e.inputState.composing >= 0 && !this.composing && (this.composing = { contextBase: r.updateRangeStart, editorBase: a, drifted: !1 });
      let c = l - a > r.text.length;
      a == this.from && s < this.from ? a = s : l == this.to && s > this.to && (l = s);
      let u = mce(e.state.sliceDoc(a, l), r.text, (c ? i.from : i.to) - a, c ? "end" : null);
      if (!u) {
        let f = ge.single(this.toEditorPos(r.selectionStart), this.toEditorPos(r.selectionEnd));
        f.main.eq(i) || e.dispatch({ selection: f, userEvent: "select" });
        return;
      }
      let d = {
        from: u.from + a,
        to: u.toA + a,
        insert: jt.of(r.text.slice(u.from, u.toB).split(`
`))
      };
      if ((ze.mac || ze.android) && d.from == o - 1 && /^\. ?$/.test(r.text) && e.contentDOM.getAttribute("autocorrect") == "off" && (d = { from: a, to: l, insert: jt.of([r.text.replace(".", " ")]) }), this.pendingContextChange = d, !e.state.readOnly) {
        let f = this.to - this.from + (d.to - d.from + d.insert.length);
        QO(e, d, ge.single(this.toEditorPos(r.selectionStart, f), this.toEditorPos(r.selectionEnd, f)));
      }
      this.pendingContextChange && (this.revertPending(e.state), this.setSelection(e.state)), d.from < d.to && !d.insert.length && e.inputState.composing >= 0 && !/[\\p{Alphabetic}\\p{Number}_]/.test(t.text.slice(Math.max(0, r.updateRangeStart - 1), Math.min(t.text.length, r.updateRangeStart + 1))) && this.handlers.compositionend(r);
    }, this.handlers.characterboundsupdate = (r) => {
      let i = [], s = null;
      for (let o = this.toEditorPos(r.rangeStart), a = this.toEditorPos(r.rangeEnd); o < a; o++) {
        let l = e.coordsForChar(o);
        s = l && new DOMRect(l.left, l.top, l.right - l.left, l.bottom - l.top) || s || new DOMRect(), i.push(s);
      }
      t.updateCharacterBounds(r.rangeStart, i);
    }, this.handlers.textformatupdate = (r) => {
      let i = [];
      for (let s of r.getTextFormats()) {
        let o = s.underlineStyle, a = s.underlineThickness;
        if (!/none/i.test(o) && !/none/i.test(a)) {
          let l = this.toEditorPos(s.rangeStart), c = this.toEditorPos(s.rangeEnd);
          if (l < c) {
            let u = `text-decoration: underline ${/^[a-z]/.test(o) ? o + " " : o == "Dashed" ? "dashed " : o == "Squiggle" ? "wavy " : ""}${/thin/i.test(a) ? 1 : 2}px`;
            i.push(ct.mark({ attributes: { style: u } }).range(l, c));
          }
        }
      }
      e.dispatch({ effects: sce.of(ct.set(i)) });
    }, this.handlers.compositionstart = () => {
      e.inputState.composing < 0 && (e.inputState.composing = 0, e.inputState.compositionFirstChange = !0);
    }, this.handlers.compositionend = () => {
      if (e.inputState.composing = -1, e.inputState.compositionFirstChange = null, this.composing) {
        let { drifted: r } = this.composing;
        this.composing = null, r && this.reset(e.state);
      }
    };
    for (let r in this.handlers)
      t.addEventListener(r, this.handlers[r]);
    this.measureReq = { read: (r) => {
      this.editContext.updateControlBounds(r.contentDOM.getBoundingClientRect());
      let i = Y0(r.root);
      i && i.rangeCount && this.editContext.updateSelectionBounds(i.getRangeAt(0).getBoundingClientRect());
    } };
  }
  applyEdits(e) {
    let t = 0, r = !1, i = this.pendingContextChange;
    return e.changes.iterChanges((s, o, a, l, c) => {
      if (r)
        return;
      let u = c.length - (o - s);
      if (i && o >= i.to)
        if (i.from == s && i.to == o && i.insert.eq(c)) {
          i = this.pendingContextChange = null, t += u, this.to += u;
          return;
        } else
          i = null, this.revertPending(e.state);
      if (s += t, o += t, o <= this.from)
        this.from += u, this.to += u;
      else if (s < this.to) {
        if (s < this.from || o > this.to || this.to - this.from + c.length > 3e4) {
          r = !0;
          return;
        }
        this.editContext.updateText(this.toContextPos(s), this.toContextPos(o), c.toString()), this.to += u;
      }
      t += u;
    }), i && !r && this.revertPending(e.state), !r;
  }
  update(e) {
    let t = this.pendingContextChange, r = e.startState.selection.main;
    this.composing && (this.composing.drifted || !e.changes.touchesRange(r.from, r.to) && e.transactions.some((i) => !i.isUserEvent("input.type") && i.changes.touchesRange(this.from, this.to))) ? (this.composing.drifted = !0, this.composing.editorBase = e.changes.mapPos(this.composing.editorBase)) : !this.applyEdits(e) || !this.rangeIsValid(e.state) ? (this.pendingContextChange = null, this.reset(e.state)) : (e.docChanged || e.selectionSet || t) && this.setSelection(e.state), (e.geometryChanged || e.docChanged || e.selectionSet) && e.view.requestMeasure(this.measureReq);
  }
  resetRange(e) {
    let { head: t } = e.selection.main;
    this.from = Math.max(
      0,
      t - 1e4
      /* CxVp.Margin */
    ), this.to = Math.min(
      e.doc.length,
      t + 1e4
      /* CxVp.Margin */
    );
  }
  reset(e) {
    this.resetRange(e), this.editContext.updateText(0, this.editContext.text.length, e.doc.sliceString(this.from, this.to)), this.setSelection(e);
  }
  revertPending(e) {
    let t = this.pendingContextChange;
    this.pendingContextChange = null, this.editContext.updateText(this.toContextPos(t.from), this.toContextPos(t.from + t.insert.length), e.doc.sliceString(t.from, t.to));
  }
  setSelection(e) {
    let { main: t } = e.selection, r = this.toContextPos(Math.max(this.from, Math.min(this.to, t.anchor))), i = this.toContextPos(t.head);
    (this.editContext.selectionStart != r || this.editContext.selectionEnd != i) && this.editContext.updateSelection(r, i);
  }
  rangeIsValid(e) {
    let { head: t } = e.selection.main;
    return !(this.from > 0 && t - this.from < 500 || this.to < e.doc.length && this.to - t < 500 || this.to - this.from > 1e4 * 3);
  }
  toEditorPos(e, t = this.to - this.from) {
    e = Math.min(e, t);
    let r = this.composing;
    return r && r.drifted ? r.editorBase + (e - r.contextBase) : e + this.from;
  }
  toContextPos(e) {
    let t = this.composing;
    return t && t.drifted ? t.contextBase + (e - t.editorBase) : e - this.from;
  }
  destroy() {
    for (let e in this.handlers)
      this.editContext.removeEventListener(e, this.handlers[e]);
  }
}
class Be {
  /**
  The current editor state.
  */
  get state() {
    return this.viewState.state;
  }
  /**
  To be able to display large documents without consuming too much
  memory or overloading the browser, CodeMirror only draws the
  code that is visible (plus a margin around it) to the DOM. This
  property tells you the extent of the current drawn viewport, in
  document positions.
  */
  get viewport() {
    return this.viewState.viewport;
  }
  /**
  When there are, for example, large collapsed ranges in the
  viewport, its size can be a lot bigger than the actual visible
  content. Thus, if you are doing something like styling the
  content in the viewport, it is preferable to only do so for
  these ranges, which are the subset of the viewport that is
  actually drawn.
  */
  get visibleRanges() {
    return this.viewState.visibleRanges;
  }
  /**
  Returns false when the editor is entirely scrolled out of view
  or otherwise hidden.
  */
  get inView() {
    return this.viewState.inView;
  }
  /**
  Indicates whether the user is currently composing text via
  [IME](https://en.wikipedia.org/wiki/Input_method), and at least
  one change has been made in the current composition.
  */
  get composing() {
    return !!this.inputState && this.inputState.composing > 0;
  }
  /**
  Indicates whether the user is currently in composing state. Note
  that on some platforms, like Android, this will be the case a
  lot, since just putting the cursor on a word starts a
  composition there.
  */
  get compositionStarted() {
    return !!this.inputState && this.inputState.composing >= 0;
  }
  /**
  The document or shadow root that the view lives in.
  */
  get root() {
    return this._root;
  }
  /**
  @internal
  */
  get win() {
    return this.dom.ownerDocument.defaultView || window;
  }
  /**
  Construct a new view. You'll want to either provide a `parent`
  option, or put `view.dom` into your document after creating a
  view, so that the user can see the editor.
  */
  constructor(e = {}) {
    var t;
    this.plugins = [], this.pluginMap = /* @__PURE__ */ new Map(), this.editorAttrs = {}, this.contentAttrs = {}, this.bidiCache = [], this.destroyed = !1, this.updateState = 2, this.measureScheduled = -1, this.measureRequests = [], this.contentDOM = document.createElement("div"), this.scrollDOM = document.createElement("div"), this.scrollDOM.tabIndex = -1, this.scrollDOM.className = "cm-scroller", this.scrollDOM.appendChild(this.contentDOM), this.announceDOM = document.createElement("div"), this.announceDOM.className = "cm-announced", this.announceDOM.setAttribute("aria-live", "polite"), this.dom = document.createElement("div"), this.dom.appendChild(this.announceDOM), this.dom.appendChild(this.scrollDOM), e.parent && e.parent.appendChild(this.dom);
    let { dispatch: r } = e;
    this.dispatchTransactions = e.dispatchTransactions || r && ((i) => i.forEach((s) => r(s, this))) || ((i) => this.update(i)), this.dispatch = this.dispatch.bind(this), this._root = e.root || qpt(e.parent) || document, this.viewState = new cW(e.state || Ht.create(e)), e.scrollTo && e.scrollTo.is(Sv) && (this.viewState.scrollTarget = e.scrollTo.value.clip(this.viewState.state)), this.plugins = this.state.facet(Qd).map((i) => new $8(i));
    for (let i of this.plugins)
      i.update(this);
    this.observer = new d0t(this), this.inputState = new Dmt(this), this.inputState.ensureHandlers(this.plugins), this.docView = new jj(this), this.mountStyles(), this.updateAttrs(), this.updateState = 0, this.requestMeasure(), !((t = document.fonts) === null || t === void 0) && t.ready && document.fonts.ready.then(() => this.requestMeasure());
  }
  dispatch(...e) {
    let t = e.length == 1 && e[0] instanceof Cr ? e : e.length == 1 && Array.isArray(e[0]) ? e[0] : [this.state.update(...e)];
    this.dispatchTransactions(t, this);
  }
  /**
  Update the view for the given array of transactions. This will
  update the visible document and selection to match the state
  produced by the transactions, and notify view plugins of the
  change. You should usually call
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
  as a primitive.
  */
  update(e) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
    let t = !1, r = !1, i, s = this.state;
    for (let f of e) {
      if (f.startState != s)
        throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
      s = f.state;
    }
    if (this.destroyed) {
      this.viewState.state = s;
      return;
    }
    let o = this.hasFocus, a = 0, l = null;
    e.some((f) => f.annotation(xce)) ? (this.inputState.notifiedFocused = o, a = 1) : o != this.inputState.notifiedFocused && (this.inputState.notifiedFocused = o, l = Ece(s, o), l || (a = 1));
    let c = this.observer.delayedAndroidKey, u = null;
    if (c ? (this.observer.clearDelayedAndroidKey(), u = this.observer.readChange(), (u && !this.state.doc.eq(s.doc) || !this.state.selection.eq(s.selection)) && (u = null)) : this.observer.clear(), s.facet(Ht.phrases) != this.state.facet(Ht.phrases))
      return this.setState(s);
    i = Zb.create(this, s, e), i.flags |= a;
    let d = this.viewState.scrollTarget;
    try {
      this.updateState = 2;
      for (let f of e) {
        if (d && (d = d.map(f.changes)), f.scrollIntoView) {
          let { main: h } = f.state.selection;
          d = new wf(h.empty ? h : ge.cursor(h.head, h.head > h.anchor ? -1 : 1));
        }
        for (let h of f.effects)
          h.is(Sv) && (d = h.value.clip(this.state));
      }
      this.viewState.update(i, d), this.bidiCache = Jb.update(this.bidiCache, i.changes), i.empty || (this.updatePlugins(i), this.inputState.update(i)), t = this.docView.update(i), this.state.facet($p) != this.styleModules && this.mountStyles(), r = this.updateAttrs(), this.showAnnouncements(e), this.docView.updateSelection(t, e.some((f) => f.isUserEvent("select.pointer")));
    } finally {
      this.updateState = 0;
    }
    if (i.startState.facet(_v) != i.state.facet(_v) && (this.viewState.mustMeasureContent = !0), (t || r || d || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) && this.requestMeasure(), t && this.docViewUpdate(), !i.empty)
      for (let f of this.state.facet(eA))
        try {
          f(i);
        } catch (h) {
          zi(this.state, h, "update listener");
        }
    (l || u) && Promise.resolve().then(() => {
      l && this.state == l.startState && this.dispatch(l), u && !pce(this, u) && c.force && bf(this.contentDOM, c.key, c.keyCode);
    });
  }
  /**
  Reset the view to the given state. (This will cause the entire
  document to be redrawn and all view plugins to be reinitialized,
  so you should probably only use it when the new state isn't
  derived from the old state. Otherwise, use
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
  */
  setState(e) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
    if (this.destroyed) {
      this.viewState.state = e;
      return;
    }
    this.updateState = 2;
    let t = this.hasFocus;
    try {
      for (let r of this.plugins)
        r.destroy(this);
      this.viewState = new cW(e), this.plugins = e.facet(Qd).map((r) => new $8(r)), this.pluginMap.clear();
      for (let r of this.plugins)
        r.update(this);
      this.docView.destroy(), this.docView = new jj(this), this.inputState.ensureHandlers(this.plugins), this.mountStyles(), this.updateAttrs(), this.bidiCache = [];
    } finally {
      this.updateState = 0;
    }
    t && this.focus(), this.requestMeasure();
  }
  updatePlugins(e) {
    let t = e.startState.facet(Qd), r = e.state.facet(Qd);
    if (t != r) {
      let i = [];
      for (let s of r) {
        let o = t.indexOf(s);
        if (o < 0)
          i.push(new $8(s));
        else {
          let a = this.plugins[o];
          a.mustUpdate = e, i.push(a);
        }
      }
      for (let s of this.plugins)
        s.mustUpdate != e && s.destroy(this);
      this.plugins = i, this.pluginMap.clear();
    } else
      for (let i of this.plugins)
        i.mustUpdate = e;
    for (let i = 0; i < this.plugins.length; i++)
      this.plugins[i].update(this);
    t != r && this.inputState.ensureHandlers(this.plugins);
  }
  docViewUpdate() {
    for (let e of this.plugins) {
      let t = e.value;
      if (t && t.docViewUpdate)
        try {
          t.docViewUpdate(this);
        } catch (r) {
          zi(this.state, r, "doc view update listener");
        }
    }
  }
  /**
  @internal
  */
  measure(e = !0) {
    if (this.destroyed)
      return;
    if (this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.observer.delayedAndroidKey) {
      this.measureScheduled = -1, this.requestMeasure();
      return;
    }
    this.measureScheduled = 0, e && this.observer.forceFlush();
    let t = null, r = this.scrollDOM, i = r.scrollTop * this.scaleY, { scrollAnchorPos: s, scrollAnchorHeight: o } = this.viewState;
    Math.abs(i - this.viewState.scrollTop) > 1 && (o = -1), this.viewState.scrollAnchorHeight = -1;
    try {
      for (let a = 0; ; a++) {
        if (o < 0)
          if (Nle(r))
            s = -1, o = this.viewState.heightMap.height;
          else {
            let h = this.viewState.scrollAnchorAt(i);
            s = h.from, o = h.top;
          }
        this.updateState = 1;
        let l = this.viewState.measure(this);
        if (!l && !this.measureRequests.length && this.viewState.scrollTarget == null)
          break;
        if (a > 5) {
          console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
          break;
        }
        let c = [];
        l & 4 || ([this.measureRequests, c] = [c, this.measureRequests]);
        let u = c.map((h) => {
          try {
            return h.read(this);
          } catch (m) {
            return zi(this.state, m), hW;
          }
        }), d = Zb.create(this, this.state, []), f = !1;
        d.flags |= l, t ? t.flags |= l : t = d, this.updateState = 2, d.empty || (this.updatePlugins(d), this.inputState.update(d), this.updateAttrs(), f = this.docView.update(d), f && this.docViewUpdate());
        for (let h = 0; h < c.length; h++)
          if (u[h] != hW)
            try {
              let m = c[h];
              m.write && m.write(u[h], this);
            } catch (m) {
              zi(this.state, m);
            }
        if (f && this.docView.updateSelection(!0), !d.viewportChanged && this.measureRequests.length == 0) {
          if (this.viewState.editorHeight)
            if (this.viewState.scrollTarget) {
              this.docView.scrollIntoView(this.viewState.scrollTarget), this.viewState.scrollTarget = null, o = -1;
              continue;
            } else {
              let m = (s < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(s).top) - o;
              if (m > 1 || m < -1) {
                i = i + m, r.scrollTop = i / this.scaleY, o = -1;
                continue;
              }
            }
          break;
        }
      }
    } finally {
      this.updateState = 0, this.measureScheduled = -1;
    }
    if (t && !t.empty)
      for (let a of this.state.facet(eA))
        a(t);
  }
  /**
  Get the CSS classes for the currently active editor themes.
  */
  get themeClasses() {
    return sA + " " + (this.state.facet(iA) ? Ace : Tce) + " " + this.state.facet(_v);
  }
  updateAttrs() {
    let e = pW(this, oce, {
      class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
    }), t = {
      spellcheck: "false",
      autocorrect: "off",
      autocapitalize: "off",
      writingsuggestions: "false",
      translate: "no",
      contenteditable: this.state.facet(qa) ? "true" : "false",
      class: "cm-content",
      style: `${ze.tabSize}: ${this.state.tabSize}`,
      role: "textbox",
      "aria-multiline": "true"
    };
    this.state.readOnly && (t["aria-readonly"] = "true"), pW(this, XO, t);
    let r = this.observer.ignore(() => {
      let i = Y9(this.contentDOM, this.contentAttrs, t), s = Y9(this.dom, this.editorAttrs, e);
      return i || s;
    });
    return this.editorAttrs = e, this.contentAttrs = t, r;
  }
  showAnnouncements(e) {
    let t = !0;
    for (let r of e)
      for (let i of r.effects)
        if (i.is(Be.announce)) {
          t && (this.announceDOM.textContent = ""), t = !1;
          let s = this.announceDOM.appendChild(document.createElement("div"));
          s.textContent = i.value;
        }
  }
  mountStyles() {
    this.styleModules = this.state.facet($p);
    let e = this.state.facet(Be.cspNonce);
    wc.mount(this.root, this.styleModules.concat(c0t).reverse(), e ? { nonce: e } : void 0);
  }
  readMeasured() {
    if (this.updateState == 2)
      throw new Error("Reading the editor layout isn't allowed during an update");
    this.updateState == 0 && this.measureScheduled > -1 && this.measure(!1);
  }
  /**
  Schedule a layout measurement, optionally providing callbacks to
  do custom DOM measuring followed by a DOM write phase. Using
  this is preferable reading DOM layout directly from, for
  example, an event handler, because it'll make sure measuring and
  drawing done by other components is synchronized, avoiding
  unnecessary DOM layout computations.
  */
  requestMeasure(e) {
    if (this.measureScheduled < 0 && (this.measureScheduled = this.win.requestAnimationFrame(() => this.measure())), e) {
      if (this.measureRequests.indexOf(e) > -1)
        return;
      if (e.key != null) {
        for (let t = 0; t < this.measureRequests.length; t++)
          if (this.measureRequests[t].key === e.key) {
            this.measureRequests[t] = e;
            return;
          }
      }
      this.measureRequests.push(e);
    }
  }
  /**
  Get the value of a specific plugin, if present. Note that
  plugins that crash can be dropped from a view, so even when you
  know you registered a given plugin, it is recommended to check
  the return value of this method.
  */
  plugin(e) {
    let t = this.pluginMap.get(e);
    return (t === void 0 || t && t.plugin != e) && this.pluginMap.set(e, t = this.plugins.find((r) => r.plugin == e) || null), t && t.update(this).value;
  }
  /**
  The top position of the document, in screen coordinates. This
  may be negative when the editor is scrolled down. Points
  directly to the top of the first line, not above the padding.
  */
  get documentTop() {
    return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
  }
  /**
  Reports the padding above and below the document.
  */
  get documentPadding() {
    return { top: this.viewState.paddingTop, bottom: this.viewState.paddingBottom };
  }
  /**
  If the editor is transformed with CSS, this provides the scale
  along the X axis. Otherwise, it will just be 1. Note that
  transforms other than translation and scaling are not supported.
  */
  get scaleX() {
    return this.viewState.scaleX;
  }
  /**
  Provide the CSS transformed scale along the Y axis.
  */
  get scaleY() {
    return this.viewState.scaleY;
  }
  /**
  Find the text line or block widget at the given vertical
  position (which is interpreted as relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
  */
  elementAtHeight(e) {
    return this.readMeasured(), this.viewState.elementAtHeight(e);
  }
  /**
  Find the line block (see
  [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt)) at the given
  height, again interpreted relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
  */
  lineBlockAtHeight(e) {
    return this.readMeasured(), this.viewState.lineBlockAtHeight(e);
  }
  /**
  Get the extent and vertical position of all [line
  blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
  are relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
  */
  get viewportLineBlocks() {
    return this.viewState.viewportLines;
  }
  /**
  Find the line block around the given document position. A line
  block is a range delimited on both sides by either a
  non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line break, or the
  start/end of the document. It will usually just hold a line of
  text, but may be broken into multiple textblocks by block
  widgets.
  */
  lineBlockAt(e) {
    return this.viewState.lineBlockAt(e);
  }
  /**
  The editor's total content height.
  */
  get contentHeight() {
    return this.viewState.contentHeight;
  }
  /**
  Move a cursor position by [grapheme
  cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
  the motion is away from the line start, or towards it. In
  bidirectional text, the line is traversed in visual order, using
  the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
  When the start position was the last one on the line, the
  returned position will be across the line break. If there is no
  further line, the original position is returned.
  
  By default, this method moves over a single cluster. The
  optional `by` argument can be used to move across more. It will
  be called with the first cluster as argument, and should return
  a predicate that determines, for each subsequent cluster,
  whether it should also be moved over.
  */
  moveByChar(e, t, r) {
    return B8(this, e, Yj(this, e, t, r));
  }
  /**
  Move a cursor position across the next group of either
  [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
  non-whitespace characters.
  */
  moveByGroup(e, t) {
    return B8(this, e, Yj(this, e, t, (r) => Tmt(this, e.head, r)));
  }
  /**
  Get the cursor position visually at the start or end of a line.
  Note that this may differ from the _logical_ position at its
  start or end (which is simply at `line.from`/`line.to`) if text
  at the start or end goes against the line's base text direction.
  */
  visualLineSide(e, t) {
    let r = this.bidiSpans(e), i = this.textDirectionAt(e.from), s = r[t ? r.length - 1 : 0];
    return ge.cursor(s.side(t, i) + e.from, s.forward(!t, i) ? 1 : -1);
  }
  /**
  Move to the next line boundary in the given direction. If
  `includeWrap` is true, line wrapping is on, and there is a
  further wrap point on the current line, the wrap point will be
  returned. Otherwise this function will return the start or end
  of the line.
  */
  moveToLineBoundary(e, t, r = !0) {
    return Cmt(this, e, t, r);
  }
  /**
  Move a cursor position vertically. When `distance` isn't given,
  it defaults to moving to the next line (including wrapped
  lines). Otherwise, `distance` should provide a positive distance
  in pixels.
  
  When `start` has a
  [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
  motion will use that as a target horizontal position. Otherwise,
  the cursor's own horizontal position is used. The returned
  cursor will have its goal column set to whichever column was
  used.
  */
  moveVertically(e, t, r) {
    return B8(this, e, Amt(this, e, t, r));
  }
  /**
  Find the DOM parent node and offset (child offset if `node` is
  an element, character offset when it is a text node) at the
  given document position.
  
  Note that for positions that aren't currently in
  `visibleRanges`, the resulting DOM position isn't necessarily
  meaningful (it may just point before or after a placeholder
  element).
  */
  domAtPos(e) {
    return this.docView.domAtPos(e);
  }
  /**
  Find the document position at the given DOM node. Can be useful
  for associating positions with DOM events. Will raise an error
  when `node` isn't part of the editor content.
  */
  posAtDOM(e, t = 0) {
    return this.docView.posFromDOM(e, t);
  }
  posAtCoords(e, t = !0) {
    return this.readMeasured(), dce(this, e, t);
  }
  /**
  Get the screen coordinates at the given document position.
  `side` determines whether the coordinates are based on the
  element before (-1) or after (1) the position (if no element is
  available on the given side, the method will transparently use
  another strategy to get reasonable coordinates).
  */
  coordsAtPos(e, t = 1) {
    this.readMeasured();
    let r = this.docView.coordsAt(e, t);
    if (!r || r.left == r.right)
      return r;
    let i = this.state.doc.lineAt(e), s = this.bidiSpans(i), o = s[rc.find(s, e - i.from, -1, t)];
    return U1(r, o.dir == Dn.LTR == t > 0);
  }
  /**
  Return the rectangle around a given character. If `pos` does not
  point in front of a character that is in the viewport and
  rendered (i.e. not replaced, not a line break), this will return
  null. For space characters that are a line wrap point, this will
  return the position before the line break.
  */
  coordsForChar(e) {
    return this.readMeasured(), this.docView.coordsForChar(e);
  }
  /**
  The default width of a character in the editor. May not
  accurately reflect the width of all characters (given variable
  width fonts or styling of invididual ranges).
  */
  get defaultCharacterWidth() {
    return this.viewState.heightOracle.charWidth;
  }
  /**
  The default height of a line in the editor. May not be accurate
  for all lines.
  */
  get defaultLineHeight() {
    return this.viewState.heightOracle.lineHeight;
  }
  /**
  The text direction
  ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
  CSS property) of the editor's content element.
  */
  get textDirection() {
    return this.viewState.defaultTextDirection;
  }
  /**
  Find the text direction of the block at the given position, as
  assigned by CSS. If
  [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
  isn't enabled, or the given position is outside of the viewport,
  this will always return the same as
  [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
  this may trigger a DOM layout.
  */
  textDirectionAt(e) {
    return !this.state.facet(nce) || e < this.viewport.from || e > this.viewport.to ? this.textDirection : (this.readMeasured(), this.docView.textDirectionAt(e));
  }
  /**
  Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
  (as determined by the
  [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
  CSS property of its content element).
  */
  get lineWrapping() {
    return this.viewState.heightOracle.lineWrapping;
  }
  /**
  Returns the bidirectional text structure of the given line
  (which should be in the current document) as an array of span
  objects. The order of these spans matches the [text
  direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
  left-to-right, the leftmost spans come first, otherwise the
  rightmost spans come first.
  */
  bidiSpans(e) {
    if (e.length > p0t)
      return qle(e.length);
    let t = this.textDirectionAt(e.from), r;
    for (let s of this.bidiCache)
      if (s.from == e.from && s.dir == t && (s.fresh || Kle(s.isolates, r = Vj(this, e))))
        return s.order;
    r || (r = Vj(this, e));
    let i = lmt(e.text, t, r);
    return this.bidiCache.push(new Jb(e.from, e.to, t, r, !0, i)), i;
  }
  /**
  Check whether the editor has focus.
  */
  get hasFocus() {
    var e;
    return (this.dom.ownerDocument.hasFocus() || ze.safari && ((e = this.inputState) === null || e === void 0 ? void 0 : e.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
  }
  /**
  Put focus on the editor.
  */
  focus() {
    this.observer.ignore(() => {
      Ple(this.contentDOM), this.docView.updateSelection();
    });
  }
  /**
  Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
  necessary when moving the editor's existing DOM to a new window or shadow root.
  */
  setRoot(e) {
    this._root != e && (this._root = e, this.observer.setWindow((e.nodeType == 9 ? e : e.ownerDocument).defaultView || window), this.mountStyles());
  }
  /**
  Clean up this editor view, removing its element from the
  document, unregistering event handlers, and notifying
  plugins. The view instance can no longer be used after
  calling this.
  */
  destroy() {
    this.root.activeElement == this.contentDOM && this.contentDOM.blur();
    for (let e of this.plugins)
      e.destroy(this);
    this.plugins = [], this.inputState.destroy(), this.docView.destroy(), this.dom.remove(), this.observer.destroy(), this.measureScheduled > -1 && this.win.cancelAnimationFrame(this.measureScheduled), this.destroyed = !0;
  }
  /**
  Returns an effect that can be
  [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
  cause it to scroll the given position or range into view.
  */
  static scrollIntoView(e, t = {}) {
    return Sv.of(new wf(typeof e == "number" ? ge.cursor(e) : e, t.y, t.x, t.yMargin, t.xMargin));
  }
  /**
  Return an effect that resets the editor to its current (at the
  time this method was called) scroll position. Note that this
  only affects the editor's own scrollable element, not parents.
  See also
  [`EditorViewConfig.scrollTo`](https://codemirror.net/6/docs/ref/#view.EditorViewConfig.scrollTo).
  
  The effect should be used with a document identical to the one
  it was created for. Failing to do so is not an error, but may
  not scroll to the expected position. You can
  [map](https://codemirror.net/6/docs/ref/#state.StateEffect.map) the effect to account for changes.
  */
  scrollSnapshot() {
    let { scrollTop: e, scrollLeft: t } = this.scrollDOM, r = this.viewState.scrollAnchorAt(e);
    return Sv.of(new wf(ge.cursor(r.from), "start", "start", r.top - e, t, !0));
  }
  /**
  Enable or disable tab-focus mode, which disables key bindings
  for Tab and Shift-Tab, letting the browser's default
  focus-changing behavior go through instead. This is useful to
  prevent trapping keyboard users in your editor.
  
  Without argument, this toggles the mode. With a boolean, it
  enables (true) or disables it (false). Given a number, it
  temporarily enables the mode until that number of milliseconds
  have passed or another non-Tab key is pressed.
  */
  setTabFocusMode(e) {
    e == null ? this.inputState.tabFocusMode = this.inputState.tabFocusMode < 0 ? 0 : -1 : typeof e == "boolean" ? this.inputState.tabFocusMode = e ? 0 : -1 : this.inputState.tabFocusMode != 0 && (this.inputState.tabFocusMode = Date.now() + e);
  }
  /**
  Returns an extension that can be used to add DOM event handlers.
  The value should be an object mapping event names to handler
  functions. For any given event, such functions are ordered by
  extension precedence, and the first handler to return true will
  be assumed to have handled that event, and no other handlers or
  built-in behavior will be activated for it. These are registered
  on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
  for `scroll` handlers, which will be called any time the
  editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
  its parent nodes is scrolled.
  */
  static domEventHandlers(e) {
    return nr.define(() => ({}), { eventHandlers: e });
  }
  /**
  Create an extension that registers DOM event observers. Contrary
  to event [handlers](https://codemirror.net/6/docs/ref/#view.EditorView^domEventHandlers),
  observers can't be prevented from running by a higher-precedence
  handler returning true. They also don't prevent other handlers
  and observers from running when they return true, and should not
  call `preventDefault`.
  */
  static domEventObservers(e) {
    return nr.define(() => ({}), { eventObservers: e });
  }
  /**
  Create a theme extension. The first argument can be a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)
  style spec providing the styles for the theme. These will be
  prefixed with a generated class for the style.
  
  Because the selectors will be prefixed with a scope class, rule
  that directly match the editor's [wrapper
  element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
  added—need to be explicitly differentiated by adding an `&` to
  the selector for that element—for example
  `&.cm-focused`.
  
  When `dark` is set to true, the theme will be marked as dark,
  which will cause the `&dark` rules from [base
  themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
  `&light` when a light theme is active).
  */
  static theme(e, t) {
    let r = wc.newName(), i = [_v.of(r), $p.of(oA(`.${r}`, e))];
    return t && t.dark && i.push(iA.of(!0)), i;
  }
  /**
  Create an extension that adds styles to the base theme. Like
  with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
  place of the editor wrapper element when directly targeting
  that. You can also use `&dark` or `&light` instead to only
  target editors with a dark or light theme.
  */
  static baseTheme(e) {
    return hd.lowest($p.of(oA("." + sA, e, Mce)));
  }
  /**
  Retrieve an editor view instance from the view's DOM
  representation.
  */
  static findFromDOM(e) {
    var t;
    let r = e.querySelector(".cm-content"), i = r && pn.get(r) || pn.get(e);
    return ((t = i?.rootView) === null || t === void 0 ? void 0 : t.view) || null;
  }
}
Be.styleModule = $p;
Be.inputHandler = ece;
Be.clipboardInputFilter = qO;
Be.clipboardOutputFilter = YO;
Be.scrollHandler = ice;
Be.focusChangeEffect = tce;
Be.perLineTextDirection = nce;
Be.exceptionSink = Jle;
Be.updateListener = eA;
Be.editable = qa;
Be.mouseSelectionStyle = Qle;
Be.dragMovesSelection = Zle;
Be.clickAddsSelectionRange = Xle;
Be.decorations = X0;
Be.outerDecorations = ace;
Be.atomicRanges = W1;
Be.bidiIsolatedRanges = lce;
Be.scrollMargins = cce;
Be.darkTheme = iA;
Be.cspNonce = /* @__PURE__ */ je.define({ combine: (n) => n.length ? n[0] : "" });
Be.contentAttributes = XO;
Be.editorAttributes = oce;
Be.lineWrapping = /* @__PURE__ */ Be.contentAttributes.of({ class: "cm-lineWrapping" });
Be.announce = /* @__PURE__ */ At.define();
const p0t = 4096, hW = {};
class Jb {
  constructor(e, t, r, i, s, o) {
    this.from = e, this.to = t, this.dir = r, this.isolates = i, this.fresh = s, this.order = o;
  }
  static update(e, t) {
    if (t.empty && !e.some((s) => s.fresh))
      return e;
    let r = [], i = e.length ? e[e.length - 1].dir : Dn.LTR;
    for (let s = Math.max(0, e.length - 10); s < e.length; s++) {
      let o = e[s];
      o.dir == i && !t.touchesRange(o.from, o.to) && r.push(new Jb(t.mapPos(o.from, 1), t.mapPos(o.to, -1), o.dir, o.isolates, !1, o.order));
    }
    return r;
  }
}
function pW(n, e, t) {
  for (let r = n.state.facet(e), i = r.length - 1; i >= 0; i--) {
    let s = r[i], o = typeof s == "function" ? s(n) : s;
    o && q9(o, t);
  }
  return t;
}
const m0t = ze.mac ? "mac" : ze.windows ? "win" : ze.linux ? "linux" : "key";
function g0t(n, e) {
  const t = n.split(/-(?!$)/);
  let r = t[t.length - 1];
  r == "Space" && (r = " ");
  let i, s, o, a;
  for (let l = 0; l < t.length - 1; ++l) {
    const c = t[l];
    if (/^(cmd|meta|m)$/i.test(c))
      a = !0;
    else if (/^a(lt)?$/i.test(c))
      i = !0;
    else if (/^(c|ctrl|control)$/i.test(c))
      s = !0;
    else if (/^s(hift)?$/i.test(c))
      o = !0;
    else if (/^mod$/i.test(c))
      e == "mac" ? a = !0 : s = !0;
    else
      throw new Error("Unrecognized modifier name: " + c);
  }
  return i && (r = "Alt-" + r), s && (r = "Ctrl-" + r), a && (r = "Meta-" + r), o && (r = "Shift-" + r), r;
}
function Ov(n, e, t) {
  return e.altKey && (n = "Alt-" + n), e.ctrlKey && (n = "Ctrl-" + n), e.metaKey && (n = "Meta-" + n), t !== !1 && e.shiftKey && (n = "Shift-" + n), n;
}
const v0t = /* @__PURE__ */ hd.default(/* @__PURE__ */ Be.domEventHandlers({
  keydown(n, e) {
    return _ce(kce(e.state), n, e, "editor");
  }
})), vx = /* @__PURE__ */ je.define({ enables: v0t }), mW = /* @__PURE__ */ new WeakMap();
function kce(n) {
  let e = n.facet(vx), t = mW.get(e);
  return t || mW.set(e, t = w0t(e.reduce((r, i) => r.concat(i), []))), t;
}
function y0t(n, e, t) {
  return _ce(kce(n.state), e, n, t);
}
let ql = null;
const b0t = 4e3;
function w0t(n, e = m0t) {
  let t = /* @__PURE__ */ Object.create(null), r = /* @__PURE__ */ Object.create(null), i = (o, a) => {
    let l = r[o];
    if (l == null)
      r[o] = a;
    else if (l != a)
      throw new Error("Key binding " + o + " is used both as a regular binding and as a multi-stroke prefix");
  }, s = (o, a, l, c, u) => {
    var d, f;
    let h = t[o] || (t[o] = /* @__PURE__ */ Object.create(null)), m = a.split(/ (?!$)/).map((y) => g0t(y, e));
    for (let y = 1; y < m.length; y++) {
      let b = m.slice(0, y).join(" ");
      i(b, !0), h[b] || (h[b] = {
        preventDefault: !0,
        stopPropagation: !1,
        run: [(x) => {
          let E = ql = { view: x, prefix: b, scope: o };
          return setTimeout(() => {
            ql == E && (ql = null);
          }, b0t), !0;
        }]
      });
    }
    let g = m.join(" ");
    i(g, !1);
    let v = h[g] || (h[g] = {
      preventDefault: !1,
      stopPropagation: !1,
      run: ((f = (d = h._any) === null || d === void 0 ? void 0 : d.run) === null || f === void 0 ? void 0 : f.slice()) || []
    });
    l && v.run.push(l), c && (v.preventDefault = !0), u && (v.stopPropagation = !0);
  };
  for (let o of n) {
    let a = o.scope ? o.scope.split(" ") : ["editor"];
    if (o.any)
      for (let c of a) {
        let u = t[c] || (t[c] = /* @__PURE__ */ Object.create(null));
        u._any || (u._any = { preventDefault: !1, stopPropagation: !1, run: [] });
        let { any: d } = o;
        for (let f in u)
          u[f].run.push((h) => d(h, aA));
      }
    let l = o[e] || o.key;
    if (l)
      for (let c of a)
        s(c, l, o.run, o.preventDefault, o.stopPropagation), o.shift && s(c, "Shift-" + l, o.shift, o.preventDefault, o.stopPropagation);
  }
  return t;
}
let aA = null;
function _ce(n, e, t, r) {
  aA = e;
  let i = Xse(e), s = Pi(i, 0), o = Jo(s) == i.length && i != " ", a = "", l = !1, c = !1, u = !1;
  ql && ql.view == t && ql.scope == r && (a = ql.prefix + " ", vce.indexOf(e.keyCode) < 0 && (c = !0, ql = null));
  let d = /* @__PURE__ */ new Set(), f = (v) => {
    if (v) {
      for (let y of v.run)
        if (!d.has(y) && (d.add(y), y(t)))
          return v.stopPropagation && (u = !0), !0;
      v.preventDefault && (v.stopPropagation && (u = !0), c = !0);
    }
    return !1;
  }, h = n[r], m, g;
  return h && (f(h[a + Ov(i, e, !o)]) ? l = !0 : o && (e.altKey || e.metaKey || e.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
  !(ze.windows && e.ctrlKey && e.altKey) && // Alt-combinations on macOS tend to be typed characters
  !(ze.mac && e.altKey && !(e.ctrlKey || e.metaKey)) && (m = pl[e.keyCode]) && m != i ? (f(h[a + Ov(m, e, !0)]) || e.shiftKey && (g = B0[e.keyCode]) != i && g != m && f(h[a + Ov(g, e, !1)])) && (l = !0) : o && e.shiftKey && f(h[a + Ov(i, e, !0)]) && (l = !0), !l && f(h._any) && (l = !0)), c && (l = !0), l && u && e.stopPropagation(), aA = null, l;
}
class G1 {
  /**
  Create a marker with the given class and dimensions. If `width`
  is null, the DOM element will get no width style.
  */
  constructor(e, t, r, i, s) {
    this.className = e, this.left = t, this.top = r, this.width = i, this.height = s;
  }
  draw() {
    let e = document.createElement("div");
    return e.className = this.className, this.adjust(e), e;
  }
  update(e, t) {
    return t.className != this.className ? !1 : (this.adjust(e), !0);
  }
  adjust(e) {
    e.style.left = this.left + "px", e.style.top = this.top + "px", this.width != null && (e.style.width = this.width + "px"), e.style.height = this.height + "px";
  }
  eq(e) {
    return this.left == e.left && this.top == e.top && this.width == e.width && this.height == e.height && this.className == e.className;
  }
  /**
  Create a set of rectangles for the given selection range,
  assigning them theclass`className`. Will create a single
  rectangle for empty ranges, and a set of selection-style
  rectangles covering the range's content (in a bidi-aware
  way) for non-empty ones.
  */
  static forRange(e, t, r) {
    if (r.empty) {
      let i = e.coordsAtPos(r.head, r.assoc || 1);
      if (!i)
        return [];
      let s = Oce(e);
      return [new G1(t, i.left - s.left, i.top - s.top, null, i.bottom - i.top)];
    } else
      return x0t(e, t, r);
  }
}
function Oce(n) {
  let e = n.scrollDOM.getBoundingClientRect();
  return { left: (n.textDirection == Dn.LTR ? e.left : e.right - n.scrollDOM.clientWidth * n.scaleX) - n.scrollDOM.scrollLeft * n.scaleX, top: e.top - n.scrollDOM.scrollTop * n.scaleY };
}
function gW(n, e, t, r) {
  let i = n.coordsAtPos(e, t * 2);
  if (!i)
    return r;
  let s = n.dom.getBoundingClientRect(), o = (i.top + i.bottom) / 2, a = n.posAtCoords({ x: s.left + 1, y: o }), l = n.posAtCoords({ x: s.right - 1, y: o });
  return a == null || l == null ? r : { from: Math.max(r.from, Math.min(a, l)), to: Math.min(r.to, Math.max(a, l)) };
}
function x0t(n, e, t) {
  if (t.to <= n.viewport.from || t.from >= n.viewport.to)
    return [];
  let r = Math.max(t.from, n.viewport.from), i = Math.min(t.to, n.viewport.to), s = n.textDirection == Dn.LTR, o = n.contentDOM, a = o.getBoundingClientRect(), l = Oce(n), c = o.querySelector(".cm-line"), u = c && window.getComputedStyle(c), d = a.left + (u ? parseInt(u.paddingLeft) + Math.min(0, parseInt(u.textIndent)) : 0), f = a.right - (u ? parseInt(u.paddingRight) : 0), h = nA(n, r, 1), m = nA(n, i, -1), g = h.type == vi.Text ? h : null, v = m.type == vi.Text ? m : null;
  if (g && (n.lineWrapping || h.widgetLineBreaks) && (g = gW(n, r, 1, g)), v && (n.lineWrapping || m.widgetLineBreaks) && (v = gW(n, i, -1, v)), g && v && g.from == v.from && g.to == v.to)
    return b(x(t.from, t.to, g));
  {
    let w = g ? x(t.from, null, g) : E(h, !1), C = v ? x(null, t.to, v) : E(m, !0), S = [];
    return (g || h).to < (v || m).from - (g && v ? 1 : 0) || h.widgetLineBreaks > 1 && w.bottom + n.defaultLineHeight / 2 < C.top ? S.push(y(d, w.bottom, f, C.top)) : w.bottom < C.top && n.elementAtHeight((w.bottom + C.top) / 2).type == vi.Text && (w.bottom = C.top = (w.bottom + C.top) / 2), b(w).concat(S).concat(b(C));
  }
  function y(w, C, S, M) {
    return new G1(e, w - l.left, C - l.top, S - w, M - C);
  }
  function b({ top: w, bottom: C, horizontal: S }) {
    let M = [];
    for (let k = 0; k < S.length; k += 2)
      M.push(y(S[k], w, S[k + 1], C));
    return M;
  }
  function x(w, C, S) {
    let M = 1e9, k = -1e9, _ = [];
    function O(P, D, L, B, $) {
      let z = n.coordsAtPos(P, P == S.to ? -2 : 2), H = n.coordsAtPos(L, L == S.from ? 2 : -2);
      !z || !H || (M = Math.min(z.top, H.top, M), k = Math.max(z.bottom, H.bottom, k), $ == Dn.LTR ? _.push(s && D ? d : z.left, s && B ? f : H.right) : _.push(!s && B ? d : H.left, !s && D ? f : z.right));
    }
    let I = w ?? S.from, R = C ?? S.to;
    for (let P of n.visibleRanges)
      if (P.to > I && P.from < R)
        for (let D = Math.max(P.from, I), L = Math.min(P.to, R); ; ) {
          let B = n.state.doc.lineAt(D);
          for (let $ of n.bidiSpans(B)) {
            let z = $.from + B.from, H = $.to + B.from;
            if (z >= L)
              break;
            H > D && O(Math.max(z, D), w == null && z <= I, Math.min(H, L), C == null && H >= R, $.dir);
          }
          if (D = B.to + 1, D >= L)
            break;
        }
    return _.length == 0 && O(I, w == null, R, C == null, n.textDirection), { top: M, bottom: k, horizontal: _ };
  }
  function E(w, C) {
    let S = a.top + (C ? w.top : w.bottom);
    return { top: S, bottom: S, horizontal: [] };
  }
}
function E0t(n, e) {
  return n.constructor == e.constructor && n.eq(e);
}
class S0t {
  constructor(e, t) {
    this.view = e, this.layer = t, this.drawn = [], this.scaleX = 1, this.scaleY = 1, this.measureReq = { read: this.measure.bind(this), write: this.draw.bind(this) }, this.dom = e.scrollDOM.appendChild(document.createElement("div")), this.dom.classList.add("cm-layer"), t.above && this.dom.classList.add("cm-layer-above"), t.class && this.dom.classList.add(t.class), this.scale(), this.dom.setAttribute("aria-hidden", "true"), this.setOrder(e.state), e.requestMeasure(this.measureReq), t.mount && t.mount(this.dom, e);
  }
  update(e) {
    e.startState.facet(d2) != e.state.facet(d2) && this.setOrder(e.state), (this.layer.update(e, this.dom) || e.geometryChanged) && (this.scale(), e.view.requestMeasure(this.measureReq));
  }
  docViewUpdate(e) {
    this.layer.updateOnDocViewUpdate !== !1 && e.requestMeasure(this.measureReq);
  }
  setOrder(e) {
    let t = 0, r = e.facet(d2);
    for (; t < r.length && r[t] != this.layer; )
      t++;
    this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - t);
  }
  measure() {
    return this.layer.markers(this.view);
  }
  scale() {
    let { scaleX: e, scaleY: t } = this.view;
    (e != this.scaleX || t != this.scaleY) && (this.scaleX = e, this.scaleY = t, this.dom.style.transform = `scale(${1 / e}, ${1 / t})`);
  }
  draw(e) {
    if (e.length != this.drawn.length || e.some((t, r) => !E0t(t, this.drawn[r]))) {
      let t = this.dom.firstChild, r = 0;
      for (let i of e)
        i.update && t && i.constructor && this.drawn[r].constructor && i.update(t, this.drawn[r]) ? (t = t.nextSibling, r++) : this.dom.insertBefore(i.draw(), t);
      for (; t; ) {
        let i = t.nextSibling;
        t.remove(), t = i;
      }
      this.drawn = e, ze.safari && ze.safari_version >= 26 && (this.dom.style.display = this.dom.firstChild ? "" : "none");
    }
  }
  destroy() {
    this.layer.destroy && this.layer.destroy(this.dom, this.view), this.dom.remove();
  }
}
const d2 = /* @__PURE__ */ je.define();
function Ice(n) {
  return [
    nr.define((e) => new S0t(e, n)),
    d2.of(n)
  ];
}
const Z0 = /* @__PURE__ */ je.define({
  combine(n) {
    return ka(n, {
      cursorBlinkRate: 1200,
      drawRangeCursor: !0
    }, {
      cursorBlinkRate: (e, t) => Math.min(e, t),
      drawRangeCursor: (e, t) => e || t
    });
  }
});
function C0t(n = {}) {
  return [
    Z0.of(n),
    T0t,
    A0t,
    M0t,
    rce.of(!0)
  ];
}
function Rce(n) {
  return n.startState.facet(Z0) != n.state.facet(Z0);
}
const T0t = /* @__PURE__ */ Ice({
  above: !0,
  markers(n) {
    let { state: e } = n, t = e.facet(Z0), r = [];
    for (let i of e.selection.ranges) {
      let s = i == e.selection.main;
      if (i.empty || t.drawRangeCursor) {
        let o = s ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary", a = i.empty ? i : ge.cursor(i.head, i.head > i.anchor ? -1 : 1);
        for (let l of G1.forRange(n, o, a))
          r.push(l);
      }
    }
    return r;
  },
  update(n, e) {
    n.transactions.some((r) => r.selection) && (e.style.animationName = e.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink");
    let t = Rce(n);
    return t && vW(n.state, e), n.docChanged || n.selectionSet || t;
  },
  mount(n, e) {
    vW(e.state, n);
  },
  class: "cm-cursorLayer"
});
function vW(n, e) {
  e.style.animationDuration = n.facet(Z0).cursorBlinkRate + "ms";
}
const A0t = /* @__PURE__ */ Ice({
  above: !1,
  markers(n) {
    return n.state.selection.ranges.map((e) => e.empty ? [] : G1.forRange(n, "cm-selectionBackground", e)).reduce((e, t) => e.concat(t));
  },
  update(n, e) {
    return n.docChanged || n.selectionSet || n.viewportChanged || Rce(n);
  },
  class: "cm-selectionLayer"
}), M0t = /* @__PURE__ */ hd.highest(/* @__PURE__ */ Be.theme({
  ".cm-line": {
    "& ::selection, &::selection": { backgroundColor: "transparent !important" },
    caretColor: "transparent !important"
  },
  ".cm-content": {
    caretColor: "transparent !important",
    "& :focus": {
      caretColor: "initial !important",
      "&::selection, & ::selection": {
        backgroundColor: "Highlight !important"
      }
    }
  }
})), Pce = /* @__PURE__ */ At.define({
  map(n, e) {
    return n == null ? null : e.mapPos(n);
  }
}), zp = /* @__PURE__ */ Xr.define({
  create() {
    return null;
  },
  update(n, e) {
    return n != null && (n = e.changes.mapPos(n)), e.effects.reduce((t, r) => r.is(Pce) ? r.value : t, n);
  }
}), k0t = /* @__PURE__ */ nr.fromClass(class {
  constructor(n) {
    this.view = n, this.cursor = null, this.measureReq = { read: this.readPos.bind(this), write: this.drawCursor.bind(this) };
  }
  update(n) {
    var e;
    let t = n.state.field(zp);
    t == null ? this.cursor != null && ((e = this.cursor) === null || e === void 0 || e.remove(), this.cursor = null) : (this.cursor || (this.cursor = this.view.scrollDOM.appendChild(document.createElement("div")), this.cursor.className = "cm-dropCursor"), (n.startState.field(zp) != t || n.docChanged || n.geometryChanged) && this.view.requestMeasure(this.measureReq));
  }
  readPos() {
    let { view: n } = this, e = n.state.field(zp), t = e != null && n.coordsAtPos(e);
    if (!t)
      return null;
    let r = n.scrollDOM.getBoundingClientRect();
    return {
      left: t.left - r.left + n.scrollDOM.scrollLeft * n.scaleX,
      top: t.top - r.top + n.scrollDOM.scrollTop * n.scaleY,
      height: t.bottom - t.top
    };
  }
  drawCursor(n) {
    if (this.cursor) {
      let { scaleX: e, scaleY: t } = this.view;
      n ? (this.cursor.style.left = n.left / e + "px", this.cursor.style.top = n.top / t + "px", this.cursor.style.height = n.height / t + "px") : this.cursor.style.left = "-100000px";
    }
  }
  destroy() {
    this.cursor && this.cursor.remove();
  }
  setDropPos(n) {
    this.view.state.field(zp) != n && this.view.dispatch({ effects: Pce.of(n) });
  }
}, {
  eventObservers: {
    dragover(n) {
      this.setDropPos(this.view.posAtCoords({ x: n.clientX, y: n.clientY }));
    },
    dragleave(n) {
      (n.target == this.view.contentDOM || !this.view.contentDOM.contains(n.relatedTarget)) && this.setDropPos(null);
    },
    dragend() {
      this.setDropPos(null);
    },
    drop() {
      this.setDropPos(null);
    }
  }
});
function _0t() {
  return [zp, k0t];
}
function yW(n, e, t, r, i) {
  e.lastIndex = 0;
  for (let s = n.iterRange(t, r), o = t, a; !s.next().done; o += s.value.length)
    if (!s.lineBreak)
      for (; a = e.exec(s.value); )
        i(o + a.index, a);
}
function O0t(n, e) {
  let t = n.visibleRanges;
  if (t.length == 1 && t[0].from == n.viewport.from && t[0].to == n.viewport.to)
    return t;
  let r = [];
  for (let { from: i, to: s } of t)
    i = Math.max(n.state.doc.lineAt(i).from, i - e), s = Math.min(n.state.doc.lineAt(s).to, s + e), r.length && r[r.length - 1].to >= i ? r[r.length - 1].to = s : r.push({ from: i, to: s });
  return r;
}
class I0t {
  /**
  Create a decorator.
  */
  constructor(e) {
    const { regexp: t, decoration: r, decorate: i, boundary: s, maxLength: o = 1e3 } = e;
    if (!t.global)
      throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
    if (this.regexp = t, i)
      this.addMatch = (a, l, c, u) => i(u, c, c + a[0].length, a, l);
    else if (typeof r == "function")
      this.addMatch = (a, l, c, u) => {
        let d = r(a, l, c);
        d && u(c, c + a[0].length, d);
      };
    else if (r)
      this.addMatch = (a, l, c, u) => u(c, c + a[0].length, r);
    else
      throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
    this.boundary = s, this.maxLength = o;
  }
  /**
  Compute the full set of decorations for matches in the given
  view's viewport. You'll want to call this when initializing your
  plugin.
  */
  createDeco(e) {
    let t = new ml(), r = t.add.bind(t);
    for (let { from: i, to: s } of O0t(e, this.maxLength))
      yW(e.state.doc, this.regexp, i, s, (o, a) => this.addMatch(a, e, o, r));
    return t.finish();
  }
  /**
  Update a set of decorations for a view update. `deco` _must_ be
  the set of decorations produced by _this_ `MatchDecorator` for
  the view state before the update.
  */
  updateDeco(e, t) {
    let r = 1e9, i = -1;
    return e.docChanged && e.changes.iterChanges((s, o, a, l) => {
      l >= e.view.viewport.from && a <= e.view.viewport.to && (r = Math.min(a, r), i = Math.max(l, i));
    }), e.viewportMoved || i - r > 1e3 ? this.createDeco(e.view) : i > -1 ? this.updateRange(e.view, t.map(e.changes), r, i) : t;
  }
  updateRange(e, t, r, i) {
    for (let s of e.visibleRanges) {
      let o = Math.max(s.from, r), a = Math.min(s.to, i);
      if (a >= o) {
        let l = e.state.doc.lineAt(o), c = l.to < a ? e.state.doc.lineAt(a) : l, u = Math.max(s.from, l.from), d = Math.min(s.to, c.to);
        if (this.boundary) {
          for (; o > l.from; o--)
            if (this.boundary.test(l.text[o - 1 - l.from])) {
              u = o;
              break;
            }
          for (; a < c.to; a++)
            if (this.boundary.test(c.text[a - c.from])) {
              d = a;
              break;
            }
        }
        let f = [], h, m = (g, v, y) => f.push(y.range(g, v));
        if (l == c)
          for (this.regexp.lastIndex = u - l.from; (h = this.regexp.exec(l.text)) && h.index < d - l.from; )
            this.addMatch(h, e, h.index + l.from, m);
        else
          yW(e.state.doc, this.regexp, u, d, (g, v) => this.addMatch(v, e, g, m));
        t = t.update({ filterFrom: u, filterTo: d, filter: (g, v) => g < u || v > d, add: f });
      }
    }
    return t;
  }
}
const lA = /x/.unicode != null ? "gu" : "g", R0t = /* @__PURE__ */ new RegExp(`[\0-\b
--­؜​‎‏\u2028\u2029‭‮⁦⁧⁩\uFEFF￹-￼]`, lA), P0t = {
  0: "null",
  7: "bell",
  8: "backspace",
  10: "newline",
  11: "vertical tab",
  13: "carriage return",
  27: "escape",
  8203: "zero width space",
  8204: "zero width non-joiner",
  8205: "zero width joiner",
  8206: "left-to-right mark",
  8207: "right-to-left mark",
  8232: "line separator",
  8237: "left-to-right override",
  8238: "right-to-left override",
  8294: "left-to-right isolate",
  8295: "right-to-left isolate",
  8297: "pop directional isolate",
  8233: "paragraph separator",
  65279: "zero width no-break space",
  65532: "object replacement"
};
let U8 = null;
function D0t() {
  var n;
  if (U8 == null && typeof document < "u" && document.body) {
    let e = document.body.style;
    U8 = ((n = e.tabSize) !== null && n !== void 0 ? n : e.MozTabSize) != null;
  }
  return U8 || !1;
}
const f2 = /* @__PURE__ */ je.define({
  combine(n) {
    let e = ka(n, {
      render: null,
      specialChars: R0t,
      addSpecialChars: null
    });
    return (e.replaceTabs = !D0t()) && (e.specialChars = new RegExp("	|" + e.specialChars.source, lA)), e.addSpecialChars && (e.specialChars = new RegExp(e.specialChars.source + "|" + e.addSpecialChars.source, lA)), e;
  }
});
function N0t(n = {}) {
  return [f2.of(n), L0t()];
}
let bW = null;
function L0t() {
  return bW || (bW = nr.fromClass(class {
    constructor(n) {
      this.view = n, this.decorations = ct.none, this.decorationCache = /* @__PURE__ */ Object.create(null), this.decorator = this.makeDecorator(n.state.facet(f2)), this.decorations = this.decorator.createDeco(n);
    }
    makeDecorator(n) {
      return new I0t({
        regexp: n.specialChars,
        decoration: (e, t, r) => {
          let { doc: i } = t.state, s = Pi(e[0], 0);
          if (s == 9) {
            let o = i.lineAt(r), a = t.state.tabSize, l = Vh(o.text, a, r - o.from);
            return ct.replace({
              widget: new z0t((a - l % a) * this.view.defaultCharacterWidth / this.view.scaleX)
            });
          }
          return this.decorationCache[s] || (this.decorationCache[s] = ct.replace({ widget: new B0t(n, s) }));
        },
        boundary: n.replaceTabs ? void 0 : /[^]/
      });
    }
    update(n) {
      let e = n.state.facet(f2);
      n.startState.facet(f2) != e ? (this.decorator = this.makeDecorator(e), this.decorations = this.decorator.createDeco(n.view)) : this.decorations = this.decorator.updateDeco(n, this.decorations);
    }
  }, {
    decorations: (n) => n.decorations
  }));
}
const $0t = "•";
function F0t(n) {
  return n >= 32 ? $0t : n == 10 ? "␤" : String.fromCharCode(9216 + n);
}
class B0t extends Sl {
  constructor(e, t) {
    super(), this.options = e, this.code = t;
  }
  eq(e) {
    return e.code == this.code;
  }
  toDOM(e) {
    let t = F0t(this.code), r = e.state.phrase("Control character") + " " + (P0t[this.code] || "0x" + this.code.toString(16)), i = this.options.render && this.options.render(this.code, r, t);
    if (i)
      return i;
    let s = document.createElement("span");
    return s.textContent = t, s.title = r, s.setAttribute("aria-label", r), s.className = "cm-specialChar", s;
  }
  ignoreEvent() {
    return !1;
  }
}
class z0t extends Sl {
  constructor(e) {
    super(), this.width = e;
  }
  eq(e) {
    return e.width == this.width;
  }
  toDOM() {
    let e = document.createElement("span");
    return e.textContent = "	", e.className = "cm-tab", e.style.width = this.width + "px", e;
  }
  ignoreEvent() {
    return !1;
  }
}
function H0t() {
  return V0t;
}
const U0t = /* @__PURE__ */ ct.line({ class: "cm-activeLine" }), V0t = /* @__PURE__ */ nr.fromClass(class {
  constructor(n) {
    this.decorations = this.getDeco(n);
  }
  update(n) {
    (n.docChanged || n.selectionSet) && (this.decorations = this.getDeco(n.view));
  }
  getDeco(n) {
    let e = -1, t = [];
    for (let r of n.state.selection.ranges) {
      let i = n.lineBlockAt(r.head);
      i.from > e && (t.push(U0t.range(i.from)), e = i.from);
    }
    return ct.set(t);
  }
}, {
  decorations: (n) => n.decorations
});
class j0t extends Sl {
  constructor(e) {
    super(), this.content = e;
  }
  toDOM(e) {
    let t = document.createElement("span");
    return t.className = "cm-placeholder", t.style.pointerEvents = "none", t.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : typeof this.content == "function" ? this.content(e) : this.content.cloneNode(!0)), t.setAttribute("aria-hidden", "true"), t;
  }
  coordsAt(e) {
    let t = e.firstChild ? uh(e.firstChild) : [];
    if (!t.length)
      return null;
    let r = window.getComputedStyle(e.parentNode), i = U1(t[0], r.direction != "rtl"), s = parseInt(r.lineHeight);
    return i.bottom - i.top > s * 1.5 ? { left: i.left, right: i.right, top: i.top, bottom: i.top + s } : i;
  }
  ignoreEvent() {
    return !1;
  }
}
function W0t(n) {
  let e = nr.fromClass(class {
    constructor(t) {
      this.view = t, this.placeholder = n ? ct.set([ct.widget({ widget: new j0t(n), side: 1 }).range(0)]) : ct.none;
    }
    get decorations() {
      return this.view.state.doc.length ? ct.none : this.placeholder;
    }
  }, { decorations: (t) => t.decorations });
  return typeof n == "string" ? [
    e,
    Be.contentAttributes.of({ "aria-placeholder": n })
  ] : e;
}
const cA = 2e3;
function G0t(n, e, t) {
  let r = Math.min(e.line, t.line), i = Math.max(e.line, t.line), s = [];
  if (e.off > cA || t.off > cA || e.col < 0 || t.col < 0) {
    let o = Math.min(e.off, t.off), a = Math.max(e.off, t.off);
    for (let l = r; l <= i; l++) {
      let c = n.doc.line(l);
      c.length <= a && s.push(ge.range(c.from + o, c.to + a));
    }
  } else {
    let o = Math.min(e.col, t.col), a = Math.max(e.col, t.col);
    for (let l = r; l <= i; l++) {
      let c = n.doc.line(l), u = z9(c.text, o, n.tabSize, !0);
      if (u < 0)
        s.push(ge.cursor(c.to));
      else {
        let d = z9(c.text, a, n.tabSize);
        s.push(ge.range(c.from + u, c.from + d));
      }
    }
  }
  return s;
}
function K0t(n, e) {
  let t = n.coordsAtPos(n.viewport.from);
  return t ? Math.round(Math.abs((t.left - e) / n.defaultCharacterWidth)) : -1;
}
function wW(n, e) {
  let t = n.posAtCoords({ x: e.clientX, y: e.clientY }, !1), r = n.state.doc.lineAt(t), i = t - r.from, s = i > cA ? -1 : i == r.length ? K0t(n, e.clientX) : Vh(r.text, n.state.tabSize, t - r.from);
  return { line: r.number, col: s, off: i };
}
function q0t(n, e) {
  let t = wW(n, e), r = n.state.selection;
  return t ? {
    update(i) {
      if (i.docChanged) {
        let s = i.changes.mapPos(i.startState.doc.line(t.line).from), o = i.state.doc.lineAt(s);
        t = { line: o.number, col: t.col, off: Math.min(t.off, o.length) }, r = r.map(i.changes);
      }
    },
    get(i, s, o) {
      let a = wW(n, i);
      if (!a)
        return r;
      let l = G0t(n.state, t, a);
      return l.length ? o ? ge.create(l.concat(r.ranges)) : ge.create(l) : r;
    }
  } : null;
}
function Y0t(n) {
  let e = ((t) => t.altKey && t.button == 0);
  return Be.mouseSelectionStyle.of((t, r) => e(r) ? q0t(t, r) : null);
}
const X0t = {
  Alt: [18, (n) => !!n.altKey],
  Control: [17, (n) => !!n.ctrlKey],
  Shift: [16, (n) => !!n.shiftKey],
  Meta: [91, (n) => !!n.metaKey]
}, Z0t = { style: "cursor: crosshair" };
function Q0t(n = {}) {
  let [e, t] = X0t[n.key || "Alt"], r = nr.fromClass(class {
    constructor(i) {
      this.view = i, this.isDown = !1;
    }
    set(i) {
      this.isDown != i && (this.isDown = i, this.view.update([]));
    }
  }, {
    eventObservers: {
      keydown(i) {
        this.set(i.keyCode == e || t(i));
      },
      keyup(i) {
        (i.keyCode == e || !t(i)) && this.set(!1);
      },
      mousemove(i) {
        this.set(t(i));
      }
    }
  });
  return [
    r,
    Be.contentAttributes.of((i) => {
      var s;
      return !((s = i.plugin(r)) === null || s === void 0) && s.isDown ? Z0t : null;
    })
  ];
}
const wp = "-10000px";
class Dce {
  constructor(e, t, r, i) {
    this.facet = t, this.createTooltipView = r, this.removeTooltipView = i, this.input = e.state.facet(t), this.tooltips = this.input.filter((o) => o);
    let s = null;
    this.tooltipViews = this.tooltips.map((o) => s = r(o, s));
  }
  update(e, t) {
    var r;
    let i = e.state.facet(this.facet), s = i.filter((l) => l);
    if (i === this.input) {
      for (let l of this.tooltipViews)
        l.update && l.update(e);
      return !1;
    }
    let o = [], a = t ? [] : null;
    for (let l = 0; l < s.length; l++) {
      let c = s[l], u = -1;
      if (c) {
        for (let d = 0; d < this.tooltips.length; d++) {
          let f = this.tooltips[d];
          f && f.create == c.create && (u = d);
        }
        if (u < 0)
          o[l] = this.createTooltipView(c, l ? o[l - 1] : null), a && (a[l] = !!c.above);
        else {
          let d = o[l] = this.tooltipViews[u];
          a && (a[l] = t[u]), d.update && d.update(e);
        }
      }
    }
    for (let l of this.tooltipViews)
      o.indexOf(l) < 0 && (this.removeTooltipView(l), (r = l.destroy) === null || r === void 0 || r.call(l));
    return t && (a.forEach((l, c) => t[c] = l), t.length = a.length), this.input = i, this.tooltips = s, this.tooltipViews = o, !0;
  }
}
function J0t(n) {
  let e = n.dom.ownerDocument.documentElement;
  return { top: 0, left: 0, bottom: e.clientHeight, right: e.clientWidth };
}
const V8 = /* @__PURE__ */ je.define({
  combine: (n) => {
    var e, t, r;
    return {
      position: ze.ios ? "absolute" : ((e = n.find((i) => i.position)) === null || e === void 0 ? void 0 : e.position) || "fixed",
      parent: ((t = n.find((i) => i.parent)) === null || t === void 0 ? void 0 : t.parent) || null,
      tooltipSpace: ((r = n.find((i) => i.tooltipSpace)) === null || r === void 0 ? void 0 : r.tooltipSpace) || J0t
    };
  }
}), xW = /* @__PURE__ */ new WeakMap(), tI = /* @__PURE__ */ nr.fromClass(class {
  constructor(n) {
    this.view = n, this.above = [], this.inView = !0, this.madeAbsolute = !1, this.lastTransaction = 0, this.measureTimeout = -1;
    let e = n.state.facet(V8);
    this.position = e.position, this.parent = e.parent, this.classes = n.themeClasses, this.createContainer(), this.measureReq = { read: this.readMeasure.bind(this), write: this.writeMeasure.bind(this), key: this }, this.resizeObserver = typeof ResizeObserver == "function" ? new ResizeObserver(() => this.measureSoon()) : null, this.manager = new Dce(n, nI, (t, r) => this.createTooltip(t, r), (t) => {
      this.resizeObserver && this.resizeObserver.unobserve(t.dom), t.dom.remove();
    }), this.above = this.manager.tooltips.map((t) => !!t.above), this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((t) => {
      Date.now() > this.lastTransaction - 50 && t.length > 0 && t[t.length - 1].intersectionRatio < 1 && this.measureSoon();
    }, { threshold: [1] }) : null, this.observeIntersection(), n.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this)), this.maybeMeasure();
  }
  createContainer() {
    this.parent ? (this.container = document.createElement("div"), this.container.style.position = "relative", this.container.className = this.view.themeClasses, this.parent.appendChild(this.container)) : this.container = this.view.dom;
  }
  observeIntersection() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      for (let n of this.manager.tooltipViews)
        this.intersectionObserver.observe(n.dom);
    }
  }
  measureSoon() {
    this.measureTimeout < 0 && (this.measureTimeout = setTimeout(() => {
      this.measureTimeout = -1, this.maybeMeasure();
    }, 50));
  }
  update(n) {
    n.transactions.length && (this.lastTransaction = Date.now());
    let e = this.manager.update(n, this.above);
    e && this.observeIntersection();
    let t = e || n.geometryChanged, r = n.state.facet(V8);
    if (r.position != this.position && !this.madeAbsolute) {
      this.position = r.position;
      for (let i of this.manager.tooltipViews)
        i.dom.style.position = this.position;
      t = !0;
    }
    if (r.parent != this.parent) {
      this.parent && this.container.remove(), this.parent = r.parent, this.createContainer();
      for (let i of this.manager.tooltipViews)
        this.container.appendChild(i.dom);
      t = !0;
    } else this.parent && this.view.themeClasses != this.classes && (this.classes = this.container.className = this.view.themeClasses);
    t && this.maybeMeasure();
  }
  createTooltip(n, e) {
    let t = n.create(this.view), r = e ? e.dom : null;
    if (t.dom.classList.add("cm-tooltip"), n.arrow && !t.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
      let i = document.createElement("div");
      i.className = "cm-tooltip-arrow", t.dom.appendChild(i);
    }
    return t.dom.style.position = this.position, t.dom.style.top = wp, t.dom.style.left = "0px", this.container.insertBefore(t.dom, r), t.mount && t.mount(this.view), this.resizeObserver && this.resizeObserver.observe(t.dom), t;
  }
  destroy() {
    var n, e, t;
    this.view.win.removeEventListener("resize", this.measureSoon);
    for (let r of this.manager.tooltipViews)
      r.dom.remove(), (n = r.destroy) === null || n === void 0 || n.call(r);
    this.parent && this.container.remove(), (e = this.resizeObserver) === null || e === void 0 || e.disconnect(), (t = this.intersectionObserver) === null || t === void 0 || t.disconnect(), clearTimeout(this.measureTimeout);
  }
  readMeasure() {
    let n = 1, e = 1, t = !1;
    if (this.position == "fixed" && this.manager.tooltipViews.length) {
      let { dom: s } = this.manager.tooltipViews[0];
      if (ze.gecko)
        t = s.offsetParent != this.container.ownerDocument.body;
      else if (s.style.top == wp && s.style.left == "0px") {
        let o = s.getBoundingClientRect();
        t = Math.abs(o.top + 1e4) > 1 || Math.abs(o.left) > 1;
      }
    }
    if (t || this.position == "absolute")
      if (this.parent) {
        let s = this.parent.getBoundingClientRect();
        s.width && s.height && (n = s.width / this.parent.offsetWidth, e = s.height / this.parent.offsetHeight);
      } else
        ({ scaleX: n, scaleY: e } = this.view.viewState);
    let r = this.view.scrollDOM.getBoundingClientRect(), i = ZO(this.view);
    return {
      visible: {
        left: r.left + i.left,
        top: r.top + i.top,
        right: r.right - i.right,
        bottom: r.bottom - i.bottom
      },
      parent: this.parent ? this.container.getBoundingClientRect() : this.view.dom.getBoundingClientRect(),
      pos: this.manager.tooltips.map((s, o) => {
        let a = this.manager.tooltipViews[o];
        return a.getCoords ? a.getCoords(s.pos) : this.view.coordsAtPos(s.pos);
      }),
      size: this.manager.tooltipViews.map(({ dom: s }) => s.getBoundingClientRect()),
      space: this.view.state.facet(V8).tooltipSpace(this.view),
      scaleX: n,
      scaleY: e,
      makeAbsolute: t
    };
  }
  writeMeasure(n) {
    var e;
    if (n.makeAbsolute) {
      this.madeAbsolute = !0, this.position = "absolute";
      for (let a of this.manager.tooltipViews)
        a.dom.style.position = "absolute";
    }
    let { visible: t, space: r, scaleX: i, scaleY: s } = n, o = [];
    for (let a = 0; a < this.manager.tooltips.length; a++) {
      let l = this.manager.tooltips[a], c = this.manager.tooltipViews[a], { dom: u } = c, d = n.pos[a], f = n.size[a];
      if (!d || l.clip !== !1 && (d.bottom <= Math.max(t.top, r.top) || d.top >= Math.min(t.bottom, r.bottom) || d.right < Math.max(t.left, r.left) - 0.1 || d.left > Math.min(t.right, r.right) + 0.1)) {
        u.style.top = wp;
        continue;
      }
      let h = l.arrow ? c.dom.querySelector(".cm-tooltip-arrow") : null, m = h ? 7 : 0, g = f.right - f.left, v = (e = xW.get(c)) !== null && e !== void 0 ? e : f.bottom - f.top, y = c.offset || t1t, b = this.view.textDirection == Dn.LTR, x = f.width > r.right - r.left ? b ? r.left : r.right - f.width : b ? Math.max(r.left, Math.min(d.left - (h ? 14 : 0) + y.x, r.right - g)) : Math.min(Math.max(r.left, d.left - g + (h ? 14 : 0) - y.x), r.right - g), E = this.above[a];
      !l.strictSide && (E ? d.top - v - m - y.y < r.top : d.bottom + v + m + y.y > r.bottom) && E == r.bottom - d.bottom > d.top - r.top && (E = this.above[a] = !E);
      let w = (E ? d.top - r.top : r.bottom - d.bottom) - m;
      if (w < v && c.resize !== !1) {
        if (w < this.view.defaultLineHeight) {
          u.style.top = wp;
          continue;
        }
        xW.set(c, v), u.style.height = (v = w) / s + "px";
      } else u.style.height && (u.style.height = "");
      let C = E ? d.top - v - m - y.y : d.bottom + m + y.y, S = x + g;
      if (c.overlap !== !0)
        for (let M of o)
          M.left < S && M.right > x && M.top < C + v && M.bottom > C && (C = E ? M.top - v - 2 - m : M.bottom + m + 2);
      if (this.position == "absolute" ? (u.style.top = (C - n.parent.top) / s + "px", EW(u, (x - n.parent.left) / i)) : (u.style.top = C / s + "px", EW(u, x / i)), h) {
        let M = d.left + (b ? y.x : -y.x) - (x + 14 - 7);
        h.style.left = M / i + "px";
      }
      c.overlap !== !0 && o.push({ left: x, top: C, right: S, bottom: C + v }), u.classList.toggle("cm-tooltip-above", E), u.classList.toggle("cm-tooltip-below", !E), c.positioned && c.positioned(n.space);
    }
  }
  maybeMeasure() {
    if (this.manager.tooltips.length && (this.view.inView && this.view.requestMeasure(this.measureReq), this.inView != this.view.inView && (this.inView = this.view.inView, !this.inView)))
      for (let n of this.manager.tooltipViews)
        n.dom.style.top = wp;
  }
}, {
  eventObservers: {
    scroll() {
      this.maybeMeasure();
    }
  }
});
function EW(n, e) {
  let t = parseInt(n.style.left, 10);
  (isNaN(t) || Math.abs(e - t) > 1) && (n.style.left = e + "px");
}
const e1t = /* @__PURE__ */ Be.baseTheme({
  ".cm-tooltip": {
    zIndex: 500,
    boxSizing: "border-box"
  },
  "&light .cm-tooltip": {
    border: "1px solid #bbb",
    backgroundColor: "#f5f5f5"
  },
  "&light .cm-tooltip-section:not(:first-child)": {
    borderTop: "1px solid #bbb"
  },
  "&dark .cm-tooltip": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tooltip-arrow": {
    height: "7px",
    width: "14px",
    position: "absolute",
    zIndex: -1,
    overflow: "hidden",
    "&:before, &:after": {
      content: "''",
      position: "absolute",
      width: 0,
      height: 0,
      borderLeft: "7px solid transparent",
      borderRight: "7px solid transparent"
    },
    ".cm-tooltip-above &": {
      bottom: "-7px",
      "&:before": {
        borderTop: "7px solid #bbb"
      },
      "&:after": {
        borderTop: "7px solid #f5f5f5",
        bottom: "1px"
      }
    },
    ".cm-tooltip-below &": {
      top: "-7px",
      "&:before": {
        borderBottom: "7px solid #bbb"
      },
      "&:after": {
        borderBottom: "7px solid #f5f5f5",
        top: "1px"
      }
    }
  },
  "&dark .cm-tooltip .cm-tooltip-arrow": {
    "&:before": {
      borderTopColor: "#333338",
      borderBottomColor: "#333338"
    },
    "&:after": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent"
    }
  }
}), t1t = { x: 0, y: 0 }, nI = /* @__PURE__ */ je.define({
  enables: [tI, e1t]
}), ew = /* @__PURE__ */ je.define({
  combine: (n) => n.reduce((e, t) => e.concat(t), [])
});
class yx {
  // Needs to be static so that host tooltip instances always match
  static create(e) {
    return new yx(e);
  }
  constructor(e) {
    this.view = e, this.mounted = !1, this.dom = document.createElement("div"), this.dom.classList.add("cm-tooltip-hover"), this.manager = new Dce(e, ew, (t, r) => this.createHostedView(t, r), (t) => t.dom.remove());
  }
  createHostedView(e, t) {
    let r = e.create(this.view);
    return r.dom.classList.add("cm-tooltip-section"), this.dom.insertBefore(r.dom, t ? t.dom.nextSibling : this.dom.firstChild), this.mounted && r.mount && r.mount(this.view), r;
  }
  mount(e) {
    for (let t of this.manager.tooltipViews)
      t.mount && t.mount(e);
    this.mounted = !0;
  }
  positioned(e) {
    for (let t of this.manager.tooltipViews)
      t.positioned && t.positioned(e);
  }
  update(e) {
    this.manager.update(e);
  }
  destroy() {
    var e;
    for (let t of this.manager.tooltipViews)
      (e = t.destroy) === null || e === void 0 || e.call(t);
  }
  passProp(e) {
    let t;
    for (let r of this.manager.tooltipViews) {
      let i = r[e];
      if (i !== void 0) {
        if (t === void 0)
          t = i;
        else if (t !== i)
          return;
      }
    }
    return t;
  }
  get offset() {
    return this.passProp("offset");
  }
  get getCoords() {
    return this.passProp("getCoords");
  }
  get overlap() {
    return this.passProp("overlap");
  }
  get resize() {
    return this.passProp("resize");
  }
}
const n1t = /* @__PURE__ */ nI.compute([ew], (n) => {
  let e = n.facet(ew);
  return e.length === 0 ? null : {
    pos: Math.min(...e.map((t) => t.pos)),
    end: Math.max(...e.map((t) => {
      var r;
      return (r = t.end) !== null && r !== void 0 ? r : t.pos;
    })),
    create: yx.create,
    above: e[0].above,
    arrow: e.some((t) => t.arrow)
  };
});
class r1t {
  constructor(e, t, r, i, s) {
    this.view = e, this.source = t, this.field = r, this.setHover = i, this.hoverTime = s, this.hoverTimeout = -1, this.restartTimeout = -1, this.pending = null, this.lastMove = { x: 0, y: 0, target: e.dom, time: 0 }, this.checkHover = this.checkHover.bind(this), e.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this)), e.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
  }
  update() {
    this.pending && (this.pending = null, clearTimeout(this.restartTimeout), this.restartTimeout = setTimeout(() => this.startHover(), 20));
  }
  get active() {
    return this.view.state.field(this.field);
  }
  checkHover() {
    if (this.hoverTimeout = -1, this.active.length)
      return;
    let e = Date.now() - this.lastMove.time;
    e < this.hoverTime ? this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - e) : this.startHover();
  }
  startHover() {
    clearTimeout(this.restartTimeout);
    let { view: e, lastMove: t } = this, r = e.docView.nearest(t.target);
    if (!r)
      return;
    let i, s = 1;
    if (r instanceof nc)
      i = r.posAtStart;
    else {
      if (i = e.posAtCoords(t), i == null)
        return;
      let a = e.coordsAtPos(i);
      if (!a || t.y < a.top || t.y > a.bottom || t.x < a.left - e.defaultCharacterWidth || t.x > a.right + e.defaultCharacterWidth)
        return;
      let l = e.bidiSpans(e.state.doc.lineAt(i)).find((u) => u.from <= i && u.to >= i), c = l && l.dir == Dn.RTL ? -1 : 1;
      s = t.x < a.left ? -c : c;
    }
    let o = this.source(e, i, s);
    if (o?.then) {
      let a = this.pending = { pos: i };
      o.then((l) => {
        this.pending == a && (this.pending = null, l && !(Array.isArray(l) && !l.length) && e.dispatch({ effects: this.setHover.of(Array.isArray(l) ? l : [l]) }));
      }, (l) => zi(e.state, l, "hover tooltip"));
    } else o && !(Array.isArray(o) && !o.length) && e.dispatch({ effects: this.setHover.of(Array.isArray(o) ? o : [o]) });
  }
  get tooltip() {
    let e = this.view.plugin(tI), t = e ? e.manager.tooltips.findIndex((r) => r.create == yx.create) : -1;
    return t > -1 ? e.manager.tooltipViews[t] : null;
  }
  mousemove(e) {
    var t, r;
    this.lastMove = { x: e.clientX, y: e.clientY, target: e.target, time: Date.now() }, this.hoverTimeout < 0 && (this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime));
    let { active: i, tooltip: s } = this;
    if (i.length && s && !i1t(s.dom, e) || this.pending) {
      let { pos: o } = i[0] || this.pending, a = (r = (t = i[0]) === null || t === void 0 ? void 0 : t.end) !== null && r !== void 0 ? r : o;
      (o == a ? this.view.posAtCoords(this.lastMove) != o : !s1t(this.view, o, a, e.clientX, e.clientY)) && (this.view.dispatch({ effects: this.setHover.of([]) }), this.pending = null);
    }
  }
  mouseleave(e) {
    clearTimeout(this.hoverTimeout), this.hoverTimeout = -1;
    let { active: t } = this;
    if (t.length) {
      let { tooltip: r } = this;
      r && r.dom.contains(e.relatedTarget) ? this.watchTooltipLeave(r.dom) : this.view.dispatch({ effects: this.setHover.of([]) });
    }
  }
  watchTooltipLeave(e) {
    let t = (r) => {
      e.removeEventListener("mouseleave", t), this.active.length && !this.view.dom.contains(r.relatedTarget) && this.view.dispatch({ effects: this.setHover.of([]) });
    };
    e.addEventListener("mouseleave", t);
  }
  destroy() {
    clearTimeout(this.hoverTimeout), this.view.dom.removeEventListener("mouseleave", this.mouseleave), this.view.dom.removeEventListener("mousemove", this.mousemove);
  }
}
const Iv = 4;
function i1t(n, e) {
  let { left: t, right: r, top: i, bottom: s } = n.getBoundingClientRect(), o;
  if (o = n.querySelector(".cm-tooltip-arrow")) {
    let a = o.getBoundingClientRect();
    i = Math.min(a.top, i), s = Math.max(a.bottom, s);
  }
  return e.clientX >= t - Iv && e.clientX <= r + Iv && e.clientY >= i - Iv && e.clientY <= s + Iv;
}
function s1t(n, e, t, r, i, s) {
  let o = n.scrollDOM.getBoundingClientRect(), a = n.documentTop + n.documentPadding.top + n.contentHeight;
  if (o.left > r || o.right < r || o.top > i || Math.min(o.bottom, a) < i)
    return !1;
  let l = n.posAtCoords({ x: r, y: i }, !1);
  return l >= e && l <= t;
}
function o1t(n, e = {}) {
  let t = At.define(), r = Xr.define({
    create() {
      return [];
    },
    update(i, s) {
      if (i.length && (e.hideOnChange && (s.docChanged || s.selection) ? i = [] : e.hideOn && (i = i.filter((o) => !e.hideOn(s, o))), s.docChanged)) {
        let o = [];
        for (let a of i) {
          let l = s.changes.mapPos(a.pos, -1, hi.TrackDel);
          if (l != null) {
            let c = Object.assign(/* @__PURE__ */ Object.create(null), a);
            c.pos = l, c.end != null && (c.end = s.changes.mapPos(c.end)), o.push(c);
          }
        }
        i = o;
      }
      for (let o of s.effects)
        o.is(t) && (i = o.value), o.is(a1t) && (i = []);
      return i;
    },
    provide: (i) => ew.from(i)
  });
  return {
    active: r,
    extension: [
      r,
      nr.define((i) => new r1t(
        i,
        n,
        r,
        t,
        e.hoverTime || 300
        /* Hover.Time */
      )),
      n1t
    ]
  };
}
function Nce(n, e) {
  let t = n.plugin(tI);
  if (!t)
    return null;
  let r = t.manager.tooltips.indexOf(e);
  return r < 0 ? null : t.manager.tooltipViews[r];
}
const a1t = /* @__PURE__ */ At.define(), SW = /* @__PURE__ */ je.define({
  combine(n) {
    let e, t;
    for (let r of n)
      e = e || r.topContainer, t = t || r.bottomContainer;
    return { topContainer: e, bottomContainer: t };
  }
});
function Q0(n, e) {
  let t = n.plugin(Lce), r = t ? t.specs.indexOf(e) : -1;
  return r > -1 ? t.panels[r] : null;
}
const Lce = /* @__PURE__ */ nr.fromClass(class {
  constructor(n) {
    this.input = n.state.facet(J0), this.specs = this.input.filter((t) => t), this.panels = this.specs.map((t) => t(n));
    let e = n.state.facet(SW);
    this.top = new Rv(n, !0, e.topContainer), this.bottom = new Rv(n, !1, e.bottomContainer), this.top.sync(this.panels.filter((t) => t.top)), this.bottom.sync(this.panels.filter((t) => !t.top));
    for (let t of this.panels)
      t.dom.classList.add("cm-panel"), t.mount && t.mount();
  }
  update(n) {
    let e = n.state.facet(SW);
    this.top.container != e.topContainer && (this.top.sync([]), this.top = new Rv(n.view, !0, e.topContainer)), this.bottom.container != e.bottomContainer && (this.bottom.sync([]), this.bottom = new Rv(n.view, !1, e.bottomContainer)), this.top.syncClasses(), this.bottom.syncClasses();
    let t = n.state.facet(J0);
    if (t != this.input) {
      let r = t.filter((l) => l), i = [], s = [], o = [], a = [];
      for (let l of r) {
        let c = this.specs.indexOf(l), u;
        c < 0 ? (u = l(n.view), a.push(u)) : (u = this.panels[c], u.update && u.update(n)), i.push(u), (u.top ? s : o).push(u);
      }
      this.specs = r, this.panels = i, this.top.sync(s), this.bottom.sync(o);
      for (let l of a)
        l.dom.classList.add("cm-panel"), l.mount && l.mount();
    } else
      for (let r of this.panels)
        r.update && r.update(n);
  }
  destroy() {
    this.top.sync([]), this.bottom.sync([]);
  }
}, {
  provide: (n) => Be.scrollMargins.of((e) => {
    let t = e.plugin(n);
    return t && { top: t.top.scrollMargin(), bottom: t.bottom.scrollMargin() };
  })
});
class Rv {
  constructor(e, t, r) {
    this.view = e, this.top = t, this.container = r, this.dom = void 0, this.classes = "", this.panels = [], this.syncClasses();
  }
  sync(e) {
    for (let t of this.panels)
      t.destroy && e.indexOf(t) < 0 && t.destroy();
    this.panels = e, this.syncDOM();
  }
  syncDOM() {
    if (this.panels.length == 0) {
      this.dom && (this.dom.remove(), this.dom = void 0);
      return;
    }
    if (!this.dom) {
      this.dom = document.createElement("div"), this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom", this.dom.style[this.top ? "top" : "bottom"] = "0";
      let t = this.container || this.view.dom;
      t.insertBefore(this.dom, this.top ? t.firstChild : null);
    }
    let e = this.dom.firstChild;
    for (let t of this.panels)
      if (t.dom.parentNode == this.dom) {
        for (; e != t.dom; )
          e = CW(e);
        e = e.nextSibling;
      } else
        this.dom.insertBefore(t.dom, e);
    for (; e; )
      e = CW(e);
  }
  scrollMargin() {
    return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
  }
  syncClasses() {
    if (!(!this.container || this.classes == this.view.themeClasses)) {
      for (let e of this.classes.split(" "))
        e && this.container.classList.remove(e);
      for (let e of (this.classes = this.view.themeClasses).split(" "))
        e && this.container.classList.add(e);
    }
  }
}
function CW(n) {
  let e = n.nextSibling;
  return n.remove(), e;
}
const J0 = /* @__PURE__ */ je.define({
  enables: Lce
});
class vl extends Gu {
  /**
  @internal
  */
  compare(e) {
    return this == e || this.constructor == e.constructor && this.eq(e);
  }
  /**
  Compare this marker to another marker of the same type.
  */
  eq(e) {
    return !1;
  }
  /**
  Called if the marker has a `toDOM` method and its representation
  was removed from a gutter.
  */
  destroy(e) {
  }
}
vl.prototype.elementClass = "";
vl.prototype.toDOM = void 0;
vl.prototype.mapMode = hi.TrackBefore;
vl.prototype.startSide = vl.prototype.endSide = -1;
vl.prototype.point = !0;
const h2 = /* @__PURE__ */ je.define(), l1t = /* @__PURE__ */ je.define(), c1t = {
  class: "",
  renderEmptyElements: !1,
  elementStyle: "",
  markers: () => Vt.empty,
  lineMarker: () => null,
  widgetMarker: () => null,
  lineMarkerChange: null,
  initialSpacer: null,
  updateSpacer: null,
  domEventHandlers: {},
  side: "before"
}, mm = /* @__PURE__ */ je.define();
function u1t(n) {
  return [$ce(), mm.of({ ...c1t, ...n })];
}
const TW = /* @__PURE__ */ je.define({
  combine: (n) => n.some((e) => e)
});
function $ce(n) {
  return [
    d1t
  ];
}
const d1t = /* @__PURE__ */ nr.fromClass(class {
  constructor(n) {
    this.view = n, this.domAfter = null, this.prevViewport = n.viewport, this.dom = document.createElement("div"), this.dom.className = "cm-gutters cm-gutters-before", this.dom.setAttribute("aria-hidden", "true"), this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px", this.gutters = n.state.facet(mm).map((e) => new MW(n, e)), this.fixed = !n.state.facet(TW);
    for (let e of this.gutters)
      e.config.side == "after" ? this.getDOMAfter().appendChild(e.dom) : this.dom.appendChild(e.dom);
    this.fixed && (this.dom.style.position = "sticky"), this.syncGutters(!1), n.scrollDOM.insertBefore(this.dom, n.contentDOM);
  }
  getDOMAfter() {
    return this.domAfter || (this.domAfter = document.createElement("div"), this.domAfter.className = "cm-gutters cm-gutters-after", this.domAfter.setAttribute("aria-hidden", "true"), this.domAfter.style.minHeight = this.view.contentHeight / this.view.scaleY + "px", this.domAfter.style.position = this.fixed ? "sticky" : "", this.view.scrollDOM.appendChild(this.domAfter)), this.domAfter;
  }
  update(n) {
    if (this.updateGutters(n)) {
      let e = this.prevViewport, t = n.view.viewport, r = Math.min(e.to, t.to) - Math.max(e.from, t.from);
      this.syncGutters(r < (t.to - t.from) * 0.8);
    }
    if (n.geometryChanged) {
      let e = this.view.contentHeight / this.view.scaleY + "px";
      this.dom.style.minHeight = e, this.domAfter && (this.domAfter.style.minHeight = e);
    }
    this.view.state.facet(TW) != !this.fixed && (this.fixed = !this.fixed, this.dom.style.position = this.fixed ? "sticky" : "", this.domAfter && (this.domAfter.style.position = this.fixed ? "sticky" : "")), this.prevViewport = n.view.viewport;
  }
  syncGutters(n) {
    let e = this.dom.nextSibling;
    n && (this.dom.remove(), this.domAfter && this.domAfter.remove());
    let t = Vt.iter(this.view.state.facet(h2), this.view.viewport.from), r = [], i = this.gutters.map((s) => new f1t(s, this.view.viewport, -this.view.documentPadding.top));
    for (let s of this.view.viewportLineBlocks)
      if (r.length && (r = []), Array.isArray(s.type)) {
        let o = !0;
        for (let a of s.type)
          if (a.type == vi.Text && o) {
            uA(t, r, a.from);
            for (let l of i)
              l.line(this.view, a, r);
            o = !1;
          } else if (a.widget)
            for (let l of i)
              l.widget(this.view, a);
      } else if (s.type == vi.Text) {
        uA(t, r, s.from);
        for (let o of i)
          o.line(this.view, s, r);
      } else if (s.widget)
        for (let o of i)
          o.widget(this.view, s);
    for (let s of i)
      s.finish();
    n && (this.view.scrollDOM.insertBefore(this.dom, e), this.domAfter && this.view.scrollDOM.appendChild(this.domAfter));
  }
  updateGutters(n) {
    let e = n.startState.facet(mm), t = n.state.facet(mm), r = n.docChanged || n.heightChanged || n.viewportChanged || !Vt.eq(n.startState.facet(h2), n.state.facet(h2), n.view.viewport.from, n.view.viewport.to);
    if (e == t)
      for (let i of this.gutters)
        i.update(n) && (r = !0);
    else {
      r = !0;
      let i = [];
      for (let s of t) {
        let o = e.indexOf(s);
        o < 0 ? i.push(new MW(this.view, s)) : (this.gutters[o].update(n), i.push(this.gutters[o]));
      }
      for (let s of this.gutters)
        s.dom.remove(), i.indexOf(s) < 0 && s.destroy();
      for (let s of i)
        s.config.side == "after" ? this.getDOMAfter().appendChild(s.dom) : this.dom.appendChild(s.dom);
      this.gutters = i;
    }
    return r;
  }
  destroy() {
    for (let n of this.gutters)
      n.destroy();
    this.dom.remove(), this.domAfter && this.domAfter.remove();
  }
}, {
  provide: (n) => Be.scrollMargins.of((e) => {
    let t = e.plugin(n);
    if (!t || t.gutters.length == 0 || !t.fixed)
      return null;
    let r = t.dom.offsetWidth * e.scaleX, i = t.domAfter ? t.domAfter.offsetWidth * e.scaleX : 0;
    return e.textDirection == Dn.LTR ? { left: r, right: i } : { right: r, left: i };
  })
});
function AW(n) {
  return Array.isArray(n) ? n : [n];
}
function uA(n, e, t) {
  for (; n.value && n.from <= t; )
    n.from == t && e.push(n.value), n.next();
}
class f1t {
  constructor(e, t, r) {
    this.gutter = e, this.height = r, this.i = 0, this.cursor = Vt.iter(e.markers, t.from);
  }
  addElement(e, t, r) {
    let { gutter: i } = this, s = (t.top - this.height) / e.scaleY, o = t.height / e.scaleY;
    if (this.i == i.elements.length) {
      let a = new Fce(e, o, s, r);
      i.elements.push(a), i.dom.appendChild(a.dom);
    } else
      i.elements[this.i].update(e, o, s, r);
    this.height = t.bottom, this.i++;
  }
  line(e, t, r) {
    let i = [];
    uA(this.cursor, i, t.from), r.length && (i = i.concat(r));
    let s = this.gutter.config.lineMarker(e, t, i);
    s && i.unshift(s);
    let o = this.gutter;
    i.length == 0 && !o.config.renderEmptyElements || this.addElement(e, t, i);
  }
  widget(e, t) {
    let r = this.gutter.config.widgetMarker(e, t.widget, t), i = r ? [r] : null;
    for (let s of e.state.facet(l1t)) {
      let o = s(e, t.widget, t);
      o && (i || (i = [])).push(o);
    }
    i && this.addElement(e, t, i);
  }
  finish() {
    let e = this.gutter;
    for (; e.elements.length > this.i; ) {
      let t = e.elements.pop();
      e.dom.removeChild(t.dom), t.destroy();
    }
  }
}
class MW {
  constructor(e, t) {
    this.view = e, this.config = t, this.elements = [], this.spacer = null, this.dom = document.createElement("div"), this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
    for (let r in t.domEventHandlers)
      this.dom.addEventListener(r, (i) => {
        let s = i.target, o;
        if (s != this.dom && this.dom.contains(s)) {
          for (; s.parentNode != this.dom; )
            s = s.parentNode;
          let l = s.getBoundingClientRect();
          o = (l.top + l.bottom) / 2;
        } else
          o = i.clientY;
        let a = e.lineBlockAtHeight(o - e.documentTop);
        t.domEventHandlers[r](e, a, i) && i.preventDefault();
      });
    this.markers = AW(t.markers(e)), t.initialSpacer && (this.spacer = new Fce(e, 0, 0, [t.initialSpacer(e)]), this.dom.appendChild(this.spacer.dom), this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none");
  }
  update(e) {
    let t = this.markers;
    if (this.markers = AW(this.config.markers(e.view)), this.spacer && this.config.updateSpacer) {
      let i = this.config.updateSpacer(this.spacer.markers[0], e);
      i != this.spacer.markers[0] && this.spacer.update(e.view, 0, 0, [i]);
    }
    let r = e.view.viewport;
    return !Vt.eq(this.markers, t, r.from, r.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(e) : !1);
  }
  destroy() {
    for (let e of this.elements)
      e.destroy();
  }
}
class Fce {
  constructor(e, t, r, i) {
    this.height = -1, this.above = 0, this.markers = [], this.dom = document.createElement("div"), this.dom.className = "cm-gutterElement", this.update(e, t, r, i);
  }
  update(e, t, r, i) {
    this.height != t && (this.height = t, this.dom.style.height = t + "px"), this.above != r && (this.dom.style.marginTop = (this.above = r) ? r + "px" : ""), h1t(this.markers, i) || this.setMarkers(e, i);
  }
  setMarkers(e, t) {
    let r = "cm-gutterElement", i = this.dom.firstChild;
    for (let s = 0, o = 0; ; ) {
      let a = o, l = s < t.length ? t[s++] : null, c = !1;
      if (l) {
        let u = l.elementClass;
        u && (r += " " + u);
        for (let d = o; d < this.markers.length; d++)
          if (this.markers[d].compare(l)) {
            a = d, c = !0;
            break;
          }
      } else
        a = this.markers.length;
      for (; o < a; ) {
        let u = this.markers[o++];
        if (u.toDOM) {
          u.destroy(i);
          let d = i.nextSibling;
          i.remove(), i = d;
        }
      }
      if (!l)
        break;
      l.toDOM && (c ? i = i.nextSibling : this.dom.insertBefore(l.toDOM(e), i)), c && o++;
    }
    this.dom.className = r, this.markers = t;
  }
  destroy() {
    this.setMarkers(null, []);
  }
}
function h1t(n, e) {
  if (n.length != e.length)
    return !1;
  for (let t = 0; t < n.length; t++)
    if (!n[t].compare(e[t]))
      return !1;
  return !0;
}
const p1t = /* @__PURE__ */ je.define(), m1t = /* @__PURE__ */ je.define(), Jd = /* @__PURE__ */ je.define({
  combine(n) {
    return ka(n, { formatNumber: String, domEventHandlers: {} }, {
      domEventHandlers(e, t) {
        let r = Object.assign({}, e);
        for (let i in t) {
          let s = r[i], o = t[i];
          r[i] = s ? (a, l, c) => s(a, l, c) || o(a, l, c) : o;
        }
        return r;
      }
    });
  }
});
class j8 extends vl {
  constructor(e) {
    super(), this.number = e;
  }
  eq(e) {
    return this.number == e.number;
  }
  toDOM() {
    return document.createTextNode(this.number);
  }
}
function W8(n, e) {
  return n.state.facet(Jd).formatNumber(e, n.state);
}
const g1t = /* @__PURE__ */ mm.compute([Jd], (n) => ({
  class: "cm-lineNumbers",
  renderEmptyElements: !1,
  markers(e) {
    return e.state.facet(p1t);
  },
  lineMarker(e, t, r) {
    return r.some((i) => i.toDOM) ? null : new j8(W8(e, e.state.doc.lineAt(t.from).number));
  },
  widgetMarker: (e, t, r) => {
    for (let i of e.state.facet(m1t)) {
      let s = i(e, t, r);
      if (s)
        return s;
    }
    return null;
  },
  lineMarkerChange: (e) => e.startState.facet(Jd) != e.state.facet(Jd),
  initialSpacer(e) {
    return new j8(W8(e, kW(e.state.doc.lines)));
  },
  updateSpacer(e, t) {
    let r = W8(t.view, kW(t.view.state.doc.lines));
    return r == e.number ? e : new j8(r);
  },
  domEventHandlers: n.facet(Jd).domEventHandlers,
  side: "before"
}));
function v1t(n = {}) {
  return [
    Jd.of(n),
    $ce(),
    g1t
  ];
}
function kW(n) {
  let e = 9;
  for (; e < n; )
    e = e * 10 + 9;
  return e;
}
const y1t = /* @__PURE__ */ new class extends vl {
  constructor() {
    super(...arguments), this.elementClass = "cm-activeLineGutter";
  }
}(), b1t = /* @__PURE__ */ h2.compute(["selection"], (n) => {
  let e = [], t = -1;
  for (let r of n.selection.ranges) {
    let i = n.doc.lineAt(r.head).from;
    i > t && (t = i, e.push(y1t.range(i)));
  }
  return Vt.of(e);
});
function w1t() {
  return b1t;
}
var G8;
const ef = /* @__PURE__ */ new Lt();
function x1t(n) {
  return je.define({
    combine: n ? (e) => e.concat(n) : void 0
  });
}
const E1t = /* @__PURE__ */ new Lt();
class mo {
  /**
  Construct a language object. If you need to invoke this
  directly, first define a data facet with
  [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
  configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
  to the language's outer syntax node.
  */
  constructor(e, t, r = [], i = "") {
    this.data = e, this.name = i, Ht.prototype.hasOwnProperty("tree") || Object.defineProperty(Ht.prototype, "tree", { get() {
      return ai(this);
    } }), this.parser = t, this.extension = [
      Ec.of(this),
      Ht.languageData.of((s, o, a) => {
        let l = _W(s, o, a), c = l.type.prop(ef);
        if (!c)
          return [];
        let u = s.facet(c), d = l.type.prop(E1t);
        if (d) {
          let f = l.resolve(o - l.from, a);
          for (let h of d)
            if (h.test(f, s)) {
              let m = s.facet(h.facet);
              return h.type == "replace" ? m : m.concat(u);
            }
        }
        return u;
      })
    ].concat(r);
  }
  /**
  Query whether this language is active at the given position.
  */
  isActiveAt(e, t, r = -1) {
    return _W(e, t, r).type.prop(ef) == this.data;
  }
  /**
  Find the document regions that were parsed using this language.
  The returned regions will _include_ any nested languages rooted
  in this language, when those exist.
  */
  findRegions(e) {
    let t = e.facet(Ec);
    if (t?.data == this.data)
      return [{ from: 0, to: e.doc.length }];
    if (!t || !t.allowsNesting)
      return [];
    let r = [], i = (s, o) => {
      if (s.prop(ef) == this.data) {
        r.push({ from: o, to: o + s.length });
        return;
      }
      let a = s.prop(Lt.mounted);
      if (a) {
        if (a.tree.prop(ef) == this.data) {
          if (a.overlay)
            for (let l of a.overlay)
              r.push({ from: l.from + o, to: l.to + o });
          else
            r.push({ from: o, to: o + s.length });
          return;
        } else if (a.overlay) {
          let l = r.length;
          if (i(a.tree, a.overlay[0].from + o), r.length > l)
            return;
        }
      }
      for (let l = 0; l < s.children.length; l++) {
        let c = s.children[l];
        c instanceof ar && i(c, s.positions[l] + o);
      }
    };
    return i(ai(e), 0), r;
  }
  /**
  Indicates whether this language allows nested languages. The
  default implementation returns true.
  */
  get allowsNesting() {
    return !0;
  }
}
mo.setState = /* @__PURE__ */ At.define();
function _W(n, e, t) {
  let r = n.facet(Ec), i = ai(n).topNode;
  if (!r || r.allowsNesting)
    for (let s = i; s; s = s.enter(e, t, kr.ExcludeBuffers))
      s.type.isTop && (i = s);
  return i;
}
class tw extends mo {
  constructor(e, t, r) {
    super(e, t, [], r), this.parser = t;
  }
  /**
  Define a language from a parser.
  */
  static define(e) {
    let t = x1t(e.languageData);
    return new tw(t, e.parser.configure({
      props: [ef.add((r) => r.isTop ? t : void 0)]
    }), e.name);
  }
  /**
  Create a new instance of this language with a reconfigured
  version of its parser and optionally a new name.
  */
  configure(e, t) {
    return new tw(this.data, this.parser.configure(e), t || this.name);
  }
  get allowsNesting() {
    return this.parser.hasWrappers();
  }
}
function ai(n) {
  let e = n.field(mo.state, !1);
  return e ? e.tree : ar.empty;
}
class S1t {
  /**
  Create an input object for the given document.
  */
  constructor(e) {
    this.doc = e, this.cursorPos = 0, this.string = "", this.cursor = e.iter();
  }
  get length() {
    return this.doc.length;
  }
  syncTo(e) {
    return this.string = this.cursor.next(e - this.cursorPos).value, this.cursorPos = e + this.string.length, this.cursorPos - this.string.length;
  }
  chunk(e) {
    return this.syncTo(e), this.string;
  }
  get lineChunks() {
    return !0;
  }
  read(e, t) {
    let r = this.cursorPos - this.string.length;
    return e < r || t >= this.cursorPos ? this.doc.sliceString(e, t) : this.string.slice(e - r, t - r);
  }
}
let xp = null;
class nw {
  constructor(e, t, r = [], i, s, o, a, l) {
    this.parser = e, this.state = t, this.fragments = r, this.tree = i, this.treeLen = s, this.viewport = o, this.skipped = a, this.scheduleOn = l, this.parse = null, this.tempSkipped = [];
  }
  /**
  @internal
  */
  static create(e, t, r) {
    return new nw(e, t, [], ar.empty, 0, r, [], null);
  }
  startParse() {
    return this.parser.startParse(new S1t(this.state.doc), this.fragments);
  }
  /**
  @internal
  */
  work(e, t) {
    return t != null && t >= this.state.doc.length && (t = void 0), this.tree != ar.empty && this.isDone(t ?? this.state.doc.length) ? (this.takeTree(), !0) : this.withContext(() => {
      var r;
      if (typeof e == "number") {
        let i = Date.now() + e;
        e = () => Date.now() > i;
      }
      for (this.parse || (this.parse = this.startParse()), t != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > t) && t < this.state.doc.length && this.parse.stopAt(t); ; ) {
        let i = this.parse.advance();
        if (i)
          if (this.fragments = this.withoutTempSkipped(_u.addTree(i, this.fragments, this.parse.stoppedAt != null)), this.treeLen = (r = this.parse.stoppedAt) !== null && r !== void 0 ? r : this.state.doc.length, this.tree = i, this.parse = null, this.treeLen < (t ?? this.state.doc.length))
            this.parse = this.startParse();
          else
            return !0;
        if (e())
          return !1;
      }
    });
  }
  /**
  @internal
  */
  takeTree() {
    let e, t;
    this.parse && (e = this.parse.parsedPos) >= this.treeLen && ((this.parse.stoppedAt == null || this.parse.stoppedAt > e) && this.parse.stopAt(e), this.withContext(() => {
      for (; !(t = this.parse.advance()); )
        ;
    }), this.treeLen = e, this.tree = t, this.fragments = this.withoutTempSkipped(_u.addTree(this.tree, this.fragments, !0)), this.parse = null);
  }
  withContext(e) {
    let t = xp;
    xp = this;
    try {
      return e();
    } finally {
      xp = t;
    }
  }
  withoutTempSkipped(e) {
    for (let t; t = this.tempSkipped.pop(); )
      e = OW(e, t.from, t.to);
    return e;
  }
  /**
  @internal
  */
  changes(e, t) {
    let { fragments: r, tree: i, treeLen: s, viewport: o, skipped: a } = this;
    if (this.takeTree(), !e.empty) {
      let l = [];
      if (e.iterChangedRanges((c, u, d, f) => l.push({ fromA: c, toA: u, fromB: d, toB: f })), r = _u.applyChanges(r, l), i = ar.empty, s = 0, o = { from: e.mapPos(o.from, -1), to: e.mapPos(o.to, 1) }, this.skipped.length) {
        a = [];
        for (let c of this.skipped) {
          let u = e.mapPos(c.from, 1), d = e.mapPos(c.to, -1);
          u < d && a.push({ from: u, to: d });
        }
      }
    }
    return new nw(this.parser, t, r, i, s, o, a, this.scheduleOn);
  }
  /**
  @internal
  */
  updateViewport(e) {
    if (this.viewport.from == e.from && this.viewport.to == e.to)
      return !1;
    this.viewport = e;
    let t = this.skipped.length;
    for (let r = 0; r < this.skipped.length; r++) {
      let { from: i, to: s } = this.skipped[r];
      i < e.to && s > e.from && (this.fragments = OW(this.fragments, i, s), this.skipped.splice(r--, 1));
    }
    return this.skipped.length >= t ? !1 : (this.reset(), !0);
  }
  /**
  @internal
  */
  reset() {
    this.parse && (this.takeTree(), this.parse = null);
  }
  /**
  Notify the parse scheduler that the given region was skipped
  because it wasn't in view, and the parse should be restarted
  when it comes into view.
  */
  skipUntilInView(e, t) {
    this.skipped.push({ from: e, to: t });
  }
  /**
  Returns a parser intended to be used as placeholder when
  asynchronously loading a nested parser. It'll skip its input and
  mark it as not-really-parsed, so that the next update will parse
  it again.
  
  When `until` is given, a reparse will be scheduled when that
  promise resolves.
  */
  static getSkippingParser(e) {
    return new class extends ale {
      createParse(t, r, i) {
        let s = i[0].from, o = i[i.length - 1].to;
        return {
          parsedPos: s,
          advance() {
            let l = xp;
            if (l) {
              for (let c of i)
                l.tempSkipped.push(c);
              e && (l.scheduleOn = l.scheduleOn ? Promise.all([l.scheduleOn, e]) : e);
            }
            return this.parsedPos = o, new ar(ji.none, [], [], o - s);
          },
          stoppedAt: null,
          stopAt() {
          }
        };
      }
    }();
  }
  /**
  @internal
  */
  isDone(e) {
    e = Math.min(e, this.state.doc.length);
    let t = this.fragments;
    return this.treeLen >= e && t.length && t[0].from == 0 && t[0].to >= e;
  }
  /**
  Get the context for the current parse, or `null` if no editor
  parse is in progress.
  */
  static get() {
    return xp;
  }
}
function OW(n, e, t) {
  return _u.applyChanges(n, [{ fromA: e, toA: t, fromB: e, toB: t }]);
}
class ph {
  constructor(e) {
    this.context = e, this.tree = e.tree;
  }
  apply(e) {
    if (!e.docChanged && this.tree == this.context.tree)
      return this;
    let t = this.context.changes(e.changes, e.state), r = this.context.treeLen == e.startState.doc.length ? void 0 : Math.max(e.changes.mapPos(this.context.treeLen), t.viewport.to);
    return t.work(20, r) || t.takeTree(), new ph(t);
  }
  static init(e) {
    let t = Math.min(3e3, e.doc.length), r = nw.create(e.facet(Ec).parser, e, { from: 0, to: t });
    return r.work(20, t) || r.takeTree(), new ph(r);
  }
}
mo.state = /* @__PURE__ */ Xr.define({
  create: ph.init,
  update(n, e) {
    for (let t of e.effects)
      if (t.is(mo.setState))
        return t.value;
    return e.startState.facet(Ec) != e.state.facet(Ec) ? ph.init(e.state) : n.apply(e);
  }
});
let Bce = (n) => {
  let e = setTimeout(
    () => n(),
    500
    /* Work.MaxPause */
  );
  return () => clearTimeout(e);
};
typeof requestIdleCallback < "u" && (Bce = (n) => {
  let e = -1, t = setTimeout(
    () => {
      e = requestIdleCallback(n, {
        timeout: 400
        /* Work.MinPause */
      });
    },
    100
    /* Work.MinPause */
  );
  return () => e < 0 ? clearTimeout(t) : cancelIdleCallback(e);
});
const K8 = typeof navigator < "u" && (!((G8 = navigator.scheduling) === null || G8 === void 0) && G8.isInputPending) ? () => navigator.scheduling.isInputPending() : null, C1t = /* @__PURE__ */ nr.fromClass(class {
  constructor(e) {
    this.view = e, this.working = null, this.workScheduled = 0, this.chunkEnd = -1, this.chunkBudget = -1, this.work = this.work.bind(this), this.scheduleWork();
  }
  update(e) {
    let t = this.view.state.field(mo.state).context;
    (t.updateViewport(e.view.viewport) || this.view.viewport.to > t.treeLen) && this.scheduleWork(), (e.docChanged || e.selectionSet) && (this.view.hasFocus && (this.chunkBudget += 50), this.scheduleWork()), this.checkAsyncSchedule(t);
  }
  scheduleWork() {
    if (this.working)
      return;
    let { state: e } = this.view, t = e.field(mo.state);
    (t.tree != t.context.tree || !t.context.isDone(e.doc.length)) && (this.working = Bce(this.work));
  }
  work(e) {
    this.working = null;
    let t = Date.now();
    if (this.chunkEnd < t && (this.chunkEnd < 0 || this.view.hasFocus) && (this.chunkEnd = t + 3e4, this.chunkBudget = 3e3), this.chunkBudget <= 0)
      return;
    let { state: r, viewport: { to: i } } = this.view, s = r.field(mo.state);
    if (s.tree == s.context.tree && s.context.isDone(
      i + 1e5
      /* Work.MaxParseAhead */
    ))
      return;
    let o = Date.now() + Math.min(this.chunkBudget, 100, e && !K8 ? Math.max(25, e.timeRemaining() - 5) : 1e9), a = s.context.treeLen < i && r.doc.length > i + 1e3, l = s.context.work(() => K8 && K8() || Date.now() > o, i + (a ? 0 : 1e5));
    this.chunkBudget -= Date.now() - t, (l || this.chunkBudget <= 0) && (s.context.takeTree(), this.view.dispatch({ effects: mo.setState.of(new ph(s.context)) })), this.chunkBudget > 0 && !(l && !a) && this.scheduleWork(), this.checkAsyncSchedule(s.context);
  }
  checkAsyncSchedule(e) {
    e.scheduleOn && (this.workScheduled++, e.scheduleOn.then(() => this.scheduleWork()).catch((t) => zi(this.view.state, t)).then(() => this.workScheduled--), e.scheduleOn = null);
  }
  destroy() {
    this.working && this.working();
  }
  isWorking() {
    return !!(this.working || this.workScheduled > 0);
  }
}, {
  eventHandlers: { focus() {
    this.scheduleWork();
  } }
}), Ec = /* @__PURE__ */ je.define({
  combine(n) {
    return n.length ? n[0] : null;
  },
  enables: (n) => [
    mo.state,
    C1t,
    Be.contentAttributes.compute([n], (e) => {
      let t = e.facet(n);
      return t && t.name ? { "data-language": t.name } : {};
    })
  ]
});
class T1t {
  /**
  Create a language support object.
  */
  constructor(e, t = []) {
    this.language = e, this.support = t, this.extension = [e, t];
  }
}
const A1t = /* @__PURE__ */ je.define(), bx = /* @__PURE__ */ je.define({
  combine: (n) => {
    if (!n.length)
      return "  ";
    let e = n[0];
    if (!e || /\S/.test(e) || Array.from(e).some((t) => t != e[0]))
      throw new Error("Invalid indent unit: " + JSON.stringify(n[0]));
    return e;
  }
});
function rw(n) {
  let e = n.facet(bx);
  return e.charCodeAt(0) == 9 ? n.tabSize * e.length : e.length;
}
function e1(n, e) {
  let t = "", r = n.tabSize, i = n.facet(bx)[0];
  if (i == "	") {
    for (; e >= r; )
      t += "	", e -= r;
    i = " ";
  }
  for (let s = 0; s < e; s++)
    t += i;
  return t;
}
function rI(n, e) {
  n instanceof Ht && (n = new wx(n));
  for (let r of n.state.facet(A1t)) {
    let i = r(n, e);
    if (i !== void 0)
      return i;
  }
  let t = ai(n.state);
  return t.length >= e ? M1t(n, t, e) : null;
}
class wx {
  /**
  Create an indent context.
  */
  constructor(e, t = {}) {
    this.state = e, this.options = t, this.unit = rw(e);
  }
  /**
  Get a description of the line at the given position, taking
  [simulated line
  breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  into account. If there is such a break at `pos`, the `bias`
  argument determines whether the part of the line line before or
  after the break is used.
  */
  lineAt(e, t = 1) {
    let r = this.state.doc.lineAt(e), { simulateBreak: i, simulateDoubleBreak: s } = this.options;
    return i != null && i >= r.from && i <= r.to ? s && i == e ? { text: "", from: e } : (t < 0 ? i < e : i <= e) ? { text: r.text.slice(i - r.from), from: i } : { text: r.text.slice(0, i - r.from), from: r.from } : r;
  }
  /**
  Get the text directly after `pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  textAfterPos(e, t = 1) {
    if (this.options.simulateDoubleBreak && e == this.options.simulateBreak)
      return "";
    let { text: r, from: i } = this.lineAt(e, t);
    return r.slice(e - i, Math.min(r.length, e + 100 - i));
  }
  /**
  Find the column for the given position.
  */
  column(e, t = 1) {
    let { text: r, from: i } = this.lineAt(e, t), s = this.countColumn(r, e - i), o = this.options.overrideIndentation ? this.options.overrideIndentation(i) : -1;
    return o > -1 && (s += o - this.countColumn(r, r.search(/\S|$/))), s;
  }
  /**
  Find the column position (taking tabs into account) of the given
  position in the given string.
  */
  countColumn(e, t = e.length) {
    return Vh(e, this.state.tabSize, t);
  }
  /**
  Find the indentation column of the line at the given point.
  */
  lineIndent(e, t = 1) {
    let { text: r, from: i } = this.lineAt(e, t), s = this.options.overrideIndentation;
    if (s) {
      let o = s(i);
      if (o > -1)
        return o;
    }
    return this.countColumn(r, r.search(/\S|$/));
  }
  /**
  Returns the [simulated line
  break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  for this context, if any.
  */
  get simulatedBreak() {
    return this.options.simulateBreak || null;
  }
}
const zce = /* @__PURE__ */ new Lt();
function M1t(n, e, t) {
  let r = e.resolveStack(t), i = e.resolveInner(t, -1).resolve(t, 0).enterUnfinishedNodesBefore(t);
  if (i != r.node) {
    let s = [];
    for (let o = i; o && !(o.from < r.node.from || o.to > r.node.to || o.from == r.node.from && o.type == r.node.type); o = o.parent)
      s.push(o);
    for (let o = s.length - 1; o >= 0; o--)
      r = { node: s[o], next: r };
  }
  return Hce(r, n, t);
}
function Hce(n, e, t) {
  for (let r = n; r; r = r.next) {
    let i = _1t(r.node);
    if (i)
      return i(iI.create(e, t, r));
  }
  return 0;
}
function k1t(n) {
  return n.pos == n.options.simulateBreak && n.options.simulateDoubleBreak;
}
function _1t(n) {
  let e = n.type.prop(zce);
  if (e)
    return e;
  let t = n.firstChild, r;
  if (t && (r = t.type.prop(Lt.closedBy))) {
    let i = n.lastChild, s = i && r.indexOf(i.name) > -1;
    return (o) => P1t(o, !0, 1, void 0, s && !k1t(o) ? i.from : void 0);
  }
  return n.parent == null ? O1t : null;
}
function O1t() {
  return 0;
}
class iI extends wx {
  constructor(e, t, r) {
    super(e.state, e.options), this.base = e, this.pos = t, this.context = r;
  }
  /**
  The syntax tree node to which the indentation strategy
  applies.
  */
  get node() {
    return this.context.node;
  }
  /**
  @internal
  */
  static create(e, t, r) {
    return new iI(e, t, r);
  }
  /**
  Get the text directly after `this.pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  get textAfter() {
    return this.textAfterPos(this.pos);
  }
  /**
  Get the indentation at the reference line for `this.node`, which
  is the line on which it starts, unless there is a node that is
  _not_ a parent of this node covering the start of that line. If
  so, the line at the start of that node is tried, again skipping
  on if it is covered by another such node.
  */
  get baseIndent() {
    return this.baseIndentFor(this.node);
  }
  /**
  Get the indentation for the reference line of the given node
  (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
  */
  baseIndentFor(e) {
    let t = this.state.doc.lineAt(e.from);
    for (; ; ) {
      let r = e.resolve(t.from);
      for (; r.parent && r.parent.from == r.from; )
        r = r.parent;
      if (I1t(r, e))
        break;
      t = this.state.doc.lineAt(r.from);
    }
    return this.lineIndent(t.from);
  }
  /**
  Continue looking for indentations in the node's parent nodes,
  and return the result of that.
  */
  continue() {
    return Hce(this.context.next, this.base, this.pos);
  }
}
function I1t(n, e) {
  for (let t = e; t; t = t.parent)
    if (n == t)
      return !0;
  return !1;
}
function R1t(n) {
  let e = n.node, t = e.childAfter(e.from), r = e.lastChild;
  if (!t)
    return null;
  let i = n.options.simulateBreak, s = n.state.doc.lineAt(t.from), o = i == null || i <= s.from ? s.to : Math.min(s.to, i);
  for (let a = t.to; ; ) {
    let l = e.childAfter(a);
    if (!l || l == r)
      return null;
    if (!l.type.isSkipped) {
      if (l.from >= o)
        return null;
      let c = /^ */.exec(s.text.slice(t.to - s.from))[0].length;
      return { from: t.from, to: t.to + c };
    }
    a = l.to;
  }
}
function P1t(n, e, t, r, i) {
  let s = n.textAfter, o = s.match(/^\s*/)[0].length, a = r && s.slice(o, o + r.length) == r || i == n.pos + o, l = R1t(n);
  return l ? a ? n.column(l.from) : n.column(l.to) : n.baseIndent + (a ? 0 : n.unit * t);
}
function IW({ except: n, units: e = 1 } = {}) {
  return (t) => {
    let r = n && n.test(t.textAfter);
    return t.baseIndent + (r ? 0 : e * t.unit);
  };
}
const D1t = 200;
function N1t() {
  return Ht.transactionFilter.of((n) => {
    if (!n.docChanged || !n.isUserEvent("input.type") && !n.isUserEvent("input.complete"))
      return n;
    let e = n.startState.languageDataAt("indentOnInput", n.startState.selection.main.head);
    if (!e.length)
      return n;
    let t = n.newDoc, { head: r } = n.newSelection.main, i = t.lineAt(r);
    if (r > i.from + D1t)
      return n;
    let s = t.sliceString(i.from, r);
    if (!e.some((c) => c.test(s)))
      return n;
    let { state: o } = n, a = -1, l = [];
    for (let { head: c } of o.selection.ranges) {
      let u = o.doc.lineAt(c);
      if (u.from == a)
        continue;
      a = u.from;
      let d = rI(o, u.from);
      if (d == null)
        continue;
      let f = /^\s*/.exec(u.text)[0], h = e1(o, d);
      f != h && l.push({ from: u.from, to: u.from + f.length, insert: h });
    }
    return l.length ? [n, { changes: l, sequential: !0 }] : n;
  });
}
const L1t = /* @__PURE__ */ je.define(), Uce = /* @__PURE__ */ new Lt();
function $1t(n) {
  let e = n.firstChild, t = n.lastChild;
  return e && e.to < t.from ? { from: e.to, to: t.type.isError ? n.to : t.from } : null;
}
function F1t(n, e, t) {
  let r = ai(n);
  if (r.length < t)
    return null;
  let i = r.resolveStack(t, 1), s = null;
  for (let o = i; o; o = o.next) {
    let a = o.node;
    if (a.to <= t || a.from > t)
      continue;
    if (s && a.from < e)
      break;
    let l = a.type.prop(Uce);
    if (l && (a.to < r.length - 50 || r.length == n.doc.length || !B1t(a))) {
      let c = l(a, n);
      c && c.from <= t && c.from >= e && c.to > t && (s = c);
    }
  }
  return s;
}
function B1t(n) {
  let e = n.lastChild;
  return e && e.to == n.to && e.type.isError;
}
function iw(n, e, t) {
  for (let r of n.facet(L1t)) {
    let i = r(n, e, t);
    if (i)
      return i;
  }
  return F1t(n, e, t);
}
function Vce(n, e) {
  let t = e.mapPos(n.from, 1), r = e.mapPos(n.to, -1);
  return t >= r ? void 0 : { from: t, to: r };
}
const xx = /* @__PURE__ */ At.define({ map: Vce }), K1 = /* @__PURE__ */ At.define({ map: Vce });
function jce(n) {
  let e = [];
  for (let { head: t } of n.state.selection.ranges)
    e.some((r) => r.from <= t && r.to >= t) || e.push(n.lineBlockAt(t));
  return e;
}
const Xu = /* @__PURE__ */ Xr.define({
  create() {
    return ct.none;
  },
  update(n, e) {
    e.isUserEvent("delete") && e.changes.iterChangedRanges((t, r) => n = RW(n, t, r)), n = n.map(e.changes);
    for (let t of e.effects)
      if (t.is(xx) && !z1t(n, t.value.from, t.value.to)) {
        let { preparePlaceholder: r } = e.state.facet(Kce), i = r ? ct.replace({ widget: new K1t(r(e.state, t.value)) }) : PW;
        n = n.update({ add: [i.range(t.value.from, t.value.to)] });
      } else t.is(K1) && (n = n.update({
        filter: (r, i) => t.value.from != r || t.value.to != i,
        filterFrom: t.value.from,
        filterTo: t.value.to
      }));
    return e.selection && (n = RW(n, e.selection.main.head)), n;
  },
  provide: (n) => Be.decorations.from(n),
  toJSON(n, e) {
    let t = [];
    return n.between(0, e.doc.length, (r, i) => {
      t.push(r, i);
    }), t;
  },
  fromJSON(n) {
    if (!Array.isArray(n) || n.length % 2)
      throw new RangeError("Invalid JSON for fold state");
    let e = [];
    for (let t = 0; t < n.length; ) {
      let r = n[t++], i = n[t++];
      if (typeof r != "number" || typeof i != "number")
        throw new RangeError("Invalid JSON for fold state");
      e.push(PW.range(r, i));
    }
    return ct.set(e, !0);
  }
});
function RW(n, e, t = e) {
  let r = !1;
  return n.between(e, t, (i, s) => {
    i < t && s > e && (r = !0);
  }), r ? n.update({
    filterFrom: e,
    filterTo: t,
    filter: (i, s) => i >= t || s <= e
  }) : n;
}
function sw(n, e, t) {
  var r;
  let i = null;
  return (r = n.field(Xu, !1)) === null || r === void 0 || r.between(e, t, (s, o) => {
    (!i || i.from > s) && (i = { from: s, to: o });
  }), i;
}
function z1t(n, e, t) {
  let r = !1;
  return n.between(e, e, (i, s) => {
    i == e && s == t && (r = !0);
  }), r;
}
function Wce(n, e) {
  return n.field(Xu, !1) ? e : e.concat(At.appendConfig.of(qce()));
}
const H1t = (n) => {
  for (let e of jce(n)) {
    let t = iw(n.state, e.from, e.to);
    if (t)
      return n.dispatch({ effects: Wce(n.state, [xx.of(t), Gce(n, t)]) }), !0;
  }
  return !1;
}, U1t = (n) => {
  if (!n.state.field(Xu, !1))
    return !1;
  let e = [];
  for (let t of jce(n)) {
    let r = sw(n.state, t.from, t.to);
    r && e.push(K1.of(r), Gce(n, r, !1));
  }
  return e.length && n.dispatch({ effects: e }), e.length > 0;
};
function Gce(n, e, t = !0) {
  let r = n.state.doc.lineAt(e.from).number, i = n.state.doc.lineAt(e.to).number;
  return Be.announce.of(`${n.state.phrase(t ? "Folded lines" : "Unfolded lines")} ${r} ${n.state.phrase("to")} ${i}.`);
}
const V1t = (n) => {
  let { state: e } = n, t = [];
  for (let r = 0; r < e.doc.length; ) {
    let i = n.lineBlockAt(r), s = iw(e, i.from, i.to);
    s && t.push(xx.of(s)), r = (s ? n.lineBlockAt(s.to) : i).to + 1;
  }
  return t.length && n.dispatch({ effects: Wce(n.state, t) }), !!t.length;
}, j1t = (n) => {
  let e = n.state.field(Xu, !1);
  if (!e || !e.size)
    return !1;
  let t = [];
  return e.between(0, n.state.doc.length, (r, i) => {
    t.push(K1.of({ from: r, to: i }));
  }), n.dispatch({ effects: t }), !0;
}, W1t = [
  { key: "Ctrl-Shift-[", mac: "Cmd-Alt-[", run: H1t },
  { key: "Ctrl-Shift-]", mac: "Cmd-Alt-]", run: U1t },
  { key: "Ctrl-Alt-[", run: V1t },
  { key: "Ctrl-Alt-]", run: j1t }
], G1t = {
  placeholderDOM: null,
  preparePlaceholder: null,
  placeholderText: "…"
}, Kce = /* @__PURE__ */ je.define({
  combine(n) {
    return ka(n, G1t);
  }
});
function qce(n) {
  return [Xu, X1t];
}
function Yce(n, e) {
  let { state: t } = n, r = t.facet(Kce), i = (o) => {
    let a = n.lineBlockAt(n.posAtDOM(o.target)), l = sw(n.state, a.from, a.to);
    l && n.dispatch({ effects: K1.of(l) }), o.preventDefault();
  };
  if (r.placeholderDOM)
    return r.placeholderDOM(n, i, e);
  let s = document.createElement("span");
  return s.textContent = r.placeholderText, s.setAttribute("aria-label", t.phrase("folded code")), s.title = t.phrase("unfold"), s.className = "cm-foldPlaceholder", s.onclick = i, s;
}
const PW = /* @__PURE__ */ ct.replace({ widget: /* @__PURE__ */ new class extends Sl {
  toDOM(n) {
    return Yce(n, null);
  }
}() });
class K1t extends Sl {
  constructor(e) {
    super(), this.value = e;
  }
  eq(e) {
    return this.value == e.value;
  }
  toDOM(e) {
    return Yce(e, this.value);
  }
}
const q1t = {
  openText: "⌄",
  closedText: "›",
  markerDOM: null,
  domEventHandlers: {},
  foldingChanged: () => !1
};
class q8 extends vl {
  constructor(e, t) {
    super(), this.config = e, this.open = t;
  }
  eq(e) {
    return this.config == e.config && this.open == e.open;
  }
  toDOM(e) {
    if (this.config.markerDOM)
      return this.config.markerDOM(this.open);
    let t = document.createElement("span");
    return t.textContent = this.open ? this.config.openText : this.config.closedText, t.title = e.state.phrase(this.open ? "Fold line" : "Unfold line"), t;
  }
}
function Y1t(n = {}) {
  let e = { ...q1t, ...n }, t = new q8(e, !0), r = new q8(e, !1), i = nr.fromClass(class {
    constructor(o) {
      this.from = o.viewport.from, this.markers = this.buildMarkers(o);
    }
    update(o) {
      (o.docChanged || o.viewportChanged || o.startState.facet(Ec) != o.state.facet(Ec) || o.startState.field(Xu, !1) != o.state.field(Xu, !1) || ai(o.startState) != ai(o.state) || e.foldingChanged(o)) && (this.markers = this.buildMarkers(o.view));
    }
    buildMarkers(o) {
      let a = new ml();
      for (let l of o.viewportLineBlocks) {
        let c = sw(o.state, l.from, l.to) ? r : iw(o.state, l.from, l.to) ? t : null;
        c && a.add(l.from, l.from, c);
      }
      return a.finish();
    }
  }), { domEventHandlers: s } = e;
  return [
    i,
    u1t({
      class: "cm-foldGutter",
      markers(o) {
        var a;
        return ((a = o.plugin(i)) === null || a === void 0 ? void 0 : a.markers) || Vt.empty;
      },
      initialSpacer() {
        return new q8(e, !1);
      },
      domEventHandlers: {
        ...s,
        click: (o, a, l) => {
          if (s.click && s.click(o, a, l))
            return !0;
          let c = sw(o.state, a.from, a.to);
          if (c)
            return o.dispatch({ effects: K1.of(c) }), !0;
          let u = iw(o.state, a.from, a.to);
          return u ? (o.dispatch({ effects: xx.of(u) }), !0) : !1;
        }
      }
    }),
    qce()
  ];
}
const X1t = /* @__PURE__ */ Be.baseTheme({
  ".cm-foldPlaceholder": {
    backgroundColor: "#eee",
    border: "1px solid #ddd",
    color: "#888",
    borderRadius: ".2em",
    margin: "0 1px",
    padding: "0 1px",
    cursor: "pointer"
  },
  ".cm-foldGutter span": {
    padding: "0 1px",
    cursor: "pointer"
  }
});
class jh {
  constructor(e, t) {
    this.specs = e;
    let r;
    function i(a) {
      let l = wc.newName();
      return (r || (r = /* @__PURE__ */ Object.create(null)))["." + l] = a, l;
    }
    const s = typeof t.all == "string" ? t.all : t.all ? i(t.all) : void 0, o = t.scope;
    this.scope = o instanceof mo ? (a) => a.prop(ef) == o.data : o ? (a) => a == o : void 0, this.style = ule(e.map((a) => ({
      tag: a.tag,
      class: a.class || i(Object.assign({}, a, { tag: null }))
    })), {
      all: s
    }).style, this.module = r ? new wc(r) : null, this.themeType = t.themeType;
  }
  /**
  Create a highlighter style that associates the given styles to
  the given tags. The specs must be objects that hold a style tag
  or array of tags in their `tag` property, and either a single
  `class` property providing a static CSS class (for highlighter
  that rely on external styling), or a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)-style
  set of CSS properties (which define the styling for those tags).
  
  The CSS rules created for a highlighter will be emitted in the
  order of the spec's properties. That means that for elements that
  have multiple tags associated with them, styles defined further
  down in the list will have a higher CSS precedence than styles
  defined earlier.
  */
  static define(e, t) {
    return new jh(e, t || {});
  }
}
const dA = /* @__PURE__ */ je.define(), Xce = /* @__PURE__ */ je.define({
  combine(n) {
    return n.length ? [n[0]] : null;
  }
});
function Y8(n) {
  let e = n.facet(dA);
  return e.length ? e : n.facet(Xce);
}
function sI(n, e) {
  let t = [Q1t], r;
  return n instanceof jh && (n.module && t.push(Be.styleModule.of(n.module)), r = n.themeType), e?.fallback ? t.push(Xce.of(n)) : r ? t.push(dA.computeN([Be.darkTheme], (i) => i.facet(Be.darkTheme) == (r == "dark") ? [n] : [])) : t.push(dA.of(n)), t;
}
class Z1t {
  constructor(e) {
    this.markCache = /* @__PURE__ */ Object.create(null), this.tree = ai(e.state), this.decorations = this.buildDeco(e, Y8(e.state)), this.decoratedTo = e.viewport.to;
  }
  update(e) {
    let t = ai(e.state), r = Y8(e.state), i = r != Y8(e.startState), { viewport: s } = e.view, o = e.changes.mapPos(this.decoratedTo, 1);
    t.length < s.to && !i && t.type == this.tree.type && o >= s.to ? (this.decorations = this.decorations.map(e.changes), this.decoratedTo = o) : (t != this.tree || e.viewportChanged || i) && (this.tree = t, this.decorations = this.buildDeco(e.view, r), this.decoratedTo = s.to);
  }
  buildDeco(e, t) {
    if (!t || !this.tree.length)
      return ct.none;
    let r = new ml();
    for (let { from: i, to: s } of e.visibleRanges)
      ypt(this.tree, t, (o, a, l) => {
        r.add(o, a, this.markCache[l] || (this.markCache[l] = ct.mark({ class: l })));
      }, i, s);
    return r.finish();
  }
}
const Q1t = /* @__PURE__ */ hd.high(/* @__PURE__ */ nr.fromClass(Z1t, {
  decorations: (n) => n.decorations
})), J1t = /* @__PURE__ */ jh.define([
  {
    tag: Y.meta,
    color: "#404740"
  },
  {
    tag: Y.link,
    textDecoration: "underline"
  },
  {
    tag: Y.heading,
    textDecoration: "underline",
    fontWeight: "bold"
  },
  {
    tag: Y.emphasis,
    fontStyle: "italic"
  },
  {
    tag: Y.strong,
    fontWeight: "bold"
  },
  {
    tag: Y.strikethrough,
    textDecoration: "line-through"
  },
  {
    tag: Y.keyword,
    color: "#708"
  },
  {
    tag: [Y.atom, Y.bool, Y.url, Y.contentSeparator, Y.labelName],
    color: "#219"
  },
  {
    tag: [Y.literal, Y.inserted],
    color: "#164"
  },
  {
    tag: [Y.string, Y.deleted],
    color: "#a11"
  },
  {
    tag: [Y.regexp, Y.escape, /* @__PURE__ */ Y.special(Y.string)],
    color: "#e40"
  },
  {
    tag: /* @__PURE__ */ Y.definition(Y.variableName),
    color: "#00f"
  },
  {
    tag: /* @__PURE__ */ Y.local(Y.variableName),
    color: "#30a"
  },
  {
    tag: [Y.typeName, Y.namespace],
    color: "#085"
  },
  {
    tag: Y.className,
    color: "#167"
  },
  {
    tag: [/* @__PURE__ */ Y.special(Y.variableName), Y.macroName],
    color: "#256"
  },
  {
    tag: /* @__PURE__ */ Y.definition(Y.propertyName),
    color: "#00c"
  },
  {
    tag: Y.comment,
    color: "#940"
  },
  {
    tag: Y.invalid,
    color: "#f00"
  }
]), egt = /* @__PURE__ */ Be.baseTheme({
  "&.cm-focused .cm-matchingBracket": { backgroundColor: "#328c8252" },
  "&.cm-focused .cm-nonmatchingBracket": { backgroundColor: "#bb555544" }
}), Zce = 1e4, Qce = "()[]{}", Jce = /* @__PURE__ */ je.define({
  combine(n) {
    return ka(n, {
      afterCursor: !0,
      brackets: Qce,
      maxScanDistance: Zce,
      renderMatch: rgt
    });
  }
}), tgt = /* @__PURE__ */ ct.mark({ class: "cm-matchingBracket" }), ngt = /* @__PURE__ */ ct.mark({ class: "cm-nonmatchingBracket" });
function rgt(n) {
  let e = [], t = n.matched ? tgt : ngt;
  return e.push(t.range(n.start.from, n.start.to)), n.end && e.push(t.range(n.end.from, n.end.to)), e;
}
const igt = /* @__PURE__ */ Xr.define({
  create() {
    return ct.none;
  },
  update(n, e) {
    if (!e.docChanged && !e.selection)
      return n;
    let t = [], r = e.state.facet(Jce);
    for (let i of e.state.selection.ranges) {
      if (!i.empty)
        continue;
      let s = aa(e.state, i.head, -1, r) || i.head > 0 && aa(e.state, i.head - 1, 1, r) || r.afterCursor && (aa(e.state, i.head, 1, r) || i.head < e.state.doc.length && aa(e.state, i.head + 1, -1, r));
      s && (t = t.concat(r.renderMatch(s, e.state)));
    }
    return ct.set(t, !0);
  },
  provide: (n) => Be.decorations.from(n)
}), sgt = [
  igt,
  egt
];
function ogt(n = {}) {
  return [Jce.of(n), sgt];
}
const agt = /* @__PURE__ */ new Lt();
function fA(n, e, t) {
  let r = n.prop(e < 0 ? Lt.openedBy : Lt.closedBy);
  if (r)
    return r;
  if (n.name.length == 1) {
    let i = t.indexOf(n.name);
    if (i > -1 && i % 2 == (e < 0 ? 1 : 0))
      return [t[i + e]];
  }
  return null;
}
function hA(n) {
  let e = n.type.prop(agt);
  return e ? e(n.node) : n;
}
function aa(n, e, t, r = {}) {
  let i = r.maxScanDistance || Zce, s = r.brackets || Qce, o = ai(n), a = o.resolveInner(e, t);
  for (let l = a; l; l = l.parent) {
    let c = fA(l.type, t, s);
    if (c && l.from < l.to) {
      let u = hA(l);
      if (u && (t > 0 ? e >= u.from && e < u.to : e > u.from && e <= u.to))
        return lgt(n, e, t, l, u, c, s);
    }
  }
  return cgt(n, e, t, o, a.type, i, s);
}
function lgt(n, e, t, r, i, s, o) {
  let a = r.parent, l = { from: i.from, to: i.to }, c = 0, u = a?.cursor();
  if (u && (t < 0 ? u.childBefore(r.from) : u.childAfter(r.to)))
    do
      if (t < 0 ? u.to <= r.from : u.from >= r.to) {
        if (c == 0 && s.indexOf(u.type.name) > -1 && u.from < u.to) {
          let d = hA(u);
          return { start: l, end: d ? { from: d.from, to: d.to } : void 0, matched: !0 };
        } else if (fA(u.type, t, o))
          c++;
        else if (fA(u.type, -t, o)) {
          if (c == 0) {
            let d = hA(u);
            return {
              start: l,
              end: d && d.from < d.to ? { from: d.from, to: d.to } : void 0,
              matched: !1
            };
          }
          c--;
        }
      }
    while (t < 0 ? u.prevSibling() : u.nextSibling());
  return { start: l, matched: !1 };
}
function cgt(n, e, t, r, i, s, o) {
  let a = t < 0 ? n.sliceDoc(e - 1, e) : n.sliceDoc(e, e + 1), l = o.indexOf(a);
  if (l < 0 || l % 2 == 0 != t > 0)
    return null;
  let c = { from: t < 0 ? e - 1 : e, to: t > 0 ? e + 1 : e }, u = n.doc.iterRange(e, t > 0 ? n.doc.length : 0), d = 0;
  for (let f = 0; !u.next().done && f <= s; ) {
    let h = u.value;
    t < 0 && (f += h.length);
    let m = e + f * t;
    for (let g = t > 0 ? 0 : h.length - 1, v = t > 0 ? h.length : -1; g != v; g += t) {
      let y = o.indexOf(h[g]);
      if (!(y < 0 || r.resolveInner(m + g, 1).type != i))
        if (y % 2 == 0 == t > 0)
          d++;
        else {
          if (d == 1)
            return { start: c, end: { from: m + g, to: m + g + 1 }, matched: y >> 1 == l >> 1 };
          d--;
        }
    }
    t > 0 && (f += h.length);
  }
  return u.done ? { start: c, matched: !1 } : null;
}
const ugt = /* @__PURE__ */ Object.create(null), DW = [ji.none], NW = [], LW = /* @__PURE__ */ Object.create(null), dgt = /* @__PURE__ */ Object.create(null);
for (let [n, e] of [
  ["variable", "variableName"],
  ["variable-2", "variableName.special"],
  ["string-2", "string.special"],
  ["def", "variableName.definition"],
  ["tag", "tagName"],
  ["attribute", "attributeName"],
  ["type", "typeName"],
  ["builtin", "variableName.standard"],
  ["qualifier", "modifier"],
  ["error", "invalid"],
  ["header", "heading"],
  ["property", "propertyName"]
])
  dgt[n] = /* @__PURE__ */ fgt(ugt, e);
function X8(n, e) {
  NW.indexOf(n) > -1 || (NW.push(n), console.warn(e));
}
function fgt(n, e) {
  let t = [];
  for (let a of e.split(" ")) {
    let l = [];
    for (let c of a.split(".")) {
      let u = n[c] || Y[c];
      u ? typeof u == "function" ? l.length ? l = l.map(u) : X8(c, `Modifier ${c} used at start of tag`) : l.length ? X8(c, `Tag ${c} used as modifier`) : l = Array.isArray(u) ? u : [u] : X8(c, `Unknown highlighting tag ${c}`);
    }
    for (let c of l)
      t.push(c);
  }
  if (!t.length)
    return 0;
  let r = e.replace(/ /g, "_"), i = r + " " + t.map((a) => a.id), s = LW[i];
  if (s)
    return s.id;
  let o = LW[i] = ji.define({
    id: DW.length,
    name: r,
    props: [lle({ [r]: t })]
  });
  return DW.push(o), o.id;
}
Dn.RTL, Dn.LTR;
const hgt = /* @__PURE__ */ tw.define({
  name: "json",
  parser: /* @__PURE__ */ Ept.configure({
    props: [
      /* @__PURE__ */ zce.add({
        Object: /* @__PURE__ */ IW({ except: /^\s*\}/ }),
        Array: /* @__PURE__ */ IW({ except: /^\s*\]/ })
      }),
      /* @__PURE__ */ Uce.add({
        "Object Array": $1t
      })
    ]
  }),
  languageData: {
    closeBrackets: { brackets: ["[", "{", '"'] },
    indentOnInput: /^\s*[\}\]]$/
  }
});
function pgt() {
  return new T1t(hgt);
}
var eue = (n) => {
  var {
    theme: e,
    settings: t = {},
    styles: r = []
  } = n, i = {
    ".cm-gutters": {}
  }, s = {};
  t.background && (s.backgroundColor = t.background), t.backgroundImage && (s.backgroundImage = t.backgroundImage), t.foreground && (s.color = t.foreground), t.fontSize && (s.fontSize = t.fontSize), (t.background || t.foreground) && (i["&"] = s), t.fontFamily && (i["&.cm-editor .cm-scroller"] = {
    fontFamily: t.fontFamily
  }), t.gutterBackground && (i[".cm-gutters"].backgroundColor = t.gutterBackground), t.gutterForeground && (i[".cm-gutters"].color = t.gutterForeground), t.gutterBorder && (i[".cm-gutters"].borderRightColor = t.gutterBorder), t.caret && (i[".cm-content"] = {
    caretColor: t.caret
  }, i[".cm-cursor, .cm-dropCursor"] = {
    borderLeftColor: t.caret
  });
  var o = {};
  t.gutterActiveForeground && (o.color = t.gutterActiveForeground), t.lineHighlight && (i[".cm-activeLine"] = {
    backgroundColor: t.lineHighlight
  }, o.backgroundColor = t.lineHighlight), i[".cm-activeLineGutter"] = o, t.selection && (i["&.cm-focused .cm-selectionBackground, & .cm-line::selection, & .cm-selectionLayer .cm-selectionBackground, .cm-content ::selection"] = {
    background: t.selection + " !important"
  }), t.selectionMatch && (i["& .cm-selectionMatch"] = {
    backgroundColor: t.selectionMatch
  });
  var a = Be.theme(i, {
    dark: e === "dark"
  }), l = jh.define(r), c = [a, sI(l)];
  return c;
}, mgt = {
  background: "#ffffff",
  foreground: "#383a42",
  caret: "#000",
  selection: "#add6ff",
  selectionMatch: "#a8ac94",
  lineHighlight: "#99999926",
  gutterBackground: "#fff",
  gutterForeground: "#237893",
  gutterActiveForeground: "#0b216f",
  fontFamily: 'Menlo, Monaco, Consolas, "Andale Mono", "Ubuntu Mono", "Courier New", monospace'
}, ggt = [{
  tag: [Y.keyword, Y.operatorKeyword, Y.modifier, Y.color, Y.constant(Y.name), Y.standard(Y.name), Y.standard(Y.tagName), Y.special(Y.brace), Y.atom, Y.bool, Y.special(Y.variableName)],
  color: "#0000ff"
}, {
  tag: [Y.moduleKeyword, Y.controlKeyword],
  color: "#af00db"
}, {
  tag: [Y.name, Y.deleted, Y.character, Y.macroName, Y.propertyName, Y.variableName, Y.labelName, Y.definition(Y.name)],
  color: "#0070c1"
}, {
  tag: Y.heading,
  fontWeight: "bold",
  color: "#0070c1"
}, {
  tag: [Y.typeName, Y.className, Y.tagName, Y.number, Y.changed, Y.annotation, Y.self, Y.namespace],
  color: "#267f99"
}, {
  tag: [Y.function(Y.variableName), Y.function(Y.propertyName)],
  color: "#795e26"
}, {
  tag: [Y.number],
  color: "#098658"
}, {
  tag: [Y.operator, Y.punctuation, Y.separator, Y.url, Y.escape, Y.regexp],
  color: "#383a42"
}, {
  tag: [Y.regexp],
  color: "#af00db"
}, {
  tag: [Y.special(Y.string), Y.processingInstruction, Y.string, Y.inserted],
  color: "#a31515"
}, {
  tag: [Y.angleBracket],
  color: "#383a42"
}, {
  tag: Y.strong,
  fontWeight: "bold"
}, {
  tag: Y.emphasis,
  fontStyle: "italic"
}, {
  tag: Y.strikethrough,
  textDecoration: "line-through"
}, {
  tag: [Y.meta, Y.comment],
  color: "#008000"
}, {
  tag: Y.link,
  color: "#4078f2",
  textDecoration: "underline"
}, {
  tag: Y.invalid,
  color: "#e45649"
}];
function vgt(n) {
  var {
    theme: e = "light",
    settings: t = {},
    styles: r = []
  } = {};
  return eue({
    theme: e,
    settings: Um({}, mgt, t),
    styles: [...ggt, ...r]
  });
}
var ygt = vgt(), bgt = {
  background: "#1e1e1e",
  foreground: "#9cdcfe",
  caret: "#c6c6c6",
  selection: "#6199ff2f",
  selectionMatch: "#72a1ff59",
  lineHighlight: "#ffffff0f",
  gutterBackground: "#1e1e1e",
  gutterForeground: "#838383",
  gutterActiveForeground: "#fff",
  fontFamily: 'Menlo, Monaco, Consolas, "Andale Mono", "Ubuntu Mono", "Courier New", monospace'
}, wgt = [{
  tag: [Y.keyword, Y.operatorKeyword, Y.modifier, Y.color, Y.constant(Y.name), Y.standard(Y.name), Y.standard(Y.tagName), Y.special(Y.brace), Y.atom, Y.bool, Y.special(Y.variableName)],
  color: "#569cd6"
}, {
  tag: [Y.controlKeyword, Y.moduleKeyword],
  color: "#c586c0"
}, {
  tag: [Y.name, Y.deleted, Y.character, Y.macroName, Y.propertyName, Y.variableName, Y.labelName, Y.definition(Y.name)],
  color: "#9cdcfe"
}, {
  tag: Y.heading,
  fontWeight: "bold",
  color: "#9cdcfe"
}, {
  tag: [Y.typeName, Y.className, Y.tagName, Y.number, Y.changed, Y.annotation, Y.self, Y.namespace],
  color: "#4ec9b0"
}, {
  tag: [Y.function(Y.variableName), Y.function(Y.propertyName)],
  color: "#dcdcaa"
}, {
  tag: [Y.number],
  color: "#b5cea8"
}, {
  tag: [Y.operator, Y.punctuation, Y.separator, Y.url, Y.escape, Y.regexp],
  color: "#d4d4d4"
}, {
  tag: [Y.regexp],
  color: "#d16969"
}, {
  tag: [Y.special(Y.string), Y.processingInstruction, Y.string, Y.inserted],
  color: "#ce9178"
}, {
  tag: [Y.angleBracket],
  color: "#808080"
}, {
  tag: Y.strong,
  fontWeight: "bold"
}, {
  tag: Y.emphasis,
  fontStyle: "italic"
}, {
  tag: Y.strikethrough,
  textDecoration: "line-through"
}, {
  tag: [Y.meta, Y.comment],
  color: "#6a9955"
}, {
  tag: Y.link,
  color: "#6a9955",
  textDecoration: "underline"
}, {
  tag: Y.invalid,
  color: "#ff0000"
}];
function xgt(n) {
  var {
    theme: e = "dark",
    settings: t = {},
    styles: r = []
  } = {};
  return eue({
    theme: e,
    settings: Um({}, bgt, t),
    styles: [...wgt, ...r]
  });
}
var Egt = xgt();
const Sgt = (n) => {
  let { state: e } = n, t = e.doc.lineAt(e.selection.main.from), r = aI(n.state, t.from);
  return r.line ? Cgt(n) : r.block ? Agt(n) : !1;
};
function oI(n, e) {
  return ({ state: t, dispatch: r }) => {
    if (t.readOnly)
      return !1;
    let i = n(e, t);
    return i ? (r(t.update(i)), !0) : !1;
  };
}
const Cgt = /* @__PURE__ */ oI(
  _gt,
  0
  /* CommentOption.Toggle */
), Tgt = /* @__PURE__ */ oI(
  tue,
  0
  /* CommentOption.Toggle */
), Agt = /* @__PURE__ */ oI(
  (n, e) => tue(n, e, kgt(e)),
  0
  /* CommentOption.Toggle */
);
function aI(n, e) {
  let t = n.languageDataAt("commentTokens", e, 1);
  return t.length ? t[0] : {};
}
const Ep = 50;
function Mgt(n, { open: e, close: t }, r, i) {
  let s = n.sliceDoc(r - Ep, r), o = n.sliceDoc(i, i + Ep), a = /\s*$/.exec(s)[0].length, l = /^\s*/.exec(o)[0].length, c = s.length - a;
  if (s.slice(c - e.length, c) == e && o.slice(l, l + t.length) == t)
    return {
      open: { pos: r - a, margin: a && 1 },
      close: { pos: i + l, margin: l && 1 }
    };
  let u, d;
  i - r <= 2 * Ep ? u = d = n.sliceDoc(r, i) : (u = n.sliceDoc(r, r + Ep), d = n.sliceDoc(i - Ep, i));
  let f = /^\s*/.exec(u)[0].length, h = /\s*$/.exec(d)[0].length, m = d.length - h - t.length;
  return u.slice(f, f + e.length) == e && d.slice(m, m + t.length) == t ? {
    open: {
      pos: r + f + e.length,
      margin: /\s/.test(u.charAt(f + e.length)) ? 1 : 0
    },
    close: {
      pos: i - h - t.length,
      margin: /\s/.test(d.charAt(m - 1)) ? 1 : 0
    }
  } : null;
}
function kgt(n) {
  let e = [];
  for (let t of n.selection.ranges) {
    let r = n.doc.lineAt(t.from), i = t.to <= r.to ? r : n.doc.lineAt(t.to);
    i.from > r.from && i.from == t.to && (i = t.to == r.to + 1 ? r : n.doc.lineAt(t.to - 1));
    let s = e.length - 1;
    s >= 0 && e[s].to > r.from ? e[s].to = i.to : e.push({ from: r.from + /^\s*/.exec(r.text)[0].length, to: i.to });
  }
  return e;
}
function tue(n, e, t = e.selection.ranges) {
  let r = t.map((s) => aI(e, s.from).block);
  if (!r.every((s) => s))
    return null;
  let i = t.map((s, o) => Mgt(e, r[o], s.from, s.to));
  if (n != 2 && !i.every((s) => s))
    return { changes: e.changes(t.map((s, o) => i[o] ? [] : [{ from: s.from, insert: r[o].open + " " }, { from: s.to, insert: " " + r[o].close }])) };
  if (n != 1 && i.some((s) => s)) {
    let s = [];
    for (let o = 0, a; o < i.length; o++)
      if (a = i[o]) {
        let l = r[o], { open: c, close: u } = a;
        s.push({ from: c.pos - l.open.length, to: c.pos + c.margin }, { from: u.pos - u.margin, to: u.pos + l.close.length });
      }
    return { changes: s };
  }
  return null;
}
function _gt(n, e, t = e.selection.ranges) {
  let r = [], i = -1;
  for (let { from: s, to: o } of t) {
    let a = r.length, l = 1e9, c = aI(e, s).line;
    if (c) {
      for (let u = s; u <= o; ) {
        let d = e.doc.lineAt(u);
        if (d.from > i && (s == o || o > d.from)) {
          i = d.from;
          let f = /^\s*/.exec(d.text)[0].length, h = f == d.length, m = d.text.slice(f, f + c.length) == c ? f : -1;
          f < d.text.length && f < l && (l = f), r.push({ line: d, comment: m, token: c, indent: f, empty: h, single: !1 });
        }
        u = d.to + 1;
      }
      if (l < 1e9)
        for (let u = a; u < r.length; u++)
          r[u].indent < r[u].line.text.length && (r[u].indent = l);
      r.length == a + 1 && (r[a].single = !0);
    }
  }
  if (n != 2 && r.some((s) => s.comment < 0 && (!s.empty || s.single))) {
    let s = [];
    for (let { line: a, token: l, indent: c, empty: u, single: d } of r)
      (d || !u) && s.push({ from: a.from + c, insert: l + " " });
    let o = e.changes(s);
    return { changes: o, selection: e.selection.map(o, 1) };
  } else if (n != 1 && r.some((s) => s.comment >= 0)) {
    let s = [];
    for (let { line: o, comment: a, token: l } of r)
      if (a >= 0) {
        let c = o.from + a, u = c + l.length;
        o.text[u - o.from] == " " && u++, s.push({ from: c, to: u });
      }
    return { changes: s };
  }
  return null;
}
const pA = /* @__PURE__ */ Ma.define(), Ogt = /* @__PURE__ */ Ma.define(), Igt = /* @__PURE__ */ je.define(), nue = /* @__PURE__ */ je.define({
  combine(n) {
    return ka(n, {
      minDepth: 100,
      newGroupDelay: 500,
      joinToEvent: (e, t) => t
    }, {
      minDepth: Math.max,
      newGroupDelay: Math.min,
      joinToEvent: (e, t) => (r, i) => e(r, i) || t(r, i)
    });
  }
}), rue = /* @__PURE__ */ Xr.define({
  create() {
    return la.empty;
  },
  update(n, e) {
    let t = e.state.facet(nue), r = e.annotation(pA);
    if (r) {
      let l = Hi.fromTransaction(e, r.selection), c = r.side, u = c == 0 ? n.undone : n.done;
      return l ? u = ow(u, u.length, t.minDepth, l) : u = oue(u, e.startState.selection), new la(c == 0 ? r.rest : u, c == 0 ? u : r.rest);
    }
    let i = e.annotation(Ogt);
    if ((i == "full" || i == "before") && (n = n.isolate()), e.annotation(Cr.addToHistory) === !1)
      return e.changes.empty ? n : n.addMapping(e.changes.desc);
    let s = Hi.fromTransaction(e), o = e.annotation(Cr.time), a = e.annotation(Cr.userEvent);
    return s ? n = n.addChanges(s, o, a, t, e) : e.selection && (n = n.addSelection(e.startState.selection, o, a, t.newGroupDelay)), (i == "full" || i == "after") && (n = n.isolate()), n;
  },
  toJSON(n) {
    return { done: n.done.map((e) => e.toJSON()), undone: n.undone.map((e) => e.toJSON()) };
  },
  fromJSON(n) {
    return new la(n.done.map(Hi.fromJSON), n.undone.map(Hi.fromJSON));
  }
});
function Rgt(n = {}) {
  return [
    rue,
    nue.of(n),
    Be.domEventHandlers({
      beforeinput(e, t) {
        let r = e.inputType == "historyUndo" ? iue : e.inputType == "historyRedo" ? mA : null;
        return r ? (e.preventDefault(), r(t)) : !1;
      }
    })
  ];
}
function Ex(n, e) {
  return function({ state: t, dispatch: r }) {
    if (!e && t.readOnly)
      return !1;
    let i = t.field(rue, !1);
    if (!i)
      return !1;
    let s = i.pop(n, t, e);
    return s ? (r(s), !0) : !1;
  };
}
const iue = /* @__PURE__ */ Ex(0, !1), mA = /* @__PURE__ */ Ex(1, !1), Pgt = /* @__PURE__ */ Ex(0, !0), Dgt = /* @__PURE__ */ Ex(1, !0);
class Hi {
  constructor(e, t, r, i, s) {
    this.changes = e, this.effects = t, this.mapped = r, this.startSelection = i, this.selectionsAfter = s;
  }
  setSelAfter(e) {
    return new Hi(this.changes, this.effects, this.mapped, this.startSelection, e);
  }
  toJSON() {
    var e, t, r;
    return {
      changes: (e = this.changes) === null || e === void 0 ? void 0 : e.toJSON(),
      mapped: (t = this.mapped) === null || t === void 0 ? void 0 : t.toJSON(),
      startSelection: (r = this.startSelection) === null || r === void 0 ? void 0 : r.toJSON(),
      selectionsAfter: this.selectionsAfter.map((i) => i.toJSON())
    };
  }
  static fromJSON(e) {
    return new Hi(e.changes && xr.fromJSON(e.changes), [], e.mapped && ma.fromJSON(e.mapped), e.startSelection && ge.fromJSON(e.startSelection), e.selectionsAfter.map(ge.fromJSON));
  }
  // This does not check `addToHistory` and such, it assumes the
  // transaction needs to be converted to an item. Returns null when
  // there are no changes or effects in the transaction.
  static fromTransaction(e, t) {
    let r = Ds;
    for (let i of e.startState.facet(Igt)) {
      let s = i(e);
      s.length && (r = r.concat(s));
    }
    return !r.length && e.changes.empty ? null : new Hi(e.changes.invert(e.startState.doc), r, void 0, t || e.startState.selection, Ds);
  }
  static selection(e) {
    return new Hi(void 0, Ds, void 0, void 0, e);
  }
}
function ow(n, e, t, r) {
  let i = e + 1 > t + 20 ? e - t - 1 : 0, s = n.slice(i, e);
  return s.push(r), s;
}
function Ngt(n, e) {
  let t = [], r = !1;
  return n.iterChangedRanges((i, s) => t.push(i, s)), e.iterChangedRanges((i, s, o, a) => {
    for (let l = 0; l < t.length; ) {
      let c = t[l++], u = t[l++];
      a >= c && o <= u && (r = !0);
    }
  }), r;
}
function Lgt(n, e) {
  return n.ranges.length == e.ranges.length && n.ranges.filter((t, r) => t.empty != e.ranges[r].empty).length === 0;
}
function sue(n, e) {
  return n.length ? e.length ? n.concat(e) : n : e;
}
const Ds = [], $gt = 200;
function oue(n, e) {
  if (n.length) {
    let t = n[n.length - 1], r = t.selectionsAfter.slice(Math.max(0, t.selectionsAfter.length - $gt));
    return r.length && r[r.length - 1].eq(e) ? n : (r.push(e), ow(n, n.length - 1, 1e9, t.setSelAfter(r)));
  } else
    return [Hi.selection([e])];
}
function Fgt(n) {
  let e = n[n.length - 1], t = n.slice();
  return t[n.length - 1] = e.setSelAfter(e.selectionsAfter.slice(0, e.selectionsAfter.length - 1)), t;
}
function Z8(n, e) {
  if (!n.length)
    return n;
  let t = n.length, r = Ds;
  for (; t; ) {
    let i = Bgt(n[t - 1], e, r);
    if (i.changes && !i.changes.empty || i.effects.length) {
      let s = n.slice(0, t);
      return s[t - 1] = i, s;
    } else
      e = i.mapped, t--, r = i.selectionsAfter;
  }
  return r.length ? [Hi.selection(r)] : Ds;
}
function Bgt(n, e, t) {
  let r = sue(n.selectionsAfter.length ? n.selectionsAfter.map((a) => a.map(e)) : Ds, t);
  if (!n.changes)
    return Hi.selection(r);
  let i = n.changes.map(e), s = e.mapDesc(n.changes, !0), o = n.mapped ? n.mapped.composeDesc(s) : s;
  return new Hi(i, At.mapEffects(n.effects, e), o, n.startSelection.map(s), r);
}
const zgt = /^(input\.type|delete)($|\.)/;
class la {
  constructor(e, t, r = 0, i = void 0) {
    this.done = e, this.undone = t, this.prevTime = r, this.prevUserEvent = i;
  }
  isolate() {
    return this.prevTime ? new la(this.done, this.undone) : this;
  }
  addChanges(e, t, r, i, s) {
    let o = this.done, a = o[o.length - 1];
    return a && a.changes && !a.changes.empty && e.changes && (!r || zgt.test(r)) && (!a.selectionsAfter.length && t - this.prevTime < i.newGroupDelay && i.joinToEvent(s, Ngt(a.changes, e.changes)) || // For compose (but not compose.start) events, always join with previous event
    r == "input.type.compose") ? o = ow(o, o.length - 1, i.minDepth, new Hi(e.changes.compose(a.changes), sue(At.mapEffects(e.effects, a.changes), a.effects), a.mapped, a.startSelection, Ds)) : o = ow(o, o.length, i.minDepth, e), new la(o, Ds, t, r);
  }
  addSelection(e, t, r, i) {
    let s = this.done.length ? this.done[this.done.length - 1].selectionsAfter : Ds;
    return s.length > 0 && t - this.prevTime < i && r == this.prevUserEvent && r && /^select($|\.)/.test(r) && Lgt(s[s.length - 1], e) ? this : new la(oue(this.done, e), this.undone, t, r);
  }
  addMapping(e) {
    return new la(Z8(this.done, e), Z8(this.undone, e), this.prevTime, this.prevUserEvent);
  }
  pop(e, t, r) {
    let i = e == 0 ? this.done : this.undone;
    if (i.length == 0)
      return null;
    let s = i[i.length - 1], o = s.selectionsAfter[0] || t.selection;
    if (r && s.selectionsAfter.length)
      return t.update({
        selection: s.selectionsAfter[s.selectionsAfter.length - 1],
        annotations: pA.of({ side: e, rest: Fgt(i), selection: o }),
        userEvent: e == 0 ? "select.undo" : "select.redo",
        scrollIntoView: !0
      });
    if (s.changes) {
      let a = i.length == 1 ? Ds : i.slice(0, i.length - 1);
      return s.mapped && (a = Z8(a, s.mapped)), t.update({
        changes: s.changes,
        selection: s.startSelection,
        effects: s.effects,
        annotations: pA.of({ side: e, rest: a, selection: o }),
        filter: !1,
        userEvent: e == 0 ? "undo" : "redo",
        scrollIntoView: !0
      });
    } else
      return null;
  }
}
la.empty = /* @__PURE__ */ new la(Ds, Ds);
const Hgt = [
  { key: "Mod-z", run: iue, preventDefault: !0 },
  { key: "Mod-y", mac: "Mod-Shift-z", run: mA, preventDefault: !0 },
  { linux: "Ctrl-Shift-z", run: mA, preventDefault: !0 },
  { key: "Mod-u", run: Pgt, preventDefault: !0 },
  { key: "Alt-u", mac: "Mod-Shift-u", run: Dgt, preventDefault: !0 }
];
function Wh(n, e) {
  return ge.create(n.ranges.map(e), n.mainIndex);
}
function Po(n, e) {
  return n.update({ selection: e, scrollIntoView: !0, userEvent: "select" });
}
function Do({ state: n, dispatch: e }, t) {
  let r = Wh(n.selection, t);
  return r.eq(n.selection, !0) ? !1 : (e(Po(n, r)), !0);
}
function Sx(n, e) {
  return ge.cursor(e ? n.to : n.from);
}
function aue(n, e) {
  return Do(n, (t) => t.empty ? n.moveByChar(t, e) : Sx(t, e));
}
function ci(n) {
  return n.textDirectionAt(n.state.selection.main.head) == Dn.LTR;
}
const lue = (n) => aue(n, !ci(n)), cue = (n) => aue(n, ci(n));
function uue(n, e) {
  return Do(n, (t) => t.empty ? n.moveByGroup(t, e) : Sx(t, e));
}
const Ugt = (n) => uue(n, !ci(n)), Vgt = (n) => uue(n, ci(n));
function jgt(n, e, t) {
  if (e.type.prop(t))
    return !0;
  let r = e.to - e.from;
  return r && (r > 2 || /[^\s,.;:]/.test(n.sliceDoc(e.from, e.to))) || e.firstChild;
}
function Cx(n, e, t) {
  let r = ai(n).resolveInner(e.head), i = t ? Lt.closedBy : Lt.openedBy;
  for (let l = e.head; ; ) {
    let c = t ? r.childAfter(l) : r.childBefore(l);
    if (!c)
      break;
    jgt(n, c, i) ? r = c : l = t ? c.to : c.from;
  }
  let s = r.type.prop(i), o, a;
  return s && (o = t ? aa(n, r.from, 1) : aa(n, r.to, -1)) && o.matched ? a = t ? o.end.to : o.end.from : a = t ? r.to : r.from, ge.cursor(a, t ? -1 : 1);
}
const Wgt = (n) => Do(n, (e) => Cx(n.state, e, !ci(n))), Ggt = (n) => Do(n, (e) => Cx(n.state, e, ci(n)));
function due(n, e) {
  return Do(n, (t) => {
    if (!t.empty)
      return Sx(t, e);
    let r = n.moveVertically(t, e);
    return r.head != t.head ? r : n.moveToLineBoundary(t, e);
  });
}
const fue = (n) => due(n, !1), hue = (n) => due(n, !0);
function pue(n) {
  let e = n.scrollDOM.clientHeight < n.scrollDOM.scrollHeight - 2, t = 0, r = 0, i;
  if (e) {
    for (let s of n.state.facet(Be.scrollMargins)) {
      let o = s(n);
      o?.top && (t = Math.max(o?.top, t)), o?.bottom && (r = Math.max(o?.bottom, r));
    }
    i = n.scrollDOM.clientHeight - t - r;
  } else
    i = (n.dom.ownerDocument.defaultView || window).innerHeight;
  return {
    marginTop: t,
    marginBottom: r,
    selfScroll: e,
    height: Math.max(n.defaultLineHeight, i - 5)
  };
}
function mue(n, e) {
  let t = pue(n), { state: r } = n, i = Wh(r.selection, (o) => o.empty ? n.moveVertically(o, e, t.height) : Sx(o, e));
  if (i.eq(r.selection))
    return !1;
  let s;
  if (t.selfScroll) {
    let o = n.coordsAtPos(r.selection.main.head), a = n.scrollDOM.getBoundingClientRect(), l = a.top + t.marginTop, c = a.bottom - t.marginBottom;
    o && o.top > l && o.bottom < c && (s = Be.scrollIntoView(i.main.head, { y: "start", yMargin: o.top - l }));
  }
  return n.dispatch(Po(r, i), { effects: s }), !0;
}
const $W = (n) => mue(n, !1), gA = (n) => mue(n, !0);
function $c(n, e, t) {
  let r = n.lineBlockAt(e.head), i = n.moveToLineBoundary(e, t);
  if (i.head == e.head && i.head != (t ? r.to : r.from) && (i = n.moveToLineBoundary(e, t, !1)), !t && i.head == r.from && r.length) {
    let s = /^\s*/.exec(n.state.sliceDoc(r.from, Math.min(r.from + 100, r.to)))[0].length;
    s && e.head != r.from + s && (i = ge.cursor(r.from + s));
  }
  return i;
}
const Kgt = (n) => Do(n, (e) => $c(n, e, !0)), qgt = (n) => Do(n, (e) => $c(n, e, !1)), Ygt = (n) => Do(n, (e) => $c(n, e, !ci(n))), Xgt = (n) => Do(n, (e) => $c(n, e, ci(n))), Zgt = (n) => Do(n, (e) => ge.cursor(n.lineBlockAt(e.head).from, 1)), Qgt = (n) => Do(n, (e) => ge.cursor(n.lineBlockAt(e.head).to, -1));
function Jgt(n, e, t) {
  let r = !1, i = Wh(n.selection, (s) => {
    let o = aa(n, s.head, -1) || aa(n, s.head, 1) || s.head > 0 && aa(n, s.head - 1, 1) || s.head < n.doc.length && aa(n, s.head + 1, -1);
    if (!o || !o.end)
      return s;
    r = !0;
    let a = o.start.from == s.head ? o.end.to : o.end.from;
    return ge.cursor(a);
  });
  return r ? (e(Po(n, i)), !0) : !1;
}
const evt = ({ state: n, dispatch: e }) => Jgt(n, e);
function Xs(n, e) {
  let t = Wh(n.state.selection, (r) => {
    let i = e(r);
    return ge.range(r.anchor, i.head, i.goalColumn, i.bidiLevel || void 0);
  });
  return t.eq(n.state.selection) ? !1 : (n.dispatch(Po(n.state, t)), !0);
}
function gue(n, e) {
  return Xs(n, (t) => n.moveByChar(t, e));
}
const vue = (n) => gue(n, !ci(n)), yue = (n) => gue(n, ci(n));
function bue(n, e) {
  return Xs(n, (t) => n.moveByGroup(t, e));
}
const tvt = (n) => bue(n, !ci(n)), nvt = (n) => bue(n, ci(n)), rvt = (n) => Xs(n, (e) => Cx(n.state, e, !ci(n))), ivt = (n) => Xs(n, (e) => Cx(n.state, e, ci(n)));
function wue(n, e) {
  return Xs(n, (t) => n.moveVertically(t, e));
}
const xue = (n) => wue(n, !1), Eue = (n) => wue(n, !0);
function Sue(n, e) {
  return Xs(n, (t) => n.moveVertically(t, e, pue(n).height));
}
const FW = (n) => Sue(n, !1), BW = (n) => Sue(n, !0), svt = (n) => Xs(n, (e) => $c(n, e, !0)), ovt = (n) => Xs(n, (e) => $c(n, e, !1)), avt = (n) => Xs(n, (e) => $c(n, e, !ci(n))), lvt = (n) => Xs(n, (e) => $c(n, e, ci(n))), cvt = (n) => Xs(n, (e) => ge.cursor(n.lineBlockAt(e.head).from)), uvt = (n) => Xs(n, (e) => ge.cursor(n.lineBlockAt(e.head).to)), zW = ({ state: n, dispatch: e }) => (e(Po(n, { anchor: 0 })), !0), HW = ({ state: n, dispatch: e }) => (e(Po(n, { anchor: n.doc.length })), !0), UW = ({ state: n, dispatch: e }) => (e(Po(n, { anchor: n.selection.main.anchor, head: 0 })), !0), VW = ({ state: n, dispatch: e }) => (e(Po(n, { anchor: n.selection.main.anchor, head: n.doc.length })), !0), dvt = ({ state: n, dispatch: e }) => (e(n.update({ selection: { anchor: 0, head: n.doc.length }, userEvent: "select" })), !0), fvt = ({ state: n, dispatch: e }) => {
  let t = Tx(n).map(({ from: r, to: i }) => ge.range(r, Math.min(i + 1, n.doc.length)));
  return e(n.update({ selection: ge.create(t), userEvent: "select" })), !0;
}, hvt = ({ state: n, dispatch: e }) => {
  let t = Wh(n.selection, (r) => {
    let i = ai(n), s = i.resolveStack(r.from, 1);
    if (r.empty) {
      let o = i.resolveStack(r.from, -1);
      o.node.from >= s.node.from && o.node.to <= s.node.to && (s = o);
    }
    for (let o = s; o; o = o.next) {
      let { node: a } = o;
      if ((a.from < r.from && a.to >= r.to || a.to > r.to && a.from <= r.from) && o.next)
        return ge.range(a.to, a.from);
    }
    return r;
  });
  return t.eq(n.selection) ? !1 : (e(Po(n, t)), !0);
};
function Cue(n, e) {
  let { state: t } = n, r = t.selection, i = t.selection.ranges.slice();
  for (let s of t.selection.ranges) {
    let o = t.doc.lineAt(s.head);
    if (e ? o.to < n.state.doc.length : o.from > 0)
      for (let a = s; ; ) {
        let l = n.moveVertically(a, e);
        if (l.head < o.from || l.head > o.to) {
          i.some((c) => c.head == l.head) || i.push(l);
          break;
        } else {
          if (l.head == a.head)
            break;
          a = l;
        }
      }
  }
  return i.length == r.ranges.length ? !1 : (n.dispatch(Po(t, ge.create(i, i.length - 1))), !0);
}
const pvt = (n) => Cue(n, !1), mvt = (n) => Cue(n, !0), gvt = ({ state: n, dispatch: e }) => {
  let t = n.selection, r = null;
  return t.ranges.length > 1 ? r = ge.create([t.main]) : t.main.empty || (r = ge.create([ge.cursor(t.main.head)])), r ? (e(Po(n, r)), !0) : !1;
};
function q1(n, e) {
  if (n.state.readOnly)
    return !1;
  let t = "delete.selection", { state: r } = n, i = r.changeByRange((s) => {
    let { from: o, to: a } = s;
    if (o == a) {
      let l = e(s);
      l < o ? (t = "delete.backward", l = Pv(n, l, !1)) : l > o && (t = "delete.forward", l = Pv(n, l, !0)), o = Math.min(o, l), a = Math.max(a, l);
    } else
      o = Pv(n, o, !1), a = Pv(n, a, !0);
    return o == a ? { range: s } : { changes: { from: o, to: a }, range: ge.cursor(o, o < s.head ? -1 : 1) };
  });
  return i.changes.empty ? !1 : (n.dispatch(r.update(i, {
    scrollIntoView: !0,
    userEvent: t,
    effects: t == "delete.selection" ? Be.announce.of(r.phrase("Selection deleted")) : void 0
  })), !0);
}
function Pv(n, e, t) {
  if (n instanceof Be)
    for (let r of n.state.facet(Be.atomicRanges).map((i) => i(n)))
      r.between(e, e, (i, s) => {
        i < e && s > e && (e = t ? s : i);
      });
  return e;
}
const Tue = (n, e, t) => q1(n, (r) => {
  let i = r.from, { state: s } = n, o = s.doc.lineAt(i), a, l;
  if (t && !e && i > o.from && i < o.from + 200 && !/[^ \t]/.test(a = o.text.slice(0, i - o.from))) {
    if (a[a.length - 1] == "	")
      return i - 1;
    let c = Vh(a, s.tabSize), u = c % rw(s) || rw(s);
    for (let d = 0; d < u && a[a.length - 1 - d] == " "; d++)
      i--;
    l = i;
  } else
    l = Gr(o.text, i - o.from, e, e) + o.from, l == i && o.number != (e ? s.doc.lines : 1) ? l += e ? 1 : -1 : !e && /[\ufe00-\ufe0f]/.test(o.text.slice(l - o.from, i - o.from)) && (l = Gr(o.text, l - o.from, !1, !1) + o.from);
  return l;
}), vA = (n) => Tue(n, !1, !0), Aue = (n) => Tue(n, !0, !1), Mue = (n, e) => q1(n, (t) => {
  let r = t.head, { state: i } = n, s = i.doc.lineAt(r), o = i.charCategorizer(r);
  for (let a = null; ; ) {
    if (r == (e ? s.to : s.from)) {
      r == t.head && s.number != (e ? i.doc.lines : 1) && (r += e ? 1 : -1);
      break;
    }
    let l = Gr(s.text, r - s.from, e) + s.from, c = s.text.slice(Math.min(r, l) - s.from, Math.max(r, l) - s.from), u = o(c);
    if (a != null && u != a)
      break;
    (c != " " || r != t.head) && (a = u), r = l;
  }
  return r;
}), kue = (n) => Mue(n, !1), vvt = (n) => Mue(n, !0), yvt = (n) => q1(n, (e) => {
  let t = n.lineBlockAt(e.head).to;
  return e.head < t ? t : Math.min(n.state.doc.length, e.head + 1);
}), bvt = (n) => q1(n, (e) => {
  let t = n.moveToLineBoundary(e, !1).head;
  return e.head > t ? t : Math.max(0, e.head - 1);
}), wvt = (n) => q1(n, (e) => {
  let t = n.moveToLineBoundary(e, !0).head;
  return e.head < t ? t : Math.min(n.state.doc.length, e.head + 1);
}), xvt = ({ state: n, dispatch: e }) => {
  if (n.readOnly)
    return !1;
  let t = n.changeByRange((r) => ({
    changes: { from: r.from, to: r.to, insert: jt.of(["", ""]) },
    range: ge.cursor(r.from)
  }));
  return e(n.update(t, { scrollIntoView: !0, userEvent: "input" })), !0;
}, Evt = ({ state: n, dispatch: e }) => {
  if (n.readOnly)
    return !1;
  let t = n.changeByRange((r) => {
    if (!r.empty || r.from == 0 || r.from == n.doc.length)
      return { range: r };
    let i = r.from, s = n.doc.lineAt(i), o = i == s.from ? i - 1 : Gr(s.text, i - s.from, !1) + s.from, a = i == s.to ? i + 1 : Gr(s.text, i - s.from, !0) + s.from;
    return {
      changes: { from: o, to: a, insert: n.doc.slice(i, a).append(n.doc.slice(o, i)) },
      range: ge.cursor(a)
    };
  });
  return t.changes.empty ? !1 : (e(n.update(t, { scrollIntoView: !0, userEvent: "move.character" })), !0);
};
function Tx(n) {
  let e = [], t = -1;
  for (let r of n.selection.ranges) {
    let i = n.doc.lineAt(r.from), s = n.doc.lineAt(r.to);
    if (!r.empty && r.to == s.from && (s = n.doc.lineAt(r.to - 1)), t >= i.number) {
      let o = e[e.length - 1];
      o.to = s.to, o.ranges.push(r);
    } else
      e.push({ from: i.from, to: s.to, ranges: [r] });
    t = s.number + 1;
  }
  return e;
}
function _ue(n, e, t) {
  if (n.readOnly)
    return !1;
  let r = [], i = [];
  for (let s of Tx(n)) {
    if (t ? s.to == n.doc.length : s.from == 0)
      continue;
    let o = n.doc.lineAt(t ? s.to + 1 : s.from - 1), a = o.length + 1;
    if (t) {
      r.push({ from: s.to, to: o.to }, { from: s.from, insert: o.text + n.lineBreak });
      for (let l of s.ranges)
        i.push(ge.range(Math.min(n.doc.length, l.anchor + a), Math.min(n.doc.length, l.head + a)));
    } else {
      r.push({ from: o.from, to: s.from }, { from: s.to, insert: n.lineBreak + o.text });
      for (let l of s.ranges)
        i.push(ge.range(l.anchor - a, l.head - a));
    }
  }
  return r.length ? (e(n.update({
    changes: r,
    scrollIntoView: !0,
    selection: ge.create(i, n.selection.mainIndex),
    userEvent: "move.line"
  })), !0) : !1;
}
const Svt = ({ state: n, dispatch: e }) => _ue(n, e, !1), Cvt = ({ state: n, dispatch: e }) => _ue(n, e, !0);
function Oue(n, e, t) {
  if (n.readOnly)
    return !1;
  let r = [];
  for (let i of Tx(n))
    t ? r.push({ from: i.from, insert: n.doc.slice(i.from, i.to) + n.lineBreak }) : r.push({ from: i.to, insert: n.lineBreak + n.doc.slice(i.from, i.to) });
  return e(n.update({ changes: r, scrollIntoView: !0, userEvent: "input.copyline" })), !0;
}
const Tvt = ({ state: n, dispatch: e }) => Oue(n, e, !1), Avt = ({ state: n, dispatch: e }) => Oue(n, e, !0), Mvt = (n) => {
  if (n.state.readOnly)
    return !1;
  let { state: e } = n, t = e.changes(Tx(e).map(({ from: i, to: s }) => (i > 0 ? i-- : s < e.doc.length && s++, { from: i, to: s }))), r = Wh(e.selection, (i) => {
    let s;
    if (n.lineWrapping) {
      let o = n.lineBlockAt(i.head), a = n.coordsAtPos(i.head, i.assoc || 1);
      a && (s = o.bottom + n.documentTop - a.bottom + n.defaultLineHeight / 2);
    }
    return n.moveVertically(i, !0, s);
  }).map(t);
  return n.dispatch({ changes: t, selection: r, scrollIntoView: !0, userEvent: "delete.line" }), !0;
};
function kvt(n, e) {
  if (/\(\)|\[\]|\{\}/.test(n.sliceDoc(e - 1, e + 1)))
    return { from: e, to: e };
  let t = ai(n).resolveInner(e), r = t.childBefore(e), i = t.childAfter(e), s;
  return r && i && r.to <= e && i.from >= e && (s = r.type.prop(Lt.closedBy)) && s.indexOf(i.name) > -1 && n.doc.lineAt(r.to).from == n.doc.lineAt(i.from).from && !/\S/.test(n.sliceDoc(r.to, i.from)) ? { from: r.to, to: i.from } : null;
}
const jW = /* @__PURE__ */ Iue(!1), _vt = /* @__PURE__ */ Iue(!0);
function Iue(n) {
  return ({ state: e, dispatch: t }) => {
    if (e.readOnly)
      return !1;
    let r = e.changeByRange((i) => {
      let { from: s, to: o } = i, a = e.doc.lineAt(s), l = !n && s == o && kvt(e, s);
      n && (s = o = (o <= a.to ? a : e.doc.lineAt(o)).to);
      let c = new wx(e, { simulateBreak: s, simulateDoubleBreak: !!l }), u = rI(c, s);
      for (u == null && (u = Vh(/^\s*/.exec(e.doc.lineAt(s).text)[0], e.tabSize)); o < a.to && /\s/.test(a.text[o - a.from]); )
        o++;
      l ? { from: s, to: o } = l : s > a.from && s < a.from + 100 && !/\S/.test(a.text.slice(0, s)) && (s = a.from);
      let d = ["", e1(e, u)];
      return l && d.push(e1(e, c.lineIndent(a.from, -1))), {
        changes: { from: s, to: o, insert: jt.of(d) },
        range: ge.cursor(s + 1 + d[1].length)
      };
    });
    return t(e.update(r, { scrollIntoView: !0, userEvent: "input" })), !0;
  };
}
function lI(n, e) {
  let t = -1;
  return n.changeByRange((r) => {
    let i = [];
    for (let o = r.from; o <= r.to; ) {
      let a = n.doc.lineAt(o);
      a.number > t && (r.empty || r.to > a.from) && (e(a, i, r), t = a.number), o = a.to + 1;
    }
    let s = n.changes(i);
    return {
      changes: i,
      range: ge.range(s.mapPos(r.anchor, 1), s.mapPos(r.head, 1))
    };
  });
}
const Ovt = ({ state: n, dispatch: e }) => {
  if (n.readOnly)
    return !1;
  let t = /* @__PURE__ */ Object.create(null), r = new wx(n, { overrideIndentation: (s) => {
    let o = t[s];
    return o ?? -1;
  } }), i = lI(n, (s, o, a) => {
    let l = rI(r, s.from);
    if (l == null)
      return;
    /\S/.test(s.text) || (l = 0);
    let c = /^\s*/.exec(s.text)[0], u = e1(n, l);
    (c != u || a.from < s.from + c.length) && (t[s.from] = l, o.push({ from: s.from, to: s.from + c.length, insert: u }));
  });
  return i.changes.empty || e(n.update(i, { userEvent: "indent" })), !0;
}, Rue = ({ state: n, dispatch: e }) => n.readOnly ? !1 : (e(n.update(lI(n, (t, r) => {
  r.push({ from: t.from, insert: n.facet(bx) });
}), { userEvent: "input.indent" })), !0), Pue = ({ state: n, dispatch: e }) => n.readOnly ? !1 : (e(n.update(lI(n, (t, r) => {
  let i = /^\s*/.exec(t.text)[0];
  if (!i)
    return;
  let s = Vh(i, n.tabSize), o = 0, a = e1(n, Math.max(0, s - rw(n)));
  for (; o < i.length && o < a.length && i.charCodeAt(o) == a.charCodeAt(o); )
    o++;
  r.push({ from: t.from + o, to: t.from + i.length, insert: a.slice(o) });
}), { userEvent: "delete.dedent" })), !0), Ivt = (n) => (n.setTabFocusMode(), !0), Rvt = [
  { key: "Ctrl-b", run: lue, shift: vue, preventDefault: !0 },
  { key: "Ctrl-f", run: cue, shift: yue },
  { key: "Ctrl-p", run: fue, shift: xue },
  { key: "Ctrl-n", run: hue, shift: Eue },
  { key: "Ctrl-a", run: Zgt, shift: cvt },
  { key: "Ctrl-e", run: Qgt, shift: uvt },
  { key: "Ctrl-d", run: Aue },
  { key: "Ctrl-h", run: vA },
  { key: "Ctrl-k", run: yvt },
  { key: "Ctrl-Alt-h", run: kue },
  { key: "Ctrl-o", run: xvt },
  { key: "Ctrl-t", run: Evt },
  { key: "Ctrl-v", run: gA }
], Pvt = /* @__PURE__ */ [
  { key: "ArrowLeft", run: lue, shift: vue, preventDefault: !0 },
  { key: "Mod-ArrowLeft", mac: "Alt-ArrowLeft", run: Ugt, shift: tvt, preventDefault: !0 },
  { mac: "Cmd-ArrowLeft", run: Ygt, shift: avt, preventDefault: !0 },
  { key: "ArrowRight", run: cue, shift: yue, preventDefault: !0 },
  { key: "Mod-ArrowRight", mac: "Alt-ArrowRight", run: Vgt, shift: nvt, preventDefault: !0 },
  { mac: "Cmd-ArrowRight", run: Xgt, shift: lvt, preventDefault: !0 },
  { key: "ArrowUp", run: fue, shift: xue, preventDefault: !0 },
  { mac: "Cmd-ArrowUp", run: zW, shift: UW },
  { mac: "Ctrl-ArrowUp", run: $W, shift: FW },
  { key: "ArrowDown", run: hue, shift: Eue, preventDefault: !0 },
  { mac: "Cmd-ArrowDown", run: HW, shift: VW },
  { mac: "Ctrl-ArrowDown", run: gA, shift: BW },
  { key: "PageUp", run: $W, shift: FW },
  { key: "PageDown", run: gA, shift: BW },
  { key: "Home", run: qgt, shift: ovt, preventDefault: !0 },
  { key: "Mod-Home", run: zW, shift: UW },
  { key: "End", run: Kgt, shift: svt, preventDefault: !0 },
  { key: "Mod-End", run: HW, shift: VW },
  { key: "Enter", run: jW, shift: jW },
  { key: "Mod-a", run: dvt },
  { key: "Backspace", run: vA, shift: vA, preventDefault: !0 },
  { key: "Delete", run: Aue, preventDefault: !0 },
  { key: "Mod-Backspace", mac: "Alt-Backspace", run: kue, preventDefault: !0 },
  { key: "Mod-Delete", mac: "Alt-Delete", run: vvt, preventDefault: !0 },
  { mac: "Mod-Backspace", run: bvt, preventDefault: !0 },
  { mac: "Mod-Delete", run: wvt, preventDefault: !0 }
].concat(/* @__PURE__ */ Rvt.map((n) => ({ mac: n.key, run: n.run, shift: n.shift }))), Dvt = /* @__PURE__ */ [
  { key: "Alt-ArrowLeft", mac: "Ctrl-ArrowLeft", run: Wgt, shift: rvt },
  { key: "Alt-ArrowRight", mac: "Ctrl-ArrowRight", run: Ggt, shift: ivt },
  { key: "Alt-ArrowUp", run: Svt },
  { key: "Shift-Alt-ArrowUp", run: Tvt },
  { key: "Alt-ArrowDown", run: Cvt },
  { key: "Shift-Alt-ArrowDown", run: Avt },
  { key: "Mod-Alt-ArrowUp", run: pvt },
  { key: "Mod-Alt-ArrowDown", run: mvt },
  { key: "Escape", run: gvt },
  { key: "Mod-Enter", run: _vt },
  { key: "Alt-l", mac: "Ctrl-l", run: fvt },
  { key: "Mod-i", run: hvt, preventDefault: !0 },
  { key: "Mod-[", run: Pue },
  { key: "Mod-]", run: Rue },
  { key: "Mod-Alt-\\", run: Ovt },
  { key: "Shift-Mod-k", run: Mvt },
  { key: "Shift-Mod-\\", run: evt },
  { key: "Mod-/", run: Sgt },
  { key: "Alt-A", run: Tgt },
  { key: "Ctrl-m", mac: "Shift-Alt-m", run: Ivt }
].concat(Pvt), Nvt = { key: "Tab", run: Rue, shift: Pue }, WW = typeof String.prototype.normalize == "function" ? (n) => n.normalize("NFKD") : (n) => n;
class mh {
  /**
  Create a text cursor. The query is the search string, `from` to
  `to` provides the region to search.
  
  When `normalize` is given, it will be called, on both the query
  string and the content it is matched against, before comparing.
  You can, for example, create a case-insensitive search by
  passing `s => s.toLowerCase()`.
  
  Text is always normalized with
  [`.normalize("NFKD")`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize)
  (when supported).
  */
  constructor(e, t, r = 0, i = e.length, s, o) {
    this.test = o, this.value = { from: 0, to: 0 }, this.done = !1, this.matches = [], this.buffer = "", this.bufferPos = 0, this.iter = e.iterRange(r, i), this.bufferStart = r, this.normalize = s ? (a) => s(WW(a)) : WW, this.query = this.normalize(t);
  }
  peek() {
    if (this.bufferPos == this.buffer.length) {
      if (this.bufferStart += this.buffer.length, this.iter.next(), this.iter.done)
        return -1;
      this.bufferPos = 0, this.buffer = this.iter.value;
    }
    return Pi(this.buffer, this.bufferPos);
  }
  /**
  Look for the next match. Updates the iterator's
  [`value`](https://codemirror.net/6/docs/ref/#search.SearchCursor.value) and
  [`done`](https://codemirror.net/6/docs/ref/#search.SearchCursor.done) properties. Should be called
  at least once before using the cursor.
  */
  next() {
    for (; this.matches.length; )
      this.matches.pop();
    return this.nextOverlapping();
  }
  /**
  The `next` method will ignore matches that partially overlap a
  previous match. This method behaves like `next`, but includes
  such matches.
  */
  nextOverlapping() {
    for (; ; ) {
      let e = this.peek();
      if (e < 0)
        return this.done = !0, this;
      let t = UO(e), r = this.bufferStart + this.bufferPos;
      this.bufferPos += Jo(e);
      let i = this.normalize(t);
      if (i.length)
        for (let s = 0, o = r; ; s++) {
          let a = i.charCodeAt(s), l = this.match(a, o, this.bufferPos + this.bufferStart);
          if (s == i.length - 1) {
            if (l)
              return this.value = l, this;
            break;
          }
          o == r && s < t.length && t.charCodeAt(s) == a && o++;
        }
    }
  }
  match(e, t, r) {
    let i = null;
    for (let s = 0; s < this.matches.length; s += 2) {
      let o = this.matches[s], a = !1;
      this.query.charCodeAt(o) == e && (o == this.query.length - 1 ? i = { from: this.matches[s + 1], to: r } : (this.matches[s]++, a = !0)), a || (this.matches.splice(s, 2), s -= 2);
    }
    return this.query.charCodeAt(0) == e && (this.query.length == 1 ? i = { from: t, to: r } : this.matches.push(1, t)), i && this.test && !this.test(i.from, i.to, this.buffer, this.bufferStart) && (i = null), i;
  }
}
typeof Symbol < "u" && (mh.prototype[Symbol.iterator] = function() {
  return this;
});
const Due = { from: -1, to: -1, match: /* @__PURE__ */ /.*/.exec("") }, cI = "gm" + (/x/.unicode == null ? "" : "u");
class Nue {
  /**
  Create a cursor that will search the given range in the given
  document. `query` should be the raw pattern (as you'd pass it to
  `new RegExp`).
  */
  constructor(e, t, r, i = 0, s = e.length) {
    if (this.text = e, this.to = s, this.curLine = "", this.done = !1, this.value = Due, /\\[sWDnr]|\n|\r|\[\^/.test(t))
      return new Lue(e, t, r, i, s);
    this.re = new RegExp(t, cI + (r?.ignoreCase ? "i" : "")), this.test = r?.test, this.iter = e.iter();
    let o = e.lineAt(i);
    this.curLineStart = o.from, this.matchPos = aw(e, i), this.getLine(this.curLineStart);
  }
  getLine(e) {
    this.iter.next(e), this.iter.lineBreak ? this.curLine = "" : (this.curLine = this.iter.value, this.curLineStart + this.curLine.length > this.to && (this.curLine = this.curLine.slice(0, this.to - this.curLineStart)), this.iter.next());
  }
  nextLine() {
    this.curLineStart = this.curLineStart + this.curLine.length + 1, this.curLineStart > this.to ? this.curLine = "" : this.getLine(0);
  }
  /**
  Move to the next match, if there is one.
  */
  next() {
    for (let e = this.matchPos - this.curLineStart; ; ) {
      this.re.lastIndex = e;
      let t = this.matchPos <= this.to && this.re.exec(this.curLine);
      if (t) {
        let r = this.curLineStart + t.index, i = r + t[0].length;
        if (this.matchPos = aw(this.text, i + (r == i ? 1 : 0)), r == this.curLineStart + this.curLine.length && this.nextLine(), (r < i || r > this.value.to) && (!this.test || this.test(r, i, t)))
          return this.value = { from: r, to: i, match: t }, this;
        e = this.matchPos - this.curLineStart;
      } else if (this.curLineStart + this.curLine.length < this.to)
        this.nextLine(), e = 0;
      else
        return this.done = !0, this;
    }
  }
}
const Q8 = /* @__PURE__ */ new WeakMap();
class xf {
  constructor(e, t) {
    this.from = e, this.text = t;
  }
  get to() {
    return this.from + this.text.length;
  }
  static get(e, t, r) {
    let i = Q8.get(e);
    if (!i || i.from >= r || i.to <= t) {
      let a = new xf(t, e.sliceString(t, r));
      return Q8.set(e, a), a;
    }
    if (i.from == t && i.to == r)
      return i;
    let { text: s, from: o } = i;
    return o > t && (s = e.sliceString(t, o) + s, o = t), i.to < r && (s += e.sliceString(i.to, r)), Q8.set(e, new xf(o, s)), new xf(t, s.slice(t - o, r - o));
  }
}
class Lue {
  constructor(e, t, r, i, s) {
    this.text = e, this.to = s, this.done = !1, this.value = Due, this.matchPos = aw(e, i), this.re = new RegExp(t, cI + (r?.ignoreCase ? "i" : "")), this.test = r?.test, this.flat = xf.get(e, i, this.chunkEnd(
      i + 5e3
      /* Chunk.Base */
    ));
  }
  chunkEnd(e) {
    return e >= this.to ? this.to : this.text.lineAt(e).to;
  }
  next() {
    for (; ; ) {
      let e = this.re.lastIndex = this.matchPos - this.flat.from, t = this.re.exec(this.flat.text);
      if (t && !t[0] && t.index == e && (this.re.lastIndex = e + 1, t = this.re.exec(this.flat.text)), t) {
        let r = this.flat.from + t.index, i = r + t[0].length;
        if ((this.flat.to >= this.to || t.index + t[0].length <= this.flat.text.length - 10) && (!this.test || this.test(r, i, t)))
          return this.value = { from: r, to: i, match: t }, this.matchPos = aw(this.text, i + (r == i ? 1 : 0)), this;
      }
      if (this.flat.to == this.to)
        return this.done = !0, this;
      this.flat = xf.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + this.flat.text.length * 2));
    }
  }
}
typeof Symbol < "u" && (Nue.prototype[Symbol.iterator] = Lue.prototype[Symbol.iterator] = function() {
  return this;
});
function Lvt(n) {
  try {
    return new RegExp(n, cI), !0;
  } catch {
    return !1;
  }
}
function aw(n, e) {
  if (e >= n.length)
    return e;
  let t = n.lineAt(e), r;
  for (; e < t.to && (r = t.text.charCodeAt(e - t.from)) >= 56320 && r < 57344; )
    e++;
  return e;
}
function yA(n) {
  let e = String(n.state.doc.lineAt(n.state.selection.main.head).number), t = yn("input", { class: "cm-textfield", name: "line", value: e }), r = yn("form", {
    class: "cm-gotoLine",
    onkeydown: (s) => {
      s.keyCode == 27 ? (s.preventDefault(), n.dispatch({ effects: gm.of(!1) }), n.focus()) : s.keyCode == 13 && (s.preventDefault(), i());
    },
    onsubmit: (s) => {
      s.preventDefault(), i();
    }
  }, yn("label", n.state.phrase("Go to line"), ": ", t), " ", yn("button", { class: "cm-button", type: "submit" }, n.state.phrase("go")), yn("button", {
    name: "close",
    onclick: () => {
      n.dispatch({ effects: gm.of(!1) }), n.focus();
    },
    "aria-label": n.state.phrase("close"),
    type: "button"
  }, ["×"]));
  function i() {
    let s = /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(t.value);
    if (!s)
      return;
    let { state: o } = n, a = o.doc.lineAt(o.selection.main.head), [, l, c, u, d] = s, f = u ? +u.slice(1) : 0, h = c ? +c : a.number;
    if (c && d) {
      let v = h / 100;
      l && (v = v * (l == "-" ? -1 : 1) + a.number / o.doc.lines), h = Math.round(o.doc.lines * v);
    } else c && l && (h = h * (l == "-" ? -1 : 1) + a.number);
    let m = o.doc.line(Math.max(1, Math.min(o.doc.lines, h))), g = ge.cursor(m.from + Math.max(0, Math.min(f, m.length)));
    n.dispatch({
      effects: [gm.of(!1), Be.scrollIntoView(g.from, { y: "center" })],
      selection: g
    }), n.focus();
  }
  return { dom: r };
}
const gm = /* @__PURE__ */ At.define(), GW = /* @__PURE__ */ Xr.define({
  create() {
    return !0;
  },
  update(n, e) {
    for (let t of e.effects)
      t.is(gm) && (n = t.value);
    return n;
  },
  provide: (n) => J0.from(n, (e) => e ? yA : null)
}), $vt = (n) => {
  let e = Q0(n, yA);
  if (!e) {
    let t = [gm.of(!0)];
    n.state.field(GW, !1) == null && t.push(At.appendConfig.of([GW, Fvt])), n.dispatch({ effects: t }), e = Q0(n, yA);
  }
  return e && e.dom.querySelector("input").select(), !0;
}, Fvt = /* @__PURE__ */ Be.baseTheme({
  ".cm-panel.cm-gotoLine": {
    padding: "2px 6px 4px",
    position: "relative",
    "& label": { fontSize: "80%" },
    "& [name=close]": {
      position: "absolute",
      top: "0",
      bottom: "0",
      right: "4px",
      backgroundColor: "inherit",
      border: "none",
      font: "inherit",
      padding: "0"
    }
  }
}), Bvt = {
  highlightWordAroundCursor: !1,
  minSelectionLength: 1,
  maxMatches: 100,
  wholeWords: !1
}, zvt = /* @__PURE__ */ je.define({
  combine(n) {
    return ka(n, Bvt, {
      highlightWordAroundCursor: (e, t) => e || t,
      minSelectionLength: Math.min,
      maxMatches: Math.min
    });
  }
});
function Hvt(n) {
  return [Gvt, Wvt];
}
const Uvt = /* @__PURE__ */ ct.mark({ class: "cm-selectionMatch" }), Vvt = /* @__PURE__ */ ct.mark({ class: "cm-selectionMatch cm-selectionMatch-main" });
function KW(n, e, t, r) {
  return (t == 0 || n(e.sliceDoc(t - 1, t)) != $n.Word) && (r == e.doc.length || n(e.sliceDoc(r, r + 1)) != $n.Word);
}
function jvt(n, e, t, r) {
  return n(e.sliceDoc(t, t + 1)) == $n.Word && n(e.sliceDoc(r - 1, r)) == $n.Word;
}
const Wvt = /* @__PURE__ */ nr.fromClass(class {
  constructor(n) {
    this.decorations = this.getDeco(n);
  }
  update(n) {
    (n.selectionSet || n.docChanged || n.viewportChanged) && (this.decorations = this.getDeco(n.view));
  }
  getDeco(n) {
    let e = n.state.facet(zvt), { state: t } = n, r = t.selection;
    if (r.ranges.length > 1)
      return ct.none;
    let i = r.main, s, o = null;
    if (i.empty) {
      if (!e.highlightWordAroundCursor)
        return ct.none;
      let l = t.wordAt(i.head);
      if (!l)
        return ct.none;
      o = t.charCategorizer(i.head), s = t.sliceDoc(l.from, l.to);
    } else {
      let l = i.to - i.from;
      if (l < e.minSelectionLength || l > 200)
        return ct.none;
      if (e.wholeWords) {
        if (s = t.sliceDoc(i.from, i.to), o = t.charCategorizer(i.head), !(KW(o, t, i.from, i.to) && jvt(o, t, i.from, i.to)))
          return ct.none;
      } else if (s = t.sliceDoc(i.from, i.to), !s)
        return ct.none;
    }
    let a = [];
    for (let l of n.visibleRanges) {
      let c = new mh(t.doc, s, l.from, l.to);
      for (; !c.next().done; ) {
        let { from: u, to: d } = c.value;
        if ((!o || KW(o, t, u, d)) && (i.empty && u <= i.from && d >= i.to ? a.push(Vvt.range(u, d)) : (u >= i.to || d <= i.from) && a.push(Uvt.range(u, d)), a.length > e.maxMatches))
          return ct.none;
      }
    }
    return ct.set(a);
  }
}, {
  decorations: (n) => n.decorations
}), Gvt = /* @__PURE__ */ Be.baseTheme({
  ".cm-selectionMatch": { backgroundColor: "#99ff7780" },
  ".cm-searchMatch .cm-selectionMatch": { backgroundColor: "transparent" }
}), Kvt = ({ state: n, dispatch: e }) => {
  let { selection: t } = n, r = ge.create(t.ranges.map((i) => n.wordAt(i.head) || ge.cursor(i.head)), t.mainIndex);
  return r.eq(t) ? !1 : (e(n.update({ selection: r })), !0);
};
function qvt(n, e) {
  let { main: t, ranges: r } = n.selection, i = n.wordAt(t.head), s = i && i.from == t.from && i.to == t.to;
  for (let o = !1, a = new mh(n.doc, e, r[r.length - 1].to); ; )
    if (a.next(), a.done) {
      if (o)
        return null;
      a = new mh(n.doc, e, 0, Math.max(0, r[r.length - 1].from - 1)), o = !0;
    } else {
      if (o && r.some((l) => l.from == a.value.from))
        continue;
      if (s) {
        let l = n.wordAt(a.value.from);
        if (!l || l.from != a.value.from || l.to != a.value.to)
          continue;
      }
      return a.value;
    }
}
const Yvt = ({ state: n, dispatch: e }) => {
  let { ranges: t } = n.selection;
  if (t.some((s) => s.from === s.to))
    return Kvt({ state: n, dispatch: e });
  let r = n.sliceDoc(t[0].from, t[0].to);
  if (n.selection.ranges.some((s) => n.sliceDoc(s.from, s.to) != r))
    return !1;
  let i = qvt(n, r);
  return i ? (e(n.update({
    selection: n.selection.addRange(ge.range(i.from, i.to), !1),
    effects: Be.scrollIntoView(i.to)
  })), !0) : !1;
}, Gh = /* @__PURE__ */ je.define({
  combine(n) {
    return ka(n, {
      top: !1,
      caseSensitive: !1,
      literal: !1,
      regexp: !1,
      wholeWord: !1,
      createPanel: (e) => new a2t(e),
      scrollToMatch: (e) => Be.scrollIntoView(e)
    });
  }
});
class $ue {
  /**
  Create a query object.
  */
  constructor(e) {
    this.search = e.search, this.caseSensitive = !!e.caseSensitive, this.literal = !!e.literal, this.regexp = !!e.regexp, this.replace = e.replace || "", this.valid = !!this.search && (!this.regexp || Lvt(this.search)), this.unquoted = this.unquote(this.search), this.wholeWord = !!e.wholeWord;
  }
  /**
  @internal
  */
  unquote(e) {
    return this.literal ? e : e.replace(/\\([nrt\\])/g, (t, r) => r == "n" ? `
` : r == "r" ? "\r" : r == "t" ? "	" : "\\");
  }
  /**
  Compare this query to another query.
  */
  eq(e) {
    return this.search == e.search && this.replace == e.replace && this.caseSensitive == e.caseSensitive && this.regexp == e.regexp && this.wholeWord == e.wholeWord;
  }
  /**
  @internal
  */
  create() {
    return this.regexp ? new Jvt(this) : new Zvt(this);
  }
  /**
  Get a search cursor for this query, searching through the given
  range in the given state.
  */
  getCursor(e, t = 0, r) {
    let i = e.doc ? e : Ht.create({ doc: e });
    return r == null && (r = i.doc.length), this.regexp ? jd(this, i, t, r) : Vd(this, i, t, r);
  }
}
class Fue {
  constructor(e) {
    this.spec = e;
  }
}
function Vd(n, e, t, r) {
  return new mh(e.doc, n.unquoted, t, r, n.caseSensitive ? void 0 : (i) => i.toLowerCase(), n.wholeWord ? Xvt(e.doc, e.charCategorizer(e.selection.main.head)) : void 0);
}
function Xvt(n, e) {
  return (t, r, i, s) => ((s > t || s + i.length < r) && (s = Math.max(0, t - 2), i = n.sliceString(s, Math.min(n.length, r + 2))), (e(lw(i, t - s)) != $n.Word || e(cw(i, t - s)) != $n.Word) && (e(cw(i, r - s)) != $n.Word || e(lw(i, r - s)) != $n.Word));
}
class Zvt extends Fue {
  constructor(e) {
    super(e);
  }
  nextMatch(e, t, r) {
    let i = Vd(this.spec, e, r, e.doc.length).nextOverlapping();
    if (i.done) {
      let s = Math.min(e.doc.length, t + this.spec.unquoted.length);
      i = Vd(this.spec, e, 0, s).nextOverlapping();
    }
    return i.done || i.value.from == t && i.value.to == r ? null : i.value;
  }
  // Searching in reverse is, rather than implementing an inverted search
  // cursor, done by scanning chunk after chunk forward.
  prevMatchInRange(e, t, r) {
    for (let i = r; ; ) {
      let s = Math.max(t, i - 1e4 - this.spec.unquoted.length), o = Vd(this.spec, e, s, i), a = null;
      for (; !o.nextOverlapping().done; )
        a = o.value;
      if (a)
        return a;
      if (s == t)
        return null;
      i -= 1e4;
    }
  }
  prevMatch(e, t, r) {
    let i = this.prevMatchInRange(e, 0, t);
    return i || (i = this.prevMatchInRange(e, Math.max(0, r - this.spec.unquoted.length), e.doc.length)), i && (i.from != t || i.to != r) ? i : null;
  }
  getReplacement(e) {
    return this.spec.unquote(this.spec.replace);
  }
  matchAll(e, t) {
    let r = Vd(this.spec, e, 0, e.doc.length), i = [];
    for (; !r.next().done; ) {
      if (i.length >= t)
        return null;
      i.push(r.value);
    }
    return i;
  }
  highlight(e, t, r, i) {
    let s = Vd(this.spec, e, Math.max(0, t - this.spec.unquoted.length), Math.min(r + this.spec.unquoted.length, e.doc.length));
    for (; !s.next().done; )
      i(s.value.from, s.value.to);
  }
}
function jd(n, e, t, r) {
  return new Nue(e.doc, n.search, {
    ignoreCase: !n.caseSensitive,
    test: n.wholeWord ? Qvt(e.charCategorizer(e.selection.main.head)) : void 0
  }, t, r);
}
function lw(n, e) {
  return n.slice(Gr(n, e, !1), e);
}
function cw(n, e) {
  return n.slice(e, Gr(n, e));
}
function Qvt(n) {
  return (e, t, r) => !r[0].length || (n(lw(r.input, r.index)) != $n.Word || n(cw(r.input, r.index)) != $n.Word) && (n(cw(r.input, r.index + r[0].length)) != $n.Word || n(lw(r.input, r.index + r[0].length)) != $n.Word);
}
class Jvt extends Fue {
  nextMatch(e, t, r) {
    let i = jd(this.spec, e, r, e.doc.length).next();
    return i.done && (i = jd(this.spec, e, 0, t).next()), i.done ? null : i.value;
  }
  prevMatchInRange(e, t, r) {
    for (let i = 1; ; i++) {
      let s = Math.max(
        t,
        r - i * 1e4
        /* FindPrev.ChunkSize */
      ), o = jd(this.spec, e, s, r), a = null;
      for (; !o.next().done; )
        a = o.value;
      if (a && (s == t || a.from > s + 10))
        return a;
      if (s == t)
        return null;
    }
  }
  prevMatch(e, t, r) {
    return this.prevMatchInRange(e, 0, t) || this.prevMatchInRange(e, r, e.doc.length);
  }
  getReplacement(e) {
    return this.spec.unquote(this.spec.replace).replace(/\$([$&]|\d+)/g, (t, r) => {
      if (r == "&")
        return e.match[0];
      if (r == "$")
        return "$";
      for (let i = r.length; i > 0; i--) {
        let s = +r.slice(0, i);
        if (s > 0 && s < e.match.length)
          return e.match[s] + r.slice(i);
      }
      return t;
    });
  }
  matchAll(e, t) {
    let r = jd(this.spec, e, 0, e.doc.length), i = [];
    for (; !r.next().done; ) {
      if (i.length >= t)
        return null;
      i.push(r.value);
    }
    return i;
  }
  highlight(e, t, r, i) {
    let s = jd(this.spec, e, Math.max(
      0,
      t - 250
      /* RegExp.HighlightMargin */
    ), Math.min(r + 250, e.doc.length));
    for (; !s.next().done; )
      i(s.value.from, s.value.to);
  }
}
const t1 = /* @__PURE__ */ At.define(), uI = /* @__PURE__ */ At.define(), fc = /* @__PURE__ */ Xr.define({
  create(n) {
    return new J8(bA(n).create(), null);
  },
  update(n, e) {
    for (let t of e.effects)
      t.is(t1) ? n = new J8(t.value.create(), n.panel) : t.is(uI) && (n = new J8(n.query, t.value ? dI : null));
    return n;
  },
  provide: (n) => J0.from(n, (e) => e.panel)
});
class J8 {
  constructor(e, t) {
    this.query = e, this.panel = t;
  }
}
const e2t = /* @__PURE__ */ ct.mark({ class: "cm-searchMatch" }), t2t = /* @__PURE__ */ ct.mark({ class: "cm-searchMatch cm-searchMatch-selected" }), n2t = /* @__PURE__ */ nr.fromClass(class {
  constructor(n) {
    this.view = n, this.decorations = this.highlight(n.state.field(fc));
  }
  update(n) {
    let e = n.state.field(fc);
    (e != n.startState.field(fc) || n.docChanged || n.selectionSet || n.viewportChanged) && (this.decorations = this.highlight(e));
  }
  highlight({ query: n, panel: e }) {
    if (!e || !n.spec.valid)
      return ct.none;
    let { view: t } = this, r = new ml();
    for (let i = 0, s = t.visibleRanges, o = s.length; i < o; i++) {
      let { from: a, to: l } = s[i];
      for (; i < o - 1 && l > s[i + 1].from - 500; )
        l = s[++i].to;
      n.highlight(t.state, a, l, (c, u) => {
        let d = t.state.selection.ranges.some((f) => f.from == c && f.to == u);
        r.add(c, u, d ? t2t : e2t);
      });
    }
    return r.finish();
  }
}, {
  decorations: (n) => n.decorations
});
function Y1(n) {
  return (e) => {
    let t = e.state.field(fc, !1);
    return t && t.query.spec.valid ? n(e, t) : Hue(e);
  };
}
const uw = /* @__PURE__ */ Y1((n, { query: e }) => {
  let { to: t } = n.state.selection.main, r = e.nextMatch(n.state, t, t);
  if (!r)
    return !1;
  let i = ge.single(r.from, r.to), s = n.state.facet(Gh);
  return n.dispatch({
    selection: i,
    effects: [fI(n, r), s.scrollToMatch(i.main, n)],
    userEvent: "select.search"
  }), zue(n), !0;
}), dw = /* @__PURE__ */ Y1((n, { query: e }) => {
  let { state: t } = n, { from: r } = t.selection.main, i = e.prevMatch(t, r, r);
  if (!i)
    return !1;
  let s = ge.single(i.from, i.to), o = n.state.facet(Gh);
  return n.dispatch({
    selection: s,
    effects: [fI(n, i), o.scrollToMatch(s.main, n)],
    userEvent: "select.search"
  }), zue(n), !0;
}), r2t = /* @__PURE__ */ Y1((n, { query: e }) => {
  let t = e.matchAll(n.state, 1e3);
  return !t || !t.length ? !1 : (n.dispatch({
    selection: ge.create(t.map((r) => ge.range(r.from, r.to))),
    userEvent: "select.search.matches"
  }), !0);
}), i2t = ({ state: n, dispatch: e }) => {
  let t = n.selection;
  if (t.ranges.length > 1 || t.main.empty)
    return !1;
  let { from: r, to: i } = t.main, s = [], o = 0;
  for (let a = new mh(n.doc, n.sliceDoc(r, i)); !a.next().done; ) {
    if (s.length > 1e3)
      return !1;
    a.value.from == r && (o = s.length), s.push(ge.range(a.value.from, a.value.to));
  }
  return e(n.update({
    selection: ge.create(s, o),
    userEvent: "select.search.matches"
  })), !0;
}, qW = /* @__PURE__ */ Y1((n, { query: e }) => {
  let { state: t } = n, { from: r, to: i } = t.selection.main;
  if (t.readOnly)
    return !1;
  let s = e.nextMatch(t, r, r);
  if (!s)
    return !1;
  let o = s, a = [], l, c, u = [];
  o.from == r && o.to == i && (c = t.toText(e.getReplacement(o)), a.push({ from: o.from, to: o.to, insert: c }), o = e.nextMatch(t, o.from, o.to), u.push(Be.announce.of(t.phrase("replaced match on line $", t.doc.lineAt(r).number) + ".")));
  let d = n.state.changes(a);
  return o && (l = ge.single(o.from, o.to).map(d), u.push(fI(n, o)), u.push(t.facet(Gh).scrollToMatch(l.main, n))), n.dispatch({
    changes: d,
    selection: l,
    effects: u,
    userEvent: "input.replace"
  }), !0;
}), s2t = /* @__PURE__ */ Y1((n, { query: e }) => {
  if (n.state.readOnly)
    return !1;
  let t = e.matchAll(n.state, 1e9).map((i) => {
    let { from: s, to: o } = i;
    return { from: s, to: o, insert: e.getReplacement(i) };
  });
  if (!t.length)
    return !1;
  let r = n.state.phrase("replaced $ matches", t.length) + ".";
  return n.dispatch({
    changes: t,
    effects: Be.announce.of(r),
    userEvent: "input.replace.all"
  }), !0;
});
function dI(n) {
  return n.state.facet(Gh).createPanel(n);
}
function bA(n, e) {
  var t, r, i, s, o;
  let a = n.selection.main, l = a.empty || a.to > a.from + 100 ? "" : n.sliceDoc(a.from, a.to);
  if (e && !l)
    return e;
  let c = n.facet(Gh);
  return new $ue({
    search: ((t = e?.literal) !== null && t !== void 0 ? t : c.literal) ? l : l.replace(/\n/g, "\\n"),
    caseSensitive: (r = e?.caseSensitive) !== null && r !== void 0 ? r : c.caseSensitive,
    literal: (i = e?.literal) !== null && i !== void 0 ? i : c.literal,
    regexp: (s = e?.regexp) !== null && s !== void 0 ? s : c.regexp,
    wholeWord: (o = e?.wholeWord) !== null && o !== void 0 ? o : c.wholeWord
  });
}
function Bue(n) {
  let e = Q0(n, dI);
  return e && e.dom.querySelector("[main-field]");
}
function zue(n) {
  let e = Bue(n);
  e && e == n.root.activeElement && e.select();
}
const Hue = (n) => {
  let e = n.state.field(fc, !1);
  if (e && e.panel) {
    let t = Bue(n);
    if (t && t != n.root.activeElement) {
      let r = bA(n.state, e.query.spec);
      r.valid && n.dispatch({ effects: t1.of(r) }), t.focus(), t.select();
    }
  } else
    n.dispatch({ effects: [
      uI.of(!0),
      e ? t1.of(bA(n.state, e.query.spec)) : At.appendConfig.of(c2t)
    ] });
  return !0;
}, Uue = (n) => {
  let e = n.state.field(fc, !1);
  if (!e || !e.panel)
    return !1;
  let t = Q0(n, dI);
  return t && t.dom.contains(n.root.activeElement) && n.focus(), n.dispatch({ effects: uI.of(!1) }), !0;
}, o2t = [
  { key: "Mod-f", run: Hue, scope: "editor search-panel" },
  { key: "F3", run: uw, shift: dw, scope: "editor search-panel", preventDefault: !0 },
  { key: "Mod-g", run: uw, shift: dw, scope: "editor search-panel", preventDefault: !0 },
  { key: "Escape", run: Uue, scope: "editor search-panel" },
  { key: "Mod-Shift-l", run: i2t },
  { key: "Mod-Alt-g", run: $vt },
  { key: "Mod-d", run: Yvt, preventDefault: !0 }
];
class a2t {
  constructor(e) {
    this.view = e;
    let t = this.query = e.state.field(fc).query.spec;
    this.commit = this.commit.bind(this), this.searchField = yn("input", {
      value: t.search,
      placeholder: es(e, "Find"),
      "aria-label": es(e, "Find"),
      class: "cm-textfield",
      name: "search",
      form: "",
      "main-field": "true",
      onchange: this.commit,
      onkeyup: this.commit
    }), this.replaceField = yn("input", {
      value: t.replace,
      placeholder: es(e, "Replace"),
      "aria-label": es(e, "Replace"),
      class: "cm-textfield",
      name: "replace",
      form: "",
      onchange: this.commit,
      onkeyup: this.commit
    }), this.caseField = yn("input", {
      type: "checkbox",
      name: "case",
      form: "",
      checked: t.caseSensitive,
      onchange: this.commit
    }), this.reField = yn("input", {
      type: "checkbox",
      name: "re",
      form: "",
      checked: t.regexp,
      onchange: this.commit
    }), this.wordField = yn("input", {
      type: "checkbox",
      name: "word",
      form: "",
      checked: t.wholeWord,
      onchange: this.commit
    });
    function r(i, s, o) {
      return yn("button", { class: "cm-button", name: i, onclick: s, type: "button" }, o);
    }
    this.dom = yn("div", { onkeydown: (i) => this.keydown(i), class: "cm-search" }, [
      this.searchField,
      r("next", () => uw(e), [es(e, "next")]),
      r("prev", () => dw(e), [es(e, "previous")]),
      r("select", () => r2t(e), [es(e, "all")]),
      yn("label", null, [this.caseField, es(e, "match case")]),
      yn("label", null, [this.reField, es(e, "regexp")]),
      yn("label", null, [this.wordField, es(e, "by word")]),
      ...e.state.readOnly ? [] : [
        yn("br"),
        this.replaceField,
        r("replace", () => qW(e), [es(e, "replace")]),
        r("replaceAll", () => s2t(e), [es(e, "replace all")])
      ],
      yn("button", {
        name: "close",
        onclick: () => Uue(e),
        "aria-label": es(e, "close"),
        type: "button"
      }, ["×"])
    ]);
  }
  commit() {
    let e = new $ue({
      search: this.searchField.value,
      caseSensitive: this.caseField.checked,
      regexp: this.reField.checked,
      wholeWord: this.wordField.checked,
      replace: this.replaceField.value
    });
    e.eq(this.query) || (this.query = e, this.view.dispatch({ effects: t1.of(e) }));
  }
  keydown(e) {
    y0t(this.view, e, "search-panel") ? e.preventDefault() : e.keyCode == 13 && e.target == this.searchField ? (e.preventDefault(), (e.shiftKey ? dw : uw)(this.view)) : e.keyCode == 13 && e.target == this.replaceField && (e.preventDefault(), qW(this.view));
  }
  update(e) {
    for (let t of e.transactions)
      for (let r of t.effects)
        r.is(t1) && !r.value.eq(this.query) && this.setQuery(r.value);
  }
  setQuery(e) {
    this.query = e, this.searchField.value = e.search, this.replaceField.value = e.replace, this.caseField.checked = e.caseSensitive, this.reField.checked = e.regexp, this.wordField.checked = e.wholeWord;
  }
  mount() {
    this.searchField.select();
  }
  get pos() {
    return 80;
  }
  get top() {
    return this.view.state.facet(Gh).top;
  }
}
function es(n, e) {
  return n.state.phrase(e);
}
const Dv = 30, Nv = /[\s\.,:;?!]/;
function fI(n, { from: e, to: t }) {
  let r = n.state.doc.lineAt(e), i = n.state.doc.lineAt(t).to, s = Math.max(r.from, e - Dv), o = Math.min(i, t + Dv), a = n.state.sliceDoc(s, o);
  if (s != r.from) {
    for (let l = 0; l < Dv; l++)
      if (!Nv.test(a[l + 1]) && Nv.test(a[l])) {
        a = a.slice(l);
        break;
      }
  }
  if (o != i) {
    for (let l = a.length - 1; l > a.length - Dv; l--)
      if (!Nv.test(a[l - 1]) && Nv.test(a[l])) {
        a = a.slice(0, l);
        break;
      }
  }
  return Be.announce.of(`${n.state.phrase("current match")}. ${a} ${n.state.phrase("on line")} ${r.number}.`);
}
const l2t = /* @__PURE__ */ Be.baseTheme({
  ".cm-panel.cm-search": {
    padding: "2px 6px 4px",
    position: "relative",
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "4px",
      backgroundColor: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    },
    "& input, & button, & label": {
      margin: ".2em .6em .2em 0"
    },
    "& input[type=checkbox]": {
      marginRight: ".2em"
    },
    "& label": {
      fontSize: "80%",
      whiteSpace: "pre"
    }
  },
  "&light .cm-searchMatch": { backgroundColor: "#ffff0054" },
  "&dark .cm-searchMatch": { backgroundColor: "#00ffff8a" },
  "&light .cm-searchMatch-selected": { backgroundColor: "#ff6a0054" },
  "&dark .cm-searchMatch-selected": { backgroundColor: "#ff00ff8a" }
}), c2t = [
  fc,
  /* @__PURE__ */ hd.low(n2t),
  l2t
];
class Vue {
  /**
  Create a new completion context. (Mostly useful for testing
  completion sources—in the editor, the extension will create
  these for you.)
  */
  constructor(e, t, r, i) {
    this.state = e, this.pos = t, this.explicit = r, this.view = i, this.abortListeners = [], this.abortOnDocChange = !1;
  }
  /**
  Get the extent, content, and (if there is a token) type of the
  token before `this.pos`.
  */
  tokenBefore(e) {
    let t = ai(this.state).resolveInner(this.pos, -1);
    for (; t && e.indexOf(t.name) < 0; )
      t = t.parent;
    return t ? {
      from: t.from,
      to: this.pos,
      text: this.state.sliceDoc(t.from, this.pos),
      type: t.type
    } : null;
  }
  /**
  Get the match of the given expression directly before the
  cursor.
  */
  matchBefore(e) {
    let t = this.state.doc.lineAt(this.pos), r = Math.max(t.from, this.pos - 250), i = t.text.slice(r - t.from, this.pos - t.from), s = i.search(jue(e, !1));
    return s < 0 ? null : { from: r + s, to: this.pos, text: i.slice(s) };
  }
  /**
  Yields true when the query has been aborted. Can be useful in
  asynchronous queries to avoid doing work that will be ignored.
  */
  get aborted() {
    return this.abortListeners == null;
  }
  /**
  Allows you to register abort handlers, which will be called when
  the query is
  [aborted](https://codemirror.net/6/docs/ref/#autocomplete.CompletionContext.aborted).
  
  By default, running queries will not be aborted for regular
  typing or backspacing, on the assumption that they are likely to
  return a result with a
  [`validFor`](https://codemirror.net/6/docs/ref/#autocomplete.CompletionResult.validFor) field that
  allows the result to be used after all. Passing `onDocChange:
  true` will cause this query to be aborted for any document
  change.
  */
  addEventListener(e, t, r) {
    e == "abort" && this.abortListeners && (this.abortListeners.push(t), r && r.onDocChange && (this.abortOnDocChange = !0));
  }
}
function YW(n) {
  let e = Object.keys(n).join(""), t = /\w/.test(e);
  return t && (e = e.replace(/\w/g, "")), `[${t ? "\\w" : ""}${e.replace(/[^\w\s]/g, "\\$&")}]`;
}
function u2t(n) {
  let e = /* @__PURE__ */ Object.create(null), t = /* @__PURE__ */ Object.create(null);
  for (let { label: i } of n) {
    e[i[0]] = !0;
    for (let s = 1; s < i.length; s++)
      t[i[s]] = !0;
  }
  let r = YW(e) + YW(t) + "*$";
  return [new RegExp("^" + r), new RegExp(r)];
}
function d2t(n) {
  let e = n.map((i) => typeof i == "string" ? { label: i } : i), [t, r] = e.every((i) => /^\w+$/.test(i.label)) ? [/\w*$/, /\w+$/] : u2t(e);
  return (i) => {
    let s = i.matchBefore(r);
    return s || i.explicit ? { from: s ? s.from : i.pos, options: e, validFor: t } : null;
  };
}
class XW {
  constructor(e, t, r, i) {
    this.completion = e, this.source = t, this.match = r, this.score = i;
  }
}
function Ou(n) {
  return n.selection.main.from;
}
function jue(n, e) {
  var t;
  let { source: r } = n, i = e && r[0] != "^", s = r[r.length - 1] != "$";
  return !i && !s ? n : new RegExp(`${i ? "^" : ""}(?:${r})${s ? "$" : ""}`, (t = n.flags) !== null && t !== void 0 ? t : n.ignoreCase ? "i" : "");
}
const Wue = /* @__PURE__ */ Ma.define();
function f2t(n, e, t, r) {
  let { main: i } = n.selection, s = t - i.from, o = r - i.from;
  return {
    ...n.changeByRange((a) => {
      if (a != i && t != r && n.sliceDoc(a.from + s, a.from + o) != n.sliceDoc(t, r))
        return { range: a };
      let l = n.toText(e);
      return {
        changes: { from: a.from + s, to: r == i.from ? a.to : a.from + o, insert: l },
        range: ge.cursor(a.from + s + l.length)
      };
    }),
    scrollIntoView: !0,
    userEvent: "input.complete"
  };
}
const ZW = /* @__PURE__ */ new WeakMap();
function h2t(n) {
  if (!Array.isArray(n))
    return n;
  let e = ZW.get(n);
  return e || ZW.set(n, e = d2t(n)), e;
}
const fw = /* @__PURE__ */ At.define(), n1 = /* @__PURE__ */ At.define();
class p2t {
  constructor(e) {
    this.pattern = e, this.chars = [], this.folded = [], this.any = [], this.precise = [], this.byWord = [], this.score = 0, this.matched = [];
    for (let t = 0; t < e.length; ) {
      let r = Pi(e, t), i = Jo(r);
      this.chars.push(r);
      let s = e.slice(t, t + i), o = s.toUpperCase();
      this.folded.push(Pi(o == s ? s.toLowerCase() : o, 0)), t += i;
    }
    this.astral = e.length != this.chars.length;
  }
  ret(e, t) {
    return this.score = e, this.matched = t, this;
  }
  // Matches a given word (completion) against the pattern (input).
  // Will return a boolean indicating whether there was a match and,
  // on success, set `this.score` to the score, `this.matched` to an
  // array of `from, to` pairs indicating the matched parts of `word`.
  //
  // The score is a number that is more negative the worse the match
  // is. See `Penalty` above.
  match(e) {
    if (this.pattern.length == 0)
      return this.ret(-100, []);
    if (e.length < this.pattern.length)
      return null;
    let { chars: t, folded: r, any: i, precise: s, byWord: o } = this;
    if (t.length == 1) {
      let b = Pi(e, 0), x = Jo(b), E = x == e.length ? 0 : -100;
      if (b != t[0]) if (b == r[0])
        E += -200;
      else
        return null;
      return this.ret(E, [0, x]);
    }
    let a = e.indexOf(this.pattern);
    if (a == 0)
      return this.ret(e.length == this.pattern.length ? 0 : -100, [0, this.pattern.length]);
    let l = t.length, c = 0;
    if (a < 0) {
      for (let b = 0, x = Math.min(e.length, 200); b < x && c < l; ) {
        let E = Pi(e, b);
        (E == t[c] || E == r[c]) && (i[c++] = b), b += Jo(E);
      }
      if (c < l)
        return null;
    }
    let u = 0, d = 0, f = !1, h = 0, m = -1, g = -1, v = /[a-z]/.test(e), y = !0;
    for (let b = 0, x = Math.min(e.length, 200), E = 0; b < x && d < l; ) {
      let w = Pi(e, b);
      a < 0 && (u < l && w == t[u] && (s[u++] = b), h < l && (w == t[h] || w == r[h] ? (h == 0 && (m = b), g = b + 1, h++) : h = 0));
      let C, S = w < 255 ? w >= 48 && w <= 57 || w >= 97 && w <= 122 ? 2 : w >= 65 && w <= 90 ? 1 : 0 : (C = UO(w)) != C.toLowerCase() ? 1 : C != C.toUpperCase() ? 2 : 0;
      (!b || S == 1 && v || E == 0 && S != 0) && (t[d] == w || r[d] == w && (f = !0) ? o[d++] = b : o.length && (y = !1)), E = S, b += Jo(w);
    }
    return d == l && o[0] == 0 && y ? this.result(-100 + (f ? -200 : 0), o, e) : h == l && m == 0 ? this.ret(-200 - e.length + (g == e.length ? 0 : -100), [0, g]) : a > -1 ? this.ret(-700 - e.length, [a, a + this.pattern.length]) : h == l ? this.ret(-900 - e.length, [m, g]) : d == l ? this.result(-100 + (f ? -200 : 0) + -700 + (y ? 0 : -1100), o, e) : t.length == 2 ? null : this.result((i[0] ? -700 : 0) + -200 + -1100, i, e);
  }
  result(e, t, r) {
    let i = [], s = 0;
    for (let o of t) {
      let a = o + (this.astral ? Jo(Pi(r, o)) : 1);
      s && i[s - 1] == o ? i[s - 1] = a : (i[s++] = o, i[s++] = a);
    }
    return this.ret(e - r.length, i);
  }
}
class m2t {
  constructor(e) {
    this.pattern = e, this.matched = [], this.score = 0, this.folded = e.toLowerCase();
  }
  match(e) {
    if (e.length < this.pattern.length)
      return null;
    let t = e.slice(0, this.pattern.length), r = t == this.pattern ? 0 : t.toLowerCase() == this.folded ? -200 : null;
    return r == null ? null : (this.matched = [0, t.length], this.score = r + (e.length == this.pattern.length ? 0 : -100), this);
  }
}
const _r = /* @__PURE__ */ je.define({
  combine(n) {
    return ka(n, {
      activateOnTyping: !0,
      activateOnCompletion: () => !1,
      activateOnTypingDelay: 100,
      selectOnOpen: !0,
      override: null,
      closeOnBlur: !0,
      maxRenderedOptions: 100,
      defaultKeymap: !0,
      tooltipClass: () => "",
      optionClass: () => "",
      aboveCursor: !1,
      icons: !0,
      addToOptions: [],
      positionInfo: g2t,
      filterStrict: !1,
      compareCompletions: (e, t) => e.label.localeCompare(t.label),
      interactionDelay: 75,
      updateSyncTime: 100
    }, {
      defaultKeymap: (e, t) => e && t,
      closeOnBlur: (e, t) => e && t,
      icons: (e, t) => e && t,
      tooltipClass: (e, t) => (r) => QW(e(r), t(r)),
      optionClass: (e, t) => (r) => QW(e(r), t(r)),
      addToOptions: (e, t) => e.concat(t),
      filterStrict: (e, t) => e || t
    });
  }
});
function QW(n, e) {
  return n ? e ? n + " " + e : n : e;
}
function g2t(n, e, t, r, i, s) {
  let o = n.textDirection == Dn.RTL, a = o, l = !1, c = "top", u, d, f = e.left - i.left, h = i.right - e.right, m = r.right - r.left, g = r.bottom - r.top;
  if (a && f < Math.min(m, h) ? a = !1 : !a && h < Math.min(m, f) && (a = !0), m <= (a ? f : h))
    u = Math.max(i.top, Math.min(t.top, i.bottom - g)) - e.top, d = Math.min(400, a ? f : h);
  else {
    l = !0, d = Math.min(
      400,
      (o ? e.right : i.right - e.left) - 30
      /* Info.Margin */
    );
    let b = i.bottom - e.bottom;
    b >= g || b > e.top ? u = t.bottom - e.top : (c = "bottom", u = e.bottom - t.top);
  }
  let v = (e.bottom - e.top) / s.offsetHeight, y = (e.right - e.left) / s.offsetWidth;
  return {
    style: `${c}: ${u / v}px; max-width: ${d / y}px`,
    class: "cm-completionInfo-" + (l ? o ? "left-narrow" : "right-narrow" : a ? "left" : "right")
  };
}
function v2t(n) {
  let e = n.addToOptions.slice();
  return n.icons && e.push({
    render(t) {
      let r = document.createElement("div");
      return r.classList.add("cm-completionIcon"), t.type && r.classList.add(...t.type.split(/\s+/g).map((i) => "cm-completionIcon-" + i)), r.setAttribute("aria-hidden", "true"), r;
    },
    position: 20
  }), e.push({
    render(t, r, i, s) {
      let o = document.createElement("span");
      o.className = "cm-completionLabel";
      let a = t.displayLabel || t.label, l = 0;
      for (let c = 0; c < s.length; ) {
        let u = s[c++], d = s[c++];
        u > l && o.appendChild(document.createTextNode(a.slice(l, u)));
        let f = o.appendChild(document.createElement("span"));
        f.appendChild(document.createTextNode(a.slice(u, d))), f.className = "cm-completionMatchedText", l = d;
      }
      return l < a.length && o.appendChild(document.createTextNode(a.slice(l))), o;
    },
    position: 50
  }, {
    render(t) {
      if (!t.detail)
        return null;
      let r = document.createElement("span");
      return r.className = "cm-completionDetail", r.textContent = t.detail, r;
    },
    position: 80
  }), e.sort((t, r) => t.position - r.position).map((t) => t.render);
}
function eC(n, e, t) {
  if (n <= t)
    return { from: 0, to: n };
  if (e < 0 && (e = 0), e <= n >> 1) {
    let i = Math.floor(e / t);
    return { from: i * t, to: (i + 1) * t };
  }
  let r = Math.floor((n - e) / t);
  return { from: n - (r + 1) * t, to: n - r * t };
}
class y2t {
  constructor(e, t, r) {
    this.view = e, this.stateField = t, this.applyCompletion = r, this.info = null, this.infoDestroy = null, this.placeInfoReq = {
      read: () => this.measureInfo(),
      write: (l) => this.placeInfo(l),
      key: this
    }, this.space = null, this.currentClass = "";
    let i = e.state.field(t), { options: s, selected: o } = i.open, a = e.state.facet(_r);
    this.optionContent = v2t(a), this.optionClass = a.optionClass, this.tooltipClass = a.tooltipClass, this.range = eC(s.length, o, a.maxRenderedOptions), this.dom = document.createElement("div"), this.dom.className = "cm-tooltip-autocomplete", this.updateTooltipClass(e.state), this.dom.addEventListener("mousedown", (l) => {
      let { options: c } = e.state.field(t).open;
      for (let u = l.target, d; u && u != this.dom; u = u.parentNode)
        if (u.nodeName == "LI" && (d = /-(\d+)$/.exec(u.id)) && +d[1] < c.length) {
          this.applyCompletion(e, c[+d[1]]), l.preventDefault();
          return;
        }
    }), this.dom.addEventListener("focusout", (l) => {
      let c = e.state.field(this.stateField, !1);
      c && c.tooltip && e.state.facet(_r).closeOnBlur && l.relatedTarget != e.contentDOM && e.dispatch({ effects: n1.of(null) });
    }), this.showOptions(s, i.id);
  }
  mount() {
    this.updateSel();
  }
  showOptions(e, t) {
    this.list && this.list.remove(), this.list = this.dom.appendChild(this.createListBox(e, t, this.range)), this.list.addEventListener("scroll", () => {
      this.info && this.view.requestMeasure(this.placeInfoReq);
    });
  }
  update(e) {
    var t;
    let r = e.state.field(this.stateField), i = e.startState.field(this.stateField);
    if (this.updateTooltipClass(e.state), r != i) {
      let { options: s, selected: o, disabled: a } = r.open;
      (!i.open || i.open.options != s) && (this.range = eC(s.length, o, e.state.facet(_r).maxRenderedOptions), this.showOptions(s, r.id)), this.updateSel(), a != ((t = i.open) === null || t === void 0 ? void 0 : t.disabled) && this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!a);
    }
  }
  updateTooltipClass(e) {
    let t = this.tooltipClass(e);
    if (t != this.currentClass) {
      for (let r of this.currentClass.split(" "))
        r && this.dom.classList.remove(r);
      for (let r of t.split(" "))
        r && this.dom.classList.add(r);
      this.currentClass = t;
    }
  }
  positioned(e) {
    this.space = e, this.info && this.view.requestMeasure(this.placeInfoReq);
  }
  updateSel() {
    let e = this.view.state.field(this.stateField), t = e.open;
    (t.selected > -1 && t.selected < this.range.from || t.selected >= this.range.to) && (this.range = eC(t.options.length, t.selected, this.view.state.facet(_r).maxRenderedOptions), this.showOptions(t.options, e.id));
    let r = this.updateSelectedOption(t.selected);
    if (r) {
      this.destroyInfo();
      let { completion: i } = t.options[t.selected], { info: s } = i;
      if (!s)
        return;
      let o = typeof s == "string" ? document.createTextNode(s) : s(i);
      if (!o)
        return;
      "then" in o ? o.then((a) => {
        a && this.view.state.field(this.stateField, !1) == e && this.addInfoPane(a, i);
      }).catch((a) => zi(this.view.state, a, "completion info")) : (this.addInfoPane(o, i), r.setAttribute("aria-describedby", this.info.id));
    }
  }
  addInfoPane(e, t) {
    this.destroyInfo();
    let r = this.info = document.createElement("div");
    if (r.className = "cm-tooltip cm-completionInfo", r.id = "cm-completionInfo-" + Math.floor(Math.random() * 65535).toString(16), e.nodeType != null)
      r.appendChild(e), this.infoDestroy = null;
    else {
      let { dom: i, destroy: s } = e;
      r.appendChild(i), this.infoDestroy = s || null;
    }
    this.dom.appendChild(r), this.view.requestMeasure(this.placeInfoReq);
  }
  updateSelectedOption(e) {
    let t = null;
    for (let r = this.list.firstChild, i = this.range.from; r; r = r.nextSibling, i++)
      r.nodeName != "LI" || !r.id ? i-- : i == e ? r.hasAttribute("aria-selected") || (r.setAttribute("aria-selected", "true"), t = r) : r.hasAttribute("aria-selected") && (r.removeAttribute("aria-selected"), r.removeAttribute("aria-describedby"));
    return t && w2t(this.list, t), t;
  }
  measureInfo() {
    let e = this.dom.querySelector("[aria-selected]");
    if (!e || !this.info)
      return null;
    let t = this.dom.getBoundingClientRect(), r = this.info.getBoundingClientRect(), i = e.getBoundingClientRect(), s = this.space;
    if (!s) {
      let o = this.dom.ownerDocument.documentElement;
      s = { left: 0, top: 0, right: o.clientWidth, bottom: o.clientHeight };
    }
    return i.top > Math.min(s.bottom, t.bottom) - 10 || i.bottom < Math.max(s.top, t.top) + 10 ? null : this.view.state.facet(_r).positionInfo(this.view, t, i, r, s, this.dom);
  }
  placeInfo(e) {
    this.info && (e ? (e.style && (this.info.style.cssText = e.style), this.info.className = "cm-tooltip cm-completionInfo " + (e.class || "")) : this.info.style.cssText = "top: -1e6px");
  }
  createListBox(e, t, r) {
    const i = document.createElement("ul");
    i.id = t, i.setAttribute("role", "listbox"), i.setAttribute("aria-expanded", "true"), i.setAttribute("aria-label", this.view.state.phrase("Completions")), i.addEventListener("mousedown", (o) => {
      o.target == i && o.preventDefault();
    });
    let s = null;
    for (let o = r.from; o < r.to; o++) {
      let { completion: a, match: l } = e[o], { section: c } = a;
      if (c) {
        let f = typeof c == "string" ? c : c.name;
        if (f != s && (o > r.from || r.from == 0))
          if (s = f, typeof c != "string" && c.header)
            i.appendChild(c.header(c));
          else {
            let h = i.appendChild(document.createElement("completion-section"));
            h.textContent = f;
          }
      }
      const u = i.appendChild(document.createElement("li"));
      u.id = t + "-" + o, u.setAttribute("role", "option");
      let d = this.optionClass(a);
      d && (u.className = d);
      for (let f of this.optionContent) {
        let h = f(a, this.view.state, this.view, l);
        h && u.appendChild(h);
      }
    }
    return r.from && i.classList.add("cm-completionListIncompleteTop"), r.to < e.length && i.classList.add("cm-completionListIncompleteBottom"), i;
  }
  destroyInfo() {
    this.info && (this.infoDestroy && this.infoDestroy(), this.info.remove(), this.info = null);
  }
  destroy() {
    this.destroyInfo();
  }
}
function b2t(n, e) {
  return (t) => new y2t(t, n, e);
}
function w2t(n, e) {
  let t = n.getBoundingClientRect(), r = e.getBoundingClientRect(), i = t.height / n.offsetHeight;
  r.top < t.top ? n.scrollTop -= (t.top - r.top) / i : r.bottom > t.bottom && (n.scrollTop += (r.bottom - t.bottom) / i);
}
function JW(n) {
  return (n.boost || 0) * 100 + (n.apply ? 10 : 0) + (n.info ? 5 : 0) + (n.type ? 1 : 0);
}
function x2t(n, e) {
  let t = [], r = null, i = null, s = (u) => {
    t.push(u);
    let { section: d } = u.completion;
    if (d) {
      r || (r = []);
      let f = typeof d == "string" ? d : d.name;
      r.some((h) => h.name == f) || r.push(typeof d == "string" ? { name: f } : d);
    }
  }, o = e.facet(_r);
  for (let u of n)
    if (u.hasResult()) {
      let d = u.result.getMatch;
      if (u.result.filter === !1)
        for (let f of u.result.options)
          s(new XW(f, u.source, d ? d(f) : [], 1e9 - t.length));
      else {
        let f = e.sliceDoc(u.from, u.to), h, m = o.filterStrict ? new m2t(f) : new p2t(f);
        for (let g of u.result.options)
          if (h = m.match(g.label)) {
            let v = g.displayLabel ? d ? d(g, h.matched) : [] : h.matched, y = h.score + (g.boost || 0);
            if (s(new XW(g, u.source, v, y)), typeof g.section == "object" && g.section.rank === "dynamic") {
              let { name: b } = g.section;
              i || (i = /* @__PURE__ */ Object.create(null)), i[b] = Math.max(y, i[b] || -1e9);
            }
          }
      }
    }
  if (r) {
    let u = /* @__PURE__ */ Object.create(null), d = 0, f = (h, m) => (h.rank === "dynamic" && m.rank === "dynamic" ? i[m.name] - i[h.name] : 0) || (typeof h.rank == "number" ? h.rank : 1e9) - (typeof m.rank == "number" ? m.rank : 1e9) || (h.name < m.name ? -1 : 1);
    for (let h of r.sort(f))
      d -= 1e5, u[h.name] = d;
    for (let h of t) {
      let { section: m } = h.completion;
      m && (h.score += u[typeof m == "string" ? m : m.name]);
    }
  }
  let a = [], l = null, c = o.compareCompletions;
  for (let u of t.sort((d, f) => f.score - d.score || c(d.completion, f.completion))) {
    let d = u.completion;
    !l || l.label != d.label || l.detail != d.detail || l.type != null && d.type != null && l.type != d.type || l.apply != d.apply || l.boost != d.boost ? a.push(u) : JW(u.completion) > JW(l) && (a[a.length - 1] = u), l = u.completion;
  }
  return a;
}
class tf {
  constructor(e, t, r, i, s, o) {
    this.options = e, this.attrs = t, this.tooltip = r, this.timestamp = i, this.selected = s, this.disabled = o;
  }
  setSelected(e, t) {
    return e == this.selected || e >= this.options.length ? this : new tf(this.options, eG(t, e), this.tooltip, this.timestamp, e, this.disabled);
  }
  static build(e, t, r, i, s, o) {
    if (i && !o && e.some((c) => c.isPending))
      return i.setDisabled();
    let a = x2t(e, t);
    if (!a.length)
      return i && e.some((c) => c.isPending) ? i.setDisabled() : null;
    let l = t.facet(_r).selectOnOpen ? 0 : -1;
    if (i && i.selected != l && i.selected != -1) {
      let c = i.options[i.selected].completion;
      for (let u = 0; u < a.length; u++)
        if (a[u].completion == c) {
          l = u;
          break;
        }
    }
    return new tf(a, eG(r, l), {
      pos: e.reduce((c, u) => u.hasResult() ? Math.min(c, u.from) : c, 1e8),
      create: M2t,
      above: s.aboveCursor
    }, i ? i.timestamp : Date.now(), l, !1);
  }
  map(e) {
    return new tf(this.options, this.attrs, { ...this.tooltip, pos: e.mapPos(this.tooltip.pos) }, this.timestamp, this.selected, this.disabled);
  }
  setDisabled() {
    return new tf(this.options, this.attrs, this.tooltip, this.timestamp, this.selected, !0);
  }
}
class hw {
  constructor(e, t, r) {
    this.active = e, this.id = t, this.open = r;
  }
  static start() {
    return new hw(T2t, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
  }
  update(e) {
    let { state: t } = e, r = t.facet(_r), s = (r.override || t.languageDataAt("autocomplete", Ou(t)).map(h2t)).map((l) => (this.active.find((u) => u.source == l) || new Ns(
      l,
      this.active.some(
        (u) => u.state != 0
        /* State.Inactive */
      ) ? 1 : 0
      /* State.Inactive */
    )).update(e, r));
    s.length == this.active.length && s.every((l, c) => l == this.active[c]) && (s = this.active);
    let o = this.open, a = e.effects.some((l) => l.is(hI));
    o && e.docChanged && (o = o.map(e.changes)), e.selection || s.some((l) => l.hasResult() && e.changes.touchesRange(l.from, l.to)) || !E2t(s, this.active) || a ? o = tf.build(s, t, this.id, o, r, a) : o && o.disabled && !s.some((l) => l.isPending) && (o = null), !o && s.every((l) => !l.isPending) && s.some((l) => l.hasResult()) && (s = s.map((l) => l.hasResult() ? new Ns(
      l.source,
      0
      /* State.Inactive */
    ) : l));
    for (let l of e.effects)
      l.is(Kue) && (o = o && o.setSelected(l.value, this.id));
    return s == this.active && o == this.open ? this : new hw(s, this.id, o);
  }
  get tooltip() {
    return this.open ? this.open.tooltip : null;
  }
  get attrs() {
    return this.open ? this.open.attrs : this.active.length ? S2t : C2t;
  }
}
function E2t(n, e) {
  if (n == e)
    return !0;
  for (let t = 0, r = 0; ; ) {
    for (; t < n.length && !n[t].hasResult(); )
      t++;
    for (; r < e.length && !e[r].hasResult(); )
      r++;
    let i = t == n.length, s = r == e.length;
    if (i || s)
      return i == s;
    if (n[t++].result != e[r++].result)
      return !1;
  }
}
const S2t = {
  "aria-autocomplete": "list"
}, C2t = {};
function eG(n, e) {
  let t = {
    "aria-autocomplete": "list",
    "aria-haspopup": "listbox",
    "aria-controls": n
  };
  return e > -1 && (t["aria-activedescendant"] = n + "-" + e), t;
}
const T2t = [];
function Gue(n, e) {
  if (n.isUserEvent("input.complete")) {
    let r = n.annotation(Wue);
    if (r && e.activateOnCompletion(r))
      return 12;
  }
  let t = n.isUserEvent("input.type");
  return t && e.activateOnTyping ? 5 : t ? 1 : n.isUserEvent("delete.backward") ? 2 : n.selection ? 8 : n.docChanged ? 16 : 0;
}
class Ns {
  constructor(e, t, r = !1) {
    this.source = e, this.state = t, this.explicit = r;
  }
  hasResult() {
    return !1;
  }
  get isPending() {
    return this.state == 1;
  }
  update(e, t) {
    let r = Gue(e, t), i = this;
    (r & 8 || r & 16 && this.touches(e)) && (i = new Ns(
      i.source,
      0
      /* State.Inactive */
    )), r & 4 && i.state == 0 && (i = new Ns(
      this.source,
      1
      /* State.Pending */
    )), i = i.updateFor(e, r);
    for (let s of e.effects)
      if (s.is(fw))
        i = new Ns(i.source, 1, s.value);
      else if (s.is(n1))
        i = new Ns(
          i.source,
          0
          /* State.Inactive */
        );
      else if (s.is(hI))
        for (let o of s.value)
          o.source == i.source && (i = o);
    return i;
  }
  updateFor(e, t) {
    return this.map(e.changes);
  }
  map(e) {
    return this;
  }
  touches(e) {
    return e.changes.touchesRange(Ou(e.state));
  }
}
class Ef extends Ns {
  constructor(e, t, r, i, s, o) {
    super(e, 3, t), this.limit = r, this.result = i, this.from = s, this.to = o;
  }
  hasResult() {
    return !0;
  }
  updateFor(e, t) {
    var r;
    if (!(t & 3))
      return this.map(e.changes);
    let i = this.result;
    i.map && !e.changes.empty && (i = i.map(i, e.changes));
    let s = e.changes.mapPos(this.from), o = e.changes.mapPos(this.to, 1), a = Ou(e.state);
    if (a > o || !i || t & 2 && (Ou(e.startState) == this.from || a < this.limit))
      return new Ns(
        this.source,
        t & 4 ? 1 : 0
        /* State.Inactive */
      );
    let l = e.changes.mapPos(this.limit);
    return A2t(i.validFor, e.state, s, o) ? new Ef(this.source, this.explicit, l, i, s, o) : i.update && (i = i.update(i, s, o, new Vue(e.state, a, !1))) ? new Ef(this.source, this.explicit, l, i, i.from, (r = i.to) !== null && r !== void 0 ? r : Ou(e.state)) : new Ns(this.source, 1, this.explicit);
  }
  map(e) {
    return e.empty ? this : (this.result.map ? this.result.map(this.result, e) : this.result) ? new Ef(this.source, this.explicit, e.mapPos(this.limit), this.result, e.mapPos(this.from), e.mapPos(this.to, 1)) : new Ns(
      this.source,
      0
      /* State.Inactive */
    );
  }
  touches(e) {
    return e.changes.touchesRange(this.from, this.to);
  }
}
function A2t(n, e, t, r) {
  if (!n)
    return !1;
  let i = e.sliceDoc(t, r);
  return typeof n == "function" ? n(i, t, r, e) : jue(n, !0).test(i);
}
const hI = /* @__PURE__ */ At.define({
  map(n, e) {
    return n.map((t) => t.map(e));
  }
}), Kue = /* @__PURE__ */ At.define(), Di = /* @__PURE__ */ Xr.define({
  create() {
    return hw.start();
  },
  update(n, e) {
    return n.update(e);
  },
  provide: (n) => [
    nI.from(n, (e) => e.tooltip),
    Be.contentAttributes.from(n, (e) => e.attrs)
  ]
});
function pI(n, e) {
  const t = e.completion.apply || e.completion.label;
  let r = n.state.field(Di).active.find((i) => i.source == e.source);
  return r instanceof Ef ? (typeof t == "string" ? n.dispatch({
    ...f2t(n.state, t, r.from, r.to),
    annotations: Wue.of(e.completion)
  }) : t(n, e.completion, r.from, r.to), !0) : !1;
}
const M2t = /* @__PURE__ */ b2t(Di, pI);
function Lv(n, e = "option") {
  return (t) => {
    let r = t.state.field(Di, !1);
    if (!r || !r.open || r.open.disabled || Date.now() - r.open.timestamp < t.state.facet(_r).interactionDelay)
      return !1;
    let i = 1, s;
    e == "page" && (s = Nce(t, r.open.tooltip)) && (i = Math.max(2, Math.floor(s.dom.offsetHeight / s.dom.querySelector("li").offsetHeight) - 1));
    let { length: o } = r.open.options, a = r.open.selected > -1 ? r.open.selected + i * (n ? 1 : -1) : n ? 0 : o - 1;
    return a < 0 ? a = e == "page" ? 0 : o - 1 : a >= o && (a = e == "page" ? o - 1 : 0), t.dispatch({ effects: Kue.of(a) }), !0;
  };
}
const k2t = (n) => {
  let e = n.state.field(Di, !1);
  return n.state.readOnly || !e || !e.open || e.open.selected < 0 || e.open.disabled || Date.now() - e.open.timestamp < n.state.facet(_r).interactionDelay ? !1 : pI(n, e.open.options[e.open.selected]);
}, tC = (n) => n.state.field(Di, !1) ? (n.dispatch({ effects: fw.of(!0) }), !0) : !1, _2t = (n) => {
  let e = n.state.field(Di, !1);
  return !e || !e.active.some(
    (t) => t.state != 0
    /* State.Inactive */
  ) ? !1 : (n.dispatch({ effects: n1.of(null) }), !0);
};
class O2t {
  constructor(e, t) {
    this.active = e, this.context = t, this.time = Date.now(), this.updates = [], this.done = void 0;
  }
}
const I2t = 50, R2t = 1e3, P2t = /* @__PURE__ */ nr.fromClass(class {
  constructor(n) {
    this.view = n, this.debounceUpdate = -1, this.running = [], this.debounceAccept = -1, this.pendingStart = !1, this.composing = 0;
    for (let e of n.state.field(Di).active)
      e.isPending && this.startQuery(e);
  }
  update(n) {
    let e = n.state.field(Di), t = n.state.facet(_r);
    if (!n.selectionSet && !n.docChanged && n.startState.field(Di) == e)
      return;
    let r = n.transactions.some((s) => {
      let o = Gue(s, t);
      return o & 8 || (s.selection || s.docChanged) && !(o & 3);
    });
    for (let s = 0; s < this.running.length; s++) {
      let o = this.running[s];
      if (r || o.context.abortOnDocChange && n.docChanged || o.updates.length + n.transactions.length > I2t && Date.now() - o.time > R2t) {
        for (let a of o.context.abortListeners)
          try {
            a();
          } catch (l) {
            zi(this.view.state, l);
          }
        o.context.abortListeners = null, this.running.splice(s--, 1);
      } else
        o.updates.push(...n.transactions);
    }
    this.debounceUpdate > -1 && clearTimeout(this.debounceUpdate), n.transactions.some((s) => s.effects.some((o) => o.is(fw))) && (this.pendingStart = !0);
    let i = this.pendingStart ? 50 : t.activateOnTypingDelay;
    if (this.debounceUpdate = e.active.some((s) => s.isPending && !this.running.some((o) => o.active.source == s.source)) ? setTimeout(() => this.startUpdate(), i) : -1, this.composing != 0)
      for (let s of n.transactions)
        s.isUserEvent("input.type") ? this.composing = 2 : this.composing == 2 && s.selection && (this.composing = 3);
  }
  startUpdate() {
    this.debounceUpdate = -1, this.pendingStart = !1;
    let { state: n } = this.view, e = n.field(Di);
    for (let t of e.active)
      t.isPending && !this.running.some((r) => r.active.source == t.source) && this.startQuery(t);
    this.running.length && e.open && e.open.disabled && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(_r).updateSyncTime));
  }
  startQuery(n) {
    let { state: e } = this.view, t = Ou(e), r = new Vue(e, t, n.explicit, this.view), i = new O2t(n, r);
    this.running.push(i), Promise.resolve(n.source(r)).then((s) => {
      i.context.aborted || (i.done = s || null, this.scheduleAccept());
    }, (s) => {
      this.view.dispatch({ effects: n1.of(null) }), zi(this.view.state, s);
    });
  }
  scheduleAccept() {
    this.running.every((n) => n.done !== void 0) ? this.accept() : this.debounceAccept < 0 && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(_r).updateSyncTime));
  }
  // For each finished query in this.running, try to create a result
  // or, if appropriate, restart the query.
  accept() {
    var n;
    this.debounceAccept > -1 && clearTimeout(this.debounceAccept), this.debounceAccept = -1;
    let e = [], t = this.view.state.facet(_r), r = this.view.state.field(Di);
    for (let i = 0; i < this.running.length; i++) {
      let s = this.running[i];
      if (s.done === void 0)
        continue;
      if (this.running.splice(i--, 1), s.done) {
        let a = Ou(s.updates.length ? s.updates[0].startState : this.view.state), l = Math.min(a, s.done.from + (s.active.explicit ? 0 : 1)), c = new Ef(s.active.source, s.active.explicit, l, s.done, s.done.from, (n = s.done.to) !== null && n !== void 0 ? n : a);
        for (let u of s.updates)
          c = c.update(u, t);
        if (c.hasResult()) {
          e.push(c);
          continue;
        }
      }
      let o = r.active.find((a) => a.source == s.active.source);
      if (o && o.isPending)
        if (s.done == null) {
          let a = new Ns(
            s.active.source,
            0
            /* State.Inactive */
          );
          for (let l of s.updates)
            a = a.update(l, t);
          a.isPending || e.push(a);
        } else
          this.startQuery(o);
    }
    (e.length || r.open && r.open.disabled) && this.view.dispatch({ effects: hI.of(e) });
  }
}, {
  eventHandlers: {
    blur(n) {
      let e = this.view.state.field(Di, !1);
      if (e && e.tooltip && this.view.state.facet(_r).closeOnBlur) {
        let t = e.open && Nce(this.view, e.open.tooltip);
        (!t || !t.dom.contains(n.relatedTarget)) && setTimeout(() => this.view.dispatch({ effects: n1.of(null) }), 10);
      }
    },
    compositionstart() {
      this.composing = 1;
    },
    compositionend() {
      this.composing == 3 && setTimeout(() => this.view.dispatch({ effects: fw.of(!1) }), 20), this.composing = 0;
    }
  }
}), D2t = typeof navigator == "object" && /* @__PURE__ */ /Win/.test(navigator.platform), N2t = /* @__PURE__ */ hd.highest(/* @__PURE__ */ Be.domEventHandlers({
  keydown(n, e) {
    let t = e.state.field(Di, !1);
    if (!t || !t.open || t.open.disabled || t.open.selected < 0 || n.key.length > 1 || n.ctrlKey && !(D2t && n.altKey) || n.metaKey)
      return !1;
    let r = t.open.options[t.open.selected], i = t.active.find((o) => o.source == r.source), s = r.completion.commitCharacters || i.result.commitCharacters;
    return s && s.indexOf(n.key) > -1 && pI(e, r), !1;
  }
})), L2t = /* @__PURE__ */ Be.baseTheme({
  ".cm-tooltip.cm-tooltip-autocomplete": {
    "& > ul": {
      fontFamily: "monospace",
      whiteSpace: "nowrap",
      overflow: "hidden auto",
      maxWidth_fallback: "700px",
      maxWidth: "min(700px, 95vw)",
      minWidth: "250px",
      maxHeight: "10em",
      height: "100%",
      listStyle: "none",
      margin: 0,
      padding: 0,
      "& > li, & > completion-section": {
        padding: "1px 3px",
        lineHeight: 1.2
      },
      "& > li": {
        overflowX: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer"
      },
      "& > completion-section": {
        display: "list-item",
        borderBottom: "1px solid silver",
        paddingLeft: "0.5em",
        opacity: 0.7
      }
    }
  },
  "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#17c",
    color: "white"
  },
  "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#777"
  },
  "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#347",
    color: "white"
  },
  "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#444"
  },
  ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
    content: '"···"',
    opacity: 0.5,
    display: "block",
    textAlign: "center"
  },
  ".cm-tooltip.cm-completionInfo": {
    position: "absolute",
    padding: "3px 9px",
    width: "max-content",
    maxWidth: "400px",
    boxSizing: "border-box",
    whiteSpace: "pre-line"
  },
  ".cm-completionInfo.cm-completionInfo-left": { right: "100%" },
  ".cm-completionInfo.cm-completionInfo-right": { left: "100%" },
  ".cm-completionInfo.cm-completionInfo-left-narrow": { right: "30px" },
  ".cm-completionInfo.cm-completionInfo-right-narrow": { left: "30px" },
  "&light .cm-snippetField": { backgroundColor: "#00000022" },
  "&dark .cm-snippetField": { backgroundColor: "#ffffff22" },
  ".cm-snippetFieldPosition": {
    verticalAlign: "text-top",
    width: 0,
    height: "1.15em",
    display: "inline-block",
    margin: "0 -0.7px -.7em",
    borderLeft: "1.4px dotted #888"
  },
  ".cm-completionMatchedText": {
    textDecoration: "underline"
  },
  ".cm-completionDetail": {
    marginLeft: "0.5em",
    fontStyle: "italic"
  },
  ".cm-completionIcon": {
    fontSize: "90%",
    width: ".8em",
    display: "inline-block",
    textAlign: "center",
    paddingRight: ".6em",
    opacity: "0.6",
    boxSizing: "content-box"
  },
  ".cm-completionIcon-function, .cm-completionIcon-method": {
    "&:after": { content: "'ƒ'" }
  },
  ".cm-completionIcon-class": {
    "&:after": { content: "'○'" }
  },
  ".cm-completionIcon-interface": {
    "&:after": { content: "'◌'" }
  },
  ".cm-completionIcon-variable": {
    "&:after": { content: "'𝑥'" }
  },
  ".cm-completionIcon-constant": {
    "&:after": { content: "'𝐶'" }
  },
  ".cm-completionIcon-type": {
    "&:after": { content: "'𝑡'" }
  },
  ".cm-completionIcon-enum": {
    "&:after": { content: "'∪'" }
  },
  ".cm-completionIcon-property": {
    "&:after": { content: "'□'" }
  },
  ".cm-completionIcon-keyword": {
    "&:after": { content: "'🔑︎'" }
    // Disable emoji rendering
  },
  ".cm-completionIcon-namespace": {
    "&:after": { content: "'▢'" }
  },
  ".cm-completionIcon-text": {
    "&:after": { content: "'abc'", fontSize: "50%", verticalAlign: "middle" }
  }
}), r1 = {
  brackets: ["(", "[", "{", "'", '"'],
  before: ")]}:;>",
  stringPrefixes: []
}, mu = /* @__PURE__ */ At.define({
  map(n, e) {
    let t = e.mapPos(n, -1, hi.TrackAfter);
    return t ?? void 0;
  }
}), mI = /* @__PURE__ */ new class extends Gu {
}();
mI.startSide = 1;
mI.endSide = -1;
const que = /* @__PURE__ */ Xr.define({
  create() {
    return Vt.empty;
  },
  update(n, e) {
    if (n = n.map(e.changes), e.selection) {
      let t = e.state.doc.lineAt(e.selection.main.head);
      n = n.update({ filter: (r) => r >= t.from && r <= t.to });
    }
    for (let t of e.effects)
      t.is(mu) && (n = n.update({ add: [mI.range(t.value, t.value + 1)] }));
    return n;
  }
});
function $2t() {
  return [B2t, que];
}
const nC = "()[]{}<>«»»«［］｛｝";
function Yue(n) {
  for (let e = 0; e < nC.length; e += 2)
    if (nC.charCodeAt(e) == n)
      return nC.charAt(e + 1);
  return UO(n < 128 ? n : n + 1);
}
function Xue(n, e) {
  return n.languageDataAt("closeBrackets", e)[0] || r1;
}
const F2t = typeof navigator == "object" && /* @__PURE__ */ /Android\b/.test(navigator.userAgent), B2t = /* @__PURE__ */ Be.inputHandler.of((n, e, t, r) => {
  if ((F2t ? n.composing : n.compositionStarted) || n.state.readOnly)
    return !1;
  let i = n.state.selection.main;
  if (r.length > 2 || r.length == 2 && Jo(Pi(r, 0)) == 1 || e != i.from || t != i.to)
    return !1;
  let s = U2t(n.state, r);
  return s ? (n.dispatch(s), !0) : !1;
}), z2t = ({ state: n, dispatch: e }) => {
  if (n.readOnly)
    return !1;
  let r = Xue(n, n.selection.main.head).brackets || r1.brackets, i = null, s = n.changeByRange((o) => {
    if (o.empty) {
      let a = V2t(n.doc, o.head);
      for (let l of r)
        if (l == a && Ax(n.doc, o.head) == Yue(Pi(l, 0)))
          return {
            changes: { from: o.head - l.length, to: o.head + l.length },
            range: ge.cursor(o.head - l.length)
          };
    }
    return { range: i = o };
  });
  return i || e(n.update(s, { scrollIntoView: !0, userEvent: "delete.backward" })), !i;
}, H2t = [
  { key: "Backspace", run: z2t }
];
function U2t(n, e) {
  let t = Xue(n, n.selection.main.head), r = t.brackets || r1.brackets;
  for (let i of r) {
    let s = Yue(Pi(i, 0));
    if (e == i)
      return s == i ? G2t(n, i, r.indexOf(i + i + i) > -1, t) : j2t(n, i, s, t.before || r1.before);
    if (e == s && Zue(n, n.selection.main.from))
      return W2t(n, i, s);
  }
  return null;
}
function Zue(n, e) {
  let t = !1;
  return n.field(que).between(0, n.doc.length, (r) => {
    r == e && (t = !0);
  }), t;
}
function Ax(n, e) {
  let t = n.sliceString(e, e + 2);
  return t.slice(0, Jo(Pi(t, 0)));
}
function V2t(n, e) {
  let t = n.sliceString(e - 2, e);
  return Jo(Pi(t, 0)) == t.length ? t : t.slice(1);
}
function j2t(n, e, t, r) {
  let i = null, s = n.changeByRange((o) => {
    if (!o.empty)
      return {
        changes: [{ insert: e, from: o.from }, { insert: t, from: o.to }],
        effects: mu.of(o.to + e.length),
        range: ge.range(o.anchor + e.length, o.head + e.length)
      };
    let a = Ax(n.doc, o.head);
    return !a || /\s/.test(a) || r.indexOf(a) > -1 ? {
      changes: { insert: e + t, from: o.head },
      effects: mu.of(o.head + e.length),
      range: ge.cursor(o.head + e.length)
    } : { range: i = o };
  });
  return i ? null : n.update(s, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function W2t(n, e, t) {
  let r = null, i = n.changeByRange((s) => s.empty && Ax(n.doc, s.head) == t ? {
    changes: { from: s.head, to: s.head + t.length, insert: t },
    range: ge.cursor(s.head + t.length)
  } : r = { range: s });
  return r ? null : n.update(i, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function G2t(n, e, t, r) {
  let i = r.stringPrefixes || r1.stringPrefixes, s = null, o = n.changeByRange((a) => {
    if (!a.empty)
      return {
        changes: [{ insert: e, from: a.from }, { insert: e, from: a.to }],
        effects: mu.of(a.to + e.length),
        range: ge.range(a.anchor + e.length, a.head + e.length)
      };
    let l = a.head, c = Ax(n.doc, l), u;
    if (c == e) {
      if (tG(n, l))
        return {
          changes: { insert: e + e, from: l },
          effects: mu.of(l + e.length),
          range: ge.cursor(l + e.length)
        };
      if (Zue(n, l)) {
        let f = t && n.sliceDoc(l, l + e.length * 3) == e + e + e ? e + e + e : e;
        return {
          changes: { from: l, to: l + f.length, insert: f },
          range: ge.cursor(l + f.length)
        };
      }
    } else {
      if (t && n.sliceDoc(l - 2 * e.length, l) == e + e && (u = nG(n, l - 2 * e.length, i)) > -1 && tG(n, u))
        return {
          changes: { insert: e + e + e + e, from: l },
          effects: mu.of(l + e.length),
          range: ge.cursor(l + e.length)
        };
      if (n.charCategorizer(l)(c) != $n.Word && nG(n, l, i) > -1 && !K2t(n, l, e, i))
        return {
          changes: { insert: e + e, from: l },
          effects: mu.of(l + e.length),
          range: ge.cursor(l + e.length)
        };
    }
    return { range: s = a };
  });
  return s ? null : n.update(o, {
    scrollIntoView: !0,
    userEvent: "input.type"
  });
}
function tG(n, e) {
  let t = ai(n).resolveInner(e + 1);
  return t.parent && t.from == e;
}
function K2t(n, e, t, r) {
  let i = ai(n).resolveInner(e, -1), s = r.reduce((o, a) => Math.max(o, a.length), 0);
  for (let o = 0; o < 5; o++) {
    let a = n.sliceDoc(i.from, Math.min(i.to, i.from + t.length + s)), l = a.indexOf(t);
    if (!l || l > -1 && r.indexOf(a.slice(0, l)) > -1) {
      let u = i.firstChild;
      for (; u && u.from == i.from && u.to - u.from > t.length + l; ) {
        if (n.sliceDoc(u.to - t.length, u.to) == t)
          return !1;
        u = u.firstChild;
      }
      return !0;
    }
    let c = i.to == e && i.parent;
    if (!c)
      break;
    i = c;
  }
  return !1;
}
function nG(n, e, t) {
  let r = n.charCategorizer(e);
  if (r(n.sliceDoc(e - 1, e)) != $n.Word)
    return e;
  for (let i of t) {
    let s = e - i.length;
    if (n.sliceDoc(s, e) == i && r(n.sliceDoc(s - 1, s)) != $n.Word)
      return s;
  }
  return -1;
}
function q2t(n = {}) {
  return [
    N2t,
    Di,
    _r.of(n),
    P2t,
    Y2t,
    L2t
  ];
}
const Que = [
  { key: "Ctrl-Space", run: tC },
  { mac: "Alt-`", run: tC },
  { mac: "Alt-i", run: tC },
  { key: "Escape", run: _2t },
  { key: "ArrowDown", run: /* @__PURE__ */ Lv(!0) },
  { key: "ArrowUp", run: /* @__PURE__ */ Lv(!1) },
  { key: "PageDown", run: /* @__PURE__ */ Lv(!0, "page") },
  { key: "PageUp", run: /* @__PURE__ */ Lv(!1, "page") },
  { key: "Enter", run: k2t }
], Y2t = /* @__PURE__ */ hd.highest(/* @__PURE__ */ vx.computeN([_r], (n) => n.facet(_r).defaultKeymap ? [Que] : []));
class rG {
  constructor(e, t, r) {
    this.from = e, this.to = t, this.diagnostic = r;
  }
}
class nu {
  constructor(e, t, r) {
    this.diagnostics = e, this.panel = t, this.selected = r;
  }
  static init(e, t, r) {
    let i = r.facet(i1).markerFilter;
    i && (e = i(e, r));
    let s = e.slice().sort((f, h) => f.from - h.from || f.to - h.to), o = new ml(), a = [], l = 0, c = r.doc.iter(), u = 0;
    for (let f = 0; ; ) {
      let h = f == s.length ? null : s[f];
      if (!h && !a.length)
        break;
      let m, g;
      for (a.length ? (m = l, g = a.reduce((b, x) => Math.min(b, x.to), h && h.from > m ? h.from : 1e8)) : (m = h.from, g = h.to, a.push(h), f++); f < s.length; ) {
        let b = s[f];
        if (b.from == m && (b.to > b.from || b.to == m))
          a.push(b), f++, g = Math.min(b.to, g);
        else {
          g = Math.min(b.from, g);
          break;
        }
      }
      let v = !1;
      if (a.some((b) => b.from == m && b.to == g) && (v = m == g, !v && g - m < 10)) {
        let b = m - (u + c.value.length);
        b > 0 && (c.next(b), u = m);
        for (let x = m; ; ) {
          if (x >= g) {
            v = !0;
            break;
          }
          if (!c.lineBreak && u + c.value.length > x)
            break;
          x = u + c.value.length, u += c.value.length, c.next();
        }
      }
      let y = lyt(a);
      if (v)
        o.add(m, m, ct.widget({
          widget: new iyt(y),
          diagnostics: a.slice()
        }));
      else {
        let b = a.reduce((x, E) => E.markClass ? x + " " + E.markClass : x, "");
        o.add(m, g, ct.mark({
          class: "cm-lintRange cm-lintRange-" + y + b,
          diagnostics: a.slice(),
          inclusiveEnd: a.some((x) => x.to > g)
        }));
      }
      l = g;
      for (let b = 0; b < a.length; b++)
        a[b].to <= l && a.splice(b--, 1);
    }
    let d = o.finish();
    return new nu(d, t, gh(d));
  }
}
function gh(n, e = null, t = 0) {
  let r = null;
  return n.between(t, 1e9, (i, s, { spec: o }) => {
    if (!(e && o.diagnostics.indexOf(e) < 0))
      if (!r)
        r = new rG(i, s, e || o.diagnostics[0]);
      else {
        if (o.diagnostics.indexOf(r.diagnostic) < 0)
          return !1;
        r = new rG(r.from, s, r.diagnostic);
      }
  }), r;
}
function X2t(n, e) {
  let t = e.pos, r = e.end || t, i = n.state.facet(i1).hideOn(n, t, r);
  if (i != null)
    return i;
  let s = n.startState.doc.lineAt(e.pos);
  return !!(n.effects.some((o) => o.is(Jue)) || n.changes.touchesRange(s.from, Math.max(s.to, r)));
}
function Z2t(n, e) {
  return n.field(ps, !1) ? e : e.concat(At.appendConfig.of(cyt));
}
const Jue = /* @__PURE__ */ At.define(), gI = /* @__PURE__ */ At.define(), ede = /* @__PURE__ */ At.define(), ps = /* @__PURE__ */ Xr.define({
  create() {
    return new nu(ct.none, null, null);
  },
  update(n, e) {
    if (e.docChanged && n.diagnostics.size) {
      let t = n.diagnostics.map(e.changes), r = null, i = n.panel;
      if (n.selected) {
        let s = e.changes.mapPos(n.selected.from, 1);
        r = gh(t, n.selected.diagnostic, s) || gh(t, null, s);
      }
      !t.size && i && e.state.facet(i1).autoPanel && (i = null), n = new nu(t, i, r);
    }
    for (let t of e.effects)
      if (t.is(Jue)) {
        let r = e.state.facet(i1).autoPanel ? t.value.length ? s1.open : null : n.panel;
        n = nu.init(t.value, r, e.state);
      } else t.is(gI) ? n = new nu(n.diagnostics, t.value ? s1.open : null, n.selected) : t.is(ede) && (n = new nu(n.diagnostics, n.panel, t.value));
    return n;
  },
  provide: (n) => [
    J0.from(n, (e) => e.panel),
    Be.decorations.from(n, (e) => e.diagnostics)
  ]
}), Q2t = /* @__PURE__ */ ct.mark({ class: "cm-lintRange cm-lintRange-active" });
function J2t(n, e, t) {
  let { diagnostics: r } = n.state.field(ps), i, s = -1, o = -1;
  r.between(e - (t < 0 ? 1 : 0), e + (t > 0 ? 1 : 0), (l, c, { spec: u }) => {
    if (e >= l && e <= c && (l == c || (e > l || t > 0) && (e < c || t < 0)))
      return i = u.diagnostics, s = l, o = c, !1;
  });
  let a = n.state.facet(i1).tooltipFilter;
  return i && a && (i = a(i, n.state)), i ? {
    pos: s,
    end: o,
    above: n.state.doc.lineAt(s).to < o,
    create() {
      return { dom: eyt(n, i) };
    }
  } : null;
}
function eyt(n, e) {
  return yn("ul", { class: "cm-tooltip-lint" }, e.map((t) => nde(n, t, !1)));
}
const tyt = (n) => {
  let e = n.state.field(ps, !1);
  (!e || !e.panel) && n.dispatch({ effects: Z2t(n.state, [gI.of(!0)]) });
  let t = Q0(n, s1.open);
  return t && t.dom.querySelector(".cm-panel-lint ul").focus(), !0;
}, iG = (n) => {
  let e = n.state.field(ps, !1);
  return !e || !e.panel ? !1 : (n.dispatch({ effects: gI.of(!1) }), !0);
}, nyt = (n) => {
  let e = n.state.field(ps, !1);
  if (!e)
    return !1;
  let t = n.state.selection.main, r = e.diagnostics.iter(t.to + 1);
  return !r.value && (r = e.diagnostics.iter(0), !r.value || r.from == t.from && r.to == t.to) ? !1 : (n.dispatch({ selection: { anchor: r.from, head: r.to }, scrollIntoView: !0 }), !0);
}, ryt = [
  { key: "Mod-Shift-m", run: tyt, preventDefault: !0 },
  { key: "F8", run: nyt }
], i1 = /* @__PURE__ */ je.define({
  combine(n) {
    return {
      sources: n.map((e) => e.source).filter((e) => e != null),
      ...ka(n.map((e) => e.config), {
        delay: 750,
        markerFilter: null,
        tooltipFilter: null,
        needsRefresh: null,
        hideOn: () => null
      }, {
        delay: Math.max,
        markerFilter: sG,
        tooltipFilter: sG,
        needsRefresh: (e, t) => e ? t ? (r) => e(r) || t(r) : e : t,
        hideOn: (e, t) => e ? t ? (r, i, s) => e(r, i, s) || t(r, i, s) : e : t,
        autoPanel: (e, t) => e || t
      })
    };
  }
});
function sG(n, e) {
  return n ? e ? (t, r) => e(n(t, r), r) : n : e;
}
function tde(n) {
  let e = [];
  if (n)
    e: for (let { name: t } of n) {
      for (let r = 0; r < t.length; r++) {
        let i = t[r];
        if (/[a-zA-Z]/.test(i) && !e.some((s) => s.toLowerCase() == i.toLowerCase())) {
          e.push(i);
          continue e;
        }
      }
      e.push("");
    }
  return e;
}
function nde(n, e, t) {
  var r;
  let i = t ? tde(e.actions) : [];
  return yn("li", { class: "cm-diagnostic cm-diagnostic-" + e.severity }, yn("span", { class: "cm-diagnosticText" }, e.renderMessage ? e.renderMessage(n) : e.message), (r = e.actions) === null || r === void 0 ? void 0 : r.map((s, o) => {
    let a = !1, l = (h) => {
      if (h.preventDefault(), a)
        return;
      a = !0;
      let m = gh(n.state.field(ps).diagnostics, e);
      m && s.apply(n, m.from, m.to);
    }, { name: c } = s, u = i[o] ? c.indexOf(i[o]) : -1, d = u < 0 ? c : [
      c.slice(0, u),
      yn("u", c.slice(u, u + 1)),
      c.slice(u + 1)
    ], f = s.markClass ? " " + s.markClass : "";
    return yn("button", {
      type: "button",
      class: "cm-diagnosticAction" + f,
      onclick: l,
      onmousedown: l,
      "aria-label": ` Action: ${c}${u < 0 ? "" : ` (access key "${i[o]})"`}.`
    }, d);
  }), e.source && yn("div", { class: "cm-diagnosticSource" }, e.source));
}
class iyt extends Sl {
  constructor(e) {
    super(), this.sev = e;
  }
  eq(e) {
    return e.sev == this.sev;
  }
  toDOM() {
    return yn("span", { class: "cm-lintPoint cm-lintPoint-" + this.sev });
  }
}
class oG {
  constructor(e, t) {
    this.diagnostic = t, this.id = "item_" + Math.floor(Math.random() * 4294967295).toString(16), this.dom = nde(e, t, !0), this.dom.id = this.id, this.dom.setAttribute("role", "option");
  }
}
class s1 {
  constructor(e) {
    this.view = e, this.items = [];
    let t = (i) => {
      if (i.keyCode == 27)
        iG(this.view), this.view.focus();
      else if (i.keyCode == 38 || i.keyCode == 33)
        this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
      else if (i.keyCode == 40 || i.keyCode == 34)
        this.moveSelection((this.selectedIndex + 1) % this.items.length);
      else if (i.keyCode == 36)
        this.moveSelection(0);
      else if (i.keyCode == 35)
        this.moveSelection(this.items.length - 1);
      else if (i.keyCode == 13)
        this.view.focus();
      else if (i.keyCode >= 65 && i.keyCode <= 90 && this.selectedIndex >= 0) {
        let { diagnostic: s } = this.items[this.selectedIndex], o = tde(s.actions);
        for (let a = 0; a < o.length; a++)
          if (o[a].toUpperCase().charCodeAt(0) == i.keyCode) {
            let l = gh(this.view.state.field(ps).diagnostics, s);
            l && s.actions[a].apply(e, l.from, l.to);
          }
      } else
        return;
      i.preventDefault();
    }, r = (i) => {
      for (let s = 0; s < this.items.length; s++)
        this.items[s].dom.contains(i.target) && this.moveSelection(s);
    };
    this.list = yn("ul", {
      tabIndex: 0,
      role: "listbox",
      "aria-label": this.view.state.phrase("Diagnostics"),
      onkeydown: t,
      onclick: r
    }), this.dom = yn("div", { class: "cm-panel-lint" }, this.list, yn("button", {
      type: "button",
      name: "close",
      "aria-label": this.view.state.phrase("close"),
      onclick: () => iG(this.view)
    }, "×")), this.update();
  }
  get selectedIndex() {
    let e = this.view.state.field(ps).selected;
    if (!e)
      return -1;
    for (let t = 0; t < this.items.length; t++)
      if (this.items[t].diagnostic == e.diagnostic)
        return t;
    return -1;
  }
  update() {
    let { diagnostics: e, selected: t } = this.view.state.field(ps), r = 0, i = !1, s = null, o = /* @__PURE__ */ new Set();
    for (e.between(0, this.view.state.doc.length, (a, l, { spec: c }) => {
      for (let u of c.diagnostics) {
        if (o.has(u))
          continue;
        o.add(u);
        let d = -1, f;
        for (let h = r; h < this.items.length; h++)
          if (this.items[h].diagnostic == u) {
            d = h;
            break;
          }
        d < 0 ? (f = new oG(this.view, u), this.items.splice(r, 0, f), i = !0) : (f = this.items[d], d > r && (this.items.splice(r, d - r), i = !0)), t && f.diagnostic == t.diagnostic ? f.dom.hasAttribute("aria-selected") || (f.dom.setAttribute("aria-selected", "true"), s = f) : f.dom.hasAttribute("aria-selected") && f.dom.removeAttribute("aria-selected"), r++;
      }
    }); r < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0); )
      i = !0, this.items.pop();
    this.items.length == 0 && (this.items.push(new oG(this.view, {
      from: -1,
      to: -1,
      severity: "info",
      message: this.view.state.phrase("No diagnostics")
    })), i = !0), s ? (this.list.setAttribute("aria-activedescendant", s.id), this.view.requestMeasure({
      key: this,
      read: () => ({ sel: s.dom.getBoundingClientRect(), panel: this.list.getBoundingClientRect() }),
      write: ({ sel: a, panel: l }) => {
        let c = l.height / this.list.offsetHeight;
        a.top < l.top ? this.list.scrollTop -= (l.top - a.top) / c : a.bottom > l.bottom && (this.list.scrollTop += (a.bottom - l.bottom) / c);
      }
    })) : this.selectedIndex < 0 && this.list.removeAttribute("aria-activedescendant"), i && this.sync();
  }
  sync() {
    let e = this.list.firstChild;
    function t() {
      let r = e;
      e = r.nextSibling, r.remove();
    }
    for (let r of this.items)
      if (r.dom.parentNode == this.list) {
        for (; e != r.dom; )
          t();
        e = r.dom.nextSibling;
      } else
        this.list.insertBefore(r.dom, e);
    for (; e; )
      t();
  }
  moveSelection(e) {
    if (this.selectedIndex < 0)
      return;
    let t = this.view.state.field(ps), r = gh(t.diagnostics, this.items[e].diagnostic);
    r && this.view.dispatch({
      selection: { anchor: r.from, head: r.to },
      scrollIntoView: !0,
      effects: ede.of(r)
    });
  }
  static open(e) {
    return new s1(e);
  }
}
function syt(n, e = 'viewBox="0 0 40 40"') {
  return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${e}>${encodeURIComponent(n)}</svg>')`;
}
function $v(n) {
  return syt(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${n}" fill="none" stroke-width=".7"/>`, 'width="6" height="3"');
}
const oyt = /* @__PURE__ */ Be.baseTheme({
  ".cm-diagnostic": {
    padding: "3px 6px 3px 8px",
    marginLeft: "-1px",
    display: "block",
    whiteSpace: "pre-wrap"
  },
  ".cm-diagnostic-error": { borderLeft: "5px solid #d11" },
  ".cm-diagnostic-warning": { borderLeft: "5px solid orange" },
  ".cm-diagnostic-info": { borderLeft: "5px solid #999" },
  ".cm-diagnostic-hint": { borderLeft: "5px solid #66d" },
  ".cm-diagnosticAction": {
    font: "inherit",
    border: "none",
    padding: "2px 4px",
    backgroundColor: "#444",
    color: "white",
    borderRadius: "3px",
    marginLeft: "8px",
    cursor: "pointer"
  },
  ".cm-diagnosticSource": {
    fontSize: "70%",
    opacity: 0.7
  },
  ".cm-lintRange": {
    backgroundPosition: "left bottom",
    backgroundRepeat: "repeat-x",
    paddingBottom: "0.7px"
  },
  ".cm-lintRange-error": { backgroundImage: /* @__PURE__ */ $v("#d11") },
  ".cm-lintRange-warning": { backgroundImage: /* @__PURE__ */ $v("orange") },
  ".cm-lintRange-info": { backgroundImage: /* @__PURE__ */ $v("#999") },
  ".cm-lintRange-hint": { backgroundImage: /* @__PURE__ */ $v("#66d") },
  ".cm-lintRange-active": { backgroundColor: "#ffdd9980" },
  ".cm-tooltip-lint": {
    padding: 0,
    margin: 0
  },
  ".cm-lintPoint": {
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: "-2px",
      borderLeft: "3px solid transparent",
      borderRight: "3px solid transparent",
      borderBottom: "4px solid #d11"
    }
  },
  ".cm-lintPoint-warning": {
    "&:after": { borderBottomColor: "orange" }
  },
  ".cm-lintPoint-info": {
    "&:after": { borderBottomColor: "#999" }
  },
  ".cm-lintPoint-hint": {
    "&:after": { borderBottomColor: "#66d" }
  },
  ".cm-panel.cm-panel-lint": {
    position: "relative",
    "& ul": {
      maxHeight: "100px",
      overflowY: "auto",
      "& [aria-selected]": {
        backgroundColor: "#ddd",
        "& u": { textDecoration: "underline" }
      },
      "&:focus [aria-selected]": {
        background_fallback: "#bdf",
        backgroundColor: "Highlight",
        color_fallback: "white",
        color: "HighlightText"
      },
      "& u": { textDecoration: "none" },
      padding: 0,
      margin: 0
    },
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "2px",
      background: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    }
  }
});
function ayt(n) {
  return n == "error" ? 4 : n == "warning" ? 3 : n == "info" ? 2 : 1;
}
function lyt(n) {
  let e = "hint", t = 1;
  for (let r of n) {
    let i = ayt(r.severity);
    i > t && (t = i, e = r.severity);
  }
  return e;
}
const cyt = [
  ps,
  /* @__PURE__ */ Be.decorations.compute([ps], (n) => {
    let { selected: e, panel: t } = n.field(ps);
    return !e || !t || e.from == e.to ? ct.none : ct.set([
      Q2t.range(e.from, e.to)
    ]);
  }),
  /* @__PURE__ */ o1t(J2t, { hideOn: X2t }),
  oyt
];
var aG = function(e) {
  e === void 0 && (e = {});
  var {
    crosshairCursor: t = !1
  } = e, r = [];
  e.closeBracketsKeymap !== !1 && (r = r.concat(H2t)), e.defaultKeymap !== !1 && (r = r.concat(Dvt)), e.searchKeymap !== !1 && (r = r.concat(o2t)), e.historyKeymap !== !1 && (r = r.concat(Hgt)), e.foldKeymap !== !1 && (r = r.concat(W1t)), e.completionKeymap !== !1 && (r = r.concat(Que)), e.lintKeymap !== !1 && (r = r.concat(ryt));
  var i = [];
  return e.lineNumbers !== !1 && i.push(v1t()), e.highlightActiveLineGutter !== !1 && i.push(w1t()), e.highlightSpecialChars !== !1 && i.push(N0t()), e.history !== !1 && i.push(Rgt()), e.foldGutter !== !1 && i.push(Y1t()), e.drawSelection !== !1 && i.push(C0t()), e.dropCursor !== !1 && i.push(_0t()), e.allowMultipleSelections !== !1 && i.push(Ht.allowMultipleSelections.of(!0)), e.indentOnInput !== !1 && i.push(N1t()), e.syntaxHighlighting !== !1 && i.push(sI(J1t, {
    fallback: !0
  })), e.bracketMatching !== !1 && i.push(ogt()), e.closeBrackets !== !1 && i.push($2t()), e.autocompletion !== !1 && i.push(q2t()), e.rectangularSelection !== !1 && i.push(Y0t()), t !== !1 && i.push(Q0t()), e.highlightActiveLine !== !1 && i.push(H0t()), e.highlightSelectionMatches !== !1 && i.push(Hvt()), e.tabSize && typeof e.tabSize == "number" && i.push(bx.of(" ".repeat(e.tabSize))), i.concat([vx.of(r.flat())]).filter(Boolean);
};
const uyt = "#e5c07b", lG = "#e06c75", dyt = "#56b6c2", fyt = "#ffffff", p2 = "#abb2bf", wA = "#7d8799", hyt = "#61afef", pyt = "#98c379", cG = "#d19a66", myt = "#c678dd", gyt = "#21252b", uG = "#2c313a", dG = "#282c34", rC = "#353a42", vyt = "#3E4451", fG = "#528bff", yyt = /* @__PURE__ */ Be.theme({
  "&": {
    color: p2,
    backgroundColor: dG
  },
  ".cm-content": {
    caretColor: fG
  },
  ".cm-cursor, .cm-dropCursor": { borderLeftColor: fG },
  "&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection": { backgroundColor: vyt },
  ".cm-panels": { backgroundColor: gyt, color: p2 },
  ".cm-panels.cm-panels-top": { borderBottom: "2px solid black" },
  ".cm-panels.cm-panels-bottom": { borderTop: "2px solid black" },
  ".cm-searchMatch": {
    backgroundColor: "#72a1ff59",
    outline: "1px solid #457dff"
  },
  ".cm-searchMatch.cm-searchMatch-selected": {
    backgroundColor: "#6199ff2f"
  },
  ".cm-activeLine": { backgroundColor: "#6699ff0b" },
  ".cm-selectionMatch": { backgroundColor: "#aafe661a" },
  "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
    backgroundColor: "#bad0f847"
  },
  ".cm-gutters": {
    backgroundColor: dG,
    color: wA,
    border: "none"
  },
  ".cm-activeLineGutter": {
    backgroundColor: uG
  },
  ".cm-foldPlaceholder": {
    backgroundColor: "transparent",
    border: "none",
    color: "#ddd"
  },
  ".cm-tooltip": {
    border: "none",
    backgroundColor: rC
  },
  ".cm-tooltip .cm-tooltip-arrow:before": {
    borderTopColor: "transparent",
    borderBottomColor: "transparent"
  },
  ".cm-tooltip .cm-tooltip-arrow:after": {
    borderTopColor: rC,
    borderBottomColor: rC
  },
  ".cm-tooltip-autocomplete": {
    "& > ul > li[aria-selected]": {
      backgroundColor: uG,
      color: p2
    }
  }
}, { dark: !0 }), byt = /* @__PURE__ */ jh.define([
  {
    tag: Y.keyword,
    color: myt
  },
  {
    tag: [Y.name, Y.deleted, Y.character, Y.propertyName, Y.macroName],
    color: lG
  },
  {
    tag: [/* @__PURE__ */ Y.function(Y.variableName), Y.labelName],
    color: hyt
  },
  {
    tag: [Y.color, /* @__PURE__ */ Y.constant(Y.name), /* @__PURE__ */ Y.standard(Y.name)],
    color: cG
  },
  {
    tag: [/* @__PURE__ */ Y.definition(Y.name), Y.separator],
    color: p2
  },
  {
    tag: [Y.typeName, Y.className, Y.number, Y.changed, Y.annotation, Y.modifier, Y.self, Y.namespace],
    color: uyt
  },
  {
    tag: [Y.operator, Y.operatorKeyword, Y.url, Y.escape, Y.regexp, Y.link, /* @__PURE__ */ Y.special(Y.string)],
    color: dyt
  },
  {
    tag: [Y.meta, Y.comment],
    color: wA
  },
  {
    tag: Y.strong,
    fontWeight: "bold"
  },
  {
    tag: Y.emphasis,
    fontStyle: "italic"
  },
  {
    tag: Y.strikethrough,
    textDecoration: "line-through"
  },
  {
    tag: Y.link,
    color: wA,
    textDecoration: "underline"
  },
  {
    tag: Y.heading,
    fontWeight: "bold",
    color: lG
  },
  {
    tag: [Y.atom, Y.bool, /* @__PURE__ */ Y.special(Y.variableName)],
    color: cG
  },
  {
    tag: [Y.processingInstruction, Y.string, Y.inserted],
    color: pyt
  },
  {
    tag: Y.invalid,
    color: fyt
  }
]), wyt = [yyt, /* @__PURE__ */ sI(byt)];
var xyt = Be.theme({
  "&": {
    backgroundColor: "#fff"
  }
}, {
  dark: !1
}), Eyt = function(e) {
  e === void 0 && (e = {});
  var {
    indentWithTab: t = !0,
    editable: r = !0,
    readOnly: i = !1,
    theme: s = "light",
    placeholder: o = "",
    basicSetup: a = !0
  } = e, l = [];
  switch (t && l.unshift(vx.of([Nvt])), a && (typeof a == "boolean" ? l.unshift(aG()) : l.unshift(aG(a))), o && l.unshift(W0t(o)), s) {
    case "light":
      l.push(xyt);
      break;
    case "dark":
      l.push(wyt);
      break;
    case "none":
      break;
    default:
      l.push(s);
      break;
  }
  return r === !1 && l.push(Be.editable.of(!1)), i && l.push(Ht.readOnly.of(!0)), [...l];
}, Syt = (n) => ({
  line: n.state.doc.lineAt(n.state.selection.main.from),
  lineCount: n.state.doc.lines,
  lineBreak: n.state.lineBreak,
  length: n.state.doc.length,
  readOnly: n.state.readOnly,
  tabSize: n.state.tabSize,
  selection: n.state.selection,
  selectionAsSingle: n.state.selection.asSingle().main,
  ranges: n.state.selection.ranges,
  selectionCode: n.state.sliceDoc(n.state.selection.main.from, n.state.selection.main.to),
  selections: n.state.selection.ranges.map((e) => n.state.sliceDoc(e.from, e.to)),
  selectedText: n.state.selection.ranges.some((e) => !e.empty)
});
class Cyt {
  constructor(e, t) {
    this.timeLeftMS = void 0, this.timeoutMS = void 0, this.isCancelled = !1, this.isTimeExhausted = !1, this.callbacks = [], this.timeLeftMS = t, this.timeoutMS = t, this.callbacks.push(e);
  }
  tick() {
    if (!this.isCancelled && !this.isTimeExhausted && (this.timeLeftMS--, this.timeLeftMS <= 0)) {
      this.isTimeExhausted = !0;
      var e = this.callbacks.slice();
      this.callbacks.length = 0, e.forEach((t) => {
        try {
          t();
        } catch (r) {
          console.error("TimeoutLatch callback error:", r);
        }
      });
    }
  }
  cancel() {
    this.isCancelled = !0, this.callbacks.length = 0;
  }
  reset() {
    this.timeLeftMS = this.timeoutMS, this.isCancelled = !1, this.isTimeExhausted = !1;
  }
  get isDone() {
    return this.isCancelled || this.isTimeExhausted;
  }
}
class hG {
  constructor() {
    this.interval = null, this.latches = /* @__PURE__ */ new Set();
  }
  add(e) {
    this.latches.add(e), this.start();
  }
  remove(e) {
    this.latches.delete(e), this.latches.size === 0 && this.stop();
  }
  start() {
    this.interval === null && (this.interval = setInterval(() => {
      this.latches.forEach((e) => {
        e.tick(), e.isDone && this.remove(e);
      });
    }, 1));
  }
  stop() {
    this.interval !== null && (clearInterval(this.interval), this.interval = null);
  }
}
var iC = null, Tyt = () => typeof window > "u" ? new hG() : (iC || (iC = new hG()), iC), pG = Ma.define(), Ayt = 200, Myt = [];
function kyt(n) {
  var {
    value: e,
    selection: t,
    onChange: r,
    onStatistics: i,
    onCreateEditor: s,
    onUpdate: o,
    extensions: a = Myt,
    autoFocus: l,
    theme: c = "light",
    height: u = null,
    minHeight: d = null,
    maxHeight: f = null,
    width: h = null,
    minWidth: m = null,
    maxWidth: g = null,
    placeholder: v = "",
    editable: y = !0,
    readOnly: b = !1,
    indentWithTab: x = !0,
    basicSetup: E = !0,
    root: w,
    initialState: C
  } = n, [S, M] = wt(), [k, _] = wt(), [O, I] = wt(), R = wt(() => ({
    current: null
  }))[0], P = wt(() => ({
    current: null
  }))[0], D = Be.theme({
    "&": {
      height: u,
      minHeight: d,
      maxHeight: f,
      width: h,
      minWidth: m,
      maxWidth: g
    },
    "& .cm-scroller": {
      height: "100% !important"
    }
  }), L = Be.updateListener.of((z) => {
    if (z.docChanged && typeof r == "function" && // Fix echoing of the remote changes:
    // If transaction is market as remote we don't have to call `onChange` handler again
    !z.transactions.some((F) => F.annotation(pG))) {
      R.current ? R.current.reset() : (R.current = new Cyt(() => {
        if (P.current) {
          var F = P.current;
          P.current = null, F();
        }
        R.current = null;
      }, Ayt), Tyt().add(R.current));
      var H = z.state.doc, U = H.toString();
      r(U, z);
    }
    i && i(Syt(z));
  }), B = Eyt({
    theme: c,
    editable: y,
    readOnly: b,
    placeholder: v,
    indentWithTab: x,
    basicSetup: E
  }), $ = [L, D, ...B];
  return o && typeof o == "function" && $.push(Be.updateListener.of(o)), $ = $.concat(a), vh(() => {
    if (S && !O) {
      var z = {
        doc: e,
        selection: t,
        extensions: $
      }, H = C ? Ht.fromJSON(C.json, z, C.fields) : Ht.create(z);
      if (I(H), !k) {
        var U = new Be({
          state: H,
          parent: S,
          root: w
        });
        _(U), s && s(U, H);
      }
    }
    return () => {
      k && (I(void 0), _(void 0));
    };
  }, [S, O]), Tt(() => {
    n.container && M(n.container);
  }, [n.container]), Tt(() => () => {
    k && (k.destroy(), _(void 0)), R.current && (R.current.cancel(), R.current = null);
  }, [k]), Tt(() => {
    l && k && k.focus();
  }, [l, k]), Tt(() => {
    k && k.dispatch({
      effects: At.reconfigure.of($)
    });
  }, [c, a, u, d, f, h, m, g, v, y, b, x, E, r, o]), Tt(() => {
    if (e !== void 0) {
      var z = k ? k.state.doc.toString() : "";
      if (k && e !== z) {
        var H = R.current && !R.current.isDone, U = () => {
          k && e !== k.state.doc.toString() && k.dispatch({
            changes: {
              from: 0,
              to: k.state.doc.toString().length,
              insert: e || ""
            },
            annotations: [pG.of(!0)]
          });
        };
        H ? P.current = U : U();
      }
    }
  }, [e, k]), {
    state: O,
    setState: I,
    view: k,
    setView: _,
    container: S,
    setContainer: M
  };
}
var _yt = ["className", "value", "selection", "extensions", "onChange", "onStatistics", "onCreateEditor", "onUpdate", "autoFocus", "theme", "height", "minHeight", "maxHeight", "width", "minWidth", "maxWidth", "basicSetup", "placeholder", "indentWithTab", "editable", "readOnly", "root", "initialState"], rde = /* @__PURE__ */ tn((n, e) => {
  var {
    className: t,
    value: r = "",
    selection: i,
    extensions: s = [],
    onChange: o,
    onStatistics: a,
    onCreateEditor: l,
    onUpdate: c,
    autoFocus: u,
    theme: d = "light",
    height: f,
    minHeight: h,
    maxHeight: m,
    width: g,
    minWidth: v,
    maxWidth: y,
    basicSetup: b,
    placeholder: x,
    indentWithTab: E,
    editable: w,
    readOnly: C,
    root: S,
    initialState: M
  } = n, k = jxe(n, _yt), _ = Gt(null), {
    state: O,
    view: I,
    container: R,
    setContainer: P
  } = kyt({
    root: S,
    value: r,
    autoFocus: u,
    theme: d,
    height: f,
    minHeight: h,
    maxHeight: m,
    width: g,
    minWidth: v,
    maxWidth: y,
    basicSetup: b,
    placeholder: x,
    indentWithTab: E,
    editable: w,
    readOnly: C,
    selection: i,
    onChange: o,
    onStatistics: a,
    onCreateEditor: l,
    onUpdate: c,
    extensions: s,
    initialState: M
  });
  xG(e, () => ({
    editor: _.current,
    state: O,
    view: I
  }), [_, R, O, I]);
  var D = Ft((B) => {
    _.current = B, P(B);
  }, [P]);
  if (typeof r != "string")
    throw new Error("value must be typeof string but got " + typeof r);
  var L = typeof d == "string" ? "cm-theme-" + d : "cm-theme";
  return /* @__PURE__ */ T("div", Um({
    ref: D,
    className: "" + L + (t ? " " + t : "")
  }, k));
});
rde.displayName = "CodeMirror";
function y3t({
  name: n,
  label: e,
  control: t,
  onChange: r,
  copyToClipboard: i,
  className: s,
  description: o,
  height: a = "200px"
}) {
  const l = wh({
    name: n,
    control: t
  }), c = t !== void 0, u = c && l ? l.field : void 0, [d, f] = wt(""), [h, m] = wt(), { isDarkMode: g } = V3();
  Tt(() => {
    c && u?.value && f(JSON.stringify(u.value, null, 2));
  }, [u?.value, c]);
  const v = Ft(
    (x, E) => {
      try {
        x !== d && x && f(x);
        const w = JSON.parse(x);
        r && r(w), c && u && u.onChange(w), m(void 0);
      } catch (w) {
        w instanceof SyntaxError && m(w.message);
      }
    },
    [d, r, c, u]
  ), y = i && d ? /* @__PURE__ */ ee(ft, { children: [
    /* @__PURE__ */ T("span", { children: e }),
    /* @__PURE__ */ T(g1, { value: d })
  ] }) : e, b = /* @__PURE__ */ T(
    rde,
    {
      className: Q(
        // "tw:bg-background",
        s
      ),
      value: d,
      height: a,
      extensions: [pgt()],
      onChange: v,
      theme: g ? Egt : ygt
    }
  );
  return c ? /* @__PURE__ */ ee(Ci, { children: [
    /* @__PURE__ */ T(Ti, { children: y }),
    b,
    o && /* @__PURE__ */ T(Ai, { children: o }),
    h && /* @__PURE__ */ T(qs, { children: h })
  ] }) : /* @__PURE__ */ ee(ft, { children: [
    /* @__PURE__ */ T(bo, { htmlFor: n, children: y }),
    b,
    h && /* @__PURE__ */ T("div", { className: "pt-2", children: /* @__PURE__ */ T(rJ, { variant: "destructive", children: h }) })
  ] });
}
const mG = _c(
  "tw:m-1 tw:transition-all tw:duration-300 tw:ease-in-out",
  {
    variants: {
      variant: {
        default: "tw:border tw:border-border tw:foreground/tw:10 tw:text-foreground tw:bg-card hover:tw:bg-card/80",
        secondary: "tw:border tw:foreground/tw:10 tw:bg-secondary tw:text-secondary-foreground hover:tw:bg-secondary/80",
        destructive: "tw:border tw:transparent tw:bg-destructive tw:text-destructive-foreground hover:tw:bg-destructive/80",
        inverted: "tw:inverted"
      },
      badgeAnimation: {
        bounce: "hover:tw:-translate-y-1 hover:tw:scale-110",
        pulse: "hover:tw:animate-pulse",
        wiggle: "hover:tw:animate-wiggle",
        fade: "hover:tw:opacity-80",
        slide: "hover:tw:translate-x-1",
        none: ""
      }
    },
    defaultVariants: {
      variant: "default",
      badgeAnimation: "bounce"
    }
  }
), sC = ({
  icon: n,
  className: e,
  style: t,
  ...r
}) => n ? A.isValidElement(n) ? A.cloneElement(n, {
  className: Q(e),
  style: { ...t },
  ...r
}) : Array.isArray(n) ? /* @__PURE__ */ T("span", { className: e, style: t, ...r, children: n }) : typeof n == "function" || typeof n == "object" && n !== null ? /* @__PURE__ */ T(n, { className: e, style: t, ...r }) : /* @__PURE__ */ T("span", { className: e, style: t, ...r, children: n }) : null, ide = A.forwardRef(
  ({
    options: n,
    onValueChange: e,
    variant: t,
    defaultValue: r = [],
    placeholder: i = "Select options",
    animation: s = 0,
    animationConfig: o,
    maxCount: a = 3,
    modalPopover: l = !1,
    // asChild = false,
    className: c,
    hideSelectAll: u = !1,
    searchable: d = !0,
    emptyIndicator: f,
    autoSize: h = !1,
    singleLine: m = !1,
    popoverClassName: g,
    disabled: v = !1,
    responsive: y,
    minWidth: b,
    maxWidth: x,
    deduplicateOptions: E = !1,
    resetOnDefaultValueChange: w = !0,
    closeOnSelect: C = !1,
    ...S
  }, M) => {
    const [k, _] = A.useState(r), [O, I] = A.useState(!1), [R, P] = A.useState(!1), [D, L] = A.useState(""), [B, $] = A.useState(""), [z, H] = A.useState(""), U = A.useRef(k.length), F = A.useRef(O), V = A.useRef(D), X = A.useCallback(
      (me, Pe = "polite") => {
        Pe === "assertive" ? (H(me), setTimeout(() => H(""), 100)) : ($(me), setTimeout(() => $(""), 100));
      },
      []
    ), Z = A.useId(), ie = `${Z}-listbox`, J = `${Z}-description`, se = `${Z}-count`, te = A.useRef(r), le = A.useCallback(
      (me) => me.length > 0 && "heading" in me[0],
      []
    ), de = A.useCallback(
      (me, Pe) => {
        if (me.length !== Pe.length) return !1;
        const yt = [...me].sort(), kt = [...Pe].sort();
        return yt.every((rn, vn) => rn === kt[vn]);
      },
      []
    ), j = A.useCallback(() => {
      _(r), I(!1), L(""), e(r);
    }, [r, e]), xe = A.useRef(null);
    A.useImperativeHandle(
      M,
      () => ({
        reset: j,
        getSelectedValues: () => k,
        setSelectedValues: (me) => {
          _(me), e(me);
        },
        clear: () => {
          _([]), e([]);
        },
        focus: () => {
          if (xe.current) {
            xe.current.focus();
            const me = xe.current.style.outline, Pe = xe.current.style.outlineOffset;
            xe.current.style.outline = "2px solid hsl(var(--ring))", xe.current.style.outlineOffset = "2px", setTimeout(() => {
              xe.current && (xe.current.style.outline = me, xe.current.style.outlineOffset = Pe);
            }, 1e3);
          }
        }
      }),
      [j, k, e]
    );
    const [ne, qe] = A.useState("desktop");
    A.useEffect(() => {
      if (typeof window > "u") return;
      const me = () => {
        const Pe = window.innerWidth;
        Pe < 640 ? qe("mobile") : Pe < 1024 ? qe("tablet") : qe("desktop");
      };
      return me(), window.addEventListener("resize", me), () => {
        typeof window < "u" && window.removeEventListener("resize", me);
      };
    }, []);
    const Ie = (() => {
      if (!y)
        return {
          maxCount: a,
          hideIcons: !1,
          compactMode: !1
        };
      if (y === !0) {
        const yt = {
          mobile: {
            maxCount: 2,
            hideIcons: !1,
            compactMode: !0
          },
          tablet: {
            maxCount: 4,
            hideIcons: !1,
            compactMode: !1
          },
          desktop: {
            maxCount: 6,
            hideIcons: !1,
            compactMode: !1
          }
        }[ne];
        return {
          maxCount: yt?.maxCount ?? a,
          hideIcons: yt?.hideIcons ?? !1,
          compactMode: yt?.compactMode ?? !1
        };
      }
      const me = y[ne];
      return {
        maxCount: me?.maxCount ?? a,
        hideIcons: me?.hideIcons ?? !1,
        compactMode: me?.compactMode ?? !1
      };
    })(), mt = () => {
      if (o?.badgeAnimation)
        switch (o.badgeAnimation) {
          case "bounce":
            return R ? "tw:animate-bounce" : "hover:tw:-translate-y-1 hover:tw:scale-110";
          case "pulse":
            return "hover:tw:animate-pulse";
          case "wiggle":
            return "hover:tw:animate-wiggle";
          case "fade":
            return "hover:tw:opacity-80";
          case "slide":
            return "hover:tw:translate-x-1";
          case "none":
            return "";
          default:
            return "";
        }
      return R ? "animate-bounce" : "";
    }, xt = () => {
      if (o?.popoverAnimation)
        switch (o.popoverAnimation) {
          case "scale":
            return "tw:animate-scaleIn";
          case "slide":
            return "tw:animate-slideInDown";
          case "fade":
            return "tw:animate-fadeIn";
          case "flip":
            return "tw:animate-flipIn";
          case "none":
            return "";
          default:
            return "";
        }
      return "";
    }, G = A.useCallback(() => {
      if (n.length === 0) return [];
      let me;
      le(n) ? me = n.flatMap((rn) => rn.options) : me = n;
      const Pe = /* @__PURE__ */ new Set(), yt = [], kt = [];
      return me.forEach((rn) => {
        Pe.has(rn.value) ? (yt.push(rn.value), E || kt.push(rn)) : (Pe.add(rn.value), kt.push(rn));
      }), process.env.NODE_ENV === "development" && yt.length > 0 && console.warn(
        `MultiSelect: Duplicate option values ${E ? "automatically removed" : "detected"}: ${yt.join(
          ", "
        )}. ${E ? "Duplicates have been removed automatically." : "This may cause unexpected behavior. Consider setting 'deduplicateOptions={true}' or ensure all option values are unique."}`
      ), E ? kt : me;
    }, [n, E, le]), re = A.useCallback(
      (me) => {
        const Pe = G().find(
          (yt) => yt.value === me
        );
        return !Pe && process.env.NODE_ENV === "development" && console.warn(
          `MultiSelect: Option with value "${me}" not found in options list`
        ), Pe;
      },
      [G]
    ), oe = A.useMemo(() => !d || !D ? n : n.length === 0 ? [] : le(n) ? n.map((me) => ({
      ...me,
      options: me.options.filter(
        (Pe) => Pe.label.toLowerCase().includes(D.toLowerCase()) || Pe.value.toLowerCase().includes(D.toLowerCase())
      )
    })).filter((me) => me.options.length > 0) : n.filter(
      (me) => me.label.toLowerCase().includes(D.toLowerCase()) || me.value.toLowerCase().includes(D.toLowerCase())
    ), [n, D, d, le]), Se = (me) => {
      if (me.key === "Enter")
        I(!0);
      else if (me.key === "Backspace" && !me.currentTarget.value) {
        const Pe = [...k];
        Pe.pop(), _(Pe), e(Pe);
      }
    }, ye = (me) => {
      if (v || re(me)?.disabled) return;
      const yt = k.includes(me) ? k.filter((kt) => kt !== me) : [...k, me];
      _(yt), e(yt), C && I(!1);
    }, be = () => {
      v || (_([]), e([]));
    }, Oe = () => {
      v || I((me) => !me);
    }, ut = () => {
      if (v) return;
      const me = k.slice(
        0,
        Ie.maxCount
      );
      _(me), e(me);
    }, Et = () => {
      if (v) return;
      const me = G().filter(
        (Pe) => !Pe.disabled
      );
      if (k.length === me.length)
        be();
      else {
        const Pe = me.map((yt) => yt.value);
        _(Pe), e(Pe);
      }
      C && I(!1);
    };
    A.useEffect(() => {
      if (!w) return;
      const me = te.current;
      de(me, r) || (de(k, r) || _(r), te.current = [...r]);
    }, [
      r,
      k,
      de,
      w
    ]);
    const Wt = {
      minWidth: b || (ne === "mobile" ? "0px" : "200px"),
      maxWidth: x || "100%",
      width: h ? "auto" : "100%"
    };
    return A.useEffect(() => {
      O || L("");
    }, [O]), A.useEffect(() => {
      const me = k.length, Pe = G(), yt = Pe.filter(
        (kt) => !kt.disabled
      ).length;
      if (me !== U.current) {
        const kt = me - U.current;
        if (kt > 0) {
          const vn = k.slice(-kt).map(
            (Xi) => Pe.find((ot) => ot.value === Xi)?.label
          ).filter(Boolean);
          vn.length === 1 ? X(
            `${vn[0]} selected. ${me} of ${yt} options selected.`
          ) : X(
            `${vn.length} options selected. ${me} of ${yt} total selected.`
          );
        } else kt < 0 && X(
          `Option removed. ${me} of ${yt} options selected.`
        );
        U.current = me;
      }
      if (O !== F.current && (X(
        O ? `Dropdown opened. ${yt} options available. Use arrow keys to navigate.` : "Dropdown closed."
      ), F.current = O), D !== V.current && D !== void 0) {
        if (D && O) {
          const kt = Pe.filter(
            (rn) => rn.label.toLowerCase().includes(D.toLowerCase()) || rn.value.toLowerCase().includes(D.toLowerCase())
          ).length;
          X(
            `${kt} option${kt === 1 ? "" : "s"} found for "${D}"`
          );
        }
        V.current = D;
      }
    }, [
      k,
      O,
      D,
      X,
      G
    ]), /* @__PURE__ */ ee(ft, { children: [
      /* @__PURE__ */ ee("div", { className: "tw:sr-only", children: [
        /* @__PURE__ */ T("div", { "aria-live": "polite", "aria-atomic": "true", role: "status", children: B }),
        /* @__PURE__ */ T("div", { "aria-live": "assertive", "aria-atomic": "true", role: "alert", children: z })
      ] }),
      /* @__PURE__ */ ee(
        Dh,
        {
          open: O,
          onOpenChange: I,
          modal: l,
          children: [
            /* @__PURE__ */ T("div", { id: J, className: "tw:sr-only", children: "Multi-select dropdown. Use arrow keys to navigate, Enter to select, and Escape to close." }),
            /* @__PURE__ */ T(
              "div",
              {
                id: se,
                className: "tw:sr-only",
                "aria-live": "polite",
                children: k.length === 0 ? "No options selected" : `${k.length} option${k.length === 1 ? "" : "s"} selected: ${k.map(
                  (me) => re(me)?.label
                ).filter(Boolean).join(", ")}`
              }
            ),
            /* @__PURE__ */ T(Nh, { asChild: !0, children: /* @__PURE__ */ T(
              Nt,
              {
                ref: xe,
                ...S,
                onClick: Oe,
                disabled: v,
                role: "combobox",
                "aria-expanded": O,
                "aria-haspopup": "listbox",
                "aria-controls": O ? ie : void 0,
                "aria-describedby": `${J} ${se}`,
                "aria-label": `Multi-select: ${k.length} of ${G().length} options selected. ${i}`,
                className: Q(
                  "tw:flex tw:h-auto tw:min-h-10 tw:items-center tw:justify-between tw:rounded-md tw:border tw:border-secondary tw:bg-inherit tw:p-1 hover:tw:bg-inherit [&_svg]:pointer-events-auto",
                  h ? "tw:w-auto" : "tw:w-full",
                  Ie.compactMode && "tw:min-h-8 tw:text-sm",
                  ne === "mobile" && "tw:min-h-12 tw:text-base",
                  v && "tw:cursor-not-allowed tw:opacity-50",
                  c
                ),
                style: {
                  ...Wt,
                  maxWidth: `min(${Wt.maxWidth}, 100%)`
                },
                children: k.length > 0 ? /* @__PURE__ */ T("div", { className: "tw:flex tw:w-full tw:items-center tw:justify-between", children: /* @__PURE__ */ ee(
                  "div",
                  {
                    className: Q(
                      "tw:flex tw:items-center gap-1",
                      m ? "tw:multiselect-singleline-scroll tw:overflow-x-auto" : "tw:flex-wrap",
                      Ie.compactMode && "tw:gap-0.5"
                    ),
                    style: m ? {
                      paddingBottom: "4px"
                    } : {},
                    children: [
                      k.slice(
                        0,
                        Ie.maxCount
                      ).map((me) => {
                        const Pe = re(me), yt = Pe?.icon, kt = Pe?.style;
                        if (!Pe)
                          return null;
                        const rn = {
                          animationDuration: `${s}s`,
                          ...kt?.badgeColor && {
                            backgroundColor: kt.badgeColor
                          },
                          ...kt?.gradient && {
                            background: kt.gradient,
                            color: "white"
                          }
                        };
                        return /* @__PURE__ */ ee(
                          hz,
                          {
                            className: Q(
                              mt(),
                              mG(
                                { variant: t }
                              ),
                              kt?.gradient && "tw:border tw:transparent tw:text-white",
                              Ie.compactMode && "tw:px-1.5 tw:py-0.5 tw:text-xs",
                              ne === "mobile" && "tw:max-w-[120px] tw:truncate",
                              m && "tw:shrink-0 tw:whitespace-nowrap",
                              "[&>svg]:tw:pointer-events-auto"
                            ),
                            style: {
                              ...rn,
                              animationDuration: `${o?.duration || s}s`,
                              animationDelay: `${o?.delay || 0}s`
                            },
                            children: [
                              yt && !Ie.hideIcons && /* @__PURE__ */ T(
                                sC,
                                {
                                  icon: yt,
                                  className: Q(
                                    "",
                                    Ie.compactMode && "",
                                    kt?.iconColor && "tw:text-current"
                                  ),
                                  style: kt?.iconColor ? {
                                    color: kt.iconColor
                                  } : void 0
                                }
                              ),
                              /* @__PURE__ */ T(
                                "span",
                                {
                                  className: Q(
                                    ne === "mobile" && "tw:truncate"
                                  ),
                                  children: Pe.label
                                }
                              ),
                              /* @__PURE__ */ T(
                                "div",
                                {
                                  role: "button",
                                  tabIndex: 0,
                                  onClick: (vn) => {
                                    vn.stopPropagation(), ye(
                                      me
                                    );
                                  },
                                  onKeyDown: (vn) => {
                                    (vn.key === "Enter" || vn.key === " ") && (vn.preventDefault(), vn.stopPropagation(), ye(
                                      me
                                    ));
                                  },
                                  "aria-label": `Remove ${Pe.label} from selection`,
                                  className: "tw:m-0.5 tw:ml-2 tw:h-4 tw:w-4 tw:cursor-pointer tw:rounded-sm tw:p-0.5 hover:tw:bg-white/20 focus:tw:ring-1 focus:tw:ring-white/50 focus:tw:outline-none",
                                  children: /* @__PURE__ */ T(
                                    UF,
                                    {
                                      className: Q(
                                        "tw:h-3 tw:w-3",
                                        Ie.compactMode && "tw:h-2.5 tw:w-2.5"
                                      )
                                    }
                                  )
                                }
                              )
                            ]
                          },
                          me
                        );
                      }).filter(Boolean),
                      k.length > Ie.maxCount && /* @__PURE__ */ ee(
                        hz,
                        {
                          className: Q(
                            "tw:text-foreground tw:border tw:foreground/tw:1 tw:bg-transparent hover:tw:bg-transparent",
                            mt(),
                            mG({
                              variant: t
                            }),
                            Ie.compactMode && "tw:px-1.5 tw:py-0.5 tw:text-xs",
                            m && "tw:shrink-0 tw:whitespace-nowrap",
                            "[&>svg]:tw:pointer-events-auto"
                          ),
                          style: {
                            animationDuration: `${o?.duration || s}s`,
                            animationDelay: `${o?.delay || 0}s`
                          },
                          children: [
                            `+ ${k.length - Ie.maxCount} more`,
                            /* @__PURE__ */ T(
                              UF,
                              {
                                className: Q(
                                  "tw:ml-2 tw:h-4 tw:w-4 tw:cursor-pointer",
                                  Ie.compactMode && "tw:ml-1 tw:h-3 tw:w-3"
                                ),
                                onClick: (me) => {
                                  me.stopPropagation(), ut();
                                }
                              }
                            )
                          ]
                        }
                      )
                    ]
                  }
                ) }) : /* @__PURE__ */ ee("div", { className: "tw:flex tw:w-full tw:items-center tw:justify-between tw:mx-auto", children: [
                  /* @__PURE__ */ T("span", { className: "tw:text-muted-foreground tw:text-sm tw:mx-3", children: i }),
                  /* @__PURE__ */ T(od, { className: "tw:text-muted-foreground tw:mx-2 tw:h-4 tw:cursor-pointer" })
                ] })
              }
            ) }),
            /* @__PURE__ */ T(
              ld,
              {
                id: ie,
                role: "listbox",
                "aria-multiselectable": "true",
                "aria-label": "Available options",
                collisionPadding: 20,
                className: Q(
                  "tw:w-auto tw:p-0",
                  xt(),
                  ne === "mobile" && "tw:w-[85vw] tw:max-w-[280px]",
                  ne === "tablet" && "tw:w-[70vw] tw:max-w-md",
                  ne === "desktop" && "tw:min-w-[300px]",
                  g
                ),
                style: {
                  animationDuration: `${o?.duration || s}s`,
                  animationDelay: `${o?.delay || 0}s`,
                  maxWidth: `min(${Wt.maxWidth}, 85vw)`,
                  maxHeight: "var(--radix-popover-content-available-height)",
                  touchAction: "manipulation"
                },
                align: "start",
                onEscapeKeyDown: () => I(!1),
                children: /* @__PURE__ */ ee(m3, { children: [
                  d && /* @__PURE__ */ T(
                    g3,
                    {
                      autoFocus: !1,
                      placeholder: "Search options...",
                      onKeyDown: Se,
                      value: D,
                      onValueChange: L,
                      "aria-label": "Search through available options",
                      "aria-describedby": `${Z}-search-help`
                    }
                  ),
                  d && /* @__PURE__ */ T(
                    "div",
                    {
                      id: `${Z}-search-help`,
                      className: "tw:sr-only",
                      children: "Type to filter options. Use arrow keys to navigate results."
                    }
                  ),
                  /* @__PURE__ */ ee(
                    v3,
                    {
                      className: Q(
                        "tw:multiselect-scrollbar tw:max-h-[40vh] tw:overflow-y-auto",
                        ne === "mobile" && "tw:max-h-[50vh]",
                        "tw:overscroll-behavior-y-contain"
                      ),
                      children: [
                        /* @__PURE__ */ T(y3, { children: f || "No results found." }),
                        " ",
                        !u && !D && /* @__PURE__ */ T(cu, { children: /* @__PURE__ */ ee(
                          Ka,
                          {
                            onSelect: Et,
                            role: "option",
                            "aria-selected": k.length === G().filter(
                              (me) => !me.disabled
                            ).length,
                            "aria-label": `Select all ${G().length} options`,
                            className: "tw:cursor-pointer",
                            children: [
                              /* @__PURE__ */ T(
                                "div",
                                {
                                  className: Q(
                                    "tw:border-border tw:mr-2 tw:flex tw:h-4 tw:w-4 tw:items-center tw:justify-center tw:rounded-sm tw:border",
                                    k.length === G().filter(
                                      (me) => !me.disabled
                                    ).length ? "tw:bg-primary tw:text-primary-foreground" : "tw:opacity-50 [&_svg]:tw:invisible"
                                  ),
                                  "aria-hidden": "true",
                                  children: /* @__PURE__ */ T(oc, { className: "tw:h-4 tw:w-4" })
                                }
                              ),
                              /* @__PURE__ */ ee("span", { children: [
                                "(Select All",
                                G().length > 20 ? ` - ${G().length} options` : "",
                                ")"
                              ] })
                            ]
                          },
                          "all"
                        ) }),
                        le(oe) ? oe.map((me) => /* @__PURE__ */ T(
                          cu,
                          {
                            heading: me.heading,
                            children: me.options.map((Pe) => {
                              const yt = k.includes(
                                Pe.value
                              );
                              return /* @__PURE__ */ ee(
                                Ka,
                                {
                                  onSelect: () => ye(
                                    Pe.value
                                  ),
                                  role: "option",
                                  "aria-selected": yt,
                                  "aria-disabled": Pe.disabled,
                                  "aria-label": `${Pe.label}${yt ? ", selected" : ", not selected"}${Pe.disabled ? ", disabled" : ""}`,
                                  className: Q(
                                    "tw:cursor-pointer",
                                    Pe.disabled && "tw:cursor-not-allowed tw:opacity-50"
                                  ),
                                  disabled: Pe.disabled,
                                  children: [
                                    /* @__PURE__ */ T(
                                      "div",
                                      {
                                        className: Q(
                                          "tw:border-border tw:mr-2 tw:flex tw:h-4 tw:w-4 tw:items-center tw:justify-center tw:rounded-sm tw:border",
                                          yt ? "tw:bg-primary tw:text-primary-foreground" : "tw:opacity-50 [&_svg]:tw:invisible"
                                        ),
                                        "aria-hidden": "true",
                                        children: /* @__PURE__ */ T(oc, { className: "tw:h-4 tw:w-4" })
                                      }
                                    ),
                                    Pe.icon && /* @__PURE__ */ T(
                                      sC,
                                      {
                                        icon: Pe.icon,
                                        className: "",
                                        "aria-hidden": "true"
                                      }
                                    ),
                                    /* @__PURE__ */ T("span", { children: Pe.label })
                                  ]
                                },
                                Pe.value
                              );
                            })
                          },
                          me.heading
                        )) : /* @__PURE__ */ T(cu, { children: oe.map((me) => {
                          const Pe = k.includes(
                            me.value
                          );
                          return /* @__PURE__ */ ee(
                            Ka,
                            {
                              onSelect: () => ye(
                                me.value
                              ),
                              role: "option",
                              "aria-selected": Pe,
                              "aria-disabled": me.disabled,
                              "aria-label": `${me.label}${Pe ? ", selected" : ", not selected"}${me.disabled ? ", disabled" : ""}`,
                              className: Q(
                                "tw:cursor-pointer",
                                me.disabled && "tw:cursor-not-allowed tw:opacity-50"
                              ),
                              disabled: me.disabled,
                              children: [
                                /* @__PURE__ */ T(
                                  "div",
                                  {
                                    className: Q(
                                      "tw:border-border tw:mr-2 tw:flex tw:h-4 tw:w-4 tw:items-center tw:justify-center tw:rounded-sm tw:border",
                                      Pe ? "tw:bg-primary tw:text-primary-foreground" : "tw:opacity-50 [&_svg]:tw:invisible"
                                    ),
                                    "aria-hidden": "true",
                                    children: /* @__PURE__ */ T(oc, { className: "tw:h-4 tw:w-4" })
                                  }
                                ),
                                me.icon && /* @__PURE__ */ T(
                                  sC,
                                  {
                                    icon: me.icon,
                                    className: "",
                                    "aria-hidden": "true"
                                  }
                                ),
                                /* @__PURE__ */ T("span", { children: me.label })
                              ]
                            },
                            me.value
                          );
                        }) }),
                        /* @__PURE__ */ T(FZ, {}),
                        /* @__PURE__ */ T(cu, { children: /* @__PURE__ */ ee("div", { className: "tw:flex tw:items-center tw:justify-between", children: [
                          k.length > 0 && /* @__PURE__ */ ee(ft, { children: [
                            /* @__PURE__ */ T(
                              Ka,
                              {
                                onSelect: be,
                                className: "tw:flex-1 tw:cursor-pointer tw:justify-center",
                                children: "Clear"
                              }
                            ),
                            /* @__PURE__ */ T(
                              ra,
                              {
                                orientation: "vertical",
                                className: "tw:flex tw:h-full tw:min-h-6"
                              }
                            )
                          ] }),
                          /* @__PURE__ */ T(
                            Ka,
                            {
                              onSelect: () => I(!1),
                              className: "tw:max-w-full tw:flex-1 tw:cursor-pointer tw:justify-center",
                              children: "Close"
                            }
                          )
                        ] }) })
                      ]
                    }
                  )
                ] })
              }
            ),
            s > 0 && k.length > 0 && /* @__PURE__ */ T(
              mRe,
              {
                className: Q(
                  "tw:text-foreground tw:bg-background tw:my-2 tw:h-3 tw:w-3 tw:cursor-pointer",
                  R ? "" : "tw:text-muted-foreground"
                ),
                onClick: () => P(!R)
              }
            )
          ]
        }
      )
    ] });
  }
);
ide.displayName = "MultiSelect";
function b3t(n) {
  return /* @__PURE__ */ T(
    xs,
    {
      control: n.control,
      name: n.name,
      render: ({ field: e }) => /* @__PURE__ */ ee(Ci, { children: [
        /* @__PURE__ */ T(Ti, { children: n.label }),
        /* @__PURE__ */ T(qi, { children: /* @__PURE__ */ T(
          ide,
          {
            options: n.options,
            placeholder: n.placeholder,
            onValueChange: (t) => {
              e.onChange(t);
            },
            defaultValue: e.value,
            modalPopover: !0,
            autoSize: !0,
            maxCount: 2,
            ...n.multiSelectProps
          }
        ) }),
        n.description && /* @__PURE__ */ T(Ai, { children: n.description }),
        /* @__PURE__ */ T(qs, {})
      ] })
    }
  );
}
function w3t({
  label: n,
  placeholder: e,
  description: t,
  control: r,
  name: i,
  fetchOptions: s,
  renderOption: o,
  renderSelected: a,
  disabled: l,
  notFoundText: c,
  onSelect: u,
  autoFocus: d
}) {
  const [f, h] = wt(""), [m, g] = wt([]), [v, y] = wt(!1), [b, x] = wt(!1), E = Fre(f, 600), w = Gt(!1);
  return Tt(() => {
    if (w.current) {
      w.current = !1;
      return;
    }
    if (!E || E.length < 3) {
      g([]), y(!1);
      return;
    }
    x(!0), y(!0), s(E).then((C) => {
      g(C);
    }).finally(() => {
      x(!1);
    }).catch((C) => {
      console.error("Scaffoldy error fetching options:", C), y(!1);
    });
  }, [E, s]), /* @__PURE__ */ T(
    xs,
    {
      control: r,
      name: i,
      render: ({ field: C }) => /* @__PURE__ */ ee(Ci, { children: [
        n && /* @__PURE__ */ T(Ti, { children: n }),
        t && /* @__PURE__ */ T(Ai, { children: t }),
        /* @__PURE__ */ T(qi, { children: /* @__PURE__ */ T("div", { className: "", children: /* @__PURE__ */ ee(Bh, { open: v, onOpenChange: y, children: [
          /* @__PURE__ */ T(
            Ui,
            {
              type: "text",
              value: f,
              onChange: (S) => {
                const M = S.target.value;
                h(M), C.onChange(M);
              },
              placeholder: e,
              disabled: l,
              autoFocus: d
            }
          ),
          /* @__PURE__ */ T(zh, {}),
          /* @__PURE__ */ T(
            dd,
            {
              align: "start",
              onOpenAutoFocus: (S) => S.preventDefault(),
              children: b ? /* @__PURE__ */ T(xo, { disabled: !0, children: /* @__PURE__ */ T(Ire, { text: "Loading..." }) }) : m.length > 0 ? m.map((S, M) => /* @__PURE__ */ T(
                xo,
                {
                  onSelect: () => {
                    w.current = !0, C.onChange(S), y(!1), h(
                      a(S)
                    ), u && u(S);
                  },
                  children: o(S)
                },
                M
              )) : /* @__PURE__ */ T(xo, { disabled: !0, children: c })
            }
          )
        ] }) }) }),
        /* @__PURE__ */ T(qs, {})
      ] })
    }
  );
}
var Mx = "Checkbox", [Oyt] = qr(Mx), [Iyt, vI] = Oyt(Mx);
function Ryt(n) {
  const {
    __scopeCheckbox: e,
    checked: t,
    children: r,
    defaultChecked: i,
    disabled: s,
    form: o,
    name: a,
    onCheckedChange: l,
    required: c,
    value: u = "on",
    // @ts-expect-error
    internal_do_not_use_render: d
  } = n, [f, h] = Kr({
    prop: t,
    defaultProp: i ?? !1,
    onChange: l,
    caller: Mx
  }), [m, g] = A.useState(null), [v, y] = A.useState(null), b = A.useRef(!1), x = m ? !!o || !!m.closest("form") : (
    // We set this to true by default so that events bubble to forms without JS (SSR)
    !0
  ), E = {
    checked: f,
    disabled: s,
    setChecked: h,
    control: m,
    setControl: g,
    name: a,
    form: o,
    value: u,
    hasConsumerStoppedPropagationRef: b,
    required: c,
    defaultChecked: hc(i) ? !1 : i,
    isFormControl: x,
    bubbleInput: v,
    setBubbleInput: y
  };
  return /* @__PURE__ */ T(
    Iyt,
    {
      scope: e,
      ...E,
      children: Pyt(d) ? d(E) : r
    }
  );
}
var sde = "CheckboxTrigger", ode = A.forwardRef(
  ({ __scopeCheckbox: n, onKeyDown: e, onClick: t, ...r }, i) => {
    const {
      control: s,
      value: o,
      disabled: a,
      checked: l,
      required: c,
      setControl: u,
      setChecked: d,
      hasConsumerStoppedPropagationRef: f,
      isFormControl: h,
      bubbleInput: m
    } = vI(sde, n), g = ht(i, u), v = A.useRef(l);
    return A.useEffect(() => {
      const y = s?.form;
      if (y) {
        const b = () => d(v.current);
        return y.addEventListener("reset", b), () => y.removeEventListener("reset", b);
      }
    }, [s, d]), /* @__PURE__ */ T(
      Ve.button,
      {
        type: "button",
        role: "checkbox",
        "aria-checked": hc(l) ? "mixed" : l,
        "aria-required": c,
        "data-state": dde(l),
        "data-disabled": a ? "" : void 0,
        disabled: a,
        value: o,
        ...r,
        ref: g,
        onKeyDown: Ce(e, (y) => {
          y.key === "Enter" && y.preventDefault();
        }),
        onClick: Ce(t, (y) => {
          d((b) => hc(b) ? !0 : !b), m && h && (f.current = y.isPropagationStopped(), f.current || y.stopPropagation());
        })
      }
    );
  }
);
ode.displayName = sde;
var yI = A.forwardRef(
  (n, e) => {
    const {
      __scopeCheckbox: t,
      name: r,
      checked: i,
      defaultChecked: s,
      required: o,
      disabled: a,
      value: l,
      onCheckedChange: c,
      form: u,
      ...d
    } = n;
    return /* @__PURE__ */ T(
      Ryt,
      {
        __scopeCheckbox: t,
        checked: i,
        defaultChecked: s,
        disabled: a,
        required: o,
        onCheckedChange: c,
        name: r,
        form: u,
        value: l,
        internal_do_not_use_render: ({ isFormControl: f }) => /* @__PURE__ */ ee(ft, { children: [
          /* @__PURE__ */ T(
            ode,
            {
              ...d,
              ref: e,
              __scopeCheckbox: t
            }
          ),
          f && /* @__PURE__ */ T(
            ude,
            {
              __scopeCheckbox: t
            }
          )
        ] })
      }
    );
  }
);
yI.displayName = Mx;
var ade = "CheckboxIndicator", lde = A.forwardRef(
  (n, e) => {
    const { __scopeCheckbox: t, forceMount: r, ...i } = n, s = vI(ade, t);
    return /* @__PURE__ */ T(
      Yr,
      {
        present: r || hc(s.checked) || s.checked === !0,
        children: /* @__PURE__ */ T(
          Ve.span,
          {
            "data-state": dde(s.checked),
            "data-disabled": s.disabled ? "" : void 0,
            ...i,
            ref: e,
            style: { pointerEvents: "none", ...n.style }
          }
        )
      }
    );
  }
);
lde.displayName = ade;
var cde = "CheckboxBubbleInput", ude = A.forwardRef(
  ({ __scopeCheckbox: n, ...e }, t) => {
    const {
      control: r,
      hasConsumerStoppedPropagationRef: i,
      checked: s,
      defaultChecked: o,
      required: a,
      disabled: l,
      name: c,
      value: u,
      form: d,
      bubbleInput: f,
      setBubbleInput: h
    } = vI(cde, n), m = ht(t, h), g = q3(s), v = S3(r);
    A.useEffect(() => {
      const b = f;
      if (!b) return;
      const x = window.HTMLInputElement.prototype, w = Object.getOwnPropertyDescriptor(
        x,
        "checked"
      ).set, C = !i.current;
      if (g !== s && w) {
        const S = new Event("click", { bubbles: C });
        b.indeterminate = hc(s), w.call(b, hc(s) ? !1 : s), b.dispatchEvent(S);
      }
    }, [f, g, s, i]);
    const y = A.useRef(hc(s) ? !1 : s);
    return /* @__PURE__ */ T(
      Ve.input,
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: o ?? y.current,
        required: a,
        disabled: l,
        name: c,
        value: u,
        form: d,
        ...e,
        tabIndex: -1,
        ref: m,
        style: {
          ...e.style,
          ...v,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0,
          // We transform because the input is absolutely positioned but we have
          // rendered it **after** the button. This pulls it back to sit on top
          // of the button.
          transform: "translateX(-100%)"
        }
      }
    );
  }
);
ude.displayName = cde;
function Pyt(n) {
  return typeof n == "function";
}
function hc(n) {
  return n === "indeterminate";
}
function dde(n) {
  return hc(n) ? "indeterminate" : n ? "checked" : "unchecked";
}
const fde = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  yI,
  {
    ref: t,
    className: Q(
      "tw:grid tw:place-content-center tw:peer tw:h-4 tw:w-4 tw:shrink-0 tw:rounded-sm tw:border tw:border-primary tw:ring-offset-background tw:focus-visible:outline-hidden tw:focus-visible:ring-2 tw:focus-visible:ring-ring tw:focus-visible:ring-offset-2 tw:disabled:cursor-not-allowed tw:disabled:opacity-50 tw:data-[state=checked]:bg-primary tw:data-[state=checked]:text-primary-foreground",
      n
    ),
    ...e,
    children: /* @__PURE__ */ T(
      lde,
      {
        className: Q("tw:grid tw:place-content-center tw:text-current"),
        children: /* @__PURE__ */ T(oc, { className: "tw:h-4 tw:w-4" })
      }
    )
  }
));
fde.displayName = yI.displayName;
function x3t(n) {
  const e = n.removeDuplicates ? [...new Set(n.options)] : n.options;
  return /* @__PURE__ */ T(
    xs,
    {
      control: n.control,
      name: n.name,
      render: ({ field: t }) => /* @__PURE__ */ ee(Ci, { children: [
        /* @__PURE__ */ T(Ti, { children: n.label }),
        /* @__PURE__ */ T(qi, { children: /* @__PURE__ */ T("div", { className: "tw:space-y-2", children: e.map((r, i) => {
          const s = r.toString();
          return /* @__PURE__ */ ee(
            "div",
            {
              className: "tw:flex tw:items-center tw:space-x-2",
              children: [
                /* @__PURE__ */ T(
                  fde,
                  {
                    checked: t.value?.includes(
                      s
                    ),
                    onCheckedChange: (o) => {
                      t.onChange(
                        o ? [
                          ...t.value || [],
                          s
                        ] : t.value?.filter(
                          (a) => a !== s
                        )
                      );
                    }
                  }
                ),
                /* @__PURE__ */ T("span", { children: n.resolveOption(r) })
              ]
            },
            i
          );
        }) }) }),
        n.description && /* @__PURE__ */ T(Ai, { children: n.description }),
        /* @__PURE__ */ T(qs, {})
      ] })
    }
  );
}
// @__NO_SIDE_EFFECTS__
function Dyt(n) {
  const e = /* @__PURE__ */ Nyt(n), t = A.forwardRef((r, i) => {
    const { children: s, ...o } = r, a = A.Children.toArray(s), l = a.find($yt);
    if (l) {
      const c = l.props.children, u = a.map((d) => d === l ? A.Children.count(c) > 1 ? A.Children.only(null) : A.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ T(e, { ...o, ref: i, children: A.isValidElement(c) ? A.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ T(e, { ...o, ref: i, children: s });
  });
  return t.displayName = `${n}.Slot`, t;
}
// @__NO_SIDE_EFFECTS__
function Nyt(n) {
  const e = A.forwardRef((t, r) => {
    const { children: i, ...s } = t;
    if (A.isValidElement(i)) {
      const o = Byt(i), a = Fyt(s, i.props);
      return i.type !== A.Fragment && (a.ref = r ? bi(r, o) : o), A.cloneElement(i, a);
    }
    return A.Children.count(i) > 1 ? A.Children.only(null) : null;
  });
  return e.displayName = `${n}.SlotClone`, e;
}
var Lyt = Symbol("radix.slottable");
function $yt(n) {
  return A.isValidElement(n) && typeof n.type == "function" && "__radixId" in n.type && n.type.__radixId === Lyt;
}
function Fyt(n, e) {
  const t = { ...e };
  for (const r in e) {
    const i = n[r], s = e[r];
    /^on[A-Z]/.test(r) ? i && s ? t[r] = (...a) => {
      const l = s(...a);
      return i(...a), l;
    } : i && (t[r] = i) : r === "style" ? t[r] = { ...i, ...s } : r === "className" && (t[r] = [i, s].filter(Boolean).join(" "));
  }
  return { ...n, ...t };
}
function Byt(n) {
  let e = Object.getOwnPropertyDescriptor(n.props, "ref")?.get, t = e && "isReactWarning" in e && e.isReactWarning;
  return t ? n.ref : (e = Object.getOwnPropertyDescriptor(n, "ref")?.get, t = e && "isReactWarning" in e && e.isReactWarning, t ? n.props.ref : n.props.ref || n.ref);
}
var zyt = [" ", "Enter", "ArrowUp", "ArrowDown"], Hyt = [" ", "Enter"], Zu = "Select", [kx, _x, Uyt] = Lh(Zu), [Kh] = qr(Zu, [
  Uyt,
  Oc
]), Ox = Oc(), [Vyt, Fc] = Kh(Zu), [jyt, Wyt] = Kh(Zu), hde = (n) => {
  const {
    __scopeSelect: e,
    children: t,
    open: r,
    defaultOpen: i,
    onOpenChange: s,
    value: o,
    defaultValue: a,
    onValueChange: l,
    dir: c,
    name: u,
    autoComplete: d,
    disabled: f,
    required: h,
    form: m
  } = n, g = Ox(e), [v, y] = A.useState(null), [b, x] = A.useState(null), [E, w] = A.useState(!1), C = Rc(c), [S, M] = Kr({
    prop: r,
    defaultProp: i ?? !1,
    onChange: s,
    caller: Zu
  }), [k, _] = Kr({
    prop: o,
    defaultProp: a,
    onChange: l,
    caller: Zu
  }), O = A.useRef(null), I = v ? m || !!v.closest("form") : !0, [R, P] = A.useState(/* @__PURE__ */ new Set()), D = Array.from(R).map((L) => L.props.value).join(";");
  return /* @__PURE__ */ T(C3, { ...g, children: /* @__PURE__ */ ee(
    Vyt,
    {
      required: h,
      scope: e,
      trigger: v,
      onTriggerChange: y,
      valueNode: b,
      onValueNodeChange: x,
      valueNodeHasChildren: E,
      onValueNodeHasChildrenChange: w,
      contentId: Xn(),
      value: k,
      onValueChange: _,
      open: S,
      onOpenChange: M,
      dir: C,
      triggerPointerDownPosRef: O,
      disabled: f,
      children: [
        /* @__PURE__ */ T(kx.Provider, { scope: e, children: /* @__PURE__ */ T(
          jyt,
          {
            scope: n.__scopeSelect,
            onNativeOptionAdd: A.useCallback((L) => {
              P((B) => new Set(B).add(L));
            }, []),
            onNativeOptionRemove: A.useCallback((L) => {
              P((B) => {
                const $ = new Set(B);
                return $.delete(L), $;
              });
            }, []),
            children: t
          }
        ) }),
        I ? /* @__PURE__ */ ee(
          $de,
          {
            "aria-hidden": !0,
            required: h,
            tabIndex: -1,
            name: u,
            autoComplete: d,
            value: k,
            onChange: (L) => _(L.target.value),
            disabled: f,
            form: m,
            children: [
              k === void 0 ? /* @__PURE__ */ T("option", { value: "" }) : null,
              Array.from(R)
            ]
          },
          D
        ) : null
      ]
    }
  ) });
};
hde.displayName = Zu;
var pde = "SelectTrigger", mde = A.forwardRef(
  (n, e) => {
    const { __scopeSelect: t, disabled: r = !1, ...i } = n, s = Ox(t), o = Fc(pde, t), a = o.disabled || r, l = ht(e, o.onTriggerChange), c = _x(t), u = A.useRef("touch"), [d, f, h] = Bde((g) => {
      const v = c().filter((x) => !x.disabled), y = v.find((x) => x.value === o.value), b = zde(v, g, y);
      b !== void 0 && o.onValueChange(b.value);
    }), m = (g) => {
      a || (o.onOpenChange(!0), h()), g && (o.triggerPointerDownPosRef.current = {
        x: Math.round(g.pageX),
        y: Math.round(g.pageY)
      });
    };
    return /* @__PURE__ */ T(C1, { asChild: !0, ...s, children: /* @__PURE__ */ T(
      Ve.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": o.contentId,
        "aria-expanded": o.open,
        "aria-required": o.required,
        "aria-autocomplete": "none",
        dir: o.dir,
        "data-state": o.open ? "open" : "closed",
        disabled: a,
        "data-disabled": a ? "" : void 0,
        "data-placeholder": Fde(o.value) ? "" : void 0,
        ...i,
        ref: l,
        onClick: Ce(i.onClick, (g) => {
          g.currentTarget.focus(), u.current !== "mouse" && m(g);
        }),
        onPointerDown: Ce(i.onPointerDown, (g) => {
          u.current = g.pointerType;
          const v = g.target;
          v.hasPointerCapture(g.pointerId) && v.releasePointerCapture(g.pointerId), g.button === 0 && g.ctrlKey === !1 && g.pointerType === "mouse" && (m(g), g.preventDefault());
        }),
        onKeyDown: Ce(i.onKeyDown, (g) => {
          const v = d.current !== "";
          !(g.ctrlKey || g.altKey || g.metaKey) && g.key.length === 1 && f(g.key), !(v && g.key === " ") && zyt.includes(g.key) && (m(), g.preventDefault());
        })
      }
    ) });
  }
);
mde.displayName = pde;
var gde = "SelectValue", vde = A.forwardRef(
  (n, e) => {
    const { __scopeSelect: t, className: r, style: i, children: s, placeholder: o = "", ...a } = n, l = Fc(gde, t), { onValueNodeHasChildrenChange: c } = l, u = s !== void 0, d = ht(e, l.onValueNodeChange);
    return Rr(() => {
      c(u);
    }, [c, u]), /* @__PURE__ */ T(
      Ve.span,
      {
        ...a,
        ref: d,
        style: { pointerEvents: "none" },
        children: Fde(l.value) ? /* @__PURE__ */ T(ft, { children: o }) : s
      }
    );
  }
);
vde.displayName = gde;
var Gyt = "SelectIcon", yde = A.forwardRef(
  (n, e) => {
    const { __scopeSelect: t, children: r, ...i } = n;
    return /* @__PURE__ */ T(Ve.span, { "aria-hidden": !0, ...i, ref: e, children: r || "▼" });
  }
);
yde.displayName = Gyt;
var Kyt = "SelectPortal", bde = (n) => /* @__PURE__ */ T(y1, { asChild: !0, ...n });
bde.displayName = Kyt;
var Qu = "SelectContent", wde = A.forwardRef(
  (n, e) => {
    const t = Fc(Qu, n.__scopeSelect), [r, i] = A.useState();
    if (Rr(() => {
      i(new DocumentFragment());
    }, []), !t.open) {
      const s = r;
      return s ? mw.createPortal(
        /* @__PURE__ */ T(xde, { scope: n.__scopeSelect, children: /* @__PURE__ */ T(kx.Slot, { scope: n.__scopeSelect, children: /* @__PURE__ */ T("div", { children: n.children }) }) }),
        s
      ) : null;
    }
    return /* @__PURE__ */ T(Ede, { ...n, ref: e });
  }
);
wde.displayName = Qu;
var ro = 10, [xde, Bc] = Kh(Qu), qyt = "SelectContentImpl", Yyt = /* @__PURE__ */ Dyt("SelectContent.RemoveScroll"), Ede = A.forwardRef(
  (n, e) => {
    const {
      __scopeSelect: t,
      position: r = "item-aligned",
      onCloseAutoFocus: i,
      onEscapeKeyDown: s,
      onPointerDownOutside: o,
      //
      // PopperContent props
      side: a,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: f,
      collisionPadding: h,
      sticky: m,
      hideWhenDetached: g,
      avoidCollisions: v,
      //
      ...y
    } = n, b = Fc(Qu, t), [x, E] = A.useState(null), [w, C] = A.useState(null), S = ht(e, (J) => E(J)), [M, k] = A.useState(null), [_, O] = A.useState(
      null
    ), I = _x(t), [R, P] = A.useState(!1), D = A.useRef(!1);
    A.useEffect(() => {
      if (x) return o3(x);
    }, [x]), i3();
    const L = A.useCallback(
      (J) => {
        const [se, ...te] = I().map((j) => j.ref.current), [le] = te.slice(-1), de = document.activeElement;
        for (const j of J)
          if (j === de || (j?.scrollIntoView({ block: "nearest" }), j === se && w && (w.scrollTop = 0), j === le && w && (w.scrollTop = w.scrollHeight), j?.focus(), document.activeElement !== de)) return;
      },
      [I, w]
    ), B = A.useCallback(
      () => L([M, x]),
      [L, M, x]
    );
    A.useEffect(() => {
      R && B();
    }, [R, B]);
    const { onOpenChange: $, triggerPointerDownPosRef: z } = b;
    A.useEffect(() => {
      if (x) {
        let J = { x: 0, y: 0 };
        const se = (le) => {
          J = {
            x: Math.abs(Math.round(le.pageX) - (z.current?.x ?? 0)),
            y: Math.abs(Math.round(le.pageY) - (z.current?.y ?? 0))
          };
        }, te = (le) => {
          J.x <= 10 && J.y <= 10 ? le.preventDefault() : x.contains(le.target) || $(!1), document.removeEventListener("pointermove", se), z.current = null;
        };
        return z.current !== null && (document.addEventListener("pointermove", se), document.addEventListener("pointerup", te, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", se), document.removeEventListener("pointerup", te, { capture: !0 });
        };
      }
    }, [x, $, z]), A.useEffect(() => {
      const J = () => $(!1);
      return window.addEventListener("blur", J), window.addEventListener("resize", J), () => {
        window.removeEventListener("blur", J), window.removeEventListener("resize", J);
      };
    }, [$]);
    const [H, U] = Bde((J) => {
      const se = I().filter((de) => !de.disabled), te = se.find((de) => de.ref.current === document.activeElement), le = zde(se, J, te);
      le && setTimeout(() => le.ref.current.focus());
    }), F = A.useCallback(
      (J, se, te) => {
        const le = !D.current && !te;
        (b.value !== void 0 && b.value === se || le) && (k(J), le && (D.current = !0));
      },
      [b.value]
    ), V = A.useCallback(() => x?.focus(), [x]), X = A.useCallback(
      (J, se, te) => {
        const le = !D.current && !te;
        (b.value !== void 0 && b.value === se || le) && O(J);
      },
      [b.value]
    ), Z = r === "popper" ? xA : Sde, ie = Z === xA ? {
      side: a,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: f,
      collisionPadding: h,
      sticky: m,
      hideWhenDetached: g,
      avoidCollisions: v
    } : {};
    return /* @__PURE__ */ T(
      xde,
      {
        scope: t,
        content: x,
        viewport: w,
        onViewportChange: C,
        itemRefCallback: F,
        selectedItem: M,
        onItemLeave: V,
        itemTextRefCallback: X,
        focusSelectedItem: B,
        selectedItemText: _,
        position: r,
        isPositioned: R,
        searchRef: H,
        children: /* @__PURE__ */ T(b1, { as: Yyt, allowPinchZoom: !0, children: /* @__PURE__ */ T(
          v1,
          {
            asChild: !0,
            trapped: b.open,
            onMountAutoFocus: (J) => {
              J.preventDefault();
            },
            onUnmountAutoFocus: Ce(i, (J) => {
              b.trigger?.focus({ preventScroll: !0 }), J.preventDefault();
            }),
            children: /* @__PURE__ */ T(
              Ih,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: s,
                onPointerDownOutside: o,
                onFocusOutside: (J) => J.preventDefault(),
                onDismiss: () => b.onOpenChange(!1),
                children: /* @__PURE__ */ T(
                  Z,
                  {
                    role: "listbox",
                    id: b.contentId,
                    "data-state": b.open ? "open" : "closed",
                    dir: b.dir,
                    onContextMenu: (J) => J.preventDefault(),
                    ...y,
                    ...ie,
                    onPlaced: () => P(!0),
                    ref: S,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...y.style
                    },
                    onKeyDown: Ce(y.onKeyDown, (J) => {
                      const se = J.ctrlKey || J.altKey || J.metaKey;
                      if (J.key === "Tab" && J.preventDefault(), !se && J.key.length === 1 && U(J.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(J.key)) {
                        let le = I().filter((de) => !de.disabled).map((de) => de.ref.current);
                        if (["ArrowUp", "End"].includes(J.key) && (le = le.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(J.key)) {
                          const de = J.target, j = le.indexOf(de);
                          le = le.slice(j + 1);
                        }
                        setTimeout(() => L(le)), J.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Ede.displayName = qyt;
var Xyt = "SelectItemAlignedPosition", Sde = A.forwardRef((n, e) => {
  const { __scopeSelect: t, onPlaced: r, ...i } = n, s = Fc(Qu, t), o = Bc(Qu, t), [a, l] = A.useState(null), [c, u] = A.useState(null), d = ht(e, (S) => u(S)), f = _x(t), h = A.useRef(!1), m = A.useRef(!0), { viewport: g, selectedItem: v, selectedItemText: y, focusSelectedItem: b } = o, x = A.useCallback(() => {
    if (s.trigger && s.valueNode && a && c && g && v && y) {
      const S = s.trigger.getBoundingClientRect(), M = c.getBoundingClientRect(), k = s.valueNode.getBoundingClientRect(), _ = y.getBoundingClientRect();
      if (s.dir !== "rtl") {
        const de = _.left - M.left, j = k.left - de, xe = S.left - j, ne = S.width + xe, qe = Math.max(ne, M.width), ve = window.innerWidth - ro, Ie = h0(j, [
          ro,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(ro, ve - qe)
        ]);
        a.style.minWidth = ne + "px", a.style.left = Ie + "px";
      } else {
        const de = M.right - _.right, j = window.innerWidth - k.right - de, xe = window.innerWidth - S.right - j, ne = S.width + xe, qe = Math.max(ne, M.width), ve = window.innerWidth - ro, Ie = h0(j, [
          ro,
          Math.max(ro, ve - qe)
        ]);
        a.style.minWidth = ne + "px", a.style.right = Ie + "px";
      }
      const O = f(), I = window.innerHeight - ro * 2, R = g.scrollHeight, P = window.getComputedStyle(c), D = parseInt(P.borderTopWidth, 10), L = parseInt(P.paddingTop, 10), B = parseInt(P.borderBottomWidth, 10), $ = parseInt(P.paddingBottom, 10), z = D + L + R + $ + B, H = Math.min(v.offsetHeight * 5, z), U = window.getComputedStyle(g), F = parseInt(U.paddingTop, 10), V = parseInt(U.paddingBottom, 10), X = S.top + S.height / 2 - ro, Z = I - X, ie = v.offsetHeight / 2, J = v.offsetTop + ie, se = D + L + J, te = z - se;
      if (se <= X) {
        const de = O.length > 0 && v === O[O.length - 1].ref.current;
        a.style.bottom = "0px";
        const j = c.clientHeight - g.offsetTop - g.offsetHeight, xe = Math.max(
          Z,
          ie + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (de ? V : 0) + j + B
        ), ne = se + xe;
        a.style.height = ne + "px";
      } else {
        const de = O.length > 0 && v === O[0].ref.current;
        a.style.top = "0px";
        const xe = Math.max(
          X,
          D + g.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (de ? F : 0) + ie
        ) + te;
        a.style.height = xe + "px", g.scrollTop = se - X + g.offsetTop;
      }
      a.style.margin = `${ro}px 0`, a.style.minHeight = H + "px", a.style.maxHeight = I + "px", r?.(), requestAnimationFrame(() => h.current = !0);
    }
  }, [
    f,
    s.trigger,
    s.valueNode,
    a,
    c,
    g,
    v,
    y,
    s.dir,
    r
  ]);
  Rr(() => x(), [x]);
  const [E, w] = A.useState();
  Rr(() => {
    c && w(window.getComputedStyle(c).zIndex);
  }, [c]);
  const C = A.useCallback(
    (S) => {
      S && m.current === !0 && (x(), b?.(), m.current = !1);
    },
    [x, b]
  );
  return /* @__PURE__ */ T(
    Qyt,
    {
      scope: t,
      contentWrapper: a,
      shouldExpandOnScrollRef: h,
      onScrollButtonChange: C,
      children: /* @__PURE__ */ T(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: E
          },
          children: /* @__PURE__ */ T(
            Ve.div,
            {
              ...i,
              ref: d,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...i.style
              }
            }
          )
        }
      )
    }
  );
});
Sde.displayName = Xyt;
var Zyt = "SelectPopperPosition", xA = A.forwardRef((n, e) => {
  const {
    __scopeSelect: t,
    align: r = "start",
    collisionPadding: i = ro,
    ...s
  } = n, o = Ox(t);
  return /* @__PURE__ */ T(
    T3,
    {
      ...o,
      ...s,
      ref: e,
      align: r,
      collisionPadding: i,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...s.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
xA.displayName = Zyt;
var [Qyt, bI] = Kh(Qu, {}), EA = "SelectViewport", Cde = A.forwardRef(
  (n, e) => {
    const { __scopeSelect: t, nonce: r, ...i } = n, s = Bc(EA, t), o = bI(EA, t), a = ht(e, s.onViewportChange), l = A.useRef(0);
    return /* @__PURE__ */ ee(ft, { children: [
      /* @__PURE__ */ T(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ T(kx.Slot, { scope: t, children: /* @__PURE__ */ T(
        Ve.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...i,
          ref: a,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...i.style
          },
          onScroll: Ce(i.onScroll, (c) => {
            const u = c.currentTarget, { contentWrapper: d, shouldExpandOnScrollRef: f } = o;
            if (f?.current && d) {
              const h = Math.abs(l.current - u.scrollTop);
              if (h > 0) {
                const m = window.innerHeight - ro * 2, g = parseFloat(d.style.minHeight), v = parseFloat(d.style.height), y = Math.max(g, v);
                if (y < m) {
                  const b = y + h, x = Math.min(m, b), E = b - x;
                  d.style.height = x + "px", d.style.bottom === "0px" && (u.scrollTop = E > 0 ? E : 0, d.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
Cde.displayName = EA;
var Tde = "SelectGroup", [Jyt, ebt] = Kh(Tde), tbt = A.forwardRef(
  (n, e) => {
    const { __scopeSelect: t, ...r } = n, i = Xn();
    return /* @__PURE__ */ T(Jyt, { scope: t, id: i, children: /* @__PURE__ */ T(Ve.div, { role: "group", "aria-labelledby": i, ...r, ref: e }) });
  }
);
tbt.displayName = Tde;
var Ade = "SelectLabel", Mde = A.forwardRef(
  (n, e) => {
    const { __scopeSelect: t, ...r } = n, i = ebt(Ade, t);
    return /* @__PURE__ */ T(Ve.div, { id: i.id, ...r, ref: e });
  }
);
Mde.displayName = Ade;
var pw = "SelectItem", [nbt, kde] = Kh(pw), _de = A.forwardRef(
  (n, e) => {
    const {
      __scopeSelect: t,
      value: r,
      disabled: i = !1,
      textValue: s,
      ...o
    } = n, a = Fc(pw, t), l = Bc(pw, t), c = a.value === r, [u, d] = A.useState(s ?? ""), [f, h] = A.useState(!1), m = ht(
      e,
      (b) => l.itemRefCallback?.(b, r, i)
    ), g = Xn(), v = A.useRef("touch"), y = () => {
      i || (a.onValueChange(r), a.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ T(
      nbt,
      {
        scope: t,
        value: r,
        disabled: i,
        textId: g,
        isSelected: c,
        onItemTextChange: A.useCallback((b) => {
          d((x) => x || (b?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ T(
          kx.ItemSlot,
          {
            scope: t,
            value: r,
            disabled: i,
            textValue: u,
            children: /* @__PURE__ */ T(
              Ve.div,
              {
                role: "option",
                "aria-labelledby": g,
                "data-highlighted": f ? "" : void 0,
                "aria-selected": c && f,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": i || void 0,
                "data-disabled": i ? "" : void 0,
                tabIndex: i ? void 0 : -1,
                ...o,
                ref: m,
                onFocus: Ce(o.onFocus, () => h(!0)),
                onBlur: Ce(o.onBlur, () => h(!1)),
                onClick: Ce(o.onClick, () => {
                  v.current !== "mouse" && y();
                }),
                onPointerUp: Ce(o.onPointerUp, () => {
                  v.current === "mouse" && y();
                }),
                onPointerDown: Ce(o.onPointerDown, (b) => {
                  v.current = b.pointerType;
                }),
                onPointerMove: Ce(o.onPointerMove, (b) => {
                  v.current = b.pointerType, i ? l.onItemLeave?.() : v.current === "mouse" && b.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: Ce(o.onPointerLeave, (b) => {
                  b.currentTarget === document.activeElement && l.onItemLeave?.();
                }),
                onKeyDown: Ce(o.onKeyDown, (b) => {
                  l.searchRef?.current !== "" && b.key === " " || (Hyt.includes(b.key) && y(), b.key === " " && b.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
_de.displayName = pw;
var Hp = "SelectItemText", Ode = A.forwardRef(
  (n, e) => {
    const { __scopeSelect: t, className: r, style: i, ...s } = n, o = Fc(Hp, t), a = Bc(Hp, t), l = kde(Hp, t), c = Wyt(Hp, t), [u, d] = A.useState(null), f = ht(
      e,
      (y) => d(y),
      l.onItemTextChange,
      (y) => a.itemTextRefCallback?.(y, l.value, l.disabled)
    ), h = u?.textContent, m = A.useMemo(
      () => /* @__PURE__ */ T("option", { value: l.value, disabled: l.disabled, children: h }, l.value),
      [l.disabled, l.value, h]
    ), { onNativeOptionAdd: g, onNativeOptionRemove: v } = c;
    return Rr(() => (g(m), () => v(m)), [g, v, m]), /* @__PURE__ */ ee(ft, { children: [
      /* @__PURE__ */ T(Ve.span, { id: l.textId, ...s, ref: f }),
      l.isSelected && o.valueNode && !o.valueNodeHasChildren ? mw.createPortal(s.children, o.valueNode) : null
    ] });
  }
);
Ode.displayName = Hp;
var Ide = "SelectItemIndicator", Rde = A.forwardRef(
  (n, e) => {
    const { __scopeSelect: t, ...r } = n;
    return kde(Ide, t).isSelected ? /* @__PURE__ */ T(Ve.span, { "aria-hidden": !0, ...r, ref: e }) : null;
  }
);
Rde.displayName = Ide;
var SA = "SelectScrollUpButton", Pde = A.forwardRef((n, e) => {
  const t = Bc(SA, n.__scopeSelect), r = bI(SA, n.__scopeSelect), [i, s] = A.useState(!1), o = ht(e, r.onScrollButtonChange);
  return Rr(() => {
    if (t.viewport && t.isPositioned) {
      let a = function() {
        const c = l.scrollTop > 0;
        s(c);
      };
      const l = t.viewport;
      return a(), l.addEventListener("scroll", a), () => l.removeEventListener("scroll", a);
    }
  }, [t.viewport, t.isPositioned]), i ? /* @__PURE__ */ T(
    Nde,
    {
      ...n,
      ref: o,
      onAutoScroll: () => {
        const { viewport: a, selectedItem: l } = t;
        a && l && (a.scrollTop = a.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
Pde.displayName = SA;
var CA = "SelectScrollDownButton", Dde = A.forwardRef((n, e) => {
  const t = Bc(CA, n.__scopeSelect), r = bI(CA, n.__scopeSelect), [i, s] = A.useState(!1), o = ht(e, r.onScrollButtonChange);
  return Rr(() => {
    if (t.viewport && t.isPositioned) {
      let a = function() {
        const c = l.scrollHeight - l.clientHeight, u = Math.ceil(l.scrollTop) < c;
        s(u);
      };
      const l = t.viewport;
      return a(), l.addEventListener("scroll", a), () => l.removeEventListener("scroll", a);
    }
  }, [t.viewport, t.isPositioned]), i ? /* @__PURE__ */ T(
    Nde,
    {
      ...n,
      ref: o,
      onAutoScroll: () => {
        const { viewport: a, selectedItem: l } = t;
        a && l && (a.scrollTop = a.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
Dde.displayName = CA;
var Nde = A.forwardRef((n, e) => {
  const { __scopeSelect: t, onAutoScroll: r, ...i } = n, s = Bc("SelectScrollButton", t), o = A.useRef(null), a = _x(t), l = A.useCallback(() => {
    o.current !== null && (window.clearInterval(o.current), o.current = null);
  }, []);
  return A.useEffect(() => () => l(), [l]), Rr(() => {
    a().find((u) => u.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [a]), /* @__PURE__ */ T(
    Ve.div,
    {
      "aria-hidden": !0,
      ...i,
      ref: e,
      style: { flexShrink: 0, ...i.style },
      onPointerDown: Ce(i.onPointerDown, () => {
        o.current === null && (o.current = window.setInterval(r, 50));
      }),
      onPointerMove: Ce(i.onPointerMove, () => {
        s.onItemLeave?.(), o.current === null && (o.current = window.setInterval(r, 50));
      }),
      onPointerLeave: Ce(i.onPointerLeave, () => {
        l();
      })
    }
  );
}), rbt = "SelectSeparator", Lde = A.forwardRef(
  (n, e) => {
    const { __scopeSelect: t, ...r } = n;
    return /* @__PURE__ */ T(Ve.div, { "aria-hidden": !0, ...r, ref: e });
  }
);
Lde.displayName = rbt;
var TA = "SelectArrow", ibt = A.forwardRef(
  (n, e) => {
    const { __scopeSelect: t, ...r } = n, i = Ox(t), s = Fc(TA, t), o = Bc(TA, t);
    return s.open && o.position === "popper" ? /* @__PURE__ */ T(A3, { ...i, ...r, ref: e }) : null;
  }
);
ibt.displayName = TA;
var sbt = "SelectBubbleInput", $de = A.forwardRef(
  ({ __scopeSelect: n, value: e, ...t }, r) => {
    const i = A.useRef(null), s = ht(r, i), o = q3(e);
    return A.useEffect(() => {
      const a = i.current;
      if (!a) return;
      const l = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (o !== e && u) {
        const d = new Event("change", { bubbles: !0 });
        u.call(a, e), a.dispatchEvent(d);
      }
    }, [o, e]), /* @__PURE__ */ T(
      Ve.select,
      {
        ...t,
        style: { ...Uee, ...t.style },
        ref: s,
        defaultValue: e
      }
    );
  }
);
$de.displayName = sbt;
function Fde(n) {
  return n === "" || n === void 0;
}
function Bde(n) {
  const e = Vr(n), t = A.useRef(""), r = A.useRef(0), i = A.useCallback(
    (o) => {
      const a = t.current + o;
      e(a), (function l(c) {
        t.current = c, window.clearTimeout(r.current), c !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      })(a);
    },
    [e]
  ), s = A.useCallback(() => {
    t.current = "", window.clearTimeout(r.current);
  }, []);
  return A.useEffect(() => () => window.clearTimeout(r.current), []), [t, i, s];
}
function zde(n, e, t) {
  const i = e.length > 1 && Array.from(e).every((c) => c === e[0]) ? e[0] : e, s = t ? n.indexOf(t) : -1;
  let o = obt(n, Math.max(s, 0));
  i.length === 1 && (o = o.filter((c) => c !== t));
  const l = o.find(
    (c) => c.textValue.toLowerCase().startsWith(i.toLowerCase())
  );
  return l !== t ? l : void 0;
}
function obt(n, e) {
  return n.map((t, r) => n[(e + r) % n.length]);
}
var abt = hde, Hde = mde, lbt = vde, cbt = yde, ubt = bde, Ude = wde, dbt = Cde, Vde = Mde, jde = _de, fbt = Ode, hbt = Rde, Wde = Pde, Gde = Dde, Kde = Lde;
const gG = abt, vG = lbt, AA = A.forwardRef(({ className: n, children: e, ...t }, r) => /* @__PURE__ */ ee(
  Hde,
  {
    ref: r,
    className: Q(
      "tw:flex tw:h-10 tw:w-full tw:items-center tw:justify-between tw:rounded-md tw:border tw:border-input tw:bg-background tw:px-3 tw:py-2 tw:text-sm tw:ring-offset-background tw:data-placeholder:text-muted-foreground tw:focus:outline-hidden tw:focus:ring-2 tw:focus:ring-ring tw:focus:ring-offset-2 tw:disabled:cursor-not-allowed tw:disabled:opacity-50 tw:[&>span]:line-clamp-1",
      n
    ),
    ...t,
    children: [
      e,
      /* @__PURE__ */ T(cbt, { asChild: !0, children: /* @__PURE__ */ T(od, { className: "tw:h-4 tw:w-4 tw:opacity-50" }) })
    ]
  }
));
AA.displayName = Hde.displayName;
const qde = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  Wde,
  {
    ref: t,
    className: Q(
      "tw:flex tw:cursor-default tw:items-center tw:justify-center tw:py-1",
      n
    ),
    ...e,
    children: /* @__PURE__ */ T(aIe, { className: "tw:h-4 tw:w-4" })
  }
));
qde.displayName = Wde.displayName;
const Yde = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  Gde,
  {
    ref: t,
    className: Q(
      "tw:flex tw:cursor-default tw:items-center tw:justify-center tw:py-1",
      n
    ),
    ...e,
    children: /* @__PURE__ */ T(od, { className: "tw:h-4 tw:w-4" })
  }
));
Yde.displayName = Gde.displayName;
const MA = A.forwardRef(({ className: n, children: e, position: t = "popper", ...r }, i) => /* @__PURE__ */ T(ubt, { children: /* @__PURE__ */ ee(
  Ude,
  {
    ref: i,
    className: Q(
      "tw:relative tw:z-50 tw:max-h-96 tw:min-w-32 tw:overflow-hidden tw:rounded-md tw:border tw:bg-popover tw:text-popover-foreground tw:shadow-md tw:data-[state=open]:animate-in tw:data-[state=closed]:animate-out tw:data-[state=closed]:fade-out-0 tw:data-[state=open]:fade-in-0 tw:data-[state=closed]:zoom-out-95 tw:data-[state=open]:zoom-in-95 tw:data-[side=bottom]:slide-in-from-top-2 tw:data-[side=left]:slide-in-from-right-2 tw:data-[side=right]:slide-in-from-left-2 tw:data-[side=top]:slide-in-from-bottom-2",
      t === "popper" && "tw:data-[side=bottom]:translate-y-1 tw:data-[side=left]:-translate-x-1 tw:data-[side=right]:translate-x-1 tw:data-[side=top]:-translate-y-1",
      n
    ),
    position: t,
    ...r,
    children: [
      /* @__PURE__ */ T(qde, {}),
      /* @__PURE__ */ T(
        dbt,
        {
          className: Q(
            "tw:p-1",
            t === "popper" && "tw:h-(--radix-select-trigger-height) tw:w-full tw:min-w-(--radix-select-trigger-width)"
          ),
          children: e
        }
      ),
      /* @__PURE__ */ T(Yde, {})
    ]
  }
) }));
MA.displayName = Ude.displayName;
const pbt = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  Vde,
  {
    ref: t,
    className: Q("tw:py-1.5 tw:pl-8 tw:pr-2 tw:text-sm tw:font-semibold", n),
    ...e
  }
));
pbt.displayName = Vde.displayName;
const kA = A.forwardRef(({ className: n, children: e, ...t }, r) => /* @__PURE__ */ ee(
  jde,
  {
    ref: r,
    className: Q(
      "tw:relative tw:flex tw:w-full tw:cursor-default tw:select-none tw:items-center tw:rounded-sm tw:py-1.5 tw:pl-8 tw:pr-2 tw:text-sm tw:outline-hidden tw:focus:bg-accent tw:focus:text-accent-foreground tw:data-disabled:pointer-events-none tw:data-disabled:opacity-50",
      n
    ),
    ...t,
    children: [
      /* @__PURE__ */ T("span", { className: "tw:absolute tw:left-2 tw:flex tw:h-3.5 tw:w-3.5 tw:items-center tw:justify-center", children: /* @__PURE__ */ T(hbt, { children: /* @__PURE__ */ T(oc, { className: "tw:h-4 tw:w-4" }) }) }),
      /* @__PURE__ */ T(fbt, { children: e })
    ]
  }
));
kA.displayName = jde.displayName;
const mbt = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  Kde,
  {
    ref: t,
    className: Q("tw:-mx-1 tw:my-1 tw:h-px tw:bg-muted", n),
    ...e
  }
));
mbt.displayName = Kde.displayName;
function E3t(n) {
  const e = n.removeDuplicates ? [...new Set(n.options)] : n.options;
  return n.control ? /* @__PURE__ */ T(
    xs,
    {
      control: n.control,
      name: n.name,
      render: ({ field: t }) => /* @__PURE__ */ ee(Ci, { children: [
        /* @__PURE__ */ T(Ti, { children: n.label }),
        /* @__PURE__ */ ee(
          gG,
          {
            onValueChange: t.onChange,
            value: t.value,
            required: n.required,
            children: [
              /* @__PURE__ */ T(qi, { children: /* @__PURE__ */ T(AA, { children: /* @__PURE__ */ T(
                vG,
                {
                  placeholder: n.placeholder
                }
              ) }) }),
              /* @__PURE__ */ T(MA, { children: e.map((r, i) => {
                const s = n.renderValue(r), o = n.renderOption(r);
                return /* @__PURE__ */ T(oC, { children: s && o && /* @__PURE__ */ T(
                  kA,
                  {
                    value: s,
                    disabled: n.disabled,
                    children: o
                  },
                  i
                ) }, i);
              }) })
            ]
          }
        ),
        n.description && /* @__PURE__ */ T(Ai, { children: n.description }),
        /* @__PURE__ */ T(qs, {})
      ] })
    }
  ) : /* @__PURE__ */ ee("div", { className: "tw:flex tw:flex-row tw:items-center tw:justify-between tw:rounded-lg tw:space-x-2", children: [
    /* @__PURE__ */ T(bo, { htmlFor: n.name, className: n.className, children: n.label }),
    /* @__PURE__ */ ee(gG, { onValueChange: n.onChange, required: n.required, children: [
      /* @__PURE__ */ T(AA, { children: /* @__PURE__ */ T(vG, { placeholder: n.placeholder }) }),
      /* @__PURE__ */ T(MA, { children: e.map((t, r) => {
        const i = n.renderValue(t), s = n.renderOption(t);
        return /* @__PURE__ */ T(oC, { children: i && s && /* @__PURE__ */ T(
          kA,
          {
            value: i,
            disabled: n.disabled,
            children: s
          },
          r
        ) }, r);
      }) })
    ] })
  ] });
}
var Xde = ["PageUp", "PageDown"], Zde = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], Qde = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, qh = "Slider", [_A, gbt, vbt] = Lh(qh), [Jde] = qr(qh, [
  vbt
]), [ybt, Ix] = Jde(qh), efe = A.forwardRef(
  (n, e) => {
    const {
      name: t,
      min: r = 0,
      max: i = 100,
      step: s = 1,
      orientation: o = "horizontal",
      disabled: a = !1,
      minStepsBetweenThumbs: l = 0,
      defaultValue: c = [r],
      value: u,
      onValueChange: d = () => {
      },
      onValueCommit: f = () => {
      },
      inverted: h = !1,
      form: m,
      ...g
    } = n, v = A.useRef(/* @__PURE__ */ new Set()), y = A.useRef(0), x = o === "horizontal" ? bbt : wbt, [E = [], w] = Kr({
      prop: u,
      defaultProp: c,
      onChange: (O) => {
        [...v.current][y.current]?.focus(), d(O);
      }
    }), C = A.useRef(E);
    function S(O) {
      const I = Tbt(E, O);
      _(O, I);
    }
    function M(O) {
      _(O, y.current);
    }
    function k() {
      const O = C.current[y.current];
      E[y.current] !== O && f(E);
    }
    function _(O, I, { commit: R } = { commit: !1 }) {
      const P = _bt(s), D = Obt(Math.round((O - r) / s) * s + r, P), L = h0(D, [r, i]);
      w((B = []) => {
        const $ = Sbt(B, L, I);
        if (kbt($, l * s)) {
          y.current = $.indexOf(L);
          const z = String($) !== String(B);
          return z && R && f($), z ? $ : B;
        } else
          return B;
      });
    }
    return /* @__PURE__ */ T(
      ybt,
      {
        scope: n.__scopeSlider,
        name: t,
        disabled: a,
        min: r,
        max: i,
        valueIndexToChangeRef: y,
        thumbs: v.current,
        values: E,
        orientation: o,
        form: m,
        children: /* @__PURE__ */ T(_A.Provider, { scope: n.__scopeSlider, children: /* @__PURE__ */ T(_A.Slot, { scope: n.__scopeSlider, children: /* @__PURE__ */ T(
          x,
          {
            "aria-disabled": a,
            "data-disabled": a ? "" : void 0,
            ...g,
            ref: e,
            onPointerDown: Ce(g.onPointerDown, () => {
              a || (C.current = E);
            }),
            min: r,
            max: i,
            inverted: h,
            onSlideStart: a ? void 0 : S,
            onSlideMove: a ? void 0 : M,
            onSlideEnd: a ? void 0 : k,
            onHomeKeyDown: () => !a && _(r, 0, { commit: !0 }),
            onEndKeyDown: () => !a && _(i, E.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: O, direction: I }) => {
              if (!a) {
                const D = Xde.includes(O.key) || O.shiftKey && Zde.includes(O.key) ? 10 : 1, L = y.current, B = E[L], $ = s * D * I;
                _(B + $, L, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
efe.displayName = qh;
var [tfe, nfe] = Jde(qh, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), bbt = A.forwardRef(
  (n, e) => {
    const {
      min: t,
      max: r,
      dir: i,
      inverted: s,
      onSlideStart: o,
      onSlideMove: a,
      onSlideEnd: l,
      onStepKeyDown: c,
      ...u
    } = n, [d, f] = A.useState(null), h = ht(e, (x) => f(x)), m = A.useRef(void 0), g = Rc(i), v = g === "ltr", y = v && !s || !v && s;
    function b(x) {
      const E = m.current || d.getBoundingClientRect(), w = [0, E.width], S = wI(w, y ? [t, r] : [r, t]);
      return m.current = E, S(x - E.left);
    }
    return /* @__PURE__ */ T(
      tfe,
      {
        scope: n.__scopeSlider,
        startEdge: y ? "left" : "right",
        endEdge: y ? "right" : "left",
        direction: y ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ T(
          rfe,
          {
            dir: g,
            "data-orientation": "horizontal",
            ...u,
            ref: h,
            style: {
              ...u.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (x) => {
              const E = b(x.clientX);
              o?.(E);
            },
            onSlideMove: (x) => {
              const E = b(x.clientX);
              a?.(E);
            },
            onSlideEnd: () => {
              m.current = void 0, l?.();
            },
            onStepKeyDown: (x) => {
              const w = Qde[y ? "from-left" : "from-right"].includes(x.key);
              c?.({ event: x, direction: w ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), wbt = A.forwardRef(
  (n, e) => {
    const {
      min: t,
      max: r,
      inverted: i,
      onSlideStart: s,
      onSlideMove: o,
      onSlideEnd: a,
      onStepKeyDown: l,
      ...c
    } = n, u = A.useRef(null), d = ht(e, u), f = A.useRef(void 0), h = !i;
    function m(g) {
      const v = f.current || u.current.getBoundingClientRect(), y = [0, v.height], x = wI(y, h ? [r, t] : [t, r]);
      return f.current = v, x(g - v.top);
    }
    return /* @__PURE__ */ T(
      tfe,
      {
        scope: n.__scopeSlider,
        startEdge: h ? "bottom" : "top",
        endEdge: h ? "top" : "bottom",
        size: "height",
        direction: h ? 1 : -1,
        children: /* @__PURE__ */ T(
          rfe,
          {
            "data-orientation": "vertical",
            ...c,
            ref: d,
            style: {
              ...c.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (g) => {
              const v = m(g.clientY);
              s?.(v);
            },
            onSlideMove: (g) => {
              const v = m(g.clientY);
              o?.(v);
            },
            onSlideEnd: () => {
              f.current = void 0, a?.();
            },
            onStepKeyDown: (g) => {
              const y = Qde[h ? "from-bottom" : "from-top"].includes(g.key);
              l?.({ event: g, direction: y ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), rfe = A.forwardRef(
  (n, e) => {
    const {
      __scopeSlider: t,
      onSlideStart: r,
      onSlideMove: i,
      onSlideEnd: s,
      onHomeKeyDown: o,
      onEndKeyDown: a,
      onStepKeyDown: l,
      ...c
    } = n, u = Ix(qh, t);
    return /* @__PURE__ */ T(
      Ve.span,
      {
        ...c,
        ref: e,
        onKeyDown: Ce(n.onKeyDown, (d) => {
          d.key === "Home" ? (o(d), d.preventDefault()) : d.key === "End" ? (a(d), d.preventDefault()) : Xde.concat(Zde).includes(d.key) && (l(d), d.preventDefault());
        }),
        onPointerDown: Ce(n.onPointerDown, (d) => {
          const f = d.target;
          f.setPointerCapture(d.pointerId), d.preventDefault(), u.thumbs.has(f) ? f.focus() : r(d);
        }),
        onPointerMove: Ce(n.onPointerMove, (d) => {
          d.target.hasPointerCapture(d.pointerId) && i(d);
        }),
        onPointerUp: Ce(n.onPointerUp, (d) => {
          const f = d.target;
          f.hasPointerCapture(d.pointerId) && (f.releasePointerCapture(d.pointerId), s(d));
        })
      }
    );
  }
), ife = "SliderTrack", sfe = A.forwardRef(
  (n, e) => {
    const { __scopeSlider: t, ...r } = n, i = Ix(ife, t);
    return /* @__PURE__ */ T(
      Ve.span,
      {
        "data-disabled": i.disabled ? "" : void 0,
        "data-orientation": i.orientation,
        ...r,
        ref: e
      }
    );
  }
);
sfe.displayName = ife;
var OA = "SliderRange", ofe = A.forwardRef(
  (n, e) => {
    const { __scopeSlider: t, ...r } = n, i = Ix(OA, t), s = nfe(OA, t), o = A.useRef(null), a = ht(e, o), l = i.values.length, c = i.values.map(
      (f) => cfe(f, i.min, i.max)
    ), u = l > 1 ? Math.min(...c) : 0, d = 100 - Math.max(...c);
    return /* @__PURE__ */ T(
      Ve.span,
      {
        "data-orientation": i.orientation,
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: a,
        style: {
          ...n.style,
          [s.startEdge]: u + "%",
          [s.endEdge]: d + "%"
        }
      }
    );
  }
);
ofe.displayName = OA;
var IA = "SliderThumb", afe = A.forwardRef(
  (n, e) => {
    const t = gbt(n.__scopeSlider), [r, i] = A.useState(null), s = ht(e, (a) => i(a)), o = A.useMemo(
      () => r ? t().findIndex((a) => a.ref.current === r) : -1,
      [t, r]
    );
    return /* @__PURE__ */ T(xbt, { ...n, ref: s, index: o });
  }
), xbt = A.forwardRef(
  (n, e) => {
    const { __scopeSlider: t, index: r, name: i, ...s } = n, o = Ix(IA, t), a = nfe(IA, t), [l, c] = A.useState(null), u = ht(e, (b) => c(b)), d = l ? o.form || !!l.closest("form") : !0, f = S3(l), h = o.values[r], m = h === void 0 ? 0 : cfe(h, o.min, o.max), g = Cbt(r, o.values.length), v = f?.[a.size], y = v ? Abt(v, m, a.direction) : 0;
    return A.useEffect(() => {
      if (l)
        return o.thumbs.add(l), () => {
          o.thumbs.delete(l);
        };
    }, [l, o.thumbs]), /* @__PURE__ */ ee(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [a.startEdge]: `calc(${m}% + ${y}px)`
        },
        children: [
          /* @__PURE__ */ T(_A.ItemSlot, { scope: n.__scopeSlider, children: /* @__PURE__ */ T(
            Ve.span,
            {
              role: "slider",
              "aria-label": n["aria-label"] || g,
              "aria-valuemin": o.min,
              "aria-valuenow": h,
              "aria-valuemax": o.max,
              "aria-orientation": o.orientation,
              "data-orientation": o.orientation,
              "data-disabled": o.disabled ? "" : void 0,
              tabIndex: o.disabled ? void 0 : 0,
              ...s,
              ref: u,
              style: h === void 0 ? { display: "none" } : n.style,
              onFocus: Ce(n.onFocus, () => {
                o.valueIndexToChangeRef.current = r;
              })
            }
          ) }),
          d && /* @__PURE__ */ T(
            lfe,
            {
              name: i ?? (o.name ? o.name + (o.values.length > 1 ? "[]" : "") : void 0),
              form: o.form,
              value: h
            },
            r
          )
        ]
      }
    );
  }
);
afe.displayName = IA;
var Ebt = "RadioBubbleInput", lfe = A.forwardRef(
  ({ __scopeSlider: n, value: e, ...t }, r) => {
    const i = A.useRef(null), s = ht(i, r), o = q3(e);
    return A.useEffect(() => {
      const a = i.current;
      if (!a) return;
      const l = window.HTMLInputElement.prototype, u = Object.getOwnPropertyDescriptor(l, "value").set;
      if (o !== e && u) {
        const d = new Event("input", { bubbles: !0 });
        u.call(a, e), a.dispatchEvent(d);
      }
    }, [o, e]), /* @__PURE__ */ T(
      Ve.input,
      {
        style: { display: "none" },
        ...t,
        ref: s,
        defaultValue: e
      }
    );
  }
);
lfe.displayName = Ebt;
function Sbt(n = [], e, t) {
  const r = [...n];
  return r[t] = e, r.sort((i, s) => i - s);
}
function cfe(n, e, t) {
  const s = 100 / (t - e) * (n - e);
  return h0(s, [0, 100]);
}
function Cbt(n, e) {
  return e > 2 ? `Value ${n + 1} of ${e}` : e === 2 ? ["Minimum", "Maximum"][n] : void 0;
}
function Tbt(n, e) {
  if (n.length === 1) return 0;
  const t = n.map((i) => Math.abs(i - e)), r = Math.min(...t);
  return t.indexOf(r);
}
function Abt(n, e, t) {
  const r = n / 2, s = wI([0, 50], [0, r]);
  return (r - s(e) * t) * t;
}
function Mbt(n) {
  return n.slice(0, -1).map((e, t) => n[t + 1] - e);
}
function kbt(n, e) {
  if (e > 0) {
    const t = Mbt(n);
    return Math.min(...t) >= e;
  }
  return !0;
}
function wI(n, e) {
  return (t) => {
    if (n[0] === n[1] || e[0] === e[1]) return e[0];
    const r = (e[1] - e[0]) / (n[1] - n[0]);
    return e[0] + r * (t - n[0]);
  };
}
function _bt(n) {
  return (String(n).split(".")[1] || "").length;
}
function Obt(n, e) {
  const t = Math.pow(10, e);
  return Math.round(n * t) / t;
}
var ufe = efe, Ibt = sfe, Rbt = ofe, Pbt = afe;
const dfe = A.forwardRef(({ className: n, ...e }, t) => {
  const r = e.value || e.defaultValue || [0];
  return /* @__PURE__ */ ee(
    ufe,
    {
      ref: t,
      className: Q(
        "tw:relative tw:flex tw:w-full tw:touch-none tw:select-none tw:items-center",
        n
      ),
      ...e,
      children: [
        /* @__PURE__ */ T(Ibt, { className: "tw:relative tw:h-2 tw:w-full tw:grow tw:overflow-hidden tw:rounded-full tw:bg-secondary", children: /* @__PURE__ */ T(Rbt, { className: "tw:absolute tw:h-full tw:bg-primary" }) }),
        r.map((i, s) => /* @__PURE__ */ T(
          Pbt,
          {
            className: "tw:block tw:h-5 tw:w-5 tw:rounded-full tw:border-2 tw:border-primary tw:bg-background tw:ring-offset-background tw:transition-colors tw:focus-visible:outline-none tw:focus-visible:ring-2 tw:focus-visible:ring-ring tw:focus-visible:ring-offset-2 tw:disabled:pointer-events-none tw:disabled:opacity-50"
          },
          s
        ))
      ]
    }
  );
});
dfe.displayName = ufe.displayName;
function S3t({
  label: n,
  name: e,
  min: t,
  max: r,
  step: i,
  scale: s = 1,
  // Defaults to 1 (no scaling)
  description: o,
  units: a,
  onChange: l,
  range: c = !1
}) {
  const { control: u, setValue: d } = Ju(), { field: f } = wh({ name: e, control: u });
  Tt(() => {
    c ? (f.value == null || !Array.isArray(f.value) || f.value.length < 2) && d(e, [t * s, r * s]) : (f.value == null || typeof f.value == "number" && isNaN(f.value) || Array.isArray(f.value)) && d(e, t * s);
  }, [f.value, t, r, e, s, d, c]);
  const h = (v) => {
    if (Array.isArray(v)) {
      const y = v.map((b) => b * s);
      d(e, y), l && l(y);
    } else {
      const y = v * s;
      y >= t * s && y <= r * s && (d(e, y), l && l(y));
    }
  }, m = Array.isArray(f.value) ? f.value.map((v) => v / s) : [
    f.value != null && !isNaN(f.value) ? f.value / s : t
  ], g = c ? m.length >= 2 ? m : [t, r] : m;
  return /* @__PURE__ */ T(
    xs,
    {
      control: u,
      name: e,
      render: () => /* @__PURE__ */ ee(Ci, { className: "tw:space-y-2", children: [
        /* @__PURE__ */ T(Ti, { children: n }),
        /* @__PURE__ */ T(qi, { children: c ? /* @__PURE__ */ ee("div", { className: "tw:flex tw:items-center tw:space-x-2", children: [
          /* @__PURE__ */ T(
            Ui,
            {
              type: "number",
              value: g[0].toFixed(2),
              onChange: (v) => h([
                Number(v.target.value),
                g[1]
              ]),
              className: "tw:grow tw:text-center"
            }
          ),
          /* @__PURE__ */ T("span", { children: "to" }),
          /* @__PURE__ */ T(
            Ui,
            {
              type: "number",
              value: g[1].toFixed(2),
              onChange: (v) => h([
                g[0],
                Number(v.target.value)
              ]),
              className: "tw:grow tw:text-center"
            }
          ),
          a && /* @__PURE__ */ T(
            Nt,
            {
              type: "button",
              variant: "outline",
              size: "icon",
              className: "tw:p-2 tw:grow",
              disabled: !0,
              children: a
            }
          )
        ] }) : /* @__PURE__ */ ee("div", { className: "tw:flex tw:items-center tw:space-x-2", children: [
          /* @__PURE__ */ T(
            Nt,
            {
              type: "button",
              variant: "outline",
              size: "icon",
              onClick: () => h(f.value / s - i),
              children: "-"
            }
          ),
          /* @__PURE__ */ ee("div", { className: "tw:flex tw:items-center tw:space-x-1", children: [
            /* @__PURE__ */ T(
              Ui,
              {
                type: "number",
                value: (f.value / s).toFixed(2),
                onChange: (v) => h(Number(v.target.value)),
                className: "tw:grow tw:text-center"
              }
            ),
            a && /* @__PURE__ */ T(
              Nt,
              {
                type: "button",
                variant: "outline",
                size: "icon",
                disabled: !0,
                children: a
              }
            )
          ] }),
          /* @__PURE__ */ T(
            Nt,
            {
              type: "button",
              variant: "outline",
              size: "icon",
              onClick: () => h(f.value / s + i),
              children: "+"
            }
          )
        ] }) }),
        /* @__PURE__ */ T(
          dfe,
          {
            value: g.map((v) => isNaN(v) ? t : v),
            min: t,
            max: r,
            step: i,
            onValueChange: (v) => h(c ? v : v[0])
          }
        ),
        o && /* @__PURE__ */ T(Ai, { children: o })
      ] })
    }
  );
}
function C3t({
  label: n,
  name: e,
  value: t,
  description: r,
  disabled: i,
  onChange: s
}) {
  const { control: o, setValue: a, getValues: l } = Ju(), { field: c } = wh({ name: e, control: o });
  Tt(() => {
    Array.isArray(c.value) || a(e, []);
  }, [c.value, e, a]);
  const u = (d) => {
    const f = l(e) || [];
    d ? a(e, [...f, t]) : a(
      e,
      f.filter((h) => h !== t)
    ), s && s([...f, t]);
  };
  return /* @__PURE__ */ T(
    xs,
    {
      control: o,
      name: e,
      render: ({ field: d }) => /* @__PURE__ */ ee(Ci, { className: "tw:flex tw:flex-row tw:items-center tw:justify-between tw:rounded-lg", children: [
        /* @__PURE__ */ T(Ti, { children: n }),
        r && /* @__PURE__ */ T(Ai, { children: r }),
        /* @__PURE__ */ T(qi, { children: /* @__PURE__ */ T(
          M0,
          {
            checked: d.value?.includes(t),
            onCheckedChange: u,
            disabled: i
          }
        ) })
      ] })
    }
  );
}
const RA = A.forwardRef(({ className: n, ...e }, t) => /* @__PURE__ */ T(
  "textarea",
  {
    className: Q(
      "tw:flex tw:min-h-[80px] tw:w-full tw:rounded-md tw:border tw:border-input tw:bg-background tw:px-3 tw:py-2 tw:text-base tw:ring-offset-background tw:placeholder:text-muted-foreground tw:focus-visible:outline-hidden tw:focus-visible:ring-2 tw:focus-visible:ring-ring tw:focus-visible:ring-offset-2 tw:disabled:cursor-not-allowed tw:disabled:opacity-50 tw:md:text-sm",
      n
    ),
    ref: t,
    ...e
  }
));
RA.displayName = "Textarea";
function T3t(n) {
  let e = n.label;
  return n.copyToClipboard && n.defaultValue ? e = /* @__PURE__ */ ee(ft, { children: [
    /* @__PURE__ */ T("span", { children: n.label }),
    /* @__PURE__ */ T(g1, { value: n.defaultValue })
  ] }) : e = n.label, n.control ? /* @__PURE__ */ T(
    xs,
    {
      control: n.control,
      name: n.name,
      render: ({ field: t }) => {
        const r = t.onChange;
        return t.onChange = (i) => {
          n.onChange && n.onChange(i.target.value), r(i);
        }, /* @__PURE__ */ ee(Ci, { children: [
          /* @__PURE__ */ T(Ti, { children: n.label }),
          /* @__PURE__ */ T(qi, { children: /* @__PURE__ */ T(
            RA,
            {
              placeholder: n.placeholder,
              defaultValue: n.defaultValue,
              required: n.required,
              autoComplete: n.autocomplete,
              maxLength: n.maxLength,
              disabled: n.disabled,
              ...t
            }
          ) }),
          n.description && /* @__PURE__ */ T(Ai, { children: n.description }),
          /* @__PURE__ */ T(qs, {})
        ] });
      }
    }
  ) : /* @__PURE__ */ ee(ft, { children: [
    /* @__PURE__ */ T(bo, { htmlFor: n.name, children: e }),
    /* @__PURE__ */ T(
      RA,
      {
        name: n.name,
        placeholder: n.placeholder,
        defaultValue: n.defaultValue,
        required: n.required,
        autoComplete: n.autocomplete,
        maxLength: n.maxLength,
        disabled: n.disabled
      }
    )
  ] });
}
function A3t(n) {
  let e = n.label;
  return n.copyToClipboard && n.defaultValue ? e = /* @__PURE__ */ ee(ft, { children: [
    /* @__PURE__ */ T("span", { children: n.label }),
    /* @__PURE__ */ T(g1, { value: n.defaultValue })
  ] }) : e = n.label, n.control ? /* @__PURE__ */ T(
    xs,
    {
      control: n.control,
      name: n.name,
      render: ({ field: t }) => {
        const r = t.onChange;
        return t.onChange = (i) => {
          n.onChange && n.onChange(i.target.value), r(i);
        }, /* @__PURE__ */ ee(Ci, { children: [
          /* @__PURE__ */ T(Ti, { children: e }),
          !n.hideInput && /* @__PURE__ */ T(qi, { className: "tw:grow", children: /* @__PURE__ */ T(
            Ui,
            {
              placeholder: n.placeholder,
              type: n.type,
              defaultValue: n.defaultValue,
              required: n.required,
              autoComplete: n.autocomplete,
              maxLength: n.maxLength,
              pattern: n.pattern,
              disabled: n.disabled,
              ...t
            }
          ) }),
          n.description && /* @__PURE__ */ T(Ai, { children: n.description }),
          /* @__PURE__ */ T(qs, {})
        ] });
      }
    }
  ) : /* @__PURE__ */ ee(ft, { children: [
    /* @__PURE__ */ T(bo, { htmlFor: n.name, children: e }),
    !n.hideInput && /* @__PURE__ */ T(
      Ui,
      {
        name: n.name,
        placeholder: n.placeholder,
        type: n.type,
        defaultValue: n.defaultValue,
        required: n.required,
        autoComplete: n.autocomplete,
        maxLength: n.maxLength,
        pattern: n.pattern,
        disabled: n.disabled,
        className: "tw:grow"
      }
    )
  ] });
}
const ffe = 132, yG = 0.6;
function Dbt({
  open: n,
  onClose: e,
  peek: t = ffe,
  title: r,
  summary: i,
  children: s,
  className: o
}) {
  const a = `${t}px`, [l, c] = wt(a);
  return Tt(() => {
    n && c(a);
  }, [n, a]), /* @__PURE__ */ T(
    mi.Root,
    {
      open: n,
      onOpenChange: (u) => !u && e(),
      modal: !1,
      noBodyStyles: !0,
      snapPoints: [a, yG],
      activeSnapPoint: l,
      setActiveSnapPoint: c,
      children: /* @__PURE__ */ T(mi.Portal, { children: /* @__PURE__ */ ee(
        mi.Content,
        {
          className: Q(
            "tw:fixed tw:inset-x-0 tw:bottom-0 tw:z-40 tw:flex tw:h-full tw:max-h-[97%] tw:flex-col tw:rounded-t-xl tw:border tw:bg-background tw:shadow-lg tw:outline-none",
            o
          ),
          "aria-describedby": void 0,
          children: [
            /* @__PURE__ */ T("div", { className: "tw:mx-auto tw:mt-2 tw:h-1.5 tw:w-12 tw:shrink-0 tw:rounded-full tw:bg-muted" }),
            /* @__PURE__ */ ee("div", { className: "tw:flex tw:items-baseline tw:justify-between tw:gap-3 tw:px-4 tw:pt-3 tw:pb-2", children: [
              /* @__PURE__ */ T(mi.Title, { className: "tw:text-base tw:font-semibold", children: r }),
              i && /* @__PURE__ */ T("span", { className: "tw:text-base tw:font-medium tw:tabular-nums", children: i })
            ] }),
            /* @__PURE__ */ T(
              "div",
              {
                className: Q(
                  "tw:flex tw:flex-col tw:gap-3 tw:px-4 tw:pb-[calc(1rem+env(safe-area-inset-bottom))]",
                  l === yG ? "tw:overflow-y-auto" : "tw:overflow-hidden"
                ),
                children: s
              }
            )
          ]
        }
      ) })
    }
  );
}
const gu = 16, bG = 72;
function wG({ children: n }) {
  return /* @__PURE__ */ ee("span", { className: "tw:inline-flex tw:items-center tw:gap-1 tw:text-muted-foreground", children: [
    /* @__PURE__ */ T($Ie, { className: "tw:size-3.5", "aria-hidden": !0 }),
    n
  ] });
}
function hfe({ selection: n }) {
  return /* @__PURE__ */ ee(ft, { children: [
    /* @__PURE__ */ T("dl", { className: "tw:grid tw:grid-cols-[auto_1fr] tw:items-center tw:gap-x-4 tw:gap-y-1.5 tw:text-sm", children: n.rows.map((e, t) => /* @__PURE__ */ ee("div", { className: "tw:contents", children: [
      /* @__PURE__ */ T("dt", { className: "tw:text-muted-foreground", children: e.label }),
      /* @__PURE__ */ T("dd", { className: "tw:flex tw:min-w-0 tw:items-center tw:justify-end tw:gap-1 tw:text-right tw:tabular-nums", children: e.locked ? /* @__PURE__ */ T(wG, { children: e.locked }) : /* @__PURE__ */ ee(ft, { children: [
        /* @__PURE__ */ T("span", { className: "tw:truncate", children: e.value }),
        e.value && /* @__PURE__ */ T(g1, { value: e.value })
      ] }) })
    ] }, `${e.key}-${t}`)) }),
    n.copies.length > 0 && /* @__PURE__ */ T("div", { className: "tw:flex tw:flex-wrap tw:gap-2", children: n.copies.map(
      (e) => e.locked ? /* @__PURE__ */ ee(
        Nt,
        {
          variant: "outline",
          size: "sm",
          disabled: !0,
          children: [
            e.label,
            " ",
            /* @__PURE__ */ T(wG, { children: e.locked })
          ]
        },
        e.label
      ) : /* @__PURE__ */ ee(
        Nt,
        {
          variant: "outline",
          size: "sm",
          onClick: () => e.text && dX(e.text),
          children: [
            "Copy ",
            e.label
          ]
        },
        e.label
      )
    ) }),
    n.actions.length > 0 && /* @__PURE__ */ T("div", { className: "tw:flex tw:flex-col tw:gap-2", children: n.actions.map((e) => /* @__PURE__ */ ee(
      Nt,
      {
        variant: e.destructive ? "destructive" : "default",
        disabled: e.disabledReason !== void 0,
        onClick: e.run,
        children: [
          e.label,
          e.disabledReason && /* @__PURE__ */ ee("span", { className: "tw:font-normal tw:opacity-80", children: [
            "(",
            e.disabledReason,
            ")"
          ] })
        ]
      },
      e.id
    )) })
  ] });
}
function Nbt({
  draw: n,
  selection: e,
  className: t
}) {
  const r = Dfe(n.anchor.subscribe, n.anchor.get), i = n.container;
  if (!i || !r) return null;
  const s = r.side === "left", o = r.y > i.clientHeight / 2;
  return vw(
    /* @__PURE__ */ ee(
      "div",
      {
        role: "dialog",
        "aria-label": e.title,
        className: Q(
          "tw:absolute tw:z-20 tw:flex tw:w-72 tw:flex-col tw:gap-3 tw:rounded-lg tw:border tw:bg-background tw:p-3 tw:text-foreground tw:shadow-lg",
          t
        ),
        style: {
          left: r.x,
          top: r.y,
          transform: `translate(${s ? `calc(-100% - ${gu}px)` : `${gu}px`}, ${o ? `calc(-100% + ${gu}px)` : `-${gu}px`})`
        },
        children: [
          /* @__PURE__ */ ee("div", { className: "tw:flex tw:items-baseline tw:justify-between tw:gap-2", children: [
            /* @__PURE__ */ T("h3", { className: "tw:text-sm tw:font-semibold", children: e.title }),
            /* @__PURE__ */ T("span", { className: "tw:ms-auto tw:text-sm tw:font-medium tw:tabular-nums", children: e.headline }),
            /* @__PURE__ */ T(
              Nt,
              {
                variant: "ghost",
                size: "none",
                "aria-label": "Close",
                onClick: n.deselect,
                children: /* @__PURE__ */ T(YM, { className: "tw:size-4" })
              }
            )
          ] }),
          /* @__PURE__ */ T(hfe, { selection: e })
        ]
      }
    ),
    i
  );
}
function Lbt({
  draw: n,
  drawing: e,
  className: t
}) {
  const r = n.container;
  if (!r) return null;
  const i = e.mode === "linestring" || e.mode === "polygon";
  return vw(
    /* @__PURE__ */ ee(
      "div",
      {
        role: "toolbar",
        "aria-label": "Drawing",
        className: Q(
          "tw:absolute tw:inset-x-3 tw:bottom-[calc(2.75rem+env(safe-area-inset-bottom))] tw:z-20 tw:mx-auto tw:flex tw:max-w-md tw:flex-col tw:gap-2 tw:rounded-lg tw:border tw:bg-background/90 tw:p-2 tw:text-foreground tw:shadow-lg tw:backdrop-blur-sm",
          t
        ),
        children: [
          /* @__PURE__ */ ee("div", { className: "tw:flex tw:items-baseline tw:justify-between tw:gap-3 tw:px-1 tw:text-sm", children: [
            /* @__PURE__ */ T("span", { className: "tw:text-muted-foreground", children: e.hint }),
            e.headline && /* @__PURE__ */ T("span", { className: "tw:shrink-0 tw:font-semibold tw:tabular-nums", children: e.headline })
          ] }),
          /* @__PURE__ */ ee("div", { className: "tw:flex tw:gap-2", children: [
            i && /* @__PURE__ */ ee(
              Nt,
              {
                variant: "outline",
                className: "tw:flex-1",
                disabled: !e.canUndo,
                onClick: n.undo,
                children: [
                  /* @__PURE__ */ T(fRe, { "aria-hidden": !0 }),
                  " Undo"
                ]
              }
            ),
            /* @__PURE__ */ T(
              Nt,
              {
                variant: "outline",
                className: "tw:flex-1",
                onClick: n.cancel,
                children: "Cancel"
              }
            ),
            i && /* @__PURE__ */ T(
              Nt,
              {
                className: "tw:flex-1",
                disabled: !e.canFinish,
                onClick: n.finish,
                children: "Finish"
              }
            )
          ] })
        ]
      }
    ),
    r
  );
}
function M3t({
  draw: n,
  peek: e = ffe,
  className: t
}) {
  const r = yw(), { selection: i, drawing: s } = n, o = i?.id, { reveal: a } = n;
  return Tt(() => {
    o && a(
      r ? {
        top: bG,
        bottom: e + gu,
        left: gu,
        right: gu
      } : { top: bG }
    );
  }, [o, r, e]), /* @__PURE__ */ ee(ft, { children: [
    s && /* @__PURE__ */ T(
      Lbt,
      {
        draw: n,
        drawing: s,
        className: t
      }
    ),
    i && (r ? /* @__PURE__ */ T(
      Dbt,
      {
        open: !0,
        onClose: n.deselect,
        peek: e,
        title: i.title,
        summary: i.headline,
        className: t,
        children: /* @__PURE__ */ T(hfe, { selection: i })
      }
    ) : /* @__PURE__ */ T(
      Nbt,
      {
        draw: n,
        selection: i,
        className: t
      }
    ))
  ] });
}
const PA = Ws({ closeDrawer: () => {
} });
function k3t() {
  return Wi(PA);
}
function _3t({
  trigger: n,
  initialOpen: e,
  onOpenChange: t,
  title: r,
  description: i,
  children: s,
  footer: o,
  preventCloseOnOutside: a,
  className: l,
  stopFormEvents: c = !0
}) {
  const u = yw(), [d, f] = wt(e ?? !1);
  Tt(() => {
    e !== void 0 && f(e);
  }, [e]), Tt(() => {
    t && t(d);
  }, [d, t]);
  const h = () => f(!1), m = a ? {
    onPointerDownOutside: (v) => v.preventDefault(),
    onInteractOutside: (v) => v.preventDefault(),
    onEscapeKeyDown: (v) => v.preventDefault()
  } : {}, g = c ? {
    onSubmit: (v) => {
      v.stopPropagation(), v.preventDefault();
    },
    onReset: (v) => {
      v.stopPropagation(), v.preventDefault();
    }
  } : {};
  return u ? /* @__PURE__ */ ee(Wk, { open: d, onOpenChange: f, children: [
    n && /* @__PURE__ */ T(BVe, { asChild: !0, children: n }),
    /* @__PURE__ */ T(Gk, { className: "", ...m, ...g, children: /* @__PURE__ */ ee(PA.Provider, { value: { closeDrawer: h }, children: [
      /* @__PURE__ */ ee(Kk, { className: "tw:text-left", children: [
        /* @__PURE__ */ T(qk, { children: r }),
        i && /* @__PURE__ */ T(Yk, { children: i })
      ] }),
      /* @__PURE__ */ T(
        "div",
        {
          className: "tw:p-4 tw:flex tw:flex-col tw:gap-4",
          ...g,
          children: s
        }
      ),
      o && /* @__PURE__ */ T(EJ, { children: o })
    ] }) })
  ] }) : /* @__PURE__ */ ee(f3, { open: d, onOpenChange: f, children: [
    n && /* @__PURE__ */ T(NZ, { asChild: !0, children: n }),
    /* @__PURE__ */ T(
      h3,
      {
        id: "dialog-content",
        className: Q("tw:sm:max-w-[425px]", l),
        ...m,
        ...g,
        children: /* @__PURE__ */ ee(PA.Provider, { value: { closeDrawer: h }, children: [
          /* @__PURE__ */ ee(ck, { children: [
            /* @__PURE__ */ T(p3, { children: r }),
            i && /* @__PURE__ */ T(uk, { children: i })
          ] }),
          /* @__PURE__ */ T("div", { ...g, children: s }),
          o && /* @__PURE__ */ T($Z, { children: /* @__PURE__ */ T(FBe, { asChild: !0, children: o }) })
        ] })
      }
    )
  ] });
}
export {
  Dwt as Accordion,
  aUe as AccordionContent,
  sUe as AccordionItem,
  oUe as AccordionTrigger,
  Ywt as Add,
  rJ as Alert,
  uUe as AlertDescription,
  cUe as AlertTitle,
  id as Area,
  Vbt as AreaChart,
  qbt as ArrowUpDown,
  jbt as AuFlag,
  hz as Badge,
  Xbt as Bell,
  Ybt as BellPlus,
  Zbt as Boxes,
  Nt as Button,
  Gbt as CaFlag,
  fUe as Card,
  gUe as CardContent,
  mUe as CardDescription,
  vUe as CardFooter,
  hUe as CardHeader,
  pUe as CardTitle,
  QUe as Carousel,
  JUe as CarouselContent,
  eVe as CarouselItem,
  nVe as CarouselNext,
  tVe as CarouselPrevious,
  gSe as CartesianGrid,
  Zwt as CenterNewLayout,
  iVe as ChartContainer,
  Lwt as ChartLegend,
  aVe as ChartLegendContent,
  Nwt as ChartTooltip,
  oVe as ChartTooltipContent,
  oc as Check,
  od as ChevronDown,
  cX as ChevronLeft,
  m1 as ChevronRight,
  aIe as ChevronUp,
  vIe as CirclePlus,
  Qbt as CircleQuestionMark,
  $wt as Close,
  Jbt as Cog,
  lVe as Collapsible,
  uVe as CollapsibleContent,
  cVe as CollapsibleTrigger,
  ewt as Cookie,
  g1 as CopyToClipboard,
  dX as CopyToClipboardFn,
  M3t as DrawDetails,
  Jwt as DropDownButton,
  Kbt as EuFlag,
  twt as Facebook,
  YZe as FileUploader,
  nwt as Filter,
  e3t as FloatingFooter,
  t3t as FloatingNavbar,
  Rwt as Form,
  n3t as FormColorPicker,
  qi as FormControl,
  r3t as FormDateTimeField,
  h3t as FormHtmlEditor,
  Ci as FormItem,
  y3t as FormJsonEditorField,
  Ti as FormLabel,
  b3t as FormMultiSelect,
  Pwt as FormPhoneInputField,
  w3t as FormSearchSelectField,
  x3t as FormSelectManyField,
  E3t as FormSelectOneField,
  S3t as FormSliderField,
  C3t as FormSwitchArrayField,
  tQe as FormSwitchField,
  T3t as FormTextAreaField,
  A3t as FormTextField,
  rwt as Globe,
  sQe as Gravatar,
  iwt as Headset,
  swt as HeartHandshake,
  owt as House,
  awt as Info,
  bo as Label,
  lwt as Layers,
  cwt as Lightbulb,
  uwt as LucideMailOpen,
  ffe as MAP_SHEET_PEEK,
  so as MagicLink,
  dwt as Mail,
  uwt as MailOpen,
  fwt as MapPin,
  Dbt as MapSheet,
  jIe as Menu,
  Jje as Menubar,
  rWe as MenubarContent,
  iWe as MenubarItem,
  Bwt as MenubarMenu,
  lWe as MenubarSeparator,
  cWe as MenubarShortcut,
  eWe as MenubarTrigger,
  hwt as MonitorSmartphone,
  pwt as Omega,
  Xwt as PageContainer,
  Xwt as PageContainerNewLayout,
  gwt as PanelLeft,
  mwt as PanelLeftClose,
  ywt as PanelRight,
  vwt as PanelRightClose,
  bwt as Pen,
  wwt as Pencil,
  _3t as ResponsiveDrawer,
  xwt as RouteOff,
  Ewt as Scale,
  Kp as ScrollArea,
  iRe as Search,
  zwt as Sheet,
  EWe as SheetContent,
  TWe as SheetDescription,
  SWe as SheetHeader,
  CWe as SheetTitle,
  Hwt as SheetTrigger,
  Swt as ShieldUser,
  tte as Sidebar,
  ste as SidebarContent,
  ote as SidebarGroup,
  ate as SidebarGroupLabel,
  ite as SidebarHeader,
  cte as SidebarMenu,
  ute as SidebarMenuButton,
  cGe as SidebarMenuItem,
  dte as SidebarMenuSub,
  hte as SidebarMenuSubButton,
  fte as SidebarMenuSubItem,
  ete as SidebarProvider,
  rte as SidebarRail,
  nte as SidebarTrigger,
  Qwt as SimpleHeader,
  Cwt as Siren,
  Ap as Sonner,
  Ire as Spinner,
  Twt as Squirrel,
  Awt as Terminal,
  Vwt as ThemeProvider,
  Mwt as Timer,
  jwt as Toaster,
  kte as ToggleGroup,
  _te as ToggleGroupItem,
  eGe as TooltipProvider,
  kwt as TriangleAlert,
  bGe as UpdatingImage,
  Wbt as UsFlag,
  _wt as Users,
  qwt as WebcamPlayer,
  Owt as Wifi,
  YM as X,
  WM as XAxis,
  GM as YAxis,
  Q as cn,
  wh as useController,
  Fre as useDebounce,
  Hbt as useFieldArray,
  Ubt as useForm,
  Ju as useFormContext,
  yw as useIsMobile,
  k3t as useResponsiveDrawer,
  Fh as useSidebar,
  V3 as useTheme,
  Ehe as useWatch
};
